require=(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;

var ADD_CLASS_SUFFIX = '-add';
var REMOVE_CLASS_SUFFIX = '-remove';
var EVENT_CLASS_PREFIX = 'ng-';
var ACTIVE_CLASS_SUFFIX = '-active';
var PREPARE_CLASS_SUFFIX = '-prepare';

var NG_ANIMATE_CLASSNAME = 'ng-animate';
var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

// Detect proper transitionend/animationend event names.
var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;

// If unprefixed events are not supported but webkit-prefixed are, use the latter.
// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
// Register both events in case `window.onanimationend` is not supported because of that,
// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
// therefore there is no reason to test anymore for other vendor prefixes:
// http://caniuse.com/#search=transition
if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  TRANSITION_PROP = 'WebkitTransition';
  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
} else {
  TRANSITION_PROP = 'transition';
  TRANSITIONEND_EVENT = 'transitionend';
}

if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
  CSS_PREFIX = '-webkit-';
  ANIMATION_PROP = 'WebkitAnimation';
  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
} else {
  ANIMATION_PROP = 'animation';
  ANIMATIONEND_EVENT = 'animationend';
}

var DURATION_KEY = 'Duration';
var PROPERTY_KEY = 'Property';
var DELAY_KEY = 'Delay';
var TIMING_KEY = 'TimingFunction';
var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
var ANIMATION_PLAYSTATE_KEY = 'PlayState';
var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;

var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;

var ngMinErr = angular.$$minErr('ng');
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function packageStyles(options) {
  var styles = {};
  if (options && (options.to || options.from)) {
    styles.to = options.to;
    styles.from = options.from;
  }
  return styles;
}

function pendClasses(classes, fix, isPrefix) {
  var className = '';
  classes = isArray(classes)
      ? classes
      : classes && isString(classes) && classes.length
          ? classes.split(/\s+/)
          : [];
  forEach(classes, function(klass, i) {
    if (klass && klass.length > 0) {
      className += (i > 0) ? ' ' : '';
      className += isPrefix ? fix + klass
                            : klass + fix;
    }
  });
  return className;
}

function removeFromArray(arr, val) {
  var index = arr.indexOf(val);
  if (val >= 0) {
    arr.splice(index, 1);
  }
}

function stripCommentsFromElement(element) {
  if (element instanceof jqLite) {
    switch (element.length) {
      case 0:
        return element;

      case 1:
        // there is no point of stripping anything if the element
        // is the only element within the jqLite wrapper.
        // (it's important that we retain the element instance.)
        if (element[0].nodeType === ELEMENT_NODE) {
          return element;
        }
        break;

      default:
        return jqLite(extractElementNode(element));
    }
  }

  if (element.nodeType === ELEMENT_NODE) {
    return jqLite(element);
  }
}

function extractElementNode(element) {
  if (!element[0]) return element;
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function $$addClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.addClass(elm, className);
  });
}

function $$removeClass($$jqLite, element, className) {
  forEach(element, function(elm) {
    $$jqLite.removeClass(elm, className);
  });
}

function applyAnimationClassesFactory($$jqLite) {
  return function(element, options) {
    if (options.addClass) {
      $$addClass($$jqLite, element, options.addClass);
      options.addClass = null;
    }
    if (options.removeClass) {
      $$removeClass($$jqLite, element, options.removeClass);
      options.removeClass = null;
    }
  };
}

function prepareAnimationOptions(options) {
  options = options || {};
  if (!options.$$prepared) {
    var domOperation = options.domOperation || noop;
    options.domOperation = function() {
      options.$$domOperationFired = true;
      domOperation();
      domOperation = noop;
    };
    options.$$prepared = true;
  }
  return options;
}

function applyAnimationStyles(element, options) {
  applyAnimationFromStyles(element, options);
  applyAnimationToStyles(element, options);
}

function applyAnimationFromStyles(element, options) {
  if (options.from) {
    element.css(options.from);
    options.from = null;
  }
}

function applyAnimationToStyles(element, options) {
  if (options.to) {
    element.css(options.to);
    options.to = null;
  }
}

function mergeAnimationDetails(element, oldAnimation, newAnimation) {
  var target = oldAnimation.options || {};
  var newOptions = newAnimation.options || {};

  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);

  if (newOptions.preparationClasses) {
    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
    delete newOptions.preparationClasses;
  }

  // noop is basically when there is no callback; otherwise something has been set
  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;

  extend(target, newOptions);

  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
  if (realDomOperation) {
    target.domOperation = realDomOperation;
  }

  if (classes.addClass) {
    target.addClass = classes.addClass;
  } else {
    target.addClass = null;
  }

  if (classes.removeClass) {
    target.removeClass = classes.removeClass;
  } else {
    target.removeClass = null;
  }

  oldAnimation.addClass = target.addClass;
  oldAnimation.removeClass = target.removeClass;

  return target;
}

function resolveElementClasses(existing, toAdd, toRemove) {
  var ADD_CLASS = 1;
  var REMOVE_CLASS = -1;

  var flags = {};
  existing = splitClassesToLookup(existing);

  toAdd = splitClassesToLookup(toAdd);
  forEach(toAdd, function(value, key) {
    flags[key] = ADD_CLASS;
  });

  toRemove = splitClassesToLookup(toRemove);
  forEach(toRemove, function(value, key) {
    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
  });

  var classes = {
    addClass: '',
    removeClass: ''
  };

  forEach(flags, function(val, klass) {
    var prop, allow;
    if (val === ADD_CLASS) {
      prop = 'addClass';
      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
    } else if (val === REMOVE_CLASS) {
      prop = 'removeClass';
      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
    }
    if (allow) {
      if (classes[prop].length) {
        classes[prop] += ' ';
      }
      classes[prop] += klass;
    }
  });

  function splitClassesToLookup(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    var obj = {};
    forEach(classes, function(klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  return classes;
}

function getDomNode(element) {
  return (element instanceof jqLite) ? element[0] : element;
}

function applyGeneratedPreparationClasses(element, event, options) {
  var classes = '';
  if (event) {
    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
  }
  if (options.addClass) {
    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
  }
  if (options.removeClass) {
    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
  }
  if (classes.length) {
    options.preparationClasses = classes;
    element.addClass(classes);
  }
}

function clearGeneratedClasses(element, options) {
  if (options.preparationClasses) {
    element.removeClass(options.preparationClasses);
    options.preparationClasses = null;
  }
  if (options.activeClasses) {
    element.removeClass(options.activeClasses);
    options.activeClasses = null;
  }
}

function blockTransitions(node, duration) {
  // we use a negative delay value since it performs blocking
  // yet it doesn't kill any existing transitions running on the
  // same element which makes this safe for class-based animations
  var value = duration ? '-' + duration + 's' : '';
  applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
  return [TRANSITION_DELAY_PROP, value];
}

function blockKeyframeAnimations(node, applyBlock) {
  var value = applyBlock ? 'paused' : '';
  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
  applyInlineStyle(node, [key, value]);
  return [key, value];
}

function applyInlineStyle(node, styleTuple) {
  var prop = styleTuple[0];
  var value = styleTuple[1];
  node.style[prop] = value;
}

function concatWithSpace(a,b) {
  if (!a) return b;
  if (!b) return a;
  return a + ' ' + b;
}

var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
  var queue, cancelFn;

  function scheduler(tasks) {
    // we make a copy since RAFScheduler mutates the state
    // of the passed in array variable and this would be difficult
    // to track down on the outside code
    queue = queue.concat(tasks);
    nextTick();
  }

  queue = scheduler.queue = [];

  /* waitUntilQuiet does two things:
   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
   *
   * The motivation here is that animation code can request more time from the scheduler
   * before the next wave runs. This allows for certain DOM properties such as classes to
   * be resolved in time for the next animation to run.
   */
  scheduler.waitUntilQuiet = function(fn) {
    if (cancelFn) cancelFn();

    cancelFn = $$rAF(function() {
      cancelFn = null;
      fn();
      nextTick();
    });
  };

  return scheduler;

  function nextTick() {
    if (!queue.length) return;

    var items = queue.shift();
    for (var i = 0; i < items.length; i++) {
      items[i]();
    }

    if (!cancelFn) {
      $$rAF(function() {
        if (!cancelFn) nextTick();
      });
    }
  }
}];

/**
 * @ngdoc directive
 * @name ngAnimateChildren
 * @restrict AE
 * @element ANY
 *
 * @description
 *
 * ngAnimateChildren allows you to specify that children of this element should animate even if any
 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
 * (structural) animation, child elements that also have an active structural animation are not animated.
 *
 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
 *
 *
 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
 *
 * @example
 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
     <file name="index.html">
       <div ng-controller="MainController as main">
         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
         <hr>
         <div ng-animate-children="{{main.animateChildren}}">
           <div ng-if="main.enterElement" class="container">
             List of items:
             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
           </div>
         </div>
       </div>
     </file>
     <file name="animations.css">

      .container.ng-enter,
      .container.ng-leave {
        transition: all ease 1.5s;
      }

      .container.ng-enter,
      .container.ng-leave-active {
        opacity: 0;
      }

      .container.ng-leave,
      .container.ng-enter-active {
        opacity: 1;
      }

      .item {
        background: firebrick;
        color: #FFF;
        margin-bottom: 10px;
      }

      .item.ng-enter,
      .item.ng-leave {
        transition: transform 1.5s ease;
      }

      .item.ng-enter {
        transform: translateX(50px);
      }

      .item.ng-enter-active {
        transform: translateX(0);
      }
    </file>
    <file name="script.js">
      angular.module('ngAnimateChildren', ['ngAnimate'])
        .controller('MainController', function MainController() {
          this.animateChildren = false;
          this.enterElement = false;
        });
    </file>
  </example>
 */
var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
  return {
    link: function(scope, element, attrs) {
      var val = attrs.ngAnimateChildren;
      if (isString(val) && val.length === 0) { //empty attribute
        element.data(NG_ANIMATE_CHILDREN_DATA, true);
      } else {
        // Interpolate and set the value, so that it is available to
        // animations that run right after compilation
        setData($interpolate(val)(scope));
        attrs.$observe('ngAnimateChildren', setData);
      }

      function setData(value) {
        value = value === 'on' || value === 'true';
        element.data(NG_ANIMATE_CHILDREN_DATA, value);
      }
    }
  };
}];

/* exported $AnimateCssProvider */

var ANIMATE_TIMER_KEY = '$$animateCss';

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 *
 * @description
 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
 * directives to create more complex animations that can be purely driven using CSS code.
 *
 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
 *
 * ## Usage
 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
 * any automatic control over cancelling animations and/or preventing animations from being run on
 * child elements will not be handled by Angular. For this to work as expected, please use `$animate` to
 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
 * the CSS animation.
 *
 * The example below shows how we can create a folding animation on an element using `ng-if`:
 *
 * ```html
 * <!-- notice the `fold-animation` CSS class -->
 * <div ng-if="onOff" class="fold-animation">
 *   This element will go BOOM
 * </div>
 * <button ng-click="onOff=true">Fold In</button>
 * ```
 *
 * Now we create the **JavaScript animation** that will trigger the CSS transition:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * ## More Advanced Uses
 *
 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
 *
 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
 * to provide a working animation that will run in CSS.
 *
 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
 *
 * ```js
 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element, doneFn) {
 *       var height = element[0].offsetHeight;
 *       return $animateCss(element, {
 *         addClass: 'red large-text pulse-twice',
 *         easing: 'ease-out',
 *         from: { height:'0px' },
 *         to: { height:height + 'px' },
 *         duration: 1 // one second
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
 *
 * ```css
 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
 * .red { background:red; }
 * .large-text { font-size:20px; }
 *
 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
 * .pulse-twice {
 *   animation: 0.5s pulse linear 2;
 *   -webkit-animation: 0.5s pulse linear 2;
 * }
 *
 * @keyframes pulse {
 *   from { transform: scale(0.5); }
 *   to { transform: scale(1.5); }
 * }
 *
 * @-webkit-keyframes pulse {
 *   from { -webkit-transform: scale(0.5); }
 *   to { -webkit-transform: scale(1.5); }
 * }
 * ```
 *
 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
 *
 * ## How the Options are handled
 *
 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
 * styles using the `from` and `to` properties.
 *
 * ```js
 * var animator = $animateCss(element, {
 *   from: { background:'red' },
 *   to: { background:'blue' }
 * });
 * animator.start();
 * ```
 *
 * ```css
 * .rotating-animation {
 *   animation:0.5s rotate linear;
 *   -webkit-animation:0.5s rotate linear;
 * }
 *
 * @keyframes rotate {
 *   from { transform: rotate(0deg); }
 *   to { transform: rotate(360deg); }
 * }
 *
 * @-webkit-keyframes rotate {
 *   from { -webkit-transform: rotate(0deg); }
 *   to { -webkit-transform: rotate(360deg); }
 * }
 * ```
 *
 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
 * and spread across the transition and keyframe animation.
 *
 * ## What is returned
 *
 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
 *
 * ```js
 * var animator = $animateCss(element, { ... });
 * ```
 *
 * Now what do the contents of our `animator` variable look like:
 *
 * ```js
 * {
 *   // starts the animation
 *   start: Function,
 *
 *   // ends (aborts) the animation
 *   end: Function
 * }
 * ```
 *
 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
 * and that changing them will not reconfigure the parameters of the animation.
 *
 * ### runner.done() vs runner.then()
 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
 * unless you really need a digest to kick off afterwards.
 *
 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
 *
 * @param {DOMElement} element the element that will be animated
 * @param {object} options the animation-related options that will be applied during the animation
 *
 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
 * is provided then the animation will be skipped entirely.
 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
 * CSS delay value.
 * * `stagger` - A numeric time value representing the delay between successively animated elements
 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
 *    the animation is closed. This is useful for when the styles are used purely for the sake of
 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
 *    By default this value is set to `false`.
 *
 * @return {object} an object with start and end methods and details about the animation.
 *
 * * `start` - The method to start the animation. This will return a `Promise` when called.
 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
 */
var ONE_SECOND = 1000;

var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
var CLOSING_TIME_BUFFER = 1.5;

var DETECT_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP,
  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
};

var DETECT_STAGGER_CSS_PROPERTIES = {
  transitionDuration:      TRANSITION_DURATION_PROP,
  transitionDelay:         TRANSITION_DELAY_PROP,
  animationDuration:       ANIMATION_DURATION_PROP,
  animationDelay:          ANIMATION_DELAY_PROP
};

function getCssKeyframeDurationStyle(duration) {
  return [ANIMATION_DURATION_PROP, duration + 's'];
}

function getCssDelayStyle(delay, isKeyframeAnimation) {
  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
  return [prop, delay + 's'];
}

function computeCssStyles($window, element, properties) {
  var styles = Object.create(null);
  var detectedStyles = $window.getComputedStyle(element) || {};
  forEach(properties, function(formalStyleName, actualStyleName) {
    var val = detectedStyles[formalStyleName];
    if (val) {
      var c = val.charAt(0);

      // only numerical-based values have a negative sign or digit as the first value
      if (c === '-' || c === '+' || c >= 0) {
        val = parseMaxTime(val);
      }

      // by setting this to null in the event that the delay is not set or is set directly as 0
      // then we can still allow for negative values to be used later on and not mistake this
      // value for being greater than any other negative value.
      if (val === 0) {
        val = null;
      }
      styles[actualStyleName] = val;
    }
  });

  return styles;
}

function parseMaxTime(str) {
  var maxValue = 0;
  var values = str.split(/\s*,\s*/);
  forEach(values, function(value) {
    // it's always safe to consider only second values and omit `ms` values since
    // getComputedStyle will always handle the conversion for us
    if (value.charAt(value.length - 1) === 's') {
      value = value.substring(0, value.length - 1);
    }
    value = parseFloat(value) || 0;
    maxValue = maxValue ? Math.max(value, maxValue) : value;
  });
  return maxValue;
}

function truthyTimingValue(val) {
  return val === 0 || val != null;
}

function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
  var style = TRANSITION_PROP;
  var value = duration + 's';
  if (applyOnlyDuration) {
    style += DURATION_KEY;
  } else {
    value += ' linear all';
  }
  return [style, value];
}

function createLocalCacheLookup() {
  var cache = Object.create(null);
  return {
    flush: function() {
      cache = Object.create(null);
    },

    count: function(key) {
      var entry = cache[key];
      return entry ? entry.total : 0;
    },

    get: function(key) {
      var entry = cache[key];
      return entry && entry.value;
    },

    put: function(key, value) {
      if (!cache[key]) {
        cache[key] = { total: 1, value: value };
      } else {
        cache[key].total++;
      }
    }
  };
}

// we do not reassign an already present style value since
// if we detect the style property value again we may be
// detecting styles that were added via the `from` styles.
// We make use of `isDefined` here since an empty string
// or null value (which is what getPropertyValue will return
// for a non-existing style) will still be marked as a valid
// value for the style (a falsy value implies that the style
// is to be removed at the end of the animation). If we had a simple
// "OR" statement then it would not be enough to catch that.
function registerRestorableStyles(backup, node, properties) {
  forEach(properties, function(prop) {
    backup[prop] = isDefined(backup[prop])
        ? backup[prop]
        : node.style.getPropertyValue(prop);
  });
}

var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var gcsLookup = createLocalCacheLookup();
  var gcsStaggerLookup = createLocalCacheLookup();

  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout',
               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,
                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    var parentCounter = 0;
    function gcsHashFn(node, extraClasses) {
      var KEY = '$$ngAnimateParentKey';
      var parentNode = node.parentNode;
      var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
      return parentID + '-' + node.getAttribute('class') + '-' + extraClasses;
    }

    function computeCachedCssStyles(node, className, cacheKey, properties) {
      var timings = gcsLookup.get(cacheKey);

      if (!timings) {
        timings = computeCssStyles($window, node, properties);
        if (timings.animationIterationCount === 'infinite') {
          timings.animationIterationCount = 1;
        }
      }

      // we keep putting this in multiple times even though the value and the cacheKey are the same
      // because we're keeping an internal tally of how many duplicate animations are detected.
      gcsLookup.put(cacheKey, timings);
      return timings;
    }

    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
      var stagger;

      // if we have one or more existing matches of matching elements
      // containing the same parent + CSS styles (which is how cacheKey works)
      // then staggering is possible
      if (gcsLookup.count(cacheKey) > 0) {
        stagger = gcsStaggerLookup.get(cacheKey);

        if (!stagger) {
          var staggerClassName = pendClasses(className, '-stagger');

          $$jqLite.addClass(node, staggerClassName);

          stagger = computeCssStyles($window, node, properties);

          // force the conversion of a null value to zero incase not set
          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);

          $$jqLite.removeClass(node, staggerClassName);

          gcsStaggerLookup.put(cacheKey, stagger);
        }
      }

      return stagger || {};
    }

    var rafWaitQueue = [];
    function waitUntilQuiet(callback) {
      rafWaitQueue.push(callback);
      $$rAFScheduler.waitUntilQuiet(function() {
        gcsLookup.flush();
        gcsStaggerLookup.flush();

        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
        var pageWidth = $$forceReflow();

        // we use a for loop to ensure that if the queue is changed
        // during this looping then it will consider new requests
        for (var i = 0; i < rafWaitQueue.length; i++) {
          rafWaitQueue[i](pageWidth);
        }
        rafWaitQueue.length = 0;
      });
    }

    function computeTimings(node, className, cacheKey) {
      var timings = computeCachedCssStyles(node, className, cacheKey, DETECT_CSS_PROPERTIES);
      var aD = timings.animationDelay;
      var tD = timings.transitionDelay;
      timings.maxDelay = aD && tD
          ? Math.max(aD, tD)
          : (aD || tD);
      timings.maxDuration = Math.max(
          timings.animationDuration * timings.animationIterationCount,
          timings.transitionDuration);

      return timings;
    }

    return function init(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = prepareAnimationOptions(copy(options));
      }

      var restoreStyles = {};
      var node = getDomNode(element);
      if (!node
          || !node.parentNode
          || !$$animateQueue.enabled()) {
        return closeAndReturnNoopAnimator();
      }

      var temporaryStyles = [];
      var classes = element.attr('class');
      var styles = packageStyles(options);
      var animationClosed;
      var animationPaused;
      var animationCompleted;
      var runner;
      var runnerHost;
      var maxDelay;
      var maxDelayTime;
      var maxDuration;
      var maxDurationTime;
      var startTime;
      var events = [];

      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
        return closeAndReturnNoopAnimator();
      }

      var method = options.event && isArray(options.event)
            ? options.event.join(' ')
            : options.event;

      var isStructural = method && options.structural;
      var structuralClassName = '';
      var addRemoveClassName = '';

      if (isStructural) {
        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
      } else if (method) {
        structuralClassName = method;
      }

      if (options.addClass) {
        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
      }

      if (options.removeClass) {
        if (addRemoveClassName.length) {
          addRemoveClassName += ' ';
        }
        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
      }

      // there may be a situation where a structural animation is combined together
      // with CSS classes that need to resolve before the animation is computed.
      // However this means that there is no explicit CSS code to block the animation
      // from happening (by setting 0s none in the class name). If this is the case
      // we need to apply the classes before the first rAF so we know to continue if
      // there actually is a detected transition or keyframe animation
      if (options.applyClassesEarly && addRemoveClassName.length) {
        applyAnimationClasses(element, options);
      }

      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
      var fullClassName = classes + ' ' + preparationClasses;
      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

      // there is no way we can trigger an animation if no styles and
      // no classes are being applied which would then trigger a transition,
      // unless there a is raw keyframe value that is applied to the element.
      if (!containsKeyframeAnimation
           && !hasToStyles
           && !preparationClasses) {
        return closeAndReturnNoopAnimator();
      }

      var cacheKey, stagger;
      if (options.stagger > 0) {
        var staggerVal = parseFloat(options.stagger);
        stagger = {
          transitionDelay: staggerVal,
          animationDelay: staggerVal,
          transitionDuration: 0,
          animationDuration: 0
        };
      } else {
        cacheKey = gcsHashFn(node, fullClassName);
        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
      }

      if (!options.$$skipPreparationClasses) {
        $$jqLite.addClass(element, preparationClasses);
      }

      var applyOnlyDuration;

      if (options.transitionStyle) {
        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
        applyInlineStyle(node, transitionStyle);
        temporaryStyles.push(transitionStyle);
      }

      if (options.duration >= 0) {
        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

        // we set the duration so that it will be picked up by getComputedStyle later
        applyInlineStyle(node, durationStyle);
        temporaryStyles.push(durationStyle);
      }

      if (options.keyframeStyle) {
        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
        applyInlineStyle(node, keyframeStyle);
        temporaryStyles.push(keyframeStyle);
      }

      var itemIndex = stagger
          ? options.staggerIndex >= 0
              ? options.staggerIndex
              : gcsLookup.count(cacheKey)
          : 0;

      var isFirst = itemIndex === 0;

      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
      // without causing any combination of transitions to kick in. By adding a negative delay value
      // it forces the setup class' transition to end immediately. We later then remove the negative
      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
      // that if there is no transition defined then nothing will happen and this will also allow
      // other transitions to be stacked on top of each other without any chopping them out.
      if (isFirst && !options.skipBlocking) {
        blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
      }

      var timings = computeTimings(node, fullClassName, cacheKey);
      var relativeDelay = timings.maxDelay;
      maxDelay = Math.max(relativeDelay, 0);
      maxDuration = timings.maxDuration;

      var flags = {};
      flags.hasTransitions          = timings.transitionDuration > 0;
      flags.hasAnimations           = timings.animationDuration > 0;
      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
      flags.applyTransitionDuration = hasToStyles && (
                                        (flags.hasTransitions && !flags.hasTransitionAll)
                                         || (flags.hasAnimations && !flags.hasTransitions));
      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
      flags.recalculateTimingStyles = addRemoveClassName.length > 0;

      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;

        if (flags.applyTransitionDuration) {
          flags.hasTransitions = true;
          timings.transitionDuration = maxDuration;
          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
        }

        if (flags.applyAnimationDuration) {
          flags.hasAnimations = true;
          timings.animationDuration = maxDuration;
          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
        }
      }

      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
        return closeAndReturnNoopAnimator();
      }

      if (options.delay != null) {
        var delayStyle;
        if (typeof options.delay !== 'boolean') {
          delayStyle = parseFloat(options.delay);
          // number in options.delay means we have to recalculate the delay for the closing timeout
          maxDelay = Math.max(delayStyle, 0);
        }

        if (flags.applyTransitionDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle));
        }

        if (flags.applyAnimationDelay) {
          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
        }
      }

      // we need to recalculate the delay value since we used a pre-emptive negative
      // delay value and the delay value is required for the final event checking. This
      // property will ensure that this will happen after the RAF phase has passed.
      if (options.duration == null && timings.transitionDuration > 0) {
        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
      }

      maxDelayTime = maxDelay * ONE_SECOND;
      maxDurationTime = maxDuration * ONE_SECOND;
      if (!options.skipBlocking) {
        flags.blockTransition = timings.transitionDuration > 0;
        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
                                       stagger.animationDelay > 0 &&
                                       stagger.animationDuration === 0;
      }

      if (options.from) {
        if (options.cleanupStyles) {
          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
        }
        applyAnimationFromStyles(element, options);
      }

      if (flags.blockTransition || flags.blockKeyframeAnimation) {
        applyBlocking(maxDuration);
      } else if (!options.skipBlocking) {
        blockTransitions(node, false);
      }

      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
      return {
        $$willAnimate: true,
        end: endFn,
        start: function() {
          if (animationClosed) return;

          runnerHost = {
            end: endFn,
            cancel: cancelFn,
            resume: null, //this will be set during the start() phase
            pause: null
          };

          runner = new $$AnimateRunner(runnerHost);

          waitUntilQuiet(start);

          // we don't have access to pause/resume the animation
          // since it hasn't run yet. AnimateRunner will therefore
          // set noop functions for resume and pause and they will
          // later be overridden once the animation is triggered
          return runner;
        }
      };

      function endFn() {
        close();
      }

      function cancelFn() {
        close(true);
      }

      function close(rejected) {
        // if the promise has been called already then we shouldn't close
        // the animation again
        if (animationClosed || (animationCompleted && animationPaused)) return;
        animationClosed = true;
        animationPaused = false;

        if (!options.$$skipPreparationClasses) {
          $$jqLite.removeClass(element, preparationClasses);
        }
        $$jqLite.removeClass(element, activeClasses);

        blockKeyframeAnimations(node, false);
        blockTransitions(node, false);

        forEach(temporaryStyles, function(entry) {
          // There is only one way to remove inline style properties entirely from elements.
          // By using `removeProperty` this works, but we need to convert camel-cased CSS
          // styles down to hyphenated values.
          node.style[entry[0]] = '';
        });

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);

        if (Object.keys(restoreStyles).length) {
          forEach(restoreStyles, function(value, prop) {
            if (value) {
              node.style.setProperty(prop, value);
            } else {
              node.style.removeProperty(prop);
            }
          });
        }

        // the reason why we have this option is to allow a synchronous closing callback
        // that is fired as SOON as the animation ends (when the CSS is removed) or if
        // the animation never takes off at all. A good example is a leave animation since
        // the element must be removed just after the animation is over or else the element
        // will appear on screen for one animation frame causing an overbearing flicker.
        if (options.onDone) {
          options.onDone();
        }

        if (events && events.length) {
          // Remove the transitionend / animationend listener(s)
          element.off(events.join(' '), onAnimationProgress);
        }

        //Cancel the fallback closing timeout and remove the timer data
        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
        if (animationTimerData) {
          $timeout.cancel(animationTimerData[0].timer);
          element.removeData(ANIMATE_TIMER_KEY);
        }

        // if the preparation function fails then the promise is not setup
        if (runner) {
          runner.complete(!rejected);
        }
      }

      function applyBlocking(duration) {
        if (flags.blockTransition) {
          blockTransitions(node, duration);
        }

        if (flags.blockKeyframeAnimation) {
          blockKeyframeAnimations(node, !!duration);
        }
      }

      function closeAndReturnNoopAnimator() {
        runner = new $$AnimateRunner({
          end: endFn,
          cancel: cancelFn
        });

        // should flush the cache animation
        waitUntilQuiet(noop);
        close();

        return {
          $$willAnimate: false,
          start: function() {
            return runner;
          },
          end: endFn
        };
      }

      function onAnimationProgress(event) {
        event.stopPropagation();
        var ev = event.originalEvent || event;

        // we now always use `Date.now()` due to the recent changes with
        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
        var timeStamp = ev.$manualTimeStamp || Date.now();

        /* Firefox (or possibly just Gecko) likes to not round values up
         * when a ms measurement is used for the animation */
        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

        /* $manualTimeStamp is a mocked timeStamp value which is set
         * within browserTrigger(). This is only here so that tests can
         * mock animations properly. Real events fallback to event.timeStamp,
         * or, if they don't, then a timeStamp is automatically created for them.
         * We're checking to see if the timeStamp surpasses the expected delay,
         * but we're using elapsedTime instead of the timeStamp on the 2nd
         * pre-condition since animationPauseds sometimes close off early */
        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
          // we set this flag to ensure that if the transition is paused then, when resumed,
          // the animation will automatically close itself since transitions cannot be paused.
          animationCompleted = true;
          close();
        }
      }

      function start() {
        if (animationClosed) return;
        if (!node.parentNode) {
          close();
          return;
        }

        // even though we only pause keyframe animations here the pause flag
        // will still happen when transitions are used. Only the transition will
        // not be paused since that is not possible. If the animation ends when
        // paused then it will not complete until unpaused or cancelled.
        var playPause = function(playAnimation) {
          if (!animationCompleted) {
            animationPaused = !playAnimation;
            if (timings.animationDuration) {
              var value = blockKeyframeAnimations(node, animationPaused);
              if (animationPaused) {
                temporaryStyles.push(value);
              } else {
                removeFromArray(temporaryStyles, value);
              }
            }
          } else if (animationPaused && playAnimation) {
            animationPaused = false;
            close();
          }
        };

        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
        // being inherited from the parent. If the transition duration is zero then we can safely
        // rely that the delay value is an intentional stagger delay style.
        var maxStagger = itemIndex > 0
                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
                            (timings.animationDuration && stagger.animationDuration === 0))
                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
        if (maxStagger) {
          $timeout(triggerAnimationStart,
                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
                   false);
        } else {
          triggerAnimationStart();
        }

        // this will decorate the existing promise runner with pause/resume methods
        runnerHost.resume = function() {
          playPause(true);
        };

        runnerHost.pause = function() {
          playPause(false);
        };

        function triggerAnimationStart() {
          // just incase a stagger animation kicks in when the animation
          // itself was cancelled entirely
          if (animationClosed) return;

          applyBlocking(false);

          forEach(temporaryStyles, function(entry) {
            var key = entry[0];
            var value = entry[1];
            node.style[key] = value;
          });

          applyAnimationClasses(element, options);
          $$jqLite.addClass(element, activeClasses);

          if (flags.recalculateTimingStyles) {
            fullClassName = node.className + ' ' + preparationClasses;
            cacheKey = gcsHashFn(node, fullClassName);

            timings = computeTimings(node, fullClassName, cacheKey);
            relativeDelay = timings.maxDelay;
            maxDelay = Math.max(relativeDelay, 0);
            maxDuration = timings.maxDuration;

            if (maxDuration === 0) {
              close();
              return;
            }

            flags.hasTransitions = timings.transitionDuration > 0;
            flags.hasAnimations = timings.animationDuration > 0;
          }

          if (flags.applyAnimationDelay) {
            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
                  ? parseFloat(options.delay)
                  : relativeDelay;

            maxDelay = Math.max(relativeDelay, 0);
            timings.animationDelay = relativeDelay;
            delayStyle = getCssDelayStyle(relativeDelay, true);
            temporaryStyles.push(delayStyle);
            node.style[delayStyle[0]] = delayStyle[1];
          }

          maxDelayTime = maxDelay * ONE_SECOND;
          maxDurationTime = maxDuration * ONE_SECOND;

          if (options.easing) {
            var easeProp, easeVal = options.easing;
            if (flags.hasTransitions) {
              easeProp = TRANSITION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
            if (flags.hasAnimations) {
              easeProp = ANIMATION_PROP + TIMING_KEY;
              temporaryStyles.push([easeProp, easeVal]);
              node.style[easeProp] = easeVal;
            }
          }

          if (timings.transitionDuration) {
            events.push(TRANSITIONEND_EVENT);
          }

          if (timings.animationDuration) {
            events.push(ANIMATIONEND_EVENT);
          }

          startTime = Date.now();
          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
          var endTime = startTime + timerTime;

          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
          var setupFallbackTimer = true;
          if (animationsData.length) {
            var currentTimerData = animationsData[0];
            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
            if (setupFallbackTimer) {
              $timeout.cancel(currentTimerData.timer);
            } else {
              animationsData.push(close);
            }
          }

          if (setupFallbackTimer) {
            var timer = $timeout(onAnimationExpired, timerTime, false);
            animationsData[0] = {
              timer: timer,
              expectedEndTime: endTime
            };
            animationsData.push(close);
            element.data(ANIMATE_TIMER_KEY, animationsData);
          }

          if (events.length) {
            element.on(events.join(' '), onAnimationProgress);
          }

          if (options.to) {
            if (options.cleanupStyles) {
              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
            }
            applyAnimationToStyles(element, options);
          }
        }

        function onAnimationExpired() {
          var animationsData = element.data(ANIMATE_TIMER_KEY);

          // this will be false in the event that the element was
          // removed from the DOM (via a leave animation or something
          // similar)
          if (animationsData) {
            for (var i = 1; i < animationsData.length; i++) {
              animationsData[i]();
            }
            element.removeData(ANIMATE_TIMER_KEY);
          }
        }
      }
    };
  }];
}];

var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateCssDriver');

  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';

  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';

  function isDocumentFragment(node) {
    return node.parentNode && node.parentNode.nodeType === 11;
  }

  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {

    // only browsers that support these properties can render animations
    if (!$sniffer.animations && !$sniffer.transitions) return noop;

    var bodyNode = $document[0].body;
    var rootNode = getDomNode($rootElement);

    var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
    );

    return function initDriverFn(animationDetails) {
      return animationDetails.from && animationDetails.to
          ? prepareFromToAnchorAnimation(animationDetails.from,
                                         animationDetails.to,
                                         animationDetails.classes,
                                         animationDetails.anchors)
          : prepareRegularAnimation(animationDetails);
    };

    function filterCssClasses(classes) {
      //remove all the `ng-` stuff
      return classes.replace(/\bng-\S+\b/g, '');
    }

    function getUniqueValues(a, b) {
      if (isString(a)) a = a.split(' ');
      if (isString(b)) b = b.split(' ');
      return a.filter(function(val) {
        return b.indexOf(val) === -1;
      }).join(' ');
    }

    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
      var startingClasses = filterCssClasses(getClassVal(clone));

      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);

      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);

      rootBodyElement.append(clone);

      var animatorIn, animatorOut = prepareOutAnimation();

      // the user may not end up using the `out` animation and
      // only making use of the `in` animation or vice-versa.
      // In either case we should allow this and not assume the
      // animation is over unless both animations are not used.
      if (!animatorOut) {
        animatorIn = prepareInAnimation();
        if (!animatorIn) {
          return end();
        }
      }

      var startingAnimator = animatorOut || animatorIn;

      return {
        start: function() {
          var runner;

          var currentAnimation = startingAnimator.start();
          currentAnimation.done(function() {
            currentAnimation = null;
            if (!animatorIn) {
              animatorIn = prepareInAnimation();
              if (animatorIn) {
                currentAnimation = animatorIn.start();
                currentAnimation.done(function() {
                  currentAnimation = null;
                  end();
                  runner.complete();
                });
                return currentAnimation;
              }
            }
            // in the event that there is no `in` animation
            end();
            runner.complete();
          });

          runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn
          });

          return runner;

          function endFn() {
            if (currentAnimation) {
              currentAnimation.end();
            }
          }
        }
      };

      function calculateAnchorStyles(anchor) {
        var styles = {};

        var coords = getDomNode(anchor).getBoundingClientRect();

        // we iterate directly since safari messes up and doesn't return
        // all the keys for the coords object when iterated
        forEach(['width','height','top','left'], function(key) {
          var value = coords[key];
          switch (key) {
            case 'top':
              value += bodyNode.scrollTop;
              break;
            case 'left':
              value += bodyNode.scrollLeft;
              break;
          }
          styles[key] = Math.floor(value) + 'px';
        });
        return styles;
      }

      function prepareOutAnimation() {
        var animator = $animateCss(clone, {
          addClass: NG_OUT_ANCHOR_CLASS_NAME,
          delay: true,
          from: calculateAnchorStyles(outAnchor)
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function getClassVal(element) {
        return element.attr('class') || '';
      }

      function prepareInAnimation() {
        var endingClasses = filterCssClasses(getClassVal(inAnchor));
        var toAdd = getUniqueValues(endingClasses, startingClasses);
        var toRemove = getUniqueValues(startingClasses, endingClasses);

        var animator = $animateCss(clone, {
          to: calculateAnchorStyles(inAnchor),
          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
          delay: true
        });

        // read the comment within `prepareRegularAnimation` to understand
        // why this check is necessary
        return animator.$$willAnimate ? animator : null;
      }

      function end() {
        clone.remove();
        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
      }
    }

    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
      var fromAnimation = prepareRegularAnimation(from, noop);
      var toAnimation = prepareRegularAnimation(to, noop);

      var anchorAnimations = [];
      forEach(anchors, function(anchor) {
        var outElement = anchor['out'];
        var inElement = anchor['in'];
        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
        if (animator) {
          anchorAnimations.push(animator);
        }
      });

      // no point in doing anything when there are no elements to animate
      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;

      return {
        start: function() {
          var animationRunners = [];

          if (fromAnimation) {
            animationRunners.push(fromAnimation.start());
          }

          if (toAnimation) {
            animationRunners.push(toAnimation.start());
          }

          forEach(anchorAnimations, function(animation) {
            animationRunners.push(animation.start());
          });

          var runner = new $$AnimateRunner({
            end: endFn,
            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
          });

          $$AnimateRunner.all(animationRunners, function(status) {
            runner.complete(status);
          });

          return runner;

          function endFn() {
            forEach(animationRunners, function(runner) {
              runner.end();
            });
          }
        }
      };
    }

    function prepareRegularAnimation(animationDetails) {
      var element = animationDetails.element;
      var options = animationDetails.options || {};

      if (animationDetails.structural) {
        options.event = animationDetails.event;
        options.structural = true;
        options.applyClassesEarly = true;

        // we special case the leave animation since we want to ensure that
        // the element is removed as soon as the animation is over. Otherwise
        // a flicker might appear or the element may not be removed at all
        if (animationDetails.event === 'leave') {
          options.onDone = options.domOperation;
        }
      }

      // We assign the preparationClasses as the actual animation event since
      // the internals of $animateCss will just suffix the event token values
      // with `-active` to trigger the animation.
      if (options.preparationClasses) {
        options.event = concatWithSpace(options.event, options.preparationClasses);
      }

      var animator = $animateCss(element, options);

      // the driver lookup code inside of $$animation attempts to spawn a
      // driver one by one until a driver returns a.$$willAnimate animator object.
      // $animateCss will always return an object, however, it will pass in
      // a flag as a hint as to whether an animation was detected or not
      return animator.$$willAnimate ? animator : null;
    }
  }];
}];

// TODO(matsko): use caching here to speed things up for detection
// TODO(matsko): add documentation
//  by the time...

var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
       function($injector,   $$AnimateRunner,   $$jqLite) {

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
         // $animateJs(element, 'enter');
    return function(element, event, classes, options) {
      var animationClosed = false;

      // the `classes` argument is optional and if it is not used
      // then the classes will be resolved from the element's className
      // property as well as options.addClass/options.removeClass.
      if (arguments.length === 3 && isObject(classes)) {
        options = classes;
        classes = null;
      }

      options = prepareAnimationOptions(options);
      if (!classes) {
        classes = element.attr('class') || '';
        if (options.addClass) {
          classes += ' ' + options.addClass;
        }
        if (options.removeClass) {
          classes += ' ' + options.removeClass;
        }
      }

      var classesToAdd = options.addClass;
      var classesToRemove = options.removeClass;

      // the lookupAnimations function returns a series of animation objects that are
      // matched up with one or more of the CSS classes. These animation objects are
      // defined via the module.animation factory function. If nothing is detected then
      // we don't return anything which then makes $animation query the next driver.
      var animations = lookupAnimations(classes);
      var before, after;
      if (animations.length) {
        var afterFn, beforeFn;
        if (event === 'leave') {
          beforeFn = 'leave';
          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
        } else {
          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
          afterFn = event;
        }

        if (event !== 'enter' && event !== 'move') {
          before = packageAnimations(element, event, options, animations, beforeFn);
        }
        after  = packageAnimations(element, event, options, animations, afterFn);
      }

      // no matching animations
      if (!before && !after) return;

      function applyOptions() {
        options.domOperation();
        applyAnimationClasses(element, options);
      }

      function close() {
        animationClosed = true;
        applyOptions();
        applyAnimationStyles(element, options);
      }

      var runner;

      return {
        $$willAnimate: true,
        end: function() {
          if (runner) {
            runner.end();
          } else {
            close();
            runner = new $$AnimateRunner();
            runner.complete(true);
          }
          return runner;
        },
        start: function() {
          if (runner) {
            return runner;
          }

          runner = new $$AnimateRunner();
          var closeActiveAnimations;
          var chain = [];

          if (before) {
            chain.push(function(fn) {
              closeActiveAnimations = before(fn);
            });
          }

          if (chain.length) {
            chain.push(function(fn) {
              applyOptions();
              fn(true);
            });
          } else {
            applyOptions();
          }

          if (after) {
            chain.push(function(fn) {
              closeActiveAnimations = after(fn);
            });
          }

          runner.setHost({
            end: function() {
              endAnimations();
            },
            cancel: function() {
              endAnimations(true);
            }
          });

          $$AnimateRunner.chain(chain, onComplete);
          return runner;

          function onComplete(success) {
            close(success);
            runner.complete(success);
          }

          function endAnimations(cancelled) {
            if (!animationClosed) {
              (closeActiveAnimations || noop)(cancelled);
              onComplete(cancelled);
            }
          }
        }
      };

      function executeAnimationFn(fn, element, event, options, onDone) {
        var args;
        switch (event) {
          case 'animate':
            args = [element, options.from, options.to, onDone];
            break;

          case 'setClass':
            args = [element, classesToAdd, classesToRemove, onDone];
            break;

          case 'addClass':
            args = [element, classesToAdd, onDone];
            break;

          case 'removeClass':
            args = [element, classesToRemove, onDone];
            break;

          default:
            args = [element, onDone];
            break;
        }

        args.push(options);

        var value = fn.apply(fn, args);
        if (value) {
          if (isFunction(value.start)) {
            value = value.start();
          }

          if (value instanceof $$AnimateRunner) {
            value.done(onDone);
          } else if (isFunction(value)) {
            // optional onEnd / onCancel callback
            return value;
          }
        }

        return noop;
      }

      function groupEventedAnimations(element, event, options, animations, fnName) {
        var operations = [];
        forEach(animations, function(ani) {
          var animation = ani[fnName];
          if (!animation) return;

          // note that all of these animations will run in parallel
          operations.push(function() {
            var runner;
            var endProgressCb;

            var resolved = false;
            var onAnimationComplete = function(rejected) {
              if (!resolved) {
                resolved = true;
                (endProgressCb || noop)(rejected);
                runner.complete(!rejected);
              }
            };

            runner = new $$AnimateRunner({
              end: function() {
                onAnimationComplete();
              },
              cancel: function() {
                onAnimationComplete(true);
              }
            });

            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
              var cancelled = result === false;
              onAnimationComplete(cancelled);
            });

            return runner;
          });
        });

        return operations;
      }

      function packageAnimations(element, event, options, animations, fnName) {
        var operations = groupEventedAnimations(element, event, options, animations, fnName);
        if (operations.length === 0) {
          var a, b;
          if (fnName === 'beforeSetClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
          } else if (fnName === 'setClass') {
            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
          }

          if (a) {
            operations = operations.concat(a);
          }
          if (b) {
            operations = operations.concat(b);
          }
        }

        if (operations.length === 0) return;

        // TODO(matsko): add documentation
        return function startAnimation(callback) {
          var runners = [];
          if (operations.length) {
            forEach(operations, function(animateFn) {
              runners.push(animateFn());
            });
          }

          if (runners.length) {
            $$AnimateRunner.all(runners, callback);
          }  else {
            callback();
          }

          return function endFn(reject) {
            forEach(runners, function(runner) {
              if (reject) {
                runner.cancel();
              } else {
                runner.end();
              }
            });
          };
        };
      }
    };

    function lookupAnimations(classes) {
      classes = isArray(classes) ? classes : classes.split(' ');
      var matches = [], flagMap = {};
      for (var i = 0; i < classes.length; i++) {
        var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
        if (animationFactory && !flagMap[klass]) {
          matches.push($injector.get(animationFactory));
          flagMap[klass] = true;
        }
      }
      return matches;
    }
  }];
}];

var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
  $$animationProvider.drivers.push('$$animateJsDriver');
  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
    return function initDriverFn(animationDetails) {
      if (animationDetails.from && animationDetails.to) {
        var fromAnimation = prepareAnimation(animationDetails.from);
        var toAnimation = prepareAnimation(animationDetails.to);
        if (!fromAnimation && !toAnimation) return;

        return {
          start: function() {
            var animationRunners = [];

            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }

            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }

            $$AnimateRunner.all(animationRunners, done);

            var runner = new $$AnimateRunner({
              end: endFnFactory(),
              cancel: endFnFactory()
            });

            return runner;

            function endFnFactory() {
              return function() {
                forEach(animationRunners, function(runner) {
                  // at this point we cannot cancel animations for groups just yet. 1.5+
                  runner.end();
                });
              };
            }

            function done(status) {
              runner.complete(status);
            }
          }
        };
      } else {
        return prepareAnimation(animationDetails);
      }
    };

    function prepareAnimation(animationDetails) {
      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
      var element = animationDetails.element;
      var event = animationDetails.event;
      var options = animationDetails.options;
      var classes = animationDetails.classes;
      return $$animateJs(element, event, classes, options);
    }
  }];
}];

var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var PRE_DIGEST_STATE = 1;
  var RUNNING_STATE = 2;
  var ONE_SPACE = ' ';

  var rules = this.rules = {
    skip: [],
    cancel: [],
    join: []
  };

  function makeTruthyCssClassMap(classString) {
    if (!classString) {
      return null;
    }

    var keys = classString.split(ONE_SPACE);
    var map = Object.create(null);

    forEach(keys, function(key) {
      map[key] = true;
    });
    return map;
  }

  function hasMatchingClasses(newClassString, currentClassString) {
    if (newClassString && currentClassString) {
      var currentClassMap = makeTruthyCssClassMap(currentClassString);
      return newClassString.split(ONE_SPACE).some(function(className) {
        return currentClassMap[className];
      });
    }
  }

  function isAllowed(ruleType, element, currentAnimation, previousAnimation) {
    return rules[ruleType].some(function(fn) {
      return fn(element, currentAnimation, previousAnimation);
    });
  }

  function hasAnimationClasses(animation, and) {
    var a = (animation.addClass || '').length > 0;
    var b = (animation.removeClass || '').length > 0;
    return and ? a && b : a || b;
  }

  rules.join.push(function(element, newAnimation, currentAnimation) {
    // if the new animation is class-based then we can just tack that on
    return !newAnimation.structural && hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // there is no need to animate anything if no classes are being added and
    // there is no structural animation that will be triggered
    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // why should we trigger a new structural animation if the element will
    // be removed from the DOM anyway?
    return currentAnimation.event === 'leave' && newAnimation.structural;
  });

  rules.skip.push(function(element, newAnimation, currentAnimation) {
    // if there is an ongoing current animation then don't even bother running the class-based animation
    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // there can never be two structural animations running at the same time
    return currentAnimation.structural && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // if the previous animation is already running, but the new animation will
    // be triggered, but the new animation is structural
    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
  });

  rules.cancel.push(function(element, newAnimation, currentAnimation) {
    // cancel the animation if classes added / removed in both animation cancel each other out,
    // but only if the current animation isn't structural

    if (currentAnimation.structural) return false;

    var nA = newAnimation.addClass;
    var nR = newAnimation.removeClass;
    var cA = currentAnimation.addClass;
    var cR = currentAnimation.removeClass;

    // early detection to save the global CPU shortage :)
    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
      return false;
    }

    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
  });

  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$HashMap',
               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
       function($$rAF,   $rootScope,   $rootElement,   $document,   $$HashMap,
                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow) {

    var activeAnimationsLookup = new $$HashMap();
    var disabledElementsLookup = new $$HashMap();
    var animationsEnabled = null;

    function postDigestTaskFactory() {
      var postDigestCalled = false;
      return function(fn) {
        // we only issue a call to postDigest before
        // it has first passed. This prevents any callbacks
        // from not firing once the animation has completed
        // since it will be out of the digest cycle.
        if (postDigestCalled) {
          fn();
        } else {
          $rootScope.$$postDigest(function() {
            postDigestCalled = true;
            fn();
          });
        }
      };
    }

    // Wait until all directive and route-related templates are downloaded and
    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
    // all of the remote templates being currently downloaded. If there are no
    // templates currently downloading then the watcher will still fire anyway.
    var deregisterWatch = $rootScope.$watch(
      function() { return $templateRequest.totalPendingRequests === 0; },
      function(isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function() {
          $rootScope.$$postDigest(function() {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      }
    );

    var callbackRegistry = Object.create(null);

    // remember that the classNameFilter is set during the provider/config
    // stage therefore we can optimize here and setup a helper function
    var classNameFilter = $animateProvider.classNameFilter();
    var isAnimatableClassName = !classNameFilter
              ? function() { return true; }
              : function(className) {
                return classNameFilter.test(className);
              };

    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function normalizeAnimationDetails(element, animation) {
      return mergeAnimationDetails(element, animation, {});
    }

    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
      // eslint-disable-next-line no-bitwise
      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
    };

    function findCallbacks(parent, element, event) {
      var targetNode = getDomNode(element);
      var targetParentNode = getDomNode(parent);

      var matches = [];
      var entries = callbackRegistry[event];
      if (entries) {
        forEach(entries, function(entry) {
          if (contains.call(entry.node, targetNode)) {
            matches.push(entry.callback);
          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
            matches.push(entry.callback);
          }
        });
      }

      return matches;
    }

    function filterFromRegistry(list, matchContainer, matchCallback) {
      var containerNode = extractElementNode(matchContainer);
      return list.filter(function(entry) {
        var isMatch = entry.node === containerNode &&
                        (!matchCallback || entry.callback === matchCallback);
        return !isMatch;
      });
    }

    function cleanupEventListeners(phase, element) {
      if (phase === 'close' && !element[0].parentNode) {
        // If the element is not attached to a parentNode, it has been removed by
        // the domOperation, and we can safely remove the event callbacks
        $animate.off(element);
      }
    }

    var $animate = {
      on: function(event, container, callback) {
        var node = extractElementNode(container);
        callbackRegistry[event] = callbackRegistry[event] || [];
        callbackRegistry[event].push({
          node: node,
          callback: callback
        });

        // Remove the callback when the element is removed from the DOM
        jqLite(container).on('$destroy', function() {
          var animationDetails = activeAnimationsLookup.get(node);

          if (!animationDetails) {
            // If there's an animation ongoing, the callback calling code will remove
            // the event listeners. If we'd remove here, the callbacks would be removed
            // before the animation ends
            $animate.off(event, container, callback);
          }
        });
      },

      off: function(event, container, callback) {
        if (arguments.length === 1 && !isString(arguments[0])) {
          container = arguments[0];
          for (var eventType in callbackRegistry) {
            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
          }

          return;
        }

        var entries = callbackRegistry[event];
        if (!entries) return;

        callbackRegistry[event] = arguments.length === 1
            ? null
            : filterFromRegistry(entries, container, callback);
      },

      pin: function(element, parentElement) {
        assertArg(isElement(element), 'element', 'not an element');
        assertArg(isElement(parentElement), 'parentElement', 'not an element');
        element.data(NG_ANIMATE_PIN_DATA, parentElement);
      },

      push: function(element, event, options, domOperation) {
        options = options || {};
        options.domOperation = domOperation;
        return queueAnimation(element, event, options);
      },

      // this method has four signatures:
      //  () - global getter
      //  (bool) - global setter
      //  (element) - element getter
      //  (element, bool) - element setter<F37>
      enabled: function(element, bool) {
        var argCount = arguments.length;

        if (argCount === 0) {
          // () - Global getter
          bool = !!animationsEnabled;
        } else {
          var hasElement = isElement(element);

          if (!hasElement) {
            // (bool) - Global setter
            bool = animationsEnabled = !!element;
          } else {
            var node = getDomNode(element);

            if (argCount === 1) {
              // (element) - Element getter
              bool = !disabledElementsLookup.get(node);
            } else {
              // (element, bool) - Element setter
              disabledElementsLookup.put(node, !bool);
            }
          }
        }

        return bool;
      }
    };

    return $animate;

    function queueAnimation(element, event, initialOptions) {
      // we always make a copy of the options since
      // there should never be any side effects on
      // the input data when running `$animateCss`.
      var options = copy(initialOptions);

      var node, parent;
      element = stripCommentsFromElement(element);
      if (element) {
        node = getDomNode(element);
        parent = element.parent();
      }

      options = prepareAnimationOptions(options);

      // we create a fake runner with a working promise.
      // These methods will become available after the digest has passed
      var runner = new $$AnimateRunner();

      // this is used to trigger callbacks in postDigest mode
      var runInNextPostDigestOrNow = postDigestTaskFactory();

      if (isArray(options.addClass)) {
        options.addClass = options.addClass.join(' ');
      }

      if (options.addClass && !isString(options.addClass)) {
        options.addClass = null;
      }

      if (isArray(options.removeClass)) {
        options.removeClass = options.removeClass.join(' ');
      }

      if (options.removeClass && !isString(options.removeClass)) {
        options.removeClass = null;
      }

      if (options.from && !isObject(options.from)) {
        options.from = null;
      }

      if (options.to && !isObject(options.to)) {
        options.to = null;
      }

      // there are situations where a directive issues an animation for
      // a jqLite wrapper that contains only comment nodes... If this
      // happens then there is no way we can perform an animation
      if (!node) {
        close();
        return runner;
      }

      var className = [node.className, options.addClass, options.removeClass].join(' ');
      if (!isAnimatableClassName(className)) {
        close();
        return runner;
      }

      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      var documentHidden = $document[0].hidden;

      // this is a hard disable of all animations for the application or on
      // the element itself, therefore  there is no need to continue further
      // past this point if not enabled
      // Animations are also disabled if the document is currently hidden (page is not visible
      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
      var skipAnimations = !animationsEnabled || documentHidden || disabledElementsLookup.get(node);
      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
      var hasExistingAnimation = !!existingAnimation.state;

      // there is no point in traversing the same collection of parent ancestors if a followup
      // animation will be run on the same element that already did all that checking work
      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
        skipAnimations = !areAnimationsAllowed(element, parent, event);
      }

      if (skipAnimations) {
        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
        if (documentHidden) notifyProgress(runner, event, 'start');
        close();
        if (documentHidden) notifyProgress(runner, event, 'close');
        return runner;
      }

      if (isStructural) {
        closeChildAnimations(element);
      }

      var newAnimation = {
        structural: isStructural,
        element: element,
        event: event,
        addClass: options.addClass,
        removeClass: options.removeClass,
        close: close,
        options: options,
        runner: runner
      };

      if (hasExistingAnimation) {
        var skipAnimationFlag = isAllowed('skip', element, newAnimation, existingAnimation);
        if (skipAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            close();
            return runner;
          } else {
            mergeAnimationDetails(element, existingAnimation, newAnimation);
            return existingAnimation.runner;
          }
        }
        var cancelAnimationFlag = isAllowed('cancel', element, newAnimation, existingAnimation);
        if (cancelAnimationFlag) {
          if (existingAnimation.state === RUNNING_STATE) {
            // this will end the animation right away and it is safe
            // to do so since the animation is already running and the
            // runner callback code will run in async
            existingAnimation.runner.end();
          } else if (existingAnimation.structural) {
            // this means that the animation is queued into a digest, but
            // hasn't started yet. Therefore it is safe to run the close
            // method which will call the runner methods in async.
            existingAnimation.close();
          } else {
            // this will merge the new animation options into existing animation options
            mergeAnimationDetails(element, existingAnimation, newAnimation);

            return existingAnimation.runner;
          }
        } else {
          // a joined animation means that this animation will take over the existing one
          // so an example would involve a leave animation taking over an enter. Then when
          // the postDigest kicks in the enter will be ignored.
          var joinAnimationFlag = isAllowed('join', element, newAnimation, existingAnimation);
          if (joinAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              normalizeAnimationDetails(element, newAnimation);
            } else {
              applyGeneratedPreparationClasses(element, isStructural ? event : null, options);

              event = newAnimation.event = existingAnimation.event;
              options = mergeAnimationDetails(element, existingAnimation, newAnimation);

              //we return the same runner since only the option values of this animation will
              //be fed into the `existingAnimation`.
              return existingAnimation.runner;
            }
          }
        }
      } else {
        // normalization in this case means that it removes redundant CSS classes that
        // already exist (addClass) or do not exist (removeClass) on the element
        normalizeAnimationDetails(element, newAnimation);
      }

      // when the options are merged and cleaned up we may end up not having to do
      // an animation at all, therefore we should check this before issuing a post
      // digest callback. Structural animations will always run no matter what.
      var isValidAnimation = newAnimation.structural;
      if (!isValidAnimation) {
        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
                            || hasAnimationClasses(newAnimation);
      }

      if (!isValidAnimation) {
        close();
        clearElementAnimationState(element);
        return runner;
      }

      // the counter keeps track of cancelled animations
      var counter = (existingAnimation.counter || 0) + 1;
      newAnimation.counter = counter;

      markElementAnimationState(element, PRE_DIGEST_STATE, newAnimation);

      $rootScope.$$postDigest(function() {
        var animationDetails = activeAnimationsLookup.get(node);
        var animationCancelled = !animationDetails;
        animationDetails = animationDetails || {};

        // if addClass/removeClass is called before something like enter then the
        // registered parent element may not be present. The code below will ensure
        // that a final value for parent element is obtained
        var parentElement = element.parent() || [];

        // animate/structural/class-based animations all have requirements. Otherwise there
        // is no point in performing an animation. The parent node must also be set.
        var isValidAnimation = parentElement.length > 0
                                && (animationDetails.event === 'animate'
                                    || animationDetails.structural
                                    || hasAnimationClasses(animationDetails));

        // this means that the previous animation was cancelled
        // even if the follow-up animation is the same event
        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
          // if another animation did not take over then we need
          // to make sure that the domOperation and options are
          // handled accordingly
          if (animationCancelled) {
            applyAnimationClasses(element, options);
            applyAnimationStyles(element, options);
          }

          // if the event changed from something like enter to leave then we do
          // it, otherwise if it's the same then the end result will be the same too
          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
            options.domOperation();
            runner.end();
          }

          // in the event that the element animation was not cancelled or a follow-up animation
          // isn't allowed to animate from here then we need to clear the state of the element
          // so that any future animations won't read the expired animation data.
          if (!isValidAnimation) {
            clearElementAnimationState(element);
          }

          return;
        }

        // this combined multiple class to addClass / removeClass into a setClass event
        // so long as a structural event did not take over the animation
        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
            ? 'setClass'
            : animationDetails.event;

        markElementAnimationState(element, RUNNING_STATE);
        var realRunner = $$animation(element, event, animationDetails.options);

        // this will update the runner's flow-control events based on
        // the `realRunner` object.
        runner.setHost(realRunner);
        notifyProgress(runner, event, 'start', {});

        realRunner.done(function(status) {
          close(!status);
          var animationDetails = activeAnimationsLookup.get(node);
          if (animationDetails && animationDetails.counter === counter) {
            clearElementAnimationState(getDomNode(element));
          }
          notifyProgress(runner, event, 'close', {});
        });
      });

      return runner;

      function notifyProgress(runner, event, phase, data) {
        runInNextPostDigestOrNow(function() {
          var callbacks = findCallbacks(parent, element, event);
          if (callbacks.length) {
            // do not optimize this call here to RAF because
            // we don't know how heavy the callback code here will
            // be and if this code is buffered then this can
            // lead to a performance regression.
            $$rAF(function() {
              forEach(callbacks, function(callback) {
                callback(element, phase, data);
              });
              cleanupEventListeners(phase, element);
            });
          } else {
            cleanupEventListeners(phase, element);
          }
        });
        runner.progress(event, phase, data);
      }

      function close(reject) {
        clearGeneratedClasses(element, options);
        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();
        runner.complete(!reject);
      }
    }

    function closeChildAnimations(element) {
      var node = getDomNode(element);
      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
      forEach(children, function(child) {
        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
        var animationDetails = activeAnimationsLookup.get(child);
        if (animationDetails) {
          switch (state) {
            case RUNNING_STATE:
              animationDetails.runner.end();
              /* falls through */
            case PRE_DIGEST_STATE:
              activeAnimationsLookup.remove(child);
              break;
          }
        }
      });
    }

    function clearElementAnimationState(element) {
      var node = getDomNode(element);
      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
      activeAnimationsLookup.remove(node);
    }

    function isMatchingElement(nodeOrElmA, nodeOrElmB) {
      return getDomNode(nodeOrElmA) === getDomNode(nodeOrElmB);
    }

    /**
     * This fn returns false if any of the following is true:
     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
     * b) a parent element has an ongoing structural animation, and animateChildren is false
     * c) the element is not a child of the body
     * d) the element is not a child of the $rootElement
     */
    function areAnimationsAllowed(element, parentElement, event) {
      var bodyElement = jqLite($document[0].body);
      var bodyElementDetected = isMatchingElement(element, bodyElement) || element[0].nodeName === 'HTML';
      var rootElementDetected = isMatchingElement(element, $rootElement);
      var parentAnimationDetected = false;
      var animateChildren;
      var elementDisabled = disabledElementsLookup.get(getDomNode(element));

      var parentHost = jqLite.data(element[0], NG_ANIMATE_PIN_DATA);
      if (parentHost) {
        parentElement = parentHost;
      }

      parentElement = getDomNode(parentElement);

      while (parentElement) {
        if (!rootElementDetected) {
          // angular doesn't want to attempt to animate elements outside of the application
          // therefore we need to ensure that the rootElement is an ancestor of the current element
          rootElementDetected = isMatchingElement(parentElement, $rootElement);
        }

        if (parentElement.nodeType !== ELEMENT_NODE) {
          // no point in inspecting the #document element
          break;
        }

        var details = activeAnimationsLookup.get(parentElement) || {};
        // either an enter, leave or move animation will commence
        // therefore we can't allow any animations to take place
        // but if a parent animation is class-based then that's ok
        if (!parentAnimationDetected) {
          var parentElementDisabled = disabledElementsLookup.get(parentElement);

          if (parentElementDisabled === true && elementDisabled !== false) {
            // disable animations if the user hasn't explicitly enabled animations on the
            // current element
            elementDisabled = true;
            // element is disabled via parent element, no need to check anything else
            break;
          } else if (parentElementDisabled === false) {
            elementDisabled = false;
          }
          parentAnimationDetected = details.structural;
        }

        if (isUndefined(animateChildren) || animateChildren === true) {
          var value = jqLite.data(parentElement, NG_ANIMATE_CHILDREN_DATA);
          if (isDefined(value)) {
            animateChildren = value;
          }
        }

        // there is no need to continue traversing at this point
        if (parentAnimationDetected && animateChildren === false) break;

        if (!bodyElementDetected) {
          // we also need to ensure that the element is or will be a part of the body element
          // otherwise it is pointless to even issue an animation to be rendered
          bodyElementDetected = isMatchingElement(parentElement, bodyElement);
        }

        if (bodyElementDetected && rootElementDetected) {
          // If both body and root have been found, any other checks are pointless,
          // as no animation data should live outside the application
          break;
        }

        if (!rootElementDetected) {
          // If no rootElement is detected, check if the parentElement is pinned to another element
          parentHost = jqLite.data(parentElement, NG_ANIMATE_PIN_DATA);
          if (parentHost) {
            // The pin target element becomes the next parent element
            parentElement = getDomNode(parentHost);
            continue;
          }
        }

        parentElement = parentElement.parentNode;
      }

      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
      return allowAnimation && rootElementDetected && bodyElementDetected;
    }

    function markElementAnimationState(element, state, details) {
      details = details || {};
      details.state = state;

      var node = getDomNode(element);
      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);

      var oldValue = activeAnimationsLookup.get(node);
      var newValue = oldValue
          ? extend(oldValue, details)
          : details;
      activeAnimationsLookup.put(node, newValue);
    }
  }];
}];

/* exported $$AnimationProvider */

var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';

  var drivers = this.drivers = [];

  var RUNNER_STORAGE_KEY = '$$animationRunner';

  function setRunner(element, runner) {
    element.data(RUNNER_STORAGE_KEY, runner);
  }

  function removeRunner(element) {
    element.removeData(RUNNER_STORAGE_KEY);
  }

  function getRunner(element) {
    return element.data(RUNNER_STORAGE_KEY);
  }

  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$HashMap', '$$rAFScheduler',
       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$HashMap,   $$rAFScheduler) {

    var animationQueue = [];
    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);

    function sortAnimations(animations) {
      var tree = { children: [] };
      var i, lookup = new $$HashMap();

      // this is done first beforehand so that the hashmap
      // is filled with a list of the elements that will be animated
      for (i = 0; i < animations.length; i++) {
        var animation = animations[i];
        lookup.put(animation.domNode, animations[i] = {
          domNode: animation.domNode,
          fn: animation.fn,
          children: []
        });
      }

      for (i = 0; i < animations.length; i++) {
        processNode(animations[i]);
      }

      return flatten(tree);

      function processNode(entry) {
        if (entry.processed) return entry;
        entry.processed = true;

        var elementNode = entry.domNode;
        var parentNode = elementNode.parentNode;
        lookup.put(elementNode, entry);

        var parentEntry;
        while (parentNode) {
          parentEntry = lookup.get(parentNode);
          if (parentEntry) {
            if (!parentEntry.processed) {
              parentEntry = processNode(parentEntry);
            }
            break;
          }
          parentNode = parentNode.parentNode;
        }

        (parentEntry || tree).children.push(entry);
        return entry;
      }

      function flatten(tree) {
        var result = [];
        var queue = [];
        var i;

        for (i = 0; i < tree.children.length; i++) {
          queue.push(tree.children[i]);
        }

        var remainingLevelEntries = queue.length;
        var nextLevelEntries = 0;
        var row = [];

        for (i = 0; i < queue.length; i++) {
          var entry = queue[i];
          if (remainingLevelEntries <= 0) {
            remainingLevelEntries = nextLevelEntries;
            nextLevelEntries = 0;
            result.push(row);
            row = [];
          }
          row.push(entry.fn);
          entry.children.forEach(function(childEntry) {
            nextLevelEntries++;
            queue.push(childEntry);
          });
          remainingLevelEntries--;
        }

        if (row.length) {
          result.push(row);
        }

        return result;
      }
    }

    // TODO(matsko): document the signature in a better way
    return function(element, event, options) {
      options = prepareAnimationOptions(options);
      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

      // there is no animation at the current moment, however
      // these runner methods will get later updated with the
      // methods leading into the driver's end/cancel methods
      // for now they just stop the animation from starting
      var runner = new $$AnimateRunner({
        end: function() { close(); },
        cancel: function() { close(true); }
      });

      if (!drivers.length) {
        close();
        return runner;
      }

      setRunner(element, runner);

      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
      var tempClasses = options.tempClasses;
      if (tempClasses) {
        classes += ' ' + tempClasses;
        options.tempClasses = null;
      }

      var prepareClassName;
      if (isStructural) {
        prepareClassName = 'ng-' + event + PREPARE_CLASS_SUFFIX;
        $$jqLite.addClass(element, prepareClassName);
      }

      animationQueue.push({
        // this data is used by the postDigest code and passed into
        // the driver step function
        element: element,
        classes: classes,
        event: event,
        structural: isStructural,
        options: options,
        beforeStart: beforeStart,
        close: close
      });

      element.on('$destroy', handleDestroyedElement);

      // we only want there to be one function called within the post digest
      // block. This way we can group animations for all the animations that
      // were apart of the same postDigest flush call.
      if (animationQueue.length > 1) return runner;

      $rootScope.$$postDigest(function() {
        var animations = [];
        forEach(animationQueue, function(entry) {
          // the element was destroyed early on which removed the runner
          // form its storage. This means we can't animate this element
          // at all and it already has been closed due to destruction.
          if (getRunner(entry.element)) {
            animations.push(entry);
          } else {
            entry.close();
          }
        });

        // now any future animations will be in another postDigest
        animationQueue.length = 0;

        var groupedAnimations = groupAnimations(animations);
        var toBeSortedAnimations = [];

        forEach(groupedAnimations, function(animationEntry) {
          toBeSortedAnimations.push({
            domNode: getDomNode(animationEntry.from ? animationEntry.from.element : animationEntry.element),
            fn: function triggerAnimationStart() {
              // it's important that we apply the `ng-animate` CSS class and the
              // temporary classes before we do any driver invoking since these
              // CSS classes may be required for proper CSS detection.
              animationEntry.beforeStart();

              var startAnimationFn, closeFn = animationEntry.close;

              // in the event that the element was removed before the digest runs or
              // during the RAF sequencing then we should not trigger the animation.
              var targetElement = animationEntry.anchors
                  ? (animationEntry.from.element || animationEntry.to.element)
                  : animationEntry.element;

              if (getRunner(targetElement)) {
                var operation = invokeFirstDriver(animationEntry);
                if (operation) {
                  startAnimationFn = operation.start;
                }
              }

              if (!startAnimationFn) {
                closeFn();
              } else {
                var animationRunner = startAnimationFn();
                animationRunner.done(function(status) {
                  closeFn(!status);
                });
                updateAnimationRunners(animationEntry, animationRunner);
              }
            }
          });
        });

        // we need to sort each of the animations in order of parent to child
        // relationships. This ensures that the child classes are applied at the
        // right time.
        $$rAFScheduler(sortAnimations(toBeSortedAnimations));
      });

      return runner;

      // TODO(matsko): change to reference nodes
      function getAnchorNodes(node) {
        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
              ? [node]
              : node.querySelectorAll(SELECTOR);
        var anchors = [];
        forEach(items, function(node) {
          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
          if (attr && attr.length) {
            anchors.push(node);
          }
        });
        return anchors;
      }

      function groupAnimations(animations) {
        var preparedAnimations = [];
        var refLookup = {};
        forEach(animations, function(animation, index) {
          var element = animation.element;
          var node = getDomNode(element);
          var event = animation.event;
          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];

          if (anchorNodes.length) {
            var direction = enterOrMove ? 'to' : 'from';

            forEach(anchorNodes, function(anchor) {
              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
              refLookup[key] = refLookup[key] || {};
              refLookup[key][direction] = {
                animationID: index,
                element: jqLite(anchor)
              };
            });
          } else {
            preparedAnimations.push(animation);
          }
        });

        var usedIndicesLookup = {};
        var anchorGroups = {};
        forEach(refLookup, function(operations, key) {
          var from = operations.from;
          var to = operations.to;

          if (!from || !to) {
            // only one of these is set therefore we can't have an
            // anchor animation since all three pieces are required
            var index = from ? from.animationID : to.animationID;
            var indexKey = index.toString();
            if (!usedIndicesLookup[indexKey]) {
              usedIndicesLookup[indexKey] = true;
              preparedAnimations.push(animations[index]);
            }
            return;
          }

          var fromAnimation = animations[from.animationID];
          var toAnimation = animations[to.animationID];
          var lookupKey = from.animationID.toString();
          if (!anchorGroups[lookupKey]) {
            var group = anchorGroups[lookupKey] = {
              structural: true,
              beforeStart: function() {
                fromAnimation.beforeStart();
                toAnimation.beforeStart();
              },
              close: function() {
                fromAnimation.close();
                toAnimation.close();
              },
              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
              from: fromAnimation,
              to: toAnimation,
              anchors: [] // TODO(matsko): change to reference nodes
            };

            // the anchor animations require that the from and to elements both have at least
            // one shared CSS class which effectively marries the two elements together to use
            // the same animation driver and to properly sequence the anchor animation.
            if (group.classes.length) {
              preparedAnimations.push(group);
            } else {
              preparedAnimations.push(fromAnimation);
              preparedAnimations.push(toAnimation);
            }
          }

          anchorGroups[lookupKey].anchors.push({
            'out': from.element, 'in': to.element
          });
        });

        return preparedAnimations;
      }

      function cssClassesIntersection(a,b) {
        a = a.split(' ');
        b = b.split(' ');
        var matches = [];

        for (var i = 0; i < a.length; i++) {
          var aa = a[i];
          if (aa.substring(0,3) === 'ng-') continue;

          for (var j = 0; j < b.length; j++) {
            if (aa === b[j]) {
              matches.push(aa);
              break;
            }
          }
        }

        return matches.join(' ');
      }

      function invokeFirstDriver(animationDetails) {
        // we loop in reverse order since the more general drivers (like CSS and JS)
        // may attempt more elements, but custom drivers are more particular
        for (var i = drivers.length - 1; i >= 0; i--) {
          var driverName = drivers[i];
          var factory = $injector.get(driverName);
          var driver = factory(animationDetails);
          if (driver) {
            return driver;
          }
        }
      }

      function beforeStart() {
        element.addClass(NG_ANIMATE_CLASSNAME);
        if (tempClasses) {
          $$jqLite.addClass(element, tempClasses);
        }
        if (prepareClassName) {
          $$jqLite.removeClass(element, prepareClassName);
          prepareClassName = null;
        }
      }

      function updateAnimationRunners(animation, newRunner) {
        if (animation.from && animation.to) {
          update(animation.from.element);
          update(animation.to.element);
        } else {
          update(animation.element);
        }

        function update(element) {
          var runner = getRunner(element);
          if (runner) runner.setHost(newRunner);
        }
      }

      function handleDestroyedElement() {
        var runner = getRunner(element);
        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
          runner.end();
        }
      }

      function close(rejected) {
        element.off('$destroy', handleDestroyedElement);
        removeRunner(element);

        applyAnimationClasses(element, options);
        applyAnimationStyles(element, options);
        options.domOperation();

        if (tempClasses) {
          $$jqLite.removeClass(element, tempClasses);
        }

        element.removeClass(NG_ANIMATE_CLASSNAME);
        runner.complete(!rejected);
      }
    };
  }];
}];

/**
 * @ngdoc directive
 * @name ngAnimateSwap
 * @restrict A
 * @scope
 *
 * @description
 *
 * ngAnimateSwap is a animation-oriented directive that allows for the container to
 * be removed and entered in whenever the associated expression changes. A
 * common usecase for this directive is a rotating banner or slider component which
 * contains one image being present at a time. When the active image changes
 * then the old image will perform a `leave` animation and the new element
 * will be inserted via an `enter` animation.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|--------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
 *
 * @example
 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
 *          deps="angular-animate.js"
 *          animations="true" fixBase="true">
 *   <file name="index.html">
 *     <div class="container" ng-controller="AppCtrl">
 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
 *         {{ number }}
 *       </div>
 *     </div>
 *   </file>
 *   <file name="script.js">
 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
 *         $scope.number = 0;
 *         $interval(function() {
 *           $scope.number++;
 *         }, 1000);
 *
 *         var colors = ['red','blue','green','yellow','orange'];
 *         $scope.colorClass = function(number) {
 *           return colors[number % colors.length];
 *         };
 *       }]);
 *   </file>
 *  <file name="animations.css">
 *  .container {
 *    height:250px;
 *    width:250px;
 *    position:relative;
 *    overflow:hidden;
 *    border:2px solid black;
 *  }
 *  .container .cell {
 *    font-size:150px;
 *    text-align:center;
 *    line-height:250px;
 *    position:absolute;
 *    top:0;
 *    left:0;
 *    right:0;
 *    border-bottom:2px solid black;
 *  }
 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
 *    transition:0.5s linear all;
 *  }
 *  .swap-animation.ng-enter {
 *    top:-250px;
 *  }
 *  .swap-animation.ng-enter-active {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave {
 *    top:0px;
 *  }
 *  .swap-animation.ng-leave-active {
 *    top:250px;
 *  }
 *  .red { background:red; }
 *  .green { background:green; }
 *  .blue { background:blue; }
 *  .yellow { background:yellow; }
 *  .orange { background:orange; }
 *  </file>
 * </example>
 */
var ngAnimateSwapDirective = ['$animate', '$rootScope', function($animate, $rootScope) {
  return {
    restrict: 'A',
    transclude: 'element',
    terminal: true,
    priority: 600, // we use 600 here to ensure that the directive is caught before others
    link: function(scope, $element, attrs, ctrl, $transclude) {
      var previousElement, previousScope;
      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
        if (previousElement) {
          $animate.leave(previousElement);
        }
        if (previousScope) {
          previousScope.$destroy();
          previousScope = null;
        }
        if (value || value === 0) {
          previousScope = scope.$new();
          $transclude(previousScope, function(element) {
            previousElement = element;
            $animate.enter(element, null, $element);
          });
        }
      });
    }
  };
}];

/**
 * @ngdoc module
 * @name ngAnimate
 * @description
 *
 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an Angular app.
 *
 * <div doc-module-components="ngAnimate"></div>
 *
 * # Usage
 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
 * the HTML element that the animation will be triggered on.
 *
 * ## Directive Support
 * The following directives are "animation aware":
 *
 * | Directive                                                                                                | Supported Animations                                                     |
 * |----------------------------------------------------------------------------------------------------------|--------------------------------------------------------------------------|
 * | {@link ng.directive:ngRepeat#animations ngRepeat}                                                        | enter, leave and move                                                    |
 * | {@link ngRoute.directive:ngView#animations ngView}                                                       | enter and leave                                                          |
 * | {@link ng.directive:ngInclude#animations ngInclude}                                                      | enter and leave                                                          |
 * | {@link ng.directive:ngSwitch#animations ngSwitch}                                                        | enter and leave                                                          |
 * | {@link ng.directive:ngIf#animations ngIf}                                                                | enter and leave                                                          |
 * | {@link ng.directive:ngClass#animations ngClass}                                                          | add and remove (the CSS class(es) present)                               |
 * | {@link ng.directive:ngShow#animations ngShow} & {@link ng.directive:ngHide#animations ngHide}            | add and remove (the ng-hide class value)                                 |
 * | {@link ng.directive:form#animation-hooks form} & {@link ng.directive:ngModel#animation-hooks ngModel}    | add and remove (dirty, pristine, valid, invalid & all other validations) |
 * | {@link module:ngMessages#animations ngMessages}                                                          | add and remove (ng-active & ng-inactive)                                 |
 * | {@link module:ngMessages#animations ngMessage}                                                           | enter and leave                                                          |
 *
 * (More information can be found by visiting each the documentation associated with each directive.)
 *
 * ## CSS-based Animations
 *
 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
 * and CSS code we can create an animation that will be picked up by Angular when an underlying directive performs an operation.
 *
 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
 *
 * ```html
 * <div ng-if="bool" class="fade">
 *    Fade me in out
 * </div>
 * <button ng-click="bool=true">Fade In!</button>
 * <button ng-click="bool=false">Fade Out!</button>
 * ```
 *
 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
 *
 * ```css
 * /&#42; The starting CSS styles for the enter animation &#42;/
 * .fade.ng-enter {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 *
 * /&#42; The finishing CSS styles for the enter animation &#42;/
 * .fade.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * ```
 *
 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
 *
 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
 *
 * ```css
 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
 * .fade.ng-leave {
 *   transition:0.5s linear all;
 *   opacity:1;
 * }
 * .fade.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
 *
 * ```css
 * /&#42; there is no need to define anything inside of the destination
 * CSS class since the keyframe will take charge of the animation &#42;/
 * .fade.ng-leave {
 *   animation: my_fade_animation 0.5s linear;
 *   -webkit-animation: my_fade_animation 0.5s linear;
 * }
 *
 * @keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 *
 * @-webkit-keyframes my_fade_animation {
 *   from { opacity:1; }
 *   to { opacity:0; }
 * }
 * ```
 *
 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
 *
 * ### CSS Class-based Animations
 *
 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
 * and removed.
 *
 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
 *
 * ```html
 * <div ng-show="bool" class="fade">
 *   Show and hide me
 * </div>
 * <button ng-click="bool=!bool">Toggle</button>
 *
 * <style>
 * .fade.ng-hide {
 *   transition:0.5s linear all;
 *   opacity:0;
 * }
 * </style>
 * ```
 *
 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
 *
 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
 * with CSS styles.
 *
 * ```html
 * <div ng-class="{on:onOff}" class="highlight">
 *   Highlight this box
 * </div>
 * <button ng-click="onOff=!onOff">Toggle</button>
 *
 * <style>
 * .highlight {
 *   transition:0.5s linear all;
 * }
 * .highlight.on-add {
 *   background:white;
 * }
 * .highlight.on {
 *   background:yellow;
 * }
 * .highlight.on-remove {
 *   background:black;
 * }
 * </style>
 * ```
 *
 * We can also make use of CSS keyframes by placing them within the CSS classes.
 *
 *
 * ### CSS Staggering Animations
 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
 *
 * ```css
 * .my-animation.ng-enter {
 *   /&#42; standard transition code &#42;/
 *   transition: 1s linear all;
 *   opacity:0;
 * }
 * .my-animation.ng-enter-stagger {
 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
 *   transition-delay: 0.1s;
 *
 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
 *     to not accidentally inherit a delay property from another CSS class &#42;/
 *   transition-duration: 0s;
 * }
 * .my-animation.ng-enter.ng-enter-active {
 *   /&#42; standard transition styles &#42;/
 *   opacity:1;
 * }
 * ```
 *
 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
 *
 * The following code will issue the **ng-leave-stagger** event on the element provided:
 *
 * ```js
 * var kids = parent.children();
 *
 * $animate.leave(kids[0]); //stagger index=0
 * $animate.leave(kids[1]); //stagger index=1
 * $animate.leave(kids[2]); //stagger index=2
 * $animate.leave(kids[3]); //stagger index=3
 * $animate.leave(kids[4]); //stagger index=4
 *
 * window.requestAnimationFrame(function() {
 *   //stagger has reset itself
 *   $animate.leave(kids[5]); //stagger index=0
 *   $animate.leave(kids[6]); //stagger index=1
 *
 *   $scope.$digest();
 * });
 * ```
 *
 * Stagger animations are currently only supported within CSS-defined animations.
 *
 * ### The `ng-animate` CSS class
 *
 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
 *
 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
 *
 * ```css
 * .zipper.ng-animate {
 *   transition:0.5s linear all;
 * }
 * .zipper.ng-enter {
 *   opacity:0;
 * }
 * .zipper.ng-enter.ng-enter-active {
 *   opacity:1;
 * }
 * .zipper.ng-leave {
 *   opacity:1;
 * }
 * .zipper.ng-leave.ng-leave-active {
 *   opacity:0;
 * }
 * ```
 *
 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
 * the CSS class once an animation has completed.)
 *
 *
 * ### The `ng-[event]-prepare` class
 *
 * This is a special class that can be used to prevent unwanted flickering / flash of content before
 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
 * before the actual animation starts (after waiting for a $digest).
 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
 *
 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
 * into elements that have class-based animations such as `ngClass`.
 *
 * ```html
 * <div ng-class="{red: myProp}">
 *   <div ng-class="{blue: myProp}">
 *     <div class="message" ng-if="myProp"></div>
 *   </div>
 * </div>
 * ```
 *
 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
 *
 * ```css
 * .message.ng-enter-prepare {
 *   opacity: 0;
 * }
 *
 * ```
 *
 * ## JavaScript-based Animations
 *
 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
 * `module.animation()` module function we can register the animation.
 *
 * Let's see an example of a enter/leave animation using `ngRepeat`:
 *
 * ```html
 * <div ng-repeat="item in items" class="slide">
 *   {{ item }}
 * </div>
 * ```
 *
 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     // make note that other events (like addClass/removeClass)
 *     // have different function input parameters
 *     enter: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *
 *       // remember to call doneFn so that angular
 *       // knows that the animation has concluded
 *     },
 *
 *     move: function(element, doneFn) {
 *       jQuery(element).fadeIn(1000, doneFn);
 *     },
 *
 *     leave: function(element, doneFn) {
 *       jQuery(element).fadeOut(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
 * greensock.js and velocity.js.
 *
 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
 *
 * ```html
 * <div ng-class="color" class="colorful">
 *   this box is moody
 * </div>
 * <button ng-click="color='red'">Change to red</button>
 * <button ng-click="color='blue'">Change to blue</button>
 * <button ng-click="color='green'">Change to green</button>
 * ```
 *
 * ```js
 * myModule.animation('.colorful', [function() {
 *   return {
 *     addClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     removeClass: function(element, className, doneFn) {
 *       // do some cool animation and call the doneFn
 *     },
 *     setClass: function(element, addedClass, removedClass, doneFn) {
 *       // do some cool animation and call the doneFn
 *     }
 *   }
 * }]);
 * ```
 *
 * ## CSS + JS Animations Together
 *
 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of Angular,
 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
 * charge of the animation**:
 *
 * ```html
 * <div ng-if="bool" class="slide">
 *   Slide in and out
 * </div>
 * ```
 *
 * ```js
 * myModule.animation('.slide', [function() {
 *   return {
 *     enter: function(element, doneFn) {
 *       jQuery(element).slideIn(1000, doneFn);
 *     }
 *   }
 * }]);
 * ```
 *
 * ```css
 * .slide.ng-enter {
 *   transition:0.5s linear all;
 *   transform:translateY(-100px);
 * }
 * .slide.ng-enter.ng-enter-active {
 *   transform:translateY(0);
 * }
 * ```
 *
 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
 * our own JS-based animation code:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
 *
 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
 * data into `$animateCss` directly:
 *
 * ```js
 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
 *   return {
 *     enter: function(element) {
 *       return $animateCss(element, {
 *         event: 'enter',
 *         structural: true,
 *         addClass: 'maroon-setting',
 *         from: { height:0 },
 *         to: { height: 200 }
 *       });
 *     }
 *   }
 * }]);
 * ```
 *
 * Now we can fill in the rest via our transition CSS code:
 *
 * ```css
 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
 * .slide.ng-enter { transition:0.5s linear all; }
 *
 * /&#42; this extra CSS class will be absorbed into the transition
 * since the $animateCss code is adding the class &#42;/
 * .maroon-setting { background:red; }
 * ```
 *
 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
 *
 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
 *
 * ## Animation Anchoring (via `ng-animate-ref`)
 *
 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
 * structural areas of an application (like views) by pairing up elements using an attribute
 * called `ng-animate-ref`.
 *
 * Let's say for example we have two views that are managed by `ng-view` and we want to show
 * that there is a relationship between two components situated in within these views. By using the
 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
 * can then attach an animation, which is triggered when the view changes.
 *
 * Say for example we have the following template code:
 *
 * ```html
 * <!-- index.html -->
 * <div ng-view class="view-animation">
 * </div>
 *
 * <!-- home.html -->
 * <a href="#/banner-page">
 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * </a>
 *
 * <!-- banner-page.html -->
 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
 * ```
 *
 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
 * HTML contents to see if there is a match reference between any components in the view
 * that is leaving and the view that is entering. It will scan both the view which is being
 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
 * contain a matching ref value.
 *
 * The two images match since they share the same ref value. ngAnimate will now create a
 * transport element (which is a clone of the first image element) and it will then attempt
 * to animate to the position of the second image element in the next view. For the animation to
 * work a special CSS class called `ng-anchor` will be added to the transported element.
 *
 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
 * ngAnimate will handle the entire transition for us as well as the addition and removal of
 * any changes of CSS classes between the elements:
 *
 * ```css
 * .banner.ng-anchor {
 *   /&#42; this animation will last for 1 second since there are
 *          two phases to the animation (an `in` and an `out` phase) &#42;/
 *   transition:0.5s linear all;
 * }
 * ```
 *
 * We also **must** include animations for the views that are being entered and removed
 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
 *
 * ```css
 * .view-animation.ng-enter, .view-animation.ng-leave {
 *   transition:0.5s linear all;
 *   position:fixed;
 *   left:0;
 *   top:0;
 *   width:100%;
 * }
 * .view-animation.ng-enter {
 *   transform:translateX(100%);
 * }
 * .view-animation.ng-leave,
 * .view-animation.ng-enter.ng-enter-active {
 *   transform:translateX(0%);
 * }
 * .view-animation.ng-leave.ng-leave-active {
 *   transform:translateX(-100%);
 * }
 * ```
 *
 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
 * from its origin. Once that animation is over then the `in` stage occurs which animates the
 * element to its destination. The reason why there are two animations is to give enough time
 * for the enter animation on the new element to be ready.
 *
 * The example above sets up a transition for both the in and out phases, but we can also target the out or
 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
 *
 * ```css
 * .banner.ng-anchor-out {
 *   transition: 0.5s linear all;
 *
 *   /&#42; the scale will be applied during the out animation,
 *          but will be animated away when the in animation runs &#42;/
 *   transform: scale(1.2);
 * }
 *
 * .banner.ng-anchor-in {
 *   transition: 1s linear all;
 * }
 * ```
 *
 *
 *
 *
 * ### Anchoring Demo
 *
  <example module="anchoringExample"
           name="anchoringExample"
           id="anchoringExample"
           deps="angular-animate.js;angular-route.js"
           animations="true">
    <file name="index.html">
      <a href="#/">Home</a>
      <hr />
      <div class="view-container">
        <div ng-view class="view"></div>
      </div>
    </file>
    <file name="script.js">
      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
        .config(['$routeProvider', function($routeProvider) {
          $routeProvider.when('/', {
            templateUrl: 'home.html',
            controller: 'HomeController as home'
          });
          $routeProvider.when('/profile/:id', {
            templateUrl: 'profile.html',
            controller: 'ProfileController as profile'
          });
        }])
        .run(['$rootScope', function($rootScope) {
          $rootScope.records = [
            { id: 1, title: 'Miss Beulah Roob' },
            { id: 2, title: 'Trent Morissette' },
            { id: 3, title: 'Miss Ava Pouros' },
            { id: 4, title: 'Rod Pouros' },
            { id: 5, title: 'Abdul Rice' },
            { id: 6, title: 'Laurie Rutherford Sr.' },
            { id: 7, title: 'Nakia McLaughlin' },
            { id: 8, title: 'Jordon Blanda DVM' },
            { id: 9, title: 'Rhoda Hand' },
            { id: 10, title: 'Alexandrea Sauer' }
          ];
        }])
        .controller('HomeController', [function() {
          //empty
        }])
        .controller('ProfileController', ['$rootScope', '$routeParams',
            function ProfileController($rootScope, $routeParams) {
          var index = parseInt($routeParams.id, 10);
          var record = $rootScope.records[index - 1];

          this.title = record.title;
          this.id = record.id;
        }]);
    </file>
    <file name="home.html">
      <h2>Welcome to the home page</h1>
      <p>Please click on an element</p>
      <a class="record"
         ng-href="#/profile/{{ record.id }}"
         ng-animate-ref="{{ record.id }}"
         ng-repeat="record in records">
        {{ record.title }}
      </a>
    </file>
    <file name="profile.html">
      <div class="profile record" ng-animate-ref="{{ profile.id }}">
        {{ profile.title }}
      </div>
    </file>
    <file name="animations.css">
      .record {
        display:block;
        font-size:20px;
      }
      .profile {
        background:black;
        color:white;
        font-size:100px;
      }
      .view-container {
        position:relative;
      }
      .view-container > .view.ng-animate {
        position:absolute;
        top:0;
        left:0;
        width:100%;
        min-height:500px;
      }
      .view.ng-enter, .view.ng-leave,
      .record.ng-anchor {
        transition:0.5s linear all;
      }
      .view.ng-enter {
        transform:translateX(100%);
      }
      .view.ng-enter.ng-enter-active, .view.ng-leave {
        transform:translateX(0%);
      }
      .view.ng-leave.ng-leave-active {
        transform:translateX(-100%);
      }
      .record.ng-anchor-out {
        background:red;
      }
    </file>
  </example>
 *
 * ### How is the element transported?
 *
 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
 * will become visible since the shim class will be removed.
 *
 * ### How is the morphing handled?
 *
 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
 * what CSS classes differ between the starting element and the destination element. These different CSS classes
 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
 * the cloned element is placed inside of root element which is likely close to the body element).
 *
 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
 *
 *
 * ## Using $animate in your directive code
 *
 * So far we've explored how to feed in animations into an Angular application, but how do we trigger animations within our own directives in our application?
 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
 * imagine we have a greeting box that shows and hides itself when the data changes
 *
 * ```html
 * <greeting-box active="onOrOff">Hi there</greeting-box>
 * ```
 *
 * ```js
 * ngModule.directive('greetingBox', ['$animate', function($animate) {
 *   return function(scope, element, attrs) {
 *     attrs.$observe('active', function(value) {
 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
 *     });
 *   });
 * }]);
 * ```
 *
 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
 * in our HTML code then we can trigger a CSS or JS animation to happen.
 *
 * ```css
 * /&#42; normally we would create a CSS class to reference on the element &#42;/
 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
 * ```
 *
 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
 * possible be sure to visit the {@link ng.$animate $animate service API page}.
 *
 *
 * ## Callbacks and Promises
 *
 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
 * ended by chaining onto the returned promise that animation method returns.
 *
 * ```js
 * // somewhere within the depths of the directive
 * $animate.enter(element, parent).then(function() {
 *   //the animation has completed
 * });
 * ```
 *
 * (Note that earlier versions of Angular prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
 * anymore.)
 *
 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
 * routing controller to hook into that:
 *
 * ```js
 * ngModule.controller('HomePageController', ['$animate', function($animate) {
 *   $animate.on('enter', ngViewElement, function(element) {
 *     // the animation for this route has completed
 *   }]);
 * }])
 * ```
 *
 * (Note that you will need to trigger a digest within the callback to get angular to notice any scope-related changes.)
 */

var copy;
var extend;
var forEach;
var isArray;
var isDefined;
var isElement;
var isFunction;
var isObject;
var isString;
var isUndefined;
var jqLite;
var noop;

/**
 * @ngdoc service
 * @name $animate
 * @kind object
 *
 * @description
 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
 *
 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
 */
angular.module('ngAnimate', [], function initAngularHelpers() {
  // Access helpers from angular core.
  // Do it inside a `config` block to ensure `window.angular` is available.
  noop        = angular.noop;
  copy        = angular.copy;
  extend      = angular.extend;
  jqLite      = angular.element;
  forEach     = angular.forEach;
  isArray     = angular.isArray;
  isString    = angular.isString;
  isObject    = angular.isObject;
  isUndefined = angular.isUndefined;
  isDefined   = angular.isDefined;
  isFunction  = angular.isFunction;
  isElement   = angular.isElement;
})
  .directive('ngAnimateSwap', ngAnimateSwapDirective)

  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
  .factory('$$rAFScheduler', $$rAFSchedulerFactory)

  .provider('$$animateQueue', $$AnimateQueueProvider)
  .provider('$$animation', $$AnimationProvider)

  .provider('$animateCss', $AnimateCssProvider)
  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)

  .provider('$$animateJs', $$AnimateJsProvider)
  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);


})(window, window.angular);

},{}],2:[function(require,module,exports){
require('./angular-animate');
module.exports = 'ngAnimate';

},{"./angular-animate":1}],3:[function(require,module,exports){
/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngAria
 * @description
 *
 * The `ngAria` module provides support for common
 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
 * attributes that convey state or semantic information about the application for users
 * of assistive technologies, such as screen readers.
 *
 * <div doc-module-components="ngAria"></div>
 *
 * ## Usage
 *
 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
 * directives are supported:
 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`, `ngClick`,
 * `ngDblClick`, and `ngMessages`.
 *
 * Below is a more detailed breakdown of the attributes handled by ngAria:
 *
 * | Directive                                   | Supported Attributes                                                                   |
 * |---------------------------------------------|----------------------------------------------------------------------------------------|
 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                          |
 * | {@link ng.directive:ngRequired ngRequired}  | aria-required
 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked
 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                          |
 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                           |
 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                            |
 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                            |
 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                               |
 * | {@link module:ngMessages ngMessages}        | aria-live                                                                              |
 * | {@link ng.directive:ngClick ngClick}        | tabindex, keypress event, button role                                                  |
 *
 * Find out more information about each directive by reading the
 * {@link guide/accessibility ngAria Developer Guide}.
 *
 * ## Example
 * Using ngDisabled with ngAria:
 * ```html
 * <md-checkbox ng-disabled="disabled">
 * ```
 * Becomes:
 * ```html
 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
 * ```
 *
 * ## Disabling Attributes
 * It's possible to disable individual attributes added by ngAria with the
 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
 * {@link guide/accessibility Developer Guide}.
 */
var ngAriaModule = angular.module('ngAria', ['ng']).
                        provider('$aria', $AriaProvider);

/**
* Internal Utilities
*/
var nodeBlackList = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];

var isNodeOneOf = function(elem, nodeTypeArray) {
  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
    return true;
  }
};
/**
 * @ngdoc provider
 * @name $ariaProvider
 * @this
 *
 * @description
 *
 * Used for configuring the ARIA attributes injected and managed by ngAria.
 *
 * ```js
 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
 *   $ariaProvider.config({
 *     ariaValue: true,
 *     tabindex: false
 *   });
 * });
 *```
 *
 * ## Dependencies
 * Requires the {@link ngAria} module to be installed.
 *
 */
function $AriaProvider() {
  var config = {
    ariaHidden: true,
    ariaChecked: true,
    ariaReadonly: true,
    ariaDisabled: true,
    ariaRequired: true,
    ariaInvalid: true,
    ariaValue: true,
    tabindex: true,
    bindKeypress: true,
    bindRoleForClick: true
  };

  /**
   * @ngdoc method
   * @name $ariaProvider#config
   *
   * @param {object} config object to enable/disable specific ARIA attributes
   *
   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and aria-valuenow tags
   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
   *  - **bindKeypress** – `{boolean}` – Enables/disables keypress event binding on `div` and
   *    `li` elements with ng-click
   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements like `div`
   *    using ng-click, making them more accessible to users of assistive technologies
   *
   * @description
   * Enables/disables various ARIA attributes
   */
  this.config = function(newConfig) {
    config = angular.extend(config, newConfig);
  };

  function watchExpr(attrName, ariaAttr, nodeBlackList, negate) {
    return function(scope, elem, attr) {
      var ariaCamelName = attr.$normalize(ariaAttr);
      if (config[ariaCamelName] && !isNodeOneOf(elem, nodeBlackList) && !attr[ariaCamelName]) {
        scope.$watch(attr[attrName], function(boolVal) {
          // ensure boolean value
          boolVal = negate ? !boolVal : !!boolVal;
          elem.attr(ariaAttr, boolVal);
        });
      }
    };
  }
  /**
   * @ngdoc service
   * @name $aria
   *
   * @description
   * @priority 200
   *
   * The $aria service contains helper methods for applying common
   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
   *
   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
   * let's review a code snippet from ngAria itself:
   *
   *```js
   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
   * }])
   *```
   * Shown above, the ngAria module creates a directive with the same signature as the
   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
   * value in `ngDisabled`.
   *
   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
   *
   * The full list of directives that interface with ngAria:
   * * **ngModel**
   * * **ngChecked**
   * * **ngReadonly**
   * * **ngRequired**
   * * **ngDisabled**
   * * **ngValue**
   * * **ngShow**
   * * **ngHide**
   * * **ngClick**
   * * **ngDblclick**
   * * **ngMessages**
   *
   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
   * directive.
   *
   *
   * ## Dependencies
   * Requires the {@link ngAria} module to be installed.
   */
  this.$get = function() {
    return {
      config: function(key) {
        return config[key];
      },
      $$watchExpr: watchExpr
    };
  };
}


ngAriaModule.directive('ngShow', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
}])
.directive('ngHide', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
}])
.directive('ngValue', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngValue', 'aria-checked', nodeBlackList, false);
}])
.directive('ngChecked', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngChecked', 'aria-checked', nodeBlackList, false);
}])
.directive('ngReadonly', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nodeBlackList, false);
}])
.directive('ngRequired', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngRequired', 'aria-required', nodeBlackList, false);
}])
.directive('ngModel', ['$aria', function($aria) {

  function shouldAttachAttr(attr, normalizedAttr, elem, allowBlacklistEls) {
    return $aria.config(normalizedAttr) && !elem.attr(attr) && (allowBlacklistEls || !isNodeOneOf(elem, nodeBlackList));
  }

  function shouldAttachRole(role, elem) {
    // if element does not have role attribute
    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
    // AND element is not INPUT
    return !elem.attr('role') && (elem.attr('type') === role) && (elem[0].nodeName !== 'INPUT');
  }

  function getShape(attr, elem) {
    var type = attr.type,
        role = attr.role;

    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
    compile: function(elem, attr) {
      var shape = getShape(attr, elem);

      return {
        pre: function(scope, elem, attr, ngModel) {
          if (shape === 'checkbox') {
            //Use the input[checkbox] $isEmpty implementation for elements with checkbox roles
            ngModel.$isEmpty = function(value) {
              return value === false;
            };
          }
        },
        post: function(scope, elem, attr, ngModel) {
          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);

          function ngAriaWatchModelValue() {
            return ngModel.$modelValue;
          }

          function getRadioReaction(newVal) {
            // Strict comparison would cause a BC
            // eslint-disable-next-line eqeqeq
            var boolVal = (attr.value == ngModel.$viewValue);
            elem.attr('aria-checked', boolVal);
          }

          function getCheckboxReaction() {
            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
          }

          switch (shape) {
            case 'radio':
            case 'checkbox':
              if (shouldAttachRole(shape, elem)) {
                elem.attr('role', shape);
              }
              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
                    getRadioReaction : getCheckboxReaction);
              }
              if (needsTabIndex) {
                elem.attr('tabindex', 0);
              }
              break;
            case 'range':
              if (shouldAttachRole(shape, elem)) {
                elem.attr('role', 'slider');
              }
              if ($aria.config('ariaValue')) {
                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
                var needsAriaValuenow = !elem.attr('aria-valuenow');

                if (needsAriaValuemin) {
                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
                    elem.attr('aria-valuemin', newVal);
                  });
                }
                if (needsAriaValuemax) {
                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
                    elem.attr('aria-valuemax', newVal);
                  });
                }
                if (needsAriaValuenow) {
                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
                    elem.attr('aria-valuenow', newVal);
                  });
                }
              }
              if (needsTabIndex) {
                elem.attr('tabindex', 0);
              }
              break;
          }

          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
            // ngModel.$error.required is undefined on custom controls
            attr.$observe('required', function() {
              elem.attr('aria-required', !!attr['required']);
            });
          }

          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
            scope.$watch(function ngAriaInvalidWatch() {
              return ngModel.$invalid;
            }, function ngAriaInvalidReaction(newVal) {
              elem.attr('aria-invalid', !!newVal);
            });
          }
        }
      };
    }
  };
}])
.directive('ngDisabled', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nodeBlackList, false);
}])
.directive('ngMessages', function() {
  return {
    restrict: 'A',
    require: '?ngMessages',
    link: function(scope, elem, attr, ngMessages) {
      if (!elem.attr('aria-live')) {
        elem.attr('aria-live', 'assertive');
      }
    }
  };
})
.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
  return {
    restrict: 'A',
    compile: function(elem, attr) {
      var fn = $parse(attr.ngClick, /* interceptorFn */ null, /* expensiveChecks */ true);
      return function(scope, elem, attr) {

        if (!isNodeOneOf(elem, nodeBlackList)) {

          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
            elem.attr('role', 'button');
          }

          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
            elem.attr('tabindex', 0);
          }

          if ($aria.config('bindKeypress') && !attr.ngKeypress) {
            elem.on('keypress', function(event) {
              var keyCode = event.which || event.keyCode;
              if (keyCode === 32 || keyCode === 13) {
                scope.$apply(callback);
              }

              function callback() {
                fn(scope, { $event: event });
              }
            });
          }
        }
      };
    }
  };
}])
.directive('ngDblclick', ['$aria', function($aria) {
  return function(scope, elem, attr) {
    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nodeBlackList)) {
      elem.attr('tabindex', 0);
    }
  };
}]);


})(window, window.angular);

},{}],4:[function(require,module,exports){
require('./angular-aria');
module.exports = 'ngAria';

},{"./angular-aria":3}],5:[function(require,module,exports){
(function() {


// Create all modules and define dependencies to make sure they exist
// and are loaded in the correct order to satisfy dependency injection
// before all nested files are concatenated by Grunt

// Modules
angular.module('angular-jwt',
    [
        'angular-jwt.options',
        'angular-jwt.interceptor',
        'angular-jwt.jwt',
        'angular-jwt.authManager'
    ]);

angular.module('angular-jwt.authManager', [])
  .provider('authManager', function () {

    this.$get = ["$rootScope", "$injector", "$location", "jwtHelper", "jwtInterceptor", "jwtOptions", function ($rootScope, $injector, $location, jwtHelper, jwtInterceptor, jwtOptions) {

      var config = jwtOptions.getConfig();

      function invokeToken(tokenGetter) {
        var token = null;
        if (Array.isArray(tokenGetter)) {
          token = $injector.invoke(tokenGetter, this, {options: null});
        } else {
          token = tokenGetter();
        }
        return token;
      }

      function invokeRedirector(redirector) {
        if (Array.isArray(redirector) || angular.isFunction(redirector)) {
          return $injector.invoke(redirector, config, {});
        } else {
          throw new Error('unauthenticatedRedirector must be a function');
        }
      }

      function isAuthenticated() {
        var token = invokeToken(config.tokenGetter);
        if (token) {
          return !jwtHelper.isTokenExpired(token);
        }
      }

      $rootScope.isAuthenticated = false;

      function authenticate() {
        $rootScope.isAuthenticated = true;
      }

      function unauthenticate() {
        $rootScope.isAuthenticated = false;
      }

      function checkAuthOnRefresh() {
        $rootScope.$on('$locationChangeStart', function () {
          var token = invokeToken(config.tokenGetter);
          if (token) {
            if (!jwtHelper.isTokenExpired(token)) {
              authenticate();
            } else {
              $rootScope.$broadcast('tokenHasExpired', token);
            }
          }
        });
      }

      function redirectWhenUnauthenticated() {
        $rootScope.$on('unauthenticated', function () {
          invokeRedirector(config.unauthenticatedRedirector);
          unauthenticate();
        });
      }

      function verifyRoute(event, next) {
        if (!next) {
          return false;
        }

        var routeData = (next.$$route) ? next.$$route : next.data;

        if (routeData && routeData.requiresLogin === true) {
          var token = invokeToken(config.tokenGetter);
          if (!token || jwtHelper.isTokenExpired(token)) {
            event.preventDefault();
            invokeRedirector(config.unauthenticatedRedirector);
          }
        }
      }

      var eventName = ($injector.has('$state')) ? '$stateChangeStart' : '$routeChangeStart';
      $rootScope.$on(eventName, verifyRoute);

      return {
        authenticate: authenticate,
        unauthenticate: unauthenticate,
        getToken: function(){ return invokeToken(config.tokenGetter); },
        redirect: function() { return invokeRedirector(config.unauthenticatedRedirector); },
        checkAuthOnRefresh: checkAuthOnRefresh,
        redirectWhenUnauthenticated: redirectWhenUnauthenticated,
        isAuthenticated: isAuthenticated
      }
    }]
  });

angular.module('angular-jwt.interceptor', [])
  .provider('jwtInterceptor', function() {

    this.urlParam;
    this.authHeader;
    this.authPrefix;
    this.whiteListedDomains;
    this.tokenGetter;

    var config = this;

    this.$get = ["$q", "$injector", "$rootScope", "urlUtils", "jwtOptions", function($q, $injector, $rootScope, urlUtils, jwtOptions) {

      var options = angular.extend({}, jwtOptions.getConfig(), config);

      function isSafe (url) {
        if (!urlUtils.isSameOrigin(url) && !options.whiteListedDomains.length) {
          throw new Error('As of v0.1.0, requests to domains other than the application\'s origin must be white listed. Use jwtOptionsProvider.config({ whiteListedDomains: [<domain>] }); to whitelist.')
        }
        var hostname = urlUtils.urlResolve(url).hostname.toLowerCase();
        for (var i = 0; i < options.whiteListedDomains.length; i++) {
          var domain = options.whiteListedDomains[i];
          var regexp = domain instanceof RegExp ? domain : new RegExp(domain, 'i');
          if (hostname.match(regexp)) {
            return true;
          }
        }

        if (urlUtils.isSameOrigin(url)) {
          return true;
        }

        return false;
      }

      return {
        request: function (request) {
          if (request.skipAuthorization || !isSafe(request.url)) {
            return request;
          }

          if (options.urlParam) {
            request.params = request.params || {};
            // Already has the token in the url itself
            if (request.params[options.urlParam]) {
              return request;
            }
          } else {
            request.headers = request.headers || {};
            // Already has an Authorization header
            if (request.headers[options.authHeader]) {
              return request;
            }
          }

          var tokenPromise = $q.when($injector.invoke(options.tokenGetter, this, {
            options: request
          }));

          return tokenPromise.then(function(token) {
            if (token) {
              if (options.urlParam) {
                request.params[options.urlParam] = token;
              } else {
                request.headers[options.authHeader] = options.authPrefix + token;
              }
            }
            return request;
          });
        },
        responseError: function (response) {
          // handle the case where the user is not authenticated
          if (response.status === 401) {
            $rootScope.$broadcast('unauthenticated', response);
          }
          return $q.reject(response);
        }
      };
    }]
  });

 angular.module('angular-jwt.jwt', [])
  .service('jwtHelper', ["$window", function($window) {

    this.urlBase64Decode = function(str) {
      var output = str.replace(/-/g, '+').replace(/_/g, '/');
      switch (output.length % 4) {
        case 0: { break; }
        case 2: { output += '=='; break; }
        case 3: { output += '='; break; }
        default: {
          throw 'Illegal base64url string!';
        }
      }
      return $window.decodeURIComponent(escape($window.atob(output))); //polyfill https://github.com/davidchambers/Base64.js
    };


    this.decodeToken = function(token) {
      var parts = token.split('.');

      if (parts.length !== 3) {
        throw new Error('JWT must have 3 parts');
      }

      var decoded = this.urlBase64Decode(parts[1]);
      if (!decoded) {
        throw new Error('Cannot decode the token');
      }

      return angular.fromJson(decoded);
    };

    this.getTokenExpirationDate = function(token) {
      var decoded = this.decodeToken(token);

      if(typeof decoded.exp === "undefined") {
        return null;
      }

      var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
      d.setUTCSeconds(decoded.exp);

      return d;
    };

    this.isTokenExpired = function(token, offsetSeconds) {
      var d = this.getTokenExpirationDate(token);
      offsetSeconds = offsetSeconds || 0;
      if (d === null) {
        return false;
      }

      // Token expired?
      return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
    };
  }]);

angular.module('angular-jwt.options', [])
  .provider('jwtOptions', function() {
    var globalConfig = {};
    this.config = function(value) {
      globalConfig = value;
    };
    this.$get = function() {

      var options = {
        urlParam: null,
        authHeader: 'Authorization',
        authPrefix: 'Bearer ',
        whiteListedDomains: [],
        tokenGetter: function() {
          return null;
        },
        loginPath: '/',
        unauthenticatedRedirectPath: '/',
        unauthenticatedRedirector: ['$location', function($location) {
          $location.path(this.unauthenticatedRedirectPath);
        }]
      };

      function JwtOptions() {
        var config = this.config = angular.extend({}, options, globalConfig);
      }

      JwtOptions.prototype.getConfig = function() {
        return this.config;
      };

      return new JwtOptions();
    }
  });

 /**
  * The content from this file was directly lifted from Angular. It is
  * unfortunately not a public API, so the best we can do is copy it.
  *
  * Angular References:
  *   https://github.com/angular/angular.js/issues/3299
  *   https://github.com/angular/angular.js/blob/d077966ff1ac18262f4615ff1a533db24d4432a7/src/ng/urlUtils.js
  */

 angular.module('angular-jwt.interceptor')
  .service('urlUtils', function () {

    // NOTE:  The usage of window and document instead of $window and $document here is
    // deliberate.  This service depends on the specific behavior of anchor nodes created by the
    // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
    // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
    // doesn't know about mocked locations and resolves URLs to the real document - which is
    // exactly the behavior needed here.  There is little value is mocking these out for this
    // service.
    var urlParsingNode = document.createElement("a");
    var originUrl = urlResolve(window.location.href);

    /**
     *
     * Implementation Notes for non-IE browsers
     * ----------------------------------------
     * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
     * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
     * URL will be resolved into an absolute URL in the context of the application document.
     * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
     * properties are all populated to reflect the normalized URL.  This approach has wide
     * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
     * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
     *
     * Implementation Notes for IE
     * ---------------------------
     * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
     * browsers.  However, the parsed components will not be set if the URL assigned did not specify
     * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
     * work around that by performing the parsing in a 2nd step by taking a previously normalized
     * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
     * properties such as protocol, hostname, port, etc.
     *
     * References:
     *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
     *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
     *   http://url.spec.whatwg.org/#urlutils
     *   https://github.com/angular/angular.js/pull/2902
     *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
     *
     * @kind function
     * @param {string} url The URL to be parsed.
     * @description Normalizes and parses a URL.
     * @returns {object} Returns the normalized URL as a dictionary.
     *
     *   | member name   | Description    |
     *   |---------------|----------------|
     *   | href          | A normalized version of the provided URL if it was not an absolute URL |
     *   | protocol      | The protocol including the trailing colon                              |
     *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
     *   | search        | The search params, minus the question mark                             |
     *   | hash          | The hash string, minus the hash symbol
     *   | hostname      | The hostname
     *   | port          | The port, without ":"
     *   | pathname      | The pathname, beginning with "/"
     *
     */
    function urlResolve(url) {
      var href = url;

      // Normalize before parse.  Refer Implementation Notes on why this is
      // done in two steps on IE.
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/')
          ? urlParsingNode.pathname
          : '/' + urlParsingNode.pathname
      };
    }

    /**
     * Parse a request URL and determine whether this is a same-origin request as the application document.
     *
     * @param {string|object} requestUrl The url of the request as a string that will be resolved
     * or a parsed URL object.
     * @returns {boolean} Whether the request is for the same origin as the application document.
     */
    function urlIsSameOrigin(requestUrl) {
      var parsed = (angular.isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
      return (parsed.protocol === originUrl.protocol &&
              parsed.host === originUrl.host);
    }

    return {
      urlResolve: urlResolve,
      isSameOrigin: urlIsSameOrigin
    };

  });

}());
},{}],6:[function(require,module,exports){
require('./dist/angular-jwt.js');
module.exports = 'angular-jwt';


},{"./dist/angular-jwt.js":5}],7:[function(require,module,exports){
/*
 * angular-marked
 * (c) 2014 - 2016 J. Harshbarger
 * Licensed MIT
 */

/* global angular, marked */

'use strict';

var unindent = require('./strip-indent');

  /**
   * @ngdoc overview
   * @name index
   *
   * @description
   * AngularJS Markdown using [marked](https://github.com/chjj/marked).
   *
   * ## Why?
   *
   * I wanted to use [marked](https://github.com/chjj/marked) instead of [showdown](https://github.com/coreyti/showdown) as used in [angular-markdown-directive](https://github.com/btford/angular-markdown-directive) as well as expose the option to globally set defaults.
   *
   * ## How?
   *
   * - {@link hc.marked.directive:marked As a directive}
   * - {@link hc.marked.service:marked As a service}
   * - {@link hc.marked.service:markedProvider Set default options}
   *
   * @example

      Convert markdown to html at run time.  For example:

      <example module="app">
        <file name="example.html">
          <form ng-controller="MainController">
            Markdown:<br />
            <textarea ng-model="my_markdown" cols="60" rows="5" class="span8"></textarea><br />
            Output:<br />
            <div marked="my_markdown" />
          </form>
        </file>
        <file  name="example.js">
          function MainController($scope) {
            $scope.my_markdown = "*This* **is** [markdown](https://daringfireball.net/projects/markdown/)";
          }
          angular.module('app', ['hc.marked']).controller('MainController', MainController);
        </file>
      </example>

    *
    */

    /**
     * @ngdoc overview
     * @name hc.marked
     * @description # angular-marked (core module)
       # Installation
      First include angular-marked.js in your HTML:

      ```js
        <script src="angular-marked.js">
      ```

      Then load the module in your application by adding it as a dependency:

      ```js
      angular.module('yourApp', ['hc.marked']);
      ```

      With that you're ready to get started!
     */

    /**
    * @ngdoc service
    * @name hc.marked.service:marked
    * @requires $window
    * @description
    * A reference to the [marked](https://github.com/chjj/marked) parser.
    *
    * @example
    <example module="app">
      <file name="example.html">
        <div ng-controller="MainController">
          html: {{html}}
        </div>
      </file>
      <file  name="example.js">
        function MainController($scope, marked) {
          $scope.html = marked('#TEST');
        }
        angular.module('app', ['hc.marked']).controller('MainController', MainController);
      </file>
    </example>
   **/

   /**
   * @ngdoc service
   * @name hc.marked.service:markedProvider
   * @description
   * Use `markedProvider` to change the default behavior of the {@link hc.marked.service:marked marked} service.
   *
   * @example

    ## Example using [google-code-prettify syntax highlighter](https://code.google.com/p/google-code-prettify/) (must include google-code-prettify.js script).  Also works with [highlight.js Javascript syntax highlighter](http://highlightjs.org/).

    <example module="myAppA">
      <file name="exampleA.js">
      angular.module('myAppA', ['hc.marked'])
        .config(['markedProvider', function(markedProvider) {
          markedProvider.setOptions({
            gfm: true,
            tables: true,
            highlight: function (code) {
              return prettyPrintOne(code);
            }
          });
        }]);
      </file>
      <file name="exampleA.html">
        <marked>
        ```js
        angular.module('myAppA', ['hc.marked'])
          .config(['markedProvider', function(markedProvider) {
            markedProvider.setOptions({
              gfm: true,
              tables: true,
              highlight: function (code) {
                return prettyPrintOne(code);
              }
            });
          }]);
        ```
        </marked>
      </file>
    </example>

    ## Example overriding the way custom markdown links are displayed

    <example module="myAppB">
      <file name="exampleB.js">
      angular.module('myAppB', ['hc.marked'])
        .config(['markedProvider', function(markedProvider) {
          markedProvider.setRenderer({
            link: function(href, title, text) {
              return "<a href='" + href + "'" + (title ? " title='" + title + "'" : '') + " target='_blank'>" + text + "</a>";
            }
          });
        }]);
      </file>
      <file name="exampleB.html">
        <marked>
          This is [an example](http://example.com/ "Title") inline link.
          [This link](http://example.net/) has no title attribute.
        </marked>
      </file>
    </example>
  **/

function markedProvider() {
  var self = this;

  /**
   * @ngdoc method
   * @name markedProvider#setRenderer
   * @methodOf hc.marked.service:markedProvider
   *
   * @param {object} opts Default renderer options for [marked](https://github.com/chjj/marked#overriding-renderer-methods).
   */

  self.setRenderer = function (opts) {
    this.renderer = opts;
  };

  /**
   * @ngdoc method
   * @name markedProvider#setOptions
   * @methodOf hc.marked.service:markedProvider
   *
   * @param {object} opts Default options for [marked](https://github.com/chjj/marked#options-1).
   */

  self.setOptions = function (opts) {  // Store options for later
    this.defaults = opts;
  };

  self.$get = ['$log', '$window', function ($log, $window) {
    var m;

    try {
      m = require('marked');
    } catch (err) {
      m = $window.marked || marked;
    }

    if (angular.isUndefined(m)) {
      $log.error('angular-marked Error: marked not loaded.  See installation instructions.');
      return;
    }

    var r = new m.Renderer();

    // override rendered markdown html
    // with custom definitions if defined
    if (self.renderer) {
      var o = Object.keys(self.renderer);
      var l = o.length;

      while (l--) {
        r[o[l]] = self.renderer[o[l]];
      }
    }

    // Customize code and codespan rendering to wrap default or overriden output in a ng-non-bindable span
    function wrapNonBindable(string) {
      return '<span ng-non-bindable>' + string + '</span>';
    }

    var renderCode = r.code.bind(r);
    r.code = function (code, lang, escaped) {
      return wrapNonBindable(renderCode(code, lang, escaped));
    };
    var renderCodespan = r.codespan.bind(r);
    r.codespan = function (code) {
      return wrapNonBindable(renderCodespan(code));
    };

    // add the new renderer to the options if need be
    self.defaults = self.defaults || {};
    self.defaults.renderer = r;

    m.setOptions(self.defaults);

    return m;
  }];
}

  // xTODO: filter and tests */
  // app.filter('marked', ['marked', function(marked) {
  //   return marked;
  // }]);

  /**
   * @ngdoc directive
   * @name hc.marked.directive:marked
   * @restrict AE
   * @element any
   *
   * @description
   * Compiles source test into HTML.
   *
   * @param {expression=} marked The source text to be compiled.  If blank uses content as the source.
   * @param {expression=} opts Hash of options that override defaults.
   * @param {boolean=} compile Set to true to to support AngularJS directives inside markdown.
   * @param {string=} src Expression evaluating to URL. If the source is a string constant,
   *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
   *
   * @example

     ## A simple block of text

      <example module="hc.marked">
        <file name="exampleA.html">
         * <marked>
         *   ### Markdown directive
         *
         *   *It works!*
         *
         *   *This* **is** [markdown](https://daringfireball.net/projects/markdown/) in the view.
         * </marked>
        </file>
      </example>

     ## Bind to a scope variable

      <example module="app">
        <file name="exampleB.html">
          <form ng-controller="MainController">
            Markdown:<br />
            <textarea ng-model="my_markdown" class="span8" cols="60" rows="5"></textarea><br />
            Output:<br />
            <blockquote marked="my_markdown"></blockquote>
          </form>
        </file>
        <file  name="exampleB.js">
          * function MainController($scope) {
          *     $scope.my_markdown = '*This* **is** [markdown](https://daringfireball.net/projects/markdown/)';
          *     $scope.my_markdown += ' in a scope variable';
          * }
          * angular.module('app', ['hc.marked']).controller('MainController', MainController);
        </file>
      </example>

      ## Include a markdown file:

       <example module="hc.marked">
         <file name="exampleC.html">
           <div marked src="'include.html'" />
         </file>
         * <file name="include.html">
         * *This* **is** [markdown](https://daringfireball.net/projects/markdown/) in a include file.
         * </file>
       </example>
   */
markedDirective.$inject = ['marked', '$templateRequest', '$compile'];
function markedDirective(marked, $templateRequest, $compile) {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      opts: '=',
      marked: '=',
      compile: '@',
      src: '='
    },
    link: function (scope, element, attrs) {
      if (attrs.marked) {
        set(scope.marked);
        scope.$watch('marked', set);
      } else if (attrs.src) {
        scope.$watch('src', function (src) {
          $templateRequest(src, true).then(function (response) {
            set(response);
          }, function () {
            set('');
            scope.$emit('$markedIncludeError', attrs.src);
          });
        });
      } else {
        set(element.text());
      }

      function set(text) {
        text = unindent(String(text || ''));
        element.html(marked(text, scope.opts || null));
        if (scope.$eval(attrs.compile)) {
          $compile(element.contents())(scope.$parent);
        }
      }
    }
  };
}

module.exports =
  angular.module('hc.marked', [])
    .directive('marked', markedDirective)
    .provider('marked', markedProvider)
    .name;

},{"./strip-indent":8,"marked":77}],8:[function(require,module,exports){
module.exports = function unindent(text) {
  if (!text) {
    return text;
  }

  var lines = text
    .replace(/\t/g, '  ')
    .split(/\r?\n/);

  var min = null;
  var len = lines.length;
  var i;

  for (i = 0; i < len; i++) {
    var line = lines[i];
    var l = line.match(/^(\s*)/)[0].length;
    if (l === line.length) {
      continue;
    }
    min = (l < min || min === null) ? l : min;
  }

  if (min !== null && min > 0) {
    for (i = 0; i < len; i++) {
      lines[i] = lines[i].substr(min);
    }
  }
  return lines.join('\n');
};

},{}],9:[function(require,module,exports){
/*!
 * AngularJS Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.5
 */
(function( window, angular, undefined ){
"use strict";

(function(){
"use strict";

angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.gestures","material.core.interaction","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.core.animate","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.chips","material.components.checkbox","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.icon","material.components.gridList","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.panel","material.components.progressCircular","material.components.progressLinear","material.components.radioButton","material.components.select","material.components.showHide","material.components.sidenav","material.components.slider","material.components.sticky","material.components.subheader","material.components.swipe","material.components.switch","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);
})();
(function(){
"use strict";

/**
 * Initialization function that validates environment
 * requirements.
 */
DetectNgTouch.$inject = ["$log", "$injector"];
MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
rAFDecorator.$inject = ["$delegate"];
qDecorator.$inject = ["$delegate"];
angular
  .module('material.core', [
    'ngAnimate',
    'material.core.animate',
    'material.core.layout',
    'material.core.interaction',
    'material.core.gestures',
    'material.core.theming'
  ])
  .config(MdCoreConfigure)
  .run(DetectNgTouch);


/**
 * Detect if the ng-Touch module is also being used.
 * Warn if detected.
 * @ngInject
 */
function DetectNgTouch($log, $injector) {
  if ( $injector.has('$swipe') ) {
    var msg = "" +
      "You are using the ngTouch module. \n" +
      "AngularJS Material already has mobile click, tap, and swipe support... \n" +
      "ngTouch is not supported with AngularJS Material!";
    $log.warn(msg);
  }
}

/**
 * @ngInject
 */
function MdCoreConfigure($provide, $mdThemingProvider) {

  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
  $provide.decorator('$q', ['$delegate', qDecorator]);

  $mdThemingProvider.theme('default')
    .primaryPalette('indigo')
    .accentPalette('pink')
    .warnPalette('deep-orange')
    .backgroundPalette('grey');
}

/**
 * @ngInject
 */
function rAFDecorator($delegate) {
  /**
   * Use this to throttle events that come in often.
   * The throttled function will always use the *last* invocation before the
   * coming frame.
   *
   * For example, window resize events that fire many times a second:
   * If we set to use an raf-throttled callback on window resize, then
   * our callback will only be fired once per frame, with the last resize
   * event that happened before that frame.
   *
   * @param {function} callback function to debounce
   */
  $delegate.throttle = function(cb) {
    var queuedArgs, alreadyQueued, queueCb, context;
    return function debounced() {
      queuedArgs = arguments;
      context = this;
      queueCb = cb;
      if (!alreadyQueued) {
        alreadyQueued = true;
        $delegate(function() {
          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
          alreadyQueued = false;
        });
      }
    };
  };
  return $delegate;
}

/**
 * @ngInject
 */
function qDecorator($delegate) {
  /**
   * Adds a shim for $q.resolve for AngularJS version that don't have it,
   * so we don't have to think about it.
   *
   * via https://github.com/angular/angular.js/pull/11987
   */

  // TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
  if (!$delegate.resolve) {
    $delegate.resolve = $delegate.when;
  }
  return $delegate;
}

})();
(function(){
"use strict";


MdAutofocusDirective.$inject = ["$parse"];angular.module('material.core')
  .directive('mdAutofocus', MdAutofocusDirective)

  // Support the deprecated md-auto-focus and md-sidenav-focus as well
  .directive('mdAutoFocus', MdAutofocusDirective)
  .directive('mdSidenavFocus', MdAutofocusDirective);

/**
 * @ngdoc directive
 * @name mdAutofocus
 * @module material.core.util
 *
 * @description
 *
 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
 *
 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
 * attribute directive and optional expression. An expression may be specified as the directive
 * value to enable conditional activation of the autofocus.
 *
 * @usage
 *
 * ### Dialog
 * <hljs lang="html">
 * <md-dialog>
 *   <form>
 *     <md-input-container>
 *       <label for="testInput">Label</label>
 *       <input id="testInput" type="text" md-autofocus>
 *     </md-input-container>
 *   </form>
 * </md-dialog>
 * </hljs>
 *
 * ### Bottomsheet
 * <hljs lang="html">
 * <md-bottom-sheet class="md-list md-has-header">
 *  <md-subheader>Comment Actions</md-subheader>
 *  <md-list>
 *    <md-list-item ng-repeat="item in items">
 *
 *      <md-button md-autofocus="$index == 2">
 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
 *      </md-button>
 *
 *    </md-list-item>
 *  </md-list>
 * </md-bottom-sheet>
 * </hljs>
 *
 * ### Autocomplete
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-autofocus
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display">
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-autocomplete>
 * </hljs>
 *
 * ### Sidenav
 * <hljs lang="html">
 * <div layout="row" ng-controller="MyController">
 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
 *     Left Nav!
 *   </md-sidenav>
 *
 *   <md-content>
 *     Center Content
 *     <md-button ng-click="openLeftMenu()">
 *       Open Left Menu
 *     </md-button>
 *   </md-content>
 *
 *   <md-sidenav md-component-id="right"
 *     md-is-locked-open="$mdMedia('min-width: 333px')"
 *     class="md-sidenav-right">
 *     <form>
 *       <md-input-container>
 *         <label for="testInput">Test input</label>
 *         <input id="testInput" type="text"
 *                ng-model="data" md-autofocus>
 *       </md-input-container>
 *     </form>
 *   </md-sidenav>
 * </div>
 * </hljs>
 **/
function MdAutofocusDirective($parse) {
  return {
    restrict: 'A',
    link: {
      pre: preLink
    }
  };

  function preLink(scope, element, attr) {
    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;

    // Initially update the expression by manually parsing the expression as per $watch source.
    updateExpression($parse(attrExp)(scope));

    // Only watch the expression if it is not empty.
    if (attrExp) {
      scope.$watch(attrExp, updateExpression);
    }

    /**
     * Updates the autofocus class which is used to determine whether the attribute
     * expression evaluates to true or false.
     * @param {string|boolean} value Attribute Value
     */
    function updateExpression(value) {

      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
      // value to true. Otherwise the class will be just toggled instead of being forced.
      if (angular.isUndefined(value)) {
        value = true;
      }

      element.toggleClass('md-autofocus', !!value);
    }
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.colorUtil
 * @description
 * Color Util
 */
angular
  .module('material.core')
  .factory('$mdColorUtil', ColorUtilFactory);

function ColorUtilFactory() {
  /**
   * Converts hex value to RGBA string
   * @param color {string}
   * @returns {string}
   */
  function hexToRgba (color) {
    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
      dig   = hex.length / 3,
      red   = hex.substr(0, dig),
      green = hex.substr(dig, dig),
      blue  = hex.substr(dig * 2);
    if (dig === 1) {
      red += red;
      green += green;
      blue += blue;
    }
    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
  }

  /**
   * Converts rgba value to hex string
   * @param color {string}
   * @returns {string}
   */
  function rgbaToHex(color) {
    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);

    var hex = (color && color.length === 4) ? "#" +
    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';

    return hex.toUpperCase();
  }

  /**
   * Converts an RGB color to RGBA
   * @param color {string}
   * @returns {string}
   */
  function rgbToRgba (color) {
    return color.replace(')', ', 0.1)').replace('(', 'a(');
  }

  /**
   * Converts an RGBA color to RGB
   * @param color {string}
   * @returns {string}
   */
  function rgbaToRgb (color) {
    return color
      ? color.replace('rgba', 'rgb').replace(/,[^\),]+\)/, ')')
      : 'rgb(0,0,0)';
  }

  return {
    rgbaToHex: rgbaToHex,
    hexToRgba: hexToRgba,
    rgbToRgba: rgbToRgba,
    rgbaToRgb: rgbaToRgb
  };
}

})();
(function(){
"use strict";

angular.module('material.core')
.factory('$mdConstant', MdConstantFactory);

/**
 * Factory function that creates the grab-bag $mdConstant service.
 * @ngInject
 */
function MdConstantFactory() {

  var prefixTestEl = document.createElement('div');
  var vendorPrefix = getVendorPrefix(prefixTestEl);
  var isWebkit = /webkit/i.test(vendorPrefix);
  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;

  function vendorProperty(name) {
    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
    var prefixedName = vendorPrefix + '-' + name;
    var ucPrefix = camelCase(prefixedName);
    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);

    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
  }

  function hasStyleProperty(testElement, property) {
    return angular.isDefined(testElement.style[property]);
  }

  function camelCase(input) {
    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
  }

  function getVendorPrefix(testElement) {
    var prop, match;
    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;

    for (prop in testElement.style) {
      if (match = vendorRegex.exec(prop)) {
        return match[0];
      }
    }
  }

  var self = {
    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
    isNumPadKey : function(e) { return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
    isMetaKey: function(e) { return (e.keyCode >= 91 && e.keyCode <= 93); },
    isFnLockKey: function(e) { return (e.keyCode >= 112 && e.keyCode <= 145); },
    isNavigationKey : function(e) {
      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
    },
    hasModifierKey: function(e) {
      return e.ctrlKey || e.metaKey || e.altKey;
    },

    /**
     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
     * compute this value, but Firefox always reports an element to have a size of zero if it
     * goes over the max, meaning that we'd have to binary search for the value.
     */
    ELEMENT_MAX_PIXELS: 1533917,

    /**
     * Priority for a directive that should run before the directives from ngAria.
     */
    BEFORE_NG_ARIA: 210,

    /**
     * Common Keyboard actions and their associated keycode.
     */
    KEY_CODE: {
      COMMA: 188,
      SEMICOLON : 186,
      ENTER: 13,
      ESCAPE: 27,
      SPACE: 32,
      PAGE_UP: 33,
      PAGE_DOWN: 34,
      END: 35,
      HOME: 36,
      LEFT_ARROW : 37,
      UP_ARROW : 38,
      RIGHT_ARROW : 39,
      DOWN_ARROW : 40,
      TAB : 9,
      BACKSPACE: 8,
      DELETE: 46
    },

    /**
     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
     * as well.
     */
    CSS: {
      /* Constants */
      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),

      TRANSFORM: vendorProperty('transform'),
      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
      TRANSITION: vendorProperty('transition'),
      TRANSITION_DURATION: vendorProperty('transitionDuration'),
      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
      ANIMATION_DURATION: vendorProperty('animationDuration'),
      ANIMATION_NAME: vendorProperty('animationName'),
      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
      ANIMATION_DIRECTION: vendorProperty('animationDirection')
    },

    /**
     * As defined in core/style/variables.scss
     *
     * $layout-breakpoint-xs:     600px !default;
     * $layout-breakpoint-sm:     960px !default;
     * $layout-breakpoint-md:     1280px !default;
     * $layout-breakpoint-lg:     1920px !default;
     *
     */
    MEDIA: {
      'xs'        : '(max-width: 599px)'                         ,
      'gt-xs'     : '(min-width: 600px)'                         ,
      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
      'gt-sm'     : '(min-width: 960px)'                         ,
      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
      'gt-md'     : '(min-width: 1280px)'                        ,
      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
      'gt-lg'     : '(min-width: 1920px)'                        ,
      'xl'        : '(min-width: 1920px)'                        ,
      'landscape' : '(orientation: landscape)'                   ,
      'portrait'  : '(orientation: portrait)'                    ,
      'print' : 'print'
    },

    MEDIA_PRIORITY: [
      'xl',
      'gt-lg',
      'lg',
      'gt-md',
      'md',
      'gt-sm',
      'sm',
      'gt-xs',
      'xs',
      'landscape',
      'portrait',
      'print'
    ]
  };

  return self;
}

})();
(function(){
"use strict";

  angular
    .module('material.core')
    .config( ["$provide", function($provide){
       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
           /**
            * Inject the iterator facade to easily support iteration and accessors
            * @see iterator below
            */
           $delegate.iterator = MdIterator;

           return $delegate;
         }
       ]);
     }]);

  /**
   * iterator is a list facade to easily support iteration and accessors
   *
   * @param items Array list which this iterator will enumerate
   * @param reloop Boolean enables iterator to consider the list as an endless reloop
   */
  function MdIterator(items, reloop) {
    var trueFn = function() { return true; };

    if (items && !angular.isArray(items)) {
      items = Array.prototype.slice.call(items);
    }

    reloop = !!reloop;
    var _items = items || [ ];

    // Published API
    return {
      items: getItems,
      count: count,

      inRange: inRange,
      contains: contains,
      indexOf: indexOf,
      itemAt: itemAt,

      findBy: findBy,

      add: add,
      remove: remove,

      first: first,
      last: last,
      next: angular.bind(null, findSubsequentItem, false),
      previous: angular.bind(null, findSubsequentItem, true),

      hasPrevious: hasPrevious,
      hasNext: hasNext

    };

    /**
     * Publish copy of the enumerable set
     * @returns {Array|*}
     */
    function getItems() {
      return [].concat(_items);
    }

    /**
     * Determine length of the list
     * @returns {Array.length|*|number}
     */
    function count() {
      return _items.length;
    }

    /**
     * Is the index specified valid
     * @param index
     * @returns {Array.length|*|number|boolean}
     */
    function inRange(index) {
      return _items.length && ( index > -1 ) && (index < _items.length );
    }

    /**
     * Can the iterator proceed to the next item in the list; relative to
     * the specified item.
     *
     * @param item
     * @returns {Array.length|*|number|boolean}
     */
    function hasNext(item) {
      return item ? inRange(indexOf(item) + 1) : false;
    }

    /**
     * Can the iterator proceed to the previous item in the list; relative to
     * the specified item.
     *
     * @param item
     * @returns {Array.length|*|number|boolean}
     */
    function hasPrevious(item) {
      return item ? inRange(indexOf(item) - 1) : false;
    }

    /**
     * Get item at specified index/position
     * @param index
     * @returns {*}
     */
    function itemAt(index) {
      return inRange(index) ? _items[index] : null;
    }

    /**
     * Find all elements matching the key/value pair
     * otherwise return null
     *
     * @param val
     * @param key
     *
     * @return array
     */
    function findBy(key, val) {
      return _items.filter(function(item) {
        return item[key] === val;
      });
    }

    /**
     * Add item to list
     * @param item
     * @param index
     * @returns {*}
     */
    function add(item, index) {
      if ( !item ) return -1;

      if (!angular.isNumber(index)) {
        index = _items.length;
      }

      _items.splice(index, 0, item);

      return indexOf(item);
    }

    /**
     * Remove item from list...
     * @param item
     */
    function remove(item) {
      if ( contains(item) ){
        _items.splice(indexOf(item), 1);
      }
    }

    /**
     * Get the zero-based index of the target item
     * @param item
     * @returns {*}
     */
    function indexOf(item) {
      return _items.indexOf(item);
    }

    /**
     * Boolean existence check
     * @param item
     * @returns {boolean}
     */
    function contains(item) {
      return item && (indexOf(item) > -1);
    }

    /**
     * Return first item in the list
     * @returns {*}
     */
    function first() {
      return _items.length ? _items[0] : null;
    }

    /**
     * Return last item in the list...
     * @returns {*}
     */
    function last() {
      return _items.length ? _items[_items.length - 1] : null;
    }

    /**
     * Find the next item. If reloop is true and at the end of the list, it will go back to the
     * first item. If given, the `validate` callback will be used to determine whether the next item
     * is valid. If not valid, it will try to find the next item again.
     *
     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
     * @param {*} item The item whose subsequent item we are looking for
     * @param {Function=} validate The `validate` function
     * @param {integer=} limit The recursion limit
     *
     * @returns {*} The subsequent item or null
     */
    function findSubsequentItem(backwards, item, validate, limit) {
      validate = validate || trueFn;

      var curIndex = indexOf(item);
      while (true) {
        if (!inRange(curIndex)) return null;

        var nextIndex = curIndex + (backwards ? -1 : 1);
        var foundItem = null;
        if (inRange(nextIndex)) {
          foundItem = _items[nextIndex];
        } else if (reloop) {
          foundItem = backwards ? last() : first();
          nextIndex = indexOf(foundItem);
        }

        if ((foundItem === null) || (nextIndex === limit)) return null;
        if (validate(foundItem)) return foundItem;

        if (angular.isUndefined(limit)) limit = nextIndex;

        curIndex = nextIndex;
      }
    }
  }


})();
(function(){
"use strict";


mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
.factory('$mdMedia', mdMediaFactory);

/**
 * @ngdoc service
 * @name $mdMedia
 * @module material.core
 *
 * @description
 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
 * you to register a watch.
 *
 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
 *
 *  <table class="md-api-table">
 *    <thead>
 *    <tr>
 *      <th>Breakpoint</th>
 *      <th>mediaQuery</th>
 *    </tr>
 *    </thead>
 *    <tbody>
 *    <tr>
 *      <td>xs</td>
 *      <td>(max-width: 599px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-xs</td>
 *      <td>(min-width: 600px)</td>
 *    </tr>
 *    <tr>
 *      <td>sm</td>
 *      <td>(min-width: 600px) and (max-width: 959px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-sm</td>
 *      <td>(min-width: 960px)</td>
 *    </tr>
 *    <tr>
 *      <td>md</td>
 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-md</td>
 *      <td>(min-width: 1280px)</td>
 *    </tr>
 *    <tr>
 *      <td>lg</td>
 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-lg</td>
 *      <td>(min-width: 1920px)</td>
 *    </tr>
 *    <tr>
 *      <td>xl</td>
 *      <td>(min-width: 1920px)</td>
 *    </tr>
 *    <tr>
 *      <td>landscape</td>
 *      <td>landscape</td>
 *    </tr>
 *    <tr>
 *      <td>portrait</td>
 *      <td>portrait</td>
 *    </tr>
 *    <tr>
 *      <td>print</td>
 *      <td>print</td>
 *    </tr>
 *    </tbody>
 *  </table>
 *
 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
 *
 *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
 *  </a>
 *
 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
 *
 * @usage
 * <hljs lang="js">
 * app.controller('MyController', function($mdMedia, $scope) {
 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
 *     $scope.bigScreen = big;
 *   });
 *
 *   $scope.screenIsSmall = $mdMedia('sm');
 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
 * });
 * </hljs>
 */

/* @ngInject */
function mdMediaFactory($mdConstant, $rootScope, $window) {
  var queries = {};
  var mqls = {};
  var results = {};
  var normalizeCache = {};

  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
  $mdMedia.getQuery = getQuery;
  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;

  return $mdMedia;

  function $mdMedia(query) {
    var validated = queries[query];
    if (angular.isUndefined(validated)) {
      validated = queries[query] = validate(query);
    }

    var result = results[validated];
    if (angular.isUndefined(result)) {
      result = add(validated);
    }

    return result;
  }

  function validate(query) {
    return $mdConstant.MEDIA[query] ||
           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
  }

  function add(query) {
    var result = mqls[query];
    if ( !result ) {
      result = mqls[query] = $window.matchMedia(query);
    }

    result.addListener(onQueryChange);
    return (results[result.media] = !!result.matches);
  }

  function onQueryChange(query) {
    $rootScope.$evalAsync(function() {
      results[query.media] = !!query.matches;
    });
  }

  function getQuery(name) {
    return mqls[name];
  }

  function getResponsiveAttribute(attrs, attrName) {
    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
      if (!mqls[queries[mediaName]].matches) {
        continue;
      }

      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
      if (attrs[normalizedName]) {
        return attrs[normalizedName];
      }
    }

    // fallback on unprefixed
    return attrs[getNormalizedName(attrs, attrName)];
  }

  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
    var unwatchFns = [];
    attrNames.forEach(function(attrName) {
      var normalizedName = getNormalizedName(attrs, attrName);
      if (angular.isDefined(attrs[normalizedName])) {
        unwatchFns.push(
            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
      }

      for (var mediaName in $mdConstant.MEDIA) {
        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
        if (angular.isDefined(attrs[normalizedName])) {
          unwatchFns.push(
              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
        }
      }
    });

    return function unwatch() {
      unwatchFns.forEach(function(fn) { fn(); });
    };
  }

  // Improves performance dramatically
  function getNormalizedName(attrs, attrName) {
    return normalizeCache[attrName] ||
        (normalizeCache[attrName] = attrs.$normalize(attrName));
  }
}

})();
(function(){
"use strict";

angular
  .module('material.core')
  .config( ["$provide", function($provide) {
    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {

      // Inject the prefixer into our original $mdUtil service.
      $delegate.prefixer = MdPrefixer;

      return $delegate;
    }]);
  }]);

function MdPrefixer(initialAttributes, buildSelector) {
  var PREFIXES = ['data', 'x'];

  if (initialAttributes) {
    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
    // the specified attributes.
    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
  }

  return {
    buildList: _buildList,
    buildSelector: _buildSelector,
    hasAttribute: _hasAttribute,
    removeAttribute: _removeAttribute
  };

  function _buildList(attributes) {
    attributes = angular.isArray(attributes) ? attributes : [attributes];

    attributes.forEach(function(item) {
      PREFIXES.forEach(function(prefix) {
        attributes.push(prefix + '-' + item);
      });
    });

    return attributes;
  }

  function _buildSelector(attributes) {
    attributes = angular.isArray(attributes) ? attributes : [attributes];

    return _buildList(attributes)
      .map(function(item) {
        return '[' + item + ']';
      })
      .join(',');
  }

  function _hasAttribute(element, attribute) {
    element = _getNativeElement(element);

    if (!element) {
      return false;
    }

    var prefixedAttrs = _buildList(attribute);

    for (var i = 0; i < prefixedAttrs.length; i++) {
      if (element.hasAttribute(prefixedAttrs[i])) {
        return true;
      }
    }

    return false;
  }

  function _removeAttribute(element, attribute) {
    element = _getNativeElement(element);

    if (!element) {
      return;
    }

    _buildList(attribute).forEach(function(prefixedAttribute) {
      element.removeAttribute(prefixedAttribute);
    });
  }

  /**
   * Transforms a jqLite or DOM element into a HTML element.
   * This is useful when supporting jqLite elements and DOM elements at
   * same time.
   * @param element {JQLite|Element} Element to be parsed
   * @returns {HTMLElement} Parsed HTMLElement
   */
  function _getNativeElement(element) {
    element =  element[0] || element;

    if (element.nodeType) {
      return element;
    }
  }

}

})();
(function(){
"use strict";

/*
 * This var has to be outside the angular factory, otherwise when
 * there are multiple material apps on the same page, each app
 * will create its own instance of this array and the app's IDs
 * will not be unique.
 */
UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
var nextUniqueId = 0;

/**
 * @ngdoc module
 * @name material.core.util
 * @description
 * Util
 */
angular
  .module('material.core')
  .factory('$mdUtil', UtilFactory);

/**
 * @ngInject
 */
function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window, $$rAF) {
  // Setup some core variables for the processTemplate method
  var startSymbol = $interpolate.startSymbol(),
    endSymbol = $interpolate.endSymbol(),
    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));

  /**
   * Checks if the target element has the requested style by key
   * @param {DOMElement|JQLite} target Target element
   * @param {string} key Style key
   * @param {string=} expectedVal Optional expected value
   * @returns {boolean} Whether the target element has the style or not
   */
  var hasComputedStyle = function (target, key, expectedVal) {
    var hasValue = false;

    if ( target && target.length  ) {
      var computedStyles = $window.getComputedStyle(target[0]);
      hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
    }

    return hasValue;
  };

  function validateCssValue(value) {
    return !value       ? '0'   :
      hasPx(value) || hasPercent(value) ? value : value + 'px';
  }

  function hasPx(value) {
    return String(value).indexOf('px') > -1;
  }

  function hasPercent(value) {
    return String(value).indexOf('%') > -1;

  }

  var $mdUtil = {
    dom: {},
    now: window.performance && window.performance.now ?
      angular.bind(window.performance, window.performance.now) : Date.now || function() {
      return new Date().getTime();
    },

    /**
     * Cross-version compatibility method to retrieve an option of a ngModel controller,
     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
     * @param {!angular.ngModelCtrl} ngModelCtrl
     * @param {!string} optionName
     * @returns {Object|undefined}
     */
    getModelOption: function (ngModelCtrl, optionName) {
      if (!ngModelCtrl.$options) {
        return;
      }

      var $options = ngModelCtrl.$options;

      // The newer versions of AngularJS introduced a `getOption function and made the option values no longer
      // visible on the $options object.
      return $options.getOption ? $options.getOption(optionName) : $options[optionName]
    },

    /**
     * Bi-directional accessor/mutator used to easily update an element's
     * property based on the current 'dir'ectional value.
     */
    bidi : function(element, property, lValue, rValue) {
      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');

      // If accessor
      if ( arguments.length == 0 ) return ltr ? 'ltr' : 'rtl';

      // If mutator
      var elem = angular.element(element);

      if ( ltr && angular.isDefined(lValue)) {
        elem.css(property, validateCssValue(lValue));
      }
      else if ( !ltr && angular.isDefined(rValue)) {
        elem.css(property, validateCssValue(rValue) );
      }
    },

    bidiProperty: function (element, lProperty, rProperty, value) {
      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');

      var elem = angular.element(element);

      if ( ltr && angular.isDefined(lProperty)) {
        elem.css(lProperty, validateCssValue(value));
        elem.css(rProperty, '');
      }
      else if ( !ltr && angular.isDefined(rProperty)) {
        elem.css(rProperty, validateCssValue(value) );
        elem.css(lProperty, '');
      }
    },

    clientRect: function(element, offsetParent, isOffsetRect) {
      var node = getNode(element);
      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
      var nodeRect = node.getBoundingClientRect();

      // The user can ask for an offsetRect: a rect relative to the offsetParent,
      // or a clientRect: a rect relative to the page
      var offsetRect = isOffsetRect ?
        offsetParent.getBoundingClientRect() :
      {left: 0, top: 0, width: 0, height: 0};
      return {
        left: nodeRect.left - offsetRect.left,
        top: nodeRect.top - offsetRect.top,
        width: nodeRect.width,
        height: nodeRect.height
      };
    },
    offsetRect: function(element, offsetParent) {
      return $mdUtil.clientRect(element, offsetParent, true);
    },

    // Annoying method to copy nodes to an array, thanks to IE
    nodesToArray: function(nodes) {
      nodes = nodes || [];

      var results = [];
      for (var i = 0; i < nodes.length; ++i) {
        results.push(nodes.item(i));
      }
      return results;
    },

    /**
     * Determines the absolute position of the viewport.
     * Useful when making client rectangles absolute.
     * @returns {number}
     */
    getViewportTop: function() {
      return window.scrollY || window.pageYOffset || 0;
    },

    /**
     * Finds the proper focus target by searching the DOM.
     *
     * @param containerEl
     * @param attributeVal
     * @returns {*}
     */
    findFocusTarget: function(containerEl, attributeVal) {
      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
      var elToFocus;

      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);

      if ( !elToFocus && attributeVal != AUTO_FOCUS) {
        // Scan for deprecated attribute
        elToFocus = scanForFocusable(containerEl, this.prefixer('md-auto-focus', true));

        if ( !elToFocus ) {
          // Scan for fallback to 'universal' API
          elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
        }
      }

      return elToFocus;

      /**
       * Can target and nested children for specified Selector (attribute)
       * whose value may be an expression that evaluates to True/False.
       */
      function scanForFocusable(target, selector) {
        var elFound, items = target[0].querySelectorAll(selector);

        // Find the last child element with the focus attribute
        if ( items && items.length ){
          items.length && angular.forEach(items, function(it) {
            it = angular.element(it);

            // Check the element for the md-autofocus class to ensure any associated expression
            // evaluated to true.
            var isFocusable = it.hasClass('md-autofocus');
            if (isFocusable) elFound = it;
          });
        }
        return elFound;
      }
    },

    /**
     * Disables scroll around the passed parent element.
     * @param element Unused
     * @param {!Element|!angular.JQLite} parent Element to disable scrolling within.
     *   Defaults to body if none supplied.
     * @param options Object of options to modify functionality
     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
     *     use the passed parent element.
     */
    disableScrollAround: function(element, parent, options) {
      options = options || {};

      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
      $mdUtil.disableScrollAround._count++;

      if ($mdUtil.disableScrollAround._restoreScroll) {
        return $mdUtil.disableScrollAround._restoreScroll;
      }

      var body = $document[0].body;
      var restoreBody = disableBodyScroll();
      var restoreElement = disableElementScroll(parent);

      return $mdUtil.disableScrollAround._restoreScroll = function() {
        if (--$mdUtil.disableScrollAround._count <= 0) {
          restoreBody();
          restoreElement();
          delete $mdUtil.disableScrollAround._restoreScroll;
        }
      };

      /**
       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
       * and wheel events
       */
      function disableElementScroll(element) {
        element = angular.element(element || body);

        var scrollMask;

        if (options.disableScrollMask) {
          scrollMask = element;
        } else {
          scrollMask = angular.element(
            '<div class="md-scroll-mask">' +
            '  <div class="md-scroll-mask-bar"></div>' +
            '</div>');
          element.append(scrollMask);
        }

        scrollMask.on('wheel', preventDefault);
        scrollMask.on('touchmove', preventDefault);

        return function restoreElementScroll() {
          scrollMask.off('wheel');
          scrollMask.off('touchmove');

          if (!options.disableScrollMask && scrollMask[0].parentNode ) {
            scrollMask[0].parentNode.removeChild(scrollMask[0]);
          }
        };

        function preventDefault(e) {
          e.preventDefault();
        }
      }

      // Converts the body to a position fixed block and translate it to the proper scroll position
      function disableBodyScroll() {
        var documentElement = $document[0].documentElement;

        var prevDocumentStyle = documentElement.style.cssText || '';
        var prevBodyStyle = body.style.cssText || '';

        var viewportTop = $mdUtil.getViewportTop();
        var clientWidth = body.clientWidth;
        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;

        // Scroll may be set on <html> element (for example by overflow-y: scroll)
        // but Chrome is reporting the scrollTop position always on <body>.
        // scrollElement will allow to restore the scrollTop position to proper target.
        var scrollElement = documentElement.scrollTop > 0 ? documentElement : body;

        if (hasVerticalScrollbar) {
          angular.element(body).css({
            position: 'fixed',
            width: '100%',
            top: -viewportTop + 'px'
          });
        }

        if (body.clientWidth < clientWidth) {
          body.style.overflow = 'hidden';
        }

        // This should be applied after the manipulation to the body, because
        // adding a scrollbar can potentially resize it, causing the measurement
        // to change.
        if (hasVerticalScrollbar) {
          documentElement.style.overflowY = 'scroll';
        }

        return function restoreScroll() {
          // Reset the inline style CSS to the previous.
          body.style.cssText = prevBodyStyle;
          documentElement.style.cssText = prevDocumentStyle;

          // The scroll position while being fixed
          scrollElement.scrollTop = viewportTop;
        };
      }

    },

    enableScrolling: function() {
      var restoreFn = this.disableScrollAround._restoreScroll;
      restoreFn && restoreFn();
    },

    floatingScrollbars: function() {
      if (this.floatingScrollbars.cached === undefined) {
        var tempNode = angular.element('<div><div></div></div>').css({
          width: '100%',
          'z-index': -1,
          position: 'absolute',
          height: '35px',
          'overflow-y': 'scroll'
        });
        tempNode.children().css('height', '60px');

        $document[0].body.appendChild(tempNode[0]);
        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
        tempNode.remove();
      }
      return this.floatingScrollbars.cached;
    },

    // Mobile safari only allows you to set focus in click event listeners...
    forceFocus: function(element) {
      var node = element[0] || element;

      document.addEventListener('click', function focusOnClick(ev) {
        if (ev.target === node && ev.$focus) {
          node.focus();
          ev.stopImmediatePropagation();
          ev.preventDefault();
          node.removeEventListener('click', focusOnClick);
        }
      }, true);

      var newEvent = document.createEvent('MouseEvents');
      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
        false, false, false, false, 0, null);
      newEvent.$material = true;
      newEvent.$focus = true;
      node.dispatchEvent(newEvent);
    },

    /**
     * facade to build md-backdrop element with desired styles
     * NOTE: Use $compile to trigger backdrop postLink function
     */
    createBackdrop: function(scope, addClass) {
      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
    },

    /**
     * supplant() method from Crockford's `Remedial Javascript`
     * Equivalent to use of $interpolate; without dependency on
     * interpolation symbols and scope. Note: the '{<token>}' can
     * be property names, property chains, or array indices.
     */
    supplant: function(template, values, pattern) {
      pattern = pattern || /\{([^\{\}]*)\}/g;
      return template.replace(pattern, function(a, b) {
        var p = b.split('.'),
          r = values;
        try {
          for (var s in p) {
            if (p.hasOwnProperty(s) ) {
              r = r[p[s]];
            }
          }
        } catch (e) {
          r = a;
        }
        return (typeof r === 'string' || typeof r === 'number') ? r : a;
      });
    },

    fakeNgModel: function() {
      return {
        $fake: true,
        $setTouched: angular.noop,
        $setViewValue: function(value) {
          this.$viewValue = value;
          this.$render(value);
          this.$viewChangeListeners.forEach(function(cb) {
            cb();
          });
        },
        $isEmpty: function(value) {
          return ('' + value).length === 0;
        },
        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop
      };
    },

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds.
    // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
    // @param invokeApply should the $timeout trigger $digest() dirty checking
    debounce: function(func, wait, scope, invokeApply) {
      var timer;

      return function debounced() {
        var context = scope,
          args = Array.prototype.slice.call(arguments);

        $timeout.cancel(timer);
        timer = $timeout(function() {

          timer = undefined;
          func.apply(context, args);

        }, wait || 10, invokeApply);
      };
    },

    // Returns a function that can only be triggered every `delay` milliseconds.
    // In other words, the function will not be called unless it has been more
    // than `delay` milliseconds since the last call.
    throttle: function throttle(func, delay) {
      var recent;
      return function throttled() {
        var context = this;
        var args = arguments;
        var now = $mdUtil.now();

        if (!recent || (now - recent > delay)) {
          func.apply(context, args);
          recent = now;
        }
      };
    },

    /**
     * Measures the number of milliseconds taken to run the provided callback
     * function. Uses a high-precision timer if available.
     */
    time: function time(cb) {
      var start = $mdUtil.now();
      cb();
      return $mdUtil.now() - start;
    },

    /**
     * Create an implicit getter that caches its `getter()`
     * lookup value
     */
    valueOnUse : function (scope, key, getter) {
      var value = null, args = Array.prototype.slice.call(arguments);
      var params = (args.length > 3) ? args.slice(3) : [ ];

      Object.defineProperty(scope, key, {
        get: function () {
          if (value === null) value = getter.apply(scope, params);
          return value;
        }
      });
    },

    /**
     * Get a unique ID.
     *
     * @returns {string} an unique numeric string
     */
    nextUid: function() {
      return '' + nextUniqueId++;
    },

    // Stop watchers and events from firing on a scope without destroying it,
    // by disconnecting it from its parent and its siblings' linked lists.
    disconnectScope: function disconnectScope(scope) {
      if (!scope) return;

      // we can't destroy the root scope or a scope that has been already destroyed
      if (scope.$root === scope) return;
      if (scope.$$destroyed) return;

      var parent = scope.$parent;
      scope.$$disconnected = true;

      // See Scope.$destroy
      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;

      scope.$$nextSibling = scope.$$prevSibling = null;

    },

    // Undo the effects of disconnectScope above.
    reconnectScope: function reconnectScope(scope) {
      if (!scope) return;

      // we can't disconnect the root node or scope already disconnected
      if (scope.$root === scope) return;
      if (!scope.$$disconnected) return;

      var child = scope;

      var parent = child.$parent;
      child.$$disconnected = false;
      // See Scope.$new for this logic...
      child.$$prevSibling = parent.$$childTail;
      if (parent.$$childHead) {
        parent.$$childTail.$$nextSibling = child;
        parent.$$childTail = child;
      } else {
        parent.$$childHead = parent.$$childTail = child;
      }
    },

    /*
     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
     *
     * @param el Element to start walking the DOM from
     * @param check Either a string or a function. If a string is passed, it will be evaluated against
     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each of
     * the parents and will use the return value to determine whether the node is a match.
     * @param onlyParent Only start checking from the parent element, not `el`.
     */
    getClosest: function getClosest(el, validateWith, onlyParent) {
      if ( angular.isString(validateWith) ) {
        var tagName = validateWith.toUpperCase();
        validateWith = function(el) {
          return el.nodeName.toUpperCase() === tagName;
        };
      }

      if (el instanceof angular.element) el = el[0];
      if (onlyParent) el = el.parentNode;
      if (!el) return null;

      do {
        if (validateWith(el)) {
          return el;
        }
      } while (el = el.parentNode);

      return null;
    },

    /**
     * Build polyfill for the Node.contains feature (if needed)
     */
    elementContains: function(node, child) {
      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
        // compares the positions of two nodes and returns a bitmask
        return (node === child) || !!(this.compareDocumentPosition(arg) & 16)
      });

      return findFn(child);
    },

    /**
     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
     * useful with interimElements where the element and its container are important...
     *
     * @param {[]} elements to scan
     * @param {string} name of node to find (e.g. 'md-dialog')
     * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
     * @param {boolean=} optional flag to enable log warnings; defaults to false
     */
    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
      var found = scanTree(element);
      if (!found && !!warnNotFound) {
        $log.warn( $mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]) );
      }

      return angular.element(found || element);

      /**
       * Breadth-First tree scan for element with matching `nodeName`
       */
      function scanTree(element) {
        return scanLevel(element) || (!!scanDeep ? scanChildren(element) : null);
      }

      /**
       * Case-insensitive scan of current elements only (do not descend).
       */
      function scanLevel(element) {
        if ( element ) {
          for (var i = 0, len = element.length; i < len; i++) {
            if (element[i].nodeName.toLowerCase() === nodeName) {
              return element[i];
            }
          }
        }
        return null;
      }

      /**
       * Scan children of specified node
       */
      function scanChildren(element) {
        var found;
        if ( element ) {
          for (var i = 0, len = element.length; i < len; i++) {
            var target = element[i];
            if ( !found ) {
              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
                found = found || scanTree([target.childNodes[j]]);
              }
            }
          }
        }
        return found;
      }

    },

    /**
     * Give optional properties with no value a boolean true if attr provided or false otherwise
     */
    initOptionalProperties: function(scope, attr, defaults) {
      defaults = defaults || {};
      angular.forEach(scope.$$isolateBindings, function(binding, key) {
        if (binding.optional && angular.isUndefined(scope[key])) {
          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
        }
      });
    },

    /**
     * Alternative to $timeout calls with 0 delay.
     * nextTick() coalesces all calls within a single frame
     * to minimize $digest thrashing
     *
     * @param callback
     * @param digest
     * @returns {*}
     */
    nextTick: function(callback, digest, scope) {
      //-- grab function reference for storing state details
      var nextTick = $mdUtil.nextTick;
      var timeout = nextTick.timeout;
      var queue = nextTick.queue || [];

      //-- add callback to the queue
      queue.push({scope: scope, callback: callback});

      //-- set default value for digest
      if (digest == null) digest = true;

      //-- store updated digest/queue values
      nextTick.digest = nextTick.digest || digest;
      nextTick.queue = queue;

      //-- either return existing timeout or create a new one
      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

      /**
       * Grab a copy of the current queue
       * Clear the queue for future use
       * Process the existing queue
       * Trigger digest if necessary
       */
      function processQueue() {
        var queue = nextTick.queue;
        var digest = nextTick.digest;

        nextTick.queue = [];
        nextTick.timeout = null;
        nextTick.digest = false;

        queue.forEach(function(queueItem) {
          var skip = queueItem.scope && queueItem.scope.$$destroyed;
          if (!skip) {
            queueItem.callback();
          }
        });

        if (digest) $rootScope.$digest();
      }
    },

    /**
     * Processes a template and replaces the start/end symbols if the application has
     * overriden them.
     *
     * @param template The template to process whose start/end tags may be replaced.
     * @returns {*}
     */
    processTemplate: function(template) {
      if (usesStandardSymbols) {
        return template;
      } else {
        if (!template || !angular.isString(template)) return template;
        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
      }
    },

    /**
     * Scan up dom hierarchy for enabled parent;
     */
    getParentWithPointerEvents: function (element) {
      var parent = element.parent();

      // jqLite might return a non-null, but still empty, parent; so check for parent and length
      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
        parent = parent.parent();
      }

      return parent;
    },

    getNearestContentElement: function (element) {
      var current = element.parent()[0];
      // Look for the nearest parent md-content, stopping at the rootElement.
      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
        current = current.parentNode;
      }
      return current;
    },

    /**
     * Checks if the current browser is natively supporting the `sticky` position.
     * @returns {string} supported sticky property name
     */
    checkStickySupport: function() {
      var stickyProp;
      var testEl = angular.element('<div>');
      $document[0].body.appendChild(testEl[0]);

      var stickyProps = ['sticky', '-webkit-sticky'];
      for (var i = 0; i < stickyProps.length; ++i) {
        testEl.css({
          position: stickyProps[i],
          top: 0,
          'z-index': 2
        });

        if (testEl.css('position') == stickyProps[i]) {
          stickyProp = stickyProps[i];
          break;
        }
      }

      testEl.remove();

      return stickyProp;
    },

    /**
     * Parses an attribute value, mostly a string.
     * By default checks for negated values and returns `false´ if present.
     * Negated values are: (native falsy) and negative strings like:
     * `false` or `0`.
     * @param value Attribute value which should be parsed.
     * @param negatedCheck When set to false, won't check for negated values.
     * @returns {boolean}
     */
    parseAttributeBoolean: function(value, negatedCheck) {
      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
    },

    hasComputedStyle: hasComputedStyle,

    /**
     * Returns true if the parent form of the element has been submitted.
     *
     * @param element An AngularJS or HTML5 element.
     *
     * @returns {boolean}
     */
    isParentFormSubmitted: function(element) {
      var parent = $mdUtil.getClosest(element, 'form');
      var form = parent ? angular.element(parent).controller('form') : null;

      return form ? form.$submitted : false;
    },

    /**
     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
     *
     * @param {!HTMLElement} element The element to scroll.
     * @param {number} scrollEnd The new/final scroll position.
     * @param {number=} duration Duration of the scroll. Default is 1000ms.
     */
    animateScrollTo: function(element, scrollEnd, duration) {
      var scrollStart = element.scrollTop;
      var scrollChange = scrollEnd - scrollStart;
      var scrollingDown = scrollStart < scrollEnd;
      var startTime = $mdUtil.now();

      $$rAF(scrollChunk);

      function scrollChunk() {
        var newPosition = calculateNewPosition();

        element.scrollTop = newPosition;

        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
          $$rAF(scrollChunk);
        }
      }

      function calculateNewPosition() {
        var easeDuration = duration || 1000;
        var currentTime = $mdUtil.now() - startTime;

        return ease(currentTime, scrollStart, scrollChange, easeDuration);
      }

      function ease(currentTime, start, change, duration) {
        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
        // straight to the proper position
        if (currentTime > duration) {
          return start + change;
        }

        var ts = (currentTime /= duration) * currentTime;
        var tc = ts * currentTime;

        return start + change * (-2 * tc + 3 * ts);
      }
    },

    /**
     * Provides an easy mechanism for removing duplicates from an array.
     *
     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
     *
     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
     *
     * @param {array} array The array whose unique values should be returned.
     *
     * @returns {array} A copy of the array containing only unique values.
     */
    uniq: function(array) {
      if (!array) { return; }

      return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
      });
    }
  };


// Instantiate other namespace utility methods

  $mdUtil.dom.animator = $$mdAnimate($mdUtil);

  return $mdUtil;

  function getNode(el) {
    return el[0] || el;
  }

}

/*
 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
 */

angular.element.prototype.focus = angular.element.prototype.focus || function() {
    if (this.length) {
      this[0].focus();
    }
    return this;
  };
angular.element.prototype.blur = angular.element.prototype.blur || function() {
    if (this.length) {
      this[0].blur();
    }
    return this;
  };

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.aria
 * @description
 * Aria Expectations for AngularJS Material components.
 */
MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
angular
  .module('material.core')
  .provider('$mdAria', MdAriaProvider);

/**
 * @ngdoc service
 * @name $mdAriaProvider
 * @module material.core.aria
 *
 * @description
 *
 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
 * components.
 *
 * You are able to disable `$mdAria` warnings, by using the following markup.
 *
 * <hljs lang="js">
 *   app.config(function($mdAriaProvider) {
 *     // Globally disables all ARIA warnings.
 *     $mdAriaProvider.disableWarnings();
 *   });
 * </hljs>
 *
 */
function MdAriaProvider() {

  var config = {
    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
    showWarnings: true
  };

  return {
    disableWarnings: disableWarnings,
    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
      return MdAriaService.apply(config, arguments);
    }]
  };

  /**
   * @ngdoc method
   * @name $mdAriaProvider#disableWarnings
   * @description Disables all ARIA warnings generated by AngularJS Material.
   */
  function disableWarnings() {
    config.showWarnings = false;
  }
}

/*
 * @ngInject
 */
function MdAriaService($$rAF, $log, $window, $interpolate) {

  // Load the showWarnings option from the current context and store it inside of a scope variable,
  // because the context will be probably lost in some function calls.
  var showWarnings = this.showWarnings;

  return {
    expect: expect,
    expectAsync: expectAsync,
    expectWithText: expectWithText,
    expectWithoutText: expectWithoutText,
    getText: getText,
    hasAriaLabel: hasAriaLabel,
    parentHasAriaLabel: parentHasAriaLabel
  };

  /**
   * Check if expected attribute has been specified on the target element or child
   * @param element
   * @param attrName
   * @param {optional} defaultValue What to set the attr to if no value is found
   */
  function expect(element, attrName, defaultValue) {

    var node = angular.element(element)[0] || element;

    // if node exists and neither it nor its children have the attribute
    if (node &&
       ((!node.hasAttribute(attrName) ||
        node.getAttribute(attrName).length === 0) &&
        !childHasAttribute(node, attrName))) {

      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
      if (defaultValue.length) {
        element.attr(attrName, defaultValue);
      } else if (showWarnings) {
        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
      }

    }
  }

  function expectAsync(element, attrName, defaultValueGetter) {
    // Problem: when retrieving the element's contents synchronously to find the label,
    // the text may not be defined yet in the case of a binding.
    // There is a higher chance that a binding will be defined if we wait one frame.
    $$rAF(function() {
        expect(element, attrName, defaultValueGetter());
    });
  }

  function expectWithText(element, attrName) {
    var content = getText(element) || "";
    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;

    if (hasBinding) {
      expectAsync(element, attrName, function() {
        return getText(element);
      });
    } else {
      expect(element, attrName, content);
    }
  }

  function expectWithoutText(element, attrName) {
    var content = getText(element);
    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;

    if ( !hasBinding && !content) {
      expect(element, attrName, content);
    }
  }

  function getText(element) {
    element = element[0] || element;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
    var text = '';

    var node;
    while (node = walker.nextNode()) {
      if (!isAriaHiddenNode(node)) {
        text += node.textContent;
      }
    }

    return text.trim() || '';

    function isAriaHiddenNode(node) {
      while (node.parentNode && (node = node.parentNode) !== element) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
          return true;
        }
      }
    }
  }

  function childHasAttribute(node, attrName) {
    var hasChildren = node.hasChildNodes(),
        hasAttr = false;

    function isHidden(el) {
      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
      return (style.display === 'none');
    }

    if (hasChildren) {
      var children = node.childNodes;
      for (var i=0; i < children.length; i++) {
        var child = children[i];
        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
          if (!isHidden(child)) {
            hasAttr = true;
          }
        }
      }
    }
    return hasAttr;
  }

  /**
   * Check if expected element has aria label attribute
   * @param element
   */
  function hasAriaLabel(element) {
    var node = angular.element(element)[0] || element;

    /* Check if compatible node type (ie: not HTML Document node) */
    if (!node.hasAttribute) {
      return false;
    }

    /* Check label or description attributes */
    return node.hasAttribute('aria-label') || node.hasAttribute('aria-labelledby') || node.hasAttribute('aria-describedby');
  }

  /**
   * Check if expected element's parent has aria label attribute and has valid role and tagName
   * @param element
   * @param {optional} level Number of levels deep search should be performed
   */
  function parentHasAriaLabel(element, level) {
    level = level || 1;
    var node = angular.element(element)[0] || element;
    if (!node.parentNode) {
      return false;
    }
    if (performCheck(node.parentNode)) {
      return true;
    }
    level--;
    if (level) {
      return parentHasAriaLabel(node.parentNode, level);
    }
    return false;

    function performCheck(parentNode) {
      if (!hasAriaLabel(parentNode)) {
        return false;
      }
      /* Perform role blacklist check */
      if (parentNode.hasAttribute('role')) {
        switch(parentNode.getAttribute('role').toLowerCase()) {
          case 'command':
          case 'definition':
          case 'directory':
          case 'grid':
          case 'list':
          case 'listitem':
          case 'log':
          case 'marquee':
          case 'menu':
          case 'menubar':
          case 'note':
          case 'presentation':
          case 'separator':
          case 'scrollbar':
          case 'status':
          case 'tablist':
            return false;
        }
      }
      /* Perform tagName blacklist check */
      switch(parentNode.tagName.toLowerCase()) {
        case 'abbr':
        case 'acronym':
        case 'address':
        case 'applet':
        case 'audio':
        case 'b':
        case 'bdi':
        case 'bdo':
        case 'big':
        case 'blockquote':
        case 'br':
        case 'canvas':
        case 'caption':
        case 'center':
        case 'cite':
        case 'code':
        case 'col':
        case 'data':
        case 'dd':
        case 'del':
        case 'dfn':
        case 'dir':
        case 'div':
        case 'dl':
        case 'em':
        case 'embed':
        case 'fieldset':
        case 'figcaption':
        case 'font':
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
        case 'hgroup':
        case 'html':
        case 'i':
        case 'ins':
        case 'isindex':
        case 'kbd':
        case 'keygen':
        case 'label':
        case 'legend':
        case 'li':
        case 'map':
        case 'mark':
        case 'menu':
        case 'object':
        case 'ol':
        case 'output':
        case 'pre':
        case 'presentation':
        case 'q':
        case 'rt':
        case 'ruby':
        case 'samp':
        case 'small':
        case 'source':
        case 'span':
        case 'status':
        case 'strike':
        case 'strong':
        case 'sub':
        case 'sup':
        case 'svg':
        case 'tbody':
        case 'td':
        case 'th':
        case 'thead':
        case 'time':
        case 'tr':
        case 'track':
        case 'tt':
        case 'ul':
        case 'var':
          return false;
      }
      return true;
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.compiler
 * @description
 * AngularJS Material template and element compiler.
 */
angular
  .module('material.core')
  .provider('$mdCompiler', MdCompilerProvider);

/**
 * @ngdoc provider
 * @name $mdCompilerProvider
 *
 * @description
 */
/**
 * @ngdoc service
 * @name $mdCompiler
 * @module material.core.compiler
 * @description
 * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
 * to easily compile an element with options like in a Directive Definition Object.
 *
 * > The compiler powers a lot of components inside of AngularJS Material.
 * > Like the `$mdPanel` or `$mdDialog`.
 *
 * @usage
 *
 * Basic Usage with a template
 *
 * <hljs lang="js">
 *   $mdCompiler.compile({
 *     templateUrl: 'modal.html',
 *     controller: 'ModalCtrl',
 *     locals: {
 *       modal: myModalInstance;
 *     }
 *   }).then(function (compileData) {
 *     compileData.element; // Compiled DOM element
 *     compileData.link(myScope); // Instantiate controller and link element to scope.
 *   });
 * </hljs>
 *
 * Example with a content element
 *
 * <hljs lang="js">
 *
 *   // Create a virtual element and link it manually.
 *   // The compiler doesn't need to recompile the element each time.
 *   var myElement = $compile('<span>Test</span>')(myScope);
 *
 *   $mdCompiler.compile({
 *     contentElement: myElement
 *   }).then(function (compileData) {
 *     compileData.element // Content Element (same as above)
 *     compileData.link // This does nothing when using a contentElement.
 *   });
 * </hljs>
 *
 * > Content Element is a significant performance improvement when the developer already knows that the
 * > compiled element will be always the same and the scope will not change either.
 *
 * The `contentElement` option also supports DOM elements which will be temporary removed and restored
 * at its old position.
 *
 * <hljs lang="js">
 *   var domElement = document.querySelector('#myElement');
 *
 *   $mdCompiler.compile({
 *     contentElement: myElement
 *   }).then(function (compileData) {
 *     compileData.element // Content Element (same as above)
 *     compileData.link // This does nothing when using a contentElement.
 *   });
 * </hljs>
 *
 * The `$mdCompiler` can also query for the element in the DOM itself.
 *
 * <hljs lang="js">
 *   $mdCompiler.compile({
 *     contentElement: '#myElement'
 *   }).then(function (compileData) {
 *     compileData.element // Content Element (same as above)
 *     compileData.link // This does nothing when using a contentElement.
 *   });
 * </hljs>
 *
 */
MdCompilerProvider.$inject = ['$compileProvider'];
function MdCompilerProvider($compileProvider) {

  var provider = this;

  /**
   * @name  $mdCompilerProvider#respectPreAssignBindingsEnabled
   *
   * @param {boolean=} respected update the respectPreAssignBindingsEnabled state if provided, otherwise just return
   * the current Material preAssignBindingsEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @description
   * Call this method to enable/disable whether Material-specific (dialogs/toasts) controllers respect the AngularJS
   * `$compile.preAssignBindingsEnabled` flag. Note that this doesn't affect directives/components created via
   * regular AngularJS methods which constitute most Material & user-created components.
   *
   * @see [AngularJS documentation for `$compile.preAssignBindingsEnabled`
   * ](https://code.angularjs.org/1.6.4/docs/api/ng/provider/$compileProvider#preAssignBindingsEnabled)
   * for more information.
   *
   * If disabled (false), the compiler assigns the value of each of the bindings to the
   * properties of the controller object before the constructor of this object is called.
   *
   * If enabled (true) the behavior depends on the AngularJS version used:
   *
   *     - `<1.5.10` - bindings are pre-assigned
   *     - `>=1.5.10 <1.7` - behaves like set to whatever `$compileProvider.preAssignBindingsEnabled()` reports; if
   *                         the `$compileProvider` flag wasn't set manually, it defaults to pre-assigning bindings
   *                         with AngularJS `1.5.x` & to calling the constructor first with AngularJS `1.6.x`.
   *     - `>=1.7` - the compiler calls the constructor first before assigning bindings
   *
   * The default value is `false` but will change to `true` in AngularJS Material 1.2.
   *
   * It is recommended to set this flag to `true` in AngularJS Material 1.1.x; the only reason it's not set that way
   * by default is backwards compatibility. Not setting the flag to `true` when
   * `$compileProvider.preAssignBindingsEnabled()` is set to `false` (i.e. default behavior in AngularJS 1.6.0 or newer)
   * makes it hard to unit test Material Dialog/Toast controllers using the `$controller` helper as it always follows
   * the `$compileProvider.preAssignBindingsEnabled()` value.
   */
  // TODO change it to `true` in Material 1.2.
  var respectPreAssignBindingsEnabled = false;
  this.respectPreAssignBindingsEnabled = function(respected) {
    if (angular.isDefined(respected)) {
      respectPreAssignBindingsEnabled = respected;
      return this;
    }

    return respectPreAssignBindingsEnabled;
  };

  /**
   * @description
   * This function returns `true` if Material-specific (dialogs/toasts) controllers have bindings pre-assigned in
   * controller constructors and `false` otherwise.
   *
   * Note that this doesn't affect directives/components created via regular AngularJS methods which constitute most
   * Material & user-created components; their behavior can be checked via `$compileProvider.preAssignBindingsEnabled()`
   * in AngularJS `>=1.5.10 <1.7.0`.
   *
   * @returns {*} current preAssignBindingsEnabled state
   */
  function getPreAssignBindingsEnabled() {
    if (!respectPreAssignBindingsEnabled) {
      // respectPreAssignBindingsEnabled === false
      // We're ignoring the AngularJS `$compileProvider.preAssignBindingsEnabled()` value in this case.
      return true;
    }

    // respectPreAssignBindingsEnabled === true

    if (typeof $compileProvider.preAssignBindingsEnabled === 'function') {
      return $compileProvider.preAssignBindingsEnabled();
    }

    // Flag respected but not present => apply logic based on AngularJS version used.
    if (angular.version.major === 1 && angular.version.minor < 6) {
      // AngularJS <1.5.10
      return true;
    }

    // AngularJS >=1.7.0
    return false;
  }

  this.$get = ["$q", "$templateRequest", "$injector", "$compile", "$controller",
    function($q, $templateRequest, $injector, $compile, $controller) {
      return new MdCompilerService($q, $templateRequest, $injector, $compile, $controller);
    }];

  function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {

    /** @private @const {!angular.$q} */
    this.$q = $q;

    /** @private @const {!angular.$templateRequest} */
    this.$templateRequest = $templateRequest;

    /** @private @const {!angular.$injector} */
    this.$injector = $injector;

    /** @private @const {!angular.$compile} */
    this.$compile = $compile;

    /** @private @const {!angular.$controller} */
    this.$controller = $controller;
  }

  /**
   * @ngdoc method
   * @name $mdCompiler#compile
   * @description
   *
   * A method to compile a HTML template with the AngularJS compiler.
   * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
   * like controller instantiation or async resolves.
   *
   * @param {!Object} options An options object, with the following properties:
   *
   *    - `controller` - `{string|Function}` Controller fn that should be associated with
   *         newly created scope or the name of a registered controller if passed as a string.
   *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
   *         published to scope under the `controllerAs` name.
   *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
   *         compiled each time, you can also use a DOM element.<br/>
   *    - `template` - `{string=}` An html template as a string.
   *    - `templateUrl` - `{string=}` A path to an html template.
   *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
   *        it is loaded. It will be given the template string as a parameter, and should
   *        return a a new string representing the transformed template.
   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
   *        be injected into the controller. If any of these dependencies are promises, the compiler
   *        will wait for them all to be resolved, or if one is rejected before the controller is
   *        instantiated `compile()` will fail..
   *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
   *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
   *        Otherwise if function, then it is injected and the return value is treated as the
   *        dependency. If the result is a promise, it is resolved before its value is
   *        injected into the controller.
   *
   * @returns {Object} promise A promise, which will be resolved with a `compileData` object.
   * `compileData` has the following properties:
   *
   *   - `element` - `{element}`: an uncompiled element matching the provided template.
   *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
   *     the element and instantiate the provided controller (if given).
   *   - `locals` - `{object}`: The locals which will be passed into the controller once `link` is
   *     called. If `bindToController` is true, they will be coppied to the ctrl instead
   *
   */
  MdCompilerService.prototype.compile = function(options) {

    if (options.contentElement) {
      return this._prepareContentElement(options);
    } else {
      return this._compileTemplate(options);
    }

  };

  /**
   * Instead of compiling any template, the compiler just fetches an existing HTML element from the DOM and
   * provides a restore function to put the element back it old DOM position.
   * @param {!Object} options Options to be used for the compiler.
   */
  MdCompilerService.prototype._prepareContentElement = function(options) {

    var contentElement = this._fetchContentElement(options);

    return this.$q.resolve({
      element: contentElement.element,
      cleanup: contentElement.restore,
      locals: {},
      link: function() {
        return contentElement.element;
      }
    });

  };

  /**
   * Compiles a template by considering all options and waiting for all resolves to be ready.
   * @param {!Object} options Compile options
   * @returns {!Object} Compile data with link function.
   */
  MdCompilerService.prototype._compileTemplate = function(options) {

    var self = this;
    var templateUrl = options.templateUrl;
    var template = options.template || '';
    var resolve = angular.extend({}, options.resolve);
    var locals = angular.extend({}, options.locals);
    var transformTemplate = options.transformTemplate || angular.identity;

    // Take resolve values and invoke them.
    // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
    // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
    angular.forEach(resolve, function(value, key) {
      if (angular.isString(value)) {
        resolve[key] = self.$injector.get(value);
      } else {
        resolve[key] = self.$injector.invoke(value);
      }
    });

    // Add the locals, which are just straight values to inject
    // eg locals: { three: 3 }, will inject three into the controller
    angular.extend(resolve, locals);

    if (templateUrl) {
      resolve.$$ngTemplate = this.$templateRequest(templateUrl);
    } else {
      resolve.$$ngTemplate = this.$q.when(template);
    }


    // Wait for all the resolves to finish if they are promises
    return this.$q.all(resolve).then(function(locals) {

      var template = transformTemplate(locals.$$ngTemplate, options);
      var element = options.element || angular.element('<div>').html(template.trim()).contents();

      return self._compileElement(locals, element, options);
    });

  };

  /**
   * Method to compile an element with the given options.
   * @param {!Object} locals Locals to be injected to the controller if present
   * @param {!JQLite} element Element to be compiled and linked
   * @param {!Object} options Options to be used for linking.
   * @returns {!Object} Compile data with link function.
   */
  MdCompilerService.prototype._compileElement = function(locals, element, options) {
    var self = this;
    var ngLinkFn = this.$compile(element);

    var compileData = {
      element: element,
      cleanup: element.remove.bind(element),
      locals: locals,
      link: linkFn
    };

    function linkFn(scope) {
      locals.$scope = scope;

      // Instantiate controller if the developer provided one.
      if (options.controller) {

        var injectLocals = angular.extend({}, locals, {
          $element: element
        });

        // Create the specified controller instance.
        var ctrl = self._createController(options, injectLocals, locals);

        // Unique identifier for AngularJS Route ngView controllers.
        element.data('$ngControllerController', ctrl);
        element.children().data('$ngControllerController', ctrl);

        // Expose the instantiated controller to the compile data
        compileData.controller = ctrl;
      }

      // Invoke the AngularJS $compile link function.
      return ngLinkFn(scope);
    }

    return compileData;

  };

  /**
   * Creates and instantiates a new controller with the specified options.
   * @param {!Object} options Options that include the controller
   * @param {!Object} injectLocals Locals to to be provided in the controller DI.
   * @param {!Object} locals Locals to be injected to the controller.
   * @returns {!Object} Created controller instance.
   */
  MdCompilerService.prototype._createController = function(options, injectLocals, locals) {
    var invokeCtrl = this.$controller(options.controller, injectLocals, true, options.controllerAs);

    if (getPreAssignBindingsEnabled() && options.bindToController) {
      angular.extend(invokeCtrl.instance, locals);
    }

    // Instantiate and initialize the specified controller.
    var ctrl = invokeCtrl();

    if (!getPreAssignBindingsEnabled() && options.bindToController) {
      angular.extend(invokeCtrl.instance, locals);
    }

    // Call the $onInit hook if it's present on the controller.
    angular.isFunction(ctrl.$onInit) && ctrl.$onInit();

    return ctrl;
  };

  /**
   * Fetches an element removing it from the DOM and using it temporary for the compiler.
   * Elements which were fetched will be restored after use.
   * @param {!Object} options Options to be used for the compilation.
   * @returns {{element: !JQLite, restore: !Function}}
   */
  MdCompilerService.prototype._fetchContentElement = function(options) {

    var contentEl = options.contentElement;
    var restoreFn = null;

    if (angular.isString(contentEl)) {
      contentEl = document.querySelector(contentEl);
      restoreFn = createRestoreFn(contentEl);
    } else {
      contentEl = contentEl[0] || contentEl;

      // When the element is visible in the DOM, then we restore it at close of the dialog.
      // Otherwise it will be removed from the DOM after close.
      if (document.contains(contentEl)) {
        restoreFn = createRestoreFn(contentEl);
      } else {
        restoreFn = function() {
          if (contentEl.parentNode) {
            contentEl.parentNode.removeChild(contentEl);
          }
        }
      }
    }

    return {
      element: angular.element(contentEl),
      restore: restoreFn
    };

    function createRestoreFn(element) {
      var parent = element.parentNode;
      var nextSibling = element.nextElementSibling;

      return function() {
        if (!nextSibling) {
          // When the element didn't had any sibling, then it can be simply appended to the
          // parent, because it plays no role, which index it had before.
          parent.appendChild(element);
        } else {
          // When the element had a sibling, which marks the previous position of the element
          // in the DOM, we insert it correctly before the sibling, to have the same index as
          // before.
          parent.insertBefore(element, nextSibling);
        }
      }
    }
  };
}


})();
(function(){
"use strict";


MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout"];
attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler"];var HANDLERS = {};

/* The state of the current 'pointer'
 * The pointer represents the state of the current touch.
 * It contains normalized x and y coordinates from DOM events,
 * as well as other information abstracted from the DOM.
 */

var pointer, lastPointer, forceSkipClickHijack = false, maxClickDistance = 6;

/**
 * The position of the most recent click if that click was on a label element.
 * @type {{x: number, y: number}?}
 */
var lastLabelClickPos = null;

// Used to attach event listeners once when multiple ng-apps are running.
var isInitialized = false;

angular
  .module('material.core.gestures', [ ])
  .provider('$mdGesture', MdGestureProvider)
  .factory('$$MdGestureHandler', MdGestureHandler)
  .run(attachToDocument );

/**
   * @ngdoc service
   * @name $mdGestureProvider
   * @module material.core.gestures
   *
   * @description
   * In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked.
   * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
   * devices.
   * You can also change max click distance (6px by default) if you have issues on some touch screens.
   *
   * <hljs lang="js">
   *   app.config(function($mdGestureProvider) {
   *
   *     // For mobile devices without jQuery loaded, do not
   *     // intercept click events during the capture phase.
   *     $mdGestureProvider.skipClickHijack();
   *
   *     // If hijcacking clicks, change default 6px click distance
   *     $mdGestureProvider.setMaxClickDistance(12);
   *
   *   });
   * </hljs>
   *
   */
function MdGestureProvider() { }

MdGestureProvider.prototype = {

  // Publish access to setter to configure a variable  BEFORE the
  // $mdGesture service is instantiated...
  skipClickHijack: function() {
    return forceSkipClickHijack = true;
  },

  setMaxClickDistance: function(clickDistance) {
    maxClickDistance = parseInt(clickDistance);
  },

  /**
   * $get is used to build an instance of $mdGesture
   * @ngInject
   */
  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", function($$MdGestureHandler, $$rAF, $timeout) {
       return new MdGesture($$MdGestureHandler, $$rAF, $timeout);
  }]
};



/**
 * MdGesture factory construction function
 * @ngInject
 */
function MdGesture($$MdGestureHandler, $$rAF, $timeout) {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isIos = userAgent.match(/ipad|iphone|ipod/i);
  var isAndroid = userAgent.match(/android/i);
  var touchActionProperty = getTouchAction();
  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

  var self = {
    handler: addHandler,
    register: register,
    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
    isHijackingClicks: (isIos || isAndroid) && !hasJQuery && !forceSkipClickHijack
  };

  if (self.isHijackingClicks) {
    self.handler('click', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: checkDistanceAndEmit('click')
    });

    self.handler('focus', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: function(ev, pointer) {
        if (pointer.distance < this.state.options.maxDistance && canFocus(ev.target)) {
          this.dispatchEvent(ev, 'focus', pointer);
          ev.target.focus();
        }
      }
    });

    self.handler('mouseup', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: checkDistanceAndEmit('mouseup')
    });

    self.handler('mousedown', {
      onStart: function(ev) {
        this.dispatchEvent(ev, 'mousedown');
      }
    });
  }

  function checkDistanceAndEmit(eventName) {
    return function(ev, pointer) {
      if (pointer.distance < this.state.options.maxDistance) {
        this.dispatchEvent(ev, eventName, pointer);
      }
    };
  }

  /*
   * Register an element to listen for a handler.
   * This allows an element to override the default options for a handler.
   * Additionally, some handlers like drag and hold only dispatch events if
   * the domEvent happens inside an element that's registered to listen for these events.
   *
   * @see GestureHandler for how overriding of default options works.
   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horziontal: false })
   */
  function register(element, handlerName, options) {
    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
    if (!handler) {
      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
    }
    return handler.registerElement(element, options);
  }

  /*
   * add a handler to $mdGesture. see below.
   */
  function addHandler(name, definition) {
    var handler = new $$MdGestureHandler(name);
    angular.extend(handler, definition);
    HANDLERS[name] = handler;

    return self;
  }

  /*
   * Register handlers. These listen to touch/start/move events, interpret them,
   * and dispatch gesture events depending on options & conditions. These are all
   * instances of GestureHandler.
   * @see GestureHandler
   */
  return self
    /*
     * The press handler dispatches an event on touchdown/touchend.
     * It's a simple abstraction of touch/mouse/pointer start and end.
     */
    .handler('press', {
      onStart: function (ev, pointer) {
        this.dispatchEvent(ev, '$md.pressdown');
      },
      onEnd: function (ev, pointer) {
        this.dispatchEvent(ev, '$md.pressup');
      }
    })

    /*
     * The hold handler dispatches an event if the user keeps their finger within
     * the same <maxDistance> area for <delay> ms.
     * The hold handler will only run if a parent of the touch target is registered
     * to listen for hold events through $mdGesture.register()
     */
    .handler('hold', {
      options: {
        maxDistance: 6,
        delay: 500
      },
      onCancel: function () {
        $timeout.cancel(this.state.timeout);
      },
      onStart: function (ev, pointer) {
        // For hold, require a parent to be registered with $mdGesture.register()
        // Because we prevent scroll events, this is necessary.
        if (!this.state.registeredParent) return this.cancel();

        this.state.pos = {x: pointer.x, y: pointer.y};
        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
          this.dispatchEvent(ev, '$md.hold');
          this.cancel(); //we're done!
        }), this.state.options.delay, false);
      },
      onMove: function (ev, pointer) {
        // Don't scroll while waiting for hold.
        // If we don't preventDefault touchmove events here, Android will assume we don't
        // want to listen to anymore touch events. It will start scrolling and stop sending
        // touchmove events.
        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();

        // If the user moves greater than <maxDistance> pixels, stop the hold timer
        // set in onStart
        var dx = this.state.pos.x - pointer.x;
        var dy = this.state.pos.y - pointer.y;
        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
          this.cancel();
        }
      },
      onEnd: function () {
        this.onCancel();
      }
    })

    /*
     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
     * <minDistance> px in the x or y direction, depending on options.horizontal.
     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
     * pixels vertically, this handler won't consider the move part of a drag.
     */
    .handler('drag', {
      options: {
        minDistance: 6,
        horizontal: true,
        cancelMultiplier: 1.5
      },
      onSetup: function(element, options) {
        if (touchActionProperty) {
          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
          this.oldTouchAction = element[0].style[touchActionProperty];
          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
        }
      },
      onCleanup: function(element) {
        if (this.oldTouchAction) {
          element[0].style[touchActionProperty] = this.oldTouchAction;
        }
      },
      onStart: function (ev) {
        // For drag, require a parent to be registered with $mdGesture.register()
        if (!this.state.registeredParent) this.cancel();
      },
      onMove: function (ev, pointer) {
        var shouldStartDrag, shouldCancel;
        // Don't scroll while deciding if this touchmove qualifies as a drag event.
        // If we don't preventDefault touchmove events here, Android will assume we don't
        // want to listen to anymore touch events. It will start scrolling and stop sending
        // touchmove events.
        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();

        if (!this.state.dragPointer) {
          if (this.state.options.horizontal) {
            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
          } else {
            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
          }

          if (shouldStartDrag) {
            // Create a new pointer representing this drag, starting at this point where the drag started.
            this.state.dragPointer = makeStartPointer(ev);
            updatePointerState(ev, this.state.dragPointer);
            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);

          } else if (shouldCancel) {
            this.cancel();
          }
        } else {
          this.dispatchDragMove(ev);
        }
      },
      // Only dispatch dragmove events every frame; any more is unnecessary
      dispatchDragMove: $$rAF.throttle(function (ev) {
        // Make sure the drag didn't stop while waiting for the next frame
        if (this.state.isRunning) {
          updatePointerState(ev, this.state.dragPointer);
          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
        }
      }),
      onEnd: function (ev, pointer) {
        if (this.state.dragPointer) {
          updatePointerState(ev, this.state.dragPointer);
          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
        }
      }
    })

    /*
     * The swipe handler will dispatch a swipe event if, on the end of a touch,
     * the velocity and distance were high enough.
     */
    .handler('swipe', {
      options: {
        minVelocity: 0.65,
        minDistance: 10
      },
      onEnd: function (ev, pointer) {
        var eventType;

        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
          this.dispatchEvent(ev, eventType);
        }
        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
          this.dispatchEvent(ev, eventType);
        }
      }
    });

  function getTouchAction() {
    var testEl = document.createElement('div');
    var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];

    for (var i = 0; i < vendorPrefixes.length; i++) {
      var prefix = vendorPrefixes[i];
      var property = prefix ? prefix + 'TouchAction' : 'touchAction';
      if (angular.isDefined(testEl.style[property])) {
        return property;
      }
    }
  }

}

/**
 * MdGestureHandler
 * A GestureHandler is an object which is able to dispatch custom dom events
 * based on native dom {touch,pointer,mouse}{start,move,end} events.
 *
 * A gesture will manage its lifecycle through the start,move,end, and cancel
 * functions, which are called by native dom events.
 *
 * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
 * overridden by elements registering through $mdGesture.register()
 */
function GestureHandler (name) {
  this.name = name;
  this.state = {};
}

function MdGestureHandler() {
  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

  GestureHandler.prototype = {
    options: {},
    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
    // differently when jQuery is loaded
    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,

    // These are overridden by the registered handler
    onSetup: angular.noop,
    onCleanup: angular.noop,
    onStart: angular.noop,
    onMove: angular.noop,
    onEnd: angular.noop,
    onCancel: angular.noop,

    // onStart sets up a new state for the handler, which includes options from the
    // nearest registered parent element of ev.target.
    start: function (ev, pointer) {
      if (this.state.isRunning) return;
      var parentTarget = this.getNearestParent(ev.target);
      // Get the options from the nearest registered parent
      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};

      this.state = {
        isRunning: true,
        // Override the default options with the nearest registered parent's options
        options: angular.extend({}, this.options, parentTargetOptions),
        // Pass in the registered parent node to the state so the onStart listener can use
        registeredParent: parentTarget
      };
      this.onStart(ev, pointer);
    },
    move: function (ev, pointer) {
      if (!this.state.isRunning) return;
      this.onMove(ev, pointer);
    },
    end: function (ev, pointer) {
      if (!this.state.isRunning) return;
      this.onEnd(ev, pointer);
      this.state.isRunning = false;
    },
    cancel: function (ev, pointer) {
      this.onCancel(ev, pointer);
      this.state = {};
    },

    // Find and return the nearest parent element that has been registered to
    // listen for this handler via $mdGesture.register(element, 'handlerName').
    getNearestParent: function (node) {
      var current = node;
      while (current) {
        if ((current.$mdGesture || {})[this.name]) {
          return current;
        }
        current = current.parentNode;
      }
      return null;
    },

    // Called from $mdGesture.register when an element registers itself with a handler.
    // Store the options the user gave on the DOMElement itself. These options will
    // be retrieved with getNearestParent when the handler starts.
    registerElement: function (element, options) {
      var self = this;
      element[0].$mdGesture = element[0].$mdGesture || {};
      element[0].$mdGesture[this.name] = options || {};
      element.on('$destroy', onDestroy);

      self.onSetup(element, options || {});

      return onDestroy;

      function onDestroy() {
        delete element[0].$mdGesture[self.name];
        element.off('$destroy', onDestroy);

        self.onCleanup(element, options || {});
      }
    }
  };

  return GestureHandler;

  /*
   * Dispatch an event with jQuery
   * TODO: Make sure this sends bubbling events
   *
   * @param srcEvent the original DOM touch event that started this.
   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
   * @param eventPointer the pointer object that matches this event.
   */
  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
    eventPointer = eventPointer || pointer;
    var eventObj = new angular.element.Event(eventType);

    eventObj.$material = true;
    eventObj.pointer = eventPointer;
    eventObj.srcEvent = srcEvent;

    angular.extend(eventObj, {
      clientX: eventPointer.x,
      clientY: eventPointer.y,
      screenX: eventPointer.x,
      screenY: eventPointer.y,
      pageX: eventPointer.x,
      pageY: eventPointer.y,
      ctrlKey: srcEvent.ctrlKey,
      altKey: srcEvent.altKey,
      shiftKey: srcEvent.shiftKey,
      metaKey: srcEvent.metaKey
    });
    angular.element(eventPointer.target).trigger(eventObj);
  }

  /*
   * NOTE: nativeDispatchEvent is very performance sensitive.
   * @param srcEvent the original DOM touch event that started this.
   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
   * @param eventPointer the pointer object that matches this event.
   */
  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
    eventPointer = eventPointer || pointer;
    var eventObj;

    if (eventType === 'click' || eventType == 'mouseup' || eventType == 'mousedown' ) {
      eventObj = document.createEvent('MouseEvents');
      eventObj.initMouseEvent(
        eventType, true, true, window, srcEvent.detail,
        eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
        srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
        srcEvent.button, srcEvent.relatedTarget || null
      );

    } else {
      eventObj = document.createEvent('CustomEvent');
      eventObj.initCustomEvent(eventType, true, true, {});
    }
    eventObj.$material = true;
    eventObj.pointer = eventPointer;
    eventObj.srcEvent = srcEvent;
    eventPointer.target.dispatchEvent(eventObj);
  }

}

/**
 * Attach Gestures: hook document and check shouldHijack clicks
 * @ngInject
 */
function attachToDocument( $mdGesture, $$MdGestureHandler ) {

  // Polyfill document.contains for IE11.
  // TODO: move to util
  document.contains || (document.contains = function (node) {
    return document.body.contains(node);
  });

  if (!isInitialized && $mdGesture.isHijackingClicks ) {
    /*
     * If hijack clicks is true, we preventDefault any click that wasn't
     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
     * click event will be sent ~400ms after a touchend event happens.
     * The only way to know if this click is real is to prevent any normal
     * click events, and add a flag to events sent by material so we know not to prevent those.
     *
     * Two exceptions to click events that should be prevented are:
     *  - click events sent by the keyboard (eg form submit)
     *  - events that originate from an Ionic app
     */
    document.addEventListener('click'    , clickHijacker     , true);
    document.addEventListener('mouseup'  , mouseInputHijacker, true);
    document.addEventListener('mousedown', mouseInputHijacker, true);
    document.addEventListener('focus'    , mouseInputHijacker, true);

    isInitialized = true;
  }

  function mouseInputHijacker(ev) {
    var isKeyClick = !ev.clientX && !ev.clientY;

    if (
      !isKeyClick &&
      !ev.$material &&
      !ev.isIonicTap &&
      !isInputEventFromLabelClick(ev) &&
      (ev.type !== 'mousedown' || (!canFocus(ev.target) && !canFocus(document.activeElement)))
    ) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  function clickHijacker(ev) {
    var isKeyClick = ev.clientX === 0 && ev.clientY === 0;
    var isSubmitEvent = ev.target && ev.target.type === 'submit';
    if (!isKeyClick && !ev.$material && !ev.isIonicTap
      && !isInputEventFromLabelClick(ev)
      && !isSubmitEvent) {
      ev.preventDefault();
      ev.stopPropagation();
      lastLabelClickPos = null;
    } else {
      lastLabelClickPos = null;
      if (ev.target.tagName.toLowerCase() == 'label') {
        lastLabelClickPos = {x: ev.x, y: ev.y};
      }
    }
  }


  // Listen to all events to cover all platforms.
  var START_EVENTS = 'mousedown touchstart pointerdown';
  var MOVE_EVENTS = 'mousemove touchmove pointermove';
  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';

  angular.element(document)
    .on(START_EVENTS, gestureStart)
    .on(MOVE_EVENTS, gestureMove)
    .on(END_EVENTS, gestureEnd)
    // For testing
    .on('$$mdGestureReset', function gestureClearCache () {
      lastPointer = pointer = null;
    });

  /*
   * When a DOM event happens, run all registered gesture handlers' lifecycle
   * methods which match the DOM event.
   * Eg when a 'touchstart' event happens, runHandlers('start') will call and
   * run `handler.cancel()` and `handler.start()` on all registered handlers.
   */
  function runHandlers(handlerEvent, event) {
    var handler;
    for (var name in HANDLERS) {
      handler = HANDLERS[name];
      if( handler instanceof $$MdGestureHandler ) {

        if (handlerEvent === 'start') {
          // Run cancel to reset any handlers' state
          handler.cancel();
        }
        handler[handlerEvent](event, pointer);

      }
    }
  }

  /*
   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
   * won't effect it.
   */
  function gestureStart(ev) {
    // If we're already touched down, abort
    if (pointer) return;

    var now = +Date.now();

    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
    // If <400ms have passed, don't allow an event of a different type than the previous event
    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
      return;
    }

    pointer = makeStartPointer(ev);

    runHandlers('start', ev);
  }
  /*
   * If a move event happens of the right type, update the pointer and run all the move handlers.
   * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
   */
  function gestureMove(ev) {
    if (!pointer || !typesMatch(ev, pointer)) return;

    updatePointerState(ev, pointer);
    runHandlers('move', ev);
  }
  /*
   * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
   */
  function gestureEnd(ev) {
    if (!pointer || !typesMatch(ev, pointer)) return;

    updatePointerState(ev, pointer);
    pointer.endTime = +Date.now();

    if (ev.type !== 'pointercancel') {
      runHandlers('end', ev);
    }

    lastPointer = pointer;
    pointer = null;
  }

}

// ********************
// Module Functions
// ********************

/*
 * Initiate the pointer. x, y, and the pointer's type.
 */
function makeStartPointer(ev) {
  var point = getEventPoint(ev);
  var startPointer = {
    startTime: +Date.now(),
    target: ev.target,
    // 'p' for pointer events, 'm' for mouse, 't' for touch
    type: ev.type.charAt(0)
  };
  startPointer.startX = startPointer.x = point.pageX;
  startPointer.startY = startPointer.y = point.pageY;
  return startPointer;
}

/*
 * return whether the pointer's type matches the event's type.
 * Eg if a touch event happens but the pointer has a mouse type, return false.
 */
function typesMatch(ev, pointer) {
  return ev && pointer && ev.type.charAt(0) === pointer.type;
}

/**
 * Gets whether the given event is an input event that was caused by clicking on an
 * associated label element.
 *
 * This is necessary because the browser will, upon clicking on a label element, fire an
 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
 * click as with `$material` correctly, but not the second input click.
 *
 * In order to determine whether an input event is from a label click, we compare the (x, y) for
 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
 * click occurs). Unfortunately, there are no event properties that tie the input and the label
 * together (such as relatedTarget).
 *
 * @param {MouseEvent} event
 * @returns {boolean}
 */
function isInputEventFromLabelClick(event) {
  return lastLabelClickPos
      && lastLabelClickPos.x == event.x
      && lastLabelClickPos.y == event.y;
}

/*
 * Update the given pointer based upon the given DOMEvent.
 * Distance, velocity, direction, duration, etc
 */
function updatePointerState(ev, pointer) {
  var point = getEventPoint(ev);
  var x = pointer.x = point.pageX;
  var y = pointer.y = point.pageY;

  pointer.distanceX = x - pointer.startX;
  pointer.distanceY = y - pointer.startY;
  pointer.distance = Math.sqrt(
    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
  );

  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';

  pointer.duration = +Date.now() - pointer.startTime;
  pointer.velocityX = pointer.distanceX / pointer.duration;
  pointer.velocityY = pointer.distanceY / pointer.duration;
}

/*
 * Normalize the point where the DOM event happened whether it's touch or mouse.
 * @returns point event obj with pageX and pageY on it.
 */
function getEventPoint(ev) {
  ev = ev.originalEvent || ev; // support jQuery events
  return (ev.touches && ev.touches[0]) ||
    (ev.changedTouches && ev.changedTouches[0]) ||
    ev;
}

/** Checks whether an element can be focused. */
function canFocus(element) {
  return (
    !!element &&
    element.getAttribute('tabindex') != '-1' &&
    !element.hasAttribute('disabled') &&
    (
      element.hasAttribute('tabindex') ||
      element.hasAttribute('href') ||
      element.isContentEditable ||
      ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'].indexOf(element.nodeName) != -1
    )
  );
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.interaction
 * @description
 * User interaction detection to provide proper accessibility.
 */
MdInteractionService.$inject = ["$timeout", "$mdUtil"];
angular
  .module('material.core.interaction', [])
  .service('$mdInteraction', MdInteractionService);


/**
 * @ngdoc service
 * @name $mdInteraction
 * @module material.core.interaction
 *
 * @description
 *
 * Service which keeps track of the last interaction type and validates them for several browsers.
 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
 *
 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
 *
 * Here is an example markup for using the interaction service.
 *
 * <hljs lang="js">
 *   var lastType = $mdInteraction.getLastInteractionType();
 *
 *   if (lastType === 'keyboard') {
 *     // We only restore the focus for keyboard users.
 *     restoreFocus();
 *   }
 * </hljs>
 *
 */
function MdInteractionService($timeout, $mdUtil) {
  this.$timeout = $timeout;
  this.$mdUtil = $mdUtil;

  this.bodyElement = angular.element(document.body);
  this.isBuffering = false;
  this.bufferTimeout = null;
  this.lastInteractionType = null;
  this.lastInteractionTime = null;

  // Type Mappings for the different events
  // There will be three three interaction types
  // `keyboard`, `mouse` and `touch`
  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
  this.inputEventMap = {
    'keydown': 'keyboard',
    'mousedown': 'mouse',
    'mouseenter': 'mouse',
    'touchstart': 'touch',
    'pointerdown': 'pointer',
    'MSPointerDown': 'pointer'
  };

  // IE PointerDown events will be validated in `touch` or `mouse`
  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
  this.iePointerMap = {
    2: 'touch',
    3: 'touch',
    4: 'mouse'
  };

  this.initializeEvents();
}

/**
 * Initializes the interaction service, by registering all interaction events to the
 * body element.
 */
MdInteractionService.prototype.initializeEvents = function() {
  // IE browsers can also trigger pointer events, which also leads to an interaction.
  var pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;

  this.bodyElement.on('keydown mousedown', this.onInputEvent.bind(this));

  if ('ontouchstart' in document.documentElement) {
    this.bodyElement.on('touchstart', this.onBufferInputEvent.bind(this));
  }

  if (pointerEvent) {
    this.bodyElement.on(pointerEvent, this.onInputEvent.bind(this));
  }

};

/**
 * Event listener for normal interaction events, which should be tracked.
 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
 */
MdInteractionService.prototype.onInputEvent = function(event) {
  if (this.isBuffering) {
    return;
  }

  var type = this.inputEventMap[event.type];

  if (type === 'pointer') {
    type = this.iePointerMap[event.pointerType] || event.pointerType;
  }

  this.lastInteractionType = type;
  this.lastInteractionTime = this.$mdUtil.now();
};

/**
 * Event listener for interaction events which should be buffered (touch events).
 * @param event {TouchEvent}
 */
MdInteractionService.prototype.onBufferInputEvent = function(event) {
  this.$timeout.cancel(this.bufferTimeout);

  this.onInputEvent(event);
  this.isBuffering = true;

  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
  // the `onInput` function multiple times.
  this.bufferTimeout = this.$timeout(function() {
    this.isBuffering = false;
  }.bind(this), 650, false);

};

/**
 * @ngdoc method
 * @name $mdInteraction#getLastInteractionType
 * @description Retrieves the last interaction type triggered in body.
 * @returns {string|null} Last interaction type.
 */
MdInteractionService.prototype.getLastInteractionType = function() {
  return this.lastInteractionType;
};

/**
 * @ngdoc method
 * @name $mdInteraction#isUserInvoked
 * @description Method to detect whether any interaction happened recently or not.
 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
 * @returns {boolean} Whether there was any interaction or not.
 */
MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;

  // Check for any interaction to be within the specified check time.
  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
};

})();
(function(){
"use strict";

angular.module('material.core')
  .provider('$$interimElement', InterimElementProvider);

/*
 * @ngdoc service
 * @name $$interimElement
 * @module material.core
 *
 * @description
 *
 * Factory that contructs `$$interimElement.$service` services.
 * Used internally in material design for elements that appear on screen temporarily.
 * The service provides a promise-like API for interacting with the temporary
 * elements.
 *
 * ```js
 * app.service('$mdToast', function($$interimElement) {
 *   var $mdToast = $$interimElement(toastDefaultOptions);
 *   return $mdToast;
 * });
 * ```
 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
 *
 * @returns {$$interimElement.$service}
 *
 */

function InterimElementProvider() {
  InterimElementFactory.$inject = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
  createInterimElementProvider.$get = InterimElementFactory;
  return createInterimElementProvider;

  /**
   * Returns a new provider which allows configuration of a new interimElement
   * service. Allows configuration of default options & methods for options,
   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
   */
  function createInterimElementProvider(interimFactoryName) {
    factory.$inject = ["$$interimElement", "$injector"];
    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];

    var customMethods = {};
    var providerConfig = {
      presets: {}
    };

    var provider = {
      setDefaults: setDefaults,
      addPreset: addPreset,
      addMethod: addMethod,
      $get: factory
    };

    /**
     * all interim elements will come with the 'build' preset
     */
    provider.addPreset('build', {
      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
    });

    return provider;

    /**
     * Save the configured defaults to be used when the factory is instantiated
     */
    function setDefaults(definition) {
      providerConfig.optionsFactory = definition.options;
      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
      return provider;
    }

    /**
     * Add a method to the factory that isn't specific to any interim element operations
     */

    function addMethod(name, fn) {
      customMethods[name] = fn;
      return provider;
    }

    /**
     * Save the configured preset to be used when the factory is instantiated
     */
    function addPreset(name, definition) {
      definition = definition || {};
      definition.methods = definition.methods || [];
      definition.options = definition.options || function() { return {}; };

      if (/^cancel|hide|show$/.test(name)) {
        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
      }
      if (definition.methods.indexOf('_options') > -1) {
        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
      }
      providerConfig.presets[name] = {
        methods: definition.methods.concat(EXPOSED_METHODS),
        optionsFactory: definition.options,
        argOption: definition.argOption
      };
      return provider;
    }

    function addPresetMethod(presetName, methodName, method) {
      providerConfig.presets[presetName][methodName] = method;
    }

    /**
     * Create a factory that has the given methods & defaults implementing interimElement
     */
    /* @ngInject */
    function factory($$interimElement, $injector) {
      var defaultMethods;
      var defaultOptions;
      var interimElementService = $$interimElement();

      /*
       * publicService is what the developer will be using.
       * It has methods hide(), cancel(), show(), build(), and any other
       * presets which were set during the config phase.
       */
      var publicService = {
        hide: interimElementService.hide,
        cancel: interimElementService.cancel,
        show: showInterimElement,

        // Special internal method to destroy an interim element without animations
        // used when navigation changes causes a $scope.$destroy() action
        destroy : destroyInterimElement
      };


      defaultMethods = providerConfig.methods || [];
      // This must be invoked after the publicService is initialized
      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});

      // Copy over the simple custom methods
      angular.forEach(customMethods, function(fn, name) {
        publicService[name] = fn;
      });

      angular.forEach(providerConfig.presets, function(definition, name) {
        var presetDefaults = invokeFactory(definition.optionsFactory, {});
        var presetMethods = (definition.methods || []).concat(defaultMethods);

        // Every interimElement built with a preset has a field called `$type`,
        // which matches the name of the preset.
        // Eg in preset 'confirm', options.$type === 'confirm'
        angular.extend(presetDefaults, { $type: name });

        // This creates a preset class which has setter methods for every
        // method given in the `.addPreset()` function, as well as every
        // method given in the `.setDefaults()` function.
        //
        // @example
        // .setDefaults({
        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
        //   options: dialogDefaultOptions
        // })
        // .addPreset('alert', {
        //   methods: ['title', 'ok'],
        //   options: alertDialogOptions
        // })
        //
        // Set values will be passed to the options when interimElement.show() is called.
        function Preset(opts) {
          this._options = angular.extend({}, presetDefaults, opts);
        }
        angular.forEach(presetMethods, function(name) {
          Preset.prototype[name] = function(value) {
            this._options[name] = value;
            return this;
          };
        });

        // Create shortcut method for one-linear methods
        if (definition.argOption) {
          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
          publicService[methodName] = function(arg) {
            var config = publicService[name](arg);
            return publicService.show(config);
          };
        }

        // eg $mdDialog.alert() will return a new alert preset
        publicService[name] = function(arg) {
          // If argOption is supplied, eg `argOption: 'content'`, then we assume
          // if the argument is not an options object then it is the `argOption` option.
          //
          // @example `$mdToast.simple('hello')` // sets options.content to hello
          //                                     // because argOption === 'content'
          if (arguments.length && definition.argOption &&
              !angular.isObject(arg) && !angular.isArray(arg))  {

            return (new Preset())[definition.argOption](arg);

          } else {
            return new Preset(arg);
          }

        };
      });

      return publicService;

      /**
       *
       */
      function showInterimElement(opts) {
        // opts is either a preset which stores its options on an _options field,
        // or just an object made up of options
        opts = opts || { };
        if (opts._options) opts = opts._options;

        return interimElementService.show(
          angular.extend({}, defaultOptions, opts)
        );
      }

      /**
       *  Special method to hide and destroy an interimElement WITHOUT
       *  any 'leave` or hide animations ( an immediate force hide/remove )
       *
       *  NOTE: This calls the onRemove() subclass method for each component...
       *  which must have code to respond to `options.$destroy == true`
       */
      function destroyInterimElement(opts) {
          return interimElementService.destroy(opts);
      }

      /**
       * Helper to call $injector.invoke with a local of the factory name for
       * this provider.
       * If an $mdDialog is providing options for a dialog and tries to inject
       * $mdDialog, a circular dependency error will happen.
       * We get around that by manually injecting $mdDialog as a local.
       */
      function invokeFactory(factory, defaultVal) {
        var locals = {};
        locals[interimFactoryName] = publicService;
        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
      }

    }

  }

  /* @ngInject */
  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
    return function createInterimElementService() {
      var SHOW_CANCELLED = false;

      /*
       * @ngdoc service
       * @name $$interimElement.$service
       *
       * @description
       * A service used to control inserting and removing an element into the DOM.
       *
       */

      var service;

      var showPromises = []; // Promises for the interim's which are currently opening.
      var hidePromises = []; // Promises for the interim's which are currently hiding.
      var showingInterims = []; // Interim elements which are currently showing up.

      // Publish instance $$interimElement service;
      // ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect

      return service = {
        show: show,
        hide: waitForInterim(hide),
        cancel: waitForInterim(cancel),
        destroy : destroy,
        $injector_: $injector
      };

      /*
       * @ngdoc method
       * @name $$interimElement.$service#show
       * @kind function
       *
       * @description
       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
       * with hide or cancel, respectively. To external cancel/hide, developers should use the
       *
       * @param {*} options is hashMap of settings
       * @returns a Promise
       *
       */
      function show(options) {
        options = options || {};
        var interimElement = new InterimElement(options || {});

        // When an interim element is currently showing, we have to cancel it.
        // Just hiding it, will resolve the InterimElement's promise, the promise should be
        // rejected instead.
        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);

        if (!options.multiple) {
          // Wait for all opening interim's to finish their transition.
          hideAction = hideAction.then(function() {
            // Wait for all closing and showing interim's to be completely closed.
            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
            return $q.all(promiseArray);
          });
        }

        var showAction = hideAction.then(function() {

          return interimElement
            .show()
            .catch(function(reason) { return reason; })
            .finally(function() {
              showPromises.splice(showPromises.indexOf(showAction), 1);
              showingInterims.push(interimElement);
            });

        });

        showPromises.push(showAction);

        // In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
        // the rejection and only log it if it's an error.
        interimElement.deferred.promise.catch(function(fault) {
          if (fault instanceof Error) {
            $exceptionHandler(fault);
          }

          return fault;
        });

        // Return a promise that will be resolved when the interim
        // element is hidden or cancelled...
        return interimElement.deferred.promise;
      }

      /*
       * @ngdoc method
       * @name $$interimElement.$service#hide
       * @kind function
       *
       * @description
       * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
       *
       * @param {*} resolveParam Data to resolve the promise with
       * @returns a Promise that will be resolved after the element has been removed.
       *
       */
      function hide(reason, options) {
        options = options || {};

        if (options.closeAll) {
          // We have to make a shallow copy of the array, because otherwise the map will break.
          return $q.all(showingInterims.slice().reverse().map(closeElement));
        } else if (options.closeTo !== undefined) {
          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
        }

        // Hide the latest showing interim element.
        return closeElement(showingInterims[showingInterims.length - 1]);

        function closeElement(interim) {

          var hideAction = interim
            .remove(reason, false, options || { })
            .catch(function(reason) { return reason; })
            .finally(function() {
              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
            });

          showingInterims.splice(showingInterims.indexOf(interim), 1);
          hidePromises.push(hideAction);

          return interim.deferred.promise;
        }
      }

      /*
       * @ngdoc method
       * @name $$interimElement.$service#cancel
       * @kind function
       *
       * @description
       * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
       *
       * @param {*} reason Data to reject the promise with
       * @returns Promise that will be resolved after the element has been removed.
       *
       */
      function cancel(reason, options) {
        var interim = showingInterims.pop();
        if (!interim) {
          return $q.when(reason);
        }

        var cancelAction = interim
          .remove(reason, true, options || {})
          .catch(function(reason) { return reason; })
          .finally(function() {
            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
          });

        hidePromises.push(cancelAction);

        // Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
        // promise from being logged to the $exceptionHandler.
        return interim.deferred.promise.catch(angular.noop);
      }

      /**
       * Creates a function to wait for at least one interim element to be available.
       * @param callbackFn Function to be used as callback
       * @returns {Function}
       */
      function waitForInterim(callbackFn) {
        return function() {
          var fnArguments = arguments;

          if (!showingInterims.length) {
            // When there are still interim's opening, then wait for the first interim element to
            // finish its open animation.
            if (showPromises.length) {
              return showPromises[0].finally(function () {
                return callbackFn.apply(service, fnArguments);
              });
            }

            return $q.when("No interim elements currently showing up.");
          }

          return callbackFn.apply(service, fnArguments);
        };
      }

      /*
       * Special method to quick-remove the interim element without animations
       * Note: interim elements are in "interim containers"
       */
      function destroy(targetEl) {
        var interim = !targetEl ? showingInterims.shift() : null;

        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;

        if (parentEl) {
          // Try to find the interim in the stack which corresponds to the supplied DOM element.
          var filtered = showingInterims.filter(function(entry) {
            return entry.options.element[0] === parentEl;
          });

          // Note: This function might be called when the element already has been removed,
          // in which case we won't find any matches.
          if (filtered.length) {
            interim = filtered[0];
            showingInterims.splice(showingInterims.indexOf(interim), 1);
          }
        }

        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
                         $q.when(SHOW_CANCELLED);
      }

      /*
       * Internal Interim Element Object
       * Used internally to manage the DOM element and related data
       */
      function InterimElement(options) {
        var self, element, showAction = $q.when(true);

        options = configureScopeAndTransitions(options);

        return self = {
          options : options,
          deferred: $q.defer(),
          show    : createAndTransitionIn,
          remove  : transitionOutAndRemove
        };

        /**
         * Compile, link, and show this interim element
         * Use optional autoHided and transition-in effects
         */
        function createAndTransitionIn() {
          return $q(function(resolve, reject) {

            // Trigger onCompiling callback before the compilation starts.
            // This is useful, when modifying options, which can be influenced by developers.
            options.onCompiling && options.onCompiling(options);

            compileElement(options)
              .then(function( compiledData ) {
                element = linkElement( compiledData, options );

                // Expose the cleanup function from the compiler.
                options.cleanupElement = compiledData.cleanup;

                showAction = showElement(element, options, compiledData.controller)
                  .then(resolve, rejectAll);
              }).catch(rejectAll);

            function rejectAll(fault) {
              // Force the '$md<xxx>.show()' promise to reject
              self.deferred.reject(fault);

              // Continue rejection propagation
              reject(fault);
            }
          });
        }

        /**
         * After the show process has finished/rejected:
         * - announce 'removing',
         * - perform the transition-out, and
         * - perform optional clean up scope.
         */
        function transitionOutAndRemove(response, isCancelled, opts) {

          // abort if the show() and compile failed
          if ( !element ) return $q.when(false);

          options = angular.extend(options || {}, opts || {});
          options.cancelAutoHide && options.cancelAutoHide();
          options.element.triggerHandler('$mdInterimElementRemove');

          if ( options.$destroy === true ) {

            return hideElement(options.element, options).then(function(){
              (isCancelled && rejectAll(response)) || resolveAll(response);
            });

          } else {
            $q.when(showAction).finally(function() {
              hideElement(options.element, options).then(function() {
                isCancelled ? rejectAll(response) : resolveAll(response);
              }, rejectAll);
            });

            return self.deferred.promise;
          }


          /**
           * The `show()` returns a promise that will be resolved when the interim
           * element is hidden or cancelled...
           */
          function resolveAll(response) {
            self.deferred.resolve(response);
          }

          /**
           * Force the '$md<xxx>.show()' promise to reject
           */
          function rejectAll(fault) {
            self.deferred.reject(fault);
          }
        }

        /**
         * Prepare optional isolated scope and prepare $animate with default enter and leave
         * transitions for the new element instance.
         */
        function configureScopeAndTransitions(options) {
          options = options || { };
          if ( options.template ) {
            options.template = $mdUtil.processTemplate(options.template);
          }

          return angular.extend({
            preserveScope: false,
            cancelAutoHide : angular.noop,
            scope: options.scope || $rootScope.$new(options.isolateScope),

            /**
             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
             */
            onShow: function transitionIn(scope, element, options) {
              return $animate.enter(element, options.parent);
            },

            /**
             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
             */
            onRemove: function transitionOut(scope, element) {
              // Element could be undefined if a new element is shown before
              // the old one finishes compiling.
              return element && $animate.leave(element) || $q.when();
            }
          }, options );

        }

        /**
         * Compile an element with a templateUrl, controller, and locals
         */
        function compileElement(options) {

          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;

          return compiled || $q(function (resolve) {
              resolve({
                locals: {},
                link: function () {
                  return options.element;
                }
              });
            });
        }

        /**
         *  Link an element with compiled configuration
         */
        function linkElement(compileData, options){
          angular.extend(compileData.locals, options);

          var element = compileData.link(options.scope);

          // Search for parent at insertion time, if not specified
          options.element = element;
          options.parent = findParent(element, options);
          if (options.themable) $mdTheming(element);

          return element;
        }

        /**
         * Search for parent at insertion time, if not specified
         */
        function findParent(element, options) {
          var parent = options.parent;

          // Search for parent at insertion time, if not specified
          if (angular.isFunction(parent)) {
            parent = parent(options.scope, element, options);
          } else if (angular.isString(parent)) {
            parent = angular.element($document[0].querySelector(parent));
          } else {
            parent = angular.element(parent);
          }

          // If parent querySelector/getter function fails, or it's just null,
          // find a default.
          if (!(parent || {}).length) {
            var el;
            if ($rootElement[0] && $rootElement[0].querySelector) {
              el = $rootElement[0].querySelector(':not(svg) > body');
            }
            if (!el) el = $rootElement[0];
            if (el.nodeName == '#comment') {
              el = $document[0].body;
            }
            return angular.element(el);
          }

          return parent;
        }

        /**
         * If auto-hide is enabled, start timer and prepare cancel function
         */
        function startAutoHide() {
          var autoHideTimer, cancelAutoHide = angular.noop;

          if (options.hideDelay) {
            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
            cancelAutoHide = function() {
              $timeout.cancel(autoHideTimer);
            };
          }

          // Cache for subsequent use
          options.cancelAutoHide = function() {
            cancelAutoHide();
            options.cancelAutoHide = undefined;
          };
        }

        /**
         * Show the element ( with transitions), notify complete and start
         * optional auto-Hide
         */
        function showElement(element, options, controller) {
          // Trigger onShowing callback before the `show()` starts
          var notifyShowing = options.onShowing || angular.noop;
          // Trigger onComplete callback when the `show()` finishes
          var notifyComplete = options.onComplete || angular.noop;

          // Necessary for consistency between AngularJS 1.5 and 1.6.
          try {
            notifyShowing(options.scope, element, options, controller);
          } catch (e) {
            return $q.reject(e);
          }

          return $q(function (resolve, reject) {
            try {
              // Start transitionIn
              $q.when(options.onShow(options.scope, element, options, controller))
                .then(function () {
                  notifyComplete(options.scope, element, options);
                  startAutoHide();

                  resolve(element);
                }, reject);

            } catch (e) {
              reject(e.message);
            }
          });
        }

        function hideElement(element, options) {
          var announceRemoving = options.onRemoving || angular.noop;

          return $q(function (resolve, reject) {
            try {
              // Start transitionIn
              var action = $q.when( options.onRemove(options.scope, element, options) || true );

              // Trigger callback *before* the remove operation starts
              announceRemoving(element, action);

              if (options.$destroy) {
                // For $destroy, onRemove should be synchronous
                resolve(element);

                if (!options.preserveScope && options.scope ) {
                  // scope destroy should still be be done after the current digest is done
                  action.then( function() { options.scope.$destroy(); });
                }
              } else {
                // Wait until transition-out is done
                action.then(function () {
                  if (!options.preserveScope && options.scope ) {
                    options.scope.$destroy();
                  }

                  resolve(element);
                }, reject);
              }
            } catch (e) {
              reject(e.message);
            }
          });
        }

      }
    };

  }

}

})();
(function(){
"use strict";

(function() {
  'use strict';

  var $mdUtil, $interpolate, $log;

  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
  var WHITESPACE = /\s+/g;

  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow' ];
  var LAYOUT_OPTIONS = ['row', 'column'];
  var ALIGNMENT_MAIN_AXIS= [ "", "start", "center", "end", "stretch", "space-around", "space-between" ];
  var ALIGNMENT_CROSS_AXIS= [ "", "start", "center", "end", "stretch" ];

  var config = {
    /**
     * Enable directive attribute-to-class conversions
     * Developers can use `<body md-layout-css />` to quickly
     * disable the Layout directives and prohibit the injection of Layout classNames
     */
    enabled: true,

    /**
     * List of mediaQuery breakpoints and associated suffixes
     *
     *   [
     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
     *   ]
     */
    breakpoints: []
  };

  registerLayoutAPI( angular.module('material.core.layout', ['ng']) );

  /**
   *   registerLayoutAPI()
   *
   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
   *
   *  ```html
   *  <div layout="column"> My Content </div>
   *  ```
   *
   *  ```css
   *  [layout] {
   *    box-sizing: border-box;
   *    display:flex;
   *  }
   *  [layout=column] {
   *    flex-direction : column
   *  }
   *  ```
   *
   *  Use of attribute selectors creates significant performance impacts in some
   *  browsers... mainly IE.
   *
   *  This module registers directives that allow the same layout attributes to be
   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
   *  contains a Layout directive.
   *
   * ```html
   *   <div layout="column" class="layout layout-column"> My Content </div>
   *```
   *
   *  ```css
   *  .layout {
   *    box-sizing: border-box;
   *    display:flex;
   *  }
   *  .layout-column {
   *    flex-direction : column
   *  }
   *  ```
   */
  function registerLayoutAPI(module){
    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;

    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
    var BREAKPOINTS     = [ "", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print" ];
    var API_WITH_VALUES = [ "layout", "flex", "flex-order", "flex-offset", "layout-align" ];
    var API_NO_VALUES   = [ "show", "hide", "layout-padding", "layout-margin" ];


    // Build directive registration functions for the standard Layout API... for all breakpoints.
    angular.forEach(BREAKPOINTS, function(mqb) {

      // Attribute directives with expected, observable value(s)
      angular.forEach( API_WITH_VALUES, function(name){
        var fullName = mqb ? name + "-" + mqb : name;
        module.directive( directiveNormalize(fullName), attributeWithObserve(fullName));
      });

      // Attribute directives with no expected value(s)
      angular.forEach( API_NO_VALUES, function(name){
        var fullName = mqb ? name + "-" + mqb : name;
        module.directive( directiveNormalize(fullName), attributeWithoutValue(fullName));
      });

    });

    // Register other, special directive functions for the Layout features:
    module

      .provider('$$mdLayout'     , function() {
        // Publish internal service for Layouts
        return {
          $get : angular.noop,
          validateAttributeValue : validateAttributeValue,
          validateAttributeUsage : validateAttributeUsage,
          /**
           * Easy way to disable/enable the Layout API.
           * When disabled, this stops all attribute-to-classname generations
           */
          disableLayouts  : function(isDisabled) {
            config.enabled =  (isDisabled !== true);
          }
        };
      })

      .directive('mdLayoutCss'        , disableLayoutDirective )
      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))

      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))

      // !! Deprecated attributes: use the `-lt` (aka less-than) notations

      .directive('layoutLtMd'     , warnAttrNotSupported('layout-lt-md', true))
      .directive('layoutLtLg'     , warnAttrNotSupported('layout-lt-lg', true))
      .directive('flexLtMd'       , warnAttrNotSupported('flex-lt-md', true))
      .directive('flexLtLg'       , warnAttrNotSupported('flex-lt-lg', true))

      .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
      .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
      .directive('flexOrderLtMd'  , warnAttrNotSupported('flex-order-lt-md'))
      .directive('flexOrderLtLg'  , warnAttrNotSupported('flex-order-lt-lg'))
      .directive('offsetLtMd'     , warnAttrNotSupported('flex-offset-lt-md'))
      .directive('offsetLtLg'     , warnAttrNotSupported('flex-offset-lt-lg'))

      .directive('hideLtMd'       , warnAttrNotSupported('hide-lt-md'))
      .directive('hideLtLg'       , warnAttrNotSupported('hide-lt-lg'))
      .directive('showLtMd'       , warnAttrNotSupported('show-lt-md'))
      .directive('showLtLg'       , warnAttrNotSupported('show-lt-lg'))

      // Determine if
      .config( detectDisabledLayouts );

    /**
     * Converts snake_case to camelCase.
     * Also there is special case for Moz prefix starting with upper case letter.
     * @param name Name to normalize
     */
    function directiveNormalize(name) {
      return name
        .replace(PREFIX_REGEXP, '')
        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
          return offset ? letter.toUpperCase() : letter;
        });
    }

  }


  /**
    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
    * If yes, then immediately disable all layout API features
    *
    * Note: this attribute should be specified on either the HTML or BODY tags
    */
   /**
    * @ngInject
    */
   function detectDisabledLayouts() {
     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
     config.enabled = !isDisabled;
   }

  /**
   * Special directive that will disable ALL Layout conversions of layout
   * attribute(s) to classname(s).
   *
   * <link rel="stylesheet" href="angular-material.min.css">
   * <link rel="stylesheet" href="angular-material.layout.css">
   *
   * <body md-layout-css>
   *  ...
   * </body>
   *
   * Note: Using md-layout-css directive requires the developer to load the Material
   * Layout Attribute stylesheet (which only uses attribute selectors):
   *
   *       `angular-material.layout.css`
   *
   * Another option is to use the LayoutProvider to configure and disable the attribute
   * conversions; this would obviate the use of the `md-layout-css` directive
   *
   */
  function disableLayoutDirective() {
    // Return a 1x-only, first-match attribute directive
    config.enabled = false;

    return {
      restrict : 'A',
      priority : '900'
    };
  }

  /**
   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
   * finish processing. Eliminates flicker with Material.Layouts
   */
  function buildCloakInterceptor(className) {
    return [ '$timeout', function($timeout){
      return {
        restrict : 'A',
        priority : -10,   // run after normal ng-cloak
        compile  : function( element ) {
          if (!config.enabled) return angular.noop;

          // Re-add the cloak
          element.addClass(className);

          return function( scope, element ) {
            // Wait while layout injectors configure, then uncloak
            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
            //       $timeout is acceptable.
            $timeout( function(){
              element.removeClass(className);
            }, 10, false);
          };
        }
      };
    }];
  }


  // *********************************************************************************
  //
  // These functions create registration functions for AngularJS Material Layout attribute directives
  // This provides easy translation to switch AngularJS Material attribute selectors to
  // CLASS selectors and directives; which has huge performance implications
  // for IE Browsers
  //
  // *********************************************************************************

  /**
   * Creates a directive registration function where a possible dynamic attribute
   * value will be observed/watched.
   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
   */
  function attributeWithObserve(className) {

    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
      $mdUtil = _$mdUtil_;
      $interpolate = _$interpolate_;
      $log = _$log_;

      return {
        restrict: 'A',
        compile: function(element, attr) {
          var linkFn;
          if (config.enabled) {
            // immediately replace static (non-interpolated) invalid values...

            validateAttributeUsage(className, attr, element, $log);

            validateAttributeValue( className,
              getNormalizedAttrValue(className, attr, ""),
              buildUpdateFn(element, className, attr)
            );

            linkFn = translateWithValueToCssClass;
          }

          // Use for postLink to account for transforms after ng-transclude.
          return linkFn || angular.noop;
        }
      };
    }];

    /**
     * Add as transformed class selector(s), then
     * remove the deprecated attribute selector
     */
    function translateWithValueToCssClass(scope, element, attrs) {
      var updateFn = updateClassWithValue(element, className, attrs);
      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);

      updateFn(getNormalizedAttrValue(className, attrs, ""));
      scope.$on("$destroy", function() { unwatch(); });
    }
  }

  /**
   * Creates a registration function for AngularJS Material Layout attribute directive.
   * This is a `simple` transpose of attribute usage to class usage; where we ignore
   * any attribute value
   */
  function attributeWithoutValue(className) {
    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
      $mdUtil = _$mdUtil_;
      $interpolate = _$interpolate_;
      $log = _$log_;

      return {
        restrict: 'A',
        compile: function(element, attr) {
          var linkFn;
          if (config.enabled) {
            // immediately replace static (non-interpolated) invalid values...

            validateAttributeValue( className,
              getNormalizedAttrValue(className, attr, ""),
              buildUpdateFn(element, className, attr)
            );

            translateToCssClass(null, element);

            // Use for postLink to account for transforms after ng-transclude.
            linkFn = translateToCssClass;
          }

          return linkFn || angular.noop;
        }
      };
    }];

    /**
     * Add as transformed class selector, then
     * remove the deprecated attribute selector
     */
    function translateToCssClass(scope, element) {
      element.addClass(className);
    }
  }



  /**
   * After link-phase, do NOT remove deprecated layout attribute selector.
   * Instead watch the attribute so interpolated data-bindings to layout
   * selectors will continue to be supported.
   *
   * $observe() the className and update with new class (after removing the last one)
   *
   * e.g. `layout="{{layoutDemo.direction}}"` will update...
   *
   * NOTE: The value must match one of the specified styles in the CSS.
   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
   *
   */
  function updateClassWithValue(element, className) {
    var lastClass;

    return function updateClassFn(newValue) {
      var value = validateAttributeValue(className, newValue || "");
      if ( angular.isDefined(value) ) {
        if (lastClass) element.removeClass(lastClass);
        lastClass = !value ? className : className + "-" + value.trim().replace(WHITESPACE, "-");
        element.addClass(lastClass);
      }
    };
  }

  /**
   * Provide console warning that this layout attribute has been deprecated
   *
   */
  function warnAttrNotSupported(className) {
    var parts = className.split("-");
    return ["$log", function($log) {
      $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
      return angular.noop;
    }];
  }

  /**
   * Centralize warnings for known flexbox issues (especially IE-related issues)
   */
  function validateAttributeUsage(className, attr, element, $log){
    var message, usage, url;
    var nodeName = element[0].nodeName.toLowerCase();

    switch(className.replace(SUFFIXES,"")) {
      case "flex":
        if ((nodeName == "md-button") || (nodeName == "fieldset")){
          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
          // Use <div flex> wrapper inside (preferred) or outside

          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";

          $log.warn( $mdUtil.supplant(message, [usage, url]) );
        }
    }

  }


  /**
   * For the Layout attribute value, validate or replace with default
   * fallback value
   */
  function validateAttributeValue(className, value, updateFn) {
    var origValue;

    if (!needsInterpolation(value)) {
      switch (className.replace(SUFFIXES,"")) {
        case 'layout'        :
          if ( !findIn(value, LAYOUT_OPTIONS) ) {
            value = LAYOUT_OPTIONS[0];    // 'row';
          }
          break;

        case 'flex'          :
          if (!findIn(value, FLEX_OPTIONS)) {
            if (isNaN(value)) {
              value = '';
            }
          }
          break;

        case 'flex-offset' :
        case 'flex-order'    :
          if (!value || isNaN(+value)) {
            value = '0';
          }
          break;

        case 'layout-align'  :
          var axis = extractAlignAxis(value);
          value = $mdUtil.supplant("{main}-{cross}",axis);
          break;

        case 'layout-padding' :
        case 'layout-margin'  :
        case 'layout-fill'    :
        case 'layout-wrap'    :
        case 'layout-nowrap'  :
        case 'layout-nowrap' :
          value = '';
          break;
      }

      if (value != origValue) {
        (updateFn || angular.noop)(value);
      }
    }

    return value ? value.trim() : "";
  }

  /**
   * Replace current attribute value with fallback value
   */
  function buildUpdateFn(element, className, attrs) {
    return function updateAttrValue(fallback) {
      if (!needsInterpolation(fallback)) {
        // Do not modify the element's attribute value; so
        // uses '<ui-layout layout="/api/sidebar.html" />' will not
        // be affected. Just update the attrs value.
        attrs[attrs.$normalize(className)] = fallback;
      }
    };
  }

  /**
   * See if the original value has interpolation symbols:
   * e.g.  flex-gt-md="{{triggerPoint}}"
   */
  function needsInterpolation(value) {
    return (value || "").indexOf($interpolate.startSymbol()) > -1;
  }

  function getNormalizedAttrValue(className, attrs, defaultVal) {
    var normalizedAttr = attrs.$normalize(className);
    return attrs[normalizedAttr] ? attrs[normalizedAttr].trim().replace(WHITESPACE, "-") : defaultVal || null;
  }

  function findIn(item, list, replaceWith) {
    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;

    var found = false;
    if (item) {
      list.forEach(function(it) {
        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
        found = found || (it === item);
      });
    }
    return found;
  }

  function extractAlignAxis(attrValue) {
    var axis = {
      main : "start",
      cross: "stretch"
    }, values;

    attrValue = (attrValue || "");

    if ( attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
      // For missing main-axis values
      attrValue = "none" + attrValue;
    }

    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
    if ( values.length && (values[0] === "space") ) {
      // for main-axis values of "space-around" or "space-between"
      values = [ values[0]+"-"+values[1],values[2] ];
    }

    if ( values.length > 0 ) axis.main  = values[0] || axis.main;
    if ( values.length > 1 ) axis.cross = values[1] || axis.cross;

    if ( ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0 )   axis.main = "start";
    if ( ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0 ) axis.cross = "stretch";

    return axis;
  }


})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.liveannouncer
 * @description
 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
 */
MdLiveAnnouncer.$inject = ["$timeout"];
angular
  .module('material.core')
  .service('$mdLiveAnnouncer', MdLiveAnnouncer);

/**
 * @ngdoc service
 * @name $mdLiveAnnouncer
 * @module material.core.liveannouncer
 *
 * @description
 *
 * Service to announce messages to supported screenreaders.
 *
 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
 *
 * <hljs lang="js">
 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
 *     // Basic announcement (Polite Mode)
 *     $mdLiveAnnouncer.announce('Hey Google');
 *
 *     // Custom announcement (Assertive Mode)
 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
 *   });
 * </hljs>
 *
 */
function MdLiveAnnouncer($timeout) {
  /** @private @const @type {!angular.$timeout} */
  this._$timeout = $timeout;

  /** @private @const @type {!HTMLElement} */
  this._liveElement = this._createLiveElement();

  /** @private @const @type {!number} */
  this._announceTimeout = 100;
}

/**
 * @ngdoc method
 * @name $mdLiveAnnouncer#announce
 * @description Announces messages to supported screenreaders.
 * @param {string} message Message to be announced to the screenreader
 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
 */
MdLiveAnnouncer.prototype.announce = function(message, politeness) {
  if (!politeness) {
    politeness = 'polite';
  }

  var self = this;

  self._liveElement.textContent = '';
  self._liveElement.setAttribute('aria-live', politeness);

  // This 100ms timeout is necessary for some browser + screen-reader combinations:
  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
  //   second time without clearing and then using a non-zero delay.
  // (using JAWS 17 at time of this writing).
  self._$timeout(function() {
    self._liveElement.textContent = message;
  }, self._announceTimeout, false);
};

/**
 * Creates a live announcer element, which listens for DOM changes and announces them
 * to the screenreaders.
 * @returns {!HTMLElement}
 * @private
 */
MdLiveAnnouncer.prototype._createLiveElement = function() {
  var liveEl = document.createElement('div');

  liveEl.classList.add('md-visually-hidden');
  liveEl.setAttribute('role', 'status');
  liveEl.setAttribute('aria-atomic', 'true');
  liveEl.setAttribute('aria-live', 'polite');

  document.body.appendChild(liveEl);

  return liveEl;
};

})();
(function(){
"use strict";

/**
 * @ngdoc service
 * @name $$mdMeta
 * @module material.core.meta
 *
 * @description
 *
 * A provider and a service that simplifies meta tags access
 *
 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
 *
 * ```js
 * app.config(function($$mdMetaProvider) {
 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
 *
 *   removeMeta();
 * });
 *
 * app.controller('myController', function($$mdMeta) {
 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
 *
 *   removeMeta();
 * });
 * ```
 *
 * @returns {$$mdMeta.$service}
 *
 */
angular.module('material.core.meta', [])
  .provider('$$mdMeta', function () {
    var head = angular.element(document.head);
    var metaElements = {};

    /**
     * Checks if the requested element was written manually and maps it
     *
     * @param {string} name meta tag 'name' attribute value
     * @returns {boolean} returns true if there is an element with the requested name
     */
    function mapExistingElement(name) {
      if (metaElements[name]) {
        return true;
      }

      var element = document.getElementsByName(name)[0];

      if (!element) {
        return false;
      }

      metaElements[name] = angular.element(element);

      return true;
    }

    /**
     * @ngdoc method
     * @name $$mdMeta#setMeta
     *
     * @description
     * Creates meta element with the 'name' and 'content' attributes,
     * if the meta tag is already created than we replace the 'content' value
     *
     * @param {string} name meta tag 'name' attribute value
     * @param {string} content meta tag 'content' attribute value
     * @returns {function} remove function
     *
     */
    function setMeta(name, content) {
      mapExistingElement(name);

      if (!metaElements[name]) {
        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
        head.append(newMeta);
        metaElements[name] = newMeta;
      }
      else {
        metaElements[name].attr('content', content);
      }

      return function () {
        metaElements[name].attr('content', '');
        metaElements[name].remove();
        delete metaElements[name];
      };
    }

    /**
     * @ngdoc method
     * @name $$mdMeta#getMeta
     *
     * @description
     * Gets the 'content' attribute value of the wanted meta element
     *
     * @param {string} name meta tag 'name' attribute value
     * @returns {string} content attribute value
     */
    function getMeta(name) {
      if (!mapExistingElement(name)) {
        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
      }

      return metaElements[name].attr('content');
    }

    var module = {
      setMeta: setMeta,
      getMeta: getMeta
    };

    return angular.extend({}, module, {
      $get: function () {
        return module;
      }
    });
  });
})();
(function(){
"use strict";

  /**
   * @ngdoc module
   * @name material.core.componentRegistry
   *
   * @description
   * A component instance registration service.
   * Note: currently this as a private service in the SideNav component.
   */
  ComponentRegistry.$inject = ["$log", "$q"];
  angular.module('material.core')
    .factory('$mdComponentRegistry', ComponentRegistry);

  /*
   * @private
   * @ngdoc factory
   * @name ComponentRegistry
   * @module material.core.componentRegistry
   *
   */
  function ComponentRegistry($log, $q) {

    var self;
    var instances = [ ];
    var pendings = { };

    return self = {
      /**
       * Used to print an error when an instance for a handle isn't found.
       */
      notFoundError: function(handle, msgContext) {
        $log.error( (msgContext || "") + 'No instance found for handle', handle);
      },
      /**
       * Return all registered instances as an array.
       */
      getInstances: function() {
        return instances;
      },

      /**
       * Get a registered instance.
       * @param handle the String handle to look up for a registered instance.
       */
      get: function(handle) {
        if ( !isValidID(handle) ) return null;

        var i, j, instance;
        for(i = 0, j = instances.length; i < j; i++) {
          instance = instances[i];
          if(instance.$$mdHandle === handle) {
            return instance;
          }
        }
        return null;
      },

      /**
       * Register an instance.
       * @param instance the instance to register
       * @param handle the handle to identify the instance under.
       */
      register: function(instance, handle) {
        if ( !handle ) return angular.noop;

        instance.$$mdHandle = handle;
        instances.push(instance);
        resolveWhen();

        return deregister;

        /**
         * Remove registration for an instance
         */
        function deregister() {
          var index = instances.indexOf(instance);
          if (index !== -1) {
            instances.splice(index, 1);
          }
        }

        /**
         * Resolve any pending promises for this instance
         */
        function resolveWhen() {
          var dfd = pendings[handle];
          if ( dfd ) {
            dfd.forEach(function (promise) {
              promise.resolve(instance);
            });
            delete pendings[handle];
          }
        }
      },

      /**
       * Async accessor to registered component instance
       * If not available then a promise is created to notify
       * all listeners when the instance is registered.
       */
      when : function(handle) {
        if ( isValidID(handle) ) {
          var deferred = $q.defer();
          var instance = self.get(handle);

          if ( instance )  {
            deferred.resolve( instance );
          } else {
            if (pendings[handle] === undefined) {
              pendings[handle] = [];
            }
            pendings[handle].push(deferred);
          }

          return deferred.promise;
        }
        return $q.reject("Invalid `md-component-id` value.");
      }

    };

    function isValidID(handle){
      return handle && (handle !== "");
    }

  }

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdButtonInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
   */

  MdButtonInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdButtonInkRipple', MdButtonInkRipple);

  function MdButtonInkRipple($mdInkRipple) {
    return {
      attach: function attachRipple(scope, element, options) {
        options = angular.extend(optionsForElement(element), options);

        return $mdInkRipple.attach(scope, element, options);
      }
    };

    function optionsForElement(element) {
      if (element.hasClass('md-icon-button')) {
        return {
          isMenuItem: element.hasClass('md-menu-item'),
          fitRipple: true,
          center: true
        };
      } else {
        return {
          isMenuItem: element.hasClass('md-menu-item'),
          dimBackground: true
        };
      }
    }
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

    /**
   * @ngdoc service
   * @name $mdCheckboxInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);

  function MdCheckboxInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: true,
        dimBackground: false,
        fitRipple: true
      }, options));
    }
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdListInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdListInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdListInkRipple', MdListInkRipple);

  function MdListInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: false,
        dimBackground: true,
        outline: false,
        rippleSize: 'full'
      }, options));
    }
  }
})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.ripple
 * @description
 * Ripple
 */
InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
angular.module('material.core')
    .provider('$mdInkRipple', InkRippleProvider)
    .directive('mdInkRipple', InkRippleDirective)
    .directive('mdNoInk', attrNoDirective)
    .directive('mdNoBar', attrNoDirective)
    .directive('mdNoStretch', attrNoDirective);

var DURATION = 450;

/**
 * @ngdoc directive
 * @name mdInkRipple
 * @module material.core.ripple
 *
 * @description
 * The `md-ink-ripple` directive allows you to specify the ripple color or if a ripple is allowed.
 *
 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
 *
 * @usage
 * ### String values
 * <hljs lang="html">
 *   <ANY md-ink-ripple="#FF0000">
 *     Ripples in red
 *   </ANY>
 *
 *   <ANY md-ink-ripple="false">
 *     Not rippling
 *   </ANY>
 * </hljs>
 *
 * ### Interpolated values
 * <hljs lang="html">
 *   <ANY md-ink-ripple="{{ randomColor() }}">
 *     Ripples with the return value of 'randomColor' function
 *   </ANY>
 *
 *   <ANY md-ink-ripple="{{ canRipple() }}">
 *     Ripples if 'canRipple' function return value is not 'false' or '0'
 *   </ANY>
 * </hljs>
 */
function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
  return {
    controller: angular.noop,
    link:       function (scope, element, attr) {
      attr.hasOwnProperty('mdInkRippleCheckbox')
          ? $mdCheckboxInkRipple.attach(scope, element)
          : $mdButtonInkRipple.attach(scope, element);
    }
  };
}

/**
 * @ngdoc service
 * @name $mdInkRipple
 * @module material.core.ripple
 *
 * @description
 * `$mdInkRipple` is a service for adding ripples to any element
 *
 * @usage
 * <hljs lang="js">
 * app.factory('$myElementInkRipple', function($mdInkRipple) {
 *   return {
 *     attach: function (scope, element, options) {
 *       return $mdInkRipple.attach(scope, element, angular.extend({
 *         center: false,
 *         dimBackground: true
 *       }, options));
 *     }
 *   };
 * });
 *
 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
 *   $scope.onClick = function (ev) {
 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
 *   }
 * });
 * </hljs>
 *
 * ### Disabling ripples globally
 * If you want to disable ink ripples globally, for all components, you can call the
 * `disableInkRipple` method in your app's config.
 *
 * <hljs lang="js">
 * app.config(function ($mdInkRippleProvider) {
 *   $mdInkRippleProvider.disableInkRipple();
 * });
 */

function InkRippleProvider () {
  var isDisabledGlobally = false;

  return {
    disableInkRipple: disableInkRipple,
    $get: ["$injector", function($injector) {
      return { attach: attach };

      /**
       * @ngdoc method
       * @name $mdInkRipple#attach
       *
       * @description
       * Attaching given scope, element and options to inkRipple controller
       *
       * @param {object=} scope Scope within the current context
       * @param {object=} element The element the ripple effect should be applied to
       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
       * * `center` -  Whether the ripple should start from the center of the container element
       * * `dimBackground` - Whether the background should be dimmed with the ripple color
       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
       * * `fitRipple` - Whether the ripple should fill the element
       */
      function attach (scope, element, options) {
        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
        return $injector.instantiate(InkRippleCtrl, {
          $scope:        scope,
          $element:      element,
          rippleOptions: options
        });
      }
    }]
  };

  /**
   * @ngdoc method
   * @name $mdInkRipple#disableInkRipple
   *
   * @description
   * A config-time method that, when called, disables ripples globally.
   */
  function disableInkRipple () {
    isDisabledGlobally = true;
  }
}

/**
 * Controller used by the ripple service in order to apply ripples
 * @ngInject
 */
function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
  this.$window    = $window;
  this.$timeout   = $timeout;
  this.$mdUtil    = $mdUtil;
  this.$mdColorUtil    = $mdColorUtil;
  this.$scope     = $scope;
  this.$element   = $element;
  this.options    = rippleOptions;
  this.mousedown  = false;
  this.ripples    = [];
  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
  this.lastRipple = null;

  $mdUtil.valueOnUse(this, 'container', this.createContainer);

  this.$element.addClass('md-ink-ripple');

  // attach method for unit tests
  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);

  this.bindEvents();
}


/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
 * mouseup or mouseleave event)
 */
function autoCleanup (self, cleanupFn) {

  if ( self.mousedown || self.lastRipple ) {
    self.mousedown = false;
    self.$mdUtil.nextTick( angular.bind(self, cleanupFn), false);
  }

}


/**
 * Returns the color that the ripple should be (either based on CSS or hard-coded)
 * @returns {string}
 */
InkRippleCtrl.prototype.color = function (value) {
  var self = this;

  // If assigning a color value, apply it to background and the ripple color
  if (angular.isDefined(value)) {
    self._color = self._parseColor(value);
  }

  // If color lookup, use assigned, defined, or inherited
  return self._color || self._parseColor( self.inkRipple() ) || self._parseColor( getElementColor() );

  /**
   * Finds the color element and returns its text color for use as default ripple color
   * @returns {string}
   */
  function getElementColor () {
    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];

    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
  }
};

/**
 * Updating the ripple colors based on the current inkRipple value
 * or the element's computed style color
 */
InkRippleCtrl.prototype.calculateColor = function () {
  return this.color();
};


/**
 * Takes a string color and converts it to RGBA format
 * @param color {string}
 * @param [multiplier] {int}
 * @returns {string}
 */

InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
  multiplier = multiplier || 1;
  var colorUtil = this.$mdColorUtil;

  if (!color) return;
  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);

};

/**
 * Binds events to the root element for
 */
InkRippleCtrl.prototype.bindEvents = function () {
  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
};

/**
 * Create a new ripple on every mousedown event from the root element
 * @param event {MouseEvent}
 */
InkRippleCtrl.prototype.handleMousedown = function (event) {
  if ( this.mousedown ) return;

  // When jQuery is loaded, we have to get the original event
  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
  this.mousedown = true;
  if (this.options.center) {
    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
  } else {

    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
    if (event.srcElement !== this.$element[0]) {
      var layerRect = this.$element[0].getBoundingClientRect();
      var layerX = event.clientX - layerRect.left;
      var layerY = event.clientY - layerRect.top;

      this.createRipple(layerX, layerY);
    } else {
      this.createRipple(event.offsetX, event.offsetY);
    }
  }
};

/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
 * mouseup, touchend or mouseleave event)
 */
InkRippleCtrl.prototype.handleMouseup = function () {
  autoCleanup(this, this.clearRipples);
};

/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
 * touchmove)
 */
InkRippleCtrl.prototype.handleTouchmove = function () {
  autoCleanup(this, this.deleteRipples);
};

/**
 * Cycles through all ripples and attempts to remove them.
 */
InkRippleCtrl.prototype.deleteRipples = function () {
  for (var i = 0; i < this.ripples.length; i++) {
    this.ripples[ i ].remove();
  }
};

/**
 * Cycles through all ripples and attempts to remove them with fade.
 * Depending on logic within `fadeInComplete`, some removals will be postponed.
 */
InkRippleCtrl.prototype.clearRipples = function () {
  for (var i = 0; i < this.ripples.length; i++) {
    this.fadeInComplete(this.ripples[ i ]);
  }
};

/**
 * Creates the ripple container element
 * @returns {*}
 */
InkRippleCtrl.prototype.createContainer = function () {
  var container = angular.element('<div class="md-ripple-container"></div>');
  this.$element.append(container);
  return container;
};

InkRippleCtrl.prototype.clearTimeout = function () {
  if (this.timeout) {
    this.$timeout.cancel(this.timeout);
    this.timeout = null;
  }
};

InkRippleCtrl.prototype.isRippleAllowed = function () {
  var element = this.$element[0];
  do {
    if (!element.tagName || element.tagName === 'BODY') break;

    if (element && angular.isFunction(element.hasAttribute)) {
      if (element.hasAttribute('disabled')) return false;
      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
    }

  } while (element = element.parentNode);
  return true;
};

/**
 * The attribute `md-ink-ripple` may be a static or interpolated
 * color value OR a boolean indicator (used to disable ripples)
 */
InkRippleCtrl.prototype.inkRipple = function () {
  return this.$element.attr('md-ink-ripple');
};

/**
 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
 * @param left
 * @param top
 */
InkRippleCtrl.prototype.createRipple = function (left, top) {
  if (!this.isRippleAllowed()) return;

  var ctrl        = this;
  var colorUtil   = ctrl.$mdColorUtil;
  var ripple      = angular.element('<div class="md-ripple"></div>');
  var width       = this.$element.prop('clientWidth');
  var height      = this.$element.prop('clientHeight');
  var x           = Math.max(Math.abs(width - left), left) * 2;
  var y           = Math.max(Math.abs(height - top), top) * 2;
  var size        = getSize(this.options.fitRipple, x, y);
  var color       = this.calculateColor();

  ripple.css({
    left:            left + 'px',
    top:             top + 'px',
    background:      'black',
    width:           size + 'px',
    height:          size + 'px',
    backgroundColor: colorUtil.rgbaToRgb(color),
    borderColor:     colorUtil.rgbaToRgb(color)
  });
  this.lastRipple = ripple;

  // we only want one timeout to be running at a time
  this.clearTimeout();
  this.timeout    = this.$timeout(function () {
    ctrl.clearTimeout();
    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
  }, DURATION * 0.35, false);

  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
  this.container.append(ripple);
  this.ripples.push(ripple);
  ripple.addClass('md-ripple-placed');

  this.$mdUtil.nextTick(function () {

    ripple.addClass('md-ripple-scaled md-ripple-active');
    ctrl.$timeout(function () {
      ctrl.clearRipples();
    }, DURATION, false);

  }, false);

  function getSize (fit, x, y) {
    return fit
        ? Math.max(x, y)
        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  }
};



/**
 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
 * @param ripple
 */
InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
  if (this.lastRipple === ripple) {
    if (!this.timeout && !this.mousedown) {
      this.removeRipple(ripple);
    }
  } else {
    this.removeRipple(ripple);
  }
};

/**
 * Kicks off the animation for removing a ripple
 * @param ripple {Element}
 */
InkRippleCtrl.prototype.removeRipple = function (ripple) {
  var ctrl  = this;
  var index = this.ripples.indexOf(ripple);
  if (index < 0) return;
  this.ripples.splice(this.ripples.indexOf(ripple), 1);
  ripple.removeClass('md-ripple-active');
  ripple.addClass('md-ripple-remove');
  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
  // use a 2-second timeout in order to allow for the animation to finish
  // we don't actually care how long the animation takes
  this.$timeout(function () {
    ctrl.fadeOutComplete(ripple);
  }, DURATION, false);
};

/**
 * Removes the provided ripple from the DOM
 * @param ripple
 */
InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
  ripple.remove();
  this.lastRipple = null;
};

/**
 * Used to create an empty directive.  This is used to track flag-directives whose children may have
 * functionality based on them.
 *
 * Example: `md-no-ink` will potentially be used by all child directives.
 */
function attrNoDirective () {
  return { controller: angular.noop };
}

})();
(function(){
"use strict";

(function() {
  'use strict';

    /**
   * @ngdoc service
   * @name $mdTabInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdTabInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdTabInkRipple', MdTabInkRipple);

  function MdTabInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: false,
        dimBackground: true,
        outline: false,
        rippleSize: 'full'
      }, options));
    }
  }
})();

})();
(function(){
"use strict";

angular.module('material.core.theming.palette', [])
.constant('$mdColorPalette', {
  'red': {
    '50': '#ffebee',
    '100': '#ffcdd2',
    '200': '#ef9a9a',
    '300': '#e57373',
    '400': '#ef5350',
    '500': '#f44336',
    '600': '#e53935',
    '700': '#d32f2f',
    '800': '#c62828',
    '900': '#b71c1c',
    'A100': '#ff8a80',
    'A200': '#ff5252',
    'A400': '#ff1744',
    'A700': '#d50000',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100',
    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
  },
  'pink': {
    '50': '#fce4ec',
    '100': '#f8bbd0',
    '200': '#f48fb1',
    '300': '#f06292',
    '400': '#ec407a',
    '500': '#e91e63',
    '600': '#d81b60',
    '700': '#c2185b',
    '800': '#ad1457',
    '900': '#880e4f',
    'A100': '#ff80ab',
    'A200': '#ff4081',
    'A400': '#f50057',
    'A700': '#c51162',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '500 600 A200 A400 A700'
  },
  'purple': {
    '50': '#f3e5f5',
    '100': '#e1bee7',
    '200': '#ce93d8',
    '300': '#ba68c8',
    '400': '#ab47bc',
    '500': '#9c27b0',
    '600': '#8e24aa',
    '700': '#7b1fa2',
    '800': '#6a1b9a',
    '900': '#4a148c',
    'A100': '#ea80fc',
    'A200': '#e040fb',
    'A400': '#d500f9',
    'A700': '#aa00ff',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '300 400 A200 A400 A700'
  },
  'deep-purple': {
    '50': '#ede7f6',
    '100': '#d1c4e9',
    '200': '#b39ddb',
    '300': '#9575cd',
    '400': '#7e57c2',
    '500': '#673ab7',
    '600': '#5e35b1',
    '700': '#512da8',
    '800': '#4527a0',
    '900': '#311b92',
    'A100': '#b388ff',
    'A200': '#7c4dff',
    'A400': '#651fff',
    'A700': '#6200ea',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '300 400 A200'
  },
  'indigo': {
    '50': '#e8eaf6',
    '100': '#c5cae9',
    '200': '#9fa8da',
    '300': '#7986cb',
    '400': '#5c6bc0',
    '500': '#3f51b5',
    '600': '#3949ab',
    '700': '#303f9f',
    '800': '#283593',
    '900': '#1a237e',
    'A100': '#8c9eff',
    'A200': '#536dfe',
    'A400': '#3d5afe',
    'A700': '#304ffe',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '300 400 A200 A400'
  },
  'blue': {
    '50': '#e3f2fd',
    '100': '#bbdefb',
    '200': '#90caf9',
    '300': '#64b5f6',
    '400': '#42a5f5',
    '500': '#2196f3',
    '600': '#1e88e5',
    '700': '#1976d2',
    '800': '#1565c0',
    '900': '#0d47a1',
    'A100': '#82b1ff',
    'A200': '#448aff',
    'A400': '#2979ff',
    'A700': '#2962ff',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 400 A100',
    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
  },
  'light-blue': {
    '50': '#e1f5fe',
    '100': '#b3e5fc',
    '200': '#81d4fa',
    '300': '#4fc3f7',
    '400': '#29b6f6',
    '500': '#03a9f4',
    '600': '#039be5',
    '700': '#0288d1',
    '800': '#0277bd',
    '900': '#01579b',
    'A100': '#80d8ff',
    'A200': '#40c4ff',
    'A400': '#00b0ff',
    'A700': '#0091ea',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '600 700 800 900 A700',
    'contrastStrongLightColors': '600 700 800 A700'
  },
  'cyan': {
    '50': '#e0f7fa',
    '100': '#b2ebf2',
    '200': '#80deea',
    '300': '#4dd0e1',
    '400': '#26c6da',
    '500': '#00bcd4',
    '600': '#00acc1',
    '700': '#0097a7',
    '800': '#00838f',
    '900': '#006064',
    'A100': '#84ffff',
    'A200': '#18ffff',
    'A400': '#00e5ff',
    'A700': '#00b8d4',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '700 800 900',
    'contrastStrongLightColors': '700 800 900'
  },
  'teal': {
    '50': '#e0f2f1',
    '100': '#b2dfdb',
    '200': '#80cbc4',
    '300': '#4db6ac',
    '400': '#26a69a',
    '500': '#009688',
    '600': '#00897b',
    '700': '#00796b',
    '800': '#00695c',
    '900': '#004d40',
    'A100': '#a7ffeb',
    'A200': '#64ffda',
    'A400': '#1de9b6',
    'A700': '#00bfa5',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '500 600 700 800 900',
    'contrastStrongLightColors': '500 600 700'
  },
  'green': {
    '50': '#e8f5e9',
    '100': '#c8e6c9',
    '200': '#a5d6a7',
    '300': '#81c784',
    '400': '#66bb6a',
    '500': '#4caf50',
    '600': '#43a047',
    '700': '#388e3c',
    '800': '#2e7d32',
    '900': '#1b5e20',
    'A100': '#b9f6ca',
    'A200': '#69f0ae',
    'A400': '#00e676',
    'A700': '#00c853',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '500 600 700 800 900',
    'contrastStrongLightColors': '500 600 700'
  },
  'light-green': {
    '50': '#f1f8e9',
    '100': '#dcedc8',
    '200': '#c5e1a5',
    '300': '#aed581',
    '400': '#9ccc65',
    '500': '#8bc34a',
    '600': '#7cb342',
    '700': '#689f38',
    '800': '#558b2f',
    '900': '#33691e',
    'A100': '#ccff90',
    'A200': '#b2ff59',
    'A400': '#76ff03',
    'A700': '#64dd17',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '700 800 900',
    'contrastStrongLightColors': '700 800 900'
  },
  'lime': {
    '50': '#f9fbe7',
    '100': '#f0f4c3',
    '200': '#e6ee9c',
    '300': '#dce775',
    '400': '#d4e157',
    '500': '#cddc39',
    '600': '#c0ca33',
    '700': '#afb42b',
    '800': '#9e9d24',
    '900': '#827717',
    'A100': '#f4ff81',
    'A200': '#eeff41',
    'A400': '#c6ff00',
    'A700': '#aeea00',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '900',
    'contrastStrongLightColors': '900'
  },
  'yellow': {
    '50': '#fffde7',
    '100': '#fff9c4',
    '200': '#fff59d',
    '300': '#fff176',
    '400': '#ffee58',
    '500': '#ffeb3b',
    '600': '#fdd835',
    '700': '#fbc02d',
    '800': '#f9a825',
    '900': '#f57f17',
    'A100': '#ffff8d',
    'A200': '#ffff00',
    'A400': '#ffea00',
    'A700': '#ffd600',
    'contrastDefaultColor': 'dark'
  },
  'amber': {
    '50': '#fff8e1',
    '100': '#ffecb3',
    '200': '#ffe082',
    '300': '#ffd54f',
    '400': '#ffca28',
    '500': '#ffc107',
    '600': '#ffb300',
    '700': '#ffa000',
    '800': '#ff8f00',
    '900': '#ff6f00',
    'A100': '#ffe57f',
    'A200': '#ffd740',
    'A400': '#ffc400',
    'A700': '#ffab00',
    'contrastDefaultColor': 'dark'
  },
  'orange': {
    '50': '#fff3e0',
    '100': '#ffe0b2',
    '200': '#ffcc80',
    '300': '#ffb74d',
    '400': '#ffa726',
    '500': '#ff9800',
    '600': '#fb8c00',
    '700': '#f57c00',
    '800': '#ef6c00',
    '900': '#e65100',
    'A100': '#ffd180',
    'A200': '#ffab40',
    'A400': '#ff9100',
    'A700': '#ff6d00',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '800 900',
    'contrastStrongLightColors': '800 900'
  },
  'deep-orange': {
    '50': '#fbe9e7',
    '100': '#ffccbc',
    '200': '#ffab91',
    '300': '#ff8a65',
    '400': '#ff7043',
    '500': '#ff5722',
    '600': '#f4511e',
    '700': '#e64a19',
    '800': '#d84315',
    '900': '#bf360c',
    'A100': '#ff9e80',
    'A200': '#ff6e40',
    'A400': '#ff3d00',
    'A700': '#dd2c00',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 400 A100 A200',
    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
  },
  'brown': {
    '50': '#efebe9',
    '100': '#d7ccc8',
    '200': '#bcaaa4',
    '300': '#a1887f',
    '400': '#8d6e63',
    '500': '#795548',
    '600': '#6d4c41',
    '700': '#5d4037',
    '800': '#4e342e',
    '900': '#3e2723',
    'A100': '#d7ccc8',
    'A200': '#bcaaa4',
    'A400': '#8d6e63',
    'A700': '#5d4037',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100 A200',
    'contrastStrongLightColors': '300 400'
  },
  'grey': {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
    'A100': '#ffffff',
    'A200': '#000000',
    'A400': '#303030',
    'A700': '#616161',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '600 700 800 900 A200 A400 A700'
  },
  'blue-grey': {
    '50': '#eceff1',
    '100': '#cfd8dc',
    '200': '#b0bec5',
    '300': '#90a4ae',
    '400': '#78909c',
    '500': '#607d8b',
    '600': '#546e7a',
    '700': '#455a64',
    '800': '#37474f',
    '900': '#263238',
    'A100': '#cfd8dc',
    'A200': '#b0bec5',
    'A400': '#78909c',
    'A700': '#455a64',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100 A200',
    'contrastStrongLightColors': '400 500 700'
  }
});

})();
(function(){
"use strict";

(function(angular) {
  'use strict';
/**
 * @ngdoc module
 * @name material.core.theming
 * @description
 * Theming
 */
detectDisabledThemes.$inject = ["$mdThemingProvider"];
ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
ThemableDirective.$inject = ["$mdTheming"];
ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
generateAllThemes.$inject = ["$injector", "$mdTheming"];
angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
  .directive('mdTheme', ThemingDirective)
  .directive('mdThemable', ThemableDirective)
  .directive('mdThemesDisabled', disableThemesDirective )
  .provider('$mdTheming', ThemingProvider)
  .config( detectDisabledThemes )
  .run(generateAllThemes);

/**
 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
 * If yes, then immediately disable all theme stylesheet generation and DOM injection
 */
/**
 * @ngInject
 */
function detectDisabledThemes($mdThemingProvider) {
  var isDisabled = !!document.querySelector('[md-themes-disabled]');
  $mdThemingProvider.disableTheming(isDisabled);
}

/**
 * @ngdoc service
 * @name $mdThemingProvider
 * @module material.core.theming
 *
 * @description Provider to configure the `$mdTheming` service.
 *
 * ### Default Theme
 * The `$mdThemingProvider` uses by default the following theme configuration:
 *
 * - Primary Palette: `Blue`
 * - Accent Palette: `Pink`
 * - Warn Palette: `Deep-Orange`
 * - Background Palette: `Grey`
 *
 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
 * the default theme.<br/>
 * This can be done by using the following markup.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     $mdThemingProvider
 *       .theme('default')
 *       .primaryPalette('blue')
 *       .accentPalette('teal')
 *       .warnPalette('red')
 *       .backgroundPalette('grey');
 *   });
 * </hljs>
 *

 * ### Dynamic Themes
 *
 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Enable theme watching.
 *     $mdThemingProvider.alwaysWatchTheme(true);
 *   });
 * </hljs>
 *
 * ### Custom Theme Styles
 *
 * Sometimes you may want to use your own theme styles for some custom components.<br/>
 * You are able to register your own styles by using the following markup.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Register our custom stylesheet into the theming provider.
 *     $mdThemingProvider.registerStyles(STYLESHEET);
 *   });
 * </hljs>
 *
 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
 * stylesheet file into the `$mdThemingProvider`.
 *
 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Register your custom stylesheet into the theming provider.
 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
 *   });
 * </hljs>
 *
 * ### Browser color
 *
 * Enables browser header coloring
 * for more info please visit:
 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
 *
 * Options parameter: <br/>
 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
 * `hue`     - The hue from the selected palette. Default is `800`<br/>
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Enable browser color
 *     $mdThemingProvider.enableBrowserColor({
 *       theme: 'myTheme', // Default is 'default'
 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
 *       hue: '200' // Default is '800'
 *     });
 *   });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#registerStyles
 * @param {string} styles The styles to be appended to AngularJS Material's built in theme css.
 */
/**
 * @ngdoc method
 * @name $mdThemingProvider#setNonce
 * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
 * Setting a value allows the use of CSP policy without using the unsafe-inline directive.
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#setDefaultTheme
 * @param {string} themeName Default theme name to be applied to elements. Default value is `default`.
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#alwaysWatchTheme
 * @param {boolean} watch Whether or not to always watch themes for changes and re-apply
 * classes when they change. Default is `false`. Enabling can reduce performance.
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#enableBrowserColor
 * @param {Object=} options Options object for the browser color<br/>
 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
 * `hue`     - The hue from the selected palette. Default is `800`<br/>
 * @returns {Function} remove function of the browser color
 */

/* Some Example Valid Theming Expressions
 * =======================================
 *
 * Intention group expansion: (valid for primary, accent, warn, background)
 *
 * {{primary-100}} - grab shade 100 from the primary palette
 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
 * {{primary-100-contrast}} - grab shade 100's contrast color
 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
 *
 * Foreground expansion: Applies rgba to black/white foreground text
 *
 * {{foreground-1}} - used for primary text
 * {{foreground-2}} - used for secondary text/divider
 * {{foreground-3}} - used for disabled text
 * {{foreground-4}} - used for dividers
 *
 */

// In memory generated CSS rules; registered by theme.name
var GENERATED = { };

// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
var PALETTES;

// Text Colors on light and dark backgrounds
// @see https://www.google.com/design/spec/style/color.html#color-text-background-colors
var DARK_FOREGROUND = {
  name: 'dark',
  '1': 'rgba(0,0,0,0.87)',
  '2': 'rgba(0,0,0,0.54)',
  '3': 'rgba(0,0,0,0.38)',
  '4': 'rgba(0,0,0,0.12)'
};
var LIGHT_FOREGROUND = {
  name: 'light',
  '1': 'rgba(255,255,255,1.0)',
  '2': 'rgba(255,255,255,0.7)',
  '3': 'rgba(255,255,255,0.5)',
  '4': 'rgba(255,255,255,0.12)'
};

var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
var LIGHT_SHADOW = '';

var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');

var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
var DEFAULT_COLOR_TYPE = 'primary';

// A color in a theme will use these hues by default, if not specified by user.
var LIGHT_DEFAULT_HUES = {
  'accent': {
    'default': 'A200',
    'hue-1': 'A100',
    'hue-2': 'A400',
    'hue-3': 'A700'
  },
  'background': {
    'default': '50',
    'hue-1': 'A100',
    'hue-2': '100',
    'hue-3': '300'
  }
};

var DARK_DEFAULT_HUES = {
  'background': {
    'default': 'A400',
    'hue-1': '800',
    'hue-2': '900',
    'hue-3': 'A200'
  }
};
THEME_COLOR_TYPES.forEach(function(colorType) {
  // Color types with unspecified default hues will use these default hue values
  var defaultDefaultHues = {
    'default': '500',
    'hue-1': '300',
    'hue-2': '800',
    'hue-3': 'A100'
  };
  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
});

var VALID_HUE_VALUES = [
  '50', '100', '200', '300', '400', '500', '600',
  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
];

var themeConfig = {
  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
};

/**
 *
 */
function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
  ThemingService.$inject = ["$rootScope", "$mdUtil", "$q", "$log"];
  PALETTES = { };
  var THEMES = { };

  var themingProvider;

  var alwaysWatchTheme = false;
  var defaultTheme = 'default';

  // Load JS Defined Palettes
  angular.extend(PALETTES, $mdColorPalette);

  // Default theme defined in core.js

  /**
   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
   * @param {string} color Hex value of the wanted browser color
   * @returns {Function} Remove function of the meta tags
   */
  var setBrowserColor = function (color) {
    // Chrome, Firefox OS and Opera
    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
    // Windows Phone
    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);

    return function () {
      removeChrome();
      removeWindows();
    };
  };

  /**
   * Enables browser header coloring
   * for more info please visit:
   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
   *
   * The default color is `800` from `primary` palette of the `default` theme
   *
   * options are:
   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme
   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
   *             'accent', 'background' and 'warn'. Default is `primary`
   * `hue`     - The hue from the selected palette. Default is `800`
   *
   * @param {Object=} options Options object for the browser color
   * @returns {Function} remove function of the browser color
   */
  var enableBrowserColor = function (options) {
    options = angular.isObject(options) ? options : {};

    var theme = options.theme || 'default';
    var hue = options.hue || '800';

    var palette = PALETTES[options.palette] ||
      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];

    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];

    return setBrowserColor(color);
  };

  return themingProvider = {
    definePalette: definePalette,
    extendPalette: extendPalette,
    theme: registerTheme,

    /**
     * return a read-only clone of the current theme configuration
     */
    configuration : function() {
      return angular.extend( { }, themeConfig, {
        defaultTheme : defaultTheme,
        alwaysWatchTheme : alwaysWatchTheme,
        registeredStyles : [].concat(themeConfig.registeredStyles)
      });
    },

    /**
     * Easy way to disable theming without having to use
     * `.constant("$MD_THEME_CSS","");` This disables
     * all dynamic theme style sheet generations and injections...
     */
    disableTheming: function(isDisabled) {
      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
    },

    registerStyles: function(styles) {
      themeConfig.registeredStyles.push(styles);
    },

    setNonce: function(nonceValue) {
      themeConfig.nonce = nonceValue;
    },

    generateThemesOnDemand: function(onDemand) {
      themeConfig.generateOnDemand = onDemand;
    },

    setDefaultTheme: function(theme) {
      defaultTheme = theme;
    },

    alwaysWatchTheme: function(alwaysWatch) {
      alwaysWatchTheme = alwaysWatch;
    },

    enableBrowserColor: enableBrowserColor,

    $get: ThemingService,
    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
    _PALETTES: PALETTES,
    _THEMES: THEMES,
    _parseRules: parseRules,
    _rgba: rgba
  };

  // Example: $mdThemingProvider.definePalette('neonRed', { 50: '#f5fafa', ... });
  function definePalette(name, map) {
    map = map || {};
    PALETTES[name] = checkPaletteValid(name, map);
    return themingProvider;
  }

  // Returns an new object which is a copy of a given palette `name` with variables from
  // `map` overwritten
  // Example: var neonRedMap = $mdThemingProvider.extendPalette('red', { 50: '#f5fafafa' });
  function extendPalette(name, map) {
    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map) );
  }

  // Make sure that palette has all required hues
  function checkPaletteValid(name, map) {
    var missingColors = VALID_HUE_VALUES.filter(function(field) {
      return !map[field];
    });
    if (missingColors.length) {
      throw new Error("Missing colors %1 in palette %2!"
                      .replace('%1', missingColors.join(', '))
                      .replace('%2', name));
    }

    return map;
  }

  // Register a theme (which is a collection of color palettes to use with various states
  // ie. warn, accent, primary )
  // Optionally inherit from an existing theme
  // $mdThemingProvider.theme('custom-theme').primaryPalette('red');
  function registerTheme(name, inheritFrom) {
    if (THEMES[name]) return THEMES[name];

    inheritFrom = inheritFrom || 'default';

    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
    var theme = new Theme(name);

    if (parentTheme) {
      angular.forEach(parentTheme.colors, function(color, colorType) {
        theme.colors[colorType] = {
          name: color.name,
          // Make sure a COPY of the hues is given to the child color,
          // not the same reference.
          hues: angular.extend({}, color.hues)
        };
      });
    }
    THEMES[name] = theme;

    return theme;
  }

  function Theme(name) {
    var self = this;
    self.name = name;
    self.colors = {};

    self.dark = setDark;
    setDark(false);

    function setDark(isDark) {
      isDark = arguments.length === 0 ? true : !!isDark;

      // If no change, abort
      if (isDark === self.isDark) return;

      self.isDark = isDark;

      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;

      // Light and dark themes have different default hues.
      // Go through each existing color type for this theme, and for every
      // hue value that is still the default hue value from the previous light/dark setting,
      // set it to the default hue value from the new light/dark setting.
      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
        var color = self.colors[colorType];
        var oldDefaults = oldDefaultHues[colorType];
        if (color) {
          for (var hueName in color.hues) {
            if (color.hues[hueName] === oldDefaults[hueName]) {
              color.hues[hueName] = newDefaults[hueName];
            }
          }
        }
      });

      return self;
    }

    THEME_COLOR_TYPES.forEach(function(colorType) {
      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
        var color = self.colors[colorType] = {
          name: paletteName,
          hues: angular.extend({}, defaultHues, hues)
        };

        Object.keys(color.hues).forEach(function(name) {
          if (!defaultHues[name]) {
            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
              .replace('%1', name)
              .replace('%2', self.name)
              .replace('%3', paletteName)
              .replace('%4', Object.keys(defaultHues).join(', '))
            );
          }
        });
        Object.keys(color.hues).map(function(key) {
          return color.hues[key];
        }).forEach(function(hueValue) {
          if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
              .replace('%1', hueValue)
              .replace('%2', self.name)
              .replace('%3', colorType)
              .replace('%4', paletteName)
              .replace('%5', VALID_HUE_VALUES.join(', '))
            );
          }
        });
        return self;
      };

      self[colorType + 'Color'] = function() {
        var args = Array.prototype.slice.call(arguments);
        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
                     'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
        return self[colorType + 'Palette'].apply(self, args);
      };
    });
  }

  /**
   * @ngdoc service
   * @name $mdTheming
   * @module material.core.theming
   *
   * @description
   *
   * Service that makes an element apply theming related <b>classes</b> to itself.
   *
   * <hljs lang="js">
   * app.directive('myFancyDirective', function($mdTheming) {
   *   return {
   *     restrict: 'e',
   *     link: function(scope, el, attrs) {
   *       $mdTheming(el);
   *
   *       $mdTheming.defineTheme('myTheme', {
   *         primary: 'blue',
   *         accent: 'pink',
   *         dark: true
   *       })
   *     }
   *   };
   * });
   * </hljs>
   * @param {element=} element to apply theming to
   */

  /**
   * @ngdoc property
   * @name $mdTheming#THEMES
   * @description
   * Property to get all the themes defined
   * @returns {Object} All the themes defined with their properties
   */

  /**
   * @ngdoc property
   * @name $mdTheming#PALETTES
   * @description
   * Property to get all the palettes defined
   * @returns {Object} All the palettes defined with their colors
   */

  /**
   * @ngdoc method
   * @name $mdTheming#registered
   * @description
   * Determine is specified theme name is a valid, registered theme
   * @param {string} themeName the theme to check if registered
   * @returns {boolean} whether the theme is registered or not
   */

  /**
   * @ngdoc method
   * @name $mdTheming#defaultTheme
   * @description
   * Returns the default theme
   * @returns {string} The default theme
   */

  /**
   * @ngdoc method
   * @name $mdTheming#generateTheme
   * @description
   * Lazy generate themes - by default, every theme is generated when defined.
   * You can disable this in the configuration section using the
   * `$mdThemingProvider.generateThemesOnDemand(true);`
   *
   * The theme name that is passed in must match the name of the theme that was defined as part of the configuration block.
   *
   * @param name {string} theme name to generate
   */

  /**
   * @ngdoc method
   * @name $mdTheming#setBrowserColor
   * @description
   * Sets browser header coloring
   * for more info please visit:
   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
   *
   * The default color is `800` from `primary` palette of the `default` theme
   *
   * options are:<br/>
   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme.<br/>
   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
   *             'accent', 'background' and 'warn'. Default is `primary`<br/>
   * `hue`     - The hue from the selected palette. Default is `800`
   *
   * @param {Object} options Options object for the browser color
   * @returns {Function} remove function of the browser color
   */

  /**
   * @ngdoc method
   * @name $mdTheming#defineTheme
   * @description
   * Dynamically define a theme by an options object
   *
   * options are:<br/>
   * `primary`    - The primary palette of the theme.<br/>
   * `accent`     - The accent palette of the theme.<br/>
   * `warn`       - The warn palette of the theme.<br/>
   * `background` - The background palette of the theme.<br/>
   * `dark`       - Indicates if it's a dark theme.<br/>
   *
   * @param {String} name Theme name to define
   * @param {Object} options Theme definition options
   * @returns {Promise<string>} A resolved promise with the theme name
   */

  /* @ngInject */
  function ThemingService($rootScope, $mdUtil, $q, $log) {
        // Allow us to be invoked via a linking function signature.
    var applyTheme = function (scope, el) {
          if (el === undefined) { el = scope; scope = undefined; }
          if (scope === undefined) { scope = $rootScope; }
          applyTheme.inherit(el, el);
        };

    Object.defineProperty(applyTheme, 'THEMES', {
      get: function () {
        return angular.extend({}, THEMES);
      }
    });
    Object.defineProperty(applyTheme, 'PALETTES', {
      get: function () {
        return angular.extend({}, PALETTES);
      }
    });
    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
      get: function () {
        return alwaysWatchTheme;
      }
    });
    applyTheme.inherit = inheritTheme;
    applyTheme.registered = registered;
    applyTheme.defaultTheme = function() { return defaultTheme; };
    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
    applyTheme.defineTheme = function(name, options) {
      options = options || {};

      var theme = registerTheme(name);

      if (options.primary) {
        theme.primaryPalette(options.primary);
      }
      if (options.accent) {
        theme.accentPalette(options.accent);
      }
      if (options.warn) {
        theme.warnPalette(options.warn);
      }
      if (options.background) {
        theme.backgroundPalette(options.background);
      }
      if (options.dark){
        theme.dark();
      }

      this.generateTheme(name);

      return $q.resolve(name);
    };
    applyTheme.setBrowserColor = enableBrowserColor;

    return applyTheme;

    /**
     * Determine is specified theme name is a valid, registered theme
     */
    function registered(themeName) {
      if (themeName === undefined || themeName === '') return true;
      return applyTheme.THEMES[themeName] !== undefined;
    }

    /**
     * Get theme name for the element, then update with Theme CSS class
     */
    function inheritTheme (el, parent) {
      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');

      updateThemeClass(lookupThemeName());

      if (ctrl) {
        var watchTheme = alwaysWatchTheme ||
                         ctrl.$shouldWatch ||
                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));

        var unwatch = ctrl.registerChanges(function (name) {
          updateThemeClass(name);

          if (!watchTheme) {
            unwatch();
          }
          else {
            el.on('$destroy', unwatch);
          }
        });
      }

      /**
       * Find the theme name from the parent controller or element data
       */
      function lookupThemeName() {
        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
        return ctrl && ctrl.$mdTheme || (defaultTheme == 'default' ? '' : defaultTheme);
      }

      /**
       * Remove old theme class and apply a new one
       * NOTE: if not a valid theme name, then the current name is not changed
       */
      function updateThemeClass(theme) {
        if (!theme) return;
        if (!registered(theme)) {
          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
                    'Register it with $mdThemingProvider.theme().');
        }

        var oldTheme = el.data('$mdThemeName');
        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
        el.addClass('md-' + theme + '-theme');
        el.data('$mdThemeName', theme);
        if (ctrl) {
          el.data('$mdThemeController', ctrl);
        }
      }
    }

  }
}

function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
  return {
    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
    link: {
      pre: function(scope, el, attrs) {
        var registeredCallbacks = [];

        var startSymbol = $interpolate.startSymbol();
        var endSymbol = $interpolate.endSymbol();

        var theme = attrs.mdTheme.trim();

        var hasInterpolation =
          theme.substr(0, startSymbol.length) === startSymbol &&
          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;

        var oneTimeOperator = '::';
        var oneTimeBind = attrs.mdTheme
            .split(startSymbol).join('')
            .split(endSymbol).join('')
            .trim()
            .substr(0, oneTimeOperator.length) === oneTimeOperator;

        var ctrl = {
          registerChanges: function (cb, context) {
            if (context) {
              cb = angular.bind(context, cb);
            }

            registeredCallbacks.push(cb);

            return function () {
              var index = registeredCallbacks.indexOf(cb);

              if (index > -1) {
                registeredCallbacks.splice(index, 1);
              }
            };
          },
          $setTheme: function (theme) {
            if (!$mdTheming.registered(theme)) {
              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
            }

            ctrl.$mdTheme = theme;

            // Iterating backwards to support unregistering during iteration
            // http://stackoverflow.com/a/9882349/890293
            // we don't use `reverse()` of array because it mutates the array and we don't want it to get re-indexed
            for (var i = registeredCallbacks.length; i--;) {
              registeredCallbacks[i](theme);
            }
          },
          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
                        $mdTheming.ALWAYS_WATCH ||
                        (hasInterpolation && !oneTimeBind)
        };

        el.data('$mdThemeController', ctrl);

        var getTheme = function () {
          var interpolation = $interpolate(attrs.mdTheme)(scope);
          return $parse(interpolation)(scope) || interpolation;
        };

        var setParsedTheme = function (theme) {
          if (typeof theme === 'string') {
            return ctrl.$setTheme(theme);
          }

          $q.when( angular.isFunction(theme) ?  theme() : theme )
            .then(function(name){
              ctrl.$setTheme(name);
            });
        };

        setParsedTheme(getTheme());

        var unwatch = scope.$watch(getTheme, function(theme) {
          if (theme) {
            setParsedTheme(theme);

            if (!ctrl.$shouldWatch) {
              unwatch();
            }
          }
        });
      }
    }
  };
}

/**
 * Special directive that will disable ALL runtime Theme style generation and DOM injection
 *
 * <link rel="stylesheet" href="angular-material.min.css">
 * <link rel="stylesheet" href="angular-material.themes.css">
 *
 * <body md-themes-disabled>
 *  ...
 * </body>
 *
 * Note: Using md-themes-css directive requires the developer to load external
 * theme stylesheets; e.g. custom themes from Material-Tools:
 *
 *       `angular-material.themes.css`
 *
 * Another option is to use the ThemingProvider to configure and disable the attribute
 * conversions; this would obviate the use of the `md-themes-css` directive
 *
 */
function disableThemesDirective() {
  themeConfig.disableTheming = true;

  // Return a 1x-only, first-match attribute directive
  return {
    restrict : 'A',
    priority : '900'
  };
}

function ThemableDirective($mdTheming) {
  return $mdTheming;
}

function parseRules(theme, colorType, rules) {
  checkValidPalette(theme, colorType);

  rules = rules.replace(/THEME_NAME/g, theme.name);
  var generatedRules = [];
  var color = theme.colors[colorType];

  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
  // Matches '{{ primary-color }}', etc
  var hueRegex = new RegExp('(\'|")?{{\\s*(' + colorType + ')-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}(\"|\')?','g');
  var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue\-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
  var palette = PALETTES[color.name];

  // find and replace simple variables where we use a specific hue, not an entire palette
  // eg. "{{primary-100}}"
  //\(' + THEME_COLOR_TYPES.join('\|') + '\)'
  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, opacity, contrast) {
    if (colorType === 'foreground') {
      if (hue == 'shadow') {
        return theme.foregroundShadow;
      } else {
        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
      }
    }

    // `default` is also accepted as a hue-value, because the background palettes are
    // using it as a name for the default hue.
    if (hue.indexOf('hue') === 0 || hue === 'default') {
      hue = theme.colors[colorType].hues[hue];
    }

    return rgba( (PALETTES[ theme.colors[colorType].name ][hue] || '')[contrast ? 'contrast' : 'value'], opacity );
  });

  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
  angular.forEach(color.hues, function(hueValue, hueName) {
    var newRule = rules
      .replace(hueRegex, function(match, _, colorType, hueType, opacity) {
        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
      });
    if (hueName !== 'default') {
      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
    }

    // Don't apply a selector rule to the default theme, making it easier to override
    // styles of the base-component
    if (theme.name == 'default') {
      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;

      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
        return match + ', ' + start + end;
      });
    }
    generatedRules.push(newRule);
  });

  return generatedRules;
}

var rulesByType = {};

// Generate our themes at run time given the state of THEMES and PALETTES
function generateAllThemes($injector, $mdTheming) {
  var head = document.head;
  var firstChild = head ? head.firstElementChild : null;
  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';

  // Append our custom registered styles to the theme stylesheet.
  themeCss += themeConfig.registeredStyles.join('');

  if ( !firstChild ) return;
  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task

  // Expose contrast colors for palettes to ensure that text is always readable
  angular.forEach(PALETTES, sanitizePalette);

  // MD_THEME_CSS is a string generated by the build process that includes all the themable
  // components as templates

  // Break the CSS into individual rules
  var rules = themeCss
                  .split(/\}(?!(\}|'|"|;))/)
                  .filter(function(rule) { return rule && rule.trim().length; })
                  .map(function(rule) { return rule.trim() + '}'; });


  var ruleMatchRegex = new RegExp('md-(' + THEME_COLOR_TYPES.join('|') + ')', 'g');

  THEME_COLOR_TYPES.forEach(function(type) {
    rulesByType[type] = '';
  });


  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
  rules.forEach(function(rule) {
    var match = rule.match(ruleMatchRegex);
    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
      if (rule.indexOf('.md-' + type) > -1) {
        return rulesByType[type] += rule;
      }
    }

    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
    // there
    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
      if (rule.indexOf(type) > -1) {
        return rulesByType[type] += rule;
      }
    }

    // Default to the primary array
    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
  });

  // If themes are being generated on-demand, quit here. The user will later manually
  // call generateTheme to do this on a theme-by-theme basis.
  if (themeConfig.generateOnDemand) return;

  angular.forEach($mdTheming.THEMES, function(theme) {
    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
      generateTheme(theme, theme.name, themeConfig.nonce);
    }
  });


  // *************************
  // Internal functions
  // *************************

  // The user specifies a 'default' contrast color as either light or dark,
  // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
  function sanitizePalette(palette, name) {
    var defaultContrast = palette.contrastDefaultColor;
    var lightColors = palette.contrastLightColors || [];
    var strongLightColors = palette.contrastStrongLightColors || [];
    var darkColors = palette.contrastDarkColors || [];

    // These colors are provided as space-separated lists
    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');

    // Cleanup after ourselves
    delete palette.contrastDefaultColor;
    delete palette.contrastLightColors;
    delete palette.contrastStrongLightColors;
    delete palette.contrastDarkColors;

    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
    angular.forEach(palette, function(hueValue, hueName) {
      if (angular.isObject(hueValue)) return; // Already converted
      // Map everything to rgb colors
      var rgbValue = colorToRgbaArray(hueValue);
      if (!rgbValue) {
        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
                        .replace('%1', hueValue)
                        .replace('%2', palette.name)
                        .replace('%3', hueName));
      }

      palette[hueName] = {
        hex: palette[hueName],
        value: rgbValue,
        contrast: getContrastColor()
      };
      function getContrastColor() {
        if (defaultContrast === 'light') {
          if (darkColors.indexOf(hueName) > -1) {
            return DARK_CONTRAST_COLOR;
          } else {
            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
              : LIGHT_CONTRAST_COLOR;
          }
        } else {
          if (lightColors.indexOf(hueName) > -1) {
            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
              : LIGHT_CONTRAST_COLOR;
          } else {
            return DARK_CONTRAST_COLOR;
          }
        }
      }
    });
  }
}

function generateTheme(theme, name, nonce) {
  var head = document.head;
  var firstChild = head ? head.firstElementChild : null;

  if (!GENERATED[name]) {
    // For each theme, use the color palettes specified for
    // `primary`, `warn` and `accent` to generate CSS rules.
    THEME_COLOR_TYPES.forEach(function(colorType) {
      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
      while (styleStrings.length) {
        var styleContent = styleStrings.shift();
        if (styleContent) {
          var style = document.createElement('style');
          style.setAttribute('md-theme-style', '');
          if (nonce) {
            style.setAttribute('nonce', nonce);
          }
          style.appendChild(document.createTextNode(styleContent));
          head.insertBefore(style, firstChild);
        }
      }
    });

    GENERATED[theme.name] = true;
  }

}


function checkValidPalette(theme, colorType) {
  // If theme attempts to use a palette that doesnt exist, throw error
  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
    throw new Error(
      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
                    .replace('%1', theme.name)
                    .replace('%2', colorType)
                    .replace('%3', Object.keys(PALETTES).join(', '))
    );
  }
}

function colorToRgbaArray(clr) {
  if (angular.isArray(clr) && clr.length == 3) return clr;
  if (/^rgb/.test(clr)) {
    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
      return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
    });
  }
  if (clr.charAt(0) == '#') clr = clr.substring(1);
  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;

  var dig = clr.length / 3;
  var red = clr.substr(0, dig);
  var grn = clr.substr(dig, dig);
  var blu = clr.substr(dig * 2);
  if (dig === 1) {
    red += red;
    grn += grn;
    blu += blu;
  }
  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
}

function rgba(rgbArray, opacity) {
  if ( !rgbArray ) return "rgb('0,0,0')";

  if (rgbArray.length == 4) {
    rgbArray = angular.copy(rgbArray);
    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
  }
  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
    'rgb(' + rgbArray.join(',') + ')';
}


})(window.angular);

})();
(function(){
"use strict";

// Polyfill angular < 1.4 (provide $animateCss)
angular
  .module('material.core')
  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss){

     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils

     return function($mdUtil) {
       return AnimateDomUtils( $mdUtil, $q, $timeout, $mdConstant, $animateCss);
     };
   }]);

/**
 * Factory function that requires special injections
 */
function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
  var self;
  return self = {
    /**
     *
     */
    translate3d : function( target, from, to, options ) {
      return $animateCss(target, {
        from: from,
        to: to,
        addClass: options.transitionInClass,
        removeClass: options.transitionOutClass,
        duration: options.duration
      })
      .start()
      .then(function(){
          // Resolve with reverser function...
          return reverseTranslate;
      });

      /**
       * Specific reversal of the request translate animation above...
       */
      function reverseTranslate (newFrom) {
        return $animateCss(target, {
           to: newFrom || from,
           addClass: options.transitionOutClass,
           removeClass: options.transitionInClass,
           duration: options.duration
        }).start();

      }
    },

    /**
     * Listen for transitionEnd event (with optional timeout)
     * Announce completion or failure via promise handlers
     */
    waitTransitionEnd: function (element, opts) {
      var TIMEOUT = 3000; // fallback is 3 secs

      return $q(function(resolve, reject){
        opts = opts || { };

        // If there is no transition is found, resolve immediately
        //
        // NOTE: using $mdUtil.nextTick() causes delays/issues
        if (noTransitionFound(opts.cachedTransitionStyles)) {
          TIMEOUT = 0;
        }

        var timer = $timeout(finished, opts.timeout || TIMEOUT);
        element.on($mdConstant.CSS.TRANSITIONEND, finished);

        /**
         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
         * NOTE: Make sure this transitionEnd didn't bubble up from a child
         */
        function finished(ev) {
          if ( ev && ev.target !== element[0]) return;

          if ( ev  ) $timeout.cancel(timer);
          element.off($mdConstant.CSS.TRANSITIONEND, finished);

          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
          resolve();

        }

        /**
         * Checks whether or not there is a transition.
         *
         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
         * will be used.
         *
         * @returns {boolean} True if there is no transition/duration; false otherwise.
         */
        function noTransitionFound(styles) {
          styles = styles || window.getComputedStyle(element[0]);

          return styles.transitionDuration == '0s' || (!styles.transition && !styles.transitionProperty);
        }

      });
    },

    calculateTransformValues: function (element, originator) {
      var origin = originator.element;
      var bounds = originator.bounds;

      if (origin || bounds) {
        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
        var dialogCenterPt = self.centerPointFor(dialogRect);
        var originCenterPt = self.centerPointFor(originBnds);

        return {
          centerX: originCenterPt.x - dialogCenterPt.x,
          centerY: originCenterPt.y - dialogCenterPt.y,
          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
        };
      }
      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};

      /**
       * This is a fallback if the origin information is no longer valid, then the
       * origin bounds simply becomes the current bounds for the dialogContainer's parent
       */
      function currentBounds() {
        var cntr = element ? element.parent() : null;
        var parent = cntr ? cntr.parent() : null;

        return parent ? self.clientRect(parent) : null;
      }
    },

    /**
     * Calculate the zoom transform from dialog to origin.
     *
     * We use this to set the dialog position immediately;
     * then the md-transition-in actually translates back to
     * `translate3d(0,0,0) scale(1.0)`...
     *
     * NOTE: all values are rounded to the nearest integer
     */
    calculateZoomToOrigin: function (element, originator) {
      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);

      return buildZoom(self.calculateTransformValues(element, originator));
    },

    /**
     * Calculate the slide transform from panel to origin.
     * NOTE: all values are rounded to the nearest integer
     */
    calculateSlideToOrigin: function (element, originator) {
      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);

      return buildSlide(self.calculateTransformValues(element, originator));
    },

    /**
     * Enhance raw values to represent valid css stylings...
     */
    toCss : function( raw ) {
      var css = { };
      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';

      angular.forEach(raw, function(value,key) {
        if ( angular.isUndefined(value) ) return;

        if ( lookups.indexOf(key) >= 0 ) {
          css[key] = value + 'px';
        } else {
          switch (key) {
            case 'transition':
              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
              break;
            case 'transform':
              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
              break;
            case 'transformOrigin':
              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
              break;
            case 'font-size':
              css['font-size'] = value; // font sizes aren't always in px
              break;
          }
        }
      });

      return css;

      function convertToVendor(key, vendor, value) {
        angular.forEach(vendor.split(' '), function (key) {
          css[key] = value;
        });
      }
    },

    /**
     * Convert the translate CSS value to key/value pair(s).
     */
    toTransformCss: function (transform, addTransition, transition) {
      var css = {};
      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
        css[key] = transform;
      });

      if (addTransition) {
        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
        css.transition = transition;
      }

      return css;
    },

    /**
     *  Clone the Rect and calculate the height/width if needed
     */
    copyRect: function (source, destination) {
      if (!source) return null;

      destination = destination || {};

      angular.forEach('left top right bottom width height'.split(' '), function (key) {
        destination[key] = Math.round(source[key]);
      });

      destination.width = destination.width || (destination.right - destination.left);
      destination.height = destination.height || (destination.bottom - destination.top);

      return destination;
    },

    /**
     * Calculate ClientRect of element; return null if hidden or zero size
     */
    clientRect: function (element) {
      var bounds = angular.element(element)[0].getBoundingClientRect();
      var isPositiveSizeClientRect = function (rect) {
        return rect && (rect.width > 0) && (rect.height > 0);
      };

      // If the event origin element has zero size, it has probably been hidden.
      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
    },

    /**
     *  Calculate 'rounded' center point of Rect
     */
    centerPointFor: function (targetRect) {
      return targetRect ? {
        x: Math.round(targetRect.left + (targetRect.width / 2)),
        y: Math.round(targetRect.top + (targetRect.height / 2))
      } : { x : 0, y : 0 };
    }

  };
}


})();
(function(){
"use strict";

if (angular.version.minor >= 4) {
  angular.module('material.core.animate', []);
} else {
(function() {
  "use strict";

  var forEach = angular.forEach;

  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
  var PREFIX = WEBKIT ? '-webkit-' : '';

  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';

  var $$ForceReflowFactory = ['$document', function($document) {
    return function() {
      return $document[0].body.clientWidth + 1;
    };
  }];

  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
    return function() {
      var passed = false;
      $$rAF(function() {
        passed = true;
      });
      return function(fn) {
        passed ? fn() : $$rAF(fn);
      };
    };
  }];

  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    function AnimateRunner(host) {
      this.setHost(host);

      this._doneCallbacks = [];
      this._runInAnimationFrame = $$rAFMutex();
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: angular.noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              status === false ? reject() : resolve();
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._runInAnimationFrame(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    // Polyfill AnimateRunner.all which is used by input animations
    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    return AnimateRunner;
  }];

  angular
    .module('material.core.animate', [])
    .factory('$$forceReflow', $$ForceReflowFactory)
    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
    .factory('$$rAFMutex', $$rAFMutexFactory)
    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {

      function init(element, options) {

        var temporaryStyles = [];
        var node = getDomNode(element);
        var areAnimationsAllowed = node && $animate.enabled();

        var hasCompleteStyles = false;
        var hasCompleteClasses = false;

        if (areAnimationsAllowed) {
          if (options.transitionStyle) {
            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
          }

          if (options.keyframeStyle) {
            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
          }

          if (options.delay) {
            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
          }

          if (options.duration) {
            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
          }

          hasCompleteStyles = options.keyframeStyle ||
              (options.to && (options.duration > 0 || options.transitionStyle));
          hasCompleteClasses = !!options.addClass || !!options.removeClass;

          blockTransition(element, true);
        }

        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);

        applyAnimationFromStyles(element, options);

        var animationClosed = false;
        var events, eventFn;

        return {
          close: $window.close,
          start: function() {
            var runner = new $$AnimateRunner();
            waitUntilQuiet(function() {
              blockTransition(element, false);
              if (!hasCompleteAnimation) {
                return close();
              }

              forEach(temporaryStyles, function(entry) {
                var key = entry[0];
                var value = entry[1];
                node.style[camelCase(key)] = value;
              });

              applyClasses(element, options);

              var timings = computeTimings(element);
              if (timings.duration === 0) {
                return close();
              }

              var moreStyles = [];

              if (options.easing) {
                if (timings.transitionDuration) {
                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
                }
                if (timings.animationDuration) {
                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
                }
              }

              if (options.delay && timings.animationDelay) {
                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
              }

              if (options.duration && timings.animationDuration) {
                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
              }

              forEach(moreStyles, function(entry) {
                var key = entry[0];
                var value = entry[1];
                node.style[camelCase(key)] = value;
                temporaryStyles.push(entry);
              });

              var maxDelay = timings.delay;
              var maxDelayTime = maxDelay * 1000;
              var maxDuration = timings.duration;
              var maxDurationTime = maxDuration * 1000;
              var startTime = Date.now();

              events = [];
              if (timings.transitionDuration) {
                events.push(TRANSITION_EVENTS);
              }
              if (timings.animationDuration) {
                events.push(ANIMATION_EVENTS);
              }
              events = events.join(' ');
              eventFn = function(event) {
                event.stopPropagation();
                var ev = event.originalEvent || event;
                var timeStamp = ev.timeStamp || Date.now();
                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
                  close();
                }
              };
              element.on(events, eventFn);

              applyAnimationToStyles(element, options);

              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
            });

            return runner;

            function close() {
              if (animationClosed) return;
              animationClosed = true;

              if (events && eventFn) {
                element.off(events, eventFn);
              }
              applyClasses(element, options);
              applyAnimationStyles(element, options);
              forEach(temporaryStyles, function(entry) {
                node.style[camelCase(entry[0])] = '';
              });
              runner.complete(true);
              return runner;
            }
          }
        };
      }

      function applyClasses(element, options) {
        if (options.addClass) {
          $$jqLite.addClass(element, options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          $$jqLite.removeClass(element, options.removeClass);
          options.removeClass = null;
        }
      }

      function computeTimings(element) {
        var node = getDomNode(element);
        var cs = $window.getComputedStyle(node);
        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
        var adr = parseMaxTime(cs[prop('animationDuration')]);
        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
        var ady = parseMaxTime(cs[prop('animationDelay')]);

        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
        var duration = Math.max(adr, tdr);
        var delay = Math.max(ady, tdy);

        return {
          duration: duration,
          delay: delay,
          animationDuration: adr,
          transitionDuration: tdr,
          animationDelay: ady,
          transitionDelay: tdy
        };

        function prop(key) {
          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
                        : key;
        }
      }

      function parseMaxTime(str) {
        var maxValue = 0;
        var values = (str || "").split(/\s*,\s*/);
        forEach(values, function(value) {
          // it's always safe to consider only second values and omit `ms` values since
          // getComputedStyle will always handle the conversion for us
          if (value.charAt(value.length - 1) == 's') {
            value = value.substring(0, value.length - 1);
          }
          value = parseFloat(value) || 0;
          maxValue = maxValue ? Math.max(value, maxValue) : value;
        });
        return maxValue;
      }

      var cancelLastRAFRequest;
      var rafWaitQueue = [];
      function waitUntilQuiet(callback) {
        if (cancelLastRAFRequest) {
          cancelLastRAFRequest(); //cancels the request
        }
        rafWaitQueue.push(callback);
        cancelLastRAFRequest = $$rAF(function() {
          cancelLastRAFRequest = null;

          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
          var pageWidth = $$forceReflow();

          // we use a for loop to ensure that if the queue is changed
          // during this looping then it will consider new requests
          for (var i = 0; i < rafWaitQueue.length; i++) {
            rafWaitQueue[i](pageWidth);
          }
          rafWaitQueue.length = 0;
        });
      }

      function applyAnimationStyles(element, options) {
        applyAnimationFromStyles(element, options);
        applyAnimationToStyles(element, options);
      }

      function applyAnimationFromStyles(element, options) {
        if (options.from) {
          element.css(options.from);
          options.from = null;
        }
      }

      function applyAnimationToStyles(element, options) {
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }

      function getDomNode(element) {
        for (var i = 0; i < element.length; i++) {
          if (element[i].nodeType === 1) return element[i];
        }
      }

      function blockTransition(element, bool) {
        var node = getDomNode(element);
        var key = camelCase(PREFIX + 'transition-delay');
        node.style[key] = bool ? '-9999s' : '';
      }

      return init;
    }]);

  /**
   * Older browsers [FF31] expect camelCase
   * property keys.
   * e.g.
   *  animation-duration --> animationDuration
   */
  function camelCase(str) {
    return str.replace(/-[a-z]/g, function(str) {
      return str.charAt(1).toUpperCase();
    });
  }

})();

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.autocomplete
 */
/*
 * @see js folder for autocomplete implementation
 */
angular.module('material.components.autocomplete', [
  'material.core',
  'material.components.icon',
  'material.components.virtualRepeat'
]);

})();
(function(){
"use strict";

/*
 * @ngdoc module
 * @name material.components.backdrop
 * @description Backdrop
 */

/**
 * @ngdoc directive
 * @name mdBackdrop
 * @module material.components.backdrop
 *
 * @restrict E
 *
 * @description
 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
 * Apply class `opaque` to make the backdrop use the theme backdrop color.
 *
 */

angular
  .module('material.components.backdrop', ['material.core'])
  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';

    return {
      restrict: 'E',
      link: postLink
    };

    function postLink(scope, element, attrs) {
      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
      if ($animate.pin) $animate.pin(element, $rootElement);

      var bodyStyles;

      $$rAF(function() {
        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
        // Note that this can be pretty expensive and is better done inside the $$rAF.
        bodyStyles = $window.getComputedStyle($document[0].body);

        if (bodyStyles.position === 'fixed') {
          var resizeHandler = $mdUtil.debounce(function(){
            bodyStyles = $window.getComputedStyle($document[0].body);
            resize();
          }, 60, null, false);

          resize();
          angular.element($window).on('resize', resizeHandler);

          scope.$on('$destroy', function() {
            angular.element($window).off('resize', resizeHandler);
          });
        }

        // Often $animate.enter() is used to append the backDrop element
        // so let's wait until $animate is done...
        var parent = element.parent();

        if (parent.length) {
          if (parent[0].nodeName === 'BODY') {
            element.css('position', 'fixed');
          }

          var styles = $window.getComputedStyle(parent[0]);

          if (styles.position === 'static') {
            // backdrop uses position:absolute and will not work properly with parent position:static (default)
            $log.warn(ERROR_CSS_POSITION);
          }

          // Only inherit the parent if the backdrop has a parent.
          $mdTheming.inherit(element, parent);
        }
      });

      function resize() {
        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
        element.css('height', viewportHeight + 'px');
      }
    }

  }]);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.bottomSheet
 * @description
 * BottomSheet
 */
MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
angular
  .module('material.components.bottomSheet', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdBottomSheet', MdBottomSheetDirective)
  .provider('$mdBottomSheet', MdBottomSheetProvider);

/* @ngInject */
function MdBottomSheetDirective($mdBottomSheet) {
  return {
    restrict: 'E',
    link : function postLink(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      // When navigation force destroys an interimElement, then
      // listen and $destroy() that interim instance...
      scope.$on('$destroy', function() {
        $mdBottomSheet.destroy();
      });
    }
  };
}


/**
 * @ngdoc service
 * @name $mdBottomSheet
 * @module material.components.bottomSheet
 *
 * @description
 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
 *
 * ## Restrictions
 *
 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
 * - Add the `md-grid` class to the bottom sheet for a grid layout.
 * - Add the `md-list` class to the bottom sheet for a list layout.
 *
 * @usage
 * <hljs lang="html">
 * <div ng-controller="MyController">
 *   <md-button ng-click="openBottomSheet()">
 *     Open a Bottom Sheet!
 *   </md-button>
 * </div>
 * </hljs>
 * <hljs lang="js">
 * var app = angular.module('app', ['ngMaterial']);
 * app.controller('MyController', function($scope, $mdBottomSheet) {
 *   $scope.openBottomSheet = function() {
 *     $mdBottomSheet.show({
 *       template: '<md-bottom-sheet>' +
 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
 *       '</md-bottom-sheet>'
 *     })
 *
 *     // Fires when the hide() method is used
 *     .then(function() {
 *       console.log('You clicked the button to close the bottom sheet!');
 *     })
 *
 *     // Fires when the cancel() method is used
 *     .catch(function() {
 *       console.log('You hit escape or clicked the backdrop to close.');
 *     });
 *   };
 *
 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
 *     $mdBottomSheet.hide();
 *   }
 *
 * });
 * </hljs>
 */

 /**
 * @ngdoc method
 * @name $mdBottomSheet#show
 *
 * @description
 * Show a bottom sheet with the specified options.
 *
 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
 * section above for an example.
 *
 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
 * this.</em>
 *
 * @param {object} options An options object, with the following properties:
 *
 *   - `templateUrl` - `{string=}`: The url of an html template file that will
 *   be used as the content of the bottom sheet. Restrictions: the template must
 *   have an outer `md-bottom-sheet` element.
 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
 *   template string.
 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
 *   be used as names of values to inject into the controller. For example,
 *   `locals: {three: 3}` would inject `three` into the controller with the value
 *   of 3.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
 *     close it. Default true.
 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the controller instance.
 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
 *     Default true.
 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
 *   and the bottom sheet will not open until the promises resolve.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
 *   e.g. angular.element(document.getElementById('content')) or "#content"
 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
 *     Default true.
 *
 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
 * rejected with `$mdBottomSheet.cancel()`.
 */

/**
 * @ngdoc method
 * @name $mdBottomSheet#hide
 *
 * @description
 * Hide the existing bottom sheet and resolve the promise returned from
 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if
 * any).
 *
 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
 *
 * @param {*=} response An argument for the resolved promise.
 *
 */

/**
 * @ngdoc method
 * @name $mdBottomSheet#cancel
 *
 * @description
 * Hide the existing bottom sheet and reject the promise returned from
 * `$mdBottomSheet.show()`.
 *
 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
 *
 * @param {*=} response An argument for the rejected promise.
 *
 */

function MdBottomSheetProvider($$interimElementProvider) {
  // how fast we need to flick down to close the sheet, pixels/ms
  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
  var CLOSING_VELOCITY = 0.5;
  var PADDING = 80; // same as css

  return $$interimElementProvider('$mdBottomSheet')
    .setDefaults({
      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
      options: bottomSheetDefaults
    });

  /* @ngInject */
  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
                               $mdGesture, $log) {
    var backdrop;

    return {
      themable: true,
      onShow: onShow,
      onRemove: onRemove,
      disableBackdrop: false,
      escapeToClose: true,
      clickOutsideToClose: true,
      disableParentScroll: true
    };


    function onShow(scope, element, options, controller) {

      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');

      // prevent tab focus or click focus on the bottom-sheet container
      element.attr('tabindex',"-1");

      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
      // This is a very common problem, so we have to notify the developer about this.
      if (element.hasClass('ng-cloak')) {
        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak >` will affect the bottom-sheet opening animations.';
        $log.warn( message, element[0] );
      }

      if (!options.disableBackdrop) {
        // Add a backdrop that will close on click
        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");

        // Prevent mouse focus on backdrop; ONLY programatic focus allowed.
        // This allows clicks on backdrop to propogate to the $rootElement and
        // ESC key events to be detected properly.
        
        backdrop[0].tabIndex = -1;

        if (options.clickOutsideToClose) {
          backdrop.on('click', function() {
            $mdUtil.nextTick($mdBottomSheet.cancel,true);
          });
        }

        $mdTheming.inherit(backdrop, options.parent);

        $animate.enter(backdrop, options.parent, null);
      }

      var bottomSheet = new BottomSheet(element, options.parent);
      options.bottomSheet = bottomSheet;

      $mdTheming.inherit(bottomSheet.element, options.parent);

      if (options.disableParentScroll) {
        options.restoreScroll = $mdUtil.disableScrollAround(bottomSheet.element, options.parent);
      }

      return $animate.enter(bottomSheet.element, options.parent, backdrop)
        .then(function() {
          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
            element[0].querySelector('button') ||
            element[0].querySelector('a') ||
            element[0].querySelector($mdUtil.prefixer('ng-click', true))
          ) || backdrop;

          if (options.escapeToClose) {
            options.rootElementKeyupCallback = function(e) {
              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
                $mdUtil.nextTick($mdBottomSheet.cancel,true);
              }
            };

            $rootElement.on('keyup', options.rootElementKeyupCallback);
            focusable && focusable.focus();
          }
        });

    }

    function onRemove(scope, element, options) {

      var bottomSheet = options.bottomSheet;

      if (!options.disableBackdrop) $animate.leave(backdrop);
      return $animate.leave(bottomSheet.element).then(function() {
        if (options.disableParentScroll) {
          options.restoreScroll();
          delete options.restoreScroll;
        }

        bottomSheet.cleanup();
      });
    }

    /**
     * BottomSheet class to apply bottom-sheet behavior to an element
     */
    function BottomSheet(element, parent) {
      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
      parent.on('$md.dragstart', onDragStart)
        .on('$md.drag', onDrag)
        .on('$md.dragend', onDragEnd);

      return {
        element: element,
        cleanup: function cleanup() {
          deregister();
          parent.off('$md.dragstart', onDragStart);
          parent.off('$md.drag', onDrag);
          parent.off('$md.dragend', onDragEnd);
        }
      };

      function onDragStart(ev) {
        // Disable transitions on transform so that it feels fast
        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
      }

      function onDrag(ev) {
        var transform = ev.pointer.distanceY;
        if (transform < 5) {
          // Slow down drag when trying to drag up, and stop after PADDING
          transform = Math.max(-PADDING, transform / 2);
        }
        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
      }

      function onDragEnd(ev) {
        if (ev.pointer.distanceY > 0 &&
            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
          $mdUtil.nextTick($mdBottomSheet.cancel,true);
        } else {
          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
          element.css($mdConstant.CSS.TRANSFORM, '');
        }
      }
    }

  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.button
 * @description
 *
 * Button
 */
MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
MdAnchorDirective.$inject = ["$mdTheming"];
angular
    .module('material.components.button', [ 'material.core' ])
    .directive('mdButton', MdButtonDirective)
    .directive('a', MdAnchorDirective);


/**
 * @private
 * @restrict E
 *
 * @description
 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
 *
 * @usage
 *
 * <hljs lang="html">
 *  <md-content md-theme="myTheme">
 *    <a href="#chapter1" class="md-accent"></a>
 *  </md-content>
 * </hljs>
 */
function MdAnchorDirective($mdTheming) {
  return {
    restrict : 'E',
    link : function postLink(scope, element) {
      // Make sure to inherit theme so stand-alone anchors
      // support theme colors for md-primary, md-accent, etc.
      $mdTheming(element);
    }
  };
}


/**
 * @ngdoc directive
 * @name mdButton
 * @module material.components.button
 *
 * @restrict E
 *
 * @description
 * `<md-button>` is a button directive with optional ink ripples (default enabled).
 *
 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
 * will become a `<button>` element. As per the
 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
 * the FAB button background is filled with the accent color [by default]. The primary color palette
 * may be used with the `md-primary` class.
 *
 * Developers can also change the color palette of the button, by using the following classes
 * - `md-primary`
 * - `md-accent`
 * - `md-warn`
 *
 * See for example
 *
 * <hljs lang="html">
 *   <md-button class="md-primary">Primary Button</md-button>
 * </hljs>
 *
 * Button can be also raised, which means that they will use the current color palette to fill the button.
 *
 * <hljs lang="html">
 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
 * </hljs>
 *
 * It is also possible to disable the focus effect on the button, by using the following markup.
 *
 * <hljs lang="html">
 *   <md-button class="md-no-focus">No Focus Style</md-button>
 * </hljs>
 *
 * @param {boolean=} md-no-ink If present, disable ripple ink effects.
 * @param {expression=} ng-disabled En/Disable based on the expression
 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`
 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
 * If no default text is found, a warning will be logged.
 *
 * @usage
 *
 * Regular buttons:
 *
 * <hljs lang="html">
 *  <md-button> Flat Button </md-button>
 *  <md-button href="http://google.com"> Flat link </md-button>
 *  <md-button class="md-raised"> Raised Button </md-button>
 *  <md-button ng-disabled="true"> Disabled Button </md-button>
 *  <md-button>
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *    Register Now
 *  </md-button>
 * </hljs>
 *
 * FAB buttons:
 *
 * <hljs lang="html">
 *  <md-button class="md-fab" aria-label="FAB">
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *  </md-button>
 *  <!-- mini-FAB -->
 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *  </md-button>
 *  <!-- Button with SVG Icon -->
 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
 *  </md-button>
 * </hljs>
 */
function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {

  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: getTemplate,
    link: postLink
  };

  function isAnchor(attr) {
    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
  }

  function getTemplate(element, attr) {
    if (isAnchor(attr)) {
      return '<a class="md-button" ng-transclude></a>';
    } else {
      //If buttons don't have type="button", they will submit forms automatically.
      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
    }
  }

  function postLink(scope, element, attr) {
    $mdTheming(element);
    $mdButtonInkRipple.attach(scope, element);

    // Use async expect to support possible bindings in the button label
    $mdAria.expectWithoutText(element, 'aria-label');

    // For anchor elements, we have to set tabindex manually when the
    // element is disabled
    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) ) {
      scope.$watch(attr.ngDisabled, function(isDisabled) {
        element.attr('tabindex', isDisabled ? -1 : 0);
      });
    }

    // disabling click event when disabled is true
    element.on('click', function(e){
      if (attr.disabled === true) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    if (!element.hasClass('md-no-focus')) {

      element.on('focus', function() {

        // Only show the focus effect when being focused through keyboard interaction or programmatically
        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
          element.addClass('md-focused');
        }

      });

      element.on('blur', function() {
        element.removeClass('md-focused');
      });
    }

  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.card
 *
 * @description
 * Card components.
 */
mdCardDirective.$inject = ["$mdTheming"];
angular.module('material.components.card', [
    'material.core'
  ])
  .directive('mdCard', mdCardDirective);


/**
 * @ngdoc directive
 * @name mdCard
 * @module material.components.card
 *
 * @restrict E
 *
 * @description
 * The `<md-card>` directive is a container element used within `<md-content>` containers.
 *
 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
 * optionally included to put content flush against the bottom edge of the card.
 *
 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
 * You can then position buttons using layout attributes.
 *
 * Card is built with:
 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
 *  - `<md-card-avatar>` - Card avatar
 *    - `md-user-avatar` - Class for user image
 *    - `<md-icon>`
 *  - `<md-card-header-text>` - Contains elements for the card description
 *    - `md-title` - Class for the card title
 *    - `md-subhead` - Class for the card sub header
 * * `<img>` - Image for the card
 * * `<md-card-title>` - Card content title
 *  - `<md-card-title-text>`
 *    - `md-headline` - Class for the card content title
 *    - `md-subhead` - Class for the card content sub header
 *  - `<md-card-title-media>` - Squared image within the title
 *    - `md-media-sm` - Class for small image
 *    - `md-media-md` - Class for medium image
 *    - `md-media-lg` - Class for large image
 *    - `md-media-xl` - Class for extra large image
 * * `<md-card-content>` - Card content
 * * `<md-card-actions>` - Card actions
 *  - `<md-card-icon-actions>` - Icon actions
 *
 * Cards have constant width and variable heights; where the maximum height is limited to what can
 * fit within a single view on a platform, but it can temporarily expand as needed.
 *
 * @usage
 * ### Card with optional footer
 * <hljs lang="html">
 * <md-card>
 *  <img src="card-image.png" class="md-card-image" alt="image caption">
 *  <md-card-content>
 *    <h2>Card headline</h2>
 *    <p>Card content</p>
 *  </md-card-content>
 *  <md-card-footer>
 *    Card footer
 *  </md-card-footer>
 * </md-card>
 * </hljs>
 *
 * ### Card with actions
 * <hljs lang="html">
 * <md-card>
 *  <img src="card-image.png" class="md-card-image" alt="image caption">
 *  <md-card-content>
 *    <h2>Card headline</h2>
 *    <p>Card content</p>
 *  </md-card-content>
 *  <md-card-actions layout="row" layout-align="end center">
 *    <md-button>Action 1</md-button>
 *    <md-button>Action 2</md-button>
 *  </md-card-actions>
 * </md-card>
 * </hljs>
 *
 * ### Card with header, image, title actions and content
 * <hljs lang="html">
 * <md-card>
 *   <md-card-header>
 *     <md-card-avatar>
 *       <img class="md-user-avatar" src="avatar.png"/>
 *     </md-card-avatar>
 *     <md-card-header-text>
 *       <span class="md-title">Title</span>
 *       <span class="md-subhead">Sub header</span>
 *     </md-card-header-text>
 *   </md-card-header>
 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
 *   <md-card-title>
 *     <md-card-title-text>
 *       <span class="md-headline">Card headline</span>
 *       <span class="md-subhead">Card subheader</span>
 *     </md-card-title-text>
 *   </md-card-title>
 *   <md-card-actions layout="row" layout-align="start center">
 *     <md-button>Action 1</md-button>
 *     <md-button>Action 2</md-button>
 *     <md-card-icon-actions>
 *       <md-button class="md-icon-button" aria-label="icon">
 *         <md-icon md-svg-icon="icon"></md-icon>
 *       </md-button>
 *     </md-card-icon-actions>
 *   </md-card-actions>
 *   <md-card-content>
 *     <p>
 *      Card content
 *     </p>
 *   </md-card-content>
 * </md-card>
 * </hljs>
 */
function mdCardDirective($mdTheming) {
  return {
    restrict: 'E',
    link: function ($scope, $element, attr) {
      $element.addClass('_md');     // private md component indicator for styling
      $mdTheming($element);
    }
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.chips
 */
/*
 * @see js folder for chips implementation
 */
angular.module('material.components.chips', [
  'material.core',
  'material.components.autocomplete'
]);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.checkbox
 * @description Checkbox module!
 */
MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
angular
  .module('material.components.checkbox', ['material.core'])
  .directive('mdCheckbox', MdCheckboxDirective);

/**
 * @ngdoc directive
 * @name mdCheckbox
 * @module material.components.checkbox
 * @restrict E
 *
 * @description
 * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-color-schemes)
 * the checkbox is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * @param {string} ng-model Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user interaction with the input element.
 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
 * @param {string=} aria-label Adds label to checkbox for accessibility.
 *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
 *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
 *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
 *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time.
 *     Adding the 'md-indeterminate' attribute overrides any checked/unchecked rendering logic.
 *     When using the 'md-indeterminate' attribute use 'ng-checked' to define rendering logic instead of using 'ng-model'.
 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css class is added to the checkbox and it
 *     will appear checked.
 *
 * @usage
 * <hljs lang="html">
 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
 *   Finished ?
 * </md-checkbox>
 *
 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
 *   No Ink Effects
 * </md-checkbox>
 *
 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
 *   Disabled
 * </md-checkbox>
 *
 * </hljs>
 *
 */
function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
  inputDirective = inputDirective[0];

  return {
    restrict: 'E',
    transclude: true,
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    priority: $mdConstant.BEFORE_NG_ARIA,
    template:
      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
        '<div class="md-icon"></div>' +
      '</div>' +
      '<div ng-transclude class="md-label"></div>',
    compile: compile
  };

  // **********************************************************
  // Private Methods
  // **********************************************************

  function compile (tElement, tAttrs) {
    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
    tAttrs.$set('type', 'checkbox');
    tAttrs.$set('role', tAttrs.type);

    return  {
      pre: function(scope, element) {
        // Attach a click handler during preLink, in order to immediately stop propagation
        // (especially for ng-click) when the checkbox is disabled.
        element.on('click', function(e) {
          if (this.hasAttribute('disabled')) {
            e.stopImmediatePropagation();
          }
        });
      },
      post: postLink
    };

    function postLink(scope, element, attr, ctrls) {
      var isIndeterminate;
      var containerCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
      var formCtrl = ctrls[2];

      if (containerCtrl) {
        var isErrorGetter = containerCtrl.isErrorGetter || function() {
          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
        };

        containerCtrl.input = element;

        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
      }

      $mdTheming(element);

      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
      element.children().on('focus', function() {
        element.focus();
      });

      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
        setIndeterminateState();
        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
      }

      if (attr.ngChecked) {
        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
          ngModelCtrl.$setViewValue(value);
          ngModelCtrl.$render();
        });
      }

      $$watchExpr('ngDisabled', 'tabindex', {
        true: '-1',
        false: attr.tabindex
      });

      $mdAria.expectWithText(element, 'aria-label');

      // Reuse the original input[type=checkbox] directive from AngularJS core.
      // This is a bit hacky as we need our own event listener and own render
      // function.
      inputDirective.link.pre(scope, {
        on: angular.noop,
        0: {}
      }, attr, [ngModelCtrl]);

      element.on('click', listener)
        .on('keypress', keypressHandler)
        .on('focus', function() {
          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
            element.addClass('md-focused');
          }
        })
        .on('blur', function() {
          element.removeClass('md-focused');
        });

      ngModelCtrl.$render = render;

      function $$watchExpr(expr, htmlAttr, valueOpts) {
        if (attr[expr]) {
          scope.$watch(attr[expr], function(val) {
            if (valueOpts[val]) {
              element.attr(htmlAttr, valueOpts[val]);
            }
          });
        }
      }

      function keypressHandler(ev) {
        var keyCode = ev.which || ev.keyCode;
        if (keyCode === $mdConstant.KEY_CODE.SPACE || keyCode === $mdConstant.KEY_CODE.ENTER) {
          ev.preventDefault();
          element.addClass('md-focused');
          listener(ev);
        }
      }

      function listener(ev) {
        // skipToggle boolean is used by the switch directive to prevent the click event
        // when releasing the drag. There will be always a click if releasing the drag over the checkbox
        if (element[0].hasAttribute('disabled') || scope.skipToggle) {
          return;
        }

        scope.$apply(function() {
          // Toggle the checkbox value...
          var viewValue = attr.ngChecked && attr.ngClick ? attr.checked : !ngModelCtrl.$viewValue;

          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
          ngModelCtrl.$render();
        });
      }

      function render() {
        // Cast the $viewValue to a boolean since it could be undefined
        element.toggleClass('md-checked', !!ngModelCtrl.$viewValue && !isIndeterminate);
      }

      function setIndeterminateState(newValue) {
        isIndeterminate = newValue !== false;
        if (isIndeterminate) {
          element.attr('aria-checked', 'mixed');
        }
        element.toggleClass('md-indeterminate', isIndeterminate);
      }
    }
  }
}

})();
(function(){
"use strict";

(function () {
  "use strict";

  /**
   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
   *  or one that should be observed and dynamically interpolated.
   */
  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?('|")[a-zA-Z0-9-.]*('|"))+\s*}$/;
  var colorPalettes = null;

  /**
   * @ngdoc module
   * @name material.components.colors
   *
   * @description
   * Define $mdColors service and a `md-colors=""` attribute directive
   */
  angular
    .module('material.components.colors', ['material.core'])
    .directive('mdColors', MdColorsDirective)
    .service('$mdColors', MdColorsService);

  /**
   * @ngdoc service
   * @name $mdColors
   * @module material.components.colors
   *
   * @description
   * With only defining themes, one couldn't get non AngularJS Material elements colored with Material colors,
   * `$mdColors` service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply
   * those values to element as CSS property values.
   *
   *  @usage
   *  <hljs lang="js">
   *    angular.controller('myCtrl', function ($mdColors) {
   *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
   *      ...
   *    });
   *  </hljs>
   *
   */
  function MdColorsService($mdTheming, $mdUtil, $log) {
    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);

    // Publish service instance
    return {
      applyThemeColors: applyThemeColors,
      getThemeColor: getThemeColor,
      hasTheme: hasTheme
    };

    // ********************************************
    // Internal Methods
    // ********************************************

    /**
     * @ngdoc method
     * @name $mdColors#applyThemeColors
     *
     * @description
     * Gets a color json object, keys are css properties and values are string of the wanted color
     * Then calculate the rgba() values based on the theme color parts
     *
     * @param {DOMElement} element the element to apply the styles on.
     * @param {object} colorExpression json object, keys are css properties and values are string of the wanted color,
     * for example: `{color: 'red-A200-0.3'}`.
     *
     * @usage
     * <hljs lang="js">
     *   app.directive('myDirective', function($mdColors) {
     *     return {
     *       ...
     *       link: function (scope, elem) {
     *         $mdColors.applyThemeColors(elem, {color: 'red'});
     *       }
     *    }
     *   });
     * </hljs>
     */
    function applyThemeColors(element, colorExpression) {
      try {
        if (colorExpression) {
          // Assign the calculate RGBA color values directly as inline CSS
          element.css(interpolateColors(colorExpression));
        }
      } catch (e) {
        $log.error(e.message);
      }

    }

    /**
     * @ngdoc method
     * @name $mdColors#getThemeColor
     *
     * @description
     * Get parsed color from expression
     *
     * @param {string} expression string of a color expression (for instance `'red-700-0.8'`)
     *
     * @returns {string} a css color expression (for instance `rgba(211, 47, 47, 0.8)`)
     *
     * @usage
     *  <hljs lang="js">
     *    angular.controller('myCtrl', function ($mdColors) {
     *      var color = $mdColors.getThemeColor('myTheme-red-200-0.5');
     *      ...
     *    });
     *  </hljs>
     */
    function getThemeColor(expression) {
      var color = extractColorOptions(expression);

      return parseColor(color);
    }

    /**
     * Return the parsed color
     * @param color hashmap of color definitions
     * @param contrast whether use contrast color for foreground
     * @returns rgba color string
     */
    function parseColor(color, contrast) {
      contrast = contrast || false;
      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];

      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;

      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
      );
    }

    /**
     * Convert the color expression into an object with scope-interpolated values
     * Then calculate the rgba() values based on the theme color parts
     *
     * @results Hashmap of CSS properties with associated `rgba( )` string vales
     *
     *
     */
    function interpolateColors(themeColors) {
      var rgbColors = {};

      var hasColorProperty = themeColors.hasOwnProperty('color');

      angular.forEach(themeColors, function (value, key) {
        var color = extractColorOptions(value);
        var hasBackground = key.indexOf('background') > -1;

        rgbColors[key] = parseColor(color);
        if (hasBackground && !hasColorProperty) {
          rgbColors.color = parseColor(color, true);
        }
      });

      return rgbColors;
    }

    /**
     * Check if expression has defined theme
     * e.g.
     * 'myTheme-primary' => true
     * 'red-800' => false
     */
    function hasTheme(expression) {
      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
    }

    /**
     * For the evaluated expression, extract the color parts into a hash map
     */
    function extractColorOptions(expression) {
      var parts = expression.split('-');
      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();

      return {
        theme: theme,
        palette: extractPalette(parts, theme),
        hue: extractHue(parts, theme),
        opacity: parts[2] || 1
      };
    }

    /**
     * Calculate the theme palette name
     */
    function extractPalette(parts, theme) {
      // If the next section is one of the palettes we assume it's a two word palette
      // Two word palette can be also written in camelCase, forming camelCase to dash-case

      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);

      if (colorPalettes.indexOf(palette) === -1) {
        // If the palette is not in the palette list it's one of primary/accent/warn/background
        var scheme = $mdTheming.THEMES[theme].colors[palette];
        if (!scheme) {
          throw new Error($mdUtil.supplant('mdColors: couldn\'t find \'{palette}\' in the palettes.', {palette: palette}));
        }
        palette = scheme.name;
      }

      return palette;
    }

    function extractHue(parts, theme) {
      var themeColors = $mdTheming.THEMES[theme].colors;

      if (parts[1] === 'hue') {
        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);

        if (hueNumber < 1 || hueNumber > 3) {
          throw new Error($mdUtil.supplant('mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'', {hueNumber: hueNumber}));
        }
        parts[1] = 'hue-' + hueNumber;

        if (!(parts[0] in themeColors)) {
          throw new Error($mdUtil.supplant('mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'', {
            availableThemes: Object.keys(themeColors).join(', '),
            usedTheme: parts[0]
          }));
        }

        return themeColors[parts[0]].hues[parts[1]];
      }

      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
    }
  }

  /**
   * @ngdoc directive
   * @name mdColors
   * @module material.components.colors
   *
   * @restrict A
   *
   * @description
   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
   *
   *   The format will be similar to our color defining in the scss files:
   *
   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
   *   - [theme]    - default value is the default theme
   *   - [palette]  - can be either palette name or primary/accent/warn/background
   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
   *   - [opacity]  - default is 1
   *
   *   > `?` indicates optional parameter
   *
   * @usage
   * <hljs lang="html">
   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
   *       <span>Color demo</span>
   *     </div>
   *   </div>
   * </hljs>
   *
   * `mdColors` directive will automatically watch for changes in the expression if it recognizes an interpolation
   * expression or a function. For performance options, you can use `::` prefix to the `md-colors` expression
   * to indicate a one-time data binding.
   * <hljs lang="html">
   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
   *   </md-card>
   * </hljs>
   *
   */
  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
    return {
      restrict: 'A',
      require: ['^?mdTheme'],
      compile: function (tElem, tAttrs) {
        var shouldWatch = shouldColorsWatch();

        return function (scope, element, attrs, ctrl) {
          var mdThemeController = ctrl[0];

          var lastColors = {};

          var parseColors = function (theme) {
            if (typeof theme !== 'string') {
              theme = '';
            }

            if (!attrs.mdColors) {
              attrs.mdColors = '{}';
            }

            /**
             * Json.parse() does not work because the keys are not quoted;
             * use $parse to convert to a hash map
             */
            var colors = $parse(attrs.mdColors)(scope);

            /**
             * If mdTheme is defined up the DOM tree
             * we add mdTheme theme to colors who doesn't specified a theme
             *
             * # example
             * <hljs lang="html">
             *   <div md-theme="myTheme">
             *     <div md-colors="{background: 'primary-600'}">
             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
             *     </div>
             *   </div>
             * </hljs>
             *
             * 'primary-600' will be 'myTheme-primary-600',
             * but 'mySecondTheme-accent-200' will stay the same cause it has a theme prefix
             */
            if (mdThemeController) {
              Object.keys(colors).forEach(function (prop) {
                var color = colors[prop];
                if (!$mdColors.hasTheme(color)) {
                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
                }
              });
            }

            cleanElement(colors);

            return colors;
          };

          var cleanElement = function (colors) {
            if (!angular.equals(colors, lastColors)) {
              var keys = Object.keys(lastColors);

              if (lastColors.background && !keys.color) {
                keys.push('color');
              }

              keys.forEach(function (key) {
                element.css(key, '');
              });
            }

            lastColors = colors;
          };

          /**
           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever a theme changes
           */
          var unregisterChanges = angular.noop;

          if (mdThemeController) {
            unregisterChanges = mdThemeController.registerChanges(function (theme) {
              $mdColors.applyThemeColors(element, parseColors(theme));
            });
          }

          scope.$on('$destroy', function () {
            unregisterChanges();
          });

          try {
            if (shouldWatch) {
              scope.$watch(parseColors, angular.bind(this,
                $mdColors.applyThemeColors, element
              ), true);
            }
            else {
              $mdColors.applyThemeColors(element, parseColors());
            }

          }
          catch (e) {
            $log.error(e.message);
          }

        };

        function shouldColorsWatch() {
          // Simulate 1x binding and mark mdColorsWatch == false
          var rawColorExpression = tAttrs.mdColors;
          var bindOnce = rawColorExpression.indexOf('::') > -1;
          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);

          // Remove it for the postLink...
          tAttrs.mdColors = rawColorExpression.replace('::', '');

          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);

          return (bindOnce || isStatic) ? false :
            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
        }
      }
    };

  }


})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.content
 *
 * @description
 * Scrollable content
 */
mdContentDirective.$inject = ["$mdTheming"];
angular.module('material.components.content', [
  'material.core'
])
  .directive('mdContent', mdContentDirective);

/**
 * @ngdoc directive
 * @name mdContent
 * @module material.components.content
 *
 * @restrict E
 *
 * @description
 *
 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
 *
 * In general, `<md-content>` components are not designed to be nested inside one another. If
 * possible, it is better to make them siblings. This often results in a better user experience as
 * having nested scrollbars may confuse the user.
 *
 * ## Troubleshooting
 *
 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
 * SVG icons and some other components.
 *
 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
 * inside (which eliminates the flicker on iOS devices).
 *
 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
 * related to the z-index of elements. Please use with caution and only on the elements needed._
 *
 * @usage
 *
 * Add the `[layout-padding]` attribute to make the content padded.
 *
 * <hljs lang="html">
 *  <md-content layout-padding>
 *      Lorem ipsum dolor sit amet, ne quod novum mei.
 *  </md-content>
 * </hljs>
 */

function mdContentDirective($mdTheming) {
  return {
    restrict: 'E',
    controller: ['$scope', '$element', ContentController],
    link: function(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      $mdTheming(element);
      scope.$broadcast('$mdContentLoaded', element);

      iosScrollFix(element[0]);
    }
  };

  function ContentController($scope, $element) {
    this.$scope = $scope;
    this.$element = $element;
  }
}

function iosScrollFix(node) {
  // IOS FIX:
  // If we scroll where there is no more room for the webview to scroll,
  // by default the webview itself will scroll up and down, this looks really
  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
  angular.element(node).on('$md.pressdown', function(ev) {
    // Only touch events
    if (ev.pointer.type !== 't') return;
    // Don't let a child content's touchstart ruin it for us.
    if (ev.$materialScrollFixed) return;
    ev.$materialScrollFixed = true;

    if (node.scrollTop === 0) {
      node.scrollTop = 1;
    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
      node.scrollTop -= 1;
    }
  });
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.datepicker
 * @description Module for the datepicker component.
 */

angular.module('material.components.datepicker', [
  'material.core',
  'material.components.icon',
  'material.components.virtualRepeat'
]);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.dialog
 */
MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
MdDialogProvider.$inject = ["$$interimElementProvider"];
angular
  .module('material.components.dialog', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdDialog', MdDialogDirective)
  .provider('$mdDialog', MdDialogProvider);

/**
 * @ngdoc directive
 * @name mdDialog
 * @module material.components.dialog
 *
 * @restrict E
 *
 * @description
 * `<md-dialog>` - The dialog's template must be inside this element.
 *
 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
 * an `<md-dialog-actions>` element for the dialog's actions.
 *
 * ## CSS
 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
 *
 * ## Notes
 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
 * prefixed with `dialogContent_`.
 *
 * @usage
 * ### Dialog template
 * <hljs lang="html">
 * <md-dialog aria-label="List dialog">
 *   <md-dialog-content>
 *     <md-list>
 *       <md-list-item ng-repeat="item in items">
 *         <p>Number {{item}}</p>
 *       </md-list-item>
 *     </md-list>
 *   </md-dialog-content>
 *   <md-dialog-actions>
 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
 *   </md-dialog-actions>
 * </md-dialog>
 * </hljs>
 */
function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
  return {
    restrict: 'E',
    link: function(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      $mdTheming(element);
      $$rAF(function() {
        var images;
        var content = element[0].querySelector('md-dialog-content');

        if (content) {
          images = content.getElementsByTagName('img');
          addOverflowClass();
          //-- delayed image loading may impact scroll height, check after images are loaded
          angular.element(images).on('load', addOverflowClass);
        }

        scope.$on('$destroy', function() {
          $mdDialog.destroy(element);
        });

        /**
         *
         */
        function addOverflowClass() {
          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
        }


      });
    }
  };
}

/**
 * @ngdoc service
 * @name $mdDialog
 * @module material.components.dialog
 *
 * @description
 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
 *  them to make decisions. There are two approaches for setup: a simple promise API
 *  and regular object syntax.
 *
 * ## Restrictions
 *
 * - The dialog is always given an isolate scope.
 * - The dialog's template must have an outer `<md-dialog>` element.
 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
 *   an `<md-dialog-actions>` element for the dialog's actions.
 * - Dialogs must cover the entire application to keep interactions inside of them.
 * Use the `parent` option to change where dialogs are appended.
 *
 * ## Sizing
 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
 * - Default max-width is 80% of the `rootElement` or `parent`.
 *
 * ## CSS
 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
 *
 * @usage
 * <hljs lang="html">
 * <div  ng-app="demoApp" ng-controller="EmployeeController">
 *   <div>
 *     <md-button ng-click="showAlert()" class="md-raised md-warn">
 *       Employee Alert!
 *       </md-button>
 *   </div>
 *   <div>
 *     <md-button ng-click="showDialog($event)" class="md-raised">
 *       Custom Dialog
 *       </md-button>
 *   </div>
 *   <div>
 *     <md-button ng-click="closeAlert()" ng-disabled="!hasAlert()" class="md-raised">
 *       Close Alert
 *     </md-button>
 *   </div>
 *   <div>
 *     <md-button ng-click="showGreeting($event)" class="md-raised md-primary" >
 *       Greet Employee
 *       </md-button>
 *   </div>
 * </div>
 * </hljs>
 *
 * ### JavaScript: object syntax
 * <hljs lang="js">
 * (function(angular, undefined){
 *   "use strict";
 *
 *   angular
 *    .module('demoApp', ['ngMaterial'])
 *    .controller('AppCtrl', AppController);
 *
 *   function AppController($scope, $mdDialog) {
 *     var alert;
 *     $scope.showAlert = showAlert;
 *     $scope.showDialog = showDialog;
 *     $scope.items = [1, 2, 3];
 *
 *     // Internal method
 *     function showAlert() {
 *       alert = $mdDialog.alert({
 *         title: 'Attention',
 *         textContent: 'This is an example of how easy dialogs can be!',
 *         ok: 'Close'
 *       });
 *
 *       $mdDialog
 *         .show( alert )
 *         .finally(function() {
 *           alert = undefined;
 *         });
 *     }
 *
 *     function showDialog($event) {
 *        var parentEl = angular.element(document.body);
 *        $mdDialog.show({
 *          parent: parentEl,
 *          targetEvent: $event,
 *          template:
 *            '<md-dialog aria-label="List dialog">' +
 *            '  <md-dialog-content>'+
 *            '    <md-list>'+
 *            '      <md-list-item ng-repeat="item in items">'+
 *            '       <p>Number {{item}}</p>' +
 *            '      </md-item>'+
 *            '    </md-list>'+
 *            '  </md-dialog-content>' +
 *            '  <md-dialog-actions>' +
 *            '    <md-button ng-click="closeDialog()" class="md-primary">' +
 *            '      Close Dialog' +
 *            '    </md-button>' +
 *            '  </md-dialog-actions>' +
 *            '</md-dialog>',
 *          locals: {
 *            items: $scope.items
 *          },
 *          controller: DialogController
 *       });
 *       function DialogController($scope, $mdDialog, items) {
 *         $scope.items = items;
 *         $scope.closeDialog = function() {
 *           $mdDialog.hide();
 *         }
 *       }
 *     }
 *   }
 * })(angular);
 * </hljs>
 *
 * ### Multiple Dialogs
 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple dialogs
 * at the same time.
 *
 * <hljs lang="js">
 *   // From plain options
 *   $mdDialog.show({
 *     multiple: true
 *   });
 *
 *   // From a dialog preset
 *   $mdDialog.show(
 *     $mdDialog
 *       .alert()
 *       .multiple(true)
 *   );
 *
 * </hljs>
 *
 * ### Pre-Rendered Dialogs
 * By using the `contentElement` option, it is possible to use an already existing element in the DOM.
 *
 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new controller.<br/>
 * > You can manually link the elements to a scope or instantiate a controller from the template (`ng-controller`)
 *
 * <hljs lang="js">
 *   $scope.showPrerenderedDialog = function() {
 *     $mdDialog.show({
 *       contentElement: '#myStaticDialog',
 *       parent: angular.element(document.body)
 *     });
 *   };
 * </hljs>
 *
 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS selector.
 *
 * <hljs lang="html">
 *   <div style="visibility: hidden">
 *     <div class="md-dialog-container" id="myStaticDialog">
 *       <md-dialog>
 *         This is a pre-rendered dialog.
 *       </md-dialog>
 *     </div>
 *   </div>
 * </hljs>
 *
 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise the dialog
 * will not show up.
 *
 * It also possible to use a DOM element for the `contentElement` option.
 * - `contentElement: document.querySelector('#myStaticDialog')`
 * - `contentElement: angular.element(TEMPLATE)`
 *
 * When using a `template` as content element, it will be not compiled upon open.
 * This allows you to compile the element yourself and use it each time the dialog opens.
 *
 * ### Custom Presets
 * Developers are also able to create their own preset, which can be easily used without repeating
 * their options each time.
 *
 * <hljs lang="js">
 *   $mdDialogProvider.addPreset('testPreset', {
 *     options: function() {
 *       return {
 *         template:
 *           '<md-dialog>' +
 *             'This is a custom preset' +
 *           '</md-dialog>',
 *         controllerAs: 'dialog',
 *         bindToController: true,
 *         clickOutsideToClose: true,
 *         escapeToClose: true
 *       };
 *     }
 *   });
 * </hljs>
 *
 * After you created your preset at config phase, you can easily access it.
 *
 * <hljs lang="js">
 *   $mdDialog.show(
 *     $mdDialog.testPreset()
 *   );
 * </hljs>
 *
 * ### JavaScript: promise API syntax, custom dialog template
 * <hljs lang="js">
 * (function(angular, undefined){
 *   "use strict";
 *
 *   angular
 *     .module('demoApp', ['ngMaterial'])
 *     .controller('EmployeeController', EmployeeEditor)
 *     .controller('GreetingController', GreetingController);
 *
 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
 *
 *   function EmployeeEditor($scope, $mdDialog) {
 *     var alert;
 *
 *     $scope.showAlert = showAlert;
 *     $scope.closeAlert = closeAlert;
 *     $scope.showGreeting = showCustomGreeting;
 *
 *     $scope.hasAlert = function() { return !!alert };
 *     $scope.userName = $scope.userName || 'Bobby';
 *
 *     // Dialog #1 - Show simple alert dialog and cache
 *     // reference to dialog instance
 *
 *     function showAlert() {
 *       alert = $mdDialog.alert()
 *         .title('Attention, ' + $scope.userName)
 *         .textContent('This is an example of how easy dialogs can be!')
 *         .ok('Close');
 *
 *       $mdDialog
 *           .show( alert )
 *           .finally(function() {
 *             alert = undefined;
 *           });
 *     }
 *
 *     // Close the specified dialog instance and resolve with 'finished' flag
 *     // Normally this is not needed, just use '$mdDialog.hide()' to close
 *     // the most recent dialog popup.
 *
 *     function closeAlert() {
 *       $mdDialog.hide( alert, "finished" );
 *       alert = undefined;
 *     }
 *
 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
 *
 *     function showCustomGreeting($event) {
 *         $mdDialog.show({
 *           targetEvent: $event,
 *           template:
 *             '<md-dialog>' +
 *
 *             '  <md-dialog-content>Hello {{ employee }}!</md-dialog-content>' +
 *
 *             '  <md-dialog-actions>' +
 *             '    <md-button ng-click="closeDialog()" class="md-primary">' +
 *             '      Close Greeting' +
 *             '    </md-button>' +
 *             '  </md-dialog-actions>' +
 *             '</md-dialog>',
 *           controller: 'GreetingController',
 *           onComplete: afterShowAnimation,
 *           locals: { employee: $scope.userName }
 *         });
 *
 *         // When the 'enter' animation finishes...
 *
 *         function afterShowAnimation(scope, element, options) {
 *            // post-show code here: DOM element focus, etc.
 *         }
 *     }
 *
 *     // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog
 *     //             Here we used ng-controller="GreetingController as vm" and
 *     //             $scope.vm === <controller instance>
 *
 *     function showCustomGreeting() {
 *
 *        $mdDialog.show({
 *           clickOutsideToClose: true,
 *
 *           scope: $scope,        // use parent scope in template
 *           preserveScope: true,  // do not forget this if use parent scope

 *           // Since GreetingController is instantiated with ControllerAs syntax
 *           // AND we are passing the parent '$scope' to the dialog, we MUST
 *           // use 'vm.<xxx>' in the template markup
 *
 *           template: '<md-dialog>' +
 *                     '  <md-dialog-content>' +
 *                     '     Hi There {{vm.employee}}' +
 *                     '  </md-dialog-content>' +
 *                     '</md-dialog>',
 *
 *           controller: function DialogController($scope, $mdDialog) {
 *             $scope.closeDialog = function() {
 *               $mdDialog.hide();
 *             }
 *           }
 *        });
 *     }
 *
 *   }
 *
 *   // Greeting controller used with the more complex 'showCustomGreeting()' custom dialog
 *
 *   function GreetingController($scope, $mdDialog, employee) {
 *     // Assigned from construction <code>locals</code> options...
 *     $scope.employee = employee;
 *
 *     $scope.closeDialog = function() {
 *       // Easily hides most recent dialog shown...
 *       // no specific instance reference is needed.
 *       $mdDialog.hide();
 *     };
 *   }
 *
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdDialog#alert
 *
 * @description
 * Builds a preconfigured dialog with the specified message.
 *
 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
 *
 * - $mdDialogPreset#title(string) - Sets the alert title.
 * - $mdDialogPreset#textContent(string) - Sets the alert message.
 * - $mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize
 *     module to be loaded. HTML is not run through Angular's compiler.
 * - $mdDialogPreset#ok(string) - Sets the alert "Okay" button text.
 * - $mdDialogPreset#theme(string) - Sets the theme of the alert dialog.
 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
 *     the location of the click will be used as the starting point for the opening animation
 *     of the the dialog.
 *
 */

/**
 * @ngdoc method
 * @name $mdDialog#confirm
 *
 * @description
 * Builds a preconfigured dialog with the specified message. You can call show and the promise returned
 * will be resolved only if the user clicks the confirm action on the dialog.
 *
 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
 *
 * Additionally, it supports the following methods:
 *
 * - $mdDialogPreset#title(string) - Sets the confirm title.
 * - $mdDialogPreset#textContent(string) - Sets the confirm message.
 * - $mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize
 *     module to be loaded. HTML is not run through Angular's compiler.
 * - $mdDialogPreset#ok(string) - Sets the confirm "Okay" button text.
 * - $mdDialogPreset#cancel(string) - Sets the confirm "Cancel" button text.
 * - $mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.
 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
 *     the location of the click will be used as the starting point for the opening animation
 *     of the the dialog.
 *
 */

/**
 * @ngdoc method
 * @name $mdDialog#prompt
 *
 * @description
 * Builds a preconfigured dialog with the specified message and input box. You can call show and the promise returned
 * will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.
 *
 * @returns {obj} an `$mdDialogPreset` with the chainable configuration methods:
 *
 * Additionally, it supports the following methods:
 *
 * - $mdDialogPreset#title(string) - Sets the prompt title.
 * - $mdDialogPreset#textContent(string) - Sets the prompt message.
 * - $mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize
 *     module to be loaded. HTML is not run through Angular's compiler.
 * - $mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.
 * - $mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.
 * - $mdDialogPreset#ok(string) - Sets the prompt "Okay" button text.
 * - $mdDialogPreset#cancel(string) - Sets the prompt "Cancel" button text.
 * - $mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.
 * - $mdDialogPreset#targetEvent(DOMClickEvent=) - A click's event object. When passed in as an option,
 *     the location of the click will be used as the starting point for the opening animation
 *     of the the dialog.
 *
 */

/**
 * @ngdoc method
 * @name $mdDialog#show
 *
 * @description
 * Show a dialog with the specified options.
 *
 * @param {object} optionsOrPreset Either provide an `$mdDialogPreset` returned from `alert()`, and
 * `confirm()`, or an options object with the following properties:
 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
 *   of the dialog.
 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
 *      with respect to Angular's [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
 *      This template should **never** be constructed with any kind of user input or user data.
 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled each time a
 *     dialog opens, you can also use a DOM element.<br/>
 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch the element into
 *       the dialog and restores it at the old DOM position upon close.
 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.
 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
 *     custom dialog directive.
 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
 *     the location of the click will be used as the starting point for the opening animation
 *     of the the dialog.
 *   - `openFrom` - `{string|Element|object}`: The query selector, DOM element or the Rect object
 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
 *     originate.
 *   - `closeTo` - `{string|Element|object}`: The query selector, DOM element or the Rect object
 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
 *     target.
 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified,
 *     it will create a new isolate scope.
 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to true.
 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
 *     Default true.
 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
 *     Default true.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
 *     close it. Default false.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
 *     Default true.
 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
 *     focusing some other way, as focus management is required for dialogs to be accessible.
 *     Defaults to true.
 *   - `controller` - `{function|string=}`: The controller to associate with the dialog. The controller
 *     will be injected with the local `$mdDialog`, which passes along a scope for the dialog.
 *   - `locals` - `{object=}`: An object containing key/value pairs. The keys will be used as names
 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
 *     copied to the controller instead.
 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
 *     to the root element of the application.
 *   - `onShowing` - `function(scope, element)`: Callback function used to announce the show() action is
 *     starting.
 *   - `onComplete` - `function(scope, element)`: Callback function used to announce when the show() action is
 *     finished.
 *   - `onRemoving` - `function(element, removePromise)`: Callback function used to announce the
 *      close/hide() action is starting. This allows developers to run custom animations
 *      in parallel the close animations.
 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
 *      or not. Defaults to `false`.
 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently open.
 * @returns {promise} A promise that can be resolved with `$mdDialog.hide()` or
 * rejected with `$mdDialog.cancel()`.
 */

/**
 * @ngdoc method
 * @name $mdDialog#hide
 *
 * @description
 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
 *
 * @param {*=} response An argument for the resolved promise.
 *
 * @returns {promise} A promise that is resolved when the dialog has been closed.
 */

/**
 * @ngdoc method
 * @name $mdDialog#cancel
 *
 * @description
 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
 *
 * @param {*=} response An argument for the rejected promise.
 *
 * @returns {promise} A promise that is resolved when the dialog has been closed.
 */

function MdDialogProvider($$interimElementProvider) {
  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
  MdDialogController.$inject = ["$mdDialog", "$mdConstant"];
  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming", "$interpolate", "$mdInteraction"];
  var topFocusTrap, bottomFocusTrap;

  return $$interimElementProvider('$mdDialog')
    .setDefaults({
      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'multiple'],
      options: dialogDefaultOptions
    })
    .addPreset('alert', {
      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'theme',
          'css'],
      options: advancedDialogOptions
    })
    .addPreset('confirm', {
      methods: ['title', 'htmlContent', 'textContent', 'content', 'ariaLabel', 'ok', 'cancel',
          'theme', 'css'],
      options: advancedDialogOptions
    })
    .addPreset('prompt', {
      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'content', 'placeholder', 'ariaLabel',
          'ok', 'cancel', 'theme', 'css', 'required'],
      options: advancedDialogOptions
    });

  /* @ngInject */
  function advancedDialogOptions() {
    return {
      template: [
        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
        '    <h2 class="md-title">{{ dialog.title }}</h2>',
        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
        '      <p>{{::dialog.mdTextContent}}</p>',
        '    </div>',
        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
        '             placeholder="{{::dialog.placeholder}}" ng-required="dialog.required">',
        '    </md-input-container>',
        '  </md-dialog-content>',
        '  <md-dialog-actions>',
        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
        '      {{ dialog.cancel }}',
        '    </md-button>',
        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'"' +
        '               ng-disabled="dialog.required && !dialog.result">',
        '      {{ dialog.ok }}',
        '    </md-button>',
        '  </md-dialog-actions>',
        '</md-dialog>'
      ].join('').replace(/\s\s+/g, ''),
      controller: MdDialogController,
      controllerAs: 'dialog',
      bindToController: true,
    };
  }

  /**
   * Controller for the md-dialog interim elements
   * @ngInject
   */
  function MdDialogController($mdDialog, $mdConstant) {
    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
    this.$onInit = function() {
      var isPrompt = this.$type == 'prompt';

      if (isPrompt && this.initialValue) {
        this.result = this.initialValue;
      }

      this.hide = function() {
        $mdDialog.hide(isPrompt ? this.result : true);
      };
      this.abort = function() {
        $mdDialog.cancel();
      };
      this.keypress = function($event) {
        if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
          $mdDialog.hide(this.result);
        }
      };
    };
  }

  /* @ngInject */
  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document, $window, $rootElement,
                                $log, $injector, $mdTheming, $interpolate, $mdInteraction) {

    return {
      hasBackdrop: true,
      isolateScope: true,
      onCompiling: beforeCompile,
      onShow: onShow,
      onShowing: beforeShow,
      onRemove: onRemove,
      clickOutsideToClose: false,
      escapeToClose: true,
      targetEvent: null,
      closeTo: null,
      openFrom: null,
      focusOnOpen: true,
      disableParentScroll: true,
      autoWrap: true,
      fullscreen: false,
      transformTemplate: function(template, options) {
        // Make the dialog container focusable, because otherwise the focus will be always redirected to
        // an element outside of the container, and the focus trap won't work probably..
        // Also the tabindex is needed for the `escapeToClose` functionality, because
        // the keyDown event can't be triggered when the focus is outside of the container.
        var startSymbol = $interpolate.startSymbol();
        var endSymbol = $interpolate.endSymbol();
        var theme = startSymbol + (options.themeWatch ? '' : '::') + 'theme' + endSymbol;
        return '<div class="md-dialog-container" tabindex="-1" md-theme="' + theme + '">' + validatedTemplate(template) + '</div>';

        /**
         * The specified template should contain a <md-dialog> wrapper element....
         */
        function validatedTemplate(template) {
          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
            return '<md-dialog>' + (template || '') + '</md-dialog>';
          } else {
            return template || '';
          }
        }
      }
    };

    function beforeCompile(options) {
      // Automatically apply the theme, if the user didn't specify a theme explicitly.
      // Those option changes need to be done, before the compilation has started, because otherwise
      // the option changes will be not available in the $mdCompilers locales.
      options.defaultTheme = $mdTheming.defaultTheme();

      detectTheming(options);
    }

    function beforeShow(scope, element, options, controller) {

      if (controller) {
        var mdHtmlContent = controller.htmlContent || options.htmlContent || '';
        var mdTextContent = controller.textContent || options.textContent ||
            controller.content || options.content || '';

        if (mdHtmlContent && !$injector.has('$sanitize')) {
          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
        }

        if (mdHtmlContent && mdTextContent) {
          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
        }

        // Only assign the content if nothing throws, otherwise it'll still be compiled.
        controller.mdHtmlContent = mdHtmlContent;
        controller.mdTextContent = mdTextContent;
      }
    }

    /** Show method for dialogs */
    function onShow(scope, element, options, controller) {
      angular.element($document[0].body).addClass('md-dialog-is-showing');

      var dialogElement = element.find('md-dialog');

      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work properly.
      // This is a very common problem, so we have to notify the developer about this.
      if (dialogElement.hasClass('ng-cloak')) {
        var message = '$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';
        $log.warn( message, element[0] );
      }

      captureParentAndFromToElements(options);
      configureAria(dialogElement, options);
      showBackdrop(scope, element, options);
      activateListeners(element, options);

      return dialogPopIn(element, options)
        .then(function() {
          lockScreenReader(element, options);
          warnDeprecatedActions();
          focusOnOpen();
        });

      /**
       * Check to see if they used the deprecated .md-actions class and log a warning
       */
      function warnDeprecatedActions() {
        if (element[0].querySelector('.md-actions')) {
          $log.warn('Using a class of md-actions is deprecated, please use <md-dialog-actions>.');
        }
      }

      /**
       * For alerts, focus on content... otherwise focus on
       * the close button (or equivalent)
       */
      function focusOnOpen() {
        if (options.focusOnOpen) {
          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
          target.focus();
        }

        /**
         * If no element with class dialog-close, try to find the last
         * button child in md-actions and assume it is a close button.
         *
         * If we find no actions at all, log a warning to the console.
         */
        function findCloseButton() {
          return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');
        }
      }
    }

    /**
     * Remove function for all dialogs
     */
    function onRemove(scope, element, options) {
      options.deactivateListeners();
      options.unlockScreenReader();
      options.hideBackdrop(options.$destroy);

      // Remove the focus traps that we added earlier for keeping focus within the dialog.
      if (topFocusTrap && topFocusTrap.parentNode) {
        topFocusTrap.parentNode.removeChild(topFocusTrap);
      }

      if (bottomFocusTrap && bottomFocusTrap.parentNode) {
        bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
      }

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal
      return !!options.$destroy ? detachAndClean() : animateRemoval().then( detachAndClean );

      /**
       * For normal closes, animate the removal.
       * For forced closes (like $destroy events), skip the animations
       */
      function animateRemoval() {
        return dialogPopOut(element, options);
      }

      /**
       * Detach the element
       */
      function detachAndClean() {
        angular.element($document[0].body).removeClass('md-dialog-is-showing');

        // Reverse the container stretch if using a content element.
        if (options.contentElement) {
          options.reverseContainerStretch();
        }

        // Exposed cleanup function from the $mdCompiler.
        options.cleanupElement();

        // Restores the focus to the origin element if the last interaction upon opening was a keyboard.
        if (!options.$destroy && options.originInteraction === 'keyboard') {
          options.origin.focus();
        }
      }
    }

    function detectTheming(options) {
      // Once the user specifies a targetEvent, we will automatically try to find the correct
      // nested theme.
      var targetEl;
      if (options.targetEvent && options.targetEvent.target) {
        targetEl = angular.element(options.targetEvent.target);
      }

      var themeCtrl = targetEl && targetEl.controller('mdTheme');

      if (!themeCtrl) {
        return;
      }

      options.themeWatch = themeCtrl.$shouldWatch;

      var theme = options.theme || themeCtrl.$mdTheme;

      if (theme) {
        options.scope.theme = theme;
      }

      var unwatch = themeCtrl.registerChanges(function (newTheme) {
        options.scope.theme = newTheme;

        if (!options.themeWatch) {
          unwatch();
        }
      });
    }

    /**
     * Capture originator/trigger/from/to element information (if available)
     * and the parent container for the dialog; defaults to the $rootElement
     * unless overridden in the options.parent
     */
    function captureParentAndFromToElements(options) {
          options.origin = angular.extend({
            element: null,
            bounds: null,
            focus: angular.noop
          }, options.origin || {});

          options.parent   = getDomElement(options.parent, $rootElement);
          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));

          if ( options.targetEvent ) {
            options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
            options.originInteraction = $mdInteraction.getLastInteractionType();
          }


          /**
           * Identify the bounding RECT for the target element
           *
           */
          function getBoundingClientRect (element, orig) {
            var source = angular.element((element || {}));
            if (source && source.length) {
              // Compute and save the target element's bounding rect, so that if the
              // element is hidden when the dialog closes, we can shrink the dialog
              // back to the same position it expanded from.
              //
              // Checking if the source is a rect object or a DOM element
              var bounds = {top:0,left:0,height:0,width:0};
              var hasFn = angular.isFunction(source[0].getBoundingClientRect);

              return angular.extend(orig || {}, {
                  element : hasFn ? source : undefined,
                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
                  focus   : angular.bind(source, source.focus),
              });
            }
          }

          /**
           * If the specifier is a simple string selector, then query for
           * the DOM element.
           */
          function getDomElement(element, defaultElement) {
            if (angular.isString(element)) {
              element = $document[0].querySelector(element);
            }

            // If we have a reference to a raw dom element, always wrap it in jqLite
            return angular.element(element || defaultElement);
          }

        }

    /**
     * Listen for escape keys and outside clicks to auto close
     */
    function activateListeners(element, options) {
      var window = angular.element($window);
      var onWindowResize = $mdUtil.debounce(function() {
        stretchDialogContainerToViewport(element, options);
      }, 60);

      var removeListeners = [];
      var smartClose = function() {
        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
        // cancel or fallback to hide.
        var closeFn = ( options.$type == 'alert' ) ? $mdDialog.hide : $mdDialog.cancel;
        $mdUtil.nextTick(closeFn, true);
      };

      if (options.escapeToClose) {
        var parentTarget = options.parent;
        var keyHandlerFn = function(ev) {
          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
            ev.stopPropagation();
            ev.preventDefault();

            smartClose();
          }
        };

        // Add keydown listeners
        element.on('keydown', keyHandlerFn);
        parentTarget.on('keydown', keyHandlerFn);

        // Queue remove listeners function
        removeListeners.push(function() {

          element.off('keydown', keyHandlerFn);
          parentTarget.off('keydown', keyHandlerFn);

        });
      }

      // Register listener to update dialog on window resize
      window.on('resize', onWindowResize);

      removeListeners.push(function() {
        window.off('resize', onWindowResize);
      });

      if (options.clickOutsideToClose) {
        var target = element;
        var sourceElem;

        // Keep track of the element on which the mouse originally went down
        // so that we can only close the backdrop when the 'click' started on it.
        // A simple 'click' handler does not work,
        // it sets the target object as the element the mouse went down on.
        var mousedownHandler = function(ev) {
          sourceElem = ev.target;
        };

        // We check if our original element and the target is the backdrop
        // because if the original was the backdrop and the target was inside the dialog
        // we don't want to dialog to close.
        var mouseupHandler = function(ev) {
          if (sourceElem === target[0] && ev.target === target[0]) {
            ev.stopPropagation();
            ev.preventDefault();

            smartClose();
          }
        };

        // Add listeners
        target.on('mousedown', mousedownHandler);
        target.on('mouseup', mouseupHandler);

        // Queue remove listeners function
        removeListeners.push(function() {
          target.off('mousedown', mousedownHandler);
          target.off('mouseup', mouseupHandler);
        });
      }

      // Attach specific `remove` listener handler
      options.deactivateListeners = function() {
        removeListeners.forEach(function(removeFn) {
          removeFn();
        });
        options.deactivateListeners = null;
      };
    }

    /**
     * Show modal backdrop element...
     */
    function showBackdrop(scope, element, options) {

      if (options.disableParentScroll) {
        // !! DO this before creating the backdrop; since disableScrollAround()
        //    configures the scroll offset; which is used by mdBackDrop postLink()
        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
      }

      if (options.hasBackdrop) {
        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
        $animate.enter(options.backdrop, options.parent);
      }

      /**
       * Hide modal backdrop element...
       */
      options.hideBackdrop = function hideBackdrop($destroy) {
        if (options.backdrop) {
          if ( !!$destroy ) options.backdrop.remove();
          else              $animate.leave(options.backdrop);
        }


        if (options.disableParentScroll) {
          options.restoreScroll && options.restoreScroll();
          delete options.restoreScroll;
        }

        options.hideBackdrop = null;
      };
    }

    /**
     * Inject ARIA-specific attributes appropriate for Dialogs
     */
    function configureAria(element, options) {

      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
      var dialogContent = element.find('md-dialog-content');
      var existingDialogId = element.attr('id');
      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());

      element.attr({
        'role': role,
        'tabIndex': '-1'
      });

      if (dialogContent.length === 0) {
        dialogContent = element;
        // If the dialog element already had an ID, don't clobber it.
        if (existingDialogId) {
          dialogContentId = existingDialogId;
        }
      }

      dialogContent.attr('id', dialogContentId);
      element.attr('aria-describedby', dialogContentId);

      if (options.ariaLabel) {
        $mdAria.expect(element, 'aria-label', options.ariaLabel);
      }
      else {
        $mdAria.expectAsync(element, 'aria-label', function() {
          // If dialog title is specified, set aria-label with it
          // See https://github.com/angular/material/issues/10582
          if (options.title) {
            return options.title;
          } else {
            var words = dialogContent.text().split(/\s+/);
            if (words.length > 3) words = words.slice(0, 3).concat('...');
            return words.join(' ');
          }
        });
      }

      // Set up elements before and after the dialog content to capture focus and
      // redirect back into the dialog.
      topFocusTrap = document.createElement('div');
      topFocusTrap.classList.add('md-dialog-focus-trap');
      topFocusTrap.tabIndex = 0;

      bottomFocusTrap = topFocusTrap.cloneNode(false);

      // When focus is about to move out of the dialog, we want to intercept it and redirect it
      // back to the dialog element.
      var focusHandler = function() {
        element.focus();
      };
      topFocusTrap.addEventListener('focus', focusHandler);
      bottomFocusTrap.addEventListener('focus', focusHandler);

      // The top focus trap inserted immeidately before the md-dialog element (as a sibling).
      // The bottom focus trap is inserted at the very end of the md-dialog element (as a child).
      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
      element.after(bottomFocusTrap);
    }

    /**
     * Prevents screen reader interaction behind modal window
     * on swipe interfaces
     */
    function lockScreenReader(element, options) {
      var isHidden = true;

      // get raw DOM node
      walkDOM(element[0]);

      options.unlockScreenReader = function() {
        isHidden = false;
        walkDOM(element[0]);

        options.unlockScreenReader = null;
      };

      /**
       * Walk DOM to apply or remove aria-hidden on sibling nodes
       * and parent sibling nodes
       *
       */
      function walkDOM(element) {
        while (element.parentNode) {
          if (element === document.body) {
            return;
          }
          var children = element.parentNode.children;
          for (var i = 0; i < children.length; i++) {
            // skip over child if it is an ascendant of the dialog
            // or a script or style tag
            if (element !== children[i] &&
             !isNodeOneOf(children[i], ['SCRIPT', 'STYLE']) &&
             !children[i].hasAttribute('aria-live')) {
              children[i].setAttribute('aria-hidden', isHidden);
            }
          }

          walkDOM(element = element.parentNode);
        }
      }
    }

    /**
     * Ensure the dialog container fill-stretches to the viewport
     */
    function stretchDialogContainerToViewport(container, options) {
      var isFixed = $window.getComputedStyle($document[0].body).position == 'fixed';
      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
      var height = backdrop ? Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10)))) : 0;

      var previousStyles = {
        top: container.css('top'),
        height: container.css('height')
      };

      // If the body is fixed, determine the distance to the viewport in relative from the parent.
      var parentTop = Math.abs(options.parent[0].getBoundingClientRect().top);

      container.css({
        top: (isFixed ? parentTop : 0) + 'px',
        height: height ? height + 'px' : '100%'
      });

      return function() {
        // Reverts the modified styles back to the previous values.
        // This is needed for contentElements, which should have the same styles after close
        // as before.
        container.css(previousStyles);
      };
    }

    /**
     *  Dialog open and pop-in animation
     */
    function dialogPopIn(container, options) {
      // Add the `md-dialog-container` to the DOM
      options.parent.append(container);
      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);

      var dialogEl = container.find('md-dialog');
      var animator = $mdUtil.dom.animator;
      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)

      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);

      return animator
        .translate3d(dialogEl, from, to, translateOptions)
        .then(function(animateReversal) {

          // Build a reversal translate function synced to this translation...
          options.reverseAnimate = function() {
            delete options.reverseAnimate;

            if (options.closeTo) {
              // Using the opposite classes to create a close animation to the closeTo element
              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
              from = to;
              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));

              return animator
                .translate3d(dialogEl, from, to,translateOptions);
            }

            return animateReversal(
              to = animator.toTransformCss(
                // in case the origin element has moved or is hidden,
                // let's recalculate the translateCSS
                buildTranslateToOrigin(dialogEl, options.origin)
              )
            );

          };

          // Function to revert the generated animation styles on the dialog element.
          // Useful when using a contentElement instead of a template.
          options.clearAnimate = function() {
            delete options.clearAnimate;

            // Remove the transition classes, added from $animateCSS, since those can't be removed
            // by reversely running the animator.
            dialogEl.removeClass([
              translateOptions.transitionOutClass,
              translateOptions.transitionInClass
            ].join(' '));

            // Run the animation reversely to remove the previous added animation styles.
            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
          };

          return true;
        });
    }

    /**
     * Dialog close and pop-out animation
     */
    function dialogPopOut(container, options) {
      return options.reverseAnimate().then(function() {
        if (options.contentElement) {
          // When we use a contentElement, we want the element to be the same as before.
          // That means, that we have to clear all the animation properties, like transform.
          options.clearAnimate();
        }
      });
    }

    /**
     * Utility function to filter out raw DOM nodes
     */
    function isNodeOneOf(elem, nodeTypeArray) {
      if (nodeTypeArray.indexOf(elem.nodeName) !== -1) {
        return true;
      }
    }

  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.divider
 * @description Divider module!
 */
MdDividerDirective.$inject = ["$mdTheming"];
angular.module('material.components.divider', [
  'material.core'
])
  .directive('mdDivider', MdDividerDirective);

/**
 * @ngdoc directive
 * @name mdDivider
 * @module material.components.divider
 * @restrict E
 *
 * @description
 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
 *
 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
 * @usage
 * <hljs lang="html">
 * <md-divider></md-divider>
 *
 * <md-divider md-inset></md-divider>
 * </hljs>
 *
 */
function MdDividerDirective($mdTheming) {
  return {
    restrict: 'E',
    link: $mdTheming
  };
}

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc module
   * @name material.components.fabActions
   */
  MdFabActionsDirective.$inject = ["$mdUtil"];
  angular
    .module('material.components.fabActions', ['material.core'])
    .directive('mdFabActions', MdFabActionsDirective);

  /**
   * @ngdoc directive
   * @name mdFabActions
   * @module material.components.fabActions
   *
   * @restrict E
   *
   * @description
   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
   * proper event listeners.
   *
   * @usage
   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
   */
  function MdFabActionsDirective($mdUtil) {
    return {
      restrict: 'E',

      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],

      compile: function(element, attributes) {
        var children = element.children();

        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');

        // Support both ng-repeat and static content
        if (hasNgRepeat) {
          children.addClass('md-fab-action-item');
        } else {
          // Wrap every child in a new div and add a class that we can scale/fling independently
          children.wrap('<div class="md-fab-action-item">');
        }
      }
    };
  }

})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
  angular.module('material.components.fabShared', ['material.core'])
    .controller('MdFabController', MdFabController);

  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
    var vm = this;
    var initialAnimationAttempts = 0;

    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops

    vm.open = function() {
      $scope.$evalAsync("vm.isOpen = true");
    };

    vm.close = function() {
      // Async eval to avoid conflicts with existing digest loops
      $scope.$evalAsync("vm.isOpen = false");

      // Focus the trigger when the element closes so users can still tab to the next item
      $element.find('md-fab-trigger')[0].focus();
    };

    // Toggle the open/close state when the trigger is clicked
    vm.toggle = function() {
      $scope.$evalAsync("vm.isOpen = !vm.isOpen");
    };

    /*
     * AngularJS Lifecycle hook for newer AngularJS versions.
     * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
     */
    vm.$onInit = function() {
      setupDefaults();
      setupListeners();
      setupWatchers();

      fireInitialAnimations();
    };

    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }

    function setupDefaults() {
      // Set the default direction to 'down' if none is specified
      vm.direction = vm.direction || 'down';

      // Set the default to be closed
      vm.isOpen = vm.isOpen || false;

      // Start the keyboard interaction at the first action
      resetActionIndex();

      // Add an animations waiting class so we know not to run
      $element.addClass('md-animations-waiting');
    }

    function setupListeners() {
      var eventTypes = [
        'click', 'focusin', 'focusout'
      ];

      // Add our listeners
      angular.forEach(eventTypes, function(eventType) {
        $element.on(eventType, parseEvents);
      });

      // Remove our listeners when destroyed
      $scope.$on('$destroy', function() {
        angular.forEach(eventTypes, function(eventType) {
          $element.off(eventType, parseEvents);
        });

        // remove any attached keyboard handlers in case element is removed while
        // speed dial is open
        disableKeyboard();
      });
    }

    var closeTimeout;
    function parseEvents(event) {
      // If the event is a click, just handle it
      if (event.type == 'click') {
        handleItemClick(event);
      }

      // If we focusout, set a timeout to close the element
      if (event.type == 'focusout' && !closeTimeout) {
        closeTimeout = $timeout(function() {
          vm.close();
        }, 100, false);
      }

      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
      if (event.type == 'focusin' && closeTimeout) {
        $timeout.cancel(closeTimeout);
        closeTimeout = null;
      }
    }

    function resetActionIndex() {
      vm.currentActionIndex = -1;
    }

    function setupWatchers() {
      // Watch for changes to the direction and update classes/attributes
      $scope.$watch('vm.direction', function(newDir, oldDir) {
        // Add the appropriate classes so we can target the direction in the CSS
        $animate.removeClass($element, 'md-' + oldDir);
        $animate.addClass($element, 'md-' + newDir);

        // Reset the action index since it may have changed
        resetActionIndex();
      });

      var trigger, actions;

      // Watch for changes to md-open
      $scope.$watch('vm.isOpen', function(isOpen) {
        // Reset the action index since it may have changed
        resetActionIndex();

        // We can't get the trigger/actions outside of the watch because the component hasn't been
        // linked yet, so we wait until the first watch fires to cache them.
        if (!trigger || !actions) {
          trigger = getTriggerElement();
          actions = getActionsElement();
        }

        if (isOpen) {
          enableKeyboard();
        } else {
          disableKeyboard();
        }

        var toAdd = isOpen ? 'md-is-open' : '';
        var toRemove = isOpen ? '' : 'md-is-open';

        // Set the proper ARIA attributes
        trigger.attr('aria-haspopup', true);
        trigger.attr('aria-expanded', isOpen);
        actions.attr('aria-hidden', !isOpen);

        // Animate the CSS classes
        $animate.setClass($element, toAdd, toRemove);
      });
    }

    function fireInitialAnimations() {
      // If the element is actually visible on the screen
      if ($element[0].scrollHeight > 0) {
        // Fire our animation
        $animate.addClass($element, '_md-animations-ready').then(function() {
          // Remove the waiting class
          $element.removeClass('md-animations-waiting');
        });
      }

      // Otherwise, try for up to 1 second before giving up
      else if (initialAnimationAttempts < 10) {
        $timeout(fireInitialAnimations, 100);

        // Increment our counter
        initialAnimationAttempts = initialAnimationAttempts + 1;
      }
    }

    function enableKeyboard() {
      $element.on('keydown', keyPressed);

      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
      $mdUtil.nextTick(function() {
        angular.element(document).on('click touchend', checkForOutsideClick);
      });

      // TODO: On desktop, we should be able to reset the indexes so you cannot tab through, but
      // this breaks accessibility, especially on mobile, since you have no arrow keys to press
      //resetActionTabIndexes();
    }

    function disableKeyboard() {
      $element.off('keydown', keyPressed);
      angular.element(document).off('click touchend', checkForOutsideClick);
    }

    function checkForOutsideClick(event) {
      if (event.target) {
        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');

        if (!closestTrigger && !closestActions) {
          vm.close();
        }
      }
    }

    function keyPressed(event) {
      switch (event.which) {
        case $mdConstant.KEY_CODE.ESCAPE: vm.close(); event.preventDefault(); return false;
        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
      }
    }

    function doActionPrev(event) {
      focusAction(event, -1);
    }

    function doActionNext(event) {
      focusAction(event, 1);
    }

    function focusAction(event, direction) {
      var actions = resetActionTabIndexes();

      // Increment/decrement the counter with restrictions
      vm.currentActionIndex = vm.currentActionIndex + direction;
      vm.currentActionIndex = Math.min(actions.length - 1, vm.currentActionIndex);
      vm.currentActionIndex = Math.max(0, vm.currentActionIndex);

      // Focus the element
      var focusElement =  angular.element(actions[vm.currentActionIndex]).children()[0];
      angular.element(focusElement).attr('tabindex', 0);
      focusElement.focus();

      // Make sure the event doesn't bubble and cause something else
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    function resetActionTabIndexes() {
      // Grab all of the actions
      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');

      // Disable all other actions for tabbing
      angular.forEach(actions, function(action) {
        angular.element(angular.element(action).children()[0]).attr('tabindex', -1);
      });

      return actions;
    }

    function doKeyLeft(event) {
      if (vm.direction === 'left') {
        doActionNext(event);
      } else {
        doActionPrev(event);
      }
    }

    function doKeyUp(event) {
      if (vm.direction === 'down') {
        doActionPrev(event);
      } else {
        doActionNext(event);
      }
    }

    function doKeyRight(event) {
      if (vm.direction === 'left') {
        doActionPrev(event);
      } else {
        doActionNext(event);
      }
    }

    function doKeyDown(event) {
      if (vm.direction === 'up') {
        doActionPrev(event);
      } else {
        doActionNext(event);
      }
    }

    function isTrigger(element) {
      return $mdUtil.getClosest(element, 'md-fab-trigger');
    }

    function isAction(element) {
      return $mdUtil.getClosest(element, 'md-fab-actions');
    }

    function handleItemClick(event) {
      if (isTrigger(event.target)) {
        vm.toggle();
      }

      if (isAction(event.target)) {
        vm.close();
      }
    }

    function getTriggerElement() {
      return $element.find('md-fab-trigger');
    }

    function getActionsElement() {
      return $element.find('md-fab-actions');
    }
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * The duration of the CSS animation in milliseconds.
   *
   * @type {number}
   */
  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
  var cssAnimationDuration = 300;

  /**
   * @ngdoc module
   * @name material.components.fabSpeedDial
   */
  angular
    // Declare our module
    .module('material.components.fabSpeedDial', [
      'material.core',
      'material.components.fabShared',
      'material.components.fabActions'
    ])

    // Register our directive
    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)

    // Register our custom animations
    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
    .animation('.md-scale', MdFabSpeedDialScaleAnimation)

    // Register a service for each animation so that we can easily inject them into unit tests
    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);

  /**
   * @ngdoc directive
   * @name mdFabSpeedDial
   * @module material.components.fabSpeedDial
   *
   * @restrict E
   *
   * @description
   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
   * `<md-button>`s) for quick access to common actions.
   *
   * There are currently two animations available by applying one of the following classes to
   * the component:
   *
   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
   *    appropriate positions.
   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
   *
   * You may also easily position the trigger by applying one one of the following classes to the
   * `<md-fab-speed-dial>` element:
   *  - `md-fab-top-left`
   *  - `md-fab-top-right`
   *  - `md-fab-bottom-left`
   *  - `md-fab-bottom-right`
   *
   * These CSS classes use `position: absolute`, so you need to ensure that the container element
   * also uses `position: absolute` or `position: relative` in order for them to work.
   *
   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
   * open or close the speed dial. However, if you wish to allow users to hover over the empty
   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
   * dial element. Without this, the hover effect will only occur on top of the trigger.
   *
   * See the demos for more information.
   *
   * ## Troubleshooting
   *
   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
   * the parent container to ensure that it is only visible once ready. We have plans to remove this
   * necessity in the future.
   *
   * @usage
   * <hljs lang="html">
   * <md-fab-speed-dial md-direction="up" class="md-fling">
   *   <md-fab-trigger>
   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
   *   </md-fab-trigger>
   *
   *   <md-fab-actions>
   *     <md-button aria-label="Add User">
   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
   *     </md-button>
   *
   *     <md-button aria-label="Add Group">
   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
   *     </md-button>
   *   </md-fab-actions>
   * </md-fab-speed-dial>
   * </hljs>
   *
   * @param {string} md-direction From which direction you would like the speed dial to appear
   * relative to the trigger element.
   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
   */
  function MdFabSpeedDialDirective() {
    return {
      restrict: 'E',

      scope: {
        direction: '@?mdDirection',
        isOpen: '=?mdOpen'
      },

      bindToController: true,
      controller: 'MdFabController',
      controllerAs: 'vm',

      link: FabSpeedDialLink
    };

    function FabSpeedDialLink(scope, element) {
      // Prepend an element to hold our CSS variables so we can use them in the animations below
      element.prepend('<div class="_md-css-variables"></div>');
    }
  }

  function MdFabSpeedDialFlingAnimation($timeout) {
    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }

    function runAnimation(element) {
      // Don't run if we are still waiting and we are not ready
      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
        return;
      }

      var el = element[0];
      var ctrl = element.controller('mdFabSpeedDial');
      var items = el.querySelectorAll('.md-fab-action-item');

      // Grab our trigger element
      var triggerElement = el.querySelector('md-fab-trigger');

      // Grab our element which stores CSS variables
      var variablesElement = el.querySelector('._md-css-variables');

      // Setup JS variables based on our CSS variables
      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);

      // Always reset the items to their natural position/state
      angular.forEach(items, function(item, index) {
        var styles = item.style;

        styles.transform = styles.webkitTransform = '';
        styles.transitionDelay = '';
        styles.opacity = 1;

        // Make the items closest to the trigger have the highest z-index
        styles.zIndex = (items.length - index) + startZIndex;
      });

      // Set the trigger to be above all of the actions so they disappear behind it.
      triggerElement.style.zIndex = startZIndex + items.length + 1;

      // If the control is closed, hide the items behind the trigger
      if (!ctrl.isOpen) {
        angular.forEach(items, function(item, index) {
          var newPosition, axis;
          var styles = item.style;

          // Make sure to account for differences in the dimensions of the trigger verses the items
          // so that we can properly center everything; this helps hide the item's shadows behind
          // the trigger.
          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;

          switch (ctrl.direction) {
            case 'up':
              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
              axis = 'Y';
              break;
            case 'down':
              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
              axis = 'Y';
              break;
            case 'left':
              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
              axis = 'X';
              break;
            case 'right':
              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
              axis = 'X';
              break;
          }

          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';

          styles.transform = styles.webkitTransform = newTranslate;
        });
      }
    }

    return {
      addClass: function(element, className, done) {
        if (element.hasClass('md-fling')) {
          runAnimation(element);
          delayDone(done);
        } else {
          done();
        }
      },
      removeClass: function(element, className, done) {
        runAnimation(element);
        delayDone(done);
      }
    };
  }

  function MdFabSpeedDialScaleAnimation($timeout) {
    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }

    var delay = 65;

    function runAnimation(element) {
      var el = element[0];
      var ctrl = element.controller('mdFabSpeedDial');
      var items = el.querySelectorAll('.md-fab-action-item');

      // Grab our element which stores CSS variables
      var variablesElement = el.querySelector('._md-css-variables');

      // Setup JS variables based on our CSS variables
      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);

      // Always reset the items to their natural position/state
      angular.forEach(items, function(item, index) {
        var styles = item.style,
          offsetDelay = index * delay;

        styles.opacity = ctrl.isOpen ? 1 : 0;
        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';

        // Make the items closest to the trigger have the highest z-index
        styles.zIndex = (items.length - index) + startZIndex;
      });
    }

    return {
      addClass: function(element, className, done) {
        runAnimation(element);
        delayDone(done);
      },

      removeClass: function(element, className, done) {
        runAnimation(element);
        delayDone(done);
      }
    };
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc module
   * @name material.components.fabToolbar
   */
  angular
    // Declare our module
    .module('material.components.fabToolbar', [
      'material.core',
      'material.components.fabShared',
      'material.components.fabActions'
    ])

    // Register our directive
    .directive('mdFabToolbar', MdFabToolbarDirective)

    // Register our custom animations
    .animation('.md-fab-toolbar', MdFabToolbarAnimation)

    // Register a service for the animation so that we can easily inject it into unit tests
    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);

  /**
   * @ngdoc directive
   * @name mdFabToolbar
   * @module material.components.fabToolbar
   *
   * @restrict E
   *
   * @description
   *
   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
   * for quick access to common actions when a floating action button is activated (via click or
   * keyboard navigation).
   *
   * You may also easily position the trigger by applying one one of the following classes to the
   * `<md-fab-toolbar>` element:
   *  - `md-fab-top-left`
   *  - `md-fab-top-right`
   *  - `md-fab-bottom-left`
   *  - `md-fab-bottom-right`
   *
   * These CSS classes use `position: absolute`, so you need to ensure that the container element
   * also uses `position: absolute` or `position: relative` in order for them to work.
   *
   * @usage
   *
   * <hljs lang="html">
   * <md-fab-toolbar md-direction='left'>
   *   <md-fab-trigger>
   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
   *   </md-fab-trigger>
   *
   *   <md-toolbar>
   *    <md-fab-actions>
   *      <md-button aria-label="Add User">
   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
   *      </md-button>
   *
   *      <md-button aria-label="Add Group">
   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
   *      </md-button>
   *    </md-fab-actions>
   *   </md-toolbar>
   * </md-fab-toolbar>
   * </hljs>
   *
   * @param {string} md-direction From which direction you would like the toolbar items to appear
   * relative to the trigger element. Supports `left` and `right` directions.
   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
   */
  function MdFabToolbarDirective() {
    return {
      restrict: 'E',
      transclude: true,
      template: '<div class="md-fab-toolbar-wrapper">' +
      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
      '</div>',

      scope: {
        direction: '@?mdDirection',
        isOpen: '=?mdOpen'
      },

      bindToController: true,
      controller: 'MdFabController',
      controllerAs: 'vm',

      link: link
    };

    function link(scope, element, attributes) {
      // Add the base class for animations
      element.addClass('md-fab-toolbar');

      // Prepend the background element to the trigger's button
      element.find('md-fab-trigger').find('button')
        .prepend('<div class="md-fab-toolbar-background"></div>');
    }
  }

  function MdFabToolbarAnimation() {

    function runAnimation(element, className, done) {
      // If no className was specified, don't do anything
      if (!className) {
        return;
      }

      var el = element[0];
      var ctrl = element.controller('mdFabToolbar');

      // Grab the relevant child elements
      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
      var triggerElement = el.querySelector('md-fab-trigger button');
      var toolbarElement = el.querySelector('md-toolbar');
      var iconElement = el.querySelector('md-fab-trigger button md-icon');
      var actions = element.find('md-fab-actions').children();

      // If we have both elements, use them to position the new background
      if (triggerElement && backgroundElement) {
        // Get our variables
        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        // Make it twice as big as it should be since we scale from the center
        var scale = 2 * (width / triggerElement.offsetWidth);

        // Set some basic styles no matter what animation we're doing
        backgroundElement.style.backgroundColor = color;
        backgroundElement.style.borderRadius = width + 'px';

        // If we're open
        if (ctrl.isOpen) {
          // Turn on toolbar pointer events when closed
          toolbarElement.style.pointerEvents = 'inherit';

          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
          backgroundElement.style.transform = 'scale(' + scale + ')';

          // Set the next close animation to have the proper delays
          backgroundElement.style.transitionDelay = '0ms';
          iconElement && (iconElement.style.transitionDelay = '.3s');

          // Apply a transition delay to actions
          angular.forEach(actions, function(action, index) {
            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
          });
        } else {
          // Turn off toolbar pointer events when closed
          toolbarElement.style.pointerEvents = 'none';

          // Scale it back down to the trigger's size
          backgroundElement.style.transform = 'scale(1)';

          // Reset the position
          backgroundElement.style.top = '0';

          if (element.hasClass('md-right')) {
            backgroundElement.style.left = '0';
            backgroundElement.style.right = null;
          }

          if (element.hasClass('md-left')) {
            backgroundElement.style.right = '0';
            backgroundElement.style.left = null;
          }

          // Set the next open animation to have the proper delays
          backgroundElement.style.transitionDelay = '200ms';
          iconElement && (iconElement.style.transitionDelay = '0ms');

          // Apply a transition delay to actions
          angular.forEach(actions, function(action, index) {
            action.style.transitionDelay = 200 + (index * 25) + 'ms';
          });
        }
      }
    }

    return {
      addClass: function(element, className, done) {
        runAnimation(element, className, done);
        done();
      },

      removeClass: function(element, className, done) {
        runAnimation(element, className, done);
        done();
      }
    };
  }
})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.icon
 * @description
 * Icon
 */
angular.module('material.components.icon', ['material.core']);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.gridList
 */
GridListController.$inject = ["$mdUtil"];
GridLayoutFactory.$inject = ["$mdUtil"];
GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia"];
GridTileDirective.$inject = ["$mdMedia"];
angular.module('material.components.gridList', ['material.core'])
       .directive('mdGridList', GridListDirective)
       .directive('mdGridTile', GridTileDirective)
       .directive('mdGridTileFooter', GridTileCaptionDirective)
       .directive('mdGridTileHeader', GridTileCaptionDirective)
       .factory('$mdGridLayout', GridLayoutFactory);

/**
 * @ngdoc directive
 * @name mdGridList
 * @module material.components.gridList
 * @restrict E
 * @description
 * Grid lists are an alternative to standard list views. Grid lists are distinct
 * from grids used for layouts and other visual presentations.
 *
 * A grid list is best suited to presenting a homogenous data type, typically
 * images, and is optimized for visual comprehension and differentiating between
 * like data types.
 *
 * A grid list is a continuous element consisting of tessellated, regular
 * subdivisions called cells that contain tiles (`md-grid-tile`).
 *
 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
 *
 * Cells are arrayed vertically and horizontally within the grid.
 *
 * Tiles hold content and can span one or more cells vertically or horizontally.
 *
 * ### Responsive Attributes
 *
 * The `md-grid-list` directive supports "responsive" attributes, which allow
 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
 * currently matching media query.
 *
 * In order to set a responsive attribute, first define the fallback value with
 * the standard attribute name, then add additional attributes with the
 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
 * (ie. `md-cols-lg="8"`)
 *
 * @param {number} md-cols Number of columns in the grid.
 * @param {string} md-row-height One of
 * <ul>
 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
 *   <li>`{width}:{height}` - Ratio of width to height (eg.
 *   `md-row-height="16:9"`)</li>
 *   <li>`"fit"` - Height will be determined by subdividing the available
 *   height by the number of rows</li>
 * </ul>
 * @param {string=} md-gutter The amount of space between tiles in CSS units
 *     (default 1px)
 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
 *     object is available as `$event`, and contains performance information.
 *
 * @usage
 * Basic:
 * <hljs lang="html">
 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 *
 * Fixed-height rows:
 * <hljs lang="html">
 * <md-grid-list md-cols="4" md-row-height="200px" ...>
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 *
 * Fit rows:
 * <hljs lang="html">
 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 *
 * Using responsive attributes:
 * <hljs lang="html">
 * <md-grid-list
 *     md-cols-sm="2"
 *     md-cols-md="4"
 *     md-cols-lg="8"
 *     md-cols-gt-lg="12"
 *     ...>
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 */
function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia) {
  return {
    restrict: 'E',
    controller: GridListController,
    scope: {
      mdOnLayout: '&'
    },
    link: postLink
  };

  function postLink(scope, element, attrs, ctrl) {
    element.addClass('_md');     // private md component indicator for styling
    
    // Apply semantics
    element.attr('role', 'list');

    // Provide the controller with a way to trigger layouts.
    ctrl.layoutDelegate = layoutDelegate;

    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
        unwatchAttrs = watchMedia();
      scope.$on('$destroy', unwatchMedia);

    /**
     * Watches for changes in media, invalidating layout as necessary.
     */
    function watchMedia() {
      for (var mediaName in $mdConstant.MEDIA) {
        $mdMedia(mediaName); // initialize
        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
            .addListener(invalidateLayout);
      }
      return $mdMedia.watchResponsiveAttributes(
          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
    }

    function unwatchMedia() {
      ctrl.layoutDelegate = angular.noop;

      unwatchAttrs();
      for (var mediaName in $mdConstant.MEDIA) {
        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
            .removeListener(invalidateLayout);
      }
    }

    /**
     * Performs grid layout if the provided mediaName matches the currently
     * active media type.
     */
    function layoutIfMediaMatch(mediaName) {
      if (mediaName == null) {
        // TODO(shyndman): It would be nice to only layout if we have
        // instances of attributes using this media type
        ctrl.invalidateLayout();
      } else if ($mdMedia(mediaName)) {
        ctrl.invalidateLayout();
      }
    }

    var lastLayoutProps;

    /**
     * Invokes the layout engine, and uses its results to lay out our
     * tile elements.
     *
     * @param {boolean} tilesInvalidated Whether tiles have been
     *    added/removed/moved since the last layout. This is to avoid situations
     *    where tiles are replaced with properties identical to their removed
     *    counterparts.
     */
    function layoutDelegate(tilesInvalidated) {
      var tiles = getTileElements();
      var props = {
        tileSpans: getTileSpans(tiles),
        colCount: getColumnCount(),
        rowMode: getRowMode(),
        rowHeight: getRowHeight(),
        gutter: getGutter()
      };

      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
        return;
      }

      var performance =
        $mdGridLayout(props.colCount, props.tileSpans, tiles)
          .map(function(tilePositions, rowCount) {
            return {
              grid: {
                element: element,
                style: getGridStyle(props.colCount, rowCount,
                    props.gutter, props.rowMode, props.rowHeight)
              },
              tiles: tilePositions.map(function(ps, i) {
                return {
                  element: angular.element(tiles[i]),
                  style: getTileStyle(ps.position, ps.spans,
                      props.colCount, rowCount,
                      props.gutter, props.rowMode, props.rowHeight)
                }
              })
            }
          })
          .reflow()
          .performance();

      // Report layout
      scope.mdOnLayout({
        $event: {
          performance: performance
        }
      });

      lastLayoutProps = props;
    }

    // Use $interpolate to do some simple string interpolation as a convenience.

    var startSymbol = $interpolate.startSymbol();
    var endSymbol = $interpolate.endSymbol();

    // Returns an expression wrapped in the interpolator's start and end symbols.
    function expr(exprStr) {
      return startSymbol + exprStr + endSymbol;
    }

    // The amount of space a single 1x1 tile would take up (either width or height), used as
    // a basis for other calculations. This consists of taking the base size percent (as would be
    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
    // However, since there are no gutters on the edges, each tile only uses a fration
    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');

    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
    // row/column (offset).
    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');

    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
    // in the space that the gutter would normally have used (which was already accounted for in
    // the base unit calculation).
    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');

    /**
     * Gets the styles applied to a tile element described by the given parameters.
     * @param {{row: number, col: number}} position The row and column indices of the tile.
     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
     * @param {number} colCount The number of columns.
     * @param {number} rowCount The number of rows.
     * @param {string} gutter The amount of space between tiles. This will be something like
     *     '5px' or '2em'.
     * @param {string} rowMode The row height mode. Can be one of:
     *     'fixed': all rows have a fixed size, given by rowHeight,
     *     'ratio': row height defined as a ratio to width, or
     *     'fit': fit to the grid-list element height, divinding evenly among rows.
     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
     *     values for top, left, width, height, marginTop, and paddingTop.
     */
    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
      // TODO(shyndman): There are style caching opportunities here.

      // Percent of the available horizontal space that one column takes up.
      var hShare = (1 / colCount) * 100;

      // Fraction of the gutter size that each column takes up.
      var hGutterShare = (colCount - 1) / colCount;

      // Base horizontal size of a column.
      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});

      // The width and horizontal position of each tile is always calculated the same way, but the
      // height and vertical position depends on the rowMode.
      var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
      var style = ltr ? {
          left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
          width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
          // resets
          paddingTop: '',
          marginTop: '',
          top: '',
          height: ''
        } : {
        right: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
        // resets
        paddingTop: '',
        marginTop: '',
        top: '',
        height: ''
      };

      switch (rowMode) {
        case 'fixed':
          // In fixed mode, simply use the given rowHeight.
          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
          break;

        case 'ratio':
          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
          var vShare = hShare / rowHeight;

          // Base veritcal size of a row.
          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });

          // padidngTop and marginTop are used to maintain the given aspect ratio, as
          // a percentage-based value for these properties is applied to the *width* of the
          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
          break;

        case 'fit':
          // Fraction of the gutter size that each column takes up.
          var vGutterShare = (rowCount - 1) / rowCount;

          // Percent of the available vertical space that one row takes up.
          var vShare = (1 / rowCount) * 100;

          // Base vertical size of a row.
          var vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});

          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
          break;
      }

      return style;
    }

    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
      var style = {};

      switch(rowMode) {
        case 'fixed':
          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
          style.paddingBottom = '';
          break;

        case 'ratio':
          // rowHeight is width / height
          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
              hShare = (1 / colCount) * 100,
              vShare = hShare * (1 / rowHeight),
              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });

          style.height = '';
          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
          break;

        case 'fit':
          // noop, as the height is user set
          break;
      }

      return style;
    }

    function getTileElements() {
      return [].filter.call(element.children(), function(ele) {
        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
      });
    }

    /**
     * Gets an array of objects containing the rowspan and colspan for each tile.
     * @returns {Array<{row: number, col: number}>}
     */
    function getTileSpans(tileElements) {
      return [].map.call(tileElements, function(ele) {
        var ctrl = angular.element(ele).controller('mdGridTile');
        return {
          row: parseInt(
              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
          col: parseInt(
              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
        };
      });
    }

    function getColumnCount() {
      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
      if (isNaN(colCount)) {
        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
      }
      return colCount;
    }

    function getGutter() {
      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
    }

    function getRowHeight() {
      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
      if (!rowHeight) {
        throw 'md-grid-list: md-row-height attribute was not found';
      }

      switch (getRowMode()) {
        case 'fixed':
          return applyDefaultUnit(rowHeight);
        case 'ratio':
          var whRatio = rowHeight.split(':');
          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
        case 'fit':
          return 0; // N/A
      }
    }

    function getRowMode() {
      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
      if (!rowHeight) {
        throw 'md-grid-list: md-row-height attribute was not found';
      }

      if (rowHeight == 'fit') {
        return 'fit';
      } else if (rowHeight.indexOf(':') !== -1) {
        return 'ratio';
      } else {
        return 'fixed';
      }
    }

    function applyDefaultUnit(val) {
      return /\D$/.test(val) ? val : val + 'px';
    }
  }
}

/* @ngInject */
function GridListController($mdUtil) {
  this.layoutInvalidated = false;
  this.tilesInvalidated = false;
  this.$timeout_ = $mdUtil.nextTick;
  this.layoutDelegate = angular.noop;
}

GridListController.prototype = {
  invalidateTiles: function() {
    this.tilesInvalidated = true;
    this.invalidateLayout();
  },

  invalidateLayout: function() {
    if (this.layoutInvalidated) {
      return;
    }
    this.layoutInvalidated = true;
    this.$timeout_(angular.bind(this, this.layout));
  },

  layout: function() {
    try {
      this.layoutDelegate(this.tilesInvalidated);
    } finally {
      this.layoutInvalidated = false;
      this.tilesInvalidated = false;
    }
  }
};


/* @ngInject */
function GridLayoutFactory($mdUtil) {
  var defaultAnimator = GridTileAnimator;

  /**
   * Set the reflow animator callback
   */
  GridLayout.animateWith = function(customAnimator) {
    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
  };

  return GridLayout;

  /**
   * Publish layout function
   */
  function GridLayout(colCount, tileSpans) {
      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;

      layoutTime = $mdUtil.time(function() {
        layoutInfo = calculateGridFor(colCount, tileSpans);
      });

      return self = {

        /**
         * An array of objects describing each tile's position in the grid.
         */
        layoutInfo: function() {
          return layoutInfo;
        },

        /**
         * Maps grid positioning to an element and a set of styles using the
         * provided updateFn.
         */
        map: function(updateFn) {
          mapTime = $mdUtil.time(function() {
            var info = self.layoutInfo();
            gridStyles = updateFn(info.positioning, info.rowCount);
          });
          return self;
        },

        /**
         * Default animator simply sets the element.css( <styles> ). An alternate
         * animator can be provided as an argument. The function has the following
         * signature:
         *
         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
         */
        reflow: function(animatorFn) {
          reflowTime = $mdUtil.time(function() {
            var animator = animatorFn || defaultAnimator;
            animator(gridStyles.grid, gridStyles.tiles);
          });
          return self;
        },

        /**
         * Timing for the most recent layout run.
         */
        performance: function() {
          return {
            tileCount: tileSpans.length,
            layoutTime: layoutTime,
            mapTime: mapTime,
            reflowTime: reflowTime,
            totalTime: layoutTime + mapTime + reflowTime
          };
        }
      };
    }

  /**
   * Default Gridlist animator simple sets the css for each element;
   * NOTE: any transitions effects must be manually set in the CSS.
   * e.g.
   *
   *  md-grid-tile {
   *    transition: all 700ms ease-out 50ms;
   *  }
   *
   */
  function GridTileAnimator(grid, tiles) {
    grid.element.css(grid.style);
    tiles.forEach(function(t) {
      t.element.css(t.style);
    })
  }

  /**
   * Calculates the positions of tiles.
   *
   * The algorithm works as follows:
   *    An Array<Number> with length colCount (spaceTracker) keeps track of
   *    available tiling positions, where elements of value 0 represents an
   *    empty position. Space for a tile is reserved by finding a sequence of
   *    0s with length <= than the tile's colspan. When such a space has been
   *    found, the occupied tile positions are incremented by the tile's
   *    rowspan value, as these positions have become unavailable for that
   *    many rows.
   *
   *    If the end of a row has been reached without finding space for the
   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
   *    of 0. Rows are searched in this fashion until space is found.
   */
  function calculateGridFor(colCount, tileSpans) {
    var curCol = 0,
        curRow = 0,
        spaceTracker = newSpaceTracker();

    return {
      positioning: tileSpans.map(function(spans, i) {
        return {
          spans: spans,
          position: reserveSpace(spans, i)
        };
      }),
      rowCount: curRow + Math.max.apply(Math, spaceTracker)
    };

    function reserveSpace(spans, i) {
      if (spans.col > colCount) {
        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
            '(' + spans.col + ') that exceeds the column count ' +
            '(' + colCount + ')';
      }

      var start = 0,
          end = 0;

      // TODO(shyndman): This loop isn't strictly necessary if you can
      // determine the minimum number of rows before a space opens up. To do
      // this, recognize that you've iterated across an entire row looking for
      // space, and if so fast-forward by the minimum rowSpan count. Repeat
      // until the required space opens up.
      while (end - start < spans.col) {
        if (curCol >= colCount) {
          nextRow();
          continue;
        }

        start = spaceTracker.indexOf(0, curCol);
        if (start === -1 || (end = findEnd(start + 1)) === -1) {
          start = end = 0;
          nextRow();
          continue;
        }

        curCol = end + 1;
      }

      adjustRow(start, spans.col, spans.row);
      curCol = start + spans.col;

      return {
        col: start,
        row: curRow
      };
    }

    function nextRow() {
      curCol = 0;
      curRow++;
      adjustRow(0, colCount, -1); // Decrement row spans by one
    }

    function adjustRow(from, cols, by) {
      for (var i = from; i < from + cols; i++) {
        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
      }
    }

    function findEnd(start) {
      var i;
      for (i = start; i < spaceTracker.length; i++) {
        if (spaceTracker[i] !== 0) {
          return i;
        }
      }

      if (i === spaceTracker.length) {
        return i;
      }
    }

    function newSpaceTracker() {
      var tracker = [];
      for (var i = 0; i < colCount; i++) {
        tracker.push(0);
      }
      return tracker;
    }
  }
}

/**
 * @ngdoc directive
 * @name mdGridTile
 * @module material.components.gridList
 * @restrict E
 * @description
 * Tiles contain the content of an `md-grid-list`. They span one or more grid
 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
 * display secondary content.
 *
 * ### Responsive Attributes
 *
 * The `md-grid-tile` directive supports "responsive" attributes, which allow
 * different `md-rowspan` and `md-colspan` values depending on the currently
 * matching media query.
 *
 * In order to set a responsive attribute, first define the fallback value with
 * the standard attribute name, then add additional attributes with the
 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
 * (ie. `md-colspan-sm="4"`)
 *
 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
 *    exceed the number of columns in the grid. Supports interpolation.
 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
 *     interpolation.
 *
 * @usage
 * With header:
 * <hljs lang="html">
 * <md-grid-tile>
 *   <md-grid-tile-header>
 *     <h3>This is a header</h3>
 *   </md-grid-tile-header>
 * </md-grid-tile>
 * </hljs>
 *
 * With footer:
 * <hljs lang="html">
 * <md-grid-tile>
 *   <md-grid-tile-footer>
 *     <h3>This is a footer</h3>
 *   </md-grid-tile-footer>
 * </md-grid-tile>
 * </hljs>
 *
 * Spanning multiple rows/columns:
 * <hljs lang="html">
 * <md-grid-tile md-colspan="2" md-rowspan="3">
 * </md-grid-tile>
 * </hljs>
 *
 * Responsive attributes:
 * <hljs lang="html">
 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
 * </md-grid-tile>
 * </hljs>
 */
function GridTileDirective($mdMedia) {
  return {
    restrict: 'E',
    require: '^mdGridList',
    template: '<figure ng-transclude></figure>',
    transclude: true,
    scope: {},
    // Simple controller that exposes attributes to the grid directive
    controller: ["$attrs", function($attrs) {
      this.$attrs = $attrs;
    }],
    link: postLink
  };

  function postLink(scope, element, attrs, gridCtrl) {
    // Apply semantics
    element.attr('role', 'listitem');

    // If our colspan or rowspan changes, trigger a layout
    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));

    // Tile registration/deregistration
    gridCtrl.invalidateTiles();
    scope.$on('$destroy', function() {
      // Mark the tile as destroyed so it is no longer considered in layout,
      // even if the DOM element sticks around (like during a leave animation)
      element[0].$$mdDestroyed = true;
      unwatchAttrs();
      gridCtrl.invalidateLayout();
    });

    if (angular.isDefined(scope.$parent.$index)) {
      scope.$watch(function() { return scope.$parent.$index; },
        function indexChanged(newIdx, oldIdx) {
          if (newIdx === oldIdx) {
            return;
          }
          gridCtrl.invalidateTiles();
        });
    }
  }
}


function GridTileCaptionDirective() {
  return {
    template: '<figcaption ng-transclude></figcaption>',
    transclude: true
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.input
 */
mdInputContainerDirective.$inject = ["$mdTheming", "$parse"];
inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
placeholderDirective.$inject = ["$compile"];
ngMessageDirective.$inject = ["$mdUtil"];
mdSelectOnFocusDirective.$inject = ["$timeout"];
mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
var inputModule = angular.module('material.components.input', [
    'material.core'
  ])
  .directive('mdInputContainer', mdInputContainerDirective)
  .directive('label', labelDirective)
  .directive('input', inputTextareaDirective)
  .directive('textarea', inputTextareaDirective)
  .directive('mdMaxlength', mdMaxlengthDirective)
  .directive('placeholder', placeholderDirective)
  .directive('ngMessages', ngMessagesDirective)
  .directive('ngMessage', ngMessageDirective)
  .directive('ngMessageExp', ngMessageDirective)
  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)

  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
  .animation('.md-input-messages-animation', ngMessagesAnimation)
  .animation('.md-input-message-animation', ngMessageAnimation);

// If we are running inside of tests; expose some extra services so that we can test them
if (window._mdMocksIncluded) {
  inputModule.service('$$mdInput', function() {
    return {
      // special accessor to internals... useful for testing
      messages: {
        show        : showInputMessages,
        hide        : hideInputMessages,
        getElement  : getMessagesElement
      }
    }
  })

  // Register a service for each animation so that we can easily inject them into unit tests
  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
  .service('mdInputMessagesAnimation', ngMessagesAnimation)
  .service('mdInputMessageAnimation', ngMessageAnimation);
}

/**
 * @ngdoc directive
 * @name mdInputContainer
 * @module material.components.input
 *
 * @restrict E
 *
 * @description
 * `<md-input-container>` is the parent of any input or textarea element.
 *
 * Input and textarea elements will not behave properly unless the md-input-container
 * parent is provided.
 *
 * A single `<md-input-container>` should contain only one `<input>` element, otherwise it will throw an error.
 *
 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an error, so
 * you may combine these with other inputs.
 *
 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container elements
 * are *block* elements, otherwise animations applied to the messages will not look as intended. Either use a `div` and
 * apply the `ng-message` and `ng-messages` classes respectively, or use the `md-block` class on your element.
 *
 * @param md-is-error {expression=} When the given expression evaluates to true, the input container
 *   will go into error state. Defaults to erroring if the input has been touched and is invalid.
 * @param md-no-float {boolean=} When present, `placeholder` attributes on the input will not be converted to floating
 *   labels.
 *
 * @usage
 * <hljs lang="html">
 *
 * <md-input-container>
 *   <label>Username</label>
 *   <input type="text" ng-model="user.name">
 * </md-input-container>
 *
 * <md-input-container>
 *   <label>Description</label>
 *   <textarea ng-model="user.description"></textarea>
 * </md-input-container>
 *
 * </hljs>
 *
 * <h3>When disabling floating labels</h3>
 * <hljs lang="html">
 *
 * <md-input-container md-no-float>
 *   <input type="text" placeholder="Non-Floating Label">
 * </md-input-container>
 *
 * </hljs>
 */
function mdInputContainerDirective($mdTheming, $parse) {

  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];

  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
  }, []).join(",");

  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
  }, []).join(",");

  return {
    restrict: 'E',
    compile: compile,
    controller: ContainerCtrl
  };

  function compile(tElement) {
    // Check for both a left & right icon
    var leftIcon = tElement[0].querySelector(LEFT_SELECTORS);
    var rightIcon = tElement[0].querySelector(RIGHT_SELECTORS);

    if (leftIcon) { tElement.addClass('md-icon-left'); }
    if (rightIcon) { tElement.addClass('md-icon-right'); }

    return function postLink(scope, element) {
      $mdTheming(element);
    };
  }

  function ContainerCtrl($scope, $element, $attrs, $animate) {
    var self = this;

    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);

    self.delegateClick = function() {
      self.input.focus();
    };
    self.element = $element;
    self.setFocused = function(isFocused) {
      $element.toggleClass('md-input-focused', !!isFocused);
    };
    self.setHasValue = function(hasValue) {
      $element.toggleClass('md-input-has-value', !!hasValue);
    };
    self.setHasPlaceholder = function(hasPlaceholder) {
      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
    };
    self.setInvalid = function(isInvalid) {
      if (isInvalid) {
        $animate.addClass($element, 'md-input-invalid');
      } else {
        $animate.removeClass($element, 'md-input-invalid');
      }
    };
    $scope.$watch(function() {
      return self.label && self.input;
    }, function(hasLabelAndInput) {
      if (hasLabelAndInput && !self.label.attr('for')) {
        self.label.attr('for', self.input.attr('id'));
      }
    });
  }
}

function labelDirective() {
  return {
    restrict: 'E',
    require: '^?mdInputContainer',
    link: function(scope, element, attr, containerCtrl) {
      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;

      containerCtrl.label = element;
      scope.$on('$destroy', function() {
        containerCtrl.label = null;
      });
    }
  };
}

/**
 * @ngdoc directive
 * @name mdInput
 * @restrict E
 * @module material.components.input
 *
 * @description
 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
 * allows you to build complex forms for data entry.
 *
 * When the input is required and uses a floating label, then the label will automatically contain
 * an asterisk (`*`).<br/>
 * This behavior can be disabled by using the `md-no-asterisk` attribute.
 *
 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
 *   specified, a character counter will be shown underneath the input.<br/><br/>
 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
 *   or maxlength attributes.<br/><br/>
 *   **Note:** Only valid for text/string inputs (not numeric).
 *
 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
 *   will be logged in the console if not present.
 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
 *   PRESENT. The placeholder text is copied to the aria-label attribute.
 * @param md-no-autogrow {boolean=} When present, textareas will not grow automatically.
 * @param md-no-asterisk {boolean=} When present, an asterisk will not be appended to the inputs floating label
 * @param md-no-resize {boolean=} Disables the textarea resize handle.
 * @param {number=} max-rows The maximum amount of rows for a textarea.
 * @param md-detect-hidden {boolean=} When present, textareas will be sized properly when they are
 *   revealed after being hidden. This is off by default for performance reasons because it
 *   guarantees a reflow every digest cycle.
 *
 * @usage
 * <hljs lang="html">
 * <md-input-container>
 *   <label>Color</label>
 *   <input type="text" ng-model="color" required md-maxlength="10">
 * </md-input-container>
 * </hljs>
 *
 * <h3>With Errors</h3>
 *
 * `md-input-container` also supports errors using the standard `ng-messages` directives and
 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
 * the `ngShow`/`ngHide` events.
 *
 * By default, the messages will be hidden until the input is in an error state. This is based off
 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
 * fill out the form before the errors become visible.
 *
 * <hljs lang="html">
 * <form name="colorForm">
 *   <md-input-container>
 *     <label>Favorite Color</label>
 *     <input name="favoriteColor" ng-model="favoriteColor" required>
 *     <div ng-messages="colorForm.favoriteColor.$error">
 *       <div ng-message="required">This is required!</div>
 *     </div>
 *   </md-input-container>
 * </form>
 * </hljs>
 *
 * We automatically disable this auto-hiding functionality if you provide any of the following
 * visibility directives on the `ng-messages` container:
 *
 *  - `ng-if`
 *  - `ng-show`/`ng-hide`
 *  - `ng-switch-when`/`ng-switch-default`
 *
 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
 * or if you are building your own visibilty directive.
 *
 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
 * initialization of the `ng-messages` directive to see if it equals the string `false`._
 *
 * <hljs lang="html">
 * <form name="userForm">
 *   <md-input-container>
 *     <label>Last Name</label>
 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
 *       <div ng-message="required">This is required!</div>
 *       <div ng-message="md-maxlength">That's too long!</div>
 *       <div ng-message="minlength">That's too short!</div>
 *     </div>
 *   </md-input-container>
 *   <md-input-container>
 *     <label>Biography</label>
 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
 *       <div ng-message="required">This is required!</div>
 *       <div ng-message="md-maxlength">That's too long!</div>
 *     </div>
 *   </md-input-container>
 *   <md-input-container>
 *     <input aria-label='title' ng-model='title'>
 *   </md-input-container>
 *   <md-input-container>
 *     <input placeholder='title' ng-model='title'>
 *   </md-input-container>
 * </form>
 * </hljs>
 *
 * <h3>Notes</h3>
 *
 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
 *
 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
 *
 *
 * <h3>Textarea directive</h3>
 * The `textarea` element within a `md-input-container` has the following specific behavior:
 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
 * attribute.
 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
 * high initially. If no rows are specified, the directive defaults to 1.
 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
 */

function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
  return {
    restrict: 'E',
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    link: postLink
  };

  function postLink(scope, element, attr, ctrls) {

    var containerCtrl = ctrls[0];
    var hasNgModel = !!ctrls[1];
    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
    var parentForm = ctrls[2];
    var isReadonly = angular.isDefined(attr.readonly);
    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
    var tagName = element[0].tagName.toLowerCase();


    if (!containerCtrl) return;
    if (attr.type === 'hidden') {
      element.attr('aria-hidden', 'true');
      return;
    } else if (containerCtrl.input) {
      if (containerCtrl.input[0].contains(element[0])) {
        return;
      } else {
        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
      }
    }
    containerCtrl.input = element;

    setupAttributeWatchers();

    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
    element.after(errorsSpacer);

    var placeholderText = angular.isString(attr.placeholder) ? attr.placeholder.trim() : '';
    if (!containerCtrl.label && !placeholderText.length) {
      $mdAria.expect(element, 'aria-label');
    }

    element.addClass('md-input');
    if (!element.attr('id')) {
      element.attr('id', 'input_' + $mdUtil.nextUid());
    }

    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
    // for more info. Also note that we don't override the `step` if the user has specified it,
    // in order to prevent some unexpected behaviour.
    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
      element.attr('step', 'any');
    } else if (tagName === 'textarea') {
      setupTextarea();
    }

    // If the input doesn't have an ngModel, it may have a static value. For that case,
    // we have to do one initial check to determine if the container should be in the
    // "has a value" state.
    if (!hasNgModel) {
      inputCheckValue();
    }

    var isErrorGetter = containerCtrl.isErrorGetter || function() {
      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
    };

    scope.$watch(isErrorGetter, containerCtrl.setInvalid);

    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
    // AngularJS's ngValue directive is just setting the `value` attribute.
    if (attr.ngValue) {
      attr.$observe('value', inputCheckValue);
    }

    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

    element.on('input', inputCheckValue);

    if (!isReadonly) {
      element
        .on('focus', function(ev) {
          $mdUtil.nextTick(function() {
            containerCtrl.setFocused(true);
          });
        })
        .on('blur', function(ev) {
          $mdUtil.nextTick(function() {
            containerCtrl.setFocused(false);
            inputCheckValue();
          });
        });
    }

    scope.$on('$destroy', function() {
      containerCtrl.setFocused(false);
      containerCtrl.setHasValue(false);
      containerCtrl.input = null;
    });

    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
    function ngModelPipelineCheckValue(arg) {
      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
      return arg;
    }

    function setupAttributeWatchers() {
      if (containerCtrl.label) {
        attr.$observe('required', function (value) {
          // We don't need to parse the required value, it's always a boolean because of angular's
          // required directive.
          containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
        });
      }
    }

    function inputCheckValue() {
      // An input's value counts if its length > 0,
      // or if the input's validity state says it has bad input (eg string in a number input)
      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
    }

    function setupTextarea() {
      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');

      attachResizeHandle();

      if (!isAutogrowing) return;

      // Can't check if height was or not explicity set,
      // so rows attribute will take precedence if present
      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
      var lineHeight = null;
      var node = element[0];

      // This timeout is necessary, because the browser needs a little bit
      // of time to calculate the `clientHeight` and `scrollHeight`.
      $timeout(function() {
        $mdUtil.nextTick(growTextarea);
      }, 10, false);

      // We could leverage ngModel's $parsers here, however it
      // isn't reliable, because AngularJS trims the input by default,
      // which means that growTextarea won't fire when newlines and
      // spaces are added.
      element.on('input', growTextarea);

      // We should still use the $formatters, because they fire when
      // the value was changed from outside the textarea.
      if (hasNgModel) {
        ngModelCtrl.$formatters.push(formattersListener);
      }

      if (!minRows) {
        element.attr('rows', 1);
      }

      angular.element($window).on('resize', growTextarea);
      scope.$on('$destroy', disableAutogrow);

      function growTextarea() {
        // temporarily disables element's flex so its height 'runs free'
        element
          .attr('rows', 1)
          .css('height', 'auto')
          .addClass('md-no-flex');

        var height = getHeight();

        if (!lineHeight) {
          // offsetHeight includes padding which can throw off our value
          var originalPadding = element[0].style.padding || '';
          lineHeight = element.css('padding', 0).prop('offsetHeight');
          element[0].style.padding = originalPadding;
        }

        if (minRows && lineHeight) {
          height = Math.max(height, lineHeight * minRows);
        }

        if (maxRows && lineHeight) {
          var maxHeight = lineHeight * maxRows;

          if (maxHeight < height) {
            element.attr('md-no-autogrow', '');
            height = maxHeight;
          } else {
            element.removeAttr('md-no-autogrow');
          }
        }

        if (lineHeight) {
          element.attr('rows', Math.round(height / lineHeight));
        }

        element
          .css('height', height + 'px')
          .removeClass('md-no-flex');
      }

      function getHeight() {
        var offsetHeight = node.offsetHeight;
        var line = node.scrollHeight - offsetHeight;
        return offsetHeight + Math.max(line, 0);
      }

      function formattersListener(value) {
        $mdUtil.nextTick(growTextarea);
        return value;
      }

      function disableAutogrow() {
        if (!isAutogrowing) return;

        isAutogrowing = false;
        angular.element($window).off('resize', growTextarea);
        scopeResizeListener && scopeResizeListener();
        element
          .attr('md-no-autogrow', '')
          .off('input', growTextarea);

        if (hasNgModel) {
          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);

          if (listenerIndex > -1) {
            ngModelCtrl.$formatters.splice(listenerIndex, 1);
          }
        }
      }

      function attachResizeHandle() {
        if (attr.hasOwnProperty('mdNoResize')) return;

        var handle = angular.element('<div class="md-resize-handle"></div>');
        var isDragging = false;
        var dragStart = null;
        var startHeight = 0;
        var container = containerCtrl.element;
        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });


        element.wrap('<div class="md-resize-wrapper">').after(handle);
        handle.on('mousedown', onMouseDown);

        container
          .on('$md.dragstart', onDragStart)
          .on('$md.drag', onDrag)
          .on('$md.dragend', onDragEnd);

        scope.$on('$destroy', function() {
          handle
            .off('mousedown', onMouseDown)
            .remove();

          container
            .off('$md.dragstart', onDragStart)
            .off('$md.drag', onDrag)
            .off('$md.dragend', onDragEnd);

          dragGestureHandler();
          handle = null;
          container = null;
          dragGestureHandler = null;
        });

        function onMouseDown(ev) {
          ev.preventDefault();
          isDragging = true;
          dragStart = ev.clientY;
          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
        }

        function onDragStart(ev) {
          if (!isDragging) return;
          ev.preventDefault();
          disableAutogrow();
          container.addClass('md-input-resized');
        }

        function onDrag(ev) {
          if (!isDragging) return;

          element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
        }

        function onDragEnd(ev) {
          if (!isDragging) return;
          isDragging = false;
          container.removeClass('md-input-resized');
        }
      }

      // Attach a watcher to detect when the textarea gets shown.
      if (attr.hasOwnProperty('mdDetectHidden')) {

        var handleHiddenChange = function() {
          var wasHidden = false;

          return function() {
            var isHidden = node.offsetHeight === 0;

            if (isHidden === false && wasHidden === true) {
              growTextarea();
            }

            wasHidden = isHidden;
          };
        }();

        // Check every digest cycle whether the visibility of the textarea has changed.
        // Queue up to run after the digest cycle is complete.
        scope.$watch(function() {
          $mdUtil.nextTick(handleHiddenChange, false);
          return true;
        });
      }
    }
  }
}

function mdMaxlengthDirective($animate, $mdUtil) {
  return {
    restrict: 'A',
    require: ['ngModel', '^mdInputContainer'],
    link: postLink
  };

  function postLink(scope, element, attr, ctrls) {
    var maxlength;
    var ngModelCtrl = ctrls[0];
    var containerCtrl = ctrls[1];
    var charCountEl, errorsSpacer;

    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
    // append our counter
    $mdUtil.nextTick(function() {
      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
      charCountEl = angular.element('<div class="md-char-counter">');

      // Append our character counter inside the errors spacer
      errorsSpacer.append(charCountEl);

      // Stop model from trimming. This makes it so whitespace
      // over the maxlength still counts as invalid.
      attr.$set('ngTrim', 'false');

      scope.$watch(attr.mdMaxlength, function(value) {
        maxlength = value;
        if (angular.isNumber(value) && value > 0) {
          if (!charCountEl.parent().length) {
            $animate.enter(charCountEl, errorsSpacer);
          }
          renderCharCount();
        } else {
          $animate.leave(charCountEl);
        }
      });

      ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
        if (!angular.isNumber(maxlength) || maxlength < 0) {
          return true;
        }

        // We always update the char count, when the modelValue has changed.
        // Using the $validators for triggering the update works very well.
        renderCharCount();

        return ( modelValue || element.val() || viewValue || '' ).length <= maxlength;
      };
    });

    function renderCharCount(value) {
      // If we have not been appended to the body yet; do not render
      if (!charCountEl.parent) {
        return value;
      }

      // Force the value into a string since it may be a number,
      // which does not have a length property.
      charCountEl.text(String(element.val() || value || '').length + ' / ' + maxlength);
      return value;
    }
  }
}

function placeholderDirective($compile) {
  return {
    restrict: 'A',
    require: '^^?mdInputContainer',
    priority: 200,
    link: {
      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
      // support data bindings in the placeholder. This is necessary, because we have a case where
      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
      // If we did this in the post-link, AngularJS would have set up the observers already and would be
      // re-adding the attribute, even though we removed it from the element.
      pre: preLink
    }
  };

  function preLink(scope, element, attr, inputContainer) {
    // If there is no input container, just return
    if (!inputContainer) return;

    var label = inputContainer.element.find('label');
    var noFloat = inputContainer.element.attr('md-no-float');

    // If we have a label, or they specify the md-no-float attribute, just return
    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
      // Add a placeholder class so we can target it in the CSS
      inputContainer.setHasPlaceholder(true);
      return;
    }

    // md-select handles placeholders on it's own
    if (element[0].nodeName != 'MD-SELECT') {
      // Move the placeholder expression to the label
      var newLabel = angular.element('<label ng-click="delegateClick()" tabindex="-1">' + attr.placeholder + '</label>');

      // Note that we unset it via `attr`, in order to get AngularJS
      // to remove any observers that it might have set up. Otherwise
      // the attribute will be added on the next digest.
      attr.$set('placeholder', null);

      // We need to compile the label manually in case it has any bindings.
      // A gotcha here is that we first add the element to the DOM and we compile
      // it later. This is necessary, because if we compile the element beforehand,
      // it won't be able to find the `mdInputContainer` controller.
      inputContainer.element
        .addClass('md-icon-float')
        .prepend(newLabel);

      $compile(newLabel)(scope);
    }
  }
}

/**
 * @ngdoc directive
 * @name mdSelectOnFocus
 * @module material.components.input
 *
 * @restrict A
 *
 * @description
 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
 *
 * <h3>Notes</h3>
 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
 *
 * @usage
 * <h3>Using with an Input</h3>
 * <hljs lang="html">
 *
 * <md-input-container>
 *   <label>Auto Select</label>
 *   <input type="text" md-select-on-focus>
 * </md-input-container>
 * </hljs>
 *
 * <h3>Using with a Textarea</h3>
 * <hljs lang="html">
 *
 * <md-input-container>
 *   <label>Auto Select</label>
 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
 * </md-input-container>
 *
 * </hljs>
 */
function mdSelectOnFocusDirective($timeout) {

  return {
    restrict: 'A',
    link: postLink
  };

  function postLink(scope, element, attr) {
    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;

    var preventMouseUp = false;

    element
      .on('focus', onFocus)
      .on('mouseup', onMouseUp);

    scope.$on('$destroy', function() {
      element
        .off('focus', onFocus)
        .off('mouseup', onMouseUp);
    });

    function onFocus() {
      preventMouseUp = true;

      $timeout(function() {
        // Use HTMLInputElement#select to fix firefox select issues.
        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
        element[0].select();

        // This should be reset from inside the `focus`, because the event might
        // have originated from something different than a click, e.g. a keyboard event.
        preventMouseUp = false;
      }, 1, false);
    }

    // Prevents the default action of the first `mouseup` after a focus.
    // This is necessary, because browsers fire a `mouseup` right after the element
    // has been focused. In some browsers (Firefox in particular) this can clear the
    // selection. There are examples of the problem in issue #7487.
    function onMouseUp(event) {
      if (preventMouseUp) {
        event.preventDefault();
      }
    }
  }
}

var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
function ngMessagesDirective() {
  return {
    restrict: 'EA',
    link: postLink,

    // This is optional because we don't want target *all* ngMessage instances, just those inside of
    // mdInputContainer.
    require: '^^?mdInputContainer'
  };

  function postLink(scope, element, attrs, inputContainer) {
    // If we are not a child of an input container, don't do anything
    if (!inputContainer) return;

    // Add our animation class
    element.toggleClass('md-input-messages-animation', true);

    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
    element.toggleClass('md-auto-hide', true);

    // If we see some known visibility directives, remove the md-auto-hide class
    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
      element.toggleClass('md-auto-hide', false);
    }
  }

  function hasVisibiltyDirective(attrs) {
    return visibilityDirectives.some(function(attr) {
      return attrs[attr];
    });
  }
}

function ngMessageDirective($mdUtil) {
  return {
    restrict: 'EA',
    compile: compile,
    priority: 100
  };

  function compile(tElement) {
    if (!isInsideInputContainer(tElement)) {

      // When the current element is inside of a document fragment, then we need to check for an input-container
      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
      // fragment, which causes the input-container check to fail.
      if (isInsideFragment()) {
        return function (scope, element) {
          if (isInsideInputContainer(element)) {
            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
            // currently hidden. To access the shown element, we need to use the element from the compile function.
            initMessageElement(tElement);
          }
        };
      }
    } else {
      initMessageElement(tElement);
    }

    function isInsideFragment() {
      var nextNode = tElement[0];
      while (nextNode = nextNode.parentNode) {
        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
          return true;
        }
      }
      return false;
    }

    function isInsideInputContainer(element) {
      return !!$mdUtil.getClosest(element, "md-input-container");
    }

    function initMessageElement(element) {
      // Add our animation class
      element.toggleClass('md-input-message-animation', true);
    }
  }
}

var $$AnimateRunner, $animateCss, $mdUtil, $log;

function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);

  return {
    addClass: function(element, className, done) {
      showInputMessages(element, done);
    }

    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
  };
}

function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);

  return {
    enter: function(element, done) {
      showInputMessages(element, done);
    },

    leave: function(element, done) {
      hideInputMessages(element, done);
    },

    addClass: function(element, className, done) {
      if (className == "ng-hide") {
        hideInputMessages(element, done);
      } else {
        done();
      }
    },

    removeClass: function(element, className, done) {
      if (className == "ng-hide") {
        showInputMessages(element, done);
      } else {
        done();
      }
    }
  };
}

function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);

  return {
    enter: function(element, done) {
      var animator = showMessage(element);

      animator.start().done(done);
    },

    leave: function(element, done) {
      var animator = hideMessage(element);

      animator.start().done(done);
    }
  };
}

function showInputMessages(element, done) {
  var animators = [], animator;
  var messages = getMessagesElement(element);
  var children = messages.children();

  if (messages.length == 0 || children.length == 0) {
    $log.warn('mdInput messages show animation called on invalid messages element: ', element);
    done();
    return;
  }

  angular.forEach(children, function(child) {
    animator = showMessage(angular.element(child));

    animators.push(animator.start());
  });

  $$AnimateRunner.all(animators, done);
}

function hideInputMessages(element, done) {
  var animators = [], animator;
  var messages = getMessagesElement(element);
  var children = messages.children();

  if (messages.length == 0 || children.length == 0) {
    $log.warn('mdInput messages hide animation called on invalid messages element: ', element);
    done();
    return;
  }

  angular.forEach(children, function(child) {
    animator = hideMessage(angular.element(child));

    animators.push(animator.start());
  });

  $$AnimateRunner.all(animators, done);
}

function showMessage(element) {
  var height = parseInt(window.getComputedStyle(element[0]).height);
  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);

  var messages = getMessagesElement(element);
  var container = getInputElement(element);

  // Check to see if the message is already visible so we can skip
  var alreadyVisible = (topMargin > -height);

  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
    return $animateCss(element, {});
  }

  return $animateCss(element, {
    event: 'enter',
    structural: true,
    from: {"opacity": 0, "margin-top": -height + "px"},
    to: {"opacity": 1, "margin-top": "0"},
    duration: 0.3
  });
}

function hideMessage(element) {
  var height = element[0].offsetHeight;
  var styles = window.getComputedStyle(element[0]);

  // If we are already hidden, just return an empty animation
  if (parseInt(styles.opacity) === 0) {
    return $animateCss(element, {});
  }

  // Otherwise, animate
  return $animateCss(element, {
    event: 'leave',
    structural: true,
    from: {"opacity": 1, "margin-top": 0},
    to: {"opacity": 0, "margin-top": -height + "px"},
    duration: 0.3
  });
}

function getInputElement(element) {
  var inputContainer = element.controller('mdInputContainer');

  return inputContainer.element;
}

function getMessagesElement(element) {
  // If we ARE the messages element, just return ourself
  if (element.hasClass('md-input-messages-animation')) {
    return element;
  }

  // If we are a ng-message element, we need to traverse up the DOM tree
  if (element.hasClass('md-input-message-animation')) {
    return angular.element($mdUtil.getClosest(element, function(node) {
      return node.classList.contains('md-input-messages-animation');
    }));
  }

  // Otherwise, we can traverse down
  return angular.element(element[0].querySelector('.md-input-messages-animation'));
}

function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_, _$log_) {
  $$AnimateRunner = _$$AnimateRunner_;
  $animateCss = _$animateCss_;
  $mdUtil = _$mdUtil_;
  $log = _$log_;
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.list
 * @description
 * List module
 */
MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
mdListDirective.$inject = ["$mdTheming"];
mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
angular.module('material.components.list', [
  'material.core'
])
  .controller('MdListController', MdListController)
  .directive('mdList', mdListDirective)
  .directive('mdListItem', mdListItemDirective);

/**
 * @ngdoc directive
 * @name mdList
 * @module material.components.list
 *
 * @restrict E
 *
 * @description
 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
 *
 * @usage
 * <hljs lang="html">
 * <md-list>
 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
 *     <md-checkbox ng-model="item.done"></md-checkbox>
 *     <div class="md-list-item-text">
 *       <h3>{{item.title}}</h3>
 *       <p>{{item.description}}</p>
 *     </div>
 *   </md-list-item>
 * </md-list>
 * </hljs>
 */

function mdListDirective($mdTheming) {
  return {
    restrict: 'E',
    compile: function(tEl) {
      tEl[0].setAttribute('role', 'list');
      return $mdTheming;
    }
  };
}
/**
 * @ngdoc directive
 * @name mdListItem
 * @module material.components.list
 *
 * @restrict E
 *
 * @description
 * A `md-list-item` element can be used to represent some information in a row.<br/>
 *
 * @usage
 * ### Single Row Item
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *   </md-list-item>
 * </hljs>
 *
 * ### Multiple Lines
 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-2-line">
 *     <div class="md-list-item-text" layout="column">
 *       <p>First Line</p>
 *       <p>Second Line</p>
 *     </div>
 *   </md-list-item>
 * </hljs>
 *
 * It is also possible to have three lines inside of one list item.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-3-line">
 *     <div class="md-list-item-text" layout="column">
 *       <p>First Line</p>
 *       <p>Second Line</p>
 *       <p>Third Line</p>
 *     </div>
 *   </md-list-item>
 * </hljs>
 *
 * ### Secondary Items
 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *     <md-button class="md-secondary">
 *       Secondary Button
 *     </md-button>
 *   </md-list-item>
 * </hljs>
 *
 * It also possible to have multiple secondary items inside of one `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *     <md-button class="md-secondary">First Button</md-button>
 *     <md-button class="md-secondary">Second Button</md-button>
 *   </md-list-item>
 * </hljs>
 *
 * ### Proxy Item
 * Proxies are elements, which will execute their specific action on click<br/>
 * Currently supported proxy items are
 * - `md-checkbox` (Toggle)
 * - `md-switch` (Toggle)
 * - `md-menu` (Open)
 *
 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
 * automatically become clickable and executes the associated action of the proxy element on click.
 *
 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-no-proxy">
 *     <span>No Proxy List</span>
 *     <md-checkbox class="md-secondary"></md-checkbox>
 *   </md-list-item>
 * </hljs>
 *
 * Here are a few examples of proxy elements inside of a list item.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>First Line</span>
 *     <md-checkbox class="md-secondary"></md-checkbox>
 *   </md-list-item>
 * </hljs>
 *
 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on click.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>First Line</span>
 *     <md-switch class="md-secondary"></md-switch>
 *   </md-list-item>
 * </hljs>
 *
 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
 *
 * It is also possible to have a `md-menu` inside of a `md-list-item`.
 * <hljs lang="html">
 *   <md-list-item>
 *     <p>Click anywhere to fire the secondary action</p>
 *     <md-menu class="md-secondary">
 *       <md-button class="md-icon-button">
 *         <md-icon md-svg-icon="communication:message"></md-icon>
 *       </md-button>
 *       <md-menu-content width="4">
 *         <md-menu-item>
 *           <md-button>
 *             Redial
 *           </md-button>
 *         </md-menu-item>
 *         <md-menu-item>
 *           <md-button>
 *             Check voicemail
 *           </md-button>
 *         </md-menu-item>
 *         <md-menu-divider></md-menu-divider>
 *         <md-menu-item>
 *           <md-button>
 *             Notifications
 *           </md-button>
 *         </md-menu-item>
 *       </md-menu-content>
 *     </md-menu>
 *   </md-list-item>
 * </hljs>
 *
 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
 *
 * If the developer didn't specify any position mode on the menu, the `md-list-item` will automatically detect the
 * position mode and applies it to the `md-menu`.
 *
 * ### Avatars
 * Sometimes you may want to have some avatars inside of the `md-list-item `.<br/>
 * You are able to create a optimized icon for the list item, by applying the `.md-avatar` class on the `<img>` element.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <img src="my-avatar.png" class="md-avatar">
 *     <span>Alan Turing</span>
 * </hljs>
 *
 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
 * <hljs lang="html">
 *   <md-list-item>
 *     <md-icon class="md-avatar-icon" md-svg-icon="avatars:timothy"></md-icon>
 *     <span>Timothy Kopra</span>
 *   </md-list-item>
 * </hljs>
 *
 * In cases, you have a `md-list-item`, which doesn't have any avatar,
 * but you want to align it with the other avatar items, you have to use the `.md-offset` class.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-offset">
 *     <span>Jon Doe</span>
 *   </md-list-item>
 * </hljs>
 *
 * ### DOM modification
 * The `md-list-item` component automatically detects if the list item should be clickable.
 *
 * ---
 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`)
 *
 * We create an overlaying button, instead of wrapping all content inside of the button,
 * because otherwise some elements may not be clickable inside of the button.
 *
 * ---
 * When using a secondary item inside of your list item, the `md-list-item` component will automatically create
 * a secondary container at the end of the `md-list-item`, which contains all secondary items.
 *
 * The secondary item container is not static, because otherwise the overflow will not work properly on the
 * list item.
 *
 */
function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
  return {
    restrict: 'E',
    controller: 'MdListController',
    compile: function(tEl, tAttrs) {

      // Check for proxy controls (no ng-click on parent, and a control inside)
      var secondaryItems = tEl[0].querySelectorAll('.md-secondary');
      var hasProxiedElement;
      var proxyElement;
      var itemContainer = tEl;

      tEl[0].setAttribute('role', 'listitem');

      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
        wrapIn('button');
      } else if (!tEl.hasClass('md-no-proxy')) {

        for (var i = 0, type; type = proxiedTypes[i]; ++i) {
          if (proxyElement = tEl[0].querySelector(type)) {
            hasProxiedElement = true;
            break;
          }
        }

        if (hasProxiedElement) {
          wrapIn('div');
        } else {
          tEl.addClass('md-no-proxy');
        }

      }

      wrapSecondaryItems();
      setupToggleAria();

      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
        setupProxiedMenu();
      }

      function setupToggleAria() {
        var toggleTypes = ['md-switch', 'md-checkbox'];
        var toggle;

        for (var i = 0, toggleType; toggleType = toggleTypes[i]; ++i) {
          if (toggle = tEl.find(toggleType)[0]) {
            if (!toggle.hasAttribute('aria-label')) {
              var p = tEl.find('p')[0];
              if (!p) return;
              toggle.setAttribute('aria-label', 'Toggle ' + p.textContent);
            }
          }
        }
      }

      function setupProxiedMenu() {
        var menuEl = angular.element(proxyElement);

        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
                           proxyElement.parentNode.firstElementChild !== proxyElement;

        var xAxisPosition = 'left';

        if (isEndAligned) {
          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
          xAxisPosition = 'right';
        }

        // Set the position mode / origin of the proxied menu.
        if (!menuEl.attr('md-position-mode')) {
          menuEl.attr('md-position-mode', xAxisPosition + ' target');
        }

        // Apply menu open binding to menu button
        var menuOpenButton = menuEl.children().eq(0);
        if (!hasClickEvent(menuOpenButton[0])) {
          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
        }

        if (!menuOpenButton.attr('aria-label')) {
          menuOpenButton.attr('aria-label', 'Open List Menu');
        }
      }

      function wrapIn(type) {
        if (type == 'div') {
          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
          itemContainer.append(tEl.contents());
          tEl.addClass('md-proxy-focus');
        } else {
          // Element which holds the default list-item content.
          itemContainer = angular.element(
            '<div class="md-button md-no-style">'+
            '   <div class="md-list-item-inner"></div>'+
            '</div>'
          );

          // Button which shows ripple and executes primary action.
          var buttonWrap = angular.element(
            '<md-button class="md-no-style"></md-button>'
          );

          copyAttributes(tEl[0], buttonWrap[0]);

          // If there is no aria-label set on the button (previously copied over if present)
          // we determine the label from the content and copy it to the button.
          if (!buttonWrap.attr('aria-label')) {
            buttonWrap.attr('aria-label', $mdAria.getText(tEl));
          }

          // We allow developers to specify the `md-no-focus` class, to disable the focus style
          // on the button executor. Once more classes should be forwarded, we should probably make the
          // class forward more generic.
          if (tEl.hasClass('md-no-focus')) {
            buttonWrap.addClass('md-no-focus');
          }

          // Append the button wrap before our list-item content, because it will overlay in relative.
          itemContainer.prepend(buttonWrap);
          itemContainer.children().eq(1).append(tEl.contents());

          tEl.addClass('_md-button-wrap');
        }

        tEl[0].setAttribute('tabindex', '-1');
        tEl.append(itemContainer);
      }

      function wrapSecondaryItems() {
        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');

        angular.forEach(secondaryItems, function(secondaryItem) {
          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
        });

        itemContainer.append(secondaryItemsWrapper);
      }

      function wrapSecondaryItem(secondaryItem, container) {
        // If the current secondary item is not a button, but contains a ng-click attribute,
        // the secondary item will be automatically wrapped inside of a button.
        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {

          $mdAria.expect(secondaryItem, 'aria-label');
          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');

          // Copy the attributes from the secondary item to the generated button.
          // We also support some additional attributes from the secondary item,
          // because some developers may use a ngIf, ngHide, ngShow on their item.
          copyAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);

          secondaryItem.setAttribute('tabindex', '-1');
          buttonWrapper.append(secondaryItem);

          secondaryItem = buttonWrapper[0];
        }

        if (secondaryItem && (!hasClickEvent(secondaryItem) || (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
          // In this case we remove the secondary class, so we can identify it later, when we searching for the
          // proxy items.
          angular.element(secondaryItem).removeClass('md-secondary');
        }

        tEl.addClass('md-with-secondary');
        container.append(secondaryItem);
      }

      /**
       * Copies attributes from a source element to the destination element
       * By default the function will copy the most necessary attributes, supported
       * by the button executor for clickable list items.
       * @param source Element with the specified attributes
       * @param destination Element which will retrieve the attributes
       * @param extraAttrs Additional attributes, which will be copied over.
       */
      function copyAttributes(source, destination, extraAttrs) {
        var copiedAttrs = $mdUtil.prefixer([
          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
          'href', 'ng-href', 'rel', 'target', 'ng-attr-ui-sref', 'ui-sref-opts'
        ]);

        if (extraAttrs) {
          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
        }

        angular.forEach(copiedAttrs, function(attr) {
          if (source.hasAttribute(attr)) {
            destination.setAttribute(attr, source.getAttribute(attr));
            source.removeAttribute(attr);
          }
        });
      }

      function isProxiedElement(el) {
        return proxiedTypes.indexOf(el.nodeName.toLowerCase()) != -1;
      }

      function isButton(el) {
        var nodeName = el.nodeName.toUpperCase();

        return nodeName == "MD-BUTTON" || nodeName == "BUTTON";
      }

      function hasClickEvent (element) {
        var attr = element.attributes;
        for (var i = 0; i < attr.length; i++) {
          if (tAttrs.$normalize(attr[i].name) === 'ngClick') return true;
        }
        return false;
      }

      return postLink;

      function postLink($scope, $element, $attr, ctrl) {
        $element.addClass('_md');     // private md component indicator for styling

        var proxies       = [],
            firstElement  = $element[0].firstElementChild,
            isButtonWrap  = $element.hasClass('_md-button-wrap'),
            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
            hasClick      = clickChild && hasClickEvent(clickChild),
            noProxies     = $element.hasClass('md-no-proxy');

        computeProxies();
        computeClickable();

        if (proxies.length) {
          angular.forEach(proxies, function(proxy) {
            proxy = angular.element(proxy);

            $scope.mouseActive = false;
            proxy.on('mousedown', function() {
              $scope.mouseActive = true;
              $timeout(function(){
                $scope.mouseActive = false;
              }, 100);
            })
            .on('focus', function() {
              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
              proxy.on('blur', function proxyOnBlur() {
                $element.removeClass('md-focused');
                proxy.off('blur', proxyOnBlur);
              });
            });
          });
        }


        function computeProxies() {

          if (firstElement && firstElement.children && !hasClick && !noProxies) {

            angular.forEach(proxiedTypes, function(type) {

              // All elements which are not capable for being used a proxy have the .md-secondary class
              // applied. These items had been sorted out in the secondary wrap function.
              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
                proxies.push(child);
              });
            });

          }
        }

        function computeClickable() {
          if (proxies.length == 1 || hasClick) {
            $element.addClass('md-clickable');

            if (!hasClick) {
              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
            }
          }
        }

        function isEventFromControl(event) {
          var forbiddenControls = ['md-slider'];

          // If there is no path property in the event, then we can assume that the event was not bubbled.
          if (!event.path) {
            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
          }

          // We iterate the event path up and check for a possible component.
          // Our maximum index to search, is the list item root.
          var maxPath = event.path.indexOf($element.children()[0]);

          for (var i = 0; i < maxPath; i++) {
            if (forbiddenControls.indexOf(event.path[i].tagName.toLowerCase()) !== -1) {
              return true;
            }
          }
        }

        var clickChildKeypressListener = function(e) {
          if (e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && !e.target.isContentEditable) {
            var keyCode = e.which || e.keyCode;
            if (keyCode == $mdConstant.KEY_CODE.SPACE) {
              if (clickChild) {
                clickChild.click();
                e.preventDefault();
                e.stopPropagation();
              }
            }
          }
        };

        if (!hasClick && !proxies.length) {
          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
        }

        $element.off('click');
        $element.off('keypress');

        if (proxies.length == 1 && clickChild) {
          $element.children().eq(0).on('click', function(e) {
            // When the event is coming from an control and it should not trigger the proxied element
            // then we are skipping.
            if (isEventFromControl(e)) return;

            var parentButton = $mdUtil.getClosest(e.target, 'BUTTON');
            if (!parentButton && clickChild.contains(e.target)) {
              angular.forEach(proxies, function(proxy) {
                if (e.target !== proxy && !proxy.contains(e.target)) {
                  if (proxy.nodeName === 'MD-MENU') {
                    proxy = proxy.children[0];
                  }
                  angular.element(proxy).triggerHandler('click');
                }
              });
            }
          });
        }

        $scope.$on('$destroy', function () {
          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
        });
      }
    }
  };
}

/*
 * @private
 * @ngdoc controller
 * @name MdListController
 * @module material.components.list
 *
 */
function MdListController($scope, $element, $mdListInkRipple) {
  var ctrl = this;
  ctrl.attachRipple = attachRipple;

  function attachRipple (scope, element) {
    var options = {};
    $mdListInkRipple.attach(scope, element, options);
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.menu
 */

angular.module('material.components.menu', [
  'material.core',
  'material.components.backdrop'
]);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.menuBar
 */

angular.module('material.components.menuBar', [
  'material.core',
  'material.components.icon',
  'material.components.menu'
]);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.navBar
 */


MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
MdNavItem.$inject = ["$mdAria", "$$rAF"];
MdNavItemController.$inject = ["$element"];
MdNavBar.$inject = ["$mdAria", "$mdTheming"];
angular.module('material.components.navBar', ['material.core'])
    .controller('MdNavBarController', MdNavBarController)
    .directive('mdNavBar', MdNavBar)
    .controller('MdNavItemController', MdNavItemController)
    .directive('mdNavItem', MdNavItem);


/*****************************************************************************
 *                            PUBLIC DOCUMENTATION                           *
 *****************************************************************************/
/**
 * @ngdoc directive
 * @name mdNavBar
 * @module material.components.navBar
 *
 * @restrict E
 *
 * @description
 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
 * body and no bar pagination.
 *
 * Because it deals with page navigation, certain routing concepts are built-in.
 * Route changes via via ng-href, ui-sref, or ng-click events are supported.
 * Alternatively, the user could simply watch currentNavItem for changes.
 *
 * Accessibility functionality is implemented as a site navigator with a
 * listbox, according to
 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
 *
 * @param {string=} mdSelectedNavItem The name of the current tab; this must
 *     match the name attribute of `<md-nav-item>`
 * @param {boolean=} mdNoInkBar If set to true, the ink bar will be hidden.
 * @param {string=} navBarAriaLabel An aria-label for the nav-bar
 *
 * @usage
 * <hljs lang="html">
 *  <md-nav-bar md-selected-nav-item="currentNavItem">
 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
 *      Page One
 *    </md-nav-item>
 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
 *    <md-nav-item
 *      md-nav-sref="app.page4"
 *      sref-opts="{reload: true, notify: true}"
 *      name="page4">
 *      Page Four
 *    </md-nav-item>
 *  </md-nav-bar>
 *</hljs>
 * <hljs lang="js">
 * (function() {
 *   'use strict';
 *
 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
 *      $scope.currentLink = getCurrentLinkFromRoute(current);
 *    });
 * });
 * </hljs>
 */

/*****************************************************************************
 *                            mdNavItem
 *****************************************************************************/
/**
 * @ngdoc directive
 * @name mdNavItem
 * @module material.components.navBar
 *
 * @restrict E
 *
 * @description
 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>`
 * component. It renders an md-button as the actual link.
 *
 * Exactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required
 * to be specified.
 *
 * @param {Function=} mdNavClick Function which will be called when the
 *     link is clicked to change the page. Renders as an `ng-click`.
 * @param {string=} mdNavHref url to transition to when this link is clicked.
 *     Renders as an `ng-href`.
 * @param {string=} mdNavSref Ui-router state to transition to when this link is
 *     clicked. Renders as a `ui-sref`.
 * @param {!Object=} srefOpts Ui-router options that are passed to the
 *     `$state.go()` function. See the [Ui-router documentation for details]
 *     (https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html).
 * @param {string=} name The name of this link. Used by the nav bar to know
 *     which link is currently selected.
 * @param {string=} aria-label Adds alternative text for accessibility
 *
 * @usage
 * See `<md-nav-bar>` for usage.
 */


/*****************************************************************************
 *                                IMPLEMENTATION                             *
 *****************************************************************************/

function MdNavBar($mdAria, $mdTheming) {
  return {
    restrict: 'E',
    transclude: true,
    controller: MdNavBarController,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      'mdSelectedNavItem': '=?',
      'mdNoInkBar': '=?',
      'navBarAriaLabel': '@?',
    },
    template:
      '<div class="md-nav-bar">' +
        '<nav role="navigation">' +
          '<ul class="_md-nav-bar-list" ng-transclude role="listbox"' +
            'tabindex="0"' +
            'ng-focus="ctrl.onFocus()"' +
            'ng-keydown="ctrl.onKeydown($event)"' +
            'aria-label="{{ctrl.navBarAriaLabel}}">' +
          '</ul>' +
        '</nav>' +
        '<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>' +
      '</div>',
    link: function(scope, element, attrs, ctrl) {
      $mdTheming(element);
      if (!ctrl.navBarAriaLabel) {
        $mdAria.expectAsync(element, 'aria-label', angular.noop);
      }
    },
  };
}

/**
 * Controller for the nav-bar component.
 *
 * Accessibility functionality is implemented as a site navigator with a
 * listbox, according to
 * https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style
 * @param {!angular.JQLite} $element
 * @param {!angular.Scope} $scope
 * @param {!angular.Timeout} $timeout
 * @param {!Object} $mdConstant
 * @constructor
 * @final
 * @ngInject
 */
function MdNavBarController($element, $scope, $timeout, $mdConstant) {
  // Injected variables
  /** @private @const {!angular.Timeout} */
  this._$timeout = $timeout;

  /** @private @const {!angular.Scope} */
  this._$scope = $scope;

  /** @private @const {!Object} */
  this._$mdConstant = $mdConstant;

  // Data-bound variables.
  /** @type {string} */
  this.mdSelectedNavItem;

  /** @type {string} */
  this.navBarAriaLabel;

  // State variables.

  /** @type {?angular.JQLite} */
  this._navBarEl = $element[0];

  /** @type {?angular.JQLite} */
  this._inkbar;

  var self = this;
  // need to wait for transcluded content to be available
  var deregisterTabWatch = this._$scope.$watch(function() {
    return self._navBarEl.querySelectorAll('._md-nav-button').length;
  },
  function(newLength) {
    if (newLength > 0) {
      self._initTabs();
      deregisterTabWatch();
    }
  });
}



/**
 * Initializes the tab components once they exist.
 * @private
 */
MdNavBarController.prototype._initTabs = function() {
  this._inkbar = angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));

  var self = this;
  this._$timeout(function() {
    self._updateTabs(self.mdSelectedNavItem, undefined);
  });

  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
    // Wait a digest before update tabs for products doing
    // anything dynamic in the template.
    self._$timeout(function() {
      self._updateTabs(newValue, oldValue);
    });
  });
};

/**
 * Set the current tab to be selected.
 * @param {string|undefined} newValue New current tab name.
 * @param {string|undefined} oldValue Previous tab name.
 * @private
 */
MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
  var self = this;
  var tabs = this._getTabs();

  // this._getTabs can return null if nav-bar has not yet been initialized
  if(!tabs)
    return;

  var oldIndex = -1;
  var newIndex = -1;
  var newTab = this._getTabByName(newValue);
  var oldTab = this._getTabByName(oldValue);

  if (oldTab) {
    oldTab.setSelected(false);
    oldIndex = tabs.indexOf(oldTab);
  }

  if (newTab) {
    newTab.setSelected(true);
    newIndex = tabs.indexOf(newTab);
  }

  this._$timeout(function() {
    self._updateInkBarStyles(newTab, newIndex, oldIndex);
  });
};

/**
 * Repositions the ink bar to the selected tab.
 * @private
 */
MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex, oldIndex) {
  this._inkbar.toggleClass('_md-left', newIndex < oldIndex)
      .toggleClass('_md-right', newIndex > oldIndex);

  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});

  if (tab) {
    var tabEl = tab.getButtonEl();
    var left = tabEl.offsetLeft;

    this._inkbar.css({left: left + 'px', width: tabEl.offsetWidth + 'px'});
  }
};

/**
 * Returns an array of the current tabs.
 * @return {!Array<!NavItemController>}
 * @private
 */
MdNavBarController.prototype._getTabs = function() {
  var controllers = Array.prototype.slice.call(
    this._navBarEl.querySelectorAll('.md-nav-item'))
    .map(function(el) {
      return angular.element(el).controller('mdNavItem')
    });
  return controllers.indexOf(undefined) ? controllers : null;
};

/**
 * Returns the tab with the specified name.
 * @param {string} name The name of the tab, found in its name attribute.
 * @return {!NavItemController|undefined}
 * @private
 */
MdNavBarController.prototype._getTabByName = function(name) {
  return this._findTab(function(tab) {
    return tab.getName() == name;
  });
};

/**
 * Returns the selected tab.
 * @return {!NavItemController|undefined}
 * @private
 */
MdNavBarController.prototype._getSelectedTab = function() {
  return this._findTab(function(tab) {
    return tab.isSelected();
  });
};

/**
 * Returns the focused tab.
 * @return {!NavItemController|undefined}
 */
MdNavBarController.prototype.getFocusedTab = function() {
  return this._findTab(function(tab) {
    return tab.hasFocus();
  });
};

/**
 * Find a tab that matches the specified function.
 * @private
 */
MdNavBarController.prototype._findTab = function(fn) {
  var tabs = this._getTabs();
  for (var i = 0; i < tabs.length; i++) {
    if (fn(tabs[i])) {
      return tabs[i];
    }
  }

  return null;
};

/**
 * Direct focus to the selected tab when focus enters the nav bar.
 */
MdNavBarController.prototype.onFocus = function() {
  var tab = this._getSelectedTab();
  if (tab) {
    tab.setFocused(true);
  }
};

/**
 * Move focus from oldTab to newTab.
 * @param {!NavItemController} oldTab
 * @param {!NavItemController} newTab
 * @private
 */
MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
  oldTab.setFocused(false);
  newTab.setFocused(true);
};

/**
 * Responds to keypress events.
 * @param {!Event} e
 */
MdNavBarController.prototype.onKeydown = function(e) {
  var keyCodes = this._$mdConstant.KEY_CODE;
  var tabs = this._getTabs();
  var focusedTab = this.getFocusedTab();
  if (!focusedTab) return;

  var focusedTabIndex = tabs.indexOf(focusedTab);

  // use arrow keys to navigate between tabs
  switch (e.keyCode) {
    case keyCodes.UP_ARROW:
    case keyCodes.LEFT_ARROW:
      if (focusedTabIndex > 0) {
        this._moveFocus(focusedTab, tabs[focusedTabIndex - 1]);
      }
      break;
    case keyCodes.DOWN_ARROW:
    case keyCodes.RIGHT_ARROW:
      if (focusedTabIndex < tabs.length - 1) {
        this._moveFocus(focusedTab, tabs[focusedTabIndex + 1]);
      }
      break;
    case keyCodes.SPACE:
    case keyCodes.ENTER:
      // timeout to avoid a "digest already in progress" console error
      this._$timeout(function() {
        focusedTab.getButtonEl().click();
      });
      break;
  }
};

/**
 * @ngInject
 */
function MdNavItem($mdAria, $$rAF) {
  return {
    restrict: 'E',
    require: ['mdNavItem', '^mdNavBar'],
    controller: MdNavItemController,
    bindToController: true,
    controllerAs: 'ctrl',
    replace: true,
    transclude: true,
    template: function(tElement, tAttrs) {
      var hasNavClick = tAttrs.mdNavClick;
      var hasNavHref = tAttrs.mdNavHref;
      var hasNavSref = tAttrs.mdNavSref;
      var hasSrefOpts = tAttrs.srefOpts;
      var navigationAttribute;
      var navigationOptions;
      var buttonTemplate;

      // Cannot specify more than one nav attribute
      if ((hasNavClick ? 1:0) + (hasNavHref ? 1:0) + (hasNavSref ? 1:0) > 1) {
        throw Error(
          'Must not specify more than one of the md-nav-click, md-nav-href, ' +
          'or md-nav-sref attributes per nav-item directive.'
        );
      }

      if (hasNavClick) {
        navigationAttribute = 'ng-click="ctrl.mdNavClick()"';
      } else if (hasNavHref) {
        navigationAttribute = 'ng-href="{{ctrl.mdNavHref}}"';
      } else if (hasNavSref) {
        navigationAttribute = 'ui-sref="{{ctrl.mdNavSref}}"';
      }

      navigationOptions = hasSrefOpts ? 'ui-sref-opts="{{ctrl.srefOpts}}" ' : '';

      if (navigationAttribute) {
        buttonTemplate = '' +
          '<md-button class="_md-nav-button md-accent" ' +
            'ng-class="ctrl.getNgClassMap()" ' +
            'ng-blur="ctrl.setFocused(false)" ' +
            'tabindex="-1" ' +
            navigationOptions +
            navigationAttribute + '>' +
            '<span ng-transclude class="_md-nav-button-text"></span>' +
          '</md-button>';
      }

      return '' +
        '<li class="md-nav-item" ' +
          'role="option" ' +
          'aria-selected="{{ctrl.isSelected()}}">' +
          (buttonTemplate || '') +
        '</li>';
    },
    scope: {
      'mdNavClick': '&?',
      'mdNavHref': '@?',
      'mdNavSref': '@?',
      'srefOpts': '=?',
      'name': '@',
    },
    link: function(scope, element, attrs, controllers) {
      // When accessing the element's contents synchronously, they
      // may not be defined yet because of transclusion. There is a higher
      // chance that it will be accessible if we wait one frame.
      $$rAF(function() {
        var mdNavItem = controllers[0];
        var mdNavBar = controllers[1];
        var navButton = angular.element(element[0].querySelector('._md-nav-button'));

        if (!mdNavItem.name) {
          mdNavItem.name = angular.element(element[0]
              .querySelector('._md-nav-button-text')).text().trim();
        }

        navButton.on('click', function() {
          mdNavBar.mdSelectedNavItem = mdNavItem.name;
          scope.$apply();
        });

        $mdAria.expectWithText(element, 'aria-label');
      });
    }
  };
}

/**
 * Controller for the nav-item component.
 * @param {!angular.JQLite} $element
 * @constructor
 * @final
 * @ngInject
 */
function MdNavItemController($element) {

  /** @private @const {!angular.JQLite} */
  this._$element = $element;

  // Data-bound variables

  /** @const {?Function} */
  this.mdNavClick;

  /** @const {?string} */
  this.mdNavHref;

  /** @const {?string} */
  this.mdNavSref;
  /** @const {?Object} */
  this.srefOpts;
  /** @const {?string} */
  this.name;

  // State variables
  /** @private {boolean} */
  this._selected = false;

  /** @private {boolean} */
  this._focused = false;
}

/**
 * Returns a map of class names and values for use by ng-class.
 * @return {!Object<string,boolean>}
 */
MdNavItemController.prototype.getNgClassMap = function() {
  return {
    'md-active': this._selected,
    'md-primary': this._selected,
    'md-unselected': !this._selected,
    'md-focused': this._focused,
  };
};

/**
 * Get the name attribute of the tab.
 * @return {string}
 */
MdNavItemController.prototype.getName = function() {
  return this.name;
};

/**
 * Get the button element associated with the tab.
 * @return {!Element}
 */
MdNavItemController.prototype.getButtonEl = function() {
  return this._$element[0].querySelector('._md-nav-button');
};

/**
 * Set the selected state of the tab.
 * @param {boolean} isSelected
 */
MdNavItemController.prototype.setSelected = function(isSelected) {
  this._selected = isSelected;
};

/**
 * @return {boolean}
 */
MdNavItemController.prototype.isSelected = function() {
  return this._selected;
};

/**
 * Set the focused state of the tab.
 * @param {boolean} isFocused
 */
MdNavItemController.prototype.setFocused = function(isFocused) {
  this._focused = isFocused;

  if (isFocused) {
    this.getButtonEl().focus();
  }
};

/**
 * @return {boolean}
 */
MdNavItemController.prototype.hasFocus = function() {
  return this._focused;
};

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.panel
 */
MdPanelService.$inject = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
angular
  .module('material.components.panel', [
    'material.core',
    'material.components.backdrop'
  ])
  .provider('$mdPanel', MdPanelProvider);


/*****************************************************************************
 *                            PUBLIC DOCUMENTATION                           *
 *****************************************************************************/


/**
 * @ngdoc service
 * @name $mdPanelProvider
 * @module material.components.panel
 *
 * @description
 * `$mdPanelProvider` allows users to create configuration presets that will be
 * stored within a cached presets object. When the configuration is needed, the
 * user can request the preset by passing it as the first parameter in the
 * `$mdPanel.create` or `$mdPanel.open` methods.
 *
 * @usage
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   'use strict';
 *
 *   angular
 *       .module('demoApp', ['ngMaterial'])
 *       .config(DemoConfig)
 *       .controller('DemoCtrl', DemoCtrl)
 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
 *
 *   function DemoConfig($mdPanelProvider) {
 *     $mdPanelProvider.definePreset('demoPreset', {
 *       attachTo: angular.element(document.body),
 *       controller: DemoMenuCtrl,
 *       controllerAs: 'ctrl',
 *       template: '' +
 *           '<div class="menu-panel" md-whiteframe="4">' +
 *           '  <div class="menu-content">' +
 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
 *           '      <button class="md-button">' +
 *           '        <span>{{item}}</span>' +
 *           '      </button>' +
 *           '    </div>' +
 *           '    <md-divider></md-divider>' +
 *           '    <div class="menu-item">' +
 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
 *           '        <span>Close Menu</span>' +
 *           '      </button>' +
 *           '    </div>' +
 *           '  </div>' +
 *           '</div>',
 *       panelClass: 'menu-panel-container',
 *       focusOnOpen: false,
 *       zIndex: 100,
 *       propagateContainerEvents: true,
 *       groupName: 'menus'
 *     });
 *   }
 *
 *   function PanelProviderCtrl($mdPanel) {
 *     this.navigation = {
 *       name: 'navigation',
 *       items: [
 *         'Home',
 *         'About',
 *         'Contact'
 *       ]
 *     };
 *     this.favorites = {
 *       name: 'favorites',
 *       items: [
 *         'Add to Favorites'
 *       ]
 *     };
 *     this.more = {
 *       name: 'more',
 *       items: [
 *         'Account',
 *         'Sign Out'
 *       ]
 *     };
 *
 *     $mdPanel.newPanelGroup('menus', {
 *       maxOpen: 2
 *     });
 *
 *     this.showMenu = function($event, menu) {
 *       $mdPanel.open('demoPreset', {
 *         id: 'menu_' + menu.name,
 *         position: $mdPanel.newPanelPosition()
 *             .relativeTo($event.srcElement)
 *             .addPanelPosition(
 *               $mdPanel.xPosition.ALIGN_START,
 *               $mdPanel.yPosition.BELOW
 *             ),
 *         locals: {
 *           items: menu.items
 *         },
 *         openFrom: $event
 *       });
 *     };
 *   }
 *
 *   function PanelMenuCtrl(mdPanelRef) {
 *     // The controller is provided with an import named 'mdPanelRef'
 *     this.closeMenu = function() {
 *       mdPanelRef && mdPanelRef.close();
 *     };
 *   }
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdPanelProvider#definePreset
 * @description
 * Takes the passed in preset name and preset configuration object and adds it
 * to the `_presets` object of the provider. This `_presets` object is then
 * passed along to the `$mdPanel` service.
 *
 * @param {string} name Preset name.
 * @param {!Object} preset Specific configuration object that can contain any
 *     and all of the parameters avaialble within the `$mdPanel.create` method.
 *     However, parameters that pertain to id, position, animation, and user
 *     interaction are not allowed and will be removed from the preset
 *     configuration.
 */


/*****************************************************************************
 *                               MdPanel Service                             *
 *****************************************************************************/


/**
 * @ngdoc service
 * @name $mdPanel
 * @module material.components.panel
 *
 * @description
 * `$mdPanel` is a robust, low-level service for creating floating panels on
 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
 *
 * @usage
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   'use strict';
 *
 *   angular
 *       .module('demoApp', ['ngMaterial'])
 *       .controller('DemoDialogController', DialogController);
 *
 *   var panelRef;
 *
 *   function showPanel($event) {
 *     var panelPosition = $mdPanel.newPanelPosition()
 *         .absolute()
 *         .top('50%')
 *         .left('50%');
 *
 *     var panelAnimation = $mdPanel.newPanelAnimation()
 *         .targetEvent($event)
 *         .defaultAnimation('md-panel-animate-fly')
 *         .closeTo('.show-button');
 *
 *     var config = {
 *       attachTo: angular.element(document.body),
 *       controller: DialogController,
 *       controllerAs: 'ctrl',
 *       position: panelPosition,
 *       animation: panelAnimation,
 *       targetEvent: $event,
 *       templateUrl: 'dialog-template.html',
 *       clickOutsideToClose: true,
 *       escapeToClose: true,
 *       focusOnOpen: true
 *     };
 *
 *     $mdPanel.open(config)
 *         .then(function(result) {
 *           panelRef = result;
 *         });
 *   }
 *
 *   function DialogController(MdPanelRef) {
 *     function closeDialog() {
 *       if (MdPanelRef) MdPanelRef.close();
 *     }
 *   }
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdPanel#create
 * @description
 * Creates a panel with the specified options.
 *
 * @param config {!Object=} Specific configuration object that may contain the
 *     following properties:
 *
 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
 *     the created panel is added to a tracked panels object. Any subsequent
 *     requests made to create a panel with that ID are ignored. This is useful
 *     in having the panel service not open multiple panels from the same user
 *     interaction when there is no backdrop and events are propagated. Defaults
 *     to an arbitrary string that is not tracked.
 *   - `template` - `{string=}`: HTML template to show in the panel. This
 *     **must** be trusted HTML with respect to AngularJS’s
 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
 *     the panel.
 *   - `contentElement` - `{(string|!angular.JQLite|!Element)=}`: Pre-compiled
 *     element to be used as the panel's content.
 *   - `controller` - `{(function|string)=}`: The controller to associate with
 *     the panel. The controller can inject a reference to the returned
 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
 *     fields passed in through locals or resolve will be bound to the
 *     controller.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
 *     the scope.
 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
 *     instead of passing them in. Defaults to true, as this is a best
 *     practice.
 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
 *     will be used as names of values to inject into the controller. For
 *     example, `locals: {three: 3}` would inject `three` into the controller,
 *     with the value 3. 'mdPanelRef' is a reserved key, and will always 
 *     be set to the created MdPanelRef instance.
 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
 *     values. The panel will not open until all of the promises resolve.
 *   - `attachTo` - `{(string|!angular.JQLite|!Element)=}`: The element to
 *     attach the panel to. Defaults to appending to the root element of the
 *     application.
 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
 *     events should be allowed to propagate 'go through' the container, aka the
 *     wrapper, of the panel. Defaults to false.
 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
 *     This class should define any borders, box-shadow, etc. for the panel.
 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
 *     Defaults to 80.
 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
 *     specifies the alignment of the panel. For more information, see
 *     `MdPanelPosition`.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
 *     outside the panel to close it. Defaults to false.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
 *     close the panel. Defaults to false.
 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
 *     called after the close successfully finishes. The first parameter passed
 *     into this function is the current panelRef and the 2nd is an optional
 *     string explaining the close reason. The currently supported closeReasons
 *     can be found in the MdPanelRef.closeReasons enum. These are by default
 *     passed along by the panel.
 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
 *     panel. If `trapFocus` is true, the user will not be able to interact
 *     with the rest of the page until the panel is dismissed. Defaults to
 *     false.
 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
 *     open. Only disable if focusing some other way, as focus management is
 *     required for panels to be accessible. Defaults to true.
 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
 *     to false.
 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
 *     specifies the animation of the panel. For more information, see
 *     `MdPanelAnimation`.
 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
 *     behind the panel. Defaults to false.
 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
 *     page behind the panel. Defaults to false.
 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
 *     the panel is added to the DOM.
 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
 *     when the open() action is finished.
 *   - `onRemoving` - `{function=}`: Callback function used to announce the
 *     close/hide() action is starting.
 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
 *     the panel is removed from the DOM.
 *   - `origin` - `{(string|!angular.JQLite|!Element)=}`: The element to focus
 *     on when the panel closes. This is commonly the element which triggered
 *     the opening of the panel. If you do not use `origin`, you need to control
 *     the focus manually.
 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
 *     group names. The group name is used for creating a group of panels. The
 *     group is used for configuring the number of open panels and identifying
 *     specific behaviors for groups. For instance, all tooltips could be
 *     identified using the same groupName.
 *
 * @returns {!MdPanelRef} panelRef
 */

/**
 * @ngdoc method
 * @name $mdPanel#open
 * @description
 * Calls the create method above, then opens the panel. This is a shortcut for
 * creating and then calling open manually. If custom methods need to be
 * called when the panel is added to the DOM or opened, do not use this method.
 * Instead create the panel, chain promises on the domAdded and openComplete
 * methods, and call open from the returned panelRef.
 *
 * @param {!Object=} config Specific configuration object that may contain
 *     the properties defined in `$mdPanel.create`.
 * @returns {!angular.$q.Promise<!MdPanelRef>} panelRef A promise that resolves
 *     to an instance of the panel.
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelPosition
 * @description
 * Returns a new instance of the MdPanelPosition object. Use this to create
 * the position config object.
 *
 * @returns {!MdPanelPosition} panelPosition
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelAnimation
 * @description
 * Returns a new instance of the MdPanelAnimation object. Use this to create
 * the animation config object.
 *
 * @returns {!MdPanelAnimation} panelAnimation
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelGroup
 * @description
 * Creates a panel group and adds it to a tracked list of panel groups.
 *
 * @param {string} groupName Name of the group to create.
 * @param {!Object=} config Specific configuration object that may contain the
 *     following properties:
 *
 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed to
 *     be open within a defined panel group.
 *
 * @returns {!Object<string,
 *     {panels: !Array<!MdPanelRef>,
 *     openPanels: !Array<!MdPanelRef>,
 *     maxOpen: number}>} panelGroup
 */

/**
 * @ngdoc method
 * @name $mdPanel#setGroupMaxOpen
 * @description
 * Sets the maximum number of panels in a group that can be opened at a given
 * time.
 *
 * @param {string} groupName The name of the group to configure.
 * @param {number} maxOpen The maximum number of panels that can be
 *     opened. Infinity can be passed in to remove the maxOpen limit.
 */


/*****************************************************************************
 *                                 MdPanelRef                                *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelRef
 * @module material.components.panel
 * @description
 * A reference to a created panel. This reference contains a unique id for the
 * panel, along with the following properties:
 *
 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
 *     when a panel was interacted with.
 *   - `config` - `{!Object=}`: The entire config object that was used in
 *     create.
 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
 *     Visibility to the user does not factor into isAttached.
 *   - `panelContainer` - `{angular.JQLite}`: The wrapper element containing the
 *     panel. This property is added in order to have access to the `addClass`,
 *     `removeClass`, `toggleClass`, etc methods.
 *   - `panelEl` - `{angular.JQLite}`: The panel element. This property is added
 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
 *     etc methods.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#open
 * @description
 * Attaches and shows the panel.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     opened.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#close
 * @description
 * Hides and detaches the panel. Note that this will **not** destroy the panel.
 * If you don't intend on using the panel again, call the {@link #destroy
 * destroy} method afterwards.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     closed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#attach
 * @description
 * Create the panel elements and attach them to the DOM. The panel will be
 * hidden by default.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     attached.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#detach
 * @description
 * Removes the panel from the DOM. This will NOT hide the panel before removing
 * it.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     detached.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#show
 * @description
 * Shows the panel.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     shown and animations are completed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#hide
 * @description
 * Hides the panel.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     hidden and animations are completed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#destroy
 * @description
 * Destroys the panel. The panel cannot be opened again after this is called.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#addClass
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 * @description
 * Adds a class to the panel. DO NOT use this hide/show the panel.
 *
 * @param {string} newClass class to be added.
 * @param {boolean} toElement Whether or not to add the class to the panel
 *     element instead of the container.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeClass
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 * @description
 * Removes a class from the panel. DO NOT use this to hide/show the panel.
 *
 * @param {string} oldClass Class to be removed.
 * @param {boolean} fromElement Whether or not to remove the class from the
 *     panel element instead of the container.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#toggleClass
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 * @description
 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
 *
 * @param {string} toggleClass Class to be toggled.
 * @param {boolean} onElement Whether or not to remove the class from the panel
 *     element instead of the container.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#updatePosition
 * @description
 * Updates the position configuration of a panel. Use this to update the
 * position of a panel that is open, without having to close and re-open the
 * panel.
 *
 * @param {!MdPanelPosition} position
 */

/**
 * @ngdoc method
 * @name MdPanelRef#addToGroup
 * @description
 * Adds a panel to a group if the panel does not exist within the group already.
 * A panel can only exist within a single group.
 *
 * @param {string} groupName The name of the group to add the panel to.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeFromGroup
 * @description
 * Removes a panel from a group if the panel exists within that group. The group
 * must be created ahead of time.
 *
 * @param {string} groupName The name of the group.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#registerInterceptor
 * @description
 * Registers an interceptor with the panel. The callback should return a promise,
 * which will allow the action to continue when it gets resolved, or will
 * prevent an action if it is rejected. The interceptors are called sequentially
 * and it reverse order. `type` must be one of the following
 * values available on `$mdPanel.interceptorTypes`:
 * * `CLOSE` - Gets called before the panel begins closing.
 *
 * @param {string} type Type of interceptor.
 * @param {!angular.$q.Promise<any>} callback Callback to be registered.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeInterceptor
 * @description
 * Removes a registered interceptor.
 *
 * @param {string} type Type of interceptor to be removed.
 * @param {function(): !angular.$q.Promise<any>} callback Interceptor to be removed.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeAllInterceptors
 * @description
 * Removes all interceptors. If a type is supplied, only the
 * interceptors of that type will be cleared.
 *
 * @param {string=} type Type of interceptors to be removed.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#updateAnimation
 * @description
 * Updates the animation configuration for a panel. You can use this to change
 * the panel's animation without having to re-create it.
 *
 * @param {!MdPanelAnimation} animation
 */


/*****************************************************************************
 *                               MdPanelPosition                            *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelPosition
 * @module material.components.panel
 * @description
 *
 * Object for configuring the position of the panel.
 *
 * @usage
 *
 * #### Centering the panel
 *
 * <hljs lang="js">
 * new MdPanelPosition().absolute().center();
 * </hljs>
 *
 * #### Overlapping the panel with an element
 *
 * <hljs lang="js">
 * new MdPanelPosition()
 *     .relativeTo(someElement)
 *     .addPanelPosition(
 *       $mdPanel.xPosition.ALIGN_START,
 *       $mdPanel.yPosition.ALIGN_TOPS
 *     );
 * </hljs>
 *
 * #### Aligning the panel with the bottom of an element
 *
 * <hljs lang="js">
 * new MdPanelPosition()
 *     .relativeTo(someElement)
 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#absolute
 * @description
 * Positions the panel absolutely relative to the parent element. If the parent
 * is document.body, this is equivalent to positioning the panel absolutely
 * within the viewport.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#relativeTo
 * @description
 * Positions the panel relative to a specific element.
 *
 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
 *     or angular element to position the panel with respect to.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#top
 * @description
 * Sets the value of `top` for the panel. Clears any previously set vertical
 * position.
 *
 * @param {string=} top Value of `top`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#bottom
 * @description
 * Sets the value of `bottom` for the panel. Clears any previously set vertical
 * position.
 *
 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#start
 * @description
 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
 * `rtl`. Clears any previously set horizontal position.
 *
 * @param {string=} start Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#end
 * @description
 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
 * Clears any previously set horizontal position.
 *
 * @param {string=} end Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#left
 * @description
 * Sets the value of `left` for the panel. Clears any previously set
 * horizontal position.
 *
 * @param {string=} left Value of `left`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#right
 * @description
 * Sets the value of `right` for the panel. Clears any previously set
 * horizontal position.
 *
 * @param {string=} right Value of `right`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#centerHorizontally
 * @description
 * Centers the panel horizontally in the viewport. Clears any previously set
 * horizontal position.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#centerVertically
 * @description
 * Centers the panel vertically in the viewport. Clears any previously set
 * vertical position.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#center
 * @description
 * Centers the panel horizontally and vertically in the viewport. This is
 * equivalent to calling both `centerHorizontally` and `centerVertically`.
 * Clears any previously set horizontal and vertical positions.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#addPanelPosition
 * @description
 * Sets the x and y position for the panel relative to another element. Can be
 * called multiple times to specify an ordered list of panel positions. The
 * first position which allows the panel to be completely on-screen will be
 * chosen; the last position will be chose whether it is on-screen or not.
 *
 * xPosition must be one of the following values available on
 * $mdPanel.xPosition:
 *
 *
 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
 *
 * <pre>
 *    *************
 *    *           *
 *    *   PANEL   *
 *    *           *
 *    *************
 *   A B    C    D E
 *
 * A: OFFSET_START (for LTR displays)
 * B: ALIGN_START (for LTR displays)
 * C: CENTER
 * D: ALIGN_END (for LTR displays)
 * E: OFFSET_END (for LTR displays)
 * </pre>
 *
 * yPosition must be one of the following values available on
 * $mdPanel.yPosition:
 *
 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
 *
 * <pre>
 *   F
 *   G *************
 *     *           *
 *   H *   PANEL   *
 *     *           *
 *   I *************
 *   J
 *
 * F: BELOW
 * G: ALIGN_TOPS
 * H: CENTER
 * I: ALIGN_BOTTOMS
 * J: ABOVE
 * </pre>
 *
 * @param {string} xPosition
 * @param {string} yPosition
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#withOffsetX
 * @description
 * Sets the value of the offset in the x-direction.
 *
 * @param {string} offsetX
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#withOffsetY
 * @description
 * Sets the value of the offset in the y-direction.
 *
 * @param {string} offsetY
 * @returns {!MdPanelPosition}
 */


/*****************************************************************************
 *                               MdPanelAnimation                            *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelAnimation
 * @module material.components.panel
 * @description
 * Animation configuration object. To use, create an MdPanelAnimation with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * @usage
 *
 * <hljs lang="js">
 * var panelAnimation = new MdPanelAnimation()
 *     .openFrom(myButtonEl)
 *     .duration(1337)
 *     .closeTo('.my-button')
 *     .withAnimation($mdPanel.animation.SCALE);
 *
 * $mdPanel.create({
 *   animation: panelAnimation
 * });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#openFrom
 * @description
 * Specifies where to start the open animation. `openFrom` accepts a
 * click event object, query selector, DOM element, or a Rect object that
 * is used to determine the bounds. When passed a click event, the location
 * of the click will be used as the position to start the animation.
 *
 * @param {string|!Element|!Event|{top: number, left: number}}
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#closeTo
 * @description
 * Specifies where to animate the panel close. `closeTo` accepts a
 * query selector, DOM element, or a Rect object that is used to determine
 * the bounds.
 *
 * @param {string|!Element|{top: number, left: number}}
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#withAnimation
 * @description
 * Specifies the animation class.
 *
 * There are several default animations that can be used:
 * ($mdPanel.animation)
 *   SLIDE: The panel slides in and out from the specified
 *       elements. It will not fade in or out.
 *   SCALE: The panel scales in and out. Slide and fade are
 *       included in this animation.
 *   FADE: The panel fades in and out.
 *
 * Custom classes will by default fade in and out unless
 * "transition: opacity 1ms" is added to the to custom class.
 *
 * @param {string|{open: string, close: string}} cssClass
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#duration
 * @description
 * Specifies the duration of the animation in milliseconds. The `duration`
 * method accepts either a number or an object with separate open and close
 * durations.
 *
 * @param {number|{open: number, close: number}} duration
 * @returns {!MdPanelAnimation}
 */


/*****************************************************************************
 *                            PUBLIC DOCUMENTATION                           *
 *****************************************************************************/


var MD_PANEL_Z_INDEX = 80;
var MD_PANEL_HIDDEN = '_md-panel-hidden';
var FOCUS_TRAP_TEMPLATE = angular.element(
    '<div class="_md-panel-focus-trap" tabindex="0"></div>');

var _presets = {};


/**
 * A provider that is used for creating presets for the panel API.
 * @final @constructor @ngInject
 */
function MdPanelProvider() {
  return {
    'definePreset': definePreset,
    'getAllPresets': getAllPresets,
    'clearPresets': clearPresets,
    '$get': $getProvider()
  };
}


/**
 * Takes the passed in panel configuration object and adds it to the `_presets`
 * object at the specified name.
 * @param {string} name Name of the preset to set.
 * @param {!Object} preset Specific configuration object that can contain any
 *     and all of the parameters avaialble within the `$mdPanel.create` method.
 *     However, parameters that pertain to id, position, animation, and user
 *     interaction are not allowed and will be removed from the preset
 *     configuration.
 */
function definePreset(name, preset) {
  if (!name || !preset) {
    throw new Error('mdPanelProvider: The panel preset definition is ' +
        'malformed. The name and preset object are required.');
  } else if (_presets.hasOwnProperty(name)) {
    throw new Error('mdPanelProvider: The panel preset you have requested ' +
        'has already been defined.');
  }

  // Delete any property on the preset that is not allowed.
  delete preset.id;
  delete preset.position;
  delete preset.animation;

  _presets[name] = preset;
}


/**
 * Gets a clone of the `_presets`.
 * @return {!Object}
 */
function getAllPresets() {
  return angular.copy(_presets);
}


/**
 * Clears all of the stored presets.
 */
function clearPresets() {
  _presets = {};
}


/**
 * Represents the `$get` method of the AngularJS provider. From here, a new
 * reference to the MdPanelService is returned where the needed arguments are
 * passed in including the MdPanelProvider `_presets`.
 * @param {!Object} _presets
 * @param {!angular.JQLite} $rootElement
 * @param {!angular.Scope} $rootScope
 * @param {!angular.$injector} $injector
 * @param {!angular.$window} $window
 */
function $getProvider() {
  return [
    '$rootElement', '$rootScope', '$injector', '$window',
    function($rootElement, $rootScope, $injector, $window) {
      return new MdPanelService(_presets, $rootElement, $rootScope,
          $injector, $window);
    }
  ];
}


/*****************************************************************************
 *                               MdPanel Service                             *
 *****************************************************************************/


/**
 * A service that is used for controlling/displaying panels on the screen.
 * @param {!Object} presets
 * @param {!angular.JQLite} $rootElement
 * @param {!angular.Scope} $rootScope
 * @param {!angular.$injector} $injector
 * @param {!angular.$window} $window
 * @final @constructor @ngInject
 */
function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
  /**
   * Default config options for the panel.
   * Anything angular related needs to be done later. Therefore
   *     scope: $rootScope.$new(true),
   *     attachTo: $rootElement,
   * are added later.
   * @private {!Object}
   */
  this._defaultConfigOptions = {
    bindToController: true,
    clickOutsideToClose: false,
    disableParentScroll: false,
    escapeToClose: false,
    focusOnOpen: true,
    fullscreen: false,
    hasBackdrop: false,
    propagateContainerEvents: false,
    transformTemplate: angular.bind(this, this._wrapTemplate),
    trapFocus: false,
    zIndex: MD_PANEL_Z_INDEX
  };

  /** @private {!Object} */
  this._config = {};

  /** @private {!Object} */
  this._presets = presets;

  /** @private @const */
  this._$rootElement = $rootElement;

  /** @private @const */
  this._$rootScope = $rootScope;

  /** @private @const */
  this._$injector = $injector;

  /** @private @const */
  this._$window = $window;

  /** @private @const */
  this._$mdUtil = this._$injector.get('$mdUtil');

  /** @private {!Object<string, !MdPanelRef>} */
  this._trackedPanels = {};

  /**
   * @private {!Object<string,
   *     {panels: !Array<!MdPanelRef>,
   *     openPanels: !Array<!MdPanelRef>,
   *     maxOpen: number}>}
   */
  this._groups = Object.create(null);

  /**
   * Default animations that can be used within the panel.
   * @type {enum}
   */
  this.animation = MdPanelAnimation.animation;

  /**
   * Possible values of xPosition for positioning the panel relative to
   * another element.
   * @type {enum}
   */
  this.xPosition = MdPanelPosition.xPosition;

  /**
   * Possible values of yPosition for positioning the panel relative to
   * another element.
   * @type {enum}
   */
  this.yPosition = MdPanelPosition.yPosition;

  /**
   * Possible values for the interceptors that can be registered on a panel.
   * @type {enum}
   */
  this.interceptorTypes = MdPanelRef.interceptorTypes;

  /**
   * Possible values for closing of a panel.
   * @type {enum}
   */
  this.closeReasons = MdPanelRef.closeReasons;

  /**
   * Possible values of absolute position.
   * @type {enum}
   */
  this.absPosition = MdPanelPosition.absPosition;
}


/**
 * Creates a panel with the specified options.
 * @param {string=} preset Name of a preset configuration that can be used to
 *     extend the panel configuration.
 * @param {!Object=} config Configuration object for the panel.
 * @returns {!MdPanelRef}
 */
MdPanelService.prototype.create = function(preset, config) {
  if (typeof preset === 'string') {
    preset = this._getPresetByName(preset);
  } else if (typeof preset === 'object' &&
      (angular.isUndefined(config) || !config)) {
    config = preset;
    preset = {};
  }

  preset = preset || {};
  config = config || {};

  // If the passed-in config contains an ID and the ID is within _trackedPanels,
  // return the tracked panel after updating its config with the passed-in
  // config.
  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
    var trackedPanel = this._trackedPanels[config.id];
    angular.extend(trackedPanel.config, config);
    return trackedPanel;
  }

  // Combine the passed-in config, the _defaultConfigOptions, and the preset
  // configuration into the `_config`.
  this._config = angular.extend({
    // If no ID is set within the passed-in config, then create an arbitrary ID.
    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
    scope: this._$rootScope.$new(true),
    attachTo: this._$rootElement
  }, this._defaultConfigOptions, config, preset);

  // Create the panelRef and add it to the `_trackedPanels` object.
  var panelRef = new MdPanelRef(this._config, this._$injector);
  this._trackedPanels[config.id] = panelRef;

  // Add the panel to each of its requested groups.
  if (this._config.groupName) {
    if (angular.isString(this._config.groupName)) {
      this._config.groupName = [this._config.groupName];
    }
    angular.forEach(this._config.groupName, function(group) {
      panelRef.addToGroup(group);
    });
  }

  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));

  return panelRef;
};


/**
 * Creates and opens a panel with the specified options.
 * @param {string=} preset Name of a preset configuration that can be used to
 *     extend the panel configuration.
 * @param {!Object=} config Configuration object for the panel.
 * @returns {!angular.$q.Promise<!MdPanelRef>} The panel created from create.
 */
MdPanelService.prototype.open = function(preset, config) {
  var panelRef = this.create(preset, config);
  return panelRef.open().then(function() {
    return panelRef;
  });
};


/**
 * Gets a specific preset configuration object saved within `_presets`.
 * @param {string} preset Name of the preset to search for.
 * @returns {!Object} The preset configuration object.
 */
MdPanelService.prototype._getPresetByName = function(preset) {
  if (!this._presets[preset]) {
    throw new Error('mdPanel: The panel preset configuration that you ' +
        'requested does not exist. Use the $mdPanelProvider to create a ' +
        'preset before requesting one.');
  }
  return this._presets[preset];
};


/**
 * Returns a new instance of the MdPanelPosition. Use this to create the
 * positioning object.
 * @returns {!MdPanelPosition}
 */
MdPanelService.prototype.newPanelPosition = function() {
  return new MdPanelPosition(this._$injector);
};


/**
 * Returns a new instance of the MdPanelAnimation. Use this to create the
 * animation object.
 * @returns {!MdPanelAnimation}
 */
MdPanelService.prototype.newPanelAnimation = function() {
  return new MdPanelAnimation(this._$injector);
};


/**
 * Creates a panel group and adds it to a tracked list of panel groups.
 * @param groupName {string} Name of the group to create.
 * @param config {!Object=} Specific configuration object that may contain the
 *     following properties:
 *
 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed
 *     open within a defined panel group.
 *
 * @returns {!Object<string,
 *     {panels: !Array<!MdPanelRef>,
 *     openPanels: !Array<!MdPanelRef>,
 *     maxOpen: number}>} panelGroup
 */
MdPanelService.prototype.newPanelGroup = function(groupName, config) {
  if (!this._groups[groupName]) {
    config = config || {};
    var group = {
      panels: [],
      openPanels: [],
      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
    };
    this._groups[groupName] = group;
  }
  return this._groups[groupName];
};


/**
 * Sets the maximum number of panels in a group that can be opened at a given
 * time.
 * @param {string} groupName The name of the group to configure.
 * @param {number} maxOpen The maximum number of panels that can be
 *     opened. Infinity can be passed in to remove the maxOpen limit.
 */
MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
  if (this._groups[groupName]) {
    this._groups[groupName].maxOpen = maxOpen;
  } else {
    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
  }
};


/**
 * Determines if the current number of open panels within a group exceeds the
 * limit of allowed open panels.
 * @param {string} groupName The name of the group to check.
 * @returns {boolean} true if open count does exceed maxOpen and false if not.
 * @private
 */
MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
  if (this._groups[groupName]) {
    var group = this._groups[groupName];
    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
  }
  return false;
};


/**
 * Closes the first open panel within a specific group.
 * @param {string} groupName The name of the group.
 * @private
 */
MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
  this._groups[groupName].openPanels[0].close();
};


/**
 * Wraps the users template in two elements, md-panel-outer-wrapper, which
 * covers the entire attachTo element, and md-panel, which contains only the
 * template. This allows the panel control over positioning, animations,
 * and similar properties.
 * @param {string} origTemplate The original template.
 * @returns {string} The wrapped template.
 * @private
 */
MdPanelService.prototype._wrapTemplate = function(origTemplate) {
  var template = origTemplate || '';

  // The panel should be initially rendered offscreen so we can calculate
  // height and width for positioning.
  return '' +
      '<div class="md-panel-outer-wrapper">' +
      '  <div class="md-panel _md-panel-offscreen">' + template + '</div>' +
      '</div>';
};


/**
 * Wraps a content element in a md-panel-outer wrapper and
 * positions it off-screen. Allows for proper control over positoning
 * and animations.
 * @param {!angular.JQLite} contentElement Element to be wrapped.
 * @return {!angular.JQLite} Wrapper element.
 * @private
 */
MdPanelService.prototype._wrapContentElement = function(contentElement) {
  var wrapper = angular.element('<div class="md-panel-outer-wrapper">');

  contentElement.addClass('md-panel _md-panel-offscreen');
  wrapper.append(contentElement);

  return wrapper;
};


/*****************************************************************************
 *                                 MdPanelRef                                *
 *****************************************************************************/


/**
 * A reference to a created panel. This reference contains a unique id for the
 * panel, along with properties/functions used to control the panel.
 * @param {!Object} config
 * @param {!angular.$injector} $injector
 * @final @constructor
 */
function MdPanelRef(config, $injector) {
  // Injected variables.
  /** @private @const {!angular.$q} */
  this._$q = $injector.get('$q');

  /** @private @const {!angular.$mdCompiler} */
  this._$mdCompiler = $injector.get('$mdCompiler');

  /** @private @const {!angular.$mdConstant} */
  this._$mdConstant = $injector.get('$mdConstant');

  /** @private @const {!angular.$mdUtil} */
  this._$mdUtil = $injector.get('$mdUtil');

  /** @private @const {!angular.$mdTheming} */
  this._$mdTheming = $injector.get('$mdTheming');

  /** @private @const {!angular.Scope} */
  this._$rootScope = $injector.get('$rootScope');

  /** @private @const {!angular.$animate} */
  this._$animate = $injector.get('$animate');

  /** @private @const {!MdPanelRef} */
  this._$mdPanel = $injector.get('$mdPanel');

  /** @private @const {!angular.$log} */
  this._$log = $injector.get('$log');

  /** @private @const {!angular.$window} */
  this._$window = $injector.get('$window');

  /** @private @const {!Function} */
  this._$$rAF = $injector.get('$$rAF');

  // Public variables.
  /**
   * Unique id for the panelRef.
   * @type {string}
   */
  this.id = config.id;

  /** @type {!Object} */
  this.config = config;

  /** @type {!angular.JQLite|undefined} */
  this.panelContainer;

  /** @type {!angular.JQLite|undefined} */
  this.panelEl;

  /**
   * Whether the panel is attached. This is synchronous. When attach is called,
   * isAttached is set to true. When detach is called, isAttached is set to
   * false.
   * @type {boolean}
   */
  this.isAttached = false;

  // Private variables.
  /** @private {Array<function()>} */
  this._removeListeners = [];

  /** @private {!angular.JQLite|undefined} */
  this._topFocusTrap;

  /** @private {!angular.JQLite|undefined} */
  this._bottomFocusTrap;

  /** @private {!$mdPanel|undefined} */
  this._backdropRef;

  /** @private {Function?} */
  this._restoreScroll = null;

  /**
   * Keeps track of all the panel interceptors.
   * @private {!Object}
   */
  this._interceptors = Object.create(null);

  /**
   * Cleanup function, provided by `$mdCompiler` and assigned after the element
   * has been compiled. When `contentElement` is used, the function is used to
   * restore the element to it's proper place in the DOM.
   * @private {!Function}
   */
  this._compilerCleanup = null;

  /**
   * Cache for saving and restoring element inline styles, CSS classes etc.
   * @type {{styles: string, classes: string}}
   */
  this._restoreCache = {
    styles: '',
    classes: ''
  };
}


MdPanelRef.interceptorTypes = {
  CLOSE: 'onClose'
};


/**
 * Opens an already created and configured panel. If the panel is already
 * visible, does nothing.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is opened and animations finish.
 */
MdPanelRef.prototype.open = function() {
  var self = this;
  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var show = self._simpleBind(self.show, self);
    var checkGroupMaxOpen = function() {
      if (self.config.groupName) {
        angular.forEach(self.config.groupName, function(group) {
          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
            self._$mdPanel._closeFirstOpenedPanel(group);
          }
        });
      }
    };

    self.attach()
        .then(show)
        .then(checkGroupMaxOpen)
        .then(done)
        .catch(reject);
  });
};


/**
 * Closes the panel.
 * @param {string} closeReason The event type that triggered the close.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is closed and animations finish.
 */
MdPanelRef.prototype.close = function(closeReason) {
  var self = this;

  return this._$q(function(resolve, reject) {
    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
      var done = self._done(resolve, self);
      var detach = self._simpleBind(self.detach, self);
      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);

      self.hide()
          .then(detach)
          .then(done)
          .then(onCloseSuccess)
          .catch(reject);
    }, reject);
  });
};


/**
 * Attaches the panel. The panel will be hidden afterwards.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is attached.
 */
MdPanelRef.prototype.attach = function() {
  if (this.isAttached && this.panelEl) {
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onDomAdded = self.config['onDomAdded'] || angular.noop;
    var addListeners = function(response) {
      self.isAttached = true;
      self._addEventListeners();
      return response;
    };

    self._$q.all([
        self._createBackdrop(),
        self._createPanel()
            .then(addListeners)
            .catch(reject)
    ]).then(onDomAdded)
      .then(done)
      .catch(reject);
  });
};


/**
 * Only detaches the panel. Will NOT hide the panel first.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is detached.
 */
MdPanelRef.prototype.detach = function() {
  if (!this.isAttached) {
    return this._$q.when(this);
  }

  var self = this;
  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;

  var detachFn = function() {
    self._removeEventListeners();

    // Remove the focus traps that we added earlier for keeping focus within
    // the panel.
    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
    }

    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
    }

    if (self._restoreCache.classes) {
      self.panelEl[0].className = self._restoreCache.classes;
    }

    // Either restore the saved styles or clear the ones set by mdPanel.
    self.panelEl[0].style.cssText = self._restoreCache.styles || '';

    self._compilerCleanup();
    self.panelContainer.remove();
    self.isAttached = false;
    return self._$q.when(self);
  };

  if (this._restoreScroll) {
    this._restoreScroll();
    this._restoreScroll = null;
  }

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);

    self._$q.all([
      detachFn(),
      self._backdropRef ? self._backdropRef.detach() : true
    ]).then(onDomRemoved)
      .then(done)
      .catch(reject);
  });
};


/**
 * Destroys the panel. The Panel cannot be opened again after this.
 */
MdPanelRef.prototype.destroy = function() {
  var self = this;
  if (this.config.groupName) {
    angular.forEach(this.config.groupName, function(group) {
      self.removeFromGroup(group);
    });
  }
  this.config.scope.$destroy();
  this.config.locals = null;
  this._interceptors = null;
};


/**
 * Shows the panel.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel has shown and animations finish.
 */
MdPanelRef.prototype.show = function() {
  if (!this.panelContainer) {
    return this._$q(function(resolve, reject) {
      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
    });
  }

  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
    return this._$q.when(this);
  }

  var self = this;
  var animatePromise = function() {
    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
    return self._animateOpen();
  };

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
    var addToGroupOpen = function() {
      if (self.config.groupName) {
        angular.forEach(self.config.groupName, function(group) {
          self._$mdPanel._groups[group].openPanels.push(self);
        });
      }
    };

    self._$q.all([
      self._backdropRef ? self._backdropRef.show() : self,
      animatePromise().then(function() { self._focusOnOpen(); }, reject)
    ]).then(onOpenComplete)
      .then(addToGroupOpen)
      .then(done)
      .catch(reject);
  });
};


/**
 * Hides the panel.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel has hidden and animations finish.
 */
MdPanelRef.prototype.hide = function() {
  if (!this.panelContainer) {
    return this._$q(function(resolve, reject) {
      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
    });
  }

  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
    return this._$q.when(this);
  }

  var self = this;

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onRemoving = self.config['onRemoving'] || angular.noop;
    var hidePanel = function() {
      self.panelContainer.addClass(MD_PANEL_HIDDEN);
    };
    var removeFromGroupOpen = function() {
      if (self.config.groupName) {
        var group, index;
        angular.forEach(self.config.groupName, function(group) {
          group = self._$mdPanel._groups[group];
          index = group.openPanels.indexOf(self);
          if (index > -1) {
            group.openPanels.splice(index, 1);
          }
        });
      }
    };
    var focusOnOrigin = function() {
      var origin = self.config['origin'];
      if (origin) {
        getElement(origin).focus();
      }
    };

    self._$q.all([
      self._backdropRef ? self._backdropRef.hide() : self,
      self._animateClose()
          .then(onRemoving)
          .then(hidePanel)
          .then(removeFromGroupOpen)
          .then(focusOnOrigin)
          .catch(reject)
    ]).then(done, reject);
  });
};


/**
 * Add a class to the panel. DO NOT use this to hide/show the panel.
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 *
 * @param {string} newClass Class to be added.
 * @param {boolean} toElement Whether or not to add the class to the panel
 *     element instead of the container.
 */
MdPanelRef.prototype.addClass = function(newClass, toElement) {
  this._$log.warn(
      'mdPanel: The addClass method is in the process of being deprecated. ' +
      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
      'To achieve the same results, use the panelContainer or panelEl ' +
      'JQLite elements that are referenced in MdPanelRef.');

  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  if (!toElement && !this.panelContainer.hasClass(newClass)) {
    this.panelContainer.addClass(newClass);
  } else if (toElement && !this.panelEl.hasClass(newClass)) {
    this.panelEl.addClass(newClass);
  }
};


/**
 * Remove a class from the panel. DO NOT use this to hide/show the panel.
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 *
 * @param {string} oldClass Class to be removed.
 * @param {boolean} fromElement Whether or not to remove the class from the
 *     panel element instead of the container.
 */
MdPanelRef.prototype.removeClass = function(oldClass, fromElement) {
  this._$log.warn(
      'mdPanel: The removeClass method is in the process of being deprecated. ' +
      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
      'To achieve the same results, use the panelContainer or panelEl ' +
      'JQLite elements that are referenced in MdPanelRef.');

  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  if (!fromElement && this.panelContainer.hasClass(oldClass)) {
    this.panelContainer.removeClass(oldClass);
  } else if (fromElement && this.panelEl.hasClass(oldClass)) {
    this.panelEl.removeClass(oldClass);
  }
};


/**
 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 *
 * @param {string} toggleClass The class to toggle.
 * @param {boolean} onElement Whether or not to toggle the class on the panel
 *     element instead of the container.
 */
MdPanelRef.prototype.toggleClass = function(toggleClass, onElement) {
  this._$log.warn(
      'mdPanel: The toggleClass method is in the process of being deprecated. ' +
      'Full deprecation is scheduled for the AngularJS Material 1.2 release. ' +
      'To achieve the same results, use the panelContainer or panelEl ' +
      'JQLite elements that are referenced in MdPanelRef.');

  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  if (!onElement) {
    this.panelContainer.toggleClass(toggleClass);
  } else {
    this.panelEl.toggleClass(toggleClass);
  }
};


/**
 * Compiles the panel, according to the passed in config and appends it to
 * the DOM. Helps normalize differences in the compilation process between
 * using a string template and a content element.
 * @returns {!angular.$q.Promise<!MdPanelRef>} Promise that is resolved when
 *     the element has been compiled and added to the DOM.
 * @private
 */
MdPanelRef.prototype._compile = function() {
  var self = this;

  // Compile the element via $mdCompiler. Note that when using a
  // contentElement, the element isn't actually being compiled, rather the
  // compiler saves it's place in the DOM and provides a way of restoring it.
  return self._$mdCompiler.compile(self.config).then(function(compileData) {
    var config = self.config;

    if (config.contentElement) {
      var panelEl = compileData.element;

      // Since mdPanel modifies the inline styles and CSS classes, we need
      // to save them in order to be able to restore on close.
      self._restoreCache.styles = panelEl[0].style.cssText;
      self._restoreCache.classes = panelEl[0].className;

      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
      self.panelEl = panelEl;
    } else {
      self.panelContainer = compileData.link(config['scope']);
      self.panelEl = angular.element(
        self.panelContainer[0].querySelector('.md-panel')
      );
    }

    // Save a reference to the cleanup function from the compiler.
    self._compilerCleanup = compileData.cleanup;

    // Attach the panel to the proper place in the DOM.
    getElement(self.config['attachTo']).append(self.panelContainer);

    return self;
  });
};


/**
 * Creates a panel and adds it to the dom.
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     created.
 * @private
 */
MdPanelRef.prototype._createPanel = function() {
  var self = this;

  return this._$q(function(resolve, reject) {
    if (!self.config.locals) {
      self.config.locals = {};
    }

    self.config.locals.mdPanelRef = self;

    self._compile().then(function() {
      if (self.config['disableParentScroll']) {
        self._restoreScroll = self._$mdUtil.disableScrollAround(
          null,
          self.panelContainer,
          { disableScrollMask: true }
        );
      }

      // Add a custom CSS class to the panel element.
      if (self.config['panelClass']) {
        self.panelEl.addClass(self.config['panelClass']);
      }

      // Handle click and touch events for the panel container.
      if (self.config['propagateContainerEvents']) {
        self.panelContainer.css('pointer-events', 'none');
        self.panelEl.css('pointer-events', 'all');
      }

      // Panel may be outside the $rootElement, tell ngAnimate to animate
      // regardless.
      if (self._$animate.pin) {
        self._$animate.pin(
          self.panelContainer,
          getElement(self.config['attachTo'])
        );
      }

      self._configureTrapFocus();
      self._addStyles().then(function() {
        resolve(self);
      }, reject);
    }, reject);

  });
};


/**
 * Adds the styles for the panel, such as positioning and z-index. Also,
 * themes the panel element and panel container using `$mdTheming`.
 * @returns {!angular.$q.Promise<!MdPanelRef>}
 * @private
 */
MdPanelRef.prototype._addStyles = function() {
  var self = this;
  return this._$q(function(resolve) {
    self.panelContainer.css('z-index', self.config['zIndex']);
    self.panelEl.css('z-index', self.config['zIndex'] + 1);

    var hideAndResolve = function() {
      // Theme the element and container.
      self._setTheming();

      // Remove offscreen class and add hidden class.
      self.panelEl.removeClass('_md-panel-offscreen');
      self.panelContainer.addClass(MD_PANEL_HIDDEN);

      resolve(self);
    };

    if (self.config['fullscreen']) {
      self.panelEl.addClass('_md-panel-fullscreen');
      hideAndResolve();
      return; // Don't setup positioning.
    }

    var positionConfig = self.config['position'];
    if (!positionConfig) {
      hideAndResolve();
      return; // Don't setup positioning.
    }

    // Wait for angular to finish processing the template
    self._$rootScope['$$postDigest'](function() {
      // Position it correctly. This is necessary so that the panel will have a
      // defined height and width.
      self._updatePosition(true);

      // Theme the element and container.
      self._setTheming();

      resolve(self);
    });
  });
};


/**
 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
 * @private
 */
MdPanelRef.prototype._setTheming = function() {
  this._$mdTheming(this.panelEl);
  this._$mdTheming(this.panelContainer);
};


/**
 * Updates the position configuration of a panel
 * @param {!MdPanelPosition} position
 */
MdPanelRef.prototype.updatePosition = function(position) {
  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  this.config['position'] = position;
  this._updatePosition();
};


/**
 * Calculates and updates the position of the panel.
 * @param {boolean=} init
 * @private
 */
MdPanelRef.prototype._updatePosition = function(init) {
  var positionConfig = this.config['position'];

  if (positionConfig) {
    positionConfig._setPanelPosition(this.panelEl);

    // Hide the panel now that position is known.
    if (init) {
      this.panelEl.removeClass('_md-panel-offscreen');
      this.panelContainer.addClass(MD_PANEL_HIDDEN);
    }

    this.panelEl.css(
      MdPanelPosition.absPosition.TOP,
      positionConfig.getTop()
    );
    this.panelEl.css(
      MdPanelPosition.absPosition.BOTTOM,
      positionConfig.getBottom()
    );
    this.panelEl.css(
      MdPanelPosition.absPosition.LEFT,
      positionConfig.getLeft()
    );
    this.panelEl.css(
      MdPanelPosition.absPosition.RIGHT,
      positionConfig.getRight()
    );
  }
};


/**
 * Focuses on the panel or the first focus target.
 * @private
 */
MdPanelRef.prototype._focusOnOpen = function() {
  if (this.config['focusOnOpen']) {
    // Wait for the template to finish rendering to guarantee md-autofocus has
    // finished adding the class md-autofocus, otherwise the focusable element
    // isn't available to focus.
    var self = this;
    this._$rootScope['$$postDigest'](function() {
      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
          self.panelEl;
      target.focus();
    });
  }
};


/**
 * Shows the backdrop.
 * @returns {!angular.$q.Promise} A promise that is resolved when the backdrop
 *     is created and attached.
 * @private
 */
MdPanelRef.prototype._createBackdrop = function() {
  if (this.config.hasBackdrop) {
    if (!this._backdropRef) {
      var backdropAnimation = this._$mdPanel.newPanelAnimation()
          .openFrom(this.config.attachTo)
          .withAnimation({
            open: '_md-opaque-enter',
            close: '_md-opaque-leave'
          });

      if (this.config.animation) {
        backdropAnimation.duration(this.config.animation._rawDuration);
      }

      var backdropConfig = {
        animation: backdropAnimation,
        attachTo: this.config.attachTo,
        focusOnOpen: false,
        panelClass: '_md-panel-backdrop',
        zIndex: this.config.zIndex - 1
      };

      this._backdropRef = this._$mdPanel.create(backdropConfig);
    }
    if (!this._backdropRef.isAttached) {
      return this._backdropRef.attach();
    }
  }
};


/**
 * Listen for escape keys and outside clicks to auto close.
 * @private
 */
MdPanelRef.prototype._addEventListeners = function() {
  this._configureEscapeToClose();
  this._configureClickOutsideToClose();
  this._configureScrollListener();
};


/**
 * Remove event listeners added in _addEventListeners.
 * @private
 */
MdPanelRef.prototype._removeEventListeners = function() {
  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
    removeFn();
  });
  this._removeListeners = [];
};


/**
 * Setup the escapeToClose event listeners.
 * @private
 */
MdPanelRef.prototype._configureEscapeToClose = function() {
  if (this.config['escapeToClose']) {
    var parentTarget = getElement(this.config['attachTo']);
    var self = this;

    var keyHandlerFn = function(ev) {
      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
        ev.stopPropagation();
        ev.preventDefault();

        self.close(MdPanelRef.closeReasons.ESCAPE);
      }
    };

    // Add keydown listeners
    this.panelContainer.on('keydown', keyHandlerFn);
    parentTarget.on('keydown', keyHandlerFn);

    // Queue remove listeners function
    this._removeListeners.push(function() {
      self.panelContainer.off('keydown', keyHandlerFn);
      parentTarget.off('keydown', keyHandlerFn);
    });
  }
};


/**
 * Setup the clickOutsideToClose event listeners.
 * @private
 */
MdPanelRef.prototype._configureClickOutsideToClose = function() {
  if (this.config['clickOutsideToClose']) {
    var target = this.config['propagateContainerEvents'] ?
        angular.element(document.body) :
        this.panelContainer;
    var sourceEl;

    // Keep track of the element on which the mouse originally went down
    // so that we can only close the backdrop when the 'click' started on it.
    // A simple 'click' handler does not work, it sets the target object as the
    // element the mouse went down on.
    var mousedownHandler = function(ev) {
      sourceEl = ev.target;
    };

    // We check if our original element and the target is the backdrop
    // because if the original was the backdrop and the target was inside the
    // panel we don't want to panel to close.
    var self = this;
    var mouseupHandler = function(ev) {
      if (self.config['propagateContainerEvents']) {

        // We check if the sourceEl of the event is the panel element or one
        // of it's children. If it is not, then close the panel.
        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
          self.close();
        }

      } else if (sourceEl === target[0] && ev.target === target[0]) {
        ev.stopPropagation();
        ev.preventDefault();

        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
      }
    };

    // Add listeners
    target.on('mousedown', mousedownHandler);
    target.on('mouseup', mouseupHandler);

    // Queue remove listeners function
    this._removeListeners.push(function() {
      target.off('mousedown', mousedownHandler);
      target.off('mouseup', mouseupHandler);
    });
  }
};


/**
 * Configures the listeners for updating the panel position on scroll.
 * @private
*/
MdPanelRef.prototype._configureScrollListener = function() {
  // No need to bind the event if scrolling is disabled.
  if (!this.config['disableParentScroll']) {
    var updatePosition = angular.bind(this, this._updatePosition);
    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
    var self = this;

    var onScroll = function() {
      debouncedUpdatePosition();
    };

    // Add listeners.
    this._$window.addEventListener('scroll', onScroll, true);

    // Queue remove listeners function.
    this._removeListeners.push(function() {
      self._$window.removeEventListener('scroll', onScroll, true);
    });
  }
};


/**
 * Setup the focus traps. These traps will wrap focus when tabbing past the
 * panel. When shift-tabbing, the focus will stick in place.
 * @private
 */
MdPanelRef.prototype._configureTrapFocus = function() {
  // Focus doesn't remain inside of the panel without this.
  this.panelEl.attr('tabIndex', '-1');
  if (this.config['trapFocus']) {
    var element = this.panelEl;
    // Set up elements before and after the panel to capture focus and
    // redirect back into the panel.
    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];

    // When focus is about to move out of the panel, we want to intercept it
    // and redirect it back to the panel element.
    var focusHandler = function() {
      element.focus();
    };
    this._topFocusTrap.addEventListener('focus', focusHandler);
    this._bottomFocusTrap.addEventListener('focus', focusHandler);

    // Queue remove listeners function
    this._removeListeners.push(this._simpleBind(function() {
      this._topFocusTrap.removeEventListener('focus', focusHandler);
      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
    }, this));

    // The top focus trap inserted immediately before the md-panel element (as
    // a sibling). The bottom focus trap inserted immediately after the
    // md-panel element (as a sibling).
    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
    element.after(this._bottomFocusTrap);
  }
};


/**
 * Updates the animation of a panel.
 * @param {!MdPanelAnimation} animation
 */
MdPanelRef.prototype.updateAnimation = function(animation) {
  this.config['animation'] = animation;

  if (this._backdropRef) {
    this._backdropRef.config.animation.duration(animation._rawDuration);
  }
};


/**
 * Animate the panel opening.
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     animated open.
 * @private
 */
MdPanelRef.prototype._animateOpen = function() {
  this.panelContainer.addClass('md-panel-is-showing');
  var animationConfig = this.config['animation'];
  if (!animationConfig) {
    // Promise is in progress, return it.
    this.panelContainer.addClass('_md-panel-shown');
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve) {
    var done = self._done(resolve, self);
    var warnAndOpen = function() {
      self._$log.warn(
          'mdPanel: MdPanel Animations failed. ' +
          'Showing panel without animating.');
      done();
    };

    animationConfig.animateOpen(self.panelEl)
        .then(done, warnAndOpen);
  });
};


/**
 * Animate the panel closing.
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     animated closed.
 * @private
 */
MdPanelRef.prototype._animateClose = function() {
  var animationConfig = this.config['animation'];
  if (!animationConfig) {
    this.panelContainer.removeClass('md-panel-is-showing');
    this.panelContainer.removeClass('_md-panel-shown');
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve) {
    var done = function() {
      self.panelContainer.removeClass('md-panel-is-showing');
      resolve(self);
    };
    var warnAndClose = function() {
      self._$log.warn(
          'mdPanel: MdPanel Animations failed. ' +
          'Hiding panel without animating.');
      done();
    };

    animationConfig.animateClose(self.panelEl)
        .then(done, warnAndClose);
  });
};


/**
 * Registers a interceptor with the panel. The callback should return a promise,
 * which will allow the action to continue when it gets resolved, or will
 * prevent an action if it is rejected.
 * @param {string} type Type of interceptor.
 * @param {!angular.$q.Promise<!any>} callback Callback to be registered.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.registerInterceptor = function(type, callback) {
  var error = null;

  if (!angular.isString(type)) {
    error = 'Interceptor type must be a string, instead got ' + typeof type;
  } else if (!angular.isFunction(callback)) {
    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
  }

  if (error) {
    throw new Error('MdPanel: ' + error);
  }

  var interceptors = this._interceptors[type] = this._interceptors[type] || [];

  if (interceptors.indexOf(callback) === -1) {
    interceptors.push(callback);
  }

  return this;
};


/**
 * Removes a registered interceptor.
 * @param {string} type Type of interceptor to be removed.
 * @param {Function} callback Interceptor to be removed.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.removeInterceptor = function(type, callback) {
  var index = this._interceptors[type] ?
    this._interceptors[type].indexOf(callback) : -1;

  if (index > -1) {
    this._interceptors[type].splice(index, 1);
  }

  return this;
};


/**
 * Removes all interceptors.
 * @param {string=} type Type of interceptors to be removed.
 *     If ommited, all interceptors types will be removed.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.removeAllInterceptors = function(type) {
  if (type) {
    this._interceptors[type] = [];
  } else {
    this._interceptors = Object.create(null);
  }

  return this;
};


/**
 * Invokes all the interceptors of a certain type sequantially in
 *     reverse order. Works in a similar way to `$q.all`, except it
 *     respects the order of the functions.
 * @param {string} type Type of interceptors to be invoked.
 * @returns {!angular.$q.Promise<!MdPanelRef>}
 * @private
 */
MdPanelRef.prototype._callInterceptors = function(type) {
  var self = this;
  var $q = self._$q;
  var interceptors = self._interceptors && self._interceptors[type] || [];

  return interceptors.reduceRight(function(promise, interceptor) {
    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
    var response = isPromiseLike ? interceptor : null;

    /**
    * For interceptors to reject/cancel subsequent portions of the chain, simply
    * return a `$q.reject(<value>)`
    */
    return promise.then(function() {
      if (!response) {
        try {
          response = interceptor(self);
        } catch(e) {
          response = $q.reject(e);
        }
      }

     return response;
    });
  }, $q.resolve(self));
};


/**
 * Faster, more basic than angular.bind
 * http://jsperf.com/angular-bind-vs-custom-vs-native
 * @param {function} callback
 * @param {!Object} self
 * @return {function} Callback function with a bound self.
 */
MdPanelRef.prototype._simpleBind = function(callback, self) {
  return function(value) {
    return callback.apply(self, value);
  };
};


/**
 * @param {function} callback
 * @param {!Object} self
 * @return {function} Callback function with a self param.
 */
MdPanelRef.prototype._done = function(callback, self) {
  return function() {
    callback(self);
  };
};


/**
 * Adds a panel to a group if the panel does not exist within the group already.
 * A panel can only exist within a single group.
 * @param {string} groupName The name of the group.
 */
MdPanelRef.prototype.addToGroup = function(groupName) {
  if (!this._$mdPanel._groups[groupName]) {
    this._$mdPanel.newPanelGroup(groupName);
  }

  var group = this._$mdPanel._groups[groupName];
  var index = group.panels.indexOf(this);

  if (index < 0) {
    group.panels.push(this);
  }
};


/**
 * Removes a panel from a group if the panel exists within that group. The group
 * must be created ahead of time.
 * @param {string} groupName The name of the group.
 */
MdPanelRef.prototype.removeFromGroup = function(groupName) {
  if (!this._$mdPanel._groups[groupName]) {
    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
  }

  var group = this._$mdPanel._groups[groupName];
  var index = group.panels.indexOf(this);

  if (index > -1) {
    group.panels.splice(index, 1);
  }
};


/**
 * Possible default closeReasons for the close function.
 * @enum {string}
 */
MdPanelRef.closeReasons = {
  CLICK_OUTSIDE: 'clickOutsideToClose',
  ESCAPE: 'escapeToClose',
};


/*****************************************************************************
 *                               MdPanelPosition                             *
 *****************************************************************************/


/**
 * Position configuration object. To use, create an MdPanelPosition with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * Example:
 *
 * var panelPosition = new MdPanelPosition()
 *     .relativeTo(myButtonEl)
 *     .addPanelPosition(
 *       $mdPanel.xPosition.CENTER,
 *       $mdPanel.yPosition.ALIGN_TOPS
 *     );
 *
 * $mdPanel.create({
 *   position: panelPosition
 * });
 *
 * @param {!angular.$injector} $injector
 * @final @constructor
 */
function MdPanelPosition($injector) {
  /** @private @const {!angular.$window} */
  this._$window = $injector.get('$window');

  /** @private {boolean} */
  this._isRTL = $injector.get('$mdUtil').bidi() === 'rtl';

  /** @private @const {!angular.$mdConstant} */
  this._$mdConstant = $injector.get('$mdConstant');

  /** @private {boolean} */
  this._absolute = false;

  /** @private {!angular.JQLite} */
  this._relativeToEl;

  /** @private {string} */
  this._top = '';

  /** @private {string} */
  this._bottom = '';

  /** @private {string} */
  this._left = '';

  /** @private {string} */
  this._right = '';

  /** @private {!Array<string>} */
  this._translateX = [];

  /** @private {!Array<string>} */
  this._translateY = [];

  /** @private {!Array<{x:string, y:string}>} */
  this._positions = [];

  /** @private {?{x:string, y:string}} */
  this._actualPosition;
}


/**
 * Possible values of xPosition.
 * @enum {string}
 */
MdPanelPosition.xPosition = {
  CENTER: 'center',
  ALIGN_START: 'align-start',
  ALIGN_END: 'align-end',
  OFFSET_START: 'offset-start',
  OFFSET_END: 'offset-end'
};


/**
 * Possible values of yPosition.
 * @enum {string}
 */
MdPanelPosition.yPosition = {
  CENTER: 'center',
  ALIGN_TOPS: 'align-tops',
  ALIGN_BOTTOMS: 'align-bottoms',
  ABOVE: 'above',
  BELOW: 'below'
};


/**
 * Possible values of absolute position.
 * @enum {string}
 */
MdPanelPosition.absPosition = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};

/**
 * Margin between the edges of a panel and the viewport.
 * @const {number}
 */
MdPanelPosition.viewportMargin = 8;


/**
 * Sets absolute positioning for the panel.
 * @return {!MdPanelPosition}
 */
MdPanelPosition.prototype.absolute = function() {
  this._absolute = true;
  return this;
};


/**
 * Sets the value of a position for the panel. Clears any previously set
 * position.
 * @param {string} position Position to set
 * @param {string=} value Value of the position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 * @private
 */
MdPanelPosition.prototype._setPosition = function(position, value) {
  if (position === MdPanelPosition.absPosition.RIGHT ||
      position === MdPanelPosition.absPosition.LEFT) {
    this._left = this._right = '';
  } else if (
      position === MdPanelPosition.absPosition.BOTTOM ||
      position === MdPanelPosition.absPosition.TOP) {
    this._top = this._bottom = '';
  } else {
    var positions = Object.keys(MdPanelPosition.absPosition).join()
        .toLowerCase();

    throw new Error('mdPanel: Position must be one of ' + positions + '.');
  }

  this['_' +  position] = angular.isString(value) ? value : '0';

  return this;
};


/**
 * Sets the value of `top` for the panel. Clears any previously set vertical
 * position.
 * @param {string=} top Value of `top`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.top = function(top) {
  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
};


/**
 * Sets the value of `bottom` for the panel. Clears any previously set vertical
 * position.
 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.bottom = function(bottom) {
  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
};


/**
 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
 * `rtl`. Clears any previously set horizontal position.
 * @param {string=} start Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.start = function(start) {
  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
  return this._setPosition(position, start);
};


/**
 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
 * Clears any previously set horizontal position.
 * @param {string=} end Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.end = function(end) {
  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
  return this._setPosition(position, end);
};


/**
 * Sets the value of `left` for the panel. Clears any previously set
 * horizontal position.
 * @param {string=} left Value of `left`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.left = function(left) {
  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
};


/**
 * Sets the value of `right` for the panel. Clears any previously set
 * horizontal position.
 * @param {string=} right Value of `right`. Defaults to '0'.
 * @returns {!MdPanelPosition}
*/
MdPanelPosition.prototype.right = function(right) {
  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
};


/**
 * Centers the panel horizontally in the viewport. Clears any previously set
 * horizontal position.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.centerHorizontally = function() {
  this._left = '50%';
  this._right = '';
  this._translateX = ['-50%'];
  return this;
};


/**
 * Centers the panel vertically in the viewport. Clears any previously set
 * vertical position.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.centerVertically = function() {
  this._top = '50%';
  this._bottom = '';
  this._translateY = ['-50%'];
  return this;
};


/**
 * Centers the panel horizontally and vertically in the viewport. This is
 * equivalent to calling both `centerHorizontally` and `centerVertically`.
 * Clears any previously set horizontal and vertical positions.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.center = function() {
  return this.centerHorizontally().centerVertically();
};


/**
 * Sets element for relative positioning.
 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
 *     or angular element to set the panel relative to.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.relativeTo = function(element) {
  this._absolute = false;
  this._relativeToEl = getElement(element);
  return this;
};


/**
 * Sets the x and y positions for the panel relative to another element.
 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
 *     values.
 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
 *     values.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
  if (!this._relativeToEl) {
    throw new Error('mdPanel: addPanelPosition can only be used with ' +
        'relative positioning. Set relativeTo first.');
  }

  this._validateXPosition(xPosition);
  this._validateYPosition(yPosition);

  this._positions.push({
      x: xPosition,
      y: yPosition,
  });
  return this;
};


/**
 * Ensures that yPosition is a valid position name. Throw an exception if not.
 * @param {string} yPosition
 */
MdPanelPosition.prototype._validateYPosition = function(yPosition) {
  // empty is ok
  if (yPosition == null) {
      return;
  }

  var positionKeys = Object.keys(MdPanelPosition.yPosition);
  var positionValues = [];
  for (var key, i = 0; key = positionKeys[i]; i++) {
    var position = MdPanelPosition.yPosition[key];
    positionValues.push(position);

    if (position === yPosition) {
      return;
    }
  }

  throw new Error('mdPanel: Panel y position only accepts the following ' +
      'values:\n' + positionValues.join(' | '));
};


/**
 * Ensures that xPosition is a valid position name. Throw an exception if not.
 * @param {string} xPosition
 */
MdPanelPosition.prototype._validateXPosition = function(xPosition) {
  // empty is ok
  if (xPosition == null) {
      return;
  }

  var positionKeys = Object.keys(MdPanelPosition.xPosition);
  var positionValues = [];
  for (var key, i = 0; key = positionKeys[i]; i++) {
    var position = MdPanelPosition.xPosition[key];
    positionValues.push(position);
    if (position === xPosition) {
      return;
    }
  }

  throw new Error('mdPanel: Panel x Position only accepts the following ' +
      'values:\n' + positionValues.join(' | '));
};


/**
 * Sets the value of the offset in the x-direction. This will add to any
 * previously set offsets.
 * @param {string|function(MdPanelPosition): string} offsetX
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.withOffsetX = function(offsetX) {
  this._translateX.push(offsetX);
  return this;
};


/**
 * Sets the value of the offset in the y-direction. This will add to any
 * previously set offsets.
 * @param {string|function(MdPanelPosition): string} offsetY
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.withOffsetY = function(offsetY) {
  this._translateY.push(offsetY);
  return this;
};


/**
 * Gets the value of `top` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getTop = function() {
  return this._top;
};


/**
 * Gets the value of `bottom` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getBottom = function() {
  return this._bottom;
};


/**
 * Gets the value of `left` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getLeft = function() {
  return this._left;
};


/**
 * Gets the value of `right` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getRight = function() {
  return this._right;
};


/**
 * Gets the value of `transform` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getTransform = function() {
  var translateX = this._reduceTranslateValues('translateX', this._translateX);
  var translateY = this._reduceTranslateValues('translateY', this._translateY);

  // It's important to trim the result, because the browser will ignore the set
  // operation if the string contains only whitespace.
  return (translateX + ' ' + translateY).trim();
};


/**
 * Sets the `transform` value for a panel element.
 * @param {!angular.JQLite} panelEl
 * @returns {!angular.JQLite}
 * @private
 */
MdPanelPosition.prototype._setTransform = function(panelEl) {
  return panelEl.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
};


/**
 * True if the panel is completely on-screen with this positioning; false
 * otherwise.
 * @param {!angular.JQLite} panelEl
 * @return {boolean}
 * @private
 */
MdPanelPosition.prototype._isOnscreen = function(panelEl) {
  // this works because we always use fixed positioning for the panel,
  // which is relative to the viewport.
  var left = parseInt(this.getLeft());
  var top = parseInt(this.getTop());

  if (this._translateX.length || this._translateY.length) {
    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
    var offsets = getComputedTranslations(panelEl, prefixedTransform);
    left += offsets.x;
    top += offsets.y;
  }

  var right = left + panelEl[0].offsetWidth;
  var bottom = top + panelEl[0].offsetHeight;

  return (left >= 0) &&
    (top >= 0) &&
    (bottom <= this._$window.innerHeight) &&
    (right <= this._$window.innerWidth);
};


/**
 * Gets the first x/y position that can fit on-screen.
 * @returns {{x: string, y: string}}
 */
MdPanelPosition.prototype.getActualPosition = function() {
  return this._actualPosition;
};


/**
 * Reduces a list of translate values to a string that can be used within
 * transform.
 * @param {string} translateFn
 * @param {!Array<string>} values
 * @returns {string}
 * @private
 */
MdPanelPosition.prototype._reduceTranslateValues =
    function(translateFn, values) {
      return values.map(function(translation) {
        // TODO(crisbeto): this should add the units after #9609 is merged.
        var translationValue = angular.isFunction(translation) ?
            translation(this) : translation;
        return translateFn + '(' + translationValue + ')';
      }, this).join(' ');
    };


/**
 * Sets the panel position based on the created panel element and best x/y
 * positioning.
 * @param {!angular.JQLite} panelEl
 * @private
 */
MdPanelPosition.prototype._setPanelPosition = function(panelEl) {
  // Remove the "position adjusted" class in case it has been added before.
  panelEl.removeClass('_md-panel-position-adjusted');

  // Only calculate the position if necessary.
  if (this._absolute) {
    this._setTransform(panelEl);
    return;
  }

  if (this._actualPosition) {
    this._calculatePanelPosition(panelEl, this._actualPosition);
    this._setTransform(panelEl);
    this._constrainToViewport(panelEl);
    return;
  }

  for (var i = 0; i < this._positions.length; i++) {
    this._actualPosition = this._positions[i];
    this._calculatePanelPosition(panelEl, this._actualPosition);
    this._setTransform(panelEl);

    if (this._isOnscreen(panelEl)) {
      return;
    }
  }

  this._constrainToViewport(panelEl);
};


/**
 * Constrains a panel's position to the viewport.
 * @param {!angular.JQLite} panelEl
 * @private
 */
MdPanelPosition.prototype._constrainToViewport = function(panelEl) {
  var margin = MdPanelPosition.viewportMargin;
  var initialTop = this._top;
  var initialLeft = this._left;

  if (this.getTop()) {
    var top = parseInt(this.getTop());
    var bottom = panelEl[0].offsetHeight + top;
    var viewportHeight = this._$window.innerHeight;

    if (top < margin) {
      this._top = margin + 'px';
    } else if (bottom > viewportHeight) {
      this._top = top - (bottom - viewportHeight + margin) + 'px';
    }
  }

  if (this.getLeft()) {
    var left = parseInt(this.getLeft());
    var right = panelEl[0].offsetWidth + left;
    var viewportWidth = this._$window.innerWidth;

    if (left < margin) {
      this._left = margin + 'px';
    } else if (right > viewportWidth) {
      this._left = left - (right - viewportWidth + margin) + 'px';
    }
  }

  // Class that can be used to re-style the panel if it was repositioned.
  panelEl.toggleClass(
    '_md-panel-position-adjusted',
    this._top !== initialTop || this._left !== initialLeft
  );
};


/**
 * Switches between 'start' and 'end'.
 * @param {string} position Horizontal position of the panel
 * @returns {string} Reversed position
 * @private
 */
MdPanelPosition.prototype._reverseXPosition = function(position) {
  if (position === MdPanelPosition.xPosition.CENTER) {
    return position;
  }

  var start = 'start';
  var end = 'end';

  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
};


/**
 * Handles horizontal positioning in rtl or ltr environments.
 * @param {string} position Horizontal position of the panel
 * @returns {string} The correct position according the page direction
 * @private
 */
MdPanelPosition.prototype._bidi = function(position) {
  return this._isRTL ? this._reverseXPosition(position) : position;
};


/**
 * Calculates the panel position based on the created panel element and the
 * provided positioning.
 * @param {!angular.JQLite} panelEl
 * @param {!{x:string, y:string}} position
 * @private
 */
MdPanelPosition.prototype._calculatePanelPosition = function(panelEl, position) {

  var panelBounds = panelEl[0].getBoundingClientRect();
  var panelWidth = panelBounds.width;
  var panelHeight = panelBounds.height;

  var targetBounds = this._relativeToEl[0].getBoundingClientRect();

  var targetLeft = targetBounds.left;
  var targetRight = targetBounds.right;
  var targetWidth = targetBounds.width;

  switch (this._bidi(position.x)) {
    case MdPanelPosition.xPosition.OFFSET_START:
      this._left = targetLeft - panelWidth + 'px';
      break;
    case MdPanelPosition.xPosition.ALIGN_END:
      this._left = targetRight - panelWidth + 'px';
      break;
    case MdPanelPosition.xPosition.CENTER:
      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
      this._left = left + 'px';
      break;
    case MdPanelPosition.xPosition.ALIGN_START:
      this._left = targetLeft + 'px';
      break;
    case MdPanelPosition.xPosition.OFFSET_END:
      this._left = targetRight + 'px';
      break;
  }

  var targetTop = targetBounds.top;
  var targetBottom = targetBounds.bottom;
  var targetHeight = targetBounds.height;

  switch (position.y) {
    case MdPanelPosition.yPosition.ABOVE:
      this._top = targetTop - panelHeight + 'px';
      break;
    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
      this._top = targetBottom - panelHeight + 'px';
      break;
    case MdPanelPosition.yPosition.CENTER:
      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
      this._top = top + 'px';
      break;
    case MdPanelPosition.yPosition.ALIGN_TOPS:
      this._top = targetTop + 'px';
      break;
    case MdPanelPosition.yPosition.BELOW:
      this._top = targetBottom + 'px';
      break;
  }
};


/*****************************************************************************
 *                               MdPanelAnimation                            *
 *****************************************************************************/


/**
 * Animation configuration object. To use, create an MdPanelAnimation with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * Example:
 *
 * var panelAnimation = new MdPanelAnimation()
 *     .openFrom(myButtonEl)
 *     .closeTo('.my-button')
 *     .withAnimation($mdPanel.animation.SCALE);
 *
 * $mdPanel.create({
 *   animation: panelAnimation
 * });
 *
 * @param {!angular.$injector} $injector
 * @final @constructor
 */
function MdPanelAnimation($injector) {
  /** @private @const {!angular.$mdUtil} */
  this._$mdUtil = $injector.get('$mdUtil');

  /**
   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
   *     undefined}
   */
  this._openFrom;

  /**
   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
   *     undefined}
   */
  this._closeTo;

  /** @private {string|{open: string, close: string}} */
  this._animationClass = '';

  /** @private {number} */
  this._openDuration;

  /** @private {number} */
  this._closeDuration;

  /** @private {number|{open: number, close: number}} */
  this._rawDuration;
}


/**
 * Possible default animations.
 * @enum {string}
 */
MdPanelAnimation.animation = {
  SLIDE: 'md-panel-animate-slide',
  SCALE: 'md-panel-animate-scale',
  FADE: 'md-panel-animate-fade'
};


/**
 * Specifies where to start the open animation. `openFrom` accepts a
 * click event object, query selector, DOM element, or a Rect object that
 * is used to determine the bounds. When passed a click event, the location
 * of the click will be used as the position to start the animation.
 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.openFrom = function(openFrom) {
  // Check if 'openFrom' is an Event.
  openFrom = openFrom.target ? openFrom.target : openFrom;

  this._openFrom = this._getPanelAnimationTarget(openFrom);

  if (!this._closeTo) {
    this._closeTo = this._openFrom;
  }
  return this;
};


/**
 * Specifies where to animate the panel close. `closeTo` accepts a
 * query selector, DOM element, or a Rect object that is used to determine
 * the bounds.
 * @param {string|!Element|{top: number, left: number}} closeTo
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.closeTo = function(closeTo) {
  this._closeTo = this._getPanelAnimationTarget(closeTo);
  return this;
};


/**
 * Specifies the duration of the animation in milliseconds.
 * @param {number|{open: number, close: number}} duration
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.duration = function(duration) {
  if (duration) {
    if (angular.isNumber(duration)) {
      this._openDuration = this._closeDuration = toSeconds(duration);
    } else if (angular.isObject(duration)) {
      this._openDuration = toSeconds(duration.open);
      this._closeDuration = toSeconds(duration.close);
    }
  }

  // Save the original value so it can be passed to the backdrop.
  this._rawDuration = duration;

  return this;

  function toSeconds(value) {
    if (angular.isNumber(value)) return value / 1000;
  }
};


/**
 * Returns the element and bounds for the animation target.
 * @param {string|!Element|{top: number, left: number}} location
 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
 * @private
 */
MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
    return {
      element: undefined,
      bounds: {
        top: location.top || 0,
        left: location.left || 0
      }
    };
  } else {
    return this._getBoundingClientRect(getElement(location));
  }
};


/**
 * Specifies the animation class.
 *
 * There are several default animations that can be used:
 * (MdPanelAnimation.animation)
 *   SLIDE: The panel slides in and out from the specified
 *        elements.
 *   SCALE: The panel scales in and out.
 *   FADE: The panel fades in and out.
 *
 * @param {string|{open: string, close: string}} cssClass
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.withAnimation = function(cssClass) {
  this._animationClass = cssClass;
  return this;
};


/**
 * Animate the panel open.
 * @param {!angular.JQLite} panelEl
 * @returns {!angular.$q.Promise} A promise that is resolved when the open
 *     animation is complete.
 */
MdPanelAnimation.prototype.animateOpen = function(panelEl) {
  var animator = this._$mdUtil.dom.animator;

  this._fixBounds(panelEl);
  var animationOptions = {};

  // Include the panel transformations when calculating the animations.
  var panelTransform = panelEl[0].style.transform || '';

  var openFrom = animator.toTransformCss(panelTransform);
  var openTo = animator.toTransformCss(panelTransform);

  switch (this._animationClass) {
    case MdPanelAnimation.animation.SLIDE:
      // Slide should start with opacity: 1.
      panelEl.css('opacity', '1');

      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };

      var openSlide = animator.calculateSlideToOrigin(
              panelEl, this._openFrom) || '';
      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.SCALE:
      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };

      var openScale = animator.calculateZoomToOrigin(
              panelEl, this._openFrom) || '';
      openFrom = animator.toTransformCss(openScale + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.FADE:
      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };
      break;

    default:
      if (angular.isString(this._animationClass)) {
        animationOptions = {
          transitionInClass: this._animationClass
        };
      } else {
        animationOptions = {
          transitionInClass: this._animationClass['open'],
          transitionOutClass: this._animationClass['close'],
        };
      }
  }

  animationOptions.duration = this._openDuration;

  return animator
      .translate3d(panelEl, openFrom, openTo, animationOptions);
};


/**
 * Animate the panel close.
 * @param {!angular.JQLite} panelEl
 * @returns {!angular.$q.Promise} A promise that resolves when the close
 *     animation is complete.
 */
MdPanelAnimation.prototype.animateClose = function(panelEl) {
  var animator = this._$mdUtil.dom.animator;
  var reverseAnimationOptions = {};

  // Include the panel transformations when calculating the animations.
  var panelTransform = panelEl[0].style.transform || '';

  var closeFrom = animator.toTransformCss(panelTransform);
  var closeTo = animator.toTransformCss(panelTransform);

  switch (this._animationClass) {
    case MdPanelAnimation.animation.SLIDE:
      // Slide should start with opacity: 1.
      panelEl.css('opacity', '1');
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-leave'
      };

      var closeSlide = animator.calculateSlideToOrigin(
              panelEl, this._closeTo) || '';
      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.SCALE:
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave'
      };

      var closeScale = animator.calculateZoomToOrigin(
              panelEl, this._closeTo) || '';
      closeTo = animator.toTransformCss(closeScale + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.FADE:
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave'
      };
      break;

    default:
      if (angular.isString(this._animationClass)) {
        reverseAnimationOptions = {
          transitionOutClass: this._animationClass
        };
      } else {
        reverseAnimationOptions = {
          transitionInClass: this._animationClass['close'],
          transitionOutClass: this._animationClass['open']
        };
      }
  }

  reverseAnimationOptions.duration = this._closeDuration;

  return animator
      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
};


/**
 * Set the height and width to match the panel if not provided.
 * @param {!angular.JQLite} panelEl
 * @private
 */
MdPanelAnimation.prototype._fixBounds = function(panelEl) {
  var panelWidth = panelEl[0].offsetWidth;
  var panelHeight = panelEl[0].offsetHeight;

  if (this._openFrom && this._openFrom.bounds.height == null) {
    this._openFrom.bounds.height = panelHeight;
  }
  if (this._openFrom && this._openFrom.bounds.width == null) {
    this._openFrom.bounds.width = panelWidth;
  }
  if (this._closeTo && this._closeTo.bounds.height == null) {
    this._closeTo.bounds.height = panelHeight;
  }
  if (this._closeTo && this._closeTo.bounds.width == null) {
    this._closeTo.bounds.width = panelWidth;
  }
};


/**
 * Identify the bounding RECT for the target element.
 * @param {!angular.JQLite} element
 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
 * @private
 */
MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
  if (element instanceof angular.element) {
    return {
      element: element,
      bounds: element[0].getBoundingClientRect()
    };
  }
};


/*****************************************************************************
 *                                Util Methods                               *
 *****************************************************************************/


/**
 * Returns the angular element associated with a css selector or element.
 * @param el {string|!angular.JQLite|!Element}
 * @returns {!angular.JQLite}
 */
function getElement(el) {
  var queryResult = angular.isString(el) ?
      document.querySelector(el) : el;
  return angular.element(queryResult);
}


/**
 * Gets the computed values for an element's translateX and translateY in px.
 * @param {!angular.JQLite|!Element} el
 * @param {string} property
 * @return {{x: number, y: number}}
 */
function getComputedTranslations(el, property) {
  // The transform being returned by `getComputedStyle` is in the format:
  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
  // if the element doesn't have a transform.
  var transform = getComputedStyle(el[0] || el)[property];
  var openIndex = transform.indexOf('(');
  var closeIndex = transform.lastIndexOf(')');
  var output = { x: 0, y: 0 };

  if (openIndex > -1 && closeIndex > -1) {
    var parsedValues = transform
      .substring(openIndex + 1, closeIndex)
      .split(', ')
      .slice(-2);

    output.x = parseInt(parsedValues[0]);
    output.y = parseInt(parsedValues[1]);
  }

  return output;
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.progressCircular
 * @description Module for a circular progressbar
 */

angular.module('material.components.progressCircular', ['material.core']);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.progressLinear
 * @description Linear Progress module!
 */
MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
angular.module('material.components.progressLinear', [
  'material.core'
])
  .directive('mdProgressLinear', MdProgressLinearDirective);

/**
 * @ngdoc directive
 * @name mdProgressLinear
 * @module material.components.progressLinear
 * @restrict E
 *
 * @description
 * The linear progress directive is used to make loading content
 * in your app as delightful and painless as possible by minimizing
 * the amount of visual change a user sees before they can view
 * and interact with content.
 *
 * Each operation should only be represented by one activity indicator
 * For example: one refresh operation should not display both a
 * refresh bar and an activity circle.
 *
 * For operations where the percentage of the operation completed
 * can be determined, use a determinate indicator. They give users
 * a quick sense of how long an operation will take.
 *
 * For operations where the user is asked to wait a moment while
 * something finishes up, and it’s not necessary to expose what's
 * happening behind the scenes and how long it will take, use an
 * indeterminate indicator.
 *
 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
 *
 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
 * will be auto-applied as the mode.
 *
 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
 * then `md-mode="determinate"` would be auto-injected instead.
 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
 *
 * @usage
 * <hljs lang="html">
 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
 *
 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
 *
 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
 *
 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
 *
 * <md-progress-linear md-mode="query"></md-progress-linear>
 * </hljs>
 */
function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
  var MODE_DETERMINATE = "determinate";
  var MODE_INDETERMINATE = "indeterminate";
  var MODE_BUFFER = "buffer";
  var MODE_QUERY = "query";
  var DISABLED_CLASS = "_md-progress-linear-disabled";

  return {
    restrict: 'E',
    template: '<div class="md-container">' +
      '<div class="md-dashed"></div>' +
      '<div class="md-bar md-bar1"></div>' +
      '<div class="md-bar md-bar2"></div>' +
      '</div>',
    compile: compile
  };

  function compile(tElement, tAttrs, transclude) {
    tElement.attr('aria-valuemin', 0);
    tElement.attr('aria-valuemax', 100);
    tElement.attr('role', 'progressbar');

    return postLink;
  }
  function postLink(scope, element, attr) {
    $mdTheming(element);

    var lastMode;
    var isDisabled = attr.hasOwnProperty('disabled');
    var toVendorCSS = $mdUtil.dom.animator.toCss;
    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
    var container = angular.element(element[0].querySelector('.md-container'));

    element
      .attr('md-mode', mode())
      .toggleClass(DISABLED_CLASS, isDisabled);

    validateMode();
    watchAttributes();

    /**
     * Watch the value, md-buffer-value, and md-mode attributes
     */
    function watchAttributes() {
      attr.$observe('value', function(value) {
        var percentValue = clamp(value);
        element.attr('aria-valuenow', percentValue);

        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
      });

      attr.$observe('mdBufferValue', function(value) {
        animateIndicator(bar1, clamp(value));
      });

      attr.$observe('disabled', function(value) {
        if (value === true || value === false) {
          isDisabled = !!value;
        } else {
          isDisabled = angular.isDefined(value);
        }

        element.toggleClass(DISABLED_CLASS, isDisabled);
        container.toggleClass(lastMode, !isDisabled);
      });

      attr.$observe('mdMode', function(mode) {
        if (lastMode) container.removeClass( lastMode );

        switch( mode ) {
          case MODE_QUERY:
          case MODE_BUFFER:
          case MODE_DETERMINATE:
          case MODE_INDETERMINATE:
            container.addClass( lastMode = "md-mode-" + mode );
            break;
          default:
            container.addClass( lastMode = "md-mode-" + MODE_INDETERMINATE );
            break;
        }
      });
    }

    /**
     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
     */
    function validateMode() {
      if ( angular.isUndefined(attr.mdMode) ) {
        var hasValue = angular.isDefined(attr.value);
        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";

        //$log.debug( $mdUtil.supplant(info, [mode]) );

        element.attr("md-mode", mode);
        attr.mdMode = mode;
      }
    }

    /**
     * Is the md-mode a valid option?
     */
    function mode() {
      var value = (attr.mdMode || "").trim();
      if ( value ) {
        switch(value) {
          case MODE_DETERMINATE:
          case MODE_INDETERMINATE:
          case MODE_BUFFER:
          case MODE_QUERY:
            break;
          default:
            value = MODE_INDETERMINATE;
            break;
        }
      }
      return value;
    }

    /**
     * Manually set CSS to animate the Determinate indicator based on the specified
     * percentage value (0-100).
     */
    function animateIndicator(target, value) {
      if ( isDisabled || !mode() ) return;

      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [ (value-100)/2, value/100 ]);
      var styles = toVendorCSS({ transform : to });
      angular.element(target).css( styles );
    }
  }

  /**
   * Clamps the value to be between 0 and 100.
   * @param {number} value The value to clamp.
   * @returns {number}
   */
  function clamp(value) {
    return Math.max(0, Math.min(value || 0, 100));
  }
}


})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.radioButton
 * @description radioButton module!
 */
mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
angular.module('material.components.radioButton', [
  'material.core'
])
  .directive('mdRadioGroup', mdRadioGroupDirective)
  .directive('mdRadioButton', mdRadioButtonDirective);

/**
 * @ngdoc directive
 * @module material.components.radioButton
 * @name mdRadioGroup
 *
 * @restrict E
 *
 * @description
 * The `<md-radio-group>` directive identifies a grouping
 * container for the 1..n grouped radio buttons; specified using nested
 * `<md-radio-button>` tags.
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the radio button is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * Note: `<md-radio-group>` and `<md-radio-button>` handle tabindex differently
 * than the native `<input type='radio'>` controls. Whereas the native controls
 * force the user to tab through all the radio buttons, `<md-radio-group>`
 * is focusable, and by default the `<md-radio-button>`s are not.
 *
 * @param {string} ng-model Assignable angular expression to data-bind to.
 * @param {boolean=} md-no-ink Use of attribute indicates flag to disable ink ripple effects.
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
 *    interaction with the input element.
 *
 * @usage
 * <hljs lang="html">
 * <md-radio-group ng-model="selected">
 *
 *   <md-radio-button
 *        ng-repeat="d in colorOptions"
 *        ng-value="d.value" aria-label="{{ d.label }}">
 *
 *          {{ d.label }}
 *
 *   </md-radio-button>
 *
 * </md-radio-group>
 * </hljs>
 *
 */
function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
  RadioGroupController.prototype = createRadioGroupControllerProto();

  return {
    restrict: 'E',
    controller: ['$element', RadioGroupController],
    require: ['mdRadioGroup', '?ngModel'],
    link: { pre: linkRadioGroup }
  };

  function linkRadioGroup(scope, element, attr, ctrls) {
    element.addClass('_md');     // private md component indicator for styling
    $mdTheming(element);

    var rgCtrl = ctrls[0];
    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();

    rgCtrl.init(ngModelCtrl);

    scope.mouseActive = false;

    element
      .attr({
        'role': 'radiogroup',
        'tabIndex': element.attr('tabindex') || '0'
      })
      .on('keydown', keydownListener)
      .on('mousedown', function(event) {
        scope.mouseActive = true;
        $timeout(function() {
          scope.mouseActive = false;
        }, 100);
      })
      .on('focus', function() {
        if(scope.mouseActive === false) {
          rgCtrl.$element.addClass('md-focused');
        }
      })
      .on('blur', function() {
        rgCtrl.$element.removeClass('md-focused');
      });

    /**
     *
     */
    function setFocus() {
      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
    }

    /**
     *
     */
    function keydownListener(ev) {
      var keyCode = ev.which || ev.keyCode;

      // Only listen to events that we originated ourselves
      // so that we don't trigger on things like arrow keys in
      // inputs.

      if (keyCode != $mdConstant.KEY_CODE.ENTER &&
          ev.currentTarget != ev.target) {
        return;
      }

      switch (keyCode) {
        case $mdConstant.KEY_CODE.LEFT_ARROW:
        case $mdConstant.KEY_CODE.UP_ARROW:
          ev.preventDefault();
          rgCtrl.selectPrevious();
          setFocus();
          break;

        case $mdConstant.KEY_CODE.RIGHT_ARROW:
        case $mdConstant.KEY_CODE.DOWN_ARROW:
          ev.preventDefault();
          rgCtrl.selectNext();
          setFocus();
          break;

        case $mdConstant.KEY_CODE.ENTER:
          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
          if (form.length > 0) {
            form.triggerHandler('submit');
          }
          break;
      }

    }
  }

  function RadioGroupController($element) {
    this._radioButtonRenderFns = [];
    this.$element = $element;
  }

  function createRadioGroupControllerProto() {
    return {
      init: function(ngModelCtrl) {
        this._ngModelCtrl = ngModelCtrl;
        this._ngModelCtrl.$render = angular.bind(this, this.render);
      },
      add: function(rbRender) {
        this._radioButtonRenderFns.push(rbRender);
      },
      remove: function(rbRender) {
        var index = this._radioButtonRenderFns.indexOf(rbRender);
        if (index !== -1) {
          this._radioButtonRenderFns.splice(index, 1);
        }
      },
      render: function() {
        this._radioButtonRenderFns.forEach(function(rbRender) {
          rbRender();
        });
      },
      setViewValue: function(value, eventType) {
        this._ngModelCtrl.$setViewValue(value, eventType);
        // update the other radio buttons as well
        this.render();
      },
      getViewValue: function() {
        return this._ngModelCtrl.$viewValue;
      },
      selectNext: function() {
        return changeSelectedButton(this.$element, 1);
      },
      selectPrevious: function() {
        return changeSelectedButton(this.$element, -1);
      },
      setActiveDescendant: function (radioId) {
        this.$element.attr('aria-activedescendant', radioId);
      },
      isDisabled: function() {
        return this.$element[0].hasAttribute('disabled');
      }
    };
  }
  /**
   * Change the radio group's selected button by a given increment.
   * If no button is selected, select the first button.
   */
  function changeSelectedButton(parent, increment) {
    // Coerce all child radio buttons into an array, then wrap then in an iterator
    var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);

    if (buttons.count()) {
      var validate = function (button) {
        // If disabled, then NOT valid
        return !angular.element(button).attr("disabled");
      };

      var selected = parent[0].querySelector('md-radio-button.md-checked');
      var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();

      // Activate radioButton's click listener (triggerHandler won't create a real click event)
      angular.element(target).triggerHandler('click');
    }
  }

}

/**
 * @ngdoc directive
 * @module material.components.radioButton
 * @name mdRadioButton
 *
 * @restrict E
 *
 * @description
 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
 *
 * While similar to the `<input type="radio" ng-model="" value="">` directive,
 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
 * supports use within named radio groups.
 *
 * @param {string} ngValue AngularJS expression which sets the value to which the expression should
 *    be set when selected.
 * @param {string} value The value to which the expression should be set when selected.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} aria-label Adds label to radio button for accessibility.
 * Defaults to radio button's text. If no text content is available, a warning will be logged.
 *
 * @usage
 * <hljs lang="html">
 *
 * <md-radio-button value="1" aria-label="Label 1">
 *   Label 1
 * </md-radio-button>
 *
 * <md-radio-button ng-value="specialValue" aria-label="Green">
 *   Green
 * </md-radio-button>
 *
 * </hljs>
 *
 */
function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {

  var CHECKED_CSS = 'md-checked';

  return {
    restrict: 'E',
    require: '^mdRadioGroup',
    transclude: true,
    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
                '<div class="md-off"></div>' +
                '<div class="md-on"></div>' +
              '</div>' +
              '<div ng-transclude class="md-label"></div>',
    link: link
  };

  function link(scope, element, attr, rgCtrl) {
    var lastChecked;

    $mdTheming(element);
    configureAria(element, scope);

    // ngAria overwrites the aria-checked inside a $watch for ngValue.
    // We should defer the initialization until all the watches have fired.
    // This can also be fixed by removing the `lastChecked` check, but that'll
    // cause more DOM manipulation on each digest.
    if (attr.ngValue) {
      $mdUtil.nextTick(initialize, false);
    } else {
      initialize();
    }

    /**
     * Initializes the component.
     */
    function initialize() {
      if (!rgCtrl) {
        throw 'RadioButton: No RadioGroupController could be found.';
      }

      rgCtrl.add(render);
      attr.$observe('value', render);

      element
        .on('click', listener)
        .on('$destroy', function() {
          rgCtrl.remove(render);
        });
    }

    /**
     * On click functionality.
     */
    function listener(ev) {
      if (element[0].hasAttribute('disabled') || rgCtrl.isDisabled()) return;

      scope.$apply(function() {
        rgCtrl.setViewValue(attr.value, ev && ev.type);
      });
    }

    /**
     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
     *  Update the `aria-activedescendant` attribute.
     */
    function render() {
      var checked = rgCtrl.getViewValue() == attr.value;

      if (checked === lastChecked) return;

      if (element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
        // If the radioButton is inside a div, then add class so highlighting will work
        element.parent().toggleClass(CHECKED_CSS, checked);
      }

      if (checked) {
        rgCtrl.setActiveDescendant(element.attr('id'));
      }

      lastChecked = checked;

      element
        .attr('aria-checked', checked)
        .toggleClass(CHECKED_CSS, checked);
    }

    /**
     * Inject ARIA-specific attributes appropriate for each radio button
     */
    function configureAria(element, scope){
      element.attr({
        id: attr.id || 'radio_' + $mdUtil.nextUid(),
        role: 'radio',
        'aria-checked': 'false'
      });

      $mdAria.expectWithText(element, 'aria-label');
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.select
 */

/***************************************************

 ### TODO - POST RC1 ###
 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service

 ***************************************************/

SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce", "$injector"];
SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil", "$mdTheming"];
SelectProvider.$inject = ["$$interimElementProvider"];
var SELECT_EDGE_MARGIN = 8;
var selectNextId = 0;
var CHECKBOX_SELECTION_INDICATOR =
  angular.element('<div class="md-container"><div class="md-icon"></div></div>');

angular.module('material.components.select', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdSelect', SelectDirective)
  .directive('mdSelectMenu', SelectMenuDirective)
  .directive('mdOption', OptionDirective)
  .directive('mdOptgroup', OptgroupDirective)
  .directive('mdSelectHeader', SelectHeaderDirective)
  .provider('$mdSelect', SelectProvider);

/**
 * @ngdoc directive
 * @name mdSelect
 * @restrict E
 * @module material.components.select
 *
 * @description Displays a select box, bound to an ng-model.
 *
 * When the select is required and uses a floating label, then the label will automatically contain
 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
 *
 * By default, the select will display with an underline to match other form elements. This can be
 * disabled by applying the `md-no-underline` CSS class.
 *
 * ### Option Params
 *
 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to  clear the
 * select and put it back in it's default state. You may supply this attribute on any option you
 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
 * defined.
 *
 * **Automatically Applied**
 *
 *  - `<md-option>`
 *  - `<md-option value>`
 *  - `<md-option value="">`
 *  - `<md-option ng-value>`
 *  - `<md-option ng-value="">`
 *
 * **NOT Automatically Applied**
 *
 *  - `<md-option ng-value="1">`
 *  - `<md-option ng-value="''">`
 *  - `<md-option ng-value="undefined">`
 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
 *
 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
 * attribute) since you may wish this to be your "Not Available" or "None" option.
 *
 * **Note:** Using the `value` attribute (as opposed to `ng-value`) always evaluates to a string, so
 * `value="null"` will require the test `ng-if="myValue != 'null'"` rather than `ng-if="!myValue"`.
 *
 * @param {expression} ng-model The model!
 * @param {boolean=} multiple When set to true, allows for more than one option to be selected. The model is an array with the selected choices.
 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
 * Will hide the select options and show a spinner until the evaluated promise resolves.
 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
 * to be displayed as a placeholder in the select input box when it is closed. The value
 * will be treated as *text* (not html).
 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
 * to be displayed as a placeholder in the select input box when it is closed. The value
 * will be treated as *html*. The value must either be explicitly marked as trustedHtml or
 * the ngSanitize module must be loaded.
 * @param {string=} placeholder Placeholder hint text.
 * @param md-no-asterisk {boolean=} When set to true, an asterisk will not be appended to the
 * floating label. **Note:** This attribute is only evaluated once; it is not watched.
 * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
 * explicit label is present.
 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
 * element (for custom styling).
 *
 * @usage
 * With a placeholder (label and aria-label are added dynamically)
 * <hljs lang="html">
 *   <md-input-container>
 *     <md-select
 *       ng-model="someModel"
 *       placeholder="Select a state">
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * With an explicit label
 * <hljs lang="html">
 *   <md-input-container>
 *     <label>State</label>
 *     <md-select
 *       ng-model="someModel">
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * With a select-header
 *
 * When a developer needs to put more than just a text label in the
 * md-select-menu, they should use the md-select-header.
 * The user can put custom HTML inside of the header and style it to their liking.
 * One common use case of this would be a sticky search bar.
 *
 * When using the md-select-header the labels that would previously be added to the
 * OptGroupDirective are ignored.
 *
 * <hljs lang="html">
 *   <md-input-container>
 *     <md-select ng-model="someModel">
 *       <md-select-header>
 *         <span> Neighborhoods - </span>
 *       </md-select-header>
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * ## Selects and object equality
 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
 * equality. Consider the following example:
 * <hljs lang="js">
 * angular.controller('MyCtrl', function($scope) {
 *   $scope.users = [
 *     { id: 1, name: 'Bob' },
 *     { id: 2, name: 'Alice' },
 *     { id: 3, name: 'Steve' }
 *   ];
 *   $scope.selectedUser = { id: 1, name: 'Bob' };
 * });
 * </hljs>
 * <hljs lang="html">
 * <div ng-controller="MyCtrl">
 *   <md-select ng-model="selectedUser">
 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
 *   </md-select>
 * </div>
 * </hljs>
 *
 * At first one might expect that the select should be populated with "Bob" as the selected user. However,
 * this is not true. To determine whether something is selected,
 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
 *
 * Javascript's `==` operator does not check for deep equality (ie. that all properties
 * on the object are the same), but instead whether the objects are *the same object in memory*.
 * In this case, we have two instances of identical objects, but they exist in memory as unique
 * entities. Because of this, the select will have no value populated for a selected user.
 *
 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
 * expression which will be used for the equality operator. As such, we can update our `html` to
 * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
 * element. This converts our equality expression to be
 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
 * which results in Bob being selected as desired.
 *
 * Working HTML:
 * <hljs lang="html">
 * <div ng-controller="MyCtrl">
 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
 *   </md-select>
 * </div>
 * </hljs>
 */
function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce,
    $injector) {
  var keyCodes = $mdConstant.KEY_CODE;
  var NAVIGATION_KEYS = [keyCodes.SPACE, keyCodes.ENTER, keyCodes.UP_ARROW, keyCodes.DOWN_ARROW];

  return {
    restrict: 'E',
    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
    compile: compile,
    controller: function() {
    } // empty placeholder controller to be initialized in link
  };

  function compile(element, attr) {
    // add the select value that will hold our placeholder or selected option value
    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
    valueEl.addClass('md-select-value');
    if (!valueEl[0].hasAttribute('id')) {
      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
    }

    // There's got to be an md-content inside. If there's not one, let's add it.
    var mdContentEl = element.find('md-content');
    if (!mdContentEl.length) {
      element.append(angular.element('<md-content>').append(element.contents()));
    }
    mdContentEl.attr('role', 'presentation');


    // Add progress spinner for md-options-loading
    if (attr.mdOnOpen) {

      // Show progress indicator while loading async
      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
      element
        .find('md-content')
        .prepend(angular.element(
          '<div>' +
          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false" md-diameter="25px"></md-progress-circular>' +
          '</div>'
        ));

      // Hide list [of item options] while loading async
      element
        .find('md-option')
        .attr('ng-show', '$$loadingAsyncDone');
    }

    if (attr.name) {
      var autofillClone = angular.element('<select class="md-visually-hidden">');
      autofillClone.attr({
        'name': attr.name,
        'aria-hidden': 'true',
        'tabindex': '-1'
      });
      var opts = element.find('md-option');
      angular.forEach(opts, function(el) {
        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
        if (el.hasAttribute('ng-value')) newEl.attr('ng-value', el.getAttribute('ng-value'));
        else if (el.hasAttribute('value')) newEl.attr('value', el.getAttribute('value'));
        autofillClone.append(newEl);
      });

      // Adds an extra option that will hold the selected value for the
      // cases where the select is a part of a non-angular form. This can be done with a ng-model,
      // however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
      // This also goes around having to prepend a dot to the name attribute.
      autofillClone.append(
        '<option ng-value="' + attr.ngModel + '" selected></option>'
      );

      element.parent().append(autofillClone);
    }

    var isMultiple = $mdUtil.parseAttributeBoolean(attr.multiple);

    // Use everything that's left inside element.contents() as the contents of the menu
    var multipleContent = isMultiple ? 'multiple' : '';
    var selectTemplate = '' +
      '<div class="md-select-menu-container" aria-hidden="true" role="presentation">' +
      '<md-select-menu role="presentation" {0}>{1}</md-select-menu>' +
      '</div>';

    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, element.html()]);
    element.empty().append(valueEl);
    element.append(selectTemplate);

    if(!attr.tabindex){
      attr.$set('tabindex', 0);
    }

    return function postLink(scope, element, attr, ctrls) {
      var untouched = true;
      var isDisabled, ariaLabelBase;

      var containerCtrl = ctrls[0];
      var mdSelectCtrl = ctrls[1];
      var ngModelCtrl = ctrls[2];
      var formCtrl = ctrls[3];
      // grab a reference to the select menu value label
      var valueEl = element.find('md-select-value');
      var isReadonly = angular.isDefined(attr.readonly);
      var disableAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);

      if (disableAsterisk) {
        element.addClass('md-no-asterisk');
      }

      if (containerCtrl) {
        var isErrorGetter = containerCtrl.isErrorGetter || function() {
          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
        };

        if (containerCtrl.input) {
          // We ignore inputs that are in the md-select-header (one
          // case where this might be useful would be adding as searchbox)
          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
          }
        }

        containerCtrl.input = element;
        if (!containerCtrl.label) {
          $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
        }

        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
      }

      var selectContainer, selectScope, selectMenuCtrl;

      findSelectContainer();
      $mdTheming(element);

      if (formCtrl && angular.isDefined(attr.multiple)) {
        $mdUtil.nextTick(function() {
          var hasModelValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue;
          if (hasModelValue) {
            formCtrl.$setPristine();
          }
        });
      }

      var originalRender = ngModelCtrl.$render;
      ngModelCtrl.$render = function() {
        originalRender();
        syncLabelText();
        syncAriaLabel();
        inputCheckValue();
      };

      attr.$observe('placeholder', ngModelCtrl.$render);

      if (containerCtrl && containerCtrl.label) {
        attr.$observe('required', function (value) {
          // Toggle the md-required class on the input containers label, because the input container is automatically
          // applying the asterisk indicator on the label.
          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
        });
      }

      mdSelectCtrl.setLabelText = function(text) {
        mdSelectCtrl.setIsPlaceholder(!text);

        // Whether the select label has been given via user content rather than the internal
        // template of <md-option>
        var isSelectLabelFromUser = false;

        if (attr.mdSelectedText && attr.mdSelectedHtml) {
          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
        }

        if (attr.mdSelectedText || attr.mdSelectedHtml) {
          text = $parse(attr.mdSelectedText || attr.mdSelectedHtml)(scope);
          isSelectLabelFromUser = true;
        } else if (!text) {
          // Use placeholder attribute, otherwise fallback to the md-input-container label
          var tmpPlaceholder = attr.placeholder ||
              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');

          text = tmpPlaceholder || '';
          isSelectLabelFromUser = true;
        }

        var target = valueEl.children().eq(0);

        if (attr.mdSelectedHtml) {
            // Using getTrustedHtml will run the content through $sanitize if it is not already
            // explicitly trusted. If the ngSanitize module is not loaded, this will
            // *correctly* throw an sce error.
            target.html($sce.getTrustedHtml(text));
        } else if (isSelectLabelFromUser) {
          target.text(text);
        } else {
          // If we've reached this point, the text is not user-provided.
          target.html(text);
        }
      };

      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
        if (isPlaceholder) {
          valueEl.addClass('md-select-placeholder');
          if (containerCtrl && containerCtrl.label) {
            containerCtrl.label.addClass('md-placeholder');
          }
        } else {
          valueEl.removeClass('md-select-placeholder');
          if (containerCtrl && containerCtrl.label) {
            containerCtrl.label.removeClass('md-placeholder');
          }
        }
      };

      if (!isReadonly) {
        element
          .on('focus', function(ev) {
            // Always focus the container (if we have one) so floating labels and other styles are
            // applied properly
            containerCtrl && containerCtrl.setFocused(true);
          });

        // Attach before ngModel's blur listener to stop propagation of blur event
        // to prevent from setting $touched.
        element.on('blur', function(event) {
          if (untouched) {
            untouched = false;
            if (selectScope._mdSelectIsOpen) {
              event.stopImmediatePropagation();
            }
          }

          if (selectScope._mdSelectIsOpen) return;
          containerCtrl && containerCtrl.setFocused(false);
          inputCheckValue();
        });
      }

      mdSelectCtrl.triggerClose = function() {
        $parse(attr.mdOnClose)(scope);
      };

      scope.$$postDigest(function() {
        initAriaLabel();
        syncLabelText();
        syncAriaLabel();
      });

      function initAriaLabel() {
        var labelText = element.attr('aria-label') || element.attr('placeholder');
        if (!labelText && containerCtrl && containerCtrl.label) {
          labelText = containerCtrl.label.text();
        }
        ariaLabelBase = labelText;
        $mdAria.expect(element, 'aria-label', labelText);
      }

      scope.$watch(function() {
        return selectMenuCtrl.selectedLabels();
      }, syncLabelText);

      function syncLabelText() {
        if (selectContainer) {
          selectMenuCtrl = selectMenuCtrl || selectContainer.find('md-select-menu').controller('mdSelectMenu');
          mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());
        }
      }

      function syncAriaLabel() {
        if (!ariaLabelBase) return;
        var ariaLabels = selectMenuCtrl.selectedLabels({mode: 'aria'});
        element.attr('aria-label', ariaLabels.length ? ariaLabelBase + ': ' + ariaLabels : ariaLabelBase);
      }

      var deregisterWatcher;
      attr.$observe('ngMultiple', function(val) {
        if (deregisterWatcher) deregisterWatcher();
        var parser = $parse(val);
        deregisterWatcher = scope.$watch(function() {
          return parser(scope);
        }, function(multiple, prevVal) {
          if (multiple === undefined && prevVal === undefined) return; // assume compiler did a good job
          if (multiple) {
            element.attr('multiple', 'multiple');
          } else {
            element.removeAttr('multiple');
          }
          element.attr('aria-multiselectable', multiple ? 'true' : 'false');
          if (selectContainer) {
            selectMenuCtrl.setMultiple(multiple);
            originalRender = ngModelCtrl.$render;
            ngModelCtrl.$render = function() {
              originalRender();
              syncLabelText();
              syncAriaLabel();
              inputCheckValue();
            };
            ngModelCtrl.$render();
          }
        });
      });

      attr.$observe('disabled', function(disabled) {
        if (angular.isString(disabled)) {
          disabled = true;
        }
        // Prevent click event being registered twice
        if (isDisabled !== undefined && isDisabled === disabled) {
          return;
        }
        isDisabled = disabled;
        if (disabled) {
          element
            .attr({'aria-disabled': 'true'})
            .removeAttr('tabindex')
            .off('click', openSelect)
            .off('keydown', handleKeypress);
        } else {
          element
            .attr({'tabindex': attr.tabindex, 'aria-disabled': 'false'})
            .on('click', openSelect)
            .on('keydown', handleKeypress);
        }
      });

      if (!attr.hasOwnProperty('disabled') && !attr.hasOwnProperty('ngDisabled')) {
        element.attr({'aria-disabled': 'false'});
        element.on('click', openSelect);
        element.on('keydown', handleKeypress);
      }

      var ariaAttrs = {
        role: 'listbox',
        'aria-expanded': 'false',
        'aria-multiselectable': isMultiple && !attr.ngMultiple ? 'true' : 'false'
      };

      if (!element[0].hasAttribute('id')) {
        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
      }

      var containerId = 'select_container_' + $mdUtil.nextUid();
      selectContainer.attr('id', containerId);
      // Only add aria-owns if element ownership is NOT represented in the DOM.
      if (!element.find('md-select-menu').length) {
        ariaAttrs['aria-owns'] = containerId;
      }
      element.attr(ariaAttrs);

      scope.$on('$destroy', function() {
        $mdSelect
          .destroy()
          .finally(function() {
            if (containerCtrl) {
              containerCtrl.setFocused(false);
              containerCtrl.setHasValue(false);
              containerCtrl.input = null;
            }
            ngModelCtrl.$setTouched();
          });
      });



      function inputCheckValue() {
        // The select counts as having a value if one or more options are selected,
        // or if the input's validity state says it has bad input (eg string in a number input)
        containerCtrl && containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length > 0 || (element[0].validity || {}).badInput);
      }

      function findSelectContainer() {
        selectContainer = angular.element(
          element[0].querySelector('.md-select-menu-container')
        );
        selectScope = scope;
        if (attr.mdContainerClass) {
          var value = selectContainer[0].getAttribute('class') + ' ' + attr.mdContainerClass;
          selectContainer[0].setAttribute('class', value);
        }
        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
        selectMenuCtrl.init(ngModelCtrl, attr.ngModel);
        element.on('$destroy', function() {
          selectContainer.remove();
        });
      }

      function handleKeypress(e) {
        if ($mdConstant.isNavigationKey(e)) {
          // prevent page scrolling on interaction
          e.preventDefault();
          openSelect(e);
        } else {
          if (shouldHandleKey(e, $mdConstant)) {
            e.preventDefault();

            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
            if (!node || node.hasAttribute('disabled')) return;
            var optionCtrl = angular.element(node).controller('mdOption');
            if (!selectMenuCtrl.isMultiple) {
              selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
            }
            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
            selectMenuCtrl.refreshViewValue();
          }
        }
      }

      function openSelect() {
        selectScope._mdSelectIsOpen = true;
        element.attr('aria-expanded', 'true');

        $mdSelect.show({
          scope: selectScope,
          preserveScope: true,
          skipCompile: true,
          element: selectContainer,
          target: element[0],
          selectCtrl: mdSelectCtrl,
          preserveElement: true,
          hasBackdrop: true,
          loadingAsync: attr.mdOnOpen ? scope.$eval(attr.mdOnOpen) || true : false
        }).finally(function() {
          selectScope._mdSelectIsOpen = false;
          element.focus();
          element.attr('aria-expanded', 'false');
          ngModelCtrl.$setTouched();
        });
      }

    };
  }
}

function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
  // We want the scope to be set to 'false' so an isolated scope is not created
  // which would interfere with the md-select-header's access to the
  // parent scope.
  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
  return {
    restrict: 'E',
    require: ['mdSelectMenu'],
    scope: false,
    controller: SelectMenuController,
    link: {pre: preLink}
  };

  // We use preLink instead of postLink to ensure that the select is initialized before
  // its child options run postLink.
  function preLink(scope, element, attr, ctrls) {
    var selectCtrl = ctrls[0];

    element.addClass('_md');     // private md component indicator for styling

    $mdTheming(element);
    element.on('click', clickListener);
    element.on('keypress', keyListener);

    function keyListener(e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        clickListener(e);
      }
    }

    function clickListener(ev) {
      var option = $mdUtil.getClosest(ev.target, 'md-option');
      var optionCtrl = option && angular.element(option).data('$mdOptionController');
      if (!option || !optionCtrl) return;
      if (option.hasAttribute('disabled')) {
        ev.stopImmediatePropagation();
        return false;
      }

      var optionHashKey = selectCtrl.hashGetter(optionCtrl.value);
      var isSelected = angular.isDefined(selectCtrl.selected[optionHashKey]);

      scope.$apply(function() {
        if (selectCtrl.isMultiple) {
          if (isSelected) {
            selectCtrl.deselect(optionHashKey);
          } else {
            selectCtrl.select(optionHashKey, optionCtrl.value);
          }
        } else {
          if (!isSelected) {
            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
            selectCtrl.select(optionHashKey, optionCtrl.value);
          }
        }
        selectCtrl.refreshViewValue();
      });
    }
  }

  function SelectMenuController($scope, $attrs, $element) {
    var self = this;
    self.isMultiple = angular.isDefined($attrs.multiple);
    // selected is an object with keys matching all of the selected options' hashed values
    self.selected = {};
    // options is an object with keys matching every option's hash value,
    // and values matching every option's controller.
    self.options = {};

    $scope.$watchCollection(function() {
      return self.options;
    }, function() {
      self.ngModel.$render();
    });

    var deregisterCollectionWatch;
    var defaultIsEmpty;
    self.setMultiple = function(isMultiple) {
      var ngModel = self.ngModel;
      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;

      self.isMultiple = isMultiple;
      if (deregisterCollectionWatch) deregisterCollectionWatch();

      if (self.isMultiple) {
        ngModel.$validators['md-multiple'] = validateArray;
        ngModel.$render = renderMultiple;

        // watchCollection on the model because by default ngModel only watches the model's
        // reference. This allowed the developer to also push and pop from their array.
        $scope.$watchCollection(self.modelBinding, function(value) {
          if (validateArray(value)) renderMultiple(value);
          self.ngModel.$setPristine();
        });

        ngModel.$isEmpty = function(value) {
          return !value || value.length === 0;
        };
      } else {
        delete ngModel.$validators['md-multiple'];
        ngModel.$render = renderSingular;
      }

      function validateArray(modelValue, viewValue) {
        // If a value is truthy but not an array, reject it.
        // If value is undefined/falsy, accept that it's an empty array.
        return angular.isArray(modelValue || viewValue || []);
      }
    };

    var searchStr = '';
    var clearSearchTimeout, optNodes, optText;
    var CLEAR_SEARCH_AFTER = 300;

    self.optNodeForKeyboardSearch = function(e) {
      clearSearchTimeout && clearTimeout(clearSearchTimeout);
      clearSearchTimeout = setTimeout(function() {
        clearSearchTimeout = undefined;
        searchStr = '';
        optText = undefined;
        optNodes = undefined;
      }, CLEAR_SEARCH_AFTER);

      // Support 1-9 on numpad
      var keyCode = e.keyCode - ($mdConstant.isNumPadKey(e) ? 48 : 0);

      searchStr += String.fromCharCode(keyCode);
      var search = new RegExp('^' + searchStr, 'i');
      if (!optNodes) {
        optNodes = $element.find('md-option');
        optText = new Array(optNodes.length);
        angular.forEach(optNodes, function(el, i) {
          optText[i] = el.textContent.trim();
        });
      }
      for (var i = 0; i < optText.length; ++i) {
        if (search.test(optText[i])) {
          return optNodes[i];
        }
      }
    };

    self.init = function(ngModel, binding) {
      self.ngModel = ngModel;
      self.modelBinding = binding;

      // Setup a more robust version of isEmpty to ensure value is a valid option
      self.ngModel.$isEmpty = function($viewValue) {
        // We have to transform the viewValue into the hashKey, because otherwise the
        // OptionCtrl may not exist. Developers may have specified a trackBy function.
        return !self.options[self.hashGetter($viewValue)];
      };

      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
      // that we can properly compare objects set on the model to the available options
      var trackByOption = $mdUtil.getModelOption(ngModel, 'trackBy');

      if (trackByOption) {
        var trackByLocals = {};
        var trackByParsed = $parse(trackByOption);
        self.hashGetter = function(value, valueScope) {
          trackByLocals.$value = value;
          return trackByParsed(valueScope || $scope, trackByLocals);
        };
        // If the user doesn't provide a trackBy, we automatically generate an id for every
        // value passed in
      } else {
        self.hashGetter = function getHashValue(value) {
          if (angular.isObject(value)) {
            return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
          }
          return value;
        };
      }
      self.setMultiple(self.isMultiple);
    };

    self.selectedLabels = function(opts) {
      opts = opts || {};
      var mode = opts.mode || 'html';
      var selectedOptionEls = $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
      if (selectedOptionEls.length) {
        var mapFn;

        if (mode == 'html') {
          // Map the given element to its innerHTML string. If the element has a child ripple
          // container remove it from the HTML string, before returning the string.
          mapFn = function(el) {
            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears the select
            if (el.hasAttribute('md-option-empty')) {
              return '';
            }

            var html = el.innerHTML;

            // Remove the ripple container from the selected option, copying it would cause a CSP violation.
            var rippleContainer = el.querySelector('.md-ripple-container');
            if (rippleContainer) {
              html = html.replace(rippleContainer.outerHTML, '');
            }

            // Remove the checkbox container, because it will cause the label to wrap inside of the placeholder.
            // It should be not displayed inside of the label element.
            var checkboxContainer = el.querySelector('.md-container');
            if (checkboxContainer) {
              html = html.replace(checkboxContainer.outerHTML, '');
            }

            return html;
          };
        } else if (mode == 'aria') {
          mapFn = function(el) { return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent; };
        }

        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
      } else {
        return '';
      }
    };

    self.select = function(hashKey, hashedValue) {
      var option = self.options[hashKey];
      option && option.setSelected(true);
      self.selected[hashKey] = hashedValue;
    };
    self.deselect = function(hashKey) {
      var option = self.options[hashKey];
      option && option.setSelected(false);
      delete self.selected[hashKey];
    };

    self.addOption = function(hashKey, optionCtrl) {
      if (angular.isDefined(self.options[hashKey])) {
        throw new Error('Duplicate md-option values are not allowed in a select. ' +
          'Duplicate value "' + optionCtrl.value + '" found.');
      }

      self.options[hashKey] = optionCtrl;

      // If this option's value was already in our ngModel, go ahead and select it.
      if (angular.isDefined(self.selected[hashKey])) {
        self.select(hashKey, optionCtrl.value);

        // When the current $modelValue of the ngModel Controller is using the same hash as
        // the current option, which will be added, then we can be sure, that the validation
        // of the option has occurred before the option was added properly.
        // This means, that we have to manually trigger a new validation of the current option.
        if (angular.isDefined(self.ngModel.$modelValue) && self.hashGetter(self.ngModel.$modelValue) === hashKey) {
          self.ngModel.$validate();
        }

        self.refreshViewValue();
      }
    };
    self.removeOption = function(hashKey) {
      delete self.options[hashKey];
      // Don't deselect an option when it's removed - the user's ngModel should be allowed
      // to have values that do not match a currently available option.
    };

    self.refreshViewValue = function() {
      var values = [];
      var option;
      for (var hashKey in self.selected) {
        // If this hashKey has an associated option, push that option's value to the model.
        if ((option = self.options[hashKey])) {
          values.push(option.value);
        } else {
          // Otherwise, the given hashKey has no associated option, and we got it
          // from an ngModel value at an earlier time. Push the unhashed value of
          // this hashKey to the model.
          // This allows the developer to put a value in the model that doesn't yet have
          // an associated option.
          values.push(self.selected[hashKey]);
        }
      }
      var usingTrackBy = $mdUtil.getModelOption(self.ngModel, 'trackBy');

      var newVal = self.isMultiple ? values : values[0];
      var prevVal = self.ngModel.$modelValue;

      if (usingTrackBy ? !angular.equals(prevVal, newVal) : (prevVal + '') !== newVal) {
        self.ngModel.$setViewValue(newVal);
        self.ngModel.$render();
      }
    };

    function renderMultiple() {
      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
      if (!angular.isArray(newSelectedValues)) return;

      var oldSelected = Object.keys(self.selected);

      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
      var deselected = oldSelected.filter(function(hash) {
        return newSelectedHashes.indexOf(hash) === -1;
      });

      deselected.forEach(self.deselect);
      newSelectedHashes.forEach(function(hashKey, i) {
        self.select(hashKey, newSelectedValues[i]);
      });
    }

    function renderSingular() {
      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
      Object.keys(self.selected).forEach(self.deselect);
      self.select(self.hashGetter(value), value);
    }
  }

}

function OptionDirective($mdButtonInkRipple, $mdUtil, $mdTheming) {

  OptionController.$inject = ["$element"];
  return {
    restrict: 'E',
    require: ['mdOption', '^^mdSelectMenu'],
    controller: OptionController,
    compile: compile
  };

  function compile(element, attr) {
    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
    element.append(angular.element('<div class="md-text">').append(element.contents()));

    element.attr('tabindex', attr.tabindex || '0');

    if (!hasDefinedValue(attr)) {
      element.attr('md-option-empty', '');
    }

    return postLink;
  }

  function hasDefinedValue(attr) {
    var value = attr.value;
    var ngValue = attr.ngValue;

    return value || ngValue;
  }

  function postLink(scope, element, attr, ctrls) {
    var optionCtrl = ctrls[0];
    var selectCtrl = ctrls[1];

    $mdTheming(element);

    if (selectCtrl.isMultiple) {
      element.addClass('md-checkbox-enabled');
      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
    }

    if (angular.isDefined(attr.ngValue)) {
      scope.$watch(attr.ngValue, setOptionValue);
    } else if (angular.isDefined(attr.value)) {
      setOptionValue(attr.value);
    } else {
      scope.$watch(function() {
        return element.text().trim();
      }, setOptionValue);
    }

    attr.$observe('disabled', function(disabled) {
      if (disabled) {
        element.attr('tabindex', '-1');
      } else {
        element.attr('tabindex', '0');
      }
    });

    scope.$$postDigest(function() {
      attr.$observe('selected', function(selected) {
        if (!angular.isDefined(selected)) return;
        if (typeof selected == 'string') selected = true;
        if (selected) {
          if (!selectCtrl.isMultiple) {
            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
          }
          selectCtrl.select(optionCtrl.hashKey, optionCtrl.value);
        } else {
          selectCtrl.deselect(optionCtrl.hashKey);
        }
        selectCtrl.refreshViewValue();
      });
    });

    $mdButtonInkRipple.attach(scope, element);
    configureAria();

    function setOptionValue(newValue, oldValue, prevAttempt) {
      if (!selectCtrl.hashGetter) {
        if (!prevAttempt) {
          scope.$$postDigest(function() {
            setOptionValue(newValue, oldValue, true);
          });
        }
        return;
      }
      var oldHashKey = selectCtrl.hashGetter(oldValue, scope);
      var newHashKey = selectCtrl.hashGetter(newValue, scope);

      optionCtrl.hashKey = newHashKey;
      optionCtrl.value = newValue;

      selectCtrl.removeOption(oldHashKey, optionCtrl);
      selectCtrl.addOption(newHashKey, optionCtrl);
    }

    scope.$on('$destroy', function() {
      selectCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
    });

    function configureAria() {
      var ariaAttrs = {
        'role': 'option',
        'aria-selected': 'false'
      };

      if (!element[0].hasAttribute('id')) {
        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
      }
      element.attr(ariaAttrs);
    }
  }

  function OptionController($element) {
    this.selected = false;
    this.setSelected = function(isSelected) {
      if (isSelected && !this.selected) {
        $element.attr({
          'selected': 'selected',
          'aria-selected': 'true'
        });
      } else if (!isSelected && this.selected) {
        $element.removeAttr('selected');
        $element.attr('aria-selected', 'false');
      }
      this.selected = isSelected;
    };
  }

}

function OptgroupDirective() {
  return {
    restrict: 'E',
    compile: compile
  };
  function compile(el, attrs) {
    // If we have a select header element, we don't want to add the normal label
    // header.
    if (!hasSelectHeader()) {
      setupLabelElement();
    }

    function hasSelectHeader() {
      return el.parent().find('md-select-header').length;
    }

    function setupLabelElement() {
      var labelElement = el.find('label');
      if (!labelElement.length) {
        labelElement = angular.element('<label>');
        el.prepend(labelElement);
      }
      labelElement.addClass('md-container-ignore');
      labelElement.attr('aria-hidden', 'true');
      if (attrs.label) labelElement.text(attrs.label);
    }
  }
}

function SelectHeaderDirective() {
  return {
    restrict: 'E',
  };
}

function SelectProvider($$interimElementProvider) {
  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
  return $$interimElementProvider('$mdSelect')
    .setDefaults({
      methods: ['target'],
      options: selectDefaultOptions
    });

  /* @ngInject */
  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
    var animator = $mdUtil.dom.animator;
    var keyCodes = $mdConstant.KEY_CODE;

    return {
      parent: 'body',
      themable: true,
      onShow: onShow,
      onRemove: onRemove,
      hasBackdrop: true,
      disableParentScroll: true
    };

    /**
     * Interim-element onRemove logic....
     */
    function onRemove(scope, element, opts) {
      var animationRunner = null;
      var destroyListener = scope.$on('$destroy', function() {
        // Listen for the case where the element was destroyed while there was an
        // ongoing close animation. If this happens, we need to end the animation
        // manually.
        animationRunner.end();
      });

      opts = opts || { };
      opts.cleanupInteraction();
      opts.cleanupResizing();
      opts.hideBackdrop();

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal
      return (opts.$destroy === true) ? cleanElement() : animateRemoval().then(cleanElement);

      /**
       * For normal closes (eg clicks), animate the removal.
       * For forced closes (like $destroy events from navigation),
       * skip the animations
       */
      function animateRemoval() {
        animationRunner = $animateCss(element, {addClass: 'md-leave'});
        return animationRunner.start();
      }

      /**
       * Restore the element to a closed state
       */
      function cleanElement() {
        destroyListener();

        element
          .removeClass('md-active')
          .attr('aria-hidden', 'true')
          .css('display', 'none');
        element.parent().find('md-select-value').removeAttr('aria-hidden');

        announceClosed(opts);

        if (!opts.$destroy && opts.restoreFocus) {
          opts.target.focus();
        }
      }

    }

    /**
     * Interim-element onShow logic....
     */
    function onShow(scope, element, opts) {

      watchAsyncLoad();
      sanitizeAndConfigure(scope, opts);

      opts.hideBackdrop = showBackdrop(scope, element, opts);

      return showDropDown(scope, element, opts)
        .then(function(response) {
          element.attr('aria-hidden', 'false');
          opts.alreadyOpen = true;
          opts.cleanupInteraction = activateInteraction();
          opts.cleanupResizing = activateResizing();
          autoFocus(opts.focusedNode);

          return response;
        }, opts.hideBackdrop);

      // ************************************
      // Closure Functions
      // ************************************

      /**
       *  Attach the select DOM element(s) and animate to the correct positions
       *  and scalings...
       */
      function showDropDown(scope, element, opts) {
        if (opts.parent !== element.parent()) {
          element.parent().attr('aria-owns', element.attr('id'));
        }
        element.parent().find('md-select-value').attr('aria-hidden', 'true');

        opts.parent.append(element);

        return $q(function(resolve, reject) {

          try {

            $animateCss(element, {removeClass: 'md-leave', duration: 0})
              .start()
              .then(positionAndFocusMenu)
              .then(resolve);

          } catch (e) {
            reject(e);
          }

        });
      }

      /**
       * Initialize container and dropDown menu positions/scale, then animate
       * to show.
       */
      function positionAndFocusMenu() {
        return $q(function(resolve) {
          if (opts.isRemoved) return $q.reject(false);

          var info = calculateMenuPositions(scope, element, opts);

          info.container.element.css(animator.toCss(info.container.styles));
          info.dropDown.element.css(animator.toCss(info.dropDown.styles));

          $$rAF(function() {
            element.addClass('md-active');
            info.dropDown.element.css(animator.toCss({transform: ''}));

            resolve();
          });

        });
      }

      /**
       * Show modal backdrop element...
       */
      function showBackdrop(scope, element, options) {

        // If we are not within a dialog...
        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
          // !! DO this before creating the backdrop; since disableScrollAround()
          //    configures the scroll offset; which is used by mdBackDrop postLink()
          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
        } else {
          options.disableParentScroll = false;
        }

        if (options.hasBackdrop) {
          // Override duration to immediately show invisible backdrop
          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
        }

        /**
         * Hide modal backdrop element...
         */
        return function hideBackdrop() {
          if (options.backdrop) options.backdrop.remove();
          if (options.disableParentScroll) options.restoreScroll();

          delete options.restoreScroll;
        };
      }

      /**
       *
       */
      function autoFocus(focusedNode) {
        if (focusedNode && !focusedNode.hasAttribute('disabled')) {
          focusedNode.focus();
        }
      }

      /**
       * Check for valid opts and set some sane defaults
       */
      function sanitizeAndConfigure(scope, options) {
        var selectEl = element.find('md-select-menu');

        if (!options.target) {
          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
        }

        angular.extend(options, {
          isRemoved: false,
          target: angular.element(options.target), //make sure it's not a naked dom node
          parent: angular.element(options.parent),
          selectEl: selectEl,
          contentEl: element.find('md-content'),
          optionNodes: selectEl[0].getElementsByTagName('md-option')
        });
      }

      /**
       * Configure various resize listeners for screen changes
       */
      function activateResizing() {
        var debouncedOnResize = (function(scope, target, options) {

          return function() {
            if (options.isRemoved) return;

            var updates = calculateMenuPositions(scope, target, options);
            var container = updates.container;
            var dropDown = updates.dropDown;

            container.element.css(animator.toCss(container.styles));
            dropDown.element.css(animator.toCss(dropDown.styles));
          };

        })(scope, element, opts);

        var window = angular.element($window);
        window.on('resize', debouncedOnResize);
        window.on('orientationchange', debouncedOnResize);

        // Publish deactivation closure...
        return function deactivateResizing() {

          // Disable resizing handlers
          window.off('resize', debouncedOnResize);
          window.off('orientationchange', debouncedOnResize);
        };
      }

      /**
       *  If asynchronously loading, watch and update internal
       *  '$$loadingAsyncDone' flag
       */
      function watchAsyncLoad() {
        if (opts.loadingAsync && !opts.isRemoved) {
          scope.$$loadingAsyncDone = false;

          $q.when(opts.loadingAsync)
            .then(function() {
              scope.$$loadingAsyncDone = true;
              delete opts.loadingAsync;
            }).then(function() {
              $$rAF(positionAndFocusMenu);
            });
        }
      }

      /**
       *
       */
      function activateInteraction() {
        if (opts.isRemoved) return;

        var dropDown = opts.selectEl;
        var selectCtrl = dropDown.controller('mdSelectMenu') || {};

        element.addClass('md-clickable');

        // Close on backdrop click
        opts.backdrop && opts.backdrop.on('click', onBackdropClick);

        // Escape to close
        // Cycling of options, and closing on enter
        dropDown.on('keydown', onMenuKeyDown);
        dropDown.on('click', checkCloseMenu);

        return function cleanupInteraction() {
          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
          dropDown.off('keydown', onMenuKeyDown);
          dropDown.off('click', checkCloseMenu);

          element.removeClass('md-clickable');
          opts.isRemoved = true;
        };

        // ************************************
        // Closure Functions
        // ************************************

        function onBackdropClick(e) {
          e.preventDefault();
          e.stopPropagation();
          opts.restoreFocus = false;
          $mdUtil.nextTick($mdSelect.hide, true);
        }

        function onMenuKeyDown(ev) {
          ev.preventDefault();
          ev.stopPropagation();

          switch (ev.keyCode) {
            case keyCodes.UP_ARROW:
              return focusPrevOption();
            case keyCodes.DOWN_ARROW:
              return focusNextOption();
            case keyCodes.SPACE:
            case keyCodes.ENTER:
              var option = $mdUtil.getClosest(ev.target, 'md-option');
              if (option) {
                dropDown.triggerHandler({
                  type: 'click',
                  target: option
                });
                ev.preventDefault();
              }
              checkCloseMenu(ev);
              break;
            case keyCodes.TAB:
            case keyCodes.ESCAPE:
              ev.stopPropagation();
              ev.preventDefault();
              opts.restoreFocus = true;
              $mdUtil.nextTick($mdSelect.hide, true);
              break;
            default:
              if (shouldHandleKey(ev, $mdConstant)) {
                var optNode = dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);
                opts.focusedNode = optNode || opts.focusedNode;
                optNode && optNode.focus();
              }
          }
        }

        function focusOption(direction) {
          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
          var index = optionsArray.indexOf(opts.focusedNode);

          var newOption;

          do {
            if (index === -1) {
              // We lost the previously focused element, reset to first option
              index = 0;
            } else if (direction === 'next' && index < optionsArray.length - 1) {
              index++;
            } else if (direction === 'prev' && index > 0) {
              index--;
            }
            newOption = optionsArray[index];
            if (newOption.hasAttribute('disabled')) newOption = undefined;
          } while (!newOption && index < optionsArray.length - 1 && index > 0);

          newOption && newOption.focus();
          opts.focusedNode = newOption;
        }

        function focusNextOption() {
          focusOption('next');
        }

        function focusPrevOption() {
          focusOption('prev');
        }

        function checkCloseMenu(ev) {
          if (ev && ( ev.type == 'click') && (ev.currentTarget != dropDown[0])) return;
          if ( mouseOnScrollbar() ) return;

          var option = $mdUtil.getClosest(ev.target, 'md-option');
          if (option && option.hasAttribute && !option.hasAttribute('disabled')) {
            ev.preventDefault();
            ev.stopPropagation();
            if (!selectCtrl.isMultiple) {
              opts.restoreFocus = true;

              $mdUtil.nextTick(function () {
                $mdSelect.hide(selectCtrl.ngModel.$viewValue);
              }, true);
            }
          }
          /**
           * check if the mouseup event was on a scrollbar
           */
          function mouseOnScrollbar() {
            var clickOnScrollbar = false;
            if (ev && (ev.currentTarget.children.length > 0)) {
              var child = ev.currentTarget.children[0];
              var hasScrollbar = child.scrollHeight > child.clientHeight;
              if (hasScrollbar && child.children.length > 0) {
                var relPosX = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
                if (relPosX > child.querySelector('md-option').offsetWidth)
                  clickOnScrollbar = true;
              }
            }
            return clickOnScrollbar;
          }
        }
      }

    }

    /**
     * To notify listeners that the Select menu has closed,
     * trigger the [optional] user-defined expression
     */
    function announceClosed(opts) {
      var mdSelect = opts.selectCtrl;
      if (mdSelect) {
        var menuController = opts.selectEl.controller('mdSelectMenu');
        mdSelect.setLabelText(menuController ? menuController.selectedLabels() : '');
        mdSelect.triggerClose();
      }
    }


    /**
     * Calculate the
     */
    function calculateMenuPositions(scope, element, opts) {
      var
        containerNode = element[0],
        targetNode = opts.target[0].children[0], // target the label
        parentNode = $document[0].body,
        selectNode = opts.selectEl[0],
        contentNode = opts.contentEl[0],
        parentRect = parentNode.getBoundingClientRect(),
        targetRect = targetNode.getBoundingClientRect(),
        shouldOpenAroundTarget = false,
        bounds = {
          left: parentRect.left + SELECT_EDGE_MARGIN,
          top: SELECT_EDGE_MARGIN,
          bottom: parentRect.height - SELECT_EDGE_MARGIN,
          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
        },
        spaceAvailable = {
          top: targetRect.top - bounds.top,
          left: targetRect.left - bounds.left,
          right: bounds.right - (targetRect.left + targetRect.width),
          bottom: bounds.bottom - (targetRect.top + targetRect.height)
        },
        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
        selectedNode = selectNode.querySelector('md-option[selected]'),
        optionNodes = selectNode.getElementsByTagName('md-option'),
        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
        isScrollable = calculateScrollable(element, contentNode),
        centeredNode;

      var loading = isPromiseLike(opts.loadingAsync);
      if (!loading) {
        // If a selected node, center around that
        if (selectedNode) {
          centeredNode = selectedNode;
          // If there are option groups, center around the first option group
        } else if (optgroupNodes.length) {
          centeredNode = optgroupNodes[0];
          // Otherwise - if we are not loading async - center around the first optionNode
        } else if (optionNodes.length) {
          centeredNode = optionNodes[0];
          // In case there are no options, center on whatever's in there... (eg progress indicator)
        } else {
          centeredNode = contentNode.firstElementChild || contentNode;
        }
      } else {
        // If loading, center on progress indicator
        centeredNode = contentNode.firstElementChild || contentNode;
      }

      if (contentNode.offsetWidth > maxWidth) {
        contentNode.style['max-width'] = maxWidth + 'px';
      } else {
        contentNode.style.maxWidth = null;
      }
      if (shouldOpenAroundTarget) {
        contentNode.style['min-width'] = targetRect.width + 'px';
      }

      // Remove padding before we compute the position of the menu
      if (isScrollable) {
        selectNode.classList.add('md-overflow');
      }

      var focusedNode = centeredNode;
      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
        centeredNode = focusedNode;
      }
      // Cache for autoFocus()
      opts.focusedNode = focusedNode;

      // Get the selectMenuRect *after* max-width is possibly set above
      containerNode.style.display = 'block';
      var selectMenuRect = selectNode.getBoundingClientRect();
      var centeredRect = getOffsetRect(centeredNode);

      if (centeredNode) {
        var centeredStyle = $window.getComputedStyle(centeredNode);
        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
      }

      if (isScrollable) {
        var scrollBuffer = contentNode.offsetHeight / 2;
        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;

        if (spaceAvailable.top < scrollBuffer) {
          contentNode.scrollTop = Math.min(
            centeredRect.top,
            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
          );
        } else if (spaceAvailable.bottom < scrollBuffer) {
          contentNode.scrollTop = Math.max(
            centeredRect.top + centeredRect.height - selectMenuRect.height,
            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
          );
        }
      }

      var left, top, transformOrigin, minWidth, fontSize;
      if (shouldOpenAroundTarget) {
        left = targetRect.left;
        top = targetRect.top + targetRect.height;
        transformOrigin = '50% 0';
        if (top + selectMenuRect.height > bounds.bottom) {
          top = targetRect.top - selectMenuRect.height;
          transformOrigin = '50% 100%';
        }
      } else {
        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
            centeredRect.top + contentNode.scrollTop) + 2;

        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';

        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);

        fontSize = window.getComputedStyle(targetNode)['font-size'];
      }

      // Keep left and top within the window
      var containerRect = containerNode.getBoundingClientRect();
      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;

      return {
        container: {
          element: angular.element(containerNode),
          styles: {
            left: Math.floor(clamp(bounds.left, left, bounds.right - containerRect.width)),
            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
            'min-width': minWidth,
            'font-size': fontSize
          }
        },
        dropDown: {
          element: angular.element(selectNode),
          styles: {
            transformOrigin: transformOrigin,
            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
          }
        }
      };

    }

  }

  function isPromiseLike(obj) {
    return obj && angular.isFunction(obj.then);
  }

  function clamp(min, n, max) {
    return Math.max(min, Math.min(n, max));
  }

  function getOffsetRect(node) {
    return node ? {
      left: node.offsetLeft,
      top: node.offsetTop,
      width: node.offsetWidth,
      height: node.offsetHeight
    } : {left: 0, top: 0, width: 0, height: 0};
  }

  function calculateScrollable(element, contentNode) {
    var isScrollable = false;

    try {
      var oldDisplay = element[0].style.display;

      // Set the element's display to block so that this calculation is correct
      element[0].style.display = 'block';

      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;

      // Reset it back afterwards
      element[0].style.display = oldDisplay;
    } finally {
      // Nothing to do
    }
    return isScrollable;
  }

}

function shouldHandleKey(ev, $mdConstant) {
  var char = String.fromCharCode(ev.keyCode);
  var isNonUsefulKey = (ev.keyCode <= 31);

  return (char && char.length && !isNonUsefulKey &&
    !$mdConstant.isMetaKey(ev) && !$mdConstant.isFnLockKey(ev) && !$mdConstant.hasModifierKey(ev));
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.showHide
 */

// Add additional handlers to ng-show and ng-hide that notify directives
// contained within that they should recompute their size.
// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
angular.module('material.components.showHide', [
  'material.core'
])
  .directive('ngShow', createDirective('ngShow', true))
  .directive('ngHide', createDirective('ngHide', false));


function createDirective(name, targetValue) {
  return ['$mdUtil', '$window', function($mdUtil, $window) {
    return {
      restrict: 'A',
      multiElement: true,
      link: function($scope, $element, $attr) {
        var unregister = $scope.$on('$md-resize-enable', function() {
          unregister();

          var node = $element[0];
          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
            $window.getComputedStyle(node) : {};

          $scope.$watch($attr[name], function(value) {
            if (!!value === targetValue) {
              $mdUtil.nextTick(function() {
                $scope.$broadcast('$md-resize');
              });

              var opts = {
                cachedTransitionStyles: cachedTransitionStyles
              };

              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
                $scope.$broadcast('$md-resize');
              });
            }
          });
        });
      }
    };
  }];
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.sidenav
 *
 * @description
 * A Sidenav QP component.
 */
SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$mdInteraction", "$animate", "$compile", "$parse", "$log", "$q", "$document", "$window", "$$rAF"];
SidenavController.$inject = ["$scope", "$attrs", "$mdComponentRegistry", "$q", "$interpolate"];
angular
  .module('material.components.sidenav', [
    'material.core',
    'material.components.backdrop'
  ])
  .factory('$mdSidenav', SidenavService )
  .directive('mdSidenav', SidenavDirective)
  .directive('mdSidenavFocus', SidenavFocusDirective)
  .controller('$mdSidenavController', SidenavController);


/**
 * @ngdoc service
 * @name $mdSidenav
 * @module material.components.sidenav
 *
 * @description
 * `$mdSidenav` makes it easy to interact with multiple sidenavs
 * in an app. When looking up a sidenav instance, you can either look
 * it up synchronously or wait for it to be initializied asynchronously.
 * This is done by passing the second argument to `$mdSidenav`.
 *
 * @usage
 * <hljs lang="js">
 * // Async lookup for sidenav instance; will resolve when the instance is available
 * $mdSidenav(componentId, true).then(function(instance) {
 *   $log.debug( componentId + "is now ready" );
 * });
 * // Sync lookup for sidenav instance; this will resolve immediately.
 * $mdSidenav(componentId).then(function(instance) {
 *   $log.debug( componentId + "is now ready" );
 * });
 * // Async toggle the given sidenav;
 * // when instance is known ready and lazy lookup is not needed.
 * $mdSidenav(componentId)
 *    .toggle()
 *    .then(function(){
 *      $log.debug('toggled');
 *    });
 * // Async open the given sidenav
 * $mdSidenav(componentId)
 *    .open()
 *    .then(function(){
 *      $log.debug('opened');
 *    });
 * // Async close the given sidenav
 * $mdSidenav(componentId)
 *    .close()
 *    .then(function(){
 *      $log.debug('closed');
 *    });
 * // Sync check to see if the specified sidenav is set to be open
 * $mdSidenav(componentId).isOpen();
 * // Sync check to whether given sidenav is locked open
 * // If this is true, the sidenav will be open regardless of close()
 * $mdSidenav(componentId).isLockedOpen();
 * // On close callback to handle close, backdrop click or escape key pressed
 * // Callback happens BEFORE the close action occurs.
 * $mdSidenav(componentId).onClose(function () {
 *   $log.debug('closing');
 * });
 * </hljs>
 */
function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
  var service = {
        find    : findInstance,     //  sync  - returns proxy API
        waitFor : waitForInstance   //  async - returns promise
      };

  /**
   * Service API that supports three (3) usages:
   *   $mdSidenav().find("left")                       // sync (must already exist) or returns undefined
   *   $mdSidenav("left").toggle();                    // sync (must already exist) or returns reject promise;
   *   $mdSidenav("left",true).then( function(left){   // async returns instance when available
   *    left.toggle();
   *   });
   */
  return function(handle, enableWait) {
    if ( angular.isUndefined(handle) ) return service;

    var shouldWait = enableWait === true;
    var instance = service.find(handle, shouldWait);
    return  !instance && shouldWait ? service.waitFor(handle) :
            !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
  };

  /**
   * For failed instance/handle lookups, older-clients expect an response object with noops
   * that include `rejected promise APIs`
   */
  function addLegacyAPI(service, handle) {
      var falseFn  = function() { return false; };
      var rejectFn = function() {
            return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
          };

      return angular.extend({
        isLockedOpen : falseFn,
        isOpen       : falseFn,
        toggle       : rejectFn,
        open         : rejectFn,
        close        : rejectFn,
        onClose      : angular.noop,
        then : function(callback) {
          return waitForInstance(handle)
            .then(callback || angular.noop);
        }
       }, service);
    }
    /**
     * Synchronously lookup the controller instance for the specified sidNav instance which has been
     * registered with the markup `md-component-id`
     */
    function findInstance(handle, shouldWait) {
      var instance = $mdComponentRegistry.get(handle);

      if (!instance && !shouldWait) {

        // Report missing instance
        $log.error( $mdUtil.supplant(errorMsg, [handle || ""]) );

        // The component has not registered itself... most like NOT yet created
        // return null to indicate that the Sidenav is not in the DOM
        return undefined;
      }
      return instance;
    }

    /**
     * Asynchronously wait for the component instantiation,
     * Deferred lookup of component instance using $component registry
     */
    function waitForInstance(handle) {
      return $mdComponentRegistry.when(handle).catch($log.error);
    }
}
/**
 * @ngdoc directive
 * @name mdSidenavFocus
 * @module material.components.sidenav
 *
 * @restrict A
 *
 * @description
 * `mdSidenavFocus` provides a way to specify the focused element when a sidenav opens.
 * This is completely optional, as the sidenav itself is focused by default.
 *
 * @usage
 * <hljs lang="html">
 * <md-sidenav>
 *   <form>
 *     <md-input-container>
 *       <label for="testInput">Label</label>
 *       <input id="testInput" type="text" md-sidenav-focus>
 *     </md-input-container>
 *   </form>
 * </md-sidenav>
 * </hljs>
 **/
function SidenavFocusDirective() {
  return {
    restrict: 'A',
    require: '^mdSidenav',
    link: function(scope, element, attr, sidenavCtrl) {
      // @see $mdUtil.findFocusTarget(...)
    }
  };
}
/**
 * @ngdoc directive
 * @name mdSidenav
 * @module material.components.sidenav
 * @restrict E
 *
 * @description
 *
 * A Sidenav component that can be opened and closed programatically.
 *
 * By default, upon opening it will slide out on top of the main content area.
 *
 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
 *
 * @usage
 * <hljs lang="html">
 * <div layout="row" ng-controller="MyController">
 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
 *     Left Nav!
 *   </md-sidenav>
 *
 *   <md-content>
 *     Center Content
 *     <md-button ng-click="openLeftMenu()">
 *       Open Left Menu
 *     </md-button>
 *   </md-content>
 *
 *   <md-sidenav md-component-id="right"
 *     md-is-locked-open="$mdMedia('min-width: 333px')"
 *     class="md-sidenav-right">
 *     <form>
 *       <md-input-container>
 *         <label for="testInput">Test input</label>
 *         <input id="testInput" type="text"
 *                ng-model="data" md-autofocus>
 *       </md-input-container>
 *     </form>
 *   </md-sidenav>
 * </div>
 * </hljs>
 *
 * <hljs lang="js">
 * var app = angular.module('myApp', ['ngMaterial']);
 * app.controller('MyController', function($scope, $mdSidenav) {
 *   $scope.openLeftMenu = function() {
 *     $mdSidenav('left').toggle();
 *   };
 * });
 * </hljs>
 *
 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a backdrop.
 * @param {string=} md-component-id componentId to use with $mdSidenav service.
 * @param {expression=} md-is-locked-open When this expression evaluates to true,
 * the sidenav 'locks open': it falls into the content's flow instead
 * of appearing over it. This overrides the `md-is-open` attribute.
 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
 *
* The $mdMedia() service is exposed to the is-locked-open attribute, which
 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
 * Examples:
 *
 *   - `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
 *   - `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
 *   - `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>` (locks open on small screens)
 */
function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $mdInteraction, $animate,
                          $compile, $parse, $log, $q, $document, $window, $$rAF) {
  return {
    restrict: 'E',
    scope: {
      isOpen: '=?mdIsOpen'
    },
    controller: '$mdSidenavController',
    compile: function(element) {
      element.addClass('md-closed').attr('tabIndex', '-1');
      return postLink;
    }
  };

  /**
   * Directive Post Link function...
   */
  function postLink(scope, element, attr, sidenavCtrl) {
    var lastParentOverFlow;
    var backdrop;
    var disableScrollTarget = null;
    var triggeringInteractionType;
    var triggeringElement = null;
    var previousContainerStyles;
    var promise = $q.when(true);
    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
    var ngWindow = angular.element($window);
    var isLocked = function() {
      return isLockedOpenParsed(scope.$parent, {
        $media: function(arg) {
          $log.warn("$media is deprecated for is-locked-open. Use $mdMedia instead.");
          return $mdMedia(arg);
        },
        $mdMedia: $mdMedia
      });
    };

    if (attr.mdDisableScrollTarget) {
      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);

      if (disableScrollTarget) {
        disableScrollTarget = angular.element(disableScrollTarget);
      } else {
        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
          'selector "{selector}". Falling back to parent.', { selector: attr.mdDisableScrollTarget }));
      }
    }

    if (!disableScrollTarget) {
      disableScrollTarget = element.parent();
    }

    // Only create the backdrop if the backdrop isn't disabled.
    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
    }

    element.addClass('_md');     // private md component indicator for styling
    $mdTheming(element);

    // The backdrop should inherit the sidenavs theme,
    // because the backdrop will take its parent theme by default.
    if ( backdrop ) $mdTheming.inherit(backdrop, element);

    element.on('$destroy', function() {
      backdrop && backdrop.remove();
      sidenavCtrl.destroy();
    });

    scope.$on('$destroy', function(){
      backdrop && backdrop.remove();
    });

    scope.$watch(isLocked, updateIsLocked);
    scope.$watch('isOpen', updateIsOpen);


    // Publish special accessor for the Controller instance
    sidenavCtrl.$toggleOpen = toggleOpen;

    /**
     * Toggle the DOM classes to indicate `locked`
     * @param isLocked
     */
    function updateIsLocked(isLocked, oldValue) {
      scope.isLockedOpen = isLocked;
      if (isLocked === oldValue) {
        element.toggleClass('md-locked-open', !!isLocked);
      } else {
        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
      }
      if (backdrop) {
        backdrop.toggleClass('md-locked-open', !!isLocked);
      }
    }

    /**
     * Toggle the SideNav view and attach/detach listeners
     * @param isOpen
     */
    function updateIsOpen(isOpen) {
      // Support deprecated md-sidenav-focus attribute as fallback
      var focusEl = $mdUtil.findFocusTarget(element) || $mdUtil.findFocusTarget(element,'[md-sidenav-focus]') || element;
      var parent = element.parent();

      parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
      if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);

      var restorePositioning = updateContainerPositions(parent, isOpen);

      if ( isOpen ) {
        // Capture upon opening..
        triggeringElement = $document[0].activeElement;
        triggeringInteractionType = $mdInteraction.getLastInteractionType();
      }

      disableParentScroll(isOpen);

      return promise = $q.all([
        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
                             $animate.leave(backdrop) : $q.when(true),
        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
      ]).then(function() {
        // Perform focus when animations are ALL done...
        if (scope.isOpen) {
          $$rAF(function() {
            // Notifies child components that the sidenav was opened. Should wait
            // a frame in order to allow for the element height to be computed.
            ngWindow.triggerHandler('resize');
          });

          focusEl && focusEl.focus();
        }

        // Restores the positioning on the sidenav and backdrop.
        restorePositioning && restorePositioning();
      });
    }

    function updateContainerPositions(parent, willOpen) {
      var drawerEl = element[0];
      var scrollTop = parent[0].scrollTop;

      if (willOpen && scrollTop) {
        previousContainerStyles = {
          top: drawerEl.style.top,
          bottom: drawerEl.style.bottom,
          height: drawerEl.style.height
        };

        // When the parent is scrolled down, then we want to be able to show the sidenav at the current scroll
        // position. We're moving the sidenav down to the correct scroll position and apply the height of the
        // parent, to increase the performance. Using 100% as height, will impact the performance heavily.
        var positionStyle = {
          top: scrollTop + 'px',
          bottom: 'auto',
          height: parent[0].clientHeight + 'px'
        };

        // Apply the new position styles to the sidenav and backdrop.
        element.css(positionStyle);
        backdrop.css(positionStyle);
      }

      // When the sidenav is closing and we have previous defined container styles,
      // then we return a restore function, which resets the sidenav and backdrop.
      if (!willOpen && previousContainerStyles) {
        return function() {
          drawerEl.style.top = previousContainerStyles.top;
          drawerEl.style.bottom = previousContainerStyles.bottom;
          drawerEl.style.height = previousContainerStyles.height;

          backdrop[0].style.top = null;
          backdrop[0].style.bottom = null;
          backdrop[0].style.height = null;

          previousContainerStyles = null;
        };
      }
    }

    /**
     * Prevent parent scrolling (when the SideNav is open)
     */
    function disableParentScroll(disabled) {
      if ( disabled && !lastParentOverFlow ) {
        lastParentOverFlow = disableScrollTarget.css('overflow');
        disableScrollTarget.css('overflow', 'hidden');
      } else if (angular.isDefined(lastParentOverFlow)) {
        disableScrollTarget.css('overflow', lastParentOverFlow);
        lastParentOverFlow = undefined;
      }
    }

    /**
     * Toggle the sideNav view and publish a promise to be resolved when
     * the view animation finishes.
     *
     * @param isOpen
     * @returns {*}
     */
    function toggleOpen( isOpen ) {
      if (scope.isOpen == isOpen ) {

        return $q.when(true);

      } else {
        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();

        return $q(function(resolve){
          // Toggle value to force an async `updateIsOpen()` to run
          scope.isOpen = isOpen;

          $mdUtil.nextTick(function() {
            // When the current `updateIsOpen()` animation finishes
            promise.then(function(result) {

              if ( !scope.isOpen && triggeringElement && triggeringInteractionType === 'keyboard') {
                // reset focus to originating element (if available) upon close
                triggeringElement.focus();
                triggeringElement = null;
              }

              resolve(result);
            });
          });

        });

      }
    }

    /**
     * Auto-close sideNav when the `escape` key is pressed.
     * @param evt
     */
    function onKeyDown(ev) {
      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
      return isEscape ? close(ev) : $q.when(true);
    }

    /**
     * With backdrop `clicks` or `escape` key-press, immediately
     * apply the CSS close transition... Then notify the controller
     * to close() and perform its own actions.
     */
    function close(ev) {
      ev.preventDefault();

      return sidenavCtrl.close();
    }

  }
}

/*
 * @private
 * @ngdoc controller
 * @name SidenavController
 * @module material.components.sidenav
 */
function SidenavController($scope, $attrs, $mdComponentRegistry, $q, $interpolate) {

  var self = this;

  // Use Default internal method until overridden by directive postLink

  // Synchronous getters
  self.isOpen = function() { return !!$scope.isOpen; };
  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };

  // Synchronous setters
  self.onClose = function (callback) {
    self.onCloseCb = callback;
    return self;
  };

  // Async actions
  self.open   = function() { return self.$toggleOpen( true );  };
  self.close  = function() { return self.$toggleOpen( false ); };
  self.toggle = function() { return self.$toggleOpen( !$scope.isOpen );  };
  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };

  // Evaluate the component id.
  var rawId = $attrs.mdComponentId;
  var hasDataBinding = rawId && rawId.indexOf($interpolate.startSymbol()) > -1;
  var componentId = hasDataBinding ? $interpolate(rawId)($scope.$parent) : rawId;

  // Register the component.
  self.destroy = $mdComponentRegistry.register(self, componentId);

  // Watch and update the component, if the id has changed.
  if (hasDataBinding) {
    $attrs.$observe('mdComponentId', function(id) {
      if (id && id !== self.$$mdHandle) {
        self.destroy(); // `destroy` only deregisters the old component id so we can add the new one.
        self.destroy = $mdComponentRegistry.register(self, id);
      }
    });
  }
}

})();
(function(){
"use strict";

  /**
   * @ngdoc module
   * @name material.components.slider
   */
SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
  angular.module('material.components.slider', [
    'material.core'
  ])
  .directive('mdSlider', SliderDirective)
  .directive('mdSliderContainer', SliderContainerDirective);

/**
 * @ngdoc directive
 * @name mdSliderContainer
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<md-slider-container>` contains slider with two other elements.
 *
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * </hljs>
 */
function SliderContainerDirective() {
  return {
    controller: function () {},
    compile: function (elem) {
      var slider = elem.find('md-slider');

      if (!slider) {
        return;
      }

      var vertical = slider.attr('md-vertical');

      if (vertical !== undefined) {
        elem.attr('md-vertical', '');
      }

      if(!slider.attr('flex')) {
        slider.attr('flex', '');
      }

      return function postLink(scope, element, attr, ctrl) {
        element.addClass('_md');     // private md component indicator for styling

        // We have to manually stop the $watch on ngDisabled because it exists
        // on the parent scope, and won't be automatically destroyed when
        // the component is destroyed.
        function setDisable(value) {
          element.children().attr('disabled', value);
          element.find('input').attr('disabled', value);
        }

        var stopDisabledWatch = angular.noop;

        if (attr.disabled) {
          setDisable(true);
        }
        else if (attr.ngDisabled) {
          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
            setDisable(value);
          });
        }

        scope.$on('$destroy', function () {
          stopDisabledWatch();
        });

        var initialMaxWidth;

        ctrl.fitInputWidthToTextLength = function (length) {
          var input = element[0].querySelector('md-input-container');

          if (input) {
            var computedStyle = getComputedStyle(input);
            var minWidth = parseInt(computedStyle.minWidth);
            var padding = parseInt(computedStyle.padding) * 2;

            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));

            input.style.maxWidth = newMaxWidth + 'px';
          }
        };
      };
    }
  };
}

/**
 * @ngdoc directive
 * @name mdSlider
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<md-slider>` component allows the user to choose from a range of
 * values.
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the slider is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * It has two modes: 'normal' mode, where the user slides between a wide range
 * of values, and 'discrete' mode, where the user slides between only a few
 * select values.
 *
 * To enable discrete mode, add the `md-discrete` attribute to a slider,
 * and use the `step` attribute to change the distance between
 * values the user is allowed to pick.
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * <md-slider ng-model="myValue" min="5" max="500">
 * </md-slider>
 * </hljs>
 * <h4>Discrete Mode</h4>
 * <hljs lang="html">
 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
 * </md-slider>
 * </hljs>
 * <h4>Invert Mode</h4>
 * <hljs lang="html">
 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
 * </md-slider>
 * </hljs>
 *
 * @param {boolean=} md-discrete Whether to enable discrete mode.
 * @param {boolean=} md-invert Whether to enable invert mode.
 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
 */
function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
  return {
    scope: {},
    require: ['?ngModel', '?^mdSliderContainer'],
    template:
      '<div class="md-slider-wrapper">' +
        '<div class="md-slider-content">' +
          '<div class="md-track-container">' +
            '<div class="md-track"></div>' +
            '<div class="md-track md-track-fill"></div>' +
            '<div class="md-track-ticks"></div>' +
          '</div>' +
          '<div class="md-thumb-container">' +
            '<div class="md-thumb"></div>' +
            '<div class="md-focus-thumb"></div>' +
            '<div class="md-focus-ring"></div>' +
            '<div class="md-sign">' +
              '<span class="md-thumb-text"></span>' +
            '</div>' +
            '<div class="md-disabled-thumb"></div>' +
          '</div>' +
        '</div>' +
      '</div>',
    compile: compile
  };

  // **********************************************************
  // Private Methods
  // **********************************************************

  function compile (tElement, tAttrs) {
    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));

    var tabIndex = tAttrs.tabindex || 0;
    wrapper.attr('tabindex', tabIndex);

    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);

    wrapper.attr('role', 'slider');

    $mdAria.expect(tElement, 'aria-label');

    return postLink;
  }

  function postLink(scope, element, attr, ctrls) {
    $mdTheming(element);
    var ngModelCtrl = ctrls[0] || {
      // Mock ngModelController if it doesn't exist to give us
      // the minimum functionality needed
      $setViewValue: function(val) {
        this.$viewValue = val;
        this.$viewChangeListeners.forEach(function(cb) { cb(); });
      },
      $parsers: [],
      $formatters: [],
      $viewChangeListeners: []
    };

    var containerCtrl = ctrls[1];
    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
          return element[0].hasAttribute('disabled');
        };

    var thumb = angular.element(element[0].querySelector('.md-thumb'));
    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
    var thumbContainer = thumb.parent();
    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);

    // Default values, overridable by attrs
    var DEFAULT_ROUND = 3;
    var vertical = angular.isDefined(attr.mdVertical);
    var discrete = angular.isDefined(attr.mdDiscrete);
    var invert = angular.isDefined(attr.mdInvert);
    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);

    // We have to manually stop the $watch on ngDisabled because it exists
    // on the parent scope, and won't be automatically destroyed when
    // the component is destroyed.
    var stopDisabledWatch = angular.noop;
    if (attr.ngDisabled) {
      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
    }

    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });

    scope.mouseActive = false;

    wrapper
      .on('keydown', keydownListener)
      .on('mousedown', mouseDownListener)
      .on('focus', focusListener)
      .on('blur', blurListener)
      .on('$md.pressdown', onPressDown)
      .on('$md.pressup', onPressUp)
      .on('$md.dragstart', onDragStart)
      .on('$md.drag', onDrag)
      .on('$md.dragend', onDragEnd);

    // On resize, recalculate the slider's dimensions and re-render
    function updateAll() {
      refreshSliderDimensions();
      ngModelRender();
    }
    setTimeout(updateAll, 0);

    var debouncedUpdateAll = $$rAF.throttle(updateAll);
    angular.element($window).on('resize', debouncedUpdateAll);

    scope.$on('$destroy', function() {
      angular.element($window).off('resize', debouncedUpdateAll);
    });

    ngModelCtrl.$render = ngModelRender;
    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
    ngModelCtrl.$formatters.push(minMaxValidator);
    ngModelCtrl.$formatters.push(stepValidator);

    /**
     * Attributes
     */
    var min;
    var max;
    var step;
    var round;
    function updateMin(value) {
      min = parseFloat(value);
      element.attr('aria-valuemin', value);
      updateAll();
    }
    function updateMax(value) {
      max = parseFloat(value);
      element.attr('aria-valuemax', value);
      updateAll();
    }
    function updateStep(value) {
      step = parseFloat(value);
    }
    function updateRound(value) {
      // Set max round digits to 6, after 6 the input uses scientific notation
      round = minMaxValidator(parseInt(value), 0, 6);
    }
    function updateAriaDisabled() {
      element.attr('aria-disabled', !!isDisabled());
    }

    // Draw the ticks with canvas.
    // The alternative to drawing ticks with canvas is to draw one element for each tick,
    // which could quickly become a performance bottleneck.
    var tickCanvas, tickCtx;
    function redrawTicks() {
      if (!discrete || isDisabled()) return;
      if ( angular.isUndefined(step) )         return;

      if ( step <= 0 ) {
        var msg = 'Slider step value must be greater than zero when in discrete mode';
        $log.error(msg);
        throw new Error(msg);
      }

      var numSteps = Math.floor( (max - min) / step );
      if (!tickCanvas) {
        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
        tickContainer.append(tickCanvas);

        tickCtx = tickCanvas[0].getContext('2d');
      }

      var dimensions = getSliderDimensions();

      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
      if (dimensions && !dimensions.height && !dimensions.width) {
        refreshSliderDimensions();
        dimensions = sliderDimensions;
      }

      tickCanvas[0].width = dimensions.width;
      tickCanvas[0].height = dimensions.height;

      var distance;
      for (var i = 0; i <= numSteps; i++) {
        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
        tickCtx.fillStyle = trackTicksStyle.color || 'black';

        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));

        tickCtx.fillRect(vertical ? 0 : distance - 1,
          vertical ? distance - 1 : 0,
          vertical ? dimensions.width : 2,
          vertical ? 2 : dimensions.height);
      }
    }

    function clearTicks() {
      if(tickCanvas && tickCtx) {
        var dimensions = getSliderDimensions();
        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
      }
    }

    /**
     * Refreshing Dimensions
     */
    var sliderDimensions = {};
    refreshSliderDimensions();
    function refreshSliderDimensions() {
      sliderDimensions = trackContainer[0].getBoundingClientRect();
    }
    function getSliderDimensions() {
      throttledRefreshDimensions();
      return sliderDimensions;
    }

    /**
     * left/right/up/down arrow listener
     */
    function keydownListener(ev) {
      if (isDisabled()) return;

      var changeAmount;
      if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
        changeAmount = -step;
      } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
        changeAmount = step;
      }
      changeAmount = invert ? -changeAmount : changeAmount;
      if (changeAmount) {
        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
          changeAmount *= 4;
        }
        ev.preventDefault();
        ev.stopPropagation();
        scope.$evalAsync(function() {
          setModelValue(ngModelCtrl.$viewValue + changeAmount);
        });
      }
    }

    function mouseDownListener() {
      redrawTicks();

      scope.mouseActive = true;
      wrapper.removeClass('md-focused');

      $timeout(function() {
        scope.mouseActive = false;
      }, 100);
    }

    function focusListener() {
      if (scope.mouseActive === false) {
        wrapper.addClass('md-focused');
      }
    }

    function blurListener() {
      wrapper.removeClass('md-focused');
      element.removeClass('md-active');
      clearTicks();
    }

    /**
     * ngModel setters and validators
     */
    function setModelValue(value) {
      ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
    }
    function ngModelRender() {
      if (isNaN(ngModelCtrl.$viewValue)) {
        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
      }

      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);

      var percent = valueToPercent(ngModelCtrl.$viewValue);
      scope.modelValue = ngModelCtrl.$viewValue;
      element.attr('aria-valuenow', ngModelCtrl.$viewValue);
      setSliderPercent(percent);
      thumbText.text( ngModelCtrl.$viewValue );
    }

    function minMaxValidator(value, minValue, maxValue) {
      if (angular.isNumber(value)) {
        minValue = angular.isNumber(minValue) ? minValue : min;
        maxValue = angular.isNumber(maxValue) ? maxValue : max;

        return Math.max(minValue, Math.min(maxValue, value));
      }
    }

    function stepValidator(value) {
      if (angular.isNumber(value)) {
        var formattedValue = (Math.round((value - min) / step) * step + min);
        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));

        if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
          $mdUtil.debounce(function () {
            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
          }, 100)();
        }

        return formattedValue;
      }
    }

    /**
     * @param percent 0-1
     */
    function setSliderPercent(percent) {

      percent = clamp(percent);

      var thumbPosition = (percent * 100) + '%';
      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;

      if (vertical) {
        thumbContainer.css('bottom', thumbPosition);
      }
      else {
        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
      }

      
      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);

      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
    }

    /**
     * Slide listeners
     */
    var isDragging = false;

    function onPressDown(ev) {
      if (isDisabled()) return;

      element.addClass('md-active');
      element[0].focus();
      refreshSliderDimensions();

      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
      var closestVal = minMaxValidator( stepValidator(exactVal) );
      scope.$apply(function() {
        setModelValue( closestVal );
        setSliderPercent( valueToPercent(closestVal));
      });
    }
    function onPressUp(ev) {
      if (isDisabled()) return;

      element.removeClass('md-dragging');

      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
      var closestVal = minMaxValidator( stepValidator(exactVal) );
      scope.$apply(function() {
        setModelValue(closestVal);
        ngModelRender();
      });
    }
    function onDragStart(ev) {
      if (isDisabled()) return;
      isDragging = true;

      ev.stopPropagation();

      element.addClass('md-dragging');
      setSliderFromEvent(ev);
    }
    function onDrag(ev) {
      if (!isDragging) return;
      ev.stopPropagation();
      setSliderFromEvent(ev);
    }
    function onDragEnd(ev) {
      if (!isDragging) return;
      ev.stopPropagation();
      isDragging = false;
    }

    function setSliderFromEvent(ev) {
      // While panning discrete, update only the
      // visual positioning but not the model value.
      if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
      else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
    }

    /**
     * Slide the UI by changing the model value
     * @param x
     */
    function doSlide( x ) {
      scope.$evalAsync( function() {
        setModelValue( percentToValue( positionToPercent(x) ));
      });
    }

    /**
     * Slide the UI without changing the model (while dragging/panning)
     * @param x
     */
    function adjustThumbPosition( x ) {
      var exactVal = percentToValue( positionToPercent( x ));
      var closestVal = minMaxValidator( stepValidator(exactVal) );
      setSliderPercent( positionToPercent(x) );
      thumbText.text( closestVal );
    }

    /**
    * Clamps the value to be between 0 and 1.
    * @param {number} value The value to clamp.
    * @returns {number}
    */
    function clamp(value) {
      return Math.max(0, Math.min(value || 0, 1));
    }

    /**
     * Convert position on slider to percentage value of offset from beginning...
     * @param position
     * @returns {number}
     */
    function positionToPercent( position ) {
      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
      var calc = (position - offset) / size;

      if (!vertical && $mdUtil.bidi() === 'rtl') {
        calc = 1 - calc;
      }

      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
    }

    /**
     * Convert percentage offset on slide to equivalent model value
     * @param percent
     * @returns {*}
     */
    function percentToValue( percent ) {
      var adjustedPercent = invert ? (1 - percent) : percent;
      return (min + adjustedPercent * (max - min));
    }

    function valueToPercent( val ) {
      var percent = (val - min) / (max - min);
      return invert ? (1 - percent) : percent;
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.sticky
 * @description
 * Sticky effects for md
 *
 */
MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
angular
  .module('material.components.sticky', [
    'material.core',
    'material.components.content'
  ])
  .factory('$mdSticky', MdSticky);

/**
 * @ngdoc service
 * @name $mdSticky
 * @module material.components.sticky
 *
 * @description
 * The `$mdSticky`service provides a mixin to make elements sticky.
 *
 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
 * use the native browser stickiness.
 *
 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
 * parameter, in the same scope as the actual element lives.
 *
 *
 * <h3>Notes</h3>
 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
 * you should compile the clone yourself using the plain template.<br/><br/>
 * See the right usage below:
 * <hljs lang="js">
 *   angular.module('myModule')
 *     .directive('stickySelect', function($mdSticky, $compile) {
 *       var SELECT_TEMPLATE =
 *         '<md-select ng-model="selected">' +
 *           '<md-option>Option 1</md-option>' +
 *         '</md-select>';
 *
 *       return {
 *         restrict: 'E',
 *         replace: true,
 *         template: SELECT_TEMPLATE,
 *         link: function(scope,element) {
 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
 *         }
 *       };
 *     });
 * </hljs>
 *
 * @usage
 * <hljs lang="js">
 *   angular.module('myModule')
 *     .directive('stickyText', function($mdSticky, $compile) {
 *       return {
 *         restrict: 'E',
 *         template: '<span>Sticky Text</span>',
 *         link: function(scope,element) {
 *           $mdSticky(scope, element);
 *         }
 *       };
 *     });
 * </hljs>
 *
 * @returns A `$mdSticky` function that takes three arguments:
 *   - `scope`
 *   - `element`: The element that will be 'sticky'
 *   - `elementClone`: A clone of the element, that will be shown
 *     when the user starts scrolling past the original element.
 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
 */
function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {

  var browserStickySupport = $mdUtil.checkStickySupport();

  /**
   * Registers an element as sticky, used internally by directives to register themselves
   */
  return function registerStickyElement(scope, element, stickyClone) {
    var contentCtrl = element.controller('mdContent');
    if (!contentCtrl) return;

    if (browserStickySupport) {
      element.css({
        position: browserStickySupport,
        top: 0,
        'z-index': 2
      });
    } else {
      var $$sticky = contentCtrl.$element.data('$$sticky');
      if (!$$sticky) {
        $$sticky = setupSticky(contentCtrl);
        contentCtrl.$element.data('$$sticky', $$sticky);
      }

      // Compile our cloned element, when cloned in this service, into the given scope.
      var cloneElement = stickyClone || $compile(element.clone())(scope);

      var deregister = $$sticky.add(element, cloneElement);
      scope.$on('$destroy', deregister);
    }
  };

  function setupSticky(contentCtrl) {
    var contentEl = contentCtrl.$element;

    // Refresh elements is very expensive, so we use the debounced
    // version when possible.
    var debouncedRefreshElements = $$rAF.throttle(refreshElements);

    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
    // more reliable than `scroll` on android.
    setupAugmentedScrollEvents(contentEl);
    contentEl.on('$scrollstart', debouncedRefreshElements);
    contentEl.on('$scroll', onScroll);

    var self;
    return self = {
      prev: null,
      current: null, //the currently stickied item
      next: null,
      items: [],
      add: add,
      refreshElements: refreshElements
    };

    /***************
     * Public
     ***************/
    // Add an element and its sticky clone to this content's sticky collection
    function add(element, stickyClone) {
      stickyClone.addClass('md-sticky-clone');

      var item = {
        element: element,
        clone: stickyClone
      };
      self.items.push(item);

      $mdUtil.nextTick(function() {
        contentEl.prepend(item.clone);
      });

      debouncedRefreshElements();

      return function remove() {
        self.items.forEach(function(item, index) {
          if (item.element[0] === element[0]) {
            self.items.splice(index, 1);
            item.clone.remove();
          }
        });
        debouncedRefreshElements();
      };
    }

    function refreshElements() {
      // Sort our collection of elements by their current position in the DOM.
      // We need to do this because our elements' order of being added may not
      // be the same as their order of display.
      self.items.forEach(refreshPosition);
      self.items = self.items.sort(function(a, b) {
        return a.top < b.top ? -1 : 1;
      });

      // Find which item in the list should be active, 
      // based upon the content's current scroll position
      var item;
      var currentScrollTop = contentEl.prop('scrollTop');
      for (var i = self.items.length - 1; i >= 0; i--) {
        if (currentScrollTop > self.items[i].top) {
          item = self.items[i];
          break;
        }
      }
      setCurrentItem(item);
    }

    /***************
     * Private
     ***************/

    // Find the `top` of an item relative to the content element,
    // and also the height.
    function refreshPosition(item) {
      // Find the top of an item by adding to the offsetHeight until we reach the 
      // content element.
      var current = item.element[0];
      item.top = 0;
      item.left = 0;
      item.right = 0;
      while (current && current !== contentEl[0]) {
        item.top += current.offsetTop;
        item.left += current.offsetLeft;
        if ( current.offsetParent ){
          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft; //Compute offsetRight
        }
        current = current.offsetParent;
      }
      item.height = item.element.prop('offsetHeight');

      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
    }

    // As we scroll, push in and select the correct sticky element.
    function onScroll() {
      var scrollTop = contentEl.prop('scrollTop');
      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);

      // Store the previous scroll so we know which direction we are scrolling
      onScroll.prevScrollTop = scrollTop;

      //
      // AT TOP (not scrolling)
      //
      if (scrollTop === 0) {
        // If we're at the top, just clear the current item and return
        setCurrentItem(null);
        return;
      }

      //
      // SCROLLING DOWN (going towards the next item)
      //
      if (isScrollingDown) {

        // If we've scrolled down past the next item's position, sticky it and return
        if (self.next && self.next.top <= scrollTop) {
          setCurrentItem(self.next);
          return;
        }

        // If the next item is close to the current one, push the current one up out of the way
        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
          return;
        }
      }

      //
      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
      //
      if (!isScrollingDown) {

        // If we've scrolled up past the previous item's position, sticky it and return
        if (self.current && self.prev && scrollTop < self.current.top) {
          setCurrentItem(self.prev);
          return;
        }

        // If the next item is close to the current one, pull the current one down into view
        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
          return;
        }
      }

      //
      // Otherwise, just move the current item to the proper place (scrolling up or down)
      //
      if (self.current) {
        translate(self.current, scrollTop);
      }
    }

    function setCurrentItem(item) {
      if (self.current === item) return;
      // Deactivate currently active item
      if (self.current) {
        translate(self.current, null);
        setStickyState(self.current, null);
      }

      // Activate new item if given
      if (item) {
        setStickyState(item, 'active');
      }

      self.current = item;
      var index = self.items.indexOf(item);
      // If index === -1, index + 1 = 0. It works out.
      self.next = self.items[index + 1];
      self.prev = self.items[index - 1];
      setStickyState(self.next, 'next');
      setStickyState(self.prev, 'prev');
    }

    function setStickyState(item, state) {
      if (!item || item.state === state) return;
      if (item.state) {
        item.clone.attr('sticky-prev-state', item.state);
        item.element.attr('sticky-prev-state', item.state);
      }
      item.clone.attr('sticky-state', state);
      item.element.attr('sticky-state', state);
      item.state = state;
    }

    function translate(item, amount) {
      if (!item) return;
      if (amount === null || amount === undefined) {
        if (item.translateY) {
          item.translateY = null;
          item.clone.css($mdConstant.CSS.TRANSFORM, '');
        }
      } else {
        item.translateY = amount;

        $mdUtil.bidi( item.clone, $mdConstant.CSS.TRANSFORM,
          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
          'translateY(' + amount + 'px)'
        );
      }
    }
  }


  // Android 4.4 don't accurately give scroll events.
  // To fix this problem, we setup a fake scroll event. We say:
  // > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
  //   then send a `$scroll` event every animationFrame.
  // Additionally, we add $scrollstart and $scrollend events.
  function setupAugmentedScrollEvents(element) {
    var SCROLL_END_DELAY = 200;
    var isScrolling;
    var lastScrollTime;
    element.on('scroll touchmove', function() {
      if (!isScrolling) {
        isScrolling = true;
        $$rAF.throttle(loopScrollEvent);
        element.triggerHandler('$scrollstart');
      }
      element.triggerHandler('$scroll');
      lastScrollTime = +$mdUtil.now();
    });

    function loopScrollEvent() {
      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
        isScrolling = false;
        element.triggerHandler('$scrollend');
      } else {
        element.triggerHandler('$scroll');
        $$rAF.throttle(loopScrollEvent);
      }
    }
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.subheader
 * @description
 * SubHeader module
 *
 *  Subheaders are special list tiles that delineate distinct sections of a
 *  list or grid list and are typically related to the current filtering or
 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
 *  can be associated with content, for example, in an adjacent column.
 *
 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
 *  pinned until pushed on or off screen by the next subheader. @see [Material
 *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
 *
 *  > To improve the visual grouping of content, use the system color for your subheaders.
 *
 */
MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
angular
  .module('material.components.subheader', [
    'material.core',
    'material.components.sticky'
  ])
  .directive('mdSubheader', MdSubheaderDirective);

/**
 * @ngdoc directive
 * @name mdSubheader
 * @module material.components.subheader
 *
 * @restrict E
 *
 * @description
 * The `md-subheader` directive creates a sticky subheader for a section.
 *
 * Developers are able to disable the stickiness of the subheader by using the following markup
 *
 * <hljs lang="html">
 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
 * </hljs>
 *
 * ### Notes
 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
 * to make the subheader sticky.
 *
 * > Whenever the current browser doesn't support stickiness natively, the subheader
 * will be compiled twice to create a sticky clone of the subheader.
 *
 * @usage
 * <hljs lang="html">
 * <md-subheader>Online Friends</md-subheader>
 * </hljs>
 */

function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: (
    '<div class="md-subheader _md">' +
    '  <div class="md-subheader-inner">' +
    '    <div class="md-subheader-content"></div>' +
    '  </div>' +
    '</div>'
    ),
    link: function postLink(scope, element, attr, controllers, transclude) {
      $mdTheming(element);
      element.addClass('_md');

      // Remove the ngRepeat attribute from the root element, because we don't want to compile
      // the ngRepeat for the sticky clone again.
      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');

      var outerHTML = element[0].outerHTML;

      function getContent(el) {
        return angular.element(el[0].querySelector('.md-subheader-content'));
      }

      // Set the ARIA attributes on the original element since it keeps it's original place in
      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
      // in order to avoid having multiple element be marked as headers.
      attr.$set('role', 'heading');
      $mdAria.expect(element, 'aria-level', '2');

      // Transclude the user-given contents of the subheader
      // the conventional way.
      transclude(scope, function(clone) {
        getContent(element).append(clone);
      });

      // Create another clone, that uses the outer and inner contents
      // of the element, that will be 'stickied' as the user scrolls.
      if (!element.hasClass('md-no-sticky')) {
        transclude(scope, function(clone) {
          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
          // compiled clone below will only be a comment tag (since they replace their elements with
          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
          // DIV to ensure we have something $mdSticky can use
          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);

          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
          // attempting to create the clone
          $mdUtil.nextTick(function() {
            // Append our transcluded clone into the wrapper.
            // We don't have to recompile the element again, because the clone is already
            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
            // our ngIf's and other previous registered bindings / properties.
            getContent(wrapper).append(clone);
          });

          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
          // element.
          $mdSticky(scope, element, wrapper);
        });
      }
    }
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.swipe
 * @description Swipe module!
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeLeft
 *
 * @restrict A
 *
 * @description
 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
 * left.
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-left="onSwipeLeft()">Swipe me left!</div>
 * </hljs>
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeRight
 *
 * @restrict A
 *
 * @description
 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
 * right.
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-right="onSwipeRight()">Swipe me right!</div>
 * </hljs>
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeUp
 *
 * @restrict A
 *
 * @description
 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
 * up.
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-up="onSwipeUp()">Swipe me up!</div>
 * </hljs>
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeDown
 *
 * @restrict A
 *
 * @description
 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
 * down.
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-down="onSwipDown()">Swipe me down!</div>
 * </hljs>
 */

angular.module('material.components.swipe', ['material.core'])
    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
    .directive('mdSwipeRight', getDirective('SwipeRight'))
    .directive('mdSwipeUp', getDirective('SwipeUp'))
    .directive('mdSwipeDown', getDirective('SwipeDown'));

function getDirective(name) {
    DirectiveFactory.$inject = ["$parse"];
  var directiveName = 'md' + name;
  var eventName = '$md.' + name.toLowerCase();

  return DirectiveFactory;

  /* @ngInject */
  function DirectiveFactory($parse) {
      return { restrict: 'A', link: postLink };
      function postLink(scope, element, attr) {
        var fn = $parse(attr[directiveName]);
        element.on(eventName, function(ev) {
          scope.$applyAsync(function() { fn(scope, { $event: ev }); });
        });
      }
    }
}



})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.switch
 */

MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
angular.module('material.components.switch', [
  'material.core',
  'material.components.checkbox'
])
  .directive('mdSwitch', MdSwitch);

/**
 * @ngdoc directive
 * @module material.components.switch
 * @name mdSwitch
 * @restrict E
 *
 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the switch is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * @param {string} ng-model Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user interaction with the input element.
 * @param {expression=} ng-disabled En/Disable based on the expression.
 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
 * @param {boolean=} md-invert When set to true, the switch will be inverted.
 *
 * @usage
 * <hljs lang="html">
 * <md-switch ng-model="isActive" aria-label="Finished?">
 *   Finished ?
 * </md-switch>
 *
 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
 *   No Ink Effects
 * </md-switch>
 *
 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
 *   Disabled
 * </md-switch>
 *
 * </hljs>
 */
function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
  var checkboxDirective = mdCheckboxDirective[0];

  return {
    restrict: 'E',
    priority: $mdConstant.BEFORE_NG_ARIA,
    transclude: true,
    template:
      '<div class="md-container">' +
        '<div class="md-bar"></div>' +
        '<div class="md-thumb-container">' +
          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
        '</div>'+
      '</div>' +
      '<div ng-transclude class="md-label"></div>',
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    compile: mdSwitchCompile
  };

  function mdSwitchCompile(element, attr) {
    var checkboxLink = checkboxDirective.compile(element, attr).post;
    // No transition on initial load.
    element.addClass('md-dragging');

    return function (scope, element, attr, ctrls) {
      var containerCtrl = ctrls[0];
      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
      var formCtrl = ctrls[2];

      var disabledGetter = null;
      if (attr.disabled != null) {
        disabledGetter = function() { return true; };
      } else if (attr.ngDisabled) {
        disabledGetter = $parse(attr.ngDisabled);
      }

      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
      var switchContainer = angular.element(element[0].querySelector('.md-container'));
      var labelContainer = angular.element(element[0].querySelector('.md-label'));

      // no transition on initial load
      $$rAF(function() {
        element.removeClass('md-dragging');
      });

      checkboxLink(scope, element, attr, ctrls);

      if (disabledGetter) {
        scope.$watch(disabledGetter, function(isDisabled) {
          element.attr('tabindex', isDisabled ? -1 : 0);
        });
      }

      attr.$observe('mdInvert', function(newValue) {
        var isInverted = $mdUtil.parseAttributeBoolean(newValue);

        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);

        // Toggle a CSS class to update the margin.
        element.toggleClass('md-inverted', isInverted);
      });

      // These events are triggered by setup drag
      $mdGesture.register(switchContainer, 'drag');
      switchContainer
        .on('$md.dragstart', onDragStart)
        .on('$md.drag', onDrag)
        .on('$md.dragend', onDragEnd);

      var drag;
      function onDragStart(ev) {
        // Don't go if the switch is disabled.
        if (disabledGetter && disabledGetter(scope)) return;
        ev.stopPropagation();

        element.addClass('md-dragging');
        drag = {width: thumbContainer.prop('offsetWidth')};
      }

      function onDrag(ev) {
        if (!drag) return;
        ev.stopPropagation();
        ev.srcEvent && ev.srcEvent.preventDefault();

        var percent = ev.pointer.distanceX / drag.width;

        //if checked, start from right. else, start from left
        var translate = ngModel.$viewValue ?  1 + percent : percent;
        // Make sure the switch stays inside its bounds, 0-1%
        translate = Math.max(0, Math.min(1, translate));

        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
        drag.translate = translate;
      }

      function onDragEnd(ev) {
        if (!drag) return;
        ev.stopPropagation();

        element.removeClass('md-dragging');
        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');

        // We changed if there is no distance (this is a click a click),
        // or if the drag distance is >50% of the total.
        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
        if (isChanged) {
          applyModelValue(!ngModel.$viewValue);
        }
        drag = null;

        // Wait for incoming mouse click
        scope.skipToggle = true;
        $timeout(function() {
          scope.skipToggle = false;
        }, 1);
      }

      function applyModelValue(newValue) {
        scope.$apply(function() {
          ngModel.$setViewValue(newValue);
          ngModel.$render();
        });
      }

    };
  }


}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.tabs
 * @description
 *
 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
 *
 *  Features include support for:
 *
 *  - static or dynamic tabs,
 *  - responsive designs,
 *  - accessibility support (ARIA),
 *  - tab pagination,
 *  - external or internal tab content,
 *  - focus indicators and arrow-key navigations,
 *  - programmatic lookup and access to tab controllers, and
 *  - dynamic transitions through different tab contents.
 *
 */
/*
 * @see js folder for tabs implementation
 */
angular.module('material.components.tabs', [
  'material.core',
  'material.components.icon'
]);

})();
(function(){
"use strict";

angular
.module('material.components.tabs')
.service('MdTabsPaginationService', MdTabsPaginationService);

/**
 * @private
 * @module material.components.tabs
 * @name MdTabsPaginationService
 * @description Provides many standalone functions to ease in pagination calculations.
 *
 * Most functions accept the elements and the current offset.
 *
 * The `elements` parameter is typically the value returned from the `getElements()` function of the
 * tabsController.
 *
 * The `offset` parameter is always positive regardless of LTR or RTL (we simply make the LTR one
 * negative when we apply our transform). This is typically the `ctrl.leftOffset` variable in the
 * tabsController.
 *
 * @returns MdTabsPaginationService
 * @constructor
 */
function MdTabsPaginationService() {
  return {
    decreasePageOffset: decreasePageOffset,
    increasePageOffset: increasePageOffset,
    getTabOffsets: getTabOffsets,
    getTotalTabsWidth: getTotalTabsWidth
  };

  /**
   * Returns the offset for the next decreasing page.
   *
   * @param elements
   * @param currentOffset
   * @returns {number}
   */
  function decreasePageOffset(elements, currentOffset) {
    var canvas       = elements.canvas,
        tabOffsets   = getTabOffsets(elements),
        i, firstVisibleTabOffset;

    // Find the first fully visible tab in offset range
    for (i = 0; i < tabOffsets.length; i++) {
      if (tabOffsets[i] >= currentOffset) {
        firstVisibleTabOffset = tabOffsets[i];
        break;
      }
    }

    // Return (the first visible tab offset - the tabs container width) without going negative
    return Math.max(0, firstVisibleTabOffset - canvas.clientWidth);
  }

  /**
   * Returns the offset for the next increasing page.
   *
   * @param elements
   * @param currentOffset
   * @returns {number}
   */
  function increasePageOffset(elements, currentOffset) {
    var canvas       = elements.canvas,
        maxOffset    = getTotalTabsWidth(elements) - canvas.clientWidth,
        tabOffsets   = getTabOffsets(elements),
        i, firstHiddenTabOffset;

    // Find the first partially (or fully) invisible tab
    for (i = 0; i < tabOffsets.length, tabOffsets[i] <= currentOffset + canvas.clientWidth; i++) {
      firstHiddenTabOffset = tabOffsets[i];
    }

    // Return the offset of the first hidden tab, or the maximum offset (whichever is smaller)
    return Math.min(maxOffset, firstHiddenTabOffset);
  }

  /**
   * Returns the offsets of all of the tabs based on their widths.
   *
   * @param elements
   * @returns {number[]}
   */
  function getTabOffsets(elements) {
    var i, tab, currentOffset = 0, offsets = [];

    for (i = 0; i < elements.tabs.length; i++) {
      tab = elements.tabs[i];
      offsets.push(currentOffset);
      currentOffset += tab.offsetWidth;
    }

    return offsets;
  }

  /**
   * Sum the width of all tabs.
   *
   * @param elements
   * @returns {number}
   */
  function getTotalTabsWidth(elements) {
    var sum = 0, i, tab;

    for (i = 0; i < elements.tabs.length; i++) {
      tab = elements.tabs[i];
      sum += tab.offsetWidth;
    }

    return sum;
  }

}

})();
(function(){
"use strict";

/**
  * @ngdoc module
  * @name material.components.toast
  * @description
  * Toast
  */
MdToastDirective.$inject = ["$mdToast"];
MdToastProvider.$inject = ["$$interimElementProvider"];
angular.module('material.components.toast', [
  'material.core',
  'material.components.button'
])
  .directive('mdToast', MdToastDirective)
  .provider('$mdToast', MdToastProvider);

/* @ngInject */
function MdToastDirective($mdToast) {
  return {
    restrict: 'E',
    link: function postLink(scope, element) {
      element.addClass('_md');     // private md component indicator for styling
      
      // When navigation force destroys an interimElement, then
      // listen and $destroy() that interim instance...
      scope.$on('$destroy', function() {
        $mdToast.destroy();
      });
    }
  };
}

/**
  * @ngdoc service
  * @name $mdToast
  * @module material.components.toast
  *
  * @description
  * `$mdToast` is a service to build a toast notification on any position
  * on the screen with an optional duration, and provides a simple promise API.
  *
  * The toast will be always positioned at the `bottom`, when the screen size is
  * between `600px` and `959px` (`sm` breakpoint)
  *
  * ## Restrictions on custom toasts
  * - The toast's template must have an outer `<md-toast>` element.
  * - For a toast action, use element with class `md-action`.
  * - Add the class `md-capsule` for curved corners.
  *
  * ### Custom Presets
  * Developers are also able to create their own preset, which can be easily used without repeating
  * their options each time.
  *
  * <hljs lang="js">
  *   $mdToastProvider.addPreset('testPreset', {
  *     options: function() {
  *       return {
  *         template:
  *           '<md-toast>' +
  *             '<div class="md-toast-content">' +
  *               'This is a custom preset' +
  *             '</div>' +
  *           '</md-toast>',
  *         controllerAs: 'toast',
  *         bindToController: true
  *       };
  *     }
  *   });
  * </hljs>
  *
  * After you created your preset at config phase, you can easily access it.
  *
  * <hljs lang="js">
  *   $mdToast.show(
  *     $mdToast.testPreset()
  *   );
  * </hljs>
  *
  * ## Parent container notes
  *
  * The toast is positioned using absolute positioning relative to its first non-static parent
  * container. Thus, if the requested parent container uses static positioning, we will temporarily
  * set its positioning to `relative` while the toast is visible and reset it when the toast is
  * hidden.
  *
  * Because of this, it is usually best to ensure that the parent container has a fixed height and
  * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
  * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
  *
  * You can, however, have a scrollable element inside of the container; just make sure the
  * container itself does not scroll.
  *
  * <hljs lang="html">
  * <div layout-fill id="toast-container">
  *   <md-content>
  *     I can have lots of content and scroll!
  *   </md-content>
  * </div>
  * </hljs>
  *
  * @usage
  * <hljs lang="html">
  * <div ng-controller="MyController">
  *   <md-button ng-click="openToast()">
  *     Open a Toast!
  *   </md-button>
  * </div>
  * </hljs>
  *
  * <hljs lang="js">
  * var app = angular.module('app', ['ngMaterial']);
  * app.controller('MyController', function($scope, $mdToast) {
  *   $scope.openToast = function($event) {
  *     $mdToast.show($mdToast.simple().textContent('Hello!'));
  *     // Could also do $mdToast.showSimple('Hello');
  *   };
  * });
  * </hljs>
  */

/**
 * @ngdoc method
 * @name $mdToast#showSimple
 * 
 * @param {string} message The message to display inside the toast
 * @description
 * Convenience method which builds and shows a simple toast.
 *
 * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
 * rejected with `$mdToast.cancel()`.
 *
 */

 /**
  * @ngdoc method
  * @name $mdToast#simple
  *
  * @description
  * Builds a preconfigured toast.
  *
  * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
  *
  * _**Note:** These configuration methods are provided in addition to the methods provided by
  * the `build()` and `show()` methods below._
  *
  * <table class="md-api-table methods">
  *    <thead>
  *      <tr>
  *        <th>Method</th>
  *        <th>Description</th>
  *      </tr>
  *    </thead>
  *    <tbody>
  *      <tr>
  *        <td>`.textContent(string)`</td>
  *        <td>Sets the toast content to the specified string</td>
  *      </tr>
  *      <tr>
  *        <td>`.action(string)`</td>
  *        <td>
  *          Adds an action button. <br/>
  *          If clicked, the promise (returned from `show()`)
  *          will resolve with the value `'ok'`; otherwise, it is resolved with `true` after a `hideDelay`
  *          timeout
  *        </td>
  *      </tr>
  *      <tr>
  *        <td>`.highlightAction(boolean)`</td>
  *        <td>
  *          Whether or not the action button will have an additional highlight class.<br/>
  *          By default the `accent` color will be applied to the action button.
  *        </td>
  *      </tr>
  *      <tr>
  *        <td>`.highlightClass(string)`</td>
  *        <td>
  *          If set, the given class will be applied to the highlighted action button.<br/>
  *          This allows you to specify the highlight color easily. Highlight classes are `md-primary`, `md-warn`
  *          and `md-accent`
  *        </td>
  *      </tr>
  *      <tr>
  *        <td>`.capsule(boolean)`</td>
  *        <td>Whether or not to add the `md-capsule` class to the toast to provide rounded corners</td>
  *      </tr>
  *      <tr>
  *        <td>`.theme(string)`</td>
  *        <td>Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s default.</td>
  *      </tr>
  *      <tr>
  *        <td>`.toastClass(string)`</td>
  *        <td>Sets a class on the toast element</td>
  *      </tr>
  *    </tbody>
  * </table>
  *
  */

/**
  * @ngdoc method
  * @name $mdToast#updateTextContent
  *
  * @description
  * Updates the content of an existing toast. Useful for updating things like counts, etc.
  *
  */

 /**
  * @ngdoc method
  * @name $mdToast#build
  *
  * @description
  * Creates a custom `$mdToastPreset` that you can configure.
  *
  * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options (see below).
  */

 /**
  * @ngdoc method
  * @name $mdToast#show
  *
  * @description Shows the toast.
  *
  * @param {object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
  * and `build()`, or an options object with the following properties:
  *
  *   - `templateUrl` - `{string=}`: The url of an html template file that will
  *     be used as the content of the toast. Restrictions: the template must
  *     have an outer `md-toast` element.
  *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
  *     template string.
  *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
  *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled if you provide a
  *     custom toast directive.
  *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
  *     This scope will be destroyed when the toast is removed unless `preserveScope` is set to true.
  *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
  *   - `hideDelay` - `{number=}`: How many milliseconds the toast should stay
  *     active before automatically closing.  Set to 0 or false to have the toast stay open until
  *     closed manually. Default: 3000.
  *   - `position` - `{string=}`: Sets the position of the toast. <br/>
  *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'` and `'start'`.
  *     The properties `'end'` and `'start'` are dynamic and can be used for RTL support.<br/>
  *     Default combination: `'bottom left'`.
  *   - `toastClass` - `{string=}`: A class to set on the toast element.
  *   - `controller` - `{string=}`: The controller to associate with this toast.
  *     The controller will be injected the local `$mdToast.hide( )`, which is a function
  *     used to hide the toast.
  *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
  *     be used as names of values to inject into the controller. For example,
  *     `locals: {three: 3}` would inject `three` into the controller with the value
  *     of 3.
  *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
  *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
  *     and the toast will not open until the promises resolve.
  *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
  *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
  *     to the root element of the application.
  *
  * @returns {promise} A promise that can be resolved with `$mdToast.hide()` or
  * rejected with `$mdToast.cancel()`. `$mdToast.hide()` will resolve either with a Boolean
  * value == 'true' or the value passed as an argument to `$mdToast.hide()`.
  * And `$mdToast.cancel()` will resolve the promise with a Boolean value == 'false'
  */

/**
  * @ngdoc method
  * @name $mdToast#hide
  *
  * @description
  * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
  *
  * @param {*=} response An argument for the resolved promise.
  *
  * @returns {promise} a promise that is called when the existing element is removed from the DOM.
  * The promise is resolved with either a Boolean value == 'true' or the value passed as the
  * argument to `.hide()`.
  *
  */

/**
  * @ngdoc method
  * @name $mdToast#cancel
  *
  * @description
  * `DEPRECATED` - The promise returned from opening a toast is used only to notify about the closing of the toast.
  * As such, there isn't any reason to also allow that promise to be rejected,
  * since it's not clear what the difference between resolve and reject would be.
  *
  * Hide the existing toast and reject the promise returned from
  * `$mdToast.show()`.
  *
  * @param {*=} response An argument for the rejected promise.
  *
  * @returns {promise} a promise that is called when the existing element is removed from the DOM
  * The promise is resolved with a Boolean value == 'false'.
  *
  */

function MdToastProvider($$interimElementProvider) {
  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks (value == ok).
  MdToastController.$inject = ["$mdToast", "$scope"];
  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia"];
  var ACTION_RESOLVE = 'ok';

  var activeToastContent;
  var $mdToast = $$interimElementProvider('$mdToast')
    .setDefaults({
      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
      options: toastDefaultOptions
    })
    .addPreset('simple', {
      argOption: 'textContent',
      methods: ['textContent', 'content', 'action', 'highlightAction', 'highlightClass', 'theme', 'parent' ],
      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
        return {
          template:
            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
            '  <div class="md-toast-content">' +
            '    <span class="md-toast-text" role="alert" aria-relevant="all" aria-atomic="true">' +
            '      {{ toast.content }}' +
            '    </span>' +
            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
            '        ng-class="highlightClasses">' +
            '      {{ toast.action }}' +
            '    </md-button>' +
            '  </div>' +
            '</md-toast>',
          controller: MdToastController,
          theme: $mdTheming.defaultTheme(),
          controllerAs: 'toast',
          bindToController: true
        };
      }]
    })
    .addMethod('updateTextContent', updateTextContent)
    .addMethod('updateContent', updateTextContent);

    function updateTextContent(newContent) {
      activeToastContent = newContent;
    }

    return $mdToast;

  /**
   * Controller for the Toast interim elements.
   * @ngInject
   */
  function MdToastController($mdToast, $scope) {
    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
    this.$onInit = function() {
      var self = this;

      if (self.highlightAction) {
        $scope.highlightClasses = [
          'md-highlight',
          self.highlightClass
        ]
      }

      $scope.$watch(function() { return activeToastContent; }, function() {
        self.content = activeToastContent;
      });

      this.resolve = function() {
        $mdToast.hide( ACTION_RESOLVE );
      };
    }
  }

  /* @ngInject */
  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia) {
    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
    return {
      onShow: onShow,
      onRemove: onRemove,
      toastClass: '',
      position: 'bottom left',
      themable: true,
      hideDelay: 3000,
      autoWrap: true,
      transformTemplate: function(template, options) {
        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);

        if (shouldAddWrapper) {
          // Root element of template will be <md-toast>. We need to wrap all of its content inside of
          // of <div class="md-toast-content">. All templates provided here should be static, developer-controlled
          // content (meaning we're not attempting to guard against XSS).
          var templateRoot = document.createElement('md-template');
          templateRoot.innerHTML = template;

          // Iterate through all root children, to detect possible md-toast directives.
          for (var i = 0; i < templateRoot.children.length; i++) {
            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
              var wrapper = angular.element('<div class="md-toast-content">');

              // Wrap the children of the `md-toast` directive in jqLite, to be able to append multiple
              // nodes with the same execution.
              wrapper.append(angular.element(templateRoot.children[i].childNodes));

              // Append the new wrapped element to the `md-toast` directive.
              templateRoot.children[i].appendChild(wrapper[0]);
            }
          }

          // We have to return the innerHTMl, because we do not want to have the `md-template` element to be
          // the root element of our interimElement.
          return templateRoot.innerHTML;
        }

        return template || '';
      }
    };

    function onShow(scope, element, options) {
      activeToastContent = options.textContent || options.content; // support deprecated #content method

      var isSmScreen = !$mdMedia('gt-sm');

      element = $mdUtil.extractElementByName(element, 'md-toast', true);
      options.element = element;

      options.onSwipe = function(ev, gesture) {
        //Add the relevant swipe class to the element so it can animate correctly
        var swipe = ev.type.replace('$md.','');
        var direction = swipe.replace('swipe', '');

        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
        // Unless the screen is small, then the toast always on bottom
        if ((direction === 'down' && options.position.indexOf('top') != -1 && !isSmScreen) ||
            (direction === 'up' && (options.position.indexOf('bottom') != -1 || isSmScreen))) {
          return;
        }

        if ((direction === 'left' || direction === 'right') && isSmScreen) {
          return;
        }

        element.addClass('md-' + swipe);
        $mdUtil.nextTick($mdToast.cancel);
      };
      options.openClass = toastOpenClass(options.position);

      element.addClass(options.toastClass);

      // 'top left' -> 'md-top md-left'
      options.parent.addClass(options.openClass);

      // static is the default position
      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
        options.parent.css('position', 'relative');
      }

      element.on(SWIPE_EVENTS, options.onSwipe);
      element.addClass(isSmScreen ? 'md-bottom' : options.position.split(' ').map(function(pos) {
        return 'md-' + pos;
      }).join(' '));

      if (options.parent) options.parent.addClass('md-toast-animating');
      return $animate.enter(element, options.parent).then(function() {
        if (options.parent) options.parent.removeClass('md-toast-animating');
      });
    }

    function onRemove(scope, element, options) {
      element.off(SWIPE_EVENTS, options.onSwipe);
      if (options.parent) options.parent.addClass('md-toast-animating');
      if (options.openClass) options.parent.removeClass(options.openClass);

      return ((options.$destroy == true) ? element.remove() : $animate.leave(element))
        .then(function () {
          if (options.parent) options.parent.removeClass('md-toast-animating');
          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
            options.parent.css('position', '');
          }
        });
    }

    function toastOpenClass(position) {
      // For mobile, always open full-width on bottom
      if (!$mdMedia('gt-xs')) {
        return 'md-toast-open-bottom';
      }

      return 'md-toast-open-' +
        (position.indexOf('top') > -1 ? 'top' : 'bottom');
    }
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.toolbar
 */
mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate"];
angular.module('material.components.toolbar', [
  'material.core',
  'material.components.content'
])
  .directive('mdToolbar', mdToolbarDirective);

/**
 * @ngdoc directive
 * @name mdToolbar
 * @module material.components.toolbar
 * @restrict E
 * @description
 * `md-toolbar` is used to place a toolbar in your app.
 *
 * Toolbars are usually used above a content area to display the title of the
 * current page, and show relevant action buttons for that page.
 *
 * You can change the height of the toolbar by adding either the
 * `md-medium-tall` or `md-tall` class to the toolbar.
 *
 * @usage
 * <hljs lang="html">
 * <div layout="column" layout-fill>
 *   <md-toolbar>
 *
 *     <div class="md-toolbar-tools">
 *       <h2 md-truncate flex>My App's Title</h2>
 *
 *       <md-button>
 *         Right Bar Button
 *       </md-button>
 *     </div>
 *
 *   </md-toolbar>
 *   <md-content>
 *     Hello!
 *   </md-content>
 * </div>
 * </hljs>
 *
 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
 * ellipsis if the title is longer than the width of the Toolbar.</i>
 *
 * ## CSS & Styles
 *
 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
 * functionality of your toolbar.
 *
 * <div>
 * <docs-css-api-table>
 *
 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
 *     buttons and text. When applied, it will center the buttons and text vertically for you.
 *   </docs-css-selector>
 *
 * </docs-css-api-table>
 * </div>
 *
 * ### Private Classes
 *
 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
 * considered public.
 *
 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
 * the user scrolls down, and reveal itself as the user scrolls up.
 *
 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
 * `md-content` element, placed before it. See the scroll shrink demo._
 *
 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
 * initialization, it does not watch for scope changes._
 *
 *
 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
 * at one fourth the rate at which the user scrolls down. Default 0.5.
 *
 */

function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate) {
  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');

  return {
    template: '',
    restrict: 'E',

    link: function(scope, element, attr) {

      element.addClass('_md');     // private md component indicator for styling
      $mdTheming(element);

      $mdUtil.nextTick(function () {
        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
      }, false);

      if (angular.isDefined(attr.mdScrollShrink)) {
        setupScrollShrink();
      }

      function setupScrollShrink() {

        var toolbarHeight;
        var contentElement;
        var disableScrollShrink = angular.noop;

        // Current "y" position of scroll
        // Store the last scroll top position
        var y = 0;
        var prevScrollTop = 0;
        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;

        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);

        // Wait for $mdContentLoaded event from mdContent directive.
        // If the mdContent element is a sibling of our toolbar, hook it up
        // to scroll events.

        scope.$on('$mdContentLoaded', onMdContentLoad);

        // If the toolbar is used inside an ng-if statement, we may miss the
        // $mdContentLoaded event, so we attempt to fake it if we have a
        // md-content close enough.

        attr.$observe('mdScrollShrink', onChangeScrollShrink);

        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
        // and not wait for $mdUtil.debounce to happen

        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }

        // If the scope is destroyed (which could happen with ng-if), make sure
        // to disable scroll shrinking again

        scope.$on('$destroy', disableScrollShrink);

        /**
         *
         */
        function onChangeScrollShrink(shrinkWithScroll) {
          var closestContent = element.parent().find('md-content');

          // If we have a content element, fake the call; this might still fail
          // if the content element isn't a sibling of the toolbar

          if (!contentElement && closestContent.length) {
            onMdContentLoad(null, closestContent);
          }

          // Evaluate the expression
          shrinkWithScroll = scope.$eval(shrinkWithScroll);

          // Disable only if the attribute's expression evaluates to false
          if (shrinkWithScroll === false) {
            disableScrollShrink();
          } else {
            disableScrollShrink = enableScrollShrink();
          }
        }

        /**
         *
         */
        function onMdContentLoad($event, newContentEl) {
          // Toolbar and content must be siblings
          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
            // unhook old content event listener if exists
            if (contentElement) {
              contentElement.off('scroll', debouncedContentScroll);
            }

            contentElement = newContentEl;
            disableScrollShrink = enableScrollShrink();
          }
        }

        /**
         *
         */
        function onContentScroll(e) {
          var scrollTop = e ? e.target.scrollTop : prevScrollTop;

          debouncedUpdateHeight();

          y = Math.min(
            toolbarHeight / shrinkSpeedFactor,
            Math.max(0, y + scrollTop - prevScrollTop)
          );

          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));

          prevScrollTop = scrollTop;

          $mdUtil.nextTick(function() {
            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');

            if (hasWhiteFrame && !y) {
              $animate.removeClass(element, 'md-whiteframe-z1');
            } else if (!hasWhiteFrame && y) {
              $animate.addClass(element, 'md-whiteframe-z1');
            }
          });

        }

        /**
         *
         */
        function enableScrollShrink() {
          if (!contentElement)     return angular.noop;           // no md-content

          contentElement.on('scroll', debouncedContentScroll);
          contentElement.attr('scroll-shrink', 'true');

          $mdUtil.nextTick(updateToolbarHeight, false);

          return function disableScrollShrink() {
            contentElement.off('scroll', debouncedContentScroll);
            contentElement.attr('scroll-shrink', 'false');

            updateToolbarHeight();
          };
        }

        /**
         *
         */
        function updateToolbarHeight() {
          toolbarHeight = element.prop('offsetHeight');
          // Add a negative margin-top the size of the toolbar to the content el.
          // The content will start transformed down the toolbarHeight amount,
          // so everything looks normal.
          //
          // As the user scrolls down, the content will be transformed up slowly
          // to put the content underneath where the toolbar was.
          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';

          contentElement.css({
            "margin-top": margin,
            "margin-bottom": margin
          });

          onContentScroll();
        }

      }

    }
  };

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.tooltip
 */
MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
angular
    .module('material.components.tooltip', [
      'material.core',
      'material.components.panel'
    ])
    .directive('mdTooltip', MdTooltipDirective)
    .service('$$mdTooltipRegistry', MdTooltipRegistry);


/**
 * @ngdoc directive
 * @name mdTooltip
 * @module material.components.tooltip
 * @description
 * Tooltips are used to describe elements that are interactive and primarily
 * graphical (not textual).
 *
 * Place a `<md-tooltip>` as a child of the element it describes.
 *
 * A tooltip will activate when the user hovers over, focuses, or touches the
 * parent element.
 *
 * @usage
 * <hljs lang="html">
 *   <md-button class="md-fab md-accent" aria-label="Play">
 *     <md-tooltip>Play Music</md-tooltip>
 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
 *   </md-button>
 * </hljs>
 *
 * @param {number=} md-z-index The visual level that the tooltip will appear
 *     in comparison with the rest of the elements of the application.
 * @param {expression=} md-visible Boolean bound to whether the tooltip is
 *     currently visible.
 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
 *     after the user hovers over, focuses, or touches the parent element.
 *     Defaults to 0ms on non-touch devices and 75ms on touch.
 * @param {boolean=} md-autohide If present or provided with a boolean value,
 *     the tooltip will hide on mouse leave, regardless of focus.
 * @param {string=} md-direction The direction that the tooltip is shown,
 *     relative to the parent element. Supports top, right, bottom, and left.
 *     Defaults to bottom.
 */
function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
    $mdUtil, $mdPanel, $$mdTooltipRegistry) {

  var ENTER_EVENTS = 'focus touchstart mouseenter';
  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
  var TOOLTIP_DEFAULT_Z_INDEX = 100;
  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
  var TOOLTIP_DIRECTIONS = {
    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
  };

  return {
    restrict: 'E',
    priority: 210, // Before ngAria
    scope: {
      mdZIndex: '=?mdZIndex',
      mdDelay: '=?mdDelay',
      mdVisible: '=?mdVisible',
      mdAutohide: '=?mdAutohide',
      mdDirection: '@?mdDirection' // Do not expect expressions.
    },
    link: linkFunc
  };

  function linkFunc(scope, element, attr) {
    // Set constants.
    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
    var parent = $mdUtil.getParentWithPointerEvents(element);
    var debouncedOnResize = $$rAF.throttle(updatePosition);
    var mouseActive = false;
    var origin, position, panelPosition, panelRef, autohide, showTimeout,
        elementFocusedOnWindowBlur = null;

    // Set defaults
    setDefaults();

    // Set parent aria-label.
    addAriaLabel();

    // Remove the element from its current DOM position.
    element.detach();

    updatePosition();
    bindEvents();
    configureWatchers();

    function setDefaults() {
      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
      }
    }

    function addAriaLabel(labelText) {
      // Only interpolate the text from the HTML element because otherwise the custom text could
      // be interpolated twice and cause XSS violations.
      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);

      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
      // tooltip directive.
      if (
        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
        parent.attr('md-labeled-by-tooltip')
      ) {
        parent.attr('aria-label', interpolatedText);

        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
        if (!parent.attr('md-labeled-by-tooltip')) {
          parent.attr('md-labeled-by-tooltip', tooltipId);
        }
      }
    }

    function updatePosition() {
      setDefaults();

      // If the panel has already been created, remove the current origin
      // class from the panel element.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.removeClass(origin);
      }

      // Set the panel element origin class based off of the current
      // mdDirection.
      origin = 'md-origin-' + scope.mdDirection;

      // Create the position of the panel based off of the mdDirection.
      position = TOOLTIP_DIRECTIONS[scope.mdDirection];

      // Using the newly created position object, use the MdPanel
      // panelPosition API to build the panel's position.
      panelPosition = $mdPanel.newPanelPosition()
          .relativeTo(parent)
          .addPanelPosition(position.x, position.y);

      // If the panel has already been created, add the new origin class to
      // the panel element and update it's position with the panelPosition.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.addClass(origin);
        panelRef.updatePosition(panelPosition);
      }
    }

    function bindEvents() {
      // Add a mutationObserver where there is support for it and the need
      // for it in the form of viable host(parent[0]).
      if (parent[0] && 'MutationObserver' in $window) {
        // Use a mutationObserver to tackle #2602.
        var attributeObserver = new MutationObserver(function(mutations) {
          if (isDisabledMutation(mutations)) {
            $mdUtil.nextTick(function() {
              setVisible(false);
            });
          }
        });

        attributeObserver.observe(parent[0], {
          attributes: true
        });
      }

      elementFocusedOnWindowBlur = false;

      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
      $$mdTooltipRegistry.register('resize', debouncedOnResize);

      scope.$on('$destroy', onDestroy);

      // To avoid 'synthetic clicks', we listen to mousedown instead of
      // 'click'.
      parent.on('mousedown', mousedownEventHandler);
      parent.on(ENTER_EVENTS, enterEventHandler);

      function isDisabledMutation(mutations) {
        mutations.some(function(mutation) {
          return mutation.attributeName === 'disabled' && parent[0].disabled;
        });
        return false;
      }

      function windowScrollEventHandler() {
        setVisible(false);
      }

      function windowBlurEventHandler() {
        elementFocusedOnWindowBlur = document.activeElement === parent[0];
      }

      function enterEventHandler($event) {
        // Prevent the tooltip from showing when the window is receiving
        // focus.
        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
          elementFocusedOnWindowBlur = false;
        } else if (!scope.mdVisible) {
          parent.on(LEAVE_EVENTS, leaveEventHandler);
          setVisible(true);

          // If the user is on a touch device, we should bind the tap away
          // after the 'touched' in order to prevent the tooltip being
          // removed immediately.
          if ($event.type === 'touchstart') {
            parent.one('touchend', function() {
              $mdUtil.nextTick(function() {
                $document.one('touchend', leaveEventHandler);
              }, false);
            });
          }
        }
      }

      function leaveEventHandler() {
        autohide = scope.hasOwnProperty('mdAutohide') ?
            scope.mdAutohide :
            attr.hasOwnProperty('mdAutohide');

        if (autohide || mouseActive ||
            $document[0].activeElement !== parent[0]) {
          // When a show timeout is currently in progress, then we have
          // to cancel it, otherwise the tooltip will remain showing
          // without focus or hover.
          if (showTimeout) {
            $timeout.cancel(showTimeout);
            setVisible.queued = false;
            showTimeout = null;
          }

          parent.off(LEAVE_EVENTS, leaveEventHandler);
          parent.triggerHandler('blur');
          setVisible(false);
        }
        mouseActive = false;
      }

      function mousedownEventHandler() {
        mouseActive = true;
      }

      function onDestroy() {
        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);

        parent
            .off(ENTER_EVENTS, enterEventHandler)
            .off(LEAVE_EVENTS, leaveEventHandler)
            .off('mousedown', mousedownEventHandler);

        // Trigger the handler in case any of the tooltips are
        // still visible.
        leaveEventHandler();
        attributeObserver && attributeObserver.disconnect();
      }
    }

    function configureWatchers() {
      if (element[0] && 'MutationObserver' in $window) {
        var attributeObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'md-visible' &&
                !scope.visibleWatcher ) {
              scope.visibleWatcher = scope.$watch('mdVisible',
                  onVisibleChanged);
            }
          });
        });

        attributeObserver.observe(element[0], {
          attributes: true
        });

        // Build watcher only if mdVisible is being used.
        if (attr.hasOwnProperty('mdVisible')) {
          scope.visibleWatcher = scope.$watch('mdVisible',
              onVisibleChanged);
        }
      } else {
        // MutationObserver not supported
        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
      }

      // Direction watcher
      scope.$watch('mdDirection', updatePosition);

      // Clean up if the element or parent was removed via jqLite's .remove.
      // A couple of notes:
      //   - In these cases the scope might not have been destroyed, which
      //     is why we destroy it manually. An example of this can be having
      //     `md-visible="false"` and adding tooltips while they're
      //     invisible. If `md-visible` becomes true, at some point, you'd
      //     usually get a lot of tooltips.
      //   - We use `.one`, not `.on`, because this only needs to fire once.
      //     If we were using `.on`, it would get thrown into an infinite
      //     loop.
      //   - This kicks off the scope's `$destroy` event which finishes the
      //     cleanup.
      element.one('$destroy', onElementDestroy);
      parent.one('$destroy', onElementDestroy);
      scope.$on('$destroy', function() {
        setVisible(false);
        panelRef && panelRef.destroy();
        attributeObserver && attributeObserver.disconnect();
        element.remove();
      });

      // Updates the aria-label when the element text changes. This watch
      // doesn't need to be set up if the element doesn't have any data
      // bindings.
      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
        scope.$watch(function() {
          return element.text().trim();
        }, addAriaLabel);
      }

      function onElementDestroy() {
        scope.$destroy();
      }
    }

    function setVisible(value) {
      // Break if passed value is already in queue or there is no queue and
      // passed value is current in the controller.
      if (setVisible.queued && setVisible.value === !!value ||
          !setVisible.queued && scope.mdVisible === !!value) {
        return;
      }
      setVisible.value = !!value;

      if (!setVisible.queued) {
        if (value) {
          setVisible.queued = true;
          showTimeout = $timeout(function() {
            scope.mdVisible = setVisible.value;
            setVisible.queued = false;
            showTimeout = null;
            if (!scope.visibleWatcher) {
              onVisibleChanged(scope.mdVisible);
            }
          }, scope.mdDelay);
        } else {
          $mdUtil.nextTick(function() {
            scope.mdVisible = false;
            if (!scope.visibleWatcher) {
              onVisibleChanged(false);
            }
          });
        }
      }
    }

    function onVisibleChanged(isVisible) {
      isVisible ? showTooltip() : hideTooltip();
    }

    function showTooltip() {
      // Do not show the tooltip if the text is empty.
      if (!element[0].textContent.trim()) {
        throw new Error('Text for the tooltip has not been provided. ' +
            'Please include text within the mdTooltip element.');
      }

      if (!panelRef) {
        var attachTo = angular.element(document.body);
        var panelAnimation = $mdPanel.newPanelAnimation()
            .openFrom(parent)
            .closeTo(parent)
            .withAnimation({
              open: 'md-show',
              close: 'md-hide'
            });

        var panelConfig = {
          id: tooltipId,
          attachTo: attachTo,
          contentElement: element,
          propagateContainerEvents: true,
          panelClass: 'md-tooltip ' + origin,
          animation: panelAnimation,
          position: panelPosition,
          zIndex: scope.mdZIndex,
          focusOnOpen: false
        };

        panelRef = $mdPanel.create(panelConfig);
      }

      panelRef.open().then(function() {
        panelRef.panelEl.attr('role', 'tooltip');
      });
    }

    function hideTooltip() {
      panelRef && panelRef.close();
    }
  }

}


/**
 * Service that is used to reduce the amount of listeners that are being
 * registered on the `window` by the tooltip component. Works by collecting
 * the individual event handlers and dispatching them from a global handler.
 *
 * @ngInject
 */
function MdTooltipRegistry() {
  var listeners = {};
  var ngWindow = angular.element(window);

  return {
    register: register,
    deregister: deregister
  };

  /**
   * Global event handler that dispatches the registered handlers in the
   * service.
   * @param {!Event} event Event object passed in by the browser
   */
  function globalEventHandler(event) {
    if (listeners[event.type]) {
      listeners[event.type].forEach(function(currentHandler) {
        currentHandler.call(this, event);
      }, this);
    }
  }

  /**
   * Registers a new handler with the service.
   * @param {string} type Type of event to be registered.
   * @param {!Function} handler Event handler.
   * @param {boolean} useCapture Whether to use event capturing.
   */
  function register(type, handler, useCapture) {
    var handlers = listeners[type] = listeners[type] || [];

    if (!handlers.length) {
      useCapture ? window.addEventListener(type, globalEventHandler, true) :
          ngWindow.on(type, globalEventHandler);
    }

    if (handlers.indexOf(handler) === -1) {
      handlers.push(handler);
    }
  }

  /**
   * Removes an event handler from the service.
   * @param {string} type Type of event handler.
   * @param {!Function} handler The event handler itself.
   * @param {boolean} useCapture Whether the event handler used event capturing.
   */
  function deregister(type, handler, useCapture) {
    var handlers = listeners[type];
    var index = handlers ? handlers.indexOf(handler) : -1;

    if (index > -1) {
      handlers.splice(index, 1);

      if (handlers.length === 0) {
        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
            ngWindow.off(type, globalEventHandler);
      }
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.truncate
 */
MdTruncateController.$inject = ["$element"];
angular.module('material.components.truncate', ['material.core'])
  .directive('mdTruncate', MdTruncateDirective);

/**
 * @ngdoc directive
 * @name mdTruncate
 * @module material.components.truncate
 * @restrict AE
 * @description
 *
 * The `md-truncate` component displays a label that will automatically clip text which is wider
 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
 * class to override this default and use a standard "clipping" approach.
 *
 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
 * provide the `flex` attribute, or some other CSS-based width management. See the
 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
 *
 * @usage
 *
 * ### As an Element
 *
 * <hljs lang="html">
 *   <div layout="row">
 *     <md-button>Back</md-button>
 *
 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
 *
 *     <md-button>Forward</md-button>
 *   </div>
 * </hljs>
 *
 * ### As an Attribute
 *
 * <hljs lang="html">
 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
 * </hljs>
 *
 * ## CSS & Styles
 *
 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
 *
 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
 * attribute to fix an issue with the flex element not shrinking properly.</i>
 *
 * <div>
 * <docs-css-api-table>
 *
 *   <docs-css-selector code=".md-ellipsis">
 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
 *     (&hellip;) to the end of the text.
 *   </docs-css-selector>
 *
 *   <docs-css-selector code=".md-clip">
 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
 *     mid-word or even mid-character.
 *   </docs-css-selector>
 *
 * </docs-css-api-table>
 * </div>
 */
function MdTruncateDirective() {
  return {
    restrict: 'AE',

    controller: MdTruncateController,
    controllerAs: '$ctrl',
    bindToController: true
  }
}

/**
 * Controller for the <md-truncate> component.
 *
 * @param $element The md-truncate element.
 *
 * @constructor
 * @ngInject
 */
function MdTruncateController($element) {
  $element.addClass('md-truncate');
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.virtualRepeat
 */
VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
VirtualRepeatDirective.$inject = ["$parse"];
angular.module('material.components.virtualRepeat', [
  'material.core',
  'material.components.showHide'
])
.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
.directive('mdVirtualRepeat', VirtualRepeatDirective)
.directive('mdForceHeight', ForceHeightDirective);


/**
 * @ngdoc directive
 * @name mdVirtualRepeatContainer
 * @module material.components.virtualRepeat
 * @restrict E
 * @description
 * `md-virtual-repeat-container` provides the scroll container for md-virtual-repeat.
 *
 * VirtualRepeat is a limited substitute for ng-repeat that renders only
 * enough DOM nodes to fill the container and recycling them as the user scrolls.
 *
 * Once an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for
 * another visible item by replacing the previous dataset with the new one.
 *
 * ### Common Issues
 *
 * - When having one-time bindings inside of the view template, the VirtualRepeat will not properly
 *   update the bindings for new items, since the view will be recycled.
 *
 * - Directives inside of a VirtualRepeat will be only compiled (linked) once, because those
 *   are will be recycled items and used for other items.
 *   The VirtualRepeat just updates the scope bindings.
 *
 *
 * ### Notes
 *
 * > The VirtualRepeat is a similar implementation to the Android
 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html)
 *
 * <!-- This comment forces a break between blockquotes //-->
 *
 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">VirtualRepeat</a>
 * documentation for more information.
 *
 *
 * @usage
 * <hljs lang="html">
 *
 * <md-virtual-repeat-container md-top-index="topIndex">
 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
 * </md-virtual-repeat-container>
 * </hljs>
 *
 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
 *     container to $scope. It can both read and set the scroll position.
 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally
 *     (defaults to orientation and scrolling vertically).
 * @param {boolean=} md-auto-shrink When present, the container will shrink to fit
 *     the number of items when that number is less than its original size.
 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
 *     will shrink to (default: 0).
 */
function VirtualRepeatContainerDirective() {
  return {
    controller: VirtualRepeatContainerController,
    template: virtualRepeatContainerTemplate,
    compile: function virtualRepeatContainerCompile($element, $attrs) {
      $element
          .addClass('md-virtual-repeat-container')
          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
              ? 'md-orient-horizontal'
              : 'md-orient-vertical');
    }
  };
}


function virtualRepeatContainerTemplate($element) {
  return '<div class="md-virtual-repeat-scroller" role="presentation">' +
    '<div class="md-virtual-repeat-sizer" role="presentation"></div>' +
    '<div class="md-virtual-repeat-offsetter" role="presentation">' +
      $element[0].innerHTML +
    '</div></div>';
}

/**
 * Number of additional elements to render above and below the visible area inside
 * of the virtual repeat container. A higher number results in less flicker when scrolling
 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
 * @const {number}
 */
var NUM_EXTRA = 3;

/** @ngInject */
function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window, $scope,
                                          $element, $attrs) {
  this.$rootScope = $rootScope;
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;

  /** @type {number} The width or height of the container */
  this.size = 0;
  /** @type {number} The scroll width or height of the scroller */
  this.scrollSize = 0;
  /** @type {number} The scrollLeft or scrollTop of the scroller */
  this.scrollOffset = 0;
  /** @type {boolean} Whether the scroller is oriented horizontally */
  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
  /** @type {!VirtualRepeatController} The repeater inside of this container */
  this.repeater = null;
  /** @type {boolean} Whether auto-shrink is enabled */
  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
  /** @type {number} Minimum number of items to auto-shrink to */
  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
  /** @type {?number} Original container size when shrank */
  this.originalSize = null;
  /** @type {number} Amount to offset the total scroll size by. */
  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
  this.oldElementSize = null;
  /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
  this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;

  if (this.$attrs.mdTopIndex) {
    /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
    /** @type {number} The index of the item that is at the top of the scroll container */
    this.topIndex = this.bindTopIndex(this.$scope);

    if (!angular.isDefined(this.topIndex)) {
      this.topIndex = 0;
      this.bindTopIndex.assign(this.$scope, 0);
    }

    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
      if (newIndex !== this.topIndex) {
        this.scrollToIndex(newIndex);
      }
    }));
  } else {
    this.topIndex = 0;
  }

  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');

  // After the dom stablizes, measure the initial size of the container and
  // make a best effort at re-measuring as it changes.
  var boundUpdateSize = angular.bind(this, this.updateSize);

  $$rAF(angular.bind(this, function() {
    boundUpdateSize();

    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
    var jWindow = angular.element($window);

    // Make one more attempt to get the size if it is 0.
    // This is not by any means a perfect approach, but there's really no
    // silver bullet here.
    if (!this.size) {
      debouncedUpdateSize();
    }

    jWindow.on('resize', debouncedUpdateSize);
    $scope.$on('$destroy', function() {
      jWindow.off('resize', debouncedUpdateSize);
    });

    $scope.$emit('$md-resize-enable');
    $scope.$on('$md-resize', boundUpdateSize);
  }));
}


/** Called by the md-virtual-repeat inside of the container at startup. */
VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
  this.repeater = repeaterCtrl;

  angular.element(this.scroller)
      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
};


/** @return {boolean} Whether the container is configured for horizontal scrolling. */
VirtualRepeatContainerController.prototype.isHorizontal = function() {
  return this.horizontal;
};


/** @return {number} The size (width or height) of the container. */
VirtualRepeatContainerController.prototype.getSize = function() {
  return this.size;
};


/**
 * Resizes the container.
 * @private
 * @param {number} size The new size to set.
 */
VirtualRepeatContainerController.prototype.setSize_ = function(size) {
  var dimension = this.getDimensionName_();

  this.size = size;
  this.$element[0].style[dimension] = size + 'px';
};


VirtualRepeatContainerController.prototype.unsetSize_ = function() {
  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
  this.oldElementSize = null;
};


/** Instructs the container to re-measure its size. */
VirtualRepeatContainerController.prototype.updateSize = function() {
  // If the original size is already determined, we can skip the update.
  if (this.originalSize) return;

  this.size = this.isHorizontal()
      ? this.$element[0].clientWidth
      : this.$element[0].clientHeight;

  // Recheck the scroll position after updating the size. This resolves
  // problems that can result if the scroll position was measured while the
  // element was display: none or detached from the document.
  this.handleScroll_();

  this.repeater && this.repeater.containerUpdated();
};


/** @return {number} The container's scrollHeight or scrollWidth. */
VirtualRepeatContainerController.prototype.getScrollSize = function() {
  return this.scrollSize;
};


VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
  return this.isHorizontal() ? 'width' : 'height';
};


/**
 * Sets the scroller element to the specified size.
 * @private
 * @param {number} size The new size.
 */
VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
  var dimension =  this.getDimensionName_();
  var crossDimension = this.isHorizontal() ? 'height' : 'width';

  // Clear any existing dimensions.
  this.sizer.innerHTML = '';

  // If the size falls within the browser's maximum explicit size for a single element, we can
  // set the size and be done. Otherwise, we have to create children that add up the the desired
  // size.
  if (size < this.maxElementPixels) {
    this.sizer.style[dimension] = size + 'px';
  } else {
    this.sizer.style[dimension] = 'auto';
    this.sizer.style[crossDimension] = 'auto';

    // Divide the total size we have to render into N max-size pieces.
    var numChildren = Math.floor(size / this.maxElementPixels);

    // Element template to clone for each max-size piece.
    var sizerChild = document.createElement('div');
    sizerChild.style[dimension] = this.maxElementPixels + 'px';
    sizerChild.style[crossDimension] = '1px';

    for (var i = 0; i < numChildren; i++) {
      this.sizer.appendChild(sizerChild.cloneNode(false));
    }

    // Re-use the element template for the remainder.
    sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
    this.sizer.appendChild(sizerChild);
  }
};


/**
 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
 * @private
 * @param {number} size The new size.
 */
VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());

  if (this.autoShrink && shrinkSize !== this.size) {
    if (this.oldElementSize === null) {
      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
    }

    var currentSize = this.originalSize || this.size;

    if (!currentSize || shrinkSize < currentSize) {
      if (!this.originalSize) {
        this.originalSize = this.size;
      }

      // Now we update the containers size, because shrinking is enabled.
      this.setSize_(shrinkSize);
    } else if (this.originalSize !== null) {
      // Set the size back to our initial size.
      this.unsetSize_();

      var _originalSize = this.originalSize;
      this.originalSize = null;

      // We determine the repeaters size again, if the original size was zero.
      // The originalSize needs to be null, to be able to determine the size.
      if (!_originalSize) this.updateSize();

      // Apply the original size or the determined size back to the container, because
      // it has been overwritten before, in the shrink block.
      this.setSize_(_originalSize || this.size);
    }

    this.repeater.containerUpdated();
  }
};


/**
 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
 * its item count and item size.
 * @param {number} itemsSize The total size of the items.
 */
VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
  var size = itemsSize + this.offsetSize;
  if (this.scrollSize === size) return;

  this.sizeScroller_(size);
  this.autoShrink_(size);
  this.scrollSize = size;
};


/** @return {number} The container's current scroll offset. */
VirtualRepeatContainerController.prototype.getScrollOffset = function() {
  return this.scrollOffset;
};

/**
 * Scrolls to a given scrollTop position.
 * @param {number} position
 */
VirtualRepeatContainerController.prototype.scrollTo = function(position) {
  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
  this.handleScroll_();
};

/**
 * Scrolls the item with the given index to the top of the scroll container.
 * @param {number} index
 */
VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
  var itemSize = this.repeater.getItemSize();
  var itemsLength = this.repeater.itemsLength;
  if(index > itemsLength) {
    index = itemsLength - 1;
  }
  this.scrollTo(itemSize * index);
};

VirtualRepeatContainerController.prototype.resetScroll = function() {
  this.scrollTo(0);
};


VirtualRepeatContainerController.prototype.handleScroll_ = function() {
  var ltr = document.dir != 'rtl' && document.body.dir != 'rtl';
  if(!ltr && !this.maxSize) {
    this.scroller.scrollLeft = this.scrollSize;
    this.maxSize = this.scroller.scrollLeft;
  }
  var offset = this.isHorizontal() ?
      (ltr?this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
      : this.scroller.scrollTop;
  if (offset === this.scrollOffset || offset > this.scrollSize - this.size) return;

  var itemSize = this.repeater.getItemSize();
  if (!itemSize) return;

  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);

  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
      (!this.isHorizontal() || ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';

  this.scrollOffset = offset;
  this.offsetter.style.webkitTransform = transform;
  this.offsetter.style.transform = transform;

  if (this.bindTopIndex) {
    var topIndex = Math.floor(offset / itemSize);
    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
      this.topIndex = topIndex;
      this.bindTopIndex.assign(this.$scope, topIndex);
      if (!this.$rootScope.$$phase) this.$scope.$digest();
    }
  }

  this.repeater.containerUpdated();
};


/**
 * @ngdoc directive
 * @name mdVirtualRepeat
 * @module material.components.virtualRepeat
 * @restrict A
 * @priority 1000
 * @description
 * `md-virtual-repeat` specifies an element to repeat using virtual scrolling.
 *
 * Virtual repeat is a limited substitute for ng-repeat that renders only
 * enough DOM nodes to fill the container and recycling them as the user scrolls.
 *
 * Arrays, but not objects are supported for iteration.
 * Track by, as alias, and (key, value) syntax are not supported.
 *
 * ### On-Demand Async Item Loading
 *
 * When using the `md-on-demand` attribute and loading some asynchronous data, the `getItemAtIndex` function will
 * mostly return nothing.
 *
 * <hljs lang="js">
 *   DynamicItems.prototype.getItemAtIndex = function(index) {
 *     if (this.pages[index]) {
 *       return this.pages[index];
 *     } else {
 *       // This is an asynchronous action and does not return any value.
 *       this.loadPage(index);
 *     }
 *   };
 * </hljs>
 *
 * This means that the VirtualRepeat will not have any value for the given index.<br/>
 * After the data loading completed, the user expects the VirtualRepeat to recognize the change.
 *
 * To make sure that the VirtualRepeat properly detects any change, you need to run the operation
 * in another digest.
 *
 * <hljs lang="js">
 *   DynamicItems.prototype.loadPage = function(index) {
 *     var self = this;
 *
 *     // Trigger a new digest by using $timeout
 *     $timeout(function() {
 *       self.pages[index] = Data;
 *     });
 *   };
 * </hljs>
 *
 * > <b>Note:</b> Please also review the
 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
 *   for more information.
 *
 * @usage
 * <hljs lang="html">
 * <md-virtual-repeat-container>
 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
 * </md-virtual-repeat-container>
 *
 * <md-virtual-repeat-container md-orient-horizontal>
 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
 * </md-virtual-repeat-container>
 * </hljs>
 *
 * @param {number=} md-item-size The height or width of the repeated elements (which must be
 *   identical for each element). Optional. Will attempt to read the size from the dom if missing,
 *   but still assumes that all repeated nodes have same height or width.
 * @param {string=} md-extra-name Evaluates to an additional name to which the current iterated item
 *   can be assigned on the repeated scope (needed for use in `md-autocomplete`).
 * @param {boolean=} md-on-demand When present, treats the md-virtual-repeat argument as an object
 *   that can fetch rows rather than an array.
 *
 *   **NOTE:** This object must implement the following interface with two (2) methods:
 *
 *   - `getItemAtIndex: function(index) [object]` The item at that index or null if it is not yet
 *     loaded (it should start downloading the item in that case).
 *   - `getLength: function() [number]` The data length to which the repeater container
 *     should be sized. Ideally, when the count is known, this method should return it.
 *     Otherwise, return a higher number than the currently loaded items to produce an
 *     infinite-scroll behavior.
 */
function VirtualRepeatDirective($parse) {
  return {
    controller: VirtualRepeatController,
    priority: 1000,
    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
    restrict: 'A',
    terminal: true,
    transclude: 'element',
    compile: function VirtualRepeatCompile($element, $attrs) {
      var expression = $attrs.mdVirtualRepeat;
      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
      var repeatName = match[1];
      var repeatListExpression = $parse(match[2]);
      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);

      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
      };
    }
  };
}


/** @ngInject */
function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
    $$rAF, $mdUtil) {
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;
  this.$browser = $browser;
  this.$document = $document;
  this.$mdUtil = $mdUtil;
  this.$rootScope = $rootScope;
  this.$$rAF = $$rAF;

  /** @type {boolean} Whether we are in on-demand mode. */
  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
  this.browserCheckUrlChange = $browser.$$checkUrlChange;
  /** @type {number} Most recent starting repeat index (based on scroll offset) */
  this.newStartIndex = 0;
  /** @type {number} Most recent ending repeat index (based on scroll offset) */
  this.newEndIndex = 0;
  /** @type {number} Most recent end visible index (based on scroll offset) */
  this.newVisibleEnd = 0;
  /** @type {number} Previous starting repeat index (based on scroll offset) */
  this.startIndex = 0;
  /** @type {number} Previous ending repeat index (based on scroll offset) */
  this.endIndex = 0;
  // TODO: measure width/height of first element from dom if not provided.
  // getComputedStyle?
  /** @type {?number} Height/width of repeated elements. */
  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;

  /** @type {boolean} Whether this is the first time that items are rendered. */
  this.isFirstRender = true;

  /**
   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
   *     nested calls to virtualRepeatUpdate_.
   */
  this.isVirtualRepeatUpdating_ = false;

  /** @type {number} Most recently seen length of items. */
  this.itemsLength = 0;

  /**
   * @type {!Function} Unwatch callback for item size (when md-items-size is
   *     not specified), or angular.noop otherwise.
   */
  this.unwatchItemSize_ = angular.noop;

  /**
   * Presently rendered blocks by repeat index.
   * @type {Object<number, !VirtualRepeatController.Block}
   */
  this.blocks = {};
  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
  this.pooledBlocks = [];

  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
}


/**
 * An object representing a repeated item.
 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
 */
VirtualRepeatController.Block;


/**
 * Called at startup by the md-virtual-repeat postLink function.
 * @param {!VirtualRepeatContainerController} container The container's controller.
 * @param {!Function} transclude The repeated element's bound transclude function.
 * @param {string} repeatName The left hand side of the repeat expression, indicating
 *     the name for each item in the array.
 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
 *     of the repeat expression. Points to the array to repeat over.
 * @param {string|undefined} extraName The optional extra repeatName.
 */
VirtualRepeatController.prototype.link_ =
    function(container, transclude, repeatName, repeatListExpression, extraName) {
  this.container = container;
  this.transclude = transclude;
  this.repeatName = repeatName;
  this.rawRepeatListExpression = repeatListExpression;
  this.extraName = extraName;
  this.sized = false;

  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);

  this.container.register(this);
};


/** @private Cleans up unused blocks. */
VirtualRepeatController.prototype.cleanupBlocks_ = function() {
  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
    block.element.remove();
  });
};


/** @private Attempts to set itemSize by measuring a repeated element in the dom */
VirtualRepeatController.prototype.readItemSize_ = function() {
  if (this.itemSize) {
    // itemSize was successfully read in a different asynchronous call.
    return;
  }

  this.items = this.repeatListExpression(this.$scope);
  this.parentNode = this.$element[0].parentNode;
  var block = this.getBlock_(0);
  if (!block.element[0].parentNode) {
    this.parentNode.appendChild(block.element[0]);
  }

  this.itemSize = block.element[0][
      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;

  this.blocks[0] = block;
  this.poolBlock_(0);

  if (this.itemSize) {
    this.containerUpdated();
  }
};


/**
 * Returns the user-specified repeat list, transforming it into an array-like
 * object in the case of infinite scroll/dynamic load mode.
 * @param {!angular.Scope} The scope.
 * @return {!Array|!Object} An array or array-like object for iteration.
 */
VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
  var repeatList = this.rawRepeatListExpression(scope);

  if (this.onDemand && repeatList) {
    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
    return virtualList;
  } else {
    return repeatList;
  }
};


/**
 * Called by the container. Informs us that the containers scroll or size has
 * changed.
 */
VirtualRepeatController.prototype.containerUpdated = function() {
  // If itemSize is unknown, attempt to measure it.
  if (!this.itemSize) {
    // Make sure to clean up watchers if we can (see #8178)
    if(this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
      this.unwatchItemSize_();
    }
    this.unwatchItemSize_ = this.$scope.$watchCollection(
        this.repeatListExpression,
        angular.bind(this, function(items) {
          if (items && items.length) {
            this.readItemSize_();
          }
        }));
    if (!this.$rootScope.$$phase) this.$scope.$digest();

    return;
  } else if (!this.sized) {
    this.items = this.repeatListExpression(this.$scope);
  }

  if (!this.sized) {
    this.unwatchItemSize_();
    this.sized = true;
    this.$scope.$watchCollection(this.repeatListExpression,
        angular.bind(this, function(items, oldItems) {
          if (!this.isVirtualRepeatUpdating_) {
            this.virtualRepeatUpdate_(items, oldItems);
          }
        }));
  }

  this.updateIndexes_();

  if (this.newStartIndex !== this.startIndex ||
      this.newEndIndex !== this.endIndex ||
      this.container.getScrollOffset() > this.container.getScrollSize()) {
    if (this.items instanceof VirtualRepeatModelArrayLike) {
      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
    }
    this.virtualRepeatUpdate_(this.items, this.items);
  }
};


/**
 * Called by the container. Returns the size of a single repeated item.
 * @return {?number} Size of a repeated item.
 */
VirtualRepeatController.prototype.getItemSize = function() {
  return this.itemSize;
};


/**
 * Called by the container. Returns the size of a single repeated item.
 * @return {?number} Size of a repeated item.
 */
VirtualRepeatController.prototype.getItemCount = function() {
  return this.itemsLength;
};


/**
 * Updates the order and visible offset of repeated blocks in response to scrolling
 * or items updates.
 * @private
 */
VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
  this.isVirtualRepeatUpdating_ = true;

  var itemsLength = items && items.length || 0;
  var lengthChanged = false;

  // If the number of items shrank, keep the scroll position.
  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
    this.items = items;
    var previousScrollOffset = this.container.getScrollOffset();
    this.container.resetScroll();
    this.container.scrollTo(previousScrollOffset);
  }

  if (itemsLength !== this.itemsLength) {
    lengthChanged = true;
    this.itemsLength = itemsLength;
  }

  this.items = items;
  if (items !== oldItems || lengthChanged) {
    this.updateIndexes_();
  }

  this.parentNode = this.$element[0].parentNode;

  if (lengthChanged) {
    this.container.setScrollSize(itemsLength * this.itemSize);
  }

  // Detach and pool any blocks that are no longer in the viewport.
  Object.keys(this.blocks).forEach(function(blockIndex) {
    var index = parseInt(blockIndex, 10);
    if (index < this.newStartIndex || index >= this.newEndIndex) {
      this.poolBlock_(index);
    }
  }, this);

  // Add needed blocks.
  // For performance reasons, temporarily block browser url checks as we digest
  // the restored block scopes ($$checkUrlChange reads window.location to
  // check for changes and trigger route change, etc, which we don't need when
  // trying to scroll at 60fps).
  this.$browser.$$checkUrlChange = angular.noop;

  var i, block,
      newStartBlocks = [],
      newEndBlocks = [];

  // Collect blocks at the top.
  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
    block = this.getBlock_(i);
    this.updateBlock_(block, i);
    newStartBlocks.push(block);
  }

  // Update blocks that are already rendered.
  for (; this.blocks[i] != null; i++) {
    this.updateBlock_(this.blocks[i], i);
  }
  var maxIndex = i - 1;

  // Collect blocks at the end.
  for (; i < this.newEndIndex; i++) {
    block = this.getBlock_(i);
    this.updateBlock_(block, i);
    newEndBlocks.push(block);
  }

  // Attach collected blocks to the document.
  if (newStartBlocks.length) {
    this.parentNode.insertBefore(
        this.domFragmentFromBlocks_(newStartBlocks),
        this.$element[0].nextSibling);
  }
  if (newEndBlocks.length) {
    this.parentNode.insertBefore(
        this.domFragmentFromBlocks_(newEndBlocks),
        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
  }

  // Restore $$checkUrlChange.
  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;

  this.startIndex = this.newStartIndex;
  this.endIndex = this.newEndIndex;

  if (this.isFirstRender) {
    this.isFirstRender = false;
    var firstRenderStartIndex = this.$attrs.mdStartIndex ?
      this.$scope.$eval(this.$attrs.mdStartIndex) :
      this.container.topIndex;

    // The first call to virtualRepeatUpdate_ may not be when the virtual repeater is ready.
    // Introduce a slight delay so that the update happens when it is actually ready.
    this.$mdUtil.nextTick(function() {
      this.container.scrollToIndex(firstRenderStartIndex);
    }.bind(this));
  }

  this.isVirtualRepeatUpdating_ = false;
};


/**
 * @param {number} index Where the block is to be in the repeated list.
 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
 * @private
 */
VirtualRepeatController.prototype.getBlock_ = function(index) {
  if (this.pooledBlocks.length) {
    return this.pooledBlocks.pop();
  }

  var block;
  this.transclude(angular.bind(this, function(clone, scope) {
    block = {
      element: clone,
      new: true,
      scope: scope
    };

    this.updateScope_(scope, index);
    this.parentNode.appendChild(clone[0]);
  }));

  return block;
};


/**
 * Updates and if not in a digest cycle, digests the specified block's scope to the data
 * at the specified index.
 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
 * @param {number} index The index to set.
 * @private
 */
VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
  this.blocks[index] = block;

  if (!block.new &&
      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
    return;
  }
  block.new = false;

  // Update and digest the block's scope.
  this.updateScope_(block.scope, index);

  // Perform digest before reattaching the block.
  // Any resulting synchronous dom mutations should be much faster as a result.
  // This might break some directives, but I'm going to try it for now.
  if (!this.$rootScope.$$phase) {
    block.scope.$digest();
  }
};


/**
 * Updates scope to the data at the specified index.
 * @param {!angular.Scope} scope The scope which should be updated.
 * @param {number} index The index to set.
 * @private
 */
VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
  scope.$index = index;
  scope[this.repeatName] = this.items && this.items[index];
  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
};


/**
 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
 * @param {number} index The index at which the block to pool is stored.
 * @private
 */
VirtualRepeatController.prototype.poolBlock_ = function(index) {
  this.pooledBlocks.push(this.blocks[index]);
  this.parentNode.removeChild(this.blocks[index].element[0]);
  delete this.blocks[index];
};


/**
 * Produces a dom fragment containing the elements from the list of blocks.
 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
 *     should be added to the document fragment.
 * @return {DocumentFragment}
 * @private
 */
VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
  var fragment = this.$document[0].createDocumentFragment();
  blocks.forEach(function(block) {
    fragment.appendChild(block.element[0]);
  });
  return fragment;
};


/**
 * Updates start and end indexes based on length of repeated items and container size.
 * @private
 */
VirtualRepeatController.prototype.updateIndexes_ = function() {
  var itemsLength = this.items ? this.items.length : 0;
  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);

  this.newStartIndex = Math.max(0, Math.min(
      itemsLength - containerLength,
      Math.floor(this.container.getScrollOffset() / this.itemSize)));
  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
};

/**
 * This VirtualRepeatModelArrayLike class enforces the interface requirements
 * for infinite scrolling within a mdVirtualRepeatContainer. An object with this
 * interface must implement the following interface with two (2) methods:
 *
 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
 *     loaded (It should start downloading the item in that case).
 *
 * getLength: function() -> number The data legnth to which the repeater container
 *     should be sized. Ideally, when the count is known, this method should return it.
 *     Otherwise, return a higher number than the currently loaded items to produce an
 *     infinite-scroll behavior.
 *
 * @usage
 * <hljs lang="html">
 *  <md-virtual-repeat-container md-orient-horizontal>
 *    <div md-virtual-repeat="i in items" md-on-demand>
 *      Hello {{i}}!
 *    </div>
 *  </md-virtual-repeat-container>
 * </hljs>
 *
 */
function VirtualRepeatModelArrayLike(model) {
  if (!angular.isFunction(model.getItemAtIndex) ||
      !angular.isFunction(model.getLength)) {
    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must implement ' +
        'functions getItemAtIndex() and getLength() ');
  }

  this.model = model;
}


VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
  for (var i = start; i < end; i++) {
    if (!this.hasOwnProperty(i)) {
      this[i] = this.model.getItemAtIndex(i);
    }
  }
  this.length = this.model.getLength();
};

/**
 * @ngdoc directive
 * @name mdForceHeight
 * @module material.components.virtualRepeat
 * @restrict A
 * @description
 *
 * Force an element to have a certain px height. This is used in place of a style tag in order to
 * conform to the Content Security Policy regarding unsafe-inline style tags.
 *
 * @usage
 * <hljs lang="html">
 *   <div md-force-height="'100px'"></div>
 * </hljs>
 */
function ForceHeightDirective($mdUtil) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var height = scope.$eval(attrs.mdForceHeight) || null;

      if (height && element) {
        element[0].style.height = height;
      }
    }
  }
}
ForceHeightDirective.$inject = ['$mdUtil'];

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.whiteframe
 */
MdWhiteframeDirective.$inject = ["$log"];
angular
  .module('material.components.whiteframe', ['material.core'])
  .directive('mdWhiteframe', MdWhiteframeDirective);

/**
 * @ngdoc directive
 * @module material.components.whiteframe
 * @name mdWhiteframe
 *
 * @description
 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
 *
 * The attribute values needs to be a number between 1 and 24 or -1.
 * When set to -1 no style is applied.
 *
 * ### Notes
 * - If there is no value specified it defaults to 4dp.
 * - If the value is not valid it defaults to 4dp.

 * @usage
 * <hljs lang="html">
 * <div md-whiteframe="3">
 *   <span>Elevation of 3dp</span>
 * </div>
 * </hljs>
 *
 * <hljs lang="html">
 * <div md-whiteframe="-1">
 *   <span>No elevation shadow applied</span>
 * </div>
 * </hljs>
 *
 * <hljs lang="html">
 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
 *   <span>Elevation of 5dp with an interpolated value</span>
 * </div>
 * </hljs>
 */
function MdWhiteframeDirective($log) {
  var DISABLE_DP = -1;
  var MIN_DP = 1;
  var MAX_DP = 24;
  var DEFAULT_DP = 4;

  return {
    link: postLink
  };

  function postLink(scope, element, attr) {
    var oldClass = '';

    attr.$observe('mdWhiteframe', function(elevation) {
      elevation = parseInt(elevation, 10) || DEFAULT_DP;

      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
        elevation = DEFAULT_DP;
      }

      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
      attr.$updateClass(newClass, oldClass);
      oldClass = newClass;
    });
  }
}


})();
(function(){
"use strict";


MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer"];angular
    .module('material.components.autocomplete')
    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);

var ITEM_HEIGHT   = 48,
    MAX_ITEMS     = 5,
    MENU_PADDING  = 8,
    INPUT_PADDING = 2; // Padding provided by `md-input-container`

function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
                             $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {

  // Internal Variables.
  var ctrl                 = this,
      itemParts            = $scope.itemsExpr.split(/ in /i),
      itemExpr             = itemParts[ 1 ],
      elements             = null,
      cache                = {},
      noBlur               = false,
      selectedItemWatchers = [],
      hasFocus             = false,
      fetchesInProgress    = 0,
      enableWrapScroll     = null,
      inputModelCtrl       = null,
      debouncedOnResize    = $mdUtil.debounce(onWindowResize);

  // Public Exported Variables with handlers
  defineProperty('hidden', handleHiddenChange, true);

  // Public Exported Variables
  ctrl.scope      = $scope;
  ctrl.parent     = $scope.$parent;
  ctrl.itemName   = itemParts[ 0 ];
  ctrl.matches    = [];
  ctrl.loading    = false;
  ctrl.hidden     = true;
  ctrl.index      = null;
  ctrl.id         = $mdUtil.nextUid();
  ctrl.isDisabled = null;
  ctrl.isRequired = null;
  ctrl.isReadonly = null;
  ctrl.hasNotFound = false;

  // Public Exported Methods
  ctrl.keydown                       = keydown;
  ctrl.blur                          = blur;
  ctrl.focus                         = focus;
  ctrl.clear                         = clearValue;
  ctrl.select                        = select;
  ctrl.listEnter                     = onListEnter;
  ctrl.listLeave                     = onListLeave;
  ctrl.mouseUp                       = onMouseup;
  ctrl.getCurrentDisplayValue        = getCurrentDisplayValue;
  ctrl.registerSelectedItemWatcher   = registerSelectedItemWatcher;
  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
  ctrl.notFoundVisible               = notFoundVisible;
  ctrl.loadingIsVisible              = loadingIsVisible;
  ctrl.positionDropdown              = positionDropdown;

  /**
   * Report types to be used for the $mdLiveAnnouncer
   * @enum {number} Unique flag id.
   */
  var ReportType = {
    Count: 1,
    Selected: 2
  };

  return init();

  //-- initialization methods

  /**
   * Initialize the controller, setup watchers, gather elements
   */
  function init () {

    $mdUtil.initOptionalProperties($scope, $attrs, {
      searchText: '',
      selectedItem: null,
      clearButton: false
    });

    $mdTheming($element);
    configureWatchers();
    $mdUtil.nextTick(function () {

      gatherElements();
      moveDropdown();

      // Forward all focus events to the input element when autofocus is enabled
      if ($scope.autofocus) {
        $element.on('focus', focusInputElement);
      }
    });
  }

  function updateModelValidators() {
    if (!$scope.requireMatch || !inputModelCtrl) return;

    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
  }

  /**
   * Calculates the dropdown's position and applies the new styles to the menu element
   * @returns {*}
   */
  function positionDropdown () {
    if (!elements) {
      return $mdUtil.nextTick(positionDropdown, false, $scope);
    }

    var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;

    var hrect  = elements.wrap.getBoundingClientRect(),
        vrect  = elements.snap.getBoundingClientRect(),
        root   = elements.root.getBoundingClientRect(),
        top    = vrect.bottom - root.top,
        bot    = root.bottom - vrect.top,
        left   = hrect.left - root.left,
        width  = hrect.width,
        offset = getVerticalOffset(),
        position = $scope.dropdownPosition,
        styles;

    // Automatically determine dropdown placement based on available space in viewport.
    if (!position) {
      position = (top > bot && root.height - top - MENU_PADDING < dropdownHeight) ? 'top' : 'bottom';
    }
    // Adjust the width to account for the padding provided by `md-input-container`
    if ($attrs.mdFloatingLabel) {
      left += INPUT_PADDING;
      width -= INPUT_PADDING * 2;
    }
    styles = {
      left:     left + 'px',
      minWidth: width + 'px',
      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
    };

    if (position === 'top') {
      styles.top       = 'auto';
      styles.bottom    = bot + 'px';
      styles.maxHeight = Math.min(dropdownHeight, hrect.top - root.top - MENU_PADDING) + 'px';
    } else {
      var bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();

      styles.top       = (top - offset) + 'px';
      styles.bottom    = 'auto';
      styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
    }

    elements.$.scrollContainer.css(styles);
    $mdUtil.nextTick(correctHorizontalAlignment, false);

    /**
     * Calculates the vertical offset for floating label examples to account for ngMessages
     * @returns {number}
     */
    function getVerticalOffset () {
      var offset = 0;
      var inputContainer = $element.find('md-input-container');
      if (inputContainer.length) {
        var input = inputContainer.find('input');
        offset = inputContainer.prop('offsetHeight');
        offset -= input.prop('offsetTop');
        offset -= input.prop('offsetHeight');
        // add in the height left up top for the floating label text
        offset += inputContainer.prop('offsetTop');
      }
      return offset;
    }

    /**
     * Makes sure that the menu doesn't go off of the screen on either side.
     */
    function correctHorizontalAlignment () {
      var dropdown = elements.scrollContainer.getBoundingClientRect(),
          styles   = {};
      if (dropdown.right > root.right - MENU_PADDING) {
        styles.left = (hrect.right - dropdown.width) + 'px';
      }
      elements.$.scrollContainer.css(styles);
    }
  }

  /**
   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
   */
  function moveDropdown () {
    if (!elements.$.root.length) return;
    $mdTheming(elements.$.scrollContainer);
    elements.$.scrollContainer.detach();
    elements.$.root.append(elements.$.scrollContainer);
    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
  }

  /**
   * Sends focus to the input element.
   */
  function focusInputElement () {
    elements.input.focus();
  }

  /**
   * Sets up any watchers used by autocomplete
   */
  function configureWatchers () {
    var wait = parseInt($scope.delay, 10) || 0;

    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });

    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
    $scope.$watch('selectedItem', selectedItemChange);

    angular.element($window).on('resize', debouncedOnResize);

    $scope.$on('$destroy', cleanup);
  }

  /**
   * Removes any events or leftover elements created by this controller
   */
  function cleanup () {
    if (!ctrl.hidden) {
      $mdUtil.enableScrolling();
    }

    angular.element($window).off('resize', debouncedOnResize);

    if ( elements ){
      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
      angular.forEach(items, function(key){
        elements.$[key].remove();
      });
    }
  }

  /**
   * Event handler to be called whenever the window resizes.
   */
  function onWindowResize() {
    if (!ctrl.hidden) {
      positionDropdown();
    }
  }

  /**
   * Gathers all of the elements needed for this controller
   */
  function gatherElements () {

    var snapWrap = gatherSnapWrap();

    elements = {
      main:  $element[0],
      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container'),
      scroller: $element[0].querySelector('.md-virtual-repeat-scroller'),
      ul:    $element.find('ul')[0],
      input: $element.find('input')[0],
      wrap:  snapWrap.wrap,
      snap:  snapWrap.snap,
      root:  document.body
    };

    elements.li   = elements.ul.getElementsByTagName('li');
    elements.$    = getAngularElements(elements);

    inputModelCtrl = elements.$.input.controller('ngModel');
  }

  /**
   * Gathers the snap and wrap elements
   *
   */
  function gatherSnapWrap() {
    var element;
    var value;
    for (element = $element; element.length; element = element.parent()) {
      value = element.attr('md-autocomplete-snap');
      if (angular.isDefined(value)) break;
    }

    if (element.length) {
      return {
        snap: element[0],
        wrap: (value.toLowerCase() === 'width') ? element[0] : $element.find('md-autocomplete-wrap')[0]
      };
    }

    var wrap = $element.find('md-autocomplete-wrap')[0];
    return {
      snap: wrap,
      wrap: wrap
    };
  }

  /**
   * Gathers angular-wrapped versions of each element
   * @param elements
   * @returns {{}}
   */
  function getAngularElements (elements) {
    var obj = {};
    for (var key in elements) {
      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
    }
    return obj;
  }

  //-- event/change handlers

  /**
   * Handles changes to the `hidden` property.
   * @param hidden
   * @param oldHidden
   */
  function handleHiddenChange (hidden, oldHidden) {
    if (!hidden && oldHidden) {
      positionDropdown();

      // Report in polite mode, because the screenreader should finish the default description of
      // the input. element.
      reportMessages(true, ReportType.Count | ReportType.Selected);

      if (elements) {
        $mdUtil.disableScrollAround(elements.ul);
        enableWrapScroll = disableElementScrollEvents(angular.element(elements.wrap));
      }
    } else if (hidden && !oldHidden) {
      $mdUtil.enableScrolling();

      if (enableWrapScroll) {
        enableWrapScroll();
        enableWrapScroll = null;
      }
    }
  }

  /**
   * Disables scrolling for a specific element
   */
  function disableElementScrollEvents(element) {

    function preventDefault(e) {
      e.preventDefault();
    }

    element.on('wheel', preventDefault);
    element.on('touchmove', preventDefault);

    return function() {
      element.off('wheel', preventDefault);
      element.off('touchmove', preventDefault);
    };
  }

  /**
   * When the user mouses over the dropdown menu, ignore blur events.
   */
  function onListEnter () {
    noBlur = true;
  }

  /**
   * When the user's mouse leaves the menu, blur events may hide the menu again.
   */
  function onListLeave () {
    if (!hasFocus && !ctrl.hidden) elements.input.focus();
    noBlur = false;
    ctrl.hidden = shouldHide();
  }

  /**
   * When the mouse button is released, send focus back to the input field.
   */
  function onMouseup () {
    elements.input.focus();
  }

  /**
   * Handles changes to the selected item.
   * @param selectedItem
   * @param previousSelectedItem
   */
  function selectedItemChange (selectedItem, previousSelectedItem) {

    updateModelValidators();

    if (selectedItem) {
      getDisplayValue(selectedItem).then(function (val) {
        $scope.searchText = val;
        handleSelectedItemChange(selectedItem, previousSelectedItem);
      });
    } else if (previousSelectedItem && $scope.searchText) {
      getDisplayValue(previousSelectedItem).then(function(displayValue) {
        // Clear the searchText, when the selectedItem is set to null.
        // Do not clear the searchText, when the searchText isn't matching with the previous
        // selected item.
        if (angular.isString($scope.searchText)
          && displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
          $scope.searchText = '';
        }
      });
    }

    if (selectedItem !== previousSelectedItem) announceItemChange();
  }

  /**
   * Use the user-defined expression to announce changes each time a new item is selected
   */
  function announceItemChange () {
    angular.isFunction($scope.itemChange) && $scope.itemChange(getItemAsNameVal($scope.selectedItem));
  }

  /**
   * Use the user-defined expression to announce changes each time the search text is changed
   */
  function announceTextChange () {
    angular.isFunction($scope.textChange) && $scope.textChange();
  }

  /**
   * Calls any external watchers listening for the selected item.  Used in conjunction with
   * `registerSelectedItemWatcher`.
   * @param selectedItem
   * @param previousSelectedItem
   */
  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
    selectedItemWatchers.forEach(function (watcher) { watcher(selectedItem, previousSelectedItem); });
  }

  /**
   * Register a function to be called when the selected item changes.
   * @param cb
   */
  function registerSelectedItemWatcher (cb) {
    if (selectedItemWatchers.indexOf(cb) == -1) {
      selectedItemWatchers.push(cb);
    }
  }

  /**
   * Unregister a function previously registered for selected item changes.
   * @param cb
   */
  function unregisterSelectedItemWatcher (cb) {
    var i = selectedItemWatchers.indexOf(cb);
    if (i != -1) {
      selectedItemWatchers.splice(i, 1);
    }
  }

  /**
   * Handles changes to the searchText property.
   * @param searchText
   * @param previousSearchText
   */
  function handleSearchText (searchText, previousSearchText) {
    ctrl.index = getDefaultIndex();

    // do nothing on init
    if (searchText === previousSearchText) return;

    updateModelValidators();

    getDisplayValue($scope.selectedItem).then(function (val) {
      // clear selected item if search text no longer matches it
      if (searchText !== val) {
        $scope.selectedItem = null;


        // trigger change event if available
        if (searchText !== previousSearchText) announceTextChange();

        // cancel results if search text is not long enough
        if (!isMinLengthMet()) {
          ctrl.matches = [];

          setLoading(false);
          reportMessages(false, ReportType.Count);

        } else {
          handleQuery();
        }
      }
    });

  }

  /**
   * Handles input blur event, determines if the dropdown should hide.
   */
  function blur($event) {
    hasFocus = false;

    if (!noBlur) {
      ctrl.hidden = shouldHide();
      evalAttr('ngBlur', { $event: $event });
    }
  }

  /**
   * Force blur on input element
   * @param forceBlur
   */
  function doBlur(forceBlur) {
    if (forceBlur) {
      noBlur = false;
      hasFocus = false;
    }
    elements.input.blur();
  }

  /**
   * Handles input focus event, determines if the dropdown should show.
   */
  function focus($event) {
    hasFocus = true;

    if (isSearchable() && isMinLengthMet()) {
      handleQuery();
    }

    ctrl.hidden = shouldHide();

    evalAttr('ngFocus', { $event: $event });
  }

  /**
   * Handles keyboard input.
   * @param event
   */
  function keydown (event) {
    switch (event.keyCode) {
      case $mdConstant.KEY_CODE.DOWN_ARROW:
        if (ctrl.loading) return;
        event.stopPropagation();
        event.preventDefault();
        ctrl.index   = Math.min(ctrl.index + 1, ctrl.matches.length - 1);
        updateScroll();
        reportMessages(false, ReportType.Selected);
        break;
      case $mdConstant.KEY_CODE.UP_ARROW:
        if (ctrl.loading) return;
        event.stopPropagation();
        event.preventDefault();
        ctrl.index   = ctrl.index < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
        updateScroll();
        reportMessages(false, ReportType.Selected);
        break;
      case $mdConstant.KEY_CODE.TAB:
        // If we hit tab, assume that we've left the list so it will close
        onListLeave();

        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
        select(ctrl.index);
        break;
      case $mdConstant.KEY_CODE.ENTER:
        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
        if (hasSelection()) return;
        event.stopPropagation();
        event.preventDefault();
        select(ctrl.index);
        break;
      case $mdConstant.KEY_CODE.ESCAPE:
        event.preventDefault(); // Prevent browser from always clearing input
        if (!shouldProcessEscape()) return;
        event.stopPropagation();

        clearSelectedItem();
        if ($scope.searchText && hasEscapeOption('clear')) {
          clearSearchText();
        }

        // Manually hide (needed for mdNotFound support)
        ctrl.hidden = true;

        if (hasEscapeOption('blur')) {
          // Force the component to blur if they hit escape
          doBlur(true);
        }

        break;
      default:
    }
  }

  //-- getters

  /**
   * Returns the minimum length needed to display the dropdown.
   * @returns {*}
   */
  function getMinLength () {
    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
  }

  /**
   * Returns the display value for an item.
   * @param item
   * @returns {*}
   */
  function getDisplayValue (item) {
    return $q.when(getItemText(item) || item).then(function(itemText) {
      if (itemText && !angular.isString(itemText)) {
        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
          'Please check the `md-item-text` attribute.');
      }

      return itemText;
    });

    /**
     * Getter function to invoke user-defined expression (in the directive)
     * to convert your object to a single string.
     */
    function getItemText (item) {
      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
    }
  }

  /**
   * Returns the locals object for compiling item templates.
   * @param item
   * @returns {{}}
   */
  function getItemAsNameVal (item) {
    if (!item) return undefined;

    var locals = {};
    if (ctrl.itemName) locals[ ctrl.itemName ] = item;

    return locals;
  }

  /**
   * Returns the default index based on whether or not autoselect is enabled.
   * @returns {number}
   */
  function getDefaultIndex () {
    return $scope.autoselect ? 0 : -1;
  }

  /**
   * Sets the loading parameter and updates the hidden state.
   * @param value {boolean} Whether or not the component is currently loading.
   */
  function setLoading(value) {
    if (ctrl.loading != value) {
      ctrl.loading = value;
    }

    // Always refresh the hidden variable as something else might have changed
    ctrl.hidden = shouldHide();
  }

  /**
   * Determines if the menu should be hidden.
   * @returns {boolean}
   */
  function shouldHide () {
    if (!isSearchable()) return true;    // Hide when not able to query
    else return !shouldShow();            // Hide when the dropdown is not able to show.
  }

  /**
   * Determines whether the autocomplete is able to query within the current state.
   * @returns {boolean}
   */
  function isSearchable() {
    if (ctrl.loading && !hasMatches()) return false; // No query when query is in progress.
    else if (hasSelection()) return false;           // No query if there is already a selection
    else if (!hasFocus) return false;                // No query if the input does not have focus
    return true;
  }

  /**
   * Determines if the escape keydown should be processed
   * @returns {boolean}
   */
  function shouldProcessEscape() {
    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
  }

  /**
   * Determines if an escape option is set
   * @returns {boolean}
   */
  function hasEscapeOption(option) {
    return !$scope.escapeOptions || $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
  }

  /**
   * Determines if the menu should be shown.
   * @returns {boolean}
   */
  function shouldShow() {
    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
  }

  /**
   * Returns true if the search text has matches.
   * @returns {boolean}
   */
  function hasMatches() {
    return ctrl.matches.length ? true : false;
  }

  /**
   * Returns true if the autocomplete has a valid selection.
   * @returns {boolean}
   */
  function hasSelection() {
    return ctrl.scope.selectedItem ? true : false;
  }

  /**
   * Returns true if the loading indicator is, or should be, visible.
   * @returns {boolean}
   */
  function loadingIsVisible() {
    return ctrl.loading && !hasSelection();
  }

  /**
   * Returns the display value of the current item.
   * @returns {*}
   */
  function getCurrentDisplayValue () {
    return getDisplayValue(ctrl.matches[ ctrl.index ]);
  }

  /**
   * Determines if the minimum length is met by the search text.
   * @returns {*}
   */
  function isMinLengthMet () {
    return ($scope.searchText || '').length >= getMinLength();
  }

  //-- actions

  /**
   * Defines a public property with a handler and a default value.
   * @param key
   * @param handler
   * @param value
   */
  function defineProperty (key, handler, value) {
    Object.defineProperty(ctrl, key, {
      get: function () { return value; },
      set: function (newValue) {
        var oldValue = value;
        value        = newValue;
        handler(newValue, oldValue);
      }
    });
  }

  /**
   * Selects the item at the given index.
   * @param index
   */
  function select (index) {
    //-- force form to update state for validation
    $mdUtil.nextTick(function () {
      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
        var ngModel = elements.$.input.controller('ngModel');
        ngModel.$setViewValue(val);
        ngModel.$render();
      }).finally(function () {
        $scope.selectedItem = ctrl.matches[ index ];
        setLoading(false);
      });
    }, false);
  }

  /**
   * Clears the searchText value and selected item.
   */
  function clearValue () {
    clearSelectedItem();
    clearSearchText();
  }

  /**
   * Clears the selected item
   */
  function clearSelectedItem () {
    // Reset our variables
    ctrl.index = 0;
    ctrl.matches = [];
  }

  /**
   * Clears the searchText value
   */
  function clearSearchText () {
    // Set the loading to true so we don't see flashes of content.
    // The flashing will only occur when an async request is running.
    // So the loading process will stop when the results had been retrieved.
    setLoading(true);

    $scope.searchText = '';

    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
    // But some browsers are not detecting it properly, which means that we have to trigger the event.
    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
    // The `change` event is a good alternative and is supported by all supported browsers.
    var eventObj = document.createEvent('CustomEvent');
    eventObj.initCustomEvent('change', true, true, { value: '' });
    elements.input.dispatchEvent(eventObj);

    // For some reason, firing the above event resets the value of $scope.searchText if
    // $scope.searchText has a space character at the end, so we blank it one more time and then
    // focus.
    elements.input.blur();
    $scope.searchText = '';
    elements.input.focus();
  }

  /**
   * Fetches the results for the provided search text.
   * @param searchText
   */
  function fetchResults (searchText) {
    var items = $scope.$parent.$eval(itemExpr),
        term  = searchText.toLowerCase(),
        isList = angular.isArray(items),
        isPromise = !!items.then; // Every promise should contain a `then` property

    if (isList) onResultsRetrieved(items);
    else if (isPromise) handleAsyncResults(items);

    function handleAsyncResults(items) {
      if ( !items ) return;

      items = $q.when(items);
      fetchesInProgress++;
      setLoading(true);

      $mdUtil.nextTick(function () {
          items
            .then(onResultsRetrieved)
            .finally(function(){
              if (--fetchesInProgress === 0) {
                setLoading(false);
              }
            });
      },true, $scope);
    }

    function onResultsRetrieved(matches) {
      cache[term] = matches;

      // Just cache the results if the request is now outdated.
      // The request becomes outdated, when the new searchText has changed during the result fetching.
      if ((searchText || '') !== ($scope.searchText || '')) {
        return;
      }

      handleResults(matches);
    }
  }


  /**
   * Reports given message types to supported screenreaders.
   * @param {boolean} isPolite Whether the announcement should be polite.
   * @param {!number} types Message flags to be reported to the screenreader.
   */
  function reportMessages(isPolite, types) {

    var politeness = isPolite ? 'polite' : 'assertive';
    var messages = [];

    if (types & ReportType.Selected && ctrl.index !== -1) {
      messages.push(getCurrentDisplayValue());
    }

    if (types & ReportType.Count) {
      messages.push($q.resolve(getCountMessage()));
    }

    $q.all(messages).then(function(data) {
      $mdLiveAnnouncer.announce(data.join(' '), politeness);
    });

  }

  /**
   * Returns the ARIA message for how many results match the current query.
   * @returns {*}
   */
  function getCountMessage () {
    switch (ctrl.matches.length) {
      case 0:
        return 'There are no matches available.';
      case 1:
        return 'There is 1 match available.';
      default:
        return 'There are ' + ctrl.matches.length + ' matches available.';
    }
  }

  /**
   * Makes sure that the focused element is within view.
   */
  function updateScroll () {
    if (!elements.li[0]) return;
    var height = elements.li[0].offsetHeight,
        top = height * ctrl.index,
        bot = top + height,
        hgt = elements.scroller.clientHeight,
        scrollTop = elements.scroller.scrollTop;
    if (top < scrollTop) {
      scrollTo(top);
    } else if (bot > scrollTop + hgt) {
      scrollTo(bot - hgt);
    }
  }

  function isPromiseFetching() {
    return fetchesInProgress !== 0;
  }

  function scrollTo (offset) {
    elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
  }

  function notFoundVisible () {
    var textLength = (ctrl.scope.searchText || '').length;

    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
  }

  /**
   * Starts the query to gather the results for the current searchText.  Attempts to return cached
   * results first, then forwards the process to `fetchResults` if necessary.
   */
  function handleQuery () {
    var searchText = $scope.searchText || '';
    var term = searchText.toLowerCase();

    // If caching is enabled and the current searchText is stored in the cache
    if (!$scope.noCache && cache[term]) {
      // The results should be handled as same as a normal un-cached request does.
      handleResults(cache[term]);
    } else {
      fetchResults(searchText);
    }

    ctrl.hidden = shouldHide();
  }

  /**
   * Handles the retrieved results by showing them in the autocompletes dropdown.
   * @param results Retrieved results
   */
  function handleResults(results) {
    ctrl.matches = results;
    ctrl.hidden  = shouldHide();

    // If loading is in progress, then we'll end the progress. This is needed for example,
    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
    if (ctrl.loading) setLoading(false);

    if ($scope.selectOnMatch) selectItemOnMatch();

    positionDropdown();
    reportMessages(true, ReportType.Count);
  }

  /**
   * If there is only one matching item and the search text matches its display value exactly,
   * automatically select that item.  Note: This function is only called if the user uses the
   * `md-select-on-match` flag.
   */
  function selectItemOnMatch () {
    var searchText = $scope.searchText,
        matches    = ctrl.matches,
        item       = matches[ 0 ];
    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
      var isMatching = searchText == displayValue;
      if ($scope.matchInsensitive && !isMatching) {
        isMatching = searchText.toLowerCase() == displayValue.toLowerCase();
      }

      if (isMatching) select(0);
    });
  }

  /**
   * Evaluates an attribute expression against the parent scope.
   * @param {String} attr Name of the attribute to be evaluated.
   * @param {Object?} locals Properties to be injected into the evaluation context.
   */
 function evalAttr(attr, locals) {
    if ($attrs[attr]) {
      $scope.$parent.$eval($attrs[attr], locals || {});
    }
  }

}

})();
(function(){
"use strict";


MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
    .module('material.components.autocomplete')
    .directive('mdAutocomplete', MdAutocomplete);

/**
 * @ngdoc directive
 * @name mdAutocomplete
 * @module material.components.autocomplete
 *
 * @description
 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
 *     custom query. This component allows you to provide real-time suggestions as the user types
 *     in the input area.
 *
 * To start, you will need to specify the required parameters and provide a template for your
 *     results. The content inside `md-autocomplete` will be treated as a template.
 *
 * In more complex cases, you may want to include other content such as a message to display when
 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
 *     adding a tag for `md-not-found`.  An example of this is shown below.
 *
 * To reset the displayed value you must clear both values for `md-search-text` and `md-selected-item`.
 *
 * ### Validation
 *
 * You can use `ng-messages` to include validation the same way that you would normally validate;
 *     however, if you want to replicate a standard input with a floating label, you will have to
 *     do the following:
 *
 * - Make sure that your template is wrapped in `md-item-template`
 * - Add your `ng-messages` code inside of `md-autocomplete`
 * - Add your validation properties to `md-autocomplete` (ie. `required`)
 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
 *
 * There is an example below of how this should look.
 *
 * ### Snapping Drop-Down
 *
 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
 *     (ie. `md-autocomplete-snap="width"`).
 *
 * ### Notes
 *
 * **Autocomplete Dropdown Items Rendering**
 *
 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeat</a>
 * directive for displaying the results inside of the dropdown.<br/>
 *
 * > When encountering issues regarding the item template please take a look at the
 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
 *
 * **Autocomplete inside of a Virtual Repeat**
 *
 * When using the `md-autocomplete` directive inside of a
 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items might
 * not update properly, because caching of the results is enabled by default.
 *
 * The autocomplete will then show invalid dropdown items, because the VirtualRepeat only updates the
 * scope bindings, rather than re-creating the `md-autocomplete` and the previous cached results will be used.
 *
 * > To avoid such problems ensure that the autocomplete does not cache any results.
 *
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-no-cache="true"
 *       md-selected-item="selectedItem"
 *       md-items="item in items"
 *       md-search-text="searchText"
 *       md-item-text="item.display">
 *     <span>{{ item.display }}</span>
 *   </md-autocomplete>
 * </hljs>
 *
 *
 *
 * @param {expression} md-items An expression in the format of `item in results` to iterate over
 *     matches for your search.<br/><br/>
 *     The `results` expression can be also a function, which returns the results synchronously
 *     or asynchronously (per Promise)
 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
 *     selected
 * @param {expression=} md-search-text-change An expression to be run each time the search text
 *     updates
 * @param {expression=} md-search-text A model to bind the search query text to
 * @param {object=} md-selected-item A model to bind the selected item to
 * @param {expression=} md-item-text An expression that will convert your object to a single string.
 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete
 * @param {boolean=} ng-disabled Determines whether or not to disable the input field
 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
 *     which will evaluate to false, when no item is currently selected.
 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
 *     make suggestions
 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
 *     for results
 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show up or not.
 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a `$mdDialog`,
 *     `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening. <br/><br/>
 *     Also the autocomplete will immediately focus the input element.
 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating label
 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
 *     in the dropdown upon open.
 * @param {string=} md-menu-class This will be applied to the dropdown menu for styling
 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
 *     `md-input-container`
 * @param {string=} md-input-name The name attribute given to the input element to be used with
 *     FormController
 * @param {string=} md-select-on-focus When present the inputs text will be automatically selected
 *     on focus.
 * @param {string=} md-input-id An ID to be added to the input element
 * @param {number=} md-input-minlength The minimum length for the input's value for validation
 * @param {number=} md-input-maxlength The maximum length for the input's value for validation
 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select exact
 *     the item if the search text is an exact match. <br/><br/>
 *     Exact match means that there is only one match showing up.
 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
 *     will select on case-insensitive match
 * @param {string=} md-escape-options Override escape key logic. Default is `blur clear`.<br/>
 *     Options: `blur | clear`, `none`
 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
 *     the dropdown.<br/><br/>
 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
 *     as less as possible.
 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`, `bottom`.
 * @param {string=} ng-trim If set to false, the search text will be not trimmed automatically.
 *     Defaults to true.
 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
 *     [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
 *
 * @usage
 * ### Basic Example
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display">
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-autocomplete>
 * </hljs>
 *
 * ### Example with "not found" message
 * <hljs lang="html">
 * <md-autocomplete
 *     md-selected-item="selectedItem"
 *     md-search-text="searchText"
 *     md-items="item in getMatches(searchText)"
 *     md-item-text="item.display">
 *   <md-item-template>
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-item-template>
 *   <md-not-found>
 *     No matches found.
 *   </md-not-found>
 * </md-autocomplete>
 * </hljs>
 *
 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
 *     different parts that make up our component.
 *
 * ### Clear button for the input
 * By default, for floating label autocomplete's the clear button is not showing up
 * ([See specs](https://material.google.com/components/text-fields.html#text-fields-auto-complete-text-field))
 *
 * Nevertheless, developers are able to explicitly toggle the clear button for all types of autocomplete's.
 *
 * <hljs lang="html">
 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
 * </hljs>
 *
 * ### Example with validation
 * <hljs lang="html">
 * <form name="autocompleteForm">
 *   <md-autocomplete
 *       required
 *       md-input-name="autocomplete"
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display">
 *     <md-item-template>
 *       <span md-highlight-text="searchText">{{item.display}}</span>
 *     </md-item-template>
 *     <div ng-messages="autocompleteForm.autocomplete.$error">
 *       <div ng-message="required">This field is required</div>
 *     </div>
 *   </md-autocomplete>
 * </form>
 * </hljs>
 *
 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
 *     input validation for the field.
 *
 * ### Asynchronous Results
 * The autocomplete items expression also supports promises, which will resolve with the query results.
 *
 * <hljs lang="js">
 *   function AppController($scope, $http) {
 *     $scope.query = function(searchText) {
 *       return $http
 *         .get(BACKEND_URL + '/items/' + searchText)
 *         .then(function(data) {
 *           // Map the response object to the data object.
 *           return data;
 *         });
 *     };
 *   }
 * </hljs>
 *
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in query(searchText)">
 *     <md-item-template>
 *       <span md-highlight-text="searchText">{{item}}</span>
 *     </md-item-template>
 * </md-autocomplete>
 * </hljs>
 *
 */

function MdAutocomplete ($$mdSvgRegistry) {

  return {
    controller:   'MdAutocompleteCtrl',
    controllerAs: '$mdAutocompleteCtrl',
    scope:        {
      inputName:        '@mdInputName',
      inputMinlength:   '@mdInputMinlength',
      inputMaxlength:   '@mdInputMaxlength',
      searchText:       '=?mdSearchText',
      selectedItem:     '=?mdSelectedItem',
      itemsExpr:        '@mdItems',
      itemText:         '&mdItemText',
      placeholder:      '@placeholder',
      noCache:          '=?mdNoCache',
      requireMatch:     '=?mdRequireMatch',
      selectOnMatch:    '=?mdSelectOnMatch',
      matchInsensitive: '=?mdMatchCaseInsensitive',
      itemChange:       '&?mdSelectedItemChange',
      textChange:       '&?mdSearchTextChange',
      minLength:        '=?mdMinLength',
      delay:            '=?mdDelay',
      autofocus:        '=?mdAutofocus',
      floatingLabel:    '@?mdFloatingLabel',
      autoselect:       '=?mdAutoselect',
      menuClass:        '@?mdMenuClass',
      inputId:          '@?mdInputId',
      escapeOptions:    '@?mdEscapeOptions',
      dropdownItems:    '=?mdDropdownItems',
      dropdownPosition: '@?mdDropdownPosition',
      clearButton:      '=?mdClearButton'
    },
    compile: function(tElement, tAttrs) {
      var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
      var input = tElement.find('input');

      attributes.forEach(function(attribute) {
        var attrValue = tAttrs[tAttrs.$normalize(attribute)];

        if (attrValue !== null) {
          input.attr(attribute, attrValue);
        }
      });

      return function(scope, element, attrs, ctrl) {
        // Retrieve the state of using a md-not-found template by using our attribute, which will
        // be added to the element in the template function.
        ctrl.hasNotFound = !!element.attr('md-has-not-found');

        // By default the inset autocomplete should show the clear button when not explicitly overwritten.
        if (!angular.isDefined(attrs.mdClearButton) && !scope.floatingLabel) {
          scope.clearButton = true;
        }
      }
    },
    template:     function (element, attr) {
      var noItemsTemplate = getNoItemsTemplate(),
          itemTemplate    = getItemTemplate(),
          leftover        = element.html(),
          tabindex        = attr.tabindex;

      // Set our attribute for the link function above which runs later.
      // We will set an attribute, because otherwise the stored variables will be trashed when
      // removing the element is hidden while retrieving the template. For example when using ngIf.
      if (noItemsTemplate) element.attr('md-has-not-found', true);

      // Always set our tabindex of the autocomplete directive to -1, because our input
      // will hold the actual tabindex.
      element.attr('tabindex', '-1');

      return '\
        <md-autocomplete-wrap\
            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
                        \'md-show-clear-button\': !!clearButton }">\
          ' + getInputElement() + '\
          ' + getClearButton() + '\
          <md-progress-linear\
              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
              md-mode="indeterminate"></md-progress-linear>\
          <md-virtual-repeat-container\
              md-auto-shrink\
              md-auto-shrink-min="1"\
              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
              ng-mouseup="$mdAutocompleteCtrl.mouseUp()"\
              ng-hide="$mdAutocompleteCtrl.hidden"\
              class="md-autocomplete-suggestions-container md-whiteframe-z1"\
              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
              role="presentation">\
            <ul class="md-autocomplete-suggestions"\
                ng-class="::menuClass"\
                id="ul-{{$mdAutocompleteCtrl.id}}">\
              <li md-virtual-repeat="item in $mdAutocompleteCtrl.matches"\
                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
                  ng-click="$mdAutocompleteCtrl.select($index)"\
                  md-extra-name="$mdAutocompleteCtrl.itemName">\
                  ' + itemTemplate + '\
                  </li>' + noItemsTemplate + '\
            </ul>\
          </md-virtual-repeat-container>\
        </md-autocomplete-wrap>';

      function getItemTemplate() {
        var templateTag = element.find('md-item-template').detach(),
            html = templateTag.length ? templateTag.html() : element.html();
        if (!templateTag.length) element.empty();
        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html + '</md-autocomplete-parent-scope>';
      }

      function getNoItemsTemplate() {
        var templateTag = element.find('md-not-found').detach(),
            template = templateTag.length ? templateTag.html() : '';
        return template
            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()"\
                         md-autocomplete-parent-scope>' + template + '</li>'
            : '';

      }

      function getInputElement () {
        if (attr.mdFloatingLabel) {
          return '\
            <md-input-container ng-if="floatingLabel">\
              <label>{{floatingLabel}}</label>\
              <input type="search"\
                  ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
                  id="{{ inputId || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
                  name="{{inputName}}"\
                  autocomplete="off"\
                  ng-required="$mdAutocompleteCtrl.isRequired"\
                  ng-readonly="$mdAutocompleteCtrl.isReadonly"\
                  ng-minlength="inputMinlength"\
                  ng-maxlength="inputMaxlength"\
                  ng-disabled="$mdAutocompleteCtrl.isDisabled"\
                  ng-model="$mdAutocompleteCtrl.scope.searchText"\
                  ng-model-options="{ allowInvalid: true }"\
                  ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
                  ng-blur="$mdAutocompleteCtrl.blur($event)"\
                  ng-focus="$mdAutocompleteCtrl.focus($event)"\
                  aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
                  aria-label="{{floatingLabel}}"\
                  aria-autocomplete="list"\
                  role="combobox"\
                  aria-haspopup="true"\
                  aria-activedescendant=""\
                  aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>\
              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
            </md-input-container>';
        } else {
          return '\
            <input type="search"\
                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
                id="{{ inputId || \'input-\' + $mdAutocompleteCtrl.id }}"\
                name="{{inputName}}"\
                ng-if="!floatingLabel"\
                autocomplete="off"\
                ng-required="$mdAutocompleteCtrl.isRequired"\
                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
                ng-minlength="inputMinlength"\
                ng-maxlength="inputMaxlength"\
                ng-model="$mdAutocompleteCtrl.scope.searchText"\
                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
                ng-blur="$mdAutocompleteCtrl.blur($event)"\
                ng-focus="$mdAutocompleteCtrl.focus($event)"\
                placeholder="{{placeholder}}"\
                aria-owns="ul-{{$mdAutocompleteCtrl.id}}"\
                aria-label="{{placeholder}}"\
                aria-autocomplete="list"\
                role="combobox"\
                aria-haspopup="true"\
                aria-activedescendant=""\
                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"/>';
        }
      }

      function getClearButton() {
        return '' +
          '<button ' +
              'type="button" ' +
              'aria-label="Clear Input" ' +
              'tabindex="-1" ' +
              'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText" ' +
              'ng-click="$mdAutocompleteCtrl.clear($event)">' +
            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
          '</button>';
        }
    }
  };
}

})();
(function(){
"use strict";


MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
  .module('material.components.autocomplete')
  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);

function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
  return {
    restrict: 'AE',
    compile: compile,
    terminal: true,
    transclude: 'element'
  };

  function compile(tElement, tAttr, transclude) {
    return function postLink(scope, element, attr) {
      var ctrl = scope.$mdAutocompleteCtrl;
      var newScope = ctrl.parent.$new();
      var itemName = ctrl.itemName;

      // Watch for changes to our scope's variables and copy them to the new scope
      watchVariable('$index', '$index');
      watchVariable('item', itemName);

      // Ensure that $digest calls on our scope trigger $digest on newScope.
      connectScopes();

      // Link the element against newScope.
      transclude(newScope, function(clone) {
        element.after(clone);
      });

      /**
       * Creates a watcher for variables that are copied from the parent scope
       * @param variable
       * @param alias
       */
      function watchVariable(variable, alias) {
        newScope[alias] = scope[variable];

        scope.$watch(variable, function(value) {
          $mdUtil.nextTick(function() {
            newScope[alias] = value;
          });
        });
      }

      /**
       * Creates watchers on scope and newScope that ensure that for any
       * $digest of scope, newScope is also $digested.
       */
      function connectScopes() {
        var scopeDigesting = false;
        var newScopeDigesting = false;

        scope.$watch(function() {
          if (newScopeDigesting || scopeDigesting) {
            return;
          }

          scopeDigesting = true;
          scope.$$postDigest(function() {
            if (!newScopeDigesting) {
              newScope.$digest();
            }

            scopeDigesting = newScopeDigesting = false;
          });
        });

        newScope.$watch(function() {
          newScopeDigesting = true;
        });
      }
    };
  }
}
})();
(function(){
"use strict";


MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs"];angular
    .module('material.components.autocomplete')
    .controller('MdHighlightCtrl', MdHighlightCtrl);

function MdHighlightCtrl ($scope, $element, $attrs) {
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;

  // Cache the Regex to avoid rebuilding each time.
  this.regex = null;
}

MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {

  this.flags = this.$attrs.mdHighlightFlags || '';

  this.unregisterFn = this.$scope.$watch(function($scope) {
    return {
      term: unsafeTermFn($scope),
      contentText: unsafeContentFn($scope)
    };
  }.bind(this), this.onRender.bind(this), true);

  this.$element.on('$destroy', this.unregisterFn);
};

/**
 * Triggered once a new change has been recognized and the highlighted
 * text needs to be updated.
 */
MdHighlightCtrl.prototype.onRender = function(state, prevState) {

  var contentText = state.contentText;

  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
  if (this.regex === null || state.term !== prevState.term) {
    this.regex = this.createRegex(state.term, this.flags);
  }

  /* If a term is available apply the regex to the content */
  if (state.term) {
    this.applyRegex(contentText);
  } else {
    this.$element.text(contentText);
  }

};

/**
 * Decomposes the specified text into different tokens (whether match or not).
 * Breaking down the string guarantees proper XSS protection due to the native browser
 * escaping of unsafe text.
 */
MdHighlightCtrl.prototype.applyRegex = function(text) {
  var tokens = this.resolveTokens(text);

  this.$element.empty();

  tokens.forEach(function (token) {

    if (token.isMatch) {
      var tokenEl = angular.element('<span class="highlight">').text(token.text);

      this.$element.append(tokenEl);
    } else {
      this.$element.append(document.createTextNode(token));
    }

  }.bind(this));

};

  /**
 * Decomposes the specified text into different tokens by running the regex against the text.
 */
MdHighlightCtrl.prototype.resolveTokens = function(string) {
  var tokens = [];
  var lastIndex = 0;

  // Use replace here, because it supports global and single regular expressions at same time.
  string.replace(this.regex, function(match, index) {
    appendToken(lastIndex, index);

    tokens.push({
      text: match,
      isMatch: true
    });

    lastIndex = index + match.length;
  });

  // Append the missing text as a token.
  appendToken(lastIndex);

  return tokens;

  function appendToken(from, to) {
    var targetText = string.slice(from, to);
    targetText && tokens.push(targetText);
  }
};

/** Creates a regex for the specified text with the given flags. */
MdHighlightCtrl.prototype.createRegex = function(term, flags) {
  var startFlag = '', endFlag = '';
  var regexTerm = this.sanitizeRegex(term);

  if (flags.indexOf('^') >= 0) startFlag = '^';
  if (flags.indexOf('$') >= 0) endFlag = '$';

  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$\^]/g, ''));
};

/** Sanitizes a regex by removing all common RegExp identifiers */
MdHighlightCtrl.prototype.sanitizeRegex = function(term) {
  return term && term.toString().replace(/[\\\^\$\*\+\?\.\(\)\|\{}\[\]]/g, '\\$&');
};

})();
(function(){
"use strict";


MdHighlight.$inject = ["$interpolate", "$parse"];angular
    .module('material.components.autocomplete')
    .directive('mdHighlightText', MdHighlight);

/**
 * @ngdoc directive
 * @name mdHighlightText
 * @module material.components.autocomplete
 *
 * @description
 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
 *     be styled through CSS.  Please note that child elements may not be used with this directive.
 *
 * @param {string} md-highlight-text A model to be searched for
 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
 * #### **Supported flags**:
 * - `g`: Find all matches within the provided text
 * - `i`: Ignore case when searching for matches
 * - `$`: Only match if the text ends with the search term
 * - `^`: Only match if the text begins with the search term
 *
 * @usage
 * <hljs lang="html">
 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
 * <ul>
 *   <li ng-repeat="result in results" md-highlight-text="searchTerm">
 *     {{result.text}}
 *   </li>
 * </ul>
 * </hljs>
 */

function MdHighlight ($interpolate, $parse) {
  return {
    terminal: true,
    controller: 'MdHighlightCtrl',
    compile: function mdHighlightCompile(tElement, tAttr) {
      var termExpr = $parse(tAttr.mdHighlightText);
      var unsafeContentExpr = $interpolate(tElement.html());

      return function mdHighlightLink(scope, element, attr, ctrl) {
        ctrl.init(termExpr, unsafeContentExpr);
      };
    }
  };
}

})();
(function(){
"use strict";


MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
  .module('material.components.chips')
  .controller('MdChipCtrl', MdChipCtrl);

/**
 * Controller for the MdChip component. Responsible for handling keyboard
 * events and editting the chip if needed.
 *
 * @param $scope
 * @param $element
 * @param $mdConstant
 * @param $timeout
 * @param $mdUtil
 * @constructor
 */
function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
  /**
   * @type {$scope}
   */
  this.$scope = $scope;

  /**
   * @type {$element}
   */
  this.$element = $element;

  /**
   * @type {$mdConstant}
   */
  this.$mdConstant = $mdConstant;

  /**
   * @type {$timeout}
   */
  this.$timeout = $timeout;

  /**
   * @type {$mdUtil}
   */
  this.$mdUtil = $mdUtil;

  /**
   * @type {boolean}
   */
  this.isEditting = false;

  /**
   * @type {MdChipsCtrl}
   */
  this.parentController = undefined;

  /**
   * @type {boolean}
   */
  this.enableChipEdit = false;
}


/**
 * @param {MdChipsCtrl} controller
 */
MdChipCtrl.prototype.init = function(controller) {
  this.parentController = controller;
  this.enableChipEdit = this.parentController.enableChipEdit;

  if (this.enableChipEdit) {
    this.$element.on('keydown', this.chipKeyDown.bind(this));
    this.$element.on('mousedown', this.chipMouseDown.bind(this));
    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
  }
};


/**
 * @return {Object}
 */
MdChipCtrl.prototype.getChipContent = function() {
  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
  return angular.element(chipContents[0]);
};


/**
 * @return {Object}
 */
MdChipCtrl.prototype.getContentElement = function() {
  return angular.element(this.getChipContent().children()[0]);
};


/**
 * @return {number}
 */
MdChipCtrl.prototype.getChipIndex = function() {
  return parseInt(this.$element.attr('index'));
};


/**
 * Presents an input element to edit the contents of the chip.
 */
MdChipCtrl.prototype.goOutOfEditMode = function() {
  if (!this.isEditting) return;

  this.isEditting = false;
  this.$element.removeClass('_md-chip-editing');
  this.getChipContent()[0].contentEditable = 'false';
  var chipIndex = this.getChipIndex();

  var content = this.getContentElement().text();
  if (content) {
    this.parentController.updateChipContents(
        chipIndex,
        this.getContentElement().text()
    );

    this.$mdUtil.nextTick(function() {
      if (this.parentController.selectedChip === chipIndex) {
        this.parentController.focusChip(chipIndex);
      }
    }.bind(this));
  } else {
    this.parentController.removeChipAndFocusInput(chipIndex);
  }
};


/**
 * Given an HTML element. Selects contents of it.
 * @param node
 */
MdChipCtrl.prototype.selectNodeContents = function(node) {
  var range, selection;
  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(node);
    range.select();
  } else if (window.getSelection) {
    selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(node);
    selection.removeAllRanges();
    selection.addRange(range);
  }
};


/**
 * Presents an input element to edit the contents of the chip.
 */
MdChipCtrl.prototype.goInEditMode = function() {
  this.isEditting = true;
  this.$element.addClass('_md-chip-editing');
  this.getChipContent()[0].contentEditable = 'true';
  this.getChipContent().on('blur', function() {
    this.goOutOfEditMode();
  }.bind(this));

  this.selectNodeContents(this.getChipContent()[0]);
};


/**
 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
 * set to true, space or enter keys can trigger going into edit mode. Enter can also
 * trigger submitting if the chip is already being edited.
 * @param event
 */
MdChipCtrl.prototype.chipKeyDown = function(event) {
  if (!this.isEditting &&
    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
    event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
    event.preventDefault();
    this.goInEditMode();
  } else if (this.isEditting &&
    event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
    event.preventDefault();
    this.goOutOfEditMode();
  }
};


/**
 * Handles the double click event
 */
MdChipCtrl.prototype.chipMouseDown = function() {
  if(this.getChipIndex() == this.parentController.selectedChip &&
    this.enableChipEdit &&
    !this.isEditting) {
    this.goInEditMode();
  }
};

})();
(function(){
"use strict";


MdChip.$inject = ["$mdTheming", "$mdUtil", "$compile", "$timeout"];angular
  .module('material.components.chips')
  .directive('mdChip', MdChip);

/**
 * @ngdoc directive
 * @name mdChip
 * @module material.components.chips
 *
 * @description
 * `<md-chip>` is a component used within `<md-chips>` and is responsible for rendering individual
 * chips.
 *
 *
 * @usage
 * <hljs lang="html">
 *   <md-chip>{{$chip}}</md-chip>
 * </hljs>
 *
 */

// This hint text is hidden within a chip but used by screen readers to
// inform the user how they can interact with a chip.
var DELETE_HINT_TEMPLATE = '\
    <span ng-if="!$mdChipsCtrl.readonly" class="md-visually-hidden">\
      {{$mdChipsCtrl.deleteHint}}\
    </span>';

/**
 * MDChip Directive Definition
 *
 * @param $mdTheming
 * @param $mdUtil
 * @ngInject
 */
function MdChip($mdTheming, $mdUtil, $compile, $timeout) {
  var deleteHintTemplate = $mdUtil.processTemplate(DELETE_HINT_TEMPLATE);

  return {
    restrict: 'E',
    require: ['^?mdChips', 'mdChip'],
    link: postLink,
    controller: 'MdChipCtrl'
  };

  function postLink(scope, element, attr, ctrls) {
    var chipsController = ctrls.shift();
    var chipController = ctrls.shift();
    var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));

    $mdTheming(element);

    if (chipsController) {
      chipController.init(chipsController);

      // Append our delete hint to the div.md-chip-content (which does not exist at compile time)
      chipContentElement.append($compile(deleteHintTemplate)(scope));

      // When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
      // through elements works properly
      chipContentElement.on('blur', function() {
        chipsController.resetSelectedChip();
        chipsController.$scope.$applyAsync();
      });
    }

    // Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
    $timeout(function() {
      if (!chipsController) {
        return;
      }

      if (chipsController.shouldFocusLastChip) {
        chipsController.focusLastChipThenInput();
      }
    });
  }
}

})();
(function(){
"use strict";


MdChipRemove.$inject = ["$timeout"];angular
    .module('material.components.chips')
    .directive('mdChipRemove', MdChipRemove);

/**
 * @ngdoc directive
 * @name mdChipRemove
 * @restrict A
 * @module material.components.chips
 *
 * @description
 * Designates an element to be used as the delete button for a chip. <br/>
 * This element is passed as a child of the `md-chips` element.
 *
 * The designated button will be just appended to the chip and removes the given chip on click.<br/>
 * By default the button is not being styled by the `md-chips` component.
 *
 * @usage
 * <hljs lang="html">
 *   <md-chips>
 *     <button md-chip-remove="">
 *       <md-icon md-svg-icon="md-close"></md-icon>
 *     </button>
 *   </md-chips>
 * </hljs>
 */


/**
 * MdChipRemove Directive Definition.
 * 
 * @param $timeout
 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
 * @constructor
 */
function MdChipRemove ($timeout) {
  return {
    restrict: 'A',
    require: '^mdChips',
    scope: false,
    link: postLink
  };

  function postLink(scope, element, attr, ctrl) {
    element.on('click', function(event) {
      scope.$apply(function() {
        ctrl.removeChip(scope.$$replacedScope.$index);
      });
    });

    // Child elements aren't available until after a $timeout tick as they are hidden by an
    // `ng-if`. see http://goo.gl/zIWfuw
    $timeout(function() {
      element.attr({ tabindex: -1, 'aria-hidden': true });
      element.find('button').attr('tabindex', '-1');
    });
  }
}

})();
(function(){
"use strict";


MdChipTransclude.$inject = ["$compile"];angular
    .module('material.components.chips')
    .directive('mdChipTransclude', MdChipTransclude);

function MdChipTransclude ($compile) {
  return {
    restrict: 'EA',
    terminal: true,
    link: link,
    scope: false
  };
  function link (scope, element, attr) {
    var ctrl = scope.$parent.$mdChipsCtrl,
        newScope = ctrl.parent.$new(false, ctrl.parent);
    newScope.$$replacedScope = scope;
    newScope.$chip = scope.$chip;
    newScope.$index = scope.$index;
    newScope.$mdChipsCtrl = ctrl;

    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);

    element.html(newHtml);
    $compile(element.contents())(newScope);
  }
}

})();
(function(){
"use strict";

/**
 * The default chip append delay.
 *
 * @type {number}
 */
MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil"];
var DEFAULT_CHIP_APPEND_DELAY = 300;

angular
    .module('material.components.chips')
    .controller('MdChipsCtrl', MdChipsCtrl);

/**
 * Controller for the MdChips component. Responsible for adding to and
 * removing from the list of chips, marking chips as selected, and binding to
 * the models of various input components.
 *
 * @param $scope
 * @param $attrs
 * @param $mdConstant
 * @param $log
 * @param $element
 * @param $timeout
 * @param $mdUtil
 * @constructor
 */
function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil) {
  /** @type {$timeout} **/
  this.$timeout = $timeout;

  /** @type {Object} */
  this.$mdConstant = $mdConstant;

  /** @type {angular.$scope} */
  this.$scope = $scope;

  /** @type {angular.$scope} */
  this.parent = $scope.$parent;

  /** @type {$mdUtil} */
  this.$mdUtil = $mdUtil;

  /** @type {$log} */
  this.$log = $log;

  /** @type {$element} */
  this.$element = $element;

  /** @type {$attrs} */
  this.$attrs = $attrs;

  /** @type {angular.NgModelController} */
  this.ngModelCtrl = null;

  /** @type {angular.NgModelController} */
  this.userInputNgModelCtrl = null;

  /** @type {MdAutocompleteCtrl} */
  this.autocompleteCtrl = null;

  /** @type {Element} */
  this.userInputElement = null;

  /** @type {Array.<Object>} */
  this.items = [];

  /** @type {number} */
  this.selectedChip = -1;

  /** @type {string} */
  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);

  /** @type {string} */
  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);

  /**
   * The text to be used as the aria-label for the input.
   * @type {string}
   */
  this.inputAriaLabel = 'Chips input.';

  /**
   * Hidden hint text to describe the chips container. Used to give context to screen readers when
   * the chips are readonly and the input cannot be selected.
   *
   * @type {string}
   */
  this.containerHint = 'Chips container. Use arrow keys to select chips.';

  /**
   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
   * @type {string}
   */
  this.deleteHint = 'Press delete to remove this chip.';

  /**
   * Hidden label for the delete button. Used to give context to screen readers.
   * @type {string}
   */
  this.deleteButtonLabel = 'Remove';

  /**
   * Model used by the input element.
   * @type {string}
   */
  this.chipBuffer = '';

  /**
   * Whether to use the transformChip expression to transform the chip buffer
   * before appending it to the list.
   * @type {boolean}
   */
  this.useTransformChip = false;

  /**
   * Whether to use the onAdd expression to notify of chip additions.
   * @type {boolean}
   */
  this.useOnAdd = false;

  /**
   * Whether to use the onRemove expression to notify of chip removals.
   * @type {boolean}
   */
  this.useOnRemove = false;

  /**
   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
   * attribute.
   *
   * Defaults to '_md-chips-wrapper-' plus a unique number.
   *
   * @type {string}
   */
  this.wrapperId = '';

  /**
   * Array of unique numbers which will be auto-generated any time the items change, and is used to
   * create unique IDs for the aria-owns attribute.
   *
   * @type {Array}
   */
  this.contentIds = [];

  /**
   * The index of the chip that should have it's tabindex property set to 0 so it is selectable
   * via the keyboard.
   *
   * @type {int}
   */
  this.ariaTabIndex = null;

  /**
   * After appending a chip, the chip will be focused for this number of milliseconds before the
   * input is refocused.
   *
   * **Note:** This is **required** for compatibility with certain screen readers in order for
   * them to properly allow keyboard access.
   *
   * @type {number}
   */
  this.chipAppendDelay = DEFAULT_CHIP_APPEND_DELAY;

  this.init();
}

/**
 * Initializes variables and sets up watchers
 */
MdChipsCtrl.prototype.init = function() {
  var ctrl = this;

  // Set the wrapper ID
  ctrl.wrapperId = '_md-chips-wrapper-' + ctrl.$mdUtil.nextUid();

  // Setup a watcher which manages the role and aria-owns attributes
  ctrl.$scope.$watchCollection('$mdChipsCtrl.items', function() {
    // Make sure our input and wrapper have the correct ARIA attributes
    ctrl.setupInputAria();
    ctrl.setupWrapperAria();
  });

  ctrl.$attrs.$observe('mdChipAppendDelay', function(newValue) {
    ctrl.chipAppendDelay = parseInt(newValue) || DEFAULT_CHIP_APPEND_DELAY;
  });
};

/**
 * If we have an input, ensure it has the appropriate ARIA attributes.
 */
MdChipsCtrl.prototype.setupInputAria = function() {
  var input = this.$element.find('input');

  // If we have no input, just return
  if (!input) {
    return;
  }

  input.attr('role', 'textbox');
  input.attr('aria-multiline', true);
};

/**
 * Ensure our wrapper has the appropriate ARIA attributes.
 */
MdChipsCtrl.prototype.setupWrapperAria = function() {
  var ctrl = this,
      wrapper = this.$element.find('md-chips-wrap');

  if (this.items && this.items.length) {
    // Dynamically add the listbox role on every change because it must be removed when there are
    // no items.
    wrapper.attr('role', 'listbox');

    // Generate some random (but unique) IDs for each chip
    this.contentIds = this.items.map(function() {
      return ctrl.wrapperId + '-chip-' + ctrl.$mdUtil.nextUid();
    });

    // Use the contentIDs above to generate the aria-owns attribute
    wrapper.attr('aria-owns', this.contentIds.join(' '));
  } else {
    // If we have no items, then the role and aria-owns attributes MUST be removed
    wrapper.removeAttr('role');
    wrapper.removeAttr('aria-owns');
  }
};

/**
 * Handles the keydown event on the input element: by default <enter> appends
 * the buffer to the chip list, while backspace removes the last chip in the
 * list if the current buffer is empty.
 * @param event
 */
MdChipsCtrl.prototype.inputKeydown = function(event) {
  var chipBuffer = this.getChipBuffer();

  // If we have an autocomplete, and it handled the event, we have nothing to do
  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
    return;
  }

  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
    // Only select and focus the previous chip, if the current caret position of the
    // input element is at the beginning.
    if (this.getCursorPosition(event.target) !== 0) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (this.items.length) {
      this.selectAndFocusChipSafe(this.items.length - 1);
    }

    return;
  }

  // By default <enter> appends the buffer to the chip list.
  if (!this.separatorKeys || this.separatorKeys.length < 1) {
    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
  }

  // Support additional separator key codes in an array of `md-separator-keys`.
  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
    event.preventDefault();

    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
    if (this.hasMaxChipsReached()) return;

    this.appendChip(chipBuffer.trim());
    this.resetChipBuffer();

    return false;
  }
};

/**
 * Returns the cursor position of the specified input element.
 * @param element HTMLInputElement
 * @returns {Number} Cursor Position of the input.
 */
MdChipsCtrl.prototype.getCursorPosition = function(element) {
  /*
   * Figure out whether the current input for the chips buffer is valid for using
   * the selectionStart / end property to retrieve the cursor position.
   * Some browsers do not allow the use of those attributes, on different input types.
   */
  try {
    if (element.selectionStart === element.selectionEnd) {
      return element.selectionStart;
    }
  } catch (e) {
    if (!element.value) {
      return 0;
    }
  }
};


/**
 * Updates the content of the chip at given index
 * @param chipIndex
 * @param chipContents
 */
MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents){
  if(chipIndex >= 0 && chipIndex < this.items.length) {
    this.items[chipIndex] = chipContents;
    this.ngModelCtrl.$setDirty();
  }
};


/**
 * Returns true if a chip is currently being edited. False otherwise.
 * @return {boolean}
 */
MdChipsCtrl.prototype.isEditingChip = function() {
  return !!this.$element[0].querySelector('._md-chip-editing');
};


MdChipsCtrl.prototype.isRemovable = function() {
  // Return false if we have static chips
  if (!this.ngModelCtrl) {
    return false;
  }

  return this.readonly ? this.removable :
         angular.isDefined(this.removable) ? this.removable : true;
};

/**
 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
 * keys switch which chips is active
 * @param event
 */
MdChipsCtrl.prototype.chipKeydown = function (event) {
  if (this.getChipBuffer()) return;
  if (this.isEditingChip()) return;

  switch (event.keyCode) {
    case this.$mdConstant.KEY_CODE.BACKSPACE:
    case this.$mdConstant.KEY_CODE.DELETE:
      if (this.selectedChip < 0) return;
      event.preventDefault();
      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
      if (!this.isRemovable()) return;
      this.removeAndSelectAdjacentChip(this.selectedChip);
      break;
    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
      event.preventDefault();
      // By default, allow selection of -1 which will focus the input; if we're readonly, don't go
      // below 0
      if (this.selectedChip < 0 || (this.readonly && this.selectedChip == 0)) {
        this.selectedChip = this.items.length;
      }
      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
      break;
    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
      event.preventDefault();
      this.selectAndFocusChipSafe(this.selectedChip + 1);
      break;
    case this.$mdConstant.KEY_CODE.ESCAPE:
    case this.$mdConstant.KEY_CODE.TAB:
      if (this.selectedChip < 0) return;
      event.preventDefault();
      this.onFocus();
      break;
  }
};

/**
 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
 * always.
 */
MdChipsCtrl.prototype.getPlaceholder = function() {
  // Allow `secondary-placeholder` to be blank.
  var useSecondary = (this.items && this.items.length &&
      (this.secondaryPlaceholder == '' || this.secondaryPlaceholder));
  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
};

/**
 * Removes chip at {@code index} and selects the adjacent chip.
 * @param index
 */
MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index) {
  var self = this;
  var selIndex = self.getAdjacentChipIndex(index);
  var wrap = this.$element[0].querySelector('md-chips-wrap');
  var chip = this.$element[0].querySelector('md-chip[index="' + index + '"]');

  self.removeChip(index);

  // The dobule-timeout is currently necessary to ensure that the DOM has finalized and the select()
  // will find the proper chip since the selection is index-based.
  //
  // TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
  self.$timeout(function() {
    self.$timeout(function() {
      self.selectAndFocusChipSafe(selIndex);
    });
  });
};

/**
 * Sets the selected chip index to -1.
 */
MdChipsCtrl.prototype.resetSelectedChip = function() {
  this.selectedChip = -1;
  this.ariaTabIndex = null;
};

/**
 * Gets the index of an adjacent chip to select after deletion. Adjacency is
 * determined as the next chip in the list, unless the target chip is the
 * last in the list, then it is the chip immediately preceding the target. If
 * there is only one item in the list, -1 is returned (select none).
 * The number returned is the index to select AFTER the target has been
 * removed.
 * If the current chip is not selected, then -1 is returned to select none.
 */
MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
  var len = this.items.length - 1;
  return (len == 0) ? -1 :
      (index == len) ? index -1 : index;
};

/**
 * Append the contents of the buffer to the chip list. This method will first
 * call out to the md-transform-chip method, if provided.
 *
 * @param newChip
 */
MdChipsCtrl.prototype.appendChip = function(newChip) {
  this.shouldFocusLastChip = true;
  if (this.useTransformChip && this.transformChip) {
    var transformedChip = this.transformChip({'$chip': newChip});

    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
    // they want the string version.
    if (angular.isDefined(transformedChip)) {
      newChip = transformedChip;
    }
  }

  // If items contains an identical object to newChip, do not append
  if (angular.isObject(newChip)){
    var identical = this.items.some(function(item){
      return angular.equals(newChip, item);
    });
    if (identical) return;
  }

  // Check for a null (but not undefined), or existing chip and cancel appending
  if (newChip == null || this.items.indexOf(newChip) + 1) return;

  // Append the new chip onto our list
  var length = this.items.push(newChip);
  var index = length - 1;

  // Update model validation
  this.ngModelCtrl.$setDirty();
  this.validateModel();

  // If they provide the md-on-add attribute, notify them of the chip addition
  if (this.useOnAdd && this.onAdd) {
    this.onAdd({ '$chip': newChip, '$index': index });
  }
};

/**
 * Sets whether to use the md-transform-chip expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code transformChip}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useTransformChipExpression = function() {
  this.useTransformChip = true;
};

/**
 * Sets whether to use the md-on-add expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code onAdd}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useOnAddExpression = function() {
  this.useOnAdd = true;
};

/**
 * Sets whether to use the md-on-remove expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code onRemove}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useOnRemoveExpression = function() {
  this.useOnRemove = true;
};

/*
 * Sets whether to use the md-on-select expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code onSelect}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useOnSelectExpression = function() {
  this.useOnSelect = true;
};

/**
 * Gets the input buffer. The input buffer can be the model bound to the
 * default input item {@code this.chipBuffer}, the {@code selectedItem}
 * model of an {@code md-autocomplete}, or, through some magic, the model
 * bound to any inpput or text area element found within a
 * {@code md-input-container} element.
 * @return {string}
 */
MdChipsCtrl.prototype.getChipBuffer = function() {
  var chipBuffer =  !this.userInputElement ? this.chipBuffer :
                     this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
                     this.userInputElement[0].value;

  // Ensure that the chip buffer is always a string. For example, the input element buffer might be falsy.
  return angular.isString(chipBuffer) ? chipBuffer : '';
};

/**
 * Resets the input buffer for either the internal input or user provided input element.
 */
MdChipsCtrl.prototype.resetChipBuffer = function() {
  if (this.userInputElement) {
    if (this.userInputNgModelCtrl) {
      this.userInputNgModelCtrl.$setViewValue('');
      this.userInputNgModelCtrl.$render();
    } else {
      this.userInputElement[0].value = '';
    }
  } else {
    this.chipBuffer = '';
  }
};

MdChipsCtrl.prototype.hasMaxChipsReached = function() {
  if (angular.isString(this.maxChips)) this.maxChips = parseInt(this.maxChips, 10) || 0;

  return this.maxChips > 0 && this.items.length >= this.maxChips;
};

/**
 * Updates the validity properties for the ngModel.
 */
MdChipsCtrl.prototype.validateModel = function() {
  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
};

/**
 * Removes the chip at the given index.
 * @param index
 */
MdChipsCtrl.prototype.removeChip = function(index) {
  var removed = this.items.splice(index, 1);

  // Update model validation
  this.ngModelCtrl.$setDirty();
  this.validateModel();

  if (removed && removed.length && this.useOnRemove && this.onRemove) {
    this.onRemove({ '$chip': removed[0], '$index': index });
  }
};

MdChipsCtrl.prototype.removeChipAndFocusInput = function (index) {
  this.removeChip(index);

  if (this.autocompleteCtrl) {
    // Always hide the autocomplete dropdown before focusing the autocomplete input.
    // Wait for the input to move horizontally, because the chip was removed.
    // This can lead to an incorrect dropdown position.
    this.autocompleteCtrl.hidden = true;
    this.$mdUtil.nextTick(this.onFocus.bind(this));
  } else {
    this.onFocus();
  }

};
/**
 * Selects the chip at `index`,
 * @param index
 */
MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
  // If we have no chips, or are asked to select a chip before the first, just focus the input
  if (!this.items.length || index === -1) {
    return this.focusInput();
  }

  // If we are asked to select a chip greater than the number of chips...
  if (index >= this.items.length) {
    if (this.readonly) {
      // If we are readonly, jump back to the start (because we have no input)
      index = 0;
    } else {
      // If we are not readonly, we should attempt to focus the input
      return this.onFocus();
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, this.items.length - 1);

  this.selectChip(index);
  this.focusChip(index);
};

MdChipsCtrl.prototype.focusLastChipThenInput = function() {
  var ctrl = this;

  ctrl.shouldFocusLastChip = false;

  ctrl.focusChip(this.items.length - 1);

  ctrl.$timeout(function() {
    ctrl.focusInput();
  }, ctrl.chipAppendDelay);
};

MdChipsCtrl.prototype.focusInput = function() {
  this.selectChip(-1);
  this.onFocus();
};

/**
 * Marks the chip at the given index as selected.
 * @param index
 */
MdChipsCtrl.prototype.selectChip = function(index) {
  if (index >= -1 && index <= this.items.length) {
    this.selectedChip = index;

    // Fire the onSelect if provided
    if (this.useOnSelect && this.onSelect) {
      this.onSelect({'$chip': this.items[index] });
    }
  } else {
    this.$log.warn('Selected Chip index out of bounds; ignoring.');
  }
};

/**
 * Selects the chip at `index` and gives it focus.
 * @param index
 */
MdChipsCtrl.prototype.selectAndFocusChip = function(index) {
  this.selectChip(index);
  if (index != -1) {
    this.focusChip(index);
  }
};

/**
 * Call `focus()` on the chip at `index`
 */
MdChipsCtrl.prototype.focusChip = function(index) {
  var chipContent = this.$element[0].querySelector('md-chip[index="' + index + '"] .md-chip-content');

  this.ariaTabIndex = index;

  chipContent.focus();
};

/**
 * Configures the required interactions with the ngModel Controller.
 * Specifically, set {@code this.items} to the {@code NgModelCtrl#$viewVale}.
 * @param ngModelCtrl
 */
MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
  this.ngModelCtrl = ngModelCtrl;

  var self = this;
  ngModelCtrl.$render = function() {
    // model is updated. do something.
    self.items = self.ngModelCtrl.$viewValue;
  };
};

MdChipsCtrl.prototype.onFocus = function () {
  var input = this.$element[0].querySelector('input');
  input && input.focus();
  this.resetSelectedChip();
};

MdChipsCtrl.prototype.onInputFocus = function () {
  this.inputHasFocus = true;

  // Make sure we have the appropriate ARIA attributes
  this.setupInputAria();

  // Make sure we don't have any chips selected
  this.resetSelectedChip();
};

MdChipsCtrl.prototype.onInputBlur = function () {
  this.inputHasFocus = false;

  if (this.shouldAddOnBlur()) {
    this.appendChip(this.getChipBuffer().trim());
    this.resetChipBuffer();
  }
};

/**
 * Configure event bindings on a user-provided input element.
 * @param inputElement
 */
MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
  this.userInputElement = inputElement;

  // Find the NgModelCtrl for the input element
  var ngModelCtrl = inputElement.controller('ngModel');
  // `.controller` will look in the parent as well.
  if (ngModelCtrl != this.ngModelCtrl) {
    this.userInputNgModelCtrl = ngModelCtrl;
  }

  var scope = this.$scope;
  var ctrl = this;

  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
  var scopeApplyFn = function(event, fn) {
    scope.$evalAsync(angular.bind(ctrl, fn, event));
  };

  // Bind to keydown and focus events of input
  inputElement
      .attr({ tabindex: 0 })
      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown) })
      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus) })
      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur) })
};

MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
  if (ctrl) {
    this.autocompleteCtrl = ctrl;

    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
      if (item) {
        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
        if (this.hasMaxChipsReached()) return;

        this.appendChip(item);
        this.resetChipBuffer();
      }
    }));

    this.$element.find('input')
        .on('focus',angular.bind(this, this.onInputFocus) )
        .on('blur', angular.bind(this, this.onInputBlur) );
  }
};

/**
 * Whether the current chip buffer should be added on input blur or not.
 * @returns {boolean}
 */
MdChipsCtrl.prototype.shouldAddOnBlur = function() {

  // Update the custom ngModel validators from the chips component.
  this.validateModel();

  var chipBuffer = this.getChipBuffer().trim();
  var isModelValid = this.ngModelCtrl.$valid;
  var isAutocompleteShowing = this.autocompleteCtrl && !this.autocompleteCtrl.hidden;

  if (this.userInputNgModelCtrl) {
    isModelValid = isModelValid && this.userInputNgModelCtrl.$valid;
  }

  return this.addOnBlur && !this.requireMatch && chipBuffer && isModelValid && !isAutocompleteShowing;
};

MdChipsCtrl.prototype.hasFocus = function () {
  return this.inputHasFocus || this.selectedChip >= 0;
};

MdChipsCtrl.prototype.contentIdFor = function(index) {
  return this.contentIds[index];
};

})();
(function(){
"use strict";

  
  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
      .module('material.components.chips')
      .directive('mdChips', MdChips);

  /**
   * @ngdoc directive
   * @name mdChips
   * @module material.components.chips
   *
   * @description
   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
   * displayed as 'chips'. This component can make use of an `<input>` element or an 
   * `<md-autocomplete>` element.
   *
   * ### Custom templates
   * A custom template may be provided to render the content of each chip. This is achieved by
   * specifying an `<md-chip-template>` element containing the custom content as a child of
   * `<md-chips>`.
   *
   * Note: Any attributes on
   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
   * the chip object and its index in the list of chips, respectively.
   * To override the chip delete control, include an element (ideally a button) with the attribute
   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
   * is also placed as a sibling to the chip content (on which there are also click listeners) to
   * avoid a nested ng-click situation.
   *
   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
   * future developers and those looking at the documentation.
   *
   * <h3> Pending Features </h3>
   * <ul style="padding-left:20px;">
   *
   *   <ul>Style
   *     <li>Colours for hover, press states (ripple?).</li>
   *   </ul>
   *
   *   <ul>Validation
   *     <li>allow a validation callback</li>
   *     <li>highlighting style for invalid chips</li>
   *   </ul>
   *
   *   <ul>Item mutation
   *     <li>Support `
   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
   *       click?
   *     </li>
   *   </ul>
   *
   *   <ul>Truncation and Disambiguation (?)
   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
   *     indistinguishable.</li>
   *   </ul>
   *
   *   <ul>Drag and Drop
   *     <li>Drag and drop chips between related `<md-chips>` elements.
   *     </li>
   *   </ul>
   * </ul>
   *
   * //-->
   *
   * Sometimes developers want to limit the amount of possible chips.<br/>
   * You can specify the maximum amount of chips by using the following markup.
   *
   * <hljs lang="html">
   *   <md-chips
   *       ng-model="myItems"
   *       placeholder="Add an item"
   *       md-max-chips="5">
   *   </md-chips>
   * </hljs>
   *
   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
   * When the maximum amount of chips has been reached, you can also disable the autocomplete selection.<br/>
   * Here is an example markup.
   *
   * <hljs lang="html">
   *   <md-chips ng-model="myItems" md-max-chips="5">
   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
   *   </md-chips>
   * </hljs>
   *
   * ### Accessibility
   *
   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
   * order to achieve this, we modified the chips behavior to select newly appended chips for
   * `300ms` before re-focusing the input and allowing the user to type.
   *
   * For most users, this delay is small enough that it will not be noticeable but allows certain
   * screen readers to function properly (JAWS and NVDA in particular).
   *
   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
   * behavior.
   *
   * Please refer to the documentation of this option (below) for more information.
   *
   * @param {string=|object=} ng-model A model to which the list of items will be bound.
   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
   *    displayed when there is at least one item in the list
   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
   *    removal icon or the Delete/Backspace key. Defaults to true.
   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
   *    marked as readonly.<br/><br/>
   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and disabled.
   * @param {string=} md-enable-chip-edit Set this to "true" to enable editing of chip contents. The user can 
   *    go into edit mode with pressing "space", "enter", or double clicking on the chip. Chip edit is only
   *    supported for chips with basic template.
   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
   *    amount is reached.
   * @param {boolean=} md-add-on-blur When set to true, remaining text inside of the input will
   *    be converted into a new chip on blur.
   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when called
   *    expects one of the following return values:
   *    - an object representing the `$chip` input string
   *    - `undefined` to simply add the `$chip` input string, or
   *    - `null` to prevent the chip from being appended
   * @param {expression=} md-on-add An expression which will be called when a chip has been
   *    added.
   * @param {expression=} md-on-remove An expression which will be called when a chip has been
   *    removed.
   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
   * @param {boolean} md-require-match If true, and the chips template contains an autocomplete,
   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
   * @param {string=} input-aria-label A string read by screen readers to identify the input.
   * @param {string=} container-hint A string read by screen readers informing users of how to
   *    navigate the chips. Used in readonly mode.
   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
   *    the delete key will remove the chip.
   * @param {string=} delete-button-label A label for the delete button. Also hidden and read by
   *    screen readers.
   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
   *
   *    _Available since Version 1.1.2._
   *
   *    **Note:** You can safely set this to `0` in one of the following two instances:
   *
   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
   *    only ChromeVox users.
   *
   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
   *    favor of another one (such as `,` or `;`).
   *
   * @usage
   * <hljs lang="html">
   *   <md-chips
   *       ng-model="myItems"
   *       placeholder="Add an item"
   *       readonly="isReadOnly">
   *   </md-chips>
   * </hljs>
   *
   * <h3>Validation</h3>
   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
   * on our custom validators.
   * <hljs lang="html">
   *   <form name="userForm">
   *     <md-chips
   *       name="fruits"
   *       ng-model="myItems"
   *       placeholder="Add an item"
   *       md-max-chips="5">
   *     </md-chips>
   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
   *    </div>
   *   </form>
   * </hljs>
   *
   */

  var MD_CHIPS_TEMPLATE = '\
      <md-chips-wrap\
          id="{{$mdChipsCtrl.wrapperId}}"\
          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
          aria-setsize="{{$mdChipsCtrl.items.length}}"\
          class="md-chips">\
        <span ng-if="$mdChipsCtrl.readonly" class="md-visually-hidden">\
          {{$mdChipsCtrl.containerHint}}\
        </span>\
        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
            index="{{$index}}"\
            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
          <div class="md-chip-content"\
              tabindex="{{$mdChipsCtrl.ariaTabIndex == $index ? 0 : -1}}"\
              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
              role="option"\
              aria-selected="{{$mdChipsCtrl.selectedChip == $index}}" \
              aria-posinset="{{$index}}"\
              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
          <div ng-if="$mdChipsCtrl.isRemovable()"\
               class="md-chip-remove-container"\
               tabindex="-1"\
               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
        </md-chip>\
        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
        </div>\
      </md-chips-wrap>';

  var CHIP_INPUT_TEMPLATE = '\
        <input\
            class="md-input"\
            tabindex="0"\
            aria-label="{{$mdChipsCtrl.inputAriaLabel}}" \
            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
            ng-model="$mdChipsCtrl.chipBuffer"\
            ng-focus="$mdChipsCtrl.onInputFocus()"\
            ng-blur="$mdChipsCtrl.onInputBlur()"\
            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';

  var CHIP_DEFAULT_TEMPLATE = '\
      <span>{{$chip}}</span>';

  var CHIP_REMOVE_TEMPLATE = '\
      <button\
          class="md-chip-remove"\
          ng-if="$mdChipsCtrl.isRemovable()"\
          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)"\
          type="button"\
          tabindex="-1">\
        <md-icon md-svg-src="{{ $mdChipsCtrl.mdCloseIcon }}"></md-icon>\
        <span class="md-visually-hidden">\
          {{$mdChipsCtrl.deleteButtonLabel}}\
        </span>\
      </button>';

  /**
   * MDChips Directive Definition
   */
  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
    var templates = getTemplates();

    return {
      template: function(element, attrs) {
        // Clone the element into an attribute. By prepending the attribute
        // name with '$', AngularJS won't write it into the DOM. The cloned
        // element propagates to the link function via the attrs argument,
        // where various contained-elements can be consumed.
        attrs['$mdUserTemplate'] = element.clone();
        return templates.chips;
      },
      require: ['mdChips'],
      restrict: 'E',
      controller: 'MdChipsCtrl',
      controllerAs: '$mdChipsCtrl',
      bindToController: true,
      compile: compile,
      scope: {
        readonly: '=readonly',
        removable: '=mdRemovable',
        placeholder: '@',
        secondaryPlaceholder: '@',
        maxChips: '@mdMaxChips',
        transformChip: '&mdTransformChip',
        onAppend: '&mdOnAppend',
        onAdd: '&mdOnAdd',
        onRemove: '&mdOnRemove',
        onSelect: '&mdOnSelect',
        inputAriaLabel: '@',
        containerHint: '@',
        deleteHint: '@',
        deleteButtonLabel: '@',
        separatorKeys: '=?mdSeparatorKeys',
        requireMatch: '=?mdRequireMatch',
        chipAppendDelayString: '@?mdChipAppendDelay'
      }
    };

    /**
     * Builds the final template for `md-chips` and returns the postLink function.
     *
     * Building the template involves 3 key components:
     * static chips
     * chip template
     * input control
     *
     * If no `ng-model` is provided, only the static chip work needs to be done.
     *
     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
     * template is appended to the chip content element.
     *
     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
     *
     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
     * If no user input is provided, a default one is appended to the input container node in the
     * template.
     *
     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
     * transclusion in the `postLink` function.
     *
     *
     * @param element
     * @param attr
     * @returns {Function}
     */
    function compile(element, attr) {
      // Grab the user template from attr and reset the attribute to null.
      var userTemplate = attr['$mdUserTemplate'];
      attr['$mdUserTemplate'] = null;

      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');

      var chipRemoveSelector = $mdUtil
        .prefixer()
        .buildList('md-chip-remove')
        .map(function(attr) {
          return 'md-chips>*[' + attr + ']';
        })
        .join(',');

      // Set the chip remove, chip contents and chip input templates. The link function will put
      // them on the scope for transclusion later.
      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
          chipContentsTemplate = chipTemplate || templates.default,
          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
              || getTemplateByQuery('md-chips>input')
              || templates.input,
          staticChips = userTemplate.find('md-chip');

      // Warn of malformed template. See #2545
      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
      }

      function getTemplateByQuery (query) {
        if (!attr.ngModel) return;
        var element = userTemplate[0].querySelector(query);
        return element && element.outerHTML;
      }

      /**
       * Configures controller and transcludes.
       */
      return function postLink(scope, element, attrs, controllers) {
        $mdUtil.initOptionalProperties(scope, attr);

        $mdTheming(element);
        var mdChipsCtrl = controllers[0];
        if(chipTemplate) {
          // Chip editing functionality assumes we are using the default chip template.
          mdChipsCtrl.enableChipEdit = false;
        }

        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;

        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdClose;

        element
            .attr({ tabindex: -1 })
            .on('focus', function () { mdChipsCtrl.onFocus(); });

        if (attr.ngModel) {
          mdChipsCtrl.configureNgModel(element.controller('ngModel'));

          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
          // before appending chips.
          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();

          // If an `md-on-append` attribute was set, tell the controller to use the expression
          // when appending chips.
          //
          // DEPRECATED: Will remove in official 1.0 release
          if (attrs.mdOnAppend) mdChipsCtrl.useOnAppendExpression();

          // If an `md-on-add` attribute was set, tell the controller to use the expression
          // when adding chips.
          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();

          // If an `md-on-remove` attribute was set, tell the controller to use the expression
          // when removing chips.
          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();

          // If an `md-on-select` attribute was set, tell the controller to use the expression
          // when selecting chips.
          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();

          // The md-autocomplete and input elements won't be compiled until after this directive
          // is complete (due to their nested nature). Wait a tick before looking for them to
          // configure the controller.
          if (chipInputTemplate != templates.input) {
            // The autocomplete will not appear until the readonly attribute is not true (i.e.
            // false or undefined), so we have to watch the readonly and then on the next tick
            // after the chip transclusion has run, we can configure the autocomplete and user
            // input.
            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
              if (!readonly) {

                $mdUtil.nextTick(function(){

                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
                    var autocompleteEl = element.find('md-autocomplete');
                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
                  }

                  mdChipsCtrl.configureUserInput(element.find('input'));
                });
              }
            });
          }

          // At the next tick, if we find an input, make sure it has the md-input class
          $mdUtil.nextTick(function() {
            var input = element.find('input');

            input && input.toggleClass('md-input', true);
          });
        }

        // Compile with the parent's scope and prepend any static chips to the wrapper.
        if (staticChips.length > 0) {
          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
        }
      };
    }

    function getTemplates() {
      return {
        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
      };
    }
  }

})();
(function(){
"use strict";

angular
    .module('material.components.chips')
    .controller('MdContactChipsCtrl', MdContactChipsCtrl);



/**
 * Controller for the MdContactChips component
 * @constructor
 */
function MdContactChipsCtrl () {
  /** @type {Object} */
  this.selectedItem = null;

  /** @type {string} */
  this.searchText = '';
}


MdContactChipsCtrl.prototype.queryContact = function(searchText) {
  return this.contactQuery({'$query': searchText});
};


MdContactChipsCtrl.prototype.itemName = function(item) {
  return item[this.contactName];
};

})();
(function(){
"use strict";


MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
  .module('material.components.chips')
  .directive('mdContactChips', MdContactChips);

/**
 * @ngdoc directive
 * @name mdContactChips
 * @module material.components.chips
 *
 * @description
 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
 * `md-autocomplete` element. The component allows the caller to supply a query expression which
 * returns  a list of possible contacts. The user can select one of these and add it to the list of
 * chips.
 *
 * You may also use the `md-highlight-text` directive along with its parameters to control the
 * appearance of the matched text inside of the contacts' autocomplete popup.
 *
 * @param {string=|object=} ng-model A model to bind the list of items to
 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
 *    displayed when there is at least on item in the list
 * @param {expression} md-contacts An expression expected to return contacts matching the search
 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
 *    waiting for it to resolve.
 * @param {string} md-contact-name The field name of the contact object representing the
 *    contact's name.
 * @param {string} md-contact-email The field name of the contact object representing the
 *    contact's email address.
 * @param {string} md-contact-image The field name of the contact object representing the
 *    contact's image.
 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
 *    make suggestions
 *
 * @param {expression=} filter-selected Whether to filter selected contacts from the list of
 *    suggestions shown in the autocomplete.
 *
 *    ***Note:** This attribute has been removed but may come back.*
 *
 *
 *
 * @usage
 * <hljs lang="html">
 *   <md-contact-chips
 *       ng-model="ctrl.contacts"
 *       md-contacts="ctrl.querySearch($query)"
 *       md-contact-name="name"
 *       md-contact-image="image"
 *       md-contact-email="email"
 *       placeholder="To">
 *   </md-contact-chips>
 * </hljs>
 *
 */


var MD_CONTACT_CHIPS_TEMPLATE = '\
      <md-chips class="md-contact-chips"\
          ng-model="$mdContactChipsCtrl.contacts"\
          md-require-match="$mdContactChipsCtrl.requireMatch"\
          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}" \
          md-autocomplete-snap>\
          <md-autocomplete\
              md-menu-class="md-contact-chips-suggestions"\
              md-selected-item="$mdContactChipsCtrl.selectedItem"\
              md-search-text="$mdContactChipsCtrl.searchText"\
              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
              md-item-text="$mdContactChipsCtrl.itemName(item)"\
              md-no-cache="true"\
              md-min-length="$mdContactChipsCtrl.minLength"\
              md-autoselect\
              placeholder="{{$mdContactChipsCtrl.contacts.length == 0 ?\
                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
            <div class="md-contact-suggestion">\
              <img \
                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
                {{item[$mdContactChipsCtrl.contactName]}}\
              </span>\
              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
            </div>\
          </md-autocomplete>\
          <md-chip-template>\
            <div class="md-contact-avatar">\
              <img \
                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
            </div>\
            <div class="md-contact-name">\
              {{$chip[$mdContactChipsCtrl.contactName]}}\
            </div>\
          </md-chip-template>\
      </md-chips>';


/**
 * MDContactChips Directive Definition
 *
 * @param $mdTheming
 * @returns {*}
 * @ngInject
 */
function MdContactChips($mdTheming, $mdUtil) {
  return {
    template: function(element, attrs) {
      return MD_CONTACT_CHIPS_TEMPLATE;
    },
    restrict: 'E',
    controller: 'MdContactChipsCtrl',
    controllerAs: '$mdContactChipsCtrl',
    bindToController: true,
    compile: compile,
    scope: {
      contactQuery: '&mdContacts',
      placeholder: '@',
      secondaryPlaceholder: '@',
      contactName: '@mdContactName',
      contactImage: '@mdContactImage',
      contactEmail: '@mdContactEmail',
      contacts: '=ngModel',
      requireMatch: '=?mdRequireMatch',
      minLength: '=?mdMinLength',
      highlightFlags: '@?mdHighlightFlags',
      chipAppendDelay: '@?mdChipAppendDelay'
    }
  };

  function compile(element, attr) {
    return function postLink(scope, element, attrs, controllers) {
      var contactChipsController = controllers;

      $mdUtil.initOptionalProperties(scope, attr);
      $mdTheming(element);

      element.attr('tabindex', '-1');

      attrs.$observe('mdChipAppendDelay', function(newValue) {
        contactChipsController.chipAppendDelay = newValue;
      });
    };
  }
}

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name mdCalendar
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Should be a Date object.
   * @param {Date=} md-min-date Expression representing the minimum date.
   * @param {Date=} md-max-date Expression representing the maximum date.
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
   *
   * @description
   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
   *
   * @usage
   *
   * <hljs lang="html">
   *   <md-calendar ng-model="birthday"></md-calendar>
   * </hljs>
   */
  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale"];
  angular.module('material.components.datepicker')
    .directive('mdCalendar', calendarDirective);

  // POST RELEASE
  // TODO(jelbourn): Mac Cmd + left / right == Home / End
  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
  // TODO(jelbourn): Scroll snapping (virtual repeat)
  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
  // TODO(jelbourn): Month headers stick to top when scrolling.
  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
  //     announcement and key handling).
  // Read-only calendar (not just date-picker).

  function calendarDirective() {
    return {
      template: function(tElement, tAttr) {
        // TODO(crisbeto): This is a workaround that allows the calendar to work, without
        // a datepicker, until issue #8585 gets resolved. It can safely be removed
        // afterwards. This ensures that the virtual repeater scrolls to the proper place on load by
        // deferring the execution until the next digest. It's necessary only if the calendar is used
        // without a datepicker, otherwise it's already wrapped in an ngIf.
        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
        var template = '' +
          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
            '<md-calendar-month ng-switch-default></md-calendar-month>' +
          '</div>';

        return template;
      },
      scope: {
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        dateFilter: '=mdDateFilter',
        _currentView: '@mdCurrentView'
      },
      require: ['ngModel', 'mdCalendar'],
      controller: CalendarCtrl,
      controllerAs: 'calendarCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var mdCalendarCtrl = controllers[1];
        mdCalendarCtrl.configureNgModel(ngModelCtrl);
      }
    };
  }

  /**
   * Occasionally the hideVerticalScrollbar method might read an element's
   * width as 0, because it hasn't been laid out yet. This value will be used
   * as a fallback, in order to prevent scenarios where the element's width
   * would otherwise have been set to 0. This value is the "usual" width of a
   * calendar within a floating calendar pane.
   */
  var FALLBACK_WIDTH = 340;

  /** Next identifier for calendar instance. */
  var nextUniqueId = 0;

  /**
   * Controller for the mdCalendar component.
   * @ngInject @constructor
   */
  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil,
    $mdConstant, $mdTheming, $$rAF, $attrs, $mdDateLocale) {

    $mdTheming($element);

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.keyCode = $mdConstant.KEY_CODE;

    /** @final */
    this.$$rAF = $$rAF;

    /** @final */
    this.$mdDateLocale = $mdDateLocale;

    /** @final {Date} */
    this.today = this.dateUtil.createDateAtMidnight();

    /** @type {!angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {String} Class applied to the selected date cell. */
    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';

    /** @type {String} Class applied to the cell for today. */
    this.TODAY_CLASS = 'md-calendar-date-today';

    /** @type {String} Class applied to the focused cell. */
    this.FOCUSED_DATE_CLASS = 'md-focus';

    /** @final {number} Unique ID for this calendar instance. */
    this.id = nextUniqueId++;

    /**
     * The date that is currently focused or showing in the calendar. This will initially be set
     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
     * to other months. The cell corresponding to the displayDate does not necesarily always have
     * focus in the document (such as for cases when the user is scrolling the calendar).
     * @type {Date}
     */
    this.displayDate = null;

    /**
     * The selected date. Keep track of this separately from the ng-model value so that we
     * can know, when the ng-model value changes, what the previous value was before it's updated
     * in the component's UI.
     *
     * @type {Date}
     */
    this.selectedDate = null;

    /**
     * The first date that can be rendered by the calendar. The default is taken
     * from the mdDateLocale provider and is limited by the mdMinDate.
     * @type {Date}
     */
    this.firstRenderableDate = null;

    /**
     * The last date that can be rendered by the calendar. The default comes
     * from the mdDateLocale provider and is limited by the maxDate.
     * @type {Date}
     */
    this.lastRenderableDate = null;

    /**
     * Used to toggle initialize the root element in the next digest.
     * @type {Boolean}
     */
    this.isInitialized = false;

    /**
     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
     * and to avoid extra reflows when switching between views.
     * @type {Number}
     */
    this.width = 0;

    /**
     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
     * @type {Number}
     */
    this.scrollbarWidth = 0;

    // Unless the user specifies so, the calendar should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if (!$attrs.tabindex) {
      $element.attr('tabindex', '-1');
    }

    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);



    // If use the md-calendar directly in the body without datepicker,
    // handleKeyEvent will disable other inputs on the page.
    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
    // otherwise apply on the calendar element only.

    var handleKeyElement;
    if ($element.parent().hasClass('md-datepicker-calendar')) {
      handleKeyElement = angular.element(document.body);
    } else {
      handleKeyElement = $element;
    }

    // Bind the keydown handler to the body, in order to handle cases where the focused
    // element gets removed from the DOM and stops propagating click events.
    handleKeyElement.on('keydown', boundKeyHandler);

    $scope.$on('$destroy', function() {
      handleKeyElement.off('keydown', boundKeyHandler);
    });

    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }

  }

  /**
   * AngularJS Lifecycle hook for newer AngularJS versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
   */
  CalendarCtrl.prototype.$onInit = function() {

    /**
     * The currently visible calendar view. Note the prefix on the scope value,
     * which is necessary, because the datepicker seems to reset the real one value if the
     * calendar is open, but the value on the datepicker's scope is empty.
     * @type {String}
     */
    this.currentView = this._currentView || 'month';

    var dateLocale = this.$mdDateLocale;

    if (this.minDate && this.minDate > dateLocale.firstRenderableDate) {
      this.firstRenderableDate = this.minDate;
    } else {
      this.firstRenderableDate = dateLocale.firstRenderableDate;
    }

    if (this.maxDate && this.maxDate < dateLocale.lastRenderableDate) {
      this.lastRenderableDate = this.maxDate;
    } else {
      this.lastRenderableDate = dateLocale.lastRenderableDate;
    }
  };

  /**
   * Sets up the controller's reference to ngModelController.
   * @param {!angular.NgModelController} ngModelCtrl
   */
  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl) {
    var self = this;

    self.ngModelCtrl = ngModelCtrl;

    self.$mdUtil.nextTick(function() {
      self.isInitialized = true;
    });

    ngModelCtrl.$render = function() {
      var value = this.$viewValue;

      // Notify the child scopes of any changes.
      self.$scope.$broadcast('md-calendar-parent-changed', value);

      // Set up the selectedDate if it hasn't been already.
      if (!self.selectedDate) {
        self.selectedDate = value;
      }

      // Also set up the displayDate.
      if (!self.displayDate) {
        self.displayDate = self.selectedDate || self.today;
      }
    };
  };

  /**
   * Sets the ng-model value for the calendar and emits a change event.
   * @param {Date} date
   */
  CalendarCtrl.prototype.setNgModelValue = function(date) {
    var value = this.dateUtil.createDateAtMidnight(date);
    this.focus(value);
    this.$scope.$emit('md-calendar-change', value);
    this.ngModelCtrl.$setViewValue(value);
    this.ngModelCtrl.$render();
    return value;
  };

  /**
   * Sets the current view that should be visible in the calendar
   * @param {string} newView View name to be set.
   * @param {number|Date} time Date object or a timestamp for the new display date.
   */
  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
    var self = this;

    self.$mdUtil.nextTick(function() {
      self.currentView = newView;

      if (time) {
        self.displayDate = angular.isDate(time) ? time : new Date(time);
      }
    });
  };

  /**
   * Focus the cell corresponding to the given date.
   * @param {Date} date The date to be focused.
   */
  CalendarCtrl.prototype.focus = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var previousFocus = this.$element[0].querySelector('.md-focus');
      if (previousFocus) {
        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
      }

      var cellId = this.getDateId(date, this.currentView);
      var cell = document.getElementById(cellId);
      if (cell) {
        cell.classList.add(this.FOCUSED_DATE_CLASS);
        cell.focus();
        this.displayDate = date;
      }
    } else {
      var rootElement = this.$element[0].querySelector('[ng-switch]');

      if (rootElement) {
        rootElement.focus();
      }
    }
  };

  /**
   * Normalizes the key event into an action name. The action will be broadcast
   * to the child controllers.
   * @param {KeyboardEvent} event
   * @returns {String} The action that should be taken, or null if the key
   * does not match a calendar shortcut.
   */
  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
    var keyCode = this.keyCode;

    switch (event.which) {
      case keyCode.ENTER: return 'select';

      case keyCode.RIGHT_ARROW: return 'move-right';
      case keyCode.LEFT_ARROW: return 'move-left';

      // TODO(crisbeto): Might want to reconsider using metaKey, because it maps
      // to the "Windows" key on PC, which opens the start menu or resizes the browser.
      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';

      case keyCode.PAGE_DOWN: return 'move-page-down';
      case keyCode.PAGE_UP: return 'move-page-up';

      case keyCode.HOME: return 'start';
      case keyCode.END: return 'end';

      default: return null;
    }
  };

  /**
   * Handles a key event in the calendar with the appropriate action. The action will either
   * be to select the focused date or to navigate to focus a new date.
   * @param {KeyboardEvent} event
   */
  CalendarCtrl.prototype.handleKeyEvent = function(event) {
    var self = this;

    this.$scope.$apply(function() {
      // Capture escape and emit back up so that a wrapping component
      // (such as a date-picker) can decide to close.
      if (event.which == self.keyCode.ESCAPE || event.which == self.keyCode.TAB) {
        self.$scope.$emit('md-calendar-close');

        if (event.which == self.keyCode.TAB) {
          event.preventDefault();
        }

        return;
      }

      // Broadcast the action that any child controllers should take.
      var action = self.getActionFromKeyEvent(event);
      if (action) {
        event.preventDefault();
        event.stopPropagation();
        self.$scope.$broadcast('md-calendar-parent-action', action);
      }
    });
  };

  /**
   * Hides the vertical scrollbar on the calendar scroller of a child controller by
   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
   * around the scroller, and then setting a padding-right on the scroller equal
   * to the width of the browser's scrollbar.
   *
   * This will cause a reflow.
   *
   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
   */
  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
    var self = this;
    var element = childCtrl.$element[0];
    var scrollMask = element.querySelector('.md-calendar-scroll-mask');

    if (self.width > 0) {
      setWidth();
    } else {
      self.$$rAF(function() {
        var scroller = childCtrl.calendarScroller;

        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
        self.width = element.querySelector('table').offsetWidth;
        setWidth();
      });
    }

    function setWidth() {
      var width = self.width || FALLBACK_WIDTH;
      var scrollbarWidth = self.scrollbarWidth;
      var scroller = childCtrl.calendarScroller;

      scrollMask.style.width = width + 'px';
      scroller.style.width = (width + scrollbarWidth) + 'px';
      scroller.style.paddingRight = scrollbarWidth + 'px';
    }
  };

  /**
   * Gets an identifier for a date unique to the calendar instance for internal
   * purposes. Not to be displayed.
   * @param {Date} date The date for which the id is being generated
   * @param {string} namespace Namespace for the id. (month, year etc.)
   * @returns {string}
   */
  CalendarCtrl.prototype.getDateId = function(date, namespace) {
    if (!namespace) {
      throw new Error('A namespace for the date id has to be specified.');
    }

    return [
      'md',
      this.id,
      namespace,
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    ].join('-');
  };

  /**
   * Util to trigger an extra digest on a parent scope, in order to to ensure that
   * any child virtual repeaters have updated. This is necessary, because the virtual
   * repeater doesn't update the $index the first time around since the content isn't
   * in place yet. The case, in which this is an issue, is when the repeater has less
   * than a page of content (e.g. a month or year view has a min or max date).
   */
  CalendarCtrl.prototype.updateVirtualRepeat = function() {
    var scope = this.$scope;
    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
      if (!scope.$$phase) {
        scope.$apply();
      }

      virtualRepeatResizeListener();
    });
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
  angular.module('material.components.datepicker')
    .directive('mdCalendarMonth', calendarDirective);

  /**
   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
   * subsequently used for scrolling to specific months.
   */
  var TBODY_HEIGHT = 265;

  /**
   * Height of a calendar month with a single row. This is needed to calculate the offset for
   * rendering an extra month in virtual-repeat that only contains one row.
   */
  var TBODY_SINGLE_ROW_HEIGHT = 45;

  /** Private directive that represents a list of months inside the calendar. */
  function calendarDirective() {
    return {
      template:
        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
        '<div class="md-calendar-scroll-mask">' +
        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
              '<tbody ' +
                  'md-calendar-month-body ' +
                  'role="rowgroup" ' +
                  'md-virtual-repeat="i in monthCtrl.items" ' +
                  'md-month-offset="$index" ' +
                  'class="md-calendar-month" ' +
                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
                  'md-item-size="' + TBODY_HEIGHT + '">' +

                // The <tr> ensures that the <tbody> will always have the
                // proper height, even if it's empty. If it's content is
                // compiled, the <tr> will be overwritten.
                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
              '</tbody>' +
            '</table>' +
          '</md-virtual-repeat-container>' +
        '</div>',
      require: ['^^mdCalendar', 'mdCalendarMonth'],
      controller: CalendarMonthCtrl,
      controllerAs: 'monthCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var monthCtrl = controllers[1];
        monthCtrl.initialize(calendarCtrl);
      }
    };
  }

  /**
   * Controller for the calendar month component.
   * @ngInject @constructor
   */
  function CalendarMonthCtrl($element, $scope, $animate, $q,
    $$mdDateUtil, $mdDateLocale) {

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final {!angular.$animate} */
    this.$animate = $animate;

    /** @final {!angular.$q} */
    this.$q = $q;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @final {HTMLElement} */
    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');

    /** @type {boolean} */
    this.isInitialized = false;

    /** @type {boolean} */
    this.isMonthTransitionInProgress = false;

    var self = this;

    /**
     * Handles a click event on a date cell.
     * Created here so that every cell can use the same function instance.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.cellClickHandler = function() {
      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
      self.$scope.$apply(function() {
        self.calendarCtrl.setNgModelValue(timestamp);
      });
    };

    /**
     * Handles click events on the month headers. Switches
     * the calendar to the year view.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.headerClickHandler = function() {
      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
    };
  }

  /*** Initialization ***/

  /**
   * Initialize the controller by saving a reference to the calendar and
   * setting up the object that will be iterated by the virtual repeater.
   */
  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
    /**
     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
     * number of months that can be viewed. We add 2 months: one to include the current month
     * and one for the last dummy month.
     *
     * This is shorter than ideal because of a (potential) Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
     */

    this.items = {
      length: this.dateUtil.getMonthDistance(
        calendarCtrl.firstRenderableDate,
        calendarCtrl.lastRenderableDate
      ) + 2
    };

    this.calendarCtrl = calendarCtrl;
    this.attachScopeListeners();
    calendarCtrl.updateVirtualRepeat();

    // Fire the initial render, since we might have missed it the first time it fired.
    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
  };

  /**
   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
   * @returns {number}
   */
  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
    var calendarCtrl = this.calendarCtrl;

    return this.dateUtil.getMonthDistance(
      calendarCtrl.firstRenderableDate,
      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
    );
  };

  /**
   * Change the selected date in the calendar (ngModel value has already been changed).
   * @param {Date} date
   */
  CalendarMonthCtrl.prototype.changeSelectedDate = function(date) {
    var self = this;
    var calendarCtrl = self.calendarCtrl;
    var previousSelectedDate = calendarCtrl.selectedDate;
    calendarCtrl.selectedDate = date;

    this.changeDisplayDate(date).then(function() {
      var selectedDateClass = calendarCtrl.SELECTED_DATE_CLASS;
      var namespace = 'month';

      // Remove the selected class from the previously selected date, if any.
      if (previousSelectedDate) {
        var prevDateCell = document.getElementById(calendarCtrl.getDateId(previousSelectedDate, namespace));
        if (prevDateCell) {
          prevDateCell.classList.remove(selectedDateClass);
          prevDateCell.setAttribute('aria-selected', 'false');
        }
      }

      // Apply the select class to the new selected date if it is set.
      if (date) {
        var dateCell = document.getElementById(calendarCtrl.getDateId(date, namespace));
        if (dateCell) {
          dateCell.classList.add(selectedDateClass);
          dateCell.setAttribute('aria-selected', 'true');
        }
      }
    });
  };

  /**
   * Change the date that is being shown in the calendar. If the given date is in a different
   * month, the displayed month will be transitioned.
   * @param {Date} date
   */
  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
    // Initialization is deferred until this function is called because we want to reflect
    // the starting value of ngModel.
    if (!this.isInitialized) {
      this.buildWeekHeader();
      this.calendarCtrl.hideVerticalScrollbar(this);
      this.isInitialized = true;
      return this.$q.when();
    }

    // If trying to show an invalid date or a transition is in progress, do nothing.
    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
      return this.$q.when();
    }

    this.isMonthTransitionInProgress = true;
    var animationPromise = this.animateDateChange(date);

    this.calendarCtrl.displayDate = date;

    var self = this;
    animationPromise.then(function() {
      self.isMonthTransitionInProgress = false;
    });

    return animationPromise;
  };

  /**
   * Animates the transition from the calendar's current month to the given month.
   * @param {Date} date
   * @returns {angular.$q.Promise} The animation promise.
   */
  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
    }

    return this.$q.when();
  };

  /**
   * Builds and appends a day-of-the-week header to the calendar.
   * This should only need to be called once during initialization.
   */
  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
    var shortDays = this.dateLocale.shortDays;

    var row = document.createElement('tr');
    for (var i = 0; i < 7; i++) {
      var th = document.createElement('th');
      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
      row.appendChild(th);
    }

    this.$element.find('thead').append(row);
  };

  /**
   * Attaches listeners for the scope events that are broadcast by the calendar.
   */
  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
      self.changeSelectedDate(value);
    });

    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
  };

  /**
   * Handles the month-specific keyboard interactions.
   * @param {Object} event Scope event object passed by the calendar.
   * @param {String} action Action, corresponding to the key that was pressed.
   */
  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
    var calendarCtrl = this.calendarCtrl;
    var displayDate = calendarCtrl.displayDate;

    if (action === 'select') {
      calendarCtrl.setNgModelValue(displayDate);
    } else {
      var date = null;
      var dateUtil = this.dateUtil;

      switch (action) {
        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;

        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;

        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;

        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
      }

      if (date) {
        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);

        this.changeDisplayDate(date).then(function() {
          calendarCtrl.focus(date);
        });
      }
    }
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
  angular.module('material.components.datepicker')
      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);

  /**
   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
   * the rest of the calendar controller logic.
   * @ngInject
   */
  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];

    return {
      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
      scope: { offset: '=mdMonthOffset' },
      controller: CalendarMonthBodyCtrl,
      controllerAs: 'mdMonthBodyCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var monthCtrl = controllers[1];
        var monthBodyCtrl = controllers[2];

        monthBodyCtrl.calendarCtrl = calendarCtrl;
        monthBodyCtrl.monthCtrl = monthCtrl;
        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);

        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
        // of repeated items that are linked, and then those elements have their bindings updated.
        // Since the months are not generated by bindings, we simply regenerate the entire thing
        // when the binding (offset) changes.
        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
          if (angular.isNumber(offset)) {
            monthBodyCtrl.generateContent();
          }
        });
      }
    };
  }

  /**
   * Controller for a single calendar month.
   * @ngInject @constructor
   */
  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @type {Object} Reference to the month view. */
    this.monthCtrl = null;

    /** @type {Object} Reference to the calendar. */
    this.calendarCtrl = null;

    /**
     * Number of months from the start of the month "items" that the currently rendered month
     * occurs. Set via angular data binding.
     * @type {number}
     */
    this.offset = null;

    /**
     * Date cell to focus after appending the month to the document.
     * @type {HTMLElement}
     */
    this.focusAfterAppend = null;
  }

  /** Generate and append the content for this month to the directive element. */
  CalendarMonthBodyCtrl.prototype.generateContent = function() {
    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);

    this.$element
      .empty()
      .append(this.buildCalendarForMonth(date));

    if (this.focusAfterAppend) {
      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
      this.focusAfterAppend.focus();
      this.focusAfterAppend = null;
    }
  };

  /**
   * Creates a single cell to contain a date in the calendar with all appropriate
   * attributes and classes added. If a date is given, the cell content will be set
   * based on the date.
   * @param {Date=} opt_date
   * @returns {HTMLElement}
   */
  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
    var monthCtrl = this.monthCtrl;
    var calendarCtrl = this.calendarCtrl;

    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
    var cell = document.createElement('td');
    cell.tabIndex = -1;
    cell.classList.add('md-calendar-date');
    cell.setAttribute('role', 'gridcell');

    if (opt_date) {
      cell.setAttribute('tabindex', '-1');
      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
      cell.id = calendarCtrl.getDateId(opt_date, 'month');

      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
      cell.setAttribute('data-timestamp', opt_date.getTime());

      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
      // It may be better to finish the construction and then query the node and add the class.
      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
        cell.classList.add(calendarCtrl.TODAY_CLASS);
      }

      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
        cell.setAttribute('aria-selected', 'true');
      }

      var cellText = this.dateLocale.dates[opt_date.getDate()];

      if (this.isDateEnabled(opt_date)) {
        // Add a indicator for select, hover, and focus states.
        var selectionIndicator = document.createElement('span');
        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
        selectionIndicator.textContent = cellText;
        cell.appendChild(selectionIndicator);
        cell.addEventListener('click', monthCtrl.cellClickHandler);

        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
          this.focusAfterAppend = cell;
        }
      } else {
        cell.classList.add('md-calendar-date-disabled');
        cell.textContent = cellText;
      }
    }

    return cell;
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date,
          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
          (!angular.isFunction(this.calendarCtrl.dateFilter)
           || this.calendarCtrl.dateFilter(opt_date));
  };

  /**
   * Builds a `tr` element for the calendar grid.
   * @param rowNumber The week number within the month.
   * @returns {HTMLElement}
   */
  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
    var row = document.createElement('tr');
    row.setAttribute('role', 'row');

    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
    // to prevent the entire row being read aloud when the user moves between rows.
    // See http://community.nvda-project.org/ticket/4643.
    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));

    return row;
  };

  /**
   * Builds the <tbody> content for the given date's month.
   * @param {Date=} opt_dateInMonth
   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
   */
  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();

    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);

    // Store rows for the month in a document fragment so that we can append them all at once.
    var monthBody = document.createDocumentFragment();

    var rowNumber = 1;
    var row = this.buildDateRow(rowNumber);
    monthBody.appendChild(row);

    // If this is the final month in the list of items, only the first week should render,
    // so we should return immediately after the first row is complete and has been
    // attached to the body.
    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;

    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
    // goes on a row above the first of the month. Otherwise, the month label takes up the first
    // two cells of the first row.
    var blankCellOffset = 0;
    var monthLabelCell = document.createElement('td');
    var monthLabelCellContent = document.createElement('span');

    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
    monthLabelCell.appendChild(monthLabelCellContent);
    monthLabelCell.classList.add('md-calendar-month-label');
    // If the entire month is after the max date, render the label as a disabled state.
    if (this.calendarCtrl.maxDate && firstDayOfMonth > this.calendarCtrl.maxDate) {
      monthLabelCell.classList.add('md-calendar-month-label-disabled');
    } else {
      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
    }

    if (firstDayOfTheWeek <= 2) {
      monthLabelCell.setAttribute('colspan', '7');

      var monthLabelRow = this.buildDateRow();
      monthLabelRow.appendChild(monthLabelCell);
      monthBody.insertBefore(monthLabelRow, row);

      if (isFinalMonth) {
        return monthBody;
      }
    } else {
      blankCellOffset = 3;
      monthLabelCell.setAttribute('colspan', '3');
      row.appendChild(monthLabelCell);
    }

    // Add a blank cell for each day of the week that occurs before the first of the month.
    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
      row.appendChild(this.buildDateCell());
    }

    // Add a cell for each day of the month, keeping track of the day of the week so that
    // we know when to start a new row.
    var dayOfWeek = firstDayOfTheWeek;
    var iterationDate = firstDayOfMonth;
    for (var d = 1; d <= numberOfDaysInMonth; d++) {
      // If we've reached the end of the week, start a new row.
      if (dayOfWeek === 7) {
        // We've finished the first row, so we're done if this is the final month.
        if (isFinalMonth) {
          return monthBody;
        }
        dayOfWeek = 0;
        rowNumber++;
        row = this.buildDateRow(rowNumber);
        monthBody.appendChild(row);
      }

      iterationDate.setDate(d);
      var cell = this.buildDateCell(iterationDate);
      row.appendChild(cell);

      dayOfWeek++;
    }

    // Ensure that the last row of the month has 7 cells.
    while (row.childNodes.length < 7) {
      row.appendChild(this.buildDateCell());
    }

    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
    // requires that all items have exactly the same height.
    while (monthBody.childNodes.length < 6) {
      var whitespaceRow = this.buildDateRow();
      for (var j = 0; j < 7; j++) {
        whitespaceRow.appendChild(this.buildDateCell());
      }
      monthBody.appendChild(whitespaceRow);
    }

    return monthBody;
  };

  /**
   * Gets the day-of-the-week index for a date for the current locale.
   * @private
   * @param {Date} date
   * @returns {number} The column index of the date in the calendar.
   */
  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil"];
  angular.module('material.components.datepicker')
    .directive('mdCalendarYear', calendarDirective);

  /**
   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
   * subsequently used for scrolling to specific years.
   */
  var TBODY_HEIGHT = 88;

  /** Private component, representing a list of years in the calendar. */
  function calendarDirective() {
    return {
      template:
        '<div class="md-calendar-scroll-mask">' +
          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
              '<tbody ' +
                  'md-calendar-year-body ' +
                  'role="rowgroup" ' +
                  'md-virtual-repeat="i in yearCtrl.items" ' +
                  'md-year-offset="$index" class="md-calendar-year" ' +
                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
                  'md-item-size="' + TBODY_HEIGHT + '">' +
                // The <tr> ensures that the <tbody> will have the proper
                // height, even though it may be empty.
                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
              '</tbody>' +
            '</table>' +
          '</md-virtual-repeat-container>' +
        '</div>',
      require: ['^^mdCalendar', 'mdCalendarYear'],
      controller: CalendarYearCtrl,
      controllerAs: 'yearCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var yearCtrl = controllers[1];
        yearCtrl.initialize(calendarCtrl);
      }
    };
  }

  /**
   * Controller for the mdCalendar component.
   * @ngInject @constructor
   */
  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil) {

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final {!angular.$animate} */
    this.$animate = $animate;

    /** @final {!angular.$q} */
    this.$q = $q;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final {HTMLElement} */
    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');

    /** @type {boolean} */
    this.isInitialized = false;

    /** @type {boolean} */
    this.isMonthTransitionInProgress = false;

    var self = this;

    /**
     * Handles a click event on a date cell.
     * Created here so that every cell can use the same function instance.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.cellClickHandler = function() {
      self.calendarCtrl.setCurrentView('month', $$mdDateUtil.getTimestampFromNode(this));
    };
  }

  /**
   * Initialize the controller by saving a reference to the calendar and
   * setting up the object that will be iterated by the virtual repeater.
   */
  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
    /**
     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
     * number of years that can be viewed. We add 1 extra in order to include the current year.
     */
    this.items = {
      length: this.dateUtil.getYearDistance(
        calendarCtrl.firstRenderableDate,
        calendarCtrl.lastRenderableDate
      ) + 1
    };

    this.calendarCtrl = calendarCtrl;
    this.attachScopeListeners();
    calendarCtrl.updateVirtualRepeat();

    // Fire the initial render, since we might have missed it the first time it fired.
    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
  };

  /**
   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
   * @returns {number}
   */
  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
    var calendarCtrl = this.calendarCtrl;

    return this.dateUtil.getYearDistance(
      calendarCtrl.firstRenderableDate,
      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
    );
  };

  /**
   * Change the date that is highlighted in the calendar.
   * @param {Date} date
   */
  CalendarYearCtrl.prototype.changeDate = function(date) {
    // Initialization is deferred until this function is called because we want to reflect
    // the starting value of ngModel.
    if (!this.isInitialized) {
      this.calendarCtrl.hideVerticalScrollbar(this);
      this.isInitialized = true;
      return this.$q.when();
    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
      var self = this;
      var animationPromise = this.animateDateChange(date);

      self.isMonthTransitionInProgress = true;
      self.calendarCtrl.displayDate = date;

      return animationPromise.then(function() {
        self.isMonthTransitionInProgress = false;
      });
    }
  };

  /**
   * Animates the transition from the calendar's current month to the given month.
   * @param {Date} date
   * @returns {angular.$q.Promise} The animation promise.
   */
  CalendarYearCtrl.prototype.animateDateChange = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
    }

    return this.$q.when();
  };

  /**
   * Handles the year-view-specific keyboard interactions.
   * @param {Object} event Scope event object passed by the calendar.
   * @param {String} action Action, corresponding to the key that was pressed.
   */
  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
    var calendarCtrl = this.calendarCtrl;
    var displayDate = calendarCtrl.displayDate;

    if (action === 'select') {
      this.changeDate(displayDate).then(function() {
        calendarCtrl.setCurrentView('month', displayDate);
        calendarCtrl.focus(displayDate);
      });
    } else {
      var date = null;
      var dateUtil = this.dateUtil;

      switch (action) {
        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;

        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
      }

      if (date) {
        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
        date = dateUtil.getFirstDateOfMonth(this.dateUtil.clampDate(date, min, max));

        this.changeDate(date).then(function() {
          calendarCtrl.focus(date);
        });
      }
    }
  };

  /**
   * Attaches listeners for the scope events that are broadcast by the calendar.
   */
  CalendarYearCtrl.prototype.attachScopeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
      self.changeDate(value);
    });

    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
  angular.module('material.components.datepicker')
      .directive('mdCalendarYearBody', mdCalendarYearDirective);

  /**
   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
   * and allows for the year view to use md-virtual-repeat.
   */
  function mdCalendarYearDirective() {
    return {
      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
      scope: { offset: '=mdYearOffset' },
      controller: CalendarYearBodyCtrl,
      controllerAs: 'mdYearBodyCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var yearCtrl = controllers[1];
        var yearBodyCtrl = controllers[2];

        yearBodyCtrl.calendarCtrl = calendarCtrl;
        yearBodyCtrl.yearCtrl = yearCtrl;

        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
          if (angular.isNumber(offset)) {
            yearBodyCtrl.generateContent();
          }
        });
      }
    };
  }

  /**
   * Controller for a single year.
   * @ngInject @constructor
   */
  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @type {Object} Reference to the calendar. */
    this.calendarCtrl = null;

    /** @type {Object} Reference to the year view. */
    this.yearCtrl = null;

    /**
     * Number of months from the start of the month "items" that the currently rendered month
     * occurs. Set via angular data binding.
     * @type {number}
     */
    this.offset = null;

    /**
     * Date cell to focus after appending the month to the document.
     * @type {HTMLElement}
     */
    this.focusAfterAppend = null;
  }

  /** Generate and append the content for this year to the directive element. */
  CalendarYearBodyCtrl.prototype.generateContent = function() {
    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);

    this.$element
      .empty()
      .append(this.buildCalendarForYear(date));

    if (this.focusAfterAppend) {
      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
      this.focusAfterAppend.focus();
      this.focusAfterAppend = null;
    }
  };

  /**
   * Creates a single cell to contain a year in the calendar.
   * @param {number} opt_year Four-digit year.
   * @param {number} opt_month Zero-indexed month.
   * @returns {HTMLElement}
   */
  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
    var calendarCtrl = this.calendarCtrl;
    var yearCtrl = this.yearCtrl;
    var cell = this.buildBlankCell();

    // Represent this month/year as a date.
    var firstOfMonth = new Date(year, month, 1);
    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');

    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
    cell.setAttribute('data-timestamp', firstOfMonth.getTime());

    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
      cell.classList.add(calendarCtrl.TODAY_CLASS);
    }

    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
      cell.setAttribute('aria-selected', 'true');
    }

    var cellText = this.dateLocale.shortMonths[month];

    if (this.dateUtil.isMonthWithinRange(firstOfMonth,
        calendarCtrl.minDate, calendarCtrl.maxDate)) {
      var selectionIndicator = document.createElement('span');
      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
      selectionIndicator.textContent = cellText;
      cell.appendChild(selectionIndicator);
      cell.addEventListener('click', yearCtrl.cellClickHandler);

      if (calendarCtrl.displayDate && this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
        this.focusAfterAppend = cell;
      }
    } else {
      cell.classList.add('md-calendar-date-disabled');
      cell.textContent = cellText;
    }

    return cell;
  };

  /**
   * Builds a blank cell.
   * @return {HTMLTableCellElement}
   */
  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
    var cell = document.createElement('td');
    cell.tabIndex = -1;
    cell.classList.add('md-calendar-date');
    cell.setAttribute('role', 'gridcell');

    cell.setAttribute('tabindex', '-1');
    return cell;
  };

  /**
   * Builds the <tbody> content for the given year.
   * @param {Date} date Date for which the content should be built.
   * @returns {DocumentFragment} A document fragment containing the months within the year.
   */
  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
    // Store rows for the month in a document fragment so that we can append them all at once.
    var year = date.getFullYear();
    var yearBody = document.createDocumentFragment();

    var monthCell, i;
    // First row contains label and Jan-Jun.
    var firstRow = document.createElement('tr');
    var labelCell = document.createElement('td');
    labelCell.className = 'md-calendar-month-label';
    labelCell.textContent = year;
    firstRow.appendChild(labelCell);

    for (i = 0; i < 6; i++) {
      firstRow.appendChild(this.buildMonthCell(year, i));
    }
    yearBody.appendChild(firstRow);

    // Second row contains a blank cell and Jul-Dec.
    var secondRow = document.createElement('tr');
    secondRow.appendChild(this.buildBlankCell());
    for (i = 6; i < 12; i++) {
      secondRow.appendChild(this.buildMonthCell(year, i));
    }
    yearBody.appendChild(secondRow);

    return yearBody;
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdDateLocaleProvider
   * @module material.components.datepicker
   *
   * @description
   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
   * This provider that allows the user to specify messages, formatters, and parsers for date
   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
   * components that deal with dates.
   *
   * @property {(Array<string>)=} months Array of month names (in order).
   * @property {(Array<string>)=} shortMonths Array of abbreviated month names.
   * @property {(Array<string>)=} days Array of the days of the week (in order).
   * @property {(Array<string>)=} shortDays Array of abbreviated days of the week.
   * @property {(Array<string>)=} dates Array of dates of the month. Only necessary for locales
   *     using a numeral system other than [1, 2, 3...].
   * @property {(Array<string>)=} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
   *    etc.
   * @property {(function(string): Date)=} parseDate Function to parse a date object from a string.
   * @property {(function(Date, string): string)=} formatDate Function to format a date object to a
   *     string. The datepicker directive also provides the time zone, if it was specified.
   * @property {(function(Date): string)=} monthHeaderFormatter Function that returns the label for
   *     a month given a date.
   * @property {(function(Date): string)=} monthFormatter Function that returns the full name of a month
   *     for a given date.
   * @property {(function(number): string)=} weekNumberFormatter Function that returns a label for
   *     a week given the week number.
   * @property {(string)=} msgCalendar Translation of the label "Calendar" for the current locale.
   * @property {(string)=} msgOpenCalendar Translation of the button label "Open calendar" for the
   *     current locale.
   * @property {Date=} firstRenderableDate The date from which the datepicker calendar will begin
   * rendering. Note that this will be ignored if a minimum date is set. Defaults to January 1st 1880.
   * @property {Date=} lastRenderableDate The last date that will be rendered by the datepicker
   * calendar. Note that this will be ignored if a maximum date is set. Defaults to January 1st 2130.
   *
   * @usage
   * <hljs lang="js">
   * myAppModule.config(function($mdDateLocaleProvider) {
   *
   *     // Example of a French localization.
   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
   *
   *     // Can change week display to start on Monday.
   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
   *
   *     // Optional.
   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
   *
   *     // Example uses moment.js to parse and format dates.
   *     $mdDateLocaleProvider.parseDate = function(dateString) {
   *       var m = moment(dateString, 'L', true);
   *       return m.isValid() ? m.toDate() : new Date(NaN);
   *     };
   *
   *     $mdDateLocaleProvider.formatDate = function(date) {
   *       var m = moment(date);
   *       return m.isValid() ? m.format('L') : '';
   *     };
   *
   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
   *     };
   *
   *     // In addition to date display, date components also need localized messages
   *     // for aria-labels for screen-reader users.
   *
   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
   *       return 'Semaine ' + weekNumber;
   *     };
   *
   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
   *
   *     // You can also set when your calendar begins and ends.
   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
   * });
   * </hljs>
   *
   */
  angular.module('material.components.datepicker').config(["$provide", function($provide) {
    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.

    /** @constructor */
    function DateLocaleProvider() {
      /** Array of full month names. E.g., ['January', 'Febuary', ...] */
      this.months = null;

      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
      this.shortMonths = null;

      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
      this.days = null;

      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
      this.shortDays = null;

      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
      this.dates = null;

      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
      this.firstDayOfWeek = 0;

      /**
       * Function that converts the date portion of a Date to a string.
       * @type {(function(Date): string)}
       */
      this.formatDate = null;

      /**
       * Function that converts a date string to a Date object (the date portion)
       * @type {function(string): Date}
       */
      this.parseDate = null;

      /**
       * Function that formats a Date into a month header string.
       * @type {function(Date): string}
       */
      this.monthHeaderFormatter = null;

      /**
       * Function that formats a week number into a label for the week.
       * @type {function(number): string}
       */
      this.weekNumberFormatter = null;

      /**
       * Function that formats a date into a long aria-label that is read
       * when the focused date changes.
       * @type {function(Date): string}
       */
      this.longDateFormatter = null;

      /**
       * ARIA label for the calendar "dialog" used in the datepicker.
       * @type {string}
       */
      this.msgCalendar = '';

      /**
       * ARIA label for the datepicker's "Open calendar" buttons.
       * @type {string}
       */
      this.msgOpenCalendar = '';
    }

    /**
     * Factory function that returns an instance of the dateLocale service.
     * @ngInject
     * @param $locale
     * @returns {DateLocale}
     */
    DateLocaleProvider.prototype.$get = function($locale, $filter) {
      /**
       * Default date-to-string formatting function.
       * @param {!Date} date
       * @param {string=} timezone
       * @returns {string}
       */
      function defaultFormatDate(date, timezone) {
        if (!date) {
          return '';
        }

        // All of the dates created through ng-material *should* be set to midnight.
        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
        // we have run into an issue with DST where we need to increment the hour by one:
        // var d = new Date(1992, 9, 8, 0, 0, 0);
        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
        var localeTime = date.toLocaleTimeString();
        var formatDate = date;
        if (date.getHours() === 0 &&
            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
        }

        return $filter('date')(formatDate, 'M/d/yyyy', timezone);
      }

      /**
       * Default string-to-date parsing function.
       * @param {string} dateString
       * @returns {!Date}
       */
      function defaultParseDate(dateString) {
        return new Date(dateString);
      }

      /**
       * Default function to determine whether a string makes sense to be
       * parsed to a Date object.
       *
       * This is very permissive and is just a basic sanity check to ensure that
       * things like single integers aren't able to be parsed into dates.
       * @param {string} dateString
       * @returns {boolean}
       */
      function defaultIsDateComplete(dateString) {
        dateString = dateString.trim();

        // Looks for three chunks of content (either numbers or text) separated
        // by delimiters.
        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ \.,]+|[\/\-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
        return re.test(dateString);
      }

      /**
       * Default date-to-string formatter to get a month header.
       * @param {!Date} date
       * @returns {string}
       */
      function defaultMonthHeaderFormatter(date) {
        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
      }

      /**
       * Default formatter for a month.
       * @param {!Date} date
       * @returns {string}
       */
      function defaultMonthFormatter(date) {
        return service.months[date.getMonth()] + ' ' + date.getFullYear();
      }

      /**
       * Default week number formatter.
       * @param number
       * @returns {string}
       */
      function defaultWeekNumberFormatter(number) {
        return 'Week ' + number;
      }

      /**
       * Default formatter for date cell aria-labels.
       * @param {!Date} date
       * @returns {string}
       */
      function defaultLongDateFormatter(date) {
        // Example: 'Thursday June 18 2015'
        return [
          service.days[date.getDay()],
          service.months[date.getMonth()],
          service.dates[date.getDate()],
          date.getFullYear()
        ].join(' ');
      }

      // The default "short" day strings are the first character of each day,
      // e.g., "Monday" => "M".
      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
        return day.substring(0, 1);
      });

      // The default dates are simply the numbers 1 through 31.
      var defaultDates = Array(32);
      for (var i = 1; i <= 31; i++) {
        defaultDates[i] = i;
      }

      // Default ARIA messages are in English (US).
      var defaultMsgCalendar = 'Calendar';
      var defaultMsgOpenCalendar = 'Open calendar';

      // Default start/end dates that are rendered in the calendar.
      var defaultFirstRenderableDate = new Date(1880, 0, 1);
      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);

      var service = {
        months: this.months || $locale.DATETIME_FORMATS.MONTH,
        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
        days: this.days || $locale.DATETIME_FORMATS.DAY,
        shortDays: this.shortDays || defaultShortDays,
        dates: this.dates || defaultDates,
        firstDayOfWeek: this.firstDayOfWeek || 0,
        formatDate: this.formatDate || defaultFormatDate,
        parseDate: this.parseDate || defaultParseDate,
        isDateComplete: this.isDateComplete || defaultIsDateComplete,
        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
        monthFormatter: this.monthFormatter || defaultMonthFormatter,
        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
        msgCalendar: this.msgCalendar || defaultMsgCalendar,
        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
      };

      return service;
    };
    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];

    $provide.provider('$mdDateLocale', new DateLocaleProvider());
  }]);
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * Utility for performing date calculations to facilitate operation of the calendar and
   * datepicker.
   */
  angular.module('material.components.datepicker').factory('$$mdDateUtil', function() {
    return {
      getFirstDateOfMonth: getFirstDateOfMonth,
      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
      getDateInNextMonth: getDateInNextMonth,
      getDateInPreviousMonth: getDateInPreviousMonth,
      isInNextMonth: isInNextMonth,
      isInPreviousMonth: isInPreviousMonth,
      getDateMidpoint: getDateMidpoint,
      isSameMonthAndYear: isSameMonthAndYear,
      getWeekOfMonth: getWeekOfMonth,
      incrementDays: incrementDays,
      incrementMonths: incrementMonths,
      getLastDateOfMonth: getLastDateOfMonth,
      isSameDay: isSameDay,
      getMonthDistance: getMonthDistance,
      isValidDate: isValidDate,
      setDateTimeToMidnight: setDateTimeToMidnight,
      createDateAtMidnight: createDateAtMidnight,
      isDateWithinRange: isDateWithinRange,
      incrementYears: incrementYears,
      getYearDistance: getYearDistance,
      clampDate: clampDate,
      getTimestampFromNode: getTimestampFromNode,
      isMonthWithinRange: isMonthWithinRange
    };

    /**
     * Gets the first day of the month for the given date's month.
     * @param {Date} date
     * @returns {Date}
     */
    function getFirstDateOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    /**
     * Gets the number of days in the month for the given date's month.
     * @param date
     * @returns {number}
     */
    function getNumberOfDaysInMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    /**
     * Get an arbitrary date in the month after the given date's month.
     * @param date
     * @returns {Date}
     */
    function getDateInNextMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    }

    /**
     * Get an arbitrary date in the month before the given date's month.
     * @param date
     * @returns {Date}
     */
    function getDateInPreviousMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    }

    /**
     * Gets whether two dates have the same month and year.
     * @param {Date} d1
     * @param {Date} d2
     * @returns {boolean}
     */
    function isSameMonthAndYear(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
    }

    /**
     * Gets whether two dates are the same day (not not necesarily the same time).
     * @param {Date} d1
     * @param {Date} d2
     * @returns {boolean}
     */
    function isSameDay(d1, d2) {
      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
    }

    /**
     * Gets whether a date is in the month immediately after some date.
     * @param {Date} startDate The date from which to compare.
     * @param {Date} endDate The date to check.
     * @returns {boolean}
     */
    function isInNextMonth(startDate, endDate) {
      var nextMonth = getDateInNextMonth(startDate);
      return isSameMonthAndYear(nextMonth, endDate);
    }

    /**
     * Gets whether a date is in the month immediately before some date.
     * @param {Date} startDate The date from which to compare.
     * @param {Date} endDate The date to check.
     * @returns {boolean}
     */
    function isInPreviousMonth(startDate, endDate) {
      var previousMonth = getDateInPreviousMonth(startDate);
      return isSameMonthAndYear(endDate, previousMonth);
    }

    /**
     * Gets the midpoint between two dates.
     * @param {Date} d1
     * @param {Date} d2
     * @returns {Date}
     */
    function getDateMidpoint(d1, d2) {
      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
    }

    /**
     * Gets the week of the month that a given date occurs in.
     * @param {Date} date
     * @returns {number} Index of the week of the month (zero-based).
     */
    function getWeekOfMonth(date) {
      var firstDayOfMonth = getFirstDateOfMonth(date);
      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
    }

    /**
     * Gets a new date incremented by the given number of days. Number of days can be negative.
     * @param {Date} date
     * @param {number} numberOfDays
     * @returns {Date}
     */
    function incrementDays(date, numberOfDays) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
    }

    /**
     * Gets a new date incremented by the given number of months. Number of months can be negative.
     * If the date of the given month does not match the target month, the date will be set to the
     * last day of the month.
     * @param {Date} date
     * @param {number} numberOfMonths
     * @returns {Date}
     */
    function incrementMonths(date, numberOfMonths) {
      // If the same date in the target month does not actually exist, the Date object will
      // automatically advance *another* month by the number of missing days.
      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
      // So, we check if the month overflowed and go to the last day of the target month instead.
      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
      if (numberOfDaysInMonth < date.getDate()) {
        dateInTargetMonth.setDate(numberOfDaysInMonth);
      } else {
        dateInTargetMonth.setDate(date.getDate());
      }

      return dateInTargetMonth;
    }

    /**
     * Get the integer distance between two months. This *only* considers the month and year
     * portion of the Date instances.
     *
     * @param {Date} start
     * @param {Date} end
     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
     *     chronologically, this number will be negative.
     */
    function getMonthDistance(start, end) {
      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
    }

    /**
     * Gets the last day of the month for the given date.
     * @param {Date} date
     * @returns {Date}
     */
    function getLastDateOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
    }

    /**
     * Checks whether a date is valid.
     * @param {Date} date
     * @return {boolean} Whether the date is a valid Date.
     */
    function isValidDate(date) {
      return date && date.getTime && !isNaN(date.getTime());
    }

    /**
     * Sets a date's time to midnight.
     * @param {Date} date
     */
    function setDateTimeToMidnight(date) {
      if (isValidDate(date)) {
        date.setHours(0, 0, 0, 0);
      }
    }

    /**
     * Creates a date with the time set to midnight.
     * Drop-in replacement for two forms of the Date constructor:
     * 1. No argument for Date representing now.
     * 2. Single-argument value representing number of seconds since Unix Epoch
     * or a Date object.
     * @param {number|Date=} opt_value
     * @return {Date} New date with time set to midnight.
     */
    function createDateAtMidnight(opt_value) {
      var date;
      if (angular.isUndefined(opt_value)) {
        date = new Date();
      } else {
        date = new Date(opt_value);
      }
      setDateTimeToMidnight(date);
      return date;
    }

     /**
      * Checks if a date is within a min and max range, ignoring the time component.
      * If minDate or maxDate are not dates, they are ignored.
      * @param {Date} date
      * @param {Date} minDate
      * @param {Date} maxDate
      */
     function isDateWithinRange(date, minDate, maxDate) {
       var dateAtMidnight = createDateAtMidnight(date);
       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
     }

    /**
     * Gets a new date incremented by the given number of years. Number of years can be negative.
     * See `incrementMonths` for notes on overflow for specific dates.
     * @param {Date} date
     * @param {number} numberOfYears
     * @returns {Date}
     */
     function incrementYears(date, numberOfYears) {
       return incrementMonths(date, numberOfYears * 12);
     }

     /**
      * Get the integer distance between two years. This *only* considers the year portion of the
      * Date instances.
      *
      * @param {Date} start
      * @param {Date} end
      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
      *     chronologically, this number will be negative.
      */
     function getYearDistance(start, end) {
       return end.getFullYear() - start.getFullYear();
     }

     /**
      * Clamps a date between a minimum and a maximum date.
      * @param {Date} date Date to be clamped
      * @param {Date=} minDate Minimum date
      * @param {Date=} maxDate Maximum date
      * @return {Date}
      */
     function clampDate(date, minDate, maxDate) {
       var boundDate = date;
       if (minDate && date < minDate) {
         boundDate = new Date(minDate.getTime());
       }
       if (maxDate && date > maxDate) {
         boundDate = new Date(maxDate.getTime());
       }
       return boundDate;
     }

     /**
      * Extracts and parses the timestamp from a DOM node.
      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
      * @return {number} Time since epoch.
      */
     function getTimestampFromNode(node) {
       if (node && node.hasAttribute('data-timestamp')) {
         return Number(node.getAttribute('data-timestamp'));
       }
     }

     /**
      * Checks if a month is within a min and max range, ignoring the date and time components.
      * If minDate or maxDate are not dates, they are ignored.
      * @param {Date} date
      * @param {Date} minDate
      * @param {Date} maxDate
      */
     function isMonthWithinRange(date, minDate, maxDate) {
       var month = date.getMonth();
       var year = date.getFullYear();

       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
     }
  });
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  // POST RELEASE
  // TODO(jelbourn): Demo that uses moment.js
  // TODO(jelbourn): make sure this plays well with validation and ngMessages.
  // TODO(jelbourn): calendar pane doesn't open up outside of visible viewport.
  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
  // TODO(jelbourn): input behavior (masking? auto-complete?)


  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter"];
  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
  angular.module('material.components.datepicker')
      .directive('mdDatepicker', datePickerDirective);

  /**
   * @ngdoc directive
   * @name mdDatepicker
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a value that can be parsed into one (e.g. a ISO 8601 string).
   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being updated. Also allows
   * for a timezone to be specified. <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the ngModelOptions docs.</a>
   * @param {expression=} ng-change Expression evaluated when the model value changes.
   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar is opened.
   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the calendar is closed.
   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
   * @param {boolean=} ng-required Whether a value is required for the datepicker.
   * @param {Date=} md-min-date Expression representing a min date (inclusive).
   * @param {Date=} md-max-date Expression representing a max date (inclusive).
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a boolean whether it can be selected or not.
   * @param {String=} md-placeholder The date input placeholder value.
   * @param {String=} md-open-on-focus When present, the calendar will be opened when the input is focused.
   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar on-demand.
   * @param {String=} md-current-view Default open view of the calendar pane. Can be either "month" or "year".
   * @param {String=} md-hide-icons Determines which datepicker icons should be hidden. Note that this may cause the
   * datepicker to not align properly with other components. **Use at your own risk.** Possible values are:
   * * `"all"` - Hides all icons.
   * * `"calendar"` - Only hides the calendar icon.
   * * `"triangle"` - Only hides the triangle icon.
   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
   * ovewritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
   *
   * @description
   * `<md-datepicker>` is a component used to select a single date.
   * For information on how to configure internationalization for the date picker,
   * see `$mdDateLocaleProvider`.
   *
   * This component supports [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
   * Supported attributes are:
   * * `required`: whether a required date is not set.
   * * `mindate`: whether the selected date is before the minimum allowed date.
   * * `maxdate`: whether the selected date is after the maximum allowed date.
   * * `debounceInterval`: ms to delay input processing (since last debounce reset); default value 500ms
   *
   * @usage
   * <hljs lang="html">
   *   <md-datepicker ng-model="birthday"></md-datepicker>
   * </hljs>
   *
   */

  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
    return {
      template: function(tElement, tAttrs) {
        // Buttons are not in the tab order because users can open the calendar via keyboard
        // interaction on the text input, and multiple tab stops for one component (picker)
        // may be confusing.
        var hiddenIcons = tAttrs.mdHideIcons;
        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;

        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
              'tabindex="-1" aria-hidden="true" ' +
              'ng-click="ctrl.openCalendarPane($event)">' +
            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
          '</md-button>';

        var triangleButton = '';

        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
          triangleButton = '' +
            '<md-button type="button" md-no-ink ' +
              'class="md-datepicker-triangle-button md-icon-button" ' +
              'ng-click="ctrl.openCalendarPane($event)" ' +
              'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
            '<div class="md-datepicker-expand-triangle"></div>' +
          '</md-button>';

          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
        }

        return calendarButton +
        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
          '<input ' +
            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
            'class="md-datepicker-input" ' +
            'aria-haspopup="true" ' +
            'aria-expanded="{{ctrl.isCalendarOpen}}" ' +
            'ng-focus="ctrl.setFocused(true)" ' +
            'ng-blur="ctrl.setFocused(false)"> ' +
            triangleButton +
        '</div>' +

        // This pane will be detached from here and re-attached to the document body.
        '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
          '<div class="md-datepicker-input-mask">' +
            '<div class="md-datepicker-input-mask-opaque"></div>' +
          '</div>' +
          '<div class="md-datepicker-calendar">' +
            '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
                'md-current-view="{{::ctrl.currentView}}"' +
                'md-min-date="ctrl.minDate"' +
                'md-max-date="ctrl.maxDate"' +
                'md-date-filter="ctrl.dateFilter"' +
                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
            '</md-calendar>' +
          '</div>' +
        '</div>';
      },
      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
      scope: {
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        placeholder: '@mdPlaceholder',
        currentView: '@mdCurrentView',
        dateFilter: '=mdDateFilter',
        isOpen: '=?mdIsOpen',
        debounceInterval: '=mdDebounceInterval',
        dateLocale: '=mdDateLocale'
      },
      controller: DatePickerCtrl,
      controllerAs: 'ctrl',
      bindToController: true,
      link: function(scope, element, attr, controllers) {
        var ngModelCtrl = controllers[0];
        var mdDatePickerCtrl = controllers[1];
        var mdInputContainer = controllers[2];
        var parentForm = controllers[3];
        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);

        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);

        if (mdInputContainer) {
          // We need to move the spacer after the datepicker itself,
          // because md-input-container adds it after the
          // md-datepicker-input by default. The spacer gets wrapped in a
          // div, because it floats and gets aligned next to the datepicker.
          // There are easier ways of working around this with CSS (making the
          // datepicker 100% wide, change the `display` etc.), however they
          // break the alignment with any other form controls.
          var spacer = element[0].querySelector('.md-errors-spacer');

          if (spacer) {
            element.after(angular.element('<div>').append(spacer));
          }

          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
          mdInputContainer.input = element;
          mdInputContainer.element
            .addClass(INPUT_CONTAINER_CLASS)
            .toggleClass(HAS_CALENDAR_ICON_CLASS, attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');

          if (!mdInputContainer.label) {
            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
          } else if(!mdNoAsterisk) {
            attr.$observe('required', function(value) {
              mdInputContainer.label.toggleClass('md-required', !!value);
            });
          }

          scope.$watch(mdInputContainer.isErrorGetter || function() {
            return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
          }, mdInputContainer.setInvalid);
        } else if (parentForm) {
          // If invalid, highlights the input when the parent form is submitted.
          var parentSubmittedWatcher = scope.$watch(function() {
            return parentForm.$submitted;
          }, function(isSubmitted) {
            if (isSubmitted) {
              mdDatePickerCtrl.updateErrorState();
              parentSubmittedWatcher();
            }
          });
        }
      }
    };
  }

  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
  var EXTRA_INPUT_SIZE = 3;

  /** Class applied to the container if the date is invalid. */
  var INVALID_CLASS = 'md-datepicker-invalid';

  /** Class applied to the datepicker when it's open. */
  var OPEN_CLASS = 'md-datepicker-open';

  /** Class applied to the md-input-container, if a datepicker is placed inside it */
  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';

  /** Class to be applied when the calendar icon is enabled. */
  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';

  /** Class to be applied when the triangle icon is enabled. */
  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';

  /** Default time in ms to debounce input event by. */
  var DEFAULT_DEBOUNCE_INTERVAL = 500;

  /**
   * Height of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_HEIGHT = 368;

  /**
   * Width of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_WIDTH = 360;

  /** Used for checking whether the current user agent is on iOS or Android. */
  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;

  /**
   * Controller for md-datepicker.
   *
   * @ngInject @constructor
   */
  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant,
    $mdTheming, $mdUtil, $mdDateLocale, $$mdDateUtil, $$rAF, $filter) {

    /** @final */
    this.$window = $window;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdConstant = $mdConstant;

    /* @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.$$rAF = $$rAF;

    /** @final */
    this.$mdDateLocale = $mdDateLocale;

    /**
     * The root document element. This is used for attaching a top-level click handler to
     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
     * instead of body because, when scrolling is disabled, some browsers consider the body element
     * to be completely off the screen and propagate events directly to the html element.
     * @type {!angular.JQLite}
     */
    this.documentElement = angular.element(document.documentElement);

    /** @type {!angular.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {HTMLInputElement} */
    this.inputElement = $element[0].querySelector('input');

    /** @final {!angular.JQLite} */
    this.ngInputElement = angular.element(this.inputElement);

    /** @type {HTMLElement} */
    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');

    /** @type {HTMLElement} Floating calendar pane. */
    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');

    /** @type {HTMLElement} Calendar icon button. */
    this.calendarButton = $element[0].querySelector('.md-datepicker-button');

    /**
     * Element covering everything but the input in the top of the floating calendar pane.
     * @type {!angular.JQLite}
     */
    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Attributes} */
    this.$attrs = $attrs;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @type {Date} */
    this.date = null;

    /** @type {boolean} */
    this.isFocused = false;

    /** @type {boolean} */
    this.isDisabled;
    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));

    /** @type {boolean} Whether the date-picker's calendar pane is open. */
    this.isCalendarOpen = false;

    /** @type {boolean} Whether the calendar should open when the input is focused. */
    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');

    /** @final */
    this.mdInputContainer = null;

    /**
     * Element from which the calendar pane was opened. Keep track of this so that we can return
     * focus to it when the pane is closed.
     * @type {HTMLElement}
     */
    this.calendarPaneOpenedFrom = null;

    /** @type {String} Unique id for the calendar pane. */
    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();

    /** Pre-bound click handler is saved so that the event listener can be removed. */
    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

    /**
     * Name of the event that will trigger a close. Necessary to sniff the browser, because
     * the resize event doesn't make sense on mobile and can have a negative impact since it
     * triggers whenever the browser zooms in on a focused input.
     */
    this.windowEventName = IS_MOBILE_REGEX.test(
      navigator.userAgent || navigator.vendor || window.opera
    ) ? 'orientationchange' : 'resize';

    /** Pre-bound close handler so that the event listener can be removed. */
    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);

    /** The built-in AngularJS date filter. */
    this.ngDateFilter = $filter('date');

    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
    this.leftMargin = 20;

    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
    this.topMargin = null;

    // Unless the user specifies so, the datepicker should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if ($attrs.tabindex) {
      this.ngInputElement.attr('tabindex', $attrs.tabindex);
      $attrs.$set('tabindex', null);
    } else {
      $attrs.$set('tabindex', '-1');
    }

    $attrs.$set('aria-owns', this.calendarPaneId);

    $mdTheming($element);
    $mdTheming(angular.element(this.calendarPane));

    var self = this;

    $scope.$on('$destroy', function() {
      self.detachCalendarPane();
    });

    if ($attrs.mdIsOpen) {
      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
        if (shouldBeOpen) {
          self.openCalendarPane({
            target: self.inputElement
          });
        } else {
          self.closeCalendarPane();
        }
      });
    }

    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }

  }

  /**
   * AngularJS Lifecycle hook for newer AngularJS versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
   */
  DatePickerCtrl.prototype.$onInit = function() {

    /**
     * Holds locale-specific formatters, parsers, labels etc. Allows
     * the user to override specific ones from the $mdDateLocale provider.
     * @type {!Object}
     */
    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale) : this.$mdDateLocale;

    this.installPropertyInterceptors();
    this.attachChangeListeners();
    this.attachInteractionListeners();
  };

  /**
   * Sets up the controller's reference to ngModelController and
   * applies AngularJS's `input[type="date"]` directive.
   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
   * @param {Object} inputDirective Config for AngularJS's `input` directive.
   */
  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
    this.ngModelCtrl = ngModelCtrl;
    this.mdInputContainer = mdInputContainer;

    // The input needs to be [type="date"] in order to be picked up by AngularJS.
    this.$attrs.$set('type', 'date');

    // Invoke the `input` directive link function, adding a stub for the element.
    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
    // It works by calling the link function directly which then adds the proper `$parsers` and
    // `$formatters` to the ngModel controller.
    inputDirective[0].link.pre(this.$scope, {
      on: angular.noop,
      val: angular.noop,
      0: {}
    }, this.$attrs, [ngModelCtrl]);

    var self = this;

    // Responds to external changes to the model value.
    self.ngModelCtrl.$formatters.push(function(value) {
      var parsedValue = angular.isDefined(value) ? Date.parse(value) : null;

      // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
      if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
        value = new Date(parsedValue);
      }

      if (value && !(value instanceof Date)) {
        throw Error(
          'The ng-model for md-datepicker must be a Date instance or a value ' +
          'that can be parsed into a date. Currently the model is of type: ' + typeof value
        );
      }

      self.onExternalChange(value);

      return value;
    });

    // Responds to external error state changes (e.g. ng-required based on another input).
    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));

    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
    // the `<md-datepicker>`.
    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');

    if (updateOn) {
      this.ngInputElement.on(
        updateOn,
        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
      );
    }
  };

  /**
   * Attach event listeners for both the text input and the md-calendar.
   * Events are used instead of ng-model so that updates don't infinitely update the other
   * on a change. This should also be more performant than using a $watch.
   */
  DatePickerCtrl.prototype.attachChangeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-change', function(event, date) {
      self.setModelValue(date);
      self.onExternalChange(date);
      self.closeCalendarPane();
    });

    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));

    var debounceInterval = angular.isDefined(this.debounceInterval) ?
        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
        debounceInterval, self));
  };

  /** Attach event listeners for user interaction. */
  DatePickerCtrl.prototype.attachInteractionListeners = function() {
    var self = this;
    var $scope = this.$scope;
    var keyCodes = this.$mdConstant.KEY_CODE;

    // Add event listener through angular so that we can triggerHandler in unit tests.
    self.ngInputElement.on('keydown', function(event) {
      if (event.altKey && event.keyCode == keyCodes.DOWN_ARROW) {
        self.openCalendarPane(event);
        $scope.$digest();
      }
    });

    if (self.openOnFocus) {
      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
      angular.element(self.$window).on('blur', self.windowBlurHandler);

      $scope.$on('$destroy', function() {
        angular.element(self.$window).off('blur', self.windowBlurHandler);
      });
    }

    $scope.$on('md-calendar-close', function() {
      self.closeCalendarPane();
    });
  };

  /**
   * Capture properties set to the date-picker and imperitively handle internal changes.
   * This is done to avoid setting up additional $watches.
   */
  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
    var self = this;

    if (this.$attrs.ngDisabled) {
      // The expression is to be evaluated against the directive element's scope and not
      // the directive's isolate scope.
      var scope = this.$scope.$parent;

      if (scope) {
        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
          self.setDisabled(isDisabled);
        });
      }
    }

    Object.defineProperty(this, 'placeholder', {
      get: function() { return self.inputElement.placeholder; },
      set: function(value) { self.inputElement.placeholder = value || ''; }
    });
  };

  /**
   * Sets whether the date-picker is disabled.
   * @param {boolean} isDisabled
   */
  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
    this.isDisabled = isDisabled;
    this.inputElement.disabled = isDisabled;

    if (this.calendarButton) {
      this.calendarButton.disabled = isDisabled;
    }
  };

  /**
   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
   *   - mindate: whether the selected date is before the minimum date.
   *   - maxdate: whether the selected flag is after the maximum date.
   *   - filtered: whether the selected date is allowed by the custom filtering function.
   *   - valid: whether the entered text input is a valid date
   *
   * The 'required' flag is handled automatically by ngModel.
   *
   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
   */
  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
    var date = opt_date || this.date;

    // Clear any existing errors to get rid of anything that's no longer relevant.
    this.clearErrorState();

    if (this.dateUtil.isValidDate(date)) {
      // Force all dates to midnight in order to ignore the time portion.
      date = this.dateUtil.createDateAtMidnight(date);

      if (this.dateUtil.isValidDate(this.minDate)) {
        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
      }

      if (this.dateUtil.isValidDate(this.maxDate)) {
        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
      }

      if (angular.isFunction(this.dateFilter)) {
        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
      }
    } else {
      // The date is seen as "not a valid date" if there is *something* set
      // (i.e.., not null or undefined), but that something isn't a valid date.
      this.ngModelCtrl.$setValidity('valid', date == null);
    }

    angular.element(this.inputContainer).toggleClass(INVALID_CLASS, !this.ngModelCtrl.$valid);
  };

  /** Clears any error flags set by `updateErrorState`. */
  DatePickerCtrl.prototype.clearErrorState = function() {
    this.inputContainer.classList.remove(INVALID_CLASS);
    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
      this.ngModelCtrl.$setValidity(field, true);
    }, this);
  };

  /** Resizes the input element based on the size of its content. */
  DatePickerCtrl.prototype.resizeInputElement = function() {
    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
  };

  /**
   * Sets the model value if the user input is a valid date.
   * Adds an invalid class to the input element if not.
   */
  DatePickerCtrl.prototype.handleInputEvent = function() {
    var inputString = this.inputElement.value;
    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
    this.dateUtil.setDateTimeToMidnight(parsedDate);

    // An input string is valid if it is either empty (representing no date)
    // or if it parses to a valid date that the user is allowed to select.
    var isValidInput = inputString == '' || (
      this.dateUtil.isValidDate(parsedDate) &&
      this.locale.isDateComplete(inputString) &&
      this.isDateEnabled(parsedDate)
    );

    // The datepicker's model is only updated when there is a valid input.
    if (isValidInput) {
      this.setModelValue(parsedDate);
      this.date = parsedDate;
    }

    this.updateErrorState(parsedDate);
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date));
  };

  /** Position and attach the floating calendar to the document. */
  DatePickerCtrl.prototype.attachCalendarPane = function() {
    var calendarPane = this.calendarPane;
    var body = document.body;

    calendarPane.style.transform = '';
    this.$element.addClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
    angular.element(body).addClass('md-datepicker-is-showing');

    var elementRect = this.inputContainer.getBoundingClientRect();
    var bodyRect = body.getBoundingClientRect();

    if (!this.topMargin || this.topMargin < 0) {
      this.topMargin = (this.inputMask.parent().prop('clientHeight') - this.ngInputElement.prop('clientHeight')) / 2;
    }

    // Check to see if the calendar pane would go off the screen. If so, adjust position
    // accordingly to keep it within the viewport.
    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;

    // If ng-material has disabled body scrolling (for example, if a dialog is open),
    // then it's possible that the already-scrolled body has a negative top/left. In this case,
    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
    // though, the top of the viewport should just be the body's scroll position.
    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop == 0) ?
        -bodyRect.top :
        document.body.scrollTop;

    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft == 0) ?
        -bodyRect.left :
        document.body.scrollLeft;

    var viewportBottom = viewportTop + this.$window.innerHeight;
    var viewportRight = viewportLeft + this.$window.innerWidth;

    // Creates an overlay with a hole the same size as element. We remove a pixel or two
    // on each end to make it overlap slightly. The overlay's background is added in
    // the theme in the form of a box-shadow with a huge spread.
    this.inputMask.css({
      position: 'absolute',
      left: this.leftMargin + 'px',
      top: this.topMargin + 'px',
      width: (elementRect.width - 1) + 'px',
      height: (elementRect.height - 2) + 'px'
    });

    // If the right edge of the pane would be off the screen and shifting it left by the
    // difference would not go past the left edge of the screen. If the calendar pane is too
    // big to fit on the screen at all, move it to the left of the screen and scale the entire
    // element down to fit.
    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
      } else {
        paneLeft = viewportLeft;
        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
        calendarPane.style.transform = 'scale(' + scale + ')';
      }

      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    // If the bottom edge of the pane would be off the screen and shifting it up by the
    // difference would not go past the top edge of the screen.
    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    calendarPane.style.left = paneLeft + 'px';
    calendarPane.style.top = paneTop + 'px';
    document.body.appendChild(calendarPane);

    // Add CSS class after one frame to trigger open animation.
    this.$$rAF(function() {
      calendarPane.classList.add('md-pane-open');
    });
  };

  /** Detach the floating calendar pane from the document. */
  DatePickerCtrl.prototype.detachCalendarPane = function() {
    this.$element.removeClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
    angular.element(document.body).removeClass('md-datepicker-is-showing');
    this.calendarPane.classList.remove('md-pane-open');
    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

    if (this.isCalendarOpen) {
      this.$mdUtil.enableScrolling();
    }

    if (this.calendarPane.parentNode) {
      // Use native DOM removal because we do not want any of the
      // angular state of this element to be disposed.
      this.calendarPane.parentNode.removeChild(this.calendarPane);
    }
  };

  /**
   * Open the floating calendar pane.
   * @param {Event} event
   */
  DatePickerCtrl.prototype.openCalendarPane = function(event) {
    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
      this.isCalendarOpen = this.isOpen = true;
      this.calendarPaneOpenedFrom = event.target;

      // Because the calendar pane is attached directly to the body, it is possible that the
      // rest of the component (input, etc) is in a different scrolling container, such as
      // an md-content. This means that, if the container is scrolled, the pane would remain
      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
      // also matches the native behavior for things like `<select>` on Mac and Windows.
      this.$mdUtil.disableScrollAround(this.calendarPane);

      this.attachCalendarPane();
      this.focusCalendar();
      this.evalAttr('ngFocus');

      // Attach click listener inside of a timeout because, if this open call was triggered by a
      // click, we don't want it to be immediately propogated up to the body and handled.
      var self = this;
      this.$mdUtil.nextTick(function() {
        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
        // events aren't propogated under most circumstances.
        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        self.documentElement.on('click touchstart', self.bodyClickHandler);
      }, false);

      window.addEventListener(this.windowEventName, this.windowEventHandler);
    }
  };

  /** Close the floating calendar pane. */
  DatePickerCtrl.prototype.closeCalendarPane = function() {
    if (this.isCalendarOpen) {
      var self = this;

      self.detachCalendarPane();
      self.ngModelCtrl.$setTouched();
      self.evalAttr('ngBlur');

      self.documentElement.off('click touchstart', self.bodyClickHandler);
      window.removeEventListener(self.windowEventName, self.windowEventHandler);

      self.calendarPaneOpenedFrom.focus();
      self.calendarPaneOpenedFrom = null;

      if (self.openOnFocus) {
        // Ensures that all focus events have fired before resetting
        // the calendar. Prevents the calendar from reopening immediately
        // in IE when md-open-on-focus is set. Also it needs to trigger
        // a digest, in order to prevent issues where the calendar wasn't
        // showing up on the next open.
        self.$mdUtil.nextTick(reset);
      } else {
        reset();
      }
    }

    function reset(){
      self.isCalendarOpen = self.isOpen = false;
    }
  };

  /** Gets the controller instance for the calendar in the floating pane. */
  DatePickerCtrl.prototype.getCalendarCtrl = function() {
    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
  };

  /** Focus the calendar in the floating pane. */
  DatePickerCtrl.prototype.focusCalendar = function() {
    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
    var self = this;
    this.$mdUtil.nextTick(function() {
      self.getCalendarCtrl().focus();
    }, false);
  };

  /**
   * Sets whether the input is currently focused.
   * @param {boolean} isFocused
   */
  DatePickerCtrl.prototype.setFocused = function(isFocused) {
    if (!isFocused) {
      this.ngModelCtrl.$setTouched();
    }

    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
    // because they also get called when the calendar is opened/closed.
    if (!this.openOnFocus) {
      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
    }

    this.isFocused = isFocused;
  };

  /**
   * Handles a click on the document body when the floating calendar pane is open.
   * Closes the floating calendar pane if the click is not inside of it.
   * @param {MouseEvent} event
   */
  DatePickerCtrl.prototype.handleBodyClick = function(event) {
    if (this.isCalendarOpen) {
      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');

      if (!isInCalendar) {
        this.closeCalendarPane();
      }

      this.$scope.$digest();
    }
  };

  /**
   * Handles the event when the user navigates away from the current tab. Keeps track of
   * whether the input was focused when the event happened, in order to prevent the calendar
   * from re-opening.
   */
  DatePickerCtrl.prototype.handleWindowBlur = function() {
    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
  };

  /**
   * Evaluates an attribute expression against the parent scope.
   * @param {String} attr Name of the attribute to be evaluated.
   */
  DatePickerCtrl.prototype.evalAttr = function(attr) {
    if (this.$attrs[attr]) {
      this.$scope.$parent.$eval(this.$attrs[attr]);
    }
  };

  /**
   * Sets the ng-model value by first converting the date object into a strng. Converting it
   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
   * the value into a Date object afterwards, before setting it on the model.
   * @param {Date=} value Date to be set as the model value.
   */
  DatePickerCtrl.prototype.setModelValue = function(value) {
    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
    this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone));
  };

  /**
   * Updates the datepicker when a model change occurred externally.
   * @param {Date=} value Value that was set to the model.
   */
  DatePickerCtrl.prototype.onExternalChange = function(value) {
    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');

    this.date = value;
    this.inputElement.value = this.locale.formatDate(value, timezone);
    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
    this.resizeInputElement();
    this.updateErrorState();
  };
})();

})();
(function(){
"use strict";

angular
  .module('material.components.icon')
  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);

/**
 * @ngdoc directive
 * @name mdIcon
 * @module material.components.icon
 *
 * @restrict E
 *
 * @description
 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
 *
 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
 * inside a `md-button` to add hover and click features.
 *
 * ### Icon fonts
 * Icon fonts are a technique in which you use a font where the glyphs in the font are
 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
 * single HTTP request, simple scaling, easy color changing, and more.
 *
 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
 * by name rather than character code.
 *
 * ### SVG
 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
 * animation.
 *
 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
 * reference it by name instead of URL throughout your templates.
 *
 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
 * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
 * also be given a name, which acts as a namespace for individual icons, so you can reference them
 * like `"social:cake"`.
 *
 * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
 * easily loaded and used. When using font-icons, developers must follow three (3) simple steps:
 *
 * <ol>
 * <li>Load the font library. e.g.<br/>
 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
 *    rel="stylesheet">`
 * </li>
 * <li>
 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
 *   none is specified.
 * </li>
 * <li> Use any of the following templates: <br/>
 *   <ul>
 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
 *   </ul>
 * </li>
 * </ol>
 *
 * Full details for these steps can be found:
 *
 * <ul>
 * <li>http://google.github.io/material-design-icons/</li>
 * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
 * </ul>
 *
 * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
 * Material Design Icons:
 *
 * <ul>
 * <li>https://design.google.com/icons/</li>
 * <li>https://design.google.com/icons/#ic_accessibility</li>
 * </ul>
 *
 * ### Localization
 *
 * Because an `md-icon` element's text content is not intended to translated, it is recommended to declare the text
 * content for an `md-icon` element in its start tag. Instead of using the HTML text content, consider using `ng-bind`
 * with a scope variable or literal string.
 *
 * Examples:
 *
 * <ul>
 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
 * </ul>
 *
 * <h2 id="material_design_icons">Material Design Icons</h2>
 * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
 * determine its textual name and character reference code. Click on any icon to see the slide-up information
 * panel with details regarding a SVG download or information on the font-icon usage.
 *
 * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
 * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
 *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
 * </a>
 *
 * <span class="image_caption">
 *  Click on the image above to link to the
 *  <a href="https://design.google.com/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
 * </span>
 *
 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
 *     external SVG.
 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
 *     interpolated strings or expressions may also be used. Specific set names can be used with
 *     the syntax `<set name>:<icon name>`.<br/><br/>
 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
 * nor a label on the parent element, a warning will be logged to the console.
 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
 * nor a label on the parent element, a warning will be logged to the console.
 *
 * @usage
 * When using SVGs:
 * <hljs lang="html">
 *
 *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
 *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
 *
 *  <!-- Icon urls; may be preloaded in templateCache -->
 *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
 *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
 *
 * </hljs>
 *
 * Use the <code>$mdIconProvider</code> to configure your application with
 * svg iconsets.
 *
 * <hljs lang="js">
 *  angular.module('appSvgIconSets', ['ngMaterial'])
 *    .controller('DemoCtrl', function($scope) {})
 *    .config(function($mdIconProvider) {
 *      $mdIconProvider
 *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
 *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
 *     });
 * </hljs>
 *
 *
 * When using Font Icons with classnames:
 * <hljs lang="html">
 *
 *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
 *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
 *
 * </hljs>
 *
 * When using Material Font Icons with ligatures:
 * <hljs lang="html">
 *  <!--
 *  For Material Design Icons
 *  The class '.material-icons' is auto-added if a style has NOT been specified
 *  since `material-icons` is the default fontset. So your markup:
 *  -->
 *  <md-icon> face </md-icon>
 *  <!-- becomes this at runtime: -->
 *  <md-icon md-font-set="material-icons"> face </md-icon>
 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
 *  <md-icon> &#xE87C; </md-icon>
 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
 * </hljs>
 *
 * When using other Font-Icon libraries:
 *
 * <hljs lang="js">
 *  // Specify a font-icon style alias
 *  angular.config(function($mdIconProvider) {
 *    $mdIconProvider.fontSet('md', 'material-icons');
 *  });
 * </hljs>
 *
 * <hljs lang="html">
 *  <md-icon md-font-set="md">favorite</md-icon>
 * </hljs>
 *
 */
function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {

  return {
    restrict: 'E',
    link : postLink
  };


  /**
   * Directive postLink
   * Supports embedded SVGs, font-icons, & external SVGs
   */
  function postLink(scope, element, attr) {
    $mdTheming(element);
    var lastFontIcon = attr.mdFontIcon;
    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);

    prepareForFontIcon();

    attr.$observe('mdFontIcon', fontIconChanged);
    attr.$observe('mdFontSet', fontIconChanged);

    // Keep track of the content of the svg src so we can compare against it later to see if the
    // attribute is static (and thus safe).
    var originalSvgSrc = element[0].getAttribute(attr.$attr.mdSvgSrc);

    // If using a font-icon, then the textual name of the icon itself
    // provides the aria-label.

    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');

    /* Provide a default accessibility role of img */
    if (!attr.role) {
      $mdAria.expect(element, 'role', 'img');
      /* manually update attr variable */
      attr.role = 'img';
    }

    /* Don't process ARIA if already valid */
    if ( attr.role === "img" && !attr.ariaHidden && !$mdAria.hasAriaLabel(element) ) {
      var iconName;
      if (attr.alt) {
        /* Use alt text by default if available */
        $mdAria.expect(element, 'aria-label', attr.alt);
      } else if ($mdAria.parentHasAriaLabel(element, 2)) {
        /* Parent has ARIA so we will assume it will describe the image */
        $mdAria.expect(element, 'aria-hidden', 'true');
      } else if (iconName = (attr.mdFontIcon || attr.mdSvgIcon || element.text())) {
        /* Use icon name as aria-label */
        $mdAria.expect(element, 'aria-label', iconName);
      } else {
        /* No label found */
        $mdAria.expect(element, 'aria-hidden', 'true');
      }
    }

    if (attrName) {
      // Use either pre-configured SVG or URL source, respectively.
      attr.$observe(attrName, function(attrVal) {
        element.empty();
        if (attrVal) {
          $mdIcon(attrVal)
            .then(function(svg) {
            element.empty();
            element.append(svg);
          });
        }
      });
    }

    function prepareForFontIcon() {
      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
        if (attr.mdFontIcon) {
          element.addClass('md-font ' + attr.mdFontIcon);
        }

        element.addClass(lastFontSet);
      }
    }

    function fontIconChanged() {
      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
        if (attr.mdFontIcon) {
          element.removeClass(lastFontIcon);
          element.addClass(attr.mdFontIcon);

          lastFontIcon = attr.mdFontIcon;
        }

        var fontSet = $mdIcon.fontSet(attr.mdFontSet);

        if (lastFontSet !== fontSet) {
          element.removeClass(lastFontSet);
          element.addClass(fontSet);

          lastFontSet = fontSet;
        }
      }
    }
  }
}

})();
(function(){
"use strict";

  
MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
    .module('material.components.icon')
    .constant('$$mdSvgRegistry', {
        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
    })
    .provider('$mdIcon', MdIconProvider);

/**
 * @ngdoc service
 * @name $mdIconProvider
 * @module material.components.icon
 *
 * @description
 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
 * directives are compiled.
 *
 * If using font-icons, the developer is responsible for loading the fonts.
 *
 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
 * that URL is used to on-demand load and parse the SVG dynamically.
 *
 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
 *
 * <hljs lang="js">
 *   app.config(function($sceDelegateProvider) {
 *     $sceDelegateProvider.resourceUrlWhitelist([
 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
 *       'self',
 *       // Using double asterisks here, will allow all URLs to load.
 *       // We recommend to only specify the given domain you want to allow.
 *       '**'
 *     ]);
 *   });
 * </hljs>
 *
 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
 *
 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
 *  In such cases you are not able to use the icon's ligature name - Like so:
 *
 *  <hljs lang="html">
 *    <md-icon md-font-set="fa">fa-bell</md-icon>
 *  </hljs>
 *
 * You should instead use the given unicode, instead of the ligature name.
 *
 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
 *  ```html
 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
 *  ```
 *
 * All unicode ligatures are prefixed with the `&#x` string.
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
    *   });
 * </hljs>
 *
 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
 * **startup** process (shown below):
 *
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Register a default set of SVG icon definitions
    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
    *
    *   })
 *   .run(function($templateRequest){
    *
    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
    *     // subsequent $templateRequest calls will look there first.
    *
    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
    *
    *     angular.forEach(urls, function(url) {
    *       $templateRequest(url);
    *     });
    *
    *   });
 *
 * </hljs>
 *
 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
 *
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#icon
 *
 * @description
 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
 *
 * @param {string} id Icon name/id used to register the icon
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
 * It is ignored for icons with an existing viewBox. Default size is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
    *   });
 * </hljs>
 *
 */
/**
 * @ngdoc method
 * @name $mdIconProvider#iconSet
 *
 * @description
 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
 * `$mdIcon(<icon set name>:<icon name>)`
 *
 * @param {string} id Icon name/id used to register the iconset
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
 * Default value is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
    *   });
 * </hljs>
 *
 */
/**
 * @ngdoc method
 * @name $mdIconProvider#defaultIconSet
 *
 * @description
 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
 * subsequent lookups of icons will failover to search this 'default' icon set.
 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
 *
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
 * Default value is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
    *   });
 * </hljs>
 *
 */
/**
 * @ngdoc method
 * @name $mdIconProvider#defaultFontSet
 *
 * @description
 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and automatically
 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
 * class style that should be applied to the `<md-icon>`.
 *
 * Configuring the default means that the attributes
 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
 * `<md-icon>` markup. For example:
 *
 *  `<md-icon> face </md-icon>`
 *  will render as
 *  `<span class="material-icons"> face </span>`, and
 *
 *  `<md-icon md-font-set="fa"> face </md-icon>`
 *  will render as
 *  `<span class="fa"> face </span>`
 *
 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
   *     $mdIconProvider.defaultFontSet( 'fa' );
   *   });
 * </hljs>
 *
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#fontSet
 *
 * @description
 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
 * solution is to define an `alias` for your fontset:
 *
 * @param {string} alias of the specified fontset.
 * @param {string} className of the fontset.
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
   *     // In this case, we set an alias for the `material-icons` fontset.
   *     $mdIconProvider.fontSet('md', 'material-icons');
   *   });
 * </hljs>
 *
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#defaultViewBoxSize
 *
 * @description
 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
 * the default width **and** height used for all icons; unless overridden by specific CSS.
 * The default sizing is (24px, 24px).
 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
 * All icons in a set should be the same size. The default value is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
    *   });
 * </hljs>
 *
 */

var config = {
  defaultViewBoxSize: 24,
  defaultFontSet: 'material-icons',
  fontSets: []
};

function MdIconProvider() {
}

MdIconProvider.prototype = {
  icon: function(id, url, viewBoxSize) {
    if (id.indexOf(':') == -1) id = '$default:' + id;

    config[id] = new ConfigurationItem(url, viewBoxSize);
    return this;
  },

  iconSet: function(id, url, viewBoxSize) {
    config[id] = new ConfigurationItem(url, viewBoxSize);
    return this;
  },

  defaultIconSet: function(url, viewBoxSize) {
    var setName = '$default';

    if (!config[setName]) {
      config[setName] = new ConfigurationItem(url, viewBoxSize);
    }

    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;

    return this;
  },

  defaultViewBoxSize: function(viewBoxSize) {
    config.defaultViewBoxSize = viewBoxSize;
    return this;
  },

  /**
   * Register an alias name associated with a font-icon library style ;
   */
  fontSet: function fontSet(alias, className) {
    config.fontSets.push({
      alias: alias,
      fontSet: className || alias
    });
    return this;
  },

  /**
   * Specify a default style name associated with a font-icon library
   * fallback to Material Icons.
   *
   */
  defaultFontSet: function defaultFontSet(className) {
    config.defaultFontSet = !className ? '' : className;
    return this;
  },

  defaultIconSize: function defaultIconSize(iconSize) {
    config.defaultIconSize = iconSize;
    return this;
  },

  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
  }]
};

/**
 *  Configuration item stored in the Icon registry; used for lookups
 *  to load if not already cached in the `loaded` cache
 */
function ConfigurationItem(url, viewBoxSize) {
  this.url = url;
  this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
}

/**
 * @ngdoc service
 * @name $mdIcon
 * @module material.components.icon
 *
 * @description
 * The `$mdIcon` service is a function used to lookup SVG icons.
 *
 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
 *
 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
 * using the `$mdIconProvider`.
 *
 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
 * will get rejected.
 *
 * @usage
 * <hljs lang="js">
 * function SomeDirective($mdIcon) {
  *
  *   // See if the icon has already been loaded, if not
  *   // then lookup the icon from the registry cache, load and cache
  *   // it for future requests.
  *   // NOTE: ID queries require configuration with $mdIconProvider
  *
  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
  *
  *   // Load and cache the external SVG using a URL
  *
  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
  *     element.append(iconEl);
  *   });
  * };
 * </hljs>
 *
 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, loaded,
 *   and instantiate SVG DOM elements.
 */

/* @ngInject */
function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
  var iconCache = {};
  var svgCache = {};
  var urlRegex = /[-\w@:%\+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%\+.~#?&//=]*)?/i;
  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-\=]*?(base64)?,(.*)$/i;

  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
  getIcon.fontSet = findRegisteredFontSet;

  // Publish service...
  return getIcon;

  /**
   * Actual $mdIcon service is essentially a lookup function
   */
  function getIcon(id) {
    id = id || '';

    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
    // over a URL string. If the value is not trusted, this will intentionally throw an error
    // because the user is attempted to use an unsafe URL, potentially opening themselves up
    // to an XSS attack.
    if (!angular.isString(id)) {
      id = $sce.getTrustedUrl(id);
    }

    // If already loaded and cached, use a clone of the cached icon.
    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.

    if (iconCache[id]) {
      return $q.when(transformClone(iconCache[id]));
    }

    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
      return loadByURL(id).then(cacheIcon(id));
    }

    if (id.indexOf(':') == -1) {
      id = '$default:' + id;
    }

    var load = config[id] ? loadByID : loadFromIconSet;
    return load(id)
      .then(cacheIcon(id));
  }

  /**
   * Lookup registered fontSet style using its alias...
   * If not found,
   */
  function findRegisteredFontSet(alias) {
    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
    if (useDefault) return config.defaultFontSet;

    var result = alias;
    angular.forEach(config.fontSets, function(it) {
      if (it.alias == alias) result = it.fontSet || result;
    });

    return result;
  }

  function transformClone(cacheElement) {
    var clone = cacheElement.clone();
    var cacheSuffix = '_cache' + $mdUtil.nextUid();

    // We need to modify for each cached icon the id attributes.
    // This is needed because SVG id's are treated as normal DOM ids
    // and should not have a duplicated id.
    if (clone.id) clone.id += cacheSuffix;
    angular.forEach(clone.querySelectorAll('[id]'), function(item) {
      item.id += cacheSuffix;
    });

    return clone;
  }

  /**
   * Prepare and cache the loaded icon for the specified `id`
   */
  function cacheIcon(id) {

    return function updateCache(icon) {
      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);

      return iconCache[id].clone();
    };
  }

  /**
   * Lookup the configuration in the registry, if !registered throw an error
   * otherwise load the icon [on-demand] using the registered URL.
   *
   */
  function loadByID(id) {
    var iconConfig = config[id];
    return loadByURL(iconConfig.url).then(function(icon) {
      return new Icon(icon, iconConfig);
    });
  }

  /**
   *    Loads the file as XML and uses querySelector( <id> ) to find
   *    the desired node...
   */
  function loadFromIconSet(id) {
    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
    var iconSetConfig = config[setName];

    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);

    function extractFromSet(set) {
      var iconName = id.slice(id.lastIndexOf(':') + 1);
      var icon = set.querySelector('#' + iconName);
      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
    }

    function announceIdNotFound(id) {
      var msg = 'icon ' + id + ' not found';
      $log.warn(msg);

      return $q.reject(msg || id);
    }
  }

  /**
   * Load the icon by URL (may use the $templateCache).
   * Extract the data for later conversion to Icon
   */
  function loadByURL(url) {
    /* Load the icon from embedded data URL. */
    function loadByDataUrl(url) {
      var results = dataUrlRegex.exec(url);
      var isBase64 = /base64/i.test(url);
      var data = isBase64 ? window.atob(results[2]) : results[2];

      return $q.when(angular.element(data)[0]);
    }

    /* Load the icon by URL using HTTP. */
    function loadByHttpUrl(url) {
      return $q(function(resolve, reject) {
        // Catch HTTP or generic errors not related to incorrect icon IDs.
        var announceAndReject = function(err) {
            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
            $log.warn(msg);
            reject(err);
          },
          extractSvg = function(response) {
            if (!svgCache[url]) {
              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
            }
            resolve(svgCache[url]);
          };

        $templateRequest(url, true).then(extractSvg, announceAndReject);
      });
    }

    return dataUrlRegex.test(url)
      ? loadByDataUrl(url)
      : loadByHttpUrl(url);
  }

  /**
   * Check target signature to see if it is an Icon instance.
   */
  function isIcon(target) {
    return angular.isDefined(target.element) && angular.isDefined(target.config);
  }

  /**
   *  Define the Icon class
   */
  function Icon(el, config) {
    if (el && el.tagName != 'svg') {
      el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
    }

    // Inject the namespace if not available...
    if (!el.getAttribute('xmlns')) {
      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
    }

    this.element = el;
    this.config = config;
    this.prepare();
  }

  /**
   *  Prepare the DOM element that will be cached in the
   *  loaded iconCache store.
   */
  function prepareAndStyle() {
    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
    angular.forEach({
      'fit': '',
      'height': '100%',
      'width': '100%',
      'preserveAspectRatio': 'xMidYMid meet',
      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
      'focusable': false // Disable IE11s default behavior to make SVGs focusable
    }, function(val, attr) {
      this.element.setAttribute(attr, val);
    }, this);
  }

  /**
   * Clone the Icon DOM element.
   */
  function cloneSVG() {
    // If the element or any of its children have a style attribute, then a CSP policy without
    // 'unsafe-inline' in the style-src directive, will result in a violation.
    return this.element.cloneNode(true);
  }

}

})();
(function(){
"use strict";



MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
angular
    .module('material.components.menu')
    .controller('mdMenuCtrl', MenuController);

/**
 * @ngInject
 */
function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {

  var prefixer = $mdUtil.prefixer();
  var menuContainer;
  var self = this;
  var triggerElement;

  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;

  /**
   * Called by our linking fn to provide access to the menu-content
   * element removed during link
   */
  this.init = function init(setMenuContainer, opts) {
    opts = opts || {};
    menuContainer = setMenuContainer;

    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
    triggerElement.setAttribute('aria-expanded', 'false');

    this.isInMenuBar = opts.isInMenuBar;
    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));

    menuContainer.on('$mdInterimElementRemove', function() {
      self.isOpen = false;
      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
    });
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});

    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
    menuContainer.attr('id', menuContainerId);
    angular.element(triggerElement).attr({
      'aria-owns': menuContainerId,
      'aria-haspopup': 'true'
    });

    $scope.$on('$destroy', angular.bind(this, function() {
      this.disableHoverListener();
      $mdMenu.destroy();
    }));

    menuContainer.on('$destroy', function() {
      $mdMenu.destroy();
    });
  };

  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
  this.enableHoverListener = function() {
    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
      if (menuContainer[0].contains(el[0])) {
        self.currentlyOpenMenu = el.controller('mdMenu');
        self.isAlreadyOpening = false;
        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
      }
    }));
    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
      if (menuContainer[0].contains(el[0])) {
        self.currentlyOpenMenu = undefined;
      }
    }));
    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
    menuItems.on('mouseenter', self.handleMenuItemHover);
    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
  };

  this.disableHoverListener = function() {
    while (deregisterScopeListeners.length) {
      deregisterScopeListeners.shift()();
    }
    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
  };

  this.handleMenuItemHover = function(event) {
    if (self.isAlreadyOpening) return;
    var nestedMenu = (
      event.target.querySelector('md-menu')
        || $mdUtil.getClosest(event.target, 'MD-MENU')
    );
    openMenuTimeout = $timeout(function() {
      if (nestedMenu) {
        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
      }

      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
        var closeTo = self.nestLevel + 1;
        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
        self.isAlreadyOpening = !!nestedMenu;
        nestedMenu && nestedMenu.open();
      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
        self.isAlreadyOpening = !!nestedMenu;
        nestedMenu && nestedMenu.open();
      }
    }, nestedMenu ? 100 : 250);
    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
    focusableTarget && focusableTarget.focus();
  };

  this.handleMenuItemMouseLeave = function() {
    if (openMenuTimeout) {
      $timeout.cancel(openMenuTimeout);
      openMenuTimeout = undefined;
    }
  };


  /**
   * Uses the $mdMenu interim element service to open the menu contents
   */
  this.open = function openMenu(ev) {
    ev && ev.stopPropagation();
    ev && ev.preventDefault();
    if (self.isOpen) return;
    self.enableHoverListener();
    self.isOpen = true;
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
    triggerElement.setAttribute('aria-expanded', 'true');
    $scope.$emit('$mdMenuOpen', $element);
    $mdMenu.show({
      scope: $scope,
      mdMenuCtrl: self,
      nestLevel: self.nestLevel,
      element: menuContainer,
      target: triggerElement,
      preserveElement: true,
      parent: 'body'
    }).finally(function() {
      triggerElement.setAttribute('aria-expanded', 'false');
      self.disableHoverListener();
    });
  };

  this.onIsOpenChanged = function(isOpen) {
    if (isOpen) {
      menuContainer.attr('aria-hidden', 'false');
      $element[0].classList.add('md-open');
      angular.forEach(self.nestedMenus, function(el) {
        el.classList.remove('md-open');
      });
    } else {
      menuContainer.attr('aria-hidden', 'true');
      $element[0].classList.remove('md-open');
    }
    $scope.$mdMenuIsOpen = self.isOpen;
  };

  this.focusMenuContainer = function focusMenuContainer() {
    var focusTarget = menuContainer[0]
      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));

    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
    focusTarget.focus();
  };

  this.registerContainerProxy = function registerContainerProxy(handler) {
    this.containerProxy = handler;
  };

  this.triggerContainerProxy = function triggerContainerProxy(ev) {
    this.containerProxy && this.containerProxy(ev);
  };

  this.destroy = function() {
    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
  };

  // Use the $mdMenu interim element service to close the menu contents
  this.close = function closeMenu(skipFocus, closeOpts) {
    if ( !self.isOpen ) return;
    self.isOpen = false;
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});

    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
    $scope.$emit('$mdMenuClose', $element, eventDetails);
    $mdMenu.hide(null, closeOpts);

    if (!skipFocus) {
      var el = self.restoreFocusTo || $element.find('button')[0];
      if (el instanceof angular.element) el = el[0];
      if (el) el.focus();
    }
  };

  /**
   * Build a nice object out of our string attribute which specifies the
   * target mode for left and top positioning
   */
  this.positionMode = function positionMode() {
    var attachment = ($attrs.mdPositionMode || 'target').split(' ');

    // If attachment is a single item, duplicate it for our second value.
    // ie. 'target' -> 'target target'
    if (attachment.length == 1) {
      attachment.push(attachment[0]);
    }

    return {
      left: attachment[0],
      top: attachment[1]
    };
  };

  /**
   * Build a nice object out of our string attribute which specifies
   * the offset of top and left in pixels.
   */
  this.offsets = function offsets() {
    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
    if (position.length == 2) {
      return {
        left: position[0],
        top: position[1]
      };
    } else if (position.length == 1) {
      return {
        top: position[0],
        left: position[0]
      };
    } else {
      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
    }
  };

  // Functionality that is exposed in the view.
  $scope.$mdMenu = {
    open: this.open,
    close: this.close
  };

  // Deprecated APIs
  $scope.$mdOpenMenu = angular.bind(this, function() {
    $log.warn('mdMenu: The $mdOpenMenu method is deprecated. Please use `$mdMenu.open`.');
    return this.open.apply(this, arguments);
  });
}

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdMenu
 * @module material.components.menu
 * @restrict E
 * @description
 *
 * Menus are elements that open when clicked. They are useful for displaying
 * additional options within the context of an action.
 *
 * Every `md-menu` must specify exactly two child elements. The first element is what is
 * left in the DOM and is used to open the menu. This element is called the trigger element.
 * The trigger element's scope has access to `$mdMenu.open($event)`
 * which it may call to open the menu. By passing $event as argument, the
 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
 * can be used to close the menu.
 *
 * The second element is the `md-menu-content` element which represents the
 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
 * but you can do custom content as well.
 *
 * <hljs lang="html">
 * <md-menu>
 *  <!-- Trigger element is a md-button with an icon -->
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
 *    <md-icon md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>

 * ## Sizing Menus
 *
 * The width of the menu when it is open may be specified by specifying a `width`
 * attribute on the `md-menu-content` element.
 * See the [Material Design Spec](https://material.google.com/components/menus.html#menus-simple-menus)
 * for more information.
 *
 *
 * ## Aligning Menus
 *
 * When a menu opens, it is important that the content aligns with the trigger element.
 * Failure to align menus can result in jarring experiences for users as content
 * suddenly shifts. To help with this, `md-menu` provides serveral APIs to help
 * with alignment.
 *
 * ### Target Mode
 *
 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
 * designated child elements in both the trigger and the menu content.
 *
 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
 * will be used as the origin element.
 *
 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
 * `md-menu-item` to specify the node that it should try and align with.
 *
 * In this example code, we specify an icon to be our origin element, and an
 * icon in our menu content to be our alignment target. This ensures that both
 * icons are aligned when the menu opens.
 *
 * <hljs lang="html">
 * <md-menu>
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item>
 *      <md-button ng-click="doSomething()" aria-label="Do something">
 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
 *        Do Something
 *      </md-button>
 *    </md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>
 *
 * Sometimes we want to specify alignment on the right side of an element, for example
 * if we have a menu on the right side a toolbar, we want to right align our menu content.
 *
 * We can specify the origin by using the `md-position-mode` attribute on both
 * the `x` and `y` axis. Right now only the `x-axis` has more than one option.
 * You may specify the default mode of `target target` or
 * `target-right target` to specify a right-oriented alignment target. See the
 * position section of the demos for more examples.
 *
 * ### Menu Offsets
 *
 * It is sometimes unavoidable to need to have a deeper level of control for
 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
 * the `md-offset` attribute to allow pixel level specificty of adjusting the
 * exact positioning.
 *
 * This offset is provided in the format of `x y` or `n` where `n` will be used
 * in both the `x` and `y` axis.
 *
 * For example, to move a menu by `2px` down from the top, we can use:
 * <hljs lang="html">
 * <md-menu md-offset="0 2">
 *   <!-- menu-content -->
 * </md-menu>
 * </hljs>
 *
 * ### Auto Focus
 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
 *
 * But sometimes you would like to focus another specific menu item instead of the first.<br/>
 * This can be done by applying the `md-autofocus` directive on the given element.
 *
 * <hljs lang="html">
 * <md-menu-item>
 *   <md-button md-autofocus ng-click="doSomething()">
 *     Auto Focus
 *   </md-button>
 * </md-menu-item>
 * </hljs>
 *
 *
 * ### Preventing close
 *
 * Sometimes you would like to be able to click on a menu item without having the menu
 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
 * can be added to a button inside a menu to stop the menu from automatically closing.
 * You can then close the menu either by using `$mdMenu.close()` in the template,
 * or programatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
 *
 * <hljs lang="html">
 * <md-menu-content ng-mouseleave="$mdMenu.close()">
 *   <md-menu-item>
 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
 *       Do Something
 *     </md-button>
 *   </md-menu-item>
 * </md-menu-content>
 * </hljs>
 *
 * @usage
 * <hljs lang="html">
 * <md-menu>
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
 *    <md-icon md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>
 *
 * @param {string} md-position-mode The position mode in the form of
 *           `x`, `y`. Default value is `target`,`target`. Right now the `x` axis
 *           also supports `target-right`.
 * @param {string} md-offset An offset to apply to the dropdown after positioning
 *           `x`, `y`. Default value is `0`,`0`.
 *
 */

MenuDirective.$inject = ["$mdUtil"];
angular
    .module('material.components.menu')
    .directive('mdMenu', MenuDirective);

/**
 * @ngInject
 */
function MenuDirective($mdUtil) {
  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
  return {
    restrict: 'E',
    require: ['mdMenu', '?^mdMenuBar'],
    controller: 'mdMenuCtrl', // empty function to be built by link
    scope: true,
    compile: compile
  };

  function compile(templateElement) {
    templateElement.addClass('md-menu');

    var triggerEl = templateElement.children()[0];
    var contentEl = templateElement.children()[1];

    var prefixer = $mdUtil.prefixer();

    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
      triggerEl = triggerEl
          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
    }

    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';

    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
      triggerEl.setAttribute('type', 'button');
    }

    if (!triggerEl) {
      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
    }

    if (!contentEl || contentEl.nodeName !== 'MD-MENU-CONTENT') {
      throw Error(INVALID_PREFIX + 'Expected the menu to contain a `md-menu-content` element.');
    }

    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');

    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
    if (nestedMenus) {
      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
        if (!menuEl.hasAttribute('md-position-mode')) {
          menuEl.setAttribute('md-position-mode', 'cascade');
        }
        menuEl.classList.add('_md-nested-menu');
        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
      });
    }
    return link;
  }

  function link(scope, element, attr, ctrls) {
    var mdMenuCtrl = ctrls[0];
    var isInMenuBar = !!ctrls[1];
    // Move everything into a md-menu-container and pass it to the controller
    var menuContainer = angular.element( '<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
    var menuContents = element.children()[1];

    element.addClass('_md');     // private md component indicator for styling

    if (!menuContents.hasAttribute('role')) {
      menuContents.setAttribute('role', 'menu');
    }
    menuContainer.append(menuContents);

    element.on('$destroy', function() {
      menuContainer.remove();
    });

    element.append(menuContainer);
    menuContainer[0].style.display = 'none';
    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });

  }
}

})();
(function(){
"use strict";


MenuProvider.$inject = ["$$interimElementProvider"];angular
  .module('material.components.menu')
  .provider('$mdMenu', MenuProvider);

/*
 * Interim element provider for the menu.
 * Handles behavior for a menu while it is open, including:
 *    - handling animating the menu opening/closing
 *    - handling key/mouse events on the menu element
 *    - handling enabling/disabling scroll while the menu is open
 *    - handling redrawing during resizes and orientation changes
 *
 */

function MenuProvider($$interimElementProvider) {
  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
  var MENU_EDGE_MARGIN = 8;

  return $$interimElementProvider('$mdMenu')
    .setDefaults({
      methods: ['target'],
      options: menuDefaultOptions
    });

  /* @ngInject */
  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
                              $animateCss, $animate, $log) {

    var prefixer = $mdUtil.prefixer();
    var animator = $mdUtil.dom.animator;

    return {
      parent: 'body',
      onShow: onShow,
      onRemove: onRemove,
      hasBackdrop: true,
      disableParentScroll: true,
      skipCompile: true,
      preserveScope: true,
      multiple: true,
      themable: true
    };

    /**
     * Show modal backdrop element...
     * @returns {function(): void} A function that removes this backdrop
     */
    function showBackdrop(scope, element, options) {
      if (options.nestLevel) return angular.noop;

      // If we are not within a dialog...
      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
        // !! DO this before creating the backdrop; since disableScrollAround()
        //    configures the scroll offset; which is used by mdBackDrop postLink()
        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
      } else {
        options.disableParentScroll = false;
      }

      if (options.hasBackdrop) {
        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");

        $animate.enter(options.backdrop, $document[0].body);
      }

      /**
       * Hide and destroys the backdrop created by showBackdrop()
       */
      return function hideBackdrop() {
        if (options.backdrop) options.backdrop.remove();
        if (options.disableParentScroll) options.restoreScroll();
      };
    }

    /**
     * Removing the menu element from the DOM and remove all associated event listeners
     * and backdrop
     */
    function onRemove(scope, element, opts) {
      opts.cleanupInteraction();
      opts.cleanupBackdrop();
      opts.cleanupResizing();
      opts.hideBackdrop();

      // Before the menu is closing remove the clickable class.
      element.removeClass('md-clickable');

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal

      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then( detachAndClean );

      /**
       * For normal closes, animate the removal.
       * For forced closes (like $destroy events), skip the animations
       */
      function animateRemoval() {
        return $animateCss(element, {addClass: 'md-leave'}).start();
      }

      /**
       * Detach the element
       */
      function detachAndClean() {
        element.removeClass('md-active');
        detachElement(element, opts);
        opts.alreadyOpen = false;
      }

    }

    /**
     * Inserts and configures the staged Menu element into the DOM, positioning it,
     * and wiring up various interaction events
     */
    function onShow(scope, element, opts) {
      sanitizeAndConfigure(opts);

      if (opts.menuContentEl[0]) {
        // Inherit the theme from the target element.
        $mdTheming.inherit(opts.menuContentEl, opts.target);
      } else {
        $log.warn(
          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
          'otherwise interactivity features will not work properly.',
          element
        );
      }
      
      // Register various listeners to move menu on resize/orientation change
      opts.cleanupResizing = startRepositioningOnResize();
      opts.hideBackdrop = showBackdrop(scope, element, opts);

      // Return the promise for when our menu is done animating in
      return showMenu()
        .then(function(response) {
          opts.alreadyOpen = true;
          opts.cleanupInteraction = activateInteraction();
          opts.cleanupBackdrop = setupBackdrop();

          // Since the menu finished its animation, mark the menu as clickable.
          element.addClass('md-clickable');

          return response;
        });

      /**
       * Place the menu into the DOM and call positioning related functions
       */
      function showMenu() {
        opts.parent.append(element);
        element[0].style.display = '';

        return $q(function(resolve) {
          var position = calculateMenuPosition(element, opts);

          element.removeClass('md-leave');

          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
          // to normal scale.
          $animateCss(element, {
            addClass: 'md-active',
            from: animator.toCss(position),
            to: animator.toCss({transform: ''})
          })
          .start()
          .then(resolve);

        });
      }

      /**
       * Check for valid opts and set some sane defaults
       */
      function sanitizeAndConfigure() {
        if (!opts.target) {
          throw Error(
            '$mdMenu.show() expected a target to animate from in options.target'
          );
        }
        angular.extend(opts, {
          alreadyOpen: false,
          isRemoved: false,
          target: angular.element(opts.target), //make sure it's not a naked dom node
          parent: angular.element(opts.parent),
          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
        });
      }

      /**
       * Configure various resize listeners for screen changes
       */
      function startRepositioningOnResize() {

        var repositionMenu = (function(target, options) {
          return $$rAF.throttle(function() {
            if (opts.isRemoved) return;
            var position = calculateMenuPosition(target, options);

            target.css(animator.toCss(position));
          });
        })(element, opts);

        $window.addEventListener('resize', repositionMenu);
        $window.addEventListener('orientationchange', repositionMenu);

        return function stopRepositioningOnResize() {

          // Disable resizing handlers
          $window.removeEventListener('resize', repositionMenu);
          $window.removeEventListener('orientationchange', repositionMenu);

        };
      }

      /**
       * Sets up the backdrop and listens for click elements.
       * Once the backdrop will be clicked, the menu will automatically close.
       * @returns {!Function} Function to remove the backdrop.
       */
      function setupBackdrop() {
        if (!opts.backdrop) return angular.noop;

        opts.backdrop.on('click', onBackdropClick);

        return function() {
          opts.backdrop.off('click', onBackdropClick);
        }
      }

      /**
       * Function to be called whenever the backdrop is clicked.
       * @param {!MouseEvent} event
       */
      function onBackdropClick(event) {
        event.preventDefault();
        event.stopPropagation();

        scope.$apply(function() {
          opts.mdMenuCtrl.close(true, { closeAll: true });
        });
      }

      /**
       * Activate interaction on the menu. Resolves the focus target and closes the menu on
       * escape or option click.
       * @returns {!Function} Function to deactivate the interaction listeners.
       */
      function activateInteraction() {
        if (!opts.menuContentEl[0]) return angular.noop;

        // Wire up keyboard listeners.
        // - Close on escape,
        // - focus next item on down arrow,
        // - focus prev item on up
        opts.menuContentEl.on('keydown', onMenuKeyDown);
        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);

        // kick off initial focus in the menu on the first enabled element
        var focusTarget = opts.menuContentEl[0]
          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));

        if ( !focusTarget ) {
          var childrenLen = opts.menuContentEl[0].children.length;
          for(var childIndex = 0; childIndex < childrenLen; childIndex++) {
            var child = opts.menuContentEl[0].children[childIndex];
            focusTarget = child.querySelector('.md-button:not([disabled])');
            if (focusTarget) {
              break;
            }
            if (child.firstElementChild && !child.firstElementChild.disabled) {
              focusTarget = child.firstElementChild;
              break;
            }
          }
        }

        focusTarget && focusTarget.focus();

        return function cleanupInteraction() {
          opts.menuContentEl.off('keydown', onMenuKeyDown);
          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
        };

        // ************************************
        // internal functions
        // ************************************

        function onMenuKeyDown(ev) {
          var handled;
          switch (ev.keyCode) {
            case $mdConstant.KEY_CODE.ESCAPE:
              opts.mdMenuCtrl.close(false, { closeAll: true });
              handled = true;
              break;
            case $mdConstant.KEY_CODE.UP_ARROW:
              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.DOWN_ARROW:
              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.LEFT_ARROW:
              if (opts.nestLevel) {
                opts.mdMenuCtrl.close();
              } else {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.RIGHT_ARROW:
              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
              if (parentMenu && parentMenu != opts.parent[0]) {
                ev.target.click();
              } else {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
          }
          if (handled) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
          }
        }

        function onBackdropClick(e) {
          e.preventDefault();
          e.stopPropagation();
          scope.$apply(function() {
            opts.mdMenuCtrl.close(true, { closeAll: true });
          });
        }

        // Close menu on menu item click, if said menu-item is not disabled
        function captureClickListener(e) {
          var target = e.target;
          // Traverse up the event until we get to the menuContentEl to see if
          // there is an ng-click and that the ng-click is not disabled
          do {
            if (target == opts.menuContentEl[0]) return;
            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
                close();
              }
              break;
            }
          } while (target = target.parentNode);

          function close() {
            scope.$apply(function() {
              opts.mdMenuCtrl.close(true, { closeAll: true });
            });
          }

          function hasAnyAttribute(target, attrs) {
            if (!target) return false;

            for (var i = 0, attr; attr = attrs[i]; ++i) {
              if (prefixer.hasAttribute(target, attr)) {
                return true;
              }
            }

            return false;
          }
        }

      }
    }

    /**
     * Takes a keypress event and focuses the next/previous menu
     * item from the emitting element
     * @param {event} e - The origin keypress event
     * @param {angular.element} menuEl - The menu element
     * @param {object} opts - The interim element options for the mdMenu
     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
     */
    function focusMenuItem(e, menuEl, opts, direction) {
      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');

      var items = $mdUtil.nodesToArray(menuEl[0].children);
      var currentIndex = items.indexOf(currentItem);

      // Traverse through our elements in the specified direction (+/-1) and try to
      // focus them until we find one that accepts focus
      var didFocus;
      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
        var focusTarget = items[i].querySelector('.md-button');
        didFocus = attemptFocus(focusTarget);
        if (didFocus) {
          break;
        }
      }
      return didFocus;
    }

    /**
     * Attempts to focus an element. Checks whether that element is the currently
     * focused element after attempting.
     * @param {HTMLElement} el - the element to attempt focus on
     * @returns {bool} - whether the element was successfully focused
     */
    function attemptFocus(el) {
      if (el && el.getAttribute('tabindex') != -1) {
        el.focus();
        return ($document[0].activeElement == el);
      }
    }

    /**
     * Use browser to remove this element without triggering a $destroy event
     */
    function detachElement(element, opts) {
      if (!opts.preserveElement) {
        if (toNode(element).parentNode === toNode(opts.parent)) {
          toNode(opts.parent).removeChild(toNode(element));
        }
      } else {
        toNode(element).style.display = 'none';
      }
    }

    /**
     * Computes menu position and sets the style on the menu container
     * @param {HTMLElement} el - the menu container element
     * @param {object} opts - the interim element options object
     */
    function calculateMenuPosition(el, opts) {

      var containerNode = el[0],
        openMenuNode = el[0].firstElementChild,
        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
        boundryNode = $document[0].body,
        boundryNodeRect = boundryNode.getBoundingClientRect();

      var menuStyle = $window.getComputedStyle(openMenuNode);

      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
        originNodeRect = originNode.getBoundingClientRect();

      var bounds = {
        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
        right: boundryNodeRect.right - MENU_EDGE_MARGIN
      };

      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
      var positionMode = opts.mdMenuCtrl.positionMode();

      if (positionMode.top == 'target' || positionMode.left == 'target' || positionMode.left == 'target-right') {
        alignTarget = firstVisibleChild();
        if ( alignTarget ) {
          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
          alignTarget = alignTarget.firstElementChild || alignTarget;
          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
          alignTargetRect = alignTarget.getBoundingClientRect();

          existingOffsets = {
            top: parseFloat(containerNode.style.top || 0),
            left: parseFloat(containerNode.style.left || 0)
          };
        }
      }

      var position = {};
      var transformOrigin = 'top ';

      switch (positionMode.top) {
        case 'target':
          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
          break;
        case 'cascade':
          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
          break;
        case 'bottom':
          position.top = originNodeRect.top + originNodeRect.height;
          break;
        default:
          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
      }

      var rtl = ($mdUtil.bidi() == 'rtl');

      switch (positionMode.left) {
        case 'target':
          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
          transformOrigin += rtl ? 'right'  : 'left';
          break;
        case 'target-left':
          position.left = originNodeRect.left;
          transformOrigin += 'left';
          break;
        case 'target-right':
          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
          transformOrigin += 'right';
          break;
        case 'cascade':
          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
          transformOrigin += willFitRight ? 'left' : 'right';
          break;
        case 'right':
          if (rtl) {
            position.left = originNodeRect.right - originNodeRect.width;
            transformOrigin += 'left';
          } else {
            position.left = originNodeRect.right - openMenuNodeRect.width;
            transformOrigin += 'right';
          }
          break;
        case 'left':
          if (rtl) {
            position.left = originNodeRect.right - openMenuNodeRect.width;
            transformOrigin += 'right';
          } else {
            position.left = originNodeRect.left;
            transformOrigin += 'left';
          }
          break;
        default:
          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
      }

      var offsets = opts.mdMenuCtrl.offsets();
      position.top += offsets.top;
      position.left += offsets.left;

      clamp(position);

      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;

      return {
        top: Math.round(position.top),
        left: Math.round(position.left),
        // Animate a scale out if we aren't just repositioning
        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
        transformOrigin: transformOrigin
      };

      /**
       * Clamps the repositioning of the menu within the confines of
       * bounding element (often the screen/body)
       */
      function clamp(pos) {
        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
      }

      /**
       * Gets the first visible child in the openMenuNode
       * Necessary incase menu nodes are being dynamically hidden
       */
      function firstVisibleChild() {
        for (var i = 0; i < openMenuNode.children.length; ++i) {
          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
            return openMenuNode.children[i];
          }
        }
      }
    }
  }
  function toNode(el) {
    if (el instanceof angular.element) {
      el = el[0];
    }
    return el;
  }
}

})();
(function(){
"use strict";


MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
angular
  .module('material.components.menuBar')
  .controller('MenuBarController', MenuBarController);

var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];

/**
 * @ngInject
 */
function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
  this.$element = $element;
  this.$attrs = $attrs;
  this.$mdConstant = $mdConstant;
  this.$mdUtil = $mdUtil;
  this.$document = $document;
  this.$scope = $scope;
  this.$rootScope = $rootScope;
  this.$timeout = $timeout;

  var self = this;
  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
    self[methodName] = angular.bind(self, self[methodName]);
  });
}

MenuBarController.prototype.init = function() {
  var $element = this.$element;
  var $mdUtil = this.$mdUtil;
  var $scope = this.$scope;

  var self = this;
  var deregisterFns = [];
  $element.on('keydown', this.handleKeyDown);
  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');

  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
    if (self.getMenus().indexOf(el[0]) != -1) {
      $element[0].classList.add('md-open');
      el[0].classList.add('md-open');
      self.currentlyOpenMenu = el.controller('mdMenu');
      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
      self.enableOpenOnHover();
    }
  }));

  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
    var rootMenus = self.getMenus();
    if (rootMenus.indexOf(el[0]) != -1) {
      $element[0].classList.remove('md-open');
      el[0].classList.remove('md-open');
    }

    if ($element[0].contains(el[0])) {
      var parentMenu = el[0];
      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
      }
      if (parentMenu) {
        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
        self.currentlyOpenMenu = undefined;
        self.disableOpenOnHover();
        self.setKeyboardMode(true);
      }
    }
  }));

  $scope.$on('$destroy', function() {
    self.disableOpenOnHover();
    while (deregisterFns.length) {
      deregisterFns.shift()();
    }
  });


  this.setKeyboardMode(true);
};

MenuBarController.prototype.setKeyboardMode = function(enabled) {
  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
  else this.$element[0].classList.remove('md-keyboard-mode');
};

MenuBarController.prototype.enableOpenOnHover = function() {
  if (this.openOnHoverEnabled) return;

  var self = this;

  self.openOnHoverEnabled = true;

  if (self.parentToolbar) {
    self.parentToolbar.classList.add('md-has-open-menu');

    // Needs to be on the next tick so it doesn't close immediately.
    self.$mdUtil.nextTick(function() {
      angular.element(self.parentToolbar).on('click', self.handleParentClick);
    }, false);
  }

  angular
    .element(self.getMenus())
    .on('mouseenter', self.handleMenuHover);
};

MenuBarController.prototype.handleMenuHover = function(e) {
  this.setKeyboardMode(false);
  if (this.openOnHoverEnabled) {
    this.scheduleOpenHoveredMenu(e);
  }
};

MenuBarController.prototype.disableOpenOnHover = function() {
  if (!this.openOnHoverEnabled) return;

  this.openOnHoverEnabled = false;

  if (this.parentToolbar) {
    this.parentToolbar.classList.remove('md-has-open-menu');
    angular.element(this.parentToolbar).off('click', this.handleParentClick);
  }

  angular
    .element(this.getMenus())
    .off('mouseenter', this.handleMenuHover);
};

MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
  var menuEl = angular.element(e.currentTarget);
  var menuCtrl = menuEl.controller('mdMenu');
  this.setKeyboardMode(false);
  this.scheduleOpenMenu(menuCtrl);
};

MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
  var self = this;
  var $timeout = this.$timeout;
  if (menuCtrl != self.currentlyOpenMenu) {
    $timeout.cancel(self.pendingMenuOpen);
    self.pendingMenuOpen = $timeout(function() {
      self.pendingMenuOpen = undefined;
      if (self.currentlyOpenMenu) {
        self.currentlyOpenMenu.close(true, { closeAll: true });
      }
      menuCtrl.open();
    }, 200, false);
  }
};

MenuBarController.prototype.handleKeyDown = function(e) {
  var keyCodes = this.$mdConstant.KEY_CODE;
  var currentMenu = this.currentlyOpenMenu;
  var wasOpen = currentMenu && currentMenu.isOpen;
  this.setKeyboardMode(true);
  var handled, newMenu, newMenuCtrl;
  switch (e.keyCode) {
    case keyCodes.DOWN_ARROW:
      if (currentMenu) {
        currentMenu.focusMenuContainer();
      } else {
        this.openFocusedMenu();
      }
      handled = true;
      break;
    case keyCodes.UP_ARROW:
      currentMenu && currentMenu.close();
      handled = true;
      break;
    case keyCodes.LEFT_ARROW:
      newMenu = this.focusMenu(-1);
      if (wasOpen) {
        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
        this.scheduleOpenMenu(newMenuCtrl);
      }
      handled = true;
      break;
    case keyCodes.RIGHT_ARROW:
      newMenu = this.focusMenu(+1);
      if (wasOpen) {
        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
        this.scheduleOpenMenu(newMenuCtrl);
      }
      handled = true;
      break;
  }
  if (handled) {
    e && e.preventDefault && e.preventDefault();
    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
  }
};

MenuBarController.prototype.focusMenu = function(direction) {
  var menus = this.getMenus();
  var focusedIndex = this.getFocusedMenuIndex();

  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }

  var changed = false;

  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
  else if (
    direction < 0 && focusedIndex > 0 ||
    direction > 0 && focusedIndex < menus.length - direction
  ) {
    focusedIndex += direction;
    changed = true;
  }
  if (changed) {
    menus[focusedIndex].querySelector('button').focus();
    return menus[focusedIndex];
  }
};

MenuBarController.prototype.openFocusedMenu = function() {
  var menu = this.getFocusedMenu();
  menu && angular.element(menu).controller('mdMenu').open();
};

MenuBarController.prototype.getMenus = function() {
  var $element = this.$element;
  return this.$mdUtil.nodesToArray($element[0].children)
    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
};

MenuBarController.prototype.getFocusedMenu = function() {
  return this.getMenus()[this.getFocusedMenuIndex()];
};

MenuBarController.prototype.getFocusedMenuIndex = function() {
  var $mdUtil = this.$mdUtil;
  var focusedEl = $mdUtil.getClosest(
    this.$document[0].activeElement,
    'MD-MENU'
  );
  if (!focusedEl) return -1;

  var focusedIndex = this.getMenus().indexOf(focusedEl);
  return focusedIndex;
};

MenuBarController.prototype.getOpenMenuIndex = function() {
  var menus = this.getMenus();
  for (var i = 0; i < menus.length; ++i) {
    if (menus[i].classList.contains('md-open')) return i;
  }
  return -1;
};

MenuBarController.prototype.handleParentClick = function(event) {
  var openMenu = this.querySelector('md-menu.md-open');

  if (openMenu && !openMenu.contains(event.target)) {
    angular.element(openMenu).controller('mdMenu').close(true, {
      closeAll: true
    });
  }
};

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdMenuBar
 * @module material.components.menuBar
 * @restrict E
 * @description
 *
 * Menu bars are containers that hold multiple menus. They change the behavior and appearence
 * of the `md-menu` directive to behave similar to an operating system provided menu.
 *
 * @usage
 * <hljs lang="html">
 * <md-menu-bar>
 *   <md-menu>
 *     <button ng-click="$mdMenu.open()">
 *       File
 *     </button>
 *     <md-menu-content>
 *       <md-menu-item>
 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
 *           Share...
 *         </md-button>
 *       </md-menu-item>
 *       <md-menu-divider></md-menu-divider>
 *       <md-menu-item>
 *       <md-menu-item>
 *         <md-menu>
 *           <md-button ng-click="$mdMenu.open()">New</md-button>
 *           <md-menu-content>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
 *           </md-menu-content>
 *         </md-menu>
 *       </md-menu-item>
 *     </md-menu-content>
 *   </md-menu>
 * </md-menu-bar>
 * </hljs>
 *
 * ## Menu Bar Controls
 *
 * You may place `md-menu-items` that function as controls within menu bars.
 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
 * to the `string` value of the `value` attribute. If you need non-string values, you can use
 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
 *
 * <hljs lang="html">
 * <md-menu-bar>
 *  <md-menu>
 *    <button ng-click="$mdMenu.open()">
 *      Sample Menu
 *    </button>
 *    <md-menu-content>
 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
 *      <md-menu-divider></md-menu-divider>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
 *    </md-menu-content>
 *  </md-menu>
 * </md-menu-bar>
 * </hljs>
 *
 *
 * ### Nesting Menus
 *
 * Menus may be nested within menu bars. This is commonly called cascading menus.
 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
 * <hljs lang="html">
 * <md-menu-item>
 *   <md-menu>
 *     <button ng-click="$mdMenu.open()">New</md-button>
 *     <md-menu-content>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
 *     </md-menu-content>
 *   </md-menu>
 * </md-menu-item>
 * </hljs>
 *
 */

MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
angular
  .module('material.components.menuBar')
  .directive('mdMenuBar', MenuBarDirective);

/* @ngInject */
function MenuBarDirective($mdUtil, $mdTheming) {
  return {
    restrict: 'E',
    require: 'mdMenuBar',
    controller: 'MenuBarController',

    compile: function compile(templateEl, templateAttrs) {
      if (!templateAttrs.ariaRole) {
        templateEl[0].setAttribute('role', 'menubar');
      }
      angular.forEach(templateEl[0].children, function(menuEl) {
        if (menuEl.nodeName == 'MD-MENU') {
          if (!menuEl.hasAttribute('md-position-mode')) {
            menuEl.setAttribute('md-position-mode', 'left bottom');

            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
            // we need to query for possible `md-buttons` as well.
            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
          }
          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
          angular.forEach(contentEls, function(contentEl) {
            contentEl.classList.add('md-menu-bar-menu');
            contentEl.classList.add('md-dense');
            if (!contentEl.hasAttribute('width')) {
              contentEl.setAttribute('width', 5);
            }
          });
        }
      });

      // Mark the child menu items that they're inside a menu bar. This is necessary,
      // because mnMenuItem has special behaviour during compilation, depending on
      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
      // the element won't have a parent and won't compile properly.
      templateEl.find('md-menu-item').addClass('md-in-menu-bar');

      return function postLink(scope, el, attr, ctrl) {
        el.addClass('_md');     // private md component indicator for styling
        $mdTheming(scope, el);
        ctrl.init();
      };
    }
  };

}

})();
(function(){
"use strict";


angular
  .module('material.components.menuBar')
  .directive('mdMenuDivider', MenuDividerDirective);


function MenuDividerDirective() {
  return {
    restrict: 'E',
    compile: function(templateEl, templateAttrs) {
      if (!templateAttrs.role) {
        templateEl[0].setAttribute('role', 'separator');
      }
    }
  };
}

})();
(function(){
"use strict";


MenuItemController.$inject = ["$scope", "$element", "$attrs"];
angular
  .module('material.components.menuBar')
  .controller('MenuItemController', MenuItemController);


/**
 * @ngInject
 */
function MenuItemController($scope, $element, $attrs) {
  this.$element = $element;
  this.$attrs = $attrs;
  this.$scope = $scope;
}

MenuItemController.prototype.init = function(ngModel) {
  var $element = this.$element;
  var $attrs = this.$attrs;

  this.ngModel = ngModel;
  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
    this.mode  = $attrs.type;
    this.iconEl = $element[0].children[0];
    this.buttonEl = $element[0].children[1];
    if (ngModel) {
      // Clear ngAria set attributes
      this.initClickListeners();
    }
  }
};

// ngAria auto sets attributes on a menu-item with a ngModel.
// We don't want this because our content (buttons) get the focus
// and set their own aria attributes appropritately. Having both
// breaks NVDA / JAWS. This undeoes ngAria's attrs.
MenuItemController.prototype.clearNgAria = function() {
  var el = this.$element[0];
  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
  angular.forEach(clearAttrs, function(attr) {
    el.removeAttribute(attr);
  });
};

MenuItemController.prototype.initClickListeners = function() {
  var self = this;
  var ngModel = this.ngModel;
  var $scope = this.$scope;
  var $attrs = this.$attrs;
  var $element = this.$element;
  var mode = this.mode;

  this.handleClick = angular.bind(this, this.handleClick);

  var icon = this.iconEl;
  var button = angular.element(this.buttonEl);
  var handleClick = this.handleClick;

  $attrs.$observe('disabled', setDisabled);
  setDisabled($attrs.disabled);

  ngModel.$render = function render() {
    self.clearNgAria();
    if (isSelected()) {
      icon.style.display = '';
      button.attr('aria-checked', 'true');
    } else {
      icon.style.display = 'none';
      button.attr('aria-checked', 'false');
    }
  };

  $scope.$$postDigest(ngModel.$render);

  function isSelected() {
    if (mode == 'radio') {
      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
      return ngModel.$modelValue == val;
    } else {
      return ngModel.$modelValue;
    }
  }

  function setDisabled(disabled) {
    if (disabled) {
      button.off('click', handleClick);
    } else {
      button.on('click', handleClick);
    }
  }
};

MenuItemController.prototype.handleClick = function(e) {
  var mode = this.mode;
  var ngModel = this.ngModel;
  var $attrs = this.$attrs;
  var newVal;
  if (mode == 'checkbox') {
    newVal = !ngModel.$modelValue;
  } else if (mode == 'radio') {
    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
  }
  ngModel.$setViewValue(newVal);
  ngModel.$render();
};

})();
(function(){
"use strict";


MenuItemDirective.$inject = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
angular
  .module('material.components.menuBar')
  .directive('mdMenuItem', MenuItemDirective);

 /* @ngInject */
function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
  return {
    controller: 'MenuItemController',
    require: ['mdMenuItem', '?ngModel'],
    priority: $mdConstant.BEFORE_NG_ARIA,
    compile: function(templateEl, templateAttrs) {
      var type = templateAttrs.type;
      var inMenuBarClass = 'md-in-menu-bar';

      // Note: This allows us to show the `check` icon for the md-menu-bar items.
      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
      if ((type == 'checkbox' || type == 'radio') && templateEl.hasClass(inMenuBarClass)) {
        var text = templateEl[0].textContent;
        var buttonEl = angular.element('<md-button type="button"></md-button>');
        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';

        buttonEl.html(text);
        buttonEl.attr('tabindex', '0');

        templateEl.html('');
        templateEl.append(angular.element(iconTemplate));
        templateEl.append(buttonEl);
        templateEl.addClass('md-indent').removeClass(inMenuBarClass);

        setDefault('role', type == 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
        moveAttrToButton('ng-disabled');

      } else {
        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
      }


      return function(scope, el, attrs, ctrls) {
        var ctrl = ctrls[0];
        var ngModel = ctrls[1];
        ctrl.init(ngModel);
      };

      function setDefault(attr, val, el) {
        el = el || templateEl;
        if (el instanceof angular.element) {
          el = el[0];
        }
        if (!el.hasAttribute(attr)) {
          el.setAttribute(attr, val);
        }
      }

      function moveAttrToButton(attribute) {
        var attributes = $mdUtil.prefixer(attribute);

        angular.forEach(attributes, function(attr) {
          if (templateEl[0].hasAttribute(attr)) {
            var val = templateEl[0].getAttribute(attr);
            buttonEl[0].setAttribute(attr, val);
            templateEl[0].removeAttribute(attr);
          }
        });
      }
    }
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdProgressCircular
 * @module material.components.progressCircular
 * @restrict E
 *
 * @description
 * The circular progress directive is used to make loading content in your app as delightful and
 * painless as possible by minimizing the amount of visual change a user sees before they can view
 * and interact with content.
 *
 * For operations where the percentage of the operation completed can be determined, use a
 * determinate indicator. They give users a quick sense of how long an operation will take.
 *
 * For operations where the user is asked to wait a moment while something finishes up, and it’s
 * not necessary to expose what's happening behind the scenes and how long it will take, use an
 * indeterminate indicator.
 *
 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
 *
 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
 * will be auto-applied as the mode.
 *
 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
 * @param {number=} value In determinate mode, this number represents the percentage of the
 *     circular progress. Default: 0
 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
 * should be a pixel-size value (eg '100'). If this attribute is
 * not present then a default value of '50px' is assumed.
 *
 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
 *
 * @usage
 * <hljs lang="html">
 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
 *
 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
 *
 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
 *
 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
 * </hljs>
 */

MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
angular
  .module('material.components.progressCircular')
  .directive('mdProgressCircular', MdProgressCircularDirective);

/* @ngInject */
function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
                                     $mdUtil, $interval, $log) {

  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
  // in any tests that call $animate.flush.
  var rAF = $window.requestAnimationFrame ||
            $window.webkitRequestAnimationFrame ||
            angular.noop;

  var cAF = $window.cancelAnimationFrame ||
            $window.webkitCancelAnimationFrame ||
            $window.webkitCancelRequestAnimationFrame ||
            angular.noop;

  var MODE_DETERMINATE = 'determinate';
  var MODE_INDETERMINATE = 'indeterminate';
  var DISABLED_CLASS = '_md-progress-circular-disabled';
  var INDETERMINATE_CLASS = 'md-mode-indeterminate';

  return {
    restrict: 'E',
    scope: {
      value: '@',
      mdDiameter: '@',
      mdMode: '@'
    },
    template:
      '<svg xmlns="http://www.w3.org/2000/svg">' +
        '<path fill="none"/>' +
      '</svg>',
    compile: function(element, attrs) {
      element.attr({
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'role': 'progressbar'
      });

      if (angular.isUndefined(attrs.mdMode)) {
        var mode = attrs.hasOwnProperty('value') ? MODE_DETERMINATE : MODE_INDETERMINATE;
        attrs.$set('mdMode', mode);
      } else {
        attrs.$set('mdMode', attrs.mdMode.trim());
      }

      return MdProgressCircularLink;
    }
  };

  function MdProgressCircularLink(scope, element, attrs) {
    var node = element[0];
    var svg = angular.element(node.querySelector('svg'));
    var path = angular.element(node.querySelector('path'));
    var startIndeterminate = $mdProgressCircular.startIndeterminate;
    var endIndeterminate = $mdProgressCircular.endIndeterminate;
    var iterationCount = 0;
    var lastAnimationId = 0;
    var lastDrawFrame;
    var interval;

    $mdTheming(element);
    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));

    // If the mode is indeterminate, it doesn't need to
    // wait for the next digest. It can start right away.
    if(scope.mdMode === MODE_INDETERMINATE){
      startIndeterminateAnimation();
    }

    scope.$on('$destroy', function(){
      cleanupIndeterminateAnimation();

      if (lastDrawFrame) {
        cAF(lastDrawFrame);
      }
    });

    scope.$watchGroup(['value', 'mdMode', function() {
      var isDisabled = node.disabled;

      // Sometimes the browser doesn't return a boolean, in
      // which case we should check whether the attribute is
      // present.
      if (isDisabled === true || isDisabled === false){
        return isDisabled;
      }

      return angular.isDefined(element.attr('disabled'));
    }], function(newValues, oldValues) {
      var mode = newValues[1];
      var isDisabled = newValues[2];
      var wasDisabled = oldValues[2];

      if (isDisabled !== wasDisabled) {
        element.toggleClass(DISABLED_CLASS, !!isDisabled);
      }

      if (isDisabled) {
        cleanupIndeterminateAnimation();
      } else {
        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
          mode = MODE_INDETERMINATE;
          attrs.$set('mdMode', mode);
        }

        if (mode === MODE_INDETERMINATE) {
          startIndeterminateAnimation();
        } else {
          var newValue = clamp(newValues[0]);

          cleanupIndeterminateAnimation();

          element.attr('aria-valuenow', newValue);
          renderCircle(clamp(oldValues[0]), newValue);
        }
      }

    });

    // This is in a separate watch in order to avoid layout, unless
    // the value has actually changed.
    scope.$watch('mdDiameter', function(newValue) {
      var diameter = getSize(newValue);
      var strokeWidth = getStroke(diameter);
      var value = clamp(scope.value);
      var transformOrigin = (diameter / 2) + 'px';
      var dimensions = {
        width: diameter + 'px',
        height: diameter + 'px'
      };

      // The viewBox has to be applied via setAttribute, because it is
      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
      // all attribute names.
      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);

      // Usually viewBox sets the dimensions for the SVG, however that doesn't
      // seem to be the case on IE10.
      // Important! The transform origin has to be set from here and it has to
      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
      // IE and Edge, because they don't account for the stroke width when
      // rotating. Also "center" doesn't help in this case, it has to be a
      // precise value.
      svg
        .css(dimensions)
        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);

      element.css(dimensions);

      path.attr('stroke-width', strokeWidth);
      path.attr('stroke-linecap', 'square');
      if (scope.mdMode == MODE_INDETERMINATE) {
        path.attr('d', getSvgArc(diameter, strokeWidth, true));
        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI * 0.75);
        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 1, 75));
      } else {
        path.attr('d', getSvgArc(diameter, strokeWidth, false));
        path.attr('stroke-dasharray', (diameter - strokeWidth) * $window.Math.PI);
        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, 0, 100));
        renderCircle(value, value);
      }

    });

    function renderCircle(animateFrom, animateTo, easing, duration, iterationCount, maxValue) {
      var id = ++lastAnimationId;
      var startTime = $mdUtil.now();
      var changeInValue = animateTo - animateFrom;
      var diameter = getSize(scope.mdDiameter);
      var strokeWidth = getStroke(diameter);
      var ease = easing || $mdProgressCircular.easeFn;
      var animationDuration = duration || $mdProgressCircular.duration;
      var rotation = -90 * (iterationCount || 0);
      var dashLimit = maxValue || 100;

      // No need to animate it if the values are the same
      if (animateTo === animateFrom) {
        renderFrame(animateTo);
      } else {
        lastDrawFrame = rAF(function animation() {
          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));

          renderFrame(ease(currentTime, animateFrom, changeInValue, animationDuration));

          // Do not allow overlapping animations
          if (id === lastAnimationId && currentTime < animationDuration) {
            lastDrawFrame = rAF(animation);
          }
        });
      }

      function renderFrame(value) {
        path.attr('stroke-dashoffset', getDashLength(diameter, strokeWidth, value, dashLimit));
        path.attr('transform','rotate(' + (rotation) + ' ' + diameter/2 + ' ' + diameter/2 + ')');
      }
    }

    function animateIndeterminate() {
      renderCircle(
        startIndeterminate,
        endIndeterminate,
        $mdProgressCircular.easeFnIndeterminate,
        $mdProgressCircular.durationIndeterminate,
        iterationCount,
        75
      );

      // The %4 technically isn't necessary, but it keeps the rotation
      // under 360, instead of becoming a crazy large number.
      iterationCount = ++iterationCount % 4;

    }

    function startIndeterminateAnimation() {
      if (!interval) {
        // Note that this interval isn't supposed to trigger a digest.
        interval = $interval(
          animateIndeterminate,
          $mdProgressCircular.durationIndeterminate,
          0,
          false
        );

        animateIndeterminate();

        element
          .addClass(INDETERMINATE_CLASS)
          .removeAttr('aria-valuenow');
      }
    }

    function cleanupIndeterminateAnimation() {
      if (interval) {
        $interval.cancel(interval);
        interval = null;
        element.removeClass(INDETERMINATE_CLASS);
      }
    }
  }

  /**
   * Returns SVG path data for progress circle
   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
   *
   * @param {number} diameter Diameter of the container.
   * @param {number} strokeWidth Stroke width to be used when drawing circle
   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
   *
   * @returns {string} String representation of an SVG arc.
   */
  function getSvgArc(diameter, strokeWidth, indeterminate) {
    var radius = diameter / 2;
    var offset = strokeWidth / 2;
    var start = radius + ',' + offset; // ie: (25, 2.5) or 12 o'clock
    var end = offset + ',' + radius;   // ie: (2.5, 25) or  9 o'clock
    var arcRadius = radius - offset;
    return 'M' + start
         + 'A' + arcRadius + ',' + arcRadius + ' 0 1 1 ' + end // 75% circle
         + (indeterminate ? '' : 'A' + arcRadius + ',' + arcRadius + ' 0 0 1 ' + start); // loop to start
  }

  /**
   * Return stroke length for progress circle
   *
   * @param {number} diameter Diameter of the container.
   * @param {number} strokeWidth Stroke width to be used when drawing circle
   * @param {number} value Percentage of circle (between 0 and 100)
   * @param {number} limit Max percentage for circle
   *
   * @returns {number} Stroke length for progres circle
   */
  function getDashLength(diameter, strokeWidth, value, limit) {
    return (diameter - strokeWidth) * $window.Math.PI * ( (3 * (limit || 100) / 100) - (value/100) );
  }

  /**
   * Limits a value between 0 and 100.
   */
  function clamp(value) {
    return $window.Math.max(0, $window.Math.min(value || 0, 100));
  }

  /**
   * Determines the size of a progress circle, based on the provided
   * value in the following formats: `X`, `Ypx`, `Z%`.
   */
  function getSize(value) {
    var defaultValue = $mdProgressCircular.progressSize;

    if (value) {
      var parsed = parseFloat(value);

      if (value.lastIndexOf('%') === value.length - 1) {
        parsed = (parsed / 100) * defaultValue;
      }

      return parsed;
    }

    return defaultValue;
  }

  /**
   * Determines the circle's stroke width, based on
   * the provided diameter.
   */
  function getStroke(diameter) {
    return $mdProgressCircular.strokeWidth / 100 * diameter;
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc service
 * @name $mdProgressCircular
 * @module material.components.progressCircular
 *
 * @description
 * Allows the user to specify the default options for the `progressCircular` directive.
 *
 * @property {number} progressSize Diameter of the progress circle in pixels.
 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
 * @property {number} duration Length of the circle animation in milliseconds.
 * @property {function} easeFn Default easing animation function.
 * @property {object} easingPresets Collection of pre-defined easing functions.
 *
 * @property {number} durationIndeterminate Duration of the indeterminate animation.
 * @property {number} startIndeterminate Indeterminate animation start point.
 * @property {number} endIndeterminate Indeterminate animation end point.
 * @property {function} easeFnIndeterminate Easing function to be used when animating
 * between the indeterminate values.
 *
 * @property {(function(object): object)} configure Used to modify the default options.
 *
 * @usage
 * <hljs lang="js">
 *   myAppModule.config(function($mdProgressCircularProvider) {
 *
 *     // Example of changing the default progress options.
 *     $mdProgressCircularProvider.configure({
 *       progressSize: 100,
 *       strokeWidth: 20,
 *       duration: 800
 *     });
 * });
 * </hljs>
 *
 */

angular
  .module('material.components.progressCircular')
  .provider("$mdProgressCircular", MdProgressCircularProvider);

function MdProgressCircularProvider() {
  var progressConfig = {
    progressSize: 50,
    strokeWidth: 10,
    duration: 100,
    easeFn: linearEase,

    durationIndeterminate: 1333,
    startIndeterminate: 1,
    endIndeterminate: 149,
    easeFnIndeterminate: materialEase,

    easingPresets: {
      linearEase: linearEase,
      materialEase: materialEase
    }
  };

  return {
    configure: function(options) {
      progressConfig = angular.extend(progressConfig, options || {});
      return progressConfig;
    },
    $get: function() { return progressConfig; }
  };

  function linearEase(t, b, c, d) {
    return c * t / d + b;
  }

  function materialEase(t, b, c, d) {
    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
    // with settings of [0, 0, 1, 1]
    var ts = (t /= d) * t;
    var tc = ts * t;
    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdTab
 * @module material.components.tabs
 *
 * @restrict E
 *
 * @description
 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
 *
 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
 * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
 * markup of the `<md-tab>` is used as the tab header markup.
 *
 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
 * is to define a clear separation between the tab content and the tab label.
 *
 * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
 * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
 * be initiated via data binding changes, programmatic invocation, or user gestures.
 *
 * @param {string=} label Optional attribute to specify a simple string as the tab label
 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
 *
 *
 * @usage
 *
 * <hljs lang="html">
 * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
 *   <h3>My Tab content</h3>
 * </md-tab>
 *
 * <md-tab >
 *   <md-tab-label>
 *     <h3>My Tab content</h3>
 *   </md-tab-label>
 *   <md-tab-body>
 *     <p>
 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
 *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
 *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
 *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
 *     </p>
 *   </md-tab-body>
 * </md-tab>
 * </hljs>
 *
 */
angular
    .module('material.components.tabs')
    .directive('mdTab', MdTab);

function MdTab () {
  return {
    require:  '^?mdTabs',
    terminal: true,
    compile:  function (element, attr) {
      var label = firstChild(element, 'md-tab-label'),
          body  = firstChild(element, 'md-tab-body');

      if (label.length === 0) {
        label = angular.element('<md-tab-label></md-tab-label>');
        if (attr.label) label.text(attr.label);
        else label.append(element.contents());

        if (body.length === 0) {
          var contents = element.contents().detach();
          body         = angular.element('<md-tab-body></md-tab-body>');
          body.append(contents);
        }
      }

      element.append(label);
      if (body.html()) element.append(body);

      return postLink;
    },
    scope:    {
      active:   '=?mdActive',
      disabled: '=?ngDisabled',
      select:   '&?mdOnSelect',
      deselect: '&?mdOnDeselect'
    }
  };

  function postLink (scope, element, attr, ctrl) {
    if (!ctrl) return;
    var index = ctrl.getTabElementIndex(element),
        body  = firstChild(element, 'md-tab-body').remove(),
        label = firstChild(element, 'md-tab-label').remove(),
        data  = ctrl.insertTab({
          scope:    scope,
          parent:   scope.$parent,
          index:    index,
          element:  element,
          template: body.html(),
          label:    label.html()
        }, index);

    scope.select   = scope.select || angular.noop;
    scope.deselect = scope.deselect || angular.noop;

    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
    scope.$watch(
        function () {
          return ctrl.getTabElementIndex(element);
        },
        function (newIndex) {
          data.index = newIndex;
          ctrl.updateTabOrder();
        }
    );
    scope.$on('$destroy', function () { ctrl.removeTab(data); });
  }

  function firstChild (element, tagName) {
    var children = element[0].children;
    for (var i = 0, len = children.length; i < len; i++) {
      var child = children[i];
      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
    }
    return angular.element();
  }
}

})();
(function(){
"use strict";

angular
    .module('material.components.tabs')
    .directive('mdTabItem', MdTabItem);

function MdTabItem () {
  return {
    require: '^?mdTabs',
    link:    function link (scope, element, attr, ctrl) {
      if (!ctrl) return;
      ctrl.attachRipple(scope, element);
    }
  };
}

})();
(function(){
"use strict";

angular
    .module('material.components.tabs')
    .directive('mdTabLabel', MdTabLabel);

function MdTabLabel () {
  return { terminal: true };
}


})();
(function(){
"use strict";


MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
    .directive('mdTabScroll', MdTabScroll);

function MdTabScroll ($parse) {
  return {
    restrict: 'A',
    compile: function ($element, attr) {
      var fn = $parse(attr.mdTabScroll, null, true);
      return function ngEventHandler (scope, element) {
        element.on('mousewheel', function (event) {
          scope.$apply(function () { fn(scope, { $event: event }); });
        });
      };
    }
  };
}

})();
(function(){
"use strict";


MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction", "MdTabsPaginationService"];angular
    .module('material.components.tabs')
    .controller('MdTabsController', MdTabsController);

/**
 * @ngInject
 */
function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction,
                           MdTabsPaginationService) {
  // define private properties
  var ctrl      = this,
      locked    = false,
      elements  = getElements(),
      queue     = [],
      destroyed = false,
      loaded    = false;


  // Define public methods
  ctrl.$onInit            = $onInit;
  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
  ctrl.redirectFocus      = redirectFocus;
  ctrl.attachRipple       = attachRipple;
  ctrl.insertTab          = insertTab;
  ctrl.removeTab          = removeTab;
  ctrl.select             = select;
  ctrl.scroll             = scroll;
  ctrl.nextPage           = nextPage;
  ctrl.previousPage       = previousPage;
  ctrl.keydown            = keydown;
  ctrl.canPageForward     = canPageForward;
  ctrl.canPageBack        = canPageBack;
  ctrl.refreshIndex       = refreshIndex;
  ctrl.incrementIndex     = incrementIndex;
  ctrl.getTabElementIndex = getTabElementIndex;
  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
  ctrl.getFocusedTabId    = getFocusedTabId;

  // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
  // manually call the $onInit hook.
  if (angular.version.major === 1 && angular.version.minor <= 4) {
    this.$onInit();
  }

  /**
   * AngularJS Lifecycle hook for newer AngularJS versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
   */
  function $onInit() {
    // Define one-way bindings
    defineOneWayBinding('stretchTabs', handleStretchTabs);

    // Define public properties with change handlers
    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
    defineProperty('offsetLeft', handleOffsetChange, 0);
    defineProperty('hasContent', handleHasContent, false);
    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
    defineProperty('shouldPaginate', handleShouldPaginate, false);

    // Define boolean attributes
    defineBooleanAttribute('noInkBar', handleInkBar);
    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
    defineBooleanAttribute('noPagination');
    defineBooleanAttribute('swipeContent');
    defineBooleanAttribute('noDisconnect');
    defineBooleanAttribute('autoselect');
    defineBooleanAttribute('noSelectClick');
    defineBooleanAttribute('centerTabs', handleCenterTabs, false);
    defineBooleanAttribute('enableDisconnect');

    // Define public properties
    ctrl.scope             = $scope;
    ctrl.parent            = $scope.$parent;
    ctrl.tabs              = [];
    ctrl.lastSelectedIndex = null;
    ctrl.hasFocus          = false;
    ctrl.styleTabItemFocus = false;
    ctrl.shouldCenterTabs  = shouldCenterTabs();
    ctrl.tabContentPrefix  = 'tab-content-';

    // Setup the tabs controller after all bindings are available.
    setupTabsController();
  }

  /**
   * Perform setup for the controller, setup events and watcher(s)
   */
  function setupTabsController () {
    ctrl.selectedIndex = ctrl.selectedIndex || 0;
    compileTemplate();
    configureWatchers();
    bindEvents();
    $mdTheming($element);
    $mdUtil.nextTick(function () {
      // Note that the element references need to be updated, because certain "browsers"
      // (IE/Edge) lose them and start throwing "Invalid calling object" errors, when we
      // compile the element contents down in `compileElement`.
      elements = getElements();
      updateHeightFromContent();
      adjustOffset();
      updateInkBarStyles();
      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
      loaded = true;
      updatePagination();
    });
  }

  /**
   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
   * directive's template function.
   */
  function compileTemplate () {
    var template = $attrs.$mdTabsTemplate,
        element  = angular.element($element[0].querySelector('md-tab-data'));

    element.html(template);
    $compile(element.contents())(ctrl.parent);
    delete $attrs.$mdTabsTemplate;
  }

  /**
   * Binds events used by the tabs component.
   */
  function bindEvents () {
    angular.element($window).on('resize', handleWindowResize);
    $scope.$on('$destroy', cleanup);
  }

  /**
   * Configure watcher(s) used by Tabs
   */
  function configureWatchers () {
    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
  }

  /**
   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
   * @param key
   * @param handler
   */
  function defineOneWayBinding (key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler);
    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
  }

  /**
   * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
   * will be treated as being truthy)
   * @param key
   * @param handler
   */
  function defineBooleanAttribute (key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler);
    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
    $attrs.$observe(attr, updateValue);
    function updateValue (newValue) {
      ctrl[ key ] = newValue !== 'false';
    }
  }

  /**
   * Remove any events defined by this controller
   */
  function cleanup () {
    destroyed = true;
    angular.element($window).off('resize', handleWindowResize);
  }

  // Change handlers

  /**
   * Toggles stretch tabs class and updates inkbar when tab stretching changes
   * @param stretchTabs
   */
  function handleStretchTabs (stretchTabs) {
    var elements = getElements();
    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
    updateInkBarStyles();
  }

  function handleCenterTabs (newValue) {
    ctrl.shouldCenterTabs = shouldCenterTabs();
  }

  function handleMaxTabWidth (newWidth, oldWidth) {
    if (newWidth !== oldWidth) {
      var elements = getElements();

      // Set the max width for the real tabs
      angular.forEach(elements.tabs, function(tab) {
        tab.style.maxWidth = newWidth + 'px';
      });

      // Set the max width for the dummy tabs too
      angular.forEach(elements.dummies, function(tab) {
        tab.style.maxWidth = newWidth + 'px';
      });

      $mdUtil.nextTick(ctrl.updateInkBarStyles);
    }
  }

  function handleShouldPaginate (newValue, oldValue) {
    if (newValue !== oldValue) {
      ctrl.maxTabWidth      = getMaxTabWidth();
      ctrl.shouldCenterTabs = shouldCenterTabs();
      $mdUtil.nextTick(function () {
        ctrl.maxTabWidth = getMaxTabWidth();
        adjustOffset(ctrl.selectedIndex);
      });
    }
  }

  /**
   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
   * @param hasContent
   */
  function handleHasContent (hasContent) {
    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
  }

  /**
   * Apply ctrl.offsetLeft to the paging element when it changes
   * @param left
   */
  function handleOffsetChange (left) {
    var elements = getElements();
    var newValue = ((ctrl.shouldCenterTabs || isRtl() ? '' : '-') + left + 'px');

    // Fix double-negative which can happen with RTL support
    newValue = newValue.replace('--', '');

    angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
    $scope.$broadcast('$mdTabsPaginationChanged');
  }

  /**
   * Update the UI whenever `ctrl.focusIndex` is updated
   * @param newIndex
   * @param oldIndex
   */
  function handleFocusIndexChange (newIndex, oldIndex) {
    if (newIndex === oldIndex) return;
    if (!getElements().tabs[ newIndex ]) return;
    adjustOffset();
    redirectFocus();
  }

  /**
   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
   * @param newValue
   * @param oldValue
   */
  function handleSelectedIndexChange (newValue, oldValue) {
    if (newValue === oldValue) return;

    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
    ctrl.lastSelectedIndex = oldValue;
    ctrl.updateInkBarStyles();
    updateHeightFromContent();
    adjustOffset(newValue);
    $scope.$broadcast('$mdTabsChanged');
    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
  }

  function getTabElementIndex(tabEl){
    var tabs = $element[0].getElementsByTagName('md-tab');
    return Array.prototype.indexOf.call(tabs, tabEl[0]);
  }

  /**
   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
   * hidden.
   */
  function handleResizeWhenVisible () {
    // if there is already a watcher waiting for resize, do nothing
    if (handleResizeWhenVisible.watcher) return;
    // otherwise, we will abuse the $watch function to check for visible
    handleResizeWhenVisible.watcher = $scope.$watch(function () {
      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
      $mdUtil.nextTick(function () {
        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
        if (!handleResizeWhenVisible.watcher) return;

        if ($element.prop('offsetParent')) {
          handleResizeWhenVisible.watcher();
          handleResizeWhenVisible.watcher = null;

          handleWindowResize();
        }
      }, false);
    });
  }

  // Event handlers / actions

  /**
   * Handle user keyboard interactions
   * @param event
   */
  function keydown (event) {
    switch (event.keyCode) {
      case $mdConstant.KEY_CODE.LEFT_ARROW:
        event.preventDefault();
        incrementIndex(-1, true);
        break;
      case $mdConstant.KEY_CODE.RIGHT_ARROW:
        event.preventDefault();
        incrementIndex(1, true);
        break;
      case $mdConstant.KEY_CODE.SPACE:
      case $mdConstant.KEY_CODE.ENTER:
        event.preventDefault();
        if (!locked) select(ctrl.focusIndex);
        break;
      case $mdConstant.KEY_CODE.TAB:
        // On tabbing out of the tablist, reset hasFocus to reset ng-focused and
        // its md-focused class if the focused tab is not the active tab.
        if (ctrl.focusIndex !== ctrl.selectedIndex) {
          ctrl.focusIndex = ctrl.selectedIndex;
        }
        break;
    }
  }

  /**
   * Update the selected index. Triggers a click event on the original `md-tab` element in order
   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
   * @param index
   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
   */
  function select (index, canSkipClick) {
    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
    // skip the click event if noSelectClick is enabled
    if (canSkipClick && ctrl.noSelectClick) return;
    // nextTick is required to prevent errors in user-defined click events
    $mdUtil.nextTick(function () {
      ctrl.tabs[ index ].element.triggerHandler('click');
    }, false);
  }

  /**
   * When pagination is on, this makes sure the selected index is in view.
   * @param event
   */
  function scroll (event) {
    if (!ctrl.shouldPaginate) return;
    event.preventDefault();
    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
  }

  /**
   * Slides the tabs over approximately one page forward.
   */
  function nextPage () {
    if (!ctrl.canPageForward()) { return }

    var newOffset = MdTabsPaginationService.increasePageOffset(getElements(), ctrl.offsetLeft);

    ctrl.offsetLeft = fixOffset(newOffset);
  }

  /**
   * Slides the tabs over approximately one page backward.
   */
  function previousPage () {
    if (!ctrl.canPageBack()) { return }

    var newOffset = MdTabsPaginationService.decreasePageOffset(getElements(), ctrl.offsetLeft);

    // Set the new offset
    ctrl.offsetLeft = fixOffset(newOffset);
  }

  /**
   * Update size calculations when the window is resized.
   */
  function handleWindowResize () {
    ctrl.lastSelectedIndex = ctrl.selectedIndex;
    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);

    $mdUtil.nextTick(function () {
      ctrl.updateInkBarStyles();
      updatePagination();
    });
  }

  function handleInkBar (hide) {
    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
  }

  /**
   * Toggle dynamic height class when value changes
   * @param value
   */
  function handleDynamicHeight (value) {
    $element.toggleClass('md-dynamic-height', value);
  }

  /**
   * Remove a tab from the data and select the nearest valid tab.
   * @param tabData
   */
  function removeTab (tabData) {
    if (destroyed) return;
    var selectedIndex = ctrl.selectedIndex,
        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
    refreshIndex();
    // when removing a tab, if the selected index did not change, we have to manually trigger the
    //   tab select/deselect events
    if (ctrl.selectedIndex === selectedIndex) {
      tab.scope.deselect();
      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
    }
    $mdUtil.nextTick(function () {
      updatePagination();
      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
    });
  }

  /**
   * Create an entry in the tabs array for a new tab at the specified index.
   * @param tabData
   * @param index
   * @returns {*}
   */
  function insertTab (tabData, index) {
    var hasLoaded = loaded;
    var proto     = {
          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
          shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
          hasFocus:     function () {
            return ctrl.styleTabItemFocus
                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
          },
          id:           $mdUtil.nextUid(),
          hasContent: !!(tabData.template && tabData.template.trim())
        },
        tab       = angular.extend(proto, tabData);
    if (angular.isDefined(index)) {
      ctrl.tabs.splice(index, 0, tab);
    } else {
      ctrl.tabs.push(tab);
    }

    processQueue();
    updateHasContent();
    $mdUtil.nextTick(function () {
      updatePagination();
      setAriaControls(tab);

      // if autoselect is enabled, select the newly added tab
      if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function () {
        $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
      });
    });
    return tab;
  }

  // Getter methods

  /**
   * Gathers references to all of the DOM elements used by this controller.
   * @returns {{}}
   */
  function getElements () {
    var elements = {};
    var node = $element[0];

    // gather tab bar elements
    elements.wrapper = node.querySelector('md-tabs-wrapper');
    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
    elements.nextButton = node.querySelector('md-next-button');
    elements.prevButton = node.querySelector('md-prev-button');

    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');

    return elements;
  }

  /**
   * Determines whether or not the left pagination arrow should be enabled.
   * @returns {boolean}
   */
  function canPageBack () {
    // This works for both LTR and RTL
    return ctrl.offsetLeft > 0;
  }

  /**
   * Determines whether or not the right pagination arrow should be enabled.
   * @returns {*|boolean}
   */
  function canPageForward () {
    var elements = getElements();
    var lastTab = elements.tabs[ elements.tabs.length - 1 ];

    if (isRtl()) {
      return ctrl.offsetLeft < elements.paging.offsetWidth - elements.canvas.offsetWidth;
    }

    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
        ctrl.offsetLeft;
  }

  /**
   * Returns currently focused tab item's element ID
   */
  function getFocusedTabId() {
    var focusedTab = ctrl.tabs[ctrl.focusIndex];
    if (!focusedTab || !focusedTab.id) {
      return null;
    }
    return 'tab-item-' + focusedTab.id;
  }

  /**
   * Determines if the UI should stretch the tabs to fill the available space.
   * @returns {*}
   */
  function shouldStretchTabs () {
    switch (ctrl.stretchTabs) {
      case 'always':
        return true;
      case 'never':
        return false;
      default:
        return !ctrl.shouldPaginate
            && $window.matchMedia('(max-width: 600px)').matches;
    }
  }

  /**
   * Determines if the tabs should appear centered.
   * @returns {string|boolean}
   */
  function shouldCenterTabs () {
    return ctrl.centerTabs && !ctrl.shouldPaginate;
  }

  /**
   * Determines if pagination is necessary to display the tabs within the available space.
   * @returns {boolean}
   */
  function shouldPaginate () {
    if (ctrl.noPagination || !loaded) return false;
    var canvasWidth = $element.prop('clientWidth');

    angular.forEach(getElements().tabs, function (tab) {
      canvasWidth -= tab.offsetWidth;
    });

    return canvasWidth < 0;
  }

  /**
   * Finds the nearest tab index that is available.  This is primarily used for when the active
   * tab is removed.
   * @param newIndex
   * @returns {*}
   */
  function getNearestSafeIndex (newIndex) {
    if (newIndex === -1) return -1;
    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
        i, tab;
    for (i = 0; i <= maxOffset; i++) {
      tab = ctrl.tabs[ newIndex + i ];
      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
      tab = ctrl.tabs[ newIndex - i ];
      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
    }
    return newIndex;
  }

  // Utility methods

  /**
   * Defines a property using a getter and setter in order to trigger a change handler without
   * using `$watch` to observe changes.
   * @param key
   * @param handler
   * @param value
   */
  function defineProperty (key, handler, value) {
    Object.defineProperty(ctrl, key, {
      get: function () { return value; },
      set: function (newValue) {
        var oldValue = value;
        value        = newValue;
        handler && handler(newValue, oldValue);
      }
    });
  }

  /**
   * Updates whether or not pagination should be displayed.
   */
  function updatePagination () {
    ctrl.maxTabWidth = getMaxTabWidth();
    ctrl.shouldPaginate = shouldPaginate();
  }

  /**
   * Calculates the width of the pagination wrapper by summing the widths of the dummy tabs.
   * @returns {number}
   */
  function calcPagingWidth () {
    return calcTabsWidth(getElements().tabs);
  }

  function calcTabsWidth(tabs) {
    var width = 0;

    angular.forEach(tabs, function (tab) {
      //-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
      //   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
      //   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
      //   of a dialog)
      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
    });

    return Math.ceil(width);
  }

  function getMaxTabWidth () {
    var elements = getElements(),
        containerWidth = elements.canvas.clientWidth,

        // See https://material.google.com/components/tabs.html#tabs-specs
        specMax = 264;

    // Do the spec maximum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
    // width can break the pagination) but not less than 0
    return Math.max(0, Math.min(containerWidth - 1, specMax));
  }

  function getMinTabWidth() {
    var elements = getElements(),
        containerWidth = elements.canvas.clientWidth,
        xsBreakpoint = 600,

        // See https://material.google.com/components/tabs.html#tabs-specs
        specMin = containerWidth > xsBreakpoint ? 160 : 72;

    // Do the spec minimum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
    // width can break the pagination) but not less than 0
    return Math.max(0, Math.min(containerWidth - 1, specMin));
  }

  /**
   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
   */
  function updateTabOrder () {
    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
      return a.index - b.index;
    });
    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
  }

  /**
   * This moves the selected or focus index left or right.  This is used by the keydown handler.
   * @param inc
   */
  function incrementIndex (inc, focus) {
    var newIndex,
        key   = focus ? 'focusIndex' : 'selectedIndex',
        index = ctrl[ key ];
    for (newIndex = index + inc;
         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
         newIndex += inc) {}

    newIndex = (index + inc + ctrl.tabs.length) % ctrl.tabs.length;

    if (ctrl.tabs[ newIndex ]) {
      ctrl[ key ] = newIndex;
    }
  }

  /**
   * This is used to forward focus to tab container elements.  This method is necessary to avoid
   * animation issues when attempting to focus an item that is out of view.
   */
  function redirectFocus () {
    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
    getElements().tabs[ ctrl.focusIndex ].focus();
  }

  /**
   * Forces the pagination to move the focused tab into view.
   */
  function adjustOffset (index) {
    var elements = getElements();

    if (!angular.isNumber(index)) index = ctrl.focusIndex;
    if (!elements.tabs[ index ]) return;
    if (ctrl.shouldCenterTabs) return;
    var tab         = elements.tabs[ index ],
        left        = tab.offsetLeft,
        right       = tab.offsetWidth + left,
        extraOffset = 32;

    // If we are selecting the first tab (in LTR and RTL), always set the offset to 0
    if (index == 0) {
      ctrl.offsetLeft = 0;
      return;
    }

    if (isRtl()) {
      var tabWidthsBefore = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index));
      var tabWidthsIncluding = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index + 1));

      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(tabWidthsBefore));
      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(tabWidthsIncluding - elements.canvas.clientWidth));
    } else {
      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + extraOffset));
      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
    }
  }

  /**
   * Iterates through all queued functions and clears the queue.  This is used for functions that
   * are called before the UI is ready, such as size calculations.
   */
  function processQueue () {
    queue.forEach(function (func) { $mdUtil.nextTick(func); });
    queue = [];
  }

  /**
   * Determines if the tab content area is needed.
   */
  function updateHasContent () {
    var hasContent  = false;

    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].hasContent) {
        hasContent = true;
        break;
      }
    }

    ctrl.hasContent = hasContent;
  }

  /**
   * Moves the indexes to their nearest valid values.
   */
  function refreshIndex () {
    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
  }

  /**
   * Calculates the content height of the current tab.
   * @returns {*}
   */
  function updateHeightFromContent () {
    if (!ctrl.dynamicHeight) return $element.css('height', '');
    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);

    var elements = getElements();

    var tabContent    = elements.contents[ ctrl.selectedIndex ],
        contentHeight = tabContent ? tabContent.offsetHeight : 0,
        tabsHeight    = elements.wrapper.offsetHeight,
        newHeight     = contentHeight + tabsHeight,
        currentHeight = $element.prop('clientHeight');

    if (currentHeight === newHeight) return;

    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
    if ($element.attr('md-align-tabs') === 'bottom') {
      currentHeight -= tabsHeight;
      newHeight -= tabsHeight;
      // Need to include bottom border in these calculations
      if ($element.attr('md-border-bottom') !== undefined) ++currentHeight;
    }

    // Lock during animation so the user can't change tabs
    locked = true;

    var fromHeight = { height: currentHeight + 'px' },
        toHeight = { height: newHeight + 'px' };

    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
    // first animates to 0, then back to the proper height causing a visual glitch
    $element.css(fromHeight);

    // Animate the height from the old to the new
    $animateCss($element, {
      from: fromHeight,
      to: toHeight,
      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
      duration: 0.5
    }).start().done(function () {
      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
      // pixel height so the height can size with browser width/content changes, etc.
      $element.css({
        transition: 'none',
        height: ''
      });

      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
      // enough to batch it for us instead of doing it immediately, which undoes the original
      // transition: none)
      $mdUtil.nextTick(function() {
        $element.css('transition', '');
      });

      // And unlock so tab changes can occur
      locked = false;
    });
  }

  /**
   * Repositions the ink bar to the selected tab.
   * @returns {*}
   */
  function updateInkBarStyles () {
    var elements = getElements();

    if (!elements.tabs[ ctrl.selectedIndex ]) {
      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
      return;
    }

    if (!ctrl.tabs.length) return queue.push(ctrl.updateInkBarStyles);
    // if the element is not visible, we will not be able to calculate sizes until it is
    // we should treat that as a resize event rather than just updating the ink bar
    if (!$element.prop('offsetParent')) return handleResizeWhenVisible();

    var index      = ctrl.selectedIndex,
        totalWidth = elements.paging.offsetWidth,
        tab        = elements.tabs[ index ],
        left       = tab.offsetLeft,
        right      = totalWidth - left - tab.offsetWidth;

    if (ctrl.shouldCenterTabs) {
      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding deviations.
      var tabWidth = calcTabsWidth(elements.tabs);

      if (totalWidth > tabWidth) {
        $mdUtil.nextTick(updateInkBarStyles, false);
      }
    }
    updateInkBarClassName();
    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
  }

  /**
   * Adds left/right classes so that the ink bar will animate properly.
   */
  function updateInkBarClassName () {
    var elements = getElements();
    var newIndex = ctrl.selectedIndex,
        oldIndex = ctrl.lastSelectedIndex,
        ink      = angular.element(elements.inkBar);
    if (!angular.isNumber(oldIndex)) return;
    ink
        .toggleClass('md-left', newIndex < oldIndex)
        .toggleClass('md-right', newIndex > oldIndex);
  }

  /**
   * Takes an offset value and makes sure that it is within the min/max allowed values.
   * @param value
   * @returns {*}
   */
  function fixOffset (value) {
    var elements = getElements();

    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;

    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;

    if (isRtl()) {
      value = Math.min(elements.paging.offsetWidth - elements.canvas.clientWidth, value);
      value = Math.max(0, value);
    } else {
      value = Math.max(0, value);
      value = Math.min(totalWidth - elements.canvas.clientWidth, value);
    }

    return value;
  }

  /**
   * Attaches a ripple to the tab item element.
   * @param scope
   * @param element
   */
  function attachRipple (scope, element) {
    var elements = getElements();
    var options = { colorElement: angular.element(elements.inkBar) };
    $mdTabInkRipple.attach(scope, element, options);
  }

  /**
   * Sets the `aria-controls` attribute to the elements that
   * correspond to the passed-in tab.
   * @param tab
   */
  function setAriaControls (tab) {
    if (tab.hasContent) {
      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
    }
  }

  function isRtl() {
    return ($mdUtil.bidi() == 'rtl');
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdTabs
 * @module material.components.tabs
 *
 * @restrict E
 *
 * @description
 * The `<md-tabs>` directive serves as the container for 1..n `<md-tab>` child directives to
 * produces a Tabs components. In turn, the nested `<md-tab>` directive is used to specify a tab
 * label for the **header button** and a [optional] tab view content that will be associated with
 * each tab button.
 *
 * Below is the markup for its simplest usage:
 *
 *  <hljs lang="html">
 *  <md-tabs>
 *    <md-tab label="Tab #1"></md-tab>
 *    <md-tab label="Tab #2"></md-tab>
 *    <md-tab label="Tab #3"></md-tab>
 *  </md-tabs>
 *  </hljs>
 *
 * Tabs supports three (3) usage scenarios:
 *
 *  1. Tabs (buttons only)
 *  2. Tabs with internal view content
 *  3. Tabs with external view content
 *
 * **Tab-only** support is useful when tab buttons are used for custom navigation regardless of any
 * other components, content, or views.
 *
 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look
 * at the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead as it can handle this
 * case a bit more natively.</i>
 *
 * **Tabs with internal views** are the traditional usages where each tab has associated view
 * content and the view switching is managed internally by the Tabs component.
 *
 * **Tabs with external view content** is often useful when content associated with each tab is
 * independently managed and data-binding notifications announce tab selection changes.
 *
 * Additional features also include:
 *
 * *  Content can include any markup.
 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
 *
 * ### Explanation of tab stretching
 *
 * Initially, tabs will have an inherent size.  This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS.  Calculations will be based on this size.
 *
 * On mobile devices, tabs will be expanded to fill the available horizontal space.  When this happens, all tabs will become the same size.
 *
 * On desktops, by default, stretching will never occur.
 *
 * This default behavior can be overridden through the `md-stretch-tabs` attribute.  Here is a table showing when stretching will occur:
 *
 * `md-stretch-tabs` | mobile    | desktop
 * ------------------|-----------|--------
 * `auto`            | stretched | ---
 * `always`          | stretched | stretched
 * `never`           | ---       | ---
 *
 * @param {integer=} md-selected Index of the active/selected tab
 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
 * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
 * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`; default is `top`
 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`, `always`, or `never`; default is `auto`
 * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the contents of the selected tab
 * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and their content
 * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need for pagination
 * @param {boolean=} md-no-pagination When enabled, pagination will remain off
 * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content area to jump between tabs
 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that are not being displayed.  This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.
 * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be automatically selected
 * @param {boolean=} md-no-select-click When enabled, click events will not be fired when selecting tabs
 *
 * @usage
 * <hljs lang="html">
 * <md-tabs md-selected="selectedIndex" >
 *   <img ng-src="img/angular.png" class="centered">
 *   <md-tab
 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
 *       md-on-select="onTabSelected(tab)"
 *       md-on-deselect="announceDeselected(tab)"
 *       ng-disabled="tab.disabled">
 *     <md-tab-label>
 *       {{tab.title}}
 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
 *     </md-tab-label>
 *     <md-tab-body>
 *       {{tab.content}}
 *     </md-tab-body>
 *   </md-tab>
 * </md-tabs>
 * </hljs>
 *
 */
MdTabs.$inject = ["$$mdSvgRegistry"];
angular
    .module('material.components.tabs')
    .directive('mdTabs', MdTabs);

function MdTabs ($$mdSvgRegistry) {
  return {
    scope:            {
      selectedIndex: '=?mdSelected'
    },
    template:         function (element, attr) {
      attr.$mdTabsTemplate = element.html();
      return '' +
        '<md-tabs-wrapper> ' +
          '<md-tab-data></md-tab-data> ' +
          '<md-prev-button ' +
              'tabindex="-1" ' +
              'role="button" ' +
              'aria-label="Previous Page" ' +
              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
              'ng-click="$mdTabsCtrl.previousPage()"> ' +
            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
          '</md-prev-button> ' +
          '<md-next-button ' +
              'tabindex="-1" ' +
              'role="button" ' +
              'aria-label="Next Page" ' +
              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
              'ng-click="$mdTabsCtrl.nextPage()"> ' +
            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
          '</md-next-button> ' +
          '<md-tabs-canvas ' +
              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
              'ng-class="{ ' +
                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
              '}" ' +
              'ng-keydown="$mdTabsCtrl.keydown($event)"> ' +
            '<md-pagination-wrapper ' +
                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
                'md-tab-scroll="$mdTabsCtrl.scroll($event)" ' +
                'role="tablist"> ' +
              '<md-tab-item ' +
                  'tabindex="{{ tab.isActive() ? 0 : -1 }}" ' +
                  'class="md-tab" ' +
                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                  'role="tab" ' +
                  'id="tab-item-{{::tab.id}}" ' +
                  'md-tab-id="{{::tab.id}}"' +
                  'aria-selected="{{tab.isActive()}}" ' +
                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
                  'ng-class="{ ' +
                      '\'md-active\':    tab.isActive(), ' +
                      '\'md-focused\':   tab.hasFocus(), ' +
                      '\'md-disabled\':  tab.scope.disabled ' +
                  '}" ' +
                  'ng-disabled="tab.scope.disabled" ' +
                  'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
                  'md-tabs-template="::tab.label" ' +
                  'md-scope="::tab.parent"></md-tab-item> ' +
              '<md-ink-bar></md-ink-bar> ' +
            '</md-pagination-wrapper> ' +
            '<md-tabs-dummy-wrapper aria-hidden="true" class="md-visually-hidden md-dummy-wrapper"> ' +
              '<md-dummy-tab ' +
                  'class="md-tab" ' +
                  'tabindex="-1" ' +
                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                  'md-tabs-template="::tab.label" ' +
                  'md-scope="::tab.parent"></md-dummy-tab> ' +
            '</md-tabs-dummy-wrapper> ' +
          '</md-tabs-canvas> ' +
        '</md-tabs-wrapper> ' +
        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
          '<md-tab-content ' +
              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
              'class="_md" ' +
              'role="tabpanel" ' +
              'aria-labelledby="tab-item-{{::tab.id}}" ' +
              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
              'ng-if="tab.hasContent" ' +
              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
              'ng-class="{ ' +
                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
                '\'md-active\':        tab.isActive(), ' +
                '\'md-left\':          tab.isLeft(), ' +
                '\'md-right\':         tab.isRight(), ' +
                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
              '}"> ' +
            '<div ' +
                'md-tabs-template="::tab.template" ' +
                'md-connected-if="tab.isActive()" ' +
                'md-scope="::tab.parent" ' +
                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
          '</md-tab-content> ' +
        '</md-tabs-content-wrapper>';
    },
    controller:       'MdTabsController',
    controllerAs:     '$mdTabsCtrl',
    bindToController: true
  };
}

})();
(function(){
"use strict";


MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
  .module('material.components.tabs')
  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);

/**
 * @private
 *
 * @param $mdUtil
 * @param $window
 * @returns {{require: string, link: link}}
 * @constructor
 *
 * @ngInject
 */
function MdTabsDummyWrapper ($mdUtil, $window) {
  return {
    require: '^?mdTabs',
    link:    function link (scope, element, attr, ctrl) {
      if (!ctrl) return;

      var observer;
      var disconnect;

      var mutationCallback = function() {
        ctrl.updatePagination();
        ctrl.updateInkBarStyles();
      };

      if('MutationObserver' in $window) {
        var config = {
          childList: true,
          subtree: true,
          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
          // the childList mutation, once a <span> element's innerText changes.
          // The characterData of the <span> element will change.
          characterData: true
        };

        observer = new MutationObserver(mutationCallback);
        observer.observe(element[0], config);
        disconnect = observer.disconnect.bind(observer);
      } else {
        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
        
        element.on('DOMSubtreeModified', debounced);
        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
      }

      // Disconnect the observer
      scope.$on('$destroy', function() {
        disconnect();
      });
    }
  };
}

})();
(function(){
"use strict";


MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
    .module('material.components.tabs')
    .directive('mdTabsTemplate', MdTabsTemplate);

function MdTabsTemplate ($compile, $mdUtil) {
  return {
    restrict: 'A',
    link:     link,
    scope:    {
      template:     '=mdTabsTemplate',
      connected:    '=?mdConnectedIf',
      compileScope: '=mdScope'
    },
    require:  '^?mdTabs'
  };
  function link (scope, element, attr, ctrl) {
    if (!ctrl) return;

    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;

    element.html(scope.template);
    $compile(element.contents())(compileScope);

    return $mdUtil.nextTick(handleScope);

    function handleScope () {
      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
      scope.$on('$destroy', reconnect);
    }

    function disconnect () {
      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
    }

    function reconnect () {
      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
    }
  }
}

})();
(function(){ 
angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-A100}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-100}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-A100}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:\"{{background-900}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight{color:\"{{background-600}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover{background:\"{{background-200}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-50}}\";border-top-color:\"{{background-300}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-50}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:\"{{primary-contrast}}\";background-color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-raised{color:\"{{background-900}}\";background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:\"{{warn-contrast}}\";background-color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:\"{{accent-contrast}}\";background-color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-hue-1}}\";border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:\"{{background-color}}\";background-color:\"{{foreground-3}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:\"{{background-500}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{accent-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-content.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-default}}\"}.md-calendar.md-THEME_NAME-theme{background:\"{{background-A100}}\";color:\"{{background-A200-0.87}}\"}.md-calendar.md-THEME_NAME-theme tr:last-child td{border-bottom-color:\"{{background-200}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-300}}\";color:\"{{background-A200-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-300}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";color:\"{{primary-500-contrast}}\";border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{background-A200-0.435}}\"}.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-A100}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:\"{{foreground-4}}\"}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:\"{{foreground-4}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{color:\"{{foreground-1}}\";border-color:\"{{foreground-4}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:\"{{foreground-3}}\";background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-A100}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{background-A200-0.87}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{background-A200-0.25}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{background-A200-0.11}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:\"{{foreground-2}}\";border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background:\"{{background-200}}\"}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.2}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.2}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-A100}}\";color:\"{{background-A200}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{background-A100-0.87}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{background-A100-0.87}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-bar1{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-dashed:before{background:radial-gradient(\"{{primary-100}}\" 0,\"{{primary-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked.md-primary .md-ink-ripple{color:\"{{warn-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background:\"{{background-A100}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{background-600-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{background-900-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{background-400-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background:\"{{background-200}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{background-900-0.87}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:\"{{background-color}}\";background-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:\"{{accent-color}}\";background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:\"{{warn-color}}\";background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:\"{{primary-color}}\";background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{color:\"{{ foreground-2-0.23 }}\";background-color:\"{{background-default}}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:\"{{primary-contrast}}\";fill:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:\"{{primary-contrast-0.26}}\";fill:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:\"{{accent-contrast}}\";fill:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:\"{{accent-contrast-0.26}}\";fill:\"{{accent-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{color:\"{{background-700-contrast}}\";background-color:\"{{background-700}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-color}}\"}"); 
})();


})(window, window.angular);;window.ngMaterial={version:{full: "1.1.5"}};
},{}],10:[function(require,module,exports){
// Should already be required, here for clarity
require('angular');

// Load Angular and dependent libs
require('angular-animate');
require('angular-aria');

// Now load Angular Material
require('./angular-material');

// Export namespace
module.exports = 'ngMaterial';

},{"./angular-material":9,"angular":"angular","angular-animate":2,"angular-aria":4}],11:[function(require,module,exports){
'use strict';

// Aliases => (official) email address
// Use name property only for people/entities without official email (ie. not in npolarPeople)

var aliases = [
// Alphabetical:
{ email: 'are.bjordal@npolar.no', alias: ['are@npolar.no', 'are'] }, { email: 'christian.lydersen@npolar.no', alias: ['lydersen@npolar.no', 'lydersen'] }, { email: 'conrad.helgeland@npolar.no', alias: ['conrad@npolar.no', 'conrad', 'ch', 'c'] }, { email: 'dag.vongraven@npolar.no', alias: ['vongraven@npolar.no'] }, { email: 'ermias.beyene.tesfamariam@npolar.no', alias: ['ermias@npolar.no', 'ermias.tesfamariam@npolar.no', 'ermias'] }, { email: 'polona.itkin@npolar.no', alias: ['polona@npolar.no', 'polona'] }, { email: 'ruben.dens@npolar.no', alias: ['ruben@npolar.no', 'ruben', 'rd', 'r'] }, { email: 'stein.tronstad@npolar.no', alias: ['stein@npolar.no', 'steint@npolar.no', 'stein', 'steint', 'st', 's'] }, { email: 'stein.orjan.nilsen@npolar.no', alias: ['steinnilsen@npolar.no', 'steinnilsen', 'stein.nilsen@npolar.no', 'stein.nilsen'] }, { email: 'stephen.hudson@npolar.no', alias: ['hudson@npolar.no', 'hudson'] },
// With name:
{ email: 'cesar.deschamps.berger@npolar.no', name: 'César Deschamps-Berger', alias: ['cesar@npolar.no', 'cesar'] }, { email: 'external@data.npolar.no', alias: ['external@data.npolar.no'], name: 'System' }, { email: 'kkjaer@online.no', name: 'Kjell-G. Kjær', alias: ['kkjaer@online.no'] }, { email: 'ssf@npolar.no', name: 'Svalbard Science Forum', alias: ['ssf@npolar.no', 'ssf'] }, { email: 'trevor.lovett@npolar.no', name: 'Trevor Lovett', alias: ['trevor@npolar.no', 'trevor'] }];

module.exports = aliases;

},{}],12:[function(require,module,exports){
/**
 * npolarApiConfig, meant to be .run and merged with overrides for the current environment
 *
 */
'use strict';

var config = {
  environment: 'production',
  lang: 'en',
  base: '//api.npolar.no',
  security: {
    authorization: 'jwt'
  }
};

module.exports = config;

},{}],13:[function(require,module,exports){
'use strict';
/**
* NpolarBaseController is meant to be the parent of a safe controller,
* ie. a controller dealing with only with presentation, search, etc.
* See also NpolarEditController.
*
*/

var BaseController = function BaseController($scope, $location, $routeParams, $http, NpolarApiSecurity, NpolarTranslate) {
  'ngInject';

  $scope._error = false;
  $scope.security = NpolarApiSecurity;
  $scope.appBase = "archive";

  $scope.error = function () {
    return $scope._error;
  };

  // Show action, ie. fetch document and inject into scope
  $scope.show = function () {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return $scope.resource.fetch(Object.assign({}, $routeParams, query), function (document) {
      $scope.document = document;
      $scope._error = false;
    }, function (errorData) {
      if (errorData.status === 404) {
        $scope._error = NpolarTranslate.translate('document.no_document') + "\"" + $routeParams.id + "\"";
      } else {
        $scope._error = NpolarTranslate.translate('document.error');
        if (errorData.statusText && errorData.statusText.length > 0) {
          $scope._error += ". Status: " + errorData.status + ", Message: " + errorData.statusText;
        }
      }
    });
  };

  // Search action, ie. fetch feed and inject into scope
  $scope.search = function () {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var facets = {};
    if (query.facets || $location.search().facets) {
      facets.facets = (query.facets ? query.facets + "," : "") + ($location.search().facets || '');
    }

    var fullQuery = Object.assign({}, $location.search(), query, facets);

    return $scope.resource.feed(fullQuery, function (response) {
      $scope.feed = response.feed;
      $scope._error = false;
    }, function (errorData) {
      $scope._error = NpolarTranslate.translate('search.error');
      if (errorData.statusText && errorData.statusText.length > 0) {
        $scope._error += ". Status: " + errorData.status + ", Message: " + errorData.statusText;
      }
    });
  };
};
BaseController.$inject = ["$scope", "$location", "$routeParams", "$http", "NpolarApiSecurity", "NpolarTranslate"];

module.exports = BaseController;

},{}],14:[function(require,module,exports){
'use strict';
/**
 * NpolarEditController extends [NpolarBaseController](https://github.com/npolar/angular-npolar/blob/master/src/api/controller/BaseController.js) with scope methods for REST-style document editing (using ngResource)
 * and [formula](https://github.com/npolar/formula)-bound controller action methods, like $scope.edit()
 *
 * For following ngResource-bound scope methods are defined
 * - create()
 * - update()
 * - delete()
 * - save()
 *
 * Usage example: https://github.com/npolar/npdc-dataset/blob/ae0dc74d33708c76ac88fc8f0f492ac14759cae7/src/edit/DatasetEditController.js
 *
 */

var EditController = function EditController($scope, $location, $route, $routeParams, $controller, $q, Gouncer, npolarApiConfig, NpolarApiSecurity, NpolarMessage) {
  'ngInject';

  // Extend NpolarBaseController

  $controller('NpolarBaseController', {
    $scope: $scope
  });

  $scope.document = null;

  // Refresh JWT
  var refreshJwt = function refreshJwt() {
    if (NpolarApiSecurity.isAuthenticated()) {
      Gouncer.authenticate().then(function (response) {
        NpolarApiSecurity.setJwt(response.data.token);
      }, function (reason) {
        NpolarApiSecurity.logout("Authentication failed: could not refresh JWT");
      });
    }
  };

  // Formula compatible save
  // SHOULD NOT BE CALLED DIRECTLY, FORMULA DOES THE VALIDATION!!
  var save = function save(model) {
    if (!model._rev) {
      return $scope.create(model);
    } else {
      return $scope.update(model);
    }
  };

  // Create action, ie. save document and redirect to new URI
  $scope.create = function (model) {
    return $scope.resource.save(model, function (doc) {
      var uri = $location.path().replace(/\/__new(\/edit)?$/, '/' + doc.id + '/edit');
      $scope.formula.setModel(doc);
      $scope.document = doc;
      $scope.resource.cache.removeAll();
      refreshJwt();
      $location.path(uri);
    });
  };

  // Edit action, ie. fetch document and edit with formula
  $scope.editAction = function () {
    return $scope.resource.fetch($routeParams, function (doc) {
      $scope.formula.setModel(doc);
      $scope.document = doc;
    });
  };

  // New action, ie. create new document and edit with formula
  // New document templates may be provided as an argument,
  // otherwise the create() function on the resource is called
  $scope.newAction = function () {
    var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var deferred = $q.defer();
    if (Object.keys(doc).length === 0) {
      if (typeof $scope.resource.create === "function") {
        doc = $scope.resource.create();
      }
    }
    var resource = new $scope.resource(doc);
    $scope.document = resource;
    $scope.formula.setModel(resource);
    deferred.resolve(resource);
    resource.$promise = deferred.promise; // for consistency with editAction
    return resource;
  };

  // Edit (or new) action
  $scope.edit = function () {
    $scope.formula.setOnSave(save);

    if ($routeParams.id === '__new') {
      return $scope.newAction();
    } else {
      return $scope.editAction();
    }
  };

  // PUT document, ie resource.update
  $scope.update = function (model) {
    return $scope.resource.update(model, function (doc) {
      $scope.resource.cache.removeAll();
      refreshJwt();
      $location.path($scope.resource.href(doc.id));
    });
  };

  // DELETE document, ie. resource remove
  $scope.delete = function () {
    var id = $scope.document.id;
    return $scope.resource.remove({ id: id }, function () {
      $scope.resource.cache.removeAll();
      refreshJwt();
      $location.path('/');
      $route.reload();
    });
  };

  // Create a duplicate of the current document
  $scope.duplicate = function () {
    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $scope.document;
    var save = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var removeFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["_id", "_rev", "created", "created_by", "id", "updated", "updated_by", "doi"];

    var dup = JSON.parse(JSON.stringify(d));
    var href = $scope.resource.href(d.id);

    removeFields.forEach(function (del) {
      delete dup[del];
    });
    if (dup.title) {
      if (typeof dup.title === 'string') {
        dup.title = '|' + dup.title + '|\u21E0' + href;
      } else if (dup.title instanceof Object) {
        var k = Object.keys(dup.title);
        k.forEach(function (language) {
          dup.title[language] = '|' + dup.title[language] + '|\u21E0' + href;
        });
      }
    }
    var duplicate = new $scope.resource(dup);

    if (save === true) {
      NpolarMessage.info('Commencing duplication of ' + d.id);
      return duplicate.$save(function (r) {
        $location.path($scope.resource.href(r.id));
      });
    } else {
      return duplicate;
    }
  };

  $scope.save = function () {
    try {
      $scope.formula.save();
    } catch (e) {
      NpolarMessage.error("Document not valid, please review " + (e || []).join(", "));
    }
  };
};
EditController.$inject = ["$scope", "$location", "$route", "$routeParams", "$controller", "$q", "Gouncer", "npolarApiConfig", "NpolarApiSecurity", "NpolarMessage"];

module.exports = EditController;

},{}],15:[function(require,module,exports){
/**
 * Angular service to communicate with [Gouncer](https://github.com/npolar/gouncer)
 */
'use strict';

var Gouncer = function Gouncer($http, NpolarApiSecurity, NpolarMessage, npolarApiConfig) {
  'ngInject';

  var base = NpolarApiSecurity.canonicalUri('/user');

  var forceNpolarEmailIfAtDomainIsMissing = function forceNpolarEmailIfAtDomainIsMissing(email) {
    if (false === /[@]/.test(email)) {
      email = email + '@npolar.no';
    }
    return email;
  };

  // Authenticate
  this.authenticate = function (email, password) {
    // Use HTTP Basic if email and password is passed
    if (email !== undefined && password !== undefined) {

      email = forceNpolarEmailIfAtDomainIsMissing(email);

      var request = { method: "GET", url: base + '/authenticate',
        headers: { "Authorization": "Basic " + NpolarApiSecurity.basicToken(email, password) }
      };
      return $http(request);
    } else if (NpolarApiSecurity.isJwtValid()) {
      return $http.get(base + '/authenticate');
    } else {
      throw new Error("Cannot authenticate: either JWT is invalid or username/password is blank");
    }
  };

  // One time password
  this.onetime = function (email) {
    var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://' + window.location.host + '/user/login/1-time?username={{user}}&code={{code}}';

    email = forceNpolarEmailIfAtDomainIsMissing(email);
    var param = { email: email };
    if (/^https/.test(link)) {
      param.link = link;
    }
    return $http.post(base + '/onetime', param);
  };

  this.reset = function (user) {
    return $http({
      method: 'POST',
      url: base + '/reset',
      data: { password: user.password }
    }).then(function () {
      NpolarMessage.info("Your password was successfully updated.");
    }, function () {
      NpolarMessage.error("Your password could not be updated.");
    });
  };

  return this;
};
Gouncer.$inject = ["$http", "NpolarApiSecurity", "NpolarMessage", "npolarApiConfig"];

module.exports = Gouncer;

},{}],16:[function(require,module,exports){
/**
 * Npolar API HTTP interceptor:
 * - adds JWT (Bearer token) in the Authorization header
 * - emits "npolar-api-*" messages
 *
 * Usage:
 * myApp.config(function($httpProvider) {
 *  $httpProvider.interceptors.push('npolarApiInterceptor');
 * });
 *
 */

'use strict';

var HttpInterceptor = function HttpInterceptor($log, $q, npolarApiConfig, NpolarMessage, NpolarApiSecurity) {
  'ngInject';

  var isNpolarApiRequest = function isNpolarApiRequest(config) {
    if (config.url === undefined || false === /\/\//.test(config.url)) {
      return false;
    }
    var isApi = config.url.split("//")[1].indexOf(npolarApiConfig.base.split("//")[1]) === 0;
    return isApi;
  };

  var isNpolarApiResponse = function isNpolarApiResponse(response) {
    if (0 === response.status) {
      return true; // Assume it's a crashed API request
    }
    return isJSON(response.headers('Content-Type')) && isNpolarApiRequest(response.config);
  };

  var isJSON = function isJSON(content_type) {
    return (/^application\/(vnd\.\w+\+)?json/.test(content_type)
    );
  };

  return {

    // Intercept API requests: add Authorization header (JWT)
    request: function request(config) {

      // Only intercept Npolar API requests
      if (isNpolarApiRequest(config)) {

        config.headers = config.headers || {};

        //@todo if ( body && ('PUT' === config.method || 'POST' === config.method)) { fire saving event? }
        //@todo if ('DELETE' === config.method) { fire deleting event? }

        // Add Authorization: Bearer [JWT]
        if (!config.headers.Authorization) {
          config.headers.Authorization = NpolarApiSecurity.authorization();
        }
      }
      return config;
    },

    response: function response(_response) {

      // Only intercept non-GET Npolar API responses
      if (_response.config.method !== "GET" && isNpolarApiResponse(_response)) {
        NpolarMessage.apiInfo(NpolarMessage.getMessage(_response));
      }
      // @todo fire saved event?
      // @todo fire deleted event?

      return _response;
    },

    requestError: function requestError(response) {

      response.body = {
        error: {
          explanation: "Request failed"
        }
      };
      NpolarMessage.apiError(NpolarMessage.getMessage(response));
      return $q.reject(response);
    },

    responseError: function responseError(response) {

      response.body = response.data;
      if (isNpolarApiResponse(response)) {
        NpolarMessage.apiError(NpolarMessage.getMessage(response));
      }
      return $q.reject(response);
    }

  };
};
HttpInterceptor.$inject = ["$log", "$q", "npolarApiConfig", "NpolarMessage", "NpolarApiSecurity"];

module.exports = HttpInterceptor;

},{}],17:[function(require,module,exports){
'use strict';

Request.$inject = ["NpolarApiSecurity"];
function Request(NpolarApiSecurity) {

  'ngInject';

  var self = this;

  this.factory = function () {
    return new XMLHttpRequest();
  };

  this.head = function (request, uri, listener) {
    var event = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'load';

    request.addEventListener(event, listener);
    request.open('HEAD', uri);
    request.setRequestHeader('Authorization', NpolarApiSecurity.authorization());
    request.send();
  };

  this.request = function (verb, uri) {
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : self.headers();
    var listeners = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [{ event: 'load', handler: null }];
  };
}
module.exports = Request;

},{}],18:[function(require,module,exports){
'use strict';

var Resource = function Resource($document, $resource, $cacheFactory, $window, npolarApiConfig) {
  'ngInject';
  // ['url', 'scheme', 'slash', 'host', 'port', 'path', 'query', 'hash']

  var PARSE_URL = /^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/;
  var base = $document[0].getElementsByTagName('base')[0];
  var appBase = base ? PARSE_URL.exec(base.href)[5].replace(/^\//, '').replace(/\/$/, '') : '';

  // Path to resource, relative to /base/ defined in index.html
  var href = function href(id) {
    var hrefBase = this.uiBase.replace(appBase, '').replace(/^\/+/, '');
    return (hrefBase ? hrefBase + '/' : '') + id;
  };

  var editHref = function editHref(id) {
    return this.href(id) + '/edit';
  };

  var newHref = function newHref() {
    return this.editHref('__new');
  };

  var _base = function _base(service) {
    // @todo canonicalUri?
    return typeof service.base === "string" ? service.base : npolarApiConfig.base;
  };

  // Generate random UUID, from http://stackoverflow.com/a/8809472
  // jshint -W016, -W116
  this.randomUUID = function () {
    var d = new Date().getTime();
    if ($window.performance && typeof $window.performance.now === "function") {
      d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
    return uuid;
  };

  // NpolarApiResource factory
  // @param service e.g. { path: '/dataset', 'resource': 'Dataset'}
  // @return NpolarApiResource - extended ngResource
  // @todo service.get == null|GET|JSONP
  // @todo make extending ngResource optional
  // @todo Support user-supplied extending
  // @todo Support non-search engine query/array/fetch
  this.resource = function (service) {

    var base = _base(service);
    var cache = service.cache || $cacheFactory('resourceCache:' + service.path + this.randomUUID().slice(-4));

    // Default parameters
    var params = {
      id: null,
      limit: 100,
      format: 'json',
      q: '',
      variant: 'atom'
    };

    //let fields_feed = (angular.isString(service.fields)) ? service.fields : null ;
    var fields_query = typeof service.fields === 'string' ? service.fields : 'id,title,name,code,titles,links,created,updated';

    //let params_feed = angular.extend({}, params, { fields: fields_feed });
    var params_query = Object.assign({}, params, {
      variant: 'array',
      limit: 1000,
      fields: fields_query
    });

    var TIMEOUT = 20000;

    var resource = $resource(base + service.path + '/:id', {}, {
      feed: {
        method: 'GET',
        params: params,
        headers: {
          Accept: 'application/json, application/geo+json'
        },
        cache: cache,
        timeout: TIMEOUT
      },
      query: {
        method: 'GET',
        params: params_query,
        isArray: true,
        cache: cache,
        timeout: TIMEOUT
      },
      array: {
        method: 'GET',
        params: params_query,
        isArray: true,
        cache: cache,
        timeout: TIMEOUT
      },
      facets: {
        method: 'GET',
        params: Object.assign({}, params, { limit: 0 }),
        isArray: true,
        cache: cache,
        timeout: TIMEOUT,
        transformResponse: function transformResponse(data) {
          if (!data) {
            return [];
          }
          return JSON.parse(data).feed.facets.map(function (facet) {
            var key = Object.keys(facet)[0];
            return {
              facet: key,
              terms: facet[key]
            };
          });
        }
      },
      fetch: {
        method: 'GET',
        params: {},
        headers: {
          Accept: 'application/json'
        },
        cache: cache,
        timeout: TIMEOUT
      },
      remove: {
        cache: cache,
        method: 'DELETE',
        timeout: TIMEOUT
      },
      delete: {
        cache: cache,
        method: 'DELETE',
        timeout: TIMEOUT
      },
      update: {
        cache: cache,
        method: 'PUT',
        params: {
          id: '@id'
        },
        headers: {
          Accept: 'application/json'
        },
        timeout: TIMEOUT
      }
    });

    resource.cache = cache;
    resource.uiBase = service.uiBase || service.path;
    resource.path = base + service.path;
    resource.href = href;
    resource.newHref = newHref;
    resource.editHref = editHref;
    resource.randomUUID = this.randomUUID;

    resource.facetTerms = function (facet) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params = Object.assign({ q: '', facets: facet, 'size-facet': 1000 }, params);
      return resource.facets(params).$promise.then(function (r) {
        return r.find(function (f) {
          return f.facet === facet;
        }).terms;
      });
    };

    return resource;
  };
};
Resource.$inject = ["$document", "$resource", "$cacheFactory", "$window", "npolarApiConfig"];

module.exports = Resource;

},{}],19:[function(require,module,exports){
'use strict';

var angular = require('angular');

/**
 * NpolarApiSecurity provides JWT Bearer HTTP Authorization header for Npolar API request,
 * see npolarApiInterceptor
 *
 * Also contains method to check decoded JWT objects from [Gouncer](https://github.com/npolar/gouncer) JWT
 *
 */
var Security = function Security($location, $log, base64, jwtHelper, npolarApiConfig, npolarPeople, NpolarApiUser, NpolarMessage) {
  'ngInject';
  // Gouncer location
  // secure uri

  //const authenticateUri = 'https://'+ npolarApiConfig.base.split("//")[1] +'/user/authenticate';

  // Gouncer system actions

  var _this2 = this;

  var actions = ['create', 'read', 'update', 'delete'];

  // @return Authorization header string (either Bearer/JWT or Basic)
  this.authorization = function () {

    var user = NpolarApiUser.getUser();

    if ('basic' === npolarApiConfig.security.authorization) {
      return 'Basic ' + this.basicToken(user);
    } else if ('jwt' === npolarApiConfig.security.authorization) {
      return 'Bearer ' + user.jwt;
    } else {
      console.error('NpolarApiSecurity authorization not implemented: ' + npolarApiConfig.security.authorization);
      return '';
    }
  };

  // @return HTTP Basic Authorization header string
  this.basicToken = function (username, password) {
    return base64.encode(username + ':' + password);
  };

  // Normalize shortened URI to absolute URI
  this.canonicalUri = function (uri) {
    var scheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https';

    var canonical = void 0;

    if (uri === undefined || uri === null) {
      return false;
      //throw new Error(`Bad URI: ${uri}`);
    }

    if (new RegExp('^' + scheme + '://').test(uri)) {
      canonical = uri;
    } else if (/^\/\//.test(uri)) {
      canonical = scheme + ':' + uri;
    } else if (/^\/[^/]/.test(uri)) {
      //throw new Error(`Relative URI: ${uri}`);
      canonical = scheme + '://' + npolarApiConfig.base.split("//")[1] + uri;
    } else if (/^https?:\/\//.test(uri)) {
      canonical = uri.replace(/^https?/, scheme);
    } else {
      throw new Error('Could not canonicalize URI: ' + uri);
    }
    return canonical;
  };

  // @return Object
  this.decodeJwt = function (jwt) {
    return jwtHelper.decodeToken(jwt);
  };

  // @return current user or empty user object
  this.getUser = function () {
    return NpolarApiUser.getUser();
  };

  // @return JWT string
  this.getJwt = function () {
    return this.getUser().jwt;
  };

  // Return all systems matching current URI (or *)
  this.systems = function (uri) {
    var _this = this;

    var systems = this.getUser().systems;

    if (uri === undefined) {
      return systems;
    }
    uri = this.canonicalUri(uri);

    return this.getUser().systems.filter(function (system) {

      if (system.uri === uri) {
        return true;
      } else if (system.uri === _this.canonicalUri(npolarApiConfig.base + "/*")) {
        return true;
      } else {
        return false;
      }
    });
  };

  // Check if the user has (any kind) of rights on system (uri)
  // @return true | false
  this.hasSystem = function (uri) {
    return this.systems(uri).length > 0;
  };

  // @return true | false
  this.isAuthenticated = function () {
    return this.isJwtValid();
  };

  // Is current user authorized to perform action on the provided uri?
  // Checks if the user is authorized *at the current time* - ie. always returns false if not authenticated
  // @param action ["create" | "read" | "update" | "delete"] => actions
  this.isAuthorized = function (action, uri) {
    var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getUser();

    if (!uri) {
      return false; // Called without uri to check against, just say no.
    }
    uri = this.canonicalUri(uri);

    if (false === actions.includes(action)) {
      $log.error('isAuthorized(' + action + ', ' + uri + ') called with invalid action');
      return false;
    }

    // @todo support just ngResource or NpolarApiResurce => get path from that
    // @todo fallback to relative application path


    // First, verify login
    if (false === this.isAuthenticated()) {
      return false;
    }
    // Then check permissions
    return this.isPermitted(action, uri, user);
  };

  // @return true | false
  this.isJwtExpired = function () {
    var jwt = this.getJwt();

    if (jwt === undefined || jwt === null || !angular.isString(jwt)) {
      return true;
    }

    try {
      return Date.now() / 1000 > this.decodeJwt(jwt).exp;
    } catch (e) {
      return true;
    }
  };

  // Check if user is permitted to perform action on uri
  this.getSystem = function (action, uri) {
    var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getUser();


    uri = this.canonicalUri(uri);
    if (false === uri) {
      return false;
    }

    // Get all systems for uri and check if at least one gives right to perform action
    var systems = this.systems(uri).filter(function (system) {
      return system.rights.includes(action);
    });

    // If we have at least 1 system, it does not matter which is returned
    // (More than 1 is probably caused by *)
    if (systems.length > 0) {
      return systems[0];
    } else {
      return false;
    }
  };

  // Check if user is permitted to perform action on uri
  // => ie. if we are left with at least 1 system
  this.isPermitted = function (action, uri) {
    var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getUser();

    var system = this.getSystem(action, uri, user);
    if (false === system) {
      return false;
    } else {
      return true;
    }
  };

  // @return true | false
  this.isJwtValid = function () {
    return false === this.isJwtExpired();
  };

  // @return true | false
  this.notAuthenticated = function () {
    return !_this2.isAuthenticated();
  };

  // Delete user in local storage
  this.removeUser = function () {
    return NpolarApiUser.removeUser();
  };

  // Store user in local storage
  this.setUser = function (user) {
    return NpolarApiUser.setUser(user);
  };

  // Set JWT (*and* user metadata) in local storage
  this.setJwt = function (jwt) {

    var token = this.decodeJwt(jwt);
    var expires = new Date(1000 * token.exp).toISOString();
    var orgtree = [];
    var cached = npolarPeople.people.find(function (p) {
      return p.email === token.email;
    });
    // find alias
    if (cached && cached.orgtree) {
      orgtree = cached.orgtree;
    }

    var user = {
      name: token.name || token.email,
      email: token.email,
      jwt: jwt,
      uri: token.uri || '',
      expires: expires,
      systems: token.systems || [],
      orgtree: orgtree
    };
    this.setUser(user);

    $log.debug('New JWT expires: ', expires, jwt);
  };

  this.logout = function (reason) {
    var who = this.getUser();
    who.reason = reason;
    NpolarMessage.logout(who);
    this.removeUser();
  };
};
Security.$inject = ["$location", "$log", "base64", "jwtHelper", "npolarApiConfig", "npolarPeople", "NpolarApiUser", "NpolarMessage"];

module.exports = Security;

},{"angular":"angular"}],20:[function(require,module,exports){
'use strict';

var angular = require('angular');

var ngNpolar = angular.module('ngNpolar');
ngNpolar.constant('npolarApiConfig', require('./config'));

var people = require('./people');
var aliases = require('./aliases');

/*
let idx;
aliases.forEach(a => {
  idx = people.findIndex(p => p.email === a.email);
  if (idx >= 0) {
    people[idx].alias = a.alias;
    console.log(idx, people[idx]);
  } else {
    people.push(a);
  }
  
});
*/
ngNpolar.constant('npolarPeople', people);
ngNpolar.constant('npolarAliases', aliases);

ngNpolar.service('NpolarApiUser', require('./session/User'));
ngNpolar.service('NpolarApiRequest', require('./http/Request'));

ngNpolar.service('NpolarApiSecurity', require('./http/Security'));
ngNpolar.service('NpolarApiResource', require('./http/Resource'));
ngNpolar.factory('npolarApiInterceptor', require('./http/HttpInterceptor'));

ngNpolar.service('NpolarApiText', require('./util/Text'));
ngNpolar.service('npolarDocumentUtil', require('./util/document'));
ngNpolar.directive('npolarJsonText', require('./util/jsonText'));

ngNpolar.controller('NpolarBaseController', require('./controller/BaseController'));
ngNpolar.controller('NpolarEditController', require('./controller/EditController'));

ngNpolar.service('Gouncer', require('./gouncer/GouncerService'));

},{"./aliases":11,"./config":12,"./controller/BaseController":13,"./controller/EditController":14,"./gouncer/GouncerService":15,"./http/HttpInterceptor":16,"./http/Request":17,"./http/Resource":18,"./http/Security":19,"./people":21,"./session/User":22,"./util/Text":23,"./util/document":24,"./util/jsonText":25,"angular":"angular"}],21:[function(require,module,exports){
'use strict';

// http://api.npolar.no/person/?q=&format=json&fields=email,first_name,last_name,orgtree&variant=array&sort=email&limit=all

var people = [{ "first_name": "Agneta", "email": "agneta.fransson@npolar.no", "last_name": "Fransson", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Aleksander", "email": "aleksander.eriksen@npolar.no", "last_name": "Eriksen", "orgtree": ["/ola/troll/"] }, { "first_name": "Alexandra", "email": "alex.messerli@npolar.no", "last_name": "Messerli", "orgtree": ["/forskning/geo/"] }, { "first_name": "Alexey", "email": "alexey.pavlov@npolar.no", "last_name": "Pavlov", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Alice", "email": "alice.trevail@npolar.no", "last_name": "Trevail", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Aline", "email": "aline.arriola@npolar.no", "last_name": "Arriola", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Alistair", "email": "alistair.everett@npolar.no", "last_name": "Everett", "orgtree": ["/forskning/geo/"] }, { "first_name": "Allison", "email": "allison.bailey@npolar.no", "last_name": "Bailey", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Amalie", "email": "amalie.ask@npolar.no", "last_name": "Ask", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Amélie", "email": "amelie.meyer@npolar.no", "last_name": "Meyer", "orgtree": ["/forskning/havkryo"] }, { "first_name": "Anders", "email": "anders.balter@npolar.no", "last_name": "Bälter", "orgtree": ["/mika/data/"] }, { "first_name": "Anders", "email": "anders.skoglund@npolar.no", "last_name": "Skoglund", "orgtree": ["/mika/kart/", "/forskning/ice/okosystemer/"] }, { "first_name": "Andrew", "email": "andrew.lowther@npolar.no", "last_name": "Lowther", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Anette", "email": "anette.wold@npolar.no", "last_name": "Wold", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Angelika H.H.", "email": "angelika.renner@npolar.no", "last_name": "Renner", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Anja", "email": "anja.diez@npolar.no", "last_name": "Diez", "orgtree": ["/forskning/geo/"] }, { "first_name": "Anja", "email": "anja.rosel@npolar.no", "last_name": "Rösel", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Ankit", "email": "ankit.pramanik@npolar.no", "last_name": "Pramanik", "orgtree": ["/forskning/geo/"] }, { "first_name": "Ann Elin", "email": "ann.elin.steinsund@npolar.no", "last_name": "Steinsund", "orgtree": ["/admin/ikt/"] }, { "first_name": "Ann Kristin", "email": "ann.kristin.balto@npolar.no", "last_name": "Balto", "orgtree": ["/komm/info/"] }, { "first_name": "Anne-Britt", "email": "anne-britt.hinz@npolar.no", "last_name": "Hinz", "orgtree": ["/komm/info/"] }, { "first_name": "Anne-Cathrine", "email": "anne.cathrine.nilsen@npolar.no", "last_name": "Nilsen", "orgtree": ["/forskning/"] }, { "first_name": "Anne", "email": "anne.kibsgaard@npolar.no", "last_name": "Kibsgaard", "orgtree": ["/admin/personal/"] }, { "first_name": "Anne", "email": "anne.urset@npolar.no", "last_name": "Urset", "orgtree": ["/mika/kart/"] }, { "first_name": "Antonio", "email": "antonio.pereira@npolar.no", "last_name": "Pereira", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Are", "email": "are.bjordal@npolar.no", "last_name": "Bjørdal", "orgtree": ["/mika/data/"] }, { "first_name": "Arild", "email": "arild.sundfjord@npolar.no", "last_name": "Sundfjord", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Arnaud", "email": "arnaud.tarroux@npolar.no", "last_name": "Tarroux", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Arto", "email": "arto.miettinen@npolar.no", "last_name": "Miettinen", "orgtree": ["forskning/geo"] }, { "first_name": "Åshild Ønvik", "email": "ashild.pedersen@npolar.no", "last_name": "Pedersen", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Astrid", "email": "astrid.hogestol@npolar.no", "last_name": "Høgestøl", "orgtree": ["mika/forvaltning/"] }, { "first_name": "Atle", "email": "atle.aasen@npolar.no", "last_name": "Aasen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Audun", "email": "audun.gjerland@npolar.no", "last_name": "Gjerland", "orgtree": ["/ola/arktis/"] }, { "first_name": "Audun", "email": "audun.igesund@npolar.no", "last_name": "Igesund", "orgtree": ["/komm/info/", "/forskning/ice/okosystemer/"] }, { "first_name": "Benjamin", "email": "benjamin.merkel@npolar.no", "last_name": "Merkel", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Bernt", "email": "bernt.bye@npolar.no", "last_name": "Bye", "orgtree": ["/mika/kart/"] }, { "first_name": "Bertran", "email": "bertran.kiil@npolar.no", "last_name": "Kiil", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Birgit", "email": "birgit.njaastad@npolar.no", "last_name": "Njåstad", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Bjørn Fossli", "email": "bjorn.fossli.johansen@npolar.no", "last_name": "Johansen", "orgtree": ["/admin/kart/"] }, { "first_name": "Britt", "email": "britt.simones@npolar.no", "last_name": "Simones", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Caixin", "email": "caixin.wang@npolar.no", "last_name": "Wang", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Cecilie H. von", "email": "cecilie.von.quillfeldt@npolar.no", "last_name": "Quillfeldt", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "César", "email": "cesar.deschamps.berger@npolar.no", "last_name": "Deschamps-Berger", "orgtree": ["/forskning/geo/"] }, { "first_name": "Christian", "email": "christian.engelke@npolar.no", "last_name": "Engelke", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Christian", "email": "christian.lydersen@npolar.no", "last_name": "Lydersen", "orgtree": ["/forskning/miljogift/", "/forskning/ice/okosystemer/"] }, { "first_name": "Christiane", "email": "christiane.hubner@npolar.no", "last_name": "Hübner", "orgtree": ["/forskning/"] }, { "first_name": "Christina Alsvik", "email": "christina.pedersen@npolar.no", "last_name": "Pedersen", "orgtree": ["/forskning/"] }, { "first_name": "Conrad", "email": "conrad.helgeland@npolar.no", "last_name": "Helgeland", "orgtree": ["/mika/data/"] }, { "first_name": "Dag", "email": "dag.bolstad@npolar.no", "last_name": "Bolstad", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Dag", "email": "dag.vongraven@npolar.no", "last_name": "Vongraven", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Dierk", "email": "dierk.blomeier@npolar.no", "last_name": "Blomeier", "orgtree": ["/forskning/geo/"] }, { "first_name": "Dmitry", "email": "dmitry.divine@npolar.no", "last_name": "Divine", "orgtree": ["/forskning/geo/"] }, { "first_name": "Dmitry", "email": "dmitry.shcherbin@npolar.no", "last_name": "Shcherbin", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Einar", "email": "einar.johansen@npolar.no", "last_name": "Johansen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Elin Vinje", "email": "elin.vinje.jenssen@npolar.no", "last_name": "Jenssen", "orgtree": ["/komm/info/"] }, { "first_name": "Elinborg", "email": "elinborg.palsdottir@npolar.no", "last_name": "Pålsdottir", "orgtree": ["/forskning/bio/"] }, { "first_name": "Elisabeth", "email": "elisabeth.isaksson@npolar.no", "last_name": "Isaksson", "orgtree": ["/forskning/geo/", "/forskning/ice/fimbul/"] }, { "first_name": "Ellen", "email": "ellen.oseth@npolar.no", "last_name": "Øseth", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Elsa", "email": "elsa.syrstad@npolar.no", "last_name": "Syrstad", "orgtree": ["/admin/personal/"] }, { "first_name": "Erik Warming", "email": "erik.warming.andersen@npolar.no", "last_name": "Andersen", "orgtree": ["/other/clic/"] }, { "first_name": "Erlend", "email": "erlend.lorentzen@npolar.no", "last_name": "Lorentzen", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Ermias Beyene", "email": "ermias.beyene.tesfamariam@npolar.no", "last_name": "Tesfamariam", "orgtree": ["/mika/data/"] }, { "first_name": "Espen", "email": "espen.egeland@npolar.no", "last_name": "Egeland", "orgtree": ["/mika/data/"] }, { "first_name": "Eva Cathrine", "email": "eva.cathrine.hansen@npolar.no", "last_name": "Hansen", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Eva", "email": "eva.fuglei@npolar.no", "last_name": "Fuglei", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Eva", "email": "eva.fuglset@npolar.no", "last_name": "Fuglset", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Evegeny", "email": "evegeny.podolskiy@npolar.no", "last_name": "Podolskiy", "orgtree": ["/forskning/geo/"] }, { "first_name": "Eystein", "email": "eystein.saether@npolar.no", "last_name": "Sæther", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Filip", "email": "filip.heitmann@npolar.no", "last_name": "Heitmann", "orgtree": ["/forskning/"] }, { "first_name": "Fiona S.", "email": "fiona.danks@npolar.no", "last_name": "Danks", "orgtree": ["/forskning/"] }, { "first_name": "Fred Endre", "email": "fred.endre.larsen@npolar.no", "last_name": "Larsen", "orgtree": ["/admin/ikt/"] }, { "first_name": "Fred", "email": "fred.godtliebsen@npolar.no", "last_name": "Godtliebsen", "orgtree": ["/forskning/"] }, { "first_name": "Fredrik", "email": "fredrik.duvohlt.haug@npolar.no", "last_name": "Duvohlt Haug", "orgtree": ["/mika/kart/"] }, { "first_name": "Gary", "email": "gary.griffith@npolar.no", "last_name": "Griffith", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Geir", "email": "geir.andersen@npolar.no", "last_name": "Andersen", "orgtree": ["/admin/", "/leder/"] }, { "first_name": "Geir", "email": "geir.moholdt@npolar.no", "last_name": "Moholdt", "orgtree": ["/forskning/geo"] }, { "first_name": "Geir Ove", "email": "geir.ove.floan@npolar.no", "last_name": "Fløan", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Geir Wing", "email": "geir.wing.gabrielsen@npolar.no", "last_name": "Gabrielsen", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "George", "email": "george.roth@npolar.no", "last_name": "Roth", "orgtree": ["/forskning/geo/"] }, { "first_name": "Gilles", "email": "gilles.guillon@npolar.no", "last_name": "Guillon", "orgtree": ["/ola/arktis/"] }, { "first_name": "Gunn Sissel", "email": "gunn.sissel.jaklin@npolar.no", "last_name": "Jaklin", "orgtree": ["/komm/", "/leder/"] }, { "first_name": "Gunnar", "email": "gunnar.sander@npolar.no", "last_name": "Sander", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Gunnar", "email": "gunnar.spreen@npolar.no", "last_name": "Spreen", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Gwenaelle", "email": "gwenaelle.hamon@npolar.no", "last_name": "Hamon", "orgtree": ["/other/clic/"] }, { "first_name": "Haakon", "email": "haakon.hop@npolar.no", "last_name": "Hop", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Håkon Stensby", "email": "hakon.stensby.sjuls@npolar.no", "last_name": "Sjuls", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Halfdan Helgi", "email": "halfdan.helgi.helgason@npolar.no", "last_name": "Helgason", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Hallgeir", "email": "hallgeir.kvernberg@npolar.no", "last_name": "Kvernberg", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Hallvard", "email": "hallvard.strom@npolar.no", "last_name": "Strøm", "orgtree": ["/forskning/biodiv/", "/forskning/ice/okosystemer/"] }, { "first_name": "Hanna", "email": "hanna.kauko@npolar.no", "last_name": "Kauko", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Hans Erik", "email": "hans.erik.fjeld@npolar.no", "last_name": "Fjeld", "orgtree": ["/forskning/"] }, { "first_name": "Harald Dag", "email": "harald.dag.jolle@npolar.no", "last_name": "Jølle", "orgtree": ["/komm/info/"] }, { "first_name": "Harald Faste", "email": "harald.faste.aas@npolar.no", "last_name": "Aas", "orgtree": ["/mika/kart/"] }, { "first_name": "Harald", "email": "harald.steen@npolar.no", "last_name": "Steen", "orgtree": ["/forskning/", "/forskning/ice/", "/forskning/ice/okosystemer/"] }, { "first_name": "Harvey", "email": "harvey.goodwin@npolar.no", "last_name": "Goodwin", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Håvar", "email": "havar.henriksen@npolar.no", "last_name": "Henriksen", "orgtree": ["admin/ikt/"] }, { "first_name": "Håvard", "email": "havard.hansen@npolar.no", "last_name": "Hansen", "orgtree": ["/ola/arktis/"] }, { "first_name": "Heidi", "email": "heidi.ahonen@npolar.no", "last_name": "Ahonen", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Heidi June", "email": "heidi.june.eklo@npolar.no", "last_name": "Eklo", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Helene", "email": "helene.henriksen@npolar.no", "last_name": "Henriksen", "orgtree": ["/admin/personal/"] }, { "first_name": "Heli", "email": "heli.routti@npolar.no", "last_name": "Routti", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Helle Valborg", "email": "helle.goldman@npolar.no", "last_name": "Goldman", "orgtree": ["/komm/info/"] }, { "first_name": "Ida Kessel", "email": "ida.kessel.nordgard@npolar.no", "last_name": "Nordgård", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Ingeborg", "email": "ingeborg.hallanger@npolar.no", "last_name": "Hallanger", "orgtree": ["/forskning/"] }, { "first_name": "Inger Brattsti", "email": "inger.brattsti.dypas@npolar.no", "last_name": "Dypås", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Inger", "email": "inger.jennings@npolar.no", "last_name": "Jennings", "orgtree": ["/forskning/other/"] }, { "first_name": "Inger Sofia", "email": "inger.sofia.mercadal@npolar.no", "last_name": "Mercadal", "orgtree": ["/ola/arktis/"] }, { "first_name": "Inger", "email": "inger.solheim@npolar.no", "last_name": "Solheim", "orgtree": ["/forskning/support/"] }, { "first_name": "Ingrid", "email": "ingrid.berthinussen@npolar.no", "last_name": "Berthinussen", "orgtree": ["/mika/", "/leder/"] }, { "first_name": "Ingrid", "email": "ingrid.schjelderup@npolar.no", "last_name": "Schjelderup", "orgtree": ["/admin/personal/"] }, { "first_name": "Ingrid", "email": "ingrid.storhaug@npolar.no", "last_name": "Storhaug", "orgtree": ["/forskning/support/"] }, { "first_name": "Ioanna", "email": "ioanna.merkouriadi@npolar.no", "last_name": "Merkouriadi", "orgtree": ["/forskning/geo/"] }, { "first_name": "Isabell", "email": "isabell.eischeid@npolar.no", "last_name": "Eischeid", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Ivar", "email": "ivar.stokkeland@npolar.no", "last_name": "Stokkeland", "orgtree": ["/komm/info/"] }, { "first_name": "Jack", "email": "jack.kohler@npolar.no", "last_name": "Kohler", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Jade", "email": "jade.vacquie.garcia@npolar.no", "last_name": "Vacquie-Garcia", "orgtree": ["/forskning/biodiv"] }, { "first_name": "Jan Erling", "email": "jan.erling.haugland@npolar.no", "last_name": "Haugland", "orgtree": ["/ola/"] }, { "first_name": "Jan-Gunnar", "email": "jan.gunnar.winther@npolar.no", "last_name": "Winther", "orgtree": ["/leder/"] }, { "first_name": "Jan", "email": "jan.roald@npolar.no", "last_name": "Roald", "orgtree": ["/komm/info/"] }, { "first_name": "Janne", "email": "janne.schreuder@npolar.no", "last_name": "Schreuder", "orgtree": ["/komm/info/"] }, { "first_name": "Jannik", "email": "jannik.schultner@npolar.no", "last_name": "Schultner", "orgtree": ["/forskning/miljogift"] }, { "first_name": "Jarl G.", "email": "jarl.pedersen@npolar.no", "last_name": "Pedersen", "orgtree": ["/ola/arktis/"] }, { "first_name": "Jean-Charles", "email": "jean.charles.gallet@npolar.no", "last_name": "Gallet", "orgtree": ["/forskning/geo/"] }, { "first_name": "Jean", "email": "jean.negrel@npolar.no", "last_name": "Negrel", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Jelte", "email": "jelte.van.oostveen@npolar.no", "last_name": "van Oostveen", "orgtree": ["/forskning/geo/"] }, { "first_name": "Jennifer", "email": "jennifer.king@npolar.no", "last_name": "King", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Jennifer", "email": "jennifer.stien@npolar.no", "last_name": "Stien", "orgtree": ["/mika/kart"] }, { "first_name": "Jenny", "email": "jenny.baeseman@npolar.no", "last_name": "Baeseman", "orgtree": ["/other/"] }, { "first_name": "Jens", "email": "jens.abild@npolar.no", "last_name": "Abild", "orgtree": ["/ola/arktis/"] }, { "first_name": "Jim Robert", "email": "jim.robert.johansen@npolar.no", "last_name": "Johansen", "orgtree": ["/ola/arktis/"] }, { "first_name": "Joel", "email": "joel.brown@npolar.no", "last_name": "Brown", "orgtree": ["/forskning/geo/"] }, { "first_name": "Johanna", "email": "johanna.hovinen@npolar.no", "last_name": "Hovinen", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Johannes Pippidis", "email": "johannes.pippidis.lorentzen@npolar.no", "last_name": "Lorentzen", "orgtree": ["mika/data/"] }, { "first_name": "John E.", "email": "john.guldahl@npolar.no", "last_name": "Guldahl", "orgtree": ["/ola/", "/leder/"] }, { "first_name": "John Olav", "email": "john.olav.vinge@npolar.no", "last_name": "Vinge", "orgtree": ["/ola/antarktis/"] }, { "first_name": "John Richard", "email": "john.richard.hansen@npolar.no", "last_name": "Hansen", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Jon", "email": "jon.aars@npolar.no", "last_name": "Aars", "orgtree": ["/forskning/biodiv/", "/forskning/ice/okosystemer/"] }, { "first_name": "Jon Hugo", "email": "jon.hugo.stromseng@npolar.no", "last_name": "Strømseng", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Jørn", "email": "jorn.dybdahl@npolar.no", "last_name": "Dybdahl", "orgtree": ["/ola/arktis/"] }, { "first_name": "Julia", "email": "julia.tchernova@npolar.no", "last_name": "Tchernova", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Kai Bjarne", "email": "kai.bjarne.johannessen@npolar.no", "last_name": "Johannessen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Karen", "email": "karen.lone@npolar.no", "last_name": "Lone", "orgtree": ["/forskning/biodiv"] }, { "first_name": "Kari", "email": "kari.larsen@npolar.no", "last_name": "Larsen", "orgtree": ["/admin/ikt/"] }, { "first_name": "Katrin", "email": "katrin.lindback@npolar.no", "last_name": "Lindbäck", "orgtree": ["/forskning/geo/"] }, { "first_name": "Katrine", "email": "katrine.husum@npolar.no", "last_name": "Husum", "orgtree": ["/forskning/geo/"] }, { "first_name": "Kenichi", "email": "kenichi.matsuoka@npolar.no", "last_name": "Matsuoka", "orgtree": ["/forskning/geo/", "/forskning/ice/"] }, { "first_name": "Kent-Ove", "email": "kent-ove.bolli@npolar.no", "last_name": "Bolli", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Kenth", "email": "kenth.hanssen@npolar.no", "last_name": "Hanssen", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Kim", "email": "kim.holmen@npolar.no", "last_name": "Holmén", "orgtree": ["/lederstab/"] }, { "first_name": "Kit M.", "email": "kit.kovacs@npolar.no", "last_name": "Kovacs", "orgtree": ["/forskning/biodiv/", "/forskning/ice/okosystemer/"] }, { "first_name": "Kjersti", "email": "kjersti.kalhagen@npolar.no", "last_name": "Kalhagen", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Knut Ole", "email": "knut.ole.strysse@npolar.no", "last_name": "Strysse", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Kristen", "email": "kristen.fossan@npolar.no", "last_name": "Fossan", "orgtree": ["/forskning/havkryo/", "/forskning/ice/fimbul/"] }, { "first_name": "Kristin", "email": "kristin.arntzen@npolar.no", "last_name": "Arntzen", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Kristin", "email": "kristin.heggland@npolar.no", "last_name": "Heggland", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Kristin", "email": "kristin.storvik@npolar.no", "last_name": "Storvik", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Lana", "email": "lana.cohen@npolar.no", "last_name": "Cohen", "orgtree": ["/forskning/geo/"] }, { "first_name": "Lars", "email": "lars.dahle@npolar.no", "last_name": "Dahle", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Lasse Mork", "email": "lasse.mork.olsen@npolar.no", "last_name": "Olsen", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Laura", "email": "laura.de.steur@npolar.no", "last_name": "de Steur", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Lawrence", "email": "lawrence.hislop@npolar.no", "last_name": "Hislop", "orgtree": ["/other/clic/"] }, { "first_name": "Leif Arild", "email": "leif.arild.hahjem@npolar.no", "last_name": "Håhjem", "orgtree": ["/forskning/"] }, { "first_name": "Leif Helge", "email": "leif.helge.jensen@npolar.no", "last_name": "Jensen", "orgtree": ["/mika/kart/"] }, { "first_name": "Lisa", "email": "lisa.orme@npolar.no", "last_name": "Orme", "orgtree": ["/forskning/geo/"] }, { "first_name": "Magali", "email": "magali.lucia@npolar.no", "last_name": "Lucia", "orgtree": ["/forskning/miljogift"] }, { "first_name": "Magnus", "email": "magnus.andersen@npolar.no", "last_name": "Andersen", "orgtree": ["/forskning/biodiv/", "/forskning/ice/okosystemer/"] }, { "first_name": "Magnus Hovind", "email": "magnus.hovind.rognhaug@npolar.no", "last_name": "Rognhaug", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Magnus", "email": "magnus.osterlund@npolar.no", "last_name": "Österlund", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Malin", "email": "malin.daase@npolar.no", "last_name": "Daase", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Mar", "email": "mar.fernandez.mendez@npolar.no", "last_name": "Fernández-Méndez", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Mari Katrine", "email": "mari.katrine.berg@npolar.no", "last_name": "Berg", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Maria A.", "email": "maria.granberg@npolar.no", "last_name": "Granberg", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Marianne", "email": "marianne.josefsen@npolar.no", "last_name": "Josefsen", "orgtree": ["/admin/personal/"] }, { "first_name": "Marie-Anne", "email": "marie.anne.blanchet@npolar.no", "last_name": "Blanchet", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Marit Raak", "email": "marit.raak.pettersen@npolar.no", "last_name": "Pettersen", "orgtree": ["/ola/support/"] }, { "first_name": "Marius", "email": "marius.bratrein@npolar.no", "last_name": "Bratrein", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Marta Karoline", "email": "marta.karoline.jansen@npolar.no", "last_name": "Jansen", "orgtree": ["/forskning/"] }, { "first_name": "Marte", "email": "marte.melnes@npolar.no", "last_name": "Melnes", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Marzena", "email": "marzena.kaczmarska@npolar.no", "last_name": "Kaczmarska", "orgtree": ["/forskning/geo/"] }, { "first_name": "Wojtek", "email": "material@npolar.no", "last_name": "Moskal", "orgtree": ["/ola/"] }, { "first_name": "Christian", "email": "material@npolar.no", "last_name": "Zoelly", "orgtree": ["/ola/arktis/"] }, { "first_name": "Mats-Ola", "email": "mats-ola.finn@npolar.no", "last_name": "Finn", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Mats A.", "email": "mats.granskog@npolar.no", "last_name": "Granskog", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Max", "email": "max.koenig@npolar.no", "last_name": "König", "orgtree": ["/mika/data/"] }, { "first_name": "Michael", "email": "michael.greenacre@npolar.no", "last_name": "Greenacre", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Mikhail", "email": "mikhail.itkin@npolar.no", "last_name": "Itkin", "orgtree": ["/mika/data/"] }, { "first_name": "Mikko", "email": "mikko.vihtakari@npolar.no", "last_name": "Vihtakari", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Monica", "email": "monica.votvik@npolar.no", "last_name": "Votvik", "orgtree": ["/ola/arktis/"] }, { "first_name": "Morten", "email": "morten.tryland@npolar.no", "last_name": "Tryland", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Nalân", "email": "nalan.koc@npolar.no", "last_name": "Koç", "orgtree": ["/forskning/", "/leder/"] }, { "first_name": "Nanette", "email": "nanette.verboven@npolar.no", "last_name": "Verboven", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Nikolas", "email": "nikolas.villarroel.cajales@npolar.no", "last_name": "Villarroel Cajales", "orgtree": ["/admin/ikt/"] }, { "first_name": "Nina Mari", "email": "nina.mari.jorgensen@npolar.no", "last_name": "Jørgensen", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Oddvar Syver", "email": "oddvar.horn@npolar.no", "last_name": "Horn", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Oddveig Øien", "email": "oddveig.orvoll@npolar.no", "last_name": "Ørvoll", "orgtree": ["/mika/kart"] }, { "first_name": "Ola", "email": "ola.storro@npolar.no", "last_name": "Storrø", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Olav", "email": "olav.ljokjel@npolar.no", "last_name": "Ljøkjel", "orgtree": ["/forskning/"] }, { "first_name": "Olga", "email": "olga.pavlova@npolar.no", "last_name": "Pavlova", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Øystein", "email": "oystein.mikelborg@npolar.no", "last_name": "Mikelborg", "orgtree": ["/lederstab/"] }, { "first_name": "Øystein", "email": "oystein.overrein@npolar.no", "last_name": "Overrein", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Pål-Yngve", "email": "pal.yngve.lind@npolar.no", "last_name": "Lind", "orgtree": ["/admin/ikt/"] }, { "first_name": "Paul A.", "email": "paul.dodd@npolar.no", "last_name": "Dodd", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Paul-Inge", "email": "paul.inge.flakstad@npolar.no", "last_name": "Flakstad", "orgtree": ["/komm/info/"] }, { "first_name": "Pedro", "email": "pedro.duarte@npolar.no", "last_name": "Duarte", "orgtree": ["/forskning/miljogift"] }, { "first_name": "Per Erik", "email": "per.erik.hanevold@npolar.no", "last_name": "Hanevold", "orgtree": ["/forskning/"] }, { "first_name": "Per Inge", "email": "per.inge.myhre@npolar.no", "last_name": "Myhre", "orgtree": ["/forskning/", "/geo/"] }, { "first_name": "Peter", "email": "peter.thor@npolar.no", "last_name": "Thor", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Petter", "email": "petter.aberg@npolar.no", "last_name": "Åberg", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Philipp", "email": "philipp.assmy@npolar.no", "last_name": "Assmy", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Polona", "email": "polona.itkin@npolar.no", "last_name": "Itkin", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Per Morten", "email": "post@npolar.no", "last_name": "Aarak", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Vegard", "email": "post@npolar.no", "last_name": "Tuven", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Joachim", "email": "post@npolar.no", "last_name": "Jacobs", "orgtree": ["/forskning/geo/"] }, { "first_name": "Alf Ingar", "email": "post@npolar.no", "last_name": "Midtskog", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Ida Elen", "email": "post@npolar.no", "last_name": "Asklund", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Joacim", "email": "post@npolar.no", "last_name": "Bugge", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Marit", "email": "post@npolar.no", "last_name": "Øvstedal", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Ragnhild", "email": "ragnhild.lindberg@npolar.no", "last_name": "Lindberg", "orgtree": ["/admin/personal/"] }, { "first_name": "Reidun", "email": "reidun.ingebrigtsen@npolar.no", "last_name": "Yttergård Ingebrigtsen", "orgtree": ["/admin/personal/"] }, { "first_name": "Remi Aleksander", "email": "remi.aleksander.solas@npolar.no", "last_name": "Solås", "orgtree": ["/mika/data/"] }, { "first_name": "Richard Ashley", "email": "richard.ashley.morris@npolar.no", "last_name": "Morris", "orgtree": ["/forskning/geo/"] }, { "first_name": "Rita", "email": "rita.brannfjell@npolar.no", "last_name": "Brannfjell", "orgtree": ["/ola/"] }, { "first_name": "Robert", "email": "robert.graham@npolar.no", "last_name": "Graham", "orgtree": ["/forskning/geo/"] }, { "first_name": "Roger Willy", "email": "roger.hagerup@npolar.no", "last_name": "Hagerup", "orgtree": ["/mika/kart/"] }, { "first_name": "Rolf", "email": "rolf.kristiansen@npolar.no", "last_name": "Kristiansen", "orgtree": ["/mika/kart/"] }, { "first_name": "Roy B.", "email": "roy.bruun@npolar.no", "last_name": "Bruun", "orgtree": ["/admin/senior/"] }, { "first_name": "Ruben", "email": "ruben.dens@npolar.no", "last_name": "Dens", "orgtree": ["/mika/data/"] }, { "first_name": "Rune", "email": "rune.nilsen@npolar.no", "last_name": "Nilsen", "orgtree": ["/admin/ikt/"] }, { "first_name": "Rune", "email": "rune.stebekk.simonstad@npolar.no", "last_name": "Stebekk Simonstad", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Rune", "email": "rune.svendsen@npolar.no", "last_name": "Svendsen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Rupert", "email": "rupert.krapp@npolar.no", "last_name": "Krapp", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Sabrina", "email": "sabrina.tartu@npolar.no", "last_name": "Tartu", "orgtree": ["/forskning/miljogift"] }, { "first_name": "Sebastian", "email": "sebastian.gerland@npolar.no", "last_name": "Gerland", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Sébastien", "email": "sebastien.descamps@npolar.no", "last_name": "Descamps", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Sigurd", "email": "sigurd.benjaminsen@npolar.no", "last_name": "Benjaminsen", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Siri", "email": "siri.uldal@npolar.no", "last_name": "Uldal", "orgtree": ["/mika/data/"] }, { "first_name": "Sissel Norum", "email": "sissel.norum.hofsoy@npolar.no", "last_name": "Hofsøy", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Sissel", "email": "sissel.olsen@npolar.no", "last_name": "Olsen", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Sophie", "email": "sophie.bourgeon@npolar.no", "last_name": "Bourgeon", "orgtree": ["/forskning/miljogift/"] }, { "first_name": "Stein Ørjan", "email": "stein.orjan.nilsen@npolar.no", "last_name": "Nilsen", "orgtree": ["/mika/forvaltning/"] }, { "first_name": "Stein", "email": "stein.tronstad@npolar.no", "last_name": "Tronstad", "orgtree": ["/mika/data/", "/forskning/ice/havis/", "/forskning/ice/fimbul/"] }, { "first_name": "Steinar", "email": "steinar.aksnes@npolar.no", "last_name": "Aksnes", "orgtree": ["/ola/arktis/"] }, { "first_name": "Stephen R.", "email": "stephen.hudson@npolar.no", "last_name": "Hudson", "orgtree": ["/forskning/geo/", "/forskning/ice/havis/"] }, { "first_name": "Stig", "email": "stig.mathisen@npolar.no", "last_name": "Mathisen", "orgtree": ["/komm/info/"] }, { "first_name": "Stine", "email": "stine.punsvik.olsen@npolar.no", "last_name": "Punsvik Olsen", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Svein", "email": "svein.henriksen@npolar.no", "last_name": "Henriksen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Sven", "email": "sven.lidstrom@npolar.no", "last_name": "Lidström", "orgtree": ["/ola/antarktis/ "] }, { "first_name": "Svetlana", "email": "svetlana.divina@npolar.no", "last_name": "Divina", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Synnøve", "email": "synnove.elvevold@npolar.no", "last_name": "Elvevold", "orgtree": ["/forskning/geo/"] }, { "first_name": "Tamer S.", "email": "tamer.abu.alam@npolar.no", "last_name": "Abu-Alam", "orgtree": ["/forskning/geo/"] }, { "first_name": "Tomas", "email": "tomas.danielsen@npolar.no", "last_name": "Danielsen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Tomas", "email": "tomas.torsvik@npolar.no", "last_name": "Torsvik", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Tor Ivan", "email": "tor.ivan.karlsen@npolar.no", "last_name": "Karlsen", "orgtree": ["/forskning/geo/"] }, { "first_name": "Tor Ytterstad", "email": "tor.ytterstad.hindberg@npolar.no", "last_name": "Hindberg", "orgtree": ["/admin/ikt/"] }, { "first_name": "Tori Flaatten", "email": "tori.flaaten.halvorsen@npolar.no", "last_name": "Halvorsen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Trine", "email": "trine.efraimsen@npolar.no", "last_name": "Efraimsen", "orgtree": ["/admin/okonomi/"] }, { "first_name": "Trond Erik", "email": "trond.erik.dyb@npolar.no", "last_name": "Dyb", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Ulf", "email": "ulf.grotta@npolar.no", "last_name": "Grøtta", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Vigdis", "email": "vigdis.tverberg@npolar.no", "last_name": "Tverberg" }, { "first_name": "Vikram", "email": "vikram.goel@npolar.no", "last_name": "Goel", "orgtree": ["/forskning/geo/"] }, { "first_name": "Virve", "email": "virve.ravolainen@npolar.no", "last_name": "Ravolainen", "orgtree": ["/forskning/biodiv/"] }, { "first_name": "Vladimir", "email": "vladimir.pavlov@npolar.no", "last_name": "Pavlov", "orgtree": ["/forskning/havkryo/", "/forskning/ice/havis/"] }, { "first_name": "Ward", "email": "ward.van.pelt@npolar.no", "last_name": "van Pelt", "orgtree": ["/forskning/geo/"] }, { "first_name": "Winfried K.", "email": "winfried.dallmann@npolar.no", "last_name": "Dallmann", "orgtree": ["/forskning/geo/"] }, { "first_name": "Yngve", "email": "yngve.melvar@npolar.no", "last_name": "Melvær", "orgtree": ["/mika/kart/"] }, { "first_name": "Yoshie", "email": "yoshie.kasajima@npolar.no", "last_name": "Kasajima", "orgtree": ["/forskning/havkryo/"] }, { "first_name": "Andreas", "last_name": "Uglebakken", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Fridjof", "last_name": "Mehlum" }, { "first_name": "Achim", "last_name": "Randelhoff" }, { "first_name": "Einar", "last_name": "Midtgard", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Peter", "last_name": "Järverup", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Geir", "last_name": "Nedgård", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Carmen", "last_name": "Vega", "orgtree": ["/forskning/geo/"] }, { "first_name": "Kent-Jöran", "last_name": "Johansson", "orgtree": ["/ola/antarktis"] }, { "first_name": "Willy Hagen", "last_name": "Larsen", "orgtree": ["/ola/antarktis/"] }, { "first_name": "Mats", "last_name": "Björkman", "orgtree": ["/forskning/"] }];

var npolarPeople = {
  // http://api.npolar.no/person/?q=&format=json&fields=updated&variant=array&sort=-updated&limit=1
  updated: '2017-01-20T11:21:31Z',
  people: people
};

module.exports = npolarPeople;

},{}],22:[function(require,module,exports){
// FIXME This service is misnamed and will probably die (it's just a thin session storage wrapper)
'use strict';

var User = function User(base64, npolarApiConfig) {
  'ngInject';

  var storage = localStorage;

  this.getUser = function () {
    var user = {
      name: null,
      email: null,
      systems: []
    };
    try {
      var storedUser = storage.getItem(this.getStorageKey());
      return JSON.parse(base64.urldecode(storedUser));
    } catch (e) {
      // noop
    }
    return user;
  };

  this.setUser = function (user) {
    var key = this.getStorageKey();
    storage.setItem(key, base64.urlencode(JSON.stringify(user)));
  };

  this.removeUser = function () {
    storage.removeItem(this.getStorageKey());
  };

  this.getStorageKey = function () {
    return 'NpolarApiUser-' + npolarApiConfig.base.split("//")[1];
  };
};
User.$inject = ["base64", "npolarApiConfig"];

module.exports = User;

},{}],23:[function(require,module,exports){
'use strict';

var Texxt = function Texxt() {
  'ngInject';

  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  // Extract the first capture (1) for all regex matches in text
  this.extract = function (text, regex, capture_capture) {

    var extracted = [];
    var m;
    var capture_which_capture = capture_capture || 1;

    while ((m = regex.exec(text)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      extracted.push(m[capture_which_capture]);
    }
    return extracted.filter(onlyUnique);
  };
};

module.exports = Texxt;

},{}],24:[function(require,module,exports){
'use strict';

var Entities = require('special-entities');

var documentUtil = function documentUtil($filter) {
  'ngInject';

  var unescape = function unescape(text) {
    return Entities.normalizeEntities(text, 'utf-8');
  };

  var title = function title(entry) {

    if (!entry) {
      return;
    }
    var t = void 0;
    if (entry.title instanceof Object) {
      t = $filter('i18n')(entry.title);
    } else {
      t = entry.title || entry.name || entry.code || entry.id;
    }
    return unescape(t);
  };

  return {
    title: title
  };
};
documentUtil.$inject = ["$filter"];

module.exports = documentUtil;

},{"special-entities":81}],25:[function(require,module,exports){
/**
 * Adapted from [Stackoverflow?]...
 *
 */
'use strict';

var jsonText = function jsonText() {
  'ngInject';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attr, ngModel) {
      function into(input) {
        //console.log(JSON.parse(input));
        return JSON.parse(input);
      }
      function out(data) {
        return JSON.stringify(data);
      }
      ngModel.$parsers.push(into);
      ngModel.$formatters.push(out);
    }
  };
};

module.exports = jsonText;

},{}],26:[function(require,module,exports){
'use strict';

var EventEmitter = require('events').EventEmitter;

var Message = function Message() {
  'ngInject';

  var washError = function washError(error) {
    if (error) {
      error = error.replace('_', ' ');
      error = error.charAt(0).toUpperCase() + error.slice(1);
    }
    return error;
  };

  var apiError = function apiError(error) {
    return error ? error.explanation : undefined;
  };

  var couchError = function couchError(error) {
    return error.error && error.reason ? washError(error.error) : undefined;
  };

  this.getMessage = function (response) {

    var time = new Date(Date.now()).toJSON();
    var message = void 0;

    if (response.body && response.body.time) {
      time = response.body.time;
    }

    if (0 === response.status) {
      message = 'HTTP ' + response.config.method + ' to Npolar API ' + response.config.url + ' failed with status: 0';
    } else if (response.body) {
      message = apiError(response.body.error) || couchError(response.body) || response.body.reason || response.body.error || response.body;
    }

    return { status: response.status,
      method: response.config.method,
      uri: response.config.url,
      headers: response.headers(),
      time: time,
      message: message
    };
  };

  this.info = function (data) {
    this.emit('npolar-info', data);
  };

  this.error = function (data) {
    this.emit('npolar-error', data);
  };

  this.apiInfo = function (data) {
    this.emit('npolar-api-info', data);
  };

  this.apiError = function (data) {
    this.emit('npolar-api-error', data);
  };

  this.login = function (data) {
    this.emit('npolar-login', data);
  };

  this.logout = function (data) {
    this.emit('npolar-logout', data);
  };

  return Object.assign(new EventEmitter(), this);
};

module.exports = Message;

},{"events":62}],27:[function(require,module,exports){
'use strict';

var angular = require('angular');

require('angular-resource');
require('angular-utf8-base64');
require('angular-jwt');
require('angular-animate');
require('angular-aria');
require('angular-material');
require('angular-route');

var ngNpolar = angular.module('ngNpolar', ['ngResource', 'ngMaterial', 'ngRoute', 'utf8-base64', 'angular-jwt']);

require('./api');
require('./ui');
require('./service');

ngNpolar.factory('NpolarMessage', require('./events/Message'));

// change-a-path-without-reloading-the-controller
// http://stackoverflow.com/a/24102139/1357822
ngNpolar.run(['$route', '$rootScope', '$location', function ($route, $rootScope, $location) {
  var original = $location.search;
  $location.search = function (params, reload) {
    if (reload === false) {
      var lastRoute = $route.current;
      var un = $rootScope.$on('$locationChangeSuccess', function () {
        $route.current = lastRoute;
        un();
      });
    }
    if (params) {
      return original.call($location, params);
    } else {
      return original.call($location);
    }
  };
}]);

},{"./api":20,"./events/Message":26,"./service":29,"./ui":46,"angular":"angular","angular-animate":2,"angular-aria":4,"angular-jwt":6,"angular-material":10,"angular-resource":53,"angular-route":55,"angular-utf8-base64":56}],28:[function(require,module,exports){
"use strict";

module.exports = ["$resource", "npolarApiConfig", function ($resource, npolarApiConfig) {
  'ngInject';

  var TIMEOUT = 20000;

  // Default parameters
  var params = {
    id: null,
    limit: 100,
    format: 'json',
    q: '',
    sort: 'native',
    variant: 'array'
  };

  var headers = {
    Accept: 'application/json'
  };

  var actions = {
    feed: {
      method: 'GET',
      params: params,
      headers: headers,
      cache: true,
      isArray: true,
      timeout: TIMEOUT
    },
    fetch: {
      method: 'GET',
      headers: headers,
      cache: true,
      timeout: TIMEOUT
    }
  };

  var Country = $resource(npolarApiConfig.base + '/country', {}, actions);
  var Language = $resource(npolarApiConfig.base + '/language', {}, actions);

  return {
    countriesByQuery: function countriesByQuery() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return Country.feed({ q: q });
    },
    countryByCode: function countryByCode(code) {
      return Country.fetch({ 'filter-code': code });
    },
    countryByName: function countryByName(name) {
      return Country.fetch({ 'filter-name': name });
    },
    countryByNative: function countryByNative(native) {
      return Country.fetch({ 'filter-native': native });
    },
    languagesByQuery: function languagesByQuery() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      return Language.feed({ q: q });
    },
    languageByCode: function languageByCode(code) {
      return Language.fetch({ 'filter-code': code });
    },
    languageByName: function languageByName(name) {
      return Language.fetch({ 'filter-name': name });
    },
    languageByNative: function languageByNative(native) {
      return Language.fetch({ 'filter-native': native });
    }
  };
}];

},{}],29:[function(require,module,exports){
'use strict';

var angular = require('angular');

var ngNpolar = angular.module('ngNpolar');

ngNpolar.service('npolarCountryService', require('./country/countryService'));

},{"./country/countryService":28,"angular":"angular"}],30:[function(require,module,exports){
'use strict';

LoginController.$inject = ["$scope", "$route", "npolarPeople", "npolarAliases", "Gouncer", "NpolarMessage", "NpolarApiSecurity"];
function LoginController($scope, $route, npolarPeople, npolarAliases, Gouncer, NpolarMessage, NpolarApiSecurity) {
  'ngInject';

  var ctrl = this;

  ctrl.emailFromName = function (name) {
    var people = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : npolarPeople.people;


    var person = (people || []).find(function (p) {
      return (p.first_name + ' ' + p.last_name).toLowerCase() === name.toLowerCase();
    });

    if (person && person.email) {
      return person.email;
    } else {
      return name;
    }
  };

  ctrl.emailFromAlias = function (alias) {
    var aliases = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : npolarAliases;

    var m = (aliases || []).find(function (p) {
      return p.alias && p.alias.includes(alias.toLowerCase()); // assumes aliases ARE already in lowercase
    });
    if (m && m.email) {
      return m.email;
    } else {
      return alias;
    }
  };

  $scope.security = NpolarApiSecurity;

  $scope.error = function () {
    return $scope._error;
  };

  // After login: store user and JWT in local storage
  $scope.onLogin = function (response) {
    NpolarApiSecurity.setJwt(response.data.token);
    NpolarMessage.login(NpolarApiSecurity.getUser());
  };

  $scope.onLoginError = function (response) {
    $route.reload();
  };

  // Login (using username and password)
  $scope.login = function (email, password) {
    // Login using real name
    if (!/@/.test(email)) {
      if (/\s/.test(email)) {
        email = ctrl.emailFromName(email);
      } else {
        email = ctrl.emailFromAlias(email);
      }
    }
    console.log('after', email);
    Gouncer.authenticate(email, password).then($scope.onLogin, $scope.onLoginError);
  };

  $scope.logout = function () {
    NpolarApiSecurity.logout();
    //$route.reload();
  };
}

module.exports = LoginController;

},{}],31:[function(require,module,exports){
'use strict';

var loginLogout = function loginLogout(NpolarApiSecurity, npolarApiConfig, $http) {
  'ngInject';

  return {
    scope: {},
    controller: 'NpolarLoginController',
    templateUrl: 'angular-npolar/src/ui/auth/_user.html',
    link: function link(scope) {

      scope.user = NpolarApiSecurity.getUser();
    }
  };
};
loginLogout.$inject = ["NpolarApiSecurity", "npolarApiConfig", "$http"];

module.exports = loginLogout;

},{}],32:[function(require,module,exports){
'use strict';

module.exports = function () {
  'ngInject';

  // From https://gist.github.com/thomseddon/3511330

  return function (bytes) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;


    if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
      return '';
    }
    var units = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb'];
    var number = Math.floor(Math.log(bytes) / Math.log(1024));

    return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
  };
};

},{}],33:[function(require,module,exports){
'use strict';

module.exports = function () {
  'ngInject';

  return function (input) {
    if (input && /^[0-9]{4}[-][0-9]{2}[-][0-9]{2}T/.test(input)) {
      return input.split("T")[0];
    } else {
      return input;
    }
  };
};

},{}],34:[function(require,module,exports){
'use strict';

module.exports = function () {
  'ngInject';

  return function (texts, prop) {
    if (texts === undefined) {
      return '';
    }
    var text = texts.find(function (t) {
      return t.lang === 'en';
    });
    if (text[prop]) {
      return text[prop];
    } else {
      return texts[0][prop];
    }
  };
};

},{}],35:[function(require,module,exports){
'use strict';

module.exports = ["npolarPeople", "npolarAliases", function (npolarPeople, npolarAliases) {
  'ngInject';

  return function (email) {
    var name = void 0;

    // Alias?
    var a = npolarAliases.find(function (a) {
      return a.alias.includes(email);
    });
    if (a) {
      if (a.name) {
        name = a.name; // Name found
      } else {
        email = a.email; // Lookup in next block
      }
    }

    if (typeof name !== 'string') {
      // Not alias with name property
      // In people <= Person API?
      var p = npolarPeople.people.find(function (p) {
        return p.email === email;
      });
      if (p) {
        if (p.first_name && p.last_name) {
          name = p.first_name + ' ' + p.last_name;
        }
      }
    }

    if (typeof name !== 'string') {
      // Bail out => return input
      name = email;
    }
    return name;
  };
}];

},{}],36:[function(require,module,exports){
'use strict';

module.exports = function () {
  'ngInject';

  return function (input) {
    if (/^\d{4}(\-\d{2}\d{2}T)?/.test(input)) {
      return input.split("-")[0];
    } else {
      return input;
    }
  };
};

},{}],37:[function(require,module,exports){
'use strict';

var tags = require('language-tags');

/**
 * Angular language service
 *
 * For language tags, see
 *
 */
var NpolarLang = function NpolarLang($location, $log, $rootScope, npolarTranslateKeys) {
  'ngInject';

  this.langName = require('./lang-name.json');

  // Get default/fallback language from html@lang
  this.fallback = document.documentElement.getAttribute('lang') || 'en';

  // Available languages
  this.languages = [this.fallback];

  // http://www.iana.org/assignments/language-subtag-registry/language-subtag-registry
  // http://publications.europa.eu/mdr/authority/language/index.html
  // http://standard.difi.no/forvaltningsstandarder/referansekatalogen-html-versjon/#Publisering
  // http://standard.difi.no/filearchive/spraakkoder-presentasjon.pdf
  // Bokmål: nb (ISO 639-1)
  // Nynorsk: nn (ISO 639-1)
  // Nordsamisk: se (ISO 639-1)
  // Lulesamisk: smj (ISO 639-2)
  // Sørsamisk: sma (ISO 639-2)
  // Finsk: fi (ISO 639-1)
  // Kvensk: fkv (ISO 639-3)
  //
  // @return [Array] List of known* language subtags (* known by the application)
  this.getLanguages = function () {
    return this.languages;
  };

  // Counts number of texts in a given language in the current dictionary
  // @return [Object] Example: {"nb":7,"en":7,"ru":1,"eo":1,"nn":1}
  this.getLanguageCounts = function (dictionary) {
    var tkey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : npolarTranslateKeys;

    if (!dictionary) {
      throw new Error("No dictionary provided");
    }
    var l = {};

    dictionary.forEach(function (d) {
      var translations = d[tkey.translations];
      translations.forEach(function (d) {
        var language = d[tkey.language];
        if (!l[language]) {
          l[language] = 1;
        } else {
          l[language]++;
        }
      });
    });
    return l;
  };

  // @return [Array] List of language names
  this.getLanguageNames = function () {
    return this.langName;
  };

  // Set new language, this involves
  // * persisting "NpolarLang" key to local storage
  // * updating location search parameter (?lang={lang})
  // * updating HTML@lang
  // * broadcast "npolar-lang" to root scope
  this.setLang = function (lang) {
    var was = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (lang !== this.getLang()) {
      if (tags.language(lang.split('-')[0])) {

        localStorage.setItem('NpolarLang', lang);
        $location.search(Object.assign($location.search(), {
          lang: lang
        }), false /* prevent reload */);
        document.documentElement.setAttribute('lang', lang);
        $rootScope.$broadcast('npolar-lang', {
          lang: lang, name: this.getNativeName(lang)
        });
      } else {
        $log.warn('Invalid language: ' + lang);
      }
    }
  };

  // Set available languages
  // Currently only used byu the language switcher
  this.setLanguages = function (arr) {
    this.languages = arr;
  };

  // setLanguagesFromDictionaryUse({ min: 0.25, force: ['en', 'nb', 'nn']);
  this.setLanguagesFromDictionaryUse = function () {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { min: 0, dictionary: null, force: [] };

    if (!opt.dictionary || !(opt.dictionary instanceof Array)) {
      // @todo support JSON-LD dictionary object
      throw new Error("No dictionary array provided");
    }
    var dictionary = opt.dictionary;
    var min = opt.min;
    var force = opt.force;

    var langCount = this.getLanguageCounts(dictionary);
    var languages = Object.keys(langCount).sort().filter(function (l) {
      if (force.includes(l)) {
        return false; // filter out forced to avoid duplicates (we add forced below)
      }
      return langCount[l] / dictionary.length > min;
    });
    languages = force.concat(languages).sort();
    this.setLanguages(languages);
  };

  // Get current language
  this.getLang = function () {
    var lang = localStorage.getItem('NpolarLang');

    // 1. From local storage (meaning the user has actively picked this language)
    if (lang) {
      return lang;

      // 2. Or from URI, if present
    } else if ($location.search().lang) {
      return $location.search().lang;

      // 3. Fallback (default is html@lang)
    } else {
      return this.fallback;
    }
  };

  // @todo handle language hierarchy (macrolanguage) and fallback hierarchy based on that
  this.getFallback = function (lang, alternatives) {
    var fallback = this.fallback;

    if (!(alternatives instanceof Array)) {
      alternatives = [fallback];
    }
    // @todo normalise both lang and alterntives array
    // was: alternatives = alternatives.map(a => a.split('-')[0].toLowerCase());

    if (/^n(o|b|n)/i.test(lang)) {
      if (alternatives.includes('nn')) {
        return 'nn';
      } else if (alternatives.includes('nb')) {
        return 'nb';
      } else if (alternatives.includes('no')) {
        return 'no';
      }
    }
    return fallback;
  };

  // @return [String] Native name of lang tag
  this.getNativeName = function (lang) {
    var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLanguageNames();

    lang = lang.split('-')[0];
    if (names && names[lang]) {
      return names[lang].name;
    } else {
      return lang;
    }
  };

  return this;
};
NpolarLang.$inject = ["$location", "$log", "$rootScope", "npolarTranslateKeys"];

module.exports = NpolarLang;

},{"./lang-name.json":41,"language-tags":73}],38:[function(require,module,exports){
'use strict';

/**
 * Angular translation service
 */

var NpolarTranslate = function NpolarTranslate($location, $log, $http, NpolarLang, npolarTranslateKeys, npolarApiConfig) {
  'ngInject';

  // Dictionary object

  this.dictionary = {};

  // Normalize array of translations to JSON-LD [string internationalization](http://www.w3.org/TR/json-ld/#string-internationalization):
  // @return [Array] Array of objects with @language and @value keys
  var normalizeTranslations = function normalizeTranslations(translations) {
    var tkey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : npolarTranslateKeys;

    // Any translations?
    if (translations && translations.length > 0) {

      // Make sure all the matching candidate texts contain the right keys
      return translations.filter(function (cand) {
        return cand[tkey.value] && cand[tkey.language];
      }).map(function (text) {
        return { '@language': text[tkey.language],
          '@value': text[tkey.value],
          bundle: text[tkey.bundle] };
      });
    }
    return false;
  };

  // Normalize dictionary array to dictionary object
  // @return [Object]
  var normalizeDictionary = function normalizeDictionary(dictionary) {
    var tkey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : npolarTranslateKeys;

    var dict = {};

    dictionary.forEach(function (t) {
      var code = t[tkey.lookup];
      var value = normalizeTranslations(t[tkey.translations]);
      // @todo Warn on duplicate codes?
      dict[code] = value;
    });
    return dict;
  };

  var isDebug = function isDebug() {
    return $location.search().debug === '1';
  };

  // Normalize/decorate value
  // @return [String]
  var normalizeValue = function normalizeValue(value, lang, code, orig) {
    if (isDebug()) {
      var l = lang;
      if (lang !== orig) {
        l = lang + ' for ' + orig;
      }
      return code + '[' + l + ']=' + value;
    }
    return value;
  };

  // Get normalized dictionary (object with JSON-LD style translations)
  this.getDictionary = function () {
    return this.dictionary;
  };

  // Set dictionary (auto-detects type and normalizes Array to Object)
  // @param [Array|Object]
  this.setDictionary = function (dictionary) {
    if (dictionary instanceof Array) {
      this.dictionary = normalizeDictionary(dictionary);
    } else {
      this.dictionary = dictionary;
    }
  };

  // Append to dictionary
  // @param [Array|Object]
  this.appendToDictionary = function (dictionary) {
    if (dictionary instanceof Array) {
      dictionary = normalizeDictionary(dictionary);
    }
    this.dictionary = Object.assign(this.dictionary, dictionary);
  };

  // Find first translation document, by looking up code in dictionary
  // @param [String] code
  // @return [Array|false] Normalized translation array (all @language versions)
  this.find = function (code) {
    var dictionary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getDictionary();

    if (dictionary && dictionary instanceof Object && dictionary[code]) {
      return dictionary[code];
    }
    return false;
  };

  // Translates a string by selecting texts matching the lookup code and language tag,
  // Sibling languages (sharing the same macrolanguage) is used if the there is match for code but not the exact language.
  // This function *always* returns a string, even if the code is not found, see #missing
  // @param [String] code
  // @
  // @
  // @return [String] Translation of code into language identified by subtag lang (context)
  this.translate = function (code) {
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NpolarLang.getLang();
    var normalize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : normalizeValue;


    // Find texts by code
    // If found: get translation value for lang and normalize
    var texts = this.find(code);
    if (texts) {
      return this.value(texts, lang, code);
    } else {
      // No matches
      if (isDebug()) {
        $log.warn('0 translations:', code, 'https://data.npolar.no/text/__new?code=' + code);
      }
      return code;
    }
  };

  // Reduce array of translation objects to a single value ie. the translated string
  // Messy signature, but only the 3 first are normlally used by external callers
  // @return [String] Translation
  // @recursive WARNING
  this.value = function (translations, lang, code, // Only used for debug output
  originalLang) {
    var tkey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : npolarTranslateKeys;
    var normalize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : normalizeValue;
    var fallbackLang = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : NpolarLang.getFallback(lang, translations.map(function (t) {
      return t[tkey.language];
    }));


    if (!translations) {
      return;
    }

    if (!originalLang) {
      originalLang = lang;
    }

    // First try the provided lang tag
    // (Notice this may be a fallback language if called in the else block below)
    var exactLangMatch = translations.find(function (cand) {
      return cand[tkey.language].split('-')[0] === lang.split('-')[0];
    });

    if (exactLangMatch) {
      var value = exactLangMatch[tkey.value];
      return normalize(value, lang, code, originalLang);
    } else {
      // No exact match, get fallback translations, ie. those NOT in the requested lang
      var fallbacks = translations.filter(function (cand) {
        return cand[tkey.language].split('-')[0] !== lang.split('-')[0];
      });
      if (fallbacks.length === 1) {
        // Just 1 match, deliver
        return fallbacks[0][tkey.value];
      } else {
        // Multiple callbacks, reduce to one by calling self requesting fallbackLang as new translation language
        // and providing the actual fallbacks as translation array (this blocks infinite recursion)
        return this.value(fallbacks, fallbackLang, code, originalLang, tkey, normalize);
      }
    }
  };

  this.loadBundles = function (bundles) {
    var NpolarTranslate = this;
    var query = bundles;
    if (bundles instanceof Array) {
      query = bundles.join('|');
    }

    $http.get(npolarApiConfig.base + '/text/?q=&filter-bundle=' + query + '&format=json&variant=array&limit=all').then(function (response) {
      NpolarTranslate.appendToDictionary(response.data);
    });
  };

  return this;
};
NpolarTranslate.$inject = ["$location", "$log", "$http", "NpolarLang", "npolarTranslateKeys", "npolarApiConfig"];

module.exports = NpolarTranslate;

},{}],39:[function(require,module,exports){
'use strict';
// Use the i18n filter to get a string from JSON-LD style i18n Array or Object

var i18nFilter = function i18nFilter(NpolarTranslate, NpolarLang) {
  'ngInject';

  var filter = function filter(text) {
    var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NpolarLang.getLang();
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { value: '@value', language: '@language' };

    if (!text) {
      return;
    }

    if (text instanceof Array && text.length > 0) {
      if (text.length > 0) {
        if (text[0][key.value]) {
          return text[0][key.value];
        } else {
          return JSON.stringify(text[0]);
        }
      }
    } else if (text instanceof Object) {
      if (text[language]) {
        return text[language];
      } else {
        var k = Object.keys(text);
        if (k && k[0] && text[k[0]]) {
          return text[k[0]];
        }
      }
    } else if (typeof text === 'string') {
      return NpolarTranslate.translate(text, NpolarLang.getLang());
    }
  };

  //filter.$stateful=true;
  return filter;
};
i18nFilter.$inject = ["NpolarTranslate", "NpolarLang"];
module.exports = i18nFilter;

},{}],40:[function(require,module,exports){
module.exports = '  <md-menu>\n      <md-button class="md-icon-button" ng-click="$mdOpenMenu($event)">\n        <md-icon md-menu-origin>language</md-icon>\n        <md-tooltip>{{ lang.getNativeName(lang.getLang()) }}</md-tooltip>\n      </md-button>\n      <md-menu-content width="6">\n         <div>\n          <md-icon>language</md-icon>\n          \n          {{ \'npdc.menu.Select_language\' | t }} ({{ \'npdc.currently\' | t }} {{ lang.getNativeName(lang.getLang()) }})\n         </div>\n         <div>\n          \n         \n         </div>\n        <md-menu-item ng-repeat="subtag in lang.getLanguages()">\n          <md-button ng-click="lang.setLang(subtag, lang.getLang())">{{ lang.getNativeName(subtag) }}</md-button>\n        </md-menu-item>\n\n      </md-menu-content>\n    </md-menu>';
},{}],41:[function(require,module,exports){
module.exports={
  "ab": {
    "en": "Abkhaz",
    "name": "аҧсуа"
  },
  "aa": {
    "en": "Afar",
    "name": "Afaraf"
  },
  "af": {
    "en": "Afrikaans",
    "name": "Afrikaans"
  },
  "ak": {
    "en": "Akan",
    "name": "Akan"
  },
  "sq": {
    "en": "Albanian",
    "name": "Shqip"
  },
  "am": {
    "en": "Amharic",
    "name": "አማርኛ"
  },
  "ar": {
    "en": "Arabic",
    "name": "العربية"
  },
  "an": {
    "en": "Aragonese",
    "name": "Aragonés"
  },
  "hy": {
    "en": "Armenian",
    "name": "Հայերեն"
  },
  "as": {
    "en": "Assamese",
    "name": "অসমীয়া"
  },
  "av": {
    "en": "Avaric",
    "name": "авар мацӀ, магӀарул мацӀ"
  },
  "ae": {
    "en": "Avestan",
    "name": "avesta"
  },
  "ay": {
    "en": "Aymara",
    "name": "aymar aru"
  },
  "az": {
    "en": "Azerbaijani",
    "name": "azərbaycan dili"
  },
  "bm": {
    "en": "Bambara",
    "name": "bamanankan"
  },
  "ba": {
    "en": "Bashkir",
    "name": "башҡорт теле"
  },
  "eu": {
    "en": "Basque",
    "name": "euskara, euskera"
  },
  "be": {
    "en": "Belarusian",
    "name": "Беларуская"
  },
  "bn": {
    "en": "Bengali",
    "name": "বাংলা"
  },
  "bh": {
    "en": "Bihari",
    "name": "भोजपुरी"
  },
  "bi": {
    "en": "Bislama",
    "name": "Bislama"
  },
  "bs": {
    "en": "Bosnian",
    "name": "bosanski jezik"
  },
  "br": {
    "en": "Breton",
    "name": "brezhoneg"
  },
  "bg": {
    "en": "Bulgarian",
    "name": "български език"
  },
  "my": {
    "en": "Burmese",
    "name": "ဗမာစာ"
  },
  "ca": {
    "en": "Catalan; Valencian",
    "name": "Català"
  },
  "ch": {
    "en": "Chamorro",
    "name": "Chamoru"
  },
  "ce": {
    "en": "Chechen",
    "name": "нохчийн мотт"
  },
  "ny": {
    "en": "Chichewa; Chewa; Nyanja",
    "name": "chiCheŵa, chinyanja"
  },
  "zh": {
    "en": "Chinese",
    "name": "中文 (Zhōngwén), 汉语, 漢語"
  },
  "cv": {
    "en": "Chuvash",
    "name": "чӑваш чӗлхи"
  },
  "kw": {
    "en": "Cornish",
    "name": "Kernewek"
  },
  "co": {
    "en": "Corsican",
    "name": "corsu, lingua corsa"
  },
  "cr": {
    "en": "Cree",
    "name": "ᓀᐦᐃᔭᐍᐏᐣ"
  },
  "hr": {
    "en": "Croatian",
    "name": "hrvatski"
  },
  "cs": {
    "en": "Czech",
    "name": "česky, čeština"
  },
  "da": {
    "en": "Danish",
    "name": "dansk"
  },
  "dv": {
    "en": "Divehi; Dhivehi; Maldivian;",
    "name": "ދިވެހި"
  },
  "nl": {
    "en": "Dutch",
    "name": "Nederlands, Vlaams"
  },
  "en": {
    "en": "English",
    "name": "English"
  },
  "eo": {
    "en": "Esperanto",
    "name": "Esperanto"
  },
  "et": {
    "en": "Estonian",
    "name": "eesti, eesti keel"
  },
  "ee": {
    "en": "Ewe",
    "name": "Eʋegbe"
  },
  "fo": {
    "en": "Faroese",
    "name": "føroyskt"
  },
  "fj": {
    "en": "Fijian",
    "name": "vosa Vakaviti"
  },
  "fi": {
    "en": "Finnish",
    "name": "suomi, suomen kieli"
  },
  "fr": {
    "en": "French",
    "name": "français, langue française"
  },
  "ff": {
    "en": "Fula; Fulah; Pulaar; Pular",
    "name": "Fulfulde, Pulaar, Pular"
  },
  "gl": {
    "en": "Galician",
    "name": "Galego"
  },
  "ka": {
    "en": "Georgian",
    "name": "ქართული"
  },
  "de": {
    "en": "German",
    "name": "Deutsch"
  },
  "el": {
    "en": "Greek, Modern",
    "name": "Ελληνικά"
  },
  "gn": {
    "en": "Guaraní",
    "name": "Avañeẽ"
  },
  "gu": {
    "en": "Gujarati",
    "name": "ગુજરાતી"
  },
  "ht": {
    "en": "Haitian; Haitian Creole",
    "name": "Kreyòl ayisyen"
  },
  "ha": {
    "en": "Hausa",
    "name": "Hausa, هَوُسَ"
  },
  "he": {
    "en": "Hebrew (modern)",
    "name": "עברית"
  },
  "hz": {
    "en": "Herero",
    "name": "Otjiherero"
  },
  "hi": {
    "en": "Hindi",
    "name": "हिन्दी, हिंदी"
  },
  "ho": {
    "en": "Hiri Motu",
    "name": "Hiri Motu"
  },
  "hu": {
    "en": "Hungarian",
    "name": "Magyar"
  },
  "ia": {
    "en": "Interlingua",
    "name": "Interlingua"
  },
  "id": {
    "en": "Indonesian",
    "name": "Bahasa Indonesia"
  },
  "ie": {
    "en": "Interlingue",
    "name": "Originally called Occidental; then Interlingue after WWII"
  },
  "ga": {
    "en": "Irish",
    "name": "Gaeilge"
  },
  "ig": {
    "en": "Igbo",
    "name": "Asụsụ Igbo"
  },
  "ik": {
    "en": "Inupiaq",
    "name": "Iñupiaq, Iñupiatun"
  },
  "io": {
    "en": "Ido",
    "name": "Ido"
  },
  "is": {
    "en": "Icelandic",
    "name": "Íslenska"
  },
  "it": {
    "en": "Italian",
    "name": "Italiano"
  },
  "iu": {
    "en": "Inuktitut",
    "name": "ᐃᓄᒃᑎᑐᑦ"
  },
  "ja": {
    "en": "Japanese",
    "name": "日本語 (にほんご／にっぽんご)"
  },
  "jv": {
    "en": "Javanese",
    "name": "basa Jawa"
  },
  "kl": {
    "en": "Kalaallisut, Greenlandic",
    "name": "kalaallisut, kalaallit oqaasii"
  },
  "kn": {
    "en": "Kannada",
    "name": "ಕನ್ನಡ"
  },
  "kr": {
    "en": "Kanuri",
    "name": "Kanuri"
  },
  "ks": {
    "en": "Kashmiri",
    "name": "कश्मीरी, كشميري‎"
  },
  "kk": {
    "en": "Kazakh",
    "name": "Қазақ тілі"
  },
  "km": {
    "en": "Khmer",
    "name": "ភាសាខ្មែរ"
  },
  "ki": {
    "en": "Kikuyu, Gikuyu",
    "name": "Gĩkũyũ"
  },
  "rw": {
    "en": "Kinyarwanda",
    "name": "Ikinyarwanda"
  },
  "ky": {
    "en": "Kirghiz, Kyrgyz",
    "name": "кыргыз тили"
  },
  "kv": {
    "en": "Komi",
    "name": "коми кыв"
  },
  "kg": {
    "en": "Kongo",
    "name": "KiKongo"
  },
  "ko": {
    "en": "Korean",
    "name": "한국어 (韓國語), 조선말 (朝鮮語)"
  },
  "ku": {
    "en": "Kurdish",
    "name": "Kurdî, كوردی‎"
  },
  "kj": {
    "en": "Kwanyama, Kuanyama",
    "name": "Kuanyama"
  },
  "la": {
    "en": "Latin",
    "name": "latine, lingua latina"
  },
  "lb": {
    "en": "Luxembourgish, Letzeburgesch",
    "name": "Lëtzebuergesch"
  },
  "lg": {
    "en": "Luganda",
    "name": "Luganda"
  },
  "li": {
    "en": "Limburgish, Limburgan, Limburger",
    "name": "Limburgs"
  },
  "ln": {
    "en": "Lingala",
    "name": "Lingála"
  },
  "lo": {
    "en": "Lao",
    "name": "ພາສາລາວ"
  },
  "lt": {
    "en": "Lithuanian",
    "name": "lietuvių kalba"
  },
  "lu": {
    "en": "Luba-Katanga",
    "name": ""
  },
  "lv": {
    "en": "Latvian",
    "name": "latviešu valoda"
  },
  "gv": {
    "en": "Manx",
    "name": "Gaelg, Gailck"
  },
  "mk": {
    "en": "Macedonian",
    "name": "македонски јазик"
  },
  "mg": {
    "en": "Malagasy",
    "name": "Malagasy fiteny"
  },
  "ms": {
    "en": "Malay",
    "name": "bahasa Melayu, بهاس ملايو‎"
  },
  "ml": {
    "en": "Malayalam",
    "name": "മലയാളം"
  },
  "mt": {
    "en": "Maltese",
    "name": "Malti"
  },
  "mi": {
    "en": "Māori",
    "name": "te reo Māori"
  },
  "mr": {
    "en": "Marathi (Marāṭhī)",
    "name": "मराठी"
  },
  "mh": {
    "en": "Marshallese",
    "name": "Kajin M̧ajeļ"
  },
  "mn": {
    "en": "Mongolian",
    "name": "монгол"
  },
  "na": {
    "en": "Nauru",
    "name": "Ekakairũ Naoero"
  },
  "nv": {
    "en": "Navajo, Navaho",
    "name": "Diné bizaad, Dinékʼehǰí"
  },
  "nb": {
    "en": "Norwegian bokmål",
    "name": "Norsk bokmål"
  },
  "nd": {
    "en": "North Ndebele",
    "name": "isiNdebele"
  },
  "ne": {
    "en": "Nepali",
    "name": "नेपाली"
  },
  "ng": {
    "en": "Ndonga",
    "name": "Owambo"
  },
  "nn": {
    "en": "Norwegian nynorsk",
    "name": "Norsk nynorsk"
  },
  "no": {
    "en": "Norwegian",
    "name": "Norsk"
  },
  "ii": {
    "en": "Nuosu",
    "name": "ꆈꌠ꒿ Nuosuhxop"
  },
  "nr": {
    "en": "South Ndebele",
    "name": "isiNdebele"
  },
  "oc": {
    "en": "Occitan",
    "name": "Occitan"
  },
  "oj": {
    "en": "Ojibwe, Ojibwa",
    "name": "ᐊᓂᔑᓈᐯᒧᐎᓐ"
  },
  "cu": {
    "en": "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic",
    "name": "ѩзыкъ словѣньскъ"
  },
  "om": {
    "en": "Oromo",
    "name": "Afaan Oromoo"
  },
  "or": {
    "en": "Oriya",
    "name": "ଓଡ଼ିଆ"
  },
  "os": {
    "en": "Ossetian, Ossetic",
    "name": "ирон æвзаг"
  },
  "pa": {
    "en": "Panjabi, Punjabi",
    "name": "ਪੰਜਾਬੀ, پنجابی‎"
  },
  "pi": {
    "en": "Pāli",
    "name": "पाऴि"
  },
  "fa": {
    "en": "Persian",
    "name": "فارسی"
  },
  "pl": {
    "en": "Polish",
    "name": "polski"
  },
  "ps": {
    "en": "Pashto, Pushto",
    "name": "پښتو"
  },
  "pt": {
    "en": "Portuguese",
    "name": "Português"
  },
  "qu": {
    "en": "Quechua",
    "name": "Runa Simi, Kichwa"
  },
  "rm": {
    "en": "Romansh",
    "name": "rumantsch grischun"
  },
  "rn": {
    "en": "Kirundi",
    "name": "kiRundi"
  },
  "ro": {
    "en": "Romanian, Moldavian, Moldovan",
    "name": "română"
  },
  "ru": {
    "en": "Russian",
    "name": "русский язык"
  },
  "sa": {
    "en": "Sanskrit (Saṁskṛta)",
    "name": "संस्कृतम्"
  },
  "sc": {
    "en": "Sardinian",
    "name": "sardu"
  },
  "sd": {
    "en": "Sindhi",
    "name": "सिन्धी, سنڌي، سندھی‎"
  },
  "se": {
    "en": "Northern Sami",
    "name": "Davvisámegiella"
  },
  "smj": {
    "en": "Lule Sami",
    "name": "_lulesamisk_"
  },
  "sm": {
    "en": "Samoan",
    "name": "gagana faa Samoa"
  },
  "sg": {
    "en": "Sango",
    "name": "yângâ tî sängö"
  },
  "sr": {
    "en": "Serbian",
    "name": "српски језик"
  },
  "gd": {
    "en": "Scottish Gaelic; Gaelic",
    "name": "Gàidhlig"
  },
  "sn": {
    "en": "Shona",
    "name": "chiShona"
  },
  "si": {
    "en": "Sinhala, Sinhalese",
    "name": "සිංහල"
  },
  "sk": {
    "en": "Slovak",
    "name": "slovenčina"
  },
  "sl": {
    "en": "Slovene",
    "name": "slovenščina"
  },
  "so": {
    "en": "Somali",
    "name": "Soomaaliga, af Soomaali"
  },
  "st": {
    "en": "Southern Sotho",
    "name": "Sesotho"
  },
  "es": {
    "en": "Spanish; Castilian",
    "name": "español, castellano"
  },
  "su": {
    "en": "Sundanese",
    "name": "Basa Sunda"
  },
  "sw": {
    "en": "Swahili",
    "name": "Kiswahili"
  },
  "ss": {
    "en": "Swati",
    "name": "SiSwati"
  },
  "sv": {
    "en": "Swedish",
    "name": "svenska"
  },
  "ta": {
    "en": "Tamil",
    "name": "தமிழ்"
  },
  "te": {
    "en": "Telugu",
    "name": "తెలుగు"
  },
  "tg": {
    "en": "Tajik",
    "name": "тоҷикӣ, toğikī, تاجیکی‎"
  },
  "th": {
    "en": "Thai",
    "name": "ไทย"
  },
  "ti": {
    "en": "Tigrinya",
    "name": "ትግርኛ"
  },
  "bo": {
    "en": "Tibetan Standard, Tibetan, Central",
    "name": "བོད་ཡིག"
  },
  "tk": {
    "en": "Turkmen",
    "name": "Türkmen, Түркмен"
  },
  "tl": {
    "en": "Tagalog",
    "name": "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔"
  },
  "tn": {
    "en": "Tswana",
    "name": "Setswana"
  },
  "to": {
    "en": "Tonga (Tonga Islands)",
    "name": "faka Tonga"
  },
  "tr": {
    "en": "Turkish",
    "name": "Türkçe"
  },
  "ts": {
    "en": "Tsonga",
    "name": "Xitsonga"
  },
  "tt": {
    "en": "Tatar",
    "name": "татарча, tatarça, تاتارچا‎"
  },
  "tw": {
    "en": "Twi",
    "name": "Twi"
  },
  "ty": {
    "en": "Tahitian",
    "name": "Reo Tahiti"
  },
  "ug": {
    "en": "Uighur, Uyghur",
    "name": "Uyƣurqə, ئۇيغۇرچە‎"
  },
  "uk": {
    "en": "Ukrainian",
    "name": "українська"
  },
  "ur": {
    "en": "Urdu",
    "name": "اردو"
  },
  "uz": {
    "en": "Uzbek",
    "name": "zbek, Ўзбек, أۇزبېك‎"
  },
  "ve": {
    "en": "Venda",
    "name": "Tshivenḓa"
  },
  "vi": {
    "en": "Vietnamese",
    "name": "Tiếng Việt"
  },
  "vo": {
    "en": "Volapük",
    "name": "Volapük"
  },
  "wa": {
    "en": "Walloon",
    "name": "Walon"
  },
  "cy": {
    "en": "Welsh",
    "name": "Cymraeg"
  },
  "wo": {
    "en": "Wolof",
    "name": "Wollof"
  },
  "fy": {
    "en": "Western Frisian",
    "name": "Frysk"
  },
  "xh": {
    "en": "Xhosa",
    "name": "isiXhosa"
  },
  "yi": {
    "en": "Yiddish",
    "name": "ייִדיש"
  },
  "yo": {
    "en": "Yoruba",
    "name": "Yorùbá"
  },
  "za": {
    "en": "Zhuang, Chuang",
    "name": "Saɯ cueŋƅ, Saw cuengh"
  }
}
},{}],42:[function(require,module,exports){
'use strict';

var langMenuDirective = function langMenuDirective(NpolarLang) {
  'ngInject';

  return {
    //scope: {},
    //controller: '',
    template: require('./lang-menu.html'),
    link: function link(scope) {
      scope.lang = NpolarLang;
    }
  };
};
langMenuDirective.$inject = ["NpolarLang"];

module.exports = langMenuDirective;

},{"./lang-menu.html":40}],43:[function(require,module,exports){
'use strict';

var titleFilter = function titleFilter(NpolarTranslate, NpolarLang) {
  'ngInject';

  var filter = function filter(titles) {
    var tkey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { value: 'title', language: 'lang' };

    if (!titles || titles.length === 0) {
      return;
    }
    // @todo Autodetect keys
    return NpolarTranslate.value(titles, NpolarLang.getLang(), null, null, tkey);
  };

  //filter.$stateful=true;
  return filter;
};
titleFilter.$inject = ["NpolarTranslate", "NpolarLang"];
module.exports = titleFilter;

},{}],44:[function(require,module,exports){
'use strict';

// A simple (but stateful) translation filter (t)

var translateFilter = function translateFilter(NpolarTranslate, NpolarLang) {
  'ngInject';

  var tFilter = function tFilter(code) {
    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NpolarLang.getLang();

    return NpolarTranslate.translate(code, lang);
  };

  tFilter.$stateful = true;
  // A stateful filter is unpure and "strongly discouraged" by https://docs.angularjs.org/guide/filter
  // However this makes usage much easier: the view does not need to provide translation language as filter parameter,
  // *and* translations are auto-updated on lang change

  return tFilter;
};
translateFilter.$inject = ["NpolarTranslate", "NpolarLang"];
module.exports = translateFilter;

},{}],45:[function(require,module,exports){
'use strict';

var translateKeys = {
  value: '@value', // Holds translation
  language: '@language', // Language (2 or 3 letter IANA subtag)
  lookup: 'code', // Lookup code for translation: some.prefix.my_code
  translations: 'texts', // Name of multilingual array holding translations (as objects with language and value keys)
  bundle: 'bundle' // Used by [Text API](http://api.npolar.no/text) to hold multiple instances of the same key, e.g. npdc.app.Title
};
module.exports = translateKeys;

},{}],46:[function(require,module,exports){
'use strict';

var angular = require('angular');

var ngNpolar = angular.module('ngNpolar');

ngNpolar.controller('NpolarLoginController', require('./auth/LoginController'));
ngNpolar.directive('npolarLoginLogout', require('./auth/loginLogoutDirective'));

ngNpolar.controller('NpolarMessageController', require('./message/MessageController'));
ngNpolar.controller('NpolarToastController', require('./message/ToastController'));
ngNpolar.directive('npolarMessage', require('./message/messageDirective'));

ngNpolar.filter('isodate', require('./filters/isodate'));
ngNpolar.filter('year', require('./filters/year'));
ngNpolar.filter('lang', require('./filters/lang'));
ngNpolar.filter('bytes', require('./filters/bytes'));
ngNpolar.filter('name', require('./filters/name'));

//map
ngNpolar.service('NpolarEsriLeaflet', require('./map/esri/NpolarEsriLeaflet'));

// i18n
ngNpolar.service('NpolarLang', require('./i18n/LangService'));
ngNpolar.service('NpolarTranslate', require('./i18n/TranslateService'));
ngNpolar.value('npolarTranslateKeys', require('./i18n/translateKeys'));
ngNpolar.filter('t', require('./i18n/translateFilter'));
ngNpolar.filter('title', require('./i18n/titleFilter'));
ngNpolar.filter('i18n', require('./i18n/i18nFilter'));
ngNpolar.directive('npolarLanguageSwitcher', require('./i18n/langMenuDirective'));

},{"./auth/LoginController":30,"./auth/loginLogoutDirective":31,"./filters/bytes":32,"./filters/isodate":33,"./filters/lang":34,"./filters/name":35,"./filters/year":36,"./i18n/LangService":37,"./i18n/TranslateService":38,"./i18n/i18nFilter":39,"./i18n/langMenuDirective":42,"./i18n/titleFilter":43,"./i18n/translateFilter":44,"./i18n/translateKeys":45,"./map/esri/NpolarEsriLeaflet":47,"./message/MessageController":48,"./message/ToastController":49,"./message/messageDirective":51,"angular":"angular"}],47:[function(require,module,exports){
'use strict';

var L = require('leaflet');
var esri = require('esri-leaflet');

require('proj4leaflet');
require('leaflet-fullscreen');
require('leaflet.heat/dist/leaflet-heat');

// http://kartena.github.io/Proj4Leaflet/examples/wmts/
// http://kartena.github.io/Proj4Leaflet/examples/wmts/script.js
// Using-LDS-XYZ-tile-services-in-Leaflet-and-OpenLayers.pdf

// Inject esri into Leaflet's L
L.esri = esri;
L.Icon.Default.imagePath = '/assets/images';

var NpolarEsriLeaflet = function NpolarEsriLeaflet(NpolarMessage) {
  'ngInject';

  var self = this;

  this.L = function () {
    return L;
  };

  this.epsg = 3857;

  this.element = 'npolar-esri-leaflet-map'; // The map's html element @id

  this.base = '//geodata.npolar.no/arcgis/rest/services';

  this.configFor = function () {
    var area = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Svalbard';
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { epsg: self.epsg, zoom: 0, view: [], element: self.element, area: area };

    var epsg = config.epsg;
    var zoom = config.zoom;
    var view = config.view;
    var element = config.element;

    switch (area) {
      case 'Arktis':
      case 'Arctic':
        epsg = 32661;
        zoom = 2;
        area = 'Arctic';
        view = [75, 0];
        break;

      case 'Svalbard':
        epsg = 25833;
        zoom = 10;
        area = 'Svalbard';
        view = [77.98455, 18.477247];
        break;

      case 'Jan Mayen':
        epsg = 25833;
        zoom = 9;
        area = 'Jan Mayen';
        view = [70.98455, -8.477247];
        break;

      case 'Antarktis':
      case 'Antarctica':
        epsg = 3031;
        zoom = 11;
        area = 'Antarctica';
        view = [-90, 0];
        break;

      case 'Dronning Maud Land':
        epsg = 3031;
        zoom = 6;
        area = 'Dronning Maud Land';
        view = [-75, 0];
        break;

      case 'Peter I Øy':
        epsg = 3857;
        zoom = 11;
        area = 'Peter I Øy';
        view = [-68.82667, -90.721664];
        break;

      case 'Bouvetøya':
        epsg = 3857;
        zoom = 11;
        area = 'Bouvetøya';
        view = [-54.407, 3.3033333];
        break;

      default:
        epsg = 3857;
        zoom = 3;
        area = null;
        view = [0, 0];
    }
    config = { area: area, epsg: epsg, zoom: zoom, view: view, element: element };
    return config;
  };

  self.mapFor = function (area) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.configFor(area);

    return self.mapFactory(self.uri(config));
  };

  self.attributionFor = function (uri) {
    var attr = '<a href="http://npolar.no">Norsk Polarinstitutt</a>';
    if (/server\.arcgisonline\.com/.test(uri)) {
      attr = 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community';
    } else if (/NP_Satellitt/.test(uri)) {
      attr = [attr, '<a href="https://landsat.usgs.gov/ ">USGS</a>', '<a href="https://landsat.gsfc.nasa.gov/">NASA Landsat</a>'];
    }
    return attr;
  };

  this.uri = function () {
    var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { epsg: self.epsg };

    var uri = self.base.replace(/\/$/, '');

    if (arg && arg.epsg) {
      var epsg = parseInt(arg.epsg);
      var _area = arg.area;

      if (epsg === 25833) {
        if (_area === "Svalbard") {
          //uri += `/Basisdata/NP_Basiskart_Svalbard_WMTS_25833/MapServer`;
          uri = '//geodata.npolar.no/arcgis/rest/services/Basisdata/NP_Satellitt_Svalbard_WMTS_25833/MapServer';
        } else if (_area === "Jan Mayen") {
          uri += '/Basisdata/NP_Basiskart_JanMayen_WMTS_25833/MapServer';
        }
      } else if (epsg === 32661) {
        uri += '/Basisdata_Intern/NP_Arktis_WMTS_32661/MapServer';
      } else if (epsg === 53032) {
        uri += '/Basisdata_Intern/NP_Verden_WMTS_53032/MapServer';
      } else if (epsg === 3857) {
        uri = '//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';
      } else if (epsg === 3031) {
        if (_area === "Dronning Maud Land") {
          uri = '//geodata.npolar.no/arcgis/rest/services/Basisdata_Intern/NP_Satellitt_DronningMaudLand_WMTS_3031/MapServer';
        } else {
          uri = '//services.arcgisonline.com/arcgis/rest/services/Polar/Antarctic_Imagery/MapServer/tile/{z}/{y}/{x}';
        }
      } else {
        console.error('Unsupported EPSG ' + epsg);
      }
      console.debug('epsg', epsg, '->', uri);
    }
    return uri;
  };

  // @return instance of Proj4Leaflet CRS (L.Proj.CRS)
  this.crsFactory = function (uri) {
    var crs = void 0;
    var path = uri;

    if (/(WMTS_25833|25833)/.test(path)) {
      crs = self.UTM_33N_CRSFactory();
    } else if (/(WMTS_32661|UPSN|32661)/.test(path)) {
      crs = self.UPSN_CRSFactory();
    } else if (/53032/.test(path)) {
      crs = self.WMTS_53032_CRSFactory();
    } else if (/Antarctic_Imagery|3031/.test(path)) {
      var resolutions = void 0;
      var transformation = void 0;
      if (area === 'Dronning Maud Land') {
        resolutions = [2116.670900008467, 1058.3354500042335, 529.1677250021168, 264.5838625010584, 132.2919312505292, 66.1459656252646, 26.458386250105836, 15.000052916772502, 6.614596562526459];
        transformation = new L.Transformation(1, 30636100, -1, 30636100);
      } else {
        resolutions = [238810.81335399998, 119405.40667699999, 59702.70333849987, 29851.351669250063, 14925.675834625032, 7462.837917312516, 3731.4189586563907, 1865.709479328063, 932.8547396640315, 466.42736983214803, 233.21368491607402, 116.60684245803701, 58.30342122888621, 29.151710614575396, 14.5758553072877, 7.28792765351156, 3.64396382688807, 1.82198191331174, 0.910990956788164, 0.45549547826179, 0.227747739130895, 0.113873869697739, 0.05693693484887, 0.028468467424435];
        transformation = new L.Transformation(1, 33699550.99203, -1, 33699551.01703);
      }
      var crsConfig = {
        resolutions: resolutions,
        transformation: transformation
      };
      crs = new L.Proj.CRS('EPSG:3031', '+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs', crsConfig);
    } else {
      crs = null; //new L.Proj.CRS("EPSG:4326","+proj=longlat +datum=WGS84 +no_defs");
    }
    return crs;
  };

  // Polar stereographic north / WGS84
  // Projection definition for EPSG:32661 from http://epsg.io/32661.js
  // http://jsfiddle.net/12c9vheh/22/
  this.UPSN_CRSFactory = function () {
    var resolutions = [21674.7100160867, 10837.35500804335, 5418.677504021675, 2709.3387520108377, 1354.6693760054188, 677.3346880027094, 338.6673440013547, 169.33367200067735, 84.66683600033868, 42.33341800016934];
    var transformation = new L.Transformation(1, 28567900, -1, 32567900);
    return new L.Proj.CRS('EPSG:32661', '+proj=stere +lat_0=90 +lat_ts=90 +lon_0=0 +k=0.994 +x_0=2000000 +y_0=2000000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs', { transformation: transformation, resolutions: resolutions });
  };

  // UTM zone 33N / ETRS89
  // Projection definition for EPSG:25833 from http://epsg.io/25833.js
  // http://jsfiddle.net/9ozgfLg7/125/
  this.UTM_33N_CRSFactory = function () {
    return new L.Proj.CRS('EPSG:25833', '+proj=utm +zone=33 +ellps=GRS80 +units=m +no_defs', {
      transformation: new L.Transformation(1, 5120900, -1, 9998100),
      resolutions: [21674.7100160867, 10837.35500804335, 5418.677504021675, 2709.3387520108377, 1354.6693760054188, 677.3346880027094, 338.6673440013547, 169.33367200067735, 84.66683600033868, 42.33341800016934, 21.16670900008467, 10.583354500042335, 5.291677250021167, 2.6458386250105836, 1.3229193125052918, 0.6614596562526459, 0.33072982812632296, 0.16536491406316148]
    });
  };

  // ESRI:53032
  // Sphere Azimuthal Equidistant
  // WARNING: https://osgeo-org.atlassian.net/browse/GEOS-7778
  this.WMTS_53032_CRSFactory = function () {
    console.warn('Do not use, will offset positions, see: https://osgeo-org.atlassian.net/browse/GEOS-7778');
    var resolutions = [173397.6801286936, 86698.8400643468, 43349.4200321734, 21674.7100160867, 10837.35500804335, 5418.677504021675, 2709.3387520108377, 1354.6693760054188, 677.3346880027094, 338.6673440013547];
    var origin = [-21986016.870795302, 21986016.870795317];

    return new L.Proj.CRS('EPSG:53032', // or ESRI:53032?
    '+proj=aeqd +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +a=6371000 +b=6371000 +units=m +no_defs', {
      transformation: new L.Transformation(1, -21986016.870795302, -1, 21986016.870795317),
      resolutions: resolutions,
      origin: origin
    });
  };

  this.esriBaseUri = function () {
    var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { epsg: self.epsg };

    return self.uri(arg);
  };

  this.heatLayerFactory = function (points) {
    var heatConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      minOpacity: 0.9,
      useLocalExtrema: true,
      scaleRadius: true,
      radius: 6
    };

    return L.heatLayer(points, heatConfig);
  };

  this.tileLayerFactory = function () {
    var esriBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.esriBaseUri();
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      url: esriBase,
      //maxZoom: 7,
      //minZoom: 2,
      continuousWorld: true,
      attribution: self.attributionFor(esriBase) };


    return new L.esri.tiledMapLayer(config);
  };

  this.mapFactory = function () {
    var esriBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.esriBaseUri();
    var mapConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      attributionControl: true,
      scrollWheelZoom: true,
      fullscreenControl: true,
      crs: self.crsFactory(esriBase)
    };
    var tileLayerConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;


    if (!(mapConfig.crs instanceof L.Proj.CRS)) {
      delete mapConfig.crs;
    }
    var map = new L.Map(self.element, mapConfig);
    map.addLayer(self.tileLayerFactory(esriBase, tileLayerConfig));

    // Disable zoom handlers.
    map.touchZoom.disable();
    map.doubleClickZoom.disable();
    map.scrollWheelZoom.disable();
    map.keyboard.disable();

    console.debug('NpolarEsriLeaflet.mapFactory L.version', L.version, 'config', mapConfig);

    return map;
  };

  return this;
};
NpolarEsriLeaflet.$inject = ["NpolarMessage"];

module.exports = NpolarEsriLeaflet;

},{"esri-leaflet":61,"leaflet":76,"leaflet-fullscreen":74,"leaflet.heat/dist/leaflet-heat":75,"proj4leaflet":79}],48:[function(require,module,exports){
'use strict';

var MessageController = function MessageController($scope, $mdToast, $timeout, NpolarMessage) {
  'ngInject';

  var tmpl = require('./_message_toast.html');
  var flashError = function flashError(error) {
    $mdToast.show({
      controller: 'NpolarToastController',
      template: tmpl,
      hideDelay: 5000,
      locals: { explanation: error.message || error, msgType: 'error' },
      position: "top left"
    });
  };

  var flashInfo = function flashInfo(message) {
    $mdToast.show({
      controller: 'NpolarToastController',
      template: tmpl,
      hideDelay: 5000,
      locals: { explanation: message, msgType: message.type || 'info' },
      position: "top left"
    });
  };

  NpolarMessage.on("npolar-info", function (message) {
    console.log("<- npolar-info", message);
    flashInfo(message);
  });

  NpolarMessage.on("npolar-api-info", function (response) {
    console.log("<- npolar-api-info", response);
    if ("PUT" === response.method) {
      // "POST" === response.method ||
      var time = new Date(response.time);
      flashInfo('Saved at ' + time.toISOString());
    } else if ("DELETE" === response.method) {
      flashInfo('Deleted document ' + response.uri + ' at ' + response.time);
    }
  });

  NpolarMessage.on("npolar-login", function (user) {
    flashInfo(user.name + ' logged in');
  });

  NpolarMessage.on("npolar-logout", function (user) {
    flashInfo(user.name + ' logged out.' + (user.reason || ''));
  });

  NpolarMessage.on("npolar-error", function (error) {
    console.log("<- npolar-error", error);
    flashError(error);
  });

  NpolarMessage.on("npolar-api-error", function (error) {
    console.log("<- npolar-api-error", error);
    flashError(error);
  });
};
MessageController.$inject = ["$scope", "$mdToast", "$timeout", "NpolarMessage"];

module.exports = MessageController;

},{"./_message_toast.html":50}],49:[function(require,module,exports){
'use strict';

var ToastController = function ToastController($scope, $mdToast, explanation, msgType) {
  'ngInject';

  $scope.explanation = explanation;
  $scope.msgType = msgType;

  $scope.closeToast = function () {
    $mdToast.hide();
  };
};
ToastController.$inject = ["$scope", "$mdToast", "explanation", "msgType"];

module.exports = ToastController;

},{}],50:[function(require,module,exports){
module.exports = '<md-toast class="{{msgType}}">\n  <span flex> <b>{{explanation}}</b></span>\n  <md-button class="md-action" ng-click="closeToast();">OK</md-button>\n</md-toast>\n';
},{}],51:[function(require,module,exports){
'use strict';

var message = function message() {
  'ngInject';

  return {
    scope: {},
    controller: 'NpolarMessageController'
  };
};

module.exports = message;

},{}],52:[function(require,module,exports){
/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

var $resourceMinErr = angular.$$minErr('$resource');

// Helper functions and regex to lookup a dotted path on an object
// stopping at undefined/null.  The path must be composed of ASCII
// identifiers (just like $parse)
var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;

function isValidDottedPath(path) {
  return (path != null && path !== '' && path !== 'hasOwnProperty' &&
      MEMBER_NAME_REGEX.test('.' + path));
}

function lookupDottedPath(obj, path) {
  if (!isValidDottedPath(path)) {
    throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
  }
  var keys = path.split('.');
  for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
    var key = keys[i];
    obj = (obj !== null) ? obj[key] : undefined;
  }
  return obj;
}

/**
 * Create a shallow copy of an object and clear other fields from the destination
 */
function shallowClearAndCopy(src, dst) {
  dst = dst || {};

  angular.forEach(dst, function(value, key) {
    delete dst[key];
  });

  for (var key in src) {
    if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
      dst[key] = src[key];
    }
  }

  return dst;
}

/**
 * @ngdoc module
 * @name ngResource
 * @description
 *
 * # ngResource
 *
 * The `ngResource` module provides interaction support with RESTful services
 * via the $resource service.
 *
 *
 * <div doc-module-components="ngResource"></div>
 *
 * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
 */

/**
 * @ngdoc provider
 * @name $resourceProvider
 *
 * @description
 *
 * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
 * service.
 *
 * ## Dependencies
 * Requires the {@link ngResource } module to be installed.
 *
 */

/**
 * @ngdoc service
 * @name $resource
 * @requires $http
 * @requires ng.$log
 * @requires $q
 * @requires ng.$timeout
 *
 * @description
 * A factory which creates a resource object that lets you interact with
 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
 *
 * The returned resource object has action methods which provide high-level behaviors without
 * the need to interact with the low level {@link ng.$http $http} service.
 *
 * Requires the {@link ngResource `ngResource`} module to be installed.
 *
 * By default, trailing slashes will be stripped from the calculated URLs,
 * which can pose problems with server backends that do not expect that
 * behavior.  This can be disabled by configuring the `$resourceProvider` like
 * this:
 *
 * ```js
     app.config(['$resourceProvider', function($resourceProvider) {
       // Don't strip trailing slashes from calculated URLs
       $resourceProvider.defaults.stripTrailingSlashes = false;
     }]);
 * ```
 *
 * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
 *   `/user/:username`. If you are using a URL with a port number (e.g.
 *   `http://example.com:8080/api`), it will be respected.
 *
 *   If you are using a url with a suffix, just add the suffix, like this:
 *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
 *   or even `$resource('http://example.com/resource/:resource_id.:format')`
 *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
 *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
 *   can escape it with `/\.`.
 *
 * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
 *   `actions` methods. If a parameter value is a function, it will be called every time
 *   a param value needs to be obtained for a request (unless the param was overridden). The function
 *   will be passed the current data value as an argument.
 *
 *   Each key value in the parameter object is first bound to url template if present and then any
 *   excess keys are appended to the url search query after the `?`.
 *
 *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
 *   URL `/path/greet?salutation=Hello`.
 *
 *   If the parameter value is prefixed with `@`, then the value for that parameter will be
 *   extracted from the corresponding property on the `data` object (provided when calling a
 *   "non-GET" action method).
 *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
 *   `someParam` will be `data.someProp`.
 *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
 *   method that does not accept a request body)
 *
 * @param {Object.<Object>=} actions Hash with declaration of custom actions that should extend
 *   the default set of resource actions. The declaration should be created in the format of {@link
 *   ng.$http#usage $http.config}:
 *
 *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
 *        action2: {method:?, params:?, isArray:?, headers:?, ...},
 *        ...}
 *
 *   Where:
 *
 *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
 *     your resource object.
 *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
 *     `DELETE`, `JSONP`, etc).
 *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
 *     the parameter value is a function, it will be called every time when a param value needs to
 *     be obtained for a request (unless the param was overridden). The function will be passed the
 *     current data value as an argument.
 *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
 *     like for the resource-level urls.
 *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
 *     see `returns` section.
 *   - **`transformRequest`** –
 *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
 *     transform function or an array of such functions. The transform function takes the http
 *     request body and headers and returns its transformed (typically serialized) version.
 *     By default, transformRequest will contain one function that checks if the request data is
 *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
 *     `transformRequest` to an empty array: `transformRequest: []`
 *   - **`transformResponse`** –
 *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
 *     transform function or an array of such functions. The transform function takes the http
 *     response body, headers and status and returns its transformed (typically deserialized)
 *     version.
 *     By default, transformResponse will contain one function that checks if the response looks
 *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
 *     set `transformResponse` to an empty array: `transformResponse: []`
 *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
 *     GET request, otherwise if a cache instance built with
 *     {@link ng.$cacheFactory $cacheFactory}, this cache will be used for
 *     caching.
 *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
 *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
 *     **not** supported in $resource, because the same value would be used for multiple requests.
 *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
 *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
 *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
 *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
 *     completed/cancelled request will have no effect.<br />
 *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
 *     XHR object. See
 *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
 *     for more information.
 *   - **`responseType`** - `{string}` - see
 *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
 *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
 *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
 *     with `http response` object. See {@link ng.$http $http interceptors}.
 *
 * @param {Object} options Hash with custom settings that should extend the
 *   default `$resourceProvider` behavior.  The supported options are:
 *
 *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
 *   slashes from any calculated URL will be stripped. (Defaults to true.)
 *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
 *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
 *   This can be overwritten per action. (Defaults to false.)
 *
 * @returns {Object} A resource "class" object with methods for the default set of resource actions
 *   optionally extended with custom `actions`. The default set contains these actions:
 *   ```js
 *   { 'get':    {method:'GET'},
 *     'save':   {method:'POST'},
 *     'query':  {method:'GET', isArray:true},
 *     'remove': {method:'DELETE'},
 *     'delete': {method:'DELETE'} };
 *   ```
 *
 *   Calling these methods invoke an {@link ng.$http} with the specified http method,
 *   destination and parameters. When the data is returned from the server then the object is an
 *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
 *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
 *   read, update, delete) on server-side data like this:
 *   ```js
 *   var User = $resource('/user/:userId', {userId:'@id'});
 *   var user = User.get({userId:123}, function() {
 *     user.abc = true;
 *     user.$save();
 *   });
 *   ```
 *
 *   It is important to realize that invoking a $resource object method immediately returns an
 *   empty reference (object or array depending on `isArray`). Once the data is returned from the
 *   server the existing reference is populated with the actual data. This is a useful trick since
 *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
 *   object results in no rendering, once the data arrives from the server then the object is
 *   populated with the data and the view automatically re-renders itself showing the new data. This
 *   means that in most cases one never has to write a callback function for the action methods.
 *
 *   The action methods on the class object or instance object can be invoked with the following
 *   parameters:
 *
 *   - HTTP GET "class" actions: `Resource.action([parameters], [success], [error])`
 *   - non-GET "class" actions: `Resource.action([parameters], postData, [success], [error])`
 *   - non-GET instance actions:  `instance.$action([parameters], [success], [error])`
 *
 *
 *   Success callback is called with (value (Object|Array), responseHeaders (Function),
 *   status (number), statusText (string)) arguments, where the value is the populated resource
 *   instance or collection object. The error callback is called with (httpResponse) argument.
 *
 *   Class actions return empty instance (with additional properties below).
 *   Instance actions return promise of the action.
 *
 *   The Resource instances and collections have these additional properties:
 *
 *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
 *     instance or collection.
 *
 *     On success, the promise is resolved with the same resource instance or collection object,
 *     updated with data from server. This makes it easy to use in
 *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
 *     rendering until the resource(s) are loaded.
 *
 *     On failure, the promise is rejected with the {@link ng.$http http response} object, without
 *     the `resource` property.
 *
 *     If an interceptor object was provided, the promise will instead be resolved with the value
 *     returned by the interceptor.
 *
 *   - `$resolved`: `true` after first server interaction is completed (either with success or
 *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
 *      data-binding.
 *
 *   The Resource instances and collections have these additional methods:
 *
 *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
 *      collection, calling this method will abort the request.
 *
 *   The Resource instances have these additional methods:
 *
 *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
 *     the Resource API. This object can be serialized through {@link angular.toJson} safely
 *     without attaching Angular-specific fields. Notice that `JSON.stringify` (and
 *     `angular.toJson`) automatically use this method when serializing a Resource instance
 *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON()_behavior)).
 *
 * @example
 *
 * # Credit card resource
 *
 * ```js
     // Define CreditCard class
     var CreditCard = $resource('/user/:userId/card/:cardId',
      {userId:123, cardId:'@id'}, {
       charge: {method:'POST', params:{charge:true}}
      });

     // We can retrieve a collection from the server
     var cards = CreditCard.query(function() {
       // GET: /user/123/card
       // server returns: [ {id:456, number:'1234', name:'Smith'} ];

       var card = cards[0];
       // each item is an instance of CreditCard
       expect(card instanceof CreditCard).toEqual(true);
       card.name = "J. Smith";
       // non GET methods are mapped onto the instances
       card.$save();
       // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
       // server returns: {id:456, number:'1234', name: 'J. Smith'};

       // our custom method is mapped as well.
       card.$charge({amount:9.99});
       // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
     });

     // we can create an instance as well
     var newCard = new CreditCard({number:'0123'});
     newCard.name = "Mike Smith";
     newCard.$save();
     // POST: /user/123/card {number:'0123', name:'Mike Smith'}
     // server returns: {id:789, number:'0123', name: 'Mike Smith'};
     expect(newCard.id).toEqual(789);
 * ```
 *
 * The object returned from this function execution is a resource "class" which has "static" method
 * for each action in the definition.
 *
 * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
 * `headers`.
 *
 * @example
 *
 * # User resource
 *
 * When the data is returned from the server then the object is an instance of the resource type and
 * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
 * operations (create, read, update, delete) on server-side data.

   ```js
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123}, function(user) {
       user.abc = true;
       user.$save();
     });
   ```
 *
 * It's worth noting that the success callback for `get`, `query` and other methods gets passed
 * in the response that came from the server as well as $http header getter function, so one
 * could rewrite the above example and get access to http headers as:
 *
   ```js
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123}, function(user, getResponseHeaders){
       user.abc = true;
       user.$save(function(user, putResponseHeaders) {
         //user => saved user object
         //putResponseHeaders => $http header getter
       });
     });
   ```
 *
 * You can also access the raw `$http` promise via the `$promise` property on the object returned
 *
   ```
     var User = $resource('/user/:userId', {userId:'@id'});
     User.get({userId:123})
         .$promise.then(function(user) {
           $scope.user = user;
         });
   ```
 *
 * @example
 *
 * # Creating a custom 'PUT' request
 *
 * In this example we create a custom method on our resource to make a PUT request
 * ```js
 *    var app = angular.module('app', ['ngResource', 'ngRoute']);
 *
 *    // Some APIs expect a PUT request in the format URL/object/ID
 *    // Here we are creating an 'update' method
 *    app.factory('Notes', ['$resource', function($resource) {
 *    return $resource('/notes/:id', null,
 *        {
 *            'update': { method:'PUT' }
 *        });
 *    }]);
 *
 *    // In our controller we get the ID from the URL using ngRoute and $routeParams
 *    // We pass in $routeParams and our Notes factory along with $scope
 *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
                                      function($scope, $routeParams, Notes) {
 *    // First get a note object from the factory
 *    var note = Notes.get({ id:$routeParams.id });
 *    $id = note.id;
 *
 *    // Now call update passing in the ID first then the object you are updating
 *    Notes.update({ id:$id }, note);
 *
 *    // This will PUT /notes/ID with the note object in the request payload
 *    }]);
 * ```
 *
 * @example
 *
 * # Cancelling requests
 *
 * If an action's configuration specifies that it is cancellable, you can cancel the request related
 * to an instance or collection (as long as it is a result of a "non-instance" call):
 *
   ```js
     // ...defining the `Hotel` resource...
     var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
       // Let's make the `query()` method cancellable
       query: {method: 'get', isArray: true, cancellable: true}
     });

     // ...somewhere in the PlanVacationController...
     ...
     this.onDestinationChanged = function onDestinationChanged(destination) {
       // We don't care about any pending request for hotels
       // in a different destination any more
       this.availableHotels.$cancelRequest();

       // Let's query for hotels in '<destination>'
       // (calls: /api/hotel?location=<destination>)
       this.availableHotels = Hotel.query({location: destination});
     };
   ```
 *
 */
angular.module('ngResource', ['ng']).
  provider('$resource', function ResourceProvider() {
    var PROTOCOL_AND_DOMAIN_REGEX = /^https?:\/\/[^/]*/;

    var provider = this;

    /**
     * @ngdoc property
     * @name $resourceProvider#defaults
     * @description
     * Object containing default options used when creating `$resource` instances.
     *
     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
     * them to further customize your instances. The available properties are:
     *
     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
     *   calculated URL will be stripped.<br />
     *   (Defaults to true.)
     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
     *   resource class or action.<br />
     *   (Defaults to false.)
     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
     *   object or a collection (array) of objects etc. For more details, see
     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
     *   class.<br />
     *   The default actions are:
     *   ```js
     *   {
     *     get: {method: 'GET'},
     *     save: {method: 'POST'},
     *     query: {method: 'GET', isArray: true},
     *     remove: {method: 'DELETE'},
     *     delete: {method: 'DELETE'}
     *   }
     *   ```
     *
     * #### Example
     *
     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions.update = {
     *         method: 'PUT'
     *       };
     *     });
     * ```
     *
     * Or you can even overwrite the whole `actions` list and specify your own:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions = {
     *         create: {method: 'POST'},
     *         get:    {method: 'GET'},
     *         getAll: {method: 'GET', isArray:true},
     *         update: {method: 'PUT'},
     *         delete: {method: 'DELETE'}
     *       };
     *     });
     * ```
     *
     */
    this.defaults = {
      // Strip slashes by default
      stripTrailingSlashes: true,

      // Make non-instance requests cancellable (via `$cancelRequest()`)
      cancellable: false,

      // Default actions configuration
      actions: {
        'get': {method: 'GET'},
        'save': {method: 'POST'},
        'query': {method: 'GET', isArray: true},
        'remove': {method: 'DELETE'},
        'delete': {method: 'DELETE'}
      }
    };

    this.$get = ['$http', '$log', '$q', '$timeout', function($http, $log, $q, $timeout) {

      var noop = angular.noop,
        forEach = angular.forEach,
        extend = angular.extend,
        copy = angular.copy,
        isArray = angular.isArray,
        isDefined = angular.isDefined,
        isFunction = angular.isFunction,
        isNumber = angular.isNumber;

      /**
       * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
       * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set
       * (pchar) allowed in path segments:
       *    segment       = *pchar
       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
       *    pct-encoded   = "%" HEXDIG HEXDIG
       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
       *                     / "*" / "+" / "," / ";" / "="
       */
      function encodeUriSegment(val) {
        return encodeUriQuery(val, true).
          replace(/%26/gi, '&').
          replace(/%3D/gi, '=').
          replace(/%2B/gi, '+');
      }


      /**
       * This method is intended for encoding *key* or *value* parts of query component. We need a
       * custom method because encodeURIComponent is too aggressive and encodes stuff that doesn't
       * have to be encoded per http://tools.ietf.org/html/rfc3986:
       *    query       = *( pchar / "/" / "?" )
       *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
       *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
       *    pct-encoded   = "%" HEXDIG HEXDIG
       *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
       *                     / "*" / "+" / "," / ";" / "="
       */
      function encodeUriQuery(val, pctEncodeSpaces) {
        return encodeURIComponent(val).
          replace(/%40/gi, '@').
          replace(/%3A/gi, ':').
          replace(/%24/g, '$').
          replace(/%2C/gi, ',').
          replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
      }

      function Route(template, defaults) {
        this.template = template;
        this.defaults = extend({}, provider.defaults, defaults);
        this.urlParams = {};
      }

      Route.prototype = {
        setUrlParams: function(config, params, actionUrl) {
          var self = this,
            url = actionUrl || self.template,
            val,
            encodedVal,
            protocolAndDomain = '';

          var urlParams = self.urlParams = {};
          forEach(url.split(/\W/), function(param) {
            if (param === 'hasOwnProperty') {
              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
            }
            if (!(new RegExp('^\\d+$').test(param)) && param &&
              (new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url))) {
              urlParams[param] = {
                isQueryParamValue: (new RegExp('\\?.*=:' + param + '(?:\\W|$)')).test(url)
              };
            }
          });
          url = url.replace(/\\:/g, ':');
          url = url.replace(PROTOCOL_AND_DOMAIN_REGEX, function(match) {
            protocolAndDomain = match;
            return '';
          });

          params = params || {};
          forEach(self.urlParams, function(paramInfo, urlParam) {
            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
            if (isDefined(val) && val !== null) {
              if (paramInfo.isQueryParamValue) {
                encodedVal = encodeUriQuery(val, true);
              } else {
                encodedVal = encodeUriSegment(val);
              }
              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function(match, p1) {
                return encodedVal + p1;
              });
            } else {
              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function(match,
                  leadingSlashes, tail) {
                if (tail.charAt(0) === '/') {
                  return tail;
                } else {
                  return leadingSlashes + tail;
                }
              });
            }
          });

          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
          if (self.defaults.stripTrailingSlashes) {
            url = url.replace(/\/+$/, '') || '/';
          }

          // then replace collapse `/.` if found in the last URL path segment before the query
          // E.g. `http://url.com/id./format?q=x` becomes `http://url.com/id.format?q=x`
          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
          // replace escaped `/\.` with `/.`
          config.url = protocolAndDomain + url.replace(/\/\\\./, '/.');


          // set params - delegate param encoding to $http
          forEach(params, function(value, key) {
            if (!self.urlParams[key]) {
              config.params = config.params || {};
              config.params[key] = value;
            }
          });
        }
      };


      function resourceFactory(url, paramDefaults, actions, options) {
        var route = new Route(url, options);

        actions = extend({}, provider.defaults.actions, actions);

        function extractParams(data, actionParams) {
          var ids = {};
          actionParams = extend({}, paramDefaults, actionParams);
          forEach(actionParams, function(value, key) {
            if (isFunction(value)) { value = value(data); }
            ids[key] = value && value.charAt && value.charAt(0) === '@' ?
              lookupDottedPath(data, value.substr(1)) : value;
          });
          return ids;
        }

        function defaultResponseInterceptor(response) {
          return response.resource;
        }

        function Resource(value) {
          shallowClearAndCopy(value || {}, this);
        }

        Resource.prototype.toJSON = function() {
          var data = extend({}, this);
          delete data.$promise;
          delete data.$resolved;
          delete data.$cancelRequest;
          return data;
        };

        forEach(actions, function(action, name) {
          var hasBody = /^(POST|PUT|PATCH)$/i.test(action.method);
          var numericTimeout = action.timeout;
          var cancellable = isDefined(action.cancellable) ?
              action.cancellable : route.defaults.cancellable;

          if (numericTimeout && !isNumber(numericTimeout)) {
            $log.debug('ngResource:\n' +
                       '  Only numeric values are allowed as `timeout`.\n' +
                       '  Promises are not supported in $resource, because the same value would ' +
                       'be used for multiple requests. If you are looking for a way to cancel ' +
                       'requests, you should use the `cancellable` option.');
            delete action.timeout;
            numericTimeout = null;
          }

          Resource[name] = function(a1, a2, a3, a4) {
            var params = {}, data, success, error;

            switch (arguments.length) {
              case 4:
                error = a4;
                success = a3;
                // falls through
              case 3:
              case 2:
                if (isFunction(a2)) {
                  if (isFunction(a1)) {
                    success = a1;
                    error = a2;
                    break;
                  }

                  success = a2;
                  error = a3;
                  // falls through
                } else {
                  params = a1;
                  data = a2;
                  success = a3;
                  break;
                }
                // falls through
              case 1:
                if (isFunction(a1)) success = a1;
                else if (hasBody) data = a1;
                else params = a1;
                break;
              case 0: break;
              default:
                throw $resourceMinErr('badargs',
                  'Expected up to 4 arguments [params, data, success, error], got {0} arguments',
                  arguments.length);
            }

            var isInstanceCall = this instanceof Resource;
            var value = isInstanceCall ? data : (action.isArray ? [] : new Resource(data));
            var httpConfig = {};
            var responseInterceptor = action.interceptor && action.interceptor.response ||
              defaultResponseInterceptor;
            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError ||
              undefined;
            var timeoutDeferred;
            var numericTimeoutPromise;

            forEach(action, function(value, key) {
              switch (key) {
                default:
                  httpConfig[key] = copy(value);
                  break;
                case 'params':
                case 'isArray':
                case 'interceptor':
                case 'cancellable':
                  break;
              }
            });

            if (!isInstanceCall && cancellable) {
              timeoutDeferred = $q.defer();
              httpConfig.timeout = timeoutDeferred.promise;

              if (numericTimeout) {
                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
              }
            }

            if (hasBody) httpConfig.data = data;
            route.setUrlParams(httpConfig,
              extend({}, extractParams(data, action.params || {}), params),
              action.url);

            var promise = $http(httpConfig).then(function(response) {
              var data = response.data;

              if (data) {
                // Need to convert action.isArray to boolean in case it is undefined
                if (isArray(data) !== (!!action.isArray)) {
                  throw $resourceMinErr('badcfg',
                      'Error in resource configuration for action `{0}`. Expected response to ' +
                      'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object',
                    isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
                }
                if (action.isArray) {
                  value.length = 0;
                  forEach(data, function(item) {
                    if (typeof item === 'object') {
                      value.push(new Resource(item));
                    } else {
                      // Valid JSON values may be string literals, and these should not be converted
                      // into objects. These items will not have access to the Resource prototype
                      // methods, but unfortunately there
                      value.push(item);
                    }
                  });
                } else {
                  var promise = value.$promise;     // Save the promise
                  shallowClearAndCopy(data, value);
                  value.$promise = promise;         // Restore the promise
                }
              }
              response.resource = value;

              return response;
            }, function(response) {
              (error || noop)(response);
              return $q.reject(response);
            });

            promise['finally'](function() {
              value.$resolved = true;
              if (!isInstanceCall && cancellable) {
                value.$cancelRequest = noop;
                $timeout.cancel(numericTimeoutPromise);
                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
              }
            });

            promise = promise.then(
              function(response) {
                var value = responseInterceptor(response);
                (success || noop)(value, response.headers, response.status, response.statusText);
                return value;
              },
              responseErrorInterceptor);

            if (!isInstanceCall) {
              // we are creating instance / collection
              // - set the initial promise
              // - return the instance / collection
              value.$promise = promise;
              value.$resolved = false;
              if (cancellable) value.$cancelRequest = timeoutDeferred.resolve;

              return value;
            }

            // instance call
            return promise;
          };


          Resource.prototype['$' + name] = function(params, success, error) {
            if (isFunction(params)) {
              error = success; success = params; params = {};
            }
            var result = Resource[name].call(this, params, this, success, error);
            return result.$promise || result;
          };
        });

        Resource.bind = function(additionalParamDefaults) {
          var extendedParamDefaults = extend({}, paramDefaults, additionalParamDefaults);
          return resourceFactory(url, extendedParamDefaults, actions, options);
        };

        return Resource;
      }

      return resourceFactory;
    }];
  });


})(window, window.angular);

},{}],53:[function(require,module,exports){
require('./angular-resource');
module.exports = 'ngResource';

},{"./angular-resource":52}],54:[function(require,module,exports){
/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* global shallowCopy: false */

// There are necessary for `shallowCopy()` (included via `src/shallowCopy.js`).
// They are initialized inside the `$RouteProvider`, to ensure `window.angular` is available.
var isArray;
var isObject;

/**
 * @ngdoc module
 * @name ngRoute
 * @description
 *
 * # ngRoute
 *
 * The `ngRoute` module provides routing and deeplinking services and directives for angular apps.
 *
 * ## Example
 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
 *
 *
 * <div doc-module-components="ngRoute"></div>
 */
 /* global -ngRouteModule */
var ngRouteModule = angular.module('ngRoute', ['ng']).
                        provider('$route', $RouteProvider),
    $routeMinErr = angular.$$minErr('ngRoute');

/**
 * @ngdoc provider
 * @name $routeProvider
 * @this
 *
 * @description
 *
 * Used for configuring routes.
 *
 * ## Example
 * See {@link ngRoute.$route#example $route} for an example of configuring and using `ngRoute`.
 *
 * ## Dependencies
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 */
function $RouteProvider() {
  isArray = angular.isArray;
  isObject = angular.isObject;

  function inherit(parent, extra) {
    return angular.extend(Object.create(parent), extra);
  }

  var routes = {};

  /**
   * @ngdoc method
   * @name $routeProvider#when
   *
   * @param {string} path Route path (matched against `$location.path`). If `$location.path`
   *    contains redundant trailing slash or is missing one, the route will still match and the
   *    `$location.path` will be updated to add or drop the trailing slash to exactly match the
   *    route definition.
   *
   *    * `path` can contain named groups starting with a colon: e.g. `:name`. All characters up
   *        to the next slash are matched and stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain named groups starting with a colon and ending with a star:
   *        e.g.`:name*`. All characters are eagerly stored in `$routeParams` under the given `name`
   *        when the route matches.
   *    * `path` can contain optional named groups with a question mark: e.g.`:name?`.
   *
   *    For example, routes like `/color/:color/largecode/:largecode*\/edit` will match
   *    `/color/brown/largecode/code/with/slashes/edit` and extract:
   *
   *    * `color: brown`
   *    * `largecode: code/with/slashes`.
   *
   *
   * @param {Object} route Mapping information to be assigned to `$route.current` on route
   *    match.
   *
   *    Object properties:
   *
   *    - `controller` – `{(string|function()=}` – Controller fn that should be associated with
   *      newly created scope or the name of a {@link angular.Module#controller registered
   *      controller} if passed as a string.
   *    - `controllerAs` – `{string=}` – An identifier name for a reference to the controller.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used by {@link
   *      ngRoute.directive:ngView ngView} or {@link ng.directive:ngInclude ngInclude} directives.
   *      This property takes precedence over `templateUrl`.
   *
   *      If `template` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used by {@link ngRoute.directive:ngView ngView}.
   *
   *      If `templateUrl` is a function, it will be called with the following parameters:
   *
   *      - `{Array.<Object>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route
   *
   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
   *      be injected into the controller. If any of these dependencies are promises, the router
   *      will wait for them all to be resolved or one to be rejected before the controller is
   *      instantiated.
   *      If all the promises are resolved successfully, the values of the resolved promises are
   *      injected and {@link ngRoute.$route#$routeChangeSuccess $routeChangeSuccess} event is
   *      fired. If any of the promises are rejected the
   *      {@link ngRoute.$route#$routeChangeError $routeChangeError} event is fired.
   *      For easier access to the resolved dependencies from the template, the `resolve` map will
   *      be available on the scope of the route, under `$resolve` (by default) or a custom name
   *      specified by the `resolveAs` property (see below). This can be particularly useful, when
   *      working with {@link angular.Module#component components} as route templates.<br />
   *      <div class="alert alert-warning">
   *        **Note:** If your scope already contains a property with this name, it will be hidden
   *        or overwritten. Make sure, you specify an appropriate name for this property, that
   *        does not collide with other properties on the scope.
   *      </div>
   *      The map object is:
   *
   *      - `key` – `{string}`: a name of a dependency to be injected into the controller.
   *      - `factory` - `{string|function}`: If `string` then it is an alias for a service.
   *        Otherwise if function, then it is {@link auto.$injector#invoke injected}
   *        and the return value is treated as the dependency. If the result is a promise, it is
   *        resolved before its value is injected into the controller. Be aware that
   *        `ngRoute.$routeParams` will still refer to the previous route within these resolve
   *        functions.  Use `$route.current.params` to access the new route parameters, instead.
   *
   *    - `resolveAs` - `{string=}` - The name under which the `resolve` map will be available on
   *      the scope of the route. If omitted, defaults to `$resolve`.
   *
   *    - `redirectTo` – `{(string|function())=}` – value to update
   *      {@link ng.$location $location} path with and trigger route redirection.
   *
   *      If `redirectTo` is a function, it will be called with the following parameters:
   *
   *      - `{Object.<string>}` - route parameters extracted from the current
   *        `$location.path()` by applying the current route templateUrl.
   *      - `{string}` - current `$location.path()`
   *      - `{Object}` - current `$location.search()`
   *
   *      The custom `redirectTo` function is expected to return a string which will be used
   *      to update `$location.path()` and `$location.search()`.
   *
   *    - `[reloadOnSearch=true]` - `{boolean=}` - reload route when only `$location.search()`
   *      or `$location.hash()` changes.
   *
   *      If the option is set to `false` and url in the browser changes, then
   *      `$routeUpdate` event is broadcasted on the root scope.
   *
   *    - `[caseInsensitiveMatch=false]` - `{boolean=}` - match routes without being case sensitive
   *
   *      If the option is set to `true`, then the particular route can be matched without being
   *      case sensitive
   *
   * @returns {Object} self
   *
   * @description
   * Adds a new route definition to the `$route` service.
   */
  this.when = function(path, route) {
    //copy original route object to preserve params inherited from proto chain
    var routeCopy = shallowCopy(route);
    if (angular.isUndefined(routeCopy.reloadOnSearch)) {
      routeCopy.reloadOnSearch = true;
    }
    if (angular.isUndefined(routeCopy.caseInsensitiveMatch)) {
      routeCopy.caseInsensitiveMatch = this.caseInsensitiveMatch;
    }
    routes[path] = angular.extend(
      routeCopy,
      path && pathRegExp(path, routeCopy)
    );

    // create redirection for trailing slashes
    if (path) {
      var redirectPath = (path[path.length - 1] === '/')
            ? path.substr(0, path.length - 1)
            : path + '/';

      routes[redirectPath] = angular.extend(
        {redirectTo: path},
        pathRegExp(redirectPath, routeCopy)
      );
    }

    return this;
  };

  /**
   * @ngdoc property
   * @name $routeProvider#caseInsensitiveMatch
   * @description
   *
   * A boolean property indicating if routes defined
   * using this provider should be matched using a case insensitive
   * algorithm. Defaults to `false`.
   */
  this.caseInsensitiveMatch = false;

   /**
    * @param path {string} path
    * @param opts {Object} options
    * @return {?Object}
    *
    * @description
    * Normalizes the given path, returning a regular expression
    * and the original path.
    *
    * Inspired by pathRexp in visionmedia/express/lib/utils.js.
    */
  function pathRegExp(path, opts) {
    var insensitive = opts.caseInsensitiveMatch,
        ret = {
          originalPath: path,
          regexp: path
        },
        keys = ret.keys = [];

    path = path
      .replace(/([().])/g, '\\$1')
      .replace(/(\/)?:(\w+)(\*\?|[?*])?/g, function(_, slash, key, option) {
        var optional = (option === '?' || option === '*?') ? '?' : null;
        var star = (option === '*' || option === '*?') ? '*' : null;
        keys.push({ name: key, optional: !!optional });
        slash = slash || '';
        return ''
          + (optional ? '' : slash)
          + '(?:'
          + (optional ? slash : '')
          + (star && '(.+?)' || '([^/]+)')
          + (optional || '')
          + ')'
          + (optional || '');
      })
      .replace(/([/$*])/g, '\\$1');

    ret.regexp = new RegExp('^' + path + '$', insensitive ? 'i' : '');
    return ret;
  }

  /**
   * @ngdoc method
   * @name $routeProvider#otherwise
   *
   * @description
   * Sets route definition that will be used on route change when no other route definition
   * is matched.
   *
   * @param {Object|string} params Mapping information to be assigned to `$route.current`.
   * If called with a string, the value maps to `redirectTo`.
   * @returns {Object} self
   */
  this.otherwise = function(params) {
    if (typeof params === 'string') {
      params = {redirectTo: params};
    }
    this.when(null, params);
    return this;
  };


  this.$get = ['$rootScope',
               '$location',
               '$routeParams',
               '$q',
               '$injector',
               '$templateRequest',
               '$sce',
      function($rootScope, $location, $routeParams, $q, $injector, $templateRequest, $sce) {

    /**
     * @ngdoc service
     * @name $route
     * @requires $location
     * @requires $routeParams
     *
     * @property {Object} current Reference to the current route definition.
     * The route definition contains:
     *
     *   - `controller`: The controller constructor as defined in the route definition.
     *   - `locals`: A map of locals which is used by {@link ng.$controller $controller} service for
     *     controller instantiation. The `locals` contain
     *     the resolved values of the `resolve` map. Additionally the `locals` also contain:
     *
     *     - `$scope` - The current route scope.
     *     - `$template` - The current route template HTML.
     *
     *     The `locals` will be assigned to the route scope's `$resolve` property. You can override
     *     the property name, using `resolveAs` in the route definition. See
     *     {@link ngRoute.$routeProvider $routeProvider} for more info.
     *
     * @property {Object} routes Object with all route configuration Objects as its properties.
     *
     * @description
     * `$route` is used for deep-linking URLs to controllers and views (HTML partials).
     * It watches `$location.url()` and tries to map the path to an existing route definition.
     *
     * Requires the {@link ngRoute `ngRoute`} module to be installed.
     *
     * You can define routes through {@link ngRoute.$routeProvider $routeProvider}'s API.
     *
     * The `$route` service is typically used in conjunction with the
     * {@link ngRoute.directive:ngView `ngView`} directive and the
     * {@link ngRoute.$routeParams `$routeParams`} service.
     *
     * @example
     * This example shows how changing the URL hash causes the `$route` to match a route against the
     * URL, and the `ngView` pulls in the partial.
     *
     * <example name="$route-service" module="ngRouteExample"
     *          deps="angular-route.js" fixBase="true">
     *   <file name="index.html">
     *     <div ng-controller="MainController">
     *       Choose:
     *       <a href="Book/Moby">Moby</a> |
     *       <a href="Book/Moby/ch/1">Moby: Ch1</a> |
     *       <a href="Book/Gatsby">Gatsby</a> |
     *       <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
     *       <a href="Book/Scarlet">Scarlet Letter</a><br/>
     *
     *       <div ng-view></div>
     *
     *       <hr />
     *
     *       <pre>$location.path() = {{$location.path()}}</pre>
     *       <pre>$route.current.templateUrl = {{$route.current.templateUrl}}</pre>
     *       <pre>$route.current.params = {{$route.current.params}}</pre>
     *       <pre>$route.current.scope.name = {{$route.current.scope.name}}</pre>
     *       <pre>$routeParams = {{$routeParams}}</pre>
     *     </div>
     *   </file>
     *
     *   <file name="book.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *   </file>
     *
     *   <file name="chapter.html">
     *     controller: {{name}}<br />
     *     Book Id: {{params.bookId}}<br />
     *     Chapter Id: {{params.chapterId}}
     *   </file>
     *
     *   <file name="script.js">
     *     angular.module('ngRouteExample', ['ngRoute'])
     *
     *      .controller('MainController', function($scope, $route, $routeParams, $location) {
     *          $scope.$route = $route;
     *          $scope.$location = $location;
     *          $scope.$routeParams = $routeParams;
     *      })
     *
     *      .controller('BookController', function($scope, $routeParams) {
     *          $scope.name = 'BookController';
     *          $scope.params = $routeParams;
     *      })
     *
     *      .controller('ChapterController', function($scope, $routeParams) {
     *          $scope.name = 'ChapterController';
     *          $scope.params = $routeParams;
     *      })
     *
     *     .config(function($routeProvider, $locationProvider) {
     *       $routeProvider
     *        .when('/Book/:bookId', {
     *         templateUrl: 'book.html',
     *         controller: 'BookController',
     *         resolve: {
     *           // I will cause a 1 second delay
     *           delay: function($q, $timeout) {
     *             var delay = $q.defer();
     *             $timeout(delay.resolve, 1000);
     *             return delay.promise;
     *           }
     *         }
     *       })
     *       .when('/Book/:bookId/ch/:chapterId', {
     *         templateUrl: 'chapter.html',
     *         controller: 'ChapterController'
     *       });
     *
     *       // configure html5 to get links working on jsfiddle
     *       $locationProvider.html5Mode(true);
     *     });
     *
     *   </file>
     *
     *   <file name="protractor.js" type="protractor">
     *     it('should load and compile correct template', function() {
     *       element(by.linkText('Moby: Ch1')).click();
     *       var content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller: ChapterController/);
     *       expect(content).toMatch(/Book Id: Moby/);
     *       expect(content).toMatch(/Chapter Id: 1/);
     *
     *       element(by.partialLinkText('Scarlet')).click();
     *
     *       content = element(by.css('[ng-view]')).getText();
     *       expect(content).toMatch(/controller: BookController/);
     *       expect(content).toMatch(/Book Id: Scarlet/);
     *     });
     *   </file>
     * </example>
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeStart
     * @eventType broadcast on root scope
     * @description
     * Broadcasted before a route change. At this  point the route services starts
     * resolving all of the dependencies needed for the route change to occur.
     * Typically this involves fetching the view template as well as any dependencies
     * defined in `resolve` route property. Once  all of the dependencies are resolved
     * `$routeChangeSuccess` is fired.
     *
     * The route change (and the `$location` change that triggered it) can be prevented
     * by calling `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on}
     * for more details about event object.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} next Future route information.
     * @param {Route} current Current route information.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeSuccess
     * @eventType broadcast on root scope
     * @description
     * Broadcasted after a route change has happened successfully.
     * The `resolve` dependencies are now available in the `current.locals` property.
     *
     * {@link ngRoute.directive:ngView ngView} listens for the directive
     * to instantiate the controller and render the view.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {Route} current Current route information.
     * @param {Route|Undefined} previous Previous route information, or undefined if current is
     * first route entered.
     */

    /**
     * @ngdoc event
     * @name $route#$routeChangeError
     * @eventType broadcast on root scope
     * @description
     * Broadcasted if any of the resolve promises are rejected.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current route information.
     * @param {Route} previous Previous route information.
     * @param {Route} rejection Rejection of the promise. Usually the error of the failed promise.
     */

    /**
     * @ngdoc event
     * @name $route#$routeUpdate
     * @eventType broadcast on root scope
     * @description
     * The `reloadOnSearch` property has been set to false, and we are reusing the same
     * instance of the Controller.
     *
     * @param {Object} angularEvent Synthetic event object
     * @param {Route} current Current/previous route information.
     */

    var forceReload = false,
        preparedRoute,
        preparedRouteIsUpdateOnly,
        $route = {
          routes: routes,

          /**
           * @ngdoc method
           * @name $route#reload
           *
           * @description
           * Causes `$route` service to reload the current route even if
           * {@link ng.$location $location} hasn't changed.
           *
           * As a result of that, {@link ngRoute.directive:ngView ngView}
           * creates new scope and reinstantiates the controller.
           */
          reload: function() {
            forceReload = true;

            var fakeLocationEvent = {
              defaultPrevented: false,
              preventDefault: function fakePreventDefault() {
                this.defaultPrevented = true;
                forceReload = false;
              }
            };

            $rootScope.$evalAsync(function() {
              prepareRoute(fakeLocationEvent);
              if (!fakeLocationEvent.defaultPrevented) commitRoute();
            });
          },

          /**
           * @ngdoc method
           * @name $route#updateParams
           *
           * @description
           * Causes `$route` service to update the current URL, replacing
           * current route parameters with those specified in `newParams`.
           * Provided property names that match the route's path segment
           * definitions will be interpolated into the location's path, while
           * remaining properties will be treated as query params.
           *
           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
           */
          updateParams: function(newParams) {
            if (this.current && this.current.$$route) {
              newParams = angular.extend({}, this.current.params, newParams);
              $location.path(interpolate(this.current.$$route.originalPath, newParams));
              // interpolate modifies newParams, only query params are left
              $location.search(newParams);
            } else {
              throw $routeMinErr('norout', 'Tried updating route when with no current route');
            }
          }
        };

    $rootScope.$on('$locationChangeStart', prepareRoute);
    $rootScope.$on('$locationChangeSuccess', commitRoute);

    return $route;

    /////////////////////////////////////////////////////

    /**
     * @param on {string} current url
     * @param route {Object} route regexp to match the url against
     * @return {?Object}
     *
     * @description
     * Check if the route matches the current url.
     *
     * Inspired by match in
     * visionmedia/express/lib/router/router.js.
     */
    function switchRouteMatcher(on, route) {
      var keys = route.keys,
          params = {};

      if (!route.regexp) return null;

      var m = route.regexp.exec(on);
      if (!m) return null;

      for (var i = 1, len = m.length; i < len; ++i) {
        var key = keys[i - 1];

        var val = m[i];

        if (key && val) {
          params[key.name] = val;
        }
      }
      return params;
    }

    function prepareRoute($locationEvent) {
      var lastRoute = $route.current;

      preparedRoute = parseRoute();
      preparedRouteIsUpdateOnly = preparedRoute && lastRoute && preparedRoute.$$route === lastRoute.$$route
          && angular.equals(preparedRoute.pathParams, lastRoute.pathParams)
          && !preparedRoute.reloadOnSearch && !forceReload;

      if (!preparedRouteIsUpdateOnly && (lastRoute || preparedRoute)) {
        if ($rootScope.$broadcast('$routeChangeStart', preparedRoute, lastRoute).defaultPrevented) {
          if ($locationEvent) {
            $locationEvent.preventDefault();
          }
        }
      }
    }

    function commitRoute() {
      var lastRoute = $route.current;
      var nextRoute = preparedRoute;

      if (preparedRouteIsUpdateOnly) {
        lastRoute.params = nextRoute.params;
        angular.copy(lastRoute.params, $routeParams);
        $rootScope.$broadcast('$routeUpdate', lastRoute);
      } else if (nextRoute || lastRoute) {
        forceReload = false;
        $route.current = nextRoute;
        if (nextRoute) {
          if (nextRoute.redirectTo) {
            if (angular.isString(nextRoute.redirectTo)) {
              $location.path(interpolate(nextRoute.redirectTo, nextRoute.params)).search(nextRoute.params)
                       .replace();
            } else {
              $location.url(nextRoute.redirectTo(nextRoute.pathParams, $location.path(), $location.search()))
                       .replace();
            }
          }
        }

        $q.when(nextRoute).
          then(resolveLocals).
          then(function(locals) {
            // after route change
            if (nextRoute === $route.current) {
              if (nextRoute) {
                nextRoute.locals = locals;
                angular.copy(nextRoute.params, $routeParams);
              }
              $rootScope.$broadcast('$routeChangeSuccess', nextRoute, lastRoute);
            }
          }, function(error) {
            if (nextRoute === $route.current) {
              $rootScope.$broadcast('$routeChangeError', nextRoute, lastRoute, error);
            }
          });
      }
    }

    function resolveLocals(route) {
      if (route) {
        var locals = angular.extend({}, route.resolve);
        angular.forEach(locals, function(value, key) {
          locals[key] = angular.isString(value) ?
              $injector.get(value) :
              $injector.invoke(value, null, null, key);
        });
        var template = getTemplateFor(route);
        if (angular.isDefined(template)) {
          locals['$template'] = template;
        }
        return $q.all(locals);
      }
    }


    function getTemplateFor(route) {
      var template, templateUrl;
      if (angular.isDefined(template = route.template)) {
        if (angular.isFunction(template)) {
          template = template(route.params);
        }
      } else if (angular.isDefined(templateUrl = route.templateUrl)) {
        if (angular.isFunction(templateUrl)) {
          templateUrl = templateUrl(route.params);
        }
        if (angular.isDefined(templateUrl)) {
          route.loadedTemplateUrl = $sce.valueOf(templateUrl);
          template = $templateRequest(templateUrl);
        }
      }
      return template;
    }


    /**
     * @returns {Object} the current active route, by matching it against the URL
     */
    function parseRoute() {
      // Match a route
      var params, match;
      angular.forEach(routes, function(route, path) {
        if (!match && (params = switchRouteMatcher($location.path(), route))) {
          match = inherit(route, {
            params: angular.extend({}, $location.search(), params),
            pathParams: params});
          match.$$route = route;
        }
      });
      // No route matched; fallback to "otherwise" route
      return match || routes[null] && inherit(routes[null], {params: {}, pathParams:{}});
    }

    /**
     * @returns {string} interpolation of the redirect path with the parameters
     */
    function interpolate(string, params) {
      var result = [];
      angular.forEach((string || '').split(':'), function(segment, i) {
        if (i === 0) {
          result.push(segment);
        } else {
          var segmentMatch = segment.match(/(\w+)(?:[?*])?(.*)/);
          var key = segmentMatch[1];
          result.push(params[key]);
          result.push(segmentMatch[2] || '');
          delete params[key];
        }
      });
      return result.join('');
    }
  }];
}

ngRouteModule.provider('$routeParams', $RouteParamsProvider);


/**
 * @ngdoc service
 * @name $routeParams
 * @requires $route
 * @this
 *
 * @description
 * The `$routeParams` service allows you to retrieve the current set of route parameters.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * The route parameters are a combination of {@link ng.$location `$location`}'s
 * {@link ng.$location#search `search()`} and {@link ng.$location#path `path()`}.
 * The `path` parameters are extracted when the {@link ngRoute.$route `$route`} path is matched.
 *
 * In case of parameter name collision, `path` params take precedence over `search` params.
 *
 * The service guarantees that the identity of the `$routeParams` object will remain unchanged
 * (but its properties will likely change) even when a route change occurs.
 *
 * Note that the `$routeParams` are only updated *after* a route change completes successfully.
 * This means that you cannot rely on `$routeParams` being correct in route resolve functions.
 * Instead you can use `$route.current.params` to access the new route's parameters.
 *
 * @example
 * ```js
 *  // Given:
 *  // URL: http://server.com/index.html#/Chapter/1/Section/2?search=moby
 *  // Route: /Chapter/:chapterId/Section/:sectionId
 *  //
 *  // Then
 *  $routeParams ==> {chapterId:'1', sectionId:'2', search:'moby'}
 * ```
 */
function $RouteParamsProvider() {
  this.$get = function() { return {}; };
}

ngRouteModule.directive('ngView', ngViewFactory);
ngRouteModule.directive('ngView', ngViewFillContentFactory);


/**
 * @ngdoc directive
 * @name ngView
 * @restrict ECA
 *
 * @description
 * # Overview
 * `ngView` is a directive that complements the {@link ngRoute.$route $route} service by
 * including the rendered template of the current route into the main layout (`index.html`) file.
 * Every time the current route changes, the included view changes with it according to the
 * configuration of the `$route` service.
 *
 * Requires the {@link ngRoute `ngRoute`} module to be installed.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM |
 * | {@link ng.$animate#leave leave}  | when the old element is removed from to the DOM  |
 *
 * The enter and leave animation occur concurrently.
 *
 * @knownIssue If `ngView` is contained in an asynchronously loaded template (e.g. in another
 *             directive's templateUrl or in a template loaded using `ngInclude`), then you need to
 *             make sure that `$route` is instantiated in time to capture the initial
 *             `$locationChangeStart` event and load the appropriate view. One way to achieve this
 *             is to have it as a dependency in a `.run` block:
 *             `myModule.run(['$route', function() {}]);`
 *
 * @scope
 * @priority 400
 * @param {string=} onload Expression to evaluate whenever the view updates.
 *
 * @param {string=} autoscroll Whether `ngView` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the view is updated.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the `autoscroll` attribute value evaluated
 *                    as an expression yields a truthy value.
 * @example
    <example name="ngView-directive" module="ngViewExample"
             deps="angular-route.js;angular-animate.js"
             animations="true" fixBase="true">
      <file name="index.html">
        <div ng-controller="MainCtrl as main">
          Choose:
          <a href="Book/Moby">Moby</a> |
          <a href="Book/Moby/ch/1">Moby: Ch1</a> |
          <a href="Book/Gatsby">Gatsby</a> |
          <a href="Book/Gatsby/ch/4?key=value">Gatsby: Ch4</a> |
          <a href="Book/Scarlet">Scarlet Letter</a><br/>

          <div class="view-animate-container">
            <div ng-view class="view-animate"></div>
          </div>
          <hr />

          <pre>$location.path() = {{main.$location.path()}}</pre>
          <pre>$route.current.templateUrl = {{main.$route.current.templateUrl}}</pre>
          <pre>$route.current.params = {{main.$route.current.params}}</pre>
          <pre>$routeParams = {{main.$routeParams}}</pre>
        </div>
      </file>

      <file name="book.html">
        <div>
          controller: {{book.name}}<br />
          Book Id: {{book.params.bookId}}<br />
        </div>
      </file>

      <file name="chapter.html">
        <div>
          controller: {{chapter.name}}<br />
          Book Id: {{chapter.params.bookId}}<br />
          Chapter Id: {{chapter.params.chapterId}}
        </div>
      </file>

      <file name="animations.css">
        .view-animate-container {
          position:relative;
          height:100px!important;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }

        .view-animate {
          padding:10px;
        }

        .view-animate.ng-enter, .view-animate.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 1.5s;

          display:block;
          width:100%;
          border-left:1px solid black;

          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          padding:10px;
        }

        .view-animate.ng-enter {
          left:100%;
        }
        .view-animate.ng-enter.ng-enter-active {
          left:0;
        }
        .view-animate.ng-leave.ng-leave-active {
          left:-100%;
        }
      </file>

      <file name="script.js">
        angular.module('ngViewExample', ['ngRoute', 'ngAnimate'])
          .config(['$routeProvider', '$locationProvider',
            function($routeProvider, $locationProvider) {
              $routeProvider
                .when('/Book/:bookId', {
                  templateUrl: 'book.html',
                  controller: 'BookCtrl',
                  controllerAs: 'book'
                })
                .when('/Book/:bookId/ch/:chapterId', {
                  templateUrl: 'chapter.html',
                  controller: 'ChapterCtrl',
                  controllerAs: 'chapter'
                });

              $locationProvider.html5Mode(true);
          }])
          .controller('MainCtrl', ['$route', '$routeParams', '$location',
            function MainCtrl($route, $routeParams, $location) {
              this.$route = $route;
              this.$location = $location;
              this.$routeParams = $routeParams;
          }])
          .controller('BookCtrl', ['$routeParams', function BookCtrl($routeParams) {
            this.name = 'BookCtrl';
            this.params = $routeParams;
          }])
          .controller('ChapterCtrl', ['$routeParams', function ChapterCtrl($routeParams) {
            this.name = 'ChapterCtrl';
            this.params = $routeParams;
          }]);

      </file>

      <file name="protractor.js" type="protractor">
        it('should load and compile correct template', function() {
          element(by.linkText('Moby: Ch1')).click();
          var content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller: ChapterCtrl/);
          expect(content).toMatch(/Book Id: Moby/);
          expect(content).toMatch(/Chapter Id: 1/);

          element(by.partialLinkText('Scarlet')).click();

          content = element(by.css('[ng-view]')).getText();
          expect(content).toMatch(/controller: BookCtrl/);
          expect(content).toMatch(/Book Id: Scarlet/);
        });
      </file>
    </example>
 */


/**
 * @ngdoc event
 * @name ngView#$viewContentLoaded
 * @eventType emit on the current ngView scope
 * @description
 * Emitted every time the ngView content is reloaded.
 */
ngViewFactory.$inject = ['$route', '$anchorScroll', '$animate'];
function ngViewFactory($route, $anchorScroll, $animate) {
  return {
    restrict: 'ECA',
    terminal: true,
    priority: 400,
    transclude: 'element',
    link: function(scope, $element, attr, ctrl, $transclude) {
        var currentScope,
            currentElement,
            previousLeaveAnimation,
            autoScrollExp = attr.autoscroll,
            onloadExp = attr.onload || '';

        scope.$on('$routeChangeSuccess', update);
        update();

        function cleanupLastView() {
          if (previousLeaveAnimation) {
            $animate.cancel(previousLeaveAnimation);
            previousLeaveAnimation = null;
          }

          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            previousLeaveAnimation = $animate.leave(currentElement);
            previousLeaveAnimation.done(function(response) {
              if (response !== false) previousLeaveAnimation = null;
            });
            currentElement = null;
          }
        }

        function update() {
          var locals = $route.current && $route.current.locals,
              template = locals && locals.$template;

          if (angular.isDefined(template)) {
            var newScope = scope.$new();
            var current = $route.current;

            // Note: This will also link all children of ng-view that were contained in the original
            // html. If that content contains controllers, ... they could pollute/change the scope.
            // However, using ng-view on an element with additional content does not make sense...
            // Note: We can't remove them in the cloneAttchFn of $transclude as that
            // function is called before linking the content, which would apply child
            // directives to non existing elements.
            var clone = $transclude(newScope, function(clone) {
              $animate.enter(clone, null, currentElement || $element).done(function onNgViewEnter(response) {
                if (response !== false && angular.isDefined(autoScrollExp)
                  && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                  $anchorScroll();
                }
              });
              cleanupLastView();
            });

            currentElement = clone;
            currentScope = current.scope = newScope;
            currentScope.$emit('$viewContentLoaded');
            currentScope.$eval(onloadExp);
          } else {
            cleanupLastView();
          }
        }
    }
  };
}

// This directive is called during the $transclude call of the first `ngView` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngView
// is called.
ngViewFillContentFactory.$inject = ['$compile', '$controller', '$route'];
function ngViewFillContentFactory($compile, $controller, $route) {
  return {
    restrict: 'ECA',
    priority: -400,
    link: function(scope, $element) {
      var current = $route.current,
          locals = current.locals;

      $element.html(locals.$template);

      var link = $compile($element.contents());

      if (current.controller) {
        locals.$scope = scope;
        var controller = $controller(current.controller, locals);
        if (current.controllerAs) {
          scope[current.controllerAs] = controller;
        }
        $element.data('$ngControllerController', controller);
        $element.children().data('$ngControllerController', controller);
      }
      scope[current.resolveAs || '$resolve'] = locals;

      link(scope);
    }
  };
}


})(window, window.angular);

},{}],55:[function(require,module,exports){
require('./angular-route');
module.exports = 'ngRoute';

},{"./angular-route":54}],56:[function(require,module,exports){
'use strict';

function Base64 () {
    angular.module('utf8-base64',[]).constant('base64', (function() {

        /*
         * Encapsulation of Vassilis Petroulias's base64.js library for AngularJS
         * Original notice included below
         */

        /*
         Copyright Vassilis Petroulias [DRDigit]

         Licensed under the Apache License, Version 2.0 (the "License");
         you may not use this file except in compliance with the License.
         You may obtain a copy of the License at

         http://www.apache.org/licenses/LICENSE-2.0

         Unless required by applicable law or agreed to in writing, software
         distributed under the License is distributed on an "AS IS" BASIS,
         WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         See the License for the specific language governing permissions and
         limitations under the License.
         */
        var B64 = {
            alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            lookup: null,
            ie: /MSIE /.test(navigator.userAgent),
            ieo: /MSIE [67]/.test(navigator.userAgent),
            encode: function (s) {
                /* jshint bitwise:false */
                var buffer = B64.toUtf8(s),
                    position = -1,
                    result,
                    len = buffer.length,
                    nan0, nan1, nan2, enc = [, , , ];
                
                if (B64.ie) {
                    result = [];
                    while (++position < len) {
                        nan0 = buffer[position];
                        nan1 = buffer[++position];
                        enc[0] = nan0 >> 2;
                        enc[1] = ((nan0 & 3) << 4) | (nan1 >> 4);
                        if (isNaN(nan1))
                            enc[2] = enc[3] = 64;
                        else {
                            nan2 = buffer[++position];
                            enc[2] = ((nan1 & 15) << 2) | (nan2 >> 6);
                            enc[3] = (isNaN(nan2)) ? 64 : nan2 & 63;
                        }
                        result.push(B64.alphabet.charAt(enc[0]), B64.alphabet.charAt(enc[1]), B64.alphabet.charAt(enc[2]), B64.alphabet.charAt(enc[3]));
                    }
                    return result.join('');
                } else {
                    result = '';
                    while (++position < len) {
                        nan0 = buffer[position];
                        nan1 = buffer[++position];
                        enc[0] = nan0 >> 2;
                        enc[1] = ((nan0 & 3) << 4) | (nan1 >> 4);
                        if (isNaN(nan1))
                            enc[2] = enc[3] = 64;
                        else {
                            nan2 = buffer[++position];
                            enc[2] = ((nan1 & 15) << 2) | (nan2 >> 6);
                            enc[3] = (isNaN(nan2)) ? 64 : nan2 & 63;
                        }
                        result += B64.alphabet[enc[0]] + B64.alphabet[enc[1]] + B64.alphabet[enc[2]] + B64.alphabet[enc[3]];
                    }
                    return result;
                }
            },
            decode: function (s) {
                /* jshint bitwise:false */
                s = s.replace(/\s/g, '');
                if (s.length % 4)
                    throw new Error('InvalidLengthError: decode failed: The string to be decoded is not the correct length for a base64 encoded string.');
                if(/[^A-Za-z0-9+\/=\s]/g.test(s))
                    throw new Error('InvalidCharacterError: decode failed: The string contains characters invalid in a base64 encoded string.');

                var buffer = B64.fromUtf8(s),
                    position = 0,
                    result,
                    len = buffer.length;

                if (B64.ieo) {
                    result = [];
                    while (position < len) {
                        if (buffer[position] < 128)
                            result.push(String.fromCharCode(buffer[position++]));
                        else if (buffer[position] > 191 && buffer[position] < 224)
                            result.push(String.fromCharCode(((buffer[position++] & 31) << 6) | (buffer[position++] & 63)));
                        else
                            result.push(String.fromCharCode(((buffer[position++] & 15) << 12) | ((buffer[position++] & 63) << 6) | (buffer[position++] & 63)));
                    }
                    return result.join('');
                } else {
                    result = '';
                    while (position < len) {
                        if (buffer[position] < 128)
                            result += String.fromCharCode(buffer[position++]);
                        else if (buffer[position] > 191 && buffer[position] < 224)
                            result += String.fromCharCode(((buffer[position++] & 31) << 6) | (buffer[position++] & 63));
                        else
                            result += String.fromCharCode(((buffer[position++] & 15) << 12) | ((buffer[position++] & 63) << 6) | (buffer[position++] & 63));
                    }
                    return result;
                }
            },
            toUtf8: function (s) {
                /* jshint bitwise:false */
                var position = -1,
                    len = s.length,
                    chr, buffer = [];
                if (/^[\x00-\x7f]*$/.test(s)) while (++position < len)
                    buffer.push(s.charCodeAt(position));
                else while (++position < len) {
                    chr = s.charCodeAt(position);
                    if (chr < 128)
                        buffer.push(chr);
                    else if (chr < 2048)
                        buffer.push((chr >> 6) | 192, (chr & 63) | 128);
                    else
                        buffer.push((chr >> 12) | 224, ((chr >> 6) & 63) | 128, (chr & 63) | 128);
                }
                return buffer;
            },
            fromUtf8: function (s) {
                /* jshint bitwise:false */
                var position = -1,
                    len, buffer = [],
                    enc = [, , , ];
                if (!B64.lookup) {
                    len = B64.alphabet.length;
                    B64.lookup = {};
                    while (++position < len)
                        B64.lookup[B64.alphabet.charAt(position)] = position;
                    position = -1;
                }
                len = s.length;
                while (++position < len) {
                    enc[0] = B64.lookup[s.charAt(position)];
                    enc[1] = B64.lookup[s.charAt(++position)];
                    buffer.push((enc[0] << 2) | (enc[1] >> 4));
                    enc[2] = B64.lookup[s.charAt(++position)];
                    if (enc[2] === 64)
                        break;
                    buffer.push(((enc[1] & 15) << 4) | (enc[2] >> 2));
                    enc[3] = B64.lookup[s.charAt(++position)];
                    if (enc[3] === 64)
                        break;
                    buffer.push(((enc[2] & 3) << 6) | enc[3]);
                }
                return buffer;
            }
        };

        var B64url = {
            decode: function(input) {
                // Replace non-url compatible chars with base64 standard chars
                input = input
                    .replace(/-/g, '+')
                    .replace(/_/g, '/');

                // Pad out with standard base64 required padding characters
                var pad = input.length % 4;
                if(pad) {
                  if(pad === 1) {
                    throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
                  }
                  input += new Array(5-pad).join('=');
                }

                return B64.decode(input);
            },

            encode: function(input) {
                var output = B64.encode(input);
                return output
                    .replace(/\+/g, '-')
                    .replace(/\//g, '_')
                    .split('=', 1)[0];
            }
        };

        return {
            decode: B64.decode,
            encode: B64.encode,
            urldecode: B64url.decode,
            urlencode: B64url.encode,
        };
    })());
}

// check for Module support, otherwise explicitly call the Base64 function to setup the angular module.
if (typeof module !== 'undefined' && module.exports)
{
    module.exports = new Base64();
}
else
{
    Base64();
}
},{}],57:[function(require,module,exports){
/**
 * @license AngularJS v1.5.11
 * (c) 2010-2017 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function(window) {'use strict';

/**
 * @description
 *
 * This object provides a utility for producing rich Error messages within
 * Angular. It can be called as follows:
 *
 * var exampleMinErr = minErr('example');
 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
 *
 * The above creates an instance of minErr in the example namespace. The
 * resulting error will have a namespaced error code of example.one.  The
 * resulting error will replace {0} with the value of foo, and {1} with the
 * value of bar. The object is not restricted in the number of arguments it can
 * take.
 *
 * If fewer arguments are specified than necessary for interpolation, the extra
 * interpolation markers will be preserved in the final string.
 *
 * Since data will be parsed statically during a build step, some restrictions
 * are applied with respect to how minErr instances are created and called.
 * Instances should have names of the form namespaceMinErr for a minErr created
 * using minErr('namespace') . Error codes, namespaces and template strings
 * should all be static strings, not variables or general expressions.
 *
 * @param {string} module The namespace to use for the new minErr instance.
 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
 *   error from returned function, for cases when a particular type of error is useful.
 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
 */

function minErr(module, ErrorConstructor) {
  ErrorConstructor = ErrorConstructor || Error;
  return function() {
    var SKIP_INDEXES = 2;

    var templateArgs = arguments,
      code = templateArgs[0],
      message = '[' + (module ? module + ':' : '') + code + '] ',
      template = templateArgs[1],
      paramPrefix, i;

    message += template.replace(/\{\d+\}/g, function(match) {
      var index = +match.slice(1, -1),
        shiftedIndex = index + SKIP_INDEXES;

      if (shiftedIndex < templateArgs.length) {
        return toDebugString(templateArgs[shiftedIndex]);
      }

      return match;
    });

    message += '\nhttp://errors.angularjs.org/1.5.11/' +
      (module ? module + '/' : '') + code;

    for (i = SKIP_INDEXES, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
      message += paramPrefix + 'p' + (i - SKIP_INDEXES) + '=' +
        encodeURIComponent(toDebugString(templateArgs[i]));
    }

    return new ErrorConstructor(message);
  };
}

/* We need to tell ESLint what variables are being exported */
/* exported
  angular,
  msie,
  jqLite,
  jQuery,
  slice,
  splice,
  push,
  toString,
  ngMinErr,
  angularModule,
  uid,
  REGEX_STRING_REGEXP,
  VALIDITY_STATE_PROPERTY,

  lowercase,
  uppercase,
  manualLowercase,
  manualUppercase,
  nodeName_,
  isArrayLike,
  forEach,
  forEachSorted,
  reverseParams,
  nextUid,
  setHashKey,
  extend,
  toInt,
  inherit,
  merge,
  noop,
  identity,
  valueFn,
  isUndefined,
  isDefined,
  isObject,
  isBlankObject,
  isString,
  isNumber,
  isNumberNaN,
  isDate,
  isArray,
  isFunction,
  isRegExp,
  isWindow,
  isScope,
  isFile,
  isFormData,
  isBlob,
  isBoolean,
  isPromiseLike,
  trim,
  escapeForRegexp,
  isElement,
  makeMap,
  includes,
  arrayRemove,
  copy,
  equals,
  csp,
  jq,
  concat,
  sliceArgs,
  bind,
  toJsonReplacer,
  toJson,
  fromJson,
  convertTimezoneToLocal,
  timezoneToOffset,
  startingTag,
  tryDecodeURIComponent,
  parseKeyValue,
  toKeyValue,
  encodeUriSegment,
  encodeUriQuery,
  angularInit,
  bootstrap,
  getTestability,
  snake_case,
  bindJQuery,
  assertArg,
  assertArgFn,
  assertNotHasOwnProperty,
  getter,
  getBlockNodes,
  hasOwnProperty,
  createMap,

  NODE_TYPE_ELEMENT,
  NODE_TYPE_ATTRIBUTE,
  NODE_TYPE_TEXT,
  NODE_TYPE_COMMENT,
  NODE_TYPE_DOCUMENT,
  NODE_TYPE_DOCUMENT_FRAGMENT
*/

////////////////////////////////////

/**
 * @ngdoc module
 * @name ng
 * @module ng
 * @installation
 * @description
 *
 * # ng (core module)
 * The ng module is loaded by default when an AngularJS application is started. The module itself
 * contains the essential components for an AngularJS application to function. The table below
 * lists a high level breakdown of each of the services/factories, filters, directives and testing
 * components available within this core module.
 *
 * <div doc-module-components="ng"></div>
 */

var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

// The name of a form control's ValidityState property.
// This is used so that it's possible for internal tests to create mock ValidityStates.
var VALIDITY_STATE_PROPERTY = 'validity';

var hasOwnProperty = Object.prototype.hasOwnProperty;

var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};


var manualLowercase = function(s) {
  /* eslint-disable no-bitwise */
  return isString(s)
      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
      : s;
  /* eslint-enable */
};
var manualUppercase = function(s) {
  /* eslint-disable no-bitwise */
  return isString(s)
      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
      : s;
  /* eslint-enable */
};


// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
if ('i' !== 'I'.toLowerCase()) {
  lowercase = manualLowercase;
  uppercase = manualUppercase;
}


var
    msie,             // holds major version number for IE, or NaN if UA is not IE.
    jqLite,           // delay binding since jQuery could be loaded after us.
    jQuery,           // delay binding
    slice             = [].slice,
    splice            = [].splice,
    push              = [].push,
    toString          = Object.prototype.toString,
    getPrototypeOf    = Object.getPrototypeOf,
    ngMinErr          = minErr('ng'),

    /** @name angular */
    angular           = window.angular || (window.angular = {}),
    angularModule,
    uid               = 0;

/**
 * documentMode is an IE-only property
 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
 */
msie = window.document.documentMode;


/**
 * @private
 * @param {*} obj
 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
 *                   String ...)
 */
function isArrayLike(obj) {

  // `null`, `undefined` and `window` are not array-like
  if (obj == null || isWindow(obj)) return false;

  // arrays, strings and jQuery/jqLite objects are array like
  // * jqLite is either the jQuery or jqLite constructor function
  // * we have to check the existence of jqLite first as this method is called
  //   via the forEach method when constructing the jqLite object in the first place
  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;

  // Support: iOS 8.2 (not reproducible in simulator)
  // "length" in obj used to prevent JIT error (gh-11508)
  var length = 'length' in Object(obj) && obj.length;

  // NodeList objects (with `item` method) and
  // other objects with suitable length characteristics are array-like
  return isNumber(length) &&
    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');

}

/**
 * @ngdoc function
 * @name angular.forEach
 * @module ng
 * @kind function
 *
 * @description
 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
 * is the value of an object property or an array element, `key` is the object property key or
 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
 *
 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
 * using the `hasOwnProperty` method.
 *
 * Unlike ES262's
 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
 * return the value provided.
 *
   ```js
     var values = {name: 'misko', gender: 'male'};
     var log = [];
     angular.forEach(values, function(value, key) {
       this.push(key + ': ' + value);
     }, log);
     expect(log).toEqual(['name: misko', 'gender: male']);
   ```
 *
 * @param {Object|Array} obj Object to iterate over.
 * @param {Function} iterator Iterator function.
 * @param {Object=} context Object to become context (`this`) for the iterator function.
 * @returns {Object|Array} Reference to `obj`.
 */

function forEach(obj, iterator, context) {
  var key, length;
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        // Need to check if hasOwnProperty exists,
        // as on IE8 the result of querySelectorAll is an object without a hasOwnProperty function
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && (!obj.hasOwnProperty || obj.hasOwnProperty(key))) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object';
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj);
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj);
        }
      }
    }
  }
  return obj;
}

function forEachSorted(obj, iterator, context) {
  var keys = Object.keys(obj).sort();
  for (var i = 0; i < keys.length; i++) {
    iterator.call(context, obj[keys[i]], keys[i]);
  }
  return keys;
}


/**
 * when using forEach the params are value, key, but it is often useful to have key, value.
 * @param {function(string, *)} iteratorFn
 * @returns {function(*, string)}
 */
function reverseParams(iteratorFn) {
  return function(value, key) {iteratorFn(key, value);};
}

/**
 * A consistent way of creating unique IDs in angular.
 *
 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
 * we hit number precision issues in JavaScript.
 *
 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
 *
 * @returns {number} an unique alpha-numeric string
 */
function nextUid() {
  return ++uid;
}


/**
 * Set or clear the hashkey for an object.
 * @param obj object
 * @param h the hashkey (!truthy to delete the hashkey)
 */
function setHashKey(obj, h) {
  if (h) {
    obj.$$hashKey = h;
  } else {
    delete obj.$$hashKey;
  }
}


function baseExtend(dst, objs, deep) {
  var h = dst.$$hashKey;

  for (var i = 0, ii = objs.length; i < ii; ++i) {
    var obj = objs[i];
    if (!isObject(obj) && !isFunction(obj)) continue;
    var keys = Object.keys(obj);
    for (var j = 0, jj = keys.length; j < jj; j++) {
      var key = keys[j];
      var src = obj[key];

      if (deep && isObject(src)) {
        if (isDate(src)) {
          dst[key] = new Date(src.valueOf());
        } else if (isRegExp(src)) {
          dst[key] = new RegExp(src);
        } else if (src.nodeName) {
          dst[key] = src.cloneNode(true);
        } else if (isElement(src)) {
          dst[key] = src.clone();
        } else {
          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
          baseExtend(dst[key], [src], true);
        }
      } else {
        dst[key] = src;
      }
    }
  }

  setHashKey(dst, h);
  return dst;
}

/**
 * @ngdoc function
 * @name angular.extend
 * @module ng
 * @kind function
 *
 * @description
 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
 *
 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
 * {@link angular.merge} for this.
 *
 * @param {Object} dst Destination object.
 * @param {...Object} src Source object(s).
 * @returns {Object} Reference to `dst`.
 */
function extend(dst) {
  return baseExtend(dst, slice.call(arguments, 1), false);
}


/**
* @ngdoc function
* @name angular.merge
* @module ng
* @kind function
*
* @description
* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
*
* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
* objects, performing a deep copy.
*
* @param {Object} dst Destination object.
* @param {...Object} src Source object(s).
* @returns {Object} Reference to `dst`.
*/
function merge(dst) {
  return baseExtend(dst, slice.call(arguments, 1), true);
}



function toInt(str) {
  return parseInt(str, 10);
}

var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
  // eslint-disable-next-line no-self-compare
  return num !== num;
};


function inherit(parent, extra) {
  return extend(Object.create(parent), extra);
}

/**
 * @ngdoc function
 * @name angular.noop
 * @module ng
 * @kind function
 *
 * @description
 * A function that performs no operations. This function can be useful when writing code in the
 * functional style.
   ```js
     function foo(callback) {
       var result = calculateResult();
       (callback || angular.noop)(result);
     }
   ```
 */
function noop() {}
noop.$inject = [];


/**
 * @ngdoc function
 * @name angular.identity
 * @module ng
 * @kind function
 *
 * @description
 * A function that returns its first argument. This function is useful when writing code in the
 * functional style.
 *
   ```js
   function transformer(transformationFn, value) {
     return (transformationFn || angular.identity)(value);
   };

   // E.g.
   function getResult(fn, input) {
     return (fn || angular.identity)(input);
   };

   getResult(function(n) { return n * 2; }, 21);   // returns 42
   getResult(null, 21);                            // returns 21
   getResult(undefined, 21);                       // returns 21
   ```
 *
 * @param {*} value to be returned.
 * @returns {*} the value passed in.
 */
function identity($) {return $;}
identity.$inject = [];


function valueFn(value) {return function valueRef() {return value;};}

function hasCustomToString(obj) {
  return isFunction(obj.toString) && obj.toString !== toString;
}


/**
 * @ngdoc function
 * @name angular.isUndefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is undefined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is undefined.
 */
function isUndefined(value) {return typeof value === 'undefined';}


/**
 * @ngdoc function
 * @name angular.isDefined
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is defined.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is defined.
 */
function isDefined(value) {return typeof value !== 'undefined';}


/**
 * @ngdoc function
 * @name angular.isObject
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
 * considered to be objects. Note that JavaScript arrays are objects.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Object` but not `null`.
 */
function isObject(value) {
  // http://jsperf.com/isobject4
  return value !== null && typeof value === 'object';
}


/**
 * Determine if a value is an object with a null prototype
 *
 * @returns {boolean} True if `value` is an `Object` with a null prototype
 */
function isBlankObject(value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
}


/**
 * @ngdoc function
 * @name angular.isString
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `String`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `String`.
 */
function isString(value) {return typeof value === 'string';}


/**
 * @ngdoc function
 * @name angular.isNumber
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Number`.
 *
 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
 *
 * If you wish to exclude these then you can use the native
 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
 * method.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Number`.
 */
function isNumber(value) {return typeof value === 'number';}


/**
 * @ngdoc function
 * @name angular.isDate
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a value is a date.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Date`.
 */
function isDate(value) {
  return toString.call(value) === '[object Date]';
}


/**
 * @ngdoc function
 * @name angular.isArray
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is an `Array`. Alias of Array.isArray.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is an `Array`.
 */
var isArray = Array.isArray;

/**
 * @ngdoc function
 * @name angular.isFunction
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a `Function`.
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `Function`.
 */
function isFunction(value) {return typeof value === 'function';}


/**
 * Determines if a value is a regular expression object.
 *
 * @private
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a `RegExp`.
 */
function isRegExp(value) {
  return toString.call(value) === '[object RegExp]';
}


/**
 * Checks if `obj` is a window object.
 *
 * @private
 * @param {*} obj Object to check
 * @returns {boolean} True if `obj` is a window obj.
 */
function isWindow(obj) {
  return obj && obj.window === obj;
}


function isScope(obj) {
  return obj && obj.$evalAsync && obj.$watch;
}


function isFile(obj) {
  return toString.call(obj) === '[object File]';
}


function isFormData(obj) {
  return toString.call(obj) === '[object FormData]';
}


function isBlob(obj) {
  return toString.call(obj) === '[object Blob]';
}


function isBoolean(value) {
  return typeof value === 'boolean';
}


function isPromiseLike(obj) {
  return obj && isFunction(obj.then);
}


var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
function isTypedArray(value) {
  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
}

function isArrayBuffer(obj) {
  return toString.call(obj) === '[object ArrayBuffer]';
}


var trim = function(value) {
  return isString(value) ? value.trim() : value;
};

// Copied from:
// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
// Prereq: s is a string.
var escapeForRegexp = function(s) {
  return s
    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
};


/**
 * @ngdoc function
 * @name angular.isElement
 * @module ng
 * @kind function
 *
 * @description
 * Determines if a reference is a DOM element (or wrapped jQuery element).
 *
 * @param {*} value Reference to check.
 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
 */
function isElement(node) {
  return !!(node &&
    (node.nodeName  // We are a direct element.
    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
}

/**
 * @param str 'key1,key2,...'
 * @returns {object} in the form of {key1:true, key2:true, ...}
 */
function makeMap(str) {
  var obj = {}, items = str.split(','), i;
  for (i = 0; i < items.length; i++) {
    obj[items[i]] = true;
  }
  return obj;
}


function nodeName_(element) {
  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
}

function includes(array, obj) {
  return Array.prototype.indexOf.call(array, obj) !== -1;
}

function arrayRemove(array, value) {
  var index = array.indexOf(value);
  if (index >= 0) {
    array.splice(index, 1);
  }
  return index;
}

/**
 * @ngdoc function
 * @name angular.copy
 * @module ng
 * @kind function
 *
 * @description
 * Creates a deep copy of `source`, which should be an object or an array.
 *
 * * If no destination is supplied, a copy of the object or array is created.
 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
 *   are deleted and then all elements/properties from the source are copied to it.
 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
 * * If `source` is identical to `destination` an exception will be thrown.
 *
 * <br />
 * <div class="alert alert-warning">
 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
 *   and on `destination`) will be ignored.
 * </div>
 *
 * @param {*} source The source that will be used to make a copy.
 *                   Can be any type, including primitives, `null`, and `undefined`.
 * @param {(Object|Array)=} destination Destination into which the source is copied. If
 *     provided, must be of the same type as `source`.
 * @returns {*} The copy or updated `destination`, if `destination` was specified.
 *
 * @example
  <example module="copyExample" name="angular-copy">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate class="simple-form">
          <label>Name: <input type="text" ng-model="user.name" /></label><br />
          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
          <button ng-click="reset()">RESET</button>
          <button ng-click="update(user)">SAVE</button>
        </form>
        <pre>form = {{user | json}}</pre>
        <pre>master = {{master | json}}</pre>
      </div>
    </file>
    <file name="script.js">
      // Module: copyExample
      angular.
        module('copyExample', []).
        controller('ExampleController', ['$scope', function($scope) {
          $scope.master = {};

          $scope.reset = function() {
            // Example with 1 argument
            $scope.user = angular.copy($scope.master);
          };

          $scope.update = function(user) {
            // Example with 2 arguments
            angular.copy(user, $scope.master);
          };

          $scope.reset();
        }]);
    </file>
  </example>
 */
function copy(source, destination) {
  var stackSource = [];
  var stackDest = [];

  if (destination) {
    if (isTypedArray(destination) || isArrayBuffer(destination)) {
      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
    }
    if (source === destination) {
      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
    }

    // Empty the destination object
    if (isArray(destination)) {
      destination.length = 0;
    } else {
      forEach(destination, function(value, key) {
        if (key !== '$$hashKey') {
          delete destination[key];
        }
      });
    }

    stackSource.push(source);
    stackDest.push(destination);
    return copyRecurse(source, destination);
  }

  return copyElement(source);

  function copyRecurse(source, destination) {
    var h = destination.$$hashKey;
    var key;
    if (isArray(source)) {
      for (var i = 0, ii = source.length; i < ii; i++) {
        destination.push(copyElement(source[i]));
      }
    } else if (isBlankObject(source)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in source) {
        destination[key] = copyElement(source[key]);
      }
    } else if (source && typeof source.hasOwnProperty === 'function') {
      // Slow path, which must rely on hasOwnProperty
      for (key in source) {
        if (source.hasOwnProperty(key)) {
          destination[key] = copyElement(source[key]);
        }
      }
    } else {
      // Slowest path --- hasOwnProperty can't be called as a method
      for (key in source) {
        if (hasOwnProperty.call(source, key)) {
          destination[key] = copyElement(source[key]);
        }
      }
    }
    setHashKey(destination, h);
    return destination;
  }

  function copyElement(source) {
    // Simple values
    if (!isObject(source)) {
      return source;
    }

    // Already copied values
    var index = stackSource.indexOf(source);
    if (index !== -1) {
      return stackDest[index];
    }

    if (isWindow(source) || isScope(source)) {
      throw ngMinErr('cpws',
        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
    }

    var needsRecurse = false;
    var destination = copyType(source);

    if (destination === undefined) {
      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
      needsRecurse = true;
    }

    stackSource.push(source);
    stackDest.push(destination);

    return needsRecurse
      ? copyRecurse(source, destination)
      : destination;
  }

  function copyType(source) {
    switch (toString.call(source)) {
      case '[object Int8Array]':
      case '[object Int16Array]':
      case '[object Int32Array]':
      case '[object Float32Array]':
      case '[object Float64Array]':
      case '[object Uint8Array]':
      case '[object Uint8ClampedArray]':
      case '[object Uint16Array]':
      case '[object Uint32Array]':
        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

      case '[object ArrayBuffer]':
        // Support: IE10
        if (!source.slice) {
          // If we're in this case we know the environment supports ArrayBuffer
          /* eslint-disable no-undef */
          var copied = new ArrayBuffer(source.byteLength);
          new Uint8Array(copied).set(new Uint8Array(source));
          /* eslint-enable */
          return copied;
        }
        return source.slice(0);

      case '[object Boolean]':
      case '[object Number]':
      case '[object String]':
      case '[object Date]':
        return new source.constructor(source.valueOf());

      case '[object RegExp]':
        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
        re.lastIndex = source.lastIndex;
        return re;

      case '[object Blob]':
        return new source.constructor([source], {type: source.type});
    }

    if (isFunction(source.cloneNode)) {
      return source.cloneNode(true);
    }
  }
}


/**
 * @ngdoc function
 * @name angular.equals
 * @module ng
 * @kind function
 *
 * @description
 * Determines if two objects or two values are equivalent. Supports value types, regular
 * expressions, arrays and objects.
 *
 * Two objects or values are considered equivalent if at least one of the following is true:
 *
 * * Both objects or values pass `===` comparison.
 * * Both objects or values are of the same type and all of their properties are equal by
 *   comparing them with `angular.equals`.
 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
 * * Both values represent the same regular expression (In JavaScript,
 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
 *   representation matches).
 *
 * During a property comparison, properties of `function` type and properties with names
 * that begin with `$` are ignored.
 *
 * Scope and DOMWindow objects are being compared only by identify (`===`).
 *
 * @param {*} o1 Object or value to compare.
 * @param {*} o2 Object or value to compare.
 * @returns {boolean} True if arguments are equal.
 *
 * @example
   <example module="equalsExample" name="equalsExample">
     <file name="index.html">
      <div ng-controller="ExampleController">
        <form novalidate>
          <h3>User 1</h3>
          Name: <input type="text" ng-model="user1.name">
          Age: <input type="number" ng-model="user1.age">

          <h3>User 2</h3>
          Name: <input type="text" ng-model="user2.name">
          Age: <input type="number" ng-model="user2.age">

          <div>
            <br/>
            <input type="button" value="Compare" ng-click="compare()">
          </div>
          User 1: <pre>{{user1 | json}}</pre>
          User 2: <pre>{{user2 | json}}</pre>
          Equal: <pre>{{result}}</pre>
        </form>
      </div>
    </file>
    <file name="script.js">
        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
          $scope.user1 = {};
          $scope.user2 = {};
          $scope.compare = function() {
            $scope.result = angular.equals($scope.user1, $scope.user2);
          };
        }]);
    </file>
  </example>
 */
function equals(o1, o2) {
  if (o1 === o2) return true;
  if (o1 === null || o2 === null) return false;
  // eslint-disable-next-line no-self-compare
  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
  if (t1 === t2 && t1 === 'object') {
    if (isArray(o1)) {
      if (!isArray(o2)) return false;
      if ((length = o1.length) === o2.length) {
        for (key = 0; key < length; key++) {
          if (!equals(o1[key], o2[key])) return false;
        }
        return true;
      }
    } else if (isDate(o1)) {
      if (!isDate(o2)) return false;
      return equals(o1.getTime(), o2.getTime());
    } else if (isRegExp(o1)) {
      if (!isRegExp(o2)) return false;
      return o1.toString() === o2.toString();
    } else {
      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
      keySet = createMap();
      for (key in o1) {
        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
        if (!equals(o1[key], o2[key])) return false;
        keySet[key] = true;
      }
      for (key in o2) {
        if (!(key in keySet) &&
            key.charAt(0) !== '$' &&
            isDefined(o2[key]) &&
            !isFunction(o2[key])) return false;
      }
      return true;
    }
  }
  return false;
}

var csp = function() {
  if (!isDefined(csp.rules)) {


    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
                    window.document.querySelector('[data-ng-csp]'));

    if (ngCspElement) {
      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
                    ngCspElement.getAttribute('data-ng-csp');
      csp.rules = {
        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
      };
    } else {
      csp.rules = {
        noUnsafeEval: noUnsafeEval(),
        noInlineStyle: false
      };
    }
  }

  return csp.rules;

  function noUnsafeEval() {
    try {
      // eslint-disable-next-line no-new, no-new-func
      new Function('');
      return false;
    } catch (e) {
      return true;
    }
  }
};

/**
 * @ngdoc directive
 * @module ng
 * @name ngJq
 *
 * @element ANY
 * @param {string=} ngJq the name of the library available under `window`
 * to be used for angular.element
 * @description
 * Use this directive to force the angular.element library.  This should be
 * used to force either jqLite by leaving ng-jq blank or setting the name of
 * the jquery variable under window (eg. jQuery).
 *
 * Since angular looks for this directive when it is loaded (doesn't wait for the
 * DOMContentLoaded event), it must be placed on an element that comes before the script
 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
 * others ignored.
 *
 * @example
 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
 ```html
 <!doctype html>
 <html ng-app ng-jq>
 ...
 ...
 </html>
 ```
 * @example
 * This example shows how to use a jQuery based library of a different name.
 * The library name must be available at the top most 'window'.
 ```html
 <!doctype html>
 <html ng-app ng-jq="jQueryLib">
 ...
 ...
 </html>
 ```
 */
var jq = function() {
  if (isDefined(jq.name_)) return jq.name_;
  var el;
  var i, ii = ngAttrPrefixes.length, prefix, name;
  for (i = 0; i < ii; ++i) {
    prefix = ngAttrPrefixes[i];
    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
    if (el) {
      name = el.getAttribute(prefix + 'jq');
      break;
    }
  }

  return (jq.name_ = name);
};

function concat(array1, array2, index) {
  return array1.concat(slice.call(array2, index));
}

function sliceArgs(args, startIndex) {
  return slice.call(args, startIndex || 0);
}


/**
 * @ngdoc function
 * @name angular.bind
 * @module ng
 * @kind function
 *
 * @description
 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
 *
 * @param {Object} self Context which `fn` should be evaluated in.
 * @param {function()} fn Function to be bound.
 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
 */
function bind(self, fn) {
  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
  if (isFunction(fn) && !(fn instanceof RegExp)) {
    return curryArgs.length
      ? function() {
          return arguments.length
            ? fn.apply(self, concat(curryArgs, arguments, 0))
            : fn.apply(self, curryArgs);
        }
      : function() {
          return arguments.length
            ? fn.apply(self, arguments)
            : fn.call(self);
        };
  } else {
    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
    return fn;
  }
}


function toJsonReplacer(key, value) {
  var val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value &&  window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}


/**
 * @ngdoc function
 * @name angular.toJson
 * @module ng
 * @kind function
 *
 * @description
 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
 * stripped since angular uses this notation internally.
 *
 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
 *    If set to an integer, the JSON output will contain that many spaces per indentation.
 * @returns {string|undefined} JSON-ified string representing `obj`.
 * @knownIssue
 *
 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
 * `Date.prototype.toJSON` method as follows:
 *
 * ```
 * var _DatetoJSON = Date.prototype.toJSON;
 * Date.prototype.toJSON = function() {
 *   try {
 *     return _DatetoJSON.call(this);
 *   } catch(e) {
 *     if (e instanceof RangeError) {
 *       return null;
 *     }
 *     throw e;
 *   }
 * };
 * ```
 *
 * See https://github.com/angular/angular.js/pull/14221 for more information.
 */
function toJson(obj, pretty) {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}


/**
 * @ngdoc function
 * @name angular.fromJson
 * @module ng
 * @kind function
 *
 * @description
 * Deserializes a JSON string.
 *
 * @param {string} json JSON string to deserialize.
 * @returns {Object|Array|string|number} Deserialized JSON string.
 */
function fromJson(json) {
  return isString(json)
      ? JSON.parse(json)
      : json;
}


var ALL_COLONS = /:/g;
function timezoneToOffset(timezone, fallback) {
  // IE/Edge do not "understand" colon (`:`) in timezone
  timezone = timezone.replace(ALL_COLONS, '');
  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
}


function addDateMinutes(date, minutes) {
  date = new Date(date.getTime());
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}


function convertTimezoneToLocal(date, timezone, reverse) {
  reverse = reverse ? -1 : 1;
  var dateTimezoneOffset = date.getTimezoneOffset();
  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
}


/**
 * @returns {string} Returns the string representation of the element.
 */
function startingTag(element) {
  element = jqLite(element).clone();
  try {
    // turns out IE does not let you set .html() on elements which
    // are not allowed to have children. So we just ignore it.
    element.empty();
  } catch (e) { /* empty */ }
  var elemHtml = jqLite('<div>').append(element).html();
  try {
    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
        elemHtml.
          match(/^(<[^>]+>)/)[1].
          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
  } catch (e) {
    return lowercase(elemHtml);
  }

}


/////////////////////////////////////////////////

/**
 * Tries to decode the URI component without throwing an exception.
 *
 * @private
 * @param str value potential URI component to check.
 * @returns {boolean} True if `value` can be decoded
 * with the decodeURIComponent function.
 */
function tryDecodeURIComponent(value) {
  try {
    return decodeURIComponent(value);
  } catch (e) {
    // Ignore any invalid uri component.
  }
}


/**
 * Parses an escaped url query string into key-value pairs.
 * @returns {Object.<string,boolean|Array>}
 */
function parseKeyValue(/**string*/keyValue) {
  var obj = {};
  forEach((keyValue || '').split('&'), function(keyValue) {
    var splitPoint, key, val;
    if (keyValue) {
      key = keyValue = keyValue.replace(/\+/g,'%20');
      splitPoint = keyValue.indexOf('=');
      if (splitPoint !== -1) {
        key = keyValue.substring(0, splitPoint);
        val = keyValue.substring(splitPoint + 1);
      }
      key = tryDecodeURIComponent(key);
      if (isDefined(key)) {
        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
        if (!hasOwnProperty.call(obj, key)) {
          obj[key] = val;
        } else if (isArray(obj[key])) {
          obj[key].push(val);
        } else {
          obj[key] = [obj[key],val];
        }
      }
    }
  });
  return obj;
}

function toKeyValue(obj) {
  var parts = [];
  forEach(obj, function(value, key) {
    if (isArray(value)) {
      forEach(value, function(arrayValue) {
        parts.push(encodeUriQuery(key, true) +
                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
      });
    } else {
    parts.push(encodeUriQuery(key, true) +
               (value === true ? '' : '=' + encodeUriQuery(value, true)));
    }
  });
  return parts.length ? parts.join('&') : '';
}


/**
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
  return encodeUriQuery(val, true).
             replace(/%26/gi, '&').
             replace(/%3D/gi, '=').
             replace(/%2B/gi, '+');
}


/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query       = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
  return encodeURIComponent(val).
             replace(/%40/gi, '@').
             replace(/%3A/gi, ':').
             replace(/%24/g, '$').
             replace(/%2C/gi, ',').
             replace(/%3B/gi, ';').
             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}

var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

function getNgAttribute(element, ngAttr) {
  var attr, i, ii = ngAttrPrefixes.length;
  for (i = 0; i < ii; ++i) {
    attr = ngAttrPrefixes[i] + ngAttr;
    if (isString(attr = element.getAttribute(attr))) {
      return attr;
    }
  }
  return null;
}

function allowAutoBootstrap(document) {
  var script = document.currentScript;
  var src = script && script.getAttribute('src');

  if (!src) {
    return true;
  }

  var link = document.createElement('a');
  link.href = src;

  if (document.location.origin === link.origin) {
    // Same-origin resources are always allowed, even for non-whitelisted schemes.
    return true;
  }
  // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
  // This is to prevent angular.js bundled with browser extensions from being used to bypass the
  // content security policy in web pages and other browser extensions.
  switch (link.protocol) {
    case 'http:':
    case 'https:':
    case 'ftp:':
    case 'blob:':
    case 'file:':
    case 'data:':
      return true;
    default:
      return false;
  }
}

// Cached as it has to run during loading so that document.currentScript is available.
var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

/**
 * @ngdoc directive
 * @name ngApp
 * @module ng
 *
 * @element ANY
 * @param {angular.Module} ngApp an optional application
 *   {@link angular.module module} name to load.
 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
 *   tracking down the root of these bugs.
 *
 * @description
 *
 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
 * designates the **root element** of the application and is typically placed near the root element
 * of the page - e.g. on the `<body>` or `<html>` tags.
 *
 * There are a few things to keep in mind when using `ngApp`:
 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
 *   found in the document will be used to define the root element to auto-bootstrap as an
 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
 *   {@link angular.bootstrap} instead.
 * - AngularJS applications cannot be nested within each other.
 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
 *   {@link ngRoute.ngView `ngView`}.
 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 *   causing animations to stop working and making the injector inaccessible from outside the app.
 *
 * You can specify an **AngularJS module** to be used as the root module for the application.  This
 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
 * should contain the application code needed or have dependencies on other modules that will
 * contain the code. See {@link angular.module} for more information.
 *
 * In the example below if the `ngApp` directive were not placed on the `html` element then the
 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
 * would not be resolved to `3`.
 *
 * `ngApp` is the easiest, and most common way to bootstrap an application.
 *
 <example module="ngAppDemo" name="ng-app">
   <file name="index.html">
   <div ng-controller="ngAppDemoController">
     I can add: {{a}} + {{b}} =  {{ a+b }}
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
     $scope.a = 1;
     $scope.b = 2;
   });
   </file>
 </example>
 *
 * Using `ngStrictDi`, you would see something like this:
 *
 <example ng-app-included="true" name="strict-di">
   <file name="index.html">
   <div ng-app="ngAppStrictDemo" ng-strict-di>
       <div ng-controller="GoodController1">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style (see
              script.js for details)
           </p>
       </div>

       <div ng-controller="GoodController2">
           Name: <input ng-model="name"><br />
           Hello, {{name}}!

           <p>This renders because the controller does not fail to
              instantiate, by using explicit annotation style
              (see script.js for details)
           </p>
       </div>

       <div ng-controller="BadController">
           I can add: {{a}} + {{b}} =  {{ a+b }}

           <p>The controller could not be instantiated, due to relying
              on automatic function annotations (which are disabled in
              strict mode). As such, the content of this section is not
              interpolated, and there should be an error in your web console.
           </p>
       </div>
   </div>
   </file>
   <file name="script.js">
   angular.module('ngAppStrictDemo', [])
     // BadController will fail to instantiate, due to relying on automatic function annotation,
     // rather than an explicit annotation
     .controller('BadController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     })
     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
     // due to using explicit annotations using the array style and $inject property, respectively.
     .controller('GoodController1', ['$scope', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     }])
     .controller('GoodController2', GoodController2);
     function GoodController2($scope) {
       $scope.name = 'World';
     }
     GoodController2.$inject = ['$scope'];
   </file>
   <file name="style.css">
   div[ng-controller] {
       margin-bottom: 1em;
       -webkit-border-radius: 4px;
       border-radius: 4px;
       border: 1px solid;
       padding: .5em;
   }
   div[ng-controller^=Good] {
       border-color: #d6e9c6;
       background-color: #dff0d8;
       color: #3c763d;
   }
   div[ng-controller^=Bad] {
       border-color: #ebccd1;
       background-color: #f2dede;
       color: #a94442;
       margin-bottom: 0;
   }
   </file>
 </example>
 */
function angularInit(element, bootstrap) {
  var appElement,
      module,
      config = {};

  // The element `element` has priority over any other element.
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';

    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
      appElement = element;
      module = element.getAttribute(name);
    }
  });
  forEach(ngAttrPrefixes, function(prefix) {
    var name = prefix + 'app';
    var candidate;

    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
      appElement = candidate;
      module = candidate.getAttribute(name);
    }
  });
  if (appElement) {
    if (!isAutoBootstrapAllowed) {
      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
          'an extension, document.location.href does not match.');
      return;
    }
    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
    bootstrap(appElement, module ? [module] : [], config);
  }
}

/**
 * @ngdoc function
 * @name angular.bootstrap
 * @module ng
 * @description
 * Use this function to manually start up angular application.
 *
 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
 *
 * Angular will detect if it has been loaded into the browser more than once and only allow the
 * first loaded script to be bootstrapped and will report a warning to the browser console for
 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
 * multiple instances of Angular try to work on the DOM.
 *
 * <div class="alert alert-warning">
 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
 * They must use {@link ng.directive:ngApp ngApp}.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
 * causing animations to stop working and making the injector inaccessible from outside the app.
 * </div>
 *
 * ```html
 * <!doctype html>
 * <html>
 * <body>
 * <div ng-controller="WelcomeController">
 *   {{greeting}}
 * </div>
 *
 * <script src="angular.js"></script>
 * <script>
 *   var app = angular.module('demo', [])
 *   .controller('WelcomeController', function($scope) {
 *       $scope.greeting = 'Welcome!';
 *   });
 *   angular.bootstrap(document, ['demo']);
 * </script>
 * </body>
 * </html>
 * ```
 *
 * @param {DOMElement} element DOM element which is the root of angular application.
 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
 *     Each item in the array should be the name of a predefined module or a (DI annotated)
 *     function that will be invoked by the injector as a `config` block.
 *     See: {@link angular.module modules}
 * @param {Object=} config an object for defining configuration options for the application. The
 *     following keys are supported:
 *
 * * `strictDi` - disable automatic function annotation for the application. This is meant to
 *   assist in finding bugs which break minified code. Defaults to `false`.
 *
 * @returns {auto.$injector} Returns the newly created injector for this app.
 */
function bootstrap(element, modules, config) {
  if (!isObject(config)) config = {};
  var defaultConfig = {
    strictDi: false
  };
  config = extend(defaultConfig, config);
  var doBootstrap = function() {
    element = jqLite(element);

    if (element.injector()) {
      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
      throw ngMinErr(
          'btstrpd',
          'App already bootstrapped with this element \'{0}\'',
          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
    }

    modules = modules || [];
    modules.unshift(['$provide', function($provide) {
      $provide.value('$rootElement', element);
    }]);

    if (config.debugInfoEnabled) {
      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
      modules.push(['$compileProvider', function($compileProvider) {
        $compileProvider.debugInfoEnabled(true);
      }]);
    }

    modules.unshift('ng');
    var injector = createInjector(modules, config.strictDi);
    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
       function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function() {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]
    );
    return injector;
  };

  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
    config.debugInfoEnabled = true;
    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
  }

  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
    return doBootstrap();
  }

  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
  angular.resumeBootstrap = function(extraModules) {
    forEach(extraModules, function(module) {
      modules.push(module);
    });
    return doBootstrap();
  };

  if (isFunction(angular.resumeDeferredBootstrap)) {
    angular.resumeDeferredBootstrap();
  }
}

/**
 * @ngdoc function
 * @name angular.reloadWithDebugInfo
 * @module ng
 * @description
 * Use this function to reload the current application with debug information turned on.
 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
 *
 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
 */
function reloadWithDebugInfo() {
  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
  window.location.reload();
}

/**
 * @name angular.getTestability
 * @module ng
 * @description
 * Get the testability service for the instance of Angular on the given
 * element.
 * @param {DOMElement} element DOM element which is the root of angular application.
 */
function getTestability(rootElement) {
  var injector = angular.element(rootElement).injector();
  if (!injector) {
    throw ngMinErr('test',
      'no injector found for element argument to getTestability');
  }
  return injector.get('$$testability');
}

var SNAKE_CASE_REGEXP = /[A-Z]/g;
function snake_case(name, separator) {
  separator = separator || '_';
  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
    return (pos ? separator : '') + letter.toLowerCase();
  });
}

var bindJQueryFired = false;
function bindJQuery() {
  var originalCleanData;

  if (bindJQueryFired) {
    return;
  }

  // bind to jQuery if present;
  var jqName = jq();
  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
           !jqName             ? undefined     :   // use jqLite
                                 window[jqName];   // use jQuery specified by `ngJq`

  // Use jQuery if it exists with proper functionality, otherwise default to us.
  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
  // versions. It will not work for sure with jQuery <1.7, though.
  if (jQuery && jQuery.fn.on) {
    jqLite = jQuery;
    extend(jQuery.fn, {
      scope: JQLitePrototype.scope,
      isolateScope: JQLitePrototype.isolateScope,
      controller: JQLitePrototype.controller,
      injector: JQLitePrototype.injector,
      inheritedData: JQLitePrototype.inheritedData
    });

    // All nodes removed from the DOM via various jQuery APIs like .remove()
    // are passed through jQuery.cleanData. Monkey-patch this method to fire
    // the $destroy event on all removed nodes.
    originalCleanData = jQuery.cleanData;
    jQuery.cleanData = function(elems) {
      var events;
      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
        events = jQuery._data(elem, 'events');
        if (events && events.$destroy) {
          jQuery(elem).triggerHandler('$destroy');
        }
      }
      originalCleanData(elems);
    };
  } else {
    jqLite = JQLite;
  }

  angular.element = jqLite;

  // Prevent double-proxying.
  bindJQueryFired = true;
}

/**
 * throw error if the argument is falsy.
 */
function assertArg(arg, name, reason) {
  if (!arg) {
    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
  }
  return arg;
}

function assertArgFn(arg, name, acceptArrayAnnotation) {
  if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
  }

  assertArg(isFunction(arg), name, 'not a function, got ' +
      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
  return arg;
}

/**
 * throw error if the name given is hasOwnProperty
 * @param  {String} name    the name to test
 * @param  {String} context the context in which the name is used, such as module or directive
 */
function assertNotHasOwnProperty(name, context) {
  if (name === 'hasOwnProperty') {
    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
  }
}

/**
 * Return the value accessible from the object by path. Any undefined traversals are ignored
 * @param {Object} obj starting object
 * @param {String} path path to traverse
 * @param {boolean} [bindFnToScope=true]
 * @returns {Object} value as accessible by path
 */
//TODO(misko): this function needs to be removed
function getter(obj, path, bindFnToScope) {
  if (!path) return obj;
  var keys = path.split('.');
  var key;
  var lastInstance = obj;
  var len = keys.length;

  for (var i = 0; i < len; i++) {
    key = keys[i];
    if (obj) {
      obj = (lastInstance = obj)[key];
    }
  }
  if (!bindFnToScope && isFunction(obj)) {
    return bind(lastInstance, obj);
  }
  return obj;
}

/**
 * Return the DOM siblings between the first and last node in the given array.
 * @param {Array} array like object
 * @returns {Array} the inputted object or a jqLite collection containing the nodes
 */
function getBlockNodes(nodes) {
  // TODO(perf): update `nodes` instead of creating a new object?
  var node = nodes[0];
  var endNode = nodes[nodes.length - 1];
  var blockNodes;

  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
    if (blockNodes || nodes[i] !== node) {
      if (!blockNodes) {
        blockNodes = jqLite(slice.call(nodes, 0, i));
      }
      blockNodes.push(node);
    }
  }

  return blockNodes || nodes;
}


/**
 * Creates a new object without a prototype. This object is useful for lookup without having to
 * guard against prototypically inherited properties via hasOwnProperty.
 *
 * Related micro-benchmarks:
 * - http://jsperf.com/object-create2
 * - http://jsperf.com/proto-map-lookup/2
 * - http://jsperf.com/for-in-vs-object-keys2
 *
 * @returns {Object}
 */
function createMap() {
  return Object.create(null);
}

var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_ATTRIBUTE = 2;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_COMMENT = 8;
var NODE_TYPE_DOCUMENT = 9;
var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

/**
 * @ngdoc type
 * @name angular.Module
 * @module ng
 * @description
 *
 * Interface for configuring angular {@link angular.module modules}.
 */

function setupModuleLoader(window) {

  var $injectorMinErr = minErr('$injector');
  var ngMinErr = minErr('ng');

  function ensure(obj, name, factory) {
    return obj[name] || (obj[name] = factory());
  }

  var angular = ensure(window, 'angular', Object);

  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
  angular.$$minErr = angular.$$minErr || minErr;

  return ensure(angular, 'module', function() {
    /** @type {Object.<string, angular.Module>} */
    var modules = {};

    /**
     * @ngdoc function
     * @name angular.module
     * @module ng
     * @description
     *
     * The `angular.module` is a global place for creating, registering and retrieving Angular
     * modules.
     * All modules (angular core or 3rd party) that should be available to an application must be
     * registered using this mechanism.
     *
     * Passing one argument retrieves an existing {@link angular.Module},
     * whereas passing more than one argument creates a new {@link angular.Module}
     *
     *
     * # Module
     *
     * A module is a collection of services, directives, controllers, filters, and configuration information.
     * `angular.module` is used to configure the {@link auto.$injector $injector}.
     *
     * ```js
     * // Create a new module
     * var myModule = angular.module('myModule', []);
     *
     * // register a new service
     * myModule.value('appName', 'MyCoolApp');
     *
     * // configure existing services inside initialization blocks.
     * myModule.config(['$locationProvider', function($locationProvider) {
     *   // Configure existing providers
     *   $locationProvider.hashPrefix('!');
     * }]);
     * ```
     *
     * Then you can create an injector and load your modules like this:
     *
     * ```js
     * var injector = angular.injector(['ng', 'myModule'])
     * ```
     *
     * However it's more likely that you'll just use
     * {@link ng.directive:ngApp ngApp} or
     * {@link angular.bootstrap} to simplify this process for you.
     *
     * @param {!string} name The name of the module to create or retrieve.
     * @param {!Array.<string>=} requires If specified then new module is being created. If
     *        unspecified then the module is being retrieved for further configuration.
     * @param {Function=} configFn Optional configuration function for the module. Same as
     *        {@link angular.Module#config Module#config()}.
     * @returns {angular.Module} new module with the {@link angular.Module} api.
     */
    return function module(name, requires, configFn) {
      var assertNotHasOwnProperty = function(name, context) {
        if (name === 'hasOwnProperty') {
          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
        }
      };

      assertNotHasOwnProperty(name, 'module');
      if (requires && modules.hasOwnProperty(name)) {
        modules[name] = null;
      }
      return ensure(modules, name, function() {
        if (!requires) {
          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
             'the module name or forgot to load it. If registering a module ensure that you ' +
             'specify the dependencies as the second argument.', name);
        }

        /** @type {!Array.<Array.<*>>} */
        var invokeQueue = [];

        /** @type {!Array.<Function>} */
        var configBlocks = [];

        /** @type {!Array.<Function>} */
        var runBlocks = [];

        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

        /** @type {angular.Module} */
        var moduleInstance = {
          // Private state
          _invokeQueue: invokeQueue,
          _configBlocks: configBlocks,
          _runBlocks: runBlocks,

          /**
           * @ngdoc property
           * @name angular.Module#requires
           * @module ng
           *
           * @description
           * Holds the list of modules which the injector will load before the current module is
           * loaded.
           */
          requires: requires,

          /**
           * @ngdoc property
           * @name angular.Module#name
           * @module ng
           *
           * @description
           * Name of the module.
           */
          name: name,


          /**
           * @ngdoc method
           * @name angular.Module#provider
           * @module ng
           * @param {string} name service name
           * @param {Function} providerType Construction function for creating new instance of the
           *                                service.
           * @description
           * See {@link auto.$provide#provider $provide.provider()}.
           */
          provider: invokeLaterAndSetModuleName('$provide', 'provider'),

          /**
           * @ngdoc method
           * @name angular.Module#factory
           * @module ng
           * @param {string} name service name
           * @param {Function} providerFunction Function for creating new instance of the service.
           * @description
           * See {@link auto.$provide#factory $provide.factory()}.
           */
          factory: invokeLaterAndSetModuleName('$provide', 'factory'),

          /**
           * @ngdoc method
           * @name angular.Module#service
           * @module ng
           * @param {string} name service name
           * @param {Function} constructor A constructor function that will be instantiated.
           * @description
           * See {@link auto.$provide#service $provide.service()}.
           */
          service: invokeLaterAndSetModuleName('$provide', 'service'),

          /**
           * @ngdoc method
           * @name angular.Module#value
           * @module ng
           * @param {string} name service name
           * @param {*} object Service instance object.
           * @description
           * See {@link auto.$provide#value $provide.value()}.
           */
          value: invokeLater('$provide', 'value'),

          /**
           * @ngdoc method
           * @name angular.Module#constant
           * @module ng
           * @param {string} name constant name
           * @param {*} object Constant value.
           * @description
           * Because the constants are fixed, they get applied before other provide methods.
           * See {@link auto.$provide#constant $provide.constant()}.
           */
          constant: invokeLater('$provide', 'constant', 'unshift'),

           /**
           * @ngdoc method
           * @name angular.Module#decorator
           * @module ng
           * @param {string} name The name of the service to decorate.
           * @param {Function} decorFn This function will be invoked when the service needs to be
           *                           instantiated and should return the decorated service instance.
           * @description
           * See {@link auto.$provide#decorator $provide.decorator()}.
           */
          decorator: invokeLaterAndSetModuleName('$provide', 'decorator'),

          /**
           * @ngdoc method
           * @name angular.Module#animation
           * @module ng
           * @param {string} name animation name
           * @param {Function} animationFactory Factory function for creating new instance of an
           *                                    animation.
           * @description
           *
           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
           *
           *
           * Defines an animation hook that can be later used with
           * {@link $animate $animate} service and directives that use this service.
           *
           * ```js
           * module.animation('.animation-name', function($inject1, $inject2) {
           *   return {
           *     eventName : function(element, done) {
           *       //code to run the animation
           *       //once complete, then run done()
           *       return function cancellationFunction(element) {
           *         //code to cancel the animation
           *       }
           *     }
           *   }
           * })
           * ```
           *
           * See {@link ng.$animateProvider#register $animateProvider.register()} and
           * {@link ngAnimate ngAnimate module} for more information.
           */
          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#filter
           * @module ng
           * @param {string} name Filter name - this must be a valid angular expression identifier
           * @param {Function} filterFactory Factory function for creating new instance of filter.
           * @description
           * See {@link ng.$filterProvider#register $filterProvider.register()}.
           *
           * <div class="alert alert-warning">
           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
           * (`myapp_subsection_filterx`).
           * </div>
           */
          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#controller
           * @module ng
           * @param {string|Object} name Controller name, or an object map of controllers where the
           *    keys are the names and the values are the constructors.
           * @param {Function} constructor Controller constructor function.
           * @description
           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
           */
          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

          /**
           * @ngdoc method
           * @name angular.Module#directive
           * @module ng
           * @param {string|Object} name Directive name, or an object map of directives where the
           *    keys are the names and the values are the factories.
           * @param {Function} directiveFactory Factory function for creating new instance of
           * directives.
           * @description
           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
           */
          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

          /**
           * @ngdoc method
           * @name angular.Module#component
           * @module ng
           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
           * @param {Object} options Component definition object (a simplified
           *    {@link ng.$compile#directive-definition-object directive definition object})
           *
           * @description
           * See {@link ng.$compileProvider#component $compileProvider.component()}.
           */
          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

          /**
           * @ngdoc method
           * @name angular.Module#config
           * @module ng
           * @param {Function} configFn Execute this function on module load. Useful for service
           *    configuration.
           * @description
           * Use this method to register work which needs to be performed on module loading.
           * For more about how to configure services, see
           * {@link providers#provider-recipe Provider Recipe}.
           */
          config: config,

          /**
           * @ngdoc method
           * @name angular.Module#run
           * @module ng
           * @param {Function} initializationFn Execute this function after injector creation.
           *    Useful for application initialization.
           * @description
           * Use this method to register work which should be performed when the injector is done
           * loading all modules.
           */
          run: function(block) {
            runBlocks.push(block);
            return this;
          }
        };

        if (configFn) {
          config(configFn);
        }

        return moduleInstance;

        /**
         * @param {string} provider
         * @param {string} method
         * @param {String=} insertMethod
         * @returns {angular.Module}
         */
        function invokeLater(provider, method, insertMethod, queue) {
          if (!queue) queue = invokeQueue;
          return function() {
            queue[insertMethod || 'push']([provider, method, arguments]);
            return moduleInstance;
          };
        }

        /**
         * @param {string} provider
         * @param {string} method
         * @returns {angular.Module}
         */
        function invokeLaterAndSetModuleName(provider, method) {
          return function(recipeName, factoryFunction) {
            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
            invokeQueue.push([provider, method, arguments]);
            return moduleInstance;
          };
        }
      });
    };
  });

}

/* global shallowCopy: true */

/**
 * Creates a shallow copy of an object, an array or a primitive.
 *
 * Assumes that there are no proto properties for objects.
 */
function shallowCopy(src, dst) {
  if (isArray(src)) {
    dst = dst || [];

    for (var i = 0, ii = src.length; i < ii; i++) {
      dst[i] = src[i];
    }
  } else if (isObject(src)) {
    dst = dst || {};

    for (var key in src) {
      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }
  }

  return dst || src;
}

/* global toDebugString: true */

function serializeObject(obj) {
  var seen = [];

  return JSON.stringify(obj, function(key, val) {
    val = toJsonReplacer(key, val);
    if (isObject(val)) {

      if (seen.indexOf(val) >= 0) return '...';

      seen.push(val);
    }
    return val;
  });
}

function toDebugString(obj) {
  if (typeof obj === 'function') {
    return obj.toString().replace(/ \{[\s\S]*$/, '');
  } else if (isUndefined(obj)) {
    return 'undefined';
  } else if (typeof obj !== 'string') {
    return serializeObject(obj);
  }
  return obj;
}

/* global angularModule: true,
  version: true,

  $CompileProvider,

  htmlAnchorDirective,
  inputDirective,
  inputDirective,
  formDirective,
  scriptDirective,
  selectDirective,
  optionDirective,
  ngBindDirective,
  ngBindHtmlDirective,
  ngBindTemplateDirective,
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective,
  ngCloakDirective,
  ngControllerDirective,
  ngFormDirective,
  ngHideDirective,
  ngIfDirective,
  ngIncludeDirective,
  ngIncludeFillContentDirective,
  ngInitDirective,
  ngNonBindableDirective,
  ngPluralizeDirective,
  ngRepeatDirective,
  ngShowDirective,
  ngStyleDirective,
  ngSwitchDirective,
  ngSwitchWhenDirective,
  ngSwitchDefaultDirective,
  ngOptionsDirective,
  ngTranscludeDirective,
  ngModelDirective,
  ngListDirective,
  ngChangeDirective,
  patternDirective,
  patternDirective,
  requiredDirective,
  requiredDirective,
  minlengthDirective,
  minlengthDirective,
  maxlengthDirective,
  maxlengthDirective,
  ngValueDirective,
  ngModelOptionsDirective,
  ngAttributeAliasDirectives,
  ngEventDirectives,

  $AnchorScrollProvider,
  $AnimateProvider,
  $CoreAnimateCssProvider,
  $$CoreAnimateJsProvider,
  $$CoreAnimateQueueProvider,
  $$AnimateRunnerFactoryProvider,
  $$AnimateAsyncRunFactoryProvider,
  $BrowserProvider,
  $CacheFactoryProvider,
  $ControllerProvider,
  $DateProvider,
  $DocumentProvider,
  $ExceptionHandlerProvider,
  $FilterProvider,
  $$ForceReflowProvider,
  $InterpolateProvider,
  $IntervalProvider,
  $$HashMapProvider,
  $HttpProvider,
  $HttpParamSerializerProvider,
  $HttpParamSerializerJQLikeProvider,
  $HttpBackendProvider,
  $xhrFactoryProvider,
  $jsonpCallbacksProvider,
  $LocationProvider,
  $LogProvider,
  $ParseProvider,
  $RootScopeProvider,
  $QProvider,
  $$QProvider,
  $$SanitizeUriProvider,
  $SceProvider,
  $SceDelegateProvider,
  $SnifferProvider,
  $TemplateCacheProvider,
  $TemplateRequestProvider,
  $$TestabilityProvider,
  $TimeoutProvider,
  $$RAFProvider,
  $WindowProvider,
  $$jqLiteProvider,
  $$CookieReaderProvider
*/


/**
 * @ngdoc object
 * @name angular.version
 * @module ng
 * @description
 * An object that contains information about the current AngularJS version.
 *
 * This object has the following properties:
 *
 * - `full` – `{string}` – Full version string, such as "0.9.18".
 * - `major` – `{number}` – Major version number, such as "0".
 * - `minor` – `{number}` – Minor version number, such as "9".
 * - `dot` – `{number}` – Dot version number, such as "18".
 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
 */
var version = {
  // These placeholder strings will be replaced by grunt's `build` task.
  // They need to be double- or single-quoted.
  full: '1.5.11',
  major: 1,
  minor: 5,
  dot: 11,
  codeName: 'princely-quest'
};


function publishExternalAPI(angular) {
  extend(angular, {
    'bootstrap': bootstrap,
    'copy': copy,
    'extend': extend,
    'merge': merge,
    'equals': equals,
    'element': jqLite,
    'forEach': forEach,
    'injector': createInjector,
    'noop': noop,
    'bind': bind,
    'toJson': toJson,
    'fromJson': fromJson,
    'identity': identity,
    'isUndefined': isUndefined,
    'isDefined': isDefined,
    'isString': isString,
    'isFunction': isFunction,
    'isObject': isObject,
    'isNumber': isNumber,
    'isElement': isElement,
    'isArray': isArray,
    'version': version,
    'isDate': isDate,
    'lowercase': lowercase,
    'uppercase': uppercase,
    'callbacks': {$$counter: 0},
    'getTestability': getTestability,
    '$$minErr': minErr,
    '$$csp': csp,
    'reloadWithDebugInfo': reloadWithDebugInfo
  });

  angularModule = setupModuleLoader(window);

  angularModule('ng', ['ngLocale'], ['$provide',
    function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).
        directive({
            a: htmlAnchorDirective,
            input: inputDirective,
            textarea: inputDirective,
            form: formDirective,
            script: scriptDirective,
            select: selectDirective,
            option: optionDirective,
            ngBind: ngBindDirective,
            ngBindHtml: ngBindHtmlDirective,
            ngBindTemplate: ngBindTemplateDirective,
            ngClass: ngClassDirective,
            ngClassEven: ngClassEvenDirective,
            ngClassOdd: ngClassOddDirective,
            ngCloak: ngCloakDirective,
            ngController: ngControllerDirective,
            ngForm: ngFormDirective,
            ngHide: ngHideDirective,
            ngIf: ngIfDirective,
            ngInclude: ngIncludeDirective,
            ngInit: ngInitDirective,
            ngNonBindable: ngNonBindableDirective,
            ngPluralize: ngPluralizeDirective,
            ngRepeat: ngRepeatDirective,
            ngShow: ngShowDirective,
            ngStyle: ngStyleDirective,
            ngSwitch: ngSwitchDirective,
            ngSwitchWhen: ngSwitchWhenDirective,
            ngSwitchDefault: ngSwitchDefaultDirective,
            ngOptions: ngOptionsDirective,
            ngTransclude: ngTranscludeDirective,
            ngModel: ngModelDirective,
            ngList: ngListDirective,
            ngChange: ngChangeDirective,
            pattern: patternDirective,
            ngPattern: patternDirective,
            required: requiredDirective,
            ngRequired: requiredDirective,
            minlength: minlengthDirective,
            ngMinlength: minlengthDirective,
            maxlength: maxlengthDirective,
            ngMaxlength: maxlengthDirective,
            ngValue: ngValueDirective,
            ngModelOptions: ngModelOptionsDirective
        }).
        directive({
          ngInclude: ngIncludeFillContentDirective
        }).
        directive(ngAttributeAliasDirectives).
        directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$HashMap: $$HashMapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }
  ]);
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* global JQLitePrototype: true,
  addEventListenerFn: true,
  removeEventListenerFn: true,
  BOOLEAN_ATTR: true,
  ALIASED_ATTR: true
*/

//////////////////////////////////
//JQLite
//////////////////////////////////

/**
 * @ngdoc function
 * @name angular.element
 * @module ng
 * @kind function
 *
 * @description
 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
 *
 * If jQuery is available, `angular.element` is an alias for the
 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
 *
 * jqLite is a tiny, API-compatible subset of jQuery that allows
 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
 * commonly needed functionality with the goal of having a very small footprint.
 *
 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
 * specific version of jQuery if multiple versions exist on the page.
 *
 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
 *
 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
 *
 * ## Angular's jqLite
 * jqLite provides only the following jQuery methods:
 *
 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
 * - [`after()`](http://api.jquery.com/after/)
 * - [`append()`](http://api.jquery.com/append/)
 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
 * - [`bind()`](http://api.jquery.com/bind/) - Does not support namespaces, selectors or eventData
 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
 * - [`clone()`](http://api.jquery.com/clone/)
 * - [`contents()`](http://api.jquery.com/contents/)
 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
 * - [`data()`](http://api.jquery.com/data/)
 * - [`detach()`](http://api.jquery.com/detach/)
 * - [`empty()`](http://api.jquery.com/empty/)
 * - [`eq()`](http://api.jquery.com/eq/)
 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
 * - [`hasClass()`](http://api.jquery.com/hasClass/)
 * - [`html()`](http://api.jquery.com/html/)
 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
 * - [`prepend()`](http://api.jquery.com/prepend/)
 * - [`prop()`](http://api.jquery.com/prop/)
 * - [`ready()`](http://api.jquery.com/ready/)
 * - [`remove()`](http://api.jquery.com/remove/)
 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
 * - [`removeData()`](http://api.jquery.com/removeData/)
 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
 * - [`text()`](http://api.jquery.com/text/)
 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
 * - [`unbind()`](http://api.jquery.com/unbind/) - Does not support namespaces or event object as parameter
 * - [`val()`](http://api.jquery.com/val/)
 * - [`wrap()`](http://api.jquery.com/wrap/)
 *
 * ## jQuery/jqLite Extras
 * Angular also provides the following additional methods and events to both jQuery and jqLite:
 *
 * ### Events
 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
 *    element before it is removed.
 *
 * ### Methods
 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
 *   `'ngModel'`).
 * - `injector()` - retrieves the injector of the current element or its parent.
 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
 *   be enabled.
 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
 *   parent element is reached.
 *
 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
 * https://github.com/angular/angular.js/issues/14251 for more information.
 *
 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
 * @returns {Object} jQuery object.
 */

JQLite.expando = 'ng339';

var jqCache = JQLite.cache = {},
    jqId = 1,
    addEventListenerFn = function(element, type, fn) {
      element.addEventListener(type, fn, false);
    },
    removeEventListenerFn = function(element, type, fn) {
      element.removeEventListener(type, fn, false);
    };

/*
 * !!! This is an undocumented "private" function !!!
 */
JQLite._data = function(node) {
  //jQuery always returns an object on cache miss
  return this.cache[node[this.expando]] || {};
};

function jqNextId() { return ++jqId; }


var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
var jqLiteMinErr = minErr('jqLite');

/**
 * Converts snake_case to camelCase.
 * Also there is special case for Moz prefix starting with upper case letter.
 * @param name Name to normalize
 */
function camelCase(name) {
  return name.
    replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    }).
    replace(MOZ_HACK_REGEXP, 'Moz$1');
}

var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
var HTML_REGEXP = /<|&#?\w+;/;
var TAG_NAME_REGEXP = /<([\w:-]+)/;
var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

var wrapMap = {
  'option': [1, '<select multiple="multiple">', '</select>'],

  'thead': [1, '<table>', '</table>'],
  'col': [2, '<table><colgroup>', '</colgroup></table>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],
  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  '_default': [0, '', '']
};

wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function jqLiteIsTextNode(html) {
  return !HTML_REGEXP.test(html);
}

function jqLiteAcceptsData(node) {
  // The window object can accept data but has no nodeType
  // Otherwise we are only interested in elements (1) and documents (9)
  var nodeType = node.nodeType;
  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
}

function jqLiteHasData(node) {
  for (var key in jqCache[node.ng339]) {
    return true;
  }
  return false;
}

function jqLiteCleanData(nodes) {
  for (var i = 0, ii = nodes.length; i < ii; i++) {
    jqLiteRemoveData(nodes[i]);
  }
}

function jqLiteBuildFragment(html, context) {
  var tmp, tag, wrap,
      fragment = context.createDocumentFragment(),
      nodes = [], i;

  if (jqLiteIsTextNode(html)) {
    // Convert non-html into a text node
    nodes.push(context.createTextNode(html));
  } else {
    // Convert html into DOM nodes
    tmp = fragment.appendChild(context.createElement('div'));
    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
    wrap = wrapMap[tag] || wrapMap._default;
    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];

    // Descend through wrappers to the right content
    i = wrap[0];
    while (i--) {
      tmp = tmp.lastChild;
    }

    nodes = concat(nodes, tmp.childNodes);

    tmp = fragment.firstChild;
    tmp.textContent = '';
  }

  // Remove wrapper from fragment
  fragment.textContent = '';
  fragment.innerHTML = ''; // Clear inner HTML
  forEach(nodes, function(node) {
    fragment.appendChild(node);
  });

  return fragment;
}

function jqLiteParseHTML(html, context) {
  context = context || window.document;
  var parsed;

  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
    return [context.createElement(parsed[1])];
  }

  if ((parsed = jqLiteBuildFragment(html, context))) {
    return parsed.childNodes;
  }

  return [];
}

function jqLiteWrapNode(node, wrapper) {
  var parent = node.parentNode;

  if (parent) {
    parent.replaceChild(wrapper, node);
  }

  wrapper.appendChild(node);
}


// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
  // eslint-disable-next-line no-bitwise
  return !!(this.compareDocumentPosition(arg) & 16);
};

/////////////////////////////////////////////
function JQLite(element) {
  if (element instanceof JQLite) {
    return element;
  }

  var argIsString;

  if (isString(element)) {
    element = trim(element);
    argIsString = true;
  }
  if (!(this instanceof JQLite)) {
    if (argIsString && element.charAt(0) !== '<') {
      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
    }
    return new JQLite(element);
  }

  if (argIsString) {
    jqLiteAddNodes(this, jqLiteParseHTML(element));
  } else {
    jqLiteAddNodes(this, element);
  }
}

function jqLiteClone(element) {
  return element.cloneNode(true);
}

function jqLiteDealoc(element, onlyDescendants) {
  if (!onlyDescendants) jqLiteRemoveData(element);

  if (element.querySelectorAll) {
    var descendants = element.querySelectorAll('*');
    for (var i = 0, l = descendants.length; i < l; i++) {
      jqLiteRemoveData(descendants[i]);
    }
  }
}

function jqLiteOff(element, type, fn, unsupported) {
  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

  var expandoStore = jqLiteExpandoStore(element);
  var events = expandoStore && expandoStore.events;
  var handle = expandoStore && expandoStore.handle;

  if (!handle) return; //no listeners registered

  if (!type) {
    for (type in events) {
      if (type !== '$destroy') {
        removeEventListenerFn(element, type, handle);
      }
      delete events[type];
    }
  } else {

    var removeHandler = function(type) {
      var listenerFns = events[type];
      if (isDefined(fn)) {
        arrayRemove(listenerFns || [], fn);
      }
      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
        removeEventListenerFn(element, type, handle);
        delete events[type];
      }
    };

    forEach(type.split(' '), function(type) {
      removeHandler(type);
      if (MOUSE_EVENT_MAP[type]) {
        removeHandler(MOUSE_EVENT_MAP[type]);
      }
    });
  }
}

function jqLiteRemoveData(element, name) {
  var expandoId = element.ng339;
  var expandoStore = expandoId && jqCache[expandoId];

  if (expandoStore) {
    if (name) {
      delete expandoStore.data[name];
      return;
    }

    if (expandoStore.handle) {
      if (expandoStore.events.$destroy) {
        expandoStore.handle({}, '$destroy');
      }
      jqLiteOff(element);
    }
    delete jqCache[expandoId];
    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
  }
}


function jqLiteExpandoStore(element, createIfNecessary) {
  var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];

  if (createIfNecessary && !expandoStore) {
    element.ng339 = expandoId = jqNextId();
    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
  }

  return expandoStore;
}


function jqLiteData(element, key, value) {
  if (jqLiteAcceptsData(element)) {

    var isSimpleSetter = isDefined(value);
    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
    var massGetter = !key;
    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
    var data = expandoStore && expandoStore.data;

    if (isSimpleSetter) { // data('key', value)
      data[key] = value;
    } else {
      if (massGetter) {  // data()
        return data;
      } else {
        if (isSimpleGetter) { // data('key')
          // don't force creation of expandoStore if it doesn't exist yet
          return data && data[key];
        } else { // mass-setter: data({key1: val1, key2: val2})
          extend(data, key);
        }
      }
    }
  }
}

function jqLiteHasClass(element, selector) {
  if (!element.getAttribute) return false;
  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
      indexOf(' ' + selector + ' ') > -1);
}

function jqLiteRemoveClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    forEach(cssClasses.split(' '), function(cssClass) {
      element.setAttribute('class', trim(
          (' ' + (element.getAttribute('class') || '') + ' ')
          .replace(/[\n\t]/g, ' ')
          .replace(' ' + trim(cssClass) + ' ', ' '))
      );
    });
  }
}

function jqLiteAddClass(element, cssClasses) {
  if (cssClasses && element.setAttribute) {
    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
                            .replace(/[\n\t]/g, ' ');

    forEach(cssClasses.split(' '), function(cssClass) {
      cssClass = trim(cssClass);
      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
        existingClasses += cssClass + ' ';
      }
    });

    element.setAttribute('class', trim(existingClasses));
  }
}


function jqLiteAddNodes(root, elements) {
  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

  if (elements) {

    // if a Node (the most common case)
    if (elements.nodeType) {
      root[root.length++] = elements;
    } else {
      var length = elements.length;

      // if an Array or NodeList and not a Window
      if (typeof length === 'number' && elements.window !== elements) {
        if (length) {
          for (var i = 0; i < length; i++) {
            root[root.length++] = elements[i];
          }
        }
      } else {
        root[root.length++] = elements;
      }
    }
  }
}


function jqLiteController(element, name) {
  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
}

function jqLiteInheritedData(element, name, value) {
  // if element is the document object work with the html element instead
  // this makes $(document).scope() possible
  if (element.nodeType === NODE_TYPE_DOCUMENT) {
    element = element.documentElement;
  }
  var names = isArray(name) ? name : [name];

  while (element) {
    for (var i = 0, ii = names.length; i < ii; i++) {
      if (isDefined(value = jqLite.data(element, names[i]))) return value;
    }

    // If dealing with a document fragment node with a host element, and no parent, use the host
    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
    // to lookup parent controllers.
    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
  }
}

function jqLiteEmpty(element) {
  jqLiteDealoc(element, true);
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}

function jqLiteRemove(element, keepData) {
  if (!keepData) jqLiteDealoc(element);
  var parent = element.parentNode;
  if (parent) parent.removeChild(element);
}


function jqLiteDocumentLoaded(action, win) {
  win = win || window;
  if (win.document.readyState === 'complete') {
    // Force the action to be run async for consistent behavior
    // from the action's point of view
    // i.e. it will definitely not be in a $apply
    win.setTimeout(action);
  } else {
    // No need to unbind this handler as load is only ever called once
    jqLite(win).on('load', action);
  }
}

//////////////////////////////////////////
// Functions which are declared directly.
//////////////////////////////////////////
var JQLitePrototype = JQLite.prototype = {
  ready: function(fn) {
    var fired = false;

    function trigger() {
      if (fired) return;
      fired = true;
      fn();
    }

    // check if document is already loaded
    if (window.document.readyState === 'complete') {
      window.setTimeout(trigger);
    } else {
      this.on('DOMContentLoaded', trigger); // works for modern browsers and IE9
      // we can not use jqLite since we are not done loading and jQuery could be loaded later.
      // eslint-disable-next-line new-cap
      JQLite(window).on('load', trigger); // fallback to window.onload for others
    }
  },
  toString: function() {
    var value = [];
    forEach(this, function(e) { value.push('' + e);});
    return '[' + value.join(', ') + ']';
  },

  eq: function(index) {
      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
  },

  length: 0,
  push: push,
  sort: [].sort,
  splice: [].splice
};

//////////////////////////////////////////
// Functions iterating getter/setters.
// these functions return self on setter and
// value on get.
//////////////////////////////////////////
var BOOLEAN_ATTR = {};
forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
  BOOLEAN_ATTR[lowercase(value)] = value;
});
var BOOLEAN_ELEMENTS = {};
forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
  BOOLEAN_ELEMENTS[value] = true;
});
var ALIASED_ATTR = {
  'ngMinlength': 'minlength',
  'ngMaxlength': 'maxlength',
  'ngMin': 'min',
  'ngMax': 'max',
  'ngPattern': 'pattern'
};

function getBooleanAttrName(element, name) {
  // check dom last since we will most likely fail on name
  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

  // booleanAttr is here twice to minimize DOM access
  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
}

function getAliasedAttrName(name) {
  return ALIASED_ATTR[name];
}

forEach({
  data: jqLiteData,
  removeData: jqLiteRemoveData,
  hasData: jqLiteHasData,
  cleanData: jqLiteCleanData
}, function(fn, name) {
  JQLite[name] = fn;
});

forEach({
  data: jqLiteData,
  inheritedData: jqLiteInheritedData,

  scope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
  },

  isolateScope: function(element) {
    // Can't use jqLiteData here directly so we stay compatible with jQuery!
    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
  },

  controller: jqLiteController,

  injector: function(element) {
    return jqLiteInheritedData(element, '$injector');
  },

  removeAttr: function(element, name) {
    element.removeAttribute(name);
  },

  hasClass: jqLiteHasClass,

  css: function(element, name, value) {
    name = camelCase(name);

    if (isDefined(value)) {
      element.style[name] = value;
    } else {
      return element.style[name];
    }
  },

  attr: function(element, name, value) {
    var nodeType = element.nodeType;
    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT) {
      return;
    }
    var lowercasedName = lowercase(name);
    if (BOOLEAN_ATTR[lowercasedName]) {
      if (isDefined(value)) {
        if (value) {
          element[name] = true;
          element.setAttribute(name, lowercasedName);
        } else {
          element[name] = false;
          element.removeAttribute(lowercasedName);
        }
      } else {
        return (element[name] ||
                 (element.attributes.getNamedItem(name) || noop).specified)
               ? lowercasedName
               : undefined;
      }
    } else if (isDefined(value)) {
      element.setAttribute(name, value);
    } else if (element.getAttribute) {
      // the extra argument "2" is to get the right thing for a.href in IE, see jQuery code
      // some elements (e.g. Document) don't have get attribute, so return undefined
      var ret = element.getAttribute(name, 2);
      // normalize non-existing attributes to undefined (as jQuery)
      return ret === null ? undefined : ret;
    }
  },

  prop: function(element, name, value) {
    if (isDefined(value)) {
      element[name] = value;
    } else {
      return element[name];
    }
  },

  text: (function() {
    getText.$dv = '';
    return getText;

    function getText(element, value) {
      if (isUndefined(value)) {
        var nodeType = element.nodeType;
        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
      }
      element.textContent = value;
    }
  })(),

  val: function(element, value) {
    if (isUndefined(value)) {
      if (element.multiple && nodeName_(element) === 'select') {
        var result = [];
        forEach(element.options, function(option) {
          if (option.selected) {
            result.push(option.value || option.text);
          }
        });
        return result.length === 0 ? null : result;
      }
      return element.value;
    }
    element.value = value;
  },

  html: function(element, value) {
    if (isUndefined(value)) {
      return element.innerHTML;
    }
    jqLiteDealoc(element, true);
    element.innerHTML = value;
  },

  empty: jqLiteEmpty
}, function(fn, name) {
  /**
   * Properties: writes return selection, reads return first value
   */
  JQLite.prototype[name] = function(arg1, arg2) {
    var i, key;
    var nodeCount = this.length;

    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
    // in a way that survives minification.
    // jqLiteEmpty takes no arguments but is a setter.
    if (fn !== jqLiteEmpty &&
        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
      if (isObject(arg1)) {

        // we are a write, but the object properties are the key/values
        for (i = 0; i < nodeCount; i++) {
          if (fn === jqLiteData) {
            // data() takes the whole object in jQuery
            fn(this[i], arg1);
          } else {
            for (key in arg1) {
              fn(this[i], key, arg1[key]);
            }
          }
        }
        // return self for chaining
        return this;
      } else {
        // we are a read, so read the first child.
        // TODO: do we still need this?
        var value = fn.$dv;
        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
        for (var j = 0; j < jj; j++) {
          var nodeValue = fn(this[j], arg1, arg2);
          value = value ? value + nodeValue : nodeValue;
        }
        return value;
      }
    } else {
      // we are a write, so apply to all children
      for (i = 0; i < nodeCount; i++) {
        fn(this[i], arg1, arg2);
      }
      // return self for chaining
      return this;
    }
  };
});

function createEventHandler(element, events) {
  var eventHandler = function(event, type) {
    // jQuery specific api
    event.isDefaultPrevented = function() {
      return event.defaultPrevented;
    };

    var eventFns = events[type || event.type];
    var eventFnsLength = eventFns ? eventFns.length : 0;

    if (!eventFnsLength) return;

    if (isUndefined(event.immediatePropagationStopped)) {
      var originalStopImmediatePropagation = event.stopImmediatePropagation;
      event.stopImmediatePropagation = function() {
        event.immediatePropagationStopped = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }

        if (originalStopImmediatePropagation) {
          originalStopImmediatePropagation.call(event);
        }
      };
    }

    event.isImmediatePropagationStopped = function() {
      return event.immediatePropagationStopped === true;
    };

    // Some events have special handlers that wrap the real handler
    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

    // Copy event handlers in case event handlers array is modified during execution.
    if ((eventFnsLength > 1)) {
      eventFns = shallowCopy(eventFns);
    }

    for (var i = 0; i < eventFnsLength; i++) {
      if (!event.isImmediatePropagationStopped()) {
        handlerWrapper(element, event, eventFns[i]);
      }
    }
  };

  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
  //       events on `element`
  eventHandler.elem = element;
  return eventHandler;
}

function defaultHandlerWrapper(element, event, handler) {
  handler.call(element, event);
}

function specialMouseHandlerWrapper(target, event, handler) {
  // Refer to jQuery's implementation of mouseenter & mouseleave
  // Read about mouseenter and mouseleave:
  // http://www.quirksmode.org/js/events_mouse.html#link8
  var related = event.relatedTarget;
  // For mousenter/leave call the handler if related is outside the target.
  // NB: No relatedTarget if the mouse left/entered the browser window
  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
    handler.call(target, event);
  }
}

//////////////////////////////////////////
// Functions iterating traversal.
// These functions chain results into a single
// selector.
//////////////////////////////////////////
forEach({
  removeData: jqLiteRemoveData,

  on: function jqLiteOn(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

    // Do not add event handlers to non-elements because they will not be cleaned up.
    if (!jqLiteAcceptsData(element)) {
      return;
    }

    var expandoStore = jqLiteExpandoStore(element, true);
    var events = expandoStore.events;
    var handle = expandoStore.handle;

    if (!handle) {
      handle = expandoStore.handle = createEventHandler(element, events);
    }

    // http://jsperf.com/string-indexof-vs-split
    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
    var i = types.length;

    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
      var eventFns = events[type];

      if (!eventFns) {
        eventFns = events[type] = [];
        eventFns.specialHandlerWrapper = specialHandlerWrapper;
        if (type !== '$destroy' && !noEventListener) {
          addEventListenerFn(element, type, handle);
        }
      }

      eventFns.push(fn);
    };

    while (i--) {
      type = types[i];
      if (MOUSE_EVENT_MAP[type]) {
        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
        addHandler(type, undefined, true);
      } else {
        addHandler(type);
      }
    }
  },

  off: jqLiteOff,

  one: function(element, type, fn) {
    element = jqLite(element);

    //add the listener twice so that when it is called
    //you can remove the original function and still be
    //able to call element.off(ev, fn) normally
    element.on(type, function onFn() {
      element.off(type, fn);
      element.off(type, onFn);
    });
    element.on(type, fn);
  },

  replaceWith: function(element, replaceNode) {
    var index, parent = element.parentNode;
    jqLiteDealoc(element);
    forEach(new JQLite(replaceNode), function(node) {
      if (index) {
        parent.insertBefore(node, index.nextSibling);
      } else {
        parent.replaceChild(node, element);
      }
      index = node;
    });
  },

  children: function(element) {
    var children = [];
    forEach(element.childNodes, function(element) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        children.push(element);
      }
    });
    return children;
  },

  contents: function(element) {
    return element.contentDocument || element.childNodes || [];
  },

  append: function(element, node) {
    var nodeType = element.nodeType;
    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

    node = new JQLite(node);

    for (var i = 0, ii = node.length; i < ii; i++) {
      var child = node[i];
      element.appendChild(child);
    }
  },

  prepend: function(element, node) {
    if (element.nodeType === NODE_TYPE_ELEMENT) {
      var index = element.firstChild;
      forEach(new JQLite(node), function(child) {
        element.insertBefore(child, index);
      });
    }
  },

  wrap: function(element, wrapNode) {
    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
  },

  remove: jqLiteRemove,

  detach: function(element) {
    jqLiteRemove(element, true);
  },

  after: function(element, newElement) {
    var index = element, parent = element.parentNode;

    if (parent) {
      newElement = new JQLite(newElement);

      for (var i = 0, ii = newElement.length; i < ii; i++) {
        var node = newElement[i];
        parent.insertBefore(node, index.nextSibling);
        index = node;
      }
    }
  },

  addClass: jqLiteAddClass,
  removeClass: jqLiteRemoveClass,

  toggleClass: function(element, selector, condition) {
    if (selector) {
      forEach(selector.split(' '), function(className) {
        var classCondition = condition;
        if (isUndefined(classCondition)) {
          classCondition = !jqLiteHasClass(element, className);
        }
        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
      });
    }
  },

  parent: function(element) {
    var parent = element.parentNode;
    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
  },

  next: function(element) {
    return element.nextElementSibling;
  },

  find: function(element, selector) {
    if (element.getElementsByTagName) {
      return element.getElementsByTagName(selector);
    } else {
      return [];
    }
  },

  clone: jqLiteClone,

  triggerHandler: function(element, event, extraParameters) {

    var dummyEvent, eventFnsCopy, handlerArgs;
    var eventName = event.type || event;
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var eventFns = events && events[eventName];

    if (eventFns) {
      // Create a dummy event to pass to the handlers
      dummyEvent = {
        preventDefault: function() { this.defaultPrevented = true; },
        isDefaultPrevented: function() { return this.defaultPrevented === true; },
        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
        stopPropagation: noop,
        type: eventName,
        target: element
      };

      // If a custom event was provided then extend our dummy event with it
      if (event.type) {
        dummyEvent = extend(dummyEvent, event);
      }

      // Copy event handlers in case event handlers array is modified during execution.
      eventFnsCopy = shallowCopy(eventFns);
      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

      forEach(eventFnsCopy, function(fn) {
        if (!dummyEvent.isImmediatePropagationStopped()) {
          fn.apply(element, handlerArgs);
        }
      });
    }
  }
}, function(fn, name) {
  /**
   * chaining functions
   */
  JQLite.prototype[name] = function(arg1, arg2, arg3) {
    var value;

    for (var i = 0, ii = this.length; i < ii; i++) {
      if (isUndefined(value)) {
        value = fn(this[i], arg1, arg2, arg3);
        if (isDefined(value)) {
          // any function which returns a value needs to be wrapped
          value = jqLite(value);
        }
      } else {
        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
      }
    }
    return isDefined(value) ? value : this;
  };
});

// bind legacy bind/unbind to on/off
JQLite.prototype.bind = JQLite.prototype.on;
JQLite.prototype.unbind = JQLite.prototype.off;


// Provider for private $$jqLite service
/** @this */
function $$jqLiteProvider() {
  this.$get = function $$jqLite() {
    return extend(JQLite, {
      hasClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteHasClass(node, classes);
      },
      addClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteAddClass(node, classes);
      },
      removeClass: function(node, classes) {
        if (node.attr) node = node[0];
        return jqLiteRemoveClass(node, classes);
      }
    });
  };
}

/**
 * Computes a hash of an 'obj'.
 * Hash of a:
 *  string is string
 *  number is number as string
 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
 *         that is also assigned to the $$hashKey property of the object.
 *
 * @param obj
 * @returns {string} hash string such that the same input will have the same hash string.
 *         The resulting string key is in 'type:hashKey' format.
 */
function hashKey(obj, nextUidFn) {
  var key = obj && obj.$$hashKey;

  if (key) {
    if (typeof key === 'function') {
      key = obj.$$hashKey();
    }
    return key;
  }

  var objType = typeof obj;
  if (objType === 'function' || (objType === 'object' && obj !== null)) {
    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
  } else {
    key = objType + ':' + obj;
  }

  return key;
}

/**
 * HashMap which can use objects as keys
 */
function HashMap(array, isolatedUid) {
  if (isolatedUid) {
    var uid = 0;
    this.nextUid = function() {
      return ++uid;
    };
  }
  forEach(array, this.put, this);
}
HashMap.prototype = {
  /**
   * Store key value pair
   * @param key key to store can be any type
   * @param value value to store can be any type
   */
  put: function(key, value) {
    this[hashKey(key, this.nextUid)] = value;
  },

  /**
   * @param key
   * @returns {Object} the value for the key
   */
  get: function(key) {
    return this[hashKey(key, this.nextUid)];
  },

  /**
   * Remove the key/value pair
   * @param key
   */
  remove: function(key) {
    var value = this[key = hashKey(key, this.nextUid)];
    delete this[key];
    return value;
  }
};

var $$HashMapProvider = [/** @this */function() {
  this.$get = [function() {
    return HashMap;
  }];
}];

/**
 * @ngdoc function
 * @module ng
 * @name angular.injector
 * @kind function
 *
 * @description
 * Creates an injector object that can be used for retrieving services as well as for
 * dependency injection (see {@link guide/di dependency injection}).
 *
 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
 *     {@link angular.module}. The `ng` module must be explicitly added.
 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
 *     disallows argument name annotation inference.
 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
 *
 * @example
 * Typical usage
 * ```js
 *   // create an injector
 *   var $injector = angular.injector(['ng']);
 *
 *   // use the injector to kick off your application
 *   // use the type inference to auto inject arguments, or use implicit injection
 *   $injector.invoke(function($rootScope, $compile, $document) {
 *     $compile($document)($rootScope);
 *     $rootScope.$digest();
 *   });
 * ```
 *
 * Sometimes you want to get access to the injector of a currently running Angular app
 * from outside Angular. Perhaps, you want to inject and compile some markup after the
 * application has been bootstrapped. You can do this using the extra `injector()` added
 * to JQuery/jqLite elements. See {@link angular.element}.
 *
 * *This is fairly rare but could be the case if a third party library is injecting the
 * markup.*
 *
 * In the following example a new block of HTML containing a `ng-controller`
 * directive is added to the end of the document body by JQuery. We then compile and link
 * it into the current AngularJS scope.
 *
 * ```js
 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
 * $(document.body).append($div);
 *
 * angular.element(document).injector().invoke(function($compile) {
 *   var scope = angular.element($div).scope();
 *   $compile($div)(scope);
 * });
 * ```
 */


/**
 * @ngdoc module
 * @name auto
 * @installation
 * @description
 *
 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
 */

var ARROW_ARG = /^([^(]+?)=>/;
var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
var FN_ARG_SPLIT = /,/;
var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
var $injectorMinErr = minErr('$injector');

function stringifyFn(fn) {
  // Support: Chrome 50-51 only
  // Creating a new string by adding `' '` at the end, to hack around some bug in Chrome v50/51
  // (See https://github.com/angular/angular.js/issues/14487.)
  // TODO (gkalpak): Remove workaround when Chrome v52 is released
  return Function.prototype.toString.call(fn) + ' ';
}

function extractArgs(fn) {
  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
  return args;
}

function anonFn(fn) {
  // For anonymous functions, showing at the very least the function signature can help in
  // debugging.
  var args = extractArgs(fn);
  if (args) {
    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
  }
  return 'fn';
}

function annotate(fn, strictDi, name) {
  var $inject,
      argDecl,
      last;

  if (typeof fn === 'function') {
    if (!($inject = fn.$inject)) {
      $inject = [];
      if (fn.length) {
        if (strictDi) {
          if (!isString(name) || !name) {
            name = fn.name || anonFn(fn);
          }
          throw $injectorMinErr('strictdi',
            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
        }
        argDecl = extractArgs(fn);
        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
          arg.replace(FN_ARG, function(all, underscore, name) {
            $inject.push(name);
          });
        });
      }
      fn.$inject = $inject;
    }
  } else if (isArray(fn)) {
    last = fn.length - 1;
    assertArgFn(fn[last], 'fn');
    $inject = fn.slice(0, last);
  } else {
    assertArgFn(fn, 'fn', true);
  }
  return $inject;
}

///////////////////////////////////////

/**
 * @ngdoc service
 * @name $injector
 *
 * @description
 *
 * `$injector` is used to retrieve object instances as defined by
 * {@link auto.$provide provider}, instantiate types, invoke methods,
 * and load modules.
 *
 * The following always holds true:
 *
 * ```js
 *   var $injector = angular.injector();
 *   expect($injector.get('$injector')).toBe($injector);
 *   expect($injector.invoke(function($injector) {
 *     return $injector;
 *   })).toBe($injector);
 * ```
 *
 * # Injection Function Annotation
 *
 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
 * following are all valid ways of annotating function with injection arguments and are equivalent.
 *
 * ```js
 *   // inferred (only works if code not minified/obfuscated)
 *   $injector.invoke(function(serviceA){});
 *
 *   // annotated
 *   function explicit(serviceA) {};
 *   explicit.$inject = ['serviceA'];
 *   $injector.invoke(explicit);
 *
 *   // inline
 *   $injector.invoke(['serviceA', function(serviceA){}]);
 * ```
 *
 * ## Inference
 *
 * In JavaScript calling `toString()` on a function returns the function definition. The definition
 * can then be parsed and the function arguments can be extracted. This method of discovering
 * annotations is disallowed when the injector is in strict mode.
 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
 * argument names.
 *
 * ## `$inject` Annotation
 * By adding an `$inject` property onto a function the injection parameters can be specified.
 *
 * ## Inline
 * As an array of injection names, where the last item in the array is the function to call.
 */

/**
 * @ngdoc method
 * @name $injector#get
 *
 * @description
 * Return an instance of the service.
 *
 * @param {string} name The name of the instance to retrieve.
 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
 * @return {*} The instance.
 */

/**
 * @ngdoc method
 * @name $injector#invoke
 *
 * @description
 * Invoke the method and supply the method arguments from the `$injector`.
 *
 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
 *   injected according to the {@link guide/di $inject Annotation} rules.
 * @param {Object=} self The `this` for the invoked method.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 *                         object first, before the `$injector` is consulted.
 * @returns {*} the value returned by the invoked `fn` function.
 */

/**
 * @ngdoc method
 * @name $injector#has
 *
 * @description
 * Allows the user to query if the particular service exists.
 *
 * @param {string} name Name of the service to query.
 * @returns {boolean} `true` if injector has given service.
 */

/**
 * @ngdoc method
 * @name $injector#instantiate
 * @description
 * Create a new instance of JS type. The method takes a constructor function, invokes the new
 * operator, and supplies all of the arguments to the constructor function as specified by the
 * constructor annotation.
 *
 * @param {Function} Type Annotated constructor function.
 * @param {Object=} locals Optional object. If preset then any argument names are read from this
 * object first, before the `$injector` is consulted.
 * @returns {Object} new instance of `Type`.
 */

/**
 * @ngdoc method
 * @name $injector#annotate
 *
 * @description
 * Returns an array of service names which the function is requesting for injection. This API is
 * used by the injector to determine which services need to be injected into the function when the
 * function is invoked. There are three ways in which the function can be annotated with the needed
 * dependencies.
 *
 * # Argument names
 *
 * The simplest form is to extract the dependencies from the arguments of the function. This is done
 * by converting the function into a string using `toString()` method and extracting the argument
 * names.
 * ```js
 *   // Given
 *   function MyController($scope, $route) {
 *     // ...
 *   }
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * You can disallow this method by using strict injection mode.
 *
 * This method does not work with code minification / obfuscation. For this reason the following
 * annotation strategies are supported.
 *
 * # The `$inject` property
 *
 * If a function has an `$inject` property and its value is an array of strings, then the strings
 * represent names of services to be injected into the function.
 * ```js
 *   // Given
 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
 *     // ...
 *   }
 *   // Define function dependencies
 *   MyController['$inject'] = ['$scope', '$route'];
 *
 *   // Then
 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
 * ```
 *
 * # The array notation
 *
 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
 * is very inconvenient. In these situations using the array notation to specify the dependencies in
 * a way that survives minification is a better choice:
 *
 * ```js
 *   // We wish to write this (not minification / obfuscation safe)
 *   injector.invoke(function($compile, $rootScope) {
 *     // ...
 *   });
 *
 *   // We are forced to write break inlining
 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
 *     // ...
 *   };
 *   tmpFn.$inject = ['$compile', '$rootScope'];
 *   injector.invoke(tmpFn);
 *
 *   // To better support inline function the inline annotation is supported
 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
 *     // ...
 *   }]);
 *
 *   // Therefore
 *   expect(injector.annotate(
 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
 *    ).toEqual(['$compile', '$rootScope']);
 * ```
 *
 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
 * be retrieved as described above.
 *
 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
 *
 * @returns {Array.<string>} The names of the services which the function requires.
 */



/**
 * @ngdoc service
 * @name $provide
 *
 * @description
 *
 * The {@link auto.$provide $provide} service has a number of methods for registering components
 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
 * {@link angular.Module}.
 *
 * An Angular **service** is a singleton object created by a **service factory**.  These **service
 * factories** are functions which, in turn, are created by a **service provider**.
 * The **service providers** are constructor functions. When instantiated they must contain a
 * property called `$get`, which holds the **service factory** function.
 *
 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
 * function to get the instance of the **service**.
 *
 * Often services have no configuration options and there is no need to add methods to the service
 * provider.  The provider will be no more than a constructor function with a `$get` property. For
 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
 * services without specifying a provider.
 *
 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
 *     {@link auto.$injector $injector}
 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
 *     providers and services.
 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
 *     services, not providers.
 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
 *     given factory function.
 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
 *      a new object using the given constructor function.
 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
 *      will be able to modify or replace the implementation of another service.
 *
 * See the individual methods for more information and examples.
 */

/**
 * @ngdoc method
 * @name $provide#provider
 * @description
 *
 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
 * are constructor functions, whose instances are responsible for "providing" a factory for a
 * service.
 *
 * Service provider names start with the name of the service they provide followed by `Provider`.
 * For example, the {@link ng.$log $log} service has a provider called
 * {@link ng.$logProvider $logProvider}.
 *
 * Service provider objects can have additional methods which allow configuration of the provider
 * and its service. Importantly, you can configure what kind of service is created by the `$get`
 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
 * method {@link ng.$logProvider#debugEnabled debugEnabled}
 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
 * console or not.
 *
 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                        'Provider'` key.
 * @param {(Object|function())} provider If the provider is:
 *
 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
 *   - `Constructor`: a new instance of the provider will be created using
 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
 *
 * @returns {Object} registered provider instance

 * @example
 *
 * The following example shows how to create a simple event tracking service and register it using
 * {@link auto.$provide#provider $provide.provider()}.
 *
 * ```js
 *  // Define the eventTracker provider
 *  function EventTrackerProvider() {
 *    var trackingUrl = '/track';
 *
 *    // A provider method for configuring where the tracked events should been saved
 *    this.setTrackingUrl = function(url) {
 *      trackingUrl = url;
 *    };
 *
 *    // The service factory function
 *    this.$get = ['$http', function($http) {
 *      var trackedEvents = {};
 *      return {
 *        // Call this to track an event
 *        event: function(event) {
 *          var count = trackedEvents[event] || 0;
 *          count += 1;
 *          trackedEvents[event] = count;
 *          return count;
 *        },
 *        // Call this to save the tracked events to the trackingUrl
 *        save: function() {
 *          $http.post(trackingUrl, trackedEvents);
 *        }
 *      };
 *    }];
 *  }
 *
 *  describe('eventTracker', function() {
 *    var postSpy;
 *
 *    beforeEach(module(function($provide) {
 *      // Register the eventTracker provider
 *      $provide.provider('eventTracker', EventTrackerProvider);
 *    }));
 *
 *    beforeEach(module(function(eventTrackerProvider) {
 *      // Configure eventTracker provider
 *      eventTrackerProvider.setTrackingUrl('/custom-track');
 *    }));
 *
 *    it('tracks events', inject(function(eventTracker) {
 *      expect(eventTracker.event('login')).toEqual(1);
 *      expect(eventTracker.event('login')).toEqual(2);
 *    }));
 *
 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
 *      postSpy = spyOn($http, 'post');
 *      eventTracker.event('login');
 *      eventTracker.save();
 *      expect(postSpy).toHaveBeenCalled();
 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
 *    }));
 *  });
 * ```
 */

/**
 * @ngdoc method
 * @name $provide#factory
 * @description
 *
 * Register a **service factory**, which will be called to return the service instance.
 * This is short for registering a service where its provider consists of only a `$get` property,
 * which is the given service factory function.
 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
 * configure your service in a provider.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service
 * ```js
 *   $provide.factory('ping', ['$http', function($http) {
 *     return function ping() {
 *       return $http.send('/ping');
 *     };
 *   }]);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#service
 * @description
 *
 * Register a **service constructor**, which will be invoked with `new` to create the service
 * instance.
 * This is short for registering a service where its provider's `$get` property is a factory
 * function that returns an instance instantiated by the injector from the service constructor
 * function.
 *
 * Internally it looks a bit like this:
 *
 * ```
 * {
 *   $get: function() {
 *     return $injector.instantiate(constructor);
 *   }
 * }
 * ```
 *
 *
 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
 * as a type/class.
 *
 * @param {string} name The name of the instance.
 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
 *     that will be instantiated.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here is an example of registering a service using
 * {@link auto.$provide#service $provide.service(class)}.
 * ```js
 *   var Ping = function($http) {
 *     this.$http = $http;
 *   };
 *
 *   Ping.$inject = ['$http'];
 *
 *   Ping.prototype.send = function() {
 *     return this.$http.get('/ping');
 *   };
 *   $provide.service('ping', Ping);
 * ```
 * You would then inject and use this service like this:
 * ```js
 *   someModule.controller('Ctrl', ['ping', function(ping) {
 *     ping.send();
 *   }]);
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#value
 * @description
 *
 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
 * number, an array, an object or a function. This is short for registering a service where its
 * provider's `$get` property is a factory function that takes no arguments and returns the **value
 * service**. That also means it is not possible to inject other services into a value service.
 *
 * Value services are similar to constant services, except that they cannot be injected into a
 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
 * an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the instance.
 * @param {*} value The value.
 * @returns {Object} registered provider instance
 *
 * @example
 * Here are some examples of creating value services.
 * ```js
 *   $provide.value('ADMIN_USER', 'admin');
 *
 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
 *
 *   $provide.value('halfOf', function(value) {
 *     return value / 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#constant
 * @description
 *
 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
 * possible to inject other services into a constant.
 *
 * But unlike {@link auto.$provide#value value}, a constant can be
 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
 *
 * @param {string} name The name of the constant.
 * @param {*} value The constant value.
 * @returns {Object} registered instance
 *
 * @example
 * Here a some examples of creating constants:
 * ```js
 *   $provide.constant('SHARD_HEIGHT', 306);
 *
 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
 *
 *   $provide.constant('double', function(value) {
 *     return value * 2;
 *   });
 * ```
 */


/**
 * @ngdoc method
 * @name $provide#decorator
 * @description
 *
 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
 * intercepts the creation of a service, allowing it to override or modify the behavior of the
 * service. The return value of the decorator function may be the original service, or a new service
 * that replaces (or wraps and delegates to) the original service.
 *
 * You can find out more about using decorators in the {@link guide/decorators} guide.
 *
 * @param {string} name The name of the service to decorate.
 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
 *    provided and should return the decorated service instance. The function is called using
 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
 *    Local injection arguments:
 *
 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
 *      decorated or delegated to.
 *
 * @example
 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
 * calls to {@link ng.$log#error $log.warn()}.
 * ```js
 *   $provide.decorator('$log', ['$delegate', function($delegate) {
 *     $delegate.warn = $delegate.error;
 *     return $delegate;
 *   }]);
 * ```
 */


function createInjector(modulesToLoad, strictDi) {
  strictDi = (strictDi === true);
  var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new HashMap([], true),
      providerCache = {
        $provide: {
            provider: supportObject(provider),
            factory: supportObject(factory),
            service: supportObject(service),
            value: supportObject(value),
            constant: supportObject(constant),
            decorator: decorator
          }
      },
      providerInjector = (providerCache.$injector =
          createInternalInjector(providerCache, function(serviceName, caller) {
            if (angular.isString(caller)) {
              path.push(caller);
            }
            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
          })),
      instanceCache = {},
      protoInstanceInjector =
          createInternalInjector(instanceCache, function(serviceName, caller) {
            var provider = providerInjector.get(serviceName + providerSuffix, caller);
            return instanceInjector.invoke(
                provider.$get, provider, undefined, serviceName);
          }),
      instanceInjector = protoInstanceInjector;

  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
  var runBlocks = loadModules(modulesToLoad);
  instanceInjector = protoInstanceInjector.get('$injector');
  instanceInjector.strictDi = strictDi;
  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });

  return instanceInjector;

  ////////////////////////////////////
  // $provider
  ////////////////////////////////////

  function supportObject(delegate) {
    return function(key, value) {
      if (isObject(key)) {
        forEach(key, reverseParams(delegate));
      } else {
        return delegate(key, value);
      }
    };
  }

  function provider(name, provider_) {
    assertNotHasOwnProperty(name, 'service');
    if (isFunction(provider_) || isArray(provider_)) {
      provider_ = providerInjector.instantiate(provider_);
    }
    if (!provider_.$get) {
      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
    }
    return (providerCache[name + providerSuffix] = provider_);
  }

  function enforceReturnValue(name, factory) {
    return /** @this */ function enforcedReturnValue() {
      var result = instanceInjector.invoke(factory, this);
      if (isUndefined(result)) {
        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
      }
      return result;
    };
  }

  function factory(name, factoryFn, enforce) {
    return provider(name, {
      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
    });
  }

  function service(name, constructor) {
    return factory(name, ['$injector', function($injector) {
      return $injector.instantiate(constructor);
    }]);
  }

  function value(name, val) { return factory(name, valueFn(val), false); }

  function constant(name, value) {
    assertNotHasOwnProperty(name, 'constant');
    providerCache[name] = value;
    instanceCache[name] = value;
  }

  function decorator(serviceName, decorFn) {
    var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;

    origProvider.$get = function() {
      var origInstance = instanceInjector.invoke(orig$get, origProvider);
      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
    };
  }

  ////////////////////////////////////
  // Module Loading
  ////////////////////////////////////
  function loadModules(modulesToLoad) {
    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
    var runBlocks = [], moduleFn;
    forEach(modulesToLoad, function(module) {
      if (loadedModules.get(module)) return;
      loadedModules.put(module, true);

      function runInvokeQueue(queue) {
        var i, ii;
        for (i = 0, ii = queue.length; i < ii; i++) {
          var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);

          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
        }
      }

      try {
        if (isString(module)) {
          moduleFn = angularModule(module);
          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
          runInvokeQueue(moduleFn._invokeQueue);
          runInvokeQueue(moduleFn._configBlocks);
        } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
        } else {
          assertArgFn(module, 'module');
        }
      } catch (e) {
        if (isArray(module)) {
          module = module[module.length - 1];
        }
        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
          // Safari & FF's stack traces don't contain error.message content
          // unlike those of Chrome and IE
          // So if stack doesn't contain message, we create a new string that contains both.
          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
          // eslint-disable-next-line no-ex-assign
          e = e.message + '\n' + e.stack;
        }
        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
                  module, e.stack || e.message || e);
      }
    });
    return runBlocks;
  }

  ////////////////////////////////////
  // internal Injector
  ////////////////////////////////////

  function createInternalInjector(cache, factory) {

    function getService(serviceName, caller) {
      if (cache.hasOwnProperty(serviceName)) {
        if (cache[serviceName] === INSTANTIATING) {
          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
                    serviceName + ' <- ' + path.join(' <- '));
        }
        return cache[serviceName];
      } else {
        try {
          path.unshift(serviceName);
          cache[serviceName] = INSTANTIATING;
          cache[serviceName] = factory(serviceName, caller);
          return cache[serviceName];
        } catch (err) {
          if (cache[serviceName] === INSTANTIATING) {
            delete cache[serviceName];
          }
          throw err;
        } finally {
          path.shift();
        }
      }
    }


    function injectionArgs(fn, locals, serviceName) {
      var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);

      for (var i = 0, length = $inject.length; i < length; i++) {
        var key = $inject[i];
        if (typeof key !== 'string') {
          throw $injectorMinErr('itkn',
                  'Incorrect injection token! Expected service name as string, got {0}', key);
        }
        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
                                                         getService(key, serviceName));
      }
      return args;
    }

    function isClass(func) {
      // IE 9-11 do not support classes and IE9 leaks with the code below.
      if (msie <= 11) {
        return false;
      }
      // Support: Edge 12-13 only
      // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
      return typeof func === 'function'
        && /^(?:class\b|constructor\()/.test(stringifyFn(func));
    }

    function invoke(fn, self, locals, serviceName) {
      if (typeof locals === 'string') {
        serviceName = locals;
        locals = null;
      }

      var args = injectionArgs(fn, locals, serviceName);
      if (isArray(fn)) {
        fn = fn[fn.length - 1];
      }

      if (!isClass(fn)) {
        // http://jsperf.com/angularjs-invoke-apply-vs-switch
        // #5388
        return fn.apply(self, args);
      } else {
        args.unshift(null);
        return new (Function.prototype.bind.apply(fn, args))();
      }
    }


    function instantiate(Type, locals, serviceName) {
      // Check if Type is annotated and use just the given function at n-1 as parameter
      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
      var args = injectionArgs(Type, locals, serviceName);
      // Empty object at position 0 is ignored for invocation with `new`, but required.
      args.unshift(null);
      return new (Function.prototype.bind.apply(ctor, args))();
    }


    return {
      invoke: invoke,
      instantiate: instantiate,
      get: getService,
      annotate: createInjector.$$annotate,
      has: function(name) {
        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
      }
    };
  }
}

createInjector.$$annotate = annotate;

/**
 * @ngdoc provider
 * @name $anchorScrollProvider
 * @this
 *
 * @description
 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
 * {@link ng.$location#hash $location.hash()} changes.
 */
function $AnchorScrollProvider() {

  var autoScrollingEnabled = true;

  /**
   * @ngdoc method
   * @name $anchorScrollProvider#disableAutoScrolling
   *
   * @description
   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
   * Use this method to disable automatic scrolling.
   *
   * If automatic scrolling is disabled, one must explicitly call
   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
   * current hash.
   */
  this.disableAutoScrolling = function() {
    autoScrollingEnabled = false;
  };

  /**
   * @ngdoc service
   * @name $anchorScroll
   * @kind function
   * @requires $window
   * @requires $location
   * @requires $rootScope
   *
   * @description
   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
   * in the
   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
   *
   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
   * match any anchor whenever it changes. This can be disabled by calling
   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
   *
   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
   * vertical scroll-offset (either fixed or dynamic).
   *
   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
   *                       {@link ng.$location#hash $location.hash()} will be used.
   *
   * @property {(number|function|jqLite)} yOffset
   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
   * positioned elements at the top of the page, such as navbars, headers etc.
   *
   * `yOffset` can be specified in various ways:
   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
   *   a number representing the offset (in pixels).<br /><br />
   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
   *   the top of the page to the element's bottom will be used as offset.<br />
   *   **Note**: The element will be taken into account only as long as its `position` is set to
   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
   *   their height and/or positioning according to the viewport's size.
   *
   * <br />
   * <div class="alert alert-warning">
   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
   * not some child element.
   * </div>
   *
   * @example
     <example module="anchorScrollExample" name="anchor-scroll">
       <file name="index.html">
         <div id="scrollArea" ng-controller="ScrollController">
           <a ng-click="gotoBottom()">Go to bottom</a>
           <a id="bottom"></a> You're at the bottom!
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollExample', [])
           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
             function($scope, $location, $anchorScroll) {
               $scope.gotoBottom = function() {
                 // set the location.hash to the id of
                 // the element you wish to scroll to.
                 $location.hash('bottom');

                 // call $anchorScroll()
                 $anchorScroll();
               };
             }]);
       </file>
       <file name="style.css">
         #scrollArea {
           height: 280px;
           overflow: auto;
         }

         #bottom {
           display: block;
           margin-top: 2000px;
         }
       </file>
     </example>
   *
   * <hr />
   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
   *
   * @example
     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
       <file name="index.html">
         <div class="fixed-header" ng-controller="headerCtrl">
           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
             Go to anchor {{x}}
           </a>
         </div>
         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
           Anchor {{x}} of 5
         </div>
       </file>
       <file name="script.js">
         angular.module('anchorScrollOffsetExample', [])
           .run(['$anchorScroll', function($anchorScroll) {
             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
           }])
           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
             function($anchorScroll, $location, $scope) {
               $scope.gotoAnchor = function(x) {
                 var newHash = 'anchor' + x;
                 if ($location.hash() !== newHash) {
                   // set the $location.hash to `newHash` and
                   // $anchorScroll will automatically scroll to it
                   $location.hash('anchor' + x);
                 } else {
                   // call $anchorScroll() explicitly,
                   // since $location.hash hasn't changed
                   $anchorScroll();
                 }
               };
             }
           ]);
       </file>
       <file name="style.css">
         body {
           padding-top: 50px;
         }

         .anchor {
           border: 2px dashed DarkOrchid;
           padding: 10px 10px 200px 10px;
         }

         .fixed-header {
           background-color: rgba(0, 0, 0, 0.2);
           height: 50px;
           position: fixed;
           top: 0; left: 0; right: 0;
         }

         .fixed-header > a {
           display: inline-block;
           margin: 5px 15px;
         }
       </file>
     </example>
   */
  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
    var document = $window.document;

    // Helper function to get first anchor from a NodeList
    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
    //  and working in all supported browsers.)
    function getFirstAnchor(list) {
      var result = null;
      Array.prototype.some.call(list, function(element) {
        if (nodeName_(element) === 'a') {
          result = element;
          return true;
        }
      });
      return result;
    }

    function getYOffset() {

      var offset = scroll.yOffset;

      if (isFunction(offset)) {
        offset = offset();
      } else if (isElement(offset)) {
        var elem = offset[0];
        var style = $window.getComputedStyle(elem);
        if (style.position !== 'fixed') {
          offset = 0;
        } else {
          offset = elem.getBoundingClientRect().bottom;
        }
      } else if (!isNumber(offset)) {
        offset = 0;
      }

      return offset;
    }

    function scrollTo(elem) {
      if (elem) {
        elem.scrollIntoView();

        var offset = getYOffset();

        if (offset) {
          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
          // top of the viewport.
          //
          // IF the number of pixels from the top of `elem` to the end of the page's content is less
          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
          // way down the page.
          //
          // This is often the case for elements near the bottom of the page.
          //
          // In such cases we do not need to scroll the whole `offset` up, just the difference between
          // the top of the element and the offset, which is enough to align the top of `elem` at the
          // desired position.
          var elemTop = elem.getBoundingClientRect().top;
          $window.scrollBy(0, elemTop - offset);
        }
      } else {
        $window.scrollTo(0, 0);
      }
    }

    function scroll(hash) {
      // Allow numeric hashes
      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
      var elm;

      // empty hash, scroll to the top of the page
      if (!hash) scrollTo(null);

      // element with given id
      else if ((elm = document.getElementById(hash))) scrollTo(elm);

      // first anchor with given name :-D
      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

      // no element and hash === 'top', scroll to the top of the page
      else if (hash === 'top') scrollTo(null);
    }

    // does not scroll when user clicks on anchor link that is currently on
    // (no url change, no $location.hash() change), browser native does scroll
    if (autoScrollingEnabled) {
      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
        function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function() {
            $rootScope.$evalAsync(scroll);
          });
        });
    }

    return scroll;
  }];
}

var $animateMinErr = minErr('$animate');
var ELEMENT_NODE = 1;
var NG_ANIMATE_CLASSNAME = 'ng-animate';

function mergeClasses(a,b) {
  if (!a && !b) return '';
  if (!a) return b;
  if (!b) return a;
  if (isArray(a)) a = a.join(' ');
  if (isArray(b)) b = b.join(' ');
  return a + ' ' + b;
}

function extractElementNode(element) {
  for (var i = 0; i < element.length; i++) {
    var elm = element[i];
    if (elm.nodeType === ELEMENT_NODE) {
      return elm;
    }
  }
}

function splitClasses(classes) {
  if (isString(classes)) {
    classes = classes.split(' ');
  }

  // Use createMap() to prevent class assumptions involving property names in
  // Object.prototype
  var obj = createMap();
  forEach(classes, function(klass) {
    // sometimes the split leaves empty string values
    // incase extra spaces were applied to the options
    if (klass.length) {
      obj[klass] = true;
    }
  });
  return obj;
}

// if any other type of options value besides an Object value is
// passed into the $animate.method() animation then this helper code
// will be run which will ignore it. While this patch is not the
// greatest solution to this, a lot of existing plugins depend on
// $animate to either call the callback (< 1.2) or return a promise
// that can be changed. This helper function ensures that the options
// are wiped clean incase a callback function is provided.
function prepareAnimateOptions(options) {
  return isObject(options)
      ? options
      : {};
}

var $$CoreAnimateJsProvider = /** @this */ function() {
  this.$get = noop;
};

// this is prefixed with Core since it conflicts with
// the animateQueueProvider defined in ngAnimate/animateQueue.js
var $$CoreAnimateQueueProvider = /** @this */ function() {
  var postDigestQueue = new HashMap();
  var postDigestElements = [];

  this.$get = ['$$AnimateRunner', '$rootScope',
       function($$AnimateRunner,   $rootScope) {
    return {
      enabled: noop,
      on: noop,
      off: noop,
      pin: noop,

      push: function(element, event, options, domOperation) {
        if (domOperation) {
          domOperation();
        }

        options = options || {};
        if (options.from) {
          element.css(options.from);
        }
        if (options.to) {
          element.css(options.to);
        }

        if (options.addClass || options.removeClass) {
          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
        }

        var runner = new $$AnimateRunner();

        // since there are no animations to run the runner needs to be
        // notified that the animation call is complete.
        runner.complete();
        return runner;
      }
    };


    function updateData(data, classes, value) {
      var changed = false;
      if (classes) {
        classes = isString(classes) ? classes.split(' ') :
                  isArray(classes) ? classes : [];
        forEach(classes, function(className) {
          if (className) {
            changed = true;
            data[className] = value;
          }
        });
      }
      return changed;
    }

    function handleCSSClassChanges() {
      forEach(postDigestElements, function(element) {
        var data = postDigestQueue.get(element);
        if (data) {
          var existing = splitClasses(element.attr('class'));
          var toAdd = '';
          var toRemove = '';
          forEach(data, function(status, className) {
            var hasClass = !!existing[className];
            if (status !== hasClass) {
              if (status) {
                toAdd += (toAdd.length ? ' ' : '') + className;
              } else {
                toRemove += (toRemove.length ? ' ' : '') + className;
              }
            }
          });

          forEach(element, function(elm) {
            if (toAdd) {
              jqLiteAddClass(elm, toAdd);
            }
            if (toRemove) {
              jqLiteRemoveClass(elm, toRemove);
            }
          });
          postDigestQueue.remove(element);
        }
      });
      postDigestElements.length = 0;
    }


    function addRemoveClassesPostDigest(element, add, remove) {
      var data = postDigestQueue.get(element) || {};

      var classesAdded = updateData(data, add, true);
      var classesRemoved = updateData(data, remove, false);

      if (classesAdded || classesRemoved) {

        postDigestQueue.put(element, data);
        postDigestElements.push(element);

        if (postDigestElements.length === 1) {
          $rootScope.$$postDigest(handleCSSClassChanges);
        }
      }
    }
  }];
};

/**
 * @ngdoc provider
 * @name $animateProvider
 *
 * @description
 * Default implementation of $animate that doesn't perform any animations, instead just
 * synchronously performs DOM updates and resolves the returned runner promise.
 *
 * In order to enable animations the `ngAnimate` module has to be loaded.
 *
 * To see the functional implementation check out `src/ngAnimate/animate.js`.
 */
var $AnimateProvider = ['$provide', /** @this */ function($provide) {
  var provider = this;

  this.$$registeredAnimations = Object.create(null);

   /**
   * @ngdoc method
   * @name $animateProvider#register
   *
   * @description
   * Registers a new injectable animation factory function. The factory function produces the
   * animation object which contains callback functions for each event that is expected to be
   * animated.
   *
   *   * `eventFn`: `function(element, ... , doneFunction, options)`
   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
   *   on the type of animation additional arguments will be injected into the animation function. The
   *   list below explains the function signatures for the different animation methods:
   *
   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
   *   - addClass: function(element, addedClasses, doneFunction, options)
   *   - removeClass: function(element, removedClasses, doneFunction, options)
   *   - enter, leave, move: function(element, doneFunction, options)
   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
   *
   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
   *
   * ```js
   *   return {
   *     //enter, leave, move signature
   *     eventFn : function(element, done, options) {
   *       //code to run the animation
   *       //once complete, then run done()
   *       return function endFunction(wasCancelled) {
   *         //code to cancel the animation
   *       }
   *     }
   *   }
   * ```
   *
   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
   * @param {Function} factory The factory function that will be executed to return the animation
   *                           object.
   */
  this.register = function(name, factory) {
    if (name && name.charAt(0) !== '.') {
      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
    }

    var key = name + '-animation';
    provider.$$registeredAnimations[name.substr(1)] = key;
    $provide.factory(key, factory);
  };

  /**
   * @ngdoc method
   * @name $animateProvider#classNameFilter
   *
   * @description
   * Sets and/or returns the CSS class regular expression that is checked when performing
   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
   * When setting the `classNameFilter` value, animations will only be performed on elements
   * that successfully match the filter expression. This in turn can boost performance
   * for low-powered devices as well as applications containing a lot of structural operations.
   * @param {RegExp=} expression The className expression which will be checked against all animations
   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
   */
  this.classNameFilter = function(expression) {
    if (arguments.length === 1) {
      this.$$classNameFilter = (expression instanceof RegExp) ? expression : null;
      if (this.$$classNameFilter) {
        var reservedRegex = new RegExp('(\\s+|\\/)' + NG_ANIMATE_CLASSNAME + '(\\s+|\\/)');
        if (reservedRegex.test(this.$$classNameFilter.toString())) {
          throw $animateMinErr('nongcls','$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);

        }
      }
    }
    return this.$$classNameFilter;
  };

  this.$get = ['$$animateQueue', function($$animateQueue) {
    function domInsert(element, parentElement, afterElement) {
      // if for some reason the previous element was removed
      // from the dom sometime before this code runs then let's
      // just stick to using the parent element as the anchor
      if (afterElement) {
        var afterNode = extractElementNode(afterElement);
        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
          afterElement = null;
        }
      }
      if (afterElement) {
        afterElement.after(element);
      } else {
        parentElement.prepend(element);
      }
    }

    /**
     * @ngdoc service
     * @name $animate
     * @description The $animate service exposes a series of DOM utility methods that provide support
     * for animation hooks. The default behavior is the application of DOM operations, however,
     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
     * to ensure that animation runs with the triggered DOM operation.
     *
     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
     * included and only when it is active then the animation hooks that `$animate` triggers will be
     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
     *
     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
     *
     * To learn more about enabling animation support, click here to visit the
     * {@link ngAnimate ngAnimate module page}.
     */
    return {
      // we don't call it directly since non-existant arguments may
      // be interpreted as null within the sub enabled function

      /**
       *
       * @ngdoc method
       * @name $animate#on
       * @kind function
       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
       *    is fired with the following params:
       *
       * ```js
       * $animate.on('enter', container,
       *    function callback(element, phase) {
       *      // cool we detected an enter animation within the container
       *    }
       * );
       * ```
       *
       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
       *     as well as among its children
       * @param {Function} callback the callback function that will be fired when the listener is triggered
       *
       * The arguments present in the callback function are:
       * * `element` - The captured DOM element that the animation was fired on.
       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
       */
      on: $$animateQueue.on,

      /**
       *
       * @ngdoc method
       * @name $animate#off
       * @kind function
       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
       * can be used in three different ways depending on the arguments:
       *
       * ```js
       * // remove all the animation event listeners listening for `enter`
       * $animate.off('enter');
       *
       * // remove listeners for all animation events from the container element
       * $animate.off(container);
       *
       * // remove all the animation event listeners listening for `enter` on the given element and its children
       * $animate.off('enter', container);
       *
       * // remove the event listener function provided by `callback` that is set
       * // to listen for `enter` on the given `container` as well as its children
       * $animate.off('enter', container, callback);
       * ```
       *
       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
       * addClass, removeClass, etc...), or the container element. If it is the element, all other
       * arguments are ignored.
       * @param {DOMElement=} container the container element the event listener was placed on
       * @param {Function=} callback the callback function that was registered as the listener
       */
      off: $$animateQueue.off,

      /**
       * @ngdoc method
       * @name $animate#pin
       * @kind function
       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
       *    element despite being outside the realm of the application or within another application. Say for example if the application
       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
       *
       *    Note that this feature is only active when the `ngAnimate` module is used.
       *
       * @param {DOMElement} element the external element that will be pinned
       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
       */
      pin: $$animateQueue.pin,

      /**
       *
       * @ngdoc method
       * @name $animate#enabled
       * @kind function
       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
       * function can be called in four ways:
       *
       * ```js
       * // returns true or false
       * $animate.enabled();
       *
       * // changes the enabled state for all animations
       * $animate.enabled(false);
       * $animate.enabled(true);
       *
       * // returns true or false if animations are enabled for an element
       * $animate.enabled(element);
       *
       * // changes the enabled state for an element and its children
       * $animate.enabled(element, true);
       * $animate.enabled(element, false);
       * ```
       *
       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
       * @param {boolean=} enabled whether or not the animations will be enabled for the element
       *
       * @return {boolean} whether or not animations are enabled
       */
      enabled: $$animateQueue.enabled,

      /**
       * @ngdoc method
       * @name $animate#cancel
       * @kind function
       * @description Cancels the provided animation.
       *
       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
       */
      cancel: function(runner) {
        if (runner.end) {
          runner.end();
        }
      },

      /**
       *
       * @ngdoc method
       * @name $animate#enter
       * @kind function
       * @description Inserts the element into the DOM either after the `after` element (if provided) or
       *   as the first child within the `parent` element and then triggers an animation.
       *   A promise is returned that will be resolved during the next digest once the animation
       *   has completed.
       *
       * @param {DOMElement} element the element which will be inserted into the DOM
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      enter: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
      },

      /**
       *
       * @ngdoc method
       * @name $animate#move
       * @kind function
       * @description Inserts (moves) the element into its new position in the DOM either after
       *   the `after` element (if provided) or as the first child within the `parent` element
       *   and then triggers an animation. A promise is returned that will be resolved
       *   during the next digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be moved into the new DOM position
       * @param {DOMElement} parent the parent element which will append the element as
       *   a child (so long as the after element is not present)
       * @param {DOMElement=} after the sibling element after which the element will be appended
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      move: function(element, parent, after, options) {
        parent = parent && jqLite(parent);
        after = after && jqLite(after);
        parent = parent || after.parent();
        domInsert(element, parent, after);
        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
      },

      /**
       * @ngdoc method
       * @name $animate#leave
       * @kind function
       * @description Triggers an animation and then removes the element from the DOM.
       * When the function is called a promise is returned that will be resolved during the next
       * digest once the animation has completed.
       *
       * @param {DOMElement} element the element which will be removed from the DOM
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      leave: function(element, options) {
        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
          element.remove();
        });
      },

      /**
       * @ngdoc method
       * @name $animate#addClass
       * @kind function
       *
       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element already contains the CSS class or if the class is removed at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      addClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addclass, className);
        return $$animateQueue.push(element, 'addClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#removeClass
       * @kind function
       *
       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
       *   animation if element does not contain the CSS class or if the class is added at a later step.
       *   Note that class-based animations are treated differently compared to structural animations
       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
       *   depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      removeClass: function(element, className, options) {
        options = prepareAnimateOptions(options);
        options.removeClass = mergeClasses(options.removeClass, className);
        return $$animateQueue.push(element, 'removeClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#setClass
       * @kind function
       *
       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
       *    passed. Note that class-based animations are treated differently compared to structural animations
       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
       *    depending if CSS or JavaScript animations are used.
       *
       * @param {DOMElement} element the element which the CSS classes will be applied to
       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      setClass: function(element, add, remove, options) {
        options = prepareAnimateOptions(options);
        options.addClass = mergeClasses(options.addClass, add);
        options.removeClass = mergeClasses(options.removeClass, remove);
        return $$animateQueue.push(element, 'setClass', options);
      },

      /**
       * @ngdoc method
       * @name $animate#animate
       * @kind function
       *
       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
       * style in `to`, the style in `from` is applied immediately, and no animation is run.
       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
       * method (or as part of the `options` parameter):
       *
       * ```js
       * ngModule.animation('.my-inline-animation', function() {
       *   return {
       *     animate : function(element, from, to, done, options) {
       *       //animation
       *       done();
       *     }
       *   }
       * });
       * ```
       *
       * @param {DOMElement} element the element which the CSS styles will be applied to
       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
       *    (Note that if no animation is detected then this value will not be applied to the element.)
       * @param {object=} options an optional collection of options/styles that will be applied to the element.
       *   The object can have the following properties:
       *
       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
       *
       * @return {Promise} the animation callback promise
       */
      animate: function(element, from, to, className, options) {
        options = prepareAnimateOptions(options);
        options.from = options.from ? extend(options.from, from) : from;
        options.to   = options.to   ? extend(options.to, to)     : to;

        className = className || 'ng-inline-animate';
        options.tempClasses = mergeClasses(options.tempClasses, className);
        return $$animateQueue.push(element, 'animate', options);
      }
    };
  }];
}];

var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
  this.$get = ['$$rAF', function($$rAF) {
    var waitQueue = [];

    function waitForTick(fn) {
      waitQueue.push(fn);
      if (waitQueue.length > 1) return;
      $$rAF(function() {
        for (var i = 0; i < waitQueue.length; i++) {
          waitQueue[i]();
        }
        waitQueue = [];
      });
    }

    return function() {
      var passed = false;
      waitForTick(function() {
        passed = true;
      });
      return function(callback) {
        if (passed) {
          callback();
        } else {
          waitForTick(callback);
        }
      };
    };
  }];
};

var $$AnimateRunnerFactoryProvider = /** @this */ function() {
  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$document', '$timeout',
       function($q,   $sniffer,   $$animateAsyncRun,   $document,   $timeout) {

    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    AnimateRunner.chain = function(chain, callback) {
      var index = 0;

      next();
      function next() {
        if (index === chain.length) {
          callback(true);
          return;
        }

        chain[index](function(response) {
          if (response === false) {
            callback(false);
            return;
          }
          index++;
          next();
        });
      }
    };

    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    function AnimateRunner(host) {
      this.setHost(host);

      var rafTick = $$animateAsyncRun();
      var timeoutTick = function(fn) {
        $timeout(fn, 0, false);
      };

      this._doneCallbacks = [];
      this._tick = function(fn) {
        var doc = $document[0];

        // the document may not be ready or attached
        // to the module for some internal tests
        if (doc && doc.hidden) {
          timeoutTick(fn);
        } else {
          rafTick(fn);
        }
      };
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              if (status === false) {
                reject();
              } else {
                resolve();
              }
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._tick(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    return AnimateRunner;
  }];
};

/* exported $CoreAnimateCssProvider */

/**
 * @ngdoc service
 * @name $animateCss
 * @kind object
 * @this
 *
 * @description
 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
 * then the `$animateCss` service will actually perform animations.
 *
 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
 */
var $CoreAnimateCssProvider = function() {
  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {

    return function(element, initialOptions) {
      // all of the animation functions should create
      // a copy of the options data, however, if a
      // parent service has already created a copy then
      // we should stick to using that
      var options = initialOptions || {};
      if (!options.$$prepared) {
        options = copy(options);
      }

      // there is no point in applying the styles since
      // there is no animation that goes on at all in
      // this version of $animateCss.
      if (options.cleanupStyles) {
        options.from = options.to = null;
      }

      if (options.from) {
        element.css(options.from);
        options.from = null;
      }

      var closed, runner = new $$AnimateRunner();
      return {
        start: run,
        end: run
      };

      function run() {
        $$rAF(function() {
          applyAnimationContents();
          if (!closed) {
            runner.complete();
          }
          closed = true;
        });
        return runner;
      }

      function applyAnimationContents() {
        if (options.addClass) {
          element.addClass(options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          element.removeClass(options.removeClass);
          options.removeClass = null;
        }
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }
    };
  }];
};

/* global stripHash: true */

/**
 * ! This is a private undocumented service !
 *
 * @name $browser
 * @requires $log
 * @description
 * This object has two goals:
 *
 * - hide all the global state in the browser caused by the window object
 * - abstract away all the browser specific features and inconsistencies
 *
 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
 * service, which can be used for convenient testing of the application without the interaction with
 * the real browser apis.
 */
/**
 * @param {object} window The global window object.
 * @param {object} document jQuery wrapped document.
 * @param {object} $log window.console or an object with the same interface.
 * @param {object} $sniffer $sniffer service
 */
function Browser(window, document, $log, $sniffer) {
  var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {};

  self.isMock = false;

  var outstandingRequestCount = 0;
  var outstandingRequestCallbacks = [];

  // TODO(vojta): remove this temporary api
  self.$$completeOutstandingRequest = completeOutstandingRequest;
  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };

  /**
   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
   */
  function completeOutstandingRequest(fn) {
    try {
      fn.apply(null, sliceArgs(arguments, 1));
    } finally {
      outstandingRequestCount--;
      if (outstandingRequestCount === 0) {
        while (outstandingRequestCallbacks.length) {
          try {
            outstandingRequestCallbacks.pop()();
          } catch (e) {
            $log.error(e);
          }
        }
      }
    }
  }

  function getHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? '' : url.substr(index);
  }

  /**
   * @private
   * Note: this method is used only by scenario runner
   * TODO(vojta): prefix this method with $$ ?
   * @param {function()} callback Function that will be called when no outstanding request
   */
  self.notifyWhenNoOutstandingRequests = function(callback) {
    if (outstandingRequestCount === 0) {
      callback();
    } else {
      outstandingRequestCallbacks.push(callback);
    }
  };

  //////////////////////////////////////////////////////////////
  // URL API
  //////////////////////////////////////////////////////////////

  var cachedState, lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };

  cacheState();
  lastHistoryState = cachedState;

  /**
   * @name $browser#url
   *
   * @description
   * GETTER:
   * Without any argument, this method just returns current value of location.href.
   *
   * SETTER:
   * With at least one argument, this method sets url to new value.
   * If html5 history api supported, pushState/replaceState is used, otherwise
   * location.href/location.replace is used.
   * Returns its own instance to allow chaining
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to change url.
   *
   * @param {string} url New url (when used as setter)
   * @param {boolean=} replace Should new url replace current history record?
   * @param {object=} state object to use with pushState/replaceState
   */
  self.url = function(url, replace, state) {
    // In modern browsers `history.state` is `null` by default; treating it separately
    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
    if (isUndefined(state)) {
      state = null;
    }

    // Android Browser BFCache causes location, history reference to become stale.
    if (location !== window.location) location = window.location;
    if (history !== window.history) history = window.history;

    // setter
    if (url) {
      var sameState = lastHistoryState === state;

      // Don't change anything if previous and current URLs and states match. This also prevents
      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
      // See https://github.com/angular/angular.js/commit/ffb2701
      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
        return self;
      }
      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
      lastBrowserUrl = url;
      lastHistoryState = state;
      // Don't use history API if only the hash changed
      // due to a bug in IE10/IE11 which leads
      // to not firing a `hashchange` nor `popstate` event
      // in some cases (see #9143).
      if ($sniffer.history && (!sameBase || !sameState)) {
        history[replace ? 'replaceState' : 'pushState'](state, '', url);
        cacheState();
        // Do the assignment again so that those two variables are referentially identical.
        lastHistoryState = cachedState;
      } else {
        if (!sameBase) {
          pendingLocation = url;
        }
        if (replace) {
          location.replace(url);
        } else if (!sameBase) {
          location.href = url;
        } else {
          location.hash = getHash(url);
        }
        if (location.href !== url) {
          pendingLocation = url;
        }
      }
      if (pendingLocation) {
        pendingLocation = url;
      }
      return self;
    // getter
    } else {
      // - pendingLocation is needed as browsers don't allow to read out
      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
      //   https://openradar.appspot.com/22186109).
      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
      return pendingLocation || location.href.replace(/%27/g,'\'');
    }
  };

  /**
   * @name $browser#state
   *
   * @description
   * This method is a getter.
   *
   * Return history.state or null if history.state is undefined.
   *
   * @returns {object} state
   */
  self.state = function() {
    return cachedState;
  };

  var urlChangeListeners = [],
      urlChangeInit = false;

  function cacheStateAndFireUrlChange() {
    pendingLocation = null;
    cacheState();
    fireUrlChange();
  }

  // This variable should be used *only* inside the cacheState function.
  var lastCachedState = null;
  function cacheState() {
    // This should be the only place in $browser where `history.state` is read.
    cachedState = getCurrentState();
    cachedState = isUndefined(cachedState) ? null : cachedState;

    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
    if (equals(cachedState, lastCachedState)) {
      cachedState = lastCachedState;
    }
    lastCachedState = cachedState;
  }

  function fireUrlChange() {
    if (lastBrowserUrl === self.url() && lastHistoryState === cachedState) {
      return;
    }

    lastBrowserUrl = self.url();
    lastHistoryState = cachedState;
    forEach(urlChangeListeners, function(listener) {
      listener(self.url(), cachedState);
    });
  }

  /**
   * @name $browser#onUrlChange
   *
   * @description
   * Register callback function that will be called, when url changes.
   *
   * It's only called when the url is changed from outside of angular:
   * - user types different url into address bar
   * - user clicks on history (forward/back) button
   * - user clicks on a link
   *
   * It's not called when url is changed by $browser.url() method
   *
   * The listener gets called with new url as parameter.
   *
   * NOTE: this api is intended for use only by the $location service. Please use the
   * {@link ng.$location $location service} to monitor url changes in angular apps.
   *
   * @param {function(string)} listener Listener function to be called when url changes.
   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
   */
  self.onUrlChange = function(callback) {
    // TODO(vojta): refactor to use node's syntax for events
    if (!urlChangeInit) {
      // We listen on both (hashchange/popstate) when available, as some browsers (e.g. Opera)
      // don't fire popstate when user change the address bar and don't fire hashchange when url
      // changed by push/replaceState

      // html5 history api - popstate event
      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
      // hashchange event
      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

      urlChangeInit = true;
    }

    urlChangeListeners.push(callback);
    return callback;
  };

  /**
   * @private
   * Remove popstate and hashchange handler from window.
   *
   * NOTE: this api is intended for use only by $rootScope.
   */
  self.$$applicationDestroyed = function() {
    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
  };

  /**
   * Checks whether the url has changed outside of Angular.
   * Needs to be exported to be able to check for changes that have been done in sync,
   * as hashchange/popstate events fire in async.
   */
  self.$$checkUrlChange = fireUrlChange;

  //////////////////////////////////////////////////////////////
  // Misc API
  //////////////////////////////////////////////////////////////

  /**
   * @name $browser#baseHref
   *
   * @description
   * Returns current <base href>
   * (always relative - without domain)
   *
   * @returns {string} The current base href
   */
  self.baseHref = function() {
    var href = baseElement.attr('href');
    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
  };

  /**
   * @name $browser#defer
   * @param {function()} fn A function, who's execution should be deferred.
   * @param {number=} [delay=0] of milliseconds to defer the function execution.
   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
   *
   * @description
   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
   *
   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
   * via `$browser.defer.flush()`.
   *
   */
  self.defer = function(fn, delay) {
    var timeoutId;
    outstandingRequestCount++;
    timeoutId = setTimeout(function() {
      delete pendingDeferIds[timeoutId];
      completeOutstandingRequest(fn);
    }, delay || 0);
    pendingDeferIds[timeoutId] = true;
    return timeoutId;
  };


  /**
   * @name $browser#defer.cancel
   *
   * @description
   * Cancels a deferred task identified with `deferId`.
   *
   * @param {*} deferId Token returned by the `$browser.defer` function.
   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
   *                    canceled.
   */
  self.defer.cancel = function(deferId) {
    if (pendingDeferIds[deferId]) {
      delete pendingDeferIds[deferId];
      clearTimeout(deferId);
      completeOutstandingRequest(noop);
      return true;
    }
    return false;
  };

}

/** @this */
function $BrowserProvider() {
  this.$get = ['$window', '$log', '$sniffer', '$document',
      function($window, $log, $sniffer, $document) {
        return new Browser($window, $document, $log, $sniffer);
      }];
}

/**
 * @ngdoc service
 * @name $cacheFactory
 * @this
 *
 * @description
 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
 * them.
 *
 * ```js
 *
 *  var cache = $cacheFactory('cacheId');
 *  expect($cacheFactory.get('cacheId')).toBe(cache);
 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
 *
 *  cache.put("key", "value");
 *  cache.put("another key", "another value");
 *
 *  // We've specified no options on creation
 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
 *
 * ```
 *
 *
 * @param {string} cacheId Name or id of the newly created cache.
 * @param {object=} options Options object that specifies the cache behavior. Properties:
 *
 *   - `{number=}` `capacity` — turns the cache into LRU cache.
 *
 * @returns {object} Newly created cache object with the following set of methods:
 *
 * - `{object}` `info()` — Returns id, size, and options of cache.
 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
 *   it.
 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
 * - `{void}` `removeAll()` — Removes all cached values.
 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
 *
 * @example
   <example module="cacheExampleApp" name="cache-factory">
     <file name="index.html">
       <div ng-controller="CacheController">
         <input ng-model="newCacheKey" placeholder="Key">
         <input ng-model="newCacheValue" placeholder="Value">
         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>

         <p ng-if="keys.length">Cached Values</p>
         <div ng-repeat="key in keys">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="cache.get(key)"></b>
         </div>

         <p>Cache Info</p>
         <div ng-repeat="(key, value) in cache.info()">
           <span ng-bind="key"></span>
           <span>: </span>
           <b ng-bind="value"></b>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('cacheExampleApp', []).
         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
           $scope.keys = [];
           $scope.cache = $cacheFactory('cacheId');
           $scope.put = function(key, value) {
             if (angular.isUndefined($scope.cache.get(key))) {
               $scope.keys.push(key);
             }
             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
           };
         }]);
     </file>
     <file name="style.css">
       p {
         margin: 10px 0 3px;
       }
     </file>
   </example>
 */
function $CacheFactoryProvider() {

  this.$get = function() {
    var caches = {};

    function cacheFactory(cacheId, options) {
      if (cacheId in caches) {
        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
      }

      var size = 0,
          stats = extend({}, options, {id: cacheId}),
          data = createMap(),
          capacity = (options && options.capacity) || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

      /**
       * @ngdoc type
       * @name $cacheFactory.Cache
       *
       * @description
       * A cache object used to store and retrieve data, primarily used by
       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
       * templates and other data.
       *
       * ```js
       *  angular.module('superCache')
       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
       *      return $cacheFactory('super-cache');
       *    }]);
       * ```
       *
       * Example test:
       *
       * ```js
       *  it('should behave like a cache', inject(function(superCache) {
       *    superCache.put('key', 'value');
       *    superCache.put('another key', 'another value');
       *
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 2
       *    });
       *
       *    superCache.remove('another key');
       *    expect(superCache.get('another key')).toBeUndefined();
       *
       *    superCache.removeAll();
       *    expect(superCache.info()).toEqual({
       *      id: 'super-cache',
       *      size: 0
       *    });
       *  }));
       * ```
       */
      return (caches[cacheId] = {

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#put
         * @kind function
         *
         * @description
         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
         * retrieved later, and incrementing the size of the cache if the key was not already
         * present in the cache. If behaving like an LRU cache, it will also remove stale
         * entries from the set.
         *
         * It will not insert undefined values into the cache.
         *
         * @param {string} key the key under which the cached data is stored.
         * @param {*} value the value to store alongside the key. If it is undefined, the key
         *    will not be stored.
         * @returns {*} the value stored.
         */
        put: function(key, value) {
          if (isUndefined(value)) return;
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});

            refresh(lruEntry);
          }

          if (!(key in data)) size++;
          data[key] = value;

          if (size > capacity) {
            this.remove(staleEnd.key);
          }

          return value;
        },

        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#get
         * @kind function
         *
         * @description
         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the data to be retrieved
         * @returns {*} the value stored.
         */
        get: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            refresh(lruEntry);
          }

          return data[key];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#remove
         * @kind function
         *
         * @description
         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
         *
         * @param {string} key the key of the entry to be removed
         */
        remove: function(key) {
          if (capacity < Number.MAX_VALUE) {
            var lruEntry = lruHash[key];

            if (!lruEntry) return;

            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
            link(lruEntry.n,lruEntry.p);

            delete lruHash[key];
          }

          if (!(key in data)) return;

          delete data[key];
          size--;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#removeAll
         * @kind function
         *
         * @description
         * Clears the cache object of any entries.
         */
        removeAll: function() {
          data = createMap();
          size = 0;
          lruHash = createMap();
          freshEnd = staleEnd = null;
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#destroy
         * @kind function
         *
         * @description
         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
         * removing it from the {@link $cacheFactory $cacheFactory} set.
         */
        destroy: function() {
          data = null;
          stats = null;
          lruHash = null;
          delete caches[cacheId];
        },


        /**
         * @ngdoc method
         * @name $cacheFactory.Cache#info
         * @kind function
         *
         * @description
         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
         *
         * @returns {object} an object with the following properties:
         *   <ul>
         *     <li>**id**: the id of the cache instance</li>
         *     <li>**size**: the number of entries kept in the cache instance</li>
         *     <li>**...**: any additional properties from the options object when creating the
         *       cache.</li>
         *   </ul>
         */
        info: function() {
          return extend({}, stats, {size: size});
        }
      });


      /**
       * makes the `entry` the freshEnd of the LRU linked list
       */
      function refresh(entry) {
        if (entry !== freshEnd) {
          if (!staleEnd) {
            staleEnd = entry;
          } else if (staleEnd === entry) {
            staleEnd = entry.n;
          }

          link(entry.n, entry.p);
          link(entry, freshEnd);
          freshEnd = entry;
          freshEnd.n = null;
        }
      }


      /**
       * bidirectionally links two entries of the LRU linked list
       */
      function link(nextEntry, prevEntry) {
        if (nextEntry !== prevEntry) {
          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
        }
      }
    }


  /**
   * @ngdoc method
   * @name $cacheFactory#info
   *
   * @description
   * Get information about all the caches that have been created
   *
   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
   */
    cacheFactory.info = function() {
      var info = {};
      forEach(caches, function(cache, cacheId) {
        info[cacheId] = cache.info();
      });
      return info;
    };


  /**
   * @ngdoc method
   * @name $cacheFactory#get
   *
   * @description
   * Get access to a cache object by the `cacheId` used when it was created.
   *
   * @param {string} cacheId Name or id of a cache to access.
   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
   */
    cacheFactory.get = function(cacheId) {
      return caches[cacheId];
    };


    return cacheFactory;
  };
}

/**
 * @ngdoc service
 * @name $templateCache
 * @this
 *
 * @description
 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
 * can load templates directly into the cache in a `script` tag, or by consuming the
 * `$templateCache` service directly.
 *
 * Adding via the `script` tag:
 *
 * ```html
 *   <script type="text/ng-template" id="templateId.html">
 *     <p>This is the content of the template</p>
 *   </script>
 * ```
 *
 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
 * element with ng-app attribute), otherwise the template will be ignored.
 *
 * Adding via the `$templateCache` service:
 *
 * ```js
 * var myApp = angular.module('myApp', []);
 * myApp.run(function($templateCache) {
 *   $templateCache.put('templateId.html', 'This is the content of the template');
 * });
 * ```
 *
 * To retrieve the template later, simply use it in your component:
 * ```js
 * myApp.component('myComponent', {
 *    templateUrl: 'templateId.html'
 * });
 * ```
 *
 * or get it via the `$templateCache` service:
 * ```js
 * $templateCache.get('templateId.html')
 * ```
 *
 * See {@link ng.$cacheFactory $cacheFactory}.
 *
 */
function $TemplateCacheProvider() {
  this.$get = ['$cacheFactory', function($cacheFactory) {
    return $cacheFactory('templates');
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables like document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
 *
 * DOM-related variables:
 *
 * - "node" - DOM Node
 * - "element" - DOM Element or Node
 * - "$node" or "$element" - jqLite-wrapped node or element
 *
 *
 * Compiler related stuff:
 *
 * - "linkFn" - linking fn of a single directive
 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
 */


/**
 * @ngdoc service
 * @name $compile
 * @kind function
 *
 * @description
 * Compiles an HTML string or DOM into a template and produces a template function, which
 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
 *
 * The compilation is a process of walking the DOM tree and matching DOM elements to
 * {@link ng.$compileProvider#directive directives}.
 *
 * <div class="alert alert-warning">
 * **Note:** This document is an in-depth reference of all directive options.
 * For a gentle introduction to directives with examples of common use cases,
 * see the {@link guide/directive directive guide}.
 * </div>
 *
 * ## Comprehensive Directive API
 *
 * There are many different options for a directive.
 *
 * The difference resides in the return value of the factory function.
 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
 * that defines the directive properties, or just the `postLink` function (all other properties will have
 * the default values).
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's recommended to use the "directive definition object" form.
 * </div>
 *
 * Here's an example directive declared with a Directive Definition Object:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       {@link $compile#-priority- priority}: 0,
 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
 *       // or
 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
 *       {@link $compile#-transclude- transclude}: false,
 *       {@link $compile#-restrict- restrict}: 'A',
 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
 *       {@link $compile#-scope- scope}: false,
 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
 *       {@link $compile#-bindtocontroller- bindToController}: false,
 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
 *       {@link $compile#-multielement- multiElement}: false,
 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
 *         return {
 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *         }
 *         // or
 *         // return function postLink( ... ) { ... }
 *       },
 *       // or
 *       // {@link $compile#-link- link}: {
 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
 *       // }
 *       // or
 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
 *     };
 *     return directiveDefinitionObject;
 *   });
 * ```
 *
 * <div class="alert alert-warning">
 * **Note:** Any unspecified options will use the default value. You can see the default values below.
 * </div>
 *
 * Therefore the above can be simplified as:
 *
 * ```js
 *   var myModule = angular.module(...);
 *
 *   myModule.directive('directiveName', function factory(injectables) {
 *     var directiveDefinitionObject = {
 *       link: function postLink(scope, iElement, iAttrs) { ... }
 *     };
 *     return directiveDefinitionObject;
 *     // or
 *     // return function postLink(scope, iElement, iAttrs) { ... }
 *   });
 * ```
 *
 * ### Life-cycle hooks
 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
 * directive:
 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
 *   this element). This is a good place to put initialization code for your controller.
 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
 *   component such as cloning the bound value to prevent accidental mutation of the outer value.
 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
 *   changes. Any actions that you wish to take in response to the changes that you detect must be
 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
 *   components will have their `$onDestroy()` hook called before child components.
 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
 *   suspended until that occurs.
 *
 * #### Comparison with Angular 2 life-cycle hooks
 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
 *
 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
 *   In Angular 2 you can only define hooks on the prototype of the Component class.
 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
 *   `ngDoCheck` in Angular 2
 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
 *   propagated throughout the application.
 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
 *   error or do nothing depending upon the state of `enableProdMode()`.
 *
 * #### Life-cycle hook examples
 *
 * This example shows how you can check for mutations to a Date object even though the identity of the object
 * has not changed.
 *
 * <example name="doCheckDateExample" module="do-check-module">
 *   <file name="app.js">
 *     angular.module('do-check-module', [])
 *       .component('app', {
 *         template:
 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
 *           'Date: {{ $ctrl.date }}' +
 *           '<test date="$ctrl.date"></test>',
 *         controller: function() {
 *           this.date = new Date();
 *           this.month = this.date.getMonth();
 *           this.updateDate = function() {
 *             this.date.setMonth(this.month);
 *           };
 *         }
 *       })
 *       .component('test', {
 *         bindings: { date: '<' },
 *         template:
 *           '<pre>{{ $ctrl.log | json }}</pre>',
 *         controller: function() {
 *           var previousValue;
 *           this.log = [];
 *           this.$doCheck = function() {
 *             var currentValue = this.date && this.date.valueOf();
 *             if (previousValue !== currentValue) {
 *               this.log.push('doCheck: date mutated: ' + this.date);
 *               previousValue = currentValue;
 *             }
 *           };
 *         }
 *       });
 *   </file>
 *   <file name="index.html">
 *     <app></app>
 *   </file>
 * </example>
 *
 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
 * arrays or objects can have a negative impact on your application performance)
 *
 * <example name="doCheckArrayExample" module="do-check-module">
 *   <file name="index.html">
 *     <div ng-init="items = []">
 *       <button ng-click="items.push(items.length)">Add Item</button>
 *       <button ng-click="items = []">Reset Items</button>
 *       <pre>{{ items }}</pre>
 *       <test items="items"></test>
 *     </div>
 *   </file>
 *   <file name="app.js">
 *      angular.module('do-check-module', [])
 *        .component('test', {
 *          bindings: { items: '<' },
 *          template:
 *            '<pre>{{ $ctrl.log | json }}</pre>',
 *          controller: function() {
 *            this.log = [];
 *
 *            this.$doCheck = function() {
 *              if (this.items_ref !== this.items) {
 *                this.log.push('doCheck: items changed');
 *                this.items_ref = this.items;
 *              }
 *              if (!angular.equals(this.items_clone, this.items)) {
 *                this.log.push('doCheck: items mutated');
 *                this.items_clone = angular.copy(this.items);
 *              }
 *            };
 *          }
 *        });
 *   </file>
 * </example>
 *
 *
 * ### Directive Definition Object
 *
 * The directive definition object provides instructions to the {@link ng.$compile
 * compiler}. The attributes are:
 *
 * #### `multiElement`
 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
 * together as the directive elements. It is recommended that this feature be used on directives
 * which are not strictly behavioral (such as {@link ngClick}), and which
 * do not manipulate or replace child nodes (such as {@link ngInclude}).
 *
 * #### `priority`
 * When there are multiple directives defined on a single DOM element, sometimes it
 * is necessary to specify the order in which the directives are applied. The `priority` is used
 * to sort the directives before their `compile` functions get called. Priority is defined as a
 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
 * are also run in priority order, but post-link functions are run in reverse order. The order
 * of directives with the same priority is undefined. The default priority is `0`.
 *
 * #### `terminal`
 * If set to true then the current `priority` will be the last set of directives
 * which will execute (any directives at the current priority will still execute
 * as the order of execution on same `priority` is undefined). Note that expressions
 * and other directives used in the directive's template will also be excluded from execution.
 *
 * #### `scope`
 * The scope property can be `false`, `true`, or an object:
 *
 * * **`false` (default):** No scope will be created for the directive. The directive will use its
 * parent's scope.
 *
 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
 * the directive's element. If multiple directives on the same element request a new scope,
 * only one new scope is created.
 *
 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's element. The
 * 'isolate' scope differs from normal scope in that it does not prototypically inherit from its parent
 * scope. This is useful when creating reusable components, which should not accidentally read or modify
 * data in the parent scope.
 *
 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
 * directive's element. These local properties are useful for aliasing values for templates. The keys in
 * the object hash map to the name of the property on the isolate scope; the values define how the property
 * is bound to the parent scope, via matching attributes on the directive's element:
 *
 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
 *   attribute name is assumed to be the same as the local name. Given `<my-component
 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
 *   the directive's scope property `localName` will reflect the interpolated value of `hello
 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
 *   scope. The `name` is read from the parent scope (not the directive's scope).
 *
 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
 *   method is used for tracking changes, and the equality check is based on object identity.
 *   However, if an object literal or an array literal is passed as the binding expression, the
 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
 *
  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
 *
 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
 *   two caveats:
 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
 *     sets the same value. That means if your bound value is an object, changes to its properties
 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
 *     to the value has changed. In most cases, this should not be of concern, but can be important
 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
 *     If you now change a property of the object in your parent scope, the change will not be
 *     propagated to the isolated scope, because the identity of the object on the parent scope
 *     has not changed. Instead you must assign a new object.
 *
 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
 *   back to the parent. However, it does not make this completely impossible.
 *
 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
 *   via an expression to the parent scope. This can be done by passing a map of local variable names
 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
 *
 * In general it's possible to apply more than one directive to one element, but there might be limitations
 * depending on the type of scope required by the directives. The following points will help explain these limitations.
 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
 *
 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
 * * **child scope** + **no scope** =>  Both directives will share one single child scope
 * * **child scope** + **child scope** =>  Both directives will share one single child scope
 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
 * its parent's scope
 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
 * be applied to the same element.
 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
 * cannot be applied to the same element.
 *
 *
 * #### `bindToController`
 * This property is used to bind scope properties directly to the controller. It can be either
 * `true` or an object hash with the same format as the `scope` property.
 *
 * When an isolate scope is used for a directive (see above), `bindToController: true` will
 * allow a component to have its properties bound to the controller, rather than to scope.
 *
 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
 * properties. You can access these bindings once they have been initialized by providing a controller method called
 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
 * initialized.
 *
 * <div class="alert alert-warning">
 * **Deprecation warning:** although bindings for non-ES6 class controllers are currently
 * bound to `this` before the controller constructor is called, this use is now deprecated. Please place initialization
 * code that relies upon bindings inside a `$onInit` method on the controller, instead.
 * </div>
 *
 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
 * scope (useful for component directives).
 *
 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
 *
 *
 * #### `controller`
 * Controller constructor function. The controller is instantiated before the
 * pre-linking phase and can be accessed by other directives (see
 * `require` attribute). This allows the directives to communicate with each other and augment
 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
 *
 * * `$scope` - Current scope associated with the element
 * * `$element` - Current element
 * * `$attrs` - Current attributes object for the element
 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
 *    * `scope`: (optional) override the scope.
 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
 *    * `futureParentElement` (optional):
 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
 *          and when the `cloneLinkingFn` is passed,
 *          as those elements need to created and cloned in a special way when they are defined outside their
 *          usual containers (e.g. like `<svg>`).
 *        * See also the `directive.templateNamespace` property.
 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
 *      then the default transclusion is provided.
 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
 *
 * #### `require`
 * Require another directive and inject its controller as the fourth argument to the linking function. The
 * `require` property can be a string, an array or an object:
 * * a **string** containing the name of the directive to pass to the linking function
 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
 * linking function will be an array of controllers in the same order as the names in the `require` property
 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
 * controllers.
 *
 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
 * have been constructed but before `$onInit` is called.
 * If the name of the required controller is the same as the local name (the key), the name can be
 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
 * See the {@link $compileProvider#component} helper for an example of how this can be used.
 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
 * raised (unless no link function is specified and the required controllers are not being bound to the directive
 * controller, in which case error checking is skipped). The name can be prefixed with:
 *
 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
 *   `null` to the `link` fn if not found.
 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
 *   `null` to the `link` fn if not found.
 *
 *
 * #### `controllerAs`
 * Identifier name for a reference to the controller in the directive's scope.
 * This allows the controller to be referenced from the directive template. This is especially
 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
 *
 *
 * #### `restrict`
 * String of subset of `EACM` which restricts the directive to a specific directive
 * declaration style. If omitted, the defaults (elements and attributes) are used.
 *
 * * `E` - Element name (default): `<my-directive></my-directive>`
 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
 * * `C` - Class: `<div class="my-directive: exp;"></div>`
 * * `M` - Comment: `<!-- directive: my-directive exp -->`
 *
 *
 * #### `templateNamespace`
 * String representing the document type used by the markup in the template.
 * AngularJS needs this information as those elements need to be created and cloned
 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
 *
 * * `html` - All root nodes in the template are HTML. Root nodes may also be
 *   top-level elements such as `<svg>` or `<math>`.
 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
 *
 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
 *
 * #### `template`
 * HTML markup that may:
 * * Replace the contents of the directive's element (default).
 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
 * * Wrap the contents of the directive's element (if `transclude` is true).
 *
 * Value may be:
 *
 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
 *   function api below) and returns a string value.
 *
 *
 * #### `templateUrl`
 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
 *
 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
 * for later when the template has been resolved.  In the meantime it will continue to compile and link
 * sibling and parent elements as though this element had not contained any directives.
 *
 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
 * case when only one deeply nested directive has `templateUrl`.
 *
 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
 *
 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
 * a string value representing the url.  In either case, the template URL is passed through {@link
 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
 *
 *
 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
 * specify what the template should replace. Defaults to `false`.
 *
 * * `true` - the template will replace the directive's element.
 * * `false` - the template will replace the contents of the directive's element.
 *
 * The replacement process migrates all of the attributes / classes from the old element to the new
 * one. See the {@link guide/directive#template-expanding-directive
 * Directives Guide} for an example.
 *
 * There are very few scenarios where element replacement is required for the application function,
 * the main one being reusable custom components that are used within SVG contexts
 * (because SVG doesn't work with custom elements in the DOM tree).
 *
 * #### `transclude`
 * Extract the contents of the element where the directive appears and make it available to the directive.
 * The contents are compiled and provided to the directive as a **transclusion function**. See the
 * {@link $compile#transclusion Transclusion} section below.
 *
 *
 * #### `compile`
 *
 * ```js
 *   function compile(tElement, tAttrs, transclude) { ... }
 * ```
 *
 * The compile function deals with transforming the template DOM. Since most directives do not do
 * template transformation, it is not used often. The compile function takes the following arguments:
 *
 *   * `tElement` - template element - The element where the directive has been declared. It is
 *     safe to do template transformation on the element and child elements only.
 *
 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
 *     between all directive compile functions.
 *
 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
 *
 * <div class="alert alert-warning">
 * **Note:** The template instance and the link instance may be different objects if the template has
 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
 * should be done in a linking function rather than in a compile function.
 * </div>

 * <div class="alert alert-warning">
 * **Note:** The compile function cannot handle directives that recursively use themselves in their
 * own templates or compile functions. Compiling these directives results in an infinite loop and
 * stack overflow errors.
 *
 * This can be avoided by manually using $compile in the postLink function to imperatively compile
 * a directive's template instead of relying on automatic template compilation via `template` or
 * `templateUrl` declaration or manual compilation inside the compile function.
 * </div>
 *
 * <div class="alert alert-danger">
 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
 *   to the link function instead.
 * </div>

 * A compile function can have a return value which can be either a function or an object.
 *
 * * returning a (post-link) function - is equivalent to registering the linking function via the
 *   `link` property of the config object when the compile function is empty.
 *
 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
 *   control when a linking function should be called during the linking phase. See info about
 *   pre-linking and post-linking functions below.
 *
 *
 * #### `link`
 * This property is used only if the `compile` property is not defined.
 *
 * ```js
 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
 * ```
 *
 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
 * executed after the template has been cloned. This is where most of the directive logic will be
 * put.
 *
 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
 *
 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
 *     manipulate the children of the element only in `postLink` function since the children have
 *     already been linked.
 *
 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
 *     between all directive linking functions.
 *
 *   * `controller` - the directive's required controller instance(s) - Instances are shared
 *     among all directives, which allows the directives to use the controllers as a communication
 *     channel. The exact value depends on the directive's `require` property:
 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
 *       * `string`: the controller instance
 *       * `array`: array of controller instances
 *
 *     If a required controller cannot be found, and it is optional, the instance is `null`,
 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
 *
 *     Note that you can also require the directive's own controller - it will be made available like
 *     any other controller.
 *
 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
 *     This is the same as the `$transclude` parameter of directive controllers,
 *     see {@link ng.$compile#-controller- the controller section for details}.
 *     `function([scope], cloneLinkingFn, futureParentElement)`.
 *
 * #### Pre-linking function
 *
 * Executed before the child elements are linked. Not safe to do DOM transformation since the
 * compiler linking function will fail to locate the correct elements for linking.
 *
 * #### Post-linking function
 *
 * Executed after the child elements are linked.
 *
 * Note that child elements that contain `templateUrl` directives will not have been compiled
 * and linked since they are waiting for their template to load asynchronously and their own
 * compilation and linking has been suspended until that occurs.
 *
 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
 * for their async templates to be resolved.
 *
 *
 * ### Transclusion
 *
 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
 * scope from where they were taken.
 *
 * Transclusion is used (often with {@link ngTransclude}) to insert the
 * original contents of a directive's element into a specified place in the template of the directive.
 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
 * content has access to the properties on the scope from which it was taken, even if the directive
 * has isolated scope.
 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
 *
 * This makes it possible for the widget to have private state for its template, while the transcluded
 * content has access to its originating scope.
 *
 * <div class="alert alert-warning">
 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
 * Testing Transclusion Directives}.
 * </div>
 *
 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
 * directive's element, the entire element or multiple parts of the element contents:
 *
 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
 * * `'element'` - transclude the whole of the directive's element including any directives on this
 *   element that defined at a lower priority than this directive. When used, the `template`
 *   property is ignored.
 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
 *
 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
 *
 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
 *
 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
 *
 * If the element selector is prefixed with a `?` then that slot is optional.
 *
 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
 *
 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
 * injectable into the directive's controller.
 *
 *
 * #### Transclusion Functions
 *
 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
 * function** to the directive's `link` function and `controller`. This transclusion function is a special
 * **linking function** that will return the compiled contents linked to a new transclusion scope.
 *
 * <div class="alert alert-info">
 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
 * ngTransclude will deal with it for us.
 * </div>
 *
 * If you want to manually control the insertion and removal of the transcluded content in your directive
 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
 *
 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
 *
 * <div class="alert alert-info">
 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
 * </div>
 *
 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
 * attach function**:
 *
 * ```js
 * var transcludedContent, transclusionScope;
 *
 * $transclude(function(clone, scope) {
 *   element.append(clone);
 *   transcludedContent = clone;
 *   transclusionScope = scope;
 * });
 * ```
 *
 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
 * associated transclusion scope:
 *
 * ```js
 * transcludedContent.remove();
 * transclusionScope.$destroy();
 * ```
 *
 * <div class="alert alert-info">
 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
 * then you are also responsible for calling `$destroy` on the transclusion scope.
 * </div>
 *
 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
 *
 *
 * #### Transclusion Scopes
 *
 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
 * was taken.
 *
 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
 * like this:
 *
 * ```html
 * <div ng-app>
 *   <div isolate>
 *     <div transclusion>
 *     </div>
 *   </div>
 * </div>
 * ```
 *
 * The `$parent` scope hierarchy will look like this:
 *
   ```
   - $rootScope
     - isolate
       - transclusion
   ```
 *
 * but the scopes will inherit prototypically from different scopes to their `$parent`.
 *
   ```
   - $rootScope
     - transclusion
   - isolate
   ```
 *
 *
 * ### Attributes
 *
 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
 * `link()` or `compile()` functions. It has a variety of uses.
 *
 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
 *   to the attributes.
 *
 * * *Directive inter-communication:* All directives share the same instance of the attributes
 *   object which allows the directives to use the attributes object as inter directive
 *   communication.
 *
 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
 *   allowing other directives to read the interpolated value.
 *
 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
 *   the only way to easily get the actual value because during the linking phase the interpolation
 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
 *
 * ```js
 * function linkingFn(scope, elm, attrs, ctrl) {
 *   // get the attribute value
 *   console.log(attrs.ngModel);
 *
 *   // change the attribute
 *   attrs.$set('ngModel', 'new value');
 *
 *   // observe changes to interpolated attribute
 *   attrs.$observe('ngModel', function(value) {
 *     console.log('ngModel has changed value to ' + value);
 *   });
 * }
 * ```
 *
 * ## Example
 *
 * <div class="alert alert-warning">
 * **Note**: Typically directives are registered with `module.directive`. The example below is
 * to illustrate how `$compile` works.
 * </div>
 *
 <example module="compileExample" name="compile">
   <file name="index.html">
    <script>
      angular.module('compileExample', [], function($compileProvider) {
        // configure new 'compile' directive by passing a directive
        // factory function. The factory function injects the '$compile'
        $compileProvider.directive('compile', function($compile) {
          // directive factory creates a link function
          return function(scope, element, attrs) {
            scope.$watch(
              function(scope) {
                 // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
              },
              function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
              }
            );
          };
        });
      })
      .controller('GreeterController', ['$scope', function($scope) {
        $scope.name = 'Angular';
        $scope.html = 'Hello {{name}}';
      }]);
    </script>
    <div ng-controller="GreeterController">
      <input ng-model="name"> <br/>
      <textarea ng-model="html"></textarea> <br/>
      <div compile="html"></div>
    </div>
   </file>
   <file name="protractor.js" type="protractor">
     it('should auto compile', function() {
       var textarea = $('textarea');
       var output = $('div[compile]');
       // The initial state reads 'Hello Angular'.
       expect(output.getText()).toBe('Hello Angular');
       textarea.clear();
       textarea.sendKeys('{{name}}!');
       expect(output.getText()).toBe('Angular!');
     });
   </file>
 </example>

 *
 *
 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
 *
 * <div class="alert alert-danger">
 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
 *   e.g. will not use the right outer scope. Please pass the transclude function as a
 *   `parentBoundTranscludeFn` to the link function instead.
 * </div>
 *
 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
 *                 root element(s), not their children)
 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
 * (a DOM element/tree) to a scope. Where:
 *
 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
 *
 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
 *      * `scope` - is the current scope with which the linking function is working with.
 *
 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
 *  keys may be used to control linking behavior:
 *
 *      * `parentBoundTranscludeFn` - the transclude function made available to
 *        directives; if given, it will be passed through to the link functions of
 *        directives found in `element` during compilation.
 *      * `transcludeControllers` - an object hash with keys that map controller names
 *        to a hash with the key `instance`, which maps to the controller instance;
 *        if given, it will make the controllers available to directives on the compileNode:
 *        ```
 *        {
 *          parent: {
 *            instance: parentControllerInstance
 *          }
 *        }
 *        ```
 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
 *        the cloned elements; only needed for transcludes that are allowed to contain non html
 *        elements (e.g. SVG elements). See also the directive.controller property.
 *
 * Calling the linking function returns the element of the template. It is either the original
 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
 *
 * After linking the view is not updated until after a call to $digest which typically is done by
 * Angular automatically.
 *
 * If you need access to the bound view, there are two ways to do it:
 *
 * - If you are not asking the linking function to clone the template, create the DOM element(s)
 *   before you send them to the compiler and keep this reference around.
 *   ```js
 *     var element = $compile('<p>{{total}}</p>')(scope);
 *   ```
 *
 * - if on the other hand, you need the element to be cloned, the view reference from the original
 *   example would not point to the clone, but rather to the original template that was cloned. In
 *   this case, you can access the clone via the cloneAttachFn:
 *   ```js
 *     var templateElement = angular.element('<p>{{total}}</p>'),
 *         scope = ....;
 *
 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
 *       //attach the clone to DOM document at the right place
 *     });
 *
 *     //now we have reference to the cloned DOM via `clonedElement`
 *   ```
 *
 *
 * For information on how the compiler works, see the
 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
 *
 * @knownIssue
 *
 * ### Double Compilation
 *
   Double compilation occurs when an already compiled part of the DOM gets
   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
   section on double compilation} for an in-depth explanation and ways to avoid it.
 *
 */

var $compileMinErr = minErr('$compile');

function UNINITIALIZED_VALUE() {}
var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

/**
 * @ngdoc provider
 * @name $compileProvider
 *
 * @description
 */
$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
/** @this */
function $CompileProvider($provide, $$sanitizeUriProvider) {
  var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
  // The assumption is that future DOM event attribute names will begin with
  // 'on' and be composed of only English letters.
  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
  var bindingCache = createMap();

  function parseIsolateBindings(scope, directiveName, isController) {
    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;

    var bindings = createMap();

    forEach(scope, function(definition, scopeName) {
      if (definition in bindingCache) {
        bindings[scopeName] = bindingCache[definition];
        return;
      }
      var match = definition.match(LOCAL_REGEXP);

      if (!match) {
        throw $compileMinErr('iscp',
            'Invalid {3} for directive \'{0}\'.' +
            ' Definition: {... {1}: \'{2}\' ...}',
            directiveName, scopeName, definition,
            (isController ? 'controller bindings definition' :
            'isolate scope definition'));
      }

      bindings[scopeName] = {
        mode: match[1][0],
        collection: match[2] === '*',
        optional: match[3] === '?',
        attrName: match[4] || scopeName
      };
      if (match[4]) {
        bindingCache[definition] = bindings[scopeName];
      }
    });

    return bindings;
  }

  function parseDirectiveBindings(directive, directiveName) {
    var bindings = {
      isolateScope: null,
      bindToController: null
    };
    if (isObject(directive.scope)) {
      if (directive.bindToController === true) {
        bindings.bindToController = parseIsolateBindings(directive.scope,
                                                         directiveName, true);
        bindings.isolateScope = {};
      } else {
        bindings.isolateScope = parseIsolateBindings(directive.scope,
                                                     directiveName, false);
      }
    }
    if (isObject(directive.bindToController)) {
      bindings.bindToController =
          parseIsolateBindings(directive.bindToController, directiveName, true);
    }
    if (bindings.bindToController && !directive.controller) {
      // There is no controller
      throw $compileMinErr('noctrl',
            'Cannot bind to controller without directive \'{0}\'s controller.',
            directiveName);
    }
    return bindings;
  }

  function assertValidDirectiveName(name) {
    var letter = name.charAt(0);
    if (!letter || letter !== lowercase(letter)) {
      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
    }
    if (name !== name.trim()) {
      throw $compileMinErr('baddir',
            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
            name);
    }
  }

  function getDirectiveRequire(directive) {
    var require = directive.require || (directive.controller && directive.name);

    if (!isArray(require) && isObject(require)) {
      forEach(require, function(value, key) {
        var match = value.match(REQUIRE_PREFIX_REGEXP);
        var name = value.substring(match[0].length);
        if (!name) require[key] = match[0] + key;
      });
    }

    return require;
  }

  function getDirectiveRestrict(restrict, name) {
    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
      throw $compileMinErr('badrestrict',
          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
          restrict,
          name);
    }

    return restrict || 'EA';
  }

  /**
   * @ngdoc method
   * @name $compileProvider#directive
   * @kind function
   *
   * @description
   * Register a new directive with the compiler.
   *
   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
   *    names and the values are the factories.
   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
   * @returns {ng.$compileProvider} Self for chaining.
   */
  this.directive = function registerDirective(name, directiveFactory) {
    assertArg(name, 'name');
    assertNotHasOwnProperty(name, 'directive');
    if (isString(name)) {
      assertValidDirectiveName(name);
      assertArg(directiveFactory, 'directiveFactory');
      if (!hasDirectives.hasOwnProperty(name)) {
        hasDirectives[name] = [];
        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
          function($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function(directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
      }
      hasDirectives[name].push(directiveFactory);
    } else {
      forEach(name, reverseParams(registerDirective));
    }
    return this;
  };

  /**
   * @ngdoc method
   * @name $compileProvider#component
   * @module ng
   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
   * @param {Object} options Component definition object (a simplified
   *    {@link ng.$compile#directive-definition-object directive definition object}),
   *    with the following properties (all optional):
   *
   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
   *      registered controller} if passed as a string. An empty `noop` function by default.
   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
   *      If present, the controller will be published to scope under the `controllerAs` name.
   *      If not present, this will default to be `$ctrl`.
   *    - `template` – `{string=|function()=}` – html template as a string or a function that
   *      returns an html template as a string which should be used as the contents of this component.
   *      Empty string by default.
   *
   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
   *      template that should be used  as the contents of this component.
   *
   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
   *      the following locals:
   *
   *      - `$element` - Current element
   *      - `$attrs` - Current attributes object for the element
   *
   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
   *      Component properties are always bound to the component controller and not to the scope.
   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
   *      Disabled by default.
   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
   *      this component's controller. The object keys specify the property names under which the required
   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
   *    - `$...` – additional properties to attach to the directive factory function and the controller
   *      constructor function. (This is used by the component router to annotate)
   *
   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
   * @description
   * Register a **component definition** with the compiler. This is a shorthand for registering a special
   * type of directive, which represents a self-contained UI component in your application. Such components
   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
   *
   * Component definitions are very simple and do not require as much configuration as defining general
   * directives. Component definitions usually consist only of a template and a controller backing it.
   *
   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
   * `bindToController`. They always have **isolate scope** and are restricted to elements.
   *
   * Here are a few examples of how you would usually define components:
   *
   * ```js
   *   var myMod = angular.module(...);
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     controller: function() {
   *       this.name = 'shahar';
   *     }
   *   });
   *
   *   myMod.component('myComp', {
   *     template: '<div>My name is {{$ctrl.name}}</div>',
   *     bindings: {name: '@'}
   *   });
   *
   *   myMod.component('myComp', {
   *     templateUrl: 'views/my-comp.html',
   *     controller: 'MyCtrl',
   *     controllerAs: 'ctrl',
   *     bindings: {name: '@'}
   *   });
   *
   * ```
   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
   *
   * <br />
   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
   */
  this.component = function registerComponent(name, options) {
    var controller = options.controller || function() {};

    function factory($injector) {
      function makeInjectable(fn) {
        if (isFunction(fn) || isArray(fn)) {
          return /** @this */ function(tElement, tAttrs) {
            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
          };
        } else {
          return fn;
        }
      }

      var template = (!options.template && !options.templateUrl ? '' : options.template);
      var ddo = {
        controller: controller,
        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
        template: makeInjectable(template),
        templateUrl: makeInjectable(options.templateUrl),
        transclude: options.transclude,
        scope: {},
        bindToController: options.bindings || {},
        restrict: 'E',
        require: options.require
      };

      // Copy annotations (starting with $) over to the DDO
      forEach(options, function(val, key) {
        if (key.charAt(0) === '$') ddo[key] = val;
      });

      return ddo;
    }

    // TODO(pete) remove the following `forEach` before we release 1.6.0
    // The component-router@0.2.0 looks for the annotations on the controller constructor
    // Nothing in Angular looks for annotations on the factory function but we can't remove
    // it from 1.5.x yet.

    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
    // These could be used by libraries such as the new component router
    forEach(options, function(val, key) {
      if (key.charAt(0) === '$') {
        factory[key] = val;
        // Don't try to copy over annotations to named controller
        if (isFunction(controller)) controller[key] = val;
      }
    });

    factory.$inject = ['$injector'];

    return this.directive(name, factory);
  };


  /**
   * @ngdoc method
   * @name $compileProvider#aHrefSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
    }
  };


  /**
   * @ngdoc method
   * @name $compileProvider#imgSrcSanitizationWhitelist
   * @kind function
   *
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
      return this;
    } else {
      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
    }
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#debugInfoEnabled
   *
   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
   * current debugInfoEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable various debug runtime information in the compiler such as adding
   * binding information and a reference to the current scope on to DOM elements.
   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
   * * `ng-binding` CSS class
   * * `$binding` data property containing an array of the binding expressions
   *
   * You may want to disable this in production for a significant performance boost. See
   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
   *
   * The default value is true.
   */
  var debugInfoEnabled = true;
  this.debugInfoEnabled = function(enabled) {
    if (isDefined(enabled)) {
      debugInfoEnabled = enabled;
      return this;
    }
    return debugInfoEnabled;
  };

  /**
   * @ngdoc method
   * @name  $compileProvider#preAssignBindingsEnabled
   *
   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
   * current preAssignBindingsEnabled state
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   *
   * @kind function
   *
   * @description
   * Call this method to enable/disable whether directive controllers are assigned bindings before
   * calling the controller's constructor.
   * If enabled (true), the compiler assigns the value of each of the bindings to the
   * properties of the controller object before the constructor of this object is called.
   *
   * If disabled (false), the compiler calls the constructor first before assigning bindings.
   *
   * The default value is true in Angular 1.5.x but will switch to false in Angular 1.6.x.
   */
  var preAssignBindingsEnabled = true;
  this.preAssignBindingsEnabled = function(enabled) {
    if (isDefined(enabled)) {
      preAssignBindingsEnabled = enabled;
      return this;
    }
    return preAssignBindingsEnabled;
  };


  var TTL = 10;
  /**
   * @ngdoc method
   * @name $compileProvider#onChangesTtl
   * @description
   *
   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
   * in several iterations of calls to these hooks. However if an application needs more than the default 10
   * iterations to stabilize then you should investigate what is causing the model to continuously change during
   * the `$onChanges` hook execution.
   *
   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
   *
   * @param {number} limit The number of `$onChanges` hook iterations.
   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
   */
  this.onChangesTtl = function(value) {
    if (arguments.length) {
      TTL = value;
      return this;
    }
    return TTL;
  };

  var commentDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#commentDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on comments should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on comments for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check comments when looking for directives.
   * This should however only be used if you are sure that no comment directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.commentDirectivesEnabled = function(value) {
    if (arguments.length) {
      commentDirectivesEnabledConfig = value;
      return this;
    }
    return commentDirectivesEnabledConfig;
  };


  var cssClassDirectivesEnabledConfig = true;
  /**
   * @ngdoc method
   * @name $compileProvider#cssClassDirectivesEnabled
   * @description
   *
   * It indicates to the compiler
   * whether or not directives on element classes should be compiled.
   * Defaults to `true`.
   *
   * Calling this function with false disables the compilation of directives
   * on element classes for the whole application.
   * This results in a compilation performance gain,
   * as the compiler doesn't have to check element classes when looking for directives.
   * This should however only be used if you are sure that no class directives are used in
   * the application (including any 3rd party directives).
   *
   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
   */
  this.cssClassDirectivesEnabled = function(value) {
    if (arguments.length) {
      cssClassDirectivesEnabledConfig = value;
      return this;
    }
    return cssClassDirectivesEnabledConfig;
  };

  this.$get = [
            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {

    var SIMPLE_ATTR_NAME = /^\w/;
    var specialAttrHolder = window.document.createElement('div');


    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;


    var onChangesTtl = TTL;
    // The onChanges hooks should all be run together in a single digest
    // When changes occur, the call to trigger their hooks will be added to this queue
    var onChangesQueue;

    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
    function flushOnChangesQueue() {
      try {
        if (!(--onChangesTtl)) {
          // We have hit the TTL limit so reset everything
          onChangesQueue = undefined;
          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
        }
        // We must run this hook in an apply since the $$postDigest runs outside apply
        $rootScope.$apply(function() {
          var errors = [];
          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
            try {
              onChangesQueue[i]();
            } catch (e) {
              errors.push(e);
            }
          }
          // Reset the queue to trigger a new schedule next time there is a change
          onChangesQueue = undefined;
          if (errors.length) {
            throw errors;
          }
        });
      } finally {
        onChangesTtl++;
      }
    }


    function Attributes(element, attributesToCopy) {
      if (attributesToCopy) {
        var keys = Object.keys(attributesToCopy);
        var i, l, key;

        for (i = 0, l = keys.length; i < l; i++) {
          key = keys[i];
          this[key] = attributesToCopy[key];
        }
      } else {
        this.$attr = {};
      }

      this.$$element = element;
    }

    Attributes.prototype = {
      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$normalize
       * @kind function
       *
       * @description
       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
       * `data-`) to its normalized, camelCase form.
       *
       * Also there is special case for Moz prefix starting with upper case letter.
       *
       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
       *
       * @param {string} name Name to normalize
       */
      $normalize: directiveNormalize,


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$addClass
       * @kind function
       *
       * @description
       * Adds the CSS class value specified by the classVal parameter to the element. If animations
       * are enabled then an animation will be triggered for the class addition.
       *
       * @param {string} classVal The className value that will be added to the element
       */
      $addClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.addClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$removeClass
       * @kind function
       *
       * @description
       * Removes the CSS class value specified by the classVal parameter from the element. If
       * animations are enabled then an animation will be triggered for the class removal.
       *
       * @param {string} classVal The className value that will be removed from the element
       */
      $removeClass: function(classVal) {
        if (classVal && classVal.length > 0) {
          $animate.removeClass(this.$$element, classVal);
        }
      },

      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$updateClass
       * @kind function
       *
       * @description
       * Adds and removes the appropriate CSS class values to the element based on the difference
       * between the new and old CSS class values (specified as newClasses and oldClasses).
       *
       * @param {string} newClasses The current CSS className value
       * @param {string} oldClasses The former CSS className value
       */
      $updateClass: function(newClasses, oldClasses) {
        var toAdd = tokenDifference(newClasses, oldClasses);
        if (toAdd && toAdd.length) {
          $animate.addClass(this.$$element, toAdd);
        }

        var toRemove = tokenDifference(oldClasses, newClasses);
        if (toRemove && toRemove.length) {
          $animate.removeClass(this.$$element, toRemove);
        }
      },

      /**
       * Set a normalized attribute on the element in a way such that all directives
       * can share the attribute. This function properly handles boolean attributes.
       * @param {string} key Normalized key. (ie ngAttribute)
       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
       *     Defaults to true.
       * @param {string=} attrName Optional none normalized name. Defaults to key.
       */
      $set: function(key, value, writeAttr, attrName) {
        // TODO: decide whether or not to throw an error if "class"
        //is set through this function since it may cause $updateClass to
        //become unstable.

        var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;

        if (booleanKey) {
          this.$$element.prop(key, value);
          attrName = booleanKey;
        } else if (aliasedKey) {
          this[aliasedKey] = value;
          observer = aliasedKey;
        }

        this[key] = value;

        // translate normalized key to actual key
        if (attrName) {
          this.$attr[key] = attrName;
        } else {
          attrName = this.$attr[key];
          if (!attrName) {
            this.$attr[key] = attrName = snake_case(key, '-');
          }
        }

        nodeName = nodeName_(this.$$element);

        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
            (nodeName === 'img' && key === 'src')) {
          // sanitize a[href] and img[src] values
          this[key] = value = $$sanitizeUri(value, key === 'src');
        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
          // sanitize img[srcset] values
          var result = '';

          // first check if there are spaces because it's not the same pattern
          var trimmedSrcset = trim(value);
          //                (   999x   ,|   999w   ,|   ,|,   )
          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

          // split srcset into tuple of uri and descriptor except for the last item
          var rawUris = trimmedSrcset.split(pattern);

          // for each tuples
          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
          for (var i = 0; i < nbrUrisWith2parts; i++) {
            var innerIdx = i * 2;
            // sanitize the uri
            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
            // add the descriptor
            result += (' ' + trim(rawUris[innerIdx + 1]));
          }

          // split the last item into uri and descriptor
          var lastTuple = trim(rawUris[i * 2]).split(/\s/);

          // sanitize the last uri
          result += $$sanitizeUri(trim(lastTuple[0]), true);

          // and add the last descriptor if any
          if (lastTuple.length === 2) {
            result += (' ' + trim(lastTuple[1]));
          }
          this[key] = value = result;
        }

        if (writeAttr !== false) {
          if (value === null || isUndefined(value)) {
            this.$$element.removeAttr(attrName);
          } else {
            if (SIMPLE_ATTR_NAME.test(attrName)) {
              this.$$element.attr(attrName, value);
            } else {
              setSpecialAttr(this.$$element[0], attrName, value);
            }
          }
        }

        // fire observers
        var $$observers = this.$$observers;
        if ($$observers) {
          forEach($$observers[observer], function(fn) {
            try {
              fn(value);
            } catch (e) {
              $exceptionHandler(e);
            }
          });
        }
      },


      /**
       * @ngdoc method
       * @name $compile.directive.Attributes#$observe
       * @kind function
       *
       * @description
       * Observes an interpolated attribute.
       *
       * The observer function will be invoked once during the next `$digest` following
       * compilation. The observer is then invoked whenever the interpolated value
       * changes.
       *
       * @param {string} key Normalized key. (ie ngAttribute) .
       * @param {function(interpolatedValue)} fn Function that will be called whenever
                the interpolated value of the attribute changes.
       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
       *        guide} for more info.
       * @returns {function()} Returns a deregistration function for this observer.
       */
      $observe: function(key, fn) {
        var attrs = this,
            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
            listeners = ($$observers[key] || ($$observers[key] = []));

        listeners.push(fn);
        $rootScope.$evalAsync(function() {
          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
            // no one registered attribute interpolation function, so lets call it manually
            fn(attrs[key]);
          }
        });

        return function() {
          arrayRemove(listeners, fn);
        };
      }
    };

    function setSpecialAttr(element, attrName, value) {
      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
      // so we have to jump through some hoops to get such an attribute
      // https://github.com/angular/angular.js/pull/13318
      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
      var attributes = specialAttrHolder.firstChild.attributes;
      var attribute = attributes[0];
      // We have to remove the attribute from its container element before we can add it to the destination element
      attributes.removeNamedItem(attribute.name);
      attribute.value = value;
      element.attributes.setNamedItem(attribute);
    }

    function safeAddClass($element, className) {
      try {
        $element.addClass(className);
      } catch (e) {
        // ignore, since it means that we are trying to set class on
        // SVG element, where class name is read-only.
      }
    }


    var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
            ? identity
            : function denormalizeTemplate(template) {
              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
      var bindings = $element.data('$binding') || [];

      if (isArray(binding)) {
        bindings = bindings.concat(binding);
      } else {
        bindings.push(binding);
      }

      $element.data('$binding', bindings);
    } : noop;

    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
      safeAddClass($element, 'ng-binding');
    } : noop;

    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
      $element.data(dataName, scope);
    } : noop;

    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
    } : noop;

    compile.$$createComment = function(directiveName, comment) {
      var content = '';
      if (debugInfoEnabled) {
        content = ' ' + (directiveName || '') + ': ';
        if (comment) content += comment + ' ';
      }
      return window.document.createComment(content);
    };

    return compile;

    //================================

    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
                        previousCompileContext) {
      if (!($compileNodes instanceof jqLite)) {
        // jquery always rewraps, whereas we need to preserve the original selector so that we can
        // modify it.
        $compileNodes = jqLite($compileNodes);
      }

      var NOT_EMPTY = /\S+/;

      // We can not compile top level text elements since text nodes can be merged and we will
      // not be able to attach scope data to them, so we will wrap them in <span>
      for (var i = 0, len = $compileNodes.length; i < len; i++) {
        var domNode = $compileNodes[i];

        if (domNode.nodeType === NODE_TYPE_TEXT && domNode.nodeValue.match(NOT_EMPTY) /* non-empty */) {
          jqLiteWrapNode(domNode, $compileNodes[i] = window.document.createElement('span'));
        }
      }

      var compositeLinkFn =
              compileNodes($compileNodes, transcludeFn, $compileNodes,
                           maxPriority, ignoreDirective, previousCompileContext);
      compile.$$addScopeClass($compileNodes);
      var namespace = null;
      return function publicLinkFn(scope, cloneConnectFn, options) {
        assertArg(scope, 'scope');

        if (previousCompileContext && previousCompileContext.needsNewScope) {
          // A parent directive did a replace and a directive on this element asked
          // for transclusion, which caused us to lose a layer of element on which
          // we could hold the new transclusion scope, so we will create it manually
          // here.
          scope = scope.$parent.$new();
        }

        options = options || {};
        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
          transcludeControllers = options.transcludeControllers,
          futureParentElement = options.futureParentElement;

        // When `parentBoundTranscludeFn` is passed, it is a
        // `controllersBoundTransclude` function (it was previously passed
        // as `transclude` to directive.link) so we must unwrap it to get
        // its `boundTranscludeFn`
        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
        }

        if (!namespace) {
          namespace = detectNamespaceForChildElements(futureParentElement);
        }
        var $linkNode;
        if (namespace !== 'html') {
          // When using a directive with replace:true and templateUrl the $compileNodes
          // (or a child element inside of them)
          // might change, so we need to recreate the namespace adapted compileNodes
          // for call to the link function.
          // Note: This will already clone the nodes...
          $linkNode = jqLite(
            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
          );
        } else if (cloneConnectFn) {
          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
          // and sometimes changes the structure of the DOM.
          $linkNode = JQLitePrototype.clone.call($compileNodes);
        } else {
          $linkNode = $compileNodes;
        }

        if (transcludeControllers) {
          for (var controllerName in transcludeControllers) {
            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
          }
        }

        compile.$$addScopeInfo($linkNode, scope);

        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
        return $linkNode;
      };
    }

    function detectNamespaceForChildElements(parentElement) {
      // TODO: Make this detect MathML as well...
      var node = parentElement && parentElement[0];
      if (!node) {
        return 'html';
      } else {
        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
      }
    }

    /**
     * Compile function matches each node in nodeList against the directives. Once all directives
     * for a particular node are collected their compile functions are executed. The compile
     * functions return values - the linking functions - are combined into a composite linking
     * function, which is the a linking function for the node.
     *
     * @param {NodeList} nodeList an array of nodes or NodeList to compile
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *        scope argument is auto-generated to the new child of the transcluded parent scope.
     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
     *        the rootElement must be set the jqLite collection of the compile root. This is
     *        needed so that the jqLite collection items can be replaced with widgets.
     * @param {number=} maxPriority Max directive priority.
     * @returns {Function} A composite linking function of all of the matched directives or null.
     */
    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
                            previousCompileContext) {
      var linkFns = [],
          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;

      for (var i = 0; i < nodeList.length; i++) {
        attrs = new Attributes();

        // we must always refer to nodeList[i] since the nodes can be replaced underneath us.
        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
                                        ignoreDirective);

        nodeLinkFn = (directives.length)
            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
                                      null, [], [], previousCompileContext)
            : null;

        if (nodeLinkFn && nodeLinkFn.scope) {
          compile.$$addScopeClass(attrs.$$element);
        }

        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
                      !(childNodes = nodeList[i].childNodes) ||
                      !childNodes.length)
            ? null
            : compileNodes(childNodes,
                 nodeLinkFn ? (
                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
                     && nodeLinkFn.transclude) : transcludeFn);

        if (nodeLinkFn || childLinkFn) {
          linkFns.push(i, nodeLinkFn, childLinkFn);
          linkFnFound = true;
          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
        }

        //use the previous context only for the first element in the virtual group
        previousCompileContext = null;
      }

      // return a linking function if we have found anything, null otherwise
      return linkFnFound ? compositeLinkFn : null;

      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
        var stableNodeList;


        if (nodeLinkFnFound) {
          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
          // offsets don't get screwed up
          var nodeListLength = nodeList.length;
          stableNodeList = new Array(nodeListLength);

          // create a sparse array by only copying the elements which have a linkFn
          for (i = 0; i < linkFns.length; i += 3) {
            idx = linkFns[i];
            stableNodeList[idx] = nodeList[idx];
          }
        } else {
          stableNodeList = nodeList;
        }

        for (i = 0, ii = linkFns.length; i < ii;) {
          node = stableNodeList[linkFns[i++]];
          nodeLinkFn = linkFns[i++];
          childLinkFn = linkFns[i++];

          if (nodeLinkFn) {
            if (nodeLinkFn.scope) {
              childScope = scope.$new();
              compile.$$addScopeInfo(jqLite(node), childScope);
            } else {
              childScope = scope;
            }

            if (nodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(
                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);

            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
              childBoundTranscludeFn = parentBoundTranscludeFn;

            } else if (!parentBoundTranscludeFn && transcludeFn) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);

            } else {
              childBoundTranscludeFn = null;
            }

            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);

          } else if (childLinkFn) {
            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
          }
        }
      }
    }

    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

        if (!transcludedScope) {
          transcludedScope = scope.$new(false, containingScope);
          transcludedScope.$$transcluded = true;
        }

        return transcludeFn(transcludedScope, cloneFn, {
          parentBoundTranscludeFn: previousBoundTranscludeFn,
          transcludeControllers: controllers,
          futureParentElement: futureParentElement
        });
      }

      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
      // so that they are available inside the `controllersBoundTransclude` function
      var boundSlots = boundTranscludeFn.$$slots = createMap();
      for (var slotName in transcludeFn.$$slots) {
        if (transcludeFn.$$slots[slotName]) {
          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
        } else {
          boundSlots[slotName] = null;
        }
      }

      return boundTranscludeFn;
    }

    /**
     * Looks for directives on the given node and adds them to the directive collection which is
     * sorted.
     *
     * @param node Node to search.
     * @param directives An array to which the directives are added to. This array is sorted before
     *        the function returns.
     * @param attrs The shared attrs object which is used to populate the normalized attributes.
     * @param {number=} maxPriority Max directive priority.
     */
    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;

      switch (nodeType) {
        case NODE_TYPE_ELEMENT: /* Element */

          nodeName = nodeName_(node);

          // use the node name: <directive>
          addDirective(directives,
              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

          // iterate over the attributes
          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
            var attrStartName = false;
            var attrEndName = false;

            attr = nAttrs[j];
            name = attr.name;
            value = trim(attr.value);

            // support ngAttr attribute binding
            ngAttrName = directiveNormalize(name);
            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
            if (isNgAttr) {
              name = name.replace(PREFIX_REGEXP, '')
                .substr(8).replace(/_(.)/g, function(match, letter) {
                  return letter.toUpperCase();
                });
            }

            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
              attrStartName = name;
              attrEndName = name.substr(0, name.length - 5) + 'end';
              name = name.substr(0, name.length - 6);
            }

            nName = directiveNormalize(name.toLowerCase());
            attrsMap[nName] = name;
            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
            }
            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
                          attrEndName);
          }

          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
            // Hidden input elements can have strange behaviour when navigating back to the page
            // This tells the browser not to try to cache and reinstate previous values
            node.setAttribute('autocomplete', 'off');
          }

          // use class as directive
          if (!cssClassDirectivesEnabled) break;
          className = node.className;
          if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
          }
          if (isString(className) && className !== '') {
            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
              nName = directiveNormalize(match[2]);
              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                attrs[nName] = trim(match[3]);
              }
              className = className.substr(match.index + match[0].length);
            }
          }
          break;
        case NODE_TYPE_TEXT: /* Text Node */
          if (msie === 11) {
            // Workaround for #11781
            while (node.parentNode && node.nextSibling && node.nextSibling.nodeType === NODE_TYPE_TEXT) {
              node.nodeValue = node.nodeValue + node.nextSibling.nodeValue;
              node.parentNode.removeChild(node.nextSibling);
            }
          }
          addTextInterpolateDirective(directives, node.nodeValue);
          break;
        case NODE_TYPE_COMMENT: /* Comment */
          if (!commentDirectivesEnabled) break;
          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
          break;
      }

      directives.sort(byPriority);
      return directives;
    }

    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
      // function created because of performance, try/catch disables
      // the optimization of the whole function #14848
      try {
        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
        if (match) {
          var nName = directiveNormalize(match[1]);
          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
            attrs[nName] = trim(match[2]);
          }
        }
      } catch (e) {
        // turns out that under some circumstances IE9 throws errors when one attempts to read
        // comment's node value.
        // Just ignore it and continue. (Can't seem to reproduce in test case.)
      }
    }

    /**
     * Given a node with a directive-start it collects all of the siblings until it finds
     * directive-end.
     * @param node
     * @param attrStart
     * @param attrEnd
     * @returns {*}
     */
    function groupScan(node, attrStart, attrEnd) {
      var nodes = [];
      var depth = 0;
      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
        do {
          if (!node) {
            throw $compileMinErr('uterdir',
                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
                      attrStart, attrEnd);
          }
          if (node.nodeType === NODE_TYPE_ELEMENT) {
            if (node.hasAttribute(attrStart)) depth++;
            if (node.hasAttribute(attrEnd)) depth--;
          }
          nodes.push(node);
          node = node.nextSibling;
        } while (depth > 0);
      } else {
        nodes.push(node);
      }

      return jqLite(nodes);
    }

    /**
     * Wrapper for linking function which converts normal linking function into a grouped
     * linking function.
     * @param linkFn
     * @param attrStart
     * @param attrEnd
     * @returns {Function}
     */
    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
        element = groupScan(element[0], attrStart, attrEnd);
        return linkFn(scope, element, attrs, controllers, transcludeFn);
      };
    }

    /**
     * A function generator that is used to support both eager and lazy compilation
     * linking function.
     * @param eager
     * @param $compileNodes
     * @param transcludeFn
     * @param maxPriority
     * @param ignoreDirective
     * @param previousCompileContext
     * @returns {Function}
     */
    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
      var compiled;

      if (eager) {
        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
      }
      return /** @this */ function lazyCompilation() {
        if (!compiled) {
          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

          // Null out all of these references in order to make them eligible for garbage collection
          // since this is a potentially long lived closure
          $compileNodes = transcludeFn = previousCompileContext = null;
        }
        return compiled.apply(this, arguments);
      };
    }

    /**
     * Once the directives have been collected, their compile functions are executed. This method
     * is responsible for inlining directive templates as well as terminating the application
     * of the directives if the terminal directive has been reached.
     *
     * @param {Array} directives Array of collected directives to execute their compile function.
     *        this needs to be pre-sorted by priority order.
     * @param {Node} compileNode The raw DOM node to apply the compile functions to
     * @param {Object} templateAttrs The shared attribute function
     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
     *                                                  scope argument is auto-generated to the new
     *                                                  child of the transcluded parent scope.
     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
     *                              argument has the root jqLite array so that we can replace nodes
     *                              on it.
     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
     *                                           compiling the transclusion.
     * @param {Array.<Function>} preLinkFns
     * @param {Array.<Function>} postLinkFns
     * @param {Object} previousCompileContext Context used for previous compilation of the current
     *                                        node
     * @returns {Function} linkFn
     */
    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
                                   previousCompileContext) {
      previousCompileContext = previousCompileContext || {};

      var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

      // executes all directives on the current element
      for (var i = 0, ii = directives.length; i < ii; i++) {
        directive = directives[i];
        var attrStart = directive.$$start;
        var attrEnd = directive.$$end;

        // collect multiblock sections
        if (attrStart) {
          $compileNode = groupScan(compileNode, attrStart, attrEnd);
        }
        $template = undefined;

        if (terminalPriority > directive.priority) {
          break; // prevent further processing of directives
        }

        directiveValue = directive.scope;

        if (directiveValue) {

          // skip the check for directives with async templates, we'll check the derived sync
          // directive when the template arrives
          if (!directive.templateUrl) {
            if (isObject(directiveValue)) {
              // This directive is trying to add an isolated scope.
              // Check that there is no scope of any kind already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
                                directive, $compileNode);
              newIsolateScopeDirective = directive;
            } else {
              // This directive is trying to add a child scope.
              // Check that there is no isolated scope already
              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
                                $compileNode);
            }
          }

          newScopeDirective = newScopeDirective || directive;
        }

        directiveName = directive.name;

        // If we encounter a condition that can result in transclusion on the directive,
        // then scan ahead in the remaining directives for others that may cause a multiple
        // transclusion error to be thrown during the compilation process.  If a matching directive
        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
        // compile the `transclude` function rather than doing it lazily in order to throw
        // exceptions at the correct time
        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
            || (directive.transclude && !directive.$$tlb))) {
                var candidateDirective;

                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
                        mightHaveMultipleTransclusionError = true;
                        break;
                    }
                }

                didScanForMultipleTransclusion = true;
        }

        if (!directive.templateUrl && directive.controller) {
          controllerDirectives = controllerDirectives || createMap();
          assertNoDuplicate('\'' + directiveName + '\' controller',
              controllerDirectives[directiveName], directive, $compileNode);
          controllerDirectives[directiveName] = directive;
        }

        directiveValue = directive.transclude;

        if (directiveValue) {
          hasTranscludeDirective = true;

          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
          // This option should only be used by directives that know how to safely handle element transclusion,
          // where the transcluded nodes are added or replaced after linking.
          if (!directive.$$tlb) {
            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
            nonTlbTranscludeDirective = directive;
          }

          if (directiveValue === 'element') {
            hasElementTranscludeDirective = true;
            terminalPriority = directive.priority;
            $template = $compileNode;
            $compileNode = templateAttrs.$$element =
                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
            compileNode = $compileNode[0];
            replaceWith(jqCollection, sliceArgs($template), compileNode);

            // Support: Chrome < 50
            // https://github.com/angular/angular.js/issues/14041

            // In the versions of V8 prior to Chrome 50, the document fragment that is created
            // in the `replaceWith` function is improperly garbage collected despite still
            // being referenced by the `parentNode` property of all of the child nodes.  By adding
            // a reference to the fragment via a different property, we can avoid that incorrect
            // behavior.
            // TODO: remove this line after Chrome 50 has been released
            $template[0].$$parentNode = $template[0].parentNode;

            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
                                        replaceDirective && replaceDirective.name, {
                                          // Don't pass in:
                                          // - controllerDirectives - otherwise we'll create duplicates controllers
                                          // - newIsolateScopeDirective or templateDirective - combining templates with
                                          //   element transclusion doesn't make sense.
                                          //
                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                                          // on the same element more than once.
                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
                                        });
          } else {

            var slots = createMap();

            $template = jqLite(jqLiteClone(compileNode)).contents();

            if (isObject(directiveValue)) {

              // We have transclusion slots,
              // collect them up, compile them and store their transclusion functions
              $template = [];

              var slotMap = createMap();
              var filledSlots = createMap();

              // Parse the element selectors
              forEach(directiveValue, function(elementSelector, slotName) {
                // If an element selector starts with a ? then it is optional
                var optional = (elementSelector.charAt(0) === '?');
                elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                slotMap[elementSelector] = slotName;

                // We explicitly assign `null` since this implies that a slot was defined but not filled.
                // Later when calling boundTransclusion functions with a slot name we only error if the
                // slot is `undefined`
                slots[slotName] = null;

                // filledSlots contains `true` for all slots that are either optional or have been
                // filled. This is used to check that we have not missed any required slots
                filledSlots[slotName] = optional;
              });

              // Add the matching elements into their slot
              forEach($compileNode.contents(), function(node) {
                var slotName = slotMap[directiveNormalize(nodeName_(node))];
                if (slotName) {
                  filledSlots[slotName] = true;
                  slots[slotName] = slots[slotName] || [];
                  slots[slotName].push(node);
                } else {
                  $template.push(node);
                }
              });

              // Check for required slots that were not filled
              forEach(filledSlots, function(filled, slotName) {
                if (!filled) {
                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                }
              });

              for (var slotName in slots) {
                if (slots[slotName]) {
                  // Only define a transclusion function if the slot was filled
                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                }
              }
            }

            $compileNode.empty(); // clear contents
            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
            childTranscludeFn.$$slots = slots;
          }
        }

        if (directive.template) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          directiveValue = (isFunction(directive.template))
              ? directive.template($compileNode, templateAttrs)
              : directive.template;

          directiveValue = denormalizeTemplate(directiveValue);

          if (directive.replace) {
            replaceDirective = directive;
            if (jqLiteIsTextNode(directiveValue)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  directiveName, '');
            }

            replaceWith(jqCollection, $compileNode, compileNode);

            var newTemplateAttrs = {$attr: {}};

            // combine directives from the original node and from the template:
            // - take the array of directives for this element
            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
            // - collect directives from the template and sort them by priority
            // - combine directives as: processed + template + unprocessed
            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

            if (newIsolateScopeDirective || newScopeDirective) {
              // The original directive caused the current element to be replaced but this element
              // also needs to have a new scope, so we need to tell the template directives
              // that they would need to get their scope from further up, if they require transclusion
              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
            }
            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

            ii = directives.length;
          } else {
            $compileNode.html(directiveValue);
          }
        }

        if (directive.templateUrl) {
          hasTemplate = true;
          assertNoDuplicate('template', templateDirective, directive, $compileNode);
          templateDirective = directive;

          if (directive.replace) {
            replaceDirective = directive;
          }

          // eslint-disable-next-line no-func-assign
          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
                controllerDirectives: controllerDirectives,
                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
                newIsolateScopeDirective: newIsolateScopeDirective,
                templateDirective: templateDirective,
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
          ii = directives.length;
        } else if (directive.compile) {
          try {
            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
            var context = directive.$$originalDirective || directive;
            if (isFunction(linkFn)) {
              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
            } else if (linkFn) {
              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
            }
          } catch (e) {
            $exceptionHandler(e, startingTag($compileNode));
          }
        }

        if (directive.terminal) {
          nodeLinkFn.terminal = true;
          terminalPriority = Math.max(terminalPriority, directive.priority);
        }

      }

      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
      nodeLinkFn.templateOnThisElement = hasTemplate;
      nodeLinkFn.transclude = childTranscludeFn;

      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
      return nodeLinkFn;

      ////////////////////

      function addLinkFns(pre, post, attrStart, attrEnd) {
        if (pre) {
          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
          pre.require = directive.require;
          pre.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
          }
          preLinkFns.push(pre);
        }
        if (post) {
          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
          post.require = directive.require;
          post.directiveName = directiveName;
          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
            post = cloneAndAnnotateFn(post, {isolateScope: true});
          }
          postLinkFns.push(post);
        }
      }

      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
            attrs, scopeBindingInfo;

        if (compileNode === linkNode) {
          attrs = templateAttrs;
          $element = templateAttrs.$$element;
        } else {
          $element = jqLite(linkNode);
          attrs = new Attributes($element, templateAttrs);
        }

        controllerScope = scope;
        if (newIsolateScopeDirective) {
          isolateScope = scope.$new(true);
        } else if (newScopeDirective) {
          controllerScope = scope.$parent;
        }

        if (boundTranscludeFn) {
          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
          transcludeFn = controllersBoundTransclude;
          transcludeFn.$$boundTransclude = boundTranscludeFn;
          // expose the slots on the `$transclude` function
          transcludeFn.isSlotFilled = function(slotName) {
            return !!boundTranscludeFn.$$slots[slotName];
          };
        }

        if (controllerDirectives) {
          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
        }

        if (newIsolateScopeDirective) {
          // Initialize isolate scope bindings for new isolate scope directive.
          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
              templateDirective === newIsolateScopeDirective.$$originalDirective)));
          compile.$$addScopeClass($element, true);
          isolateScope.$$isolateBindings =
              newIsolateScopeDirective.$$isolateBindings;
          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
                                        isolateScope.$$isolateBindings,
                                        newIsolateScopeDirective);
          if (scopeBindingInfo.removeWatches) {
            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
          }
        }

        // Initialize bindToController bindings
        for (var name in elementControllers) {
          var controllerDirective = controllerDirectives[name];
          var controller = elementControllers[name];
          var bindings = controllerDirective.$$bindings.bindToController;

          if (preAssignBindingsEnabled) {
            if (bindings) {
              controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
            } else {
              controller.bindingInfo = {};
            }

            var controllerResult = controller();
            if (controllerResult !== controller.instance) {
              // If the controller constructor has a return value, overwrite the instance
              // from setupControllers
              controller.instance = controllerResult;
              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
              if (controller.bindingInfo.removeWatches) {
                controller.bindingInfo.removeWatches();
              }
              controller.bindingInfo =
                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
            }
          } else {
            controller.instance = controller();
            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
            controller.bindingInfo =
              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }
        }

        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
        forEach(controllerDirectives, function(controllerDirective, name) {
          var require = controllerDirective.require;
          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
          }
        });

        // Handle the init and destroy lifecycle hooks on all controllers that have them
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$onChanges)) {
            try {
              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$onInit)) {
            try {
              controllerInstance.$onInit();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          if (isFunction(controllerInstance.$doCheck)) {
            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
            controllerInstance.$doCheck();
          }
          if (isFunction(controllerInstance.$onDestroy)) {
            controllerScope.$on('$destroy', function callOnDestroyHook() {
              controllerInstance.$onDestroy();
            });
          }
        });

        // PRELINKING
        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
          linkFn = preLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // RECURSION
        // We only pass the isolate scope, if the isolate directive has a template,
        // otherwise the child elements do not belong to the isolate directive.
        var scopeToChild = scope;
        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
          scopeToChild = isolateScope;
        }
        if (childLinkFn) {
          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
        }

        // POSTLINKING
        for (i = postLinkFns.length - 1; i >= 0; i--) {
          linkFn = postLinkFns[i];
          invokeLinkFn(linkFn,
              linkFn.isolateScope ? isolateScope : scope,
              $element,
              attrs,
              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
              transcludeFn
          );
        }

        // Trigger $postLink lifecycle hooks
        forEach(elementControllers, function(controller) {
          var controllerInstance = controller.instance;
          if (isFunction(controllerInstance.$postLink)) {
            controllerInstance.$postLink();
          }
        });

        // This is the function that is injected as `$transclude`.
        // Note: all arguments are optional!
        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
          var transcludeControllers;
          // No scope passed in:
          if (!isScope(scope)) {
            slotName = futureParentElement;
            futureParentElement = cloneAttachFn;
            cloneAttachFn = scope;
            scope = undefined;
          }

          if (hasElementTranscludeDirective) {
            transcludeControllers = elementControllers;
          }
          if (!futureParentElement) {
            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
          }
          if (slotName) {
            // slotTranscludeFn can be one of three things:
            //  * a transclude function - a filled slot
            //  * `null` - an optional slot that was not filled
            //  * `undefined` - a slot that was not declared (i.e. invalid)
            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
            if (slotTranscludeFn) {
              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            } else if (isUndefined(slotTranscludeFn)) {
              throw $compileMinErr('noslot',
               'No parent directive that requires a transclusion with slot name "{0}". ' +
               'Element: {1}',
               slotName, startingTag($element));
            }
          } else {
            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
          }
        }
      }
    }

    function getControllers(directiveName, require, $element, elementControllers) {
      var value;

      if (isString(require)) {
        var match = require.match(REQUIRE_PREFIX_REGEXP);
        var name = require.substring(match[0].length);
        var inheritType = match[1] || match[3];
        var optional = match[2] === '?';

        //If only parents then start at the parent element
        if (inheritType === '^^') {
          $element = $element.parent();
        //Otherwise attempt getting the controller from elementControllers in case
        //the element is transcluded (and has no data) and to avoid .data if possible
        } else {
          value = elementControllers && elementControllers[name];
          value = value && value.instance;
        }

        if (!value) {
          var dataName = '$' + name + 'Controller';
          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
        }

        if (!value && !optional) {
          throw $compileMinErr('ctreq',
              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
              name, directiveName);
        }
      } else if (isArray(require)) {
        value = [];
        for (var i = 0, ii = require.length; i < ii; i++) {
          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
        }
      } else if (isObject(require)) {
        value = {};
        forEach(require, function(controller, property) {
          value[property] = getControllers(directiveName, controller, $element, elementControllers);
        });
      }

      return value || null;
    }

    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
      var elementControllers = createMap();
      for (var controllerKey in controllerDirectives) {
        var directive = controllerDirectives[controllerKey];
        var locals = {
          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
          $element: $element,
          $attrs: attrs,
          $transclude: transcludeFn
        };

        var controller = directive.controller;
        if (controller === '@') {
          controller = attrs[directive.name];
        }

        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

        // For directives with element transclusion the element is a comment.
        // In this case .data will not attach any data.
        // Instead, we save the controllers for the element in a local hash and attach to .data
        // later, once we have the actual element.
        elementControllers[directive.name] = controllerInstance;
        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
      }
      return elementControllers;
    }

    // Depending upon the context in which a directive finds itself it might need to have a new isolated
    // or child scope created. For instance:
    // * if the directive has been pulled into a template because another directive with a higher priority
    // asked for element transclusion
    // * if the directive itself asks for transclusion but it is at the root of a template and the original
    // element was replaced. See https://github.com/angular/angular.js/issues/12936
    function markDirectiveScope(directives, isolateScope, newScope) {
      for (var j = 0, jj = directives.length; j < jj; j++) {
        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
      }
    }

    /**
     * looks up the directive and decorates it with exception handling and proper parameters. We
     * call this the boundDirective.
     *
     * @param {string} name name of the directive to look up.
     * @param {string} location The directive must be found in specific format.
     *   String containing any of theses characters:
     *
     *   * `E`: element name
     *   * `A': attribute
     *   * `C`: class
     *   * `M`: comment
     * @returns {boolean} true if directive was added.
     */
    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
                          endAttrName) {
      if (name === ignoreDirective) return null;
      var match = null;
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
               directive.restrict.indexOf(location) !== -1) {
            if (startAttrName) {
              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
            }
            if (!directive.$$bindings) {
              var bindings = directive.$$bindings =
                  parseDirectiveBindings(directive, directive.name);
              if (isObject(bindings.isolateScope)) {
                directive.$$isolateBindings = bindings.isolateScope;
              }
            }
            tDirectives.push(directive);
            match = directive;
          }
        }
      }
      return match;
    }


    /**
     * looks up the directive and returns true if it is a multi-element directive,
     * and therefore requires DOM nodes between -start and -end markers to be grouped
     * together.
     *
     * @param {string} name name of the directive to look up.
     * @returns true if directive was registered as multi-element.
     */
    function directiveIsMultiElement(name) {
      if (hasDirectives.hasOwnProperty(name)) {
        for (var directive, directives = $injector.get(name + Suffix),
            i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          if (directive.multiElement) {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * When the element is replaced with HTML template then the new attributes
     * on the template need to be merged with the existing attributes in the DOM.
     * The desired effect is to have both of the attributes present.
     *
     * @param {object} dst destination attributes (original DOM)
     * @param {object} src source attributes (from the directive template)
     */
    function mergeTemplateAttributes(dst, src) {
      var srcAttr = src.$attr,
          dstAttr = dst.$attr;

      // reapply the old attributes to the new element
      forEach(dst, function(value, key) {
        if (key.charAt(0) !== '$') {
          if (src[key] && src[key] !== value) {
            value += (key === 'style' ? ';' : ' ') + src[key];
          }
          dst.$set(key, value, true, srcAttr[key]);
        }
      });

      // copy the new attributes on the old attrs object
      forEach(src, function(value, key) {
        // Check if we already set this attribute in the loop above.
        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
        // have an attribute like "has-own-property" or "data-has-own-property", etc.
        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
          dst[key] = value;

          if (key !== 'class' && key !== 'style') {
            dstAttr[key] = srcAttr[key];
          }
        }
      });
    }


    function compileTemplateUrl(directives, $compileNode, tAttrs,
        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
      var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
          }),
          templateUrl = (isFunction(origAsyncDirective.templateUrl))
              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
              : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;

      $compileNode.empty();

      $templateRequest(templateUrl)
        .then(function(content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt',
                  'Template for directive \'{0}\' must have exactly one root element. {1}',
                  origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = {$attr: {}};
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
              previousCompileContext);
          forEach($rootElement, function(node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective &&
                  origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
              childBoundTranscludeFn);
          }
          linkQueue = null;
        });

      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
        var childBoundTranscludeFn = boundTranscludeFn;
        if (scope.$$destroyed) return;
        if (linkQueue) {
          linkQueue.push(scope,
                         node,
                         rootElement,
                         childBoundTranscludeFn);
        } else {
          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
          }
          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
        }
      };
    }


    /**
     * Sorting function for bound directives.
     */
    function byPriority(a, b) {
      var diff = b.priority - a.priority;
      if (diff !== 0) return diff;
      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
      return a.index - b.index;
    }

    function assertNoDuplicate(what, previousDirective, directive, element) {

      function wrapModuleNameIfDefined(moduleName) {
        return moduleName ?
          (' (module: ' + moduleName + ')') :
          '';
      }

      if (previousDirective) {
        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
      }
    }


    function addTextInterpolateDirective(directives, text) {
      var interpolateFn = $interpolate(text, true);
      if (interpolateFn) {
        directives.push({
          priority: 0,
          compile: function textInterpolateCompileFn(templateNode) {
            var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

            // When transcluding a template that has bindings in the root
            // we don't have a parent and thus need to add the class during linking fn.
            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

            return function textInterpolateLinkFn(scope, node) {
              var parent = node.parent();
              if (!hasCompileParent) compile.$$addBindingClass(parent);
              compile.$$addBindingInfo(parent, interpolateFn.expressions);
              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                node[0].nodeValue = value;
              });
            };
          }
        });
      }
    }


    function wrapTemplate(type, template) {
      type = lowercase(type || 'html');
      switch (type) {
      case 'svg':
      case 'math':
        var wrapper = window.document.createElement('div');
        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
        return wrapper.childNodes[0].childNodes;
      default:
        return template;
      }
    }


    function getTrustedContext(node, attrNormalizedName) {
      if (attrNormalizedName === 'srcdoc') {
        return $sce.HTML;
      }
      var tag = nodeName_(node);
      // All tags with src attributes require a RESOURCE_URL value, except for
      // img and various html5 media tags.
      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
          return $sce.RESOURCE_URL;
        }
      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
      } else if (attrNormalizedName === 'xlinkHref' ||
          (tag === 'form' && attrNormalizedName === 'action')
      ) {
        return $sce.RESOURCE_URL;
      }
    }


    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
      var trustedContext = getTrustedContext(node, name);
      var mustHaveExpression = !isNgAttr;
      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

      // no interpolation found -> ignore
      if (!interpolateFn) return;

      if (name === 'multiple' && nodeName_(node) === 'select') {
        throw $compileMinErr('selmulti',
            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
            startingTag(node));
      }

      directives.push({
        priority: 100,
        compile: function() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));

                if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
                  throw $compileMinErr('nodomevents',
                      'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
                          'ng- versions (such as ng-click instead of onclick) instead.');
                }

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).
                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                    //special case for class attribute addition + removal
                    //so that class changes can tap into the animation
                    //hooks provided by the $animate service. Be sure to
                    //skip animations when the first digest occurs (when
                    //both the new and the old values are the same) since
                    //the CSS classes are the non-interpolated values
                    if (name === 'class' && newValue !== oldValue) {
                      attr.$updateClass(newValue, oldValue);
                    } else {
                      attr.$set(name, newValue);
                    }
                  });
              }
            };
          }
      });
    }


    /**
     * This is a special jqLite.replaceWith, which can replace items which
     * have no parents, provided that the containing jqLite collection is provided.
     *
     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
     *                               in the root of the tree.
     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
     *                                  the shell, but replace its DOM node reference.
     * @param {Node} newNode The new DOM node.
     */
    function replaceWith($rootElement, elementsToRemove, newNode) {
      var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i, ii;

      if ($rootElement) {
        for (i = 0, ii = $rootElement.length; i < ii; i++) {
          if ($rootElement[i] === firstElementToRemove) {
            $rootElement[i++] = newNode;
            for (var j = i, j2 = j + removeCount - 1,
                     jj = $rootElement.length;
                 j < jj; j++, j2++) {
              if (j2 < jj) {
                $rootElement[j] = $rootElement[j2];
              } else {
                delete $rootElement[j];
              }
            }
            $rootElement.length -= removeCount - 1;

            // If the replaced element is also the jQuery .context then replace it
            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
            // http://api.jquery.com/context/
            if ($rootElement.context === firstElementToRemove) {
              $rootElement.context = newNode;
            }
            break;
          }
        }
      }

      if (parent) {
        parent.replaceChild(newNode, firstElementToRemove);
      }

      // Append all the `elementsToRemove` to a fragment. This will...
      // - remove them from the DOM
      // - allow them to still be traversed with .nextSibling
      // - allow a single fragment.qSA to fetch all elements being removed
      var fragment = window.document.createDocumentFragment();
      for (i = 0; i < removeCount; i++) {
        fragment.appendChild(elementsToRemove[i]);
      }

      if (jqLite.hasData(firstElementToRemove)) {
        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
        // data here because there's no public interface in jQuery to do that and copying over
        // event listeners (which is the main use of private data) wouldn't work anyway.
        jqLite.data(newNode, jqLite.data(firstElementToRemove));

        // Remove $destroy event listeners from `firstElementToRemove`
        jqLite(firstElementToRemove).off('$destroy');
      }

      // Cleanup any data/listeners on the elements and children.
      // This includes invoking the $destroy event on any elements with listeners.
      jqLite.cleanData(fragment.querySelectorAll('*'));

      // Update the jqLite collection to only contain the `newNode`
      for (i = 1; i < removeCount; i++) {
        delete elementsToRemove[i];
      }
      elementsToRemove[0] = newNode;
      elementsToRemove.length = 1;
    }


    function cloneAndAnnotateFn(fn, annotation) {
      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
    }


    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
      try {
        linkFn(scope, $element, attrs, controllers, transcludeFn);
      } catch (e) {
        $exceptionHandler(e, startingTag($element));
      }
    }


    // Set up $watches for isolate scope and controller bindings.
    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
      var removeWatchCollection = [];
      var initialChanges = {};
      var changes;
      forEach(bindings, function initializeBinding(definition, scopeName) {
        var attrName = definition.attrName,
        optional = definition.optional,
        mode = definition.mode, // @, =, <, or &
        lastValue,
        parentGet, parentSet, compare, removeWatch;

        switch (mode) {

          case '@':
            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
              destination[scopeName] = attrs[attrName] = undefined;
            }
            removeWatch = attrs.$observe(attrName, function(value) {
              if (isString(value) || isBoolean(value)) {
                var oldValue = destination[scopeName];
                recordChanges(scopeName, value, oldValue);
                destination[scopeName] = value;
              }
            });
            attrs.$$observers[attrName].$$scope = scope;
            lastValue = attrs[attrName];
            if (isString(lastValue)) {
              // If the attribute has been provided then we trigger an interpolation to ensure
              // the value is there for use in the link fn
              destination[scopeName] = $interpolate(lastValue)(scope);
            } else if (isBoolean(lastValue)) {
              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
              // the value to boolean rather than a string, so we special case this situation
              destination[scopeName] = lastValue;
            }
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
            removeWatchCollection.push(removeWatch);
            break;

          case '=':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            if (parentGet.literal) {
              compare = equals;
            } else {
              // eslint-disable-next-line no-self-compare
              compare = function simpleCompare(a, b) { return a === b || (a !== a && b !== b); };
            }
            parentSet = parentGet.assign || function() {
              // reset the change, or we will throw this exception on every $digest
              lastValue = destination[scopeName] = parentGet(scope);
              throw $compileMinErr('nonassign',
                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
                  attrs[attrName], attrName, directive.name);
            };
            lastValue = destination[scopeName] = parentGet(scope);
            var parentValueWatch = function parentValueWatch(parentValue) {
              if (!compare(parentValue, destination[scopeName])) {
                // we are out of sync and need to copy
                if (!compare(parentValue, lastValue)) {
                  // parent changed and it has precedence
                  destination[scopeName] = parentValue;
                } else {
                  // if the parent can be assigned then do so
                  parentSet(scope, parentValue = destination[scopeName]);
                }
              }
              lastValue = parentValue;
              return lastValue;
            };
            parentValueWatch.$stateful = true;
            if (definition.collection) {
              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
            } else {
              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
            }
            removeWatchCollection.push(removeWatch);
            break;

          case '<':
            if (!hasOwnProperty.call(attrs, attrName)) {
              if (optional) break;
              attrs[attrName] = undefined;
            }
            if (optional && !attrs[attrName]) break;

            parentGet = $parse(attrs[attrName]);
            var deepWatch = parentGet.literal;

            var initialValue = destination[scopeName] = parentGet(scope);
            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
              if (oldValue === newValue) {
                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
                  return;
                }
                oldValue = initialValue;
              }
              recordChanges(scopeName, newValue, oldValue);
              destination[scopeName] = newValue;
            }, deepWatch);

            removeWatchCollection.push(removeWatch);
            break;

          case '&':
            // Don't assign Object.prototype method to scope
            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

            // Don't assign noop to destination if expression is not valid
            if (parentGet === noop && optional) break;

            destination[scopeName] = function(locals) {
              return parentGet(scope, locals);
            };
            break;
        }
      });

      function recordChanges(key, currentValue, previousValue) {
        if (isFunction(destination.$onChanges) && currentValue !== previousValue &&
            // eslint-disable-next-line no-self-compare
            (currentValue === currentValue || previousValue === previousValue)) {
          // If we have not already scheduled the top level onChangesQueue handler then do so now
          if (!onChangesQueue) {
            scope.$$postDigest(flushOnChangesQueue);
            onChangesQueue = [];
          }
          // If we have not already queued a trigger of onChanges for this controller then do so now
          if (!changes) {
            changes = {};
            onChangesQueue.push(triggerOnChangesHook);
          }
          // If the has been a change on this property already then we need to reuse the previous value
          if (changes[key]) {
            previousValue = changes[key].previousValue;
          }
          // Store this change
          changes[key] = new SimpleChange(previousValue, currentValue);
        }
      }

      function triggerOnChangesHook() {
        destination.$onChanges(changes);
        // Now clear the changes so that we schedule onChanges when more changes arrive
        changes = undefined;
      }

      return {
        initialChanges: initialChanges,
        removeWatches: removeWatchCollection.length && function removeWatches() {
          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
            removeWatchCollection[i]();
          }
        }
      };
    }
  }];
}

function SimpleChange(previous, current) {
  this.previousValue = previous;
  this.currentValue = current;
}
SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };


var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
/**
 * Converts all accepted directives format into proper directive name.
 * @param name Name to normalize
 */
function directiveNormalize(name) {
  return camelCase(name.replace(PREFIX_REGEXP, ''));
}

/**
 * @ngdoc type
 * @name $compile.directive.Attributes
 *
 * @description
 * A shared object between directive compile / linking functions which contains normalized DOM
 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
 * needed since all of these are treated as equivalent in Angular:
 *
 * ```
 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
 * ```
 */

/**
 * @ngdoc property
 * @name $compile.directive.Attributes#$attr
 *
 * @description
 * A map of DOM element attribute names to the normalized name. This is
 * needed to do reverse lookup from normalized name back to actual name.
 */


/**
 * @ngdoc method
 * @name $compile.directive.Attributes#$set
 * @kind function
 *
 * @description
 * Set DOM element attribute value.
 *
 *
 * @param {string} name Normalized element attribute name of the property to modify. The name is
 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
 *          property to the original name.
 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
 */



/**
 * Closure compiler type information
 */

function nodesetLinkingFn(
  /* angular.Scope */ scope,
  /* NodeList */ nodeList,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function directiveLinkingFn(
  /* nodesetLinkingFn */ nodesetLinkingFn,
  /* angular.Scope */ scope,
  /* Node */ node,
  /* Element */ rootElement,
  /* function(Function) */ boundTranscludeFn
) {}

function tokenDifference(str1, str2) {
  var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);

  outer:
  for (var i = 0; i < tokens1.length; i++) {
    var token = tokens1[i];
    for (var j = 0; j < tokens2.length; j++) {
      if (token === tokens2[j]) continue outer;
    }
    values += (values.length > 0 ? ' ' : '') + token;
  }
  return values;
}

function removeComments(jqNodes) {
  jqNodes = jqLite(jqNodes);
  var i = jqNodes.length;

  if (i <= 1) {
    return jqNodes;
  }

  while (i--) {
    var node = jqNodes[i];
    if (node.nodeType === NODE_TYPE_COMMENT ||
       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
         splice.call(jqNodes, i, 1);
    }
  }
  return jqNodes;
}

var $controllerMinErr = minErr('$controller');


var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
function identifierForController(controller, ident) {
  if (ident && isString(ident)) return ident;
  if (isString(controller)) {
    var match = CNTRL_REG.exec(controller);
    if (match) return match[3];
  }
}


/**
 * @ngdoc provider
 * @name $controllerProvider
 * @this
 *
 * @description
 * The {@link ng.$controller $controller service} is used by Angular to create new
 * controllers.
 *
 * This provider allows controller registration via the
 * {@link ng.$controllerProvider#register register} method.
 */
function $ControllerProvider() {
  var controllers = {},
      globals = false;

  /**
   * @ngdoc method
   * @name $controllerProvider#has
   * @param {string} name Controller name to check.
   */
  this.has = function(name) {
    return controllers.hasOwnProperty(name);
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#register
   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
   *    the names and the values are the constructors.
   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
   *    annotations in the array notation).
   */
  this.register = function(name, constructor) {
    assertNotHasOwnProperty(name, 'controller');
    if (isObject(name)) {
      extend(controllers, name);
    } else {
      controllers[name] = constructor;
    }
  };

  /**
   * @ngdoc method
   * @name $controllerProvider#allowGlobals
   *
   * @deprecated
   * sinceVersion="v1.3.0"
   * removeVersion="v1.7.0"
   * This method of finding controllers has been deprecated.
   *
   * @description If called, allows `$controller` to find controller constructors on `window`   *
   */
  this.allowGlobals = function() {
    globals = true;
  };


  this.$get = ['$injector', '$window', function($injector, $window) {

    /**
     * @ngdoc service
     * @name $controller
     * @requires $injector
     *
     * @param {Function|string} constructor If called with a function then it's considered to be the
     *    controller constructor function. Otherwise it's considered to be a string which is used
     *    to retrieve the controller constructor using the following steps:
     *
     *    * check if a controller with given name is registered via `$controllerProvider`
     *    * check if evaluating the string on the current scope returns a constructor
     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
     *      `window` object (not recommended)
     *
     *    The string can use the `controller as property` syntax, where the controller instance is published
     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
     *    to work correctly.
     *
     * @param {Object} locals Injection locals for Controller.
     * @return {Object} Instance of given controller.
     *
     * @description
     * `$controller` service is responsible for instantiating controllers.
     *
     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
     */
    return function $controller(expression, locals, later, ident) {
      // PRIVATE API:
      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
      //                     If true, $controller will allocate the object with the correct
      //                     prototype chain, but will not invoke the controller until a returned
      //                     callback is invoked.
      //   param `ident` --- An optional label which overrides the label parsed from the controller
      //                     expression, if any.
      var instance, match, constructor, identifier;
      later = later === true;
      if (ident && isString(ident)) {
        identifier = ident;
      }

      if (isString(expression)) {
        match = expression.match(CNTRL_REG);
        if (!match) {
          throw $controllerMinErr('ctrlfmt',
            'Badly formed controller string \'{0}\'. ' +
            'Must match `__name__ as __id__` or `__name__`.', expression);
        }
        constructor = match[1];
        identifier = identifier || match[3];
        expression = controllers.hasOwnProperty(constructor)
            ? controllers[constructor]
            : getter(locals.$scope, constructor, true) ||
                (globals ? getter($window, constructor, true) : undefined);

        if (!expression) {
          throw $controllerMinErr('ctrlreg',
            'The controller with the name \'{0}\' is not registered.', constructor);
        }

        assertArgFn(expression, constructor, true);
      }

      if (later) {
        // Instantiate controller later:
        // This machinery is used to create an instance of the object before calling the
        // controller's constructor itself.
        //
        // This allows properties to be added to the controller before the constructor is
        // invoked. Primarily, this is used for isolate scope bindings in $compile.
        //
        // This feature is not intended for use by applications, and is thus not documented
        // publicly.
        // Object creation: http://jsperf.com/create-constructor/2
        var controllerPrototype = (isArray(expression) ?
          expression[expression.length - 1] : expression).prototype;
        instance = Object.create(controllerPrototype || null);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return extend(function $controllerInit() {
          var result = $injector.invoke(expression, instance, locals, constructor);
          if (result !== instance && (isObject(result) || isFunction(result))) {
            instance = result;
            if (identifier) {
              // If result changed, re-assign controllerAs value to scope.
              addIdentifier(locals, identifier, instance, constructor || expression.name);
            }
          }
          return instance;
        }, {
          instance: instance,
          identifier: identifier
        });
      }

      instance = $injector.instantiate(expression, locals, constructor);

      if (identifier) {
        addIdentifier(locals, identifier, instance, constructor || expression.name);
      }

      return instance;
    };

    function addIdentifier(locals, identifier, instance, name) {
      if (!(locals && isObject(locals.$scope))) {
        throw minErr('$controller')('noscp',
          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
          name, identifier);
      }

      locals.$scope[identifier] = instance;
    }
  }];
}

/**
 * @ngdoc service
 * @name $document
 * @requires $window
 * @this
 *
 * @description
 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
 *
 * @example
   <example module="documentExample" name="document">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <p>$document title: <b ng-bind="title"></b></p>
         <p>window.document title: <b ng-bind="windowTitle"></b></p>
       </div>
     </file>
     <file name="script.js">
       angular.module('documentExample', [])
         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
           $scope.title = $document[0].title;
           $scope.windowTitle = angular.element(window.document)[0].title;
         }]);
     </file>
   </example>
 */
function $DocumentProvider() {
  this.$get = ['$window', function(window) {
    return jqLite(window.document);
  }];
}

/**
 * @ngdoc service
 * @name $exceptionHandler
 * @requires ng.$log
 * @this
 *
 * @description
 * Any uncaught exception in angular expressions is delegated to this service.
 * The default implementation simply delegates to `$log.error` which logs it into
 * the browser console.
 *
 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
 *
 * ## Example:
 *
 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
 * of `$log.error()`.
 *
 * ```js
 *   angular.
 *     module('exceptionOverwrite', []).
 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
 *       return function myExceptionHandler(exception, cause) {
 *         logErrorsToBackend(exception, cause);
 *         $log.warn(exception, cause);
 *       };
 *     }]);
 * ```
 *
 * <hr />
 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
 * (unless executed during a digest).
 *
 * If you wish, you can manually delegate exceptions, e.g.
 * `try { ... } catch(e) { $exceptionHandler(e); }`
 *
 * @param {Error} exception Exception associated with the error.
 * @param {string=} cause Optional information about the context in which
 *       the error was thrown.
 *
 */
function $ExceptionHandlerProvider() {
  this.$get = ['$log', function($log) {
    return function(exception, cause) {
      $log.error.apply($log, arguments);
    };
  }];
}

var $$ForceReflowProvider = /** @this */ function() {
  this.$get = ['$document', function($document) {
    return function(domNode) {
      //the line below will force the browser to perform a repaint so
      //that all the animated elements within the animation frame will
      //be properly updated and drawn on screen. This is required to
      //ensure that the preparation animation is properly flushed so that
      //the active state picks up from there. DO NOT REMOVE THIS LINE.
      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
      if (domNode) {
        if (!domNode.nodeType && domNode instanceof jqLite) {
          domNode = domNode[0];
        }
      } else {
        domNode = $document[0].body;
      }
      return domNode.offsetWidth + 1;
    };
  }];
};

var APPLICATION_JSON = 'application/json';
var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
var JSON_START = /^\[|^\{(?!\{)/;
var JSON_ENDS = {
  '[': /]$/,
  '{': /}$/
};
var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
var $httpMinErr = minErr('$http');
var $httpMinErrLegacyFn = function(method) {
  return function() {
    throw $httpMinErr('legacy', 'The method `{0}` on the promise returned from `$http` has been disabled.', method);
  };
};

function serializeValue(v) {
  if (isObject(v)) {
    return isDate(v) ? v.toISOString() : toJson(v);
  }
  return v;
}


/** @this */
function $HttpParamSerializerProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializer
   * @description
   *
   * Default {@link $http `$http`} params serializer that converts objects to strings
   * according to the following rules:
   *
   * * `{'foo': 'bar'}` results in `foo=bar`
   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
   *
   * Note that serializer will sort the request parameters alphabetically.
   * */

  this.$get = function() {
    return function ngParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      forEachSorted(params, function(value, key) {
        if (value === null || isUndefined(value)) return;
        if (isArray(value)) {
          forEach(value, function(v) {
            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
          });
        } else {
          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
        }
      });

      return parts.join('&');
    };
  };
}

/** @this */
function $HttpParamSerializerJQLikeProvider() {
  /**
   * @ngdoc service
   * @name $httpParamSerializerJQLike
   *
   * @description
   *
   * Alternative {@link $http `$http`} params serializer that follows
   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
   * The serializer will also sort the params alphabetically.
   *
   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
   *
   * ```js
   * $http({
   *   url: myUrl,
   *   method: 'GET',
   *   params: myParams,
   *   paramSerializer: '$httpParamSerializerJQLike'
   * });
   * ```
   *
   * It is also possible to set it as the default `paramSerializer` in the
   * {@link $httpProvider#defaults `$httpProvider`}.
   *
   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
   * form data for submission:
   *
   * ```js
   * .controller(function($http, $httpParamSerializerJQLike) {
   *   //...
   *
   *   $http({
   *     url: myUrl,
   *     method: 'POST',
   *     data: $httpParamSerializerJQLike(myData),
   *     headers: {
   *       'Content-Type': 'application/x-www-form-urlencoded'
   *     }
   *   });
   *
   * });
   * ```
   *
   * */
  this.$get = function() {
    return function jQueryLikeParamSerializer(params) {
      if (!params) return '';
      var parts = [];
      serialize(params, '', true);
      return parts.join('&');

      function serialize(toSerialize, prefix, topLevel) {
        if (toSerialize === null || isUndefined(toSerialize)) return;
        if (isArray(toSerialize)) {
          forEach(toSerialize, function(value, index) {
            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
          });
        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
          forEachSorted(toSerialize, function(value, key) {
            serialize(value, prefix +
                (topLevel ? '' : '[') +
                key +
                (topLevel ? '' : ']'));
          });
        } else {
          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
        }
      }
    };
  };
}

function defaultHttpResponseTransform(data, headers) {
  if (isString(data)) {
    // Strip json vulnerability protection prefix and trim whitespace
    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

    if (tempData) {
      var contentType = headers('Content-Type');
      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
        data = fromJson(tempData);
      }
    }
  }

  return data;
}

function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
}

/**
 * Parse headers into key value object
 *
 * @param {string} headers Raw headers as a string
 * @returns {Object} Parsed headers as key value object
 */
function parseHeaders(headers) {
  var parsed = createMap(), i;

  function fillInParsed(key, val) {
    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  }

  if (isString(headers)) {
    forEach(headers.split('\n'), function(line) {
      i = line.indexOf(':');
      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
    });
  } else if (isObject(headers)) {
    forEach(headers, function(headerVal, headerKey) {
      fillInParsed(lowercase(headerKey), trim(headerVal));
    });
  }

  return parsed;
}


/**
 * Returns a function that provides access to parsed headers.
 *
 * Headers are lazy parsed when first requested.
 * @see parseHeaders
 *
 * @param {(string|Object)} headers Headers to provide access to.
 * @returns {function(string=)} Returns a getter function which if called with:
 *
 *   - if called with an argument returns a single header value or null
 *   - if called with no arguments returns an object containing all headers.
 */
function headersGetter(headers) {
  var headersObj;

  return function(name) {
    if (!headersObj) headersObj =  parseHeaders(headers);

    if (name) {
      var value = headersObj[lowercase(name)];
      if (value === undefined) {
        value = null;
      }
      return value;
    }

    return headersObj;
  };
}


/**
 * Chain all given functions
 *
 * This function is used for both request and response transforming
 *
 * @param {*} data Data to transform.
 * @param {function(string=)} headers HTTP headers getter fn.
 * @param {number} status HTTP status code of the response.
 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
 * @returns {*} Transformed data.
 */
function transformData(data, headers, status, fns) {
  if (isFunction(fns)) {
    return fns(data, headers, status);
  }

  forEach(fns, function(fn) {
    data = fn(data, headers, status);
  });

  return data;
}


function isSuccess(status) {
  return 200 <= status && status < 300;
}


/**
 * @ngdoc provider
 * @name $httpProvider
 * @this
 *
 * @description
 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
 * */
function $HttpProvider() {
  /**
   * @ngdoc property
   * @name $httpProvider#defaults
   * @description
   *
   * Object containing default values for all {@link ng.$http $http} requests.
   *
   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
   * by default. See {@link $http#caching $http Caching} for more information.
   *
   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
   * Defaults value is `'XSRF-TOKEN'`.
   *
   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
   *
   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
   * setting default headers.
   *     - **`defaults.headers.common`**
   *     - **`defaults.headers.post`**
   *     - **`defaults.headers.put`**
   *     - **`defaults.headers.patch`**
   *
   *
   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
   *  used to the prepare string representation of request parameters (specified as an object).
   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
   *
   **/
  var defaults = this.defaults = {
    // transform incoming response data
    transformResponse: [defaultHttpResponseTransform],

    // transform outgoing request data
    transformRequest: [function(d) {
      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
    }],

    // default headers
    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      },
      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
    },

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    paramSerializer: '$httpParamSerializer'
  };

  var useApplyAsync = false;
  /**
   * @ngdoc method
   * @name $httpProvider#useApplyAsync
   * @description
   *
   * Configure $http service to combine processing of multiple http responses received at around
   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
   * significant performance improvement for bigger applications that make many HTTP requests
   * concurrently (common during application bootstrap).
   *
   * Defaults to false. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
   *    to load and share the same digest cycle.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useApplyAsync = function(value) {
    if (isDefined(value)) {
      useApplyAsync = !!value;
      return this;
    }
    return useApplyAsync;
  };

  var useLegacyPromise = true;
  /**
   * @ngdoc method
   * @name $httpProvider#useLegacyPromiseExtensions
   * @description
   *
   * @deprecated
   * sinceVersion="v1.4.4"
   * removeVersion="v1.6.0"
   * This method will be removed in v1.6.0 along with the legacy promise methods.
   *
   * Configure `$http` service to return promises without the shorthand methods `success` and `error`.
   * This should be used to make sure that applications work without these methods.
   *
   * Defaults to true. If no value is specified, returns the current configured value.
   *
   * @param {boolean=} value If true, `$http` will return a promise with the deprecated legacy `success` and `error` methods.
   *
   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
   *    otherwise, returns the current configured value.
   **/
  this.useLegacyPromiseExtensions = function(value) {
    if (isDefined(value)) {
      useLegacyPromise = !!value;
      return this;
    }
    return useLegacyPromise;
  };

  /**
   * @ngdoc property
   * @name $httpProvider#interceptors
   * @description
   *
   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
   * pre-processing of request or postprocessing of responses.
   *
   * These service factories are ordered by request, i.e. they are applied in the same order as the
   * array, on request, but reverse order, on response.
   *
   * {@link ng.$http#interceptors Interceptors detailed info}
   **/
  var interceptorFactories = this.interceptors = [];

  this.$get = ['$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector',
      function($httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector) {

    var defaultCache = $cacheFactory('$http');

    /**
     * Make sure that default param serializer is exposed as a function
     */
    defaults.paramSerializer = isString(defaults.paramSerializer) ?
      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

    /**
     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
     * The reversal is needed so that we can build up the interception chain around the
     * server request.
     */
    var reversedInterceptors = [];

    forEach(interceptorFactories, function(interceptorFactory) {
      reversedInterceptors.unshift(isString(interceptorFactory)
          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
    });

    /**
     * @ngdoc service
     * @kind function
     * @name $http
     * @requires ng.$httpBackend
     * @requires $cacheFactory
     * @requires $rootScope
     * @requires $q
     * @requires $injector
     *
     * @description
     * The `$http` service is a core Angular service that facilitates communication with the remote
     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
     *
     * For unit testing applications that use `$http` service, see
     * {@link ngMock.$httpBackend $httpBackend mock}.
     *
     * For a higher level of abstraction, please check out the {@link ngResource.$resource
     * $resource} service.
     *
     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
     * it is important to familiarize yourself with these APIs and the guarantees they provide.
     *
     *
     * ## General usage
     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
     *
     * ```js
     *   // Simple GET request example:
     *   $http({
     *     method: 'GET',
     *     url: '/someUrl'
     *   }).then(function successCallback(response) {
     *       // this callback will be called asynchronously
     *       // when the response is available
     *     }, function errorCallback(response) {
     *       // called asynchronously if an error occurs
     *       // or server returns response with an error status.
     *     });
     * ```
     *
     * The response object has these properties:
     *
     *   - **data** – `{string|Object}` – The response body transformed with the transform
     *     functions.
     *   - **status** – `{number}` – HTTP status code of the response.
     *   - **headers** – `{function([headerName])}` – Header getter function.
     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
     *   - **statusText** – `{string}` – HTTP status text of the response.
     *
     * A response status code between 200 and 299 is considered a success status and will result in
     * the success callback being called. Any response status code outside of that range is
     * considered an error status and will result in the error callback being called.
     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
     * aborted, e.g. using a `config.timeout`.
     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
     * that the outcome (success or error) will be determined by the final response status code.
     *
     *
     * ## Shortcut methods
     *
     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
     * last argument.
     *
     * ```js
     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
     * ```
     *
     * Complete list of shortcut methods:
     *
     * - {@link ng.$http#get $http.get}
     * - {@link ng.$http#head $http.head}
     * - {@link ng.$http#post $http.post}
     * - {@link ng.$http#put $http.put}
     * - {@link ng.$http#delete $http.delete}
     * - {@link ng.$http#jsonp $http.jsonp}
     * - {@link ng.$http#patch $http.patch}
     *
     *
     * ## Writing Unit Tests that use $http
     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
     * request using trained responses.
     *
     * ```
     * $httpBackend.expectGET(...);
     * $http.get(...);
     * $httpBackend.flush();
     * ```
     *
     * ## Deprecation Notice
     * <div class="alert alert-danger">
     *   The `$http` legacy promise methods `success` and `error` have been deprecated and will be
     *   removed in v1.6.0.
     *   Use the standard `then` method instead.
     *   If {@link $httpProvider#useLegacyPromiseExtensions `$httpProvider.useLegacyPromiseExtensions`} is set to
     *   `false` then these methods will throw {@link $http:legacy `$http/legacy`} error.
     * </div>
     *
     * ## Setting HTTP Headers
     *
     * The $http service will automatically add certain HTTP headers to all requests. These defaults
     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
     * object, which currently contains this default configuration:
     *
     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
     *   - `Content-Type: application/json`
     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
     *   - `Content-Type: application/json`
     *
     * To add or overwrite these defaults, simply add or remove a property from these configuration
     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
     * with the lowercased HTTP method name as the key, e.g.
     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
     *
     * The defaults can also be set at runtime via the `$http.defaults` object in the same
     * fashion. For example:
     *
     * ```
     * module.run(function($http) {
     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
     * });
     * ```
     *
     * In addition, you can supply a `headers` property in the config object passed when
     * calling `$http(config)`, which overrides the defaults without changing them globally.
     *
     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
     * Use the `headers` property, setting the desired header to `undefined`. For example:
     *
     * ```js
     * var req = {
     *  method: 'POST',
     *  url: 'http://example.com',
     *  headers: {
     *    'Content-Type': undefined
     *  },
     *  data: { test: 'test' }
     * }
     *
     * $http(req).then(function(){...}, function(){...});
     * ```
     *
     * ## Transforming Requests and Responses
     *
     * Both requests and responses can be transformed using transformation functions: `transformRequest`
     * and `transformResponse`. These properties can be a single function that returns
     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
     *
     * <div class="alert alert-warning">
     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
     * function will be reflected on the scope and in any templates where the object is data-bound.
     * To prevent this, transform functions should have no side-effects.
     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
     * </div>
     *
     * ### Default Transformations
     *
     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
     * `defaults.transformResponse` properties. If a request does not provide its own transformations
     * then these will be applied.
     *
     * You can augment or replace the default transformations by modifying these properties by adding to or
     * replacing the array.
     *
     * Angular provides the following default transformations:
     *
     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
     *
     * - If the `data` property of the request configuration object contains an object, serialize it
     *   into JSON format.
     *
     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
     *
     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
     *  - If JSON response is detected, deserialize it using a JSON parser.
     *
     *
     * ### Overriding the Default Transformations Per Request
     *
     * If you wish to override the request/response transformations only for a single request then provide
     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
     * into `$http`.
     *
     * Note that if you provide these properties on the config object the default transformations will be
     * overwritten. If you wish to augment the default transformations then you must include them in your
     * local transformation array.
     *
     * The following code demonstrates adding a new response transformation to be run after the default response
     * transformations have been run.
     *
     * ```js
     * function appendTransform(defaults, transform) {
     *
     *   // We can't guarantee that the default transformation is an array
     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
     *
     *   // Append the new transformation to the defaults
     *   return defaults.concat(transform);
     * }
     *
     * $http({
     *   url: '...',
     *   method: 'GET',
     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
     *     return doTransform(value);
     *   })
     * });
     * ```
     *
     *
     * ## Caching
     *
     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
     * set the config.cache value or the default cache value to TRUE or to a cache object (created
     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
     * precedence over the default cache value.
     *
     * In order to:
     *   * cache all responses - set the default cache value to TRUE or to a cache object
     *   * cache a specific response - set config.cache value to TRUE or to a cache object
     *
     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
     * then the default `$cacheFactory("$http")` object is used.
     *
     * The default cache value can be set by updating the
     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
     *
     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
     * the relevant cache object. The next time the same request is made, the response is returned
     * from the cache without sending a request to the server.
     *
     * Take note that:
     *
     *   * Only GET and JSONP requests are cached.
     *   * The cache key is the request URL including search parameters; headers are not considered.
     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
     *   * If multiple identical requests are made using the same cache, which is not yet populated,
     *     one request will be made to the server and remaining requests will return the same response.
     *   * A cache-control header on the response does not affect if or how responses are cached.
     *
     *
     * ## Interceptors
     *
     * Before you start creating interceptors, be sure to understand the
     * {@link ng.$q $q and deferred/promise APIs}.
     *
     * For purposes of global error handling, authentication, or any kind of synchronous or
     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
     * able to intercept requests before they are handed to the server and
     * responses before they are handed over to the application code that
     * initiated these requests. The interceptors leverage the {@link ng.$q
     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
     *
     * The interceptors are service factories that are registered with the `$httpProvider` by
     * adding them to the `$httpProvider.interceptors` array. The factory is called and
     * injected with dependencies (if specified) and returns the interceptor.
     *
     * There are two kinds of interceptors (and two kinds of rejection interceptors):
     *
     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
     *     modify the `config` object or create a new one. The function needs to return the `config`
     *     object directly, or a promise containing the `config` or a new `config` object.
     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *   * `response`: interceptors get called with http `response` object. The function is free to
     *     modify the `response` object or create a new one. The function needs to return the `response`
     *     object directly, or as a promise containing the `response` or a new `response` object.
     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
     *     resolved with a rejection.
     *
     *
     * ```js
     *   // register the interceptor as a service
     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
     *     return {
     *       // optional method
     *       'request': function(config) {
     *         // do something on success
     *         return config;
     *       },
     *
     *       // optional method
     *      'requestError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       },
     *
     *
     *
     *       // optional method
     *       'response': function(response) {
     *         // do something on success
     *         return response;
     *       },
     *
     *       // optional method
     *      'responseError': function(rejection) {
     *         // do something on error
     *         if (canRecover(rejection)) {
     *           return responseOrNewPromise
     *         }
     *         return $q.reject(rejection);
     *       }
     *     };
     *   });
     *
     *   $httpProvider.interceptors.push('myHttpInterceptor');
     *
     *
     *   // alternatively, register the interceptor via an anonymous factory
     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
     *     return {
     *      'request': function(config) {
     *          // same as above
     *       },
     *
     *       'response': function(response) {
     *          // same as above
     *       }
     *     };
     *   });
     * ```
     *
     * ## Security Considerations
     *
     * When designing web applications, consider security threats from:
     *
     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
     *
     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
     * pre-configured with strategies that address these issues, but for this to work backend server
     * cooperation is required.
     *
     * ### JSON Vulnerability Protection
     *
     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
     * allows third party website to turn your JSON resource URL into
     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
     * Angular will automatically strip the prefix before processing it as JSON.
     *
     * For example if your server needs to return:
     * ```js
     * ['one','two']
     * ```
     *
     * which is vulnerable to attack, your server can return:
     * ```js
     * )]}',
     * ['one','two']
     * ```
     *
     * Angular will strip the prefix, before processing the JSON.
     *
     *
     * ### Cross Site Request Forgery (XSRF) Protection
     *
     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
     * which the attacker can trick an authenticated user into unknowingly executing actions on your
     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
     * The header will not be set for cross-domain requests.
     *
     * To take advantage of this, your server needs to set a token in a JavaScript readable session
     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
     * that only JavaScript running on your domain could have sent the request. The token must be
     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
     * making up its own tokens). We recommend that the token is a digest of your site's
     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
     * for added security.
     *
     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
     * or the per-request config object.
     *
     * In order to prevent collisions in environments where multiple Angular apps share the
     * same domain or subdomain, we recommend that each application uses unique cookie name.
     *
     * @param {object} config Object describing the request to be made and how it should be
     *    processed. The object has following properties:
     *
     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
     *    - **url** – `{string}` – Absolute or relative URL of the resource that is being requested.
     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
     *      with the `paramSerializer` and appended as GET parameters.
     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
     *      HTTP headers to send to the server. If the return value of a function is null, the
     *      header will not be sent. Functions accept a config object as an argument.
     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
     *      The handler will be called in the context of a `$apply` block.
     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
     *    - **transformRequest** –
     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      request body and headers and returns its transformed (typically serialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **transformResponse** –
     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
     *      transform function or an array of such functions. The transform function takes the http
     *      response body, headers and status and returns its transformed (typically deserialized) version.
     *      See {@link ng.$http#overriding-the-default-transformations-per-request
     *      Overriding the Default Transformations}
     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
     *      prepare the string representation of request parameters (specified as an object).
     *      If specified as string, it is interpreted as function registered with the
     *      {@link $injector $injector}, which means you can create your own serializer
     *      by registering it as a {@link auto.$provide#service service}.
     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
     *      See {@link $http#caching $http Caching} for more information.
     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
     *      that should abort the request when resolved.
     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
     *      for more information.
     *    - **responseType** - `{string}` - see
     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
     *
     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
     *                        when the request succeeds or fails.
     *
     *
     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
     *   requests. This is primarily meant to be used for debugging purposes.
     *
     *
     * @example
<example module="httpExample" name="http-service">
<file name="index.html">
  <div ng-controller="FetchController">
    <select ng-model="method" aria-label="Request method">
      <option>GET</option>
      <option>JSONP</option>
    </select>
    <input type="text" ng-model="url" size="80" aria-label="URL" />
    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
    <button id="samplejsonpbtn"
      ng-click="updateModel('JSONP',
                    'https://angularjs.org/greet.php?callback=JSON_CALLBACK&name=Super%20Hero')">
      Sample JSONP
    </button>
    <button id="invalidjsonpbtn"
      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist&callback=JSON_CALLBACK')">
        Invalid JSONP
      </button>
    <pre>http status code: {{status}}</pre>
    <pre>http response data: {{data}}</pre>
  </div>
</file>
<file name="script.js">
  angular.module('httpExample', [])
    .controller('FetchController', ['$scope', '$http', '$templateCache',
      function($scope, $http, $templateCache) {
        $scope.method = 'GET';
        $scope.url = 'http-hello.html';

        $scope.fetch = function() {
          $scope.code = null;
          $scope.response = null;

          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
            then(function(response) {
              $scope.status = response.status;
              $scope.data = response.data;
            }, function(response) {
              $scope.data = response.data || 'Request failed';
              $scope.status = response.status;
          });
        };

        $scope.updateModel = function(method, url) {
          $scope.method = method;
          $scope.url = url;
        };
      }]);
</file>
<file name="http-hello.html">
  Hello, $http!
</file>
<file name="protractor.js" type="protractor">
  var status = element(by.binding('status'));
  var data = element(by.binding('data'));
  var fetchBtn = element(by.id('fetchbtn'));
  var sampleGetBtn = element(by.id('samplegetbtn'));
  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));

  it('should make an xhr GET request', function() {
    sampleGetBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('200');
    expect(data.getText()).toMatch(/Hello, \$http!/);
  });

// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
// it('should make a JSONP request to angularjs.org', function() {
//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
//   sampleJsonpBtn.click();
//   fetchBtn.click();
//   expect(status.getText()).toMatch('200');
//   expect(data.getText()).toMatch(/Super Hero!/);
// });

  it('should make JSONP request to invalid URL and invoke the error handler',
      function() {
    invalidJsonpBtn.click();
    fetchBtn.click();
    expect(status.getText()).toMatch('0');
    expect(data.getText()).toMatch('Request failed');
  });
</file>
</example>
     */
    function $http(requestConfig) {

      if (!isObject(requestConfig)) {
        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
      }

      if (!isString(requestConfig.url)) {
        throw minErr('$http')('badreq', 'Http request configuration url must be a string.  Received: {0}', requestConfig.url);
      }

      var config = extend({
        method: 'get',
        transformRequest: defaults.transformRequest,
        transformResponse: defaults.transformResponse,
        paramSerializer: defaults.paramSerializer
      }, requestConfig);

      config.headers = mergeHeaders(requestConfig);
      config.method = uppercase(config.method);
      config.paramSerializer = isString(config.paramSerializer) ?
          $injector.get(config.paramSerializer) : config.paramSerializer;

      var requestInterceptors = [];
      var responseInterceptors = [];
      var promise = $q.when(config);

      // apply interceptors
      forEach(reversedInterceptors, function(interceptor) {
        if (interceptor.request || interceptor.requestError) {
          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
        }
        if (interceptor.response || interceptor.responseError) {
          responseInterceptors.push(interceptor.response, interceptor.responseError);
        }
      });

      promise = chainInterceptors(promise, requestInterceptors);
      promise = promise.then(serverRequest);
      promise = chainInterceptors(promise, responseInterceptors);

      if (useLegacyPromise) {
        promise.success = function(fn) {
          assertArgFn(fn, 'fn');

          promise.then(function(response) {
            fn(response.data, response.status, response.headers, config);
          });
          return promise;
        };

        promise.error = function(fn) {
          assertArgFn(fn, 'fn');

          promise.then(null, function(response) {
            fn(response.data, response.status, response.headers, config);
          });
          return promise;
        };
      } else {
        promise.success = $httpMinErrLegacyFn('success');
        promise.error = $httpMinErrLegacyFn('error');
      }

      return promise;


      function chainInterceptors(promise, interceptors) {
        for (var i = 0, ii = interceptors.length; i < ii;) {
          var thenFn = interceptors[i++];
          var rejectFn = interceptors[i++];

          promise = promise.then(thenFn, rejectFn);
        }

        interceptors.length = 0;

        return promise;
      }

      function executeHeaderFns(headers, config) {
        var headerContent, processedHeaders = {};

        forEach(headers, function(headerFn, header) {
          if (isFunction(headerFn)) {
            headerContent = headerFn(config);
            if (headerContent != null) {
              processedHeaders[header] = headerContent;
            }
          } else {
            processedHeaders[header] = headerFn;
          }
        });

        return processedHeaders;
      }

      function mergeHeaders(config) {
        var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName, lowercaseDefHeaderName, reqHeaderName;

        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
        defaultHeadersIteration:
        for (defHeaderName in defHeaders) {
          lowercaseDefHeaderName = lowercase(defHeaderName);

          for (reqHeaderName in reqHeaders) {
            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
              continue defaultHeadersIteration;
            }
          }

          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
        }

        // execute if header value is a function for merged headers
        return executeHeaderFns(reqHeaders, shallowCopy(config));
      }

      function serverRequest(config) {
        var headers = config.headers;
        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

        // strip content-type if data is undefined
        if (isUndefined(reqData)) {
          forEach(headers, function(value, header) {
            if (lowercase(header) === 'content-type') {
              delete headers[header];
            }
          });
        }

        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
          config.withCredentials = defaults.withCredentials;
        }

        // send request
        return sendReq(config, reqData).then(transformResponse, transformResponse);
      }

      function transformResponse(response) {
        // make a copy since the response must be cacheable
        var resp = extend({}, response);
        resp.data = transformData(response.data, response.headers, response.status,
                                  config.transformResponse);
        return (isSuccess(response.status))
          ? resp
          : $q.reject(resp);
      }
    }

    $http.pendingRequests = [];

    /**
     * @ngdoc method
     * @name $http#get
     *
     * @description
     * Shortcut method to perform `GET` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#delete
     *
     * @description
     * Shortcut method to perform `DELETE` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#head
     *
     * @description
     * Shortcut method to perform `HEAD` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#jsonp
     *
     * @description
     * Shortcut method to perform `JSONP` request.
     * If you would like to customize where and how the callbacks are stored then try overriding
     * or decorating the {@link $jsonpCallbacks} service.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request.
     *                     The name of the callback should be the string `JSON_CALLBACK`.
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */
    createShortMethods('get', 'delete', 'head', 'jsonp');

    /**
     * @ngdoc method
     * @name $http#post
     *
     * @description
     * Shortcut method to perform `POST` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

    /**
     * @ngdoc method
     * @name $http#put
     *
     * @description
     * Shortcut method to perform `PUT` request.
     *
     * @param {string} url Relative or absolute URL specifying the destination of the request
     * @param {*} data Request content
     * @param {Object=} config Optional configuration object
     * @returns {HttpPromise} Future object
     */

     /**
      * @ngdoc method
      * @name $http#patch
      *
      * @description
      * Shortcut method to perform `PATCH` request.
      *
      * @param {string} url Relative or absolute URL specifying the destination of the request
      * @param {*} data Request content
      * @param {Object=} config Optional configuration object
      * @returns {HttpPromise} Future object
      */
    createShortMethodsWithData('post', 'put', 'patch');

        /**
         * @ngdoc property
         * @name $http#defaults
         *
         * @description
         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
         * default headers, withCredentials as well as request and response transformations.
         *
         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
         */
    $http.defaults = defaults;


    return $http;


    function createShortMethods(names) {
      forEach(arguments, function(name) {
        $http[name] = function(url, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url
          }));
        };
      });
    }


    function createShortMethodsWithData(name) {
      forEach(arguments, function(name) {
        $http[name] = function(url, data, config) {
          return $http(extend({}, config || {}, {
            method: name,
            url: url,
            data: data
          }));
        };
      });
    }


    /**
     * Makes the request.
     *
     * !!! ACCESSES CLOSURE VARS:
     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
     */
    function sendReq(config, reqData) {
      var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          url = buildUrl(config.url, config.paramSerializer(config.params));

      $http.pendingRequests.push(config);
      promise.then(removePendingReq, removePendingReq);


      if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
        cache = isObject(config.cache) ? config.cache
              : isObject(defaults.cache) ? defaults.cache
              : defaultCache;
      }

      if (cache) {
        cachedResp = cache.get(url);
        if (isDefined(cachedResp)) {
          if (isPromiseLike(cachedResp)) {
            // cached request has already been sent, but there is no response yet
            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
          } else {
            // serving from cache
            if (isArray(cachedResp)) {
              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
            } else {
              resolvePromise(cachedResp, 200, {}, 'OK');
            }
          }
        } else {
          // put the promise for the non-transformed response into cache as a placeholder
          cache.put(url, promise);
        }
      }


      // if we won't have the response in cache, set the xsrf headers and
      // send the request to the backend
      if (isUndefined(cachedResp)) {
        var xsrfValue = urlIsSameOrigin(config.url)
            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
            : undefined;
        if (xsrfValue) {
          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
        }

        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
            config.withCredentials, config.responseType,
            createApplyHandlers(config.eventHandlers),
            createApplyHandlers(config.uploadEventHandlers));
      }

      return promise;

      function createApplyHandlers(eventHandlers) {
        if (eventHandlers) {
          var applyHandlers = {};
          forEach(eventHandlers, function(eventHandler, key) {
            applyHandlers[key] = function(event) {
              if (useApplyAsync) {
                $rootScope.$applyAsync(callEventHandler);
              } else if ($rootScope.$$phase) {
                callEventHandler();
              } else {
                $rootScope.$apply(callEventHandler);
              }

              function callEventHandler() {
                eventHandler(event);
              }
            };
          });
          return applyHandlers;
        }
      }


      /**
       * Callback registered to $httpBackend():
       *  - caches the response if desired
       *  - resolves the raw $http promise
       *  - calls $apply
       */
      function done(status, response, headersString, statusText) {
        if (cache) {
          if (isSuccess(status)) {
            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
          } else {
            // remove promise from the cache
            cache.remove(url);
          }
        }

        function resolveHttpPromise() {
          resolvePromise(response, status, headersString, statusText);
        }

        if (useApplyAsync) {
          $rootScope.$applyAsync(resolveHttpPromise);
        } else {
          resolveHttpPromise();
          if (!$rootScope.$$phase) $rootScope.$apply();
        }
      }


      /**
       * Resolves the raw $http promise.
       */
      function resolvePromise(response, status, headers, statusText) {
        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
        status = status >= -1 ? status : 0;

        (isSuccess(status) ? deferred.resolve : deferred.reject)({
          data: response,
          status: status,
          headers: headersGetter(headers),
          config: config,
          statusText: statusText
        });
      }

      function resolvePromiseWithResult(result) {
        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
      }

      function removePendingReq() {
        var idx = $http.pendingRequests.indexOf(config);
        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
      }
    }


    function buildUrl(url, serializedParams) {
      if (serializedParams.length > 0) {
        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
      }
      return url;
    }
  }];
}

/**
 * @ngdoc service
 * @name $xhrFactory
 * @this
 *
 * @description
 * Factory function used to create XMLHttpRequest objects.
 *
 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
 *
 * ```
 * angular.module('myApp', [])
 * .factory('$xhrFactory', function() {
 *   return function createXhr(method, url) {
 *     return new window.XMLHttpRequest({mozSystem: true});
 *   };
 * });
 * ```
 *
 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
 * @param {string} url URL of the request.
 */
function $xhrFactoryProvider() {
  this.$get = function() {
    return function createXhr() {
      return new window.XMLHttpRequest();
    };
  };
}

/**
 * @ngdoc service
 * @name $httpBackend
 * @requires $jsonpCallbacks
 * @requires $document
 * @requires $xhrFactory
 * @this
 *
 * @description
 * HTTP backend used by the {@link ng.$http service} that delegates to
 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
 *
 * You should never need to use this service directly, instead use the higher-level abstractions:
 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
 *
 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
 * $httpBackend} which can be trained with responses.
 */
function $HttpBackendProvider() {
  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
  }];
}

function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
  // TODO(vojta): fix the signature
  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
    $browser.$$incOutstandingRequestCount();
    url = url || $browser.url();

    if (lowercase(method) === 'jsonp') {
      var callbackPath = callbacks.createCallback(url);
      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
        var response = (status === 200) && callbacks.getResponse(callbackPath);
        completeRequest(callback, status, response, '', text);
        callbacks.removeCallback(callbackPath);
      });
    } else {

      var xhr = createXhr(method, url);

      xhr.open(method, url, true);
      forEach(headers, function(value, key) {
        if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
        }
      });

      xhr.onload = function requestLoaded() {
        var statusText = xhr.statusText || '';

        // responseText is the old-school way of retrieving response (supported by IE9)
        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
        var response = ('response' in xhr) ? xhr.response : xhr.responseText;

        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
        var status = xhr.status === 1223 ? 204 : xhr.status;

        // fix status code when it is 0 (0 status is undocumented).
        // Occurs when accessing file resources or on Android 4.1 stock browser
        // while retrieving files from application cache.
        if (status === 0) {
          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
        }

        completeRequest(callback,
            status,
            response,
            xhr.getAllResponseHeaders(),
            statusText);
      };

      var requestError = function() {
        // The response is always empty
        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
        completeRequest(callback, -1, null, null, '');
      };

      xhr.onerror = requestError;
      xhr.onabort = requestError;
      xhr.ontimeout = requestError;

      forEach(eventHandlers, function(value, key) {
          xhr.addEventListener(key, value);
      });

      forEach(uploadEventHandlers, function(value, key) {
        xhr.upload.addEventListener(key, value);
      });

      if (withCredentials) {
        xhr.withCredentials = true;
      }

      if (responseType) {
        try {
          xhr.responseType = responseType;
        } catch (e) {
          // WebKit added support for the json responseType value on 09/03/2013
          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
          // known to throw when setting the value "json" as the response type. Other older
          // browsers implementing the responseType
          //
          // The json response type can be ignored if not supported, because JSON payloads are
          // parsed on the client-side regardless.
          if (responseType !== 'json') {
            throw e;
          }
        }
      }

      xhr.send(isUndefined(post) ? null : post);
    }

    if (timeout > 0) {
      var timeoutId = $browserDefer(timeoutRequest, timeout);
    } else if (isPromiseLike(timeout)) {
      timeout.then(timeoutRequest);
    }


    function timeoutRequest() {
      if (jsonpDone) {
        jsonpDone();
      }
      if (xhr) {
        xhr.abort();
      }
    }

    function completeRequest(callback, status, response, headersString, statusText) {
      // cancel timeout and subsequent timeout promise resolution
      if (isDefined(timeoutId)) {
        $browserDefer.cancel(timeoutId);
      }
      jsonpDone = xhr = null;

      callback(status, response, headersString, statusText);
      $browser.$$completeOutstandingRequest(noop);
    }
  };

  function jsonpReq(url, callbackPath, done) {
    url = url.replace('JSON_CALLBACK', callbackPath);
    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
    // - fetches local scripts via XHR and evals them
    // - adds and immediately removes script elements from the document
    var script = rawDocument.createElement('script'), callback = null;
    script.type = 'text/javascript';
    script.src = url;
    script.async = true;

    callback = function(event) {
      removeEventListenerFn(script, 'load', callback);
      removeEventListenerFn(script, 'error', callback);
      rawDocument.body.removeChild(script);
      script = null;
      var status = -1;
      var text = 'unknown';

      if (event) {
        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
          event = { type: 'error' };
        }
        text = event.type;
        status = event.type === 'error' ? 404 : 200;
      }

      if (done) {
        done(status, text);
      }
    };

    addEventListenerFn(script, 'load', callback);
    addEventListenerFn(script, 'error', callback);
    rawDocument.body.appendChild(script);
    return callback;
  }
}

var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
$interpolateMinErr.throwNoconcat = function(text) {
  throw $interpolateMinErr('noconcat',
      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
      'interpolations that concatenate multiple expressions when a trusted value is ' +
      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
};

$interpolateMinErr.interr = function(text, err) {
  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
};

/**
 * @ngdoc provider
 * @name $interpolateProvider
 * @this
 *
 * @description
 *
 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
 *
 * <div class="alert alert-danger">
 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
 * template within a Python Jinja template (or any other template language). Mixing templating
 * languages is **very dangerous**. The embedding template language will not safely escape Angular
 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
 * security bugs!
 * </div>
 *
 * @example
<example name="custom-interpolation-markup" module="customInterpolationApp">
<file name="index.html">
<script>
  var customInterpolationApp = angular.module('customInterpolationApp', []);

  customInterpolationApp.config(function($interpolateProvider) {
    $interpolateProvider.startSymbol('//');
    $interpolateProvider.endSymbol('//');
  });


  customInterpolationApp.controller('DemoController', function() {
      this.label = "This binding is brought you by // interpolation symbols.";
  });
</script>
<div ng-controller="DemoController as demo">
    //demo.label//
</div>
</file>
<file name="protractor.js" type="protractor">
  it('should interpolate binding with custom symbols', function() {
    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
  });
</file>
</example>
 */
function $InterpolateProvider() {
  var startSymbol = '{{';
  var endSymbol = '}}';

  /**
   * @ngdoc method
   * @name $interpolateProvider#startSymbol
   * @description
   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
   *
   * @param {string=} value new value to set the starting symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.startSymbol = function(value) {
    if (value) {
      startSymbol = value;
      return this;
    } else {
      return startSymbol;
    }
  };

  /**
   * @ngdoc method
   * @name $interpolateProvider#endSymbol
   * @description
   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
   *
   * @param {string=} value new value to set the ending symbol to.
   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
   */
  this.endSymbol = function(value) {
    if (value) {
      endSymbol = value;
      return this;
    } else {
      return endSymbol;
    }
  };


  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
    var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

    function escape(ch) {
      return '\\\\\\' + ch;
    }

    function unescapeText(text) {
      return text.replace(escapedStartRegexp, startSymbol).
        replace(escapedEndRegexp, endSymbol);
    }

    function stringify(value) {
      if (value == null) { // null || undefined
        return '';
      }
      switch (typeof value) {
        case 'string':
          break;
        case 'number':
          value = '' + value;
          break;
        default:
          value = toJson(value);
      }

      return value;
    }

    // TODO: this is the same as the constantWatchDelegate in parse.js
    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
        unwatch();
        return constantInterp(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    /**
     * @ngdoc service
     * @name $interpolate
     * @kind function
     *
     * @requires $parse
     * @requires $sce
     *
     * @description
     *
     * Compiles a string with markup into an interpolation function. This service is used by the
     * HTML {@link ng.$compile $compile} service for data binding. See
     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
     * interpolation markup.
     *
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var exp = $interpolate('Hello {{name | uppercase}}!');
     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
     * ```
     *
     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
     * `true`, the interpolation function will return `undefined` unless all embedded expressions
     * evaluate to a value other than `undefined`.
     *
     * ```js
     *   var $interpolate = ...; // injected
     *   var context = {greeting: 'Hello', name: undefined };
     *
     *   // default "forgiving" mode
     *   var exp = $interpolate('{{greeting}} {{name}}!');
     *   expect(exp(context)).toEqual('Hello !');
     *
     *   // "allOrNothing" mode
     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
     *   expect(exp(context)).toBeUndefined();
     *   context.name = 'Angular';
     *   expect(exp(context)).toEqual('Hello Angular!');
     * ```
     *
     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
     *
     * #### Escaped Interpolation
     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
     * or binding.
     *
     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
     * degree, while also enabling code examples to work without relying on the
     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
     *
     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
     * interpolation start/end markers with their escaped counterparts.**
     *
     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
     * output when the $interpolate service processes the text. So, for HTML elements interpolated
     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
     * this is typically useful only when user-data is used in rendering a template from the server, or
     * when otherwise untrusted data is used by a directive.
     *
     * <example name="interpolation">
     *  <file name="index.html">
     *    <div ng-init="username='A user'">
     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
     *        </p>
     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
     *        application, but fails to accomplish their task, because the server has correctly
     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
     *        characters.</p>
     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
     *        from the database by an administrator.</p>
     *    </div>
     *  </file>
     * </example>
     *
     * @knownIssue
     * It is currently not possible for an interpolated expression to contain the interpolation end
     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
     *
     * @knownIssue
     * All directives and components must use the standard `{{` `}}` interpolation symbols
     * in their templates. If you change the application interpolation symbols the {@link $compile}
     * service will attempt to denormalize the standard symbols to the custom symbols.
     * The denormalization process is not clever enough to know not to replace instances of the standard
     * symbols where they would not normally be treated as interpolation symbols. For example in the following
     * code snippet the closing braces of the literal object will get incorrectly denormalized:
     *
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"}}">
     * ```
     *
     * The workaround is to ensure that such instances are separated by whitespace:
     * ```
     * <div data-context='{"context":{"id":3,"type":"page"} }">
     * ```
     *
     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
     *
     * @param {string} text The text with markup to interpolate.
     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
     *    embedded expression in order to return an interpolation function. Strings with no
     *    embedded expression will return null for the interpolation function.
     * @param {string=} trustedContext when provided, the returned function passes the interpolated
     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
     *    provides Strict Contextual Escaping for details.
     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
     *    unless all embedded expressions evaluate to a value other than `undefined`.
     * @returns {function(context)} an interpolation function which is used to compute the
     *    interpolated string. The function has these parameters:
     *
     * - `context`: evaluation context for all expressions embedded in the interpolated text
     */
    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
      // Provide a quick exit and simplified result function for text with no interpolation
      if (!text.length || text.indexOf(startSymbol) === -1) {
        var constantInterp;
        if (!mustHaveExpression) {
          var unescapedText = unescapeText(text);
          constantInterp = valueFn(unescapedText);
          constantInterp.exp = text;
          constantInterp.expressions = [];
          constantInterp.$$watchDelegate = constantWatchDelegate;
        }
        return constantInterp;
      }

      allOrNothing = !!allOrNothing;
      var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns = [],
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [];

      while (index < textLength) {
        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
          if (index !== startIndex) {
            concat.push(unescapeText(text.substring(index, startIndex)));
          }
          exp = text.substring(startIndex + startSymbolLength, endIndex);
          expressions.push(exp);
          parseFns.push($parse(exp, parseStringifyInterceptor));
          index = endIndex + endSymbolLength;
          expressionPositions.push(concat.length);
          concat.push('');
        } else {
          // we did not find an interpolation, so we have to add the remainder to the separators array
          if (index !== textLength) {
            concat.push(unescapeText(text.substring(index)));
          }
          break;
        }
      }

      // Concatenating expressions makes it hard to reason about whether some combination of
      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
      // single expression be used for iframe[src], object[src], etc., we ensure that the value
      // that's used is assigned or constructed by some JS code somewhere that is more testable or
      // make it obvious that you bound the value to some user controlled value.  This helps reduce
      // the load when auditing for XSS issues.
      if (trustedContext && concat.length > 1) {
          $interpolateMinErr.throwNoconcat(text);
      }

      if (!mustHaveExpression || expressions.length) {
        var compute = function(values) {
          for (var i = 0, ii = expressions.length; i < ii; i++) {
            if (allOrNothing && isUndefined(values[i])) return;
            concat[expressionPositions[i]] = values[i];
          }
          return concat.join('');
        };

        var getValue = function(value) {
          return trustedContext ?
            $sce.getTrusted(trustedContext, value) :
            $sce.valueOf(value);
        };

        return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }

          }, {
          // all of these properties are undocumented for now
          exp: text, //just for compatibility with regular watchers created via $watch
          expressions: expressions,
          $$watchDelegate: function(scope, listener) {
            var lastValue;
            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
              var currValue = compute(values);
              if (isFunction(listener)) {
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
              }
              lastValue = currValue;
            });
          }
        });
      }

      function parseStringifyInterceptor(value) {
        try {
          value = getValue(value);
          return allOrNothing && !isDefined(value) ? value : stringify(value);
        } catch (err) {
          $exceptionHandler($interpolateMinErr.interr(text, err));
        }
      }
    }


    /**
     * @ngdoc method
     * @name $interpolate#startSymbol
     * @description
     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
     *
     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
     * the symbol.
     *
     * @returns {string} start symbol.
     */
    $interpolate.startSymbol = function() {
      return startSymbol;
    };


    /**
     * @ngdoc method
     * @name $interpolate#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
     * the symbol.
     *
     * @returns {string} end symbol.
     */
    $interpolate.endSymbol = function() {
      return endSymbol;
    };

    return $interpolate;
  }];
}

/** @this */
function $IntervalProvider() {
  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
       function($rootScope,   $window,   $q,   $$q,   $browser) {
    var intervals = {};


     /**
      * @ngdoc service
      * @name $interval
      *
      * @description
      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
      * milliseconds.
      *
      * The return value of registering an interval function is a promise. This promise will be
      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
      * run indefinitely if `count` is not defined. The value of the notification will be the
      * number of iterations that have run.
      * To cancel an interval, call `$interval.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
      * time.
      *
      * <div class="alert alert-warning">
      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
      * with them.  In particular they are not automatically destroyed when a controller's scope or a
      * directive's element are destroyed.
      * You should take this into consideration and make sure to always cancel the interval at the
      * appropriate moment.  See the example below for more details on how and when to do this.
      * </div>
      *
      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
      *   are passed (see below), the function is called with the current iteration count.
      * @param {number} delay Number of milliseconds between each function call.
      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
      *   indefinitely.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {promise} A promise which will be notified on each iteration.
      *
      * @example
      * <example module="intervalExample" name="interval-service">
      * <file name="index.html">
      *   <script>
      *     angular.module('intervalExample', [])
      *       .controller('ExampleController', ['$scope', '$interval',
      *         function($scope, $interval) {
      *           $scope.format = 'M/d/yy h:mm:ss a';
      *           $scope.blood_1 = 100;
      *           $scope.blood_2 = 120;
      *
      *           var stop;
      *           $scope.fight = function() {
      *             // Don't start a new fight if we are already fighting
      *             if ( angular.isDefined(stop) ) return;
      *
      *             stop = $interval(function() {
      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
      *                 $scope.blood_1 = $scope.blood_1 - 3;
      *                 $scope.blood_2 = $scope.blood_2 - 4;
      *               } else {
      *                 $scope.stopFight();
      *               }
      *             }, 100);
      *           };
      *
      *           $scope.stopFight = function() {
      *             if (angular.isDefined(stop)) {
      *               $interval.cancel(stop);
      *               stop = undefined;
      *             }
      *           };
      *
      *           $scope.resetFight = function() {
      *             $scope.blood_1 = 100;
      *             $scope.blood_2 = 120;
      *           };
      *
      *           $scope.$on('$destroy', function() {
      *             // Make sure that the interval is destroyed too
      *             $scope.stopFight();
      *           });
      *         }])
      *       // Register the 'myCurrentTime' directive factory method.
      *       // We inject $interval and dateFilter service since the factory method is DI.
      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
      *         function($interval, dateFilter) {
      *           // return the directive link function. (compile function not needed)
      *           return function(scope, element, attrs) {
      *             var format,  // date format
      *                 stopTime; // so that we can cancel the time updates
      *
      *             // used to update the UI
      *             function updateTime() {
      *               element.text(dateFilter(new Date(), format));
      *             }
      *
      *             // watch the expression, and update the UI on change.
      *             scope.$watch(attrs.myCurrentTime, function(value) {
      *               format = value;
      *               updateTime();
      *             });
      *
      *             stopTime = $interval(updateTime, 1000);
      *
      *             // listen on DOM destroy (removal) event, and cancel the next UI update
      *             // to prevent updating time after the DOM element was removed.
      *             element.on('$destroy', function() {
      *               $interval.cancel(stopTime);
      *             });
      *           }
      *         }]);
      *   </script>
      *
      *   <div>
      *     <div ng-controller="ExampleController">
      *       <label>Date format: <input ng-model="format"></label> <hr/>
      *       Current time is: <span my-current-time="format"></span>
      *       <hr/>
      *       Blood 1 : <font color='red'>{{blood_1}}</font>
      *       Blood 2 : <font color='red'>{{blood_2}}</font>
      *       <button type="button" data-ng-click="fight()">Fight</button>
      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
      *     </div>
      *   </div>
      *
      * </file>
      * </example>
      */
    function interval(fn, delay, count, invokeApply) {
      var hasParams = arguments.length > 4,
          args = hasParams ? sliceArgs(arguments, 4) : [],
          setInterval = $window.setInterval,
          clearInterval = $window.clearInterval,
          iteration = 0,
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise;

      count = isDefined(count) ? count : 0;

      promise.$$intervalId = setInterval(function tick() {
        if (skipApply) {
          $browser.defer(callback);
        } else {
          $rootScope.$evalAsync(callback);
        }
        deferred.notify(iteration++);

        if (count > 0 && iteration >= count) {
          deferred.resolve(iteration);
          clearInterval(promise.$$intervalId);
          delete intervals[promise.$$intervalId];
        }

        if (!skipApply) $rootScope.$apply();

      }, delay);

      intervals[promise.$$intervalId] = deferred;

      return promise;

      function callback() {
        if (!hasParams) {
          fn(iteration);
        } else {
          fn.apply(null, args);
        }
      }
    }


     /**
      * @ngdoc method
      * @name $interval#cancel
      *
      * @description
      * Cancels a task associated with the `promise`.
      *
      * @param {Promise=} promise returned by the `$interval` function.
      * @returns {boolean} Returns `true` if the task was successfully canceled.
      */
    interval.cancel = function(promise) {
      if (promise && promise.$$intervalId in intervals) {
        intervals[promise.$$intervalId].reject('canceled');
        $window.clearInterval(promise.$$intervalId);
        delete intervals[promise.$$intervalId];
        return true;
      }
      return false;
    };

    return interval;
  }];
}

/**
 * @ngdoc service
 * @name $jsonpCallbacks
 * @requires $window
 * @description
 * This service handles the lifecycle of callbacks to handle JSONP requests.
 * Override this service if you wish to customise where the callbacks are stored and
 * how they vary compared to the requested url.
 */
var $jsonpCallbacksProvider = /** @this */ function() {
  this.$get = ['$window', function($window) {
    var callbacks = $window.angular.callbacks;
    var callbackMap = {};

    function createCallback(callbackId) {
      var callback = function(data) {
        callback.data = data;
        callback.called = true;
      };
      callback.id = callbackId;
      return callback;
    }

    return {
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#createCallback
       * @param {string} url the url of the JSONP request
       * @returns {string} the callback path to send to the server as part of the JSONP request
       * @description
       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
       */
      createCallback: function(url) {
        var callbackId = '_' + (callbacks.$$counter++).toString(36);
        var callbackPath = 'angular.callbacks.' + callbackId;
        var callback = createCallback(callbackId);
        callbackMap[callbackPath] = callbacks[callbackId] = callback;
        return callbackPath;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#wasCalled
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
       * @description
       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
       * callback that was passed in the request.
       */
      wasCalled: function(callbackPath) {
        return callbackMap[callbackPath].called;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#getResponse
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @returns {*} the data received from the response via the registered callback
       * @description
       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
       * in the JSONP response.
       */
      getResponse: function(callbackPath) {
        return callbackMap[callbackPath].data;
      },
      /**
       * @ngdoc method
       * @name $jsonpCallbacks#removeCallback
       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
       * @description
       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
       * completed or timed-out.
       */
      removeCallback: function(callbackPath) {
        var callback = callbackMap[callbackPath];
        delete callbacks[callback.id];
        delete callbackMap[callbackPath];
      }
    };
  }];
};

/**
 * @ngdoc service
 * @name $locale
 *
 * @description
 * $locale service provides localization rules for various Angular components. As of right now the
 * only public api is:
 *
 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
 */

var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
var $locationMinErr = minErr('$location');


/**
 * Encode path using encodeUriSegment, ignoring forward slashes
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
  var segments = path.split('/'),
      i = segments.length;

  while (i--) {
    segments[i] = encodeUriSegment(segments[i]);
  }

  return segments.join('/');
}

function parseAbsoluteUrl(absoluteUrl, locationObj) {
  var parsedUrl = urlResolve(absoluteUrl);

  locationObj.$$protocol = parsedUrl.protocol;
  locationObj.$$host = parsedUrl.hostname;
  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
}

var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
function parseAppUrl(url, locationObj) {

  if (DOUBLE_SLASH_REGEX.test(url)) {
    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
  }

  var prefixed = (url.charAt(0) !== '/');
  if (prefixed) {
    url = '/' + url;
  }
  var match = urlResolve(url);
  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
      match.pathname.substring(1) : match.pathname);
  locationObj.$$search = parseKeyValue(match.search);
  locationObj.$$hash = decodeURIComponent(match.hash);

  // make sure path starts with '/';
  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
    locationObj.$$path = '/' + locationObj.$$path;
  }
}

function startsWith(str, search) {
  return str.slice(0, search.length) === search;
}

/**
 *
 * @param {string} base
 * @param {string} url
 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
 *                   the expected string.
 */
function stripBaseUrl(base, url) {
  if (startsWith(url, base)) {
    return url.substr(base.length);
  }
}


function stripHash(url) {
  var index = url.indexOf('#');
  return index === -1 ? url : url.substr(0, index);
}

function trimEmptyHash(url) {
  return url.replace(/(#.+)|#$/, '$1');
}


function stripFile(url) {
  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
}

/* return the server only (scheme://host:port) */
function serverBase(url) {
  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
}


/**
 * LocationHtml5Url represents a URL
 * This object is exposed as $location service when HTML5 mode is enabled and supported
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} basePrefix URL path prefix
 */
function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
  this.$$html5 = true;
  basePrefix = basePrefix || '';
  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given HTML5 (regular) URL string into properties
   * @param {string} url HTML5 URL
   * @private
   */
  this.$$parse = function(url) {
    var pathUrl = stripBaseUrl(appBaseNoFile, url);
    if (!isString(pathUrl)) {
      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
          appBaseNoFile);
    }

    parseAppUrl(pathUrl, this);

    if (!this.$$path) {
      this.$$path = '/';
    }

    this.$$compose();
  };

  /**
   * Compose url and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }
    var appUrl, prevAppUrl;
    var rewrittenUrl;


    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
      prevAppUrl = appUrl;
      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
      } else {
        rewrittenUrl = appBase + prevAppUrl;
      }
    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBaseNoFile + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when developer doesn't opt into html5 mode.
 * It also serves as the base class for html5 mode fallback on legacy browsers.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

  parseAbsoluteUrl(appBase, this);


  /**
   * Parse given hashbang URL into properties
   * @param {string} url Hashbang URL
   * @private
   */
  this.$$parse = function(url) {
    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
    var withoutHashUrl;

    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

      // The rest of the URL starts with a hash so we have
      // got either a hashbang path or a plain hash fragment
      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
      if (isUndefined(withoutHashUrl)) {
        // There was no hashbang prefix so we just have a hash fragment
        withoutHashUrl = withoutBaseUrl;
      }

    } else {
      // There was no hashbang path nor hash fragment:
      // If we are in HTML5 mode we use what is left as the path;
      // Otherwise we ignore what is left
      if (this.$$html5) {
        withoutHashUrl = withoutBaseUrl;
      } else {
        withoutHashUrl = '';
        if (isUndefined(withoutBaseUrl)) {
          appBase = url;
          this.replace();
        }
      }
    }

    parseAppUrl(withoutHashUrl, this);

    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

    this.$$compose();

    /*
     * In Windows, on an anchor node on documents loaded from
     * the filesystem, the browser will return a pathname
     * prefixed with the drive name ('/C:/path') when a
     * pathname without a drive is set:
     *  * a.setAttribute('href', '/foo')
     *   * a.pathname === '/C:/foo' //true
     *
     * Inside of Angular, we're always using pathnames that
     * do not include drive names for routing.
     */
    function removeWindowsDriveName(path, url, base) {
      /*
      Matches paths for file protocol on windows,
      such as /C:/foo/bar, and captures only /foo/bar.
      */
      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

      var firstPathSegmentMatch;

      //Get the relative path from the input URL.
      if (startsWith(url, base)) {
        url = url.replace(base, '');
      }

      // The input URL intentionally contains a first path segment that ends with a colon.
      if (windowsFilePathExp.exec(url)) {
        return path;
      }

      firstPathSegmentMatch = windowsFilePathExp.exec(path);
      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
    }
  };

  /**
   * Compose hashbang URL and update `absUrl` property
   * @private
   */
  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
  };

  this.$$parseLinkUrl = function(url, relHref) {
    if (stripHash(appBase) === stripHash(url)) {
      this.$$parse(url);
      return true;
    }
    return false;
  };
}


/**
 * LocationHashbangUrl represents URL
 * This object is exposed as $location service when html5 history api is enabled but the browser
 * does not support it.
 *
 * @constructor
 * @param {string} appBase application base URL
 * @param {string} appBaseNoFile application base URL stripped of any filename
 * @param {string} hashPrefix hashbang prefix
 */
function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
  this.$$html5 = true;
  LocationHashbangUrl.apply(this, arguments);

  this.$$parseLinkUrl = function(url, relHref) {
    if (relHref && relHref[0] === '#') {
      // special case for links to hash fragments:
      // keep the old url and only replace the hash fragment
      this.hash(relHref.slice(1));
      return true;
    }

    var rewrittenUrl;
    var appUrl;

    if (appBase === stripHash(url)) {
      rewrittenUrl = url;
    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
      rewrittenUrl = appBase + hashPrefix + appUrl;
    } else if (appBaseNoFile === url + '/') {
      rewrittenUrl = appBaseNoFile;
    }
    if (rewrittenUrl) {
      this.$$parse(rewrittenUrl);
    }
    return !!rewrittenUrl;
  };

  this.$$compose = function() {
    var search = toKeyValue(this.$$search),
        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
    this.$$absUrl = appBase + hashPrefix + this.$$url;
  };

}


var locationPrototype = {

  /**
   * Ensure absolute URL is initialized.
   * @private
   */
  $$absUrl:'',

  /**
   * Are we in html5 mode?
   * @private
   */
  $$html5: false,

  /**
   * Has any change been replacing?
   * @private
   */
  $$replace: false,

  /**
   * @ngdoc method
   * @name $location#absUrl
   *
   * @description
   * This method is getter only.
   *
   * Return full URL representation with all segments encoded according to rules specified in
   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var absUrl = $location.absUrl();
   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @return {string} full URL
   */
  absUrl: locationGetter('$$absUrl'),

  /**
   * @ngdoc method
   * @name $location#url
   *
   * @description
   * This method is getter / setter.
   *
   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
   *
   * Change path, search and hash, when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var url = $location.url();
   * // => "/some/path?foo=bar&baz=xoxo"
   * ```
   *
   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
   * @return {string} url
   */
  url: function(url) {
    if (isUndefined(url)) {
      return this.$$url;
    }

    var match = PATH_MATCH.exec(url);
    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
    if (match[2] || match[1] || url === '') this.search(match[3] || '');
    this.hash(match[5] || '');

    return this;
  },

  /**
   * @ngdoc method
   * @name $location#protocol
   *
   * @description
   * This method is getter only.
   *
   * Return protocol of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var protocol = $location.protocol();
   * // => "http"
   * ```
   *
   * @return {string} protocol of current URL
   */
  protocol: locationGetter('$$protocol'),

  /**
   * @ngdoc method
   * @name $location#host
   *
   * @description
   * This method is getter only.
   *
   * Return host of current URL.
   *
   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var host = $location.host();
   * // => "example.com"
   *
   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
   * host = $location.host();
   * // => "example.com"
   * host = location.host;
   * // => "example.com:8080"
   * ```
   *
   * @return {string} host of current URL.
   */
  host: locationGetter('$$host'),

  /**
   * @ngdoc method
   * @name $location#port
   *
   * @description
   * This method is getter only.
   *
   * Return port of current URL.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var port = $location.port();
   * // => 80
   * ```
   *
   * @return {Number} port
   */
  port: locationGetter('$$port'),

  /**
   * @ngdoc method
   * @name $location#path
   *
   * @description
   * This method is getter / setter.
   *
   * Return path of current URL when called without any parameter.
   *
   * Change path when called with parameter and return `$location`.
   *
   * Note: Path should always begin with forward slash (/), this method will add the forward slash
   * if it is missing.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var path = $location.path();
   * // => "/some/path"
   * ```
   *
   * @param {(string|number)=} path New path
   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
   */
  path: locationGetterSetter('$$path', function(path) {
    path = path !== null ? path.toString() : '';
    return path.charAt(0) === '/' ? path : '/' + path;
  }),

  /**
   * @ngdoc method
   * @name $location#search
   *
   * @description
   * This method is getter / setter.
   *
   * Return search part (as object) of current URL when called without any parameter.
   *
   * Change search part when called with parameter and return `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
   * var searchObject = $location.search();
   * // => {foo: 'bar', baz: 'xoxo'}
   *
   * // set foo to 'yipee'
   * $location.search('foo', 'yipee');
   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
   * ```
   *
   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
   * hash object.
   *
   * When called with a single argument the method acts as a setter, setting the `search` component
   * of `$location` to the specified value.
   *
   * If the argument is a hash object containing an array of values, these values will be encoded
   * as duplicate search parameters in the URL.
   *
   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
   * will override only a single search property.
   *
   * If `paramValue` is an array, it will override the property of the `search` component of
   * `$location` specified via the first argument.
   *
   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
   *
   * If `paramValue` is `true`, the property specified via the first argument will be added with no
   * value nor trailing equal sign.
   *
   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
   * one or more arguments returns `$location` object itself.
   */
  search: function(search, paramValue) {
    switch (arguments.length) {
      case 0:
        return this.$$search;
      case 1:
        if (isString(search) || isNumber(search)) {
          search = search.toString();
          this.$$search = parseKeyValue(search);
        } else if (isObject(search)) {
          search = copy(search, {});
          // remove object undefined or null properties
          forEach(search, function(value, key) {
            if (value == null) delete search[key];
          });

          this.$$search = search;
        } else {
          throw $locationMinErr('isrcharg',
              'The first argument of the `$location#search()` call must be a string or an object.');
        }
        break;
      default:
        if (isUndefined(paramValue) || paramValue === null) {
          delete this.$$search[search];
        } else {
          this.$$search[search] = paramValue;
        }
    }

    this.$$compose();
    return this;
  },

  /**
   * @ngdoc method
   * @name $location#hash
   *
   * @description
   * This method is getter / setter.
   *
   * Returns the hash fragment when called without any parameters.
   *
   * Changes the hash fragment when called with a parameter and returns `$location`.
   *
   *
   * ```js
   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
   * var hash = $location.hash();
   * // => "hashValue"
   * ```
   *
   * @param {(string|number)=} hash New hash fragment
   * @return {string} hash
   */
  hash: locationGetterSetter('$$hash', function(hash) {
    return hash !== null ? hash.toString() : '';
  }),

  /**
   * @ngdoc method
   * @name $location#replace
   *
   * @description
   * If called, all changes to $location during the current `$digest` will replace the current history
   * record, instead of adding a new one.
   */
  replace: function() {
    this.$$replace = true;
    return this;
  }
};

forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
  Location.prototype = Object.create(locationPrototype);

  /**
   * @ngdoc method
   * @name $location#state
   *
   * @description
   * This method is getter / setter.
   *
   * Return the history state object when called without any parameter.
   *
   * Change the history state object when called with one parameter and return `$location`.
   * The state object is later passed to `pushState` or `replaceState`.
   *
   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
   * older browsers (like IE9 or Android < 4.0), don't use this method.
   *
   * @param {object=} state State object for pushState or replaceState
   * @return {object} state
   */
  Location.prototype.state = function(state) {
    if (!arguments.length) {
      return this.$$state;
    }

    if (Location !== LocationHtml5Url || !this.$$html5) {
      throw $locationMinErr('nostate', 'History API state support is available only ' +
        'in HTML5 mode and only in browsers supporting HTML5 History API');
    }
    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
    // but we're changing the $$state reference to $browser.state() during the $digest
    // so the modification window is narrow.
    this.$$state = isUndefined(state) ? null : state;

    return this;
  };
});


function locationGetter(property) {
  return /** @this */ function() {
    return this[property];
  };
}


function locationGetterSetter(property, preprocess) {
  return /** @this */ function(value) {
    if (isUndefined(value)) {
      return this[property];
    }

    this[property] = preprocess(value);
    this.$$compose();

    return this;
  };
}


/**
 * @ngdoc service
 * @name $location
 *
 * @requires $rootElement
 *
 * @description
 * The $location service parses the URL in the browser address bar (based on the
 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
 * available to your application. Changes to the URL in the address bar are reflected into
 * $location service and changes to $location are reflected into the browser address bar.
 *
 * **The $location service:**
 *
 * - Exposes the current URL in the browser address bar, so you can
 *   - Watch and observe the URL.
 *   - Change the URL.
 * - Synchronizes the URL with the browser when the user
 *   - Changes the address bar.
 *   - Clicks the back or forward button (or clicks a History link).
 *   - Clicks on a link.
 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
 *
 * For more information see {@link guide/$location Developer Guide: Using $location}
 */

/**
 * @ngdoc provider
 * @name $locationProvider
 * @this
 *
 * @description
 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
 */
function $LocationProvider() {
  var hashPrefix = '',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

  /**
   * @ngdoc method
   * @name $locationProvider#hashPrefix
   * @description
   * The default value for the prefix is `''`.
   * @param {string=} prefix Prefix for hash part (containing path and search)
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.hashPrefix = function(prefix) {
    if (isDefined(prefix)) {
      hashPrefix = prefix;
      return this;
    } else {
      return hashPrefix;
    }
  };

  /**
   * @ngdoc method
   * @name $locationProvider#html5Mode
   * @description
   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
   *   properties:
   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
   *     support `pushState`.
   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
   *     See the {@link guide/$location $location guide for more information}
   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
   *     only happen on links with an attribute that matches the given string. For example, if set
   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
   *     here, so `'internalLink'` will **not** match `'internal-link'`.
   *
   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
   */
  this.html5Mode = function(mode) {
    if (isBoolean(mode)) {
      html5Mode.enabled = mode;
      return this;
    } else if (isObject(mode)) {

      if (isBoolean(mode.enabled)) {
        html5Mode.enabled = mode.enabled;
      }

      if (isBoolean(mode.requireBase)) {
        html5Mode.requireBase = mode.requireBase;
      }

      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
        html5Mode.rewriteLinks = mode.rewriteLinks;
      }

      return this;
    } else {
      return html5Mode;
    }
  };

  /**
   * @ngdoc event
   * @name $location#$locationChangeStart
   * @eventType broadcast on root scope
   * @description
   * Broadcasted before a URL will change.
   *
   * This change can be prevented by calling
   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
   * details about event object. Upon successful change
   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  /**
   * @ngdoc event
   * @name $location#$locationChangeSuccess
   * @eventType broadcast on root scope
   * @description
   * Broadcasted after a URL was changed.
   *
   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
   * the browser supports the HTML5 History API.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {string} newUrl New URL
   * @param {string=} oldUrl URL that was before it was changed.
   * @param {string=} newState New history state object
   * @param {string=} oldState History state object that was before it was changed.
   */

  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
      function($rootScope, $browser, $sniffer, $rootElement, $window) {
    var $location,
        LocationMode,
        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;

    if (html5Mode.enabled) {
      if (!baseHref && html5Mode.requireBase) {
        throw $locationMinErr('nobase',
          '$location in HTML5 mode requires a <base> tag to be present!');
      }
      appBase = serverBase(initialUrl) + (baseHref || '/');
      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
    } else {
      appBase = stripHash(initialUrl);
      LocationMode = LocationHashbangUrl;
    }
    var appBaseNoFile = stripFile(appBase);

    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
    $location.$$parseLinkUrl(initialUrl, initialUrl);

    $location.$$state = $browser.state();

    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

    function setBrowserUrlWithFallback(url, replace, state) {
      var oldUrl = $location.url();
      var oldState = $location.$$state;
      try {
        $browser.url(url, replace, state);

        // Make sure $location.state() returns referentially identical (not just deeply equal)
        // state object; this makes possible quick checking if the state changed in the digest
        // loop. Checking deep equality would be too expensive.
        $location.$$state = $browser.state();
      } catch (e) {
        // Restore old values if pushState fails
        $location.url(oldUrl);
        $location.$$state = oldState;

        throw e;
      }
    }

    $rootElement.on('click', function(event) {
      var rewriteLinks = html5Mode.rewriteLinks;
      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
      // currently we open nice url link and redirect then

      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

      var elm = jqLite(event.target);

      // traverse the DOM up to find first A tag
      while (nodeName_(elm[0]) !== 'a') {
        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
      }

      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

      var absHref = elm.prop('href');
      // get the actual href attribute - see
      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
      var relHref = elm.attr('href') || elm.attr('xlink:href');

      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
        // an animation.
        absHref = urlResolve(absHref.animVal).href;
      }

      // Ignore when url is started with javascript: or mailto:
      if (IGNORE_URI_REGEXP.test(absHref)) return;

      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
        if ($location.$$parseLinkUrl(absHref, relHref)) {
          // We do a preventDefault for all urls that are part of the angular application,
          // in html5mode and also without, so that we are able to abort navigation without
          // getting double entries in the location history.
          event.preventDefault();
          // update location manually
          if ($location.absUrl() !== $browser.url()) {
            $rootScope.$apply();
            // hack to work around FF6 bug 684208 when scenario runner clicks on links
            $window.angular['ff-684208-preventDefault'] = true;
          }
        }
      }
    });


    // rewrite hashbang url <> html5 url
    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
      $browser.url($location.absUrl(), true);
    }

    var initializing = true;

    // update $location when $browser url changes
    $browser.onUrlChange(function(newUrl, newState) {

      if (isUndefined(stripBaseUrl(appBaseNoFile, newUrl))) {
        // If we are navigating outside of the app then force a reload
        $window.location.href = newUrl;
        return;
      }

      $rootScope.$evalAsync(function() {
        var oldUrl = $location.absUrl();
        var oldState = $location.$$state;
        var defaultPrevented;
        newUrl = trimEmptyHash(newUrl);
        $location.$$parse(newUrl);
        $location.$$state = newState;

        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
            newState, oldState).defaultPrevented;

        // if the location was changed by a `$locationChangeStart` handler then stop
        // processing this location change
        if ($location.absUrl() !== newUrl) return;

        if (defaultPrevented) {
          $location.$$parse(oldUrl);
          $location.$$state = oldState;
          setBrowserUrlWithFallback(oldUrl, false, oldState);
        } else {
          initializing = false;
          afterLocationChange(oldUrl, oldState);
        }
      });
      if (!$rootScope.$$phase) $rootScope.$digest();
    });

    // update browser
    $rootScope.$watch(function $locationWatch() {
      var oldUrl = trimEmptyHash($browser.url());
      var newUrl = trimEmptyHash($location.absUrl());
      var oldState = $browser.state();
      var currentReplace = $location.$$replace;
      var urlOrStateChanged = oldUrl !== newUrl ||
        ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);

      if (initializing || urlOrStateChanged) {
        initializing = false;

        $rootScope.$evalAsync(function() {
          var newUrl = $location.absUrl();
          var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
              $location.$$state, oldState).defaultPrevented;

          // if the location was changed by a `$locationChangeStart` handler then stop
          // processing this location change
          if ($location.absUrl() !== newUrl) return;

          if (defaultPrevented) {
            $location.$$parse(oldUrl);
            $location.$$state = oldState;
          } else {
            if (urlOrStateChanged) {
              setBrowserUrlWithFallback(newUrl, currentReplace,
                                        oldState === $location.$$state ? null : $location.$$state);
            }
            afterLocationChange(oldUrl, oldState);
          }
        });
      }

      $location.$$replace = false;

      // we don't need to return anything because $evalAsync will make the digest loop dirty when
      // there is a change
    });

    return $location;

    function afterLocationChange(oldUrl, oldState) {
      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
        $location.$$state, oldState);
    }
}];
}

/**
 * @ngdoc service
 * @name $log
 * @requires $window
 *
 * @description
 * Simple service for logging. Default implementation safely writes the message
 * into the browser's console (if present).
 *
 * The main purpose of this service is to simplify debugging and troubleshooting.
 *
 * The default is to log `debug` messages. You can use
 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
 *
 * @example
   <example module="logExample" name="log-service">
     <file name="script.js">
       angular.module('logExample', [])
         .controller('LogController', ['$scope', '$log', function($scope, $log) {
           $scope.$log = $log;
           $scope.message = 'Hello World!';
         }]);
     </file>
     <file name="index.html">
       <div ng-controller="LogController">
         <p>Reload this page with open console, enter text and hit the log button...</p>
         <label>Message:
         <input type="text" ng-model="message" /></label>
         <button ng-click="$log.log(message)">log</button>
         <button ng-click="$log.warn(message)">warn</button>
         <button ng-click="$log.info(message)">info</button>
         <button ng-click="$log.error(message)">error</button>
         <button ng-click="$log.debug(message)">debug</button>
       </div>
     </file>
   </example>
 */

/**
 * @ngdoc provider
 * @name $logProvider
 * @this
 *
 * @description
 * Use the `$logProvider` to configure how the application logs messages
 */
function $LogProvider() {
  var debug = true,
      self = this;

  /**
   * @ngdoc method
   * @name $logProvider#debugEnabled
   * @description
   * @param {boolean=} flag enable or disable debug level messages
   * @returns {*} current value if used as getter or itself (chaining) if used as setter
   */
  this.debugEnabled = function(flag) {
    if (isDefined(flag)) {
      debug = flag;
      return this;
    } else {
      return debug;
    }
  };

  this.$get = ['$window', function($window) {
    return {
      /**
       * @ngdoc method
       * @name $log#log
       *
       * @description
       * Write a log message
       */
      log: consoleLog('log'),

      /**
       * @ngdoc method
       * @name $log#info
       *
       * @description
       * Write an information message
       */
      info: consoleLog('info'),

      /**
       * @ngdoc method
       * @name $log#warn
       *
       * @description
       * Write a warning message
       */
      warn: consoleLog('warn'),

      /**
       * @ngdoc method
       * @name $log#error
       *
       * @description
       * Write an error message
       */
      error: consoleLog('error'),

      /**
       * @ngdoc method
       * @name $log#debug
       *
       * @description
       * Write a debug message
       */
      debug: (function() {
        var fn = consoleLog('debug');

        return function() {
          if (debug) {
            fn.apply(self, arguments);
          }
        };
      })()
    };

    function formatError(arg) {
      if (arg instanceof Error) {
        if (arg.stack) {
          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
              ? 'Error: ' + arg.message + '\n' + arg.stack
              : arg.stack;
        } else if (arg.sourceURL) {
          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
        }
      }
      return arg;
    }

    function consoleLog(type) {
      var console = $window.console || {},
          logFn = console[type] || console.log || noop,
          hasApply = false;

      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
      // The reason behind this is that console.log has type "object" in IE8...
      try {
        hasApply = !!logFn.apply;
      } catch (e) { /* empty */ }

      if (hasApply) {
        return function() {
          var args = [];
          forEach(arguments, function(arg) {
            args.push(formatError(arg));
          });
          return logFn.apply(console, args);
        };
      }

      // we are IE which either doesn't have window.console => this is noop and we do nothing,
      // or we are IE where console.log doesn't have apply so we log at least first 2 args
      return function(arg1, arg2) {
        logFn(arg1, arg2 == null ? '' : arg2);
      };
    }
  }];
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

var $parseMinErr = minErr('$parse');

var ARRAY_CTOR = [].constructor;
var BOOLEAN_CTOR = (false).constructor;
var FUNCTION_CTOR = Function.constructor;
var NUMBER_CTOR = (0).constructor;
var OBJECT_CTOR = {}.constructor;
var STRING_CTOR = ''.constructor;
var ARRAY_CTOR_PROTO = ARRAY_CTOR.prototype;
var BOOLEAN_CTOR_PROTO = BOOLEAN_CTOR.prototype;
var FUNCTION_CTOR_PROTO = FUNCTION_CTOR.prototype;
var NUMBER_CTOR_PROTO = NUMBER_CTOR.prototype;
var OBJECT_CTOR_PROTO = OBJECT_CTOR.prototype;
var STRING_CTOR_PROTO = STRING_CTOR.prototype;

var CALL = FUNCTION_CTOR_PROTO.call;
var APPLY = FUNCTION_CTOR_PROTO.apply;
var BIND = FUNCTION_CTOR_PROTO.bind;

var objectValueOf = OBJECT_CTOR_PROTO.valueOf;

// Sandboxing Angular Expressions
// ------------------------------
// Angular expressions are generally considered safe because these expressions only have direct
// access to `$scope` and locals. However, one can obtain the ability to execute arbitrary JS code by
// obtaining a reference to native JS functions such as the Function constructor.
//
// As an example, consider the following Angular expression:
//
//   {}.toString.constructor('alert("evil JS code")')
//
// This sandboxing technique is not perfect and doesn't aim to be. The goal is to prevent exploits
// against the expression language, but not to prevent exploits that were enabled by exposing
// sensitive JavaScript or browser APIs on Scope. Exposing such objects on a Scope is never a good
// practice and therefore we are not even trying to protect against interaction with an object
// explicitly exposed in this way.
//
// In general, it is not possible to access a Window object from an angular expression unless a
// window or some DOM object that has a reference to window is published onto a Scope.
// Similarly we prevent invocations of function known to be dangerous, as well as assignments to
// native objects.
//
// See https://docs.angularjs.org/guide/security


function ensureSafeMemberName(name, fullExpression) {
  if (name === '__defineGetter__' || name === '__defineSetter__'
      || name === '__lookupGetter__' || name === '__lookupSetter__'
      || name === '__proto__') {
    throw $parseMinErr('isecfld',
        'Attempting to access a disallowed field in Angular expressions! '
        + 'Expression: {0}', fullExpression);
  }
  return name;
}

function getStringValue(name) {
  // Property names must be strings. This means that non-string objects cannot be used
  // as keys in an object. Any non-string object, including a number, is typecasted
  // into a string via the toString method.
  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
  //
  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
  // to a string. It's not always possible. If `name` is an object and its `toString` method is
  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
  //
  // TypeError: Cannot convert object to primitive value
  //
  // For performance reasons, we don't catch this error here and allow it to propagate up the call
  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
  // such a 'broken' object as a key.
  return name + '';
}

function ensureSafeObject(obj, fullExpression) {
  // nifty check if obj is Function that is fast and works across iframes and other contexts
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
          'Referencing Function in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isWindow(obj)
        obj.window === obj) {
      throw $parseMinErr('isecwindow',
          'Referencing the Window in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// isElement(obj)
        obj.children && (obj.nodeName || (obj.prop && obj.attr && obj.find))) {
      throw $parseMinErr('isecdom',
          'Referencing DOM nodes in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    } else if (// block Object so that we can't get hold of dangerous Object.* methods
        obj === Object) {
      throw $parseMinErr('isecobj',
          'Referencing Object in Angular expressions is disallowed! Expression: {0}',
          fullExpression);
    }
  }
  return obj;
}

function ensureSafeFunction(obj, fullExpression) {
  if (obj) {
    if (obj.constructor === obj) {
      throw $parseMinErr('isecfn',
        'Referencing Function in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    } else if (obj === CALL || obj === APPLY || obj === BIND) {
      throw $parseMinErr('isecff',
        'Referencing call, apply or bind in Angular expressions is disallowed! Expression: {0}',
        fullExpression);
    }
  }
}

function ensureSafeAssignContext(obj, fullExpression) {
  if (obj) {
    if (obj === ARRAY_CTOR ||
        obj === BOOLEAN_CTOR ||
        obj === FUNCTION_CTOR ||
        obj === NUMBER_CTOR ||
        obj === OBJECT_CTOR ||
        obj === STRING_CTOR ||
        obj === ARRAY_CTOR_PROTO ||
        obj === BOOLEAN_CTOR_PROTO ||
        obj === FUNCTION_CTOR_PROTO ||
        obj === NUMBER_CTOR_PROTO ||
        obj === OBJECT_CTOR_PROTO ||
        obj === STRING_CTOR_PROTO) {
      throw $parseMinErr('isecaf',
        'Assigning to a constructor or its prototype is disallowed! Expression: {0}',
        fullExpression);
    }
  }
}

var OPERATORS = createMap();
forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};


/////////////////////////////////////////


/**
 * @constructor
 */
var Lexer = function Lexer(options) {
  this.options = options;
};

Lexer.prototype = {
  constructor: Lexer,

  lex: function(text) {
    this.text = text;
    this.index = 0;
    this.tokens = [];

    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      if (ch === '"' || ch === '\'') {
        this.readString(ch);
      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
        this.readNumber();
      } else if (this.isIdentifierStart(this.peekMultichar())) {
        this.readIdent();
      } else if (this.is(ch, '(){}[].,;:?')) {
        this.tokens.push({index: this.index, text: ch});
        this.index++;
      } else if (this.isWhitespace(ch)) {
        this.index++;
      } else {
        var ch2 = ch + this.peek();
        var ch3 = ch2 + this.peek(2);
        var op1 = OPERATORS[ch];
        var op2 = OPERATORS[ch2];
        var op3 = OPERATORS[ch3];
        if (op1 || op2 || op3) {
          var token = op3 ? ch3 : (op2 ? ch2 : ch);
          this.tokens.push({index: this.index, text: token, operator: true});
          this.index += token.length;
        } else {
          this.throwError('Unexpected next character ', this.index, this.index + 1);
        }
      }
    }
    return this.tokens;
  },

  is: function(ch, chars) {
    return chars.indexOf(ch) !== -1;
  },

  peek: function(i) {
    var num = i || 1;
    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
  },

  isNumber: function(ch) {
    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
  },

  isWhitespace: function(ch) {
    // IE treats non-breaking space as \u00A0
    return (ch === ' ' || ch === '\r' || ch === '\t' ||
            ch === '\n' || ch === '\v' || ch === '\u00A0');
  },

  isIdentifierStart: function(ch) {
    return this.options.isIdentifierStart ?
        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
        this.isValidIdentifierStart(ch);
  },

  isValidIdentifierStart: function(ch) {
    return ('a' <= ch && ch <= 'z' ||
            'A' <= ch && ch <= 'Z' ||
            '_' === ch || ch === '$');
  },

  isIdentifierContinue: function(ch) {
    return this.options.isIdentifierContinue ?
        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
        this.isValidIdentifierContinue(ch);
  },

  isValidIdentifierContinue: function(ch, cp) {
    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
  },

  codePointAt: function(ch) {
    if (ch.length === 1) return ch.charCodeAt(0);
    // eslint-disable-next-line no-bitwise
    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
  },

  peekMultichar: function() {
    var ch = this.text.charAt(this.index);
    var peek = this.peek();
    if (!peek) {
      return ch;
    }
    var cp1 = ch.charCodeAt(0);
    var cp2 = peek.charCodeAt(0);
    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
      return ch + peek;
    }
    return ch;
  },

  isExpOperator: function(ch) {
    return (ch === '-' || ch === '+' || this.isNumber(ch));
  },

  throwError: function(error, start, end) {
    end = end || this.index;
    var colStr = (isDefined(start)
            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
            : ' ' + end);
    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
        error, colStr, this.text);
  },

  readNumber: function() {
    var number = '';
    var start = this.index;
    while (this.index < this.text.length) {
      var ch = lowercase(this.text.charAt(this.index));
      if (ch === '.' || this.isNumber(ch)) {
        number += ch;
      } else {
        var peekCh = this.peek();
        if (ch === 'e' && this.isExpOperator(peekCh)) {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            peekCh && this.isNumber(peekCh) &&
            number.charAt(number.length - 1) === 'e') {
          number += ch;
        } else if (this.isExpOperator(ch) &&
            (!peekCh || !this.isNumber(peekCh)) &&
            number.charAt(number.length - 1) === 'e') {
          this.throwError('Invalid exponent');
        } else {
          break;
        }
      }
      this.index++;
    }
    this.tokens.push({
      index: start,
      text: number,
      constant: true,
      value: Number(number)
    });
  },

  readIdent: function() {
    var start = this.index;
    this.index += this.peekMultichar().length;
    while (this.index < this.text.length) {
      var ch = this.peekMultichar();
      if (!this.isIdentifierContinue(ch)) {
        break;
      }
      this.index += ch.length;
    }
    this.tokens.push({
      index: start,
      text: this.text.slice(start, this.index),
      identifier: true
    });
  },

  readString: function(quote) {
    var start = this.index;
    this.index++;
    var string = '';
    var rawString = quote;
    var escape = false;
    while (this.index < this.text.length) {
      var ch = this.text.charAt(this.index);
      rawString += ch;
      if (escape) {
        if (ch === 'u') {
          var hex = this.text.substring(this.index + 1, this.index + 5);
          if (!hex.match(/[\da-f]{4}/i)) {
            this.throwError('Invalid unicode escape [\\u' + hex + ']');
          }
          this.index += 4;
          string += String.fromCharCode(parseInt(hex, 16));
        } else {
          var rep = ESCAPE[ch];
          string = string + (rep || ch);
        }
        escape = false;
      } else if (ch === '\\') {
        escape = true;
      } else if (ch === quote) {
        this.index++;
        this.tokens.push({
          index: start,
          text: rawString,
          constant: true,
          value: string
        });
        return;
      } else {
        string += ch;
      }
      this.index++;
    }
    this.throwError('Unterminated quote', start);
  }
};

var AST = function AST(lexer, options) {
  this.lexer = lexer;
  this.options = options;
};

AST.Program = 'Program';
AST.ExpressionStatement = 'ExpressionStatement';
AST.AssignmentExpression = 'AssignmentExpression';
AST.ConditionalExpression = 'ConditionalExpression';
AST.LogicalExpression = 'LogicalExpression';
AST.BinaryExpression = 'BinaryExpression';
AST.UnaryExpression = 'UnaryExpression';
AST.CallExpression = 'CallExpression';
AST.MemberExpression = 'MemberExpression';
AST.Identifier = 'Identifier';
AST.Literal = 'Literal';
AST.ArrayExpression = 'ArrayExpression';
AST.Property = 'Property';
AST.ObjectExpression = 'ObjectExpression';
AST.ThisExpression = 'ThisExpression';
AST.LocalsExpression = 'LocalsExpression';

// Internal use only
AST.NGValueParameter = 'NGValueParameter';

AST.prototype = {
  ast: function(text) {
    this.text = text;
    this.tokens = this.lexer.lex(text);

    var value = this.program();

    if (this.tokens.length !== 0) {
      this.throwError('is an unexpected token', this.tokens[0]);
    }

    return value;
  },

  program: function() {
    var body = [];
    while (true) {
      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
        body.push(this.expressionStatement());
      if (!this.expect(';')) {
        return { type: AST.Program, body: body};
      }
    }
  },

  expressionStatement: function() {
    return { type: AST.ExpressionStatement, expression: this.filterChain() };
  },

  filterChain: function() {
    var left = this.expression();
    while (this.expect('|')) {
      left = this.filter(left);
    }
    return left;
  },

  expression: function() {
    return this.assignment();
  },

  assignment: function() {
    var result = this.ternary();
    if (this.expect('=')) {
      if (!isAssignable(result)) {
        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
      }

      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
    }
    return result;
  },

  ternary: function() {
    var test = this.logicalOR();
    var alternate;
    var consequent;
    if (this.expect('?')) {
      alternate = this.expression();
      if (this.consume(':')) {
        consequent = this.expression();
        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
      }
    }
    return test;
  },

  logicalOR: function() {
    var left = this.logicalAND();
    while (this.expect('||')) {
      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
    }
    return left;
  },

  logicalAND: function() {
    var left = this.equality();
    while (this.expect('&&')) {
      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
    }
    return left;
  },

  equality: function() {
    var left = this.relational();
    var token;
    while ((token = this.expect('==','!=','===','!=='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
    }
    return left;
  },

  relational: function() {
    var left = this.additive();
    var token;
    while ((token = this.expect('<', '>', '<=', '>='))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
    }
    return left;
  },

  additive: function() {
    var left = this.multiplicative();
    var token;
    while ((token = this.expect('+','-'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
    }
    return left;
  },

  multiplicative: function() {
    var left = this.unary();
    var token;
    while ((token = this.expect('*','/','%'))) {
      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
    }
    return left;
  },

  unary: function() {
    var token;
    if ((token = this.expect('+', '-', '!'))) {
      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
    } else {
      return this.primary();
    }
  },

  primary: function() {
    var primary;
    if (this.expect('(')) {
      primary = this.filterChain();
      this.consume(')');
    } else if (this.expect('[')) {
      primary = this.arrayDeclaration();
    } else if (this.expect('{')) {
      primary = this.object();
    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
      primary = copy(this.selfReferential[this.consume().text]);
    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
    } else if (this.peek().identifier) {
      primary = this.identifier();
    } else if (this.peek().constant) {
      primary = this.constant();
    } else {
      this.throwError('not a primary expression', this.peek());
    }

    var next;
    while ((next = this.expect('(', '[', '.'))) {
      if (next.text === '(') {
        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
        this.consume(')');
      } else if (next.text === '[') {
        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
        this.consume(']');
      } else if (next.text === '.') {
        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
      } else {
        this.throwError('IMPOSSIBLE');
      }
    }
    return primary;
  },

  filter: function(baseExpression) {
    var args = [baseExpression];
    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};

    while (this.expect(':')) {
      args.push(this.expression());
    }

    return result;
  },

  parseArguments: function() {
    var args = [];
    if (this.peekToken().text !== ')') {
      do {
        args.push(this.filterChain());
      } while (this.expect(','));
    }
    return args;
  },

  identifier: function() {
    var token = this.consume();
    if (!token.identifier) {
      this.throwError('is not a valid identifier', token);
    }
    return { type: AST.Identifier, name: token.text };
  },

  constant: function() {
    // TODO check that it is a constant
    return { type: AST.Literal, value: this.consume().value };
  },

  arrayDeclaration: function() {
    var elements = [];
    if (this.peekToken().text !== ']') {
      do {
        if (this.peek(']')) {
          // Support trailing commas per ES5.1.
          break;
        }
        elements.push(this.expression());
      } while (this.expect(','));
    }
    this.consume(']');

    return { type: AST.ArrayExpression, elements: elements };
  },

  object: function() {
    var properties = [], property;
    if (this.peekToken().text !== '}') {
      do {
        if (this.peek('}')) {
          // Support trailing commas per ES5.1.
          break;
        }
        property = {type: AST.Property, kind: 'init'};
        if (this.peek().constant) {
          property.key = this.constant();
          property.computed = false;
          this.consume(':');
          property.value = this.expression();
        } else if (this.peek().identifier) {
          property.key = this.identifier();
          property.computed = false;
          if (this.peek(':')) {
            this.consume(':');
            property.value = this.expression();
          } else {
            property.value = property.key;
          }
        } else if (this.peek('[')) {
          this.consume('[');
          property.key = this.expression();
          this.consume(']');
          property.computed = true;
          this.consume(':');
          property.value = this.expression();
        } else {
          this.throwError('invalid key', this.peek());
        }
        properties.push(property);
      } while (this.expect(','));
    }
    this.consume('}');

    return {type: AST.ObjectExpression, properties: properties };
  },

  throwError: function(msg, token) {
    throw $parseMinErr('syntax',
        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
  },

  consume: function(e1) {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }

    var token = this.expect(e1);
    if (!token) {
      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
    }
    return token;
  },

  peekToken: function() {
    if (this.tokens.length === 0) {
      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
    }
    return this.tokens[0];
  },

  peek: function(e1, e2, e3, e4) {
    return this.peekAhead(0, e1, e2, e3, e4);
  },

  peekAhead: function(i, e1, e2, e3, e4) {
    if (this.tokens.length > i) {
      var token = this.tokens[i];
      var t = token.text;
      if (t === e1 || t === e2 || t === e3 || t === e4 ||
          (!e1 && !e2 && !e3 && !e4)) {
        return token;
      }
    }
    return false;
  },

  expect: function(e1, e2, e3, e4) {
    var token = this.peek(e1, e2, e3, e4);
    if (token) {
      this.tokens.shift();
      return token;
    }
    return false;
  },

  selfReferential: {
    'this': {type: AST.ThisExpression },
    '$locals': {type: AST.LocalsExpression }
  }
};

function ifDefined(v, d) {
  return typeof v !== 'undefined' ? v : d;
}

function plusFn(l, r) {
  if (typeof l === 'undefined') return r;
  if (typeof r === 'undefined') return l;
  return l + r;
}

function isStateless($filter, filterName) {
  var fn = $filter(filterName);
  return !fn.$stateful;
}

function findConstantAndWatchExpressions(ast, $filter) {
  var allConstants;
  var argsToWatch;
  var isStatelessFilter;
  switch (ast.type) {
  case AST.Program:
    allConstants = true;
    forEach(ast.body, function(expr) {
      findConstantAndWatchExpressions(expr.expression, $filter);
      allConstants = allConstants && expr.expression.constant;
    });
    ast.constant = allConstants;
    break;
  case AST.Literal:
    ast.constant = true;
    ast.toWatch = [];
    break;
  case AST.UnaryExpression:
    findConstantAndWatchExpressions(ast.argument, $filter);
    ast.constant = ast.argument.constant;
    ast.toWatch = ast.argument.toWatch;
    break;
  case AST.BinaryExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
    break;
  case AST.LogicalExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.ConditionalExpression:
    findConstantAndWatchExpressions(ast.test, $filter);
    findConstantAndWatchExpressions(ast.alternate, $filter);
    findConstantAndWatchExpressions(ast.consequent, $filter);
    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
    ast.toWatch = ast.constant ? [] : [ast];
    break;
  case AST.Identifier:
    ast.constant = false;
    ast.toWatch = [ast];
    break;
  case AST.MemberExpression:
    findConstantAndWatchExpressions(ast.object, $filter);
    if (ast.computed) {
      findConstantAndWatchExpressions(ast.property, $filter);
    }
    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
    ast.toWatch = [ast];
    break;
  case AST.CallExpression:
    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
    allConstants = isStatelessFilter;
    argsToWatch = [];
    forEach(ast.arguments, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
    break;
  case AST.AssignmentExpression:
    findConstantAndWatchExpressions(ast.left, $filter);
    findConstantAndWatchExpressions(ast.right, $filter);
    ast.constant = ast.left.constant && ast.right.constant;
    ast.toWatch = [ast];
    break;
  case AST.ArrayExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.elements, function(expr) {
      findConstantAndWatchExpressions(expr, $filter);
      allConstants = allConstants && expr.constant;
      if (!expr.constant) {
        argsToWatch.push.apply(argsToWatch, expr.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ObjectExpression:
    allConstants = true;
    argsToWatch = [];
    forEach(ast.properties, function(property) {
      findConstantAndWatchExpressions(property.value, $filter);
      allConstants = allConstants && property.value.constant && !property.computed;
      if (!property.value.constant) {
        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
      }
    });
    ast.constant = allConstants;
    ast.toWatch = argsToWatch;
    break;
  case AST.ThisExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  case AST.LocalsExpression:
    ast.constant = false;
    ast.toWatch = [];
    break;
  }
}

function getInputs(body) {
  if (body.length !== 1) return;
  var lastExpression = body[0].expression;
  var candidate = lastExpression.toWatch;
  if (candidate.length !== 1) return candidate;
  return candidate[0] !== lastExpression ? candidate : undefined;
}

function isAssignable(ast) {
  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
}

function assignableAST(ast) {
  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
  }
}

function isLiteral(ast) {
  return ast.body.length === 0 ||
      ast.body.length === 1 && (
      ast.body[0].expression.type === AST.Literal ||
      ast.body[0].expression.type === AST.ArrayExpression ||
      ast.body[0].expression.type === AST.ObjectExpression);
}

function isConstant(ast) {
  return ast.constant;
}

function ASTCompiler(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTCompiler.prototype = {
  compile: function(expression, expensiveChecks) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    this.state = {
      nextId: 0,
      filters: {},
      expensiveChecks: expensiveChecks,
      fn: {vars: [], body: [], own: {}},
      assign: {vars: [], body: [], own: {}},
      inputs: []
    };
    findConstantAndWatchExpressions(ast, self.$filter);
    var extra = '';
    var assignable;
    this.stage = 'assign';
    if ((assignable = assignableAST(ast))) {
      this.state.computing = 'assign';
      var result = this.nextId();
      this.recurse(assignable, result);
      this.return_(result);
      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
    }
    var toWatch = getInputs(ast.body);
    self.stage = 'inputs';
    forEach(toWatch, function(watch, key) {
      var fnKey = 'fn' + key;
      self.state[fnKey] = {vars: [], body: [], own: {}};
      self.state.computing = fnKey;
      var intoId = self.nextId();
      self.recurse(watch, intoId);
      self.return_(intoId);
      self.state.inputs.push(fnKey);
      watch.watchId = key;
    });
    this.state.computing = 'fn';
    this.stage = 'main';
    this.recurse(ast);
    var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' +
      this.filterPrefix() +
      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
      extra +
      this.watchFns() +
      'return fn;';

    // eslint-disable-next-line no-new-func
    var fn = (new Function('$filter',
        'ensureSafeMemberName',
        'ensureSafeObject',
        'ensureSafeFunction',
        'getStringValue',
        'ensureSafeAssignContext',
        'ifDefined',
        'plus',
        'text',
        fnString))(
          this.$filter,
          ensureSafeMemberName,
          ensureSafeObject,
          ensureSafeFunction,
          getStringValue,
          ensureSafeAssignContext,
          ifDefined,
          plusFn,
          expression);
    this.state = this.stage = undefined;
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  USE: 'use',

  STRICT: 'strict',

  watchFns: function() {
    var result = [];
    var fns = this.state.inputs;
    var self = this;
    forEach(fns, function(name) {
      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
    });
    if (fns.length) {
      result.push('fn.inputs=[' + fns.join(',') + '];');
    }
    return result.join('');
  },

  generateFunction: function(name, params) {
    return 'function(' + params + '){' +
        this.varsPrefix(name) +
        this.body(name) +
        '};';
  },

  filterPrefix: function() {
    var parts = [];
    var self = this;
    forEach(this.state.filters, function(id, filter) {
      parts.push(id + '=$filter(' + self.escape(filter) + ')');
    });
    if (parts.length) return 'var ' + parts.join(',') + ';';
    return '';
  },

  varsPrefix: function(section) {
    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
  },

  body: function(section) {
    return this.state[section].body.join('');
  },

  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var left, right, self = this, args, expression, computed;
    recursionFn = recursionFn || noop;
    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
      intoId = intoId || this.nextId();
      this.if_('i',
        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
      );
      return;
    }
    switch (ast.type) {
    case AST.Program:
      forEach(ast.body, function(expression, pos) {
        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
        if (pos !== ast.body.length - 1) {
          self.current().body.push(right, ';');
        } else {
          self.return_(right);
        }
      });
      break;
    case AST.Literal:
      expression = this.escape(ast.value);
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.UnaryExpression:
      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.BinaryExpression:
      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
      if (ast.operator === '+') {
        expression = this.plus(left, right);
      } else if (ast.operator === '-') {
        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
      } else {
        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
      }
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.LogicalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.left, intoId);
      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
      recursionFn(intoId);
      break;
    case AST.ConditionalExpression:
      intoId = intoId || this.nextId();
      self.recurse(ast.test, intoId);
      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
      recursionFn(intoId);
      break;
    case AST.Identifier:
      intoId = intoId || this.nextId();
      if (nameId) {
        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
        nameId.computed = false;
        nameId.name = ast.name;
      }
      ensureSafeMemberName(ast.name);
      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
        function() {
          self.if_(self.stage === 'inputs' || 's', function() {
            if (create && create !== 1) {
              self.if_(
                self.not(self.nonComputedMember('s', ast.name)),
                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
            }
            self.assign(intoId, self.nonComputedMember('s', ast.name));
          });
        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
        );
      if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.name)) {
        self.addEnsureSafeObject(intoId);
      }
      recursionFn(intoId);
      break;
    case AST.MemberExpression:
      left = nameId && (nameId.context = this.nextId()) || this.nextId();
      intoId = intoId || this.nextId();
      self.recurse(ast.object, left, undefined, function() {
        self.if_(self.notNull(left), function() {
          if (create && create !== 1) {
            self.addEnsureSafeAssignContext(left);
          }
          if (ast.computed) {
            right = self.nextId();
            self.recurse(ast.property, right);
            self.getStringValue(right);
            self.addEnsureSafeMemberName(right);
            if (create && create !== 1) {
              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
            }
            expression = self.ensureSafeObject(self.computedMember(left, right));
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = true;
              nameId.name = right;
            }
          } else {
            ensureSafeMemberName(ast.property.name);
            if (create && create !== 1) {
              self.if_(self.not(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
            }
            expression = self.nonComputedMember(left, ast.property.name);
            if (self.state.expensiveChecks || isPossiblyDangerousMemberName(ast.property.name)) {
              expression = self.ensureSafeObject(expression);
            }
            self.assign(intoId, expression);
            if (nameId) {
              nameId.computed = false;
              nameId.name = ast.property.name;
            }
          }
        }, function() {
          self.assign(intoId, 'undefined');
        });
        recursionFn(intoId);
      }, !!create);
      break;
    case AST.CallExpression:
      intoId = intoId || this.nextId();
      if (ast.filter) {
        right = self.filter(ast.callee.name);
        args = [];
        forEach(ast.arguments, function(expr) {
          var argument = self.nextId();
          self.recurse(expr, argument);
          args.push(argument);
        });
        expression = right + '(' + args.join(',') + ')';
        self.assign(intoId, expression);
        recursionFn(intoId);
      } else {
        right = self.nextId();
        left = {};
        args = [];
        self.recurse(ast.callee, right, left, function() {
          self.if_(self.notNull(right), function() {
            self.addEnsureSafeFunction(right);
            forEach(ast.arguments, function(expr) {
              self.recurse(expr, self.nextId(), undefined, function(argument) {
                args.push(self.ensureSafeObject(argument));
              });
            });
            if (left.name) {
              if (!self.state.expensiveChecks) {
                self.addEnsureSafeObject(left.context);
              }
              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
            } else {
              expression = right + '(' + args.join(',') + ')';
            }
            expression = self.ensureSafeObject(expression);
            self.assign(intoId, expression);
          }, function() {
            self.assign(intoId, 'undefined');
          });
          recursionFn(intoId);
        });
      }
      break;
    case AST.AssignmentExpression:
      right = this.nextId();
      left = {};
      this.recurse(ast.left, undefined, left, function() {
        self.if_(self.notNull(left.context), function() {
          self.recurse(ast.right, right);
          self.addEnsureSafeObject(self.member(left.context, left.name, left.computed));
          self.addEnsureSafeAssignContext(left.context);
          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
          self.assign(intoId, expression);
          recursionFn(intoId || expression);
        });
      }, 1);
      break;
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        self.recurse(expr, self.nextId(), undefined, function(argument) {
          args.push(argument);
        });
      });
      expression = '[' + args.join(',') + ']';
      this.assign(intoId, expression);
      recursionFn(expression);
      break;
    case AST.ObjectExpression:
      args = [];
      computed = false;
      forEach(ast.properties, function(property) {
        if (property.computed) {
          computed = true;
        }
      });
      if (computed) {
        intoId = intoId || this.nextId();
        this.assign(intoId, '{}');
        forEach(ast.properties, function(property) {
          if (property.computed) {
            left = self.nextId();
            self.recurse(property.key, left);
          } else {
            left = property.key.type === AST.Identifier ?
                       property.key.name :
                       ('' + property.key.value);
          }
          right = self.nextId();
          self.recurse(property.value, right);
          self.assign(self.member(intoId, left, property.computed), right);
        });
      } else {
        forEach(ast.properties, function(property) {
          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
            args.push(self.escape(
                property.key.type === AST.Identifier ? property.key.name :
                  ('' + property.key.value)) +
                ':' + expr);
          });
        });
        expression = '{' + args.join(',') + '}';
        this.assign(intoId, expression);
      }
      recursionFn(intoId || expression);
      break;
    case AST.ThisExpression:
      this.assign(intoId, 's');
      recursionFn('s');
      break;
    case AST.LocalsExpression:
      this.assign(intoId, 'l');
      recursionFn('l');
      break;
    case AST.NGValueParameter:
      this.assign(intoId, 'v');
      recursionFn('v');
      break;
    }
  },

  getHasOwnProperty: function(element, property) {
    var key = element + '.' + property;
    var own = this.current().own;
    if (!own.hasOwnProperty(key)) {
      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
    }
    return own[key];
  },

  assign: function(id, value) {
    if (!id) return;
    this.current().body.push(id, '=', value, ';');
    return id;
  },

  filter: function(filterName) {
    if (!this.state.filters.hasOwnProperty(filterName)) {
      this.state.filters[filterName] = this.nextId(true);
    }
    return this.state.filters[filterName];
  },

  ifDefined: function(id, defaultValue) {
    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
  },

  plus: function(left, right) {
    return 'plus(' + left + ',' + right + ')';
  },

  return_: function(id) {
    this.current().body.push('return ', id, ';');
  },

  if_: function(test, alternate, consequent) {
    if (test === true) {
      alternate();
    } else {
      var body = this.current().body;
      body.push('if(', test, '){');
      alternate();
      body.push('}');
      if (consequent) {
        body.push('else{');
        consequent();
        body.push('}');
      }
    }
  },

  not: function(expression) {
    return '!(' + expression + ')';
  },

  notNull: function(expression) {
    return expression + '!=null';
  },

  nonComputedMember: function(left, right) {
    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
    if (SAFE_IDENTIFIER.test(right)) {
      return left + '.' + right;
    } else {
      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
    }
  },

  computedMember: function(left, right) {
    return left + '[' + right + ']';
  },

  member: function(left, right, computed) {
    if (computed) return this.computedMember(left, right);
    return this.nonComputedMember(left, right);
  },

  addEnsureSafeObject: function(item) {
    this.current().body.push(this.ensureSafeObject(item), ';');
  },

  addEnsureSafeMemberName: function(item) {
    this.current().body.push(this.ensureSafeMemberName(item), ';');
  },

  addEnsureSafeFunction: function(item) {
    this.current().body.push(this.ensureSafeFunction(item), ';');
  },

  addEnsureSafeAssignContext: function(item) {
    this.current().body.push(this.ensureSafeAssignContext(item), ';');
  },

  ensureSafeObject: function(item) {
    return 'ensureSafeObject(' + item + ',text)';
  },

  ensureSafeMemberName: function(item) {
    return 'ensureSafeMemberName(' + item + ',text)';
  },

  ensureSafeFunction: function(item) {
    return 'ensureSafeFunction(' + item + ',text)';
  },

  getStringValue: function(item) {
    this.assign(item, 'getStringValue(' + item + ')');
  },

  ensureSafeAssignContext: function(item) {
    return 'ensureSafeAssignContext(' + item + ',text)';
  },

  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
    var self = this;
    return function() {
      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
    };
  },

  lazyAssign: function(id, value) {
    var self = this;
    return function() {
      self.assign(id, value);
    };
  },

  stringEscapeRegex: /[^ a-zA-Z0-9]/g,

  stringEscapeFn: function(c) {
    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
  },

  escape: function(value) {
    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
    if (isNumber(value)) return value.toString();
    if (value === true) return 'true';
    if (value === false) return 'false';
    if (value === null) return 'null';
    if (typeof value === 'undefined') return 'undefined';

    throw $parseMinErr('esc', 'IMPOSSIBLE');
  },

  nextId: function(skip, init) {
    var id = 'v' + (this.state.nextId++);
    if (!skip) {
      this.current().vars.push(id + (init ? '=' + init : ''));
    }
    return id;
  },

  current: function() {
    return this.state[this.state.computing];
  }
};


function ASTInterpreter(astBuilder, $filter) {
  this.astBuilder = astBuilder;
  this.$filter = $filter;
}

ASTInterpreter.prototype = {
  compile: function(expression, expensiveChecks) {
    var self = this;
    var ast = this.astBuilder.ast(expression);
    this.expression = expression;
    this.expensiveChecks = expensiveChecks;
    findConstantAndWatchExpressions(ast, self.$filter);
    var assignable;
    var assign;
    if ((assignable = assignableAST(ast))) {
      assign = this.recurse(assignable);
    }
    var toWatch = getInputs(ast.body);
    var inputs;
    if (toWatch) {
      inputs = [];
      forEach(toWatch, function(watch, key) {
        var input = self.recurse(watch);
        watch.input = input;
        inputs.push(input);
        watch.watchId = key;
      });
    }
    var expressions = [];
    forEach(ast.body, function(expression) {
      expressions.push(self.recurse(expression.expression));
    });
    var fn = ast.body.length === 0 ? noop :
             ast.body.length === 1 ? expressions[0] :
             function(scope, locals) {
               var lastValue;
               forEach(expressions, function(exp) {
                 lastValue = exp(scope, locals);
               });
               return lastValue;
             };
    if (assign) {
      fn.assign = function(scope, value, locals) {
        return assign(scope, locals, value);
      };
    }
    if (inputs) {
      fn.inputs = inputs;
    }
    fn.literal = isLiteral(ast);
    fn.constant = isConstant(ast);
    return fn;
  },

  recurse: function(ast, context, create) {
    var left, right, self = this, args;
    if (ast.input) {
      return this.inputs(ast.input, ast.watchId);
    }
    switch (ast.type) {
    case AST.Literal:
      return this.value(ast.value, context);
    case AST.UnaryExpression:
      right = this.recurse(ast.argument);
      return this['unary' + ast.operator](right, context);
    case AST.BinaryExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.LogicalExpression:
      left = this.recurse(ast.left);
      right = this.recurse(ast.right);
      return this['binary' + ast.operator](left, right, context);
    case AST.ConditionalExpression:
      return this['ternary?:'](
        this.recurse(ast.test),
        this.recurse(ast.alternate),
        this.recurse(ast.consequent),
        context
      );
    case AST.Identifier:
      ensureSafeMemberName(ast.name, self.expression);
      return self.identifier(ast.name,
                             self.expensiveChecks || isPossiblyDangerousMemberName(ast.name),
                             context, create, self.expression);
    case AST.MemberExpression:
      left = this.recurse(ast.object, false, !!create);
      if (!ast.computed) {
        ensureSafeMemberName(ast.property.name, self.expression);
        right = ast.property.name;
      }
      if (ast.computed) right = this.recurse(ast.property);
      return ast.computed ?
        this.computedMember(left, right, context, create, self.expression) :
        this.nonComputedMember(left, right, self.expensiveChecks, context, create, self.expression);
    case AST.CallExpression:
      args = [];
      forEach(ast.arguments, function(expr) {
        args.push(self.recurse(expr));
      });
      if (ast.filter) right = this.$filter(ast.callee.name);
      if (!ast.filter) right = this.recurse(ast.callee, true);
      return ast.filter ?
        function(scope, locals, assign, inputs) {
          var values = [];
          for (var i = 0; i < args.length; ++i) {
            values.push(args[i](scope, locals, assign, inputs));
          }
          var value = right.apply(undefined, values, inputs);
          return context ? {context: undefined, name: undefined, value: value} : value;
        } :
        function(scope, locals, assign, inputs) {
          var rhs = right(scope, locals, assign, inputs);
          var value;
          if (rhs.value != null) {
            ensureSafeObject(rhs.context, self.expression);
            ensureSafeFunction(rhs.value, self.expression);
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(ensureSafeObject(args[i](scope, locals, assign, inputs), self.expression));
            }
            value = ensureSafeObject(rhs.value.apply(rhs.context, values), self.expression);
          }
          return context ? {value: value} : value;
        };
    case AST.AssignmentExpression:
      left = this.recurse(ast.left, true, 1);
      right = this.recurse(ast.right);
      return function(scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        ensureSafeObject(lhs.value, self.expression);
        ensureSafeAssignContext(lhs.context);
        lhs.context[lhs.name] = rhs;
        return context ? {value: rhs} : rhs;
      };
    case AST.ArrayExpression:
      args = [];
      forEach(ast.elements, function(expr) {
        args.push(self.recurse(expr));
      });
      return function(scope, locals, assign, inputs) {
        var value = [];
        for (var i = 0; i < args.length; ++i) {
          value.push(args[i](scope, locals, assign, inputs));
        }
        return context ? {value: value} : value;
      };
    case AST.ObjectExpression:
      args = [];
      forEach(ast.properties, function(property) {
        if (property.computed) {
          args.push({key: self.recurse(property.key),
                     computed: true,
                     value: self.recurse(property.value)
          });
        } else {
          args.push({key: property.key.type === AST.Identifier ?
                          property.key.name :
                          ('' + property.key.value),
                     computed: false,
                     value: self.recurse(property.value)
          });
        }
      });
      return function(scope, locals, assign, inputs) {
        var value = {};
        for (var i = 0; i < args.length; ++i) {
          if (args[i].computed) {
            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
          } else {
            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
          }
        }
        return context ? {value: value} : value;
      };
    case AST.ThisExpression:
      return function(scope) {
        return context ? {value: scope} : scope;
      };
    case AST.LocalsExpression:
      return function(scope, locals) {
        return context ? {value: locals} : locals;
      };
    case AST.NGValueParameter:
      return function(scope, locals, assign) {
        return context ? {value: assign} : assign;
      };
    }
  },

  'unary+': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = +arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary-': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = argument(scope, locals, assign, inputs);
      if (isDefined(arg)) {
        arg = -arg;
      } else {
        arg = 0;
      }
      return context ? {value: arg} : arg;
    };
  },
  'unary!': function(argument, context) {
    return function(scope, locals, assign, inputs) {
      var arg = !argument(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary+': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = plusFn(lhs, rhs);
      return context ? {value: arg} : arg;
    };
  },
  'binary-': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs = right(scope, locals, assign, inputs);
      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
      return context ? {value: arg} : arg;
    };
  },
  'binary*': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary/': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary%': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary===': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary==': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary!=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      // eslint-disable-next-line eqeqeq
      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary<=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary>=': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary&&': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'binary||': function(left, right, context) {
    return function(scope, locals, assign, inputs) {
      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  'ternary?:': function(test, alternate, consequent, context) {
    return function(scope, locals, assign, inputs) {
      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
      return context ? {value: arg} : arg;
    };
  },
  value: function(value, context) {
    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
  },
  identifier: function(name, expensiveChecks, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var base = locals && (name in locals) ? locals : scope;
      if (create && create !== 1 && base && !(base[name])) {
        base[name] = {};
      }
      var value = base ? base[name] : undefined;
      if (expensiveChecks) {
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: base, name: name, value: value};
      } else {
        return value;
      }
    };
  },
  computedMember: function(left, right, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      var rhs;
      var value;
      if (lhs != null) {
        rhs = right(scope, locals, assign, inputs);
        rhs = getStringValue(rhs);
        ensureSafeMemberName(rhs, expression);
        if (create && create !== 1) {
          ensureSafeAssignContext(lhs);
          if (lhs && !(lhs[rhs])) {
            lhs[rhs] = {};
          }
        }
        value = lhs[rhs];
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: lhs, name: rhs, value: value};
      } else {
        return value;
      }
    };
  },
  nonComputedMember: function(left, right, expensiveChecks, context, create, expression) {
    return function(scope, locals, assign, inputs) {
      var lhs = left(scope, locals, assign, inputs);
      if (create && create !== 1) {
        ensureSafeAssignContext(lhs);
        if (lhs && !(lhs[right])) {
          lhs[right] = {};
        }
      }
      var value = lhs != null ? lhs[right] : undefined;
      if (expensiveChecks || isPossiblyDangerousMemberName(right)) {
        ensureSafeObject(value, expression);
      }
      if (context) {
        return {context: lhs, name: right, value: value};
      } else {
        return value;
      }
    };
  },
  inputs: function(input, watchId) {
    return function(scope, value, locals, inputs) {
      if (inputs) return inputs[watchId];
      return input(scope, value, locals);
    };
  }
};

/**
 * @constructor
 */
var Parser = function Parser(lexer, $filter, options) {
  this.lexer = lexer;
  this.$filter = $filter;
  this.options = options;
  this.ast = new AST(lexer, options);
  this.astCompiler = options.csp ? new ASTInterpreter(this.ast, $filter) :
                                   new ASTCompiler(this.ast, $filter);
};

Parser.prototype = {
  constructor: Parser,

  parse: function(text) {
    return this.astCompiler.compile(text, this.options.expensiveChecks);
  }
};

function isPossiblyDangerousMemberName(name) {
  return name === 'constructor';
}

function getValueOf(value) {
  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
}

///////////////////////////////////

/**
 * @ngdoc service
 * @name $parse
 * @kind function
 *
 * @description
 *
 * Converts Angular {@link guide/expression expression} into a function.
 *
 * ```js
 *   var getter = $parse('user.name');
 *   var setter = getter.assign;
 *   var context = {user:{name:'angular'}};
 *   var locals = {user:{name:'local'}};
 *
 *   expect(getter(context)).toEqual('angular');
 *   setter(context, 'newValue');
 *   expect(context.user.name).toEqual('newValue');
 *   expect(getter(context, locals)).toEqual('local');
 * ```
 *
 *
 * @param {string} expression String expression to compile.
 * @returns {function(context, locals)} a function which represents the compiled expression:
 *
 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
 *      are evaluated against (typically a scope object).
 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
 *      `context`.
 *
 *    The returned function also has the following properties:
 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
 *        literal.
 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
 *        constant literals.
 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
 *        set to a function to change its value on the given context.
 *
 */


/**
 * @ngdoc provider
 * @name $parseProvider
 * @this
 *
 * @description
 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
 *  service.
 */
function $ParseProvider() {
  var cacheDefault = createMap();
  var cacheExpensive = createMap();
  var literals = {
    'true': true,
    'false': false,
    'null': null,
    'undefined': undefined
  };
  var identStart, identContinue;

  /**
   * @ngdoc method
   * @name $parseProvider#addLiteral
   * @description
   *
   * Configure $parse service to add literal values that will be present as literal at expressions.
   *
   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
   *
   **/
  this.addLiteral = function(literalName, literalValue) {
    literals[literalName] = literalValue;
  };

 /**
  * @ngdoc method
  * @name $parseProvider#setIdentifierFns
  *
  * @description
  *
  * Allows defining the set of characters that are allowed in Angular expressions. The function
  * `identifierStart` will get called to know if a given character is a valid character to be the
  * first character for an identifier. The function `identifierContinue` will get called to know if
  * a given character is a valid character to be a follow-up identifier character. The functions
  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
  * mind that the `string` parameter can be two characters long depending on the character
  * representation. It is expected for the function to return `true` or `false`, whether that
  * character is allowed or not.
  *
  * Since this function will be called extensively, keep the implementation of these functions fast,
  * as the performance of these functions have a direct impact on the expressions parsing speed.
  *
  * @param {function=} identifierStart The function that will decide whether the given character is
  *   a valid identifier start character.
  * @param {function=} identifierContinue The function that will decide whether the given character is
  *   a valid identifier continue character.
  */
  this.setIdentifierFns = function(identifierStart, identifierContinue) {
    identStart = identifierStart;
    identContinue = identifierContinue;
    return this;
  };

  this.$get = ['$filter', function($filter) {
    var noUnsafeEval = csp().noUnsafeEval;
    var $parseOptions = {
          csp: noUnsafeEval,
          expensiveChecks: false,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        },
        $parseOptionsExpensive = {
          csp: noUnsafeEval,
          expensiveChecks: true,
          literals: copy(literals),
          isIdentifierStart: isFunction(identStart) && identStart,
          isIdentifierContinue: isFunction(identContinue) && identContinue
        };
    var runningChecksEnabled = false;

    $parse.$$runningExpensiveChecks = function() {
      return runningChecksEnabled;
    };

    return $parse;

    function $parse(exp, interceptorFn, expensiveChecks) {
      var parsedExpression, oneTime, cacheKey;

      expensiveChecks = expensiveChecks || runningChecksEnabled;

      switch (typeof exp) {
        case 'string':
          exp = exp.trim();
          cacheKey = exp;

          var cache = (expensiveChecks ? cacheExpensive : cacheDefault);
          parsedExpression = cache[cacheKey];

          if (!parsedExpression) {
            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
              oneTime = true;
              exp = exp.substring(2);
            }
            var parseOptions = expensiveChecks ? $parseOptionsExpensive : $parseOptions;
            var lexer = new Lexer(parseOptions);
            var parser = new Parser(lexer, $filter, parseOptions);
            parsedExpression = parser.parse(exp);
            if (parsedExpression.constant) {
              parsedExpression.$$watchDelegate = constantWatchDelegate;
            } else if (oneTime) {
              parsedExpression.$$watchDelegate = parsedExpression.literal ?
                  oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
            } else if (parsedExpression.inputs) {
              parsedExpression.$$watchDelegate = inputsWatchDelegate;
            }
            if (expensiveChecks) {
              parsedExpression = expensiveChecksInterceptor(parsedExpression);
            }
            cache[cacheKey] = parsedExpression;
          }
          return addInterceptor(parsedExpression, interceptorFn);

        case 'function':
          return addInterceptor(exp, interceptorFn);

        default:
          return addInterceptor(noop, interceptorFn);
      }
    }

    function expensiveChecksInterceptor(fn) {
      if (!fn) return fn;
      expensiveCheckFn.$$watchDelegate = fn.$$watchDelegate;
      expensiveCheckFn.assign = expensiveChecksInterceptor(fn.assign);
      expensiveCheckFn.constant = fn.constant;
      expensiveCheckFn.literal = fn.literal;
      for (var i = 0; fn.inputs && i < fn.inputs.length; ++i) {
        fn.inputs[i] = expensiveChecksInterceptor(fn.inputs[i]);
      }
      expensiveCheckFn.inputs = fn.inputs;

      return expensiveCheckFn;

      function expensiveCheckFn(scope, locals, assign, inputs) {
        var expensiveCheckOldValue = runningChecksEnabled;
        runningChecksEnabled = true;
        try {
          return fn(scope, locals, assign, inputs);
        } finally {
          runningChecksEnabled = expensiveCheckOldValue;
        }
      }
    }

    function expressionInputDirtyCheck(newValue, oldValueOfValue) {

      if (newValue == null || oldValueOfValue == null) { // null/undefined
        return newValue === oldValueOfValue;
      }

      if (typeof newValue === 'object') {

        // attempt to convert the value to a primitive type
        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
        //             be cheaply dirty-checked
        newValue = getValueOf(newValue);

        if (typeof newValue === 'object') {
          // objects/arrays are not supported - deep-watching them would be too expensive
          return false;
        }

        // fall-through to the primitive equality check
      }

      //Primitive or NaN
      // eslint-disable-next-line no-self-compare
      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
    }

    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
      var inputExpressions = parsedExpression.inputs;
      var lastResult;

      if (inputExpressions.length === 1) {
        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
        inputExpressions = inputExpressions[0];
        return scope.$watch(function expressionInputWatch(scope) {
          var newInputValue = inputExpressions(scope);
          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf)) {
            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
            oldInputValueOf = newInputValue && getValueOf(newInputValue);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      var oldInputValueOfValues = [];
      var oldInputValues = [];
      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
        oldInputValues[i] = null;
      }

      return scope.$watch(function expressionInputsWatch(scope) {
        var changed = false;

        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          var newInputValue = inputExpressions[i](scope);
          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i]))) {
            oldInputValues[i] = newInputValue;
            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
          }
        }

        if (changed) {
          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
        }

        return lastResult;
      }, listener, objectEquality, prettyPrintExpression);
    }

    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, /** @this */ function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.apply(this, arguments);
        }
        if (isDefined(value)) {
          scope.$$postDigest(function() {
            if (isDefined(lastValue)) {
              unwatch();
            }
          });
        }
      }, objectEquality);
      return unwatch;
    }

    function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch, lastValue;
      unwatch = scope.$watch(function oneTimeWatch(scope) {
        return parsedExpression(scope);
      }, /** @this */ function oneTimeListener(value, old, scope) {
        lastValue = value;
        if (isFunction(listener)) {
          listener.call(this, value, old, scope);
        }
        if (isAllDefined(value)) {
          scope.$$postDigest(function() {
            if (isAllDefined(lastValue)) unwatch();
          });
        }
      }, objectEquality);

      return unwatch;

      function isAllDefined(value) {
        var allDefined = true;
        forEach(value, function(val) {
          if (!isDefined(val)) allDefined = false;
        });
        return allDefined;
      }
    }

    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
      var unwatch = scope.$watch(function constantWatch(scope) {
        unwatch();
        return parsedExpression(scope);
      }, listener, objectEquality);
      return unwatch;
    }

    function addInterceptor(parsedExpression, interceptorFn) {
      if (!interceptorFn) return parsedExpression;
      var watchDelegate = parsedExpression.$$watchDelegate;
      var useInputs = false;

      var regularWatch =
          watchDelegate !== oneTimeLiteralWatchDelegate &&
          watchDelegate !== oneTimeWatchDelegate;

      var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
        return interceptorFn(value, scope, locals);
      } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
        var value = parsedExpression(scope, locals, assign, inputs);
        var result = interceptorFn(value, scope, locals);
        // we only return the interceptor's result if the
        // initial value is defined (for bind-once)
        return isDefined(value) ? result : value;
      };

      // Propagate $$watchDelegates other then inputsWatchDelegate
      if (parsedExpression.$$watchDelegate &&
          parsedExpression.$$watchDelegate !== inputsWatchDelegate) {
        fn.$$watchDelegate = parsedExpression.$$watchDelegate;
      } else if (!interceptorFn.$stateful) {
        // If there is an interceptor, but no watchDelegate then treat the interceptor like
        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
        fn.$$watchDelegate = inputsWatchDelegate;
        useInputs = !parsedExpression.inputs;
        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
      }

      return fn;
    }
  }];
}

/**
 * @ngdoc service
 * @name $q
 * @requires $rootScope
 * @this
 *
 * @description
 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
 * when they are done processing.
 *
 * This is an implementation of promises/deferred objects inspired by
 * [Kris Kowal's Q](https://github.com/kriskowal/q).
 *
 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
 *
 * # $q constructor
 *
 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
 * function as the first argument. This is similar to the native Promise implementation from ES6,
 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 *
 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
 * available yet.
 *
 * It can be used like so:
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
 *     return $q(function(resolve, reject) {
 *       setTimeout(function() {
 *         if (okToGreet(name)) {
 *           resolve('Hello, ' + name + '!');
 *         } else {
 *           reject('Greeting ' + name + ' is not allowed.');
 *         }
 *       }, 1000);
 *     });
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   });
 * ```
 *
 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
 *
 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
 *
 * However, the more traditional CommonJS-style usage is still available, and documented below.
 *
 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
 * interface for interacting with an object that represents the result of an action that is
 * performed asynchronously, and may or may not be finished at any given point in time.
 *
 * From the perspective of dealing with error handling, deferred and promise APIs are to
 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
 *
 * ```js
 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
 *   // are available in the current lexical scope (they could have been injected or passed in).
 *
 *   function asyncGreet(name) {
 *     var deferred = $q.defer();
 *
 *     setTimeout(function() {
 *       deferred.notify('About to greet ' + name + '.');
 *
 *       if (okToGreet(name)) {
 *         deferred.resolve('Hello, ' + name + '!');
 *       } else {
 *         deferred.reject('Greeting ' + name + ' is not allowed.');
 *       }
 *     }, 1000);
 *
 *     return deferred.promise;
 *   }
 *
 *   var promise = asyncGreet('Robin Hood');
 *   promise.then(function(greeting) {
 *     alert('Success: ' + greeting);
 *   }, function(reason) {
 *     alert('Failed: ' + reason);
 *   }, function(update) {
 *     alert('Got notification: ' + update);
 *   });
 * ```
 *
 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
 * comes in the way of guarantees that promise and deferred APIs make, see
 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
 *
 * Additionally the promise api allows for composition that is very hard to do with the
 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
 * section on serial or parallel joining of promises.
 *
 * # The Deferred API
 *
 * A new instance of deferred is constructed by calling `$q.defer()`.
 *
 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
 * that can be used for signaling the successful or unsuccessful completion, as well as the status
 * of the task.
 *
 * **Methods**
 *
 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
 *   constructed via `$q.reject`, the promise will be rejected instead.
 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
 *   resolving it with a rejection constructed via `$q.reject`.
 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
 *   multiple times before the promise is either resolved or rejected.
 *
 * **Properties**
 *
 * - promise – `{Promise}` – promise object associated with this deferred.
 *
 *
 * # The Promise API
 *
 * A new promise instance is created when a deferred instance is created and can be retrieved by
 * calling `deferred.promise`.
 *
 * The purpose of the promise object is to allow for interested parties to get access to the result
 * of the deferred task when it completes.
 *
 * **Methods**
 *
 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
 *   as soon as the result is available. The callbacks are called with a single argument: the result
 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
 *   provide a progress indication, before the promise is resolved or rejected.
 *
 *   This method *returns a new promise* which is resolved or rejected via the return value of the
 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
 *   with the value which is resolved in that promise using
 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
 *   arguments are optional.
 *
 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
 *
 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
 *   but to do so without modifying the final value. This is useful to release resources or do some
 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
 *   more information.
 *
 * # Chaining promises
 *
 * Because calling the `then` method of a promise returns a new derived promise, it is easily
 * possible to create a chain of promises:
 *
 * ```js
 *   promiseB = promiseA.then(function(result) {
 *     return result + 1;
 *   });
 *
 *   // promiseB will be resolved immediately after promiseA is resolved and its value
 *   // will be the result of promiseA incremented by 1
 * ```
 *
 * It is possible to create chains of any length and since a promise can be resolved with another
 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
 * $http's response interceptors.
 *
 *
 * # Differences between Kris Kowal's Q and $q
 *
 *  There are two main differences:
 *
 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
 *   mechanism in angular, which means faster propagation of resolution or rejection into your
 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
 *   all the important functionality needed for common async tasks.
 *
 * # Testing
 *
 *  ```js
 *    it('should simulate promise', inject(function($q, $rootScope) {
 *      var deferred = $q.defer();
 *      var promise = deferred.promise;
 *      var resolvedValue;
 *
 *      promise.then(function(value) { resolvedValue = value; });
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Simulate resolving of promise
 *      deferred.resolve(123);
 *      // Note that the 'then' function does not get called synchronously.
 *      // This is because we want the promise API to always be async, whether or not
 *      // it got called synchronously or asynchronously.
 *      expect(resolvedValue).toBeUndefined();
 *
 *      // Propagate promise resolution to 'then' functions using $apply().
 *      $rootScope.$apply();
 *      expect(resolvedValue).toEqual(123);
 *    }));
 *  ```
 *
 * @param {function(function, function)} resolver Function which is responsible for resolving or
 *   rejecting the newly created promise. The first parameter is a function which resolves the
 *   promise, the second parameter is a function which rejects the promise.
 *
 * @returns {Promise} The newly created promise.
 */
function $QProvider() {

  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
    return qFactory(function(callback) {
      $rootScope.$evalAsync(callback);
    }, $exceptionHandler);
  }];
}

/** @this */
function $$QProvider() {
  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
    return qFactory(function(callback) {
      $browser.defer(callback);
    }, $exceptionHandler);
  }];
}

/**
 * Constructs a promise manager.
 *
 * @param {function(function)} nextTick Function for executing functions in the next turn.
 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
 *     debugging purposes.
 * @returns {object} Promise manager.
 */
function qFactory(nextTick, exceptionHandler) {
  var $qMinErr = minErr('$q', TypeError);

  /**
   * @ngdoc method
   * @name ng.$q#defer
   * @kind function
   *
   * @description
   * Creates a `Deferred` object which represents a task which will finish in the future.
   *
   * @returns {Deferred} Returns a new instance of deferred.
   */
  function defer() {
    var d = new Deferred();
    //Necessary to support unbound execution :/
    d.resolve = simpleBind(d, d.resolve);
    d.reject = simpleBind(d, d.reject);
    d.notify = simpleBind(d, d.notify);
    return d;
  }

  function Promise() {
    this.$$state = { status: 0 };
  }

  extend(Promise.prototype, {
    then: function(onFulfilled, onRejected, progressBack) {
      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
        return this;
      }
      var result = new Deferred();

      this.$$state.pending = this.$$state.pending || [];
      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

      return result.promise;
    },

    'catch': function(callback) {
      return this.then(null, callback);
    },

    'finally': function(callback, progressBack) {
      return this.then(function(value) {
        return handleCallback(value, resolve, callback);
      }, function(error) {
        return handleCallback(error, reject, callback);
      }, progressBack);
    }
  });

  //Faster, more basic than angular.bind http://jsperf.com/angular-bind-vs-custom-vs-native
  function simpleBind(context, fn) {
    return function(value) {
      fn.call(context, value);
    };
  }

  function processQueue(state) {
    var fn, deferred, pending;

    pending = state.pending;
    state.processScheduled = false;
    state.pending = undefined;
    for (var i = 0, ii = pending.length; i < ii; ++i) {
      deferred = pending[i][0];
      fn = pending[i][state.status];
      try {
        if (isFunction(fn)) {
          deferred.resolve(fn(state.value));
        } else if (state.status === 1) {
          deferred.resolve(state.value);
        } else {
          deferred.reject(state.value);
        }
      } catch (e) {
        deferred.reject(e);
        exceptionHandler(e);
      }
    }
  }

  function scheduleProcessQueue(state) {
    if (state.processScheduled || !state.pending) return;
    state.processScheduled = true;
    nextTick(function() { processQueue(state); });
  }

  function Deferred() {
    this.promise = new Promise();
  }

  extend(Deferred.prototype, {
    resolve: function(val) {
      if (this.promise.$$state.status) return;
      if (val === this.promise) {
        this.$$reject($qMinErr(
          'qcycle',
          'Expected promise to be resolved with value other than itself \'{0}\'',
          val));
      } else {
        this.$$resolve(val);
      }

    },

    $$resolve: function(val) {
      var then;
      var that = this;
      var done = false;
      try {
        if ((isObject(val) || isFunction(val))) then = val && val.then;
        if (isFunction(then)) {
          this.promise.$$state.status = -1;
          then.call(val, resolvePromise, rejectPromise, simpleBind(this, this.notify));
        } else {
          this.promise.$$state.value = val;
          this.promise.$$state.status = 1;
          scheduleProcessQueue(this.promise.$$state);
        }
      } catch (e) {
        rejectPromise(e);
        exceptionHandler(e);
      }

      function resolvePromise(val) {
        if (done) return;
        done = true;
        that.$$resolve(val);
      }
      function rejectPromise(val) {
        if (done) return;
        done = true;
        that.$$reject(val);
      }
    },

    reject: function(reason) {
      if (this.promise.$$state.status) return;
      this.$$reject(reason);
    },

    $$reject: function(reason) {
      this.promise.$$state.value = reason;
      this.promise.$$state.status = 2;
      scheduleProcessQueue(this.promise.$$state);
    },

    notify: function(progress) {
      var callbacks = this.promise.$$state.pending;

      if ((this.promise.$$state.status <= 0) && callbacks && callbacks.length) {
        nextTick(function() {
          var callback, result;
          for (var i = 0, ii = callbacks.length; i < ii; i++) {
            result = callbacks[i][0];
            callback = callbacks[i][3];
            try {
              result.notify(isFunction(callback) ? callback(progress) : progress);
            } catch (e) {
              exceptionHandler(e);
            }
          }
        });
      }
    }
  });

  /**
   * @ngdoc method
   * @name $q#reject
   * @kind function
   *
   * @description
   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
   * a promise chain, you don't need to worry about it.
   *
   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
   * a promise error callback and you want to forward the error to the promise derived from the
   * current promise, you have to "rethrow" the error by returning a rejection constructed via
   * `reject`.
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     // success: do something and resolve promiseB
   *     //          with the old or a new result
   *     return result;
   *   }, function(reason) {
   *     // error: handle the error if possible and
   *     //        resolve promiseB with newPromiseOrValue,
   *     //        otherwise forward the rejection to promiseB
   *     if (canHandle(reason)) {
   *      // handle the error and recover
   *      return newPromiseOrValue;
   *     }
   *     return $q.reject(reason);
   *   });
   * ```
   *
   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
   */
  function reject(reason) {
    var result = new Deferred();
    result.reject(reason);
    return result.promise;
  }

  function handleCallback(value, resolver, callback) {
    var callbackOutput = null;
    try {
      if (isFunction(callback)) callbackOutput = callback();
    } catch (e) {
      return reject(e);
    }
    if (isPromiseLike(callbackOutput)) {
      return callbackOutput.then(function() {
        return resolver(value);
      }, reject);
    } else {
      return resolver(value);
    }
  }

  /**
   * @ngdoc method
   * @name $q#when
   * @kind function
   *
   * @description
   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
   * This is useful when you are dealing with an object that might or might not be a promise, or if
   * the promise comes from a source that can't be trusted.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */


  function when(value, callback, errback, progressBack) {
    var result = new Deferred();
    result.resolve(value);
    return result.promise.then(callback, errback, progressBack);
  }

  /**
   * @ngdoc method
   * @name $q#resolve
   * @kind function
   *
   * @description
   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
   *
   * @param {*} value Value or a promise
   * @param {Function=} successCallback
   * @param {Function=} errorCallback
   * @param {Function=} progressCallback
   * @returns {Promise} Returns a promise of the passed value or promise
   */
  var resolve = when;

  /**
   * @ngdoc method
   * @name $q#all
   * @kind function
   *
   * @description
   * Combines multiple promises into a single promise that is resolved when all of the input
   * promises are resolved.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
   *   with the same rejection value.
   */

  function all(promises) {
    var deferred = new Deferred(),
        counter = 0,
        results = isArray(promises) ? [] : {};

    forEach(promises, function(promise, key) {
      counter++;
      when(promise).then(function(value) {
        results[key] = value;
        if (!(--counter)) deferred.resolve(results);
      }, function(reason) {
        deferred.reject(reason);
      });
    });

    if (counter === 0) {
      deferred.resolve(results);
    }

    return deferred.promise;
  }

  /**
   * @ngdoc method
   * @name $q#race
   * @kind function
   *
   * @description
   * Returns a promise that resolves or rejects as soon as one of those promises
   * resolves or rejects, with the value or reason from that promise.
   *
   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
   * resolves or rejects, with the value or reason from that promise.
   */

  function race(promises) {
    var deferred = defer();

    forEach(promises, function(promise) {
      when(promise).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise;
  }

  function $Q(resolver) {
    if (!isFunction(resolver)) {
      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
    }

    var deferred = new Deferred();

    function resolveFn(value) {
      deferred.resolve(value);
    }

    function rejectFn(reason) {
      deferred.reject(reason);
    }

    resolver(resolveFn, rejectFn);

    return deferred.promise;
  }

  // Let's make the instanceof operator work for promises, so that
  // `new $q(fn) instanceof $q` would evaluate to true.
  $Q.prototype = Promise.prototype;

  $Q.defer = defer;
  $Q.reject = reject;
  $Q.when = when;
  $Q.resolve = resolve;
  $Q.all = all;
  $Q.race = race;

  return $Q;
}

/** @this */
function $$RAFProvider() { //rAF
  this.$get = ['$window', '$timeout', function($window, $timeout) {
    var requestAnimationFrame = $window.requestAnimationFrame ||
                                $window.webkitRequestAnimationFrame;

    var cancelAnimationFrame = $window.cancelAnimationFrame ||
                               $window.webkitCancelAnimationFrame ||
                               $window.webkitCancelRequestAnimationFrame;

    var rafSupported = !!requestAnimationFrame;
    var raf = rafSupported
      ? function(fn) {
          var id = requestAnimationFrame(fn);
          return function() {
            cancelAnimationFrame(id);
          };
        }
      : function(fn) {
          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
          return function() {
            $timeout.cancel(timer);
          };
        };

    raf.supported = rafSupported;

    return raf;
  }];
}

/**
 * DESIGN NOTES
 *
 * The design decisions behind the scope are heavily favored for speed and memory consumption.
 *
 * The typical use of scope is to watch the expressions, which most of the time return the same
 * value as last time so we optimize the operation.
 *
 * Closures construction is expensive in terms of speed as well as memory:
 *   - No closures, instead use prototypical inheritance for API
 *   - Internal state needs to be stored on scope directly, which means that private state is
 *     exposed as $$____ properties
 *
 * Loop operations are optimized by using while(count--) { ... }
 *   - This means that in order to keep the same order of execution as addition we have to add
 *     items to the array at the beginning (unshift) instead of at the end (push)
 *
 * Child scopes are created and removed often
 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
 *
 * There are fewer watches than observers. This is why you don't want the observer to be implemented
 * in the same way as watch. Watch requires return of the initialization function which is expensive
 * to construct.
 */


/**
 * @ngdoc provider
 * @name $rootScopeProvider
 * @description
 *
 * Provider for the $rootScope service.
 */

/**
 * @ngdoc method
 * @name $rootScopeProvider#digestTtl
 * @description
 *
 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
 * assuming that the model is unstable.
 *
 * The current default is 10 iterations.
 *
 * In complex applications it's possible that the dependencies between `$watch`s will result in
 * several digest iterations. However if an application needs more than the default 10 digest
 * iterations for its model to stabilize then you should investigate what is causing the model to
 * continuously change during the digest.
 *
 * Increasing the TTL could have performance implications, so you should not change it without
 * proper justification.
 *
 * @param {number} limit The number of digest iterations.
 */


/**
 * @ngdoc service
 * @name $rootScope
 * @this
 *
 * @description
 *
 * Every application has a single root {@link ng.$rootScope.Scope scope}.
 * All other scopes are descendant scopes of the root scope. Scopes provide separation
 * between the model and the view, via a mechanism for watching the model for changes.
 * They also provide event emission/broadcast and subscription facility. See the
 * {@link guide/scope developer guide on scopes}.
 */
function $RootScopeProvider() {
  var TTL = 10;
  var $rootScopeMinErr = minErr('$rootScope');
  var lastDirtyWatch = null;
  var applyAsyncId = null;

  this.digestTtl = function(value) {
    if (arguments.length) {
      TTL = value;
    }
    return TTL;
  };

  function createChildScopeClass(parent) {
    function ChildScope() {
      this.$$watchers = this.$$nextSibling =
          this.$$childHead = this.$$childTail = null;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$id = nextUid();
      this.$$ChildScope = null;
    }
    ChildScope.prototype = parent;
    return ChildScope;
  }

  this.$get = ['$exceptionHandler', '$parse', '$browser',
      function($exceptionHandler, $parse, $browser) {

    function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
    }

    function cleanUpScope($scope) {

      if (msie === 9) {
        // There is a memory leak in IE9 if all child scopes are not disconnected
        // completely when a scope is destroyed. So this code will recurse up through
        // all this scopes children
        //
        // See issue https://github.com/angular/angular.js/issues/10706
        if ($scope.$$childHead) {
          cleanUpScope($scope.$$childHead);
        }
        if ($scope.$$nextSibling) {
          cleanUpScope($scope.$$nextSibling);
        }
      }

      // The code below works around IE9 and V8's memory leaks
      //
      // See:
      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
    }

    /**
     * @ngdoc type
     * @name $rootScope.Scope
     *
     * @description
     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
     * {@link auto.$injector $injector}. Child scopes are created using the
     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
     * an in-depth introduction and usage examples.
     *
     *
     * # Inheritance
     * A scope can inherit from a parent scope, as in this example:
     * ```js
         var parent = $rootScope;
         var child = parent.$new();

         parent.salutation = "Hello";
         expect(child.salutation).toEqual('Hello');

         child.salutation = "Welcome";
         expect(child.salutation).toEqual('Welcome');
         expect(parent.salutation).toEqual('Hello');
     * ```
     *
     * When interacting with `Scope` in tests, additional helper methods are available on the
     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
     * details.
     *
     *
     * @param {Object.<string, function()>=} providers Map of service factory which need to be
     *                                       provided for the current scope. Defaults to {@link ng}.
     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
     *                              append/override services provided by `providers`. This is handy
     *                              when unit-testing and having the need to override a default
     *                              service.
     * @returns {Object} Newly created scope.
     *
     */
    function Scope() {
      this.$id = nextUid();
      this.$$phase = this.$parent = this.$$watchers =
                     this.$$nextSibling = this.$$prevSibling =
                     this.$$childHead = this.$$childTail = null;
      this.$root = this;
      this.$$destroyed = false;
      this.$$listeners = {};
      this.$$listenerCount = {};
      this.$$watchersCount = 0;
      this.$$isolateBindings = null;
    }

    /**
     * @ngdoc property
     * @name $rootScope.Scope#$id
     *
     * @description
     * Unique scope ID (monotonically increasing) useful for debugging.
     */

     /**
      * @ngdoc property
      * @name $rootScope.Scope#$parent
      *
      * @description
      * Reference to the parent scope.
      */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

    Scope.prototype = {
      constructor: Scope,
      /**
       * @ngdoc method
       * @name $rootScope.Scope#$new
       * @kind function
       *
       * @description
       * Creates a new child {@link ng.$rootScope.Scope scope}.
       *
       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
       *
       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
       * desired for the scope and its child scopes to be permanently detached from the parent and
       * thus stop participating in model change detection and listener notification by invoking.
       *
       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
       *         parent scope. The scope is isolated, as it can not see parent scope properties.
       *         When creating widgets, it is useful for the widget to not accidentally read parent
       *         state.
       *
       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
       *                              of the newly created scope. Defaults to `this` scope if not provided.
       *                              This is used when creating a transclude scope to correctly place it
       *                              in the scope hierarchy while maintaining the correct prototypical
       *                              inheritance.
       *
       * @returns {Object} The newly created child scope.
       *
       */
      $new: function(isolate, parent) {
        var child;

        parent = parent || this;

        if (isolate) {
          child = new Scope();
          child.$root = this.$root;
        } else {
          // Only create a child scope class if somebody asks for one,
          // but cache it to allow the VM to optimize lookups.
          if (!this.$$ChildScope) {
            this.$$ChildScope = createChildScopeClass(this);
          }
          child = new this.$$ChildScope();
        }
        child.$parent = parent;
        child.$$prevSibling = parent.$$childTail;
        if (parent.$$childHead) {
          parent.$$childTail.$$nextSibling = child;
          parent.$$childTail = child;
        } else {
          parent.$$childHead = parent.$$childTail = child;
        }

        // When the new scope is not isolated or we inherit from `this`, and
        // the parent scope is destroyed, the property `$$destroyed` is inherited
        // prototypically. In all other cases, this property needs to be set
        // when the parent scope is destroyed.
        // The listener needs to be added after the parent is set
        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

        return child;
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watch
       * @kind function
       *
       * @description
       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
       *
       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
       *   its value when executed multiple times with the same input because it may be executed multiple
       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
       * - The `listener` is called only when the value from the current `watchExpression` and the
       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
       *   see below). Inequality is determined according to reference inequality,
       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
       *    via the `!==` Javascript operator, unless `objectEquality == true`
       *   (see next point)
       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
       *   according to the {@link angular.equals} function. To save the value of the object for
       *   later comparison, the {@link angular.copy} function is used. This therefore means that
       *   watching complex objects will have adverse memory and performance implications.
       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
       *   iteration limit is 10 to prevent an infinite loop deadlock.
       *
       *
       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
       * you can register a `watchExpression` function with no `listener`. (Be prepared for
       * multiple calls to your `watchExpression` because it will execute multiple times in a
       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
       *
       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
       * watcher. In rare cases, this is undesirable because the listener is called when the result
       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
       * listener was called due to initialization.
       *
       *
       *
       * # Example
       * ```js
           // let's assume that scope was dependency injected as the $rootScope
           var scope = $rootScope;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);



           // Using a function as a watchExpression
           var food;
           scope.foodCounter = 0;
           expect(scope.foodCounter).toEqual(0);
           scope.$watch(
             // This function returns the value being watched. It is called for each turn of the $digest loop
             function() { return food; },
             // This is the change listener, called when the value returned from the above function changes
             function(newValue, oldValue) {
               if ( newValue !== oldValue ) {
                 // Only increment the counter if the value changed
                 scope.foodCounter = scope.foodCounter + 1;
               }
             }
           );
           // No digest has been run so the counter will be zero
           expect(scope.foodCounter).toEqual(0);

           // Run the digest but since food has not changed count will still be zero
           scope.$digest();
           expect(scope.foodCounter).toEqual(0);

           // Update food and run digest.  Now the counter will increment
           food = 'cheeseburger';
           scope.$digest();
           expect(scope.foodCounter).toEqual(1);

       * ```
       *
       *
       *
       * @param {(function()|string)} watchExpression Expression that is evaluated on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
       *    a call to the `listener`.
       *
       *    - `string`: Evaluated as {@link guide/expression expression}
       *    - `function(scope)`: called with current `scope` as a parameter.
       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
       *    of `watchExpression` changes.
       *
       *    - `newVal` contains the current value of the `watchExpression`
       *    - `oldVal` contains the previous value of the `watchExpression`
       *    - `scope` refers to the current scope
       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
       *     comparing for reference equality.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
        var get = $parse(watchExp);

        if (get.$$watchDelegate) {
          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
        }
        var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: listener,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };

        lastDirtyWatch = null;

        if (!isFunction(listener)) {
          watcher.fn = noop;
        }

        if (!array) {
          array = scope.$$watchers = [];
          array.$$digestWatchIndex = -1;
        }
        // we use unshift since we use a while loop in $digest for speed.
        // the while loop reads in reverse order.
        array.unshift(watcher);
        array.$$digestWatchIndex++;
        incrementWatchersCount(this, 1);

        return function deregisterWatch() {
          var index = arrayRemove(array, watcher);
          if (index >= 0) {
            incrementWatchersCount(scope, -1);
            if (index < array.$$digestWatchIndex) {
              array.$$digestWatchIndex--;
            }
          }
          lastDirtyWatch = null;
        };
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchGroup
       * @kind function
       *
       * @description
       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
       * If any one expression in the collection changes the `listener` is executed.
       *
       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
       *   values are examined for changes on every call to `$digest`.
       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
       *
       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
       *
       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
       *    expression in `watchExpressions` changes
       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
       *    those of `watchExpression`
       *    The `scope` refers to the current scope.
       * @returns {function()} Returns a de-registration function for all listeners.
       */
      $watchGroup: function(watchExpressions, listener) {
        var oldValues = new Array(watchExpressions.length);
        var newValues = new Array(watchExpressions.length);
        var deregisterFns = [];
        var self = this;
        var changeReactionScheduled = false;
        var firstRun = true;

        if (!watchExpressions.length) {
          // No expressions means we call the listener ASAP
          var shouldCall = true;
          self.$evalAsync(function() {
            if (shouldCall) listener(newValues, newValues, self);
          });
          return function deregisterWatchGroup() {
            shouldCall = false;
          };
        }

        if (watchExpressions.length === 1) {
          // Special case size of one
          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
            newValues[0] = value;
            oldValues[0] = oldValue;
            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
          });
        }

        forEach(watchExpressions, function(expr, i) {
          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
            newValues[i] = value;
            oldValues[i] = oldValue;
            if (!changeReactionScheduled) {
              changeReactionScheduled = true;
              self.$evalAsync(watchGroupAction);
            }
          });
          deregisterFns.push(unwatchFn);
        });

        function watchGroupAction() {
          changeReactionScheduled = false;

          if (firstRun) {
            firstRun = false;
            listener(newValues, newValues, self);
          } else {
            listener(newValues, oldValues, self);
          }
        }

        return function deregisterWatchGroup() {
          while (deregisterFns.length) {
            deregisterFns.shift()();
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$watchCollection
       * @kind function
       *
       * @description
       * Shallow watches the properties of an object and fires whenever any of the properties change
       * (for arrays, this implies watching the array items; for object maps, this implies watching
       * the properties). If a change is detected, the `listener` callback is fired.
       *
       * - The `obj` collection is observed via standard $watch operation and is examined on every
       *   call to $digest() to see if any items have been added, removed, or moved.
       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
       *   adding, removing, and moving items belonging to an object or array.
       *
       *
       * # Example
       * ```js
          $scope.names = ['igor', 'matias', 'misko', 'james'];
          $scope.dataCount = 4;

          $scope.$watchCollection('names', function(newNames, oldNames) {
            $scope.dataCount = newNames.length;
          });

          expect($scope.dataCount).toEqual(4);
          $scope.$digest();

          //still at 4 ... no changes
          expect($scope.dataCount).toEqual(4);

          $scope.names.pop();
          $scope.$digest();

          //now there's been a change
          expect($scope.dataCount).toEqual(3);
       * ```
       *
       *
       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
       *    expression value should evaluate to an object or an array which is observed on each
       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
       *    collection will trigger a call to the `listener`.
       *
       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
       *    when a change is detected.
       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
       *    - The `oldCollection` object is a copy of the former collection data.
       *      Due to performance considerations, the`oldCollection` value is computed only if the
       *      `listener` function declares two or more arguments.
       *    - The `scope` argument refers to the current scope.
       *
       * @returns {function()} Returns a de-registration function for this listener. When the
       *    de-registration function is executed, the internal watch operation is terminated.
       */
      $watchCollection: function(obj, listener) {
        $watchCollectionInterceptor.$stateful = true;

        var self = this;
        // the current value, updated on each dirty-check run
        var newValue;
        // a shallow copy of the newValue from the last dirty-check run,
        // updated to match newValue during dirty-check run
        var oldValue;
        // a shallow copy of the newValue from when the last change happened
        var veryOldValue;
        // only track veryOldValue if the listener is asking for it
        var trackVeryOldValue = (listener.length > 1);
        var changeDetected = 0;
        var changeDetector = $parse(obj, $watchCollectionInterceptor);
        var internalArray = [];
        var internalObject = {};
        var initRun = true;
        var oldLength = 0;

        function $watchCollectionInterceptor(_value) {
          newValue = _value;
          var newLength, key, bothNaN, newItem, oldItem;

          // If the new value is undefined, then return undefined as the watch may be a one-time watch
          if (isUndefined(newValue)) return;

          if (!isObject(newValue)) { // if primitive
            if (oldValue !== newValue) {
              oldValue = newValue;
              changeDetected++;
            }
          } else if (isArrayLike(newValue)) {
            if (oldValue !== internalArray) {
              // we are transitioning from something which was not an array into array.
              oldValue = internalArray;
              oldLength = oldValue.length = 0;
              changeDetected++;
            }

            newLength = newValue.length;

            if (oldLength !== newLength) {
              // if lengths do not match we need to trigger change notification
              changeDetected++;
              oldValue.length = oldLength = newLength;
            }
            // copy the items to oldValue and look for changes.
            for (var i = 0; i < newLength; i++) {
              oldItem = oldValue[i];
              newItem = newValue[i];

              // eslint-disable-next-line no-self-compare
              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
              if (!bothNaN && (oldItem !== newItem)) {
                changeDetected++;
                oldValue[i] = newItem;
              }
            }
          } else {
            if (oldValue !== internalObject) {
              // we are transitioning from something which was not an object into object.
              oldValue = internalObject = {};
              oldLength = 0;
              changeDetected++;
            }
            // copy the items to oldValue and look for changes.
            newLength = 0;
            for (key in newValue) {
              if (hasOwnProperty.call(newValue, key)) {
                newLength++;
                newItem = newValue[key];
                oldItem = oldValue[key];

                if (key in oldValue) {
                  // eslint-disable-next-line no-self-compare
                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
                  if (!bothNaN && (oldItem !== newItem)) {
                    changeDetected++;
                    oldValue[key] = newItem;
                  }
                } else {
                  oldLength++;
                  oldValue[key] = newItem;
                  changeDetected++;
                }
              }
            }
            if (oldLength > newLength) {
              // we used to have more keys, need to find them and destroy them.
              changeDetected++;
              for (key in oldValue) {
                if (!hasOwnProperty.call(newValue, key)) {
                  oldLength--;
                  delete oldValue[key];
                }
              }
            }
          }
          return changeDetected;
        }

        function $watchCollectionAction() {
          if (initRun) {
            initRun = false;
            listener(newValue, newValue, self);
          } else {
            listener(newValue, veryOldValue, self);
          }

          // make a copy for the next time a collection is changed
          if (trackVeryOldValue) {
            if (!isObject(newValue)) {
              //primitive
              veryOldValue = newValue;
            } else if (isArrayLike(newValue)) {
              veryOldValue = new Array(newValue.length);
              for (var i = 0; i < newValue.length; i++) {
                veryOldValue[i] = newValue[i];
              }
            } else { // if object
              veryOldValue = {};
              for (var key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  veryOldValue[key] = newValue[key];
                }
              }
            }
          }
        }

        return this.$watch(changeDetector, $watchCollectionAction);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$digest
       * @kind function
       *
       * @description
       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
       * until no more listeners are firing. This means that it is possible to get into an infinite
       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
       * iterations exceeds 10.
       *
       * Usually, you don't call `$digest()` directly in
       * {@link ng.directive:ngController controllers} or in
       * {@link ng.$compileProvider#directive directives}.
       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
       *
       * If you want to be notified whenever `$digest()` is called,
       * you can register a `watchExpression` function with
       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
       *
       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
       *
       * # Example
       * ```js
           var scope = ...;
           scope.name = 'misko';
           scope.counter = 0;

           expect(scope.counter).toEqual(0);
           scope.$watch('name', function(newValue, oldValue) {
             scope.counter = scope.counter + 1;
           });
           expect(scope.counter).toEqual(0);

           scope.$digest();
           // the listener is always called during the first $digest loop after it was registered
           expect(scope.counter).toEqual(1);

           scope.$digest();
           // but now it will not be called unless the value changes
           expect(scope.counter).toEqual(1);

           scope.name = 'adam';
           scope.$digest();
           expect(scope.counter).toEqual(2);
       * ```
       *
       */
      $digest: function() {
        var watch, value, last, fn, get,
            watchers,
            dirty, ttl = TTL,
            next, current, target = this,
            watchLog = [],
            logIdx, asyncTask;

        beginPhase('$digest');
        // Check for changes to browser url that happened in sync before the call to $digest
        $browser.$$checkUrlChange();

        if (this === $rootScope && applyAsyncId !== null) {
          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
          $browser.defer.cancel(applyAsyncId);
          flushApplyAsync();
        }

        lastDirtyWatch = null;

        do { // "while dirty" loop
          dirty = false;
          current = target;

          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
          // be reentered recursively. Calling $digest from a function passed to $applyAsync would
          // lead to a '$digest already in progress' error.
          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
            try {
              asyncTask = asyncQueue[asyncQueuePosition];
              asyncTask.scope.$eval(asyncTask.expression, asyncTask.locals);
            } catch (e) {
              $exceptionHandler(e);
            }
            lastDirtyWatch = null;
          }
          asyncQueue.length = 0;

          traverseScopesLoop:
          do { // "traverse the scopes" loop
            if ((watchers = current.$$watchers)) {
              // process our watches
              watchers.$$digestWatchIndex = watchers.length;
              while (watchers.$$digestWatchIndex--) {
                try {
                  watch = watchers[watchers.$$digestWatchIndex];
                  // Most common watches are on primitives, in which case we can short
                  // circuit it with === operator, only when === fails do we use .equals
                  if (watch) {
                    get = watch.get;
                    if ((value = get(current)) !== (last = watch.last) &&
                        !(watch.eq
                            ? equals(value, last)
                            : (isNumberNaN(value) && isNumberNaN(last)))) {
                      dirty = true;
                      lastDirtyWatch = watch;
                      watch.last = watch.eq ? copy(value, null) : value;
                      fn = watch.fn;
                      fn(value, ((last === initWatchVal) ? value : last), current);
                      if (ttl < 5) {
                        logIdx = 4 - ttl;
                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
                        watchLog[logIdx].push({
                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                          newVal: value,
                          oldVal: last
                        });
                      }
                    } else if (watch === lastDirtyWatch) {
                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                      // have already been tested.
                      dirty = false;
                      break traverseScopesLoop;
                    }
                  }
                } catch (e) {
                  $exceptionHandler(e);
                }
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $broadcast
            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
                (current !== target && current.$$nextSibling)))) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          } while ((current = next));

          // `break traverseScopesLoop;` takes us to here

          if ((dirty || asyncQueue.length) && !(ttl--)) {
            clearPhase();
            throw $rootScopeMinErr('infdig',
                '{0} $digest() iterations reached. Aborting!\n' +
                'Watchers fired in the last 5 iterations: {1}',
                TTL, watchLog);
          }

        } while (dirty || asyncQueue.length);

        clearPhase();

        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
        while (postDigestQueuePosition < postDigestQueue.length) {
          try {
            postDigestQueue[postDigestQueuePosition++]();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        postDigestQueue.length = postDigestQueuePosition = 0;
      },


      /**
       * @ngdoc event
       * @name $rootScope.Scope#$destroy
       * @eventType broadcast on scope being destroyed
       *
       * @description
       * Broadcasted when a scope and its children are being destroyed.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$destroy
       * @kind function
       *
       * @description
       * Removes the current scope (and all of its children) from the parent scope. Removal implies
       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
       * propagate to the current scope and its children. Removal also implies that the current
       * scope is eligible for garbage collection.
       *
       * The `$destroy()` is usually used by directives such as
       * {@link ng.directive:ngRepeat ngRepeat} for managing the
       * unrolling of the loop.
       *
       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
       * Application code can register a `$destroy` event handler that will give it a chance to
       * perform any necessary cleanup.
       *
       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
       * clean up DOM bindings before an element is removed from the DOM.
       */
      $destroy: function() {
        // We can't destroy a scope that has been already destroyed.
        if (this.$$destroyed) return;
        var parent = this.$parent;

        this.$broadcast('$destroy');
        this.$$destroyed = true;

        if (this === $rootScope) {
          //Remove handlers attached to window when $rootScope is removed
          $browser.$$applicationDestroyed();
        }

        incrementWatchersCount(this, -this.$$watchersCount);
        for (var eventName in this.$$listenerCount) {
          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
        }

        // sever all the references to parent scopes (after this cleanup, the current scope should
        // not be retained by any of our references and should be eligible for garbage collection)
        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

        // Disable listeners, watchers and apply/digest methods
        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
        this.$$listeners = {};

        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
        this.$$nextSibling = null;
        cleanUpScope(this);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$eval
       * @kind function
       *
       * @description
       * Executes the `expression` on the current scope and returns the result. Any exceptions in
       * the expression are propagated (uncaught). This is useful when evaluating Angular
       * expressions.
       *
       * # Example
       * ```js
           var scope = ng.$rootScope.Scope();
           scope.a = 1;
           scope.b = 2;

           expect(scope.$eval('a+b')).toEqual(3);
           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
       * ```
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       * @returns {*} The result of evaluating the expression.
       */
      $eval: function(expr, locals) {
        return $parse(expr)(this, locals);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$evalAsync
       * @kind function
       *
       * @description
       * Executes the expression on the current scope at a later point in time.
       *
       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
       * that:
       *
       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
       *     rendering).
       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
       *     `expression` execution.
       *
       * Any exceptions from the execution of the expression are forwarded to the
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
       * will be scheduled. However, it is encouraged to always call code that changes the model
       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
       *
       * @param {(string|function())=} expression An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with the current `scope` parameter.
       *
       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
       */
      $evalAsync: function(expr, locals) {
        // if we are outside of an $digest loop and this is the first time we are scheduling async
        // task also schedule async auto-flush
        if (!$rootScope.$$phase && !asyncQueue.length) {
          $browser.defer(function() {
            if (asyncQueue.length) {
              $rootScope.$digest();
            }
          });
        }

        asyncQueue.push({scope: this, expression: $parse(expr), locals: locals});
      },

      $$postDigest: function(fn) {
        postDigestQueue.push(fn);
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$apply
       * @kind function
       *
       * @description
       * `$apply()` is used to execute an expression in angular from outside of the angular
       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
       * Because we are calling into the angular framework we need to perform proper scope life
       * cycle of {@link ng.$exceptionHandler exception handling},
       * {@link ng.$rootScope.Scope#$digest executing watches}.
       *
       * ## Life cycle
       *
       * # Pseudo-Code of `$apply()`
       * ```js
           function $apply(expr) {
             try {
               return $eval(expr);
             } catch (e) {
               $exceptionHandler(e);
             } finally {
               $root.$digest();
             }
           }
       * ```
       *
       *
       * Scope's `$apply()` method transitions through the following stages:
       *
       * 1. The {@link guide/expression expression} is executed using the
       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
       * 2. Any exceptions from the execution of the expression are forwarded to the
       *    {@link ng.$exceptionHandler $exceptionHandler} service.
       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
       *
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       *
       * @returns {*} The result of evaluating the expression.
       */
      $apply: function(expr) {
        try {
          beginPhase('$apply');
          try {
            return this.$eval(expr);
          } finally {
            clearPhase();
          }
        } catch (e) {
          $exceptionHandler(e);
        } finally {
          try {
            $rootScope.$digest();
          } catch (e) {
            $exceptionHandler(e);
            // eslint-disable-next-line no-unsafe-finally
            throw e;
          }
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$applyAsync
       * @kind function
       *
       * @description
       * Schedule the invocation of $apply to occur at a later time. The actual time difference
       * varies across browsers, but is typically around ~10 milliseconds.
       *
       * This can be used to queue up multiple expressions which need to be evaluated in the same
       * digest.
       *
       * @param {(string|function())=} exp An angular expression to be executed.
       *
       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
       *    - `function(scope)`: execute the function with current `scope` parameter.
       */
      $applyAsync: function(expr) {
        var scope = this;
        if (expr) {
          applyAsyncQueue.push($applyAsyncExpression);
        }
        expr = $parse(expr);
        scheduleApplyAsync();

        function $applyAsyncExpression() {
          scope.$eval(expr);
        }
      },

      /**
       * @ngdoc method
       * @name $rootScope.Scope#$on
       * @kind function
       *
       * @description
       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
       * discussion of event life cycle.
       *
       * The event listener function format is: `function(event, args...)`. The `event` object
       * passed into the listener has the following attributes:
       *
       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
       *     `$broadcast`-ed.
       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
       *     event propagates through the scope hierarchy, this property is set to null.
       *   - `name` - `{string}`: name of the event.
       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
       *     further event propagation (available only for events that were `$emit`-ed).
       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
       *     to true.
       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
       *
       * @param {string} name Event name to listen on.
       * @param {function(event, ...args)} listener Function to call when the event is emitted.
       * @returns {function()} Returns a deregistration function for this listener.
       */
      $on: function(name, listener) {
        var namedListeners = this.$$listeners[name];
        if (!namedListeners) {
          this.$$listeners[name] = namedListeners = [];
        }
        namedListeners.push(listener);

        var current = this;
        do {
          if (!current.$$listenerCount[name]) {
            current.$$listenerCount[name] = 0;
          }
          current.$$listenerCount[name]++;
        } while ((current = current.$parent));

        var self = this;
        return function() {
          var indexOfListener = namedListeners.indexOf(listener);
          if (indexOfListener !== -1) {
            namedListeners[indexOfListener] = null;
            decrementListenerCount(self, 1, name);
          }
        };
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$emit
       * @kind function
       *
       * @description
       * Dispatches an event `name` upwards through the scope hierarchy notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$emit` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
       * registered listeners along the way. The event will stop propagating if one of the listeners
       * cancels it.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to emit.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
       */
      $emit: function(name, args) {
        var empty = [],
            namedListeners,
            scope = this,
            stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function() {stopPropagation = true;},
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i, length;

        do {
          namedListeners = scope.$$listeners[name] || empty;
          event.currentScope = scope;
          for (i = 0, length = namedListeners.length; i < length; i++) {

            // if listeners were deregistered, defragment the array
            if (!namedListeners[i]) {
              namedListeners.splice(i, 1);
              i--;
              length--;
              continue;
            }
            try {
              //allow all listeners attached to the current scope to run
              namedListeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          //if any listener on the current scope stops propagation, prevent bubbling
          if (stopPropagation) {
            event.currentScope = null;
            return event;
          }
          //traverse upwards
          scope = scope.$parent;
        } while (scope);

        event.currentScope = null;

        return event;
      },


      /**
       * @ngdoc method
       * @name $rootScope.Scope#$broadcast
       * @kind function
       *
       * @description
       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
       * registered {@link ng.$rootScope.Scope#$on} listeners.
       *
       * The event life cycle starts at the scope on which `$broadcast` was called. All
       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
       * scope and calls all registered listeners along the way. The event cannot be canceled.
       *
       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * @param {string} name Event name to broadcast.
       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
       */
      $broadcast: function(name, args) {
        var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };

        if (!target.$$listenerCount[name]) return event;

        var listenerArgs = concat([event], arguments, 1),
            listeners, i, length;

        //down while you can, then up and next sibling or up and next sibling until back at root
        while ((current = next)) {
          event.currentScope = current;
          listeners = current.$$listeners[name] || [];
          for (i = 0, length = listeners.length; i < length; i++) {
            // if listeners were deregistered, defragment the array
            if (!listeners[i]) {
              listeners.splice(i, 1);
              i--;
              length--;
              continue;
            }

            try {
              listeners[i].apply(null, listenerArgs);
            } catch (e) {
              $exceptionHandler(e);
            }
          }

          // Insanity Warning: scope depth-first traversal
          // yes, this code is a bit crazy, but it works and we have tests to prove it!
          // this piece should be kept in sync with the traversal in $digest
          // (though it differs due to having the extra check for $$listenerCount)
          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
              (current !== target && current.$$nextSibling)))) {
            while (current !== target && !(next = current.$$nextSibling)) {
              current = current.$parent;
            }
          }
        }

        event.currentScope = null;
        return event;
      }
    };

    var $rootScope = new Scope();

    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
    var asyncQueue = $rootScope.$$asyncQueue = [];
    var postDigestQueue = $rootScope.$$postDigestQueue = [];
    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

    var postDigestQueuePosition = 0;

    return $rootScope;


    function beginPhase(phase) {
      if ($rootScope.$$phase) {
        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
      }

      $rootScope.$$phase = phase;
    }

    function clearPhase() {
      $rootScope.$$phase = null;
    }

    function incrementWatchersCount(current, count) {
      do {
        current.$$watchersCount += count;
      } while ((current = current.$parent));
    }

    function decrementListenerCount(current, count, name) {
      do {
        current.$$listenerCount[name] -= count;

        if (current.$$listenerCount[name] === 0) {
          delete current.$$listenerCount[name];
        }
      } while ((current = current.$parent));
    }

    /**
     * function used as an initial value for watchers.
     * because it's unique we can easily tell it apart from other values
     */
    function initWatchVal() {}

    function flushApplyAsync() {
      while (applyAsyncQueue.length) {
        try {
          applyAsyncQueue.shift()();
        } catch (e) {
          $exceptionHandler(e);
        }
      }
      applyAsyncId = null;
    }

    function scheduleApplyAsync() {
      if (applyAsyncId === null) {
        applyAsyncId = $browser.defer(function() {
          $rootScope.$apply(flushApplyAsync);
        });
      }
    }
  }];
}

/**
 * @ngdoc service
 * @name $rootElement
 *
 * @description
 * The root element of Angular application. This is either the element where {@link
 * ng.directive:ngApp ngApp} was declared or the element passed into
 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
 * location where the application's {@link auto.$injector $injector} service gets
 * published, and can be retrieved using `$rootElement.injector()`.
 */


// the implementation is in angular.bootstrap

/**
 * @this
 * @description
 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
 */
function $$SanitizeUriProvider() {
  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during a[href] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.aHrefSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      aHrefSanitizationWhitelist = regexp;
      return this;
    }
    return aHrefSanitizationWhitelist;
  };


  /**
   * @description
   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
   * urls during img[src] sanitization.
   *
   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
   *
   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
   *
   * @param {RegExp=} regexp New regexp to whitelist urls with.
   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
   *    chaining otherwise.
   */
  this.imgSrcSanitizationWhitelist = function(regexp) {
    if (isDefined(regexp)) {
      imgSrcSanitizationWhitelist = regexp;
      return this;
    }
    return imgSrcSanitizationWhitelist;
  };

  this.$get = function() {
    return function sanitizeUri(uri, isImage) {
      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
      var normalizedVal;
      normalizedVal = urlResolve(uri).href;
      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
        return 'unsafe:' + normalizedVal;
      }
      return uri;
    };
  };
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *     Any commits to this file should be reviewed with security in mind.  *
 *   Changes to this file can potentially create security vulnerabilities. *
 *          An approval from 2 Core members with history of modifying      *
 *                         this file is required.                          *
 *                                                                         *
 *  Does the change somehow allow for arbitrary javascript to be executed? *
 *    Or allows for someone to change the prototype of built-in objects?   *
 *     Or gives undesired access to variables likes document or window?    *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

/* exported $SceProvider, $SceDelegateProvider */

var $sceMinErr = minErr('$sce');

var SCE_CONTEXTS = {
  HTML: 'html',
  CSS: 'css',
  URL: 'url',
  // RESOURCE_URL is a subtype of URL used in contexts where a privileged resource is sourced from a
  // url.  (e.g. ng-include, script src, templateUrl)
  RESOURCE_URL: 'resourceUrl',
  JS: 'js'
};

// Helper functions follow.

function adjustMatcher(matcher) {
  if (matcher === 'self') {
    return matcher;
  } else if (isString(matcher)) {
    // Strings match exactly except for 2 wildcards - '*' and '**'.
    // '*' matches any character except those from the set ':/.?&'.
    // '**' matches any character (like .* in a RegExp).
    // More than 2 *'s raises an error as it's ill defined.
    if (matcher.indexOf('***') > -1) {
      throw $sceMinErr('iwcard',
          'Illegal sequence *** in string matcher.  String: {0}', matcher);
    }
    matcher = escapeForRegexp(matcher).
                  replace(/\\\*\\\*/g, '.*').
                  replace(/\\\*/g, '[^:/.?&;]*');
    return new RegExp('^' + matcher + '$');
  } else if (isRegExp(matcher)) {
    // The only other type of matcher allowed is a Regexp.
    // Match entire URL / disallow partial matches.
    // Flags are reset (i.e. no global, ignoreCase or multiline)
    return new RegExp('^' + matcher.source + '$');
  } else {
    throw $sceMinErr('imatcher',
        'Matchers may only be "self", string patterns or RegExp objects');
  }
}


function adjustMatchers(matchers) {
  var adjustedMatchers = [];
  if (isDefined(matchers)) {
    forEach(matchers, function(matcher) {
      adjustedMatchers.push(adjustMatcher(matcher));
    });
  }
  return adjustedMatchers;
}


/**
 * @ngdoc service
 * @name $sceDelegate
 * @kind function
 *
 * @description
 *
 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
 * Contextual Escaping (SCE)} services to AngularJS.
 *
 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
 * work because `$sce` delegates to `$sceDelegate` for these operations.
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
 *
 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
 * can override it completely to change the behavior of `$sce`, the common case would
 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 */

/**
 * @ngdoc provider
 * @name $sceDelegateProvider
 * @this
 *
 * @description
 *
 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
 * $sceDelegate} service.  This allows one to get/set the whitelists and blacklists used to ensure
 * that the URLs used for sourcing Angular templates are safe.  Refer {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist} and
 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
 *
 * For the general details about this service in Angular, read the main page for {@link ng.$sce
 * Strict Contextual Escaping (SCE)}.
 *
 * **Example**:  Consider the following case. <a name="example"></a>
 *
 * - your app is hosted at url `http://myapp.example.com/`
 * - but some of your templates are hosted on other domains you control such as
 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
 *
 * Here is what a secure configuration for this scenario might look like:
 *
 * ```
 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
 *    $sceDelegateProvider.resourceUrlWhitelist([
 *      // Allow same origin resource loads.
 *      'self',
 *      // Allow loading from our assets domain.  Notice the difference between * and **.
 *      'http://srv*.assets.example.com/**'
 *    ]);
 *
 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
 *    $sceDelegateProvider.resourceUrlBlacklist([
 *      'http://myapp.example.com/clickThru**'
 *    ]);
 *  });
 * ```
 */

function $SceDelegateProvider() {
  this.SCE_CONTEXTS = SCE_CONTEXTS;

  // Resource URLs can also be trusted by policy.
  var resourceUrlWhitelist = ['self'],
      resourceUrlBlacklist = [];

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlWhitelist
   * @kind function
   *
   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
   *    provided.  This must be an array or null.  A snapshot of this array is used so further
   *    changes to the array are ignored.
   *
   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *    allowed in this array.
   *
   *    <div class="alert alert-warning">
   *    **Note:** an empty whitelist array will block all URLs!
   *    </div>
   *
   * @return {Array} the currently set whitelist array.
   *
   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
   * same origin resource requests.
   *
   * @description
   * Sets/Gets the whitelist of trusted resource URLs.
   */
  this.resourceUrlWhitelist = function(value) {
    if (arguments.length) {
      resourceUrlWhitelist = adjustMatchers(value);
    }
    return resourceUrlWhitelist;
  };

  /**
   * @ngdoc method
   * @name $sceDelegateProvider#resourceUrlBlacklist
   * @kind function
   *
   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
   *    provided.  This must be an array or null.  A snapshot of this array is used so further
   *    changes to the array are ignored.
   *
   *    Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
   *    allowed in this array.
   *
   *    The typical usage for the blacklist is to **block
   *    [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
   *    these would otherwise be trusted but actually return content from the redirected domain.
   *
   *    Finally, **the blacklist overrides the whitelist** and has the final say.
   *
   * @return {Array} the currently set blacklist array.
   *
   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
   * is no blacklist.)
   *
   * @description
   * Sets/Gets the blacklist of trusted resource URLs.
   */

  this.resourceUrlBlacklist = function(value) {
    if (arguments.length) {
      resourceUrlBlacklist = adjustMatchers(value);
    }
    return resourceUrlBlacklist;
  };

  this.$get = ['$injector', function($injector) {

    var htmlSanitizer = function htmlSanitizer(html) {
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    };

    if ($injector.has('$sanitize')) {
      htmlSanitizer = $injector.get('$sanitize');
    }


    function matchUrl(matcher, parsedUrl) {
      if (matcher === 'self') {
        return urlIsSameOrigin(parsedUrl);
      } else {
        // definitely a regex.  See adjustMatchers()
        return !!matcher.exec(parsedUrl.href);
      }
    }

    function isResourceUrlAllowedByPolicy(url) {
      var parsedUrl = urlResolve(url.toString());
      var i, n, allowed = false;
      // Ensure that at least one item from the whitelist allows this url.
      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
          allowed = true;
          break;
        }
      }
      if (allowed) {
        // Ensure that no item from the blacklist blocked this url.
        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
            allowed = false;
            break;
          }
        }
      }
      return allowed;
    }

    function generateHolderType(Base) {
      var holderType = function TrustedValueHolderType(trustedValue) {
        this.$$unwrapTrustedValue = function() {
          return trustedValue;
        };
      };
      if (Base) {
        holderType.prototype = new Base();
      }
      holderType.prototype.valueOf = function sceValueOf() {
        return this.$$unwrapTrustedValue();
      };
      holderType.prototype.toString = function sceToString() {
        return this.$$unwrapTrustedValue().toString();
      };
      return holderType;
    }

    var trustedValueHolderBase = generateHolderType(),
        byType = {};

    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

    /**
     * @ngdoc method
     * @name $sceDelegate#trustAs
     *
     * @description
     * Returns an object that is trusted by angular for use in specified strict
     * contextual escaping contexts (such as ng-bind-html, ng-include, any src
     * attribute interpolation, any dom event binding attribute interpolation
     * such as for onclick,  etc.) that uses the provided value.
     * See {@link ng.$sce $sce} for enabling strict contextual escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */
    function trustAs(type, trustedValue) {
      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (!Constructor) {
        throw $sceMinErr('icontext',
            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
            type, trustedValue);
      }
      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
        return trustedValue;
      }
      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
      // mutable objects, we ensure here that the value passed in is actually a string.
      if (typeof trustedValue !== 'string') {
        throw $sceMinErr('itype',
            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
            type);
      }
      return new Constructor(trustedValue);
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#valueOf
     *
     * @description
     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
     *
     * If the passed parameter is not a value that had been returned by {@link
     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, returns it as-is.
     *
     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
     *      call or anything else.
     * @returns {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
     *     `value` unchanged.
     */
    function valueOf(maybeTrusted) {
      if (maybeTrusted instanceof trustedValueHolderBase) {
        return maybeTrusted.$$unwrapTrustedValue();
      } else {
        return maybeTrusted;
      }
    }

    /**
     * @ngdoc method
     * @name $sceDelegate#getTrusted
     *
     * @description
     * Takes the result of a {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call and
     * returns the originally supplied value if the queried context type is a supertype of the
     * created type.  If this condition isn't satisfied, throws an exception.
     *
     * <div class="alert alert-danger">
     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
     * (XSS) vulnerability in your application.
     * </div>
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} call.
     * @returns {*} The value the was originally provided to {@link ng.$sceDelegate#trustAs
     *     `$sceDelegate.trustAs`} if valid in this context.  Otherwise, throws an exception.
     */
    function getTrusted(type, maybeTrusted) {
      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
        return maybeTrusted;
      }
      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
      if (constructor && maybeTrusted instanceof constructor) {
        return maybeTrusted.$$unwrapTrustedValue();
      }
      // If we get here, then we may only take one of two actions.
      // 1. sanitize the value for the requested type, or
      // 2. throw an exception.
      if (type === SCE_CONTEXTS.RESOURCE_URL) {
        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
          return maybeTrusted;
        } else {
          throw $sceMinErr('insecurl',
              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
              maybeTrusted.toString());
        }
      } else if (type === SCE_CONTEXTS.HTML) {
        return htmlSanitizer(maybeTrusted);
      }
      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
    }

    return { trustAs: trustAs,
             getTrusted: getTrusted,
             valueOf: valueOf };
  }];
}


/**
 * @ngdoc provider
 * @name $sceProvider
 * @this
 *
 * @description
 *
 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
 * -   enable/disable Strict Contextual Escaping (SCE) in a module
 * -   override the default implementation with a custom delegate
 *
 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
 */

/**
 * @ngdoc service
 * @name $sce
 * @kind function
 *
 * @description
 *
 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
 *
 * # Strict Contextual Escaping
 *
 * Strict Contextual Escaping (SCE) is a mode in which AngularJS requires bindings in certain
 * contexts to result in a value that is marked as safe to use for that context.  One example of
 * such a context is binding arbitrary html controlled by the user via `ng-bind-html`.  We refer
 * to these contexts as privileged or SCE contexts.
 *
 * As of version 1.2, Angular ships with SCE enabled by default.
 *
 * Note:  When enabled (the default), IE<11 in quirks mode is not supported.  In this mode, IE<11 allow
 * one to execute arbitrary javascript by the use of the expression() syntax.  Refer
 * <http://blogs.msdn.com/b/ie/archive/2008/10/16/ending-expressions.aspx> to learn more about them.
 * You can ensure your document is in standards mode and not quirks mode by adding `<!doctype html>`
 * to the top of your HTML document.
 *
 * SCE assists in writing code in a way that (a) is secure by default and (b) makes auditing for
 * security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
 *
 * Here's an example of a binding in a privileged context:
 *
 * ```
 * <input ng-model="userHtml" aria-label="User input">
 * <div ng-bind-html="userHtml"></div>
 * ```
 *
 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
 * disabled, this application allows the user to render arbitrary HTML into the DIV.
 * In a more realistic example, one may be rendering user comments, blog articles, etc. via
 * bindings.  (HTML is just one example of a context where rendering user controlled input creates
 * security vulnerabilities.)
 *
 * For the case of HTML, you might use a library, either on the client side, or on the server side,
 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
 *
 * How would you ensure that every place that used these types of bindings was bound to a value that
 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
 * properties/fields and forgot to update the binding to the sanitized value?
 *
 * To be secure by default, you want to ensure that any such bindings are disallowed unless you can
 * determine that something explicitly says it's safe to use a value for binding in that
 * context.  You can then audit your code (a simple grep would do) to ensure that this is only done
 * for those values that you can easily tell are safe - because they were received from your server,
 * sanitized by your library, etc.  You can organize your codebase to help with this - perhaps
 * allowing only the files in a specific directory to do this.  Ensuring that the internal API
 * exposed by that code doesn't markup arbitrary values as safe then becomes a more manageable task.
 *
 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
 * obtain values that will be accepted by SCE / privileged contexts.
 *
 *
 * ## How does it work?
 *
 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
 * $sce.getTrusted(context, value)} rather than to the value directly.  Directives use {@link
 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs the
 * {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals.
 *
 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
 * simplified):
 *
 * ```
 * var ngBindHtmlDirective = ['$sce', function($sce) {
 *   return function(scope, element, attr) {
 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
 *       element.html(value || '');
 *     });
 *   };
 * }];
 * ```
 *
 * ## Impact on loading templates
 *
 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
 * `templateUrl`'s specified by {@link guide/directive directives}.
 *
 * By default, Angular only loads templates from the same domain and protocol as the application
 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
 *
 * *Please note*:
 * The browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy apply in addition to this and may further restrict whether the template is successfully
 * loaded.  This means that without the right CORS policy, loading templates from a different domain
 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
 * browsers.
 *
 * ## This feels like too much overhead
 *
 * It's important to remember that SCE only applies to interpolation expressions.
 *
 * If your expressions are constant literals, they're automatically trusted and you don't need to
 * call `$sce.trustAs` on them (remember to include the `ngSanitize` module) (e.g.
 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works.
 *
 * Additionally, `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
 * through {@link ng.$sce#getTrusted $sce.getTrusted}.  SCE doesn't play a role here.
 *
 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
 * templates in `ng-include` from your application's domain without having to even know about SCE.
 * It blocks loading templates from other domains or loading templates over http from an https
 * served document.  You can change these by setting your own custom {@link
 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
 *
 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
 * application that's secure and can be audited to verify that with much more ease than bolting
 * security onto an application later.
 *
 * <a name="contexts"></a>
 * ## What trusted context types are supported?
 *
 * | Context             | Notes          |
 * |---------------------|----------------|
 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=` and `<img src=` sanitize their urls and don't constitute an SCE context. |
 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
 *
 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
 *
 *  Each element in these arrays must be one of the following:
 *
 *  - **'self'**
 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
 *      domain** as the application document using the **same protocol**.
 *  - **String** (except the special value `'self'`)
 *    - The string is matched against the full *normalized / absolute URL* of the resource
 *      being tested (substring matches are not good enough.)
 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
 *      match themselves.
 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
 *      in a whitelist.
 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
 *      http://foo.example.com/templates/**).
 *  - **RegExp** (*see caveat below*)
 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
 *      is highly recommended to use the string patterns and only fall back to regular expressions
 *      as a last resort.
 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
 *    - If you are generating your JavaScript from some other templating engine (not
 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
 *      remember to escape your regular expression (and be aware that you might need more than
 *      one level of escaping depending on your templating engine and the way you interpolated
 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
 *      enough before coding your own.  E.g. Ruby has
 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
 *      Closure library's [goog.string.regExpEscape(s)](
 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
 *
 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
 *
 * ## Show me an example using SCE.
 *
 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
 * <file name="index.html">
 *   <div ng-controller="AppController as myCtrl">
 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
 *     <b>User comments</b><br>
 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
 *     exploit.
 *     <div class="well">
 *       <div ng-repeat="userComment in myCtrl.userComments">
 *         <b>{{userComment.name}}</b>:
 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
 *         <br>
 *       </div>
 *     </div>
 *   </div>
 * </file>
 *
 * <file name="script.js">
 *   angular.module('mySceApp', ['ngSanitize'])
 *     .controller('AppController', ['$http', '$templateCache', '$sce',
 *       function AppController($http, $templateCache, $sce) {
 *         var self = this;
 *         $http.get('test_data.json', {cache: $templateCache}).success(function(userComments) {
 *           self.userComments = userComments;
 *         });
 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *             'sanitization.&quot;">Hover over this text.</span>');
 *       }]);
 * </file>
 *
 * <file name="test_data.json">
 * [
 *   { "name": "Alice",
 *     "htmlComment":
 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
 *   },
 *   { "name": "Bob",
 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
 *   }
 * ]
 * </file>
 *
 * <file name="protractor.js" type="protractor">
 *   describe('SCE doc demo', function() {
 *     it('should sanitize untrusted values', function() {
 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
 *     });
 *
 *     it('should NOT sanitize explicitly trusted values', function() {
 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
 *           'sanitization.&quot;">Hover over this text.</span>');
 *     });
 *   });
 * </file>
 * </example>
 *
 *
 *
 * ## Can I disable SCE completely?
 *
 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
 * for little coding overhead.  It will be much harder to take an SCE disabled application and
 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
 * for cases where you have a lot of existing code that was written before SCE was introduced and
 * you're migrating them a module at a time.
 *
 * That said, here's how you can completely disable SCE:
 *
 * ```
 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
 *   // Completely disable SCE.  For demonstration purposes only!
 *   // Do not use in new projects.
 *   $sceProvider.enabled(false);
 * });
 * ```
 *
 */

function $SceProvider() {
  var enabled = true;

  /**
   * @ngdoc method
   * @name $sceProvider#enabled
   * @kind function
   *
   * @param {boolean=} value If provided, then enables/disables SCE.
   * @return {boolean} true if SCE is enabled, false otherwise.
   *
   * @description
   * Enables/disables SCE and returns the current value.
   */
  this.enabled = function(value) {
    if (arguments.length) {
      enabled = !!value;
    }
    return enabled;
  };


  /* Design notes on the default implementation for SCE.
   *
   * The API contract for the SCE delegate
   * -------------------------------------
   * The SCE delegate object must provide the following 3 methods:
   *
   * - trustAs(contextEnum, value)
   *     This method is used to tell the SCE service that the provided value is OK to use in the
   *     contexts specified by contextEnum.  It must return an object that will be accepted by
   *     getTrusted() for a compatible contextEnum and return this value.
   *
   * - valueOf(value)
   *     For values that were not produced by trustAs(), return them as is.  For values that were
   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
   *     such a value.
   *
   * - getTrusted(contextEnum, value)
   *     This function should return the a value that is safe to use in the context specified by
   *     contextEnum or throw and exception otherwise.
   *
   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
   * instance, an implementation could maintain a registry of all trusted objects by context.  In
   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
   * return the same object passed in if it was found in the registry under a compatible context or
   * throw an exception otherwise.  An implementation might only wrap values some of the time based
   * on some criteria.  getTrusted() might return a value and not throw an exception for special
   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
   *
   *
   * A note on the inheritance model for SCE contexts
   * ------------------------------------------------
   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
   * is purely an implementation details.
   *
   * The contract is simply this:
   *
   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
   *     will also succeed.
   *
   * Inheritance happens to capture this in a natural way.  In some future, we
   * may not use inheritance anymore.  That is OK because no code outside of
   * sce.js and sceSpecs.js would need to be aware of this detail.
   */

  this.$get = ['$parse', '$sceDelegate', function(
                $parse,   $sceDelegate) {
    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
    // the "expression(javascript expression)" syntax which is insecure.
    if (enabled && msie < 8) {
      throw $sceMinErr('iequirks',
        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
    }

    var sce = shallowCopy(SCE_CONTEXTS);

    /**
     * @ngdoc method
     * @name $sce#isEnabled
     * @kind function
     *
     * @return {Boolean} true if SCE is enabled, false otherwise.  If you want to set the value, you
     * have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
     *
     * @description
     * Returns a boolean indicating if SCE is enabled.
     */
    sce.isEnabled = function() {
      return enabled;
    };
    sce.trustAs = $sceDelegate.trustAs;
    sce.getTrusted = $sceDelegate.getTrusted;
    sce.valueOf = $sceDelegate.valueOf;

    if (!enabled) {
      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
      sce.valueOf = identity;
    }

    /**
     * @ngdoc method
     * @name $sce#parseAs
     *
     * @description
     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
     * *result*)}
     *
     * @param {string} type The kind of SCE context in which this result will be used.
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */
    sce.parseAs = function sceParseAs(type, expr) {
      var parsed = $parse(expr);
      if (parsed.literal && parsed.constant) {
        return parsed;
      } else {
        return $parse(expr, function(value) {
          return sce.getTrusted(type, value);
        });
      }
    };

    /**
     * @ngdoc method
     * @name $sce#trustAs
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.  As such,
     * returns an object that is trusted by angular for use in specified strict contextual
     * escaping contexts (such as ng-bind-html, ng-include, any src attribute
     * interpolation, any dom event binding attribute interpolation such as for onclick,  etc.)
     * that uses the provided value.  See * {@link ng.$sce $sce} for enabling strict contextual
     * escaping.
     *
     * @param {string} type The kind of context in which this value is safe for use.  e.g. url,
     *   resourceUrl, html, js and css.
     * @param {*} value The value that that should be considered trusted/safe.
     * @returns {*} A value that can be used to stand in for the provided `value` in places
     * where Angular expects a $sce.trustAs() return value.
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsHtml
     *
     * @description
     * Shorthand method.  `$sce.trustAsHtml(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedHtml
     *     $sce.getTrustedHtml(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedUrl
     *     $sce.getTrustedUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedResourceUrl
     *     $sce.getTrustedResourceUrl(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the return
     *     value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#trustAsJs
     *
     * @description
     * Shorthand method.  `$sce.trustAsJs(value)` →
     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
     *
     * @param {*} value The value to trustAs.
     * @returns {*} An object that can be passed to {@link ng.$sce#getTrustedJs
     *     $sce.getTrustedJs(value)} to obtain the original value.  (privileged directives
     *     only accept expressions that are either literal constants or are the
     *     return value of {@link ng.$sce#trustAs $sce.trustAs}.)
     */

    /**
     * @ngdoc method
     * @name $sce#getTrusted
     *
     * @description
     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
     * takes the result of a {@link ng.$sce#trustAs `$sce.trustAs`}() call and returns the
     * originally supplied value if the queried context type is a supertype of the created type.
     * If this condition isn't satisfied, throws an exception.
     *
     * @param {string} type The kind of context in which this value is to be used.
     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs `$sce.trustAs`}
     *                         call.
     * @returns {*} The value the was originally provided to
     *              {@link ng.$sce#trustAs `$sce.trustAs`} if valid in this context.
     *              Otherwise, throws an exception.
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedHtml
     *
     * @description
     * Shorthand method.  `$sce.getTrustedHtml(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.HTML, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedCss
     *
     * @description
     * Shorthand method.  `$sce.getTrustedCss(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.CSS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
     *
     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#getTrustedJs
     *
     * @description
     * Shorthand method.  `$sce.getTrustedJs(value)` →
     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
     *
     * @param {*} value The value to pass to `$sce.getTrusted`.
     * @returns {*} The return value of `$sce.getTrusted($sce.JS, value)`
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsHtml
     *
     * @description
     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsCss
     *
     * @description
     * Shorthand method.  `$sce.parseAsCss(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsResourceUrl
     *
     * @description
     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    /**
     * @ngdoc method
     * @name $sce#parseAsJs
     *
     * @description
     * Shorthand method.  `$sce.parseAsJs(value)` →
     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
     *
     * @param {string} expression String expression to compile.
     * @returns {function(context, locals)} a function which represents the compiled expression:
     *
     *    * `context` – `{object}` – an object against which any expressions embedded in the strings
     *      are evaluated against (typically a scope object).
     *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
     *      `context`.
     */

    // Shorthand delegations.
    var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;

    forEach(SCE_CONTEXTS, function(enumValue, name) {
      var lName = lowercase(name);
      sce[camelCase('parse_as_' + lName)] = function(expr) {
        return parse(enumValue, expr);
      };
      sce[camelCase('get_trusted_' + lName)] = function(value) {
        return getTrusted(enumValue, value);
      };
      sce[camelCase('trust_as_' + lName)] = function(value) {
        return trustAs(enumValue, value);
      };
    });

    return sce;
  }];
}

/* exported $SnifferProvider */

/**
 * !!! This is an undocumented "private" service !!!
 *
 * @name $sniffer
 * @requires $window
 * @requires $document
 * @this
 *
 * @property {boolean} history Does the browser support html5 history api ?
 * @property {boolean} transitions Does the browser support CSS transition events ?
 * @property {boolean} animations Does the browser support CSS animation events ?
 *
 * @description
 * This is very simple implementation of testing browser's features.
 */
function $SnifferProvider() {
  this.$get = ['$window', '$document', function($window, $document) {
    var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        isChromePackagedApp =
            $window.chrome &&
            ($window.chrome.app && $window.chrome.app.runtime ||
                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android =
          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        vendorPrefix,
        vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/,
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false,
        match;

    if (bodyStyle) {
      for (var prop in bodyStyle) {
        if ((match = vendorRegex.exec(prop))) {
          vendorPrefix = match[0];
          vendorPrefix = vendorPrefix[0].toUpperCase() + vendorPrefix.substr(1);
          break;
        }
      }

      if (!vendorPrefix) {
        vendorPrefix = ('WebkitOpacity' in bodyStyle) && 'webkit';
      }

      transitions = !!(('transition' in bodyStyle) || (vendorPrefix + 'Transition' in bodyStyle));
      animations  = !!(('animation' in bodyStyle) || (vendorPrefix + 'Animation' in bodyStyle));

      if (android && (!transitions ||  !animations)) {
        transitions = isString(bodyStyle.webkitTransition);
        animations = isString(bodyStyle.webkitAnimation);
      }
    }


    return {
      // Android has history.pushState, but it does not update location correctly
      // so let's not use the history API at all.
      // http://code.google.com/p/android/issues/detail?id=17471
      // https://github.com/angular/angular.js/issues/904

      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
      // so let's not use the history API also
      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
      hasEvent: function(event) {
        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
        // it. In particular the event is not fired when backspace or delete key are pressed or
        // when cut operation is performed.
        // IE10+ implements 'input' event but it erroneously fires under various situations,
        // e.g. when placeholder changes, or a form is focused.
        if (event === 'input' && msie <= 11) return false;

        if (isUndefined(eventSupport[event])) {
          var divElm = document.createElement('div');
          eventSupport[event] = 'on' + event in divElm;
        }

        return eventSupport[event];
      },
      csp: csp(),
      vendorPrefix: vendorPrefix,
      transitions: transitions,
      animations: animations,
      android: android
    };
  }];
}

var $templateRequestMinErr = minErr('$compile');

/**
 * @ngdoc provider
 * @name $templateRequestProvider
 * @this
 *
 * @description
 * Used to configure the options passed to the {@link $http} service when making a template request.
 *
 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
 * requesting a template.
 */
function $TemplateRequestProvider() {

  var httpOptions;

  /**
   * @ngdoc method
   * @name $templateRequestProvider#httpOptions
   * @description
   * The options to be passed to the {@link $http} service when making the request.
   * You can use this to override options such as the "Accept" header for template requests.
   *
   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
   * options if not overridden here.
   *
   * @param {string=} value new value for the {@link $http} options.
   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
   */
  this.httpOptions = function(val) {
    if (val) {
      httpOptions = val;
      return this;
    }
    return httpOptions;
  };

  /**
   * @ngdoc service
   * @name $templateRequest
   *
   * @description
   * The `$templateRequest` service runs security checks then downloads the provided template using
   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
   * when `tpl` is of type string and `$templateCache` has the matching entry.
   *
   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
   * can configure this via {@link $templateRequestProvider#httpOptions}.
   *
   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
   *
   * @return {Promise} a promise for the HTTP response data of the given URL.
   *
   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
   */
  this.$get = ['$templateCache', '$http', '$q', '$sce', function($templateCache, $http, $q, $sce) {

    function handleRequestFn(tpl, ignoreRequestError) {
      handleRequestFn.totalPendingRequests++;

      // We consider the template cache holds only trusted templates, so
      // there's no need to go through whitelisting again for keys that already
      // are included in there. This also makes Angular accept any script
      // directive, no matter its name. However, we still need to unwrap trusted
      // types.
      if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
        tpl = $sce.getTrustedResourceUrl(tpl);
      }

      var transformResponse = $http.defaults && $http.defaults.transformResponse;

      if (isArray(transformResponse)) {
        transformResponse = transformResponse.filter(function(transformer) {
          return transformer !== defaultHttpResponseTransform;
        });
      } else if (transformResponse === defaultHttpResponseTransform) {
        transformResponse = null;
      }

      return $http.get(tpl, extend({
          cache: $templateCache,
          transformResponse: transformResponse
        }, httpOptions)
        )['finally'](function() {
          handleRequestFn.totalPendingRequests--;
        })
        .then(function(response) {
          $templateCache.put(tpl, response.data);
          return response.data;
        }, handleError);

      function handleError(resp) {
        if (!ignoreRequestError) {
          throw $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})',
            tpl, resp.status, resp.statusText);
        }
        return $q.reject(resp);
      }
    }

    handleRequestFn.totalPendingRequests = 0;

    return handleRequestFn;
  }];
}

/** @this */
function $$TestabilityProvider() {
  this.$get = ['$rootScope', '$browser', '$location',
       function($rootScope,   $browser,   $location) {

    /**
     * @name $testability
     *
     * @description
     * The private $$testability service provides a collection of methods for use when debugging
     * or by automated test and debugging tools.
     */
    var testability = {};

    /**
     * @name $$testability#findBindings
     *
     * @description
     * Returns an array of elements that are bound (via ng-bind or {{}})
     * to expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The binding expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression. Filters and whitespace are ignored.
     */
    testability.findBindings = function(element, expression, opt_exactMatch) {
      var bindings = element.getElementsByClassName('ng-binding');
      var matches = [];
      forEach(bindings, function(binding) {
        var dataBinding = angular.element(binding).data('$binding');
        if (dataBinding) {
          forEach(dataBinding, function(bindingName) {
            if (opt_exactMatch) {
              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
              if (matcher.test(bindingName)) {
                matches.push(binding);
              }
            } else {
              if (bindingName.indexOf(expression) !== -1) {
                matches.push(binding);
              }
            }
          });
        }
      });
      return matches;
    };

    /**
     * @name $$testability#findModels
     *
     * @description
     * Returns an array of elements that are two-way found via ng-model to
     * expressions matching the input.
     *
     * @param {Element} element The element root to search from.
     * @param {string} expression The model expression to match.
     * @param {boolean} opt_exactMatch If true, only returns exact matches
     *     for the expression.
     */
    testability.findModels = function(element, expression, opt_exactMatch) {
      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
      for (var p = 0; p < prefixes.length; ++p) {
        var attributeEquals = opt_exactMatch ? '=' : '*=';
        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
        var elements = element.querySelectorAll(selector);
        if (elements.length) {
          return elements;
        }
      }
    };

    /**
     * @name $$testability#getLocation
     *
     * @description
     * Shortcut for getting the location in a browser agnostic way. Returns
     *     the path, search, and hash. (e.g. /path?a=b#hash)
     */
    testability.getLocation = function() {
      return $location.url();
    };

    /**
     * @name $$testability#setLocation
     *
     * @description
     * Shortcut for navigating to a location without doing a full page reload.
     *
     * @param {string} url The location url (path, search and hash,
     *     e.g. /path?a=b#hash) to go to.
     */
    testability.setLocation = function(url) {
      if (url !== $location.url()) {
        $location.url(url);
        $rootScope.$digest();
      }
    };

    /**
     * @name $$testability#whenStable
     *
     * @description
     * Calls the callback when $timeout and $http requests are completed.
     *
     * @param {function} callback
     */
    testability.whenStable = function(callback) {
      $browser.notifyWhenNoOutstandingRequests(callback);
    };

    return testability;
  }];
}

/** @this */
function $TimeoutProvider() {
  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {

    var deferreds = {};


     /**
      * @ngdoc service
      * @name $timeout
      *
      * @description
      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
      * block and delegates any exceptions to
      * {@link ng.$exceptionHandler $exceptionHandler} service.
      *
      * The return value of calling `$timeout` is a promise, which will be resolved when
      * the delay has passed and the timeout function, if provided, is executed.
      *
      * To cancel a timeout request, call `$timeout.cancel(promise)`.
      *
      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
      * synchronously flush the queue of deferred functions.
      *
      * If you only want a promise that will be resolved after some specified delay
      * then you can call `$timeout` without the `fn` function.
      *
      * @param {function()=} fn A function, whose execution should be delayed.
      * @param {number=} [delay=0] Delay in milliseconds.
      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
      * @param {...*=} Pass additional parameters to the executed function.
      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
      *   will be resolved with the return value of the `fn` function.
      *
      */
    function timeout(fn, delay, invokeApply) {
      if (!isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = noop;
      }

      var args = sliceArgs(arguments, 3),
          skipApply = (isDefined(invokeApply) && !invokeApply),
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;

      timeoutId = $browser.defer(function() {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (!skipApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }


     /**
      * @ngdoc method
      * @name $timeout#cancel
      *
      * @description
      * Cancels a task associated with the `promise`. As a result of this, the promise will be
      * resolved with a rejection.
      *
      * @param {Promise=} promise Promise returned by the `$timeout` function.
      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
      *   canceled.
      */
    timeout.cancel = function(promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $browser.defer.cancel(promise.$$timeoutId);
      }
      return false;
    };

    return timeout;
  }];
}

// NOTE:  The usage of window and document instead of $window and $document here is
// deliberate.  This service depends on the specific behavior of anchor nodes created by the
// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
// doesn't know about mocked locations and resolves URLs to the real document - which is
// exactly the behavior needed here.  There is little value is mocking these out for this
// service.
var urlParsingNode = window.document.createElement('a');
var originUrl = urlResolve(window.location.href);


/**
 *
 * Implementation Notes for non-IE browsers
 * ----------------------------------------
 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
 * URL will be resolved into an absolute URL in the context of the application document.
 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
 * properties are all populated to reflect the normalized URL.  This approach has wide
 * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *
 * Implementation Notes for IE
 * ---------------------------
 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
 * work around that by performing the parsing in a 2nd step by taking a previously normalized
 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
 * properties such as protocol, hostname, port, etc.
 *
 * References:
 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
 *   http://url.spec.whatwg.org/#urlutils
 *   https://github.com/angular/angular.js/pull/2902
 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @kind function
 * @param {string} url The URL to be parsed.
 * @description Normalizes and parses a URL.
 * @returns {object} Returns the normalized URL as a dictionary.
 *
 *   | member name   | Description    |
 *   |---------------|----------------|
 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
 *   | protocol      | The protocol including the trailing colon                              |
 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
 *   | search        | The search params, minus the question mark                             |
 *   | hash          | The hash string, minus the hash symbol
 *   | hostname      | The hostname
 *   | port          | The port, without ":"
 *   | pathname      | The pathname, beginning with "/"
 *
 */
function urlResolve(url) {
  var href = url;

  if (msie) {
    // Normalize before parse.  Refer Implementation Notes on why this is
    // done in two steps on IE.
    urlParsingNode.setAttribute('href', href);
    href = urlParsingNode.href;
  }

  urlParsingNode.setAttribute('href', href);

  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
  return {
    href: urlParsingNode.href,
    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
    host: urlParsingNode.host,
    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
    hostname: urlParsingNode.hostname,
    port: urlParsingNode.port,
    pathname: (urlParsingNode.pathname.charAt(0) === '/')
      ? urlParsingNode.pathname
      : '/' + urlParsingNode.pathname
  };
}

/**
 * Parse a request URL and determine whether this is a same-origin request as the application document.
 *
 * @param {string|object} requestUrl The url of the request as a string that will be resolved
 * or a parsed URL object.
 * @returns {boolean} Whether the request is for the same origin as the application document.
 */
function urlIsSameOrigin(requestUrl) {
  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
  return (parsed.protocol === originUrl.protocol &&
          parsed.host === originUrl.host);
}

/**
 * @ngdoc service
 * @name $window
 * @this
 *
 * @description
 * A reference to the browser's `window` object. While `window`
 * is globally available in JavaScript, it causes testability problems, because
 * it is a global variable. In angular we always refer to it through the
 * `$window` service, so it may be overridden, removed or mocked for testing.
 *
 * Expressions, like the one defined for the `ngClick` directive in the example
 * below, are evaluated with respect to the current scope.  Therefore, there is
 * no risk of inadvertently coding in a dependency on a global value in such an
 * expression.
 *
 * @example
   <example module="windowExample" name="window-service">
     <file name="index.html">
       <script>
         angular.module('windowExample', [])
           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
             $scope.greeting = 'Hello, World!';
             $scope.doGreeting = function(greeting) {
               $window.alert(greeting);
             };
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="text" ng-model="greeting" aria-label="greeting" />
         <button ng-click="doGreeting(greeting)">ALERT</button>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
      it('should display the greeting in the input box', function() {
       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
       // If we click the button it will block the test runner
       // element(':button').click();
      });
     </file>
   </example>
 */
function $WindowProvider() {
  this.$get = valueFn(window);
}

/**
 * @name $$cookieReader
 * @requires $document
 *
 * @description
 * This is a private service for reading cookies used by $http and ngCookies
 *
 * @return {Object} a key/value map of the current cookies
 */
function $$CookieReader($document) {
  var rawDocument = $document[0] || {};
  var lastCookies = {};
  var lastCookieString = '';

  function safeGetCookie(rawDocument) {
    try {
      return rawDocument.cookie || '';
    } catch (e) {
      return '';
    }
  }

  function safeDecodeURIComponent(str) {
    try {
      return decodeURIComponent(str);
    } catch (e) {
      return str;
    }
  }

  return function() {
    var cookieArray, cookie, i, index, name;
    var currentCookieString = safeGetCookie(rawDocument);

    if (currentCookieString !== lastCookieString) {
      lastCookieString = currentCookieString;
      cookieArray = lastCookieString.split('; ');
      lastCookies = {};

      for (i = 0; i < cookieArray.length; i++) {
        cookie = cookieArray[i];
        index = cookie.indexOf('=');
        if (index > 0) { //ignore nameless cookies
          name = safeDecodeURIComponent(cookie.substring(0, index));
          // the first value that is seen for a cookie is the most
          // specific one.  values for the same cookie name that
          // follow are for less specific paths.
          if (isUndefined(lastCookies[name])) {
            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
          }
        }
      }
    }
    return lastCookies;
  };
}

$$CookieReader.$inject = ['$document'];

/** @this */
function $$CookieReaderProvider() {
  this.$get = $$CookieReader;
}

/* global currencyFilter: true,
 dateFilter: true,
 filterFilter: true,
 jsonFilter: true,
 limitToFilter: true,
 lowercaseFilter: true,
 numberFilter: true,
 orderByFilter: true,
 uppercaseFilter: true,
 */

/**
 * @ngdoc provider
 * @name $filterProvider
 * @description
 *
 * Filters are just functions which transform input to an output. However filters need to be
 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
 * annotated with dependencies and is responsible for creating a filter function.
 *
 * <div class="alert alert-warning">
 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
 * (`myapp_subsection_filterx`).
 * </div>
 *
 * ```js
 *   // Filter registration
 *   function MyModule($provide, $filterProvider) {
 *     // create a service to demonstrate injection (not always needed)
 *     $provide.value('greet', function(name){
 *       return 'Hello ' + name + '!';
 *     });
 *
 *     // register a filter factory which uses the
 *     // greet service to demonstrate DI.
 *     $filterProvider.register('greet', function(greet){
 *       // return the filter function which uses the greet service
 *       // to generate salutation
 *       return function(text) {
 *         // filters need to be forgiving so check input validity
 *         return text && greet(text) || text;
 *       };
 *     });
 *   }
 * ```
 *
 * The filter function is registered with the `$injector` under the filter name suffix with
 * `Filter`.
 *
 * ```js
 *   it('should be the same instance', inject(
 *     function($filterProvider) {
 *       $filterProvider.register('reverse', function(){
 *         return ...;
 *       });
 *     },
 *     function($filter, reverseFilter) {
 *       expect($filter('reverse')).toBe(reverseFilter);
 *     });
 * ```
 *
 *
 * For more information about how angular filters work, and how to create your own filters, see
 * {@link guide/filter Filters} in the Angular Developer Guide.
 */

/**
 * @ngdoc service
 * @name $filter
 * @kind function
 * @description
 * Filters are used for formatting data displayed to the user.
 *
 * They can be used in view templates, controllers or services.Angular comes
 * with a collection of [built-in filters](api/ng/filter), but it is easy to
 * define your own as well.
 *
 * The general syntax in templates is as follows:
 *
 * ```html
 * {{ expression [| filter_name[:parameter_value] ... ] }}
 * ```
 *
 * @param {String} name Name of the filter function to retrieve
 * @return {Function} the filter function
 * @example
   <example name="$filter" module="filterExample">
     <file name="index.html">
       <div ng-controller="MainCtrl">
        <h3>{{ originalText }}</h3>
        <h3>{{ filteredText }}</h3>
       </div>
     </file>

     <file name="script.js">
      angular.module('filterExample', [])
      .controller('MainCtrl', function($scope, $filter) {
        $scope.originalText = 'hello';
        $scope.filteredText = $filter('uppercase')($scope.originalText);
      });
     </file>
   </example>
  */
$FilterProvider.$inject = ['$provide'];
/** @this */
function $FilterProvider($provide) {
  var suffix = 'Filter';

  /**
   * @ngdoc method
   * @name $filterProvider#register
   * @param {string|Object} name Name of the filter function, or an object map of filters where
   *    the keys are the filter names and the values are the filter factories.
   *
   *    <div class="alert alert-warning">
   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   *    (`myapp_subsection_filterx`).
   *    </div>
    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
   *    of the registered filter instances.
   */
  function register(name, factory) {
    if (isObject(name)) {
      var filters = {};
      forEach(name, function(filter, key) {
        filters[key] = register(key, filter);
      });
      return filters;
    } else {
      return $provide.factory(name + suffix, factory);
    }
  }
  this.register = register;

  this.$get = ['$injector', function($injector) {
    return function(name) {
      return $injector.get(name + suffix);
    };
  }];

  ////////////////////////////////////////

  /* global
    currencyFilter: false,
    dateFilter: false,
    filterFilter: false,
    jsonFilter: false,
    limitToFilter: false,
    lowercaseFilter: false,
    numberFilter: false,
    orderByFilter: false,
    uppercaseFilter: false
  */

  register('currency', currencyFilter);
  register('date', dateFilter);
  register('filter', filterFilter);
  register('json', jsonFilter);
  register('limitTo', limitToFilter);
  register('lowercase', lowercaseFilter);
  register('number', numberFilter);
  register('orderBy', orderByFilter);
  register('uppercase', uppercaseFilter);
}

/**
 * @ngdoc filter
 * @name filter
 * @kind function
 *
 * @description
 * Selects a subset of items from `array` and returns it as a new array.
 *
 * @param {Array} array The source array.
 * @param {string|Object|function()} expression The predicate to be used for selecting items from
 *   `array`.
 *
 *   Can be one of:
 *
 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
 *     objects with string properties in `array` that match this string will be returned. This also
 *     applies to nested object properties.
 *     The predicate can be negated by prefixing the string with `!`.
 *
 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
 *     which have property `name` containing "M" and property `phone` containing "1". A special
 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
 *     against any property of the object or its nested object properties. That's equivalent to the
 *     simple substring match with a `string` as described above. The special property name can be
 *     overwritten, using the `anyPropertyKey` parameter.
 *     The predicate can be negated by prefixing the string with `!`.
 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
 *     not containing "M".
 *
 *     Note that a named property will match properties on the same level only, while the special
 *     `$` property will match properties on the same level or deeper. E.g. an array item like
 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
 *     **will** be matched by `{$: 'John'}`.
 *
 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
 *     The function is called for each element of the array, with the element, its index, and
 *     the entire array itself as arguments.
 *
 *     The final result is an array of those elements that the predicate returned true for.
 *
 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
 *     determining if the expected value (from the filter expression) and actual value (from
 *     the object in the array) should be considered a match.
 *
 *   Can be one of:
 *
 *   - `function(actual, expected)`:
 *     The function will be given the object value and the predicate value to compare and
 *     should return true if both values should be considered equal.
 *
 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
 *     This is essentially strict comparison of expected and actual.
 *
 *   - `false`: A short hand for a function which will look for a substring match in a case
 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
 *
 *
 *   Defaults to `false`.
 *
 * @param {string} [anyPropertyKey] The special property name that matches against any property.
 *     By default `$`.
 *
 * @example
   <example name="filter-filter">
     <file name="index.html">
       <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                {name:'Mary', phone:'800-BIG-MARY'},
                                {name:'Mike', phone:'555-4321'},
                                {name:'Adam', phone:'555-5678'},
                                {name:'Julie', phone:'555-8765'},
                                {name:'Juliette', phone:'555-5678'}]"></div>

       <label>Search: <input ng-model="searchText"></label>
       <table id="searchTextResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friend in friends | filter:searchText">
           <td>{{friend.name}}</td>
           <td>{{friend.phone}}</td>
         </tr>
       </table>
       <hr>
       <label>Any: <input ng-model="search.$"></label> <br>
       <label>Name only <input ng-model="search.name"></label><br>
       <label>Phone only <input ng-model="search.phone"></label><br>
       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
       <table id="searchObjResults">
         <tr><th>Name</th><th>Phone</th></tr>
         <tr ng-repeat="friendObj in friends | filter:search:strict">
           <td>{{friendObj.name}}</td>
           <td>{{friendObj.phone}}</td>
         </tr>
       </table>
     </file>
     <file name="protractor.js" type="protractor">
       var expectFriendNames = function(expectedNames, key) {
         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
           arr.forEach(function(wd, i) {
             expect(wd.getText()).toMatch(expectedNames[i]);
           });
         });
       };

       it('should search across all fields when filtering with a string', function() {
         var searchText = element(by.model('searchText'));
         searchText.clear();
         searchText.sendKeys('m');
         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');

         searchText.clear();
         searchText.sendKeys('76');
         expectFriendNames(['John', 'Julie'], 'friend');
       });

       it('should search in specific fields when filtering with a predicate object', function() {
         var searchAny = element(by.model('search.$'));
         searchAny.clear();
         searchAny.sendKeys('i');
         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
       });
       it('should use a equal comparison when comparator is true', function() {
         var searchName = element(by.model('search.name'));
         var strict = element(by.model('strict'));
         searchName.clear();
         searchName.sendKeys('Julie');
         strict.click();
         expectFriendNames(['Julie'], 'friendObj');
       });
     </file>
   </example>
 */

function filterFilter() {
  return function(array, expression, comparator, anyPropertyKey) {
    if (!isArrayLike(array)) {
      if (array == null) {
        return array;
      } else {
        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
      }
    }

    anyPropertyKey = anyPropertyKey || '$';
    var expressionType = getTypeForFilter(expression);
    var predicateFn;
    var matchAgainstAnyProp;

    switch (expressionType) {
      case 'function':
        predicateFn = expression;
        break;
      case 'boolean':
      case 'null':
      case 'number':
      case 'string':
        matchAgainstAnyProp = true;
        // falls through
      case 'object':
        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
        break;
      default:
        return array;
    }

    return Array.prototype.filter.call(array, predicateFn);
  };
}

// Helper functions for `filterFilter`
function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
  var predicateFn;

  if (comparator === true) {
    comparator = equals;
  } else if (!isFunction(comparator)) {
    comparator = function(actual, expected) {
      if (isUndefined(actual)) {
        // No substring matching against `undefined`
        return false;
      }
      if ((actual === null) || (expected === null)) {
        // No substring matching against `null`; only match against `null`
        return actual === expected;
      }
      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
        // Should not compare primitives against objects, unless they have custom `toString` method
        return false;
      }

      actual = lowercase('' + actual);
      expected = lowercase('' + expected);
      return actual.indexOf(expected) !== -1;
    };
  }

  predicateFn = function(item) {
    if (shouldMatchPrimitives && !isObject(item)) {
      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
    }
    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
  };

  return predicateFn;
}

function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
  var actualType = getTypeForFilter(actual);
  var expectedType = getTypeForFilter(expected);

  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
  } else if (isArray(actual)) {
    // In case `actual` is an array, consider it a match
    // if ANY of it's items matches `expected`
    return actual.some(function(item) {
      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
    });
  }

  switch (actualType) {
    case 'object':
      var key;
      if (matchAgainstAnyProp) {
        for (key in actual) {
          if ((key.charAt(0) !== '$') && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
            return true;
          }
        }
        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
      } else if (expectedType === 'object') {
        for (key in expected) {
          var expectedVal = expected[key];
          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
            continue;
          }

          var matchAnyProperty = key === anyPropertyKey;
          var actualVal = matchAnyProperty ? actual : actual[key];
          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
            return false;
          }
        }
        return true;
      } else {
        return comparator(actual, expected);
      }
    case 'function':
      return false;
    default:
      return comparator(actual, expected);
  }
}

// Used for easily differentiating between `null` and actual `object`
function getTypeForFilter(val) {
  return (val === null) ? 'null' : typeof val;
}

var MAX_DIGITS = 22;
var DECIMAL_SEP = '.';
var ZERO_CHAR = '0';

/**
 * @ngdoc filter
 * @name currency
 * @kind function
 *
 * @description
 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
 * symbol for current locale is used.
 *
 * @param {number} amount Input to filter.
 * @param {string=} symbol Currency symbol or identifier to be displayed.
 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
 * @returns {string} Formatted number.
 *
 *
 * @example
   <example module="currencyExample" name="currency-filter">
     <file name="index.html">
       <script>
         angular.module('currencyExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.amount = 1234.56;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <input type="number" ng-model="amount" aria-label="amount"> <br>
         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span>
         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should init with 1234.56', function() {
         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
       });
       it('should update', function() {
         if (browser.params.browser === 'safari') {
           // Safari does not understand the minus key. See
           // https://github.com/angular/protractor/issues/481
           return;
         }
         element(by.model('amount')).clear();
         element(by.model('amount')).sendKeys('-1234');
         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
       });
     </file>
   </example>
 */
currencyFilter.$inject = ['$locale'];
function currencyFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(amount, currencySymbol, fractionSize) {
    if (isUndefined(currencySymbol)) {
      currencySymbol = formats.CURRENCY_SYM;
    }

    if (isUndefined(fractionSize)) {
      fractionSize = formats.PATTERNS[1].maxFrac;
    }

    // if null or undefined pass it through
    return (amount == null)
        ? amount
        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
            replace(/\u00A4/g, currencySymbol);
  };
}

/**
 * @ngdoc filter
 * @name number
 * @kind function
 *
 * @description
 * Formats a number as text.
 *
 * If the input is null or undefined, it will just be returned.
 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
 * If the input is not a number an empty string is returned.
 *
 *
 * @param {number|string} number Number to format.
 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
 * If this is not provided then the fraction size is computed from the current locale's number
 * formatting pattern. In the case of the default locale, it will be 3.
 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
 *                   include "," group separators after each third digit).
 *
 * @example
   <example module="numberFilterExample" name="number-filter">
     <file name="index.html">
       <script>
         angular.module('numberFilterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.val = 1234.56789;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter number: <input ng-model='val'></label><br>
         Default formatting: <span id='number-default'>{{val | number}}</span><br>
         No fractions: <span>{{val | number:0}}</span><br>
         Negative number: <span>{{-val | number:4}}</span>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format numbers', function() {
         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
       });

       it('should update', function() {
         element(by.model('val')).clear();
         element(by.model('val')).sendKeys('3374.333');
         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
      });
     </file>
   </example>
 */
numberFilter.$inject = ['$locale'];
function numberFilter($locale) {
  var formats = $locale.NUMBER_FORMATS;
  return function(number, fractionSize) {

    // if null or undefined pass it through
    return (number == null)
        ? number
        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
                       fractionSize);
  };
}

/**
 * Parse a number (as a string) into three components that can be used
 * for formatting the number.
 *
 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
 *
 * @param  {string} numStr The number to parse
 * @return {object} An object describing this number, containing the following keys:
 *  - d : an array of digits containing leading zeros as necessary
 *  - i : the number of the digits in `d` that are to the left of the decimal point
 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
 *
 */
function parse(numStr) {
  var exponent = 0, digits, numberOfIntegerDigits;
  var i, j, zeros;

  // Decimal point?
  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
    numStr = numStr.replace(DECIMAL_SEP, '');
  }

  // Exponential form?
  if ((i = numStr.search(/e/i)) > 0) {
    // Work out the exponent.
    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
    numberOfIntegerDigits += +numStr.slice(i + 1);
    numStr = numStr.substring(0, i);
  } else if (numberOfIntegerDigits < 0) {
    // There was no decimal point or exponent so it is an integer.
    numberOfIntegerDigits = numStr.length;
  }

  // Count the number of leading zeros.
  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }

  if (i === (zeros = numStr.length)) {
    // The digits are all zero.
    digits = [0];
    numberOfIntegerDigits = 1;
  } else {
    // Count the number of trailing zeros
    zeros--;
    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

    // Trailing zeros are insignificant so ignore them
    numberOfIntegerDigits -= i;
    digits = [];
    // Convert string to array of digits without leading/trailing zeros.
    for (j = 0; i <= zeros; i++, j++) {
      digits[j] = +numStr.charAt(i);
    }
  }

  // If the number overflows the maximum allowed digits then use an exponent.
  if (numberOfIntegerDigits > MAX_DIGITS) {
    digits = digits.splice(0, MAX_DIGITS - 1);
    exponent = numberOfIntegerDigits - 1;
    numberOfIntegerDigits = 1;
  }

  return { d: digits, e: exponent, i: numberOfIntegerDigits };
}

/**
 * Round the parsed number to the specified number of decimal places
 * This function changed the parsedNumber in-place
 */
function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);


    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function(carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
}

/**
 * Format a number into a string
 * @param  {number} number       The number to format
 * @param  {{
 *           minFrac, // the minimum number of digits required in the fraction part of the number
 *           maxFrac, // the maximum number of digits required in the fraction part of the number
 *           gSize,   // number of digits in each group of separated digits
 *           lgSize,  // number of digits in the last group of digits before the decimal separator
 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
 *           posPre,  // the string to go in front of a positive number
 *           negSuf,  // the string to go after a negative number (e.g. `)`)
 *           posSuf   // the string to go after a positive number
 *         }} pattern
 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
 * @param  {[type]} fractionSize The size of the fractional part of the number
 * @return {string}              The number formatted as a string
 */
function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

  var isInfinity = !isFinite(number);
  var isZero = false;
  var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;

  if (isInfinity) {
    formattedText = '\u221e';
  } else {
    parsedNumber = parse(numStr);

    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

    var digits = parsedNumber.d;
    var integerLen = parsedNumber.i;
    var exponent = parsedNumber.e;
    var decimals = [];
    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);

    // pad zeros for small numbers
    while (integerLen < 0) {
      digits.unshift(0);
      integerLen++;
    }

    // extract decimals digits
    if (integerLen > 0) {
      decimals = digits.splice(integerLen, digits.length);
    } else {
      decimals = digits;
      digits = [0];
    }

    // format the integer digits with grouping separators
    var groups = [];
    if (digits.length >= pattern.lgSize) {
      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
    }
    while (digits.length > pattern.gSize) {
      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
    }
    if (digits.length) {
      groups.unshift(digits.join(''));
    }
    formattedText = groups.join(groupSep);

    // append the decimal digits
    if (decimals.length) {
      formattedText += decimalSep + decimals.join('');
    }

    if (exponent) {
      formattedText += 'e+' + exponent;
    }
  }
  if (number < 0 && !isZero) {
    return pattern.negPre + formattedText + pattern.negSuf;
  } else {
    return pattern.posPre + formattedText + pattern.posSuf;
  }
}

function padNumber(num, digits, trim, negWrap) {
  var neg = '';
  if (num < 0 || (negWrap && num <= 0)) {
    if (negWrap) {
      num = -num + 1;
    } else {
      num = -num;
      neg = '-';
    }
  }
  num = '' + num;
  while (num.length < digits) num = ZERO_CHAR + num;
  if (trim) {
    num = num.substr(num.length - digits);
  }
  return neg + num;
}


function dateGetter(name, size, offset, trim, negWrap) {
  offset = offset || 0;
  return function(date) {
    var value = date['get' + name]();
    if (offset > 0 || value > -offset) {
      value += offset;
    }
    if (value === 0 && offset === -12) value = 12;
    return padNumber(value, size, trim, negWrap);
  };
}

function dateStrGetter(name, shortForm, standAlone) {
  return function(date, formats) {
    var value = date['get' + name]();
    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
    var get = uppercase(propPrefix + name);

    return formats[get][value];
  };
}

function timeZoneGetter(date, formats, offset) {
  var zone = -1 * offset;
  var paddedZone = (zone >= 0) ? '+' : '';

  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
                padNumber(Math.abs(zone % 60), 2);

  return paddedZone;
}

function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
}

function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
      // 4 = index of Thursday
      datetime.getDate() + (4 - datetime.getDay()));
}

function weekGetter(size) {
   return function(date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
         thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
   };
}

function ampmGetter(date, formats) {
  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
}

function eraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
}

function longEraGetter(date, formats) {
  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
}

var DATE_FORMATS = {
  yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
     y: dateGetter('FullYear', 1, 0, false, true),
  MMMM: dateStrGetter('Month'),
   MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
     M: dateGetter('Month', 1, 1),
  LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
     d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
     H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
     h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
     m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
     s: dateGetter('Seconds', 1),
     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
   sss: dateGetter('Milliseconds', 3),
  EEEE: dateStrGetter('Day'),
   EEE: dateStrGetter('Day', true),
     a: ampmGetter,
     Z: timeZoneGetter,
    ww: weekGetter(2),
     w: weekGetter(1),
     G: eraGetter,
     GG: eraGetter,
     GGG: eraGetter,
     GGGG: longEraGetter
};

var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))(.*)/,
    NUMBER_STRING = /^-?\d+$/;

/**
 * @ngdoc filter
 * @name date
 * @kind function
 *
 * @description
 *   Formats `date` to a string based on the requested `format`.
 *
 *   `format` string can be composed of the following elements:
 *
 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
 *   * `'MMMM'`: Month in year (January-December)
 *   * `'MMM'`: Month in year (Jan-Dec)
 *   * `'MM'`: Month in year, padded (01-12)
 *   * `'M'`: Month in year (1-12)
 *   * `'LLLL'`: Stand-alone month in year (January-December)
 *   * `'dd'`: Day in month, padded (01-31)
 *   * `'d'`: Day in month (1-31)
 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
 *   * `'EEE'`: Day in Week, (Sun-Sat)
 *   * `'HH'`: Hour in day, padded (00-23)
 *   * `'H'`: Hour in day (0-23)
 *   * `'hh'`: Hour in AM/PM, padded (01-12)
 *   * `'h'`: Hour in AM/PM, (1-12)
 *   * `'mm'`: Minute in hour, padded (00-59)
 *   * `'m'`: Minute in hour (0-59)
 *   * `'ss'`: Second in minute, padded (00-59)
 *   * `'s'`: Second in minute (0-59)
 *   * `'sss'`: Millisecond in second, padded (000-999)
 *   * `'a'`: AM/PM marker
 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
 *
 *   `format` string can also be one of the following predefined
 *   {@link guide/i18n localizable formats}:
 *
 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
 *     (e.g. Sep 3, 2010 12:05:08 PM)
 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
 *     (e.g. Friday, September 3, 2010)
 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
 *
 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
 *   (e.g. `"h 'o''clock'"`).
 *
 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
 *    specified in the string input, the time is considered to be in the local timezone.
 * @param {string=} format Formatting rules (see Description). If not specified,
 *    `mediumDate` is used.
 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *    If not specified, the timezone of the browser will be used.
 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
 *
 * @example
   <example name="filter-date">
     <file name="index.html">
       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
           <span>{{1288323623006 | date:'medium'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
     </file>
     <file name="protractor.js" type="protractor">
       it('should format date', function() {
         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
       });
     </file>
   </example>
 */
dateFilter.$inject = ['$locale'];
function dateFilter($locale) {


  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
                     // 1        2       3         4          5          6          7          8  9     10      11
  function jsonStringToDate(string) {
    var match;
    if ((match = string.match(R_ISO8601_STR))) {
      var date = new Date(0),
          tzHour = 0,
          tzMin  = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;

      if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
      }
      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
      var h = toInt(match[4] || 0) - tzHour;
      var m = toInt(match[5] || 0) - tzMin;
      var s = toInt(match[6] || 0);
      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
      timeSetter.call(date, h, m, s, ms);
      return date;
    }
    return string;
  }


  return function(date, format, timezone) {
    var text = '',
        parts = [],
        fn, match;

    format = format || 'mediumDate';
    format = $locale.DATETIME_FORMATS[format] || format;
    if (isString(date)) {
      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
    }

    if (isNumber(date)) {
      date = new Date(date);
    }

    if (!isDate(date) || !isFinite(date.getTime())) {
      return date;
    }

    while (format) {
      match = DATE_FORMATS_SPLIT.exec(format);
      if (match) {
        parts = concat(parts, match, 1);
        format = parts.pop();
      } else {
        parts.push(format);
        format = null;
      }
    }

    var dateTimezoneOffset = date.getTimezoneOffset();
    if (timezone) {
      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
      date = convertTimezoneToLocal(date, timezone, true);
    }
    forEach(parts, function(value) {
      fn = DATE_FORMATS[value];
      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
    });

    return text;
  };
}


/**
 * @ngdoc filter
 * @name json
 * @kind function
 *
 * @description
 *   Allows you to convert a JavaScript object into JSON string.
 *
 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
 *   the binding is automatically converted to JSON.
 *
 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
 * @returns {string} JSON string.
 *
 *
 * @example
   <example name="filter-json">
     <file name="index.html">
       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
     </file>
     <file name="protractor.js" type="protractor">
       it('should jsonify filtered objects', function() {
         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
       });
     </file>
   </example>
 *
 */
function jsonFilter() {
  return function(object, spacing) {
    if (isUndefined(spacing)) {
        spacing = 2;
    }
    return toJson(object, spacing);
  };
}


/**
 * @ngdoc filter
 * @name lowercase
 * @kind function
 * @description
 * Converts string to lowercase.
 * @see angular.lowercase
 */
var lowercaseFilter = valueFn(lowercase);


/**
 * @ngdoc filter
 * @name uppercase
 * @kind function
 * @description
 * Converts string to uppercase.
 * @see angular.uppercase
 */
var uppercaseFilter = valueFn(uppercase);

/**
 * @ngdoc filter
 * @name limitTo
 * @kind function
 *
 * @description
 * Creates a new array or string containing only a specified number of elements. The elements are
 * taken from either the beginning or the end of the source array, string or number, as specified by
 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
 * it is converted to a string.
 *
 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
 *     If the number is negative, `limit` number  of items from the end of the source array/string
 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
 *     the input will be returned unchanged.
 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
 *     less than `limit` elements.
 *
 * @example
   <example module="limitToExample" name="limit-to-filter">
     <file name="index.html">
       <script>
         angular.module('limitToExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.numbers = [1,2,3,4,5,6,7,8,9];
             $scope.letters = "abcdefghi";
             $scope.longNumber = 2345432342;
             $scope.numLimit = 3;
             $scope.letterLimit = 3;
             $scope.longNumberLimit = 3;
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>
            Limit {{numbers}} to:
            <input type="number" step="1" ng-model="numLimit">
         </label>
         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
         <label>
            Limit {{letters}} to:
            <input type="number" step="1" ng-model="letterLimit">
         </label>
         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
         <label>
            Limit {{longNumber}} to:
            <input type="number" step="1" ng-model="longNumberLimit">
         </label>
         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       var numLimitInput = element(by.model('numLimit'));
       var letterLimitInput = element(by.model('letterLimit'));
       var longNumberLimitInput = element(by.model('longNumberLimit'));
       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));

       it('should limit the number array to first three items', function() {
         expect(numLimitInput.getAttribute('value')).toBe('3');
         expect(letterLimitInput.getAttribute('value')).toBe('3');
         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
         expect(limitedLetters.getText()).toEqual('Output letters: abc');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
       });

       // There is a bug in safari and protractor that doesn't like the minus key
       // it('should update the output when -3 is entered', function() {
       //   numLimitInput.clear();
       //   numLimitInput.sendKeys('-3');
       //   letterLimitInput.clear();
       //   letterLimitInput.sendKeys('-3');
       //   longNumberLimitInput.clear();
       //   longNumberLimitInput.sendKeys('-3');
       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
       // });

       it('should not exceed the maximum size of input array', function() {
         numLimitInput.clear();
         numLimitInput.sendKeys('100');
         letterLimitInput.clear();
         letterLimitInput.sendKeys('100');
         longNumberLimitInput.clear();
         longNumberLimitInput.sendKeys('100');
         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
       });
     </file>
   </example>
*/
function limitToFilter() {
  return function(input, limit, begin) {
    if (Math.abs(Number(limit)) === Infinity) {
      limit = Number(limit);
    } else {
      limit = toInt(limit);
    }
    if (isNumberNaN(limit)) return input;

    if (isNumber(input)) input = input.toString();
    if (!isArrayLike(input)) return input;

    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;

    if (limit >= 0) {
      return sliceFn(input, begin, begin + limit);
    } else {
      if (begin === 0) {
        return sliceFn(input, limit, input.length);
      } else {
        return sliceFn(input, Math.max(0, begin + limit), begin);
      }
    }
  };
}

function sliceFn(input, begin, end) {
  if (isString(input)) return input.slice(begin, end);

  return slice.call(input, begin, end);
}

/**
 * @ngdoc filter
 * @name orderBy
 * @kind function
 *
 * @description
 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
 * function based on the values computed using the `expression` predicate.
 *
 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
 * `[{id: 'bar'}, {id: 'foo'}]`.
 *
 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
 * String, etc).
 *
 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
 * for the preceding one. The `expression` is evaluated against each item and the output is used
 * for comparing with other items.
 *
 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
 * ascending order.
 *
 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
 * strings alphabetically).
 *
 * ### Under the hood
 *
 * Ordering the specified `collection` happens in two phases:
 *
 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
 *    through a predicate that extracts the value of the `label` property, would be transformed to:
 *    ```
 *    {
 *      value: 'foo',
 *      type: 'string',
 *      index: ...
 *    }
 *    ```
 * 2. The comparator function is used to sort the items, based on the derived values, types and
 *    indices.
 *
 * If you use a custom comparator, it will be called with pairs of objects of the form
 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
 * second, or `1` otherwise.
 *
 * In order to ensure that the sorting will be deterministic across platforms, if none of the
 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
 * dummy predicate that returns the item's index as `value`.
 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
 *
 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
 * it to the comparator. The following rules govern the conversion:
 *
 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
 *    used instead.<br />
 *    (If the object has a `valueOf()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
 *    returns a primitive, its return value will be used instead.<br />
 *    (If the object has a `toString()` method that returns another object, then the returned object
 *    will be used in subsequent steps.)
 * 3. No conversion; the object itself is used.
 *
 * ### The default comparator
 *
 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
 * using their index in the original collection, and sorts values of different types by type.
 *
 * More specifically, it follows these steps to determine the relative order of items:
 *
 * 1. If the compared values are of different types, compare the types themselves alphabetically.
 * 2. If both values are of type `string`, compare them alphabetically in a case- and
 *    locale-insensitive way.
 * 3. If both values are objects, compare their indices instead.
 * 4. Otherwise, return:
 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
 *    -  `1`, otherwise.
 *
 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
 *           saved as numbers and not strings.
 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
 *           other values.
 *
 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
 *    predicates) to be used by the comparator to determine the order of elements.
 *
 *    Can be one of:
 *
 *    - `Function`: A getter function. This function will be called with each item as argument and
 *      the return value will be used for sorting.
 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
 *      result will be used for sorting. For example, use `'label'` to sort by a property called
 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
 *      property.<br />
 *      (The result of a constant expression is interpreted as a property name to be used for
 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
 *      property called `special name`.)<br />
 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
 *      relative order of two items, the next predicate is used as a tie-breaker.
 *
 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
 *
 * @param {boolean=} reverse - If `true`, reverse the sorting order.
 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
 *    value pairs. If omitted, the built-in comparator will be used.
 *
 * @returns {Array} - The sorted array.
 *
 *
 * @example
 * ### Ordering a table with `ngRepeat`
 *
 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
 * it defaults to the built-in comparator.
 *
   <example name="orderBy-static" module="orderByExample1">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <table class="friends">
           <tr>
             <th>Name</th>
             <th>Phone Number</th>
             <th>Age</th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:'-age'">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample1', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var names = element.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by age in reverse order', function() {
         expect(names.get(0).getText()).toBe('Adam');
         expect(names.get(1).getText()).toBe('Julie');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('John');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Changing parameters dynamically
 *
 * All parameters can be changed dynamically. The next example shows how you can make the columns of
 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
 *
   <example name="orderBy-dynamic" module="orderByExample2">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample2', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = friends;

           $scope.sortBy = function(propertyName) {
             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using `orderBy` inside a controller
 *
 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
 *
   <example name="orderBy-call-manually" module="orderByExample3">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
         <hr/>
         <button ng-click="sortBy(null)">Set to unsorted</button>
         <hr/>
         <table class="friends">
           <tr>
             <th>
               <button ng-click="sortBy('name')">Name</button>
               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('phone')">Phone Number</button>
               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
             </th>
             <th>
               <button ng-click="sortBy('age')">Age</button>
               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
             </th>
           </tr>
           <tr ng-repeat="friend in friends">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
             <td>{{friend.age}}</td>
           </tr>
         </table>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample3', [])
         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
           var friends = [
             {name: 'John',   phone: '555-1212',  age: 10},
             {name: 'Mary',   phone: '555-9876',  age: 19},
             {name: 'Mike',   phone: '555-4321',  age: 21},
             {name: 'Adam',   phone: '555-5678',  age: 35},
             {name: 'Julie',  phone: '555-8765',  age: 29}
           ];

           $scope.propertyName = 'age';
           $scope.reverse = true;
           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);

           $scope.sortBy = function(propertyName) {
             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                 ? !$scope.reverse : false;
             $scope.propertyName = propertyName;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
           };
         }]);
     </file>
     <file name="style.css">
       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }

       .sortorder:after {
         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
       }
       .sortorder.reverse:after {
         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var unsortButton = element(by.partialButtonText('unsorted'));
       var nameHeader = element(by.partialButtonText('Name'));
       var phoneHeader = element(by.partialButtonText('Phone'));
       var ageHeader = element(by.partialButtonText('Age'));
       var firstName = element(by.repeater('friends').column('friend.name').row(0));
       var lastName = element(by.repeater('friends').column('friend.name').row(4));

       it('should sort friends by some property, when clicking on the column header', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         phoneHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Mary');

         nameHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('Mike');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');
       });

       it('should sort friends in reverse order, when clicking on the same column', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         ageHeader.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Adam');

         ageHeader.click();
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');
       });

       it('should restore the original order, when clicking "Set to unsorted"', function() {
         expect(firstName.getText()).toBe('Adam');
         expect(lastName.getText()).toBe('John');

         unsortButton.click();
         expect(firstName.getText()).toBe('John');
         expect(lastName.getText()).toBe('Julie');
       });
     </file>
   </example>
 * <hr />
 *
 * @example
 * ### Using a custom comparator
 *
 * If you have very specific requirements about the way items are sorted, you can pass your own
 * comparator function. For example, you might need to compare some strings in a locale-sensitive
 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
 * argument - passing `false` retains the default sorting order, i.e. ascending.)
 *
   <example name="orderBy-custom-comparator" module="orderByExample4">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <div class="friends-container custom-comparator">
           <h3>Locale-sensitive Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
         <div class="friends-container default-comparator">
           <h3>Default Comparator</h3>
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Favorite Letter</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
               <td>{{friend.name}}</td>
               <td>{{friend.favoriteLetter}}</td>
             </tr>
           </table>
         </div>
       </div>
     </file>
     <file name="script.js">
       angular.module('orderByExample4', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.friends = [
             {name: 'John',   favoriteLetter: 'Ä'},
             {name: 'Mary',   favoriteLetter: 'Ü'},
             {name: 'Mike',   favoriteLetter: 'Ö'},
             {name: 'Adam',   favoriteLetter: 'H'},
             {name: 'Julie',  favoriteLetter: 'Z'}
           ];

           $scope.localeSensitiveComparator = function(v1, v2) {
             // If we don't get strings, just compare by index
             if (v1.type !== 'string' || v2.type !== 'string') {
               return (v1.index < v2.index) ? -1 : 1;
             }

             // Compare strings alphabetically, taking locale into account
             return v1.value.localeCompare(v2.value);
           };
         }]);
     </file>
     <file name="style.css">
       .friends-container {
         display: inline-block;
         margin: 0 30px;
       }

       .friends {
         border-collapse: collapse;
       }

       .friends th {
         border-bottom: 1px solid;
       }
       .friends td, .friends th {
         border-left: 1px solid;
         padding: 5px 10px;
       }
       .friends td:first-child, .friends th:first-child {
         border-left: none;
       }
     </file>
     <file name="protractor.js" type="protractor">
       // Element locators
       var container = element(by.css('.custom-comparator'));
       var names = container.all(by.repeater('friends').column('friend.name'));

       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
         expect(names.get(0).getText()).toBe('John');
         expect(names.get(1).getText()).toBe('Adam');
         expect(names.get(2).getText()).toBe('Mike');
         expect(names.get(3).getText()).toBe('Mary');
         expect(names.get(4).getText()).toBe('Julie');
       });
     </file>
   </example>
 *
 */
orderByFilter.$inject = ['$parse'];
function orderByFilter($parse) {
  return function(array, sortPredicate, reverseOrder, compareFn) {

    if (array == null) return array;
    if (!isArrayLike(array)) {
      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
    }

    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
    if (sortPredicate.length === 0) { sortPredicate = ['+']; }

    var predicates = processPredicates(sortPredicate);

    var descending = reverseOrder ? -1 : 1;

    // Define the `compare()` function. Use a default comparator if none is specified.
    var compare = isFunction(compareFn) ? compareFn : defaultCompare;

    // The next three lines are a version of a Swartzian Transform idiom from Perl
    // (sometimes called the Decorate-Sort-Undecorate idiom)
    // See https://en.wikipedia.org/wiki/Schwartzian_transform
    var compareValues = Array.prototype.map.call(array, getComparisonObject);
    compareValues.sort(doComparison);
    array = compareValues.map(function(item) { return item.value; });

    return array;

    function getComparisonObject(value, index) {
      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
      // This will be used to keep the sort stable when none of the input predicates can
      // distinguish between two elements.
      return {
        value: value,
        tieBreaker: {value: index, type: 'number', index: index},
        predicateValues: predicates.map(function(predicate) {
          return getPredicateValue(predicate.get(value), index);
        })
      };
    }

    function doComparison(v1, v2) {
      for (var i = 0, ii = predicates.length; i < ii; i++) {
        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
        if (result) {
          return result * predicates[i].descending * descending;
        }
      }

      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
    }
  };

  function processPredicates(sortPredicates) {
    return sortPredicates.map(function(predicate) {
      var descending = 1, get = identity;

      if (isFunction(predicate)) {
        get = predicate;
      } else if (isString(predicate)) {
        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
          descending = predicate.charAt(0) === '-' ? -1 : 1;
          predicate = predicate.substring(1);
        }
        if (predicate !== '') {
          get = $parse(predicate);
          if (get.constant) {
            var key = get();
            get = function(value) { return value[key]; };
          }
        }
      }
      return {get: get, descending: descending};
    });
  }

  function isPrimitive(value) {
    switch (typeof value) {
      case 'number': /* falls through */
      case 'boolean': /* falls through */
      case 'string':
        return true;
      default:
        return false;
    }
  }

  function objectValue(value) {
    // If `valueOf` is a valid function use that
    if (isFunction(value.valueOf)) {
      value = value.valueOf();
      if (isPrimitive(value)) return value;
    }
    // If `toString` is a valid function and not the one from `Object.prototype` use that
    if (hasCustomToString(value)) {
      value = value.toString();
      if (isPrimitive(value)) return value;
    }

    return value;
  }

  function getPredicateValue(value, index) {
    var type = typeof value;
    if (value === null) {
      type = 'string';
      value = 'null';
    } else if (type === 'object') {
      value = objectValue(value);
    }
    return {value: value, type: type, index: index};
  }

  function defaultCompare(v1, v2) {
    var result = 0;
    var type1 = v1.type;
    var type2 = v2.type;

    if (type1 === type2) {
      var value1 = v1.value;
      var value2 = v2.value;

      if (type1 === 'string') {
        // Compare strings case-insensitively
        value1 = value1.toLowerCase();
        value2 = value2.toLowerCase();
      } else if (type1 === 'object') {
        // For basic objects, use the position of the object
        // in the collection instead of the value
        if (isObject(value1)) value1 = v1.index;
        if (isObject(value2)) value2 = v2.index;
      }

      if (value1 !== value2) {
        result = value1 < value2 ? -1 : 1;
      }
    } else {
      result = type1 < type2 ? -1 : 1;
    }

    return result;
  }
}

function ngDirective(directive) {
  if (isFunction(directive)) {
    directive = {
      link: directive
    };
  }
  directive.restrict = directive.restrict || 'AC';
  return valueFn(directive);
}

/**
 * @ngdoc directive
 * @name a
 * @restrict E
 *
 * @description
 * Modifies the default behavior of the html a tag so that the default action is prevented when
 * the href attribute is empty.
 *
 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
 */
var htmlAnchorDirective = valueFn({
  restrict: 'E',
  compile: function(element, attr) {
    if (!attr.href && !attr.xlinkHref) {
      return function(scope, element) {
        // If the linked element is not an anchor tag anymore, do nothing
        if (element[0].nodeName.toLowerCase() !== 'a') return;

        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
                   'xlink:href' : 'href';
        element.on('click', function(event) {
          // if we have no href url, then don't navigate anywhere.
          if (!element.attr(href)) {
            event.preventDefault();
          }
        });
      };
    }
  }
});

/**
 * @ngdoc directive
 * @name ngHref
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in an href attribute will
 * make the link go to the wrong URL if the user clicks it before
 * Angular has a chance to replace the `{{hash}}` markup with its
 * value. Until Angular replaces the markup the link will be broken
 * and will most likely return a 404 error. The `ngHref` directive
 * solves this problem.
 *
 * The wrong way to write it:
 * ```html
 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
 * ```
 *
 * @element A
 * @param {template} ngHref any string which can contain `{{}}` markup.
 *
 * @example
 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
 * in links and their different behaviors:
    <example name="ng-href">
      <file name="index.html">
        <input ng-model="value" /><br />
        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
      </file>
      <file name="protractor.js" type="protractor">
        it('should execute ng-click but not reload when href without value', function() {
          element(by.id('link-1')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when href empty string', function() {
          element(by.id('link-2')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click and change url when ng-href specified', function() {
          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);

          element(by.id('link-3')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.

          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/123$/);
            });
          }, 5000, 'page should navigate to /123');
        });

        it('should execute ng-click but not reload when href empty string and name specified', function() {
          element(by.id('link-4')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
        });

        it('should execute ng-click but not reload when no href but name specified', function() {
          element(by.id('link-5')).click();
          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
        });

        it('should only change url when only ng-href', function() {
          element(by.model('value')).clear();
          element(by.model('value')).sendKeys('6');
          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);

          element(by.id('link-6')).click();

          // At this point, we navigate away from an Angular page, so we need
          // to use browser.driver to get the base webdriver.
          browser.wait(function() {
            return browser.driver.getCurrentUrl().then(function(url) {
              return url.match(/\/6$/);
            });
          }, 5000, 'page should navigate to /6');
        });
      </file>
    </example>
 */

/**
 * @ngdoc directive
 * @name ngSrc
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrc` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrc any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngSrcset
 * @restrict A
 * @priority 99
 *
 * @description
 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
 * work right: The browser will fetch from the URL with the literal
 * text `{{hash}}` until Angular replaces the expression inside
 * `{{hash}}`. The `ngSrcset` directive solves this problem.
 *
 * The buggy way to write it:
 * ```html
 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
 * ```
 *
 * The correct way to write it:
 * ```html
 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
 * ```
 *
 * @element IMG
 * @param {template} ngSrcset any string which can contain `{{}}` markup.
 */

/**
 * @ngdoc directive
 * @name ngDisabled
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * This directive sets the `disabled` attribute on the element if the
 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `disabled`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-disabled">
      <file name="index.html">
        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
        <button ng-model="button" ng-disabled="checked">Button</button>
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle button', function() {
          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
 *     then the `disabled` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngChecked
 * @restrict A
 * @priority 100
 *
 * @description
 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
 *
 * Note that this directive should not be used together with {@link ngModel `ngModel`},
 * as this can lead to unexpected behavior.
 *
 * A special directive is necessary because we cannot use interpolation inside the `checked`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-checked">
      <file name="index.html">
        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
      </file>
      <file name="protractor.js" type="protractor">
        it('should check both checkBoxes', function() {
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
          element(by.model('master')).click();
          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
 *     then the `checked` attribute will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngReadonly
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
 *
 * A special directive is necessary because we cannot use interpolation inside the `readonly`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * @example
    <example name="ng-readonly">
      <file name="index.html">
        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
      </file>
      <file name="protractor.js" type="protractor">
        it('should toggle readonly attr', function() {
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
          element(by.model('checked')).click();
          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element INPUT
 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
 *     then special attribute "readonly" will be set on the element
 */


/**
 * @ngdoc directive
 * @name ngSelected
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `selected`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * <div class="alert alert-warning">
 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
 *   selected options.
 * </div>
 *
 * @example
    <example name="ng-selected">
      <file name="index.html">
        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
        <select aria-label="ngSelected demo">
          <option>Hello!</option>
          <option id="greet" ng-selected="selected">Greetings!</option>
        </select>
      </file>
      <file name="protractor.js" type="protractor">
        it('should select Greetings!', function() {
          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
          element(by.model('selected')).click();
          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
        });
      </file>
    </example>
 *
 * @element OPTION
 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
 *     then special attribute "selected" will be set on the element
 */

/**
 * @ngdoc directive
 * @name ngOpen
 * @restrict A
 * @priority 100
 *
 * @description
 *
 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
 *
 * A special directive is necessary because we cannot use interpolation inside the `open`
 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
 *
 * ## A note about browser compatibility
 *
 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
 *
 * @example
     <example name="ng-open">
       <file name="index.html">
         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
         <details id="details" ng-open="open">
            <summary>Show/Hide me</summary>
         </details>
       </file>
       <file name="protractor.js" type="protractor">
         it('should toggle open', function() {
           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
           element(by.model('open')).click();
           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
         });
       </file>
     </example>
 *
 * @element DETAILS
 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
 *     then special attribute "open" will be set on the element
 */

var ngAttributeAliasDirectives = {};

// boolean attrs are evaluated
forEach(BOOLEAN_ATTR, function(propName, attrName) {
  // binding to multiple is not supported
  if (propName === 'multiple') return;

  function defaultLinkFn(scope, element, attr) {
    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
      attr.$set(attrName, !!value);
    });
  }

  var normalized = directiveNormalize('ng-' + attrName);
  var linkFn = defaultLinkFn;

  if (propName === 'checked') {
    linkFn = function(scope, element, attr) {
      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
      if (attr.ngModel !== attr[normalized]) {
        defaultLinkFn(scope, element, attr);
      }
    };
  }

  ngAttributeAliasDirectives[normalized] = function() {
    return {
      restrict: 'A',
      priority: 100,
      link: linkFn
    };
  };
});

// aliased input attrs are evaluated
forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
  ngAttributeAliasDirectives[ngAttr] = function() {
    return {
      priority: 100,
      link: function(scope, element, attr) {
        //special case ngPattern when a literal regular expression value
        //is used as the expression (this way we don't have to watch anything).
        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
          if (match) {
            attr.$set('ngPattern', new RegExp(match[1], match[2]));
            return;
          }
        }

        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
          attr.$set(ngAttr, value);
        });
      }
    };
  };
});

// ng-src, ng-srcset, ng-href are interpolated
forEach(['src', 'srcset', 'href'], function(attrName) {
  var normalized = directiveNormalize('ng-' + attrName);
  ngAttributeAliasDirectives[normalized] = function() {
    return {
      priority: 99, // it needs to run after the attributes are interpolated
      link: function(scope, element, attr) {
        var propName = attrName,
            name = attrName;

        if (attrName === 'href' &&
            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
          name = 'xlinkHref';
          attr.$attr[name] = 'xlink:href';
          propName = null;
        }

        attr.$observe(normalized, function(value) {
          if (!value) {
            if (attrName === 'href') {
              attr.$set(name, null);
            }
            return;
          }

          attr.$set(name, value);

          // on IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
          // to set the property as well to achieve the desired effect.
          // we use attr[attrName] value since $set can sanitize the url.
          if (msie && propName) element.prop(propName, attr[name]);
        });
      }
    };
  };
});

/* global -nullFormCtrl, -SUBMITTED_CLASS, addSetValidityMethod: true
 */
var nullFormCtrl = {
  $addControl: noop,
  $$renameControl: nullFormRenameControl,
  $removeControl: noop,
  $setValidity: noop,
  $setDirty: noop,
  $setPristine: noop,
  $setSubmitted: noop
},
SUBMITTED_CLASS = 'ng-submitted';

function nullFormRenameControl(control, name) {
  control.$name = name;
}

/**
 * @ngdoc type
 * @name form.FormController
 *
 * @property {boolean} $pristine True if user has not interacted with the form yet.
 * @property {boolean} $dirty True if user has already interacted with the form.
 * @property {boolean} $valid True if all of the containing forms and controls are valid.
 * @property {boolean} $invalid True if at least one containing control or form is invalid.
 * @property {boolean} $pending True if at least one containing control or form is pending.
 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
 *
 * @property {Object} $error Is an object hash, containing references to controls or
 *  forms with failing validators, where:
 *
 *  - keys are validation tokens (error names),
 *  - values are arrays of controls or forms that have a failing validator for given error name.
 *
 *  Built-in validation tokens:
 *
 *  - `email`
 *  - `max`
 *  - `maxlength`
 *  - `min`
 *  - `minlength`
 *  - `number`
 *  - `pattern`
 *  - `required`
 *  - `url`
 *  - `date`
 *  - `datetimelocal`
 *  - `time`
 *  - `week`
 *  - `month`
 *
 * @description
 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
 * such as being valid/invalid or dirty/pristine.
 *
 * Each {@link ng.directive:form form} directive creates an instance
 * of `FormController`.
 *
 */
//asks for $scope to fool the BC controller module
FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
function FormController(element, attrs, $scope, $animate, $interpolate) {
  var form = this,
      controls = [];

  // init state
  form.$error = {};
  form.$$success = {};
  form.$pending = undefined;
  form.$name = $interpolate(attrs.name || attrs.ngForm || '')($scope);
  form.$dirty = false;
  form.$pristine = true;
  form.$valid = true;
  form.$invalid = false;
  form.$submitted = false;
  form.$$parentForm = nullFormCtrl;

  /**
   * @ngdoc method
   * @name form.FormController#$rollbackViewValue
   *
   * @description
   * Rollback all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is typically needed by the reset button of
   * a form that uses `ng-model-options` to pend updates.
   */
  form.$rollbackViewValue = function() {
    forEach(controls, function(control) {
      control.$rollbackViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$commitViewValue
   *
   * @description
   * Commit all form controls pending updates to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  form.$commitViewValue = function() {
    forEach(controls, function(control) {
      control.$commitViewValue();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$addControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Register a control with the form. Input elements using ngModelController do this automatically
   * when they are linked.
   *
   * Note that the current state of the control will not be reflected on the new parent form. This
   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
   * state.
   *
   * However, if the method is used programmatically, for example by adding dynamically created controls,
   * or controls that have been previously removed without destroying their corresponding DOM element,
   * it's the developers responsibility to make sure the current state propagates to the parent form.
   *
   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
   */
  form.$addControl = function(control) {
    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
    // and not added to the scope.  Now we throw an error.
    assertNotHasOwnProperty(control.$name, 'input');
    controls.push(control);

    if (control.$name) {
      form[control.$name] = control;
    }

    control.$$parentForm = form;
  };

  // Private API: rename a form control
  form.$$renameControl = function(control, newName) {
    var oldName = control.$name;

    if (form[oldName] === control) {
      delete form[oldName];
    }
    form[newName] = control;
    control.$name = newName;
  };

  /**
   * @ngdoc method
   * @name form.FormController#$removeControl
   * @param {object} control control object, either a {@link form.FormController} or an
   * {@link ngModel.NgModelController}
   *
   * @description
   * Deregister a control from the form.
   *
   * Input elements using ngModelController do this automatically when they are destroyed.
   *
   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
   * different from case to case. For example, removing the only `$dirty` control from a form may or
   * may not mean that the form is still `$dirty`.
   */
  form.$removeControl = function(control) {
    if (control.$name && form[control.$name] === control) {
      delete form[control.$name];
    }
    forEach(form.$pending, function(value, name) {
      form.$setValidity(name, null, control);
    });
    forEach(form.$error, function(value, name) {
      form.$setValidity(name, null, control);
    });
    forEach(form.$$success, function(value, name) {
      form.$setValidity(name, null, control);
    });

    arrayRemove(controls, control);
    control.$$parentForm = nullFormCtrl;
  };


  /**
   * @ngdoc method
   * @name form.FormController#$setValidity
   *
   * @description
   * Sets the validity of a form control.
   *
   * This method will also propagate to parent forms.
   */
  addSetValidityMethod({
    ctrl: this,
    $element: element,
    set: function(object, property, controller) {
      var list = object[property];
      if (!list) {
        object[property] = [controller];
      } else {
        var index = list.indexOf(controller);
        if (index === -1) {
          list.push(controller);
        }
      }
    },
    unset: function(object, property, controller) {
      var list = object[property];
      if (!list) {
        return;
      }
      arrayRemove(list, controller);
      if (list.length === 0) {
        delete object[property];
      }
    },
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name form.FormController#$setDirty
   *
   * @description
   * Sets the form to a dirty state.
   *
   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
   * state (ng-dirty class). This method will also propagate to parent forms.
   */
  form.$setDirty = function() {
    $animate.removeClass(element, PRISTINE_CLASS);
    $animate.addClass(element, DIRTY_CLASS);
    form.$dirty = true;
    form.$pristine = false;
    form.$$parentForm.$setDirty();
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setPristine
   *
   * @description
   * Sets the form to its pristine state.
   *
   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
   * state to false.
   *
   * This method will also propagate to all the controls contained in this form.
   *
   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
   * saving or resetting it.
   */
  form.$setPristine = function() {
    $animate.setClass(element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
    form.$dirty = false;
    form.$pristine = true;
    form.$submitted = false;
    forEach(controls, function(control) {
      control.$setPristine();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setUntouched
   *
   * @description
   * Sets the form to its untouched state.
   *
   * This method can be called to remove the 'ng-touched' class and set the form controls to their
   * untouched state (ng-untouched class).
   *
   * Setting a form controls back to their untouched state is often useful when setting the form
   * back to its pristine state.
   */
  form.$setUntouched = function() {
    forEach(controls, function(control) {
      control.$setUntouched();
    });
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setSubmitted
   *
   * @description
   * Sets the form to its submitted state.
   */
  form.$setSubmitted = function() {
    $animate.addClass(element, SUBMITTED_CLASS);
    form.$submitted = true;
    form.$$parentForm.$setSubmitted();
  };
}

/**
 * @ngdoc directive
 * @name ngForm
 * @restrict EAC
 *
 * @description
 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
 * sub-group of controls needs to be determined.
 *
 * Note: the purpose of `ngForm` is to group controls,
 * but not to be a replacement for the `<form>` tag with all of its capabilities
 * (e.g. posting to the server, ...).
 *
 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 *
 */

 /**
 * @ngdoc directive
 * @name form
 * @restrict E
 *
 * @description
 * Directive that instantiates
 * {@link form.FormController FormController}.
 *
 * If the `name` attribute is specified, the form controller is published onto the current scope under
 * this name.
 *
 * # Alias: {@link ng.directive:ngForm `ngForm`}
 *
 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
 * of controls needs to be determined.
 *
 * # CSS classes
 *  - `ng-valid` is set if the form is valid.
 *  - `ng-invalid` is set if the form is invalid.
 *  - `ng-pending` is set if the form is pending.
 *  - `ng-pristine` is set if the form is pristine.
 *  - `ng-dirty` is set if the form is dirty.
 *  - `ng-submitted` is set if the form was submitted.
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 *
 * # Submitting a form and preventing the default action
 *
 * Since the role of forms in client-side Angular applications is different than in classical
 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
 * page reload that sends the data to the server. Instead some javascript logic should be triggered
 * to handle the form submission in an application-specific way.
 *
 * For this reason, Angular prevents the default action (form submission to the server) unless the
 * `<form>` element has an `action` attribute specified.
 *
 * You can use one of the following two ways to specify what javascript method should be called when
 * a form is submitted:
 *
 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
 * - {@link ng.directive:ngClick ngClick} directive on the first
  *  button or input field of type submit (input[type=submit])
 *
 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
 * or {@link ng.directive:ngClick ngClick} directives.
 * This is because of the following form submission rules in the HTML specification:
 *
 * - If a form has only one input field then hitting enter in this field triggers form submit
 * (`ngSubmit`)
 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
 * doesn't trigger submit
 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
 *
 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * ## Animation Hooks
 *
 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
 * other validations that are performed within the form. Animations in ngForm are similar to how
 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
 * as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style a form element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-form {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-form.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
      <file name="index.html">
       <script>
         angular.module('formExample', [])
           .controller('FormController', ['$scope', function($scope) {
             $scope.userType = 'guest';
           }]);
       </script>
       <style>
        .my-form {
          transition:all linear 0.5s;
          background: transparent;
        }
        .my-form.ng-invalid {
          background: red;
        }
       </style>
       <form name="myForm" ng-controller="FormController" class="my-form">
         userType: <input name="input" ng-model="userType" required>
         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
         <code>userType = {{userType}}</code><br>
         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
         <code>myForm.$valid = {{myForm.$valid}}</code><br>
         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        it('should initialize to model', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));

          expect(userType.getText()).toContain('guest');
          expect(valid.getText()).toContain('true');
        });

        it('should be invalid if empty', function() {
          var userType = element(by.binding('userType'));
          var valid = element(by.binding('myForm.input.$valid'));
          var userInput = element(by.model('userType'));

          userInput.clear();
          userInput.sendKeys('');

          expect(userType.getText()).toEqual('userType =');
          expect(valid.getText()).toContain('false');
        });
      </file>
    </example>
 *
 * @param {string=} name Name of the form. If specified, the form controller will be published into
 *                       related scope, under this name.
 */
var formDirectiveFactory = function(isNgForm) {
  return ['$timeout', '$parse', function($timeout, $parse) {
    var formDirective = {
      name: 'form',
      restrict: isNgForm ? 'EAC' : 'E',
      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
      controller: FormController,
      compile: function ngFormCompile(formElement, attr) {
        // Setup initial state of the control
        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);

        return {
          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
            var controller = ctrls[0];

            // if `action` attr is not present on the form, prevent the default action (submission)
            if (!('action' in attr)) {
              // we can't use jq events because if a form is destroyed during submission the default
              // action is not prevented. see #1238
              //
              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
              // page reload if the form was destroyed by submission of the form via a click handler
              // on a button in the form. Looks like an IE9 specific bug.
              var handleFormSubmission = function(event) {
                scope.$apply(function() {
                  controller.$commitViewValue();
                  controller.$setSubmitted();
                });

                event.preventDefault();
              };

              addEventListenerFn(formElement[0], 'submit', handleFormSubmission);

              // unregister the preventDefault listener so that we don't not leak memory but in a
              // way that will achieve the prevention of the default action.
              formElement.on('$destroy', function() {
                $timeout(function() {
                  removeEventListenerFn(formElement[0], 'submit', handleFormSubmission);
                }, 0, false);
              });
            }

            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
            parentFormCtrl.$addControl(controller);

            var setter = nameAttr ? getSetter(controller.$name) : noop;

            if (nameAttr) {
              setter(scope, controller);
              attr.$observe(nameAttr, function(newValue) {
                if (controller.$name === newValue) return;
                setter(scope, undefined);
                controller.$$parentForm.$$renameControl(controller, newValue);
                setter = getSetter(controller.$name);
                setter(scope, controller);
              });
            }
            formElement.on('$destroy', function() {
              controller.$$parentForm.$removeControl(controller);
              setter(scope, undefined);
              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
            });
          }
        };
      }
    };

    return formDirective;

    function getSetter(expression) {
      if (expression === '') {
        //create an assignable expression, so forms with an empty name can be renamed later
        return $parse('this[""]').assign;
      }
      return $parse(expression).assign || noop;
    }
  }];
};

var formDirective = formDirectiveFactory();
var ngFormDirective = formDirectiveFactory(true);

/* global
  VALID_CLASS: false,
  INVALID_CLASS: false,
  PRISTINE_CLASS: false,
  DIRTY_CLASS: false,
  ngModelMinErr: false
*/

// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
// Note: We are being more lenient, because browsers are too.
//   1. Scheme
//   2. Slashes
//   3. Username
//   4. Password
//   5. Hostname
//   6. Port
//   7. Path
//   8. Query
//   9. Fragment
//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
// eslint-disable-next-line max-len
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
var PARTIAL_VALIDATION_TYPES = createMap();
forEach('date,datetime-local,month,time,week'.split(','), function(type) {
  PARTIAL_VALIDATION_TYPES[type] = true;
});

var inputType = {

  /**
   * @ngdoc input
   * @name input[text]
   *
   * @description
   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Adds `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="text-input-directive" module="textInputExample">
        <file name="index.html">
         <script>
           angular.module('textInputExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 text: 'guest',
                 word: /^\s*\w*\s*$/
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Single word:
             <input type="text" name="input" ng-model="example.text"
                    ng-pattern="example.word" required ng-trim="false">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.pattern">
               Single word only!</span>
           </div>
           <code>text = {{example.text}}</code><br/>
           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('example.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('guest');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if multi word', function() {
            input.clear();
            input.sendKeys('hello world');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise Angular will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable angular expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange Angular expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));

        // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }

        it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });

        it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });

        it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
  'date': createDateInputType('date', DATE_REGEXP,
         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
         'yyyy-MM-dd'),

   /**
    * @ngdoc input
    * @name input[datetime-local]
    *
    * @description
    * Input with datetime validation and transformation. In browsers that do not yet support
    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `min` will also add native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
    *   Note that `max` will also add native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="datetimelocal-input-directive" module="dateExample">
    <file name="index.html">
      <script>
        angular.module('dateExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2010, 11, 28, 14, 57)
            };
          }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a date between in 2013:</label>
        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.datetimelocal">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2010-12-28T14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01-01T23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
      'yyyy-MM-ddTHH:mm:ss.sss'),

  /**
   * @ngdoc input
   * @name input[time]
   *
   * @description
   * Input with time validation and transformation. In browsers that do not yet support
   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="time-input-directive" module="timeExample">
   <file name="index.html">
     <script>
      angular.module('timeExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(1970, 0, 1, 14, 57, 0)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
        <input type="time" id="exampleInput" name="input" ng-model="example.value"
            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.time">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('14:57:00');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('23:59:00');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'time': createDateInputType('time', TIME_REGEXP,
      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
     'HH:mm:ss.sss'),

   /**
    * @ngdoc input
    * @name input[week]
    *
    * @description
    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
    * week format (yyyy-W##), for example: `2013-W02`.
    *
    * The model must always be a Date object, otherwise Angular will throw an error.
    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
    *
    * The timezone to be used to read/write the `Date` instance in the model can be defined using
    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
    *
    * @param {string} ngModel Assignable angular expression to data-bind to.
    * @param {string=} name Property name of the form under which the control is published.
    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
    *   native HTML5 constraint validation.
    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
    *   native HTML5 constraint validation.
    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    * @param {string=} required Sets `required` validation error key if the value is not entered.
    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
    *    `required` when you want to data-bind to the `required` attribute.
    * @param {string=} ngChange Angular expression to be executed when input changes due to user
    *    interaction with the input element.
    *
    * @example
    <example name="week-input-directive" module="weekExample">
    <file name="index.html">
      <script>
      angular.module('weekExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 0, 3)
          };
        }]);
      </script>
      <form name="myForm" ng-controller="DateController as dateCtrl">
        <label>Pick a date between in 2013:
          <input id="exampleInput" type="week" name="input" ng-model="example.value"
                 placeholder="YYYY-W##" min="2012-W32"
                 max="2013-W52" required />
        </label>
        <div role="alert">
          <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
          <span class="error" ng-show="myForm.input.$error.week">
              Not a valid date!</span>
        </div>
        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-Www"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-W01');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-W01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
    </file>
    </example>
    */
  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

  /**
   * @ngdoc input
   * @name input[month]
   *
   * @description
   * Input with month validation and transformation. In browsers that do not yet support
   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
   * month format (yyyy-MM), for example: `2009-01`.
   *
   * The model must always be a Date object, otherwise Angular will throw an error.
   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
   * If the model is not set to the first of the month, the next view to model update will set it
   * to the first of the month.
   *
   * The timezone to be used to read/write the `Date` instance in the model can be defined using
   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
   *   native HTML5 constraint validation.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
   *   native HTML5 constraint validation.
   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.

   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
   <example name="month-input-directive" module="monthExample">
   <file name="index.html">
     <script>
      angular.module('monthExample', [])
        .controller('DateController', ['$scope', function($scope) {
          $scope.example = {
            value: new Date(2013, 9, 1)
          };
        }]);
     </script>
     <form name="myForm" ng-controller="DateController as dateCtrl">
       <label for="exampleInput">Pick a month in 2013:</label>
       <input id="exampleInput" type="month" name="input" ng-model="example.value"
          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
       <div role="alert">
         <span class="error" ng-show="myForm.input.$error.required">
            Required!</span>
         <span class="error" ng-show="myForm.input.$error.month">
            Not a valid month!</span>
       </div>
       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
     </form>
   </file>
   <file name="protractor.js" type="protractor">
      var value = element(by.binding('example.value | date: "yyyy-MM"'));
      var valid = element(by.binding('myForm.input.$valid'));

      // currently protractor/webdriver does not support
      // sending keys to all known HTML5 input controls
      // for various browsers (https://github.com/angular/protractor/issues/562).
      function setInput(val) {
        // set the value of the element and force validation.
        var scr = "var ipt = document.getElementById('exampleInput'); " +
        "ipt.value = '" + val + "';" +
        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
        browser.executeScript(scr);
      }

      it('should initialize to model', function() {
        expect(value.getText()).toContain('2013-10');
        expect(valid.getText()).toContain('myForm.input.$valid = true');
      });

      it('should be invalid if empty', function() {
        setInput('');
        expect(value.getText()).toEqual('value =');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });

      it('should be invalid if over max', function() {
        setInput('2015-01');
        expect(value.getText()).toContain('');
        expect(valid.getText()).toContain('myForm.input.$valid = false');
      });
   </file>
   </example>
   */
  'month': createDateInputType('month', MONTH_REGEXP,
     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
     'yyyy-MM'),

  /**
   * @ngdoc input
   * @name input[number]
   *
   * @description
   * Text input with number validation and transformation. Sets the `number` validation
   * error if not a valid number.
   *
   * <div class="alert alert-warning">
   * The model must always be of type `number` otherwise Angular will throw an error.
   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
   * error docs for more information and an example of how to convert your model if necessary.
   * </div>
   *
   * ## Issues with HTML5 constraint validation
   *
   * In browsers that follow the
   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
   * If a non-number is entered in the input, the browser will report the value as an empty string,
   * which means the view / model values in `ngModel` and subsequently the scope value
   * will also be an empty string.
   *
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="number-input-directive" module="numberExample">
        <file name="index.html">
         <script>
           angular.module('numberExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.example = {
                 value: 12
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Number:
             <input type="number" name="input" ng-model="example.value"
                    min="0" max="99" required>
          </label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.number">
               Not valid number!</span>
           </div>
           <tt>value = {{example.value}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('example.value'));

          it('should initialize to model', function() {
            expect(value.getText()).toContain('12');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if over max', function() {
            input.clear();
            input.sendKeys('123');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'number': numberInputType,


  /**
   * @ngdoc input
   * @name input[url]
   *
   * @description
   * Text input with URL validation. Sets the `url` validation error key if the content is not a
   * valid URL.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
   * the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="url-input-directive" module="urlExample">
        <file name="index.html">
         <script>
           angular.module('urlExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.url = {
                 text: 'http://google.com'
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>URL:
             <input type="url" name="input" ng-model="url.text" required>
           <label>
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
             <span class="error" ng-show="myForm.input.$error.url">
               Not valid url!</span>
           </div>
           <tt>text = {{url.text}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('url.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('url.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('http://google.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');

            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not url', function() {
            input.clear();
            input.sendKeys('box');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'url': urlInputType,


  /**
   * @ngdoc input
   * @name input[email]
   *
   * @description
   * Text input with email validation. Sets the `email` validation error key if not a valid email
   * address.
   *
   * <div class="alert alert-warning">
   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
   * </div>
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
   *    any length.
   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
   *    that contains the regular expression body that will be converted to a regular expression
   *    as in the ngPattern directive.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="email-input-directive" module="emailExample">
        <file name="index.html">
         <script>
           angular.module('emailExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.email = {
                 text: 'me@example.com'
               };
             }]);
         </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Email:
               <input type="email" name="input" ng-model="email.text" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.email">
                 Not valid email!</span>
             </div>
             <tt>text = {{email.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
           </form>
         </file>
        <file name="protractor.js" type="protractor">
          var text = element(by.binding('email.text'));
          var valid = element(by.binding('myForm.input.$valid'));
          var input = element(by.model('email.text'));

          it('should initialize to model', function() {
            expect(text.getText()).toContain('me@example.com');
            expect(valid.getText()).toContain('true');
          });

          it('should be invalid if empty', function() {
            input.clear();
            input.sendKeys('');
            expect(text.getText()).toEqual('text =');
            expect(valid.getText()).toContain('false');
          });

          it('should be invalid if not email', function() {
            input.clear();
            input.sendKeys('xxx');

            expect(valid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  'email': emailInputType,


  /**
   * @ngdoc input
   * @name input[radio]
   *
   * @description
   * HTML radio button.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string} value The value to which the `ngModel` expression should be set when selected.
   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
   *    is selected. Should be used instead of the `value` attribute if you need
   *    a non-string `ngModel` (`boolean`, `array`, ...).
   *
   * @example
      <example name="radio-input-directive" module="radioExample">
        <file name="index.html">
         <script>
           angular.module('radioExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.color = {
                 name: 'blue'
               };
               $scope.specialValue = {
                 "id": "12345",
                 "value": "green"
               };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>
             <input type="radio" ng-model="color.name" value="red">
             Red
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" ng-value="specialValue">
             Green
           </label><br/>
           <label>
             <input type="radio" ng-model="color.name" value="blue">
             Blue
           </label><br/>
           <tt>color = {{color.name | json}}</tt><br/>
          </form>
          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var inputs = element.all(by.model('color.name'));
            var color = element(by.binding('color.name'));

            expect(color.getText()).toContain('blue');

            inputs.get(0).click();
            expect(color.getText()).toContain('red');

            inputs.get(1).click();
            expect(color.getText()).toContain('green');
          });
        </file>
      </example>
   */
  'radio': radioInputType,

  /**
   * @ngdoc input
   * @name input[range]
   *
   * @description
   * Native range input with validation and transformation.
   *
   * <div class="alert alert-warning">
   *   <p>
   *     In v1.5.9+, in order to avoid interfering with already existing, custom directives for
   *     `input[range]`, you need to let Angular know that you want to enable its built-in support.
   *     You can do this by adding the `ng-input-range` attribute to the input element. E.g.:
   *     `<input type="range" ng-input-range ... />`
   *   </p><br />
   *   <p>
   *     Input elements without the `ng-input-range` attibute will continue to be treated the same
   *     as in previous versions (e.g. their model value will be a string not a number and Angular
   *     will not take `min`/`max`/`step` attributes and properties into account).
   *   </p><br />
   *   <p>
   *     **Note:** From v1.6.x onwards, the support for `input[range]` will be always enabled and
   *     the `ng-input-range` attribute will have no effect.
   *   </p><br />
   *   <p>
   *     This documentation page refers to elements which have the built-in support enabled; i.e.
   *     elements _with_ the `ng-input-range` attribute.
   *   </p>
   * </div>
   *
   * The model for the range input must always be a `Number`.
   *
   * IE9 and other browsers that do not support the `range` type fall back
   * to a text input without any default values for `min`, `max` and `step`. Model binding,
   * validation and number parsing are nevertheless supported.
   *
   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
   * in a way that never allows the input to hold an invalid value. That means:
   * - any non-numerical value is set to `(max + min) / 2`.
   * - any numerical value that is less than the current min val, or greater than the current max val
   * is set to the min / max val respectively.
   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
   * is used.
   *
   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
   * for more info.
   *
   * This has the following consequences for Angular:
   *
   * Since the element value should always reflect the current model value, a range input
   * will set the bound ngModel expression to the value that the browser has set for the
   * input element. For example, in the following input `<input type="range" ng-input-range ng-model="model.value">`,
   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
   *
   * That means the model for range will immediately be set to `50` after `ngModel` has been
   * initialized. It also means a range input can never have the required error.
   *
   * This does not only affect changes to the model value, but also to the values of the `min`,
   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
   * the input value, Angular will also update the model value.
   *
   * Automatic value adjustment also means that a range input element can never have the `required`,
   * `min`, or `max` errors.
   *
   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
   * when the step value changes dynamically - they do not adjust the element value correctly, but
   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
   * error on the input, and set the model to `undefined`.
   *
   * Note that `input[range]` is not compatible with `ngMax`, `ngMin`, and `ngStep`, because they do
   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
   *
   * @param           ngInputRange The presense of this attribute enables the built-in support for
   *                  `input[range]`.
   * @param {string}  ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
   *                  than `min`. Can be interpolated.
   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
   *                  Can be interpolated.
   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
   *                  Can be interpolated.
   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
   *                  to user interaction with the input element.
   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
   *
   * @example
      <example name="range-input-directive" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">

            Model as range: <input type="range" ng-input-range name="range" ng-model="value" min="{{min}}"  max="{{max}}">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   * ## Range Input with ngMin & ngMax attributes

   * @example
      <example name="range-input-directive-ng" module="rangeExample">
        <file name="index.html">
          <script>
            angular.module('rangeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.value = 75;
                $scope.min = 10;
                $scope.max = 90;
              }]);
          </script>
          <form name="myForm" ng-controller="ExampleController">
            Model as range: <input type="range" ng-input-range name="range" ng-model="value" ng-min="min" ng-max="max">
            <hr>
            Model as number: <input type="number" ng-model="value"><br>
            Min: <input type="number" ng-model="min"><br>
            Max: <input type="number" ng-model="max"><br>
            value = <code>{{value}}</code><br/>
            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
            myForm.range.$error = <code>{{myForm.range.$error}}</code>
          </form>
        </file>
      </example>

   */
  'range': rangeInputType,

  /**
   * @ngdoc input
   * @name input[checkbox]
   *
   * @description
   * HTML checkbox.
   *
   * @param {string} ngModel Assignable angular expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
   * @param {string=} ngChange Angular expression to be executed when input changes due to user
   *    interaction with the input element.
   *
   * @example
      <example name="checkbox-input-directive" module="checkboxExample">
        <file name="index.html">
         <script>
           angular.module('checkboxExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.checkboxModel = {
                value1 : true,
                value2 : 'YES'
              };
             }]);
         </script>
         <form name="myForm" ng-controller="ExampleController">
           <label>Value1:
             <input type="checkbox" ng-model="checkboxModel.value1">
           </label><br/>
           <label>Value2:
             <input type="checkbox" ng-model="checkboxModel.value2"
                    ng-true-value="'YES'" ng-false-value="'NO'">
            </label><br/>
           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          it('should change state', function() {
            var value1 = element(by.binding('checkboxModel.value1'));
            var value2 = element(by.binding('checkboxModel.value2'));

            expect(value1.getText()).toContain('true');
            expect(value2.getText()).toContain('YES');

            element(by.model('checkboxModel.value1')).click();
            element(by.model('checkboxModel.value2')).click();

            expect(value1.getText()).toContain('false');
            expect(value2.getText()).toContain('NO');
          });
        </file>
      </example>
   */
  'checkbox': checkboxInputType,

  'hidden': noop,
  'button': noop,
  'submit': noop,
  'reset': noop,
  'file': noop
};

function stringBasedInputType(ctrl) {
  ctrl.$formatters.push(function(value) {
    return ctrl.$isEmpty(value) ? value : value.toString();
  });
}

function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);
}

function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  var type = lowercase(element[0].type);

  // In composition mode, users are still inputting intermediate text buffer,
  // hold the listener until composition is done.
  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
  if (!$sniffer.android) {
    var composing = false;

    element.on('compositionstart', function() {
      composing = true;
    });

    element.on('compositionend', function() {
      composing = false;
      listener();
    });
  }

  var timeout;

  var listener = function(ev) {
    if (timeout) {
      $browser.defer.cancel(timeout);
      timeout = null;
    }
    if (composing) return;
    var value = element.val(),
        event = ev && ev.type;

    // By default we will trim the value
    // If the attribute ng-trim exists we will avoid trimming
    // If input type is 'password', the value is never trimmed
    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
      value = trim(value);
    }

    // If a control is suffering from bad input (due to native validators), browsers discard its
    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
    // control's value is the same empty value twice in a row.
    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
      ctrl.$setViewValue(value, event);
    }
  };

  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
  // input event on backspace, delete or cut
  if ($sniffer.hasEvent('input')) {
    element.on('input', listener);
  } else {
    var deferListener = function(ev, input, origValue) {
      if (!timeout) {
        timeout = $browser.defer(function() {
          timeout = null;
          if (!input || input.value !== origValue) {
            listener(ev);
          }
        });
      }
    };

    element.on('keydown', /** @this */ function(event) {
      var key = event.keyCode;

      // ignore
      //    command            modifiers                   arrows
      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;

      deferListener(event, this, this.value);
    });

    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
    if ($sniffer.hasEvent('paste')) {
      element.on('paste cut', deferListener);
    }
  }

  // if user paste into input using mouse on older browser
  // or form autocomplete on newer browser, we need "change" event to catch it
  element.on('change', listener);

  // Some native input types (date-family) have the ability to change validity without
  // firing any input/change events.
  // For these event types, when native validators are present and the browser supports the type,
  // check for validity changes on various DOM events.
  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
      if (!timeout) {
        var validity = this[VALIDITY_STATE_PROPERTY];
        var origBadInput = validity.badInput;
        var origTypeMismatch = validity.typeMismatch;
        timeout = $browser.defer(function() {
          timeout = null;
          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
            listener(ev);
          }
        });
      }
    });
  }

  ctrl.$render = function() {
    // Workaround for Firefox validation #12102.
    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
    if (element.val() !== value) {
      element.val(value);
    }
  };
}

function weekParser(isoWeek, existingDate) {
  if (isDate(isoWeek)) {
    return isoWeek;
  }

  if (isString(isoWeek)) {
    WEEK_REGEXP.lastIndex = 0;
    var parts = WEEK_REGEXP.exec(isoWeek);
    if (parts) {
      var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;

      if (existingDate) {
        hours = existingDate.getHours();
        minutes = existingDate.getMinutes();
        seconds = existingDate.getSeconds();
        milliseconds = existingDate.getMilliseconds();
      }

      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
    }
  }

  return NaN;
}

function createDateParser(regexp, mapping) {
  return function(iso, date) {
    var parts, map;

    if (isDate(iso)) {
      return iso;
    }

    if (isString(iso)) {
      // When a date is JSON'ified to wraps itself inside of an extra
      // set of double quotes. This makes the date parsing code unable
      // to match the date string and parse it as a date.
      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
        iso = iso.substring(1, iso.length - 1);
      }
      if (ISO_DATE_REGEXP.test(iso)) {
        return new Date(iso);
      }
      regexp.lastIndex = 0;
      parts = regexp.exec(iso);

      if (parts) {
        parts.shift();
        if (date) {
          map = {
            yyyy: date.getFullYear(),
            MM: date.getMonth() + 1,
            dd: date.getDate(),
            HH: date.getHours(),
            mm: date.getMinutes(),
            ss: date.getSeconds(),
            sss: date.getMilliseconds() / 1000
          };
        } else {
          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
        }

        forEach(parts, function(part, index) {
          if (index < mapping.length) {
            map[mapping[index]] = +part;
          }
        });
        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
      }
    }

    return NaN;
  };
}

function createDateInputType(type, regexp, parseDate, format) {
  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
    badInputChecker(scope, element, attr, ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var timezone = ctrl && ctrl.$options && ctrl.$options.timezone;
    var previousDate;

    ctrl.$$parserName = type;
    ctrl.$parsers.push(function(value) {
      if (ctrl.$isEmpty(value)) return null;
      if (regexp.test(value)) {
        // Note: We cannot read ctrl.$modelValue, as there might be a different
        // parser/formatter in the processing chain so that the model
        // contains some different data format!
        var parsedDate = parseDate(value, previousDate);
        if (timezone) {
          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
        }
        return parsedDate;
      }
      return undefined;
    });

    ctrl.$formatters.push(function(value) {
      if (value && !isDate(value)) {
        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
      }
      if (isValidDate(value)) {
        previousDate = value;
        if (previousDate && timezone) {
          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
        }
        return $filter('date')(value, format, timezone);
      } else {
        previousDate = null;
        return '';
      }
    });

    if (isDefined(attr.min) || attr.ngMin) {
      var minVal;
      ctrl.$validators.min = function(value) {
        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
      };
      attr.$observe('min', function(val) {
        minVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal;
      ctrl.$validators.max = function(value) {
        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
      };
      attr.$observe('max', function(val) {
        maxVal = parseObservedDateValue(val);
        ctrl.$validate();
      });
    }

    function isValidDate(value) {
      // Invalid Date: getTime() returns NaN
      return value && !(value.getTime && value.getTime() !== value.getTime());
    }

    function parseObservedDateValue(val) {
      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
    }
  };
}

function badInputChecker(scope, element, attr, ctrl) {
  var node = element[0];
  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
  if (nativeValidation) {
    ctrl.$parsers.push(function(value) {
      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
      return validity.badInput || validity.typeMismatch ? undefined : value;
    });
  }
}

function numberFormatterParser(ctrl) {
  ctrl.$$parserName = 'number';
  ctrl.$parsers.push(function(value) {
    if (ctrl.$isEmpty(value))      return null;
    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
    return undefined;
  });

  ctrl.$formatters.push(function(value) {
    if (!ctrl.$isEmpty(value)) {
      if (!isNumber(value)) {
        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
      }
      value = value.toString();
    }
    return value;
  });
}

function parseNumberAttrVal(val) {
  if (isDefined(val) && !isNumber(val)) {
    val = parseFloat(val);
  }
  return !isNumberNaN(val) ? val : undefined;
}

function isNumberInteger(num) {
  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
  // (minus the assumption that `num` is a number)

  // eslint-disable-next-line no-bitwise
  return (num | 0) === num;
}

function countDecimals(num) {
  var numString = num.toString();
  var decimalSymbolIndex = numString.indexOf('.');

  if (decimalSymbolIndex === -1) {
    if (-1 < num && num < 1) {
      // It may be in the exponential notation format (`1e-X`)
      var match = /e-(\d+)$/.exec(numString);

      if (match) {
        return Number(match[1]);
      }
    }

    return 0;
  }

  return numString.length - decimalSymbolIndex - 1;
}

function isValidForStep(viewValue, stepBase, step) {
  // At this point `stepBase` and `step` are expected to be non-NaN values
  // and `viewValue` is expected to be a valid stringified number.
  var value = Number(viewValue);

  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
  if (!isNumberInteger(value) || !isNumberInteger(stepBase) || !isNumberInteger(step)) {
    var decimalCount = Math.max(countDecimals(value), countDecimals(stepBase), countDecimals(step));
    var multiplier = Math.pow(10, decimalCount);

    value = value * multiplier;
    stepBase = stepBase * multiplier;
    step = step * multiplier;
  }

  return (value - stepBase) % step === 0;
}

function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  numberFormatterParser(ctrl);

  var minVal;
  var maxVal;

  if (isDefined(attr.min) || attr.ngMin) {
    ctrl.$validators.min = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
    };

    attr.$observe('min', function(val) {
      minVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }

  if (isDefined(attr.max) || attr.ngMax) {
    ctrl.$validators.max = function(value) {
      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
    };

    attr.$observe('max', function(val) {
      maxVal = parseNumberAttrVal(val);
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    });
  }
}

function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  badInputChecker(scope, element, attr, ctrl);
  numberFormatterParser(ctrl);
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);

  var originalRender = ctrl.$render;

  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } :
    originalRender;

  if (hasMinAttr) {
    ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() { return true; } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

    setInitialValueAndObserver('min', minChange);
  }

  if (hasMaxAttr) {
    ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() { return true; } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

    setInitialValueAndObserver('max', maxChange);
  }

  if (hasStepAttr) {
    ctrl.$validators.step = supportsRange ?
      function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
               isValidForStep(viewValue, minVal || 0, stepVal);
      };

    setInitialValueAndObserver('step', stepChange);
  }

  function setInitialValueAndObserver(htmlAttrName, changeFn) {
    // interpolated attributes set the attribute value only after a digest, but we need the
    // attribute value when the input is first rendered, so that the browser can adjust the
    // input value based on the min/max value
    element.attr(htmlAttrName, attr[htmlAttrName]);
    attr.$observe(htmlAttrName, changeFn);
  }

  function minChange(val) {
    minVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
      if (minVal > elVal) {
        elVal = minVal;
        element.val(elVal);
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function maxChange(val) {
    maxVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    if (supportsRange) {
      var elVal = element.val();
      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
      if (maxVal < elVal) {
        element.val(maxVal);
        // IE11 and Chrome don't set the value to the minVal when max < min
        elVal = maxVal < minVal ? minVal : maxVal;
      }
      ctrl.$setViewValue(elVal);
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }

  function stepChange(val) {
    stepVal = parseNumberAttrVal(val);
    // ignore changes before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
    if (supportsRange && ctrl.$viewValue !== element.val()) {
      ctrl.$setViewValue(element.val());
    } else {
      // TODO(matsko): implement validateLater to reduce number of validations
      ctrl.$validate();
    }
  }
}

function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'url';
  ctrl.$validators.url = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
  };
}

function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
  // Note: no badInputChecker here by purpose as `url` is only a validation
  // in browsers, i.e. we can always read out input.value even if it is not valid!
  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
  stringBasedInputType(ctrl);

  ctrl.$$parserName = 'email';
  ctrl.$validators.email = function(modelValue, viewValue) {
    var value = modelValue || viewValue;
    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
  };
}

function radioInputType(scope, element, attr, ctrl) {
  // make the name unique, if not defined
  if (isUndefined(attr.name)) {
    element.attr('name', nextUid());
  }

  var listener = function(ev) {
    if (element[0].checked) {
      ctrl.$setViewValue(attr.value, ev && ev.type);
    }
  };

  element.on('click', listener);

  ctrl.$render = function() {
    var value = attr.value;
    // We generally use strict comparison. This is behavior we cannot change without a BC.
    // eslint-disable-next-line eqeqeq
    element[0].checked = (value == ctrl.$viewValue);
  };

  attr.$observe('value', ctrl.$render);
}

function parseConstantExpr($parse, context, name, expression, fallback) {
  var parseFn;
  if (isDefined(expression)) {
    parseFn = $parse(expression);
    if (!parseFn.constant) {
      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                                   '`{1}`.', name, expression);
    }
    return parseFn(context);
  }
  return fallback;
}

function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

  var listener = function(ev) {
    ctrl.$setViewValue(element[0].checked, ev && ev.type);
  };

  element.on('click', listener);

  ctrl.$render = function() {
    element[0].checked = ctrl.$viewValue;
  };

  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
  // it to a boolean.
  ctrl.$isEmpty = function(value) {
    return value === false;
  };

  ctrl.$formatters.push(function(value) {
    return equals(value, trueValue);
  });

  ctrl.$parsers.push(function(value) {
    return value ? trueValue : falseValue;
  });
}


/**
 * @ngdoc directive
 * @name textarea
 * @restrict E
 *
 * @description
 * HTML textarea element control with angular data-binding. The data-binding and validation
 * properties of this element are exactly the same as those of the
 * {@link ng.directive:input input element}.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 *
 * @knownIssue
 *
 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
 * insert the placeholder value as the textarea's content. If the placeholder value contains
 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
 * the value of the by-then-removed text node. This doesn't affect the functionality of the
 * textarea, but can be undesirable.
 *
 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
 * find more details on `ngAttr` in the
 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
 * Developer Guide.
 */


/**
 * @ngdoc directive
 * @name input
 * @restrict E
 *
 * @description
 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
 * input state control, and validation.
 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
 *
 * <div class="alert alert-warning">
 * **Note:** Not every feature offered is available for all input types.
 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
 * </div>
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {boolean=} ngRequired Sets `required` attribute if set to true
 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
 *    minlength.
 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
 *    length.
 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
 *    If the expression evaluates to a RegExp object, then this is used directly.
 *    If the expression evaluates to a string, then it will be converted to a RegExp
 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
 *    `new RegExp('^abc$')`.<br />
 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 *    start at the index of the last search's match, thus not taking the whole input value into
 *    account.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
 *    This parameter is ignored for input[type=password] controls, which will never trim the
 *    input.
 *
 * @example
    <example name="input-directive" module="inputExample">
      <file name="index.html">
       <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.user = {name: 'guest', last: 'visitor'};
            }]);
       </script>
       <div ng-controller="ExampleController">
         <form name="myForm">
           <label>
              User name:
              <input type="text" name="userName" ng-model="user.name" required>
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.userName.$error.required">
              Required!</span>
           </div>
           <label>
              Last name:
              <input type="text" name="lastName" ng-model="user.last"
              ng-minlength="3" ng-maxlength="10">
           </label>
           <div role="alert">
             <span class="error" ng-show="myForm.lastName.$error.minlength">
               Too short!</span>
             <span class="error" ng-show="myForm.lastName.$error.maxlength">
               Too long!</span>
           </div>
         </form>
         <hr>
         <tt>user = {{user}}</tt><br/>
         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
       </div>
      </file>
      <file name="protractor.js" type="protractor">
        var user = element(by.exactBinding('user'));
        var userNameValid = element(by.binding('myForm.userName.$valid'));
        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
        var lastNameError = element(by.binding('myForm.lastName.$error'));
        var formValid = element(by.binding('myForm.$valid'));
        var userNameInput = element(by.model('user.name'));
        var userLastInput = element(by.model('user.last'));

        it('should initialize to model', function() {
          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
          expect(userNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if empty when required', function() {
          userNameInput.clear();
          userNameInput.sendKeys('');

          expect(user.getText()).toContain('{"last":"visitor"}');
          expect(userNameValid.getText()).toContain('false');
          expect(formValid.getText()).toContain('false');
        });

        it('should be valid if empty when min length is set', function() {
          userLastInput.clear();
          userLastInput.sendKeys('');

          expect(user.getText()).toContain('{"name":"guest","last":""}');
          expect(lastNameValid.getText()).toContain('true');
          expect(formValid.getText()).toContain('true');
        });

        it('should be invalid if less than required min length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('xx');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('minlength');
          expect(formValid.getText()).toContain('false');
        });

        it('should be invalid if longer than max length', function() {
          userLastInput.clear();
          userLastInput.sendKeys('some ridiculously long name');

          expect(user.getText()).toContain('{"name":"guest"}');
          expect(lastNameValid.getText()).toContain('false');
          expect(lastNameError.getText()).toContain('maxlength');
          expect(formValid.getText()).toContain('false');
        });
      </file>
    </example>
 */
var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
    function($browser, $sniffer, $filter, $parse) {
  return {
    restrict: 'E',
    require: ['?ngModel'],
    link: {
      pre: function(scope, element, attr, ctrls) {
        if (ctrls[0]) {
          var type = lowercase(attr.type);
          if ((type === 'range') && !attr.hasOwnProperty('ngInputRange')) {
            type = 'text';
          }
          (inputType[type] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
                                                              $browser, $filter, $parse);
        }
      }
    }
  };
}];



var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
/**
 * @ngdoc directive
 * @name ngValue
 *
 * @description
 * Binds the given expression to the value of `<option>` or {@link input[radio] `input[radio]`},
 * so that when the element is selected, the {@link ngModel `ngModel`} of that element is set to
 * the bound value.
 *
 * `ngValue` is useful when dynamically generating lists of radio buttons using
 * {@link ngRepeat `ngRepeat`}, as shown below.
 *
 * Likewise, `ngValue` can be used to generate `<option>` elements for
 * the {@link select `select`} element. In that case however, only strings are supported
 * for the `value `attribute, so the resulting `ngModel` will always be a string.
 * Support for `select` models with non-string values is available via `ngOptions`.
 *
 * @element input
 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
 *   of the `input` element
 *
 * @example
    <example name="ngValue-directive" module="valueExample">
      <file name="index.html">
       <script>
          angular.module('valueExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.names = ['pizza', 'unicorns', 'robots'];
              $scope.my = { favorite: 'unicorns' };
            }]);
       </script>
        <form ng-controller="ExampleController">
          <h2>Which is your favorite?</h2>
            <label ng-repeat="name in names" for="{{name}}">
              {{name}}
              <input type="radio"
                     ng-model="my.favorite"
                     ng-value="name"
                     id="{{name}}"
                     name="favorite">
            </label>
          <div>You chose {{my.favorite}}</div>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
        var favorite = element(by.binding('my.favorite'));

        it('should initialize to model', function() {
          expect(favorite.getText()).toContain('unicorns');
        });
        it('should bind the values to the inputs', function() {
          element.all(by.model('my.favorite')).get(0).click();
          expect(favorite.getText()).toContain('pizza');
        });
      </file>
    </example>
 */
var ngValueDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    compile: function(tpl, tplAttr) {
      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
        return function ngValueConstantLink(scope, elm, attr) {
          attr.$set('value', scope.$eval(attr.ngValue));
        };
      } else {
        return function ngValueLink(scope, elm, attr) {
          scope.$watch(attr.ngValue, function valueWatchAction(value) {
            attr.$set('value', value);
          });
        };
      }
    }
  };
};

/**
 * @ngdoc directive
 * @name ngBind
 * @restrict AC
 *
 * @description
 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
 * with the value of a given expression, and to update the text content when the value of that
 * expression changes.
 *
 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
 * `{{ expression }}` which is similar but less verbose.
 *
 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
 * element attribute, it makes the bindings invisible to the user while the page is loading.
 *
 * An alternative solution to this problem would be using the
 * {@link ng.directive:ngCloak ngCloak} directive.
 *
 *
 * @element ANY
 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
 *
 * @example
 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
   <example module="bindExample" name="ng-bind">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.name = 'Whirled';
           }]);
       </script>
       <div ng-controller="ExampleController">
         <label>Enter name: <input type="text" ng-model="name"></label><br>
         Hello <span ng-bind="name"></span>!
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var nameInput = element(by.model('name'));

         expect(element(by.binding('name')).getText()).toBe('Whirled');
         nameInput.clear();
         nameInput.sendKeys('world');
         expect(element(by.binding('name')).getText()).toBe('world');
       });
     </file>
   </example>
 */
var ngBindDirective = ['$compile', function($compile) {
  return {
    restrict: 'AC',
    compile: function ngBindCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBind);
        element = element[0];
        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindTemplate
 *
 * @description
 * The `ngBindTemplate` directive specifies that the element
 * text content should be replaced with the interpolation of the template
 * in the `ngBindTemplate` attribute.
 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
 * expressions. This directive is needed since some HTML elements
 * (such as TITLE and OPTION) cannot contain SPAN elements.
 *
 * @element ANY
 * @param {string} ngBindTemplate template of form
 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
 *
 * @example
 * Try it here: enter text in text box and watch the greeting change.
   <example module="bindExample" name="ng-bind-template">
     <file name="index.html">
       <script>
         angular.module('bindExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.salutation = 'Hello';
             $scope.name = 'World';
           }]);
       </script>
       <div ng-controller="ExampleController">
        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
        <label>Name: <input type="text" ng-model="name"></label><br>
        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
       </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-bind', function() {
         var salutationElem = element(by.binding('salutation'));
         var salutationInput = element(by.model('salutation'));
         var nameInput = element(by.model('name'));

         expect(salutationElem.getText()).toBe('Hello World!');

         salutationInput.clear();
         salutationInput.sendKeys('Greetings');
         nameInput.clear();
         nameInput.sendKeys('user');

         expect(salutationElem.getText()).toBe('Greetings user!');
       });
     </file>
   </example>
 */
var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
  return {
    compile: function ngBindTemplateCompile(templateElement) {
      $compile.$$addBindingClass(templateElement);
      return function ngBindTemplateLink(scope, element, attr) {
        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
        $compile.$$addBindingInfo(element, interpolateFn.expressions);
        element = element[0];
        attr.$observe('ngBindTemplate', function(value) {
          element.textContent = isUndefined(value) ? '' : value;
        });
      };
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngBindHtml
 *
 * @description
 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
 *
 * You may also bypass sanitization for values you know are safe. To do so, bind to
 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
 *
 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
 * will have an exception (instead of an exploit.)
 *
 * @element ANY
 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
 *
 * @example

   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
     <file name="index.html">
       <div ng-controller="ExampleController">
        <p ng-bind-html="myHTML"></p>
       </div>
     </file>

     <file name="script.js">
       angular.module('bindHtmlExample', ['ngSanitize'])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.myHTML =
              'I am an <code>HTML</code>string with ' +
              '<a href="#">links!</a> and other <em>stuff</em>';
         }]);
     </file>

     <file name="protractor.js" type="protractor">
       it('should check ng-bind-html', function() {
         expect(element(by.binding('myHTML')).getText()).toBe(
             'I am an HTMLstring with links! and other stuff');
       });
     </file>
   </example>
 */
var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
  return {
    restrict: 'A',
    compile: function ngBindHtmlCompile(tElement, tAttrs) {
      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
        return $sce.valueOf(val);
      });
      $compile.$$addBindingClass(tElement);

      return function ngBindHtmlLink(scope, element, attr) {
        $compile.$$addBindingInfo(element, attr.ngBindHtml);

        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
          var value = ngBindHtmlGetter(scope);
          element.html($sce.getTrustedHtml(value) || '');
        });
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngChange
 *
 * @description
 * Evaluate the given expression when the user changes the input.
 * The expression is evaluated immediately, unlike the JavaScript onchange event
 * which only triggers at the end of a change (usually, when the user leaves the
 * form element or presses the return key).
 *
 * The `ngChange` expression is only evaluated when a change in the input value causes
 * a new value to be committed to the model.
 *
 * It will not be evaluated:
 * * if the value returned from the `$parsers` transformation pipeline has not changed
 * * if the input has continued to be invalid since the model will stay `null`
 * * if the model is changed programmatically and not by a change to the input value
 *
 *
 * Note, this directive requires `ngModel` to be present.
 *
 * @element input
 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
 * in input value.
 *
 * @example
 * <example name="ngChange-directive" module="changeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('changeExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.counter = 0;
 *           $scope.change = function() {
 *             $scope.counter++;
 *           };
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
 *       <label for="ng-change-example2">Confirmed</label><br />
 *       <tt>debug = {{confirmed}}</tt><br/>
 *       <tt>counter = {{counter}}</tt><br/>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var counter = element(by.binding('counter'));
 *     var debug = element(by.binding('confirmed'));
 *
 *     it('should evaluate the expression if changing from view', function() {
 *       expect(counter.getText()).toContain('0');
 *
 *       element(by.id('ng-change-example1')).click();
 *
 *       expect(counter.getText()).toContain('1');
 *       expect(debug.getText()).toContain('true');
 *     });
 *
 *     it('should not evaluate the expression if changing from model', function() {
 *       element(by.id('ng-change-example2')).click();

 *       expect(counter.getText()).toContain('0');
 *       expect(debug.getText()).toContain('true');
 *     });
 *   </file>
 * </example>
 */
var ngChangeDirective = valueFn({
  restrict: 'A',
  require: 'ngModel',
  link: function(scope, element, attr, ctrl) {
    ctrl.$viewChangeListeners.push(function() {
      scope.$eval(attr.ngChange);
    });
  }
});

/* exported
  ngClassDirective,
  ngClassEvenDirective,
  ngClassOddDirective
*/

function classDirective(name, selector) {
  name = 'ngClass' + name;
  return ['$animate', function($animate) {
    return {
      restrict: 'AC',
      link: function(scope, element, attr) {
        var oldVal;

        attr.$observe('class', function(value) {
          ngClassWatchAction(scope.$eval(attr[name]));
        });


        if (name !== 'ngClass') {
          scope.$watch('$index', function($index, old$index) {
            /* eslint-disable no-bitwise */
            var mod = $index & 1;
            if (mod !== (old$index & 1)) {
              var classes = arrayClasses(oldVal);
              if (mod === selector) {
                addClasses(classes);
              } else {
                removeClasses(classes);
              }
            }
            /* eslint-enable */
          });
        }

        scope.$watch(attr[name], ngClassWatchAction, true);

        function addClasses(classes) {
          var newClasses = digestClassCounts(classes, 1);
          attr.$addClass(newClasses);
        }

        function removeClasses(classes) {
          var newClasses = digestClassCounts(classes, -1);
          attr.$removeClass(newClasses);
        }

        function digestClassCounts(classes, count) {
          // Use createMap() to prevent class assumptions involving property
          // names in Object.prototype
          var classCounts = element.data('$classCounts') || createMap();
          var classesToUpdate = [];
          forEach(classes, function(className) {
            if (count > 0 || classCounts[className]) {
              classCounts[className] = (classCounts[className] || 0) + count;
              if (classCounts[className] === +(count > 0)) {
                classesToUpdate.push(className);
              }
            }
          });
          element.data('$classCounts', classCounts);
          return classesToUpdate.join(' ');
        }

        function updateClasses(oldClasses, newClasses) {
          var toAdd = arrayDifference(newClasses, oldClasses);
          var toRemove = arrayDifference(oldClasses, newClasses);
          toAdd = digestClassCounts(toAdd, 1);
          toRemove = digestClassCounts(toRemove, -1);
          if (toAdd && toAdd.length) {
            $animate.addClass(element, toAdd);
          }
          if (toRemove && toRemove.length) {
            $animate.removeClass(element, toRemove);
          }
        }

        function ngClassWatchAction(newVal) {
          // eslint-disable-next-line no-bitwise
          if (selector === true || (scope.$index & 1) === selector) {
            var newClasses = arrayClasses(newVal || []);
            if (!oldVal) {
              addClasses(newClasses);
            } else if (!equals(newVal,oldVal)) {
              var oldClasses = arrayClasses(oldVal);
              updateClasses(oldClasses, newClasses);
            }
          }
          if (isArray(newVal)) {
            oldVal = newVal.map(function(v) { return shallowCopy(v); });
          } else {
            oldVal = shallowCopy(newVal);
          }
        }
      }
    };

    function arrayDifference(tokens1, tokens2) {
      var values = [];

      outer:
      for (var i = 0; i < tokens1.length; i++) {
        var token = tokens1[i];
        for (var j = 0; j < tokens2.length; j++) {
          if (token === tokens2[j]) continue outer;
        }
        values.push(token);
      }
      return values;
    }

    function arrayClasses(classVal) {
      var classes = [];
      if (isArray(classVal)) {
        forEach(classVal, function(v) {
          classes = classes.concat(arrayClasses(v));
        });
        return classes;
      } else if (isString(classVal)) {
        return classVal.split(' ');
      } else if (isObject(classVal)) {
        forEach(classVal, function(v, k) {
          if (v) {
            classes = classes.concat(k.split(' '));
          }
        });
        return classes;
      }
      return classVal;
    }
  }];
}

/**
 * @ngdoc directive
 * @name ngClass
 * @restrict AC
 *
 * @description
 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
 * an expression that represents all classes to be added.
 *
 * The directive operates in three different ways, depending on which of three types the expression
 * evaluates to:
 *
 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
 * names.
 *
 * 2. If the expression evaluates to an object, then for each key-value pair of the
 * object with a truthy value the corresponding key is used as a class name.
 *
 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
 * to give you more control over what CSS classes appear. See the code below for an example of this.
 *
 *
 * The directive won't add duplicate classes if a particular class was already set.
 *
 * When the expression changes, the previously added classes are removed and only then are the
 * new classes added.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
 * attribute, when using the `ngClass` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
 *
 * @element ANY
 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class
 *   names, an array, or a map of class names to boolean values. In the case of a map, the
 *   names of the properties whose values are truthy will be added as css classes to the
 *   element.
 *
 * @example Example that demonstrates basic bindings via ngClass directive.
   <example name="ng-class">
     <file name="index.html">
       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
       <label>
          <input type="checkbox" ng-model="deleted">
          deleted (apply "strike" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="important">
          important (apply "bold" class)
       </label><br>
       <label>
          <input type="checkbox" ng-model="error">
          error (apply "has-error" class)
       </label>
       <hr>
       <p ng-class="style">Using String Syntax</p>
       <input type="text" ng-model="style"
              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
       <hr>
       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
       <input ng-model="style1"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
       <input ng-model="style2"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
       <input ng-model="style3"
              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
       <hr>
       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
     </file>
     <file name="style.css">
       .strike {
           text-decoration: line-through;
       }
       .bold {
           font-weight: bold;
       }
       .red {
           color: red;
       }
       .has-error {
           color: red;
           background-color: yellow;
       }
       .orange {
           color: orange;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var ps = element.all(by.css('p'));

       it('should let you toggle the class', function() {

         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);

         element(by.model('important')).click();
         expect(ps.first().getAttribute('class')).toMatch(/bold/);

         element(by.model('error')).click();
         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
       });

       it('should let you toggle string example', function() {
         expect(ps.get(1).getAttribute('class')).toBe('');
         element(by.model('style')).clear();
         element(by.model('style')).sendKeys('red');
         expect(ps.get(1).getAttribute('class')).toBe('red');
       });

       it('array example should have 3 classes', function() {
         expect(ps.get(2).getAttribute('class')).toBe('');
         element(by.model('style1')).sendKeys('bold');
         element(by.model('style2')).sendKeys('strike');
         element(by.model('style3')).sendKeys('red');
         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
       });

       it('array with map example should have 2 classes', function() {
         expect(ps.last().getAttribute('class')).toBe('');
         element(by.model('style4')).sendKeys('bold');
         element(by.model('warning')).click();
         expect(ps.last().getAttribute('class')).toBe('bold orange');
       });
     </file>
   </example>

   ## Animations

   The example below demonstrates how to perform animations using ngClass.

   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
     <file name="index.html">
      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
      <br>
      <span class="base-class" ng-class="myVar">Sample Text</span>
     </file>
     <file name="style.css">
       .base-class {
         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
       }

       .base-class.my-class {
         color: red;
         font-size:3em;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class', function() {
         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);

         element(by.id('setbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).
           toMatch(/my-class/);

         element(by.id('clearbtn')).click();

         expect(element(by.css('.base-class')).getAttribute('class')).not.
           toMatch(/my-class/);
       });
     </file>
   </example>


   ## ngClass and pre-existing CSS3 Transitions/Animations
   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
   to view the step by step details of {@link $animate#addClass $animate.addClass} and
   {@link $animate#removeClass $animate.removeClass}.
 */
var ngClassDirective = classDirective('', true);

/**
 * @ngdoc directive
 * @name ngClassOdd
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
 *   of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-odd">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}}
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassOddDirective = classDirective('Odd', 0);

/**
 * @ngdoc directive
 * @name ngClassEven
 * @restrict AC
 *
 * @description
 * The `ngClassOdd` and `ngClassEven` directives work exactly as
 * {@link ng.directive:ngClass ngClass}, except they work in
 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
 *
 * This directive can be applied only within the scope of an
 * {@link ng.directive:ngRepeat ngRepeat}.
 *
 * @element ANY
 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
 *   result of the evaluation can be a string representing space delimited class names or an array.
 *
 * @example
   <example name="ng-class-even">
     <file name="index.html">
        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
          <li ng-repeat="name in names">
           <span ng-class-odd="'odd'" ng-class-even="'even'">
             {{name}} &nbsp; &nbsp; &nbsp;
           </span>
          </li>
        </ol>
     </file>
     <file name="style.css">
       .odd {
         color: red;
       }
       .even {
         color: blue;
       }
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-class-odd and ng-class-even', function() {
         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
           toMatch(/odd/);
         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
           toMatch(/even/);
       });
     </file>
   </example>
 */
var ngClassEvenDirective = classDirective('Even', 1);

/**
 * @ngdoc directive
 * @name ngCloak
 * @restrict AC
 *
 * @description
 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
 * directive to avoid the undesirable flicker effect caused by the html template display.
 *
 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
 * of the browser view.
 *
 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
 * `angular.min.js`.
 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
 *
 * ```css
 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
 *   display: none !important;
 * }
 * ```
 *
 * When this css rule is loaded by the browser, all html elements (including their children) that
 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
 * during the compilation of the template it deletes the `ngCloak` element attribute, making
 * the compiled element visible.
 *
 * For the best result, the `angular.js` script must be loaded in the head section of the html
 * document; alternatively, the css rule above must be included in the external stylesheet of the
 * application.
 *
 * @element ANY
 *
 * @example
   <example name="ng-cloak">
     <file name="index.html">
        <div id="template1" ng-cloak>{{ 'hello' }}</div>
        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should remove the template directive and css class', function() {
         expect($('#template1').getAttribute('ng-cloak')).
           toBeNull();
         expect($('#template2').getAttribute('ng-cloak')).
           toBeNull();
       });
     </file>
   </example>
 *
 */
var ngCloakDirective = ngDirective({
  compile: function(element, attr) {
    attr.$set('ngCloak', undefined);
    element.removeClass('ng-cloak');
  }
});

/**
 * @ngdoc directive
 * @name ngController
 *
 * @description
 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
 * supports the principles behind the Model-View-Controller design pattern.
 *
 * MVC components in angular:
 *
 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
 *   are accessed through bindings.
 * * View — The template (HTML with data bindings) that is rendered into the View.
 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
 *   logic behind the application to decorate the scope with functions and values
 *
 * Note that you can also attach controllers to the DOM by declaring it in a route definition
 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
 * and executed twice.
 *
 * @element ANY
 * @scope
 * @priority 500
 * @param {expression} ngController Name of a constructor function registered with the current
 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
 * that on the current scope evaluates to a constructor function.
 *
 * The controller instance can be published into a scope property by specifying
 * `ng-controller="as propertyName"`.
 *
 * If the current `$controllerProvider` is configured to use globals (via
 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
 * also be the name of a globally accessible constructor function (not recommended).
 *
 * @example
 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
 * greeting are methods declared on the controller (see source tab). These methods can
 * easily be called from the angular markup. Any changes to the data are automatically reflected
 * in the View without the need for a manual update.
 *
 * Two different declaration styles are included below:
 *
 * * one binds methods and properties directly onto the controller using `this`:
 * `ng-controller="SettingsController1 as settings"`
 * * one injects `$scope` into the controller:
 * `ng-controller="SettingsController2"`
 *
 * The second option is more common in the Angular community, and is generally used in boilerplates
 * and in this guide. However, there are advantages to binding properties directly to the controller
 * and avoiding scope.
 *
 * * Using `controller as` makes it obvious which controller you are accessing in the template when
 * multiple controllers apply to an element.
 * * If you are writing your controllers as classes you have easier access to the properties and
 * methods, which will appear on the scope, from inside the controller code.
 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
 * inheritance masking primitives.
 *
 * This example demonstrates the `controller as` syntax.
 *
 * <example name="ngControllerAs" module="controllerAsExample">
 *   <file name="index.html">
 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
 *      <button ng-click="settings.greet()">greet</button><br/>
 *      Contact:
 *      <ul>
 *        <li ng-repeat="contact in settings.contacts">
 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
 *             <option>phone</option>
 *             <option>email</option>
 *          </select>
 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *          <button ng-click="settings.clearContact(contact)">clear</button>
 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
 *        </li>
 *        <li><button ng-click="settings.addContact()">add</button></li>
 *     </ul>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('controllerAsExample', [])
 *      .controller('SettingsController1', SettingsController1);
 *
 *    function SettingsController1() {
 *      this.name = 'John Smith';
 *      this.contacts = [
 *        {type: 'phone', value: '408 555 1212'},
 *        {type: 'email', value: 'john.smith@example.org'}
 *      ];
 *    }
 *
 *    SettingsController1.prototype.greet = function() {
 *      alert(this.name);
 *    };
 *
 *    SettingsController1.prototype.addContact = function() {
 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
 *    };
 *
 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
 *     var index = this.contacts.indexOf(contactToRemove);
 *      this.contacts.splice(index, 1);
 *    };
 *
 *    SettingsController1.prototype.clearContact = function(contact) {
 *      contact.type = 'phone';
 *      contact.value = '';
 *    };
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should check controller as', function() {
 *       var container = element(by.id('ctrl-as-exmpl'));
 *         expect(container.element(by.model('settings.name'))
 *           .getAttribute('value')).toBe('John Smith');
 *
 *       var firstRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(0));
 *       var secondRepeat =
 *           container.element(by.repeater('contact in settings.contacts').row(1));
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('408 555 1212');
 *
 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('john.smith@example.org');
 *
 *       firstRepeat.element(by.buttonText('clear')).click();
 *
 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *           .toBe('');
 *
 *       container.element(by.buttonText('add')).click();
 *
 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
 *           .element(by.model('contact.value'))
 *           .getAttribute('value'))
 *           .toBe('yourname@example.org');
 *     });
 *   </file>
 * </example>
 *
 * This example demonstrates the "attach to `$scope`" style of controller.
 *
 * <example name="ngController" module="controllerExample">
 *  <file name="index.html">
 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
 *     <label>Name: <input type="text" ng-model="name"/></label>
 *     <button ng-click="greet()">greet</button><br/>
 *     Contact:
 *     <ul>
 *       <li ng-repeat="contact in contacts">
 *         <select ng-model="contact.type" id="select_{{$index}}">
 *            <option>phone</option>
 *            <option>email</option>
 *         </select>
 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
 *         <button ng-click="clearContact(contact)">clear</button>
 *         <button ng-click="removeContact(contact)">X</button>
 *       </li>
 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
 *    </ul>
 *   </div>
 *  </file>
 *  <file name="app.js">
 *   angular.module('controllerExample', [])
 *     .controller('SettingsController2', ['$scope', SettingsController2]);
 *
 *   function SettingsController2($scope) {
 *     $scope.name = 'John Smith';
 *     $scope.contacts = [
 *       {type:'phone', value:'408 555 1212'},
 *       {type:'email', value:'john.smith@example.org'}
 *     ];
 *
 *     $scope.greet = function() {
 *       alert($scope.name);
 *     };
 *
 *     $scope.addContact = function() {
 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
 *     };
 *
 *     $scope.removeContact = function(contactToRemove) {
 *       var index = $scope.contacts.indexOf(contactToRemove);
 *       $scope.contacts.splice(index, 1);
 *     };
 *
 *     $scope.clearContact = function(contact) {
 *       contact.type = 'phone';
 *       contact.value = '';
 *     };
 *   }
 *  </file>
 *  <file name="protractor.js" type="protractor">
 *    it('should check controller', function() {
 *      var container = element(by.id('ctrl-exmpl'));
 *
 *      expect(container.element(by.model('name'))
 *          .getAttribute('value')).toBe('John Smith');
 *
 *      var firstRepeat =
 *          container.element(by.repeater('contact in contacts').row(0));
 *      var secondRepeat =
 *          container.element(by.repeater('contact in contacts').row(1));
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('408 555 1212');
 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('john.smith@example.org');
 *
 *      firstRepeat.element(by.buttonText('clear')).click();
 *
 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
 *          .toBe('');
 *
 *      container.element(by.buttonText('add')).click();
 *
 *      expect(container.element(by.repeater('contact in contacts').row(2))
 *          .element(by.model('contact.value'))
 *          .getAttribute('value'))
 *          .toBe('yourname@example.org');
 *    });
 *  </file>
 *</example>

 */
var ngControllerDirective = [function() {
  return {
    restrict: 'A',
    scope: true,
    controller: '@',
    priority: 500
  };
}];

/**
 * @ngdoc directive
 * @name ngCsp
 *
 * @restrict A
 * @element ANY
 * @description
 *
 * Angular has some features that can conflict with certain restrictions that are applied when using
 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
 *
 * If you intend to implement CSP with these rules then you must tell Angular not to use these
 * features.
 *
 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
 *
 *
 * The following default rules in CSP affect Angular:
 *
 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
 * weaken the protections offered by CSP.)
 *
 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
 * it is generally not recommended as it would weaken the protections offered by CSP.)
 *
 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
 * CSP error to be logged in the console:
 *
 * ```
 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
 * script in the following Content Security Policy directive: "default-src 'self'". Note that
 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
 * ```
 *
 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
 * directive on an element of the HTML document that appears before the `<script>` tag that loads
 * the `angular.js` file.
 *
 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
 *
 * You can specify which of the CSP related Angular features should be deactivated by providing
 * a value for the `ng-csp` attribute. The options are as follows:
 *
 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
 *
 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
 *
 * You can use these values in the following combinations:
 *
 *
 * * No declaration means that Angular will assume that you can do inline styles, but it will do
 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
 * versions of Angular.
 *
 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
 * versions of Angular.
 *
 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
 *
 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
 *
 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
 * styles nor use eval, which is the same as an empty: ng-csp.
 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
 *
 * @example
 * This example shows how to apply the `ngCsp` directive to the `html` tag.
   ```html
     <!doctype html>
     <html ng-app ng-csp>
     ...
     ...
     </html>
   ```
  * @example
      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
      <example name="example.csp" module="cspExample" ng-csp="true">
        <file name="index.html">
          <div ng-controller="MainController as ctrl">
            <div>
              <button ng-click="ctrl.inc()" id="inc">Increment</button>
              <span id="counter">
                {{ctrl.counter}}
              </span>
            </div>

            <div>
              <button ng-click="ctrl.evil()" id="evil">Evil</button>
              <span id="evilError">
                {{ctrl.evilError}}
              </span>
            </div>
          </div>
        </file>
        <file name="script.js">
           angular.module('cspExample', [])
             .controller('MainController', function MainController() {
                this.counter = 0;
                this.inc = function() {
                  this.counter++;
                };
                this.evil = function() {
                  try {
                    eval('1+2'); // eslint-disable-line no-eval
                  } catch (e) {
                    this.evilError = e.message;
                  }
                };
              });
        </file>
        <file name="protractor.js" type="protractor">
          var util, webdriver;

          var incBtn = element(by.id('inc'));
          var counter = element(by.id('counter'));
          var evilBtn = element(by.id('evil'));
          var evilError = element(by.id('evilError'));

          function getAndClearSevereErrors() {
            return browser.manage().logs().get('browser').then(function(browserLog) {
              return browserLog.filter(function(logEntry) {
                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
              });
            });
          }

          function clearErrors() {
            getAndClearSevereErrors();
          }

          function expectNoErrors() {
            getAndClearSevereErrors().then(function(filteredLog) {
              expect(filteredLog.length).toEqual(0);
              if (filteredLog.length) {
                console.log('browser console errors: ' + util.inspect(filteredLog));
              }
            });
          }

          function expectError(regex) {
            getAndClearSevereErrors().then(function(filteredLog) {
              var found = false;
              filteredLog.forEach(function(log) {
                if (log.message.match(regex)) {
                  found = true;
                }
              });
              if (!found) {
                throw new Error('expected an error that matches ' + regex);
              }
            });
          }

          beforeEach(function() {
            util = require('util');
            webdriver = require('selenium-webdriver');
          });

          // For now, we only test on Chrome,
          // as Safari does not load the page with Protractor's injected scripts,
          // and Firefox webdriver always disables content security policy (#6358)
          if (browser.params.browser !== 'chrome') {
            return;
          }

          it('should not report errors when the page is loaded', function() {
            // clear errors so we are not dependent on previous tests
            clearErrors();
            // Need to reload the page as the page is already loaded when
            // we come here
            browser.driver.getCurrentUrl().then(function(url) {
              browser.get(url);
            });
            expectNoErrors();
          });

          it('should evaluate expressions', function() {
            expect(counter.getText()).toEqual('0');
            incBtn.click();
            expect(counter.getText()).toEqual('1');
            expectNoErrors();
          });

          it('should throw and report an error when using "eval"', function() {
            evilBtn.click();
            expect(evilError.getText()).toMatch(/Content Security Policy/);
            expectError(/Content Security Policy/);
          });
        </file>
      </example>
  */

// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
// fn that looks for the `ng-csp` attribute anywhere in the current doc.

/**
 * @ngdoc directive
 * @name ngClick
 *
 * @description
 * The ngClick directive allows you to specify custom behavior when
 * an element is clicked.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
 * click. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-click">
     <file name="index.html">
      <button ng-click="count = count + 1" ng-init="count=0">
        Increment
      </button>
      <span>
        count: {{count}}
      </span>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-click', function() {
         expect(element(by.binding('count')).getText()).toMatch('0');
         element(by.css('button')).click();
         expect(element(by.binding('count')).getText()).toMatch('1');
       });
     </file>
   </example>
 */
/*
 * A collection of directives that allows creation of custom event handlers that are defined as
 * angular expressions and are compiled and executed within the current scope.
 */
var ngEventDirectives = {};

// For events that might fire synchronously during DOM manipulation
// we need to execute their event handlers asynchronously using $evalAsync,
// so that they are not executed in an inconsistent state.
var forceAsyncEvents = {
  'blur': true,
  'focus': true
};
forEach(
  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
  function(eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
      return {
        restrict: 'A',
        compile: function($element, attr) {
          // We expose the powerful $event object on the scope that provides access to the Window,
          // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
          // checks at the cost of speed since event handler expressions are not executed as
          // frequently as regular change detection.
          var fn = $parse(attr[directiveName], /* interceptorFn */ null, /* expensiveChecks */ true);
          return function ngEventHandler(scope, element) {
            element.on(eventName, function(event) {
              var callback = function() {
                fn(scope, {$event:event});
              };
              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          };
        }
      };
    }];
  }
);

/**
 * @ngdoc directive
 * @name ngDblclick
 *
 * @description
 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
 * a dblclick. (The Event object is available as `$event`)
 *
 * @example
   <example name="ng-dblclick">
     <file name="index.html">
      <button ng-dblclick="count = count + 1" ng-init="count=0">
        Increment (on double click)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousedown
 *
 * @description
 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousedown">
     <file name="index.html">
      <button ng-mousedown="count = count + 1" ng-init="count=0">
        Increment (on mouse down)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseup
 *
 * @description
 * Specify custom behavior on mouseup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseup">
     <file name="index.html">
      <button ng-mouseup="count = count + 1" ng-init="count=0">
        Increment (on mouse up)
      </button>
      count: {{count}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngMouseover
 *
 * @description
 * Specify custom behavior on mouseover event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseover">
     <file name="index.html">
      <button ng-mouseover="count = count + 1" ng-init="count=0">
        Increment (when mouse is over)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseenter
 *
 * @description
 * Specify custom behavior on mouseenter event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseenter">
     <file name="index.html">
      <button ng-mouseenter="count = count + 1" ng-init="count=0">
        Increment (when mouse enters)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMouseleave
 *
 * @description
 * Specify custom behavior on mouseleave event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mouseleave">
     <file name="index.html">
      <button ng-mouseleave="count = count + 1" ng-init="count=0">
        Increment (when mouse leaves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngMousemove
 *
 * @description
 * Specify custom behavior on mousemove event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-mousemove">
     <file name="index.html">
      <button ng-mousemove="count = count + 1" ng-init="count=0">
        Increment (when mouse moves)
      </button>
      count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeydown
 *
 * @description
 * Specify custom behavior on keydown event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keydown">
     <file name="index.html">
      <input ng-keydown="count = count + 1" ng-init="count=0">
      key down count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeyup
 *
 * @description
 * Specify custom behavior on keyup event.
 *
 * @element ANY
 * @priority 0
 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keyup">
     <file name="index.html">
       <p>Typing in the input box below updates the key count</p>
       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}

       <p>Typing in the input box below updates the keycode</p>
       <input ng-keyup="event=$event">
       <p>event keyCode: {{ event.keyCode }}</p>
       <p>event altKey: {{ event.altKey }}</p>
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngKeypress
 *
 * @description
 * Specify custom behavior on keypress event.
 *
 * @element ANY
 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
 * and can be interrogated for keyCode, altKey, etc.)
 *
 * @example
   <example name="ng-keypress">
     <file name="index.html">
      <input ng-keypress="count = count + 1" ng-init="count=0">
      key press count: {{count}}
     </file>
   </example>
 */


/**
 * @ngdoc directive
 * @name ngSubmit
 *
 * @description
 * Enables binding angular expressions to onsubmit events.
 *
 * Additionally it prevents the default action (which for form means sending the request to the
 * server and reloading the current page), but only if the form does not contain `action`,
 * `data-action`, or `x-action` attributes.
 *
 * <div class="alert alert-warning">
 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
 * `ngSubmit` handlers together. See the
 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
 * for a detailed discussion of when `ngSubmit` may be triggered.
 * </div>
 *
 * @element form
 * @priority 0
 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
 * ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example module="submitExample" name="ng-submit">
     <file name="index.html">
      <script>
        angular.module('submitExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.list = [];
            $scope.text = 'hello';
            $scope.submit = function() {
              if ($scope.text) {
                $scope.list.push(this.text);
                $scope.text = '';
              }
            };
          }]);
      </script>
      <form ng-submit="submit()" ng-controller="ExampleController">
        Enter text and hit enter:
        <input type="text" ng-model="text" name="text" />
        <input type="submit" id="submit" value="Submit" />
        <pre>list={{list}}</pre>
      </form>
     </file>
     <file name="protractor.js" type="protractor">
       it('should check ng-submit', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
         expect(element(by.model('text')).getAttribute('value')).toBe('');
       });
       it('should ignore empty strings', function() {
         expect(element(by.binding('list')).getText()).toBe('list=[]');
         element(by.css('#submit')).click();
         element(by.css('#submit')).click();
         expect(element(by.binding('list')).getText()).toContain('hello');
        });
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngFocus
 *
 * @description
 * Specify custom behavior on focus event.
 *
 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngBlur
 *
 * @description
 * Specify custom behavior on blur event.
 *
 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
 * an element has lost focus.
 *
 * Note: As the `blur` event is executed synchronously also during DOM manipulations
 * (e.g. removing a focussed input),
 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
 * during an `$apply` to ensure a consistent state.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
 * See {@link ng.directive:ngClick ngClick}
 */

/**
 * @ngdoc directive
 * @name ngCopy
 *
 * @description
 * Specify custom behavior on copy event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-copy">
     <file name="index.html">
      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
      copied: {{copied}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngCut
 *
 * @description
 * Specify custom behavior on cut event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-cut">
     <file name="index.html">
      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
      cut: {{cut}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngPaste
 *
 * @description
 * Specify custom behavior on paste event.
 *
 * @element window, input, select, textarea, a
 * @priority 0
 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
 *
 * @example
   <example name="ng-paste">
     <file name="index.html">
      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
      pasted: {{paste}}
     </file>
   </example>
 */

/**
 * @ngdoc directive
 * @name ngIf
 * @restrict A
 * @multiElement
 *
 * @description
 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
 * {expression}. If the expression assigned to `ngIf` evaluates to a false
 * value then the element is removed from the DOM, otherwise a clone of the
 * element is reinserted into the DOM.
 *
 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
 * element in the DOM rather than changing its visibility via the `display` css property.  A common
 * case when this difference is significant is when using css selectors that rely on an element's
 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
 *
 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
 * is created when the element is restored.  The scope created within `ngIf` inherits from
 * its parent scope using
 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
 * a javascript primitive defined in the parent scope. In this case any modifications made to the
 * variable within the child scope will override (hide) the value in the parent scope.
 *
 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
 * is if an element's class attribute is directly modified after it's compiled, using something like
 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
 * the added class will be lost because the original compiled state is used to regenerate the element.
 *
 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
 * and `leave` effects.
 *
 * @animations
 * | Animation                        | Occurs                               |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
 *
 * @element ANY
 * @scope
 * @priority 600
 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
 *     element is added to the DOM tree.
 *
 * @example
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
    <file name="index.html">
      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
      Show when checked:
      <span ng-if="checked" class="animate-if">
        This is removed when the checkbox is unchecked.
      </span>
    </file>
    <file name="animations.css">
      .animate-if {
        background:white;
        border:1px solid black;
        padding:10px;
      }

      .animate-if.ng-enter, .animate-if.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
      }

      .animate-if.ng-enter,
      .animate-if.ng-leave.ng-leave-active {
        opacity:0;
      }

      .animate-if.ng-leave,
      .animate-if.ng-enter.ng-enter-active {
        opacity:1;
      }
    </file>
  </example>
 */
var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link: function($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function(clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function(response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngInclude
 * @restrict ECA
 *
 * @description
 * Fetches, compiles and includes an external HTML fragment.
 *
 * By default, the template URL is restricted to the same domain and protocol as the
 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
 * ng.$sce Strict Contextual Escaping}.
 *
 * In addition, the browser's
 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
 * policy may further restrict whether the template is successfully loaded.
 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
 * access on some browsers.
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
 *
 * The enter and leave animation occur concurrently.
 *
 * @scope
 * @priority 400
 *
 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
 * @param {string=} onload Expression to evaluate when a new partial is loaded.
 *                  <div class="alert alert-warning">
 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
 *                  a function with the name on the window element, which will usually throw a
 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
 *                  different form that {@link guide/directive#normalization matches} `onload`.
 *                  </div>
   *
 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
 *                  $anchorScroll} to scroll the viewport after the content is loaded.
 *
 *                  - If the attribute is not set, disable scrolling.
 *                  - If the attribute is set without value, enable scrolling.
 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
 *
 * @example
  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
    <file name="index.html">
     <div ng-controller="ExampleController">
       <select ng-model="template" ng-options="t.name for t in templates">
        <option value="">(blank)</option>
       </select>
       url of the template: <code>{{template.url}}</code>
       <hr/>
       <div class="slide-animate-container">
         <div class="slide-animate" ng-include="template.url"></div>
       </div>
     </div>
    </file>
    <file name="script.js">
      angular.module('includeExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.templates =
            [{ name: 'template1.html', url: 'template1.html'},
             { name: 'template2.html', url: 'template2.html'}];
          $scope.template = $scope.templates[0];
        }]);
     </file>
    <file name="template1.html">
      Content of template1.html
    </file>
    <file name="template2.html">
      Content of template2.html
    </file>
    <file name="animations.css">
      .slide-animate-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .slide-animate {
        padding:10px;
      }

      .slide-animate.ng-enter, .slide-animate.ng-leave {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        display:block;
        padding:10px;
      }

      .slide-animate.ng-enter {
        top:-50px;
      }
      .slide-animate.ng-enter.ng-enter-active {
        top:0;
      }

      .slide-animate.ng-leave {
        top:0;
      }
      .slide-animate.ng-leave.ng-leave-active {
        top:50px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var templateSelect = element(by.model('template'));
      var includeElem = element(by.css('[ng-include]'));

      it('should load template1.html', function() {
        expect(includeElem.getText()).toMatch(/Content of template1.html/);
      });

      it('should load template2.html', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          // See https://github.com/angular/protractor/issues/480
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(2).click();
        expect(includeElem.getText()).toMatch(/Content of template2.html/);
      });

      it('should change to blank', function() {
        if (browser.params.browser === 'firefox') {
          // Firefox can't handle using selects
          return;
        }
        templateSelect.click();
        templateSelect.all(by.css('option')).get(0).click();
        expect(includeElem.isPresent()).toBe(false);
      });
    </file>
  </example>
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentRequested
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted every time the ngInclude content is requested.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentLoaded
 * @eventType emit on the current ngInclude scope
 * @description
 * Emitted every time the ngInclude content is reloaded.
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */


/**
 * @ngdoc event
 * @name ngInclude#$includeContentError
 * @eventType emit on the scope ngInclude was declared in
 * @description
 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
 *
 * @param {Object} angularEvent Synthetic event object.
 * @param {String} src URL of content to load.
 */
var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
                  function($templateRequest,   $anchorScroll,   $animate) {
  return {
    restrict: 'ECA',
    priority: 400,
    terminal: true,
    transclude: 'element',
    controller: angular.noop,
    compile: function(element, attr) {
      var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;

      return function(scope, $element, $attr, ctrl, $transclude) {
        var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

        var cleanupLastIncludeContent = function() {
          if (previousElement) {
            previousElement.remove();
            previousElement = null;
          }
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }
          if (currentElement) {
            $animate.leave(currentElement).done(function(response) {
              if (response !== false) previousElement = null;
            });
            previousElement = currentElement;
            currentElement = null;
          }
        };

        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
          var afterAnimation = function(response) {
            if (response !== false && isDefined(autoScrollExp) &&
              (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
            }
          };
          var thisChangeId = ++changeCounter;

          if (src) {
            //set the 2nd param to true to ignore the template request error so that the inner
            //contents and scope can be cleaned up.
            $templateRequest(src, true).then(function(response) {
              if (scope.$$destroyed) return;

              if (thisChangeId !== changeCounter) return;
              var newScope = scope.$new();
              ctrl.template = response;

              // Note: This will also link all children of ng-include that were contained in the original
              // html. If that content contains controllers, ... they could pollute/change the scope.
              // However, using ng-include on an element with additional content does not make sense...
              // Note: We can't remove them in the cloneAttchFn of $transclude as that
              // function is called before linking the content, which would apply child
              // directives to non existing elements.
              var clone = $transclude(newScope, function(clone) {
                cleanupLastIncludeContent();
                $animate.enter(clone, null, $element).done(afterAnimation);
              });

              currentScope = newScope;
              currentElement = clone;

              currentScope.$emit('$includeContentLoaded', src);
              scope.$eval(onloadExp);
            }, function() {
              if (scope.$$destroyed) return;

              if (thisChangeId === changeCounter) {
                cleanupLastIncludeContent();
                scope.$emit('$includeContentError', src);
              }
            });
            scope.$emit('$includeContentRequested', src);
          } else {
            cleanupLastIncludeContent();
            ctrl.template = null;
          }
        });
      };
    }
  };
}];

// This directive is called during the $transclude call of the first `ngInclude` directive.
// It will replace and compile the content of the element with the loaded template.
// We need this directive so that the element content is already filled when
// the link function of another directive on the same element as ngInclude
// is called.
var ngIncludeFillContentDirective = ['$compile',
  function($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
              function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {futureParentElement: $element});
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

/**
 * @ngdoc directive
 * @name ngInit
 * @restrict AC
 *
 * @description
 * The `ngInit` directive allows you to evaluate an expression in the
 * current scope.
 *
 * <div class="alert alert-danger">
 * This directive can be abused to add unnecessary amounts of logic into your templates.
 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
 * rather than `ngInit` to initialize values on a scope.
 * </div>
 *
 * <div class="alert alert-warning">
 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
 * sure you have parentheses to ensure correct operator precedence:
 * <pre class="prettyprint">
 * `<div ng-init="test1 = ($index | toString)"></div>`
 * </pre>
 * </div>
 *
 * @priority 450
 *
 * @element ANY
 * @param {expression} ngInit {@link guide/expression Expression} to eval.
 *
 * @example
   <example module="initExample" name="ng-init">
     <file name="index.html">
   <script>
     angular.module('initExample', [])
       .controller('ExampleController', ['$scope', function($scope) {
         $scope.list = [['a', 'b'], ['c', 'd']];
       }]);
   </script>
   <div ng-controller="ExampleController">
     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
       </div>
     </div>
   </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should alias index positions', function() {
         var elements = element.all(by.css('.example-init'));
         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
       });
     </file>
   </example>
 */
var ngInitDirective = ngDirective({
  priority: 450,
  compile: function() {
    return {
      pre: function(scope, element, attrs) {
        scope.$eval(attrs.ngInit);
      }
    };
  }
});

/**
 * @ngdoc directive
 * @name ngList
 *
 * @description
 * Text input that converts between a delimited string and an array of strings. The default
 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
 *
 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
 *   list item is respected. This implies that the user of the directive is responsible for
 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
 *   tab or newline character.
 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
 *   when joining the list items back together) and whitespace around each list item is stripped
 *   before it is added to the model.
 *
 * ### Example with Validation
 *
 * <example name="ngList-directive" module="listExample">
 *   <file name="app.js">
 *      angular.module('listExample', [])
 *        .controller('ExampleController', ['$scope', function($scope) {
 *          $scope.names = ['morpheus', 'neo', 'trinity'];
 *        }]);
 *   </file>
 *   <file name="index.html">
 *    <form name="myForm" ng-controller="ExampleController">
 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
 *      <span role="alert">
 *        <span class="error" ng-show="myForm.namesInput.$error.required">
 *        Required!</span>
 *      </span>
 *      <br>
 *      <tt>names = {{names}}</tt><br/>
 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
 *     </form>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     var listInput = element(by.model('names'));
 *     var names = element(by.exactBinding('names'));
 *     var valid = element(by.binding('myForm.namesInput.$valid'));
 *     var error = element(by.css('span.error'));
 *
 *     it('should initialize to model', function() {
 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
 *       expect(valid.getText()).toContain('true');
 *       expect(error.getCssValue('display')).toBe('none');
 *     });
 *
 *     it('should be invalid if empty', function() {
 *       listInput.clear();
 *       listInput.sendKeys('');
 *
 *       expect(names.getText()).toContain('');
 *       expect(valid.getText()).toContain('false');
 *       expect(error.getCssValue('display')).not.toBe('none');
 *     });
 *   </file>
 * </example>
 *
 * ### Example - splitting on newline
 * <example name="ngList-directive-newlines">
 *   <file name="index.html">
 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
 *    <pre>{{ list | json }}</pre>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it("should split the text by newlines", function() {
 *       var listInput = element(by.model('list'));
 *       var output = element(by.binding('list | json'));
 *       listInput.sendKeys('abc\ndef\nghi');
 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
 *     });
 *   </file>
 * </example>
 *
 * @element input
 * @param {string=} ngList optional delimiter that should be used to split the value.
 */
var ngListDirective = function() {
  return {
    restrict: 'A',
    priority: 100,
    require: 'ngModel',
    link: function(scope, element, attr, ctrl) {
      // We want to control whitespace trimming so we use this convoluted approach
      // to access the ngList attribute, which doesn't pre-trim the attribute
      var ngList = element.attr(attr.$attr.ngList) || ', ';
      var trimValues = attr.ngTrim !== 'false';
      var separator = trimValues ? trim(ngList) : ngList;

      var parse = function(viewValue) {
        // If the viewValue is invalid (say required but empty) it will be `undefined`
        if (isUndefined(viewValue)) return;

        var list = [];

        if (viewValue) {
          forEach(viewValue.split(separator), function(value) {
            if (value) list.push(trimValues ? trim(value) : value);
          });
        }

        return list;
      };

      ctrl.$parsers.push(parse);
      ctrl.$formatters.push(function(value) {
        if (isArray(value)) {
          return value.join(ngList);
        }

        return undefined;
      });

      // Override the standard $isEmpty because an empty array means the input is empty.
      ctrl.$isEmpty = function(value) {
        return !value || !value.length;
      };
    }
  };
};

/* global VALID_CLASS: true,
  INVALID_CLASS: true,
  PRISTINE_CLASS: true,
  DIRTY_CLASS: true,
  UNTOUCHED_CLASS: true,
  TOUCHED_CLASS: true
*/

var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    PENDING_CLASS = 'ng-pending',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';

var ngModelMinErr = minErr('ngModel');

/**
 * @ngdoc type
 * @name ngModel.NgModelController
 *
 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
 * is set.
 * @property {*} $modelValue The value in the model that the control is bound to.
 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
       the control reads value from the DOM. The functions are called in array order, each passing
       its return value through to the next. The last return value is forwarded to the
       {@link ngModel.NgModelController#$validators `$validators`} collection.

Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
`$viewValue`}.

Returning `undefined` from a parser means a parse error occurred. In that case,
no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
is set to `true`. The parse error is stored in `ngModel.$error.parse`.

 *
 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
       the model value changes. The functions are called in reverse array order, each passing the value through to the
       next. The last return value is used as the actual DOM value.
       Used to format / convert values for display in the control.
 * ```js
 * function formatter(value) {
 *   if (value) {
 *     return value.toUpperCase();
 *   }
 * }
 * ngModel.$formatters.push(formatter);
 * ```
 *
 * @property {Object.<string, function>} $validators A collection of validators that are applied
 *      whenever the model value changes. The key value within the object refers to the name of the
 *      validator while the function refers to the validation operation. The validation operation is
 *      provided with the model value as an argument and must return a true or false value depending
 *      on the response of that validation.
 *
 * ```js
 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *   return /[0-9]+/.test(value) &&
 *          /[a-z]+/.test(value) &&
 *          /[A-Z]+/.test(value) &&
 *          /\W+/.test(value);
 * };
 * ```
 *
 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
 *      is expected to return a promise when it is run during the model validation process. Once the promise
 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
 *      will only run once all synchronous validators have passed.
 *
 * Please note that if $http is used then it is important that the server returns a success HTTP response code
 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
 *
 * ```js
 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
 *   var value = modelValue || viewValue;
 *
 *   // Lookup user by username
 *   return $http.get('/api/users/' + value).
 *      then(function resolved() {
 *        //username exists, this means validation fails
 *        return $q.reject('exists');
 *      }, function rejected() {
 *        //username does not exist, therefore this validation passes
 *        return true;
 *      });
 * };
 * ```
 *
 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
 *     view value has changed. It is called with no arguments, and its return value is ignored.
 *     This can be used in place of additional $watches against the model value.
 *
 * @property {Object} $error An object hash with all failing validator ids as keys.
 * @property {Object} $pending An object hash with all pending validator ids as keys.
 *
 * @property {boolean} $untouched True if control has not lost focus yet.
 * @property {boolean} $touched True if control has lost focus.
 * @property {boolean} $pristine True if user has not interacted with the control yet.
 * @property {boolean} $dirty True if user has already interacted with the control.
 * @property {boolean} $valid True if there is no error.
 * @property {boolean} $invalid True if at least one error on the control.
 * @property {string} $name The name attribute of the control.
 *
 * @description
 *
 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
 * The controller contains services for data-binding, validation, CSS updates, and value formatting
 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
 * listening to DOM events.
 * Such DOM related logic should be provided by other directives which make use of
 * `NgModelController` for data-binding to control elements.
 * Angular provides this DOM logic for most {@link input `input`} elements.
 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
 *
 * @example
 * ### Custom Control Example
 * This example shows how to use `NgModelController` with a custom control to achieve
 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
 * collaborate together to achieve the desired result.
 *
 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
 * contents be edited in place by the user.
 *
 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
 * that content using the `$sce` service.
 *
 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
    <file name="style.css">
      [contenteditable] {
        border: 1px solid black;
        background-color: white;
        min-height: 20px;
      }

      .ng-invalid {
        border: 1px solid red;
      }

    </file>
    <file name="script.js">
      angular.module('customControl', ['ngSanitize']).
        directive('contenteditable', ['$sce', function($sce) {
          return {
            restrict: 'A', // only activate on element attribute
            require: '?ngModel', // get a hold of NgModelController
            link: function(scope, element, attrs, ngModel) {
              if (!ngModel) return; // do nothing if no ng-model

              // Specify how UI should be updated
              ngModel.$render = function() {
                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
              };

              // Listen for change events to enable binding
              element.on('blur keyup change', function() {
                scope.$evalAsync(read);
              });
              read(); // initialize

              // Write data to the model
              function read() {
                var html = element.html();
                // When we clear the content editable the browser leaves a <br> behind
                // If strip-br attribute is provided then we strip this out
                if (attrs.stripBr && html === '<br>') {
                  html = '';
                }
                ngModel.$setViewValue(html);
              }
            }
          };
        }]);
    </file>
    <file name="index.html">
      <form name="myForm">
       <div contenteditable
            name="myWidget" ng-model="userContent"
            strip-br="true"
            required>Change me!</div>
        <span ng-show="myForm.myWidget.$error.required">Required!</span>
       <hr>
       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
      </form>
    </file>
    <file name="protractor.js" type="protractor">
    it('should data-bind and become invalid', function() {
      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
        // SafariDriver can't handle contenteditable
        // and Firefox driver can't clear contenteditables very well
        return;
      }
      var contentEditable = element(by.css('[contenteditable]'));
      var content = 'Change me!';

      expect(contentEditable.getText()).toEqual(content);

      contentEditable.clear();
      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
      expect(contentEditable.getText()).toEqual('');
      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
    });
    </file>
 * </example>
 *
 *
 */
var NgModelController = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$rootScope', '$q', '$interpolate',
    /** @this */ function($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $rootScope, $q, $interpolate) {
  this.$viewValue = Number.NaN;
  this.$modelValue = Number.NaN;
  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
  this.$validators = {};
  this.$asyncValidators = {};
  this.$parsers = [];
  this.$formatters = [];
  this.$viewChangeListeners = [];
  this.$untouched = true;
  this.$touched = false;
  this.$pristine = true;
  this.$dirty = false;
  this.$valid = true;
  this.$invalid = false;
  this.$error = {}; // keep invalid keys here
  this.$$success = {}; // keep valid keys here
  this.$pending = undefined; // keep pending keys here
  this.$name = $interpolate($attr.name || '', false)($scope);
  this.$$parentForm = nullFormCtrl;

  var parsedNgModel = $parse($attr.ngModel),
      parsedNgModelAssign = parsedNgModel.assign,
      ngModelGet = parsedNgModel,
      ngModelSet = parsedNgModelAssign,
      pendingDebounce = null,
      parserValid,
      ctrl = this;

  this.$$setOptions = function(options) {
    ctrl.$options = options;
    if (options && options.getterSetter) {
      var invokeModelGetter = $parse($attr.ngModel + '()'),
          invokeModelSetter = $parse($attr.ngModel + '($$$p)');

      ngModelGet = function($scope) {
        var modelValue = parsedNgModel($scope);
        if (isFunction(modelValue)) {
          modelValue = invokeModelGetter($scope);
        }
        return modelValue;
      };
      ngModelSet = function($scope, newValue) {
        if (isFunction(parsedNgModel($scope))) {
          invokeModelSetter($scope, {$$$p: newValue});
        } else {
          parsedNgModelAssign($scope, newValue);
        }
      };
    } else if (!parsedNgModel.assign) {
      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
          $attr.ngModel, startingTag($element));
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$render
   *
   * @description
   * Called when the view needs to be updated. It is expected that the user of the ng-model
   * directive will implement this method.
   *
   * The `$render()` method is invoked in the following situations:
   *
   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
   *   committed value then `$render()` is called to update the input control.
   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
   *   the `$viewValue` are different from last time.
   *
   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
   * invoked if you only change a property on the objects.
   */
  this.$render = noop;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$isEmpty
   *
   * @description
   * This is called when we need to determine if the value of an input is empty.
   *
   * For instance, the required directive does this to work out if the input has data or not.
   *
   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
   *
   * You can override this for input directives whose concept of being empty is different from the
   * default. The `checkboxInputType` directive does this because in its case a value of `false`
   * implies empty.
   *
   * @param {*} value The value of the input to check for emptiness.
   * @returns {boolean} True if `value` is "empty".
   */
  this.$isEmpty = function(value) {
    // eslint-disable-next-line no-self-compare
    return isUndefined(value) || value === '' || value === null || value !== value;
  };

  this.$$updateEmptyClasses = function(value) {
    if (ctrl.$isEmpty(value)) {
      $animate.removeClass($element, NOT_EMPTY_CLASS);
      $animate.addClass($element, EMPTY_CLASS);
    } else {
      $animate.removeClass($element, EMPTY_CLASS);
      $animate.addClass($element, NOT_EMPTY_CLASS);
    }
  };


  var currentValidationRunId = 0;

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setValidity
   *
   * @description
   * Change the validity state, and notify the form.
   *
   * This method can be called within $parsers/$formatters or a custom validation implementation.
   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
   *
   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
   *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
   *                          Skipped is used by Angular when validators do not run because of parse errors and
   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
   */
  addSetValidityMethod({
    ctrl: this,
    $element: $element,
    set: function(object, property) {
      object[property] = true;
    },
    unset: function(object, property) {
      delete object[property];
    },
    $animate: $animate
  });

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setPristine
   *
   * @description
   * Sets the control to its pristine state.
   *
   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
   * state (`ng-pristine` class). A model is considered to be pristine when the control
   * has not been changed from when first compiled.
   */
  this.$setPristine = function() {
    ctrl.$dirty = false;
    ctrl.$pristine = true;
    $animate.removeClass($element, DIRTY_CLASS);
    $animate.addClass($element, PRISTINE_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setDirty
   *
   * @description
   * Sets the control to its dirty state.
   *
   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
   * from when first compiled.
   */
  this.$setDirty = function() {
    ctrl.$dirty = true;
    ctrl.$pristine = false;
    $animate.removeClass($element, PRISTINE_CLASS);
    $animate.addClass($element, DIRTY_CLASS);
    ctrl.$$parentForm.$setDirty();
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setUntouched
   *
   * @description
   * Sets the control to its untouched state.
   *
   * This method can be called to remove the `ng-touched` class and set the control to its
   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
   * by default, however this function can be used to restore that state if the model has
   * already been touched by the user.
   */
  this.$setUntouched = function() {
    ctrl.$touched = false;
    ctrl.$untouched = true;
    $animate.setClass($element, UNTOUCHED_CLASS, TOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setTouched
   *
   * @description
   * Sets the control to its touched state.
   *
   * This method can be called to remove the `ng-untouched` class and set the control to its
   * touched state (`ng-touched` class). A model is considered to be touched when the user has
   * first focused the control element and then shifted focus away from the control (blur event).
   */
  this.$setTouched = function() {
    ctrl.$touched = true;
    ctrl.$untouched = false;
    $animate.setClass($element, TOUCHED_CLASS, UNTOUCHED_CLASS);
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$rollbackViewValue
   *
   * @description
   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
   * which may be caused by a pending debounced event or because the input is waiting for some
   * future event.
   *
   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
   * sync with the ngModel's `$modelValue`.
   *
   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
   * and reset the input to the last committed view value.
   *
   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
   * programmatically before these debounced/future events have resolved/occurred, because Angular's
   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
   *
   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
   * input which may have such events pending. This is important in order to make sure that the
   * input field will be updated with the new model value and any pending operations are cancelled.
   *
   * <example name="ng-model-cancel-update" module="cancel-update-example">
   *   <file name="app.js">
   *     angular.module('cancel-update-example', [])
   *
   *     .controller('CancelUpdateController', ['$scope', function($scope) {
   *       $scope.model = {value1: '', value2: ''};
   *
   *       $scope.setEmpty = function(e, value, rollback) {
   *         if (e.keyCode === 27) {
   *           e.preventDefault();
   *           if (rollback) {
   *             $scope.myForm[value].$rollbackViewValue();
   *           }
   *           $scope.model[value] = '';
   *         }
   *       };
   *     }]);
   *   </file>
   *   <file name="index.html">
   *     <div ng-controller="CancelUpdateController">
   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
   *       empty them. Follow these steps and observe the difference:</p>
   *       <ol>
   *         <li>Type something in the input. You will see that the model is not yet updated</li>
   *         <li>Press the Escape key.
   *           <ol>
   *             <li> In the first example, nothing happens, because the model is already '', and no
   *             update is detected. If you blur the input, the model will be set to the current view.
   *             </li>
   *             <li> In the second example, the pending update is cancelled, and the input is set back
   *             to the last committed view value (''). Blurring the input does nothing.
   *             </li>
   *           </ol>
   *         </li>
   *       </ol>
   *
   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
   *         <div>
   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
   *                  ng-keydown="setEmpty($event, 'value1')">
   *           value1: "{{ model.value1 }}"
   *         </div>
   *
   *         <div>
   *           <p id="inputDescription2">With $rollbackViewValue():</p>
   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
   *                  ng-keydown="setEmpty($event, 'value2', true)">
   *           value2: "{{ model.value2 }}"
   *         </div>
   *       </form>
   *     </div>
   *   </file>
       <file name="style.css">
          div {
            display: table-cell;
          }
          div:nth-child(1) {
            padding-right: 30px;
          }

        </file>
   * </example>
   */
  this.$rollbackViewValue = function() {
    $timeout.cancel(pendingDebounce);
    ctrl.$viewValue = ctrl.$$lastCommittedViewValue;
    ctrl.$render();
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$validate
   *
   * @description
   * Runs each of the registered validators (first synchronous validators and then
   * asynchronous validators).
   * If the validity changes to invalid, the model will be set to `undefined`,
   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
   * If the validity changes to valid, it will set the model to the last available valid
   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
   */
  this.$validate = function() {
    // ignore $validate before model is initialized
    if (isNumberNaN(ctrl.$modelValue)) {
      return;
    }

    var viewValue = ctrl.$$lastCommittedViewValue;
    // Note: we use the $$rawModelValue as $modelValue might have been
    // set to undefined during a view -> model update that found validation
    // errors. We can't parse the view here, since that could change
    // the model although neither viewValue nor the model on the scope changed
    var modelValue = ctrl.$$rawModelValue;

    var prevValid = ctrl.$valid;
    var prevModelValue = ctrl.$modelValue;

    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;

    ctrl.$$runValidators(modelValue, viewValue, function(allValid) {
      // If there was no change in validity, don't update the model
      // This prevents changing an invalid modelValue to undefined
      if (!allowInvalid && prevValid !== allValid) {
        // Note: Don't check ctrl.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        ctrl.$modelValue = allValid ? modelValue : undefined;

        if (ctrl.$modelValue !== prevModelValue) {
          ctrl.$$writeModelToScope();
        }
      }
    });

  };

  this.$$runValidators = function(modelValue, viewValue, doneCallback) {
    currentValidationRunId++;
    var localValidationRunId = currentValidationRunId;

    // check parser error
    if (!processParseErrors()) {
      validationDone(false);
      return;
    }
    if (!processSyncValidators()) {
      validationDone(false);
      return;
    }
    processAsyncValidators();

    function processParseErrors() {
      var errorKey = ctrl.$$parserName || 'parse';
      if (isUndefined(parserValid)) {
        setValidity(errorKey, null);
      } else {
        if (!parserValid) {
          forEach(ctrl.$validators, function(v, name) {
            setValidity(name, null);
          });
          forEach(ctrl.$asyncValidators, function(v, name) {
            setValidity(name, null);
          });
        }
        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
        setValidity(errorKey, parserValid);
        return parserValid;
      }
      return true;
    }

    function processSyncValidators() {
      var syncValidatorsValid = true;
      forEach(ctrl.$validators, function(validator, name) {
        var result = validator(modelValue, viewValue);
        syncValidatorsValid = syncValidatorsValid && result;
        setValidity(name, result);
      });
      if (!syncValidatorsValid) {
        forEach(ctrl.$asyncValidators, function(v, name) {
          setValidity(name, null);
        });
        return false;
      }
      return true;
    }

    function processAsyncValidators() {
      var validatorPromises = [];
      var allValid = true;
      forEach(ctrl.$asyncValidators, function(validator, name) {
        var promise = validator(modelValue, viewValue);
        if (!isPromiseLike(promise)) {
          throw ngModelMinErr('nopromise',
            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
        }
        setValidity(name, undefined);
        validatorPromises.push(promise.then(function() {
          setValidity(name, true);
        }, function() {
          allValid = false;
          setValidity(name, false);
        }));
      });
      if (!validatorPromises.length) {
        validationDone(true);
      } else {
        $q.all(validatorPromises).then(function() {
          validationDone(allValid);
        }, noop);
      }
    }

    function setValidity(name, isValid) {
      if (localValidationRunId === currentValidationRunId) {
        ctrl.$setValidity(name, isValid);
      }
    }

    function validationDone(allValid) {
      if (localValidationRunId === currentValidationRunId) {

        doneCallback(allValid);
      }
    }
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$commitViewValue
   *
   * @description
   * Commit a pending update to the `$modelValue`.
   *
   * Updates may be pending by a debounced event or because the input is waiting for a some future
   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
   * usually handles calling this in response to input events.
   */
  this.$commitViewValue = function() {
    var viewValue = ctrl.$viewValue;

    $timeout.cancel(pendingDebounce);

    // If the view value has not changed then we should just exit, except in the case where there is
    // a native validator on the element. In this case the validation state may have changed even though
    // the viewValue has stayed empty.
    if (ctrl.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !ctrl.$$hasNativeValidators)) {
      return;
    }
    ctrl.$$updateEmptyClasses(viewValue);
    ctrl.$$lastCommittedViewValue = viewValue;

    // change to dirty
    if (ctrl.$pristine) {
      this.$setDirty();
    }
    this.$$parseAndValidate();
  };

  this.$$parseAndValidate = function() {
    var viewValue = ctrl.$$lastCommittedViewValue;
    var modelValue = viewValue;
    parserValid = isUndefined(modelValue) ? undefined : true;

    if (parserValid) {
      for (var i = 0; i < ctrl.$parsers.length; i++) {
        modelValue = ctrl.$parsers[i](modelValue);
        if (isUndefined(modelValue)) {
          parserValid = false;
          break;
        }
      }
    }
    if (isNumberNaN(ctrl.$modelValue)) {
      // ctrl.$modelValue has not been touched yet...
      ctrl.$modelValue = ngModelGet($scope);
    }
    var prevModelValue = ctrl.$modelValue;
    var allowInvalid = ctrl.$options && ctrl.$options.allowInvalid;
    ctrl.$$rawModelValue = modelValue;

    if (allowInvalid) {
      ctrl.$modelValue = modelValue;
      writeToModelIfNeeded();
    }

    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
    // This can happen if e.g. $setViewValue is called from inside a parser
    ctrl.$$runValidators(modelValue, ctrl.$$lastCommittedViewValue, function(allValid) {
      if (!allowInvalid) {
        // Note: Don't check ctrl.$valid here, as we could have
        // external validators (e.g. calculated on the server),
        // that just call $setValidity and need the model value
        // to calculate their validity.
        ctrl.$modelValue = allValid ? modelValue : undefined;
        writeToModelIfNeeded();
      }
    });

    function writeToModelIfNeeded() {
      if (ctrl.$modelValue !== prevModelValue) {
        ctrl.$$writeModelToScope();
      }
    }
  };

  this.$$writeModelToScope = function() {
    ngModelSet($scope, ctrl.$modelValue);
    forEach(ctrl.$viewChangeListeners, function(listener) {
      try {
        listener();
      } catch (e) {
        $exceptionHandler(e);
      }
    });
  };

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setViewValue
   *
   * @description
   * Update the view value.
   *
   * This method should be called when a control wants to change the view value; typically,
   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
   * directive calls it when the value of the input changes and {@link ng.directive:select select}
   * calls it when an option is selected.
   *
   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
   * value sent directly for processing, finally to be applied to `$modelValue` and then the
   * **expression** specified in the `ng-model` attribute. Lastly, all the registered change listeners,
   * in the `$viewChangeListeners` list, are called.
   *
   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
   * and the `default` trigger is not listed, all those actions will remain pending until one of the
   * `updateOn` events is triggered on the DOM element.
   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
   * directive is used with a custom debounce for this particular event.
   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
   * is specified, once the timer runs out.
   *
   * When used with standard inputs, the view value will always be a string (which is in some cases
   * parsed into another type, such as a `Date` object for `input[date]`.)
   * However, custom controls might also pass objects to this method. In this case, we should make
   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
   * perform a deep watch of objects, it only looks for a change of identity. If you only change
   * the property of the object then ngModel will not realize that the object has changed and
   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
   * not change properties of the copy once it has been passed to `$setViewValue`.
   * Otherwise you may cause the model value on the scope to change incorrectly.
   *
   * <div class="alert alert-info">
   * In any case, the value passed to the method should always reflect the current value
   * of the control. For example, if you are calling `$setViewValue` for an input element,
   * you should pass the input DOM value. Otherwise, the control and the scope model become
   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
   * the control's DOM value in any way. If we want to change the control's DOM value
   * programmatically, we should update the `ngModel` scope expression. Its new value will be
   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
   * to update the DOM, and finally call `$validate` on it.
   * </div>
   *
   * @param {*} value value from the view.
   * @param {string} trigger Event that triggered the update.
   */
  this.$setViewValue = function(value, trigger) {
    ctrl.$viewValue = value;
    if (!ctrl.$options || ctrl.$options.updateOnDefault) {
      ctrl.$$debounceViewValueCommit(trigger);
    }
  };

  this.$$debounceViewValueCommit = function(trigger) {
    var debounceDelay = 0,
        options = ctrl.$options,
        debounce;

    if (options && isDefined(options.debounce)) {
      debounce = options.debounce;
      if (isNumber(debounce)) {
        debounceDelay = debounce;
      } else if (isNumber(debounce[trigger])) {
        debounceDelay = debounce[trigger];
      } else if (isNumber(debounce['default'])) {
        debounceDelay = debounce['default'];
      }
    }

    $timeout.cancel(pendingDebounce);
    if (debounceDelay) {
      pendingDebounce = $timeout(function() {
        ctrl.$commitViewValue();
      }, debounceDelay);
    } else if ($rootScope.$$phase) {
      ctrl.$commitViewValue();
    } else {
      $scope.$apply(function() {
        ctrl.$commitViewValue();
      });
    }
  };

  // model -> value
  // Note: we cannot use a normal scope.$watch as we want to detect the following:
  // 1. scope value is 'a'
  // 2. user enters 'b'
  // 3. ng-change kicks in and reverts scope value to 'a'
  //    -> scope value did not change since the last digest as
  //       ng-change executes in apply phase
  // 4. view should be changed back to 'a'
  $scope.$watch(function ngModelWatch() {
    var modelValue = ngModelGet($scope);

    // if scope model value and ngModel value are out of sync
    // TODO(perf): why not move this to the action fn?
    if (modelValue !== ctrl.$modelValue &&
       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
        // eslint-disable-next-line no-self-compare
       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
    ) {
      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
      parserValid = undefined;

      var formatters = ctrl.$formatters,
          idx = formatters.length;

      var viewValue = modelValue;
      while (idx--) {
        viewValue = formatters[idx](viewValue);
      }
      if (ctrl.$viewValue !== viewValue) {
        ctrl.$$updateEmptyClasses(viewValue);
        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
        ctrl.$render();

        // It is possible that model and view value have been updated during render
        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
      }
    }

    return modelValue;
  });
}];


/**
 * @ngdoc directive
 * @name ngModel
 *
 * @element input
 * @priority 1
 *
 * @description
 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
 * property on the scope using {@link ngModel.NgModelController NgModelController},
 * which is created and exposed by this directive.
 *
 * `ngModel` is responsible for:
 *
 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
 *   require.
 * - Providing validation behavior (i.e. required, number, email, url).
 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
 * - Registering the control with its parent {@link ng.directive:form form}.
 *
 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
 * current scope. If the property doesn't already exist on this scope, it will be created
 * implicitly and added to the scope.
 *
 * For best practices on using `ngModel`, see:
 *
 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
 *
 * For basic examples, how to use `ngModel`, see:
 *
 *  - {@link ng.directive:input input}
 *    - {@link input[text] text}
 *    - {@link input[checkbox] checkbox}
 *    - {@link input[radio] radio}
 *    - {@link input[number] number}
 *    - {@link input[email] email}
 *    - {@link input[url] url}
 *    - {@link input[date] date}
 *    - {@link input[datetime-local] datetime-local}
 *    - {@link input[time] time}
 *    - {@link input[month] month}
 *    - {@link input[week] week}
 *  - {@link ng.directive:select select}
 *  - {@link ng.directive:textarea textarea}
 *
 * # Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
 *
 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
 *
 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
 * if the select is given the `multiple` attribute.
 *
 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
 * not trigger a re-rendering of the model.
 *
 * # CSS classes
 * The following CSS classes are added and removed on the associated input/select/textarea element
 * depending on the validity of the model.
 *
 *  - `ng-valid`: the model is valid
 *  - `ng-invalid`: the model is invalid
 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
 *  - `ng-pristine`: the control hasn't been interacted with yet
 *  - `ng-dirty`: the control has been interacted with
 *  - `ng-touched`: the control has been blurred
 *  - `ng-untouched`: the control hasn't been blurred
 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
 *     by the {@link ngModel.NgModelController#$isEmpty} method
 *  - `ng-not-empty`: the view contains a non-empty value
 *
 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
 *
 * ## Animation Hooks
 *
 * Animations within models are triggered when any of the associated CSS classes are added and removed
 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
 * The animations that are triggered within ngModel are similar to how they work in ngClass and
 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
 *
 * The following example shows a simple way to utilize CSS transitions to style an input element
 * that has been rendered as invalid after it has been validated:
 *
 * <pre>
 * //be sure to include ngAnimate as a module to hook into more
 * //advanced animations
 * .my-input {
 *   transition:0.5s linear all;
 *   background: white;
 * }
 * .my-input.ng-invalid {
 *   background: red;
 *   color:white;
 * }
 * </pre>
 *
 * @example
 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
     <file name="index.html">
       <script>
        angular.module('inputExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.val = '1';
          }]);
       </script>
       <style>
         .my-input {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-input.ng-invalid {
           color:white;
           background: red;
         }
       </style>
       <p id="inputDescription">
        Update input to see transitions when valid/invalid.
        Integer is a valid value.
       </p>
       <form name="testForm" ng-controller="ExampleController">
         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                aria-describedby="inputDescription" />
       </form>
     </file>
 * </example>
 *
 * ## Binding to a getter/setter
 *
 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
 * function that returns a representation of the model when called with zero arguments, and sets
 * the internal state of a model when called with an argument. It's sometimes useful to use this
 * for models that have an internal representation that's different from what the model exposes
 * to the view.
 *
 * <div class="alert alert-success">
 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
 * frequently than other parts of your code.
 * </div>
 *
 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
 *
 * The following example shows how to use `ngModel` with a getter/setter:
 *
 * @example
 * <example name="ngModel-getter-setter" module="getterSetterExample">
     <file name="index.html">
       <div ng-controller="ExampleController">
         <form name="userForm">
           <label>Name:
             <input type="text" name="userName"
                    ng-model="user.name"
                    ng-model-options="{ getterSetter: true }" />
           </label>
         </form>
         <pre>user.name = <span ng-bind="user.name()"></span></pre>
       </div>
     </file>
     <file name="app.js">
       angular.module('getterSetterExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           var _name = 'Brian';
           $scope.user = {
             name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
             }
           };
         }]);
     </file>
 * </example>
 */
var ngModelDirective = ['$rootScope', function($rootScope) {
  return {
    restrict: 'A',
    require: ['ngModel', '^?form', '^?ngModelOptions'],
    controller: NgModelController,
    // Prelink needs to run before any input directive
    // so that we can set the NgModelOptions in NgModelController
    // before anyone else uses it.
    priority: 1,
    compile: function ngModelCompile(element) {
      // Setup initial state of the control
      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

      return {
        pre: function ngModelPreLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm;

          modelCtrl.$$setOptions(ctrls[2] && ctrls[2].$options);

          // notify others, especially parent forms
          formCtrl.$addControl(modelCtrl);

          attr.$observe('name', function(newValue) {
            if (modelCtrl.$name !== newValue) {
              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
            }
          });

          scope.$on('$destroy', function() {
            modelCtrl.$$parentForm.$removeControl(modelCtrl);
          });
        },
        post: function ngModelPostLink(scope, element, attr, ctrls) {
          var modelCtrl = ctrls[0];
          if (modelCtrl.$options && modelCtrl.$options.updateOn) {
            element.on(modelCtrl.$options.updateOn, function(ev) {
              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
            });
          }

          element.on('blur', function() {
            if (modelCtrl.$touched) return;

            if ($rootScope.$$phase) {
              scope.$evalAsync(modelCtrl.$setTouched);
            } else {
              scope.$apply(modelCtrl.$setTouched);
            }
          });
        }
      };
    }
  };
}];



var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

/**
 * @ngdoc directive
 * @name ngModelOptions
 *
 * @description
 * Allows tuning how model updates are done. Using `ngModelOptions` you can specify a custom list of
 * events that will trigger a model update and/or a debouncing delay so that the actual update only
 * takes place when a timer expires; this timer will be reset after another change takes place.
 *
 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
 * be different from the value in the actual model. This means that if you update the model you
 * should also invoke {@link ngModel.NgModelController `$rollbackViewValue`} on the relevant input field in
 * order to make sure it is synchronized with the model and that any debounced action is canceled.
 *
 * The easiest way to reference the control's {@link ngModel.NgModelController `$rollbackViewValue`}
 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
 * important because `form` controllers are published to the related scope under the name in their
 * `name` attribute.
 *
 * Any pending changes will take place immediately when an enclosing form is submitted via the
 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
 * to have access to the updated model.
 *
 * `ngModelOptions` has an effect on the element it's declared on and its descendants.
 *
 * @param {Object} ngModelOptions options to apply to the current model. Valid keys are:
 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
 *     events using an space delimited list. There is a special event called `default` that
 *     matches the default events belonging of the control.
 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
 *     custom value for each event. For example:
 *     `ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 } }"`
 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
 *     not validate correctly instead of the default behavior of setting the model to undefined.
 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
       `ngModel` as getters/setters.
 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
 *     `<input type="date">`, `<input type="time">`, ... . It understands UTC/GMT and the
 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
 *     If not specified, the timezone of the browser will be used.
 *
 * @example

  The following example shows how to override immediate updates. Changes on the inputs within the
  form will update the model only when the control loses focus (blur event). If `escape` key is
  pressed while the input field is focused, the value is reset to the value in the current model.

  <example name="ngModelOptions-directive-blur" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ updateOn: 'blur' }"
                   ng-keyup="cancel($event)" />
          </label><br />
          <label>Other data:
            <input type="text" ng-model="user.data" />
          </label><br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
        <pre>user.data = <span ng-bind="user.data"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'John', data: '' };

          $scope.cancel = function(e) {
            if (e.keyCode === 27) {
              $scope.userForm.userName.$rollbackViewValue();
            }
          };
        }]);
    </file>
    <file name="protractor.js" type="protractor">
      var model = element(by.binding('user.name'));
      var input = element(by.model('user.name'));
      var other = element(by.model('user.data'));

      it('should allow custom events', function() {
        input.sendKeys(' Doe');
        input.click();
        expect(model.getText()).toEqual('John');
        other.click();
        expect(model.getText()).toEqual('John Doe');
      });

      it('should $rollbackViewValue when model changes', function() {
        input.sendKeys(' Doe');
        expect(input.getAttribute('value')).toEqual('John Doe');
        input.sendKeys(protractor.Key.ESCAPE);
        expect(input.getAttribute('value')).toEqual('John');
        other.click();
        expect(model.getText()).toEqual('John');
      });
    </file>
  </example>

  This one shows how to debounce model changes. Model will be updated only 1 sec after last change.
  If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.

  <example name="ngModelOptions-directive-debounce" module="optionsExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ debounce: 1000 }" />
          </label>
          <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button>
          <br />
        </form>
        <pre>user.name = <span ng-bind="user.name"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('optionsExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.user = { name: 'Igor' };
        }]);
    </file>
  </example>

  This one shows how to bind to getter/setters:

  <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <form name="userForm">
          <label>Name:
            <input type="text" name="userName"
                   ng-model="user.name"
                   ng-model-options="{ getterSetter: true }" />
          </label>
        </form>
        <pre>user.name = <span ng-bind="user.name()"></span></pre>
      </div>
    </file>
    <file name="app.js">
      angular.module('getterSetterExample', [])
        .controller('ExampleController', ['$scope', function($scope) {
          var _name = 'Brian';
          $scope.user = {
            name: function(newName) {
              // Note that newName can be undefined for two reasons:
              // 1. Because it is called as a getter and thus called with no arguments
              // 2. Because the property should actually be set to undefined. This happens e.g. if the
              //    input is invalid
              return arguments.length ? (_name = newName) : _name;
            }
          };
        }]);
    </file>
  </example>
 */
var ngModelOptionsDirective = function() {
  return {
    restrict: 'A',
    controller: ['$scope', '$attrs', function NgModelOptionsController($scope, $attrs) {
      var that = this;
      this.$options = copy($scope.$eval($attrs.ngModelOptions));
      // Allow adding/overriding bound events
      if (isDefined(this.$options.updateOn)) {
        this.$options.updateOnDefault = false;
        // extract "default" pseudo-event from list of events that can trigger a model update
        this.$options.updateOn = trim(this.$options.updateOn.replace(DEFAULT_REGEXP, function() {
          that.$options.updateOnDefault = true;
          return ' ';
        }));
      } else {
        this.$options.updateOnDefault = true;
      }
    }]
  };
};



// helper methods
function addSetValidityMethod(context) {
  var ctrl = context.ctrl,
      $element = context.$element,
      classCache = {},
      set = context.set,
      unset = context.unset,
      $animate = context.$animate;

  classCache[INVALID_CLASS] = !(classCache[VALID_CLASS] = $element.hasClass(VALID_CLASS));

  ctrl.$setValidity = setValidity;

  function setValidity(validationErrorKey, state, controller) {
    if (isUndefined(state)) {
      createAndSet('$pending', validationErrorKey, controller);
    } else {
      unsetAndCleanup('$pending', validationErrorKey, controller);
    }
    if (!isBoolean(state)) {
      unset(ctrl.$error, validationErrorKey, controller);
      unset(ctrl.$$success, validationErrorKey, controller);
    } else {
      if (state) {
        unset(ctrl.$error, validationErrorKey, controller);
        set(ctrl.$$success, validationErrorKey, controller);
      } else {
        set(ctrl.$error, validationErrorKey, controller);
        unset(ctrl.$$success, validationErrorKey, controller);
      }
    }
    if (ctrl.$pending) {
      cachedToggleClass(PENDING_CLASS, true);
      ctrl.$valid = ctrl.$invalid = undefined;
      toggleValidationCss('', null);
    } else {
      cachedToggleClass(PENDING_CLASS, false);
      ctrl.$valid = isObjectEmpty(ctrl.$error);
      ctrl.$invalid = !ctrl.$valid;
      toggleValidationCss('', ctrl.$valid);
    }

    // re-read the state as the set/unset methods could have
    // combined state in ctrl.$error[validationError] (used for forms),
    // where setting/unsetting only increments/decrements the value,
    // and does not replace it.
    var combinedState;
    if (ctrl.$pending && ctrl.$pending[validationErrorKey]) {
      combinedState = undefined;
    } else if (ctrl.$error[validationErrorKey]) {
      combinedState = false;
    } else if (ctrl.$$success[validationErrorKey]) {
      combinedState = true;
    } else {
      combinedState = null;
    }

    toggleValidationCss(validationErrorKey, combinedState);
    ctrl.$$parentForm.$setValidity(validationErrorKey, combinedState, ctrl);
  }

  function createAndSet(name, value, controller) {
    if (!ctrl[name]) {
      ctrl[name] = {};
    }
    set(ctrl[name], value, controller);
  }

  function unsetAndCleanup(name, value, controller) {
    if (ctrl[name]) {
      unset(ctrl[name], value, controller);
    }
    if (isObjectEmpty(ctrl[name])) {
      ctrl[name] = undefined;
    }
  }

  function cachedToggleClass(className, switchValue) {
    if (switchValue && !classCache[className]) {
      $animate.addClass($element, className);
      classCache[className] = true;
    } else if (!switchValue && classCache[className]) {
      $animate.removeClass($element, className);
      classCache[className] = false;
    }
  }

  function toggleValidationCss(validationErrorKey, isValid) {
    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

    cachedToggleClass(VALID_CLASS + validationErrorKey, isValid === true);
    cachedToggleClass(INVALID_CLASS + validationErrorKey, isValid === false);
  }
}

function isObjectEmpty(obj) {
  if (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
  }
  return true;
}

/**
 * @ngdoc directive
 * @name ngNonBindable
 * @restrict AC
 * @priority 1000
 *
 * @description
 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
 * DOM element. This is useful if the element contains what appears to be Angular directives and
 * bindings but which should be ignored by Angular. This could be the case if you have a site that
 * displays snippets of code, for instance.
 *
 * @element ANY
 *
 * @example
 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
 * but the one wrapped in `ngNonBindable` is left alone.
 *
 * @example
    <example name="ng-non-bindable">
      <file name="index.html">
        <div>Normal: {{1 + 2}}</div>
        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
      </file>
      <file name="protractor.js" type="protractor">
       it('should check ng-non-bindable', function() {
         expect(element(by.binding('1 + 2')).getText()).toContain('3');
         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
       });
      </file>
    </example>
 */
var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

/* exported ngOptionsDirective */

/* global jqLiteRemove */

var ngOptionsMinErr = minErr('ngOptions');

/**
 * @ngdoc directive
 * @name ngOptions
 * @restrict A
 *
 * @description
 *
 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
 * elements for the `<select>` element using the array or object obtained by evaluating the
 * `ngOptions` comprehension expression.
 *
 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements
 * instead of `ngOptions` to achieve a similar result.
 * However, `ngOptions` provides some benefits such as reducing memory and
 * increasing speed by not creating a new scope for each repeated instance, as well as providing
 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression. `ngOptions` should be used when the `<select>` model needs to be bound
 *  to a non-string value. This is because an option element can only be bound to string values at
 * present.
 *
 * When an item in the `<select>` menu is selected, the array element or object property
 * represented by the selected option will be bound to the model identified by the `ngModel`
 * directive.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * ## Complex Models (objects or collections)
 *
 * By default, `ngModel` watches the model by reference, not value. This is important to know when
 * binding the select to a model that is an object or a collection.
 *
 * One issue occurs if you want to preselect an option. For example, if you set
 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
 * because the objects are not identical. So by default, you should always reference the item in your collection
 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
 *
 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
 * of the item not by reference, but by the result of the `track by` expression. For example, if your
 * collection items have an id property, you would `track by item.id`.
 *
 * A different issue with objects or collections is that ngModel won't detect if an object property or
 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
 * has not changed identity, but only a property on the object or an item in the collection changes.
 *
 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
 * if the model is an array). This means that changing a property deeper than the first level inside the
 * object/collection will not trigger a re-rendering.
 *
 * ## `select` **`as`**
 *
 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
 *
 *
 * ### `select` **`as`** and **`track by`**
 *
 * <div class="alert alert-warning">
 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
 * </div>
 *
 * Given this array of items on the $scope:
 *
 * ```js
 * $scope.items = [{
 *   id: 1,
 *   label: 'aLabel',
 *   subItem: { name: 'aSubItem' }
 * }, {
 *   id: 2,
 *   label: 'bLabel',
 *   subItem: { name: 'bSubItem' }
 * }];
 * ```
 *
 * This will work:
 *
 * ```html
 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0];
 * ```
 *
 * but this will not work:
 *
 * ```html
 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
 * ```
 * ```js
 * $scope.selected = $scope.items[0].subItem;
 * ```
 *
 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
 * `items` array. Because the selected option has been set programmatically in the controller, the
 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
 *
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} required The control is considered valid only if value is entered.
 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
 *    `required` when you want to data-bind to the `required` attribute.
 * @param {comprehension_expression=} ngOptions in one of the following forms:
 *
 *   * for array data sources:
 *     * `label` **`for`** `value` **`in`** `array`
 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
 *        (for including a filter with `track by`)
 *   * for object data sources:
 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`group by`** `group`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *     * `select` **`as`** `label` **`disable when`** `disable`
 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
 *
 * Where:
 *
 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
 *   * `value`: local variable which will refer to each item in the `array` or each property value
 *      of `object` during iteration.
 *   * `key`: local variable which will refer to a property name in `object` during iteration.
 *   * `label`: The result of this expression will be the label for `<option>` element. The
 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
 *      element. If not specified, `select` expression will default to `value`.
 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
 *      DOM element.
 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
 *      element. Return `true` to disable.
 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
 *      even when the options are recreated (e.g. reloaded from the server).
 *
 * @example
    <example module="selectExample" name="select">
      <file name="index.html">
        <script>
        angular.module('selectExample', [])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.colors = [
              {name:'black', shade:'dark'},
              {name:'white', shade:'light', notAnOption: true},
              {name:'red', shade:'dark'},
              {name:'blue', shade:'dark', notAnOption: true},
              {name:'yellow', shade:'light', notAnOption: false}
            ];
            $scope.myColor = $scope.colors[2]; // red
          }]);
        </script>
        <div ng-controller="ExampleController">
          <ul>
            <li ng-repeat="color in colors">
              <label>Name: <input ng-model="color.name"></label>
              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
            </li>
            <li>
              <button ng-click="colors.push({})">add</button>
            </li>
          </ul>
          <hr/>
          <label>Color (null not allowed):
            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
          </label><br/>
          <label>Color (null allowed):
          <span  class="nullable">
            <select ng-model="myColor" ng-options="color.name for color in colors">
              <option value="">-- choose color --</option>
            </select>
          </span></label><br/>

          <label>Color grouped by shade:
            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
            </select>
          </label><br/>

          <label>Color grouped by shade, with some disabled:
            <select ng-model="myColor"
                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
            </select>
          </label><br/>



          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
          <br/>
          <hr/>
          Currently selected: {{ {selected_color:myColor} }}
          <div style="border:solid 1px black; height:20px"
               ng-style="{'background-color':myColor.name}">
          </div>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
         it('should check ng-options', function() {
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
           element.all(by.model('myColor')).first().click();
           element.all(by.css('select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
           element(by.css('.nullable select[ng-model="myColor"]')).click();
           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
         });
      </file>
    </example>
 */

/* eslint-disable max-len */
//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
                        // 1: value expression (valueFn)
                        // 2: label expression (displayFn)
                        // 3: group by expression (groupByFn)
                        // 4: disable when expression (disableWhenFn)
                        // 5: array item variable name
                        // 6: object item key variable name
                        // 7: object item value variable name
                        // 8: collection expression
                        // 9: track by expression
/* eslint-enable */


var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {

  function parseOptionsExpression(optionsExp, selectElement, scope) {

    var match = optionsExp.match(NG_OPTIONS_REGEXP);
    if (!(match)) {
      throw ngOptionsMinErr('iexp',
        'Expected expression in form of ' +
        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
        ' but got \'{0}\'. Element: {1}',
        optionsExp, startingTag(selectElement));
    }

    // Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];
    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];
    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];
    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;
    var trackByFn = trackBy && $parse(trackBy);

    // Get the value by which we are going to track the option
    // if we have a trackFn then use that (passing scope and locals)
    // otherwise just hash the given viewValue
    var getTrackByValueFn = trackBy ?
                              function(value, locals) { return trackByFn(scope, locals); } :
                              function getHashOfValue(value) { return hashKey(value); };
    var getTrackByValue = function(value, key) {
      return getTrackByValueFn(value, getLocals(value, key));
    };

    var displayFn = $parse(match[2] || match[1]);
    var groupByFn = $parse(match[3] || '');
    var disableWhenFn = $parse(match[4] || '');
    var valuesFn = $parse(match[8]);

    var locals = {};
    var getLocals = keyName ? function(value, key) {
      locals[keyName] = key;
      locals[valueName] = value;
      return locals;
    } : function(value) {
      locals[valueName] = value;
      return locals;
    };


    function Option(selectValue, viewValue, label, group, disabled) {
      this.selectValue = selectValue;
      this.viewValue = viewValue;
      this.label = label;
      this.group = group;
      this.disabled = disabled;
    }

    function getOptionValuesKeys(optionValues) {
      var optionValuesKeys;

      if (!keyName && isArrayLike(optionValues)) {
        optionValuesKeys = optionValues;
      } else {
        // if object, extract keys, in enumeration order, unsorted
        optionValuesKeys = [];
        for (var itemKey in optionValues) {
          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
            optionValuesKeys.push(itemKey);
          }
        }
      }
      return optionValuesKeys;
    }

    return {
      trackBy: trackBy,
      getTrackByValue: getTrackByValue,
      getWatchables: $parse(valuesFn, function(optionValues) {
        // Create a collection of things that we would like to watch (watchedArray)
        // so that they can all be watched using a single $watchCollection
        // that only runs the handler once if anything changes
        var watchedArray = [];
        optionValues = optionValues || [];

        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;
        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];

          var locals = getLocals(value, key);
          var selectValue = getTrackByValueFn(value, locals);
          watchedArray.push(selectValue);

          // Only need to watch the displayFn if there is a specific label expression
          if (match[2] || match[1]) {
            var label = displayFn(scope, locals);
            watchedArray.push(label);
          }

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }
        }
        return watchedArray;
      }),

      getOptions: function() {

        var optionItems = [];
        var selectValueMap = {};

        // The option values were already computed in the `getWatchables` fn,
        // which must have been called to trigger `getOptions`
        var optionValues = valuesFn(scope) || [];
        var optionValuesKeys = getOptionValuesKeys(optionValues);
        var optionValuesLength = optionValuesKeys.length;

        for (var index = 0; index < optionValuesLength; index++) {
          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
          var value = optionValues[key];
          var locals = getLocals(value, key);
          var viewValue = viewValueFn(scope, locals);
          var selectValue = getTrackByValueFn(viewValue, locals);
          var label = displayFn(scope, locals);
          var group = groupByFn(scope, locals);
          var disabled = disableWhenFn(scope, locals);
          var optionItem = new Option(selectValue, viewValue, label, group, disabled);

          optionItems.push(optionItem);
          selectValueMap[selectValue] = optionItem;
        }

        return {
          items: optionItems,
          selectValueMap: selectValueMap,
          getOptionFromViewValue: function(value) {
            return selectValueMap[getTrackByValue(value)];
          },
          getViewValueFromOption: function(option) {
            // If the viewValue could be an object that may be mutated by the application,
            // we need to make a copy and not return the reference to the value on the option.
            return trackBy ? copy(option.viewValue) : option.viewValue;
          }
        };
      }
    };
  }


  // we can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      var emptyOption;
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          emptyOption = children.eq(i);
          break;
        }
      }

      var providedEmptyOption = !!emptyOption;
      var emptyOptionRendered = false;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      var renderEmptyOption = function() {
        if (!providedEmptyOption) {
          selectElement.prepend(emptyOption);
        }
        selectElement.val('');
        if (emptyOptionRendered) {
          emptyOption.prop('selected', true); // needed for IE
          emptyOption.attr('selected', true);
        }
      };

      var removeEmptyOption = function() {
        if (!providedEmptyOption) {
          emptyOption.remove();
        } else if (emptyOptionRendered) {
          emptyOption.removeAttr('selected');
        }
      };

      var renderUnknownOption = function() {
        selectElement.prepend(unknownOption);
        selectElement.val('?');
        unknownOption.prop('selected', true); // needed for IE
        unknownOption.attr('selected', true);
      };

      var removeUnknownOption = function() {
        unknownOption.remove();
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          var selectedOption = options.selectValueMap[selectElement.val()];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.element.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              removeUnknownOption();
              removeEmptyOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            if (value === null || providedEmptyOption) {
              removeUnknownOption();
              renderEmptyOption();
            } else {
              removeEmptyOption();
              renderUnknownOption();
            }
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            removeEmptyOption();
            removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(
            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
            function() { ngModelCtrl.$render(); }
          );
        }

      } else {

        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };


        selectCtrl.writeValue = function writeNgOptionsMultiple(value) {
          options.items.forEach(function(option) {
            option.element.selected = false;
          });

          if (value) {
            value.forEach(function(item) {
              var option = options.getOptionFromViewValue(item);
              if (option) option.element.selected = true;
            });
          }
        };


        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function(value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function() {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function(value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function() {
            ngModelCtrl.$render();
          });

        }
      }


      if (providedEmptyOption) {

        // we need to remove it before calling selectElement.empty() because otherwise IE will
        // remove the label from the element. wtf?
        emptyOption.remove();

        // compile the element since there might be bindings in it
        $compile(emptyOption)(scope);

        if (emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.

          emptyOptionRendered = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function(optionScope, optionEl) {
            if (optionEl.val() === '') {
              emptyOptionRendered = true;
              emptyOption = optionEl;
              emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function() {
                emptyOption = undefined;
                emptyOptionRendered = false;
              });
            }
          };

        } else {
          emptyOption.removeClass('ng-scope');
          emptyOptionRendered = true;
        }

      } else {
        emptyOption = jqLite(optionTemplate.cloneNode(false));
      }

      selectElement.empty();

      // We need to do this here to ensure that the options object is defined
      // when we first hit it in writeNgOptionsValue
      updateOptions();

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }


      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        // Ensure that the empty option is always there if it was explicitly provided
        if (providedEmptyOption) {
          selectElement.prepend(emptyOption);
        }

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);

          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }

      }
  }

  return {
    restrict: 'A',
    terminal: true,
    require: ['select', 'ngModel'],
    link: {
      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
        // Deactivate the SelectController.register method to prevent
        // option directives from accidentally registering themselves
        // (and unwanted $destroy handlers etc.)
        ctrls[0].registerOption = noop;
      },
      post: ngOptionsPostLink
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngPluralize
 * @restrict EA
 *
 * @description
 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
 * These rules are bundled with angular.js, but can be overridden
 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
 * by specifying the mappings between
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * and the strings to be displayed.
 *
 * # Plural categories and explicit number rules
 * There are two
 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
 * in Angular's default en-US locale: "one" and "other".
 *
 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
 * any number that is not 1), an explicit number rule can only match one number. For example, the
 * explicit number rule for "3" matches the number 3. There are examples of plural categories
 * and explicit number rules throughout the rest of this documentation.
 *
 * # Configuring ngPluralize
 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
 * You can also provide an optional attribute, `offset`.
 *
 * The value of the `count` attribute can be either a string or an {@link guide/expression
 * Angular expression}; these are evaluated on the current scope for its bound value.
 *
 * The `when` attribute specifies the mappings between plural categories and the actual
 * string to be displayed. The value of the attribute should be a JSON object.
 *
 * The following example shows how to configure ngPluralize:
 *
 * ```html
 * <ng-pluralize count="personCount"
                 when="{'0': 'Nobody is viewing.',
 *                      'one': '1 person is viewing.',
 *                      'other': '{} people are viewing.'}">
 * </ng-pluralize>
 *```
 *
 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
 * show "a dozen people are viewing".
 *
 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
 * into pluralized strings. In the previous example, Angular will replace `{}` with
 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
 * for <span ng-non-bindable>{{numberExpression}}</span>.
 *
 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
 *
 * # Configuring ngPluralize with offset
 * The `offset` attribute allows further customization of pluralized text, which can result in
 * a better user experience. For example, instead of the message "4 people are viewing this document",
 * you might display "John, Kate and 2 others are viewing this document".
 * The offset attribute allows you to offset a number by any desired value.
 * Let's take a look at an example:
 *
 * ```html
 * <ng-pluralize count="personCount" offset=2
 *               when="{'0': 'Nobody is viewing.',
 *                      '1': '{{person1}} is viewing.',
 *                      '2': '{{person1}} and {{person2}} are viewing.',
 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
 * </ng-pluralize>
 * ```
 *
 * Notice that we are still using two plural categories(one, other), but we added
 * three explicit number rules 0, 1 and 2.
 * When one person, perhaps John, views the document, "John is viewing" will be shown.
 * When three people view the document, no explicit number rule is found, so
 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
 * is shown.
 *
 * Note that when you specify offsets, you must provide explicit number rules for
 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
 * plural categories "one" and "other".
 *
 * @param {string|expression} count The variable to be bound to.
 * @param {string} when The mapping between plural category to its corresponding strings.
 * @param {number=} offset Offset to deduct from the total number.
 *
 * @example
    <example module="pluralizeExample" name="ng-pluralize">
      <file name="index.html">
        <script>
          angular.module('pluralizeExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.person1 = 'Igor';
              $scope.person2 = 'Misko';
              $scope.personCount = 1;
            }]);
        </script>
        <div ng-controller="ExampleController">
          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>

          <!--- Example with simple pluralization rules for en locale --->
          Without Offset:
          <ng-pluralize count="personCount"
                        when="{'0': 'Nobody is viewing.',
                               'one': '1 person is viewing.',
                               'other': '{} people are viewing.'}">
          </ng-pluralize><br>

          <!--- Example with offset --->
          With Offset(2):
          <ng-pluralize count="personCount" offset=2
                        when="{'0': 'Nobody is viewing.',
                               '1': '{{person1}} is viewing.',
                               '2': '{{person1}} and {{person2}} are viewing.',
                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
          </ng-pluralize>
        </div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should show correct pluralized string', function() {
          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var countInput = element(by.model('personCount'));

          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
          expect(withOffset.getText()).toEqual('Igor is viewing.');

          countInput.clear();
          countInput.sendKeys('0');

          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
          expect(withOffset.getText()).toEqual('Nobody is viewing.');

          countInput.clear();
          countInput.sendKeys('2');

          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');

          countInput.clear();
          countInput.sendKeys('3');

          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');

          countInput.clear();
          countInput.sendKeys('4');

          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
        });
        it('should show data-bound names', function() {
          var withOffset = element.all(by.css('ng-pluralize')).get(1);
          var personCount = element(by.model('personCount'));
          var person1 = element(by.model('person1'));
          var person2 = element(by.model('person2'));
          personCount.clear();
          personCount.sendKeys('4');
          person1.clear();
          person1.sendKeys('Di');
          person2.clear();
          person2.sendKeys('Vojta');
          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
        });
      </file>
    </example>
 */
var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
  var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;

  return {
    link: function(scope, element, attr) {
      var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;

      forEach(attr, function(expression, attributeName) {
        var tmpMatch = IS_WHEN.exec(attributeName);
        if (tmpMatch) {
          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
          whens[whenKey] = element.attr(attr.$attr[attributeName]);
        }
      });
      forEach(whens, function(expression, key) {
        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));

      });

      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
        var count = parseFloat(newVal);
        var countIsNaN = isNumberNaN(count);

        if (!countIsNaN && !(count in whens)) {
          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
          // Otherwise, check it against pluralization rules in $locale service.
          count = $locale.pluralCat(count - offset);
        }

        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
        // In JS `NaN !== NaN`, so we have to explicitly check.
        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
          watchRemover();
          var whenExpFn = whensExpFns[count];
          if (isUndefined(whenExpFn)) {
            if (newVal != null) {
              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
            }
            watchRemover = noop;
            updateElementText();
          } else {
            watchRemover = scope.$watch(whenExpFn, updateElementText);
          }
          lastCount = count;
        }
      });

      function updateElementText(newText) {
        element.text(newText || '');
      }
    }
  };
}];

/* exported ngRepeatDirective */

/**
 * @ngdoc directive
 * @name ngRepeat
 * @multiElement
 *
 * @description
 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
 * instance gets its own scope, where the given loop variable is set to the current collection item,
 * and `$index` is set to the item index or key.
 *
 * Special properties are exposed on the local scope of each template instance, including:
 *
 * | Variable  | Type            | Details                                                                     |
 * |-----------|-----------------|-----------------------------------------------------------------------------|
 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
 *
 * <div class="alert alert-info">
 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
 *   This may be useful when, for instance, nesting ngRepeats.
 * </div>
 *
 *
 * # Iterating over object properties
 *
 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
 * syntax:
 *
 * ```js
 * <div ng-repeat="(key, value) in myObj"> ... </div>
 * ```
 *
 * However, there are a few limitations compared to array iteration:
 *
 * - The JavaScript specification does not define the order of keys
 *   returned for an object, so Angular relies on the order returned by the browser
 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
 *   and reinstated. See the
 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
 *
 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
 *
 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
 *   objects, and will throw an error if used with one.
 *
 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
 * or implement a `$watch` on the object yourself.
 *
 *
 * # Tracking and Duplicates
 *
 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 *
 * To minimize creation of DOM elements, `ngRepeat` uses a function
 * to "keep track" of all items in the collection and their corresponding DOM elements.
 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
 * already have DOM elements, and will not re-render them.
 *
 * The default tracking function (which tracks items by their identity) does not allow
 * duplicate items in arrays. This is because when there are duplicates, it is not possible
 * to maintain a one-to-one mapping between collection items and DOM elements.
 *
 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
 * with your own using the `track by` expression.
 *
 * For example, you may track items by the index of each item in the collection, using the
 * special scope property `$index`:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
 *      {{n}}
 *    </div>
 * ```
 *
 * You may also use arbitrary expressions in `track by`, including references to custom functions
 * on the scope:
 * ```html
 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
 *      {{n}}
 *    </div>
 * ```
 *
 * <div class="alert alert-success">
 * If you are working with objects that have a unique identifier property, you should track
 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
 * will not have to rebuild the DOM elements for items it has already rendered, even if the
 * JavaScript objects in the collection have been substituted for new ones. For large collections,
 * this significantly improves rendering performance. If you don't have a unique identifier,
 * `track by $index` can also provide a performance boost.
 * </div>
 *
 * ```html
 *    <div ng-repeat="model in collection track by model.id">
 *      {{model.name}}
 *    </div>
 * ```
 *
 * <br />
 * <div class="alert alert-warning">
 * Avoid using `track by $index` when the repeated template contains
 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
 * element will always be matched with the `nth` item of the array, so the bindings on that element
 * will not be updated even when the corresponding item changes, essentially causing the view to get
 * out-of-sync with the underlying data.
 * </div>
 *
 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
 * `$id` function, which tracks items by their identity:
 * ```html
 *    <div ng-repeat="obj in collection track by $id(obj)">
 *      {{obj.prop}}
 *    </div>
 * ```
 *
 * <br />
 * <div class="alert alert-warning">
 * **Note:** `track by` must always be the last expression:
 * </div>
 * ```
 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
 *      {{model.name}}
 *    </div>
 * ```
 *
 *
 * # Special repeat start and end points
 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
 *
 * The example below makes use of this feature:
 * ```html
 *   <header ng-repeat-start="item in items">
 *     Header {{ item }}
 *   </header>
 *   <div class="body">
 *     Body {{ item }}
 *   </div>
 *   <footer ng-repeat-end>
 *     Footer {{ item }}
 *   </footer>
 * ```
 *
 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
 * ```html
 *   <header>
 *     Header A
 *   </header>
 *   <div class="body">
 *     Body A
 *   </div>
 *   <footer>
 *     Footer A
 *   </footer>
 *   <header>
 *     Header B
 *   </header>
 *   <div class="body">
 *     Body B
 *   </div>
 *   <footer>
 *     Footer B
 *   </footer>
 * ```
 *
 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
 *
 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
 *
 * See the example below for defining CSS animations with ngRepeat.
 *
 * @element ANY
 * @scope
 * @priority 1000
 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
 *   formats are currently supported:
 *
 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
 *     is a scope expression giving the collection to enumerate.
 *
 *     For example: `album in artist.albums`.
 *
 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
 *     and `expression` is the scope expression giving the collection to enumerate.
 *
 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
 *
 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
 *     is specified, ng-repeat associates elements by identity. It is an error to have
 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
 *     mapped to the same DOM element, which is not possible.)
 *
 *     Note that the tracking expression must come last, after any filters, and the alias expression.
 *
 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
 *     will be associated by item identity in the array.
 *
 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
 *     element in the same way in the DOM.
 *
 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
 *     property is same.
 *
 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
 *     to items in conjunction with a tracking expression.
 *
 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
 *     when a filter is active on the repeater, but the filtered result set is empty.
 *
 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
 *     the items have been processed through the filter.
 *
 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
 *     (and not as operator, inside an expression).
 *
 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
 *
 * @example
 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
 * results by name or by age. New (entering) and removed (leaving) items are animated.
  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
    <file name="index.html">
      <div ng-controller="repeatController">
        I have {{friends.length}} friends. They are:
        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
        <ul class="example-animate-container">
          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
          </li>
          <li class="animate-repeat" ng-if="results.length === 0">
            <strong>No results found...</strong>
          </li>
        </ul>
      </div>
    </file>
    <file name="script.js">
      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
        $scope.friends = [
          {name:'John', age:25, gender:'boy'},
          {name:'Jessie', age:30, gender:'girl'},
          {name:'Johanna', age:28, gender:'girl'},
          {name:'Joy', age:15, gender:'girl'},
          {name:'Mary', age:28, gender:'girl'},
          {name:'Peter', age:95, gender:'boy'},
          {name:'Sebastian', age:50, gender:'boy'},
          {name:'Erika', age:27, gender:'girl'},
          {name:'Patrick', age:40, gender:'boy'},
          {name:'Samantha', age:60, gender:'girl'}
        ];
      });
    </file>
    <file name="animations.css">
      .example-animate-container {
        background:white;
        border:1px solid black;
        list-style:none;
        margin:0;
        padding:0 10px;
      }

      .animate-repeat {
        line-height:30px;
        list-style:none;
        box-sizing:border-box;
      }

      .animate-repeat.ng-move,
      .animate-repeat.ng-enter,
      .animate-repeat.ng-leave {
        transition:all linear 0.5s;
      }

      .animate-repeat.ng-leave.ng-leave-active,
      .animate-repeat.ng-move,
      .animate-repeat.ng-enter {
        opacity:0;
        max-height:0;
      }

      .animate-repeat.ng-leave,
      .animate-repeat.ng-move.ng-move-active,
      .animate-repeat.ng-enter.ng-enter-active {
        opacity:1;
        max-height:30px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var friends = element.all(by.repeater('friend in friends'));

      it('should render initial data set', function() {
        expect(friends.count()).toBe(10);
        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
        expect(element(by.binding('friends.length')).getText())
            .toMatch("I have 10 friends. They are:");
      });

       it('should update repeater when filter predicate changes', function() {
         expect(friends.count()).toBe(10);

         element(by.model('q')).sendKeys('ma');

         expect(friends.count()).toBe(2);
         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
       });
      </file>
    </example>
 */
var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
  var NG_REMOVED = '$$NG_REMOVED';
  var ngRepeatMinErr = minErr('ngRepeat');

  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
    scope[valueIdentifier] = value;
    if (keyIdentifier) scope[keyIdentifier] = key;
    scope.$index = index;
    scope.$first = (index === 0);
    scope.$last = (index === (arrayLength - 1));
    scope.$middle = !(scope.$first || scope.$last);
    // eslint-disable-next-line no-bitwise
    scope.$odd = !(scope.$even = (index & 1) === 0);
  };

  var getBlockStart = function(block) {
    return block.clone[0];
  };

  var getBlockEnd = function(block) {
    return block.clone[block.clone.length - 1];
  };


  return {
    restrict: 'A',
    multiElement: true,
    transclude: 'element',
    priority: 1000,
    terminal: true,
    $$tlb: true,
    compile: function ngRepeatCompile($element, $attr) {
      var expression = $attr.ngRepeat;
      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

      if (!match) {
        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
            expression);
      }

      var lhs = match[1];
      var rhs = match[2];
      var aliasAs = match[3];
      var trackByExp = match[4];

      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

      if (!match) {
        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
            lhs);
      }
      var valueIdentifier = match[3] || match[1];
      var keyIdentifier = match[2];

      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
          aliasAs);
      }

      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
      var hashFnLocals = {$id: hashKey};

      if (trackByExp) {
        trackByExpGetter = $parse(trackByExp);
      } else {
        trackByIdArrayFn = function(key, value) {
          return hashKey(value);
        };
        trackByIdObjFn = function(key) {
          return key;
        };
      }

      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

        if (trackByExpGetter) {
          trackByIdExpFn = function(key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }

        // Store a list of elements from previous run. This is a hash where key is the item from the
        // iterator, and the value is objects with following properties.
        //   - scope: bound scope
        //   - element: previous element.
        //   - index: position
        //
        // We are using no-proto object so that we don't need to guard against inherited props via
        // hasOwnProperty.
        var lastBlockMap = createMap();

        //watch props
        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
          var index, length,
              previousNode = $element[0],     // node that cloned nodes should be inserted after
                                              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key, value, // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,       // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;

          if (aliasAs) {
            $scope[aliasAs] = collection;
          }

          if (isArrayLike(collection)) {
            collectionKeys = collection;
            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
          } else {
            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
            // if object, extract keys, in enumeration order, unsorted
            collectionKeys = [];
            for (var itemKey in collection) {
              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                collectionKeys.push(itemKey);
              }
            }
          }

          collectionLength = collectionKeys.length;
          nextBlockOrder = new Array(collectionLength);

          // locate existing items
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            trackById = trackByIdFn(key, value, index);
            if (lastBlockMap[trackById]) {
              // found previously seen block
              block = lastBlockMap[trackById];
              delete lastBlockMap[trackById];
              nextBlockMap[trackById] = block;
              nextBlockOrder[index] = block;
            } else if (nextBlockMap[trackById]) {
              // if collision detected. restore lastBlockMap and throw an error
              forEach(nextBlockOrder, function(block) {
                if (block && block.scope) lastBlockMap[block.id] = block;
              });
              throw ngRepeatMinErr('dupes',
                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
                  expression, trackById, value);
            } else {
              // new never before seen block
              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
              nextBlockMap[trackById] = true;
            }
          }

          // remove leftover items
          for (var blockKey in lastBlockMap) {
            block = lastBlockMap[blockKey];
            elementsToRemove = getBlockNodes(block.clone);
            $animate.leave(elementsToRemove);
            if (elementsToRemove[0].parentNode) {
              // if the element was not removed yet because of pending animation, mark it as deleted
              // so that we can ignore it later
              for (index = 0, length = elementsToRemove.length; index < length; index++) {
                elementsToRemove[index][NG_REMOVED] = true;
              }
            }
            block.scope.$destroy();
          }

          // we are not using forEach for perf reasons (trying to avoid #call)
          for (index = 0; index < collectionLength; index++) {
            key = (collection === collectionKeys) ? index : collectionKeys[index];
            value = collection[key];
            block = nextBlockOrder[index];

            if (block.scope) {
              // if we have already seen this object, then we need to reuse the
              // associated scope/element

              nextNode = previousNode;

              // skip nodes that are already pending removal via leave animation
              do {
                nextNode = nextNode.nextSibling;
              } while (nextNode && nextNode[NG_REMOVED]);

              if (getBlockStart(block) !== nextNode) {
                // existing item which got moved
                $animate.move(getBlockNodes(block.clone), null, previousNode);
              }
              previousNode = getBlockEnd(block);
              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
            } else {
              // new item which we don't know about
              $transclude(function ngRepeatTransclude(clone, scope) {
                block.scope = scope;
                // http://jsperf.com/clone-vs-createcomment
                var endNode = ngRepeatEndComment.cloneNode(false);
                clone[clone.length++] = endNode;

                $animate.enter(clone, null, previousNode);
                previousNode = endNode;
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block.clone = clone;
                nextBlockMap[block.id] = block;
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              });
            }
          }
          lastBlockMap = nextBlockMap;
        });
      };
    }
  };
}];

var NG_HIDE_CLASS = 'ng-hide';
var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
/**
 * @ngdoc directive
 * @name ngShow
 * @multiElement
 *
 * @description
 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
 * the `ngShow` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is visible) -->
 * <div ng-show="myValue"></div>
 *
 * <!-- when $scope.myValue is falsy (element is hidden) -->
 * <div ng-show="myValue" class="ng-hide"></div>
 * ```
 *
 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override anything in CSS and the animations will work around the
 * display style.
 *
 * ## A note about animations with `ngShow`
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                        |
 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
 *
 * @element ANY
 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is shown/hidden respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element animate-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
    <file name="index.html">
      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
      <div class="check-element funky-show-hide" ng-show="checked">
        I show up when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngShow', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(false);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(true);
      });
    </file>
  </example>
 */
var ngShowDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
        // we're adding a temporary, animation-specific class for ng-hide since this way
        // we can control when the element is actually displayed on screen without having
        // to have a global/greedy CSS selector that breaks when other animations are run.
        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];


/**
 * @ngdoc directive
 * @name ngHide
 * @multiElement
 *
 * @description
 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
 * the `ngHide` attribute.
 *
 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
 * {@link ng.directive:ngCsp ngCsp}).
 *
 * ```html
 * <!-- when $scope.myValue is truthy (element is hidden) -->
 * <div ng-hide="myValue" class="ng-hide"></div>
 *
 * <!-- when $scope.myValue is falsy (element is visible) -->
 * <div ng-hide="myValue"></div>
 * ```
 *
 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
 * CSS class is removed from the element causing the element not to appear hidden.
 *
 * ## Why is `!important` used?
 *
 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
 * simple as changing the display style on a HTML list item would make hidden elements appear
 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
 *
 * By using `!important`, the show and hide behavior will work as expected despite any clash between
 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
 * developer chooses to override the styling to change how to hide an element then it is just a
 * matter of using `!important` in their own CSS code.
 *
 * ### Overriding `.ng-hide`
 *
 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
 *
 * ```css
 * .ng-hide:not(.ng-hide-animate) {
 *   /&#42; These are just alternative ways of hiding an element &#42;/
 *   display: block!important;
 *   position: absolute;
 *   top: -9999px;
 *   left: -9999px;
 * }
 * ```
 *
 * By default you don't need to override in CSS anything and the animations will work around the
 * display style.
 *
 * ## A note about animations with `ngHide`
 *
 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
 * directive expression is true and false. This system works like the animation system present with
 * `ngClass` except that you must also include the `!important` flag to override the display
 * property so that the elements are not actually hidden during the animation.
 *
 * ```css
 * /&#42; A working example can be found at the bottom of this page. &#42;/
 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
 *   transition: all 0.5s linear;
 * }
 *
 * .my-element.ng-hide-add { ... }
 * .my-element.ng-hide-add.ng-hide-add-active { ... }
 * .my-element.ng-hide-remove { ... }
 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
 * ```
 *
 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
 *
 * @animations
 * | Animation                                           | Occurs                                                                                                     |
 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
 *
 *
 * @element ANY
 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
 *                            element is hidden/shown respectively.
 *
 * @example
 * A simple example, animating the element's opacity:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element animate-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      .animate-show-hide.ng-hide {
        opacity: 0;
      }

      .animate-show-hide.ng-hide-add,
      .animate-show-hide.ng-hide-remove {
        transition: all linear 0.5s;
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 *
 * <hr />
 * @example
 * A more complex example, featuring different show/hide animations:
 *
  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
    <file name="index.html">
      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
      <div class="check-element funky-show-hide" ng-hide="checked">
        I hide when your checkbox is checked.
      </div>
    </file>
    <file name="animations.css">
      body {
        overflow: hidden;
        perspective: 1000px;
      }

      .funky-show-hide.ng-hide-add {
        transform: rotateZ(0);
        transform-origin: right;
        transition: all 0.5s ease-in-out;
      }

      .funky-show-hide.ng-hide-add.ng-hide-add-active {
        transform: rotateZ(-135deg);
      }

      .funky-show-hide.ng-hide-remove {
        transform: rotateY(90deg);
        transform-origin: left;
        transition: all 0.5s ease;
      }

      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
        transform: rotateY(0);
      }

      .check-element {
        border: 1px solid black;
        opacity: 1;
        padding: 10px;
      }
    </file>
    <file name="protractor.js" type="protractor">
      it('should check ngHide', function() {
        var checkbox = element(by.model('checked'));
        var checkElem = element(by.css('.check-element'));

        expect(checkElem.isDisplayed()).toBe(true);
        checkbox.click();
        expect(checkElem.isDisplayed()).toBe(false);
      });
    </file>
  </example>
 */
var ngHideDirective = ['$animate', function($animate) {
  return {
    restrict: 'A',
    multiElement: true,
    link: function(scope, element, attr) {
      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
        // The comment inside of the ngShowDirective explains why we add and
        // remove a temporary class for the show/hide animation
        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
        });
      });
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngStyle
 * @restrict AC
 *
 * @description
 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
 *
 * @knownIssue
 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
 * attribute, when using the `ngStyle` directive on the same element.
 * See {@link guide/interpolation#known-issues here} for more info.
 *
 * @element ANY
 * @param {expression} ngStyle
 *
 * {@link guide/expression Expression} which evals to an
 * object whose keys are CSS style names and values are corresponding values for those CSS
 * keys.
 *
 * Since some CSS style names are not valid keys for an object, they must be quoted.
 * See the 'background-color' style in the example below.
 *
 * @example
   <example name="ng-style">
     <file name="index.html">
        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
        <input type="button" value="clear" ng-click="myStyle={}">
        <br/>
        <span ng-style="myStyle">Sample Text</span>
        <pre>myStyle={{myStyle}}</pre>
     </file>
     <file name="style.css">
       span {
         color: black;
       }
     </file>
     <file name="protractor.js" type="protractor">
       var colorSpan = element(by.css('span'));

       it('should check ng-style', function() {
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         element(by.css('input[value=\'set color\']')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
         element(by.css('input[value=clear]')).click();
         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
       });
     </file>
   </example>
 */
var ngStyleDirective = ngDirective(function(scope, element, attr) {
  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
    if (oldStyles && (newStyles !== oldStyles)) {
      forEach(oldStyles, function(val, style) { element.css(style, '');});
    }
    if (newStyles) element.css(newStyles);
  }, true);
});

/**
 * @ngdoc directive
 * @name ngSwitch
 * @restrict EA
 *
 * @description
 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
 * as specified in the template.
 *
 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
 * matches the value obtained from the evaluated expression. In other words, you define a container element
 * (where you place the directive), place an expression on the **`on="..."` attribute**
 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
 * attribute is displayed.
 *
 * <div class="alert alert-info">
 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
 * as literal string values to match against.
 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
 * value of the expression `$scope.someVal`.
 * </div>

 * @animations
 * | Animation                        | Occurs                              |
 * |----------------------------------|-------------------------------------|
 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
 *
 * @usage
 *
 * ```
 * <ANY ng-switch="expression">
 *   <ANY ng-switch-when="matchValue1">...</ANY>
 *   <ANY ng-switch-when="matchValue2">...</ANY>
 *   <ANY ng-switch-default>...</ANY>
 * </ANY>
 * ```
 *
 *
 * @scope
 * @priority 1200
 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
 * On child elements add:
 *
 * * `ngSwitchWhen`: the case statement to match against. If match then this
 *   case will be displayed. If the same match appears multiple times, all the
 *   elements will be displayed. It is possible to associate multiple values to
 *   the same `ngSwitchWhen` by defining the optional attribute
 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
 *   if any of the `ngSwitch` evaluates to any of these tokens.
 * * `ngSwitchDefault`: the default case when no other case match. If there
 *   are multiple default cases, all of them will be displayed when no other
 *   case match.
 *
 *
 * @example
  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
    <file name="index.html">
      <div ng-controller="ExampleController">
        <select ng-model="selection" ng-options="item for item in items">
        </select>
        <code>selection={{selection}}</code>
        <hr/>
        <div class="animate-switch-container"
          ng-switch on="selection">
            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
            <div class="animate-switch" ng-switch-when="home">Home Span</div>
            <div class="animate-switch" ng-switch-default>default</div>
        </div>
      </div>
    </file>
    <file name="script.js">
      angular.module('switchExample', ['ngAnimate'])
        .controller('ExampleController', ['$scope', function($scope) {
          $scope.items = ['settings', 'home', 'options', 'other'];
          $scope.selection = $scope.items[0];
        }]);
    </file>
    <file name="animations.css">
      .animate-switch-container {
        position:relative;
        background:white;
        border:1px solid black;
        height:40px;
        overflow:hidden;
      }

      .animate-switch {
        padding:10px;
      }

      .animate-switch.ng-animate {
        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;

        position:absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
      }

      .animate-switch.ng-leave.ng-leave-active,
      .animate-switch.ng-enter {
        top:-50px;
      }
      .animate-switch.ng-leave,
      .animate-switch.ng-enter.ng-enter-active {
        top:0;
      }
    </file>
    <file name="protractor.js" type="protractor">
      var switchElem = element(by.css('[ng-switch]'));
      var select = element(by.model('selection'));

      it('should start in settings', function() {
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should change to home', function() {
        select.all(by.css('option')).get(1).click();
        expect(switchElem.getText()).toMatch(/Home Span/);
      });
      it('should change to settings via "options"', function() {
        select.all(by.css('option')).get(2).click();
        expect(switchElem.getText()).toMatch(/Settings Div/);
      });
      it('should select default', function() {
        select.all(by.css('option')).get(3).click();
        expect(switchElem.getText()).toMatch(/default/);
      });
    </file>
  </example>
 */
var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
  return {
    require: 'ngSwitch',

    // asks for $scope to fool the BC controller module
    controller: ['$scope', function NgSwitchController() {
     this.cases = {};
    }],
    link: function(scope, element, attr, ngSwitchController) {
      var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];

      var spliceFactory = function(array, index) {
          return function(response) {
            if (response !== false) array.splice(index, 1);
          };
      };

      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
        var i, ii;

        // Start with the last, in case the array is modified during the loop
        while (previousLeaveAnimations.length) {
          $animate.cancel(previousLeaveAnimations.pop());
        }

        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
          var selected = getBlockNodes(selectedElements[i].clone);
          selectedScopes[i].$destroy();
          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
          runner.done(spliceFactory(previousLeaveAnimations, i));
        }

        selectedElements.length = 0;
        selectedScopes.length = 0;

        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
          forEach(selectedTranscludes, function(selectedTransclude) {
            selectedTransclude.transclude(function(caseElement, selectedScope) {
              selectedScopes.push(selectedScope);
              var anchor = selectedTransclude.element;
              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
              var block = { clone: caseElement };

              selectedElements.push(block);
              $animate.enter(caseElement, anchor.parent(), anchor);
            });
          });
        }
      });
    }
  };
}];

var ngSwitchWhenDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attrs, ctrl, $transclude) {

    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function(element, index, array) { return array[index - 1] !== element; }
    );

    forEach(cases, function(whenCase) {
      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
    });
  }
});

var ngSwitchDefaultDirective = ngDirective({
  transclude: 'element',
  priority: 1200,
  require: '^ngSwitch',
  multiElement: true,
  link: function(scope, element, attr, ctrl, $transclude) {
    ctrl.cases['?'] = (ctrl.cases['?'] || []);
    ctrl.cases['?'].push({ transclude: $transclude, element: element });
   }
});

/**
 * @ngdoc directive
 * @name ngTransclude
 * @restrict EAC
 *
 * @description
 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
 *
 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
 *
 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
 * content of this element will be removed before the transcluded content is inserted.
 * If the transcluded content is empty, the existing content is left intact. This lets you provide fallback content in the case
 * that no transcluded content is provided.
 *
 * @element ANY
 *
 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
 *                                               or its value is the same as the name of the attribute then the default slot is used.
 *
 * @example
 * ### Basic transclusion
 * This example demonstrates basic transclusion of content into a component directive.
 * <example name="simpleTranscludeExample" module="transcludeExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('transcludeExample', [])
 *        .directive('pane', function(){
 *           return {
 *             restrict: 'E',
 *             transclude: true,
 *             scope: { title:'@' },
 *             template: '<div style="border: 1px solid black;">' +
 *                         '<div style="background-color: gray">{{title}}</div>' +
 *                         '<ng-transclude></ng-transclude>' +
 *                       '</div>'
 *           };
 *       })
 *       .controller('ExampleController', ['$scope', function($scope) {
 *         $scope.title = 'Lorem Ipsum';
 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *       }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <input ng-model="title" aria-label="title"> <br/>
 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *       <pane title="{{title}}">{{text}}</pane>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *      });
 *   </file>
 * </example>
 *
 * @example
 * ### Transclude fallback content
 * This example shows how to use `NgTransclude` with fallback content, that
 * is displayed if no transcluded content is provided.
 *
 * <example module="transcludeFallbackContentExample" name="ng-transclude">
 * <file name="index.html">
 * <script>
 * angular.module('transcludeFallbackContentExample', [])
 * .directive('myButton', function(){
 *             return {
 *               restrict: 'E',
 *               transclude: true,
 *               scope: true,
 *               template: '<button style="cursor: pointer;">' +
 *                           '<ng-transclude>' +
 *                             '<b style="color: red;">Button1</b>' +
 *                           '</ng-transclude>' +
 *                         '</button>'
 *             };
 *         });
 * </script>
 * <!-- fallback button content -->
 * <my-button id="fallback"></my-button>
 * <!-- modified button content -->
 * <my-button id="modified">
 *   <i style="color: green;">Button2</i>
 * </my-button>
 * </file>
 * <file name="protractor.js" type="protractor">
 * it('should have different transclude element content', function() {
 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
 *          expect(element(by.id('modified')).getText()).toBe('Button2');
 *        });
 * </file>
 * </example>
 *
 * @example
 * ### Multi-slot transclusion
 * This example demonstrates using multi-slot transclusion in a component directive.
 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
 *   <file name="index.html">
 *    <style>
 *      .title, .footer {
 *        background-color: gray
 *      }
 *    </style>
 *    <div ng-controller="ExampleController">
 *      <input ng-model="title" aria-label="title"> <br/>
 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
 *      <pane>
 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
 *        <pane-body><p>{{text}}</p></pane-body>
 *      </pane>
 *    </div>
 *   </file>
 *   <file name="app.js">
 *    angular.module('multiSlotTranscludeExample', [])
 *     .directive('pane', function() {
 *        return {
 *          restrict: 'E',
 *          transclude: {
 *            'title': '?paneTitle',
 *            'body': 'paneBody',
 *            'footer': '?paneFooter'
 *          },
 *          template: '<div style="border: 1px solid black;">' +
 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
 *                      '<div ng-transclude="body"></div>' +
 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
 *                    '</div>'
 *        };
 *    })
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.title = 'Lorem Ipsum';
 *      $scope.link = 'https://google.com';
 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
 *    }]);
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *      it('should have transcluded the title and the body', function() {
 *        var titleElement = element(by.model('title'));
 *        titleElement.clear();
 *        titleElement.sendKeys('TITLE');
 *        var textElement = element(by.model('text'));
 *        textElement.clear();
 *        textElement.sendKeys('TEXT');
 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
 *      });
 *   </file>
 * </example>
 */
var ngTranscludeMinErr = minErr('ngTransclude');
var ngTranscludeDirective = ['$compile', function($compile) {
  return {
    restrict: 'EAC',
    terminal: true,
    compile: function ngTranscludeCompile(tElement) {

      // Remove and cache any original content to act as a fallback
      var fallbackLinkFn = $compile(tElement.contents());
      tElement.empty();

      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

        if (!$transclude) {
          throw ngTranscludeMinErr('orphan',
          'Illegal use of ngTransclude directive in the template! ' +
          'No parent directive that requires a transclusion found. ' +
          'Element: {0}',
          startingTag($element));
        }


        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
          $attrs.ngTransclude = '';
        }
        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

        // If the slot is required and no transclusion content is provided then this call will throw an error
        $transclude(ngTranscludeCloneAttachFn, null, slotName);

        // If the slot is optional and no transclusion content is provided then use the fallback content
        if (slotName && !$transclude.isSlotFilled(slotName)) {
          useFallbackContent();
        }

        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
          if (clone.length) {
            $element.append(clone);
          } else {
            useFallbackContent();
            // There is nothing linked against the transcluded scope since no content was available,
            // so it should be safe to clean up the generated scope.
            transcludedScope.$destroy();
          }
        }

        function useFallbackContent() {
          // Since this is the fallback content rather than the transcluded content,
          // we link against the scope of this directive rather than the transcluded scope
          fallbackLinkFn($scope, function(clone) {
            $element.append(clone);
          });
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
 *
 * @param {string} type Must be set to `'text/ng-template'`.
 * @param {string} id Cache name of the template.
 *
 * @example
  <example  name="script-tag">
    <file name="index.html">
      <script type="text/ng-template" id="/tpl.html">
        Content of the template.
      </script>

      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
      <div id="tpl-content" ng-include src="currentTpl"></div>
    </file>
    <file name="protractor.js" type="protractor">
      it('should load template defined inside script tag', function() {
        element(by.css('#tpl-link')).click();
        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
      });
    </file>
  </example>
 */
var scriptDirective = ['$templateCache', function($templateCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function(element, attr) {
      if (attr.type === 'text/ng-template') {
        var templateUrl = attr.id,
            text = element[0].text;

        $templateCache.put(templateUrl, text);
      }
    }
  };
}];

/* exported selectDirective, optionDirective */

var noopNgModelController = { $setViewValue: noop, $render: noop };

function chromeHack(optionElement) {
  // Workaround for https://code.google.com/p/chromium/issues/detail?id=381459
  // Adding an <option selected="selected"> element to a <select required="required"> should
  // automatically select the new element
  if (optionElement[0].hasAttribute('selected')) {
    optionElement[0].selected = true;
  }
}

/**
 * @ngdoc type
 * @name  select.SelectController
 * @description
 * The controller for the `<select>` directive. This provides support for reading
 * and writing the selected value(s) of the control and also coordinates dynamically
 * added `<option>` elements, perhaps by an `ngRepeat` directive.
 */
var SelectController =
        ['$element', '$scope', /** @this */ function($element, $scope) {

  var self = this,
      optionsMap = new HashMap();

  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
  self.ngModelCtrl = noopNgModelController;

  // The "unknown" option is one that is prepended to the list if the viewValue
  // does not match any of the options. When it is rendered the value of the unknown
  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
  //
  // We can't just jqLite('<option>') since jqLite is not smart enough
  // to create it in <select> and IE barfs otherwise.
  self.unknownOption = jqLite(window.document.createElement('option'));
  self.renderUnknownOption = function(val) {
    var unknownVal = '? ' + hashKey(val) + ' ?';
    self.unknownOption.val(unknownVal);
    $element.prepend(self.unknownOption);
    $element.val(unknownVal);
  };

  $scope.$on('$destroy', function() {
    // disable unknown option so that we don't do work when the whole select is being destroyed
    self.renderUnknownOption = noop;
  });

  self.removeUnknownOption = function() {
    if (self.unknownOption.parent()) self.unknownOption.remove();
  };


  // Read the value of the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.readValue = function readSingleValue() {
    self.removeUnknownOption();
    return $element.val();
  };


  // Write the value to the select control, the implementation of this changes depending
  // upon whether the select can have multiple values and whether ngOptions is at work.
  self.writeValue = function writeSingleValue(value) {
    if (self.hasOption(value)) {
      self.removeUnknownOption();
      $element.val(value);
      if (value === '') self.emptyOption.prop('selected', true); // to make IE9 happy
    } else {
      if (value == null && self.emptyOption) {
        self.removeUnknownOption();
        $element.val('');
      } else {
        self.renderUnknownOption(value);
      }
    }
  };


  // Tell the select control that an option, with the given value, has been added
  self.addOption = function(value, element) {
    // Skip comment nodes, as they only pollute the `optionsMap`
    if (element[0].nodeType === NODE_TYPE_COMMENT) return;

    assertNotHasOwnProperty(value, '"option value"');
    if (value === '') {
      self.emptyOption = element;
    }
    var count = optionsMap.get(value) || 0;
    optionsMap.put(value, count + 1);
    self.ngModelCtrl.$render();
    chromeHack(element);
  };

  // Tell the select control that an option, with the given value, has been removed
  self.removeOption = function(value) {
    var count = optionsMap.get(value);
    if (count) {
      if (count === 1) {
        optionsMap.remove(value);
        if (value === '') {
          self.emptyOption = undefined;
        }
      } else {
        optionsMap.put(value, count - 1);
      }
    }
  };

  // Check whether the select control has an option matching the given value
  self.hasOption = function(value) {
    return !!optionsMap.get(value);
  };


  self.registerOption = function(optionScope, optionElement, optionAttrs, hasDynamicValueAttr, interpolateTextFn) {

    if (hasDynamicValueAttr) {
      // either "value" is interpolated directly, or set by ngValue
      var oldVal;
      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
        if (isDefined(oldVal)) {
          self.removeOption(oldVal);
        }
        oldVal = newVal;
        self.addOption(newVal, optionElement);
      });
    } else if (interpolateTextFn) {
      // The text content is interpolated
      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
        optionAttrs.$set('value', newVal);
        if (oldVal !== newVal) {
          self.removeOption(oldVal);
        }
        self.addOption(newVal, optionElement);
      });
    } else {
      // The value attribute is static
      self.addOption(optionAttrs.value, optionElement);
    }

    optionElement.on('$destroy', function() {
      self.removeOption(optionAttrs.value);
      self.ngModelCtrl.$render();
    });
  };
}];

/**
 * @ngdoc directive
 * @name select
 * @restrict E
 *
 * @description
 * HTML `SELECT` element with angular data-binding.
 *
 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
 * between the scope and the `<select>` control (including setting default values).
 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
 * {@link ngOptions `ngOptions`} directives.
 *
 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
 * to the model identified by the `ngModel` directive. With static or repeated options, this is
 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
 * For dynamic options, use interpolation inside the `value` attribute or the `textContent`. Using
 * {@link ngValue ngValue} is also possible (as it sets the `value` attribute), and will take
 * precedence over `value` and `textContent`.
 *
 * <div class="alert alert-warning">
 * Note that the value of a `select` directive used without `ngOptions` is always a string.
 * When the model needs to be bound to a non-string value, you must either explicitly convert it
 * using a directive (see example below) or use `ngOptions` to specify the set of options.
 * This is because an option element can only be bound to string values at present.
 * </div>
 *
 * If the viewValue of `ngModel` does not match any of the options, then the control
 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
 *
 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
 * option. See example below for demonstration.
 *
 * <div class="alert alert-info">
 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits, such as
 * more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
 * comprehension expression, and additionally in reducing memory and increasing speed by not creating
 * a new scope for each repeated instance.
 * </div>
 *
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
 *     bound to the model as an array.
 * @param {string=} required Sets `required` validation error key if the value is not entered.
 * @param {string=} ngRequired Adds required attribute and required validation constraint to
 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
 * when you want to data-bind to the required attribute.
 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
 *    interaction with the select element.
 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
 * set on the model on selection. See {@link ngOptions `ngOptions`}.
 *
 * @example
 * ### Simple `select` elements with static options
 *
 * <example name="static-select" module="staticSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="singleSelect"> Single select: </label><br>
 *     <select name="singleSelect" ng-model="data.singleSelect">
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *
 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
 *       <option value="option-2">Option 2</option>
 *     </select><br>
 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
 *     <tt>singleSelect = {{data.singleSelect}}</tt>
 *
 *     <hr>
 *     <label for="multipleSelect"> Multiple select: </label><br>
 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
 *       <option value="option-1">Option 1</option>
 *       <option value="option-2">Option 2</option>
 *       <option value="option-3">Option 3</option>
 *     </select><br>
 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
 *   </form>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('staticSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       singleSelect: null,
 *       multipleSelect: [],
 *       option1: 'option-1'
 *      };
 *
 *      $scope.forceUnknownOption = function() {
 *        $scope.data.singleSelect = 'nonsense';
 *      };
 *   }]);
 * </file>
 *</example>
 *
 * ### Using `ngRepeat` to generate `select` options
 * <example name="ngrepeat-select" module="ngrepeatSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="repeatSelect"> Repeat select: </label>
 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.repeatSelect">
 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
 *     </select>
 *   </form>
 *   <hr>
 *   <tt>repeatSelect = {{data.repeatSelect}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('ngrepeatSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       repeatSelect: null,
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ]
 *      };
 *   }]);
 * </file>
 *</example>
 *
 *
 * ### Using `select` with `ngOptions` and setting a default value
 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
 *
 * <example name="select-with-default-values" module="defaultValueSelect">
 * <file name="index.html">
 * <div ng-controller="ExampleController">
 *   <form name="myForm">
 *     <label for="mySelect">Make a choice:</label>
 *     <select name="mySelect" id="mySelect"
 *       ng-options="option.name for option in data.availableOptions track by option.id"
 *       ng-model="data.selectedOption"></select>
 *   </form>
 *   <hr>
 *   <tt>option = {{data.selectedOption}}</tt><br/>
 * </div>
 * </file>
 * <file name="app.js">
 *  angular.module('defaultValueSelect', [])
 *    .controller('ExampleController', ['$scope', function($scope) {
 *      $scope.data = {
 *       availableOptions: [
 *         {id: '1', name: 'Option A'},
 *         {id: '2', name: 'Option B'},
 *         {id: '3', name: 'Option C'}
 *       ],
 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
 *       };
 *   }]);
 * </file>
 *</example>
 *
 *
 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
 *
 * <example name="select-with-non-string-options" module="nonStringSelect">
 *   <file name="index.html">
 *     <select ng-model="model.id" convert-to-number>
 *       <option value="0">Zero</option>
 *       <option value="1">One</option>
 *       <option value="2">Two</option>
 *     </select>
 *     {{ model }}
 *   </file>
 *   <file name="app.js">
 *     angular.module('nonStringSelect', [])
 *       .run(function($rootScope) {
 *         $rootScope.model = { id: 2 };
 *       })
 *       .directive('convertToNumber', function() {
 *         return {
 *           require: 'ngModel',
 *           link: function(scope, element, attrs, ngModel) {
 *             ngModel.$parsers.push(function(val) {
 *               return parseInt(val, 10);
 *             });
 *             ngModel.$formatters.push(function(val) {
 *               return '' + val;
 *             });
 *           }
 *         };
 *       });
 *   </file>
 *   <file name="protractor.js" type="protractor">
 *     it('should initialize to model', function() {
 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
 *     });
 *   </file>
 * </example>
 *
 */
var selectDirective = function() {

  return {
    restrict: 'E',
    require: ['select', '?ngModel'],
    controller: SelectController,
    priority: 1,
    link: {
      pre: selectPreLink,
      post: selectPostLink
    }
  };

  function selectPreLink(scope, element, attr, ctrls) {

      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function() {
        scope.$apply(function() {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function(option) {
            if (option.selected) {
              array.push(option.value);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          var items = new HashMap(value);
          forEach(element.find('option'), function(option) {
            option.selected = isDefined(items.get(option.value));
          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView, lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function(value) {
          return !value || value.length === 0;
        };

      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function() {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
};


// The option directive is purely designed to communicate the existence (or lack of)
// of dynamically created (and destroyed) option elements to their containing select
// directive via its controller.
var optionDirective = ['$interpolate', function($interpolate) {
  return {
    restrict: 'E',
    priority: 100,
    compile: function(element, attr) {
      var hasDynamicValueAttr, interpolateTextFn;

      if (isDefined(attr.ngValue)) {
        // If ngValue is defined, then the value attr will be set to the result of the expression,
        // and the selectCtrl must set up an observer
        hasDynamicValueAttr = true;
      } else if (isDefined(attr.value)) {
        // If the value attr contains an interpolation, the selectCtrl must set up an observer
        hasDynamicValueAttr = $interpolate(attr.value, true);
      } else {
        // If the value attribute is not defined then we fall back to the
        // text content of the option element, which may be interpolated
        interpolateTextFn = $interpolate(element.text(), true);
        if (!interpolateTextFn) {
          attr.$set('value', element.text());
        }
      }

      return function(scope, element, attr) {
        // This is an optimization over using ^^ since we don't want to have to search
        // all the way to the root of the DOM for every single option element
        var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) ||
              parent.parent().data(selectCtrlName); // in case we are in optgroup

        if (selectCtrl) {
          selectCtrl.registerOption(scope, element, attr, hasDynamicValueAttr, interpolateTextFn);
        }
      };
    }
  };
}];

/**
 * @ngdoc directive
 * @name ngRequired
 * @restrict A
 *
 * @description
 *
 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
 * applied to custom controls.
 *
 * The directive sets the `required` attribute on the element if the Angular expression inside
 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
 * for more info.
 *
 * The validator will set the `required` error key to true if the `required` attribute is set and
 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
 *
 * @example
 * <example name="ngRequiredDirective" module="ngRequiredExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngRequiredExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.required = true;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="required">Toggle required: </label>
 *         <input type="checkbox" ng-model="required" id="required" />
 *         <br>
 *         <label for="input">This input must be filled if `required` is true: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
 *         <hr>
 *         required error set? = <code>{{form.input.$error.required}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var required = element(by.binding('form.input.$error.required'));
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should set the required error', function() {
         expect(required.getText()).toContain('true');

         input.sendKeys('123');
         expect(required.getText()).not.toContain('true');
         expect(model.getText()).toContain('123');
       });
 *   </file>
 * </example>
 */
var requiredDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;
      attr.required = true; // force truthy in case we are on non input element

      ctrl.$validators.required = function(modelValue, viewValue) {
        return !attr.required || !ctrl.$isEmpty(viewValue);
      };

      attr.$observe('required', function() {
        ctrl.$validate();
      });
    }
  };
};

/**
 * @ngdoc directive
 * @name ngPattern
 *
 * @description
 *
 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
 * `ngPattern` attribute value:
 * * If the expression evaluates to a RegExp object, then this is used directly.
 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
 *
 * <div class="alert alert-info">
 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
 * start at the index of the last search's match, thus not taking the whole input value into
 * account.
 * </div>
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
 *     not available.
 *   </li>
 *   <li>
 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngPatternDirective" module="ngPatternExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngPatternExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.regex = '\\d+';
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="regex">Set a pattern (regex string): </label>
 *         <input type="text" ng-model="regex" id="regex" />
 *         <br>
 *         <label for="input">This input is restricted by the current pattern: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default pattern', function() {
         input.sendKeys('aaa');
         expect(model.getText()).not.toContain('aaa');

         input.clear().then(function() {
           input.sendKeys('123');
           expect(model.getText()).toContain('123');
         });
       });
 *   </file>
 * </example>
 */
var patternDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var regexp, patternExp = attr.ngPattern || attr.pattern;
      attr.$observe('pattern', function(regex) {
        if (isString(regex) && regex.length > 0) {
          regex = new RegExp('^' + regex + '$');
        }

        if (regex && !regex.test) {
          throw minErr('ngPattern')('noregexp',
            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
            regex, startingTag(elm));
        }

        regexp = regex || undefined;
        ctrl.$validate();
      });

      ctrl.$validators.pattern = function(modelValue, viewValue) {
        // HTML5 pattern constraint validates the input value, so we validate the viewValue
        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMaxlength
 *
 * @description
 *
 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is longer than the integer obtained by evaluating the Angular expression given in the
 * `ngMaxlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMaxlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.maxlength = 5;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="maxlength">Set a maxlength: </label>
 *         <input type="number" ng-model="maxlength" id="maxlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current maxlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default maxlength', function() {
         input.sendKeys('abcdef');
         expect(model.getText()).not.toContain('abcdef');

         input.clear().then(function() {
           input.sendKeys('abcde');
           expect(model.getText()).toContain('abcde');
         });
       });
 *   </file>
 * </example>
 */
var maxlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var maxlength = -1;
      attr.$observe('maxlength', function(value) {
        var intVal = toInt(value);
        maxlength = isNumberNaN(intVal) ? -1 : intVal;
        ctrl.$validate();
      });
      ctrl.$validators.maxlength = function(modelValue, viewValue) {
        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
      };
    }
  };
};

/**
 * @ngdoc directive
 * @name ngMinlength
 *
 * @description
 *
 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
 *
 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
 * is shorter than the integer obtained by evaluating the Angular expression given in the
 * `ngMinlength` attribute value.
 *
 * <div class="alert alert-info">
 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
 * differences:
 * <ol>
 *   <li>
 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
 *     validation is not available.
 *   </li>
 *   <li>
 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
 *     interpolated.
 *   </li>
 * </ol>
 * </div>
 *
 * @example
 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
 *   <file name="index.html">
 *     <script>
 *       angular.module('ngMinlengthExample', [])
 *         .controller('ExampleController', ['$scope', function($scope) {
 *           $scope.minlength = 3;
 *         }]);
 *     </script>
 *     <div ng-controller="ExampleController">
 *       <form name="form">
 *         <label for="minlength">Set a minlength: </label>
 *         <input type="number" ng-model="minlength" id="minlength" />
 *         <br>
 *         <label for="input">This input is restricted by the current minlength: </label>
 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
 *         <hr>
 *         input valid? = <code>{{form.input.$valid}}</code><br>
 *         model = <code>{{model}}</code>
 *       </form>
 *     </div>
 *   </file>
 *   <file name="protractor.js" type="protractor">
       var model = element(by.binding('model'));
       var input = element(by.id('input'));

       it('should validate the input with the default minlength', function() {
         input.sendKeys('ab');
         expect(model.getText()).not.toContain('ab');

         input.sendKeys('abc');
         expect(model.getText()).toContain('abc');
       });
 *   </file>
 * </example>
 */
var minlengthDirective = function() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elm, attr, ctrl) {
      if (!ctrl) return;

      var minlength = 0;
      attr.$observe('minlength', function(value) {
        minlength = toInt(value) || 0;
        ctrl.$validate();
      });
      ctrl.$validators.minlength = function(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
      };
    }
  };
};

if (window.angular.bootstrap) {
  //AngularJS is already loaded, so we can return here...
  if (window.console) {
    console.log('WARNING: Tried to load angular more than once.');
  }
  return;
}

//try to bind to jquery now so that one can write jqLite(document).ready()
//but we will rebind on bootstrap again.
bindJQuery();

publishExternalAPI(angular);

angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
function getDecimals(n) {
  n = n + '';
  var i = n.indexOf('.');
  return (i == -1) ? 0 : n.length - i - 1;
}

function getVF(n, opt_precision) {
  var v = opt_precision;

  if (undefined === v) {
    v = Math.min(getDecimals(n), 3);
  }

  var base = Math.pow(10, v);
  var f = ((n * base) | 0) % base;
  return {v: v, f: f};
}

$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "ERANAMES": [
      "Before Christ",
      "Anno Domini"
    ],
    "ERAS": [
      "BC",
      "AD"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "SHORTDAY": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "SHORTMONTH": [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "STANDALONEMONTH": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, MMMM d, y",
    "longDate": "MMMM d, y",
    "medium": "MMM d, y h:mm:ss a",
    "mediumDate": "MMM d, y",
    "mediumTime": "h:mm:ss a",
    "short": "M/d/yy h:mm a",
    "shortDate": "M/d/yy",
    "shortTime": "h:mm a"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "$",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "en-us",
  "localeID": "en_US",
  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

  jqLite(window.document).ready(function() {
    angularInit(window.document, bootstrap);
  });

})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');
},{}],58:[function(require,module,exports){
/*! angularjs-slider - v5.9.0 - 
 (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervieu.me>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> - 
 https://github.com/angular-slider/angularjs-slider - 
 2016-12-12 */
/*jslint unparam: true */
/*global angular: false, console: false, define, module */
(function(root, factory) {
  'use strict';
  /* istanbul ignore next */
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['angular'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    // to support bundler like browserify
    var angularObj = angular || require('angular');
    if ((!angularObj || !angularObj.module) && typeof angular != 'undefined') {
      angularObj = angular;
    }
    module.exports = factory(angularObj);
  } else {
    // Browser globals (root is window)
    factory(root.angular);
  }

}(this, function(angular) {
  'use strict';
  var module = angular.module('rzModule', [])

  .factory('RzSliderOptions', function() {
    var defaultOptions = {
      floor: 0,
      ceil: null, //defaults to rz-slider-model
      step: 1,
      precision: 0,
      minRange: null,
      maxRange: null,
      pushRange: false,
      minLimit: null,
      maxLimit: null,
      id: null,
      translate: null,
      getLegend: null,
      stepsArray: null,
      bindIndexForStepsArray: false,
      draggableRange: false,
      draggableRangeOnly: false,
      showSelectionBar: false,
      showSelectionBarEnd: false,
      showSelectionBarFromValue: null,
      hidePointerLabels: false,
      hideLimitLabels: false,
      autoHideLimitLabels: true,
      readOnly: false,
      disabled: false,
      interval: 350,
      showTicks: false,
      showTicksValues: false,
      ticksArray: null,
      ticksTooltip: null,
      ticksValuesTooltip: null,
      vertical: false,
      getSelectionBarColor: null,
      getTickColor: null,
      getPointerColor: null,
      keyboardSupport: true,
      scale: 1,
      enforceStep: true,
      enforceRange: false,
      noSwitching: false,
      onlyBindHandles: false,
      onStart: null,
      onChange: null,
      onEnd: null,
      rightToLeft: false,
      boundPointerLabels: true,
      mergeRangeLabelsIfSame: false,
      customTemplateScope: null,
      logScale: false,
      customValueToPosition: null,
      customPositionToValue: null,
      selectionBarGradient: null
    };
    var globalOptions = {};

    var factory = {};
    /**
     * `options({})` allows global configuration of all sliders in the
     * application.
     *
     *   var app = angular.module( 'App', ['rzModule'], function( RzSliderOptions ) {
     *     // show ticks for all sliders
     *     RzSliderOptions.options( { showTicks: true } );
     *   });
     */
    factory.options = function(value) {
      angular.extend(globalOptions, value);
    };

    factory.getOptions = function(options) {
      return angular.extend({}, defaultOptions, globalOptions, options);
    };

    return factory;
  })

  .factory('rzThrottle', ['$timeout', function($timeout) {
    /**
     * rzThrottle
     *
     * Taken from underscore project
     *
     * @param {Function} func
     * @param {number} wait
     * @param {ThrottleOptions} options
     * @returns {Function}
     */
    return function(func, wait, options) {
      'use strict';
      /* istanbul ignore next */
      var getTime = (Date.now || function() {
        return new Date().getTime();
      });
      var context, args, result;
      var timeout = null;
      var previous = 0;
      options = options || {};
      var later = function() {
        previous = getTime();
        timeout = null;
        result = func.apply(context, args);
        context = args = null;
      };
      return function() {
        var now = getTime();
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
          $timeout.cancel(timeout);
          timeout = null;
          previous = now;
          result = func.apply(context, args);
          context = args = null;
        } else if (!timeout && options.trailing !== false) {
          timeout = $timeout(later, remaining);
        }
        return result;
      };
    }
  }])

  .factory('RzSlider', ['$timeout', '$document', '$window', '$compile', 'RzSliderOptions', 'rzThrottle', function($timeout, $document, $window, $compile, RzSliderOptions, rzThrottle) {
    'use strict';

    /**
     * Slider
     *
     * @param {ngScope} scope            The AngularJS scope
     * @param {Element} sliderElem The slider directive element wrapped in jqLite
     * @constructor
     */
    var Slider = function(scope, sliderElem) {
      /**
       * The slider's scope
       *
       * @type {ngScope}
       */
      this.scope = scope;

      /**
       * The slider inner low value (linked to rzSliderModel)
       * @type {number}
       */
      this.lowValue = 0;

      /**
       * The slider inner high value (linked to rzSliderHigh)
       * @type {number}
       */
      this.highValue = 0;

      /**
       * Slider element wrapped in jqLite
       *
       * @type {jqLite}
       */
      this.sliderElem = sliderElem;

      /**
       * Slider type
       *
       * @type {boolean} Set to true for range slider
       */
      this.range = this.scope.rzSliderModel !== undefined && this.scope.rzSliderHigh !== undefined;

      /**
       * Values recorded when first dragging the bar
       *
       * @type {Object}
       */
      this.dragging = {
        active: false,
        value: 0,
        difference: 0,
        position: 0,
        lowLimit: 0,
        highLimit: 0
      };

      /**
       * property that handle position (defaults to left for horizontal)
       * @type {string}
       */
      this.positionProperty = 'left';

      /**
       * property that handle dimension (defaults to width for horizontal)
       * @type {string}
       */
      this.dimensionProperty = 'width';

      /**
       * Half of the width or height of the slider handles
       *
       * @type {number}
       */
      this.handleHalfDim = 0;

      /**
       * Maximum position the slider handle can have
       *
       * @type {number}
       */
      this.maxPos = 0;

      /**
       * Precision
       *
       * @type {number}
       */
      this.precision = 0;

      /**
       * Step
       *
       * @type {number}
       */
      this.step = 1;

      /**
       * The name of the handle we are currently tracking
       *
       * @type {string}
       */
      this.tracking = '';

      /**
       * Minimum value (floor) of the model
       *
       * @type {number}
       */
      this.minValue = 0;

      /**
       * Maximum value (ceiling) of the model
       *
       * @type {number}
       */
      this.maxValue = 0;


      /**
       * The delta between min and max value
       *
       * @type {number}
       */
      this.valueRange = 0;


      /**
       * If showTicks/showTicksValues options are number.
       * In this case, ticks values should be displayed below the slider.
       * @type {boolean}
       */
      this.intermediateTicks = false;

      /**
       * Set to true if init method already executed
       *
       * @type {boolean}
       */
      this.initHasRun = false;

      /**
       * Used to call onStart on the first keydown event
       *
       * @type {boolean}
       */
      this.firstKeyDown = false;

      /**
       * Internal flag to prevent watchers to be called when the sliders value are modified internally.
       * @type {boolean}
       */
      this.internalChange = false;

      /**
       * Internal flag to keep track of the visibility of combo label
       * @type {boolean}
       */
      this.cmbLabelShown = false;

      /**
       * Internal variable to keep track of the focus element
       */
      this.currentFocusElement = null;

      // Slider DOM elements wrapped in jqLite
      this.fullBar = null; // The whole slider bar
      this.selBar = null; // Highlight between two handles
      this.minH = null; // Left slider handle
      this.maxH = null; // Right slider handle
      this.flrLab = null; // Floor label
      this.ceilLab = null; // Ceiling label
      this.minLab = null; // Label above the low value
      this.maxLab = null; // Label above the high value
      this.cmbLab = null; // Combined label
      this.ticks = null; // The ticks

      // Initialize slider
      this.init();
    };

    // Add instance methods
    Slider.prototype = {

      /**
       * Initialize slider
       *
       * @returns {undefined}
       */
      init: function() {
        var thrLow, thrHigh,
          self = this;

        var calcDimFn = function() {
          self.calcViewDimensions();
        };

        this.applyOptions();
        this.syncLowValue();
        if (this.range)
          this.syncHighValue();
        this.initElemHandles();
        this.manageElementsStyle();
        this.setDisabledState();
        this.calcViewDimensions();
        this.setMinAndMax();
        this.addAccessibility();
        this.updateCeilLab();
        this.updateFloorLab();
        this.initHandles();
        this.manageEventsBindings();

        // Recalculate slider view dimensions
        this.scope.$on('reCalcViewDimensions', calcDimFn);

        // Recalculate stuff if view port dimensions have changed
        angular.element($window).on('resize', calcDimFn);

        this.initHasRun = true;

        // Watch for changes to the model
        thrLow = rzThrottle(function() {
          self.onLowHandleChange();
        }, self.options.interval);

        thrHigh = rzThrottle(function() {
          self.onHighHandleChange();
        }, self.options.interval);

        this.scope.$on('rzSliderForceRender', function() {
          self.resetLabelsValue();
          thrLow();
          if (self.range) {
            thrHigh();
          }
          self.resetSlider();
        });

        // Watchers (order is important because in case of simultaneous change,
        // watchers will be called in the same order)
        this.scope.$watch('rzSliderOptions()', function(newValue, oldValue) {
          if (newValue === oldValue)
            return;
          self.applyOptions(); // need to be called before synchronizing the values
          self.syncLowValue();
          if (self.range)
            self.syncHighValue();
          self.resetSlider();
        }, true);

        this.scope.$watch('rzSliderModel', function(newValue, oldValue) {
          if (self.internalChange)
            return;
          if (newValue === oldValue)
            return;
          thrLow();
        });

        this.scope.$watch('rzSliderHigh', function(newValue, oldValue) {
          if (self.internalChange)
            return;
          if (newValue === oldValue)
            return;
          if (newValue != null)
            thrHigh();
          if (self.range && newValue == null || !self.range && newValue != null) {
            self.applyOptions();
            self.resetSlider();
          }
        });

        this.scope.$on('$destroy', function() {
          self.unbindEvents();
          angular.element($window).off('resize', calcDimFn);
          self.currentFocusElement = null;
        });
      },

      findStepIndex: function(modelValue) {
        var index = 0;
        for (var i = 0; i < this.options.stepsArray.length; i++) {
          var step = this.options.stepsArray[i];
          if (step === modelValue) {
            index = i;
            break;
          }
          else if (angular.isDate(step)) {
            if (step.getTime() === modelValue.getTime()) {
              index = i;
              break;
            }
          }
          else if (angular.isObject(step)) {
            if (angular.isDate(step.value) && step.value.getTime() === modelValue.getTime() || step.value === modelValue) {
              index = i;
              break;
            }
          }
        }
        return index;
      },

      syncLowValue: function() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray)
            this.lowValue = this.findStepIndex(this.scope.rzSliderModel);
          else
            this.lowValue = this.scope.rzSliderModel
        }
        else
          this.lowValue = this.scope.rzSliderModel;
      },

      syncHighValue: function() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray)
            this.highValue = this.findStepIndex(this.scope.rzSliderHigh);
          else
            this.highValue = this.scope.rzSliderHigh
        }
        else
          this.highValue = this.scope.rzSliderHigh;
      },

      getStepValue: function(sliderValue) {
        var step = this.options.stepsArray[sliderValue];
        if (angular.isDate(step))
          return step;
        if (angular.isObject(step))
          return step.value;
        return step;
      },

      applyLowValue: function() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray)
            this.scope.rzSliderModel = this.getStepValue(this.lowValue);
          else
            this.scope.rzSliderModel = this.lowValue
        }
        else
          this.scope.rzSliderModel = this.lowValue;
      },

      applyHighValue: function() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray)
            this.scope.rzSliderHigh = this.getStepValue(this.highValue);
          else
            this.scope.rzSliderHigh = this.highValue
        }
        else
          this.scope.rzSliderHigh = this.highValue;
      },

      /*
       * Reflow the slider when the low handle changes (called with throttle)
       */
      onLowHandleChange: function() {
        this.syncLowValue();
        if (this.range)
          this.syncHighValue();
        this.setMinAndMax();
        this.updateLowHandle(this.valueToPosition(this.lowValue));
        this.updateSelectionBar();
        this.updateTicksScale();
        this.updateAriaAttributes();
        if (this.range) {
          this.updateCmbLabel();
        }
      },

      /*
       * Reflow the slider when the high handle changes (called with throttle)
       */
      onHighHandleChange: function() {
        this.syncLowValue();
        this.syncHighValue();
        this.setMinAndMax();
        this.updateHighHandle(this.valueToPosition(this.highValue));
        this.updateSelectionBar();
        this.updateTicksScale();
        this.updateCmbLabel();
        this.updateAriaAttributes();
      },

      /**
       * Read the user options and apply them to the slider model
       */
      applyOptions: function() {
        var sliderOptions;
        if (this.scope.rzSliderOptions)
          sliderOptions = this.scope.rzSliderOptions();
        else
          sliderOptions = {};

        this.options = RzSliderOptions.getOptions(sliderOptions);

        if (this.options.step <= 0)
          this.options.step = 1;

        this.range = this.scope.rzSliderModel !== undefined && this.scope.rzSliderHigh !== undefined;
        this.options.draggableRange = this.range && this.options.draggableRange;
        this.options.draggableRangeOnly = this.range && this.options.draggableRangeOnly;
        if (this.options.draggableRangeOnly) {
          this.options.draggableRange = true;
        }

        this.options.showTicks = this.options.showTicks || this.options.showTicksValues || !!this.options.ticksArray;
        this.scope.showTicks = this.options.showTicks; //scope is used in the template
        if (angular.isNumber(this.options.showTicks) || this.options.ticksArray)
          this.intermediateTicks = true;

        this.options.showSelectionBar = this.options.showSelectionBar || this.options.showSelectionBarEnd
          || this.options.showSelectionBarFromValue !== null;

        if (this.options.stepsArray) {
          this.parseStepsArray();
        } else {
          if (this.options.translate)
            this.customTrFn = this.options.translate;
          else
            this.customTrFn = function(value) {
              return String(value);
            };

          this.getLegend = this.options.getLegend;
        }

        if (this.options.vertical) {
          this.positionProperty = 'bottom';
          this.dimensionProperty = 'height';
        }

        if (this.options.customTemplateScope)
          this.scope.custom = this.options.customTemplateScope;
      },

      parseStepsArray: function() {
        this.options.floor = 0;
        this.options.ceil = this.options.stepsArray.length - 1;
        this.options.step = 1;

        if (this.options.translate) {
          this.customTrFn = this.options.translate;
        }
        else {
          this.customTrFn = function(modelValue) {
            if (this.options.bindIndexForStepsArray)
              return this.getStepValue(modelValue);
            return modelValue;
          };
        }

        this.getLegend = function(index) {
          var step = this.options.stepsArray[index];
          if (angular.isObject(step))
            return step.legend;
          return null;
        };
      },

      /**
       * Resets slider
       *
       * @returns {undefined}
       */
      resetSlider: function() {
        this.manageElementsStyle();
        this.addAccessibility();
        this.setMinAndMax();
        this.updateCeilLab();
        this.updateFloorLab();
        this.unbindEvents();
        this.manageEventsBindings();
        this.setDisabledState();
        this.calcViewDimensions();
        this.refocusPointerIfNeeded();
      },

      refocusPointerIfNeeded: function() {
        if (this.currentFocusElement) {
          this.onPointerFocus(this.currentFocusElement.pointer, this.currentFocusElement.ref);
          this.focusElement(this.currentFocusElement.pointer)
        }
      },

      /**
       * Set the slider children to variables for easy access
       *
       * Run only once during initialization
       *
       * @returns {undefined}
       */
      initElemHandles: function() {
        // Assign all slider elements to object properties for easy access
        angular.forEach(this.sliderElem.children(), function(elem, index) {
          var jElem = angular.element(elem);

          switch (index) {
            case 0:
              this.fullBar = jElem;
              break;
            case 1:
              this.selBar = jElem;
              break;
            case 2:
              this.minH = jElem;
              break;
            case 3:
              this.maxH = jElem;
              break;
            case 4:
              this.flrLab = jElem;
              break;
            case 5:
              this.ceilLab = jElem;
              break;
            case 6:
              this.minLab = jElem;
              break;
            case 7:
              this.maxLab = jElem;
              break;
            case 8:
              this.cmbLab = jElem;
              break;
            case 9:
              this.ticks = jElem;
              break;
          }

        }, this);

        // Initialize position cache properties
        this.selBar.rzsp = 0;
        this.minH.rzsp = 0;
        this.maxH.rzsp = 0;
        this.flrLab.rzsp = 0;
        this.ceilLab.rzsp = 0;
        this.minLab.rzsp = 0;
        this.maxLab.rzsp = 0;
        this.cmbLab.rzsp = 0;
      },

      /**
       * Update each elements style based on options
       */
      manageElementsStyle: function() {

        if (!this.range)
          this.maxH.css('display', 'none');
        else
          this.maxH.css('display', '');


        this.alwaysHide(this.flrLab, this.options.showTicksValues || this.options.hideLimitLabels);
        this.alwaysHide(this.ceilLab, this.options.showTicksValues || this.options.hideLimitLabels);

        var hideLabelsForTicks = this.options.showTicksValues && !this.intermediateTicks;
        this.alwaysHide(this.minLab, hideLabelsForTicks || this.options.hidePointerLabels);
        this.alwaysHide(this.maxLab, hideLabelsForTicks || !this.range || this.options.hidePointerLabels);
        this.alwaysHide(this.cmbLab, hideLabelsForTicks || !this.range || this.options.hidePointerLabels);
        this.alwaysHide(this.selBar, !this.range && !this.options.showSelectionBar);

        if (this.options.vertical)
          this.sliderElem.addClass('rz-vertical');

        if (this.options.draggableRange)
          this.selBar.addClass('rz-draggable');
        else
          this.selBar.removeClass('rz-draggable');

        if (this.intermediateTicks && this.options.showTicksValues)
          this.ticks.addClass('rz-ticks-values-under');
      },

      alwaysHide: function(el, hide) {
        el.rzAlwaysHide = hide;
        if (hide)
          this.hideEl(el);
        else
          this.showEl(el)
      },

      /**
       * Manage the events bindings based on readOnly and disabled options
       *
       * @returns {undefined}
       */
      manageEventsBindings: function() {
        if (this.options.disabled || this.options.readOnly)
          this.unbindEvents();
        else
          this.bindEvents();
      },

      /**
       * Set the disabled state based on rzSliderDisabled
       *
       * @returns {undefined}
       */
      setDisabledState: function() {
        if (this.options.disabled) {
          this.sliderElem.attr('disabled', 'disabled');
        } else {
          this.sliderElem.attr('disabled', null);
        }
      },

      /**
       * Reset label values
       *
       * @return {undefined}
       */
      resetLabelsValue: function() {
        this.minLab.rzsv = undefined;
        this.maxLab.rzsv = undefined;
      },

      /**
       * Initialize slider handles positions and labels
       *
       * Run only once during initialization and every time view port changes size
       *
       * @returns {undefined}
       */
      initHandles: function() {
        this.updateLowHandle(this.valueToPosition(this.lowValue));

        /*
         the order here is important since the selection bar should be
         updated after the high handle but before the combined label
         */
        if (this.range)
          this.updateHighHandle(this.valueToPosition(this.highValue));
        this.updateSelectionBar();
        if (this.range)
          this.updateCmbLabel();

        this.updateTicksScale();
      },

      /**
       * Translate value to human readable format
       *
       * @param {number|string} value
       * @param {jqLite} label
       * @param {String} which
       * @param {boolean} [useCustomTr]
       * @returns {undefined}
       */
      translateFn: function(value, label, which, useCustomTr) {
        useCustomTr = useCustomTr === undefined ? true : useCustomTr;

        var valStr = '',
          getDimension = false,
          noLabelInjection = label.hasClass('no-label-injection');

        if (useCustomTr) {
          if (this.options.stepsArray && !this.options.bindIndexForStepsArray)
            value = this.getStepValue(value);
          valStr = String(this.customTrFn(value, this.options.id, which));
        }
        else {
          valStr = String(value)
        }

        if (label.rzsv === undefined || label.rzsv.length !== valStr.length || (label.rzsv.length > 0 && label.rzsd === 0)) {
          getDimension = true;
          label.rzsv = valStr;
        }

        if (!noLabelInjection) {
          label.html(valStr);
        }
        ;

        this.scope[which + 'Label'] = valStr;

        // Update width only when length of the label have changed
        if (getDimension) {
          this.getDimension(label);
        }
      },

      /**
       * Set maximum and minimum values for the slider and ensure the model and high
       * value match these limits
       * @returns {undefined}
       */
      setMinAndMax: function() {

        this.step = +this.options.step;
        this.precision = +this.options.precision;

        this.minValue = this.options.floor;
        if (this.options.logScale && this.minValue === 0)
          throw Error("Can't use floor=0 with logarithmic scale");

        if (this.options.enforceStep) {
          this.lowValue = this.roundStep(this.lowValue);
          if (this.range)
            this.highValue = this.roundStep(this.highValue);
        }

        if (this.options.ceil != null)
          this.maxValue = this.options.ceil;
        else
          this.maxValue = this.options.ceil = this.range ? this.highValue : this.lowValue;

        if (this.options.enforceRange) {
          this.lowValue = this.sanitizeValue(this.lowValue);
          if (this.range)
            this.highValue = this.sanitizeValue(this.highValue);
        }

        this.applyLowValue();
        if (this.range)
          this.applyHighValue();

        this.valueRange = this.maxValue - this.minValue;
      },

      /**
       * Adds accessibility attributes
       *
       * Run only once during initialization
       *
       * @returns {undefined}
       */
      addAccessibility: function() {
        this.minH.attr('role', 'slider');
        this.updateAriaAttributes();
        if (this.options.keyboardSupport && !(this.options.readOnly || this.options.disabled))
          this.minH.attr('tabindex', '0');
        else
          this.minH.attr('tabindex', '');
        if (this.options.vertical)
          this.minH.attr('aria-orientation', 'vertical');

        if (this.range) {
          this.maxH.attr('role', 'slider');
          if (this.options.keyboardSupport && !(this.options.readOnly || this.options.disabled))
            this.maxH.attr('tabindex', '0');
          else
            this.maxH.attr('tabindex', '');
          if (this.options.vertical)
            this.maxH.attr('aria-orientation', 'vertical');
        }
      },

      /**
       * Updates aria attributes according to current values
       */
      updateAriaAttributes: function() {
        this.minH.attr({
          'aria-valuenow': this.scope.rzSliderModel,
          'aria-valuetext': this.customTrFn(this.scope.rzSliderModel, this.options.id, 'model'),
          'aria-valuemin': this.minValue,
          'aria-valuemax': this.maxValue
        });
        if (this.range) {
          this.maxH.attr({
            'aria-valuenow': this.scope.rzSliderHigh,
            'aria-valuetext': this.customTrFn(this.scope.rzSliderHigh, this.options.id, 'high'),
            'aria-valuemin': this.minValue,
            'aria-valuemax': this.maxValue
          });
        }
      },

      /**
       * Calculate dimensions that are dependent on view port size
       *
       * Run once during initialization and every time view port changes size.
       *
       * @returns {undefined}
       */
      calcViewDimensions: function() {
        var handleWidth = this.getDimension(this.minH);

        this.handleHalfDim = handleWidth / 2;
        this.barDimension = this.getDimension(this.fullBar);

        this.maxPos = this.barDimension - handleWidth;

        this.getDimension(this.sliderElem);
        this.sliderElem.rzsp = this.sliderElem[0].getBoundingClientRect()[this.positionProperty];

        if (this.initHasRun) {
          this.updateFloorLab();
          this.updateCeilLab();
          this.initHandles();
          var self = this;
          $timeout(function() {
            self.updateTicksScale();
          });
        }
      },

      /**
       * Update the ticks position
       *
       * @returns {undefined}
       */
      updateTicksScale: function() {
        if (!this.options.showTicks) return;

        var ticksArray = this.options.ticksArray || this.getTicksArray(),
          translate = this.options.vertical ? 'translateY' : 'translateX',
          self = this;

        if (this.options.rightToLeft)
          ticksArray.reverse();

        this.scope.ticks = ticksArray.map(function(value) {
          var position = self.valueToPosition(value);

          if (self.options.vertical)
            position = self.maxPos - position;

          var tick = {
            selected: self.isTickSelected(value),
            style: {
              transform: translate + '(' + Math.round(position) + 'px)'
            }
          };
          if (tick.selected && self.options.getSelectionBarColor) {
            tick.style['background-color'] = self.getSelectionBarColor();
          }
          if (!tick.selected && self.options.getTickColor) {
            tick.style['background-color'] = self.getTickColor(value);
          }
          if (self.options.ticksTooltip) {
            tick.tooltip = self.options.ticksTooltip(value);
            tick.tooltipPlacement = self.options.vertical ? 'right' : 'top';
          }
          if (self.options.showTicksValues) {
            tick.value = self.getDisplayValue(value, 'tick-value');
            if (self.options.ticksValuesTooltip) {
              tick.valueTooltip = self.options.ticksValuesTooltip(value);
              tick.valueTooltipPlacement = self.options.vertical ? 'right' : 'top';
            }
          }
          if (self.getLegend) {
            var legend = self.getLegend(value, self.options.id);
            if (legend)
              tick.legend = legend;
          }
          return tick;
        });
      },

      getTicksArray: function() {
        var step = this.step,
          ticksArray = [];
        if (this.intermediateTicks)
          step = this.options.showTicks;
        for (var value = this.minValue; value <= this.maxValue; value += step) {
          ticksArray.push(value);
        }
        return ticksArray;
      },

      isTickSelected: function(value) {
        if (!this.range) {
          if (this.options.showSelectionBarFromValue !== null) {
            var center = this.options.showSelectionBarFromValue;
            if (this.lowValue > center && value >= center && value <= this.lowValue)
              return true;
            else if (this.lowValue < center && value <= center && value >= this.lowValue)
              return true;
          }
          else if (this.options.showSelectionBarEnd) {
            if (value >= this.lowValue)
              return true;
          }
          else if (this.options.showSelectionBar && value <= this.lowValue)
            return true;
        }
        if (this.range && value >= this.lowValue && value <= this.highValue)
          return true;
        return false;
      },

      /**
       * Update position of the floor label
       *
       * @returns {undefined}
       */
      updateFloorLab: function() {
        this.translateFn(this.minValue, this.flrLab, 'floor');
        this.getDimension(this.flrLab);
        var position = this.options.rightToLeft ? this.barDimension - this.flrLab.rzsd : 0;
        this.setPosition(this.flrLab, position);
      },

      /**
       * Update position of the ceiling label
       *
       * @returns {undefined}
       */
      updateCeilLab: function() {
        this.translateFn(this.maxValue, this.ceilLab, 'ceil');
        this.getDimension(this.ceilLab);
        var position = this.options.rightToLeft ? 0 : this.barDimension - this.ceilLab.rzsd;
        this.setPosition(this.ceilLab, position);
      },

      /**
       * Update slider handles and label positions
       *
       * @param {string} which
       * @param {number} newPos
       */
      updateHandles: function(which, newPos) {
        if (which === 'lowValue')
          this.updateLowHandle(newPos);
        else
          this.updateHighHandle(newPos);

        this.updateSelectionBar();
        this.updateTicksScale();
        if (this.range)
          this.updateCmbLabel();
      },

      /**
       * Helper function to work out the position for handle labels depending on RTL or not
       *
       * @param {string} labelName maxLab or minLab
       * @param newPos
       *
       * @returns {number}
       */
      getHandleLabelPos: function(labelName, newPos) {
        var labelRzsd = this[labelName].rzsd,
          nearHandlePos = newPos - labelRzsd / 2 + this.handleHalfDim,
          endOfBarPos = this.barDimension - labelRzsd;

        if (!this.options.boundPointerLabels)
          return nearHandlePos;

        if (this.options.rightToLeft && labelName === 'minLab' || !this.options.rightToLeft && labelName === 'maxLab') {
          return Math.min(nearHandlePos, endOfBarPos);
        } else {
          return Math.min(Math.max(nearHandlePos, 0), endOfBarPos);
        }
      },

      /**
       * Update low slider handle position and label
       *
       * @param {number} newPos
       * @returns {undefined}
       */
      updateLowHandle: function(newPos) {
        this.setPosition(this.minH, newPos);
        this.translateFn(this.lowValue, this.minLab, 'model');
        this.setPosition(this.minLab, this.getHandleLabelPos('minLab', newPos));

        if (this.options.getPointerColor) {
          var pointercolor = this.getPointerColor('min');
          this.scope.minPointerStyle = {
            backgroundColor: pointercolor
          };
        }

        if (this.options.autoHideLimitLabels) {
          this.shFloorCeil();
        }
      },

      /**
       * Update high slider handle position and label
       *
       * @param {number} newPos
       * @returns {undefined}
       */
      updateHighHandle: function(newPos) {
        this.setPosition(this.maxH, newPos);
        this.translateFn(this.highValue, this.maxLab, 'high');
        this.setPosition(this.maxLab, this.getHandleLabelPos('maxLab', newPos));

        if (this.options.getPointerColor) {
          var pointercolor = this.getPointerColor('max');
          this.scope.maxPointerStyle = {
            backgroundColor: pointercolor
          };
        }
        if (this.options.autoHideLimitLabels) {
          this.shFloorCeil();
        }

      },

      /**
       * Show/hide floor/ceiling label
       *
       * @returns {undefined}
       */
      shFloorCeil: function() {
        // Show based only on hideLimitLabels if pointer labels are hidden
        if (this.options.hidePointerLabels) {
          return;
        }
        var flHidden = false,
          clHidden = false,
          isMinLabAtFloor = this.isLabelBelowFloorLab(this.minLab),
          isMinLabAtCeil = this.isLabelAboveCeilLab(this.minLab),
          isMaxLabAtCeil = this.isLabelAboveCeilLab(this.maxLab),
          isCmbLabAtFloor = this.isLabelBelowFloorLab(this.cmbLab),
          isCmbLabAtCeil =  this.isLabelAboveCeilLab(this.cmbLab);

        if (isMinLabAtFloor) {
          flHidden = true;
          this.hideEl(this.flrLab);
        } else {
          flHidden = false;
          this.showEl(this.flrLab);
        }

        if (isMinLabAtCeil) {
          clHidden = true;
          this.hideEl(this.ceilLab);
        } else {
          clHidden = false;
          this.showEl(this.ceilLab);
        }

        if (this.range) {
          var hideCeil = this.cmbLabelShown ? isCmbLabAtCeil : isMaxLabAtCeil;
          var hideFloor = this.cmbLabelShown ? isCmbLabAtFloor : isMinLabAtFloor;

          if (hideCeil) {
            this.hideEl(this.ceilLab);
          } else if (!clHidden) {
            this.showEl(this.ceilLab);
          }

          // Hide or show floor label
          if (hideFloor) {
            this.hideEl(this.flrLab);
          } else if (!flHidden) {
            this.showEl(this.flrLab);
          }
        }
      },

      isLabelBelowFloorLab: function(label) {
        var isRTL = this.options.rightToLeft,
          pos = label.rzsp,
          dim = label.rzsd,
          floorPos = this.flrLab.rzsp,
          floorDim = this.flrLab.rzsd;
        return isRTL ?
        pos + dim >= floorPos - 2 :
        pos <= floorPos + floorDim + 2;
      },

      isLabelAboveCeilLab: function(label) {
        var isRTL = this.options.rightToLeft,
          pos = label.rzsp,
          dim = label.rzsd,
          ceilPos = this.ceilLab.rzsp,
          ceilDim = this.ceilLab.rzsd;
        return isRTL ?
        pos <= ceilPos + ceilDim + 2 :
        pos + dim >= ceilPos - 2;
      },

      /**
       * Update slider selection bar, combined label and range label
       *
       * @returns {undefined}
       */
      updateSelectionBar: function() {
        var position = 0,
          dimension = 0,
          isSelectionBarFromRight = this.options.rightToLeft ? !this.options.showSelectionBarEnd : this.options.showSelectionBarEnd,
          positionForRange = this.options.rightToLeft ? this.maxH.rzsp + this.handleHalfDim : this.minH.rzsp + this.handleHalfDim;

        if (this.range) {
          dimension = Math.abs(this.maxH.rzsp - this.minH.rzsp);
          position = positionForRange;
        }
        else {
          if (this.options.showSelectionBarFromValue !== null) {
            var center = this.options.showSelectionBarFromValue,
              centerPosition = this.valueToPosition(center),
              isModelGreaterThanCenter = this.options.rightToLeft ? this.lowValue <= center : this.lowValue > center;
            if (isModelGreaterThanCenter) {
              dimension = this.minH.rzsp - centerPosition;
              position = centerPosition + this.handleHalfDim;
            }
            else {
              dimension = centerPosition - this.minH.rzsp;
              position = this.minH.rzsp + this.handleHalfDim;
            }
          }
          else if (isSelectionBarFromRight) {
            dimension = Math.abs(this.maxPos - this.minH.rzsp) + this.handleHalfDim;
            position = this.minH.rzsp + this.handleHalfDim;
          } else {
            dimension = Math.abs(this.maxH.rzsp - this.minH.rzsp) + this.handleHalfDim;
            position = 0;
          }
        }
        this.setDimension(this.selBar, dimension);
        this.setPosition(this.selBar, position);
        if (this.options.getSelectionBarColor) {
          var color = this.getSelectionBarColor();
          this.scope.barStyle = {
            backgroundColor: color
          };
        } else if (this.options.selectionBarGradient) {
          var offset = this.options.showSelectionBarFromValue !== null ? this.valueToPosition(this.options.showSelectionBarFromValue) : 0,
            reversed = offset - position > 0 ^ isSelectionBarFromRight,
            direction = this.options.vertical ? (reversed ? 'bottom' : 'top') : (reversed ? 'left' : 'right');
          this.scope.barStyle = {
            backgroundImage: 'linear-gradient(to ' + direction + ', ' + this.options.selectionBarGradient.from + ' 0%,' + this.options.selectionBarGradient.to + ' 100%)'
          };
          if (this.options.vertical) {
            this.scope.barStyle.backgroundPosition = 'center ' + (offset + dimension + position + (reversed ? -this.handleHalfDim : 0)) + 'px';
            this.scope.barStyle.backgroundSize = '100% ' + (this.barDimension - this.handleHalfDim) + 'px';
          } else {
            this.scope.barStyle.backgroundPosition = (offset - position + (reversed ? this.handleHalfDim : 0)) + 'px center';
            this.scope.barStyle.backgroundSize = (this.barDimension - this.handleHalfDim) + 'px 100%';
          }
        }
      },

      /**
       * Wrapper around the getSelectionBarColor of the user to pass to
       * correct parameters
       */
      getSelectionBarColor: function() {
        if (this.range)
          return this.options.getSelectionBarColor(this.scope.rzSliderModel, this.scope.rzSliderHigh);
        return this.options.getSelectionBarColor(this.scope.rzSliderModel);
      },

      /**
       * Wrapper around the getPointerColor of the user to pass to
       * correct parameters
       */
      getPointerColor: function(pointerType) {
        if (pointerType === 'max') {
          return this.options.getPointerColor(this.scope.rzSliderHigh, pointerType);
        }
        return this.options.getPointerColor(this.scope.rzSliderModel, pointerType);
      },

      /**
       * Wrapper around the getTickColor of the user to pass to
       * correct parameters
       */
      getTickColor: function(value) {
        return this.options.getTickColor(value);
      },

      /**
       * Update combined label position and value
       *
       * @returns {undefined}
       */
      updateCmbLabel: function() {
        var isLabelOverlap = null;
        if (this.options.rightToLeft) {
          isLabelOverlap = this.minLab.rzsp - this.minLab.rzsd - 10 <= this.maxLab.rzsp;
        } else {
          isLabelOverlap = this.minLab.rzsp + this.minLab.rzsd + 10 >= this.maxLab.rzsp;
        }

        if (isLabelOverlap) {
          var lowTr = this.getDisplayValue(this.lowValue, 'model'),
            highTr = this.getDisplayValue(this.highValue, 'high'),
            labelVal = '';
          if (this.options.mergeRangeLabelsIfSame && lowTr === highTr) {
            labelVal = lowTr;
          } else {
            labelVal = this.options.rightToLeft ? highTr + ' - ' + lowTr : lowTr + ' - ' + highTr;
          }

          this.translateFn(labelVal, this.cmbLab, 'cmb', false);
          var pos = this.options.boundPointerLabels ? Math.min(
            Math.max(
              this.selBar.rzsp + this.selBar.rzsd / 2 - this.cmbLab.rzsd / 2,
              0
            ),
            this.barDimension - this.cmbLab.rzsd
          ) : this.selBar.rzsp + this.selBar.rzsd / 2 - this.cmbLab.rzsd / 2;

          this.setPosition(this.cmbLab, pos);
          this.cmbLabelShown = true;
          this.hideEl(this.minLab);
          this.hideEl(this.maxLab);
          this.showEl(this.cmbLab);
        } else {
          this.cmbLabelShown = false;
          this.showEl(this.maxLab);
          this.showEl(this.minLab);
          this.hideEl(this.cmbLab);
        }
        if (this.options.autoHideLimitLabels) {
          this.shFloorCeil();
        }
      },

      /**
       * Return the translated value if a translate function is provided else the original value
       * @param value
       * @param which if it's min or max handle
       * @returns {*}
       */
      getDisplayValue: function(value, which) {
        if (this.options.stepsArray && !this.options.bindIndexForStepsArray) {
          value = this.getStepValue(value);
        }
        return this.customTrFn(value, this.options.id, which);
      },

      /**
       * Round value to step and precision based on minValue
       *
       * @param {number} value
       * @param {number} customStep a custom step to override the defined step
       * @returns {number}
       */
      roundStep: function(value, customStep) {
        var step = customStep ? customStep : this.step,
          steppedDifference = parseFloat((value - this.minValue) / step).toPrecision(12);
        steppedDifference = Math.round(+steppedDifference) * step;
        var newValue = (this.minValue + steppedDifference).toFixed(this.precision);
        return +newValue;
      },

      /**
       * Hide element
       *
       * @param element
       * @returns {jqLite} The jqLite wrapped DOM element
       */
      hideEl: function(element) {
        return element.css({
          visibility: 'hidden'
        });
      },

      /**
       * Show element
       *
       * @param element The jqLite wrapped DOM element
       * @returns {jqLite} The jqLite
       */
      showEl: function(element) {
        if (!!element.rzAlwaysHide) {
          return element;
        }

        return element.css({
          visibility: 'visible'
        });
      },

      /**
       * Set element left/top position depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem The jqLite wrapped DOM element
       * @param {number} pos
       * @returns {number}
       */
      setPosition: function(elem, pos) {
        elem.rzsp = pos;
        var css = {};
        css[this.positionProperty] = Math.round(pos) + 'px';
        elem.css(css);
        return pos;
      },

      /**
       * Get element width/height depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem The jqLite wrapped DOM element
       * @returns {number}
       */
      getDimension: function(elem) {
        var val = elem[0].getBoundingClientRect();
        if (this.options.vertical)
          elem.rzsd = (val.bottom - val.top) * this.options.scale;
        else
          elem.rzsd = (val.right - val.left) * this.options.scale;
        return elem.rzsd;
      },

      /**
       * Set element width/height depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem  The jqLite wrapped DOM element
       * @param {number} dim
       * @returns {number}
       */
      setDimension: function(elem, dim) {
        elem.rzsd = dim;
        var css = {};
        css[this.dimensionProperty] = Math.round(dim) + 'px';
        elem.css(css);
        return dim;
      },

      /**
       * Returns a value that is within slider range
       *
       * @param {number} val
       * @returns {number}
       */
      sanitizeValue: function(val) {
        return Math.min(Math.max(val, this.minValue), this.maxValue);
      },

      /**
       * Translate value to pixel position
       *
       * @param {number} val
       * @returns {number}
       */
      valueToPosition: function(val) {
        var fn = this.linearValueToPosition;
        if (this.options.customValueToPosition)
          fn = this.options.customValueToPosition;
        else if (this.options.logScale)
          fn = this.logValueToPosition;

        val = this.sanitizeValue(val);
        var percent = fn(val, this.minValue, this.maxValue) || 0;
        if (this.options.rightToLeft)
          percent = 1 - percent;
        return percent * this.maxPos;
      },

      linearValueToPosition: function(val, minVal, maxVal) {
        var range = maxVal - minVal;
        return (val - minVal) / range;
      },

      logValueToPosition: function(val, minVal, maxVal) {
        val = Math.log(val);
        minVal = Math.log(minVal);
        maxVal = Math.log(maxVal);
        var range = maxVal - minVal;
        return (val - minVal) / range;
      },

      /**
       * Translate position to model value
       *
       * @param {number} position
       * @returns {number}
       */
      positionToValue: function(position) {
        var percent = position / this.maxPos;
        if (this.options.rightToLeft)
          percent = 1 - percent;
        var fn = this.linearPositionToValue;
        if (this.options.customPositionToValue)
          fn = this.options.customPositionToValue;
        else if (this.options.logScale)
          fn = this.logPositionToValue;
        return fn(percent, this.minValue, this.maxValue) || 0;
      },

      linearPositionToValue: function(percent, minVal, maxVal) {
        return percent * (maxVal - minVal) + minVal;
      },

      logPositionToValue: function(percent, minVal, maxVal) {
        minVal = Math.log(minVal);
        maxVal = Math.log(maxVal);
        var value = percent * (maxVal - minVal) + minVal;
        return Math.exp(value);
      },

      // Events
      /**
       * Get the X-coordinate or Y-coordinate of an event
       *
       * @param {Object} event  The event
       * @returns {number}
       */
      getEventXY: function(event) {
        /* http://stackoverflow.com/a/12336075/282882 */
        //noinspection JSLint
        var clientXY = this.options.vertical ? 'clientY' : 'clientX';
        if (event[clientXY] !== undefined) {
          return event[clientXY];
        }

        return event.originalEvent === undefined ?
          event.touches[0][clientXY] : event.originalEvent.touches[0][clientXY];
      },

      /**
       * Compute the event position depending on whether the slider is horizontal or vertical
       * @param event
       * @returns {number}
       */
      getEventPosition: function(event) {
        var sliderPos = this.sliderElem.rzsp,
          eventPos = 0;
        if (this.options.vertical)
          eventPos = -this.getEventXY(event) + sliderPos;
        else
          eventPos = this.getEventXY(event) - sliderPos;
        return eventPos * this.options.scale - this.handleHalfDim; // #346 handleHalfDim is already scaled
      },

      /**
       * Get event names for move and event end
       *
       * @param {Event}    event    The event
       *
       * @return {{moveEvent: string, endEvent: string}}
       */
      getEventNames: function(event) {
        var eventNames = {
          moveEvent: '',
          endEvent: ''
        };

        if (event.touches || (event.originalEvent !== undefined && event.originalEvent.touches)) {
          eventNames.moveEvent = 'touchmove';
          eventNames.endEvent = 'touchend';
        } else {
          eventNames.moveEvent = 'mousemove';
          eventNames.endEvent = 'mouseup';
        }

        return eventNames;
      },

      /**
       * Get the handle closest to an event.
       *
       * @param event {Event} The event
       * @returns {jqLite} The handle closest to the event.
       */
      getNearestHandle: function(event) {
        if (!this.range) {
          return this.minH;
        }
        var position = this.getEventPosition(event),
          distanceMin = Math.abs(position - this.minH.rzsp),
          distanceMax = Math.abs(position - this.maxH.rzsp);
        if (distanceMin < distanceMax)
          return this.minH;
        else if (distanceMin > distanceMax)
          return this.maxH;
        else if (!this.options.rightToLeft)
        //if event is at the same distance from min/max then if it's at left of minH, we return minH else maxH
          return position < this.minH.rzsp ? this.minH : this.maxH;
        else
        //reverse in rtl
          return position > this.minH.rzsp ? this.minH : this.maxH;
      },

      /**
       * Wrapper function to focus an angular element
       *
       * @param el {AngularElement} the element to focus
       */
      focusElement: function(el) {
        var DOM_ELEMENT = 0;
        el[DOM_ELEMENT].focus();
      },

      /**
       * Bind mouse and touch events to slider handles
       *
       * @returns {undefined}
       */
      bindEvents: function() {
        var barTracking, barStart, barMove;

        if (this.options.draggableRange) {
          barTracking = 'rzSliderDrag';
          barStart = this.onDragStart;
          barMove = this.onDragMove;
        } else {
          barTracking = 'lowValue';
          barStart = this.onStart;
          barMove = this.onMove;
        }

        if (!this.options.onlyBindHandles) {
          this.selBar.on('mousedown', angular.bind(this, barStart, null, barTracking));
          this.selBar.on('mousedown', angular.bind(this, barMove, this.selBar));
        }

        if (this.options.draggableRangeOnly) {
          this.minH.on('mousedown', angular.bind(this, barStart, null, barTracking));
          this.maxH.on('mousedown', angular.bind(this, barStart, null, barTracking));
        } else {
          this.minH.on('mousedown', angular.bind(this, this.onStart, this.minH, 'lowValue'));
          if (this.range) {
            this.maxH.on('mousedown', angular.bind(this, this.onStart, this.maxH, 'highValue'));
          }
          if (!this.options.onlyBindHandles) {
            this.fullBar.on('mousedown', angular.bind(this, this.onStart, null, null));
            this.fullBar.on('mousedown', angular.bind(this, this.onMove, this.fullBar));
            this.ticks.on('mousedown', angular.bind(this, this.onStart, null, null));
            this.ticks.on('mousedown', angular.bind(this, this.onTickClick, this.ticks));
          }
        }

        if (!this.options.onlyBindHandles) {
          this.selBar.on('touchstart', angular.bind(this, barStart, null, barTracking));
          this.selBar.on('touchstart', angular.bind(this, barMove, this.selBar));
        }
        if (this.options.draggableRangeOnly) {
          this.minH.on('touchstart', angular.bind(this, barStart, null, barTracking));
          this.maxH.on('touchstart', angular.bind(this, barStart, null, barTracking));
        } else {
          this.minH.on('touchstart', angular.bind(this, this.onStart, this.minH, 'lowValue'));
          if (this.range) {
            this.maxH.on('touchstart', angular.bind(this, this.onStart, this.maxH, 'highValue'));
          }
          if (!this.options.onlyBindHandles) {
            this.fullBar.on('touchstart', angular.bind(this, this.onStart, null, null));
            this.fullBar.on('touchstart', angular.bind(this, this.onMove, this.fullBar));
            this.ticks.on('touchstart', angular.bind(this, this.onStart, null, null));
            this.ticks.on('touchstart', angular.bind(this, this.onTickClick, this.ticks));
          }
        }

        if (this.options.keyboardSupport) {
          this.minH.on('focus', angular.bind(this, this.onPointerFocus, this.minH, 'lowValue'));
          if (this.range) {
            this.maxH.on('focus', angular.bind(this, this.onPointerFocus, this.maxH, 'highValue'));
          }
        }
      },

      /**
       * Unbind mouse and touch events to slider handles
       *
       * @returns {undefined}
       */
      unbindEvents: function() {
        this.minH.off();
        this.maxH.off();
        this.fullBar.off();
        this.selBar.off();
        this.ticks.off();
      },

      /**
       * onStart event handler
       *
       * @param {?Object} pointer The jqLite wrapped DOM element; if null, the closest handle is used
       * @param {?string} ref     The name of the handle being changed; if null, the closest handle's value is modified
       * @param {Event}   event   The event
       * @returns {undefined}
       */
      onStart: function(pointer, ref, event) {
        var ehMove, ehEnd,
          eventNames = this.getEventNames(event);

        event.stopPropagation();
        event.preventDefault();

        // We have to do this in case the HTML where the sliders are on
        // have been animated into view.
        this.calcViewDimensions();

        if (pointer) {
          this.tracking = ref;
        } else {
          pointer = this.getNearestHandle(event);
          this.tracking = pointer === this.minH ? 'lowValue' : 'highValue';
        }

        pointer.addClass('rz-active');

        if (this.options.keyboardSupport)
          this.focusElement(pointer);

        ehMove = angular.bind(this, this.dragging.active ? this.onDragMove : this.onMove, pointer);
        ehEnd = angular.bind(this, this.onEnd, ehMove);

        $document.on(eventNames.moveEvent, ehMove);
        $document.one(eventNames.endEvent, ehEnd);
        this.callOnStart();
      },

      /**
       * onMove event handler
       *
       * @param {jqLite} pointer
       * @param {Event}  event The event
       * @param {boolean}  fromTick if the event occured on a tick or not
       * @returns {undefined}
       */
      onMove: function(pointer, event, fromTick) {
        var newPos = this.getEventPosition(event),
          newValue,
          ceilValue = this.options.rightToLeft ? this.minValue : this.maxValue,
          flrValue = this.options.rightToLeft ? this.maxValue : this.minValue;

        if (newPos <= 0) {
          newValue = flrValue;
        } else if (newPos >= this.maxPos) {
          newValue = ceilValue;
        } else {
          newValue = this.positionToValue(newPos);
          if (fromTick && angular.isNumber(this.options.showTicks))
            newValue = this.roundStep(newValue, this.options.showTicks);
          else
            newValue = this.roundStep(newValue);
        }
        this.positionTrackingHandle(newValue);
      },

      /**
       * onEnd event handler
       *
       * @param {Event}    event    The event
       * @param {Function} ehMove   The the bound move event handler
       * @returns {undefined}
       */
      onEnd: function(ehMove, event) {
        var moveEventName = this.getEventNames(event).moveEvent;

        if (!this.options.keyboardSupport) {
          this.minH.removeClass('rz-active');
          this.maxH.removeClass('rz-active');
          this.tracking = '';
        }
        this.dragging.active = false;

        $document.off(moveEventName, ehMove);
        this.callOnEnd();
      },

      onTickClick: function(pointer, event) {
        this.onMove(pointer, event, true);
      },

      onPointerFocus: function(pointer, ref) {
        this.tracking = ref;
        pointer.one('blur', angular.bind(this, this.onPointerBlur, pointer));
        pointer.on('keydown', angular.bind(this, this.onKeyboardEvent));
        pointer.on('keyup', angular.bind(this, this.onKeyUp));
        this.firstKeyDown = true;
        pointer.addClass('rz-active');

        this.currentFocusElement = {
          pointer: pointer,
          ref: ref
        };
      },

      onKeyUp: function() {
        this.firstKeyDown = true;
        this.callOnEnd();
      },

      onPointerBlur: function(pointer) {
        pointer.off('keydown');
        pointer.off('keyup');
        this.tracking = '';
        pointer.removeClass('rz-active');
        this.currentFocusElement = null
      },

      /**
       * Key actions helper function
       *
       * @param {number} currentValue value of the slider
       *
       * @returns {?Object} action value mappings
       */
      getKeyActions: function(currentValue) {
        var increaseStep = currentValue + this.step,
          decreaseStep = currentValue - this.step,
          increasePage = currentValue + this.valueRange / 10,
          decreasePage = currentValue - this.valueRange / 10;

        //Left to right default actions
        var actions = {
          'UP': increaseStep,
          'DOWN': decreaseStep,
          'LEFT': decreaseStep,
          'RIGHT': increaseStep,
          'PAGEUP': increasePage,
          'PAGEDOWN': decreasePage,
          'HOME': this.minValue,
          'END': this.maxValue
        };
        //right to left means swapping right and left arrows
        if (this.options.rightToLeft) {
          actions.LEFT = increaseStep;
          actions.RIGHT = decreaseStep;
          // right to left and vertical means we also swap up and down
          if (this.options.vertical) {
            actions.UP = decreaseStep;
            actions.DOWN = increaseStep;
          }
        }
        return actions;
      },

      onKeyboardEvent: function(event) {
        var currentValue = this[this.tracking],
          keyCode = event.keyCode || event.which,
          keys = {
            38: 'UP',
            40: 'DOWN',
            37: 'LEFT',
            39: 'RIGHT',
            33: 'PAGEUP',
            34: 'PAGEDOWN',
            36: 'HOME',
            35: 'END'
          },
          actions = this.getKeyActions(currentValue),
          key = keys[keyCode],
          action = actions[key];
        if (action == null || this.tracking === '') return;
        event.preventDefault();

        if (this.firstKeyDown) {
          this.firstKeyDown = false;
          this.callOnStart();
        }

        var self = this;
        $timeout(function() {
          var newValue = self.roundStep(self.sanitizeValue(action));
          if (!self.options.draggableRangeOnly) {
            self.positionTrackingHandle(newValue);
          }
          else {
            var difference = self.highValue - self.lowValue,
              newMinValue, newMaxValue;
            if (self.tracking === 'lowValue') {
              newMinValue = newValue;
              newMaxValue = newValue + difference;
              if (newMaxValue > self.maxValue) {
                newMaxValue = self.maxValue;
                newMinValue = newMaxValue - difference;
              }
            } else {
              newMaxValue = newValue;
              newMinValue = newValue - difference;
              if (newMinValue < self.minValue) {
                newMinValue = self.minValue;
                newMaxValue = newMinValue + difference;
              }
            }
            self.positionTrackingBar(newMinValue, newMaxValue);
          }
        });
      },

      /**
       * onDragStart event handler
       *
       * Handles dragging of the middle bar.
       *
       * @param {Object} pointer The jqLite wrapped DOM element
       * @param {string} ref     One of the refLow, refHigh values
       * @param {Event}  event   The event
       * @returns {undefined}
       */
      onDragStart: function(pointer, ref, event) {
        var position = this.getEventPosition(event);
        this.dragging = {
          active: true,
          value: this.positionToValue(position),
          difference: this.highValue - this.lowValue,
          lowLimit: this.options.rightToLeft ? this.minH.rzsp - position : position - this.minH.rzsp,
          highLimit: this.options.rightToLeft ? position - this.maxH.rzsp : this.maxH.rzsp - position
        };

        this.onStart(pointer, ref, event);
      },

      /**
       * getValue helper function
       *
       * gets max or min value depending on whether the newPos is outOfBounds above or below the bar and rightToLeft
       *
       * @param {string} type 'max' || 'min' The value we are calculating
       * @param {number} newPos  The new position
       * @param {boolean} outOfBounds Is the new position above or below the max/min?
       * @param {boolean} isAbove Is the new position above the bar if out of bounds?
       *
       * @returns {number}
       */
      getValue: function(type, newPos, outOfBounds, isAbove) {
        var isRTL = this.options.rightToLeft,
          value = null;

        if (type === 'min') {
          if (outOfBounds) {
            if (isAbove) {
              value = isRTL ? this.minValue : this.maxValue - this.dragging.difference;
            } else {
              value = isRTL ? this.maxValue - this.dragging.difference : this.minValue;
            }
          } else {
            value = isRTL ? this.positionToValue(newPos + this.dragging.lowLimit) : this.positionToValue(newPos - this.dragging.lowLimit)
          }
        } else {
          if (outOfBounds) {
            if (isAbove) {
              value = isRTL ? this.minValue + this.dragging.difference : this.maxValue;
            } else {
              value = isRTL ? this.maxValue : this.minValue + this.dragging.difference;
            }
          } else {
            if (isRTL) {
              value = this.positionToValue(newPos + this.dragging.lowLimit) + this.dragging.difference
            } else {
              value = this.positionToValue(newPos - this.dragging.lowLimit) + this.dragging.difference;
            }
          }
        }
        return this.roundStep(value);
      },

      /**
       * onDragMove event handler
       *
       * Handles dragging of the middle bar.
       *
       * @param {jqLite} pointer
       * @param {Event}  event The event
       * @returns {undefined}
       */
      onDragMove: function(pointer, event) {
        var newPos = this.getEventPosition(event),
          newMinValue, newMaxValue,
          ceilLimit, flrLimit,
          isUnderFlrLimit, isOverCeilLimit,
          flrH, ceilH;

        if (this.options.rightToLeft) {
          ceilLimit = this.dragging.lowLimit;
          flrLimit = this.dragging.highLimit;
          flrH = this.maxH;
          ceilH = this.minH;
        } else {
          ceilLimit = this.dragging.highLimit;
          flrLimit = this.dragging.lowLimit;
          flrH = this.minH;
          ceilH = this.maxH;
        }
        isUnderFlrLimit = newPos <= flrLimit;
        isOverCeilLimit = newPos >= this.maxPos - ceilLimit;

        if (isUnderFlrLimit) {
          if (flrH.rzsp === 0)
            return;
          newMinValue = this.getValue('min', newPos, true, false);
          newMaxValue = this.getValue('max', newPos, true, false);
        } else if (isOverCeilLimit) {
          if (ceilH.rzsp === this.maxPos)
            return;
          newMaxValue = this.getValue('max', newPos, true, true);
          newMinValue = this.getValue('min', newPos, true, true);
        } else {
          newMinValue = this.getValue('min', newPos, false);
          newMaxValue = this.getValue('max', newPos, false);
        }
        this.positionTrackingBar(newMinValue, newMaxValue);
      },

      /**
       * Set the new value and position for the entire bar
       *
       * @param {number} newMinValue   the new minimum value
       * @param {number} newMaxValue   the new maximum value
       */
      positionTrackingBar: function(newMinValue, newMaxValue) {

        if (this.options.minLimit != null && newMinValue < this.options.minLimit) {
          newMinValue = this.options.minLimit;
          newMaxValue = newMinValue + this.dragging.difference;
        }
        if (this.options.maxLimit != null && newMaxValue > this.options.maxLimit) {
          newMaxValue = this.options.maxLimit;
          newMinValue = newMaxValue - this.dragging.difference;
        }

        this.lowValue = newMinValue;
        this.highValue = newMaxValue;
        this.applyLowValue();
        if (this.range)
          this.applyHighValue();
        this.applyModel();
        this.updateHandles('lowValue', this.valueToPosition(newMinValue));
        this.updateHandles('highValue', this.valueToPosition(newMaxValue));
      },

      /**
       * Set the new value and position to the current tracking handle
       *
       * @param {number} newValue new model value
       */
      positionTrackingHandle: function(newValue) {
        var valueChanged = false;

        newValue = this.applyMinMaxLimit(newValue);
        if (this.range) {
          if (this.options.pushRange) {
            newValue = this.applyPushRange(newValue);
            valueChanged = true;
          }
          else {
            if (this.options.noSwitching) {
              if (this.tracking === 'lowValue' && newValue > this.highValue)
                newValue = this.applyMinMaxRange(this.highValue);
              else if (this.tracking === 'highValue' && newValue < this.lowValue)
                newValue = this.applyMinMaxRange(this.lowValue);
            }
            newValue = this.applyMinMaxRange(newValue);
            /* This is to check if we need to switch the min and max handles */
            if (this.tracking === 'lowValue' && newValue > this.highValue) {
              this.lowValue = this.highValue;
              this.applyLowValue();
              this.updateHandles(this.tracking, this.maxH.rzsp);
              this.updateAriaAttributes();
              this.tracking = 'highValue';
              this.minH.removeClass('rz-active');
              this.maxH.addClass('rz-active');
              if (this.options.keyboardSupport)
                this.focusElement(this.maxH);
              valueChanged = true;
            }
            else if (this.tracking === 'highValue' && newValue < this.lowValue) {
              this.highValue = this.lowValue;
              this.applyHighValue();
              this.updateHandles(this.tracking, this.minH.rzsp);
              this.updateAriaAttributes();
              this.tracking = 'lowValue';
              this.maxH.removeClass('rz-active');
              this.minH.addClass('rz-active');
              if (this.options.keyboardSupport)
                this.focusElement(this.minH);
              valueChanged = true;
            }
          }
        }

        if (this[this.tracking] !== newValue) {
          this[this.tracking] = newValue;
          if (this.tracking === 'lowValue')
            this.applyLowValue();
          else
            this.applyHighValue();
          this.updateHandles(this.tracking, this.valueToPosition(newValue));
          this.updateAriaAttributes();
          valueChanged = true;
        }

        if (valueChanged)
          this.applyModel();
      },

      applyMinMaxLimit: function(newValue) {
        if (this.options.minLimit != null && newValue < this.options.minLimit)
          return this.options.minLimit;
        if (this.options.maxLimit != null && newValue > this.options.maxLimit)
          return this.options.maxLimit;
        return newValue;
      },

      applyMinMaxRange: function(newValue) {
        var oppositeValue = this.tracking === 'lowValue' ? this.highValue : this.lowValue,
          difference = Math.abs(newValue - oppositeValue);
        if (this.options.minRange != null) {
          if (difference < this.options.minRange) {
            if (this.tracking === 'lowValue')
              return this.highValue - this.options.minRange;
            else
              return this.lowValue + this.options.minRange;
          }
        }
        if (this.options.maxRange != null) {
          if (difference > this.options.maxRange) {
            if (this.tracking === 'lowValue')
              return this.highValue - this.options.maxRange;
            else
              return this.lowValue + this.options.maxRange;
          }
        }
        return newValue;
      },

      applyPushRange: function(newValue) {
        var difference = this.tracking === 'lowValue' ? this.highValue - newValue : newValue - this.lowValue,
          minRange = this.options.minRange !== null ? this.options.minRange : this.options.step,
          maxRange = this.options.maxRange;
        // if smaller than minRange
        if (difference < minRange) {
          if (this.tracking === 'lowValue') {
            this.highValue = Math.min(newValue + minRange, this.maxValue);
            newValue = this.highValue - minRange;
            this.applyHighValue();
            this.updateHandles('highValue', this.valueToPosition(this.highValue));
          }
          else {
            this.lowValue = Math.max(newValue - minRange, this.minValue);
            newValue = this.lowValue + minRange;
            this.applyLowValue();
            this.updateHandles('lowValue', this.valueToPosition(this.lowValue));
          }
          this.updateAriaAttributes();
        }
        // if greater than maxRange
        else if (maxRange !== null && difference > maxRange) {
          if (this.tracking === 'lowValue') {
            this.highValue = newValue + maxRange;
            this.applyHighValue();
            this.updateHandles('highValue', this.valueToPosition(this.highValue));
          }
          else {
            this.lowValue = newValue - maxRange;
            this.applyLowValue();
            this.updateHandles('lowValue', this.valueToPosition(this.lowValue));
          }
          this.updateAriaAttributes();
        }
        return newValue;
      },

      /**
       * Apply the model values using scope.$apply.
       * We wrap it with the internalChange flag to avoid the watchers to be called
       */
      applyModel: function() {
        this.internalChange = true;
        this.scope.$apply();
        this.callOnChange();
        this.internalChange = false;
      },

      /**
       * Call the onStart callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
      callOnStart: function() {
        if (this.options.onStart) {
          var self = this,
            pointerType = this.tracking === 'lowValue' ? 'min' : 'max';
          this.scope.$evalAsync(function() {
            self.options.onStart(self.options.id, self.scope.rzSliderModel, self.scope.rzSliderHigh, pointerType);
          });
        }
      },

      /**
       * Call the onChange callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
      callOnChange: function() {
        if (this.options.onChange) {
          var self = this,
            pointerType = this.tracking === 'lowValue' ? 'min' : 'max';
          this.scope.$evalAsync(function() {
            self.options.onChange(self.options.id, self.scope.rzSliderModel, self.scope.rzSliderHigh, pointerType);
          });
        }
      },

      /**
       * Call the onEnd callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
      callOnEnd: function() {
        if (this.options.onEnd) {
          var self = this,
            pointerType = this.tracking === 'lowValue' ? 'min' : 'max';
          this.scope.$evalAsync(function() {
            self.options.onEnd(self.options.id, self.scope.rzSliderModel, self.scope.rzSliderHigh, pointerType);
          });
        }
        this.scope.$emit('slideEnded');
      }
    };

    return Slider;
  }])

  .directive('rzslider', ['RzSlider', function(RzSlider) {
    'use strict';

    return {
      restrict: 'AE',
      replace: true,
      scope: {
        rzSliderModel: '=?',
        rzSliderHigh: '=?',
        rzSliderOptions: '&?',
        rzSliderTplUrl: '@'
      },

      /**
       * Return template URL
       *
       * @param {jqLite} elem
       * @param {Object} attrs
       * @return {string}
       */
      templateUrl: function(elem, attrs) {
        //noinspection JSUnresolvedVariable
        return attrs.rzSliderTplUrl || 'rzSliderTpl.html';
      },

      link: function(scope, elem) {
        scope.slider = new RzSlider(scope, elem); //attach on scope so we can test it
      }
    };
  }]);

  // IDE assist

  /**
   * @name ngScope
   *
   * @property {number} rzSliderModel
   * @property {number} rzSliderHigh
   * @property {Object} rzSliderOptions
   */

  /**
   * @name jqLite
   *
   * @property {number|undefined} rzsp rzslider label position position
   * @property {number|undefined} rzsd rzslider element dimension
   * @property {string|undefined} rzsv rzslider label value/text
   * @property {Function} css
   * @property {Function} text
   */

  /**
   * @name Event
   * @property {Array} touches
   * @property {Event} originalEvent
   */

  /**
   * @name ThrottleOptions
   *
   * @property {boolean} leading
   * @property {boolean} trailing
   */

  module.run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('rzSliderTpl.html',
    "<div class=rzslider><span class=rz-bar-wrapper><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-selection\" ng-style=barStyle></span></span> <span class=\"rz-pointer rz-pointer-min\" ng-style=minPointerStyle></span> <span class=\"rz-pointer rz-pointer-max\" ng-style=maxPointerStyle></span> <span class=\"rz-bubble rz-limit rz-floor\"></span> <span class=\"rz-bubble rz-limit rz-ceil\"></span> <span class=rz-bubble></span> <span class=rz-bubble></span> <span class=rz-bubble></span><ul ng-show=showTicks class=rz-ticks><li ng-repeat=\"t in ticks track by $index\" class=rz-tick ng-class=\"{'rz-selected': t.selected}\" ng-style=t.style ng-attr-uib-tooltip=\"{{ t.tooltip }}\" ng-attr-tooltip-placement={{t.tooltipPlacement}} ng-attr-tooltip-append-to-body=\"{{ t.tooltip ? true : undefined}}\"><span ng-if=\"t.value != null\" class=rz-tick-value ng-attr-uib-tooltip=\"{{ t.valueTooltip }}\" ng-attr-tooltip-placement={{t.valueTooltipPlacement}}>{{ t.value }}</span> <span ng-if=\"t.legend != null\" class=rz-tick-legend>{{ t.legend }}</span></li></ul></div>"
  );

}]);

  return module.name
}));

},{"angular":"angular"}],59:[function(require,module,exports){
!function(){Chronopic.i18n.en_US={anteMeridiem:"㏂",dayOfWeek:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayOfWeekShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],disabled:"disabled",formatDate:"{MMMM} {D}, {YYYY}",formatDateTime:"{MMMM} {D}, {YYYY} - {h}:{mm} {ap}",formatYearMonth:"{MMMM}, {YYYY}",month:"Month",monthName:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNameShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],nextMonth:"Next month",nextYear:"Next year",postMeridiem:"㏘",prevMonth:"Previous month",prevYear:"Previous year",selectMonth:"Select month",titleDay:"{DDDD} {MMMM} {D}, {YYYY}",titleMonth:"{MMMM} {YYYY}",week:"Week",year:"Year"},Chronopic.i18n.en=Chronopic.i18n.en_US}();
!function(){Chronopic.i18n.fi_FI={anteMeridiem:"",dayOfWeek:["sunnuntai","maanantai","tiistai","keskiviikko","torstai","perjantai","lauantai"],dayOfWeekShort:["su","ma","ti","ke","to","pe","la"],disabled:"disabloitu",formatDate:"{D}. {MMMM}ta {YYYY}",formatDateTime:"{D}. {MMMM}ta {YYYY} - {HH}:{mm}",formatYearMonth:"{MMMM}ta {YYYY}",month:"kuukausi",monthName:["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],monthNameShort:["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],nextMonth:"seuraava kuukausi",nextYear:"seuraava vuosi",postMeridiem:"",prevMonth:"edellinen kuukausi",prevYear:"edellinen vuosi",selectMonth:"valitse kuukausi",titleDay:"{DDDD}, {D}. {MMMM}ta {YYYY}",titleMonth:"{MMMM} {YYYY}",week:"viikko",year:"vuosi"},Chronopic.i18n.fi=Chronopic.i18n.fi_FI}();
!function(){Chronopic.i18n.ja_JP={anteMeridiem:"午前",dayOfWeek:["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],dayOfWeekShort:["日","月","火","水","木","金","土"],disabled:"無効",formatDate:"{YYYY}年{M}月{D}日",formatDateTime:"{YYYY}年{M}月{D}日 {ap} {h}時{m}分",formatYearMonth:"{YYYY}年{M}月",month:"月",monthName:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthNameShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],nextMonth:"来月",nextYear:"来年",postMeridiem:"午後",prevMonth:"前月",prevYear:"前年",selectMonth:"月選択",titleDay:"{YYYY}年{MM}月{D}日 {DDDD}",titleMonth:"{YYYY}年{MMMM}",week:"週",year:"年",zeroHour:!0},Chronopic.i18n.ja=Chronopic.i18n.ja_JP}();
!function(){Chronopic.i18n.nb_NO={anteMeridiem:"",dayOfWeek:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],dayOfWeekShort:["sø","ma","ti","on","to","fr","lø"],disabled:"deaktivert",formatDate:"{D}. {MMMM} {YYYY}",formatDateTime:"{D}. {MMMM} {YYYY}, {HH}:{mm}",formatYearMonth:"{MMMM} {YYYY}",month:"Måned",monthName:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNameShort:["jan","feb","mars","apr","mai","juni","juli","aug","sep","okt","nov","des"],nextMonth:"Neste måned",nextYear:"Neste år",postMeridiem:"",prevMonth:"Forrige måned",prevYear:"Forrige år",selectMonth:"Velg måned",titleDay:"{DDDD} {D}. {MMMM} {YYYY}",titleMonth:"{MMMM} {YYYY}",week:"Uke",year:"År"},Chronopic.i18n.no=Chronopic.i18n.nb=Chronopic.i18n.nb_NO}();
!function(){Chronopic.i18n.nl_BE={anteMeridiem:"",dayOfWeek:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayOfWeekShort:["zo","ma","di","woe","do","vrij","zat"],disabled:"gedeactiveerd",formatDate:"{D} {MMMM} {YYYY}",formatDateTime:"{D} {MMMM} {YYYY}, {HH}:{mm}",formatYearMonth:"{MMMM} {YYYY}",month:"maand",monthName:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNameShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],nextMonth:"volgende maand",nextYear:"volgend jaar",postMeridiem:"",prevMonth:"vorige maand",prevYear:"vorig jaar",selectMonth:"selecteer maand",titleDay:"{DDDD} {D} {MMMM} {YYYY}",titleMonth:"{MMMM} {YYYY}",week:"week",year:"jaar"}}();
!function(){Chronopic.i18n.nl_NL={anteMeridiem:"",dayOfWeek:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayOfWeekShort:["zo","ma","di","woe","do","vrij","zat"],disabled:"gedeactiveerd",formatDate:"{D} {MMMM} {YYYY}",formatDateTime:"{D} {MMMM} {YYYY}, {HH}:{mm}",formatYearMonth:"{MMMM} {YYYY}",month:"maand",monthName:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNameShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],nextMonth:"volgende maand",nextYear:"volgend jaar",postMeridiem:"",prevMonth:"vorige maand",prevYear:"vorig jaar",selectMonth:"selecteer maand",titleDay:"{DDDD} {D} {MMMM} {YYYY}",titleMonth:"{MMMM} {YYYY}",week:"week",year:"jaar"},Chronopic.i18n.nl=Chronopic.i18n.nl_NL}();
!function(){Chronopic.i18n.nn_NO={anteMeridiem:"",dayOfWeek:["sundag","måndag","tysdag","onsdag","torsdag","fredag","laurdag"],dayOfWeekShort:["su","må","ty","on","to","fr","lau"],disabled:"deaktivert",formatDate:"{D}. {MMMM} {YYYY}",formatDateTime:"{D}. {MMMM} {YYYY}, {HH}:{mm}",formatYearMonth:"{MMMM} {YYYY}",month:"Månad",monthName:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNameShort:["jan","feb","mars","apr","mai","juni","juli","aug","sep","okt","nov","des"],nextMonth:"Neste månad",nextYear:"Neste år",postMeridiem:"",prevMonth:"Førre månad",prevYear:"Førre år",selectMonth:"Velj månad",titleDay:"{DDDD} {D}. {MMMM} {YYYY}",titleMonth:"{MMMM} {YYYY}",week:"Veke",year:"År"},Chronopic.i18n.nn=Chronopic.i18n.nn_NO}();
},{}],60:[function(require,module,exports){
(function() {
	"use strict";

	// Function used to check if a variable is a valid number
	function isNum(value) {
		return (typeof value == "number" && !isNaN(value) && Math.abs(value) < Infinity);
	}

	// Object.assign polyfill
	("function" != typeof Object.assign && (Object.assign = function(target) {
		if(undefined === target || null === target) {
			throw new TypeError("Cannot convert undefined or null to object");
		}

		var output = Object(target), index, source, key;

		for(index = 1; index < arguments.length; ++index) {
			if(undefined !== (source = arguments[index]) && null !== source) {
				for(key in source) {
					(source.hasOwnProperty(key) && (output[key] = source[key]));
				}
			}
		}

		return output;
	}));

	// DOM Element helper class for easy DOM manipulation
	function Element(selector, options) {
		options = Object.assign({
			appendTo:      null,
			context:       document,
			html:          "",
			insertAfter:   null,
			insertBefore:  null,
			replace:       null
		}, options);

		var a, parsed, elem = (selector instanceof HTMLElement ? selector : null);

		if("string" == typeof selector) {
			parsed = (function(selector, parsed) {
				selector.match(/(\[[^\]]+\]|#[^#.\[]+|\.[^#.\[]+|\w+)/g)
				.forEach(function(m) {
					(m[0] == "[" ? ((m = m.match(/^\[([^=\]]+)=?([^\]]+)?\]$/)) && (parsed.attribs[m[1]] = m[2] || "")) : // Attribute
					(m[0] == "." ? parsed.classes.push(m.substr(1)) : // Class
					(m[0] == "#" ? (parsed.attribs.id = m.substr(1)) : // ID
					(parsed.tag = m)))); // Tag
				});
				return parsed;
			})(selector, { attribs: {}, classes: [] });

			// Create element from parsed string
			elem = options.context.createElement(parsed.tag);

			// Add classes
			parsed.classes.forEach(function(className) {
				elem.classList.add(className);
			});

			// Add attributes
			for(a in parsed.attribs) {
				(parsed.attribs.hasOwnProperty(a) && elem.setAttribute(a, parsed.attribs[a]));
			}
		}

		(this.element = elem).innerHTML = options.html;
		this.parent = null;
		this.events = {};

		// Add element to DOM
		if(options.replace) {
			options.replace.parentNode.replaceChild(elem, options.replace);
		} else if(options.appendTo) {
			(this.parent = options.appendTo).element.appendChild(elem);
		} else if(options.insertAfter) {
			options.insertAfter.parentNode.insertBefore(elem, options.insertAfter.nextSibling);
		} else if(options.insertBefore) {
			options.insertBefore.parentNode.insertBefore(elem, options.insertBefore);
		}

		return this;
	}

	Element.prototype = {
		add: function(elements, clear) {
			(clear === true && (this.clear()));

			(elements instanceof Array ? elements : [ elements ])
			.forEach(function(element) {
				this.element.appendChild(element.element);
				element.parent = this;
			}, this);

			return this;
		},
		get classes() {
			return this.element.classList;
		},
		clear: function() {
			var elem = this.element, child;

			while((child = elem.firstChild)) {
				elem.removeChild(child);
			}

			return this;
		},
		on: function(events, callback) {
			(events instanceof Array ? events : [ events ])
			.forEach(function(event) {
				var self = this, fn = (typeof callback == "function" ? function(e) { return callback.call(self, e); } : null);
				(self.events[event] instanceof Array || (self.events[event] = []));

				if(fn) {
					self.events[event].push(fn);
					self.element.addEventListener(event, fn);
				} else {
					self.events[event].forEach(function(callback) { self.element.removeEventListener(event, callback); });
					self.events[event] = [];
				}
			}, this);
			return this;
		}
	};

	// JavaScript Date object wrapper for additional functionality
	function δ(date) {
		return {
			// Function used to compare date objects and return a number between 0 (unequal) and 6 (equal to the second)
			compare: function(arg) {
				var result = 0, f, fragments = [ "getFullYear", "getMonth", "getDate", "getHours", "getMinutes", "getSeconds" ];

				for(f in fragments) {
					if(date[fragments[f]]() == arg[fragments[f]]()) {
						result = ++f;
					} else break;
				}

				return result;
			},
			// Number of days in current month
			get days() {
				return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
			},
			// First day of the week in current month
			get firstDay() {
				return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
			},
			// ISO-8601 week number of current date
			get week() {
				var d = new Date(date);
				d.setHours(0, 0, 0);
				d.setDate(d.getDate() + 4 - (d.getDay() || 7));
				return Math.ceil((((d - new Date(d.getFullYear(), 0, 1)) / 86400000) + 1) / 7);
			}
		};
	}

	// Function used to parse a formatted string based on specified locale
	function formatted(date, format, locale) {
		var d = date.getDate(),
		    m = date.getMonth(),
		    y = date.getFullYear(),
		    h = date.getHours(),
		    h12 = (h % 12) || (locale.zeroHour ? 0 : 12),
		    n = date.getMinutes(),
		    s = date.getSeconds(),
		    w = δ(date).week,
		    wd = date.getDay(),
		    ap = h < 12 ? locale.anteMeridiem : locale.postMeridiem;

		return format
		.replace(/{date}/gi, locale.formatDate)
		.replace(/{datetime}/gi, locale.formatDateTime)
		.replace(/{isodate}/gi, "{YYYY}-{MM}-{DD}")
		.replace(/{yearmonth}/gi, locale.formatYearMonth)
		.replace(/{ww}/gi, ("0" + w).slice(-2))
		.replace(/{w}/gi, w)
		.replace(/{DDDD}/g, locale.dayOfWeek[wd])
		.replace(/{DDD}/g, locale.dayOfWeekShort[wd])
		.replace(/{DD}/g, ("0" + d).slice(-2))
		.replace(/{D}/g, d)
		.replace(/{MMMM}/g, locale.monthName[m])
		.replace(/{MMM}/g, locale.monthNameShort[m])
		.replace(/{MM}/g, ("0" + (m + 1)).slice(-2))
		.replace(/{M}/g, m + 1)
		.replace(/{YYYY}/g, y)
		.replace(/{YY}/g, y.toString().slice(-2))
		.replace(/{HH}/g, ("0" + h).slice(-2))
		.replace(/{H}/g, h)
		.replace(/{hh}/g, ("0" + h12).slice(-2))
		.replace(/{h}/g, h12)
		.replace(/{mm}/g, ("0" + n).slice(-2))
		.replace(/{m}/g, n)
		.replace(/{ss}/g, ("0" + s).slice(-2))
		.replace(/{s}/g, s)
		.replace(/{ap}/g, ap);
	}

	// Function used to create a table of days based on specified year and month
	function dayTable(year, month) {
		var firstDay = δ(new Date(year, month)).firstDay || 7,
		    current = new Date(year, month, 1 - ((firstDay - 1) || 7)),
		    row, col, table = [];

		for(row = 0; row < 6; ++row) {
			table.push([]);

			for(col = 0; col < 7; ++col) {
				table[row].push(new Date(current));
				current.setDate(current.getDate() + 1);
			}
		}

		return table;
	}

	// Function used to create a table of months based on specified year
	function monthTable(year) {
		var row, col, table = [];

		for(row = 0; row < 3; ++row) {
			table.push([]);

			for(col = 0; col < 4; ++col) {
				table[row].push(new Date(year, (row * 4) + col));
			}
		}

		return table;
	}

	// Chronopic main class
	function _(selector, options) {
		// Merge options with defaults
		options = Object.assign({
			className:      "chronopic",
			container:      null,
			date:           null,
			direction:      "down",
			format:         "{date}",
			locale:         null,
			max:            { year: 2100 },
			min:            { year: 1900 },
			monthYearOnly:  false,
			onChange:       null
		}, options);

		// Public properties
		this.container      = options.container;
		this.direction      = options.direction;
		this.format         = options.format;
		this.instances      = [];
		this.max            = ("object" == typeof options.max ? options.max : {});
		this.min            = ("object" == typeof options.min ? options.min : {});
		this.monthYearOnly  = (options.monthYearOnly === true);

		// Private properties
		this._i18n = _.i18n.en_GB;

		var self = this, date = new Date();

		// Set initial date if specified in options
		if(options.date && "object" == typeof (date = options.date)) {
			date = (date instanceof Date ? new Date(date) :
				new Date(date.year, date.month - 1, date.day));
		}

		// Parse minimum and maximum dates from options
		(self.max instanceof Date && (self.max = { year: self.max.getFullYear(), month: self.max.getMonth() + 1, day: self.max.getDate() }));
		(self.min instanceof Date && (self.min = { year: self.min.getFullYear(), month: self.min.getMonth() + 1, day: self.min.getDate() }));

		// Function used to check if a specified date is within a valid range
		function valid(year, month, day) {
			var days, min = self.min, max = self.max, fixed;

			// Fix day overflows
			while(day > (days = δ(new Date(year, month, day)).days)) {
				++month;
				day -= day - days;
			}

			// Fix month overflows
			while(month > 12) {
				++year;
				month -= 12;
			}

			if(!isNaN((fixed = new Date(year, month - 1, isNaN(day) ? 1 : day)))) {
				year = fixed.getFullYear();
				month = fixed.getMonth() + 1;
				day = fixed.getDate();
			}

			if(isNum(year)) {
				if((isNum(min.year) && year < min.year)
				|| (isNum(max.year) && year > max.year)) {
					return false;
				}

				if(isNum(month)) {
					if((isNum(min.month) && month < min.month && year <= min.year)
					|| (isNum(max.month) && month > max.month && year >= max.year)) {
						return false;
					}

					if(isNum(day)) {
						if((isNum(min.day) && day < min.day && month <= min.month && year <= min.year)
						|| (isNum(max.day) && day > max.day && month >= max.month && year >= max.year)) {
							return false;
						}
					}
				}
			}

			return true;
		}

		// Inject Chronpic in DOM Elements from constructor selector parameter
		("string" == typeof selector ? [].slice.call(document.querySelectorAll(selector)) : [ selector ])
		.forEach(function(element) {
			if(element instanceof HTMLElement) {
				_.instances.forEach(function(parent) {
					parent.instances.forEach(function(child, index, array) {
						if(child.element.element == element) {
							// Clear events and remove instance if previously defined by different selector
							child.element.on([ "click", "change", "keydown" ], null);
							array.splice(index, 1);
						}
					});
				});

				var sibling = element.nextSibling;
				((sibling.tagName == "DIV" && sibling.classList.contains(options.className)) || (sibling = null));

				var className = options.className,
					container = new Element("div." + className, { insertAfter: element, replace: sibling }),
				    instance,
				    self = this,
				    tables = {};

				[ "day", "month" ].forEach(function(table) {
					container.add((tables[table] = new Element("table.hidden." + table)));
					tables[table].head = new Element("thead", { appendTo: tables[table] });
					tables[table].body = new Element("tbody", { appendTo: tables[table] });
				});

				self.instances.push((instance = {
					date: new Date(date),
					container: container,
					element: new Element(element),
					selected: {},
					tables: tables,
					value: "",
					visible: false,

					get day() {
						return this.date.getDate();
					},
					set day(value) {
						if(valid(this.date.getFullYear(), this.date.getMonth() + 1, value)) {
							this.date.setDate(value);
							this.selected.day = new Date(this.date);
						}
					},
					hide: function() {
						for(var t in tables) {
							tables[t].classes.add("hidden");
						}

						this.visible = false;
						this.selected.month = null;

						if(this.selected.day) {
							this.date = new Date(this.selected.day);
							this.selected.month = new Date(this.date);
						}

						return this;
					},
					get hour() {
						return this.date.getHours();
					},
					set hour(value) {
						// TODO: check if valid (not disabled)
						this.date.setHours(value);
					},
					get minute() {
						return this.date.getMinutes();
					},
					set minute(value) {
						// TODO: check if valid (not disabled)
						this.date.setMinutes(value);
					},
					get month() {
						return this.date.getMonth();
					},
					set month(value) {
						if(valid(this.date.getFullYear(), value + 1)) {
							this.date.setMonth(value);
							this.selected.month = new Date(this.date);
						}
					},
					rebuild: function(table) {
						var instance = this,
						    sel = instance.selected,
						    now = new Date(),
						    dow = 1,
						    lables, i;

						if(!table || table == "day") {
							instance.tables.day.head.add([
								new Element("tr.title").add([
									new Element("th.prev[title=" + self.locale.prevMonth + "]", { html: "&lt;" })
									.on("click", function(e) {
										instance.date.setDate(1);
										instance.month--;
										instance.show("day");
										e.stopPropagation();
									}),
									new Element("th[colspan=6][title=" + self.locale.selectMonth + "]", { html: formatted(instance.date, self.locale.titleMonth, self.locale) })
									.on("click", function() {
										instance.show("month");
									}),
									new Element("th.next[title=" + self.locale.nextMonth + "]", { html: "&gt;" })
									.on("click", function(e) {
										instance.date.setDate(1);
										instance.month++;
										instance.show("day")
										e.stopPropagation();
									})
								]),
								(lables = new Element("tr.labels").add(new Element("th.week", { html: self.locale.week })))
							], true);

							for(i = 0; i < 7; ++i) {
								lables.add(new Element("th.day[title=" + self.locale.dayOfWeek[dow % 7] + "]", { html: self.locale.dayOfWeekShort[dow++ % 7] }));
							}

							instance.tables.day.body.clear();
							dayTable(instance.year, instance.month).forEach(function(row) {
								var tr = new Element("tr", { appendTo: instance.tables.day.body });
								tr.add(new Element("td.week", { html: δ(row[0]).week }));

								row.forEach(function(col) {
									var classNames = ".day",
										monthDiff = col.getMonth() - instance.month,
										disabled = !valid(col.getFullYear(), col.getMonth() + 1, col.getDate()),
										title = formatted(col, self.locale.titleDay, self.locale),
										elem;

									((monthDiff == -1 || monthDiff == 11) && (classNames += ".prev"));
									((monthDiff == 1 || monthDiff == -11) && (classNames += ".next"));
									(sel.day && δ(sel.day).compare(col) >= 3 && (classNames += ".selected"));
									(δ(col).compare(now) >= 3 && (classNames += ".now"));

									if(disabled) {
										classNames += ".disabled";
										title += " (" + self.locale.disabled + ")";
									}

									tr.add((elem = new Element("td[title=" + title + "]" + classNames, { html: col.getDate() })));
									(!disabled && elem.on("click", function() {
										instance.month = col.getMonth(),
										instance.day = col.getDate();
										instance.update().hide();
									}));
								});
							});
						}

						if(!table || table == "month") {
							instance.tables.month.head.add([
								new Element("tr.title").add([
									new Element("th.prev[title=" + self.locale.prevYear + "]", { html: "&lt;" })
									.on("click", function(e) {
										instance.year--;
										instance.show("month");
										e.stopPropagation();
									}),
									new Element("th.year[colspan=6][title=" + self.locale.year + "]").add(
										new Element("input[type=number][step=1][min=" + (self.min.year || 0) + "][max=" + (self.max.year || 9999) + "][value=" + instance.year + "]")
										.on("change", function(e, v) {
											if(isNum((v = Number(e.target.value)))) {
												instance.year = v;
												instance.show("month");
												instance.container.element.querySelector(".year input").focus();
											}
										})
									),
									new Element("th.next[title=" + self.locale.nextYear + "]", { html: "&gt;" })
									.on("click", function(e) {
										instance.year++;
										instance.show("month");
										e.stopPropagation();
									})
								]),
							], true);

							instance.tables.month.body.clear();
							monthTable(instance.year).forEach(function(row) {
								var tr = new Element("tr", { appendTo: instance.tables.month.body });

								row.forEach(function(col) {
									var classNames = ".month",
									    month = col.getMonth(),
									    disabled = !valid(col.getFullYear(), month + 1),
									    title = formatted(col, self.locale.titleMonth, self.locale),
									    elem;

									(sel.month && δ(sel.month).compare(col) >= 2 && (classNames += ".selected"));
									(disabled && (classNames += ".disabled"));
									(δ(col).compare(now) >= 2 && (classNames += ".now"));

									if(disabled) {
										classNames += ".disabled";
										title += " (" + self.locale.disabled + ")";
									}

									tr.add((elem = new Element("td[colspan=2][title=" + title + "]" + classNames, { html: self.locale.monthNameShort[month] })));
									(!disabled && elem.on("click", function() {
										instance.date.setDate(1);
										instance.month = month;
										(self.monthYearOnly === true ? instance.update().hide() : instance.show("day"));
									}));
								});
							});
						}

						return this;
					},
					get second() {
						return this.date.getSeconds();
					},
					set second(value) {
						// TODO: check if valid (not disabled)
						this.date.setSeconds(value);
					},
					show: function(table) {
						table = (self.monthYearOnly === true ? "month" : (table || "day"));
						this.rebuild(table);
						this.visible = true;

						var widget = { elem: this.container.element },
						    parent = { elem: (self.container instanceof HTMLElement ? self.container : widget.elem.parentNode) },
						    target = { elem: element },
						    dir = self.direction, t, upPos, downPos, centerPos, fitsDown, fitsUp;

						// Calculate dimensions and positions
						[ widget, parent, target ].forEach(function(item, idx) {
							var rect = item.elem.getBoundingClientRect();

							item.h = item.elem.offsetHeight;
							item.w = item.elem.offsetWidth;
							item.abs = { x: rect.left, y: rect.top };
							item.rel = { x: item.elem.offsetLeft, y: item.elem.offsetTop };
						});

						// Show correct table and update widget dimensions
						for(t in tables) {
							(tables.hasOwnProperty(t) && tables[t].classes[(t == table ? "remove" : "add")]("hidden"));
							widget.h = Math.max(widget.h, tables[t].element.offsetHeight);
							widget.w = Math.max(widget.w, tables[t].element.offsetWidth);
						}

						upPos = (target.rel.y - widget.h) + "px";
						downPos = (target.rel.y + target.h) + "px";
						centerPos = ((parent.h / 2) - (widget.h / 2)) + "px";
						fitsDown = (target.abs.y + target.h + widget.h < parent.abs.y + parent.h);
						fitsUp = (target.abs.y - widget.h > parent.abs.y);

						widget.elem.style.top =
							(dir == "down" ? downPos :
								(dir == "up" ? upPos :
									(fitsDown ? downPos :
										(fitsUp ? upPos :
											centerPos))));

						(widget.w == target.w || (widget.elem.style.width = target.w + "px"));
					},
					update: function() {
						this.value = element.value = formatted(this.date, self.format, self._i18n);
						this.selected.day = new Date(this.date);

						if(typeof options.onChange == 'function') {
							options.onChange(element, this.date);
						}

						return this;
					},
					get year() {
						return this.date.getFullYear();
					},
					set year(value) {
						(valid(value) && this.date.setFullYear(value));
					}
				}));

				((options.date && instance.update()) || (element.value = ""));

				// Handle DOM events
				instance.element
				.on("click", function(e) {
					instance[(instance.visible ? "hide" : "show")]();
				})
				.on("keydown", function(e) {
					var key = e.keyCode,
					    beg = e.target.selectionStart, end,
					    inc, tmp, leftmost, rightmost, genSegs;

					// 37:left, 38:up, 39:right, 40:down
					if(key < 37 || key > 40) {
						return;
					}

					// Split format string into segments of placeholders and separators
					(genSegs = function(value) {
						var segs = [], fmt, pos = 0;

						self.format.match(/(\{[^}]*\}|[^{]+)/g).forEach(function(seg, idx, arr) {
							// Translate formatted string if needed
							fmt = /^\{(.*)\}$/.test(seg) ? formatted(instance.date, seg, self._i18n) : seg;

							// Update end position of previous segment if present
							((idx = segs.length) && (segs[idx - 1].end = pos));

							segs.push({
								fmt:    seg,            // Format string
								val:    fmt,            // Output value
								beg:    pos,            // Start position
								end:    value.length,   // End position
								field:  (seg != fmt)    // Editable field?
							});

							// Determine leftmost and rightmost editable fields
							((seg != fmt) && (rightmost = segs[idx]) && (leftmost || (leftmost = rightmost)));

							pos += fmt.length;
						});

						return segs;
					})(e.target.value)

					// Loop through generated segments to determine keyboard action
					.forEach(function(seg, idx, arr) {
						if(beg < leftmost.beg) {
							beg = leftmost.beg;
							end = leftmost.end;
						} else if(beg > rightmost.beg) {
							beg = rightmost.beg;
							end = rightmost.end;
						} else if(!end && beg >= seg.beg && beg < seg.end) {
							// Highlight editable segment if applicable
							if(seg.field && e.target.selectionEnd == beg) {
								beg = seg.beg;
								end = seg.end;
							}

							// Change highlight to editable segment left of current
							else if(key == 37) {
								while(idx && !tmp) {
									if((tmp = arr[--idx]).field) {
										beg = tmp.beg;
										end = tmp.end;
									} else tmp = null;
								}
								(end || (end = leftmost.end));
							}

							// Change highlight to editable segment right of current
							else if(key == 39) { // right
								while(++idx < arr.length && !tmp) {
									if((tmp = arr[idx]).field) {
										beg = tmp.beg;
										end = tmp.end;
									} else tmp = null;
								}
								(end || (end = rightmost.end));
							}

							// Change value of highlighted segment
							else if(key == 38 || key == 40) {
								// Ensure highlighted segment is editable
								if(seg.field) {
									var fmt = seg.fmt, inc = (key == 38 ? 1 : -1);

									if(/D{1,2}/.test(fmt)) {
										instance.day += inc;
									} else if(/M{1,4}/.test(fmt)) {
										instance.month += inc;
									} else if(/YY(YY)?/.test(fmt)) {
										instance.year += inc;
									} else if(/HH?/i.test(fmt)) {
										instance.hour += inc;
									} else if(/mm?/.test(fmt)) {
										instance.minute += inc;
									} else if(/ss?/.test(fmt)) {
										instance.second += inc;
									} else if(/ap/.test(fmt)) {
										instance.hour += (12 * inc);
									}

									// Update GUI
									instance.update();
									(instance.visible && instance.show());

									// Update highlight area
									tmp = genSegs(e.target.value)[idx];
									beg = tmp.beg;
									end = tmp.end;
								}

								// ...Otherwise, highlight editable segment to the left
								else while(idx && !tmp) {
									if((tmp = arr[--idx]).field) {
										beg = tmp.beg;
										end = tmp.end;
									} else tmp = null;
								}
							}
						}
					});

					e.preventDefault();
					e.target.selectionStart = beg;
					e.target.selectionEnd = end || beg;
				})
				.on("change", function(e) {
					var newVal = e.target.value,
					    valPos = 0,
					    status = true,
					    d, m, y, h, n, s, a;

					self.format.match(/(\{[^}]*\}|[^{]+)/g).forEach(function(seg, idx, arr) {
						if(status) {
							if(/^\{(.*)\}$/.test(seg)) {
								var val = newVal.slice(valPos);
								(++idx < arr.length && (val = val.slice(0, val.search(arr[idx]))));
								valPos += val.length;
								seg = seg.slice(1, -1);

								if(seg == "DD" || seg == "D") {
									d = Number(val);
								} else if(seg == "MMMM") {
									self._i18n.monthName.forEach(function(monthName, monthNumber) {
										(!m && val == monthName && (m = monthNumber + 1));
									});
									(m || (status = false));
								} else if(seg == "MMM") {
									self._i18n.monthNameShort.forEach(function(monthName, monthNumber) {
										(!m && val == monthName && (m = monthNumber + 1));
									});
									(m || (status = false));
								} else if(seg == "MM" || seg == "M") {
									m = Number(val);
								} else if(seg == "YYYY" || seg == "YY") {
									y = Number(val);
								} else if(seg == "HH" || seg == "H" || seg == "hh" || seg == "h") {
									h = Number(val);
								} else if(seg == "mm" || seg == "m") {
									n = Number(val);
								} else if(seg == "s" || seg == "s") {
									s = Number(val);
								} else if(seg == "ap") {
									((a = val) != self._i18n.anteMeridiem && a != self._i18n.postMeridiem && (status = false));
								} else {
									status = false;
								}
							} else if(newVal.substr(valPos, seg.length) == seg) {
								valPos += seg.length;
							} else {
								status = false;
							}
						}
					});

					if(!status) {
						e.target.value = instance.value;
						return;
					}

					(isNum(s) && (instance.second = s));
					(isNum(n) && (instance.minute = n));
					(isNum(h) && (instance.hour = h));
					(isNum(d) && (instance.day = d));
					(isNum(m) && (instance.month = m - 1));
					(isNum(y) && (instance.year = y));

					instance.update();
					(instance.visible && instance.show());
				});

				document.addEventListener("click", function(e, node) {
					while((node = node ? node.parentNode : e.target)) {
						if(node == element || node == container.element) {
							return;
						}
					}
					instance.hide();
				});
			}
		}, this);

		// Use locale specified in constructor options if specified, otherwise browser locale. Default locale as fallback
		this.locale = (options.locale || (navigator ? (navigator.userLanguage || navigator.language).replace("-", "_") : null));

		_.instances.push(this);
	}

	_.VERSION = 0.43;
	_.instances = [];

	_.prototype = {
		get direction() {
			return (this._dir || "auto");
		},
		set direction(value) {
			([ "auto", "down", "up" ].indexOf(value.toLowerCase()) != -1 && (this._dir = value.toLowerCase()));
			return this.direction;
		},
		get format() {
			switch(this._fmt) {
			case "{date}":
				return this._i18n.formatDate;

			case "{datetime}":
				return this._i18n.formatDateTime;

			case "{yearmonth}":
				return this._i18n.formatYearMonth;
			}

			return (this._fmt || "");
		},
		set format(value) {
			this._fmt = ("string" == typeof value ? value : "");
		},
		get locale() {
			return this._i18n;
		},
		set locale(value) {
			if(_.i18n[value] && (_.i18n[value] !== this._i18n)) {
				this._i18n = _.i18n[value];

				this.instances.forEach(function(instance) {
					if(instance.selected.day) {
						instance.day = instance.date.getDate();
						instance.update()
					}

					instance.rebuild();
				});
			}
		}
	};

	// Default locale settings
	_.i18n = {
		en_GB: {
			anteMeridiem:       "㏂",
			dayOfWeek:          [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
			dayOfWeekShort:     [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
			disabled:           "disabled",
			formatDate:         "{D} {MMMM} {YYYY}",
			formatDateTime:     "{D} {MMMM} {YYYY}, {h}:{mm} {ap}",
			formatYearMonth:    "{MMMM} {YYYY}",
			month:              "Month",
			monthName:          [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
			monthNameShort:     [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
			nextMonth:          "Next month",
			nextYear:           "Next year",
			postMeridiem:       "㏘",
			prevMonth:          "Previous month",
			prevYear:           "Previous year",
			selectMonth:        "Select month",
			titleDay:           "{DDDD} {D} {MMMM} {YYYY}",
			titleMonth:         "{MMMM} {YYYY}",
			week:               "Week",
			year:               "Year"
		}
	};

	if(typeof window != "undefined") {
		// Enable dynamic resizing of Chronopic instances
		window.addEventListener("resize", function(e) {
			_.instances.forEach(function(instance) {
				instance.instances.forEach(function(instance) {
					(instance.visible && (instance.show()));
				});
			});
		});

		window.Chronopic = _;
	}

	if(typeof module == "object" && module.exports) {
		module.exports = _;
	}

	return _;
})();

},{}],61:[function(require,module,exports){
/* esri-leaflet - v2.1.4 - Fri Mar 09 2018 18:29:17 GMT-0800 (PST)
 * Copyright (c) 2018 Environmental Systems Research Institute, Inc.
 * Apache-2.0 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('leaflet')) :
	typeof define === 'function' && define.amd ? define(['exports', 'leaflet'], factory) :
	(factory((global.L = global.L || {}, global.L.esri = {}),global.L));
}(this, (function (exports,leaflet) { 'use strict';

var version = "2.1.4";

var cors = ((window.XMLHttpRequest && 'withCredentials' in new window.XMLHttpRequest()));
var pointerEvents = document.documentElement.style.pointerEvents === '';

var Support = {
  cors: cors,
  pointerEvents: pointerEvents
};

var options = {
  attributionWidthOffset: 55
};

var callbacks = 0;

function serialize (params) {
  var data = '';

  params.f = params.f || 'json';

  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      var param = params[key];
      var type = Object.prototype.toString.call(param);
      var value;

      if (data.length) {
        data += '&';
      }

      if (type === '[object Array]') {
        value = (Object.prototype.toString.call(param[0]) === '[object Object]') ? JSON.stringify(param) : param.join(',');
      } else if (type === '[object Object]') {
        value = JSON.stringify(param);
      } else if (type === '[object Date]') {
        value = param.valueOf();
      } else {
        value = param;
      }

      data += encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }
  }

  return data;
}

function createRequest (callback, context) {
  var httpRequest = new window.XMLHttpRequest();

  httpRequest.onerror = function (e) {
    httpRequest.onreadystatechange = leaflet.Util.falseFn;

    callback.call(context, {
      error: {
        code: 500,
        message: 'XMLHttpRequest error'
      }
    }, null);
  };

  httpRequest.onreadystatechange = function () {
    var response;
    var error;

    if (httpRequest.readyState === 4) {
      try {
        response = JSON.parse(httpRequest.responseText);
      } catch (e) {
        response = null;
        error = {
          code: 500,
          message: 'Could not parse response as JSON. This could also be caused by a CORS or XMLHttpRequest error.'
        };
      }

      if (!error && response.error) {
        error = response.error;
        response = null;
      }

      httpRequest.onerror = leaflet.Util.falseFn;

      callback.call(context, error, response);
    }
  };

  httpRequest.ontimeout = function () {
    this.onerror();
  };

  return httpRequest;
}

function xmlHttpPost (url, params, callback, context) {
  var httpRequest = createRequest(callback, context);
  httpRequest.open('POST', url);

  if (typeof context !== 'undefined' && context !== null) {
    if (typeof context.options !== 'undefined') {
      httpRequest.timeout = context.options.timeout;
    }
  }
  httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  httpRequest.send(serialize(params));

  return httpRequest;
}

function xmlHttpGet (url, params, callback, context) {
  var httpRequest = createRequest(callback, context);
  httpRequest.open('GET', url + '?' + serialize(params), true);

  if (typeof context !== 'undefined' && context !== null) {
    if (typeof context.options !== 'undefined') {
      httpRequest.timeout = context.options.timeout;
    }
  }
  httpRequest.send(null);

  return httpRequest;
}

// AJAX handlers for CORS (modern browsers) or JSONP (older browsers)
function request (url, params, callback, context) {
  var paramString = serialize(params);
  var httpRequest = createRequest(callback, context);
  var requestLength = (url + '?' + paramString).length;

  // ie10/11 require the request be opened before a timeout is applied
  if (requestLength <= 2000 && Support.cors) {
    httpRequest.open('GET', url + '?' + paramString);
  } else if (requestLength > 2000 && Support.cors) {
    httpRequest.open('POST', url);
    httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  }

  if (typeof context !== 'undefined' && context !== null) {
    if (typeof context.options !== 'undefined') {
      httpRequest.timeout = context.options.timeout;
    }
  }

  // request is less than 2000 characters and the browser supports CORS, make GET request with XMLHttpRequest
  if (requestLength <= 2000 && Support.cors) {
    httpRequest.send(null);

  // request is more than 2000 characters and the browser supports CORS, make POST request with XMLHttpRequest
  } else if (requestLength > 2000 && Support.cors) {
    httpRequest.send(paramString);

  // request is less  than 2000 characters and the browser does not support CORS, make a JSONP request
  } else if (requestLength <= 2000 && !Support.cors) {
    return jsonp(url, params, callback, context);

  // request is longer then 2000 characters and the browser does not support CORS, log a warning
  } else {
    warn('a request to ' + url + ' was longer then 2000 characters and this browser cannot make a cross-domain post request. Please use a proxy http://esri.github.io/esri-leaflet/api-reference/request.html');
    return;
  }

  return httpRequest;
}

function jsonp (url, params, callback, context) {
  window._EsriLeafletCallbacks = window._EsriLeafletCallbacks || {};
  var callbackId = 'c' + callbacks;
  params.callback = 'window._EsriLeafletCallbacks.' + callbackId;

  window._EsriLeafletCallbacks[callbackId] = function (response) {
    if (window._EsriLeafletCallbacks[callbackId] !== true) {
      var error;
      var responseType = Object.prototype.toString.call(response);

      if (!(responseType === '[object Object]' || responseType === '[object Array]')) {
        error = {
          error: {
            code: 500,
            message: 'Expected array or object as JSONP response'
          }
        };
        response = null;
      }

      if (!error && response.error) {
        error = response;
        response = null;
      }

      callback.call(context, error, response);
      window._EsriLeafletCallbacks[callbackId] = true;
    }
  };

  var script = leaflet.DomUtil.create('script', null, document.body);
  script.type = 'text/javascript';
  script.src = url + '?' + serialize(params);
  script.id = callbackId;
  leaflet.DomUtil.addClass(script, 'esri-leaflet-jsonp');

  callbacks++;

  return {
    id: callbackId,
    url: script.src,
    abort: function () {
      window._EsriLeafletCallbacks._callback[callbackId]({
        code: 0,
        message: 'Request aborted.'
      });
    }
  };
}

var get = ((Support.cors) ? xmlHttpGet : jsonp);
get.CORS = xmlHttpGet;
get.JSONP = jsonp;

// export the Request object to call the different handlers for debugging
var Request = {
  request: request,
  get: get,
  post: xmlHttpPost
};

/*
 * Copyright 2017 Esri
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// checks if 2 x,y points are equal
function pointsEqual (a, b) {
  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}

// checks if the first and last points of a ring are equal and closes the ring
function closeRing (coordinates) {
  if (!pointsEqual(coordinates[0], coordinates[coordinates.length - 1])) {
    coordinates.push(coordinates[0]);
  }
  return coordinates;
}

// determine if polygon ring coordinates are clockwise. clockwise signifies outer ring, counter-clockwise an inner ring
// or hole. this logic was found at http://stackoverflow.com/questions/1165647/how-to-determine-if-a-list-of-polygon-
// points-are-in-clockwise-order
function ringIsClockwise (ringToTest) {
  var total = 0;
  var i = 0;
  var rLength = ringToTest.length;
  var pt1 = ringToTest[i];
  var pt2;
  for (i; i < rLength - 1; i++) {
    pt2 = ringToTest[i + 1];
    total += (pt2[0] - pt1[0]) * (pt2[1] + pt1[1]);
    pt1 = pt2;
  }
  return (total >= 0);
}

// ported from terraformer.js https://github.com/Esri/Terraformer/blob/master/terraformer.js#L504-L519
function vertexIntersectsVertex (a1, a2, b1, b2) {
  var uaT = ((b2[0] - b1[0]) * (a1[1] - b1[1])) - ((b2[1] - b1[1]) * (a1[0] - b1[0]));
  var ubT = ((a2[0] - a1[0]) * (a1[1] - b1[1])) - ((a2[1] - a1[1]) * (a1[0] - b1[0]));
  var uB = ((b2[1] - b1[1]) * (a2[0] - a1[0])) - ((b2[0] - b1[0]) * (a2[1] - a1[1]));

  if (uB !== 0) {
    var ua = uaT / uB;
    var ub = ubT / uB;

    if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
      return true;
    }
  }

  return false;
}

// ported from terraformer.js https://github.com/Esri/Terraformer/blob/master/terraformer.js#L521-L531
function arrayIntersectsArray (a, b) {
  for (var i = 0; i < a.length - 1; i++) {
    for (var j = 0; j < b.length - 1; j++) {
      if (vertexIntersectsVertex(a[i], a[i + 1], b[j], b[j + 1])) {
        return true;
      }
    }
  }

  return false;
}

// ported from terraformer.js https://github.com/Esri/Terraformer/blob/master/terraformer.js#L470-L480
function coordinatesContainPoint (coordinates, point) {
  var contains = false;
  for (var i = -1, l = coordinates.length, j = l - 1; ++i < l; j = i) {
    if (((coordinates[i][1] <= point[1] && point[1] < coordinates[j][1]) ||
         (coordinates[j][1] <= point[1] && point[1] < coordinates[i][1])) &&
        (point[0] < (((coordinates[j][0] - coordinates[i][0]) * (point[1] - coordinates[i][1])) / (coordinates[j][1] - coordinates[i][1])) + coordinates[i][0])) {
      contains = !contains;
    }
  }
  return contains;
}

// ported from terraformer-arcgis-parser.js https://github.com/Esri/terraformer-arcgis-parser/blob/master/terraformer-arcgis-parser.js#L106-L113
function coordinatesContainCoordinates (outer, inner) {
  var intersects = arrayIntersectsArray(outer, inner);
  var contains = coordinatesContainPoint(outer, inner[0]);
  if (!intersects && contains) {
    return true;
  }
  return false;
}

// do any polygons in this array contain any other polygons in this array?
// used for checking for holes in arcgis rings
// ported from terraformer-arcgis-parser.js https://github.com/Esri/terraformer-arcgis-parser/blob/master/terraformer-arcgis-parser.js#L117-L172
function convertRingsToGeoJSON (rings) {
  var outerRings = [];
  var holes = [];
  var x; // iterator
  var outerRing; // current outer ring being evaluated
  var hole; // current hole being evaluated

  // for each ring
  for (var r = 0; r < rings.length; r++) {
    var ring = closeRing(rings[r].slice(0));
    if (ring.length < 4) {
      continue;
    }
    // is this ring an outer ring? is it clockwise?
    if (ringIsClockwise(ring)) {
      var polygon = [ ring.slice().reverse() ]; // wind outer rings counterclockwise for RFC 7946 compliance
      outerRings.push(polygon); // push to outer rings
    } else {
      holes.push(ring.slice().reverse()); // wind inner rings clockwise for RFC 7946 compliance
    }
  }

  var uncontainedHoles = [];

  // while there are holes left...
  while (holes.length) {
    // pop a hole off out stack
    hole = holes.pop();

    // loop over all outer rings and see if they contain our hole.
    var contained = false;
    for (x = outerRings.length - 1; x >= 0; x--) {
      outerRing = outerRings[x][0];
      if (coordinatesContainCoordinates(outerRing, hole)) {
        // the hole is contained push it into our polygon
        outerRings[x].push(hole);
        contained = true;
        break;
      }
    }

    // ring is not contained in any outer ring
    // sometimes this happens https://github.com/Esri/esri-leaflet/issues/320
    if (!contained) {
      uncontainedHoles.push(hole);
    }
  }

  // if we couldn't match any holes using contains we can try intersects...
  while (uncontainedHoles.length) {
    // pop a hole off out stack
    hole = uncontainedHoles.pop();

    // loop over all outer rings and see if any intersect our hole.
    var intersects = false;

    for (x = outerRings.length - 1; x >= 0; x--) {
      outerRing = outerRings[x][0];
      if (arrayIntersectsArray(outerRing, hole)) {
        // the hole is contained push it into our polygon
        outerRings[x].push(hole);
        intersects = true;
        break;
      }
    }

    if (!intersects) {
      outerRings.push([hole.reverse()]);
    }
  }

  if (outerRings.length === 1) {
    return {
      type: 'Polygon',
      coordinates: outerRings[0]
    };
  } else {
    return {
      type: 'MultiPolygon',
      coordinates: outerRings
    };
  }
}

// This function ensures that rings are oriented in the right directions
// outer rings are clockwise, holes are counterclockwise
// used for converting GeoJSON Polygons to ArcGIS Polygons
function orientRings (poly) {
  var output = [];
  var polygon = poly.slice(0);
  var outerRing = closeRing(polygon.shift().slice(0));
  if (outerRing.length >= 4) {
    if (!ringIsClockwise(outerRing)) {
      outerRing.reverse();
    }

    output.push(outerRing);

    for (var i = 0; i < polygon.length; i++) {
      var hole = closeRing(polygon[i].slice(0));
      if (hole.length >= 4) {
        if (ringIsClockwise(hole)) {
          hole.reverse();
        }
        output.push(hole);
      }
    }
  }

  return output;
}

// This function flattens holes in multipolygons to one array of polygons
// used for converting GeoJSON Polygons to ArcGIS Polygons
function flattenMultiPolygonRings (rings) {
  var output = [];
  for (var i = 0; i < rings.length; i++) {
    var polygon = orientRings(rings[i]);
    for (var x = polygon.length - 1; x >= 0; x--) {
      var ring = polygon[x].slice(0);
      output.push(ring);
    }
  }
  return output;
}

// shallow object clone for feature properties and attributes
// from http://jsperf.com/cloning-an-object/2
function shallowClone (obj) {
  var target = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      target[i] = obj[i];
    }
  }
  return target;
}

function getId (attributes, idAttribute) {
  var keys = idAttribute ? [idAttribute, 'OBJECTID', 'FID'] : ['OBJECTID', 'FID'];
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (
      key in attributes &&
      (typeof attributes[key] === 'string' ||
        typeof attributes[key] === 'number')
    ) {
      return attributes[key];
    }
  }
  throw Error('No valid id attribute found');
}

function arcgisToGeoJSON (arcgis, idAttribute) {
  var geojson = {};

  if (typeof arcgis.x === 'number' && typeof arcgis.y === 'number') {
    geojson.type = 'Point';
    geojson.coordinates = [arcgis.x, arcgis.y];
    if (typeof arcgis.z === 'number') {
      geojson.coordinates.push(arcgis.z);
    }
  }

  if (arcgis.points) {
    geojson.type = 'MultiPoint';
    geojson.coordinates = arcgis.points.slice(0);
  }

  if (arcgis.paths) {
    if (arcgis.paths.length === 1) {
      geojson.type = 'LineString';
      geojson.coordinates = arcgis.paths[0].slice(0);
    } else {
      geojson.type = 'MultiLineString';
      geojson.coordinates = arcgis.paths.slice(0);
    }
  }

  if (arcgis.rings) {
    geojson = convertRingsToGeoJSON(arcgis.rings.slice(0));
  }

  if (arcgis.geometry || arcgis.attributes) {
    geojson.type = 'Feature';
    geojson.geometry = (arcgis.geometry) ? arcgisToGeoJSON(arcgis.geometry) : null;
    geojson.properties = (arcgis.attributes) ? shallowClone(arcgis.attributes) : null;
    if (arcgis.attributes) {
      try {
        geojson.id = getId(arcgis.attributes, idAttribute);
      } catch (err) {
        // don't set an id
      }
    }
  }

  // if no valid geometry was encountered
  if (JSON.stringify(geojson.geometry) === JSON.stringify({})) {
    geojson.geometry = null;
  }

  if (
    arcgis.spatialReference &&
    arcgis.spatialReference.wkid &&
    arcgis.spatialReference.wkid !== 4326
  ) {
    console.warn('Object converted in non-standard crs - ' + JSON.stringify(arcgis.spatialReference));
  }

  return geojson;
}

function geojsonToArcGIS (geojson, idAttribute) {
  idAttribute = idAttribute || 'OBJECTID';
  var spatialReference = { wkid: 4326 };
  var result = {};
  var i;

  switch (geojson.type) {
    case 'Point':
      result.x = geojson.coordinates[0];
      result.y = geojson.coordinates[1];
      result.spatialReference = spatialReference;
      break;
    case 'MultiPoint':
      result.points = geojson.coordinates.slice(0);
      result.spatialReference = spatialReference;
      break;
    case 'LineString':
      result.paths = [geojson.coordinates.slice(0)];
      result.spatialReference = spatialReference;
      break;
    case 'MultiLineString':
      result.paths = geojson.coordinates.slice(0);
      result.spatialReference = spatialReference;
      break;
    case 'Polygon':
      result.rings = orientRings(geojson.coordinates.slice(0));
      result.spatialReference = spatialReference;
      break;
    case 'MultiPolygon':
      result.rings = flattenMultiPolygonRings(geojson.coordinates.slice(0));
      result.spatialReference = spatialReference;
      break;
    case 'Feature':
      if (geojson.geometry) {
        result.geometry = geojsonToArcGIS(geojson.geometry, idAttribute);
      }
      result.attributes = (geojson.properties) ? shallowClone(geojson.properties) : {};
      if (geojson.id) {
        result.attributes[idAttribute] = geojson.id;
      }
      break;
    case 'FeatureCollection':
      result = [];
      for (i = 0; i < geojson.features.length; i++) {
        result.push(geojsonToArcGIS(geojson.features[i], idAttribute));
      }
      break;
    case 'GeometryCollection':
      result = [];
      for (i = 0; i < geojson.geometries.length; i++) {
        result.push(geojsonToArcGIS(geojson.geometries[i], idAttribute));
      }
      break;
  }

  return result;
}

function geojsonToArcGIS$1 (geojson, idAttr) {
  return geojsonToArcGIS(geojson, idAttr);
}

function arcgisToGeoJSON$1 (arcgis, idAttr) {
  return arcgisToGeoJSON(arcgis, idAttr);
}

// convert an extent (ArcGIS) to LatLngBounds (Leaflet)
function extentToBounds (extent) {
  // "NaN" coordinates from ArcGIS Server indicate a null geometry
  if (extent.xmin !== 'NaN' && extent.ymin !== 'NaN' && extent.xmax !== 'NaN' && extent.ymax !== 'NaN') {
    var sw = leaflet.latLng(extent.ymin, extent.xmin);
    var ne = leaflet.latLng(extent.ymax, extent.xmax);
    return leaflet.latLngBounds(sw, ne);
  } else {
    return null;
  }
}

// convert an LatLngBounds (Leaflet) to extent (ArcGIS)
function boundsToExtent (bounds) {
  bounds = leaflet.latLngBounds(bounds);
  return {
    'xmin': bounds.getSouthWest().lng,
    'ymin': bounds.getSouthWest().lat,
    'xmax': bounds.getNorthEast().lng,
    'ymax': bounds.getNorthEast().lat,
    'spatialReference': {
      'wkid': 4326
    }
  };
}

var knownFieldNames = /^(OBJECTID|FID|OID|ID)$/i;

// Attempts to find the ID Field from response
function _findIdAttributeFromResponse (response) {
  var result;

  if (response.objectIdFieldName) {
    // Find Id Field directly
    result = response.objectIdFieldName;
  } else if (response.fields) {
    // Find ID Field based on field type
    for (var j = 0; j <= response.fields.length - 1; j++) {
      if (response.fields[j].type === 'esriFieldTypeOID') {
        result = response.fields[j].name;
        break;
      }
    }
    if (!result) {
      // If no field was marked as being the esriFieldTypeOID try well known field names
      for (j = 0; j <= response.fields.length - 1; j++) {
        if (response.fields[j].name.match(knownFieldNames)) {
          result = response.fields[j].name;
          break;
        }
      }
    }
  }
  return result;
}

// This is the 'last' resort, find the Id field from the specified feature
function _findIdAttributeFromFeature (feature) {
  for (var key in feature.attributes) {
    if (key.match(knownFieldNames)) {
      return key;
    }
  }
}

function responseToFeatureCollection (response, idAttribute) {
  var objectIdField;
  var features = response.features || response.results;
  var count = features.length;

  if (idAttribute) {
    objectIdField = idAttribute;
  } else {
    objectIdField = _findIdAttributeFromResponse(response);
  }

  var featureCollection = {
    type: 'FeatureCollection',
    features: []
  };

  if (count) {
    for (var i = features.length - 1; i >= 0; i--) {
      var feature = arcgisToGeoJSON$1(features[i], objectIdField || _findIdAttributeFromFeature(features[i]));
      featureCollection.features.push(feature);
    }
  }

  return featureCollection;
}

  // trim url whitespace and add a trailing slash if needed
function cleanUrl (url) {
  // trim leading and trailing spaces, but not spaces inside the url
  url = leaflet.Util.trim(url);

  // add a trailing slash to the url if the user omitted it
  if (url[url.length - 1] !== '/') {
    url += '/';
  }

  return url;
}

/* Extract url params if any and store them in requestParams attribute.
   Return the options params updated */
function getUrlParams (options$$1) {
  if (options$$1.url.indexOf('?') !== -1) {
    options$$1.requestParams = options$$1.requestParams || {};
    var queryString = options$$1.url.substring(options$$1.url.indexOf('?') + 1);
    options$$1.url = options$$1.url.split('?')[0];
    options$$1.requestParams = JSON.parse('{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
  }
  options$$1.url = cleanUrl(options$$1.url.split('?')[0]);
  return options$$1;
}

function isArcgisOnline (url) {
  /* hosted feature services support geojson as an output format
  utility.arcgis.com services are proxied from a variety of ArcGIS Server vintages, and may not */
  return (/^(?!.*utility\.arcgis\.com).*\.arcgis\.com.*FeatureServer/i).test(url);
}

function geojsonTypeToArcGIS (geoJsonType) {
  var arcgisGeometryType;
  switch (geoJsonType) {
    case 'Point':
      arcgisGeometryType = 'esriGeometryPoint';
      break;
    case 'MultiPoint':
      arcgisGeometryType = 'esriGeometryMultipoint';
      break;
    case 'LineString':
      arcgisGeometryType = 'esriGeometryPolyline';
      break;
    case 'MultiLineString':
      arcgisGeometryType = 'esriGeometryPolyline';
      break;
    case 'Polygon':
      arcgisGeometryType = 'esriGeometryPolygon';
      break;
    case 'MultiPolygon':
      arcgisGeometryType = 'esriGeometryPolygon';
      break;
  }

  return arcgisGeometryType;
}

function warn () {
  if (console && console.warn) {
    console.warn.apply(console, arguments);
  }
}

function calcAttributionWidth (map) {
  // either crop at 55px or user defined buffer
  return (map.getSize().x - options.attributionWidthOffset) + 'px';
}

function setEsriAttribution (map) {
  if (map.attributionControl && !map.attributionControl._esriAttributionAdded) {
    map.attributionControl.setPrefix('<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | Powered by <a href="https://www.esri.com">Esri</a>');

    var hoverAttributionStyle = document.createElement('style');
    hoverAttributionStyle.type = 'text/css';
    hoverAttributionStyle.innerHTML = '.esri-truncated-attribution:hover {' +
      'white-space: normal;' +
    '}';

    document.getElementsByTagName('head')[0].appendChild(hoverAttributionStyle);
    leaflet.DomUtil.addClass(map.attributionControl._container, 'esri-truncated-attribution:hover');

    // define a new css class in JS to trim attribution into a single line
    var attributionStyle = document.createElement('style');
    attributionStyle.type = 'text/css';
    attributionStyle.innerHTML = '.esri-truncated-attribution {' +
      'vertical-align: -3px;' +
      'white-space: nowrap;' +
      'overflow: hidden;' +
      'text-overflow: ellipsis;' +
      'display: inline-block;' +
      'transition: 0s white-space;' +
      'transition-delay: 1s;' +
      'max-width: ' + calcAttributionWidth(map) + ';' +
    '}';

    document.getElementsByTagName('head')[0].appendChild(attributionStyle);
    leaflet.DomUtil.addClass(map.attributionControl._container, 'esri-truncated-attribution');

    // update the width used to truncate when the map itself is resized
    map.on('resize', function (e) {
      map.attributionControl._container.style.maxWidth = calcAttributionWidth(e.target);
    });

    // remove injected scripts and style tags
    map.on('unload', function () {
      hoverAttributionStyle.parentNode.removeChild(hoverAttributionStyle);
      attributionStyle.parentNode.removeChild(attributionStyle);
      var nodeList = document.querySelectorAll('.esri-leaflet-jsonp');
      for (var i = 0; i < nodeList.length; i++) {
        nodeList.item(i).parentNode.removeChild(nodeList.item(i));
      }
    });

    map.attributionControl._esriAttributionAdded = true;
  }
}

function _setGeometry (geometry) {
  var params = {
    geometry: null,
    geometryType: null
  };

  // convert bounds to extent and finish
  if (geometry instanceof leaflet.LatLngBounds) {
    // set geometry + geometryType
    params.geometry = boundsToExtent(geometry);
    params.geometryType = 'esriGeometryEnvelope';
    return params;
  }

  // convert L.Marker > L.LatLng
  if (geometry.getLatLng) {
    geometry = geometry.getLatLng();
  }

  // convert L.LatLng to a geojson point and continue;
  if (geometry instanceof leaflet.LatLng) {
    geometry = {
      type: 'Point',
      coordinates: [geometry.lng, geometry.lat]
    };
  }

  // handle L.GeoJSON, pull out the first geometry
  if (geometry instanceof leaflet.GeoJSON) {
    // reassign geometry to the GeoJSON value  (we are assuming that only one feature is present)
    geometry = geometry.getLayers()[0].feature.geometry;
    params.geometry = geojsonToArcGIS$1(geometry);
    params.geometryType = geojsonTypeToArcGIS(geometry.type);
  }

  // Handle L.Polyline and L.Polygon
  if (geometry.toGeoJSON) {
    geometry = geometry.toGeoJSON();
  }

  // handle GeoJSON feature by pulling out the geometry
  if (geometry.type === 'Feature') {
    // get the geometry of the geojson feature
    geometry = geometry.geometry;
  }

  // confirm that our GeoJSON is a point, line or polygon
  if (geometry.type === 'Point' || geometry.type === 'LineString' || geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
    params.geometry = geojsonToArcGIS$1(geometry);
    params.geometryType = geojsonTypeToArcGIS(geometry.type);
    return params;
  }

  // warn the user if we havn't found an appropriate object
  warn('invalid geometry passed to spatial query. Should be L.LatLng, L.LatLngBounds, L.Marker or a GeoJSON Point, Line, Polygon or MultiPolygon object');

  return;
}

function _getAttributionData (url, map) {
  jsonp(url, {}, leaflet.Util.bind(function (error, attributions) {
    if (error) { return; }
    map._esriAttributions = [];
    for (var c = 0; c < attributions.contributors.length; c++) {
      var contributor = attributions.contributors[c];

      for (var i = 0; i < contributor.coverageAreas.length; i++) {
        var coverageArea = contributor.coverageAreas[i];
        var southWest = leaflet.latLng(coverageArea.bbox[0], coverageArea.bbox[1]);
        var northEast = leaflet.latLng(coverageArea.bbox[2], coverageArea.bbox[3]);
        map._esriAttributions.push({
          attribution: contributor.attribution,
          score: coverageArea.score,
          bounds: leaflet.latLngBounds(southWest, northEast),
          minZoom: coverageArea.zoomMin,
          maxZoom: coverageArea.zoomMax
        });
      }
    }

    map._esriAttributions.sort(function (a, b) {
      return b.score - a.score;
    });

    // pass the same argument as the map's 'moveend' event
    var obj = { target: map };
    _updateMapAttribution(obj);
  }, this));
}

function _updateMapAttribution (evt) {
  var map = evt.target;
  var oldAttributions = map._esriAttributions;

  if (map && map.attributionControl && oldAttributions) {
    var newAttributions = '';
    var bounds = map.getBounds();
    var wrappedBounds = leaflet.latLngBounds(
      bounds.getSouthWest().wrap(),
      bounds.getNorthEast().wrap()
    );
    var zoom = map.getZoom();

    for (var i = 0; i < oldAttributions.length; i++) {
      var attribution = oldAttributions[i];
      var text = attribution.attribution;

      if (!newAttributions.match(text) && attribution.bounds.intersects(wrappedBounds) && zoom >= attribution.minZoom && zoom <= attribution.maxZoom) {
        newAttributions += (', ' + text);
      }
    }

    newAttributions = newAttributions.substr(2);
    var attributionElement = map.attributionControl._container.querySelector('.esri-dynamic-attribution');

    attributionElement.innerHTML = newAttributions;
    attributionElement.style.maxWidth = calcAttributionWidth(map);

    map.fire('attributionupdated', {
      attribution: newAttributions
    });
  }
}

var EsriUtil = {
  warn: warn,
  cleanUrl: cleanUrl,
  getUrlParams: getUrlParams,
  isArcgisOnline: isArcgisOnline,
  geojsonTypeToArcGIS: geojsonTypeToArcGIS,
  responseToFeatureCollection: responseToFeatureCollection,
  geojsonToArcGIS: geojsonToArcGIS$1,
  arcgisToGeoJSON: arcgisToGeoJSON$1,
  boundsToExtent: boundsToExtent,
  extentToBounds: extentToBounds,
  calcAttributionWidth: calcAttributionWidth,
  setEsriAttribution: setEsriAttribution,
  _setGeometry: _setGeometry,
  _getAttributionData: _getAttributionData,
  _updateMapAttribution: _updateMapAttribution,
  _findIdAttributeFromFeature: _findIdAttributeFromFeature,
  _findIdAttributeFromResponse: _findIdAttributeFromResponse
};

var Task = leaflet.Class.extend({

  options: {
    proxy: false,
    useCors: cors
  },

  // Generate a method for each methodName:paramName in the setters for this task.
  generateSetter: function (param, context) {
    return leaflet.Util.bind(function (value) {
      this.params[param] = value;
      return this;
    }, context);
  },

  initialize: function (endpoint) {
    // endpoint can be either a url (and options) for an ArcGIS Rest Service or an instance of EsriLeaflet.Service
    if (endpoint.request && endpoint.options) {
      this._service = endpoint;
      leaflet.Util.setOptions(this, endpoint.options);
    } else {
      leaflet.Util.setOptions(this, endpoint);
      this.options.url = cleanUrl(endpoint.url);
    }

    // clone default params into this object
    this.params = leaflet.Util.extend({}, this.params || {});

    // generate setter methods based on the setters object implimented a child class
    if (this.setters) {
      for (var setter in this.setters) {
        var param = this.setters[setter];
        this[setter] = this.generateSetter(param, this);
      }
    }
  },

  token: function (token) {
    if (this._service) {
      this._service.authenticate(token);
    } else {
      this.params.token = token;
    }
    return this;
  },

  // ArcGIS Server Find/Identify 10.5+
  format: function (boolean) {
    // use double negative to expose a more intuitive positive method name
    this.params.returnUnformattedValues = !boolean;
    return this;
  },

  request: function (callback, context) {
    if (this.options.requestParams) {
      leaflet.Util.extend(this.params, this.options.requestParams);
    }
    if (this._service) {
      return this._service.request(this.path, this.params, callback, context);
    }

    return this._request('request', this.path, this.params, callback, context);
  },

  _request: function (method, path, params, callback, context) {
    var url = (this.options.proxy) ? this.options.proxy + '?' + this.options.url + path : this.options.url + path;

    if ((method === 'get' || method === 'request') && !this.options.useCors) {
      return Request.get.JSONP(url, params, callback, context);
    }

    return Request[method](url, params, callback, context);
  }
});

function task (options) {
  options = getUrlParams(options);
  return new Task(options);
}

var Query = Task.extend({
  setters: {
    'offset': 'resultOffset',
    'limit': 'resultRecordCount',
    'fields': 'outFields',
    'precision': 'geometryPrecision',
    'featureIds': 'objectIds',
    'returnGeometry': 'returnGeometry',
    'returnM': 'returnM',
    'transform': 'datumTransformation',
    'token': 'token'
  },

  path: 'query',

  params: {
    returnGeometry: true,
    where: '1=1',
    outSr: 4326,
    outFields: '*'
  },

  // Returns a feature if its shape is wholly contained within the search geometry. Valid for all shape type combinations.
  within: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelContains'; // to the REST api this reads geometry **contains** layer
    return this;
  },

  // Returns a feature if any spatial relationship is found. Applies to all shape type combinations.
  intersects: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelIntersects';
    return this;
  },

  // Returns a feature if its shape wholly contains the search geometry. Valid for all shape type combinations.
  contains: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelWithin'; // to the REST api this reads geometry **within** layer
    return this;
  },

  // Returns a feature if the intersection of the interiors of the two shapes is not empty and has a lower dimension than the maximum dimension of the two shapes. Two lines that share an endpoint in common do not cross. Valid for Line/Line, Line/Area, Multi-point/Area, and Multi-point/Line shape type combinations.
  crosses: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelCrosses';
    return this;
  },

  // Returns a feature if the two shapes share a common boundary. However, the intersection of the interiors of the two shapes must be empty. In the Point/Line case, the point may touch an endpoint only of the line. Applies to all combinations except Point/Point.
  touches: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelTouches';
    return this;
  },

  // Returns a feature if the intersection of the two shapes results in an object of the same dimension, but different from both of the shapes. Applies to Area/Area, Line/Line, and Multi-point/Multi-point shape type combinations.
  overlaps: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelOverlaps';
    return this;
  },

  // Returns a feature if the envelope of the two shapes intersects.
  bboxIntersects: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelEnvelopeIntersects';
    return this;
  },

  // if someone can help decipher the ArcObjects explanation and translate to plain speak, we should mention this method in the doc
  indexIntersects: function (geometry) {
    this._setGeometryParams(geometry);
    this.params.spatialRel = 'esriSpatialRelIndexIntersects'; // Returns a feature if the envelope of the query geometry intersects the index entry for the target geometry
    return this;
  },

  // only valid for Feature Services running on ArcGIS Server 10.3+ or ArcGIS Online
  nearby: function (latlng, radius) {
    latlng = leaflet.latLng(latlng);
    this.params.geometry = [latlng.lng, latlng.lat];
    this.params.geometryType = 'esriGeometryPoint';
    this.params.spatialRel = 'esriSpatialRelIntersects';
    this.params.units = 'esriSRUnit_Meter';
    this.params.distance = radius;
    this.params.inSr = 4326;
    return this;
  },

  where: function (string) {
    // instead of converting double-quotes to single quotes, pass as is, and provide a more informative message if a 400 is encountered
    this.params.where = string;
    return this;
  },

  between: function (start, end) {
    this.params.time = [start.valueOf(), end.valueOf()];
    return this;
  },

  simplify: function (map, factor) {
    var mapWidth = Math.abs(map.getBounds().getWest() - map.getBounds().getEast());
    this.params.maxAllowableOffset = (mapWidth / map.getSize().y) * factor;
    return this;
  },

  orderBy: function (fieldName, order) {
    order = order || 'ASC';
    this.params.orderByFields = (this.params.orderByFields) ? this.params.orderByFields + ',' : '';
    this.params.orderByFields += ([fieldName, order]).join(' ');
    return this;
  },

  run: function (callback, context) {
    this._cleanParams();

    // services hosted on ArcGIS Online and ArcGIS Server 10.3.1+ support requesting geojson directly
    if (this.options.isModern || isArcgisOnline(this.options.url)) {
      this.params.f = 'geojson';

      return this.request(function (error, response) {
        this._trapSQLerrors(error);
        callback.call(context, error, response, response);
      }, this);

    // otherwise convert it in the callback then pass it on
    } else {
      return this.request(function (error, response) {
        this._trapSQLerrors(error);
        callback.call(context, error, (response && responseToFeatureCollection(response)), response);
      }, this);
    }
  },

  count: function (callback, context) {
    this._cleanParams();
    this.params.returnCountOnly = true;
    return this.request(function (error, response) {
      callback.call(this, error, (response && response.count), response);
    }, context);
  },

  ids: function (callback, context) {
    this._cleanParams();
    this.params.returnIdsOnly = true;
    return this.request(function (error, response) {
      callback.call(this, error, (response && response.objectIds), response);
    }, context);
  },

  // only valid for Feature Services running on ArcGIS Server 10.3+ or ArcGIS Online
  bounds: function (callback, context) {
    this._cleanParams();
    this.params.returnExtentOnly = true;
    return this.request(function (error, response) {
      if (response && response.extent && extentToBounds(response.extent)) {
        callback.call(context, error, extentToBounds(response.extent), response);
      } else {
        error = {
          message: 'Invalid Bounds'
        };
        callback.call(context, error, null, response);
      }
    }, context);
  },

  distinct: function () {
    // geometry must be omitted for queries requesting distinct values
    this.params.returnGeometry = false;
    this.params.returnDistinctValues = true;
    return this;
  },

  // only valid for image services
  pixelSize: function (rawPoint) {
    var castPoint = leaflet.point(rawPoint);
    this.params.pixelSize = [castPoint.x, castPoint.y];
    return this;
  },

  // only valid for map services
  layer: function (layer) {
    this.path = layer + '/query';
    return this;
  },

  _trapSQLerrors: function (error) {
    if (error) {
      if (error.code === '400') {
        warn('one common syntax error in query requests is encasing string values in double quotes instead of single quotes');
      }
    }
  },

  _cleanParams: function () {
    delete this.params.returnIdsOnly;
    delete this.params.returnExtentOnly;
    delete this.params.returnCountOnly;
  },

  _setGeometryParams: function (geometry) {
    this.params.inSr = 4326;
    var converted = _setGeometry(geometry);
    this.params.geometry = converted.geometry;
    this.params.geometryType = converted.geometryType;
  }

});

function query (options) {
  return new Query(options);
}

var Find = Task.extend({
  setters: {
    // method name > param name
    'contains': 'contains',
    'text': 'searchText',
    'fields': 'searchFields', // denote an array or single string
    'spatialReference': 'sr',
    'sr': 'sr',
    'layers': 'layers',
    'returnGeometry': 'returnGeometry',
    'maxAllowableOffset': 'maxAllowableOffset',
    'precision': 'geometryPrecision',
    'dynamicLayers': 'dynamicLayers',
    'returnZ': 'returnZ',
    'returnM': 'returnM',
    'gdbVersion': 'gdbVersion',
    // skipped implementing this (for now) because the REST service implementation isnt consistent between operations
    // 'transform': 'datumTransformations',
    'token': 'token'
  },

  path: 'find',

  params: {
    sr: 4326,
    contains: true,
    returnGeometry: true,
    returnZ: true,
    returnM: false
  },

  layerDefs: function (id, where) {
    this.params.layerDefs = (this.params.layerDefs) ? this.params.layerDefs + ';' : '';
    this.params.layerDefs += ([id, where]).join(':');
    return this;
  },

  simplify: function (map, factor) {
    var mapWidth = Math.abs(map.getBounds().getWest() - map.getBounds().getEast());
    this.params.maxAllowableOffset = (mapWidth / map.getSize().y) * factor;
    return this;
  },

  run: function (callback, context) {
    return this.request(function (error, response) {
      callback.call(context, error, (response && responseToFeatureCollection(response)), response);
    }, context);
  }
});

function find (options) {
  return new Find(options);
}

var Identify = Task.extend({
  path: 'identify',

  between: function (start, end) {
    this.params.time = [start.valueOf(), end.valueOf()];
    return this;
  }
});

function identify (options) {
  return new Identify(options);
}

var IdentifyFeatures = Identify.extend({
  setters: {
    'layers': 'layers',
    'precision': 'geometryPrecision',
    'tolerance': 'tolerance',
    // skipped implementing this (for now) because the REST service implementation isnt consistent between operations.
    // 'transform': 'datumTransformations'
    'returnGeometry': 'returnGeometry'
  },

  params: {
    sr: 4326,
    layers: 'all',
    tolerance: 3,
    returnGeometry: true
  },

  on: function (map) {
    var extent = boundsToExtent(map.getBounds());
    var size = map.getSize();
    this.params.imageDisplay = [size.x, size.y, 96];
    this.params.mapExtent = [extent.xmin, extent.ymin, extent.xmax, extent.ymax];
    return this;
  },

  at: function (geometry) {
    // cast lat, long pairs in raw array form manually
    if (geometry.length === 2) {
      geometry = leaflet.latLng(geometry);
    }
    this._setGeometryParams(geometry);
    return this;
  },

  layerDef: function (id, where) {
    this.params.layerDefs = (this.params.layerDefs) ? this.params.layerDefs + ';' : '';
    this.params.layerDefs += ([id, where]).join(':');
    return this;
  },

  simplify: function (map, factor) {
    var mapWidth = Math.abs(map.getBounds().getWest() - map.getBounds().getEast());
    this.params.maxAllowableOffset = (mapWidth / map.getSize().y) * factor;
    return this;
  },

  run: function (callback, context) {
    return this.request(function (error, response) {
      // immediately invoke with an error
      if (error) {
        callback.call(context, error, undefined, response);
        return;

      // ok no error lets just assume we have features...
      } else {
        var featureCollection = responseToFeatureCollection(response);
        response.results = response.results.reverse();
        for (var i = 0; i < featureCollection.features.length; i++) {
          var feature = featureCollection.features[i];
          feature.layerId = response.results[i].layerId;
        }
        callback.call(context, undefined, featureCollection, response);
      }
    });
  },

  _setGeometryParams: function (geometry) {
    var converted = _setGeometry(geometry);
    this.params.geometry = converted.geometry;
    this.params.geometryType = converted.geometryType;
  }
});

function identifyFeatures (options) {
  return new IdentifyFeatures(options);
}

var IdentifyImage = Identify.extend({
  setters: {
    'setMosaicRule': 'mosaicRule',
    'setRenderingRule': 'renderingRule',
    'setPixelSize': 'pixelSize',
    'returnCatalogItems': 'returnCatalogItems',
    'returnGeometry': 'returnGeometry'
  },

  params: {
    returnGeometry: false
  },

  at: function (latlng) {
    latlng = leaflet.latLng(latlng);
    this.params.geometry = JSON.stringify({
      x: latlng.lng,
      y: latlng.lat,
      spatialReference: {
        wkid: 4326
      }
    });
    this.params.geometryType = 'esriGeometryPoint';
    return this;
  },

  getMosaicRule: function () {
    return this.params.mosaicRule;
  },

  getRenderingRule: function () {
    return this.params.renderingRule;
  },

  getPixelSize: function () {
    return this.params.pixelSize;
  },

  run: function (callback, context) {
    return this.request(function (error, response) {
      callback.call(context, error, (response && this._responseToGeoJSON(response)), response);
    }, this);
  },

  // get pixel data and return as geoJSON point
  // populate catalog items (if any)
  // merging in any catalogItemVisibilities as a propery of each feature
  _responseToGeoJSON: function (response) {
    var location = response.location;
    var catalogItems = response.catalogItems;
    var catalogItemVisibilities = response.catalogItemVisibilities;
    var geoJSON = {
      'pixel': {
        'type': 'Feature',
        'geometry': {
          'type': 'Point',
          'coordinates': [location.x, location.y]
        },
        'crs': {
          'type': 'EPSG',
          'properties': {
            'code': location.spatialReference.wkid
          }
        },
        'properties': {
          'OBJECTID': response.objectId,
          'name': response.name,
          'value': response.value
        },
        'id': response.objectId
      }
    };

    if (response.properties && response.properties.Values) {
      geoJSON.pixel.properties.values = response.properties.Values;
    }

    if (catalogItems && catalogItems.features) {
      geoJSON.catalogItems = responseToFeatureCollection(catalogItems);
      if (catalogItemVisibilities && catalogItemVisibilities.length === geoJSON.catalogItems.features.length) {
        for (var i = catalogItemVisibilities.length - 1; i >= 0; i--) {
          geoJSON.catalogItems.features[i].properties.catalogItemVisibility = catalogItemVisibilities[i];
        }
      }
    }
    return geoJSON;
  }

});

function identifyImage (params) {
  return new IdentifyImage(params);
}

var Service = leaflet.Evented.extend({

  options: {
    proxy: false,
    useCors: cors,
    timeout: 0
  },

  initialize: function (options) {
    options = options || {};
    this._requestQueue = [];
    this._authenticating = false;
    leaflet.Util.setOptions(this, options);
    this.options.url = cleanUrl(this.options.url);
  },

  get: function (path, params, callback, context) {
    return this._request('get', path, params, callback, context);
  },

  post: function (path, params, callback, context) {
    return this._request('post', path, params, callback, context);
  },

  request: function (path, params, callback, context) {
    return this._request('request', path, params, callback, context);
  },

  metadata: function (callback, context) {
    return this._request('get', '', {}, callback, context);
  },

  authenticate: function (token) {
    this._authenticating = false;
    this.options.token = token;
    this._runQueue();
    return this;
  },

  getTimeout: function () {
    return this.options.timeout;
  },

  setTimeout: function (timeout) {
    this.options.timeout = timeout;
  },

  _request: function (method, path, params, callback, context) {
    this.fire('requeststart', {
      url: this.options.url + path,
      params: params,
      method: method
    }, true);

    var wrappedCallback = this._createServiceCallback(method, path, params, callback, context);

    if (this.options.token) {
      params.token = this.options.token;
    }
    if (this.options.requestParams) {
      leaflet.Util.extend(params, this.options.requestParams);
    }
    if (this._authenticating) {
      this._requestQueue.push([method, path, params, callback, context]);
      return;
    } else {
      var url = (this.options.proxy) ? this.options.proxy + '?' + this.options.url + path : this.options.url + path;

      if ((method === 'get' || method === 'request') && !this.options.useCors) {
        return Request.get.JSONP(url, params, wrappedCallback, context);
      } else {
        return Request[method](url, params, wrappedCallback, context);
      }
    }
  },

  _createServiceCallback: function (method, path, params, callback, context) {
    return leaflet.Util.bind(function (error, response) {
      if (error && (error.code === 499 || error.code === 498)) {
        this._authenticating = true;

        this._requestQueue.push([method, path, params, callback, context]);

        // fire an event for users to handle and re-authenticate
        this.fire('authenticationrequired', {
          authenticate: leaflet.Util.bind(this.authenticate, this)
        }, true);

        // if the user has access to a callback they can handle the auth error
        error.authenticate = leaflet.Util.bind(this.authenticate, this);
      }

      callback.call(context, error, response);

      if (error) {
        this.fire('requesterror', {
          url: this.options.url + path,
          params: params,
          message: error.message,
          code: error.code,
          method: method
        }, true);
      } else {
        this.fire('requestsuccess', {
          url: this.options.url + path,
          params: params,
          response: response,
          method: method
        }, true);
      }

      this.fire('requestend', {
        url: this.options.url + path,
        params: params,
        method: method
      }, true);
    }, this);
  },

  _runQueue: function () {
    for (var i = this._requestQueue.length - 1; i >= 0; i--) {
      var request$$1 = this._requestQueue[i];
      var method = request$$1.shift();
      this[method].apply(this, request$$1);
    }
    this._requestQueue = [];
  }
});

function service (options) {
  options = getUrlParams(options);
  return new Service(options);
}

var MapService = Service.extend({

  identify: function () {
    return identifyFeatures(this);
  },

  find: function () {
    return find(this);
  },

  query: function () {
    return query(this);
  }

});

function mapService (options) {
  return new MapService(options);
}

var ImageService = Service.extend({

  query: function () {
    return query(this);
  },

  identify: function () {
    return identifyImage(this);
  }
});

function imageService (options) {
  return new ImageService(options);
}

var FeatureLayerService = Service.extend({

  options: {
    idAttribute: 'OBJECTID'
  },

  query: function () {
    return query(this);
  },

  addFeature: function (feature, callback, context) {
    delete feature.id;

    feature = geojsonToArcGIS$1(feature);

    return this.post('addFeatures', {
      features: [feature]
    }, function (error, response) {
      var result = (response && response.addResults) ? response.addResults[0] : undefined;
      if (callback) {
        callback.call(context, error || response.addResults[0].error, result);
      }
    }, context);
  },

  updateFeature: function (feature, callback, context) {
    feature = geojsonToArcGIS$1(feature, this.options.idAttribute);

    return this.post('updateFeatures', {
      features: [feature]
    }, function (error, response) {
      var result = (response && response.updateResults) ? response.updateResults[0] : undefined;
      if (callback) {
        callback.call(context, error || response.updateResults[0].error, result);
      }
    }, context);
  },

  deleteFeature: function (id, callback, context) {
    return this.post('deleteFeatures', {
      objectIds: id
    }, function (error, response) {
      var result = (response && response.deleteResults) ? response.deleteResults[0] : undefined;
      if (callback) {
        callback.call(context, error || response.deleteResults[0].error, result);
      }
    }, context);
  },

  deleteFeatures: function (ids, callback, context) {
    return this.post('deleteFeatures', {
      objectIds: ids
    }, function (error, response) {
      // pass back the entire array
      var result = (response && response.deleteResults) ? response.deleteResults : undefined;
      if (callback) {
        callback.call(context, error || response.deleteResults[0].error, result);
      }
    }, context);
  }
});

function featureLayerService (options) {
  return new FeatureLayerService(options);
}

var tileProtocol = (window.location.protocol !== 'https:') ? 'http:' : 'https:';

var BasemapLayer = leaflet.TileLayer.extend({
  statics: {
    TILES: {
      Streets: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 19,
          subdomains: ['server', 'services'],
          attribution: 'USGS, NOAA',
          attributionUrl: 'https://static.arcgis.com/attribution/World_Street_Map'
        }
      },
      Topographic: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 19,
          subdomains: ['server', 'services'],
          attribution: 'USGS, NOAA',
          attributionUrl: 'https://static.arcgis.com/attribution/World_Topo_Map'
        }
      },
      Oceans: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 16,
          subdomains: ['server', 'services'],
          attribution: 'USGS, NOAA',
          attributionUrl: 'https://static.arcgis.com/attribution/Ocean_Basemap'
        }
      },
      OceansLabels: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Reference/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 16,
          subdomains: ['server', 'services'],
          pane: (pointerEvents) ? 'esri-labels' : 'tilePane'
        }
      },
      NationalGeographic: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 16,
          subdomains: ['server', 'services'],
          attribution: 'National Geographic, DeLorme, HERE, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, increment P Corp.'
        }
      },
      DarkGray: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 16,
          subdomains: ['server', 'services'],
          attribution: 'HERE, DeLorme, MapmyIndia, &copy; OpenStreetMap contributors'
        }
      },
      DarkGrayLabels: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 16,
          subdomains: ['server', 'services'],
          pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
          attribution: ''

        }
      },
      Gray: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 16,
          subdomains: ['server', 'services'],
          attribution: 'HERE, DeLorme, MapmyIndia, &copy; OpenStreetMap contributors'
        }
      },
      GrayLabels: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 16,
          subdomains: ['server', 'services'],
          pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
          attribution: ''
        }
      },
      Imagery: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 19,
          subdomains: ['server', 'services'],
          attribution: 'DigitalGlobe, GeoEye, i-cubed, USDA, USGS, AEX, Getmapping, Aerogrid, IGN, IGP, swisstopo, and the GIS User Community',
          attributionUrl: 'https://static.arcgis.com/attribution/World_Imagery'
        }
      },
      ImageryLabels: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 19,
          subdomains: ['server', 'services'],
          pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
          attribution: ''
        }
      },
      ImageryTransportation: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 19,
          subdomains: ['server', 'services'],
          pane: (pointerEvents) ? 'esri-labels' : 'tilePane'
        }
      },
      ShadedRelief: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 13,
          subdomains: ['server', 'services'],
          attribution: 'USGS'
        }
      },
      ShadedReliefLabels: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places_Alternate/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 12,
          subdomains: ['server', 'services'],
          pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
          attribution: ''
        }
      },
      Terrain: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/World_Terrain_Base/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 13,
          subdomains: ['server', 'services'],
          attribution: 'USGS, NOAA'
        }
      },
      TerrainLabels: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/Reference/World_Reference_Overlay/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 13,
          subdomains: ['server', 'services'],
          pane: (pointerEvents) ? 'esri-labels' : 'tilePane',
          attribution: ''
        }
      },
      USATopo: {
        urlTemplate: tileProtocol + '//{s}.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 15,
          subdomains: ['server', 'services'],
          attribution: 'USGS, National Geographic Society, i-cubed'
        }
      },
      ImageryClarity: {
        urlTemplate: tileProtocol + '//clarity.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: 'Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
        }
      }
    }
  },

  initialize: function (key, options) {
    var config;

    // set the config variable with the appropriate config object
    if (typeof key === 'object' && key.urlTemplate && key.options) {
      config = key;
    } else if (typeof key === 'string' && BasemapLayer.TILES[key]) {
      config = BasemapLayer.TILES[key];
    } else {
      throw new Error('L.esri.BasemapLayer: Invalid parameter. Use one of "Streets", "Topographic", "Oceans", "OceansLabels", "NationalGeographic", "Gray", "GrayLabels", "DarkGray", "DarkGrayLabels", "Imagery", "ImageryLabels", "ImageryTransportation", "ImageryClarity", "ShadedRelief", "ShadedReliefLabels", "Terrain", "TerrainLabels" or "USATopo"');
    }

    // merge passed options into the config options
    var tileOptions = leaflet.Util.extend(config.options, options);

    leaflet.Util.setOptions(this, tileOptions);

    if (this.options.token) {
      config.urlTemplate += ('?token=' + this.options.token);
    }

    // call the initialize method on L.TileLayer to set everything up
    leaflet.TileLayer.prototype.initialize.call(this, config.urlTemplate, tileOptions);
  },

  onAdd: function (map) {
    // include 'Powered by Esri' in map attribution
    setEsriAttribution(map);

    if (this.options.pane === 'esri-labels') {
      this._initPane();
    }
    // some basemaps can supply dynamic attribution
    if (this.options.attributionUrl) {
      _getAttributionData(this.options.attributionUrl, map);
    }

    map.on('moveend', _updateMapAttribution);

    leaflet.TileLayer.prototype.onAdd.call(this, map);
  },

  onRemove: function (map) {
    map.off('moveend', _updateMapAttribution);
    leaflet.TileLayer.prototype.onRemove.call(this, map);
  },

  _initPane: function () {
    if (!this._map.getPane(this.options.pane)) {
      var pane = this._map.createPane(this.options.pane);
      pane.style.pointerEvents = 'none';
      pane.style.zIndex = 500;
    }
  },

  getAttribution: function () {
    if (this.options.attribution) {
      var attribution = '<span class="esri-dynamic-attribution">' + this.options.attribution + '</span>';
    }
    return attribution;
  }
});

function basemapLayer (key, options) {
  return new BasemapLayer(key, options);
}

var TiledMapLayer = leaflet.TileLayer.extend({
  options: {
    zoomOffsetAllowance: 0.1,
    errorTileUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEABAMAAACuXLVVAAAAA1BMVEUzNDVszlHHAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAAAAAAAAAB6mUWpAAAADZJREFUeJztwQEBAAAAgiD/r25IQAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA7waBAAABw08RwAAAAABJRU5ErkJggg=='
  },

  statics: {
    MercatorZoomLevels: {
      '0': 156543.03392799999,
      '1': 78271.516963999893,
      '2': 39135.758482000099,
      '3': 19567.879240999901,
      '4': 9783.9396204999593,
      '5': 4891.9698102499797,
      '6': 2445.9849051249898,
      '7': 1222.9924525624899,
      '8': 611.49622628138002,
      '9': 305.74811314055802,
      '10': 152.874056570411,
      '11': 76.437028285073197,
      '12': 38.218514142536598,
      '13': 19.109257071268299,
      '14': 9.5546285356341496,
      '15': 4.7773142679493699,
      '16': 2.38865713397468,
      '17': 1.1943285668550501,
      '18': 0.59716428355981699,
      '19': 0.29858214164761698,
      '20': 0.14929107082381,
      '21': 0.07464553541191,
      '22': 0.0373227677059525,
      '23': 0.0186613838529763
    }
  },

  initialize: function (options) {
    options = leaflet.Util.setOptions(this, options);

    // set the urls
    options = getUrlParams(options);
    this.tileUrl = (options.proxy ? options.proxy + '?' : '') + options.url + 'tile/{z}/{y}/{x}' + (options.requestParams && Object.keys(options.requestParams).length > 0 ? leaflet.Util.getParamString(options.requestParams) : '');
    // Remove subdomain in url
    // https://github.com/Esri/esri-leaflet/issues/991
    if (options.url.indexOf('{s}') !== -1 && options.subdomains) {
      options.url = options.url.replace('{s}', options.subdomains[0]);
    }
    this.service = mapService(options);
    this.service.addEventParent(this);

    var arcgisonline = new RegExp(/tiles.arcgis(online)?\.com/g);
    if (arcgisonline.test(options.url)) {
      this.tileUrl = this.tileUrl.replace('://tiles', '://tiles{s}');
      options.subdomains = ['1', '2', '3', '4'];
    }

    if (this.options.token) {
      this.tileUrl += ('?token=' + this.options.token);
    }

    // init layer by calling TileLayers initialize method
    leaflet.TileLayer.prototype.initialize.call(this, this.tileUrl, options);
  },

  getTileUrl: function (tilePoint) {
    var zoom = this._getZoomForUrl();

    return leaflet.Util.template(this.tileUrl, leaflet.Util.extend({
      s: this._getSubdomain(tilePoint),
      x: tilePoint.x,
      y: tilePoint.y,
      // try lod map first, then just default to zoom level
      z: (this._lodMap && this._lodMap[zoom]) ? this._lodMap[zoom] : zoom
    }, this.options));
  },

  createTile: function (coords, done) {
    var tile = document.createElement('img');

    leaflet.DomEvent.on(tile, 'load', leaflet.Util.bind(this._tileOnLoad, this, done, tile));
    leaflet.DomEvent.on(tile, 'error', leaflet.Util.bind(this._tileOnError, this, done, tile));

    if (this.options.crossOrigin) {
      tile.crossOrigin = '';
    }

    /*
     Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
     http://www.w3.org/TR/WCAG20-TECHS/H67
    */
    tile.alt = '';

    // if there is no lod map or an lod map with a proper zoom load the tile
    // otherwise wait for the lod map to become available
    if (!this._lodMap || (this._lodMap && this._lodMap[this._getZoomForUrl()])) {
      tile.src = this.getTileUrl(coords);
    } else {
      this.once('lodmap', function () {
        tile.src = this.getTileUrl(coords);
      }, this);
    }

    return tile;
  },

  onAdd: function (map) {
    // include 'Powered by Esri' in map attribution
    setEsriAttribution(map);

    if (!this._lodMap) {
      this.metadata(function (error, metadata) {
        if (!error && metadata.spatialReference) {
          var sr = metadata.spatialReference.latestWkid || metadata.spatialReference.wkid;
          // display the copyright text from the service using leaflet's attribution control
          if (!this.options.attribution && map.attributionControl && metadata.copyrightText) {
            this.options.attribution = metadata.copyrightText;
            map.attributionControl.addAttribution(this.getAttribution());
          }

          // if the service tiles were published in web mercator using conventional LODs but missing levels, we can try and remap them
          if (map.options.crs === leaflet.CRS.EPSG3857 && (sr === 102100 || sr === 3857)) {
            this._lodMap = {};
            // create the zoom level data
            var arcgisLODs = metadata.tileInfo.lods;
            var correctResolutions = TiledMapLayer.MercatorZoomLevels;

            for (var i = 0; i < arcgisLODs.length; i++) {
              var arcgisLOD = arcgisLODs[i];
              for (var ci in correctResolutions) {
                var correctRes = correctResolutions[ci];

                if (this._withinPercentage(arcgisLOD.resolution, correctRes, this.options.zoomOffsetAllowance)) {
                  this._lodMap[ci] = arcgisLOD.level;
                  break;
                }
              }
            }

            this.fire('lodmap');
          } else if (map.options.crs && map.options.crs.code && (map.options.crs.code.indexOf(sr) > -1)) {
            // if the projection is WGS84, or the developer is using Proj4 to define a custom CRS, no action is required
          } else {
            // if the service was cached in a custom projection and an appropriate LOD hasn't been defined in the map, guide the developer to our Proj4 sample
            warn('L.esri.TiledMapLayer is using a non-mercator spatial reference. Support may be available through Proj4Leaflet http://esri.github.io/esri-leaflet/examples/non-mercator-projection.html');
          }
        }
      }, this);
    }

    leaflet.TileLayer.prototype.onAdd.call(this, map);
  },

  metadata: function (callback, context) {
    this.service.metadata(callback, context);
    return this;
  },

  identify: function () {
    return this.service.identify();
  },

  find: function () {
    return this.service.find();
  },

  query: function () {
    return this.service.query();
  },

  authenticate: function (token) {
    var tokenQs = '?token=' + token;
    this.tileUrl = (this.options.token) ? this.tileUrl.replace(/\?token=(.+)/g, tokenQs) : this.tileUrl + tokenQs;
    this.options.token = token;
    this.service.authenticate(token);
    return this;
  },

  _withinPercentage: function (a, b, percentage) {
    var diff = Math.abs((a / b) - 1);
    return diff < percentage;
  }
});

function tiledMapLayer (url, options) {
  return new TiledMapLayer(url, options);
}

var Overlay = leaflet.ImageOverlay.extend({
  onAdd: function (map) {
    this._topLeft = map.getPixelBounds().min;
    leaflet.ImageOverlay.prototype.onAdd.call(this, map);
  },
  _reset: function () {
    if (this._map.options.crs === leaflet.CRS.EPSG3857) {
      leaflet.ImageOverlay.prototype._reset.call(this);
    } else {
      leaflet.DomUtil.setPosition(this._image, this._topLeft.subtract(this._map.getPixelOrigin()));
    }
  }
});

var RasterLayer = leaflet.Layer.extend({
  options: {
    opacity: 1,
    position: 'front',
    f: 'image',
    useCors: cors,
    attribution: null,
    interactive: false,
    alt: ''
  },

  onAdd: function (map) {
    // include 'Powered by Esri' in map attribution
    setEsriAttribution(map);

    this._update = leaflet.Util.throttle(this._update, this.options.updateInterval, this);

    map.on('moveend', this._update, this);

    // if we had an image loaded and it matches the
    // current bounds show the image otherwise remove it
    if (this._currentImage && this._currentImage._bounds.equals(this._map.getBounds())) {
      map.addLayer(this._currentImage);
    } else if (this._currentImage) {
      this._map.removeLayer(this._currentImage);
      this._currentImage = null;
    }

    this._update();

    if (this._popup) {
      this._map.on('click', this._getPopupData, this);
      this._map.on('dblclick', this._resetPopupState, this);
    }

    // add copyright text listed in service metadata
    this.metadata(function (err, metadata) {
      if (!err && !this.options.attribution && map.attributionControl && metadata.copyrightText) {
        this.options.attribution = metadata.copyrightText;
        map.attributionControl.addAttribution(this.getAttribution());
      }
    }, this);
  },

  onRemove: function (map) {
    if (this._currentImage) {
      this._map.removeLayer(this._currentImage);
    }

    if (this._popup) {
      this._map.off('click', this._getPopupData, this);
      this._map.off('dblclick', this._resetPopupState, this);
    }

    this._map.off('moveend', this._update, this);
  },

  bindPopup: function (fn, popupOptions) {
    this._shouldRenderPopup = false;
    this._lastClick = false;
    this._popup = leaflet.popup(popupOptions);
    this._popupFunction = fn;
    if (this._map) {
      this._map.on('click', this._getPopupData, this);
      this._map.on('dblclick', this._resetPopupState, this);
    }
    return this;
  },

  unbindPopup: function () {
    if (this._map) {
      this._map.closePopup(this._popup);
      this._map.off('click', this._getPopupData, this);
      this._map.off('dblclick', this._resetPopupState, this);
    }
    this._popup = false;
    return this;
  },

  bringToFront: function () {
    this.options.position = 'front';
    if (this._currentImage) {
      this._currentImage.bringToFront();
    }
    return this;
  },

  bringToBack: function () {
    this.options.position = 'back';
    if (this._currentImage) {
      this._currentImage.bringToBack();
    }
    return this;
  },

  getAttribution: function () {
    return this.options.attribution;
  },

  getOpacity: function () {
    return this.options.opacity;
  },

  setOpacity: function (opacity) {
    this.options.opacity = opacity;
    if (this._currentImage) {
      this._currentImage.setOpacity(opacity);
    }
    return this;
  },

  getTimeRange: function () {
    return [this.options.from, this.options.to];
  },

  setTimeRange: function (from, to) {
    this.options.from = from;
    this.options.to = to;
    this._update();
    return this;
  },

  metadata: function (callback, context) {
    this.service.metadata(callback, context);
    return this;
  },

  authenticate: function (token) {
    this.service.authenticate(token);
    return this;
  },

  redraw: function () {
    this._update();
  },

  _renderImage: function (url, bounds, contentType) {
    if (this._map) {
      // if no output directory has been specified for a service, MIME data will be returned
      if (contentType) {
        url = 'data:' + contentType + ';base64,' + url;
      }
      // create a new image overlay and add it to the map
      // to start loading the image
      // opacity is 0 while the image is loading
      var image = new Overlay(url, bounds, {
        opacity: 0,
        crossOrigin: this.options.useCors,
        alt: this.options.alt,
        pane: this.options.pane || this.getPane(),
        interactive: this.options.interactive
      }).addTo(this._map);

      var onOverlayError = function () {
        this._map.removeLayer(image);
        this.fire('error');
        image.off('load', onOverlayLoad, this);
      };

      var onOverlayLoad = function (e) {
        image.off('error', onOverlayLoad, this);
        if (this._map) {
          var newImage = e.target;
          var oldImage = this._currentImage;

          // if the bounds of this image matches the bounds that
          // _renderImage was called with and we have a map with the same bounds
          // hide the old image if there is one and set the opacity
          // of the new image otherwise remove the new image
          if (newImage._bounds.equals(bounds) && newImage._bounds.equals(this._map.getBounds())) {
            this._currentImage = newImage;

            if (this.options.position === 'front') {
              this.bringToFront();
            } else {
              this.bringToBack();
            }

            if (this._map && this._currentImage._map) {
              this._currentImage.setOpacity(this.options.opacity);
            } else {
              this._currentImage._map.removeLayer(this._currentImage);
            }

            if (oldImage && this._map) {
              this._map.removeLayer(oldImage);
            }

            if (oldImage && oldImage._map) {
              oldImage._map.removeLayer(oldImage);
            }
          } else {
            this._map.removeLayer(newImage);
          }
        }

        this.fire('load', {
          bounds: bounds
        });
      };

      // If loading the image fails
      image.once('error', onOverlayError, this);

      // once the image loads
      image.once('load', onOverlayLoad, this);

      this.fire('loading', {
        bounds: bounds
      });
    }
  },

  _update: function () {
    if (!this._map) {
      return;
    }

    var zoom = this._map.getZoom();
    var bounds = this._map.getBounds();

    if (this._animatingZoom) {
      return;
    }

    if (this._map._panTransition && this._map._panTransition._inProgress) {
      return;
    }

    if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
      if (this._currentImage) {
        this._currentImage._map.removeLayer(this._currentImage);
        this._currentImage = null;
      }
      return;
    }

    var params = this._buildExportParams();
    leaflet.Util.extend(params, this.options.requestParams);

    if (params) {
      this._requestExport(params, bounds);
    } else if (this._currentImage) {
      this._currentImage._map.removeLayer(this._currentImage);
      this._currentImage = null;
    }
  },

  _renderPopup: function (latlng, error, results, response) {
    latlng = leaflet.latLng(latlng);
    if (this._shouldRenderPopup && this._lastClick.equals(latlng)) {
      // add the popup to the map where the mouse was clicked at
      var content = this._popupFunction(error, results, response);
      if (content) {
        this._popup.setLatLng(latlng).setContent(content).openOn(this._map);
      }
    }
  },

  _resetPopupState: function (e) {
    this._shouldRenderPopup = false;
    this._lastClick = e.latlng;
  },

  _calculateBbox: function () {
    var pixelBounds = this._map.getPixelBounds();

    var sw = this._map.unproject(pixelBounds.getBottomLeft());
    var ne = this._map.unproject(pixelBounds.getTopRight());

    var neProjected = this._map.options.crs.project(ne);
    var swProjected = this._map.options.crs.project(sw);

    // this ensures ne/sw are switched in polar maps where north/top bottom/south is inverted
    var boundsProjected = leaflet.bounds(neProjected, swProjected);

    return [boundsProjected.getBottomLeft().x, boundsProjected.getBottomLeft().y, boundsProjected.getTopRight().x, boundsProjected.getTopRight().y].join(',');
  },

  _calculateImageSize: function () {
    // ensure that we don't ask ArcGIS Server for a taller image than we have actual map displaying within the div
    var bounds = this._map.getPixelBounds();
    var size = this._map.getSize();

    var sw = this._map.unproject(bounds.getBottomLeft());
    var ne = this._map.unproject(bounds.getTopRight());

    var top = this._map.latLngToLayerPoint(ne).y;
    var bottom = this._map.latLngToLayerPoint(sw).y;

    if (top > 0 || bottom < size.y) {
      size.y = bottom - top;
    }

    return size.x + ',' + size.y;
  }
});

var ImageMapLayer = RasterLayer.extend({

  options: {
    updateInterval: 150,
    format: 'jpgpng',
    transparent: true,
    f: 'image'
  },

  query: function () {
    return this.service.query();
  },

  identify: function () {
    return this.service.identify();
  },

  initialize: function (options) {
    options = getUrlParams(options);
    this.service = imageService(options);
    this.service.addEventParent(this);

    leaflet.Util.setOptions(this, options);
  },

  setPixelType: function (pixelType) {
    this.options.pixelType = pixelType;
    this._update();
    return this;
  },

  getPixelType: function () {
    return this.options.pixelType;
  },

  setBandIds: function (bandIds) {
    if (leaflet.Util.isArray(bandIds)) {
      this.options.bandIds = bandIds.join(',');
    } else {
      this.options.bandIds = bandIds.toString();
    }
    this._update();
    return this;
  },

  getBandIds: function () {
    return this.options.bandIds;
  },

  setNoData: function (noData, noDataInterpretation) {
    if (leaflet.Util.isArray(noData)) {
      this.options.noData = noData.join(',');
    } else {
      this.options.noData = noData.toString();
    }
    if (noDataInterpretation) {
      this.options.noDataInterpretation = noDataInterpretation;
    }
    this._update();
    return this;
  },

  getNoData: function () {
    return this.options.noData;
  },

  getNoDataInterpretation: function () {
    return this.options.noDataInterpretation;
  },

  setRenderingRule: function (renderingRule) {
    this.options.renderingRule = renderingRule;
    this._update();
  },

  getRenderingRule: function () {
    return this.options.renderingRule;
  },

  setMosaicRule: function (mosaicRule) {
    this.options.mosaicRule = mosaicRule;
    this._update();
  },

  getMosaicRule: function () {
    return this.options.mosaicRule;
  },

  _getPopupData: function (e) {
    var callback = leaflet.Util.bind(function (error, results, response) {
      if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire
      setTimeout(leaflet.Util.bind(function () {
        this._renderPopup(e.latlng, error, results, response);
      }, this), 300);
    }, this);

    var identifyRequest = this.identify().at(e.latlng);

    // set mosaic rule for identify task if it is set for layer
    if (this.options.mosaicRule) {
      identifyRequest.setMosaicRule(this.options.mosaicRule);
      // @TODO: force return catalog items too?
    }

    // @TODO: set rendering rule? Not sure,
    // sometimes you want raw pixel values
    // if (this.options.renderingRule) {
    //   identifyRequest.setRenderingRule(this.options.renderingRule);
    // }

    identifyRequest.run(callback);

    // set the flags to show the popup
    this._shouldRenderPopup = true;
    this._lastClick = e.latlng;
  },

  _buildExportParams: function () {
    var sr = parseInt(this._map.options.crs.code.split(':')[1], 10);

    var params = {
      bbox: this._calculateBbox(),
      size: this._calculateImageSize(),
      format: this.options.format,
      transparent: this.options.transparent,
      bboxSR: sr,
      imageSR: sr
    };

    if (this.options.from && this.options.to) {
      params.time = this.options.from.valueOf() + ',' + this.options.to.valueOf();
    }

    if (this.options.pixelType) {
      params.pixelType = this.options.pixelType;
    }

    if (this.options.interpolation) {
      params.interpolation = this.options.interpolation;
    }

    if (this.options.compressionQuality) {
      params.compressionQuality = this.options.compressionQuality;
    }

    if (this.options.bandIds) {
      params.bandIds = this.options.bandIds;
    }

    // 0 is falsy *and* a valid input parameter
    if (this.options.noData === 0 || this.options.noData) {
      params.noData = this.options.noData;
    }

    if (this.options.noDataInterpretation) {
      params.noDataInterpretation = this.options.noDataInterpretation;
    }

    if (this.service.options.token) {
      params.token = this.service.options.token;
    }

    if (this.options.renderingRule) {
      params.renderingRule = JSON.stringify(this.options.renderingRule);
    }

    if (this.options.mosaicRule) {
      params.mosaicRule = JSON.stringify(this.options.mosaicRule);
    }

    return params;
  },

  _requestExport: function (params, bounds) {
    if (this.options.f === 'json') {
      this.service.request('exportImage', params, function (error, response) {
        if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire
        if (this.options.token) {
          response.href += ('?token=' + this.options.token);
        }
        this._renderImage(response.href, bounds);
      }, this);
    } else {
      params.f = 'image';
      this._renderImage(this.options.url + 'exportImage' + leaflet.Util.getParamString(params), bounds);
    }
  }
});

function imageMapLayer (url, options) {
  return new ImageMapLayer(url, options);
}

var DynamicMapLayer = RasterLayer.extend({

  options: {
    updateInterval: 150,
    layers: false,
    layerDefs: false,
    timeOptions: false,
    format: 'png24',
    transparent: true,
    f: 'json'
  },

  initialize: function (options) {
    options = getUrlParams(options);
    this.service = mapService(options);
    this.service.addEventParent(this);

    if ((options.proxy || options.token) && options.f !== 'json') {
      options.f = 'json';
    }

    leaflet.Util.setOptions(this, options);
  },

  getDynamicLayers: function () {
    return this.options.dynamicLayers;
  },

  setDynamicLayers: function (dynamicLayers) {
    this.options.dynamicLayers = dynamicLayers;
    this._update();
    return this;
  },

  getLayers: function () {
    return this.options.layers;
  },

  setLayers: function (layers) {
    this.options.layers = layers;
    this._update();
    return this;
  },

  getLayerDefs: function () {
    return this.options.layerDefs;
  },

  setLayerDefs: function (layerDefs) {
    this.options.layerDefs = layerDefs;
    this._update();
    return this;
  },

  getTimeOptions: function () {
    return this.options.timeOptions;
  },

  setTimeOptions: function (timeOptions) {
    this.options.timeOptions = timeOptions;
    this._update();
    return this;
  },

  query: function () {
    return this.service.query();
  },

  identify: function () {
    return this.service.identify();
  },

  find: function () {
    return this.service.find();
  },

  _getPopupData: function (e) {
    var callback = leaflet.Util.bind(function (error, featureCollection, response) {
      if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire
      setTimeout(leaflet.Util.bind(function () {
        this._renderPopup(e.latlng, error, featureCollection, response);
      }, this), 300);
    }, this);

    var identifyRequest;
    if (this.options.popup) {
      identifyRequest = this.options.popup.on(this._map).at(e.latlng);
    } else {
      identifyRequest = this.identify().on(this._map).at(e.latlng);
    }

    // remove extraneous vertices from response features if it has not already been done
    identifyRequest.params.maxAllowableOffset ? true : identifyRequest.simplify(this._map, 0.5);

    if (!(this.options.popup && this.options.popup.params && this.options.popup.params.layers)) {
      if (this.options.layers) {
        identifyRequest.layers('visible:' + this.options.layers.join(','));
      } else {
        identifyRequest.layers('visible');
      }
    }

    // if present, pass layer ids and sql filters through to the identify task
    if (this.options.layerDefs && typeof this.options.layerDefs !== 'string' && !identifyRequest.params.layerDefs) {
      for (var id in this.options.layerDefs) {
        if (this.options.layerDefs.hasOwnProperty(id)) {
          identifyRequest.layerDef(id, this.options.layerDefs[id]);
        }
      }
    }

    identifyRequest.run(callback);

    // set the flags to show the popup
    this._shouldRenderPopup = true;
    this._lastClick = e.latlng;
  },

  _buildExportParams: function () {
    var sr = parseInt(this._map.options.crs.code.split(':')[1], 10);

    var params = {
      bbox: this._calculateBbox(),
      size: this._calculateImageSize(),
      dpi: 96,
      format: this.options.format,
      transparent: this.options.transparent,
      bboxSR: sr,
      imageSR: sr
    };

    if (this.options.dynamicLayers) {
      params.dynamicLayers = this.options.dynamicLayers;
    }

    if (this.options.layers) {
      if (this.options.layers.length === 0) {
        return;
      } else {
        params.layers = 'show:' + this.options.layers.join(',');
      }
    }

    if (this.options.layerDefs) {
      params.layerDefs = typeof this.options.layerDefs === 'string' ? this.options.layerDefs : JSON.stringify(this.options.layerDefs);
    }

    if (this.options.timeOptions) {
      params.timeOptions = JSON.stringify(this.options.timeOptions);
    }

    if (this.options.from && this.options.to) {
      params.time = this.options.from.valueOf() + ',' + this.options.to.valueOf();
    }

    if (this.service.options.token) {
      params.token = this.service.options.token;
    }

    if (this.options.proxy) {
      params.proxy = this.options.proxy;
    }

    // use a timestamp to bust server cache
    if (this.options.disableCache) {
      params._ts = Date.now();
    }

    return params;
  },

  _requestExport: function (params, bounds) {
    if (this.options.f === 'json') {
      this.service.request('export', params, function (error, response) {
        if (error) { return; } // we really can't do anything here but authenticate or requesterror will fire

        if (this.options.token) {
          response.href += ('?token=' + this.options.token);
        }
        if (this.options.proxy) {
          response.href = this.options.proxy + '?' + response.href;
        }
        if (response.href) {
          this._renderImage(response.href, bounds);
        } else {
          this._renderImage(response.imageData, bounds, response.contentType);
        }
      }, this);
    } else {
      params.f = 'image';
      this._renderImage(this.options.url + 'export' + leaflet.Util.getParamString(params), bounds);
    }
  }
});

function dynamicMapLayer (url, options) {
  return new DynamicMapLayer(url, options);
}

var VirtualGrid = leaflet.Layer.extend({

  options: {
    cellSize: 512,
    updateInterval: 150
  },

  initialize: function (options) {
    options = leaflet.setOptions(this, options);
    this._zooming = false;
  },

  onAdd: function (map) {
    this._map = map;
    this._update = leaflet.Util.throttle(this._update, this.options.updateInterval, this);
    this._reset();
    this._update();
  },

  onRemove: function () {
    this._map.removeEventListener(this.getEvents(), this);
    this._removeCells();
  },

  getEvents: function () {
    var events = {
      moveend: this._update,
      zoomstart: this._zoomstart,
      zoomend: this._reset
    };

    return events;
  },

  addTo: function (map) {
    map.addLayer(this);
    return this;
  },

  removeFrom: function (map) {
    map.removeLayer(this);
    return this;
  },

  _zoomstart: function () {
    this._zooming = true;
  },

  _reset: function () {
    this._removeCells();

    this._cells = {};
    this._activeCells = {};
    this._cellsToLoad = 0;
    this._cellsTotal = 0;
    this._cellNumBounds = this._getCellNumBounds();

    this._resetWrap();
    this._zooming = false;
  },

  _resetWrap: function () {
    var map = this._map;
    var crs = map.options.crs;

    if (crs.infinite) { return; }

    var cellSize = this._getCellSize();

    if (crs.wrapLng) {
      this._wrapLng = [
        Math.floor(map.project([0, crs.wrapLng[0]]).x / cellSize),
        Math.ceil(map.project([0, crs.wrapLng[1]]).x / cellSize)
      ];
    }

    if (crs.wrapLat) {
      this._wrapLat = [
        Math.floor(map.project([crs.wrapLat[0], 0]).y / cellSize),
        Math.ceil(map.project([crs.wrapLat[1], 0]).y / cellSize)
      ];
    }
  },

  _getCellSize: function () {
    return this.options.cellSize;
  },

  _update: function () {
    if (!this._map) {
      return;
    }

    var mapBounds = this._map.getPixelBounds();
    var cellSize = this._getCellSize();

    // cell coordinates range for the current view
    var cellBounds = leaflet.bounds(
      mapBounds.min.divideBy(cellSize).floor(),
      mapBounds.max.divideBy(cellSize).floor());

    this._removeOtherCells(cellBounds);
    this._addCells(cellBounds);

    this.fire('cellsupdated');
  },

  _addCells: function (cellBounds) {
    var queue = [];
    var center = cellBounds.getCenter();
    var zoom = this._map.getZoom();

    var j, i, coords;
    // create a queue of coordinates to load cells from
    for (j = cellBounds.min.y; j <= cellBounds.max.y; j++) {
      for (i = cellBounds.min.x; i <= cellBounds.max.x; i++) {
        coords = leaflet.point(i, j);
        coords.z = zoom;

        if (this._isValidCell(coords)) {
          queue.push(coords);
        }
      }
    }

    var cellsToLoad = queue.length;

    if (cellsToLoad === 0) { return; }

    this._cellsToLoad += cellsToLoad;
    this._cellsTotal += cellsToLoad;

    // sort cell queue to load cells in order of their distance to center
    queue.sort(function (a, b) {
      return a.distanceTo(center) - b.distanceTo(center);
    });

    for (i = 0; i < cellsToLoad; i++) {
      this._addCell(queue[i]);
    }
  },

  _isValidCell: function (coords) {
    var crs = this._map.options.crs;

    if (!crs.infinite) {
      // don't load cell if it's out of bounds and not wrapped
      var cellNumBounds = this._cellNumBounds;
      if (
        (!crs.wrapLng && (coords.x < cellNumBounds.min.x || coords.x > cellNumBounds.max.x)) ||
        (!crs.wrapLat && (coords.y < cellNumBounds.min.y || coords.y > cellNumBounds.max.y))
      ) {
        return false;
      }
    }

    if (!this.options.bounds) {
      return true;
    }

    // don't load cell if it doesn't intersect the bounds in options
    var cellBounds = this._cellCoordsToBounds(coords);
    return leaflet.latLngBounds(this.options.bounds).intersects(cellBounds);
  },

  // converts cell coordinates to its geographical bounds
  _cellCoordsToBounds: function (coords) {
    var map = this._map;
    var cellSize = this.options.cellSize;
    var nwPoint = coords.multiplyBy(cellSize);
    var sePoint = nwPoint.add([cellSize, cellSize]);
    var nw = map.wrapLatLng(map.unproject(nwPoint, coords.z));
    var se = map.wrapLatLng(map.unproject(sePoint, coords.z));

    return leaflet.latLngBounds(nw, se);
  },

  // converts cell coordinates to key for the cell cache
  _cellCoordsToKey: function (coords) {
    return coords.x + ':' + coords.y;
  },

  // converts cell cache key to coordiantes
  _keyToCellCoords: function (key) {
    var kArr = key.split(':');
    var x = parseInt(kArr[0], 10);
    var y = parseInt(kArr[1], 10);

    return leaflet.point(x, y);
  },

  // remove any present cells that are off the specified bounds
  _removeOtherCells: function (bounds) {
    for (var key in this._cells) {
      if (!bounds.contains(this._keyToCellCoords(key))) {
        this._removeCell(key);
      }
    }
  },

  _removeCell: function (key) {
    var cell = this._activeCells[key];

    if (cell) {
      delete this._activeCells[key];

      if (this.cellLeave) {
        this.cellLeave(cell.bounds, cell.coords);
      }

      this.fire('cellleave', {
        bounds: cell.bounds,
        coords: cell.coords
      });
    }
  },

  _removeCells: function () {
    for (var key in this._cells) {
      var cellBounds = this._cells[key].bounds;
      var coords = this._cells[key].coords;

      if (this.cellLeave) {
        this.cellLeave(cellBounds, coords);
      }

      this.fire('cellleave', {
        bounds: cellBounds,
        coords: coords
      });
    }
  },

  _addCell: function (coords) {
    // wrap cell coords if necessary (depending on CRS)
    this._wrapCoords(coords);

    // generate the cell key
    var key = this._cellCoordsToKey(coords);

    // get the cell from the cache
    var cell = this._cells[key];
    // if this cell should be shown as isnt active yet (enter)

    if (cell && !this._activeCells[key]) {
      if (this.cellEnter) {
        this.cellEnter(cell.bounds, coords);
      }

      this.fire('cellenter', {
        bounds: cell.bounds,
        coords: coords
      });

      this._activeCells[key] = cell;
    }

    // if we dont have this cell in the cache yet (create)
    if (!cell) {
      cell = {
        coords: coords,
        bounds: this._cellCoordsToBounds(coords)
      };

      this._cells[key] = cell;
      this._activeCells[key] = cell;

      if (this.createCell) {
        this.createCell(cell.bounds, coords);
      }

      this.fire('cellcreate', {
        bounds: cell.bounds,
        coords: coords
      });
    }
  },

  _wrapCoords: function (coords) {
    coords.x = this._wrapLng ? leaflet.Util.wrapNum(coords.x, this._wrapLng) : coords.x;
    coords.y = this._wrapLat ? leaflet.Util.wrapNum(coords.y, this._wrapLat) : coords.y;
  },

  // get the global cell coordinates range for the current zoom
  _getCellNumBounds: function () {
    var worldBounds = this._map.getPixelWorldBounds();
    var size = this._getCellSize();

    return worldBounds ? leaflet.bounds(
      worldBounds.min.divideBy(size).floor(),
      worldBounds.max.divideBy(size).ceil().subtract([1, 1])) : null;
  }
});

function BinarySearchIndex (values) {
  this.values = [].concat(values || []);
}

BinarySearchIndex.prototype.query = function (value) {
  var index = this.getIndex(value);
  return this.values[index];
};

BinarySearchIndex.prototype.getIndex = function getIndex (value) {
  if (this.dirty) {
    this.sort();
  }

  var minIndex = 0;
  var maxIndex = this.values.length - 1;
  var currentIndex;
  var currentElement;

  while (minIndex <= maxIndex) {
    currentIndex = (minIndex + maxIndex) / 2 | 0;
    currentElement = this.values[Math.round(currentIndex)];
    if (+currentElement.value < +value) {
      minIndex = currentIndex + 1;
    } else if (+currentElement.value > +value) {
      maxIndex = currentIndex - 1;
    } else {
      return currentIndex;
    }
  }

  return Math.abs(~maxIndex);
};

BinarySearchIndex.prototype.between = function between (start, end) {
  var startIndex = this.getIndex(start);
  var endIndex = this.getIndex(end);

  if (startIndex === 0 && endIndex === 0) {
    return [];
  }

  while (this.values[startIndex - 1] && this.values[startIndex - 1].value === start) {
    startIndex--;
  }

  while (this.values[endIndex + 1] && this.values[endIndex + 1].value === end) {
    endIndex++;
  }

  if (this.values[endIndex] && this.values[endIndex].value === end && this.values[endIndex + 1]) {
    endIndex++;
  }

  return this.values.slice(startIndex, endIndex);
};

BinarySearchIndex.prototype.insert = function insert (item) {
  this.values.splice(this.getIndex(item.value), 0, item);
  return this;
};

BinarySearchIndex.prototype.bulkAdd = function bulkAdd (items, sort) {
  this.values = this.values.concat([].concat(items || []));

  if (sort) {
    this.sort();
  } else {
    this.dirty = true;
  }

  return this;
};

BinarySearchIndex.prototype.sort = function sort () {
  this.values.sort(function (a, b) {
    return +b.value - +a.value;
  }).reverse();
  this.dirty = false;
  return this;
};

var FeatureManager = VirtualGrid.extend({
  /**
   * Options
   */

  options: {
    attribution: null,
    where: '1=1',
    fields: ['*'],
    from: false,
    to: false,
    timeField: false,
    timeFilterMode: 'server',
    simplifyFactor: 0,
    precision: 6
  },

  /**
   * Constructor
   */

  initialize: function (options) {
    VirtualGrid.prototype.initialize.call(this, options);

    options = getUrlParams(options);
    options = leaflet.Util.setOptions(this, options);

    this.service = featureLayerService(options);
    this.service.addEventParent(this);

    // use case insensitive regex to look for common fieldnames used for indexing
    if (this.options.fields[0] !== '*') {
      var oidCheck = false;
      for (var i = 0; i < this.options.fields.length; i++) {
        if (this.options.fields[i].match(/^(OBJECTID|FID|OID|ID)$/i)) {
          oidCheck = true;
        }
      }
      if (oidCheck === false) {
        warn('no known esriFieldTypeOID field detected in fields Array.  Please add an attribute field containing unique IDs to ensure the layer can be drawn correctly.');
      }
    }

    if (this.options.timeField.start && this.options.timeField.end) {
      this._startTimeIndex = new BinarySearchIndex();
      this._endTimeIndex = new BinarySearchIndex();
    } else if (this.options.timeField) {
      this._timeIndex = new BinarySearchIndex();
    }

    this._cache = {};
    this._currentSnapshot = []; // cache of what layers should be active
    this._activeRequests = 0;
  },

  /**
   * Layer Interface
   */

  onAdd: function (map) {
    // include 'Powered by Esri' in map attribution
    setEsriAttribution(map);

    this.service.metadata(function (err, metadata) {
      if (!err) {
        var supportedFormats = metadata.supportedQueryFormats;

        // Check if someone has requested that we don't use geoJSON, even if it's available
        var forceJsonFormat = false;
        if (this.service.options.isModern === false) {
          forceJsonFormat = true;
        }

        // Unless we've been told otherwise, check to see whether service can emit GeoJSON natively
        if (!forceJsonFormat && supportedFormats && supportedFormats.indexOf('geoJSON') !== -1) {
          this.service.options.isModern = true;
        }

        // add copyright text listed in service metadata
        if (!this.options.attribution && map.attributionControl && metadata.copyrightText) {
          this.options.attribution = metadata.copyrightText;
          map.attributionControl.addAttribution(this.getAttribution());
        }
      }
    }, this);

    map.on('zoomend', this._handleZoomChange, this);

    return VirtualGrid.prototype.onAdd.call(this, map);
  },

  onRemove: function (map) {
    map.off('zoomend', this._handleZoomChange, this);

    return VirtualGrid.prototype.onRemove.call(this, map);
  },

  getAttribution: function () {
    return this.options.attribution;
  },

  /**
   * Feature Management
   */

  createCell: function (bounds, coords) {
    // dont fetch features outside the scale range defined for the layer
    if (this._visibleZoom()) {
      this._requestFeatures(bounds, coords);
    }
  },

  _requestFeatures: function (bounds, coords, callback) {
    this._activeRequests++;

    // our first active request fires loading
    if (this._activeRequests === 1) {
      this.fire('loading', {
        bounds: bounds
      }, true);
    }

    return this._buildQuery(bounds).run(function (error, featureCollection, response) {
      if (response && response.exceededTransferLimit) {
        this.fire('drawlimitexceeded');
      }

      // no error, features
      if (!error && featureCollection && featureCollection.features.length) {
        // schedule adding features until the next animation frame
        leaflet.Util.requestAnimFrame(leaflet.Util.bind(function () {
          this._addFeatures(featureCollection.features, coords);
          this._postProcessFeatures(bounds);
        }, this));
      }

      // no error, no features
      if (!error && featureCollection && !featureCollection.features.length) {
        this._postProcessFeatures(bounds);
      }

      if (error) {
        this._postProcessFeatures(bounds);
      }

      if (callback) {
        callback.call(this, error, featureCollection);
      }
    }, this);
  },

  _postProcessFeatures: function (bounds) {
    // deincrement the request counter now that we have processed features
    this._activeRequests--;

    // if there are no more active requests fire a load event for this view
    if (this._activeRequests <= 0) {
      this.fire('load', {
        bounds: bounds
      });
    }
  },

  _cacheKey: function (coords) {
    return coords.z + ':' + coords.x + ':' + coords.y;
  },

  _addFeatures: function (features, coords) {
    var key = this._cacheKey(coords);
    this._cache[key] = this._cache[key] || [];

    for (var i = features.length - 1; i >= 0; i--) {
      var id = features[i].id;

      if (this._currentSnapshot.indexOf(id) === -1) {
        this._currentSnapshot.push(id);
      }
      if (this._cache[key].indexOf(id) === -1) {
        this._cache[key].push(id);
      }
    }

    if (this.options.timeField) {
      this._buildTimeIndexes(features);
    }

    this.createLayers(features);
  },

  _buildQuery: function (bounds) {
    var query = this.service.query()
      .intersects(bounds)
      .where(this.options.where)
      .fields(this.options.fields)
      .precision(this.options.precision);

    if (this.options.requestParams) {
      leaflet.Util.extend(query.params, this.options.requestParams);
    }

    if (this.options.simplifyFactor) {
      query.simplify(this._map, this.options.simplifyFactor);
    }

    if (this.options.timeFilterMode === 'server' && this.options.from && this.options.to) {
      query.between(this.options.from, this.options.to);
    }

    return query;
  },

  /**
   * Where Methods
   */

  setWhere: function (where, callback, context) {
    this.options.where = (where && where.length) ? where : '1=1';

    var oldSnapshot = [];
    var newSnapshot = [];
    var pendingRequests = 0;
    var requestError = null;
    var requestCallback = leaflet.Util.bind(function (error, featureCollection) {
      if (error) {
        requestError = error;
      }

      if (featureCollection) {
        for (var i = featureCollection.features.length - 1; i >= 0; i--) {
          newSnapshot.push(featureCollection.features[i].id);
        }
      }

      pendingRequests--;

      if (pendingRequests <= 0 && this._visibleZoom()) {
        this._currentSnapshot = newSnapshot;
        // schedule adding features for the next animation frame
        leaflet.Util.requestAnimFrame(leaflet.Util.bind(function () {
          this.removeLayers(oldSnapshot);
          this.addLayers(newSnapshot);
          if (callback) {
            callback.call(context, requestError);
          }
        }, this));
      }
    }, this);

    for (var i = this._currentSnapshot.length - 1; i >= 0; i--) {
      oldSnapshot.push(this._currentSnapshot[i]);
    }

    for (var key in this._activeCells) {
      pendingRequests++;
      var coords = this._keyToCellCoords(key);
      var bounds = this._cellCoordsToBounds(coords);
      this._requestFeatures(bounds, key, requestCallback);
    }

    return this;
  },

  getWhere: function () {
    return this.options.where;
  },

  /**
   * Time Range Methods
   */

  getTimeRange: function () {
    return [this.options.from, this.options.to];
  },

  setTimeRange: function (from, to, callback, context) {
    var oldFrom = this.options.from;
    var oldTo = this.options.to;
    var pendingRequests = 0;
    var requestError = null;
    var requestCallback = leaflet.Util.bind(function (error) {
      if (error) {
        requestError = error;
      }
      this._filterExistingFeatures(oldFrom, oldTo, from, to);

      pendingRequests--;

      if (callback && pendingRequests <= 0) {
        callback.call(context, requestError);
      }
    }, this);

    this.options.from = from;
    this.options.to = to;

    this._filterExistingFeatures(oldFrom, oldTo, from, to);

    if (this.options.timeFilterMode === 'server') {
      for (var key in this._activeCells) {
        pendingRequests++;
        var coords = this._keyToCellCoords(key);
        var bounds = this._cellCoordsToBounds(coords);
        this._requestFeatures(bounds, key, requestCallback);
      }
    }

    return this;
  },

  refresh: function () {
    for (var key in this._activeCells) {
      var coords = this._keyToCellCoords(key);
      var bounds = this._cellCoordsToBounds(coords);
      this._requestFeatures(bounds, key);
    }

    if (this.redraw) {
      this.once('load', function () {
        this.eachFeature(function (layer) {
          this._redraw(layer.feature.id);
        }, this);
      }, this);
    }
  },

  _filterExistingFeatures: function (oldFrom, oldTo, newFrom, newTo) {
    var layersToRemove = (oldFrom && oldTo) ? this._getFeaturesInTimeRange(oldFrom, oldTo) : this._currentSnapshot;
    var layersToAdd = this._getFeaturesInTimeRange(newFrom, newTo);

    if (layersToAdd.indexOf) {
      for (var i = 0; i < layersToAdd.length; i++) {
        var shouldRemoveLayer = layersToRemove.indexOf(layersToAdd[i]);
        if (shouldRemoveLayer >= 0) {
          layersToRemove.splice(shouldRemoveLayer, 1);
        }
      }
    }

    // schedule adding features until the next animation frame
    leaflet.Util.requestAnimFrame(leaflet.Util.bind(function () {
      this.removeLayers(layersToRemove);
      this.addLayers(layersToAdd);
    }, this));
  },

  _getFeaturesInTimeRange: function (start, end) {
    var ids = [];
    var search;

    if (this.options.timeField.start && this.options.timeField.end) {
      var startTimes = this._startTimeIndex.between(start, end);
      var endTimes = this._endTimeIndex.between(start, end);
      search = startTimes.concat(endTimes);
    } else {
      search = this._timeIndex.between(start, end);
    }

    for (var i = search.length - 1; i >= 0; i--) {
      ids.push(search[i].id);
    }

    return ids;
  },

  _buildTimeIndexes: function (geojson) {
    var i;
    var feature;
    if (this.options.timeField.start && this.options.timeField.end) {
      var startTimeEntries = [];
      var endTimeEntries = [];
      for (i = geojson.length - 1; i >= 0; i--) {
        feature = geojson[i];
        startTimeEntries.push({
          id: feature.id,
          value: new Date(feature.properties[this.options.timeField.start])
        });
        endTimeEntries.push({
          id: feature.id,
          value: new Date(feature.properties[this.options.timeField.end])
        });
      }
      this._startTimeIndex.bulkAdd(startTimeEntries);
      this._endTimeIndex.bulkAdd(endTimeEntries);
    } else {
      var timeEntries = [];
      for (i = geojson.length - 1; i >= 0; i--) {
        feature = geojson[i];
        timeEntries.push({
          id: feature.id,
          value: new Date(feature.properties[this.options.timeField])
        });
      }

      this._timeIndex.bulkAdd(timeEntries);
    }
  },

  _featureWithinTimeRange: function (feature) {
    if (!this.options.from || !this.options.to) {
      return true;
    }

    var from = +this.options.from.valueOf();
    var to = +this.options.to.valueOf();

    if (typeof this.options.timeField === 'string') {
      var date = +feature.properties[this.options.timeField];
      return (date >= from) && (date <= to);
    }

    if (this.options.timeField.start && this.options.timeField.end) {
      var startDate = +feature.properties[this.options.timeField.start];
      var endDate = +feature.properties[this.options.timeField.end];
      return ((startDate >= from) && (startDate <= to)) || ((endDate >= from) && (endDate <= to));
    }
  },

  _visibleZoom: function () {
    // check to see whether the current zoom level of the map is within the optional limit defined for the FeatureLayer
    if (!this._map) {
      return false;
    }
    var zoom = this._map.getZoom();
    if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
      return false;
    } else { return true; }
  },

  _handleZoomChange: function () {
    if (!this._visibleZoom()) {
      this.removeLayers(this._currentSnapshot);
      this._currentSnapshot = [];
    } else {
      /*
      for every cell in this._activeCells
        1. Get the cache key for the coords of the cell
        2. If this._cache[key] exists it will be an array of feature IDs.
        3. Call this.addLayers(this._cache[key]) to instruct the feature layer to add the layers back.
      */
      for (var i in this._activeCells) {
        var coords = this._activeCells[i].coords;
        var key = this._cacheKey(coords);
        if (this._cache[key]) {
          this.addLayers(this._cache[key]);
        }
      }
    }
  },

  /**
   * Service Methods
   */

  authenticate: function (token) {
    this.service.authenticate(token);
    return this;
  },

  metadata: function (callback, context) {
    this.service.metadata(callback, context);
    return this;
  },

  query: function () {
    return this.service.query();
  },

  _getMetadata: function (callback) {
    if (this._metadata) {
      var error;
      callback(error, this._metadata);
    } else {
      this.metadata(leaflet.Util.bind(function (error, response) {
        this._metadata = response;
        callback(error, this._metadata);
      }, this));
    }
  },

  addFeature: function (feature, callback, context) {
    this._getMetadata(leaflet.Util.bind(function (error, metadata) {
      if (error) {
        if (callback) { callback.call(this, error, null); }
        return;
      }

      this.service.addFeature(feature, leaflet.Util.bind(function (error, response) {
        if (!error) {
          // assign ID from result to appropriate objectid field from service metadata
          feature.properties[metadata.objectIdField] = response.objectId;

          // we also need to update the geojson id for createLayers() to function
          feature.id = response.objectId;
          this.createLayers([feature]);
        }

        if (callback) {
          callback.call(context, error, response);
        }
      }, this));
    }, this));
  },

  updateFeature: function (feature, callback, context) {
    this.service.updateFeature(feature, function (error, response) {
      if (!error) {
        this.removeLayers([feature.id], true);
        this.createLayers([feature]);
      }

      if (callback) {
        callback.call(context, error, response);
      }
    }, this);
  },

  deleteFeature: function (id, callback, context) {
    this.service.deleteFeature(id, function (error, response) {
      if (!error && response.objectId) {
        this.removeLayers([response.objectId], true);
      }
      if (callback) {
        callback.call(context, error, response);
      }
    }, this);
  },

  deleteFeatures: function (ids, callback, context) {
    return this.service.deleteFeatures(ids, function (error, response) {
      if (!error && response.length > 0) {
        for (var i = 0; i < response.length; i++) {
          this.removeLayers([response[i].objectId], true);
        }
      }
      if (callback) {
        callback.call(context, error, response);
      }
    }, this);
  }
});

var FeatureLayer = FeatureManager.extend({

  options: {
    cacheLayers: true
  },

  /**
   * Constructor
   */
  initialize: function (options) {
    FeatureManager.prototype.initialize.call(this, options);
    this._originalStyle = this.options.style;
    this._layers = {};
  },

  /**
   * Layer Interface
   */

  onRemove: function (map) {
    for (var i in this._layers) {
      map.removeLayer(this._layers[i]);
      // trigger the event when the entire featureLayer is removed from the map
      this.fire('removefeature', {
        feature: this._layers[i].feature,
        permanent: false
      }, true);
    }

    return FeatureManager.prototype.onRemove.call(this, map);
  },

  createNewLayer: function (geojson) {
    var layer = leaflet.GeoJSON.geometryToLayer(geojson, this.options);
    layer.defaultOptions = layer.options;
    return layer;
  },

  _updateLayer: function (layer, geojson) {
    // convert the geojson coordinates into a Leaflet LatLng array/nested arrays
    // pass it to setLatLngs to update layer geometries
    var latlngs = [];
    var coordsToLatLng = this.options.coordsToLatLng || leaflet.GeoJSON.coordsToLatLng;

    // copy new attributes, if present
    if (geojson.properties) {
      layer.feature.properties = geojson.properties;
    }

    switch (geojson.geometry.type) {
      case 'Point':
        latlngs = leaflet.GeoJSON.coordsToLatLng(geojson.geometry.coordinates);
        layer.setLatLng(latlngs);
        break;
      case 'LineString':
        latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 0, coordsToLatLng);
        layer.setLatLngs(latlngs);
        break;
      case 'MultiLineString':
        latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 1, coordsToLatLng);
        layer.setLatLngs(latlngs);
        break;
      case 'Polygon':
        latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 1, coordsToLatLng);
        layer.setLatLngs(latlngs);
        break;
      case 'MultiPolygon':
        latlngs = leaflet.GeoJSON.coordsToLatLngs(geojson.geometry.coordinates, 2, coordsToLatLng);
        layer.setLatLngs(latlngs);
        break;
    }
  },

  /**
   * Feature Management Methods
   */

  createLayers: function (features) {
    for (var i = features.length - 1; i >= 0; i--) {
      var geojson = features[i];

      var layer = this._layers[geojson.id];
      var newLayer;

      if (this._visibleZoom() && layer && !this._map.hasLayer(layer)) {
        this._map.addLayer(layer);
        this.fire('addfeature', {
          feature: layer.feature
        }, true);
      }

      // update geometry if necessary
      if (layer && this.options.simplifyFactor > 0 && (layer.setLatLngs || layer.setLatLng)) {
        this._updateLayer(layer, geojson);
      }

      if (!layer) {
        newLayer = this.createNewLayer(geojson);
        newLayer.feature = geojson;

        // bubble events from individual layers to the feature layer
        newLayer.addEventParent(this);

        if (this.options.onEachFeature) {
          this.options.onEachFeature(newLayer.feature, newLayer);
        }

        // cache the layer
        this._layers[newLayer.feature.id] = newLayer;

        // style the layer
        this.setFeatureStyle(newLayer.feature.id, this.options.style);

        this.fire('createfeature', {
          feature: newLayer.feature
        }, true);

        // add the layer if the current zoom level is inside the range defined for the layer, it is within the current time bounds or our layer is not time enabled
        if (this._visibleZoom() && (!this.options.timeField || (this.options.timeField && this._featureWithinTimeRange(geojson)))) {
          this._map.addLayer(newLayer);
        }
      }
    }
  },

  addLayers: function (ids) {
    for (var i = ids.length - 1; i >= 0; i--) {
      var layer = this._layers[ids[i]];
      if (layer) {
        this._map.addLayer(layer);
      }
    }
  },

  removeLayers: function (ids, permanent) {
    for (var i = ids.length - 1; i >= 0; i--) {
      var id = ids[i];
      var layer = this._layers[id];
      if (layer) {
        this.fire('removefeature', {
          feature: layer.feature,
          permanent: permanent
        }, true);
        this._map.removeLayer(layer);
      }
      if (layer && permanent) {
        delete this._layers[id];
      }
    }
  },

  cellEnter: function (bounds, coords) {
    if (this._visibleZoom() && !this._zooming && this._map) {
      leaflet.Util.requestAnimFrame(leaflet.Util.bind(function () {
        var cacheKey = this._cacheKey(coords);
        var cellKey = this._cellCoordsToKey(coords);
        var layers = this._cache[cacheKey];
        if (this._activeCells[cellKey] && layers) {
          this.addLayers(layers);
        }
      }, this));
    }
  },

  cellLeave: function (bounds, coords) {
    if (!this._zooming) {
      leaflet.Util.requestAnimFrame(leaflet.Util.bind(function () {
        if (this._map) {
          var cacheKey = this._cacheKey(coords);
          var cellKey = this._cellCoordsToKey(coords);
          var layers = this._cache[cacheKey];
          var mapBounds = this._map.getBounds();
          if (!this._activeCells[cellKey] && layers) {
            var removable = true;

            for (var i = 0; i < layers.length; i++) {
              var layer = this._layers[layers[i]];
              if (layer && layer.getBounds && mapBounds.intersects(layer.getBounds())) {
                removable = false;
              }
            }

            if (removable) {
              this.removeLayers(layers, !this.options.cacheLayers);
            }

            if (!this.options.cacheLayers && removable) {
              delete this._cache[cacheKey];
              delete this._cells[cellKey];
              delete this._activeCells[cellKey];
            }
          }
        }
      }, this));
    }
  },

  /**
   * Styling Methods
   */

  resetStyle: function () {
    this.options.style = this._originalStyle;
    this.eachFeature(function (layer) {
      this.resetFeatureStyle(layer.feature.id);
    }, this);
    return this;
  },

  setStyle: function (style) {
    this.options.style = style;
    this.eachFeature(function (layer) {
      this.setFeatureStyle(layer.feature.id, style);
    }, this);
    return this;
  },

  resetFeatureStyle: function (id) {
    var layer = this._layers[id];
    var style = this._originalStyle || leaflet.Path.prototype.options;
    if (layer) {
      leaflet.Util.extend(layer.options, layer.defaultOptions);
      this.setFeatureStyle(id, style);
    }
    return this;
  },

  setFeatureStyle: function (id, style) {
    var layer = this._layers[id];
    if (typeof style === 'function') {
      style = style(layer.feature);
    }
    if (layer.setStyle) {
      layer.setStyle(style);
    }
    return this;
  },

  /**
   * Utility Methods
   */

  eachActiveFeature: function (fn, context) {
    // figure out (roughly) which layers are in view
    if (this._map) {
      var activeBounds = this._map.getBounds();
      for (var i in this._layers) {
        if (this._currentSnapshot.indexOf(this._layers[i].feature.id) !== -1) {
          // a simple point in poly test for point geometries
          if (typeof this._layers[i].getLatLng === 'function' && activeBounds.contains(this._layers[i].getLatLng())) {
            fn.call(context, this._layers[i]);
          } else if (typeof this._layers[i].getBounds === 'function' && activeBounds.intersects(this._layers[i].getBounds())) {
            // intersecting bounds check for polyline and polygon geometries
            fn.call(context, this._layers[i]);
          }
        }
      }
    }
    return this;
  },

  eachFeature: function (fn, context) {
    for (var i in this._layers) {
      fn.call(context, this._layers[i]);
    }
    return this;
  },

  getFeature: function (id) {
    return this._layers[id];
  },

  bringToBack: function () {
    this.eachFeature(function (layer) {
      if (layer.bringToBack) {
        layer.bringToBack();
      }
    });
  },

  bringToFront: function () {
    this.eachFeature(function (layer) {
      if (layer.bringToFront) {
        layer.bringToFront();
      }
    });
  },

  redraw: function (id) {
    if (id) {
      this._redraw(id);
    }
    return this;
  },

  _redraw: function (id) {
    var layer = this._layers[id];
    var geojson = layer.feature;

    // if this looks like a marker
    if (layer && layer.setIcon && this.options.pointToLayer) {
      // update custom symbology, if necessary
      if (this.options.pointToLayer) {
        var getIcon = this.options.pointToLayer(geojson, leaflet.latLng(geojson.geometry.coordinates[1], geojson.geometry.coordinates[0]));
        var updatedIcon = getIcon.options.icon;
        layer.setIcon(updatedIcon);
      }
    }

    // looks like a vector marker (circleMarker)
    if (layer && layer.setStyle && this.options.pointToLayer) {
      var getStyle = this.options.pointToLayer(geojson, leaflet.latLng(geojson.geometry.coordinates[1], geojson.geometry.coordinates[0]));
      var updatedStyle = getStyle.options;
      this.setFeatureStyle(geojson.id, updatedStyle);
    }

    // looks like a path (polygon/polyline)
    if (layer && layer.setStyle && this.options.style) {
      this.resetStyle(geojson.id);
    }
  }
});

function featureLayer (options) {
  return new FeatureLayer(options);
}

// export version

exports.VERSION = version;
exports.Support = Support;
exports.options = options;
exports.Util = EsriUtil;
exports.get = get;
exports.post = xmlHttpPost;
exports.request = request;
exports.Task = Task;
exports.task = task;
exports.Query = Query;
exports.query = query;
exports.Find = Find;
exports.find = find;
exports.Identify = Identify;
exports.identify = identify;
exports.IdentifyFeatures = IdentifyFeatures;
exports.identifyFeatures = identifyFeatures;
exports.IdentifyImage = IdentifyImage;
exports.identifyImage = identifyImage;
exports.Service = Service;
exports.service = service;
exports.MapService = MapService;
exports.mapService = mapService;
exports.ImageService = ImageService;
exports.imageService = imageService;
exports.FeatureLayerService = FeatureLayerService;
exports.featureLayerService = featureLayerService;
exports.BasemapLayer = BasemapLayer;
exports.basemapLayer = basemapLayer;
exports.TiledMapLayer = TiledMapLayer;
exports.tiledMapLayer = tiledMapLayer;
exports.RasterLayer = RasterLayer;
exports.ImageMapLayer = ImageMapLayer;
exports.imageMapLayer = imageMapLayer;
exports.DynamicMapLayer = DynamicMapLayer;
exports.dynamicMapLayer = dynamicMapLayer;
exports.FeatureManager = FeatureManager;
exports.FeatureLayer = FeatureLayer;
exports.featureLayer = featureLayer;

Object.defineProperty(exports, '__esModule', { value: true });

})));


},{"leaflet":76}],62:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}],63:[function(require,module,exports){
!function(){"use strict";FileFunnel.i18n.en_US={add:"Add files",browse:"Choose file",cancel:"Cancel",delete:"Delete",reset:"Reset",upload:"Upload",previewOpen:"Maximize preview in new window",previewClose:"Close preview",bytes:" bytes",gibiBytes:" GiB",kibiBytes:" KiB",mebiBytes:" MiB",fileName:"Filename",fileSize:"Unknown size",fileType:"Unrecognized filetype",aborted:"Upload aborted",exists:"File already exists",failed:"Upload failed",forbidden:"Unauthorized for upload",invalidName:"Invalid filename",oversized:"File too big for upload",processing:"Processing, please wait...",refused:"Connection refused",rejected:"File rejected by server",success:"Upload successful",timeout:"Upload timed out",unsupported:"Unsupported filetype",unprocessable:"File unprocessable by server"},FileFunnel.i18n.en=FileFunnel.i18n.en_US}();
!function(){"use strict";FileFunnel.i18n.ja_JP={add:"ファイル追加",browse:"ファイル選択",cancel:"キャンセル",delete:"ファイル削除",reset:"リセット",upload:"アップロード",previewOpen:"新しいウィンドウでプレビューを最大にする",previewClose:"プレビューを閉じる",bytes:" バイト",gibiBytes:" GiB",kibiBytes:" KiB",mebiBytes:" MiB",fileName:"ファイルネーム",fileSize:"ファイルサイズ不明",fileType:"無認識のファイルタイプ",aborted:"アップロード中止された",exists:"ファイルがすでに存在します",failed:"アップロード失敗",forbidden:"アップロード無許可",invalidName:"ファイルネーム無効",oversized:"ファイルサイズが大きすぎる",processing:"処理中、お待ち下さい…",refused:"接続拒否",rejected:"ファイルがサーバーに拒絶された",success:"アップロード完成",timeout:"タイムアウト",unsupported:"ファイルタイプ非対応",unprocessable:"サーバーでファイル処理失敗"},FileFunnel.i18n.ja=FileFunnel.i18n.ja_JP}();
!function(){"use strict";FileFunnel.i18n.nb_NO={add:"Legg til filer",browse:"Velg fil",cancel:"Avbryt",delete:"Slett fil",reset:"Tilbakestill",upload:"Last opp",previewOpen:"Maksimér forhåndsvisning i nytt vindu",previewClose:"Lukk forhåndsvisning",bytes:" bytes",gibiBytes:" GiB",kibiBytes:" KiB",mebiBytes:" MiB",fileName:"Filnavn",fileSize:"Ukjent størrelse",fileType:"Ukjent filtype",aborted:"Opplasting avbrutt",exists:"Filen eksisterer allerede",failed:"Opplasting feilet",forbidden:"Ikke autorisert for opplasting",invalidName:"Ugyldig filnavn",oversized:"Filen er for stor for opplasting",processing:"Prosesserer, vennligst vent...",refused:"Tilkobling nektet",rejected:"Filen ble avvist av tjeneren",success:"Opplasting gjennomført",timeout:"Opplastingen ble tidsavbrutt",unsupported:"Filtypen er ikke støttet",unprocessable:"Filen kunne ikke prosesseres av tjeneren"},FileFunnel.i18n.no=FileFunnel.i18n.nb=FileFunnel.i18n.nb_NO}();
!function(){"use strict";FileFunnel.i18n.nl_BE={add:"Voeg bestanden toe",browse:"Selecteer bestand",cancel:"Annuleer",delete:"Verwijderen",reset:"Wissen",upload:"Uploaden",bytes:" bytes",gibiBytes:" GiB",kibiBytes:" KiB",mebiBytes:" MiB",fileName:"Bestandsnaam",fileSize:"Onbekende bestandsgrootte",fileType:"Onbekende bestandstype",aborted:"Upload geannuleerd",exists:"Bestand bestaat al",failed:"Upload mislukt",forbidden:"Upload niet toegestaan",invalidName:"Ongeldige bestandsnaam",oversized:"Bestand is te groot",processing:"Verwerking, even geduld...",refused:"Verbinding geweigerd",rejected:"[File rejected by server]",success:"Bestand succesvol geupload",timeout:"Tijd verstreken",unsupported:"Niet ondersteund bestandstype"}}();
!function(){"use strict";FileFunnel.i18n.nl_NL={add:"Voeg bestanden toe",browse:"Selecteer bestand",cancel:"Annuleer",delete:"Verwijderen",reset:"Wissen",upload:"Uploaden",bytes:" bytes",gibiBytes:" GiB",kibiBytes:" KiB",mebiBytes:" MiB",fileName:"Bestandsnaam",fileSize:"Onbekende bestandsgrootte",fileType:"Onbekende bestandstype",aborted:"Upload geannuleerd",exists:"Bestand bestaat al",failed:"Upload mislukt",forbidden:"Upload niet toegestaan",invalidName:"Ongeldige bestandsnaam",oversized:"Bestand is te groot",processing:"Verwerking, even geduld...",refused:"Verbinding geweigerd",rejected:"[File rejected by server]",success:"Bestand succesvol geupload",timeout:"Tijd verstreken",unsupported:"Niet ondersteund bestandstype"},FileFunnel.i18n.nl=FileFunnel.i18n.nl_NL}();
!function(){"use strict";FileFunnel.i18n.nn_NO={add:"Legg til filer",browse:"Velj fil",cancel:"Avbryt",delete:"Slett fil",reset:"Tilbakestill",upload:"Last opp",previewOpen:"Maksimér førehandsvisning i nytt vindauge",previewClose:"Lukk førehandsvisning",bytes:" bytes",gibiBytes:" GiB",kibiBytes:" KiB",mebiBytes:" MiB",fileName:"Filnamn",fileSize:"Ukjend storleik",fileType:"Ukjend filtype",aborted:"Opplasting avbrote",exists:"Fila eksisterer allereie",failed:"Opplasting feila",forbidden:"Ikkje autorisert for opplasting",invalidName:"Ugyldig filnamn",oversized:"Fila er for stor for opplasting",processing:"Prosesserar, vennlegst vent...",refused:"Tilkobling nekta",rejected:"Fila blei avvist av tenaren",success:"Opplasting gjennomført",timeout:"Opplastinga blei tidsavbrote",unsupported:"Filtypen er ikkje støtta",unprocessable:"Fila kunne ikkje prosesseres av tenaren"},FileFunnel.i18n.nn=FileFunnel.i18n.nn_NO}();
},{}],64:[function(require,module,exports){
!function(){"use strict";function e(e,t){return"string"==typeof e?(t||document).querySelector(e):null}function t(e,t){return[].slice.call((t||document).querySelectorAll(e))}function s(t,n){if(t instanceof s)return t;if(t instanceof HTMLElement&&!(this instanceof s))return new s(t,n);if(!(this instanceof s))return(t=e(t,n instanceof s?n.dom:n))?new s(t):null;n=Object.assign({appendTo:null,context:document,html:"",insertAfter:null,insertBefore:null,replace:null},n);var i,o,r=t instanceof HTMLElement?t:null;if("string"==typeof t){o=function(e,t){return e.match(/(\[[^\]]+\]|#[^#.\[]+|\.[^#.\[]+|\w+)/g).forEach(function(e){"["==e[0]?(e=e.match(/^\[([^=\]]+)=?([^\]]+)?\]$/))&&(t.attribs[e[1]]=e[2]||""):"."==e[0]?t.classes.push(e.substr(1)):"#"==e[0]?t.attribs.id=e.substr(1):t.tag=e}),t}(t,{attribs:{},classes:[]}),r=n.context.createElement(o.tag),o.classes.forEach(function(e){r.classList.add(e)});for(i in o.attribs)o.attribs.hasOwnProperty(i)&&r.setAttribute(i,o.attribs[i])}this.events={},this.dom=t instanceof HTMLElement?t:r,this.parent=t instanceof HTMLElement?s(t.parentElement):null,n.html&&r&&(r.innerHTML=n.html),(i=s(n.replace))?i.parent.replace(i,this):(i=s(n.appendTo))?i.append(this):(i=s(n.insertAfter))?i.parent.append(this,i):(i=s(n.insertBefore))&&i.parent.insert(this,i);var a=this.dom,l={add:function(){return[].slice.call(arguments).forEach(function(e){a.setAttribute(e,"")}),a.attributes},get:function(e){return a.getAttribute(arg)},remove:function(){return[].slice.call(arguments).forEach(function(e){a.removeAttribute(e)}),a.attributes},set:function(e,t){return a.setAttribute(e,t),a.attributes}};for(var u in l)a.attributes[u]=l[u]}function n(e,t){return this._callbacks={},this._elements={},this._i18n={},this._parent=s(e),this._options=Object.assign({accept:"*/*",autoResize:!0,auth:null,chunked:!1,chunkSize:1048576,className:"filefunnel",credentials:!1,emptyNames:!1,headers:{},maxSize:1/0,multiple:!1,preview:!1,progress:!1},t),this.files=[],this.locale=this._options.locale||(navigator?(navigator.userLanguage||navigator.language).replace("-","_"):null),this.status=n.status.NONE,this.build()}return"function"!=typeof Object.assign&&(Object.assign=function(e){if(void 0===e||null===e)throw new TypeError("Cannot convert undefined or null to object");var t,s,n,i=Object(e);for(t=1;t<arguments.length;++t)if(void 0!==(s=arguments[t])&&null!==s)for(n in s)s.hasOwnProperty(n)&&(i[n]=s[n]);return i}),s.prototype={add:function(e){return(e instanceof Array?e:[e]).forEach(function(e){(e=s(e))&&(this.dom.appendChild(e.dom),e.parent=this)},this),this},append:function(e,t){return(t=this.child(t))?this.dom.insertBefore(s(e).dom,t.dom.nextElementSibling):this.dom.appendChild(s(e).dom),e instanceof s&&(e.parent=this),this},get attribs(){return this.dom.attributes},child:function(n){if("string"==typeof n){var i,o,r,a,l=this.dom;if(n.split(" ").forEach(function(t,s,n){l&&s<n.length-1&&(l=e(t,l))}),l){o=[].slice.call(l.children),a=t(n,l);for(r in a)for(i in o)if(a[r]===o[i])return s(o[i])}}else{if(n instanceof s)return n.dom.parentElement===this.dom?n:null;if(n instanceof HTMLElement)return n.parentElement===this.dom?s(n):null}return null},get classes(){return this.dom.classList},clear:function(){for(var e,t=this.dom;e=t.firstChild;)t.removeChild(e);return this},get enabled(){return!this.dom.hasAttribute("disabled")},set enabled(e){return e?this.dom.removeAttribute("disabled"):this.dom.setAttribute("disabled",""),this.enabled},focus:function(){this.dom.focus(),this.dom.selectionStart=this.value.length},get html(){return this.dom.innerHTML},set html(e){return this.dom.innerHTML=e},insert:function(e,t){return this.dom.insertBefore(s(e).dom,(t=this.child(t))?t.dom:this.dom.firstElementChild),e instanceof s&&(e.parent=this),this},on:function(e,t,s){return(e instanceof Array?e:[e]).forEach(function(e){if("string"==typeof e){var n=this,i="function"==typeof t?function(e){return t.call(s||n,e)}:null;n.events[e]instanceof Array||(n.events[e]=[]),i?(n.events[e].push(i),n.dom.addEventListener(e,i)):n.events[e].forEach(function(t,s,i){n.dom.removeEventListener(e,t),i.splice(s,1)})}},this),this},remove:function(e){(e=s(e))&&this.dom.removeChild(e.dom)},replace:function(e,t){return(t=new s(t))&&(e=s(e,this))&&(this.dom.replaceChild(t.dom,e.dom),t.parent=this,e.parent=null),this},get value(){return void 0!==this.dom.value?this.dom.value:this.html},set value(e){return void 0!==this.dom.value?this.dom.value=e:this.html=e},get visible(){return!this.dom.hasAttribute("hidden")},set visible(e){return e?this.dom.removeAttribute("hidden"):this.dom.setAttribute("hidden",""),this.visible}},n.VERSION="0.12.5",n.status={NONE:0,READY:1,UPLOADING:2,COMPLETED:3,ABORTED:4,FAILED:5},n.prototype={abort:function(){this._elements.resetButton&&this._elements.resetButton.dom.click()},get auth(){return"string"==typeof this._options.auth?this._options.auth:null},set auth(e){return this._options.auth="string"==typeof e?e:null},browse:function(){this._elements.fileInput&&this._elements.fileInput.dom.click()},build:function(){var e=this,t=e.files,i=e._i18n,o=e._options,r=e._parent,a=("string"==typeof o.accept?o.accept:"*/*").replace(/[\[\]#\s]/g,"").split(","),l={form:new s("form[enctype=multipart/form-data][method=POST]."+o.className),browseButton:new s("input[type=button][value="+(o.multiple?i.add:i.browse)+"].browse"),fileInput:new s("input[type=file][accept="+a.join(",")+"][hidden][multiple]"),fileList:new s("div.filelist"),submitButton:new s("input[type=submit][value="+i.upload+"][disabled].submit"),resetButton:new s("input[type=reset][value="+i.reset+"].reset")},u={401:i.forbidden,403:i.forbidden,409:i.exists,412:i.invalidName,413:i.oversized,415:i.unsupported,422:i.unprocessable};return!0!==o.multiple&&l.fileInput.dom.removeAttribute("multiple"),l.form.add([l.browseButton,l.fileInput,l.fileList,l.submitButton,l.resetButton]),r&&(e._elements.form&&e._elements.form.parent?e._elements.form.parent.replace(e._elements.form,l.form):r.dom instanceof HTMLInputElement?(r.parent.append(l.form,r),l.form.classes.add("widget"),e._elements=l,e.hide().resize(),r.on("click",function(){e.toggle()}),document.addEventListener("click",function(t,s){if(l.form.visible){for(;s=s?s.parentNode:t.target;)if(s==l.form.dom||s==r.dom)return;e.hide()}}),window.addEventListener("resize",function(){!0===o.autoResize&&e.resize()})):r.append(l.form)),e._elements=l,l.browseButton.on("click",function(){l.fileInput.dom.click()}),l.fileInput.on("change",function(r){o.multiple||(t.length=0,l.fileList.clear()),[].slice.call(r.target.files).forEach(function(r){function u(e){var t=e.match(/^([^\/]+)\/(.*)$/);return function(s){return s==e||t&&s==t[1]+"/*"||"*/*"==s}}for(var r,c,f=r.size,d=r.lastModifiedDate,m={},p=0;p<t.length;++p)if((c=t[p].reference).name==r.name&&c.lastModifiedDate.valueOf()==d.valueOf())return;if(f=f>=1073741824?(f/1073741824).toFixed(2)+i.gibiBytes:f>=1048576?(f/1048576).toFixed(2)+i.mebiBytes:f>=1024?(f/1024).toFixed(2)+i.kibiBytes:f+=i.bytes,l.fileList.add(new s("fieldset.fileinfo").append(new s("legend",{html:r.name})).append(m.name=new s("input[type=text].name")).append(m.size=new s("input[type=text][disabled].size")).append(m.type=new s("input[type=text][disabled].type")).append(m.prog=new s("progress[value=0].progress")).append(m.view=new s("div[hidden].view")).append(m.info=new s("span.info"))),m.name.attribs.set("placeholder",i.fileName).set("value",r.name),m.size.attribs.set("placeholder",i.fileSize).set("value",f),m.type.attribs.set("placeholder",i.fileType).set("value",r.type),o.preview&&r.type.match(/^image\//)){var h=new FileReader;h.onload=function(){var e,t,n=h.result;m.view.add(e=new s("img")).add(t=new s("a.close",{html:"&times;"})).attribs.remove("hidden"),e.on("click",function(){window.open(n,"_blank")}).attribs.set("title",i.previewOpen).set("src",n),t.on("click",function(){m.view.visible=!1}).attribs.set("title",i.previewClose)},h.readAsDataURL(r)}o.emptyNames||m.name.on(["input","change"],function(e){e.target.value||n.status.READY!=r.status?i.invalidName==r.elements.info.value&&(r.status=n.status.READY,r.elements.info.classes.remove("error"),r.elements.info.value=""):(r.status=n.status.ABORTED,r.elements.info.classes.add("error"),r.elements.info.value=i.invalidName),l.submitButton.enabled=t.some(function(e){return n.status.READY==e.status})}),t.push(r={bytesSent:0,bytesTotal:r.size,elements:m,location:null,parent:e,reference:r,response:null,status:n.status.READY,xhr:null,get progress(){return n.status.UPLOADING==this.status?Math.round(this.bytesSent/this.bytesTotal*100):NaN},reject:function(){this.elements.info.classes.add("warning"),this.elements.info.classes.remove("error","success"),this.elements.info.value=i.rejected,this.elements.prog.attribs.set("max",1).set("value",1)}}),r.reference.size>o.maxSize?(r.status=n.status.ABORTED,r.elements.info.classes.add("error"),r.elements.info.value=i.oversized):a.some(u(r.reference.type))||(r.status=n.status.ABORTED,r.elements.info.classes.add("error"),r.elements.info.value=i.unsupported)}),e.status=t.length?n.status.READY:n.status.NONE,l.submitButton.enabled=t.some(function(e){return n.status.READY==e.status})}),l.form.on("submit",function(t){t.preventDefault(),e.upload()}),e.upload=function(){function s(s){for(var o in t)if(n.status.UPLOADING==t[o].status)return;l.resetButton.on("click",null),l.resetButton.value=i.reset,e.status=n.status.COMPLETED}if(l.browseButton.enabled=l.submitButton.enabled=!1,l.resetButton.value=i.cancel,e.status=n.status.UPLOADING,"string"==typeof o.auth&&(o.credentials=!0,o.headers=Object.assign({Authorization:o.auth},o.headers)),l.resetButton.on("click",function(e){if(e.preventDefault(),o.chunked)for(var s in t)t[s].xhr instanceof XMLHttpRequest&&t[s].xhr.abort();else t.xhr instanceof XMLHttpRequest&&t.xhr.abort()}),o.chunked){var r="number"==typeof o.chunkSize?o.chunkSize:1048576;t.forEach(function(t){if(t.status==n.status.READY){var a=t.elements.name.value,l=function(){var c=t.reference.slice(t.bytesSent,Math.min(t.bytesTotal,t.bytesSent+r)+1,t.reference.type),f=t.xhr=new XMLHttpRequest,d={};f.onloadstart=function(s){t.status=n.status.UPLOADING,"function"==typeof e._callbacks.start&&e._callbacks.start(t)},f.onreadystatechange=function(e,t){f.HEADERS_RECEIVED==f.readyState&&(t=f.getAllResponseHeaders())&&t.split("\r\n").forEach(function(e){(e=e.match(/\s*([^:]*)\s*:\s*(.*)\s*/))&&(d[e[1]]=e[2])})},f.upload.onprogress=function(s){s.lengthComputable&&(t.elements.prog.value=t.bytesSent+s.loaded),t.bytesSent+s.loaded>=t.bytesTotal&&(t.elements.info.value=i.processing),"function"==typeof e._callbacks.progress&&e._callbacks.progress(t)},f.onload=function(o){var r=o.target.status;if(t.response={headers:d,code:r,text:f.responseText,json:(d["Content-Type"]||"").match(/\/(?:json|.+\+json)(?:$|;)/)?JSON.parse(f.responseText):null},200<=r&&300>r){if(t.elements.prog.attribs.set("max",t.bytesTotal).set("value",t.bytesSent+=c.size),t.bytesSent<t.bytesTotal)return"function"==typeof l&&l();t.status=n.status.COMPLETED,t.elements.info.classes.add("success"),t.elements.info.value=i.success,s(t),201==r&&(t.location=f.getResponseHeader("Content-Location")||null),"function"==typeof e._callbacks.success&&e._callbacks.success(t)}else 400<=r&&(t.status=n.status.FAILED,t.elements.info.classes.add("error"),t.elements.info.value=u[r]||i.failed,s(t),"function"==typeof e._callbacks.error&&e._callbacks.error(t))},f.onabort=function(){t.status=n.status.ABORTED,t.elements.info.value=i.aborted,s(t),"function"==typeof e._callbacks.abort&&e._callbacks.abort(t)},f.ontimeout=function(){t.status=n.status.FAILED,t.elements.info.classes.add("error"),t.elements.info.value=i.timeout,s(t),"function"==typeof e._callbacks.error&&e._callbacks.error(t)},f.onerror=function(){t.status=n.status.FAILED,t.elements.info.classes.add("error"),t.elements.info.value=i.refused,s(t),"function"==typeof e._callbacks.error&&e._callbacks.error(t)};var m,p=Object.assign({"Content-Type":c.type,"X-File-Name":a,"X-File-Size":t.bytesTotal},o.headers);f.open("POST",o.server,!0),f.withCredentials=o.credentials===!0;for(m in p)f.setRequestHeader(m,p[m]);f.send(c)};t.elements.prog.attribs.set("max",t.bytesTotal),l()}})}else{var a,c=t.xhr=new XMLHttpRequest,f=new FormData,d=0,m=0,p={};c.onloadstart=function(s){t.forEach(function(t){n.status.READY==t.status&&(t.status=n.status.UPLOADING,t.elements.prog.attribs.remove("max","value"),"function"==typeof e._callbacks.start&&e._callbacks.start(t))})},c.onreadystatechange=function(e,t){c.HEADERS_RECEIVED==c.readyState&&(t=c.getAllResponseHeaders())&&t.split("\r\n").forEach(function(e){(e=e.match(/\s*([^:]*)\s*:\s*(.*)\s*/))&&(p[e[1]]=e[2])})},o.progress&&(c.upload.onprogress=function(s){s.lengthComputable&&(a=t[d])&&n.status.UPLOADING==a.status&&(a.elements.prog.attribs.set("max",a.bytesTotal).set("value",a.bytesSent=Math.min(a.bytesTotal,s.loaded-m)),a.bytesSent>=a.bytesTotal&&(++d,m+=a.bytesTotal,a.elements.info.value=i.processing),"function"==typeof e._callbacks.progress&&e._callbacks.progress(a))}),c.onload=function(o){var r=o.target.status;t.forEach(function(t){n.status.UPLOADING==t.status&&(t.response={headers:p,code:c.status,text:c.responseText,json:(p["Content-Type"]||"").match(/\/(?:json|.+\+json)(?:$|;)/)?JSON.parse(c.responseText):null},200<=r&&300>r?(t.status=n.status.COMPLETED,t.bytesSent=t.bytesTotal,t.elements.prog.attribs.set("max",1).set("value",1),t.elements.info.classes.add("success"),t.elements.info.value=u[r]||i.success,s(t),"function"==typeof e._callbacks.success&&e._callbacks.success(t)):400<=r&&(t.status=n.status.FAILED,t.elements.prog.attribs.set("max",1).set("value",0),t.elements.info.classes.add("error"),t.elements.info.value=u[r]||i.failed,s(t),"function"==typeof e._callbacks.error&&e._callbacks.error(t)))})},c.onabort=function(){t.forEach(function(t){t.status=n.status.ABORTED,t.elements.prog.attribs.set("max",1).set("value",0),t.elements.info.value=i.aborted,s(t),"function"==typeof e._callbacks.abort&&e._callbacks.abort(t)})},c.ontimeout=function(){t.forEach(function(t){t.status=n.status.FAILED,t.elements.prog.attribs.set("max",1).set("value",0),t.elements.info.classes.add("error"),t.elements.info.value=i.timeout,s(t),"function"==typeof e._callbacks.error&&e._callbacks.error(t)})},c.onerror=function(o){t.forEach(function(t){t.status=n.status.FAILED,t.elements.prog.attribs.set("max",1).set("value",0),t.elements.info.classes.add("error"),t.elements.info.value=i.refused,s(t),"function"==typeof e._callbacks.error&&e._callbacks.error(t)})},t.forEach(function(e){e.status==n.status.READY&&(f.append(e.reference.name,e.reference,e.elements.name.value),e.elements.prog.dom.removeAttribute("value"))});var h,b=o.headers;c.open("POST",o.server,!0),c.withCredentials=o.credentials===!0;for(h in b)c.setRequestHeader(h,b[h]);c.send(f)}},l.form.on("reset",function(){t.length=0,l.fileList.clear(),l.browseButton.enabled=!0,l.submitButton.enabled=!1,l.resetButton.value=i.reset,e.status=n.status.NONE,"function"==typeof e._callbacks.reset&&e._callbacks.reset()}),this},get element(){return this._parent?this._parent.dom:null},get headers(){return this._options.headers},hide:function(){return this._elements.form&&(this._elements.form.visible=!1),this},get locale(){return this._i18n._id},set locale(e){return(this._i18n=Object.assign({_id:n.i18n[e]?e:"en_GB"},n.i18n.en_GB,n.i18n[e]))._id},on:function(e,t){return(e instanceof Array?e:[e]).forEach(function(e){if(-1==["start","progress","success","abort","error","reset"].indexOf(e))throw"Unrecognized FileFunnel event: "+e;this._callbacks[e]="function"==typeof t?t:null},this),this},reset:function(){this._elements.form&&this._elements.form.dom.reset()},resize:function(e){return this._elements.form&&this._parent&&(this._elements.form.dom.style.width=(isNaN(e=Number(e))?this._parent.dom.offsetWidth:e)+"px"),this},get server(){return"string"==typeof this._options.server?this._options.server:null},set server(e){return this._options.server="string"==typeof e?e:null},show:function(){return this._elements.form&&(this._elements.form.visible=!0),this},toggle:function(){return this._elements.form&&(this._elements.form.visible=!this._elements.form.visible),this},upload:function(){}},n.i18n={en_GB:{add:"Add files",browse:"Choose file",cancel:"Cancel",delete:"Delete",reset:"Reset",upload:"Upload",previewOpen:"Maximise preview in new window",previewClose:"Close preview",bytes:" bytes",gibiBytes:" GiB",kibiBytes:" KiB",mebiBytes:" MiB",fileName:"Filename",fileSize:"Unknown size",fileType:"Unrecognised filetype",aborted:"Upload aborted",exists:"File already exists",failed:"Upload failed",forbidden:"Unauthorised for upload",invalidName:"Invalid filename",oversized:"File too big for upload",processing:"Processing, please wait...",refused:"Connection refused",rejected:"File rejected by server",success:"Upload successful",timeout:"Upload timed out",unsupported:"Unsupported filetype",unprocessable:"File unprocessable by server"}},"undefined"!=typeof window&&(window.FileFunnel=n),"object"==typeof module&&module.exports&&(module.exports=n),n}();
},{}],65:[function(require,module,exports){
var angular = require("angular");var tv4 = require("tv4");module.exports = /* globals angular */

(function() {
  "use strict";

  /**
   * formula.js
   * Generic JSON Schema form builder
   *
   * Norsk Polarinstutt 2014, http://npolar.no/
   */

  angular.module('formula', []);
})();

/* globals angular */
angular.module('formula').directive('formulaField', ['$compile', 'formulaClassService', 'formulaI18n',
  function($compile, formulaClassService, i18n) {
    "use strict";

    return {
      restrict: 'AE',
      scope: {
        field: '='
      },
      link: function(scope, iElement, iAttrs) {
        var field = scope.field;
        iElement.addClass(formulaClassService.pathClass(field));
        iElement.addClass(formulaClassService.schemaClass(field));
        if (field.required) {
          iElement.addClass('required');
        }
        scope.i18n = i18n;
        scope.$watch('field.template', function (template) {
          if (!field.hidden && field.template) {
            iElement.html(field.template);
            $compile(iElement.contents())(scope);
            field._elem_q.resolve(iElement);
          } else {
            field._elem_q.reject(iElement);
          }
        });
      },
    };
  }
]);

/* globals angular */
angular.module('formula').directive('formulaFields', ['$compile', 'formulaClassService', 'formulaI18n',
  function($compile, formulaClassService, i18n) {
    "use strict";


    return {
      restrict: 'AE',
      scope: {
        fields: '='
      },
      compile: function(tElement, tAttrs) {
        if (tElement.html()) {
          var innerTemplate = tElement.html();
          tElement.empty();
        }
        return function link(scope, iElement, iAttrs) {
          scope.i18n = i18n;
          scope.fields.forEach(function(field) {
            var fieldScope = scope.$new();
            fieldScope.field = field;
            fieldScope.parent = field.parents[field.parents.length - 1];
            var template = innerTemplate || '<formula:field field="field"></formula:field>';
            if (!field.hidden && template) {
              $compile(template)(fieldScope, function(cloned, scope) {
                iElement.append(cloned);
              });
            }
          });
        };
      }
    };
  }
]);

/* globals angular */
angular.module('formula').directive('formulaFieldsets', ['$compile', 'formulaClassService', 'formulaDirtyCheckService',
  function($compile, formulaClassService, formulaDirtyCheckService) {
    "use strict";

    return {
      restrict: 'AE',
      require: '?^^form',
      link: function(scope, iElement, iAttrs, formController) {
        scope.form.fieldsets.forEach(function(fieldset) {
          var template = fieldset.template;
          if (!fieldset.hidden && template) {
            var fieldsetScope = scope.$new();
            var elem = angular.element(template);
            fieldsetScope.fieldset = fieldset;
            elem.addClass(formulaClassService.schemaClass(fieldset));
            $compile(elem)(fieldsetScope, function(cloned, scope) {
              iElement.append(cloned);
            });

            if (formController) {
              formController.$setPristine();
              formulaDirtyCheckService.setForm(formController);
            }
          }
        });
      }
    };
  }
]);

/* globals angular */
angular.module('formula').directive('formula', ['$compile', '$timeout', 'formulaI18n', 'formulaClassService',
  function($compile, $timeout, i18n, formulaClassService) {
    "use strict";


    return {
      restrict: 'AE',
      scope: {
        options: '='
      },
      controller: ['$scope', function($scope) {
        if (!$scope.options) {
          throw "No formula options provided!";
        }

        var controller = {
          setLanguage: function(code) {
            $scope.language = code;
            if (this.form) {
              this.form.translate();
            }
            $timeout();
          },

          setForm: function(form) {
            $scope.form = this.form = form;
          }
        };

        var init = function () {
          controller.setForm($scope.options.form);
          controller.setLanguage(i18n.code);

          $scope.options.controller = controller;
          $scope.i18n = i18n;
        };

        init();
      }],
      link: function(scope, iElement, iAttrs) {
        scope.$watch('form', function(form) {
          if (form) {
            iElement.addClass(formulaClassService.schemaClass(form));
            iElement.html(form.template);
            $compile(iElement.contents())(scope);

            // http://stackoverflow.com/a/19686824/1357822
            var to;
            var listener = scope.$watch(function() {
              clearTimeout(to);
              to = setTimeout(function() {
                listener();
                $timeout(function() {
                  scope.form.ready = true;
                }, 100);
              }, 50);
            });
          }
        });
      }
    };
  }
]);

/* globals angular */
angular.module('formula').directive('formulaInput', ['$compile',
  function($compile) {
    "use strict";


    var getInputElement = function(field, type, element) {
      var elem;
      switch (type.sub) {
        case 'textarea':
          elem = angular.element('<textarea>');
          elem.attr('md-detect-hidden', true); // FIXME move to template in common
          break;

        case 'select':
          elem = angular.element('<select>');

          if (element.children().length) {
            angular.forEach(element.children(), function(child) {
              elem.append(child);
            });
          } else {
            elem.attr('ng-options', 'value.id as value.label for value in field.values');
          }

          if (field.multiple) {
            elem.attr('multiple', 'multiple');
          }
          break;

        default:
          elem = angular.element('<input>');
          elem.attr('type', type.sub);

          switch (type.sub) {
            case 'number':
            case 'range':
              if (field.step !== null) {
                elem.attr('step', field.step);
              }
              break;

            case 'any':
            case 'date':
            case 'datetime':
            case 'time':
              elem.attr('type', 'text');
              break;
          }
      }

      return elem;
    };


    var getType = function(field) {
      var type = field.type ? field.type.split(':') : null;
      type = type ? {
        main: type[0],
        sub: type[1]
      } : null;
      return type;
    };


    var setAttrs = function(attrs) {
      attrs.$set('id', '{{field.uid}}');
      attrs.$set('ngModel', 'field.value');
      attrs.$set('ng-disabled', 'field.disabled');
      attrs.$set('ng-readonly', 'field.readonly');
    };

    var getElement = function(scope, element, attrs) {
      var field = scope.field;
      var type = getType(field);
      var elem = getInputElement(field, type, element);

      angular.forEach(attrs, function(val, key) {
        if (attrs.$attr[key]) {
          elem.attr(attrs.$attr[key], val);
        }
      });
      return elem;
    };

    return {
      restrict: 'AE',
      scope: {
        field: '='
      },
      compile: function(tElement, tAttrs, transclude) {

        return function link(scope, iElement, iAttrs) {
          setAttrs(iAttrs);
          var elem = getElement(scope, iElement, iAttrs);
          elem.removeAttr('formula:input');
          $compile(elem)(scope, function(cloned, scope) {
            iElement.replaceWith(cloned);
          });
        };
      }
    };
  }
]);

/* globals angular */
angular.module('formula').factory('formulaFieldset', ['formulaFieldBuilder', 'formulaTemplateService',
  function(fieldBuiler, templates) {
    "use strict";


    function fieldsetFromSchema(schema, data) {
      if (schema && schema.type === 'object') {
        var fieldsets = [{
          fields: [],
          active: true,
          id: 'the-fieldset',
          mainType: '@fieldset',
          valid: true
        }];

        Object.keys(schema.properties).forEach(function(key) {
          var val = schema.properties[key];
          var newField = fieldBuiler.build({
            schema: val,
            id: key
          });
          if (newField) {
            newField.setRequired(schema.required);
            newField.valueFromModel(data);
            fieldsets[0].fields.push(newField);
          }
        });
        templates.initNode(fieldsets[0]);
        return fieldsets;
      }

      throw "Can't create fieldsets from schema";
    }

    var fieldsetFromDefinition = function(schema, formDefinition, data) {
      if (schema && schema.type === 'object' && formDefinition.fieldsets) {
        var fieldsets = [];

        formDefinition.fieldsets.forEach(function(fs, i) {
          var fieldset = {
            title: fs.title,
            active: (i ? false : true),
            fields: [],
            id: 'fs' + i,
            mainType: '@fieldset',
            valid: true
          };
          fieldsets.push(fieldset);
          fs.fields.forEach(function(f, j) {
            var key = (typeof f === 'string') ? f : f.id;
            var fieldSchema = schema.properties[key] || {
              id: key
            };
            var duplicate = fieldsets.reduce(function (memo, fieldset) {
              return memo.concat(fieldset.fields);
            }, []).find(function (field) {
              return field.id === key;
            });
            var newField = fieldBuiler.build({
              schema: fieldSchema,
              id: key,
              fieldDefinition: f
            });

            if (duplicate) {
              newField.value = duplicate.value;
              if (duplicate.values) {
                newField.values = duplicate.values;
              }
              if (duplicate.fields) {
                newField.fields = duplicate.fields;
              }
            }

            if (newField) {
              newField.setRequired(schema.required);
              newField.valueFromModel(data);
              fieldset.fields.push(newField);
            }
          });
          templates.initNode(fieldset);
        });
        return fieldsets;
      }

      throw "Can't create fieldsets from schema/formDefinition";
    };

    return {
      fieldsetFromSchema: fieldsetFromSchema,
      fieldsetFromDefinition: fieldsetFromDefinition
    };
  }
]);

/* globals angular,window,console */
angular.module('formula').factory('formulaForm', ['$rootScope', '$location', 'formulaJsonLoader', 'formulaModel', 'formulaI18n',
  'formulaEvaluateConditionsService', 'formulaTemplateService', 'formulaFieldset', 'formulaDirtyCheckService',
  function($rootScope, $location, jsonLoader, Model, i18n, formulaEvaluateConditionsService, templates, formulaFieldset, dirtyCheckService) {
    "use strict";

    /**
     * @class form
     *
     * HTML form handler class.
     *
     * @param schema Mandatory JSON Schema object
     * @param data
     * @param formDefinition Optional form definition object
     */
    function Form(schema, data, formDefinition, keepFailing) {
      this.errors = null;

      this.schema = schema;
      this.formDefinition = formDefinition;
      this.title = null;
      this.valid = false;
      this.model = new Model(data);
      this.mainType = '@form';

      templates.initNode(this);
      formulaEvaluateConditionsService.setKeepFailing(!!keepFailing);

      var defaultLang = 'en';
      if (formDefinition) {
        this.title = formDefinition.title;
        this.fieldsets = formulaFieldset.fieldsetFromDefinition(schema, formDefinition, this.model.data);

        defaultLang = formDefinition.lang || defaultLang;
      } else {
        this.fieldsets = formulaFieldset.fieldsetFromSchema(schema, this.model.data);
      }

      this.onsave = function(model) {
        window.open("data:application/json," + JSON.stringify(model));
        this.ready = true;
      };

      var self = this;
      this.destroyWatcher = $rootScope.$on('revalidate', function() {
        self.validate();
      });
      this.destoryDirtyChecker = $rootScope.$on('$locationChangeStart', function(event, next, prev) {
        if (dirtyCheckService.isDirty() && self.confirmDirtyNavigate) {
          event.preventDefault();
          self.confirmDirtyNavigate(function () {
            dirtyCheckService.override();
            var baseTag = document.head.querySelector('base'), base;
            base = baseTag ? baseTag.href.replace(/\/$/, '') : location.protocol + '//' + location.host;
            $location.path(next.replace(base, ''));
          });
        }
      });

      i18n.addDefaultLanguage(this, defaultLang).then(function () {
        self.translate();
      });
      this.activate = this.activate.bind(this);
      this.validate(true, true);
    }

    var collectFields = function(field) {
      var fields = [];

      var recurseField = function(field) {
        fields.push.apply(fields, collectFields(field));
      };

      if (field.typeOf('array')) {
        field.items.forEach(recurseField);
        field.values.forEach(recurseField);
      } else if (field.typeOf('object')) {
        field.fields.forEach(recurseField);
      }
      fields.push(field);

      return fields;
    };

    Form.prototype = {

      updateTemplates: function() {
        templates.initNode(this);
        this.fieldsets.forEach(templates.initNode);
        this.fields().forEach(templates.initNode);
      },

      updateTemplate: function(template) {
        templates.evalTemplate(this, template);
        this.fieldsets.forEach(function(fieldset) {
          templates.evalTemplate(fieldset, template);
        });
        this.fields().forEach(function(field) {
          templates.evalTemplate(field, template);
        });
      },

      fields: function() {
        var fields = [];
        this.fieldsets.forEach(function(fieldset) {
          fieldset.fields.forEach(function(field) {
            fields.push.apply(fields, collectFields(field));
          });
        });
        return fields;
      },

      destroy: function() {
        this.fields().forEach(function(field) {
          field.destroy();
        });
        this.destroyWatcher();
        this.destoryDirtyChecker();
      },

      /**
       * @method activate
       *
       * Function used to activate a specified fieldset.
       * Useful to hide inactive fieldsets when using a tabbed environment.
       *
       * @param fieldset An object or an index number representing the fieldset
       */
      activate: function(fieldset) {
        if (!this.fieldsets) {
          return; // might be called before form is ready
        }
        var fs;
        this.fieldsets.forEach(function(f, i) {
          if (typeof fieldset === 'object' || typeof fieldset === 'number') {
            if ((typeof fieldset === 'object') ? (f === fieldset) : (i === fieldset)) {
              f.active = true;
              fs = f;
            } else {
              f.active = false;
            }
          }
        });
        $rootScope.$broadcast('activate:fieldset', fs);
      },

      /**
       * @method toggleArrays
       *
       * Function used to collapse/expand all arrays in the form.
       */
      toggleArrays: function() {
        this.fieldsets.forEach(function(fieldset) {
          fieldset.fields.forEach(function(field) {
            field.values.forEach(function(value, index) {
              field.itemToggle(index);
            });
          });
        });
      },

      /**
       * @method save
       *
       * Function calling a provided callback function used to save the form.
       * This function automatically injects the current form model object as a parameter.
       * If the callback parameter is not set, the model is displayed in a new window.
       *
       * @param validate Prevent form validation if this parameter is set to false
       */
      save: function(validate) {
        if ((validate !== false) && !this.validate(true)) {
          console.warn('Document not vaild', this.errors);
          throw this.errors;
        }

        if (typeof this.onsave === 'function') {
          this.ready = false;
          return this.onsave(this.model.data);
        }
      },

      /**
       * @method translate
       *
       * Function used to translate the form to language set in i18n service.
       *
       */
      translate: function() {
        this.fieldsets.forEach(function(fs, i) {
          if (i18n.fieldsets) {
            fs.title = i18n.fieldsets[i] || fs.title;
          }
          if (i18n.fields) {
            fs.fields.forEach(function(field) {
              if (i18n.fields[field.id]) {
                field.translate(i18n.fields[field.id]);
              }
            });
          }
        });
      },

      /**
       * @method validate
       *
       * Function used to validate all the fields within the form.
       * This function also populates the form errors member if the validation fails.
       *
       * @returns true if the entire form is valid, otherwise false
       */
      validate: function(force, silent) {
        var form = this;
        this.errors = [];
        var fieldValidate = function(field, fieldset) {
          var valid = true;
          if (field.typeOf('array')) {
            field.values.forEach(function(value) {
              fieldValidate(value, fieldset);
            });
          } else if (field.typeOf('object')) {
            field.fields.forEach(function(subfield) {
              fieldValidate(subfield, fieldset);
            });
          }

          // jshint -W041,-W116
          if ((field.dirty || force) && field.instance == null) {
            if (field.validate(force, silent)) {
              delete fieldset.errors[field.id];
            } else {
              if (field.typeOf('input') && !silent) {
                fieldset.errors[field.id] = field.error;
              }
              valid = false;
            }
          }
          return valid;
        };

        this.valid = true;
        this.fieldsets.forEach(function(fieldset) {
          fieldset.valid = true;
          fieldset.errors = fieldset.errors || {};
          fieldset.fields.forEach(function(field) {
            if (fieldValidate(field, fieldset)) {
              form.model.data[field.id] = field.value;
            } else {
              fieldset.valid = silent || (field.valid === false ? false : fieldset.valid);
              form.valid = false;
              delete form.model.data[field.id];
            }
          });
          form.errors = form.errors.concat(Object.keys(fieldset.errors).map(function (key) {
            return key + ': ' + fieldset.errors[key];
          }));
        });

        formulaEvaluateConditionsService.evaluateConditions(this);

        if (this.valid) {
          this.errors = null;
        }
        return this.valid;
      }
    };

    return Form;
  }
]);

/* globals angular */
angular.module('formula').factory('formulaFormat', [function() {
  "use strict";

  return {
    color: // CSS 2.1 color
      function(data, schema) {
      var colors = "aqua,black,blue,fuchsia,gray,green,lime,maroon,navy,olive,orange,purple,red,silver,teal,white,yellow";

      if (typeof data === 'string') {
        // TODO: rgb-colors restricted to values between 0 and 255 (inclusive)
        if (colors.split(',').indexOf(data.toLowerCase()) !== -1 || /^(#([a-f0-9]{3}|[a-f0-9]{6})|rgb\(\s?\d{1,3}%?,\s?\d{1,3}%?,\s?\d{1,3}%?\s?\))$/i.test(data)) {
          return null;
        }

      }

      return 'CSS 2.1 color';
    },
    date: // ISO 8601 date
      function(data, schema) {
      if (typeof data === 'string' && /^\d{4}(-\d{2}){2}$/.test(data)) {
        return null;
      }

      return 'ISO 8601 date, e.g. 2015-11-30 (year-month-day)';
    },
    datetime: // ISO 8601 datetime combination
      function(data, schema) {
      if (typeof data === 'string' && /^\d{4}(-\d{2}){2}T\d{2}(:\d{2}){2}(.\d+)?(([+-](\d{2}|\d{4}|\d{2}:\d{2}))|Z)$/.test(data)) {
        return null;
      }

      return 'ISO 8601 datetime, e.g. 2015-11-30T23:45:30Z';
    },
    yearmonth: // ISO 8601 date (without day)
      function(data, schema) {
      if (typeof data === 'string' && /^\d{4}-\d{2}$/.test(data)) {
        return null;
      }

      return 'ISO 8601 date without day fraction, e.g. 2016-01 (year-month)';
    },
    year: // ISO 8601 four-digit year
      function(data, schema) {
      if (typeof data === 'string' && /^\d{4}$/.test(data)) {
        return null;
      }

      return 'ISO 8601 four-digit year, e.g. 2015';
    },
    email: // RCF 3696 email
      function(data, schema) {
      var local = /^[-+a-z0-9!#$%&'*=?^_`{|}~\/]([-+a-z0-9!#$%&'*=?^_`{|}~\/]|\.(?!\.)){0,62}[-+a-z0-9!#$%&'*=?^_`{|}~\/]$/i,
        domain = /^[-a-z0-9]([-a-z0-9]|\.(?!\.)){0,253}[-a-z0-9]$/i, // TODO: IPv4 and IPv6 support
        comment = /\(.*\)/g,
        parts = (typeof data === 'string' ? data.split('@') : []);

      if (parts.length === 2 && data.length <= 254) {
        if (local.test(parts[0].replace(comment, '')) && domain.test(parts[1].replace(comment, ''))) {
          return null;
        }
      }

      return 'RCF 3696 e-mail address';
    },
    time: // ISO 8601 time
      function(data, schema) {
      if (typeof data === 'string' && /^\d{2}(:\d{2}){2}$/.test(data)) {
        return null;
      }

      return 'ISO 8601 time, e.g. 23:45:30';
    },
    uri: // RFC 3986 URI
      function(data, schema) {
      if (typeof data === 'string' && /^([a-z][a-z0-9+.-]*):(?:\/\/((?:(?=((?:[a-z0-9-._~!$&'()*+,;=:]|%[0-9A-F]{2})*))(\3)@)?(?=(\[[0-9A-F:.]{2,}\]|(?:[a-z0-9-._~!$&'()*+,;=]|%[0-9A-F]{2})*))\5(?::(?=(\d*))\6)?)(\/(?=((?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*))\8)?|(\/?(?!\/)(?=((?:[a-z0-9-._~!$&'()*+,;=:@\/]|%[0-9A-F]{2})*))\10)?)(?:\?(?=((?:[a-z0-9-._~!$&'()*+,;=:@\/?]|%[0-9A-F]{2})*))\11)?(?:#(?=((?:[a-z0-9-._~!$&'()*+,;=:@\/?]|%[0-9A-F]{2})*))\12)?$/i.test(data)) {
        return null;
      }

      return 'RFC 3986 URI';
    }
  };
}]);

/* globals angular */
angular.module('formula').factory('formula', ['$q', 'formulaI18n', 'formulaTemplateService', 'formulaSchema', 'formulaJsonLoader', 'formulaForm',
  function($q, i18n, templates, Schema, jsonLoader, Form) {
    "use strict";


    var Formula = function(options) {
      if (!options) {
        throw "No formula options provided!";
      }
      var _cfg = {};
      var schema = new Schema();
      var formDefinition;
      var asyncs = [schema.deref(options.schema), jsonLoader(options.model), jsonLoader(options.form)];
      var setLanguage = function(code) {
        i18n.set(code).then(function() {
          if (_cfg.controller) {
            _cfg.controller.setLanguage(code);
          }
        });
      };


      if (options.templates instanceof Array) {
        templates.setTemplates(options.templates);
      }

      var languagePromises = (options.languages instanceof Array ? options.languages : []).map(function(language, index) {
        return i18n.add(language.uri || language.map, language.code, language.aliases);
      });

      $q.all(languagePromises).then(function (responses) {
        setLanguage(options.language || 'en');
      });

      var formLoaded = $q.all(asyncs).then(function(responses) {
        formDefinition = responses[2];
        createForm(responses[1], responses[2]);
        return responses;
      }, function() {
        console.error('Could not load form', arguments);
      });

      var createForm = function(model, form) {
        if (_cfg.form) {
          _cfg.form.destroy();
        }
        _cfg.form = new Form(schema.json, model, form, options.keepFailing);
        if (_cfg.controller) {
          _cfg.controller.setForm(_cfg.form);
          _cfg.form.translate();
        }
        _cfg.form.onsave = options.onsave || _cfg.form.onsave;
        _cfg.form.confirmDirtyNavigate = options.confirmDirtyNavigate;
      };

      this.setModel = function(model) {
        options.model = model;
        formLoaded.then(function(responses) {
          createForm(model, formDefinition);
        });
      };

      this.getModel = function() {
        return _cfg.form ? _cfg.form.model.data : options.model;
      };

      this.setForm = function(form) {
        var asyncs = [formLoaded];
        if (typeof form === 'string') {
          asyncs.push(jsonLoader(form));
        } else {
          asyncs.push(Promise.resolve(form));
        }
        $q.all(asyncs).then(function(responses) {
          formDefinition = responses[1];
          createForm(options.model, responses[1]);
        });
      };

      this.setTemplates = function(templates) {
        templates.setTemplates(templates);
        formLoaded.then(function(responses) {
          _cfg.form.updateTemplates();
        });
      };

      this.addTemplate = function(template) {
        templates.addTemplate(template);
        formLoaded.then(function(responses) {
          _cfg.form.updateTemplate(template);
        });
      };

      this.setOnSave = function(onsave) {
        options.onsave = onsave;
        if (_cfg.form) {
          _cfg.form.onsave = onsave;
        }
      };

      this.save = function() {
        return _cfg.form.save();
      };

      this.getSchema = function () {
        var deferred = $q.defer();
        formLoaded.then(function(responses) {
          deferred.resolve(_cfg.form.schema);
        });
        return deferred.promise;
      };

      this.getFieldByPath = function (jsonPath) {
        var deferred = $q.defer();
        formLoaded.then(function(responses) {
          var field = _cfg.form.fields().find(function (field) {
            return field.path === jsonPath;
          });
          deferred.resolve(field);
        });
        return deferred.promise;
      };

      this.getFields = function () {
        var deferred = $q.defer();
        formLoaded.then(function(responses) {
          deferred.resolve(_cfg.form.fields());
        });
        return deferred.promise;
      };

      this.i18n = {
        add: i18n.add,
        set: setLanguage,
        get code() {
          return i18n.code;
        }
      };

      this.setConfirmDirtyNavigate = function (confirm) {
        options.confirmDirtyNavigate = confirm;
        if (_cfg.form) {
          _cfg.form.confirmDirtyNavigate = confirm;
        }
      };

      this._cfg = _cfg;
      return this;
    };

    return {
      getInstance: function(options) {
        return new Formula(options);
      }
    };
  }
]);

/* globals angular, tv4 */
angular.module('formula').factory('formulaI18n', ['formulaJsonLoader', 'formulaLog', '$q',
  function(jsonLoader, log, $q) {
    "use strict";

    var DEFAULT_TEXTS = {
      code: 'en',
      text: {
        actions: {
          label: 'More',
          tooltip: 'Click for more actions'
        },
        add: {
          label: 'Add',
          tooltip: 'Click to add a new item'
        },
        invalid: '{count} invalid fields',
        moveup: {
          label: 'Move up',
          tooltip: 'Click to move item up'
        },
        movedown: {
          label: 'Move down',
          tooltip: 'Click to move item down'
        },
        maximize: {
          label: 'Maximize',
          tooltip: 'Click to maximize item'
        },
        minimize: {
          label: 'Minimize',
          tooltip: 'Click to minimize item'
        },
        remove: {
          label: 'Remove',
          tooltip: 'Click to remove item'
        },
        required: 'required',
        save: {
          label: 'Save',
          tooltip: 'Click to save document'
        },
        validate: {
          label: 'Validate',
          tooltip: 'Click to validate form'
        },
        item: 'Item {item}: {error}',
      },
      fields: {},
      fieldsets: []
    };

    var currentLocale = DEFAULT_TEXTS;
    var cache = {};
    var languagePromises = {};
    var codeAliases = {};

    var set = function(code) {
      var cacheKey = codeAliases[code];
      tv4.language(cacheKey.replace('_', '-'));
      if (languagePromises[cacheKey]) {
        return Promise.resolve(languagePromises[cacheKey]).then(function(locale) {
          currentLocale = locale;
          currentLocale.code = cacheKey;
        });
      }

    };

    var addTv4 = function(lang, key) {
      if (lang.tv4) {
        tv4.addLanguage(key.replace('_', '-'), lang.tv4);
      }
    };

    /**
     * @method add
     *
     * Function used to add a new translation from JSON URI.
     *
     * @param lang URI to JSON containing translation or translation object
     * @param code for this translation
     * @param code aliases. eg. no => nb => nb_NO
     * @returns $q promise object resolving to ISO 639-3 code
     */

    var add = function(lang, code, aliases) {
      if (!lang) {
        log.warning(log.codes.I18N_MISSING_URI);
        return;
      }
      if (!code) {
        log.warning(log.codes.I18N_MISSING_CODE, {
          uri: lang
        });
        return;
      }

      var deferred = $q.defer();
      (aliases instanceof Array ? aliases : [aliases])
      .forEach(function(alias) {
        codeAliases[alias] = code;
      });
      codeAliases[code] = code;
      var cacheKey = codeAliases[code];
      languagePromises[cacheKey] = deferred.promise;

      if (typeof lang === 'string') { // lang is uri
        jsonLoader(lang).then(function(data) {
          var translations = cache[cacheKey] || {};
          cache[cacheKey] = angular.merge(translations, data);
          addTv4(cache[cacheKey], cacheKey);
          deferred.resolve(cache[cacheKey]);
        });
      } else { // lang is map
        var translations = cache[cacheKey] || {};
        cache[cacheKey] = angular.merge(translations, lang);
        addTv4(cache[cacheKey], cacheKey);
        deferred.resolve(cache[cacheKey]);
      }

      return deferred.promise;
    };

    var gatherFields = function (memo, fields) {
      fields.forEach(function (field) {
        memo[field.id] = {
          title: field.title || field.id,
          description: field.description
        };
        if (field.typeOf("object") && field.fields) {
          memo[field.id].fields = {};
          gatherFields(memo[field.id].fields, field.fields);
        } else if (field.typeOf("field") && field.items[0]) {
          memo[field.id].items = {};
          gatherFields(memo[field.id].items, field.items);
        } else if (field.typeOf("fieldset") && field.items[0]) {
          memo[field.id].items = {
            title: field.items[0].title,
            description: field.items[0].description,
          };
          if (field.items[0].items) { // nested arrays
            memo[field.id].items.items = {};
            gatherFields(memo[field.id].items.items, field.items[0].items);
          } else {
            memo[field.id].items.fields = {};
            gatherFields(memo[field.id].items.fields, field.items[0].fields);
          }
        } else if (field.typeOf("select") && field.values) {
          memo[field.id].values = field.values.map(function (value) {
            return value.label;
          });
        }
      });
      return memo;
    };

    var addDefaultLanguage = function (form, code) {
      var lang = angular.merge({}, {
        fieldsets: form.fieldsets.map(function (fs) {
          return fs.title;
        }),
        fields: form.fieldsets.reduce(function (memo, fs) {
          return gatherFields(memo, fs.fields);
        }, {}),
        code: code
      }, cache[code]);
      return add(lang, code).then(function () {
        if (currentLocale.code === code) {
          set(code);
        }
      });
    };

    add(DEFAULT_TEXTS, 'en');

    return {
      add: add,
      set: set,
      get fields() {
        return currentLocale.fields;
      },
      get fieldsets() {
        return currentLocale.fieldsets;
      },
      get text() {
        return currentLocale.text;
      },
      get code() {
        return currentLocale.code;
      },
      addDefaultLanguage: addDefaultLanguage
    };
  }
]);

/* globals angular */
angular.module('formula').factory('formulaJsonLoader', ['$http', '$q', 'formulaLog',
  function($http, $q, log) {
    "use strict";

    var jsonLoader;

    return (jsonLoader = function(uri, jsonp, rerun) {
      var deferred = $q.defer();
      if (typeof uri !== "string") { // uri is not uri but schema object
        deferred.resolve(uri);
      } else {
        (jsonp ? $http.jsonp(uri + '?callback=JSON_CALLBACK') : $http.get(uri))
        .success(function(data, status, headers, config) {
          deferred.resolve(data);
        }).error(function(data, status, headers, config) {
          if (!jsonp) {
            return jsonLoader(uri, true);
          }

          log.error(log.codes.JSON_LOAD_ERROR, {
            uri: uri
          });
          deferred.reject(uri);
        });
      }

      return deferred.promise;
    });
  }
]);

/* globals angular,console */
angular.module('formula').factory('formulaLog', [
  function() {
    "use strict";

    var codes = {
      FIELD_INVALID_ID: 'field ID contains an illegal character: {character} ({field})',
      FIELD_MISSING_PROPERTY: 'missing required field property: {property} ({field})',
      FIELD_UNSUPPORTED_FORMAT: 'unsupported string format: {format} ({field})',
      FIELD_UNSUPPORTED_PROPERTY: 'unsupported field property: {property} ({field})',
      FIELD_UNSUPPORTED_TOKEN: 'unsupported default token: {token} ({field})',
      FIELD_UNSUPPORTED_TYPE: 'unsupported field type: {type} ({field})',
      FIELD_HIDDEN_DEFAULT: 'field hidden by default: {field}',
      I18N_MISSING_CODE: 'missing language code: {uri}',
      I18N_MISSING_URI: 'missing i18n uri',
      JSON_LOAD_ERROR: 'could not load JSON document: {uri}',
      SCHEMA_INVALID_URI: 'invalid URI for schema deref: {uri}',
      SCHEMA_MISSING_PROPERTY: 'missing required schema property: {property} ({schema})',
      SCHEMA_MISSING_REFERENCE: 'missing schema reference: {schema}',
      MISSING_TEMPLATE: 'missing template for {missing}'
    };

    function codeTranslate(code, params) {
      var msg = code,
        match = msg.match(/\{[^\}]*\}/g);
      angular.forEach(match, function(v, k) {
        msg = msg.replace(v, params[v.substr(1, v.length - 2)]);
      });
      return msg;
    }

    return {
      codes: codes,
      debug: function(msg, params) {
        if (params) {
          console.debug(codeTranslate(msg, params));
        } else {
          console.debug(msg);
        }
      },
      error: function(code, params) {
        console.error(codeTranslate(code, params));
      },
      warning: function(code, params) {
        console.warn(codeTranslate(code, params));
      }
    };
  }
]);

/* globals angular */
angular.module('formula').factory('formulaModel', [function() {
  "use strict";

  function Model(data) {
    this.data = ("object" === typeof data ? angular.copy(data) : {});
  }

  return Model;
}]);

/* globals angular */
angular.module('formula').factory('formulaSchema', ['$q', 'formulaJsonLoader', 'formulaLog',
  function($q, jsonLoader, log) {
    "use strict";

    /**
     * @class schema
     *
     * JSON Schema wrapper class.
     */

    function Schema(uri) {
      this.deferred = null;
      this.json = null;
      this.uri = uri || null;
    }

    Schema.cache = {};

    Schema.prototype = {
      /**
       * @method compile
       *
       * Function used to compile $ref's, effectively replacing the json contents.
       *
       * @returns true if all references were successfully solved, otherwise false
       */

      compile: function() {
        var self = this;

        function selfDeref(path) {
          if (path[0] === '#') {
            path = path.substr(path[1] === '/' ? 2 : 1).split('/');
            var schemaJson = self.json;

            angular.forEach(path, function(subpath) {
              if (schemaJson) {
                schemaJson = (schemaJson[subpath]);
              }
            });

            return schemaJson;
          }

          return null;
        }

        // TODO: Prevent circular refs
        function refCompile(schemaJson, parentJson, parentKey) {
          var missing = [],
            deref;

          angular.forEach(schemaJson, function(data, key) {
            if (typeof data === 'object') {
              missing = missing.concat(refCompile(data, schemaJson, key));
            } else if (key === '$ref' && parentJson) {
              if (data[0] === '#') {
                if ((deref = selfDeref(data))) {
                  parentJson[parentKey] = deref;
                } else {
                  missing.push(data);
                  delete parentJson[parentKey];
                }
              } else {
                if (Schema.cache[data] && Schema.cache[data].json) {
                  parentJson[parentKey] = Schema.cache[data].json;
                } else {
                  missing.push(data);
                  delete parentJson[parentKey];
                }
              }
            }
          });

          return missing;
        }

        var missing = (this.json ? refCompile(this.json) : [this.uri]);

        if (missing.length) {
          angular.forEach(missing, function(uri) {
            log.warning(log.codes.SCHEMA_MISSING_REFERENCE, {
              schema: uri
            });
          });

          return false;
        }

        return true;
      },

      /**
       * @method deref
       *
       * Function used to retrieve and deref JSON Schema from URI.
       *
       * @param uri URI to JSON Schema as string
       * @returns $q promise object to loaded JSON Schema
       */

      deref: function(uri) {
        var self = this;
        this.deferred = $q.defer();

        if (uri && typeof uri === 'string') {
          if (!Schema.cache[uri]) {
            var root = {
              schema: Schema.cache[uri] = new Schema(uri),
              missing: null,
              resolve: function(uri) {
                if (uri && this.missing instanceof Array) {
                  var index = this.missing.indexOf(uri);
                  if (index !== -1) {
                    this.missing.splice(index, 1);
                  }
                }

                if (!this.missing || !this.missing.length) {
                  this.schema.compile();
                  self.json = this.schema.json;
                  self.deferred.resolve(self.json);
                }
              }
            };

            jsonLoader(uri).then(function(data) {
              root.schema.json = data;
              var missing = root.schema.missing(false);

              if (missing) {
                root.missing = angular.copy(missing);
                angular.forEach(missing, function(uri) {
                  if (!Schema.cache[uri]) {
                    var ref = new Schema();
                    ref.deref(uri).then(function() {
                      root.resolve(uri);
                    });
                  } else {
                    Schema.cache[uri].then(function() {
                      root.resolve(uri);
                    });
                  }
                });
              } else {
                root.resolve();
              }
            }, function(error) {
              self.deferred.reject(error);
            });
          } else {
            Schema.cache[uri].then(function(data) {
              self.json = data;
              self.deferred.resolve(data);
            });
          }
        } else {
          log.warning(log.codes.SCHEMA_INVALID_URI, {
            uri: uri
          });
          this.deferred.reject('Invalid schema URI: ' + uri);
        }

        return this;
      },

      /**
       * @method missing
       *
       * Function used to find all $ref URIs in schema.
       * Optionally only return non-cached $ref URIs.
       *
       * @param ignoreCached Only return non-chached $ref URIs if true
       * @returns An array of uncompiled $ref URIs or null if empty
       */

      missing: function(ignoreCached) {
        function refArray(json) {
          var refs = [];
          angular.forEach(json, function(data, key) {
            if (typeof data === 'object') {
              var subRefs = refArray(data);
              angular.forEach(subRefs, function(ref) {
                refs.push(ref);
              });
            } else if (key === '$ref' && data[0] !== '#') {
              if (!ignoreCached || !Schema.cache[data]) {
                refs.push(data);
              }
            }
          });
          return refs;
        }

        var refs = refArray(this.json);
        return refs.length ? refs : null;
      },

      /**
       * @method then
       *
       * Function running a callback-function when schema is successfully compiled.
       *
       * @param callback Callback function with one parameter for JSON data
       */

      then: function(callback) {
        if (this.deferred) {
          this.deferred.promise.then(function(data) {
            callback(data);
          }, function(error) {
            // TODO: Failed schema promise
          });
        } else {
          callback(this.json);
        }
      }
    };

    return Schema;
  }
]);

/* globals angular */
angular.module('formula').filter('formulaInlineValues', [function() {
  "use strict";

  return function(values, params) {

    var result = [];

    angular.forEach(values, function(value) {
      if (value instanceof Array) {
        result.push('Array[' + value.length + ']');
      } else switch (typeof value) {
        case 'string':
        case 'number':
        case 'boolean':
          result.push(value);
          break;

        default:
      }
    });

    return result.join(', ');
  };
}]);

/* globals angular */
angular.module('formula').filter('formulaReplace', [function() {
  "use strict";

  return function(input, params) {
    var result = input;

    (input.match(/\{[^\}]*\}/g) || [])
    .forEach(function(val) {
      result = result.replace(val, params[val.substr(1, val.length - 2)]);
    });

    return result;
  };
}]);

/* globals angular */
angular.module('formula').service('formulaClassService', [function() {
  "use strict";

  // class based on field parents and ID
  var pathClass = function(node) {
    var path = node.path;
    path = path.replace('#', 'formula');
    return path;
  };

  // css class of schema type
  var schemaClass = function(node) {
    var schemaType = node.mainType.replace('@', '');
    return "formula" +
      schemaType.charAt(0).toUpperCase() +
      schemaType.slice(1);
  };

  return {
    schemaClass: schemaClass,
    pathClass: pathClass
  };
}]);

/* globals angular */
angular.module('formula').service('formulaDirtyCheckService', [function() {
  "use strict";

  var formCtrl;

  return {
    setForm: function (form) {
      formCtrl = form;
    },
    isDirty: function () {
      return formCtrl ? formCtrl.$dirty : false;
    },
    override: function () {
      if (formCtrl) {
        formCtrl.$setPristine();
        formCtrl.$setUntouched();
      }
    }
  };
}]);

/* globals angular */
angular.module('formula').service('formulaEvaluateConditionsService', ['$rootScope',
  function($rootScope) {
    "use strict";

    var keepFailing = true;

    var evaluateConditions = function(form) {
      var model = {};
      form.fieldsets.forEach(function(fieldset) {
        fieldset.fields.forEach(function(field) {
          model[field.id] = field.value;
        });
      });
      form.fields().forEach(function(field) {
        evaluateField(field, model);
      });
    };

    var evaluateField = function(field, model) {
      // Evaluate condition
      if (field.condition) {
        var pass = true,
          condition = (field.condition instanceof Array ? field.condition : [field.condition]);

        // jshint -W116
        condition.forEach(function(cond) {
          if (pass) {
            // Relative path
            if (cond[0] !== '#') {
              cond = field.path.substr(0, field.path.lastIndexOf('/') + 1) + cond;
            }
            // Absolute JSON path
            cond = cond.substr(2);
            cond = cond.replace(/\/(\d+)/g, '[$1]');
            cond = cond.replace(/\//g, '.');
            // Disable setters
            cond = cond.replace('=', '==').replace('===', '==');

            pass = $rootScope.$eval(cond, model);
          }
        });

        field.visible = field.hidden ? false : pass;

        if (!keepFailing) {
          if (pass) {
            field.value = field.backupValue || field.value;
          } else {
            field.backupValue = field.value;
            field.value = undefined;
          }
        }
      }
    };

    return {
      evaluateConditions: evaluateConditions,
      setKeepFailing: function(val) {
        keepFailing = val;
      }
    };
  }
]);

/* globals angular */
angular.module('formula').service('formulaTemplateService', ['$templateCache', '$templateRequest', '$q', 'formulaLog',
  'formulaFieldConfig',
  function($templateCache, $templateRequest, $q, log, fieldConfig) {
    "use strict";

    // LIFO prio
    var DEFAULT_TEMPLATES = [{
      match: '@field',
      templateUrl: 'formula/default/field.html'
    }, {
      match: '@object',
      templateUrl: 'formula/default/object.html'
    }, {
      match: '@array',
      templateUrl: 'formula/default/array.html'
    }, {
      match: '@fieldset',
      templateUrl: 'formula/default/fieldset.html'
    }, {
      match: '@form',
      templateUrl: 'formula/default/form.html'
    }];

    var configs = fieldConfig.getInstance(DEFAULT_TEMPLATES);

    var doTemplateRequest = function(templateUrl) {
      var templateElement = $templateCache.get(templateUrl);
      if (!templateElement) {
        return $templateRequest(templateUrl, false);
      }
      var deferred = $q.defer();
      deferred.resolve(templateElement);
      return deferred.promise;
    };

    var getTemplate = function(field, templateConfig) {
      var config = templateConfig || configs.getMatchingConfig(field);
      var deferred = $q.defer();
      if (config) {
        if (config.hidden || config.template === "") {
          deferred.resolve(false);
        } else if (config.template) {
          deferred.resolve(config.template);
        } else if (config.templateUrl) {
          doTemplateRequest(config.templateUrl).then(function(template) {
            deferred.resolve(template);
          }, function() {
            deferred.reject(config.templateUrl);
          });
        } else {
          deferred.reject(field.path);
        }
      } else {
        deferred.reject(field.mainType);
      }
      return deferred.promise;
    };

    var initNode = function(node) {
      if (node.template) {
        return;
      }
      getTemplate(node).then(function(template) {
        if (template) {
          node.template = template;
        } else {
          node.hidden = true;
        }
      }, function(missing) {
        log.warning(log.codes.MISSING_TEMPLATE, {
          missing: missing
        });
        node.hidden = true;
      });
    };

    var setTemplates = function(templates) {
      configs.setConfigs(templates);
    };

    var addTemplate = function(template) {
      configs.addConfig(template);
    };

    var evalTemplate = function(node, config) {
      if (configs.isMatch(node, config)) {
        getTemplate(node, config).then(function (template) {
          node.template = template;
        });
      }
    };

    return {
      addTemplate: addTemplate,
      setTemplates: setTemplates,
      initNode: initNode,
      evalTemplate: evalTemplate
    };
  }
]);

angular.module("formula").run(["$templateCache", function($templateCache) {$templateCache.put("formula/default/array.html","<fieldset ng-class=\"{ valid: field.valid, error: field.errors }\"><legend>{{ field.title }} ({{ field.nrArrayValues() || 0 }})</legend><ul ng-if=\"::field.typeOf(\'fieldset\')\"><li ng-repeat=\"value in field.values\" ng-if=\"!value.hidden\"><fieldset ng-class=\"{ valid: value.valid }\"><legend><span ng-if=\"!value.visible\">{{ value.value | formulaInlineValues }}</span> <a ng-show=\"!$first\" class=\"toggle\" href=\"\" ng-click=\"field.moveUp($index)\" ng-attr-title=\"{{ i18n.text.moveup }}\">&uarr;</a> <a ng-show=\"!$last\" class=\"toggle\" href=\"\" ng-click=\"field.moveDown($index)\" ng-attr-title=\"{{ i18n.text.movedown }}\">&darr;</a> <a class=\"toggle\" href=\"\" ng-click=\"field.itemToggle($index)\" ng-attr-title=\"{{ value.visible ? i18n.text.minimize.tooltip : i18n.text.maximize.tooltip }}\">{{ value.visible ? \'_\' : \'‾\' }}</a> <a class=\"remove\" href=\"\" ng-click=\"field.itemRemove($index)\" ng-attr-title=\"{{ i18n.text.remove.tooltip }}\">&times;</a></legend><formula:field field=\"value\" ng-if=\"value.visible\"></formula:field></fieldset></li></ul><ul ng-if=\"::field.typeOf(\'field\')\"><li ng-class=\"{ valid: value.valid, error: value.error }\" ng-repeat=\"value in field.values\"><input formula:input=\"\" field=\"value\"><div class=\"input-ctrls\"><a ng-show=\"!$first\" class=\"toggle\" href=\"\" ng-click=\"field.moveUp($index)\" ng-attr-title=\"{{ i18n.text.moveup }}\">&uarr;</a> <a ng-show=\"!$last\" class=\"toggle\" href=\"\" ng-click=\"field.moveDown($index)\" ng-attr-title=\"{{ i18n.text.movedown }}\">&darr;</a> <a class=\"remove\" href=\"\" ng-click=\"field.itemRemove($index)\" ng-attr-title=\"{{ i18n.text.remove.tooltip }}\">&times;</a></div><div><span ng-if=\"value.error\">{{ value.getErrorText() }}</span> <span ng-if=\"value.description\">{{ value.description }}</span></div></li></ul><div ng-if=\"field.errors\" title=\"{{ field.errors.join(\'\\n\') }}\">{{ i18n.text.invalid | formulaReplace : { count: field.errors.length } }}</div><div ng-if=\"!field.errors\">{{ field.description }}</div><div class=\"formulaArrayCtrls\"><button class=\"add\" ng-click=\"field.itemAdd()\" title=\"{{ i18n.text.add.tooltip }}\" type=\"button\"><strong>&plus;</strong> {{ i18n.text.add.label }}</button></div></fieldset>");
$templateCache.put("formula/default/field.html","<div ng-class=\"{ valid: field.valid, error: field.error, required: (field.required && field.value == null) }\" ng-if=\"field.visible\" title=\"{{ field.description }}\"><label for=\"{{ ::field.uid }}\">{{ field.title }} {{field.visibility}}</label><formula:input field=\"field\"></formula:input><span ng-if=\"field.error\">{{ field.getErrorText() }}</span> <span ng-if=\"field.description\">{{ field.description }}</span></div>");
$templateCache.put("formula/default/fieldset.html","<fieldset ng-show=\"fieldset.active\"><formula:fields fields=\"::fieldset.fields\"></formula:fields></fieldset>");
$templateCache.put("formula/default/form.html","<div><div class=\"formula\" ng-if=\"!form.ready\"><div class=\"loading\"><div class=\"spinner\"></div><span>Loading...</span></div></div><form class=\"formula\" ng-show=\"form.ready\"><header ng-if=\"::form.title\">{{ form.title }}</header><nav ng-if=\"::form.fieldsets.length > 1\"><a href=\"\" ng-class=\"{ active: fieldset.active, error: !fieldset.valid }\" ng-click=\"form.activate(fieldset)\" ng-repeat=\"fieldset in ::form.fieldsets track by fieldset.id\">{{ fieldset.title }}</a></nav><formula:fieldsets></formula:fieldsets><footer><span ng-if=\"form.errors\" title=\"{{ form.errors.join(\'\\n\') }}\">{{ i18n.text.invalid | formulaReplace : { count: form.errors.length } }}</span> <button ng-click=\"form.validate(true);\" ng-if=\"!data.hideButtons\" title=\"{{ i18n.text.validate.tooltip }}\"><strong>&#10003;</strong> {{ i18n.text.validate.label }}</button> <button ng-click=\"form.save()\" ng-disabled=\"!form.valid\" ng-if=\"!data.hideButtons\" title=\"{{ i18n.text.save.tooltip }}\"><strong>&#9921;</strong> {{ i18n.text.save.label }}</button></footer></form></div>");
$templateCache.put("formula/default/object.html","<fieldset><legend ng-if=\"::field.title\">{{ field.title }}</legend><formula:fields fields=\"::field.fields\"></formula:fields></fieldset>");}]);
/* globals angular */
angular.module('formula').factory('formulaArrayField', ['$rootScope', 'formulaField', 'formulaI18n', 'formulaArrayFieldTypeService', 'formulaTemplateService',
  function($rootScope, formulaField, i18n, formulaArrayFieldTypeService, formulaTemplateService) {
    "use strict";

    var applyDefaultValue = function(field) {
      if (field.default !== undefined) {
        // Ensure array typed default if required
        if (!(field.default instanceof Array)) {
          field.default = [field.default];
        }
        field.value = field.default;
      } else {
        field.value = [];
      }
    };

    var ArrayField = {
      create: function(options) {
        var field = formulaField.create(options);
        angular.extend(field, ArrayField.prototype);
        formulaArrayFieldTypeService.applyType(field);
        if (!field.type) {
          return;
        }
        field.values = [];
        applyDefaultValue(field);

        field.setItemProto();

        // Add one element to arrays which requires at least one element
        if (field.schema.minItems) {
          field.itemAdd();
        }

        formulaTemplateService.initNode(field);
        field.visible = field.hidden ? false : true;

        return field;
      },
    };

    var countHidden = function(memo, value) {
      return memo + (value.hidden ? 0 : 1);
    };

    ArrayField.prototype = {

      /**
       * @method setItemProto
       *
       * Sets array item prototype
       *
       * @returns true if the field was successfully added, otherwise false
       */
      setItemProto: function() {
        var newField;
        var parents = this.parents.slice();
        parents.push(this);

        if (!this.items) {
          this.items = [];
        }

        var id = /\/([^\/]*?)$/.exec(this.path)[1] + '_item';
        var fieldDefinition = this.fieldDefinition.items || {};
        fieldDefinition.id = id;
        var schema = this.schema.items;
        newField = formulaField.builder.build({
          schema: schema,
          id: id,
          parents: parents,
          fieldDefinition: fieldDefinition
        });
        if (newField) {
          newField.setRequired(this.schema.required);
          newField.index = this.items.length;
          this.items.push(newField);
          return true;
        }
        return false;
      },

      /**
       * @method itemAdd
       *
       * Function used to add a copy of the subfields for validating.
       * The values of each fieldset are automatically monitored.
       *
       * @param preventValidation bool
       * @returns Reference to the item just added
       */
      itemAdd: function(preventValidation) {
        if (this.items) {
          var parents = this.parents.slice();
          parents.push(this);

          var index = this.values.length;
          var proto = this.items[0];
          var field = formulaField.builder.build({
            schema: proto.schema,
            id: proto.id,
            parents: parents,
            fieldDefinition: proto.fieldDefinition,
            index: index
          });
          if (!field.type) {
            return null;
          }
          this.values.push(field);

          if (field.value !== undefined) {
            this.value.push(field.value);
          }
          this.dirty = true;
          this.updateParent();
          if (preventValidation !== true) {
            $rootScope.$emit('revalidate');
          }
          if (this.fieldTranslations) {
            field.translate(this.fieldTranslations);
          }
          return field;
        }

        return null;
      },

      /**
       * @method itemRemove
       *
       * Function used to remove a fieldset from an array-typed field.
       *
       * @param item Index number of the fieldset which should be removed
       * @return removed item
       */
      itemRemove: function(item) {
        var removed;
        if (this.values.length > item) {
          removed = this.values.splice(item, 1)[0];
          this.value.splice(item, 1);
        }

        this.values.forEach(function(fs, i) {
          fs.index = i;
        });

        if (typeof item.destroyWatcher === 'function') {
          item.destroyWatcher();
        }

        this.dirty = true;
        this.updateParent();
        $rootScope.$emit('revalidate');
        return removed;
      },

      moveUp: function (index) {
        var a = this.values[index];
        var b = this.values[index - 1];
        a.index = index - 1;
        b.index = index;
        this.values[index - 1] = a;
        this.values[index] = b;
        this.itemChange();
      },

      moveDown: function (index) {
        var a = this.values[index];
        var b = this.values[index + 1];
        a.index = index + 1;
        b.index = index;
        this.values[index + 1] = a;
        this.values[index] = b;
        this.itemChange();
      },

      itemChange: function(item) {
        this.value.length = 0;

        this.values.forEach(function(field) {
          if (field.value !== undefined) {
            this.value.push(field.value);
          }
        }, this);

        this.dirty = true;
        this.updateParent();
      },

      /**
       * @method itemToggle
       *
       * Function used to toggle visibility of a fieldset item.
       *
       * @param item Index number of the fieldset which should be toggled
       */
      itemToggle: function(item) {
        if (this.values.length > item) {
          this.values[item].visible = !this.values[item].visible;
        }
      },

      destroy: function() {
        this.values.forEach(function (val) {
          val.destroy();
        });
      },

      valueFromModel: function(model, validate) {
        var data = angular.copy(model);
        if (data[this.id] !== undefined) {
          this.values.forEach(function (val) {
            val.destroy();
          });
          this.values.length = 0;
          data[this.id].forEach(function(item, index) {
            var newField = this.itemAdd(true /* preventValidation */ );
            if (newField) {
              if (this.typeOf('fieldset') && newField.index !== 0) {
                newField.visible = false;
              }

              var valueModel = {};
              valueModel[this.values[index].id] = item;
              this.values[index].valueFromModel(valueModel);
            }
          }, this);
          formulaField.prototype.valueFromModel.call(this, data, validate);
        }

      },

      translate: function (translations) {
        if (translations) {
          this.fieldTranslations = translations.items;
          Object.keys(translations.items || {}).forEach(function (key, index) {
            this.items.concat(this.values).forEach(function(field) {
              field.translate(translations.items);
            }, this);
          }, this);
          formulaField.prototype.translate.call(this, translations);
        }
      },

      nrArrayValues: function() {
        if (this.values) {
          return this.values.reduce(countHidden, 0);
        }
        return 0;
      }
    };

    return ArrayField;
  }
]);

/* globals angular */
angular.module('formula').factory('formulaField', ['$q', '$filter', '$rootScope', 'formulaLog', 'formulaI18n', 'formulaTemplateService', 'formulaFieldValidateService',
  function($q, $filter, $rootScope, log, i18n, formulaTemplateService, formulaFieldValidateService) {
    "use strict";

    var fieldBuilder;
    var nextUid = 1;

    var validateFieldId = function(field) {
      ['.', '/', '#'].forEach(function(invalidChar) {
        if (this.id && this.id.indexOf(invalidChar) >= 0) {
          log.warning(log.codes.FIELD_INVALID_ID, {
            character: invalidChar,
            field: this.path
          });
        }
      }, field);
    };

    var assign = function(field, data) {
      if (typeof field === 'object') {
        var attribs = 'condition,default,description,disabled,enum,format,hidden,instance,maximum,maxLength,minimum,minLength,multiple,nullable,pattern,readonly,required,step,title,type,values'.split(',');
        angular.forEach(data, function(v, k) {
          if (attribs.indexOf(k) !== -1) {
            this[k] = v;
          }
        }, field);
      }
    };

    var reduceFieldTypes = function(field) {
      if (field.type instanceof Array) {
        field.nullable = field.type.some(function(type) {
          return type === 'null';
        });
        if (field.type.length === 1) {
          field.type = field.type[0];
        } else if (field.type.length === 2) {
          if (field.type[0] === 'null') {
            field.type = field.type[1];
          } else if (field.type[1] === 'null') {
            field.type = field.type[0];
          }
        } else {
          field.types = field.type;
          field.type = 'any';
          // @TODO support any
        }
      }
    };

    var uidGen = function (field) {
      var uid = 'formula-' + ('00000' + (nextUid++).toString(16)).slice(-5);
      return (field.uid = uid);
    };

    var Field = {
      create: function(options) {
        var field = Object.create(Field.prototype);
        field.parents = options.parents || [];
        field.id = options.id;
        field.title = options.id.replace(/_/g, ' ');
        field.index = options.index;

        field._elem_q = $q.defer();

        assign(field, (field.schema = options.schema));
        assign(field, (field.fieldDefinition = options.fieldDefinition || {}));

        validateFieldId(field);
        uidGen(field);
        reduceFieldTypes(field);

        return field;
      },
      fieldBuilder: fieldBuilder
    };

    Field.prototype = {
      get element() {
        return this._elem_q.promise;
      },

      get path() {
        var path = '#';

        // jshint -W116
        var genFieldPath = function(field) {
          var path = '/';

          // jshint -W041
          if (field.index != null) {
            path += field.index;
          } else {
            path += field.id;
          }
          return path;
        };

        this.parents.forEach(function(parent) {
          path += genFieldPath(parent);
        });

        path += genFieldPath(this);
        return path;
      },

      /**
       * @method typeOf
       *
       * Function used to check if field in a specific type.
       *
       * @param type Type to check
       * @returns true if field type matches with specified type, otherwise false
       */
      typeOf: function(type) {
        if (!(this.type && typeof this.type === 'string')) {
          return false;
        }
        var types;
        return (type === this.type || type === (types = this.type.split(':'))[0] || type === types[1]);
      },

      isEmpty: function() {
        // jshint -W041,-W116
        return (this.value == null || this.value.length === 0);
      },
      /**
       * @method validate
       *
       * Function used to validate the field based on its schema.
       * This function also sets the field error memeber value if the validation fails,
       * and additionally sets the form valid state if a parent form is specified.
       *
       * @returns true if the field is valid, otherwise false
       */
      validate: function(force, silent) {
        return formulaFieldValidateService.validate(this, {
          force: force,
          silent: silent
        });
      },

      valueFromModel: function(model, validate) {
        if (model[this.id] !== undefined && this.value !== model[this.id]) {
          this.value = model[this.id];
          this.dirty = true;

          this.updateParent();

          formulaTemplateService.initNode(this);
          if (validate) {
            $rootScope.$emit('revalidate');
          }
        }
      },

      setRequired: function(required) {
        this.required = (required === true) || (required instanceof Array && required.indexOf(this.id) !== -1);
      },

      translate: function(translations) {
        this.title = translations.title || this.title;
        this.description = translations.description || this.description;
      },

      getErrorText: function(error) {
        var text = '';
        error = error || this.error;
        if (!error) {
          return text;
        }
        if (error.dataPath) {
          var item = Number(error.dataPath.replace(/^\/(\d+).*$/, '$1')) + 1;
          text += $filter('formulaReplace')(i18n.text.item, {
            item: item,
            error: error.message
          });
        } else {
          text += error.message;
        }
        return text;
      },

      destroy: function() {
        if (typeof this.destroyWatcher === 'function') {
          this.destroyWatcher();
        }
      },

      updateParent: function () {
        var parent;
        if ((parent = this.parents[this.parents.length - 1])) {
          parent.itemChange(this);
        }
      }
    };

    return Field;
  }
]);

/* globals angular */
angular.module('formula').factory('formulaFieldConfig', [function() {
  "use strict";

  var Config = function(cfgs) {
    var configs = cfgs || [];

    var isMatch = function(node, cfg) {
      var match = false;
      if (cfg.match) {
        if (typeof cfg.match === 'function') {
          try {
            if (cfg.match.call({}, node)) {
              match = true;
            }
          } catch (e) {
            // noop
          }
        } else if (typeof cfg.match === 'string' && [node.mainType, node.id, node.path].indexOf(cfg.match) !== -1) {
          match = true;
        }
      }
      return match;
    };

    this.getMatchingConfig = function(node) {
      var config;
      var last = configs.length - 1;
      for (var i = last; i >= 0; i--) {
        if (isMatch(node, configs[i])) {
          config = configs[i];
          break;
        }
      }
      return config;
    };

    this.addConfig = function(config) {
      configs.push(config);
    };

    this.setConfigs = function(cfgs) {
      configs = cfgs;
    };

    this.isMatch = function(node, cfg) {
      return isMatch(node, cfg);
    };
  };

  return {
    getInstance: function(configs) {
      return new Config(configs);
    }
  };
}]);

/* globals angular */
angular.module('formula').factory('formulaInputField', ['$rootScope', 'formulaLog', 'formulaField', 'formulaFieldTranslateDefaultsService',
  'formulaInputFieldTypeService', 'formulaTemplateService',
  function($rootScope, log, formulaField, formulaFieldTranslateDefaultsService,
    formulaInputFieldTypeService, formulaTemplateService) {
    "use strict";

    var applyDefaultValue = function(field) {
      if (field.default !== undefined) {
        field.value = field.default;
      } else if (field.typeOf('select') && !field.multiple) {
        field.value = field.enum[0];
      }
    };

    var watchField = function(field) {
      field.destroyWatcher = $rootScope.$watch(function fieldWatch() {
        return field.value;
      }, function(n, o) {
        if (!angular.equals(n, o)) {
          if (field.value === null || field.value === "") {
            field.value = undefined;
            return; // triggers new watch
          }
          field.dirty = true;
          field.updateParent();
          $rootScope.$emit('revalidate');
        }
      });
    };

    var InputField = {
      create: function(options) {
        var field = formulaField.create(options);
        angular.extend(field, InputField.prototype);
        formulaInputFieldTypeService.applyType(field);
        if (!field.type) {
          return;
        }
        formulaFieldTranslateDefaultsService.translateDefaultValues(field);
        applyDefaultValue(field);

        // Set schema pattern if not set and pattern is defined
        if (field.pattern && !field.schema.pattern) {
          field.schema.pattern = field.pattern;
        }

        // Automatically hide fields by default if ID starts with underscore
        if ((field.id && field.id[0] === '_') && field.hidden !== false) {
          log.debug(log.codes.FIELD_HIDDEN_DEFAULT, {
            field: field.path
          });
          field.hidden = true;
        }

        formulaTemplateService.initNode(field);

        field.visible = field.hidden ? false : true;

        watchField(field);
        return field;
      }
    };


    InputField.prototype = {
      translate: function (translations) {
        if (this.typeOf('select') && translations.values) {
          this.values.forEach(function (value, index) {
            value.label = translations.values[index] || value.label;
          }, this);
        }

        formulaField.prototype.translate.call(this, translations);
      }
    };

    return InputField;
  }
]);

/* globals angular */
angular.module('formula').factory('formulaObjectField', ['formulaLog', 'formulaField', 'formulaTemplateService',
  function(log, formulaField, formulaTemplateService) {
    "use strict";

    var applyDefaultValue = function(field) {
      if (field.default !== undefined) {
        field.value = field.default;
      } else {
        field.value = {};
      }
    };

    var applyType = function(field) {
      field.mainType = '@object';
      if (!field.schema.properties) {
        log.warning(log.codes.FIELD_MISSING_PROPERTY, {
          property: 'properties',
          field: field.path
        });
        field.type = null;
      }
    };

    var ObjectField = {
      create: function(options) {
        var field = formulaField.create(options);
        angular.extend(field, ObjectField.prototype);
        applyType(field);
        if (!field.type) {
          return;
        }
        applyDefaultValue(field);

        field.fieldAdd();

        formulaTemplateService.initNode(field);

        field.visible = field.hidden ? false : true;

        return field;
      }
    };

    var skipField = function(fieldDefinition) {
      return (typeof fieldDefinition === 'string' && fieldDefinition.charAt(0) === "!");
    };

    ObjectField.prototype = {

      /**
       * @method fieldAdd
       *
       * Function used to add subfields to object and array-typed field.
       *
       * @param schema JSON Schema defining the field being added
       * @returns true if the field was successfully added, otherwise false
       */

      fieldAdd: function() {
        var parents = this.parents.slice();
        parents.push(this);

        if (!this.fields) {
          this.fields = [];
        }

        Object.keys(this.schema.properties).forEach(function(key) {
          var schema = this.schema.properties[key];
          var fieldDefinition;
          if (this.fieldDefinition.fields) {
            this.fieldDefinition.fields.forEach(function(field) {
              var id;
              if (typeof field === 'string') {
                id = field.replace('!', '');
              } else {
                id = field.id;
              }
              if (key === id) {
                fieldDefinition = field;
              }
            });
          }
          if (!skipField(fieldDefinition)) {
            var newField = formulaField.builder.build({
              schema: schema,
              id: key,
              parents: parents,
              fieldDefinition: fieldDefinition
            });
            if (newField) {
              newField.setRequired(this.schema.required);
              this.fields.push(newField);
            }
          }

        }, this);
      },

      itemChange: function(item) {
        if (this.fields) {
          this.fields.forEach(function(field) {
            if (field.value !== undefined) {
              this.value[field.id] = field.value;
            }
          }, this);
        }
        this.dirty = true;

        this.updateParent();
      },

      valueFromModel: function(model, validate) {
        if (model[this.id] !== undefined) {
          this.fields.forEach(function(fc, index) {
            if (model[this.id][fc.id] !== undefined) {
              fc.valueFromModel(model[this.id]);
            }
          }, this);

          formulaField.prototype.valueFromModel.call(this, model, validate);
        }
      },

      translate: function (translations) {
        if (translations) {
          if (translations.fields) {
            this.fields.forEach(function(field) {
              if (translations.fields[field.id]) {
                field.translate(translations.fields[field.id]);
              }
            });
          }

          formulaField.prototype.translate.call(this, translations);
        }
      },

    };

    return ObjectField;
  }
]);

/* globals angular */
angular.module('formula').service('formulaArrayFieldTypeService', ['$filter', 'formulaLog', 'formulaFormat',
  function($filter, log, format) {
    "use strict";

    var applyType = function(field) {
      field.mainType = '@array';
      field.values = [];
      if (field.schema.items) {
        var items = field.schema.items;

        if (items.type === 'object' || items.type === 'array') {
          field.type = 'array:fieldset';
        } else if (items.allOf) {
          // @TODO
          log.warning(log.codes.FIELD_UNSUPPORTED_PROPERTY, {
            property: 'allOf',
            field: field.path
          });
        } else if (items.anyOf) {
          // @TODO
          log.warning(log.codes.FIELD_UNSUPPORTED_PROPERTY, {
            property: 'anyOf',
            field: field.path
          });
        } else if (items.oneOf) {
          // @TODO
          log.warning(log.codes.FIELD_UNSUPPORTED_PROPERTY, {
            property: 'oneOf',
            field: field.path
          });
        } else {
          field.type = 'array:field';
        }
        if (field.schema.minItems >= 1) {
          field.required = true;
        }
      } else {
        log.warning(log.codes.FIELD_MISSING_PROPERTY, {
          property: 'items',
          field: field.path
        });
        field.type = null;
      }
    };


    return {
      applyType: applyType
    };
  }
]);

/* globals angular */
angular.module('formula').service('formulaFieldBuilder', ['formulaField', 'formulaInputField', 'formulaObjectField', 'formulaArrayField',
  function(Field, InputField, ObjectField, ArrayField) {
    "use strict";

    var isType = function (schemaType, type) {
      if (schemaType instanceof Array) {
        return schemaType.indexOf(type) !== -1;
      } else {
        return schemaType === type;
      }
    };

    var isEnum = function (schema) {
      return (schema.items && schema.items.enum);
    };

    return {
      build: function(options) {
        var schema = options.schema;
        Field.builder = this;
        if (typeof schema === 'object') {
          var field;
          if (isType(schema.type, 'object')) {
            field = ObjectField.create(options);
          } else if (isType(schema.type, 'array') && !isEnum(schema)) {
            field = ArrayField.create(options);
          } else {
            field = InputField.create(options);
          }
          return field;
        }
      }
    };
  }
]);

/* globals angular */
angular.module('formula').service('formulaFieldTranslateDefaultsService', ['$filter', 'formulaLog',
  function($filter, log) {
    "use strict";

    var translateDefaultValues = function(field) {
      if (typeof field.default === 'string') {
        var match = field.default.match(/^%(.*)%$/),
          replace;
        if (match) {
          switch (match[1]) {
            case 'date':
              replace = $filter('date')(new Date(), 'yyyy-MM-dd', 'UTC');
              break;

            case 'datetime':
              replace = $filter('date')(new Date(), 'yyyy-MM-ddThh:mm:ss', 'UTC') + 'Z';
              break;

            case 'time':
              replace = $filter('date')(new Date(), 'hh:mm:ss', 'UTC');
              break;

            case 'year':
              replace = $filter('date')(new Date(), 'yyyy', 'UTC');
              break;

            default:
              log.warning(log.codes.FIELD_UNSUPPORTED_TOKEN, {
                token: match[1],
                field: field.path
              });
          }

          if (replace) {
            field.default = replace;
          }
        }
      }
    };
    return {
      translateDefaultValues: translateDefaultValues
    };
  }
]);

/* globals angular,tv4 */
angular.module('formula').service('formulaFieldValidateService', [
  function() {
    "use strict";

    var validate = function(field, options) {
      var silent = options.silent,
        force = options.force;
      if (field.schema) {
        var result;

        if ((field.dirty || force) && (field.required || field.value !== undefined)) {
          result = tv4.validateMultiple(field.value, field.schema);
          field.valid = result.valid;
        }

        if (!field.valid && field.nullable) {
          switch (typeof field.value) {
            case 'string':
              if (!field.value || !field.value.length) {
                field.value = null;
              }
              break;

            case 'number':
              if (isNaN(field.value)) {
                field.value = null;
              }
              break;

            case 'object':
              if (field.typeOf('object') && !Object.keys(field.value).length) {
                field.value = null;
              }
              break;
          }

          // Nullable array case..
          if (field.typeOf('array') && field.values && !field.values.length) {
            field.value = null;
          }

          // TODO: Add support for null-types in tv4
          if (field.isEmpty()) {
            field.valid = true;
          }
        }

        if (!silent && result && field.valid === false) {
          if (field.typeOf('array') || field.typeOf('object')) {
            field.errors = result.errors;
          } else {
            field.error = result.errors[0];
          }
        } else {
          field.error = null;
          field.errors = null;
        }
        field.dirty = false;

        return field.valid !== false;
      }
      return false;
    };

    return {
      validate: validate
    };
  }
]);

/* globals angular,tv4 */
angular.module('formula').service('formulaInputFieldTypeService', ['$filter', 'formulaLog', 'formulaFormat',
  function($filter, log, format) {
    "use strict";

    var handleMultiEnum = function (field) {
      field.enum = field.schema.items.enum;
      field.multiple = true;
      if (field.schema.minItems >= 1) {
        field.required = true;
      }
    };

    var handleEnums = function (field) {
      field.values = [];
      field.enum.forEach(function(val) {
        field.values.push({
          id: val,
          label: val
        });
      });
    };

    var applyType = function(field) {
      field.mainType = '@field';
      var newType = 'input:text'; // default
      if (field.schema.items && field.schema.items.enum) { // enums as array in schema
        handleMultiEnum(field);
      }

      if (field.type === 'select' || field.enum) {
        newType = 'input:select';
        handleEnums(field);
      } else if (field.format) {
        var formatNoDash = field.format.replace('-', '');

        if (format[formatNoDash]) {
          tv4.addFormat(field.format, format[formatNoDash]);
          if (['date', 'datetime', 'time'].indexOf(formatNoDash) !== -1) {
            newType = 'input:' + formatNoDash;
          }
        } else {
          log.warning(log.codes.FIELD_UNSUPPORTED_FORMAT, {
            format: field.format,
            field: field.path
          });
        }
      } else {
        switch (field.type) {
          case 'any':
            newType = 'input:any';
            break;

          case 'boolean':
            newType = 'input:checkbox';
            field.value = !!field.value;
            break;

          case 'integer':
          case 'number':
            newType = 'input:number';
            break;

          case 'range':
            newType = 'input:range';
            break;

          case 'textarea':
            newType = 'input:textarea';
            break;

          case 'string':
          case 'text':
            newType = 'input:text';
            break;
          case undefined:
            newType = 'input:text';
            break;

          default:
            log.warning(log.codes.FIELD_UNSUPPORTED_TYPE, {
              type: field.type,
              field: field.path
            });
            newType = null;
        }
      }
      field.type = newType;
    };


    return {
      applyType: applyType
    };
  }
]);
;
},{"angular":"angular","tv4":82}],66:[function(require,module,exports){
module.exports={
  "text": {
    "actions": {
      "label": "Mer",
      "tooltip": "Klikk for flere handlinger"
    },
    "add": {
      "label": "Legg til",
      "tooltip": "Klikk for å legge til et nytt element"
    },
    "invalid": "{count} ugyldige felt",
    "moveup": {
      "label": "Flytt opp",
      "tooltip": "Klikk for å flytte elementet opp"
    },
    "movedown": {
      "label": "Flytt ned",
      "tooltip": "Klikk for å flytte elementet ned"
    },
    "maximize": {
      "label": "Maksimer",
      "tooltip": "Klikk for å maksimere"
    },
    "minimize": {
      "label": "Minimere",
      "tooltip": "Klikk for å minimere"
    },
    "remove": {
      "label": "Fjern",
      "tooltip": "Klikk for å fjerne elementet"
    },
    "required": "påkrevd",
    "save": {
      "label": "Lagre",
      "tooltip": "Klikk for å lagre dokumentet"
    },
    "validate": {
      "label": "Validér",
      "tooltip": "Klikk for å validere dokumentet"
    },
    "item": "Rad {item}: {error}"
  },
  "fieldsets": [],
  "fields": {},
  "tv4": {
		"INVALID_TYPE": "Ugyldig type: {type} (forventet {expected})",
		"ENUM_MISMATCH": "Ingen samsvarende enum verdi for: {value}",
		"ANY_OF_MISSING": "Data samsvarer ikke med noe skjema fra \"anyOf\"",
		"ONE_OF_MISSING": "Data samsvarer ikke med noe skjema fra \"oneOf\"",
		"ONE_OF_MULTIPLE": "Data samsvarer med mer enn ett skjema fra \"oneOf\": indeks {index1} og {index2}",
		"NOT_PASSED": "Data samsvarer med skjema fra \"not\"",
		"NUMBER_MULTIPLE_OF": "Verdien {value} er ikke et multiplum av {multipleOf}",
		"NUMBER_MINIMUM": "Verdien {value} er mindre enn minsteverdi {minimum}",
		"NUMBER_MINIMUM_EXCLUSIVE": "Verdien {value} er lik eksklusiv minsteverdi {minimum}",
		"NUMBER_MAXIMUM": "Verdien {value} er større enn maksimalverdi {maximum}",
		"NUMBER_MAXIMUM_EXCLUSIVE": "Verdien {value} er lik eksklusiv maksimalverdi {maximum}",
		"NUMBER_NOT_A_NUMBER": "Verdien {value} er ikke et gyldig tall",
		"STRING_LENGTH_SHORT": "Strengen er for kort ({length} tegn), minst {minimum}",
		"STRING_LENGTH_LONG": "Strengen er for lang ({length} tegn), maksimalt {maximum}",
		"STRING_PATTERN": "Strengen samsvarer ikke med regulært uttrykk: {pattern}",
		"OBJECT_PROPERTIES_MINIMUM": "For få variabler definert ({propertyCount}), minst {minimum} er forventet",
		"OBJECT_PROPERTIES_MAXIMUM": "For mange variabler definert ({propertyCount}), makismalt {maximum} er tillatt",
		"OBJECT_REQUIRED": "Mangler obligatorisk variabel: {key}",
		"OBJECT_ADDITIONAL_PROPERTIES": "Tilleggsvariabler er ikke tillatt",
		"OBJECT_DEPENDENCY_KEY": "Variabelen {missing} må være definert (på grunn av følgende variabel: {key})",
		"ARRAY_LENGTH_SHORT": "Listen er for kort ({length} elementer), minst {minimum}",
		"ARRAY_LENGTH_LONG": "Listen er for lang ({length} elementer), maksimalt {maximum}",
		"ARRAY_UNIQUE": "Elementene er ikke unike (indeks {match1} og {match2} er like)",
		"ARRAY_ADDITIONAL_ITEMS": "Tillegselementer er ikke tillatt",
		"FORMAT_CUSTOM": "Formatteringen stemmer ikke ({message})",
		"KEYWORD_CUSTOM": "Nøkkelen stemmer ikke: {key} ({message})",
		"CIRCULAR_REFERENCE": "Sirkulære referanser ($refs): {urls}",
		"UNKNOWN_PROPERTY": "Ukjent variabel (eksisterer ikke i skjemaet)"
	}
}

},{}],67:[function(require,module,exports){
module.exports={
	"142": {
		"region": 8843
	},
	"143": {
		"region": 8844
	},
	"145": {
		"region": 8845
	},
	"150": {
		"region": 8846
	},
	"151": {
		"region": 8847
	},
	"154": {
		"region": 8848
	},
	"155": {
		"region": 8849
	},
	"419": {
		"region": 8850
	},
	"1901": {
		"variant": 8853
	},
	"1994": {
		"variant": 8855
	},
	"1996": {
		"variant": 8856
	},
	"aa": {
		"language": 0,
		"region": 8548
	},
	"ab": {
		"language": 1
	},
	"ae": {
		"language": 2,
		"region": 8551
	},
	"af": {
		"language": 3,
		"region": 8552
	},
	"ak": {
		"language": 4
	},
	"am": {
		"language": 5,
		"region": 8556
	},
	"an": {
		"language": 6,
		"region": 8557
	},
	"ar": {
		"language": 7,
		"region": 8560
	},
	"as": {
		"language": 8,
		"region": 8561
	},
	"av": {
		"language": 9
	},
	"ay": {
		"language": 10
	},
	"az": {
		"language": 11,
		"region": 8566
	},
	"ba": {
		"language": 12,
		"region": 8567
	},
	"be": {
		"language": 13,
		"region": 8570
	},
	"bg": {
		"language": 14,
		"region": 8572
	},
	"bh": {
		"language": 15,
		"region": 8573
	},
	"bi": {
		"language": 16,
		"region": 8574
	},
	"bm": {
		"language": 17,
		"region": 8577
	},
	"bn": {
		"language": 18,
		"region": 8578
	},
	"bo": {
		"language": 19,
		"region": 8579
	},
	"br": {
		"language": 20,
		"region": 8581
	},
	"bs": {
		"language": 21,
		"region": 8582
	},
	"ca": {
		"language": 22,
		"region": 8589
	},
	"ce": {
		"language": 23
	},
	"ch": {
		"language": 24,
		"region": 8594
	},
	"co": {
		"language": 25,
		"region": 8600
	},
	"cr": {
		"language": 26,
		"region": 8602
	},
	"cs": {
		"language": 27,
		"region": 8603
	},
	"cu": {
		"language": 28,
		"region": 8604
	},
	"cv": {
		"language": 29,
		"region": 8605
	},
	"cy": {
		"language": 30,
		"region": 8608
	},
	"da": {
		"language": 31
	},
	"de": {
		"language": 32,
		"region": 8611
	},
	"dv": {
		"language": 33
	},
	"dz": {
		"language": 34,
		"region": 8617
	},
	"ee": {
		"language": 35,
		"region": 8620
	},
	"el": {
		"language": 36
	},
	"en": {
		"language": 37
	},
	"eo": {
		"language": 38
	},
	"es": {
		"language": 39,
		"region": 8624
	},
	"et": {
		"language": 40,
		"region": 8625
	},
	"eu": {
		"language": 41,
		"region": 8626
	},
	"fa": {
		"language": 42
	},
	"ff": {
		"language": 43
	},
	"fi": {
		"language": 44,
		"region": 8628
	},
	"fj": {
		"language": 45,
		"region": 8629
	},
	"fo": {
		"language": 46,
		"region": 8632
	},
	"fr": {
		"language": 47,
		"region": 8633
	},
	"fy": {
		"language": 48
	},
	"ga": {
		"language": 49,
		"region": 8635
	},
	"gd": {
		"language": 50,
		"region": 8637
	},
	"gl": {
		"language": 51,
		"region": 8643
	},
	"gn": {
		"language": 52,
		"region": 8645
	},
	"gu": {
		"language": 53,
		"region": 8651
	},
	"gv": {
		"language": 54
	},
	"ha": {
		"language": 55
	},
	"he": {
		"language": 56
	},
	"hi": {
		"language": 57
	},
	"ho": {
		"language": 58
	},
	"hr": {
		"language": 59,
		"region": 8657
	},
	"ht": {
		"language": 60,
		"region": 8658
	},
	"hu": {
		"language": 61,
		"region": 8659
	},
	"hy": {
		"language": 62
	},
	"hz": {
		"language": 63
	},
	"ia": {
		"language": 64
	},
	"id": {
		"language": 65,
		"region": 8661
	},
	"ie": {
		"language": 66,
		"region": 8662
	},
	"ig": {
		"language": 67
	},
	"ii": {
		"language": 68
	},
	"ik": {
		"language": 69
	},
	"in": {
		"language": 70,
		"region": 8665
	},
	"io": {
		"language": 71,
		"region": 8666
	},
	"is": {
		"language": 72,
		"region": 8669
	},
	"it": {
		"language": 73,
		"region": 8670
	},
	"iu": {
		"language": 74
	},
	"iw": {
		"language": 75
	},
	"ja": {
		"language": 76
	},
	"ji": {
		"language": 77
	},
	"jv": {
		"language": 78
	},
	"jw": {
		"language": 79
	},
	"ka": {
		"language": 80
	},
	"kg": {
		"language": 81,
		"region": 8676
	},
	"ki": {
		"language": 82,
		"region": 8678
	},
	"kj": {
		"language": 83
	},
	"kk": {
		"language": 84
	},
	"kl": {
		"language": 85
	},
	"km": {
		"language": 86,
		"region": 8679
	},
	"kn": {
		"language": 87,
		"region": 8680
	},
	"ko": {
		"language": 88
	},
	"kr": {
		"language": 89,
		"region": 8682
	},
	"ks": {
		"language": 90
	},
	"ku": {
		"language": 91
	},
	"kv": {
		"language": 92
	},
	"kw": {
		"language": 93,
		"region": 8683
	},
	"ky": {
		"language": 94,
		"region": 8684
	},
	"la": {
		"language": 95,
		"region": 8686
	},
	"lb": {
		"language": 96,
		"region": 8687
	},
	"lg": {
		"language": 97
	},
	"li": {
		"language": 98,
		"region": 8689
	},
	"ln": {
		"language": 99
	},
	"lo": {
		"language": 100
	},
	"lt": {
		"language": 101,
		"region": 8693
	},
	"lu": {
		"language": 102,
		"region": 8694
	},
	"lv": {
		"language": 103,
		"region": 8695
	},
	"mg": {
		"language": 104,
		"region": 8702
	},
	"mh": {
		"language": 105,
		"region": 8703
	},
	"mi": {
		"language": 106
	},
	"mk": {
		"language": 107,
		"region": 8704
	},
	"ml": {
		"language": 108,
		"region": 8705
	},
	"mn": {
		"language": 109,
		"region": 8707
	},
	"mo": {
		"language": 110,
		"region": 8708
	},
	"mr": {
		"language": 111,
		"region": 8711
	},
	"ms": {
		"language": 112,
		"region": 8712
	},
	"mt": {
		"language": 113,
		"region": 8713
	},
	"my": {
		"language": 114,
		"region": 8718
	},
	"na": {
		"language": 115,
		"region": 8720
	},
	"nb": {
		"language": 116
	},
	"nd": {
		"language": 117
	},
	"ne": {
		"language": 118,
		"region": 8722
	},
	"ng": {
		"language": 119,
		"region": 8724
	},
	"nl": {
		"language": 120,
		"region": 8726
	},
	"nn": {
		"language": 121
	},
	"no": {
		"language": 122,
		"region": 8727
	},
	"nr": {
		"language": 123,
		"region": 8729
	},
	"nv": {
		"language": 124
	},
	"ny": {
		"language": 125
	},
	"oc": {
		"language": 126
	},
	"oj": {
		"language": 127
	},
	"om": {
		"language": 128,
		"region": 8733
	},
	"or": {
		"language": 129
	},
	"os": {
		"language": 130
	},
	"pa": {
		"language": 131,
		"region": 8734
	},
	"pi": {
		"language": 132
	},
	"pl": {
		"language": 133,
		"region": 8740
	},
	"ps": {
		"language": 134,
		"region": 8744
	},
	"pt": {
		"language": 135,
		"region": 8745
	},
	"qu": {
		"language": 136
	},
	"rm": {
		"language": 137
	},
	"rn": {
		"language": 138
	},
	"ro": {
		"language": 139,
		"region": 8751
	},
	"ru": {
		"language": 140,
		"region": 8753
	},
	"rw": {
		"language": 141,
		"region": 8754
	},
	"sa": {
		"language": 142,
		"region": 8755
	},
	"sc": {
		"language": 143,
		"region": 8757
	},
	"sd": {
		"language": 144,
		"region": 8758
	},
	"se": {
		"language": 145,
		"region": 8759
	},
	"sg": {
		"language": 146,
		"region": 8760
	},
	"sh": {
		"language": 147,
		"region": 8761
	},
	"si": {
		"language": 148,
		"region": 8762
	},
	"sk": {
		"language": 149,
		"region": 8764
	},
	"sl": {
		"language": 150,
		"region": 8765
	},
	"sm": {
		"language": 151,
		"region": 8766
	},
	"sn": {
		"language": 152,
		"region": 8767
	},
	"so": {
		"language": 153,
		"region": 8768
	},
	"sq": {
		"language": 154
	},
	"sr": {
		"language": 155,
		"region": 8769
	},
	"ss": {
		"language": 156,
		"region": 8770
	},
	"st": {
		"language": 157,
		"region": 8771
	},
	"su": {
		"language": 158,
		"region": 8772
	},
	"sv": {
		"language": 159,
		"region": 8773
	},
	"sw": {
		"language": 160
	},
	"ta": {
		"language": 161,
		"region": 8777
	},
	"te": {
		"language": 162
	},
	"tg": {
		"language": 163,
		"region": 8781
	},
	"th": {
		"language": 164,
		"region": 8782
	},
	"ti": {
		"language": 165
	},
	"tk": {
		"language": 166,
		"region": 8784
	},
	"tl": {
		"language": 167,
		"region": 8785
	},
	"tn": {
		"language": 168,
		"region": 8787
	},
	"to": {
		"language": 169,
		"region": 8788
	},
	"tr": {
		"language": 170,
		"region": 8790
	},
	"ts": {
		"language": 171
	},
	"tt": {
		"language": 172,
		"region": 8791
	},
	"tw": {
		"language": 173,
		"region": 8793
	},
	"ty": {
		"language": 174
	},
	"ug": {
		"language": 175,
		"region": 8796
	},
	"uk": {
		"language": 176
	},
	"ur": {
		"language": 177
	},
	"uz": {
		"language": 178,
		"region": 8801
	},
	"ve": {
		"language": 179,
		"region": 8804
	},
	"vi": {
		"language": 180,
		"region": 8806
	},
	"vo": {
		"language": 181
	},
	"wa": {
		"language": 182
	},
	"wo": {
		"language": 183
	},
	"xh": {
		"language": 184
	},
	"yi": {
		"language": 185
	},
	"yo": {
		"language": 186
	},
	"za": {
		"language": 187,
		"region": 8816
	},
	"zh": {
		"language": 188
	},
	"zu": {
		"language": 189
	},
	"aaa": {
		"language": 190
	},
	"aab": {
		"language": 191
	},
	"aac": {
		"language": 192
	},
	"aad": {
		"language": 193
	},
	"aae": {
		"language": 194
	},
	"aaf": {
		"language": 195
	},
	"aag": {
		"language": 196
	},
	"aah": {
		"language": 197
	},
	"aai": {
		"language": 198
	},
	"aak": {
		"language": 199
	},
	"aal": {
		"language": 200
	},
	"aam": {
		"language": 201
	},
	"aan": {
		"language": 202
	},
	"aao": {
		"language": 203,
		"extlang": 8126
	},
	"aap": {
		"language": 204
	},
	"aaq": {
		"language": 205
	},
	"aas": {
		"language": 206
	},
	"aat": {
		"language": 207
	},
	"aau": {
		"language": 208
	},
	"aav": {
		"language": 209
	},
	"aaw": {
		"language": 210
	},
	"aax": {
		"language": 211
	},
	"aaz": {
		"language": 212
	},
	"aba": {
		"language": 213
	},
	"abb": {
		"language": 214
	},
	"abc": {
		"language": 215
	},
	"abd": {
		"language": 216
	},
	"abe": {
		"language": 217
	},
	"abf": {
		"language": 218
	},
	"abg": {
		"language": 219
	},
	"abh": {
		"language": 220,
		"extlang": 8127
	},
	"abi": {
		"language": 221
	},
	"abj": {
		"language": 222
	},
	"abl": {
		"language": 223
	},
	"abm": {
		"language": 224
	},
	"abn": {
		"language": 225
	},
	"abo": {
		"language": 226
	},
	"abp": {
		"language": 227
	},
	"abq": {
		"language": 228
	},
	"abr": {
		"language": 229
	},
	"abs": {
		"language": 230
	},
	"abt": {
		"language": 231
	},
	"abu": {
		"language": 232
	},
	"abv": {
		"language": 233,
		"extlang": 8128
	},
	"abw": {
		"language": 234
	},
	"abx": {
		"language": 235
	},
	"aby": {
		"language": 236
	},
	"abz": {
		"language": 237
	},
	"aca": {
		"language": 238
	},
	"acb": {
		"language": 239
	},
	"acd": {
		"language": 240
	},
	"ace": {
		"language": 241
	},
	"acf": {
		"language": 242
	},
	"ach": {
		"language": 243
	},
	"aci": {
		"language": 244
	},
	"ack": {
		"language": 245
	},
	"acl": {
		"language": 246
	},
	"acm": {
		"language": 247,
		"extlang": 8129
	},
	"acn": {
		"language": 248
	},
	"acp": {
		"language": 249
	},
	"acq": {
		"language": 250,
		"extlang": 8130
	},
	"acr": {
		"language": 251
	},
	"acs": {
		"language": 252
	},
	"act": {
		"language": 253
	},
	"acu": {
		"language": 254
	},
	"acv": {
		"language": 255
	},
	"acw": {
		"language": 256,
		"extlang": 8131
	},
	"acx": {
		"language": 257,
		"extlang": 8132
	},
	"acy": {
		"language": 258,
		"extlang": 8133
	},
	"acz": {
		"language": 259
	},
	"ada": {
		"language": 260
	},
	"adb": {
		"language": 261
	},
	"add": {
		"language": 262
	},
	"ade": {
		"language": 263
	},
	"adf": {
		"language": 264,
		"extlang": 8134
	},
	"adg": {
		"language": 265
	},
	"adh": {
		"language": 266
	},
	"adi": {
		"language": 267
	},
	"adj": {
		"language": 268
	},
	"adl": {
		"language": 269
	},
	"adn": {
		"language": 270
	},
	"ado": {
		"language": 271
	},
	"adp": {
		"language": 272
	},
	"adq": {
		"language": 273
	},
	"adr": {
		"language": 274
	},
	"ads": {
		"language": 275,
		"extlang": 8135
	},
	"adt": {
		"language": 276
	},
	"adu": {
		"language": 277
	},
	"adw": {
		"language": 278
	},
	"adx": {
		"language": 279
	},
	"ady": {
		"language": 280
	},
	"adz": {
		"language": 281
	},
	"aea": {
		"language": 282
	},
	"aeb": {
		"language": 283,
		"extlang": 8136
	},
	"aec": {
		"language": 284,
		"extlang": 8137
	},
	"aed": {
		"language": 285,
		"extlang": 8138
	},
	"aee": {
		"language": 286
	},
	"aek": {
		"language": 287
	},
	"ael": {
		"language": 288
	},
	"aem": {
		"language": 289
	},
	"aen": {
		"language": 290,
		"extlang": 8139
	},
	"aeq": {
		"language": 291
	},
	"aer": {
		"language": 292
	},
	"aes": {
		"language": 293
	},
	"aeu": {
		"language": 294
	},
	"aew": {
		"language": 295
	},
	"aey": {
		"language": 296
	},
	"aez": {
		"language": 297
	},
	"afa": {
		"language": 298
	},
	"afb": {
		"language": 299,
		"extlang": 8140
	},
	"afd": {
		"language": 300
	},
	"afe": {
		"language": 301
	},
	"afg": {
		"language": 302,
		"extlang": 8141
	},
	"afh": {
		"language": 303
	},
	"afi": {
		"language": 304
	},
	"afk": {
		"language": 305
	},
	"afn": {
		"language": 306
	},
	"afo": {
		"language": 307
	},
	"afp": {
		"language": 308
	},
	"afs": {
		"language": 309
	},
	"aft": {
		"language": 310
	},
	"afu": {
		"language": 311
	},
	"afz": {
		"language": 312
	},
	"aga": {
		"language": 313
	},
	"agb": {
		"language": 314
	},
	"agc": {
		"language": 315
	},
	"agd": {
		"language": 316
	},
	"age": {
		"language": 317
	},
	"agf": {
		"language": 318
	},
	"agg": {
		"language": 319
	},
	"agh": {
		"language": 320
	},
	"agi": {
		"language": 321
	},
	"agj": {
		"language": 322
	},
	"agk": {
		"language": 323
	},
	"agl": {
		"language": 324
	},
	"agm": {
		"language": 325
	},
	"agn": {
		"language": 326
	},
	"ago": {
		"language": 327
	},
	"agp": {
		"language": 328
	},
	"agq": {
		"language": 329
	},
	"agr": {
		"language": 330
	},
	"ags": {
		"language": 331
	},
	"agt": {
		"language": 332
	},
	"agu": {
		"language": 333
	},
	"agv": {
		"language": 334
	},
	"agw": {
		"language": 335
	},
	"agx": {
		"language": 336
	},
	"agy": {
		"language": 337
	},
	"agz": {
		"language": 338
	},
	"aha": {
		"language": 339
	},
	"ahb": {
		"language": 340
	},
	"ahg": {
		"language": 341
	},
	"ahh": {
		"language": 342
	},
	"ahi": {
		"language": 343
	},
	"ahk": {
		"language": 344
	},
	"ahl": {
		"language": 345
	},
	"ahm": {
		"language": 346
	},
	"ahn": {
		"language": 347
	},
	"aho": {
		"language": 348
	},
	"ahp": {
		"language": 349
	},
	"ahr": {
		"language": 350
	},
	"ahs": {
		"language": 351
	},
	"aht": {
		"language": 352
	},
	"aia": {
		"language": 353
	},
	"aib": {
		"language": 354
	},
	"aic": {
		"language": 355
	},
	"aid": {
		"language": 356
	},
	"aie": {
		"language": 357
	},
	"aif": {
		"language": 358
	},
	"aig": {
		"language": 359
	},
	"aih": {
		"language": 360
	},
	"aii": {
		"language": 361
	},
	"aij": {
		"language": 362
	},
	"aik": {
		"language": 363
	},
	"ail": {
		"language": 364
	},
	"aim": {
		"language": 365
	},
	"ain": {
		"language": 366
	},
	"aio": {
		"language": 367
	},
	"aip": {
		"language": 368
	},
	"aiq": {
		"language": 369
	},
	"air": {
		"language": 370
	},
	"ais": {
		"language": 371
	},
	"ait": {
		"language": 372
	},
	"aiw": {
		"language": 373
	},
	"aix": {
		"language": 374
	},
	"aiy": {
		"language": 375
	},
	"aja": {
		"language": 376
	},
	"ajg": {
		"language": 377
	},
	"aji": {
		"language": 378
	},
	"ajn": {
		"language": 379
	},
	"ajp": {
		"language": 380,
		"extlang": 8142
	},
	"ajt": {
		"language": 381
	},
	"aju": {
		"language": 382
	},
	"ajw": {
		"language": 383
	},
	"ajz": {
		"language": 384
	},
	"akb": {
		"language": 385
	},
	"akc": {
		"language": 386
	},
	"akd": {
		"language": 387
	},
	"ake": {
		"language": 388
	},
	"akf": {
		"language": 389
	},
	"akg": {
		"language": 390
	},
	"akh": {
		"language": 391
	},
	"aki": {
		"language": 392
	},
	"akj": {
		"language": 393
	},
	"akk": {
		"language": 394
	},
	"akl": {
		"language": 395
	},
	"akm": {
		"language": 396
	},
	"ako": {
		"language": 397
	},
	"akp": {
		"language": 398
	},
	"akq": {
		"language": 399
	},
	"akr": {
		"language": 400
	},
	"aks": {
		"language": 401
	},
	"akt": {
		"language": 402
	},
	"aku": {
		"language": 403
	},
	"akv": {
		"language": 404
	},
	"akw": {
		"language": 405
	},
	"akx": {
		"language": 406
	},
	"aky": {
		"language": 407
	},
	"akz": {
		"language": 408
	},
	"ala": {
		"language": 409
	},
	"alc": {
		"language": 410
	},
	"ald": {
		"language": 411
	},
	"ale": {
		"language": 412
	},
	"alf": {
		"language": 413
	},
	"alg": {
		"language": 414
	},
	"alh": {
		"language": 415
	},
	"ali": {
		"language": 416
	},
	"alj": {
		"language": 417
	},
	"alk": {
		"language": 418
	},
	"all": {
		"language": 419
	},
	"alm": {
		"language": 420
	},
	"aln": {
		"language": 421
	},
	"alo": {
		"language": 422
	},
	"alp": {
		"language": 423
	},
	"alq": {
		"language": 424
	},
	"alr": {
		"language": 425
	},
	"als": {
		"language": 426
	},
	"alt": {
		"language": 427
	},
	"alu": {
		"language": 428
	},
	"alv": {
		"language": 429
	},
	"alw": {
		"language": 430
	},
	"alx": {
		"language": 431
	},
	"aly": {
		"language": 432
	},
	"alz": {
		"language": 433
	},
	"ama": {
		"language": 434
	},
	"amb": {
		"language": 435
	},
	"amc": {
		"language": 436
	},
	"ame": {
		"language": 437
	},
	"amf": {
		"language": 438
	},
	"amg": {
		"language": 439
	},
	"ami": {
		"language": 440
	},
	"amj": {
		"language": 441
	},
	"amk": {
		"language": 442
	},
	"aml": {
		"language": 443
	},
	"amm": {
		"language": 444
	},
	"amn": {
		"language": 445
	},
	"amo": {
		"language": 446
	},
	"amp": {
		"language": 447
	},
	"amq": {
		"language": 448
	},
	"amr": {
		"language": 449
	},
	"ams": {
		"language": 450
	},
	"amt": {
		"language": 451
	},
	"amu": {
		"language": 452
	},
	"amv": {
		"language": 453
	},
	"amw": {
		"language": 454
	},
	"amx": {
		"language": 455
	},
	"amy": {
		"language": 456
	},
	"amz": {
		"language": 457
	},
	"ana": {
		"language": 458
	},
	"anb": {
		"language": 459
	},
	"anc": {
		"language": 460
	},
	"and": {
		"language": 461
	},
	"ane": {
		"language": 462
	},
	"anf": {
		"language": 463
	},
	"ang": {
		"language": 464
	},
	"anh": {
		"language": 465
	},
	"ani": {
		"language": 466
	},
	"anj": {
		"language": 467
	},
	"ank": {
		"language": 468
	},
	"anl": {
		"language": 469
	},
	"anm": {
		"language": 470
	},
	"ann": {
		"language": 471
	},
	"ano": {
		"language": 472
	},
	"anp": {
		"language": 473
	},
	"anq": {
		"language": 474
	},
	"anr": {
		"language": 475
	},
	"ans": {
		"language": 476
	},
	"ant": {
		"language": 477
	},
	"anu": {
		"language": 478
	},
	"anv": {
		"language": 479
	},
	"anw": {
		"language": 480
	},
	"anx": {
		"language": 481
	},
	"any": {
		"language": 482
	},
	"anz": {
		"language": 483
	},
	"aoa": {
		"language": 484
	},
	"aob": {
		"language": 485
	},
	"aoc": {
		"language": 486
	},
	"aod": {
		"language": 487
	},
	"aoe": {
		"language": 488
	},
	"aof": {
		"language": 489
	},
	"aog": {
		"language": 490
	},
	"aoh": {
		"language": 491
	},
	"aoi": {
		"language": 492
	},
	"aoj": {
		"language": 493
	},
	"aok": {
		"language": 494
	},
	"aol": {
		"language": 495
	},
	"aom": {
		"language": 496
	},
	"aon": {
		"language": 497
	},
	"aor": {
		"language": 498
	},
	"aos": {
		"language": 499
	},
	"aot": {
		"language": 500
	},
	"aou": {
		"language": 501
	},
	"aox": {
		"language": 502
	},
	"aoz": {
		"language": 503
	},
	"apa": {
		"language": 504
	},
	"apb": {
		"language": 505
	},
	"apc": {
		"language": 506,
		"extlang": 8143
	},
	"apd": {
		"language": 507,
		"extlang": 8144
	},
	"ape": {
		"language": 508
	},
	"apf": {
		"language": 509
	},
	"apg": {
		"language": 510
	},
	"aph": {
		"language": 511
	},
	"api": {
		"language": 512
	},
	"apj": {
		"language": 513
	},
	"apk": {
		"language": 514
	},
	"apl": {
		"language": 515
	},
	"apm": {
		"language": 516
	},
	"apn": {
		"language": 517
	},
	"apo": {
		"language": 518
	},
	"app": {
		"language": 519
	},
	"apq": {
		"language": 520
	},
	"apr": {
		"language": 521
	},
	"aps": {
		"language": 522
	},
	"apt": {
		"language": 523
	},
	"apu": {
		"language": 524
	},
	"apv": {
		"language": 525
	},
	"apw": {
		"language": 526
	},
	"apx": {
		"language": 527
	},
	"apy": {
		"language": 528
	},
	"apz": {
		"language": 529
	},
	"aqa": {
		"language": 530
	},
	"aqc": {
		"language": 531
	},
	"aqd": {
		"language": 532
	},
	"aqg": {
		"language": 533
	},
	"aql": {
		"language": 534
	},
	"aqm": {
		"language": 535
	},
	"aqn": {
		"language": 536
	},
	"aqp": {
		"language": 537
	},
	"aqr": {
		"language": 538
	},
	"aqt": {
		"language": 539
	},
	"aqz": {
		"language": 540
	},
	"arb": {
		"language": 541,
		"extlang": 8145
	},
	"arc": {
		"language": 542
	},
	"ard": {
		"language": 543
	},
	"are": {
		"language": 544
	},
	"arh": {
		"language": 545
	},
	"ari": {
		"language": 546
	},
	"arj": {
		"language": 547
	},
	"ark": {
		"language": 548
	},
	"arl": {
		"language": 549
	},
	"arn": {
		"language": 550
	},
	"aro": {
		"language": 551
	},
	"arp": {
		"language": 552
	},
	"arq": {
		"language": 553,
		"extlang": 8146
	},
	"arr": {
		"language": 554
	},
	"ars": {
		"language": 555,
		"extlang": 8147
	},
	"art": {
		"language": 556
	},
	"aru": {
		"language": 557
	},
	"arv": {
		"language": 558
	},
	"arw": {
		"language": 559
	},
	"arx": {
		"language": 560
	},
	"ary": {
		"language": 561,
		"extlang": 8148
	},
	"arz": {
		"language": 562,
		"extlang": 8149
	},
	"asa": {
		"language": 563
	},
	"asb": {
		"language": 564
	},
	"asc": {
		"language": 565
	},
	"asd": {
		"language": 566
	},
	"ase": {
		"language": 567,
		"extlang": 8150
	},
	"asf": {
		"language": 568,
		"extlang": 8151
	},
	"asg": {
		"language": 569
	},
	"ash": {
		"language": 570
	},
	"asi": {
		"language": 571
	},
	"asj": {
		"language": 572
	},
	"ask": {
		"language": 573
	},
	"asl": {
		"language": 574
	},
	"asn": {
		"language": 575
	},
	"aso": {
		"language": 576
	},
	"asp": {
		"language": 577,
		"extlang": 8152
	},
	"asq": {
		"language": 578,
		"extlang": 8153
	},
	"asr": {
		"language": 579
	},
	"ass": {
		"language": 580
	},
	"ast": {
		"language": 581
	},
	"asu": {
		"language": 582
	},
	"asv": {
		"language": 583
	},
	"asw": {
		"language": 584,
		"extlang": 8154
	},
	"asx": {
		"language": 585
	},
	"asy": {
		"language": 586
	},
	"asz": {
		"language": 587
	},
	"ata": {
		"language": 588
	},
	"atb": {
		"language": 589
	},
	"atc": {
		"language": 590
	},
	"atd": {
		"language": 591
	},
	"ate": {
		"language": 592
	},
	"atg": {
		"language": 593
	},
	"ath": {
		"language": 594
	},
	"ati": {
		"language": 595
	},
	"atj": {
		"language": 596
	},
	"atk": {
		"language": 597
	},
	"atl": {
		"language": 598
	},
	"atm": {
		"language": 599
	},
	"atn": {
		"language": 600
	},
	"ato": {
		"language": 601
	},
	"atp": {
		"language": 602
	},
	"atq": {
		"language": 603
	},
	"atr": {
		"language": 604
	},
	"ats": {
		"language": 605
	},
	"att": {
		"language": 606
	},
	"atu": {
		"language": 607
	},
	"atv": {
		"language": 608
	},
	"atw": {
		"language": 609
	},
	"atx": {
		"language": 610
	},
	"aty": {
		"language": 611
	},
	"atz": {
		"language": 612
	},
	"aua": {
		"language": 613
	},
	"aub": {
		"language": 614
	},
	"auc": {
		"language": 615
	},
	"aud": {
		"language": 616
	},
	"aue": {
		"language": 617
	},
	"auf": {
		"language": 618
	},
	"aug": {
		"language": 619
	},
	"auh": {
		"language": 620
	},
	"aui": {
		"language": 621
	},
	"auj": {
		"language": 622
	},
	"auk": {
		"language": 623
	},
	"aul": {
		"language": 624
	},
	"aum": {
		"language": 625
	},
	"aun": {
		"language": 626
	},
	"auo": {
		"language": 627
	},
	"aup": {
		"language": 628
	},
	"auq": {
		"language": 629
	},
	"aur": {
		"language": 630
	},
	"aus": {
		"language": 631
	},
	"aut": {
		"language": 632
	},
	"auu": {
		"language": 633
	},
	"auw": {
		"language": 634
	},
	"aux": {
		"language": 635
	},
	"auy": {
		"language": 636
	},
	"auz": {
		"language": 637,
		"extlang": 8155
	},
	"avb": {
		"language": 638
	},
	"avd": {
		"language": 639
	},
	"avi": {
		"language": 640
	},
	"avk": {
		"language": 641
	},
	"avl": {
		"language": 642,
		"extlang": 8156
	},
	"avm": {
		"language": 643
	},
	"avn": {
		"language": 644
	},
	"avo": {
		"language": 645
	},
	"avs": {
		"language": 646
	},
	"avt": {
		"language": 647
	},
	"avu": {
		"language": 648
	},
	"avv": {
		"language": 649
	},
	"awa": {
		"language": 650
	},
	"awb": {
		"language": 651
	},
	"awc": {
		"language": 652
	},
	"awd": {
		"language": 653
	},
	"awe": {
		"language": 654
	},
	"awg": {
		"language": 655
	},
	"awh": {
		"language": 656
	},
	"awi": {
		"language": 657
	},
	"awk": {
		"language": 658
	},
	"awm": {
		"language": 659
	},
	"awn": {
		"language": 660
	},
	"awo": {
		"language": 661
	},
	"awr": {
		"language": 662
	},
	"aws": {
		"language": 663
	},
	"awt": {
		"language": 664
	},
	"awu": {
		"language": 665
	},
	"awv": {
		"language": 666
	},
	"aww": {
		"language": 667
	},
	"awx": {
		"language": 668
	},
	"awy": {
		"language": 669
	},
	"axb": {
		"language": 670
	},
	"axe": {
		"language": 671
	},
	"axg": {
		"language": 672
	},
	"axk": {
		"language": 673
	},
	"axl": {
		"language": 674
	},
	"axm": {
		"language": 675
	},
	"axx": {
		"language": 676
	},
	"aya": {
		"language": 677
	},
	"ayb": {
		"language": 678
	},
	"ayc": {
		"language": 679
	},
	"ayd": {
		"language": 680
	},
	"aye": {
		"language": 681
	},
	"ayg": {
		"language": 682
	},
	"ayh": {
		"language": 683,
		"extlang": 8157
	},
	"ayi": {
		"language": 684
	},
	"ayk": {
		"language": 685
	},
	"ayl": {
		"language": 686,
		"extlang": 8158
	},
	"ayn": {
		"language": 687,
		"extlang": 8159
	},
	"ayo": {
		"language": 688
	},
	"ayp": {
		"language": 689,
		"extlang": 8160
	},
	"ayq": {
		"language": 690
	},
	"ayr": {
		"language": 691
	},
	"ays": {
		"language": 692
	},
	"ayt": {
		"language": 693
	},
	"ayu": {
		"language": 694
	},
	"ayx": {
		"language": 695
	},
	"ayy": {
		"language": 696
	},
	"ayz": {
		"language": 697
	},
	"aza": {
		"language": 698
	},
	"azb": {
		"language": 699
	},
	"azc": {
		"language": 700
	},
	"azd": {
		"language": 701
	},
	"azg": {
		"language": 702
	},
	"azj": {
		"language": 703
	},
	"azm": {
		"language": 704
	},
	"azn": {
		"language": 705
	},
	"azo": {
		"language": 706
	},
	"azt": {
		"language": 707
	},
	"azz": {
		"language": 708
	},
	"baa": {
		"language": 709
	},
	"bab": {
		"language": 710
	},
	"bac": {
		"language": 711
	},
	"bad": {
		"language": 712
	},
	"bae": {
		"language": 713
	},
	"baf": {
		"language": 714
	},
	"bag": {
		"language": 715
	},
	"bah": {
		"language": 716
	},
	"bai": {
		"language": 717
	},
	"baj": {
		"language": 718
	},
	"bal": {
		"language": 719
	},
	"ban": {
		"language": 720
	},
	"bao": {
		"language": 721
	},
	"bap": {
		"language": 722
	},
	"bar": {
		"language": 723
	},
	"bas": {
		"language": 724
	},
	"bat": {
		"language": 725
	},
	"bau": {
		"language": 726
	},
	"bav": {
		"language": 727
	},
	"baw": {
		"language": 728
	},
	"bax": {
		"language": 729
	},
	"bay": {
		"language": 730
	},
	"baz": {
		"language": 731
	},
	"bba": {
		"language": 732
	},
	"bbb": {
		"language": 733
	},
	"bbc": {
		"language": 734
	},
	"bbd": {
		"language": 735
	},
	"bbe": {
		"language": 736
	},
	"bbf": {
		"language": 737
	},
	"bbg": {
		"language": 738
	},
	"bbh": {
		"language": 739
	},
	"bbi": {
		"language": 740
	},
	"bbj": {
		"language": 741
	},
	"bbk": {
		"language": 742
	},
	"bbl": {
		"language": 743
	},
	"bbm": {
		"language": 744
	},
	"bbn": {
		"language": 745
	},
	"bbo": {
		"language": 746
	},
	"bbp": {
		"language": 747
	},
	"bbq": {
		"language": 748
	},
	"bbr": {
		"language": 749
	},
	"bbs": {
		"language": 750
	},
	"bbt": {
		"language": 751
	},
	"bbu": {
		"language": 752
	},
	"bbv": {
		"language": 753
	},
	"bbw": {
		"language": 754
	},
	"bbx": {
		"language": 755
	},
	"bby": {
		"language": 756
	},
	"bbz": {
		"language": 757,
		"extlang": 8161
	},
	"bca": {
		"language": 758
	},
	"bcb": {
		"language": 759
	},
	"bcc": {
		"language": 760
	},
	"bcd": {
		"language": 761
	},
	"bce": {
		"language": 762
	},
	"bcf": {
		"language": 763
	},
	"bcg": {
		"language": 764
	},
	"bch": {
		"language": 765
	},
	"bci": {
		"language": 766
	},
	"bcj": {
		"language": 767
	},
	"bck": {
		"language": 768
	},
	"bcl": {
		"language": 769
	},
	"bcm": {
		"language": 770
	},
	"bcn": {
		"language": 771
	},
	"bco": {
		"language": 772
	},
	"bcp": {
		"language": 773
	},
	"bcq": {
		"language": 774
	},
	"bcr": {
		"language": 775
	},
	"bcs": {
		"language": 776
	},
	"bct": {
		"language": 777
	},
	"bcu": {
		"language": 778
	},
	"bcv": {
		"language": 779
	},
	"bcw": {
		"language": 780
	},
	"bcy": {
		"language": 781
	},
	"bcz": {
		"language": 782
	},
	"bda": {
		"language": 783
	},
	"bdb": {
		"language": 784
	},
	"bdc": {
		"language": 785
	},
	"bdd": {
		"language": 786
	},
	"bde": {
		"language": 787
	},
	"bdf": {
		"language": 788
	},
	"bdg": {
		"language": 789
	},
	"bdh": {
		"language": 790
	},
	"bdi": {
		"language": 791
	},
	"bdj": {
		"language": 792
	},
	"bdk": {
		"language": 793
	},
	"bdl": {
		"language": 794
	},
	"bdm": {
		"language": 795
	},
	"bdn": {
		"language": 796
	},
	"bdo": {
		"language": 797
	},
	"bdp": {
		"language": 798
	},
	"bdq": {
		"language": 799
	},
	"bdr": {
		"language": 800
	},
	"bds": {
		"language": 801
	},
	"bdt": {
		"language": 802
	},
	"bdu": {
		"language": 803
	},
	"bdv": {
		"language": 804
	},
	"bdw": {
		"language": 805
	},
	"bdx": {
		"language": 806
	},
	"bdy": {
		"language": 807
	},
	"bdz": {
		"language": 808
	},
	"bea": {
		"language": 809
	},
	"beb": {
		"language": 810
	},
	"bec": {
		"language": 811
	},
	"bed": {
		"language": 812
	},
	"bee": {
		"language": 813
	},
	"bef": {
		"language": 814
	},
	"beg": {
		"language": 815
	},
	"beh": {
		"language": 816
	},
	"bei": {
		"language": 817
	},
	"bej": {
		"language": 818
	},
	"bek": {
		"language": 819
	},
	"bem": {
		"language": 820
	},
	"beo": {
		"language": 821
	},
	"bep": {
		"language": 822
	},
	"beq": {
		"language": 823
	},
	"ber": {
		"language": 824
	},
	"bes": {
		"language": 825
	},
	"bet": {
		"language": 826
	},
	"beu": {
		"language": 827
	},
	"bev": {
		"language": 828
	},
	"bew": {
		"language": 829
	},
	"bex": {
		"language": 830
	},
	"bey": {
		"language": 831
	},
	"bez": {
		"language": 832
	},
	"bfa": {
		"language": 833
	},
	"bfb": {
		"language": 834
	},
	"bfc": {
		"language": 835
	},
	"bfd": {
		"language": 836
	},
	"bfe": {
		"language": 837
	},
	"bff": {
		"language": 838
	},
	"bfg": {
		"language": 839
	},
	"bfh": {
		"language": 840
	},
	"bfi": {
		"language": 841,
		"extlang": 8162
	},
	"bfj": {
		"language": 842
	},
	"bfk": {
		"language": 843,
		"extlang": 8163
	},
	"bfl": {
		"language": 844
	},
	"bfm": {
		"language": 845
	},
	"bfn": {
		"language": 846
	},
	"bfo": {
		"language": 847
	},
	"bfp": {
		"language": 848
	},
	"bfq": {
		"language": 849
	},
	"bfr": {
		"language": 850
	},
	"bfs": {
		"language": 851
	},
	"bft": {
		"language": 852
	},
	"bfu": {
		"language": 853
	},
	"bfw": {
		"language": 854
	},
	"bfx": {
		"language": 855
	},
	"bfy": {
		"language": 856
	},
	"bfz": {
		"language": 857
	},
	"bga": {
		"language": 858
	},
	"bgb": {
		"language": 859
	},
	"bgc": {
		"language": 860
	},
	"bgd": {
		"language": 861
	},
	"bge": {
		"language": 862
	},
	"bgf": {
		"language": 863
	},
	"bgg": {
		"language": 864
	},
	"bgi": {
		"language": 865
	},
	"bgj": {
		"language": 866
	},
	"bgk": {
		"language": 867
	},
	"bgl": {
		"language": 868
	},
	"bgm": {
		"language": 869
	},
	"bgn": {
		"language": 870
	},
	"bgo": {
		"language": 871
	},
	"bgp": {
		"language": 872
	},
	"bgq": {
		"language": 873
	},
	"bgr": {
		"language": 874
	},
	"bgs": {
		"language": 875
	},
	"bgt": {
		"language": 876
	},
	"bgu": {
		"language": 877
	},
	"bgv": {
		"language": 878
	},
	"bgw": {
		"language": 879
	},
	"bgx": {
		"language": 880
	},
	"bgy": {
		"language": 881
	},
	"bgz": {
		"language": 882
	},
	"bha": {
		"language": 883
	},
	"bhb": {
		"language": 884
	},
	"bhc": {
		"language": 885
	},
	"bhd": {
		"language": 886
	},
	"bhe": {
		"language": 887
	},
	"bhf": {
		"language": 888
	},
	"bhg": {
		"language": 889
	},
	"bhh": {
		"language": 890
	},
	"bhi": {
		"language": 891
	},
	"bhj": {
		"language": 892
	},
	"bhk": {
		"language": 893
	},
	"bhl": {
		"language": 894
	},
	"bhm": {
		"language": 895
	},
	"bhn": {
		"language": 896
	},
	"bho": {
		"language": 897
	},
	"bhp": {
		"language": 898
	},
	"bhq": {
		"language": 899
	},
	"bhr": {
		"language": 900
	},
	"bhs": {
		"language": 901
	},
	"bht": {
		"language": 902
	},
	"bhu": {
		"language": 903
	},
	"bhv": {
		"language": 904
	},
	"bhw": {
		"language": 905
	},
	"bhx": {
		"language": 906
	},
	"bhy": {
		"language": 907
	},
	"bhz": {
		"language": 908
	},
	"bia": {
		"language": 909
	},
	"bib": {
		"language": 910
	},
	"bic": {
		"language": 911
	},
	"bid": {
		"language": 912
	},
	"bie": {
		"language": 913
	},
	"bif": {
		"language": 914
	},
	"big": {
		"language": 915
	},
	"bij": {
		"language": 916
	},
	"bik": {
		"language": 917
	},
	"bil": {
		"language": 918
	},
	"bim": {
		"language": 919
	},
	"bin": {
		"language": 920
	},
	"bio": {
		"language": 921
	},
	"bip": {
		"language": 922
	},
	"biq": {
		"language": 923
	},
	"bir": {
		"language": 924
	},
	"bit": {
		"language": 925
	},
	"biu": {
		"language": 926
	},
	"biv": {
		"language": 927
	},
	"biw": {
		"language": 928
	},
	"bix": {
		"language": 929
	},
	"biy": {
		"language": 930
	},
	"biz": {
		"language": 931
	},
	"bja": {
		"language": 932
	},
	"bjb": {
		"language": 933
	},
	"bjc": {
		"language": 934
	},
	"bjd": {
		"language": 935
	},
	"bje": {
		"language": 936
	},
	"bjf": {
		"language": 937
	},
	"bjg": {
		"language": 938
	},
	"bjh": {
		"language": 939
	},
	"bji": {
		"language": 940
	},
	"bjj": {
		"language": 941
	},
	"bjk": {
		"language": 942
	},
	"bjl": {
		"language": 943
	},
	"bjm": {
		"language": 944
	},
	"bjn": {
		"language": 945,
		"extlang": 8164
	},
	"bjo": {
		"language": 946
	},
	"bjp": {
		"language": 947
	},
	"bjq": {
		"language": 948
	},
	"bjr": {
		"language": 949
	},
	"bjs": {
		"language": 950
	},
	"bjt": {
		"language": 951
	},
	"bju": {
		"language": 952
	},
	"bjv": {
		"language": 953
	},
	"bjw": {
		"language": 954
	},
	"bjx": {
		"language": 955
	},
	"bjy": {
		"language": 956
	},
	"bjz": {
		"language": 957
	},
	"bka": {
		"language": 958
	},
	"bkb": {
		"language": 959
	},
	"bkc": {
		"language": 960
	},
	"bkd": {
		"language": 961
	},
	"bkf": {
		"language": 962
	},
	"bkg": {
		"language": 963
	},
	"bkh": {
		"language": 964
	},
	"bki": {
		"language": 965
	},
	"bkj": {
		"language": 966
	},
	"bkk": {
		"language": 967
	},
	"bkl": {
		"language": 968
	},
	"bkm": {
		"language": 969
	},
	"bkn": {
		"language": 970
	},
	"bko": {
		"language": 971
	},
	"bkp": {
		"language": 972
	},
	"bkq": {
		"language": 973
	},
	"bkr": {
		"language": 974
	},
	"bks": {
		"language": 975
	},
	"bkt": {
		"language": 976
	},
	"bku": {
		"language": 977
	},
	"bkv": {
		"language": 978
	},
	"bkw": {
		"language": 979
	},
	"bkx": {
		"language": 980
	},
	"bky": {
		"language": 981
	},
	"bkz": {
		"language": 982
	},
	"bla": {
		"language": 983
	},
	"blb": {
		"language": 984
	},
	"blc": {
		"language": 985
	},
	"bld": {
		"language": 986
	},
	"ble": {
		"language": 987
	},
	"blf": {
		"language": 988
	},
	"blg": {
		"language": 989
	},
	"blh": {
		"language": 990
	},
	"bli": {
		"language": 991
	},
	"blj": {
		"language": 992
	},
	"blk": {
		"language": 993
	},
	"bll": {
		"language": 994
	},
	"blm": {
		"language": 995
	},
	"bln": {
		"language": 996
	},
	"blo": {
		"language": 997
	},
	"blp": {
		"language": 998
	},
	"blq": {
		"language": 999
	},
	"blr": {
		"language": 1000
	},
	"bls": {
		"language": 1001
	},
	"blt": {
		"language": 1002
	},
	"blv": {
		"language": 1003
	},
	"blw": {
		"language": 1004
	},
	"blx": {
		"language": 1005
	},
	"bly": {
		"language": 1006
	},
	"blz": {
		"language": 1007
	},
	"bma": {
		"language": 1008
	},
	"bmb": {
		"language": 1009
	},
	"bmc": {
		"language": 1010
	},
	"bmd": {
		"language": 1011
	},
	"bme": {
		"language": 1012
	},
	"bmf": {
		"language": 1013
	},
	"bmg": {
		"language": 1014
	},
	"bmh": {
		"language": 1015
	},
	"bmi": {
		"language": 1016
	},
	"bmj": {
		"language": 1017
	},
	"bmk": {
		"language": 1018
	},
	"bml": {
		"language": 1019
	},
	"bmm": {
		"language": 1020
	},
	"bmn": {
		"language": 1021
	},
	"bmo": {
		"language": 1022
	},
	"bmp": {
		"language": 1023
	},
	"bmq": {
		"language": 1024
	},
	"bmr": {
		"language": 1025
	},
	"bms": {
		"language": 1026
	},
	"bmt": {
		"language": 1027
	},
	"bmu": {
		"language": 1028
	},
	"bmv": {
		"language": 1029
	},
	"bmw": {
		"language": 1030
	},
	"bmx": {
		"language": 1031
	},
	"bmy": {
		"language": 1032
	},
	"bmz": {
		"language": 1033
	},
	"bna": {
		"language": 1034
	},
	"bnb": {
		"language": 1035
	},
	"bnc": {
		"language": 1036
	},
	"bnd": {
		"language": 1037
	},
	"bne": {
		"language": 1038
	},
	"bnf": {
		"language": 1039
	},
	"bng": {
		"language": 1040
	},
	"bni": {
		"language": 1041
	},
	"bnj": {
		"language": 1042
	},
	"bnk": {
		"language": 1043
	},
	"bnl": {
		"language": 1044
	},
	"bnm": {
		"language": 1045
	},
	"bnn": {
		"language": 1046
	},
	"bno": {
		"language": 1047
	},
	"bnp": {
		"language": 1048
	},
	"bnq": {
		"language": 1049
	},
	"bnr": {
		"language": 1050
	},
	"bns": {
		"language": 1051
	},
	"bnt": {
		"language": 1052
	},
	"bnu": {
		"language": 1053
	},
	"bnv": {
		"language": 1054
	},
	"bnw": {
		"language": 1055
	},
	"bnx": {
		"language": 1056
	},
	"bny": {
		"language": 1057
	},
	"bnz": {
		"language": 1058
	},
	"boa": {
		"language": 1059
	},
	"bob": {
		"language": 1060
	},
	"boe": {
		"language": 1061
	},
	"bof": {
		"language": 1062
	},
	"bog": {
		"language": 1063,
		"extlang": 8165
	},
	"boh": {
		"language": 1064
	},
	"boi": {
		"language": 1065
	},
	"boj": {
		"language": 1066
	},
	"bok": {
		"language": 1067
	},
	"bol": {
		"language": 1068
	},
	"bom": {
		"language": 1069
	},
	"bon": {
		"language": 1070
	},
	"boo": {
		"language": 1071
	},
	"bop": {
		"language": 1072
	},
	"boq": {
		"language": 1073
	},
	"bor": {
		"language": 1074
	},
	"bot": {
		"language": 1075
	},
	"bou": {
		"language": 1076
	},
	"bov": {
		"language": 1077
	},
	"bow": {
		"language": 1078
	},
	"box": {
		"language": 1079
	},
	"boy": {
		"language": 1080
	},
	"boz": {
		"language": 1081
	},
	"bpa": {
		"language": 1082
	},
	"bpb": {
		"language": 1083
	},
	"bpd": {
		"language": 1084
	},
	"bpg": {
		"language": 1085
	},
	"bph": {
		"language": 1086
	},
	"bpi": {
		"language": 1087
	},
	"bpj": {
		"language": 1088
	},
	"bpk": {
		"language": 1089
	},
	"bpl": {
		"language": 1090
	},
	"bpm": {
		"language": 1091
	},
	"bpn": {
		"language": 1092
	},
	"bpo": {
		"language": 1093
	},
	"bpp": {
		"language": 1094
	},
	"bpq": {
		"language": 1095
	},
	"bpr": {
		"language": 1096
	},
	"bps": {
		"language": 1097
	},
	"bpt": {
		"language": 1098
	},
	"bpu": {
		"language": 1099
	},
	"bpv": {
		"language": 1100
	},
	"bpw": {
		"language": 1101
	},
	"bpx": {
		"language": 1102
	},
	"bpy": {
		"language": 1103
	},
	"bpz": {
		"language": 1104
	},
	"bqa": {
		"language": 1105
	},
	"bqb": {
		"language": 1106
	},
	"bqc": {
		"language": 1107
	},
	"bqd": {
		"language": 1108
	},
	"bqf": {
		"language": 1109
	},
	"bqg": {
		"language": 1110
	},
	"bqh": {
		"language": 1111
	},
	"bqi": {
		"language": 1112
	},
	"bqj": {
		"language": 1113
	},
	"bqk": {
		"language": 1114
	},
	"bql": {
		"language": 1115
	},
	"bqm": {
		"language": 1116
	},
	"bqn": {
		"language": 1117,
		"extlang": 8166
	},
	"bqo": {
		"language": 1118
	},
	"bqp": {
		"language": 1119
	},
	"bqq": {
		"language": 1120
	},
	"bqr": {
		"language": 1121
	},
	"bqs": {
		"language": 1122
	},
	"bqt": {
		"language": 1123
	},
	"bqu": {
		"language": 1124
	},
	"bqv": {
		"language": 1125
	},
	"bqw": {
		"language": 1126
	},
	"bqx": {
		"language": 1127
	},
	"bqy": {
		"language": 1128,
		"extlang": 8167
	},
	"bqz": {
		"language": 1129
	},
	"bra": {
		"language": 1130
	},
	"brb": {
		"language": 1131
	},
	"brc": {
		"language": 1132
	},
	"brd": {
		"language": 1133
	},
	"brf": {
		"language": 1134
	},
	"brg": {
		"language": 1135
	},
	"brh": {
		"language": 1136
	},
	"bri": {
		"language": 1137
	},
	"brj": {
		"language": 1138
	},
	"brk": {
		"language": 1139
	},
	"brl": {
		"language": 1140
	},
	"brm": {
		"language": 1141
	},
	"brn": {
		"language": 1142
	},
	"bro": {
		"language": 1143
	},
	"brp": {
		"language": 1144
	},
	"brq": {
		"language": 1145
	},
	"brr": {
		"language": 1146
	},
	"brs": {
		"language": 1147
	},
	"brt": {
		"language": 1148
	},
	"bru": {
		"language": 1149
	},
	"brv": {
		"language": 1150
	},
	"brw": {
		"language": 1151
	},
	"brx": {
		"language": 1152
	},
	"bry": {
		"language": 1153
	},
	"brz": {
		"language": 1154
	},
	"bsa": {
		"language": 1155
	},
	"bsb": {
		"language": 1156
	},
	"bsc": {
		"language": 1157
	},
	"bse": {
		"language": 1158
	},
	"bsf": {
		"language": 1159
	},
	"bsg": {
		"language": 1160
	},
	"bsh": {
		"language": 1161
	},
	"bsi": {
		"language": 1162
	},
	"bsj": {
		"language": 1163
	},
	"bsk": {
		"language": 1164
	},
	"bsl": {
		"language": 1165
	},
	"bsm": {
		"language": 1166
	},
	"bsn": {
		"language": 1167
	},
	"bso": {
		"language": 1168
	},
	"bsp": {
		"language": 1169
	},
	"bsq": {
		"language": 1170
	},
	"bsr": {
		"language": 1171
	},
	"bss": {
		"language": 1172
	},
	"bst": {
		"language": 1173
	},
	"bsu": {
		"language": 1174
	},
	"bsv": {
		"language": 1175
	},
	"bsw": {
		"language": 1176
	},
	"bsx": {
		"language": 1177
	},
	"bsy": {
		"language": 1178
	},
	"bta": {
		"language": 1179
	},
	"btb": {
		"language": 1180
	},
	"btc": {
		"language": 1181
	},
	"btd": {
		"language": 1182
	},
	"bte": {
		"language": 1183
	},
	"btf": {
		"language": 1184
	},
	"btg": {
		"language": 1185
	},
	"bth": {
		"language": 1186
	},
	"bti": {
		"language": 1187
	},
	"btj": {
		"language": 1188,
		"extlang": 8168
	},
	"btk": {
		"language": 1189
	},
	"btl": {
		"language": 1190
	},
	"btm": {
		"language": 1191
	},
	"btn": {
		"language": 1192
	},
	"bto": {
		"language": 1193
	},
	"btp": {
		"language": 1194
	},
	"btq": {
		"language": 1195
	},
	"btr": {
		"language": 1196
	},
	"bts": {
		"language": 1197
	},
	"btt": {
		"language": 1198
	},
	"btu": {
		"language": 1199
	},
	"btv": {
		"language": 1200
	},
	"btw": {
		"language": 1201
	},
	"btx": {
		"language": 1202
	},
	"bty": {
		"language": 1203
	},
	"btz": {
		"language": 1204
	},
	"bua": {
		"language": 1205
	},
	"bub": {
		"language": 1206
	},
	"buc": {
		"language": 1207
	},
	"bud": {
		"language": 1208
	},
	"bue": {
		"language": 1209
	},
	"buf": {
		"language": 1210
	},
	"bug": {
		"language": 1211
	},
	"buh": {
		"language": 1212
	},
	"bui": {
		"language": 1213
	},
	"buj": {
		"language": 1214
	},
	"buk": {
		"language": 1215
	},
	"bum": {
		"language": 1216
	},
	"bun": {
		"language": 1217
	},
	"buo": {
		"language": 1218
	},
	"bup": {
		"language": 1219
	},
	"buq": {
		"language": 1220
	},
	"bus": {
		"language": 1221
	},
	"but": {
		"language": 1222
	},
	"buu": {
		"language": 1223
	},
	"buv": {
		"language": 1224
	},
	"buw": {
		"language": 1225
	},
	"bux": {
		"language": 1226
	},
	"buy": {
		"language": 1227
	},
	"buz": {
		"language": 1228
	},
	"bva": {
		"language": 1229
	},
	"bvb": {
		"language": 1230
	},
	"bvc": {
		"language": 1231
	},
	"bvd": {
		"language": 1232
	},
	"bve": {
		"language": 1233,
		"extlang": 8169
	},
	"bvf": {
		"language": 1234
	},
	"bvg": {
		"language": 1235
	},
	"bvh": {
		"language": 1236
	},
	"bvi": {
		"language": 1237
	},
	"bvj": {
		"language": 1238
	},
	"bvk": {
		"language": 1239
	},
	"bvl": {
		"language": 1240,
		"extlang": 8170
	},
	"bvm": {
		"language": 1241
	},
	"bvn": {
		"language": 1242
	},
	"bvo": {
		"language": 1243
	},
	"bvp": {
		"language": 1244
	},
	"bvq": {
		"language": 1245
	},
	"bvr": {
		"language": 1246
	},
	"bvt": {
		"language": 1247
	},
	"bvu": {
		"language": 1248,
		"extlang": 8171
	},
	"bvv": {
		"language": 1249
	},
	"bvw": {
		"language": 1250
	},
	"bvx": {
		"language": 1251
	},
	"bvy": {
		"language": 1252
	},
	"bvz": {
		"language": 1253
	},
	"bwa": {
		"language": 1254
	},
	"bwb": {
		"language": 1255
	},
	"bwc": {
		"language": 1256
	},
	"bwd": {
		"language": 1257
	},
	"bwe": {
		"language": 1258
	},
	"bwf": {
		"language": 1259
	},
	"bwg": {
		"language": 1260
	},
	"bwh": {
		"language": 1261
	},
	"bwi": {
		"language": 1262
	},
	"bwj": {
		"language": 1263
	},
	"bwk": {
		"language": 1264
	},
	"bwl": {
		"language": 1265
	},
	"bwm": {
		"language": 1266
	},
	"bwn": {
		"language": 1267
	},
	"bwo": {
		"language": 1268
	},
	"bwp": {
		"language": 1269
	},
	"bwq": {
		"language": 1270
	},
	"bwr": {
		"language": 1271
	},
	"bws": {
		"language": 1272
	},
	"bwt": {
		"language": 1273
	},
	"bwu": {
		"language": 1274
	},
	"bww": {
		"language": 1275
	},
	"bwx": {
		"language": 1276
	},
	"bwy": {
		"language": 1277
	},
	"bwz": {
		"language": 1278
	},
	"bxa": {
		"language": 1279
	},
	"bxb": {
		"language": 1280
	},
	"bxc": {
		"language": 1281
	},
	"bxd": {
		"language": 1282
	},
	"bxe": {
		"language": 1283
	},
	"bxf": {
		"language": 1284
	},
	"bxg": {
		"language": 1285
	},
	"bxh": {
		"language": 1286
	},
	"bxi": {
		"language": 1287
	},
	"bxj": {
		"language": 1288
	},
	"bxk": {
		"language": 1289
	},
	"bxl": {
		"language": 1290
	},
	"bxm": {
		"language": 1291
	},
	"bxn": {
		"language": 1292
	},
	"bxo": {
		"language": 1293
	},
	"bxp": {
		"language": 1294
	},
	"bxq": {
		"language": 1295
	},
	"bxr": {
		"language": 1296
	},
	"bxs": {
		"language": 1297
	},
	"bxu": {
		"language": 1298
	},
	"bxv": {
		"language": 1299
	},
	"bxw": {
		"language": 1300
	},
	"bxx": {
		"language": 1301
	},
	"bxz": {
		"language": 1302
	},
	"bya": {
		"language": 1303
	},
	"byb": {
		"language": 1304
	},
	"byc": {
		"language": 1305
	},
	"byd": {
		"language": 1306
	},
	"bye": {
		"language": 1307
	},
	"byf": {
		"language": 1308
	},
	"byg": {
		"language": 1309
	},
	"byh": {
		"language": 1310
	},
	"byi": {
		"language": 1311
	},
	"byj": {
		"language": 1312
	},
	"byk": {
		"language": 1313
	},
	"byl": {
		"language": 1314
	},
	"bym": {
		"language": 1315
	},
	"byn": {
		"language": 1316
	},
	"byo": {
		"language": 1317
	},
	"byp": {
		"language": 1318
	},
	"byq": {
		"language": 1319
	},
	"byr": {
		"language": 1320
	},
	"bys": {
		"language": 1321
	},
	"byt": {
		"language": 1322
	},
	"byv": {
		"language": 1323
	},
	"byw": {
		"language": 1324
	},
	"byx": {
		"language": 1325
	},
	"byy": {
		"language": 1326
	},
	"byz": {
		"language": 1327
	},
	"bza": {
		"language": 1328
	},
	"bzb": {
		"language": 1329
	},
	"bzc": {
		"language": 1330
	},
	"bzd": {
		"language": 1331
	},
	"bze": {
		"language": 1332
	},
	"bzf": {
		"language": 1333
	},
	"bzg": {
		"language": 1334
	},
	"bzh": {
		"language": 1335
	},
	"bzi": {
		"language": 1336
	},
	"bzj": {
		"language": 1337
	},
	"bzk": {
		"language": 1338
	},
	"bzl": {
		"language": 1339
	},
	"bzm": {
		"language": 1340
	},
	"bzn": {
		"language": 1341
	},
	"bzo": {
		"language": 1342
	},
	"bzp": {
		"language": 1343
	},
	"bzq": {
		"language": 1344
	},
	"bzr": {
		"language": 1345
	},
	"bzs": {
		"language": 1346,
		"extlang": 8172
	},
	"bzt": {
		"language": 1347
	},
	"bzu": {
		"language": 1348
	},
	"bzv": {
		"language": 1349
	},
	"bzw": {
		"language": 1350
	},
	"bzx": {
		"language": 1351
	},
	"bzy": {
		"language": 1352
	},
	"bzz": {
		"language": 1353
	},
	"caa": {
		"language": 1354
	},
	"cab": {
		"language": 1355
	},
	"cac": {
		"language": 1356
	},
	"cad": {
		"language": 1357
	},
	"cae": {
		"language": 1358
	},
	"caf": {
		"language": 1359
	},
	"cag": {
		"language": 1360
	},
	"cah": {
		"language": 1361
	},
	"cai": {
		"language": 1362
	},
	"caj": {
		"language": 1363
	},
	"cak": {
		"language": 1364
	},
	"cal": {
		"language": 1365
	},
	"cam": {
		"language": 1366
	},
	"can": {
		"language": 1367
	},
	"cao": {
		"language": 1368
	},
	"cap": {
		"language": 1369
	},
	"caq": {
		"language": 1370
	},
	"car": {
		"language": 1371
	},
	"cas": {
		"language": 1372
	},
	"cau": {
		"language": 1373
	},
	"cav": {
		"language": 1374
	},
	"caw": {
		"language": 1375
	},
	"cax": {
		"language": 1376
	},
	"cay": {
		"language": 1377
	},
	"caz": {
		"language": 1378
	},
	"cba": {
		"language": 1379
	},
	"cbb": {
		"language": 1380
	},
	"cbc": {
		"language": 1381
	},
	"cbd": {
		"language": 1382
	},
	"cbe": {
		"language": 1383
	},
	"cbg": {
		"language": 1384
	},
	"cbh": {
		"language": 1385
	},
	"cbi": {
		"language": 1386
	},
	"cbj": {
		"language": 1387
	},
	"cbk": {
		"language": 1388
	},
	"cbl": {
		"language": 1389
	},
	"cbn": {
		"language": 1390
	},
	"cbo": {
		"language": 1391
	},
	"cbq": {
		"language": 1392
	},
	"cbr": {
		"language": 1393
	},
	"cbs": {
		"language": 1394
	},
	"cbt": {
		"language": 1395
	},
	"cbu": {
		"language": 1396
	},
	"cbv": {
		"language": 1397
	},
	"cbw": {
		"language": 1398
	},
	"cby": {
		"language": 1399
	},
	"cca": {
		"language": 1400
	},
	"ccc": {
		"language": 1401
	},
	"ccd": {
		"language": 1402
	},
	"cce": {
		"language": 1403
	},
	"ccg": {
		"language": 1404
	},
	"cch": {
		"language": 1405
	},
	"ccj": {
		"language": 1406
	},
	"ccl": {
		"language": 1407
	},
	"ccm": {
		"language": 1408
	},
	"ccn": {
		"language": 1409
	},
	"cco": {
		"language": 1410
	},
	"ccp": {
		"language": 1411
	},
	"ccq": {
		"language": 1412
	},
	"ccr": {
		"language": 1413
	},
	"ccs": {
		"language": 1414
	},
	"cda": {
		"language": 1415
	},
	"cdc": {
		"language": 1416
	},
	"cdd": {
		"language": 1417
	},
	"cde": {
		"language": 1418
	},
	"cdf": {
		"language": 1419
	},
	"cdg": {
		"language": 1420
	},
	"cdh": {
		"language": 1421
	},
	"cdi": {
		"language": 1422
	},
	"cdj": {
		"language": 1423
	},
	"cdm": {
		"language": 1424
	},
	"cdn": {
		"language": 1425
	},
	"cdo": {
		"language": 1426,
		"extlang": 8173
	},
	"cdr": {
		"language": 1427
	},
	"cds": {
		"language": 1428,
		"extlang": 8174
	},
	"cdy": {
		"language": 1429
	},
	"cdz": {
		"language": 1430
	},
	"cea": {
		"language": 1431
	},
	"ceb": {
		"language": 1432
	},
	"ceg": {
		"language": 1433
	},
	"cek": {
		"language": 1434
	},
	"cel": {
		"language": 1435
	},
	"cen": {
		"language": 1436
	},
	"cet": {
		"language": 1437
	},
	"cfa": {
		"language": 1438
	},
	"cfd": {
		"language": 1439
	},
	"cfg": {
		"language": 1440
	},
	"cfm": {
		"language": 1441
	},
	"cga": {
		"language": 1442
	},
	"cgc": {
		"language": 1443
	},
	"cgg": {
		"language": 1444
	},
	"cgk": {
		"language": 1445
	},
	"chb": {
		"language": 1446
	},
	"chc": {
		"language": 1447
	},
	"chd": {
		"language": 1448
	},
	"chf": {
		"language": 1449
	},
	"chg": {
		"language": 1450
	},
	"chh": {
		"language": 1451
	},
	"chj": {
		"language": 1452
	},
	"chk": {
		"language": 1453
	},
	"chl": {
		"language": 1454
	},
	"chm": {
		"language": 1455
	},
	"chn": {
		"language": 1456
	},
	"cho": {
		"language": 1457
	},
	"chp": {
		"language": 1458
	},
	"chq": {
		"language": 1459
	},
	"chr": {
		"language": 1460
	},
	"cht": {
		"language": 1461
	},
	"chw": {
		"language": 1462
	},
	"chx": {
		"language": 1463
	},
	"chy": {
		"language": 1464
	},
	"chz": {
		"language": 1465
	},
	"cia": {
		"language": 1466
	},
	"cib": {
		"language": 1467
	},
	"cic": {
		"language": 1468
	},
	"cid": {
		"language": 1469
	},
	"cie": {
		"language": 1470
	},
	"cih": {
		"language": 1471
	},
	"cik": {
		"language": 1472
	},
	"cim": {
		"language": 1473
	},
	"cin": {
		"language": 1474
	},
	"cip": {
		"language": 1475
	},
	"cir": {
		"language": 1476
	},
	"ciw": {
		"language": 1477
	},
	"ciy": {
		"language": 1478
	},
	"cja": {
		"language": 1479
	},
	"cje": {
		"language": 1480
	},
	"cjh": {
		"language": 1481
	},
	"cji": {
		"language": 1482
	},
	"cjk": {
		"language": 1483
	},
	"cjm": {
		"language": 1484
	},
	"cjn": {
		"language": 1485
	},
	"cjo": {
		"language": 1486
	},
	"cjp": {
		"language": 1487
	},
	"cjr": {
		"language": 1488
	},
	"cjs": {
		"language": 1489
	},
	"cjv": {
		"language": 1490
	},
	"cjy": {
		"language": 1491,
		"extlang": 8175
	},
	"cka": {
		"language": 1492
	},
	"ckb": {
		"language": 1493
	},
	"ckh": {
		"language": 1494
	},
	"ckl": {
		"language": 1495
	},
	"ckn": {
		"language": 1496
	},
	"cko": {
		"language": 1497
	},
	"ckq": {
		"language": 1498
	},
	"ckr": {
		"language": 1499
	},
	"cks": {
		"language": 1500
	},
	"ckt": {
		"language": 1501
	},
	"cku": {
		"language": 1502
	},
	"ckv": {
		"language": 1503
	},
	"ckx": {
		"language": 1504
	},
	"cky": {
		"language": 1505
	},
	"ckz": {
		"language": 1506
	},
	"cla": {
		"language": 1507
	},
	"clc": {
		"language": 1508
	},
	"cld": {
		"language": 1509
	},
	"cle": {
		"language": 1510
	},
	"clh": {
		"language": 1511
	},
	"cli": {
		"language": 1512
	},
	"clj": {
		"language": 1513
	},
	"clk": {
		"language": 1514
	},
	"cll": {
		"language": 1515
	},
	"clm": {
		"language": 1516
	},
	"clo": {
		"language": 1517
	},
	"clt": {
		"language": 1518
	},
	"clu": {
		"language": 1519
	},
	"clw": {
		"language": 1520
	},
	"cly": {
		"language": 1521
	},
	"cma": {
		"language": 1522
	},
	"cmc": {
		"language": 1523
	},
	"cme": {
		"language": 1524
	},
	"cmg": {
		"language": 1525
	},
	"cmi": {
		"language": 1526
	},
	"cmk": {
		"language": 1527
	},
	"cml": {
		"language": 1528
	},
	"cmm": {
		"language": 1529
	},
	"cmn": {
		"language": 1530,
		"extlang": 8176
	},
	"cmo": {
		"language": 1531
	},
	"cmr": {
		"language": 1532
	},
	"cms": {
		"language": 1533
	},
	"cmt": {
		"language": 1534
	},
	"cna": {
		"language": 1535
	},
	"cnb": {
		"language": 1536
	},
	"cnc": {
		"language": 1537
	},
	"cng": {
		"language": 1538
	},
	"cnh": {
		"language": 1539
	},
	"cni": {
		"language": 1540
	},
	"cnk": {
		"language": 1541
	},
	"cnl": {
		"language": 1542
	},
	"cno": {
		"language": 1543
	},
	"cns": {
		"language": 1544
	},
	"cnt": {
		"language": 1545
	},
	"cnu": {
		"language": 1546
	},
	"cnw": {
		"language": 1547
	},
	"cnx": {
		"language": 1548
	},
	"coa": {
		"language": 1549,
		"extlang": 8177
	},
	"cob": {
		"language": 1550
	},
	"coc": {
		"language": 1551
	},
	"cod": {
		"language": 1552
	},
	"coe": {
		"language": 1553
	},
	"cof": {
		"language": 1554
	},
	"cog": {
		"language": 1555
	},
	"coh": {
		"language": 1556
	},
	"coj": {
		"language": 1557
	},
	"cok": {
		"language": 1558
	},
	"col": {
		"language": 1559
	},
	"com": {
		"language": 1560
	},
	"con": {
		"language": 1561
	},
	"coo": {
		"language": 1562
	},
	"cop": {
		"language": 1563
	},
	"coq": {
		"language": 1564
	},
	"cot": {
		"language": 1565
	},
	"cou": {
		"language": 1566
	},
	"cov": {
		"language": 1567
	},
	"cow": {
		"language": 1568
	},
	"cox": {
		"language": 1569
	},
	"coy": {
		"language": 1570
	},
	"coz": {
		"language": 1571
	},
	"cpa": {
		"language": 1572
	},
	"cpb": {
		"language": 1573
	},
	"cpc": {
		"language": 1574
	},
	"cpe": {
		"language": 1575
	},
	"cpf": {
		"language": 1576
	},
	"cpg": {
		"language": 1577
	},
	"cpi": {
		"language": 1578
	},
	"cpn": {
		"language": 1579
	},
	"cpo": {
		"language": 1580
	},
	"cpp": {
		"language": 1581
	},
	"cps": {
		"language": 1582
	},
	"cpu": {
		"language": 1583
	},
	"cpx": {
		"language": 1584,
		"extlang": 8178
	},
	"cpy": {
		"language": 1585
	},
	"cqd": {
		"language": 1586
	},
	"cqu": {
		"language": 1587
	},
	"cra": {
		"language": 1588
	},
	"crb": {
		"language": 1589
	},
	"crc": {
		"language": 1590
	},
	"crd": {
		"language": 1591
	},
	"crf": {
		"language": 1592
	},
	"crg": {
		"language": 1593
	},
	"crh": {
		"language": 1594
	},
	"cri": {
		"language": 1595
	},
	"crj": {
		"language": 1596
	},
	"crk": {
		"language": 1597
	},
	"crl": {
		"language": 1598
	},
	"crm": {
		"language": 1599
	},
	"crn": {
		"language": 1600
	},
	"cro": {
		"language": 1601
	},
	"crp": {
		"language": 1602
	},
	"crq": {
		"language": 1603
	},
	"crr": {
		"language": 1604
	},
	"crs": {
		"language": 1605
	},
	"crt": {
		"language": 1606
	},
	"crv": {
		"language": 1607
	},
	"crw": {
		"language": 1608
	},
	"crx": {
		"language": 1609
	},
	"cry": {
		"language": 1610
	},
	"crz": {
		"language": 1611
	},
	"csa": {
		"language": 1612
	},
	"csb": {
		"language": 1613
	},
	"csc": {
		"language": 1614,
		"extlang": 8179
	},
	"csd": {
		"language": 1615,
		"extlang": 8180
	},
	"cse": {
		"language": 1616,
		"extlang": 8181
	},
	"csf": {
		"language": 1617,
		"extlang": 8182
	},
	"csg": {
		"language": 1618,
		"extlang": 8183
	},
	"csh": {
		"language": 1619
	},
	"csi": {
		"language": 1620
	},
	"csj": {
		"language": 1621
	},
	"csk": {
		"language": 1622
	},
	"csl": {
		"language": 1623,
		"extlang": 8184
	},
	"csm": {
		"language": 1624
	},
	"csn": {
		"language": 1625,
		"extlang": 8185
	},
	"cso": {
		"language": 1626
	},
	"csq": {
		"language": 1627,
		"extlang": 8186
	},
	"csr": {
		"language": 1628,
		"extlang": 8187
	},
	"css": {
		"language": 1629
	},
	"cst": {
		"language": 1630
	},
	"csu": {
		"language": 1631
	},
	"csv": {
		"language": 1632
	},
	"csw": {
		"language": 1633
	},
	"csy": {
		"language": 1634
	},
	"csz": {
		"language": 1635
	},
	"cta": {
		"language": 1636
	},
	"ctc": {
		"language": 1637
	},
	"ctd": {
		"language": 1638
	},
	"cte": {
		"language": 1639
	},
	"ctg": {
		"language": 1640
	},
	"cth": {
		"language": 1641
	},
	"ctl": {
		"language": 1642
	},
	"ctm": {
		"language": 1643
	},
	"ctn": {
		"language": 1644
	},
	"cto": {
		"language": 1645
	},
	"ctp": {
		"language": 1646
	},
	"cts": {
		"language": 1647
	},
	"ctt": {
		"language": 1648
	},
	"ctu": {
		"language": 1649
	},
	"ctz": {
		"language": 1650
	},
	"cua": {
		"language": 1651
	},
	"cub": {
		"language": 1652
	},
	"cuc": {
		"language": 1653
	},
	"cug": {
		"language": 1654
	},
	"cuh": {
		"language": 1655
	},
	"cui": {
		"language": 1656
	},
	"cuj": {
		"language": 1657
	},
	"cuk": {
		"language": 1658
	},
	"cul": {
		"language": 1659
	},
	"cum": {
		"language": 1660
	},
	"cuo": {
		"language": 1661
	},
	"cup": {
		"language": 1662
	},
	"cuq": {
		"language": 1663
	},
	"cur": {
		"language": 1664
	},
	"cus": {
		"language": 1665
	},
	"cut": {
		"language": 1666
	},
	"cuu": {
		"language": 1667
	},
	"cuv": {
		"language": 1668
	},
	"cuw": {
		"language": 1669
	},
	"cux": {
		"language": 1670
	},
	"cvg": {
		"language": 1671
	},
	"cvn": {
		"language": 1672
	},
	"cwa": {
		"language": 1673
	},
	"cwb": {
		"language": 1674
	},
	"cwd": {
		"language": 1675
	},
	"cwe": {
		"language": 1676
	},
	"cwg": {
		"language": 1677
	},
	"cwt": {
		"language": 1678
	},
	"cya": {
		"language": 1679
	},
	"cyb": {
		"language": 1680
	},
	"cyo": {
		"language": 1681
	},
	"czh": {
		"language": 1682,
		"extlang": 8188
	},
	"czk": {
		"language": 1683
	},
	"czn": {
		"language": 1684
	},
	"czo": {
		"language": 1685,
		"extlang": 8189
	},
	"czt": {
		"language": 1686
	},
	"daa": {
		"language": 1687
	},
	"dac": {
		"language": 1688
	},
	"dad": {
		"language": 1689
	},
	"dae": {
		"language": 1690
	},
	"daf": {
		"language": 1691
	},
	"dag": {
		"language": 1692
	},
	"dah": {
		"language": 1693
	},
	"dai": {
		"language": 1694
	},
	"daj": {
		"language": 1695
	},
	"dak": {
		"language": 1696
	},
	"dal": {
		"language": 1697
	},
	"dam": {
		"language": 1698
	},
	"dao": {
		"language": 1699
	},
	"dap": {
		"language": 1700
	},
	"daq": {
		"language": 1701
	},
	"dar": {
		"language": 1702
	},
	"das": {
		"language": 1703
	},
	"dau": {
		"language": 1704
	},
	"dav": {
		"language": 1705
	},
	"daw": {
		"language": 1706
	},
	"dax": {
		"language": 1707
	},
	"day": {
		"language": 1708
	},
	"daz": {
		"language": 1709
	},
	"dba": {
		"language": 1710
	},
	"dbb": {
		"language": 1711
	},
	"dbd": {
		"language": 1712
	},
	"dbe": {
		"language": 1713
	},
	"dbf": {
		"language": 1714
	},
	"dbg": {
		"language": 1715
	},
	"dbi": {
		"language": 1716
	},
	"dbj": {
		"language": 1717
	},
	"dbl": {
		"language": 1718
	},
	"dbm": {
		"language": 1719
	},
	"dbn": {
		"language": 1720
	},
	"dbo": {
		"language": 1721
	},
	"dbp": {
		"language": 1722
	},
	"dbq": {
		"language": 1723
	},
	"dbr": {
		"language": 1724
	},
	"dbt": {
		"language": 1725
	},
	"dbu": {
		"language": 1726
	},
	"dbv": {
		"language": 1727
	},
	"dbw": {
		"language": 1728
	},
	"dby": {
		"language": 1729
	},
	"dcc": {
		"language": 1730
	},
	"dcr": {
		"language": 1731
	},
	"dda": {
		"language": 1732
	},
	"ddd": {
		"language": 1733
	},
	"dde": {
		"language": 1734
	},
	"ddg": {
		"language": 1735
	},
	"ddi": {
		"language": 1736
	},
	"ddj": {
		"language": 1737
	},
	"ddn": {
		"language": 1738
	},
	"ddo": {
		"language": 1739
	},
	"ddr": {
		"language": 1740
	},
	"dds": {
		"language": 1741
	},
	"ddw": {
		"language": 1742
	},
	"dec": {
		"language": 1743
	},
	"ded": {
		"language": 1744
	},
	"dee": {
		"language": 1745
	},
	"def": {
		"language": 1746
	},
	"deg": {
		"language": 1747
	},
	"deh": {
		"language": 1748
	},
	"dei": {
		"language": 1749
	},
	"dek": {
		"language": 1750
	},
	"del": {
		"language": 1751
	},
	"dem": {
		"language": 1752
	},
	"den": {
		"language": 1753
	},
	"dep": {
		"language": 1754
	},
	"deq": {
		"language": 1755
	},
	"der": {
		"language": 1756
	},
	"des": {
		"language": 1757
	},
	"dev": {
		"language": 1758
	},
	"dez": {
		"language": 1759
	},
	"dga": {
		"language": 1760
	},
	"dgb": {
		"language": 1761
	},
	"dgc": {
		"language": 1762
	},
	"dgd": {
		"language": 1763
	},
	"dge": {
		"language": 1764
	},
	"dgg": {
		"language": 1765
	},
	"dgh": {
		"language": 1766
	},
	"dgi": {
		"language": 1767
	},
	"dgk": {
		"language": 1768
	},
	"dgl": {
		"language": 1769
	},
	"dgn": {
		"language": 1770
	},
	"dgo": {
		"language": 1771
	},
	"dgr": {
		"language": 1772
	},
	"dgs": {
		"language": 1773
	},
	"dgt": {
		"language": 1774
	},
	"dgu": {
		"language": 1775
	},
	"dgw": {
		"language": 1776
	},
	"dgx": {
		"language": 1777
	},
	"dgz": {
		"language": 1778
	},
	"dha": {
		"language": 1779
	},
	"dhd": {
		"language": 1780
	},
	"dhg": {
		"language": 1781
	},
	"dhi": {
		"language": 1782
	},
	"dhl": {
		"language": 1783
	},
	"dhm": {
		"language": 1784
	},
	"dhn": {
		"language": 1785
	},
	"dho": {
		"language": 1786
	},
	"dhr": {
		"language": 1787
	},
	"dhs": {
		"language": 1788
	},
	"dhu": {
		"language": 1789
	},
	"dhv": {
		"language": 1790
	},
	"dhw": {
		"language": 1791
	},
	"dhx": {
		"language": 1792
	},
	"dia": {
		"language": 1793
	},
	"dib": {
		"language": 1794
	},
	"dic": {
		"language": 1795
	},
	"did": {
		"language": 1796
	},
	"dif": {
		"language": 1797
	},
	"dig": {
		"language": 1798
	},
	"dih": {
		"language": 1799
	},
	"dii": {
		"language": 1800
	},
	"dij": {
		"language": 1801
	},
	"dik": {
		"language": 1802
	},
	"dil": {
		"language": 1803
	},
	"dim": {
		"language": 1804
	},
	"din": {
		"language": 1805
	},
	"dio": {
		"language": 1806
	},
	"dip": {
		"language": 1807
	},
	"diq": {
		"language": 1808
	},
	"dir": {
		"language": 1809
	},
	"dis": {
		"language": 1810
	},
	"dit": {
		"language": 1811
	},
	"diu": {
		"language": 1812
	},
	"diw": {
		"language": 1813
	},
	"dix": {
		"language": 1814
	},
	"diy": {
		"language": 1815
	},
	"diz": {
		"language": 1816
	},
	"dja": {
		"language": 1817
	},
	"djb": {
		"language": 1818
	},
	"djc": {
		"language": 1819
	},
	"djd": {
		"language": 1820
	},
	"dje": {
		"language": 1821
	},
	"djf": {
		"language": 1822
	},
	"dji": {
		"language": 1823
	},
	"djj": {
		"language": 1824
	},
	"djk": {
		"language": 1825
	},
	"djl": {
		"language": 1826
	},
	"djm": {
		"language": 1827
	},
	"djn": {
		"language": 1828
	},
	"djo": {
		"language": 1829
	},
	"djr": {
		"language": 1830
	},
	"dju": {
		"language": 1831
	},
	"djw": {
		"language": 1832
	},
	"dka": {
		"language": 1833
	},
	"dkk": {
		"language": 1834
	},
	"dkl": {
		"language": 1835
	},
	"dkr": {
		"language": 1836
	},
	"dks": {
		"language": 1837
	},
	"dkx": {
		"language": 1838
	},
	"dlg": {
		"language": 1839
	},
	"dlk": {
		"language": 1840
	},
	"dlm": {
		"language": 1841
	},
	"dln": {
		"language": 1842
	},
	"dma": {
		"language": 1843
	},
	"dmb": {
		"language": 1844
	},
	"dmc": {
		"language": 1845
	},
	"dmd": {
		"language": 1846
	},
	"dme": {
		"language": 1847
	},
	"dmg": {
		"language": 1848
	},
	"dmk": {
		"language": 1849
	},
	"dml": {
		"language": 1850
	},
	"dmm": {
		"language": 1851
	},
	"dmn": {
		"language": 1852
	},
	"dmo": {
		"language": 1853
	},
	"dmr": {
		"language": 1854
	},
	"dms": {
		"language": 1855
	},
	"dmu": {
		"language": 1856
	},
	"dmv": {
		"language": 1857
	},
	"dmw": {
		"language": 1858
	},
	"dmx": {
		"language": 1859
	},
	"dmy": {
		"language": 1860
	},
	"dna": {
		"language": 1861
	},
	"dnd": {
		"language": 1862
	},
	"dne": {
		"language": 1863
	},
	"dng": {
		"language": 1864
	},
	"dni": {
		"language": 1865
	},
	"dnj": {
		"language": 1866
	},
	"dnk": {
		"language": 1867
	},
	"dnn": {
		"language": 1868
	},
	"dnr": {
		"language": 1869
	},
	"dnt": {
		"language": 1870
	},
	"dnu": {
		"language": 1871
	},
	"dnv": {
		"language": 1872
	},
	"dnw": {
		"language": 1873
	},
	"dny": {
		"language": 1874
	},
	"doa": {
		"language": 1875
	},
	"dob": {
		"language": 1876
	},
	"doc": {
		"language": 1877
	},
	"doe": {
		"language": 1878
	},
	"dof": {
		"language": 1879
	},
	"doh": {
		"language": 1880
	},
	"doi": {
		"language": 1881
	},
	"dok": {
		"language": 1882
	},
	"dol": {
		"language": 1883
	},
	"don": {
		"language": 1884
	},
	"doo": {
		"language": 1885
	},
	"dop": {
		"language": 1886
	},
	"doq": {
		"language": 1887,
		"extlang": 8190
	},
	"dor": {
		"language": 1888
	},
	"dos": {
		"language": 1889
	},
	"dot": {
		"language": 1890
	},
	"dov": {
		"language": 1891
	},
	"dow": {
		"language": 1892
	},
	"dox": {
		"language": 1893
	},
	"doy": {
		"language": 1894
	},
	"doz": {
		"language": 1895
	},
	"dpp": {
		"language": 1896
	},
	"dra": {
		"language": 1897
	},
	"drb": {
		"language": 1898
	},
	"drc": {
		"language": 1899
	},
	"drd": {
		"language": 1900
	},
	"dre": {
		"language": 1901
	},
	"drg": {
		"language": 1902
	},
	"drh": {
		"language": 1903
	},
	"dri": {
		"language": 1904
	},
	"drl": {
		"language": 1905
	},
	"drn": {
		"language": 1906
	},
	"dro": {
		"language": 1907
	},
	"drq": {
		"language": 1908
	},
	"drr": {
		"language": 1909
	},
	"drs": {
		"language": 1910
	},
	"drt": {
		"language": 1911
	},
	"dru": {
		"language": 1912
	},
	"drw": {
		"language": 1913
	},
	"dry": {
		"language": 1914
	},
	"dsb": {
		"language": 1915
	},
	"dse": {
		"language": 1916,
		"extlang": 8191
	},
	"dsh": {
		"language": 1917
	},
	"dsi": {
		"language": 1918
	},
	"dsl": {
		"language": 1919,
		"extlang": 8192
	},
	"dsn": {
		"language": 1920
	},
	"dso": {
		"language": 1921
	},
	"dsq": {
		"language": 1922
	},
	"dta": {
		"language": 1923
	},
	"dtb": {
		"language": 1924
	},
	"dtd": {
		"language": 1925
	},
	"dth": {
		"language": 1926
	},
	"dti": {
		"language": 1927
	},
	"dtk": {
		"language": 1928
	},
	"dtm": {
		"language": 1929
	},
	"dtn": {
		"language": 1930
	},
	"dto": {
		"language": 1931
	},
	"dtp": {
		"language": 1932
	},
	"dtr": {
		"language": 1933
	},
	"dts": {
		"language": 1934
	},
	"dtt": {
		"language": 1935
	},
	"dtu": {
		"language": 1936
	},
	"dty": {
		"language": 1937
	},
	"dua": {
		"language": 1938
	},
	"dub": {
		"language": 1939
	},
	"duc": {
		"language": 1940
	},
	"dud": {
		"language": 1941
	},
	"due": {
		"language": 1942
	},
	"duf": {
		"language": 1943
	},
	"dug": {
		"language": 1944
	},
	"duh": {
		"language": 1945
	},
	"dui": {
		"language": 1946
	},
	"duj": {
		"language": 1947
	},
	"duk": {
		"language": 1948
	},
	"dul": {
		"language": 1949
	},
	"dum": {
		"language": 1950
	},
	"dun": {
		"language": 1951
	},
	"duo": {
		"language": 1952
	},
	"dup": {
		"language": 1953,
		"extlang": 8193
	},
	"duq": {
		"language": 1954
	},
	"dur": {
		"language": 1955
	},
	"dus": {
		"language": 1956
	},
	"duu": {
		"language": 1957
	},
	"duv": {
		"language": 1958
	},
	"duw": {
		"language": 1959
	},
	"dux": {
		"language": 1960
	},
	"duy": {
		"language": 1961
	},
	"duz": {
		"language": 1962
	},
	"dva": {
		"language": 1963
	},
	"dwa": {
		"language": 1964
	},
	"dwl": {
		"language": 1965
	},
	"dwr": {
		"language": 1966
	},
	"dws": {
		"language": 1967
	},
	"dwu": {
		"language": 1968
	},
	"dww": {
		"language": 1969
	},
	"dwy": {
		"language": 1970
	},
	"dya": {
		"language": 1971
	},
	"dyb": {
		"language": 1972
	},
	"dyd": {
		"language": 1973
	},
	"dyg": {
		"language": 1974
	},
	"dyi": {
		"language": 1975
	},
	"dym": {
		"language": 1976
	},
	"dyn": {
		"language": 1977
	},
	"dyo": {
		"language": 1978
	},
	"dyu": {
		"language": 1979
	},
	"dyy": {
		"language": 1980
	},
	"dza": {
		"language": 1981
	},
	"dzd": {
		"language": 1982
	},
	"dze": {
		"language": 1983
	},
	"dzg": {
		"language": 1984
	},
	"dzl": {
		"language": 1985
	},
	"dzn": {
		"language": 1986
	},
	"eaa": {
		"language": 1987
	},
	"ebg": {
		"language": 1988
	},
	"ebk": {
		"language": 1989
	},
	"ebo": {
		"language": 1990
	},
	"ebr": {
		"language": 1991
	},
	"ebu": {
		"language": 1992
	},
	"ecr": {
		"language": 1993
	},
	"ecs": {
		"language": 1994,
		"extlang": 8194
	},
	"ecy": {
		"language": 1995
	},
	"eee": {
		"language": 1996
	},
	"efa": {
		"language": 1997
	},
	"efe": {
		"language": 1998
	},
	"efi": {
		"language": 1999
	},
	"ega": {
		"language": 2000
	},
	"egl": {
		"language": 2001
	},
	"ego": {
		"language": 2002
	},
	"egx": {
		"language": 2003
	},
	"egy": {
		"language": 2004
	},
	"ehu": {
		"language": 2005
	},
	"eip": {
		"language": 2006
	},
	"eit": {
		"language": 2007
	},
	"eiv": {
		"language": 2008
	},
	"eja": {
		"language": 2009
	},
	"eka": {
		"language": 2010
	},
	"ekc": {
		"language": 2011
	},
	"eke": {
		"language": 2012
	},
	"ekg": {
		"language": 2013
	},
	"eki": {
		"language": 2014
	},
	"ekk": {
		"language": 2015
	},
	"ekl": {
		"language": 2016
	},
	"ekm": {
		"language": 2017
	},
	"eko": {
		"language": 2018
	},
	"ekp": {
		"language": 2019
	},
	"ekr": {
		"language": 2020
	},
	"eky": {
		"language": 2021
	},
	"ele": {
		"language": 2022
	},
	"elh": {
		"language": 2023
	},
	"eli": {
		"language": 2024
	},
	"elk": {
		"language": 2025
	},
	"elm": {
		"language": 2026
	},
	"elo": {
		"language": 2027
	},
	"elp": {
		"language": 2028
	},
	"elu": {
		"language": 2029
	},
	"elx": {
		"language": 2030
	},
	"ema": {
		"language": 2031
	},
	"emb": {
		"language": 2032
	},
	"eme": {
		"language": 2033
	},
	"emg": {
		"language": 2034
	},
	"emi": {
		"language": 2035
	},
	"emk": {
		"language": 2036
	},
	"emm": {
		"language": 2037
	},
	"emn": {
		"language": 2038
	},
	"emo": {
		"language": 2039
	},
	"emp": {
		"language": 2040
	},
	"ems": {
		"language": 2041
	},
	"emu": {
		"language": 2042
	},
	"emw": {
		"language": 2043
	},
	"emx": {
		"language": 2044
	},
	"emy": {
		"language": 2045
	},
	"ena": {
		"language": 2046
	},
	"enb": {
		"language": 2047
	},
	"enc": {
		"language": 2048
	},
	"end": {
		"language": 2049
	},
	"enf": {
		"language": 2050
	},
	"enh": {
		"language": 2051
	},
	"enl": {
		"language": 2052
	},
	"enm": {
		"language": 2053
	},
	"enn": {
		"language": 2054
	},
	"eno": {
		"language": 2055
	},
	"enq": {
		"language": 2056
	},
	"enr": {
		"language": 2057
	},
	"enu": {
		"language": 2058
	},
	"env": {
		"language": 2059
	},
	"enw": {
		"language": 2060
	},
	"enx": {
		"language": 2061
	},
	"eot": {
		"language": 2062
	},
	"epi": {
		"language": 2063
	},
	"era": {
		"language": 2064
	},
	"erg": {
		"language": 2065
	},
	"erh": {
		"language": 2066
	},
	"eri": {
		"language": 2067
	},
	"erk": {
		"language": 2068
	},
	"ero": {
		"language": 2069
	},
	"err": {
		"language": 2070
	},
	"ers": {
		"language": 2071
	},
	"ert": {
		"language": 2072
	},
	"erw": {
		"language": 2073
	},
	"ese": {
		"language": 2074
	},
	"esg": {
		"language": 2075
	},
	"esh": {
		"language": 2076
	},
	"esi": {
		"language": 2077
	},
	"esk": {
		"language": 2078
	},
	"esl": {
		"language": 2079,
		"extlang": 8195
	},
	"esm": {
		"language": 2080
	},
	"esn": {
		"language": 2081,
		"extlang": 8196
	},
	"eso": {
		"language": 2082,
		"extlang": 8197
	},
	"esq": {
		"language": 2083
	},
	"ess": {
		"language": 2084
	},
	"esu": {
		"language": 2085
	},
	"esx": {
		"language": 2086
	},
	"esy": {
		"language": 2087
	},
	"etb": {
		"language": 2088
	},
	"etc": {
		"language": 2089
	},
	"eth": {
		"language": 2090,
		"extlang": 8198
	},
	"etn": {
		"language": 2091
	},
	"eto": {
		"language": 2092
	},
	"etr": {
		"language": 2093
	},
	"ets": {
		"language": 2094
	},
	"ett": {
		"language": 2095
	},
	"etu": {
		"language": 2096
	},
	"etx": {
		"language": 2097
	},
	"etz": {
		"language": 2098
	},
	"euq": {
		"language": 2099
	},
	"eve": {
		"language": 2100
	},
	"evh": {
		"language": 2101
	},
	"evn": {
		"language": 2102
	},
	"ewo": {
		"language": 2103
	},
	"ext": {
		"language": 2104
	},
	"eya": {
		"language": 2105
	},
	"eyo": {
		"language": 2106
	},
	"eza": {
		"language": 2107
	},
	"eze": {
		"language": 2108
	},
	"faa": {
		"language": 2109
	},
	"fab": {
		"language": 2110
	},
	"fad": {
		"language": 2111
	},
	"faf": {
		"language": 2112
	},
	"fag": {
		"language": 2113
	},
	"fah": {
		"language": 2114
	},
	"fai": {
		"language": 2115
	},
	"faj": {
		"language": 2116
	},
	"fak": {
		"language": 2117
	},
	"fal": {
		"language": 2118
	},
	"fam": {
		"language": 2119
	},
	"fan": {
		"language": 2120
	},
	"fap": {
		"language": 2121
	},
	"far": {
		"language": 2122
	},
	"fat": {
		"language": 2123
	},
	"fau": {
		"language": 2124
	},
	"fax": {
		"language": 2125
	},
	"fay": {
		"language": 2126
	},
	"faz": {
		"language": 2127
	},
	"fbl": {
		"language": 2128
	},
	"fcs": {
		"language": 2129,
		"extlang": 8199
	},
	"fer": {
		"language": 2130
	},
	"ffi": {
		"language": 2131
	},
	"ffm": {
		"language": 2132
	},
	"fgr": {
		"language": 2133
	},
	"fia": {
		"language": 2134
	},
	"fie": {
		"language": 2135
	},
	"fil": {
		"language": 2136
	},
	"fip": {
		"language": 2137
	},
	"fir": {
		"language": 2138
	},
	"fit": {
		"language": 2139
	},
	"fiu": {
		"language": 2140
	},
	"fiw": {
		"language": 2141
	},
	"fkk": {
		"language": 2142
	},
	"fkv": {
		"language": 2143
	},
	"fla": {
		"language": 2144
	},
	"flh": {
		"language": 2145
	},
	"fli": {
		"language": 2146
	},
	"fll": {
		"language": 2147
	},
	"fln": {
		"language": 2148
	},
	"flr": {
		"language": 2149
	},
	"fly": {
		"language": 2150
	},
	"fmp": {
		"language": 2151
	},
	"fmu": {
		"language": 2152
	},
	"fnb": {
		"language": 2153
	},
	"fng": {
		"language": 2154
	},
	"fni": {
		"language": 2155
	},
	"fod": {
		"language": 2156
	},
	"foi": {
		"language": 2157
	},
	"fom": {
		"language": 2158
	},
	"fon": {
		"language": 2159
	},
	"for": {
		"language": 2160
	},
	"fos": {
		"language": 2161
	},
	"fox": {
		"language": 2162
	},
	"fpe": {
		"language": 2163
	},
	"fqs": {
		"language": 2164
	},
	"frc": {
		"language": 2165
	},
	"frd": {
		"language": 2166
	},
	"frk": {
		"language": 2167
	},
	"frm": {
		"language": 2168
	},
	"fro": {
		"language": 2169
	},
	"frp": {
		"language": 2170
	},
	"frq": {
		"language": 2171
	},
	"frr": {
		"language": 2172
	},
	"frs": {
		"language": 2173
	},
	"frt": {
		"language": 2174
	},
	"fse": {
		"language": 2175,
		"extlang": 8200
	},
	"fsl": {
		"language": 2176,
		"extlang": 8201
	},
	"fss": {
		"language": 2177,
		"extlang": 8202
	},
	"fub": {
		"language": 2178
	},
	"fuc": {
		"language": 2179
	},
	"fud": {
		"language": 2180
	},
	"fue": {
		"language": 2181
	},
	"fuf": {
		"language": 2182
	},
	"fuh": {
		"language": 2183
	},
	"fui": {
		"language": 2184
	},
	"fuj": {
		"language": 2185
	},
	"fum": {
		"language": 2186
	},
	"fun": {
		"language": 2187
	},
	"fuq": {
		"language": 2188
	},
	"fur": {
		"language": 2189
	},
	"fut": {
		"language": 2190
	},
	"fuu": {
		"language": 2191
	},
	"fuv": {
		"language": 2192
	},
	"fuy": {
		"language": 2193
	},
	"fvr": {
		"language": 2194
	},
	"fwa": {
		"language": 2195
	},
	"fwe": {
		"language": 2196
	},
	"gaa": {
		"language": 2197
	},
	"gab": {
		"language": 2198
	},
	"gac": {
		"language": 2199
	},
	"gad": {
		"language": 2200
	},
	"gae": {
		"language": 2201
	},
	"gaf": {
		"language": 2202
	},
	"gag": {
		"language": 2203
	},
	"gah": {
		"language": 2204
	},
	"gai": {
		"language": 2205
	},
	"gaj": {
		"language": 2206
	},
	"gak": {
		"language": 2207
	},
	"gal": {
		"language": 2208
	},
	"gam": {
		"language": 2209
	},
	"gan": {
		"language": 2210,
		"extlang": 8203
	},
	"gao": {
		"language": 2211
	},
	"gap": {
		"language": 2212
	},
	"gaq": {
		"language": 2213
	},
	"gar": {
		"language": 2214
	},
	"gas": {
		"language": 2215
	},
	"gat": {
		"language": 2216
	},
	"gau": {
		"language": 2217
	},
	"gav": {
		"language": 2218
	},
	"gaw": {
		"language": 2219
	},
	"gax": {
		"language": 2220
	},
	"gay": {
		"language": 2221
	},
	"gaz": {
		"language": 2222
	},
	"gba": {
		"language": 2223
	},
	"gbb": {
		"language": 2224
	},
	"gbc": {
		"language": 2225
	},
	"gbd": {
		"language": 2226
	},
	"gbe": {
		"language": 2227
	},
	"gbf": {
		"language": 2228
	},
	"gbg": {
		"language": 2229
	},
	"gbh": {
		"language": 2230
	},
	"gbi": {
		"language": 2231
	},
	"gbj": {
		"language": 2232
	},
	"gbk": {
		"language": 2233
	},
	"gbl": {
		"language": 2234
	},
	"gbm": {
		"language": 2235
	},
	"gbn": {
		"language": 2236
	},
	"gbo": {
		"language": 2237
	},
	"gbp": {
		"language": 2238
	},
	"gbq": {
		"language": 2239
	},
	"gbr": {
		"language": 2240
	},
	"gbs": {
		"language": 2241
	},
	"gbu": {
		"language": 2242
	},
	"gbv": {
		"language": 2243
	},
	"gbw": {
		"language": 2244
	},
	"gbx": {
		"language": 2245
	},
	"gby": {
		"language": 2246
	},
	"gbz": {
		"language": 2247
	},
	"gcc": {
		"language": 2248
	},
	"gcd": {
		"language": 2249
	},
	"gce": {
		"language": 2250
	},
	"gcf": {
		"language": 2251
	},
	"gcl": {
		"language": 2252
	},
	"gcn": {
		"language": 2253
	},
	"gcr": {
		"language": 2254
	},
	"gct": {
		"language": 2255
	},
	"gda": {
		"language": 2256
	},
	"gdb": {
		"language": 2257
	},
	"gdc": {
		"language": 2258
	},
	"gdd": {
		"language": 2259
	},
	"gde": {
		"language": 2260
	},
	"gdf": {
		"language": 2261
	},
	"gdg": {
		"language": 2262
	},
	"gdh": {
		"language": 2263
	},
	"gdi": {
		"language": 2264
	},
	"gdj": {
		"language": 2265
	},
	"gdk": {
		"language": 2266
	},
	"gdl": {
		"language": 2267
	},
	"gdm": {
		"language": 2268
	},
	"gdn": {
		"language": 2269
	},
	"gdo": {
		"language": 2270
	},
	"gdq": {
		"language": 2271
	},
	"gdr": {
		"language": 2272
	},
	"gds": {
		"language": 2273,
		"extlang": 8204
	},
	"gdt": {
		"language": 2274
	},
	"gdu": {
		"language": 2275
	},
	"gdx": {
		"language": 2276
	},
	"gea": {
		"language": 2277
	},
	"geb": {
		"language": 2278
	},
	"gec": {
		"language": 2279
	},
	"ged": {
		"language": 2280
	},
	"geg": {
		"language": 2281
	},
	"geh": {
		"language": 2282
	},
	"gei": {
		"language": 2283
	},
	"gej": {
		"language": 2284
	},
	"gek": {
		"language": 2285
	},
	"gel": {
		"language": 2286
	},
	"gem": {
		"language": 2287
	},
	"geq": {
		"language": 2288
	},
	"ges": {
		"language": 2289
	},
	"gev": {
		"language": 2290
	},
	"gew": {
		"language": 2291
	},
	"gex": {
		"language": 2292
	},
	"gey": {
		"language": 2293
	},
	"gez": {
		"language": 2294
	},
	"gfk": {
		"language": 2295
	},
	"gft": {
		"language": 2296
	},
	"gfx": {
		"language": 2297
	},
	"gga": {
		"language": 2298
	},
	"ggb": {
		"language": 2299
	},
	"ggd": {
		"language": 2300
	},
	"gge": {
		"language": 2301
	},
	"ggg": {
		"language": 2302
	},
	"ggk": {
		"language": 2303
	},
	"ggl": {
		"language": 2304
	},
	"ggn": {
		"language": 2305
	},
	"ggo": {
		"language": 2306
	},
	"ggr": {
		"language": 2307
	},
	"ggt": {
		"language": 2308
	},
	"ggu": {
		"language": 2309
	},
	"ggw": {
		"language": 2310
	},
	"gha": {
		"language": 2311
	},
	"ghc": {
		"language": 2312
	},
	"ghe": {
		"language": 2313
	},
	"ghh": {
		"language": 2314
	},
	"ghk": {
		"language": 2315
	},
	"ghl": {
		"language": 2316
	},
	"ghn": {
		"language": 2317
	},
	"gho": {
		"language": 2318
	},
	"ghr": {
		"language": 2319
	},
	"ghs": {
		"language": 2320
	},
	"ght": {
		"language": 2321
	},
	"gia": {
		"language": 2322
	},
	"gib": {
		"language": 2323
	},
	"gic": {
		"language": 2324
	},
	"gid": {
		"language": 2325
	},
	"gie": {
		"language": 2326
	},
	"gig": {
		"language": 2327
	},
	"gih": {
		"language": 2328
	},
	"gil": {
		"language": 2329
	},
	"gim": {
		"language": 2330
	},
	"gin": {
		"language": 2331
	},
	"gio": {
		"language": 2332
	},
	"gip": {
		"language": 2333
	},
	"giq": {
		"language": 2334
	},
	"gir": {
		"language": 2335
	},
	"gis": {
		"language": 2336
	},
	"git": {
		"language": 2337
	},
	"giu": {
		"language": 2338
	},
	"giw": {
		"language": 2339
	},
	"gix": {
		"language": 2340
	},
	"giy": {
		"language": 2341
	},
	"giz": {
		"language": 2342
	},
	"gji": {
		"language": 2343
	},
	"gjk": {
		"language": 2344
	},
	"gjm": {
		"language": 2345
	},
	"gjn": {
		"language": 2346
	},
	"gjr": {
		"language": 2347
	},
	"gju": {
		"language": 2348
	},
	"gka": {
		"language": 2349
	},
	"gke": {
		"language": 2350
	},
	"gkn": {
		"language": 2351
	},
	"gko": {
		"language": 2352
	},
	"gkp": {
		"language": 2353
	},
	"gku": {
		"language": 2354
	},
	"glc": {
		"language": 2355
	},
	"gld": {
		"language": 2356
	},
	"glh": {
		"language": 2357
	},
	"gli": {
		"language": 2358
	},
	"glj": {
		"language": 2359
	},
	"glk": {
		"language": 2360
	},
	"gll": {
		"language": 2361
	},
	"glo": {
		"language": 2362
	},
	"glr": {
		"language": 2363
	},
	"glu": {
		"language": 2364
	},
	"glw": {
		"language": 2365
	},
	"gly": {
		"language": 2366
	},
	"gma": {
		"language": 2367
	},
	"gmb": {
		"language": 2368
	},
	"gmd": {
		"language": 2369
	},
	"gme": {
		"language": 2370
	},
	"gmg": {
		"language": 2371
	},
	"gmh": {
		"language": 2372
	},
	"gml": {
		"language": 2373
	},
	"gmm": {
		"language": 2374
	},
	"gmn": {
		"language": 2375
	},
	"gmq": {
		"language": 2376
	},
	"gmu": {
		"language": 2377
	},
	"gmv": {
		"language": 2378
	},
	"gmw": {
		"language": 2379
	},
	"gmx": {
		"language": 2380
	},
	"gmy": {
		"language": 2381
	},
	"gmz": {
		"language": 2382
	},
	"gna": {
		"language": 2383
	},
	"gnb": {
		"language": 2384
	},
	"gnc": {
		"language": 2385
	},
	"gnd": {
		"language": 2386
	},
	"gne": {
		"language": 2387
	},
	"gng": {
		"language": 2388
	},
	"gnh": {
		"language": 2389
	},
	"gni": {
		"language": 2390
	},
	"gnk": {
		"language": 2391
	},
	"gnl": {
		"language": 2392
	},
	"gnm": {
		"language": 2393
	},
	"gnn": {
		"language": 2394
	},
	"gno": {
		"language": 2395
	},
	"gnq": {
		"language": 2396
	},
	"gnr": {
		"language": 2397
	},
	"gnt": {
		"language": 2398
	},
	"gnu": {
		"language": 2399
	},
	"gnw": {
		"language": 2400
	},
	"gnz": {
		"language": 2401
	},
	"goa": {
		"language": 2402
	},
	"gob": {
		"language": 2403
	},
	"goc": {
		"language": 2404
	},
	"god": {
		"language": 2405
	},
	"goe": {
		"language": 2406
	},
	"gof": {
		"language": 2407
	},
	"gog": {
		"language": 2408
	},
	"goh": {
		"language": 2409
	},
	"goi": {
		"language": 2410
	},
	"goj": {
		"language": 2411
	},
	"gok": {
		"language": 2412
	},
	"gol": {
		"language": 2413
	},
	"gom": {
		"language": 2414,
		"extlang": 8205
	},
	"gon": {
		"language": 2415
	},
	"goo": {
		"language": 2416
	},
	"gop": {
		"language": 2417
	},
	"goq": {
		"language": 2418
	},
	"gor": {
		"language": 2419
	},
	"gos": {
		"language": 2420
	},
	"got": {
		"language": 2421
	},
	"gou": {
		"language": 2422
	},
	"gow": {
		"language": 2423
	},
	"gox": {
		"language": 2424
	},
	"goy": {
		"language": 2425
	},
	"goz": {
		"language": 2426
	},
	"gpa": {
		"language": 2427
	},
	"gpe": {
		"language": 2428
	},
	"gpn": {
		"language": 2429
	},
	"gqa": {
		"language": 2430
	},
	"gqi": {
		"language": 2431
	},
	"gqn": {
		"language": 2432
	},
	"gqr": {
		"language": 2433
	},
	"gqu": {
		"language": 2434
	},
	"gra": {
		"language": 2435
	},
	"grb": {
		"language": 2436
	},
	"grc": {
		"language": 2437
	},
	"grd": {
		"language": 2438
	},
	"grg": {
		"language": 2439
	},
	"grh": {
		"language": 2440
	},
	"gri": {
		"language": 2441
	},
	"grj": {
		"language": 2442
	},
	"grk": {
		"language": 2443
	},
	"grm": {
		"language": 2444
	},
	"gro": {
		"language": 2445
	},
	"grq": {
		"language": 2446
	},
	"grr": {
		"language": 2447
	},
	"grs": {
		"language": 2448
	},
	"grt": {
		"language": 2449
	},
	"gru": {
		"language": 2450
	},
	"grv": {
		"language": 2451
	},
	"grw": {
		"language": 2452
	},
	"grx": {
		"language": 2453
	},
	"gry": {
		"language": 2454
	},
	"grz": {
		"language": 2455
	},
	"gse": {
		"language": 2456,
		"extlang": 8206
	},
	"gsg": {
		"language": 2457,
		"extlang": 8207
	},
	"gsl": {
		"language": 2458
	},
	"gsm": {
		"language": 2459,
		"extlang": 8208
	},
	"gsn": {
		"language": 2460
	},
	"gso": {
		"language": 2461
	},
	"gsp": {
		"language": 2462
	},
	"gss": {
		"language": 2463,
		"extlang": 8209
	},
	"gsw": {
		"language": 2464
	},
	"gta": {
		"language": 2465
	},
	"gti": {
		"language": 2466
	},
	"gtu": {
		"language": 2467
	},
	"gua": {
		"language": 2468
	},
	"gub": {
		"language": 2469
	},
	"guc": {
		"language": 2470
	},
	"gud": {
		"language": 2471
	},
	"gue": {
		"language": 2472
	},
	"guf": {
		"language": 2473
	},
	"gug": {
		"language": 2474
	},
	"guh": {
		"language": 2475
	},
	"gui": {
		"language": 2476
	},
	"guk": {
		"language": 2477
	},
	"gul": {
		"language": 2478
	},
	"gum": {
		"language": 2479
	},
	"gun": {
		"language": 2480
	},
	"guo": {
		"language": 2481
	},
	"gup": {
		"language": 2482
	},
	"guq": {
		"language": 2483
	},
	"gur": {
		"language": 2484
	},
	"gus": {
		"language": 2485,
		"extlang": 8210
	},
	"gut": {
		"language": 2486
	},
	"guu": {
		"language": 2487
	},
	"guv": {
		"language": 2488
	},
	"guw": {
		"language": 2489
	},
	"gux": {
		"language": 2490
	},
	"guz": {
		"language": 2491
	},
	"gva": {
		"language": 2492
	},
	"gvc": {
		"language": 2493
	},
	"gve": {
		"language": 2494
	},
	"gvf": {
		"language": 2495
	},
	"gvj": {
		"language": 2496
	},
	"gvl": {
		"language": 2497
	},
	"gvm": {
		"language": 2498
	},
	"gvn": {
		"language": 2499
	},
	"gvo": {
		"language": 2500
	},
	"gvp": {
		"language": 2501
	},
	"gvr": {
		"language": 2502
	},
	"gvs": {
		"language": 2503
	},
	"gvy": {
		"language": 2504
	},
	"gwa": {
		"language": 2505
	},
	"gwb": {
		"language": 2506
	},
	"gwc": {
		"language": 2507
	},
	"gwd": {
		"language": 2508
	},
	"gwe": {
		"language": 2509
	},
	"gwf": {
		"language": 2510
	},
	"gwg": {
		"language": 2511
	},
	"gwi": {
		"language": 2512
	},
	"gwj": {
		"language": 2513
	},
	"gwm": {
		"language": 2514
	},
	"gwn": {
		"language": 2515
	},
	"gwr": {
		"language": 2516
	},
	"gwt": {
		"language": 2517
	},
	"gwu": {
		"language": 2518
	},
	"gww": {
		"language": 2519
	},
	"gwx": {
		"language": 2520
	},
	"gxx": {
		"language": 2521
	},
	"gya": {
		"language": 2522
	},
	"gyb": {
		"language": 2523
	},
	"gyd": {
		"language": 2524
	},
	"gye": {
		"language": 2525
	},
	"gyf": {
		"language": 2526
	},
	"gyg": {
		"language": 2527
	},
	"gyi": {
		"language": 2528
	},
	"gyl": {
		"language": 2529
	},
	"gym": {
		"language": 2530
	},
	"gyn": {
		"language": 2531
	},
	"gyr": {
		"language": 2532
	},
	"gyy": {
		"language": 2533
	},
	"gza": {
		"language": 2534
	},
	"gzi": {
		"language": 2535
	},
	"gzn": {
		"language": 2536
	},
	"haa": {
		"language": 2537
	},
	"hab": {
		"language": 2538,
		"extlang": 8211
	},
	"hac": {
		"language": 2539
	},
	"had": {
		"language": 2540
	},
	"hae": {
		"language": 2541
	},
	"haf": {
		"language": 2542,
		"extlang": 8212
	},
	"hag": {
		"language": 2543
	},
	"hah": {
		"language": 2544
	},
	"hai": {
		"language": 2545
	},
	"haj": {
		"language": 2546
	},
	"hak": {
		"language": 2547,
		"extlang": 8213
	},
	"hal": {
		"language": 2548
	},
	"ham": {
		"language": 2549
	},
	"han": {
		"language": 2550
	},
	"hao": {
		"language": 2551
	},
	"hap": {
		"language": 2552
	},
	"haq": {
		"language": 2553
	},
	"har": {
		"language": 2554
	},
	"has": {
		"language": 2555
	},
	"hav": {
		"language": 2556
	},
	"haw": {
		"language": 2557
	},
	"hax": {
		"language": 2558
	},
	"hay": {
		"language": 2559
	},
	"haz": {
		"language": 2560
	},
	"hba": {
		"language": 2561
	},
	"hbb": {
		"language": 2562
	},
	"hbn": {
		"language": 2563
	},
	"hbo": {
		"language": 2564
	},
	"hbu": {
		"language": 2565
	},
	"hca": {
		"language": 2566
	},
	"hch": {
		"language": 2567
	},
	"hdn": {
		"language": 2568
	},
	"hds": {
		"language": 2569,
		"extlang": 8214
	},
	"hdy": {
		"language": 2570
	},
	"hea": {
		"language": 2571
	},
	"hed": {
		"language": 2572
	},
	"heg": {
		"language": 2573
	},
	"heh": {
		"language": 2574
	},
	"hei": {
		"language": 2575
	},
	"hem": {
		"language": 2576
	},
	"hgm": {
		"language": 2577
	},
	"hgw": {
		"language": 2578
	},
	"hhi": {
		"language": 2579
	},
	"hhr": {
		"language": 2580
	},
	"hhy": {
		"language": 2581
	},
	"hia": {
		"language": 2582
	},
	"hib": {
		"language": 2583
	},
	"hid": {
		"language": 2584
	},
	"hif": {
		"language": 2585
	},
	"hig": {
		"language": 2586
	},
	"hih": {
		"language": 2587
	},
	"hii": {
		"language": 2588
	},
	"hij": {
		"language": 2589
	},
	"hik": {
		"language": 2590
	},
	"hil": {
		"language": 2591
	},
	"him": {
		"language": 2592
	},
	"hio": {
		"language": 2593
	},
	"hir": {
		"language": 2594
	},
	"hit": {
		"language": 2595
	},
	"hiw": {
		"language": 2596
	},
	"hix": {
		"language": 2597
	},
	"hji": {
		"language": 2598,
		"extlang": 8215
	},
	"hka": {
		"language": 2599
	},
	"hke": {
		"language": 2600
	},
	"hkk": {
		"language": 2601
	},
	"hks": {
		"language": 2602,
		"extlang": 8216
	},
	"hla": {
		"language": 2603
	},
	"hlb": {
		"language": 2604
	},
	"hld": {
		"language": 2605
	},
	"hle": {
		"language": 2606
	},
	"hlt": {
		"language": 2607
	},
	"hlu": {
		"language": 2608
	},
	"hma": {
		"language": 2609
	},
	"hmb": {
		"language": 2610
	},
	"hmc": {
		"language": 2611
	},
	"hmd": {
		"language": 2612
	},
	"hme": {
		"language": 2613
	},
	"hmf": {
		"language": 2614
	},
	"hmg": {
		"language": 2615
	},
	"hmh": {
		"language": 2616
	},
	"hmi": {
		"language": 2617
	},
	"hmj": {
		"language": 2618
	},
	"hmk": {
		"language": 2619
	},
	"hml": {
		"language": 2620
	},
	"hmm": {
		"language": 2621
	},
	"hmn": {
		"language": 2622
	},
	"hmp": {
		"language": 2623
	},
	"hmq": {
		"language": 2624
	},
	"hmr": {
		"language": 2625
	},
	"hms": {
		"language": 2626
	},
	"hmt": {
		"language": 2627
	},
	"hmu": {
		"language": 2628
	},
	"hmv": {
		"language": 2629
	},
	"hmw": {
		"language": 2630
	},
	"hmx": {
		"language": 2631
	},
	"hmy": {
		"language": 2632
	},
	"hmz": {
		"language": 2633
	},
	"hna": {
		"language": 2634
	},
	"hnd": {
		"language": 2635
	},
	"hne": {
		"language": 2636
	},
	"hnh": {
		"language": 2637
	},
	"hni": {
		"language": 2638
	},
	"hnj": {
		"language": 2639
	},
	"hnn": {
		"language": 2640
	},
	"hno": {
		"language": 2641
	},
	"hns": {
		"language": 2642
	},
	"hnu": {
		"language": 2643
	},
	"hoa": {
		"language": 2644
	},
	"hob": {
		"language": 2645
	},
	"hoc": {
		"language": 2646
	},
	"hod": {
		"language": 2647
	},
	"hoe": {
		"language": 2648
	},
	"hoh": {
		"language": 2649
	},
	"hoi": {
		"language": 2650
	},
	"hoj": {
		"language": 2651
	},
	"hok": {
		"language": 2652
	},
	"hol": {
		"language": 2653
	},
	"hom": {
		"language": 2654
	},
	"hoo": {
		"language": 2655
	},
	"hop": {
		"language": 2656
	},
	"hor": {
		"language": 2657
	},
	"hos": {
		"language": 2658,
		"extlang": 8217
	},
	"hot": {
		"language": 2659
	},
	"hov": {
		"language": 2660
	},
	"how": {
		"language": 2661
	},
	"hoy": {
		"language": 2662
	},
	"hoz": {
		"language": 2663
	},
	"hpo": {
		"language": 2664
	},
	"hps": {
		"language": 2665,
		"extlang": 8218
	},
	"hra": {
		"language": 2666
	},
	"hrc": {
		"language": 2667
	},
	"hre": {
		"language": 2668
	},
	"hrk": {
		"language": 2669
	},
	"hrm": {
		"language": 2670
	},
	"hro": {
		"language": 2671
	},
	"hrp": {
		"language": 2672
	},
	"hrr": {
		"language": 2673
	},
	"hrt": {
		"language": 2674
	},
	"hru": {
		"language": 2675
	},
	"hrw": {
		"language": 2676
	},
	"hrx": {
		"language": 2677
	},
	"hrz": {
		"language": 2678
	},
	"hsb": {
		"language": 2679
	},
	"hsh": {
		"language": 2680,
		"extlang": 8219
	},
	"hsl": {
		"language": 2681,
		"extlang": 8220
	},
	"hsn": {
		"language": 2682,
		"extlang": 8221
	},
	"hss": {
		"language": 2683
	},
	"hti": {
		"language": 2684
	},
	"hto": {
		"language": 2685
	},
	"hts": {
		"language": 2686
	},
	"htu": {
		"language": 2687
	},
	"htx": {
		"language": 2688
	},
	"hub": {
		"language": 2689
	},
	"huc": {
		"language": 2690
	},
	"hud": {
		"language": 2691
	},
	"hue": {
		"language": 2692
	},
	"huf": {
		"language": 2693
	},
	"hug": {
		"language": 2694
	},
	"huh": {
		"language": 2695
	},
	"hui": {
		"language": 2696
	},
	"huj": {
		"language": 2697
	},
	"huk": {
		"language": 2698
	},
	"hul": {
		"language": 2699
	},
	"hum": {
		"language": 2700
	},
	"huo": {
		"language": 2701
	},
	"hup": {
		"language": 2702
	},
	"huq": {
		"language": 2703
	},
	"hur": {
		"language": 2704
	},
	"hus": {
		"language": 2705
	},
	"hut": {
		"language": 2706
	},
	"huu": {
		"language": 2707
	},
	"huv": {
		"language": 2708
	},
	"huw": {
		"language": 2709
	},
	"hux": {
		"language": 2710
	},
	"huy": {
		"language": 2711
	},
	"huz": {
		"language": 2712
	},
	"hvc": {
		"language": 2713
	},
	"hve": {
		"language": 2714
	},
	"hvk": {
		"language": 2715
	},
	"hvn": {
		"language": 2716
	},
	"hvv": {
		"language": 2717
	},
	"hwa": {
		"language": 2718
	},
	"hwc": {
		"language": 2719
	},
	"hwo": {
		"language": 2720
	},
	"hya": {
		"language": 2721
	},
	"hyx": {
		"language": 2722
	},
	"iai": {
		"language": 2723
	},
	"ian": {
		"language": 2724
	},
	"iap": {
		"language": 2725
	},
	"iar": {
		"language": 2726
	},
	"iba": {
		"language": 2727
	},
	"ibb": {
		"language": 2728
	},
	"ibd": {
		"language": 2729
	},
	"ibe": {
		"language": 2730
	},
	"ibg": {
		"language": 2731
	},
	"ibh": {
		"language": 2732
	},
	"ibi": {
		"language": 2733
	},
	"ibl": {
		"language": 2734
	},
	"ibm": {
		"language": 2735
	},
	"ibn": {
		"language": 2736
	},
	"ibr": {
		"language": 2737
	},
	"ibu": {
		"language": 2738
	},
	"iby": {
		"language": 2739
	},
	"ica": {
		"language": 2740
	},
	"ich": {
		"language": 2741
	},
	"icl": {
		"language": 2742,
		"extlang": 8222
	},
	"icr": {
		"language": 2743
	},
	"ida": {
		"language": 2744
	},
	"idb": {
		"language": 2745
	},
	"idc": {
		"language": 2746
	},
	"idd": {
		"language": 2747
	},
	"ide": {
		"language": 2748
	},
	"idi": {
		"language": 2749
	},
	"idr": {
		"language": 2750
	},
	"ids": {
		"language": 2751
	},
	"idt": {
		"language": 2752
	},
	"idu": {
		"language": 2753
	},
	"ifa": {
		"language": 2754
	},
	"ifb": {
		"language": 2755
	},
	"ife": {
		"language": 2756
	},
	"iff": {
		"language": 2757
	},
	"ifk": {
		"language": 2758
	},
	"ifm": {
		"language": 2759
	},
	"ifu": {
		"language": 2760
	},
	"ify": {
		"language": 2761
	},
	"igb": {
		"language": 2762
	},
	"ige": {
		"language": 2763
	},
	"igg": {
		"language": 2764
	},
	"igl": {
		"language": 2765
	},
	"igm": {
		"language": 2766
	},
	"ign": {
		"language": 2767
	},
	"igo": {
		"language": 2768
	},
	"igs": {
		"language": 2769
	},
	"igw": {
		"language": 2770
	},
	"ihb": {
		"language": 2771
	},
	"ihi": {
		"language": 2772
	},
	"ihp": {
		"language": 2773
	},
	"ihw": {
		"language": 2774
	},
	"iin": {
		"language": 2775
	},
	"iir": {
		"language": 2776
	},
	"ijc": {
		"language": 2777
	},
	"ije": {
		"language": 2778
	},
	"ijj": {
		"language": 2779
	},
	"ijn": {
		"language": 2780
	},
	"ijo": {
		"language": 2781
	},
	"ijs": {
		"language": 2782
	},
	"ike": {
		"language": 2783
	},
	"iki": {
		"language": 2784
	},
	"ikk": {
		"language": 2785
	},
	"ikl": {
		"language": 2786
	},
	"iko": {
		"language": 2787
	},
	"ikp": {
		"language": 2788
	},
	"ikr": {
		"language": 2789
	},
	"iks": {
		"language": 2790,
		"extlang": 8223
	},
	"ikt": {
		"language": 2791
	},
	"ikv": {
		"language": 2792
	},
	"ikw": {
		"language": 2793
	},
	"ikx": {
		"language": 2794
	},
	"ikz": {
		"language": 2795
	},
	"ila": {
		"language": 2796
	},
	"ilb": {
		"language": 2797
	},
	"ilg": {
		"language": 2798
	},
	"ili": {
		"language": 2799
	},
	"ilk": {
		"language": 2800
	},
	"ill": {
		"language": 2801
	},
	"ilm": {
		"language": 2802
	},
	"ilo": {
		"language": 2803
	},
	"ilp": {
		"language": 2804
	},
	"ils": {
		"language": 2805,
		"extlang": 8224
	},
	"ilu": {
		"language": 2806
	},
	"ilv": {
		"language": 2807
	},
	"ilw": {
		"language": 2808
	},
	"ima": {
		"language": 2809
	},
	"ime": {
		"language": 2810
	},
	"imi": {
		"language": 2811
	},
	"iml": {
		"language": 2812
	},
	"imn": {
		"language": 2813
	},
	"imo": {
		"language": 2814
	},
	"imr": {
		"language": 2815
	},
	"ims": {
		"language": 2816
	},
	"imy": {
		"language": 2817
	},
	"inb": {
		"language": 2818
	},
	"inc": {
		"language": 2819
	},
	"ine": {
		"language": 2820
	},
	"ing": {
		"language": 2821
	},
	"inh": {
		"language": 2822
	},
	"inj": {
		"language": 2823
	},
	"inl": {
		"language": 2824,
		"extlang": 8225
	},
	"inm": {
		"language": 2825
	},
	"inn": {
		"language": 2826
	},
	"ino": {
		"language": 2827
	},
	"inp": {
		"language": 2828
	},
	"ins": {
		"language": 2829,
		"extlang": 8226
	},
	"int": {
		"language": 2830
	},
	"inz": {
		"language": 2831
	},
	"ior": {
		"language": 2832
	},
	"iou": {
		"language": 2833
	},
	"iow": {
		"language": 2834
	},
	"ipi": {
		"language": 2835
	},
	"ipo": {
		"language": 2836
	},
	"iqu": {
		"language": 2837
	},
	"iqw": {
		"language": 2838
	},
	"ira": {
		"language": 2839
	},
	"ire": {
		"language": 2840
	},
	"irh": {
		"language": 2841
	},
	"iri": {
		"language": 2842
	},
	"irk": {
		"language": 2843
	},
	"irn": {
		"language": 2844
	},
	"iro": {
		"language": 2845
	},
	"irr": {
		"language": 2846
	},
	"iru": {
		"language": 2847
	},
	"irx": {
		"language": 2848
	},
	"iry": {
		"language": 2849
	},
	"isa": {
		"language": 2850
	},
	"isc": {
		"language": 2851
	},
	"isd": {
		"language": 2852
	},
	"ise": {
		"language": 2853,
		"extlang": 8227
	},
	"isg": {
		"language": 2854,
		"extlang": 8228
	},
	"ish": {
		"language": 2855
	},
	"isi": {
		"language": 2856
	},
	"isk": {
		"language": 2857
	},
	"ism": {
		"language": 2858
	},
	"isn": {
		"language": 2859
	},
	"iso": {
		"language": 2860
	},
	"isr": {
		"language": 2861,
		"extlang": 8229
	},
	"ist": {
		"language": 2862
	},
	"isu": {
		"language": 2863
	},
	"itb": {
		"language": 2864
	},
	"itc": {
		"language": 2865
	},
	"itd": {
		"language": 2866
	},
	"ite": {
		"language": 2867
	},
	"iti": {
		"language": 2868
	},
	"itk": {
		"language": 2869
	},
	"itl": {
		"language": 2870
	},
	"itm": {
		"language": 2871
	},
	"ito": {
		"language": 2872
	},
	"itr": {
		"language": 2873
	},
	"its": {
		"language": 2874
	},
	"itt": {
		"language": 2875
	},
	"itv": {
		"language": 2876
	},
	"itw": {
		"language": 2877
	},
	"itx": {
		"language": 2878
	},
	"ity": {
		"language": 2879
	},
	"itz": {
		"language": 2880
	},
	"ium": {
		"language": 2881
	},
	"ivb": {
		"language": 2882
	},
	"ivv": {
		"language": 2883
	},
	"iwk": {
		"language": 2884
	},
	"iwm": {
		"language": 2885
	},
	"iwo": {
		"language": 2886
	},
	"iws": {
		"language": 2887
	},
	"ixc": {
		"language": 2888
	},
	"ixl": {
		"language": 2889
	},
	"iya": {
		"language": 2890
	},
	"iyo": {
		"language": 2891
	},
	"iyx": {
		"language": 2892
	},
	"izh": {
		"language": 2893
	},
	"izi": {
		"language": 2894
	},
	"izr": {
		"language": 2895
	},
	"izz": {
		"language": 2896
	},
	"jaa": {
		"language": 2897
	},
	"jab": {
		"language": 2898
	},
	"jac": {
		"language": 2899
	},
	"jad": {
		"language": 2900
	},
	"jae": {
		"language": 2901
	},
	"jaf": {
		"language": 2902
	},
	"jah": {
		"language": 2903
	},
	"jaj": {
		"language": 2904
	},
	"jak": {
		"language": 2905,
		"extlang": 8230
	},
	"jal": {
		"language": 2906
	},
	"jam": {
		"language": 2907
	},
	"jan": {
		"language": 2908
	},
	"jao": {
		"language": 2909
	},
	"jaq": {
		"language": 2910
	},
	"jar": {
		"language": 2911
	},
	"jas": {
		"language": 2912
	},
	"jat": {
		"language": 2913
	},
	"jau": {
		"language": 2914
	},
	"jax": {
		"language": 2915,
		"extlang": 8231
	},
	"jay": {
		"language": 2916
	},
	"jaz": {
		"language": 2917
	},
	"jbe": {
		"language": 2918
	},
	"jbi": {
		"language": 2919
	},
	"jbj": {
		"language": 2920
	},
	"jbk": {
		"language": 2921
	},
	"jbn": {
		"language": 2922
	},
	"jbo": {
		"language": 2923
	},
	"jbr": {
		"language": 2924
	},
	"jbt": {
		"language": 2925
	},
	"jbu": {
		"language": 2926
	},
	"jbw": {
		"language": 2927
	},
	"jcs": {
		"language": 2928,
		"extlang": 8232
	},
	"jct": {
		"language": 2929
	},
	"jda": {
		"language": 2930
	},
	"jdg": {
		"language": 2931
	},
	"jdt": {
		"language": 2932
	},
	"jeb": {
		"language": 2933
	},
	"jee": {
		"language": 2934
	},
	"jeg": {
		"language": 2935
	},
	"jeh": {
		"language": 2936
	},
	"jei": {
		"language": 2937
	},
	"jek": {
		"language": 2938
	},
	"jel": {
		"language": 2939
	},
	"jen": {
		"language": 2940
	},
	"jer": {
		"language": 2941
	},
	"jet": {
		"language": 2942
	},
	"jeu": {
		"language": 2943
	},
	"jgb": {
		"language": 2944
	},
	"jge": {
		"language": 2945
	},
	"jgk": {
		"language": 2946
	},
	"jgo": {
		"language": 2947
	},
	"jhi": {
		"language": 2948
	},
	"jhs": {
		"language": 2949,
		"extlang": 8233
	},
	"jia": {
		"language": 2950
	},
	"jib": {
		"language": 2951
	},
	"jic": {
		"language": 2952
	},
	"jid": {
		"language": 2953
	},
	"jie": {
		"language": 2954
	},
	"jig": {
		"language": 2955
	},
	"jih": {
		"language": 2956
	},
	"jii": {
		"language": 2957
	},
	"jil": {
		"language": 2958
	},
	"jim": {
		"language": 2959
	},
	"jio": {
		"language": 2960
	},
	"jiq": {
		"language": 2961
	},
	"jit": {
		"language": 2962
	},
	"jiu": {
		"language": 2963
	},
	"jiv": {
		"language": 2964
	},
	"jiy": {
		"language": 2965
	},
	"jje": {
		"language": 2966
	},
	"jjr": {
		"language": 2967
	},
	"jka": {
		"language": 2968
	},
	"jkm": {
		"language": 2969
	},
	"jko": {
		"language": 2970
	},
	"jkp": {
		"language": 2971
	},
	"jkr": {
		"language": 2972
	},
	"jku": {
		"language": 2973
	},
	"jle": {
		"language": 2974
	},
	"jls": {
		"language": 2975,
		"extlang": 8234
	},
	"jma": {
		"language": 2976
	},
	"jmb": {
		"language": 2977
	},
	"jmc": {
		"language": 2978
	},
	"jmd": {
		"language": 2979
	},
	"jmi": {
		"language": 2980
	},
	"jml": {
		"language": 2981
	},
	"jmn": {
		"language": 2982
	},
	"jmr": {
		"language": 2983
	},
	"jms": {
		"language": 2984
	},
	"jmw": {
		"language": 2985
	},
	"jmx": {
		"language": 2986
	},
	"jna": {
		"language": 2987
	},
	"jnd": {
		"language": 2988
	},
	"jng": {
		"language": 2989
	},
	"jni": {
		"language": 2990
	},
	"jnj": {
		"language": 2991
	},
	"jnl": {
		"language": 2992
	},
	"jns": {
		"language": 2993
	},
	"job": {
		"language": 2994
	},
	"jod": {
		"language": 2995
	},
	"jog": {
		"language": 2996
	},
	"jor": {
		"language": 2997
	},
	"jos": {
		"language": 2998,
		"extlang": 8235
	},
	"jow": {
		"language": 2999
	},
	"jpa": {
		"language": 3000
	},
	"jpr": {
		"language": 3001
	},
	"jpx": {
		"language": 3002
	},
	"jqr": {
		"language": 3003
	},
	"jra": {
		"language": 3004
	},
	"jrb": {
		"language": 3005
	},
	"jrr": {
		"language": 3006
	},
	"jrt": {
		"language": 3007
	},
	"jru": {
		"language": 3008
	},
	"jsl": {
		"language": 3009,
		"extlang": 8236
	},
	"jua": {
		"language": 3010
	},
	"jub": {
		"language": 3011
	},
	"juc": {
		"language": 3012
	},
	"jud": {
		"language": 3013
	},
	"juh": {
		"language": 3014
	},
	"jui": {
		"language": 3015
	},
	"juk": {
		"language": 3016
	},
	"jul": {
		"language": 3017
	},
	"jum": {
		"language": 3018
	},
	"jun": {
		"language": 3019
	},
	"juo": {
		"language": 3020
	},
	"jup": {
		"language": 3021
	},
	"jur": {
		"language": 3022
	},
	"jus": {
		"language": 3023,
		"extlang": 8237
	},
	"jut": {
		"language": 3024
	},
	"juu": {
		"language": 3025
	},
	"juw": {
		"language": 3026
	},
	"juy": {
		"language": 3027
	},
	"jvd": {
		"language": 3028
	},
	"jvn": {
		"language": 3029
	},
	"jwi": {
		"language": 3030
	},
	"jya": {
		"language": 3031
	},
	"jye": {
		"language": 3032
	},
	"jyy": {
		"language": 3033
	},
	"kaa": {
		"language": 3034
	},
	"kab": {
		"language": 3035
	},
	"kac": {
		"language": 3036
	},
	"kad": {
		"language": 3037
	},
	"kae": {
		"language": 3038
	},
	"kaf": {
		"language": 3039
	},
	"kag": {
		"language": 3040
	},
	"kah": {
		"language": 3041
	},
	"kai": {
		"language": 3042
	},
	"kaj": {
		"language": 3043
	},
	"kak": {
		"language": 3044
	},
	"kam": {
		"language": 3045
	},
	"kao": {
		"language": 3046
	},
	"kap": {
		"language": 3047
	},
	"kaq": {
		"language": 3048
	},
	"kar": {
		"language": 3049
	},
	"kav": {
		"language": 3050
	},
	"kaw": {
		"language": 3051
	},
	"kax": {
		"language": 3052
	},
	"kay": {
		"language": 3053
	},
	"kba": {
		"language": 3054
	},
	"kbb": {
		"language": 3055
	},
	"kbc": {
		"language": 3056
	},
	"kbd": {
		"language": 3057
	},
	"kbe": {
		"language": 3058
	},
	"kbf": {
		"language": 3059
	},
	"kbg": {
		"language": 3060
	},
	"kbh": {
		"language": 3061
	},
	"kbi": {
		"language": 3062
	},
	"kbj": {
		"language": 3063
	},
	"kbk": {
		"language": 3064
	},
	"kbl": {
		"language": 3065
	},
	"kbm": {
		"language": 3066
	},
	"kbn": {
		"language": 3067
	},
	"kbo": {
		"language": 3068
	},
	"kbp": {
		"language": 3069
	},
	"kbq": {
		"language": 3070
	},
	"kbr": {
		"language": 3071
	},
	"kbs": {
		"language": 3072
	},
	"kbt": {
		"language": 3073
	},
	"kbu": {
		"language": 3074
	},
	"kbv": {
		"language": 3075
	},
	"kbw": {
		"language": 3076
	},
	"kbx": {
		"language": 3077
	},
	"kby": {
		"language": 3078
	},
	"kbz": {
		"language": 3079
	},
	"kca": {
		"language": 3080
	},
	"kcb": {
		"language": 3081
	},
	"kcc": {
		"language": 3082
	},
	"kcd": {
		"language": 3083
	},
	"kce": {
		"language": 3084
	},
	"kcf": {
		"language": 3085
	},
	"kcg": {
		"language": 3086
	},
	"kch": {
		"language": 3087
	},
	"kci": {
		"language": 3088
	},
	"kcj": {
		"language": 3089
	},
	"kck": {
		"language": 3090
	},
	"kcl": {
		"language": 3091
	},
	"kcm": {
		"language": 3092
	},
	"kcn": {
		"language": 3093
	},
	"kco": {
		"language": 3094
	},
	"kcp": {
		"language": 3095
	},
	"kcq": {
		"language": 3096
	},
	"kcr": {
		"language": 3097
	},
	"kcs": {
		"language": 3098
	},
	"kct": {
		"language": 3099
	},
	"kcu": {
		"language": 3100
	},
	"kcv": {
		"language": 3101
	},
	"kcw": {
		"language": 3102
	},
	"kcx": {
		"language": 3103
	},
	"kcy": {
		"language": 3104
	},
	"kcz": {
		"language": 3105
	},
	"kda": {
		"language": 3106
	},
	"kdc": {
		"language": 3107
	},
	"kdd": {
		"language": 3108
	},
	"kde": {
		"language": 3109
	},
	"kdf": {
		"language": 3110
	},
	"kdg": {
		"language": 3111
	},
	"kdh": {
		"language": 3112
	},
	"kdi": {
		"language": 3113
	},
	"kdj": {
		"language": 3114
	},
	"kdk": {
		"language": 3115
	},
	"kdl": {
		"language": 3116
	},
	"kdm": {
		"language": 3117
	},
	"kdn": {
		"language": 3118
	},
	"kdo": {
		"language": 3119
	},
	"kdp": {
		"language": 3120
	},
	"kdq": {
		"language": 3121
	},
	"kdr": {
		"language": 3122
	},
	"kdt": {
		"language": 3123
	},
	"kdu": {
		"language": 3124
	},
	"kdv": {
		"language": 3125
	},
	"kdw": {
		"language": 3126
	},
	"kdx": {
		"language": 3127
	},
	"kdy": {
		"language": 3128
	},
	"kdz": {
		"language": 3129
	},
	"kea": {
		"language": 3130
	},
	"keb": {
		"language": 3131
	},
	"kec": {
		"language": 3132
	},
	"ked": {
		"language": 3133
	},
	"kee": {
		"language": 3134
	},
	"kef": {
		"language": 3135
	},
	"keg": {
		"language": 3136
	},
	"keh": {
		"language": 3137
	},
	"kei": {
		"language": 3138
	},
	"kej": {
		"language": 3139
	},
	"kek": {
		"language": 3140
	},
	"kel": {
		"language": 3141
	},
	"kem": {
		"language": 3142
	},
	"ken": {
		"language": 3143
	},
	"keo": {
		"language": 3144
	},
	"kep": {
		"language": 3145
	},
	"keq": {
		"language": 3146
	},
	"ker": {
		"language": 3147
	},
	"kes": {
		"language": 3148
	},
	"ket": {
		"language": 3149
	},
	"keu": {
		"language": 3150
	},
	"kev": {
		"language": 3151
	},
	"kew": {
		"language": 3152
	},
	"kex": {
		"language": 3153
	},
	"key": {
		"language": 3154
	},
	"kez": {
		"language": 3155
	},
	"kfa": {
		"language": 3156
	},
	"kfb": {
		"language": 3157
	},
	"kfc": {
		"language": 3158
	},
	"kfd": {
		"language": 3159
	},
	"kfe": {
		"language": 3160
	},
	"kff": {
		"language": 3161
	},
	"kfg": {
		"language": 3162
	},
	"kfh": {
		"language": 3163
	},
	"kfi": {
		"language": 3164
	},
	"kfj": {
		"language": 3165
	},
	"kfk": {
		"language": 3166
	},
	"kfl": {
		"language": 3167
	},
	"kfm": {
		"language": 3168
	},
	"kfn": {
		"language": 3169
	},
	"kfo": {
		"language": 3170
	},
	"kfp": {
		"language": 3171
	},
	"kfq": {
		"language": 3172
	},
	"kfr": {
		"language": 3173
	},
	"kfs": {
		"language": 3174
	},
	"kft": {
		"language": 3175
	},
	"kfu": {
		"language": 3176
	},
	"kfv": {
		"language": 3177
	},
	"kfw": {
		"language": 3178
	},
	"kfx": {
		"language": 3179
	},
	"kfy": {
		"language": 3180
	},
	"kfz": {
		"language": 3181
	},
	"kga": {
		"language": 3182
	},
	"kgb": {
		"language": 3183
	},
	"kgc": {
		"language": 3184
	},
	"kgd": {
		"language": 3185
	},
	"kge": {
		"language": 3186
	},
	"kgf": {
		"language": 3187
	},
	"kgg": {
		"language": 3188
	},
	"kgh": {
		"language": 3189
	},
	"kgi": {
		"language": 3190,
		"extlang": 8238
	},
	"kgj": {
		"language": 3191
	},
	"kgk": {
		"language": 3192
	},
	"kgl": {
		"language": 3193
	},
	"kgm": {
		"language": 3194
	},
	"kgn": {
		"language": 3195
	},
	"kgo": {
		"language": 3196
	},
	"kgp": {
		"language": 3197
	},
	"kgq": {
		"language": 3198
	},
	"kgr": {
		"language": 3199
	},
	"kgs": {
		"language": 3200
	},
	"kgt": {
		"language": 3201
	},
	"kgu": {
		"language": 3202
	},
	"kgv": {
		"language": 3203
	},
	"kgw": {
		"language": 3204
	},
	"kgx": {
		"language": 3205
	},
	"kgy": {
		"language": 3206
	},
	"kha": {
		"language": 3207
	},
	"khb": {
		"language": 3208
	},
	"khc": {
		"language": 3209
	},
	"khd": {
		"language": 3210
	},
	"khe": {
		"language": 3211
	},
	"khf": {
		"language": 3212
	},
	"khg": {
		"language": 3213
	},
	"khh": {
		"language": 3214
	},
	"khi": {
		"language": 3215
	},
	"khj": {
		"language": 3216
	},
	"khk": {
		"language": 3217
	},
	"khl": {
		"language": 3218
	},
	"khn": {
		"language": 3219
	},
	"kho": {
		"language": 3220
	},
	"khp": {
		"language": 3221
	},
	"khq": {
		"language": 3222
	},
	"khr": {
		"language": 3223
	},
	"khs": {
		"language": 3224
	},
	"kht": {
		"language": 3225
	},
	"khu": {
		"language": 3226
	},
	"khv": {
		"language": 3227
	},
	"khw": {
		"language": 3228
	},
	"khx": {
		"language": 3229
	},
	"khy": {
		"language": 3230
	},
	"khz": {
		"language": 3231
	},
	"kia": {
		"language": 3232
	},
	"kib": {
		"language": 3233
	},
	"kic": {
		"language": 3234
	},
	"kid": {
		"language": 3235
	},
	"kie": {
		"language": 3236
	},
	"kif": {
		"language": 3237
	},
	"kig": {
		"language": 3238
	},
	"kih": {
		"language": 3239
	},
	"kii": {
		"language": 3240
	},
	"kij": {
		"language": 3241
	},
	"kil": {
		"language": 3242
	},
	"kim": {
		"language": 3243
	},
	"kio": {
		"language": 3244
	},
	"kip": {
		"language": 3245
	},
	"kiq": {
		"language": 3246
	},
	"kis": {
		"language": 3247
	},
	"kit": {
		"language": 3248
	},
	"kiu": {
		"language": 3249
	},
	"kiv": {
		"language": 3250
	},
	"kiw": {
		"language": 3251
	},
	"kix": {
		"language": 3252
	},
	"kiy": {
		"language": 3253
	},
	"kiz": {
		"language": 3254
	},
	"kja": {
		"language": 3255
	},
	"kjb": {
		"language": 3256
	},
	"kjc": {
		"language": 3257
	},
	"kjd": {
		"language": 3258
	},
	"kje": {
		"language": 3259
	},
	"kjf": {
		"language": 3260
	},
	"kjg": {
		"language": 3261
	},
	"kjh": {
		"language": 3262
	},
	"kji": {
		"language": 3263
	},
	"kjj": {
		"language": 3264
	},
	"kjk": {
		"language": 3265
	},
	"kjl": {
		"language": 3266
	},
	"kjm": {
		"language": 3267
	},
	"kjn": {
		"language": 3268
	},
	"kjo": {
		"language": 3269
	},
	"kjp": {
		"language": 3270
	},
	"kjq": {
		"language": 3271
	},
	"kjr": {
		"language": 3272
	},
	"kjs": {
		"language": 3273
	},
	"kjt": {
		"language": 3274
	},
	"kju": {
		"language": 3275
	},
	"kjv": {
		"language": 3276
	},
	"kjx": {
		"language": 3277
	},
	"kjy": {
		"language": 3278
	},
	"kjz": {
		"language": 3279
	},
	"kka": {
		"language": 3280
	},
	"kkb": {
		"language": 3281
	},
	"kkc": {
		"language": 3282
	},
	"kkd": {
		"language": 3283
	},
	"kke": {
		"language": 3284
	},
	"kkf": {
		"language": 3285
	},
	"kkg": {
		"language": 3286
	},
	"kkh": {
		"language": 3287
	},
	"kki": {
		"language": 3288
	},
	"kkj": {
		"language": 3289
	},
	"kkk": {
		"language": 3290
	},
	"kkl": {
		"language": 3291
	},
	"kkm": {
		"language": 3292
	},
	"kkn": {
		"language": 3293
	},
	"kko": {
		"language": 3294
	},
	"kkp": {
		"language": 3295
	},
	"kkq": {
		"language": 3296
	},
	"kkr": {
		"language": 3297
	},
	"kks": {
		"language": 3298
	},
	"kkt": {
		"language": 3299
	},
	"kku": {
		"language": 3300
	},
	"kkv": {
		"language": 3301
	},
	"kkw": {
		"language": 3302
	},
	"kkx": {
		"language": 3303
	},
	"kky": {
		"language": 3304
	},
	"kkz": {
		"language": 3305
	},
	"kla": {
		"language": 3306
	},
	"klb": {
		"language": 3307
	},
	"klc": {
		"language": 3308
	},
	"kld": {
		"language": 3309
	},
	"kle": {
		"language": 3310
	},
	"klf": {
		"language": 3311
	},
	"klg": {
		"language": 3312
	},
	"klh": {
		"language": 3313
	},
	"kli": {
		"language": 3314
	},
	"klj": {
		"language": 3315
	},
	"klk": {
		"language": 3316
	},
	"kll": {
		"language": 3317
	},
	"klm": {
		"language": 3318
	},
	"kln": {
		"language": 3319
	},
	"klo": {
		"language": 3320
	},
	"klp": {
		"language": 3321
	},
	"klq": {
		"language": 3322
	},
	"klr": {
		"language": 3323
	},
	"kls": {
		"language": 3324
	},
	"klt": {
		"language": 3325
	},
	"klu": {
		"language": 3326
	},
	"klv": {
		"language": 3327
	},
	"klw": {
		"language": 3328
	},
	"klx": {
		"language": 3329
	},
	"kly": {
		"language": 3330
	},
	"klz": {
		"language": 3331
	},
	"kma": {
		"language": 3332
	},
	"kmb": {
		"language": 3333
	},
	"kmc": {
		"language": 3334
	},
	"kmd": {
		"language": 3335
	},
	"kme": {
		"language": 3336
	},
	"kmf": {
		"language": 3337
	},
	"kmg": {
		"language": 3338
	},
	"kmh": {
		"language": 3339
	},
	"kmi": {
		"language": 3340
	},
	"kmj": {
		"language": 3341
	},
	"kmk": {
		"language": 3342
	},
	"kml": {
		"language": 3343
	},
	"kmm": {
		"language": 3344
	},
	"kmn": {
		"language": 3345
	},
	"kmo": {
		"language": 3346
	},
	"kmp": {
		"language": 3347
	},
	"kmq": {
		"language": 3348
	},
	"kmr": {
		"language": 3349
	},
	"kms": {
		"language": 3350
	},
	"kmt": {
		"language": 3351
	},
	"kmu": {
		"language": 3352
	},
	"kmv": {
		"language": 3353
	},
	"kmw": {
		"language": 3354
	},
	"kmx": {
		"language": 3355
	},
	"kmy": {
		"language": 3356
	},
	"kmz": {
		"language": 3357
	},
	"kna": {
		"language": 3358
	},
	"knb": {
		"language": 3359
	},
	"knc": {
		"language": 3360
	},
	"knd": {
		"language": 3361
	},
	"kne": {
		"language": 3362
	},
	"knf": {
		"language": 3363
	},
	"kng": {
		"language": 3364
	},
	"kni": {
		"language": 3365
	},
	"knj": {
		"language": 3366
	},
	"knk": {
		"language": 3367
	},
	"knl": {
		"language": 3368
	},
	"knm": {
		"language": 3369
	},
	"knn": {
		"language": 3370,
		"extlang": 8239
	},
	"kno": {
		"language": 3371
	},
	"knp": {
		"language": 3372
	},
	"knq": {
		"language": 3373
	},
	"knr": {
		"language": 3374
	},
	"kns": {
		"language": 3375
	},
	"knt": {
		"language": 3376
	},
	"knu": {
		"language": 3377
	},
	"knv": {
		"language": 3378
	},
	"knw": {
		"language": 3379
	},
	"knx": {
		"language": 3380
	},
	"kny": {
		"language": 3381
	},
	"knz": {
		"language": 3382
	},
	"koa": {
		"language": 3383
	},
	"koc": {
		"language": 3384
	},
	"kod": {
		"language": 3385
	},
	"koe": {
		"language": 3386
	},
	"kof": {
		"language": 3387
	},
	"kog": {
		"language": 3388
	},
	"koh": {
		"language": 3389
	},
	"koi": {
		"language": 3390
	},
	"koj": {
		"language": 3391
	},
	"kok": {
		"language": 3392
	},
	"kol": {
		"language": 3393
	},
	"koo": {
		"language": 3394
	},
	"kop": {
		"language": 3395
	},
	"koq": {
		"language": 3396
	},
	"kos": {
		"language": 3397
	},
	"kot": {
		"language": 3398
	},
	"kou": {
		"language": 3399
	},
	"kov": {
		"language": 3400
	},
	"kow": {
		"language": 3401
	},
	"kox": {
		"language": 3402
	},
	"koy": {
		"language": 3403
	},
	"koz": {
		"language": 3404
	},
	"kpa": {
		"language": 3405
	},
	"kpb": {
		"language": 3406
	},
	"kpc": {
		"language": 3407
	},
	"kpd": {
		"language": 3408
	},
	"kpe": {
		"language": 3409
	},
	"kpf": {
		"language": 3410
	},
	"kpg": {
		"language": 3411
	},
	"kph": {
		"language": 3412
	},
	"kpi": {
		"language": 3413
	},
	"kpj": {
		"language": 3414
	},
	"kpk": {
		"language": 3415
	},
	"kpl": {
		"language": 3416
	},
	"kpm": {
		"language": 3417
	},
	"kpn": {
		"language": 3418
	},
	"kpo": {
		"language": 3419
	},
	"kpp": {
		"language": 3420
	},
	"kpq": {
		"language": 3421
	},
	"kpr": {
		"language": 3422
	},
	"kps": {
		"language": 3423
	},
	"kpt": {
		"language": 3424
	},
	"kpu": {
		"language": 3425
	},
	"kpv": {
		"language": 3426
	},
	"kpw": {
		"language": 3427
	},
	"kpx": {
		"language": 3428
	},
	"kpy": {
		"language": 3429
	},
	"kpz": {
		"language": 3430
	},
	"kqa": {
		"language": 3431
	},
	"kqb": {
		"language": 3432
	},
	"kqc": {
		"language": 3433
	},
	"kqd": {
		"language": 3434
	},
	"kqe": {
		"language": 3435
	},
	"kqf": {
		"language": 3436
	},
	"kqg": {
		"language": 3437
	},
	"kqh": {
		"language": 3438
	},
	"kqi": {
		"language": 3439
	},
	"kqj": {
		"language": 3440
	},
	"kqk": {
		"language": 3441
	},
	"kql": {
		"language": 3442
	},
	"kqm": {
		"language": 3443
	},
	"kqn": {
		"language": 3444
	},
	"kqo": {
		"language": 3445
	},
	"kqp": {
		"language": 3446
	},
	"kqq": {
		"language": 3447
	},
	"kqr": {
		"language": 3448
	},
	"kqs": {
		"language": 3449
	},
	"kqt": {
		"language": 3450
	},
	"kqu": {
		"language": 3451
	},
	"kqv": {
		"language": 3452
	},
	"kqw": {
		"language": 3453
	},
	"kqx": {
		"language": 3454
	},
	"kqy": {
		"language": 3455
	},
	"kqz": {
		"language": 3456
	},
	"kra": {
		"language": 3457
	},
	"krb": {
		"language": 3458
	},
	"krc": {
		"language": 3459
	},
	"krd": {
		"language": 3460
	},
	"kre": {
		"language": 3461
	},
	"krf": {
		"language": 3462
	},
	"krh": {
		"language": 3463
	},
	"kri": {
		"language": 3464
	},
	"krj": {
		"language": 3465
	},
	"krk": {
		"language": 3466
	},
	"krl": {
		"language": 3467
	},
	"krm": {
		"language": 3468
	},
	"krn": {
		"language": 3469
	},
	"kro": {
		"language": 3470
	},
	"krp": {
		"language": 3471
	},
	"krr": {
		"language": 3472
	},
	"krs": {
		"language": 3473
	},
	"krt": {
		"language": 3474
	},
	"kru": {
		"language": 3475
	},
	"krv": {
		"language": 3476
	},
	"krw": {
		"language": 3477
	},
	"krx": {
		"language": 3478
	},
	"kry": {
		"language": 3479
	},
	"krz": {
		"language": 3480
	},
	"ksa": {
		"language": 3481
	},
	"ksb": {
		"language": 3482
	},
	"ksc": {
		"language": 3483
	},
	"ksd": {
		"language": 3484
	},
	"kse": {
		"language": 3485
	},
	"ksf": {
		"language": 3486
	},
	"ksg": {
		"language": 3487
	},
	"ksh": {
		"language": 3488
	},
	"ksi": {
		"language": 3489
	},
	"ksj": {
		"language": 3490
	},
	"ksk": {
		"language": 3491
	},
	"ksl": {
		"language": 3492
	},
	"ksm": {
		"language": 3493
	},
	"ksn": {
		"language": 3494
	},
	"kso": {
		"language": 3495
	},
	"ksp": {
		"language": 3496
	},
	"ksq": {
		"language": 3497
	},
	"ksr": {
		"language": 3498
	},
	"kss": {
		"language": 3499
	},
	"kst": {
		"language": 3500
	},
	"ksu": {
		"language": 3501
	},
	"ksv": {
		"language": 3502
	},
	"ksw": {
		"language": 3503
	},
	"ksx": {
		"language": 3504
	},
	"ksy": {
		"language": 3505
	},
	"ksz": {
		"language": 3506
	},
	"kta": {
		"language": 3507
	},
	"ktb": {
		"language": 3508
	},
	"ktc": {
		"language": 3509
	},
	"ktd": {
		"language": 3510
	},
	"kte": {
		"language": 3511
	},
	"ktf": {
		"language": 3512
	},
	"ktg": {
		"language": 3513
	},
	"kth": {
		"language": 3514
	},
	"kti": {
		"language": 3515
	},
	"ktj": {
		"language": 3516
	},
	"ktk": {
		"language": 3517
	},
	"ktl": {
		"language": 3518
	},
	"ktm": {
		"language": 3519
	},
	"ktn": {
		"language": 3520
	},
	"kto": {
		"language": 3521
	},
	"ktp": {
		"language": 3522
	},
	"ktq": {
		"language": 3523
	},
	"ktr": {
		"language": 3524
	},
	"kts": {
		"language": 3525
	},
	"ktt": {
		"language": 3526
	},
	"ktu": {
		"language": 3527
	},
	"ktv": {
		"language": 3528
	},
	"ktw": {
		"language": 3529
	},
	"ktx": {
		"language": 3530
	},
	"kty": {
		"language": 3531
	},
	"ktz": {
		"language": 3532
	},
	"kub": {
		"language": 3533
	},
	"kuc": {
		"language": 3534
	},
	"kud": {
		"language": 3535
	},
	"kue": {
		"language": 3536
	},
	"kuf": {
		"language": 3537
	},
	"kug": {
		"language": 3538
	},
	"kuh": {
		"language": 3539
	},
	"kui": {
		"language": 3540
	},
	"kuj": {
		"language": 3541
	},
	"kuk": {
		"language": 3542
	},
	"kul": {
		"language": 3543
	},
	"kum": {
		"language": 3544
	},
	"kun": {
		"language": 3545
	},
	"kuo": {
		"language": 3546
	},
	"kup": {
		"language": 3547
	},
	"kuq": {
		"language": 3548
	},
	"kus": {
		"language": 3549
	},
	"kut": {
		"language": 3550
	},
	"kuu": {
		"language": 3551
	},
	"kuv": {
		"language": 3552
	},
	"kuw": {
		"language": 3553
	},
	"kux": {
		"language": 3554
	},
	"kuy": {
		"language": 3555
	},
	"kuz": {
		"language": 3556
	},
	"kva": {
		"language": 3557
	},
	"kvb": {
		"language": 3558,
		"extlang": 8240
	},
	"kvc": {
		"language": 3559
	},
	"kvd": {
		"language": 3560
	},
	"kve": {
		"language": 3561
	},
	"kvf": {
		"language": 3562
	},
	"kvg": {
		"language": 3563
	},
	"kvh": {
		"language": 3564
	},
	"kvi": {
		"language": 3565
	},
	"kvj": {
		"language": 3566
	},
	"kvk": {
		"language": 3567,
		"extlang": 8241
	},
	"kvl": {
		"language": 3568
	},
	"kvm": {
		"language": 3569
	},
	"kvn": {
		"language": 3570
	},
	"kvo": {
		"language": 3571
	},
	"kvp": {
		"language": 3572
	},
	"kvq": {
		"language": 3573
	},
	"kvr": {
		"language": 3574,
		"extlang": 8242
	},
	"kvs": {
		"language": 3575
	},
	"kvt": {
		"language": 3576
	},
	"kvu": {
		"language": 3577
	},
	"kvv": {
		"language": 3578
	},
	"kvw": {
		"language": 3579
	},
	"kvx": {
		"language": 3580
	},
	"kvy": {
		"language": 3581
	},
	"kvz": {
		"language": 3582
	},
	"kwa": {
		"language": 3583
	},
	"kwb": {
		"language": 3584
	},
	"kwc": {
		"language": 3585
	},
	"kwd": {
		"language": 3586
	},
	"kwe": {
		"language": 3587
	},
	"kwf": {
		"language": 3588
	},
	"kwg": {
		"language": 3589
	},
	"kwh": {
		"language": 3590
	},
	"kwi": {
		"language": 3591
	},
	"kwj": {
		"language": 3592
	},
	"kwk": {
		"language": 3593
	},
	"kwl": {
		"language": 3594
	},
	"kwm": {
		"language": 3595
	},
	"kwn": {
		"language": 3596
	},
	"kwo": {
		"language": 3597
	},
	"kwp": {
		"language": 3598
	},
	"kwq": {
		"language": 3599
	},
	"kwr": {
		"language": 3600
	},
	"kws": {
		"language": 3601
	},
	"kwt": {
		"language": 3602
	},
	"kwu": {
		"language": 3603
	},
	"kwv": {
		"language": 3604
	},
	"kww": {
		"language": 3605
	},
	"kwx": {
		"language": 3606
	},
	"kwy": {
		"language": 3607
	},
	"kwz": {
		"language": 3608
	},
	"kxa": {
		"language": 3609
	},
	"kxb": {
		"language": 3610
	},
	"kxc": {
		"language": 3611
	},
	"kxd": {
		"language": 3612,
		"extlang": 8243
	},
	"kxe": {
		"language": 3613
	},
	"kxf": {
		"language": 3614
	},
	"kxh": {
		"language": 3615
	},
	"kxi": {
		"language": 3616
	},
	"kxj": {
		"language": 3617
	},
	"kxk": {
		"language": 3618
	},
	"kxl": {
		"language": 3619
	},
	"kxm": {
		"language": 3620
	},
	"kxn": {
		"language": 3621
	},
	"kxo": {
		"language": 3622
	},
	"kxp": {
		"language": 3623
	},
	"kxq": {
		"language": 3624
	},
	"kxr": {
		"language": 3625
	},
	"kxs": {
		"language": 3626
	},
	"kxt": {
		"language": 3627
	},
	"kxu": {
		"language": 3628
	},
	"kxv": {
		"language": 3629
	},
	"kxw": {
		"language": 3630
	},
	"kxx": {
		"language": 3631
	},
	"kxy": {
		"language": 3632
	},
	"kxz": {
		"language": 3633
	},
	"kya": {
		"language": 3634
	},
	"kyb": {
		"language": 3635
	},
	"kyc": {
		"language": 3636
	},
	"kyd": {
		"language": 3637
	},
	"kye": {
		"language": 3638
	},
	"kyf": {
		"language": 3639
	},
	"kyg": {
		"language": 3640
	},
	"kyh": {
		"language": 3641
	},
	"kyi": {
		"language": 3642
	},
	"kyj": {
		"language": 3643
	},
	"kyk": {
		"language": 3644
	},
	"kyl": {
		"language": 3645
	},
	"kym": {
		"language": 3646
	},
	"kyn": {
		"language": 3647
	},
	"kyo": {
		"language": 3648
	},
	"kyp": {
		"language": 3649
	},
	"kyq": {
		"language": 3650
	},
	"kyr": {
		"language": 3651
	},
	"kys": {
		"language": 3652
	},
	"kyt": {
		"language": 3653
	},
	"kyu": {
		"language": 3654
	},
	"kyv": {
		"language": 3655
	},
	"kyw": {
		"language": 3656
	},
	"kyx": {
		"language": 3657
	},
	"kyy": {
		"language": 3658
	},
	"kyz": {
		"language": 3659
	},
	"kza": {
		"language": 3660
	},
	"kzb": {
		"language": 3661
	},
	"kzc": {
		"language": 3662
	},
	"kzd": {
		"language": 3663
	},
	"kze": {
		"language": 3664
	},
	"kzf": {
		"language": 3665
	},
	"kzg": {
		"language": 3666
	},
	"kzh": {
		"language": 3667
	},
	"kzi": {
		"language": 3668
	},
	"kzj": {
		"language": 3669
	},
	"kzk": {
		"language": 3670
	},
	"kzl": {
		"language": 3671
	},
	"kzm": {
		"language": 3672
	},
	"kzn": {
		"language": 3673
	},
	"kzo": {
		"language": 3674
	},
	"kzp": {
		"language": 3675
	},
	"kzq": {
		"language": 3676
	},
	"kzr": {
		"language": 3677
	},
	"kzs": {
		"language": 3678
	},
	"kzt": {
		"language": 3679
	},
	"kzu": {
		"language": 3680
	},
	"kzv": {
		"language": 3681
	},
	"kzw": {
		"language": 3682
	},
	"kzx": {
		"language": 3683
	},
	"kzy": {
		"language": 3684
	},
	"kzz": {
		"language": 3685
	},
	"laa": {
		"language": 3686
	},
	"lab": {
		"language": 3687
	},
	"lac": {
		"language": 3688
	},
	"lad": {
		"language": 3689
	},
	"lae": {
		"language": 3690
	},
	"laf": {
		"language": 3691
	},
	"lag": {
		"language": 3692
	},
	"lah": {
		"language": 3693
	},
	"lai": {
		"language": 3694
	},
	"laj": {
		"language": 3695
	},
	"lak": {
		"language": 3696
	},
	"lal": {
		"language": 3697
	},
	"lam": {
		"language": 3698
	},
	"lan": {
		"language": 3699
	},
	"lap": {
		"language": 3700
	},
	"laq": {
		"language": 3701
	},
	"lar": {
		"language": 3702
	},
	"las": {
		"language": 3703
	},
	"lau": {
		"language": 3704
	},
	"law": {
		"language": 3705
	},
	"lax": {
		"language": 3706
	},
	"lay": {
		"language": 3707
	},
	"laz": {
		"language": 3708
	},
	"lba": {
		"language": 3709
	},
	"lbb": {
		"language": 3710
	},
	"lbc": {
		"language": 3711
	},
	"lbe": {
		"language": 3712
	},
	"lbf": {
		"language": 3713
	},
	"lbg": {
		"language": 3714
	},
	"lbi": {
		"language": 3715
	},
	"lbj": {
		"language": 3716
	},
	"lbk": {
		"language": 3717
	},
	"lbl": {
		"language": 3718
	},
	"lbm": {
		"language": 3719
	},
	"lbn": {
		"language": 3720
	},
	"lbo": {
		"language": 3721
	},
	"lbq": {
		"language": 3722
	},
	"lbr": {
		"language": 3723
	},
	"lbs": {
		"language": 3724,
		"extlang": 8244
	},
	"lbt": {
		"language": 3725
	},
	"lbu": {
		"language": 3726
	},
	"lbv": {
		"language": 3727
	},
	"lbw": {
		"language": 3728
	},
	"lbx": {
		"language": 3729
	},
	"lby": {
		"language": 3730
	},
	"lbz": {
		"language": 3731
	},
	"lcc": {
		"language": 3732
	},
	"lcd": {
		"language": 3733
	},
	"lce": {
		"language": 3734,
		"extlang": 8245
	},
	"lcf": {
		"language": 3735,
		"extlang": 8246
	},
	"lch": {
		"language": 3736
	},
	"lcl": {
		"language": 3737
	},
	"lcm": {
		"language": 3738
	},
	"lcp": {
		"language": 3739
	},
	"lcq": {
		"language": 3740
	},
	"lcs": {
		"language": 3741
	},
	"lda": {
		"language": 3742
	},
	"ldb": {
		"language": 3743
	},
	"ldd": {
		"language": 3744
	},
	"ldg": {
		"language": 3745
	},
	"ldh": {
		"language": 3746
	},
	"ldi": {
		"language": 3747
	},
	"ldj": {
		"language": 3748
	},
	"ldk": {
		"language": 3749
	},
	"ldl": {
		"language": 3750
	},
	"ldm": {
		"language": 3751
	},
	"ldn": {
		"language": 3752
	},
	"ldo": {
		"language": 3753
	},
	"ldp": {
		"language": 3754
	},
	"ldq": {
		"language": 3755
	},
	"lea": {
		"language": 3756
	},
	"leb": {
		"language": 3757
	},
	"lec": {
		"language": 3758
	},
	"led": {
		"language": 3759
	},
	"lee": {
		"language": 3760
	},
	"lef": {
		"language": 3761
	},
	"leg": {
		"language": 3762
	},
	"leh": {
		"language": 3763
	},
	"lei": {
		"language": 3764
	},
	"lej": {
		"language": 3765
	},
	"lek": {
		"language": 3766
	},
	"lel": {
		"language": 3767
	},
	"lem": {
		"language": 3768
	},
	"len": {
		"language": 3769
	},
	"leo": {
		"language": 3770
	},
	"lep": {
		"language": 3771
	},
	"leq": {
		"language": 3772
	},
	"ler": {
		"language": 3773
	},
	"les": {
		"language": 3774
	},
	"let": {
		"language": 3775
	},
	"leu": {
		"language": 3776
	},
	"lev": {
		"language": 3777
	},
	"lew": {
		"language": 3778
	},
	"lex": {
		"language": 3779
	},
	"ley": {
		"language": 3780
	},
	"lez": {
		"language": 3781
	},
	"lfa": {
		"language": 3782
	},
	"lfn": {
		"language": 3783
	},
	"lga": {
		"language": 3784
	},
	"lgb": {
		"language": 3785
	},
	"lgg": {
		"language": 3786
	},
	"lgh": {
		"language": 3787
	},
	"lgi": {
		"language": 3788
	},
	"lgk": {
		"language": 3789
	},
	"lgl": {
		"language": 3790
	},
	"lgm": {
		"language": 3791
	},
	"lgn": {
		"language": 3792
	},
	"lgq": {
		"language": 3793
	},
	"lgr": {
		"language": 3794
	},
	"lgt": {
		"language": 3795
	},
	"lgu": {
		"language": 3796
	},
	"lgz": {
		"language": 3797
	},
	"lha": {
		"language": 3798
	},
	"lhh": {
		"language": 3799
	},
	"lhi": {
		"language": 3800
	},
	"lhl": {
		"language": 3801
	},
	"lhm": {
		"language": 3802
	},
	"lhn": {
		"language": 3803
	},
	"lhp": {
		"language": 3804
	},
	"lhs": {
		"language": 3805
	},
	"lht": {
		"language": 3806
	},
	"lhu": {
		"language": 3807
	},
	"lia": {
		"language": 3808
	},
	"lib": {
		"language": 3809
	},
	"lic": {
		"language": 3810
	},
	"lid": {
		"language": 3811
	},
	"lie": {
		"language": 3812
	},
	"lif": {
		"language": 3813
	},
	"lig": {
		"language": 3814
	},
	"lih": {
		"language": 3815
	},
	"lii": {
		"language": 3816
	},
	"lij": {
		"language": 3817
	},
	"lik": {
		"language": 3818
	},
	"lil": {
		"language": 3819
	},
	"lio": {
		"language": 3820
	},
	"lip": {
		"language": 3821
	},
	"liq": {
		"language": 3822
	},
	"lir": {
		"language": 3823
	},
	"lis": {
		"language": 3824
	},
	"liu": {
		"language": 3825
	},
	"liv": {
		"language": 3826
	},
	"liw": {
		"language": 3827,
		"extlang": 8247
	},
	"lix": {
		"language": 3828
	},
	"liy": {
		"language": 3829
	},
	"liz": {
		"language": 3830
	},
	"lja": {
		"language": 3831
	},
	"lje": {
		"language": 3832
	},
	"lji": {
		"language": 3833
	},
	"ljl": {
		"language": 3834
	},
	"ljp": {
		"language": 3835
	},
	"ljw": {
		"language": 3836
	},
	"ljx": {
		"language": 3837
	},
	"lka": {
		"language": 3838
	},
	"lkb": {
		"language": 3839
	},
	"lkc": {
		"language": 3840
	},
	"lkd": {
		"language": 3841
	},
	"lke": {
		"language": 3842
	},
	"lkh": {
		"language": 3843
	},
	"lki": {
		"language": 3844
	},
	"lkj": {
		"language": 3845
	},
	"lkl": {
		"language": 3846
	},
	"lkm": {
		"language": 3847
	},
	"lkn": {
		"language": 3848
	},
	"lko": {
		"language": 3849
	},
	"lkr": {
		"language": 3850
	},
	"lks": {
		"language": 3851
	},
	"lkt": {
		"language": 3852
	},
	"lku": {
		"language": 3853
	},
	"lky": {
		"language": 3854
	},
	"lla": {
		"language": 3855
	},
	"llb": {
		"language": 3856
	},
	"llc": {
		"language": 3857
	},
	"lld": {
		"language": 3858
	},
	"lle": {
		"language": 3859
	},
	"llf": {
		"language": 3860
	},
	"llg": {
		"language": 3861
	},
	"llh": {
		"language": 3862
	},
	"lli": {
		"language": 3863
	},
	"llj": {
		"language": 3864
	},
	"llk": {
		"language": 3865
	},
	"lll": {
		"language": 3866
	},
	"llm": {
		"language": 3867
	},
	"lln": {
		"language": 3868
	},
	"llo": {
		"language": 3869
	},
	"llp": {
		"language": 3870
	},
	"llq": {
		"language": 3871
	},
	"lls": {
		"language": 3872,
		"extlang": 8248
	},
	"llu": {
		"language": 3873
	},
	"llx": {
		"language": 3874
	},
	"lma": {
		"language": 3875
	},
	"lmb": {
		"language": 3876
	},
	"lmc": {
		"language": 3877
	},
	"lmd": {
		"language": 3878
	},
	"lme": {
		"language": 3879
	},
	"lmf": {
		"language": 3880
	},
	"lmg": {
		"language": 3881
	},
	"lmh": {
		"language": 3882
	},
	"lmi": {
		"language": 3883
	},
	"lmj": {
		"language": 3884
	},
	"lmk": {
		"language": 3885
	},
	"lml": {
		"language": 3886
	},
	"lmm": {
		"language": 3887
	},
	"lmn": {
		"language": 3888
	},
	"lmo": {
		"language": 3889
	},
	"lmp": {
		"language": 3890
	},
	"lmq": {
		"language": 3891
	},
	"lmr": {
		"language": 3892
	},
	"lmu": {
		"language": 3893
	},
	"lmv": {
		"language": 3894
	},
	"lmw": {
		"language": 3895
	},
	"lmx": {
		"language": 3896
	},
	"lmy": {
		"language": 3897
	},
	"lmz": {
		"language": 3898
	},
	"lna": {
		"language": 3899
	},
	"lnb": {
		"language": 3900
	},
	"lnd": {
		"language": 3901
	},
	"lng": {
		"language": 3902
	},
	"lnh": {
		"language": 3903
	},
	"lni": {
		"language": 3904
	},
	"lnj": {
		"language": 3905
	},
	"lnl": {
		"language": 3906
	},
	"lnm": {
		"language": 3907
	},
	"lnn": {
		"language": 3908
	},
	"lno": {
		"language": 3909
	},
	"lns": {
		"language": 3910
	},
	"lnu": {
		"language": 3911
	},
	"lnw": {
		"language": 3912
	},
	"lnz": {
		"language": 3913
	},
	"loa": {
		"language": 3914
	},
	"lob": {
		"language": 3915
	},
	"loc": {
		"language": 3916
	},
	"loe": {
		"language": 3917
	},
	"lof": {
		"language": 3918
	},
	"log": {
		"language": 3919
	},
	"loh": {
		"language": 3920
	},
	"loi": {
		"language": 3921
	},
	"loj": {
		"language": 3922
	},
	"lok": {
		"language": 3923
	},
	"lol": {
		"language": 3924
	},
	"lom": {
		"language": 3925
	},
	"lon": {
		"language": 3926
	},
	"loo": {
		"language": 3927
	},
	"lop": {
		"language": 3928
	},
	"loq": {
		"language": 3929
	},
	"lor": {
		"language": 3930
	},
	"los": {
		"language": 3931
	},
	"lot": {
		"language": 3932
	},
	"lou": {
		"language": 3933
	},
	"lov": {
		"language": 3934
	},
	"low": {
		"language": 3935
	},
	"lox": {
		"language": 3936
	},
	"loy": {
		"language": 3937
	},
	"loz": {
		"language": 3938
	},
	"lpa": {
		"language": 3939
	},
	"lpe": {
		"language": 3940
	},
	"lpn": {
		"language": 3941
	},
	"lpo": {
		"language": 3942
	},
	"lpx": {
		"language": 3943
	},
	"lra": {
		"language": 3944
	},
	"lrc": {
		"language": 3945
	},
	"lre": {
		"language": 3946
	},
	"lrg": {
		"language": 3947
	},
	"lri": {
		"language": 3948
	},
	"lrk": {
		"language": 3949
	},
	"lrl": {
		"language": 3950
	},
	"lrm": {
		"language": 3951
	},
	"lrn": {
		"language": 3952
	},
	"lro": {
		"language": 3953
	},
	"lrr": {
		"language": 3954
	},
	"lrt": {
		"language": 3955
	},
	"lrv": {
		"language": 3956
	},
	"lrz": {
		"language": 3957
	},
	"lsa": {
		"language": 3958
	},
	"lsd": {
		"language": 3959
	},
	"lse": {
		"language": 3960
	},
	"lsg": {
		"language": 3961,
		"extlang": 8249
	},
	"lsh": {
		"language": 3962
	},
	"lsi": {
		"language": 3963
	},
	"lsl": {
		"language": 3964,
		"extlang": 8250
	},
	"lsm": {
		"language": 3965
	},
	"lso": {
		"language": 3966,
		"extlang": 8251
	},
	"lsp": {
		"language": 3967,
		"extlang": 8252
	},
	"lsr": {
		"language": 3968
	},
	"lss": {
		"language": 3969
	},
	"lst": {
		"language": 3970,
		"extlang": 8253
	},
	"lsy": {
		"language": 3971,
		"extlang": 8254
	},
	"ltc": {
		"language": 3972
	},
	"ltg": {
		"language": 3973,
		"extlang": 8255
	},
	"lth": {
		"language": 3974
	},
	"lti": {
		"language": 3975
	},
	"ltn": {
		"language": 3976
	},
	"lto": {
		"language": 3977
	},
	"lts": {
		"language": 3978
	},
	"ltu": {
		"language": 3979
	},
	"lua": {
		"language": 3980
	},
	"luc": {
		"language": 3981
	},
	"lud": {
		"language": 3982
	},
	"lue": {
		"language": 3983
	},
	"luf": {
		"language": 3984
	},
	"lui": {
		"language": 3985
	},
	"luj": {
		"language": 3986
	},
	"luk": {
		"language": 3987
	},
	"lul": {
		"language": 3988
	},
	"lum": {
		"language": 3989
	},
	"lun": {
		"language": 3990
	},
	"luo": {
		"language": 3991
	},
	"lup": {
		"language": 3992
	},
	"luq": {
		"language": 3993
	},
	"lur": {
		"language": 3994
	},
	"lus": {
		"language": 3995
	},
	"lut": {
		"language": 3996
	},
	"luu": {
		"language": 3997
	},
	"luv": {
		"language": 3998
	},
	"luw": {
		"language": 3999
	},
	"luy": {
		"language": 4000
	},
	"luz": {
		"language": 4001
	},
	"lva": {
		"language": 4002
	},
	"lvk": {
		"language": 4003
	},
	"lvs": {
		"language": 4004,
		"extlang": 8256
	},
	"lvu": {
		"language": 4005
	},
	"lwa": {
		"language": 4006
	},
	"lwe": {
		"language": 4007
	},
	"lwg": {
		"language": 4008
	},
	"lwh": {
		"language": 4009
	},
	"lwl": {
		"language": 4010
	},
	"lwm": {
		"language": 4011
	},
	"lwo": {
		"language": 4012
	},
	"lwt": {
		"language": 4013
	},
	"lwu": {
		"language": 4014
	},
	"lww": {
		"language": 4015
	},
	"lya": {
		"language": 4016
	},
	"lyg": {
		"language": 4017
	},
	"lyn": {
		"language": 4018
	},
	"lzh": {
		"language": 4019,
		"extlang": 8257
	},
	"lzl": {
		"language": 4020
	},
	"lzn": {
		"language": 4021
	},
	"lzz": {
		"language": 4022
	},
	"maa": {
		"language": 4023
	},
	"mab": {
		"language": 4024
	},
	"mad": {
		"language": 4025
	},
	"mae": {
		"language": 4026
	},
	"maf": {
		"language": 4027
	},
	"mag": {
		"language": 4028
	},
	"mai": {
		"language": 4029
	},
	"maj": {
		"language": 4030
	},
	"mak": {
		"language": 4031
	},
	"mam": {
		"language": 4032
	},
	"man": {
		"language": 4033
	},
	"map": {
		"language": 4034
	},
	"maq": {
		"language": 4035
	},
	"mas": {
		"language": 4036
	},
	"mat": {
		"language": 4037
	},
	"mau": {
		"language": 4038
	},
	"mav": {
		"language": 4039
	},
	"maw": {
		"language": 4040
	},
	"max": {
		"language": 4041,
		"extlang": 8258
	},
	"maz": {
		"language": 4042
	},
	"mba": {
		"language": 4043
	},
	"mbb": {
		"language": 4044
	},
	"mbc": {
		"language": 4045
	},
	"mbd": {
		"language": 4046
	},
	"mbe": {
		"language": 4047
	},
	"mbf": {
		"language": 4048
	},
	"mbh": {
		"language": 4049
	},
	"mbi": {
		"language": 4050
	},
	"mbj": {
		"language": 4051
	},
	"mbk": {
		"language": 4052
	},
	"mbl": {
		"language": 4053
	},
	"mbm": {
		"language": 4054
	},
	"mbn": {
		"language": 4055
	},
	"mbo": {
		"language": 4056
	},
	"mbp": {
		"language": 4057
	},
	"mbq": {
		"language": 4058
	},
	"mbr": {
		"language": 4059
	},
	"mbs": {
		"language": 4060
	},
	"mbt": {
		"language": 4061
	},
	"mbu": {
		"language": 4062
	},
	"mbv": {
		"language": 4063
	},
	"mbw": {
		"language": 4064
	},
	"mbx": {
		"language": 4065
	},
	"mby": {
		"language": 4066
	},
	"mbz": {
		"language": 4067
	},
	"mca": {
		"language": 4068
	},
	"mcb": {
		"language": 4069
	},
	"mcc": {
		"language": 4070
	},
	"mcd": {
		"language": 4071
	},
	"mce": {
		"language": 4072
	},
	"mcf": {
		"language": 4073
	},
	"mcg": {
		"language": 4074
	},
	"mch": {
		"language": 4075
	},
	"mci": {
		"language": 4076
	},
	"mcj": {
		"language": 4077
	},
	"mck": {
		"language": 4078
	},
	"mcl": {
		"language": 4079
	},
	"mcm": {
		"language": 4080
	},
	"mcn": {
		"language": 4081
	},
	"mco": {
		"language": 4082
	},
	"mcp": {
		"language": 4083
	},
	"mcq": {
		"language": 4084
	},
	"mcr": {
		"language": 4085
	},
	"mcs": {
		"language": 4086
	},
	"mct": {
		"language": 4087
	},
	"mcu": {
		"language": 4088
	},
	"mcv": {
		"language": 4089
	},
	"mcw": {
		"language": 4090
	},
	"mcx": {
		"language": 4091
	},
	"mcy": {
		"language": 4092
	},
	"mcz": {
		"language": 4093
	},
	"mda": {
		"language": 4094
	},
	"mdb": {
		"language": 4095
	},
	"mdc": {
		"language": 4096
	},
	"mdd": {
		"language": 4097
	},
	"mde": {
		"language": 4098
	},
	"mdf": {
		"language": 4099
	},
	"mdg": {
		"language": 4100
	},
	"mdh": {
		"language": 4101
	},
	"mdi": {
		"language": 4102
	},
	"mdj": {
		"language": 4103
	},
	"mdk": {
		"language": 4104
	},
	"mdl": {
		"language": 4105,
		"extlang": 8259
	},
	"mdm": {
		"language": 4106
	},
	"mdn": {
		"language": 4107
	},
	"mdp": {
		"language": 4108
	},
	"mdq": {
		"language": 4109
	},
	"mdr": {
		"language": 4110
	},
	"mds": {
		"language": 4111
	},
	"mdt": {
		"language": 4112
	},
	"mdu": {
		"language": 4113
	},
	"mdv": {
		"language": 4114
	},
	"mdw": {
		"language": 4115
	},
	"mdx": {
		"language": 4116
	},
	"mdy": {
		"language": 4117
	},
	"mdz": {
		"language": 4118
	},
	"mea": {
		"language": 4119
	},
	"meb": {
		"language": 4120
	},
	"mec": {
		"language": 4121
	},
	"med": {
		"language": 4122
	},
	"mee": {
		"language": 4123
	},
	"mef": {
		"language": 4124
	},
	"meg": {
		"language": 4125
	},
	"meh": {
		"language": 4126
	},
	"mei": {
		"language": 4127
	},
	"mej": {
		"language": 4128
	},
	"mek": {
		"language": 4129
	},
	"mel": {
		"language": 4130
	},
	"mem": {
		"language": 4131
	},
	"men": {
		"language": 4132
	},
	"meo": {
		"language": 4133,
		"extlang": 8260
	},
	"mep": {
		"language": 4134
	},
	"meq": {
		"language": 4135
	},
	"mer": {
		"language": 4136
	},
	"mes": {
		"language": 4137
	},
	"met": {
		"language": 4138
	},
	"meu": {
		"language": 4139
	},
	"mev": {
		"language": 4140
	},
	"mew": {
		"language": 4141
	},
	"mey": {
		"language": 4142
	},
	"mez": {
		"language": 4143
	},
	"mfa": {
		"language": 4144,
		"extlang": 8261
	},
	"mfb": {
		"language": 4145,
		"extlang": 8262
	},
	"mfc": {
		"language": 4146
	},
	"mfd": {
		"language": 4147
	},
	"mfe": {
		"language": 4148
	},
	"mff": {
		"language": 4149
	},
	"mfg": {
		"language": 4150
	},
	"mfh": {
		"language": 4151
	},
	"mfi": {
		"language": 4152
	},
	"mfj": {
		"language": 4153
	},
	"mfk": {
		"language": 4154
	},
	"mfl": {
		"language": 4155
	},
	"mfm": {
		"language": 4156
	},
	"mfn": {
		"language": 4157
	},
	"mfo": {
		"language": 4158
	},
	"mfp": {
		"language": 4159
	},
	"mfq": {
		"language": 4160
	},
	"mfr": {
		"language": 4161
	},
	"mfs": {
		"language": 4162,
		"extlang": 8263
	},
	"mft": {
		"language": 4163
	},
	"mfu": {
		"language": 4164
	},
	"mfv": {
		"language": 4165
	},
	"mfw": {
		"language": 4166
	},
	"mfx": {
		"language": 4167
	},
	"mfy": {
		"language": 4168
	},
	"mfz": {
		"language": 4169
	},
	"mga": {
		"language": 4170
	},
	"mgb": {
		"language": 4171
	},
	"mgc": {
		"language": 4172
	},
	"mgd": {
		"language": 4173
	},
	"mge": {
		"language": 4174
	},
	"mgf": {
		"language": 4175
	},
	"mgg": {
		"language": 4176
	},
	"mgh": {
		"language": 4177
	},
	"mgi": {
		"language": 4178
	},
	"mgj": {
		"language": 4179
	},
	"mgk": {
		"language": 4180
	},
	"mgl": {
		"language": 4181
	},
	"mgm": {
		"language": 4182
	},
	"mgn": {
		"language": 4183
	},
	"mgo": {
		"language": 4184
	},
	"mgp": {
		"language": 4185
	},
	"mgq": {
		"language": 4186
	},
	"mgr": {
		"language": 4187
	},
	"mgs": {
		"language": 4188
	},
	"mgt": {
		"language": 4189
	},
	"mgu": {
		"language": 4190
	},
	"mgv": {
		"language": 4191
	},
	"mgw": {
		"language": 4192
	},
	"mgx": {
		"language": 4193
	},
	"mgy": {
		"language": 4194
	},
	"mgz": {
		"language": 4195
	},
	"mha": {
		"language": 4196
	},
	"mhb": {
		"language": 4197
	},
	"mhc": {
		"language": 4198
	},
	"mhd": {
		"language": 4199
	},
	"mhe": {
		"language": 4200
	},
	"mhf": {
		"language": 4201
	},
	"mhg": {
		"language": 4202
	},
	"mhh": {
		"language": 4203
	},
	"mhi": {
		"language": 4204
	},
	"mhj": {
		"language": 4205
	},
	"mhk": {
		"language": 4206
	},
	"mhl": {
		"language": 4207
	},
	"mhm": {
		"language": 4208
	},
	"mhn": {
		"language": 4209
	},
	"mho": {
		"language": 4210
	},
	"mhp": {
		"language": 4211
	},
	"mhq": {
		"language": 4212
	},
	"mhr": {
		"language": 4213
	},
	"mhs": {
		"language": 4214
	},
	"mht": {
		"language": 4215
	},
	"mhu": {
		"language": 4216
	},
	"mhw": {
		"language": 4217
	},
	"mhx": {
		"language": 4218
	},
	"mhy": {
		"language": 4219
	},
	"mhz": {
		"language": 4220
	},
	"mia": {
		"language": 4221
	},
	"mib": {
		"language": 4222
	},
	"mic": {
		"language": 4223
	},
	"mid": {
		"language": 4224
	},
	"mie": {
		"language": 4225
	},
	"mif": {
		"language": 4226
	},
	"mig": {
		"language": 4227
	},
	"mih": {
		"language": 4228
	},
	"mii": {
		"language": 4229
	},
	"mij": {
		"language": 4230
	},
	"mik": {
		"language": 4231
	},
	"mil": {
		"language": 4232
	},
	"mim": {
		"language": 4233
	},
	"min": {
		"language": 4234,
		"extlang": 8264
	},
	"mio": {
		"language": 4235
	},
	"mip": {
		"language": 4236
	},
	"miq": {
		"language": 4237
	},
	"mir": {
		"language": 4238
	},
	"mis": {
		"language": 4239
	},
	"mit": {
		"language": 4240
	},
	"miu": {
		"language": 4241
	},
	"miw": {
		"language": 4242
	},
	"mix": {
		"language": 4243
	},
	"miy": {
		"language": 4244
	},
	"miz": {
		"language": 4245
	},
	"mja": {
		"language": 4246
	},
	"mjb": {
		"language": 4247
	},
	"mjc": {
		"language": 4248
	},
	"mjd": {
		"language": 4249
	},
	"mje": {
		"language": 4250
	},
	"mjg": {
		"language": 4251
	},
	"mjh": {
		"language": 4252
	},
	"mji": {
		"language": 4253
	},
	"mjj": {
		"language": 4254
	},
	"mjk": {
		"language": 4255
	},
	"mjl": {
		"language": 4256
	},
	"mjm": {
		"language": 4257
	},
	"mjn": {
		"language": 4258
	},
	"mjo": {
		"language": 4259
	},
	"mjp": {
		"language": 4260
	},
	"mjq": {
		"language": 4261
	},
	"mjr": {
		"language": 4262
	},
	"mjs": {
		"language": 4263
	},
	"mjt": {
		"language": 4264
	},
	"mju": {
		"language": 4265
	},
	"mjv": {
		"language": 4266
	},
	"mjw": {
		"language": 4267
	},
	"mjx": {
		"language": 4268
	},
	"mjy": {
		"language": 4269
	},
	"mjz": {
		"language": 4270
	},
	"mka": {
		"language": 4271
	},
	"mkb": {
		"language": 4272
	},
	"mkc": {
		"language": 4273
	},
	"mke": {
		"language": 4274
	},
	"mkf": {
		"language": 4275
	},
	"mkg": {
		"language": 4276
	},
	"mkh": {
		"language": 4277
	},
	"mki": {
		"language": 4278
	},
	"mkj": {
		"language": 4279
	},
	"mkk": {
		"language": 4280
	},
	"mkl": {
		"language": 4281
	},
	"mkm": {
		"language": 4282
	},
	"mkn": {
		"language": 4283
	},
	"mko": {
		"language": 4284
	},
	"mkp": {
		"language": 4285
	},
	"mkq": {
		"language": 4286
	},
	"mkr": {
		"language": 4287
	},
	"mks": {
		"language": 4288
	},
	"mkt": {
		"language": 4289
	},
	"mku": {
		"language": 4290
	},
	"mkv": {
		"language": 4291
	},
	"mkw": {
		"language": 4292
	},
	"mkx": {
		"language": 4293
	},
	"mky": {
		"language": 4294
	},
	"mkz": {
		"language": 4295
	},
	"mla": {
		"language": 4296
	},
	"mlb": {
		"language": 4297
	},
	"mlc": {
		"language": 4298
	},
	"mld": {
		"language": 4299
	},
	"mle": {
		"language": 4300
	},
	"mlf": {
		"language": 4301
	},
	"mlh": {
		"language": 4302
	},
	"mli": {
		"language": 4303
	},
	"mlj": {
		"language": 4304
	},
	"mlk": {
		"language": 4305
	},
	"mll": {
		"language": 4306
	},
	"mlm": {
		"language": 4307
	},
	"mln": {
		"language": 4308
	},
	"mlo": {
		"language": 4309
	},
	"mlp": {
		"language": 4310
	},
	"mlq": {
		"language": 4311
	},
	"mlr": {
		"language": 4312
	},
	"mls": {
		"language": 4313
	},
	"mlu": {
		"language": 4314
	},
	"mlv": {
		"language": 4315
	},
	"mlw": {
		"language": 4316
	},
	"mlx": {
		"language": 4317
	},
	"mlz": {
		"language": 4318
	},
	"mma": {
		"language": 4319
	},
	"mmb": {
		"language": 4320
	},
	"mmc": {
		"language": 4321
	},
	"mmd": {
		"language": 4322
	},
	"mme": {
		"language": 4323
	},
	"mmf": {
		"language": 4324
	},
	"mmg": {
		"language": 4325
	},
	"mmh": {
		"language": 4326
	},
	"mmi": {
		"language": 4327
	},
	"mmj": {
		"language": 4328
	},
	"mmk": {
		"language": 4329
	},
	"mml": {
		"language": 4330
	},
	"mmm": {
		"language": 4331
	},
	"mmn": {
		"language": 4332
	},
	"mmo": {
		"language": 4333
	},
	"mmp": {
		"language": 4334
	},
	"mmq": {
		"language": 4335
	},
	"mmr": {
		"language": 4336
	},
	"mmt": {
		"language": 4337
	},
	"mmu": {
		"language": 4338
	},
	"mmv": {
		"language": 4339
	},
	"mmw": {
		"language": 4340
	},
	"mmx": {
		"language": 4341
	},
	"mmy": {
		"language": 4342
	},
	"mmz": {
		"language": 4343
	},
	"mna": {
		"language": 4344
	},
	"mnb": {
		"language": 4345
	},
	"mnc": {
		"language": 4346
	},
	"mnd": {
		"language": 4347
	},
	"mne": {
		"language": 4348
	},
	"mnf": {
		"language": 4349
	},
	"mng": {
		"language": 4350
	},
	"mnh": {
		"language": 4351
	},
	"mni": {
		"language": 4352
	},
	"mnj": {
		"language": 4353
	},
	"mnk": {
		"language": 4354
	},
	"mnl": {
		"language": 4355
	},
	"mnm": {
		"language": 4356
	},
	"mnn": {
		"language": 4357
	},
	"mno": {
		"language": 4358
	},
	"mnp": {
		"language": 4359,
		"extlang": 8265
	},
	"mnq": {
		"language": 4360
	},
	"mnr": {
		"language": 4361
	},
	"mns": {
		"language": 4362
	},
	"mnt": {
		"language": 4363
	},
	"mnu": {
		"language": 4364
	},
	"mnv": {
		"language": 4365
	},
	"mnw": {
		"language": 4366
	},
	"mnx": {
		"language": 4367
	},
	"mny": {
		"language": 4368
	},
	"mnz": {
		"language": 4369
	},
	"moa": {
		"language": 4370
	},
	"moc": {
		"language": 4371
	},
	"mod": {
		"language": 4372
	},
	"moe": {
		"language": 4373
	},
	"mof": {
		"language": 4374
	},
	"mog": {
		"language": 4375
	},
	"moh": {
		"language": 4376
	},
	"moi": {
		"language": 4377
	},
	"moj": {
		"language": 4378
	},
	"mok": {
		"language": 4379
	},
	"mom": {
		"language": 4380
	},
	"moo": {
		"language": 4381
	},
	"mop": {
		"language": 4382
	},
	"moq": {
		"language": 4383
	},
	"mor": {
		"language": 4384
	},
	"mos": {
		"language": 4385
	},
	"mot": {
		"language": 4386
	},
	"mou": {
		"language": 4387
	},
	"mov": {
		"language": 4388
	},
	"mow": {
		"language": 4389
	},
	"mox": {
		"language": 4390
	},
	"moy": {
		"language": 4391
	},
	"moz": {
		"language": 4392
	},
	"mpa": {
		"language": 4393
	},
	"mpb": {
		"language": 4394
	},
	"mpc": {
		"language": 4395
	},
	"mpd": {
		"language": 4396
	},
	"mpe": {
		"language": 4397
	},
	"mpg": {
		"language": 4398
	},
	"mph": {
		"language": 4399
	},
	"mpi": {
		"language": 4400
	},
	"mpj": {
		"language": 4401
	},
	"mpk": {
		"language": 4402
	},
	"mpl": {
		"language": 4403
	},
	"mpm": {
		"language": 4404
	},
	"mpn": {
		"language": 4405
	},
	"mpo": {
		"language": 4406
	},
	"mpp": {
		"language": 4407
	},
	"mpq": {
		"language": 4408
	},
	"mpr": {
		"language": 4409
	},
	"mps": {
		"language": 4410
	},
	"mpt": {
		"language": 4411
	},
	"mpu": {
		"language": 4412
	},
	"mpv": {
		"language": 4413
	},
	"mpw": {
		"language": 4414
	},
	"mpx": {
		"language": 4415
	},
	"mpy": {
		"language": 4416
	},
	"mpz": {
		"language": 4417
	},
	"mqa": {
		"language": 4418
	},
	"mqb": {
		"language": 4419
	},
	"mqc": {
		"language": 4420
	},
	"mqe": {
		"language": 4421
	},
	"mqf": {
		"language": 4422
	},
	"mqg": {
		"language": 4423,
		"extlang": 8266
	},
	"mqh": {
		"language": 4424
	},
	"mqi": {
		"language": 4425
	},
	"mqj": {
		"language": 4426
	},
	"mqk": {
		"language": 4427
	},
	"mql": {
		"language": 4428
	},
	"mqm": {
		"language": 4429
	},
	"mqn": {
		"language": 4430
	},
	"mqo": {
		"language": 4431
	},
	"mqp": {
		"language": 4432
	},
	"mqq": {
		"language": 4433
	},
	"mqr": {
		"language": 4434
	},
	"mqs": {
		"language": 4435
	},
	"mqt": {
		"language": 4436
	},
	"mqu": {
		"language": 4437
	},
	"mqv": {
		"language": 4438
	},
	"mqw": {
		"language": 4439
	},
	"mqx": {
		"language": 4440
	},
	"mqy": {
		"language": 4441
	},
	"mqz": {
		"language": 4442
	},
	"mra": {
		"language": 4443
	},
	"mrb": {
		"language": 4444
	},
	"mrc": {
		"language": 4445
	},
	"mrd": {
		"language": 4446
	},
	"mre": {
		"language": 4447,
		"extlang": 8267
	},
	"mrf": {
		"language": 4448
	},
	"mrg": {
		"language": 4449
	},
	"mrh": {
		"language": 4450
	},
	"mrj": {
		"language": 4451
	},
	"mrk": {
		"language": 4452
	},
	"mrl": {
		"language": 4453
	},
	"mrm": {
		"language": 4454
	},
	"mrn": {
		"language": 4455
	},
	"mro": {
		"language": 4456
	},
	"mrp": {
		"language": 4457
	},
	"mrq": {
		"language": 4458
	},
	"mrr": {
		"language": 4459
	},
	"mrs": {
		"language": 4460
	},
	"mrt": {
		"language": 4461
	},
	"mru": {
		"language": 4462
	},
	"mrv": {
		"language": 4463
	},
	"mrw": {
		"language": 4464
	},
	"mrx": {
		"language": 4465
	},
	"mry": {
		"language": 4466
	},
	"mrz": {
		"language": 4467
	},
	"msb": {
		"language": 4468
	},
	"msc": {
		"language": 4469
	},
	"msd": {
		"language": 4470,
		"extlang": 8268
	},
	"mse": {
		"language": 4471
	},
	"msf": {
		"language": 4472
	},
	"msg": {
		"language": 4473
	},
	"msh": {
		"language": 4474
	},
	"msi": {
		"language": 4475,
		"extlang": 8269
	},
	"msj": {
		"language": 4476
	},
	"msk": {
		"language": 4477
	},
	"msl": {
		"language": 4478
	},
	"msm": {
		"language": 4479
	},
	"msn": {
		"language": 4480
	},
	"mso": {
		"language": 4481
	},
	"msp": {
		"language": 4482
	},
	"msq": {
		"language": 4483
	},
	"msr": {
		"language": 4484,
		"extlang": 8270
	},
	"mss": {
		"language": 4485
	},
	"mst": {
		"language": 4486
	},
	"msu": {
		"language": 4487
	},
	"msv": {
		"language": 4488
	},
	"msw": {
		"language": 4489
	},
	"msx": {
		"language": 4490
	},
	"msy": {
		"language": 4491
	},
	"msz": {
		"language": 4492
	},
	"mta": {
		"language": 4493
	},
	"mtb": {
		"language": 4494
	},
	"mtc": {
		"language": 4495
	},
	"mtd": {
		"language": 4496
	},
	"mte": {
		"language": 4497
	},
	"mtf": {
		"language": 4498
	},
	"mtg": {
		"language": 4499
	},
	"mth": {
		"language": 4500
	},
	"mti": {
		"language": 4501
	},
	"mtj": {
		"language": 4502
	},
	"mtk": {
		"language": 4503
	},
	"mtl": {
		"language": 4504
	},
	"mtm": {
		"language": 4505
	},
	"mtn": {
		"language": 4506
	},
	"mto": {
		"language": 4507
	},
	"mtp": {
		"language": 4508
	},
	"mtq": {
		"language": 4509
	},
	"mtr": {
		"language": 4510
	},
	"mts": {
		"language": 4511
	},
	"mtt": {
		"language": 4512
	},
	"mtu": {
		"language": 4513
	},
	"mtv": {
		"language": 4514
	},
	"mtw": {
		"language": 4515
	},
	"mtx": {
		"language": 4516
	},
	"mty": {
		"language": 4517
	},
	"mua": {
		"language": 4518
	},
	"mub": {
		"language": 4519
	},
	"muc": {
		"language": 4520
	},
	"mud": {
		"language": 4521
	},
	"mue": {
		"language": 4522
	},
	"mug": {
		"language": 4523
	},
	"muh": {
		"language": 4524
	},
	"mui": {
		"language": 4525,
		"extlang": 8271
	},
	"muj": {
		"language": 4526
	},
	"muk": {
		"language": 4527
	},
	"mul": {
		"language": 4528
	},
	"mum": {
		"language": 4529
	},
	"mun": {
		"language": 4530
	},
	"muo": {
		"language": 4531
	},
	"mup": {
		"language": 4532
	},
	"muq": {
		"language": 4533
	},
	"mur": {
		"language": 4534
	},
	"mus": {
		"language": 4535
	},
	"mut": {
		"language": 4536
	},
	"muu": {
		"language": 4537
	},
	"muv": {
		"language": 4538
	},
	"mux": {
		"language": 4539
	},
	"muy": {
		"language": 4540
	},
	"muz": {
		"language": 4541
	},
	"mva": {
		"language": 4542
	},
	"mvb": {
		"language": 4543
	},
	"mvd": {
		"language": 4544
	},
	"mve": {
		"language": 4545
	},
	"mvf": {
		"language": 4546
	},
	"mvg": {
		"language": 4547
	},
	"mvh": {
		"language": 4548
	},
	"mvi": {
		"language": 4549
	},
	"mvk": {
		"language": 4550
	},
	"mvl": {
		"language": 4551
	},
	"mvm": {
		"language": 4552
	},
	"mvn": {
		"language": 4553
	},
	"mvo": {
		"language": 4554
	},
	"mvp": {
		"language": 4555
	},
	"mvq": {
		"language": 4556
	},
	"mvr": {
		"language": 4557
	},
	"mvs": {
		"language": 4558
	},
	"mvt": {
		"language": 4559
	},
	"mvu": {
		"language": 4560
	},
	"mvv": {
		"language": 4561
	},
	"mvw": {
		"language": 4562
	},
	"mvx": {
		"language": 4563
	},
	"mvy": {
		"language": 4564
	},
	"mvz": {
		"language": 4565
	},
	"mwa": {
		"language": 4566
	},
	"mwb": {
		"language": 4567
	},
	"mwc": {
		"language": 4568
	},
	"mwd": {
		"language": 4569
	},
	"mwe": {
		"language": 4570
	},
	"mwf": {
		"language": 4571
	},
	"mwg": {
		"language": 4572
	},
	"mwh": {
		"language": 4573
	},
	"mwi": {
		"language": 4574
	},
	"mwj": {
		"language": 4575
	},
	"mwk": {
		"language": 4576
	},
	"mwl": {
		"language": 4577
	},
	"mwm": {
		"language": 4578
	},
	"mwn": {
		"language": 4579
	},
	"mwo": {
		"language": 4580
	},
	"mwp": {
		"language": 4581
	},
	"mwq": {
		"language": 4582
	},
	"mwr": {
		"language": 4583
	},
	"mws": {
		"language": 4584
	},
	"mwt": {
		"language": 4585
	},
	"mwu": {
		"language": 4586
	},
	"mwv": {
		"language": 4587
	},
	"mww": {
		"language": 4588
	},
	"mwx": {
		"language": 4589
	},
	"mwy": {
		"language": 4590
	},
	"mwz": {
		"language": 4591
	},
	"mxa": {
		"language": 4592
	},
	"mxb": {
		"language": 4593
	},
	"mxc": {
		"language": 4594
	},
	"mxd": {
		"language": 4595
	},
	"mxe": {
		"language": 4596
	},
	"mxf": {
		"language": 4597
	},
	"mxg": {
		"language": 4598
	},
	"mxh": {
		"language": 4599
	},
	"mxi": {
		"language": 4600
	},
	"mxj": {
		"language": 4601
	},
	"mxk": {
		"language": 4602
	},
	"mxl": {
		"language": 4603
	},
	"mxm": {
		"language": 4604
	},
	"mxn": {
		"language": 4605
	},
	"mxo": {
		"language": 4606
	},
	"mxp": {
		"language": 4607
	},
	"mxq": {
		"language": 4608
	},
	"mxr": {
		"language": 4609
	},
	"mxs": {
		"language": 4610
	},
	"mxt": {
		"language": 4611
	},
	"mxu": {
		"language": 4612
	},
	"mxv": {
		"language": 4613
	},
	"mxw": {
		"language": 4614
	},
	"mxx": {
		"language": 4615
	},
	"mxy": {
		"language": 4616
	},
	"mxz": {
		"language": 4617
	},
	"myb": {
		"language": 4618
	},
	"myc": {
		"language": 4619
	},
	"myd": {
		"language": 4620
	},
	"mye": {
		"language": 4621
	},
	"myf": {
		"language": 4622
	},
	"myg": {
		"language": 4623
	},
	"myh": {
		"language": 4624
	},
	"myi": {
		"language": 4625
	},
	"myj": {
		"language": 4626
	},
	"myk": {
		"language": 4627
	},
	"myl": {
		"language": 4628
	},
	"mym": {
		"language": 4629
	},
	"myn": {
		"language": 4630
	},
	"myo": {
		"language": 4631
	},
	"myp": {
		"language": 4632
	},
	"myq": {
		"language": 4633
	},
	"myr": {
		"language": 4634
	},
	"mys": {
		"language": 4635
	},
	"myt": {
		"language": 4636
	},
	"myu": {
		"language": 4637
	},
	"myv": {
		"language": 4638
	},
	"myw": {
		"language": 4639
	},
	"myx": {
		"language": 4640
	},
	"myy": {
		"language": 4641
	},
	"myz": {
		"language": 4642
	},
	"mza": {
		"language": 4643
	},
	"mzb": {
		"language": 4644
	},
	"mzc": {
		"language": 4645,
		"extlang": 8272
	},
	"mzd": {
		"language": 4646
	},
	"mze": {
		"language": 4647
	},
	"mzg": {
		"language": 4648,
		"extlang": 8273
	},
	"mzh": {
		"language": 4649
	},
	"mzi": {
		"language": 4650
	},
	"mzj": {
		"language": 4651
	},
	"mzk": {
		"language": 4652
	},
	"mzl": {
		"language": 4653
	},
	"mzm": {
		"language": 4654
	},
	"mzn": {
		"language": 4655
	},
	"mzo": {
		"language": 4656
	},
	"mzp": {
		"language": 4657
	},
	"mzq": {
		"language": 4658
	},
	"mzr": {
		"language": 4659
	},
	"mzs": {
		"language": 4660
	},
	"mzt": {
		"language": 4661
	},
	"mzu": {
		"language": 4662
	},
	"mzv": {
		"language": 4663
	},
	"mzw": {
		"language": 4664
	},
	"mzx": {
		"language": 4665
	},
	"mzy": {
		"language": 4666,
		"extlang": 8274
	},
	"mzz": {
		"language": 4667
	},
	"naa": {
		"language": 4668
	},
	"nab": {
		"language": 4669
	},
	"nac": {
		"language": 4670
	},
	"nad": {
		"language": 4671
	},
	"nae": {
		"language": 4672
	},
	"naf": {
		"language": 4673
	},
	"nag": {
		"language": 4674
	},
	"nah": {
		"language": 4675
	},
	"nai": {
		"language": 4676
	},
	"naj": {
		"language": 4677
	},
	"nak": {
		"language": 4678
	},
	"nal": {
		"language": 4679
	},
	"nam": {
		"language": 4680
	},
	"nan": {
		"language": 4681,
		"extlang": 8275
	},
	"nao": {
		"language": 4682
	},
	"nap": {
		"language": 4683
	},
	"naq": {
		"language": 4684
	},
	"nar": {
		"language": 4685
	},
	"nas": {
		"language": 4686
	},
	"nat": {
		"language": 4687
	},
	"naw": {
		"language": 4688
	},
	"nax": {
		"language": 4689
	},
	"nay": {
		"language": 4690
	},
	"naz": {
		"language": 4691
	},
	"nba": {
		"language": 4692
	},
	"nbb": {
		"language": 4693
	},
	"nbc": {
		"language": 4694
	},
	"nbd": {
		"language": 4695
	},
	"nbe": {
		"language": 4696
	},
	"nbf": {
		"language": 4697
	},
	"nbg": {
		"language": 4698
	},
	"nbh": {
		"language": 4699
	},
	"nbi": {
		"language": 4700
	},
	"nbj": {
		"language": 4701
	},
	"nbk": {
		"language": 4702
	},
	"nbm": {
		"language": 4703
	},
	"nbn": {
		"language": 4704
	},
	"nbo": {
		"language": 4705
	},
	"nbp": {
		"language": 4706
	},
	"nbq": {
		"language": 4707
	},
	"nbr": {
		"language": 4708
	},
	"nbs": {
		"language": 4709,
		"extlang": 8276
	},
	"nbt": {
		"language": 4710
	},
	"nbu": {
		"language": 4711
	},
	"nbv": {
		"language": 4712
	},
	"nbw": {
		"language": 4713
	},
	"nbx": {
		"language": 4714
	},
	"nby": {
		"language": 4715
	},
	"nca": {
		"language": 4716
	},
	"ncb": {
		"language": 4717
	},
	"ncc": {
		"language": 4718
	},
	"ncd": {
		"language": 4719
	},
	"nce": {
		"language": 4720
	},
	"ncf": {
		"language": 4721
	},
	"ncg": {
		"language": 4722
	},
	"nch": {
		"language": 4723
	},
	"nci": {
		"language": 4724
	},
	"ncj": {
		"language": 4725
	},
	"nck": {
		"language": 4726
	},
	"ncl": {
		"language": 4727
	},
	"ncm": {
		"language": 4728
	},
	"ncn": {
		"language": 4729
	},
	"nco": {
		"language": 4730
	},
	"ncp": {
		"language": 4731
	},
	"ncq": {
		"language": 4732
	},
	"ncr": {
		"language": 4733
	},
	"ncs": {
		"language": 4734,
		"extlang": 8277
	},
	"nct": {
		"language": 4735
	},
	"ncu": {
		"language": 4736
	},
	"ncx": {
		"language": 4737
	},
	"ncz": {
		"language": 4738
	},
	"nda": {
		"language": 4739
	},
	"ndb": {
		"language": 4740
	},
	"ndc": {
		"language": 4741
	},
	"ndd": {
		"language": 4742
	},
	"ndf": {
		"language": 4743
	},
	"ndg": {
		"language": 4744
	},
	"ndh": {
		"language": 4745
	},
	"ndi": {
		"language": 4746
	},
	"ndj": {
		"language": 4747
	},
	"ndk": {
		"language": 4748
	},
	"ndl": {
		"language": 4749
	},
	"ndm": {
		"language": 4750
	},
	"ndn": {
		"language": 4751
	},
	"ndp": {
		"language": 4752
	},
	"ndq": {
		"language": 4753
	},
	"ndr": {
		"language": 4754
	},
	"nds": {
		"language": 4755
	},
	"ndt": {
		"language": 4756
	},
	"ndu": {
		"language": 4757
	},
	"ndv": {
		"language": 4758
	},
	"ndw": {
		"language": 4759
	},
	"ndx": {
		"language": 4760
	},
	"ndy": {
		"language": 4761
	},
	"ndz": {
		"language": 4762
	},
	"nea": {
		"language": 4763
	},
	"neb": {
		"language": 4764
	},
	"nec": {
		"language": 4765
	},
	"ned": {
		"language": 4766
	},
	"nee": {
		"language": 4767
	},
	"nef": {
		"language": 4768
	},
	"neg": {
		"language": 4769
	},
	"neh": {
		"language": 4770
	},
	"nei": {
		"language": 4771
	},
	"nej": {
		"language": 4772
	},
	"nek": {
		"language": 4773
	},
	"nem": {
		"language": 4774
	},
	"nen": {
		"language": 4775
	},
	"neo": {
		"language": 4776
	},
	"neq": {
		"language": 4777
	},
	"ner": {
		"language": 4778
	},
	"nes": {
		"language": 4779
	},
	"net": {
		"language": 4780
	},
	"neu": {
		"language": 4781
	},
	"nev": {
		"language": 4782
	},
	"new": {
		"language": 4783
	},
	"nex": {
		"language": 4784
	},
	"ney": {
		"language": 4785
	},
	"nez": {
		"language": 4786
	},
	"nfa": {
		"language": 4787
	},
	"nfd": {
		"language": 4788
	},
	"nfl": {
		"language": 4789
	},
	"nfr": {
		"language": 4790
	},
	"nfu": {
		"language": 4791
	},
	"nga": {
		"language": 4792
	},
	"ngb": {
		"language": 4793
	},
	"ngc": {
		"language": 4794
	},
	"ngd": {
		"language": 4795
	},
	"nge": {
		"language": 4796
	},
	"ngf": {
		"language": 4797
	},
	"ngg": {
		"language": 4798
	},
	"ngh": {
		"language": 4799
	},
	"ngi": {
		"language": 4800
	},
	"ngj": {
		"language": 4801
	},
	"ngk": {
		"language": 4802
	},
	"ngl": {
		"language": 4803
	},
	"ngm": {
		"language": 4804
	},
	"ngn": {
		"language": 4805
	},
	"ngo": {
		"language": 4806
	},
	"ngp": {
		"language": 4807
	},
	"ngq": {
		"language": 4808
	},
	"ngr": {
		"language": 4809
	},
	"ngs": {
		"language": 4810
	},
	"ngt": {
		"language": 4811
	},
	"ngu": {
		"language": 4812
	},
	"ngv": {
		"language": 4813
	},
	"ngw": {
		"language": 4814
	},
	"ngx": {
		"language": 4815
	},
	"ngy": {
		"language": 4816
	},
	"ngz": {
		"language": 4817
	},
	"nha": {
		"language": 4818
	},
	"nhb": {
		"language": 4819
	},
	"nhc": {
		"language": 4820
	},
	"nhd": {
		"language": 4821
	},
	"nhe": {
		"language": 4822
	},
	"nhf": {
		"language": 4823
	},
	"nhg": {
		"language": 4824
	},
	"nhh": {
		"language": 4825
	},
	"nhi": {
		"language": 4826
	},
	"nhk": {
		"language": 4827
	},
	"nhm": {
		"language": 4828
	},
	"nhn": {
		"language": 4829
	},
	"nho": {
		"language": 4830
	},
	"nhp": {
		"language": 4831
	},
	"nhq": {
		"language": 4832
	},
	"nhr": {
		"language": 4833
	},
	"nht": {
		"language": 4834
	},
	"nhu": {
		"language": 4835
	},
	"nhv": {
		"language": 4836
	},
	"nhw": {
		"language": 4837
	},
	"nhx": {
		"language": 4838
	},
	"nhy": {
		"language": 4839
	},
	"nhz": {
		"language": 4840
	},
	"nia": {
		"language": 4841
	},
	"nib": {
		"language": 4842
	},
	"nic": {
		"language": 4843
	},
	"nid": {
		"language": 4844
	},
	"nie": {
		"language": 4845
	},
	"nif": {
		"language": 4846
	},
	"nig": {
		"language": 4847
	},
	"nih": {
		"language": 4848
	},
	"nii": {
		"language": 4849
	},
	"nij": {
		"language": 4850
	},
	"nik": {
		"language": 4851
	},
	"nil": {
		"language": 4852
	},
	"nim": {
		"language": 4853
	},
	"nin": {
		"language": 4854
	},
	"nio": {
		"language": 4855
	},
	"niq": {
		"language": 4856
	},
	"nir": {
		"language": 4857
	},
	"nis": {
		"language": 4858
	},
	"nit": {
		"language": 4859
	},
	"niu": {
		"language": 4860
	},
	"niv": {
		"language": 4861
	},
	"niw": {
		"language": 4862
	},
	"nix": {
		"language": 4863
	},
	"niy": {
		"language": 4864
	},
	"niz": {
		"language": 4865
	},
	"nja": {
		"language": 4866
	},
	"njb": {
		"language": 4867
	},
	"njd": {
		"language": 4868
	},
	"njh": {
		"language": 4869
	},
	"nji": {
		"language": 4870
	},
	"njj": {
		"language": 4871
	},
	"njl": {
		"language": 4872
	},
	"njm": {
		"language": 4873
	},
	"njn": {
		"language": 4874
	},
	"njo": {
		"language": 4875
	},
	"njr": {
		"language": 4876
	},
	"njs": {
		"language": 4877
	},
	"njt": {
		"language": 4878
	},
	"nju": {
		"language": 4879
	},
	"njx": {
		"language": 4880
	},
	"njy": {
		"language": 4881
	},
	"njz": {
		"language": 4882
	},
	"nka": {
		"language": 4883
	},
	"nkb": {
		"language": 4884
	},
	"nkc": {
		"language": 4885
	},
	"nkd": {
		"language": 4886
	},
	"nke": {
		"language": 4887
	},
	"nkf": {
		"language": 4888
	},
	"nkg": {
		"language": 4889
	},
	"nkh": {
		"language": 4890
	},
	"nki": {
		"language": 4891
	},
	"nkj": {
		"language": 4892
	},
	"nkk": {
		"language": 4893
	},
	"nkm": {
		"language": 4894
	},
	"nkn": {
		"language": 4895
	},
	"nko": {
		"language": 4896
	},
	"nkp": {
		"language": 4897
	},
	"nkq": {
		"language": 4898
	},
	"nkr": {
		"language": 4899
	},
	"nks": {
		"language": 4900
	},
	"nkt": {
		"language": 4901
	},
	"nku": {
		"language": 4902
	},
	"nkv": {
		"language": 4903
	},
	"nkw": {
		"language": 4904
	},
	"nkx": {
		"language": 4905
	},
	"nkz": {
		"language": 4906
	},
	"nla": {
		"language": 4907
	},
	"nlc": {
		"language": 4908
	},
	"nle": {
		"language": 4909
	},
	"nlg": {
		"language": 4910
	},
	"nli": {
		"language": 4911
	},
	"nlj": {
		"language": 4912
	},
	"nlk": {
		"language": 4913
	},
	"nll": {
		"language": 4914
	},
	"nln": {
		"language": 4915
	},
	"nlo": {
		"language": 4916
	},
	"nlq": {
		"language": 4917
	},
	"nlr": {
		"language": 4918
	},
	"nlu": {
		"language": 4919
	},
	"nlv": {
		"language": 4920
	},
	"nlw": {
		"language": 4921
	},
	"nlx": {
		"language": 4922
	},
	"nly": {
		"language": 4923
	},
	"nlz": {
		"language": 4924
	},
	"nma": {
		"language": 4925
	},
	"nmb": {
		"language": 4926
	},
	"nmc": {
		"language": 4927
	},
	"nmd": {
		"language": 4928
	},
	"nme": {
		"language": 4929
	},
	"nmf": {
		"language": 4930
	},
	"nmg": {
		"language": 4931
	},
	"nmh": {
		"language": 4932
	},
	"nmi": {
		"language": 4933
	},
	"nmj": {
		"language": 4934
	},
	"nmk": {
		"language": 4935
	},
	"nml": {
		"language": 4936
	},
	"nmm": {
		"language": 4937
	},
	"nmn": {
		"language": 4938
	},
	"nmo": {
		"language": 4939
	},
	"nmp": {
		"language": 4940
	},
	"nmq": {
		"language": 4941
	},
	"nmr": {
		"language": 4942
	},
	"nms": {
		"language": 4943
	},
	"nmt": {
		"language": 4944
	},
	"nmu": {
		"language": 4945
	},
	"nmv": {
		"language": 4946
	},
	"nmw": {
		"language": 4947
	},
	"nmx": {
		"language": 4948
	},
	"nmy": {
		"language": 4949
	},
	"nmz": {
		"language": 4950
	},
	"nna": {
		"language": 4951
	},
	"nnb": {
		"language": 4952
	},
	"nnc": {
		"language": 4953
	},
	"nnd": {
		"language": 4954
	},
	"nne": {
		"language": 4955
	},
	"nnf": {
		"language": 4956
	},
	"nng": {
		"language": 4957
	},
	"nnh": {
		"language": 4958
	},
	"nni": {
		"language": 4959
	},
	"nnj": {
		"language": 4960
	},
	"nnk": {
		"language": 4961
	},
	"nnl": {
		"language": 4962
	},
	"nnm": {
		"language": 4963
	},
	"nnn": {
		"language": 4964
	},
	"nnp": {
		"language": 4965
	},
	"nnq": {
		"language": 4966
	},
	"nnr": {
		"language": 4967
	},
	"nns": {
		"language": 4968
	},
	"nnt": {
		"language": 4969
	},
	"nnu": {
		"language": 4970
	},
	"nnv": {
		"language": 4971
	},
	"nnw": {
		"language": 4972
	},
	"nnx": {
		"language": 4973
	},
	"nny": {
		"language": 4974
	},
	"nnz": {
		"language": 4975
	},
	"noa": {
		"language": 4976
	},
	"noc": {
		"language": 4977
	},
	"nod": {
		"language": 4978
	},
	"noe": {
		"language": 4979
	},
	"nof": {
		"language": 4980
	},
	"nog": {
		"language": 4981
	},
	"noh": {
		"language": 4982
	},
	"noi": {
		"language": 4983
	},
	"noj": {
		"language": 4984
	},
	"nok": {
		"language": 4985
	},
	"nol": {
		"language": 4986
	},
	"nom": {
		"language": 4987
	},
	"non": {
		"language": 4988
	},
	"noo": {
		"language": 4989
	},
	"nop": {
		"language": 4990
	},
	"noq": {
		"language": 4991
	},
	"nos": {
		"language": 4992
	},
	"not": {
		"language": 4993
	},
	"nou": {
		"language": 4994
	},
	"nov": {
		"language": 4995
	},
	"now": {
		"language": 4996
	},
	"noy": {
		"language": 4997
	},
	"noz": {
		"language": 4998
	},
	"npa": {
		"language": 4999
	},
	"npb": {
		"language": 5000
	},
	"npg": {
		"language": 5001
	},
	"nph": {
		"language": 5002
	},
	"npi": {
		"language": 5003
	},
	"npl": {
		"language": 5004
	},
	"npn": {
		"language": 5005
	},
	"npo": {
		"language": 5006
	},
	"nps": {
		"language": 5007
	},
	"npu": {
		"language": 5008
	},
	"npx": {
		"language": 5009
	},
	"npy": {
		"language": 5010
	},
	"nqg": {
		"language": 5011
	},
	"nqk": {
		"language": 5012
	},
	"nql": {
		"language": 5013
	},
	"nqm": {
		"language": 5014
	},
	"nqn": {
		"language": 5015
	},
	"nqo": {
		"language": 5016
	},
	"nqq": {
		"language": 5017
	},
	"nqy": {
		"language": 5018
	},
	"nra": {
		"language": 5019
	},
	"nrb": {
		"language": 5020
	},
	"nrc": {
		"language": 5021
	},
	"nre": {
		"language": 5022
	},
	"nrf": {
		"language": 5023
	},
	"nrg": {
		"language": 5024
	},
	"nri": {
		"language": 5025
	},
	"nrk": {
		"language": 5026
	},
	"nrl": {
		"language": 5027
	},
	"nrm": {
		"language": 5028
	},
	"nrn": {
		"language": 5029
	},
	"nrp": {
		"language": 5030
	},
	"nrr": {
		"language": 5031
	},
	"nrt": {
		"language": 5032
	},
	"nru": {
		"language": 5033
	},
	"nrx": {
		"language": 5034
	},
	"nrz": {
		"language": 5035
	},
	"nsa": {
		"language": 5036
	},
	"nsc": {
		"language": 5037
	},
	"nsd": {
		"language": 5038
	},
	"nse": {
		"language": 5039
	},
	"nsf": {
		"language": 5040
	},
	"nsg": {
		"language": 5041
	},
	"nsh": {
		"language": 5042
	},
	"nsi": {
		"language": 5043,
		"extlang": 8278
	},
	"nsk": {
		"language": 5044
	},
	"nsl": {
		"language": 5045,
		"extlang": 8279
	},
	"nsm": {
		"language": 5046
	},
	"nsn": {
		"language": 5047
	},
	"nso": {
		"language": 5048
	},
	"nsp": {
		"language": 5049,
		"extlang": 8280
	},
	"nsq": {
		"language": 5050
	},
	"nsr": {
		"language": 5051,
		"extlang": 8281
	},
	"nss": {
		"language": 5052
	},
	"nst": {
		"language": 5053
	},
	"nsu": {
		"language": 5054
	},
	"nsv": {
		"language": 5055
	},
	"nsw": {
		"language": 5056
	},
	"nsx": {
		"language": 5057
	},
	"nsy": {
		"language": 5058
	},
	"nsz": {
		"language": 5059
	},
	"ntd": {
		"language": 5060
	},
	"nte": {
		"language": 5061
	},
	"ntg": {
		"language": 5062
	},
	"nti": {
		"language": 5063
	},
	"ntj": {
		"language": 5064
	},
	"ntk": {
		"language": 5065
	},
	"ntm": {
		"language": 5066
	},
	"nto": {
		"language": 5067
	},
	"ntp": {
		"language": 5068
	},
	"ntr": {
		"language": 5069
	},
	"nts": {
		"language": 5070
	},
	"ntu": {
		"language": 5071
	},
	"ntw": {
		"language": 5072
	},
	"ntx": {
		"language": 5073
	},
	"nty": {
		"language": 5074
	},
	"ntz": {
		"language": 5075
	},
	"nua": {
		"language": 5076
	},
	"nub": {
		"language": 5077
	},
	"nuc": {
		"language": 5078
	},
	"nud": {
		"language": 5079
	},
	"nue": {
		"language": 5080
	},
	"nuf": {
		"language": 5081
	},
	"nug": {
		"language": 5082
	},
	"nuh": {
		"language": 5083
	},
	"nui": {
		"language": 5084
	},
	"nuj": {
		"language": 5085
	},
	"nuk": {
		"language": 5086
	},
	"nul": {
		"language": 5087
	},
	"num": {
		"language": 5088
	},
	"nun": {
		"language": 5089
	},
	"nuo": {
		"language": 5090
	},
	"nup": {
		"language": 5091
	},
	"nuq": {
		"language": 5092
	},
	"nur": {
		"language": 5093
	},
	"nus": {
		"language": 5094
	},
	"nut": {
		"language": 5095
	},
	"nuu": {
		"language": 5096
	},
	"nuv": {
		"language": 5097
	},
	"nuw": {
		"language": 5098
	},
	"nux": {
		"language": 5099
	},
	"nuy": {
		"language": 5100
	},
	"nuz": {
		"language": 5101
	},
	"nvh": {
		"language": 5102
	},
	"nvm": {
		"language": 5103
	},
	"nvo": {
		"language": 5104
	},
	"nwa": {
		"language": 5105
	},
	"nwb": {
		"language": 5106
	},
	"nwc": {
		"language": 5107
	},
	"nwe": {
		"language": 5108
	},
	"nwg": {
		"language": 5109
	},
	"nwi": {
		"language": 5110
	},
	"nwm": {
		"language": 5111
	},
	"nwo": {
		"language": 5112
	},
	"nwr": {
		"language": 5113
	},
	"nwx": {
		"language": 5114
	},
	"nwy": {
		"language": 5115
	},
	"nxa": {
		"language": 5116
	},
	"nxd": {
		"language": 5117
	},
	"nxe": {
		"language": 5118
	},
	"nxg": {
		"language": 5119
	},
	"nxi": {
		"language": 5120
	},
	"nxk": {
		"language": 5121
	},
	"nxl": {
		"language": 5122
	},
	"nxm": {
		"language": 5123
	},
	"nxn": {
		"language": 5124
	},
	"nxo": {
		"language": 5125
	},
	"nxq": {
		"language": 5126
	},
	"nxr": {
		"language": 5127
	},
	"nxu": {
		"language": 5128
	},
	"nxx": {
		"language": 5129
	},
	"nyb": {
		"language": 5130
	},
	"nyc": {
		"language": 5131
	},
	"nyd": {
		"language": 5132
	},
	"nye": {
		"language": 5133
	},
	"nyf": {
		"language": 5134
	},
	"nyg": {
		"language": 5135
	},
	"nyh": {
		"language": 5136
	},
	"nyi": {
		"language": 5137
	},
	"nyj": {
		"language": 5138
	},
	"nyk": {
		"language": 5139
	},
	"nyl": {
		"language": 5140
	},
	"nym": {
		"language": 5141
	},
	"nyn": {
		"language": 5142
	},
	"nyo": {
		"language": 5143
	},
	"nyp": {
		"language": 5144
	},
	"nyq": {
		"language": 5145
	},
	"nyr": {
		"language": 5146
	},
	"nys": {
		"language": 5147
	},
	"nyt": {
		"language": 5148
	},
	"nyu": {
		"language": 5149
	},
	"nyv": {
		"language": 5150
	},
	"nyw": {
		"language": 5151
	},
	"nyx": {
		"language": 5152
	},
	"nyy": {
		"language": 5153
	},
	"nza": {
		"language": 5154
	},
	"nzb": {
		"language": 5155
	},
	"nzi": {
		"language": 5156
	},
	"nzk": {
		"language": 5157
	},
	"nzm": {
		"language": 5158
	},
	"nzs": {
		"language": 5159,
		"extlang": 8282
	},
	"nzu": {
		"language": 5160
	},
	"nzy": {
		"language": 5161
	},
	"nzz": {
		"language": 5162
	},
	"oaa": {
		"language": 5163
	},
	"oac": {
		"language": 5164
	},
	"oar": {
		"language": 5165
	},
	"oav": {
		"language": 5166
	},
	"obi": {
		"language": 5167
	},
	"obk": {
		"language": 5168
	},
	"obl": {
		"language": 5169
	},
	"obm": {
		"language": 5170
	},
	"obo": {
		"language": 5171
	},
	"obr": {
		"language": 5172
	},
	"obt": {
		"language": 5173
	},
	"obu": {
		"language": 5174
	},
	"oca": {
		"language": 5175
	},
	"och": {
		"language": 5176
	},
	"oco": {
		"language": 5177
	},
	"ocu": {
		"language": 5178
	},
	"oda": {
		"language": 5179
	},
	"odk": {
		"language": 5180
	},
	"odt": {
		"language": 5181
	},
	"odu": {
		"language": 5182
	},
	"ofo": {
		"language": 5183
	},
	"ofs": {
		"language": 5184
	},
	"ofu": {
		"language": 5185
	},
	"ogb": {
		"language": 5186
	},
	"ogc": {
		"language": 5187
	},
	"oge": {
		"language": 5188
	},
	"ogg": {
		"language": 5189
	},
	"ogo": {
		"language": 5190
	},
	"ogu": {
		"language": 5191
	},
	"oht": {
		"language": 5192
	},
	"ohu": {
		"language": 5193
	},
	"oia": {
		"language": 5194
	},
	"oin": {
		"language": 5195
	},
	"ojb": {
		"language": 5196
	},
	"ojc": {
		"language": 5197
	},
	"ojg": {
		"language": 5198
	},
	"ojp": {
		"language": 5199
	},
	"ojs": {
		"language": 5200
	},
	"ojv": {
		"language": 5201
	},
	"ojw": {
		"language": 5202
	},
	"oka": {
		"language": 5203
	},
	"okb": {
		"language": 5204
	},
	"okd": {
		"language": 5205
	},
	"oke": {
		"language": 5206
	},
	"okg": {
		"language": 5207
	},
	"okh": {
		"language": 5208
	},
	"oki": {
		"language": 5209
	},
	"okj": {
		"language": 5210
	},
	"okk": {
		"language": 5211
	},
	"okl": {
		"language": 5212,
		"extlang": 8283
	},
	"okm": {
		"language": 5213
	},
	"okn": {
		"language": 5214
	},
	"oko": {
		"language": 5215
	},
	"okr": {
		"language": 5216
	},
	"oks": {
		"language": 5217
	},
	"oku": {
		"language": 5218
	},
	"okv": {
		"language": 5219
	},
	"okx": {
		"language": 5220
	},
	"ola": {
		"language": 5221
	},
	"old": {
		"language": 5222
	},
	"ole": {
		"language": 5223
	},
	"olk": {
		"language": 5224
	},
	"olm": {
		"language": 5225
	},
	"olo": {
		"language": 5226
	},
	"olr": {
		"language": 5227
	},
	"olt": {
		"language": 5228
	},
	"olu": {
		"language": 5229
	},
	"oma": {
		"language": 5230
	},
	"omb": {
		"language": 5231
	},
	"omc": {
		"language": 5232
	},
	"ome": {
		"language": 5233
	},
	"omg": {
		"language": 5234
	},
	"omi": {
		"language": 5235
	},
	"omk": {
		"language": 5236
	},
	"oml": {
		"language": 5237
	},
	"omn": {
		"language": 5238
	},
	"omo": {
		"language": 5239
	},
	"omp": {
		"language": 5240
	},
	"omq": {
		"language": 5241
	},
	"omr": {
		"language": 5242
	},
	"omt": {
		"language": 5243
	},
	"omu": {
		"language": 5244
	},
	"omv": {
		"language": 5245
	},
	"omw": {
		"language": 5246
	},
	"omx": {
		"language": 5247
	},
	"ona": {
		"language": 5248
	},
	"onb": {
		"language": 5249
	},
	"one": {
		"language": 5250
	},
	"ong": {
		"language": 5251
	},
	"oni": {
		"language": 5252
	},
	"onj": {
		"language": 5253
	},
	"onk": {
		"language": 5254
	},
	"onn": {
		"language": 5255
	},
	"ono": {
		"language": 5256
	},
	"onp": {
		"language": 5257
	},
	"onr": {
		"language": 5258
	},
	"ons": {
		"language": 5259
	},
	"ont": {
		"language": 5260
	},
	"onu": {
		"language": 5261
	},
	"onw": {
		"language": 5262
	},
	"onx": {
		"language": 5263
	},
	"ood": {
		"language": 5264
	},
	"oog": {
		"language": 5265
	},
	"oon": {
		"language": 5266
	},
	"oor": {
		"language": 5267
	},
	"oos": {
		"language": 5268
	},
	"opa": {
		"language": 5269
	},
	"opk": {
		"language": 5270
	},
	"opm": {
		"language": 5271
	},
	"opo": {
		"language": 5272
	},
	"opt": {
		"language": 5273
	},
	"opy": {
		"language": 5274
	},
	"ora": {
		"language": 5275
	},
	"orc": {
		"language": 5276
	},
	"ore": {
		"language": 5277
	},
	"org": {
		"language": 5278
	},
	"orh": {
		"language": 5279
	},
	"orn": {
		"language": 5280,
		"extlang": 8284
	},
	"oro": {
		"language": 5281
	},
	"orr": {
		"language": 5282
	},
	"ors": {
		"language": 5283,
		"extlang": 8285
	},
	"ort": {
		"language": 5284
	},
	"oru": {
		"language": 5285
	},
	"orv": {
		"language": 5286
	},
	"orw": {
		"language": 5287
	},
	"orx": {
		"language": 5288
	},
	"ory": {
		"language": 5289
	},
	"orz": {
		"language": 5290
	},
	"osa": {
		"language": 5291
	},
	"osc": {
		"language": 5292
	},
	"osi": {
		"language": 5293
	},
	"oso": {
		"language": 5294
	},
	"osp": {
		"language": 5295
	},
	"ost": {
		"language": 5296
	},
	"osu": {
		"language": 5297
	},
	"osx": {
		"language": 5298
	},
	"ota": {
		"language": 5299
	},
	"otb": {
		"language": 5300
	},
	"otd": {
		"language": 5301
	},
	"ote": {
		"language": 5302
	},
	"oti": {
		"language": 5303
	},
	"otk": {
		"language": 5304
	},
	"otl": {
		"language": 5305
	},
	"otm": {
		"language": 5306
	},
	"otn": {
		"language": 5307
	},
	"oto": {
		"language": 5308
	},
	"otq": {
		"language": 5309
	},
	"otr": {
		"language": 5310
	},
	"ots": {
		"language": 5311
	},
	"ott": {
		"language": 5312
	},
	"otu": {
		"language": 5313
	},
	"otw": {
		"language": 5314
	},
	"otx": {
		"language": 5315
	},
	"oty": {
		"language": 5316
	},
	"otz": {
		"language": 5317
	},
	"oua": {
		"language": 5318
	},
	"oub": {
		"language": 5319
	},
	"oue": {
		"language": 5320
	},
	"oui": {
		"language": 5321
	},
	"oum": {
		"language": 5322
	},
	"oun": {
		"language": 5323
	},
	"ovd": {
		"language": 5324
	},
	"owi": {
		"language": 5325
	},
	"owl": {
		"language": 5326
	},
	"oyb": {
		"language": 5327
	},
	"oyd": {
		"language": 5328
	},
	"oym": {
		"language": 5329
	},
	"oyy": {
		"language": 5330
	},
	"ozm": {
		"language": 5331
	},
	"paa": {
		"language": 5332
	},
	"pab": {
		"language": 5333
	},
	"pac": {
		"language": 5334
	},
	"pad": {
		"language": 5335
	},
	"pae": {
		"language": 5336
	},
	"paf": {
		"language": 5337
	},
	"pag": {
		"language": 5338
	},
	"pah": {
		"language": 5339
	},
	"pai": {
		"language": 5340
	},
	"pak": {
		"language": 5341
	},
	"pal": {
		"language": 5342
	},
	"pam": {
		"language": 5343
	},
	"pao": {
		"language": 5344
	},
	"pap": {
		"language": 5345
	},
	"paq": {
		"language": 5346
	},
	"par": {
		"language": 5347
	},
	"pas": {
		"language": 5348
	},
	"pat": {
		"language": 5349
	},
	"pau": {
		"language": 5350
	},
	"pav": {
		"language": 5351
	},
	"paw": {
		"language": 5352
	},
	"pax": {
		"language": 5353
	},
	"pay": {
		"language": 5354
	},
	"paz": {
		"language": 5355
	},
	"pbb": {
		"language": 5356
	},
	"pbc": {
		"language": 5357
	},
	"pbe": {
		"language": 5358
	},
	"pbf": {
		"language": 5359
	},
	"pbg": {
		"language": 5360
	},
	"pbh": {
		"language": 5361
	},
	"pbi": {
		"language": 5362
	},
	"pbl": {
		"language": 5363
	},
	"pbn": {
		"language": 5364
	},
	"pbo": {
		"language": 5365
	},
	"pbp": {
		"language": 5366
	},
	"pbr": {
		"language": 5367
	},
	"pbs": {
		"language": 5368
	},
	"pbt": {
		"language": 5369
	},
	"pbu": {
		"language": 5370
	},
	"pbv": {
		"language": 5371
	},
	"pby": {
		"language": 5372
	},
	"pbz": {
		"language": 5373
	},
	"pca": {
		"language": 5374
	},
	"pcb": {
		"language": 5375
	},
	"pcc": {
		"language": 5376
	},
	"pcd": {
		"language": 5377
	},
	"pce": {
		"language": 5378
	},
	"pcf": {
		"language": 5379
	},
	"pcg": {
		"language": 5380
	},
	"pch": {
		"language": 5381
	},
	"pci": {
		"language": 5382
	},
	"pcj": {
		"language": 5383
	},
	"pck": {
		"language": 5384
	},
	"pcl": {
		"language": 5385
	},
	"pcm": {
		"language": 5386
	},
	"pcn": {
		"language": 5387
	},
	"pcp": {
		"language": 5388
	},
	"pcr": {
		"language": 5389
	},
	"pcw": {
		"language": 5390
	},
	"pda": {
		"language": 5391
	},
	"pdc": {
		"language": 5392
	},
	"pdi": {
		"language": 5393
	},
	"pdn": {
		"language": 5394
	},
	"pdo": {
		"language": 5395
	},
	"pdt": {
		"language": 5396
	},
	"pdu": {
		"language": 5397
	},
	"pea": {
		"language": 5398
	},
	"peb": {
		"language": 5399
	},
	"ped": {
		"language": 5400
	},
	"pee": {
		"language": 5401
	},
	"pef": {
		"language": 5402
	},
	"peg": {
		"language": 5403
	},
	"peh": {
		"language": 5404
	},
	"pei": {
		"language": 5405
	},
	"pej": {
		"language": 5406
	},
	"pek": {
		"language": 5407
	},
	"pel": {
		"language": 5408,
		"extlang": 8286
	},
	"pem": {
		"language": 5409
	},
	"peo": {
		"language": 5410
	},
	"pep": {
		"language": 5411
	},
	"peq": {
		"language": 5412
	},
	"pes": {
		"language": 5413
	},
	"pev": {
		"language": 5414
	},
	"pex": {
		"language": 5415
	},
	"pey": {
		"language": 5416
	},
	"pez": {
		"language": 5417
	},
	"pfa": {
		"language": 5418
	},
	"pfe": {
		"language": 5419
	},
	"pfl": {
		"language": 5420
	},
	"pga": {
		"language": 5421,
		"extlang": 8287
	},
	"pgd": {
		"language": 5422
	},
	"pgg": {
		"language": 5423
	},
	"pgi": {
		"language": 5424
	},
	"pgk": {
		"language": 5425
	},
	"pgl": {
		"language": 5426
	},
	"pgn": {
		"language": 5427
	},
	"pgs": {
		"language": 5428
	},
	"pgu": {
		"language": 5429
	},
	"pgy": {
		"language": 5430
	},
	"pgz": {
		"language": 5431,
		"extlang": 8288
	},
	"pha": {
		"language": 5432
	},
	"phd": {
		"language": 5433
	},
	"phg": {
		"language": 5434
	},
	"phh": {
		"language": 5435
	},
	"phi": {
		"language": 5436
	},
	"phk": {
		"language": 5437
	},
	"phl": {
		"language": 5438
	},
	"phm": {
		"language": 5439
	},
	"phn": {
		"language": 5440
	},
	"pho": {
		"language": 5441
	},
	"phq": {
		"language": 5442
	},
	"phr": {
		"language": 5443
	},
	"pht": {
		"language": 5444
	},
	"phu": {
		"language": 5445
	},
	"phv": {
		"language": 5446
	},
	"phw": {
		"language": 5447
	},
	"pia": {
		"language": 5448
	},
	"pib": {
		"language": 5449
	},
	"pic": {
		"language": 5450
	},
	"pid": {
		"language": 5451
	},
	"pie": {
		"language": 5452
	},
	"pif": {
		"language": 5453
	},
	"pig": {
		"language": 5454
	},
	"pih": {
		"language": 5455
	},
	"pii": {
		"language": 5456
	},
	"pij": {
		"language": 5457
	},
	"pil": {
		"language": 5458
	},
	"pim": {
		"language": 5459
	},
	"pin": {
		"language": 5460
	},
	"pio": {
		"language": 5461
	},
	"pip": {
		"language": 5462
	},
	"pir": {
		"language": 5463
	},
	"pis": {
		"language": 5464
	},
	"pit": {
		"language": 5465
	},
	"piu": {
		"language": 5466
	},
	"piv": {
		"language": 5467
	},
	"piw": {
		"language": 5468
	},
	"pix": {
		"language": 5469
	},
	"piy": {
		"language": 5470
	},
	"piz": {
		"language": 5471
	},
	"pjt": {
		"language": 5472
	},
	"pka": {
		"language": 5473
	},
	"pkb": {
		"language": 5474
	},
	"pkc": {
		"language": 5475
	},
	"pkg": {
		"language": 5476
	},
	"pkh": {
		"language": 5477
	},
	"pkn": {
		"language": 5478
	},
	"pko": {
		"language": 5479
	},
	"pkp": {
		"language": 5480
	},
	"pkr": {
		"language": 5481
	},
	"pks": {
		"language": 5482,
		"extlang": 8289
	},
	"pkt": {
		"language": 5483
	},
	"pku": {
		"language": 5484
	},
	"pla": {
		"language": 5485
	},
	"plb": {
		"language": 5486
	},
	"plc": {
		"language": 5487
	},
	"pld": {
		"language": 5488
	},
	"ple": {
		"language": 5489
	},
	"plf": {
		"language": 5490
	},
	"plg": {
		"language": 5491
	},
	"plh": {
		"language": 5492
	},
	"plj": {
		"language": 5493
	},
	"plk": {
		"language": 5494
	},
	"pll": {
		"language": 5495
	},
	"pln": {
		"language": 5496
	},
	"plo": {
		"language": 5497
	},
	"plp": {
		"language": 5498
	},
	"plq": {
		"language": 5499
	},
	"plr": {
		"language": 5500
	},
	"pls": {
		"language": 5501
	},
	"plt": {
		"language": 5502
	},
	"plu": {
		"language": 5503
	},
	"plv": {
		"language": 5504
	},
	"plw": {
		"language": 5505
	},
	"ply": {
		"language": 5506
	},
	"plz": {
		"language": 5507
	},
	"pma": {
		"language": 5508
	},
	"pmb": {
		"language": 5509
	},
	"pmc": {
		"language": 5510
	},
	"pmd": {
		"language": 5511
	},
	"pme": {
		"language": 5512
	},
	"pmf": {
		"language": 5513
	},
	"pmh": {
		"language": 5514
	},
	"pmi": {
		"language": 5515
	},
	"pmj": {
		"language": 5516
	},
	"pmk": {
		"language": 5517
	},
	"pml": {
		"language": 5518
	},
	"pmm": {
		"language": 5519
	},
	"pmn": {
		"language": 5520
	},
	"pmo": {
		"language": 5521
	},
	"pmq": {
		"language": 5522
	},
	"pmr": {
		"language": 5523
	},
	"pms": {
		"language": 5524
	},
	"pmt": {
		"language": 5525
	},
	"pmu": {
		"language": 5526
	},
	"pmw": {
		"language": 5527
	},
	"pmx": {
		"language": 5528
	},
	"pmy": {
		"language": 5529
	},
	"pmz": {
		"language": 5530
	},
	"pna": {
		"language": 5531
	},
	"pnb": {
		"language": 5532
	},
	"pnc": {
		"language": 5533
	},
	"pne": {
		"language": 5534
	},
	"png": {
		"language": 5535
	},
	"pnh": {
		"language": 5536
	},
	"pni": {
		"language": 5537
	},
	"pnj": {
		"language": 5538
	},
	"pnk": {
		"language": 5539
	},
	"pnl": {
		"language": 5540
	},
	"pnm": {
		"language": 5541
	},
	"pnn": {
		"language": 5542
	},
	"pno": {
		"language": 5543
	},
	"pnp": {
		"language": 5544
	},
	"pnq": {
		"language": 5545
	},
	"pnr": {
		"language": 5546
	},
	"pns": {
		"language": 5547
	},
	"pnt": {
		"language": 5548
	},
	"pnu": {
		"language": 5549
	},
	"pnv": {
		"language": 5550
	},
	"pnw": {
		"language": 5551
	},
	"pnx": {
		"language": 5552
	},
	"pny": {
		"language": 5553
	},
	"pnz": {
		"language": 5554
	},
	"poc": {
		"language": 5555
	},
	"pod": {
		"language": 5556
	},
	"poe": {
		"language": 5557
	},
	"pof": {
		"language": 5558
	},
	"pog": {
		"language": 5559
	},
	"poh": {
		"language": 5560
	},
	"poi": {
		"language": 5561
	},
	"pok": {
		"language": 5562
	},
	"pom": {
		"language": 5563
	},
	"pon": {
		"language": 5564
	},
	"poo": {
		"language": 5565
	},
	"pop": {
		"language": 5566
	},
	"poq": {
		"language": 5567
	},
	"pos": {
		"language": 5568
	},
	"pot": {
		"language": 5569
	},
	"pov": {
		"language": 5570
	},
	"pow": {
		"language": 5571
	},
	"pox": {
		"language": 5572
	},
	"poy": {
		"language": 5573
	},
	"poz": {
		"language": 5574
	},
	"ppa": {
		"language": 5575
	},
	"ppe": {
		"language": 5576
	},
	"ppi": {
		"language": 5577
	},
	"ppk": {
		"language": 5578
	},
	"ppl": {
		"language": 5579
	},
	"ppm": {
		"language": 5580
	},
	"ppn": {
		"language": 5581
	},
	"ppo": {
		"language": 5582
	},
	"ppp": {
		"language": 5583
	},
	"ppq": {
		"language": 5584
	},
	"ppr": {
		"language": 5585
	},
	"pps": {
		"language": 5586
	},
	"ppt": {
		"language": 5587
	},
	"ppu": {
		"language": 5588
	},
	"pqa": {
		"language": 5589
	},
	"pqe": {
		"language": 5590
	},
	"pqm": {
		"language": 5591
	},
	"pqw": {
		"language": 5592
	},
	"pra": {
		"language": 5593
	},
	"prb": {
		"language": 5594
	},
	"prc": {
		"language": 5595
	},
	"prd": {
		"language": 5596
	},
	"pre": {
		"language": 5597
	},
	"prf": {
		"language": 5598
	},
	"prg": {
		"language": 5599
	},
	"prh": {
		"language": 5600
	},
	"pri": {
		"language": 5601
	},
	"prk": {
		"language": 5602
	},
	"prl": {
		"language": 5603,
		"extlang": 8290
	},
	"prm": {
		"language": 5604
	},
	"prn": {
		"language": 5605
	},
	"pro": {
		"language": 5606
	},
	"prp": {
		"language": 5607
	},
	"prq": {
		"language": 5608
	},
	"prr": {
		"language": 5609
	},
	"prs": {
		"language": 5610
	},
	"prt": {
		"language": 5611
	},
	"pru": {
		"language": 5612
	},
	"prw": {
		"language": 5613
	},
	"prx": {
		"language": 5614
	},
	"pry": {
		"language": 5615
	},
	"prz": {
		"language": 5616,
		"extlang": 8291
	},
	"psa": {
		"language": 5617
	},
	"psc": {
		"language": 5618,
		"extlang": 8292
	},
	"psd": {
		"language": 5619,
		"extlang": 8293
	},
	"pse": {
		"language": 5620,
		"extlang": 8294
	},
	"psg": {
		"language": 5621,
		"extlang": 8295
	},
	"psh": {
		"language": 5622
	},
	"psi": {
		"language": 5623
	},
	"psl": {
		"language": 5624,
		"extlang": 8296
	},
	"psm": {
		"language": 5625
	},
	"psn": {
		"language": 5626
	},
	"pso": {
		"language": 5627,
		"extlang": 8297
	},
	"psp": {
		"language": 5628,
		"extlang": 8298
	},
	"psq": {
		"language": 5629
	},
	"psr": {
		"language": 5630,
		"extlang": 8299
	},
	"pss": {
		"language": 5631
	},
	"pst": {
		"language": 5632
	},
	"psu": {
		"language": 5633
	},
	"psw": {
		"language": 5634
	},
	"psy": {
		"language": 5635
	},
	"pta": {
		"language": 5636
	},
	"pth": {
		"language": 5637
	},
	"pti": {
		"language": 5638
	},
	"ptn": {
		"language": 5639
	},
	"pto": {
		"language": 5640
	},
	"ptp": {
		"language": 5641
	},
	"ptq": {
		"language": 5642
	},
	"ptr": {
		"language": 5643
	},
	"ptt": {
		"language": 5644
	},
	"ptu": {
		"language": 5645
	},
	"ptv": {
		"language": 5646
	},
	"ptw": {
		"language": 5647
	},
	"pty": {
		"language": 5648
	},
	"pua": {
		"language": 5649
	},
	"pub": {
		"language": 5650
	},
	"puc": {
		"language": 5651
	},
	"pud": {
		"language": 5652
	},
	"pue": {
		"language": 5653
	},
	"puf": {
		"language": 5654
	},
	"pug": {
		"language": 5655
	},
	"pui": {
		"language": 5656
	},
	"puj": {
		"language": 5657
	},
	"puk": {
		"language": 5658
	},
	"pum": {
		"language": 5659
	},
	"puo": {
		"language": 5660
	},
	"pup": {
		"language": 5661
	},
	"puq": {
		"language": 5662
	},
	"pur": {
		"language": 5663
	},
	"put": {
		"language": 5664
	},
	"puu": {
		"language": 5665
	},
	"puw": {
		"language": 5666
	},
	"pux": {
		"language": 5667
	},
	"puy": {
		"language": 5668
	},
	"puz": {
		"language": 5669
	},
	"pwa": {
		"language": 5670
	},
	"pwb": {
		"language": 5671
	},
	"pwg": {
		"language": 5672
	},
	"pwi": {
		"language": 5673
	},
	"pwm": {
		"language": 5674
	},
	"pwn": {
		"language": 5675
	},
	"pwo": {
		"language": 5676
	},
	"pwr": {
		"language": 5677
	},
	"pww": {
		"language": 5678
	},
	"pxm": {
		"language": 5679
	},
	"pye": {
		"language": 5680
	},
	"pym": {
		"language": 5681
	},
	"pyn": {
		"language": 5682
	},
	"pys": {
		"language": 5683,
		"extlang": 8300
	},
	"pyu": {
		"language": 5684
	},
	"pyx": {
		"language": 5685
	},
	"pyy": {
		"language": 5686
	},
	"pzn": {
		"language": 5687
	},
	"qaa..qtz": {
		"language": 5688
	},
	"qua": {
		"language": 5689
	},
	"qub": {
		"language": 5690
	},
	"quc": {
		"language": 5691
	},
	"qud": {
		"language": 5692
	},
	"quf": {
		"language": 5693
	},
	"qug": {
		"language": 5694
	},
	"quh": {
		"language": 5695
	},
	"qui": {
		"language": 5696
	},
	"quk": {
		"language": 5697
	},
	"qul": {
		"language": 5698
	},
	"qum": {
		"language": 5699
	},
	"qun": {
		"language": 5700
	},
	"qup": {
		"language": 5701
	},
	"quq": {
		"language": 5702
	},
	"qur": {
		"language": 5703
	},
	"qus": {
		"language": 5704
	},
	"quv": {
		"language": 5705
	},
	"quw": {
		"language": 5706
	},
	"qux": {
		"language": 5707
	},
	"quy": {
		"language": 5708
	},
	"quz": {
		"language": 5709
	},
	"qva": {
		"language": 5710
	},
	"qvc": {
		"language": 5711
	},
	"qve": {
		"language": 5712
	},
	"qvh": {
		"language": 5713
	},
	"qvi": {
		"language": 5714
	},
	"qvj": {
		"language": 5715
	},
	"qvl": {
		"language": 5716
	},
	"qvm": {
		"language": 5717
	},
	"qvn": {
		"language": 5718
	},
	"qvo": {
		"language": 5719
	},
	"qvp": {
		"language": 5720
	},
	"qvs": {
		"language": 5721
	},
	"qvw": {
		"language": 5722
	},
	"qvy": {
		"language": 5723
	},
	"qvz": {
		"language": 5724
	},
	"qwa": {
		"language": 5725
	},
	"qwc": {
		"language": 5726
	},
	"qwe": {
		"language": 5727
	},
	"qwh": {
		"language": 5728
	},
	"qwm": {
		"language": 5729
	},
	"qws": {
		"language": 5730
	},
	"qwt": {
		"language": 5731
	},
	"qxa": {
		"language": 5732
	},
	"qxc": {
		"language": 5733
	},
	"qxh": {
		"language": 5734
	},
	"qxl": {
		"language": 5735
	},
	"qxn": {
		"language": 5736
	},
	"qxo": {
		"language": 5737
	},
	"qxp": {
		"language": 5738
	},
	"qxq": {
		"language": 5739
	},
	"qxr": {
		"language": 5740
	},
	"qxs": {
		"language": 5741
	},
	"qxt": {
		"language": 5742
	},
	"qxu": {
		"language": 5743
	},
	"qxw": {
		"language": 5744
	},
	"qya": {
		"language": 5745
	},
	"qyp": {
		"language": 5746
	},
	"raa": {
		"language": 5747
	},
	"rab": {
		"language": 5748
	},
	"rac": {
		"language": 5749
	},
	"rad": {
		"language": 5750
	},
	"raf": {
		"language": 5751
	},
	"rag": {
		"language": 5752
	},
	"rah": {
		"language": 5753
	},
	"rai": {
		"language": 5754
	},
	"raj": {
		"language": 5755
	},
	"rak": {
		"language": 5756
	},
	"ral": {
		"language": 5757
	},
	"ram": {
		"language": 5758
	},
	"ran": {
		"language": 5759
	},
	"rao": {
		"language": 5760
	},
	"rap": {
		"language": 5761
	},
	"raq": {
		"language": 5762
	},
	"rar": {
		"language": 5763
	},
	"ras": {
		"language": 5764
	},
	"rat": {
		"language": 5765
	},
	"rau": {
		"language": 5766
	},
	"rav": {
		"language": 5767
	},
	"raw": {
		"language": 5768
	},
	"rax": {
		"language": 5769
	},
	"ray": {
		"language": 5770
	},
	"raz": {
		"language": 5771
	},
	"rbb": {
		"language": 5772
	},
	"rbk": {
		"language": 5773
	},
	"rbl": {
		"language": 5774
	},
	"rbp": {
		"language": 5775
	},
	"rcf": {
		"language": 5776
	},
	"rdb": {
		"language": 5777
	},
	"rea": {
		"language": 5778
	},
	"reb": {
		"language": 5779
	},
	"ree": {
		"language": 5780
	},
	"reg": {
		"language": 5781
	},
	"rei": {
		"language": 5782
	},
	"rej": {
		"language": 5783
	},
	"rel": {
		"language": 5784
	},
	"rem": {
		"language": 5785
	},
	"ren": {
		"language": 5786
	},
	"rer": {
		"language": 5787
	},
	"res": {
		"language": 5788
	},
	"ret": {
		"language": 5789
	},
	"rey": {
		"language": 5790
	},
	"rga": {
		"language": 5791
	},
	"rge": {
		"language": 5792
	},
	"rgk": {
		"language": 5793
	},
	"rgn": {
		"language": 5794
	},
	"rgr": {
		"language": 5795
	},
	"rgs": {
		"language": 5796
	},
	"rgu": {
		"language": 5797
	},
	"rhg": {
		"language": 5798
	},
	"rhp": {
		"language": 5799
	},
	"ria": {
		"language": 5800
	},
	"rie": {
		"language": 5801
	},
	"rif": {
		"language": 5802
	},
	"ril": {
		"language": 5803
	},
	"rim": {
		"language": 5804
	},
	"rin": {
		"language": 5805
	},
	"rir": {
		"language": 5806
	},
	"rit": {
		"language": 5807
	},
	"riu": {
		"language": 5808
	},
	"rjg": {
		"language": 5809
	},
	"rji": {
		"language": 5810
	},
	"rjs": {
		"language": 5811
	},
	"rka": {
		"language": 5812
	},
	"rkb": {
		"language": 5813
	},
	"rkh": {
		"language": 5814
	},
	"rki": {
		"language": 5815
	},
	"rkm": {
		"language": 5816
	},
	"rkt": {
		"language": 5817
	},
	"rkw": {
		"language": 5818
	},
	"rma": {
		"language": 5819
	},
	"rmb": {
		"language": 5820
	},
	"rmc": {
		"language": 5821
	},
	"rmd": {
		"language": 5822
	},
	"rme": {
		"language": 5823
	},
	"rmf": {
		"language": 5824
	},
	"rmg": {
		"language": 5825
	},
	"rmh": {
		"language": 5826
	},
	"rmi": {
		"language": 5827
	},
	"rmk": {
		"language": 5828
	},
	"rml": {
		"language": 5829
	},
	"rmm": {
		"language": 5830
	},
	"rmn": {
		"language": 5831
	},
	"rmo": {
		"language": 5832
	},
	"rmp": {
		"language": 5833
	},
	"rmq": {
		"language": 5834
	},
	"rmr": {
		"language": 5835
	},
	"rms": {
		"language": 5836,
		"extlang": 8301
	},
	"rmt": {
		"language": 5837
	},
	"rmu": {
		"language": 5838
	},
	"rmv": {
		"language": 5839
	},
	"rmw": {
		"language": 5840
	},
	"rmx": {
		"language": 5841
	},
	"rmy": {
		"language": 5842
	},
	"rmz": {
		"language": 5843
	},
	"rna": {
		"language": 5844
	},
	"rnd": {
		"language": 5845
	},
	"rng": {
		"language": 5846
	},
	"rnl": {
		"language": 5847
	},
	"rnn": {
		"language": 5848
	},
	"rnp": {
		"language": 5849
	},
	"rnr": {
		"language": 5850
	},
	"rnw": {
		"language": 5851
	},
	"roa": {
		"language": 5852
	},
	"rob": {
		"language": 5853
	},
	"roc": {
		"language": 5854
	},
	"rod": {
		"language": 5855
	},
	"roe": {
		"language": 5856
	},
	"rof": {
		"language": 5857
	},
	"rog": {
		"language": 5858
	},
	"rol": {
		"language": 5859
	},
	"rom": {
		"language": 5860
	},
	"roo": {
		"language": 5861
	},
	"rop": {
		"language": 5862
	},
	"ror": {
		"language": 5863
	},
	"rou": {
		"language": 5864
	},
	"row": {
		"language": 5865
	},
	"rpn": {
		"language": 5866
	},
	"rpt": {
		"language": 5867
	},
	"rri": {
		"language": 5868
	},
	"rro": {
		"language": 5869
	},
	"rrt": {
		"language": 5870
	},
	"rsb": {
		"language": 5871
	},
	"rsi": {
		"language": 5872,
		"extlang": 8302
	},
	"rsl": {
		"language": 5873,
		"extlang": 8303
	},
	"rsm": {
		"language": 5874,
		"extlang": 8304
	},
	"rtc": {
		"language": 5875
	},
	"rth": {
		"language": 5876
	},
	"rtm": {
		"language": 5877
	},
	"rts": {
		"language": 5878
	},
	"rtw": {
		"language": 5879
	},
	"rub": {
		"language": 5880
	},
	"ruc": {
		"language": 5881
	},
	"rue": {
		"language": 5882
	},
	"ruf": {
		"language": 5883
	},
	"rug": {
		"language": 5884
	},
	"ruh": {
		"language": 5885
	},
	"rui": {
		"language": 5886
	},
	"ruk": {
		"language": 5887
	},
	"ruo": {
		"language": 5888
	},
	"rup": {
		"language": 5889
	},
	"ruq": {
		"language": 5890
	},
	"rut": {
		"language": 5891
	},
	"ruu": {
		"language": 5892
	},
	"ruy": {
		"language": 5893
	},
	"ruz": {
		"language": 5894
	},
	"rwa": {
		"language": 5895
	},
	"rwk": {
		"language": 5896
	},
	"rwm": {
		"language": 5897
	},
	"rwo": {
		"language": 5898
	},
	"rwr": {
		"language": 5899
	},
	"rxd": {
		"language": 5900
	},
	"rxw": {
		"language": 5901
	},
	"ryn": {
		"language": 5902
	},
	"rys": {
		"language": 5903
	},
	"ryu": {
		"language": 5904
	},
	"rzh": {
		"language": 5905
	},
	"saa": {
		"language": 5906
	},
	"sab": {
		"language": 5907
	},
	"sac": {
		"language": 5908
	},
	"sad": {
		"language": 5909
	},
	"sae": {
		"language": 5910
	},
	"saf": {
		"language": 5911
	},
	"sah": {
		"language": 5912
	},
	"sai": {
		"language": 5913
	},
	"saj": {
		"language": 5914
	},
	"sak": {
		"language": 5915
	},
	"sal": {
		"language": 5916
	},
	"sam": {
		"language": 5917
	},
	"sao": {
		"language": 5918
	},
	"sap": {
		"language": 5919
	},
	"saq": {
		"language": 5920
	},
	"sar": {
		"language": 5921
	},
	"sas": {
		"language": 5922
	},
	"sat": {
		"language": 5923
	},
	"sau": {
		"language": 5924
	},
	"sav": {
		"language": 5925
	},
	"saw": {
		"language": 5926
	},
	"sax": {
		"language": 5927
	},
	"say": {
		"language": 5928
	},
	"saz": {
		"language": 5929
	},
	"sba": {
		"language": 5930
	},
	"sbb": {
		"language": 5931
	},
	"sbc": {
		"language": 5932
	},
	"sbd": {
		"language": 5933
	},
	"sbe": {
		"language": 5934
	},
	"sbf": {
		"language": 5935
	},
	"sbg": {
		"language": 5936
	},
	"sbh": {
		"language": 5937
	},
	"sbi": {
		"language": 5938
	},
	"sbj": {
		"language": 5939
	},
	"sbk": {
		"language": 5940
	},
	"sbl": {
		"language": 5941
	},
	"sbm": {
		"language": 5942
	},
	"sbn": {
		"language": 5943
	},
	"sbo": {
		"language": 5944
	},
	"sbp": {
		"language": 5945
	},
	"sbq": {
		"language": 5946
	},
	"sbr": {
		"language": 5947
	},
	"sbs": {
		"language": 5948
	},
	"sbt": {
		"language": 5949
	},
	"sbu": {
		"language": 5950
	},
	"sbv": {
		"language": 5951
	},
	"sbw": {
		"language": 5952
	},
	"sbx": {
		"language": 5953
	},
	"sby": {
		"language": 5954
	},
	"sbz": {
		"language": 5955
	},
	"sca": {
		"language": 5956
	},
	"scb": {
		"language": 5957
	},
	"sce": {
		"language": 5958
	},
	"scf": {
		"language": 5959
	},
	"scg": {
		"language": 5960
	},
	"sch": {
		"language": 5961
	},
	"sci": {
		"language": 5962
	},
	"sck": {
		"language": 5963
	},
	"scl": {
		"language": 5964
	},
	"scn": {
		"language": 5965
	},
	"sco": {
		"language": 5966
	},
	"scp": {
		"language": 5967
	},
	"scq": {
		"language": 5968
	},
	"scs": {
		"language": 5969
	},
	"sct": {
		"language": 5970
	},
	"scu": {
		"language": 5971
	},
	"scv": {
		"language": 5972
	},
	"scw": {
		"language": 5973
	},
	"scx": {
		"language": 5974
	},
	"sda": {
		"language": 5975
	},
	"sdb": {
		"language": 5976
	},
	"sdc": {
		"language": 5977
	},
	"sde": {
		"language": 5978
	},
	"sdf": {
		"language": 5979
	},
	"sdg": {
		"language": 5980
	},
	"sdh": {
		"language": 5981
	},
	"sdj": {
		"language": 5982
	},
	"sdk": {
		"language": 5983
	},
	"sdl": {
		"language": 5984,
		"extlang": 8305
	},
	"sdm": {
		"language": 5985
	},
	"sdn": {
		"language": 5986
	},
	"sdo": {
		"language": 5987
	},
	"sdp": {
		"language": 5988
	},
	"sdr": {
		"language": 5989
	},
	"sds": {
		"language": 5990
	},
	"sdt": {
		"language": 5991
	},
	"sdu": {
		"language": 5992
	},
	"sdv": {
		"language": 5993
	},
	"sdx": {
		"language": 5994
	},
	"sdz": {
		"language": 5995
	},
	"sea": {
		"language": 5996
	},
	"seb": {
		"language": 5997
	},
	"sec": {
		"language": 5998
	},
	"sed": {
		"language": 5999
	},
	"see": {
		"language": 6000
	},
	"sef": {
		"language": 6001
	},
	"seg": {
		"language": 6002
	},
	"seh": {
		"language": 6003
	},
	"sei": {
		"language": 6004
	},
	"sej": {
		"language": 6005
	},
	"sek": {
		"language": 6006
	},
	"sel": {
		"language": 6007
	},
	"sem": {
		"language": 6008
	},
	"sen": {
		"language": 6009
	},
	"seo": {
		"language": 6010
	},
	"sep": {
		"language": 6011
	},
	"seq": {
		"language": 6012
	},
	"ser": {
		"language": 6013
	},
	"ses": {
		"language": 6014
	},
	"set": {
		"language": 6015
	},
	"seu": {
		"language": 6016
	},
	"sev": {
		"language": 6017
	},
	"sew": {
		"language": 6018
	},
	"sey": {
		"language": 6019
	},
	"sez": {
		"language": 6020
	},
	"sfb": {
		"language": 6021,
		"extlang": 8306
	},
	"sfe": {
		"language": 6022
	},
	"sfm": {
		"language": 6023
	},
	"sfs": {
		"language": 6024,
		"extlang": 8307
	},
	"sfw": {
		"language": 6025
	},
	"sga": {
		"language": 6026
	},
	"sgb": {
		"language": 6027
	},
	"sgc": {
		"language": 6028
	},
	"sgd": {
		"language": 6029
	},
	"sge": {
		"language": 6030
	},
	"sgg": {
		"language": 6031,
		"extlang": 8308
	},
	"sgh": {
		"language": 6032
	},
	"sgi": {
		"language": 6033
	},
	"sgj": {
		"language": 6034
	},
	"sgk": {
		"language": 6035
	},
	"sgl": {
		"language": 6036
	},
	"sgm": {
		"language": 6037
	},
	"sgn": {
		"language": 6038
	},
	"sgo": {
		"language": 6039
	},
	"sgp": {
		"language": 6040
	},
	"sgr": {
		"language": 6041
	},
	"sgs": {
		"language": 6042
	},
	"sgt": {
		"language": 6043
	},
	"sgu": {
		"language": 6044
	},
	"sgw": {
		"language": 6045
	},
	"sgx": {
		"language": 6046,
		"extlang": 8309
	},
	"sgy": {
		"language": 6047
	},
	"sgz": {
		"language": 6048
	},
	"sha": {
		"language": 6049
	},
	"shb": {
		"language": 6050
	},
	"shc": {
		"language": 6051
	},
	"shd": {
		"language": 6052
	},
	"she": {
		"language": 6053
	},
	"shg": {
		"language": 6054
	},
	"shh": {
		"language": 6055
	},
	"shi": {
		"language": 6056
	},
	"shj": {
		"language": 6057
	},
	"shk": {
		"language": 6058
	},
	"shl": {
		"language": 6059
	},
	"shm": {
		"language": 6060
	},
	"shn": {
		"language": 6061
	},
	"sho": {
		"language": 6062
	},
	"shp": {
		"language": 6063
	},
	"shq": {
		"language": 6064
	},
	"shr": {
		"language": 6065
	},
	"shs": {
		"language": 6066
	},
	"sht": {
		"language": 6067
	},
	"shu": {
		"language": 6068,
		"extlang": 8310
	},
	"shv": {
		"language": 6069
	},
	"shw": {
		"language": 6070
	},
	"shx": {
		"language": 6071
	},
	"shy": {
		"language": 6072
	},
	"shz": {
		"language": 6073
	},
	"sia": {
		"language": 6074
	},
	"sib": {
		"language": 6075
	},
	"sid": {
		"language": 6076
	},
	"sie": {
		"language": 6077
	},
	"sif": {
		"language": 6078
	},
	"sig": {
		"language": 6079
	},
	"sih": {
		"language": 6080
	},
	"sii": {
		"language": 6081
	},
	"sij": {
		"language": 6082
	},
	"sik": {
		"language": 6083
	},
	"sil": {
		"language": 6084
	},
	"sim": {
		"language": 6085
	},
	"sio": {
		"language": 6086
	},
	"sip": {
		"language": 6087
	},
	"siq": {
		"language": 6088
	},
	"sir": {
		"language": 6089
	},
	"sis": {
		"language": 6090
	},
	"sit": {
		"language": 6091
	},
	"siu": {
		"language": 6092
	},
	"siv": {
		"language": 6093
	},
	"siw": {
		"language": 6094
	},
	"six": {
		"language": 6095
	},
	"siy": {
		"language": 6096
	},
	"siz": {
		"language": 6097
	},
	"sja": {
		"language": 6098
	},
	"sjb": {
		"language": 6099
	},
	"sjd": {
		"language": 6100
	},
	"sje": {
		"language": 6101
	},
	"sjg": {
		"language": 6102
	},
	"sjk": {
		"language": 6103
	},
	"sjl": {
		"language": 6104
	},
	"sjm": {
		"language": 6105
	},
	"sjn": {
		"language": 6106
	},
	"sjo": {
		"language": 6107
	},
	"sjp": {
		"language": 6108
	},
	"sjr": {
		"language": 6109
	},
	"sjs": {
		"language": 6110
	},
	"sjt": {
		"language": 6111
	},
	"sju": {
		"language": 6112
	},
	"sjw": {
		"language": 6113
	},
	"ska": {
		"language": 6114
	},
	"skb": {
		"language": 6115
	},
	"skc": {
		"language": 6116
	},
	"skd": {
		"language": 6117
	},
	"ske": {
		"language": 6118
	},
	"skf": {
		"language": 6119
	},
	"skg": {
		"language": 6120
	},
	"skh": {
		"language": 6121
	},
	"ski": {
		"language": 6122
	},
	"skj": {
		"language": 6123
	},
	"skk": {
		"language": 6124
	},
	"skm": {
		"language": 6125
	},
	"skn": {
		"language": 6126
	},
	"sko": {
		"language": 6127
	},
	"skp": {
		"language": 6128
	},
	"skq": {
		"language": 6129
	},
	"skr": {
		"language": 6130
	},
	"sks": {
		"language": 6131
	},
	"skt": {
		"language": 6132
	},
	"sku": {
		"language": 6133
	},
	"skv": {
		"language": 6134
	},
	"skw": {
		"language": 6135
	},
	"skx": {
		"language": 6136
	},
	"sky": {
		"language": 6137
	},
	"skz": {
		"language": 6138
	},
	"sla": {
		"language": 6139
	},
	"slc": {
		"language": 6140
	},
	"sld": {
		"language": 6141
	},
	"sle": {
		"language": 6142
	},
	"slf": {
		"language": 6143,
		"extlang": 8311
	},
	"slg": {
		"language": 6144
	},
	"slh": {
		"language": 6145
	},
	"sli": {
		"language": 6146
	},
	"slj": {
		"language": 6147
	},
	"sll": {
		"language": 6148
	},
	"slm": {
		"language": 6149
	},
	"sln": {
		"language": 6150
	},
	"slp": {
		"language": 6151
	},
	"slq": {
		"language": 6152
	},
	"slr": {
		"language": 6153
	},
	"sls": {
		"language": 6154,
		"extlang": 8312
	},
	"slt": {
		"language": 6155
	},
	"slu": {
		"language": 6156
	},
	"slw": {
		"language": 6157
	},
	"slx": {
		"language": 6158
	},
	"sly": {
		"language": 6159
	},
	"slz": {
		"language": 6160
	},
	"sma": {
		"language": 6161
	},
	"smb": {
		"language": 6162
	},
	"smc": {
		"language": 6163
	},
	"smd": {
		"language": 6164
	},
	"smf": {
		"language": 6165
	},
	"smg": {
		"language": 6166
	},
	"smh": {
		"language": 6167
	},
	"smi": {
		"language": 6168
	},
	"smj": {
		"language": 6169
	},
	"smk": {
		"language": 6170
	},
	"sml": {
		"language": 6171
	},
	"smm": {
		"language": 6172
	},
	"smn": {
		"language": 6173
	},
	"smp": {
		"language": 6174
	},
	"smq": {
		"language": 6175
	},
	"smr": {
		"language": 6176
	},
	"sms": {
		"language": 6177
	},
	"smt": {
		"language": 6178
	},
	"smu": {
		"language": 6179
	},
	"smv": {
		"language": 6180
	},
	"smw": {
		"language": 6181
	},
	"smx": {
		"language": 6182
	},
	"smy": {
		"language": 6183
	},
	"smz": {
		"language": 6184
	},
	"snb": {
		"language": 6185
	},
	"snc": {
		"language": 6186
	},
	"sne": {
		"language": 6187
	},
	"snf": {
		"language": 6188
	},
	"sng": {
		"language": 6189
	},
	"snh": {
		"language": 6190
	},
	"sni": {
		"language": 6191
	},
	"snj": {
		"language": 6192
	},
	"snk": {
		"language": 6193
	},
	"snl": {
		"language": 6194
	},
	"snm": {
		"language": 6195
	},
	"snn": {
		"language": 6196
	},
	"sno": {
		"language": 6197
	},
	"snp": {
		"language": 6198
	},
	"snq": {
		"language": 6199
	},
	"snr": {
		"language": 6200
	},
	"sns": {
		"language": 6201
	},
	"snu": {
		"language": 6202
	},
	"snv": {
		"language": 6203
	},
	"snw": {
		"language": 6204
	},
	"snx": {
		"language": 6205
	},
	"sny": {
		"language": 6206
	},
	"snz": {
		"language": 6207
	},
	"soa": {
		"language": 6208
	},
	"sob": {
		"language": 6209
	},
	"soc": {
		"language": 6210
	},
	"sod": {
		"language": 6211
	},
	"soe": {
		"language": 6212
	},
	"sog": {
		"language": 6213
	},
	"soh": {
		"language": 6214
	},
	"soi": {
		"language": 6215
	},
	"soj": {
		"language": 6216
	},
	"sok": {
		"language": 6217
	},
	"sol": {
		"language": 6218
	},
	"son": {
		"language": 6219
	},
	"soo": {
		"language": 6220
	},
	"sop": {
		"language": 6221
	},
	"soq": {
		"language": 6222
	},
	"sor": {
		"language": 6223
	},
	"sos": {
		"language": 6224
	},
	"sou": {
		"language": 6225
	},
	"sov": {
		"language": 6226
	},
	"sow": {
		"language": 6227
	},
	"sox": {
		"language": 6228
	},
	"soy": {
		"language": 6229
	},
	"soz": {
		"language": 6230
	},
	"spb": {
		"language": 6231
	},
	"spc": {
		"language": 6232
	},
	"spd": {
		"language": 6233
	},
	"spe": {
		"language": 6234
	},
	"spg": {
		"language": 6235
	},
	"spi": {
		"language": 6236
	},
	"spk": {
		"language": 6237
	},
	"spl": {
		"language": 6238
	},
	"spm": {
		"language": 6239
	},
	"spn": {
		"language": 6240
	},
	"spo": {
		"language": 6241
	},
	"spp": {
		"language": 6242
	},
	"spq": {
		"language": 6243
	},
	"spr": {
		"language": 6244
	},
	"sps": {
		"language": 6245
	},
	"spt": {
		"language": 6246
	},
	"spu": {
		"language": 6247
	},
	"spv": {
		"language": 6248
	},
	"spx": {
		"language": 6249
	},
	"spy": {
		"language": 6250
	},
	"sqa": {
		"language": 6251
	},
	"sqh": {
		"language": 6252
	},
	"sqj": {
		"language": 6253
	},
	"sqk": {
		"language": 6254,
		"extlang": 8313
	},
	"sqm": {
		"language": 6255
	},
	"sqn": {
		"language": 6256
	},
	"sqo": {
		"language": 6257
	},
	"sqq": {
		"language": 6258
	},
	"sqr": {
		"language": 6259
	},
	"sqs": {
		"language": 6260,
		"extlang": 8314
	},
	"sqt": {
		"language": 6261
	},
	"squ": {
		"language": 6262
	},
	"sra": {
		"language": 6263
	},
	"srb": {
		"language": 6264
	},
	"src": {
		"language": 6265
	},
	"sre": {
		"language": 6266
	},
	"srf": {
		"language": 6267
	},
	"srg": {
		"language": 6268
	},
	"srh": {
		"language": 6269
	},
	"sri": {
		"language": 6270
	},
	"srk": {
		"language": 6271
	},
	"srl": {
		"language": 6272
	},
	"srm": {
		"language": 6273
	},
	"srn": {
		"language": 6274
	},
	"sro": {
		"language": 6275
	},
	"srq": {
		"language": 6276
	},
	"srr": {
		"language": 6277
	},
	"srs": {
		"language": 6278
	},
	"srt": {
		"language": 6279
	},
	"sru": {
		"language": 6280
	},
	"srv": {
		"language": 6281
	},
	"srw": {
		"language": 6282
	},
	"srx": {
		"language": 6283
	},
	"sry": {
		"language": 6284
	},
	"srz": {
		"language": 6285
	},
	"ssa": {
		"language": 6286
	},
	"ssb": {
		"language": 6287
	},
	"ssc": {
		"language": 6288
	},
	"ssd": {
		"language": 6289
	},
	"sse": {
		"language": 6290
	},
	"ssf": {
		"language": 6291
	},
	"ssg": {
		"language": 6292
	},
	"ssh": {
		"language": 6293,
		"extlang": 8315
	},
	"ssi": {
		"language": 6294
	},
	"ssj": {
		"language": 6295
	},
	"ssk": {
		"language": 6296
	},
	"ssl": {
		"language": 6297
	},
	"ssm": {
		"language": 6298
	},
	"ssn": {
		"language": 6299
	},
	"sso": {
		"language": 6300
	},
	"ssp": {
		"language": 6301,
		"extlang": 8316
	},
	"ssq": {
		"language": 6302
	},
	"ssr": {
		"language": 6303,
		"extlang": 8317
	},
	"sss": {
		"language": 6304
	},
	"sst": {
		"language": 6305
	},
	"ssu": {
		"language": 6306
	},
	"ssv": {
		"language": 6307
	},
	"ssx": {
		"language": 6308
	},
	"ssy": {
		"language": 6309
	},
	"ssz": {
		"language": 6310
	},
	"sta": {
		"language": 6311
	},
	"stb": {
		"language": 6312
	},
	"std": {
		"language": 6313
	},
	"ste": {
		"language": 6314
	},
	"stf": {
		"language": 6315
	},
	"stg": {
		"language": 6316
	},
	"sth": {
		"language": 6317
	},
	"sti": {
		"language": 6318
	},
	"stj": {
		"language": 6319
	},
	"stk": {
		"language": 6320
	},
	"stl": {
		"language": 6321
	},
	"stm": {
		"language": 6322
	},
	"stn": {
		"language": 6323
	},
	"sto": {
		"language": 6324
	},
	"stp": {
		"language": 6325
	},
	"stq": {
		"language": 6326
	},
	"str": {
		"language": 6327
	},
	"sts": {
		"language": 6328
	},
	"stt": {
		"language": 6329
	},
	"stu": {
		"language": 6330
	},
	"stv": {
		"language": 6331
	},
	"stw": {
		"language": 6332
	},
	"sty": {
		"language": 6333
	},
	"sua": {
		"language": 6334
	},
	"sub": {
		"language": 6335
	},
	"suc": {
		"language": 6336
	},
	"sue": {
		"language": 6337
	},
	"sug": {
		"language": 6338
	},
	"sui": {
		"language": 6339
	},
	"suj": {
		"language": 6340
	},
	"suk": {
		"language": 6341
	},
	"sul": {
		"language": 6342
	},
	"sum": {
		"language": 6343
	},
	"suq": {
		"language": 6344
	},
	"sur": {
		"language": 6345
	},
	"sus": {
		"language": 6346
	},
	"sut": {
		"language": 6347
	},
	"suv": {
		"language": 6348
	},
	"suw": {
		"language": 6349
	},
	"sux": {
		"language": 6350
	},
	"suy": {
		"language": 6351
	},
	"suz": {
		"language": 6352
	},
	"sva": {
		"language": 6353
	},
	"svb": {
		"language": 6354
	},
	"svc": {
		"language": 6355
	},
	"sve": {
		"language": 6356
	},
	"svk": {
		"language": 6357,
		"extlang": 8318
	},
	"svm": {
		"language": 6358
	},
	"svr": {
		"language": 6359
	},
	"svs": {
		"language": 6360
	},
	"svx": {
		"language": 6361
	},
	"swb": {
		"language": 6362
	},
	"swc": {
		"language": 6363,
		"extlang": 8319
	},
	"swf": {
		"language": 6364
	},
	"swg": {
		"language": 6365
	},
	"swh": {
		"language": 6366,
		"extlang": 8320
	},
	"swi": {
		"language": 6367
	},
	"swj": {
		"language": 6368
	},
	"swk": {
		"language": 6369
	},
	"swl": {
		"language": 6370,
		"extlang": 8321
	},
	"swm": {
		"language": 6371
	},
	"swn": {
		"language": 6372
	},
	"swo": {
		"language": 6373
	},
	"swp": {
		"language": 6374
	},
	"swq": {
		"language": 6375
	},
	"swr": {
		"language": 6376
	},
	"sws": {
		"language": 6377
	},
	"swt": {
		"language": 6378
	},
	"swu": {
		"language": 6379
	},
	"swv": {
		"language": 6380
	},
	"sww": {
		"language": 6381
	},
	"swx": {
		"language": 6382
	},
	"swy": {
		"language": 6383
	},
	"sxb": {
		"language": 6384
	},
	"sxc": {
		"language": 6385
	},
	"sxe": {
		"language": 6386
	},
	"sxg": {
		"language": 6387
	},
	"sxk": {
		"language": 6388
	},
	"sxl": {
		"language": 6389
	},
	"sxm": {
		"language": 6390
	},
	"sxn": {
		"language": 6391
	},
	"sxo": {
		"language": 6392
	},
	"sxr": {
		"language": 6393
	},
	"sxs": {
		"language": 6394
	},
	"sxu": {
		"language": 6395
	},
	"sxw": {
		"language": 6396
	},
	"sya": {
		"language": 6397
	},
	"syb": {
		"language": 6398
	},
	"syc": {
		"language": 6399
	},
	"syd": {
		"language": 6400
	},
	"syi": {
		"language": 6401
	},
	"syk": {
		"language": 6402
	},
	"syl": {
		"language": 6403
	},
	"sym": {
		"language": 6404
	},
	"syn": {
		"language": 6405
	},
	"syo": {
		"language": 6406
	},
	"syr": {
		"language": 6407
	},
	"sys": {
		"language": 6408
	},
	"syw": {
		"language": 6409
	},
	"syx": {
		"language": 6410
	},
	"syy": {
		"language": 6411,
		"extlang": 8322
	},
	"sza": {
		"language": 6412
	},
	"szb": {
		"language": 6413
	},
	"szc": {
		"language": 6414
	},
	"szd": {
		"language": 6415
	},
	"sze": {
		"language": 6416
	},
	"szg": {
		"language": 6417
	},
	"szl": {
		"language": 6418
	},
	"szn": {
		"language": 6419
	},
	"szp": {
		"language": 6420
	},
	"szs": {
		"language": 6421,
		"extlang": 8323
	},
	"szv": {
		"language": 6422
	},
	"szw": {
		"language": 6423
	},
	"taa": {
		"language": 6424
	},
	"tab": {
		"language": 6425
	},
	"tac": {
		"language": 6426
	},
	"tad": {
		"language": 6427
	},
	"tae": {
		"language": 6428
	},
	"taf": {
		"language": 6429
	},
	"tag": {
		"language": 6430
	},
	"tai": {
		"language": 6431
	},
	"taj": {
		"language": 6432
	},
	"tak": {
		"language": 6433
	},
	"tal": {
		"language": 6434
	},
	"tan": {
		"language": 6435
	},
	"tao": {
		"language": 6436
	},
	"tap": {
		"language": 6437
	},
	"taq": {
		"language": 6438
	},
	"tar": {
		"language": 6439
	},
	"tas": {
		"language": 6440
	},
	"tau": {
		"language": 6441
	},
	"tav": {
		"language": 6442
	},
	"taw": {
		"language": 6443
	},
	"tax": {
		"language": 6444
	},
	"tay": {
		"language": 6445
	},
	"taz": {
		"language": 6446
	},
	"tba": {
		"language": 6447
	},
	"tbb": {
		"language": 6448
	},
	"tbc": {
		"language": 6449
	},
	"tbd": {
		"language": 6450
	},
	"tbe": {
		"language": 6451
	},
	"tbf": {
		"language": 6452
	},
	"tbg": {
		"language": 6453
	},
	"tbh": {
		"language": 6454
	},
	"tbi": {
		"language": 6455
	},
	"tbj": {
		"language": 6456
	},
	"tbk": {
		"language": 6457
	},
	"tbl": {
		"language": 6458
	},
	"tbm": {
		"language": 6459
	},
	"tbn": {
		"language": 6460
	},
	"tbo": {
		"language": 6461
	},
	"tbp": {
		"language": 6462
	},
	"tbq": {
		"language": 6463
	},
	"tbr": {
		"language": 6464
	},
	"tbs": {
		"language": 6465
	},
	"tbt": {
		"language": 6466
	},
	"tbu": {
		"language": 6467
	},
	"tbv": {
		"language": 6468
	},
	"tbw": {
		"language": 6469
	},
	"tbx": {
		"language": 6470
	},
	"tby": {
		"language": 6471
	},
	"tbz": {
		"language": 6472
	},
	"tca": {
		"language": 6473
	},
	"tcb": {
		"language": 6474
	},
	"tcc": {
		"language": 6475
	},
	"tcd": {
		"language": 6476
	},
	"tce": {
		"language": 6477
	},
	"tcf": {
		"language": 6478
	},
	"tcg": {
		"language": 6479
	},
	"tch": {
		"language": 6480
	},
	"tci": {
		"language": 6481
	},
	"tck": {
		"language": 6482
	},
	"tcl": {
		"language": 6483
	},
	"tcm": {
		"language": 6484
	},
	"tcn": {
		"language": 6485
	},
	"tco": {
		"language": 6486
	},
	"tcp": {
		"language": 6487
	},
	"tcq": {
		"language": 6488
	},
	"tcs": {
		"language": 6489
	},
	"tct": {
		"language": 6490
	},
	"tcu": {
		"language": 6491
	},
	"tcw": {
		"language": 6492
	},
	"tcx": {
		"language": 6493
	},
	"tcy": {
		"language": 6494
	},
	"tcz": {
		"language": 6495
	},
	"tda": {
		"language": 6496
	},
	"tdb": {
		"language": 6497
	},
	"tdc": {
		"language": 6498
	},
	"tdd": {
		"language": 6499
	},
	"tde": {
		"language": 6500
	},
	"tdf": {
		"language": 6501
	},
	"tdg": {
		"language": 6502
	},
	"tdh": {
		"language": 6503
	},
	"tdi": {
		"language": 6504
	},
	"tdj": {
		"language": 6505
	},
	"tdk": {
		"language": 6506
	},
	"tdl": {
		"language": 6507
	},
	"tdm": {
		"language": 6508
	},
	"tdn": {
		"language": 6509
	},
	"tdo": {
		"language": 6510
	},
	"tdq": {
		"language": 6511
	},
	"tdr": {
		"language": 6512
	},
	"tds": {
		"language": 6513
	},
	"tdt": {
		"language": 6514
	},
	"tdu": {
		"language": 6515
	},
	"tdv": {
		"language": 6516
	},
	"tdx": {
		"language": 6517
	},
	"tdy": {
		"language": 6518
	},
	"tea": {
		"language": 6519
	},
	"teb": {
		"language": 6520
	},
	"tec": {
		"language": 6521
	},
	"ted": {
		"language": 6522
	},
	"tee": {
		"language": 6523
	},
	"tef": {
		"language": 6524
	},
	"teg": {
		"language": 6525
	},
	"teh": {
		"language": 6526
	},
	"tei": {
		"language": 6527
	},
	"tek": {
		"language": 6528
	},
	"tem": {
		"language": 6529
	},
	"ten": {
		"language": 6530
	},
	"teo": {
		"language": 6531
	},
	"tep": {
		"language": 6532
	},
	"teq": {
		"language": 6533
	},
	"ter": {
		"language": 6534
	},
	"tes": {
		"language": 6535
	},
	"tet": {
		"language": 6536
	},
	"teu": {
		"language": 6537
	},
	"tev": {
		"language": 6538
	},
	"tew": {
		"language": 6539
	},
	"tex": {
		"language": 6540
	},
	"tey": {
		"language": 6541
	},
	"tfi": {
		"language": 6542
	},
	"tfn": {
		"language": 6543
	},
	"tfo": {
		"language": 6544
	},
	"tfr": {
		"language": 6545
	},
	"tft": {
		"language": 6546
	},
	"tga": {
		"language": 6547
	},
	"tgb": {
		"language": 6548
	},
	"tgc": {
		"language": 6549
	},
	"tgd": {
		"language": 6550
	},
	"tge": {
		"language": 6551
	},
	"tgf": {
		"language": 6552
	},
	"tgg": {
		"language": 6553
	},
	"tgh": {
		"language": 6554
	},
	"tgi": {
		"language": 6555
	},
	"tgj": {
		"language": 6556
	},
	"tgn": {
		"language": 6557
	},
	"tgo": {
		"language": 6558
	},
	"tgp": {
		"language": 6559
	},
	"tgq": {
		"language": 6560
	},
	"tgr": {
		"language": 6561
	},
	"tgs": {
		"language": 6562
	},
	"tgt": {
		"language": 6563
	},
	"tgu": {
		"language": 6564
	},
	"tgv": {
		"language": 6565
	},
	"tgw": {
		"language": 6566
	},
	"tgx": {
		"language": 6567
	},
	"tgy": {
		"language": 6568
	},
	"tgz": {
		"language": 6569
	},
	"thc": {
		"language": 6570
	},
	"thd": {
		"language": 6571
	},
	"the": {
		"language": 6572
	},
	"thf": {
		"language": 6573
	},
	"thh": {
		"language": 6574
	},
	"thi": {
		"language": 6575
	},
	"thk": {
		"language": 6576
	},
	"thl": {
		"language": 6577
	},
	"thm": {
		"language": 6578
	},
	"thn": {
		"language": 6579
	},
	"thp": {
		"language": 6580
	},
	"thq": {
		"language": 6581
	},
	"thr": {
		"language": 6582
	},
	"ths": {
		"language": 6583
	},
	"tht": {
		"language": 6584
	},
	"thu": {
		"language": 6585
	},
	"thv": {
		"language": 6586
	},
	"thw": {
		"language": 6587
	},
	"thx": {
		"language": 6588
	},
	"thy": {
		"language": 6589
	},
	"thz": {
		"language": 6590
	},
	"tia": {
		"language": 6591
	},
	"tic": {
		"language": 6592
	},
	"tid": {
		"language": 6593
	},
	"tie": {
		"language": 6594
	},
	"tif": {
		"language": 6595
	},
	"tig": {
		"language": 6596
	},
	"tih": {
		"language": 6597
	},
	"tii": {
		"language": 6598
	},
	"tij": {
		"language": 6599
	},
	"tik": {
		"language": 6600
	},
	"til": {
		"language": 6601
	},
	"tim": {
		"language": 6602
	},
	"tin": {
		"language": 6603
	},
	"tio": {
		"language": 6604
	},
	"tip": {
		"language": 6605
	},
	"tiq": {
		"language": 6606
	},
	"tis": {
		"language": 6607
	},
	"tit": {
		"language": 6608
	},
	"tiu": {
		"language": 6609
	},
	"tiv": {
		"language": 6610
	},
	"tiw": {
		"language": 6611
	},
	"tix": {
		"language": 6612
	},
	"tiy": {
		"language": 6613
	},
	"tiz": {
		"language": 6614
	},
	"tja": {
		"language": 6615
	},
	"tjg": {
		"language": 6616
	},
	"tji": {
		"language": 6617
	},
	"tjl": {
		"language": 6618
	},
	"tjm": {
		"language": 6619
	},
	"tjn": {
		"language": 6620
	},
	"tjo": {
		"language": 6621
	},
	"tjs": {
		"language": 6622
	},
	"tju": {
		"language": 6623
	},
	"tjw": {
		"language": 6624
	},
	"tka": {
		"language": 6625
	},
	"tkb": {
		"language": 6626
	},
	"tkd": {
		"language": 6627
	},
	"tke": {
		"language": 6628
	},
	"tkf": {
		"language": 6629
	},
	"tkg": {
		"language": 6630
	},
	"tkk": {
		"language": 6631
	},
	"tkl": {
		"language": 6632
	},
	"tkm": {
		"language": 6633
	},
	"tkn": {
		"language": 6634
	},
	"tkp": {
		"language": 6635
	},
	"tkq": {
		"language": 6636
	},
	"tkr": {
		"language": 6637
	},
	"tks": {
		"language": 6638
	},
	"tkt": {
		"language": 6639
	},
	"tku": {
		"language": 6640
	},
	"tkv": {
		"language": 6641
	},
	"tkw": {
		"language": 6642
	},
	"tkx": {
		"language": 6643
	},
	"tkz": {
		"language": 6644
	},
	"tla": {
		"language": 6645
	},
	"tlb": {
		"language": 6646
	},
	"tlc": {
		"language": 6647
	},
	"tld": {
		"language": 6648
	},
	"tlf": {
		"language": 6649
	},
	"tlg": {
		"language": 6650
	},
	"tlh": {
		"language": 6651
	},
	"tli": {
		"language": 6652
	},
	"tlj": {
		"language": 6653
	},
	"tlk": {
		"language": 6654
	},
	"tll": {
		"language": 6655
	},
	"tlm": {
		"language": 6656
	},
	"tln": {
		"language": 6657
	},
	"tlo": {
		"language": 6658
	},
	"tlp": {
		"language": 6659
	},
	"tlq": {
		"language": 6660
	},
	"tlr": {
		"language": 6661
	},
	"tls": {
		"language": 6662
	},
	"tlt": {
		"language": 6663
	},
	"tlu": {
		"language": 6664
	},
	"tlv": {
		"language": 6665
	},
	"tlw": {
		"language": 6666
	},
	"tlx": {
		"language": 6667
	},
	"tly": {
		"language": 6668
	},
	"tma": {
		"language": 6669
	},
	"tmb": {
		"language": 6670
	},
	"tmc": {
		"language": 6671
	},
	"tmd": {
		"language": 6672
	},
	"tme": {
		"language": 6673
	},
	"tmf": {
		"language": 6674
	},
	"tmg": {
		"language": 6675
	},
	"tmh": {
		"language": 6676
	},
	"tmi": {
		"language": 6677
	},
	"tmj": {
		"language": 6678
	},
	"tmk": {
		"language": 6679
	},
	"tml": {
		"language": 6680
	},
	"tmm": {
		"language": 6681
	},
	"tmn": {
		"language": 6682
	},
	"tmo": {
		"language": 6683
	},
	"tmp": {
		"language": 6684
	},
	"tmq": {
		"language": 6685
	},
	"tmr": {
		"language": 6686
	},
	"tms": {
		"language": 6687
	},
	"tmt": {
		"language": 6688
	},
	"tmu": {
		"language": 6689
	},
	"tmv": {
		"language": 6690
	},
	"tmw": {
		"language": 6691,
		"extlang": 8324
	},
	"tmy": {
		"language": 6692
	},
	"tmz": {
		"language": 6693
	},
	"tna": {
		"language": 6694
	},
	"tnb": {
		"language": 6695
	},
	"tnc": {
		"language": 6696
	},
	"tnd": {
		"language": 6697
	},
	"tne": {
		"language": 6698
	},
	"tnf": {
		"language": 6699
	},
	"tng": {
		"language": 6700
	},
	"tnh": {
		"language": 6701
	},
	"tni": {
		"language": 6702
	},
	"tnk": {
		"language": 6703
	},
	"tnl": {
		"language": 6704
	},
	"tnm": {
		"language": 6705
	},
	"tnn": {
		"language": 6706
	},
	"tno": {
		"language": 6707
	},
	"tnp": {
		"language": 6708
	},
	"tnq": {
		"language": 6709
	},
	"tnr": {
		"language": 6710
	},
	"tns": {
		"language": 6711
	},
	"tnt": {
		"language": 6712
	},
	"tnu": {
		"language": 6713
	},
	"tnv": {
		"language": 6714
	},
	"tnw": {
		"language": 6715
	},
	"tnx": {
		"language": 6716
	},
	"tny": {
		"language": 6717
	},
	"tnz": {
		"language": 6718
	},
	"tob": {
		"language": 6719
	},
	"toc": {
		"language": 6720
	},
	"tod": {
		"language": 6721
	},
	"toe": {
		"language": 6722
	},
	"tof": {
		"language": 6723
	},
	"tog": {
		"language": 6724
	},
	"toh": {
		"language": 6725
	},
	"toi": {
		"language": 6726
	},
	"toj": {
		"language": 6727
	},
	"tol": {
		"language": 6728
	},
	"tom": {
		"language": 6729
	},
	"too": {
		"language": 6730
	},
	"top": {
		"language": 6731
	},
	"toq": {
		"language": 6732
	},
	"tor": {
		"language": 6733
	},
	"tos": {
		"language": 6734
	},
	"tou": {
		"language": 6735
	},
	"tov": {
		"language": 6736
	},
	"tow": {
		"language": 6737
	},
	"tox": {
		"language": 6738
	},
	"toy": {
		"language": 6739
	},
	"toz": {
		"language": 6740
	},
	"tpa": {
		"language": 6741
	},
	"tpc": {
		"language": 6742
	},
	"tpe": {
		"language": 6743
	},
	"tpf": {
		"language": 6744
	},
	"tpg": {
		"language": 6745
	},
	"tpi": {
		"language": 6746
	},
	"tpj": {
		"language": 6747
	},
	"tpk": {
		"language": 6748
	},
	"tpl": {
		"language": 6749
	},
	"tpm": {
		"language": 6750
	},
	"tpn": {
		"language": 6751
	},
	"tpo": {
		"language": 6752
	},
	"tpp": {
		"language": 6753
	},
	"tpq": {
		"language": 6754
	},
	"tpr": {
		"language": 6755
	},
	"tpt": {
		"language": 6756
	},
	"tpu": {
		"language": 6757
	},
	"tpv": {
		"language": 6758
	},
	"tpw": {
		"language": 6759
	},
	"tpx": {
		"language": 6760
	},
	"tpy": {
		"language": 6761
	},
	"tpz": {
		"language": 6762
	},
	"tqb": {
		"language": 6763
	},
	"tql": {
		"language": 6764
	},
	"tqm": {
		"language": 6765
	},
	"tqn": {
		"language": 6766
	},
	"tqo": {
		"language": 6767
	},
	"tqp": {
		"language": 6768
	},
	"tqq": {
		"language": 6769
	},
	"tqr": {
		"language": 6770
	},
	"tqt": {
		"language": 6771
	},
	"tqu": {
		"language": 6772
	},
	"tqw": {
		"language": 6773
	},
	"tra": {
		"language": 6774
	},
	"trb": {
		"language": 6775
	},
	"trc": {
		"language": 6776
	},
	"trd": {
		"language": 6777
	},
	"tre": {
		"language": 6778
	},
	"trf": {
		"language": 6779
	},
	"trg": {
		"language": 6780
	},
	"trh": {
		"language": 6781
	},
	"tri": {
		"language": 6782
	},
	"trj": {
		"language": 6783
	},
	"trk": {
		"language": 6784
	},
	"trl": {
		"language": 6785
	},
	"trm": {
		"language": 6786
	},
	"trn": {
		"language": 6787
	},
	"tro": {
		"language": 6788
	},
	"trp": {
		"language": 6789
	},
	"trq": {
		"language": 6790
	},
	"trr": {
		"language": 6791
	},
	"trs": {
		"language": 6792
	},
	"trt": {
		"language": 6793
	},
	"tru": {
		"language": 6794
	},
	"trv": {
		"language": 6795
	},
	"trw": {
		"language": 6796
	},
	"trx": {
		"language": 6797
	},
	"try": {
		"language": 6798
	},
	"trz": {
		"language": 6799
	},
	"tsa": {
		"language": 6800
	},
	"tsb": {
		"language": 6801
	},
	"tsc": {
		"language": 6802
	},
	"tsd": {
		"language": 6803
	},
	"tse": {
		"language": 6804,
		"extlang": 8325
	},
	"tsf": {
		"language": 6805
	},
	"tsg": {
		"language": 6806
	},
	"tsh": {
		"language": 6807
	},
	"tsi": {
		"language": 6808
	},
	"tsj": {
		"language": 6809
	},
	"tsk": {
		"language": 6810
	},
	"tsl": {
		"language": 6811
	},
	"tsm": {
		"language": 6812,
		"extlang": 8326
	},
	"tsp": {
		"language": 6813
	},
	"tsq": {
		"language": 6814,
		"extlang": 8327
	},
	"tsr": {
		"language": 6815
	},
	"tss": {
		"language": 6816,
		"extlang": 8328
	},
	"tst": {
		"language": 6817
	},
	"tsu": {
		"language": 6818
	},
	"tsv": {
		"language": 6819
	},
	"tsw": {
		"language": 6820
	},
	"tsx": {
		"language": 6821
	},
	"tsy": {
		"language": 6822,
		"extlang": 8329
	},
	"tsz": {
		"language": 6823
	},
	"tta": {
		"language": 6824
	},
	"ttb": {
		"language": 6825
	},
	"ttc": {
		"language": 6826
	},
	"ttd": {
		"language": 6827
	},
	"tte": {
		"language": 6828
	},
	"ttf": {
		"language": 6829
	},
	"ttg": {
		"language": 6830
	},
	"tth": {
		"language": 6831
	},
	"tti": {
		"language": 6832
	},
	"ttj": {
		"language": 6833
	},
	"ttk": {
		"language": 6834
	},
	"ttl": {
		"language": 6835
	},
	"ttm": {
		"language": 6836
	},
	"ttn": {
		"language": 6837
	},
	"tto": {
		"language": 6838
	},
	"ttp": {
		"language": 6839
	},
	"ttq": {
		"language": 6840
	},
	"ttr": {
		"language": 6841
	},
	"tts": {
		"language": 6842
	},
	"ttt": {
		"language": 6843
	},
	"ttu": {
		"language": 6844
	},
	"ttv": {
		"language": 6845
	},
	"ttw": {
		"language": 6846
	},
	"tty": {
		"language": 6847
	},
	"ttz": {
		"language": 6848
	},
	"tua": {
		"language": 6849
	},
	"tub": {
		"language": 6850
	},
	"tuc": {
		"language": 6851
	},
	"tud": {
		"language": 6852
	},
	"tue": {
		"language": 6853
	},
	"tuf": {
		"language": 6854
	},
	"tug": {
		"language": 6855
	},
	"tuh": {
		"language": 6856
	},
	"tui": {
		"language": 6857
	},
	"tuj": {
		"language": 6858
	},
	"tul": {
		"language": 6859
	},
	"tum": {
		"language": 6860
	},
	"tun": {
		"language": 6861
	},
	"tuo": {
		"language": 6862
	},
	"tup": {
		"language": 6863
	},
	"tuq": {
		"language": 6864
	},
	"tus": {
		"language": 6865
	},
	"tut": {
		"language": 6866
	},
	"tuu": {
		"language": 6867
	},
	"tuv": {
		"language": 6868
	},
	"tuw": {
		"language": 6869
	},
	"tux": {
		"language": 6870
	},
	"tuy": {
		"language": 6871
	},
	"tuz": {
		"language": 6872
	},
	"tva": {
		"language": 6873
	},
	"tvd": {
		"language": 6874
	},
	"tve": {
		"language": 6875
	},
	"tvk": {
		"language": 6876
	},
	"tvl": {
		"language": 6877
	},
	"tvm": {
		"language": 6878
	},
	"tvn": {
		"language": 6879
	},
	"tvo": {
		"language": 6880
	},
	"tvs": {
		"language": 6881
	},
	"tvt": {
		"language": 6882
	},
	"tvu": {
		"language": 6883
	},
	"tvw": {
		"language": 6884
	},
	"tvy": {
		"language": 6885
	},
	"twa": {
		"language": 6886
	},
	"twb": {
		"language": 6887
	},
	"twc": {
		"language": 6888
	},
	"twd": {
		"language": 6889
	},
	"twe": {
		"language": 6890
	},
	"twf": {
		"language": 6891
	},
	"twg": {
		"language": 6892
	},
	"twh": {
		"language": 6893
	},
	"twl": {
		"language": 6894
	},
	"twm": {
		"language": 6895
	},
	"twn": {
		"language": 6896
	},
	"two": {
		"language": 6897
	},
	"twp": {
		"language": 6898
	},
	"twq": {
		"language": 6899
	},
	"twr": {
		"language": 6900
	},
	"twt": {
		"language": 6901
	},
	"twu": {
		"language": 6902
	},
	"tww": {
		"language": 6903
	},
	"twx": {
		"language": 6904
	},
	"twy": {
		"language": 6905
	},
	"txa": {
		"language": 6906
	},
	"txb": {
		"language": 6907
	},
	"txc": {
		"language": 6908
	},
	"txe": {
		"language": 6909
	},
	"txg": {
		"language": 6910
	},
	"txh": {
		"language": 6911
	},
	"txi": {
		"language": 6912
	},
	"txj": {
		"language": 6913
	},
	"txm": {
		"language": 6914
	},
	"txn": {
		"language": 6915
	},
	"txo": {
		"language": 6916
	},
	"txq": {
		"language": 6917
	},
	"txr": {
		"language": 6918
	},
	"txs": {
		"language": 6919
	},
	"txt": {
		"language": 6920
	},
	"txu": {
		"language": 6921
	},
	"txx": {
		"language": 6922
	},
	"txy": {
		"language": 6923
	},
	"tya": {
		"language": 6924
	},
	"tye": {
		"language": 6925
	},
	"tyh": {
		"language": 6926
	},
	"tyi": {
		"language": 6927
	},
	"tyj": {
		"language": 6928
	},
	"tyl": {
		"language": 6929
	},
	"tyn": {
		"language": 6930
	},
	"typ": {
		"language": 6931
	},
	"tyr": {
		"language": 6932
	},
	"tys": {
		"language": 6933
	},
	"tyt": {
		"language": 6934
	},
	"tyu": {
		"language": 6935
	},
	"tyv": {
		"language": 6936
	},
	"tyx": {
		"language": 6937
	},
	"tyz": {
		"language": 6938
	},
	"tza": {
		"language": 6939,
		"extlang": 8330
	},
	"tzh": {
		"language": 6940
	},
	"tzj": {
		"language": 6941
	},
	"tzl": {
		"language": 6942
	},
	"tzm": {
		"language": 6943
	},
	"tzn": {
		"language": 6944
	},
	"tzo": {
		"language": 6945
	},
	"tzx": {
		"language": 6946
	},
	"uam": {
		"language": 6947
	},
	"uan": {
		"language": 6948
	},
	"uar": {
		"language": 6949
	},
	"uba": {
		"language": 6950
	},
	"ubi": {
		"language": 6951
	},
	"ubl": {
		"language": 6952
	},
	"ubr": {
		"language": 6953
	},
	"ubu": {
		"language": 6954
	},
	"uby": {
		"language": 6955
	},
	"uda": {
		"language": 6956
	},
	"ude": {
		"language": 6957
	},
	"udg": {
		"language": 6958
	},
	"udi": {
		"language": 6959
	},
	"udj": {
		"language": 6960
	},
	"udl": {
		"language": 6961
	},
	"udm": {
		"language": 6962
	},
	"udu": {
		"language": 6963
	},
	"ues": {
		"language": 6964
	},
	"ufi": {
		"language": 6965
	},
	"uga": {
		"language": 6966
	},
	"ugb": {
		"language": 6967
	},
	"uge": {
		"language": 6968
	},
	"ugn": {
		"language": 6969,
		"extlang": 8331
	},
	"ugo": {
		"language": 6970
	},
	"ugy": {
		"language": 6971,
		"extlang": 8332
	},
	"uha": {
		"language": 6972
	},
	"uhn": {
		"language": 6973
	},
	"uis": {
		"language": 6974
	},
	"uiv": {
		"language": 6975
	},
	"uji": {
		"language": 6976
	},
	"uka": {
		"language": 6977
	},
	"ukg": {
		"language": 6978
	},
	"ukh": {
		"language": 6979
	},
	"ukk": {
		"language": 6980
	},
	"ukl": {
		"language": 6981,
		"extlang": 8333
	},
	"ukp": {
		"language": 6982
	},
	"ukq": {
		"language": 6983
	},
	"uks": {
		"language": 6984,
		"extlang": 8334
	},
	"uku": {
		"language": 6985
	},
	"ukw": {
		"language": 6986
	},
	"uky": {
		"language": 6987
	},
	"ula": {
		"language": 6988
	},
	"ulb": {
		"language": 6989
	},
	"ulc": {
		"language": 6990
	},
	"ule": {
		"language": 6991
	},
	"ulf": {
		"language": 6992
	},
	"uli": {
		"language": 6993
	},
	"ulk": {
		"language": 6994
	},
	"ull": {
		"language": 6995
	},
	"ulm": {
		"language": 6996
	},
	"uln": {
		"language": 6997
	},
	"ulu": {
		"language": 6998
	},
	"ulw": {
		"language": 6999
	},
	"uma": {
		"language": 7000
	},
	"umb": {
		"language": 7001
	},
	"umc": {
		"language": 7002
	},
	"umd": {
		"language": 7003
	},
	"umg": {
		"language": 7004
	},
	"umi": {
		"language": 7005
	},
	"umm": {
		"language": 7006
	},
	"umn": {
		"language": 7007
	},
	"umo": {
		"language": 7008
	},
	"ump": {
		"language": 7009
	},
	"umr": {
		"language": 7010
	},
	"ums": {
		"language": 7011
	},
	"umu": {
		"language": 7012
	},
	"una": {
		"language": 7013
	},
	"und": {
		"language": 7014
	},
	"une": {
		"language": 7015
	},
	"ung": {
		"language": 7016
	},
	"unk": {
		"language": 7017
	},
	"unm": {
		"language": 7018
	},
	"unn": {
		"language": 7019
	},
	"unp": {
		"language": 7020
	},
	"unr": {
		"language": 7021
	},
	"unu": {
		"language": 7022
	},
	"unx": {
		"language": 7023
	},
	"unz": {
		"language": 7024
	},
	"uok": {
		"language": 7025
	},
	"upi": {
		"language": 7026
	},
	"upv": {
		"language": 7027
	},
	"ura": {
		"language": 7028
	},
	"urb": {
		"language": 7029
	},
	"urc": {
		"language": 7030
	},
	"ure": {
		"language": 7031
	},
	"urf": {
		"language": 7032
	},
	"urg": {
		"language": 7033
	},
	"urh": {
		"language": 7034
	},
	"uri": {
		"language": 7035
	},
	"urj": {
		"language": 7036
	},
	"urk": {
		"language": 7037,
		"extlang": 8335
	},
	"url": {
		"language": 7038
	},
	"urm": {
		"language": 7039
	},
	"urn": {
		"language": 7040
	},
	"uro": {
		"language": 7041
	},
	"urp": {
		"language": 7042
	},
	"urr": {
		"language": 7043
	},
	"urt": {
		"language": 7044
	},
	"uru": {
		"language": 7045
	},
	"urv": {
		"language": 7046
	},
	"urw": {
		"language": 7047
	},
	"urx": {
		"language": 7048
	},
	"ury": {
		"language": 7049
	},
	"urz": {
		"language": 7050
	},
	"usa": {
		"language": 7051
	},
	"ush": {
		"language": 7052
	},
	"usi": {
		"language": 7053
	},
	"usk": {
		"language": 7054
	},
	"usp": {
		"language": 7055
	},
	"usu": {
		"language": 7056
	},
	"uta": {
		"language": 7057
	},
	"ute": {
		"language": 7058
	},
	"utp": {
		"language": 7059
	},
	"utr": {
		"language": 7060
	},
	"utu": {
		"language": 7061
	},
	"uum": {
		"language": 7062
	},
	"uun": {
		"language": 7063
	},
	"uur": {
		"language": 7064
	},
	"uuu": {
		"language": 7065
	},
	"uve": {
		"language": 7066
	},
	"uvh": {
		"language": 7067
	},
	"uvl": {
		"language": 7068
	},
	"uwa": {
		"language": 7069
	},
	"uya": {
		"language": 7070
	},
	"uzn": {
		"language": 7071,
		"extlang": 8336
	},
	"uzs": {
		"language": 7072,
		"extlang": 8337
	},
	"vaa": {
		"language": 7073
	},
	"vae": {
		"language": 7074
	},
	"vaf": {
		"language": 7075
	},
	"vag": {
		"language": 7076
	},
	"vah": {
		"language": 7077
	},
	"vai": {
		"language": 7078
	},
	"vaj": {
		"language": 7079
	},
	"val": {
		"language": 7080
	},
	"vam": {
		"language": 7081
	},
	"van": {
		"language": 7082
	},
	"vao": {
		"language": 7083
	},
	"vap": {
		"language": 7084
	},
	"var": {
		"language": 7085
	},
	"vas": {
		"language": 7086
	},
	"vau": {
		"language": 7087
	},
	"vav": {
		"language": 7088
	},
	"vay": {
		"language": 7089
	},
	"vbb": {
		"language": 7090
	},
	"vbk": {
		"language": 7091
	},
	"vec": {
		"language": 7092
	},
	"ved": {
		"language": 7093
	},
	"vel": {
		"language": 7094
	},
	"vem": {
		"language": 7095
	},
	"veo": {
		"language": 7096
	},
	"vep": {
		"language": 7097
	},
	"ver": {
		"language": 7098
	},
	"vgr": {
		"language": 7099
	},
	"vgt": {
		"language": 7100,
		"extlang": 8338
	},
	"vic": {
		"language": 7101
	},
	"vid": {
		"language": 7102
	},
	"vif": {
		"language": 7103
	},
	"vig": {
		"language": 7104
	},
	"vil": {
		"language": 7105
	},
	"vin": {
		"language": 7106
	},
	"vis": {
		"language": 7107
	},
	"vit": {
		"language": 7108
	},
	"viv": {
		"language": 7109
	},
	"vka": {
		"language": 7110
	},
	"vki": {
		"language": 7111
	},
	"vkj": {
		"language": 7112
	},
	"vkk": {
		"language": 7113,
		"extlang": 8339
	},
	"vkl": {
		"language": 7114
	},
	"vkm": {
		"language": 7115
	},
	"vko": {
		"language": 7116
	},
	"vkp": {
		"language": 7117
	},
	"vkt": {
		"language": 7118,
		"extlang": 8340
	},
	"vku": {
		"language": 7119
	},
	"vlp": {
		"language": 7120
	},
	"vls": {
		"language": 7121
	},
	"vma": {
		"language": 7122
	},
	"vmb": {
		"language": 7123
	},
	"vmc": {
		"language": 7124
	},
	"vmd": {
		"language": 7125
	},
	"vme": {
		"language": 7126
	},
	"vmf": {
		"language": 7127
	},
	"vmg": {
		"language": 7128
	},
	"vmh": {
		"language": 7129
	},
	"vmi": {
		"language": 7130
	},
	"vmj": {
		"language": 7131
	},
	"vmk": {
		"language": 7132
	},
	"vml": {
		"language": 7133
	},
	"vmm": {
		"language": 7134
	},
	"vmp": {
		"language": 7135
	},
	"vmq": {
		"language": 7136
	},
	"vmr": {
		"language": 7137
	},
	"vms": {
		"language": 7138
	},
	"vmu": {
		"language": 7139
	},
	"vmv": {
		"language": 7140
	},
	"vmw": {
		"language": 7141
	},
	"vmx": {
		"language": 7142
	},
	"vmy": {
		"language": 7143
	},
	"vmz": {
		"language": 7144
	},
	"vnk": {
		"language": 7145
	},
	"vnm": {
		"language": 7146
	},
	"vnp": {
		"language": 7147
	},
	"vor": {
		"language": 7148
	},
	"vot": {
		"language": 7149
	},
	"vra": {
		"language": 7150
	},
	"vro": {
		"language": 7151
	},
	"vrs": {
		"language": 7152
	},
	"vrt": {
		"language": 7153
	},
	"vsi": {
		"language": 7154,
		"extlang": 8341
	},
	"vsl": {
		"language": 7155,
		"extlang": 8342
	},
	"vsv": {
		"language": 7156,
		"extlang": 8343
	},
	"vto": {
		"language": 7157
	},
	"vum": {
		"language": 7158
	},
	"vun": {
		"language": 7159
	},
	"vut": {
		"language": 7160
	},
	"vwa": {
		"language": 7161
	},
	"waa": {
		"language": 7162
	},
	"wab": {
		"language": 7163
	},
	"wac": {
		"language": 7164
	},
	"wad": {
		"language": 7165
	},
	"wae": {
		"language": 7166
	},
	"waf": {
		"language": 7167
	},
	"wag": {
		"language": 7168
	},
	"wah": {
		"language": 7169
	},
	"wai": {
		"language": 7170
	},
	"waj": {
		"language": 7171
	},
	"wak": {
		"language": 7172
	},
	"wal": {
		"language": 7173
	},
	"wam": {
		"language": 7174
	},
	"wan": {
		"language": 7175
	},
	"wao": {
		"language": 7176
	},
	"wap": {
		"language": 7177
	},
	"waq": {
		"language": 7178
	},
	"war": {
		"language": 7179
	},
	"was": {
		"language": 7180
	},
	"wat": {
		"language": 7181
	},
	"wau": {
		"language": 7182
	},
	"wav": {
		"language": 7183
	},
	"waw": {
		"language": 7184
	},
	"wax": {
		"language": 7185
	},
	"way": {
		"language": 7186
	},
	"waz": {
		"language": 7187
	},
	"wba": {
		"language": 7188
	},
	"wbb": {
		"language": 7189
	},
	"wbe": {
		"language": 7190
	},
	"wbf": {
		"language": 7191
	},
	"wbh": {
		"language": 7192
	},
	"wbi": {
		"language": 7193
	},
	"wbj": {
		"language": 7194
	},
	"wbk": {
		"language": 7195
	},
	"wbl": {
		"language": 7196
	},
	"wbm": {
		"language": 7197
	},
	"wbp": {
		"language": 7198
	},
	"wbq": {
		"language": 7199
	},
	"wbr": {
		"language": 7200
	},
	"wbs": {
		"language": 7201,
		"extlang": 8344
	},
	"wbt": {
		"language": 7202
	},
	"wbv": {
		"language": 7203
	},
	"wbw": {
		"language": 7204
	},
	"wca": {
		"language": 7205
	},
	"wci": {
		"language": 7206
	},
	"wdd": {
		"language": 7207
	},
	"wdg": {
		"language": 7208
	},
	"wdj": {
		"language": 7209
	},
	"wdk": {
		"language": 7210
	},
	"wdu": {
		"language": 7211
	},
	"wdy": {
		"language": 7212
	},
	"wea": {
		"language": 7213
	},
	"wec": {
		"language": 7214
	},
	"wed": {
		"language": 7215
	},
	"weg": {
		"language": 7216
	},
	"weh": {
		"language": 7217
	},
	"wei": {
		"language": 7218
	},
	"wem": {
		"language": 7219
	},
	"wen": {
		"language": 7220
	},
	"weo": {
		"language": 7221
	},
	"wep": {
		"language": 7222
	},
	"wer": {
		"language": 7223
	},
	"wes": {
		"language": 7224
	},
	"wet": {
		"language": 7225
	},
	"weu": {
		"language": 7226
	},
	"wew": {
		"language": 7227
	},
	"wfg": {
		"language": 7228
	},
	"wga": {
		"language": 7229
	},
	"wgb": {
		"language": 7230
	},
	"wgg": {
		"language": 7231
	},
	"wgi": {
		"language": 7232
	},
	"wgo": {
		"language": 7233
	},
	"wgu": {
		"language": 7234
	},
	"wgw": {
		"language": 7235
	},
	"wgy": {
		"language": 7236
	},
	"wha": {
		"language": 7237
	},
	"whg": {
		"language": 7238
	},
	"whk": {
		"language": 7239
	},
	"whu": {
		"language": 7240
	},
	"wib": {
		"language": 7241
	},
	"wic": {
		"language": 7242
	},
	"wie": {
		"language": 7243
	},
	"wif": {
		"language": 7244
	},
	"wig": {
		"language": 7245
	},
	"wih": {
		"language": 7246
	},
	"wii": {
		"language": 7247
	},
	"wij": {
		"language": 7248
	},
	"wik": {
		"language": 7249
	},
	"wil": {
		"language": 7250
	},
	"wim": {
		"language": 7251
	},
	"win": {
		"language": 7252
	},
	"wir": {
		"language": 7253
	},
	"wit": {
		"language": 7254
	},
	"wiu": {
		"language": 7255
	},
	"wiv": {
		"language": 7256
	},
	"wiw": {
		"language": 7257
	},
	"wiy": {
		"language": 7258
	},
	"wja": {
		"language": 7259
	},
	"wji": {
		"language": 7260
	},
	"wka": {
		"language": 7261
	},
	"wkb": {
		"language": 7262
	},
	"wkd": {
		"language": 7263
	},
	"wkl": {
		"language": 7264
	},
	"wku": {
		"language": 7265
	},
	"wkw": {
		"language": 7266
	},
	"wky": {
		"language": 7267
	},
	"wla": {
		"language": 7268
	},
	"wlc": {
		"language": 7269
	},
	"wle": {
		"language": 7270
	},
	"wlg": {
		"language": 7271
	},
	"wli": {
		"language": 7272
	},
	"wlk": {
		"language": 7273
	},
	"wll": {
		"language": 7274
	},
	"wlm": {
		"language": 7275
	},
	"wlo": {
		"language": 7276
	},
	"wlr": {
		"language": 7277
	},
	"wls": {
		"language": 7278
	},
	"wlu": {
		"language": 7279
	},
	"wlv": {
		"language": 7280
	},
	"wlw": {
		"language": 7281
	},
	"wlx": {
		"language": 7282
	},
	"wly": {
		"language": 7283
	},
	"wma": {
		"language": 7284
	},
	"wmb": {
		"language": 7285
	},
	"wmc": {
		"language": 7286
	},
	"wmd": {
		"language": 7287
	},
	"wme": {
		"language": 7288
	},
	"wmh": {
		"language": 7289
	},
	"wmi": {
		"language": 7290
	},
	"wmm": {
		"language": 7291
	},
	"wmn": {
		"language": 7292
	},
	"wmo": {
		"language": 7293
	},
	"wms": {
		"language": 7294
	},
	"wmt": {
		"language": 7295
	},
	"wmw": {
		"language": 7296
	},
	"wmx": {
		"language": 7297
	},
	"wnb": {
		"language": 7298
	},
	"wnc": {
		"language": 7299
	},
	"wnd": {
		"language": 7300
	},
	"wne": {
		"language": 7301
	},
	"wng": {
		"language": 7302
	},
	"wni": {
		"language": 7303
	},
	"wnk": {
		"language": 7304
	},
	"wnm": {
		"language": 7305
	},
	"wnn": {
		"language": 7306
	},
	"wno": {
		"language": 7307
	},
	"wnp": {
		"language": 7308
	},
	"wnu": {
		"language": 7309
	},
	"wnw": {
		"language": 7310
	},
	"wny": {
		"language": 7311
	},
	"woa": {
		"language": 7312
	},
	"wob": {
		"language": 7313
	},
	"woc": {
		"language": 7314
	},
	"wod": {
		"language": 7315
	},
	"woe": {
		"language": 7316
	},
	"wof": {
		"language": 7317
	},
	"wog": {
		"language": 7318
	},
	"woi": {
		"language": 7319
	},
	"wok": {
		"language": 7320
	},
	"wom": {
		"language": 7321
	},
	"won": {
		"language": 7322
	},
	"woo": {
		"language": 7323
	},
	"wor": {
		"language": 7324
	},
	"wos": {
		"language": 7325
	},
	"wow": {
		"language": 7326
	},
	"woy": {
		"language": 7327
	},
	"wpc": {
		"language": 7328
	},
	"wra": {
		"language": 7329
	},
	"wrb": {
		"language": 7330
	},
	"wrd": {
		"language": 7331
	},
	"wrg": {
		"language": 7332
	},
	"wrh": {
		"language": 7333
	},
	"wri": {
		"language": 7334
	},
	"wrk": {
		"language": 7335
	},
	"wrl": {
		"language": 7336
	},
	"wrm": {
		"language": 7337
	},
	"wrn": {
		"language": 7338
	},
	"wro": {
		"language": 7339
	},
	"wrp": {
		"language": 7340
	},
	"wrr": {
		"language": 7341
	},
	"wrs": {
		"language": 7342
	},
	"wru": {
		"language": 7343
	},
	"wrv": {
		"language": 7344
	},
	"wrw": {
		"language": 7345
	},
	"wrx": {
		"language": 7346
	},
	"wry": {
		"language": 7347
	},
	"wrz": {
		"language": 7348
	},
	"wsa": {
		"language": 7349
	},
	"wsg": {
		"language": 7350
	},
	"wsi": {
		"language": 7351
	},
	"wsk": {
		"language": 7352
	},
	"wsr": {
		"language": 7353
	},
	"wss": {
		"language": 7354
	},
	"wsu": {
		"language": 7355
	},
	"wsv": {
		"language": 7356
	},
	"wtf": {
		"language": 7357
	},
	"wth": {
		"language": 7358
	},
	"wti": {
		"language": 7359
	},
	"wtk": {
		"language": 7360
	},
	"wtm": {
		"language": 7361
	},
	"wtw": {
		"language": 7362
	},
	"wua": {
		"language": 7363
	},
	"wub": {
		"language": 7364
	},
	"wud": {
		"language": 7365
	},
	"wuh": {
		"language": 7366
	},
	"wul": {
		"language": 7367
	},
	"wum": {
		"language": 7368
	},
	"wun": {
		"language": 7369
	},
	"wur": {
		"language": 7370
	},
	"wut": {
		"language": 7371
	},
	"wuu": {
		"language": 7372,
		"extlang": 8345
	},
	"wuv": {
		"language": 7373
	},
	"wux": {
		"language": 7374
	},
	"wuy": {
		"language": 7375
	},
	"wwa": {
		"language": 7376
	},
	"wwb": {
		"language": 7377
	},
	"wwo": {
		"language": 7378
	},
	"wwr": {
		"language": 7379
	},
	"www": {
		"language": 7380
	},
	"wxa": {
		"language": 7381
	},
	"wxw": {
		"language": 7382
	},
	"wya": {
		"language": 7383
	},
	"wyb": {
		"language": 7384
	},
	"wyi": {
		"language": 7385
	},
	"wym": {
		"language": 7386
	},
	"wyr": {
		"language": 7387
	},
	"wyy": {
		"language": 7388
	},
	"xaa": {
		"language": 7389
	},
	"xab": {
		"language": 7390
	},
	"xac": {
		"language": 7391
	},
	"xad": {
		"language": 7392
	},
	"xae": {
		"language": 7393
	},
	"xag": {
		"language": 7394
	},
	"xai": {
		"language": 7395
	},
	"xaj": {
		"language": 7396
	},
	"xak": {
		"language": 7397
	},
	"xal": {
		"language": 7398
	},
	"xam": {
		"language": 7399
	},
	"xan": {
		"language": 7400
	},
	"xao": {
		"language": 7401
	},
	"xap": {
		"language": 7402
	},
	"xaq": {
		"language": 7403
	},
	"xar": {
		"language": 7404
	},
	"xas": {
		"language": 7405
	},
	"xat": {
		"language": 7406
	},
	"xau": {
		"language": 7407
	},
	"xav": {
		"language": 7408
	},
	"xaw": {
		"language": 7409
	},
	"xay": {
		"language": 7410
	},
	"xba": {
		"language": 7411
	},
	"xbb": {
		"language": 7412
	},
	"xbc": {
		"language": 7413
	},
	"xbd": {
		"language": 7414
	},
	"xbe": {
		"language": 7415
	},
	"xbg": {
		"language": 7416
	},
	"xbi": {
		"language": 7417
	},
	"xbj": {
		"language": 7418
	},
	"xbm": {
		"language": 7419
	},
	"xbn": {
		"language": 7420
	},
	"xbo": {
		"language": 7421
	},
	"xbp": {
		"language": 7422
	},
	"xbr": {
		"language": 7423
	},
	"xbw": {
		"language": 7424
	},
	"xbx": {
		"language": 7425
	},
	"xby": {
		"language": 7426
	},
	"xcb": {
		"language": 7427
	},
	"xcc": {
		"language": 7428
	},
	"xce": {
		"language": 7429
	},
	"xcg": {
		"language": 7430
	},
	"xch": {
		"language": 7431
	},
	"xcl": {
		"language": 7432
	},
	"xcm": {
		"language": 7433
	},
	"xcn": {
		"language": 7434
	},
	"xco": {
		"language": 7435
	},
	"xcr": {
		"language": 7436
	},
	"xct": {
		"language": 7437
	},
	"xcu": {
		"language": 7438
	},
	"xcv": {
		"language": 7439
	},
	"xcw": {
		"language": 7440
	},
	"xcy": {
		"language": 7441
	},
	"xda": {
		"language": 7442
	},
	"xdc": {
		"language": 7443
	},
	"xdk": {
		"language": 7444
	},
	"xdm": {
		"language": 7445
	},
	"xdo": {
		"language": 7446
	},
	"xdy": {
		"language": 7447
	},
	"xeb": {
		"language": 7448
	},
	"xed": {
		"language": 7449
	},
	"xeg": {
		"language": 7450
	},
	"xel": {
		"language": 7451
	},
	"xem": {
		"language": 7452
	},
	"xep": {
		"language": 7453
	},
	"xer": {
		"language": 7454
	},
	"xes": {
		"language": 7455
	},
	"xet": {
		"language": 7456
	},
	"xeu": {
		"language": 7457
	},
	"xfa": {
		"language": 7458
	},
	"xga": {
		"language": 7459
	},
	"xgb": {
		"language": 7460
	},
	"xgd": {
		"language": 7461
	},
	"xgf": {
		"language": 7462
	},
	"xgg": {
		"language": 7463
	},
	"xgi": {
		"language": 7464
	},
	"xgl": {
		"language": 7465
	},
	"xgm": {
		"language": 7466
	},
	"xgn": {
		"language": 7467
	},
	"xgr": {
		"language": 7468
	},
	"xgu": {
		"language": 7469
	},
	"xgw": {
		"language": 7470
	},
	"xha": {
		"language": 7471
	},
	"xhc": {
		"language": 7472
	},
	"xhd": {
		"language": 7473
	},
	"xhe": {
		"language": 7474
	},
	"xhr": {
		"language": 7475
	},
	"xht": {
		"language": 7476
	},
	"xhu": {
		"language": 7477
	},
	"xhv": {
		"language": 7478
	},
	"xia": {
		"language": 7479
	},
	"xib": {
		"language": 7480
	},
	"xii": {
		"language": 7481
	},
	"xil": {
		"language": 7482
	},
	"xin": {
		"language": 7483
	},
	"xip": {
		"language": 7484
	},
	"xir": {
		"language": 7485
	},
	"xis": {
		"language": 7486
	},
	"xiv": {
		"language": 7487
	},
	"xiy": {
		"language": 7488
	},
	"xjb": {
		"language": 7489
	},
	"xjt": {
		"language": 7490
	},
	"xka": {
		"language": 7491
	},
	"xkb": {
		"language": 7492
	},
	"xkc": {
		"language": 7493
	},
	"xkd": {
		"language": 7494
	},
	"xke": {
		"language": 7495
	},
	"xkf": {
		"language": 7496
	},
	"xkg": {
		"language": 7497
	},
	"xkh": {
		"language": 7498
	},
	"xki": {
		"language": 7499,
		"extlang": 8346
	},
	"xkj": {
		"language": 7500
	},
	"xkk": {
		"language": 7501
	},
	"xkl": {
		"language": 7502
	},
	"xkn": {
		"language": 7503
	},
	"xko": {
		"language": 7504
	},
	"xkp": {
		"language": 7505
	},
	"xkq": {
		"language": 7506
	},
	"xkr": {
		"language": 7507
	},
	"xks": {
		"language": 7508
	},
	"xkt": {
		"language": 7509
	},
	"xku": {
		"language": 7510
	},
	"xkv": {
		"language": 7511
	},
	"xkw": {
		"language": 7512
	},
	"xkx": {
		"language": 7513
	},
	"xky": {
		"language": 7514
	},
	"xkz": {
		"language": 7515
	},
	"xla": {
		"language": 7516
	},
	"xlb": {
		"language": 7517
	},
	"xlc": {
		"language": 7518
	},
	"xld": {
		"language": 7519
	},
	"xle": {
		"language": 7520
	},
	"xlg": {
		"language": 7521
	},
	"xli": {
		"language": 7522
	},
	"xln": {
		"language": 7523
	},
	"xlo": {
		"language": 7524
	},
	"xlp": {
		"language": 7525
	},
	"xls": {
		"language": 7526
	},
	"xlu": {
		"language": 7527
	},
	"xly": {
		"language": 7528
	},
	"xma": {
		"language": 7529
	},
	"xmb": {
		"language": 7530
	},
	"xmc": {
		"language": 7531
	},
	"xmd": {
		"language": 7532
	},
	"xme": {
		"language": 7533
	},
	"xmf": {
		"language": 7534
	},
	"xmg": {
		"language": 7535
	},
	"xmh": {
		"language": 7536
	},
	"xmj": {
		"language": 7537
	},
	"xmk": {
		"language": 7538
	},
	"xml": {
		"language": 7539,
		"extlang": 8347
	},
	"xmm": {
		"language": 7540,
		"extlang": 8348
	},
	"xmn": {
		"language": 7541
	},
	"xmo": {
		"language": 7542
	},
	"xmp": {
		"language": 7543
	},
	"xmq": {
		"language": 7544
	},
	"xmr": {
		"language": 7545
	},
	"xms": {
		"language": 7546,
		"extlang": 8349
	},
	"xmt": {
		"language": 7547
	},
	"xmu": {
		"language": 7548
	},
	"xmv": {
		"language": 7549
	},
	"xmw": {
		"language": 7550
	},
	"xmx": {
		"language": 7551
	},
	"xmy": {
		"language": 7552
	},
	"xmz": {
		"language": 7553
	},
	"xna": {
		"language": 7554
	},
	"xnb": {
		"language": 7555
	},
	"xnd": {
		"language": 7556
	},
	"xng": {
		"language": 7557
	},
	"xnh": {
		"language": 7558
	},
	"xni": {
		"language": 7559
	},
	"xnk": {
		"language": 7560
	},
	"xnn": {
		"language": 7561
	},
	"xno": {
		"language": 7562
	},
	"xnr": {
		"language": 7563
	},
	"xns": {
		"language": 7564
	},
	"xnt": {
		"language": 7565
	},
	"xnu": {
		"language": 7566
	},
	"xny": {
		"language": 7567
	},
	"xnz": {
		"language": 7568
	},
	"xoc": {
		"language": 7569
	},
	"xod": {
		"language": 7570
	},
	"xog": {
		"language": 7571
	},
	"xoi": {
		"language": 7572
	},
	"xok": {
		"language": 7573
	},
	"xom": {
		"language": 7574
	},
	"xon": {
		"language": 7575
	},
	"xoo": {
		"language": 7576
	},
	"xop": {
		"language": 7577
	},
	"xor": {
		"language": 7578
	},
	"xow": {
		"language": 7579
	},
	"xpa": {
		"language": 7580
	},
	"xpc": {
		"language": 7581
	},
	"xpe": {
		"language": 7582
	},
	"xpg": {
		"language": 7583
	},
	"xpi": {
		"language": 7584
	},
	"xpj": {
		"language": 7585
	},
	"xpk": {
		"language": 7586
	},
	"xpm": {
		"language": 7587
	},
	"xpn": {
		"language": 7588
	},
	"xpo": {
		"language": 7589
	},
	"xpp": {
		"language": 7590
	},
	"xpq": {
		"language": 7591
	},
	"xpr": {
		"language": 7592
	},
	"xps": {
		"language": 7593
	},
	"xpt": {
		"language": 7594
	},
	"xpu": {
		"language": 7595
	},
	"xpy": {
		"language": 7596
	},
	"xqa": {
		"language": 7597
	},
	"xqt": {
		"language": 7598
	},
	"xra": {
		"language": 7599
	},
	"xrb": {
		"language": 7600
	},
	"xrd": {
		"language": 7601
	},
	"xre": {
		"language": 7602
	},
	"xrg": {
		"language": 7603
	},
	"xri": {
		"language": 7604
	},
	"xrm": {
		"language": 7605
	},
	"xrn": {
		"language": 7606
	},
	"xrq": {
		"language": 7607
	},
	"xrr": {
		"language": 7608
	},
	"xrt": {
		"language": 7609
	},
	"xru": {
		"language": 7610
	},
	"xrw": {
		"language": 7611
	},
	"xsa": {
		"language": 7612
	},
	"xsb": {
		"language": 7613
	},
	"xsc": {
		"language": 7614
	},
	"xsd": {
		"language": 7615
	},
	"xse": {
		"language": 7616
	},
	"xsh": {
		"language": 7617
	},
	"xsi": {
		"language": 7618
	},
	"xsj": {
		"language": 7619
	},
	"xsl": {
		"language": 7620
	},
	"xsm": {
		"language": 7621
	},
	"xsn": {
		"language": 7622
	},
	"xso": {
		"language": 7623
	},
	"xsp": {
		"language": 7624
	},
	"xsq": {
		"language": 7625
	},
	"xsr": {
		"language": 7626
	},
	"xss": {
		"language": 7627
	},
	"xsu": {
		"language": 7628
	},
	"xsv": {
		"language": 7629
	},
	"xsy": {
		"language": 7630
	},
	"xta": {
		"language": 7631
	},
	"xtb": {
		"language": 7632
	},
	"xtc": {
		"language": 7633
	},
	"xtd": {
		"language": 7634
	},
	"xte": {
		"language": 7635
	},
	"xtg": {
		"language": 7636
	},
	"xth": {
		"language": 7637
	},
	"xti": {
		"language": 7638
	},
	"xtj": {
		"language": 7639
	},
	"xtl": {
		"language": 7640
	},
	"xtm": {
		"language": 7641
	},
	"xtn": {
		"language": 7642
	},
	"xto": {
		"language": 7643
	},
	"xtp": {
		"language": 7644
	},
	"xtq": {
		"language": 7645
	},
	"xtr": {
		"language": 7646
	},
	"xts": {
		"language": 7647
	},
	"xtt": {
		"language": 7648
	},
	"xtu": {
		"language": 7649
	},
	"xtv": {
		"language": 7650
	},
	"xtw": {
		"language": 7651
	},
	"xty": {
		"language": 7652
	},
	"xtz": {
		"language": 7653
	},
	"xua": {
		"language": 7654
	},
	"xub": {
		"language": 7655
	},
	"xud": {
		"language": 7656
	},
	"xug": {
		"language": 7657
	},
	"xuj": {
		"language": 7658
	},
	"xul": {
		"language": 7659
	},
	"xum": {
		"language": 7660
	},
	"xun": {
		"language": 7661
	},
	"xuo": {
		"language": 7662
	},
	"xup": {
		"language": 7663
	},
	"xur": {
		"language": 7664
	},
	"xut": {
		"language": 7665
	},
	"xuu": {
		"language": 7666
	},
	"xve": {
		"language": 7667
	},
	"xvi": {
		"language": 7668
	},
	"xvn": {
		"language": 7669
	},
	"xvo": {
		"language": 7670
	},
	"xvs": {
		"language": 7671
	},
	"xwa": {
		"language": 7672
	},
	"xwc": {
		"language": 7673
	},
	"xwd": {
		"language": 7674
	},
	"xwe": {
		"language": 7675
	},
	"xwg": {
		"language": 7676
	},
	"xwj": {
		"language": 7677
	},
	"xwk": {
		"language": 7678
	},
	"xwl": {
		"language": 7679
	},
	"xwo": {
		"language": 7680
	},
	"xwr": {
		"language": 7681
	},
	"xwt": {
		"language": 7682
	},
	"xww": {
		"language": 7683
	},
	"xxb": {
		"language": 7684
	},
	"xxk": {
		"language": 7685
	},
	"xxm": {
		"language": 7686
	},
	"xxr": {
		"language": 7687
	},
	"xxt": {
		"language": 7688
	},
	"xya": {
		"language": 7689
	},
	"xyb": {
		"language": 7690
	},
	"xyj": {
		"language": 7691
	},
	"xyk": {
		"language": 7692
	},
	"xyl": {
		"language": 7693
	},
	"xyt": {
		"language": 7694
	},
	"xyy": {
		"language": 7695
	},
	"xzh": {
		"language": 7696
	},
	"xzm": {
		"language": 7697
	},
	"xzp": {
		"language": 7698
	},
	"yaa": {
		"language": 7699
	},
	"yab": {
		"language": 7700
	},
	"yac": {
		"language": 7701
	},
	"yad": {
		"language": 7702
	},
	"yae": {
		"language": 7703
	},
	"yaf": {
		"language": 7704
	},
	"yag": {
		"language": 7705
	},
	"yah": {
		"language": 7706
	},
	"yai": {
		"language": 7707
	},
	"yaj": {
		"language": 7708
	},
	"yak": {
		"language": 7709
	},
	"yal": {
		"language": 7710
	},
	"yam": {
		"language": 7711
	},
	"yan": {
		"language": 7712
	},
	"yao": {
		"language": 7713
	},
	"yap": {
		"language": 7714
	},
	"yaq": {
		"language": 7715
	},
	"yar": {
		"language": 7716
	},
	"yas": {
		"language": 7717
	},
	"yat": {
		"language": 7718
	},
	"yau": {
		"language": 7719
	},
	"yav": {
		"language": 7720
	},
	"yaw": {
		"language": 7721
	},
	"yax": {
		"language": 7722
	},
	"yay": {
		"language": 7723
	},
	"yaz": {
		"language": 7724
	},
	"yba": {
		"language": 7725
	},
	"ybb": {
		"language": 7726
	},
	"ybd": {
		"language": 7727
	},
	"ybe": {
		"language": 7728
	},
	"ybh": {
		"language": 7729
	},
	"ybi": {
		"language": 7730
	},
	"ybj": {
		"language": 7731
	},
	"ybk": {
		"language": 7732
	},
	"ybl": {
		"language": 7733
	},
	"ybm": {
		"language": 7734
	},
	"ybn": {
		"language": 7735
	},
	"ybo": {
		"language": 7736
	},
	"ybx": {
		"language": 7737
	},
	"yby": {
		"language": 7738
	},
	"ych": {
		"language": 7739
	},
	"ycl": {
		"language": 7740
	},
	"ycn": {
		"language": 7741
	},
	"ycp": {
		"language": 7742
	},
	"yda": {
		"language": 7743
	},
	"ydd": {
		"language": 7744
	},
	"yde": {
		"language": 7745
	},
	"ydg": {
		"language": 7746
	},
	"ydk": {
		"language": 7747
	},
	"yds": {
		"language": 7748,
		"extlang": 8350
	},
	"yea": {
		"language": 7749
	},
	"yec": {
		"language": 7750
	},
	"yee": {
		"language": 7751
	},
	"yei": {
		"language": 7752
	},
	"yej": {
		"language": 7753
	},
	"yel": {
		"language": 7754
	},
	"yen": {
		"language": 7755
	},
	"yer": {
		"language": 7756
	},
	"yes": {
		"language": 7757
	},
	"yet": {
		"language": 7758
	},
	"yeu": {
		"language": 7759
	},
	"yev": {
		"language": 7760
	},
	"yey": {
		"language": 7761
	},
	"yga": {
		"language": 7762
	},
	"ygi": {
		"language": 7763
	},
	"ygl": {
		"language": 7764
	},
	"ygm": {
		"language": 7765
	},
	"ygp": {
		"language": 7766
	},
	"ygr": {
		"language": 7767
	},
	"ygs": {
		"language": 7768,
		"extlang": 8351
	},
	"ygu": {
		"language": 7769
	},
	"ygw": {
		"language": 7770
	},
	"yha": {
		"language": 7771
	},
	"yhd": {
		"language": 7772
	},
	"yhl": {
		"language": 7773
	},
	"yhs": {
		"language": 7774,
		"extlang": 8352
	},
	"yia": {
		"language": 7775
	},
	"yif": {
		"language": 7776
	},
	"yig": {
		"language": 7777
	},
	"yih": {
		"language": 7778
	},
	"yii": {
		"language": 7779
	},
	"yij": {
		"language": 7780
	},
	"yik": {
		"language": 7781
	},
	"yil": {
		"language": 7782
	},
	"yim": {
		"language": 7783
	},
	"yin": {
		"language": 7784
	},
	"yip": {
		"language": 7785
	},
	"yiq": {
		"language": 7786
	},
	"yir": {
		"language": 7787
	},
	"yis": {
		"language": 7788
	},
	"yit": {
		"language": 7789
	},
	"yiu": {
		"language": 7790
	},
	"yiv": {
		"language": 7791
	},
	"yix": {
		"language": 7792
	},
	"yiy": {
		"language": 7793
	},
	"yiz": {
		"language": 7794
	},
	"yka": {
		"language": 7795
	},
	"ykg": {
		"language": 7796
	},
	"yki": {
		"language": 7797
	},
	"ykk": {
		"language": 7798
	},
	"ykl": {
		"language": 7799
	},
	"ykm": {
		"language": 7800
	},
	"ykn": {
		"language": 7801
	},
	"yko": {
		"language": 7802
	},
	"ykr": {
		"language": 7803
	},
	"ykt": {
		"language": 7804
	},
	"yku": {
		"language": 7805
	},
	"yky": {
		"language": 7806
	},
	"yla": {
		"language": 7807
	},
	"ylb": {
		"language": 7808
	},
	"yle": {
		"language": 7809
	},
	"ylg": {
		"language": 7810
	},
	"yli": {
		"language": 7811
	},
	"yll": {
		"language": 7812
	},
	"ylm": {
		"language": 7813
	},
	"yln": {
		"language": 7814
	},
	"ylo": {
		"language": 7815
	},
	"ylr": {
		"language": 7816
	},
	"ylu": {
		"language": 7817
	},
	"yly": {
		"language": 7818
	},
	"yma": {
		"language": 7819
	},
	"ymb": {
		"language": 7820
	},
	"ymc": {
		"language": 7821
	},
	"ymd": {
		"language": 7822
	},
	"yme": {
		"language": 7823
	},
	"ymg": {
		"language": 7824
	},
	"ymh": {
		"language": 7825
	},
	"ymi": {
		"language": 7826
	},
	"ymk": {
		"language": 7827
	},
	"yml": {
		"language": 7828
	},
	"ymm": {
		"language": 7829
	},
	"ymn": {
		"language": 7830
	},
	"ymo": {
		"language": 7831
	},
	"ymp": {
		"language": 7832
	},
	"ymq": {
		"language": 7833
	},
	"ymr": {
		"language": 7834
	},
	"yms": {
		"language": 7835
	},
	"ymt": {
		"language": 7836
	},
	"ymx": {
		"language": 7837
	},
	"ymz": {
		"language": 7838
	},
	"yna": {
		"language": 7839
	},
	"ynd": {
		"language": 7840
	},
	"yne": {
		"language": 7841
	},
	"yng": {
		"language": 7842
	},
	"ynh": {
		"language": 7843
	},
	"ynk": {
		"language": 7844
	},
	"ynl": {
		"language": 7845
	},
	"ynn": {
		"language": 7846
	},
	"yno": {
		"language": 7847
	},
	"ynq": {
		"language": 7848
	},
	"yns": {
		"language": 7849
	},
	"ynu": {
		"language": 7850
	},
	"yob": {
		"language": 7851
	},
	"yog": {
		"language": 7852
	},
	"yoi": {
		"language": 7853
	},
	"yok": {
		"language": 7854
	},
	"yol": {
		"language": 7855
	},
	"yom": {
		"language": 7856
	},
	"yon": {
		"language": 7857
	},
	"yos": {
		"language": 7858
	},
	"yot": {
		"language": 7859
	},
	"yox": {
		"language": 7860
	},
	"yoy": {
		"language": 7861
	},
	"ypa": {
		"language": 7862
	},
	"ypb": {
		"language": 7863
	},
	"ypg": {
		"language": 7864
	},
	"yph": {
		"language": 7865
	},
	"ypk": {
		"language": 7866
	},
	"ypm": {
		"language": 7867
	},
	"ypn": {
		"language": 7868
	},
	"ypo": {
		"language": 7869
	},
	"ypp": {
		"language": 7870
	},
	"ypz": {
		"language": 7871
	},
	"yra": {
		"language": 7872
	},
	"yrb": {
		"language": 7873
	},
	"yre": {
		"language": 7874
	},
	"yri": {
		"language": 7875
	},
	"yrk": {
		"language": 7876
	},
	"yrl": {
		"language": 7877
	},
	"yrm": {
		"language": 7878
	},
	"yrn": {
		"language": 7879
	},
	"yro": {
		"language": 7880
	},
	"yrs": {
		"language": 7881
	},
	"yrw": {
		"language": 7882
	},
	"yry": {
		"language": 7883
	},
	"ysc": {
		"language": 7884
	},
	"ysd": {
		"language": 7885
	},
	"ysg": {
		"language": 7886
	},
	"ysl": {
		"language": 7887,
		"extlang": 8353
	},
	"ysn": {
		"language": 7888
	},
	"yso": {
		"language": 7889
	},
	"ysp": {
		"language": 7890
	},
	"ysr": {
		"language": 7891
	},
	"yss": {
		"language": 7892
	},
	"ysy": {
		"language": 7893
	},
	"yta": {
		"language": 7894
	},
	"ytl": {
		"language": 7895
	},
	"ytp": {
		"language": 7896
	},
	"ytw": {
		"language": 7897
	},
	"yty": {
		"language": 7898
	},
	"yua": {
		"language": 7899
	},
	"yub": {
		"language": 7900
	},
	"yuc": {
		"language": 7901
	},
	"yud": {
		"language": 7902
	},
	"yue": {
		"language": 7903,
		"extlang": 8354
	},
	"yuf": {
		"language": 7904
	},
	"yug": {
		"language": 7905
	},
	"yui": {
		"language": 7906
	},
	"yuj": {
		"language": 7907
	},
	"yuk": {
		"language": 7908
	},
	"yul": {
		"language": 7909
	},
	"yum": {
		"language": 7910
	},
	"yun": {
		"language": 7911
	},
	"yup": {
		"language": 7912
	},
	"yuq": {
		"language": 7913
	},
	"yur": {
		"language": 7914
	},
	"yut": {
		"language": 7915
	},
	"yuu": {
		"language": 7916
	},
	"yuw": {
		"language": 7917
	},
	"yux": {
		"language": 7918
	},
	"yuy": {
		"language": 7919
	},
	"yuz": {
		"language": 7920
	},
	"yva": {
		"language": 7921
	},
	"yvt": {
		"language": 7922
	},
	"ywa": {
		"language": 7923
	},
	"ywg": {
		"language": 7924
	},
	"ywl": {
		"language": 7925
	},
	"ywn": {
		"language": 7926
	},
	"ywq": {
		"language": 7927
	},
	"ywr": {
		"language": 7928
	},
	"ywt": {
		"language": 7929
	},
	"ywu": {
		"language": 7930
	},
	"yww": {
		"language": 7931
	},
	"yxa": {
		"language": 7932
	},
	"yxg": {
		"language": 7933
	},
	"yxl": {
		"language": 7934
	},
	"yxm": {
		"language": 7935
	},
	"yxu": {
		"language": 7936
	},
	"yxy": {
		"language": 7937
	},
	"yyr": {
		"language": 7938
	},
	"yyu": {
		"language": 7939
	},
	"yyz": {
		"language": 7940
	},
	"yzg": {
		"language": 7941
	},
	"yzk": {
		"language": 7942
	},
	"zaa": {
		"language": 7943
	},
	"zab": {
		"language": 7944
	},
	"zac": {
		"language": 7945
	},
	"zad": {
		"language": 7946
	},
	"zae": {
		"language": 7947
	},
	"zaf": {
		"language": 7948
	},
	"zag": {
		"language": 7949
	},
	"zah": {
		"language": 7950
	},
	"zai": {
		"language": 7951
	},
	"zaj": {
		"language": 7952
	},
	"zak": {
		"language": 7953
	},
	"zal": {
		"language": 7954
	},
	"zam": {
		"language": 7955
	},
	"zao": {
		"language": 7956
	},
	"zap": {
		"language": 7957
	},
	"zaq": {
		"language": 7958
	},
	"zar": {
		"language": 7959
	},
	"zas": {
		"language": 7960
	},
	"zat": {
		"language": 7961
	},
	"zau": {
		"language": 7962
	},
	"zav": {
		"language": 7963
	},
	"zaw": {
		"language": 7964
	},
	"zax": {
		"language": 7965
	},
	"zay": {
		"language": 7966
	},
	"zaz": {
		"language": 7967
	},
	"zbc": {
		"language": 7968
	},
	"zbe": {
		"language": 7969
	},
	"zbl": {
		"language": 7970
	},
	"zbt": {
		"language": 7971
	},
	"zbw": {
		"language": 7972
	},
	"zca": {
		"language": 7973
	},
	"zch": {
		"language": 7974
	},
	"zdj": {
		"language": 7975
	},
	"zea": {
		"language": 7976
	},
	"zeg": {
		"language": 7977
	},
	"zeh": {
		"language": 7978
	},
	"zen": {
		"language": 7979
	},
	"zga": {
		"language": 7980
	},
	"zgb": {
		"language": 7981
	},
	"zgh": {
		"language": 7982
	},
	"zgm": {
		"language": 7983
	},
	"zgn": {
		"language": 7984
	},
	"zgr": {
		"language": 7985
	},
	"zhb": {
		"language": 7986
	},
	"zhd": {
		"language": 7987
	},
	"zhi": {
		"language": 7988
	},
	"zhn": {
		"language": 7989
	},
	"zhw": {
		"language": 7990
	},
	"zhx": {
		"language": 7991
	},
	"zia": {
		"language": 7992
	},
	"zib": {
		"language": 7993,
		"extlang": 8355
	},
	"zik": {
		"language": 7994
	},
	"zil": {
		"language": 7995
	},
	"zim": {
		"language": 7996
	},
	"zin": {
		"language": 7997
	},
	"zir": {
		"language": 7998
	},
	"ziw": {
		"language": 7999
	},
	"ziz": {
		"language": 8000
	},
	"zka": {
		"language": 8001
	},
	"zkb": {
		"language": 8002
	},
	"zkd": {
		"language": 8003
	},
	"zkg": {
		"language": 8004
	},
	"zkh": {
		"language": 8005
	},
	"zkk": {
		"language": 8006
	},
	"zkn": {
		"language": 8007
	},
	"zko": {
		"language": 8008
	},
	"zkp": {
		"language": 8009
	},
	"zkr": {
		"language": 8010
	},
	"zkt": {
		"language": 8011
	},
	"zku": {
		"language": 8012
	},
	"zkv": {
		"language": 8013
	},
	"zkz": {
		"language": 8014
	},
	"zle": {
		"language": 8015
	},
	"zlj": {
		"language": 8016
	},
	"zlm": {
		"language": 8017,
		"extlang": 8356
	},
	"zln": {
		"language": 8018
	},
	"zlq": {
		"language": 8019
	},
	"zls": {
		"language": 8020
	},
	"zlw": {
		"language": 8021
	},
	"zma": {
		"language": 8022
	},
	"zmb": {
		"language": 8023
	},
	"zmc": {
		"language": 8024
	},
	"zmd": {
		"language": 8025
	},
	"zme": {
		"language": 8026
	},
	"zmf": {
		"language": 8027
	},
	"zmg": {
		"language": 8028
	},
	"zmh": {
		"language": 8029
	},
	"zmi": {
		"language": 8030,
		"extlang": 8357
	},
	"zmj": {
		"language": 8031
	},
	"zmk": {
		"language": 8032
	},
	"zml": {
		"language": 8033
	},
	"zmm": {
		"language": 8034
	},
	"zmn": {
		"language": 8035
	},
	"zmo": {
		"language": 8036
	},
	"zmp": {
		"language": 8037
	},
	"zmq": {
		"language": 8038
	},
	"zmr": {
		"language": 8039
	},
	"zms": {
		"language": 8040
	},
	"zmt": {
		"language": 8041
	},
	"zmu": {
		"language": 8042
	},
	"zmv": {
		"language": 8043
	},
	"zmw": {
		"language": 8044
	},
	"zmx": {
		"language": 8045
	},
	"zmy": {
		"language": 8046
	},
	"zmz": {
		"language": 8047
	},
	"zna": {
		"language": 8048
	},
	"znd": {
		"language": 8049
	},
	"zne": {
		"language": 8050
	},
	"zng": {
		"language": 8051
	},
	"znk": {
		"language": 8052
	},
	"zns": {
		"language": 8053
	},
	"zoc": {
		"language": 8054
	},
	"zoh": {
		"language": 8055
	},
	"zom": {
		"language": 8056
	},
	"zoo": {
		"language": 8057
	},
	"zoq": {
		"language": 8058
	},
	"zor": {
		"language": 8059
	},
	"zos": {
		"language": 8060
	},
	"zpa": {
		"language": 8061
	},
	"zpb": {
		"language": 8062
	},
	"zpc": {
		"language": 8063
	},
	"zpd": {
		"language": 8064
	},
	"zpe": {
		"language": 8065
	},
	"zpf": {
		"language": 8066
	},
	"zpg": {
		"language": 8067
	},
	"zph": {
		"language": 8068
	},
	"zpi": {
		"language": 8069
	},
	"zpj": {
		"language": 8070
	},
	"zpk": {
		"language": 8071
	},
	"zpl": {
		"language": 8072
	},
	"zpm": {
		"language": 8073
	},
	"zpn": {
		"language": 8074
	},
	"zpo": {
		"language": 8075
	},
	"zpp": {
		"language": 8076
	},
	"zpq": {
		"language": 8077
	},
	"zpr": {
		"language": 8078
	},
	"zps": {
		"language": 8079
	},
	"zpt": {
		"language": 8080
	},
	"zpu": {
		"language": 8081
	},
	"zpv": {
		"language": 8082
	},
	"zpw": {
		"language": 8083
	},
	"zpx": {
		"language": 8084
	},
	"zpy": {
		"language": 8085
	},
	"zpz": {
		"language": 8086
	},
	"zqe": {
		"language": 8087
	},
	"zra": {
		"language": 8088
	},
	"zrg": {
		"language": 8089
	},
	"zrn": {
		"language": 8090
	},
	"zro": {
		"language": 8091
	},
	"zrp": {
		"language": 8092
	},
	"zrs": {
		"language": 8093
	},
	"zsa": {
		"language": 8094
	},
	"zsk": {
		"language": 8095
	},
	"zsl": {
		"language": 8096,
		"extlang": 8358
	},
	"zsm": {
		"language": 8097,
		"extlang": 8359
	},
	"zsr": {
		"language": 8098
	},
	"zsu": {
		"language": 8099
	},
	"zte": {
		"language": 8100
	},
	"ztg": {
		"language": 8101
	},
	"ztl": {
		"language": 8102
	},
	"ztm": {
		"language": 8103
	},
	"ztn": {
		"language": 8104
	},
	"ztp": {
		"language": 8105
	},
	"ztq": {
		"language": 8106
	},
	"zts": {
		"language": 8107
	},
	"ztt": {
		"language": 8108
	},
	"ztu": {
		"language": 8109
	},
	"ztx": {
		"language": 8110
	},
	"zty": {
		"language": 8111
	},
	"zua": {
		"language": 8112
	},
	"zuh": {
		"language": 8113
	},
	"zum": {
		"language": 8114
	},
	"zun": {
		"language": 8115
	},
	"zuy": {
		"language": 8116
	},
	"zwa": {
		"language": 8117
	},
	"zxx": {
		"language": 8118
	},
	"zyb": {
		"language": 8119
	},
	"zyg": {
		"language": 8120
	},
	"zyj": {
		"language": 8121
	},
	"zyn": {
		"language": 8122
	},
	"zyp": {
		"language": 8123
	},
	"zza": {
		"language": 8124
	},
	"zzj": {
		"language": 8125
	},
	"adlm": {
		"script": 8360
	},
	"afak": {
		"script": 8361
	},
	"aghb": {
		"script": 8362
	},
	"ahom": {
		"script": 8363
	},
	"arab": {
		"script": 8364
	},
	"aran": {
		"script": 8365
	},
	"armi": {
		"script": 8366
	},
	"armn": {
		"script": 8367
	},
	"avst": {
		"script": 8368
	},
	"bali": {
		"script": 8369
	},
	"bamu": {
		"script": 8370
	},
	"bass": {
		"script": 8371
	},
	"batk": {
		"script": 8372
	},
	"beng": {
		"script": 8373
	},
	"bhks": {
		"script": 8374
	},
	"blis": {
		"script": 8375
	},
	"bopo": {
		"script": 8376
	},
	"brah": {
		"script": 8377
	},
	"brai": {
		"script": 8378
	},
	"bugi": {
		"script": 8379
	},
	"buhd": {
		"script": 8380
	},
	"cakm": {
		"script": 8381
	},
	"cans": {
		"script": 8382
	},
	"cari": {
		"script": 8383
	},
	"cham": {
		"script": 8384
	},
	"cher": {
		"script": 8385
	},
	"cirt": {
		"script": 8386
	},
	"copt": {
		"script": 8387
	},
	"cprt": {
		"script": 8388
	},
	"cyrl": {
		"script": 8389
	},
	"cyrs": {
		"script": 8390
	},
	"deva": {
		"script": 8391
	},
	"dogr": {
		"script": 8392
	},
	"dsrt": {
		"script": 8393
	},
	"dupl": {
		"script": 8394
	},
	"egyd": {
		"script": 8395
	},
	"egyh": {
		"script": 8396
	},
	"egyp": {
		"script": 8397
	},
	"elba": {
		"script": 8398
	},
	"ethi": {
		"script": 8399
	},
	"geok": {
		"script": 8400
	},
	"geor": {
		"script": 8401
	},
	"glag": {
		"script": 8402
	},
	"gong": {
		"script": 8403
	},
	"gonm": {
		"script": 8404
	},
	"goth": {
		"script": 8405
	},
	"gran": {
		"script": 8406
	},
	"grek": {
		"script": 8407
	},
	"gujr": {
		"script": 8408
	},
	"guru": {
		"script": 8409
	},
	"hanb": {
		"script": 8410
	},
	"hang": {
		"script": 8411
	},
	"hani": {
		"script": 8412
	},
	"hano": {
		"script": 8413
	},
	"hans": {
		"script": 8414
	},
	"hant": {
		"script": 8415
	},
	"hatr": {
		"script": 8416
	},
	"hebr": {
		"script": 8417
	},
	"hira": {
		"script": 8418
	},
	"hluw": {
		"script": 8419
	},
	"hmng": {
		"script": 8420
	},
	"hrkt": {
		"script": 8421
	},
	"hung": {
		"script": 8422
	},
	"inds": {
		"script": 8423
	},
	"ital": {
		"script": 8424
	},
	"jamo": {
		"script": 8425
	},
	"java": {
		"script": 8426
	},
	"jpan": {
		"script": 8427
	},
	"jurc": {
		"script": 8428
	},
	"kali": {
		"script": 8429
	},
	"kana": {
		"script": 8430
	},
	"khar": {
		"script": 8431
	},
	"khmr": {
		"script": 8432
	},
	"khoj": {
		"script": 8433
	},
	"kitl": {
		"script": 8434
	},
	"kits": {
		"script": 8435
	},
	"knda": {
		"script": 8436
	},
	"kore": {
		"script": 8437
	},
	"kpel": {
		"script": 8438
	},
	"kthi": {
		"script": 8439
	},
	"lana": {
		"script": 8440
	},
	"laoo": {
		"script": 8441
	},
	"latf": {
		"script": 8442
	},
	"latg": {
		"script": 8443
	},
	"latn": {
		"script": 8444
	},
	"leke": {
		"script": 8445
	},
	"lepc": {
		"script": 8446
	},
	"limb": {
		"script": 8447
	},
	"lina": {
		"script": 8448
	},
	"linb": {
		"script": 8449
	},
	"lisu": {
		"script": 8450
	},
	"loma": {
		"script": 8451
	},
	"lyci": {
		"script": 8452
	},
	"lydi": {
		"script": 8453
	},
	"mahj": {
		"script": 8454
	},
	"maka": {
		"script": 8455
	},
	"mand": {
		"script": 8456
	},
	"mani": {
		"script": 8457
	},
	"marc": {
		"script": 8458
	},
	"maya": {
		"script": 8459
	},
	"medf": {
		"script": 8460
	},
	"mend": {
		"script": 8461
	},
	"merc": {
		"script": 8462
	},
	"mero": {
		"script": 8463
	},
	"mlym": {
		"script": 8464
	},
	"modi": {
		"script": 8465
	},
	"mong": {
		"script": 8466
	},
	"moon": {
		"script": 8467
	},
	"mroo": {
		"script": 8468
	},
	"mtei": {
		"script": 8469
	},
	"mult": {
		"script": 8470
	},
	"mymr": {
		"script": 8471
	},
	"narb": {
		"script": 8472
	},
	"nbat": {
		"script": 8473
	},
	"newa": {
		"script": 8474
	},
	"nkgb": {
		"script": 8475
	},
	"nkoo": {
		"script": 8476
	},
	"nshu": {
		"script": 8477
	},
	"ogam": {
		"script": 8478
	},
	"olck": {
		"script": 8479
	},
	"orkh": {
		"script": 8480
	},
	"orya": {
		"script": 8481
	},
	"osge": {
		"script": 8482
	},
	"osma": {
		"script": 8483
	},
	"palm": {
		"script": 8484
	},
	"pauc": {
		"script": 8485
	},
	"perm": {
		"script": 8486
	},
	"phag": {
		"script": 8487
	},
	"phli": {
		"script": 8488
	},
	"phlp": {
		"script": 8489
	},
	"phlv": {
		"script": 8490
	},
	"phnx": {
		"script": 8491
	},
	"piqd": {
		"script": 8492
	},
	"plrd": {
		"script": 8493
	},
	"prti": {
		"script": 8494
	},
	"qaaa..qabx": {
		"script": 8495
	},
	"rjng": {
		"script": 8496
	},
	"roro": {
		"script": 8497
	},
	"runr": {
		"script": 8498
	},
	"samr": {
		"script": 8499
	},
	"sara": {
		"script": 8500
	},
	"sarb": {
		"script": 8501
	},
	"saur": {
		"script": 8502
	},
	"sgnw": {
		"script": 8503
	},
	"shaw": {
		"script": 8504
	},
	"shrd": {
		"script": 8505
	},
	"sidd": {
		"script": 8506
	},
	"sind": {
		"script": 8507
	},
	"sinh": {
		"script": 8508
	},
	"sora": {
		"script": 8509
	},
	"soyo": {
		"script": 8510
	},
	"sund": {
		"script": 8511
	},
	"sylo": {
		"script": 8512
	},
	"syrc": {
		"script": 8513
	},
	"syre": {
		"script": 8514
	},
	"syrj": {
		"script": 8515
	},
	"syrn": {
		"script": 8516
	},
	"tagb": {
		"script": 8517
	},
	"takr": {
		"script": 8518
	},
	"tale": {
		"script": 8519
	},
	"talu": {
		"script": 8520
	},
	"taml": {
		"script": 8521
	},
	"tang": {
		"script": 8522
	},
	"tavt": {
		"script": 8523
	},
	"telu": {
		"script": 8524
	},
	"teng": {
		"script": 8525
	},
	"tfng": {
		"script": 8526
	},
	"tglg": {
		"script": 8527
	},
	"thaa": {
		"script": 8528
	},
	"thai": {
		"script": 8529
	},
	"tibt": {
		"script": 8530
	},
	"tirh": {
		"script": 8531
	},
	"ugar": {
		"script": 8532
	},
	"vaii": {
		"script": 8533
	},
	"visp": {
		"script": 8534
	},
	"wara": {
		"script": 8535
	},
	"wole": {
		"script": 8536
	},
	"xpeo": {
		"script": 8537
	},
	"xsux": {
		"script": 8538
	},
	"yiii": {
		"script": 8539
	},
	"zanb": {
		"script": 8540
	},
	"zinh": {
		"script": 8541
	},
	"zmth": {
		"script": 8542
	},
	"zsye": {
		"script": 8543
	},
	"zsym": {
		"script": 8544
	},
	"zxxx": {
		"script": 8545
	},
	"zyyy": {
		"script": 8546
	},
	"zzzz": {
		"script": 8547
	},
	"ac": {
		"region": 8549
	},
	"ad": {
		"region": 8550
	},
	"ag": {
		"region": 8553
	},
	"ai": {
		"region": 8554
	},
	"al": {
		"region": 8555
	},
	"ao": {
		"region": 8558
	},
	"aq": {
		"region": 8559
	},
	"at": {
		"region": 8562
	},
	"au": {
		"region": 8563
	},
	"aw": {
		"region": 8564
	},
	"ax": {
		"region": 8565
	},
	"bb": {
		"region": 8568
	},
	"bd": {
		"region": 8569
	},
	"bf": {
		"region": 8571
	},
	"bj": {
		"region": 8575
	},
	"bl": {
		"region": 8576
	},
	"bq": {
		"region": 8580
	},
	"bt": {
		"region": 8583
	},
	"bu": {
		"region": 8584
	},
	"bv": {
		"region": 8585
	},
	"bw": {
		"region": 8586
	},
	"by": {
		"region": 8587
	},
	"bz": {
		"region": 8588
	},
	"cc": {
		"region": 8590
	},
	"cd": {
		"region": 8591
	},
	"cf": {
		"region": 8592
	},
	"cg": {
		"region": 8593
	},
	"ci": {
		"region": 8595
	},
	"ck": {
		"region": 8596
	},
	"cl": {
		"region": 8597
	},
	"cm": {
		"region": 8598
	},
	"cn": {
		"region": 8599
	},
	"cp": {
		"region": 8601
	},
	"cw": {
		"region": 8606
	},
	"cx": {
		"region": 8607
	},
	"cz": {
		"region": 8609
	},
	"dd": {
		"region": 8610
	},
	"dg": {
		"region": 8612
	},
	"dj": {
		"region": 8613
	},
	"dk": {
		"region": 8614
	},
	"dm": {
		"region": 8615
	},
	"do": {
		"region": 8616
	},
	"ea": {
		"region": 8618
	},
	"ec": {
		"region": 8619
	},
	"eg": {
		"region": 8621
	},
	"eh": {
		"region": 8622
	},
	"er": {
		"region": 8623
	},
	"ez": {
		"region": 8627
	},
	"fk": {
		"region": 8630
	},
	"fm": {
		"region": 8631
	},
	"fx": {
		"region": 8634
	},
	"gb": {
		"region": 8636
	},
	"ge": {
		"region": 8638
	},
	"gf": {
		"region": 8639
	},
	"gg": {
		"region": 8640
	},
	"gh": {
		"region": 8641
	},
	"gi": {
		"region": 8642
	},
	"gm": {
		"region": 8644
	},
	"gp": {
		"region": 8646
	},
	"gq": {
		"region": 8647
	},
	"gr": {
		"region": 8648
	},
	"gs": {
		"region": 8649
	},
	"gt": {
		"region": 8650
	},
	"gw": {
		"region": 8652
	},
	"gy": {
		"region": 8653
	},
	"hk": {
		"region": 8654
	},
	"hm": {
		"region": 8655
	},
	"hn": {
		"region": 8656
	},
	"ic": {
		"region": 8660
	},
	"il": {
		"region": 8663
	},
	"im": {
		"region": 8664
	},
	"iq": {
		"region": 8667
	},
	"ir": {
		"region": 8668
	},
	"je": {
		"region": 8671
	},
	"jm": {
		"region": 8672
	},
	"jo": {
		"region": 8673
	},
	"jp": {
		"region": 8674
	},
	"ke": {
		"region": 8675
	},
	"kh": {
		"region": 8677
	},
	"kp": {
		"region": 8681
	},
	"kz": {
		"region": 8685
	},
	"lc": {
		"region": 8688
	},
	"lk": {
		"region": 8690
	},
	"lr": {
		"region": 8691
	},
	"ls": {
		"region": 8692
	},
	"ly": {
		"region": 8696
	},
	"ma": {
		"region": 8697
	},
	"mc": {
		"region": 8698
	},
	"md": {
		"region": 8699
	},
	"me": {
		"region": 8700
	},
	"mf": {
		"region": 8701
	},
	"mm": {
		"region": 8706
	},
	"mp": {
		"region": 8709
	},
	"mq": {
		"region": 8710
	},
	"mu": {
		"region": 8714
	},
	"mv": {
		"region": 8715
	},
	"mw": {
		"region": 8716
	},
	"mx": {
		"region": 8717
	},
	"mz": {
		"region": 8719
	},
	"nc": {
		"region": 8721
	},
	"nf": {
		"region": 8723
	},
	"ni": {
		"region": 8725
	},
	"np": {
		"region": 8728
	},
	"nt": {
		"region": 8730
	},
	"nu": {
		"region": 8731
	},
	"nz": {
		"region": 8732
	},
	"pe": {
		"region": 8735
	},
	"pf": {
		"region": 8736
	},
	"pg": {
		"region": 8737
	},
	"ph": {
		"region": 8738
	},
	"pk": {
		"region": 8739
	},
	"pm": {
		"region": 8741
	},
	"pn": {
		"region": 8742
	},
	"pr": {
		"region": 8743
	},
	"pw": {
		"region": 8746
	},
	"py": {
		"region": 8747
	},
	"qa": {
		"region": 8748
	},
	"qm..qz": {
		"region": 8749
	},
	"re": {
		"region": 8750
	},
	"rs": {
		"region": 8752
	},
	"sb": {
		"region": 8756
	},
	"sj": {
		"region": 8763
	},
	"sx": {
		"region": 8774
	},
	"sy": {
		"region": 8775
	},
	"sz": {
		"region": 8776
	},
	"tc": {
		"region": 8778
	},
	"td": {
		"region": 8779
	},
	"tf": {
		"region": 8780
	},
	"tj": {
		"region": 8783
	},
	"tm": {
		"region": 8786
	},
	"tp": {
		"region": 8789
	},
	"tv": {
		"region": 8792
	},
	"tz": {
		"region": 8794
	},
	"ua": {
		"region": 8795
	},
	"um": {
		"region": 8797
	},
	"un": {
		"region": 8798
	},
	"us": {
		"region": 8799
	},
	"uy": {
		"region": 8800
	},
	"va": {
		"region": 8802
	},
	"vc": {
		"region": 8803
	},
	"vg": {
		"region": 8805
	},
	"vn": {
		"region": 8807
	},
	"vu": {
		"region": 8808
	},
	"wf": {
		"region": 8809
	},
	"ws": {
		"region": 8810
	},
	"xa..xz": {
		"region": 8811
	},
	"yd": {
		"region": 8812
	},
	"ye": {
		"region": 8813
	},
	"yt": {
		"region": 8814
	},
	"yu": {
		"region": 8815
	},
	"zm": {
		"region": 8817
	},
	"zr": {
		"region": 8818
	},
	"zw": {
		"region": 8819
	},
	"zz": {
		"region": 8820
	},
	"001": {
		"region": 8821
	},
	"002": {
		"region": 8822
	},
	"003": {
		"region": 8823
	},
	"005": {
		"region": 8824
	},
	"009": {
		"region": 8825
	},
	"011": {
		"region": 8826
	},
	"013": {
		"region": 8827
	},
	"014": {
		"region": 8828
	},
	"015": {
		"region": 8829
	},
	"017": {
		"region": 8830
	},
	"018": {
		"region": 8831
	},
	"019": {
		"region": 8832
	},
	"021": {
		"region": 8833
	},
	"029": {
		"region": 8834
	},
	"030": {
		"region": 8835
	},
	"034": {
		"region": 8836
	},
	"035": {
		"region": 8837
	},
	"039": {
		"region": 8838
	},
	"053": {
		"region": 8839
	},
	"054": {
		"region": 8840
	},
	"057": {
		"region": 8841
	},
	"061": {
		"region": 8842
	},
	"1606nict": {
		"variant": 8851
	},
	"1694acad": {
		"variant": 8852
	},
	"1959acad": {
		"variant": 8854
	},
	"abl1943": {
		"variant": 8857
	},
	"alalc97": {
		"variant": 8858
	},
	"aluku": {
		"variant": 8859
	},
	"ao1990": {
		"variant": 8860
	},
	"arevela": {
		"variant": 8861
	},
	"arevmda": {
		"variant": 8862
	},
	"baku1926": {
		"variant": 8863
	},
	"balanka": {
		"variant": 8864
	},
	"barla": {
		"variant": 8865
	},
	"basiceng": {
		"variant": 8866
	},
	"bauddha": {
		"variant": 8867
	},
	"biscayan": {
		"variant": 8868
	},
	"biske": {
		"variant": 8869
	},
	"bohoric": {
		"variant": 8870
	},
	"boont": {
		"variant": 8871
	},
	"colb1945": {
		"variant": 8872
	},
	"cornu": {
		"variant": 8873
	},
	"dajnko": {
		"variant": 8874
	},
	"ekavsk": {
		"variant": 8875
	},
	"emodeng": {
		"variant": 8876
	},
	"fonipa": {
		"variant": 8877
	},
	"fonnapa": {
		"variant": 8878
	},
	"fonupa": {
		"variant": 8879
	},
	"fonxsamp": {
		"variant": 8880
	},
	"hepburn": {
		"variant": 8881
	},
	"heploc": {
		"variant": 8882
	},
	"hognorsk": {
		"variant": 8883
	},
	"ijekavsk": {
		"variant": 8884
	},
	"itihasa": {
		"variant": 8885
	},
	"jauer": {
		"variant": 8886
	},
	"jyutping": {
		"variant": 8887
	},
	"kkcor": {
		"variant": 8888
	},
	"kociewie": {
		"variant": 8889
	},
	"kscor": {
		"variant": 8890
	},
	"laukika": {
		"variant": 8891
	},
	"lipaw": {
		"variant": 8892
	},
	"luna1918": {
		"variant": 8893
	},
	"metelko": {
		"variant": 8894
	},
	"monoton": {
		"variant": 8895
	},
	"ndyuka": {
		"variant": 8896
	},
	"nedis": {
		"variant": 8897
	},
	"newfound": {
		"variant": 8898
	},
	"njiva": {
		"variant": 8899
	},
	"nulik": {
		"variant": 8900
	},
	"osojs": {
		"variant": 8901
	},
	"oxendict": {
		"variant": 8902
	},
	"pahawh2": {
		"variant": 8903
	},
	"pahawh3": {
		"variant": 8904
	},
	"pahawh4": {
		"variant": 8905
	},
	"pamaka": {
		"variant": 8906
	},
	"petr1708": {
		"variant": 8907
	},
	"pinyin": {
		"variant": 8908
	},
	"polyton": {
		"variant": 8909
	},
	"puter": {
		"variant": 8910
	},
	"rigik": {
		"variant": 8911
	},
	"rozaj": {
		"variant": 8912
	},
	"rumgr": {
		"variant": 8913
	},
	"scotland": {
		"variant": 8914
	},
	"scouse": {
		"variant": 8915
	},
	"simple": {
		"variant": 8916
	},
	"solba": {
		"variant": 8917
	},
	"sotav": {
		"variant": 8918
	},
	"spanglis": {
		"variant": 8919
	},
	"surmiran": {
		"variant": 8920
	},
	"sursilv": {
		"variant": 8921
	},
	"sutsilv": {
		"variant": 8922
	},
	"tarask": {
		"variant": 8923
	},
	"uccor": {
		"variant": 8924
	},
	"ucrcor": {
		"variant": 8925
	},
	"ulster": {
		"variant": 8926
	},
	"unifon": {
		"variant": 8927
	},
	"vaidika": {
		"variant": 8928
	},
	"valencia": {
		"variant": 8929
	},
	"vallader": {
		"variant": 8930
	},
	"wadegile": {
		"variant": 8931
	},
	"art-lojban": {
		"grandfathered": 8932
	},
	"cel-gaulish": {
		"grandfathered": 8933
	},
	"en-gb-oed": {
		"grandfathered": 8934
	},
	"i-ami": {
		"grandfathered": 8935
	},
	"i-bnn": {
		"grandfathered": 8936
	},
	"i-default": {
		"grandfathered": 8937
	},
	"i-enochian": {
		"grandfathered": 8938
	},
	"i-hak": {
		"grandfathered": 8939
	},
	"i-klingon": {
		"grandfathered": 8940
	},
	"i-lux": {
		"grandfathered": 8941
	},
	"i-mingo": {
		"grandfathered": 8942
	},
	"i-navajo": {
		"grandfathered": 8943
	},
	"i-pwn": {
		"grandfathered": 8944
	},
	"i-tao": {
		"grandfathered": 8945
	},
	"i-tay": {
		"grandfathered": 8946
	},
	"i-tsu": {
		"grandfathered": 8947
	},
	"no-bok": {
		"grandfathered": 8948
	},
	"no-nyn": {
		"grandfathered": 8949
	},
	"sgn-be-fr": {
		"grandfathered": 8950
	},
	"sgn-be-nl": {
		"grandfathered": 8951
	},
	"sgn-ch-de": {
		"grandfathered": 8952
	},
	"zh-guoyu": {
		"grandfathered": 8953
	},
	"zh-hakka": {
		"grandfathered": 8954
	},
	"zh-min": {
		"grandfathered": 8955
	},
	"zh-min-nan": {
		"grandfathered": 8956
	},
	"zh-xiang": {
		"grandfathered": 8957
	},
	"az-arab": {
		"redundant": 8958
	},
	"az-cyrl": {
		"redundant": 8959
	},
	"az-latn": {
		"redundant": 8960
	},
	"be-latn": {
		"redundant": 8961
	},
	"bs-cyrl": {
		"redundant": 8962
	},
	"bs-latn": {
		"redundant": 8963
	},
	"de-1901": {
		"redundant": 8964
	},
	"de-1996": {
		"redundant": 8965
	},
	"de-at-1901": {
		"redundant": 8966
	},
	"de-at-1996": {
		"redundant": 8967
	},
	"de-ch-1901": {
		"redundant": 8968
	},
	"de-ch-1996": {
		"redundant": 8969
	},
	"de-de-1901": {
		"redundant": 8970
	},
	"de-de-1996": {
		"redundant": 8971
	},
	"en-boont": {
		"redundant": 8972
	},
	"en-scouse": {
		"redundant": 8973
	},
	"es-419": {
		"redundant": 8974
	},
	"iu-cans": {
		"redundant": 8975
	},
	"iu-latn": {
		"redundant": 8976
	},
	"mn-cyrl": {
		"redundant": 8977
	},
	"mn-mong": {
		"redundant": 8978
	},
	"sgn-br": {
		"redundant": 8979
	},
	"sgn-co": {
		"redundant": 8980
	},
	"sgn-de": {
		"redundant": 8981
	},
	"sgn-dk": {
		"redundant": 8982
	},
	"sgn-es": {
		"redundant": 8983
	},
	"sgn-fr": {
		"redundant": 8984
	},
	"sgn-gb": {
		"redundant": 8985
	},
	"sgn-gr": {
		"redundant": 8986
	},
	"sgn-ie": {
		"redundant": 8987
	},
	"sgn-it": {
		"redundant": 8988
	},
	"sgn-jp": {
		"redundant": 8989
	},
	"sgn-mx": {
		"redundant": 8990
	},
	"sgn-ni": {
		"redundant": 8991
	},
	"sgn-nl": {
		"redundant": 8992
	},
	"sgn-no": {
		"redundant": 8993
	},
	"sgn-pt": {
		"redundant": 8994
	},
	"sgn-se": {
		"redundant": 8995
	},
	"sgn-us": {
		"redundant": 8996
	},
	"sgn-za": {
		"redundant": 8997
	},
	"sl-nedis": {
		"redundant": 8998
	},
	"sl-rozaj": {
		"redundant": 8999
	},
	"sr-cyrl": {
		"redundant": 9000
	},
	"sr-latn": {
		"redundant": 9001
	},
	"tg-arab": {
		"redundant": 9002
	},
	"tg-cyrl": {
		"redundant": 9003
	},
	"uz-cyrl": {
		"redundant": 9004
	},
	"uz-latn": {
		"redundant": 9005
	},
	"yi-latn": {
		"redundant": 9006
	},
	"zh-cmn": {
		"redundant": 9007
	},
	"zh-cmn-hans": {
		"redundant": 9008
	},
	"zh-cmn-hant": {
		"redundant": 9009
	},
	"zh-gan": {
		"redundant": 9010
	},
	"zh-hans": {
		"redundant": 9011
	},
	"zh-hans-cn": {
		"redundant": 9012
	},
	"zh-hans-hk": {
		"redundant": 9013
	},
	"zh-hans-mo": {
		"redundant": 9014
	},
	"zh-hans-sg": {
		"redundant": 9015
	},
	"zh-hans-tw": {
		"redundant": 9016
	},
	"zh-hant": {
		"redundant": 9017
	},
	"zh-hant-cn": {
		"redundant": 9018
	},
	"zh-hant-hk": {
		"redundant": 9019
	},
	"zh-hant-mo": {
		"redundant": 9020
	},
	"zh-hant-sg": {
		"redundant": 9021
	},
	"zh-hant-tw": {
		"redundant": 9022
	},
	"zh-wuu": {
		"redundant": 9023
	},
	"zh-yue": {
		"redundant": 9024
	}
}

},{}],68:[function(require,module,exports){
module.exports={
	"ak": 4,
	"ar": 7,
	"ay": 10,
	"az": 11,
	"cr": 26,
	"et": 40,
	"fa": 42,
	"ff": 43,
	"gn": 52,
	"ik": 69,
	"iu": 74,
	"kg": 81,
	"kr": 89,
	"ku": 91,
	"kv": 92,
	"lv": 103,
	"mg": 104,
	"mn": 109,
	"ms": 112,
	"ne": 118,
	"no": 122,
	"oj": 127,
	"om": 128,
	"or": 129,
	"ps": 134,
	"qu": 136,
	"sc": 143,
	"sh": 147,
	"sq": 154,
	"sw": 160,
	"uz": 178,
	"yi": 185,
	"za": 187,
	"zh": 188,
	"bal": 719,
	"bik": 917,
	"bnc": 1036,
	"bua": 1205,
	"chm": 1455,
	"del": 1751,
	"den": 1753,
	"din": 1805,
	"doi": 1881,
	"gba": 2223,
	"gon": 2415,
	"grb": 2436,
	"hai": 2545,
	"hmn": 2622,
	"jrb": 3005,
	"kln": 3319,
	"kok": 3392,
	"kpe": 3409,
	"lah": 3693,
	"luy": 4000,
	"man": 4033,
	"mwr": 4583,
	"raj": 5755,
	"rom": 5860,
	"syr": 6407,
	"tmh": 6676,
	"zap": 7957,
	"zza": 8124
}

},{}],69:[function(require,module,exports){
module.exports={
	"File-Date": "2017-03-03"
}

},{}],70:[function(require,module,exports){
module.exports=[
	{
		"Type": "language",
		"Subtag": "aa",
		"Description": [
			"Afar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ab",
		"Description": [
			"Abkhazian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Cyrl"
	},
	{
		"Type": "language",
		"Subtag": "ae",
		"Description": [
			"Avestan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "af",
		"Description": [
			"Afrikaans"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ak",
		"Description": [
			"Akan"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "am",
		"Description": [
			"Amharic"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Ethi"
	},
	{
		"Type": "language",
		"Subtag": "an",
		"Description": [
			"Aragonese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ar",
		"Description": [
			"Arabic"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Arab",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "as",
		"Description": [
			"Assamese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Beng"
	},
	{
		"Type": "language",
		"Subtag": "av",
		"Description": [
			"Avaric"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ay",
		"Description": [
			"Aymara"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "az",
		"Description": [
			"Azerbaijani"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ba",
		"Description": [
			"Bashkir"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "be",
		"Description": [
			"Belarusian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Cyrl"
	},
	{
		"Type": "language",
		"Subtag": "bg",
		"Description": [
			"Bulgarian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Cyrl"
	},
	{
		"Type": "language",
		"Subtag": "bh",
		"Description": [
			"Bihari languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "bi",
		"Description": [
			"Bislama"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bm",
		"Description": [
			"Bambara"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bn",
		"Description": [
			"Bengali",
			"Bangla"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Beng"
	},
	{
		"Type": "language",
		"Subtag": "bo",
		"Description": [
			"Tibetan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "br",
		"Description": [
			"Breton"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bs",
		"Description": [
			"Bosnian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Macrolanguage": "sh"
	},
	{
		"Type": "language",
		"Subtag": "ca",
		"Description": [
			"Catalan",
			"Valencian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ce",
		"Description": [
			"Chechen"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ch",
		"Description": [
			"Chamorro"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "co",
		"Description": [
			"Corsican"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cr",
		"Description": [
			"Cree"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "cs",
		"Description": [
			"Czech"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "cu",
		"Description": [
			"Church Slavic",
			"Church Slavonic",
			"Old Bulgarian",
			"Old Church Slavonic",
			"Old Slavonic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cv",
		"Description": [
			"Chuvash"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cy",
		"Description": [
			"Welsh"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "da",
		"Description": [
			"Danish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "de",
		"Description": [
			"German"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "dv",
		"Description": [
			"Dhivehi",
			"Divehi",
			"Maldivian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Thaa"
	},
	{
		"Type": "language",
		"Subtag": "dz",
		"Description": [
			"Dzongkha"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Tibt"
	},
	{
		"Type": "language",
		"Subtag": "ee",
		"Description": [
			"Ewe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "el",
		"Description": [
			"Modern Greek (1453-)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Grek"
	},
	{
		"Type": "language",
		"Subtag": "en",
		"Description": [
			"English"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "eo",
		"Description": [
			"Esperanto"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "es",
		"Description": [
			"Spanish",
			"Castilian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "et",
		"Description": [
			"Estonian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "eu",
		"Description": [
			"Basque"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "fa",
		"Description": [
			"Persian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Arab",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ff",
		"Description": [
			"Fulah"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "fi",
		"Description": [
			"Finnish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "fj",
		"Description": [
			"Fijian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "fo",
		"Description": [
			"Faroese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "fr",
		"Description": [
			"French"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "fy",
		"Description": [
			"Western Frisian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ga",
		"Description": [
			"Irish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "gd",
		"Description": [
			"Scottish Gaelic",
			"Gaelic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gl",
		"Description": [
			"Galician"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "gn",
		"Description": [
			"Guarani"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "gu",
		"Description": [
			"Gujarati"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Gujr"
	},
	{
		"Type": "language",
		"Subtag": "gv",
		"Description": [
			"Manx"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ha",
		"Description": [
			"Hausa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "he",
		"Description": [
			"Hebrew"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Hebr"
	},
	{
		"Type": "language",
		"Subtag": "hi",
		"Description": [
			"Hindi"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Deva"
	},
	{
		"Type": "language",
		"Subtag": "ho",
		"Description": [
			"Hiri Motu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "hr",
		"Description": [
			"Croatian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Macrolanguage": "sh"
	},
	{
		"Type": "language",
		"Subtag": "ht",
		"Description": [
			"Haitian",
			"Haitian Creole"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "hu",
		"Description": [
			"Hungarian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "hy",
		"Description": [
			"Armenian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Armn"
	},
	{
		"Type": "language",
		"Subtag": "hz",
		"Description": [
			"Herero"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ia",
		"Description": [
			"Interlingua (International Auxiliary Language",
			"Association)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "id",
		"Description": [
			"Indonesian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "ie",
		"Description": [
			"Interlingue",
			"Occidental"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ig",
		"Description": [
			"Igbo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ii",
		"Description": [
			"Sichuan Yi",
			"Nuosu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ik",
		"Description": [
			"Inupiaq"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "in",
		"Description": [
			"Indonesian"
		],
		"Added": "2005-10-16",
		"Deprecated": "1989-01-01",
		"Preferred-Value": "id",
		"Suppress-Script": "Latn",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "io",
		"Description": [
			"Ido"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "is",
		"Description": [
			"Icelandic"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "it",
		"Description": [
			"Italian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "iu",
		"Description": [
			"Inuktitut"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "iw",
		"Description": [
			"Hebrew"
		],
		"Added": "2005-10-16",
		"Deprecated": "1989-01-01",
		"Preferred-Value": "he",
		"Suppress-Script": "Hebr"
	},
	{
		"Type": "language",
		"Subtag": "ja",
		"Description": [
			"Japanese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Jpan"
	},
	{
		"Type": "language",
		"Subtag": "ji",
		"Description": [
			"Yiddish"
		],
		"Added": "2005-10-16",
		"Deprecated": "1989-01-01",
		"Preferred-Value": "yi"
	},
	{
		"Type": "language",
		"Subtag": "jv",
		"Description": [
			"Javanese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "jw",
		"Description": [
			"Javanese"
		],
		"Added": "2005-10-16",
		"Deprecated": "2001-08-13",
		"Preferred-Value": "jv",
		"Comments": [
			"published by error in Table 1 of ISO 639:1988"
		]
	},
	{
		"Type": "language",
		"Subtag": "ka",
		"Description": [
			"Georgian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Geor"
	},
	{
		"Type": "language",
		"Subtag": "kg",
		"Description": [
			"Kongo"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ki",
		"Description": [
			"Kikuyu",
			"Gikuyu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kj",
		"Description": [
			"Kuanyama",
			"Kwanyama"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kk",
		"Description": [
			"Kazakh"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Cyrl"
	},
	{
		"Type": "language",
		"Subtag": "kl",
		"Description": [
			"Kalaallisut",
			"Greenlandic"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "km",
		"Description": [
			"Central Khmer"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Khmr"
	},
	{
		"Type": "language",
		"Subtag": "kn",
		"Description": [
			"Kannada"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Knda"
	},
	{
		"Type": "language",
		"Subtag": "ko",
		"Description": [
			"Korean"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Kore"
	},
	{
		"Type": "language",
		"Subtag": "kr",
		"Description": [
			"Kanuri"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ks",
		"Description": [
			"Kashmiri"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ku",
		"Description": [
			"Kurdish"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "kv",
		"Description": [
			"Komi"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "kw",
		"Description": [
			"Cornish"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ky",
		"Description": [
			"Kirghiz",
			"Kyrgyz"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "la",
		"Description": [
			"Latin"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "lb",
		"Description": [
			"Luxembourgish",
			"Letzeburgesch"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "lg",
		"Description": [
			"Ganda"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "li",
		"Description": [
			"Limburgan",
			"Limburger",
			"Limburgish"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ln",
		"Description": [
			"Lingala"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "lo",
		"Description": [
			"Lao"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Laoo"
	},
	{
		"Type": "language",
		"Subtag": "lt",
		"Description": [
			"Lithuanian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "lu",
		"Description": [
			"Luba-Katanga"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lv",
		"Description": [
			"Latvian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "mg",
		"Description": [
			"Malagasy"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "mh",
		"Description": [
			"Marshallese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "mi",
		"Description": [
			"Maori"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mk",
		"Description": [
			"Macedonian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Cyrl"
	},
	{
		"Type": "language",
		"Subtag": "ml",
		"Description": [
			"Malayalam"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Mlym"
	},
	{
		"Type": "language",
		"Subtag": "mn",
		"Description": [
			"Mongolian"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "mo",
		"Description": [
			"Moldavian",
			"Moldovan"
		],
		"Added": "2005-10-16",
		"Deprecated": "2008-11-22",
		"Preferred-Value": "ro",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "mr",
		"Description": [
			"Marathi"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Deva"
	},
	{
		"Type": "language",
		"Subtag": "ms",
		"Description": [
			"Malay (macrolanguage)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "mt",
		"Description": [
			"Maltese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "my",
		"Description": [
			"Burmese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Mymr"
	},
	{
		"Type": "language",
		"Subtag": "na",
		"Description": [
			"Nauru"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "nb",
		"Description": [
			"Norwegian Bokmål"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Macrolanguage": "no"
	},
	{
		"Type": "language",
		"Subtag": "nd",
		"Description": [
			"North Ndebele"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ne",
		"Description": [
			"Nepali (macrolanguage)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Deva",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ng",
		"Description": [
			"Ndonga"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nl",
		"Description": [
			"Dutch",
			"Flemish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "nn",
		"Description": [
			"Norwegian Nynorsk"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Macrolanguage": "no"
	},
	{
		"Type": "language",
		"Subtag": "no",
		"Description": [
			"Norwegian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "nr",
		"Description": [
			"South Ndebele"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "nv",
		"Description": [
			"Navajo",
			"Navaho"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ny",
		"Description": [
			"Nyanja",
			"Chewa",
			"Chichewa"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "oc",
		"Description": [
			"Occitan (post 1500)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "oj",
		"Description": [
			"Ojibwa"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "om",
		"Description": [
			"Oromo"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "or",
		"Description": [
			"Oriya (macrolanguage)",
			"Odia (macrolanguage)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Orya",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "os",
		"Description": [
			"Ossetian",
			"Ossetic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pa",
		"Description": [
			"Panjabi",
			"Punjabi"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Guru"
	},
	{
		"Type": "language",
		"Subtag": "pi",
		"Description": [
			"Pali"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pl",
		"Description": [
			"Polish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ps",
		"Description": [
			"Pushto",
			"Pashto"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Arab",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "pt",
		"Description": [
			"Portuguese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "qu",
		"Description": [
			"Quechua"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "rm",
		"Description": [
			"Romansh"
		],
		"Suppress-Script": "Latn",
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "rn",
		"Description": [
			"Rundi"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ro",
		"Description": [
			"Romanian",
			"Moldavian",
			"Moldovan"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ru",
		"Description": [
			"Russian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Cyrl"
	},
	{
		"Type": "language",
		"Subtag": "rw",
		"Description": [
			"Kinyarwanda"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "sa",
		"Description": [
			"Sanskrit"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sc",
		"Description": [
			"Sardinian"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "sd",
		"Description": [
			"Sindhi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "se",
		"Description": [
			"Northern Sami"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sg",
		"Description": [
			"Sango"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "sh",
		"Description": [
			"Serbo-Croatian"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage",
		"Comments": [
			"sr, hr, bs are preferred for most modern uses"
		]
	},
	{
		"Type": "language",
		"Subtag": "si",
		"Description": [
			"Sinhala",
			"Sinhalese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Sinh"
	},
	{
		"Type": "language",
		"Subtag": "sk",
		"Description": [
			"Slovak"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "sl",
		"Description": [
			"Slovenian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "sm",
		"Description": [
			"Samoan"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "sn",
		"Description": [
			"Shona"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "so",
		"Description": [
			"Somali"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "sq",
		"Description": [
			"Albanian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "sr",
		"Description": [
			"Serbian"
		],
		"Added": "2005-10-16",
		"Macrolanguage": "sh"
	},
	{
		"Type": "language",
		"Subtag": "ss",
		"Description": [
			"Swati"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "st",
		"Description": [
			"Southern Sotho"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "su",
		"Description": [
			"Sundanese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sv",
		"Description": [
			"Swedish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "sw",
		"Description": [
			"Swahili (macrolanguage)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ta",
		"Description": [
			"Tamil"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Taml"
	},
	{
		"Type": "language",
		"Subtag": "te",
		"Description": [
			"Telugu"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Telu"
	},
	{
		"Type": "language",
		"Subtag": "tg",
		"Description": [
			"Tajik"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "th",
		"Description": [
			"Thai"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Thai"
	},
	{
		"Type": "language",
		"Subtag": "ti",
		"Description": [
			"Tigrinya"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Ethi"
	},
	{
		"Type": "language",
		"Subtag": "tk",
		"Description": [
			"Turkmen"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tl",
		"Description": [
			"Tagalog"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "tn",
		"Description": [
			"Tswana"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "to",
		"Description": [
			"Tonga (Tonga Islands)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "tr",
		"Description": [
			"Turkish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ts",
		"Description": [
			"Tsonga"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "tt",
		"Description": [
			"Tatar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tw",
		"Description": [
			"Twi"
		],
		"Added": "2005-10-16",
		"Macrolanguage": "ak"
	},
	{
		"Type": "language",
		"Subtag": "ty",
		"Description": [
			"Tahitian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ug",
		"Description": [
			"Uighur",
			"Uyghur"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "uk",
		"Description": [
			"Ukrainian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Cyrl"
	},
	{
		"Type": "language",
		"Subtag": "ur",
		"Description": [
			"Urdu"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Arab"
	},
	{
		"Type": "language",
		"Subtag": "uz",
		"Description": [
			"Uzbek"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ve",
		"Description": [
			"Venda"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "vi",
		"Description": [
			"Vietnamese"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "vo",
		"Description": [
			"Volapük"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "wa",
		"Description": [
			"Walloon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "wo",
		"Description": [
			"Wolof"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "xh",
		"Description": [
			"Xhosa"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "yi",
		"Description": [
			"Yiddish"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Hebr",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "yo",
		"Description": [
			"Yoruba"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "za",
		"Description": [
			"Zhuang",
			"Chuang"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "zh",
		"Description": [
			"Chinese"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "zu",
		"Description": [
			"Zulu"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "aaa",
		"Description": [
			"Ghotuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aab",
		"Description": [
			"Alumu-Tesu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aac",
		"Description": [
			"Ari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aad",
		"Description": [
			"Amal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aae",
		"Description": [
			"Arbëreshë Albanian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sq"
	},
	{
		"Type": "language",
		"Subtag": "aaf",
		"Description": [
			"Aranadan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aag",
		"Description": [
			"Ambrak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aah",
		"Description": [
			"Abu' Arapesh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aai",
		"Description": [
			"Arifama-Miniafia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aak",
		"Description": [
			"Ankave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aal",
		"Description": [
			"Afade"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aam",
		"Description": [
			"Aramanik"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "aas"
	},
	{
		"Type": "language",
		"Subtag": "aan",
		"Description": [
			"Anambé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aao",
		"Description": [
			"Algerian Saharan Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "aap",
		"Description": [
			"Pará Arára"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aaq",
		"Description": [
			"Eastern Abnaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aas",
		"Description": [
			"Aasáx"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aat",
		"Description": [
			"Arvanitika Albanian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sq"
	},
	{
		"Type": "language",
		"Subtag": "aau",
		"Description": [
			"Abau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aav",
		"Description": [
			"Austro-Asiatic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "aaw",
		"Description": [
			"Solong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aax",
		"Description": [
			"Mandobo Atas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aaz",
		"Description": [
			"Amarasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aba",
		"Description": [
			"Abé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abb",
		"Description": [
			"Bankon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abc",
		"Description": [
			"Ambala Ayta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abd",
		"Description": [
			"Manide"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abe",
		"Description": [
			"Western Abnaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abf",
		"Description": [
			"Abai Sungai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abg",
		"Description": [
			"Abaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abh",
		"Description": [
			"Tajiki Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "abi",
		"Description": [
			"Abidji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abj",
		"Description": [
			"Aka-Bea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abl",
		"Description": [
			"Lampung Nyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abm",
		"Description": [
			"Abanyom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abn",
		"Description": [
			"Abua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abo",
		"Description": [
			"Abon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abp",
		"Description": [
			"Abellen Ayta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abq",
		"Description": [
			"Abaza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abr",
		"Description": [
			"Abron"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abs",
		"Description": [
			"Ambonese Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abt",
		"Description": [
			"Ambulas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abu",
		"Description": [
			"Abure"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abv",
		"Description": [
			"Baharna Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "abw",
		"Description": [
			"Pal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abx",
		"Description": [
			"Inabaknon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aby",
		"Description": [
			"Aneme Wake"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "abz",
		"Description": [
			"Abui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aca",
		"Description": [
			"Achagua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acb",
		"Description": [
			"Áncá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acd",
		"Description": [
			"Gikyode"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ace",
		"Description": [
			"Achinese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "acf",
		"Description": [
			"Saint Lucian Creole French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ach",
		"Description": [
			"Acoli"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "aci",
		"Description": [
			"Aka-Cari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ack",
		"Description": [
			"Aka-Kora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acl",
		"Description": [
			"Akar-Bale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acm",
		"Description": [
			"Mesopotamian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "acn",
		"Description": [
			"Achang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acp",
		"Description": [
			"Eastern Acipa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acq",
		"Description": [
			"Ta'izzi-Adeni Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "acr",
		"Description": [
			"Achi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acs",
		"Description": [
			"Acroá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "act",
		"Description": [
			"Achterhoeks"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acu",
		"Description": [
			"Achuar-Shiwiar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acv",
		"Description": [
			"Achumawi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "acw",
		"Description": [
			"Hijazi Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "acx",
		"Description": [
			"Omani Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "acy",
		"Description": [
			"Cypriot Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "acz",
		"Description": [
			"Acheron"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ada",
		"Description": [
			"Adangme"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "adb",
		"Description": [
			"Adabe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "add",
		"Description": [
			"Dzodinka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ade",
		"Description": [
			"Adele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adf",
		"Description": [
			"Dhofari Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "adg",
		"Description": [
			"Andegerebinha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adh",
		"Description": [
			"Adhola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adi",
		"Description": [
			"Adi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adj",
		"Description": [
			"Adioukrou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adl",
		"Description": [
			"Galo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adn",
		"Description": [
			"Adang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ado",
		"Description": [
			"Abu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adp",
		"Description": [
			"Adap"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "dz"
	},
	{
		"Type": "language",
		"Subtag": "adq",
		"Description": [
			"Adangbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adr",
		"Description": [
			"Adonara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ads",
		"Description": [
			"Adamorobe Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adt",
		"Description": [
			"Adnyamathanha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adu",
		"Description": [
			"Aduge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adw",
		"Description": [
			"Amundava"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "adx",
		"Description": [
			"Amdo Tibetan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ady",
		"Description": [
			"Adyghe",
			"Adygei"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "adz",
		"Description": [
			"Adzera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aea",
		"Description": [
			"Areba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aeb",
		"Description": [
			"Tunisian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "aec",
		"Description": [
			"Saidi Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "aed",
		"Description": [
			"Argentine Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aee",
		"Description": [
			"Northeast Pashai",
			"Northeast Pashayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aek",
		"Description": [
			"Haeke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ael",
		"Description": [
			"Ambele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aem",
		"Description": [
			"Arem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aen",
		"Description": [
			"Armenian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aeq",
		"Description": [
			"Aer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aer",
		"Description": [
			"Eastern Arrernte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aes",
		"Description": [
			"Alsea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aeu",
		"Description": [
			"Akeu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aew",
		"Description": [
			"Ambakich"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aey",
		"Description": [
			"Amele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aez",
		"Description": [
			"Aeka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afa",
		"Description": [
			"Afro-Asiatic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "afb",
		"Description": [
			"Gulf Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "afd",
		"Description": [
			"Andai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afe",
		"Description": [
			"Putukwam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afg",
		"Description": [
			"Afghan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afh",
		"Description": [
			"Afrihili"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "afi",
		"Description": [
			"Akrukay",
			"Chini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afk",
		"Description": [
			"Nanubae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afn",
		"Description": [
			"Defaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afo",
		"Description": [
			"Eloyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afp",
		"Description": [
			"Tapei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afs",
		"Description": [
			"Afro-Seminole Creole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aft",
		"Description": [
			"Afitti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afu",
		"Description": [
			"Awutu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "afz",
		"Description": [
			"Obokuitai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aga",
		"Description": [
			"Aguano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agb",
		"Description": [
			"Legbo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agc",
		"Description": [
			"Agatu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agd",
		"Description": [
			"Agarabi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "age",
		"Description": [
			"Angal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agf",
		"Description": [
			"Arguni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agg",
		"Description": [
			"Angor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agh",
		"Description": [
			"Ngelima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agi",
		"Description": [
			"Agariya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agj",
		"Description": [
			"Argobba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agk",
		"Description": [
			"Isarog Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agl",
		"Description": [
			"Fembe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agm",
		"Description": [
			"Angaataha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agn",
		"Description": [
			"Agutaynen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ago",
		"Description": [
			"Tainae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agp",
		"Description": [
			"Paranan"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see apf, prf"
		]
	},
	{
		"Type": "language",
		"Subtag": "agq",
		"Description": [
			"Aghem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agr",
		"Description": [
			"Aguaruna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ags",
		"Description": [
			"Esimbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agt",
		"Description": [
			"Central Cagayan Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agu",
		"Description": [
			"Aguacateco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agv",
		"Description": [
			"Remontado Dumagat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agw",
		"Description": [
			"Kahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agx",
		"Description": [
			"Aghul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agy",
		"Description": [
			"Southern Alta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "agz",
		"Description": [
			"Mt. Iriga Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aha",
		"Description": [
			"Ahanta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahb",
		"Description": [
			"Axamb"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahg",
		"Description": [
			"Qimant"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahh",
		"Description": [
			"Aghu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahi",
		"Description": [
			"Tiagbamrin Aizi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahk",
		"Description": [
			"Akha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahl",
		"Description": [
			"Igo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahm",
		"Description": [
			"Mobumrin Aizi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahn",
		"Description": [
			"Àhàn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aho",
		"Description": [
			"Ahom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahp",
		"Description": [
			"Aproumu Aizi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahr",
		"Description": [
			"Ahirani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ahs",
		"Description": [
			"Ashe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aht",
		"Description": [
			"Ahtena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aia",
		"Description": [
			"Arosi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aib",
		"Description": [
			"Ainu (China)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aic",
		"Description": [
			"Ainbai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aid",
		"Description": [
			"Alngith"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aie",
		"Description": [
			"Amara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aif",
		"Description": [
			"Agi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aig",
		"Description": [
			"Antigua and Barbuda Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aih",
		"Description": [
			"Ai-Cham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aii",
		"Description": [
			"Assyrian Neo-Aramaic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "syr"
	},
	{
		"Type": "language",
		"Subtag": "aij",
		"Description": [
			"Lishanid Noshan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aik",
		"Description": [
			"Ake"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ail",
		"Description": [
			"Aimele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aim",
		"Description": [
			"Aimol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ain",
		"Description": [
			"Ainu (Japan)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "aio",
		"Description": [
			"Aiton"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aip",
		"Description": [
			"Burumakok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aiq",
		"Description": [
			"Aimaq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "air",
		"Description": [
			"Airoran"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ais",
		"Description": [
			"Nataoran Amis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ait",
		"Description": [
			"Arikem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aiw",
		"Description": [
			"Aari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aix",
		"Description": [
			"Aighon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aiy",
		"Description": [
			"Ali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aja",
		"Description": [
			"Aja (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ajg",
		"Description": [
			"Aja (Benin)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aji",
		"Description": [
			"Ajië"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ajn",
		"Description": [
			"Andajin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "ajp",
		"Description": [
			"South Levantine Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "ajt",
		"Description": [
			"Judeo-Tunisian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "jrb"
	},
	{
		"Type": "language",
		"Subtag": "aju",
		"Description": [
			"Judeo-Moroccan Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "jrb"
	},
	{
		"Type": "language",
		"Subtag": "ajw",
		"Description": [
			"Ajawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ajz",
		"Description": [
			"Amri Karbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akb",
		"Description": [
			"Batak Angkola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akc",
		"Description": [
			"Mpur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akd",
		"Description": [
			"Ukpet-Ehom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ake",
		"Description": [
			"Akawaio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akf",
		"Description": [
			"Akpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akg",
		"Description": [
			"Anakalangu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akh",
		"Description": [
			"Angal Heneng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aki",
		"Description": [
			"Aiome"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akj",
		"Description": [
			"Aka-Jeru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akk",
		"Description": [
			"Akkadian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "akl",
		"Description": [
			"Aklanon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akm",
		"Description": [
			"Aka-Bo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ako",
		"Description": [
			"Akurio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akp",
		"Description": [
			"Siwu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akq",
		"Description": [
			"Ak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akr",
		"Description": [
			"Araki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aks",
		"Description": [
			"Akaselem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akt",
		"Description": [
			"Akolet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aku",
		"Description": [
			"Akum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akv",
		"Description": [
			"Akhvakh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akw",
		"Description": [
			"Akwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akx",
		"Description": [
			"Aka-Kede"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aky",
		"Description": [
			"Aka-Kol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "akz",
		"Description": [
			"Alabama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ala",
		"Description": [
			"Alago"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alc",
		"Description": [
			"Qawasqar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ald",
		"Description": [
			"Alladian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ale",
		"Description": [
			"Aleut"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "alf",
		"Description": [
			"Alege"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alg",
		"Description": [
			"Algonquian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "alh",
		"Description": [
			"Alawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ali",
		"Description": [
			"Amaimon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alj",
		"Description": [
			"Alangan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alk",
		"Description": [
			"Alak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "all",
		"Description": [
			"Allar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alm",
		"Description": [
			"Amblong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aln",
		"Description": [
			"Gheg Albanian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sq"
	},
	{
		"Type": "language",
		"Subtag": "alo",
		"Description": [
			"Larike-Wakasihu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alp",
		"Description": [
			"Alune"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alq",
		"Description": [
			"Algonquin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alr",
		"Description": [
			"Alutor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "als",
		"Description": [
			"Tosk Albanian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sq"
	},
	{
		"Type": "language",
		"Subtag": "alt",
		"Description": [
			"Southern Altai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "alu",
		"Description": [
			"'Are'are"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alv",
		"Description": [
			"Atlantic-Congo languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "alw",
		"Description": [
			"Alaba-K’abeena",
			"Wanbasana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alx",
		"Description": [
			"Amol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aly",
		"Description": [
			"Alyawarr"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "alz",
		"Description": [
			"Alur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ama",
		"Description": [
			"Amanayé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amb",
		"Description": [
			"Ambo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amc",
		"Description": [
			"Amahuaca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ame",
		"Description": [
			"Yanesha'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amf",
		"Description": [
			"Hamer-Banna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amg",
		"Description": [
			"Amurdak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ami",
		"Description": [
			"Amis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amj",
		"Description": [
			"Amdang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amk",
		"Description": [
			"Ambai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aml",
		"Description": [
			"War-Jaintia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amm",
		"Description": [
			"Ama (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amn",
		"Description": [
			"Amanab"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amo",
		"Description": [
			"Amo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amp",
		"Description": [
			"Alamblak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amq",
		"Description": [
			"Amahai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amr",
		"Description": [
			"Amarakaeri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ams",
		"Description": [
			"Southern Amami-Oshima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amt",
		"Description": [
			"Amto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amu",
		"Description": [
			"Guerrero Amuzgo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amv",
		"Description": [
			"Ambelau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amw",
		"Description": [
			"Western Neo-Aramaic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amx",
		"Description": [
			"Anmatyerre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amy",
		"Description": [
			"Ami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "amz",
		"Description": [
			"Atampaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ana",
		"Description": [
			"Andaqui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anb",
		"Description": [
			"Andoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anc",
		"Description": [
			"Ngas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "and",
		"Description": [
			"Ansus"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ane",
		"Description": [
			"Xârâcùù"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anf",
		"Description": [
			"Animere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ang",
		"Description": [
			"Old English (ca. 450-1100)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "anh",
		"Description": [
			"Nend"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ani",
		"Description": [
			"Andi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anj",
		"Description": [
			"Anor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ank",
		"Description": [
			"Goemai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anl",
		"Description": [
			"Anu-Hkongso Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anm",
		"Description": [
			"Anal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ann",
		"Description": [
			"Obolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ano",
		"Description": [
			"Andoque"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anp",
		"Description": [
			"Angika"
		],
		"Added": "2006-03-08"
	},
	{
		"Type": "language",
		"Subtag": "anq",
		"Description": [
			"Jarawa (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anr",
		"Description": [
			"Andh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ans",
		"Description": [
			"Anserma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ant",
		"Description": [
			"Antakarinya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anu",
		"Description": [
			"Anuak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anv",
		"Description": [
			"Denya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anw",
		"Description": [
			"Anaang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anx",
		"Description": [
			"Andra-Hus"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "any",
		"Description": [
			"Anyin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "anz",
		"Description": [
			"Anem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aoa",
		"Description": [
			"Angolar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aob",
		"Description": [
			"Abom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aoc",
		"Description": [
			"Pemon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aod",
		"Description": [
			"Andarum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aoe",
		"Description": [
			"Angal Enen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aof",
		"Description": [
			"Bragat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aog",
		"Description": [
			"Angoram"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aoh",
		"Description": [
			"Arma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aoi",
		"Description": [
			"Anindilyakwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aoj",
		"Description": [
			"Mufian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aok",
		"Description": [
			"Arhö"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aol",
		"Description": [
			"Alor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aom",
		"Description": [
			"Ömie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aon",
		"Description": [
			"Bumbita Arapesh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aor",
		"Description": [
			"Aore"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aos",
		"Description": [
			"Taikat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aot",
		"Description": [
			"Atong (India)",
			"A'tong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aou",
		"Description": [
			"A'ou"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "aox",
		"Description": [
			"Atorada"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aoz",
		"Description": [
			"Uab Meto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apa",
		"Description": [
			"Apache languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "apb",
		"Description": [
			"Sa'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apc",
		"Description": [
			"North Levantine Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "apd",
		"Description": [
			"Sudanese Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "ape",
		"Description": [
			"Bukiyip"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apf",
		"Description": [
			"Pahanan Agta"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "apg",
		"Description": [
			"Ampanang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aph",
		"Description": [
			"Athpariya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "api",
		"Description": [
			"Apiaká"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apj",
		"Description": [
			"Jicarilla Apache"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apk",
		"Description": [
			"Kiowa Apache"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apl",
		"Description": [
			"Lipan Apache"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apm",
		"Description": [
			"Mescalero-Chiricahua Apache"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apn",
		"Description": [
			"Apinayé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apo",
		"Description": [
			"Ambul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "app",
		"Description": [
			"Apma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apq",
		"Description": [
			"A-Pucikwar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apr",
		"Description": [
			"Arop-Lokep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aps",
		"Description": [
			"Arop-Sissano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apt",
		"Description": [
			"Apatani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apu",
		"Description": [
			"Apurinã"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apv",
		"Description": [
			"Alapmunte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apw",
		"Description": [
			"Western Apache"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apx",
		"Description": [
			"Aputai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apy",
		"Description": [
			"Apalaí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "apz",
		"Description": [
			"Safeyoka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aqa",
		"Description": [
			"Alacalufan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "aqc",
		"Description": [
			"Archi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aqd",
		"Description": [
			"Ampari Dogon"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "aqg",
		"Description": [
			"Arigidi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aql",
		"Description": [
			"Algic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "aqm",
		"Description": [
			"Atohwaim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aqn",
		"Description": [
			"Northern Alta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aqp",
		"Description": [
			"Atakapa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aqr",
		"Description": [
			"Arhâ"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aqt",
		"Description": [
			"Angaité"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "aqz",
		"Description": [
			"Akuntsu"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "arb",
		"Description": [
			"Standard Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "arc",
		"Description": [
			"Official Aramaic (700-300 BCE)",
			"Imperial Aramaic (700-300 BCE)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ard",
		"Description": [
			"Arabana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "are",
		"Description": [
			"Western Arrarnta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "arh",
		"Description": [
			"Arhuaco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ari",
		"Description": [
			"Arikara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "arj",
		"Description": [
			"Arapaso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ark",
		"Description": [
			"Arikapú"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "arl",
		"Description": [
			"Arabela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "arn",
		"Description": [
			"Mapudungun",
			"Mapuche"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "aro",
		"Description": [
			"Araona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "arp",
		"Description": [
			"Arapaho"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "arq",
		"Description": [
			"Algerian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "arr",
		"Description": [
			"Karo (Brazil)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ars",
		"Description": [
			"Najdi Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "art",
		"Description": [
			"Artificial languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "aru",
		"Description": [
			"Aruá (Amazonas State)",
			"Arawá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "arv",
		"Description": [
			"Arbore"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "arw",
		"Description": [
			"Arawak"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "arx",
		"Description": [
			"Aruá (Rodonia State)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ary",
		"Description": [
			"Moroccan Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "arz",
		"Description": [
			"Egyptian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "asa",
		"Description": [
			"Asu (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asb",
		"Description": [
			"Assiniboine"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asc",
		"Description": [
			"Casuarina Coast Asmat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asd",
		"Description": [
			"Asas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ase",
		"Description": [
			"American Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asf",
		"Description": [
			"Australian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asg",
		"Description": [
			"Cishingini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ash",
		"Description": [
			"Abishira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asi",
		"Description": [
			"Buruwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asj",
		"Description": [
			"Sari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ask",
		"Description": [
			"Ashkun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asl",
		"Description": [
			"Asilulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asn",
		"Description": [
			"Xingú Asuriní"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aso",
		"Description": [
			"Dano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asp",
		"Description": [
			"Algerian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asq",
		"Description": [
			"Austrian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asr",
		"Description": [
			"Asuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ass",
		"Description": [
			"Ipulo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ast",
		"Description": [
			"Asturian",
			"Asturleonese",
			"Bable",
			"Leonese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "asu",
		"Description": [
			"Tocantins Asurini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asv",
		"Description": [
			"Asoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asw",
		"Description": [
			"Australian Aborigines Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asx",
		"Description": [
			"Muratayak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asy",
		"Description": [
			"Yaosakor Asmat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "asz",
		"Description": [
			"As"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ata",
		"Description": [
			"Pele-Ata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atb",
		"Description": [
			"Zaiwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atc",
		"Description": [
			"Atsahuaca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atd",
		"Description": [
			"Ata Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ate",
		"Description": [
			"Atemble"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atg",
		"Description": [
			"Ivbie North-Okpela-Arhe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ath",
		"Description": [
			"Athapascan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ati",
		"Description": [
			"Attié"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atj",
		"Description": [
			"Atikamekw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atk",
		"Description": [
			"Ati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atl",
		"Description": [
			"Mt. Iraya Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atm",
		"Description": [
			"Ata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atn",
		"Description": [
			"Ashtiani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ato",
		"Description": [
			"Atong (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atp",
		"Description": [
			"Pudtol Atta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atq",
		"Description": [
			"Aralle-Tabulahan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atr",
		"Description": [
			"Waimiri-Atroari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ats",
		"Description": [
			"Gros Ventre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "att",
		"Description": [
			"Pamplona Atta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atu",
		"Description": [
			"Reel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atv",
		"Description": [
			"Northern Altai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atw",
		"Description": [
			"Atsugewi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atx",
		"Description": [
			"Arutani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aty",
		"Description": [
			"Aneityum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "atz",
		"Description": [
			"Arta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aua",
		"Description": [
			"Asumboa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aub",
		"Description": [
			"Alugu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auc",
		"Description": [
			"Waorani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aud",
		"Description": [
			"Anuta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aue",
		"Description": [
			"=/Kx'au//'ein"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "ktz"
	},
	{
		"Type": "language",
		"Subtag": "auf",
		"Description": [
			"Arauan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "aug",
		"Description": [
			"Aguna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auh",
		"Description": [
			"Aushi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aui",
		"Description": [
			"Anuki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auj",
		"Description": [
			"Awjilah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auk",
		"Description": [
			"Heyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aul",
		"Description": [
			"Aulua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aum",
		"Description": [
			"Asu (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aun",
		"Description": [
			"Molmo One"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auo",
		"Description": [
			"Auyokawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aup",
		"Description": [
			"Makayam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auq",
		"Description": [
			"Anus",
			"Korur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aur",
		"Description": [
			"Aruek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aus",
		"Description": [
			"Australian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "aut",
		"Description": [
			"Austral"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auu",
		"Description": [
			"Auye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auw",
		"Description": [
			"Awyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aux",
		"Description": [
			"Aurá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auy",
		"Description": [
			"Awiyaana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "auz",
		"Description": [
			"Uzbeki Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "avb",
		"Description": [
			"Avau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avd",
		"Description": [
			"Alviri-Vidari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avi",
		"Description": [
			"Avikam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avk",
		"Description": [
			"Kotava"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avl",
		"Description": [
			"Eastern Egyptian Bedawi Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "avm",
		"Description": [
			"Angkamuthi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "avn",
		"Description": [
			"Avatime"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avo",
		"Description": [
			"Agavotaguerra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avs",
		"Description": [
			"Aushiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avt",
		"Description": [
			"Au"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avu",
		"Description": [
			"Avokaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "avv",
		"Description": [
			"Avá-Canoeiro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awa",
		"Description": [
			"Awadhi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "awb",
		"Description": [
			"Awa (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awc",
		"Description": [
			"Cicipu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awd",
		"Description": [
			"Arawakan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "awe",
		"Description": [
			"Awetí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awg",
		"Description": [
			"Anguthimri"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "awh",
		"Description": [
			"Awbono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awi",
		"Description": [
			"Aekyom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awk",
		"Description": [
			"Awabakal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awm",
		"Description": [
			"Arawum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awn",
		"Description": [
			"Awngi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awo",
		"Description": [
			"Awak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awr",
		"Description": [
			"Awera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aws",
		"Description": [
			"South Awyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awt",
		"Description": [
			"Araweté"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awu",
		"Description": [
			"Central Awyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awv",
		"Description": [
			"Jair Awyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aww",
		"Description": [
			"Awun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awx",
		"Description": [
			"Awara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "awy",
		"Description": [
			"Edera Awyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "axb",
		"Description": [
			"Abipon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "axe",
		"Description": [
			"Ayerrerenge"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "axg",
		"Description": [
			"Mato Grosso Arára"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "axk",
		"Description": [
			"Yaka (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "axl",
		"Description": [
			"Lower Southern Aranda"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "axm",
		"Description": [
			"Middle Armenian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "axx",
		"Description": [
			"Xârâgurè"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aya",
		"Description": [
			"Awar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayb",
		"Description": [
			"Ayizo Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayc",
		"Description": [
			"Southern Aymara"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ay"
	},
	{
		"Type": "language",
		"Subtag": "ayd",
		"Description": [
			"Ayabadhu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aye",
		"Description": [
			"Ayere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayg",
		"Description": [
			"Ginyanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayh",
		"Description": [
			"Hadrami Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "ayi",
		"Description": [
			"Leyigha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayk",
		"Description": [
			"Akuku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayl",
		"Description": [
			"Libyan Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "ayn",
		"Description": [
			"Sanaani Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "ayo",
		"Description": [
			"Ayoreo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayp",
		"Description": [
			"North Mesopotamian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "ayq",
		"Description": [
			"Ayi (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayr",
		"Description": [
			"Central Aymara"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ay"
	},
	{
		"Type": "language",
		"Subtag": "ays",
		"Description": [
			"Sorsogon Ayta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayt",
		"Description": [
			"Magbukun Ayta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayu",
		"Description": [
			"Ayu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayx",
		"Description": [
			"Ayi (China)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16",
		"Preferred-Value": "nun"
	},
	{
		"Type": "language",
		"Subtag": "ayy",
		"Description": [
			"Tayabas Ayta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ayz",
		"Description": [
			"Mai Brat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "aza",
		"Description": [
			"Azha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "azb",
		"Description": [
			"South Azerbaijani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "az"
	},
	{
		"Type": "language",
		"Subtag": "azc",
		"Description": [
			"Uto-Aztecan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "azd",
		"Description": [
			"Eastern Durango Nahuatl"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "azg",
		"Description": [
			"San Pedro Amuzgos Amuzgo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "azj",
		"Description": [
			"North Azerbaijani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "az"
	},
	{
		"Type": "language",
		"Subtag": "azm",
		"Description": [
			"Ipalapa Amuzgo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "azn",
		"Description": [
			"Western Durango Nahuatl"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "azo",
		"Description": [
			"Awing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "azt",
		"Description": [
			"Faire Atta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "azz",
		"Description": [
			"Highland Puebla Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "baa",
		"Description": [
			"Babatana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bab",
		"Description": [
			"Bainouk-Gunyuño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bac",
		"Description": [
			"Badui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bad",
		"Description": [
			"Banda languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "bae",
		"Description": [
			"Baré"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "baf",
		"Description": [
			"Nubaca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bag",
		"Description": [
			"Tuki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bah",
		"Description": [
			"Bahamas Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bai",
		"Description": [
			"Bamileke languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "baj",
		"Description": [
			"Barakai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bal",
		"Description": [
			"Baluchi"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "ban",
		"Description": [
			"Balinese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bao",
		"Description": [
			"Waimaha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bap",
		"Description": [
			"Bantawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bar",
		"Description": [
			"Bavarian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bas",
		"Description": [
			"Basa (Cameroon)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bat",
		"Description": [
			"Baltic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "bau",
		"Description": [
			"Bada (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bav",
		"Description": [
			"Vengo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "baw",
		"Description": [
			"Bambili-Bambui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bax",
		"Description": [
			"Bamun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bay",
		"Description": [
			"Batuley"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "baz",
		"Description": [
			"Tunen"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see nvo, tvu"
		]
	},
	{
		"Type": "language",
		"Subtag": "bba",
		"Description": [
			"Baatonum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbb",
		"Description": [
			"Barai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbc",
		"Description": [
			"Batak Toba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbd",
		"Description": [
			"Bau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbe",
		"Description": [
			"Bangba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbf",
		"Description": [
			"Baibai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbg",
		"Description": [
			"Barama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbh",
		"Description": [
			"Bugan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbi",
		"Description": [
			"Barombi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbj",
		"Description": [
			"Ghomálá'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbk",
		"Description": [
			"Babanki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbl",
		"Description": [
			"Bats"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbm",
		"Description": [
			"Babango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbn",
		"Description": [
			"Uneapa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbo",
		"Description": [
			"Northern Bobo Madaré",
			"Konabéré"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbp",
		"Description": [
			"West Central Banda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbq",
		"Description": [
			"Bamali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbr",
		"Description": [
			"Girawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbs",
		"Description": [
			"Bakpinka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbt",
		"Description": [
			"Mburku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbu",
		"Description": [
			"Kulung (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbv",
		"Description": [
			"Karnai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbw",
		"Description": [
			"Baba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbx",
		"Description": [
			"Bubia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bby",
		"Description": [
			"Befang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bbz",
		"Description": [
			"Babalia Creole Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "bca",
		"Description": [
			"Central Bai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcb",
		"Description": [
			"Bainouk-Samik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcc",
		"Description": [
			"Southern Balochi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bal"
	},
	{
		"Type": "language",
		"Subtag": "bcd",
		"Description": [
			"North Babar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bce",
		"Description": [
			"Bamenyam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcf",
		"Description": [
			"Bamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcg",
		"Description": [
			"Baga Pokur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bch",
		"Description": [
			"Bariai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bci",
		"Description": [
			"Baoulé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcj",
		"Description": [
			"Bardi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bck",
		"Description": [
			"Bunaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcl",
		"Description": [
			"Central Bikol"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "bcm",
		"Description": [
			"Bannoni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcn",
		"Description": [
			"Bali (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bco",
		"Description": [
			"Kaluli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcp",
		"Description": [
			"Bali (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcq",
		"Description": [
			"Bench"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcr",
		"Description": [
			"Babine"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcs",
		"Description": [
			"Kohumono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bct",
		"Description": [
			"Bendi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcu",
		"Description": [
			"Awad Bing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcv",
		"Description": [
			"Shoo-Minda-Nye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcw",
		"Description": [
			"Bana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcy",
		"Description": [
			"Bacama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bcz",
		"Description": [
			"Bainouk-Gunyaamolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bda",
		"Description": [
			"Bayot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdb",
		"Description": [
			"Basap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdc",
		"Description": [
			"Emberá-Baudó"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdd",
		"Description": [
			"Bunama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bde",
		"Description": [
			"Bade"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdf",
		"Description": [
			"Biage"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "bdg",
		"Description": [
			"Bonggi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdh",
		"Description": [
			"Baka (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdi",
		"Description": [
			"Burun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdj",
		"Description": [
			"Bai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdk",
		"Description": [
			"Budukh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdl",
		"Description": [
			"Indonesian Bajau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdm",
		"Description": [
			"Buduma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdn",
		"Description": [
			"Baldemu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdo",
		"Description": [
			"Morom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdp",
		"Description": [
			"Bende"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdq",
		"Description": [
			"Bahnar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdr",
		"Description": [
			"West Coast Bajau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bds",
		"Description": [
			"Burunge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdt",
		"Description": [
			"Bokoto"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gba"
	},
	{
		"Type": "language",
		"Subtag": "bdu",
		"Description": [
			"Oroko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdv",
		"Description": [
			"Bodo Parja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdw",
		"Description": [
			"Baham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdx",
		"Description": [
			"Budong-Budong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdy",
		"Description": [
			"Bandjalang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bdz",
		"Description": [
			"Badeshi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bea",
		"Description": [
			"Beaver"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "beb",
		"Description": [
			"Bebele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bec",
		"Description": [
			"Iceve-Maci"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bed",
		"Description": [
			"Bedoanas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bee",
		"Description": [
			"Byangsi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bef",
		"Description": [
			"Benabena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "beg",
		"Description": [
			"Belait"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "beh",
		"Description": [
			"Biali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bei",
		"Description": [
			"Bekati'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bej",
		"Description": [
			"Beja",
			"Bedawiyet"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bek",
		"Description": [
			"Bebeli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bem",
		"Description": [
			"Bemba (Zambia)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "beo",
		"Description": [
			"Beami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bep",
		"Description": [
			"Besoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "beq",
		"Description": [
			"Beembe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ber",
		"Description": [
			"Berber languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "bes",
		"Description": [
			"Besme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bet",
		"Description": [
			"Guiberoua Béte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "beu",
		"Description": [
			"Blagar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bev",
		"Description": [
			"Daloa Bété"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bew",
		"Description": [
			"Betawi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bex",
		"Description": [
			"Jur Modo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bey",
		"Description": [
			"Beli (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bez",
		"Description": [
			"Bena (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfa",
		"Description": [
			"Bari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfb",
		"Description": [
			"Pauri Bareli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfc",
		"Description": [
			"Panyi Bai",
			"Northern Bai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfd",
		"Description": [
			"Bafut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfe",
		"Description": [
			"Betaf",
			"Tena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bff",
		"Description": [
			"Bofi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfg",
		"Description": [
			"Busang Kayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfh",
		"Description": [
			"Blafe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfi",
		"Description": [
			"British Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfj",
		"Description": [
			"Bafanji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfk",
		"Description": [
			"Ban Khor Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfl",
		"Description": [
			"Banda-Ndélé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfm",
		"Description": [
			"Mmen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfn",
		"Description": [
			"Bunak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfo",
		"Description": [
			"Malba Birifor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfp",
		"Description": [
			"Beba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfq",
		"Description": [
			"Badaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfr",
		"Description": [
			"Bazigar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfs",
		"Description": [
			"Southern Bai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bft",
		"Description": [
			"Balti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfu",
		"Description": [
			"Gahri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfw",
		"Description": [
			"Bondo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfx",
		"Description": [
			"Bantayanon"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "bfy",
		"Description": [
			"Bagheli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bfz",
		"Description": [
			"Mahasu Pahari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bga",
		"Description": [
			"Gwamhi-Wuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgb",
		"Description": [
			"Bobongko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgc",
		"Description": [
			"Haryanvi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgd",
		"Description": [
			"Rathwi Bareli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bge",
		"Description": [
			"Bauria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgf",
		"Description": [
			"Bangandu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgg",
		"Description": [
			"Bugun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgi",
		"Description": [
			"Giangan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgj",
		"Description": [
			"Bangolan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgk",
		"Description": [
			"Bit",
			"Buxinhua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgl",
		"Description": [
			"Bo (Laos)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgm",
		"Description": [
			"Baga Mboteni"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "bcg"
	},
	{
		"Type": "language",
		"Subtag": "bgn",
		"Description": [
			"Western Balochi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bal"
	},
	{
		"Type": "language",
		"Subtag": "bgo",
		"Description": [
			"Baga Koga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgp",
		"Description": [
			"Eastern Balochi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bal"
	},
	{
		"Type": "language",
		"Subtag": "bgq",
		"Description": [
			"Bagri"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "raj"
	},
	{
		"Type": "language",
		"Subtag": "bgr",
		"Description": [
			"Bawm Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgs",
		"Description": [
			"Tagabawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgt",
		"Description": [
			"Bughotu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgu",
		"Description": [
			"Mbongno"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgv",
		"Description": [
			"Warkay-Bipim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgw",
		"Description": [
			"Bhatri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgx",
		"Description": [
			"Balkan Gagauz Turkish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgy",
		"Description": [
			"Benggoi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bgz",
		"Description": [
			"Banggai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bha",
		"Description": [
			"Bharia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhb",
		"Description": [
			"Bhili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhc",
		"Description": [
			"Biga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhd",
		"Description": [
			"Bhadrawahi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhe",
		"Description": [
			"Bhaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhf",
		"Description": [
			"Odiai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhg",
		"Description": [
			"Binandere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhh",
		"Description": [
			"Bukharic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhi",
		"Description": [
			"Bhilali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhj",
		"Description": [
			"Bahing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhk",
		"Description": [
			"Albay Bicolano"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Macrolanguage": "bik",
		"Comments": [
			"see fbl, lbl, rbl, ubl"
		]
	},
	{
		"Type": "language",
		"Subtag": "bhl",
		"Description": [
			"Bimin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhm",
		"Description": [
			"Bathari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhn",
		"Description": [
			"Bohtan Neo-Aramaic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bho",
		"Description": [
			"Bhojpuri"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bhp",
		"Description": [
			"Bima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhq",
		"Description": [
			"Tukang Besi South"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhr",
		"Description": [
			"Bara Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "bhs",
		"Description": [
			"Buwal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bht",
		"Description": [
			"Bhattiyali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhu",
		"Description": [
			"Bhunjia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhv",
		"Description": [
			"Bahau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhw",
		"Description": [
			"Biak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhx",
		"Description": [
			"Bhalay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhy",
		"Description": [
			"Bhele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bhz",
		"Description": [
			"Bada (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bia",
		"Description": [
			"Badimaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bib",
		"Description": [
			"Bissa",
			"Bisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bic",
		"Description": [
			"Bikaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bid",
		"Description": [
			"Bidiyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bie",
		"Description": [
			"Bepour"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bif",
		"Description": [
			"Biafada"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "big",
		"Description": [
			"Biangai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bij",
		"Description": [
			"Vaghat-Ya-Bijim-Legeri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bik",
		"Description": [
			"Bikol"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "bil",
		"Description": [
			"Bile"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bim",
		"Description": [
			"Bimoba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bin",
		"Description": [
			"Bini",
			"Edo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "bio",
		"Description": [
			"Nai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bip",
		"Description": [
			"Bila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "biq",
		"Description": [
			"Bipi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bir",
		"Description": [
			"Bisorio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bit",
		"Description": [
			"Berinomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "biu",
		"Description": [
			"Biete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "biv",
		"Description": [
			"Southern Birifor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "biw",
		"Description": [
			"Kol (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bix",
		"Description": [
			"Bijori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "biy",
		"Description": [
			"Birhor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "biz",
		"Description": [
			"Baloi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bja",
		"Description": [
			"Budza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjb",
		"Description": [
			"Banggarla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjc",
		"Description": [
			"Bariji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjd",
		"Description": [
			"Bandjigali"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "drl"
	},
	{
		"Type": "language",
		"Subtag": "bje",
		"Description": [
			"Biao-Jiao Mien"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjf",
		"Description": [
			"Barzani Jewish Neo-Aramaic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjg",
		"Description": [
			"Bidyogo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjh",
		"Description": [
			"Bahinemo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bji",
		"Description": [
			"Burji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjj",
		"Description": [
			"Kanauji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjk",
		"Description": [
			"Barok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjl",
		"Description": [
			"Bulu (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjm",
		"Description": [
			"Bajelani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjn",
		"Description": [
			"Banjar"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "bjo",
		"Description": [
			"Mid-Southern Banda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjp",
		"Description": [
			"Fanamaket"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "bjq",
		"Description": [
			"Southern Betsimisaraka Malagasy"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16",
		"Macrolanguage": "mg",
		"Comments": [
			"see bzc, tkg"
		]
	},
	{
		"Type": "language",
		"Subtag": "bjr",
		"Description": [
			"Binumarien"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjs",
		"Description": [
			"Bajan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjt",
		"Description": [
			"Balanta-Ganja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bju",
		"Description": [
			"Busuu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjv",
		"Description": [
			"Bedjond"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjw",
		"Description": [
			"Bakwé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjx",
		"Description": [
			"Banao Itneg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjy",
		"Description": [
			"Bayali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bjz",
		"Description": [
			"Baruga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bka",
		"Description": [
			"Kyak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkb",
		"Description": [
			"Finallig"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see ebk, obk"
		]
	},
	{
		"Type": "language",
		"Subtag": "bkc",
		"Description": [
			"Baka (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkd",
		"Description": [
			"Binukid",
			"Talaandig"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkf",
		"Description": [
			"Beeke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkg",
		"Description": [
			"Buraka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkh",
		"Description": [
			"Bakoko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bki",
		"Description": [
			"Baki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkj",
		"Description": [
			"Pande"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkk",
		"Description": [
			"Brokskat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkl",
		"Description": [
			"Berik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkm",
		"Description": [
			"Kom (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkn",
		"Description": [
			"Bukitan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bko",
		"Description": [
			"Kwa'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkp",
		"Description": [
			"Boko (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkq",
		"Description": [
			"Bakairí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkr",
		"Description": [
			"Bakumpai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bks",
		"Description": [
			"Northern Sorsoganon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkt",
		"Description": [
			"Boloki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bku",
		"Description": [
			"Buhid"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkv",
		"Description": [
			"Bekwarra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkw",
		"Description": [
			"Bekwel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkx",
		"Description": [
			"Baikeno"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bky",
		"Description": [
			"Bokyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bkz",
		"Description": [
			"Bungku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bla",
		"Description": [
			"Siksika"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "blb",
		"Description": [
			"Bilua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blc",
		"Description": [
			"Bella Coola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bld",
		"Description": [
			"Bolango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ble",
		"Description": [
			"Balanta-Kentohe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blf",
		"Description": [
			"Buol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blg",
		"Description": [
			"Balau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blh",
		"Description": [
			"Kuwaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bli",
		"Description": [
			"Bolia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blj",
		"Description": [
			"Bolongan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blk",
		"Description": [
			"Pa'o Karen",
			"Pa'O"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bll",
		"Description": [
			"Biloxi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blm",
		"Description": [
			"Beli (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bln",
		"Description": [
			"Southern Catanduanes Bikol"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "blo",
		"Description": [
			"Anii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blp",
		"Description": [
			"Blablanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blq",
		"Description": [
			"Baluan-Pam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blr",
		"Description": [
			"Blang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bls",
		"Description": [
			"Balaesang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blt",
		"Description": [
			"Tai Dam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blv",
		"Description": [
			"Kibala",
			"Bolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blw",
		"Description": [
			"Balangao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blx",
		"Description": [
			"Mag-Indi Ayta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bly",
		"Description": [
			"Notre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "blz",
		"Description": [
			"Balantak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bma",
		"Description": [
			"Lame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmb",
		"Description": [
			"Bembe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmc",
		"Description": [
			"Biem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmd",
		"Description": [
			"Baga Manduri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bme",
		"Description": [
			"Limassa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmf",
		"Description": [
			"Bom-Kim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmg",
		"Description": [
			"Bamwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmh",
		"Description": [
			"Kein"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmi",
		"Description": [
			"Bagirmi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmj",
		"Description": [
			"Bote-Majhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmk",
		"Description": [
			"Ghayavi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bml",
		"Description": [
			"Bomboli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmm",
		"Description": [
			"Northern Betsimisaraka Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "bmn",
		"Description": [
			"Bina (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmo",
		"Description": [
			"Bambalang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmp",
		"Description": [
			"Bulgebi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmq",
		"Description": [
			"Bomu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmr",
		"Description": [
			"Muinane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bms",
		"Description": [
			"Bilma Kanuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmt",
		"Description": [
			"Biao Mon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmu",
		"Description": [
			"Somba-Siawari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmv",
		"Description": [
			"Bum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmw",
		"Description": [
			"Bomwali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmx",
		"Description": [
			"Baimak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bmy",
		"Description": [
			"Bemba (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "bmz",
		"Description": [
			"Baramu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bna",
		"Description": [
			"Bonerate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnb",
		"Description": [
			"Bookan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnc",
		"Description": [
			"Bontok"
		],
		"Added": "2009-07-29",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "bnd",
		"Description": [
			"Banda (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bne",
		"Description": [
			"Bintauna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnf",
		"Description": [
			"Masiwang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bng",
		"Description": [
			"Benga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bni",
		"Description": [
			"Bangi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnj",
		"Description": [
			"Eastern Tawbuid"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnk",
		"Description": [
			"Bierebo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnl",
		"Description": [
			"Boon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnm",
		"Description": [
			"Batanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnn",
		"Description": [
			"Bunun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bno",
		"Description": [
			"Bantoanon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnp",
		"Description": [
			"Bola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnq",
		"Description": [
			"Bantik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnr",
		"Description": [
			"Butmas-Tur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bns",
		"Description": [
			"Bundeli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnt",
		"Description": [
			"Bantu languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "bnu",
		"Description": [
			"Bentong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnv",
		"Description": [
			"Bonerif",
			"Beneraf",
			"Edwas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnw",
		"Description": [
			"Bisis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnx",
		"Description": [
			"Bangubangu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bny",
		"Description": [
			"Bintulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bnz",
		"Description": [
			"Beezen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boa",
		"Description": [
			"Bora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bob",
		"Description": [
			"Aweer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boe",
		"Description": [
			"Mundabli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bof",
		"Description": [
			"Bolon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bog",
		"Description": [
			"Bamako Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boh",
		"Description": [
			"Boma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boi",
		"Description": [
			"Barbareño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boj",
		"Description": [
			"Anjam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bok",
		"Description": [
			"Bonjo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bol",
		"Description": [
			"Bole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bom",
		"Description": [
			"Berom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bon",
		"Description": [
			"Bine"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boo",
		"Description": [
			"Tiemacèwè Bozo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bop",
		"Description": [
			"Bonkiman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boq",
		"Description": [
			"Bogaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bor",
		"Description": [
			"Borôro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bot",
		"Description": [
			"Bongo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bou",
		"Description": [
			"Bondei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bov",
		"Description": [
			"Tuwuli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bow",
		"Description": [
			"Rema"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "box",
		"Description": [
			"Buamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boy",
		"Description": [
			"Bodo (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "boz",
		"Description": [
			"Tiéyaxo Bozo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpa",
		"Description": [
			"Daakaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpb",
		"Description": [
			"Barbacoas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpd",
		"Description": [
			"Banda-Banda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpg",
		"Description": [
			"Bonggo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bph",
		"Description": [
			"Botlikh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpi",
		"Description": [
			"Bagupi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpj",
		"Description": [
			"Binji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpk",
		"Description": [
			"Orowe",
			"'Ôrôê"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpl",
		"Description": [
			"Broome Pearling Lugger Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpm",
		"Description": [
			"Biyom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpn",
		"Description": [
			"Dzao Min"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpo",
		"Description": [
			"Anasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpp",
		"Description": [
			"Kaure"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpq",
		"Description": [
			"Banda Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpr",
		"Description": [
			"Koronadal Blaan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bps",
		"Description": [
			"Sarangani Blaan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpt",
		"Description": [
			"Barrow Point"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpu",
		"Description": [
			"Bongu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpv",
		"Description": [
			"Bian Marind"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpw",
		"Description": [
			"Bo (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpx",
		"Description": [
			"Palya Bareli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpy",
		"Description": [
			"Bishnupriya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bpz",
		"Description": [
			"Bilba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqa",
		"Description": [
			"Tchumbuli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqb",
		"Description": [
			"Bagusa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqc",
		"Description": [
			"Boko (Benin)",
			"Boo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqd",
		"Description": [
			"Bung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqf",
		"Description": [
			"Baga Kaloum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqg",
		"Description": [
			"Bago-Kusuntu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqh",
		"Description": [
			"Baima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqi",
		"Description": [
			"Bakhtiari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqj",
		"Description": [
			"Bandial"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqk",
		"Description": [
			"Banda-Mbrès"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bql",
		"Description": [
			"Bilakura"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqm",
		"Description": [
			"Wumboko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqn",
		"Description": [
			"Bulgarian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqo",
		"Description": [
			"Balo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqp",
		"Description": [
			"Busa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqq",
		"Description": [
			"Biritai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqr",
		"Description": [
			"Burusu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqs",
		"Description": [
			"Bosngun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqt",
		"Description": [
			"Bamukumbit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqu",
		"Description": [
			"Boguru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqv",
		"Description": [
			"Koro Wachi",
			"Begbere-Ejar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqw",
		"Description": [
			"Buru (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqx",
		"Description": [
			"Baangi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqy",
		"Description": [
			"Bengkala Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bqz",
		"Description": [
			"Bakaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bra",
		"Description": [
			"Braj"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "brb",
		"Description": [
			"Lave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brc",
		"Description": [
			"Berbice Creole Dutch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brd",
		"Description": [
			"Baraamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brf",
		"Description": [
			"Bera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brg",
		"Description": [
			"Baure"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brh",
		"Description": [
			"Brahui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bri",
		"Description": [
			"Mokpwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brj",
		"Description": [
			"Bieria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brk",
		"Description": [
			"Birked"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brl",
		"Description": [
			"Birwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brm",
		"Description": [
			"Barambu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brn",
		"Description": [
			"Boruca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bro",
		"Description": [
			"Brokkat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brp",
		"Description": [
			"Barapasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brq",
		"Description": [
			"Breri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brr",
		"Description": [
			"Birao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brs",
		"Description": [
			"Baras"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brt",
		"Description": [
			"Bitare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bru",
		"Description": [
			"Eastern Bru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brv",
		"Description": [
			"Western Bru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brw",
		"Description": [
			"Bellari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brx",
		"Description": [
			"Bodo (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bry",
		"Description": [
			"Burui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "brz",
		"Description": [
			"Bilbil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsa",
		"Description": [
			"Abinomn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsb",
		"Description": [
			"Brunei Bisaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsc",
		"Description": [
			"Bassari",
			"Oniyan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bse",
		"Description": [
			"Wushi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsf",
		"Description": [
			"Bauchi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsg",
		"Description": [
			"Bashkardi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsh",
		"Description": [
			"Kati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsi",
		"Description": [
			"Bassossi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsj",
		"Description": [
			"Bangwinji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsk",
		"Description": [
			"Burushaski"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsl",
		"Description": [
			"Basa-Gumna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsm",
		"Description": [
			"Busami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsn",
		"Description": [
			"Barasana-Eduria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bso",
		"Description": [
			"Buso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsp",
		"Description": [
			"Baga Sitemu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsq",
		"Description": [
			"Bassa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsr",
		"Description": [
			"Bassa-Kontagora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bss",
		"Description": [
			"Akoose"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bst",
		"Description": [
			"Basketo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsu",
		"Description": [
			"Bahonsuai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsv",
		"Description": [
			"Baga Sobané"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsw",
		"Description": [
			"Baiso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsx",
		"Description": [
			"Yangkam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bsy",
		"Description": [
			"Sabah Bisaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bta",
		"Description": [
			"Bata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btb",
		"Description": [
			"Beti (Cameroon)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see beb, bum, bxp, eto, ewo, fan, mct"
		]
	},
	{
		"Type": "language",
		"Subtag": "btc",
		"Description": [
			"Bati (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btd",
		"Description": [
			"Batak Dairi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bte",
		"Description": [
			"Gamo-Ningi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btf",
		"Description": [
			"Birgit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btg",
		"Description": [
			"Gagnoa Bété"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bth",
		"Description": [
			"Biatah Bidayuh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bti",
		"Description": [
			"Burate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btj",
		"Description": [
			"Bacanese Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "btk",
		"Description": [
			"Batak languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "btl",
		"Description": [
			"Bhatola"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "btm",
		"Description": [
			"Batak Mandailing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btn",
		"Description": [
			"Ratagnon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bto",
		"Description": [
			"Rinconada Bikol"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "btp",
		"Description": [
			"Budibud"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btq",
		"Description": [
			"Batek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btr",
		"Description": [
			"Baetora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bts",
		"Description": [
			"Batak Simalungun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btt",
		"Description": [
			"Bete-Bendi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btu",
		"Description": [
			"Batu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btv",
		"Description": [
			"Bateri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btw",
		"Description": [
			"Butuanon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btx",
		"Description": [
			"Batak Karo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bty",
		"Description": [
			"Bobot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "btz",
		"Description": [
			"Batak Alas-Kluet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bua",
		"Description": [
			"Buriat"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "bub",
		"Description": [
			"Bua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buc",
		"Description": [
			"Bushi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bud",
		"Description": [
			"Ntcham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bue",
		"Description": [
			"Beothuk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buf",
		"Description": [
			"Bushoong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bug",
		"Description": [
			"Buginese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "buh",
		"Description": [
			"Younuo Bunu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bui",
		"Description": [
			"Bongili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buj",
		"Description": [
			"Basa-Gurmana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buk",
		"Description": [
			"Bugawac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bum",
		"Description": [
			"Bulu (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bun",
		"Description": [
			"Sherbro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buo",
		"Description": [
			"Terei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bup",
		"Description": [
			"Busoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buq",
		"Description": [
			"Brem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bus",
		"Description": [
			"Bokobaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "but",
		"Description": [
			"Bungain"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buu",
		"Description": [
			"Budu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buv",
		"Description": [
			"Bun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buw",
		"Description": [
			"Bubi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bux",
		"Description": [
			"Boghom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buy",
		"Description": [
			"Bullom So"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "buz",
		"Description": [
			"Bukwen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bva",
		"Description": [
			"Barein"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvb",
		"Description": [
			"Bube"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvc",
		"Description": [
			"Baelelea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvd",
		"Description": [
			"Baeggu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bve",
		"Description": [
			"Berau Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "bvf",
		"Description": [
			"Boor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvg",
		"Description": [
			"Bonkeng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvh",
		"Description": [
			"Bure"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvi",
		"Description": [
			"Belanda Viri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvj",
		"Description": [
			"Baan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvk",
		"Description": [
			"Bukat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvl",
		"Description": [
			"Bolivian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvm",
		"Description": [
			"Bamunka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvn",
		"Description": [
			"Buna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvo",
		"Description": [
			"Bolgo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvp",
		"Description": [
			"Bumang"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "bvq",
		"Description": [
			"Birri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvr",
		"Description": [
			"Burarra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvt",
		"Description": [
			"Bati (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvu",
		"Description": [
			"Bukit Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "bvv",
		"Description": [
			"Baniva"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvw",
		"Description": [
			"Boga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvx",
		"Description": [
			"Dibole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bvy",
		"Description": [
			"Baybayanon"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "bvz",
		"Description": [
			"Bauzi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwa",
		"Description": [
			"Bwatoo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwb",
		"Description": [
			"Namosi-Naitasiri-Serua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwc",
		"Description": [
			"Bwile"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwd",
		"Description": [
			"Bwaidoka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwe",
		"Description": [
			"Bwe Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwf",
		"Description": [
			"Boselewa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwg",
		"Description": [
			"Barwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwh",
		"Description": [
			"Bishuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwi",
		"Description": [
			"Baniwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwj",
		"Description": [
			"Láá Láá Bwamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwk",
		"Description": [
			"Bauwaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwl",
		"Description": [
			"Bwela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwm",
		"Description": [
			"Biwat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwn",
		"Description": [
			"Wunai Bunu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwo",
		"Description": [
			"Boro (Ethiopia)",
			"Borna (Ethiopia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwp",
		"Description": [
			"Mandobo Bawah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwq",
		"Description": [
			"Southern Bobo Madaré"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwr",
		"Description": [
			"Bura-Pabir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bws",
		"Description": [
			"Bomboma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwt",
		"Description": [
			"Bafaw-Balong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwu",
		"Description": [
			"Buli (Ghana)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bww",
		"Description": [
			"Bwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwx",
		"Description": [
			"Bu-Nao Bunu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwy",
		"Description": [
			"Cwi Bwamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bwz",
		"Description": [
			"Bwisi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxa",
		"Description": [
			"Tairaha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxb",
		"Description": [
			"Belanda Bor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxc",
		"Description": [
			"Molengue"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxd",
		"Description": [
			"Pela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxe",
		"Description": [
			"Birale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxf",
		"Description": [
			"Bilur",
			"Minigir"
		],
		"Added": "2009-07-29",
		"Comments": [
			"see also vmg"
		]
	},
	{
		"Type": "language",
		"Subtag": "bxg",
		"Description": [
			"Bangala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxh",
		"Description": [
			"Buhutu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxi",
		"Description": [
			"Pirlatapa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxj",
		"Description": [
			"Bayungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxk",
		"Description": [
			"Bukusu",
			"Lubukusu"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "bxl",
		"Description": [
			"Jalkunan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxm",
		"Description": [
			"Mongolia Buriat"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bua"
	},
	{
		"Type": "language",
		"Subtag": "bxn",
		"Description": [
			"Burduna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxo",
		"Description": [
			"Barikanchi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxp",
		"Description": [
			"Bebil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxq",
		"Description": [
			"Beele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxr",
		"Description": [
			"Russia Buriat"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bua"
	},
	{
		"Type": "language",
		"Subtag": "bxs",
		"Description": [
			"Busam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxu",
		"Description": [
			"China Buriat"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bua"
	},
	{
		"Type": "language",
		"Subtag": "bxv",
		"Description": [
			"Berakou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxw",
		"Description": [
			"Bankagooma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bxx",
		"Description": [
			"Borna (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "bxz",
		"Description": [
			"Binahari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bya",
		"Description": [
			"Batak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byb",
		"Description": [
			"Bikya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byc",
		"Description": [
			"Ubaghara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byd",
		"Description": [
			"Benyadu'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bye",
		"Description": [
			"Pouye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byf",
		"Description": [
			"Bete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byg",
		"Description": [
			"Baygo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byh",
		"Description": [
			"Bhujel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byi",
		"Description": [
			"Buyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byj",
		"Description": [
			"Bina (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byk",
		"Description": [
			"Biao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byl",
		"Description": [
			"Bayono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bym",
		"Description": [
			"Bidyara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byn",
		"Description": [
			"Bilin",
			"Blin"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "byo",
		"Description": [
			"Biyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byp",
		"Description": [
			"Bumaji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byq",
		"Description": [
			"Basay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byr",
		"Description": [
			"Baruya",
			"Yipma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bys",
		"Description": [
			"Burak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byt",
		"Description": [
			"Berti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byv",
		"Description": [
			"Medumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byw",
		"Description": [
			"Belhariya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byx",
		"Description": [
			"Qaqet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "byy",
		"Description": [
			"Buya"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "byz",
		"Description": [
			"Banaro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bza",
		"Description": [
			"Bandi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzb",
		"Description": [
			"Andio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzc",
		"Description": [
			"Southern Betsimisaraka Malagasy"
		],
		"Added": "2011-08-16",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "bzd",
		"Description": [
			"Bribri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bze",
		"Description": [
			"Jenaama Bozo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzf",
		"Description": [
			"Boikin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzg",
		"Description": [
			"Babuza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzh",
		"Description": [
			"Mapos Buang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzi",
		"Description": [
			"Bisu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzj",
		"Description": [
			"Belize Kriol English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzk",
		"Description": [
			"Nicaragua Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzl",
		"Description": [
			"Boano (Sulawesi)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzm",
		"Description": [
			"Bolondo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzn",
		"Description": [
			"Boano (Maluku)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzo",
		"Description": [
			"Bozaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzp",
		"Description": [
			"Kemberano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzq",
		"Description": [
			"Buli (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzr",
		"Description": [
			"Biri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzs",
		"Description": [
			"Brazilian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzt",
		"Description": [
			"Brithenig"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzu",
		"Description": [
			"Burmeso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzv",
		"Description": [
			"Naami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzw",
		"Description": [
			"Basa (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzx",
		"Description": [
			"Kɛlɛngaxo Bozo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzy",
		"Description": [
			"Obanliku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "bzz",
		"Description": [
			"Evant"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "caa",
		"Description": [
			"Chortí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cab",
		"Description": [
			"Garifuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cac",
		"Description": [
			"Chuj"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cad",
		"Description": [
			"Caddo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cae",
		"Description": [
			"Lehar",
			"Laalaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "caf",
		"Description": [
			"Southern Carrier"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cag",
		"Description": [
			"Nivaclé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cah",
		"Description": [
			"Cahuarano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cai",
		"Description": [
			"Central American Indian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "caj",
		"Description": [
			"Chané"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cak",
		"Description": [
			"Kaqchikel",
			"Cakchiquel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cal",
		"Description": [
			"Carolinian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cam",
		"Description": [
			"Cemuhî"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "can",
		"Description": [
			"Chambri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cao",
		"Description": [
			"Chácobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cap",
		"Description": [
			"Chipaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "caq",
		"Description": [
			"Car Nicobarese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "car",
		"Description": [
			"Galibi Carib"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cas",
		"Description": [
			"Tsimané"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cau",
		"Description": [
			"Caucasian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cav",
		"Description": [
			"Cavineña"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "caw",
		"Description": [
			"Callawalla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cax",
		"Description": [
			"Chiquitano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cay",
		"Description": [
			"Cayuga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "caz",
		"Description": [
			"Canichana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cba",
		"Description": [
			"Chibchan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cbb",
		"Description": [
			"Cabiyarí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbc",
		"Description": [
			"Carapana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbd",
		"Description": [
			"Carijona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbe",
		"Description": [
			"Chipiajes"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "cbg",
		"Description": [
			"Chimila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbh",
		"Description": [
			"Cagua"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "cbi",
		"Description": [
			"Chachi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbj",
		"Description": [
			"Ede Cabe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbk",
		"Description": [
			"Chavacano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbl",
		"Description": [
			"Bualkhaw Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbn",
		"Description": [
			"Nyahkur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbo",
		"Description": [
			"Izora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbq",
		"Description": [
			"Tsucuba",
			"Cuba"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "cbr",
		"Description": [
			"Cashibo-Cacataibo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbs",
		"Description": [
			"Cashinahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbt",
		"Description": [
			"Chayahuita"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbu",
		"Description": [
			"Candoshi-Shapra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbv",
		"Description": [
			"Cacua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cbw",
		"Description": [
			"Kinabalian"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "cby",
		"Description": [
			"Carabayo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cca",
		"Description": [
			"Cauca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccc",
		"Description": [
			"Chamicuro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccd",
		"Description": [
			"Cafundo Creole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cce",
		"Description": [
			"Chopi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccg",
		"Description": [
			"Samba Daka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cch",
		"Description": [
			"Atsam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccj",
		"Description": [
			"Kasanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccl",
		"Description": [
			"Cutchi-Swahili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccm",
		"Description": [
			"Malaccan Creole Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccn",
		"Description": [
			"North Caucasian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cco",
		"Description": [
			"Comaltepec Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccp",
		"Description": [
			"Chakma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccq",
		"Description": [
			"Chaungtha"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "rki"
	},
	{
		"Type": "language",
		"Subtag": "ccr",
		"Description": [
			"Cacaopera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ccs",
		"Description": [
			"South Caucasian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cda",
		"Description": [
			"Choni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdc",
		"Description": [
			"Chadic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cdd",
		"Description": [
			"Caddoan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cde",
		"Description": [
			"Chenchu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdf",
		"Description": [
			"Chiru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdg",
		"Description": [
			"Chamari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdh",
		"Description": [
			"Chambeali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdi",
		"Description": [
			"Chodri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdj",
		"Description": [
			"Churahi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdm",
		"Description": [
			"Chepang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdn",
		"Description": [
			"Chaudangsi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdo",
		"Description": [
			"Min Dong Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "cdr",
		"Description": [
			"Cinda-Regi-Tiyal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cds",
		"Description": [
			"Chadian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdy",
		"Description": [
			"Chadong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cdz",
		"Description": [
			"Koda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cea",
		"Description": [
			"Lower Chehalis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ceb",
		"Description": [
			"Cebuano"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ceg",
		"Description": [
			"Chamacoco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cek",
		"Description": [
			"Eastern Khumi Chin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "cel",
		"Description": [
			"Celtic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cen",
		"Description": [
			"Cen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cet",
		"Description": [
			"Centúúm"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cfa",
		"Description": [
			"Dijim-Bwilim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cfd",
		"Description": [
			"Cara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cfg",
		"Description": [
			"Como Karim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cfm",
		"Description": [
			"Falam Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cga",
		"Description": [
			"Changriwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cgc",
		"Description": [
			"Kagayanen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cgg",
		"Description": [
			"Chiga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cgk",
		"Description": [
			"Chocangacakha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chb",
		"Description": [
			"Chibcha"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "chc",
		"Description": [
			"Catawba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chd",
		"Description": [
			"Highland Oaxaca Chontal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chf",
		"Description": [
			"Tabasco Chontal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chg",
		"Description": [
			"Chagatai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "chh",
		"Description": [
			"Chinook"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chj",
		"Description": [
			"Ojitlán Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chk",
		"Description": [
			"Chuukese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "chl",
		"Description": [
			"Cahuilla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chm",
		"Description": [
			"Mari (Russia)"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "chn",
		"Description": [
			"Chinook jargon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cho",
		"Description": [
			"Choctaw"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "chp",
		"Description": [
			"Chipewyan",
			"Dene Suline"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "chq",
		"Description": [
			"Quiotepec Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chr",
		"Description": [
			"Cherokee"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cht",
		"Description": [
			"Cholón"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chw",
		"Description": [
			"Chuwabu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chx",
		"Description": [
			"Chantyal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "chy",
		"Description": [
			"Cheyenne"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "chz",
		"Description": [
			"Ozumacín Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cia",
		"Description": [
			"Cia-Cia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cib",
		"Description": [
			"Ci Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cic",
		"Description": [
			"Chickasaw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cid",
		"Description": [
			"Chimariko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cie",
		"Description": [
			"Cineni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cih",
		"Description": [
			"Chinali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cik",
		"Description": [
			"Chitkuli Kinnauri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cim",
		"Description": [
			"Cimbrian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cin",
		"Description": [
			"Cinta Larga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cip",
		"Description": [
			"Chiapanec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cir",
		"Description": [
			"Tiri",
			"Haméa",
			"Méa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ciw",
		"Description": [
			"Chippewa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "oj"
	},
	{
		"Type": "language",
		"Subtag": "ciy",
		"Description": [
			"Chaima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cja",
		"Description": [
			"Western Cham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cje",
		"Description": [
			"Chru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjh",
		"Description": [
			"Upper Chehalis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cji",
		"Description": [
			"Chamalal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjk",
		"Description": [
			"Chokwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjm",
		"Description": [
			"Eastern Cham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjn",
		"Description": [
			"Chenapian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjo",
		"Description": [
			"Ashéninka Pajonal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjp",
		"Description": [
			"Cabécar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjr",
		"Description": [
			"Chorotega"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "mom"
	},
	{
		"Type": "language",
		"Subtag": "cjs",
		"Description": [
			"Shor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjv",
		"Description": [
			"Chuave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cjy",
		"Description": [
			"Jinyu Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "cka",
		"Description": [
			"Khumi Awa Chin"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "cmr"
	},
	{
		"Type": "language",
		"Subtag": "ckb",
		"Description": [
			"Central Kurdish"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ku"
	},
	{
		"Type": "language",
		"Subtag": "ckh",
		"Description": [
			"Chak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckl",
		"Description": [
			"Cibak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckn",
		"Description": [
			"Kaang Chin"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "cko",
		"Description": [
			"Anufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckq",
		"Description": [
			"Kajakse"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckr",
		"Description": [
			"Kairak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cks",
		"Description": [
			"Tayo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckt",
		"Description": [
			"Chukot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cku",
		"Description": [
			"Koasati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckv",
		"Description": [
			"Kavalan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckx",
		"Description": [
			"Caka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cky",
		"Description": [
			"Cakfem-Mushere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ckz",
		"Description": [
			"Cakchiquel-Quiché Mixed Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cla",
		"Description": [
			"Ron"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "clc",
		"Description": [
			"Chilcotin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cld",
		"Description": [
			"Chaldean Neo-Aramaic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "syr"
	},
	{
		"Type": "language",
		"Subtag": "cle",
		"Description": [
			"Lealao Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "clh",
		"Description": [
			"Chilisso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cli",
		"Description": [
			"Chakali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "clj",
		"Description": [
			"Laitu Chin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "clk",
		"Description": [
			"Idu-Mishmi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cll",
		"Description": [
			"Chala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "clm",
		"Description": [
			"Clallam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "clo",
		"Description": [
			"Lowland Oaxaca Chontal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "clt",
		"Description": [
			"Lautu Chin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "clu",
		"Description": [
			"Caluyanun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "clw",
		"Description": [
			"Chulym"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cly",
		"Description": [
			"Eastern Highland Chatino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cma",
		"Description": [
			"Maa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmc",
		"Description": [
			"Chamic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cme",
		"Description": [
			"Cerma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmg",
		"Description": [
			"Classical Mongolian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmi",
		"Description": [
			"Emberá-Chamí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmk",
		"Description": [
			"Chimakum"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "xch"
	},
	{
		"Type": "language",
		"Subtag": "cml",
		"Description": [
			"Campalagian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmm",
		"Description": [
			"Michigamea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmn",
		"Description": [
			"Mandarin Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "cmo",
		"Description": [
			"Central Mnong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmr",
		"Description": [
			"Mro-Khimi Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cms",
		"Description": [
			"Messapic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cmt",
		"Description": [
			"Camtho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cna",
		"Description": [
			"Changthang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnb",
		"Description": [
			"Chinbon Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnc",
		"Description": [
			"Côông"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cng",
		"Description": [
			"Northern Qiang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnh",
		"Description": [
			"Hakha Chin",
			"Haka Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cni",
		"Description": [
			"Asháninka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnk",
		"Description": [
			"Khumi Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnl",
		"Description": [
			"Lalana Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cno",
		"Description": [
			"Con"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cns",
		"Description": [
			"Central Asmat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnt",
		"Description": [
			"Tepetotutla Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnu",
		"Description": [
			"Chenoua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnw",
		"Description": [
			"Ngawn Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cnx",
		"Description": [
			"Middle Cornish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "coa",
		"Description": [
			"Cocos Islands Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "cob",
		"Description": [
			"Chicomuceltec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "coc",
		"Description": [
			"Cocopa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cod",
		"Description": [
			"Cocama-Cocamilla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "coe",
		"Description": [
			"Koreguaje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cof",
		"Description": [
			"Colorado"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cog",
		"Description": [
			"Chong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "coh",
		"Description": [
			"Chonyi-Dzihana-Kauma",
			"Chichonyi-Chidzihana-Chikauma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "coj",
		"Description": [
			"Cochimi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cok",
		"Description": [
			"Santa Teresa Cora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "col",
		"Description": [
			"Columbia-Wenatchi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "com",
		"Description": [
			"Comanche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "con",
		"Description": [
			"Cofán"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "coo",
		"Description": [
			"Comox"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cop",
		"Description": [
			"Coptic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "coq",
		"Description": [
			"Coquille"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cot",
		"Description": [
			"Caquinte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cou",
		"Description": [
			"Wamey"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cov",
		"Description": [
			"Cao Miao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cow",
		"Description": [
			"Cowlitz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cox",
		"Description": [
			"Nanti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "coy",
		"Description": [
			"Coyaima"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "pij"
	},
	{
		"Type": "language",
		"Subtag": "coz",
		"Description": [
			"Chochotec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpa",
		"Description": [
			"Palantla Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpb",
		"Description": [
			"Ucayali-Yurúa Ashéninka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpc",
		"Description": [
			"Ajyíninka Apurucayali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpe",
		"Description": [
			"English-based creoles and pidgins"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cpf",
		"Description": [
			"French-based creoles and pidgins"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cpg",
		"Description": [
			"Cappadocian Greek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpi",
		"Description": [
			"Chinese Pidgin English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpn",
		"Description": [
			"Cherepon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpo",
		"Description": [
			"Kpeego"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "cpp",
		"Description": [
			"Portuguese-based creoles and pidgins"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cps",
		"Description": [
			"Capiznon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpu",
		"Description": [
			"Pichis Ashéninka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cpx",
		"Description": [
			"Pu-Xian Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "cpy",
		"Description": [
			"South Ucayali Ashéninka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cqd",
		"Description": [
			"Chuanqiandian Cluster Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "cqu",
		"Description": [
			"Chilean Quechua"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "quh",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "cra",
		"Description": [
			"Chara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crb",
		"Description": [
			"Island Carib"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crc",
		"Description": [
			"Lonwolwol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crd",
		"Description": [
			"Coeur d'Alene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crf",
		"Description": [
			"Caramanta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crg",
		"Description": [
			"Michif"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crh",
		"Description": [
			"Crimean Tatar",
			"Crimean Turkish"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "cri",
		"Description": [
			"Sãotomense"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crj",
		"Description": [
			"Southern East Cree"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "cr"
	},
	{
		"Type": "language",
		"Subtag": "crk",
		"Description": [
			"Plains Cree"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "cr"
	},
	{
		"Type": "language",
		"Subtag": "crl",
		"Description": [
			"Northern East Cree"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "cr"
	},
	{
		"Type": "language",
		"Subtag": "crm",
		"Description": [
			"Moose Cree"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "cr"
	},
	{
		"Type": "language",
		"Subtag": "crn",
		"Description": [
			"El Nayar Cora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cro",
		"Description": [
			"Crow"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crp",
		"Description": [
			"Creoles and pidgins"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "crq",
		"Description": [
			"Iyo'wujwa Chorote"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crr",
		"Description": [
			"Carolina Algonquian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crs",
		"Description": [
			"Seselwa Creole French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crt",
		"Description": [
			"Iyojwa'ja Chorote"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crv",
		"Description": [
			"Chaura"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crw",
		"Description": [
			"Chrau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crx",
		"Description": [
			"Carrier"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cry",
		"Description": [
			"Cori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "crz",
		"Description": [
			"Cruzeño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csa",
		"Description": [
			"Chiltepec Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csb",
		"Description": [
			"Kashubian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "csc",
		"Description": [
			"Catalan Sign Language",
			"Lengua de señas catalana",
			"Llengua de Signes Catalana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csd",
		"Description": [
			"Chiangmai Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cse",
		"Description": [
			"Czech Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csf",
		"Description": [
			"Cuba Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csg",
		"Description": [
			"Chilean Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csh",
		"Description": [
			"Asho Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csi",
		"Description": [
			"Coast Miwok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csj",
		"Description": [
			"Songlai Chin"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "csk",
		"Description": [
			"Jola-Kasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csl",
		"Description": [
			"Chinese Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csm",
		"Description": [
			"Central Sierra Miwok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csn",
		"Description": [
			"Colombian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cso",
		"Description": [
			"Sochiapam Chinantec",
			"Sochiapan Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csq",
		"Description": [
			"Croatia Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csr",
		"Description": [
			"Costa Rican Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "css",
		"Description": [
			"Southern Ohlone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cst",
		"Description": [
			"Northern Ohlone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csu",
		"Description": [
			"Central Sudanic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "csv",
		"Description": [
			"Sumtu Chin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "csw",
		"Description": [
			"Swampy Cree"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "cr"
	},
	{
		"Type": "language",
		"Subtag": "csy",
		"Description": [
			"Siyin Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "csz",
		"Description": [
			"Coos"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cta",
		"Description": [
			"Tataltepec Chatino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctc",
		"Description": [
			"Chetco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctd",
		"Description": [
			"Tedim Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cte",
		"Description": [
			"Tepinapa Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctg",
		"Description": [
			"Chittagonian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cth",
		"Description": [
			"Thaiphum Chin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "ctl",
		"Description": [
			"Tlacoatzintepec Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctm",
		"Description": [
			"Chitimacha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctn",
		"Description": [
			"Chhintange"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cto",
		"Description": [
			"Emberá-Catío"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctp",
		"Description": [
			"Western Highland Chatino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cts",
		"Description": [
			"Northern Catanduanes Bikol"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "ctt",
		"Description": [
			"Wayanad Chetti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctu",
		"Description": [
			"Chol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ctz",
		"Description": [
			"Zacatepec Chatino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cua",
		"Description": [
			"Cua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cub",
		"Description": [
			"Cubeo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuc",
		"Description": [
			"Usila Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cug",
		"Description": [
			"Chungmboko",
			"Cung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuh",
		"Description": [
			"Chuka",
			"Gichuka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cui",
		"Description": [
			"Cuiba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuj",
		"Description": [
			"Mashco Piro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuk",
		"Description": [
			"San Blas Kuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cul",
		"Description": [
			"Culina",
			"Kulina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cum",
		"Description": [
			"Cumeral"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "cuo",
		"Description": [
			"Cumanagoto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cup",
		"Description": [
			"Cupeño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuq",
		"Description": [
			"Cun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cur",
		"Description": [
			"Chhulung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cus",
		"Description": [
			"Cushitic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "cut",
		"Description": [
			"Teutila Cuicatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuu",
		"Description": [
			"Tai Ya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuv",
		"Description": [
			"Cuvok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cuw",
		"Description": [
			"Chukwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cux",
		"Description": [
			"Tepeuxila Cuicatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cvg",
		"Description": [
			"Chug"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cvn",
		"Description": [
			"Valle Nacional Chinantec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cwa",
		"Description": [
			"Kabwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cwb",
		"Description": [
			"Maindo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cwd",
		"Description": [
			"Woods Cree"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "cr"
	},
	{
		"Type": "language",
		"Subtag": "cwe",
		"Description": [
			"Kwere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cwg",
		"Description": [
			"Chewong",
			"Cheq Wong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cwt",
		"Description": [
			"Kuwaataay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cya",
		"Description": [
			"Nopala Chatino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cyb",
		"Description": [
			"Cayubaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "cyo",
		"Description": [
			"Cuyonon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "czh",
		"Description": [
			"Huizhou Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "czk",
		"Description": [
			"Knaanic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "czn",
		"Description": [
			"Zenzontepec Chatino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "czo",
		"Description": [
			"Min Zhong Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "czt",
		"Description": [
			"Zotung Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "daa",
		"Description": [
			"Dangaléat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dac",
		"Description": [
			"Dambi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dad",
		"Description": [
			"Marik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dae",
		"Description": [
			"Duupa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "daf",
		"Description": [
			"Dan"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see dnj, lda"
		]
	},
	{
		"Type": "language",
		"Subtag": "dag",
		"Description": [
			"Dagbani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dah",
		"Description": [
			"Gwahatike"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dai",
		"Description": [
			"Day"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "daj",
		"Description": [
			"Dar Fur Daju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dak",
		"Description": [
			"Dakota"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "dal",
		"Description": [
			"Dahalo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dam",
		"Description": [
			"Damakawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dao",
		"Description": [
			"Daai Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dap",
		"Description": [
			"Nisi (India)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see njz, tgj"
		]
	},
	{
		"Type": "language",
		"Subtag": "daq",
		"Description": [
			"Dandami Maria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dar",
		"Description": [
			"Dargwa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "das",
		"Description": [
			"Daho-Doo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dau",
		"Description": [
			"Dar Sila Daju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dav",
		"Description": [
			"Taita",
			"Dawida"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "daw",
		"Description": [
			"Davawenyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dax",
		"Description": [
			"Dayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "day",
		"Description": [
			"Land Dayak languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "daz",
		"Description": [
			"Dao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dba",
		"Description": [
			"Bangime"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbb",
		"Description": [
			"Deno"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbd",
		"Description": [
			"Dadiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbe",
		"Description": [
			"Dabe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbf",
		"Description": [
			"Edopi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbg",
		"Description": [
			"Dogul Dom Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbi",
		"Description": [
			"Doka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbj",
		"Description": [
			"Ida'an"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbl",
		"Description": [
			"Dyirbal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbm",
		"Description": [
			"Duguri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbn",
		"Description": [
			"Duriankere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbo",
		"Description": [
			"Dulbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbp",
		"Description": [
			"Duwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbq",
		"Description": [
			"Daba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbr",
		"Description": [
			"Dabarre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbt",
		"Description": [
			"Ben Tey Dogon"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dbu",
		"Description": [
			"Bondum Dom Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbv",
		"Description": [
			"Dungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dbw",
		"Description": [
			"Bankan Tey Dogon"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dby",
		"Description": [
			"Dibiyaso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dcc",
		"Description": [
			"Deccan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dcr",
		"Description": [
			"Negerhollands"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dda",
		"Description": [
			"Dadi Dadi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "ddd",
		"Description": [
			"Dongotono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dde",
		"Description": [
			"Doondo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ddg",
		"Description": [
			"Fataluku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ddi",
		"Description": [
			"West Goodenough"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ddj",
		"Description": [
			"Jaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ddn",
		"Description": [
			"Dendi (Benin)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ddo",
		"Description": [
			"Dido"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ddr",
		"Description": [
			"Dhudhuroa"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dds",
		"Description": [
			"Donno So Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ddw",
		"Description": [
			"Dawera-Daweloor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dec",
		"Description": [
			"Dagik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ded",
		"Description": [
			"Dedua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dee",
		"Description": [
			"Dewoin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "def",
		"Description": [
			"Dezfuli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "deg",
		"Description": [
			"Degema"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "deh",
		"Description": [
			"Dehwari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dei",
		"Description": [
			"Demisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dek",
		"Description": [
			"Dek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "del",
		"Description": [
			"Delaware"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "dem",
		"Description": [
			"Dem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "den",
		"Description": [
			"Slave (Athapascan)"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "dep",
		"Description": [
			"Pidgin Delaware"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "deq",
		"Description": [
			"Dendi (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "der",
		"Description": [
			"Deori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "des",
		"Description": [
			"Desano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dev",
		"Description": [
			"Domung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dez",
		"Description": [
			"Dengese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dga",
		"Description": [
			"Southern Dagaare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgb",
		"Description": [
			"Bunoge Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgc",
		"Description": [
			"Casiguran Dumagat Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgd",
		"Description": [
			"Dagaari Dioula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dge",
		"Description": [
			"Degenan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgg",
		"Description": [
			"Doga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgh",
		"Description": [
			"Dghwede"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgi",
		"Description": [
			"Northern Dagara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgk",
		"Description": [
			"Dagba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgl",
		"Description": [
			"Andaandi",
			"Dongolawi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dgn",
		"Description": [
			"Dagoman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgo",
		"Description": [
			"Dogri (individual language)"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "doi"
	},
	{
		"Type": "language",
		"Subtag": "dgr",
		"Description": [
			"Dogrib"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "dgs",
		"Description": [
			"Dogoso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgt",
		"Description": [
			"Ndra'ngith"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dgu",
		"Description": [
			"Degaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgw",
		"Description": [
			"Daungwurrung"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dgx",
		"Description": [
			"Doghoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dgz",
		"Description": [
			"Daga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dha",
		"Description": [
			"Dhanwar (India)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "dhd",
		"Description": [
			"Dhundari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mwr"
	},
	{
		"Type": "language",
		"Subtag": "dhg",
		"Description": [
			"Dhangu-Djangu",
			"Dhangu",
			"Djangu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhi",
		"Description": [
			"Dhimal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhl",
		"Description": [
			"Dhalandji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhm",
		"Description": [
			"Zemba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhn",
		"Description": [
			"Dhanki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dho",
		"Description": [
			"Dhodia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhr",
		"Description": [
			"Dhargari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhs",
		"Description": [
			"Dhaiso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhu",
		"Description": [
			"Dhurga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhv",
		"Description": [
			"Dehu",
			"Drehu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhw",
		"Description": [
			"Dhanwar (Nepal)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dhx",
		"Description": [
			"Dhungaloo"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "dia",
		"Description": [
			"Dia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dib",
		"Description": [
			"South Central Dinka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "din"
	},
	{
		"Type": "language",
		"Subtag": "dic",
		"Description": [
			"Lakota Dida"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "did",
		"Description": [
			"Didinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dif",
		"Description": [
			"Dieri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dig",
		"Description": [
			"Digo",
			"Chidigo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dih",
		"Description": [
			"Kumiai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dii",
		"Description": [
			"Dimbong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dij",
		"Description": [
			"Dai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dik",
		"Description": [
			"Southwestern Dinka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "din"
	},
	{
		"Type": "language",
		"Subtag": "dil",
		"Description": [
			"Dilling"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dim",
		"Description": [
			"Dime"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "din",
		"Description": [
			"Dinka"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "dio",
		"Description": [
			"Dibo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dip",
		"Description": [
			"Northeastern Dinka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "din"
	},
	{
		"Type": "language",
		"Subtag": "diq",
		"Description": [
			"Dimli (individual language)"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zza"
	},
	{
		"Type": "language",
		"Subtag": "dir",
		"Description": [
			"Dirim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dis",
		"Description": [
			"Dimasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dit",
		"Description": [
			"Dirari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "diu",
		"Description": [
			"Diriku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "diw",
		"Description": [
			"Northwestern Dinka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "din"
	},
	{
		"Type": "language",
		"Subtag": "dix",
		"Description": [
			"Dixon Reef"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "diy",
		"Description": [
			"Diuwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "diz",
		"Description": [
			"Ding"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dja",
		"Description": [
			"Djadjawurrung"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "djb",
		"Description": [
			"Djinba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djc",
		"Description": [
			"Dar Daju Daju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djd",
		"Description": [
			"Djamindjung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dje",
		"Description": [
			"Zarma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djf",
		"Description": [
			"Djangun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dji",
		"Description": [
			"Djinang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djj",
		"Description": [
			"Djeebbana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djk",
		"Description": [
			"Eastern Maroon Creole",
			"Businenge Tongo",
			"Nenge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djl",
		"Description": [
			"Djiwarli"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see dze, iin"
		]
	},
	{
		"Type": "language",
		"Subtag": "djm",
		"Description": [
			"Jamsay Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djn",
		"Description": [
			"Djauan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djo",
		"Description": [
			"Jangkang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djr",
		"Description": [
			"Djambarrpuyngu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dju",
		"Description": [
			"Kapriman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "djw",
		"Description": [
			"Djawi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dka",
		"Description": [
			"Dakpakha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dkk",
		"Description": [
			"Dakka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dkl",
		"Description": [
			"Kolum So Dogon"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16",
		"Comments": [
			"see aqd, dmb"
		]
	},
	{
		"Type": "language",
		"Subtag": "dkr",
		"Description": [
			"Kuijau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dks",
		"Description": [
			"Southeastern Dinka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "din"
	},
	{
		"Type": "language",
		"Subtag": "dkx",
		"Description": [
			"Mazagway"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dlg",
		"Description": [
			"Dolgan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dlk",
		"Description": [
			"Dahalik"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "dlm",
		"Description": [
			"Dalmatian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dln",
		"Description": [
			"Darlong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dma",
		"Description": [
			"Duma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmb",
		"Description": [
			"Mombo Dogon"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "dmc",
		"Description": [
			"Gavak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmd",
		"Description": [
			"Madhi Madhi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dme",
		"Description": [
			"Dugwor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmg",
		"Description": [
			"Upper Kinabatangan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmk",
		"Description": [
			"Domaaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dml",
		"Description": [
			"Dameli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmm",
		"Description": [
			"Dama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmn",
		"Description": [
			"Mande languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "dmo",
		"Description": [
			"Kemedzung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmr",
		"Description": [
			"East Damar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dms",
		"Description": [
			"Dampelas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmu",
		"Description": [
			"Dubu",
			"Tebi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmv",
		"Description": [
			"Dumpas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmw",
		"Description": [
			"Mudburra"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "dmx",
		"Description": [
			"Dema"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dmy",
		"Description": [
			"Demta",
			"Sowari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dna",
		"Description": [
			"Upper Grand Valley Dani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dnd",
		"Description": [
			"Daonda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dne",
		"Description": [
			"Ndendeule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dng",
		"Description": [
			"Dungan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dni",
		"Description": [
			"Lower Grand Valley Dani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dnj",
		"Description": [
			"Dan"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "dnk",
		"Description": [
			"Dengka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dnn",
		"Description": [
			"Dzùùngoo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dnr",
		"Description": [
			"Danaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dnt",
		"Description": [
			"Mid Grand Valley Dani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dnu",
		"Description": [
			"Danau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dnv",
		"Description": [
			"Danu"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dnw",
		"Description": [
			"Western Dani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dny",
		"Description": [
			"Dení"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doa",
		"Description": [
			"Dom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dob",
		"Description": [
			"Dobu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doc",
		"Description": [
			"Northern Dong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doe",
		"Description": [
			"Doe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dof",
		"Description": [
			"Domu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doh",
		"Description": [
			"Dong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doi",
		"Description": [
			"Dogri (macrolanguage)"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "dok",
		"Description": [
			"Dondo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dol",
		"Description": [
			"Doso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "don",
		"Description": [
			"Toura (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doo",
		"Description": [
			"Dongo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dop",
		"Description": [
			"Lukpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doq",
		"Description": [
			"Dominican Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dor",
		"Description": [
			"Dori'o"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dos",
		"Description": [
			"Dogosé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dot",
		"Description": [
			"Dass"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dov",
		"Description": [
			"Dombe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dow",
		"Description": [
			"Doyayo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dox",
		"Description": [
			"Bussa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doy",
		"Description": [
			"Dompo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "doz",
		"Description": [
			"Dorze"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dpp",
		"Description": [
			"Papar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dra",
		"Description": [
			"Dravidian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "drb",
		"Description": [
			"Dair"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drc",
		"Description": [
			"Minderico"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "drd",
		"Description": [
			"Darmiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dre",
		"Description": [
			"Dolpo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drg",
		"Description": [
			"Rungus"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drh",
		"Description": [
			"Darkhat"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "khk"
	},
	{
		"Type": "language",
		"Subtag": "dri",
		"Description": [
			"C'Lela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drl",
		"Description": [
			"Paakantyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drn",
		"Description": [
			"West Damar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dro",
		"Description": [
			"Daro-Matu Melanau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drq",
		"Description": [
			"Dura"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drr",
		"Description": [
			"Dororo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drs",
		"Description": [
			"Gedeo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drt",
		"Description": [
			"Drents"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dru",
		"Description": [
			"Rukai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "drw",
		"Description": [
			"Darwazi"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "prs"
	},
	{
		"Type": "language",
		"Subtag": "dry",
		"Description": [
			"Darai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dsb",
		"Description": [
			"Lower Sorbian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "dse",
		"Description": [
			"Dutch Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dsh",
		"Description": [
			"Daasanach"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dsi",
		"Description": [
			"Disa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dsl",
		"Description": [
			"Danish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dsn",
		"Description": [
			"Dusner"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dso",
		"Description": [
			"Desiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dsq",
		"Description": [
			"Tadaksahak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dta",
		"Description": [
			"Daur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtb",
		"Description": [
			"Labuk-Kinabatangan Kadazan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtd",
		"Description": [
			"Ditidaht"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "dth",
		"Description": [
			"Adithinngithigh"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dti",
		"Description": [
			"Ana Tinga Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtk",
		"Description": [
			"Tene Kan Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtm",
		"Description": [
			"Tomo Kan Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtn",
		"Description": [
			"Daatsʼíin"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "dto",
		"Description": [
			"Tommo So Dogon"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "dtp",
		"Description": [
			"Kadazan Dusun",
			"Central Dusun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtr",
		"Description": [
			"Lotud"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dts",
		"Description": [
			"Toro So Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtt",
		"Description": [
			"Toro Tegu Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dtu",
		"Description": [
			"Tebul Ure Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dty",
		"Description": [
			"Dotyali"
		],
		"Added": "2012-08-12",
		"Macrolanguage": "ne"
	},
	{
		"Type": "language",
		"Subtag": "dua",
		"Description": [
			"Duala"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "dub",
		"Description": [
			"Dubli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duc",
		"Description": [
			"Duna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dud",
		"Description": [
			"Hun-Saare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "due",
		"Description": [
			"Umiray Dumaget Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duf",
		"Description": [
			"Dumbea",
			"Drubea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dug",
		"Description": [
			"Duruma",
			"Chiduruma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duh",
		"Description": [
			"Dungra Bhil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dui",
		"Description": [
			"Dumun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duj",
		"Description": [
			"Dhuwal"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Comments": [
			"see dwu, dwy"
		]
	},
	{
		"Type": "language",
		"Subtag": "duk",
		"Description": [
			"Uyajitaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dul",
		"Description": [
			"Alabat Island Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dum",
		"Description": [
			"Middle Dutch (ca. 1050-1350)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "dun",
		"Description": [
			"Dusun Deyah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duo",
		"Description": [
			"Dupaninan Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dup",
		"Description": [
			"Duano"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "duq",
		"Description": [
			"Dusun Malang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dur",
		"Description": [
			"Dii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dus",
		"Description": [
			"Dumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duu",
		"Description": [
			"Drung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duv",
		"Description": [
			"Duvle"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duw",
		"Description": [
			"Dusun Witu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dux",
		"Description": [
			"Duungooma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duy",
		"Description": [
			"Dicamay Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "duz",
		"Description": [
			"Duli-Gey"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dva",
		"Description": [
			"Duau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dwa",
		"Description": [
			"Diri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dwl",
		"Description": [
			"Walo Kumbe Dogon"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see dbt, dbw"
		]
	},
	{
		"Type": "language",
		"Subtag": "dwr",
		"Description": [
			"Dawro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dws",
		"Description": [
			"Dutton World Speedwords"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dwu",
		"Description": [
			"Dhuwal"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "dww",
		"Description": [
			"Dawawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dwy",
		"Description": [
			"Dhuwaya"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "dya",
		"Description": [
			"Dyan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dyb",
		"Description": [
			"Dyaberdyaber"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dyd",
		"Description": [
			"Dyugun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dyg",
		"Description": [
			"Villa Viciosa Agta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dyi",
		"Description": [
			"Djimini Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dym",
		"Description": [
			"Yanda Dom Dogon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dyn",
		"Description": [
			"Dyangadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dyo",
		"Description": [
			"Jola-Fonyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dyu",
		"Description": [
			"Dyula"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "dyy",
		"Description": [
			"Dyaabugay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dza",
		"Description": [
			"Tunzu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dzd",
		"Description": [
			"Daza"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "dze",
		"Description": [
			"Djiwarli"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "dzg",
		"Description": [
			"Dazaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dzl",
		"Description": [
			"Dzalakha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "dzn",
		"Description": [
			"Dzando"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eaa",
		"Description": [
			"Karenggapa"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ebg",
		"Description": [
			"Ebughu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ebk",
		"Description": [
			"Eastern Bontok"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bnc"
	},
	{
		"Type": "language",
		"Subtag": "ebo",
		"Description": [
			"Teke-Ebo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ebr",
		"Description": [
			"Ebrié"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ebu",
		"Description": [
			"Embu",
			"Kiembu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ecr",
		"Description": [
			"Eteocretan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ecs",
		"Description": [
			"Ecuadorian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ecy",
		"Description": [
			"Eteocypriot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eee",
		"Description": [
			"E"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "efa",
		"Description": [
			"Efai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "efe",
		"Description": [
			"Efe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "efi",
		"Description": [
			"Efik"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ega",
		"Description": [
			"Ega"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "egl",
		"Description": [
			"Emilian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ego",
		"Description": [
			"Eggon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "egx",
		"Description": [
			"Egyptian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "egy",
		"Description": [
			"Egyptian (Ancient)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ehu",
		"Description": [
			"Ehueun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eip",
		"Description": [
			"Eipomek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eit",
		"Description": [
			"Eitiep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eiv",
		"Description": [
			"Askopan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eja",
		"Description": [
			"Ejamat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eka",
		"Description": [
			"Ekajuk"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ekc",
		"Description": [
			"Eastern Karnic"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "eke",
		"Description": [
			"Ekit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ekg",
		"Description": [
			"Ekari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eki",
		"Description": [
			"Eki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ekk",
		"Description": [
			"Standard Estonian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "et"
	},
	{
		"Type": "language",
		"Subtag": "ekl",
		"Description": [
			"Kol (Bangladesh)",
			"Kol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ekm",
		"Description": [
			"Elip"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eko",
		"Description": [
			"Koti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ekp",
		"Description": [
			"Ekpeye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ekr",
		"Description": [
			"Yace"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eky",
		"Description": [
			"Eastern Kayah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ele",
		"Description": [
			"Elepi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "elh",
		"Description": [
			"El Hugeirat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eli",
		"Description": [
			"Nding"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "elk",
		"Description": [
			"Elkei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "elm",
		"Description": [
			"Eleme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "elo",
		"Description": [
			"El Molo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "elp",
		"Description": [
			"Elpaputih"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see amq, plh"
		]
	},
	{
		"Type": "language",
		"Subtag": "elu",
		"Description": [
			"Elu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "elx",
		"Description": [
			"Elamite"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ema",
		"Description": [
			"Emai-Iuleha-Ora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emb",
		"Description": [
			"Embaloh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eme",
		"Description": [
			"Emerillon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emg",
		"Description": [
			"Eastern Meohang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emi",
		"Description": [
			"Mussau-Emira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emk",
		"Description": [
			"Eastern Maninkakan"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "man"
	},
	{
		"Type": "language",
		"Subtag": "emm",
		"Description": [
			"Mamulique"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emn",
		"Description": [
			"Eman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emo",
		"Description": [
			"Emok"
		],
		"Added": "2009-07-29",
		"Deprecated": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "emp",
		"Description": [
			"Northern Emberá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ems",
		"Description": [
			"Pacific Gulf Yupik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emu",
		"Description": [
			"Eastern Muria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emw",
		"Description": [
			"Emplawas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "emx",
		"Description": [
			"Erromintxela"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "emy",
		"Description": [
			"Epigraphic Mayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ena",
		"Description": [
			"Apali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enb",
		"Description": [
			"Markweeta"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "enc",
		"Description": [
			"En"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "end",
		"Description": [
			"Ende"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enf",
		"Description": [
			"Forest Enets"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enh",
		"Description": [
			"Tundra Enets"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enl",
		"Description": [
			"Enlhet"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "enm",
		"Description": [
			"Middle English (1100-1500)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "enn",
		"Description": [
			"Engenni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eno",
		"Description": [
			"Enggano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enq",
		"Description": [
			"Enga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enr",
		"Description": [
			"Emumu",
			"Emem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enu",
		"Description": [
			"Enu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "env",
		"Description": [
			"Enwan (Edu State)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enw",
		"Description": [
			"Enwan (Akwa Ibom State)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "enx",
		"Description": [
			"Enxet"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "eot",
		"Description": [
			"Beti (Côte d'Ivoire)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "epi",
		"Description": [
			"Epie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "era",
		"Description": [
			"Eravallan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "erg",
		"Description": [
			"Sie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "erh",
		"Description": [
			"Eruwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eri",
		"Description": [
			"Ogea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "erk",
		"Description": [
			"South Efate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ero",
		"Description": [
			"Horpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "err",
		"Description": [
			"Erre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ers",
		"Description": [
			"Ersu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ert",
		"Description": [
			"Eritai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "erw",
		"Description": [
			"Erokwanas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ese",
		"Description": [
			"Ese Ejja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "esg",
		"Description": [
			"Aheri Gondi"
		],
		"Added": "2016-05-30",
		"Macrolanguage": "gon"
	},
	{
		"Type": "language",
		"Subtag": "esh",
		"Description": [
			"Eshtehardi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "esi",
		"Description": [
			"North Alaskan Inupiatun"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ik"
	},
	{
		"Type": "language",
		"Subtag": "esk",
		"Description": [
			"Northwest Alaska Inupiatun"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ik"
	},
	{
		"Type": "language",
		"Subtag": "esl",
		"Description": [
			"Egypt Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "esm",
		"Description": [
			"Esuma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "esn",
		"Description": [
			"Salvadoran Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eso",
		"Description": [
			"Estonian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "esq",
		"Description": [
			"Esselen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ess",
		"Description": [
			"Central Siberian Yupik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "esu",
		"Description": [
			"Central Yupik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "esx",
		"Description": [
			"Eskimo-Aleut languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "esy",
		"Description": [
			"Eskayan"
		],
		"Added": "2014-04-06"
	},
	{
		"Type": "language",
		"Subtag": "etb",
		"Description": [
			"Etebi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "etc",
		"Description": [
			"Etchemin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eth",
		"Description": [
			"Ethiopian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "etn",
		"Description": [
			"Eton (Vanuatu)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eto",
		"Description": [
			"Eton (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "etr",
		"Description": [
			"Edolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ets",
		"Description": [
			"Yekhee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ett",
		"Description": [
			"Etruscan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "etu",
		"Description": [
			"Ejagham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "etx",
		"Description": [
			"Eten"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "etz",
		"Description": [
			"Semimi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "euq",
		"Description": [
			"Basque (family)"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "eve",
		"Description": [
			"Even"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "evh",
		"Description": [
			"Uvbie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "evn",
		"Description": [
			"Evenki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ewo",
		"Description": [
			"Ewondo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ext",
		"Description": [
			"Extremaduran"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eya",
		"Description": [
			"Eyak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "eyo",
		"Description": [
			"Keiyo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "eza",
		"Description": [
			"Ezaa"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "eze",
		"Description": [
			"Uzekwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "faa",
		"Description": [
			"Fasu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fab",
		"Description": [
			"Fa d'Ambu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fad",
		"Description": [
			"Wagi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "faf",
		"Description": [
			"Fagani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fag",
		"Description": [
			"Finongan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fah",
		"Description": [
			"Baissa Fali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fai",
		"Description": [
			"Faiwol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "faj",
		"Description": [
			"Faita"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fak",
		"Description": [
			"Fang (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fal",
		"Description": [
			"South Fali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fam",
		"Description": [
			"Fam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fan",
		"Description": [
			"Fang (Equatorial Guinea)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "fap",
		"Description": [
			"Palor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "far",
		"Description": [
			"Fataleka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fat",
		"Description": [
			"Fanti"
		],
		"Added": "2005-10-16",
		"Macrolanguage": "ak"
	},
	{
		"Type": "language",
		"Subtag": "fau",
		"Description": [
			"Fayu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fax",
		"Description": [
			"Fala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fay",
		"Description": [
			"Southwestern Fars"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "faz",
		"Description": [
			"Northwestern Fars"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fbl",
		"Description": [
			"West Albay Bikol"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "fcs",
		"Description": [
			"Quebec Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fer",
		"Description": [
			"Feroge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ffi",
		"Description": [
			"Foia Foia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ffm",
		"Description": [
			"Maasina Fulfulde"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fgr",
		"Description": [
			"Fongoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fia",
		"Description": [
			"Nobiin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fie",
		"Description": [
			"Fyer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fil",
		"Description": [
			"Filipino",
			"Pilipino"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "fip",
		"Description": [
			"Fipa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fir",
		"Description": [
			"Firan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fit",
		"Description": [
			"Tornedalen Finnish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fiu",
		"Description": [
			"Finno-Ugrian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "fiw",
		"Description": [
			"Fiwaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fkk",
		"Description": [
			"Kirya-Konzəl"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "fkv",
		"Description": [
			"Kven Finnish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fla",
		"Description": [
			"Kalispel-Pend d'Oreille"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "flh",
		"Description": [
			"Foau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fli",
		"Description": [
			"Fali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fll",
		"Description": [
			"North Fali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fln",
		"Description": [
			"Flinders Island"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "flr",
		"Description": [
			"Fuliiru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fly",
		"Description": [
			"Flaaitaal",
			"Tsotsitaal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fmp",
		"Description": [
			"Fe'fe'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fmu",
		"Description": [
			"Far Western Muria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fnb",
		"Description": [
			"Fanbak"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "fng",
		"Description": [
			"Fanagalo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fni",
		"Description": [
			"Fania"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fod",
		"Description": [
			"Foodo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "foi",
		"Description": [
			"Foi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fom",
		"Description": [
			"Foma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fon",
		"Description": [
			"Fon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "for",
		"Description": [
			"Fore"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fos",
		"Description": [
			"Siraya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fox",
		"Description": [
			"Formosan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "fpe",
		"Description": [
			"Fernando Po Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fqs",
		"Description": [
			"Fas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "frc",
		"Description": [
			"Cajun French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "frd",
		"Description": [
			"Fordata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "frk",
		"Description": [
			"Frankish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "frm",
		"Description": [
			"Middle French (ca. 1400-1600)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "fro",
		"Description": [
			"Old French (842-ca. 1400)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "frp",
		"Description": [
			"Arpitan",
			"Francoprovençal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "frq",
		"Description": [
			"Forak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "frr",
		"Description": [
			"Northern Frisian"
		],
		"Added": "2006-03-08",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "frs",
		"Description": [
			"Eastern Frisian"
		],
		"Added": "2006-03-08",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "frt",
		"Description": [
			"Fortsenal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fse",
		"Description": [
			"Finnish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fsl",
		"Description": [
			"French Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fss",
		"Description": [
			"Finland-Swedish Sign Language",
			"finlandssvenskt teckenspråk",
			"suomenruotsalainen viittomakieli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fub",
		"Description": [
			"Adamawa Fulfulde"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fuc",
		"Description": [
			"Pulaar"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fud",
		"Description": [
			"East Futuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fue",
		"Description": [
			"Borgu Fulfulde"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fuf",
		"Description": [
			"Pular"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fuh",
		"Description": [
			"Western Niger Fulfulde"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fui",
		"Description": [
			"Bagirmi Fulfulde"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fuj",
		"Description": [
			"Ko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fum",
		"Description": [
			"Fum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fun",
		"Description": [
			"Fulniô"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fuq",
		"Description": [
			"Central-Eastern Niger Fulfulde"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fur",
		"Description": [
			"Friulian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "fut",
		"Description": [
			"Futuna-Aniwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fuu",
		"Description": [
			"Furu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fuv",
		"Description": [
			"Nigerian Fulfulde"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ff"
	},
	{
		"Type": "language",
		"Subtag": "fuy",
		"Description": [
			"Fuyug"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fvr",
		"Description": [
			"Fur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fwa",
		"Description": [
			"Fwâi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "fwe",
		"Description": [
			"Fwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gaa",
		"Description": [
			"Ga"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gab",
		"Description": [
			"Gabri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gac",
		"Description": [
			"Mixed Great Andamanese"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "gad",
		"Description": [
			"Gaddang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gae",
		"Description": [
			"Guarequena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gaf",
		"Description": [
			"Gende"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gag",
		"Description": [
			"Gagauz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gah",
		"Description": [
			"Alekano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gai",
		"Description": [
			"Borei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gaj",
		"Description": [
			"Gadsup"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gak",
		"Description": [
			"Gamkonora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gal",
		"Description": [
			"Galolen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gam",
		"Description": [
			"Kandawo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gan",
		"Description": [
			"Gan Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "gao",
		"Description": [
			"Gants"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gap",
		"Description": [
			"Gal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gaq",
		"Description": [
			"Gata'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gar",
		"Description": [
			"Galeya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gas",
		"Description": [
			"Adiwasi Garasia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gat",
		"Description": [
			"Kenati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gau",
		"Description": [
			"Mudhili Gadaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gav",
		"Description": [
			"Gabutamon"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "dev"
	},
	{
		"Type": "language",
		"Subtag": "gaw",
		"Description": [
			"Nobonob"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gax",
		"Description": [
			"Borana-Arsi-Guji Oromo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "om"
	},
	{
		"Type": "language",
		"Subtag": "gay",
		"Description": [
			"Gayo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gaz",
		"Description": [
			"West Central Oromo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "om"
	},
	{
		"Type": "language",
		"Subtag": "gba",
		"Description": [
			"Gbaya (Central African Republic)"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "gbb",
		"Description": [
			"Kaytetye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbc",
		"Description": [
			"Garawa"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see wny, wrk"
		]
	},
	{
		"Type": "language",
		"Subtag": "gbd",
		"Description": [
			"Karadjeri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbe",
		"Description": [
			"Niksek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbf",
		"Description": [
			"Gaikundi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbg",
		"Description": [
			"Gbanziri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbh",
		"Description": [
			"Defi Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbi",
		"Description": [
			"Galela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbj",
		"Description": [
			"Bodo Gadaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbk",
		"Description": [
			"Gaddi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbl",
		"Description": [
			"Gamit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbm",
		"Description": [
			"Garhwali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbn",
		"Description": [
			"Mo'da"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbo",
		"Description": [
			"Northern Grebo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "grb"
	},
	{
		"Type": "language",
		"Subtag": "gbp",
		"Description": [
			"Gbaya-Bossangoa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gba"
	},
	{
		"Type": "language",
		"Subtag": "gbq",
		"Description": [
			"Gbaya-Bozoum"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gba"
	},
	{
		"Type": "language",
		"Subtag": "gbr",
		"Description": [
			"Gbagyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbs",
		"Description": [
			"Gbesi Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbu",
		"Description": [
			"Gagadu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbv",
		"Description": [
			"Gbanu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbw",
		"Description": [
			"Gabi-Gabi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "gbx",
		"Description": [
			"Eastern Xwla Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gby",
		"Description": [
			"Gbari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gbz",
		"Description": [
			"Zoroastrian Dari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gcc",
		"Description": [
			"Mali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gcd",
		"Description": [
			"Ganggalida"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gce",
		"Description": [
			"Galice"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gcf",
		"Description": [
			"Guadeloupean Creole French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gcl",
		"Description": [
			"Grenadian Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gcn",
		"Description": [
			"Gaina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gcr",
		"Description": [
			"Guianese Creole French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gct",
		"Description": [
			"Colonia Tovar German"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gda",
		"Description": [
			"Gade Lohar"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "raj"
	},
	{
		"Type": "language",
		"Subtag": "gdb",
		"Description": [
			"Pottangi Ollar Gadaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdc",
		"Description": [
			"Gugu Badhun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdd",
		"Description": [
			"Gedaged"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gde",
		"Description": [
			"Gude"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdf",
		"Description": [
			"Guduf-Gava"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdg",
		"Description": [
			"Ga'dang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdh",
		"Description": [
			"Gadjerawang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdi",
		"Description": [
			"Gundi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdj",
		"Description": [
			"Gurdjar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdk",
		"Description": [
			"Gadang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdl",
		"Description": [
			"Dirasha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdm",
		"Description": [
			"Laal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdn",
		"Description": [
			"Umanakaina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdo",
		"Description": [
			"Ghodoberi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdq",
		"Description": [
			"Mehri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdr",
		"Description": [
			"Wipi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gds",
		"Description": [
			"Ghandruk Sign Language"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "gdt",
		"Description": [
			"Kungardutyi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "gdu",
		"Description": [
			"Gudu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gdx",
		"Description": [
			"Godwari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gea",
		"Description": [
			"Geruma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "geb",
		"Description": [
			"Kire"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gec",
		"Description": [
			"Gboloo Grebo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "grb"
	},
	{
		"Type": "language",
		"Subtag": "ged",
		"Description": [
			"Gade"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "geg",
		"Description": [
			"Gengle"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "geh",
		"Description": [
			"Hutterite German",
			"Hutterisch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gei",
		"Description": [
			"Gebe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gej",
		"Description": [
			"Gen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gek",
		"Description": [
			"Ywom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gel",
		"Description": [
			"ut-Ma'in"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gem",
		"Description": [
			"Germanic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "geq",
		"Description": [
			"Geme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ges",
		"Description": [
			"Geser-Gorom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gev",
		"Description": [
			"Eviya"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "gew",
		"Description": [
			"Gera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gex",
		"Description": [
			"Garre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gey",
		"Description": [
			"Enya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gez",
		"Description": [
			"Geez"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gfk",
		"Description": [
			"Patpatar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gft",
		"Description": [
			"Gafat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gfx",
		"Description": [
			"Mangetti Dune !Xung"
		],
		"Added": "2012-08-12",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "vaj"
	},
	{
		"Type": "language",
		"Subtag": "gga",
		"Description": [
			"Gao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggb",
		"Description": [
			"Gbii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggd",
		"Description": [
			"Gugadj"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gge",
		"Description": [
			"Guragone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggg",
		"Description": [
			"Gurgula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggk",
		"Description": [
			"Kungarakany"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggl",
		"Description": [
			"Ganglau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggn",
		"Description": [
			"Eastern Gurung"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "gvr"
	},
	{
		"Type": "language",
		"Subtag": "ggo",
		"Description": [
			"Southern Gondi"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Comments": [
			"see esg, wsg"
		]
	},
	{
		"Type": "language",
		"Subtag": "ggr",
		"Description": [
			"Aghu Tharnggalu"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see gtu, ikr"
		]
	},
	{
		"Type": "language",
		"Subtag": "ggt",
		"Description": [
			"Gitua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggu",
		"Description": [
			"Gagu",
			"Gban"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ggw",
		"Description": [
			"Gogodala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gha",
		"Description": [
			"Ghadamès"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghc",
		"Description": [
			"Hiberno-Scottish Gaelic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghe",
		"Description": [
			"Southern Ghale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghh",
		"Description": [
			"Northern Ghale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghk",
		"Description": [
			"Geko Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghl",
		"Description": [
			"Ghulfan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghn",
		"Description": [
			"Ghanongga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gho",
		"Description": [
			"Ghomara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghr",
		"Description": [
			"Ghera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ghs",
		"Description": [
			"Guhu-Samane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ght",
		"Description": [
			"Kuke",
			"Kutang Ghale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gia",
		"Description": [
			"Kitja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gib",
		"Description": [
			"Gibanawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gic",
		"Description": [
			"Gail"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gid",
		"Description": [
			"Gidar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gie",
		"Description": [
			"Gaɓogbo",
			"Guébie"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "gig",
		"Description": [
			"Goaria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gih",
		"Description": [
			"Githabul"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "gil",
		"Description": [
			"Gilbertese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gim",
		"Description": [
			"Gimi (Eastern Highlands)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gin",
		"Description": [
			"Hinukh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gio",
		"Description": [
			"Gelao"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see aou, gqu"
		]
	},
	{
		"Type": "language",
		"Subtag": "gip",
		"Description": [
			"Gimi (West New Britain)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "giq",
		"Description": [
			"Green Gelao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gir",
		"Description": [
			"Red Gelao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gis",
		"Description": [
			"North Giziga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "git",
		"Description": [
			"Gitxsan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "giu",
		"Description": [
			"Mulao"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "giw",
		"Description": [
			"White Gelao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gix",
		"Description": [
			"Gilima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "giy",
		"Description": [
			"Giyug"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "giz",
		"Description": [
			"South Giziga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gji",
		"Description": [
			"Geji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gjk",
		"Description": [
			"Kachi Koli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gjm",
		"Description": [
			"Gunditjmara"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "gjn",
		"Description": [
			"Gonja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gjr",
		"Description": [
			"Gurindji Kriol"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "gju",
		"Description": [
			"Gujari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "raj"
	},
	{
		"Type": "language",
		"Subtag": "gka",
		"Description": [
			"Guya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gke",
		"Description": [
			"Ndai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gkn",
		"Description": [
			"Gokana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gko",
		"Description": [
			"Kok-Nar"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "gkp",
		"Description": [
			"Guinea Kpelle"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kpe"
	},
	{
		"Type": "language",
		"Subtag": "gku",
		"Description": [
			"ǂUngkue",
			"=/Ungkue"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "glc",
		"Description": [
			"Bon Gula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gld",
		"Description": [
			"Nanai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "glh",
		"Description": [
			"Northwest Pashai",
			"Northwest Pashayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gli",
		"Description": [
			"Guliguli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "glj",
		"Description": [
			"Gula Iro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "glk",
		"Description": [
			"Gilaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gll",
		"Description": [
			"Garlali"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "glo",
		"Description": [
			"Galambu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "glr",
		"Description": [
			"Glaro-Twabo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "glu",
		"Description": [
			"Gula (Chad)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "glw",
		"Description": [
			"Glavda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gly",
		"Description": [
			"Gule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gma",
		"Description": [
			"Gambera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmb",
		"Description": [
			"Gula'alaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmd",
		"Description": [
			"Mághdì"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gme",
		"Description": [
			"East Germanic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "gmg",
		"Description": [
			"Magɨyi"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "gmh",
		"Description": [
			"Middle High German (ca. 1050-1500)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gml",
		"Description": [
			"Middle Low German"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmm",
		"Description": [
			"Gbaya-Mbodomo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gba"
	},
	{
		"Type": "language",
		"Subtag": "gmn",
		"Description": [
			"Gimnime"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmq",
		"Description": [
			"North Germanic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "gmu",
		"Description": [
			"Gumalu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmv",
		"Description": [
			"Gamo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmw",
		"Description": [
			"West Germanic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "gmx",
		"Description": [
			"Magoma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmy",
		"Description": [
			"Mycenaean Greek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gmz",
		"Description": [
			"Mgbolizhia"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "gna",
		"Description": [
			"Kaansa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnb",
		"Description": [
			"Gangte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnc",
		"Description": [
			"Guanche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnd",
		"Description": [
			"Zulgo-Gemzek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gne",
		"Description": [
			"Ganang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gng",
		"Description": [
			"Ngangam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnh",
		"Description": [
			"Lere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gni",
		"Description": [
			"Gooniyandi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnk",
		"Description": [
			"//Gana",
			"ǁGana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnl",
		"Description": [
			"Gangulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnm",
		"Description": [
			"Ginuman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnn",
		"Description": [
			"Gumatj"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gno",
		"Description": [
			"Northern Gondi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gon"
	},
	{
		"Type": "language",
		"Subtag": "gnq",
		"Description": [
			"Gana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnr",
		"Description": [
			"Gureng Gureng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnt",
		"Description": [
			"Guntai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnu",
		"Description": [
			"Gnau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gnw",
		"Description": [
			"Western Bolivian Guaraní"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gn"
	},
	{
		"Type": "language",
		"Subtag": "gnz",
		"Description": [
			"Ganzi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goa",
		"Description": [
			"Guro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gob",
		"Description": [
			"Playero"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goc",
		"Description": [
			"Gorakor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "god",
		"Description": [
			"Godié"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goe",
		"Description": [
			"Gongduk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gof",
		"Description": [
			"Gofa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gog",
		"Description": [
			"Gogo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goh",
		"Description": [
			"Old High German (ca. 750-1050)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "goi",
		"Description": [
			"Gobasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goj",
		"Description": [
			"Gowlan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gok",
		"Description": [
			"Gowli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gol",
		"Description": [
			"Gola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gom",
		"Description": [
			"Goan Konkani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kok"
	},
	{
		"Type": "language",
		"Subtag": "gon",
		"Description": [
			"Gondi"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "goo",
		"Description": [
			"Gone Dau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gop",
		"Description": [
			"Yeretuar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goq",
		"Description": [
			"Gorap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gor",
		"Description": [
			"Gorontalo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gos",
		"Description": [
			"Gronings"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "got",
		"Description": [
			"Gothic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gou",
		"Description": [
			"Gavar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gow",
		"Description": [
			"Gorowa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gox",
		"Description": [
			"Gobu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goy",
		"Description": [
			"Goundo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "goz",
		"Description": [
			"Gozarkhani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gpa",
		"Description": [
			"Gupa-Abawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gpe",
		"Description": [
			"Ghanaian Pidgin English"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "gpn",
		"Description": [
			"Taiap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gqa",
		"Description": [
			"Ga'anda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gqi",
		"Description": [
			"Guiqiong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gqn",
		"Description": [
			"Guana (Brazil)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gqr",
		"Description": [
			"Gor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gqu",
		"Description": [
			"Qau"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "gra",
		"Description": [
			"Rajput Garasia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grb",
		"Description": [
			"Grebo"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "grc",
		"Description": [
			"Ancient Greek (to 1453)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "grd",
		"Description": [
			"Guruntum-Mbaaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grg",
		"Description": [
			"Madi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grh",
		"Description": [
			"Gbiri-Niragu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gri",
		"Description": [
			"Ghari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grj",
		"Description": [
			"Southern Grebo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "grb"
	},
	{
		"Type": "language",
		"Subtag": "grk",
		"Description": [
			"Greek languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "grm",
		"Description": [
			"Kota Marudu Talantang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gro",
		"Description": [
			"Groma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grq",
		"Description": [
			"Gorovu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grr",
		"Description": [
			"Taznatit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grs",
		"Description": [
			"Gresi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grt",
		"Description": [
			"Garo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gru",
		"Description": [
			"Kistane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grv",
		"Description": [
			"Central Grebo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "grb"
	},
	{
		"Type": "language",
		"Subtag": "grw",
		"Description": [
			"Gweda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "grx",
		"Description": [
			"Guriaso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gry",
		"Description": [
			"Barclayville Grebo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "grb"
	},
	{
		"Type": "language",
		"Subtag": "grz",
		"Description": [
			"Guramalum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gse",
		"Description": [
			"Ghanaian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gsg",
		"Description": [
			"German Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gsl",
		"Description": [
			"Gusilay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gsm",
		"Description": [
			"Guatemalan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gsn",
		"Description": [
			"Nema",
			"Gusan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gso",
		"Description": [
			"Southwest Gbaya"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gba"
	},
	{
		"Type": "language",
		"Subtag": "gsp",
		"Description": [
			"Wasembo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gss",
		"Description": [
			"Greek Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gsw",
		"Description": [
			"Swiss German",
			"Alemannic",
			"Alsatian"
		],
		"Added": "2006-03-08",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "gta",
		"Description": [
			"Guató"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gti",
		"Description": [
			"Gbati-ri"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "nyc"
	},
	{
		"Type": "language",
		"Subtag": "gtu",
		"Description": [
			"Aghu-Tharnggala"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "gua",
		"Description": [
			"Shiki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gub",
		"Description": [
			"Guajajára"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "guc",
		"Description": [
			"Wayuu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gud",
		"Description": [
			"Yocoboué Dida"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gue",
		"Description": [
			"Gurinji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "guf",
		"Description": [
			"Gupapuyngu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gug",
		"Description": [
			"Paraguayan Guaraní"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gn"
	},
	{
		"Type": "language",
		"Subtag": "guh",
		"Description": [
			"Guahibo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gui",
		"Description": [
			"Eastern Bolivian Guaraní"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gn"
	},
	{
		"Type": "language",
		"Subtag": "guk",
		"Description": [
			"Gumuz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gul",
		"Description": [
			"Sea Island Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gum",
		"Description": [
			"Guambiano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gun",
		"Description": [
			"Mbyá Guaraní"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gn"
	},
	{
		"Type": "language",
		"Subtag": "guo",
		"Description": [
			"Guayabero"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gup",
		"Description": [
			"Gunwinggu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "guq",
		"Description": [
			"Aché"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gur",
		"Description": [
			"Farefare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gus",
		"Description": [
			"Guinean Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gut",
		"Description": [
			"Maléku Jaíka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "guu",
		"Description": [
			"Yanomamö"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "guv",
		"Description": [
			"Gey"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "duz"
	},
	{
		"Type": "language",
		"Subtag": "guw",
		"Description": [
			"Gun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gux",
		"Description": [
			"Gourmanchéma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "guz",
		"Description": [
			"Gusii",
			"Ekegusii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gva",
		"Description": [
			"Guana (Paraguay)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvc",
		"Description": [
			"Guanano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gve",
		"Description": [
			"Duwet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvf",
		"Description": [
			"Golin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvj",
		"Description": [
			"Guajá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvl",
		"Description": [
			"Gulay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvm",
		"Description": [
			"Gurmana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvn",
		"Description": [
			"Kuku-Yalanji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvo",
		"Description": [
			"Gavião Do Jiparaná"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvp",
		"Description": [
			"Pará Gavião"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvr",
		"Description": [
			"Gurung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvs",
		"Description": [
			"Gumawana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gvy",
		"Description": [
			"Guyani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwa",
		"Description": [
			"Mbato"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwb",
		"Description": [
			"Gwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwc",
		"Description": [
			"Kalami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwd",
		"Description": [
			"Gawwada"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwe",
		"Description": [
			"Gweno"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwf",
		"Description": [
			"Gowro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwg",
		"Description": [
			"Moo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwi",
		"Description": [
			"Gwichʼin"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "gwj",
		"Description": [
			"/Gwi",
			"ǀGwi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwm",
		"Description": [
			"Awngthim"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "gwn",
		"Description": [
			"Gwandara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwr",
		"Description": [
			"Gwere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwt",
		"Description": [
			"Gawar-Bati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwu",
		"Description": [
			"Guwamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gww",
		"Description": [
			"Kwini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gwx",
		"Description": [
			"Gua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gxx",
		"Description": [
			"Wè Southern"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gya",
		"Description": [
			"Northwest Gbaya"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gba"
	},
	{
		"Type": "language",
		"Subtag": "gyb",
		"Description": [
			"Garus"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyd",
		"Description": [
			"Kayardild"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gye",
		"Description": [
			"Gyem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyf",
		"Description": [
			"Gungabula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyg",
		"Description": [
			"Gbayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyi",
		"Description": [
			"Gyele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyl",
		"Description": [
			"Gayil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gym",
		"Description": [
			"Ngäbere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyn",
		"Description": [
			"Guyanese Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyr",
		"Description": [
			"Guarayu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gyy",
		"Description": [
			"Gunya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gza",
		"Description": [
			"Ganza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gzi",
		"Description": [
			"Gazi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "gzn",
		"Description": [
			"Gane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "haa",
		"Description": [
			"Han"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hab",
		"Description": [
			"Hanoi Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hac",
		"Description": [
			"Gurani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "had",
		"Description": [
			"Hatam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hae",
		"Description": [
			"Eastern Oromo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "om"
	},
	{
		"Type": "language",
		"Subtag": "haf",
		"Description": [
			"Haiphong Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hag",
		"Description": [
			"Hanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hah",
		"Description": [
			"Hahon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hai",
		"Description": [
			"Haida"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "haj",
		"Description": [
			"Hajong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hak",
		"Description": [
			"Hakka Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "hal",
		"Description": [
			"Halang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ham",
		"Description": [
			"Hewa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "han",
		"Description": [
			"Hangaza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hao",
		"Description": [
			"Hakö"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hap",
		"Description": [
			"Hupla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "haq",
		"Description": [
			"Ha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "har",
		"Description": [
			"Harari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "has",
		"Description": [
			"Haisla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hav",
		"Description": [
			"Havu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "haw",
		"Description": [
			"Hawaiian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "hax",
		"Description": [
			"Southern Haida"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hai"
	},
	{
		"Type": "language",
		"Subtag": "hay",
		"Description": [
			"Haya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "haz",
		"Description": [
			"Hazaragi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hba",
		"Description": [
			"Hamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hbb",
		"Description": [
			"Huba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hbn",
		"Description": [
			"Heiban"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hbo",
		"Description": [
			"Ancient Hebrew"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hbu",
		"Description": [
			"Habu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hca",
		"Description": [
			"Andaman Creole Hindi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hch",
		"Description": [
			"Huichol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hdn",
		"Description": [
			"Northern Haida"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hai"
	},
	{
		"Type": "language",
		"Subtag": "hds",
		"Description": [
			"Honduras Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hdy",
		"Description": [
			"Hadiyya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hea",
		"Description": [
			"Northern Qiandong Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hed",
		"Description": [
			"Herdé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "heg",
		"Description": [
			"Helong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "heh",
		"Description": [
			"Hehe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hei",
		"Description": [
			"Heiltsuk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hem",
		"Description": [
			"Hemba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hgm",
		"Description": [
			"Hai//om",
			"Haiǁom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hgw",
		"Description": [
			"Haigwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hhi",
		"Description": [
			"Hoia Hoia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hhr",
		"Description": [
			"Kerak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hhy",
		"Description": [
			"Hoyahoya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hia",
		"Description": [
			"Lamang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hib",
		"Description": [
			"Hibito"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hid",
		"Description": [
			"Hidatsa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hif",
		"Description": [
			"Fiji Hindi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hig",
		"Description": [
			"Kamwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hih",
		"Description": [
			"Pamosu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hii",
		"Description": [
			"Hinduri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hij",
		"Description": [
			"Hijuk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hik",
		"Description": [
			"Seit-Kaitetu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hil",
		"Description": [
			"Hiligaynon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "him",
		"Description": [
			"Himachali languages",
			"Western Pahari languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "hio",
		"Description": [
			"Tsoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hir",
		"Description": [
			"Himarimã"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hit",
		"Description": [
			"Hittite"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "hiw",
		"Description": [
			"Hiw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hix",
		"Description": [
			"Hixkaryána"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hji",
		"Description": [
			"Haji"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "hka",
		"Description": [
			"Kahe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hke",
		"Description": [
			"Hunde"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hkk",
		"Description": [
			"Hunjara-Kaina Ke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hks",
		"Description": [
			"Hong Kong Sign Language",
			"Heung Kong Sau Yue"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hla",
		"Description": [
			"Halia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hlb",
		"Description": [
			"Halbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hld",
		"Description": [
			"Halang Doan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hle",
		"Description": [
			"Hlersu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hlt",
		"Description": [
			"Matu Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hlu",
		"Description": [
			"Hieroglyphic Luwian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hma",
		"Description": [
			"Southern Mashan Hmong",
			"Southern Mashan Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmb",
		"Description": [
			"Humburi Senni Songhay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hmc",
		"Description": [
			"Central Huishui Hmong",
			"Central Huishui Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmd",
		"Description": [
			"Large Flowery Miao",
			"A-hmaos",
			"Da-Hua Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hme",
		"Description": [
			"Eastern Huishui Hmong",
			"Eastern Huishui Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmf",
		"Description": [
			"Hmong Don"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hmg",
		"Description": [
			"Southwestern Guiyang Hmong"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmh",
		"Description": [
			"Southwestern Huishui Hmong",
			"Southwestern Huishui Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmi",
		"Description": [
			"Northern Huishui Hmong",
			"Northern Huishui Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmj",
		"Description": [
			"Ge",
			"Gejia"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmk",
		"Description": [
			"Maek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hml",
		"Description": [
			"Luopohe Hmong",
			"Luopohe Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmm",
		"Description": [
			"Central Mashan Hmong",
			"Central Mashan Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmn",
		"Description": [
			"Hmong",
			"Mong"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "hmp",
		"Description": [
			"Northern Mashan Hmong",
			"Northern Mashan Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmq",
		"Description": [
			"Eastern Qiandong Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmr",
		"Description": [
			"Hmar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hms",
		"Description": [
			"Southern Qiandong Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmt",
		"Description": [
			"Hamtai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hmu",
		"Description": [
			"Hamap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hmv",
		"Description": [
			"Hmong Dô"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hmw",
		"Description": [
			"Western Mashan Hmong",
			"Western Mashan Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmx",
		"Description": [
			"Hmong-Mien languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "hmy",
		"Description": [
			"Southern Guiyang Hmong",
			"Southern Guiyang Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hmz",
		"Description": [
			"Hmong Shua",
			"Sinicized Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hna",
		"Description": [
			"Mina (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hnd",
		"Description": [
			"Southern Hindko"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "hne",
		"Description": [
			"Chhattisgarhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hnh",
		"Description": [
			"//Ani",
			"ǁAni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hni",
		"Description": [
			"Hani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hnj",
		"Description": [
			"Hmong Njua",
			"Mong Leng",
			"Mong Njua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hnn",
		"Description": [
			"Hanunoo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hno",
		"Description": [
			"Northern Hindko"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "hns",
		"Description": [
			"Caribbean Hindustani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hnu",
		"Description": [
			"Hung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoa",
		"Description": [
			"Hoava"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hob",
		"Description": [
			"Mari (Madang Province)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoc",
		"Description": [
			"Ho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hod",
		"Description": [
			"Holma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoe",
		"Description": [
			"Horom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoh",
		"Description": [
			"Hobyót"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoi",
		"Description": [
			"Holikachuk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoj",
		"Description": [
			"Hadothi",
			"Haroti"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "raj"
	},
	{
		"Type": "language",
		"Subtag": "hok",
		"Description": [
			"Hokan languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "hol",
		"Description": [
			"Holu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hom",
		"Description": [
			"Homa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoo",
		"Description": [
			"Holoholo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hop",
		"Description": [
			"Hopi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hor",
		"Description": [
			"Horo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hos",
		"Description": [
			"Ho Chi Minh City Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hot",
		"Description": [
			"Hote",
			"Malê"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hov",
		"Description": [
			"Hovongan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "how",
		"Description": [
			"Honi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoy",
		"Description": [
			"Holiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hoz",
		"Description": [
			"Hozo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hpo",
		"Description": [
			"Hpon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hps",
		"Description": [
			"Hawai'i Sign Language (HSL)",
			"Hawai'i Pidgin Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hra",
		"Description": [
			"Hrangkhol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hrc",
		"Description": [
			"Niwer Mil"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "hre",
		"Description": [
			"Hre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hrk",
		"Description": [
			"Haruku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hrm",
		"Description": [
			"Horned Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "hro",
		"Description": [
			"Haroi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hrp",
		"Description": [
			"Nhirrpi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "hrr",
		"Description": [
			"Horuru"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "jal"
	},
	{
		"Type": "language",
		"Subtag": "hrt",
		"Description": [
			"Hértevin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hru",
		"Description": [
			"Hruso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hrw",
		"Description": [
			"Warwar Feni"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "hrx",
		"Description": [
			"Hunsrik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hrz",
		"Description": [
			"Harzani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hsb",
		"Description": [
			"Upper Sorbian"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "hsh",
		"Description": [
			"Hungarian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hsl",
		"Description": [
			"Hausa Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hsn",
		"Description": [
			"Xiang Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "hss",
		"Description": [
			"Harsusi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hti",
		"Description": [
			"Hoti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hto",
		"Description": [
			"Minica Huitoto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hts",
		"Description": [
			"Hadza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "htu",
		"Description": [
			"Hitu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "htx",
		"Description": [
			"Middle Hittite"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hub",
		"Description": [
			"Huambisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huc",
		"Description": [
			"=/Hua",
			"ǂHua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hud",
		"Description": [
			"Huaulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hue",
		"Description": [
			"San Francisco Del Mar Huave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huf",
		"Description": [
			"Humene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hug",
		"Description": [
			"Huachipaeri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huh",
		"Description": [
			"Huilliche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hui",
		"Description": [
			"Huli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huj",
		"Description": [
			"Northern Guiyang Hmong",
			"Northern Guiyang Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "huk",
		"Description": [
			"Hulung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hul",
		"Description": [
			"Hula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hum",
		"Description": [
			"Hungana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huo",
		"Description": [
			"Hu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hup",
		"Description": [
			"Hupa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "huq",
		"Description": [
			"Tsat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hur",
		"Description": [
			"Halkomelem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hus",
		"Description": [
			"Huastec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hut",
		"Description": [
			"Humla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huu",
		"Description": [
			"Murui Huitoto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huv",
		"Description": [
			"San Mateo Del Mar Huave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huw",
		"Description": [
			"Hukumina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hux",
		"Description": [
			"Nüpode Huitoto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huy",
		"Description": [
			"Hulaulá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "huz",
		"Description": [
			"Hunzib"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hvc",
		"Description": [
			"Haitian Vodoun Culture Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hve",
		"Description": [
			"San Dionisio Del Mar Huave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hvk",
		"Description": [
			"Haveke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hvn",
		"Description": [
			"Sabu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hvv",
		"Description": [
			"Santa María Del Mar Huave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hwa",
		"Description": [
			"Wané"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hwc",
		"Description": [
			"Hawai'i Creole English",
			"Hawai'i Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hwo",
		"Description": [
			"Hwana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hya",
		"Description": [
			"Hya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "hyx",
		"Description": [
			"Armenian (family)"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "iai",
		"Description": [
			"Iaai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ian",
		"Description": [
			"Iatmul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iap",
		"Description": [
			"Iapama"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "iar",
		"Description": [
			"Purari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iba",
		"Description": [
			"Iban"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ibb",
		"Description": [
			"Ibibio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibd",
		"Description": [
			"Iwaidja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibe",
		"Description": [
			"Akpes"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibg",
		"Description": [
			"Ibanag"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibh",
		"Description": [
			"Bih"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "ibi",
		"Description": [
			"Ibilo"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "opa"
	},
	{
		"Type": "language",
		"Subtag": "ibl",
		"Description": [
			"Ibaloi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibm",
		"Description": [
			"Agoi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibn",
		"Description": [
			"Ibino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibr",
		"Description": [
			"Ibuoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ibu",
		"Description": [
			"Ibu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iby",
		"Description": [
			"Ibani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ica",
		"Description": [
			"Ede Ica"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ich",
		"Description": [
			"Etkywan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "icl",
		"Description": [
			"Icelandic Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "icr",
		"Description": [
			"Islander Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ida",
		"Description": [
			"Idakho-Isukha-Tiriki",
			"Luidakho-Luisukha-Lutirichi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "idb",
		"Description": [
			"Indo-Portuguese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "idc",
		"Description": [
			"Idon",
			"Ajiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "idd",
		"Description": [
			"Ede Idaca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ide",
		"Description": [
			"Idere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "idi",
		"Description": [
			"Idi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "idr",
		"Description": [
			"Indri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ids",
		"Description": [
			"Idesa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "idt",
		"Description": [
			"Idaté"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "idu",
		"Description": [
			"Idoma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ifa",
		"Description": [
			"Amganad Ifugao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ifb",
		"Description": [
			"Batad Ifugao",
			"Ayangan Ifugao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ife",
		"Description": [
			"Ifè"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iff",
		"Description": [
			"Ifo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ifk",
		"Description": [
			"Tuwali Ifugao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ifm",
		"Description": [
			"Teke-Fuumu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ifu",
		"Description": [
			"Mayoyao Ifugao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ify",
		"Description": [
			"Keley-I Kallahan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "igb",
		"Description": [
			"Ebira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ige",
		"Description": [
			"Igede"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "igg",
		"Description": [
			"Igana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "igl",
		"Description": [
			"Igala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "igm",
		"Description": [
			"Kanggape"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ign",
		"Description": [
			"Ignaciano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "igo",
		"Description": [
			"Isebe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "igs",
		"Description": [
			"Interglossa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "igw",
		"Description": [
			"Igwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ihb",
		"Description": [
			"Iha Based Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ihi",
		"Description": [
			"Ihievbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ihp",
		"Description": [
			"Iha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ihw",
		"Description": [
			"Bidhawal"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "iin",
		"Description": [
			"Thiin"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "iir",
		"Description": [
			"Indo-Iranian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ijc",
		"Description": [
			"Izon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ije",
		"Description": [
			"Biseni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ijj",
		"Description": [
			"Ede Ije"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ijn",
		"Description": [
			"Kalabari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ijo",
		"Description": [
			"Ijo languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ijs",
		"Description": [
			"Southeast Ijo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ike",
		"Description": [
			"Eastern Canadian Inuktitut"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "iu"
	},
	{
		"Type": "language",
		"Subtag": "iki",
		"Description": [
			"Iko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ikk",
		"Description": [
			"Ika"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ikl",
		"Description": [
			"Ikulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iko",
		"Description": [
			"Olulumo-Ikom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ikp",
		"Description": [
			"Ikpeshi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ikr",
		"Description": [
			"Ikaranggal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "iks",
		"Description": [
			"Inuit Sign Language"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "ikt",
		"Description": [
			"Inuinnaqtun",
			"Western Canadian Inuktitut"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "iu"
	},
	{
		"Type": "language",
		"Subtag": "ikv",
		"Description": [
			"Iku-Gora-Ankwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ikw",
		"Description": [
			"Ikwere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ikx",
		"Description": [
			"Ik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ikz",
		"Description": [
			"Ikizu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ila",
		"Description": [
			"Ile Ape"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ilb",
		"Description": [
			"Ila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ilg",
		"Description": [
			"Garig-Ilgar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ili",
		"Description": [
			"Ili Turki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ilk",
		"Description": [
			"Ilongot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ill",
		"Description": [
			"Iranun"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Comments": [
			"see ilm, ilp"
		]
	},
	{
		"Type": "language",
		"Subtag": "ilm",
		"Description": [
			"Iranun (Malaysia)"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "ilo",
		"Description": [
			"Iloko"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ilp",
		"Description": [
			"Iranun (Philippines)"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "ils",
		"Description": [
			"International Sign"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ilu",
		"Description": [
			"Ili'uun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ilv",
		"Description": [
			"Ilue"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ilw",
		"Description": [
			"Talur"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Preferred-Value": "gal"
	},
	{
		"Type": "language",
		"Subtag": "ima",
		"Description": [
			"Mala Malasar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ime",
		"Description": [
			"Imeraguen"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "imi",
		"Description": [
			"Anamgura"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iml",
		"Description": [
			"Miluk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "imn",
		"Description": [
			"Imonda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "imo",
		"Description": [
			"Imbongu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "imr",
		"Description": [
			"Imroing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ims",
		"Description": [
			"Marsian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "imy",
		"Description": [
			"Milyan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inb",
		"Description": [
			"Inga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inc",
		"Description": [
			"Indic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ine",
		"Description": [
			"Indo-European languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ing",
		"Description": [
			"Degexit'an"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inh",
		"Description": [
			"Ingush"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "inj",
		"Description": [
			"Jungle Inga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inl",
		"Description": [
			"Indonesian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inm",
		"Description": [
			"Minaean"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inn",
		"Description": [
			"Isinai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ino",
		"Description": [
			"Inoke-Yate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inp",
		"Description": [
			"Iñapari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ins",
		"Description": [
			"Indian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "int",
		"Description": [
			"Intha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "inz",
		"Description": [
			"Ineseño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ior",
		"Description": [
			"Inor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iou",
		"Description": [
			"Tuma-Irumu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iow",
		"Description": [
			"Iowa-Oto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ipi",
		"Description": [
			"Ipili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ipo",
		"Description": [
			"Ipiko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iqu",
		"Description": [
			"Iquito"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iqw",
		"Description": [
			"Ikwo"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ira",
		"Description": [
			"Iranian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ire",
		"Description": [
			"Iresim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "irh",
		"Description": [
			"Irarutu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iri",
		"Description": [
			"Irigwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "irk",
		"Description": [
			"Iraqw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "irn",
		"Description": [
			"Irántxe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iro",
		"Description": [
			"Iroquoian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "irr",
		"Description": [
			"Ir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iru",
		"Description": [
			"Irula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "irx",
		"Description": [
			"Kamberau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iry",
		"Description": [
			"Iraya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isa",
		"Description": [
			"Isabi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isc",
		"Description": [
			"Isconahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isd",
		"Description": [
			"Isnag"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ise",
		"Description": [
			"Italian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isg",
		"Description": [
			"Irish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ish",
		"Description": [
			"Esan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isi",
		"Description": [
			"Nkem-Nkum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isk",
		"Description": [
			"Ishkashimi"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "ism",
		"Description": [
			"Masimasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isn",
		"Description": [
			"Isanzu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iso",
		"Description": [
			"Isoko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isr",
		"Description": [
			"Israeli Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ist",
		"Description": [
			"Istriot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "isu",
		"Description": [
			"Isu (Menchum Division)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itb",
		"Description": [
			"Binongan Itneg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itc",
		"Description": [
			"Italic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "itd",
		"Description": [
			"Southern Tidung"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "ite",
		"Description": [
			"Itene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iti",
		"Description": [
			"Inlaod Itneg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itk",
		"Description": [
			"Judeo-Italian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itl",
		"Description": [
			"Itelmen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itm",
		"Description": [
			"Itu Mbon Uzo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ito",
		"Description": [
			"Itonama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itr",
		"Description": [
			"Iteri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "its",
		"Description": [
			"Isekiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itt",
		"Description": [
			"Maeng Itneg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itv",
		"Description": [
			"Itawit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itw",
		"Description": [
			"Ito"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itx",
		"Description": [
			"Itik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ity",
		"Description": [
			"Moyadan Itneg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "itz",
		"Description": [
			"Itzá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ium",
		"Description": [
			"Iu Mien"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ivb",
		"Description": [
			"Ibatan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ivv",
		"Description": [
			"Ivatan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iwk",
		"Description": [
			"I-Wak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iwm",
		"Description": [
			"Iwam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iwo",
		"Description": [
			"Iwur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iws",
		"Description": [
			"Sepik Iwam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ixc",
		"Description": [
			"Ixcatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ixl",
		"Description": [
			"Ixil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iya",
		"Description": [
			"Iyayu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iyo",
		"Description": [
			"Mesaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "iyx",
		"Description": [
			"Yaka (Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "izh",
		"Description": [
			"Ingrian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "izi",
		"Description": [
			"Izi-Ezaa-Ikwo-Mgbo"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see eza, gmz, iqw, izz"
		]
	},
	{
		"Type": "language",
		"Subtag": "izr",
		"Description": [
			"Izere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "izz",
		"Description": [
			"Izii"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "jaa",
		"Description": [
			"Jamamadí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jab",
		"Description": [
			"Hyam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jac",
		"Description": [
			"Popti'",
			"Jakalteko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jad",
		"Description": [
			"Jahanka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jae",
		"Description": [
			"Yabem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jaf",
		"Description": [
			"Jara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jah",
		"Description": [
			"Jah Hut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jaj",
		"Description": [
			"Zazao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jak",
		"Description": [
			"Jakun"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "jal",
		"Description": [
			"Yalahatan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jam",
		"Description": [
			"Jamaican Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jan",
		"Description": [
			"Jandai"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jao",
		"Description": [
			"Yanyuwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jaq",
		"Description": [
			"Yaqay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jar",
		"Description": [
			"Jarawa (Nigeria)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see jgk, jjr"
		]
	},
	{
		"Type": "language",
		"Subtag": "jas",
		"Description": [
			"New Caledonian Javanese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jat",
		"Description": [
			"Jakati"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "jau",
		"Description": [
			"Yaur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jax",
		"Description": [
			"Jambi Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "jay",
		"Description": [
			"Yan-nhangu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jaz",
		"Description": [
			"Jawe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jbe",
		"Description": [
			"Judeo-Berber"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jbi",
		"Description": [
			"Badjiri"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "jbj",
		"Description": [
			"Arandai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jbk",
		"Description": [
			"Barikewa"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jbn",
		"Description": [
			"Nafusi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jbo",
		"Description": [
			"Lojban"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "jbr",
		"Description": [
			"Jofotek-Bromnya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jbt",
		"Description": [
			"Jabutí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jbu",
		"Description": [
			"Jukun Takum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jbw",
		"Description": [
			"Yawijibaya"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jcs",
		"Description": [
			"Jamaican Country Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jct",
		"Description": [
			"Krymchak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jda",
		"Description": [
			"Jad"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jdg",
		"Description": [
			"Jadgali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jdt",
		"Description": [
			"Judeo-Tat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jeb",
		"Description": [
			"Jebero"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jee",
		"Description": [
			"Jerung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jeg",
		"Description": [
			"Jeng"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23",
		"Preferred-Value": "oyb"
	},
	{
		"Type": "language",
		"Subtag": "jeh",
		"Description": [
			"Jeh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jei",
		"Description": [
			"Yei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jek",
		"Description": [
			"Jeri Kuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jel",
		"Description": [
			"Yelmek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jen",
		"Description": [
			"Dza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jer",
		"Description": [
			"Jere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jet",
		"Description": [
			"Manem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jeu",
		"Description": [
			"Jonkor Bourmataguil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jgb",
		"Description": [
			"Ngbee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jge",
		"Description": [
			"Judeo-Georgian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jgk",
		"Description": [
			"Gwak"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jgo",
		"Description": [
			"Ngomba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jhi",
		"Description": [
			"Jehai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jhs",
		"Description": [
			"Jhankot Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jia",
		"Description": [
			"Jina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jib",
		"Description": [
			"Jibu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jic",
		"Description": [
			"Tol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jid",
		"Description": [
			"Bu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jie",
		"Description": [
			"Jilbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jig",
		"Description": [
			"Djingili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jih",
		"Description": [
			"sTodsde",
			"Shangzhai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jii",
		"Description": [
			"Jiiddu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jil",
		"Description": [
			"Jilim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jim",
		"Description": [
			"Jimi (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jio",
		"Description": [
			"Jiamao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jiq",
		"Description": [
			"Guanyinqiao",
			"Lavrung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jit",
		"Description": [
			"Jita"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jiu",
		"Description": [
			"Youle Jinuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jiv",
		"Description": [
			"Shuar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jiy",
		"Description": [
			"Buyuan Jinuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jje",
		"Description": [
			"Jejueo"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "jjr",
		"Description": [
			"Bankal"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jka",
		"Description": [
			"Kaera"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "jkm",
		"Description": [
			"Mobwa Karen"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jko",
		"Description": [
			"Kubo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jkp",
		"Description": [
			"Paku Karen"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jkr",
		"Description": [
			"Koro (India)"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jku",
		"Description": [
			"Labir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jle",
		"Description": [
			"Ngile"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jls",
		"Description": [
			"Jamaican Sign Language"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "jma",
		"Description": [
			"Dima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jmb",
		"Description": [
			"Zumbun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jmc",
		"Description": [
			"Machame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jmd",
		"Description": [
			"Yamdena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jmi",
		"Description": [
			"Jimi (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jml",
		"Description": [
			"Jumli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jmn",
		"Description": [
			"Makuri Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jmr",
		"Description": [
			"Kamara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jms",
		"Description": [
			"Mashi (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jmw",
		"Description": [
			"Mouwase"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "jmx",
		"Description": [
			"Western Juxtlahuaca Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jna",
		"Description": [
			"Jangshung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jnd",
		"Description": [
			"Jandavra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jng",
		"Description": [
			"Yangman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jni",
		"Description": [
			"Janji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jnj",
		"Description": [
			"Yemsa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jnl",
		"Description": [
			"Rawat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jns",
		"Description": [
			"Jaunsari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "job",
		"Description": [
			"Joba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jod",
		"Description": [
			"Wojenaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jog",
		"Description": [
			"Jogi"
		],
		"Added": "2015-05-27"
	},
	{
		"Type": "language",
		"Subtag": "jor",
		"Description": [
			"Jorá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jos",
		"Description": [
			"Jordanian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jow",
		"Description": [
			"Jowulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jpa",
		"Description": [
			"Jewish Palestinian Aramaic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jpr",
		"Description": [
			"Judeo-Persian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "jpx",
		"Description": [
			"Japanese (family)"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "jqr",
		"Description": [
			"Jaqaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jra",
		"Description": [
			"Jarai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jrb",
		"Description": [
			"Judeo-Arabic"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "jrr",
		"Description": [
			"Jiru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jrt",
		"Description": [
			"Jorto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jru",
		"Description": [
			"Japrería"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jsl",
		"Description": [
			"Japanese Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jua",
		"Description": [
			"Júma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jub",
		"Description": [
			"Wannu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "juc",
		"Description": [
			"Jurchen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jud",
		"Description": [
			"Worodougou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "juh",
		"Description": [
			"Hõne"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jui",
		"Description": [
			"Ngadjuri"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "juk",
		"Description": [
			"Wapan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jul",
		"Description": [
			"Jirel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jum",
		"Description": [
			"Jumjum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jun",
		"Description": [
			"Juang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "juo",
		"Description": [
			"Jiba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jup",
		"Description": [
			"Hupdë"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jur",
		"Description": [
			"Jurúna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jus",
		"Description": [
			"Jumla Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jut",
		"Description": [
			"Jutish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "juu",
		"Description": [
			"Ju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "juw",
		"Description": [
			"Wãpha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "juy",
		"Description": [
			"Juray"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jvd",
		"Description": [
			"Javindo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jvn",
		"Description": [
			"Caribbean Javanese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jwi",
		"Description": [
			"Jwira-Pepesa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jya",
		"Description": [
			"Jiarong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "jye",
		"Description": [
			"Judeo-Yemeni Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "jrb"
	},
	{
		"Type": "language",
		"Subtag": "jyy",
		"Description": [
			"Jaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kaa",
		"Description": [
			"Kara-Kalpak"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kab",
		"Description": [
			"Kabyle"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kac",
		"Description": [
			"Kachin",
			"Jingpho"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kad",
		"Description": [
			"Adara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kae",
		"Description": [
			"Ketangalan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kaf",
		"Description": [
			"Katso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kag",
		"Description": [
			"Kajaman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kah",
		"Description": [
			"Kara (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kai",
		"Description": [
			"Karekare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kaj",
		"Description": [
			"Jju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kak",
		"Description": [
			"Kalanguya",
			"Kayapa Kallahan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kam",
		"Description": [
			"Kamba (Kenya)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kao",
		"Description": [
			"Xaasongaxango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kap",
		"Description": [
			"Bezhta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kaq",
		"Description": [
			"Capanahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kar",
		"Description": [
			"Karen languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "kav",
		"Description": [
			"Katukína"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kaw",
		"Description": [
			"Kawi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kax",
		"Description": [
			"Kao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kay",
		"Description": [
			"Kamayurá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kba",
		"Description": [
			"Kalarko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbb",
		"Description": [
			"Kaxuiâna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbc",
		"Description": [
			"Kadiwéu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbd",
		"Description": [
			"Kabardian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kbe",
		"Description": [
			"Kanju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbf",
		"Description": [
			"Kakauhua"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "kbg",
		"Description": [
			"Khamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbh",
		"Description": [
			"Camsá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbi",
		"Description": [
			"Kaptiau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbj",
		"Description": [
			"Kari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbk",
		"Description": [
			"Grass Koiari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbl",
		"Description": [
			"Kanembu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbm",
		"Description": [
			"Iwal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbn",
		"Description": [
			"Kare (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbo",
		"Description": [
			"Keliko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbp",
		"Description": [
			"Kabiyè"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbq",
		"Description": [
			"Kamano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbr",
		"Description": [
			"Kafa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbs",
		"Description": [
			"Kande"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbt",
		"Description": [
			"Abadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbu",
		"Description": [
			"Kabutra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbv",
		"Description": [
			"Dera (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbw",
		"Description": [
			"Kaiep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kbx",
		"Description": [
			"Ap Ma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kby",
		"Description": [
			"Manga Kanuri"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kr"
	},
	{
		"Type": "language",
		"Subtag": "kbz",
		"Description": [
			"Duhwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kca",
		"Description": [
			"Khanty"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcb",
		"Description": [
			"Kawacha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcc",
		"Description": [
			"Lubila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcd",
		"Description": [
			"Ngkâlmpw Kanum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kce",
		"Description": [
			"Kaivi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcf",
		"Description": [
			"Ukaan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcg",
		"Description": [
			"Tyap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kch",
		"Description": [
			"Vono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kci",
		"Description": [
			"Kamantan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcj",
		"Description": [
			"Kobiana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kck",
		"Description": [
			"Kalanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcl",
		"Description": [
			"Kela (Papua New Guinea)",
			"Kala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcm",
		"Description": [
			"Gula (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcn",
		"Description": [
			"Nubi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kco",
		"Description": [
			"Kinalakna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcp",
		"Description": [
			"Kanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcq",
		"Description": [
			"Kamo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcr",
		"Description": [
			"Katla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcs",
		"Description": [
			"Koenoem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kct",
		"Description": [
			"Kaian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcu",
		"Description": [
			"Kami (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcv",
		"Description": [
			"Kete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcw",
		"Description": [
			"Kabwari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcx",
		"Description": [
			"Kachama-Ganjule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcy",
		"Description": [
			"Korandje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kcz",
		"Description": [
			"Konongo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kda",
		"Description": [
			"Worimi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdc",
		"Description": [
			"Kutu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdd",
		"Description": [
			"Yankunytjatjara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kde",
		"Description": [
			"Makonde"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdf",
		"Description": [
			"Mamusi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdg",
		"Description": [
			"Seba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdh",
		"Description": [
			"Tem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdi",
		"Description": [
			"Kumam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdj",
		"Description": [
			"Karamojong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdk",
		"Description": [
			"Numèè",
			"Kwényi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdl",
		"Description": [
			"Tsikimba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdm",
		"Description": [
			"Kagoma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdn",
		"Description": [
			"Kunda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdo",
		"Description": [
			"Kordofanian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "kdp",
		"Description": [
			"Kaningdon-Nindem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdq",
		"Description": [
			"Koch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdr",
		"Description": [
			"Karaim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdt",
		"Description": [
			"Kuy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdu",
		"Description": [
			"Kadaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdv",
		"Description": [
			"Kado"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see zkd, zkn"
		]
	},
	{
		"Type": "language",
		"Subtag": "kdw",
		"Description": [
			"Koneraw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdx",
		"Description": [
			"Kam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdy",
		"Description": [
			"Keder",
			"Keijar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kdz",
		"Description": [
			"Kwaja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kea",
		"Description": [
			"Kabuverdianu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "keb",
		"Description": [
			"Kélé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kec",
		"Description": [
			"Keiga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ked",
		"Description": [
			"Kerewe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kee",
		"Description": [
			"Eastern Keres"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kef",
		"Description": [
			"Kpessi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "keg",
		"Description": [
			"Tese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "keh",
		"Description": [
			"Keak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kei",
		"Description": [
			"Kei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kej",
		"Description": [
			"Kadar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kek",
		"Description": [
			"Kekchí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kel",
		"Description": [
			"Kela (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kem",
		"Description": [
			"Kemak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ken",
		"Description": [
			"Kenyang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "keo",
		"Description": [
			"Kakwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kep",
		"Description": [
			"Kaikadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "keq",
		"Description": [
			"Kamar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ker",
		"Description": [
			"Kera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kes",
		"Description": [
			"Kugbo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ket",
		"Description": [
			"Ket"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "keu",
		"Description": [
			"Akebu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kev",
		"Description": [
			"Kanikkaran"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kew",
		"Description": [
			"West Kewa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kex",
		"Description": [
			"Kukna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "key",
		"Description": [
			"Kupia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kez",
		"Description": [
			"Kukele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfa",
		"Description": [
			"Kodava"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfb",
		"Description": [
			"Northwestern Kolami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfc",
		"Description": [
			"Konda-Dora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfd",
		"Description": [
			"Korra Koraga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfe",
		"Description": [
			"Kota (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kff",
		"Description": [
			"Koya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfg",
		"Description": [
			"Kudiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfh",
		"Description": [
			"Kurichiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfi",
		"Description": [
			"Kannada Kurumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfj",
		"Description": [
			"Kemiehua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfk",
		"Description": [
			"Kinnauri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfl",
		"Description": [
			"Kung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfm",
		"Description": [
			"Khunsari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfn",
		"Description": [
			"Kuk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfo",
		"Description": [
			"Koro (Côte d'Ivoire)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfp",
		"Description": [
			"Korwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfq",
		"Description": [
			"Korku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfr",
		"Description": [
			"Kachhi",
			"Kutchi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfs",
		"Description": [
			"Bilaspuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kft",
		"Description": [
			"Kanjari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfu",
		"Description": [
			"Katkari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfv",
		"Description": [
			"Kurmukar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfw",
		"Description": [
			"Kharam Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfx",
		"Description": [
			"Kullu Pahari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfy",
		"Description": [
			"Kumaoni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kfz",
		"Description": [
			"Koromfé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kga",
		"Description": [
			"Koyaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgb",
		"Description": [
			"Kawe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgc",
		"Description": [
			"Kasseng"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "tdf"
	},
	{
		"Type": "language",
		"Subtag": "kgd",
		"Description": [
			"Kataang"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23",
		"Comments": [
			"see ncq, sct"
		]
	},
	{
		"Type": "language",
		"Subtag": "kge",
		"Description": [
			"Komering"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgf",
		"Description": [
			"Kube"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgg",
		"Description": [
			"Kusunda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgh",
		"Description": [
			"Upper Tanudan Kalinga"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "kml"
	},
	{
		"Type": "language",
		"Subtag": "kgi",
		"Description": [
			"Selangor Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgj",
		"Description": [
			"Gamale Kham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgk",
		"Description": [
			"Kaiwá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgl",
		"Description": [
			"Kunggari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgm",
		"Description": [
			"Karipúna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgn",
		"Description": [
			"Karingani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgo",
		"Description": [
			"Krongo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgp",
		"Description": [
			"Kaingang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgq",
		"Description": [
			"Kamoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgr",
		"Description": [
			"Abun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgs",
		"Description": [
			"Kumbainggar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgt",
		"Description": [
			"Somyev"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgu",
		"Description": [
			"Kobol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgv",
		"Description": [
			"Karas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgw",
		"Description": [
			"Karon Dori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgx",
		"Description": [
			"Kamaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kgy",
		"Description": [
			"Kyerung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kha",
		"Description": [
			"Khasi"
		],
		"Added": "2005-10-16",
		"Comments": [
			"as of 2008-04-21 this subtag does not include Lyngngam; see",
			"lyg"
		]
	},
	{
		"Type": "language",
		"Subtag": "khb",
		"Description": [
			"Lü"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khc",
		"Description": [
			"Tukang Besi North"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khd",
		"Description": [
			"Bädi Kanum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khe",
		"Description": [
			"Korowai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khf",
		"Description": [
			"Khuen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khg",
		"Description": [
			"Khams Tibetan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khh",
		"Description": [
			"Kehu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khi",
		"Description": [
			"Khoisan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "khj",
		"Description": [
			"Kuturmi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khk",
		"Description": [
			"Halh Mongolian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mn"
	},
	{
		"Type": "language",
		"Subtag": "khl",
		"Description": [
			"Lusi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khn",
		"Description": [
			"Khandesi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kho",
		"Description": [
			"Khotanese",
			"Sakan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "khp",
		"Description": [
			"Kapori",
			"Kapauri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khq",
		"Description": [
			"Koyra Chiini Songhay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khr",
		"Description": [
			"Kharia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khs",
		"Description": [
			"Kasua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kht",
		"Description": [
			"Khamti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khu",
		"Description": [
			"Nkhumbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khv",
		"Description": [
			"Khvarshi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khw",
		"Description": [
			"Khowar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khx",
		"Description": [
			"Kanu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khy",
		"Description": [
			"Kele (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "khz",
		"Description": [
			"Keapara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kia",
		"Description": [
			"Kim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kib",
		"Description": [
			"Koalib"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kic",
		"Description": [
			"Kickapoo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kid",
		"Description": [
			"Koshin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kie",
		"Description": [
			"Kibet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kif",
		"Description": [
			"Eastern Parbate Kham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kig",
		"Description": [
			"Kimaama",
			"Kimaghima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kih",
		"Description": [
			"Kilmeri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kii",
		"Description": [
			"Kitsai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kij",
		"Description": [
			"Kilivila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kil",
		"Description": [
			"Kariya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kim",
		"Description": [
			"Karagas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kio",
		"Description": [
			"Kiowa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kip",
		"Description": [
			"Sheshi Kham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kiq",
		"Description": [
			"Kosadle",
			"Kosare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kis",
		"Description": [
			"Kis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kit",
		"Description": [
			"Agob"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kiu",
		"Description": [
			"Kirmanjki (individual language)"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zza"
	},
	{
		"Type": "language",
		"Subtag": "kiv",
		"Description": [
			"Kimbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kiw",
		"Description": [
			"Northeast Kiwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kix",
		"Description": [
			"Khiamniungan Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kiy",
		"Description": [
			"Kirikiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kiz",
		"Description": [
			"Kisi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kja",
		"Description": [
			"Mlap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjb",
		"Description": [
			"Q'anjob'al",
			"Kanjobal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjc",
		"Description": [
			"Coastal Konjo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjd",
		"Description": [
			"Southern Kiwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kje",
		"Description": [
			"Kisar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjf",
		"Description": [
			"Khalaj"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjg",
		"Description": [
			"Khmu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjh",
		"Description": [
			"Khakas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kji",
		"Description": [
			"Zabana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjj",
		"Description": [
			"Khinalugh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjk",
		"Description": [
			"Highland Konjo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjl",
		"Description": [
			"Western Parbate Kham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjm",
		"Description": [
			"Kháng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjn",
		"Description": [
			"Kunjen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjo",
		"Description": [
			"Harijan Kinnauri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjp",
		"Description": [
			"Pwo Eastern Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjq",
		"Description": [
			"Western Keres"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjr",
		"Description": [
			"Kurudu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjs",
		"Description": [
			"East Kewa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjt",
		"Description": [
			"Phrae Pwo Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kju",
		"Description": [
			"Kashaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjv",
		"Description": [
			"Kaikavian Literary Language"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "kjx",
		"Description": [
			"Ramopa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjy",
		"Description": [
			"Erave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kjz",
		"Description": [
			"Bumthangkha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kka",
		"Description": [
			"Kakanda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkb",
		"Description": [
			"Kwerisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkc",
		"Description": [
			"Odoodee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkd",
		"Description": [
			"Kinuku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kke",
		"Description": [
			"Kakabe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkf",
		"Description": [
			"Kalaktang Monpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkg",
		"Description": [
			"Mabaka Valley Kalinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkh",
		"Description": [
			"Khün"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kki",
		"Description": [
			"Kagulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkj",
		"Description": [
			"Kako"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkk",
		"Description": [
			"Kokota"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkl",
		"Description": [
			"Kosarek Yale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkm",
		"Description": [
			"Kiong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkn",
		"Description": [
			"Kon Keu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kko",
		"Description": [
			"Karko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkp",
		"Description": [
			"Gugubera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkq",
		"Description": [
			"Kaiku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkr",
		"Description": [
			"Kir-Balar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kks",
		"Description": [
			"Giiwo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkt",
		"Description": [
			"Koi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kku",
		"Description": [
			"Tumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkv",
		"Description": [
			"Kangean"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkw",
		"Description": [
			"Teke-Kukuya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkx",
		"Description": [
			"Kohin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kky",
		"Description": [
			"Guguyimidjir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kkz",
		"Description": [
			"Kaska"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kla",
		"Description": [
			"Klamath-Modoc"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klb",
		"Description": [
			"Kiliwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klc",
		"Description": [
			"Kolbila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kld",
		"Description": [
			"Gamilaraay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kle",
		"Description": [
			"Kulung (Nepal)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klf",
		"Description": [
			"Kendeje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klg",
		"Description": [
			"Tagakaulo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klh",
		"Description": [
			"Weliki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kli",
		"Description": [
			"Kalumpang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klj",
		"Description": [
			"Turkic Khalaj"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klk",
		"Description": [
			"Kono (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kll",
		"Description": [
			"Kagan Kalagan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klm",
		"Description": [
			"Migum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kln",
		"Description": [
			"Kalenjin"
		],
		"Added": "2009-07-29",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "klo",
		"Description": [
			"Kapya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klp",
		"Description": [
			"Kamasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klq",
		"Description": [
			"Rumu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klr",
		"Description": [
			"Khaling"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kls",
		"Description": [
			"Kalasha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klt",
		"Description": [
			"Nukna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klu",
		"Description": [
			"Klao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klv",
		"Description": [
			"Maskelynes"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klw",
		"Description": [
			"Tado",
			"Lindu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klx",
		"Description": [
			"Koluwawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kly",
		"Description": [
			"Kalao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "klz",
		"Description": [
			"Kabola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kma",
		"Description": [
			"Konni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmb",
		"Description": [
			"Kimbundu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kmc",
		"Description": [
			"Southern Dong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmd",
		"Description": [
			"Majukayang Kalinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kme",
		"Description": [
			"Bakole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmf",
		"Description": [
			"Kare (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmg",
		"Description": [
			"Kâte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmh",
		"Description": [
			"Kalam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmi",
		"Description": [
			"Kami (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmj",
		"Description": [
			"Kumarbhag Paharia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmk",
		"Description": [
			"Limos Kalinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kml",
		"Description": [
			"Tanudan Kalinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmm",
		"Description": [
			"Kom (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmn",
		"Description": [
			"Awtuw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmo",
		"Description": [
			"Kwoma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmp",
		"Description": [
			"Gimme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmq",
		"Description": [
			"Kwama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmr",
		"Description": [
			"Northern Kurdish"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ku"
	},
	{
		"Type": "language",
		"Subtag": "kms",
		"Description": [
			"Kamasau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmt",
		"Description": [
			"Kemtuik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmu",
		"Description": [
			"Kanite"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmv",
		"Description": [
			"Karipúna Creole French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmw",
		"Description": [
			"Komo (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmx",
		"Description": [
			"Waboda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmy",
		"Description": [
			"Koma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kmz",
		"Description": [
			"Khorasani Turkish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kna",
		"Description": [
			"Dera (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knb",
		"Description": [
			"Lubuagan Kalinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knc",
		"Description": [
			"Central Kanuri"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kr"
	},
	{
		"Type": "language",
		"Subtag": "knd",
		"Description": [
			"Konda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kne",
		"Description": [
			"Kankanaey"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knf",
		"Description": [
			"Mankanya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kng",
		"Description": [
			"Koongo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kg"
	},
	{
		"Type": "language",
		"Subtag": "kni",
		"Description": [
			"Kanufi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knj",
		"Description": [
			"Western Kanjobal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knk",
		"Description": [
			"Kuranko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knl",
		"Description": [
			"Keninjal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knm",
		"Description": [
			"Kanamarí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knn",
		"Description": [
			"Konkani (individual language)"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kok"
	},
	{
		"Type": "language",
		"Subtag": "kno",
		"Description": [
			"Kono (Sierra Leone)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knp",
		"Description": [
			"Kwanja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knq",
		"Description": [
			"Kintaq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knr",
		"Description": [
			"Kaningra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kns",
		"Description": [
			"Kensiu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knt",
		"Description": [
			"Panoan Katukína"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knu",
		"Description": [
			"Kono (Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knv",
		"Description": [
			"Tabo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knw",
		"Description": [
			"Kung-Ekoka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knx",
		"Description": [
			"Kendayan",
			"Salako"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kny",
		"Description": [
			"Kanyok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "knz",
		"Description": [
			"Kalamsé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koa",
		"Description": [
			"Konomala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koc",
		"Description": [
			"Kpati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kod",
		"Description": [
			"Kodi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koe",
		"Description": [
			"Kacipo-Balesi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kof",
		"Description": [
			"Kubi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kog",
		"Description": [
			"Cogui",
			"Kogi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koh",
		"Description": [
			"Koyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koi",
		"Description": [
			"Komi-Permyak"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kv"
	},
	{
		"Type": "language",
		"Subtag": "koj",
		"Description": [
			"Sara Dunjo"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "kwv"
	},
	{
		"Type": "language",
		"Subtag": "kok",
		"Description": [
			"Konkani (macrolanguage)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Deva",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "kol",
		"Description": [
			"Kol (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koo",
		"Description": [
			"Konzo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kop",
		"Description": [
			"Waube"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koq",
		"Description": [
			"Kota (Gabon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kos",
		"Description": [
			"Kosraean"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kot",
		"Description": [
			"Lagwan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kou",
		"Description": [
			"Koke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kov",
		"Description": [
			"Kudu-Camo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kow",
		"Description": [
			"Kugama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kox",
		"Description": [
			"Coxima"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "koy",
		"Description": [
			"Koyukon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "koz",
		"Description": [
			"Korak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpa",
		"Description": [
			"Kutto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpb",
		"Description": [
			"Mullu Kurumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpc",
		"Description": [
			"Curripaco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpd",
		"Description": [
			"Koba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpe",
		"Description": [
			"Kpelle"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "kpf",
		"Description": [
			"Komba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpg",
		"Description": [
			"Kapingamarangi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kph",
		"Description": [
			"Kplang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpi",
		"Description": [
			"Kofei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpj",
		"Description": [
			"Karajá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpk",
		"Description": [
			"Kpan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpl",
		"Description": [
			"Kpala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpm",
		"Description": [
			"Koho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpn",
		"Description": [
			"Kepkiriwát"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpo",
		"Description": [
			"Ikposo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpp",
		"Description": [
			"Paku Karen"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see jkm, jkp"
		]
	},
	{
		"Type": "language",
		"Subtag": "kpq",
		"Description": [
			"Korupun-Sela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpr",
		"Description": [
			"Korafe-Yegha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kps",
		"Description": [
			"Tehit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpt",
		"Description": [
			"Karata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpu",
		"Description": [
			"Kafoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpv",
		"Description": [
			"Komi-Zyrian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kv"
	},
	{
		"Type": "language",
		"Subtag": "kpw",
		"Description": [
			"Kobon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpx",
		"Description": [
			"Mountain Koiali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpy",
		"Description": [
			"Koryak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kpz",
		"Description": [
			"Kupsabiny"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqa",
		"Description": [
			"Mum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqb",
		"Description": [
			"Kovai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqc",
		"Description": [
			"Doromu-Koki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqd",
		"Description": [
			"Koy Sanjaq Surat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqe",
		"Description": [
			"Kalagan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqf",
		"Description": [
			"Kakabai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqg",
		"Description": [
			"Khe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqh",
		"Description": [
			"Kisankasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqi",
		"Description": [
			"Koitabu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqj",
		"Description": [
			"Koromira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqk",
		"Description": [
			"Kotafon Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kql",
		"Description": [
			"Kyenele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqm",
		"Description": [
			"Khisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqn",
		"Description": [
			"Kaonde"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqo",
		"Description": [
			"Eastern Krahn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqp",
		"Description": [
			"Kimré"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqq",
		"Description": [
			"Krenak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqr",
		"Description": [
			"Kimaragang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqs",
		"Description": [
			"Northern Kissi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqt",
		"Description": [
			"Klias River Kadazan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqu",
		"Description": [
			"Seroa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqv",
		"Description": [
			"Okolod"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqw",
		"Description": [
			"Kandas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqx",
		"Description": [
			"Mser"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqy",
		"Description": [
			"Koorete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kqz",
		"Description": [
			"Korana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kra",
		"Description": [
			"Kumhali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krb",
		"Description": [
			"Karkin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krc",
		"Description": [
			"Karachay-Balkar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "krd",
		"Description": [
			"Kairui-Midiki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kre",
		"Description": [
			"Panará"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krf",
		"Description": [
			"Koro (Vanuatu)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krh",
		"Description": [
			"Kurama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kri",
		"Description": [
			"Krio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krj",
		"Description": [
			"Kinaray-A"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krk",
		"Description": [
			"Kerek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krl",
		"Description": [
			"Karelian"
		],
		"Added": "2006-03-08"
	},
	{
		"Type": "language",
		"Subtag": "krm",
		"Description": [
			"Krim"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23",
		"Preferred-Value": "bmf"
	},
	{
		"Type": "language",
		"Subtag": "krn",
		"Description": [
			"Sapo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kro",
		"Description": [
			"Kru languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "krp",
		"Description": [
			"Korop"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krr",
		"Description": [
			"Krung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krs",
		"Description": [
			"Gbaya (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krt",
		"Description": [
			"Tumari Kanuri"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kr"
	},
	{
		"Type": "language",
		"Subtag": "kru",
		"Description": [
			"Kurukh"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "krv",
		"Description": [
			"Kavet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krw",
		"Description": [
			"Western Krahn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krx",
		"Description": [
			"Karon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kry",
		"Description": [
			"Kryts"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "krz",
		"Description": [
			"Sota Kanum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksa",
		"Description": [
			"Shuwa-Zamani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksb",
		"Description": [
			"Shambala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksc",
		"Description": [
			"Southern Kalinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksd",
		"Description": [
			"Kuanua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kse",
		"Description": [
			"Kuni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksf",
		"Description": [
			"Bafia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksg",
		"Description": [
			"Kusaghe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksh",
		"Description": [
			"Kölsch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksi",
		"Description": [
			"Krisa",
			"I'saka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksj",
		"Description": [
			"Uare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksk",
		"Description": [
			"Kansa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksl",
		"Description": [
			"Kumalu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksm",
		"Description": [
			"Kumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksn",
		"Description": [
			"Kasiguranin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kso",
		"Description": [
			"Kofa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksp",
		"Description": [
			"Kaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksq",
		"Description": [
			"Kwaami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksr",
		"Description": [
			"Borong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kss",
		"Description": [
			"Southern Kisi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kst",
		"Description": [
			"Winyé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksu",
		"Description": [
			"Khamyang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksv",
		"Description": [
			"Kusu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksw",
		"Description": [
			"S'gaw Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksx",
		"Description": [
			"Kedang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksy",
		"Description": [
			"Kharia Thar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ksz",
		"Description": [
			"Kodaku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kta",
		"Description": [
			"Katua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktb",
		"Description": [
			"Kambaata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktc",
		"Description": [
			"Kholok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktd",
		"Description": [
			"Kokata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kte",
		"Description": [
			"Nubri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktf",
		"Description": [
			"Kwami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktg",
		"Description": [
			"Kalkutung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kth",
		"Description": [
			"Karanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kti",
		"Description": [
			"North Muyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktj",
		"Description": [
			"Plapo Krumen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktk",
		"Description": [
			"Kaniet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktl",
		"Description": [
			"Koroshi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktm",
		"Description": [
			"Kurti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktn",
		"Description": [
			"Karitiâna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kto",
		"Description": [
			"Kuot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktp",
		"Description": [
			"Kaduo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktq",
		"Description": [
			"Katabaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktr",
		"Description": [
			"Kota Marudu Tinagas"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "dtp"
	},
	{
		"Type": "language",
		"Subtag": "kts",
		"Description": [
			"South Muyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktt",
		"Description": [
			"Ketum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktu",
		"Description": [
			"Kituba (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktv",
		"Description": [
			"Eastern Katu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktw",
		"Description": [
			"Kato"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktx",
		"Description": [
			"Kaxararí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kty",
		"Description": [
			"Kango (Bas-Uélé District)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ktz",
		"Description": [
			"Ju/'hoan",
			"Juǀʼhoan",
			"Juǀʼhoansi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kub",
		"Description": [
			"Kutep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuc",
		"Description": [
			"Kwinsu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kud",
		"Description": [
			"'Auhelawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kue",
		"Description": [
			"Kuman (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuf",
		"Description": [
			"Western Katu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kug",
		"Description": [
			"Kupa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuh",
		"Description": [
			"Kushi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kui",
		"Description": [
			"Kuikúro-Kalapálo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuj",
		"Description": [
			"Kuria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuk",
		"Description": [
			"Kepo'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kul",
		"Description": [
			"Kulere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kum",
		"Description": [
			"Kumyk"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kun",
		"Description": [
			"Kunama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuo",
		"Description": [
			"Kumukio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kup",
		"Description": [
			"Kunimaipa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuq",
		"Description": [
			"Karipuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kus",
		"Description": [
			"Kusaal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kut",
		"Description": [
			"Kutenai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "kuu",
		"Description": [
			"Upper Kuskokwim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuv",
		"Description": [
			"Kur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuw",
		"Description": [
			"Kpagua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kux",
		"Description": [
			"Kukatja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuy",
		"Description": [
			"Kuuku-Ya'u"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kuz",
		"Description": [
			"Kunza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kva",
		"Description": [
			"Bagvalal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvb",
		"Description": [
			"Kubu"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "kvc",
		"Description": [
			"Kove"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvd",
		"Description": [
			"Kui (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kve",
		"Description": [
			"Kalabakan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvf",
		"Description": [
			"Kabalai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvg",
		"Description": [
			"Kuni-Boazi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvh",
		"Description": [
			"Komodo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvi",
		"Description": [
			"Kwang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvj",
		"Description": [
			"Psikye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvk",
		"Description": [
			"Korean Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvl",
		"Description": [
			"Kayaw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvm",
		"Description": [
			"Kendem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvn",
		"Description": [
			"Border Kuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvo",
		"Description": [
			"Dobel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvp",
		"Description": [
			"Kompane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvq",
		"Description": [
			"Geba Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvr",
		"Description": [
			"Kerinci"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "kvs",
		"Description": [
			"Kunggara"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "gdj"
	},
	{
		"Type": "language",
		"Subtag": "kvt",
		"Description": [
			"Lahta Karen",
			"Lahta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvu",
		"Description": [
			"Yinbaw Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvv",
		"Description": [
			"Kola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvw",
		"Description": [
			"Wersing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvx",
		"Description": [
			"Parkari Koli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvy",
		"Description": [
			"Yintale Karen",
			"Yintale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kvz",
		"Description": [
			"Tsakwambo",
			"Tsaukambo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwa",
		"Description": [
			"Dâw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwb",
		"Description": [
			"Kwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwc",
		"Description": [
			"Likwala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwd",
		"Description": [
			"Kwaio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwe",
		"Description": [
			"Kwerba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwf",
		"Description": [
			"Kwara'ae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwg",
		"Description": [
			"Sara Kaba Deme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwh",
		"Description": [
			"Kowiai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwi",
		"Description": [
			"Awa-Cuaiquer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwj",
		"Description": [
			"Kwanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwk",
		"Description": [
			"Kwakiutl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwl",
		"Description": [
			"Kofyar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwm",
		"Description": [
			"Kwambi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwn",
		"Description": [
			"Kwangali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwo",
		"Description": [
			"Kwomtari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwp",
		"Description": [
			"Kodia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwq",
		"Description": [
			"Kwak"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "yam"
	},
	{
		"Type": "language",
		"Subtag": "kwr",
		"Description": [
			"Kwer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kws",
		"Description": [
			"Kwese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwt",
		"Description": [
			"Kwesten"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwu",
		"Description": [
			"Kwakum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwv",
		"Description": [
			"Sara Kaba Náà"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kww",
		"Description": [
			"Kwinti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwx",
		"Description": [
			"Khirwar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kwy",
		"Description": [
			"San Salvador Kongo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kg"
	},
	{
		"Type": "language",
		"Subtag": "kwz",
		"Description": [
			"Kwadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxa",
		"Description": [
			"Kairiru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxb",
		"Description": [
			"Krobu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxc",
		"Description": [
			"Konso",
			"Khonso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxd",
		"Description": [
			"Brunei"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "kxe",
		"Description": [
			"Kakihum"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "tvd"
	},
	{
		"Type": "language",
		"Subtag": "kxf",
		"Description": [
			"Manumanaw Karen",
			"Manumanaw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxh",
		"Description": [
			"Karo (Ethiopia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxi",
		"Description": [
			"Keningau Murut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxj",
		"Description": [
			"Kulfa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxk",
		"Description": [
			"Zayein Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxl",
		"Description": [
			"Nepali Kurux"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxm",
		"Description": [
			"Northern Khmer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxn",
		"Description": [
			"Kanowit-Tanjong Melanau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxo",
		"Description": [
			"Kanoé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxp",
		"Description": [
			"Wadiyara Koli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxq",
		"Description": [
			"Smärky Kanum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxr",
		"Description": [
			"Koro (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxs",
		"Description": [
			"Kangjia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxt",
		"Description": [
			"Koiwat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxu",
		"Description": [
			"Kui (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxv",
		"Description": [
			"Kuvi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxw",
		"Description": [
			"Konai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxx",
		"Description": [
			"Likuba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxy",
		"Description": [
			"Kayong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kxz",
		"Description": [
			"Kerewo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kya",
		"Description": [
			"Kwaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyb",
		"Description": [
			"Butbut Kalinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyc",
		"Description": [
			"Kyaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyd",
		"Description": [
			"Karey"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kye",
		"Description": [
			"Krache"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyf",
		"Description": [
			"Kouya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyg",
		"Description": [
			"Keyagana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyh",
		"Description": [
			"Karok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyi",
		"Description": [
			"Kiput"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyj",
		"Description": [
			"Karao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyk",
		"Description": [
			"Kamayo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyl",
		"Description": [
			"Kalapuya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kym",
		"Description": [
			"Kpatili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyn",
		"Description": [
			"Northern Binukidnon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyo",
		"Description": [
			"Kelon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyp",
		"Description": [
			"Kang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyq",
		"Description": [
			"Kenga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyr",
		"Description": [
			"Kuruáya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kys",
		"Description": [
			"Baram Kayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyt",
		"Description": [
			"Kayagar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyu",
		"Description": [
			"Western Kayah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyv",
		"Description": [
			"Kayort"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyw",
		"Description": [
			"Kudmali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyx",
		"Description": [
			"Rapoisi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyy",
		"Description": [
			"Kambaira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kyz",
		"Description": [
			"Kayabí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kza",
		"Description": [
			"Western Karaboro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzb",
		"Description": [
			"Kaibobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzc",
		"Description": [
			"Bondoukou Kulango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzd",
		"Description": [
			"Kadai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kze",
		"Description": [
			"Kosena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzf",
		"Description": [
			"Da'a Kaili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzg",
		"Description": [
			"Kikai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzh",
		"Description": [
			"Kenuzi-Dongola"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see dgl, xnz"
		]
	},
	{
		"Type": "language",
		"Subtag": "kzi",
		"Description": [
			"Kelabit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzj",
		"Description": [
			"Coastal Kadazan"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "dtp"
	},
	{
		"Type": "language",
		"Subtag": "kzk",
		"Description": [
			"Kazukuru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzl",
		"Description": [
			"Kayeli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzm",
		"Description": [
			"Kais"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzn",
		"Description": [
			"Kokola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzo",
		"Description": [
			"Kaningi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzp",
		"Description": [
			"Kaidipang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzq",
		"Description": [
			"Kaike"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzr",
		"Description": [
			"Karang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzs",
		"Description": [
			"Sugut Dusun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzt",
		"Description": [
			"Tambunan Dusun"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "dtp"
	},
	{
		"Type": "language",
		"Subtag": "kzu",
		"Description": [
			"Kayupulau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzv",
		"Description": [
			"Komyandaret"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzw",
		"Description": [
			"Karirí-Xocó"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzx",
		"Description": [
			"Kamarian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzy",
		"Description": [
			"Kango (Tshopo District)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "kzz",
		"Description": [
			"Kalabra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "laa",
		"Description": [
			"Southern Subanen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lab",
		"Description": [
			"Linear A"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lac",
		"Description": [
			"Lacandon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lad",
		"Description": [
			"Ladino"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lae",
		"Description": [
			"Pattani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "laf",
		"Description": [
			"Lafofa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lag",
		"Description": [
			"Langi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lah",
		"Description": [
			"Lahnda"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "lai",
		"Description": [
			"Lambya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "laj",
		"Description": [
			"Lango (Uganda)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lak",
		"Description": [
			"Laka (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lal",
		"Description": [
			"Lalia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lam",
		"Description": [
			"Lamba"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lan",
		"Description": [
			"Laru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lap",
		"Description": [
			"Laka (Chad)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "laq",
		"Description": [
			"Qabiao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lar",
		"Description": [
			"Larteh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "las",
		"Description": [
			"Lama (Togo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lau",
		"Description": [
			"Laba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "law",
		"Description": [
			"Lauje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lax",
		"Description": [
			"Tiwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lay",
		"Description": [
			"Lama Bai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "laz",
		"Description": [
			"Aribwatsa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lba",
		"Description": [
			"Lui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbb",
		"Description": [
			"Label"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbc",
		"Description": [
			"Lakkia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbe",
		"Description": [
			"Lak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbf",
		"Description": [
			"Tinani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbg",
		"Description": [
			"Laopang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbi",
		"Description": [
			"La'bi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbj",
		"Description": [
			"Ladakhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbk",
		"Description": [
			"Central Bontok"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bnc"
	},
	{
		"Type": "language",
		"Subtag": "lbl",
		"Description": [
			"Libon Bikol"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "lbm",
		"Description": [
			"Lodhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbn",
		"Description": [
			"Lamet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbo",
		"Description": [
			"Laven"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbq",
		"Description": [
			"Wampar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbr",
		"Description": [
			"Lohorung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbs",
		"Description": [
			"Libyan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbt",
		"Description": [
			"Lachi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbu",
		"Description": [
			"Labu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbv",
		"Description": [
			"Lavatbura-Lamusong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbw",
		"Description": [
			"Tolaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbx",
		"Description": [
			"Lawangan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lby",
		"Description": [
			"Lamu-Lamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lbz",
		"Description": [
			"Lardil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lcc",
		"Description": [
			"Legenyem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lcd",
		"Description": [
			"Lola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lce",
		"Description": [
			"Loncong",
			"Sekak"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "lcf",
		"Description": [
			"Lubu"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "lch",
		"Description": [
			"Luchazi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lcl",
		"Description": [
			"Lisela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lcm",
		"Description": [
			"Tungag"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lcp",
		"Description": [
			"Western Lawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lcq",
		"Description": [
			"Luhu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lcs",
		"Description": [
			"Lisabata-Nuniali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lda",
		"Description": [
			"Kla-Dan"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ldb",
		"Description": [
			"Dũya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldd",
		"Description": [
			"Luri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldg",
		"Description": [
			"Lenyima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldh",
		"Description": [
			"Lamja-Dengsa-Tola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldi",
		"Description": [
			"Laari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kg"
	},
	{
		"Type": "language",
		"Subtag": "ldj",
		"Description": [
			"Lemoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldk",
		"Description": [
			"Leelau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldl",
		"Description": [
			"Kaan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldm",
		"Description": [
			"Landoma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldn",
		"Description": [
			"Láadan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldo",
		"Description": [
			"Loo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldp",
		"Description": [
			"Tso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ldq",
		"Description": [
			"Lufu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lea",
		"Description": [
			"Lega-Shabunda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "leb",
		"Description": [
			"Lala-Bisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lec",
		"Description": [
			"Leco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "led",
		"Description": [
			"Lendu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lee",
		"Description": [
			"Lyélé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lef",
		"Description": [
			"Lelemi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "leg",
		"Description": [
			"Lengua"
		],
		"Added": "2009-07-29",
		"Deprecated": "2014-02-28",
		"Comments": [
			"see enl, enx"
		]
	},
	{
		"Type": "language",
		"Subtag": "leh",
		"Description": [
			"Lenje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lei",
		"Description": [
			"Lemio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lej",
		"Description": [
			"Lengola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lek",
		"Description": [
			"Leipon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lel",
		"Description": [
			"Lele (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lem",
		"Description": [
			"Nomaande"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "len",
		"Description": [
			"Lenca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "leo",
		"Description": [
			"Leti (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lep",
		"Description": [
			"Lepcha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "leq",
		"Description": [
			"Lembena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ler",
		"Description": [
			"Lenkau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "les",
		"Description": [
			"Lese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "let",
		"Description": [
			"Lesing-Gelimi",
			"Amio-Gelimi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "leu",
		"Description": [
			"Kara (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lev",
		"Description": [
			"Lamma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lew",
		"Description": [
			"Ledo Kaili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lex",
		"Description": [
			"Luang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ley",
		"Description": [
			"Lemolang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lez",
		"Description": [
			"Lezghian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lfa",
		"Description": [
			"Lefa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lfn",
		"Description": [
			"Lingua Franca Nova"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lga",
		"Description": [
			"Lungga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgb",
		"Description": [
			"Laghu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgg",
		"Description": [
			"Lugbara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgh",
		"Description": [
			"Laghuu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgi",
		"Description": [
			"Lengilu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgk",
		"Description": [
			"Lingarak",
			"Neverver"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgl",
		"Description": [
			"Wala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgm",
		"Description": [
			"Lega-Mwenga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgn",
		"Description": [
			"T'apo",
			"Opuuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgq",
		"Description": [
			"Logba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgr",
		"Description": [
			"Lengo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgt",
		"Description": [
			"Pahi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgu",
		"Description": [
			"Longgu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lgz",
		"Description": [
			"Ligenza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lha",
		"Description": [
			"Laha (Viet Nam)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhh",
		"Description": [
			"Laha (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhi",
		"Description": [
			"Lahu Shi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhl",
		"Description": [
			"Lahul Lohar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhm",
		"Description": [
			"Lhomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhn",
		"Description": [
			"Lahanan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhp",
		"Description": [
			"Lhokpu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhs",
		"Description": [
			"Mlahsö"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lht",
		"Description": [
			"Lo-Toga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lhu",
		"Description": [
			"Lahu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lia",
		"Description": [
			"West-Central Limba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lib",
		"Description": [
			"Likum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lic",
		"Description": [
			"Hlai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lid",
		"Description": [
			"Nyindrou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lie",
		"Description": [
			"Likila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lif",
		"Description": [
			"Limbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lig",
		"Description": [
			"Ligbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lih",
		"Description": [
			"Lihir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lii",
		"Description": [
			"Lingkhim"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "raq"
	},
	{
		"Type": "language",
		"Subtag": "lij",
		"Description": [
			"Ligurian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lik",
		"Description": [
			"Lika"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lil",
		"Description": [
			"Lillooet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lio",
		"Description": [
			"Liki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lip",
		"Description": [
			"Sekpele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "liq",
		"Description": [
			"Libido"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lir",
		"Description": [
			"Liberian English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lis",
		"Description": [
			"Lisu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "liu",
		"Description": [
			"Logorik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "liv",
		"Description": [
			"Liv"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "liw",
		"Description": [
			"Col"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "lix",
		"Description": [
			"Liabuku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "liy",
		"Description": [
			"Banda-Bambari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "liz",
		"Description": [
			"Libinza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lja",
		"Description": [
			"Golpa"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "lje",
		"Description": [
			"Rampi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lji",
		"Description": [
			"Laiyolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ljl",
		"Description": [
			"Li'o"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ljp",
		"Description": [
			"Lampung Api"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ljw",
		"Description": [
			"Yirandali"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ljx",
		"Description": [
			"Yuru"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "lka",
		"Description": [
			"Lakalei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lkb",
		"Description": [
			"Kabras",
			"Lukabaras"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lkc",
		"Description": [
			"Kucong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lkd",
		"Description": [
			"Lakondê"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lke",
		"Description": [
			"Kenyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lkh",
		"Description": [
			"Lakha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lki",
		"Description": [
			"Laki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lkj",
		"Description": [
			"Remun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lkl",
		"Description": [
			"Laeko-Libuat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lkm",
		"Description": [
			"Kalaamaya"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "lkn",
		"Description": [
			"Lakon",
			"Vure"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lko",
		"Description": [
			"Khayo",
			"Olukhayo"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lkr",
		"Description": [
			"Päri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lks",
		"Description": [
			"Kisa",
			"Olushisa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lkt",
		"Description": [
			"Lakota"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lku",
		"Description": [
			"Kungkari"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "lky",
		"Description": [
			"Lokoya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lla",
		"Description": [
			"Lala-Roba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llb",
		"Description": [
			"Lolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llc",
		"Description": [
			"Lele (Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lld",
		"Description": [
			"Ladin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lle",
		"Description": [
			"Lele (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llf",
		"Description": [
			"Hermit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llg",
		"Description": [
			"Lole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llh",
		"Description": [
			"Lamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lli",
		"Description": [
			"Teke-Laali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llj",
		"Description": [
			"Ladji Ladji"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "llk",
		"Description": [
			"Lelak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lll",
		"Description": [
			"Lilau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llm",
		"Description": [
			"Lasalimu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lln",
		"Description": [
			"Lele (Chad)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llo",
		"Description": [
			"Khlor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llp",
		"Description": [
			"North Efate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llq",
		"Description": [
			"Lolak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lls",
		"Description": [
			"Lithuanian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llu",
		"Description": [
			"Lau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "llx",
		"Description": [
			"Lauan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lma",
		"Description": [
			"East Limba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmb",
		"Description": [
			"Merei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmc",
		"Description": [
			"Limilngan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmd",
		"Description": [
			"Lumun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lme",
		"Description": [
			"Pévé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmf",
		"Description": [
			"South Lembata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmg",
		"Description": [
			"Lamogai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmh",
		"Description": [
			"Lambichhong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmi",
		"Description": [
			"Lombi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmj",
		"Description": [
			"West Lembata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmk",
		"Description": [
			"Lamkang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lml",
		"Description": [
			"Hano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmm",
		"Description": [
			"Lamam"
		],
		"Added": "2009-07-29",
		"Deprecated": "2014-02-28",
		"Preferred-Value": "rmx"
	},
	{
		"Type": "language",
		"Subtag": "lmn",
		"Description": [
			"Lambadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmo",
		"Description": [
			"Lombard"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmp",
		"Description": [
			"Limbum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmq",
		"Description": [
			"Lamatuka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmr",
		"Description": [
			"Lamalera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmu",
		"Description": [
			"Lamenu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmv",
		"Description": [
			"Lomaiviti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmw",
		"Description": [
			"Lake Miwok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmx",
		"Description": [
			"Laimbue"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmy",
		"Description": [
			"Lamboya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lmz",
		"Description": [
			"Lumbee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lna",
		"Description": [
			"Langbashe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnb",
		"Description": [
			"Mbalanhu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnd",
		"Description": [
			"Lundayeh",
			"Lun Bawang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lng",
		"Description": [
			"Langobardic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnh",
		"Description": [
			"Lanoh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lni",
		"Description": [
			"Daantanai'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnj",
		"Description": [
			"Leningitij"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnl",
		"Description": [
			"South Central Banda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnm",
		"Description": [
			"Langam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnn",
		"Description": [
			"Lorediakarkar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lno",
		"Description": [
			"Lango (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lns",
		"Description": [
			"Lamnso'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnu",
		"Description": [
			"Longuda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lnw",
		"Description": [
			"Lanima"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "lnz",
		"Description": [
			"Lonzo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loa",
		"Description": [
			"Loloda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lob",
		"Description": [
			"Lobi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loc",
		"Description": [
			"Inonhan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loe",
		"Description": [
			"Saluan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lof",
		"Description": [
			"Logol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "log",
		"Description": [
			"Logo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loh",
		"Description": [
			"Narim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loi",
		"Description": [
			"Loma (Côte d'Ivoire)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loj",
		"Description": [
			"Lou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lok",
		"Description": [
			"Loko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lol",
		"Description": [
			"Mongo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lom",
		"Description": [
			"Loma (Liberia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lon",
		"Description": [
			"Malawi Lomwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loo",
		"Description": [
			"Lombo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lop",
		"Description": [
			"Lopa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loq",
		"Description": [
			"Lobala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lor",
		"Description": [
			"Téén"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "los",
		"Description": [
			"Loniu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lot",
		"Description": [
			"Otuho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lou",
		"Description": [
			"Louisiana Creole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lov",
		"Description": [
			"Lopi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "low",
		"Description": [
			"Tampias Lobu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lox",
		"Description": [
			"Loun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loy",
		"Description": [
			"Loke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "loz",
		"Description": [
			"Lozi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lpa",
		"Description": [
			"Lelepa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lpe",
		"Description": [
			"Lepki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lpn",
		"Description": [
			"Long Phuri Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lpo",
		"Description": [
			"Lipo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lpx",
		"Description": [
			"Lopit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lra",
		"Description": [
			"Rara Bakati'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrc",
		"Description": [
			"Northern Luri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lre",
		"Description": [
			"Laurentian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrg",
		"Description": [
			"Laragia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lri",
		"Description": [
			"Marachi",
			"Olumarachi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lrk",
		"Description": [
			"Loarki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrl",
		"Description": [
			"Lari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrm",
		"Description": [
			"Marama",
			"Olumarama"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lrn",
		"Description": [
			"Lorang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lro",
		"Description": [
			"Laro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrr",
		"Description": [
			"Southern Yamphu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrt",
		"Description": [
			"Larantuka Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrv",
		"Description": [
			"Larevat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lrz",
		"Description": [
			"Lemerig"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsa",
		"Description": [
			"Lasgerdi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsd",
		"Description": [
			"Lishana Deni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lse",
		"Description": [
			"Lusengo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsg",
		"Description": [
			"Lyons Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsh",
		"Description": [
			"Lish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsi",
		"Description": [
			"Lashi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsl",
		"Description": [
			"Latvian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsm",
		"Description": [
			"Saamia",
			"Olusamia"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lso",
		"Description": [
			"Laos Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsp",
		"Description": [
			"Panamanian Sign Language",
			"Lengua de Señas Panameñas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsr",
		"Description": [
			"Aruop"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lss",
		"Description": [
			"Lasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lst",
		"Description": [
			"Trinidad and Tobago Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lsy",
		"Description": [
			"Mauritian Sign Language"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "ltc",
		"Description": [
			"Late Middle Chinese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ltg",
		"Description": [
			"Latgalian"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "lv"
	},
	{
		"Type": "language",
		"Subtag": "lth",
		"Description": [
			"Thur"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "lti",
		"Description": [
			"Leti (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ltn",
		"Description": [
			"Latundê"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lto",
		"Description": [
			"Tsotso",
			"Olutsotso"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lts",
		"Description": [
			"Tachoni",
			"Lutachoni"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "ltu",
		"Description": [
			"Latu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lua",
		"Description": [
			"Luba-Lulua"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "luc",
		"Description": [
			"Aringa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lud",
		"Description": [
			"Ludian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lue",
		"Description": [
			"Luvale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "luf",
		"Description": [
			"Laua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lui",
		"Description": [
			"Luiseno"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "luj",
		"Description": [
			"Luna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "luk",
		"Description": [
			"Lunanakha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lul",
		"Description": [
			"Olu'bo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lum",
		"Description": [
			"Luimbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lun",
		"Description": [
			"Lunda"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "luo",
		"Description": [
			"Luo (Kenya and Tanzania)",
			"Dholuo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lup",
		"Description": [
			"Lumbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "luq",
		"Description": [
			"Lucumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lur",
		"Description": [
			"Laura"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lus",
		"Description": [
			"Lushai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "lut",
		"Description": [
			"Lushootseed"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "luu",
		"Description": [
			"Lumba-Yakkha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "luv",
		"Description": [
			"Luwati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "luw",
		"Description": [
			"Luo (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "luy",
		"Description": [
			"Luyia",
			"Oluluyia"
		],
		"Added": "2009-07-29",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "luz",
		"Description": [
			"Southern Luri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lva",
		"Description": [
			"Maku'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lvk",
		"Description": [
			"Lavukaleve"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lvs",
		"Description": [
			"Standard Latvian"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "lv"
	},
	{
		"Type": "language",
		"Subtag": "lvu",
		"Description": [
			"Levuka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwa",
		"Description": [
			"Lwalu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwe",
		"Description": [
			"Lewo Eleng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwg",
		"Description": [
			"Wanga",
			"Oluwanga"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "lwh",
		"Description": [
			"White Lachi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwl",
		"Description": [
			"Eastern Lawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwm",
		"Description": [
			"Laomian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwo",
		"Description": [
			"Luwo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwt",
		"Description": [
			"Lewotobi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lwu",
		"Description": [
			"Lawu"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "lww",
		"Description": [
			"Lewo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lya",
		"Description": [
			"Layakha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lyg",
		"Description": [
			"Lyngngam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lyn",
		"Description": [
			"Luyana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lzh",
		"Description": [
			"Literary Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "lzl",
		"Description": [
			"Litzlitz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lzn",
		"Description": [
			"Leinong Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "lzz",
		"Description": [
			"Laz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "maa",
		"Description": [
			"San Jerónimo Tecóatl Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mab",
		"Description": [
			"Yutanduchi Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mad",
		"Description": [
			"Madurese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mae",
		"Description": [
			"Bo-Rukul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "maf",
		"Description": [
			"Mafa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mag",
		"Description": [
			"Magahi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mai",
		"Description": [
			"Maithili"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Deva"
	},
	{
		"Type": "language",
		"Subtag": "maj",
		"Description": [
			"Jalapa De Díaz Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mak",
		"Description": [
			"Makasar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mam",
		"Description": [
			"Mam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "man",
		"Description": [
			"Mandingo",
			"Manding"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "map",
		"Description": [
			"Austronesian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "maq",
		"Description": [
			"Chiquihuitlán Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mas",
		"Description": [
			"Masai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mat",
		"Description": [
			"San Francisco Matlatzinca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mau",
		"Description": [
			"Huautla Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mav",
		"Description": [
			"Sateré-Mawé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "maw",
		"Description": [
			"Mampruli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "max",
		"Description": [
			"North Moluccan Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "maz",
		"Description": [
			"Central Mazahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mba",
		"Description": [
			"Higaonon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbb",
		"Description": [
			"Western Bukidnon Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbc",
		"Description": [
			"Macushi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbd",
		"Description": [
			"Dibabawon Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbe",
		"Description": [
			"Molale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbf",
		"Description": [
			"Baba Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbh",
		"Description": [
			"Mangseng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbi",
		"Description": [
			"Ilianen Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbj",
		"Description": [
			"Nadëb"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbk",
		"Description": [
			"Malol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbl",
		"Description": [
			"Maxakalí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbm",
		"Description": [
			"Ombamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbn",
		"Description": [
			"Macaguán"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbo",
		"Description": [
			"Mbo (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbp",
		"Description": [
			"Malayo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbq",
		"Description": [
			"Maisin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbr",
		"Description": [
			"Nukak Makú"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbs",
		"Description": [
			"Sarangani Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbt",
		"Description": [
			"Matigsalug Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbu",
		"Description": [
			"Mbula-Bwazza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbv",
		"Description": [
			"Mbulungish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbw",
		"Description": [
			"Maring"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbx",
		"Description": [
			"Mari (East Sepik Province)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mby",
		"Description": [
			"Memoni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mbz",
		"Description": [
			"Amoltepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mca",
		"Description": [
			"Maca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcb",
		"Description": [
			"Machiguenga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcc",
		"Description": [
			"Bitur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcd",
		"Description": [
			"Sharanahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mce",
		"Description": [
			"Itundujia Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcf",
		"Description": [
			"Matsés"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcg",
		"Description": [
			"Mapoyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mch",
		"Description": [
			"Maquiritari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mci",
		"Description": [
			"Mese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcj",
		"Description": [
			"Mvanip"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mck",
		"Description": [
			"Mbunda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcl",
		"Description": [
			"Macaguaje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcm",
		"Description": [
			"Malaccan Creole Portuguese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcn",
		"Description": [
			"Masana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mco",
		"Description": [
			"Coatlán Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcp",
		"Description": [
			"Makaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcq",
		"Description": [
			"Ese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcr",
		"Description": [
			"Menya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcs",
		"Description": [
			"Mambai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mct",
		"Description": [
			"Mengisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcu",
		"Description": [
			"Cameroon Mambila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcv",
		"Description": [
			"Minanibai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcw",
		"Description": [
			"Mawa (Chad)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcx",
		"Description": [
			"Mpiemo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcy",
		"Description": [
			"South Watut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mcz",
		"Description": [
			"Mawan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mda",
		"Description": [
			"Mada (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdb",
		"Description": [
			"Morigi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdc",
		"Description": [
			"Male (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdd",
		"Description": [
			"Mbum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mde",
		"Description": [
			"Maba (Chad)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdf",
		"Description": [
			"Moksha"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mdg",
		"Description": [
			"Massalat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdh",
		"Description": [
			"Maguindanaon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdi",
		"Description": [
			"Mamvu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdj",
		"Description": [
			"Mangbetu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdk",
		"Description": [
			"Mangbutu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdl",
		"Description": [
			"Maltese Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdm",
		"Description": [
			"Mayogo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdn",
		"Description": [
			"Mbati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdp",
		"Description": [
			"Mbala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdq",
		"Description": [
			"Mbole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdr",
		"Description": [
			"Mandar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mds",
		"Description": [
			"Maria (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdt",
		"Description": [
			"Mbere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdu",
		"Description": [
			"Mboko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdv",
		"Description": [
			"Santa Lucía Monteverde Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdw",
		"Description": [
			"Mbosi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdx",
		"Description": [
			"Dizin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdy",
		"Description": [
			"Male (Ethiopia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mdz",
		"Description": [
			"Suruí Do Pará"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mea",
		"Description": [
			"Menka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "meb",
		"Description": [
			"Ikobi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mec",
		"Description": [
			"Mara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "med",
		"Description": [
			"Melpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mee",
		"Description": [
			"Mengen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mef",
		"Description": [
			"Megam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "meg",
		"Description": [
			"Mea"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Preferred-Value": "cir"
	},
	{
		"Type": "language",
		"Subtag": "meh",
		"Description": [
			"Southwestern Tlaxiaco Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mei",
		"Description": [
			"Midob"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mej",
		"Description": [
			"Meyah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mek",
		"Description": [
			"Mekeo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mel",
		"Description": [
			"Central Melanau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mem",
		"Description": [
			"Mangala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "men",
		"Description": [
			"Mende (Sierra Leone)"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "meo",
		"Description": [
			"Kedah Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "mep",
		"Description": [
			"Miriwung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "meq",
		"Description": [
			"Merey"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mer",
		"Description": [
			"Meru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mes",
		"Description": [
			"Masmaje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "met",
		"Description": [
			"Mato"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "meu",
		"Description": [
			"Motu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mev",
		"Description": [
			"Mano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mew",
		"Description": [
			"Maaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mey",
		"Description": [
			"Hassaniyya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mez",
		"Description": [
			"Menominee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfa",
		"Description": [
			"Pattani Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "mfb",
		"Description": [
			"Bangka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "mfc",
		"Description": [
			"Mba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfd",
		"Description": [
			"Mendankwe-Nkwen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfe",
		"Description": [
			"Morisyen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mff",
		"Description": [
			"Naki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfg",
		"Description": [
			"Mogofin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfh",
		"Description": [
			"Matal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfi",
		"Description": [
			"Wandala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfj",
		"Description": [
			"Mefele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfk",
		"Description": [
			"North Mofu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfl",
		"Description": [
			"Putai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfm",
		"Description": [
			"Marghi South"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfn",
		"Description": [
			"Cross River Mbembe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfo",
		"Description": [
			"Mbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfp",
		"Description": [
			"Makassar Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfq",
		"Description": [
			"Moba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfr",
		"Description": [
			"Marithiel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfs",
		"Description": [
			"Mexican Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mft",
		"Description": [
			"Mokerang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfu",
		"Description": [
			"Mbwela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfv",
		"Description": [
			"Mandjak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfw",
		"Description": [
			"Mulaha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfx",
		"Description": [
			"Melo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfy",
		"Description": [
			"Mayo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mfz",
		"Description": [
			"Mabaan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mga",
		"Description": [
			"Middle Irish (900-1200)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mgb",
		"Description": [
			"Mararit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgc",
		"Description": [
			"Morokodo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgd",
		"Description": [
			"Moru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mge",
		"Description": [
			"Mango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgf",
		"Description": [
			"Maklew"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgg",
		"Description": [
			"Mpumpong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgh",
		"Description": [
			"Makhuwa-Meetto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgi",
		"Description": [
			"Lijili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgj",
		"Description": [
			"Abureni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgk",
		"Description": [
			"Mawes"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgl",
		"Description": [
			"Maleu-Kilenge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgm",
		"Description": [
			"Mambae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgn",
		"Description": [
			"Mbangi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgo",
		"Description": [
			"Meta'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgp",
		"Description": [
			"Eastern Magar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgq",
		"Description": [
			"Malila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgr",
		"Description": [
			"Mambwe-Lungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgs",
		"Description": [
			"Manda (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgt",
		"Description": [
			"Mongol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgu",
		"Description": [
			"Mailu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgv",
		"Description": [
			"Matengo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgw",
		"Description": [
			"Matumbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgx",
		"Description": [
			"Omati"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see jbk, jmw"
		]
	},
	{
		"Type": "language",
		"Subtag": "mgy",
		"Description": [
			"Mbunga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mgz",
		"Description": [
			"Mbugwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mha",
		"Description": [
			"Manda (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhb",
		"Description": [
			"Mahongwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhc",
		"Description": [
			"Mocho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhd",
		"Description": [
			"Mbugu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhe",
		"Description": [
			"Besisi",
			"Mah Meri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhf",
		"Description": [
			"Mamaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhg",
		"Description": [
			"Margu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhh",
		"Description": [
			"Maskoy Pidgin"
		],
		"Added": "2009-07-29",
		"Deprecated": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "mhi",
		"Description": [
			"Ma'di"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhj",
		"Description": [
			"Mogholi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhk",
		"Description": [
			"Mungaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhl",
		"Description": [
			"Mauwake"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhm",
		"Description": [
			"Makhuwa-Moniga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhn",
		"Description": [
			"Mócheno"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mho",
		"Description": [
			"Mashi (Zambia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhp",
		"Description": [
			"Balinese Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhq",
		"Description": [
			"Mandan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhr",
		"Description": [
			"Eastern Mari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "chm"
	},
	{
		"Type": "language",
		"Subtag": "mhs",
		"Description": [
			"Buru (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mht",
		"Description": [
			"Mandahuaca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhu",
		"Description": [
			"Digaro-Mishmi",
			"Darang Deng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhw",
		"Description": [
			"Mbukushu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhx",
		"Description": [
			"Maru",
			"Lhaovo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhy",
		"Description": [
			"Ma'anyan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mhz",
		"Description": [
			"Mor (Mor Islands)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mia",
		"Description": [
			"Miami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mib",
		"Description": [
			"Atatláhuca Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mic",
		"Description": [
			"Mi'kmaq",
			"Micmac"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mid",
		"Description": [
			"Mandaic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mie",
		"Description": [
			"Ocotepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mif",
		"Description": [
			"Mofu-Gudur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mig",
		"Description": [
			"San Miguel El Grande Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mih",
		"Description": [
			"Chayuco Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mii",
		"Description": [
			"Chigmecatitlán Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mij",
		"Description": [
			"Abar",
			"Mungbam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mik",
		"Description": [
			"Mikasuki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mil",
		"Description": [
			"Peñoles Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mim",
		"Description": [
			"Alacatlatzala Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "min",
		"Description": [
			"Minangkabau"
		],
		"Added": "2005-10-16",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "mio",
		"Description": [
			"Pinotepa Nacional Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mip",
		"Description": [
			"Apasco-Apoala Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "miq",
		"Description": [
			"Mískito"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mir",
		"Description": [
			"Isthmus Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mis",
		"Description": [
			"Uncoded languages"
		],
		"Added": "2005-10-16",
		"Scope": "special"
	},
	{
		"Type": "language",
		"Subtag": "mit",
		"Description": [
			"Southern Puebla Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "miu",
		"Description": [
			"Cacaloxtepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "miw",
		"Description": [
			"Akoye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mix",
		"Description": [
			"Mixtepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "miy",
		"Description": [
			"Ayutla Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "miz",
		"Description": [
			"Coatzospan Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mja",
		"Description": [
			"Mahei"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "mjb",
		"Description": [
			"Makalero"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "mjc",
		"Description": [
			"San Juan Colorado Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjd",
		"Description": [
			"Northwest Maidu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mje",
		"Description": [
			"Muskum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjg",
		"Description": [
			"Tu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjh",
		"Description": [
			"Mwera (Nyasa)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mji",
		"Description": [
			"Kim Mun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjj",
		"Description": [
			"Mawak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjk",
		"Description": [
			"Matukar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjl",
		"Description": [
			"Mandeali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjm",
		"Description": [
			"Medebur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjn",
		"Description": [
			"Ma (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjo",
		"Description": [
			"Malankuravan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjp",
		"Description": [
			"Malapandaram"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjq",
		"Description": [
			"Malaryan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjr",
		"Description": [
			"Malavedan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjs",
		"Description": [
			"Miship"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjt",
		"Description": [
			"Sauria Paharia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mju",
		"Description": [
			"Manna-Dora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjv",
		"Description": [
			"Mannan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjw",
		"Description": [
			"Karbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjx",
		"Description": [
			"Mahali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjy",
		"Description": [
			"Mahican"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mjz",
		"Description": [
			"Majhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mka",
		"Description": [
			"Mbre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkb",
		"Description": [
			"Mal Paharia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkc",
		"Description": [
			"Siliput"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mke",
		"Description": [
			"Mawchi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkf",
		"Description": [
			"Miya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkg",
		"Description": [
			"Mak (China)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkh",
		"Description": [
			"Mon-Khmer languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "mki",
		"Description": [
			"Dhatki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkj",
		"Description": [
			"Mokilese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkk",
		"Description": [
			"Byep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkl",
		"Description": [
			"Mokole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkm",
		"Description": [
			"Moklen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkn",
		"Description": [
			"Kupang Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mko",
		"Description": [
			"Mingang Doso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkp",
		"Description": [
			"Moikodi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkq",
		"Description": [
			"Bay Miwok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkr",
		"Description": [
			"Malas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mks",
		"Description": [
			"Silacayoapan Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkt",
		"Description": [
			"Vamale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mku",
		"Description": [
			"Konyanka Maninka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "man"
	},
	{
		"Type": "language",
		"Subtag": "mkv",
		"Description": [
			"Mafea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkw",
		"Description": [
			"Kituba (Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkx",
		"Description": [
			"Kinamiging Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mky",
		"Description": [
			"East Makian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mkz",
		"Description": [
			"Makasae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mla",
		"Description": [
			"Malo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlb",
		"Description": [
			"Mbule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlc",
		"Description": [
			"Cao Lan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mld",
		"Description": [
			"Malakhel"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "mle",
		"Description": [
			"Manambu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlf",
		"Description": [
			"Mal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlh",
		"Description": [
			"Mape"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mli",
		"Description": [
			"Malimpung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlj",
		"Description": [
			"Miltu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlk",
		"Description": [
			"Ilwana",
			"Kiwilwana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mll",
		"Description": [
			"Malua Bay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlm",
		"Description": [
			"Mulam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mln",
		"Description": [
			"Malango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlo",
		"Description": [
			"Mlomp"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlp",
		"Description": [
			"Bargam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlq",
		"Description": [
			"Western Maninkakan"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "man"
	},
	{
		"Type": "language",
		"Subtag": "mlr",
		"Description": [
			"Vame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mls",
		"Description": [
			"Masalit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlu",
		"Description": [
			"To'abaita"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlv",
		"Description": [
			"Motlav",
			"Mwotlap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlw",
		"Description": [
			"Moloko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlx",
		"Description": [
			"Malfaxal",
			"Naha'ai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mlz",
		"Description": [
			"Malaynon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mma",
		"Description": [
			"Mama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmb",
		"Description": [
			"Momina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmc",
		"Description": [
			"Michoacán Mazahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmd",
		"Description": [
			"Maonan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mme",
		"Description": [
			"Mae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmf",
		"Description": [
			"Mundat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmg",
		"Description": [
			"North Ambrym"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmh",
		"Description": [
			"Mehináku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmi",
		"Description": [
			"Musar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmj",
		"Description": [
			"Majhwar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmk",
		"Description": [
			"Mukha-Dora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mml",
		"Description": [
			"Man Met"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmm",
		"Description": [
			"Maii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmn",
		"Description": [
			"Mamanwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmo",
		"Description": [
			"Mangga Buang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmp",
		"Description": [
			"Siawi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmq",
		"Description": [
			"Musak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmr",
		"Description": [
			"Western Xiangxi Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "mmt",
		"Description": [
			"Malalamai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmu",
		"Description": [
			"Mmaala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmv",
		"Description": [
			"Miriti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmw",
		"Description": [
			"Emae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmx",
		"Description": [
			"Madak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmy",
		"Description": [
			"Migaama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mmz",
		"Description": [
			"Mabaale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mna",
		"Description": [
			"Mbula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnb",
		"Description": [
			"Muna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnc",
		"Description": [
			"Manchu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mnd",
		"Description": [
			"Mondé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mne",
		"Description": [
			"Naba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnf",
		"Description": [
			"Mundani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mng",
		"Description": [
			"Eastern Mnong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnh",
		"Description": [
			"Mono (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mni",
		"Description": [
			"Manipuri"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mnj",
		"Description": [
			"Munji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnk",
		"Description": [
			"Mandinka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "man"
	},
	{
		"Type": "language",
		"Subtag": "mnl",
		"Description": [
			"Tiale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnm",
		"Description": [
			"Mapena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnn",
		"Description": [
			"Southern Mnong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mno",
		"Description": [
			"Manobo languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "mnp",
		"Description": [
			"Min Bei Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "mnq",
		"Description": [
			"Minriq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnr",
		"Description": [
			"Mono (USA)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mns",
		"Description": [
			"Mansi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnt",
		"Description": [
			"Maykulan"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see wnn, xyj, xyk, xyt"
		]
	},
	{
		"Type": "language",
		"Subtag": "mnu",
		"Description": [
			"Mer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnv",
		"Description": [
			"Rennell-Bellona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnw",
		"Description": [
			"Mon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnx",
		"Description": [
			"Manikion"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mny",
		"Description": [
			"Manyawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mnz",
		"Description": [
			"Moni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moa",
		"Description": [
			"Mwan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moc",
		"Description": [
			"Mocoví"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mod",
		"Description": [
			"Mobilian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moe",
		"Description": [
			"Montagnais"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mof",
		"Description": [
			"Mohegan-Montauk-Narragansett"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see xnt, xpq"
		]
	},
	{
		"Type": "language",
		"Subtag": "mog",
		"Description": [
			"Mongondow"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moh",
		"Description": [
			"Mohawk"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "moi",
		"Description": [
			"Mboi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moj",
		"Description": [
			"Monzombo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mok",
		"Description": [
			"Morori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mom",
		"Description": [
			"Mangue"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moo",
		"Description": [
			"Monom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mop",
		"Description": [
			"Mopán Maya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moq",
		"Description": [
			"Mor (Bomberai Peninsula)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mor",
		"Description": [
			"Moro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mos",
		"Description": [
			"Mossi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mot",
		"Description": [
			"Barí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mou",
		"Description": [
			"Mogum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mov",
		"Description": [
			"Mohave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mow",
		"Description": [
			"Moi (Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mox",
		"Description": [
			"Molima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moy",
		"Description": [
			"Shekkacho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "moz",
		"Description": [
			"Mukulu",
			"Gergiko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpa",
		"Description": [
			"Mpoto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpb",
		"Description": [
			"Mullukmulluk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpc",
		"Description": [
			"Mangarayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpd",
		"Description": [
			"Machinere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpe",
		"Description": [
			"Majang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpg",
		"Description": [
			"Marba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mph",
		"Description": [
			"Maung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpi",
		"Description": [
			"Mpade"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpj",
		"Description": [
			"Martu Wangka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpk",
		"Description": [
			"Mbara (Chad)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpl",
		"Description": [
			"Middle Watut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpm",
		"Description": [
			"Yosondúa Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpn",
		"Description": [
			"Mindiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpo",
		"Description": [
			"Miu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpp",
		"Description": [
			"Migabac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpq",
		"Description": [
			"Matís"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpr",
		"Description": [
			"Vangunu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mps",
		"Description": [
			"Dadibi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpt",
		"Description": [
			"Mian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpu",
		"Description": [
			"Makuráp"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpv",
		"Description": [
			"Mungkip"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpw",
		"Description": [
			"Mapidian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpx",
		"Description": [
			"Misima-Panaeati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpy",
		"Description": [
			"Mapia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mpz",
		"Description": [
			"Mpi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqa",
		"Description": [
			"Maba (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqb",
		"Description": [
			"Mbuko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqc",
		"Description": [
			"Mangole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqe",
		"Description": [
			"Matepi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqf",
		"Description": [
			"Momuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqg",
		"Description": [
			"Kota Bangun Kutai Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "mqh",
		"Description": [
			"Tlazoyaltepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqi",
		"Description": [
			"Mariri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqj",
		"Description": [
			"Mamasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqk",
		"Description": [
			"Rajah Kabunsuwan Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mql",
		"Description": [
			"Mbelime"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqm",
		"Description": [
			"South Marquesan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqn",
		"Description": [
			"Moronene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqo",
		"Description": [
			"Modole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqp",
		"Description": [
			"Manipa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqq",
		"Description": [
			"Minokok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqr",
		"Description": [
			"Mander"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqs",
		"Description": [
			"West Makian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqt",
		"Description": [
			"Mok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqu",
		"Description": [
			"Mandari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqv",
		"Description": [
			"Mosimo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqw",
		"Description": [
			"Murupi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqx",
		"Description": [
			"Mamuju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqy",
		"Description": [
			"Manggarai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mqz",
		"Description": [
			"Pano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mra",
		"Description": [
			"Mlabri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrb",
		"Description": [
			"Marino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrc",
		"Description": [
			"Maricopa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrd",
		"Description": [
			"Western Magar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mre",
		"Description": [
			"Martha's Vineyard Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrf",
		"Description": [
			"Elseng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrg",
		"Description": [
			"Mising"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrh",
		"Description": [
			"Mara Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrj",
		"Description": [
			"Western Mari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "chm"
	},
	{
		"Type": "language",
		"Subtag": "mrk",
		"Description": [
			"Hmwaveke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrl",
		"Description": [
			"Mortlockese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrm",
		"Description": [
			"Merlav",
			"Mwerlap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrn",
		"Description": [
			"Cheke Holo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mro",
		"Description": [
			"Mru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrp",
		"Description": [
			"Morouas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrq",
		"Description": [
			"North Marquesan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrr",
		"Description": [
			"Maria (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrs",
		"Description": [
			"Maragus"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrt",
		"Description": [
			"Marghi Central"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mru",
		"Description": [
			"Mono (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrv",
		"Description": [
			"Mangareva"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrw",
		"Description": [
			"Maranao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrx",
		"Description": [
			"Maremgi",
			"Dineor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mry",
		"Description": [
			"Mandaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mrz",
		"Description": [
			"Marind"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msb",
		"Description": [
			"Masbatenyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msc",
		"Description": [
			"Sankaran Maninka"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "man"
	},
	{
		"Type": "language",
		"Subtag": "msd",
		"Description": [
			"Yucatec Maya Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mse",
		"Description": [
			"Musey"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msf",
		"Description": [
			"Mekwei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msg",
		"Description": [
			"Moraid"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msh",
		"Description": [
			"Masikoro Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "msi",
		"Description": [
			"Sabah Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "msj",
		"Description": [
			"Ma (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msk",
		"Description": [
			"Mansaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msl",
		"Description": [
			"Molof",
			"Poule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msm",
		"Description": [
			"Agusan Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msn",
		"Description": [
			"Vurës"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mso",
		"Description": [
			"Mombum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msp",
		"Description": [
			"Maritsauá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msq",
		"Description": [
			"Caac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msr",
		"Description": [
			"Mongolian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mss",
		"Description": [
			"West Masela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mst",
		"Description": [
			"Cataelano Mandaya"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "mry"
	},
	{
		"Type": "language",
		"Subtag": "msu",
		"Description": [
			"Musom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msv",
		"Description": [
			"Maslam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msw",
		"Description": [
			"Mansoanka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msx",
		"Description": [
			"Moresada"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msy",
		"Description": [
			"Aruamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "msz",
		"Description": [
			"Momare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mta",
		"Description": [
			"Cotabato Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtb",
		"Description": [
			"Anyin Morofo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtc",
		"Description": [
			"Munit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtd",
		"Description": [
			"Mualang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mte",
		"Description": [
			"Mono (Solomon Islands)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtf",
		"Description": [
			"Murik (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtg",
		"Description": [
			"Una"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mth",
		"Description": [
			"Munggui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mti",
		"Description": [
			"Maiwa (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtj",
		"Description": [
			"Moskona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtk",
		"Description": [
			"Mbe'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtl",
		"Description": [
			"Montol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtm",
		"Description": [
			"Mator"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtn",
		"Description": [
			"Matagalpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mto",
		"Description": [
			"Totontepec Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtp",
		"Description": [
			"Wichí Lhamtés Nocten"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtq",
		"Description": [
			"Muong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtr",
		"Description": [
			"Mewari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mwr"
	},
	{
		"Type": "language",
		"Subtag": "mts",
		"Description": [
			"Yora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtt",
		"Description": [
			"Mota"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtu",
		"Description": [
			"Tututepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtv",
		"Description": [
			"Asaro'o"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtw",
		"Description": [
			"Southern Binukidnon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mtx",
		"Description": [
			"Tidaá Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mty",
		"Description": [
			"Nabi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mua",
		"Description": [
			"Mundang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mub",
		"Description": [
			"Mubi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "muc",
		"Description": [
			"Ajumbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mud",
		"Description": [
			"Mednyj Aleut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mue",
		"Description": [
			"Media Lengua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mug",
		"Description": [
			"Musgu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "muh",
		"Description": [
			"Mündü"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mui",
		"Description": [
			"Musi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "muj",
		"Description": [
			"Mabire"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "muk",
		"Description": [
			"Mugom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mul",
		"Description": [
			"Multiple languages"
		],
		"Added": "2005-10-16",
		"Scope": "special"
	},
	{
		"Type": "language",
		"Subtag": "mum",
		"Description": [
			"Maiwala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mun",
		"Description": [
			"Munda languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "muo",
		"Description": [
			"Nyong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mup",
		"Description": [
			"Malvi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "raj"
	},
	{
		"Type": "language",
		"Subtag": "muq",
		"Description": [
			"Eastern Xiangxi Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "mur",
		"Description": [
			"Murle"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mus",
		"Description": [
			"Creek"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mut",
		"Description": [
			"Western Muria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "muu",
		"Description": [
			"Yaaku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "muv",
		"Description": [
			"Muthuvan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mux",
		"Description": [
			"Bo-Ung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "muy",
		"Description": [
			"Muyang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "muz",
		"Description": [
			"Mursi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mva",
		"Description": [
			"Manam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvb",
		"Description": [
			"Mattole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvd",
		"Description": [
			"Mamboru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mve",
		"Description": [
			"Marwari (Pakistan)"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mwr"
	},
	{
		"Type": "language",
		"Subtag": "mvf",
		"Description": [
			"Peripheral Mongolian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mn"
	},
	{
		"Type": "language",
		"Subtag": "mvg",
		"Description": [
			"Yucuañe Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvh",
		"Description": [
			"Mulgi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvi",
		"Description": [
			"Miyako"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvk",
		"Description": [
			"Mekmek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvl",
		"Description": [
			"Mbara (Australia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvm",
		"Description": [
			"Muya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvn",
		"Description": [
			"Minaveha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvo",
		"Description": [
			"Marovo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvp",
		"Description": [
			"Duri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvq",
		"Description": [
			"Moere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvr",
		"Description": [
			"Marau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvs",
		"Description": [
			"Massep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvt",
		"Description": [
			"Mpotovoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvu",
		"Description": [
			"Marfa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvv",
		"Description": [
			"Tagal Murut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvw",
		"Description": [
			"Machinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvx",
		"Description": [
			"Meoswar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvy",
		"Description": [
			"Indus Kohistani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mvz",
		"Description": [
			"Mesqan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwa",
		"Description": [
			"Mwatebu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwb",
		"Description": [
			"Juwal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwc",
		"Description": [
			"Are"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwd",
		"Description": [
			"Mudbura"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see dmw, xrq"
		]
	},
	{
		"Type": "language",
		"Subtag": "mwe",
		"Description": [
			"Mwera (Chimwera)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwf",
		"Description": [
			"Murrinh-Patha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwg",
		"Description": [
			"Aiklep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwh",
		"Description": [
			"Mouk-Aria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwi",
		"Description": [
			"Labo",
			"Ninde"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwj",
		"Description": [
			"Maligo"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "vaj"
	},
	{
		"Type": "language",
		"Subtag": "mwk",
		"Description": [
			"Kita Maninkakan"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "man"
	},
	{
		"Type": "language",
		"Subtag": "mwl",
		"Description": [
			"Mirandese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "mwm",
		"Description": [
			"Sar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwn",
		"Description": [
			"Nyamwanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwo",
		"Description": [
			"Central Maewo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwp",
		"Description": [
			"Kala Lagaw Ya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwq",
		"Description": [
			"Mün Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwr",
		"Description": [
			"Marwari"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "mws",
		"Description": [
			"Mwimbi-Muthambi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwt",
		"Description": [
			"Moken"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwu",
		"Description": [
			"Mittu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwv",
		"Description": [
			"Mentawai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mww",
		"Description": [
			"Hmong Daw"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "mwx",
		"Description": [
			"Mediak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwy",
		"Description": [
			"Mosiro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mwz",
		"Description": [
			"Moingi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxa",
		"Description": [
			"Northwest Oaxaca Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxb",
		"Description": [
			"Tezoatlán Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxc",
		"Description": [
			"Manyika"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxd",
		"Description": [
			"Modang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxe",
		"Description": [
			"Mele-Fila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxf",
		"Description": [
			"Malgbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxg",
		"Description": [
			"Mbangala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxh",
		"Description": [
			"Mvuba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxi",
		"Description": [
			"Mozarabic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxj",
		"Description": [
			"Miju-Mishmi",
			"Geman Deng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxk",
		"Description": [
			"Monumbo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxl",
		"Description": [
			"Maxi Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxm",
		"Description": [
			"Meramera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxn",
		"Description": [
			"Moi (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxo",
		"Description": [
			"Mbowe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxp",
		"Description": [
			"Tlahuitoltepec Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxq",
		"Description": [
			"Juquila Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxr",
		"Description": [
			"Murik (Malaysia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxs",
		"Description": [
			"Huitepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxt",
		"Description": [
			"Jamiltepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxu",
		"Description": [
			"Mada (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxv",
		"Description": [
			"Metlatónoc Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxw",
		"Description": [
			"Namo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxx",
		"Description": [
			"Mahou",
			"Mawukakan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxy",
		"Description": [
			"Southeastern Nochixtlán Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mxz",
		"Description": [
			"Central Masela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myb",
		"Description": [
			"Mbay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myc",
		"Description": [
			"Mayeka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myd",
		"Description": [
			"Maramba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mye",
		"Description": [
			"Myene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myf",
		"Description": [
			"Bambassi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myg",
		"Description": [
			"Manta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myh",
		"Description": [
			"Makah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myi",
		"Description": [
			"Mina (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myj",
		"Description": [
			"Mangayat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myk",
		"Description": [
			"Mamara Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myl",
		"Description": [
			"Moma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mym",
		"Description": [
			"Me'en"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myn",
		"Description": [
			"Mayan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "myo",
		"Description": [
			"Anfillo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myp",
		"Description": [
			"Pirahã"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myq",
		"Description": [
			"Forest Maninka"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Macrolanguage": "man"
	},
	{
		"Type": "language",
		"Subtag": "myr",
		"Description": [
			"Muniche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mys",
		"Description": [
			"Mesmes"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myt",
		"Description": [
			"Sangab Mandaya"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "mry"
	},
	{
		"Type": "language",
		"Subtag": "myu",
		"Description": [
			"Mundurukú"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myv",
		"Description": [
			"Erzya"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "myw",
		"Description": [
			"Muyuw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myx",
		"Description": [
			"Masaaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myy",
		"Description": [
			"Macuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "myz",
		"Description": [
			"Classical Mandaic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mza",
		"Description": [
			"Santa María Zacatepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzb",
		"Description": [
			"Tumzabt"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzc",
		"Description": [
			"Madagascar Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzd",
		"Description": [
			"Malimba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mze",
		"Description": [
			"Morawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzg",
		"Description": [
			"Monastic Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzh",
		"Description": [
			"Wichí Lhamtés Güisnay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzi",
		"Description": [
			"Ixcatlán Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzj",
		"Description": [
			"Manya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzk",
		"Description": [
			"Nigeria Mambila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzl",
		"Description": [
			"Mazatlán Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzm",
		"Description": [
			"Mumuye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzn",
		"Description": [
			"Mazanderani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzo",
		"Description": [
			"Matipuhy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzp",
		"Description": [
			"Movima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzq",
		"Description": [
			"Mori Atas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzr",
		"Description": [
			"Marúbo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzs",
		"Description": [
			"Macanese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzt",
		"Description": [
			"Mintil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzu",
		"Description": [
			"Inapang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzv",
		"Description": [
			"Manza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzw",
		"Description": [
			"Deg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzx",
		"Description": [
			"Mawayana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzy",
		"Description": [
			"Mozambican Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "mzz",
		"Description": [
			"Maiadomu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "naa",
		"Description": [
			"Namla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nab",
		"Description": [
			"Southern Nambikuára"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nac",
		"Description": [
			"Narak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nad",
		"Description": [
			"Nijadali"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "xny"
	},
	{
		"Type": "language",
		"Subtag": "nae",
		"Description": [
			"Naka'ela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "naf",
		"Description": [
			"Nabak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nag",
		"Description": [
			"Naga Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nah",
		"Description": [
			"Nahuatl languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "nai",
		"Description": [
			"North American Indian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "naj",
		"Description": [
			"Nalu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nak",
		"Description": [
			"Nakanai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nal",
		"Description": [
			"Nalik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nam",
		"Description": [
			"Ngan'gityemerri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nan",
		"Description": [
			"Min Nan Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "nao",
		"Description": [
			"Naaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nap",
		"Description": [
			"Neapolitan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "naq",
		"Description": [
			"Khoekhoe",
			"Nama (Namibia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nar",
		"Description": [
			"Iguta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nas",
		"Description": [
			"Naasioi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nat",
		"Description": [
			"Ca̱hungwa̱rya̱",
			"Hungworo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "naw",
		"Description": [
			"Nawuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nax",
		"Description": [
			"Nakwi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nay",
		"Description": [
			"Narrinyeri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "naz",
		"Description": [
			"Coatepec Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nba",
		"Description": [
			"Nyemba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbb",
		"Description": [
			"Ndoe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbc",
		"Description": [
			"Chang Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbd",
		"Description": [
			"Ngbinda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbe",
		"Description": [
			"Konyak Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbf",
		"Description": [
			"Naxi"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16",
		"Comments": [
			"see nru, nxq"
		]
	},
	{
		"Type": "language",
		"Subtag": "nbg",
		"Description": [
			"Nagarchal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbh",
		"Description": [
			"Ngamo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbi",
		"Description": [
			"Mao Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbj",
		"Description": [
			"Ngarinman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbk",
		"Description": [
			"Nake"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbm",
		"Description": [
			"Ngbaka Ma'bo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbn",
		"Description": [
			"Kuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbo",
		"Description": [
			"Nkukoli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbp",
		"Description": [
			"Nnam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbq",
		"Description": [
			"Nggem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbr",
		"Description": [
			"Numana-Nunku-Gbantu-Numbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbs",
		"Description": [
			"Namibian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbt",
		"Description": [
			"Na"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbu",
		"Description": [
			"Rongmei Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbv",
		"Description": [
			"Ngamambo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbw",
		"Description": [
			"Southern Ngbandi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nbx",
		"Description": [
			"Ngura"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see ekc, gll, jbi, xpt, xwk"
		]
	},
	{
		"Type": "language",
		"Subtag": "nby",
		"Description": [
			"Ningera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nca",
		"Description": [
			"Iyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncb",
		"Description": [
			"Central Nicobarese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncc",
		"Description": [
			"Ponam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncd",
		"Description": [
			"Nachering"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nce",
		"Description": [
			"Yale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncf",
		"Description": [
			"Notsi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncg",
		"Description": [
			"Nisga'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nch",
		"Description": [
			"Central Huasteca Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nci",
		"Description": [
			"Classical Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncj",
		"Description": [
			"Northern Puebla Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nck",
		"Description": [
			"Nakara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncl",
		"Description": [
			"Michoacán Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncm",
		"Description": [
			"Nambo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncn",
		"Description": [
			"Nauna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nco",
		"Description": [
			"Sibe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncp",
		"Description": [
			"Ndaktup"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncq",
		"Description": [
			"Northern Katang"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "ncr",
		"Description": [
			"Ncane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncs",
		"Description": [
			"Nicaraguan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nct",
		"Description": [
			"Chothe Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncu",
		"Description": [
			"Chumburung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncx",
		"Description": [
			"Central Puebla Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ncz",
		"Description": [
			"Natchez"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nda",
		"Description": [
			"Ndasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndb",
		"Description": [
			"Kenswei Nsei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndc",
		"Description": [
			"Ndau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndd",
		"Description": [
			"Nde-Nsele-Nta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndf",
		"Description": [
			"Nadruvian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndg",
		"Description": [
			"Ndengereko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndh",
		"Description": [
			"Ndali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndi",
		"Description": [
			"Samba Leko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndj",
		"Description": [
			"Ndamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndk",
		"Description": [
			"Ndaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndl",
		"Description": [
			"Ndolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndm",
		"Description": [
			"Ndam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndn",
		"Description": [
			"Ngundi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndp",
		"Description": [
			"Ndo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndq",
		"Description": [
			"Ndombe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndr",
		"Description": [
			"Ndoola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nds",
		"Description": [
			"Low German",
			"Low Saxon"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ndt",
		"Description": [
			"Ndunga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndu",
		"Description": [
			"Dugun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndv",
		"Description": [
			"Ndut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndw",
		"Description": [
			"Ndobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndx",
		"Description": [
			"Nduga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndy",
		"Description": [
			"Lutos"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ndz",
		"Description": [
			"Ndogo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nea",
		"Description": [
			"Eastern Ngad'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "neb",
		"Description": [
			"Toura (Côte d'Ivoire)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nec",
		"Description": [
			"Nedebang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ned",
		"Description": [
			"Nde-Gbite"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nee",
		"Description": [
			"Nêlêmwa-Nixumwak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nef",
		"Description": [
			"Nefamese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "neg",
		"Description": [
			"Negidal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "neh",
		"Description": [
			"Nyenkha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nei",
		"Description": [
			"Neo-Hittite"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nej",
		"Description": [
			"Neko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nek",
		"Description": [
			"Neku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nem",
		"Description": [
			"Nemi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nen",
		"Description": [
			"Nengone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "neo",
		"Description": [
			"Ná-Meo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "neq",
		"Description": [
			"North Central Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ner",
		"Description": [
			"Yahadian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nes",
		"Description": [
			"Bhoti Kinnauri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "net",
		"Description": [
			"Nete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "neu",
		"Description": [
			"Neo"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nev",
		"Description": [
			"Nyaheun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "new",
		"Description": [
			"Newari",
			"Nepal Bhasa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nex",
		"Description": [
			"Neme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ney",
		"Description": [
			"Neyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nez",
		"Description": [
			"Nez Perce"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nfa",
		"Description": [
			"Dhao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nfd",
		"Description": [
			"Ahwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nfl",
		"Description": [
			"Ayiwo",
			"Äiwoo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nfr",
		"Description": [
			"Nafaanra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nfu",
		"Description": [
			"Mfumte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nga",
		"Description": [
			"Ngbaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngb",
		"Description": [
			"Northern Ngbandi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngc",
		"Description": [
			"Ngombe (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngd",
		"Description": [
			"Ngando (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nge",
		"Description": [
			"Ngemba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngf",
		"Description": [
			"Trans-New Guinea languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ngg",
		"Description": [
			"Ngbaka Manza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngh",
		"Description": [
			"N/u",
			"Nǀu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngi",
		"Description": [
			"Ngizim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngj",
		"Description": [
			"Ngie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngk",
		"Description": [
			"Dalabon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngl",
		"Description": [
			"Lomwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngm",
		"Description": [
			"Ngatik Men's Creole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngn",
		"Description": [
			"Ngwo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngo",
		"Description": [
			"Ngoni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngp",
		"Description": [
			"Ngulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngq",
		"Description": [
			"Ngurimi",
			"Ngoreme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngr",
		"Description": [
			"Engdewu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngs",
		"Description": [
			"Gvoko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngt",
		"Description": [
			"Kriang",
			"Ngeq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngu",
		"Description": [
			"Guerrero Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngv",
		"Description": [
			"Nagumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngw",
		"Description": [
			"Ngwaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngx",
		"Description": [
			"Nggwahyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngy",
		"Description": [
			"Tibea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ngz",
		"Description": [
			"Ngungwel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nha",
		"Description": [
			"Nhanda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhb",
		"Description": [
			"Beng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhc",
		"Description": [
			"Tabasco Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhd",
		"Description": [
			"Chiripá",
			"Ava Guaraní"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "gn"
	},
	{
		"Type": "language",
		"Subtag": "nhe",
		"Description": [
			"Eastern Huasteca Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhf",
		"Description": [
			"Nhuwala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhg",
		"Description": [
			"Tetelcingo Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhh",
		"Description": [
			"Nahari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhi",
		"Description": [
			"Zacatlán-Ahuacatlán-Tepetzintla Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhk",
		"Description": [
			"Isthmus-Cosoleacaque Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhm",
		"Description": [
			"Morelos Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhn",
		"Description": [
			"Central Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nho",
		"Description": [
			"Takuu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhp",
		"Description": [
			"Isthmus-Pajapan Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhq",
		"Description": [
			"Huaxcaleca Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhr",
		"Description": [
			"Naro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nht",
		"Description": [
			"Ometepec Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhu",
		"Description": [
			"Noone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhv",
		"Description": [
			"Temascaltepec Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhw",
		"Description": [
			"Western Huasteca Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhx",
		"Description": [
			"Isthmus-Mecayapan Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhy",
		"Description": [
			"Northern Oaxaca Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nhz",
		"Description": [
			"Santa María La Alta Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nia",
		"Description": [
			"Nias"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nib",
		"Description": [
			"Nakame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nic",
		"Description": [
			"Niger-Kordofanian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "nid",
		"Description": [
			"Ngandi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nie",
		"Description": [
			"Niellim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nif",
		"Description": [
			"Nek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nig",
		"Description": [
			"Ngalakan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nih",
		"Description": [
			"Nyiha (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nii",
		"Description": [
			"Nii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nij",
		"Description": [
			"Ngaju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nik",
		"Description": [
			"Southern Nicobarese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nil",
		"Description": [
			"Nila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nim",
		"Description": [
			"Nilamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nin",
		"Description": [
			"Ninzo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nio",
		"Description": [
			"Nganasan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "niq",
		"Description": [
			"Nandi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "nir",
		"Description": [
			"Nimboran"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nis",
		"Description": [
			"Nimi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nit",
		"Description": [
			"Southeastern Kolami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "niu",
		"Description": [
			"Niuean"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "niv",
		"Description": [
			"Gilyak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "niw",
		"Description": [
			"Nimo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nix",
		"Description": [
			"Hema"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "niy",
		"Description": [
			"Ngiti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "niz",
		"Description": [
			"Ningil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nja",
		"Description": [
			"Nzanyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njb",
		"Description": [
			"Nocte Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njd",
		"Description": [
			"Ndonde Hamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njh",
		"Description": [
			"Lotha Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nji",
		"Description": [
			"Gudanji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njj",
		"Description": [
			"Njen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njl",
		"Description": [
			"Njalgulgule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njm",
		"Description": [
			"Angami Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njn",
		"Description": [
			"Liangmai Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njo",
		"Description": [
			"Ao Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njr",
		"Description": [
			"Njerep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njs",
		"Description": [
			"Nisa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njt",
		"Description": [
			"Ndyuka-Trio Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nju",
		"Description": [
			"Ngadjunmaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njx",
		"Description": [
			"Kunyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njy",
		"Description": [
			"Njyem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "njz",
		"Description": [
			"Nyishi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nka",
		"Description": [
			"Nkoya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkb",
		"Description": [
			"Khoibu Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkc",
		"Description": [
			"Nkongho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkd",
		"Description": [
			"Koireng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nke",
		"Description": [
			"Duke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkf",
		"Description": [
			"Inpui Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkg",
		"Description": [
			"Nekgini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkh",
		"Description": [
			"Khezha Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nki",
		"Description": [
			"Thangal Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkj",
		"Description": [
			"Nakai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkk",
		"Description": [
			"Nokuku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkm",
		"Description": [
			"Namat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkn",
		"Description": [
			"Nkangala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nko",
		"Description": [
			"Nkonya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkp",
		"Description": [
			"Niuatoputapu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkq",
		"Description": [
			"Nkami"
		],
		"Added": "2010-04-16"
	},
	{
		"Type": "language",
		"Subtag": "nkr",
		"Description": [
			"Nukuoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nks",
		"Description": [
			"North Asmat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkt",
		"Description": [
			"Nyika (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nku",
		"Description": [
			"Bouna Kulango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkv",
		"Description": [
			"Nyika (Malawi and Zambia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkw",
		"Description": [
			"Nkutu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkx",
		"Description": [
			"Nkoroo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nkz",
		"Description": [
			"Nkari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nla",
		"Description": [
			"Ngombale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nlc",
		"Description": [
			"Nalca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nle",
		"Description": [
			"East Nyala"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "nlg",
		"Description": [
			"Gela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nli",
		"Description": [
			"Grangali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nlj",
		"Description": [
			"Nyali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nlk",
		"Description": [
			"Ninia Yali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nll",
		"Description": [
			"Nihali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nln",
		"Description": [
			"Durango Nahuatl"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see azd, azn"
		]
	},
	{
		"Type": "language",
		"Subtag": "nlo",
		"Description": [
			"Ngul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nlq",
		"Description": [
			"Lao Naga"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "nlr",
		"Description": [
			"Ngarla"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see nrk, ywg"
		]
	},
	{
		"Type": "language",
		"Subtag": "nlu",
		"Description": [
			"Nchumbulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nlv",
		"Description": [
			"Orizaba Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nlw",
		"Description": [
			"Walangama"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "nlx",
		"Description": [
			"Nahali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nly",
		"Description": [
			"Nyamal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nlz",
		"Description": [
			"Nalögo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nma",
		"Description": [
			"Maram Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmb",
		"Description": [
			"Big Nambas",
			"V'ënen Taut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmc",
		"Description": [
			"Ngam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmd",
		"Description": [
			"Ndumu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nme",
		"Description": [
			"Mzieme Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmf",
		"Description": [
			"Tangkhul Naga (India)"
		],
		"Added": "2009-07-29",
		"Comments": [
			"see ntx"
		]
	},
	{
		"Type": "language",
		"Subtag": "nmg",
		"Description": [
			"Kwasio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmh",
		"Description": [
			"Monsang Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmi",
		"Description": [
			"Nyam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmj",
		"Description": [
			"Ngombe (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmk",
		"Description": [
			"Namakura"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nml",
		"Description": [
			"Ndemli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmm",
		"Description": [
			"Manangba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmn",
		"Description": [
			"!Xóõ",
			"ǃXóõ"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmo",
		"Description": [
			"Moyon Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmp",
		"Description": [
			"Nimanbur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmq",
		"Description": [
			"Nambya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmr",
		"Description": [
			"Nimbari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nms",
		"Description": [
			"Letemboi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmt",
		"Description": [
			"Namonuito"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmu",
		"Description": [
			"Northeast Maidu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmv",
		"Description": [
			"Ngamini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmw",
		"Description": [
			"Nimoa",
			"Rifao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmx",
		"Description": [
			"Nama (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmy",
		"Description": [
			"Namuyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nmz",
		"Description": [
			"Nawdm"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nna",
		"Description": [
			"Nyangumarta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnb",
		"Description": [
			"Nande"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnc",
		"Description": [
			"Nancere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnd",
		"Description": [
			"West Ambae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nne",
		"Description": [
			"Ngandyera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnf",
		"Description": [
			"Ngaing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nng",
		"Description": [
			"Maring Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnh",
		"Description": [
			"Ngiemboon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nni",
		"Description": [
			"North Nuaulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnj",
		"Description": [
			"Nyangatom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnk",
		"Description": [
			"Nankina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnl",
		"Description": [
			"Northern Rengma Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnm",
		"Description": [
			"Namia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnn",
		"Description": [
			"Ngete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnp",
		"Description": [
			"Wancho Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnq",
		"Description": [
			"Ngindo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnr",
		"Description": [
			"Narungga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nns",
		"Description": [
			"Ningye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnt",
		"Description": [
			"Nanticoke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnu",
		"Description": [
			"Dwang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnv",
		"Description": [
			"Nugunu (Australia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnw",
		"Description": [
			"Southern Nuni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnx",
		"Description": [
			"Ngong"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "ngv"
	},
	{
		"Type": "language",
		"Subtag": "nny",
		"Description": [
			"Nyangga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nnz",
		"Description": [
			"Nda'nda'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noa",
		"Description": [
			"Woun Meu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noc",
		"Description": [
			"Nuk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nod",
		"Description": [
			"Northern Thai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noe",
		"Description": [
			"Nimadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nof",
		"Description": [
			"Nomane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nog",
		"Description": [
			"Nogai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "noh",
		"Description": [
			"Nomu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noi",
		"Description": [
			"Noiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noj",
		"Description": [
			"Nonuya"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "nok",
		"Description": [
			"Nooksack"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nol",
		"Description": [
			"Nomlaki"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "nom",
		"Description": [
			"Nocamán"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "non",
		"Description": [
			"Old Norse"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "noo",
		"Description": [
			"Nootka"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16",
		"Comments": [
			"see dtd, nuk"
		]
	},
	{
		"Type": "language",
		"Subtag": "nop",
		"Description": [
			"Numanggang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noq",
		"Description": [
			"Ngongo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nos",
		"Description": [
			"Eastern Nisu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "not",
		"Description": [
			"Nomatsiguenga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nou",
		"Description": [
			"Ewage-Notu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nov",
		"Description": [
			"Novial"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "now",
		"Description": [
			"Nyambo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noy",
		"Description": [
			"Noy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "noz",
		"Description": [
			"Nayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npa",
		"Description": [
			"Nar Phu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npb",
		"Description": [
			"Nupbikha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npg",
		"Description": [
			"Ponyo-Gongwang Naga"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nph",
		"Description": [
			"Phom Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npi",
		"Description": [
			"Nepali (individual language)"
		],
		"Added": "2012-08-12",
		"Macrolanguage": "ne"
	},
	{
		"Type": "language",
		"Subtag": "npl",
		"Description": [
			"Southeastern Puebla Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npn",
		"Description": [
			"Mondropolon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npo",
		"Description": [
			"Pochuri Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nps",
		"Description": [
			"Nipsan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npu",
		"Description": [
			"Puimei Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "npx",
		"Description": [
			"Noipx"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "npy",
		"Description": [
			"Napu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nqg",
		"Description": [
			"Southern Nago"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nqk",
		"Description": [
			"Kura Ede Nago"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nql",
		"Description": [
			"Ngendelengo"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "nqm",
		"Description": [
			"Ndom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nqn",
		"Description": [
			"Nen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nqo",
		"Description": [
			"N'Ko",
			"N’Ko"
		],
		"Added": "2006-06-05",
		"Suppress-Script": "Nkoo"
	},
	{
		"Type": "language",
		"Subtag": "nqq",
		"Description": [
			"Kyan-Karyaw Naga"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "nqy",
		"Description": [
			"Akyaung Ari Naga"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nra",
		"Description": [
			"Ngom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrb",
		"Description": [
			"Nara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrc",
		"Description": [
			"Noric"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nre",
		"Description": [
			"Southern Rengma Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrf",
		"Description": [
			"Jèrriais",
			"Guernésiais"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "nrg",
		"Description": [
			"Narango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nri",
		"Description": [
			"Chokri Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrk",
		"Description": [
			"Ngarla"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "nrl",
		"Description": [
			"Ngarluma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrm",
		"Description": [
			"Narom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrn",
		"Description": [
			"Norn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrp",
		"Description": [
			"North Picene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrr",
		"Description": [
			"Norra",
			"Nora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrt",
		"Description": [
			"Northern Kalapuya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nru",
		"Description": [
			"Narua"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "nrx",
		"Description": [
			"Ngurmbur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nrz",
		"Description": [
			"Lala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsa",
		"Description": [
			"Sangtam Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsc",
		"Description": [
			"Nshi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsd",
		"Description": [
			"Southern Nisu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nse",
		"Description": [
			"Nsenga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsf",
		"Description": [
			"Northwestern Nisu"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nsg",
		"Description": [
			"Ngasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsh",
		"Description": [
			"Ngoshie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsi",
		"Description": [
			"Nigerian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsk",
		"Description": [
			"Naskapi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsl",
		"Description": [
			"Norwegian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsm",
		"Description": [
			"Sumi Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsn",
		"Description": [
			"Nehan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nso",
		"Description": [
			"Pedi",
			"Northern Sotho",
			"Sepedi"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "nsp",
		"Description": [
			"Nepalese Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsq",
		"Description": [
			"Northern Sierra Miwok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsr",
		"Description": [
			"Maritime Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nss",
		"Description": [
			"Nali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nst",
		"Description": [
			"Tase Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsu",
		"Description": [
			"Sierra Negra Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsv",
		"Description": [
			"Southwestern Nisu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsw",
		"Description": [
			"Navut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsx",
		"Description": [
			"Nsongo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsy",
		"Description": [
			"Nasal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nsz",
		"Description": [
			"Nisenan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntd",
		"Description": [
			"Northern Tidung"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "nte",
		"Description": [
			"Nathembo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntg",
		"Description": [
			"Ngantangarra"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "nti",
		"Description": [
			"Natioro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntj",
		"Description": [
			"Ngaanyatjarra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntk",
		"Description": [
			"Ikoma-Nata-Isenye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntm",
		"Description": [
			"Nateni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nto",
		"Description": [
			"Ntomba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntp",
		"Description": [
			"Northern Tepehuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntr",
		"Description": [
			"Delo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nts",
		"Description": [
			"Natagaimas"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "pij"
	},
	{
		"Type": "language",
		"Subtag": "ntu",
		"Description": [
			"Natügu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntw",
		"Description": [
			"Nottoway"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntx",
		"Description": [
			"Tangkhul Naga (Myanmar)"
		],
		"Added": "2012-08-12",
		"Comments": [
			"see nmf"
		]
	},
	{
		"Type": "language",
		"Subtag": "nty",
		"Description": [
			"Mantsi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ntz",
		"Description": [
			"Natanzi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nua",
		"Description": [
			"Yuanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nub",
		"Description": [
			"Nubian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "nuc",
		"Description": [
			"Nukuini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nud",
		"Description": [
			"Ngala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nue",
		"Description": [
			"Ngundu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuf",
		"Description": [
			"Nusu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nug",
		"Description": [
			"Nungali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuh",
		"Description": [
			"Ndunda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nui",
		"Description": [
			"Ngumbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuj",
		"Description": [
			"Nyole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuk",
		"Description": [
			"Nuu-chah-nulth",
			"Nuuchahnulth"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "nul",
		"Description": [
			"Nusa Laut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "num",
		"Description": [
			"Niuafo'ou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nun",
		"Description": [
			"Anong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuo",
		"Description": [
			"Nguôn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nup",
		"Description": [
			"Nupe-Nupe-Tako"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuq",
		"Description": [
			"Nukumanu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nur",
		"Description": [
			"Nukuria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nus",
		"Description": [
			"Nuer"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nut",
		"Description": [
			"Nung (Viet Nam)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuu",
		"Description": [
			"Ngbundu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuv",
		"Description": [
			"Northern Nuni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuw",
		"Description": [
			"Nguluwan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nux",
		"Description": [
			"Mehek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuy",
		"Description": [
			"Nunggubuyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nuz",
		"Description": [
			"Tlamacazapa Nahuatl"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nvh",
		"Description": [
			"Nasarian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nvm",
		"Description": [
			"Namiae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nvo",
		"Description": [
			"Nyokon"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nwa",
		"Description": [
			"Nawathinehena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nwb",
		"Description": [
			"Nyabwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nwc",
		"Description": [
			"Classical Newari",
			"Classical Nepal Bhasa",
			"Old Newari"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nwe",
		"Description": [
			"Ngwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nwg",
		"Description": [
			"Ngayawung"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nwi",
		"Description": [
			"Southwest Tanna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nwm",
		"Description": [
			"Nyamusa-Molo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nwo",
		"Description": [
			"Nauo"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nwr",
		"Description": [
			"Nawaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nwx",
		"Description": [
			"Middle Newar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nwy",
		"Description": [
			"Nottoway-Meherrin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxa",
		"Description": [
			"Nauete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxd",
		"Description": [
			"Ngando (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxe",
		"Description": [
			"Nage"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxg",
		"Description": [
			"Ngad'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxi",
		"Description": [
			"Nindi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxk",
		"Description": [
			"Koki Naga"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "nxl",
		"Description": [
			"South Nuaulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxm",
		"Description": [
			"Numidian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxn",
		"Description": [
			"Ngawun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxo",
		"Description": [
			"Ndambomo"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "nxq",
		"Description": [
			"Naxi"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "nxr",
		"Description": [
			"Ninggerum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxu",
		"Description": [
			"Narau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nxx",
		"Description": [
			"Nafri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyb",
		"Description": [
			"Nyangbo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyc",
		"Description": [
			"Nyanga-li"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyd",
		"Description": [
			"Nyore",
			"Olunyole"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "nye",
		"Description": [
			"Nyengo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyf",
		"Description": [
			"Giryama",
			"Kigiryama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyg",
		"Description": [
			"Nyindu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyh",
		"Description": [
			"Nyigina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyi",
		"Description": [
			"Ama (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyj",
		"Description": [
			"Nyanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyk",
		"Description": [
			"Nyaneka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyl",
		"Description": [
			"Nyeu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nym",
		"Description": [
			"Nyamwezi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nyn",
		"Description": [
			"Nyankole"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nyo",
		"Description": [
			"Nyoro"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nyp",
		"Description": [
			"Nyang'i"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyq",
		"Description": [
			"Nayini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyr",
		"Description": [
			"Nyiha (Malawi)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nys",
		"Description": [
			"Nyunga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyt",
		"Description": [
			"Nyawaygi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyu",
		"Description": [
			"Nyungwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyv",
		"Description": [
			"Nyulnyul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyw",
		"Description": [
			"Nyaw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyx",
		"Description": [
			"Nganyaywana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nyy",
		"Description": [
			"Nyakyusa-Ngonde"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nza",
		"Description": [
			"Tigon Mbembe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nzb",
		"Description": [
			"Njebi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nzi",
		"Description": [
			"Nzima"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "nzk",
		"Description": [
			"Nzakara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nzm",
		"Description": [
			"Zeme Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nzs",
		"Description": [
			"New Zealand Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nzu",
		"Description": [
			"Teke-Nzikou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nzy",
		"Description": [
			"Nzakambay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "nzz",
		"Description": [
			"Nanga Dama Dogon"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "oaa",
		"Description": [
			"Orok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oac",
		"Description": [
			"Oroch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oar",
		"Description": [
			"Old Aramaic (up to 700 BCE)",
			"Ancient Aramaic (up to 700 BCE)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oav",
		"Description": [
			"Old Avar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "obi",
		"Description": [
			"Obispeño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "obk",
		"Description": [
			"Southern Bontok"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bnc"
	},
	{
		"Type": "language",
		"Subtag": "obl",
		"Description": [
			"Oblo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "obm",
		"Description": [
			"Moabite"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "obo",
		"Description": [
			"Obo Manobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "obr",
		"Description": [
			"Old Burmese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "obt",
		"Description": [
			"Old Breton"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "obu",
		"Description": [
			"Obulom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oca",
		"Description": [
			"Ocaina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "och",
		"Description": [
			"Old Chinese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oco",
		"Description": [
			"Old Cornish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ocu",
		"Description": [
			"Atzingo Matlatzinca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oda",
		"Description": [
			"Odut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "odk",
		"Description": [
			"Od"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "odt",
		"Description": [
			"Old Dutch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "odu",
		"Description": [
			"Odual"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ofo",
		"Description": [
			"Ofo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ofs",
		"Description": [
			"Old Frisian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ofu",
		"Description": [
			"Efutop"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ogb",
		"Description": [
			"Ogbia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ogc",
		"Description": [
			"Ogbah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oge",
		"Description": [
			"Old Georgian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ogg",
		"Description": [
			"Ogbogolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ogo",
		"Description": [
			"Khana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ogu",
		"Description": [
			"Ogbronuagum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oht",
		"Description": [
			"Old Hittite"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ohu",
		"Description": [
			"Old Hungarian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oia",
		"Description": [
			"Oirata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oin",
		"Description": [
			"Inebu One"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ojb",
		"Description": [
			"Northwestern Ojibwa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "oj"
	},
	{
		"Type": "language",
		"Subtag": "ojc",
		"Description": [
			"Central Ojibwa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "oj"
	},
	{
		"Type": "language",
		"Subtag": "ojg",
		"Description": [
			"Eastern Ojibwa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "oj"
	},
	{
		"Type": "language",
		"Subtag": "ojp",
		"Description": [
			"Old Japanese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ojs",
		"Description": [
			"Severn Ojibwa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "oj"
	},
	{
		"Type": "language",
		"Subtag": "ojv",
		"Description": [
			"Ontong Java"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ojw",
		"Description": [
			"Western Ojibwa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "oj"
	},
	{
		"Type": "language",
		"Subtag": "oka",
		"Description": [
			"Okanagan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okb",
		"Description": [
			"Okobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okd",
		"Description": [
			"Okodia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oke",
		"Description": [
			"Okpe (Southwestern Edo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okg",
		"Description": [
			"Koko Babangk"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "okh",
		"Description": [
			"Koresh-e Rostam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oki",
		"Description": [
			"Okiek"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "okj",
		"Description": [
			"Oko-Juwoi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okk",
		"Description": [
			"Kwamtim One"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okl",
		"Description": [
			"Old Kentish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okm",
		"Description": [
			"Middle Korean (10th-16th cent.)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okn",
		"Description": [
			"Oki-No-Erabu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oko",
		"Description": [
			"Old Korean (3rd-9th cent.)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okr",
		"Description": [
			"Kirike"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oks",
		"Description": [
			"Oko-Eni-Osayen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oku",
		"Description": [
			"Oku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okv",
		"Description": [
			"Orokaiva"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "okx",
		"Description": [
			"Okpe (Northwestern Edo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ola",
		"Description": [
			"Walungge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "old",
		"Description": [
			"Mochi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ole",
		"Description": [
			"Olekha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "olk",
		"Description": [
			"Olkol"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "olm",
		"Description": [
			"Oloma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "olo",
		"Description": [
			"Livvi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "olr",
		"Description": [
			"Olrat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "olt",
		"Description": [
			"Old Lithuanian"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "olu",
		"Description": [
			"Kuvale"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "oma",
		"Description": [
			"Omaha-Ponca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omb",
		"Description": [
			"East Ambae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omc",
		"Description": [
			"Mochica"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ome",
		"Description": [
			"Omejes"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "omg",
		"Description": [
			"Omagua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omi",
		"Description": [
			"Omi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omk",
		"Description": [
			"Omok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oml",
		"Description": [
			"Ombo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omn",
		"Description": [
			"Minoan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omo",
		"Description": [
			"Utarmbung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omp",
		"Description": [
			"Old Manipuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omq",
		"Description": [
			"Oto-Manguean languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "omr",
		"Description": [
			"Old Marathi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omt",
		"Description": [
			"Omotik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omu",
		"Description": [
			"Omurano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omv",
		"Description": [
			"Omotic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "omw",
		"Description": [
			"South Tairora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "omx",
		"Description": [
			"Old Mon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ona",
		"Description": [
			"Ona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onb",
		"Description": [
			"Lingao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "one",
		"Description": [
			"Oneida"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ong",
		"Description": [
			"Olo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oni",
		"Description": [
			"Onin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onj",
		"Description": [
			"Onjob"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onk",
		"Description": [
			"Kabore One"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onn",
		"Description": [
			"Onobasulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ono",
		"Description": [
			"Onondaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onp",
		"Description": [
			"Sartang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onr",
		"Description": [
			"Northern One"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ons",
		"Description": [
			"Ono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ont",
		"Description": [
			"Ontenu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onu",
		"Description": [
			"Unua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onw",
		"Description": [
			"Old Nubian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "onx",
		"Description": [
			"Onin Based Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ood",
		"Description": [
			"Tohono O'odham"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oog",
		"Description": [
			"Ong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oon",
		"Description": [
			"Önge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oor",
		"Description": [
			"Oorlams"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oos",
		"Description": [
			"Old Ossetic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "opa",
		"Description": [
			"Okpamheri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "opk",
		"Description": [
			"Kopkaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "opm",
		"Description": [
			"Oksapmin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "opo",
		"Description": [
			"Opao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "opt",
		"Description": [
			"Opata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "opy",
		"Description": [
			"Ofayé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ora",
		"Description": [
			"Oroha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "orc",
		"Description": [
			"Orma"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "om"
	},
	{
		"Type": "language",
		"Subtag": "ore",
		"Description": [
			"Orejón"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "org",
		"Description": [
			"Oring"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "orh",
		"Description": [
			"Oroqen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "orn",
		"Description": [
			"Orang Kanaq"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "oro",
		"Description": [
			"Orokolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "orr",
		"Description": [
			"Oruma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ors",
		"Description": [
			"Orang Seletar"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "ort",
		"Description": [
			"Adivasi Oriya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oru",
		"Description": [
			"Ormuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "orv",
		"Description": [
			"Old Russian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "orw",
		"Description": [
			"Oro Win"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "orx",
		"Description": [
			"Oro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ory",
		"Description": [
			"Odia (individual language)",
			"Oriya (individual language)"
		],
		"Added": "2012-08-12",
		"Macrolanguage": "or"
	},
	{
		"Type": "language",
		"Subtag": "orz",
		"Description": [
			"Ormu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "osa",
		"Description": [
			"Osage"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "osc",
		"Description": [
			"Oscan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "osi",
		"Description": [
			"Osing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oso",
		"Description": [
			"Ososo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "osp",
		"Description": [
			"Old Spanish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ost",
		"Description": [
			"Osatu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "osu",
		"Description": [
			"Southern One"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "osx",
		"Description": [
			"Old Saxon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ota",
		"Description": [
			"Ottoman Turkish (1500-1928)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "otb",
		"Description": [
			"Old Tibetan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otd",
		"Description": [
			"Ot Danum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ote",
		"Description": [
			"Mezquital Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oti",
		"Description": [
			"Oti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otk",
		"Description": [
			"Old Turkish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otl",
		"Description": [
			"Tilapa Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otm",
		"Description": [
			"Eastern Highland Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otn",
		"Description": [
			"Tenango Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oto",
		"Description": [
			"Otomian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "otq",
		"Description": [
			"Querétaro Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otr",
		"Description": [
			"Otoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ots",
		"Description": [
			"Estado de México Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ott",
		"Description": [
			"Temoaya Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otu",
		"Description": [
			"Otuke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otw",
		"Description": [
			"Ottawa"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "oj"
	},
	{
		"Type": "language",
		"Subtag": "otx",
		"Description": [
			"Texcatepec Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oty",
		"Description": [
			"Old Tamil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "otz",
		"Description": [
			"Ixtenco Otomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oua",
		"Description": [
			"Tagargrent"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oub",
		"Description": [
			"Glio-Oubi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oue",
		"Description": [
			"Oune"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oui",
		"Description": [
			"Old Uighur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oum",
		"Description": [
			"Ouma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oun",
		"Description": [
			"!O!ung"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "vaj"
	},
	{
		"Type": "language",
		"Subtag": "ovd",
		"Description": [
			"Elfdalian",
			"Övdalian"
		],
		"Added": "2016-06-16"
	},
	{
		"Type": "language",
		"Subtag": "owi",
		"Description": [
			"Owiniga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "owl",
		"Description": [
			"Old Welsh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oyb",
		"Description": [
			"Oy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oyd",
		"Description": [
			"Oyda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oym",
		"Description": [
			"Wayampi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "oyy",
		"Description": [
			"Oya'oya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ozm",
		"Description": [
			"Koonzime"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "paa",
		"Description": [
			"Papuan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "pab",
		"Description": [
			"Parecís"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pac",
		"Description": [
			"Pacoh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pad",
		"Description": [
			"Paumarí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pae",
		"Description": [
			"Pagibete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "paf",
		"Description": [
			"Paranawát"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pag",
		"Description": [
			"Pangasinan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pah",
		"Description": [
			"Tenharim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pai",
		"Description": [
			"Pe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pak",
		"Description": [
			"Parakanã"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pal",
		"Description": [
			"Pahlavi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pam",
		"Description": [
			"Pampanga",
			"Kapampangan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pao",
		"Description": [
			"Northern Paiute"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pap",
		"Description": [
			"Papiamento"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "paq",
		"Description": [
			"Parya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "par",
		"Description": [
			"Panamint",
			"Timbisha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pas",
		"Description": [
			"Papasena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pat",
		"Description": [
			"Papitalai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pau",
		"Description": [
			"Palauan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pav",
		"Description": [
			"Pakaásnovos"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "paw",
		"Description": [
			"Pawnee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pax",
		"Description": [
			"Pankararé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pay",
		"Description": [
			"Pech"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "paz",
		"Description": [
			"Pankararú"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbb",
		"Description": [
			"Páez"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbc",
		"Description": [
			"Patamona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbe",
		"Description": [
			"Mezontla Popoloca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbf",
		"Description": [
			"Coyotepec Popoloca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbg",
		"Description": [
			"Paraujano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbh",
		"Description": [
			"E'ñapa Woromaipu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbi",
		"Description": [
			"Parkwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbl",
		"Description": [
			"Mak (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbn",
		"Description": [
			"Kpasam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbo",
		"Description": [
			"Papel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbp",
		"Description": [
			"Badyara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbr",
		"Description": [
			"Pangwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbs",
		"Description": [
			"Central Pame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbt",
		"Description": [
			"Southern Pashto"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ps"
	},
	{
		"Type": "language",
		"Subtag": "pbu",
		"Description": [
			"Northern Pashto"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ps"
	},
	{
		"Type": "language",
		"Subtag": "pbv",
		"Description": [
			"Pnar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pby",
		"Description": [
			"Pyu (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pbz",
		"Description": [
			"Palu"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "pca",
		"Description": [
			"Santa Inés Ahuatempan Popoloca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcb",
		"Description": [
			"Pear"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcc",
		"Description": [
			"Bouyei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcd",
		"Description": [
			"Picard"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pce",
		"Description": [
			"Ruching Palaung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcf",
		"Description": [
			"Paliyan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcg",
		"Description": [
			"Paniya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pch",
		"Description": [
			"Pardhan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pci",
		"Description": [
			"Duruwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcj",
		"Description": [
			"Parenga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pck",
		"Description": [
			"Paite Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcl",
		"Description": [
			"Pardhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcm",
		"Description": [
			"Nigerian Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcn",
		"Description": [
			"Piti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcp",
		"Description": [
			"Pacahuara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pcr",
		"Description": [
			"Panang"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Preferred-Value": "adx"
	},
	{
		"Type": "language",
		"Subtag": "pcw",
		"Description": [
			"Pyapun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pda",
		"Description": [
			"Anam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pdc",
		"Description": [
			"Pennsylvania German"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pdi",
		"Description": [
			"Pa Di"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pdn",
		"Description": [
			"Podena",
			"Fedan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pdo",
		"Description": [
			"Padoe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pdt",
		"Description": [
			"Plautdietsch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pdu",
		"Description": [
			"Kayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pea",
		"Description": [
			"Peranakan Indonesian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "peb",
		"Description": [
			"Eastern Pomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ped",
		"Description": [
			"Mala (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pee",
		"Description": [
			"Taje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pef",
		"Description": [
			"Northeastern Pomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "peg",
		"Description": [
			"Pengo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "peh",
		"Description": [
			"Bonan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pei",
		"Description": [
			"Chichimeca-Jonaz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pej",
		"Description": [
			"Northern Pomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pek",
		"Description": [
			"Penchal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pel",
		"Description": [
			"Pekal"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "pem",
		"Description": [
			"Phende"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "peo",
		"Description": [
			"Old Persian (ca. 600-400 B.C.)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pep",
		"Description": [
			"Kunja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "peq",
		"Description": [
			"Southern Pomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pes",
		"Description": [
			"Iranian Persian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "fa"
	},
	{
		"Type": "language",
		"Subtag": "pev",
		"Description": [
			"Pémono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pex",
		"Description": [
			"Petats"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pey",
		"Description": [
			"Petjo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pez",
		"Description": [
			"Eastern Penan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pfa",
		"Description": [
			"Pááfang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pfe",
		"Description": [
			"Peere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pfl",
		"Description": [
			"Pfaelzisch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pga",
		"Description": [
			"Sudanese Creole Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "pgd",
		"Description": [
			"Gāndhārī"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "pgg",
		"Description": [
			"Pangwali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pgi",
		"Description": [
			"Pagi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pgk",
		"Description": [
			"Rerep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pgl",
		"Description": [
			"Primitive Irish"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "pgn",
		"Description": [
			"Paelignian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pgs",
		"Description": [
			"Pangseng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pgu",
		"Description": [
			"Pagu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pgy",
		"Description": [
			"Pongyong"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "pgz",
		"Description": [
			"Papua New Guinean Sign Language"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "pha",
		"Description": [
			"Pa-Hng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phd",
		"Description": [
			"Phudagi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phg",
		"Description": [
			"Phuong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phh",
		"Description": [
			"Phukha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phi",
		"Description": [
			"Philippine languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "phk",
		"Description": [
			"Phake"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phl",
		"Description": [
			"Phalura",
			"Palula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phm",
		"Description": [
			"Phimbi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phn",
		"Description": [
			"Phoenician"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "pho",
		"Description": [
			"Phunoi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phq",
		"Description": [
			"Phana'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phr",
		"Description": [
			"Pahari-Potwari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "pht",
		"Description": [
			"Phu Thai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phu",
		"Description": [
			"Phuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phv",
		"Description": [
			"Pahlavani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "phw",
		"Description": [
			"Phangduwali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pia",
		"Description": [
			"Pima Bajo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pib",
		"Description": [
			"Yine"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pic",
		"Description": [
			"Pinji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pid",
		"Description": [
			"Piaroa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pie",
		"Description": [
			"Piro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pif",
		"Description": [
			"Pingelapese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pig",
		"Description": [
			"Pisabo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pih",
		"Description": [
			"Pitcairn-Norfolk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pii",
		"Description": [
			"Pini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pij",
		"Description": [
			"Pijao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pil",
		"Description": [
			"Yom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pim",
		"Description": [
			"Powhatan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pin",
		"Description": [
			"Piame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pio",
		"Description": [
			"Piapoco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pip",
		"Description": [
			"Pero"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pir",
		"Description": [
			"Piratapuyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pis",
		"Description": [
			"Pijin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pit",
		"Description": [
			"Pitta Pitta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "piu",
		"Description": [
			"Pintupi-Luritja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "piv",
		"Description": [
			"Pileni",
			"Vaeakau-Taumako"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "piw",
		"Description": [
			"Pimbwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pix",
		"Description": [
			"Piu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "piy",
		"Description": [
			"Piya-Kwonci"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "piz",
		"Description": [
			"Pije"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pjt",
		"Description": [
			"Pitjantjatjara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pka",
		"Description": [
			"Ardhamāgadhī Prākrit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pkb",
		"Description": [
			"Pokomo",
			"Kipfokomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pkc",
		"Description": [
			"Paekche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pkg",
		"Description": [
			"Pak-Tong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pkh",
		"Description": [
			"Pankhu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pkn",
		"Description": [
			"Pakanha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pko",
		"Description": [
			"Pökoot"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "pkp",
		"Description": [
			"Pukapuka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pkr",
		"Description": [
			"Attapady Kurumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pks",
		"Description": [
			"Pakistan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pkt",
		"Description": [
			"Maleng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pku",
		"Description": [
			"Paku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pla",
		"Description": [
			"Miani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plb",
		"Description": [
			"Polonombauk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plc",
		"Description": [
			"Central Palawano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pld",
		"Description": [
			"Polari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ple",
		"Description": [
			"Palu'e"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plf",
		"Description": [
			"Central Malayo-Polynesian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "plg",
		"Description": [
			"Pilagá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plh",
		"Description": [
			"Paulohi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plj",
		"Description": [
			"Polci"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plk",
		"Description": [
			"Kohistani Shina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pll",
		"Description": [
			"Shwe Palaung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pln",
		"Description": [
			"Palenquero"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plo",
		"Description": [
			"Oluta Popoluca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plp",
		"Description": [
			"Palpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plq",
		"Description": [
			"Palaic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plr",
		"Description": [
			"Palaka Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pls",
		"Description": [
			"San Marcos Tlacoyalco Popoloca",
			"San Marcos Tlalcoyalco Popoloca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plt",
		"Description": [
			"Plateau Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "plu",
		"Description": [
			"Palikúr"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plv",
		"Description": [
			"Southwest Palawano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plw",
		"Description": [
			"Brooke's Point Palawano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ply",
		"Description": [
			"Bolyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "plz",
		"Description": [
			"Paluan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pma",
		"Description": [
			"Paama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmb",
		"Description": [
			"Pambia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmc",
		"Description": [
			"Palumata"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "huw"
	},
	{
		"Type": "language",
		"Subtag": "pmd",
		"Description": [
			"Pallanganmiddang"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "pme",
		"Description": [
			"Pwaamei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmf",
		"Description": [
			"Pamona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmh",
		"Description": [
			"Māhārāṣṭri Prākrit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmi",
		"Description": [
			"Northern Pumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmj",
		"Description": [
			"Southern Pumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmk",
		"Description": [
			"Pamlico"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pml",
		"Description": [
			"Lingua Franca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmm",
		"Description": [
			"Pomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmn",
		"Description": [
			"Pam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmo",
		"Description": [
			"Pom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmq",
		"Description": [
			"Northern Pame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmr",
		"Description": [
			"Paynamar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pms",
		"Description": [
			"Piemontese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmt",
		"Description": [
			"Tuamotuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmu",
		"Description": [
			"Mirpur Panjabi"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "phr",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "pmw",
		"Description": [
			"Plains Miwok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmx",
		"Description": [
			"Poumei Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmy",
		"Description": [
			"Papuan Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pmz",
		"Description": [
			"Southern Pame"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pna",
		"Description": [
			"Punan Bah-Biau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnb",
		"Description": [
			"Western Panjabi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "pnc",
		"Description": [
			"Pannei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pne",
		"Description": [
			"Western Penan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "png",
		"Description": [
			"Pongu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnh",
		"Description": [
			"Penrhyn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pni",
		"Description": [
			"Aoheng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnj",
		"Description": [
			"Pinjarup"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "pnk",
		"Description": [
			"Paunaka"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "pnl",
		"Description": [
			"Paleni"
		],
		"Added": "2013-09-10",
		"Comments": [
			"see also wbf"
		]
	},
	{
		"Type": "language",
		"Subtag": "pnm",
		"Description": [
			"Punan Batu 1"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnn",
		"Description": [
			"Pinai-Hagahai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pno",
		"Description": [
			"Panobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnp",
		"Description": [
			"Pancana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnq",
		"Description": [
			"Pana (Burkina Faso)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnr",
		"Description": [
			"Panim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pns",
		"Description": [
			"Ponosakan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnt",
		"Description": [
			"Pontic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnu",
		"Description": [
			"Jiongnai Bunu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnv",
		"Description": [
			"Pinigura"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnw",
		"Description": [
			"Panytyima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pnx",
		"Description": [
			"Phong-Kniang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pny",
		"Description": [
			"Pinyin"
		],
		"Added": "2009-07-29",
		"Comments": [
			"a Niger-Congo language spoken in Cameroon; not to be confused",
			"with the Pinyin romanization systems used for Chinese and Tibetan"
		]
	},
	{
		"Type": "language",
		"Subtag": "pnz",
		"Description": [
			"Pana (Central African Republic)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "poc",
		"Description": [
			"Poqomam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pod",
		"Description": [
			"Ponares"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "poe",
		"Description": [
			"San Juan Atzingo Popoloca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pof",
		"Description": [
			"Poke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pog",
		"Description": [
			"Potiguára"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "poh",
		"Description": [
			"Poqomchi'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "poi",
		"Description": [
			"Highland Popoluca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pok",
		"Description": [
			"Pokangá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pom",
		"Description": [
			"Southeastern Pomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pon",
		"Description": [
			"Pohnpeian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "poo",
		"Description": [
			"Central Pomo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pop",
		"Description": [
			"Pwapwâ"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "poq",
		"Description": [
			"Texistepec Popoluca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pos",
		"Description": [
			"Sayula Popoluca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pot",
		"Description": [
			"Potawatomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pov",
		"Description": [
			"Upper Guinea Crioulo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pow",
		"Description": [
			"San Felipe Otlaltepec Popoloca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pox",
		"Description": [
			"Polabian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "poy",
		"Description": [
			"Pogolo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "poz",
		"Description": [
			"Malayo-Polynesian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ppa",
		"Description": [
			"Pao"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "bfy"
	},
	{
		"Type": "language",
		"Subtag": "ppe",
		"Description": [
			"Papi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppi",
		"Description": [
			"Paipai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppk",
		"Description": [
			"Uma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppl",
		"Description": [
			"Pipil",
			"Nicarao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppm",
		"Description": [
			"Papuma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppn",
		"Description": [
			"Papapana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppo",
		"Description": [
			"Folopa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppp",
		"Description": [
			"Pelende"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppq",
		"Description": [
			"Pei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppr",
		"Description": [
			"Piru"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Preferred-Value": "lcq"
	},
	{
		"Type": "language",
		"Subtag": "pps",
		"Description": [
			"San Luís Temalacayuca Popoloca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppt",
		"Description": [
			"Pare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ppu",
		"Description": [
			"Papora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pqa",
		"Description": [
			"Pa'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pqe",
		"Description": [
			"Eastern Malayo-Polynesian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "pqm",
		"Description": [
			"Malecite-Passamaquoddy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pqw",
		"Description": [
			"Western Malayo-Polynesian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "pra",
		"Description": [
			"Prakrit languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "prb",
		"Description": [
			"Lua'"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "prc",
		"Description": [
			"Parachi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prd",
		"Description": [
			"Parsi-Dari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pre",
		"Description": [
			"Principense"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prf",
		"Description": [
			"Paranan"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "prg",
		"Description": [
			"Prussian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prh",
		"Description": [
			"Porohanon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pri",
		"Description": [
			"Paicî"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prk",
		"Description": [
			"Parauk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prl",
		"Description": [
			"Peruvian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prm",
		"Description": [
			"Kibiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prn",
		"Description": [
			"Prasuni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pro",
		"Description": [
			"Old Provençal (to 1500)",
			"Old Occitan (to 1500)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "prp",
		"Description": [
			"Parsi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prq",
		"Description": [
			"Ashéninka Perené"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prr",
		"Description": [
			"Puri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prs",
		"Description": [
			"Dari",
			"Afghan Persian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "fa"
	},
	{
		"Type": "language",
		"Subtag": "prt",
		"Description": [
			"Phai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pru",
		"Description": [
			"Puragi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prw",
		"Description": [
			"Parawen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "prx",
		"Description": [
			"Purik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pry",
		"Description": [
			"Pray 3"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "prt"
	},
	{
		"Type": "language",
		"Subtag": "prz",
		"Description": [
			"Providencia Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psa",
		"Description": [
			"Asue Awyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psc",
		"Description": [
			"Persian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psd",
		"Description": [
			"Plains Indian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pse",
		"Description": [
			"Central Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "psg",
		"Description": [
			"Penang Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psh",
		"Description": [
			"Southwest Pashai",
			"Southwest Pashayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psi",
		"Description": [
			"Southeast Pashai",
			"Southeast Pashayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psl",
		"Description": [
			"Puerto Rican Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psm",
		"Description": [
			"Pauserna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psn",
		"Description": [
			"Panasuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pso",
		"Description": [
			"Polish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psp",
		"Description": [
			"Philippine Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psq",
		"Description": [
			"Pasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psr",
		"Description": [
			"Portuguese Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pss",
		"Description": [
			"Kaulong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pst",
		"Description": [
			"Central Pashto"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ps"
	},
	{
		"Type": "language",
		"Subtag": "psu",
		"Description": [
			"Sauraseni Prākrit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psw",
		"Description": [
			"Port Sandwich"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "psy",
		"Description": [
			"Piscataway"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pta",
		"Description": [
			"Pai Tavytera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pth",
		"Description": [
			"Pataxó Hã-Ha-Hãe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pti",
		"Description": [
			"Pintiini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ptn",
		"Description": [
			"Patani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pto",
		"Description": [
			"Zo'é"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ptp",
		"Description": [
			"Patep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ptq",
		"Description": [
			"Pattapu"
		],
		"Added": "2014-04-06"
	},
	{
		"Type": "language",
		"Subtag": "ptr",
		"Description": [
			"Piamatsina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ptt",
		"Description": [
			"Enrekang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ptu",
		"Description": [
			"Bambam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ptv",
		"Description": [
			"Port Vato"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ptw",
		"Description": [
			"Pentlatch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pty",
		"Description": [
			"Pathiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pua",
		"Description": [
			"Western Highland Purepecha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pub",
		"Description": [
			"Purum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puc",
		"Description": [
			"Punan Merap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pud",
		"Description": [
			"Punan Aput"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pue",
		"Description": [
			"Puelche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puf",
		"Description": [
			"Punan Merah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pug",
		"Description": [
			"Phuie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pui",
		"Description": [
			"Puinave"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puj",
		"Description": [
			"Punan Tubu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puk",
		"Description": [
			"Pu Ko"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "pum",
		"Description": [
			"Puma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puo",
		"Description": [
			"Puoc"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pup",
		"Description": [
			"Pulabu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puq",
		"Description": [
			"Puquina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pur",
		"Description": [
			"Puruborá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "put",
		"Description": [
			"Putoh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puu",
		"Description": [
			"Punu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puw",
		"Description": [
			"Puluwatese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pux",
		"Description": [
			"Puare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puy",
		"Description": [
			"Purisimeño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "puz",
		"Description": [
			"Purum Naga"
		],
		"Added": "2009-07-29",
		"Deprecated": "2014-02-28",
		"Preferred-Value": "pub"
	},
	{
		"Type": "language",
		"Subtag": "pwa",
		"Description": [
			"Pawaia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pwb",
		"Description": [
			"Panawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pwg",
		"Description": [
			"Gapapaiwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pwi",
		"Description": [
			"Patwin"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "pwm",
		"Description": [
			"Molbog"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pwn",
		"Description": [
			"Paiwan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pwo",
		"Description": [
			"Pwo Western Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pwr",
		"Description": [
			"Powari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pww",
		"Description": [
			"Pwo Northern Karen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pxm",
		"Description": [
			"Quetzaltepec Mixe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pye",
		"Description": [
			"Pye Krumen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pym",
		"Description": [
			"Fyam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pyn",
		"Description": [
			"Poyanáwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pys",
		"Description": [
			"Paraguayan Sign Language",
			"Lengua de Señas del Paraguay"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "pyu",
		"Description": [
			"Puyuma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pyx",
		"Description": [
			"Pyu (Myanmar)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pyy",
		"Description": [
			"Pyen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "pzn",
		"Description": [
			"Para Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qaa..qtz",
		"Description": [
			"Private use"
		],
		"Added": "2005-10-16",
		"Scope": "private-use"
	},
	{
		"Type": "language",
		"Subtag": "qua",
		"Description": [
			"Quapaw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qub",
		"Description": [
			"Huallaga Huánuco Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "quc",
		"Description": [
			"K'iche'",
			"Quiché"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qud",
		"Description": [
			"Calderón Highland Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "quf",
		"Description": [
			"Lambayeque Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qug",
		"Description": [
			"Chimborazo Highland Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "quh",
		"Description": [
			"South Bolivian Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qui",
		"Description": [
			"Quileute"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "quk",
		"Description": [
			"Chachapoyas Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qul",
		"Description": [
			"North Bolivian Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qum",
		"Description": [
			"Sipacapense"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qun",
		"Description": [
			"Quinault"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qup",
		"Description": [
			"Southern Pastaza Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "quq",
		"Description": [
			"Quinqui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qur",
		"Description": [
			"Yanahuanca Pasco Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qus",
		"Description": [
			"Santiago del Estero Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "quv",
		"Description": [
			"Sacapulteco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "quw",
		"Description": [
			"Tena Lowland Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qux",
		"Description": [
			"Yauyos Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "quy",
		"Description": [
			"Ayacucho Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "quz",
		"Description": [
			"Cusco Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qva",
		"Description": [
			"Ambo-Pasco Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvc",
		"Description": [
			"Cajamarca Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qve",
		"Description": [
			"Eastern Apurímac Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvh",
		"Description": [
			"Huamalíes-Dos de Mayo Huánuco Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvi",
		"Description": [
			"Imbabura Highland Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvj",
		"Description": [
			"Loja Highland Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvl",
		"Description": [
			"Cajatambo North Lima Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvm",
		"Description": [
			"Margos-Yarowilca-Lauricocha Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvn",
		"Description": [
			"North Junín Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvo",
		"Description": [
			"Napo Lowland Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvp",
		"Description": [
			"Pacaraos Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvs",
		"Description": [
			"San Martín Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvw",
		"Description": [
			"Huaylla Wanca Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qvy",
		"Description": [
			"Queyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qvz",
		"Description": [
			"Northern Pastaza Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qwa",
		"Description": [
			"Corongo Ancash Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qwc",
		"Description": [
			"Classical Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qwe",
		"Description": [
			"Quechuan (family)"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "qwh",
		"Description": [
			"Huaylas Ancash Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qwm",
		"Description": [
			"Kuman (Russia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qws",
		"Description": [
			"Sihuas Ancash Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qwt",
		"Description": [
			"Kwalhioqua-Tlatskanai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qxa",
		"Description": [
			"Chiquián Ancash Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxc",
		"Description": [
			"Chincha Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxh",
		"Description": [
			"Panao Huánuco Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxl",
		"Description": [
			"Salasaca Highland Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxn",
		"Description": [
			"Northern Conchucos Ancash Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxo",
		"Description": [
			"Southern Conchucos Ancash Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxp",
		"Description": [
			"Puno Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxq",
		"Description": [
			"Qashqa'i"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qxr",
		"Description": [
			"Cañar Highland Quichua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxs",
		"Description": [
			"Southern Qiang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qxt",
		"Description": [
			"Santa Ana de Tusi Pasco Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxu",
		"Description": [
			"Arequipa-La Unión Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qxw",
		"Description": [
			"Jauja Wanca Quechua"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "qu"
	},
	{
		"Type": "language",
		"Subtag": "qya",
		"Description": [
			"Quenya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "qyp",
		"Description": [
			"Quiripi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "raa",
		"Description": [
			"Dungmali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rab",
		"Description": [
			"Camling"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rac",
		"Description": [
			"Rasawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rad",
		"Description": [
			"Rade"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "raf",
		"Description": [
			"Western Meohang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rag",
		"Description": [
			"Logooli",
			"Lulogooli"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "luy"
	},
	{
		"Type": "language",
		"Subtag": "rah",
		"Description": [
			"Rabha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rai",
		"Description": [
			"Ramoaaina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "raj",
		"Description": [
			"Rajasthani"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "rak",
		"Description": [
			"Tulu-Bohuai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ral",
		"Description": [
			"Ralte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ram",
		"Description": [
			"Canela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ran",
		"Description": [
			"Riantana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rao",
		"Description": [
			"Rao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rap",
		"Description": [
			"Rapanui"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "raq",
		"Description": [
			"Saam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rar",
		"Description": [
			"Rarotongan",
			"Cook Islands Maori"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ras",
		"Description": [
			"Tegali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rat",
		"Description": [
			"Razajerdi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rau",
		"Description": [
			"Raute"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rav",
		"Description": [
			"Sampang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "raw",
		"Description": [
			"Rawang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rax",
		"Description": [
			"Rang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ray",
		"Description": [
			"Rapa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "raz",
		"Description": [
			"Rahambuu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rbb",
		"Description": [
			"Rumai Palaung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rbk",
		"Description": [
			"Northern Bontok"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bnc"
	},
	{
		"Type": "language",
		"Subtag": "rbl",
		"Description": [
			"Miraya Bikol"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "rbp",
		"Description": [
			"Barababaraba"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "rcf",
		"Description": [
			"Réunion Creole French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rdb",
		"Description": [
			"Rudbari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rea",
		"Description": [
			"Rerau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "reb",
		"Description": [
			"Rembong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ree",
		"Description": [
			"Rejang Kayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "reg",
		"Description": [
			"Kara (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rei",
		"Description": [
			"Reli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rej",
		"Description": [
			"Rejang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rel",
		"Description": [
			"Rendille"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rem",
		"Description": [
			"Remo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ren",
		"Description": [
			"Rengao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rer",
		"Description": [
			"Rer Bare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "res",
		"Description": [
			"Reshe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ret",
		"Description": [
			"Retta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rey",
		"Description": [
			"Reyesano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rga",
		"Description": [
			"Roria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rge",
		"Description": [
			"Romano-Greek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rgk",
		"Description": [
			"Rangkas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rgn",
		"Description": [
			"Romagnol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rgr",
		"Description": [
			"Resígaro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rgs",
		"Description": [
			"Southern Roglai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rgu",
		"Description": [
			"Ringgou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rhg",
		"Description": [
			"Rohingya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rhp",
		"Description": [
			"Yahang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ria",
		"Description": [
			"Riang (India)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rie",
		"Description": [
			"Rien"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "rif",
		"Description": [
			"Tarifit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ril",
		"Description": [
			"Riang (Myanmar)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rim",
		"Description": [
			"Nyaturu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rin",
		"Description": [
			"Nungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rir",
		"Description": [
			"Ribun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rit",
		"Description": [
			"Ritarungo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "riu",
		"Description": [
			"Riung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rjg",
		"Description": [
			"Rajong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rji",
		"Description": [
			"Raji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rjs",
		"Description": [
			"Rajbanshi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rka",
		"Description": [
			"Kraol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rkb",
		"Description": [
			"Rikbaktsa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rkh",
		"Description": [
			"Rakahanga-Manihiki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rki",
		"Description": [
			"Rakhine"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rkm",
		"Description": [
			"Marka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rkt",
		"Description": [
			"Rangpuri",
			"Kamta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rkw",
		"Description": [
			"Arakwal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "rma",
		"Description": [
			"Rama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmb",
		"Description": [
			"Rembarunga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmc",
		"Description": [
			"Carpathian Romani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "rom"
	},
	{
		"Type": "language",
		"Subtag": "rmd",
		"Description": [
			"Traveller Danish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rme",
		"Description": [
			"Angloromani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmf",
		"Description": [
			"Kalo Finnish Romani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "rom"
	},
	{
		"Type": "language",
		"Subtag": "rmg",
		"Description": [
			"Traveller Norwegian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmh",
		"Description": [
			"Murkim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmi",
		"Description": [
			"Lomavren"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmk",
		"Description": [
			"Romkun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rml",
		"Description": [
			"Baltic Romani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "rom"
	},
	{
		"Type": "language",
		"Subtag": "rmm",
		"Description": [
			"Roma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmn",
		"Description": [
			"Balkan Romani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "rom"
	},
	{
		"Type": "language",
		"Subtag": "rmo",
		"Description": [
			"Sinte Romani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "rom"
	},
	{
		"Type": "language",
		"Subtag": "rmp",
		"Description": [
			"Rempi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmq",
		"Description": [
			"Caló"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "rmr",
		"Description": [
			"Caló"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see emx, rmq"
		]
	},
	{
		"Type": "language",
		"Subtag": "rms",
		"Description": [
			"Romanian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmt",
		"Description": [
			"Domari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmu",
		"Description": [
			"Tavringer Romani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmv",
		"Description": [
			"Romanova"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmw",
		"Description": [
			"Welsh Romani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "rom"
	},
	{
		"Type": "language",
		"Subtag": "rmx",
		"Description": [
			"Romam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rmy",
		"Description": [
			"Vlax Romani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "rom"
	},
	{
		"Type": "language",
		"Subtag": "rmz",
		"Description": [
			"Marma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rna",
		"Description": [
			"Runa"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "rnd",
		"Description": [
			"Ruund"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rng",
		"Description": [
			"Ronga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rnl",
		"Description": [
			"Ranglong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rnn",
		"Description": [
			"Roon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rnp",
		"Description": [
			"Rongpo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rnr",
		"Description": [
			"Nari Nari"
		],
		"Added": "2012-08-20"
	},
	{
		"Type": "language",
		"Subtag": "rnw",
		"Description": [
			"Rungwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "roa",
		"Description": [
			"Romance languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "rob",
		"Description": [
			"Tae'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "roc",
		"Description": [
			"Cacgia Roglai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rod",
		"Description": [
			"Rogo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "roe",
		"Description": [
			"Ronji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rof",
		"Description": [
			"Rombo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rog",
		"Description": [
			"Northern Roglai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rol",
		"Description": [
			"Romblomanon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rom",
		"Description": [
			"Romany"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "roo",
		"Description": [
			"Rotokas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rop",
		"Description": [
			"Kriol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ror",
		"Description": [
			"Rongga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rou",
		"Description": [
			"Runga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "row",
		"Description": [
			"Dela-Oenale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rpn",
		"Description": [
			"Repanbitip"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rpt",
		"Description": [
			"Rapting"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rri",
		"Description": [
			"Ririo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rro",
		"Description": [
			"Waima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rrt",
		"Description": [
			"Arritinngithigh"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "rsb",
		"Description": [
			"Romano-Serbian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rsi",
		"Description": [
			"Rennellese Sign Language"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "rsl",
		"Description": [
			"Russian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rsm",
		"Description": [
			"Miriwoong Sign Language"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "rtc",
		"Description": [
			"Rungtu Chin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "rth",
		"Description": [
			"Ratahan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rtm",
		"Description": [
			"Rotuman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rts",
		"Description": [
			"Yurats"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "rtw",
		"Description": [
			"Rathawi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rub",
		"Description": [
			"Gungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruc",
		"Description": [
			"Ruuli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rue",
		"Description": [
			"Rusyn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruf",
		"Description": [
			"Luguru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rug",
		"Description": [
			"Roviana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruh",
		"Description": [
			"Ruga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rui",
		"Description": [
			"Rufiji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruk",
		"Description": [
			"Che"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruo",
		"Description": [
			"Istro Romanian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rup",
		"Description": [
			"Macedo-Romanian",
			"Aromanian",
			"Arumanian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ruq",
		"Description": [
			"Megleno Romanian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rut",
		"Description": [
			"Rutul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruu",
		"Description": [
			"Lanas Lobu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruy",
		"Description": [
			"Mala (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ruz",
		"Description": [
			"Ruma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rwa",
		"Description": [
			"Rawo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rwk",
		"Description": [
			"Rwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rwm",
		"Description": [
			"Amba (Uganda)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rwo",
		"Description": [
			"Rawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rwr",
		"Description": [
			"Marwari (India)"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mwr"
	},
	{
		"Type": "language",
		"Subtag": "rxd",
		"Description": [
			"Ngardi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "rxw",
		"Description": [
			"Karuwali"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ryn",
		"Description": [
			"Northern Amami-Oshima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rys",
		"Description": [
			"Yaeyama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ryu",
		"Description": [
			"Central Okinawan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "rzh",
		"Description": [
			"Rāziḥī"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "saa",
		"Description": [
			"Saba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sab",
		"Description": [
			"Buglere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sac",
		"Description": [
			"Meskwaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sad",
		"Description": [
			"Sandawe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sae",
		"Description": [
			"Sabanê"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "saf",
		"Description": [
			"Safaliba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sah",
		"Description": [
			"Yakut"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sai",
		"Description": [
			"South American Indian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "saj",
		"Description": [
			"Sahu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sak",
		"Description": [
			"Sake"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sal",
		"Description": [
			"Salishan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "sam",
		"Description": [
			"Samaritan Aramaic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sao",
		"Description": [
			"Sause"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sap",
		"Description": [
			"Sanapaná"
		],
		"Added": "2009-07-29",
		"Deprecated": "2014-02-28",
		"Comments": [
			"see aqt, spn"
		]
	},
	{
		"Type": "language",
		"Subtag": "saq",
		"Description": [
			"Samburu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sar",
		"Description": [
			"Saraveca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sas",
		"Description": [
			"Sasak"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sat",
		"Description": [
			"Santali"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sau",
		"Description": [
			"Saleman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sav",
		"Description": [
			"Saafi-Saafi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "saw",
		"Description": [
			"Sawi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sax",
		"Description": [
			"Sa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "say",
		"Description": [
			"Saya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "saz",
		"Description": [
			"Saurashtra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sba",
		"Description": [
			"Ngambay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbb",
		"Description": [
			"Simbo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbc",
		"Description": [
			"Kele (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbd",
		"Description": [
			"Southern Samo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbe",
		"Description": [
			"Saliba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbf",
		"Description": [
			"Chabu",
			"Shabo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbg",
		"Description": [
			"Seget"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbh",
		"Description": [
			"Sori-Harengan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbi",
		"Description": [
			"Seti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbj",
		"Description": [
			"Surbakhal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbk",
		"Description": [
			"Safwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbl",
		"Description": [
			"Botolan Sambal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbm",
		"Description": [
			"Sagala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbn",
		"Description": [
			"Sindhi Bhil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbo",
		"Description": [
			"Sabüm"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbp",
		"Description": [
			"Sangu (Tanzania)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbq",
		"Description": [
			"Sileibi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbr",
		"Description": [
			"Sembakung Murut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbs",
		"Description": [
			"Subiya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbt",
		"Description": [
			"Kimki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbu",
		"Description": [
			"Stod Bhoti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbv",
		"Description": [
			"Sabine"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbw",
		"Description": [
			"Simba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbx",
		"Description": [
			"Seberuang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sby",
		"Description": [
			"Soli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sbz",
		"Description": [
			"Sara Kaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sca",
		"Description": [
			"Sansu"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "hle"
	},
	{
		"Type": "language",
		"Subtag": "scb",
		"Description": [
			"Chut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sce",
		"Description": [
			"Dongxiang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scf",
		"Description": [
			"San Miguel Creole French"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scg",
		"Description": [
			"Sanggau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sch",
		"Description": [
			"Sakachep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sci",
		"Description": [
			"Sri Lankan Creole Malay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sck",
		"Description": [
			"Sadri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scl",
		"Description": [
			"Shina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scn",
		"Description": [
			"Sicilian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sco",
		"Description": [
			"Scots"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "scp",
		"Description": [
			"Helambu Sherpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scq",
		"Description": [
			"Sa'och"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scs",
		"Description": [
			"North Slavey"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "den"
	},
	{
		"Type": "language",
		"Subtag": "sct",
		"Description": [
			"Southern Katang"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "scu",
		"Description": [
			"Shumcho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scv",
		"Description": [
			"Sheni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scw",
		"Description": [
			"Sha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "scx",
		"Description": [
			"Sicel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sda",
		"Description": [
			"Toraja-Sa'dan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdb",
		"Description": [
			"Shabak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdc",
		"Description": [
			"Sassarese Sardinian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sc"
	},
	{
		"Type": "language",
		"Subtag": "sde",
		"Description": [
			"Surubu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdf",
		"Description": [
			"Sarli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdg",
		"Description": [
			"Savi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdh",
		"Description": [
			"Southern Kurdish"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ku"
	},
	{
		"Type": "language",
		"Subtag": "sdj",
		"Description": [
			"Suundi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdk",
		"Description": [
			"Sos Kundi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdl",
		"Description": [
			"Saudi Arabian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdm",
		"Description": [
			"Semandang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdn",
		"Description": [
			"Gallurese Sardinian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sc"
	},
	{
		"Type": "language",
		"Subtag": "sdo",
		"Description": [
			"Bukar-Sadung Bidayuh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdp",
		"Description": [
			"Sherdukpen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdr",
		"Description": [
			"Oraon Sadri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sds",
		"Description": [
			"Sened"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdt",
		"Description": [
			"Shuadit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdu",
		"Description": [
			"Sarudu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdv",
		"Description": [
			"Eastern Sudanic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "sdx",
		"Description": [
			"Sibu Melanau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sdz",
		"Description": [
			"Sallands"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sea",
		"Description": [
			"Semai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "seb",
		"Description": [
			"Shempire Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sec",
		"Description": [
			"Sechelt"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sed",
		"Description": [
			"Sedang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "see",
		"Description": [
			"Seneca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sef",
		"Description": [
			"Cebaara Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "seg",
		"Description": [
			"Segeju"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "seh",
		"Description": [
			"Sena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sei",
		"Description": [
			"Seri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sej",
		"Description": [
			"Sene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sek",
		"Description": [
			"Sekani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sel",
		"Description": [
			"Selkup"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sem",
		"Description": [
			"Semitic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "sen",
		"Description": [
			"Nanerigé Sénoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "seo",
		"Description": [
			"Suarmin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sep",
		"Description": [
			"Sìcìté Sénoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "seq",
		"Description": [
			"Senara Sénoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ser",
		"Description": [
			"Serrano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ses",
		"Description": [
			"Koyraboro Senni Songhai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "set",
		"Description": [
			"Sentani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "seu",
		"Description": [
			"Serui-Laut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sev",
		"Description": [
			"Nyarafolo Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sew",
		"Description": [
			"Sewa Bay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sey",
		"Description": [
			"Secoya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sez",
		"Description": [
			"Senthang Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sfb",
		"Description": [
			"Langue des signes de Belgique Francophone",
			"French Belgian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sfe",
		"Description": [
			"Eastern Subanen"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "sfm",
		"Description": [
			"Small Flowery Miao"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "hmn"
	},
	{
		"Type": "language",
		"Subtag": "sfs",
		"Description": [
			"South African Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sfw",
		"Description": [
			"Sehwi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sga",
		"Description": [
			"Old Irish (to 900)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sgb",
		"Description": [
			"Mag-antsi Ayta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgc",
		"Description": [
			"Kipsigis"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "sgd",
		"Description": [
			"Surigaonon"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "sge",
		"Description": [
			"Segai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgg",
		"Description": [
			"Swiss-German Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgh",
		"Description": [
			"Shughni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgi",
		"Description": [
			"Suga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgj",
		"Description": [
			"Surgujia"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "sgk",
		"Description": [
			"Sangkong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgl",
		"Description": [
			"Sanglechi-Ishkashimi"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see isk, sgy"
		]
	},
	{
		"Type": "language",
		"Subtag": "sgm",
		"Description": [
			"Singa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgn",
		"Description": [
			"Sign languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "sgo",
		"Description": [
			"Songa"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "sgp",
		"Description": [
			"Singpho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgr",
		"Description": [
			"Sangisari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgs",
		"Description": [
			"Samogitian"
		],
		"Added": "2010-07-26"
	},
	{
		"Type": "language",
		"Subtag": "sgt",
		"Description": [
			"Brokpake"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgu",
		"Description": [
			"Salas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgw",
		"Description": [
			"Sebat Bet Gurage"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgx",
		"Description": [
			"Sierra Leone Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sgy",
		"Description": [
			"Sanglechi"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "sgz",
		"Description": [
			"Sursurunga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sha",
		"Description": [
			"Shall-Zwall"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shb",
		"Description": [
			"Ninam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shc",
		"Description": [
			"Sonde"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shd",
		"Description": [
			"Kundal Shahi"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "she",
		"Description": [
			"Sheko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shg",
		"Description": [
			"Shua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shh",
		"Description": [
			"Shoshoni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shi",
		"Description": [
			"Tachelhit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shj",
		"Description": [
			"Shatt"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shk",
		"Description": [
			"Shilluk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shl",
		"Description": [
			"Shendu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shm",
		"Description": [
			"Shahrudi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shn",
		"Description": [
			"Shan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sho",
		"Description": [
			"Shanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shp",
		"Description": [
			"Shipibo-Conibo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shq",
		"Description": [
			"Sala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shr",
		"Description": [
			"Shi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shs",
		"Description": [
			"Shuswap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sht",
		"Description": [
			"Shasta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shu",
		"Description": [
			"Chadian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "shv",
		"Description": [
			"Shehri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shw",
		"Description": [
			"Shwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shx",
		"Description": [
			"She"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shy",
		"Description": [
			"Tachawit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "shz",
		"Description": [
			"Syenara Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sia",
		"Description": [
			"Akkala Sami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sib",
		"Description": [
			"Sebop"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sid",
		"Description": [
			"Sidamo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sie",
		"Description": [
			"Simaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sif",
		"Description": [
			"Siamou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sig",
		"Description": [
			"Paasaal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sih",
		"Description": [
			"Zire",
			"Sîshëë"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sii",
		"Description": [
			"Shom Peng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sij",
		"Description": [
			"Numbami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sik",
		"Description": [
			"Sikiana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sil",
		"Description": [
			"Tumulung Sisaala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sim",
		"Description": [
			"Mende (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sio",
		"Description": [
			"Siouan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "sip",
		"Description": [
			"Sikkimese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "siq",
		"Description": [
			"Sonia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sir",
		"Description": [
			"Siri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sis",
		"Description": [
			"Siuslaw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sit",
		"Description": [
			"Sino-Tibetan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "siu",
		"Description": [
			"Sinagen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "siv",
		"Description": [
			"Sumariup"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "siw",
		"Description": [
			"Siwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "six",
		"Description": [
			"Sumau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "siy",
		"Description": [
			"Sivandi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "siz",
		"Description": [
			"Siwi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sja",
		"Description": [
			"Epena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjb",
		"Description": [
			"Sajau Basap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjd",
		"Description": [
			"Kildin Sami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sje",
		"Description": [
			"Pite Sami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjg",
		"Description": [
			"Assangori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjk",
		"Description": [
			"Kemi Sami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjl",
		"Description": [
			"Sajalong",
			"Miji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjm",
		"Description": [
			"Mapun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjn",
		"Description": [
			"Sindarin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjo",
		"Description": [
			"Xibe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjp",
		"Description": [
			"Surjapuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjr",
		"Description": [
			"Siar-Lak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjs",
		"Description": [
			"Senhaja De Srair"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjt",
		"Description": [
			"Ter Sami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sju",
		"Description": [
			"Ume Sami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sjw",
		"Description": [
			"Shawnee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ska",
		"Description": [
			"Skagit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skb",
		"Description": [
			"Saek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skc",
		"Description": [
			"Ma Manda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skd",
		"Description": [
			"Southern Sierra Miwok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ske",
		"Description": [
			"Seke (Vanuatu)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skf",
		"Description": [
			"Sakirabiá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skg",
		"Description": [
			"Sakalava Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "skh",
		"Description": [
			"Sikule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ski",
		"Description": [
			"Sika"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skj",
		"Description": [
			"Seke (Nepal)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skk",
		"Description": [
			"Sok"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23",
		"Preferred-Value": "oyb"
	},
	{
		"Type": "language",
		"Subtag": "skm",
		"Description": [
			"Kutong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skn",
		"Description": [
			"Kolibugan Subanon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sko",
		"Description": [
			"Seko Tengah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skp",
		"Description": [
			"Sekapan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skq",
		"Description": [
			"Sininkere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skr",
		"Description": [
			"Saraiki",
			"Seraiki"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "sks",
		"Description": [
			"Maia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skt",
		"Description": [
			"Sakata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sku",
		"Description": [
			"Sakao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skv",
		"Description": [
			"Skou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skw",
		"Description": [
			"Skepi Creole Dutch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skx",
		"Description": [
			"Seko Padang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sky",
		"Description": [
			"Sikaiana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "skz",
		"Description": [
			"Sekar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sla",
		"Description": [
			"Slavic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "slc",
		"Description": [
			"Sáliba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sld",
		"Description": [
			"Sissala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sle",
		"Description": [
			"Sholaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slf",
		"Description": [
			"Swiss-Italian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slg",
		"Description": [
			"Selungai Murut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slh",
		"Description": [
			"Southern Puget Sound Salish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sli",
		"Description": [
			"Lower Silesian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slj",
		"Description": [
			"Salumá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sll",
		"Description": [
			"Salt-Yui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slm",
		"Description": [
			"Pangutaran Sama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sln",
		"Description": [
			"Salinan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slp",
		"Description": [
			"Lamaholot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slq",
		"Description": [
			"Salchuq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slr",
		"Description": [
			"Salar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sls",
		"Description": [
			"Singapore Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slt",
		"Description": [
			"Sila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slu",
		"Description": [
			"Selaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slw",
		"Description": [
			"Sialum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slx",
		"Description": [
			"Salampasu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sly",
		"Description": [
			"Selayar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "slz",
		"Description": [
			"Ma'ya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sma",
		"Description": [
			"Southern Sami"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "smb",
		"Description": [
			"Simbari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smc",
		"Description": [
			"Som"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smd",
		"Description": [
			"Sama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smf",
		"Description": [
			"Auwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smg",
		"Description": [
			"Simbali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smh",
		"Description": [
			"Samei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smi",
		"Description": [
			"Sami languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "smj",
		"Description": [
			"Lule Sami"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "smk",
		"Description": [
			"Bolinao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sml",
		"Description": [
			"Central Sama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smm",
		"Description": [
			"Musasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smn",
		"Description": [
			"Inari Sami"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "smp",
		"Description": [
			"Samaritan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smq",
		"Description": [
			"Samo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smr",
		"Description": [
			"Simeulue"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sms",
		"Description": [
			"Skolt Sami"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "smt",
		"Description": [
			"Simte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smu",
		"Description": [
			"Somray"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smv",
		"Description": [
			"Samvedi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smw",
		"Description": [
			"Sumbawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smx",
		"Description": [
			"Samba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smy",
		"Description": [
			"Semnani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "smz",
		"Description": [
			"Simeku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snb",
		"Description": [
			"Sebuyau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snc",
		"Description": [
			"Sinaugoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sne",
		"Description": [
			"Bau Bidayuh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snf",
		"Description": [
			"Noon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sng",
		"Description": [
			"Sanga (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snh",
		"Description": [
			"Shinabo"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "sni",
		"Description": [
			"Sensi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snj",
		"Description": [
			"Riverain Sango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snk",
		"Description": [
			"Soninke"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "snl",
		"Description": [
			"Sangil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snm",
		"Description": [
			"Southern Ma'di"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snn",
		"Description": [
			"Siona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sno",
		"Description": [
			"Snohomish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snp",
		"Description": [
			"Siane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snq",
		"Description": [
			"Sangu (Gabon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snr",
		"Description": [
			"Sihan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sns",
		"Description": [
			"South West Bay",
			"Nahavaq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snu",
		"Description": [
			"Senggi",
			"Viid"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snv",
		"Description": [
			"Sa'ban"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snw",
		"Description": [
			"Selee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snx",
		"Description": [
			"Sam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sny",
		"Description": [
			"Saniyo-Hiyewe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "snz",
		"Description": [
			"Sinsauru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soa",
		"Description": [
			"Thai Song"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sob",
		"Description": [
			"Sobei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soc",
		"Description": [
			"So (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sod",
		"Description": [
			"Songoora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soe",
		"Description": [
			"Songomeno"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sog",
		"Description": [
			"Sogdian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "soh",
		"Description": [
			"Aka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soi",
		"Description": [
			"Sonha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soj",
		"Description": [
			"Soi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sok",
		"Description": [
			"Sokoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sol",
		"Description": [
			"Solos"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "son",
		"Description": [
			"Songhai languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "soo",
		"Description": [
			"Songo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sop",
		"Description": [
			"Songe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soq",
		"Description": [
			"Kanasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sor",
		"Description": [
			"Somrai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sos",
		"Description": [
			"Seeku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sou",
		"Description": [
			"Southern Thai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sov",
		"Description": [
			"Sonsorol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sow",
		"Description": [
			"Sowanda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sox",
		"Description": [
			"Swo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soy",
		"Description": [
			"Miyobe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "soz",
		"Description": [
			"Temi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spb",
		"Description": [
			"Sepa (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spc",
		"Description": [
			"Sapé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spd",
		"Description": [
			"Saep"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spe",
		"Description": [
			"Sepa (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spg",
		"Description": [
			"Sian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spi",
		"Description": [
			"Saponi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spk",
		"Description": [
			"Sengo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spl",
		"Description": [
			"Selepet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spm",
		"Description": [
			"Akukem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spn",
		"Description": [
			"Sanapaná"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "spo",
		"Description": [
			"Spokane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spp",
		"Description": [
			"Supyire Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spq",
		"Description": [
			"Loreto-Ucayali Spanish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spr",
		"Description": [
			"Saparua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sps",
		"Description": [
			"Saposa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spt",
		"Description": [
			"Spiti Bhoti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spu",
		"Description": [
			"Sapuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spv",
		"Description": [
			"Sambalpuri",
			"Kosli"
		],
		"Added": "2012-08-12",
		"Macrolanguage": "or"
	},
	{
		"Type": "language",
		"Subtag": "spx",
		"Description": [
			"South Picene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "spy",
		"Description": [
			"Sabaot"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "sqa",
		"Description": [
			"Shama-Sambuga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqh",
		"Description": [
			"Shau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqj",
		"Description": [
			"Albanian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "sqk",
		"Description": [
			"Albanian Sign Language"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "sqm",
		"Description": [
			"Suma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqn",
		"Description": [
			"Susquehannock"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqo",
		"Description": [
			"Sorkhei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqq",
		"Description": [
			"Sou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqr",
		"Description": [
			"Siculo Arabic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqs",
		"Description": [
			"Sri Lankan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sqt",
		"Description": [
			"Soqotri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "squ",
		"Description": [
			"Squamish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sra",
		"Description": [
			"Saruga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srb",
		"Description": [
			"Sora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "src",
		"Description": [
			"Logudorese Sardinian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sc"
	},
	{
		"Type": "language",
		"Subtag": "sre",
		"Description": [
			"Sara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srf",
		"Description": [
			"Nafi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srg",
		"Description": [
			"Sulod"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srh",
		"Description": [
			"Sarikoli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sri",
		"Description": [
			"Siriano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srk",
		"Description": [
			"Serudung Murut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srl",
		"Description": [
			"Isirawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srm",
		"Description": [
			"Saramaccan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srn",
		"Description": [
			"Sranan Tongo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sro",
		"Description": [
			"Campidanese Sardinian"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sc"
	},
	{
		"Type": "language",
		"Subtag": "srq",
		"Description": [
			"Sirionó"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srr",
		"Description": [
			"Serer"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "srs",
		"Description": [
			"Sarsi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srt",
		"Description": [
			"Sauri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sru",
		"Description": [
			"Suruí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srv",
		"Description": [
			"Southern Sorsoganon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srw",
		"Description": [
			"Serua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srx",
		"Description": [
			"Sirmauri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sry",
		"Description": [
			"Sera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "srz",
		"Description": [
			"Shahmirzadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssa",
		"Description": [
			"Nilo-Saharan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ssb",
		"Description": [
			"Southern Sama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssc",
		"Description": [
			"Suba-Simbiti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssd",
		"Description": [
			"Siroi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sse",
		"Description": [
			"Balangingi",
			"Bangingih Sama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssf",
		"Description": [
			"Thao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssg",
		"Description": [
			"Seimat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssh",
		"Description": [
			"Shihhi Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ar"
	},
	{
		"Type": "language",
		"Subtag": "ssi",
		"Description": [
			"Sansi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssj",
		"Description": [
			"Sausi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssk",
		"Description": [
			"Sunam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssl",
		"Description": [
			"Western Sisaala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssm",
		"Description": [
			"Semnam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssn",
		"Description": [
			"Waata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sso",
		"Description": [
			"Sissano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssp",
		"Description": [
			"Spanish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssq",
		"Description": [
			"So'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssr",
		"Description": [
			"Swiss-French Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sss",
		"Description": [
			"Sô"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sst",
		"Description": [
			"Sinasina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssu",
		"Description": [
			"Susuami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssv",
		"Description": [
			"Shark Bay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssx",
		"Description": [
			"Samberigi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssy",
		"Description": [
			"Saho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ssz",
		"Description": [
			"Sengseng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sta",
		"Description": [
			"Settla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stb",
		"Description": [
			"Northern Subanen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "std",
		"Description": [
			"Sentinel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ste",
		"Description": [
			"Liana-Seti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stf",
		"Description": [
			"Seta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stg",
		"Description": [
			"Trieng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sth",
		"Description": [
			"Shelta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sti",
		"Description": [
			"Bulo Stieng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stj",
		"Description": [
			"Matya Samo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stk",
		"Description": [
			"Arammba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stl",
		"Description": [
			"Stellingwerfs"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stm",
		"Description": [
			"Setaman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stn",
		"Description": [
			"Owa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sto",
		"Description": [
			"Stoney"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stp",
		"Description": [
			"Southeastern Tepehuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stq",
		"Description": [
			"Saterfriesisch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "str",
		"Description": [
			"Straits Salish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sts",
		"Description": [
			"Shumashti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stt",
		"Description": [
			"Budeh Stieng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stu",
		"Description": [
			"Samtao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stv",
		"Description": [
			"Silt'e"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "stw",
		"Description": [
			"Satawalese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sty",
		"Description": [
			"Siberian Tatar"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "sua",
		"Description": [
			"Sulka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sub",
		"Description": [
			"Suku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "suc",
		"Description": [
			"Western Subanon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sue",
		"Description": [
			"Suena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sug",
		"Description": [
			"Suganga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sui",
		"Description": [
			"Suki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "suj",
		"Description": [
			"Shubi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "suk",
		"Description": [
			"Sukuma"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sul",
		"Description": [
			"Surigaonon"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see sgd, tgn"
		]
	},
	{
		"Type": "language",
		"Subtag": "sum",
		"Description": [
			"Sumo-Mayangna"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see ulw, yan"
		]
	},
	{
		"Type": "language",
		"Subtag": "suq",
		"Description": [
			"Suri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sur",
		"Description": [
			"Mwaghavul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sus",
		"Description": [
			"Susu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "sut",
		"Description": [
			"Subtiaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "suv",
		"Description": [
			"Puroik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "suw",
		"Description": [
			"Sumbwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sux",
		"Description": [
			"Sumerian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "suy",
		"Description": [
			"Suyá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "suz",
		"Description": [
			"Sunwar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sva",
		"Description": [
			"Svan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "svb",
		"Description": [
			"Ulau-Suain"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "svc",
		"Description": [
			"Vincentian Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sve",
		"Description": [
			"Serili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "svk",
		"Description": [
			"Slovakian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "svm",
		"Description": [
			"Slavomolisano"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "svr",
		"Description": [
			"Savara"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "svs",
		"Description": [
			"Savosavo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "svx",
		"Description": [
			"Skalvian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swb",
		"Description": [
			"Maore Comorian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swc",
		"Description": [
			"Congo Swahili"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sw"
	},
	{
		"Type": "language",
		"Subtag": "swf",
		"Description": [
			"Sere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swg",
		"Description": [
			"Swabian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swh",
		"Description": [
			"Swahili (individual language)",
			"Kiswahili"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "sw"
	},
	{
		"Type": "language",
		"Subtag": "swi",
		"Description": [
			"Sui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swj",
		"Description": [
			"Sira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swk",
		"Description": [
			"Malawi Sena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swl",
		"Description": [
			"Swedish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swm",
		"Description": [
			"Samosa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swn",
		"Description": [
			"Sawknah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swo",
		"Description": [
			"Shanenawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swp",
		"Description": [
			"Suau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swq",
		"Description": [
			"Sharwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swr",
		"Description": [
			"Saweru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sws",
		"Description": [
			"Seluwasan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swt",
		"Description": [
			"Sawila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swu",
		"Description": [
			"Suwawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swv",
		"Description": [
			"Shekhawati"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mwr"
	},
	{
		"Type": "language",
		"Subtag": "sww",
		"Description": [
			"Sowa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swx",
		"Description": [
			"Suruahá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "swy",
		"Description": [
			"Sarua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxb",
		"Description": [
			"Suba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxc",
		"Description": [
			"Sicanian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxe",
		"Description": [
			"Sighu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxg",
		"Description": [
			"Shixing"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxk",
		"Description": [
			"Southern Kalapuya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxl",
		"Description": [
			"Selian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxm",
		"Description": [
			"Samre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxn",
		"Description": [
			"Sangir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxo",
		"Description": [
			"Sorothaptic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxr",
		"Description": [
			"Saaroa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxs",
		"Description": [
			"Sasaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxu",
		"Description": [
			"Upper Saxon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sxw",
		"Description": [
			"Saxwe Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sya",
		"Description": [
			"Siang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syb",
		"Description": [
			"Central Subanen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syc",
		"Description": [
			"Classical Syriac"
		],
		"Added": "2007-04-03"
	},
	{
		"Type": "language",
		"Subtag": "syd",
		"Description": [
			"Samoyedic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "syi",
		"Description": [
			"Seki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syk",
		"Description": [
			"Sukur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syl",
		"Description": [
			"Sylheti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sym",
		"Description": [
			"Maya Samo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syn",
		"Description": [
			"Senaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syo",
		"Description": [
			"Suoy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syr",
		"Description": [
			"Syriac"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "sys",
		"Description": [
			"Sinyar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syw",
		"Description": [
			"Kagate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "syx",
		"Description": [
			"Samay"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "syy",
		"Description": [
			"Al-Sayyid Bedouin Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sza",
		"Description": [
			"Semelai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szb",
		"Description": [
			"Ngalum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szc",
		"Description": [
			"Semaq Beri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szd",
		"Description": [
			"Seru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "sze",
		"Description": [
			"Seze"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szg",
		"Description": [
			"Sengele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szl",
		"Description": [
			"Silesian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szn",
		"Description": [
			"Sula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szp",
		"Description": [
			"Suabo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szs",
		"Description": [
			"Solomon Islands Sign Language"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "szv",
		"Description": [
			"Isu (Fako Division)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "szw",
		"Description": [
			"Sawai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "taa",
		"Description": [
			"Lower Tanana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tab",
		"Description": [
			"Tabassaran"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tac",
		"Description": [
			"Lowland Tarahumara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tad",
		"Description": [
			"Tause"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tae",
		"Description": [
			"Tariana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "taf",
		"Description": [
			"Tapirapé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tag",
		"Description": [
			"Tagoi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tai",
		"Description": [
			"Tai languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "taj",
		"Description": [
			"Eastern Tamang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tak",
		"Description": [
			"Tala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tal",
		"Description": [
			"Tal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tan",
		"Description": [
			"Tangale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tao",
		"Description": [
			"Yami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tap",
		"Description": [
			"Taabwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "taq",
		"Description": [
			"Tamasheq"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "tmh"
	},
	{
		"Type": "language",
		"Subtag": "tar",
		"Description": [
			"Central Tarahumara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tas",
		"Description": [
			"Tay Boi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tau",
		"Description": [
			"Upper Tanana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tav",
		"Description": [
			"Tatuyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "taw",
		"Description": [
			"Tai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tax",
		"Description": [
			"Tamki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tay",
		"Description": [
			"Atayal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "taz",
		"Description": [
			"Tocho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tba",
		"Description": [
			"Aikanã"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbb",
		"Description": [
			"Tapeba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbc",
		"Description": [
			"Takia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbd",
		"Description": [
			"Kaki Ae"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbe",
		"Description": [
			"Tanimbili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbf",
		"Description": [
			"Mandara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbg",
		"Description": [
			"North Tairora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbh",
		"Description": [
			"Thurawal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbi",
		"Description": [
			"Gaam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbj",
		"Description": [
			"Tiang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbk",
		"Description": [
			"Calamian Tagbanwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbl",
		"Description": [
			"Tboli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbm",
		"Description": [
			"Tagbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbn",
		"Description": [
			"Barro Negro Tunebo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbo",
		"Description": [
			"Tawala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbp",
		"Description": [
			"Taworta",
			"Diebroud"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbq",
		"Description": [
			"Tibeto-Burman languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "tbr",
		"Description": [
			"Tumtum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbs",
		"Description": [
			"Tanguat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbt",
		"Description": [
			"Tembo (Kitembo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbu",
		"Description": [
			"Tubar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbv",
		"Description": [
			"Tobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbw",
		"Description": [
			"Tagbanwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbx",
		"Description": [
			"Kapin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tby",
		"Description": [
			"Tabaru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tbz",
		"Description": [
			"Ditammari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tca",
		"Description": [
			"Ticuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcb",
		"Description": [
			"Tanacross"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcc",
		"Description": [
			"Datooga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcd",
		"Description": [
			"Tafi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tce",
		"Description": [
			"Southern Tutchone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcf",
		"Description": [
			"Malinaltepec Me'phaa",
			"Malinaltepec Tlapanec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcg",
		"Description": [
			"Tamagario"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tch",
		"Description": [
			"Turks And Caicos Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tci",
		"Description": [
			"Wára"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tck",
		"Description": [
			"Tchitchege"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcl",
		"Description": [
			"Taman (Myanmar)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcm",
		"Description": [
			"Tanahmerah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcn",
		"Description": [
			"Tichurong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tco",
		"Description": [
			"Taungyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcp",
		"Description": [
			"Tawr Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcq",
		"Description": [
			"Kaiy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcs",
		"Description": [
			"Torres Strait Creole"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tct",
		"Description": [
			"T'en"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcu",
		"Description": [
			"Southeastern Tarahumara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcw",
		"Description": [
			"Tecpatlán Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcx",
		"Description": [
			"Toda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcy",
		"Description": [
			"Tulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tcz",
		"Description": [
			"Thado Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tda",
		"Description": [
			"Tagdal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdb",
		"Description": [
			"Panchpargania"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdc",
		"Description": [
			"Emberá-Tadó"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdd",
		"Description": [
			"Tai Nüa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tde",
		"Description": [
			"Tiranige Diga Dogon"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "tdf",
		"Description": [
			"Talieng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdg",
		"Description": [
			"Western Tamang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdh",
		"Description": [
			"Thulung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdi",
		"Description": [
			"Tomadino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdj",
		"Description": [
			"Tajio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdk",
		"Description": [
			"Tambas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdl",
		"Description": [
			"Sur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdm",
		"Description": [
			"Taruma"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "tdn",
		"Description": [
			"Tondano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdo",
		"Description": [
			"Teme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdq",
		"Description": [
			"Tita"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdr",
		"Description": [
			"Todrah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tds",
		"Description": [
			"Doutai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdt",
		"Description": [
			"Tetun Dili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdu",
		"Description": [
			"Tempasuk Dusun"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "dtp"
	},
	{
		"Type": "language",
		"Subtag": "tdv",
		"Description": [
			"Toro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tdx",
		"Description": [
			"Tandroy-Mahafaly Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "tdy",
		"Description": [
			"Tadyawan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tea",
		"Description": [
			"Temiar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "teb",
		"Description": [
			"Tetete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tec",
		"Description": [
			"Terik"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "ted",
		"Description": [
			"Tepo Krumen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tee",
		"Description": [
			"Huehuetla Tepehua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tef",
		"Description": [
			"Teressa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "teg",
		"Description": [
			"Teke-Tege"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "teh",
		"Description": [
			"Tehuelche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tei",
		"Description": [
			"Torricelli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tek",
		"Description": [
			"Ibali Teke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tem",
		"Description": [
			"Timne"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "ten",
		"Description": [
			"Tama (Colombia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "teo",
		"Description": [
			"Teso"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tep",
		"Description": [
			"Tepecano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "teq",
		"Description": [
			"Temein"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ter",
		"Description": [
			"Tereno"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tes",
		"Description": [
			"Tengger"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tet",
		"Description": [
			"Tetum"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "teu",
		"Description": [
			"Soo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tev",
		"Description": [
			"Teor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tew",
		"Description": [
			"Tewa (USA)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tex",
		"Description": [
			"Tennet"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tey",
		"Description": [
			"Tulishi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tfi",
		"Description": [
			"Tofin Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tfn",
		"Description": [
			"Tanaina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tfo",
		"Description": [
			"Tefaro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tfr",
		"Description": [
			"Teribe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tft",
		"Description": [
			"Ternate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tga",
		"Description": [
			"Sagalla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgb",
		"Description": [
			"Tobilung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgc",
		"Description": [
			"Tigak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgd",
		"Description": [
			"Ciwogai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tge",
		"Description": [
			"Eastern Gorkha Tamang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgf",
		"Description": [
			"Chalikha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgg",
		"Description": [
			"Tangga"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see bjp, hrc, hrw"
		]
	},
	{
		"Type": "language",
		"Subtag": "tgh",
		"Description": [
			"Tobagonian Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgi",
		"Description": [
			"Lawunuia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgj",
		"Description": [
			"Tagin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "tgn",
		"Description": [
			"Tandaganon"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "tgo",
		"Description": [
			"Sudest"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgp",
		"Description": [
			"Tangoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgq",
		"Description": [
			"Tring"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgr",
		"Description": [
			"Tareng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgs",
		"Description": [
			"Nume"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgt",
		"Description": [
			"Central Tagbanwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgu",
		"Description": [
			"Tanggu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgv",
		"Description": [
			"Tingui-Boto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgw",
		"Description": [
			"Tagwana Senoufo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgx",
		"Description": [
			"Tagish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgy",
		"Description": [
			"Togoyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tgz",
		"Description": [
			"Tagalaka"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "thc",
		"Description": [
			"Tai Hang Tong"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "tpo"
	},
	{
		"Type": "language",
		"Subtag": "thd",
		"Description": [
			"Thayore"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "the",
		"Description": [
			"Chitwania Tharu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thf",
		"Description": [
			"Thangmi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thh",
		"Description": [
			"Northern Tarahumara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thi",
		"Description": [
			"Tai Long"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thk",
		"Description": [
			"Tharaka",
			"Kitharaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thl",
		"Description": [
			"Dangaura Tharu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thm",
		"Description": [
			"Aheu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thn",
		"Description": [
			"Thachanadan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thp",
		"Description": [
			"Thompson"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thq",
		"Description": [
			"Kochila Tharu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thr",
		"Description": [
			"Rana Tharu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ths",
		"Description": [
			"Thakali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tht",
		"Description": [
			"Tahltan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thu",
		"Description": [
			"Thuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thv",
		"Description": [
			"Tahaggart Tamahaq"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "tmh"
	},
	{
		"Type": "language",
		"Subtag": "thw",
		"Description": [
			"Thudam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thx",
		"Description": [
			"The"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "oyb"
	},
	{
		"Type": "language",
		"Subtag": "thy",
		"Description": [
			"Tha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "thz",
		"Description": [
			"Tayart Tamajeq"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "tmh"
	},
	{
		"Type": "language",
		"Subtag": "tia",
		"Description": [
			"Tidikelt Tamazight"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tic",
		"Description": [
			"Tira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tid",
		"Description": [
			"Tidong"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Comments": [
			"see itd, ntd"
		]
	},
	{
		"Type": "language",
		"Subtag": "tie",
		"Description": [
			"Tingal"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16",
		"Preferred-Value": "ras"
	},
	{
		"Type": "language",
		"Subtag": "tif",
		"Description": [
			"Tifal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tig",
		"Description": [
			"Tigre"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tih",
		"Description": [
			"Timugon Murut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tii",
		"Description": [
			"Tiene"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tij",
		"Description": [
			"Tilung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tik",
		"Description": [
			"Tikar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "til",
		"Description": [
			"Tillamook"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tim",
		"Description": [
			"Timbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tin",
		"Description": [
			"Tindi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tio",
		"Description": [
			"Teop"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tip",
		"Description": [
			"Trimuris"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tiq",
		"Description": [
			"Tiéfo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tis",
		"Description": [
			"Masadiit Itneg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tit",
		"Description": [
			"Tinigua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tiu",
		"Description": [
			"Adasen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tiv",
		"Description": [
			"Tiv"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tiw",
		"Description": [
			"Tiwi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tix",
		"Description": [
			"Southern Tiwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tiy",
		"Description": [
			"Tiruray"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tiz",
		"Description": [
			"Tai Hongjin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tja",
		"Description": [
			"Tajuasohn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tjg",
		"Description": [
			"Tunjung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tji",
		"Description": [
			"Northern Tujia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tjl",
		"Description": [
			"Tai Laing"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "tjm",
		"Description": [
			"Timucua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tjn",
		"Description": [
			"Tonjon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tjo",
		"Description": [
			"Temacine Tamazight"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tjs",
		"Description": [
			"Southern Tujia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tju",
		"Description": [
			"Tjurruru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tjw",
		"Description": [
			"Djabwurrung"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "tka",
		"Description": [
			"Truká"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkb",
		"Description": [
			"Buksa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkd",
		"Description": [
			"Tukudede"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tke",
		"Description": [
			"Takwane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkf",
		"Description": [
			"Tukumanféd"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkg",
		"Description": [
			"Tesaka Malagasy"
		],
		"Added": "2011-08-16",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "tkk",
		"Description": [
			"Takpa"
		],
		"Added": "2009-07-29",
		"Deprecated": "2011-08-16",
		"Preferred-Value": "twm"
	},
	{
		"Type": "language",
		"Subtag": "tkl",
		"Description": [
			"Tokelau"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "tkm",
		"Description": [
			"Takelma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkn",
		"Description": [
			"Toku-No-Shima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkp",
		"Description": [
			"Tikopia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkq",
		"Description": [
			"Tee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkr",
		"Description": [
			"Tsakhur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tks",
		"Description": [
			"Takestani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkt",
		"Description": [
			"Kathoriya Tharu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tku",
		"Description": [
			"Upper Necaxa Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkv",
		"Description": [
			"Mur Pano"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "tkw",
		"Description": [
			"Teanu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkx",
		"Description": [
			"Tangko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tkz",
		"Description": [
			"Takua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tla",
		"Description": [
			"Southwestern Tepehuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlb",
		"Description": [
			"Tobelo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlc",
		"Description": [
			"Yecuatla Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tld",
		"Description": [
			"Talaud"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlf",
		"Description": [
			"Telefol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlg",
		"Description": [
			"Tofanma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlh",
		"Description": [
			"Klingon",
			"tlhIngan-Hol"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tli",
		"Description": [
			"Tlingit"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tlj",
		"Description": [
			"Talinga-Bwisi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlk",
		"Description": [
			"Taloki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tll",
		"Description": [
			"Tetela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlm",
		"Description": [
			"Tolomako"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tln",
		"Description": [
			"Talondo'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlo",
		"Description": [
			"Talodi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlp",
		"Description": [
			"Filomena Mata-Coahuitlán Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlq",
		"Description": [
			"Tai Loi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlr",
		"Description": [
			"Talise"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tls",
		"Description": [
			"Tambotalo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlt",
		"Description": [
			"Sou Nama",
			"Teluti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlu",
		"Description": [
			"Tulehu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlv",
		"Description": [
			"Taliabu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tlw",
		"Description": [
			"South Wemale"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "weo"
	},
	{
		"Type": "language",
		"Subtag": "tlx",
		"Description": [
			"Khehek"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tly",
		"Description": [
			"Talysh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tma",
		"Description": [
			"Tama (Chad)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmb",
		"Description": [
			"Katbol",
			"Avava"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmc",
		"Description": [
			"Tumak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmd",
		"Description": [
			"Haruai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tme",
		"Description": [
			"Tremembé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmf",
		"Description": [
			"Toba-Maskoy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmg",
		"Description": [
			"Ternateño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmh",
		"Description": [
			"Tamashek"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "tmi",
		"Description": [
			"Tutuba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmj",
		"Description": [
			"Samarokena"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmk",
		"Description": [
			"Northwestern Tamang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tml",
		"Description": [
			"Tamnim Citak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmm",
		"Description": [
			"Tai Thanh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmn",
		"Description": [
			"Taman (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmo",
		"Description": [
			"Temoq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmp",
		"Description": [
			"Tai Mène"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "tyj"
	},
	{
		"Type": "language",
		"Subtag": "tmq",
		"Description": [
			"Tumleo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmr",
		"Description": [
			"Jewish Babylonian Aramaic (ca. 200-1200 CE)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tms",
		"Description": [
			"Tima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmt",
		"Description": [
			"Tasmate"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmu",
		"Description": [
			"Iau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmv",
		"Description": [
			"Tembo (Motembo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmw",
		"Description": [
			"Temuan"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "tmy",
		"Description": [
			"Tami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tmz",
		"Description": [
			"Tamanaku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tna",
		"Description": [
			"Tacana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnb",
		"Description": [
			"Western Tunebo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnc",
		"Description": [
			"Tanimuca-Retuarã"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnd",
		"Description": [
			"Angosturas Tunebo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tne",
		"Description": [
			"Tinoc Kallahan"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "kak"
	},
	{
		"Type": "language",
		"Subtag": "tnf",
		"Description": [
			"Tangshewi"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Preferred-Value": "prs"
	},
	{
		"Type": "language",
		"Subtag": "tng",
		"Description": [
			"Tobanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnh",
		"Description": [
			"Maiani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tni",
		"Description": [
			"Tandia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnk",
		"Description": [
			"Kwamera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnl",
		"Description": [
			"Lenakel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnm",
		"Description": [
			"Tabla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnn",
		"Description": [
			"North Tanna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tno",
		"Description": [
			"Toromono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnp",
		"Description": [
			"Whitesands"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnq",
		"Description": [
			"Taino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnr",
		"Description": [
			"Ménik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tns",
		"Description": [
			"Tenis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnt",
		"Description": [
			"Tontemboan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnu",
		"Description": [
			"Tay Khang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnv",
		"Description": [
			"Tangchangya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnw",
		"Description": [
			"Tonsawang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnx",
		"Description": [
			"Tanema"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tny",
		"Description": [
			"Tongwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tnz",
		"Description": [
			"Ten'edn"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tob",
		"Description": [
			"Toba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "toc",
		"Description": [
			"Coyutla Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tod",
		"Description": [
			"Toma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "toe",
		"Description": [
			"Tomedes"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "tof",
		"Description": [
			"Gizrra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tog",
		"Description": [
			"Tonga (Nyasa)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "toh",
		"Description": [
			"Gitonga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "toi",
		"Description": [
			"Tonga (Zambia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "toj",
		"Description": [
			"Tojolabal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tol",
		"Description": [
			"Tolowa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tom",
		"Description": [
			"Tombulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "too",
		"Description": [
			"Xicotepec De Juárez Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "top",
		"Description": [
			"Papantla Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "toq",
		"Description": [
			"Toposa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tor",
		"Description": [
			"Togbo-Vara Banda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tos",
		"Description": [
			"Highland Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tou",
		"Description": [
			"Tho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tov",
		"Description": [
			"Upper Taromi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tow",
		"Description": [
			"Jemez"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tox",
		"Description": [
			"Tobian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "toy",
		"Description": [
			"Topoiyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "toz",
		"Description": [
			"To"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpa",
		"Description": [
			"Taupota"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpc",
		"Description": [
			"Azoyú Me'phaa",
			"Azoyú Tlapanec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpe",
		"Description": [
			"Tippera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpf",
		"Description": [
			"Tarpia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpg",
		"Description": [
			"Kula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpi",
		"Description": [
			"Tok Pisin"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "tpj",
		"Description": [
			"Tapieté"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpk",
		"Description": [
			"Tupinikin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpl",
		"Description": [
			"Tlacoapa Me'phaa",
			"Tlacoapa Tlapanec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpm",
		"Description": [
			"Tampulma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpn",
		"Description": [
			"Tupinambá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpo",
		"Description": [
			"Tai Pao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpp",
		"Description": [
			"Pisaflores Tepehua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpq",
		"Description": [
			"Tukpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpr",
		"Description": [
			"Tuparí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpt",
		"Description": [
			"Tlachichilco Tepehua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpu",
		"Description": [
			"Tampuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpv",
		"Description": [
			"Tanapag"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpw",
		"Description": [
			"Tupí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpx",
		"Description": [
			"Acatepec Me'phaa",
			"Acatepec Tlapanec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpy",
		"Description": [
			"Trumai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tpz",
		"Description": [
			"Tinputz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqb",
		"Description": [
			"Tembé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tql",
		"Description": [
			"Lehali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqm",
		"Description": [
			"Turumsa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqn",
		"Description": [
			"Tenino"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqo",
		"Description": [
			"Toaripi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqp",
		"Description": [
			"Tomoip"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqq",
		"Description": [
			"Tunni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqr",
		"Description": [
			"Torona"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqt",
		"Description": [
			"Western Totonac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqu",
		"Description": [
			"Touo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tqw",
		"Description": [
			"Tonkawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tra",
		"Description": [
			"Tirahi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trb",
		"Description": [
			"Terebu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trc",
		"Description": [
			"Copala Triqui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trd",
		"Description": [
			"Turi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tre",
		"Description": [
			"East Tarangan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trf",
		"Description": [
			"Trinidadian Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trg",
		"Description": [
			"Lishán Didán"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trh",
		"Description": [
			"Turaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tri",
		"Description": [
			"Trió"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trj",
		"Description": [
			"Toram"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trk",
		"Description": [
			"Turkic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "trl",
		"Description": [
			"Traveller Scottish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trm",
		"Description": [
			"Tregami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trn",
		"Description": [
			"Trinitario"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tro",
		"Description": [
			"Tarao Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trp",
		"Description": [
			"Kok Borok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trq",
		"Description": [
			"San Martín Itunyoso Triqui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trr",
		"Description": [
			"Taushiro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trs",
		"Description": [
			"Chicahuaxtla Triqui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trt",
		"Description": [
			"Tunggare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tru",
		"Description": [
			"Turoyo",
			"Surayt"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trv",
		"Description": [
			"Taroko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trw",
		"Description": [
			"Torwali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trx",
		"Description": [
			"Tringgus-Sembaan Bidayuh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "try",
		"Description": [
			"Turung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "trz",
		"Description": [
			"Torá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsa",
		"Description": [
			"Tsaangi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsb",
		"Description": [
			"Tsamai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsc",
		"Description": [
			"Tswa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsd",
		"Description": [
			"Tsakonian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tse",
		"Description": [
			"Tunisian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsf",
		"Description": [
			"Southwestern Tamang"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "taj"
	},
	{
		"Type": "language",
		"Subtag": "tsg",
		"Description": [
			"Tausug"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsh",
		"Description": [
			"Tsuvan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsi",
		"Description": [
			"Tsimshian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tsj",
		"Description": [
			"Tshangla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsk",
		"Description": [
			"Tseku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsl",
		"Description": [
			"Ts'ün-Lao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsm",
		"Description": [
			"Turkish Sign Language",
			"Türk İşaret Dili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsp",
		"Description": [
			"Northern Toussian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsq",
		"Description": [
			"Thai Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsr",
		"Description": [
			"Akei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tss",
		"Description": [
			"Taiwan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tst",
		"Description": [
			"Tondi Songway Kiini"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "tsu",
		"Description": [
			"Tsou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsv",
		"Description": [
			"Tsogo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsw",
		"Description": [
			"Tsishingini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsx",
		"Description": [
			"Mubami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsy",
		"Description": [
			"Tebul Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tsz",
		"Description": [
			"Purepecha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tta",
		"Description": [
			"Tutelo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttb",
		"Description": [
			"Gaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttc",
		"Description": [
			"Tektiteko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttd",
		"Description": [
			"Tauade"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tte",
		"Description": [
			"Bwanabwana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttf",
		"Description": [
			"Tuotomb"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttg",
		"Description": [
			"Tutong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tth",
		"Description": [
			"Upper Ta'oih"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tti",
		"Description": [
			"Tobati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttj",
		"Description": [
			"Tooro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttk",
		"Description": [
			"Totoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttl",
		"Description": [
			"Totela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttm",
		"Description": [
			"Northern Tutchone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttn",
		"Description": [
			"Towei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tto",
		"Description": [
			"Lower Ta'oih"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttp",
		"Description": [
			"Tombelala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttq",
		"Description": [
			"Tawallammat Tamajaq"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "tmh"
	},
	{
		"Type": "language",
		"Subtag": "ttr",
		"Description": [
			"Tera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tts",
		"Description": [
			"Northeastern Thai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttt",
		"Description": [
			"Muslim Tat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttu",
		"Description": [
			"Torau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttv",
		"Description": [
			"Titan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttw",
		"Description": [
			"Long Wat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tty",
		"Description": [
			"Sikaritai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ttz",
		"Description": [
			"Tsum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tua",
		"Description": [
			"Wiarumus"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tub",
		"Description": [
			"Tübatulabal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuc",
		"Description": [
			"Mutu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tud",
		"Description": [
			"Tuxá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tue",
		"Description": [
			"Tuyuca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuf",
		"Description": [
			"Central Tunebo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tug",
		"Description": [
			"Tunia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuh",
		"Description": [
			"Taulil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tui",
		"Description": [
			"Tupuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuj",
		"Description": [
			"Tugutil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tul",
		"Description": [
			"Tula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tum",
		"Description": [
			"Tumbuka"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tun",
		"Description": [
			"Tunica"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuo",
		"Description": [
			"Tucano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tup",
		"Description": [
			"Tupi languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "tuq",
		"Description": [
			"Tedaga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tus",
		"Description": [
			"Tuscarora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tut",
		"Description": [
			"Altaic languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "tuu",
		"Description": [
			"Tututni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuv",
		"Description": [
			"Turkana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuw",
		"Description": [
			"Tungus languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "tux",
		"Description": [
			"Tuxináwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tuy",
		"Description": [
			"Tugen"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kln"
	},
	{
		"Type": "language",
		"Subtag": "tuz",
		"Description": [
			"Turka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tva",
		"Description": [
			"Vaghua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvd",
		"Description": [
			"Tsuvadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tve",
		"Description": [
			"Te'un"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvk",
		"Description": [
			"Southeast Ambrym"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvl",
		"Description": [
			"Tuvalu"
		],
		"Added": "2005-10-16",
		"Suppress-Script": "Latn"
	},
	{
		"Type": "language",
		"Subtag": "tvm",
		"Description": [
			"Tela-Masbuar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvn",
		"Description": [
			"Tavoyan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvo",
		"Description": [
			"Tidore"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvs",
		"Description": [
			"Taveta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvt",
		"Description": [
			"Tutsa Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvu",
		"Description": [
			"Tunen"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "tvw",
		"Description": [
			"Sedoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tvy",
		"Description": [
			"Timor Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twa",
		"Description": [
			"Twana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twb",
		"Description": [
			"Western Tawbuid"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twc",
		"Description": [
			"Teshenawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twd",
		"Description": [
			"Twents"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twe",
		"Description": [
			"Tewa (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twf",
		"Description": [
			"Northern Tiwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twg",
		"Description": [
			"Tereweng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twh",
		"Description": [
			"Tai Dón"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twl",
		"Description": [
			"Tawara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twm",
		"Description": [
			"Tawang Monpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twn",
		"Description": [
			"Twendi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "two",
		"Description": [
			"Tswapong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twp",
		"Description": [
			"Ere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twq",
		"Description": [
			"Tasawaq"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twr",
		"Description": [
			"Southwestern Tarahumara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twt",
		"Description": [
			"Turiwára"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twu",
		"Description": [
			"Termanu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tww",
		"Description": [
			"Tuwari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twx",
		"Description": [
			"Tewe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "twy",
		"Description": [
			"Tawoyan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txa",
		"Description": [
			"Tombonuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txb",
		"Description": [
			"Tokharian B"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txc",
		"Description": [
			"Tsetsaut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txe",
		"Description": [
			"Totoli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txg",
		"Description": [
			"Tangut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txh",
		"Description": [
			"Thracian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txi",
		"Description": [
			"Ikpeng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txj",
		"Description": [
			"Tarjumo"
		],
		"Added": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "txm",
		"Description": [
			"Tomini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txn",
		"Description": [
			"West Tarangan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txo",
		"Description": [
			"Toto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txq",
		"Description": [
			"Tii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txr",
		"Description": [
			"Tartessian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txs",
		"Description": [
			"Tonsea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txt",
		"Description": [
			"Citak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txu",
		"Description": [
			"Kayapó"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txx",
		"Description": [
			"Tatana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "txy",
		"Description": [
			"Tanosy Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "tya",
		"Description": [
			"Tauya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tye",
		"Description": [
			"Kyanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyh",
		"Description": [
			"O'du"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyi",
		"Description": [
			"Teke-Tsaayi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyj",
		"Description": [
			"Tai Do",
			"Tai Yo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyl",
		"Description": [
			"Thu Lao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyn",
		"Description": [
			"Kombai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "typ",
		"Description": [
			"Thaypan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyr",
		"Description": [
			"Tai Daeng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tys",
		"Description": [
			"Tày Sa Pa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyt",
		"Description": [
			"Tày Tac"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyu",
		"Description": [
			"Kua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyv",
		"Description": [
			"Tuvinian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "tyx",
		"Description": [
			"Teke-Tyee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tyz",
		"Description": [
			"Tày"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tza",
		"Description": [
			"Tanzanian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tzh",
		"Description": [
			"Tzeltal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tzj",
		"Description": [
			"Tz'utujil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tzl",
		"Description": [
			"Talossan"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "tzm",
		"Description": [
			"Central Atlas Tamazight"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tzn",
		"Description": [
			"Tugun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tzo",
		"Description": [
			"Tzotzil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "tzx",
		"Description": [
			"Tabriak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uam",
		"Description": [
			"Uamué"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uan",
		"Description": [
			"Kuan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uar",
		"Description": [
			"Tairuma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uba",
		"Description": [
			"Ubang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ubi",
		"Description": [
			"Ubi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ubl",
		"Description": [
			"Buhi'non Bikol"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bik"
	},
	{
		"Type": "language",
		"Subtag": "ubr",
		"Description": [
			"Ubir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ubu",
		"Description": [
			"Umbu-Ungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uby",
		"Description": [
			"Ubykh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uda",
		"Description": [
			"Uda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ude",
		"Description": [
			"Udihe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "udg",
		"Description": [
			"Muduga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "udi",
		"Description": [
			"Udi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "udj",
		"Description": [
			"Ujir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "udl",
		"Description": [
			"Wuzlam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "udm",
		"Description": [
			"Udmurt"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "udu",
		"Description": [
			"Uduk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ues",
		"Description": [
			"Kioko"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ufi",
		"Description": [
			"Ufim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uga",
		"Description": [
			"Ugaritic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "ugb",
		"Description": [
			"Kuku-Ugbanh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uge",
		"Description": [
			"Ughele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ugn",
		"Description": [
			"Ugandan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ugo",
		"Description": [
			"Ugong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ugy",
		"Description": [
			"Uruguayan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uha",
		"Description": [
			"Uhami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uhn",
		"Description": [
			"Damal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uis",
		"Description": [
			"Uisai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uiv",
		"Description": [
			"Iyive"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uji",
		"Description": [
			"Tanjijili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uka",
		"Description": [
			"Kaburi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ukg",
		"Description": [
			"Ukuriguma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ukh",
		"Description": [
			"Ukhwejo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ukk",
		"Description": [
			"Muak Sa-aak"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "ukl",
		"Description": [
			"Ukrainian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ukp",
		"Description": [
			"Ukpe-Bayobiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ukq",
		"Description": [
			"Ukwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uks",
		"Description": [
			"Urubú-Kaapor Sign Language",
			"Kaapor Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uku",
		"Description": [
			"Ukue"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ukw",
		"Description": [
			"Ukwuani-Aboh-Ndoni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uky",
		"Description": [
			"Kuuk-Yak"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "ula",
		"Description": [
			"Fungwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ulb",
		"Description": [
			"Ulukwumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ulc",
		"Description": [
			"Ulch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ule",
		"Description": [
			"Lule"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ulf",
		"Description": [
			"Usku",
			"Afra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uli",
		"Description": [
			"Ulithian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ulk",
		"Description": [
			"Meriam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ull",
		"Description": [
			"Ullatan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ulm",
		"Description": [
			"Ulumanda'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uln",
		"Description": [
			"Unserdeutsch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ulu",
		"Description": [
			"Uma' Lung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ulw",
		"Description": [
			"Ulwa"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "uma",
		"Description": [
			"Umatilla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umb",
		"Description": [
			"Umbundu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "umc",
		"Description": [
			"Marrucinian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umd",
		"Description": [
			"Umbindhamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umg",
		"Description": [
			"Umbuygamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umi",
		"Description": [
			"Ukit"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umm",
		"Description": [
			"Umon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umn",
		"Description": [
			"Makyan Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umo",
		"Description": [
			"Umotína"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ump",
		"Description": [
			"Umpila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umr",
		"Description": [
			"Umbugarla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ums",
		"Description": [
			"Pendau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "umu",
		"Description": [
			"Munsee"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "del"
	},
	{
		"Type": "language",
		"Subtag": "una",
		"Description": [
			"North Watut"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "und",
		"Description": [
			"Undetermined"
		],
		"Added": "2005-10-16",
		"Scope": "special"
	},
	{
		"Type": "language",
		"Subtag": "une",
		"Description": [
			"Uneme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ung",
		"Description": [
			"Ngarinyin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "unk",
		"Description": [
			"Enawené-Nawé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "unm",
		"Description": [
			"Unami"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "del"
	},
	{
		"Type": "language",
		"Subtag": "unn",
		"Description": [
			"Kurnai"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "unp",
		"Description": [
			"Worora"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see wro, xgu"
		]
	},
	{
		"Type": "language",
		"Subtag": "unr",
		"Description": [
			"Mundari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "unu",
		"Description": [
			"Unubahe"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "unx",
		"Description": [
			"Munda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "unz",
		"Description": [
			"Unde Kaili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uok",
		"Description": [
			"Uokha"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "ema"
	},
	{
		"Type": "language",
		"Subtag": "upi",
		"Description": [
			"Umeda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "upv",
		"Description": [
			"Uripiv-Wala-Rano-Atchin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ura",
		"Description": [
			"Urarina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urb",
		"Description": [
			"Urubú-Kaapor",
			"Kaapor"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urc",
		"Description": [
			"Urningangg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ure",
		"Description": [
			"Uru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urf",
		"Description": [
			"Uradhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urg",
		"Description": [
			"Urigina"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urh",
		"Description": [
			"Urhobo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uri",
		"Description": [
			"Urim"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urj",
		"Description": [
			"Uralic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "urk",
		"Description": [
			"Urak Lawoi'"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "url",
		"Description": [
			"Urali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urm",
		"Description": [
			"Urapmin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urn",
		"Description": [
			"Uruangnirin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uro",
		"Description": [
			"Ura (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urp",
		"Description": [
			"Uru-Pa-In"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urr",
		"Description": [
			"Lehalurup",
			"Löyöp"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urt",
		"Description": [
			"Urat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uru",
		"Description": [
			"Urumi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urv",
		"Description": [
			"Uruava"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urw",
		"Description": [
			"Sop"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urx",
		"Description": [
			"Urimo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ury",
		"Description": [
			"Orya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "urz",
		"Description": [
			"Uru-Eu-Wau-Wau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "usa",
		"Description": [
			"Usarufa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ush",
		"Description": [
			"Ushojo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "usi",
		"Description": [
			"Usui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "usk",
		"Description": [
			"Usaghade"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "usp",
		"Description": [
			"Uspanteco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "usu",
		"Description": [
			"Uya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uta",
		"Description": [
			"Otank"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ute",
		"Description": [
			"Ute-Southern Paiute"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "utp",
		"Description": [
			"Amba (Solomon Islands)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "utr",
		"Description": [
			"Etulo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "utu",
		"Description": [
			"Utu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uum",
		"Description": [
			"Urum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uun",
		"Description": [
			"Kulon-Pazeh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uur",
		"Description": [
			"Ura (Vanuatu)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uuu",
		"Description": [
			"U"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uve",
		"Description": [
			"West Uvean",
			"Fagauvea"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uvh",
		"Description": [
			"Uri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uvl",
		"Description": [
			"Lote"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uwa",
		"Description": [
			"Kuku-Uwanh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uya",
		"Description": [
			"Doko-Uyanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "uzn",
		"Description": [
			"Northern Uzbek"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "uz"
	},
	{
		"Type": "language",
		"Subtag": "uzs",
		"Description": [
			"Southern Uzbek"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "uz"
	},
	{
		"Type": "language",
		"Subtag": "vaa",
		"Description": [
			"Vaagri Booli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vae",
		"Description": [
			"Vale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vaf",
		"Description": [
			"Vafsi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vag",
		"Description": [
			"Vagla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vah",
		"Description": [
			"Varhadi-Nagpuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vai",
		"Description": [
			"Vai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "vaj",
		"Description": [
			"Sekele",
			"Northwestern !Kung",
			"Northwestern ǃKung",
			"Vasekele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "val",
		"Description": [
			"Vehes"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vam",
		"Description": [
			"Vanimo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "van",
		"Description": [
			"Valman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vao",
		"Description": [
			"Vao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vap",
		"Description": [
			"Vaiphei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "var",
		"Description": [
			"Huarijio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vas",
		"Description": [
			"Vasavi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vau",
		"Description": [
			"Vanuma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vav",
		"Description": [
			"Varli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vay",
		"Description": [
			"Wayu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vbb",
		"Description": [
			"Southeast Babar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vbk",
		"Description": [
			"Southwestern Bontok"
		],
		"Added": "2010-03-11",
		"Macrolanguage": "bnc"
	},
	{
		"Type": "language",
		"Subtag": "vec",
		"Description": [
			"Venetian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ved",
		"Description": [
			"Veddah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vel",
		"Description": [
			"Veluws"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vem",
		"Description": [
			"Vemgo-Mabas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "veo",
		"Description": [
			"Ventureño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vep",
		"Description": [
			"Veps"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ver",
		"Description": [
			"Mom Jango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vgr",
		"Description": [
			"Vaghri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vgt",
		"Description": [
			"Vlaamse Gebarentaal",
			"Flemish Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vic",
		"Description": [
			"Virgin Islands Creole English"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vid",
		"Description": [
			"Vidunda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vif",
		"Description": [
			"Vili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vig",
		"Description": [
			"Viemo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vil",
		"Description": [
			"Vilela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vin",
		"Description": [
			"Vinza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vis",
		"Description": [
			"Vishavan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vit",
		"Description": [
			"Viti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "viv",
		"Description": [
			"Iduna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vka",
		"Description": [
			"Kariyarra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vki",
		"Description": [
			"Ija-Zuba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vkj",
		"Description": [
			"Kujarge"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vkk",
		"Description": [
			"Kaur"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "vkl",
		"Description": [
			"Kulisusu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vkm",
		"Description": [
			"Kamakan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vko",
		"Description": [
			"Kodeoha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vkp",
		"Description": [
			"Korlai Creole Portuguese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vkt",
		"Description": [
			"Tenggarong Kutai Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "vku",
		"Description": [
			"Kurrama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vlp",
		"Description": [
			"Valpei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vls",
		"Description": [
			"Vlaams"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vma",
		"Description": [
			"Martuyhunira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmb",
		"Description": [
			"Barbaram"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmc",
		"Description": [
			"Juxtlahuaca Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmd",
		"Description": [
			"Mudu Koraga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vme",
		"Description": [
			"East Masela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmf",
		"Description": [
			"Mainfränkisch"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmg",
		"Description": [
			"Lungalunga"
		],
		"Added": "2009-07-29",
		"Comments": [
			"see also bxf"
		]
	},
	{
		"Type": "language",
		"Subtag": "vmh",
		"Description": [
			"Maraghei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmi",
		"Description": [
			"Miwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmj",
		"Description": [
			"Ixtayutla Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmk",
		"Description": [
			"Makhuwa-Shirima"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vml",
		"Description": [
			"Malgana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmm",
		"Description": [
			"Mitlatongo Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmp",
		"Description": [
			"Soyaltepec Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmq",
		"Description": [
			"Soyaltepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmr",
		"Description": [
			"Marenje"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vms",
		"Description": [
			"Moksela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmu",
		"Description": [
			"Muluridyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmv",
		"Description": [
			"Valley Maidu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmw",
		"Description": [
			"Makhuwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmx",
		"Description": [
			"Tamazola Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmy",
		"Description": [
			"Ayautla Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vmz",
		"Description": [
			"Mazatlán Mazatec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vnk",
		"Description": [
			"Vano",
			"Lovono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vnm",
		"Description": [
			"Vinmavis",
			"Neve'ei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vnp",
		"Description": [
			"Vunapu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vor",
		"Description": [
			"Voro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vot",
		"Description": [
			"Votic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "vra",
		"Description": [
			"Vera'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vro",
		"Description": [
			"Võro"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "et"
	},
	{
		"Type": "language",
		"Subtag": "vrs",
		"Description": [
			"Varisi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vrt",
		"Description": [
			"Burmbar",
			"Banam Bay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vsi",
		"Description": [
			"Moldova Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vsl",
		"Description": [
			"Venezuelan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vsv",
		"Description": [
			"Valencian Sign Language",
			"Llengua de signes valenciana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vto",
		"Description": [
			"Vitou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vum",
		"Description": [
			"Vumbu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vun",
		"Description": [
			"Vunjo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vut",
		"Description": [
			"Vute"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "vwa",
		"Description": [
			"Awa (China)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "waa",
		"Description": [
			"Walla Walla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wab",
		"Description": [
			"Wab"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wac",
		"Description": [
			"Wasco-Wishram"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wad",
		"Description": [
			"Wandamen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wae",
		"Description": [
			"Walser"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "waf",
		"Description": [
			"Wakoná"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wag",
		"Description": [
			"Wa'ema"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wah",
		"Description": [
			"Watubela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wai",
		"Description": [
			"Wares"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "waj",
		"Description": [
			"Waffa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wak",
		"Description": [
			"Wakashan languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "wal",
		"Description": [
			"Wolaytta",
			"Wolaitta"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "wam",
		"Description": [
			"Wampanoag"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wan",
		"Description": [
			"Wan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wao",
		"Description": [
			"Wappo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wap",
		"Description": [
			"Wapishana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "waq",
		"Description": [
			"Wageman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "war",
		"Description": [
			"Waray (Philippines)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "was",
		"Description": [
			"Washo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "wat",
		"Description": [
			"Kaninuwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wau",
		"Description": [
			"Waurá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wav",
		"Description": [
			"Waka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "waw",
		"Description": [
			"Waiwai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wax",
		"Description": [
			"Watam",
			"Marangis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "way",
		"Description": [
			"Wayana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "waz",
		"Description": [
			"Wampur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wba",
		"Description": [
			"Warao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbb",
		"Description": [
			"Wabo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbe",
		"Description": [
			"Waritai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbf",
		"Description": [
			"Wara"
		],
		"Added": "2009-07-29",
		"Comments": [
			"see also pnl"
		]
	},
	{
		"Type": "language",
		"Subtag": "wbh",
		"Description": [
			"Wanda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbi",
		"Description": [
			"Vwanji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbj",
		"Description": [
			"Alagwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbk",
		"Description": [
			"Waigali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbl",
		"Description": [
			"Wakhi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbm",
		"Description": [
			"Wa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbp",
		"Description": [
			"Warlpiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbq",
		"Description": [
			"Waddar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbr",
		"Description": [
			"Wagdi"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "raj"
	},
	{
		"Type": "language",
		"Subtag": "wbs",
		"Description": [
			"West Bengal Sign Language"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "wbt",
		"Description": [
			"Wanman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbv",
		"Description": [
			"Wajarri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wbw",
		"Description": [
			"Woi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wca",
		"Description": [
			"Yanomámi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wci",
		"Description": [
			"Waci Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wdd",
		"Description": [
			"Wandji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wdg",
		"Description": [
			"Wadaginam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wdj",
		"Description": [
			"Wadjiginy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wdk",
		"Description": [
			"Wadikali"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wdu",
		"Description": [
			"Wadjigu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wdy",
		"Description": [
			"Wadjabangayi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wea",
		"Description": [
			"Wewaw"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wec",
		"Description": [
			"Wè Western"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wed",
		"Description": [
			"Wedau"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "weg",
		"Description": [
			"Wergaia"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "weh",
		"Description": [
			"Weh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wei",
		"Description": [
			"Kiunum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wem",
		"Description": [
			"Weme Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wen",
		"Description": [
			"Sorbian languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "weo",
		"Description": [
			"Wemale"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wep",
		"Description": [
			"Westphalien"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wer",
		"Description": [
			"Weri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wes",
		"Description": [
			"Cameroon Pidgin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wet",
		"Description": [
			"Perai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "weu",
		"Description": [
			"Rawngtu Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wew",
		"Description": [
			"Wejewa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wfg",
		"Description": [
			"Yafi",
			"Zorop"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wga",
		"Description": [
			"Wagaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wgb",
		"Description": [
			"Wagawaga"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "wgg",
		"Description": [
			"Wangganguru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wgi",
		"Description": [
			"Wahgi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wgo",
		"Description": [
			"Waigeo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wgu",
		"Description": [
			"Wirangu"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "wgw",
		"Description": [
			"Wagawaga"
		],
		"Added": "2009-07-29",
		"Deprecated": "2010-03-11",
		"Comments": [
			"see wgb, ylb"
		]
	},
	{
		"Type": "language",
		"Subtag": "wgy",
		"Description": [
			"Warrgamay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wha",
		"Description": [
			"Sou Upaa",
			"Manusela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "whg",
		"Description": [
			"North Wahgi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "whk",
		"Description": [
			"Wahau Kenyah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "whu",
		"Description": [
			"Wahau Kayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wib",
		"Description": [
			"Southern Toussian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wic",
		"Description": [
			"Wichita"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wie",
		"Description": [
			"Wik-Epa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wif",
		"Description": [
			"Wik-Keyangan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wig",
		"Description": [
			"Wik-Ngathana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wih",
		"Description": [
			"Wik-Me'anha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wii",
		"Description": [
			"Minidien"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wij",
		"Description": [
			"Wik-Iiyanh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wik",
		"Description": [
			"Wikalkan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wil",
		"Description": [
			"Wilawila"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wim",
		"Description": [
			"Wik-Mungkan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "win",
		"Description": [
			"Ho-Chunk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wir",
		"Description": [
			"Wiraféd"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wit",
		"Description": [
			"Wintu"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see nol, pwi, wnw"
		]
	},
	{
		"Type": "language",
		"Subtag": "wiu",
		"Description": [
			"Wiru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wiv",
		"Description": [
			"Vitu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wiw",
		"Description": [
			"Wirangu"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see nwo, wgu"
		]
	},
	{
		"Type": "language",
		"Subtag": "wiy",
		"Description": [
			"Wiyot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wja",
		"Description": [
			"Waja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wji",
		"Description": [
			"Warji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wka",
		"Description": [
			"Kw'adza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wkb",
		"Description": [
			"Kumbaran"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wkd",
		"Description": [
			"Wakde",
			"Mo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wkl",
		"Description": [
			"Kalanadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wku",
		"Description": [
			"Kunduvadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wkw",
		"Description": [
			"Wakawaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wky",
		"Description": [
			"Wangkayutyuru"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wla",
		"Description": [
			"Walio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlc",
		"Description": [
			"Mwali Comorian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wle",
		"Description": [
			"Wolane"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlg",
		"Description": [
			"Kunbarlang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wli",
		"Description": [
			"Waioli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlk",
		"Description": [
			"Wailaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wll",
		"Description": [
			"Wali (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlm",
		"Description": [
			"Middle Welsh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlo",
		"Description": [
			"Wolio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlr",
		"Description": [
			"Wailapa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wls",
		"Description": [
			"Wallisian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlu",
		"Description": [
			"Wuliwuli"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlv",
		"Description": [
			"Wichí Lhamtés Vejoz"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlw",
		"Description": [
			"Walak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wlx",
		"Description": [
			"Wali (Ghana)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wly",
		"Description": [
			"Waling"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wma",
		"Description": [
			"Mawa (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmb",
		"Description": [
			"Wambaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmc",
		"Description": [
			"Wamas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmd",
		"Description": [
			"Mamaindé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wme",
		"Description": [
			"Wambule"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmh",
		"Description": [
			"Waima'a"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmi",
		"Description": [
			"Wamin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmm",
		"Description": [
			"Maiwa (Indonesia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmn",
		"Description": [
			"Waamwang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmo",
		"Description": [
			"Wom (Papua New Guinea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wms",
		"Description": [
			"Wambon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmt",
		"Description": [
			"Walmajarri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmw",
		"Description": [
			"Mwani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wmx",
		"Description": [
			"Womo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnb",
		"Description": [
			"Wanambre"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnc",
		"Description": [
			"Wantoat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnd",
		"Description": [
			"Wandarang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wne",
		"Description": [
			"Waneci"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wng",
		"Description": [
			"Wanggom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wni",
		"Description": [
			"Ndzwani Comorian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnk",
		"Description": [
			"Wanukaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnm",
		"Description": [
			"Wanggamala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnn",
		"Description": [
			"Wunumara"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wno",
		"Description": [
			"Wano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnp",
		"Description": [
			"Wanap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnu",
		"Description": [
			"Usan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wnw",
		"Description": [
			"Wintu"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wny",
		"Description": [
			"Wanyi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "woa",
		"Description": [
			"Tyaraity"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wob",
		"Description": [
			"Wè Northern"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "woc",
		"Description": [
			"Wogeo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wod",
		"Description": [
			"Wolani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "woe",
		"Description": [
			"Woleaian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wof",
		"Description": [
			"Gambian Wolof"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wog",
		"Description": [
			"Wogamusin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "woi",
		"Description": [
			"Kamang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wok",
		"Description": [
			"Longto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wom",
		"Description": [
			"Wom (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "won",
		"Description": [
			"Wongo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "woo",
		"Description": [
			"Manombai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wor",
		"Description": [
			"Woria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wos",
		"Description": [
			"Hanga Hundi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wow",
		"Description": [
			"Wawonii"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "woy",
		"Description": [
			"Weyto"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wpc",
		"Description": [
			"Maco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wra",
		"Description": [
			"Warapu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrb",
		"Description": [
			"Warluwara"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrd",
		"Description": [
			"Warduji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrg",
		"Description": [
			"Warungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrh",
		"Description": [
			"Wiradhuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wri",
		"Description": [
			"Wariyangga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrk",
		"Description": [
			"Garrwa"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "wrl",
		"Description": [
			"Warlmanpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrm",
		"Description": [
			"Warumungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrn",
		"Description": [
			"Warnang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wro",
		"Description": [
			"Worrorra"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "wrp",
		"Description": [
			"Waropen"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrr",
		"Description": [
			"Wardaman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrs",
		"Description": [
			"Waris"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wru",
		"Description": [
			"Waru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrv",
		"Description": [
			"Waruna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrw",
		"Description": [
			"Gugu Warra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wrx",
		"Description": [
			"Wae Rana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wry",
		"Description": [
			"Merwari"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mwr"
	},
	{
		"Type": "language",
		"Subtag": "wrz",
		"Description": [
			"Waray (Australia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wsa",
		"Description": [
			"Warembori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wsg",
		"Description": [
			"Adilabad Gondi"
		],
		"Added": "2016-05-30",
		"Macrolanguage": "gon"
	},
	{
		"Type": "language",
		"Subtag": "wsi",
		"Description": [
			"Wusi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wsk",
		"Description": [
			"Waskia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wsr",
		"Description": [
			"Owenia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wss",
		"Description": [
			"Wasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wsu",
		"Description": [
			"Wasu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wsv",
		"Description": [
			"Wotapuri-Katarqalai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wtf",
		"Description": [
			"Watiwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wth",
		"Description": [
			"Wathawurrung"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wti",
		"Description": [
			"Berta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wtk",
		"Description": [
			"Watakataui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wtm",
		"Description": [
			"Mewati"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wtw",
		"Description": [
			"Wotu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wua",
		"Description": [
			"Wikngenchera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wub",
		"Description": [
			"Wunambal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wud",
		"Description": [
			"Wudu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wuh",
		"Description": [
			"Wutunhua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wul",
		"Description": [
			"Silimo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wum",
		"Description": [
			"Wumbvu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wun",
		"Description": [
			"Bungu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wur",
		"Description": [
			"Wurrugu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wut",
		"Description": [
			"Wutung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wuu",
		"Description": [
			"Wu Chinese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "wuv",
		"Description": [
			"Wuvulu-Aua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wux",
		"Description": [
			"Wulna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wuy",
		"Description": [
			"Wauyai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wwa",
		"Description": [
			"Waama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wwb",
		"Description": [
			"Wakabunga"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "wwo",
		"Description": [
			"Wetamut",
			"Dorig"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wwr",
		"Description": [
			"Warrwa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "www",
		"Description": [
			"Wawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wxa",
		"Description": [
			"Waxianghua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wxw",
		"Description": [
			"Wardandi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wya",
		"Description": [
			"Wyandot"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wyb",
		"Description": [
			"Wangaaybuwan-Ngiyambaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wyi",
		"Description": [
			"Woiwurrung"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "wym",
		"Description": [
			"Wymysorys"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wyr",
		"Description": [
			"Wayoró"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "wyy",
		"Description": [
			"Western Fijian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xaa",
		"Description": [
			"Andalusian Arabic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xab",
		"Description": [
			"Sambe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xac",
		"Description": [
			"Kachari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xad",
		"Description": [
			"Adai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xae",
		"Description": [
			"Aequian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xag",
		"Description": [
			"Aghwan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xai",
		"Description": [
			"Kaimbé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xaj",
		"Description": [
			"Ararandewára"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "xak",
		"Description": [
			"Máku"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "xal",
		"Description": [
			"Kalmyk",
			"Oirat"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "xam",
		"Description": [
			"/Xam",
			"ǀXam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xan",
		"Description": [
			"Xamtanga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xao",
		"Description": [
			"Khao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xap",
		"Description": [
			"Apalachee"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xaq",
		"Description": [
			"Aquitanian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xar",
		"Description": [
			"Karami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xas",
		"Description": [
			"Kamas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xat",
		"Description": [
			"Katawixi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xau",
		"Description": [
			"Kauwera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xav",
		"Description": [
			"Xavánte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xaw",
		"Description": [
			"Kawaiisu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xay",
		"Description": [
			"Kayan Mahakam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xba",
		"Description": [
			"Kamba (Brazil)"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "cax"
	},
	{
		"Type": "language",
		"Subtag": "xbb",
		"Description": [
			"Lower Burdekin"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "xbc",
		"Description": [
			"Bactrian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xbd",
		"Description": [
			"Bindal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xbe",
		"Description": [
			"Bigambal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xbg",
		"Description": [
			"Bunganditj"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xbi",
		"Description": [
			"Kombio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xbj",
		"Description": [
			"Birrpayi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xbm",
		"Description": [
			"Middle Breton"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xbn",
		"Description": [
			"Kenaboi"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "xbo",
		"Description": [
			"Bolgarian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xbp",
		"Description": [
			"Bibbulman"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xbr",
		"Description": [
			"Kambera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xbw",
		"Description": [
			"Kambiwá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xbx",
		"Description": [
			"Kabixí"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "xby",
		"Description": [
			"Batyala"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xcb",
		"Description": [
			"Cumbric"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcc",
		"Description": [
			"Camunic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xce",
		"Description": [
			"Celtiberian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcg",
		"Description": [
			"Cisalpine Gaulish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xch",
		"Description": [
			"Chemakum",
			"Chimakum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcl",
		"Description": [
			"Classical Armenian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcm",
		"Description": [
			"Comecrudo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcn",
		"Description": [
			"Cotoname"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xco",
		"Description": [
			"Chorasmian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcr",
		"Description": [
			"Carian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xct",
		"Description": [
			"Classical Tibetan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcu",
		"Description": [
			"Curonian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcv",
		"Description": [
			"Chuvantsy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcw",
		"Description": [
			"Coahuilteco"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xcy",
		"Description": [
			"Cayuse"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xda",
		"Description": [
			"Darkinyung"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xdc",
		"Description": [
			"Dacian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xdk",
		"Description": [
			"Dharuk"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xdm",
		"Description": [
			"Edomite"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xdo",
		"Description": [
			"Kwandu"
		],
		"Added": "2017-02-23"
	},
	{
		"Type": "language",
		"Subtag": "xdy",
		"Description": [
			"Malayic Dayak"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xeb",
		"Description": [
			"Eblan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xed",
		"Description": [
			"Hdi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xeg",
		"Description": [
			"//Xegwi",
			"ǁXegwi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xel",
		"Description": [
			"Kelo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xem",
		"Description": [
			"Kembayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xep",
		"Description": [
			"Epi-Olmec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xer",
		"Description": [
			"Xerénte"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xes",
		"Description": [
			"Kesawai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xet",
		"Description": [
			"Xetá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xeu",
		"Description": [
			"Keoru-Ahia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xfa",
		"Description": [
			"Faliscan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xga",
		"Description": [
			"Galatian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xgb",
		"Description": [
			"Gbin"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "xgd",
		"Description": [
			"Gudang"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xgf",
		"Description": [
			"Gabrielino-Fernandeño"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xgg",
		"Description": [
			"Goreng"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xgi",
		"Description": [
			"Garingbal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xgl",
		"Description": [
			"Galindan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xgm",
		"Description": [
			"Dharumbal",
			"Guwinmal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xgn",
		"Description": [
			"Mongolian languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "xgr",
		"Description": [
			"Garza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xgu",
		"Description": [
			"Unggumi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "xgw",
		"Description": [
			"Guwa"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xha",
		"Description": [
			"Harami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xhc",
		"Description": [
			"Hunnic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xhd",
		"Description": [
			"Hadrami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xhe",
		"Description": [
			"Khetrani"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "lah"
	},
	{
		"Type": "language",
		"Subtag": "xhr",
		"Description": [
			"Hernican"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xht",
		"Description": [
			"Hattic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xhu",
		"Description": [
			"Hurrian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xhv",
		"Description": [
			"Khua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xia",
		"Description": [
			"Xiandao"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Preferred-Value": "acn"
	},
	{
		"Type": "language",
		"Subtag": "xib",
		"Description": [
			"Iberian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xii",
		"Description": [
			"Xiri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xil",
		"Description": [
			"Illyrian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xin",
		"Description": [
			"Xinca"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xip",
		"Description": [
			"Xipináwa"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "xir",
		"Description": [
			"Xiriâna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xis",
		"Description": [
			"Kisan"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "xiv",
		"Description": [
			"Indus Valley Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xiy",
		"Description": [
			"Xipaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xjb",
		"Description": [
			"Minjungbal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xjt",
		"Description": [
			"Jaitmatang"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xka",
		"Description": [
			"Kalkoti"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkb",
		"Description": [
			"Northern Nago"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkc",
		"Description": [
			"Kho'ini"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkd",
		"Description": [
			"Mendalam Kayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xke",
		"Description": [
			"Kereho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkf",
		"Description": [
			"Khengkha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkg",
		"Description": [
			"Kagoro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkh",
		"Description": [
			"Karahawyana"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30",
		"Preferred-Value": "waw"
	},
	{
		"Type": "language",
		"Subtag": "xki",
		"Description": [
			"Kenyan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkj",
		"Description": [
			"Kajali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkk",
		"Description": [
			"Kaco'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkl",
		"Description": [
			"Mainstream Kenyah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkn",
		"Description": [
			"Kayan River Kayan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xko",
		"Description": [
			"Kiorr"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkp",
		"Description": [
			"Kabatei"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkq",
		"Description": [
			"Koroni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkr",
		"Description": [
			"Xakriabá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xks",
		"Description": [
			"Kumbewaha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkt",
		"Description": [
			"Kantosi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xku",
		"Description": [
			"Kaamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkv",
		"Description": [
			"Kgalagadi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkw",
		"Description": [
			"Kembra"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkx",
		"Description": [
			"Karore"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xky",
		"Description": [
			"Uma' Lasan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xkz",
		"Description": [
			"Kurtokha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xla",
		"Description": [
			"Kamula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xlb",
		"Description": [
			"Loup B"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xlc",
		"Description": [
			"Lycian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xld",
		"Description": [
			"Lydian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xle",
		"Description": [
			"Lemnian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xlg",
		"Description": [
			"Ligurian (Ancient)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xli",
		"Description": [
			"Liburnian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xln",
		"Description": [
			"Alanic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xlo",
		"Description": [
			"Loup A"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xlp",
		"Description": [
			"Lepontic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xls",
		"Description": [
			"Lusitanian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xlu",
		"Description": [
			"Cuneiform Luwian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xly",
		"Description": [
			"Elymian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xma",
		"Description": [
			"Mushungulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmb",
		"Description": [
			"Mbonga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmc",
		"Description": [
			"Makhuwa-Marrevone"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmd",
		"Description": [
			"Mbudum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xme",
		"Description": [
			"Median"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmf",
		"Description": [
			"Mingrelian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmg",
		"Description": [
			"Mengaka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmh",
		"Description": [
			"Kuku-Muminh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmj",
		"Description": [
			"Majera"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmk",
		"Description": [
			"Ancient Macedonian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xml",
		"Description": [
			"Malaysian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmm",
		"Description": [
			"Manado Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "xmn",
		"Description": [
			"Manichaean Middle Persian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmo",
		"Description": [
			"Morerebi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmp",
		"Description": [
			"Kuku-Mu'inh"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmq",
		"Description": [
			"Kuku-Mangk"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmr",
		"Description": [
			"Meroitic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xms",
		"Description": [
			"Moroccan Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmt",
		"Description": [
			"Matbat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmu",
		"Description": [
			"Kamu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmv",
		"Description": [
			"Antankarana Malagasy",
			"Tankarana Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "xmw",
		"Description": [
			"Tsimihety Malagasy"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "mg"
	},
	{
		"Type": "language",
		"Subtag": "xmx",
		"Description": [
			"Maden"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmy",
		"Description": [
			"Mayaguduna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xmz",
		"Description": [
			"Mori Bawah"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xna",
		"Description": [
			"Ancient North Arabian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xnb",
		"Description": [
			"Kanakanabu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xnd",
		"Description": [
			"Na-Dene languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "xng",
		"Description": [
			"Middle Mongolian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xnh",
		"Description": [
			"Kuanhua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xni",
		"Description": [
			"Ngarigu"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xnk",
		"Description": [
			"Nganakarti"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xnn",
		"Description": [
			"Northern Kankanay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xno",
		"Description": [
			"Anglo-Norman"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xnr",
		"Description": [
			"Kangri"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "doi"
	},
	{
		"Type": "language",
		"Subtag": "xns",
		"Description": [
			"Kanashi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xnt",
		"Description": [
			"Narragansett"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "xnu",
		"Description": [
			"Nukunul"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xny",
		"Description": [
			"Nyiyaparli"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xnz",
		"Description": [
			"Kenzi",
			"Mattoki"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "xoc",
		"Description": [
			"O'chi'chi'"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xod",
		"Description": [
			"Kokoda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xog",
		"Description": [
			"Soga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xoi",
		"Description": [
			"Kominimung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xok",
		"Description": [
			"Xokleng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xom",
		"Description": [
			"Komo (Sudan)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xon",
		"Description": [
			"Konkomba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xoo",
		"Description": [
			"Xukurú"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xop",
		"Description": [
			"Kopar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xor",
		"Description": [
			"Korubo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xow",
		"Description": [
			"Kowaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpa",
		"Description": [
			"Pirriya"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xpc",
		"Description": [
			"Pecheneg"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpe",
		"Description": [
			"Liberia Kpelle"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "kpe"
	},
	{
		"Type": "language",
		"Subtag": "xpg",
		"Description": [
			"Phrygian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpi",
		"Description": [
			"Pictish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpj",
		"Description": [
			"Mpalitjanh"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "xpk",
		"Description": [
			"Kulina Pano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpm",
		"Description": [
			"Pumpokol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpn",
		"Description": [
			"Kapinawá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpo",
		"Description": [
			"Pochutec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpp",
		"Description": [
			"Puyo-Paekche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpq",
		"Description": [
			"Mohegan-Pequot"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "xpr",
		"Description": [
			"Parthian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xps",
		"Description": [
			"Pisidian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpt",
		"Description": [
			"Punthamara"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xpu",
		"Description": [
			"Punic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xpy",
		"Description": [
			"Puyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xqa",
		"Description": [
			"Karakhanid"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xqt",
		"Description": [
			"Qatabanian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xra",
		"Description": [
			"Krahô"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrb",
		"Description": [
			"Eastern Karaboro"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrd",
		"Description": [
			"Gundungurra"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xre",
		"Description": [
			"Kreye"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrg",
		"Description": [
			"Minang"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xri",
		"Description": [
			"Krikati-Timbira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrm",
		"Description": [
			"Armazic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrn",
		"Description": [
			"Arin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrq",
		"Description": [
			"Karranga"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xrr",
		"Description": [
			"Raetic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrt",
		"Description": [
			"Aranama-Tamique"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xru",
		"Description": [
			"Marriammu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xrw",
		"Description": [
			"Karawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsa",
		"Description": [
			"Sabaean"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsb",
		"Description": [
			"Sambal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsc",
		"Description": [
			"Scythian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsd",
		"Description": [
			"Sidetic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xse",
		"Description": [
			"Sempan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsh",
		"Description": [
			"Shamang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsi",
		"Description": [
			"Sio"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsj",
		"Description": [
			"Subi"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "suj"
	},
	{
		"Type": "language",
		"Subtag": "xsl",
		"Description": [
			"South Slavey"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "den"
	},
	{
		"Type": "language",
		"Subtag": "xsm",
		"Description": [
			"Kasem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsn",
		"Description": [
			"Sanga (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xso",
		"Description": [
			"Solano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsp",
		"Description": [
			"Silopi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsq",
		"Description": [
			"Makhuwa-Saka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsr",
		"Description": [
			"Sherpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xss",
		"Description": [
			"Assan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsu",
		"Description": [
			"Sanumá"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsv",
		"Description": [
			"Sudovian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xsy",
		"Description": [
			"Saisiyat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xta",
		"Description": [
			"Alcozauca Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtb",
		"Description": [
			"Chazumba Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtc",
		"Description": [
			"Katcha-Kadugli-Miri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtd",
		"Description": [
			"Diuxi-Tilantongo Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xte",
		"Description": [
			"Ketengban"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtg",
		"Description": [
			"Transalpine Gaulish"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xth",
		"Description": [
			"Yitha Yitha"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xti",
		"Description": [
			"Sinicahua Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtj",
		"Description": [
			"San Juan Teita Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtl",
		"Description": [
			"Tijaltepec Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtm",
		"Description": [
			"Magdalena Peñasco Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtn",
		"Description": [
			"Northern Tlaxiaco Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xto",
		"Description": [
			"Tokharian A"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtp",
		"Description": [
			"San Miguel Piedras Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtq",
		"Description": [
			"Tumshuqese"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtr",
		"Description": [
			"Early Tripuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xts",
		"Description": [
			"Sindihui Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtt",
		"Description": [
			"Tacahua Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtu",
		"Description": [
			"Cuyamecalco Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtv",
		"Description": [
			"Thawa"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xtw",
		"Description": [
			"Tawandê"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xty",
		"Description": [
			"Yoloxochitl Mixtec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xtz",
		"Description": [
			"Tasmanian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xua",
		"Description": [
			"Alu Kurumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xub",
		"Description": [
			"Betta Kurumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xud",
		"Description": [
			"Umiida"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "xug",
		"Description": [
			"Kunigami"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xuj",
		"Description": [
			"Jennu Kurumba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xul",
		"Description": [
			"Ngunawal"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xum",
		"Description": [
			"Umbrian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xun",
		"Description": [
			"Unggaranggu"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "xuo",
		"Description": [
			"Kuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xup",
		"Description": [
			"Upper Umpqua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xur",
		"Description": [
			"Urartian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xut",
		"Description": [
			"Kuthant"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xuu",
		"Description": [
			"Kxoe",
			"Khwedam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xve",
		"Description": [
			"Venetic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xvi",
		"Description": [
			"Kamviri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xvn",
		"Description": [
			"Vandalic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xvo",
		"Description": [
			"Volscian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xvs",
		"Description": [
			"Vestinian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwa",
		"Description": [
			"Kwaza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwc",
		"Description": [
			"Woccon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwd",
		"Description": [
			"Wadi Wadi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xwe",
		"Description": [
			"Xwela Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwg",
		"Description": [
			"Kwegu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwj",
		"Description": [
			"Wajuk"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xwk",
		"Description": [
			"Wangkumara"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xwl",
		"Description": [
			"Western Xwla Gbe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwo",
		"Description": [
			"Written Oirat"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwr",
		"Description": [
			"Kwerba Mamberamo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xwt",
		"Description": [
			"Wotjobaluk"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xww",
		"Description": [
			"Wemba Wemba"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xxb",
		"Description": [
			"Boro (Ghana)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xxk",
		"Description": [
			"Ke'o"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xxm",
		"Description": [
			"Minkin"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xxr",
		"Description": [
			"Koropó"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xxt",
		"Description": [
			"Tambora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xya",
		"Description": [
			"Yaygir"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xyb",
		"Description": [
			"Yandjibara"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xyj",
		"Description": [
			"Mayi-Yapi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xyk",
		"Description": [
			"Mayi-Kulan"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xyl",
		"Description": [
			"Yalakalore"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xyt",
		"Description": [
			"Mayi-Thakurti"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "xyy",
		"Description": [
			"Yorta Yorta"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "xzh",
		"Description": [
			"Zhang-Zhung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xzm",
		"Description": [
			"Zemgalian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "xzp",
		"Description": [
			"Ancient Zapotec"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yaa",
		"Description": [
			"Yaminahua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yab",
		"Description": [
			"Yuhup"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yac",
		"Description": [
			"Pass Valley Yali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yad",
		"Description": [
			"Yagua"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yae",
		"Description": [
			"Pumé"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yaf",
		"Description": [
			"Yaka (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yag",
		"Description": [
			"Yámana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yah",
		"Description": [
			"Yazgulyam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yai",
		"Description": [
			"Yagnobi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yaj",
		"Description": [
			"Banda-Yangere"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yak",
		"Description": [
			"Yakama"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yal",
		"Description": [
			"Yalunka"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yam",
		"Description": [
			"Yamba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yan",
		"Description": [
			"Mayangna"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "yao",
		"Description": [
			"Yao"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "yap",
		"Description": [
			"Yapese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "yaq",
		"Description": [
			"Yaqui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yar",
		"Description": [
			"Yabarana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yas",
		"Description": [
			"Nugunu (Cameroon)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yat",
		"Description": [
			"Yambeta"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yau",
		"Description": [
			"Yuwana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yav",
		"Description": [
			"Yangben"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yaw",
		"Description": [
			"Yawalapití"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yax",
		"Description": [
			"Yauma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yay",
		"Description": [
			"Agwagwune"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yaz",
		"Description": [
			"Lokaa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yba",
		"Description": [
			"Yala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybb",
		"Description": [
			"Yemba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybd",
		"Description": [
			"Yangbye"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "rki"
	},
	{
		"Type": "language",
		"Subtag": "ybe",
		"Description": [
			"West Yugur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybh",
		"Description": [
			"Yakha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybi",
		"Description": [
			"Yamphu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybj",
		"Description": [
			"Hasha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybk",
		"Description": [
			"Bokha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybl",
		"Description": [
			"Yukuben"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybm",
		"Description": [
			"Yaben"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybn",
		"Description": [
			"Yabaâna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybo",
		"Description": [
			"Yabong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ybx",
		"Description": [
			"Yawiyo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yby",
		"Description": [
			"Yaweyuha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ych",
		"Description": [
			"Chesu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ycl",
		"Description": [
			"Lolopo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ycn",
		"Description": [
			"Yucuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ycp",
		"Description": [
			"Chepya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yda",
		"Description": [
			"Yanda"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ydd",
		"Description": [
			"Eastern Yiddish"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "yi"
	},
	{
		"Type": "language",
		"Subtag": "yde",
		"Description": [
			"Yangum Dey"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ydg",
		"Description": [
			"Yidgha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ydk",
		"Description": [
			"Yoidik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yds",
		"Description": [
			"Yiddish Sign Language"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "yea",
		"Description": [
			"Ravula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yec",
		"Description": [
			"Yeniche"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yee",
		"Description": [
			"Yimas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yei",
		"Description": [
			"Yeni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yej",
		"Description": [
			"Yevanic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yel",
		"Description": [
			"Yela"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yen",
		"Description": [
			"Yendang"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Comments": [
			"see ynq, yot"
		]
	},
	{
		"Type": "language",
		"Subtag": "yer",
		"Description": [
			"Tarok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yes",
		"Description": [
			"Nyankpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yet",
		"Description": [
			"Yetfa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yeu",
		"Description": [
			"Yerukula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yev",
		"Description": [
			"Yapunda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yey",
		"Description": [
			"Yeyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yga",
		"Description": [
			"Malyangapa"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "ygi",
		"Description": [
			"Yiningayi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ygl",
		"Description": [
			"Yangum Gel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ygm",
		"Description": [
			"Yagomi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ygp",
		"Description": [
			"Gepo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ygr",
		"Description": [
			"Yagaria"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ygs",
		"Description": [
			"Yolŋu Sign Language"
		],
		"Added": "2014-02-28"
	},
	{
		"Type": "language",
		"Subtag": "ygu",
		"Description": [
			"Yugul"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ygw",
		"Description": [
			"Yagwoia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yha",
		"Description": [
			"Baha Buyang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yhd",
		"Description": [
			"Judeo-Iraqi Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "jrb"
	},
	{
		"Type": "language",
		"Subtag": "yhl",
		"Description": [
			"Hlepho Phowa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yhs",
		"Description": [
			"Yan-nhaŋu Sign Language"
		],
		"Added": "2015-04-17"
	},
	{
		"Type": "language",
		"Subtag": "yia",
		"Description": [
			"Yinggarda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yif",
		"Description": [
			"Ache"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yig",
		"Description": [
			"Wusa Nasu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yih",
		"Description": [
			"Western Yiddish"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "yi"
	},
	{
		"Type": "language",
		"Subtag": "yii",
		"Description": [
			"Yidiny"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yij",
		"Description": [
			"Yindjibarndi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yik",
		"Description": [
			"Dongshanba Lalo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yil",
		"Description": [
			"Yindjilandji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yim",
		"Description": [
			"Yimchungru Naga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yin",
		"Description": [
			"Yinchia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yip",
		"Description": [
			"Pholo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yiq",
		"Description": [
			"Miqie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yir",
		"Description": [
			"North Awyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yis",
		"Description": [
			"Yis"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yit",
		"Description": [
			"Eastern Lalu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yiu",
		"Description": [
			"Awu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yiv",
		"Description": [
			"Northern Nisu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yix",
		"Description": [
			"Axi Yi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yiy",
		"Description": [
			"Yir Yoront"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Comments": [
			"see yrm, yyr"
		]
	},
	{
		"Type": "language",
		"Subtag": "yiz",
		"Description": [
			"Azhe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yka",
		"Description": [
			"Yakan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ykg",
		"Description": [
			"Northern Yukaghir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yki",
		"Description": [
			"Yoke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ykk",
		"Description": [
			"Yakaikeke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ykl",
		"Description": [
			"Khlula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ykm",
		"Description": [
			"Kap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ykn",
		"Description": [
			"Kua-nsi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "yko",
		"Description": [
			"Yasa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ykr",
		"Description": [
			"Yekora"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ykt",
		"Description": [
			"Kathu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yku",
		"Description": [
			"Kuamasi"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "yky",
		"Description": [
			"Yakoma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yla",
		"Description": [
			"Yaul"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ylb",
		"Description": [
			"Yaleba"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "yle",
		"Description": [
			"Yele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ylg",
		"Description": [
			"Yelogu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yli",
		"Description": [
			"Angguruk Yali"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yll",
		"Description": [
			"Yil"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ylm",
		"Description": [
			"Limi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yln",
		"Description": [
			"Langnian Buyang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ylo",
		"Description": [
			"Naluo Yi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ylr",
		"Description": [
			"Yalarnnga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ylu",
		"Description": [
			"Aribwaung"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yly",
		"Description": [
			"Nyâlayu",
			"Nyelâyu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yma",
		"Description": [
			"Yamphe"
		],
		"Added": "2009-07-29",
		"Deprecated": "2012-08-12",
		"Preferred-Value": "lrr"
	},
	{
		"Type": "language",
		"Subtag": "ymb",
		"Description": [
			"Yambes"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymc",
		"Description": [
			"Southern Muji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymd",
		"Description": [
			"Muda"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yme",
		"Description": [
			"Yameo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymg",
		"Description": [
			"Yamongeri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymh",
		"Description": [
			"Mili"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymi",
		"Description": [
			"Moji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymk",
		"Description": [
			"Makwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yml",
		"Description": [
			"Iamalele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymm",
		"Description": [
			"Maay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymn",
		"Description": [
			"Yamna",
			"Sunum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymo",
		"Description": [
			"Yangum Mon"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymp",
		"Description": [
			"Yamap"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymq",
		"Description": [
			"Qila Muji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymr",
		"Description": [
			"Malasar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yms",
		"Description": [
			"Mysian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymt",
		"Description": [
			"Mator-Taygi-Karagas"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Preferred-Value": "mtm"
	},
	{
		"Type": "language",
		"Subtag": "ymx",
		"Description": [
			"Northern Muji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ymz",
		"Description": [
			"Muzi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yna",
		"Description": [
			"Aluo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ynd",
		"Description": [
			"Yandruwandha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yne",
		"Description": [
			"Lang'e"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yng",
		"Description": [
			"Yango"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ynh",
		"Description": [
			"Yangho"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12"
	},
	{
		"Type": "language",
		"Subtag": "ynk",
		"Description": [
			"Naukan Yupik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ynl",
		"Description": [
			"Yangulam"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ynn",
		"Description": [
			"Yana"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yno",
		"Description": [
			"Yong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ynq",
		"Description": [
			"Yendang"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "yns",
		"Description": [
			"Yansi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ynu",
		"Description": [
			"Yahuna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yob",
		"Description": [
			"Yoba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yog",
		"Description": [
			"Yogad"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yoi",
		"Description": [
			"Yonaguni"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yok",
		"Description": [
			"Yokuts"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yol",
		"Description": [
			"Yola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yom",
		"Description": [
			"Yombe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yon",
		"Description": [
			"Yongkom"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yos",
		"Description": [
			"Yos"
		],
		"Added": "2009-07-29",
		"Deprecated": "2013-09-10",
		"Preferred-Value": "zom"
	},
	{
		"Type": "language",
		"Subtag": "yot",
		"Description": [
			"Yotti"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "yox",
		"Description": [
			"Yoron"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yoy",
		"Description": [
			"Yoy"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypa",
		"Description": [
			"Phala"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypb",
		"Description": [
			"Labo Phowa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypg",
		"Description": [
			"Phola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yph",
		"Description": [
			"Phupha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypk",
		"Description": [
			"Yupik languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "ypm",
		"Description": [
			"Phuma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypn",
		"Description": [
			"Ani Phowa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypo",
		"Description": [
			"Alo Phola"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypp",
		"Description": [
			"Phupa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ypz",
		"Description": [
			"Phuza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yra",
		"Description": [
			"Yerakai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yrb",
		"Description": [
			"Yareba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yre",
		"Description": [
			"Yaouré"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yri",
		"Description": [
			"Yarí"
		],
		"Added": "2009-07-29",
		"Deprecated": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "yrk",
		"Description": [
			"Nenets"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yrl",
		"Description": [
			"Nhengatu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yrm",
		"Description": [
			"Yirrk-Mel"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "yrn",
		"Description": [
			"Yerong"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yro",
		"Description": [
			"Yaroamë"
		],
		"Added": "2016-05-30"
	},
	{
		"Type": "language",
		"Subtag": "yrs",
		"Description": [
			"Yarsun"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yrw",
		"Description": [
			"Yarawata"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yry",
		"Description": [
			"Yarluyandi"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ysc",
		"Description": [
			"Yassic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ysd",
		"Description": [
			"Samatao"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ysg",
		"Description": [
			"Sonaga"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "ysl",
		"Description": [
			"Yugoslavian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ysn",
		"Description": [
			"Sani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yso",
		"Description": [
			"Nisi (China)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ysp",
		"Description": [
			"Southern Lolopo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ysr",
		"Description": [
			"Sirenik Yupik"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yss",
		"Description": [
			"Yessan-Mayo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ysy",
		"Description": [
			"Sanie"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yta",
		"Description": [
			"Talu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ytl",
		"Description": [
			"Tanglang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ytp",
		"Description": [
			"Thopho"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ytw",
		"Description": [
			"Yout Wam"
		],
		"Added": "2010-03-11"
	},
	{
		"Type": "language",
		"Subtag": "yty",
		"Description": [
			"Yatay"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "yua",
		"Description": [
			"Yucateco",
			"Yucatec Maya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yub",
		"Description": [
			"Yugambal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yuc",
		"Description": [
			"Yuchi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yud",
		"Description": [
			"Judeo-Tripolitanian Arabic"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "jrb"
	},
	{
		"Type": "language",
		"Subtag": "yue",
		"Description": [
			"Yue Chinese",
			"Cantonese"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zh"
	},
	{
		"Type": "language",
		"Subtag": "yuf",
		"Description": [
			"Havasupai-Walapai-Yavapai"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yug",
		"Description": [
			"Yug"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yui",
		"Description": [
			"Yurutí"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yuj",
		"Description": [
			"Karkar-Yuri"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yuk",
		"Description": [
			"Yuki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yul",
		"Description": [
			"Yulu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yum",
		"Description": [
			"Quechan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yun",
		"Description": [
			"Bena (Nigeria)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yup",
		"Description": [
			"Yukpa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yuq",
		"Description": [
			"Yuqui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yur",
		"Description": [
			"Yurok"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yut",
		"Description": [
			"Yopno"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yuu",
		"Description": [
			"Yugh"
		],
		"Added": "2009-07-29",
		"Deprecated": "2014-02-28",
		"Preferred-Value": "yug"
	},
	{
		"Type": "language",
		"Subtag": "yuw",
		"Description": [
			"Yau (Morobe Province)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yux",
		"Description": [
			"Southern Yukaghir"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yuy",
		"Description": [
			"East Yugur"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yuz",
		"Description": [
			"Yuracare"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yva",
		"Description": [
			"Yawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yvt",
		"Description": [
			"Yavitero"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ywa",
		"Description": [
			"Kalou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ywg",
		"Description": [
			"Yinhawangka"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "ywl",
		"Description": [
			"Western Lalu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ywn",
		"Description": [
			"Yawanawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ywq",
		"Description": [
			"Wuding-Luquan Yi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ywr",
		"Description": [
			"Yawuru"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ywt",
		"Description": [
			"Xishanba Lalo",
			"Central Lalo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ywu",
		"Description": [
			"Wumeng Nasu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yww",
		"Description": [
			"Yawarawarga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yxa",
		"Description": [
			"Mayawali"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "yxg",
		"Description": [
			"Yagara"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "yxl",
		"Description": [
			"Yardliyawarra"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "yxm",
		"Description": [
			"Yinwum"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "yxu",
		"Description": [
			"Yuyu"
		],
		"Added": "2013-09-10"
	},
	{
		"Type": "language",
		"Subtag": "yxy",
		"Description": [
			"Yabula Yabula"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "yyr",
		"Description": [
			"Yir Yoront"
		],
		"Added": "2013-09-03"
	},
	{
		"Type": "language",
		"Subtag": "yyu",
		"Description": [
			"Yau (Sandaun Province)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yyz",
		"Description": [
			"Ayizi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yzg",
		"Description": [
			"E'ma Buyang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "yzk",
		"Description": [
			"Zokhuo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zaa",
		"Description": [
			"Sierra de Juárez Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zab",
		"Description": [
			"Western Tlacolula Valley Zapotec",
			"San Juan Guelavía Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zac",
		"Description": [
			"Ocotlán Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zad",
		"Description": [
			"Cajonos Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zae",
		"Description": [
			"Yareni Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zaf",
		"Description": [
			"Ayoquesco Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zag",
		"Description": [
			"Zaghawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zah",
		"Description": [
			"Zangwal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zai",
		"Description": [
			"Isthmus Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zaj",
		"Description": [
			"Zaramo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zak",
		"Description": [
			"Zanaki"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zal",
		"Description": [
			"Zauzou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zam",
		"Description": [
			"Miahuatlán Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zao",
		"Description": [
			"Ozolotepec Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zap",
		"Description": [
			"Zapotec"
		],
		"Added": "2005-10-16",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "zaq",
		"Description": [
			"Aloápam Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zar",
		"Description": [
			"Rincón Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zas",
		"Description": [
			"Santo Domingo Albarradas Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zat",
		"Description": [
			"Tabaa Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zau",
		"Description": [
			"Zangskari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zav",
		"Description": [
			"Yatzachi Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zaw",
		"Description": [
			"Mitla Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zax",
		"Description": [
			"Xadani Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zay",
		"Description": [
			"Zayse-Zergulla",
			"Zaysete"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zaz",
		"Description": [
			"Zari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zbc",
		"Description": [
			"Central Berawan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zbe",
		"Description": [
			"East Berawan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zbl",
		"Description": [
			"Blissymbols",
			"Bliss",
			"Blissymbolics"
		],
		"Added": "2007-08-21",
		"Suppress-Script": "Blis"
	},
	{
		"Type": "language",
		"Subtag": "zbt",
		"Description": [
			"Batui"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zbw",
		"Description": [
			"West Berawan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zca",
		"Description": [
			"Coatecas Altas Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zch",
		"Description": [
			"Central Hongshuihe Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zdj",
		"Description": [
			"Ngazidja Comorian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zea",
		"Description": [
			"Zeeuws"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zeg",
		"Description": [
			"Zenag"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zeh",
		"Description": [
			"Eastern Hongshuihe Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zen",
		"Description": [
			"Zenaga"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "zga",
		"Description": [
			"Kinga"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zgb",
		"Description": [
			"Guibei Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zgh",
		"Description": [
			"Standard Moroccan Tamazight"
		],
		"Added": "2013-01-25"
	},
	{
		"Type": "language",
		"Subtag": "zgm",
		"Description": [
			"Minz Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zgn",
		"Description": [
			"Guibian Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zgr",
		"Description": [
			"Magori"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zhb",
		"Description": [
			"Zhaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zhd",
		"Description": [
			"Dai Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zhi",
		"Description": [
			"Zhire"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zhn",
		"Description": [
			"Nong Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zhw",
		"Description": [
			"Zhoa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zhx",
		"Description": [
			"Chinese (family)"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "zia",
		"Description": [
			"Zia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zib",
		"Description": [
			"Zimbabwe Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zik",
		"Description": [
			"Zimakani"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zil",
		"Description": [
			"Zialo"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "language",
		"Subtag": "zim",
		"Description": [
			"Mesme"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zin",
		"Description": [
			"Zinza"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zir",
		"Description": [
			"Ziriya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ziw",
		"Description": [
			"Zigula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "ziz",
		"Description": [
			"Zizilivakan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zka",
		"Description": [
			"Kaimbulawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkb",
		"Description": [
			"Koibal"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkd",
		"Description": [
			"Kadu"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "zkg",
		"Description": [
			"Koguryo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkh",
		"Description": [
			"Khorezmian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkk",
		"Description": [
			"Karankawa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkn",
		"Description": [
			"Kanan"
		],
		"Added": "2012-08-12"
	},
	{
		"Type": "language",
		"Subtag": "zko",
		"Description": [
			"Kott"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkp",
		"Description": [
			"São Paulo Kaingáng"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkr",
		"Description": [
			"Zakhring"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkt",
		"Description": [
			"Kitan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zku",
		"Description": [
			"Kaurna"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkv",
		"Description": [
			"Krevinian"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zkz",
		"Description": [
			"Khazar"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zle",
		"Description": [
			"East Slavic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "zlj",
		"Description": [
			"Liujiang Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zlm",
		"Description": [
			"Malay (individual language)"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "zln",
		"Description": [
			"Lianshan Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zlq",
		"Description": [
			"Liuqian Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zls",
		"Description": [
			"South Slavic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "zlw",
		"Description": [
			"West Slavic languages"
		],
		"Added": "2009-07-29",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "zma",
		"Description": [
			"Manda (Australia)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmb",
		"Description": [
			"Zimba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmc",
		"Description": [
			"Margany"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmd",
		"Description": [
			"Maridan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zme",
		"Description": [
			"Mangerr"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmf",
		"Description": [
			"Mfinu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmg",
		"Description": [
			"Marti Ke"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmh",
		"Description": [
			"Makolkol"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmi",
		"Description": [
			"Negeri Sembilan Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "zmj",
		"Description": [
			"Maridjabin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmk",
		"Description": [
			"Mandandanyi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zml",
		"Description": [
			"Madngele"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmm",
		"Description": [
			"Marimanindji"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmn",
		"Description": [
			"Mbangwe"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmo",
		"Description": [
			"Molo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmp",
		"Description": [
			"Mpuono"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmq",
		"Description": [
			"Mituku"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmr",
		"Description": [
			"Maranunggu"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zms",
		"Description": [
			"Mbesa"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmt",
		"Description": [
			"Maringarr"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmu",
		"Description": [
			"Muruwari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmv",
		"Description": [
			"Mbariman-Gudhinma"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmw",
		"Description": [
			"Mbo (Democratic Republic of Congo)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmx",
		"Description": [
			"Bomitaba"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmy",
		"Description": [
			"Mariyedi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zmz",
		"Description": [
			"Mbandja"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zna",
		"Description": [
			"Zan Gula"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "znd",
		"Description": [
			"Zande languages"
		],
		"Added": "2005-10-16",
		"Scope": "collection"
	},
	{
		"Type": "language",
		"Subtag": "zne",
		"Description": [
			"Zande (individual language)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zng",
		"Description": [
			"Mang"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "znk",
		"Description": [
			"Manangkari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zns",
		"Description": [
			"Mangas"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zoc",
		"Description": [
			"Copainalá Zoque"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zoh",
		"Description": [
			"Chimalapa Zoque"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zom",
		"Description": [
			"Zou"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zoo",
		"Description": [
			"Asunción Mixtepec Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zoq",
		"Description": [
			"Tabasco Zoque"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zor",
		"Description": [
			"Rayón Zoque"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zos",
		"Description": [
			"Francisco León Zoque"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zpa",
		"Description": [
			"Lachiguiri Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpb",
		"Description": [
			"Yautepec Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpc",
		"Description": [
			"Choapan Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpd",
		"Description": [
			"Southeastern Ixtlán Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpe",
		"Description": [
			"Petapa Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpf",
		"Description": [
			"San Pedro Quiatoni Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpg",
		"Description": [
			"Guevea De Humboldt Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zph",
		"Description": [
			"Totomachapan Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpi",
		"Description": [
			"Santa María Quiegolani Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpj",
		"Description": [
			"Quiavicuzas Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpk",
		"Description": [
			"Tlacolulita Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpl",
		"Description": [
			"Lachixío Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpm",
		"Description": [
			"Mixtepec Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpn",
		"Description": [
			"Santa Inés Yatzechi Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpo",
		"Description": [
			"Amatlán Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpp",
		"Description": [
			"El Alto Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpq",
		"Description": [
			"Zoogocho Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpr",
		"Description": [
			"Santiago Xanica Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zps",
		"Description": [
			"Coatlán Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpt",
		"Description": [
			"San Vicente Coatlán Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpu",
		"Description": [
			"Yalálag Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpv",
		"Description": [
			"Chichicapan Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpw",
		"Description": [
			"Zaniza Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpx",
		"Description": [
			"San Baltazar Loxicha Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpy",
		"Description": [
			"Mazaltepec Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zpz",
		"Description": [
			"Texmelucan Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zqe",
		"Description": [
			"Qiubei Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zra",
		"Description": [
			"Kara (Korea)"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zrg",
		"Description": [
			"Mirgan"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zrn",
		"Description": [
			"Zerenkel"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zro",
		"Description": [
			"Záparo"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zrp",
		"Description": [
			"Zarphatic"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zrs",
		"Description": [
			"Mairasi"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zsa",
		"Description": [
			"Sarasira"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zsk",
		"Description": [
			"Kaskean"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zsl",
		"Description": [
			"Zambian Sign Language"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zsm",
		"Description": [
			"Standard Malay"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "ms"
	},
	{
		"Type": "language",
		"Subtag": "zsr",
		"Description": [
			"Southern Rincon Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zsu",
		"Description": [
			"Sukurum"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zte",
		"Description": [
			"Elotepec Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztg",
		"Description": [
			"Xanaguía Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztl",
		"Description": [
			"Lapaguía-Guivini Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztm",
		"Description": [
			"San Agustín Mixtepec Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztn",
		"Description": [
			"Santa Catarina Albarradas Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztp",
		"Description": [
			"Loxicha Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztq",
		"Description": [
			"Quioquitani-Quierí Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zts",
		"Description": [
			"Tilquiapan Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztt",
		"Description": [
			"Tejalapan Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztu",
		"Description": [
			"Güilá Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "ztx",
		"Description": [
			"Zaachila Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zty",
		"Description": [
			"Yatee Zapotec"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "zap"
	},
	{
		"Type": "language",
		"Subtag": "zua",
		"Description": [
			"Zeem"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zuh",
		"Description": [
			"Tokano"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zum",
		"Description": [
			"Kumzari"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zun",
		"Description": [
			"Zuni"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "language",
		"Subtag": "zuy",
		"Description": [
			"Zumaya"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zwa",
		"Description": [
			"Zay"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zxx",
		"Description": [
			"No linguistic content",
			"Not applicable"
		],
		"Added": "2006-03-08",
		"Scope": "special"
	},
	{
		"Type": "language",
		"Subtag": "zyb",
		"Description": [
			"Yongbei Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zyg",
		"Description": [
			"Yang Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zyj",
		"Description": [
			"Youjiang Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zyn",
		"Description": [
			"Yongnan Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "language",
		"Subtag": "zyp",
		"Description": [
			"Zyphe Chin"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "language",
		"Subtag": "zza",
		"Description": [
			"Zaza",
			"Dimili",
			"Dimli (macrolanguage)",
			"Kirdki",
			"Kirmanjki (macrolanguage)",
			"Zazaki"
		],
		"Added": "2006-08-24",
		"Scope": "macrolanguage"
	},
	{
		"Type": "language",
		"Subtag": "zzj",
		"Description": [
			"Zuojiang Zhuang"
		],
		"Added": "2009-07-29",
		"Macrolanguage": "za"
	},
	{
		"Type": "extlang",
		"Subtag": "aao",
		"Description": [
			"Algerian Saharan Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "aao",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "abh",
		"Description": [
			"Tajiki Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "abh",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "abv",
		"Description": [
			"Baharna Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "abv",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "acm",
		"Description": [
			"Mesopotamian Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "acm",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "acq",
		"Description": [
			"Ta'izzi-Adeni Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "acq",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "acw",
		"Description": [
			"Hijazi Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "acw",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "acx",
		"Description": [
			"Omani Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "acx",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "acy",
		"Description": [
			"Cypriot Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "acy",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "adf",
		"Description": [
			"Dhofari Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "adf",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ads",
		"Description": [
			"Adamorobe Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ads",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "aeb",
		"Description": [
			"Tunisian Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "aeb",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "aec",
		"Description": [
			"Saidi Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "aec",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "aed",
		"Description": [
			"Argentine Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "aed",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "aen",
		"Description": [
			"Armenian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "aen",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "afb",
		"Description": [
			"Gulf Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "afb",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "afg",
		"Description": [
			"Afghan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "afg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ajp",
		"Description": [
			"South Levantine Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ajp",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "apc",
		"Description": [
			"North Levantine Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "apc",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "apd",
		"Description": [
			"Sudanese Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "apd",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "arb",
		"Description": [
			"Standard Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "arb",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "arq",
		"Description": [
			"Algerian Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "arq",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ars",
		"Description": [
			"Najdi Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ars",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ary",
		"Description": [
			"Moroccan Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ary",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "arz",
		"Description": [
			"Egyptian Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "arz",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ase",
		"Description": [
			"American Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ase",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "asf",
		"Description": [
			"Australian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "asf",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "asp",
		"Description": [
			"Algerian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "asp",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "asq",
		"Description": [
			"Austrian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "asq",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "asw",
		"Description": [
			"Australian Aborigines Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "asw",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "auz",
		"Description": [
			"Uzbeki Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "auz",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "avl",
		"Description": [
			"Eastern Egyptian Bedawi Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "avl",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ayh",
		"Description": [
			"Hadrami Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ayh",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ayl",
		"Description": [
			"Libyan Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ayl",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ayn",
		"Description": [
			"Sanaani Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ayn",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ayp",
		"Description": [
			"North Mesopotamian Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ayp",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "bbz",
		"Description": [
			"Babalia Creole Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bbz",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "bfi",
		"Description": [
			"British Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bfi",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "bfk",
		"Description": [
			"Ban Khor Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bfk",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "bjn",
		"Description": [
			"Banjar"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bjn",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "bog",
		"Description": [
			"Bamako Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bog",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "bqn",
		"Description": [
			"Bulgarian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bqn",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "bqy",
		"Description": [
			"Bengkala Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bqy",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "btj",
		"Description": [
			"Bacanese Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "btj",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "bve",
		"Description": [
			"Berau Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bve",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "bvl",
		"Description": [
			"Bolivian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bvl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "bvu",
		"Description": [
			"Bukit Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bvu",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "bzs",
		"Description": [
			"Brazilian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "bzs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "cdo",
		"Description": [
			"Min Dong Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "cdo",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "cds",
		"Description": [
			"Chadian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "cds",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "cjy",
		"Description": [
			"Jinyu Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "cjy",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "cmn",
		"Description": [
			"Mandarin Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "cmn",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "coa",
		"Description": [
			"Cocos Islands Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "coa",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "cpx",
		"Description": [
			"Pu-Xian Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "cpx",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "csc",
		"Description": [
			"Catalan Sign Language",
			"Lengua de señas catalana",
			"Llengua de Signes Catalana"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csc",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "csd",
		"Description": [
			"Chiangmai Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csd",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "cse",
		"Description": [
			"Czech Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "cse",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "csf",
		"Description": [
			"Cuba Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csf",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "csg",
		"Description": [
			"Chilean Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "csl",
		"Description": [
			"Chinese Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "csn",
		"Description": [
			"Colombian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csn",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "csq",
		"Description": [
			"Croatia Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csq",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "csr",
		"Description": [
			"Costa Rican Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "csr",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "czh",
		"Description": [
			"Huizhou Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "czh",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "czo",
		"Description": [
			"Min Zhong Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "czo",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "doq",
		"Description": [
			"Dominican Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "doq",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "dse",
		"Description": [
			"Dutch Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "dse",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "dsl",
		"Description": [
			"Danish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "dsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "dup",
		"Description": [
			"Duano"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "dup",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "ecs",
		"Description": [
			"Ecuadorian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ecs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "esl",
		"Description": [
			"Egypt Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "esl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "esn",
		"Description": [
			"Salvadoran Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "esn",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "eso",
		"Description": [
			"Estonian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "eso",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "eth",
		"Description": [
			"Ethiopian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "eth",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "fcs",
		"Description": [
			"Quebec Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "fcs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "fse",
		"Description": [
			"Finnish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "fse",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "fsl",
		"Description": [
			"French Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "fsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "fss",
		"Description": [
			"Finland-Swedish Sign Language",
			"finlandssvenskt teckenspråk",
			"suomenruotsalainen viittomakieli"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "fss",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "gan",
		"Description": [
			"Gan Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "gan",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "gds",
		"Description": [
			"Ghandruk Sign Language"
		],
		"Added": "2012-08-12",
		"Preferred-Value": "gds",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "gom",
		"Description": [
			"Goan Konkani"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "gom",
		"Prefix": [
			"kok"
		],
		"Macrolanguage": "kok"
	},
	{
		"Type": "extlang",
		"Subtag": "gse",
		"Description": [
			"Ghanaian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "gse",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "gsg",
		"Description": [
			"German Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "gsg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "gsm",
		"Description": [
			"Guatemalan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "gsm",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "gss",
		"Description": [
			"Greek Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "gss",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "gus",
		"Description": [
			"Guinean Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "gus",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hab",
		"Description": [
			"Hanoi Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hab",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "haf",
		"Description": [
			"Haiphong Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "haf",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hak",
		"Description": [
			"Hakka Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hak",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "hds",
		"Description": [
			"Honduras Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hds",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hji",
		"Description": [
			"Haji"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hji",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "hks",
		"Description": [
			"Hong Kong Sign Language",
			"Heung Kong Sau Yue"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hks",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hos",
		"Description": [
			"Ho Chi Minh City Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hos",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hps",
		"Description": [
			"Hawai'i Sign Language (HSL)",
			"Hawai'i Pidgin Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hps",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hsh",
		"Description": [
			"Hungarian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hsh",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hsl",
		"Description": [
			"Hausa Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "hsn",
		"Description": [
			"Xiang Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "hsn",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "icl",
		"Description": [
			"Icelandic Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "icl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "iks",
		"Description": [
			"Inuit Sign Language"
		],
		"Added": "2015-02-12",
		"Preferred-Value": "iks",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ils",
		"Description": [
			"International Sign"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ils",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "inl",
		"Description": [
			"Indonesian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "inl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ins",
		"Description": [
			"Indian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ins",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ise",
		"Description": [
			"Italian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ise",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "isg",
		"Description": [
			"Irish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "isg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "isr",
		"Description": [
			"Israeli Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "isr",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "jak",
		"Description": [
			"Jakun"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "jak",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "jax",
		"Description": [
			"Jambi Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "jax",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "jcs",
		"Description": [
			"Jamaican Country Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "jcs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "jhs",
		"Description": [
			"Jhankot Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "jhs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "jls",
		"Description": [
			"Jamaican Sign Language"
		],
		"Added": "2010-03-11",
		"Preferred-Value": "jls",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "jos",
		"Description": [
			"Jordanian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "jos",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "jsl",
		"Description": [
			"Japanese Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "jsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "jus",
		"Description": [
			"Jumla Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "jus",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "kgi",
		"Description": [
			"Selangor Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "kgi",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "knn",
		"Description": [
			"Konkani (individual language)"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "knn",
		"Prefix": [
			"kok"
		],
		"Macrolanguage": "kok"
	},
	{
		"Type": "extlang",
		"Subtag": "kvb",
		"Description": [
			"Kubu"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "kvb",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "kvk",
		"Description": [
			"Korean Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "kvk",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "kvr",
		"Description": [
			"Kerinci"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "kvr",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "kxd",
		"Description": [
			"Brunei"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "kxd",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "lbs",
		"Description": [
			"Libyan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lbs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "lce",
		"Description": [
			"Loncong",
			"Sekak"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lce",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "lcf",
		"Description": [
			"Lubu"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lcf",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "liw",
		"Description": [
			"Col"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "liw",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "lls",
		"Description": [
			"Lithuanian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lls",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "lsg",
		"Description": [
			"Lyons Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lsg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "lsl",
		"Description": [
			"Latvian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "lso",
		"Description": [
			"Laos Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lso",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "lsp",
		"Description": [
			"Panamanian Sign Language",
			"Lengua de Señas Panameñas"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lsp",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "lst",
		"Description": [
			"Trinidad and Tobago Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lst",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "lsy",
		"Description": [
			"Mauritian Sign Language"
		],
		"Added": "2010-03-11",
		"Preferred-Value": "lsy",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ltg",
		"Description": [
			"Latgalian"
		],
		"Added": "2010-03-11",
		"Preferred-Value": "ltg",
		"Prefix": [
			"lv"
		],
		"Macrolanguage": "lv"
	},
	{
		"Type": "extlang",
		"Subtag": "lvs",
		"Description": [
			"Standard Latvian"
		],
		"Added": "2010-03-11",
		"Preferred-Value": "lvs",
		"Prefix": [
			"lv"
		],
		"Macrolanguage": "lv"
	},
	{
		"Type": "extlang",
		"Subtag": "lzh",
		"Description": [
			"Literary Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "lzh",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "max",
		"Description": [
			"North Moluccan Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "max",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "mdl",
		"Description": [
			"Maltese Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mdl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "meo",
		"Description": [
			"Kedah Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "meo",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "mfa",
		"Description": [
			"Pattani Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mfa",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "mfb",
		"Description": [
			"Bangka"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mfb",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "mfs",
		"Description": [
			"Mexican Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mfs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "min",
		"Description": [
			"Minangkabau"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "min",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "mnp",
		"Description": [
			"Min Bei Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mnp",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "mqg",
		"Description": [
			"Kota Bangun Kutai Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mqg",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "mre",
		"Description": [
			"Martha's Vineyard Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mre",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "msd",
		"Description": [
			"Yucatec Maya Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "msd",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "msi",
		"Description": [
			"Sabah Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "msi",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "msr",
		"Description": [
			"Mongolian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "msr",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "mui",
		"Description": [
			"Musi"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mui",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "mzc",
		"Description": [
			"Madagascar Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mzc",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "mzg",
		"Description": [
			"Monastic Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mzg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "mzy",
		"Description": [
			"Mozambican Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "mzy",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "nan",
		"Description": [
			"Min Nan Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "nan",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "nbs",
		"Description": [
			"Namibian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "nbs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ncs",
		"Description": [
			"Nicaraguan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ncs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "nsi",
		"Description": [
			"Nigerian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "nsi",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "nsl",
		"Description": [
			"Norwegian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "nsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "nsp",
		"Description": [
			"Nepalese Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "nsp",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "nsr",
		"Description": [
			"Maritime Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "nsr",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "nzs",
		"Description": [
			"New Zealand Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "nzs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "okl",
		"Description": [
			"Old Kentish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "okl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "orn",
		"Description": [
			"Orang Kanaq"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "orn",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "ors",
		"Description": [
			"Orang Seletar"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ors",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "pel",
		"Description": [
			"Pekal"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "pel",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "pga",
		"Description": [
			"Sudanese Creole Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "pga",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "pgz",
		"Description": [
			"Papua New Guinean Sign Language"
		],
		"Added": "2016-05-30",
		"Preferred-Value": "pgz",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "pks",
		"Description": [
			"Pakistan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "pks",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "prl",
		"Description": [
			"Peruvian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "prl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "prz",
		"Description": [
			"Providencia Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "prz",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "psc",
		"Description": [
			"Persian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "psc",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "psd",
		"Description": [
			"Plains Indian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "psd",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "pse",
		"Description": [
			"Central Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "pse",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "psg",
		"Description": [
			"Penang Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "psg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "psl",
		"Description": [
			"Puerto Rican Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "psl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "pso",
		"Description": [
			"Polish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "pso",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "psp",
		"Description": [
			"Philippine Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "psp",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "psr",
		"Description": [
			"Portuguese Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "psr",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "pys",
		"Description": [
			"Paraguayan Sign Language",
			"Lengua de Señas del Paraguay"
		],
		"Added": "2010-03-11",
		"Preferred-Value": "pys",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "rms",
		"Description": [
			"Romanian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "rms",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "rsi",
		"Description": [
			"Rennellese Sign Language"
		],
		"Added": "2009-07-29",
		"Deprecated": "2017-02-23",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "rsl",
		"Description": [
			"Russian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "rsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "rsm",
		"Description": [
			"Miriwoong Sign Language"
		],
		"Added": "2016-05-30",
		"Preferred-Value": "rsm",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sdl",
		"Description": [
			"Saudi Arabian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "sdl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sfb",
		"Description": [
			"Langue des signes de Belgique Francophone",
			"French Belgian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "sfb",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sfs",
		"Description": [
			"South African Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "sfs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sgg",
		"Description": [
			"Swiss-German Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "sgg",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sgx",
		"Description": [
			"Sierra Leone Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "sgx",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "shu",
		"Description": [
			"Chadian Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "shu",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "slf",
		"Description": [
			"Swiss-Italian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "slf",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sls",
		"Description": [
			"Singapore Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "sls",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sqk",
		"Description": [
			"Albanian Sign Language"
		],
		"Added": "2012-08-12",
		"Preferred-Value": "sqk",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "sqs",
		"Description": [
			"Sri Lankan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "sqs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ssh",
		"Description": [
			"Shihhi Arabic"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ssh",
		"Prefix": [
			"ar"
		],
		"Macrolanguage": "ar"
	},
	{
		"Type": "extlang",
		"Subtag": "ssp",
		"Description": [
			"Spanish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ssp",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ssr",
		"Description": [
			"Swiss-French Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ssr",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "svk",
		"Description": [
			"Slovakian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "svk",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "swc",
		"Description": [
			"Congo Swahili"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "swc",
		"Prefix": [
			"sw"
		],
		"Macrolanguage": "sw"
	},
	{
		"Type": "extlang",
		"Subtag": "swh",
		"Description": [
			"Swahili (individual language)",
			"Kiswahili"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "swh",
		"Prefix": [
			"sw"
		],
		"Macrolanguage": "sw"
	},
	{
		"Type": "extlang",
		"Subtag": "swl",
		"Description": [
			"Swedish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "swl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "syy",
		"Description": [
			"Al-Sayyid Bedouin Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "syy",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "szs",
		"Description": [
			"Solomon Islands Sign Language"
		],
		"Added": "2017-02-23",
		"Preferred-Value": "szs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "tmw",
		"Description": [
			"Temuan"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "tmw",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "tse",
		"Description": [
			"Tunisian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "tse",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "tsm",
		"Description": [
			"Turkish Sign Language",
			"Türk İşaret Dili"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "tsm",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "tsq",
		"Description": [
			"Thai Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "tsq",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "tss",
		"Description": [
			"Taiwan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "tss",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "tsy",
		"Description": [
			"Tebul Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "tsy",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "tza",
		"Description": [
			"Tanzanian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "tza",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ugn",
		"Description": [
			"Ugandan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ugn",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ugy",
		"Description": [
			"Uruguayan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ugy",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ukl",
		"Description": [
			"Ukrainian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ukl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "uks",
		"Description": [
			"Urubú-Kaapor Sign Language",
			"Kaapor Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "uks",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "urk",
		"Description": [
			"Urak Lawoi'"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "urk",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "uzn",
		"Description": [
			"Northern Uzbek"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "uzn",
		"Prefix": [
			"uz"
		],
		"Macrolanguage": "uz"
	},
	{
		"Type": "extlang",
		"Subtag": "uzs",
		"Description": [
			"Southern Uzbek"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "uzs",
		"Prefix": [
			"uz"
		],
		"Macrolanguage": "uz"
	},
	{
		"Type": "extlang",
		"Subtag": "vgt",
		"Description": [
			"Vlaamse Gebarentaal",
			"Flemish Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "vgt",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "vkk",
		"Description": [
			"Kaur"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "vkk",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "vkt",
		"Description": [
			"Tenggarong Kutai Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "vkt",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "vsi",
		"Description": [
			"Moldova Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "vsi",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "vsl",
		"Description": [
			"Venezuelan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "vsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "vsv",
		"Description": [
			"Valencian Sign Language",
			"Llengua de signes valenciana"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "vsv",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "wbs",
		"Description": [
			"West Bengal Sign Language"
		],
		"Added": "2017-02-23",
		"Preferred-Value": "wbs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "wuu",
		"Description": [
			"Wu Chinese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "wuu",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "xki",
		"Description": [
			"Kenyan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "xki",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "xml",
		"Description": [
			"Malaysian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "xml",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "xmm",
		"Description": [
			"Manado Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "xmm",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "xms",
		"Description": [
			"Moroccan Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "xms",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "yds",
		"Description": [
			"Yiddish Sign Language"
		],
		"Added": "2009-07-29",
		"Deprecated": "2015-02-12",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ygs",
		"Description": [
			"Yolŋu Sign Language"
		],
		"Added": "2014-02-28",
		"Preferred-Value": "ygs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "yhs",
		"Description": [
			"Yan-nhaŋu Sign Language"
		],
		"Added": "2015-04-17",
		"Preferred-Value": "yhs",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "ysl",
		"Description": [
			"Yugoslavian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "ysl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "yue",
		"Description": [
			"Yue Chinese",
			"Cantonese"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "yue",
		"Prefix": [
			"zh"
		],
		"Macrolanguage": "zh"
	},
	{
		"Type": "extlang",
		"Subtag": "zib",
		"Description": [
			"Zimbabwe Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "zib",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "zlm",
		"Description": [
			"Malay (individual language)"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "zlm",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "zmi",
		"Description": [
			"Negeri Sembilan Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "zmi",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "extlang",
		"Subtag": "zsl",
		"Description": [
			"Zambian Sign Language"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "zsl",
		"Prefix": [
			"sgn"
		]
	},
	{
		"Type": "extlang",
		"Subtag": "zsm",
		"Description": [
			"Standard Malay"
		],
		"Added": "2009-07-29",
		"Preferred-Value": "zsm",
		"Prefix": [
			"ms"
		],
		"Macrolanguage": "ms"
	},
	{
		"Type": "script",
		"Subtag": "Adlm",
		"Description": [
			"Adlam"
		],
		"Added": "2014-12-11"
	},
	{
		"Type": "script",
		"Subtag": "Afak",
		"Description": [
			"Afaka"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Aghb",
		"Description": [
			"Caucasian Albanian"
		],
		"Added": "2012-11-01"
	},
	{
		"Type": "script",
		"Subtag": "Ahom",
		"Description": [
			"Ahom",
			"Tai Ahom"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "script",
		"Subtag": "Arab",
		"Description": [
			"Arabic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Aran",
		"Description": [
			"Arabic (Nastaliq variant)"
		],
		"Added": "2014-12-11"
	},
	{
		"Type": "script",
		"Subtag": "Armi",
		"Description": [
			"Imperial Aramaic"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Armn",
		"Description": [
			"Armenian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Avst",
		"Description": [
			"Avestan"
		],
		"Added": "2007-07-28"
	},
	{
		"Type": "script",
		"Subtag": "Bali",
		"Description": [
			"Balinese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Bamu",
		"Description": [
			"Bamum"
		],
		"Added": "2009-07-30"
	},
	{
		"Type": "script",
		"Subtag": "Bass",
		"Description": [
			"Bassa Vah"
		],
		"Added": "2010-04-10"
	},
	{
		"Type": "script",
		"Subtag": "Batk",
		"Description": [
			"Batak"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Beng",
		"Description": [
			"Bengali",
			"Bangla"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Bhks",
		"Description": [
			"Bhaiksuki"
		],
		"Added": "2015-07-24"
	},
	{
		"Type": "script",
		"Subtag": "Blis",
		"Description": [
			"Blissymbols"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Bopo",
		"Description": [
			"Bopomofo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Brah",
		"Description": [
			"Brahmi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Brai",
		"Description": [
			"Braille"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Bugi",
		"Description": [
			"Buginese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Buhd",
		"Description": [
			"Buhid"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Cakm",
		"Description": [
			"Chakma"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Cans",
		"Description": [
			"Unified Canadian Aboriginal Syllabics"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Cari",
		"Description": [
			"Carian"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Cham",
		"Description": [
			"Cham"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Cher",
		"Description": [
			"Cherokee"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Cirt",
		"Description": [
			"Cirth"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Copt",
		"Description": [
			"Coptic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Cprt",
		"Description": [
			"Cypriot"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Cyrl",
		"Description": [
			"Cyrillic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Cyrs",
		"Description": [
			"Cyrillic (Old Church Slavonic variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Deva",
		"Description": [
			"Devanagari",
			"Nagari"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Dogr",
		"Description": [
			"Dogra"
		],
		"Added": "2017-01-13"
	},
	{
		"Type": "script",
		"Subtag": "Dsrt",
		"Description": [
			"Deseret",
			"Mormon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Dupl",
		"Description": [
			"Duployan shorthand",
			"Duployan stenography"
		],
		"Added": "2010-08-16"
	},
	{
		"Type": "script",
		"Subtag": "Egyd",
		"Description": [
			"Egyptian demotic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Egyh",
		"Description": [
			"Egyptian hieratic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Egyp",
		"Description": [
			"Egyptian hieroglyphs"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Elba",
		"Description": [
			"Elbasan"
		],
		"Added": "2010-08-16"
	},
	{
		"Type": "script",
		"Subtag": "Ethi",
		"Description": [
			"Ethiopic",
			"Geʻez",
			"Ge'ez"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Geok",
		"Description": [
			"Khutsuri (Asomtavruli and Nuskhuri)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Geor",
		"Description": [
			"Georgian (Mkhedruli and Mtavruli)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Glag",
		"Description": [
			"Glagolitic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Gong",
		"Description": [
			"Gunjala Gondi"
		],
		"Added": "2017-01-13"
	},
	{
		"Type": "script",
		"Subtag": "Gonm",
		"Description": [
			"Masaram Gondi"
		],
		"Added": "2017-01-13"
	},
	{
		"Type": "script",
		"Subtag": "Goth",
		"Description": [
			"Gothic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Gran",
		"Description": [
			"Grantha"
		],
		"Added": "2009-12-09"
	},
	{
		"Type": "script",
		"Subtag": "Grek",
		"Description": [
			"Greek"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Gujr",
		"Description": [
			"Gujarati"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Guru",
		"Description": [
			"Gurmukhi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hanb",
		"Description": [
			"Han with Bopomofo (alias for Han + Bopomofo)"
		],
		"Added": "2016-02-08"
	},
	{
		"Type": "script",
		"Subtag": "Hang",
		"Description": [
			"Hangul",
			"Hangŭl",
			"Hangeul"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hani",
		"Description": [
			"Han",
			"Hanzi",
			"Kanji",
			"Hanja"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hano",
		"Description": [
			"Hanunoo",
			"Hanunóo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hans",
		"Description": [
			"Han (Simplified variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hant",
		"Description": [
			"Han (Traditional variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hatr",
		"Description": [
			"Hatran"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "script",
		"Subtag": "Hebr",
		"Description": [
			"Hebrew"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hira",
		"Description": [
			"Hiragana"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hluw",
		"Description": [
			"Anatolian Hieroglyphs",
			"Luwian Hieroglyphs",
			"Hittite Hieroglyphs"
		],
		"Added": "2011-12-28"
	},
	{
		"Type": "script",
		"Subtag": "Hmng",
		"Description": [
			"Pahawh Hmong"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hrkt",
		"Description": [
			"Japanese syllabaries (alias for Hiragana + Katakana)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Hung",
		"Description": [
			"Old Hungarian",
			"Hungarian Runic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Inds",
		"Description": [
			"Indus",
			"Harappan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Ital",
		"Description": [
			"Old Italic (Etruscan, Oscan, etc.)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Jamo",
		"Description": [
			"Jamo (alias for Jamo subset of Hangul)"
		],
		"Added": "2016-02-08"
	},
	{
		"Type": "script",
		"Subtag": "Java",
		"Description": [
			"Javanese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Jpan",
		"Description": [
			"Japanese (alias for Han + Hiragana + Katakana)"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Jurc",
		"Description": [
			"Jurchen"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Kali",
		"Description": [
			"Kayah Li"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Kana",
		"Description": [
			"Katakana"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Khar",
		"Description": [
			"Kharoshthi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Khmr",
		"Description": [
			"Khmer"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Khoj",
		"Description": [
			"Khojki"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "script",
		"Subtag": "Kitl",
		"Description": [
			"Khitan large script"
		],
		"Added": "2014-12-11"
	},
	{
		"Type": "script",
		"Subtag": "Kits",
		"Description": [
			"Khitan small script"
		],
		"Added": "2014-12-11"
	},
	{
		"Type": "script",
		"Subtag": "Knda",
		"Description": [
			"Kannada"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Kore",
		"Description": [
			"Korean (alias for Hangul + Han)"
		],
		"Added": "2007-07-05"
	},
	{
		"Type": "script",
		"Subtag": "Kpel",
		"Description": [
			"Kpelle"
		],
		"Added": "2010-04-10"
	},
	{
		"Type": "script",
		"Subtag": "Kthi",
		"Description": [
			"Kaithi"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Lana",
		"Description": [
			"Tai Tham",
			"Lanna"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Laoo",
		"Description": [
			"Lao"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Latf",
		"Description": [
			"Latin (Fraktur variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Latg",
		"Description": [
			"Latin (Gaelic variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Latn",
		"Description": [
			"Latin"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Leke",
		"Description": [
			"Leke"
		],
		"Added": "2015-07-24"
	},
	{
		"Type": "script",
		"Subtag": "Lepc",
		"Description": [
			"Lepcha",
			"Róng"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Limb",
		"Description": [
			"Limbu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Lina",
		"Description": [
			"Linear A"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Linb",
		"Description": [
			"Linear B"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Lisu",
		"Description": [
			"Lisu",
			"Fraser"
		],
		"Added": "2009-03-13"
	},
	{
		"Type": "script",
		"Subtag": "Loma",
		"Description": [
			"Loma"
		],
		"Added": "2010-04-10"
	},
	{
		"Type": "script",
		"Subtag": "Lyci",
		"Description": [
			"Lycian"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Lydi",
		"Description": [
			"Lydian"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Mahj",
		"Description": [
			"Mahajani"
		],
		"Added": "2012-11-01"
	},
	{
		"Type": "script",
		"Subtag": "Maka",
		"Description": [
			"Makasar"
		],
		"Added": "2017-01-13"
	},
	{
		"Type": "script",
		"Subtag": "Mand",
		"Description": [
			"Mandaic",
			"Mandaean"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Mani",
		"Description": [
			"Manichaean"
		],
		"Added": "2007-07-28"
	},
	{
		"Type": "script",
		"Subtag": "Marc",
		"Description": [
			"Marchen"
		],
		"Added": "2014-12-11"
	},
	{
		"Type": "script",
		"Subtag": "Maya",
		"Description": [
			"Mayan hieroglyphs"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Medf",
		"Description": [
			"Medefaidrin",
			"Oberi Okaime",
			"Oberi Ɔkaimɛ"
		],
		"Added": "2017-01-13"
	},
	{
		"Type": "script",
		"Subtag": "Mend",
		"Description": [
			"Mende Kikakui"
		],
		"Added": "2010-04-10"
	},
	{
		"Type": "script",
		"Subtag": "Merc",
		"Description": [
			"Meroitic Cursive"
		],
		"Added": "2009-12-09"
	},
	{
		"Type": "script",
		"Subtag": "Mero",
		"Description": [
			"Meroitic Hieroglyphs"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Mlym",
		"Description": [
			"Malayalam"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Modi",
		"Description": [
			"Modi",
			"Moḍī"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "script",
		"Subtag": "Mong",
		"Description": [
			"Mongolian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Moon",
		"Description": [
			"Moon",
			"Moon code",
			"Moon script",
			"Moon type"
		],
		"Added": "2007-01-26"
	},
	{
		"Type": "script",
		"Subtag": "Mroo",
		"Description": [
			"Mro",
			"Mru"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Mtei",
		"Description": [
			"Meitei Mayek",
			"Meithei",
			"Meetei"
		],
		"Added": "2007-01-26"
	},
	{
		"Type": "script",
		"Subtag": "Mult",
		"Description": [
			"Multani"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "script",
		"Subtag": "Mymr",
		"Description": [
			"Myanmar",
			"Burmese"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Narb",
		"Description": [
			"Old North Arabian",
			"Ancient North Arabian"
		],
		"Added": "2010-04-10"
	},
	{
		"Type": "script",
		"Subtag": "Nbat",
		"Description": [
			"Nabataean"
		],
		"Added": "2010-04-10"
	},
	{
		"Type": "script",
		"Subtag": "Newa",
		"Description": [
			"Newa",
			"Newar",
			"Newari",
			"Nepāla lipi"
		],
		"Added": "2016-01-04"
	},
	{
		"Type": "script",
		"Subtag": "Nkgb",
		"Description": [
			"Nakhi Geba",
			"'Na-'Khi ²Ggŏ-¹baw",
			"Naxi Geba"
		],
		"Added": "2009-03-13"
	},
	{
		"Type": "script",
		"Subtag": "Nkoo",
		"Description": [
			"N’Ko",
			"N'Ko"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Nshu",
		"Description": [
			"Nüshu"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Ogam",
		"Description": [
			"Ogham"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Olck",
		"Description": [
			"Ol Chiki",
			"Ol Cemet'",
			"Ol",
			"Santali"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Orkh",
		"Description": [
			"Old Turkic",
			"Orkhon Runic"
		],
		"Added": "2009-07-30"
	},
	{
		"Type": "script",
		"Subtag": "Orya",
		"Description": [
			"Oriya",
			"Odia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Osge",
		"Description": [
			"Osage"
		],
		"Added": "2014-12-11"
	},
	{
		"Type": "script",
		"Subtag": "Osma",
		"Description": [
			"Osmanya"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Palm",
		"Description": [
			"Palmyrene"
		],
		"Added": "2010-04-10"
	},
	{
		"Type": "script",
		"Subtag": "Pauc",
		"Description": [
			"Pau Cin Hau"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "script",
		"Subtag": "Perm",
		"Description": [
			"Old Permic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Phag",
		"Description": [
			"Phags-pa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Phli",
		"Description": [
			"Inscriptional Pahlavi"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Phlp",
		"Description": [
			"Psalter Pahlavi"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Phlv",
		"Description": [
			"Book Pahlavi"
		],
		"Added": "2007-07-28"
	},
	{
		"Type": "script",
		"Subtag": "Phnx",
		"Description": [
			"Phoenician"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Piqd",
		"Description": [
			"Klingon (KLI pIqaD)"
		],
		"Added": "2016-01-04"
	},
	{
		"Type": "script",
		"Subtag": "Plrd",
		"Description": [
			"Miao",
			"Pollard"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Prti",
		"Description": [
			"Inscriptional Parthian"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Qaaa..Qabx",
		"Description": [
			"Private use"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Rjng",
		"Description": [
			"Rejang",
			"Redjang",
			"Kaganga"
		],
		"Added": "2006-10-17"
	},
	{
		"Type": "script",
		"Subtag": "Roro",
		"Description": [
			"Rongorongo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Runr",
		"Description": [
			"Runic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Samr",
		"Description": [
			"Samaritan"
		],
		"Added": "2007-07-28"
	},
	{
		"Type": "script",
		"Subtag": "Sara",
		"Description": [
			"Sarati"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Sarb",
		"Description": [
			"Old South Arabian"
		],
		"Added": "2009-07-30"
	},
	{
		"Type": "script",
		"Subtag": "Saur",
		"Description": [
			"Saurashtra"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Sgnw",
		"Description": [
			"SignWriting"
		],
		"Added": "2006-10-17"
	},
	{
		"Type": "script",
		"Subtag": "Shaw",
		"Description": [
			"Shavian",
			"Shaw"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Shrd",
		"Description": [
			"Sharada",
			"Śāradā"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Sidd",
		"Description": [
			"Siddham",
			"Siddhaṃ",
			"Siddhamātṛkā"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "script",
		"Subtag": "Sind",
		"Description": [
			"Khudawadi",
			"Sindhi"
		],
		"Added": "2010-08-16"
	},
	{
		"Type": "script",
		"Subtag": "Sinh",
		"Description": [
			"Sinhala"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Sora",
		"Description": [
			"Sora Sompeng"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Soyo",
		"Description": [
			"Soyombo"
		],
		"Added": "2017-01-13"
	},
	{
		"Type": "script",
		"Subtag": "Sund",
		"Description": [
			"Sundanese"
		],
		"Added": "2006-07-21"
	},
	{
		"Type": "script",
		"Subtag": "Sylo",
		"Description": [
			"Syloti Nagri"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Syrc",
		"Description": [
			"Syriac"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Syre",
		"Description": [
			"Syriac (Estrangelo variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Syrj",
		"Description": [
			"Syriac (Western variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Syrn",
		"Description": [
			"Syriac (Eastern variant)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Tagb",
		"Description": [
			"Tagbanwa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Takr",
		"Description": [
			"Takri",
			"Ṭākrī",
			"Ṭāṅkrī"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Tale",
		"Description": [
			"Tai Le"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Talu",
		"Description": [
			"New Tai Lue"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Taml",
		"Description": [
			"Tamil"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Tang",
		"Description": [
			"Tangut"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Tavt",
		"Description": [
			"Tai Viet"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Telu",
		"Description": [
			"Telugu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Teng",
		"Description": [
			"Tengwar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Tfng",
		"Description": [
			"Tifinagh",
			"Berber"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Tglg",
		"Description": [
			"Tagalog",
			"Baybayin",
			"Alibata"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Thaa",
		"Description": [
			"Thaana"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Thai",
		"Description": [
			"Thai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Tibt",
		"Description": [
			"Tibetan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Tirh",
		"Description": [
			"Tirhuta"
		],
		"Added": "2011-08-16"
	},
	{
		"Type": "script",
		"Subtag": "Ugar",
		"Description": [
			"Ugaritic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Vaii",
		"Description": [
			"Vai"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Visp",
		"Description": [
			"Visible Speech"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Wara",
		"Description": [
			"Warang Citi",
			"Varang Kshiti"
		],
		"Added": "2009-12-09"
	},
	{
		"Type": "script",
		"Subtag": "Wole",
		"Description": [
			"Woleai"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "script",
		"Subtag": "Xpeo",
		"Description": [
			"Old Persian"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Xsux",
		"Description": [
			"Sumero-Akkadian cuneiform"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Yiii",
		"Description": [
			"Yi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Zanb",
		"Description": [
			"Zanabazar Square",
			"Zanabazarin Dörböljin Useg",
			"Xewtee Dörböljin Bicig",
			"Horizontal Square Script"
		],
		"Added": "2017-01-13"
	},
	{
		"Type": "script",
		"Subtag": "Zinh",
		"Description": [
			"Code for inherited script"
		],
		"Added": "2009-04-03",
		"Comments": [
			"Not intended for use as a language subtag"
		]
	},
	{
		"Type": "script",
		"Subtag": "Zmth",
		"Description": [
			"Mathematical notation"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Zsye",
		"Description": [
			"Symbols (Emoji variant)"
		],
		"Added": "2016-01-04"
	},
	{
		"Type": "script",
		"Subtag": "Zsym",
		"Description": [
			"Symbols"
		],
		"Added": "2007-12-05"
	},
	{
		"Type": "script",
		"Subtag": "Zxxx",
		"Description": [
			"Code for unwritten documents"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Zyyy",
		"Description": [
			"Code for undetermined script"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "script",
		"Subtag": "Zzzz",
		"Description": [
			"Code for uncoded script"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AA",
		"Description": [
			"Private use"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AC",
		"Description": [
			"Ascension Island"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "region",
		"Subtag": "AD",
		"Description": [
			"Andorra"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AE",
		"Description": [
			"United Arab Emirates"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AF",
		"Description": [
			"Afghanistan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AG",
		"Description": [
			"Antigua and Barbuda"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AI",
		"Description": [
			"Anguilla"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AL",
		"Description": [
			"Albania"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AM",
		"Description": [
			"Armenia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AN",
		"Description": [
			"Netherlands Antilles"
		],
		"Added": "2005-10-16",
		"Deprecated": "2011-01-07",
		"Comments": [
			"see BQ, CW, and SX"
		]
	},
	{
		"Type": "region",
		"Subtag": "AO",
		"Description": [
			"Angola"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AQ",
		"Description": [
			"Antarctica"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AR",
		"Description": [
			"Argentina"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AS",
		"Description": [
			"American Samoa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AT",
		"Description": [
			"Austria"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AU",
		"Description": [
			"Australia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AW",
		"Description": [
			"Aruba"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AX",
		"Description": [
			"Åland Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "AZ",
		"Description": [
			"Azerbaijan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BA",
		"Description": [
			"Bosnia and Herzegovina"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BB",
		"Description": [
			"Barbados"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BD",
		"Description": [
			"Bangladesh"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BE",
		"Description": [
			"Belgium"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BF",
		"Description": [
			"Burkina Faso"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BG",
		"Description": [
			"Bulgaria"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BH",
		"Description": [
			"Bahrain"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BI",
		"Description": [
			"Burundi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BJ",
		"Description": [
			"Benin"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BL",
		"Description": [
			"Saint Barthélemy"
		],
		"Added": "2007-11-02"
	},
	{
		"Type": "region",
		"Subtag": "BM",
		"Description": [
			"Bermuda"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BN",
		"Description": [
			"Brunei Darussalam"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BO",
		"Description": [
			"Bolivia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BQ",
		"Description": [
			"Bonaire, Sint Eustatius and Saba"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "region",
		"Subtag": "BR",
		"Description": [
			"Brazil"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BS",
		"Description": [
			"Bahamas"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BT",
		"Description": [
			"Bhutan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BU",
		"Description": [
			"Burma"
		],
		"Added": "2005-10-16",
		"Deprecated": "1989-12-05",
		"Preferred-Value": "MM"
	},
	{
		"Type": "region",
		"Subtag": "BV",
		"Description": [
			"Bouvet Island"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BW",
		"Description": [
			"Botswana"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BY",
		"Description": [
			"Belarus"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "BZ",
		"Description": [
			"Belize"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CA",
		"Description": [
			"Canada"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CC",
		"Description": [
			"Cocos (Keeling) Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CD",
		"Description": [
			"The Democratic Republic of the Congo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CF",
		"Description": [
			"Central African Republic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CG",
		"Description": [
			"Congo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CH",
		"Description": [
			"Switzerland"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CI",
		"Description": [
			"Côte d'Ivoire"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CK",
		"Description": [
			"Cook Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CL",
		"Description": [
			"Chile"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CM",
		"Description": [
			"Cameroon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CN",
		"Description": [
			"China"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CO",
		"Description": [
			"Colombia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CP",
		"Description": [
			"Clipperton Island"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "region",
		"Subtag": "CR",
		"Description": [
			"Costa Rica"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CS",
		"Description": [
			"Serbia and Montenegro"
		],
		"Added": "2005-10-16",
		"Deprecated": "2006-10-05",
		"Comments": [
			"see RS for Serbia or ME for Montenegro"
		]
	},
	{
		"Type": "region",
		"Subtag": "CU",
		"Description": [
			"Cuba"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CV",
		"Description": [
			"Cabo Verde",
			"Cape Verde"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CW",
		"Description": [
			"Curaçao"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "region",
		"Subtag": "CX",
		"Description": [
			"Christmas Island"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CY",
		"Description": [
			"Cyprus"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "CZ",
		"Description": [
			"Czechia",
			"Czech Republic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "DD",
		"Description": [
			"German Democratic Republic"
		],
		"Added": "2005-10-16",
		"Deprecated": "1990-10-30",
		"Preferred-Value": "DE"
	},
	{
		"Type": "region",
		"Subtag": "DE",
		"Description": [
			"Germany"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "DG",
		"Description": [
			"Diego Garcia"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "region",
		"Subtag": "DJ",
		"Description": [
			"Djibouti"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "DK",
		"Description": [
			"Denmark"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "DM",
		"Description": [
			"Dominica"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "DO",
		"Description": [
			"Dominican Republic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "DZ",
		"Description": [
			"Algeria"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "EA",
		"Description": [
			"Ceuta, Melilla"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "region",
		"Subtag": "EC",
		"Description": [
			"Ecuador"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "EE",
		"Description": [
			"Estonia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "EG",
		"Description": [
			"Egypt"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "EH",
		"Description": [
			"Western Sahara"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ER",
		"Description": [
			"Eritrea"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ES",
		"Description": [
			"Spain"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ET",
		"Description": [
			"Ethiopia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "EU",
		"Description": [
			"European Union"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "region",
		"Subtag": "EZ",
		"Description": [
			"Eurozone"
		],
		"Added": "2016-07-14"
	},
	{
		"Type": "region",
		"Subtag": "FI",
		"Description": [
			"Finland"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "FJ",
		"Description": [
			"Fiji"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "FK",
		"Description": [
			"Falkland Islands (Malvinas)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "FM",
		"Description": [
			"Federated States of Micronesia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "FO",
		"Description": [
			"Faroe Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "FR",
		"Description": [
			"France"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "FX",
		"Description": [
			"Metropolitan France"
		],
		"Added": "2005-10-16",
		"Deprecated": "1997-07-14",
		"Preferred-Value": "FR"
	},
	{
		"Type": "region",
		"Subtag": "GA",
		"Description": [
			"Gabon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GB",
		"Description": [
			"United Kingdom"
		],
		"Added": "2005-10-16",
		"Comments": [
			"as of 2006-03-29 GB no longer includes the Channel Islands and",
			"Isle of Man; see GG, JE, IM"
		]
	},
	{
		"Type": "region",
		"Subtag": "GD",
		"Description": [
			"Grenada"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GE",
		"Description": [
			"Georgia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GF",
		"Description": [
			"French Guiana"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GG",
		"Description": [
			"Guernsey"
		],
		"Added": "2006-03-29"
	},
	{
		"Type": "region",
		"Subtag": "GH",
		"Description": [
			"Ghana"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GI",
		"Description": [
			"Gibraltar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GL",
		"Description": [
			"Greenland"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GM",
		"Description": [
			"Gambia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GN",
		"Description": [
			"Guinea"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GP",
		"Description": [
			"Guadeloupe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GQ",
		"Description": [
			"Equatorial Guinea"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GR",
		"Description": [
			"Greece"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GS",
		"Description": [
			"South Georgia and the South Sandwich Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GT",
		"Description": [
			"Guatemala"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GU",
		"Description": [
			"Guam"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GW",
		"Description": [
			"Guinea-Bissau"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "GY",
		"Description": [
			"Guyana"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "HK",
		"Description": [
			"Hong Kong"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "HM",
		"Description": [
			"Heard Island and McDonald Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "HN",
		"Description": [
			"Honduras"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "HR",
		"Description": [
			"Croatia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "HT",
		"Description": [
			"Haiti"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "HU",
		"Description": [
			"Hungary"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IC",
		"Description": [
			"Canary Islands"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "region",
		"Subtag": "ID",
		"Description": [
			"Indonesia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IE",
		"Description": [
			"Ireland"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IL",
		"Description": [
			"Israel"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IM",
		"Description": [
			"Isle of Man"
		],
		"Added": "2006-03-29"
	},
	{
		"Type": "region",
		"Subtag": "IN",
		"Description": [
			"India"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IO",
		"Description": [
			"British Indian Ocean Territory"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IQ",
		"Description": [
			"Iraq"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IR",
		"Description": [
			"Islamic Republic of Iran"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IS",
		"Description": [
			"Iceland"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "IT",
		"Description": [
			"Italy"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "JE",
		"Description": [
			"Jersey"
		],
		"Added": "2006-03-29"
	},
	{
		"Type": "region",
		"Subtag": "JM",
		"Description": [
			"Jamaica"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "JO",
		"Description": [
			"Jordan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "JP",
		"Description": [
			"Japan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KE",
		"Description": [
			"Kenya"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KG",
		"Description": [
			"Kyrgyzstan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KH",
		"Description": [
			"Cambodia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KI",
		"Description": [
			"Kiribati"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KM",
		"Description": [
			"Comoros"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KN",
		"Description": [
			"Saint Kitts and Nevis"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KP",
		"Description": [
			"Democratic People's Republic of Korea"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KR",
		"Description": [
			"Republic of Korea"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KW",
		"Description": [
			"Kuwait"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KY",
		"Description": [
			"Cayman Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "KZ",
		"Description": [
			"Kazakhstan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LA",
		"Description": [
			"Lao People's Democratic Republic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LB",
		"Description": [
			"Lebanon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LC",
		"Description": [
			"Saint Lucia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LI",
		"Description": [
			"Liechtenstein"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LK",
		"Description": [
			"Sri Lanka"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LR",
		"Description": [
			"Liberia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LS",
		"Description": [
			"Lesotho"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LT",
		"Description": [
			"Lithuania"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LU",
		"Description": [
			"Luxembourg"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LV",
		"Description": [
			"Latvia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "LY",
		"Description": [
			"Libya"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MA",
		"Description": [
			"Morocco"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MC",
		"Description": [
			"Monaco"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MD",
		"Description": [
			"Moldova"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ME",
		"Description": [
			"Montenegro"
		],
		"Added": "2006-10-05"
	},
	{
		"Type": "region",
		"Subtag": "MF",
		"Description": [
			"Saint Martin (French part)"
		],
		"Added": "2007-11-02"
	},
	{
		"Type": "region",
		"Subtag": "MG",
		"Description": [
			"Madagascar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MH",
		"Description": [
			"Marshall Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MK",
		"Description": [
			"The Former Yugoslav Republic of Macedonia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ML",
		"Description": [
			"Mali"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MM",
		"Description": [
			"Myanmar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MN",
		"Description": [
			"Mongolia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MO",
		"Description": [
			"Macao"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MP",
		"Description": [
			"Northern Mariana Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MQ",
		"Description": [
			"Martinique"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MR",
		"Description": [
			"Mauritania"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MS",
		"Description": [
			"Montserrat"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MT",
		"Description": [
			"Malta"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MU",
		"Description": [
			"Mauritius"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MV",
		"Description": [
			"Maldives"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MW",
		"Description": [
			"Malawi"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MX",
		"Description": [
			"Mexico"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MY",
		"Description": [
			"Malaysia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "MZ",
		"Description": [
			"Mozambique"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NA",
		"Description": [
			"Namibia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NC",
		"Description": [
			"New Caledonia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NE",
		"Description": [
			"Niger"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NF",
		"Description": [
			"Norfolk Island"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NG",
		"Description": [
			"Nigeria"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NI",
		"Description": [
			"Nicaragua"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NL",
		"Description": [
			"Netherlands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NO",
		"Description": [
			"Norway"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NP",
		"Description": [
			"Nepal"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NR",
		"Description": [
			"Nauru"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NT",
		"Description": [
			"Neutral Zone"
		],
		"Added": "2005-10-16",
		"Deprecated": "1993-07-12"
	},
	{
		"Type": "region",
		"Subtag": "NU",
		"Description": [
			"Niue"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "NZ",
		"Description": [
			"New Zealand"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "OM",
		"Description": [
			"Oman"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PA",
		"Description": [
			"Panama"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PE",
		"Description": [
			"Peru"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PF",
		"Description": [
			"French Polynesia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PG",
		"Description": [
			"Papua New Guinea"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PH",
		"Description": [
			"Philippines"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PK",
		"Description": [
			"Pakistan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PL",
		"Description": [
			"Poland"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PM",
		"Description": [
			"Saint Pierre and Miquelon"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PN",
		"Description": [
			"Pitcairn"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PR",
		"Description": [
			"Puerto Rico"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PS",
		"Description": [
			"State of Palestine"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PT",
		"Description": [
			"Portugal"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PW",
		"Description": [
			"Palau"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "PY",
		"Description": [
			"Paraguay"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "QA",
		"Description": [
			"Qatar"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "QM..QZ",
		"Description": [
			"Private use"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "RE",
		"Description": [
			"Réunion"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "RO",
		"Description": [
			"Romania"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "RS",
		"Description": [
			"Serbia"
		],
		"Added": "2006-10-05"
	},
	{
		"Type": "region",
		"Subtag": "RU",
		"Description": [
			"Russian Federation"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "RW",
		"Description": [
			"Rwanda"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SA",
		"Description": [
			"Saudi Arabia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SB",
		"Description": [
			"Solomon Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SC",
		"Description": [
			"Seychelles"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SD",
		"Description": [
			"Sudan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SE",
		"Description": [
			"Sweden"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SG",
		"Description": [
			"Singapore"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SH",
		"Description": [
			"Saint Helena, Ascension and Tristan da Cunha"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SI",
		"Description": [
			"Slovenia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SJ",
		"Description": [
			"Svalbard and Jan Mayen"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SK",
		"Description": [
			"Slovakia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SL",
		"Description": [
			"Sierra Leone"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SM",
		"Description": [
			"San Marino"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SN",
		"Description": [
			"Senegal"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SO",
		"Description": [
			"Somalia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SR",
		"Description": [
			"Suriname"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SS",
		"Description": [
			"South Sudan"
		],
		"Added": "2011-08-25"
	},
	{
		"Type": "region",
		"Subtag": "ST",
		"Description": [
			"Sao Tome and Principe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SU",
		"Description": [
			"Union of Soviet Socialist Republics"
		],
		"Added": "2005-10-16",
		"Deprecated": "1992-08-30"
	},
	{
		"Type": "region",
		"Subtag": "SV",
		"Description": [
			"El Salvador"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SX",
		"Description": [
			"Sint Maarten (Dutch part)"
		],
		"Added": "2011-01-07"
	},
	{
		"Type": "region",
		"Subtag": "SY",
		"Description": [
			"Syrian Arab Republic"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "SZ",
		"Description": [
			"Swaziland"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TA",
		"Description": [
			"Tristan da Cunha"
		],
		"Added": "2009-07-29"
	},
	{
		"Type": "region",
		"Subtag": "TC",
		"Description": [
			"Turks and Caicos Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TD",
		"Description": [
			"Chad"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TF",
		"Description": [
			"French Southern Territories"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TG",
		"Description": [
			"Togo"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TH",
		"Description": [
			"Thailand"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TJ",
		"Description": [
			"Tajikistan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TK",
		"Description": [
			"Tokelau"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TL",
		"Description": [
			"Timor-Leste"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TM",
		"Description": [
			"Turkmenistan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TN",
		"Description": [
			"Tunisia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TO",
		"Description": [
			"Tonga"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TP",
		"Description": [
			"East Timor"
		],
		"Added": "2005-10-16",
		"Deprecated": "2002-05-20",
		"Preferred-Value": "TL"
	},
	{
		"Type": "region",
		"Subtag": "TR",
		"Description": [
			"Turkey"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TT",
		"Description": [
			"Trinidad and Tobago"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TV",
		"Description": [
			"Tuvalu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TW",
		"Description": [
			"Taiwan, Province of China"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "TZ",
		"Description": [
			"United Republic of Tanzania"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "UA",
		"Description": [
			"Ukraine"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "UG",
		"Description": [
			"Uganda"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "UM",
		"Description": [
			"United States Minor Outlying Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "UN",
		"Description": [
			"United Nations"
		],
		"Added": "2016-07-14"
	},
	{
		"Type": "region",
		"Subtag": "US",
		"Description": [
			"United States"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "UY",
		"Description": [
			"Uruguay"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "UZ",
		"Description": [
			"Uzbekistan"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "VA",
		"Description": [
			"Holy See (Vatican City State)"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "VC",
		"Description": [
			"Saint Vincent and the Grenadines"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "VE",
		"Description": [
			"Venezuela"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "VG",
		"Description": [
			"British Virgin Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "VI",
		"Description": [
			"U.S. Virgin Islands"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "VN",
		"Description": [
			"Viet Nam"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "VU",
		"Description": [
			"Vanuatu"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "WF",
		"Description": [
			"Wallis and Futuna"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "WS",
		"Description": [
			"Samoa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "XA..XZ",
		"Description": [
			"Private use"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "YD",
		"Description": [
			"Democratic Yemen"
		],
		"Added": "2005-10-16",
		"Deprecated": "1990-08-14",
		"Preferred-Value": "YE"
	},
	{
		"Type": "region",
		"Subtag": "YE",
		"Description": [
			"Yemen"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "YT",
		"Description": [
			"Mayotte"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "YU",
		"Description": [
			"Yugoslavia"
		],
		"Added": "2005-10-16",
		"Deprecated": "2003-07-23",
		"Comments": [
			"see BA, HR, ME, MK, RS, or SI"
		]
	},
	{
		"Type": "region",
		"Subtag": "ZA",
		"Description": [
			"South Africa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ZM",
		"Description": [
			"Zambia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ZR",
		"Description": [
			"Zaire"
		],
		"Added": "2005-10-16",
		"Deprecated": "1997-07-14",
		"Preferred-Value": "CD"
	},
	{
		"Type": "region",
		"Subtag": "ZW",
		"Description": [
			"Zimbabwe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "ZZ",
		"Description": [
			"Private use"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "001",
		"Description": [
			"World"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "002",
		"Description": [
			"Africa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "003",
		"Description": [
			"North America"
		],
		"Added": "2010-08-16",
		"Comments": [
			"Includes Northern America (021), Caribbean (029), and Central",
			"America (013); see also 021"
		]
	},
	{
		"Type": "region",
		"Subtag": "005",
		"Description": [
			"South America"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "009",
		"Description": [
			"Oceania"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "011",
		"Description": [
			"Western Africa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "013",
		"Description": [
			"Central America"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "014",
		"Description": [
			"Eastern Africa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "015",
		"Description": [
			"Northern Africa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "017",
		"Description": [
			"Middle Africa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "018",
		"Description": [
			"Southern Africa"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "019",
		"Description": [
			"Americas"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "021",
		"Description": [
			"Northern America"
		],
		"Added": "2005-10-16",
		"Comments": [
			"Does not include Caribbean (029) or Central America (013); see",
			"also 003"
		]
	},
	{
		"Type": "region",
		"Subtag": "029",
		"Description": [
			"Caribbean"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "030",
		"Description": [
			"Eastern Asia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "034",
		"Description": [
			"Southern Asia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "035",
		"Description": [
			"South-Eastern Asia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "039",
		"Description": [
			"Southern Europe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "053",
		"Description": [
			"Australia and New Zealand"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "054",
		"Description": [
			"Melanesia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "057",
		"Description": [
			"Micronesia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "061",
		"Description": [
			"Polynesia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "142",
		"Description": [
			"Asia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "143",
		"Description": [
			"Central Asia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "145",
		"Description": [
			"Western Asia"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "150",
		"Description": [
			"Europe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "151",
		"Description": [
			"Eastern Europe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "154",
		"Description": [
			"Northern Europe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "155",
		"Description": [
			"Western Europe"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "region",
		"Subtag": "419",
		"Description": [
			"Latin America and the Caribbean"
		],
		"Added": "2005-10-16"
	},
	{
		"Type": "variant",
		"Subtag": "1606nict",
		"Description": [
			"Late Middle French (to 1606)"
		],
		"Added": "2007-03-20",
		"Prefix": [
			"frm"
		],
		"Comments": [
			"16th century French as in Jean Nicot, \"Thresor de la langue",
			"francoyse\", 1606, but also including some French similar to that of",
			"Rabelais"
		]
	},
	{
		"Type": "variant",
		"Subtag": "1694acad",
		"Description": [
			"Early Modern French"
		],
		"Added": "2007-03-20",
		"Prefix": [
			"fr"
		],
		"Comments": [
			"17th century French, as catalogued in the \"Dictionnaire de",
			"l'académie françoise\", 4eme ed. 1694; frequently includes",
			"elements of Middle French, as this is a transitional period"
		]
	},
	{
		"Type": "variant",
		"Subtag": "1901",
		"Description": [
			"Traditional German orthography"
		],
		"Added": "2005-10-16",
		"Prefix": [
			"de"
		]
	},
	{
		"Type": "variant",
		"Subtag": "1959acad",
		"Description": [
			"\"Academic\" (\"governmental\") variant of Belarusian as",
			"codified in 1959"
		],
		"Added": "2008-09-30",
		"Prefix": [
			"be"
		]
	},
	{
		"Type": "variant",
		"Subtag": "1994",
		"Description": [
			"Standardized Resian orthography"
		],
		"Added": "2007-07-28",
		"Prefix": [
			"sl-rozaj",
			"sl-rozaj-biske",
			"sl-rozaj-njiva",
			"sl-rozaj-osojs",
			"sl-rozaj-solba"
		],
		"Comments": [
			"For standardized Resian an orthography was published in 1994."
		]
	},
	{
		"Type": "variant",
		"Subtag": "1996",
		"Description": [
			"German orthography of 1996"
		],
		"Added": "2005-10-16",
		"Prefix": [
			"de"
		]
	},
	{
		"Type": "variant",
		"Subtag": "abl1943",
		"Description": [
			"Orthographic formulation of 1943 - Official in Brazil",
			"(Formulário Ortográfico de 1943 - Oficial no Brasil)"
		],
		"Added": "2015-05-06",
		"Prefix": [
			"pt-BR"
		],
		"Comments": [
			"Denotes conventions established by the Academia Brasileira de",
			"Letras in 1943 and generally used in Brazil until 2009"
		]
	},
	{
		"Type": "variant",
		"Subtag": "alalc97",
		"Description": [
			"ALA-LC Romanization, 1997 edition"
		],
		"Added": "2009-12-09",
		"Comments": [
			"Romanizations recommended by the American Library Association",
			"and the Library of Congress, in \"ALA-LC Romanization Tables:",
			"Transliteration Schemes for Non-Roman Scripts\" (1997), ISBN",
			"978-0-8444-0940-5."
		]
	},
	{
		"Type": "variant",
		"Subtag": "aluku",
		"Description": [
			"Aluku dialect",
			"Boni dialect"
		],
		"Added": "2009-09-05",
		"Prefix": [
			"djk"
		],
		"Comments": [
			"Aluku dialect of the \"Busi Nenge Tongo\" English-based Creole",
			"continuum in Eastern Suriname and Western French Guiana"
		]
	},
	{
		"Type": "variant",
		"Subtag": "ao1990",
		"Description": [
			"Portuguese Language Orthographic Agreement of 1990 (Acordo",
			"Ortográfico da Língua Portuguesa de 1990)"
		],
		"Added": "2015-05-06",
		"Prefix": [
			"pt",
			"gl"
		],
		"Comments": [
			"Portuguese orthography conventions established in 1990 but",
			"not brought into effect until 2009"
		]
	},
	{
		"Type": "variant",
		"Subtag": "arevela",
		"Description": [
			"Eastern Armenian"
		],
		"Added": "2006-09-18",
		"Prefix": [
			"hy"
		]
	},
	{
		"Type": "variant",
		"Subtag": "arevmda",
		"Description": [
			"Western Armenian"
		],
		"Added": "2006-09-18",
		"Prefix": [
			"hy"
		]
	},
	{
		"Type": "variant",
		"Subtag": "baku1926",
		"Description": [
			"Unified Turkic Latin Alphabet (Historical)"
		],
		"Added": "2007-04-18",
		"Prefix": [
			"az",
			"ba",
			"crh",
			"kk",
			"krc",
			"ky",
			"sah",
			"tk",
			"tt",
			"uz"
		],
		"Comments": [
			"Denotes alphabet used in Turkic republics/regions of the",
			"former USSR in late 1920s, and throughout 1930s, which aspired to",
			"represent equivalent phonemes in a unified fashion. Also known as: New",
			"Turkic Alphabet; Birlәşdirilmiş Jeni Tyrk",
			"Әlifbasь (Birlesdirilmis Jeni Tyrk Elifbasi);",
			"Jaŋalif (Janalif)."
		]
	},
	{
		"Type": "variant",
		"Subtag": "balanka",
		"Description": [
			"The Balanka dialect of Anii"
		],
		"Added": "2014-02-15",
		"Prefix": [
			"blo"
		],
		"Comments": [
			"Balanka is one of 19 Anii dialects."
		]
	},
	{
		"Type": "variant",
		"Subtag": "barla",
		"Description": [
			"The Barlavento dialect group of Kabuverdianu"
		],
		"Prefix": [
			"kea"
		],
		"Comments": [
			"Barlavento is one of the two main dialect groups of",
			"Kabuverdianu."
		],
		"Added": "2013-12-10"
	},
	{
		"Type": "variant",
		"Subtag": "basiceng",
		"Description": [
			"Basic English"
		],
		"Added": "2015-12-29",
		"Prefix": [
			"en"
		]
	},
	{
		"Type": "variant",
		"Subtag": "bauddha",
		"Description": [
			"Buddhist Hybrid Sanskrit"
		],
		"Added": "2010-07-28",
		"Prefix": [
			"sa"
		]
	},
	{
		"Type": "variant",
		"Subtag": "biscayan",
		"Description": [
			"Biscayan dialect of Basque"
		],
		"Added": "2010-04-13",
		"Prefix": [
			"eu"
		]
	},
	{
		"Type": "variant",
		"Subtag": "biske",
		"Description": [
			"The San Giorgio dialect of Resian",
			"The Bila dialect of Resian"
		],
		"Added": "2007-07-05",
		"Prefix": [
			"sl-rozaj"
		],
		"Comments": [
			"The dialect of San Giorgio/Bila is one of the four major local",
			"dialects of Resian"
		]
	},
	{
		"Type": "variant",
		"Subtag": "bohoric",
		"Description": [
			"Slovene in Bohorič alphabet"
		],
		"Added": "2012-06-27",
		"Prefix": [
			"sl"
		],
		"Comments": [
			"The subtag represents the alphabet codified by Adam Bohorič",
			"in 1584 and used from the first printed Slovene book and up to the",
			"mid-19th century."
		]
	},
	{
		"Type": "variant",
		"Subtag": "boont",
		"Description": [
			"Boontling"
		],
		"Added": "2006-09-18",
		"Prefix": [
			"en"
		],
		"Comments": [
			"Jargon embedded in American English"
		]
	},
	{
		"Type": "variant",
		"Subtag": "colb1945",
		"Description": [
			"Portuguese-Brazilian Orthographic Convention of 1945",
			"(Convenção Ortográfica Luso-Brasileira de 1945)"
		],
		"Added": "2015-05-06",
		"Prefix": [
			"pt"
		],
		"Comments": [
			"Portuguese orthography conventions established in 1945,",
			"generally in effect until 2009. This reform was not ratified in",
			"Brazil."
		]
	},
	{
		"Type": "variant",
		"Subtag": "cornu",
		"Description": [
			"Cornu-English",
			"Cornish English",
			"Anglo-Cornish"
		],
		"Added": "2015-12-07",
		"Prefix": [
			"en"
		]
	},
	{
		"Type": "variant",
		"Subtag": "dajnko",
		"Description": [
			"Slovene in Dajnko alphabet"
		],
		"Added": "2012-06-27",
		"Prefix": [
			"sl"
		],
		"Comments": [
			"The subtag represents the alphabet codified by Peter Dajnko",
			"and used from 1824 to 1839 mostly in Styria (in what is now Eastern",
			"Slovenia)."
		]
	},
	{
		"Type": "variant",
		"Subtag": "ekavsk",
		"Description": [
			"Serbian with Ekavian pronunciation"
		],
		"Prefix": [
			"sr",
			"sr-Latn",
			"sr-Cyrl"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "variant",
		"Subtag": "emodeng",
		"Description": [
			"Early Modern English (1500-1700)"
		],
		"Added": "2012-02-05",
		"Prefix": [
			"en"
		]
	},
	{
		"Type": "variant",
		"Subtag": "fonipa",
		"Description": [
			"International Phonetic Alphabet"
		],
		"Added": "2006-12-11"
	},
	{
		"Type": "variant",
		"Subtag": "fonnapa",
		"Description": [
			"North American Phonetic Alphabet",
			"Americanist Phonetic Notation"
		],
		"Added": "2016-06-24"
	},
	{
		"Type": "variant",
		"Subtag": "fonupa",
		"Description": [
			"Uralic Phonetic Alphabet"
		],
		"Added": "2006-12-11"
	},
	{
		"Type": "variant",
		"Subtag": "fonxsamp",
		"Description": [
			"X-SAMPA transcription"
		],
		"Added": "2010-10-23",
		"Comments": [
			"Indicates that the content is transcribed according to X-SAMPA"
		]
	},
	{
		"Type": "variant",
		"Subtag": "hepburn",
		"Description": [
			"Hepburn romanization"
		],
		"Added": "2009-10-01",
		"Prefix": [
			"ja-Latn"
		]
	},
	{
		"Type": "variant",
		"Subtag": "heploc",
		"Description": [
			"Hepburn romanization, Library of Congress method"
		],
		"Added": "2009-10-01",
		"Deprecated": "2010-02-07",
		"Preferred-Value": "alalc97",
		"Prefix": [
			"ja-Latn-hepburn"
		],
		"Comments": [
			"Preferred tag is ja-Latn-alalc97"
		]
	},
	{
		"Type": "variant",
		"Subtag": "hognorsk",
		"Description": [
			"Norwegian in Høgnorsk (High Norwegian) orthography"
		],
		"Added": "2010-01-02",
		"Prefix": [
			"nn"
		],
		"Comments": [
			"Norwegian following Ivar Aasen's orthographical principles,",
			"including modern usage."
		]
	},
	{
		"Type": "variant",
		"Subtag": "ijekavsk",
		"Description": [
			"Serbian with Ijekavian pronunciation"
		],
		"Prefix": [
			"sr",
			"sr-Latn",
			"sr-Cyrl"
		],
		"Added": "2013-12-02"
	},
	{
		"Type": "variant",
		"Subtag": "itihasa",
		"Description": [
			"Epic Sanskrit"
		],
		"Added": "2010-07-28",
		"Prefix": [
			"sa"
		]
	},
	{
		"Type": "variant",
		"Subtag": "jauer",
		"Description": [
			"Jauer dialect of Romansh"
		],
		"Added": "2010-06-29",
		"Prefix": [
			"rm"
		],
		"Comments": [
			"The spoken dialect of the Val Müstair, which has no written",
			"standard."
		]
	},
	{
		"Type": "variant",
		"Subtag": "jyutping",
		"Description": [
			"Jyutping Cantonese Romanization"
		],
		"Added": "2010-10-23",
		"Prefix": [
			"yue"
		],
		"Comments": [
			"Jyutping romanization of Cantonese"
		]
	},
	{
		"Type": "variant",
		"Subtag": "kkcor",
		"Description": [
			"Common Cornish orthography of Revived Cornish"
		],
		"Added": "2008-10-14",
		"Prefix": [
			"kw"
		]
	},
	{
		"Type": "variant",
		"Subtag": "kociewie",
		"Description": [
			"The Kociewie dialect of Polish"
		],
		"Added": "2014-11-27",
		"Prefix": [
			"pl"
		],
		"Comments": [
			"The dialect of Kociewie is spoken in the region around",
			"Starogard Gdański, Tczew and Świecie in northern Poland."
		]
	},
	{
		"Type": "variant",
		"Subtag": "kscor",
		"Description": [
			"Standard Cornish orthography of Revived Cornish",
			"Kernowek Standard"
		],
		"Added": "2012-06-27",
		"Prefix": [
			"kw"
		]
	},
	{
		"Type": "variant",
		"Subtag": "laukika",
		"Description": [
			"Classical Sanskrit"
		],
		"Added": "2010-07-28",
		"Prefix": [
			"sa"
		]
	},
	{
		"Type": "variant",
		"Subtag": "lipaw",
		"Description": [
			"The Lipovaz dialect of Resian",
			"The Lipovec dialect of Resian"
		],
		"Added": "2007-08-11",
		"Prefix": [
			"sl-rozaj"
		],
		"Comments": [
			"The dialect of Lipovaz/Lipovec is one of the minor local",
			"dialects of Resian"
		]
	},
	{
		"Type": "variant",
		"Subtag": "luna1918",
		"Description": [
			"Post-1917 Russian orthography"
		],
		"Added": "2010-10-10",
		"Prefix": [
			"ru"
		],
		"Comments": [
			"Russian orthography as established by the 1917/1918",
			"orthographic reforms"
		]
	},
	{
		"Type": "variant",
		"Subtag": "metelko",
		"Description": [
			"Slovene in Metelko alphabet"
		],
		"Added": "2012-06-27",
		"Prefix": [
			"sl"
		],
		"Comments": [
			"The subtag represents the alphabet codified by Franc Serafin",
			"Metelko and used from 1825 to 1833."
		]
	},
	{
		"Type": "variant",
		"Subtag": "monoton",
		"Description": [
			"Monotonic Greek"
		],
		"Added": "2006-12-11",
		"Prefix": [
			"el"
		]
	},
	{
		"Type": "variant",
		"Subtag": "ndyuka",
		"Description": [
			"Ndyuka dialect",
			"Aukan dialect"
		],
		"Added": "2009-09-05",
		"Prefix": [
			"djk"
		],
		"Comments": [
			"Ndyuka dialect of the \"Busi Nenge Tongo\" English-based",
			"Creole continuum in Eastern Suriname and Western French Guiana"
		]
	},
	{
		"Type": "variant",
		"Subtag": "nedis",
		"Description": [
			"Natisone dialect",
			"Nadiza dialect"
		],
		"Added": "2005-10-16",
		"Prefix": [
			"sl"
		]
	},
	{
		"Type": "variant",
		"Subtag": "newfound",
		"Description": [
			"Newfoundland English"
		],
		"Added": "2015-11-25",
		"Prefix": [
			"en-CA"
		]
	},
	{
		"Type": "variant",
		"Subtag": "njiva",
		"Description": [
			"The Gniva dialect of Resian",
			"The Njiva dialect of Resian"
		],
		"Added": "2007-07-05",
		"Prefix": [
			"sl-rozaj"
		],
		"Comments": [
			"The dialect of Gniva/Njiva is one of the four major local",
			"dialects of Resian"
		]
	},
	{
		"Type": "variant",
		"Subtag": "nulik",
		"Description": [
			"Volapük nulik",
			"Volapük perevidöl",
			"Volapük nulädik",
			"de Jong's Volapük",
			"New Volapük",
			"Revised Volapük",
			"Modern Volapük"
		],
		"Added": "2012-01-28",
		"Prefix": [
			"vo"
		]
	},
	{
		"Type": "variant",
		"Subtag": "osojs",
		"Description": [
			"The Oseacco dialect of Resian",
			"The Osojane dialect of Resian"
		],
		"Added": "2007-07-05",
		"Prefix": [
			"sl-rozaj"
		],
		"Comments": [
			"The dialect of Oseacco/Osojane is one of the four major local",
			"dialects of Resian"
		]
	},
	{
		"Type": "variant",
		"Subtag": "oxendict",
		"Description": [
			"Oxford English Dictionary spelling"
		],
		"Added": "2015-04-17",
		"Prefix": [
			"en"
		]
	},
	{
		"Type": "variant",
		"Subtag": "pahawh2",
		"Description": [
			"Pahawh Hmong Second Stage Reduced orthography"
		],
		"Added": "2017-01-13",
		"Prefix": [
			"mww",
			"hnj"
		]
	},
	{
		"Type": "variant",
		"Subtag": "pahawh3",
		"Description": [
			"Pahawh Hmong Third Stage Reduced orthography"
		],
		"Added": "2017-01-13",
		"Prefix": [
			"mww",
			"hnj"
		]
	},
	{
		"Type": "variant",
		"Subtag": "pahawh4",
		"Description": [
			"Pahawh Hmong Final Version orthography"
		],
		"Added": "2017-01-13",
		"Prefix": [
			"mww",
			"hnj"
		]
	},
	{
		"Type": "variant",
		"Subtag": "pamaka",
		"Description": [
			"Pamaka dialect"
		],
		"Added": "2009-09-05",
		"Prefix": [
			"djk"
		],
		"Comments": [
			"Pamaka dialect of the \"Busi Nenge Tongo\" English-based",
			"Creole continuum in Eastern Suriname and Western French Guiana"
		]
	},
	{
		"Type": "variant",
		"Subtag": "petr1708",
		"Description": [
			"Petrine orthography"
		],
		"Added": "2010-10-10",
		"Prefix": [
			"ru"
		],
		"Comments": [
			"Russian orthography from the Petrine orthographic reforms of",
			"1708 to the 1917 orthographic reform"
		]
	},
	{
		"Type": "variant",
		"Subtag": "pinyin",
		"Description": [
			"Pinyin romanization"
		],
		"Added": "2008-10-14",
		"Prefix": [
			"zh-Latn",
			"bo-Latn"
		]
	},
	{
		"Type": "variant",
		"Subtag": "polyton",
		"Description": [
			"Polytonic Greek"
		],
		"Added": "2006-12-11",
		"Prefix": [
			"el"
		]
	},
	{
		"Type": "variant",
		"Subtag": "puter",
		"Description": [
			"Puter idiom of Romansh"
		],
		"Added": "2010-06-29",
		"Prefix": [
			"rm"
		],
		"Comments": [
			"Puter is one of the five traditional written standards or",
			"\"idioms\" of the Romansh language."
		]
	},
	{
		"Type": "variant",
		"Subtag": "rigik",
		"Description": [
			"Volapük rigik",
			"Schleyer's Volapük",
			"Original Volapük",
			"Classic Volapük"
		],
		"Added": "2012-01-28",
		"Prefix": [
			"vo"
		]
	},
	{
		"Type": "variant",
		"Subtag": "rozaj",
		"Description": [
			"Resian",
			"Resianic",
			"Rezijan"
		],
		"Added": "2005-10-16",
		"Prefix": [
			"sl"
		]
	},
	{
		"Type": "variant",
		"Subtag": "rumgr",
		"Description": [
			"Rumantsch Grischun"
		],
		"Added": "2010-06-29",
		"Prefix": [
			"rm"
		],
		"Comments": [
			"Supraregional Romansh written standard"
		]
	},
	{
		"Type": "variant",
		"Subtag": "scotland",
		"Description": [
			"Scottish Standard English"
		],
		"Added": "2007-08-31",
		"Prefix": [
			"en"
		]
	},
	{
		"Type": "variant",
		"Subtag": "scouse",
		"Description": [
			"Scouse"
		],
		"Added": "2006-09-18",
		"Prefix": [
			"en"
		],
		"Comments": [
			"English Liverpudlian dialect known as 'Scouse'"
		]
	},
	{
		"Type": "variant",
		"Subtag": "simple",
		"Description": [
			"Simplified form"
		],
		"Added": "2015-12-29"
	},
	{
		"Type": "variant",
		"Subtag": "solba",
		"Description": [
			"The Stolvizza dialect of Resian",
			"The Solbica dialect of Resian"
		],
		"Added": "2007-07-05",
		"Prefix": [
			"sl-rozaj"
		],
		"Comments": [
			"The dialect of Stolvizza/Solbica is one of the four major",
			"local dialects of Resian"
		]
	},
	{
		"Type": "variant",
		"Subtag": "sotav",
		"Description": [
			"The Sotavento dialect group of Kabuverdianu"
		],
		"Prefix": [
			"kea"
		],
		"Comments": [
			"Sotavento is one of the two main dialect groups of",
			"Kabuverdianu."
		],
		"Added": "2013-12-10"
	},
	{
		"Type": "variant",
		"Subtag": "spanglis",
		"Description": [
			"Spanglish"
		],
		"Added": "2017-02-23",
		"Prefix": [
			"en",
			"es"
		],
		"Comments": [
			"A variety of contact dialects of English and Spanish"
		]
	},
	{
		"Type": "variant",
		"Subtag": "surmiran",
		"Description": [
			"Surmiran idiom of Romansh"
		],
		"Added": "2010-06-29",
		"Prefix": [
			"rm"
		],
		"Comments": [
			"Surmiran is one of the five traditional written standards or",
			"\"idioms\" of the Romansh language."
		]
	},
	{
		"Type": "variant",
		"Subtag": "sursilv",
		"Description": [
			"Sursilvan idiom of Romansh"
		],
		"Added": "2010-06-29",
		"Prefix": [
			"rm"
		],
		"Comments": [
			"Sursilvan is one of the five traditional written standards or",
			"\"idioms\" of the Romansh language."
		]
	},
	{
		"Type": "variant",
		"Subtag": "sutsilv",
		"Description": [
			"Sutsilvan idiom of Romansh"
		],
		"Added": "2010-06-29",
		"Prefix": [
			"rm"
		],
		"Comments": [
			"Sutsilvan is one of the five traditional written standards or",
			"\"idioms\" of the Romansh language."
		]
	},
	{
		"Type": "variant",
		"Subtag": "tarask",
		"Description": [
			"Belarusian in Taraskievica orthography"
		],
		"Added": "2007-04-27",
		"Prefix": [
			"be"
		],
		"Comments": [
			"The subtag represents Branislau Taraskievic's Belarusian",
			"orthography as published in \"Bielaruski klasycny pravapis\" by Juras",
			"Buslakou, Vincuk Viacorka, Zmicier Sanko, and Zmicier Sauka (Vilnia-",
			"Miensk 2005)."
		]
	},
	{
		"Type": "variant",
		"Subtag": "uccor",
		"Description": [
			"Unified Cornish orthography of Revived Cornish"
		],
		"Added": "2008-10-14",
		"Prefix": [
			"kw"
		]
	},
	{
		"Type": "variant",
		"Subtag": "ucrcor",
		"Description": [
			"Unified Cornish Revised orthography of Revived Cornish"
		],
		"Added": "2008-10-14",
		"Prefix": [
			"kw"
		]
	},
	{
		"Type": "variant",
		"Subtag": "ulster",
		"Description": [
			"Ulster dialect of Scots"
		],
		"Added": "2010-04-10",
		"Prefix": [
			"sco"
		]
	},
	{
		"Type": "variant",
		"Subtag": "unifon",
		"Description": [
			"Unifon phonetic alphabet"
		],
		"Added": "2013-10-02",
		"Prefix": [
			"en",
			"hup",
			"kyh",
			"tol",
			"yur"
		]
	},
	{
		"Type": "variant",
		"Subtag": "vaidika",
		"Description": [
			"Vedic Sanskrit"
		],
		"Added": "2010-07-28",
		"Prefix": [
			"sa"
		],
		"Comments": [
			"The most ancient dialect of Sanskrit used in verse and prose",
			"composed until about the 4th century B.C.E."
		]
	},
	{
		"Type": "variant",
		"Subtag": "valencia",
		"Description": [
			"Valencian"
		],
		"Added": "2007-03-06",
		"Prefix": [
			"ca"
		],
		"Comments": [
			"Variety spoken in the \"Comunidad Valenciana\" region of Spain,",
			"where it is co-official with Spanish."
		]
	},
	{
		"Type": "variant",
		"Subtag": "vallader",
		"Description": [
			"Vallader idiom of Romansh"
		],
		"Added": "2010-06-29",
		"Prefix": [
			"rm"
		],
		"Comments": [
			"Vallader is one of the five traditional written standards or",
			"\"idioms\" of the Romansh language."
		]
	},
	{
		"Type": "variant",
		"Subtag": "wadegile",
		"Description": [
			"Wade-Giles romanization"
		],
		"Added": "2008-10-03",
		"Prefix": [
			"zh-Latn"
		]
	},
	{
		"Type": "grandfathered",
		"Tag": "art-lojban",
		"Description": [
			"Lojban"
		],
		"Added": "2001-11-11",
		"Deprecated": "2003-09-02",
		"Preferred-Value": "jbo"
	},
	{
		"Type": "grandfathered",
		"Tag": "cel-gaulish",
		"Description": [
			"Gaulish"
		],
		"Added": "2001-05-25",
		"Deprecated": "2015-03-29",
		"Comments": [
			"see xcg, xga, xtg"
		]
	},
	{
		"Type": "grandfathered",
		"Tag": "en-GB-oed",
		"Description": [
			"English, Oxford English Dictionary spelling"
		],
		"Added": "2003-07-09",
		"Deprecated": "2015-04-17",
		"Preferred-Value": "en-GB-oxendict"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-ami",
		"Description": [
			"Amis"
		],
		"Added": "1999-05-25",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "ami"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-bnn",
		"Description": [
			"Bunun"
		],
		"Added": "1999-05-25",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "bnn"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-default",
		"Description": [
			"Default Language"
		],
		"Added": "1998-03-10"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-enochian",
		"Description": [
			"Enochian"
		],
		"Added": "2002-07-03",
		"Deprecated": "2015-03-29"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-hak",
		"Description": [
			"Hakka"
		],
		"Added": "1999-01-31",
		"Deprecated": "2000-01-10",
		"Preferred-Value": "hak"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-klingon",
		"Description": [
			"Klingon"
		],
		"Added": "1999-05-26",
		"Deprecated": "2004-02-24",
		"Preferred-Value": "tlh"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-lux",
		"Description": [
			"Luxembourgish"
		],
		"Added": "1997-09-19",
		"Deprecated": "1998-09-09",
		"Preferred-Value": "lb"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-mingo",
		"Description": [
			"Mingo"
		],
		"Added": "1997-09-19"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-navajo",
		"Description": [
			"Navajo"
		],
		"Added": "1997-09-19",
		"Deprecated": "2000-02-18",
		"Preferred-Value": "nv"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-pwn",
		"Description": [
			"Paiwan"
		],
		"Added": "1999-05-25",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "pwn"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-tao",
		"Description": [
			"Tao"
		],
		"Added": "1999-05-25",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "tao"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-tay",
		"Description": [
			"Tayal"
		],
		"Added": "1999-05-25",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "tay"
	},
	{
		"Type": "grandfathered",
		"Tag": "i-tsu",
		"Description": [
			"Tsou"
		],
		"Added": "1999-05-25",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "tsu"
	},
	{
		"Type": "grandfathered",
		"Tag": "no-bok",
		"Description": [
			"Norwegian Bokmal"
		],
		"Added": "1995-08-23",
		"Deprecated": "2000-02-18",
		"Preferred-Value": "nb"
	},
	{
		"Type": "grandfathered",
		"Tag": "no-nyn",
		"Description": [
			"Norwegian Nynorsk"
		],
		"Added": "1995-08-23",
		"Deprecated": "2000-02-18",
		"Preferred-Value": "nn"
	},
	{
		"Type": "grandfathered",
		"Tag": "sgn-BE-FR",
		"Description": [
			"Belgian-French Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "sfb"
	},
	{
		"Type": "grandfathered",
		"Tag": "sgn-BE-NL",
		"Description": [
			"Belgian-Flemish Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "vgt"
	},
	{
		"Type": "grandfathered",
		"Tag": "sgn-CH-DE",
		"Description": [
			"Swiss German Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "sgg"
	},
	{
		"Type": "grandfathered",
		"Tag": "zh-guoyu",
		"Description": [
			"Mandarin or Standard Chinese"
		],
		"Added": "1999-12-18",
		"Deprecated": "2005-07-15",
		"Preferred-Value": "cmn"
	},
	{
		"Type": "grandfathered",
		"Tag": "zh-hakka",
		"Description": [
			"Hakka"
		],
		"Added": "1999-12-18",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "hak"
	},
	{
		"Type": "grandfathered",
		"Tag": "zh-min",
		"Description": [
			"Min, Fuzhou, Hokkien, Amoy, or Taiwanese"
		],
		"Added": "1999-12-18",
		"Deprecated": "2009-07-29",
		"Comments": [
			"see cdo, cpx, czo, mnp, nan"
		]
	},
	{
		"Type": "grandfathered",
		"Tag": "zh-min-nan",
		"Description": [
			"Minnan, Hokkien, Amoy, Taiwanese, Southern Min, Southern",
			"Fujian, Hoklo, Southern Fukien, Ho-lo"
		],
		"Added": "2001-03-26",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "nan"
	},
	{
		"Type": "grandfathered",
		"Tag": "zh-xiang",
		"Description": [
			"Xiang or Hunanese"
		],
		"Added": "1999-12-18",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "hsn"
	},
	{
		"Type": "redundant",
		"Tag": "az-Arab",
		"Description": [
			"Azerbaijani in Arabic script"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "az-Cyrl",
		"Description": [
			"Azerbaijani in Cyrillic script"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "az-Latn",
		"Description": [
			"Azerbaijani in Latin script"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "be-Latn",
		"Description": [
			"Belarusian in Latin script"
		],
		"Added": "2005-01-06"
	},
	{
		"Type": "redundant",
		"Tag": "bs-Cyrl",
		"Description": [
			"Bosnian in Cyrillic script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "bs-Latn",
		"Description": [
			"Bosnian in Latin script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-1901",
		"Description": [
			"German, traditional orthography"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-1996",
		"Description": [
			"German, orthography of 1996"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-AT-1901",
		"Description": [
			"German, Austrian variant, traditional orthography"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-AT-1996",
		"Description": [
			"German, Austrian variant, orthography of 1996"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-CH-1901",
		"Description": [
			"German, Swiss variant, traditional orthography"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-CH-1996",
		"Description": [
			"German, Swiss variant, orthography of 1996"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-DE-1901",
		"Description": [
			"German, German variant, traditional orthography"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "de-DE-1996",
		"Description": [
			"German, German variant, orthography of 1996"
		],
		"Added": "2001-07-17"
	},
	{
		"Type": "redundant",
		"Tag": "en-boont",
		"Description": [
			"Boontling"
		],
		"Added": "2003-02-14"
	},
	{
		"Type": "redundant",
		"Tag": "en-scouse",
		"Description": [
			"Scouse"
		],
		"Added": "2000-05-25"
	},
	{
		"Type": "redundant",
		"Tag": "es-419",
		"Description": [
			"Latin American Spanish"
		],
		"Added": "2005-07-15"
	},
	{
		"Type": "redundant",
		"Tag": "iu-Cans",
		"Description": [
			"Inuktitut in Canadian Aboriginal Syllabic script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "iu-Latn",
		"Description": [
			"Inuktitut in Latin script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "mn-Cyrl",
		"Description": [
			"Mongolian in Cyrillic script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "mn-Mong",
		"Description": [
			"Mongolian in Mongolian script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-BR",
		"Description": [
			"Brazilian Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "bzs"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-CO",
		"Description": [
			"Colombian Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "csn"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-DE",
		"Description": [
			"German Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "gsg"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-DK",
		"Description": [
			"Danish Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "dsl"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-ES",
		"Description": [
			"Spanish Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "ssp"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-FR",
		"Description": [
			"French Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "fsl"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-GB",
		"Description": [
			"British Sign Language"
		],
		"Added": "2001-03-02",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "bfi"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-GR",
		"Description": [
			"Greek Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "gss"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-IE",
		"Description": [
			"Irish Sign Language"
		],
		"Added": "2001-03-02",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "isg"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-IT",
		"Description": [
			"Italian Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "ise"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-JP",
		"Description": [
			"Japanese Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "jsl"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-MX",
		"Description": [
			"Mexican Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "mfs"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-NI",
		"Description": [
			"Nicaraguan Sign Language"
		],
		"Added": "2001-03-02",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "ncs"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-NL",
		"Description": [
			"Dutch Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "dse"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-NO",
		"Description": [
			"Norwegian Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "nsl"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-PT",
		"Description": [
			"Portuguese Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "psr"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-SE",
		"Description": [
			"Swedish Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "swl"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-US",
		"Description": [
			"American Sign Language"
		],
		"Added": "2001-03-02",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "ase"
	},
	{
		"Type": "redundant",
		"Tag": "sgn-ZA",
		"Description": [
			"South African Sign Language"
		],
		"Added": "2001-11-11",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "sfs"
	},
	{
		"Type": "redundant",
		"Tag": "sl-nedis",
		"Description": [
			"Natisone dialect, Nadiza dialect"
		],
		"Added": "2004-06-01"
	},
	{
		"Type": "redundant",
		"Tag": "sl-rozaj",
		"Description": [
			"Resian, Resianic, Rezijan"
		],
		"Added": "2003-10-09"
	},
	{
		"Type": "redundant",
		"Tag": "sr-Cyrl",
		"Description": [
			"Serbian in Cyrillic script"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "sr-Latn",
		"Description": [
			"Serbian in Latin script"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "tg-Arab",
		"Description": [
			"Tajik in Arabic script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "tg-Cyrl",
		"Description": [
			"Tajik in Cyrillic script"
		],
		"Added": "2005-02-17"
	},
	{
		"Type": "redundant",
		"Tag": "uz-Cyrl",
		"Description": [
			"Uzbek in Cyrillic script"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "uz-Latn",
		"Description": [
			"Uzbek in Latin script"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "yi-Latn",
		"Description": [
			"Yiddish, in Latin script"
		],
		"Added": "2003-01-07"
	},
	{
		"Type": "redundant",
		"Tag": "zh-cmn",
		"Description": [
			"Mandarin Chinese"
		],
		"Added": "2005-07-15",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "cmn"
	},
	{
		"Type": "redundant",
		"Tag": "zh-cmn-Hans",
		"Description": [
			"Mandarin Chinese (Simplified)"
		],
		"Added": "2005-07-15",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "cmn-Hans"
	},
	{
		"Type": "redundant",
		"Tag": "zh-cmn-Hant",
		"Description": [
			"Mandarin Chinese (Traditional)"
		],
		"Added": "2005-07-15",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "cmn-Hant"
	},
	{
		"Type": "redundant",
		"Tag": "zh-gan",
		"Description": [
			"Kan or Gan"
		],
		"Added": "1999-12-18",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "gan"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hans",
		"Description": [
			"simplified Chinese"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hans-CN",
		"Description": [
			"PRC Mainland Chinese in simplified script"
		],
		"Added": "2005-04-13"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hans-HK",
		"Description": [
			"Hong Kong Chinese in simplified script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hans-MO",
		"Description": [
			"Macao Chinese in simplified script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hans-SG",
		"Description": [
			"Singapore Chinese in simplified script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hans-TW",
		"Description": [
			"Taiwan Chinese in simplified script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hant",
		"Description": [
			"traditional Chinese"
		],
		"Added": "2003-05-30"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hant-CN",
		"Description": [
			"PRC Mainland Chinese in traditional script"
		],
		"Added": "2005-04-13"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hant-HK",
		"Description": [
			"Hong Kong Chinese in traditional script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hant-MO",
		"Description": [
			"Macao Chinese in traditional script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hant-SG",
		"Description": [
			"Singapore Chinese in traditional script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-Hant-TW",
		"Description": [
			"Taiwan Chinese in traditional script"
		],
		"Added": "2005-04-11"
	},
	{
		"Type": "redundant",
		"Tag": "zh-wuu",
		"Description": [
			"Shanghaiese or Wu"
		],
		"Added": "1999-12-18",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "wuu"
	},
	{
		"Type": "redundant",
		"Tag": "zh-yue",
		"Description": [
			"Cantonese"
		],
		"Added": "1999-12-18",
		"Deprecated": "2009-07-29",
		"Preferred-Value": "yue"
	}
]

},{}],71:[function(require,module,exports){
/**
 * @author Matthew Caruana Galizia <m@m.cg>
 * @license MIT: http://mattcg.mit-license.org/
 * @copyright Copyright (c) 2013, Matthew Caruana Galizia
 */

/*jshint node:true*/

'use strict';

var index = require('language-subtag-registry/data/json/index');
var registry = require('language-subtag-registry/data/json/registry');

module.exports = Subtag;

Subtag.ERR_NONEXISTENT = 1;
Subtag.ERR_TAG = 2;

function Subtag(subtag, type) {
	var types, i, record, error;

	// Lowercase for consistency (case is only a formatting convention, not a standard requirement).
	subtag = subtag.toLowerCase();
	type = type.toLowerCase();

	error = function(code, message) {
		var err;

		err = new Error(message);
		err.code = code;
		err.subtag = subtag;
		throw err;
	};

	types = index[subtag];
	if (!types) {
		error(Subtag.ERR_NONEXISTENT, 'Non-existent subtag \'' + subtag + '\'.');
	}

	i = types[type];
	if (!i && 0 !== i) {
		error(Subtag.ERR_NONEXISTENT, 'Non-existent subtag \'' + subtag + '\' of type \'' + type + '\'.');
	}

	record = registry[i];
	if (!record.Subtag) {
		error(Subtag.ERR_TAG, '\'' + subtag + '\' is a \'' + type + '\' tag.');
	}

	this.data = {};
	this.data.subtag = subtag;
	this.data.record = record;
	this.data.type = type;
}

Subtag.prototype.type = function() {
	return this.data.type;
};

Subtag.prototype.descriptions = function() {

	// Every record has one or more descriptions (stored as an array).
	return this.data.record.Description;
};

Subtag.prototype.preferred = function() {
	var type, preferred = this.data.record['Preferred-Value'];

	if (preferred) {
		type = this.data.type;
		if (type === 'extlang') {
			type = 'language';
		}

		return new Subtag(preferred, type);
	}

	return null;
};

Subtag.prototype.script = function() {
	var script = this.data.record['Suppress-Script'];

	if (script) {
		return new Subtag(script, 'script');
	}

	return null;
};

Subtag.prototype.scope = function() {
	return this.data.record.Scope || null;
};

Subtag.prototype.deprecated = function() {
	return this.data.record.Deprecated || null;
};

Subtag.prototype.added = function() {
	return this.data.record.Added;
};

Subtag.prototype.comments = function() {

	// Comments don't always occur for records, so switch to an empty array if missing.
	return this.data.record.Comments || [];
};

Subtag.prototype.format = function() {
	var subtag = this.data.subtag;

	switch (this.data.type) {
	case 'region':
		return subtag.toUpperCase();
	case 'script':
		return subtag[0].toUpperCase() + subtag.substr(1);
	}

	return subtag;
};

Subtag.prototype.toString = function() {
	return this.format();
};

},{"language-subtag-registry/data/json/index":67,"language-subtag-registry/data/json/registry":70}],72:[function(require,module,exports){
/**
 * @author Matthew Caruana Galizia <m@m.cg>
 * @license MIT: http://mattcg.mit-license.org/
 * @copyright Copyright (c) 2013, Matthew Caruana Galizia
 */

/*jshint node:true*/

'use strict';

var index = require('language-subtag-registry/data/json/index');
var registry = require('language-subtag-registry/data/json/registry');

var Subtag = require('./Subtag');

module.exports = Tag;

Tag.ERR_DEPRECATED = 1;
Tag.ERR_NO_LANGUAGE = 2;
Tag.ERR_UNKNOWN = 3;
Tag.ERR_TOO_LONG = 4;
Tag.ERR_EXTRA_REGION = 5;
Tag.ERR_EXTRA_EXTLANG = 6;
Tag.ERR_EXTRA_SCRIPT = 7;
Tag.ERR_DUPLICATE_VARIANT = 8;
Tag.ERR_WRONG_ORDER = 9;
Tag.ERR_SUPPRESS_SCRIPT = 10;
Tag.ERR_SUBTAG_DEPRECATED = 11;
Tag.ERR_EXTRA_LANGUAGE = 12;

function Tag(tag) {
	var types;

	// Lowercase for consistency (case is only a formatting convention, not a standard requirement).
	tag = tag.trim().toLowerCase();

	this.data = {};
	this.data.tag = tag;

	// Check if the input tag is grandfathered or redundant.
	types = index[tag];
	if (types && (types.grandfathered || types.redundant)) {
		this.data.record = registry[types.grandfathered || types.redundant];
	}
}

Tag.prototype.preferred = function() {
	var preferred = this.data.record['Preferred-Value'];

	if (preferred) {
		return new Tag(preferred);
	}

	return null;
};

Tag.prototype.subtags = function() {
	var codes, data = this.data, subtags = [];

	// No subtags if the tag is grandfathered.
	if (data.record && this.type() === 'grandfathered') {
		return subtags;
	}

	codes = data.tag.split('-');
	if (!codes.length) {
		return subtags;
	}

	// Try and find the language tag.
	codes.some(function(code, i) {
		var types;

		// Singletons and anything after are unhandled.
		if (code.length < 2) {
			return true; // Stop the loop (stop processing after a singleton).
		}

		types = index[code];

		// Check for non-existent tag.
		if (!types) {
			return; // Skip to the next item.
		}

		// Check against undefined because value could be 0.
		// Language subtags may only appear at the beginning of the tag, otherwise the subtag type is indeterminate.
		if (0 === i && undefined !== types.language) {
			subtags.push(new Subtag(code, 'language'));
			return;
		}

		switch (code.length) {
		case 2:

			// Should be a region.
			if (types.region) {
				subtags.push(new Subtag(code, 'region'));

			// Error case: language subtag in the wrong place.
			} else if (types.language) {
				subtags.push(new Subtag(code, 'language'));
			}

			break;
		case 3:

			// Could be a numeric region code e.g. '001' for 'World'.
			if (types.region) {
				subtags.push(new Subtag(code, 'region'));
			} else if (types.extlang) {
				subtags.push(new Subtag(code, 'extlang'));

			// Error case: language subtag in the wrong place.
			} else if (types.language) {
				subtags.push(new Subtag(code, 'language'));
			}

			break;
		case 4:

			// Could be a numeric variant.
			if (types.variant) {
				subtags.push(new Subtag(code, 'variant'));
			} else if (types.script) {
				subtags.push(new Subtag(code, 'script'));
			}

			break;
		default:

			// Should be a variant.
			if (types.variant) {
				subtags.push(new Subtag(code, 'variant'));
			}

			break;
		}
	});

	return subtags;
};

Tag.prototype.language = function() {
	return this.find('language');
};

Tag.prototype.region = function() {
	return this.find('region');
};

Tag.prototype.script = function() {
	return this.find('script');
};

Tag.prototype.find = function(type) {
	var i, l, subtag, subtags = this.subtags();

	for (i = 0, l = subtags.length; i < l; i++) {
		subtag = subtags[i];

		if (subtag.type() === type) {
			return subtag;
		}
	}
};

Tag.prototype.valid = function() {
	return this.errors().length < 1;
};

Tag.prototype.errors = function() {
	var error, subtags, data = this.data, errors = [];

	error = function(code, subtag) {
		var err, message;

		switch (code) {
		case Tag.ERR_DEPRECATED:
			message = 'The tag \'' + data.tag + '\' is deprecated.';

			// Note that a record that contains a 'Deprecated' field and no corresponding 'Preferred-Value' field has no replacement mapping (RFC 5646 section 3.1.6).
			if (data.record['Preferred-Value']) {
				message += ' Use \'' + data.record['Preferred-Value'] + '\' instead.';
			}

			break;
		case Tag.ERR_SUBTAG_DEPRECATED:
			message = 'The subtag \'' + subtag + '\' is deprecated.';
			break;
		case Tag.ERR_NO_LANGUAGE:
			if (!data.tag) {
				message = 'Empty tag.';
			} else {
				message = 'Missing language tag in \'' + data.tag + '\'.';
			}

			break;
		case Tag.ERR_UNKNOWN:
			message = 'Unknown code \'' + subtag + '\'';
			break;
		case Tag.ERR_TOO_LONG:
			message = 'The private-use subtag \'' + subtag + '\' is too long.';
			break;
		case Tag.ERR_EXTRA_LANGUAGE:
		case Tag.ERR_EXTRA_EXTLANG:
		case Tag.ERR_EXTRA_REGION:
		case Tag.ERR_EXTRA_SCRIPT:
			message = 'Extra ' + subtag.type() + ' subtag \'' + subtag + '\' found.';
			break;
		case Tag.ERR_DUPLICATE_VARIANT:
			message = 'Duplicate variant subtag \'' + subtag + '\' found.';
			break;
		case Tag.ERR_WRONG_ORDER:
			message = 'The subtag \'' + subtag[0] + '\' should not appear before \'' + subtag[1] + '\'.';
			break;
		case Tag.ERR_SUPPRESS_SCRIPT:
			message = 'The script subtag \'' + subtag + '\' is the same as the language suppress-script.';
			break;
		}

		err = new Error(message);
		err.code = code;
		err.tag = data.tag;
		err.subtag = subtag;
		errors.push(err);
	};

	// Check if the tag is grandfathered and if the grandfathered tag is deprecated (e.g. no-nyn).
	if (data.record) {
		if (data.record.Deprecated) {
			error(Tag.ERR_DEPRECATED);
		}

		// Only check every subtag if the tag is not explicitly listed as grandfathered or redundant.
		return errors;
	}

	// Check that all subtag codes are meaningful.
	data.tag.split('-').some(function(code, i, codes) {
		var types;

		// Ignore anything after a singleton.
		if (code.length < 2) {

			// Check that each private-use subtag is within the maximum allowed length.
			codes.slice(i).forEach(function(code) {
				if (code.length > 8) {
					error(Tag.ERR_TOO_LONG, code);
				}
			});

			return true;
		}

		types = index[code];
		if (!types) {
			error(Tag.ERR_UNKNOWN, code);
		}

		return false; // Continue to the next item.
	});

	// Check that first tag is a language tag.
	subtags = this.subtags();
	if (!subtags.length || 'language' !== subtags[0].type()) {
		error(Tag.ERR_NO_LANGUAGE);
		return errors;
	}

	// Check for more than one of some types and for deprecation.
	subtags.forEach(function(subtag, i) {
		var type = subtag.type(), language, script, found = this;

		if (subtag.deprecated()) {
			error(Tag.ERR_SUBTAG_DEPRECATED, subtag);
		}

		if (found[type]) {
			found[type].push(subtag);
		}

		switch (type) {
		case 'language':
			if (found.language.length > 1) {
				error(Tag.ERR_EXTRA_LANGUAGE, subtag);
			}

			break;
		case 'region':
			if (found.region.length > 1) {
				error(Tag.ERR_EXTRA_REGION, subtag);
			}

			break;
		case 'extlang':
			if (found.extlang.length > 1) {
				error(Tag.ERR_EXTRA_EXTLANG, subtag);
			}

			break;
		case 'script':
			if (found.script.length > 1) {
				error(Tag.ERR_EXTRA_SCRIPT, subtag);

			// Check if script is same as language suppress-script.
			} else {
				language = subtags[0];
				if ('language' === language.type()) {
					script = language.script();
					if (script && script.format() === subtag.format()) {
						error(Tag.ERR_SUPPRESS_SCRIPT, subtag);
					}
				}
			}

			break;
		case 'variant':
			if (found.variant.length > 1 && found.variant.some(function(variant) {
				return variant.format() === subtag.format();
			})) {
				error(Tag.ERR_DUPLICATE_VARIANT, subtag);
			}
		}
	}, {
		language: [],
		extlang: [],
		variant: [],
		script: [],
		region: []
	});

	// Check for correct order.
	subtags.forEach(function(subtag, i, subtags) {
		var priority = this, next = subtags[i + 1];

		if (next && priority[subtag.type()] > priority[next.type()]) {
			error(Tag.ERR_WRONG_ORDER, [subtag, next]);
		}
	}, {
		language: 4,
		extlang: 5,
		script: 6,
		region: 7,
		variant: 8
	});

	return errors;
};

Tag.prototype.type = function() {
	var record = this.data.record;

	if (record) {
		return record.Type;
	}

	return 'tag';
};

Tag.prototype.added = function() {
	var record = this.data.record;

	return record && record.Added;
};

Tag.prototype.deprecated = function() {
	var record = this.data.record;

	return record && record.Deprecated;
};

Tag.prototype.descriptions = function() {
	var record = this.data.record;

	if (record && record.Description) {
		return record.Description;
	}

	return [];
};

Tag.prototype.format = function() {
	var tag = this.data.tag;

	// Format according to algorithm defined in RFC 5646 section 2.1.1.
	return tag.split('-').reduce(function(p, c, i, a) {
		if (i === 0) {
			return c;
		}

		if (a[i - 1].length === 1) {
			return p + '-' + c;
		}

		switch (c.length) {
		case 2:
			return p + '-' + c.toUpperCase();
		case 4:
			return p + '-' + c[0].toUpperCase() + c.substr(1);
		}

		return p + '-' + c;
	});
};

},{"./Subtag":71,"language-subtag-registry/data/json/index":67,"language-subtag-registry/data/json/registry":70}],73:[function(require,module,exports){
/**
 * @author Matthew Caruana Galizia <m@m.cg>
 * @license MIT: http://mattcg.mit-license.org/
 * @copyright Copyright (c) 2013, Matthew Caruana Galizia
 */

/*jshint node:true*/

'use strict';

var Tag = require('./Tag');
var Subtag = require('./Subtag');

var index = require('language-subtag-registry/data/json/index');
var registry = require('language-subtag-registry/data/json/registry');

var tags = function(tag) {
	return new Tag(tag);
};

module.exports = tags;

tags.check = function(tag) {
	return new Tag(tag).valid();
};

tags.types = function(subtag) {
	var types = index[subtag];

	if (!types) {
		return [];
	}

	return Object.keys(types).filter(function(type) {
		return type !== 'grandfathered' && type !== 'redundant';
	});
};

tags.subtags = function(subtags) {
	var result = [];

	if (!Array.isArray(subtags)) {
		subtags = [subtags];
	}

	subtags.forEach(function(subtag) {
		tags.types(subtag).forEach(function(type) {
			result.push(new Subtag(subtag, type));
		});
	});

	return result;
};

tags.filter = function(subtags) {
	return subtags.filter(function(subtag) {
		return !tags.types(subtag).length;
	});
};

tags.search = function(query, all) {
	var test;

	if ('function' === typeof query.test) {
		test = function(description) {
			return query.test(description);
		};

	// If the query is all lowercase, make a case-insensitive match.
	} else if (query.toLowerCase() === query) {
		test = function(description) {
			return -1 !== description.toLowerCase().indexOf(query);
		};
	} else {
		test = function(description) {
			return -1 !== description.indexOf(query);
		};
	}

	return registry.filter(function(record) {
		if (!record.Subtag && !all) {
			return false;
		}

		return record.Description.some(test);

	// Sort by matched description string length.
	// This is a quick way to push precise matches towards the top.
	}).sort(function(a, b) {
		return Math.min.apply(Math, a.Description.filter(test).map(function(description) {
			return description.length;
		})) - Math.min.apply(Math, b.Description.filter(test).map(function(description) {
			return description.length;
		}));
	}).map(function(record) {
		if (record.Subtag) {
			return new Subtag(record.Subtag, record.Type);
		}

		return new Tag(record.Tag);
	});
};

tags.languages = function(macrolanguage) {
	var i, l, record, results = [];

	macrolanguage = macrolanguage.toLowerCase();
	if (!require('language-subtag-registry/data/json/macrolanguage')[macrolanguage]) {
		throw new Error('\'' + macrolanguage + '\' is not a macrolanguage.');
	}

	for (i = 0, l = registry.length; i < l; i++) {
		record = registry[i];
		if (record.Macrolanguage === macrolanguage) {
			results.push(new Subtag(record.Subtag, record.Type));
		}
	}

	return results;
};

tags.language = function(subtag) {
	return tags.type(subtag, 'language');
};

tags.region = function(subtag) {
	return tags.type(subtag, 'region');
};

tags.type = function(subtag, type) {
	var types = index[subtag.toLowerCase()];

	if (types && types[type]) {
		return new Subtag(subtag, type);
	}

	return null;
};

tags.date = function() {
	return require('language-subtag-registry/data/json/meta')['File-Date'];
};

},{"./Subtag":71,"./Tag":72,"language-subtag-registry/data/json/index":67,"language-subtag-registry/data/json/macrolanguage":68,"language-subtag-registry/data/json/meta":69,"language-subtag-registry/data/json/registry":70}],74:[function(require,module,exports){
L.Control.Fullscreen = L.Control.extend({
    options: {
        position: 'topleft',
        title: {
            'false': 'View Fullscreen',
            'true': 'Exit Fullscreen'
        }
    },

    onAdd: function (map) {
        var container = L.DomUtil.create('div', 'leaflet-control-fullscreen leaflet-bar leaflet-control');

        this.link = L.DomUtil.create('a', 'leaflet-control-fullscreen-button leaflet-bar-part', container);
        this.link.href = '#';

        this._map = map;
        this._map.on('fullscreenchange', this._toggleTitle, this);
        this._toggleTitle();

        L.DomEvent.on(this.link, 'click', this._click, this);

        return container;
    },

    _click: function (e) {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        this._map.toggleFullscreen(this.options);
    },

    _toggleTitle: function() {
        this.link.title = this.options.title[this._map.isFullscreen()];
    }
});

L.Map.include({
    isFullscreen: function () {
        return this._isFullscreen || false;
    },

    toggleFullscreen: function (options) {
        var container = this.getContainer();
        if (this.isFullscreen()) {
            if (options && options.pseudoFullscreen) {
                this._disablePseudoFullscreen(container);
            } else if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else {
                this._disablePseudoFullscreen(container);
            }
        } else {
            if (options && options.pseudoFullscreen) {
                this._enablePseudoFullscreen(container);
            } else if (container.requestFullscreen) {
                container.requestFullscreen();
            } else if (container.mozRequestFullScreen) {
                container.mozRequestFullScreen();
            } else if (container.webkitRequestFullscreen) {
                container.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (container.msRequestFullscreen) {
                container.msRequestFullscreen();
            } else {
                this._enablePseudoFullscreen(container);
            }
        }

    },

    _enablePseudoFullscreen: function (container) {
        L.DomUtil.addClass(container, 'leaflet-pseudo-fullscreen');
        this._setFullscreen(true);
        this.fire('fullscreenchange');
    },

    _disablePseudoFullscreen: function (container) {
        L.DomUtil.removeClass(container, 'leaflet-pseudo-fullscreen');
        this._setFullscreen(false);
        this.fire('fullscreenchange');
    },

    _setFullscreen: function(fullscreen) {
        this._isFullscreen = fullscreen;
        var container = this.getContainer();
        if (fullscreen) {
            L.DomUtil.addClass(container, 'leaflet-fullscreen-on');
        } else {
            L.DomUtil.removeClass(container, 'leaflet-fullscreen-on');
        }
        this.invalidateSize();
    },

    _onFullscreenChange: function (e) {
        var fullscreenElement =
            document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement;

        if (fullscreenElement === this.getContainer() && !this._isFullscreen) {
            this._setFullscreen(true);
            this.fire('fullscreenchange');
        } else if (fullscreenElement !== this.getContainer() && this._isFullscreen) {
            this._setFullscreen(false);
            this.fire('fullscreenchange');
        }
    }
});

L.Map.mergeOptions({
    fullscreenControl: false
});

L.Map.addInitHook(function () {
    if (this.options.fullscreenControl) {
        this.fullscreenControl = new L.Control.Fullscreen(this.options.fullscreenControl);
        this.addControl(this.fullscreenControl);
    }

    var fullscreenchange;

    if ('onfullscreenchange' in document) {
        fullscreenchange = 'fullscreenchange';
    } else if ('onmozfullscreenchange' in document) {
        fullscreenchange = 'mozfullscreenchange';
    } else if ('onwebkitfullscreenchange' in document) {
        fullscreenchange = 'webkitfullscreenchange';
    } else if ('onmsfullscreenchange' in document) {
        fullscreenchange = 'MSFullscreenChange';
    }

    if (fullscreenchange) {
        var onFullscreenChange = L.bind(this._onFullscreenChange, this);

        this.whenReady(function () {
            L.DomEvent.on(document, fullscreenchange, onFullscreenChange);
        });

        this.on('unload', function () {
            L.DomEvent.off(document, fullscreenchange, onFullscreenChange);
        });
    }
});

L.control.fullscreen = function (options) {
    return new L.Control.Fullscreen(options);
};

},{}],75:[function(require,module,exports){
/*
 (c) 2014, Vladimir Agafonkin
 simpleheat, a tiny JavaScript library for drawing heatmaps with Canvas
 https://github.com/mourner/simpleheat
*/
!function(){"use strict";function t(i){return this instanceof t?(this._canvas=i="string"==typeof i?document.getElementById(i):i,this._ctx=i.getContext("2d"),this._width=i.width,this._height=i.height,this._max=1,void this.clear()):new t(i)}t.prototype={defaultRadius:25,defaultGradient:{.4:"blue",.6:"cyan",.7:"lime",.8:"yellow",1:"red"},data:function(t,i){return this._data=t,this},max:function(t){return this._max=t,this},add:function(t){return this._data.push(t),this},clear:function(){return this._data=[],this},radius:function(t,i){i=i||15;var a=this._circle=document.createElement("canvas"),s=a.getContext("2d"),e=this._r=t+i;return a.width=a.height=2*e,s.shadowOffsetX=s.shadowOffsetY=200,s.shadowBlur=i,s.shadowColor="black",s.beginPath(),s.arc(e-200,e-200,t,0,2*Math.PI,!0),s.closePath(),s.fill(),this},gradient:function(t){var i=document.createElement("canvas"),a=i.getContext("2d"),s=a.createLinearGradient(0,0,0,256);i.width=1,i.height=256;for(var e in t)s.addColorStop(e,t[e]);return a.fillStyle=s,a.fillRect(0,0,1,256),this._grad=a.getImageData(0,0,1,256).data,this},draw:function(t){this._circle||this.radius(this.defaultRadius),this._grad||this.gradient(this.defaultGradient);var i=this._ctx;i.clearRect(0,0,this._width,this._height);for(var a,s=0,e=this._data.length;e>s;s++)a=this._data[s],i.globalAlpha=Math.max(a[2]/this._max,t||.05),i.drawImage(this._circle,a[0]-this._r,a[1]-this._r);var n=i.getImageData(0,0,this._width,this._height);return this._colorize(n.data,this._grad),i.putImageData(n,0,0),this},_colorize:function(t,i){for(var a,s=3,e=t.length;e>s;s+=4)a=4*t[s],a&&(t[s-3]=i[a],t[s-2]=i[a+1],t[s-1]=i[a+2])}},window.simpleheat=t}(),/*
 (c) 2014, Vladimir Agafonkin
 Leaflet.heat, a tiny and fast heatmap plugin for Leaflet.
 https://github.com/Leaflet/Leaflet.heat
*/
L.HeatLayer=(L.Layer?L.Layer:L.Class).extend({initialize:function(t,i){this._latlngs=t,L.setOptions(this,i)},setLatLngs:function(t){return this._latlngs=t,this.redraw()},addLatLng:function(t){return this._latlngs.push(t),this.redraw()},setOptions:function(t){return L.setOptions(this,t),this._heat&&this._updateOptions(),this.redraw()},redraw:function(){return!this._heat||this._frame||this._map._animating||(this._frame=L.Util.requestAnimFrame(this._redraw,this)),this},onAdd:function(t){this._map=t,this._canvas||this._initCanvas(),t._panes.overlayPane.appendChild(this._canvas),t.on("moveend",this._reset,this),t.options.zoomAnimation&&L.Browser.any3d&&t.on("zoomanim",this._animateZoom,this),this._reset()},onRemove:function(t){t.getPanes().overlayPane.removeChild(this._canvas),t.off("moveend",this._reset,this),t.options.zoomAnimation&&t.off("zoomanim",this._animateZoom,this)},addTo:function(t){return t.addLayer(this),this},_initCanvas:function(){var t=this._canvas=L.DomUtil.create("canvas","leaflet-heatmap-layer leaflet-layer"),i=L.DomUtil.testProp(["transformOrigin","WebkitTransformOrigin","msTransformOrigin"]);t.style[i]="50% 50%";var a=this._map.getSize();t.width=a.x,t.height=a.y;var s=this._map.options.zoomAnimation&&L.Browser.any3d;L.DomUtil.addClass(t,"leaflet-zoom-"+(s?"animated":"hide")),this._heat=simpleheat(t),this._updateOptions()},_updateOptions:function(){this._heat.radius(this.options.radius||this._heat.defaultRadius,this.options.blur),this.options.gradient&&this._heat.gradient(this.options.gradient),this.options.max&&this._heat.max(this.options.max)},_reset:function(){var t=this._map.containerPointToLayerPoint([0,0]);L.DomUtil.setPosition(this._canvas,t);var i=this._map.getSize();this._heat._width!==i.x&&(this._canvas.width=this._heat._width=i.x),this._heat._height!==i.y&&(this._canvas.height=this._heat._height=i.y),this._redraw()},_redraw:function(){var t,i,a,s,e,n,h,o,r,d=[],_=this._heat._r,l=this._map.getSize(),m=new L.Bounds(L.point([-_,-_]),l.add([_,_])),c=void 0===this.options.max?1:this.options.max,u=void 0===this.options.maxZoom?this._map.getMaxZoom():this.options.maxZoom,f=1/Math.pow(2,Math.max(0,Math.min(u-this._map.getZoom(),12))),g=_/2,p=[],v=this._map._getMapPanePos(),w=v.x%g,y=v.y%g;for(t=0,i=this._latlngs.length;i>t;t++)if(a=this._map.latLngToContainerPoint(this._latlngs[t]),m.contains(a)){e=Math.floor((a.x-w)/g)+2,n=Math.floor((a.y-y)/g)+2;var x=void 0!==this._latlngs[t].alt?this._latlngs[t].alt:void 0!==this._latlngs[t][2]?+this._latlngs[t][2]:1;r=x*f,p[n]=p[n]||[],s=p[n][e],s?(s[0]=(s[0]*s[2]+a.x*r)/(s[2]+r),s[1]=(s[1]*s[2]+a.y*r)/(s[2]+r),s[2]+=r):p[n][e]=[a.x,a.y,r]}for(t=0,i=p.length;i>t;t++)if(p[t])for(h=0,o=p[t].length;o>h;h++)s=p[t][h],s&&d.push([Math.round(s[0]),Math.round(s[1]),Math.min(s[2],c)]);this._heat.data(d).draw(this.options.minOpacity),this._frame=null},_animateZoom:function(t){var i=this._map.getZoomScale(t.zoom),a=this._map._getCenterOffset(t.center)._multiplyBy(-i).subtract(this._map._getMapPanePos());L.DomUtil.setTransform?L.DomUtil.setTransform(this._canvas,a,i):this._canvas.style[L.DomUtil.TRANSFORM]=L.DomUtil.getTranslateString(a)+" scale("+i+")"}}),L.heatLayer=function(t,i){return new L.HeatLayer(t,i)};
},{}],76:[function(require,module,exports){
/*
 Leaflet 1.0.3, a JS library for interactive maps. http://leafletjs.com
 (c) 2010-2016 Vladimir Agafonkin, (c) 2010-2011 CloudMade
*/
(function (window, document, undefined) {
var L = {
	version: "1.0.3"
};

function expose() {
	var oldL = window.L;

	L.noConflict = function () {
		window.L = oldL;
		return this;
	};

	window.L = L;
}

// define Leaflet for Node module pattern loaders, including Browserify
if (typeof module === 'object' && typeof module.exports === 'object') {
	module.exports = L;

// define Leaflet as an AMD module
} else if (typeof define === 'function' && define.amd) {
	define(L);
}

// define Leaflet as a global L variable, saving the original L to restore later if needed
if (typeof window !== 'undefined') {
	expose();
}



/*
 * @namespace Util
 *
 * Various utility functions, used by Leaflet internally.
 */

L.Util = {

	// @function extend(dest: Object, src?: Object): Object
	// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
	extend: function (dest) {
		var i, j, len, src;

		for (j = 1, len = arguments.length; j < len; j++) {
			src = arguments[j];
			for (i in src) {
				dest[i] = src[i];
			}
		}
		return dest;
	},

	// @function create(proto: Object, properties?: Object): Object
	// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
	create: Object.create || (function () {
		function F() {}
		return function (proto) {
			F.prototype = proto;
			return new F();
		};
	})(),

	// @function bind(fn: Function, …): Function
	// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
	// Has a `L.bind()` shortcut.
	bind: function (fn, obj) {
		var slice = Array.prototype.slice;

		if (fn.bind) {
			return fn.bind.apply(fn, slice.call(arguments, 1));
		}

		var args = slice.call(arguments, 2);

		return function () {
			return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
		};
	},

	// @function stamp(obj: Object): Number
	// Returns the unique ID of an object, assiging it one if it doesn't have it.
	stamp: function (obj) {
		/*eslint-disable */
		obj._leaflet_id = obj._leaflet_id || ++L.Util.lastId;
		return obj._leaflet_id;
		/*eslint-enable */
	},

	// @property lastId: Number
	// Last unique ID used by [`stamp()`](#util-stamp)
	lastId: 0,

	// @function throttle(fn: Function, time: Number, context: Object): Function
	// Returns a function which executes function `fn` with the given scope `context`
	// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
	// `fn` will be called no more than one time per given amount of `time`. The arguments
	// received by the bound function will be any arguments passed when binding the
	// function, followed by any arguments passed when invoking the bound function.
	// Has an `L.bind` shortcut.
	throttle: function (fn, time, context) {
		var lock, args, wrapperFn, later;

		later = function () {
			// reset lock and call if queued
			lock = false;
			if (args) {
				wrapperFn.apply(context, args);
				args = false;
			}
		};

		wrapperFn = function () {
			if (lock) {
				// called too soon, queue to call later
				args = arguments;

			} else {
				// call and lock until later
				fn.apply(context, arguments);
				setTimeout(later, time);
				lock = true;
			}
		};

		return wrapperFn;
	},

	// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
	// Returns the number `num` modulo `range` in such a way so it lies within
	// `range[0]` and `range[1]`. The returned value will be always smaller than
	// `range[1]` unless `includeMax` is set to `true`.
	wrapNum: function (x, range, includeMax) {
		var max = range[1],
		    min = range[0],
		    d = max - min;
		return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
	},

	// @function falseFn(): Function
	// Returns a function which always returns `false`.
	falseFn: function () { return false; },

	// @function formatNum(num: Number, digits?: Number): Number
	// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
	formatNum: function (num, digits) {
		var pow = Math.pow(10, digits || 5);
		return Math.round(num * pow) / pow;
	},

	// @function trim(str: String): String
	// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
	trim: function (str) {
		return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
	},

	// @function splitWords(str: String): String[]
	// Trims and splits the string on whitespace and returns the array of parts.
	splitWords: function (str) {
		return L.Util.trim(str).split(/\s+/);
	},

	// @function setOptions(obj: Object, options: Object): Object
	// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
	setOptions: function (obj, options) {
		if (!obj.hasOwnProperty('options')) {
			obj.options = obj.options ? L.Util.create(obj.options) : {};
		}
		for (var i in options) {
			obj.options[i] = options[i];
		}
		return obj.options;
	},

	// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
	// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
	// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
	// be appended at the end. If `uppercase` is `true`, the parameter names will
	// be uppercased (e.g. `'?A=foo&B=bar'`)
	getParamString: function (obj, existingUrl, uppercase) {
		var params = [];
		for (var i in obj) {
			params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
		}
		return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
	},

	// @function template(str: String, data: Object): String
	// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
	// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
	// `('Hello foo, bar')`. You can also specify functions instead of strings for
	// data values — they will be evaluated passing `data` as an argument.
	template: function (str, data) {
		return str.replace(L.Util.templateRe, function (str, key) {
			var value = data[key];

			if (value === undefined) {
				throw new Error('No value provided for variable ' + str);

			} else if (typeof value === 'function') {
				value = value(data);
			}
			return value;
		});
	},

	templateRe: /\{ *([\w_\-]+) *\}/g,

	// @function isArray(obj): Boolean
	// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
	isArray: Array.isArray || function (obj) {
		return (Object.prototype.toString.call(obj) === '[object Array]');
	},

	// @function indexOf(array: Array, el: Object): Number
	// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
	indexOf: function (array, el) {
		for (var i = 0; i < array.length; i++) {
			if (array[i] === el) { return i; }
		}
		return -1;
	},

	// @property emptyImageUrl: String
	// Data URI string containing a base64-encoded empty GIF image.
	// Used as a hack to free memory from unused images on WebKit-powered
	// mobile devices (by setting image `src` to this string).
	emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
};

(function () {
	// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/

	function getPrefixed(name) {
		return window['webkit' + name] || window['moz' + name] || window['ms' + name];
	}

	var lastTime = 0;

	// fallback for IE 7-8
	function timeoutDefer(fn) {
		var time = +new Date(),
		    timeToCall = Math.max(0, 16 - (time - lastTime));

		lastTime = time + timeToCall;
		return window.setTimeout(fn, timeToCall);
	}

	var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer,
	    cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
	               getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };


	// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
	// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
	// `context` if given. When `immediate` is set, `fn` is called immediately if
	// the browser doesn't have native support for
	// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
	// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
	L.Util.requestAnimFrame = function (fn, context, immediate) {
		if (immediate && requestFn === timeoutDefer) {
			fn.call(context);
		} else {
			return requestFn.call(window, L.bind(fn, context));
		}
	};

	// @function cancelAnimFrame(id: Number): undefined
	// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
	L.Util.cancelAnimFrame = function (id) {
		if (id) {
			cancelFn.call(window, id);
		}
	};
})();

// shortcuts for most used utility functions
L.extend = L.Util.extend;
L.bind = L.Util.bind;
L.stamp = L.Util.stamp;
L.setOptions = L.Util.setOptions;




// @class Class
// @aka L.Class

// @section
// @uninheritable

// Thanks to John Resig and Dean Edwards for inspiration!

L.Class = function () {};

L.Class.extend = function (props) {

	// @function extend(props: Object): Function
	// [Extends the current class](#class-inheritance) given the properties to be included.
	// Returns a Javascript function that is a class constructor (to be called with `new`).
	var NewClass = function () {

		// call the constructor
		if (this.initialize) {
			this.initialize.apply(this, arguments);
		}

		// call all constructor hooks
		this.callInitHooks();
	};

	var parentProto = NewClass.__super__ = this.prototype;

	var proto = L.Util.create(parentProto);
	proto.constructor = NewClass;

	NewClass.prototype = proto;

	// inherit parent's statics
	for (var i in this) {
		if (this.hasOwnProperty(i) && i !== 'prototype') {
			NewClass[i] = this[i];
		}
	}

	// mix static properties into the class
	if (props.statics) {
		L.extend(NewClass, props.statics);
		delete props.statics;
	}

	// mix includes into the prototype
	if (props.includes) {
		L.Util.extend.apply(null, [proto].concat(props.includes));
		delete props.includes;
	}

	// merge options
	if (proto.options) {
		props.options = L.Util.extend(L.Util.create(proto.options), props.options);
	}

	// mix given properties into the prototype
	L.extend(proto, props);

	proto._initHooks = [];

	// add method for calling all hooks
	proto.callInitHooks = function () {

		if (this._initHooksCalled) { return; }

		if (parentProto.callInitHooks) {
			parentProto.callInitHooks.call(this);
		}

		this._initHooksCalled = true;

		for (var i = 0, len = proto._initHooks.length; i < len; i++) {
			proto._initHooks[i].call(this);
		}
	};

	return NewClass;
};


// @function include(properties: Object): this
// [Includes a mixin](#class-includes) into the current class.
L.Class.include = function (props) {
	L.extend(this.prototype, props);
	return this;
};

// @function mergeOptions(options: Object): this
// [Merges `options`](#class-options) into the defaults of the class.
L.Class.mergeOptions = function (options) {
	L.extend(this.prototype.options, options);
	return this;
};

// @function addInitHook(fn: Function): this
// Adds a [constructor hook](#class-constructor-hooks) to the class.
L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
	var args = Array.prototype.slice.call(arguments, 1);

	var init = typeof fn === 'function' ? fn : function () {
		this[fn].apply(this, args);
	};

	this.prototype._initHooks = this.prototype._initHooks || [];
	this.prototype._initHooks.push(init);
	return this;
};



/*
 * @class Evented
 * @aka L.Evented
 * @inherits Class
 *
 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
 *
 * @example
 *
 * ```js
 * map.on('click', function(e) {
 * 	alert(e.latlng);
 * } );
 * ```
 *
 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
 *
 * ```js
 * function onClick(e) { ... }
 *
 * map.on('click', onClick);
 * map.off('click', onClick);
 * ```
 */


L.Evented = L.Class.extend({

	/* @method on(type: String, fn: Function, context?: Object): this
	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
	 *
	 * @alternative
	 * @method on(eventMap: Object): this
	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	 */
	on: function (types, fn, context) {

		// types can be a map of types/handlers
		if (typeof types === 'object') {
			for (var type in types) {
				// we don't process space-separated events here for performance;
				// it's a hot path since Layer uses the on(obj) syntax
				this._on(type, types[type], fn);
			}

		} else {
			// types can be a string of space-separated words
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._on(types[i], fn, context);
			}
		}

		return this;
	},

	/* @method off(type: String, fn?: Function, context?: Object): this
	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
	 *
	 * @alternative
	 * @method off(eventMap: Object): this
	 * Removes a set of type/listener pairs.
	 *
	 * @alternative
	 * @method off: this
	 * Removes all listeners to all events on the object.
	 */
	off: function (types, fn, context) {

		if (!types) {
			// clear all listeners if called without arguments
			delete this._events;

		} else if (typeof types === 'object') {
			for (var type in types) {
				this._off(type, types[type], fn);
			}

		} else {
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._off(types[i], fn, context);
			}
		}

		return this;
	},

	// attach listener (without syntactic sugar now)
	_on: function (type, fn, context) {
		this._events = this._events || {};

		/* get/init listeners for type */
		var typeListeners = this._events[type];
		if (!typeListeners) {
			typeListeners = [];
			this._events[type] = typeListeners;
		}

		if (context === this) {
			// Less memory footprint.
			context = undefined;
		}
		var newListener = {fn: fn, ctx: context},
		    listeners = typeListeners;

		// check if fn already there
		for (var i = 0, len = listeners.length; i < len; i++) {
			if (listeners[i].fn === fn && listeners[i].ctx === context) {
				return;
			}
		}

		listeners.push(newListener);
	},

	_off: function (type, fn, context) {
		var listeners,
		    i,
		    len;

		if (!this._events) { return; }

		listeners = this._events[type];

		if (!listeners) {
			return;
		}

		if (!fn) {
			// Set all removed listeners to noop so they are not called if remove happens in fire
			for (i = 0, len = listeners.length; i < len; i++) {
				listeners[i].fn = L.Util.falseFn;
			}
			// clear all listeners for a type if function isn't specified
			delete this._events[type];
			return;
		}

		if (context === this) {
			context = undefined;
		}

		if (listeners) {

			// find fn and remove it
			for (i = 0, len = listeners.length; i < len; i++) {
				var l = listeners[i];
				if (l.ctx !== context) { continue; }
				if (l.fn === fn) {

					// set the removed listener to noop so that's not called if remove happens in fire
					l.fn = L.Util.falseFn;

					if (this._firingCount) {
						/* copy array in case events are being fired */
						this._events[type] = listeners = listeners.slice();
					}
					listeners.splice(i, 1);

					return;
				}
			}
		}
	},

	// @method fire(type: String, data?: Object, propagate?: Boolean): this
	// Fires an event of the specified type. You can optionally provide an data
	// object — the first argument of the listener function will contain its
	// properties. The event can optionally be propagated to event parents.
	fire: function (type, data, propagate) {
		if (!this.listens(type, propagate)) { return this; }

		var event = L.Util.extend({}, data, {type: type, target: this});

		if (this._events) {
			var listeners = this._events[type];

			if (listeners) {
				this._firingCount = (this._firingCount + 1) || 1;
				for (var i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					l.fn.call(l.ctx || this, event);
				}

				this._firingCount--;
			}
		}

		if (propagate) {
			// propagate the event to parents (set with addEventParent)
			this._propagateEvent(event);
		}

		return this;
	},

	// @method listens(type: String): Boolean
	// Returns `true` if a particular event type has any listeners attached to it.
	listens: function (type, propagate) {
		var listeners = this._events && this._events[type];
		if (listeners && listeners.length) { return true; }

		if (propagate) {
			// also check parents for listeners if event propagates
			for (var id in this._eventParents) {
				if (this._eventParents[id].listens(type, propagate)) { return true; }
			}
		}
		return false;
	},

	// @method once(…): this
	// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
	once: function (types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this.once(type, types[type], fn);
			}
			return this;
		}

		var handler = L.bind(function () {
			this
			    .off(types, fn, context)
			    .off(types, handler, context);
		}, this);

		// add a listener that's executed once and removed after that
		return this
		    .on(types, fn, context)
		    .on(types, handler, context);
	},

	// @method addEventParent(obj: Evented): this
	// Adds an event parent - an `Evented` that will receive propagated events
	addEventParent: function (obj) {
		this._eventParents = this._eventParents || {};
		this._eventParents[L.stamp(obj)] = obj;
		return this;
	},

	// @method removeEventParent(obj: Evented): this
	// Removes an event parent, so it will stop receiving propagated events
	removeEventParent: function (obj) {
		if (this._eventParents) {
			delete this._eventParents[L.stamp(obj)];
		}
		return this;
	},

	_propagateEvent: function (e) {
		for (var id in this._eventParents) {
			this._eventParents[id].fire(e.type, L.extend({layer: e.target}, e), true);
		}
	}
});

var proto = L.Evented.prototype;

// aliases; we should ditch those eventually

// @method addEventListener(…): this
// Alias to [`on(…)`](#evented-on)
proto.addEventListener = proto.on;

// @method removeEventListener(…): this
// Alias to [`off(…)`](#evented-off)

// @method clearAllEventListeners(…): this
// Alias to [`off()`](#evented-off)
proto.removeEventListener = proto.clearAllEventListeners = proto.off;

// @method addOneTimeEventListener(…): this
// Alias to [`once(…)`](#evented-once)
proto.addOneTimeEventListener = proto.once;

// @method fireEvent(…): this
// Alias to [`fire(…)`](#evented-fire)
proto.fireEvent = proto.fire;

// @method hasEventListeners(…): Boolean
// Alias to [`listens(…)`](#evented-listens)
proto.hasEventListeners = proto.listens;

L.Mixin = {Events: proto};



/*
 * @namespace Browser
 * @aka L.Browser
 *
 * A namespace with static properties for browser/feature detection used by Leaflet internally.
 *
 * @example
 *
 * ```js
 * if (L.Browser.ielt9) {
 *   alert('Upgrade your browser, dude!');
 * }
 * ```
 */

(function () {

	var ua = navigator.userAgent.toLowerCase(),
	    doc = document.documentElement,

	    ie = 'ActiveXObject' in window,

	    webkit    = ua.indexOf('webkit') !== -1,
	    phantomjs = ua.indexOf('phantom') !== -1,
	    android23 = ua.search('android [23]') !== -1,
	    chrome    = ua.indexOf('chrome') !== -1,
	    gecko     = ua.indexOf('gecko') !== -1  && !webkit && !window.opera && !ie,

	    win = navigator.platform.indexOf('Win') === 0,

	    mobile = typeof orientation !== 'undefined' || ua.indexOf('mobile') !== -1,
	    msPointer = !window.PointerEvent && window.MSPointerEvent,
	    pointer = window.PointerEvent || msPointer,

	    ie3d = ie && ('transition' in doc.style),
	    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
	    gecko3d = 'MozPerspective' in doc.style,
	    opera12 = 'OTransition' in doc.style;


	var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
			(window.DocumentTouch && document instanceof window.DocumentTouch));

	L.Browser = {

		// @property ie: Boolean
		// `true` for all Internet Explorer versions (not Edge).
		ie: ie,

		// @property ielt9: Boolean
		// `true` for Internet Explorer versions less than 9.
		ielt9: ie && !document.addEventListener,

		// @property edge: Boolean
		// `true` for the Edge web browser.
		edge: 'msLaunchUri' in navigator && !('documentMode' in document),

		// @property webkit: Boolean
		// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
		webkit: webkit,

		// @property gecko: Boolean
		// `true` for gecko-based browsers like Firefox.
		gecko: gecko,

		// @property android: Boolean
		// `true` for any browser running on an Android platform.
		android: ua.indexOf('android') !== -1,

		// @property android23: Boolean
		// `true` for browsers running on Android 2 or Android 3.
		android23: android23,

		// @property chrome: Boolean
		// `true` for the Chrome browser.
		chrome: chrome,

		// @property safari: Boolean
		// `true` for the Safari browser.
		safari: !chrome && ua.indexOf('safari') !== -1,


		// @property win: Boolean
		// `true` when the browser is running in a Windows platform
		win: win,


		// @property ie3d: Boolean
		// `true` for all Internet Explorer versions supporting CSS transforms.
		ie3d: ie3d,

		// @property webkit3d: Boolean
		// `true` for webkit-based browsers supporting CSS transforms.
		webkit3d: webkit3d,

		// @property gecko3d: Boolean
		// `true` for gecko-based browsers supporting CSS transforms.
		gecko3d: gecko3d,

		// @property opera12: Boolean
		// `true` for the Opera browser supporting CSS transforms (version 12 or later).
		opera12: opera12,

		// @property any3d: Boolean
		// `true` for all browsers supporting CSS transforms.
		any3d: !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantomjs,


		// @property mobile: Boolean
		// `true` for all browsers running in a mobile device.
		mobile: mobile,

		// @property mobileWebkit: Boolean
		// `true` for all webkit-based browsers in a mobile device.
		mobileWebkit: mobile && webkit,

		// @property mobileWebkit3d: Boolean
		// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
		mobileWebkit3d: mobile && webkit3d,

		// @property mobileOpera: Boolean
		// `true` for the Opera browser in a mobile device.
		mobileOpera: mobile && window.opera,

		// @property mobileGecko: Boolean
		// `true` for gecko-based browsers running in a mobile device.
		mobileGecko: mobile && gecko,


		// @property touch: Boolean
		// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
		// This does not necessarily mean that the browser is running in a computer with
		// a touchscreen, it only means that the browser is capable of understanding
		// touch events.
		touch: !!touch,

		// @property msPointer: Boolean
		// `true` for browsers implementing the Microsoft touch events model (notably IE10).
		msPointer: !!msPointer,

		// @property pointer: Boolean
		// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
		pointer: !!pointer,


		// @property retina: Boolean
		// `true` for browsers on a high-resolution "retina" screen.
		retina: (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1
	};

}());



/*
 * @class Point
 * @aka L.Point
 *
 * Represents a point with `x` and `y` coordinates in pixels.
 *
 * @example
 *
 * ```js
 * var point = L.point(200, 300);
 * ```
 *
 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
 *
 * ```js
 * map.panBy([200, 300]);
 * map.panBy(L.point(200, 300));
 * ```
 */

L.Point = function (x, y, round) {
	// @property x: Number; The `x` coordinate of the point
	this.x = (round ? Math.round(x) : x);
	// @property y: Number; The `y` coordinate of the point
	this.y = (round ? Math.round(y) : y);
};

L.Point.prototype = {

	// @method clone(): Point
	// Returns a copy of the current point.
	clone: function () {
		return new L.Point(this.x, this.y);
	},

	// @method add(otherPoint: Point): Point
	// Returns the result of addition of the current and the given points.
	add: function (point) {
		// non-destructive, returns a new point
		return this.clone()._add(L.point(point));
	},

	_add: function (point) {
		// destructive, used directly for performance in situations where it's safe to modify existing point
		this.x += point.x;
		this.y += point.y;
		return this;
	},

	// @method subtract(otherPoint: Point): Point
	// Returns the result of subtraction of the given point from the current.
	subtract: function (point) {
		return this.clone()._subtract(L.point(point));
	},

	_subtract: function (point) {
		this.x -= point.x;
		this.y -= point.y;
		return this;
	},

	// @method divideBy(num: Number): Point
	// Returns the result of division of the current point by the given number.
	divideBy: function (num) {
		return this.clone()._divideBy(num);
	},

	_divideBy: function (num) {
		this.x /= num;
		this.y /= num;
		return this;
	},

	// @method multiplyBy(num: Number): Point
	// Returns the result of multiplication of the current point by the given number.
	multiplyBy: function (num) {
		return this.clone()._multiplyBy(num);
	},

	_multiplyBy: function (num) {
		this.x *= num;
		this.y *= num;
		return this;
	},

	// @method scaleBy(scale: Point): Point
	// Multiply each coordinate of the current point by each coordinate of
	// `scale`. In linear algebra terms, multiply the point by the
	// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
	// defined by `scale`.
	scaleBy: function (point) {
		return new L.Point(this.x * point.x, this.y * point.y);
	},

	// @method unscaleBy(scale: Point): Point
	// Inverse of `scaleBy`. Divide each coordinate of the current point by
	// each coordinate of `scale`.
	unscaleBy: function (point) {
		return new L.Point(this.x / point.x, this.y / point.y);
	},

	// @method round(): Point
	// Returns a copy of the current point with rounded coordinates.
	round: function () {
		return this.clone()._round();
	},

	_round: function () {
		this.x = Math.round(this.x);
		this.y = Math.round(this.y);
		return this;
	},

	// @method floor(): Point
	// Returns a copy of the current point with floored coordinates (rounded down).
	floor: function () {
		return this.clone()._floor();
	},

	_floor: function () {
		this.x = Math.floor(this.x);
		this.y = Math.floor(this.y);
		return this;
	},

	// @method ceil(): Point
	// Returns a copy of the current point with ceiled coordinates (rounded up).
	ceil: function () {
		return this.clone()._ceil();
	},

	_ceil: function () {
		this.x = Math.ceil(this.x);
		this.y = Math.ceil(this.y);
		return this;
	},

	// @method distanceTo(otherPoint: Point): Number
	// Returns the cartesian distance between the current and the given points.
	distanceTo: function (point) {
		point = L.point(point);

		var x = point.x - this.x,
		    y = point.y - this.y;

		return Math.sqrt(x * x + y * y);
	},

	// @method equals(otherPoint: Point): Boolean
	// Returns `true` if the given point has the same coordinates.
	equals: function (point) {
		point = L.point(point);

		return point.x === this.x &&
		       point.y === this.y;
	},

	// @method contains(otherPoint: Point): Boolean
	// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
	contains: function (point) {
		point = L.point(point);

		return Math.abs(point.x) <= Math.abs(this.x) &&
		       Math.abs(point.y) <= Math.abs(this.y);
	},

	// @method toString(): String
	// Returns a string representation of the point for debugging purposes.
	toString: function () {
		return 'Point(' +
		        L.Util.formatNum(this.x) + ', ' +
		        L.Util.formatNum(this.y) + ')';
	}
};

// @factory L.point(x: Number, y: Number, round?: Boolean)
// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.

// @alternative
// @factory L.point(coords: Number[])
// Expects an array of the form `[x, y]` instead.

// @alternative
// @factory L.point(coords: Object)
// Expects a plain object of the form `{x: Number, y: Number}` instead.
L.point = function (x, y, round) {
	if (x instanceof L.Point) {
		return x;
	}
	if (L.Util.isArray(x)) {
		return new L.Point(x[0], x[1]);
	}
	if (x === undefined || x === null) {
		return x;
	}
	if (typeof x === 'object' && 'x' in x && 'y' in x) {
		return new L.Point(x.x, x.y);
	}
	return new L.Point(x, y, round);
};



/*
 * @class Bounds
 * @aka L.Bounds
 *
 * Represents a rectangular area in pixel coordinates.
 *
 * @example
 *
 * ```js
 * var p1 = L.point(10, 10),
 * p2 = L.point(40, 60),
 * bounds = L.bounds(p1, p2);
 * ```
 *
 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * otherBounds.intersects([[10, 10], [40, 60]]);
 * ```
 */

L.Bounds = function (a, b) {
	if (!a) { return; }

	var points = b ? [a, b] : a;

	for (var i = 0, len = points.length; i < len; i++) {
		this.extend(points[i]);
	}
};

L.Bounds.prototype = {
	// @method extend(point: Point): this
	// Extends the bounds to contain the given point.
	extend: function (point) { // (Point)
		point = L.point(point);

		// @property min: Point
		// The top left corner of the rectangle.
		// @property max: Point
		// The bottom right corner of the rectangle.
		if (!this.min && !this.max) {
			this.min = point.clone();
			this.max = point.clone();
		} else {
			this.min.x = Math.min(point.x, this.min.x);
			this.max.x = Math.max(point.x, this.max.x);
			this.min.y = Math.min(point.y, this.min.y);
			this.max.y = Math.max(point.y, this.max.y);
		}
		return this;
	},

	// @method getCenter(round?: Boolean): Point
	// Returns the center point of the bounds.
	getCenter: function (round) {
		return new L.Point(
		        (this.min.x + this.max.x) / 2,
		        (this.min.y + this.max.y) / 2, round);
	},

	// @method getBottomLeft(): Point
	// Returns the bottom-left point of the bounds.
	getBottomLeft: function () {
		return new L.Point(this.min.x, this.max.y);
	},

	// @method getTopRight(): Point
	// Returns the top-right point of the bounds.
	getTopRight: function () { // -> Point
		return new L.Point(this.max.x, this.min.y);
	},

	// @method getSize(): Point
	// Returns the size of the given bounds
	getSize: function () {
		return this.max.subtract(this.min);
	},

	// @method contains(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle contains the given one.
	// @alternative
	// @method contains(point: Point): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) {
		var min, max;

		if (typeof obj[0] === 'number' || obj instanceof L.Point) {
			obj = L.point(obj);
		} else {
			obj = L.bounds(obj);
		}

		if (obj instanceof L.Bounds) {
			min = obj.min;
			max = obj.max;
		} else {
			min = max = obj;
		}

		return (min.x >= this.min.x) &&
		       (max.x <= this.max.x) &&
		       (min.y >= this.min.y) &&
		       (max.y <= this.max.y);
	},

	// @method intersects(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds
	// intersect if they have at least one point in common.
	intersects: function (bounds) { // (Bounds) -> Boolean
		bounds = L.bounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
		    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);

		return xIntersects && yIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds
	// overlap if their intersection is an area.
	overlaps: function (bounds) { // (Bounds) -> Boolean
		bounds = L.bounds(bounds);

		var min = this.min,
		    max = this.max,
		    min2 = bounds.min,
		    max2 = bounds.max,
		    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
		    yOverlaps = (max2.y > min.y) && (min2.y < max.y);

		return xOverlaps && yOverlaps;
	},

	isValid: function () {
		return !!(this.min && this.max);
	}
};


// @factory L.bounds(topLeft: Point, bottomRight: Point)
// Creates a Bounds object from two coordinates (usually top-left and bottom-right corners).
// @alternative
// @factory L.bounds(points: Point[])
// Creates a Bounds object from the points it contains
L.bounds = function (a, b) {
	if (!a || a instanceof L.Bounds) {
		return a;
	}
	return new L.Bounds(a, b);
};



/*
 * @class Transformation
 * @aka L.Transformation
 *
 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
 * the reverse. Used by Leaflet in its projections code.
 *
 * @example
 *
 * ```js
 * var transformation = new L.Transformation(2, 5, -1, 10),
 * 	p = L.point(1, 2),
 * 	p2 = transformation.transform(p), //  L.point(7, 8)
 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
 * ```
 */


// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
// Creates a `Transformation` object with the given coefficients.
L.Transformation = function (a, b, c, d) {
	this._a = a;
	this._b = b;
	this._c = c;
	this._d = d;
};

L.Transformation.prototype = {
	// @method transform(point: Point, scale?: Number): Point
	// Returns a transformed point, optionally multiplied by the given scale.
	// Only accepts actual `L.Point` instances, not arrays.
	transform: function (point, scale) { // (Point, Number) -> Point
		return this._transform(point.clone(), scale);
	},

	// destructive transform (faster)
	_transform: function (point, scale) {
		scale = scale || 1;
		point.x = scale * (this._a * point.x + this._b);
		point.y = scale * (this._c * point.y + this._d);
		return point;
	},

	// @method untransform(point: Point, scale?: Number): Point
	// Returns the reverse transformation of the given point, optionally divided
	// by the given scale. Only accepts actual `L.Point` instances, not arrays.
	untransform: function (point, scale) {
		scale = scale || 1;
		return new L.Point(
		        (point.x / scale - this._b) / this._a,
		        (point.y / scale - this._d) / this._c);
	}
};



/*
 * @namespace DomUtil
 *
 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
 * tree, used by Leaflet internally.
 *
 * Most functions expecting or returning a `HTMLElement` also work for
 * SVG elements. The only difference is that classes refer to CSS classes
 * in HTML and SVG classes in SVG.
 */

L.DomUtil = {

	// @function get(id: String|HTMLElement): HTMLElement
	// Returns an element given its DOM id, or returns the element itself
	// if it was passed directly.
	get: function (id) {
		return typeof id === 'string' ? document.getElementById(id) : id;
	},

	// @function getStyle(el: HTMLElement, styleAttrib: String): String
	// Returns the value for a certain style attribute on an element,
	// including computed values or values set through CSS.
	getStyle: function (el, style) {

		var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);

		if ((!value || value === 'auto') && document.defaultView) {
			var css = document.defaultView.getComputedStyle(el, null);
			value = css ? css[style] : null;
		}

		return value === 'auto' ? null : value;
	},

	// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
	// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
	create: function (tagName, className, container) {

		var el = document.createElement(tagName);
		el.className = className || '';

		if (container) {
			container.appendChild(el);
		}

		return el;
	},

	// @function remove(el: HTMLElement)
	// Removes `el` from its parent element
	remove: function (el) {
		var parent = el.parentNode;
		if (parent) {
			parent.removeChild(el);
		}
	},

	// @function empty(el: HTMLElement)
	// Removes all of `el`'s children elements from `el`
	empty: function (el) {
		while (el.firstChild) {
			el.removeChild(el.firstChild);
		}
	},

	// @function toFront(el: HTMLElement)
	// Makes `el` the last children of its parent, so it renders in front of the other children.
	toFront: function (el) {
		el.parentNode.appendChild(el);
	},

	// @function toBack(el: HTMLElement)
	// Makes `el` the first children of its parent, so it renders back from the other children.
	toBack: function (el) {
		var parent = el.parentNode;
		parent.insertBefore(el, parent.firstChild);
	},

	// @function hasClass(el: HTMLElement, name: String): Boolean
	// Returns `true` if the element's class attribute contains `name`.
	hasClass: function (el, name) {
		if (el.classList !== undefined) {
			return el.classList.contains(name);
		}
		var className = L.DomUtil.getClass(el);
		return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
	},

	// @function addClass(el: HTMLElement, name: String)
	// Adds `name` to the element's class attribute.
	addClass: function (el, name) {
		if (el.classList !== undefined) {
			var classes = L.Util.splitWords(name);
			for (var i = 0, len = classes.length; i < len; i++) {
				el.classList.add(classes[i]);
			}
		} else if (!L.DomUtil.hasClass(el, name)) {
			var className = L.DomUtil.getClass(el);
			L.DomUtil.setClass(el, (className ? className + ' ' : '') + name);
		}
	},

	// @function removeClass(el: HTMLElement, name: String)
	// Removes `name` from the element's class attribute.
	removeClass: function (el, name) {
		if (el.classList !== undefined) {
			el.classList.remove(name);
		} else {
			L.DomUtil.setClass(el, L.Util.trim((' ' + L.DomUtil.getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
		}
	},

	// @function setClass(el: HTMLElement, name: String)
	// Sets the element's class.
	setClass: function (el, name) {
		if (el.className.baseVal === undefined) {
			el.className = name;
		} else {
			// in case of SVG element
			el.className.baseVal = name;
		}
	},

	// @function getClass(el: HTMLElement): String
	// Returns the element's class.
	getClass: function (el) {
		return el.className.baseVal === undefined ? el.className : el.className.baseVal;
	},

	// @function setOpacity(el: HTMLElement, opacity: Number)
	// Set the opacity of an element (including old IE support).
	// `opacity` must be a number from `0` to `1`.
	setOpacity: function (el, value) {

		if ('opacity' in el.style) {
			el.style.opacity = value;

		} else if ('filter' in el.style) {
			L.DomUtil._setOpacityIE(el, value);
		}
	},

	_setOpacityIE: function (el, value) {
		var filter = false,
		    filterName = 'DXImageTransform.Microsoft.Alpha';

		// filters collection throws an error if we try to retrieve a filter that doesn't exist
		try {
			filter = el.filters.item(filterName);
		} catch (e) {
			// don't set opacity to 1 if we haven't already set an opacity,
			// it isn't needed and breaks transparent pngs.
			if (value === 1) { return; }
		}

		value = Math.round(value * 100);

		if (filter) {
			filter.Enabled = (value !== 100);
			filter.Opacity = value;
		} else {
			el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
		}
	},

	// @function testProp(props: String[]): String|false
	// Goes through the array of style names and returns the first name
	// that is a valid style name for an element. If no such name is found,
	// it returns false. Useful for vendor-prefixed styles like `transform`.
	testProp: function (props) {

		var style = document.documentElement.style;

		for (var i = 0; i < props.length; i++) {
			if (props[i] in style) {
				return props[i];
			}
		}
		return false;
	},

	// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
	// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
	// and optionally scaled by `scale`. Does not have an effect if the
	// browser doesn't support 3D CSS transforms.
	setTransform: function (el, offset, scale) {
		var pos = offset || new L.Point(0, 0);

		el.style[L.DomUtil.TRANSFORM] =
			(L.Browser.ie3d ?
				'translate(' + pos.x + 'px,' + pos.y + 'px)' :
				'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
			(scale ? ' scale(' + scale + ')' : '');
	},

	// @function setPosition(el: HTMLElement, position: Point)
	// Sets the position of `el` to coordinates specified by `position`,
	// using CSS translate or top/left positioning depending on the browser
	// (used by Leaflet internally to position its layers).
	setPosition: function (el, point) { // (HTMLElement, Point[, Boolean])

		/*eslint-disable */
		el._leaflet_pos = point;
		/*eslint-enable */

		if (L.Browser.any3d) {
			L.DomUtil.setTransform(el, point);
		} else {
			el.style.left = point.x + 'px';
			el.style.top = point.y + 'px';
		}
	},

	// @function getPosition(el: HTMLElement): Point
	// Returns the coordinates of an element previously positioned with setPosition.
	getPosition: function (el) {
		// this method is only used for elements previously positioned using setPosition,
		// so it's safe to cache the position for performance

		return el._leaflet_pos || new L.Point(0, 0);
	}
};


(function () {
	// prefix style property names

	// @property TRANSFORM: String
	// Vendor-prefixed fransform style name (e.g. `'webkitTransform'` for WebKit).
	L.DomUtil.TRANSFORM = L.DomUtil.testProp(
			['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);


	// webkitTransition comes first because some browser versions that drop vendor prefix don't do
	// the same for the transitionend event, in particular the Android 4.1 stock browser

	// @property TRANSITION: String
	// Vendor-prefixed transform style name.
	var transition = L.DomUtil.TRANSITION = L.DomUtil.testProp(
			['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);

	L.DomUtil.TRANSITION_END =
			transition === 'webkitTransition' || transition === 'OTransition' ? transition + 'End' : 'transitionend';

	// @function disableTextSelection()
	// Prevents the user from generating `selectstart` DOM events, usually generated
	// when the user drags the mouse through a page with text. Used internally
	// by Leaflet to override the behaviour of any click-and-drag interaction on
	// the map. Affects drag interactions on the whole document.

	// @function enableTextSelection()
	// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
	if ('onselectstart' in document) {
		L.DomUtil.disableTextSelection = function () {
			L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
		};
		L.DomUtil.enableTextSelection = function () {
			L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
		};

	} else {
		var userSelectProperty = L.DomUtil.testProp(
			['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);

		L.DomUtil.disableTextSelection = function () {
			if (userSelectProperty) {
				var style = document.documentElement.style;
				this._userSelect = style[userSelectProperty];
				style[userSelectProperty] = 'none';
			}
		};
		L.DomUtil.enableTextSelection = function () {
			if (userSelectProperty) {
				document.documentElement.style[userSelectProperty] = this._userSelect;
				delete this._userSelect;
			}
		};
	}

	// @function disableImageDrag()
	// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
	// for `dragstart` DOM events, usually generated when the user drags an image.
	L.DomUtil.disableImageDrag = function () {
		L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
	};

	// @function enableImageDrag()
	// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
	L.DomUtil.enableImageDrag = function () {
		L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
	};

	// @function preventOutline(el: HTMLElement)
	// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
	// of the element `el` invisible. Used internally by Leaflet to prevent
	// focusable elements from displaying an outline when the user performs a
	// drag interaction on them.
	L.DomUtil.preventOutline = function (element) {
		while (element.tabIndex === -1) {
			element = element.parentNode;
		}
		if (!element || !element.style) { return; }
		L.DomUtil.restoreOutline();
		this._outlineElement = element;
		this._outlineStyle = element.style.outline;
		element.style.outline = 'none';
		L.DomEvent.on(window, 'keydown', L.DomUtil.restoreOutline, this);
	};

	// @function restoreOutline()
	// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
	L.DomUtil.restoreOutline = function () {
		if (!this._outlineElement) { return; }
		this._outlineElement.style.outline = this._outlineStyle;
		delete this._outlineElement;
		delete this._outlineStyle;
		L.DomEvent.off(window, 'keydown', L.DomUtil.restoreOutline, this);
	};
})();



/* @class LatLng
 * @aka L.LatLng
 *
 * Represents a geographical point with a certain latitude and longitude.
 *
 * @example
 *
 * ```
 * var latlng = L.latLng(50.5, 30.5);
 * ```
 *
 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
 *
 * ```
 * map.panTo([50, 30]);
 * map.panTo({lon: 30, lat: 50});
 * map.panTo({lat: 50, lng: 30});
 * map.panTo(L.latLng(50, 30));
 * ```
 */

L.LatLng = function (lat, lng, alt) {
	if (isNaN(lat) || isNaN(lng)) {
		throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
	}

	// @property lat: Number
	// Latitude in degrees
	this.lat = +lat;

	// @property lng: Number
	// Longitude in degrees
	this.lng = +lng;

	// @property alt: Number
	// Altitude in meters (optional)
	if (alt !== undefined) {
		this.alt = +alt;
	}
};

L.LatLng.prototype = {
	// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
	// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
	equals: function (obj, maxMargin) {
		if (!obj) { return false; }

		obj = L.latLng(obj);

		var margin = Math.max(
		        Math.abs(this.lat - obj.lat),
		        Math.abs(this.lng - obj.lng));

		return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
	},

	// @method toString(): String
	// Returns a string representation of the point (for debugging purposes).
	toString: function (precision) {
		return 'LatLng(' +
		        L.Util.formatNum(this.lat, precision) + ', ' +
		        L.Util.formatNum(this.lng, precision) + ')';
	},

	// @method distanceTo(otherLatLng: LatLng): Number
	// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
	distanceTo: function (other) {
		return L.CRS.Earth.distance(this, L.latLng(other));
	},

	// @method wrap(): LatLng
	// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
	wrap: function () {
		return L.CRS.Earth.wrapLatLng(this);
	},

	// @method toBounds(sizeInMeters: Number): LatLngBounds
	// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
	toBounds: function (sizeInMeters) {
		var latAccuracy = 180 * sizeInMeters / 40075017,
		    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);

		return L.latLngBounds(
		        [this.lat - latAccuracy, this.lng - lngAccuracy],
		        [this.lat + latAccuracy, this.lng + lngAccuracy]);
	},

	clone: function () {
		return new L.LatLng(this.lat, this.lng, this.alt);
	}
};



// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).

// @alternative
// @factory L.latLng(coords: Array): LatLng
// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.

// @alternative
// @factory L.latLng(coords: Object): LatLng
// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.

L.latLng = function (a, b, c) {
	if (a instanceof L.LatLng) {
		return a;
	}
	if (L.Util.isArray(a) && typeof a[0] !== 'object') {
		if (a.length === 3) {
			return new L.LatLng(a[0], a[1], a[2]);
		}
		if (a.length === 2) {
			return new L.LatLng(a[0], a[1]);
		}
		return null;
	}
	if (a === undefined || a === null) {
		return a;
	}
	if (typeof a === 'object' && 'lat' in a) {
		return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
	}
	if (b === undefined) {
		return null;
	}
	return new L.LatLng(a, b, c);
};



/*
 * @class LatLngBounds
 * @aka L.LatLngBounds
 *
 * Represents a rectangular geographical area on a map.
 *
 * @example
 *
 * ```js
 * var corner1 = L.latLng(40.712, -74.227),
 * corner2 = L.latLng(40.774, -74.125),
 * bounds = L.latLngBounds(corner1, corner2);
 * ```
 *
 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
 *
 * ```js
 * map.fitBounds([
 * 	[40.712, -74.227],
 * 	[40.774, -74.125]
 * ]);
 * ```
 *
 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
 */

L.LatLngBounds = function (corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
	if (!corner1) { return; }

	var latlngs = corner2 ? [corner1, corner2] : corner1;

	for (var i = 0, len = latlngs.length; i < len; i++) {
		this.extend(latlngs[i]);
	}
};

L.LatLngBounds.prototype = {

	// @method extend(latlng: LatLng): this
	// Extend the bounds to contain the given point

	// @alternative
	// @method extend(otherBounds: LatLngBounds): this
	// Extend the bounds to contain the given bounds
	extend: function (obj) {
		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof L.LatLng) {
			sw2 = obj;
			ne2 = obj;

		} else if (obj instanceof L.LatLngBounds) {
			sw2 = obj._southWest;
			ne2 = obj._northEast;

			if (!sw2 || !ne2) { return this; }

		} else {
			return obj ? this.extend(L.latLng(obj) || L.latLngBounds(obj)) : this;
		}

		if (!sw && !ne) {
			this._southWest = new L.LatLng(sw2.lat, sw2.lng);
			this._northEast = new L.LatLng(ne2.lat, ne2.lng);
		} else {
			sw.lat = Math.min(sw2.lat, sw.lat);
			sw.lng = Math.min(sw2.lng, sw.lng);
			ne.lat = Math.max(ne2.lat, ne.lat);
			ne.lng = Math.max(ne2.lng, ne.lng);
		}

		return this;
	},

	// @method pad(bufferRatio: Number): LatLngBounds
	// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
	pad: function (bufferRatio) {
		var sw = this._southWest,
		    ne = this._northEast,
		    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
		    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;

		return new L.LatLngBounds(
		        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
		        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
	},

	// @method getCenter(): LatLng
	// Returns the center point of the bounds.
	getCenter: function () {
		return new L.LatLng(
		        (this._southWest.lat + this._northEast.lat) / 2,
		        (this._southWest.lng + this._northEast.lng) / 2);
	},

	// @method getSouthWest(): LatLng
	// Returns the south-west point of the bounds.
	getSouthWest: function () {
		return this._southWest;
	},

	// @method getNorthEast(): LatLng
	// Returns the north-east point of the bounds.
	getNorthEast: function () {
		return this._northEast;
	},

	// @method getNorthWest(): LatLng
	// Returns the north-west point of the bounds.
	getNorthWest: function () {
		return new L.LatLng(this.getNorth(), this.getWest());
	},

	// @method getSouthEast(): LatLng
	// Returns the south-east point of the bounds.
	getSouthEast: function () {
		return new L.LatLng(this.getSouth(), this.getEast());
	},

	// @method getWest(): Number
	// Returns the west longitude of the bounds
	getWest: function () {
		return this._southWest.lng;
	},

	// @method getSouth(): Number
	// Returns the south latitude of the bounds
	getSouth: function () {
		return this._southWest.lat;
	},

	// @method getEast(): Number
	// Returns the east longitude of the bounds
	getEast: function () {
		return this._northEast.lng;
	},

	// @method getNorth(): Number
	// Returns the north latitude of the bounds
	getNorth: function () {
		return this._northEast.lat;
	},

	// @method contains(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle contains the given one.

	// @alternative
	// @method contains (latlng: LatLng): Boolean
	// Returns `true` if the rectangle contains the given point.
	contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
		if (typeof obj[0] === 'number' || obj instanceof L.LatLng || 'lat' in obj) {
			obj = L.latLng(obj);
		} else {
			obj = L.latLngBounds(obj);
		}

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2, ne2;

		if (obj instanceof L.LatLngBounds) {
			sw2 = obj.getSouthWest();
			ne2 = obj.getNorthEast();
		} else {
			sw2 = ne2 = obj;
		}

		return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
		       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
	},

	// @method intersects(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
	intersects: function (bounds) {
		bounds = L.latLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
		    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);

		return latIntersects && lngIntersects;
	},

	// @method overlaps(otherBounds: Bounds): Boolean
	// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
	overlaps: function (bounds) {
		bounds = L.latLngBounds(bounds);

		var sw = this._southWest,
		    ne = this._northEast,
		    sw2 = bounds.getSouthWest(),
		    ne2 = bounds.getNorthEast(),

		    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
		    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);

		return latOverlaps && lngOverlaps;
	},

	// @method toBBoxString(): String
	// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
	toBBoxString: function () {
		return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
	},

	// @method equals(otherBounds: LatLngBounds): Boolean
	// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds.
	equals: function (bounds) {
		if (!bounds) { return false; }

		bounds = L.latLngBounds(bounds);

		return this._southWest.equals(bounds.getSouthWest()) &&
		       this._northEast.equals(bounds.getNorthEast());
	},

	// @method isValid(): Boolean
	// Returns `true` if the bounds are properly initialized.
	isValid: function () {
		return !!(this._southWest && this._northEast);
	}
};

// TODO International date line?

// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.

// @alternative
// @factory L.latLngBounds(latlngs: LatLng[])
// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
L.latLngBounds = function (a, b) {
	if (a instanceof L.LatLngBounds) {
		return a;
	}
	return new L.LatLngBounds(a, b);
};



/*
 * @namespace Projection
 * @section
 * Leaflet comes with a set of already defined Projections out of the box:
 *
 * @projection L.Projection.LonLat
 *
 * Equirectangular, or Plate Carree projection — the most simple projection,
 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
 * `EPSG:3395` and `Simple` CRS.
 */

L.Projection = {};

L.Projection.LonLat = {
	project: function (latlng) {
		return new L.Point(latlng.lng, latlng.lat);
	},

	unproject: function (point) {
		return new L.LatLng(point.y, point.x);
	},

	bounds: L.bounds([-180, -90], [180, 90])
};



/*
 * @namespace Projection
 * @projection L.Projection.SphericalMercator
 *
 * Spherical Mercator projection — the most common projection for online maps,
 * used by almost all free and commercial tile providers. Assumes that Earth is
 * a sphere. Used by the `EPSG:3857` CRS.
 */

L.Projection.SphericalMercator = {

	R: 6378137,
	MAX_LATITUDE: 85.0511287798,

	project: function (latlng) {
		var d = Math.PI / 180,
		    max = this.MAX_LATITUDE,
		    lat = Math.max(Math.min(max, latlng.lat), -max),
		    sin = Math.sin(lat * d);

		return new L.Point(
				this.R * latlng.lng * d,
				this.R * Math.log((1 + sin) / (1 - sin)) / 2);
	},

	unproject: function (point) {
		var d = 180 / Math.PI;

		return new L.LatLng(
			(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
			point.x * d / this.R);
	},

	bounds: (function () {
		var d = 6378137 * Math.PI;
		return L.bounds([-d, -d], [d, d]);
	})()
};



/*
 * @class CRS
 * @aka L.CRS
 * Abstract class that defines coordinate reference systems for projecting
 * geographical points into pixel (screen) coordinates and back (and to
 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
 *
 * Leaflet defines the most usual CRSs by default. If you want to use a
 * CRS not defined by default, take a look at the
 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
 */

L.CRS = {
	// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
	// Projects geographical coordinates into pixel coordinates for a given zoom.
	latLngToPoint: function (latlng, zoom) {
		var projectedPoint = this.projection.project(latlng),
		    scale = this.scale(zoom);

		return this.transformation._transform(projectedPoint, scale);
	},

	// @method pointToLatLng(point: Point, zoom: Number): LatLng
	// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
	// zoom into geographical coordinates.
	pointToLatLng: function (point, zoom) {
		var scale = this.scale(zoom),
		    untransformedPoint = this.transformation.untransform(point, scale);

		return this.projection.unproject(untransformedPoint);
	},

	// @method project(latlng: LatLng): Point
	// Projects geographical coordinates into coordinates in units accepted for
	// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
	project: function (latlng) {
		return this.projection.project(latlng);
	},

	// @method unproject(point: Point): LatLng
	// Given a projected coordinate returns the corresponding LatLng.
	// The inverse of `project`.
	unproject: function (point) {
		return this.projection.unproject(point);
	},

	// @method scale(zoom: Number): Number
	// Returns the scale used when transforming projected coordinates into
	// pixel coordinates for a particular zoom. For example, it returns
	// `256 * 2^zoom` for Mercator-based CRS.
	scale: function (zoom) {
		return 256 * Math.pow(2, zoom);
	},

	// @method zoom(scale: Number): Number
	// Inverse of `scale()`, returns the zoom level corresponding to a scale
	// factor of `scale`.
	zoom: function (scale) {
		return Math.log(scale / 256) / Math.LN2;
	},

	// @method getProjectedBounds(zoom: Number): Bounds
	// Returns the projection's bounds scaled and transformed for the provided `zoom`.
	getProjectedBounds: function (zoom) {
		if (this.infinite) { return null; }

		var b = this.projection.bounds,
		    s = this.scale(zoom),
		    min = this.transformation.transform(b.min, s),
		    max = this.transformation.transform(b.max, s);

		return L.bounds(min, max);
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates.

	// @property code: String
	// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
	//
	// @property wrapLng: Number[]
	// An array of two numbers defining whether the longitude (horizontal) coordinate
	// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
	// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
	//
	// @property wrapLat: Number[]
	// Like `wrapLng`, but for the latitude (vertical) axis.

	// wrapLng: [min, max],
	// wrapLat: [min, max],

	// @property infinite: Boolean
	// If true, the coordinate space will be unbounded (infinite in both axes)
	infinite: false,

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where lat and lng has been wrapped according to the
	// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
	// Only accepts actual `L.LatLng` instances, not arrays.
	wrapLatLng: function (latlng) {
		var lng = this.wrapLng ? L.Util.wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
		    lat = this.wrapLat ? L.Util.wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
		    alt = latlng.alt;

		return L.latLng(lat, lng, alt);
	},

	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	// Returns a `LatLngBounds` with the same size as the given one, ensuring
	// that its center is within the CRS's bounds.
	// Only accepts actual `L.LatLngBounds` instances, not arrays.
	wrapLatLngBounds: function (bounds) {
		var center = bounds.getCenter(),
		    newCenter = this.wrapLatLng(center),
		    latShift = center.lat - newCenter.lat,
		    lngShift = center.lng - newCenter.lng;

		if (latShift === 0 && lngShift === 0) {
			return bounds;
		}

		var sw = bounds.getSouthWest(),
		    ne = bounds.getNorthEast(),
		    newSw = L.latLng({lat: sw.lat - latShift, lng: sw.lng - lngShift}),
		    newNe = L.latLng({lat: ne.lat - latShift, lng: ne.lng - lngShift});

		return new L.LatLngBounds(newSw, newNe);
	}
};



/*
 * @namespace CRS
 * @crs L.CRS.Simple
 *
 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
 * axis should still be inverted (going from bottom to top). `distance()` returns
 * simple euclidean distance.
 */

L.CRS.Simple = L.extend({}, L.CRS, {
	projection: L.Projection.LonLat,
	transformation: new L.Transformation(1, 0, -1, 0),

	scale: function (zoom) {
		return Math.pow(2, zoom);
	},

	zoom: function (scale) {
		return Math.log(scale) / Math.LN2;
	},

	distance: function (latlng1, latlng2) {
		var dx = latlng2.lng - latlng1.lng,
		    dy = latlng2.lat - latlng1.lat;

		return Math.sqrt(dx * dx + dy * dy);
	},

	infinite: true
});



/*
 * @namespace CRS
 * @crs L.CRS.Earth
 *
 * Serves as the base for CRS that are global such that they cover the earth.
 * Can only be used as the base for other CRS and cannot be used directly,
 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
 * meters.
 */

L.CRS.Earth = L.extend({}, L.CRS, {
	wrapLng: [-180, 180],

	// Mean Earth Radius, as recommended for use by
	// the International Union of Geodesy and Geophysics,
	// see http://rosettacode.org/wiki/Haversine_formula
	R: 6371000,

	// distance between two geographical points using spherical law of cosines approximation
	distance: function (latlng1, latlng2) {
		var rad = Math.PI / 180,
		    lat1 = latlng1.lat * rad,
		    lat2 = latlng2.lat * rad,
		    a = Math.sin(lat1) * Math.sin(lat2) +
		        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);

		return this.R * Math.acos(Math.min(a, 1));
	}
});



/*
 * @namespace CRS
 * @crs L.CRS.EPSG3857
 *
 * The most common CRS for online maps, used by almost all free and commercial
 * tile providers. Uses Spherical Mercator projection. Set in by default in
 * Map's `crs` option.
 */

L.CRS.EPSG3857 = L.extend({}, L.CRS.Earth, {
	code: 'EPSG:3857',
	projection: L.Projection.SphericalMercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * L.Projection.SphericalMercator.R);
		return new L.Transformation(scale, 0.5, -scale, 0.5);
	}())
});

L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
	code: 'EPSG:900913'
});



/*
 * @namespace CRS
 * @crs L.CRS.EPSG4326
 *
 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
 *
 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
 */

L.CRS.EPSG4326 = L.extend({}, L.CRS.Earth, {
	code: 'EPSG:4326',
	projection: L.Projection.LonLat,
	transformation: new L.Transformation(1 / 180, 1, -1 / 180, 0.5)
});



/*
 * @class Map
 * @aka L.Map
 * @inherits Evented
 *
 * The central class of the API — it is used to create a map on a page and manipulate it.
 *
 * @example
 *
 * ```js
 * // initialize the map on the "map" div with a given center and zoom
 * var map = L.map('map', {
 * 	center: [51.505, -0.09],
 * 	zoom: 13
 * });
 * ```
 *
 */

L.Map = L.Evented.extend({

	options: {
		// @section Map State Options
		// @option crs: CRS = L.CRS.EPSG3857
		// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
		// sure what it means.
		crs: L.CRS.EPSG3857,

		// @option center: LatLng = undefined
		// Initial geographic center of the map
		center: undefined,

		// @option zoom: Number = undefined
		// Initial map zoom level
		zoom: undefined,

		// @option minZoom: Number = undefined
		// Minimum zoom level of the map. Overrides any `minZoom` option set on map layers.
		minZoom: undefined,

		// @option maxZoom: Number = undefined
		// Maximum zoom level of the map. Overrides any `maxZoom` option set on map layers.
		maxZoom: undefined,

		// @option layers: Layer[] = []
		// Array of layers that will be added to the map initially
		layers: [],

		// @option maxBounds: LatLngBounds = null
		// When this option is set, the map restricts the view to the given
		// geographical bounds, bouncing the user back if the user tries to pan
		// outside the view. To set the restriction dynamically, use
		// [`setMaxBounds`](#map-setmaxbounds) method.
		maxBounds: undefined,

		// @option renderer: Renderer = *
		// The default method for drawing vector layers on the map. `L.SVG`
		// or `L.Canvas` by default depending on browser support.
		renderer: undefined,


		// @section Animation Options
		// @option zoomAnimation: Boolean = true
		// Whether the map zoom animation is enabled. By default it's enabled
		// in all browsers that support CSS3 Transitions except Android.
		zoomAnimation: true,

		// @option zoomAnimationThreshold: Number = 4
		// Won't animate zoom if the zoom difference exceeds this value.
		zoomAnimationThreshold: 4,

		// @option fadeAnimation: Boolean = true
		// Whether the tile fade animation is enabled. By default it's enabled
		// in all browsers that support CSS3 Transitions except Android.
		fadeAnimation: true,

		// @option markerZoomAnimation: Boolean = true
		// Whether markers animate their zoom with the zoom animation, if disabled
		// they will disappear for the length of the animation. By default it's
		// enabled in all browsers that support CSS3 Transitions except Android.
		markerZoomAnimation: true,

		// @option transform3DLimit: Number = 2^23
		// Defines the maximum size of a CSS translation transform. The default
		// value should not be changed unless a web browser positions layers in
		// the wrong place after doing a large `panBy`.
		transform3DLimit: 8388608, // Precision limit of a 32-bit float

		// @section Interaction Options
		// @option zoomSnap: Number = 1
		// Forces the map's zoom level to always be a multiple of this, particularly
		// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
		// By default, the zoom level snaps to the nearest integer; lower values
		// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
		// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
		zoomSnap: 1,

		// @option zoomDelta: Number = 1
		// Controls how much the map's zoom level will change after a
		// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
		// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
		// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
		zoomDelta: 1,

		// @option trackResize: Boolean = true
		// Whether the map automatically handles browser window resize to update itself.
		trackResize: true
	},

	initialize: function (id, options) { // (HTMLElement or String, Object)
		options = L.setOptions(this, options);

		this._initContainer(id);
		this._initLayout();

		// hack for https://github.com/Leaflet/Leaflet/issues/1980
		this._onResize = L.bind(this._onResize, this);

		this._initEvents();

		if (options.maxBounds) {
			this.setMaxBounds(options.maxBounds);
		}

		if (options.zoom !== undefined) {
			this._zoom = this._limitZoom(options.zoom);
		}

		if (options.center && options.zoom !== undefined) {
			this.setView(L.latLng(options.center), options.zoom, {reset: true});
		}

		this._handlers = [];
		this._layers = {};
		this._zoomBoundLayers = {};
		this._sizeChanged = true;

		this.callInitHooks();

		// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
		this._zoomAnimated = L.DomUtil.TRANSITION && L.Browser.any3d && !L.Browser.mobileOpera &&
				this.options.zoomAnimation;

		// zoom transitions run with the same duration for all layers, so if one of transitionend events
		// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
		if (this._zoomAnimated) {
			this._createAnimProxy();
			L.DomEvent.on(this._proxy, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
		}

		this._addLayers(this.options.layers);
	},


	// @section Methods for modifying map state

	// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) with the given
	// animation options.
	setView: function (center, zoom, options) {

		zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
		center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
		options = options || {};

		this._stop();

		if (this._loaded && !options.reset && options !== true) {

			if (options.animate !== undefined) {
				options.zoom = L.extend({animate: options.animate}, options.zoom);
				options.pan = L.extend({animate: options.animate, duration: options.duration}, options.pan);
			}

			// try animating pan or zoom
			var moved = (this._zoom !== zoom) ?
				this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
				this._tryAnimatedPan(center, options.pan);

			if (moved) {
				// prevent resize handler call, the view will refresh after animation anyway
				clearTimeout(this._sizeTimer);
				return this;
			}
		}

		// animation didn't start, just reset the map view
		this._resetView(center, zoom);

		return this;
	},

	// @method setZoom(zoom: Number, options: Zoom/pan options): this
	// Sets the zoom of the map.
	setZoom: function (zoom, options) {
		if (!this._loaded) {
			this._zoom = zoom;
			return this;
		}
		return this.setView(this.getCenter(), zoom, {zoom: options});
	},

	// @method zoomIn(delta?: Number, options?: Zoom options): this
	// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomIn: function (delta, options) {
		delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom + delta, options);
	},

	// @method zoomOut(delta?: Number, options?: Zoom options): this
	// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
	zoomOut: function (delta, options) {
		delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
		return this.setZoom(this._zoom - delta, options);
	},

	// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified geographical point on the map
	// stationary (e.g. used internally for scroll zoom and double-click zoom).
	// @alternative
	// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
	// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
	setZoomAround: function (latlng, zoom, options) {
		var scale = this.getZoomScale(zoom),
		    viewHalf = this.getSize().divideBy(2),
		    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),

		    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
		    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));

		return this.setView(newCenter, zoom, {zoom: options});
	},

	_getBoundsCenterZoom: function (bounds, options) {

		options = options || {};
		bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);

		var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
		    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),

		    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));

		zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;

		var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),

		    swPoint = this.project(bounds.getSouthWest(), zoom),
		    nePoint = this.project(bounds.getNorthEast(), zoom),
		    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);

		return {
			center: center,
			zoom: zoom
		};
	},

	// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
	// Sets a map view that contains the given geographical bounds with the
	// maximum zoom level possible.
	fitBounds: function (bounds, options) {

		bounds = L.latLngBounds(bounds);

		if (!bounds.isValid()) {
			throw new Error('Bounds are not valid.');
		}

		var target = this._getBoundsCenterZoom(bounds, options);
		return this.setView(target.center, target.zoom, options);
	},

	// @method fitWorld(options?: fitBounds options): this
	// Sets a map view that mostly contains the whole world with the maximum
	// zoom level possible.
	fitWorld: function (options) {
		return this.fitBounds([[-90, -180], [90, 180]], options);
	},

	// @method panTo(latlng: LatLng, options?: Pan options): this
	// Pans the map to a given center.
	panTo: function (center, options) { // (LatLng)
		return this.setView(center, this._zoom, {pan: options});
	},

	// @method panBy(offset: Point): this
	// Pans the map by a given number of pixels (animated).
	panBy: function (offset, options) {
		offset = L.point(offset).round();
		options = options || {};

		if (!offset.x && !offset.y) {
			return this.fire('moveend');
		}
		// If we pan too far, Chrome gets issues with tiles
		// and makes them disappear or appear in the wrong place (slightly offset) #2602
		if (options.animate !== true && !this.getSize().contains(offset)) {
			this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
			return this;
		}

		if (!this._panAnim) {
			this._panAnim = new L.PosAnimation();

			this._panAnim.on({
				'step': this._onPanTransitionStep,
				'end': this._onPanTransitionEnd
			}, this);
		}

		// don't fire movestart if animating inertia
		if (!options.noMoveStart) {
			this.fire('movestart');
		}

		// animate pan unless animate: false specified
		if (options.animate !== false) {
			L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');

			var newPos = this._getMapPanePos().subtract(offset).round();
			this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
		} else {
			this._rawPanBy(offset);
			this.fire('move').fire('moveend');
		}

		return this;
	},

	// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
	// Sets the view of the map (geographical center and zoom) performing a smooth
	// pan-zoom animation.
	flyTo: function (targetCenter, targetZoom, options) {

		options = options || {};
		if (options.animate === false || !L.Browser.any3d) {
			return this.setView(targetCenter, targetZoom, options);
		}

		this._stop();

		var from = this.project(this.getCenter()),
		    to = this.project(targetCenter),
		    size = this.getSize(),
		    startZoom = this._zoom;

		targetCenter = L.latLng(targetCenter);
		targetZoom = targetZoom === undefined ? startZoom : targetZoom;

		var w0 = Math.max(size.x, size.y),
		    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
		    u1 = (to.distanceTo(from)) || 1,
		    rho = 1.42,
		    rho2 = rho * rho;

		function r(i) {
			var s1 = i ? -1 : 1,
			    s2 = i ? w1 : w0,
			    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
			    b1 = 2 * s2 * rho2 * u1,
			    b = t1 / b1,
			    sq = Math.sqrt(b * b + 1) - b;

			    // workaround for floating point precision bug when sq = 0, log = -Infinite,
			    // thus triggering an infinite loop in flyTo
			    var log = sq < 0.000000001 ? -18 : Math.log(sq);

			return log;
		}

		function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
		function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
		function tanh(n) { return sinh(n) / cosh(n); }

		var r0 = r(0);

		function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
		function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }

		function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }

		var start = Date.now(),
		    S = (r(1) - r0) / rho,
		    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;

		function frame() {
			var t = (Date.now() - start) / duration,
			    s = easeOut(t) * S;

			if (t <= 1) {
				this._flyToFrame = L.Util.requestAnimFrame(frame, this);

				this._move(
					this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
					this.getScaleZoom(w0 / w(s), startZoom),
					{flyTo: true});

			} else {
				this
					._move(targetCenter, targetZoom)
					._moveEnd(true);
			}
		}

		this._moveStart(true);

		frame.call(this);
		return this;
	},

	// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
	// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
	// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
	flyToBounds: function (bounds, options) {
		var target = this._getBoundsCenterZoom(bounds, options);
		return this.flyTo(target.center, target.zoom, options);
	},

	// @method setMaxBounds(bounds: Bounds): this
	// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
	setMaxBounds: function (bounds) {
		bounds = L.latLngBounds(bounds);

		if (!bounds.isValid()) {
			this.options.maxBounds = null;
			return this.off('moveend', this._panInsideMaxBounds);
		} else if (this.options.maxBounds) {
			this.off('moveend', this._panInsideMaxBounds);
		}

		this.options.maxBounds = bounds;

		if (this._loaded) {
			this._panInsideMaxBounds();
		}

		return this.on('moveend', this._panInsideMaxBounds);
	},

	// @method setMinZoom(zoom: Number): this
	// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
	setMinZoom: function (zoom) {
		this.options.minZoom = zoom;

		if (this._loaded && this.getZoom() < this.options.minZoom) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method setMaxZoom(zoom: Number): this
	// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
	setMaxZoom: function (zoom) {
		this.options.maxZoom = zoom;

		if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
			return this.setZoom(zoom);
		}

		return this;
	},

	// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
	// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
	panInsideBounds: function (bounds, options) {
		this._enforcingBounds = true;
		var center = this.getCenter(),
		    newCenter = this._limitCenter(center, this._zoom, L.latLngBounds(bounds));

		if (!center.equals(newCenter)) {
			this.panTo(newCenter, options);
		}

		this._enforcingBounds = false;
		return this;
	},

	// @method invalidateSize(options: Zoom/Pan options): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default. If `options.pan` is `false`, panning will not occur.
	// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
	// that it doesn't happen often even if the method is called many
	// times in a row.

	// @alternative
	// @method invalidateSize(animate: Boolean): this
	// Checks if the map container size changed and updates the map if so —
	// call it after you've changed the map size dynamically, also animating
	// pan by default.
	invalidateSize: function (options) {
		if (!this._loaded) { return this; }

		options = L.extend({
			animate: false,
			pan: true
		}, options === true ? {animate: true} : options);

		var oldSize = this.getSize();
		this._sizeChanged = true;
		this._lastCenter = null;

		var newSize = this.getSize(),
		    oldCenter = oldSize.divideBy(2).round(),
		    newCenter = newSize.divideBy(2).round(),
		    offset = oldCenter.subtract(newCenter);

		if (!offset.x && !offset.y) { return this; }

		if (options.animate && options.pan) {
			this.panBy(offset);

		} else {
			if (options.pan) {
				this._rawPanBy(offset);
			}

			this.fire('move');

			if (options.debounceMoveend) {
				clearTimeout(this._sizeTimer);
				this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
			} else {
				this.fire('moveend');
			}
		}

		// @section Map state change events
		// @event resize: ResizeEvent
		// Fired when the map is resized.
		return this.fire('resize', {
			oldSize: oldSize,
			newSize: newSize
		});
	},

	// @section Methods for modifying map state
	// @method stop(): this
	// Stops the currently running `panTo` or `flyTo` animation, if any.
	stop: function () {
		this.setZoom(this._limitZoom(this._zoom));
		if (!this.options.zoomSnap) {
			this.fire('viewreset');
		}
		return this._stop();
	},

	// @section Geolocation methods
	// @method locate(options?: Locate options): this
	// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
	// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
	// and optionally sets the map view to the user's location with respect to
	// detection accuracy (or to the world view if geolocation failed).
	// Note that, if your page doesn't use HTTPS, this method will fail in
	// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
	// See `Locate options` for more details.
	locate: function (options) {

		options = this._locateOptions = L.extend({
			timeout: 10000,
			watch: false
			// setView: false
			// maxZoom: <Number>
			// maximumAge: 0
			// enableHighAccuracy: false
		}, options);

		if (!('geolocation' in navigator)) {
			this._handleGeolocationError({
				code: 0,
				message: 'Geolocation not supported.'
			});
			return this;
		}

		var onResponse = L.bind(this._handleGeolocationResponse, this),
		    onError = L.bind(this._handleGeolocationError, this);

		if (options.watch) {
			this._locationWatchId =
			        navigator.geolocation.watchPosition(onResponse, onError, options);
		} else {
			navigator.geolocation.getCurrentPosition(onResponse, onError, options);
		}
		return this;
	},

	// @method stopLocate(): this
	// Stops watching location previously initiated by `map.locate({watch: true})`
	// and aborts resetting the map view if map.locate was called with
	// `{setView: true}`.
	stopLocate: function () {
		if (navigator.geolocation && navigator.geolocation.clearWatch) {
			navigator.geolocation.clearWatch(this._locationWatchId);
		}
		if (this._locateOptions) {
			this._locateOptions.setView = false;
		}
		return this;
	},

	_handleGeolocationError: function (error) {
		var c = error.code,
		    message = error.message ||
		            (c === 1 ? 'permission denied' :
		            (c === 2 ? 'position unavailable' : 'timeout'));

		if (this._locateOptions.setView && !this._loaded) {
			this.fitWorld();
		}

		// @section Location events
		// @event locationerror: ErrorEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
		this.fire('locationerror', {
			code: c,
			message: 'Geolocation error: ' + message + '.'
		});
	},

	_handleGeolocationResponse: function (pos) {
		var lat = pos.coords.latitude,
		    lng = pos.coords.longitude,
		    latlng = new L.LatLng(lat, lng),
		    bounds = latlng.toBounds(pos.coords.accuracy),
		    options = this._locateOptions;

		if (options.setView) {
			var zoom = this.getBoundsZoom(bounds);
			this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
		}

		var data = {
			latlng: latlng,
			bounds: bounds,
			timestamp: pos.timestamp
		};

		for (var i in pos.coords) {
			if (typeof pos.coords[i] === 'number') {
				data[i] = pos.coords[i];
			}
		}

		// @event locationfound: LocationEvent
		// Fired when geolocation (using the [`locate`](#map-locate) method)
		// went successfully.
		this.fire('locationfound', data);
	},

	// TODO handler.addTo
	// TODO Appropiate docs section?
	// @section Other Methods
	// @method addHandler(name: String, HandlerClass: Function): this
	// Adds a new `Handler` to the map, given its name and constructor function.
	addHandler: function (name, HandlerClass) {
		if (!HandlerClass) { return this; }

		var handler = this[name] = new HandlerClass(this);

		this._handlers.push(handler);

		if (this.options[name]) {
			handler.enable();
		}

		return this;
	},

	// @method remove(): this
	// Destroys the map and clears all related event listeners.
	remove: function () {

		this._initEvents(true);

		if (this._containerId !== this._container._leaflet_id) {
			throw new Error('Map container is being reused by another instance');
		}

		try {
			// throws error in IE6-8
			delete this._container._leaflet_id;
			delete this._containerId;
		} catch (e) {
			/*eslint-disable */
			this._container._leaflet_id = undefined;
			/*eslint-enable */
			this._containerId = undefined;
		}

		L.DomUtil.remove(this._mapPane);

		if (this._clearControlPos) {
			this._clearControlPos();
		}

		this._clearHandlers();

		if (this._loaded) {
			// @section Map state change events
			// @event unload: Event
			// Fired when the map is destroyed with [remove](#map-remove) method.
			this.fire('unload');
		}

		for (var i in this._layers) {
			this._layers[i].remove();
		}

		return this;
	},

	// @section Other Methods
	// @method createPane(name: String, container?: HTMLElement): HTMLElement
	// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
	// then returns it. The pane is created as a children of `container`, or
	// as a children of the main map pane if not set.
	createPane: function (name, container) {
		var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
		    pane = L.DomUtil.create('div', className, container || this._mapPane);

		if (name) {
			this._panes[name] = pane;
		}
		return pane;
	},

	// @section Methods for Getting Map State

	// @method getCenter(): LatLng
	// Returns the geographical center of the map view
	getCenter: function () {
		this._checkIfLoaded();

		if (this._lastCenter && !this._moved()) {
			return this._lastCenter;
		}
		return this.layerPointToLatLng(this._getCenterLayerPoint());
	},

	// @method getZoom(): Number
	// Returns the current zoom level of the map view
	getZoom: function () {
		return this._zoom;
	},

	// @method getBounds(): LatLngBounds
	// Returns the geographical bounds visible in the current map view
	getBounds: function () {
		var bounds = this.getPixelBounds(),
		    sw = this.unproject(bounds.getBottomLeft()),
		    ne = this.unproject(bounds.getTopRight());

		return new L.LatLngBounds(sw, ne);
	},

	// @method getMinZoom(): Number
	// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
	getMinZoom: function () {
		return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
	},

	// @method getMaxZoom(): Number
	// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
	getMaxZoom: function () {
		return this.options.maxZoom === undefined ?
			(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
			this.options.maxZoom;
	},

	// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
	// Returns the maximum zoom level on which the given bounds fit to the map
	// view in its entirety. If `inside` (optional) is set to `true`, the method
	// instead returns the minimum zoom level on which the map view fits into
	// the given bounds in its entirety.
	getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
		bounds = L.latLngBounds(bounds);
		padding = L.point(padding || [0, 0]);

		var zoom = this.getZoom() || 0,
		    min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    nw = bounds.getNorthWest(),
		    se = bounds.getSouthEast(),
		    size = this.getSize().subtract(padding),
		    boundsSize = L.bounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
		    snap = L.Browser.any3d ? this.options.zoomSnap : 1;

		var scale = Math.min(size.x / boundsSize.x, size.y / boundsSize.y);
		zoom = this.getScaleZoom(scale, zoom);

		if (snap) {
			zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
			zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
		}

		return Math.max(min, Math.min(max, zoom));
	},

	// @method getSize(): Point
	// Returns the current size of the map container (in pixels).
	getSize: function () {
		if (!this._size || this._sizeChanged) {
			this._size = new L.Point(
				this._container.clientWidth || 0,
				this._container.clientHeight || 0);

			this._sizeChanged = false;
		}
		return this._size.clone();
	},

	// @method getPixelBounds(): Bounds
	// Returns the bounds of the current map view in projected pixel
	// coordinates (sometimes useful in layer and overlay implementations).
	getPixelBounds: function (center, zoom) {
		var topLeftPoint = this._getTopLeftPoint(center, zoom);
		return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
	},

	// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
	// the map pane? "left point of the map layer" can be confusing, specially
	// since there can be negative offsets.
	// @method getPixelOrigin(): Point
	// Returns the projected pixel coordinates of the top left point of
	// the map layer (useful in custom layer and overlay implementations).
	getPixelOrigin: function () {
		this._checkIfLoaded();
		return this._pixelOrigin;
	},

	// @method getPixelWorldBounds(zoom?: Number): Bounds
	// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
	// If `zoom` is omitted, the map's current zoom level is used.
	getPixelWorldBounds: function (zoom) {
		return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
	},

	// @section Other Methods

	// @method getPane(pane: String|HTMLElement): HTMLElement
	// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
	getPane: function (pane) {
		return typeof pane === 'string' ? this._panes[pane] : pane;
	},

	// @method getPanes(): Object
	// Returns a plain object containing the names of all [panes](#map-pane) as keys and
	// the panes as values.
	getPanes: function () {
		return this._panes;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the map.
	getContainer: function () {
		return this._container;
	},


	// @section Conversion Methods

	// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
	// Returns the scale factor to be applied to a map transition from zoom level
	// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
	getZoomScale: function (toZoom, fromZoom) {
		// TODO replace with universal implementation after refactoring projections
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		return crs.scale(toZoom) / crs.scale(fromZoom);
	},

	// @method getScaleZoom(scale: Number, fromZoom: Number): Number
	// Returns the zoom level that the map would end up at, if it is at `fromZoom`
	// level and everything is scaled by a factor of `scale`. Inverse of
	// [`getZoomScale`](#map-getZoomScale).
	getScaleZoom: function (scale, fromZoom) {
		var crs = this.options.crs;
		fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
		var zoom = crs.zoom(scale * crs.scale(fromZoom));
		return isNaN(zoom) ? Infinity : zoom;
	},

	// @method project(latlng: LatLng, zoom: Number): Point
	// Projects a geographical coordinate `LatLng` according to the projection
	// of the map's CRS, then scales it according to `zoom` and the CRS's
	// `Transformation`. The result is pixel coordinate relative to
	// the CRS origin.
	project: function (latlng, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
	},

	// @method unproject(point: Point, zoom: Number): LatLng
	// Inverse of [`project`](#map-project).
	unproject: function (point, zoom) {
		zoom = zoom === undefined ? this._zoom : zoom;
		return this.options.crs.pointToLatLng(L.point(point), zoom);
	},

	// @method layerPointToLatLng(point: Point): LatLng
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding geographical coordinate (for the current zoom level).
	layerPointToLatLng: function (point) {
		var projectedPoint = L.point(point).add(this.getPixelOrigin());
		return this.unproject(projectedPoint);
	},

	// @method latLngToLayerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the [origin pixel](#map-getpixelorigin).
	latLngToLayerPoint: function (latlng) {
		var projectedPoint = this.project(L.latLng(latlng))._round();
		return projectedPoint._subtract(this.getPixelOrigin());
	},

	// @method wrapLatLng(latlng: LatLng): LatLng
	// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
	// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
	// CRS's bounds.
	// By default this means longitude is wrapped around the dateline so its
	// value is between -180 and +180 degrees.
	wrapLatLng: function (latlng) {
		return this.options.crs.wrapLatLng(L.latLng(latlng));
	},

	// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
	// Returns a `LatLngBounds` with the same size as the given one, ensuring that
	// its center is within the CRS's bounds.
	// By default this means the center longitude is wrapped around the dateline so its
	// value is between -180 and +180 degrees, and the majority of the bounds
	// overlaps the CRS's bounds.
	wrapLatLngBounds: function (latlng) {
		return this.options.crs.wrapLatLngBounds(L.latLngBounds(latlng));
	},

	// @method distance(latlng1: LatLng, latlng2: LatLng): Number
	// Returns the distance between two geographical coordinates according to
	// the map's CRS. By default this measures distance in meters.
	distance: function (latlng1, latlng2) {
		return this.options.crs.distance(L.latLng(latlng1), L.latLng(latlng2));
	},

	// @method containerPointToLayerPoint(point: Point): Point
	// Given a pixel coordinate relative to the map container, returns the corresponding
	// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
	containerPointToLayerPoint: function (point) { // (Point)
		return L.point(point).subtract(this._getMapPanePos());
	},

	// @method layerPointToContainerPoint(point: Point): Point
	// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
	// returns the corresponding pixel coordinate relative to the map container.
	layerPointToContainerPoint: function (point) { // (Point)
		return L.point(point).add(this._getMapPanePos());
	},

	// @method containerPointToLatLng(point: Point): LatLng
	// Given a pixel coordinate relative to the map container, returns
	// the corresponding geographical coordinate (for the current zoom level).
	containerPointToLatLng: function (point) {
		var layerPoint = this.containerPointToLayerPoint(L.point(point));
		return this.layerPointToLatLng(layerPoint);
	},

	// @method latLngToContainerPoint(latlng: LatLng): Point
	// Given a geographical coordinate, returns the corresponding pixel coordinate
	// relative to the map container.
	latLngToContainerPoint: function (latlng) {
		return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
	},

	// @method mouseEventToContainerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to the
	// map container where the event took place.
	mouseEventToContainerPoint: function (e) {
		return L.DomEvent.getMousePosition(e, this._container);
	},

	// @method mouseEventToLayerPoint(ev: MouseEvent): Point
	// Given a MouseEvent object, returns the pixel coordinate relative to
	// the [origin pixel](#map-getpixelorigin) where the event took place.
	mouseEventToLayerPoint: function (e) {
		return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
	},

	// @method mouseEventToLatLng(ev: MouseEvent): LatLng
	// Given a MouseEvent object, returns geographical coordinate where the
	// event took place.
	mouseEventToLatLng: function (e) { // (MouseEvent)
		return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
	},


	// map initialization methods

	_initContainer: function (id) {
		var container = this._container = L.DomUtil.get(id);

		if (!container) {
			throw new Error('Map container not found.');
		} else if (container._leaflet_id) {
			throw new Error('Map container is already initialized.');
		}

		L.DomEvent.addListener(container, 'scroll', this._onScroll, this);
		this._containerId = L.Util.stamp(container);
	},

	_initLayout: function () {
		var container = this._container;

		this._fadeAnimated = this.options.fadeAnimation && L.Browser.any3d;

		L.DomUtil.addClass(container, 'leaflet-container' +
			(L.Browser.touch ? ' leaflet-touch' : '') +
			(L.Browser.retina ? ' leaflet-retina' : '') +
			(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
			(L.Browser.safari ? ' leaflet-safari' : '') +
			(this._fadeAnimated ? ' leaflet-fade-anim' : ''));

		var position = L.DomUtil.getStyle(container, 'position');

		if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
			container.style.position = 'relative';
		}

		this._initPanes();

		if (this._initControlPos) {
			this._initControlPos();
		}
	},

	_initPanes: function () {
		var panes = this._panes = {};
		this._paneRenderers = {};

		// @section
		//
		// Panes are DOM elements used to control the ordering of layers on the map. You
		// can access panes with [`map.getPane`](#map-getpane) or
		// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
		// [`map.createPane`](#map-createpane) method.
		//
		// Every map has the following default panes that differ only in zIndex.
		//
		// @pane mapPane: HTMLElement = 'auto'
		// Pane that contains all other map panes

		this._mapPane = this.createPane('mapPane', this._container);
		L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));

		// @pane tilePane: HTMLElement = 200
		// Pane for `GridLayer`s and `TileLayer`s
		this.createPane('tilePane');
		// @pane overlayPane: HTMLElement = 400
		// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
		this.createPane('shadowPane');
		// @pane shadowPane: HTMLElement = 500
		// Pane for overlay shadows (e.g. `Marker` shadows)
		this.createPane('overlayPane');
		// @pane markerPane: HTMLElement = 600
		// Pane for `Icon`s of `Marker`s
		this.createPane('markerPane');
		// @pane tooltipPane: HTMLElement = 650
		// Pane for tooltip.
		this.createPane('tooltipPane');
		// @pane popupPane: HTMLElement = 700
		// Pane for `Popup`s.
		this.createPane('popupPane');

		if (!this.options.markerZoomAnimation) {
			L.DomUtil.addClass(panes.markerPane, 'leaflet-zoom-hide');
			L.DomUtil.addClass(panes.shadowPane, 'leaflet-zoom-hide');
		}
	},


	// private methods that modify map state

	// @section Map state change events
	_resetView: function (center, zoom) {
		L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));

		var loading = !this._loaded;
		this._loaded = true;
		zoom = this._limitZoom(zoom);

		this.fire('viewprereset');

		var zoomChanged = this._zoom !== zoom;
		this
			._moveStart(zoomChanged)
			._move(center, zoom)
			._moveEnd(zoomChanged);

		// @event viewreset: Event
		// Fired when the map needs to redraw its content (this usually happens
		// on map zoom or load). Very useful for creating custom overlays.
		this.fire('viewreset');

		// @event load: Event
		// Fired when the map is initialized (when its center and zoom are set
		// for the first time).
		if (loading) {
			this.fire('load');
		}
	},

	_moveStart: function (zoomChanged) {
		// @event zoomstart: Event
		// Fired when the map zoom is about to change (e.g. before zoom animation).
		// @event movestart: Event
		// Fired when the view of the map starts changing (e.g. user starts dragging the map).
		if (zoomChanged) {
			this.fire('zoomstart');
		}
		return this.fire('movestart');
	},

	_move: function (center, zoom, data) {
		if (zoom === undefined) {
			zoom = this._zoom;
		}
		var zoomChanged = this._zoom !== zoom;

		this._zoom = zoom;
		this._lastCenter = center;
		this._pixelOrigin = this._getNewPixelOrigin(center);

		// @event zoom: Event
		// Fired repeatedly during any change in zoom level, including zoom
		// and fly animations.
		if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
			this.fire('zoom', data);
		}

		// @event move: Event
		// Fired repeatedly during any movement of the map, including pan and
		// fly animations.
		return this.fire('move', data);
	},

	_moveEnd: function (zoomChanged) {
		// @event zoomend: Event
		// Fired when the map has changed, after any animations.
		if (zoomChanged) {
			this.fire('zoomend');
		}

		// @event moveend: Event
		// Fired when the center of the map stops changing (e.g. user stopped
		// dragging the map).
		return this.fire('moveend');
	},

	_stop: function () {
		L.Util.cancelAnimFrame(this._flyToFrame);
		if (this._panAnim) {
			this._panAnim.stop();
		}
		return this;
	},

	_rawPanBy: function (offset) {
		L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
	},

	_getZoomSpan: function () {
		return this.getMaxZoom() - this.getMinZoom();
	},

	_panInsideMaxBounds: function () {
		if (!this._enforcingBounds) {
			this.panInsideBounds(this.options.maxBounds);
		}
	},

	_checkIfLoaded: function () {
		if (!this._loaded) {
			throw new Error('Set map center and zoom first.');
		}
	},

	// DOM event handling

	// @section Interaction events
	_initEvents: function (remove) {
		if (!L.DomEvent) { return; }

		this._targets = {};
		this._targets[L.stamp(this._container)] = this;

		var onOff = remove ? 'off' : 'on';

		// @event click: MouseEvent
		// Fired when the user clicks (or taps) the map.
		// @event dblclick: MouseEvent
		// Fired when the user double-clicks (or double-taps) the map.
		// @event mousedown: MouseEvent
		// Fired when the user pushes the mouse button on the map.
		// @event mouseup: MouseEvent
		// Fired when the user releases the mouse button on the map.
		// @event mouseover: MouseEvent
		// Fired when the mouse enters the map.
		// @event mouseout: MouseEvent
		// Fired when the mouse leaves the map.
		// @event mousemove: MouseEvent
		// Fired while the mouse moves over the map.
		// @event contextmenu: MouseEvent
		// Fired when the user pushes the right mouse button on the map, prevents
		// default browser context menu from showing if there are listeners on
		// this event. Also fired on mobile when the user holds a single touch
		// for a second (also called long press).
		// @event keypress: KeyboardEvent
		// Fired when the user presses a key from the keyboard while the map is focused.
		L.DomEvent[onOff](this._container, 'click dblclick mousedown mouseup ' +
			'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);

		if (this.options.trackResize) {
			L.DomEvent[onOff](window, 'resize', this._onResize, this);
		}

		if (L.Browser.any3d && this.options.transform3DLimit) {
			this[onOff]('moveend', this._onMoveEnd);
		}
	},

	_onResize: function () {
		L.Util.cancelAnimFrame(this._resizeRequest);
		this._resizeRequest = L.Util.requestAnimFrame(
		        function () { this.invalidateSize({debounceMoveend: true}); }, this);
	},

	_onScroll: function () {
		this._container.scrollTop  = 0;
		this._container.scrollLeft = 0;
	},

	_onMoveEnd: function () {
		var pos = this._getMapPanePos();
		if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
			// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
			this._resetView(this.getCenter(), this.getZoom());
		}
	},

	_findEventTargets: function (e, type) {
		var targets = [],
		    target,
		    isHover = type === 'mouseout' || type === 'mouseover',
		    src = e.target || e.srcElement,
		    dragging = false;

		while (src) {
			target = this._targets[L.stamp(src)];
			if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
				// Prevent firing click after you just dragged an object.
				dragging = true;
				break;
			}
			if (target && target.listens(type, true)) {
				if (isHover && !L.DomEvent._isExternalTarget(src, e)) { break; }
				targets.push(target);
				if (isHover) { break; }
			}
			if (src === this._container) { break; }
			src = src.parentNode;
		}
		if (!targets.length && !dragging && !isHover && L.DomEvent._isExternalTarget(src, e)) {
			targets = [this];
		}
		return targets;
	},

	_handleDOMEvent: function (e) {
		if (!this._loaded || L.DomEvent._skipped(e)) { return; }

		var type = e.type === 'keypress' && e.keyCode === 13 ? 'click' : e.type;

		if (type === 'mousedown') {
			// prevents outline when clicking on keyboard-focusable element
			L.DomUtil.preventOutline(e.target || e.srcElement);
		}

		this._fireDOMEvent(e, type);
	},

	_fireDOMEvent: function (e, type, targets) {

		if (e.type === 'click') {
			// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
			// @event preclick: MouseEvent
			// Fired before mouse click on the map (sometimes useful when you
			// want something to happen on click before any existing click
			// handlers start running).
			var synth = L.Util.extend({}, e);
			synth.type = 'preclick';
			this._fireDOMEvent(synth, synth.type, targets);
		}

		if (e._stopped) { return; }

		// Find the layer the event is propagating from and its parents.
		targets = (targets || []).concat(this._findEventTargets(e, type));

		if (!targets.length) { return; }

		var target = targets[0];
		if (type === 'contextmenu' && target.listens(type, true)) {
			L.DomEvent.preventDefault(e);
		}

		var data = {
			originalEvent: e
		};

		if (e.type !== 'keypress') {
			var isMarker = target instanceof L.Marker;
			data.containerPoint = isMarker ?
					this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
			data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
			data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
		}

		for (var i = 0; i < targets.length; i++) {
			targets[i].fire(type, data, true);
			if (data.originalEvent._stopped ||
				(targets[i].options.nonBubblingEvents && L.Util.indexOf(targets[i].options.nonBubblingEvents, type) !== -1)) { return; }
		}
	},

	_draggableMoved: function (obj) {
		obj = obj.dragging && obj.dragging.enabled() ? obj : this;
		return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
	},

	_clearHandlers: function () {
		for (var i = 0, len = this._handlers.length; i < len; i++) {
			this._handlers[i].disable();
		}
	},

	// @section Other Methods

	// @method whenReady(fn: Function, context?: Object): this
	// Runs the given function `fn` when the map gets initialized with
	// a view (center and zoom) and at least one layer, or immediately
	// if it's already initialized, optionally passing a function context.
	whenReady: function (callback, context) {
		if (this._loaded) {
			callback.call(context || this, {target: this});
		} else {
			this.on('load', callback, context);
		}
		return this;
	},


	// private methods for getting map state

	_getMapPanePos: function () {
		return L.DomUtil.getPosition(this._mapPane) || new L.Point(0, 0);
	},

	_moved: function () {
		var pos = this._getMapPanePos();
		return pos && !pos.equals([0, 0]);
	},

	_getTopLeftPoint: function (center, zoom) {
		var pixelOrigin = center && zoom !== undefined ?
			this._getNewPixelOrigin(center, zoom) :
			this.getPixelOrigin();
		return pixelOrigin.subtract(this._getMapPanePos());
	},

	_getNewPixelOrigin: function (center, zoom) {
		var viewHalf = this.getSize()._divideBy(2);
		return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
	},

	_latLngToNewLayerPoint: function (latlng, zoom, center) {
		var topLeft = this._getNewPixelOrigin(center, zoom);
		return this.project(latlng, zoom)._subtract(topLeft);
	},

	_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
		var topLeft = this._getNewPixelOrigin(center, zoom);
		return L.bounds([
			this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
			this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
		]);
	},

	// layer point of the current center
	_getCenterLayerPoint: function () {
		return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
	},

	// offset of the specified place to the current center in pixels
	_getCenterOffset: function (latlng) {
		return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
	},

	// adjust center for view to get inside bounds
	_limitCenter: function (center, zoom, bounds) {

		if (!bounds) { return center; }

		var centerPoint = this.project(center, zoom),
		    viewHalf = this.getSize().divideBy(2),
		    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
		    offset = this._getBoundsOffset(viewBounds, bounds, zoom);

		// If offset is less than a pixel, ignore.
		// This prevents unstable projections from getting into
		// an infinite loop of tiny offsets.
		if (offset.round().equals([0, 0])) {
			return center;
		}

		return this.unproject(centerPoint.add(offset), zoom);
	},

	// adjust offset for view to get inside bounds
	_limitOffset: function (offset, bounds) {
		if (!bounds) { return offset; }

		var viewBounds = this.getPixelBounds(),
		    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));

		return offset.add(this._getBoundsOffset(newBounds, bounds));
	},

	// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
	_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
		var projectedMaxBounds = L.bounds(
		        this.project(maxBounds.getNorthEast(), zoom),
		        this.project(maxBounds.getSouthWest(), zoom)
		    ),
		    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
		    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),

		    dx = this._rebound(minOffset.x, -maxOffset.x),
		    dy = this._rebound(minOffset.y, -maxOffset.y);

		return new L.Point(dx, dy);
	},

	_rebound: function (left, right) {
		return left + right > 0 ?
			Math.round(left - right) / 2 :
			Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
	},

	_limitZoom: function (zoom) {
		var min = this.getMinZoom(),
		    max = this.getMaxZoom(),
		    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
		if (snap) {
			zoom = Math.round(zoom / snap) * snap;
		}
		return Math.max(min, Math.min(max, zoom));
	},

	_onPanTransitionStep: function () {
		this.fire('move');
	},

	_onPanTransitionEnd: function () {
		L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
		this.fire('moveend');
	},

	_tryAnimatedPan: function (center, options) {
		// difference between the new and current centers in pixels
		var offset = this._getCenterOffset(center)._floor();

		// don't animate too far unless animate: true specified in options
		if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }

		this.panBy(offset, options);

		return true;
	},

	_createAnimProxy: function () {

		var proxy = this._proxy = L.DomUtil.create('div', 'leaflet-proxy leaflet-zoom-animated');
		this._panes.mapPane.appendChild(proxy);

		this.on('zoomanim', function (e) {
			var prop = L.DomUtil.TRANSFORM,
			    transform = proxy.style[prop];

			L.DomUtil.setTransform(proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));

			// workaround for case when transform is the same and so transitionend event is not fired
			if (transform === proxy.style[prop] && this._animatingZoom) {
				this._onZoomTransitionEnd();
			}
		}, this);

		this.on('load moveend', function () {
			var c = this.getCenter(),
			    z = this.getZoom();
			L.DomUtil.setTransform(proxy, this.project(c, z), this.getZoomScale(z, 1));
		}, this);
	},

	_catchTransitionEnd: function (e) {
		if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
			this._onZoomTransitionEnd();
		}
	},

	_nothingToAnimate: function () {
		return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
	},

	_tryAnimatedZoom: function (center, zoom, options) {

		if (this._animatingZoom) { return true; }

		options = options || {};

		// don't animate if disabled, not supported or zoom difference is too large
		if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
		        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }

		// offset is the pixel coords of the zoom origin relative to the current center
		var scale = this.getZoomScale(zoom),
		    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);

		// don't animate if the zoom origin isn't within one screen from the current center, unless forced
		if (options.animate !== true && !this.getSize().contains(offset)) { return false; }

		L.Util.requestAnimFrame(function () {
			this
			    ._moveStart(true)
			    ._animateZoom(center, zoom, true);
		}, this);

		return true;
	},

	_animateZoom: function (center, zoom, startAnim, noUpdate) {
		if (startAnim) {
			this._animatingZoom = true;

			// remember what center/zoom to set after animation
			this._animateToCenter = center;
			this._animateToZoom = zoom;

			L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');
		}

		// @event zoomanim: ZoomAnimEvent
		// Fired on every frame of a zoom animation
		this.fire('zoomanim', {
			center: center,
			zoom: zoom,
			noUpdate: noUpdate
		});

		// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
		setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
	},

	_onZoomTransitionEnd: function () {
		if (!this._animatingZoom) { return; }

		L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');

		this._animatingZoom = false;

		this._move(this._animateToCenter, this._animateToZoom);

		// This anim frame should prevent an obscure iOS webkit tile loading race condition.
		L.Util.requestAnimFrame(function () {
			this._moveEnd(true);
		}, this);
	}
});

// @section

// @factory L.map(id: String, options?: Map options)
// Instantiates a map object given the DOM ID of a `<div>` element
// and optionally an object literal with `Map options`.
//
// @alternative
// @factory L.map(el: HTMLElement, options?: Map options)
// Instantiates a map object given an instance of a `<div>` HTML element
// and optionally an object literal with `Map options`.
L.map = function (id, options) {
	return new L.Map(id, options);
};




/*
 * @class Layer
 * @inherits Evented
 * @aka L.Layer
 * @aka ILayer
 *
 * A set of methods from the Layer base class that all Leaflet layers use.
 * Inherits all methods, options and events from `L.Evented`.
 *
 * @example
 *
 * ```js
 * var layer = L.Marker(latlng).addTo(map);
 * layer.addTo(map);
 * layer.remove();
 * ```
 *
 * @event add: Event
 * Fired after the layer is added to a map
 *
 * @event remove: Event
 * Fired after the layer is removed from a map
 */


L.Layer = L.Evented.extend({

	// Classes extending `L.Layer` will inherit the following options:
	options: {
		// @option pane: String = 'overlayPane'
		// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
		pane: 'overlayPane',
		nonBubblingEvents: [],  // Array of events that should not be bubbled to DOM parents (like the map),

		// @option attribution: String = null
		// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
		attribution: null
	},

	/* @section
	 * Classes extending `L.Layer` will inherit the following methods:
	 *
	 * @method addTo(map: Map): this
	 * Adds the layer to the given map
	 */
	addTo: function (map) {
		map.addLayer(this);
		return this;
	},

	// @method remove: this
	// Removes the layer from the map it is currently active on.
	remove: function () {
		return this.removeFrom(this._map || this._mapToAdd);
	},

	// @method removeFrom(map: Map): this
	// Removes the layer from the given map
	removeFrom: function (obj) {
		if (obj) {
			obj.removeLayer(this);
		}
		return this;
	},

	// @method getPane(name? : String): HTMLElement
	// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
	getPane: function (name) {
		return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
	},

	addInteractiveTarget: function (targetEl) {
		this._map._targets[L.stamp(targetEl)] = this;
		return this;
	},

	removeInteractiveTarget: function (targetEl) {
		delete this._map._targets[L.stamp(targetEl)];
		return this;
	},

	// @method getAttribution: String
	// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
	getAttribution: function () {
		return this.options.attribution;
	},

	_layerAdd: function (e) {
		var map = e.target;

		// check in case layer gets added and then removed before the map is ready
		if (!map.hasLayer(this)) { return; }

		this._map = map;
		this._zoomAnimated = map._zoomAnimated;

		if (this.getEvents) {
			var events = this.getEvents();
			map.on(events, this);
			this.once('remove', function () {
				map.off(events, this);
			}, this);
		}

		this.onAdd(map);

		if (this.getAttribution && map.attributionControl) {
			map.attributionControl.addAttribution(this.getAttribution());
		}

		this.fire('add');
		map.fire('layeradd', {layer: this});
	}
});

/* @section Extension methods
 * @uninheritable
 *
 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): this
 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
 *
 * @method onRemove(map: Map): this
 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
 *
 * @method getEvents(): Object
 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
 *
 * @method getAttribution(): String
 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
 *
 * @method beforeAdd(map: Map): this
 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
 */


/* @namespace Map
 * @section Layer events
 *
 * @event layeradd: LayerEvent
 * Fired when a new layer is added to the map.
 *
 * @event layerremove: LayerEvent
 * Fired when some layer is removed from the map
 *
 * @section Methods for Layers and Controls
 */
L.Map.include({
	// @method addLayer(layer: Layer): this
	// Adds the given layer to the map
	addLayer: function (layer) {
		var id = L.stamp(layer);
		if (this._layers[id]) { return this; }
		this._layers[id] = layer;

		layer._mapToAdd = this;

		if (layer.beforeAdd) {
			layer.beforeAdd(this);
		}

		this.whenReady(layer._layerAdd, layer);

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the map.
	removeLayer: function (layer) {
		var id = L.stamp(layer);

		if (!this._layers[id]) { return this; }

		if (this._loaded) {
			layer.onRemove(this);
		}

		if (layer.getAttribution && this.attributionControl) {
			this.attributionControl.removeAttribution(layer.getAttribution());
		}

		delete this._layers[id];

		if (this._loaded) {
			this.fire('layerremove', {layer: layer});
			layer.fire('remove');
		}

		layer._map = layer._mapToAdd = null;

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the map
	hasLayer: function (layer) {
		return !!layer && (L.stamp(layer) in this._layers);
	},

	/* @method eachLayer(fn: Function, context?: Object): this
	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
	 * ```
	 * map.eachLayer(function(layer){
	 *     layer.bindPopup('Hello');
	 * });
	 * ```
	 */
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	_addLayers: function (layers) {
		layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];

		for (var i = 0, len = layers.length; i < len; i++) {
			this.addLayer(layers[i]);
		}
	},

	_addZoomLimit: function (layer) {
		if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
			this._zoomBoundLayers[L.stamp(layer)] = layer;
			this._updateZoomLevels();
		}
	},

	_removeZoomLimit: function (layer) {
		var id = L.stamp(layer);

		if (this._zoomBoundLayers[id]) {
			delete this._zoomBoundLayers[id];
			this._updateZoomLevels();
		}
	},

	_updateZoomLevels: function () {
		var minZoom = Infinity,
		    maxZoom = -Infinity,
		    oldZoomSpan = this._getZoomSpan();

		for (var i in this._zoomBoundLayers) {
			var options = this._zoomBoundLayers[i].options;

			minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
			maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
		}

		this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
		this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;

		// @section Map state change events
		// @event zoomlevelschange: Event
		// Fired when the number of zoomlevels on the map is changed due
		// to adding or removing a layer.
		if (oldZoomSpan !== this._getZoomSpan()) {
			this.fire('zoomlevelschange');
		}

		if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
			this.setZoom(this._layersMaxZoom);
		}
		if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
			this.setZoom(this._layersMinZoom);
		}
	}
});



/*
 * @namespace DomEvent
 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
 */

// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.



var eventsKey = '_leaflet_events';

L.DomEvent = {

	// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Adds a listener function (`fn`) to a particular DOM event type of the
	// element `el`. You can optionally specify the context of the listener
	// (object the `this` keyword will point to). You can also pass several
	// space-separated types (e.g. `'click dblclick'`).

	// @alternative
	// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
	// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	on: function (obj, types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this._on(obj, type, types[type], fn);
			}
		} else {
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._on(obj, types[i], fn, context);
			}
		}

		return this;
	},

	// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
	// Removes a previously added listener function. If no function is specified,
	// it will remove all the listeners of that particular DOM event from the element.
	// Note that if you passed a custom context to on, you must pass the same
	// context to `off` in order to remove the listener.

	// @alternative
	// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
	// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
	off: function (obj, types, fn, context) {

		if (typeof types === 'object') {
			for (var type in types) {
				this._off(obj, type, types[type], fn);
			}
		} else {
			types = L.Util.splitWords(types);

			for (var i = 0, len = types.length; i < len; i++) {
				this._off(obj, types[i], fn, context);
			}
		}

		return this;
	},

	_on: function (obj, type, fn, context) {
		var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : '');

		if (obj[eventsKey] && obj[eventsKey][id]) { return this; }

		var handler = function (e) {
			return fn.call(context || obj, e || window.event);
		};

		var originalHandler = handler;

		if (L.Browser.pointer && type.indexOf('touch') === 0) {
			this.addPointerListener(obj, type, handler, id);

		} else if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener &&
		           !(L.Browser.pointer && L.Browser.chrome)) {
			// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
			// See #5180
			this.addDoubleTapListener(obj, handler, id);

		} else if ('addEventListener' in obj) {

			if (type === 'mousewheel') {
				obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

			} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
				handler = function (e) {
					e = e || window.event;
					if (L.DomEvent._isExternalTarget(obj, e)) {
						originalHandler(e);
					}
				};
				obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);

			} else {
				if (type === 'click' && L.Browser.android) {
					handler = function (e) {
						return L.DomEvent._filterClick(e, originalHandler);
					};
				}
				obj.addEventListener(type, handler, false);
			}

		} else if ('attachEvent' in obj) {
			obj.attachEvent('on' + type, handler);
		}

		obj[eventsKey] = obj[eventsKey] || {};
		obj[eventsKey][id] = handler;

		return this;
	},

	_off: function (obj, type, fn, context) {

		var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : ''),
		    handler = obj[eventsKey] && obj[eventsKey][id];

		if (!handler) { return this; }

		if (L.Browser.pointer && type.indexOf('touch') === 0) {
			this.removePointerListener(obj, type, id);

		} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
			this.removeDoubleTapListener(obj, id);

		} else if ('removeEventListener' in obj) {

			if (type === 'mousewheel') {
				obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);

			} else {
				obj.removeEventListener(
					type === 'mouseenter' ? 'mouseover' :
					type === 'mouseleave' ? 'mouseout' : type, handler, false);
			}

		} else if ('detachEvent' in obj) {
			obj.detachEvent('on' + type, handler);
		}

		obj[eventsKey][id] = null;

		return this;
	},

	// @function stopPropagation(ev: DOMEvent): this
	// Stop the given event from propagation to parent elements. Used inside the listener functions:
	// ```js
	// L.DomEvent.on(div, 'click', function (ev) {
	// 	L.DomEvent.stopPropagation(ev);
	// });
	// ```
	stopPropagation: function (e) {

		if (e.stopPropagation) {
			e.stopPropagation();
		} else if (e.originalEvent) {  // In case of Leaflet event.
			e.originalEvent._stopped = true;
		} else {
			e.cancelBubble = true;
		}
		L.DomEvent._skipped(e);

		return this;
	},

	// @function disableScrollPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
	disableScrollPropagation: function (el) {
		return L.DomEvent.on(el, 'mousewheel', L.DomEvent.stopPropagation);
	},

	// @function disableClickPropagation(el: HTMLElement): this
	// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
	// `'mousedown'` and `'touchstart'` events (plus browser variants).
	disableClickPropagation: function (el) {
		var stop = L.DomEvent.stopPropagation;

		L.DomEvent.on(el, L.Draggable.START.join(' '), stop);

		return L.DomEvent.on(el, {
			click: L.DomEvent._fakeStop,
			dblclick: stop
		});
	},

	// @function preventDefault(ev: DOMEvent): this
	// Prevents the default action of the DOM Event `ev` from happening (such as
	// following a link in the href of the a element, or doing a POST request
	// with page reload when a `<form>` is submitted).
	// Use it inside listener functions.
	preventDefault: function (e) {

		if (e.preventDefault) {
			e.preventDefault();
		} else {
			e.returnValue = false;
		}
		return this;
	},

	// @function stop(ev): this
	// Does `stopPropagation` and `preventDefault` at the same time.
	stop: function (e) {
		return L.DomEvent
			.preventDefault(e)
			.stopPropagation(e);
	},

	// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
	// Gets normalized mouse position from a DOM event relative to the
	// `container` or to the whole page if not specified.
	getMousePosition: function (e, container) {
		if (!container) {
			return new L.Point(e.clientX, e.clientY);
		}

		var rect = container.getBoundingClientRect();

		return new L.Point(
			e.clientX - rect.left - container.clientLeft,
			e.clientY - rect.top - container.clientTop);
	},

	// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
	// and Firefox scrolls device pixels, not CSS pixels
	_wheelPxFactor: (L.Browser.win && L.Browser.chrome) ? 2 :
	                L.Browser.gecko ? window.devicePixelRatio :
	                1,

	// @function getWheelDelta(ev: DOMEvent): Number
	// Gets normalized wheel delta from a mousewheel DOM event, in vertical
	// pixels scrolled (negative if scrolling down).
	// Events from pointing devices without precise scrolling are mapped to
	// a best guess of 60 pixels.
	getWheelDelta: function (e) {
		return (L.Browser.edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
		       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / L.DomEvent._wheelPxFactor : // Pixels
		       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
		       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
		       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
		       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
		       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
		       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
		       0;
	},

	_skipEvents: {},

	_fakeStop: function (e) {
		// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
		L.DomEvent._skipEvents[e.type] = true;
	},

	_skipped: function (e) {
		var skipped = this._skipEvents[e.type];
		// reset when checking, as it's only used in map container and propagates outside of the map
		this._skipEvents[e.type] = false;
		return skipped;
	},

	// check if element really left/entered the event target (for mouseenter/mouseleave)
	_isExternalTarget: function (el, e) {

		var related = e.relatedTarget;

		if (!related) { return true; }

		try {
			while (related && (related !== el)) {
				related = related.parentNode;
			}
		} catch (err) {
			return false;
		}
		return (related !== el);
	},

	// this is a horrible workaround for a bug in Android where a single touch triggers two click events
	_filterClick: function (e, handler) {
		var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
		    elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);

		// are they closer together than 500ms yet more than 100ms?
		// Android typically triggers them ~300ms apart while multiple listeners
		// on the same event should be triggered far faster;
		// or check if click is simulated on the element, and if it is, reject any non-simulated events

		if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
			L.DomEvent.stop(e);
			return;
		}
		L.DomEvent._lastClick = timeStamp;

		handler(e);
	}
};

// @function addListener(…): this
// Alias to [`L.DomEvent.on`](#domevent-on)
L.DomEvent.addListener = L.DomEvent.on;

// @function removeListener(…): this
// Alias to [`L.DomEvent.off`](#domevent-off)
L.DomEvent.removeListener = L.DomEvent.off;



/*
 * @class PosAnimation
 * @aka L.PosAnimation
 * @inherits Evented
 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
 *
 * @example
 * ```js
 * var fx = new L.PosAnimation();
 * fx.run(el, [300, 500], 0.5);
 * ```
 *
 * @constructor L.PosAnimation()
 * Creates a `PosAnimation` object.
 *
 */

L.PosAnimation = L.Evented.extend({

	// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
	// Run an animation of a given element to a new position, optionally setting
	// duration in seconds (`0.25` by default) and easing linearity factor (3rd
	// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
	// `0.5` by default).
	run: function (el, newPos, duration, easeLinearity) {
		this.stop();

		this._el = el;
		this._inProgress = true;
		this._duration = duration || 0.25;
		this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);

		this._startPos = L.DomUtil.getPosition(el);
		this._offset = newPos.subtract(this._startPos);
		this._startTime = +new Date();

		// @event start: Event
		// Fired when the animation starts
		this.fire('start');

		this._animate();
	},

	// @method stop()
	// Stops the animation (if currently running).
	stop: function () {
		if (!this._inProgress) { return; }

		this._step(true);
		this._complete();
	},

	_animate: function () {
		// animation loop
		this._animId = L.Util.requestAnimFrame(this._animate, this);
		this._step();
	},

	_step: function (round) {
		var elapsed = (+new Date()) - this._startTime,
		    duration = this._duration * 1000;

		if (elapsed < duration) {
			this._runFrame(this._easeOut(elapsed / duration), round);
		} else {
			this._runFrame(1);
			this._complete();
		}
	},

	_runFrame: function (progress, round) {
		var pos = this._startPos.add(this._offset.multiplyBy(progress));
		if (round) {
			pos._round();
		}
		L.DomUtil.setPosition(this._el, pos);

		// @event step: Event
		// Fired continuously during the animation.
		this.fire('step');
	},

	_complete: function () {
		L.Util.cancelAnimFrame(this._animId);

		this._inProgress = false;
		// @event end: Event
		// Fired when the animation ends.
		this.fire('end');
	},

	_easeOut: function (t) {
		return 1 - Math.pow(1 - t, this._easeOutPower);
	}
});



/*
 * @namespace Projection
 * @projection L.Projection.Mercator
 *
 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
 */

L.Projection.Mercator = {
	R: 6378137,
	R_MINOR: 6356752.314245179,

	bounds: L.bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),

	project: function (latlng) {
		var d = Math.PI / 180,
		    r = this.R,
		    y = latlng.lat * d,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    con = e * Math.sin(y);

		var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
		y = -r * Math.log(Math.max(ts, 1E-10));

		return new L.Point(latlng.lng * d * r, y);
	},

	unproject: function (point) {
		var d = 180 / Math.PI,
		    r = this.R,
		    tmp = this.R_MINOR / r,
		    e = Math.sqrt(1 - tmp * tmp),
		    ts = Math.exp(-point.y / r),
		    phi = Math.PI / 2 - 2 * Math.atan(ts);

		for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
			con = e * Math.sin(phi);
			con = Math.pow((1 - con) / (1 + con), e / 2);
			dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
			phi += dphi;
		}

		return new L.LatLng(phi * d, point.x * d / r);
	}
};



/*
 * @namespace CRS
 * @crs L.CRS.EPSG3395
 *
 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
 */

L.CRS.EPSG3395 = L.extend({}, L.CRS.Earth, {
	code: 'EPSG:3395',
	projection: L.Projection.Mercator,

	transformation: (function () {
		var scale = 0.5 / (Math.PI * L.Projection.Mercator.R);
		return new L.Transformation(scale, 0.5, -scale, 0.5);
	}())
});



/*
 * @class GridLayer
 * @inherits Layer
 * @aka L.GridLayer
 *
 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
 *
 *
 * @section Synchronous usage
 * @example
 *
 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords){
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
 *         var ctx = tile.getContext('2d');
 *
 *         // return the tile so it can be rendered on screen
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section Asynchronous usage
 * @example
 *
 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
 *
 * ```js
 * var CanvasLayer = L.GridLayer.extend({
 *     createTile: function(coords, done){
 *         var error;
 *
 *         // create a <canvas> element for drawing
 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
 *
 *         // setup tile width and height according to the options
 *         var size = this.getTileSize();
 *         tile.width = size.x;
 *         tile.height = size.y;
 *
 *         // draw something asynchronously and pass the tile to the done() callback
 *         setTimeout(function() {
 *             done(error, tile);
 *         }, 1000);
 *
 *         return tile;
 *     }
 * });
 * ```
 *
 * @section
 */


L.GridLayer = L.Layer.extend({

	// @section
	// @aka GridLayer options
	options: {
		// @option tileSize: Number|Point = 256
		// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
		tileSize: 256,

		// @option opacity: Number = 1.0
		// Opacity of the tiles. Can be used in the `createTile()` function.
		opacity: 1,

		// @option updateWhenIdle: Boolean = depends
		// If `false`, new tiles are loaded during panning, otherwise only after it (for better performance). `true` by default on mobile browsers, otherwise `false`.
		updateWhenIdle: L.Browser.mobile,

		// @option updateWhenZooming: Boolean = true
		// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
		updateWhenZooming: true,

		// @option updateInterval: Number = 200
		// Tiles will not update more than once every `updateInterval` milliseconds when panning.
		updateInterval: 200,

		// @option zIndex: Number = 1
		// The explicit zIndex of the tile layer.
		zIndex: 1,

		// @option bounds: LatLngBounds = undefined
		// If set, tiles will only be loaded inside the set `LatLngBounds`.
		bounds: null,

		// @option minZoom: Number = 0
		// The minimum zoom level that tiles will be loaded at. By default the entire map.
		minZoom: 0,

		// @option maxZoom: Number = undefined
		// The maximum zoom level that tiles will be loaded at.
		maxZoom: undefined,

		// @option noWrap: Boolean = false
		// Whether the layer is wrapped around the antimeridian. If `true`, the
		// GridLayer will only be displayed once at low zoom levels. Has no
		// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
		// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
		// tiles outside the CRS limits.
		noWrap: false,

		// @option pane: String = 'tilePane'
		// `Map pane` where the grid layer will be added.
		pane: 'tilePane',

		// @option className: String = ''
		// A custom class name to assign to the tile layer. Empty by default.
		className: '',

		// @option keepBuffer: Number = 2
		// When panning the map, keep this many rows and columns of tiles before unloading them.
		keepBuffer: 2
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	onAdd: function () {
		this._initContainer();

		this._levels = {};
		this._tiles = {};

		this._resetView();
		this._update();
	},

	beforeAdd: function (map) {
		map._addZoomLimit(this);
	},

	onRemove: function (map) {
		this._removeAllTiles();
		L.DomUtil.remove(this._container);
		map._removeZoomLimit(this);
		this._container = null;
		this._tileZoom = null;
	},

	// @method bringToFront: this
	// Brings the tile layer to the top of all tile layers.
	bringToFront: function () {
		if (this._map) {
			L.DomUtil.toFront(this._container);
			this._setAutoZIndex(Math.max);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings the tile layer to the bottom of all tile layers.
	bringToBack: function () {
		if (this._map) {
			L.DomUtil.toBack(this._container);
			this._setAutoZIndex(Math.min);
		}
		return this;
	},

	// @method getContainer: HTMLElement
	// Returns the HTML element that contains the tiles for this layer.
	getContainer: function () {
		return this._container;
	},

	// @method setOpacity(opacity: Number): this
	// Changes the [opacity](#gridlayer-opacity) of the grid layer.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		this._updateOpacity();
		return this;
	},

	// @method setZIndex(zIndex: Number): this
	// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
	setZIndex: function (zIndex) {
		this.options.zIndex = zIndex;
		this._updateZIndex();

		return this;
	},

	// @method isLoading: Boolean
	// Returns `true` if any tile in the grid layer has not finished loading.
	isLoading: function () {
		return this._loading;
	},

	// @method redraw: this
	// Causes the layer to clear all the tiles and request them again.
	redraw: function () {
		if (this._map) {
			this._removeAllTiles();
			this._update();
		}
		return this;
	},

	getEvents: function () {
		var events = {
			viewprereset: this._invalidateAll,
			viewreset: this._resetView,
			zoom: this._resetView,
			moveend: this._onMoveEnd
		};

		if (!this.options.updateWhenIdle) {
			// update tiles on move, but not more often than once per given interval
			if (!this._onMove) {
				this._onMove = L.Util.throttle(this._onMoveEnd, this.options.updateInterval, this);
			}

			events.move = this._onMove;
		}

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	// @section Extension methods
	// Layers extending `GridLayer` shall reimplement the following method.
	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, must be overriden by classes extending `GridLayer`.
	// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
	// is specified, it must be called when the tile has finished loading and drawing.
	createTile: function () {
		return document.createElement('div');
	},

	// @section
	// @method getTileSize: Point
	// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
	getTileSize: function () {
		var s = this.options.tileSize;
		return s instanceof L.Point ? s : new L.Point(s, s);
	},

	_updateZIndex: function () {
		if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
			this._container.style.zIndex = this.options.zIndex;
		}
	},

	_setAutoZIndex: function (compare) {
		// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)

		var layers = this.getPane().children,
		    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min

		for (var i = 0, len = layers.length, zIndex; i < len; i++) {

			zIndex = layers[i].style.zIndex;

			if (layers[i] !== this._container && zIndex) {
				edgeZIndex = compare(edgeZIndex, +zIndex);
			}
		}

		if (isFinite(edgeZIndex)) {
			this.options.zIndex = edgeZIndex + compare(-1, 1);
			this._updateZIndex();
		}
	},

	_updateOpacity: function () {
		if (!this._map) { return; }

		// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
		if (L.Browser.ielt9) { return; }

		L.DomUtil.setOpacity(this._container, this.options.opacity);

		var now = +new Date(),
		    nextFrame = false,
		    willPrune = false;

		for (var key in this._tiles) {
			var tile = this._tiles[key];
			if (!tile.current || !tile.loaded) { continue; }

			var fade = Math.min(1, (now - tile.loaded) / 200);

			L.DomUtil.setOpacity(tile.el, fade);
			if (fade < 1) {
				nextFrame = true;
			} else {
				if (tile.active) { willPrune = true; }
				tile.active = true;
			}
		}

		if (willPrune && !this._noPrune) { this._pruneTiles(); }

		if (nextFrame) {
			L.Util.cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
		}
	},

	_initContainer: function () {
		if (this._container) { return; }

		this._container = L.DomUtil.create('div', 'leaflet-layer ' + (this.options.className || ''));
		this._updateZIndex();

		if (this.options.opacity < 1) {
			this._updateOpacity();
		}

		this.getPane().appendChild(this._container);
	},

	_updateLevels: function () {

		var zoom = this._tileZoom,
		    maxZoom = this.options.maxZoom;

		if (zoom === undefined) { return undefined; }

		for (var z in this._levels) {
			if (this._levels[z].el.children.length || z === zoom) {
				this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
			} else {
				L.DomUtil.remove(this._levels[z].el);
				this._removeTilesAtZoom(z);
				delete this._levels[z];
			}
		}

		var level = this._levels[zoom],
		    map = this._map;

		if (!level) {
			level = this._levels[zoom] = {};

			level.el = L.DomUtil.create('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
			level.el.style.zIndex = maxZoom;

			level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
			level.zoom = zoom;

			this._setZoomTransform(level, map.getCenter(), map.getZoom());

			// force the browser to consider the newly added element for transition
			L.Util.falseFn(level.el.offsetWidth);
		}

		this._level = level;

		return level;
	},

	_pruneTiles: function () {
		if (!this._map) {
			return;
		}

		var key, tile;

		var zoom = this._map.getZoom();
		if (zoom > this.options.maxZoom ||
			zoom < this.options.minZoom) {
			this._removeAllTiles();
			return;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			tile.retain = tile.current;
		}

		for (key in this._tiles) {
			tile = this._tiles[key];
			if (tile.current && !tile.active) {
				var coords = tile.coords;
				if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
					this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
				}
			}
		}

		for (key in this._tiles) {
			if (!this._tiles[key].retain) {
				this._removeTile(key);
			}
		}
	},

	_removeTilesAtZoom: function (zoom) {
		for (var key in this._tiles) {
			if (this._tiles[key].coords.z !== zoom) {
				continue;
			}
			this._removeTile(key);
		}
	},

	_removeAllTiles: function () {
		for (var key in this._tiles) {
			this._removeTile(key);
		}
	},

	_invalidateAll: function () {
		for (var z in this._levels) {
			L.DomUtil.remove(this._levels[z].el);
			delete this._levels[z];
		}
		this._removeAllTiles();

		this._tileZoom = null;
	},

	_retainParent: function (x, y, z, minZoom) {
		var x2 = Math.floor(x / 2),
		    y2 = Math.floor(y / 2),
		    z2 = z - 1,
		    coords2 = new L.Point(+x2, +y2);
		coords2.z = +z2;

		var key = this._tileCoordsToKey(coords2),
		    tile = this._tiles[key];

		if (tile && tile.active) {
			tile.retain = true;
			return true;

		} else if (tile && tile.loaded) {
			tile.retain = true;
		}

		if (z2 > minZoom) {
			return this._retainParent(x2, y2, z2, minZoom);
		}

		return false;
	},

	_retainChildren: function (x, y, z, maxZoom) {

		for (var i = 2 * x; i < 2 * x + 2; i++) {
			for (var j = 2 * y; j < 2 * y + 2; j++) {

				var coords = new L.Point(i, j);
				coords.z = z + 1;

				var key = this._tileCoordsToKey(coords),
				    tile = this._tiles[key];

				if (tile && tile.active) {
					tile.retain = true;
					continue;

				} else if (tile && tile.loaded) {
					tile.retain = true;
				}

				if (z + 1 < maxZoom) {
					this._retainChildren(i, j, z + 1, maxZoom);
				}
			}
		}
	},

	_resetView: function (e) {
		var animating = e && (e.pinch || e.flyTo);
		this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
	},

	_animateZoom: function (e) {
		this._setView(e.center, e.zoom, true, e.noUpdate);
	},

	_setView: function (center, zoom, noPrune, noUpdate) {
		var tileZoom = Math.round(zoom);
		if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
		    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
			tileZoom = undefined;
		}

		var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);

		if (!noUpdate || tileZoomChanged) {

			this._tileZoom = tileZoom;

			if (this._abortLoading) {
				this._abortLoading();
			}

			this._updateLevels();
			this._resetGrid();

			if (tileZoom !== undefined) {
				this._update(center);
			}

			if (!noPrune) {
				this._pruneTiles();
			}

			// Flag to prevent _updateOpacity from pruning tiles during
			// a zoom anim or a pinch gesture
			this._noPrune = !!noPrune;
		}

		this._setZoomTransforms(center, zoom);
	},

	_setZoomTransforms: function (center, zoom) {
		for (var i in this._levels) {
			this._setZoomTransform(this._levels[i], center, zoom);
		}
	},

	_setZoomTransform: function (level, center, zoom) {
		var scale = this._map.getZoomScale(zoom, level.zoom),
		    translate = level.origin.multiplyBy(scale)
		        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();

		if (L.Browser.any3d) {
			L.DomUtil.setTransform(level.el, translate, scale);
		} else {
			L.DomUtil.setPosition(level.el, translate);
		}
	},

	_resetGrid: function () {
		var map = this._map,
		    crs = map.options.crs,
		    tileSize = this._tileSize = this.getTileSize(),
		    tileZoom = this._tileZoom;

		var bounds = this._map.getPixelWorldBounds(this._tileZoom);
		if (bounds) {
			this._globalTileRange = this._pxBoundsToTileRange(bounds);
		}

		this._wrapX = crs.wrapLng && !this.options.noWrap && [
			Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
			Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
		];
		this._wrapY = crs.wrapLat && !this.options.noWrap && [
			Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
			Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
		];
	},

	_onMoveEnd: function () {
		if (!this._map || this._map._animatingZoom) { return; }

		this._update();
	},

	_getTiledPixelBounds: function (center) {
		var map = this._map,
		    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
		    scale = map.getZoomScale(mapZoom, this._tileZoom),
		    pixelCenter = map.project(center, this._tileZoom).floor(),
		    halfSize = map.getSize().divideBy(scale * 2);

		return new L.Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
	},

	// Private method to load tiles in the grid's active zoom level according to map bounds
	_update: function (center) {
		var map = this._map;
		if (!map) { return; }
		var zoom = map.getZoom();

		if (center === undefined) { center = map.getCenter(); }
		if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom

		var pixelBounds = this._getTiledPixelBounds(center),
		    tileRange = this._pxBoundsToTileRange(pixelBounds),
		    tileCenter = tileRange.getCenter(),
		    queue = [],
		    margin = this.options.keepBuffer,
		    noPruneRange = new L.Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
		                              tileRange.getTopRight().add([margin, -margin]));

		for (var key in this._tiles) {
			var c = this._tiles[key].coords;
			if (c.z !== this._tileZoom || !noPruneRange.contains(L.point(c.x, c.y))) {
				this._tiles[key].current = false;
			}
		}

		// _update just loads more tiles. If the tile zoom level differs too much
		// from the map's, let _setView reset levels and prune old tiles.
		if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }

		// create a queue of coordinates to load tiles from
		for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
			for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
				var coords = new L.Point(i, j);
				coords.z = this._tileZoom;

				if (!this._isValidTile(coords)) { continue; }

				var tile = this._tiles[this._tileCoordsToKey(coords)];
				if (tile) {
					tile.current = true;
				} else {
					queue.push(coords);
				}
			}
		}

		// sort tile queue to load tiles in order of their distance to center
		queue.sort(function (a, b) {
			return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
		});

		if (queue.length !== 0) {
			// if it's the first batch of tiles to load
			if (!this._loading) {
				this._loading = true;
				// @event loading: Event
				// Fired when the grid layer starts loading tiles.
				this.fire('loading');
			}

			// create DOM fragment to append tiles in one batch
			var fragment = document.createDocumentFragment();

			for (i = 0; i < queue.length; i++) {
				this._addTile(queue[i], fragment);
			}

			this._level.el.appendChild(fragment);
		}
	},

	_isValidTile: function (coords) {
		var crs = this._map.options.crs;

		if (!crs.infinite) {
			// don't load tile if it's out of bounds and not wrapped
			var bounds = this._globalTileRange;
			if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
			    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
		}

		if (!this.options.bounds) { return true; }

		// don't load tile if it doesn't intersect the bounds in options
		var tileBounds = this._tileCoordsToBounds(coords);
		return L.latLngBounds(this.options.bounds).overlaps(tileBounds);
	},

	_keyToBounds: function (key) {
		return this._tileCoordsToBounds(this._keyToTileCoords(key));
	},

	// converts tile coordinates to its geographical bounds
	_tileCoordsToBounds: function (coords) {

		var map = this._map,
		    tileSize = this.getTileSize(),

		    nwPoint = coords.scaleBy(tileSize),
		    sePoint = nwPoint.add(tileSize),

		    nw = map.unproject(nwPoint, coords.z),
		    se = map.unproject(sePoint, coords.z),
		    bounds = new L.LatLngBounds(nw, se);

		if (!this.options.noWrap) {
			map.wrapLatLngBounds(bounds);
		}

		return bounds;
	},

	// converts tile coordinates to key for the tile cache
	_tileCoordsToKey: function (coords) {
		return coords.x + ':' + coords.y + ':' + coords.z;
	},

	// converts tile cache key to coordinates
	_keyToTileCoords: function (key) {
		var k = key.split(':'),
		    coords = new L.Point(+k[0], +k[1]);
		coords.z = +k[2];
		return coords;
	},

	_removeTile: function (key) {
		var tile = this._tiles[key];
		if (!tile) { return; }

		L.DomUtil.remove(tile.el);

		delete this._tiles[key];

		// @event tileunload: TileEvent
		// Fired when a tile is removed (e.g. when a tile goes off the screen).
		this.fire('tileunload', {
			tile: tile.el,
			coords: this._keyToTileCoords(key)
		});
	},

	_initTile: function (tile) {
		L.DomUtil.addClass(tile, 'leaflet-tile');

		var tileSize = this.getTileSize();
		tile.style.width = tileSize.x + 'px';
		tile.style.height = tileSize.y + 'px';

		tile.onselectstart = L.Util.falseFn;
		tile.onmousemove = L.Util.falseFn;

		// update opacity on tiles in IE7-8 because of filter inheritance problems
		if (L.Browser.ielt9 && this.options.opacity < 1) {
			L.DomUtil.setOpacity(tile, this.options.opacity);
		}

		// without this hack, tiles disappear after zoom on Chrome for Android
		// https://github.com/Leaflet/Leaflet/issues/2078
		if (L.Browser.android && !L.Browser.android23) {
			tile.style.WebkitBackfaceVisibility = 'hidden';
		}
	},

	_addTile: function (coords, container) {
		var tilePos = this._getTilePos(coords),
		    key = this._tileCoordsToKey(coords);

		var tile = this.createTile(this._wrapCoords(coords), L.bind(this._tileReady, this, coords));

		this._initTile(tile);

		// if createTile is defined with a second argument ("done" callback),
		// we know that tile is async and will be ready later; otherwise
		if (this.createTile.length < 2) {
			// mark tile as ready, but delay one frame for opacity animation to happen
			L.Util.requestAnimFrame(L.bind(this._tileReady, this, coords, null, tile));
		}

		L.DomUtil.setPosition(tile, tilePos);

		// save tile in cache
		this._tiles[key] = {
			el: tile,
			coords: coords,
			current: true
		};

		container.appendChild(tile);
		// @event tileloadstart: TileEvent
		// Fired when a tile is requested and starts loading.
		this.fire('tileloadstart', {
			tile: tile,
			coords: coords
		});
	},

	_tileReady: function (coords, err, tile) {
		if (!this._map) { return; }

		if (err) {
			// @event tileerror: TileErrorEvent
			// Fired when there is an error loading a tile.
			this.fire('tileerror', {
				error: err,
				tile: tile,
				coords: coords
			});
		}

		var key = this._tileCoordsToKey(coords);

		tile = this._tiles[key];
		if (!tile) { return; }

		tile.loaded = +new Date();
		if (this._map._fadeAnimated) {
			L.DomUtil.setOpacity(tile.el, 0);
			L.Util.cancelAnimFrame(this._fadeFrame);
			this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
		} else {
			tile.active = true;
			this._pruneTiles();
		}

		if (!err) {
			L.DomUtil.addClass(tile.el, 'leaflet-tile-loaded');

			// @event tileload: TileEvent
			// Fired when a tile loads.
			this.fire('tileload', {
				tile: tile.el,
				coords: coords
			});
		}

		if (this._noTilesToLoad()) {
			this._loading = false;
			// @event load: Event
			// Fired when the grid layer loaded all visible tiles.
			this.fire('load');

			if (L.Browser.ielt9 || !this._map._fadeAnimated) {
				L.Util.requestAnimFrame(this._pruneTiles, this);
			} else {
				// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
				// to trigger a pruning.
				setTimeout(L.bind(this._pruneTiles, this), 250);
			}
		}
	},

	_getTilePos: function (coords) {
		return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
	},

	_wrapCoords: function (coords) {
		var newCoords = new L.Point(
			this._wrapX ? L.Util.wrapNum(coords.x, this._wrapX) : coords.x,
			this._wrapY ? L.Util.wrapNum(coords.y, this._wrapY) : coords.y);
		newCoords.z = coords.z;
		return newCoords;
	},

	_pxBoundsToTileRange: function (bounds) {
		var tileSize = this.getTileSize();
		return new L.Bounds(
			bounds.min.unscaleBy(tileSize).floor(),
			bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
	},

	_noTilesToLoad: function () {
		for (var key in this._tiles) {
			if (!this._tiles[key].loaded) { return false; }
		}
		return true;
	}
});

// @factory L.gridLayer(options?: GridLayer options)
// Creates a new instance of GridLayer with the supplied options.
L.gridLayer = function (options) {
	return new L.GridLayer(options);
};



/*
 * @class TileLayer
 * @inherits GridLayer
 * @aka L.TileLayer
 * Used to load and display tile layers on the map. Extends `GridLayer`.
 *
 * @example
 *
 * ```js
 * L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
 * ```
 *
 * @section URL template
 * @example
 *
 * A string of the following form:
 *
 * ```
 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
 * ```
 *
 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add @2x to the URL to load retina tiles.
 *
 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
 *
 * ```
 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
 * ```
 */


L.TileLayer = L.GridLayer.extend({

	// @section
	// @aka TileLayer options
	options: {
		// @option minZoom: Number = 0
		// Minimum zoom number.
		minZoom: 0,

		// @option maxZoom: Number = 18
		// Maximum zoom number.
		maxZoom: 18,

		// @option maxNativeZoom: Number = null
		// Maximum zoom number the tile source has available. If it is specified,
		// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
		// from `maxNativeZoom` level and auto-scaled.
		maxNativeZoom: null,

		// @option minNativeZoom: Number = null
		// Minimum zoom number the tile source has available. If it is specified,
		// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
		// from `minNativeZoom` level and auto-scaled.
		minNativeZoom: null,

		// @option subdomains: String|String[] = 'abc'
		// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
		subdomains: 'abc',

		// @option errorTileUrl: String = ''
		// URL to the tile image to show in place of the tile that failed to load.
		errorTileUrl: '',

		// @option zoomOffset: Number = 0
		// The zoom number used in tile URLs will be offset with this value.
		zoomOffset: 0,

		// @option tms: Boolean = false
		// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
		tms: false,

		// @option zoomReverse: Boolean = false
		// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
		zoomReverse: false,

		// @option detectRetina: Boolean = false
		// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
		detectRetina: false,

		// @option crossOrigin: Boolean = false
		// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
		crossOrigin: false
	},

	initialize: function (url, options) {

		this._url = url;

		options = L.setOptions(this, options);

		// detecting retina displays, adjusting tileSize and zoom levels
		if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {

			options.tileSize = Math.floor(options.tileSize / 2);

			if (!options.zoomReverse) {
				options.zoomOffset++;
				options.maxZoom--;
			} else {
				options.zoomOffset--;
				options.minZoom++;
			}

			options.minZoom = Math.max(0, options.minZoom);
		}

		if (typeof options.subdomains === 'string') {
			options.subdomains = options.subdomains.split('');
		}

		// for https://github.com/Leaflet/Leaflet/issues/137
		if (!L.Browser.android) {
			this.on('tileunload', this._onTileRemove);
		}
	},

	// @method setUrl(url: String, noRedraw?: Boolean): this
	// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
	setUrl: function (url, noRedraw) {
		this._url = url;

		if (!noRedraw) {
			this.redraw();
		}
		return this;
	},

	// @method createTile(coords: Object, done?: Function): HTMLElement
	// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
	// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
	// callback is called when the tile has been loaded.
	createTile: function (coords, done) {
		var tile = document.createElement('img');

		L.DomEvent.on(tile, 'load', L.bind(this._tileOnLoad, this, done, tile));
		L.DomEvent.on(tile, 'error', L.bind(this._tileOnError, this, done, tile));

		if (this.options.crossOrigin) {
			tile.crossOrigin = '';
		}

		/*
		 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
		 http://www.w3.org/TR/WCAG20-TECHS/H67
		*/
		tile.alt = '';

		/*
		 Set role="presentation" to force screen readers to ignore this
		 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
		*/
		tile.setAttribute('role', 'presentation');

		tile.src = this.getTileUrl(coords);

		return tile;
	},

	// @section Extension methods
	// @uninheritable
	// Layers extending `TileLayer` might reimplement the following method.
	// @method getTileUrl(coords: Object): String
	// Called only internally, returns the URL for a tile given its coordinates.
	// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
	getTileUrl: function (coords) {
		var data = {
			r: L.Browser.retina ? '@2x' : '',
			s: this._getSubdomain(coords),
			x: coords.x,
			y: coords.y,
			z: this._getZoomForUrl()
		};
		if (this._map && !this._map.options.crs.infinite) {
			var invertedY = this._globalTileRange.max.y - coords.y;
			if (this.options.tms) {
				data['y'] = invertedY;
			}
			data['-y'] = invertedY;
		}

		return L.Util.template(this._url, L.extend(data, this.options));
	},

	_tileOnLoad: function (done, tile) {
		// For https://github.com/Leaflet/Leaflet/issues/3332
		if (L.Browser.ielt9) {
			setTimeout(L.bind(done, this, null, tile), 0);
		} else {
			done(null, tile);
		}
	},

	_tileOnError: function (done, tile, e) {
		var errorUrl = this.options.errorTileUrl;
		if (errorUrl && tile.src !== errorUrl) {
			tile.src = errorUrl;
		}
		done(e, tile);
	},

	getTileSize: function () {
		var map = this._map,
		tileSize = L.GridLayer.prototype.getTileSize.call(this),
		zoom = this._tileZoom + this.options.zoomOffset,
		minNativeZoom = this.options.minNativeZoom,
		maxNativeZoom = this.options.maxNativeZoom;

		// decrease tile size when scaling below minNativeZoom
		if (minNativeZoom !== null && zoom < minNativeZoom) {
			return tileSize.divideBy(map.getZoomScale(minNativeZoom, zoom)).round();
		}

		// increase tile size when scaling above maxNativeZoom
		if (maxNativeZoom !== null && zoom > maxNativeZoom) {
			return tileSize.divideBy(map.getZoomScale(maxNativeZoom, zoom)).round();
		}

		return tileSize;
	},

	_onTileRemove: function (e) {
		e.tile.onload = null;
	},

	_getZoomForUrl: function () {
		var zoom = this._tileZoom,
		maxZoom = this.options.maxZoom,
		zoomReverse = this.options.zoomReverse,
		zoomOffset = this.options.zoomOffset,
		minNativeZoom = this.options.minNativeZoom,
		maxNativeZoom = this.options.maxNativeZoom;

		if (zoomReverse) {
			zoom = maxZoom - zoom;
		}

		zoom += zoomOffset;

		if (minNativeZoom !== null && zoom < minNativeZoom) {
			return minNativeZoom;
		}

		if (maxNativeZoom !== null && zoom > maxNativeZoom) {
			return maxNativeZoom;
		}

		return zoom;
	},

	_getSubdomain: function (tilePoint) {
		var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
		return this.options.subdomains[index];
	},

	// stops loading all tiles in the background layer
	_abortLoading: function () {
		var i, tile;
		for (i in this._tiles) {
			if (this._tiles[i].coords.z !== this._tileZoom) {
				tile = this._tiles[i].el;

				tile.onload = L.Util.falseFn;
				tile.onerror = L.Util.falseFn;

				if (!tile.complete) {
					tile.src = L.Util.emptyImageUrl;
					L.DomUtil.remove(tile);
				}
			}
		}
	}
});


// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
// Instantiates a tile layer object given a `URL template` and optionally an options object.

L.tileLayer = function (url, options) {
	return new L.TileLayer(url, options);
};



/*
 * @class TileLayer.WMS
 * @inherits TileLayer
 * @aka L.TileLayer.WMS
 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
 *
 * @example
 *
 * ```js
 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
 * 	layers: 'nexrad-n0r-900913',
 * 	format: 'image/png',
 * 	transparent: true,
 * 	attribution: "Weather data © 2012 IEM Nexrad"
 * });
 * ```
 */

L.TileLayer.WMS = L.TileLayer.extend({

	// @section
	// @aka TileLayer.WMS options
	// If any custom options not documented here are used, they will be sent to the
	// WMS server as extra parameters in each request URL. This can be useful for
	// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
	defaultWmsParams: {
		service: 'WMS',
		request: 'GetMap',

		// @option layers: String = ''
		// **(required)** Comma-separated list of WMS layers to show.
		layers: '',

		// @option styles: String = ''
		// Comma-separated list of WMS styles.
		styles: '',

		// @option format: String = 'image/jpeg'
		// WMS image format (use `'image/png'` for layers with transparency).
		format: 'image/jpeg',

		// @option transparent: Boolean = false
		// If `true`, the WMS service will return images with transparency.
		transparent: false,

		// @option version: String = '1.1.1'
		// Version of the WMS service to use
		version: '1.1.1'
	},

	options: {
		// @option crs: CRS = null
		// Coordinate Reference System to use for the WMS requests, defaults to
		// map CRS. Don't change this if you're not sure what it means.
		crs: null,

		// @option uppercase: Boolean = false
		// If `true`, WMS request parameter keys will be uppercase.
		uppercase: false
	},

	initialize: function (url, options) {

		this._url = url;

		var wmsParams = L.extend({}, this.defaultWmsParams);

		// all keys that are not TileLayer options go to WMS params
		for (var i in options) {
			if (!(i in this.options)) {
				wmsParams[i] = options[i];
			}
		}

		options = L.setOptions(this, options);

		wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && L.Browser.retina ? 2 : 1);

		this.wmsParams = wmsParams;
	},

	onAdd: function (map) {

		this._crs = this.options.crs || map.options.crs;
		this._wmsVersion = parseFloat(this.wmsParams.version);

		var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
		this.wmsParams[projectionKey] = this._crs.code;

		L.TileLayer.prototype.onAdd.call(this, map);
	},

	getTileUrl: function (coords) {

		var tileBounds = this._tileCoordsToBounds(coords),
		    nw = this._crs.project(tileBounds.getNorthWest()),
		    se = this._crs.project(tileBounds.getSouthEast()),

		    bbox = (this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
			    [se.y, nw.x, nw.y, se.x] :
			    [nw.x, se.y, se.x, nw.y]).join(','),

		    url = L.TileLayer.prototype.getTileUrl.call(this, coords);

		return url +
			L.Util.getParamString(this.wmsParams, url, this.options.uppercase) +
			(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
	},

	// @method setParams(params: Object, noRedraw?: Boolean): this
	// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
	setParams: function (params, noRedraw) {

		L.extend(this.wmsParams, params);

		if (!noRedraw) {
			this.redraw();
		}

		return this;
	}
});


// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
L.tileLayer.wms = function (url, options) {
	return new L.TileLayer.WMS(url, options);
};



/*
 * @class ImageOverlay
 * @aka L.ImageOverlay
 * @inherits Interactive layer
 *
 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
 * ```
 */

L.ImageOverlay = L.Layer.extend({

	// @section
	// @aka ImageOverlay options
	options: {
		// @option opacity: Number = 1.0
		// The opacity of the image overlay.
		opacity: 1,

		// @option alt: String = ''
		// Text for the `alt` attribute of the image (useful for accessibility).
		alt: '',

		// @option interactive: Boolean = false
		// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
		interactive: false,

		// @option crossOrigin: Boolean = false
		// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
		crossOrigin: false
	},

	initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
		this._url = url;
		this._bounds = L.latLngBounds(bounds);

		L.setOptions(this, options);
	},

	onAdd: function () {
		if (!this._image) {
			this._initImage();

			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
		}

		if (this.options.interactive) {
			L.DomUtil.addClass(this._image, 'leaflet-interactive');
			this.addInteractiveTarget(this._image);
		}

		this.getPane().appendChild(this._image);
		this._reset();
	},

	onRemove: function () {
		L.DomUtil.remove(this._image);
		if (this.options.interactive) {
			this.removeInteractiveTarget(this._image);
		}
	},

	// @method setOpacity(opacity: Number): this
	// Sets the opacity of the overlay.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._image) {
			this._updateOpacity();
		}
		return this;
	},

	setStyle: function (styleOpts) {
		if (styleOpts.opacity) {
			this.setOpacity(styleOpts.opacity);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all overlays.
	bringToFront: function () {
		if (this._map) {
			L.DomUtil.toFront(this._image);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all overlays.
	bringToBack: function () {
		if (this._map) {
			L.DomUtil.toBack(this._image);
		}
		return this;
	},

	// @method setUrl(url: String): this
	// Changes the URL of the image.
	setUrl: function (url) {
		this._url = url;

		if (this._image) {
			this._image.src = url;
		}
		return this;
	},

	// @method setBounds(bounds: LatLngBounds): this
	// Update the bounds that this ImageOverlay covers
	setBounds: function (bounds) {
		this._bounds = bounds;

		if (this._map) {
			this._reset();
		}
		return this;
	},

	getEvents: function () {
		var events = {
			zoom: this._reset,
			viewreset: this._reset
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}

		return events;
	},

	// @method getBounds(): LatLngBounds
	// Get the bounds that this ImageOverlay covers
	getBounds: function () {
		return this._bounds;
	},

	// @method getElement(): HTMLElement
	// Get the img element that represents the ImageOverlay on the map
	getElement: function () {
		return this._image;
	},

	_initImage: function () {
		var img = this._image = L.DomUtil.create('img',
				'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : ''));

		img.onselectstart = L.Util.falseFn;
		img.onmousemove = L.Util.falseFn;

		img.onload = L.bind(this.fire, this, 'load');

		if (this.options.crossOrigin) {
			img.crossOrigin = '';
		}

		img.src = this._url;
		img.alt = this.options.alt;
	},

	_animateZoom: function (e) {
		var scale = this._map.getZoomScale(e.zoom),
		    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;

		L.DomUtil.setTransform(this._image, offset, scale);
	},

	_reset: function () {
		var image = this._image,
		    bounds = new L.Bounds(
		        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
		        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
		    size = bounds.getSize();

		L.DomUtil.setPosition(image, bounds.min);

		image.style.width  = size.x + 'px';
		image.style.height = size.y + 'px';
	},

	_updateOpacity: function () {
		L.DomUtil.setOpacity(this._image, this.options.opacity);
	}
});

// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
// Instantiates an image overlay object given the URL of the image and the
// geographical bounds it is tied to.
L.imageOverlay = function (url, bounds, options) {
	return new L.ImageOverlay(url, bounds, options);
};



/*
 * @class Icon
 * @aka L.Icon
 * @inherits Layer
 *
 * Represents an icon to provide when creating a marker.
 *
 * @example
 *
 * ```js
 * var myIcon = L.icon({
 *     iconUrl: 'my-icon.png',
 *     iconRetinaUrl: 'my-icon@2x.png',
 *     iconSize: [38, 95],
 *     iconAnchor: [22, 94],
 *     popupAnchor: [-3, -76],
 *     shadowUrl: 'my-icon-shadow.png',
 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
 *     shadowSize: [68, 95],
 *     shadowAnchor: [22, 94]
 * });
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
 *
 */

L.Icon = L.Class.extend({

	/* @section
	 * @aka Icon options
	 *
	 * @option iconUrl: String = null
	 * **(required)** The URL to the icon image (absolute or relative to your script path).
	 *
	 * @option iconRetinaUrl: String = null
	 * The URL to a retina sized version of the icon image (absolute or relative to your
	 * script path). Used for Retina screen devices.
	 *
	 * @option iconSize: Point = null
	 * Size of the icon image in pixels.
	 *
	 * @option iconAnchor: Point = null
	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
	 * will be aligned so that this point is at the marker's geographical location. Centered
	 * by default if size is specified, also can be set in CSS with negative margins.
	 *
	 * @option popupAnchor: Point = null
	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
	 *
	 * @option shadowUrl: String = null
	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
	 *
	 * @option shadowRetinaUrl: String = null
	 *
	 * @option shadowSize: Point = null
	 * Size of the shadow image in pixels.
	 *
	 * @option shadowAnchor: Point = null
	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
	 * as iconAnchor if not specified).
	 *
	 * @option className: String = ''
	 * A custom class name to assign to both icon and shadow images. Empty by default.
	 */

	initialize: function (options) {
		L.setOptions(this, options);
	},

	// @method createIcon(oldIcon?: HTMLElement): HTMLElement
	// Called internally when the icon has to be shown, returns a `<img>` HTML element
	// styled according to the options.
	createIcon: function (oldIcon) {
		return this._createIcon('icon', oldIcon);
	},

	// @method createShadow(oldIcon?: HTMLElement): HTMLElement
	// As `createIcon`, but for the shadow beneath it.
	createShadow: function (oldIcon) {
		return this._createIcon('shadow', oldIcon);
	},

	_createIcon: function (name, oldIcon) {
		var src = this._getIconUrl(name);

		if (!src) {
			if (name === 'icon') {
				throw new Error('iconUrl not set in Icon options (see the docs).');
			}
			return null;
		}

		var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
		this._setIconStyles(img, name);

		return img;
	},

	_setIconStyles: function (img, name) {
		var options = this.options;
		var sizeOption = options[name + 'Size'];

		if (typeof sizeOption === 'number') {
			sizeOption = [sizeOption, sizeOption];
		}

		var size = L.point(sizeOption),
		    anchor = L.point(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
		            size && size.divideBy(2, true));

		img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');

		if (anchor) {
			img.style.marginLeft = (-anchor.x) + 'px';
			img.style.marginTop  = (-anchor.y) + 'px';
		}

		if (size) {
			img.style.width  = size.x + 'px';
			img.style.height = size.y + 'px';
		}
	},

	_createImg: function (src, el) {
		el = el || document.createElement('img');
		el.src = src;
		return el;
	},

	_getIconUrl: function (name) {
		return L.Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
	}
});


// @factory L.icon(options: Icon options)
// Creates an icon instance with the given options.
L.icon = function (options) {
	return new L.Icon(options);
};



/*
 * @miniclass Icon.Default (Icon)
 * @aka L.Icon.Default
 * @section
 *
 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
 * no icon is specified. Points to the blue marker image distributed with Leaflet
 * releases.
 *
 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
 * (which is a set of `Icon options`).
 *
 * If you want to _completely_ replace the default icon, override the
 * `L.Marker.prototype.options.icon` with your own icon instead.
 */

L.Icon.Default = L.Icon.extend({

	options: {
		iconUrl:       'marker-icon.png',
		iconRetinaUrl: 'marker-icon-2x.png',
		shadowUrl:     'marker-shadow.png',
		iconSize:    [25, 41],
		iconAnchor:  [12, 41],
		popupAnchor: [1, -34],
		tooltipAnchor: [16, -28],
		shadowSize:  [41, 41]
	},

	_getIconUrl: function (name) {
		if (!L.Icon.Default.imagePath) {	// Deprecated, backwards-compatibility only
			L.Icon.Default.imagePath = this._detectIconPath();
		}

		// @option imagePath: String
		// `L.Icon.Default` will try to auto-detect the absolute location of the
		// blue icon images. If you are placing these images in a non-standard
		// way, set this option to point to the right absolute path.
		return (this.options.imagePath || L.Icon.Default.imagePath) + L.Icon.prototype._getIconUrl.call(this, name);
	},

	_detectIconPath: function () {
		var el = L.DomUtil.create('div',  'leaflet-default-icon-path', document.body);
		var path = L.DomUtil.getStyle(el, 'background-image') ||
		           L.DomUtil.getStyle(el, 'backgroundImage');	// IE8

		document.body.removeChild(el);

		return path.indexOf('url') === 0 ?
			path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '') : '';
	}
});



/*
 * @class Marker
 * @inherits Interactive layer
 * @aka L.Marker
 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.marker([50.5, 30.5]).addTo(map);
 * ```
 */

L.Marker = L.Layer.extend({

	// @section
	// @aka Marker options
	options: {
		// @option icon: Icon = *
		// Icon class to use for rendering the marker. See [Icon documentation](#L.Icon) for details on how to customize the marker icon. If not specified, a new `L.Icon.Default` is used.
		icon: new L.Icon.Default(),

		// Option inherited from "Interactive layer" abstract class
		interactive: true,

		// @option draggable: Boolean = false
		// Whether the marker is draggable with mouse/touch or not.
		draggable: false,

		// @option keyboard: Boolean = true
		// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
		keyboard: true,

		// @option title: String = ''
		// Text for the browser tooltip that appear on marker hover (no tooltip by default).
		title: '',

		// @option alt: String = ''
		// Text for the `alt` attribute of the icon image (useful for accessibility).
		alt: '',

		// @option zIndexOffset: Number = 0
		// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
		zIndexOffset: 0,

		// @option opacity: Number = 1.0
		// The opacity of the marker.
		opacity: 1,

		// @option riseOnHover: Boolean = false
		// If `true`, the marker will get on top of others when you hover the mouse over it.
		riseOnHover: false,

		// @option riseOffset: Number = 250
		// The z-index offset used for the `riseOnHover` feature.
		riseOffset: 250,

		// @option pane: String = 'markerPane'
		// `Map pane` where the markers icon will be added.
		pane: 'markerPane',

		// FIXME: shadowPane is no longer a valid option
		nonBubblingEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu']
	},

	/* @section
	 *
	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
	 */

	initialize: function (latlng, options) {
		L.setOptions(this, options);
		this._latlng = L.latLng(latlng);
	},

	onAdd: function (map) {
		this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;

		if (this._zoomAnimated) {
			map.on('zoomanim', this._animateZoom, this);
		}

		this._initIcon();
		this.update();
	},

	onRemove: function (map) {
		if (this.dragging && this.dragging.enabled()) {
			this.options.draggable = true;
			this.dragging.removeHooks();
		}

		if (this._zoomAnimated) {
			map.off('zoomanim', this._animateZoom, this);
		}

		this._removeIcon();
		this._removeShadow();
	},

	getEvents: function () {
		return {
			zoom: this.update,
			viewreset: this.update
		};
	},

	// @method getLatLng: LatLng
	// Returns the current geographical position of the marker.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Changes the marker position to the given point.
	setLatLng: function (latlng) {
		var oldLatLng = this._latlng;
		this._latlng = L.latLng(latlng);
		this.update();

		// @event move: Event
		// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
		return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
	},

	// @method setZIndexOffset(offset: Number): this
	// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
	setZIndexOffset: function (offset) {
		this.options.zIndexOffset = offset;
		return this.update();
	},

	// @method setIcon(icon: Icon): this
	// Changes the marker icon.
	setIcon: function (icon) {

		this.options.icon = icon;

		if (this._map) {
			this._initIcon();
			this.update();
		}

		if (this._popup) {
			this.bindPopup(this._popup, this._popup.options);
		}

		return this;
	},

	getElement: function () {
		return this._icon;
	},

	update: function () {

		if (this._icon) {
			var pos = this._map.latLngToLayerPoint(this._latlng).round();
			this._setPos(pos);
		}

		return this;
	},

	_initIcon: function () {
		var options = this.options,
		    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		var icon = options.icon.createIcon(this._icon),
		    addIcon = false;

		// if we're not reusing the icon, remove the old one and init new one
		if (icon !== this._icon) {
			if (this._icon) {
				this._removeIcon();
			}
			addIcon = true;

			if (options.title) {
				icon.title = options.title;
			}
			if (options.alt) {
				icon.alt = options.alt;
			}
		}

		L.DomUtil.addClass(icon, classToAdd);

		if (options.keyboard) {
			icon.tabIndex = '0';
		}

		this._icon = icon;

		if (options.riseOnHover) {
			this.on({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		var newShadow = options.icon.createShadow(this._shadow),
		    addShadow = false;

		if (newShadow !== this._shadow) {
			this._removeShadow();
			addShadow = true;
		}

		if (newShadow) {
			L.DomUtil.addClass(newShadow, classToAdd);
			newShadow.alt = '';
		}
		this._shadow = newShadow;


		if (options.opacity < 1) {
			this._updateOpacity();
		}


		if (addIcon) {
			this.getPane().appendChild(this._icon);
		}
		this._initInteraction();
		if (newShadow && addShadow) {
			this.getPane('shadowPane').appendChild(this._shadow);
		}
	},

	_removeIcon: function () {
		if (this.options.riseOnHover) {
			this.off({
				mouseover: this._bringToFront,
				mouseout: this._resetZIndex
			});
		}

		L.DomUtil.remove(this._icon);
		this.removeInteractiveTarget(this._icon);

		this._icon = null;
	},

	_removeShadow: function () {
		if (this._shadow) {
			L.DomUtil.remove(this._shadow);
		}
		this._shadow = null;
	},

	_setPos: function (pos) {
		L.DomUtil.setPosition(this._icon, pos);

		if (this._shadow) {
			L.DomUtil.setPosition(this._shadow, pos);
		}

		this._zIndex = pos.y + this.options.zIndexOffset;

		this._resetZIndex();
	},

	_updateZIndex: function (offset) {
		this._icon.style.zIndex = this._zIndex + offset;
	},

	_animateZoom: function (opt) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();

		this._setPos(pos);
	},

	_initInteraction: function () {

		if (!this.options.interactive) { return; }

		L.DomUtil.addClass(this._icon, 'leaflet-interactive');

		this.addInteractiveTarget(this._icon);

		if (L.Handler.MarkerDrag) {
			var draggable = this.options.draggable;
			if (this.dragging) {
				draggable = this.dragging.enabled();
				this.dragging.disable();
			}

			this.dragging = new L.Handler.MarkerDrag(this);

			if (draggable) {
				this.dragging.enable();
			}
		}
	},

	// @method setOpacity(opacity: Number): this
	// Changes the opacity of the marker.
	setOpacity: function (opacity) {
		this.options.opacity = opacity;
		if (this._map) {
			this._updateOpacity();
		}

		return this;
	},

	_updateOpacity: function () {
		var opacity = this.options.opacity;

		L.DomUtil.setOpacity(this._icon, opacity);

		if (this._shadow) {
			L.DomUtil.setOpacity(this._shadow, opacity);
		}
	},

	_bringToFront: function () {
		this._updateZIndex(this.options.riseOffset);
	},

	_resetZIndex: function () {
		this._updateZIndex(0);
	},

	_getPopupAnchor: function () {
		return this.options.icon.options.popupAnchor || [0, 0];
	},

	_getTooltipAnchor: function () {
		return this.options.icon.options.tooltipAnchor || [0, 0];
	}
});


// factory L.marker(latlng: LatLng, options? : Marker options)

// @factory L.marker(latlng: LatLng, options? : Marker options)
// Instantiates a Marker object given a geographical point and optionally an options object.
L.marker = function (latlng, options) {
	return new L.Marker(latlng, options);
};



/*
 * @class DivIcon
 * @aka L.DivIcon
 * @inherits Icon
 *
 * Represents a lightweight icon for markers that uses a simple `<div>`
 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
 *
 * @example
 * ```js
 * var myIcon = L.divIcon({className: 'my-div-icon'});
 * // you can set .my-div-icon styles in CSS
 *
 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
 * ```
 *
 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
 */

L.DivIcon = L.Icon.extend({
	options: {
		// @section
		// @aka DivIcon options
		iconSize: [12, 12], // also can be set through CSS

		// iconAnchor: (Point),
		// popupAnchor: (Point),

		// @option html: String = ''
		// Custom HTML code to put inside the div element, empty by default.
		html: false,

		// @option bgPos: Point = [0, 0]
		// Optional relative position of the background, in pixels
		bgPos: null,

		className: 'leaflet-div-icon'
	},

	createIcon: function (oldIcon) {
		var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
		    options = this.options;

		div.innerHTML = options.html !== false ? options.html : '';

		if (options.bgPos) {
			var bgPos = L.point(options.bgPos);
			div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
		}
		this._setIconStyles(div, 'icon');

		return div;
	},

	createShadow: function () {
		return null;
	}
});

// @factory L.divIcon(options: DivIcon options)
// Creates a `DivIcon` instance with the given options.
L.divIcon = function (options) {
	return new L.DivIcon(options);
};



/*
 * @class DivOverlay
 * @inherits Layer
 * @aka L.DivOverlay
 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
 */

// @namespace DivOverlay
L.DivOverlay = L.Layer.extend({

	// @section
	// @aka DivOverlay options
	options: {
		// @option offset: Point = Point(0, 7)
		// The offset of the popup position. Useful to control the anchor
		// of the popup when opening it on some overlays.
		offset: [0, 7],

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: '',

		// @option pane: String = 'popupPane'
		// `Map pane` where the popup will be added.
		pane: 'popupPane'
	},

	initialize: function (options, source) {
		L.setOptions(this, options);

		this._source = source;
	},

	onAdd: function (map) {
		this._zoomAnimated = map._zoomAnimated;

		if (!this._container) {
			this._initLayout();
		}

		if (map._fadeAnimated) {
			L.DomUtil.setOpacity(this._container, 0);
		}

		clearTimeout(this._removeTimeout);
		this.getPane().appendChild(this._container);
		this.update();

		if (map._fadeAnimated) {
			L.DomUtil.setOpacity(this._container, 1);
		}

		this.bringToFront();
	},

	onRemove: function (map) {
		if (map._fadeAnimated) {
			L.DomUtil.setOpacity(this._container, 0);
			this._removeTimeout = setTimeout(L.bind(L.DomUtil.remove, L.DomUtil, this._container), 200);
		} else {
			L.DomUtil.remove(this._container);
		}
	},

	// @namespace Popup
	// @method getLatLng: LatLng
	// Returns the geographical point of popup.
	getLatLng: function () {
		return this._latlng;
	},

	// @method setLatLng(latlng: LatLng): this
	// Sets the geographical point where the popup will open.
	setLatLng: function (latlng) {
		this._latlng = L.latLng(latlng);
		if (this._map) {
			this._updatePosition();
			this._adjustPan();
		}
		return this;
	},

	// @method getContent: String|HTMLElement
	// Returns the content of the popup.
	getContent: function () {
		return this._content;
	},

	// @method setContent(htmlContent: String|HTMLElement|Function): this
	// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
	setContent: function (content) {
		this._content = content;
		this.update();
		return this;
	},

	// @method getElement: String|HTMLElement
	// Alias for [getContent()](#popup-getcontent)
	getElement: function () {
		return this._container;
	},

	// @method update: null
	// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
	update: function () {
		if (!this._map) { return; }

		this._container.style.visibility = 'hidden';

		this._updateContent();
		this._updateLayout();
		this._updatePosition();

		this._container.style.visibility = '';

		this._adjustPan();
	},

	getEvents: function () {
		var events = {
			zoom: this._updatePosition,
			viewreset: this._updatePosition
		};

		if (this._zoomAnimated) {
			events.zoomanim = this._animateZoom;
		}
		return events;
	},

	// @method isOpen: Boolean
	// Returns `true` when the popup is visible on the map.
	isOpen: function () {
		return !!this._map && this._map.hasLayer(this);
	},

	// @method bringToFront: this
	// Brings this popup in front of other popups (in the same map pane).
	bringToFront: function () {
		if (this._map) {
			L.DomUtil.toFront(this._container);
		}
		return this;
	},

	// @method bringToBack: this
	// Brings this popup to the back of other popups (in the same map pane).
	bringToBack: function () {
		if (this._map) {
			L.DomUtil.toBack(this._container);
		}
		return this;
	},

	_updateContent: function () {
		if (!this._content) { return; }

		var node = this._contentNode;
		var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;

		if (typeof content === 'string') {
			node.innerHTML = content;
		} else {
			while (node.hasChildNodes()) {
				node.removeChild(node.firstChild);
			}
			node.appendChild(content);
		}
		this.fire('contentupdate');
	},

	_updatePosition: function () {
		if (!this._map) { return; }

		var pos = this._map.latLngToLayerPoint(this._latlng),
		    offset = L.point(this.options.offset),
		    anchor = this._getAnchor();

		if (this._zoomAnimated) {
			L.DomUtil.setPosition(this._container, pos.add(anchor));
		} else {
			offset = offset.add(pos).add(anchor);
		}

		var bottom = this._containerBottom = -offset.y,
		    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;

		// bottom position the popup in case the height of the popup changes (images loading etc)
		this._container.style.bottom = bottom + 'px';
		this._container.style.left = left + 'px';
	},

	_getAnchor: function () {
		return [0, 0];
	}

});



/*
 * @class Popup
 * @inherits DivOverlay
 * @aka L.Popup
 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
 * open popups while making sure that only one popup is open at one time
 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
 *
 * @example
 *
 * If you want to just bind a popup to marker click and then open it, it's really easy:
 *
 * ```js
 * marker.bindPopup(popupContent).openPopup();
 * ```
 * Path overlays like polylines also have a `bindPopup` method.
 * Here's a more complicated way to open a popup on a map:
 *
 * ```js
 * var popup = L.popup()
 * 	.setLatLng(latlng)
 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
 * 	.openOn(map);
 * ```
 */


// @namespace Popup
L.Popup = L.DivOverlay.extend({

	// @section
	// @aka Popup options
	options: {
		// @option maxWidth: Number = 300
		// Max width of the popup, in pixels.
		maxWidth: 300,

		// @option minWidth: Number = 50
		// Min width of the popup, in pixels.
		minWidth: 50,

		// @option maxHeight: Number = null
		// If set, creates a scrollable container of the given height
		// inside a popup if its content exceeds it.
		maxHeight: null,

		// @option autoPan: Boolean = true
		// Set it to `false` if you don't want the map to do panning animation
		// to fit the opened popup.
		autoPan: true,

		// @option autoPanPaddingTopLeft: Point = null
		// The margin between the popup and the top left corner of the map
		// view after autopanning was performed.
		autoPanPaddingTopLeft: null,

		// @option autoPanPaddingBottomRight: Point = null
		// The margin between the popup and the bottom right corner of the map
		// view after autopanning was performed.
		autoPanPaddingBottomRight: null,

		// @option autoPanPadding: Point = Point(5, 5)
		// Equivalent of setting both top left and bottom right autopan padding to the same value.
		autoPanPadding: [5, 5],

		// @option keepInView: Boolean = false
		// Set it to `true` if you want to prevent users from panning the popup
		// off of the screen while it is open.
		keepInView: false,

		// @option closeButton: Boolean = true
		// Controls the presence of a close button in the popup.
		closeButton: true,

		// @option autoClose: Boolean = true
		// Set it to `false` if you want to override the default behavior of
		// the popup closing when user clicks the map (set globally by
		// the Map's [closePopupOnClick](#map-closepopuponclick) option).
		autoClose: true,

		// @option className: String = ''
		// A custom CSS class name to assign to the popup.
		className: ''
	},

	// @namespace Popup
	// @method openOn(map: Map): this
	// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
	openOn: function (map) {
		map.openPopup(this);
		return this;
	},

	onAdd: function (map) {
		L.DivOverlay.prototype.onAdd.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupopen: PopupEvent
		// Fired when a popup is opened in the map
		map.fire('popupopen', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup bound to this layer is opened
			this._source.fire('popupopen', {popup: this}, true);
			// For non-path layers, we toggle the popup when clicking
			// again the layer, so prevent the map to reopen it.
			if (!(this._source instanceof L.Path)) {
				this._source.on('preclick', L.DomEvent.stopPropagation);
			}
		}
	},

	onRemove: function (map) {
		L.DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Popup events
		// @event popupclose: PopupEvent
		// Fired when a popup in the map is closed
		map.fire('popupclose', {popup: this});

		if (this._source) {
			// @namespace Layer
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup bound to this layer is closed
			this._source.fire('popupclose', {popup: this}, true);
			if (!(this._source instanceof L.Path)) {
				this._source.off('preclick', L.DomEvent.stopPropagation);
			}
		}
	},

	getEvents: function () {
		var events = L.DivOverlay.prototype.getEvents.call(this);

		if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
			events.preclick = this._close;
		}

		if (this.options.keepInView) {
			events.moveend = this._adjustPan;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closePopup(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-popup',
		    container = this._container = L.DomUtil.create('div',
			prefix + ' ' + (this.options.className || '') +
			' leaflet-zoom-animated');

		if (this.options.closeButton) {
			var closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
			closeButton.href = '#close';
			closeButton.innerHTML = '&#215;';

			L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
		}

		var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
		this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);

		L.DomEvent
			.disableClickPropagation(wrapper)
			.disableScrollPropagation(this._contentNode)
			.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);

		this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
		this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
	},

	_updateLayout: function () {
		var container = this._contentNode,
		    style = container.style;

		style.width = '';
		style.whiteSpace = 'nowrap';

		var width = container.offsetWidth;
		width = Math.min(width, this.options.maxWidth);
		width = Math.max(width, this.options.minWidth);

		style.width = (width + 1) + 'px';
		style.whiteSpace = '';

		style.height = '';

		var height = container.offsetHeight,
		    maxHeight = this.options.maxHeight,
		    scrolledClass = 'leaflet-popup-scrolled';

		if (maxHeight && height > maxHeight) {
			style.height = maxHeight + 'px';
			L.DomUtil.addClass(container, scrolledClass);
		} else {
			L.DomUtil.removeClass(container, scrolledClass);
		}

		this._containerWidth = this._container.offsetWidth;
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
		    anchor = this._getAnchor();
		L.DomUtil.setPosition(this._container, pos.add(anchor));
	},

	_adjustPan: function () {
		if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }

		var map = this._map,
		    marginBottom = parseInt(L.DomUtil.getStyle(this._container, 'marginBottom'), 10) || 0,
		    containerHeight = this._container.offsetHeight + marginBottom,
		    containerWidth = this._containerWidth,
		    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);

		layerPos._add(L.DomUtil.getPosition(this._container));

		var containerPos = map.layerPointToContainerPoint(layerPos),
		    padding = L.point(this.options.autoPanPadding),
		    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
		    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
		    size = map.getSize(),
		    dx = 0,
		    dy = 0;

		if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
			dx = containerPos.x + containerWidth - size.x + paddingBR.x;
		}
		if (containerPos.x - dx - paddingTL.x < 0) { // left
			dx = containerPos.x - paddingTL.x;
		}
		if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
			dy = containerPos.y + containerHeight - size.y + paddingBR.y;
		}
		if (containerPos.y - dy - paddingTL.y < 0) { // top
			dy = containerPos.y - paddingTL.y;
		}

		// @namespace Map
		// @section Popup events
		// @event autopanstart: Event
		// Fired when the map starts autopanning when opening a popup.
		if (dx || dy) {
			map
			    .fire('autopanstart')
			    .panBy([dx, dy]);
		}
	},

	_onCloseButtonClick: function (e) {
		this._close();
		L.DomEvent.stop(e);
	},

	_getAnchor: function () {
		// Where should we anchor the popup on the source layer?
		return L.point(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
	}

});

// @namespace Popup
// @factory L.popup(options?: Popup options, source?: Layer)
// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
L.popup = function (options, source) {
	return new L.Popup(options, source);
};


/* @namespace Map
 * @section Interaction Options
 * @option closePopupOnClick: Boolean = true
 * Set it to `false` if you don't want popups to close when user clicks the map.
 */
L.Map.mergeOptions({
	closePopupOnClick: true
});


// @namespace Map
// @section Methods for Layers and Controls
L.Map.include({
	// @method openPopup(popup: Popup): this
	// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
	// @alternative
	// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
	// Creates a popup with the specified content and options and opens it in the given point on a map.
	openPopup: function (popup, latlng, options) {
		if (!(popup instanceof L.Popup)) {
			popup = new L.Popup(options).setContent(popup);
		}

		if (latlng) {
			popup.setLatLng(latlng);
		}

		if (this.hasLayer(popup)) {
			return this;
		}

		if (this._popup && this._popup.options.autoClose) {
			this.closePopup();
		}

		this._popup = popup;
		return this.addLayer(popup);
	},

	// @method closePopup(popup?: Popup): this
	// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
	closePopup: function (popup) {
		if (!popup || popup === this._popup) {
			popup = this._popup;
			this._popup = null;
		}
		if (popup) {
			this.removeLayer(popup);
		}
		return this;
	}
});

/*
 * @namespace Layer
 * @section Popup methods example
 *
 * All layers share a set of methods convenient for binding popups to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
 * layer.openPopup();
 * layer.closePopup();
 * ```
 *
 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
 */

// @section Popup methods
L.Layer.include({

	// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
	// Binds a popup to the layer with the passed `content` and sets up the
	// neccessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindPopup: function (content, options) {

		if (content instanceof L.Popup) {
			L.setOptions(content, options);
			this._popup = content;
			content._source = this;
		} else {
			if (!this._popup || options) {
				this._popup = new L.Popup(options, this);
			}
			this._popup.setContent(content);
		}

		if (!this._popupHandlersAdded) {
			this.on({
				click: this._openPopup,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = true;
		}

		return this;
	},

	// @method unbindPopup(): this
	// Removes the popup previously bound with `bindPopup`.
	unbindPopup: function () {
		if (this._popup) {
			this.off({
				click: this._openPopup,
				remove: this.closePopup,
				move: this._movePopup
			});
			this._popupHandlersAdded = false;
			this._popup = null;
		}
		return this;
	},

	// @method openPopup(latlng?: LatLng): this
	// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
	openPopup: function (layer, latlng) {
		if (!(layer instanceof L.Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof L.FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._popup && this._map) {
			// set popup source to this layer
			this._popup._source = layer;

			// update the popup (content, layout, ect...)
			this._popup.update();

			// open the popup on the map
			this._map.openPopup(this._popup, latlng);
		}

		return this;
	},

	// @method closePopup(): this
	// Closes the popup bound to this layer if it is open.
	closePopup: function () {
		if (this._popup) {
			this._popup._close();
		}
		return this;
	},

	// @method togglePopup(): this
	// Opens or closes the popup bound to this layer depending on its current state.
	togglePopup: function (target) {
		if (this._popup) {
			if (this._popup._map) {
				this.closePopup();
			} else {
				this.openPopup(target);
			}
		}
		return this;
	},

	// @method isPopupOpen(): boolean
	// Returns `true` if the popup bound to this layer is currently open.
	isPopupOpen: function () {
		return (this._popup ? this._popup.isOpen() : false);
	},

	// @method setPopupContent(content: String|HTMLElement|Popup): this
	// Sets the content of the popup bound to this layer.
	setPopupContent: function (content) {
		if (this._popup) {
			this._popup.setContent(content);
		}
		return this;
	},

	// @method getPopup(): Popup
	// Returns the popup bound to this layer.
	getPopup: function () {
		return this._popup;
	},

	_openPopup: function (e) {
		var layer = e.layer || e.target;

		if (!this._popup) {
			return;
		}

		if (!this._map) {
			return;
		}

		// prevent map click
		L.DomEvent.stop(e);

		// if this inherits from Path its a vector and we can just
		// open the popup at the new location
		if (layer instanceof L.Path) {
			this.openPopup(e.layer || e.target, e.latlng);
			return;
		}

		// otherwise treat it like a marker and figure out
		// if we should toggle it open/closed
		if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
			this.closePopup();
		} else {
			this.openPopup(layer, e.latlng);
		}
	},

	_movePopup: function (e) {
		this._popup.setLatLng(e.latlng);
	}
});



/*
 * @class Tooltip
 * @inherits DivOverlay
 * @aka L.Tooltip
 * Used to display small texts on top of map layers.
 *
 * @example
 *
 * ```js
 * marker.bindTooltip("my tooltip text").openTooltip();
 * ```
 * Note about tooltip offset. Leaflet takes two options in consideration
 * for computing tooltip offseting:
 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
 *   move it to the bottom. Negatives will move to the left and top.
 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
 *   should adapt this value if you use a custom icon.
 */


// @namespace Tooltip
L.Tooltip = L.DivOverlay.extend({

	// @section
	// @aka Tooltip options
	options: {
		// @option pane: String = 'tooltipPane'
		// `Map pane` where the tooltip will be added.
		pane: 'tooltipPane',

		// @option offset: Point = Point(0, 0)
		// Optional offset of the tooltip position.
		offset: [0, 0],

		// @option direction: String = 'auto'
		// Direction where to open the tooltip. Possible values are: `right`, `left`,
		// `top`, `bottom`, `center`, `auto`.
		// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
		// position on the map.
		direction: 'auto',

		// @option permanent: Boolean = false
		// Whether to open the tooltip permanently or only on mouseover.
		permanent: false,

		// @option sticky: Boolean = false
		// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
		sticky: false,

		// @option interactive: Boolean = false
		// If true, the tooltip will listen to the feature events.
		interactive: false,

		// @option opacity: Number = 0.9
		// Tooltip container opacity.
		opacity: 0.9
	},

	onAdd: function (map) {
		L.DivOverlay.prototype.onAdd.call(this, map);
		this.setOpacity(this.options.opacity);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipopen: TooltipEvent
		// Fired when a tooltip is opened in the map.
		map.fire('tooltipopen', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip bound to this layer is opened.
			this._source.fire('tooltipopen', {tooltip: this}, true);
		}
	},

	onRemove: function (map) {
		L.DivOverlay.prototype.onRemove.call(this, map);

		// @namespace Map
		// @section Tooltip events
		// @event tooltipclose: TooltipEvent
		// Fired when a tooltip in the map is closed.
		map.fire('tooltipclose', {tooltip: this});

		if (this._source) {
			// @namespace Layer
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip bound to this layer is closed.
			this._source.fire('tooltipclose', {tooltip: this}, true);
		}
	},

	getEvents: function () {
		var events = L.DivOverlay.prototype.getEvents.call(this);

		if (L.Browser.touch && !this.options.permanent) {
			events.preclick = this._close;
		}

		return events;
	},

	_close: function () {
		if (this._map) {
			this._map.closeTooltip(this);
		}
	},

	_initLayout: function () {
		var prefix = 'leaflet-tooltip',
		    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');

		this._contentNode = this._container = L.DomUtil.create('div', className);
	},

	_updateLayout: function () {},

	_adjustPan: function () {},

	_setPosition: function (pos) {
		var map = this._map,
		    container = this._container,
		    centerPoint = map.latLngToContainerPoint(map.getCenter()),
		    tooltipPoint = map.layerPointToContainerPoint(pos),
		    direction = this.options.direction,
		    tooltipWidth = container.offsetWidth,
		    tooltipHeight = container.offsetHeight,
		    offset = L.point(this.options.offset),
		    anchor = this._getAnchor();

		if (direction === 'top') {
			pos = pos.add(L.point(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
		} else if (direction === 'bottom') {
			pos = pos.subtract(L.point(tooltipWidth / 2 - offset.x, -offset.y, true));
		} else if (direction === 'center') {
			pos = pos.subtract(L.point(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
		} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
			direction = 'right';
			pos = pos.add(L.point(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
		} else {
			direction = 'left';
			pos = pos.subtract(L.point(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
		}

		L.DomUtil.removeClass(container, 'leaflet-tooltip-right');
		L.DomUtil.removeClass(container, 'leaflet-tooltip-left');
		L.DomUtil.removeClass(container, 'leaflet-tooltip-top');
		L.DomUtil.removeClass(container, 'leaflet-tooltip-bottom');
		L.DomUtil.addClass(container, 'leaflet-tooltip-' + direction);
		L.DomUtil.setPosition(container, pos);
	},

	_updatePosition: function () {
		var pos = this._map.latLngToLayerPoint(this._latlng);
		this._setPosition(pos);
	},

	setOpacity: function (opacity) {
		this.options.opacity = opacity;

		if (this._container) {
			L.DomUtil.setOpacity(this._container, opacity);
		}
	},

	_animateZoom: function (e) {
		var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
		this._setPosition(pos);
	},

	_getAnchor: function () {
		// Where should we anchor the tooltip on the source layer?
		return L.point(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
	}

});

// @namespace Tooltip
// @factory L.tooltip(options?: Tooltip options, source?: Layer)
// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
L.tooltip = function (options, source) {
	return new L.Tooltip(options, source);
};

// @namespace Map
// @section Methods for Layers and Controls
L.Map.include({

	// @method openTooltip(tooltip: Tooltip): this
	// Opens the specified tooltip.
	// @alternative
	// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
	// Creates a tooltip with the specified content and options and open it.
	openTooltip: function (tooltip, latlng, options) {
		if (!(tooltip instanceof L.Tooltip)) {
			tooltip = new L.Tooltip(options).setContent(tooltip);
		}

		if (latlng) {
			tooltip.setLatLng(latlng);
		}

		if (this.hasLayer(tooltip)) {
			return this;
		}

		return this.addLayer(tooltip);
	},

	// @method closeTooltip(tooltip?: Tooltip): this
	// Closes the tooltip given as parameter.
	closeTooltip: function (tooltip) {
		if (tooltip) {
			this.removeLayer(tooltip);
		}
		return this;
	}

});

/*
 * @namespace Layer
 * @section Tooltip methods example
 *
 * All layers share a set of methods convenient for binding tooltips to it.
 *
 * ```js
 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
 * layer.openTooltip();
 * layer.closeTooltip();
 * ```
 */

// @section Tooltip methods
L.Layer.include({

	// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
	// Binds a tooltip to the layer with the passed `content` and sets up the
	// neccessary event listeners. If a `Function` is passed it will receive
	// the layer as the first argument and should return a `String` or `HTMLElement`.
	bindTooltip: function (content, options) {

		if (content instanceof L.Tooltip) {
			L.setOptions(content, options);
			this._tooltip = content;
			content._source = this;
		} else {
			if (!this._tooltip || options) {
				this._tooltip = L.tooltip(options, this);
			}
			this._tooltip.setContent(content);

		}

		this._initTooltipInteractions();

		if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
			this.openTooltip();
		}

		return this;
	},

	// @method unbindTooltip(): this
	// Removes the tooltip previously bound with `bindTooltip`.
	unbindTooltip: function () {
		if (this._tooltip) {
			this._initTooltipInteractions(true);
			this.closeTooltip();
			this._tooltip = null;
		}
		return this;
	},

	_initTooltipInteractions: function (remove) {
		if (!remove && this._tooltipHandlersAdded) { return; }
		var onOff = remove ? 'off' : 'on',
		    events = {
			remove: this.closeTooltip,
			move: this._moveTooltip
		    };
		if (!this._tooltip.options.permanent) {
			events.mouseover = this._openTooltip;
			events.mouseout = this.closeTooltip;
			if (this._tooltip.options.sticky) {
				events.mousemove = this._moveTooltip;
			}
			if (L.Browser.touch) {
				events.click = this._openTooltip;
			}
		} else {
			events.add = this._openTooltip;
		}
		this[onOff](events);
		this._tooltipHandlersAdded = !remove;
	},

	// @method openTooltip(latlng?: LatLng): this
	// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
	openTooltip: function (layer, latlng) {
		if (!(layer instanceof L.Layer)) {
			latlng = layer;
			layer = this;
		}

		if (layer instanceof L.FeatureGroup) {
			for (var id in this._layers) {
				layer = this._layers[id];
				break;
			}
		}

		if (!latlng) {
			latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
		}

		if (this._tooltip && this._map) {

			// set tooltip source to this layer
			this._tooltip._source = layer;

			// update the tooltip (content, layout, ect...)
			this._tooltip.update();

			// open the tooltip on the map
			this._map.openTooltip(this._tooltip, latlng);

			// Tooltip container may not be defined if not permanent and never
			// opened.
			if (this._tooltip.options.interactive && this._tooltip._container) {
				L.DomUtil.addClass(this._tooltip._container, 'leaflet-clickable');
				this.addInteractiveTarget(this._tooltip._container);
			}
		}

		return this;
	},

	// @method closeTooltip(): this
	// Closes the tooltip bound to this layer if it is open.
	closeTooltip: function () {
		if (this._tooltip) {
			this._tooltip._close();
			if (this._tooltip.options.interactive && this._tooltip._container) {
				L.DomUtil.removeClass(this._tooltip._container, 'leaflet-clickable');
				this.removeInteractiveTarget(this._tooltip._container);
			}
		}
		return this;
	},

	// @method toggleTooltip(): this
	// Opens or closes the tooltip bound to this layer depending on its current state.
	toggleTooltip: function (target) {
		if (this._tooltip) {
			if (this._tooltip._map) {
				this.closeTooltip();
			} else {
				this.openTooltip(target);
			}
		}
		return this;
	},

	// @method isTooltipOpen(): boolean
	// Returns `true` if the tooltip bound to this layer is currently open.
	isTooltipOpen: function () {
		return this._tooltip.isOpen();
	},

	// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
	// Sets the content of the tooltip bound to this layer.
	setTooltipContent: function (content) {
		if (this._tooltip) {
			this._tooltip.setContent(content);
		}
		return this;
	},

	// @method getTooltip(): Tooltip
	// Returns the tooltip bound to this layer.
	getTooltip: function () {
		return this._tooltip;
	},

	_openTooltip: function (e) {
		var layer = e.layer || e.target;

		if (!this._tooltip || !this._map) {
			return;
		}
		this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
	},

	_moveTooltip: function (e) {
		var latlng = e.latlng, containerPoint, layerPoint;
		if (this._tooltip.options.sticky && e.originalEvent) {
			containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
			layerPoint = this._map.containerPointToLayerPoint(containerPoint);
			latlng = this._map.layerPointToLatLng(layerPoint);
		}
		this._tooltip.setLatLng(latlng);
	}
});



/*
 * @class LayerGroup
 * @aka L.LayerGroup
 * @inherits Layer
 *
 * Used to group several layers and handle them as one. If you add it to the map,
 * any layers added or removed from the group will be added/removed on the map as
 * well. Extends `Layer`.
 *
 * @example
 *
 * ```js
 * L.layerGroup([marker1, marker2])
 * 	.addLayer(polyline)
 * 	.addTo(map);
 * ```
 */

L.LayerGroup = L.Layer.extend({

	initialize: function (layers) {
		this._layers = {};

		var i, len;

		if (layers) {
			for (i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		}
	},

	// @method addLayer(layer: Layer): this
	// Adds the given layer to the group.
	addLayer: function (layer) {
		var id = this.getLayerId(layer);

		this._layers[id] = layer;

		if (this._map) {
			this._map.addLayer(layer);
		}

		return this;
	},

	// @method removeLayer(layer: Layer): this
	// Removes the given layer from the group.
	// @alternative
	// @method removeLayer(id: Number): this
	// Removes the layer with the given internal ID from the group.
	removeLayer: function (layer) {
		var id = layer in this._layers ? layer : this.getLayerId(layer);

		if (this._map && this._layers[id]) {
			this._map.removeLayer(this._layers[id]);
		}

		delete this._layers[id];

		return this;
	},

	// @method hasLayer(layer: Layer): Boolean
	// Returns `true` if the given layer is currently added to the group.
	hasLayer: function (layer) {
		return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
	},

	// @method clearLayers(): this
	// Removes all the layers from the group.
	clearLayers: function () {
		for (var i in this._layers) {
			this.removeLayer(this._layers[i]);
		}
		return this;
	},

	// @method invoke(methodName: String, …): this
	// Calls `methodName` on every layer contained in this group, passing any
	// additional parameters. Has no effect if the layers contained do not
	// implement `methodName`.
	invoke: function (methodName) {
		var args = Array.prototype.slice.call(arguments, 1),
		    i, layer;

		for (i in this._layers) {
			layer = this._layers[i];

			if (layer[methodName]) {
				layer[methodName].apply(layer, args);
			}
		}

		return this;
	},

	onAdd: function (map) {
		for (var i in this._layers) {
			map.addLayer(this._layers[i]);
		}
	},

	onRemove: function (map) {
		for (var i in this._layers) {
			map.removeLayer(this._layers[i]);
		}
	},

	// @method eachLayer(fn: Function, context?: Object): this
	// Iterates over the layers of the group, optionally specifying context of the iterator function.
	// ```js
	// group.eachLayer(function (layer) {
	// 	layer.bindPopup('Hello');
	// });
	// ```
	eachLayer: function (method, context) {
		for (var i in this._layers) {
			method.call(context, this._layers[i]);
		}
		return this;
	},

	// @method getLayer(id: Number): Layer
	// Returns the layer with the given internal ID.
	getLayer: function (id) {
		return this._layers[id];
	},

	// @method getLayers(): Layer[]
	// Returns an array of all the layers added to the group.
	getLayers: function () {
		var layers = [];

		for (var i in this._layers) {
			layers.push(this._layers[i]);
		}
		return layers;
	},

	// @method setZIndex(zIndex: Number): this
	// Calls `setZIndex` on every layer contained in this group, passing the z-index.
	setZIndex: function (zIndex) {
		return this.invoke('setZIndex', zIndex);
	},

	// @method getLayerId(layer: Layer): Number
	// Returns the internal ID for a layer
	getLayerId: function (layer) {
		return L.stamp(layer);
	}
});


// @factory L.layerGroup(layers: Layer[])
// Create a layer group, optionally given an initial set of layers.
L.layerGroup = function (layers) {
	return new L.LayerGroup(layers);
};



/*
 * @class FeatureGroup
 * @aka L.FeatureGroup
 * @inherits LayerGroup
 *
 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
 * handler, it will handle events from any of the layers. This includes mouse events
 * and custom events.
 *  * Has `layeradd` and `layerremove` events
 *
 * @example
 *
 * ```js
 * L.featureGroup([marker1, marker2, polyline])
 * 	.bindPopup('Hello world!')
 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
 * 	.addTo(map);
 * ```
 */

L.FeatureGroup = L.LayerGroup.extend({

	addLayer: function (layer) {
		if (this.hasLayer(layer)) {
			return this;
		}

		layer.addEventParent(this);

		L.LayerGroup.prototype.addLayer.call(this, layer);

		// @event layeradd: LayerEvent
		// Fired when a layer is added to this `FeatureGroup`
		return this.fire('layeradd', {layer: layer});
	},

	removeLayer: function (layer) {
		if (!this.hasLayer(layer)) {
			return this;
		}
		if (layer in this._layers) {
			layer = this._layers[layer];
		}

		layer.removeEventParent(this);

		L.LayerGroup.prototype.removeLayer.call(this, layer);

		// @event layerremove: LayerEvent
		// Fired when a layer is removed from this `FeatureGroup`
		return this.fire('layerremove', {layer: layer});
	},

	// @method setStyle(style: Path options): this
	// Sets the given path options to each layer of the group that has a `setStyle` method.
	setStyle: function (style) {
		return this.invoke('setStyle', style);
	},

	// @method bringToFront(): this
	// Brings the layer group to the top of all other layers
	bringToFront: function () {
		return this.invoke('bringToFront');
	},

	// @method bringToBack(): this
	// Brings the layer group to the top of all other layers
	bringToBack: function () {
		return this.invoke('bringToBack');
	},

	// @method getBounds(): LatLngBounds
	// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
	getBounds: function () {
		var bounds = new L.LatLngBounds();

		for (var id in this._layers) {
			var layer = this._layers[id];
			bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
		}
		return bounds;
	}
});

// @factory L.featureGroup(layers: Layer[])
// Create a feature group, optionally given an initial set of layers.
L.featureGroup = function (layers) {
	return new L.FeatureGroup(layers);
};



/*
 * @class Renderer
 * @inherits Layer
 * @aka L.Renderer
 *
 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
 * DOM container of the renderer, its bounds, and its zoom animation.
 *
 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
 * itself can be added or removed to the map. All paths use a renderer, which can
 * be implicit (the map will decide the type of renderer and use it automatically)
 * or explicit (using the [`renderer`](#path-renderer) option of the path).
 *
 * Do not use this class directly, use `SVG` and `Canvas` instead.
 *
 * @event update: Event
 * Fired when the renderer updates its bounds, center and zoom, for example when
 * its map has moved
 */

L.Renderer = L.Layer.extend({

	// @section
	// @aka Renderer options
	options: {
		// @option padding: Number = 0.1
		// How much to extend the clip area around the map view (relative to its size)
		// e.g. 0.1 would be 10% of map view in each direction
		padding: 0.1
	},

	initialize: function (options) {
		L.setOptions(this, options);
		L.stamp(this);
		this._layers = this._layers || {};
	},

	onAdd: function () {
		if (!this._container) {
			this._initContainer(); // defined by renderer implementations

			if (this._zoomAnimated) {
				L.DomUtil.addClass(this._container, 'leaflet-zoom-animated');
			}
		}

		this.getPane().appendChild(this._container);
		this._update();
		this.on('update', this._updatePaths, this);
	},

	onRemove: function () {
		L.DomUtil.remove(this._container);
		this.off('update', this._updatePaths, this);
	},

	getEvents: function () {
		var events = {
			viewreset: this._reset,
			zoom: this._onZoom,
			moveend: this._update,
			zoomend: this._onZoomEnd
		};
		if (this._zoomAnimated) {
			events.zoomanim = this._onAnimZoom;
		}
		return events;
	},

	_onAnimZoom: function (ev) {
		this._updateTransform(ev.center, ev.zoom);
	},

	_onZoom: function () {
		this._updateTransform(this._map.getCenter(), this._map.getZoom());
	},

	_updateTransform: function (center, zoom) {
		var scale = this._map.getZoomScale(zoom, this._zoom),
		    position = L.DomUtil.getPosition(this._container),
		    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
		    currentCenterPoint = this._map.project(this._center, zoom),
		    destCenterPoint = this._map.project(center, zoom),
		    centerOffset = destCenterPoint.subtract(currentCenterPoint),

		    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);

		if (L.Browser.any3d) {
			L.DomUtil.setTransform(this._container, topLeftOffset, scale);
		} else {
			L.DomUtil.setPosition(this._container, topLeftOffset);
		}
	},

	_reset: function () {
		this._update();
		this._updateTransform(this._center, this._zoom);

		for (var id in this._layers) {
			this._layers[id]._reset();
		}
	},

	_onZoomEnd: function () {
		for (var id in this._layers) {
			this._layers[id]._project();
		}
	},

	_updatePaths: function () {
		for (var id in this._layers) {
			this._layers[id]._update();
		}
	},

	_update: function () {
		// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
		// Subclasses are responsible of firing the 'update' event.
		var p = this.options.padding,
		    size = this._map.getSize(),
		    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();

		this._bounds = new L.Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());

		this._center = this._map.getCenter();
		this._zoom = this._map.getZoom();
	}
});


L.Map.include({
	// @namespace Map; @method getRenderer(layer: Path): Renderer
	// Returns the instance of `Renderer` that should be used to render the given
	// `Path`. It will ensure that the `renderer` options of the map and paths
	// are respected, and that the renderers do exist on the map.
	getRenderer: function (layer) {
		// @namespace Path; @option renderer: Renderer
		// Use this specific instance of `Renderer` for this path. Takes
		// precedence over the map's [default renderer](#map-renderer).
		var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;

		if (!renderer) {
			// @namespace Map; @option preferCanvas: Boolean = false
			// Whether `Path`s should be rendered on a `Canvas` renderer.
			// By default, all `Path`s are rendered in a `SVG` renderer.
			renderer = this._renderer = (this.options.preferCanvas && L.canvas()) || L.svg();
		}

		if (!this.hasLayer(renderer)) {
			this.addLayer(renderer);
		}
		return renderer;
	},

	_getPaneRenderer: function (name) {
		if (name === 'overlayPane' || name === undefined) {
			return false;
		}

		var renderer = this._paneRenderers[name];
		if (renderer === undefined) {
			renderer = (L.SVG && L.svg({pane: name})) || (L.Canvas && L.canvas({pane: name}));
			this._paneRenderers[name] = renderer;
		}
		return renderer;
	}
});



/*
 * @class Path
 * @aka L.Path
 * @inherits Interactive layer
 *
 * An abstract class that contains options and constants shared between vector
 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
 */

L.Path = L.Layer.extend({

	// @section
	// @aka Path options
	options: {
		// @option stroke: Boolean = true
		// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
		stroke: true,

		// @option color: String = '#3388ff'
		// Stroke color
		color: '#3388ff',

		// @option weight: Number = 3
		// Stroke width in pixels
		weight: 3,

		// @option opacity: Number = 1.0
		// Stroke opacity
		opacity: 1,

		// @option lineCap: String= 'round'
		// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
		lineCap: 'round',

		// @option lineJoin: String = 'round'
		// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
		lineJoin: 'round',

		// @option dashArray: String = null
		// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashArray: null,

		// @option dashOffset: String = null
		// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
		dashOffset: null,

		// @option fill: Boolean = depends
		// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
		fill: false,

		// @option fillColor: String = *
		// Fill color. Defaults to the value of the [`color`](#path-color) option
		fillColor: null,

		// @option fillOpacity: Number = 0.2
		// Fill opacity.
		fillOpacity: 0.2,

		// @option fillRule: String = 'evenodd'
		// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
		fillRule: 'evenodd',

		// className: '',

		// Option inherited from "Interactive layer" abstract class
		interactive: true
	},

	beforeAdd: function (map) {
		// Renderer is set here because we need to call renderer.getEvents
		// before this.getEvents.
		this._renderer = map.getRenderer(this);
	},

	onAdd: function () {
		this._renderer._initPath(this);
		this._reset();
		this._renderer._addPath(this);
	},

	onRemove: function () {
		this._renderer._removePath(this);
	},

	// @method redraw(): this
	// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
	redraw: function () {
		if (this._map) {
			this._renderer._updatePath(this);
		}
		return this;
	},

	// @method setStyle(style: Path options): this
	// Changes the appearance of a Path based on the options in the `Path options` object.
	setStyle: function (style) {
		L.setOptions(this, style);
		if (this._renderer) {
			this._renderer._updateStyle(this);
		}
		return this;
	},

	// @method bringToFront(): this
	// Brings the layer to the top of all path layers.
	bringToFront: function () {
		if (this._renderer) {
			this._renderer._bringToFront(this);
		}
		return this;
	},

	// @method bringToBack(): this
	// Brings the layer to the bottom of all path layers.
	bringToBack: function () {
		if (this._renderer) {
			this._renderer._bringToBack(this);
		}
		return this;
	},

	getElement: function () {
		return this._path;
	},

	_reset: function () {
		// defined in children classes
		this._project();
		this._update();
	},

	_clickTolerance: function () {
		// used when doing hit detection for Canvas layers
		return (this.options.stroke ? this.options.weight / 2 : 0) + (L.Browser.touch ? 10 : 0);
	}
});



/*
 * @namespace LineUtil
 *
 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
 */

L.LineUtil = {

	// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
	// Improves rendering performance dramatically by lessening the number of points to draw.

	// @function simplify(points: Point[], tolerance: Number): Point[]
	// Dramatically reduces the number of points in a polyline while retaining
	// its shape and returns a new array of simplified points, using the
	// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
	// Used for a huge performance boost when processing/displaying Leaflet polylines for
	// each zoom level and also reducing visual noise. tolerance affects the amount of
	// simplification (lesser value means higher quality but slower and with more points).
	// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
	simplify: function (points, tolerance) {
		if (!tolerance || !points.length) {
			return points.slice();
		}

		var sqTolerance = tolerance * tolerance;

		// stage 1: vertex reduction
		points = this._reducePoints(points, sqTolerance);

		// stage 2: Douglas-Peucker simplification
		points = this._simplifyDP(points, sqTolerance);

		return points;
	},

	// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
	// Returns the distance between point `p` and segment `p1` to `p2`.
	pointToSegmentDistance:  function (p, p1, p2) {
		return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
	},

	// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
	// Returns the closest point from a point `p` on a segment `p1` to `p2`.
	closestPointOnSegment: function (p, p1, p2) {
		return this._sqClosestPointOnSegment(p, p1, p2);
	},

	// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
	_simplifyDP: function (points, sqTolerance) {

		var len = points.length,
		    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
		    markers = new ArrayConstructor(len);

		markers[0] = markers[len - 1] = 1;

		this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);

		var i,
		    newPoints = [];

		for (i = 0; i < len; i++) {
			if (markers[i]) {
				newPoints.push(points[i]);
			}
		}

		return newPoints;
	},

	_simplifyDPStep: function (points, markers, sqTolerance, first, last) {

		var maxSqDist = 0,
		    index, i, sqDist;

		for (i = first + 1; i <= last - 1; i++) {
			sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);

			if (sqDist > maxSqDist) {
				index = i;
				maxSqDist = sqDist;
			}
		}

		if (maxSqDist > sqTolerance) {
			markers[index] = 1;

			this._simplifyDPStep(points, markers, sqTolerance, first, index);
			this._simplifyDPStep(points, markers, sqTolerance, index, last);
		}
	},

	// reduce points that are too close to each other to a single point
	_reducePoints: function (points, sqTolerance) {
		var reducedPoints = [points[0]];

		for (var i = 1, prev = 0, len = points.length; i < len; i++) {
			if (this._sqDist(points[i], points[prev]) > sqTolerance) {
				reducedPoints.push(points[i]);
				prev = i;
			}
		}
		if (prev < len - 1) {
			reducedPoints.push(points[len - 1]);
		}
		return reducedPoints;
	},


	// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
	// Clips the segment a to b by rectangular bounds with the
	// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
	// (modifying the segment points directly!). Used by Leaflet to only show polyline
	// points that are on the screen or near, increasing performance.
	clipSegment: function (a, b, bounds, useLastCode, round) {
		var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
		    codeB = this._getBitCode(b, bounds),

		    codeOut, p, newCode;

		// save 2nd code to avoid calculating it on the next segment
		this._lastCode = codeB;

		while (true) {
			// if a,b is inside the clip window (trivial accept)
			if (!(codeA | codeB)) {
				return [a, b];
			}

			// if a,b is outside the clip window (trivial reject)
			if (codeA & codeB) {
				return false;
			}

			// other cases
			codeOut = codeA || codeB;
			p = this._getEdgeIntersection(a, b, codeOut, bounds, round);
			newCode = this._getBitCode(p, bounds);

			if (codeOut === codeA) {
				a = p;
				codeA = newCode;
			} else {
				b = p;
				codeB = newCode;
			}
		}
	},

	_getEdgeIntersection: function (a, b, code, bounds, round) {
		var dx = b.x - a.x,
		    dy = b.y - a.y,
		    min = bounds.min,
		    max = bounds.max,
		    x, y;

		if (code & 8) { // top
			x = a.x + dx * (max.y - a.y) / dy;
			y = max.y;

		} else if (code & 4) { // bottom
			x = a.x + dx * (min.y - a.y) / dy;
			y = min.y;

		} else if (code & 2) { // right
			x = max.x;
			y = a.y + dy * (max.x - a.x) / dx;

		} else if (code & 1) { // left
			x = min.x;
			y = a.y + dy * (min.x - a.x) / dx;
		}

		return new L.Point(x, y, round);
	},

	_getBitCode: function (p, bounds) {
		var code = 0;

		if (p.x < bounds.min.x) { // left
			code |= 1;
		} else if (p.x > bounds.max.x) { // right
			code |= 2;
		}

		if (p.y < bounds.min.y) { // bottom
			code |= 4;
		} else if (p.y > bounds.max.y) { // top
			code |= 8;
		}

		return code;
	},

	// square distance (to avoid unnecessary Math.sqrt calls)
	_sqDist: function (p1, p2) {
		var dx = p2.x - p1.x,
		    dy = p2.y - p1.y;
		return dx * dx + dy * dy;
	},

	// return closest point on segment or distance to that point
	_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
		var x = p1.x,
		    y = p1.y,
		    dx = p2.x - x,
		    dy = p2.y - y,
		    dot = dx * dx + dy * dy,
		    t;

		if (dot > 0) {
			t = ((p.x - x) * dx + (p.y - y) * dy) / dot;

			if (t > 1) {
				x = p2.x;
				y = p2.y;
			} else if (t > 0) {
				x += dx * t;
				y += dy * t;
			}
		}

		dx = p.x - x;
		dy = p.y - y;

		return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
	}
};



/*
 * @class Polyline
 * @aka L.Polyline
 * @inherits Path
 *
 * A class for drawing polyline overlays on a map. Extends `Path`.
 *
 * @example
 *
 * ```js
 * // create a red polyline from an array of LatLng points
 * var latlngs = [
 * 	[45.51, -122.68],
 * 	[37.77, -122.43],
 * 	[34.04, -118.2]
 * ];
 *
 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polyline
 * map.fitBounds(polyline.getBounds());
 * ```
 *
 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
 *
 * ```js
 * // create a red polyline from an array of arrays of LatLng points
 * var latlngs = [
 * 	[[45.51, -122.68],
 * 	 [37.77, -122.43],
 * 	 [34.04, -118.2]],
 * 	[[40.78, -73.91],
 * 	 [41.83, -87.62],
 * 	 [32.76, -96.72]]
 * ];
 * ```
 */

L.Polyline = L.Path.extend({

	// @section
	// @aka Polyline options
	options: {
		// @option smoothFactor: Number = 1.0
		// How much to simplify the polyline on each zoom level. More means
		// better performance and smoother look, and less means more accurate representation.
		smoothFactor: 1.0,

		// @option noClip: Boolean = false
		// Disable polyline clipping.
		noClip: false
	},

	initialize: function (latlngs, options) {
		L.setOptions(this, options);
		this._setLatLngs(latlngs);
	},

	// @method getLatLngs(): LatLng[]
	// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
	getLatLngs: function () {
		return this._latlngs;
	},

	// @method setLatLngs(latlngs: LatLng[]): this
	// Replaces all the points in the polyline with the given array of geographical points.
	setLatLngs: function (latlngs) {
		this._setLatLngs(latlngs);
		return this.redraw();
	},

	// @method isEmpty(): Boolean
	// Returns `true` if the Polyline has no LatLngs.
	isEmpty: function () {
		return !this._latlngs.length;
	},

	closestLayerPoint: function (p) {
		var minDistance = Infinity,
		    minPoint = null,
		    closest = L.LineUtil._sqClosestPointOnSegment,
		    p1, p2;

		for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
			var points = this._parts[j];

			for (var i = 1, len = points.length; i < len; i++) {
				p1 = points[i - 1];
				p2 = points[i];

				var sqDist = closest(p, p1, p2, true);

				if (sqDist < minDistance) {
					minDistance = sqDist;
					minPoint = closest(p, p1, p2);
				}
			}
		}
		if (minPoint) {
			minPoint.distance = Math.sqrt(minDistance);
		}
		return minPoint;
	},

	// @method getCenter(): LatLng
	// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, halfDist, segDist, dist, p1, p2, ratio,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polyline centroid algorithm; only uses the first ring if there are multiple

		for (i = 0, halfDist = 0; i < len - 1; i++) {
			halfDist += points[i].distanceTo(points[i + 1]) / 2;
		}

		// The line is so small in the current view that all points are on the same pixel.
		if (halfDist === 0) {
			return this._map.layerPointToLatLng(points[0]);
		}

		for (i = 0, dist = 0; i < len - 1; i++) {
			p1 = points[i];
			p2 = points[i + 1];
			segDist = p1.distanceTo(p2);
			dist += segDist;

			if (dist > halfDist) {
				ratio = (dist - halfDist) / segDist;
				return this._map.layerPointToLatLng([
					p2.x - ratio * (p2.x - p1.x),
					p2.y - ratio * (p2.y - p1.y)
				]);
			}
		}
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		return this._bounds;
	},

	// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
	// Adds a given point to the polyline. By default, adds to the first ring of
	// the polyline in case of a multi-polyline, but can be overridden by passing
	// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
	addLatLng: function (latlng, latlngs) {
		latlngs = latlngs || this._defaultShape();
		latlng = L.latLng(latlng);
		latlngs.push(latlng);
		this._bounds.extend(latlng);
		return this.redraw();
	},

	_setLatLngs: function (latlngs) {
		this._bounds = new L.LatLngBounds();
		this._latlngs = this._convertLatLngs(latlngs);
	},

	_defaultShape: function () {
		return L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0];
	},

	// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
	_convertLatLngs: function (latlngs) {
		var result = [],
		    flat = L.Polyline._flat(latlngs);

		for (var i = 0, len = latlngs.length; i < len; i++) {
			if (flat) {
				result[i] = L.latLng(latlngs[i]);
				this._bounds.extend(result[i]);
			} else {
				result[i] = this._convertLatLngs(latlngs[i]);
			}
		}

		return result;
	},

	_project: function () {
		var pxBounds = new L.Bounds();
		this._rings = [];
		this._projectLatlngs(this._latlngs, this._rings, pxBounds);

		var w = this._clickTolerance(),
		    p = new L.Point(w, w);

		if (this._bounds.isValid() && pxBounds.isValid()) {
			pxBounds.min._subtract(p);
			pxBounds.max._add(p);
			this._pxBounds = pxBounds;
		}
	},

	// recursively turns latlngs into a set of rings with projected coordinates
	_projectLatlngs: function (latlngs, result, projectedBounds) {
		var flat = latlngs[0] instanceof L.LatLng,
		    len = latlngs.length,
		    i, ring;

		if (flat) {
			ring = [];
			for (i = 0; i < len; i++) {
				ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
				projectedBounds.extend(ring[i]);
			}
			result.push(ring);
		} else {
			for (i = 0; i < len; i++) {
				this._projectLatlngs(latlngs[i], result, projectedBounds);
			}
		}
	},

	// clip polyline by renderer bounds so that we have less to render for performance
	_clipPoints: function () {
		var bounds = this._renderer._bounds;

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		var parts = this._parts,
		    i, j, k, len, len2, segment, points;

		for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
			points = this._rings[i];

			for (j = 0, len2 = points.length; j < len2 - 1; j++) {
				segment = L.LineUtil.clipSegment(points[j], points[j + 1], bounds, j, true);

				if (!segment) { continue; }

				parts[k] = parts[k] || [];
				parts[k].push(segment[0]);

				// if segment goes out of screen, or it's the last one, it's the end of the line part
				if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
					parts[k].push(segment[1]);
					k++;
				}
			}
		}
	},

	// simplify each clipped part of the polyline for performance
	_simplifyPoints: function () {
		var parts = this._parts,
		    tolerance = this.options.smoothFactor;

		for (var i = 0, len = parts.length; i < len; i++) {
			parts[i] = L.LineUtil.simplify(parts[i], tolerance);
		}
	},

	_update: function () {
		if (!this._map) { return; }

		this._clipPoints();
		this._simplifyPoints();
		this._updatePath();
	},

	_updatePath: function () {
		this._renderer._updatePoly(this);
	}
});

// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
// Instantiates a polyline object given an array of geographical points and
// optionally an options object. You can create a `Polyline` object with
// multiple separate lines (`MultiPolyline`) by passing an array of arrays
// of geographic points.
L.polyline = function (latlngs, options) {
	return new L.Polyline(latlngs, options);
};

L.Polyline._flat = function (latlngs) {
	// true if it's a flat array of latlngs; false if nested
	return !L.Util.isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
};



/*
 * @namespace PolyUtil
 * Various utility functions for polygon geometries.
 */

L.PolyUtil = {};

/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
 * performance. Note that polygon points needs different algorithm for clipping
 * than polyline, so there's a seperate method for it.
 */
L.PolyUtil.clipPolygon = function (points, bounds, round) {
	var clippedPoints,
	    edges = [1, 4, 2, 8],
	    i, j, k,
	    a, b,
	    len, edge, p,
	    lu = L.LineUtil;

	for (i = 0, len = points.length; i < len; i++) {
		points[i]._code = lu._getBitCode(points[i], bounds);
	}

	// for each edge (left, bottom, right, top)
	for (k = 0; k < 4; k++) {
		edge = edges[k];
		clippedPoints = [];

		for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
			a = points[i];
			b = points[j];

			// if a is inside the clip window
			if (!(a._code & edge)) {
				// if b is outside the clip window (a->b goes out of screen)
				if (b._code & edge) {
					p = lu._getEdgeIntersection(b, a, edge, bounds, round);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
				clippedPoints.push(a);

			// else if b is inside the clip window (a->b enters the screen)
			} else if (!(b._code & edge)) {
				p = lu._getEdgeIntersection(b, a, edge, bounds, round);
				p._code = lu._getBitCode(p, bounds);
				clippedPoints.push(p);
			}
		}
		points = clippedPoints;
	}

	return points;
};



/*
 * @class Polygon
 * @aka L.Polygon
 * @inherits Polyline
 *
 * A class for drawing polygon overlays on a map. Extends `Polyline`.
 *
 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
 *
 *
 * @example
 *
 * ```js
 * // create a red polygon from an array of LatLng points
 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
 *
 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
 *
 * // zoom the map to the polygon
 * map.fitBounds(polygon.getBounds());
 * ```
 *
 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
 *
 * ```js
 * var latlngs = [
 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
 * ];
 * ```
 *
 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
 *
 * ```js
 * var latlngs = [
 *   [ // first polygon
 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
 *   ],
 *   [ // second polygon
 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
 *   ]
 * ];
 * ```
 */

L.Polygon = L.Polyline.extend({

	options: {
		fill: true
	},

	isEmpty: function () {
		return !this._latlngs.length || !this._latlngs[0].length;
	},

	getCenter: function () {
		// throws error when not yet added to map as this center calculation requires projected coordinates
		if (!this._map) {
			throw new Error('Must add layer to map before using getCenter()');
		}

		var i, j, p1, p2, f, area, x, y, center,
		    points = this._rings[0],
		    len = points.length;

		if (!len) { return null; }

		// polygon centroid algorithm; only uses the first ring if there are multiple

		area = x = y = 0;

		for (i = 0, j = len - 1; i < len; j = i++) {
			p1 = points[i];
			p2 = points[j];

			f = p1.y * p2.x - p2.y * p1.x;
			x += (p1.x + p2.x) * f;
			y += (p1.y + p2.y) * f;
			area += f * 3;
		}

		if (area === 0) {
			// Polygon is so small that all points are on same pixel.
			center = points[0];
		} else {
			center = [x / area, y / area];
		}
		return this._map.layerPointToLatLng(center);
	},

	_convertLatLngs: function (latlngs) {
		var result = L.Polyline.prototype._convertLatLngs.call(this, latlngs),
		    len = result.length;

		// remove last point if it equals first one
		if (len >= 2 && result[0] instanceof L.LatLng && result[0].equals(result[len - 1])) {
			result.pop();
		}
		return result;
	},

	_setLatLngs: function (latlngs) {
		L.Polyline.prototype._setLatLngs.call(this, latlngs);
		if (L.Polyline._flat(this._latlngs)) {
			this._latlngs = [this._latlngs];
		}
	},

	_defaultShape: function () {
		return L.Polyline._flat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
	},

	_clipPoints: function () {
		// polygons need a different clipping algorithm so we redefine that

		var bounds = this._renderer._bounds,
		    w = this.options.weight,
		    p = new L.Point(w, w);

		// increase clip padding by stroke width to avoid stroke on clip edges
		bounds = new L.Bounds(bounds.min.subtract(p), bounds.max.add(p));

		this._parts = [];
		if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
			return;
		}

		if (this.options.noClip) {
			this._parts = this._rings;
			return;
		}

		for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
			clipped = L.PolyUtil.clipPolygon(this._rings[i], bounds, true);
			if (clipped.length) {
				this._parts.push(clipped);
			}
		}
	},

	_updatePath: function () {
		this._renderer._updatePoly(this, true);
	}
});


// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
L.polygon = function (latlngs, options) {
	return new L.Polygon(latlngs, options);
};



/*
 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
 */

/*
 * @class Rectangle
 * @aka L.Retangle
 * @inherits Polygon
 *
 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
 *
 * @example
 *
 * ```js
 * // define rectangle geographical bounds
 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
 *
 * // create an orange rectangle
 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
 *
 * // zoom the map to the rectangle bounds
 * map.fitBounds(bounds);
 * ```
 *
 */


L.Rectangle = L.Polygon.extend({
	initialize: function (latLngBounds, options) {
		L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
	},

	// @method setBounds(latLngBounds: LatLngBounds): this
	// Redraws the rectangle with the passed bounds.
	setBounds: function (latLngBounds) {
		return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
	},

	_boundsToLatLngs: function (latLngBounds) {
		latLngBounds = L.latLngBounds(latLngBounds);
		return [
			latLngBounds.getSouthWest(),
			latLngBounds.getNorthWest(),
			latLngBounds.getNorthEast(),
			latLngBounds.getSouthEast()
		];
	}
});


// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
L.rectangle = function (latLngBounds, options) {
	return new L.Rectangle(latLngBounds, options);
};



/*
 * @class CircleMarker
 * @aka L.CircleMarker
 * @inherits Path
 *
 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
 */

L.CircleMarker = L.Path.extend({

	// @section
	// @aka CircleMarker options
	options: {
		fill: true,

		// @option radius: Number = 10
		// Radius of the circle marker, in pixels
		radius: 10
	},

	initialize: function (latlng, options) {
		L.setOptions(this, options);
		this._latlng = L.latLng(latlng);
		this._radius = this.options.radius;
	},

	// @method setLatLng(latLng: LatLng): this
	// Sets the position of a circle marker to a new location.
	setLatLng: function (latlng) {
		this._latlng = L.latLng(latlng);
		this.redraw();
		return this.fire('move', {latlng: this._latlng});
	},

	// @method getLatLng(): LatLng
	// Returns the current geographical position of the circle marker
	getLatLng: function () {
		return this._latlng;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle marker. Units are in pixels.
	setRadius: function (radius) {
		this.options.radius = this._radius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of the circle
	getRadius: function () {
		return this._radius;
	},

	setStyle : function (options) {
		var radius = options && options.radius || this._radius;
		L.Path.prototype.setStyle.call(this, options);
		this.setRadius(radius);
		return this;
	},

	_project: function () {
		this._point = this._map.latLngToLayerPoint(this._latlng);
		this._updateBounds();
	},

	_updateBounds: function () {
		var r = this._radius,
		    r2 = this._radiusY || r,
		    w = this._clickTolerance(),
		    p = [r + w, r2 + w];
		this._pxBounds = new L.Bounds(this._point.subtract(p), this._point.add(p));
	},

	_update: function () {
		if (this._map) {
			this._updatePath();
		}
	},

	_updatePath: function () {
		this._renderer._updateCircle(this);
	},

	_empty: function () {
		return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
	}
});


// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
// Instantiates a circle marker object given a geographical point, and an optional options object.
L.circleMarker = function (latlng, options) {
	return new L.CircleMarker(latlng, options);
};



/*
 * @class Circle
 * @aka L.Circle
 * @inherits CircleMarker
 *
 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
 *
 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
 *
 * @example
 *
 * ```js
 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
 * ```
 */

L.Circle = L.CircleMarker.extend({

	initialize: function (latlng, options, legacyOptions) {
		if (typeof options === 'number') {
			// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
			options = L.extend({}, legacyOptions, {radius: options});
		}
		L.setOptions(this, options);
		this._latlng = L.latLng(latlng);

		if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }

		// @section
		// @aka Circle options
		// @option radius: Number; Radius of the circle, in meters.
		this._mRadius = this.options.radius;
	},

	// @method setRadius(radius: Number): this
	// Sets the radius of a circle. Units are in meters.
	setRadius: function (radius) {
		this._mRadius = radius;
		return this.redraw();
	},

	// @method getRadius(): Number
	// Returns the current radius of a circle. Units are in meters.
	getRadius: function () {
		return this._mRadius;
	},

	// @method getBounds(): LatLngBounds
	// Returns the `LatLngBounds` of the path.
	getBounds: function () {
		var half = [this._radius, this._radiusY || this._radius];

		return new L.LatLngBounds(
			this._map.layerPointToLatLng(this._point.subtract(half)),
			this._map.layerPointToLatLng(this._point.add(half)));
	},

	setStyle: L.Path.prototype.setStyle,

	_project: function () {

		var lng = this._latlng.lng,
		    lat = this._latlng.lat,
		    map = this._map,
		    crs = map.options.crs;

		if (crs.distance === L.CRS.Earth.distance) {
			var d = Math.PI / 180,
			    latR = (this._mRadius / L.CRS.Earth.R) / d,
			    top = map.project([lat + latR, lng]),
			    bottom = map.project([lat - latR, lng]),
			    p = top.add(bottom).divideBy(2),
			    lat2 = map.unproject(p).lat,
			    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
			            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;

			if (isNaN(lngR) || lngR === 0) {
				lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
			}

			this._point = p.subtract(map.getPixelOrigin());
			this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
			this._radiusY = Math.max(Math.round(p.y - top.y), 1);

		} else {
			var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));

			this._point = map.latLngToLayerPoint(this._latlng);
			this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
		}

		this._updateBounds();
	}
});

// @factory L.circle(latlng: LatLng, options?: Circle options)
// Instantiates a circle object given a geographical point, and an options object
// which contains the circle radius.
// @alternative
// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
// Do not use in new applications or plugins.
L.circle = function (latlng, options, legacyOptions) {
	return new L.Circle(latlng, options, legacyOptions);
};



/*
 * @class SVG
 * @inherits Renderer
 * @aka L.SVG
 *
 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
 * available in all web browsers, notably Android 2.x and 3.x.
 *
 * Although SVG is not available on IE7 and IE8, these browsers support
 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
 * (a now deprecated technology), and the SVG renderer will fall back to VML in
 * this case.
 *
 * @example
 *
 * Use SVG by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.svg()
 * });
 * ```
 *
 * Use a SVG renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.svg({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

L.SVG = L.Renderer.extend({

	getEvents: function () {
		var events = L.Renderer.prototype.getEvents.call(this);
		events.zoomstart = this._onZoomStart;
		return events;
	},

	_initContainer: function () {
		this._container = L.SVG.create('svg');

		// makes it possible to click through svg root; we'll reset it back in individual paths
		this._container.setAttribute('pointer-events', 'none');

		this._rootGroup = L.SVG.create('g');
		this._container.appendChild(this._rootGroup);
	},

	_onZoomStart: function () {
		// Drag-then-pinch interactions might mess up the center and zoom.
		// In this case, the easiest way to prevent this is re-do the renderer
		//   bounds and padding when the zooming starts.
		this._update();
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		L.Renderer.prototype._update.call(this);

		var b = this._bounds,
		    size = b.getSize(),
		    container = this._container;

		// set size of svg-container if changed
		if (!this._svgSize || !this._svgSize.equals(size)) {
			this._svgSize = size;
			container.setAttribute('width', size.x);
			container.setAttribute('height', size.y);
		}

		// movement: update container viewBox so that we don't have to change coordinates of individual layers
		L.DomUtil.setPosition(container, b.min);
		container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));

		this.fire('update');
	},

	// methods below are called by vector layers implementations

	_initPath: function (layer) {
		var path = layer._path = L.SVG.create('path');

		// @namespace Path
		// @option className: String = null
		// Custom class name set on an element. Only for SVG renderer.
		if (layer.options.className) {
			L.DomUtil.addClass(path, layer.options.className);
		}

		if (layer.options.interactive) {
			L.DomUtil.addClass(path, 'leaflet-interactive');
		}

		this._updateStyle(layer);
		this._layers[L.stamp(layer)] = layer;
	},

	_addPath: function (layer) {
		this._rootGroup.appendChild(layer._path);
		layer.addInteractiveTarget(layer._path);
	},

	_removePath: function (layer) {
		L.DomUtil.remove(layer._path);
		layer.removeInteractiveTarget(layer._path);
		delete this._layers[L.stamp(layer)];
	},

	_updatePath: function (layer) {
		layer._project();
		layer._update();
	},

	_updateStyle: function (layer) {
		var path = layer._path,
		    options = layer.options;

		if (!path) { return; }

		if (options.stroke) {
			path.setAttribute('stroke', options.color);
			path.setAttribute('stroke-opacity', options.opacity);
			path.setAttribute('stroke-width', options.weight);
			path.setAttribute('stroke-linecap', options.lineCap);
			path.setAttribute('stroke-linejoin', options.lineJoin);

			if (options.dashArray) {
				path.setAttribute('stroke-dasharray', options.dashArray);
			} else {
				path.removeAttribute('stroke-dasharray');
			}

			if (options.dashOffset) {
				path.setAttribute('stroke-dashoffset', options.dashOffset);
			} else {
				path.removeAttribute('stroke-dashoffset');
			}
		} else {
			path.setAttribute('stroke', 'none');
		}

		if (options.fill) {
			path.setAttribute('fill', options.fillColor || options.color);
			path.setAttribute('fill-opacity', options.fillOpacity);
			path.setAttribute('fill-rule', options.fillRule || 'evenodd');
		} else {
			path.setAttribute('fill', 'none');
		}
	},

	_updatePoly: function (layer, closed) {
		this._setPath(layer, L.SVG.pointsToPath(layer._parts, closed));
	},

	_updateCircle: function (layer) {
		var p = layer._point,
		    r = layer._radius,
		    r2 = layer._radiusY || r,
		    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';

		// drawing a circle with two half-arcs
		var d = layer._empty() ? 'M0 0' :
				'M' + (p.x - r) + ',' + p.y +
				arc + (r * 2) + ',0 ' +
				arc + (-r * 2) + ',0 ';

		this._setPath(layer, d);
	},

	_setPath: function (layer, path) {
		layer._path.setAttribute('d', path);
	},

	// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
	_bringToFront: function (layer) {
		L.DomUtil.toFront(layer._path);
	},

	_bringToBack: function (layer) {
		L.DomUtil.toBack(layer._path);
	}
});


// @namespace SVG; @section
// There are several static functions which can be called without instantiating L.SVG:
L.extend(L.SVG, {
	// @function create(name: String): SVGElement
	// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
	// corresponding to the class name passed. For example, using 'line' will return
	// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
	create: function (name) {
		return document.createElementNS('http://www.w3.org/2000/svg', name);
	},

	// @function pointsToPath(rings: Point[], closed: Boolean): String
	// Generates a SVG path string for multiple rings, with each ring turning
	// into "M..L..L.." instructions
	pointsToPath: function (rings, closed) {
		var str = '',
		    i, j, len, len2, points, p;

		for (i = 0, len = rings.length; i < len; i++) {
			points = rings[i];

			for (j = 0, len2 = points.length; j < len2; j++) {
				p = points[j];
				str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
			}

			// closes the ring for polygons; "x" is VML syntax
			str += closed ? (L.Browser.svg ? 'z' : 'x') : '';
		}

		// SVG complains about empty path strings
		return str || 'M0 0';
	}
});

// @namespace Browser; @property svg: Boolean
// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
L.Browser.svg = !!(document.createElementNS && L.SVG.create('svg').createSVGRect);


// @namespace SVG
// @factory L.svg(options?: Renderer options)
// Creates a SVG renderer with the given options.
L.svg = function (options) {
	return L.Browser.svg || L.Browser.vml ? new L.SVG(options) : null;
};



/*
 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
 */

/*
 * @class SVG
 *
 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
 *
 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
 * with old versions of Internet Explorer.
 */

// @namespace Browser; @property vml: Boolean
// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
L.Browser.vml = !L.Browser.svg && (function () {
	try {
		var div = document.createElement('div');
		div.innerHTML = '<v:shape adj="1"/>';

		var shape = div.firstChild;
		shape.style.behavior = 'url(#default#VML)';

		return shape && (typeof shape.adj === 'object');

	} catch (e) {
		return false;
	}
}());

// redefine some SVG methods to handle VML syntax which is similar but with some differences
L.SVG.include(!L.Browser.vml ? {} : {

	_initContainer: function () {
		this._container = L.DomUtil.create('div', 'leaflet-vml-container');
	},

	_update: function () {
		if (this._map._animatingZoom) { return; }
		L.Renderer.prototype._update.call(this);
		this.fire('update');
	},

	_initPath: function (layer) {
		var container = layer._container = L.SVG.create('shape');

		L.DomUtil.addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));

		container.coordsize = '1 1';

		layer._path = L.SVG.create('path');
		container.appendChild(layer._path);

		this._updateStyle(layer);
		this._layers[L.stamp(layer)] = layer;
	},

	_addPath: function (layer) {
		var container = layer._container;
		this._container.appendChild(container);

		if (layer.options.interactive) {
			layer.addInteractiveTarget(container);
		}
	},

	_removePath: function (layer) {
		var container = layer._container;
		L.DomUtil.remove(container);
		layer.removeInteractiveTarget(container);
		delete this._layers[L.stamp(layer)];
	},

	_updateStyle: function (layer) {
		var stroke = layer._stroke,
		    fill = layer._fill,
		    options = layer.options,
		    container = layer._container;

		container.stroked = !!options.stroke;
		container.filled = !!options.fill;

		if (options.stroke) {
			if (!stroke) {
				stroke = layer._stroke = L.SVG.create('stroke');
			}
			container.appendChild(stroke);
			stroke.weight = options.weight + 'px';
			stroke.color = options.color;
			stroke.opacity = options.opacity;

			if (options.dashArray) {
				stroke.dashStyle = L.Util.isArray(options.dashArray) ?
				    options.dashArray.join(' ') :
				    options.dashArray.replace(/( *, *)/g, ' ');
			} else {
				stroke.dashStyle = '';
			}
			stroke.endcap = options.lineCap.replace('butt', 'flat');
			stroke.joinstyle = options.lineJoin;

		} else if (stroke) {
			container.removeChild(stroke);
			layer._stroke = null;
		}

		if (options.fill) {
			if (!fill) {
				fill = layer._fill = L.SVG.create('fill');
			}
			container.appendChild(fill);
			fill.color = options.fillColor || options.color;
			fill.opacity = options.fillOpacity;

		} else if (fill) {
			container.removeChild(fill);
			layer._fill = null;
		}
	},

	_updateCircle: function (layer) {
		var p = layer._point.round(),
		    r = Math.round(layer._radius),
		    r2 = Math.round(layer._radiusY || r);

		this._setPath(layer, layer._empty() ? 'M0 0' :
				'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
	},

	_setPath: function (layer, path) {
		layer._path.v = path;
	},

	_bringToFront: function (layer) {
		L.DomUtil.toFront(layer._container);
	},

	_bringToBack: function (layer) {
		L.DomUtil.toBack(layer._container);
	}
});

if (L.Browser.vml) {
	L.SVG.create = (function () {
		try {
			document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
			return function (name) {
				return document.createElement('<lvml:' + name + ' class="lvml">');
			};
		} catch (e) {
			return function (name) {
				return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
			};
		}
	})();
}



/*
 * @class Canvas
 * @inherits Renderer
 * @aka L.Canvas
 *
 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
 * Inherits `Renderer`.
 *
 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
 * available in all web browsers, notably IE8, and overlapping geometries might
 * not display properly in some edge cases.
 *
 * @example
 *
 * Use Canvas by default for all paths in the map:
 *
 * ```js
 * var map = L.map('map', {
 * 	renderer: L.canvas()
 * });
 * ```
 *
 * Use a Canvas renderer with extra padding for specific vector geometries:
 *
 * ```js
 * var map = L.map('map');
 * var myRenderer = L.canvas({ padding: 0.5 });
 * var line = L.polyline( coordinates, { renderer: myRenderer } );
 * var circle = L.circle( center, { renderer: myRenderer } );
 * ```
 */

L.Canvas = L.Renderer.extend({
	getEvents: function () {
		var events = L.Renderer.prototype.getEvents.call(this);
		events.viewprereset = this._onViewPreReset;
		return events;
	},

	_onViewPreReset: function () {
		// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
		this._postponeUpdatePaths = true;
	},

	onAdd: function () {
		L.Renderer.prototype.onAdd.call(this);

		// Redraw vectors since canvas is cleared upon removal,
		// in case of removing the renderer itself from the map.
		this._draw();
	},

	_initContainer: function () {
		var container = this._container = document.createElement('canvas');

		L.DomEvent
			.on(container, 'mousemove', L.Util.throttle(this._onMouseMove, 32, this), this)
			.on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this)
			.on(container, 'mouseout', this._handleMouseOut, this);

		this._ctx = container.getContext('2d');
	},

	_updatePaths: function () {
		if (this._postponeUpdatePaths) { return; }

		var layer;
		this._redrawBounds = null;
		for (var id in this._layers) {
			layer = this._layers[id];
			layer._update();
		}
		this._redraw();
	},

	_update: function () {
		if (this._map._animatingZoom && this._bounds) { return; }

		this._drawnLayers = {};

		L.Renderer.prototype._update.call(this);

		var b = this._bounds,
		    container = this._container,
		    size = b.getSize(),
		    m = L.Browser.retina ? 2 : 1;

		L.DomUtil.setPosition(container, b.min);

		// set canvas size (also clearing it); use double size on retina
		container.width = m * size.x;
		container.height = m * size.y;
		container.style.width = size.x + 'px';
		container.style.height = size.y + 'px';

		if (L.Browser.retina) {
			this._ctx.scale(2, 2);
		}

		// translate so we use the same path coordinates after canvas element moves
		this._ctx.translate(-b.min.x, -b.min.y);

		// Tell paths to redraw themselves
		this.fire('update');
	},

	_reset: function () {
		L.Renderer.prototype._reset.call(this);

		if (this._postponeUpdatePaths) {
			this._postponeUpdatePaths = false;
			this._updatePaths();
		}
	},

	_initPath: function (layer) {
		this._updateDashArray(layer);
		this._layers[L.stamp(layer)] = layer;

		var order = layer._order = {
			layer: layer,
			prev: this._drawLast,
			next: null
		};
		if (this._drawLast) { this._drawLast.next = order; }
		this._drawLast = order;
		this._drawFirst = this._drawFirst || this._drawLast;
	},

	_addPath: function (layer) {
		this._requestRedraw(layer);
	},

	_removePath: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (next) {
			next.prev = prev;
		} else {
			this._drawLast = prev;
		}
		if (prev) {
			prev.next = next;
		} else {
			this._drawFirst = next;
		}

		delete layer._order;

		delete this._layers[L.stamp(layer)];

		this._requestRedraw(layer);
	},

	_updatePath: function (layer) {
		// Redraw the union of the layer's old pixel
		// bounds and the new pixel bounds.
		this._extendRedrawBounds(layer);
		layer._project();
		layer._update();
		// The redraw will extend the redraw bounds
		// with the new pixel bounds.
		this._requestRedraw(layer);
	},

	_updateStyle: function (layer) {
		this._updateDashArray(layer);
		this._requestRedraw(layer);
	},

	_updateDashArray: function (layer) {
		if (layer.options.dashArray) {
			var parts = layer.options.dashArray.split(','),
			    dashArray = [],
			    i;
			for (i = 0; i < parts.length; i++) {
				dashArray.push(Number(parts[i]));
			}
			layer.options._dashArray = dashArray;
		}
	},

	_requestRedraw: function (layer) {
		if (!this._map) { return; }

		this._extendRedrawBounds(layer);
		this._redrawRequest = this._redrawRequest || L.Util.requestAnimFrame(this._redraw, this);
	},

	_extendRedrawBounds: function (layer) {
		var padding = (layer.options.weight || 0) + 1;
		this._redrawBounds = this._redrawBounds || new L.Bounds();
		this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
		this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
	},

	_redraw: function () {
		this._redrawRequest = null;

		if (this._redrawBounds) {
			this._redrawBounds.min._floor();
			this._redrawBounds.max._ceil();
		}

		this._clear(); // clear layers in redraw bounds
		this._draw(); // draw layers

		this._redrawBounds = null;
	},

	_clear: function () {
		var bounds = this._redrawBounds;
		if (bounds) {
			var size = bounds.getSize();
			this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
		} else {
			this._ctx.clearRect(0, 0, this._container.width, this._container.height);
		}
	},

	_draw: function () {
		var layer, bounds = this._redrawBounds;
		this._ctx.save();
		if (bounds) {
			var size = bounds.getSize();
			this._ctx.beginPath();
			this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
			this._ctx.clip();
		}

		this._drawing = true;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
				layer._updatePath();
			}
		}

		this._drawing = false;

		this._ctx.restore();  // Restore state before clipping.
	},

	_updatePoly: function (layer, closed) {
		if (!this._drawing) { return; }

		var i, j, len2, p,
		    parts = layer._parts,
		    len = parts.length,
		    ctx = this._ctx;

		if (!len) { return; }

		this._drawnLayers[layer._leaflet_id] = layer;

		ctx.beginPath();

		if (ctx.setLineDash) {
			ctx.setLineDash(layer.options && layer.options._dashArray || []);
		}

		for (i = 0; i < len; i++) {
			for (j = 0, len2 = parts[i].length; j < len2; j++) {
				p = parts[i][j];
				ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
			}
			if (closed) {
				ctx.closePath();
			}
		}

		this._fillStroke(ctx, layer);

		// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
	},

	_updateCircle: function (layer) {

		if (!this._drawing || layer._empty()) { return; }

		var p = layer._point,
		    ctx = this._ctx,
		    r = layer._radius,
		    s = (layer._radiusY || r) / r;

		this._drawnLayers[layer._leaflet_id] = layer;

		if (s !== 1) {
			ctx.save();
			ctx.scale(1, s);
		}

		ctx.beginPath();
		ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);

		if (s !== 1) {
			ctx.restore();
		}

		this._fillStroke(ctx, layer);
	},

	_fillStroke: function (ctx, layer) {
		var options = layer.options;

		if (options.fill) {
			ctx.globalAlpha = options.fillOpacity;
			ctx.fillStyle = options.fillColor || options.color;
			ctx.fill(options.fillRule || 'evenodd');
		}

		if (options.stroke && options.weight !== 0) {
			ctx.globalAlpha = options.opacity;
			ctx.lineWidth = options.weight;
			ctx.strokeStyle = options.color;
			ctx.lineCap = options.lineCap;
			ctx.lineJoin = options.lineJoin;
			ctx.stroke();
		}
	},

	// Canvas obviously doesn't have mouse events for individual drawn objects,
	// so we emulate that by calculating what's under the mouse on mousemove/click manually

	_onClick: function (e) {
		var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
				clickedLayer = layer;
			}
		}
		if (clickedLayer)  {
			L.DomEvent._fakeStop(e);
			this._fireEvent([clickedLayer], e);
		}
	},

	_onMouseMove: function (e) {
		if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }

		var point = this._map.mouseEventToLayerPoint(e);
		this._handleMouseHover(e, point);
	},


	_handleMouseOut: function (e) {
		var layer = this._hoveredLayer;
		if (layer) {
			// if we're leaving the layer, fire mouseout
			L.DomUtil.removeClass(this._container, 'leaflet-interactive');
			this._fireEvent([layer], e, 'mouseout');
			this._hoveredLayer = null;
		}
	},

	_handleMouseHover: function (e, point) {
		var layer, candidateHoveredLayer;

		for (var order = this._drawFirst; order; order = order.next) {
			layer = order.layer;
			if (layer.options.interactive && layer._containsPoint(point)) {
				candidateHoveredLayer = layer;
			}
		}

		if (candidateHoveredLayer !== this._hoveredLayer) {
			this._handleMouseOut(e);

			if (candidateHoveredLayer) {
				L.DomUtil.addClass(this._container, 'leaflet-interactive'); // change cursor
				this._fireEvent([candidateHoveredLayer], e, 'mouseover');
				this._hoveredLayer = candidateHoveredLayer;
			}
		}

		if (this._hoveredLayer) {
			this._fireEvent([this._hoveredLayer], e);
		}
	},

	_fireEvent: function (layers, e, type) {
		this._map._fireDOMEvent(e, type || e.type, layers);
	},

	_bringToFront: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (next) {
			next.prev = prev;
		} else {
			// Already last
			return;
		}
		if (prev) {
			prev.next = next;
		} else if (next) {
			// Update first entry unless this is the
			// signle entry
			this._drawFirst = next;
		}

		order.prev = this._drawLast;
		this._drawLast.next = order;

		order.next = null;
		this._drawLast = order;

		this._requestRedraw(layer);
	},

	_bringToBack: function (layer) {
		var order = layer._order;
		var next = order.next;
		var prev = order.prev;

		if (prev) {
			prev.next = next;
		} else {
			// Already first
			return;
		}
		if (next) {
			next.prev = prev;
		} else if (prev) {
			// Update last entry unless this is the
			// signle entry
			this._drawLast = prev;
		}

		order.prev = null;

		order.next = this._drawFirst;
		this._drawFirst.prev = order;
		this._drawFirst = order;

		this._requestRedraw(layer);
	}
});

// @namespace Browser; @property canvas: Boolean
// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
L.Browser.canvas = (function () {
	return !!document.createElement('canvas').getContext;
}());

// @namespace Canvas
// @factory L.canvas(options?: Renderer options)
// Creates a Canvas renderer with the given options.
L.canvas = function (options) {
	return L.Browser.canvas ? new L.Canvas(options) : null;
};

L.Polyline.prototype._containsPoint = function (p, closed) {
	var i, j, k, len, len2, part,
	    w = this._clickTolerance();

	if (!this._pxBounds.contains(p)) { return false; }

	// hit detection for polylines
	for (i = 0, len = this._parts.length; i < len; i++) {
		part = this._parts[i];

		for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
			if (!closed && (j === 0)) { continue; }

			if (L.LineUtil.pointToSegmentDistance(p, part[k], part[j]) <= w) {
				return true;
			}
		}
	}
	return false;
};

L.Polygon.prototype._containsPoint = function (p) {
	var inside = false,
	    part, p1, p2, i, j, k, len, len2;

	if (!this._pxBounds.contains(p)) { return false; }

	// ray casting algorithm for detecting if point is in polygon
	for (i = 0, len = this._parts.length; i < len; i++) {
		part = this._parts[i];

		for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
			p1 = part[j];
			p2 = part[k];

			if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
				inside = !inside;
			}
		}
	}

	// also check if it's on polygon stroke
	return inside || L.Polyline.prototype._containsPoint.call(this, p, true);
};

L.CircleMarker.prototype._containsPoint = function (p) {
	return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
};



/*
 * @class GeoJSON
 * @aka L.GeoJSON
 * @inherits FeatureGroup
 *
 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
 *
 * @example
 *
 * ```js
 * L.geoJSON(data, {
 * 	style: function (feature) {
 * 		return {color: feature.properties.color};
 * 	}
 * }).bindPopup(function (layer) {
 * 	return layer.feature.properties.description;
 * }).addTo(map);
 * ```
 */

L.GeoJSON = L.FeatureGroup.extend({

	/* @section
	 * @aka GeoJSON options
	 *
	 * @option pointToLayer: Function = *
	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
	 * The default is to spawn a default `Marker`:
	 * ```js
	 * function(geoJsonPoint, latlng) {
	 * 	return L.marker(latlng);
	 * }
	 * ```
	 *
	 * @option style: Function = *
	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
	 * called internally when data is added.
	 * The default value is to not override any defaults:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return {}
	 * }
	 * ```
	 *
	 * @option onEachFeature: Function = *
	 * A `Function` that will be called once for each created `Feature`, after it has
	 * been created and styled. Useful for attaching events and popups to features.
	 * The default is to do nothing with the newly created layers:
	 * ```js
	 * function (feature, layer) {}
	 * ```
	 *
	 * @option filter: Function = *
	 * A `Function` that will be used to decide whether to include a feature or not.
	 * The default is to include all features:
	 * ```js
	 * function (geoJsonFeature) {
	 * 	return true;
	 * }
	 * ```
	 * Note: dynamically changing the `filter` option will have effect only on newly
	 * added data. It will _not_ re-evaluate already included features.
	 *
	 * @option coordsToLatLng: Function = *
	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
	 * The default is the `coordsToLatLng` static method.
	 */

	initialize: function (geojson, options) {
		L.setOptions(this, options);

		this._layers = {};

		if (geojson) {
			this.addData(geojson);
		}
	},

	// @method addData( <GeoJSON> data ): this
	// Adds a GeoJSON object to the layer.
	addData: function (geojson) {
		var features = L.Util.isArray(geojson) ? geojson : geojson.features,
		    i, len, feature;

		if (features) {
			for (i = 0, len = features.length; i < len; i++) {
				// only add this if geometry or geometries are set and not null
				feature = features[i];
				if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
					this.addData(feature);
				}
			}
			return this;
		}

		var options = this.options;

		if (options.filter && !options.filter(geojson)) { return this; }

		var layer = L.GeoJSON.geometryToLayer(geojson, options);
		if (!layer) {
			return this;
		}
		layer.feature = L.GeoJSON.asFeature(geojson);

		layer.defaultOptions = layer.options;
		this.resetStyle(layer);

		if (options.onEachFeature) {
			options.onEachFeature(geojson, layer);
		}

		return this.addLayer(layer);
	},

	// @method resetStyle( <Path> layer ): this
	// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
	resetStyle: function (layer) {
		// reset any custom styles
		layer.options = L.Util.extend({}, layer.defaultOptions);
		this._setLayerStyle(layer, this.options.style);
		return this;
	},

	// @method setStyle( <Function> style ): this
	// Changes styles of GeoJSON vector layers with the given style function.
	setStyle: function (style) {
		return this.eachLayer(function (layer) {
			this._setLayerStyle(layer, style);
		}, this);
	},

	_setLayerStyle: function (layer, style) {
		if (typeof style === 'function') {
			style = style(layer.feature);
		}
		if (layer.setStyle) {
			layer.setStyle(style);
		}
	}
});

// @section
// There are several static functions which can be called without instantiating L.GeoJSON:
L.extend(L.GeoJSON, {
	// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
	// Creates a `Layer` from a given GeoJSON feature. Can use a custom
	// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
	// functions if provided as options.
	geometryToLayer: function (geojson, options) {

		var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
		    coords = geometry ? geometry.coordinates : null,
		    layers = [],
		    pointToLayer = options && options.pointToLayer,
		    coordsToLatLng = options && options.coordsToLatLng || this.coordsToLatLng,
		    latlng, latlngs, i, len;

		if (!coords && !geometry) {
			return null;
		}

		switch (geometry.type) {
		case 'Point':
			latlng = coordsToLatLng(coords);
			return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);

		case 'MultiPoint':
			for (i = 0, len = coords.length; i < len; i++) {
				latlng = coordsToLatLng(coords[i]);
				layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
			}
			return new L.FeatureGroup(layers);

		case 'LineString':
		case 'MultiLineString':
			latlngs = this.coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, coordsToLatLng);
			return new L.Polyline(latlngs, options);

		case 'Polygon':
		case 'MultiPolygon':
			latlngs = this.coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, coordsToLatLng);
			return new L.Polygon(latlngs, options);

		case 'GeometryCollection':
			for (i = 0, len = geometry.geometries.length; i < len; i++) {
				var layer = this.geometryToLayer({
					geometry: geometry.geometries[i],
					type: 'Feature',
					properties: geojson.properties
				}, options);

				if (layer) {
					layers.push(layer);
				}
			}
			return new L.FeatureGroup(layers);

		default:
			throw new Error('Invalid GeoJSON object.');
		}
	},

	// @function coordsToLatLng(coords: Array): LatLng
	// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
	// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
	coordsToLatLng: function (coords) {
		return new L.LatLng(coords[1], coords[0], coords[2]);
	},

	// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
	// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
	// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
	// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
	coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) {
		var latlngs = [];

		for (var i = 0, len = coords.length, latlng; i < len; i++) {
			latlng = levelsDeep ?
			        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
			        (coordsToLatLng || this.coordsToLatLng)(coords[i]);

			latlngs.push(latlng);
		}

		return latlngs;
	},

	// @function latLngToCoords(latlng: LatLng): Array
	// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
	latLngToCoords: function (latlng) {
		return latlng.alt !== undefined ?
				[latlng.lng, latlng.lat, latlng.alt] :
				[latlng.lng, latlng.lat];
	},

	// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
	// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
	// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
	latLngsToCoords: function (latlngs, levelsDeep, closed) {
		var coords = [];

		for (var i = 0, len = latlngs.length; i < len; i++) {
			coords.push(levelsDeep ?
				L.GeoJSON.latLngsToCoords(latlngs[i], levelsDeep - 1, closed) :
				L.GeoJSON.latLngToCoords(latlngs[i]));
		}

		if (!levelsDeep && closed) {
			coords.push(coords[0]);
		}

		return coords;
	},

	getFeature: function (layer, newGeometry) {
		return layer.feature ?
				L.extend({}, layer.feature, {geometry: newGeometry}) :
				L.GeoJSON.asFeature(newGeometry);
	},

	// @function asFeature(geojson: Object): Object
	// Normalize GeoJSON geometries/features into GeoJSON features.
	asFeature: function (geojson) {
		if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
			return geojson;
		}

		return {
			type: 'Feature',
			properties: {},
			geometry: geojson
		};
	}
});

var PointToGeoJSON = {
	toGeoJSON: function () {
		return L.GeoJSON.getFeature(this, {
			type: 'Point',
			coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
		});
	}
};

// @namespace Marker
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
L.Marker.include(PointToGeoJSON);

// @namespace CircleMarker
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
L.Circle.include(PointToGeoJSON);
L.CircleMarker.include(PointToGeoJSON);


// @namespace Polyline
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
L.Polyline.prototype.toGeoJSON = function () {
	var multi = !L.Polyline._flat(this._latlngs);

	var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 1 : 0);

	return L.GeoJSON.getFeature(this, {
		type: (multi ? 'Multi' : '') + 'LineString',
		coordinates: coords
	});
};

// @namespace Polygon
// @method toGeoJSON(): Object
// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
L.Polygon.prototype.toGeoJSON = function () {
	var holes = !L.Polyline._flat(this._latlngs),
	    multi = holes && !L.Polyline._flat(this._latlngs[0]);

	var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true);

	if (!holes) {
		coords = [coords];
	}

	return L.GeoJSON.getFeature(this, {
		type: (multi ? 'Multi' : '') + 'Polygon',
		coordinates: coords
	});
};


// @namespace LayerGroup
L.LayerGroup.include({
	toMultiPoint: function () {
		var coords = [];

		this.eachLayer(function (layer) {
			coords.push(layer.toGeoJSON().geometry.coordinates);
		});

		return L.GeoJSON.getFeature(this, {
			type: 'MultiPoint',
			coordinates: coords
		});
	},

	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `GeometryCollection`).
	toGeoJSON: function () {

		var type = this.feature && this.feature.geometry && this.feature.geometry.type;

		if (type === 'MultiPoint') {
			return this.toMultiPoint();
		}

		var isGeometryCollection = type === 'GeometryCollection',
		    jsons = [];

		this.eachLayer(function (layer) {
			if (layer.toGeoJSON) {
				var json = layer.toGeoJSON();
				jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
			}
		});

		if (isGeometryCollection) {
			return L.GeoJSON.getFeature(this, {
				geometries: jsons,
				type: 'GeometryCollection'
			});
		}

		return {
			type: 'FeatureCollection',
			features: jsons
		};
	}
});

// @namespace GeoJSON
// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
// Creates a GeoJSON layer. Optionally accepts an object in
// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
// (you can alternatively add it later with `addData` method) and an `options` object.
L.geoJSON = function (geojson, options) {
	return new L.GeoJSON(geojson, options);
};
// Backward compatibility.
L.geoJson = L.geoJSON;



/*
 * @class Draggable
 * @aka L.Draggable
 * @inherits Evented
 *
 * A class for making DOM elements draggable (including touch support).
 * Used internally for map and marker dragging. Only works for elements
 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
 *
 * @example
 * ```js
 * var draggable = new L.Draggable(elementToDrag);
 * draggable.enable();
 * ```
 */

L.Draggable = L.Evented.extend({

	options: {
		// @option clickTolerance: Number = 3
		// The max number of pixels a user can shift the mouse pointer during a click
		// for it to be considered a valid click (as opposed to a mouse drag).
		clickTolerance: 3
	},

	statics: {
		START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
		END: {
			mousedown: 'mouseup',
			touchstart: 'touchend',
			pointerdown: 'touchend',
			MSPointerDown: 'touchend'
		},
		MOVE: {
			mousedown: 'mousemove',
			touchstart: 'touchmove',
			pointerdown: 'touchmove',
			MSPointerDown: 'touchmove'
		}
	},

	// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline: Boolean)
	// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
	initialize: function (element, dragStartTarget, preventOutline) {
		this._element = element;
		this._dragStartTarget = dragStartTarget || element;
		this._preventOutline = preventOutline;
	},

	// @method enable()
	// Enables the dragging ability
	enable: function () {
		if (this._enabled) { return; }

		L.DomEvent.on(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);

		this._enabled = true;
	},

	// @method disable()
	// Disables the dragging ability
	disable: function () {
		if (!this._enabled) { return; }

		// If we're currently dragging this draggable,
		// disabling it counts as first ending the drag.
		if (L.Draggable._dragging === this) {
			this.finishDrag();
		}

		L.DomEvent.off(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);

		this._enabled = false;
		this._moved = false;
	},

	_onDown: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		this._moved = false;

		if (L.DomUtil.hasClass(this._element, 'leaflet-zoom-anim')) { return; }

		if (L.Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
		L.Draggable._dragging = this;  // Prevent dragging multiple objects at once.

		if (this._preventOutline) {
			L.DomUtil.preventOutline(this._element);
		}

		L.DomUtil.disableImageDrag();
		L.DomUtil.disableTextSelection();

		if (this._moving) { return; }

		// @event down: Event
		// Fired when a drag is about to start.
		this.fire('down');

		var first = e.touches ? e.touches[0] : e;

		this._startPoint = new L.Point(first.clientX, first.clientY);

		L.DomEvent
			.on(document, L.Draggable.MOVE[e.type], this._onMove, this)
			.on(document, L.Draggable.END[e.type], this._onUp, this);
	},

	_onMove: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }

		if (e.touches && e.touches.length > 1) {
			this._moved = true;
			return;
		}

		var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
		    newPoint = new L.Point(first.clientX, first.clientY),
		    offset = newPoint.subtract(this._startPoint);

		if (!offset.x && !offset.y) { return; }
		if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }

		L.DomEvent.preventDefault(e);

		if (!this._moved) {
			// @event dragstart: Event
			// Fired when a drag starts
			this.fire('dragstart');

			this._moved = true;
			this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);

			L.DomUtil.addClass(document.body, 'leaflet-dragging');

			this._lastTarget = e.target || e.srcElement;
			// IE and Edge do not give the <use> element, so fetch it
			// if necessary
			if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
				this._lastTarget = this._lastTarget.correspondingUseElement;
			}
			L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
		}

		this._newPos = this._startPos.add(offset);
		this._moving = true;

		L.Util.cancelAnimFrame(this._animRequest);
		this._lastEvent = e;
		this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true);
	},

	_updatePosition: function () {
		var e = {originalEvent: this._lastEvent};

		// @event predrag: Event
		// Fired continuously during dragging *before* each corresponding
		// update of the element's position.
		this.fire('predrag', e);
		L.DomUtil.setPosition(this._element, this._newPos);

		// @event drag: Event
		// Fired continuously during dragging.
		this.fire('drag', e);
	},

	_onUp: function (e) {
		// Ignore simulated events, since we handle both touch and
		// mouse explicitly; otherwise we risk getting duplicates of
		// touch events, see #4315.
		// Also ignore the event if disabled; this happens in IE11
		// under some circumstances, see #3666.
		if (e._simulated || !this._enabled) { return; }
		this.finishDrag();
	},

	finishDrag: function () {
		L.DomUtil.removeClass(document.body, 'leaflet-dragging');

		if (this._lastTarget) {
			L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
			this._lastTarget = null;
		}

		for (var i in L.Draggable.MOVE) {
			L.DomEvent
				.off(document, L.Draggable.MOVE[i], this._onMove, this)
				.off(document, L.Draggable.END[i], this._onUp, this);
		}

		L.DomUtil.enableImageDrag();
		L.DomUtil.enableTextSelection();

		if (this._moved && this._moving) {
			// ensure drag is not fired after dragend
			L.Util.cancelAnimFrame(this._animRequest);

			// @event dragend: DragEndEvent
			// Fired when the drag ends.
			this.fire('dragend', {
				distance: this._newPos.distanceTo(this._startPos)
			});
		}

		this._moving = false;
		L.Draggable._dragging = false;
	}

});



/*
	L.Handler is a base class for handler classes that are used internally to inject
	interaction features like dragging to classes like Map and Marker.
*/

// @class Handler
// @aka L.Handler
// Abstract class for map interaction handlers

L.Handler = L.Class.extend({
	initialize: function (map) {
		this._map = map;
	},

	// @method enable(): this
	// Enables the handler
	enable: function () {
		if (this._enabled) { return this; }

		this._enabled = true;
		this.addHooks();
		return this;
	},

	// @method disable(): this
	// Disables the handler
	disable: function () {
		if (!this._enabled) { return this; }

		this._enabled = false;
		this.removeHooks();
		return this;
	},

	// @method enabled(): Boolean
	// Returns `true` if the handler is enabled
	enabled: function () {
		return !!this._enabled;
	}

	// @section Extension methods
	// Classes inheriting from `Handler` must implement the two following methods:
	// @method addHooks()
	// Called when the handler is enabled, should add event hooks.
	// @method removeHooks()
	// Called when the handler is disabled, should remove the event hooks added previously.
});



/*
 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @option dragging: Boolean = true
	// Whether the map be draggable with mouse/touch or not.
	dragging: true,

	// @section Panning Inertia Options
	// @option inertia: Boolean = *
	// If enabled, panning of the map will have an inertia effect where
	// the map builds momentum while dragging and continues moving in
	// the same direction for some time. Feels especially nice on touch
	// devices. Enabled by default unless running on old Android devices.
	inertia: !L.Browser.android23,

	// @option inertiaDeceleration: Number = 3000
	// The rate with which the inertial movement slows down, in pixels/second².
	inertiaDeceleration: 3400, // px/s^2

	// @option inertiaMaxSpeed: Number = Infinity
	// Max speed of the inertial movement, in pixels/second.
	inertiaMaxSpeed: Infinity, // px/s

	// @option easeLinearity: Number = 0.2
	easeLinearity: 0.2,

	// TODO refactor, move to CRS
	// @option worldCopyJump: Boolean = false
	// With this option enabled, the map tracks when you pan to another "copy"
	// of the world and seamlessly jumps to the original one so that all overlays
	// like markers and vector layers are still visible.
	worldCopyJump: false,

	// @option maxBoundsViscosity: Number = 0.0
	// If `maxBounds` is set, this option will control how solid the bounds
	// are when dragging the map around. The default value of `0.0` allows the
	// user to drag outside the bounds at normal speed, higher values will
	// slow down map dragging outside bounds, and `1.0` makes the bounds fully
	// solid, preventing the user from dragging outside the bounds.
	maxBoundsViscosity: 0.0
});

L.Map.Drag = L.Handler.extend({
	addHooks: function () {
		if (!this._draggable) {
			var map = this._map;

			this._draggable = new L.Draggable(map._mapPane, map._container);

			this._draggable.on({
				down: this._onDown,
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this);

			this._draggable.on('predrag', this._onPreDragLimit, this);
			if (map.options.worldCopyJump) {
				this._draggable.on('predrag', this._onPreDragWrap, this);
				map.on('zoomend', this._onZoomEnd, this);

				map.whenReady(this._onZoomEnd, this);
			}
		}
		L.DomUtil.addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
		this._draggable.enable();
		this._positions = [];
		this._times = [];
	},

	removeHooks: function () {
		L.DomUtil.removeClass(this._map._container, 'leaflet-grab');
		L.DomUtil.removeClass(this._map._container, 'leaflet-touch-drag');
		this._draggable.disable();
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	moving: function () {
		return this._draggable && this._draggable._moving;
	},

	_onDown: function () {
		this._map._stop();
	},

	_onDragStart: function () {
		var map = this._map;

		if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
			var bounds = L.latLngBounds(this._map.options.maxBounds);

			this._offsetLimit = L.bounds(
				this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
				this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
					.add(this._map.getSize()));

			this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
		} else {
			this._offsetLimit = null;
		}

		map
		    .fire('movestart')
		    .fire('dragstart');

		if (map.options.inertia) {
			this._positions = [];
			this._times = [];
		}
	},

	_onDrag: function (e) {
		if (this._map.options.inertia) {
			var time = this._lastTime = +new Date(),
			    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;

			this._positions.push(pos);
			this._times.push(time);

			if (time - this._times[0] > 50) {
				this._positions.shift();
				this._times.shift();
			}
		}

		this._map
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onZoomEnd: function () {
		var pxCenter = this._map.getSize().divideBy(2),
		    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);

		this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
		this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
	},

	_viscousLimit: function (value, threshold) {
		return value - (value - threshold) * this._viscosity;
	},

	_onPreDragLimit: function () {
		if (!this._viscosity || !this._offsetLimit) { return; }

		var offset = this._draggable._newPos.subtract(this._draggable._startPos);

		var limit = this._offsetLimit;
		if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
		if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
		if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
		if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }

		this._draggable._newPos = this._draggable._startPos.add(offset);
	},

	_onPreDragWrap: function () {
		// TODO refactor to be able to adjust map pane position after zoom
		var worldWidth = this._worldWidth,
		    halfWidth = Math.round(worldWidth / 2),
		    dx = this._initialWorldOffset,
		    x = this._draggable._newPos.x,
		    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
		    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
		    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;

		this._draggable._absPos = this._draggable._newPos.clone();
		this._draggable._newPos.x = newX;
	},

	_onDragEnd: function (e) {
		var map = this._map,
		    options = map.options,

		    noInertia = !options.inertia || this._times.length < 2;

		map.fire('dragend', e);

		if (noInertia) {
			map.fire('moveend');

		} else {

			var direction = this._lastPos.subtract(this._positions[0]),
			    duration = (this._lastTime - this._times[0]) / 1000,
			    ease = options.easeLinearity,

			    speedVector = direction.multiplyBy(ease / duration),
			    speed = speedVector.distanceTo([0, 0]),

			    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
			    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),

			    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
			    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();

			if (!offset.x && !offset.y) {
				map.fire('moveend');

			} else {
				offset = map._limitOffset(offset, map.options.maxBounds);

				L.Util.requestAnimFrame(function () {
					map.panBy(offset, {
						duration: decelerationDuration,
						easeLinearity: ease,
						noMoveStart: true,
						animate: true
					});
				});
			}
		}
	}
});

// @section Handlers
// @property dragging: Handler
// Map dragging handler (by both mouse and touch).
L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);



/*
 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
 */

// @namespace Map
// @section Interaction Options

L.Map.mergeOptions({
	// @option doubleClickZoom: Boolean|String = true
	// Whether the map can be zoomed in by double clicking on it and
	// zoomed out by double clicking while holding shift. If passed
	// `'center'`, double-click zoom will zoom to the center of the
	//  view regardless of where the mouse was.
	doubleClickZoom: true
});

L.Map.DoubleClickZoom = L.Handler.extend({
	addHooks: function () {
		this._map.on('dblclick', this._onDoubleClick, this);
	},

	removeHooks: function () {
		this._map.off('dblclick', this._onDoubleClick, this);
	},

	_onDoubleClick: function (e) {
		var map = this._map,
		    oldZoom = map.getZoom(),
		    delta = map.options.zoomDelta,
		    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;

		if (map.options.doubleClickZoom === 'center') {
			map.setZoom(zoom);
		} else {
			map.setZoomAround(e.containerPoint, zoom);
		}
	}
});

// @section Handlers
//
// Map properties include interaction handlers that allow you to control
// interaction behavior in runtime, enabling or disabling certain features such
// as dragging or touch zoom (see `Handler` methods). For example:
//
// ```js
// map.doubleClickZoom.disable();
// ```
//
// @property doubleClickZoom: Handler
// Double click zoom handler.
L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);



/*
 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @section Mousewheel options
	// @option scrollWheelZoom: Boolean|String = true
	// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
	// it will zoom to the center of the view regardless of where the mouse was.
	scrollWheelZoom: true,

	// @option wheelDebounceTime: Number = 40
	// Limits the rate at which a wheel can fire (in milliseconds). By default
	// user can't zoom via wheel more often than once per 40 ms.
	wheelDebounceTime: 40,

	// @option wheelPxPerZoomLevel: Number = 60
	// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
	// mean a change of one full zoom level. Smaller values will make wheel-zooming
	// faster (and vice versa).
	wheelPxPerZoomLevel: 60
});

L.Map.ScrollWheelZoom = L.Handler.extend({
	addHooks: function () {
		L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);

		this._delta = 0;
	},

	removeHooks: function () {
		L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll, this);
	},

	_onWheelScroll: function (e) {
		var delta = L.DomEvent.getWheelDelta(e);

		var debounce = this._map.options.wheelDebounceTime;

		this._delta += delta;
		this._lastMousePos = this._map.mouseEventToContainerPoint(e);

		if (!this._startTime) {
			this._startTime = +new Date();
		}

		var left = Math.max(debounce - (+new Date() - this._startTime), 0);

		clearTimeout(this._timer);
		this._timer = setTimeout(L.bind(this._performZoom, this), left);

		L.DomEvent.stop(e);
	},

	_performZoom: function () {
		var map = this._map,
		    zoom = map.getZoom(),
		    snap = this._map.options.zoomSnap || 0;

		map._stop(); // stop panning and fly animations if any

		// map the delta with a sigmoid function to -4..4 range leaning on -1..1
		var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
		    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
		    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
		    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;

		this._delta = 0;
		this._startTime = null;

		if (!delta) { return; }

		if (map.options.scrollWheelZoom === 'center') {
			map.setZoom(zoom + delta);
		} else {
			map.setZoomAround(this._lastMousePos, zoom + delta);
		}
	}
});

// @section Handlers
// @property scrollWheelZoom: Handler
// Scroll wheel zoom handler.
L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);



/*
 * Extends the event handling code with double tap support for mobile browsers.
 */

L.extend(L.DomEvent, {

	_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
	_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',

	// inspired by Zepto touch code by Thomas Fuchs
	addDoubleTapListener: function (obj, handler, id) {
		var last, touch,
		    doubleTap = false,
		    delay = 250;

		function onTouchStart(e) {
			var count;

			if (L.Browser.pointer) {
				if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }
				count = L.DomEvent._pointersCount;
			} else {
				count = e.touches.length;
			}

			if (count > 1) { return; }

			var now = Date.now(),
			    delta = now - (last || now);

			touch = e.touches ? e.touches[0] : e;
			doubleTap = (delta > 0 && delta <= delay);
			last = now;
		}

		function onTouchEnd(e) {
			if (doubleTap && !touch.cancelBubble) {
				if (L.Browser.pointer) {
					if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }

					// work around .type being readonly with MSPointer* events
					var newTouch = {},
					    prop, i;

					for (i in touch) {
						prop = touch[i];
						newTouch[i] = prop && prop.bind ? prop.bind(touch) : prop;
					}
					touch = newTouch;
				}
				touch.type = 'dblclick';
				handler(touch);
				last = null;
			}
		}

		var pre = '_leaflet_',
		    touchstart = this._touchstart,
		    touchend = this._touchend;

		obj[pre + touchstart + id] = onTouchStart;
		obj[pre + touchend + id] = onTouchEnd;
		obj[pre + 'dblclick' + id] = handler;

		obj.addEventListener(touchstart, onTouchStart, false);
		obj.addEventListener(touchend, onTouchEnd, false);

		// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
		// the browser doesn't fire touchend/pointerup events but does fire
		// native dblclicks. See #4127.
		// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
		obj.addEventListener('dblclick', handler, false);

		return this;
	},

	removeDoubleTapListener: function (obj, id) {
		var pre = '_leaflet_',
		    touchstart = obj[pre + this._touchstart + id],
		    touchend = obj[pre + this._touchend + id],
		    dblclick = obj[pre + 'dblclick' + id];

		obj.removeEventListener(this._touchstart, touchstart, false);
		obj.removeEventListener(this._touchend, touchend, false);
		if (!L.Browser.edge) {
			obj.removeEventListener('dblclick', dblclick, false);
		}

		return this;
	}
});



/*
 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
 */

L.extend(L.DomEvent, {

	POINTER_DOWN:   L.Browser.msPointer ? 'MSPointerDown'   : 'pointerdown',
	POINTER_MOVE:   L.Browser.msPointer ? 'MSPointerMove'   : 'pointermove',
	POINTER_UP:     L.Browser.msPointer ? 'MSPointerUp'     : 'pointerup',
	POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',
	TAG_WHITE_LIST: ['INPUT', 'SELECT', 'OPTION'],

	_pointers: {},
	_pointersCount: 0,

	// Provides a touch events wrapper for (ms)pointer events.
	// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890

	addPointerListener: function (obj, type, handler, id) {

		if (type === 'touchstart') {
			this._addPointerStart(obj, handler, id);

		} else if (type === 'touchmove') {
			this._addPointerMove(obj, handler, id);

		} else if (type === 'touchend') {
			this._addPointerEnd(obj, handler, id);
		}

		return this;
	},

	removePointerListener: function (obj, type, id) {
		var handler = obj['_leaflet_' + type + id];

		if (type === 'touchstart') {
			obj.removeEventListener(this.POINTER_DOWN, handler, false);

		} else if (type === 'touchmove') {
			obj.removeEventListener(this.POINTER_MOVE, handler, false);

		} else if (type === 'touchend') {
			obj.removeEventListener(this.POINTER_UP, handler, false);
			obj.removeEventListener(this.POINTER_CANCEL, handler, false);
		}

		return this;
	},

	_addPointerStart: function (obj, handler, id) {
		var onDown = L.bind(function (e) {
			if (e.pointerType !== 'mouse' && e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
				// In IE11, some touch events needs to fire for form controls, or
				// the controls will stop working. We keep a whitelist of tag names that
				// need these events. For other target tags, we prevent default on the event.
				if (this.TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
					L.DomEvent.preventDefault(e);
				} else {
					return;
				}
			}

			this._handlePointer(e, handler);
		}, this);

		obj['_leaflet_touchstart' + id] = onDown;
		obj.addEventListener(this.POINTER_DOWN, onDown, false);

		// need to keep track of what pointers and how many are active to provide e.touches emulation
		if (!this._pointerDocListener) {
			var pointerUp = L.bind(this._globalPointerUp, this);

			// we listen documentElement as any drags that end by moving the touch off the screen get fired there
			document.documentElement.addEventListener(this.POINTER_DOWN, L.bind(this._globalPointerDown, this), true);
			document.documentElement.addEventListener(this.POINTER_MOVE, L.bind(this._globalPointerMove, this), true);
			document.documentElement.addEventListener(this.POINTER_UP, pointerUp, true);
			document.documentElement.addEventListener(this.POINTER_CANCEL, pointerUp, true);

			this._pointerDocListener = true;
		}
	},

	_globalPointerDown: function (e) {
		this._pointers[e.pointerId] = e;
		this._pointersCount++;
	},

	_globalPointerMove: function (e) {
		if (this._pointers[e.pointerId]) {
			this._pointers[e.pointerId] = e;
		}
	},

	_globalPointerUp: function (e) {
		delete this._pointers[e.pointerId];
		this._pointersCount--;
	},

	_handlePointer: function (e, handler) {
		e.touches = [];
		for (var i in this._pointers) {
			e.touches.push(this._pointers[i]);
		}
		e.changedTouches = [e];

		handler(e);
	},

	_addPointerMove: function (obj, handler, id) {
		var onMove = L.bind(function (e) {
			// don't fire touch moves when mouse isn't down
			if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }

			this._handlePointer(e, handler);
		}, this);

		obj['_leaflet_touchmove' + id] = onMove;
		obj.addEventListener(this.POINTER_MOVE, onMove, false);
	},

	_addPointerEnd: function (obj, handler, id) {
		var onUp = L.bind(function (e) {
			this._handlePointer(e, handler);
		}, this);

		obj['_leaflet_touchend' + id] = onUp;
		obj.addEventListener(this.POINTER_UP, onUp, false);
		obj.addEventListener(this.POINTER_CANCEL, onUp, false);
	}
});



/*
 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @section Touch interaction options
	// @option touchZoom: Boolean|String = *
	// Whether the map can be zoomed by touch-dragging with two fingers. If
	// passed `'center'`, it will zoom to the center of the view regardless of
	// where the touch events (fingers) were. Enabled for touch-capable web
	// browsers except for old Androids.
	touchZoom: L.Browser.touch && !L.Browser.android23,

	// @option bounceAtZoomLimits: Boolean = true
	// Set it to false if you don't want the map to zoom beyond min/max zoom
	// and then bounce back when pinch-zooming.
	bounceAtZoomLimits: true
});

L.Map.TouchZoom = L.Handler.extend({
	addHooks: function () {
		L.DomUtil.addClass(this._map._container, 'leaflet-touch-zoom');
		L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	removeHooks: function () {
		L.DomUtil.removeClass(this._map._container, 'leaflet-touch-zoom');
		L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
	},

	_onTouchStart: function (e) {
		var map = this._map;
		if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }

		var p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]);

		this._centerPoint = map.getSize()._divideBy(2);
		this._startLatLng = map.containerPointToLatLng(this._centerPoint);
		if (map.options.touchZoom !== 'center') {
			this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
		}

		this._startDist = p1.distanceTo(p2);
		this._startZoom = map.getZoom();

		this._moved = false;
		this._zooming = true;

		map._stop();

		L.DomEvent
		    .on(document, 'touchmove', this._onTouchMove, this)
		    .on(document, 'touchend', this._onTouchEnd, this);

		L.DomEvent.preventDefault(e);
	},

	_onTouchMove: function (e) {
		if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }

		var map = this._map,
		    p1 = map.mouseEventToContainerPoint(e.touches[0]),
		    p2 = map.mouseEventToContainerPoint(e.touches[1]),
		    scale = p1.distanceTo(p2) / this._startDist;


		this._zoom = map.getScaleZoom(scale, this._startZoom);

		if (!map.options.bounceAtZoomLimits && (
			(this._zoom < map.getMinZoom() && scale < 1) ||
			(this._zoom > map.getMaxZoom() && scale > 1))) {
			this._zoom = map._limitZoom(this._zoom);
		}

		if (map.options.touchZoom === 'center') {
			this._center = this._startLatLng;
			if (scale === 1) { return; }
		} else {
			// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
			var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
			if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
			this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
		}

		if (!this._moved) {
			map._moveStart(true);
			this._moved = true;
		}

		L.Util.cancelAnimFrame(this._animRequest);

		var moveFn = L.bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
		this._animRequest = L.Util.requestAnimFrame(moveFn, this, true);

		L.DomEvent.preventDefault(e);
	},

	_onTouchEnd: function () {
		if (!this._moved || !this._zooming) {
			this._zooming = false;
			return;
		}

		this._zooming = false;
		L.Util.cancelAnimFrame(this._animRequest);

		L.DomEvent
		    .off(document, 'touchmove', this._onTouchMove)
		    .off(document, 'touchend', this._onTouchEnd);

		// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
		if (this._map.options.zoomAnimation) {
			this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
		} else {
			this._map._resetView(this._center, this._map._limitZoom(this._zoom));
		}
	}
});

// @section Handlers
// @property touchZoom: Handler
// Touch zoom handler.
L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);



/*
 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @section Touch interaction options
	// @option tap: Boolean = true
	// Enables mobile hacks for supporting instant taps (fixing 200ms click
	// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
	tap: true,

	// @option tapTolerance: Number = 15
	// The max number of pixels a user can shift his finger during touch
	// for it to be considered a valid tap.
	tapTolerance: 15
});

L.Map.Tap = L.Handler.extend({
	addHooks: function () {
		L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
	},

	removeHooks: function () {
		L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
	},

	_onDown: function (e) {
		if (!e.touches) { return; }

		L.DomEvent.preventDefault(e);

		this._fireClick = true;

		// don't simulate click or track longpress if more than 1 touch
		if (e.touches.length > 1) {
			this._fireClick = false;
			clearTimeout(this._holdTimeout);
			return;
		}

		var first = e.touches[0],
		    el = first.target;

		this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);

		// if touching a link, highlight it
		if (el.tagName && el.tagName.toLowerCase() === 'a') {
			L.DomUtil.addClass(el, 'leaflet-active');
		}

		// simulate long hold but setting a timeout
		this._holdTimeout = setTimeout(L.bind(function () {
			if (this._isTapValid()) {
				this._fireClick = false;
				this._onUp();
				this._simulateEvent('contextmenu', first);
			}
		}, this), 1000);

		this._simulateEvent('mousedown', first);

		L.DomEvent.on(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);
	},

	_onUp: function (e) {
		clearTimeout(this._holdTimeout);

		L.DomEvent.off(document, {
			touchmove: this._onMove,
			touchend: this._onUp
		}, this);

		if (this._fireClick && e && e.changedTouches) {

			var first = e.changedTouches[0],
			    el = first.target;

			if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.removeClass(el, 'leaflet-active');
			}

			this._simulateEvent('mouseup', first);

			// simulate click if the touch didn't move too much
			if (this._isTapValid()) {
				this._simulateEvent('click', first);
			}
		}
	},

	_isTapValid: function () {
		return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
	},

	_onMove: function (e) {
		var first = e.touches[0];
		this._newPos = new L.Point(first.clientX, first.clientY);
		this._simulateEvent('mousemove', first);
	},

	_simulateEvent: function (type, e) {
		var simulatedEvent = document.createEvent('MouseEvents');

		simulatedEvent._simulated = true;
		e.target._simulatedClick = true;

		simulatedEvent.initMouseEvent(
		        type, true, true, window, 1,
		        e.screenX, e.screenY,
		        e.clientX, e.clientY,
		        false, false, false, false, 0, null);

		e.target.dispatchEvent(simulatedEvent);
	}
});

// @section Handlers
// @property tap: Handler
// Mobile touch hacks (quick tap and touch hold) handler.
if (L.Browser.touch && !L.Browser.pointer) {
	L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
}



/*
 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
 * (zoom to a selected bounding box), enabled by default.
 */

// @namespace Map
// @section Interaction Options
L.Map.mergeOptions({
	// @option boxZoom: Boolean = true
	// Whether the map can be zoomed to a rectangular area specified by
	// dragging the mouse while pressing the shift key.
	boxZoom: true
});

L.Map.BoxZoom = L.Handler.extend({
	initialize: function (map) {
		this._map = map;
		this._container = map._container;
		this._pane = map._panes.overlayPane;
	},

	addHooks: function () {
		L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
	},

	removeHooks: function () {
		L.DomEvent.off(this._container, 'mousedown', this._onMouseDown, this);
	},

	moved: function () {
		return this._moved;
	},

	_resetState: function () {
		this._moved = false;
	},

	_onMouseDown: function (e) {
		if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }

		this._resetState();

		L.DomUtil.disableTextSelection();
		L.DomUtil.disableImageDrag();

		this._startPoint = this._map.mouseEventToContainerPoint(e);

		L.DomEvent.on(document, {
			contextmenu: L.DomEvent.stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseMove: function (e) {
		if (!this._moved) {
			this._moved = true;

			this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._container);
			L.DomUtil.addClass(this._container, 'leaflet-crosshair');

			this._map.fire('boxzoomstart');
		}

		this._point = this._map.mouseEventToContainerPoint(e);

		var bounds = new L.Bounds(this._point, this._startPoint),
		    size = bounds.getSize();

		L.DomUtil.setPosition(this._box, bounds.min);

		this._box.style.width  = size.x + 'px';
		this._box.style.height = size.y + 'px';
	},

	_finish: function () {
		if (this._moved) {
			L.DomUtil.remove(this._box);
			L.DomUtil.removeClass(this._container, 'leaflet-crosshair');
		}

		L.DomUtil.enableTextSelection();
		L.DomUtil.enableImageDrag();

		L.DomEvent.off(document, {
			contextmenu: L.DomEvent.stop,
			mousemove: this._onMouseMove,
			mouseup: this._onMouseUp,
			keydown: this._onKeyDown
		}, this);
	},

	_onMouseUp: function (e) {
		if ((e.which !== 1) && (e.button !== 1)) { return; }

		this._finish();

		if (!this._moved) { return; }
		// Postpone to next JS tick so internal click event handling
		// still see it as "moved".
		setTimeout(L.bind(this._resetState, this), 0);

		var bounds = new L.LatLngBounds(
		        this._map.containerPointToLatLng(this._startPoint),
		        this._map.containerPointToLatLng(this._point));

		this._map
			.fitBounds(bounds)
			.fire('boxzoomend', {boxZoomBounds: bounds});
	},

	_onKeyDown: function (e) {
		if (e.keyCode === 27) {
			this._finish();
		}
	}
});

// @section Handlers
// @property boxZoom: Handler
// Box (shift-drag with mouse) zoom handler.
L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);



/*
 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
 */

// @namespace Map
// @section Keyboard Navigation Options
L.Map.mergeOptions({
	// @option keyboard: Boolean = true
	// Makes the map focusable and allows users to navigate the map with keyboard
	// arrows and `+`/`-` keys.
	keyboard: true,

	// @option keyboardPanDelta: Number = 80
	// Amount of pixels to pan when pressing an arrow key.
	keyboardPanDelta: 80
});

L.Map.Keyboard = L.Handler.extend({

	keyCodes: {
		left:    [37],
		right:   [39],
		down:    [40],
		up:      [38],
		zoomIn:  [187, 107, 61, 171],
		zoomOut: [189, 109, 54, 173]
	},

	initialize: function (map) {
		this._map = map;

		this._setPanDelta(map.options.keyboardPanDelta);
		this._setZoomDelta(map.options.zoomDelta);
	},

	addHooks: function () {
		var container = this._map._container;

		// make the container focusable by tabbing
		if (container.tabIndex <= 0) {
			container.tabIndex = '0';
		}

		L.DomEvent.on(container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.on({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	removeHooks: function () {
		this._removeHooks();

		L.DomEvent.off(this._map._container, {
			focus: this._onFocus,
			blur: this._onBlur,
			mousedown: this._onMouseDown
		}, this);

		this._map.off({
			focus: this._addHooks,
			blur: this._removeHooks
		}, this);
	},

	_onMouseDown: function () {
		if (this._focused) { return; }

		var body = document.body,
		    docEl = document.documentElement,
		    top = body.scrollTop || docEl.scrollTop,
		    left = body.scrollLeft || docEl.scrollLeft;

		this._map._container.focus();

		window.scrollTo(left, top);
	},

	_onFocus: function () {
		this._focused = true;
		this._map.fire('focus');
	},

	_onBlur: function () {
		this._focused = false;
		this._map.fire('blur');
	},

	_setPanDelta: function (panDelta) {
		var keys = this._panKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.left.length; i < len; i++) {
			keys[codes.left[i]] = [-1 * panDelta, 0];
		}
		for (i = 0, len = codes.right.length; i < len; i++) {
			keys[codes.right[i]] = [panDelta, 0];
		}
		for (i = 0, len = codes.down.length; i < len; i++) {
			keys[codes.down[i]] = [0, panDelta];
		}
		for (i = 0, len = codes.up.length; i < len; i++) {
			keys[codes.up[i]] = [0, -1 * panDelta];
		}
	},

	_setZoomDelta: function (zoomDelta) {
		var keys = this._zoomKeys = {},
		    codes = this.keyCodes,
		    i, len;

		for (i = 0, len = codes.zoomIn.length; i < len; i++) {
			keys[codes.zoomIn[i]] = zoomDelta;
		}
		for (i = 0, len = codes.zoomOut.length; i < len; i++) {
			keys[codes.zoomOut[i]] = -zoomDelta;
		}
	},

	_addHooks: function () {
		L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
	},

	_removeHooks: function () {
		L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
	},

	_onKeyDown: function (e) {
		if (e.altKey || e.ctrlKey || e.metaKey) { return; }

		var key = e.keyCode,
		    map = this._map,
		    offset;

		if (key in this._panKeys) {

			if (map._panAnim && map._panAnim._inProgress) { return; }

			offset = this._panKeys[key];
			if (e.shiftKey) {
				offset = L.point(offset).multiplyBy(3);
			}

			map.panBy(offset);

			if (map.options.maxBounds) {
				map.panInsideBounds(map.options.maxBounds);
			}

		} else if (key in this._zoomKeys) {
			map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);

		} else if (key === 27) {
			map.closePopup();

		} else {
			return;
		}

		L.DomEvent.stop(e);
	}
});

// @section Handlers
// @section Handlers
// @property keyboard: Handler
// Keyboard navigation handler.
L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);



/*
 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
 */


/* @namespace Marker
 * @section Interaction handlers
 *
 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
 *
 * ```js
 * marker.dragging.disable();
 * ```
 *
 * @property dragging: Handler
 * Marker dragging handler (by both mouse and touch).
 */

L.Handler.MarkerDrag = L.Handler.extend({
	initialize: function (marker) {
		this._marker = marker;
	},

	addHooks: function () {
		var icon = this._marker._icon;

		if (!this._draggable) {
			this._draggable = new L.Draggable(icon, icon, true);
		}

		this._draggable.on({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).enable();

		L.DomUtil.addClass(icon, 'leaflet-marker-draggable');
	},

	removeHooks: function () {
		this._draggable.off({
			dragstart: this._onDragStart,
			drag: this._onDrag,
			dragend: this._onDragEnd
		}, this).disable();

		if (this._marker._icon) {
			L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
		}
	},

	moved: function () {
		return this._draggable && this._draggable._moved;
	},

	_onDragStart: function () {
		// @section Dragging events
		// @event dragstart: Event
		// Fired when the user starts dragging the marker.

		// @event movestart: Event
		// Fired when the marker starts moving (because of dragging).

		this._oldLatLng = this._marker.getLatLng();
		this._marker
		    .closePopup()
		    .fire('movestart')
		    .fire('dragstart');
	},

	_onDrag: function (e) {
		var marker = this._marker,
		    shadow = marker._shadow,
		    iconPos = L.DomUtil.getPosition(marker._icon),
		    latlng = marker._map.layerPointToLatLng(iconPos);

		// update shadow position
		if (shadow) {
			L.DomUtil.setPosition(shadow, iconPos);
		}

		marker._latlng = latlng;
		e.latlng = latlng;
		e.oldLatLng = this._oldLatLng;

		// @event drag: Event
		// Fired repeatedly while the user drags the marker.
		marker
		    .fire('move', e)
		    .fire('drag', e);
	},

	_onDragEnd: function (e) {
		// @event dragend: DragEndEvent
		// Fired when the user stops dragging the marker.

		// @event moveend: Event
		// Fired when the marker stops moving (because of dragging).
		delete this._oldLatLng;
		this._marker
		    .fire('moveend')
		    .fire('dragend', e);
	}
});



/*
 * @class Control
 * @aka L.Control
 * @inherits Class
 *
 * L.Control is a base class for implementing map controls. Handles positioning.
 * All other controls extend from this class.
 */

L.Control = L.Class.extend({
	// @section
	// @aka Control options
	options: {
		// @option position: String = 'topright'
		// The position of the control (one of the map corners). Possible values are `'topleft'`,
		// `'topright'`, `'bottomleft'` or `'bottomright'`
		position: 'topright'
	},

	initialize: function (options) {
		L.setOptions(this, options);
	},

	/* @section
	 * Classes extending L.Control will inherit the following methods:
	 *
	 * @method getPosition: string
	 * Returns the position of the control.
	 */
	getPosition: function () {
		return this.options.position;
	},

	// @method setPosition(position: string): this
	// Sets the position of the control.
	setPosition: function (position) {
		var map = this._map;

		if (map) {
			map.removeControl(this);
		}

		this.options.position = position;

		if (map) {
			map.addControl(this);
		}

		return this;
	},

	// @method getContainer: HTMLElement
	// Returns the HTMLElement that contains the control.
	getContainer: function () {
		return this._container;
	},

	// @method addTo(map: Map): this
	// Adds the control to the given map.
	addTo: function (map) {
		this.remove();
		this._map = map;

		var container = this._container = this.onAdd(map),
		    pos = this.getPosition(),
		    corner = map._controlCorners[pos];

		L.DomUtil.addClass(container, 'leaflet-control');

		if (pos.indexOf('bottom') !== -1) {
			corner.insertBefore(container, corner.firstChild);
		} else {
			corner.appendChild(container);
		}

		return this;
	},

	// @method remove: this
	// Removes the control from the map it is currently active on.
	remove: function () {
		if (!this._map) {
			return this;
		}

		L.DomUtil.remove(this._container);

		if (this.onRemove) {
			this.onRemove(this._map);
		}

		this._map = null;

		return this;
	},

	_refocusOnMap: function (e) {
		// if map exists and event is not a keyboard event
		if (this._map && e && e.screenX > 0 && e.screenY > 0) {
			this._map.getContainer().focus();
		}
	}
});

L.control = function (options) {
	return new L.Control(options);
};

/* @section Extension methods
 * @uninheritable
 *
 * Every control should extend from `L.Control` and (re-)implement the following methods.
 *
 * @method onAdd(map: Map): HTMLElement
 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
 *
 * @method onRemove(map: Map)
 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
 */

/* @namespace Map
 * @section Methods for Layers and Controls
 */
L.Map.include({
	// @method addControl(control: Control): this
	// Adds the given control to the map
	addControl: function (control) {
		control.addTo(this);
		return this;
	},

	// @method removeControl(control: Control): this
	// Removes the given control from the map
	removeControl: function (control) {
		control.remove();
		return this;
	},

	_initControlPos: function () {
		var corners = this._controlCorners = {},
		    l = 'leaflet-',
		    container = this._controlContainer =
		            L.DomUtil.create('div', l + 'control-container', this._container);

		function createCorner(vSide, hSide) {
			var className = l + vSide + ' ' + l + hSide;

			corners[vSide + hSide] = L.DomUtil.create('div', className, container);
		}

		createCorner('top', 'left');
		createCorner('top', 'right');
		createCorner('bottom', 'left');
		createCorner('bottom', 'right');
	},

	_clearControlPos: function () {
		L.DomUtil.remove(this._controlContainer);
	}
});



/*
 * @class Control.Zoom
 * @aka L.Control.Zoom
 * @inherits Control
 *
 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
 */

L.Control.Zoom = L.Control.extend({
	// @section
	// @aka Control.Zoom options
	options: {
		position: 'topleft',

		// @option zoomInText: String = '+'
		// The text set on the 'zoom in' button.
		zoomInText: '+',

		// @option zoomInTitle: String = 'Zoom in'
		// The title set on the 'zoom in' button.
		zoomInTitle: 'Zoom in',

		// @option zoomOutText: String = '-'
		// The text set on the 'zoom out' button.
		zoomOutText: '-',

		// @option zoomOutTitle: String = 'Zoom out'
		// The title set on the 'zoom out' button.
		zoomOutTitle: 'Zoom out'
	},

	onAdd: function (map) {
		var zoomName = 'leaflet-control-zoom',
		    container = L.DomUtil.create('div', zoomName + ' leaflet-bar'),
		    options = this.options;

		this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
		        zoomName + '-in',  container, this._zoomIn);
		this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
		        zoomName + '-out', container, this._zoomOut);

		this._updateDisabled();
		map.on('zoomend zoomlevelschange', this._updateDisabled, this);

		return container;
	},

	onRemove: function (map) {
		map.off('zoomend zoomlevelschange', this._updateDisabled, this);
	},

	disable: function () {
		this._disabled = true;
		this._updateDisabled();
		return this;
	},

	enable: function () {
		this._disabled = false;
		this._updateDisabled();
		return this;
	},

	_zoomIn: function (e) {
		if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
			this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_zoomOut: function (e) {
		if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
			this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
		}
	},

	_createButton: function (html, title, className, container, fn) {
		var link = L.DomUtil.create('a', className, container);
		link.innerHTML = html;
		link.href = '#';
		link.title = title;

		/*
		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
		 */
		link.setAttribute('role', 'button');
		link.setAttribute('aria-label', title);

		L.DomEvent
		    .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
		    .on(link, 'click', L.DomEvent.stop)
		    .on(link, 'click', fn, this)
		    .on(link, 'click', this._refocusOnMap, this);

		return link;
	},

	_updateDisabled: function () {
		var map = this._map,
		    className = 'leaflet-disabled';

		L.DomUtil.removeClass(this._zoomInButton, className);
		L.DomUtil.removeClass(this._zoomOutButton, className);

		if (this._disabled || map._zoom === map.getMinZoom()) {
			L.DomUtil.addClass(this._zoomOutButton, className);
		}
		if (this._disabled || map._zoom === map.getMaxZoom()) {
			L.DomUtil.addClass(this._zoomInButton, className);
		}
	}
});

// @namespace Map
// @section Control options
// @option zoomControl: Boolean = true
// Whether a [zoom control](#control-zoom) is added to the map by default.
L.Map.mergeOptions({
	zoomControl: true
});

L.Map.addInitHook(function () {
	if (this.options.zoomControl) {
		this.zoomControl = new L.Control.Zoom();
		this.addControl(this.zoomControl);
	}
});

// @namespace Control.Zoom
// @factory L.control.zoom(options: Control.Zoom options)
// Creates a zoom control
L.control.zoom = function (options) {
	return new L.Control.Zoom(options);
};



/*
 * @class Control.Attribution
 * @aka L.Control.Attribution
 * @inherits Control
 *
 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
 */

L.Control.Attribution = L.Control.extend({
	// @section
	// @aka Control.Attribution options
	options: {
		position: 'bottomright',

		// @option prefix: String = 'Leaflet'
		// The HTML text shown before the attributions. Pass `false` to disable.
		prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
	},

	initialize: function (options) {
		L.setOptions(this, options);

		this._attributions = {};
	},

	onAdd: function (map) {
		map.attributionControl = this;
		this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
		if (L.DomEvent) {
			L.DomEvent.disableClickPropagation(this._container);
		}

		// TODO ugly, refactor
		for (var i in map._layers) {
			if (map._layers[i].getAttribution) {
				this.addAttribution(map._layers[i].getAttribution());
			}
		}

		this._update();

		return this._container;
	},

	// @method setPrefix(prefix: String): this
	// Sets the text before the attributions.
	setPrefix: function (prefix) {
		this.options.prefix = prefix;
		this._update();
		return this;
	},

	// @method addAttribution(text: String): this
	// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
	addAttribution: function (text) {
		if (!text) { return this; }

		if (!this._attributions[text]) {
			this._attributions[text] = 0;
		}
		this._attributions[text]++;

		this._update();

		return this;
	},

	// @method removeAttribution(text: String): this
	// Removes an attribution text.
	removeAttribution: function (text) {
		if (!text) { return this; }

		if (this._attributions[text]) {
			this._attributions[text]--;
			this._update();
		}

		return this;
	},

	_update: function () {
		if (!this._map) { return; }

		var attribs = [];

		for (var i in this._attributions) {
			if (this._attributions[i]) {
				attribs.push(i);
			}
		}

		var prefixAndAttribs = [];

		if (this.options.prefix) {
			prefixAndAttribs.push(this.options.prefix);
		}
		if (attribs.length) {
			prefixAndAttribs.push(attribs.join(', '));
		}

		this._container.innerHTML = prefixAndAttribs.join(' | ');
	}
});

// @namespace Map
// @section Control options
// @option attributionControl: Boolean = true
// Whether a [attribution control](#control-attribution) is added to the map by default.
L.Map.mergeOptions({
	attributionControl: true
});

L.Map.addInitHook(function () {
	if (this.options.attributionControl) {
		new L.Control.Attribution().addTo(this);
	}
});

// @namespace Control.Attribution
// @factory L.control.attribution(options: Control.Attribution options)
// Creates an attribution control.
L.control.attribution = function (options) {
	return new L.Control.Attribution(options);
};



/*
 * @class Control.Scale
 * @aka L.Control.Scale
 * @inherits Control
 *
 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
 *
 * @example
 *
 * ```js
 * L.control.scale().addTo(map);
 * ```
 */

L.Control.Scale = L.Control.extend({
	// @section
	// @aka Control.Scale options
	options: {
		position: 'bottomleft',

		// @option maxWidth: Number = 100
		// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
		maxWidth: 100,

		// @option metric: Boolean = True
		// Whether to show the metric scale line (m/km).
		metric: true,

		// @option imperial: Boolean = True
		// Whether to show the imperial scale line (mi/ft).
		imperial: true

		// @option updateWhenIdle: Boolean = false
		// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
	},

	onAdd: function (map) {
		var className = 'leaflet-control-scale',
		    container = L.DomUtil.create('div', className),
		    options = this.options;

		this._addScales(options, className + '-line', container);

		map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		map.whenReady(this._update, this);

		return container;
	},

	onRemove: function (map) {
		map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
	},

	_addScales: function (options, className, container) {
		if (options.metric) {
			this._mScale = L.DomUtil.create('div', className, container);
		}
		if (options.imperial) {
			this._iScale = L.DomUtil.create('div', className, container);
		}
	},

	_update: function () {
		var map = this._map,
		    y = map.getSize().y / 2;

		var maxMeters = map.distance(
				map.containerPointToLatLng([0, y]),
				map.containerPointToLatLng([this.options.maxWidth, y]));

		this._updateScales(maxMeters);
	},

	_updateScales: function (maxMeters) {
		if (this.options.metric && maxMeters) {
			this._updateMetric(maxMeters);
		}
		if (this.options.imperial && maxMeters) {
			this._updateImperial(maxMeters);
		}
	},

	_updateMetric: function (maxMeters) {
		var meters = this._getRoundNum(maxMeters),
		    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';

		this._updateScale(this._mScale, label, meters / maxMeters);
	},

	_updateImperial: function (maxMeters) {
		var maxFeet = maxMeters * 3.2808399,
		    maxMiles, miles, feet;

		if (maxFeet > 5280) {
			maxMiles = maxFeet / 5280;
			miles = this._getRoundNum(maxMiles);
			this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);

		} else {
			feet = this._getRoundNum(maxFeet);
			this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
		}
	},

	_updateScale: function (scale, text, ratio) {
		scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
		scale.innerHTML = text;
	},

	_getRoundNum: function (num) {
		var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
		    d = num / pow10;

		d = d >= 10 ? 10 :
		    d >= 5 ? 5 :
		    d >= 3 ? 3 :
		    d >= 2 ? 2 : 1;

		return pow10 * d;
	}
});


// @factory L.control.scale(options?: Control.Scale options)
// Creates an scale control with the given options.
L.control.scale = function (options) {
	return new L.Control.Scale(options);
};



/*
 * @class Control.Layers
 * @aka L.Control.Layers
 * @inherits Control
 *
 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control.html)). Extends `Control`.
 *
 * @example
 *
 * ```js
 * var baseLayers = {
 * 	"Mapbox": mapbox,
 * 	"OpenStreetMap": osm
 * };
 *
 * var overlays = {
 * 	"Marker": marker,
 * 	"Roads": roadsLayer
 * };
 *
 * L.control.layers(baseLayers, overlays).addTo(map);
 * ```
 *
 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
 *
 * ```js
 * {
 *     "<someName1>": layer1,
 *     "<someName2>": layer2
 * }
 * ```
 *
 * The layer names can contain HTML, which allows you to add additional styling to the items:
 *
 * ```js
 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
 * ```
 */


L.Control.Layers = L.Control.extend({
	// @section
	// @aka Control.Layers options
	options: {
		// @option collapsed: Boolean = true
		// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
		collapsed: true,
		position: 'topright',

		// @option autoZIndex: Boolean = true
		// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
		autoZIndex: true,

		// @option hideSingleBase: Boolean = false
		// If `true`, the base layers in the control will be hidden when there is only one.
		hideSingleBase: false,

		// @option sortLayers: Boolean = false
		// Whether to sort the layers. When `false`, layers will keep the order
		// in which they were added to the control.
		sortLayers: false,

		// @option sortFunction: Function = *
		// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
		// that will be used for sorting the layers, when `sortLayers` is `true`.
		// The function receives both the `L.Layer` instances and their names, as in
		// `sortFunction(layerA, layerB, nameA, nameB)`.
		// By default, it sorts layers alphabetically by their name.
		sortFunction: function (layerA, layerB, nameA, nameB) {
			return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
		}
	},

	initialize: function (baseLayers, overlays, options) {
		L.setOptions(this, options);

		this._layers = [];
		this._lastZIndex = 0;
		this._handlingClick = false;

		for (var i in baseLayers) {
			this._addLayer(baseLayers[i], i);
		}

		for (i in overlays) {
			this._addLayer(overlays[i], i, true);
		}
	},

	onAdd: function (map) {
		this._initLayout();
		this._update();

		this._map = map;
		map.on('zoomend', this._checkDisabledLayers, this);

		return this._container;
	},

	onRemove: function () {
		this._map.off('zoomend', this._checkDisabledLayers, this);

		for (var i = 0; i < this._layers.length; i++) {
			this._layers[i].layer.off('add remove', this._onLayerChange, this);
		}
	},

	// @method addBaseLayer(layer: Layer, name: String): this
	// Adds a base layer (radio button entry) with the given name to the control.
	addBaseLayer: function (layer, name) {
		this._addLayer(layer, name);
		return (this._map) ? this._update() : this;
	},

	// @method addOverlay(layer: Layer, name: String): this
	// Adds an overlay (checkbox entry) with the given name to the control.
	addOverlay: function (layer, name) {
		this._addLayer(layer, name, true);
		return (this._map) ? this._update() : this;
	},

	// @method removeLayer(layer: Layer): this
	// Remove the given layer from the control.
	removeLayer: function (layer) {
		layer.off('add remove', this._onLayerChange, this);

		var obj = this._getLayer(L.stamp(layer));
		if (obj) {
			this._layers.splice(this._layers.indexOf(obj), 1);
		}
		return (this._map) ? this._update() : this;
	},

	// @method expand(): this
	// Expand the control container if collapsed.
	expand: function () {
		L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
		this._form.style.height = null;
		var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
		if (acceptableHeight < this._form.clientHeight) {
			L.DomUtil.addClass(this._form, 'leaflet-control-layers-scrollbar');
			this._form.style.height = acceptableHeight + 'px';
		} else {
			L.DomUtil.removeClass(this._form, 'leaflet-control-layers-scrollbar');
		}
		this._checkDisabledLayers();
		return this;
	},

	// @method collapse(): this
	// Collapse the control container if expanded.
	collapse: function () {
		L.DomUtil.removeClass(this._container, 'leaflet-control-layers-expanded');
		return this;
	},

	_initLayout: function () {
		var className = 'leaflet-control-layers',
		    container = this._container = L.DomUtil.create('div', className),
		    collapsed = this.options.collapsed;

		// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
		container.setAttribute('aria-haspopup', true);

		L.DomEvent.disableClickPropagation(container);
		if (!L.Browser.touch) {
			L.DomEvent.disableScrollPropagation(container);
		}

		var form = this._form = L.DomUtil.create('form', className + '-list');

		if (collapsed) {
			this._map.on('click', this.collapse, this);

			if (!L.Browser.android) {
				L.DomEvent.on(container, {
					mouseenter: this.expand,
					mouseleave: this.collapse
				}, this);
			}
		}

		var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
		link.href = '#';
		link.title = 'Layers';

		if (L.Browser.touch) {
			L.DomEvent
			    .on(link, 'click', L.DomEvent.stop)
			    .on(link, 'click', this.expand, this);
		} else {
			L.DomEvent.on(link, 'focus', this.expand, this);
		}

		// work around for Firefox Android issue https://github.com/Leaflet/Leaflet/issues/2033
		L.DomEvent.on(form, 'click', function () {
			setTimeout(L.bind(this._onInputClick, this), 0);
		}, this);

		// TODO keyboard accessibility

		if (!collapsed) {
			this.expand();
		}

		this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
		this._separator = L.DomUtil.create('div', className + '-separator', form);
		this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);

		container.appendChild(form);
	},

	_getLayer: function (id) {
		for (var i = 0; i < this._layers.length; i++) {

			if (this._layers[i] && L.stamp(this._layers[i].layer) === id) {
				return this._layers[i];
			}
		}
	},

	_addLayer: function (layer, name, overlay) {
		layer.on('add remove', this._onLayerChange, this);

		this._layers.push({
			layer: layer,
			name: name,
			overlay: overlay
		});

		if (this.options.sortLayers) {
			this._layers.sort(L.bind(function (a, b) {
				return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
			}, this));
		}

		if (this.options.autoZIndex && layer.setZIndex) {
			this._lastZIndex++;
			layer.setZIndex(this._lastZIndex);
		}
	},

	_update: function () {
		if (!this._container) { return this; }

		L.DomUtil.empty(this._baseLayersList);
		L.DomUtil.empty(this._overlaysList);

		var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;

		for (i = 0; i < this._layers.length; i++) {
			obj = this._layers[i];
			this._addItem(obj);
			overlaysPresent = overlaysPresent || obj.overlay;
			baseLayersPresent = baseLayersPresent || !obj.overlay;
			baseLayersCount += !obj.overlay ? 1 : 0;
		}

		// Hide base layers section if there's only one layer.
		if (this.options.hideSingleBase) {
			baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
			this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
		}

		this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';

		return this;
	},

	_onLayerChange: function (e) {
		if (!this._handlingClick) {
			this._update();
		}

		var obj = this._getLayer(L.stamp(e.target));

		// @namespace Map
		// @section Layer events
		// @event baselayerchange: LayersControlEvent
		// Fired when the base layer is changed through the [layer control](#control-layers).
		// @event overlayadd: LayersControlEvent
		// Fired when an overlay is selected through the [layer control](#control-layers).
		// @event overlayremove: LayersControlEvent
		// Fired when an overlay is deselected through the [layer control](#control-layers).
		// @namespace Control.Layers
		var type = obj.overlay ?
			(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
			(e.type === 'add' ? 'baselayerchange' : null);

		if (type) {
			this._map.fire(type, obj);
		}
	},

	// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
	_createRadioElement: function (name, checked) {

		var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
				name + '"' + (checked ? ' checked="checked"' : '') + '/>';

		var radioFragment = document.createElement('div');
		radioFragment.innerHTML = radioHtml;

		return radioFragment.firstChild;
	},

	_addItem: function (obj) {
		var label = document.createElement('label'),
		    checked = this._map.hasLayer(obj.layer),
		    input;

		if (obj.overlay) {
			input = document.createElement('input');
			input.type = 'checkbox';
			input.className = 'leaflet-control-layers-selector';
			input.defaultChecked = checked;
		} else {
			input = this._createRadioElement('leaflet-base-layers', checked);
		}

		input.layerId = L.stamp(obj.layer);

		L.DomEvent.on(input, 'click', this._onInputClick, this);

		var name = document.createElement('span');
		name.innerHTML = ' ' + obj.name;

		// Helps from preventing layer control flicker when checkboxes are disabled
		// https://github.com/Leaflet/Leaflet/issues/2771
		var holder = document.createElement('div');

		label.appendChild(holder);
		holder.appendChild(input);
		holder.appendChild(name);

		var container = obj.overlay ? this._overlaysList : this._baseLayersList;
		container.appendChild(label);

		this._checkDisabledLayers();
		return label;
	},

	_onInputClick: function () {
		var inputs = this._form.getElementsByTagName('input'),
		    input, layer, hasLayer;
		var addedLayers = [],
		    removedLayers = [];

		this._handlingClick = true;

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;
			hasLayer = this._map.hasLayer(layer);

			if (input.checked && !hasLayer) {
				addedLayers.push(layer);

			} else if (!input.checked && hasLayer) {
				removedLayers.push(layer);
			}
		}

		// Bugfix issue 2318: Should remove all old layers before readding new ones
		for (i = 0; i < removedLayers.length; i++) {
			this._map.removeLayer(removedLayers[i]);
		}
		for (i = 0; i < addedLayers.length; i++) {
			this._map.addLayer(addedLayers[i]);
		}

		this._handlingClick = false;

		this._refocusOnMap();
	},

	_checkDisabledLayers: function () {
		var inputs = this._form.getElementsByTagName('input'),
		    input,
		    layer,
		    zoom = this._map.getZoom();

		for (var i = inputs.length - 1; i >= 0; i--) {
			input = inputs[i];
			layer = this._getLayer(input.layerId).layer;
			input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
			                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);

		}
	},

	_expand: function () {
		// Backward compatibility, remove me in 1.1.
		return this.expand();
	},

	_collapse: function () {
		// Backward compatibility, remove me in 1.1.
		return this.collapse();
	}

});


// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
L.control.layers = function (baseLayers, overlays, options) {
	return new L.Control.Layers(baseLayers, overlays, options);
};



}(window, document));

},{}],77:[function(require,module,exports){
(function (global){
/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/chjj/marked
 */

;(function() {

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: noop,
  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
  nptable: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
  table: noop,
  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
  text: /^[^\n]+/
};

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = replace(block.item, 'gm')
  (/bull/g, block.bullet)
  ();

block.list = replace(block.list)
  (/bull/g, block.bullet)
  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
  ('def', '\\n+(?=' + block.def.source + ')')
  ();

block.blockquote = replace(block.blockquote)
  ('def', block.def)
  ();

block._tag = '(?!(?:'
  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';

block.html = replace(block.html)
  ('comment', /<!--[\s\S]*?-->/)
  ('closed', /<(tag)[\s\S]+?<\/\1>/)
  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
  (/tag/g, block._tag)
  ();

block.paragraph = replace(block.paragraph)
  ('hr', block.hr)
  ('heading', block.heading)
  ('lheading', block.lheading)
  ('blockquote', block.blockquote)
  ('tag', '<' + block._tag)
  ('def', block.def)
  ();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = replace(block.paragraph)
  ('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  ();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = {};
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top, bq) {
  var src = src.replace(/^ +$/gm, '')
    , next
    , loose
    , cap
    , bull
    , b
    , item
    , space
    , i
    , l;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      this.tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? cap.replace(/\n+$/, '')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i].split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top, true);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];

      this.tokens.push({
        type: 'list_start',
        ordered: bull.length > 1
      });

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        this.tokens.push({
          type: loose
            ? 'loose_item_start'
            : 'list_item_start'
        });

        // Recurse.
        this.token(item, false, bq);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.links[cap[1].toLowerCase()] = {
        href: cap[2],
        title: cap[3]
      };
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i]
          .replace(/^ *\| *| *\| *$/g, '')
          .split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
  autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
  url: noop,
  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
  link: /^!?\[(inside)\]\(href\)/,
  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
  code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
  br: /^ {2,}\n(?!\s*$)/,
  del: noop,
  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
};

inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;

inline.link = replace(inline.link)
  ('inside', inline._inside)
  ('href', inline._href)
  ();

inline.reflink = replace(inline.reflink)
  ('inside', inline._inside)
  ();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: replace(inline.escape)('])', '~|])')(),
  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
  del: /^~~(?=\S)([\s\S]*?\S)~~/,
  text: replace(inline.text)
    (']|', '~]|')
    ('|', '|https?://|')
    ()
});

/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: replace(inline.br)('{2,}', '*')(),
  text: replace(inline.gfm.text)('{2,}', '*')()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer;
  this.renderer.options = this.options;

  if (!this.links) {
    throw new
      Error('Tokens array requires a `links` property.');
  }

  if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  } else if (this.options.pedantic) {
    this.rules = inline.pedantic;
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = ''
    , link
    , text
    , href
    , cap;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += cap[1];
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = cap[1].charAt(6) === ':'
          ? this.mangle(cap[1].substring(7))
          : this.mangle(cap[1]);
        href = this.mangle('mailto:') + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      src = src.substring(cap[0].length);
      text = escape(cap[1]);
      href = text;
      out += this.renderer.link(href, null, text);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0]
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      out += this.outputLink(cap, {
        href: cap[2],
        title: cap[3]
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2], true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.text(escape(this.smartypants(cap[0])));
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = escape(link.href)
    , title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = ''
    , l = text.length
    , i = 0
    , ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || {};
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '\n</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '\n</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  return '<h'
    + level
    + ' id="'
    + this.options.headerPrefix
    + raw.toLowerCase().replace(/[^\w]+/g, '-')
    + '">'
    + text
    + '</h'
    + level
    + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered) {
  var type = ordered ? 'ol' : 'ul';
  return '<' + type + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + '<tbody>\n'
    + body
    + '</tbody>\n'
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' style="text-align:' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  if (this.options.sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0) {
      return '';
    }
  }
  var out = '<a href="' + href + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer;
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options, renderer) {
  var parser = new Parser(options, renderer);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options, this.renderer);
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        this.token.text);
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = ''
        , body = ''
        , i
        , row
        , cell
        , flags
        , j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        flags = { header: true, align: this.token.align[i] };
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      var body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      var body = ''
        , ordered = this.token.ordered;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered);
    }
    case 'list_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'loose_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'html': {
      var html = !this.token.pre && !this.options.pedantic
        ? this.inline.output(this.token.text)
        : this.token.text;
      return this.renderer.html(html);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  return html
    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function unescape(html) {
	// explicitly match decimal, hex, and named HTML entities 
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function replace(regex, opt) {
  regex = regex.source;
  opt = opt || '';
  return function self(name, val) {
    if (!name) return new RegExp(regex, opt);
    val = val.source || val;
    val = val.replace(/(^|[^\[])\^/g, '$1');
    regex = regex.replace(name, val);
    return self;
  };
}

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1
    , target
    , key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}


/**
 * Marked
 */

function marked(src, opt, callback) {
  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight
      , tokens
      , pending
      , i = 0;

    try {
      tokens = Lexer.lex(src, opt)
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/chjj/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occured:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.defaults = {
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  sanitizer: null,
  mangle: true,
  smartLists: false,
  silent: false,
  highlight: null,
  langPrefix: 'lang-',
  smartypants: false,
  headerPrefix: '',
  renderer: new Renderer,
  xhtml: false
};

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;

if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  this.marked = marked;
}

}).call(function() {
  return this || (typeof window !== 'undefined' ? window : global);
}());

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],78:[function(require,module,exports){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.proj4 = factory());
}(this, (function () { 'use strict';

	var globals = function(defs) {
	  defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
	  defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
	  defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");

	  defs.WGS84 = defs['EPSG:4326'];
	  defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
	  defs.GOOGLE = defs['EPSG:3857'];
	  defs['EPSG:900913'] = defs['EPSG:3857'];
	  defs['EPSG:102113'] = defs['EPSG:3857'];
	};

	var PJD_3PARAM = 1;
	var PJD_7PARAM = 2;
	var PJD_WGS84 = 4; // WGS84 or equivalent
	var PJD_NODATUM = 5; // WGS84 or equivalent
	var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
	var HALF_PI = Math.PI/2;
	// ellipoid pj_set_ell.c
	var SIXTH = 0.1666666666666666667;
	/* 1/6 */
	var RA4 = 0.04722222222222222222;
	/* 17/360 */
	var RA6 = 0.02215608465608465608;
	var EPSLN = 1.0e-10;
	// you'd think you could use Number.EPSILON above but that makes
	// Mollweide get into an infinate loop.

	var D2R = 0.01745329251994329577;
	var R2D = 57.29577951308232088;
	var FORTPI = Math.PI/4;
	var TWO_PI = Math.PI * 2;
	// SPI is slightly greater than Math.PI, so values that exceed the -180..180
	// degree range by a tiny amount don't get wrapped. This prevents points that
	// have drifted from their original location along the 180th meridian (due to
	// floating point error) from changing their sign.
	var SPI = 3.14159265359;

	var exports$1 = {};
	exports$1.greenwich = 0.0; //"0dE",
	exports$1.lisbon = -9.131906111111; //"9d07'54.862\"W",
	exports$1.paris = 2.337229166667; //"2d20'14.025\"E",
	exports$1.bogota = -74.080916666667; //"74d04'51.3\"W",
	exports$1.madrid = -3.687938888889; //"3d41'16.58\"W",
	exports$1.rome = 12.452333333333; //"12d27'8.4\"E",
	exports$1.bern = 7.439583333333; //"7d26'22.5\"E",
	exports$1.jakarta = 106.807719444444; //"106d48'27.79\"E",
	exports$1.ferro = -17.666666666667; //"17d40'W",
	exports$1.brussels = 4.367975; //"4d22'4.71\"E",
	exports$1.stockholm = 18.058277777778; //"18d3'29.8\"E",
	exports$1.athens = 23.7163375; //"23d42'58.815\"E",
	exports$1.oslo = 10.722916666667; //"10d43'22.5\"E"

	var units = {
	  ft: {to_meter: 0.3048},
	  'us-ft': {to_meter: 1200 / 3937}
	};

	var ignoredChar = /[\s_\-\/\(\)]/g;
	function match(obj, key) {
	  if (obj[key]) {
	    return obj[key];
	  }
	  var keys = Object.keys(obj);
	  var lkey = key.toLowerCase().replace(ignoredChar, '');
	  var i = -1;
	  var testkey, processedKey;
	  while (++i < keys.length) {
	    testkey = keys[i];
	    processedKey = testkey.toLowerCase().replace(ignoredChar, '');
	    if (processedKey === lkey) {
	      return obj[testkey];
	    }
	  }
	}

	var parseProj = function(defData) {
	  var self = {};
	  var paramObj = defData.split('+').map(function(v) {
	    return v.trim();
	  }).filter(function(a) {
	    return a;
	  }).reduce(function(p, a) {
	    var split = a.split('=');
	    split.push(true);
	    p[split[0].toLowerCase()] = split[1];
	    return p;
	  }, {});
	  var paramName, paramVal, paramOutname;
	  var params = {
	    proj: 'projName',
	    datum: 'datumCode',
	    rf: function(v) {
	      self.rf = parseFloat(v);
	    },
	    lat_0: function(v) {
	      self.lat0 = v * D2R;
	    },
	    lat_1: function(v) {
	      self.lat1 = v * D2R;
	    },
	    lat_2: function(v) {
	      self.lat2 = v * D2R;
	    },
	    lat_ts: function(v) {
	      self.lat_ts = v * D2R;
	    },
	    lon_0: function(v) {
	      self.long0 = v * D2R;
	    },
	    lon_1: function(v) {
	      self.long1 = v * D2R;
	    },
	    lon_2: function(v) {
	      self.long2 = v * D2R;
	    },
	    alpha: function(v) {
	      self.alpha = parseFloat(v) * D2R;
	    },
	    lonc: function(v) {
	      self.longc = v * D2R;
	    },
	    x_0: function(v) {
	      self.x0 = parseFloat(v);
	    },
	    y_0: function(v) {
	      self.y0 = parseFloat(v);
	    },
	    k_0: function(v) {
	      self.k0 = parseFloat(v);
	    },
	    k: function(v) {
	      self.k0 = parseFloat(v);
	    },
	    a: function(v) {
	      self.a = parseFloat(v);
	    },
	    b: function(v) {
	      self.b = parseFloat(v);
	    },
	    r_a: function() {
	      self.R_A = true;
	    },
	    zone: function(v) {
	      self.zone = parseInt(v, 10);
	    },
	    south: function() {
	      self.utmSouth = true;
	    },
	    towgs84: function(v) {
	      self.datum_params = v.split(",").map(function(a) {
	        return parseFloat(a);
	      });
	    },
	    to_meter: function(v) {
	      self.to_meter = parseFloat(v);
	    },
	    units: function(v) {
	      self.units = v;
	      var unit = match(units, v);
	      if (unit) {
	        self.to_meter = unit.to_meter;
	      }
	    },
	    from_greenwich: function(v) {
	      self.from_greenwich = v * D2R;
	    },
	    pm: function(v) {
	      var pm = match(exports$1, v);
	      self.from_greenwich = (pm ? pm : parseFloat(v)) * D2R;
	    },
	    nadgrids: function(v) {
	      if (v === '@null') {
	        self.datumCode = 'none';
	      }
	      else {
	        self.nadgrids = v;
	      }
	    },
	    axis: function(v) {
	      var legalAxis = "ewnsud";
	      if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) {
	        self.axis = v;
	      }
	    }
	  };
	  for (paramName in paramObj) {
	    paramVal = paramObj[paramName];
	    if (paramName in params) {
	      paramOutname = params[paramName];
	      if (typeof paramOutname === 'function') {
	        paramOutname(paramVal);
	      }
	      else {
	        self[paramOutname] = paramVal;
	      }
	    }
	    else {
	      self[paramName] = paramVal;
	    }
	  }
	  if(typeof self.datumCode === 'string' && self.datumCode !== "WGS84"){
	    self.datumCode = self.datumCode.toLowerCase();
	  }
	  return self;
	};

	var NEUTRAL = 1;
	var KEYWORD = 2;
	var NUMBER = 3;
	var QUOTED = 4;
	var AFTERQUOTE = 5;
	var ENDED = -1;
	var whitespace = /\s/;
	var latin = /[A-Za-z]/;
	var keyword = /[A-Za-z84]/;
	var endThings = /[,\]]/;
	var digets = /[\d\.E\-\+]/;
	// const ignoredChar = /[\s_\-\/\(\)]/g;
	function Parser(text) {
	  if (typeof text !== 'string') {
	    throw new Error('not a string');
	  }
	  this.text = text.trim();
	  this.level = 0;
	  this.place = 0;
	  this.root = null;
	  this.stack = [];
	  this.currentObject = null;
	  this.state = NEUTRAL;
	}
	Parser.prototype.readCharicter = function() {
	  var char = this.text[this.place++];
	  if (this.state !== QUOTED) {
	    while (whitespace.test(char)) {
	      if (this.place >= this.text.length) {
	        return;
	      }
	      char = this.text[this.place++];
	    }
	  }
	  switch (this.state) {
	    case NEUTRAL:
	      return this.neutral(char);
	    case KEYWORD:
	      return this.keyword(char)
	    case QUOTED:
	      return this.quoted(char);
	    case AFTERQUOTE:
	      return this.afterquote(char);
	    case NUMBER:
	      return this.number(char);
	    case ENDED:
	      return;
	  }
	};
	Parser.prototype.afterquote = function(char) {
	  if (char === '"') {
	    this.word += '"';
	    this.state = QUOTED;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.word = this.word.trim();
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in afterquote yet, index ' + this.place);
	};
	Parser.prototype.afterItem = function(char) {
	  if (char === ',') {
	    if (this.word !== null) {
	      this.currentObject.push(this.word);
	    }
	    this.word = null;
	    this.state = NEUTRAL;
	    return;
	  }
	  if (char === ']') {
	    this.level--;
	    if (this.word !== null) {
	      this.currentObject.push(this.word);
	      this.word = null;
	    }
	    this.state = NEUTRAL;
	    this.currentObject = this.stack.pop();
	    if (!this.currentObject) {
	      this.state = ENDED;
	    }

	    return;
	  }
	};
	Parser.prototype.number = function(char) {
	  if (digets.test(char)) {
	    this.word += char;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.word = parseFloat(this.word);
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in number yet, index ' + this.place);
	};
	Parser.prototype.quoted = function(char) {
	  if (char === '"') {
	    this.state = AFTERQUOTE;
	    return;
	  }
	  this.word += char;
	  return;
	};
	Parser.prototype.keyword = function(char) {
	  if (keyword.test(char)) {
	    this.word += char;
	    return;
	  }
	  if (char === '[') {
	    var newObjects = [];
	    newObjects.push(this.word);
	    this.level++;
	    if (this.root === null) {
	      this.root = newObjects;
	    } else {
	      this.currentObject.push(newObjects);
	    }
	    this.stack.push(this.currentObject);
	    this.currentObject = newObjects;
	    this.state = NEUTRAL;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in keyword yet, index ' + this.place);
	};
	Parser.prototype.neutral = function(char) {
	  if (latin.test(char)) {
	    this.word = char;
	    this.state = KEYWORD;
	    return;
	  }
	  if (char === '"') {
	    this.word = '';
	    this.state = QUOTED;
	    return;
	  }
	  if (digets.test(char)) {
	    this.word = char;
	    this.state = NUMBER;
	    return;
	  }
	  if (endThings.test(char)) {
	    this.afterItem(char);
	    return;
	  }
	  throw new Error('havn\'t handled "' +char + '" in neutral yet, index ' + this.place);
	};
	Parser.prototype.output = function() {
	  while (this.place < this.text.length) {
	    this.readCharicter();
	  }
	  if (this.state === ENDED) {
	    return this.root;
	  }
	  throw new Error('unable to parse string "' +this.text + '". State is ' + this.state);
	};

	function parseString(txt) {
	  var parser = new Parser(txt);
	  return parser.output();
	}

	function mapit(obj, key, value) {
	  if (Array.isArray(key)) {
	    value.unshift(key);
	    key = null;
	  }
	  var thing = key ? {} : obj;

	  var out = value.reduce(function(newObj, item) {
	    sExpr(item, newObj);
	    return newObj
	  }, thing);
	  if (key) {
	    obj[key] = out;
	  }
	}

	function sExpr(v, obj) {
	  if (!Array.isArray(v)) {
	    obj[v] = true;
	    return;
	  }
	  var key = v.shift();
	  if (key === 'PARAMETER') {
	    key = v.shift();
	  }
	  if (v.length === 1) {
	    if (Array.isArray(v[0])) {
	      obj[key] = {};
	      sExpr(v[0], obj[key]);
	      return;
	    }
	    obj[key] = v[0];
	    return;
	  }
	  if (!v.length) {
	    obj[key] = true;
	    return;
	  }
	  if (key === 'TOWGS84') {
	    obj[key] = v;
	    return;
	  }
	  if (!Array.isArray(key)) {
	    obj[key] = {};
	  }

	  var i;
	  switch (key) {
	    case 'UNIT':
	    case 'PRIMEM':
	    case 'VERT_DATUM':
	      obj[key] = {
	        name: v[0].toLowerCase(),
	        convert: v[1]
	      };
	      if (v.length === 3) {
	        sExpr(v[2], obj[key]);
	      }
	      return;
	    case 'SPHEROID':
	    case 'ELLIPSOID':
	      obj[key] = {
	        name: v[0],
	        a: v[1],
	        rf: v[2]
	      };
	      if (v.length === 4) {
	        sExpr(v[3], obj[key]);
	      }
	      return;
	    case 'PROJECTEDCRS':
	    case 'PROJCRS':
	    case 'GEOGCS':
	    case 'GEOCCS':
	    case 'PROJCS':
	    case 'LOCAL_CS':
	    case 'GEODCRS':
	    case 'GEODETICCRS':
	    case 'GEODETICDATUM':
	    case 'EDATUM':
	    case 'ENGINEERINGDATUM':
	    case 'VERT_CS':
	    case 'VERTCRS':
	    case 'VERTICALCRS':
	    case 'COMPD_CS':
	    case 'COMPOUNDCRS':
	    case 'ENGINEERINGCRS':
	    case 'ENGCRS':
	    case 'FITTED_CS':
	    case 'LOCAL_DATUM':
	    case 'DATUM':
	      v[0] = ['name', v[0]];
	      mapit(obj, key, v);
	      return;
	    default:
	      i = -1;
	      while (++i < v.length) {
	        if (!Array.isArray(v[i])) {
	          return sExpr(v, obj[key]);
	        }
	      }
	      return mapit(obj, key, v);
	  }
	}

	var D2R$1 = 0.01745329251994329577;
	function rename(obj, params) {
	  var outName = params[0];
	  var inName = params[1];
	  if (!(outName in obj) && (inName in obj)) {
	    obj[outName] = obj[inName];
	    if (params.length === 3) {
	      obj[outName] = params[2](obj[outName]);
	    }
	  }
	}

	function d2r(input) {
	  return input * D2R$1;
	}

	function cleanWKT(wkt) {
	  if (wkt.type === 'GEOGCS') {
	    wkt.projName = 'longlat';
	  } else if (wkt.type === 'LOCAL_CS') {
	    wkt.projName = 'identity';
	    wkt.local = true;
	  } else {
	    if (typeof wkt.PROJECTION === 'object') {
	      wkt.projName = Object.keys(wkt.PROJECTION)[0];
	    } else {
	      wkt.projName = wkt.PROJECTION;
	    }
	  }
	  if (wkt.UNIT) {
	    wkt.units = wkt.UNIT.name.toLowerCase();
	    if (wkt.units === 'metre') {
	      wkt.units = 'meter';
	    }
	    if (wkt.UNIT.convert) {
	      if (wkt.type === 'GEOGCS') {
	        if (wkt.DATUM && wkt.DATUM.SPHEROID) {
	          wkt.to_meter = wkt.UNIT.convert*wkt.DATUM.SPHEROID.a;
	        }
	      } else {
	        wkt.to_meter = wkt.UNIT.convert, 10;
	      }
	    }
	  }
	  var geogcs = wkt.GEOGCS;
	  if (wkt.type === 'GEOGCS') {
	    geogcs = wkt;
	  }
	  if (geogcs) {
	    //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
	    //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
	    //}
	    if (geogcs.DATUM) {
	      wkt.datumCode = geogcs.DATUM.name.toLowerCase();
	    } else {
	      wkt.datumCode = geogcs.name.toLowerCase();
	    }
	    if (wkt.datumCode.slice(0, 2) === 'd_') {
	      wkt.datumCode = wkt.datumCode.slice(2);
	    }
	    if (wkt.datumCode === 'new_zealand_geodetic_datum_1949' || wkt.datumCode === 'new_zealand_1949') {
	      wkt.datumCode = 'nzgd49';
	    }
	    if (wkt.datumCode === 'wgs_1984') {
	      if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') {
	        wkt.sphere = true;
	      }
	      wkt.datumCode = 'wgs84';
	    }
	    if (wkt.datumCode.slice(-6) === '_ferro') {
	      wkt.datumCode = wkt.datumCode.slice(0, - 6);
	    }
	    if (wkt.datumCode.slice(-8) === '_jakarta') {
	      wkt.datumCode = wkt.datumCode.slice(0, - 8);
	    }
	    if (~wkt.datumCode.indexOf('belge')) {
	      wkt.datumCode = 'rnb72';
	    }
	    if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
	      wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
	      if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') {
	        wkt.ellps = 'intl';
	      }

	      wkt.a = geogcs.DATUM.SPHEROID.a;
	      wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
	    }
	    if (~wkt.datumCode.indexOf('osgb_1936')) {
	      wkt.datumCode = 'osgb36';
	    }
	    if (~wkt.datumCode.indexOf('osni_1952')) {
	      wkt.datumCode = 'osni52';
	    }
	    if (~wkt.datumCode.indexOf('tm65')
	      || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) {
	      wkt.datumCode = 'ire65';
	    }
	  }
	  if (wkt.b && !isFinite(wkt.b)) {
	    wkt.b = wkt.a;
	  }

	  function toMeter(input) {
	    var ratio = wkt.to_meter || 1;
	    return input * ratio;
	  }
	  var renamer = function(a) {
	    return rename(wkt, a);
	  };
	  var list = [
	    ['standard_parallel_1', 'Standard_Parallel_1'],
	    ['standard_parallel_2', 'Standard_Parallel_2'],
	    ['false_easting', 'False_Easting'],
	    ['false_northing', 'False_Northing'],
	    ['central_meridian', 'Central_Meridian'],
	    ['latitude_of_origin', 'Latitude_Of_Origin'],
	    ['latitude_of_origin', 'Central_Parallel'],
	    ['scale_factor', 'Scale_Factor'],
	    ['k0', 'scale_factor'],
	    ['latitude_of_center', 'Latitude_of_center'],
	    ['lat0', 'latitude_of_center', d2r],
	    ['longitude_of_center', 'Longitude_Of_Center'],
	    ['longc', 'longitude_of_center', d2r],
	    ['x0', 'false_easting', toMeter],
	    ['y0', 'false_northing', toMeter],
	    ['long0', 'central_meridian', d2r],
	    ['lat0', 'latitude_of_origin', d2r],
	    ['lat0', 'standard_parallel_1', d2r],
	    ['lat1', 'standard_parallel_1', d2r],
	    ['lat2', 'standard_parallel_2', d2r],
	    ['alpha', 'azimuth', d2r],
	    ['srsCode', 'name']
	  ];
	  list.forEach(renamer);
	  if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === 'Lambert_Azimuthal_Equal_Area')) {
	    wkt.long0 = wkt.longc;
	  }
	  if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
	    wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
	    wkt.lat_ts = wkt.lat1;
	  }
	}
	var wkt = function(wkt) {
	  var lisp = parseString(wkt);
	  var type = lisp.shift();
	  var name = lisp.shift();
	  lisp.unshift(['name', name]);
	  lisp.unshift(['type', type]);
	  var obj = {};
	  sExpr(lisp, obj);
	  cleanWKT(obj);
	  return obj;
	};

	function defs(name) {
	  /*global console*/
	  var that = this;
	  if (arguments.length === 2) {
	    var def = arguments[1];
	    if (typeof def === 'string') {
	      if (def.charAt(0) === '+') {
	        defs[name] = parseProj(arguments[1]);
	      }
	      else {
	        defs[name] = wkt(arguments[1]);
	      }
	    } else {
	      defs[name] = def;
	    }
	  }
	  else if (arguments.length === 1) {
	    if (Array.isArray(name)) {
	      return name.map(function(v) {
	        if (Array.isArray(v)) {
	          defs.apply(that, v);
	        }
	        else {
	          defs(v);
	        }
	      });
	    }
	    else if (typeof name === 'string') {
	      if (name in defs) {
	        return defs[name];
	      }
	    }
	    else if ('EPSG' in name) {
	      defs['EPSG:' + name.EPSG] = name;
	    }
	    else if ('ESRI' in name) {
	      defs['ESRI:' + name.ESRI] = name;
	    }
	    else if ('IAU2000' in name) {
	      defs['IAU2000:' + name.IAU2000] = name;
	    }
	    else {
	      console.log(name);
	    }
	    return;
	  }


	}
	globals(defs);

	function testObj(code){
	  return typeof code === 'string';
	}
	function testDef(code){
	  return code in defs;
	}
	 var codeWords = ['PROJECTEDCRS', 'PROJCRS', 'GEOGCS','GEOCCS','PROJCS','LOCAL_CS', 'GEODCRS', 'GEODETICCRS', 'GEODETICDATUM', 'ENGCRS', 'ENGINEERINGCRS']; 
	function testWKT(code){
	  return codeWords.some(function (word) {
	    return code.indexOf(word) > -1;
	  });
	}
	function testProj(code){
	  return code[0] === '+';
	}
	function parse(code){
	  if (testObj(code)) {
	    //check to see if this is a WKT string
	    if (testDef(code)) {
	      return defs[code];
	    }
	    if (testWKT(code)) {
	      return wkt(code);
	    }
	    if (testProj(code)) {
	      return parseProj(code);
	    }
	  }else{
	    return code;
	  }
	}

	var extend = function(destination, source) {
	  destination = destination || {};
	  var value, property;
	  if (!source) {
	    return destination;
	  }
	  for (property in source) {
	    value = source[property];
	    if (value !== undefined) {
	      destination[property] = value;
	    }
	  }
	  return destination;
	};

	var msfnz = function(eccent, sinphi, cosphi) {
	  var con = eccent * sinphi;
	  return cosphi / (Math.sqrt(1 - con * con));
	};

	var sign = function(x) {
	  return x<0 ? -1 : 1;
	};

	var adjust_lon = function(x) {
	  return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
	};

	var tsfnz = function(eccent, phi, sinphi) {
	  var con = eccent * sinphi;
	  var com = 0.5 * eccent;
	  con = Math.pow(((1 - con) / (1 + con)), com);
	  return (Math.tan(0.5 * (HALF_PI - phi)) / con);
	};

	var phi2z = function(eccent, ts) {
	  var eccnth = 0.5 * eccent;
	  var con, dphi;
	  var phi = HALF_PI - 2 * Math.atan(ts);
	  for (var i = 0; i <= 15; i++) {
	    con = eccent * Math.sin(phi);
	    dphi = HALF_PI - 2 * Math.atan(ts * (Math.pow(((1 - con) / (1 + con)), eccnth))) - phi;
	    phi += dphi;
	    if (Math.abs(dphi) <= 0.0000000001) {
	      return phi;
	    }
	  }
	  //console.log("phi2z has NoConvergence");
	  return -9999;
	};

	function init() {
	  var con = this.b / this.a;
	  this.es = 1 - con * con;
	  if(!('x0' in this)){
	    this.x0 = 0;
	  }
	  if(!('y0' in this)){
	    this.y0 = 0;
	  }
	  this.e = Math.sqrt(this.es);
	  if (this.lat_ts) {
	    if (this.sphere) {
	      this.k0 = Math.cos(this.lat_ts);
	    }
	    else {
	      this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
	    }
	  }
	  else {
	    if (!this.k0) {
	      if (this.k) {
	        this.k0 = this.k;
	      }
	      else {
	        this.k0 = 1;
	      }
	    }
	  }
	}

	/* Mercator forward equations--mapping lat,long to x,y
	  --------------------------------------------------*/

	function forward(p) {
	  var lon = p.x;
	  var lat = p.y;
	  // convert to radians
	  if (lat * R2D > 90 && lat * R2D < -90 && lon * R2D > 180 && lon * R2D < -180) {
	    return null;
	  }

	  var x, y;
	  if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
	    return null;
	  }
	  else {
	    if (this.sphere) {
	      x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
	      y = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * lat));
	    }
	    else {
	      var sinphi = Math.sin(lat);
	      var ts = tsfnz(this.e, lat, sinphi);
	      x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
	      y = this.y0 - this.a * this.k0 * Math.log(ts);
	    }
	    p.x = x;
	    p.y = y;
	    return p;
	  }
	}

	/* Mercator inverse equations--mapping x,y to lat/long
	  --------------------------------------------------*/
	function inverse(p) {

	  var x = p.x - this.x0;
	  var y = p.y - this.y0;
	  var lon, lat;

	  if (this.sphere) {
	    lat = HALF_PI - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
	  }
	  else {
	    var ts = Math.exp(-y / (this.a * this.k0));
	    lat = phi2z(this.e, ts);
	    if (lat === -9999) {
	      return null;
	    }
	  }
	  lon = adjust_lon(this.long0 + x / (this.a * this.k0));

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$1 = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
	var merc = {
	  init: init,
	  forward: forward,
	  inverse: inverse,
	  names: names$1
	};

	function init$1() {
	  //no-op for longlat
	}

	function identity(pt) {
	  return pt;
	}
	var names$2 = ["longlat", "identity"];
	var longlat = {
	  init: init$1,
	  forward: identity,
	  inverse: identity,
	  names: names$2
	};

	var projs = [merc, longlat];
	var names$$1 = {};
	var projStore = [];

	function add(proj, i) {
	  var len = projStore.length;
	  if (!proj.names) {
	    console.log(i);
	    return true;
	  }
	  projStore[len] = proj;
	  proj.names.forEach(function(n) {
	    names$$1[n.toLowerCase()] = len;
	  });
	  return this;
	}

	function get(name) {
	  if (!name) {
	    return false;
	  }
	  var n = name.toLowerCase();
	  if (typeof names$$1[n] !== 'undefined' && projStore[names$$1[n]]) {
	    return projStore[names$$1[n]];
	  }
	}

	function start() {
	  projs.forEach(add);
	}
	var projections = {
	  start: start,
	  add: add,
	  get: get
	};

	var exports$2 = {};
	exports$2.MERIT = {
	  a: 6378137.0,
	  rf: 298.257,
	  ellipseName: "MERIT 1983"
	};

	exports$2.SGS85 = {
	  a: 6378136.0,
	  rf: 298.257,
	  ellipseName: "Soviet Geodetic System 85"
	};

	exports$2.GRS80 = {
	  a: 6378137.0,
	  rf: 298.257222101,
	  ellipseName: "GRS 1980(IUGG, 1980)"
	};

	exports$2.IAU76 = {
	  a: 6378140.0,
	  rf: 298.257,
	  ellipseName: "IAU 1976"
	};

	exports$2.airy = {
	  a: 6377563.396,
	  b: 6356256.910,
	  ellipseName: "Airy 1830"
	};

	exports$2.APL4 = {
	  a: 6378137,
	  rf: 298.25,
	  ellipseName: "Appl. Physics. 1965"
	};

	exports$2.NWL9D = {
	  a: 6378145.0,
	  rf: 298.25,
	  ellipseName: "Naval Weapons Lab., 1965"
	};

	exports$2.mod_airy = {
	  a: 6377340.189,
	  b: 6356034.446,
	  ellipseName: "Modified Airy"
	};

	exports$2.andrae = {
	  a: 6377104.43,
	  rf: 300.0,
	  ellipseName: "Andrae 1876 (Den., Iclnd.)"
	};

	exports$2.aust_SA = {
	  a: 6378160.0,
	  rf: 298.25,
	  ellipseName: "Australian Natl & S. Amer. 1969"
	};

	exports$2.GRS67 = {
	  a: 6378160.0,
	  rf: 298.2471674270,
	  ellipseName: "GRS 67(IUGG 1967)"
	};

	exports$2.bessel = {
	  a: 6377397.155,
	  rf: 299.1528128,
	  ellipseName: "Bessel 1841"
	};

	exports$2.bess_nam = {
	  a: 6377483.865,
	  rf: 299.1528128,
	  ellipseName: "Bessel 1841 (Namibia)"
	};

	exports$2.clrk66 = {
	  a: 6378206.4,
	  b: 6356583.8,
	  ellipseName: "Clarke 1866"
	};

	exports$2.clrk80 = {
	  a: 6378249.145,
	  rf: 293.4663,
	  ellipseName: "Clarke 1880 mod."
	};

	exports$2.clrk58 = {
	  a: 6378293.645208759,
	  rf: 294.2606763692654,
	  ellipseName: "Clarke 1858"
	};

	exports$2.CPM = {
	  a: 6375738.7,
	  rf: 334.29,
	  ellipseName: "Comm. des Poids et Mesures 1799"
	};

	exports$2.delmbr = {
	  a: 6376428.0,
	  rf: 311.5,
	  ellipseName: "Delambre 1810 (Belgium)"
	};

	exports$2.engelis = {
	  a: 6378136.05,
	  rf: 298.2566,
	  ellipseName: "Engelis 1985"
	};

	exports$2.evrst30 = {
	  a: 6377276.345,
	  rf: 300.8017,
	  ellipseName: "Everest 1830"
	};

	exports$2.evrst48 = {
	  a: 6377304.063,
	  rf: 300.8017,
	  ellipseName: "Everest 1948"
	};

	exports$2.evrst56 = {
	  a: 6377301.243,
	  rf: 300.8017,
	  ellipseName: "Everest 1956"
	};

	exports$2.evrst69 = {
	  a: 6377295.664,
	  rf: 300.8017,
	  ellipseName: "Everest 1969"
	};

	exports$2.evrstSS = {
	  a: 6377298.556,
	  rf: 300.8017,
	  ellipseName: "Everest (Sabah & Sarawak)"
	};

	exports$2.fschr60 = {
	  a: 6378166.0,
	  rf: 298.3,
	  ellipseName: "Fischer (Mercury Datum) 1960"
	};

	exports$2.fschr60m = {
	  a: 6378155.0,
	  rf: 298.3,
	  ellipseName: "Fischer 1960"
	};

	exports$2.fschr68 = {
	  a: 6378150.0,
	  rf: 298.3,
	  ellipseName: "Fischer 1968"
	};

	exports$2.helmert = {
	  a: 6378200.0,
	  rf: 298.3,
	  ellipseName: "Helmert 1906"
	};

	exports$2.hough = {
	  a: 6378270.0,
	  rf: 297.0,
	  ellipseName: "Hough"
	};

	exports$2.intl = {
	  a: 6378388.0,
	  rf: 297.0,
	  ellipseName: "International 1909 (Hayford)"
	};

	exports$2.kaula = {
	  a: 6378163.0,
	  rf: 298.24,
	  ellipseName: "Kaula 1961"
	};

	exports$2.lerch = {
	  a: 6378139.0,
	  rf: 298.257,
	  ellipseName: "Lerch 1979"
	};

	exports$2.mprts = {
	  a: 6397300.0,
	  rf: 191.0,
	  ellipseName: "Maupertius 1738"
	};

	exports$2.new_intl = {
	  a: 6378157.5,
	  b: 6356772.2,
	  ellipseName: "New International 1967"
	};

	exports$2.plessis = {
	  a: 6376523.0,
	  rf: 6355863.0,
	  ellipseName: "Plessis 1817 (France)"
	};

	exports$2.krass = {
	  a: 6378245.0,
	  rf: 298.3,
	  ellipseName: "Krassovsky, 1942"
	};

	exports$2.SEasia = {
	  a: 6378155.0,
	  b: 6356773.3205,
	  ellipseName: "Southeast Asia"
	};

	exports$2.walbeck = {
	  a: 6376896.0,
	  b: 6355834.8467,
	  ellipseName: "Walbeck"
	};

	exports$2.WGS60 = {
	  a: 6378165.0,
	  rf: 298.3,
	  ellipseName: "WGS 60"
	};

	exports$2.WGS66 = {
	  a: 6378145.0,
	  rf: 298.25,
	  ellipseName: "WGS 66"
	};

	exports$2.WGS7 = {
	  a: 6378135.0,
	  rf: 298.26,
	  ellipseName: "WGS 72"
	};

	var WGS84 = exports$2.WGS84 = {
	  a: 6378137.0,
	  rf: 298.257223563,
	  ellipseName: "WGS 84"
	};

	exports$2.sphere = {
	  a: 6370997.0,
	  b: 6370997.0,
	  ellipseName: "Normal Sphere (r=6370997)"
	};

	function eccentricity(a, b, rf, R_A) {
	  var a2 = a * a; // used in geocentric
	  var b2 = b * b; // used in geocentric
	  var es = (a2 - b2) / a2; // e ^ 2
	  var e = 0;
	  if (R_A) {
	    a *= 1 - es * (SIXTH + es * (RA4 + es * RA6));
	    a2 = a * a;
	    es = 0;
	  } else {
	    e = Math.sqrt(es); // eccentricity
	  }
	  var ep2 = (a2 - b2) / b2; // used in geocentric
	  return {
	    es: es,
	    e: e,
	    ep2: ep2
	  };
	}
	function sphere(a, b, rf, ellps, sphere) {
	  if (!a) { // do we have an ellipsoid?
	    var ellipse = match(exports$2, ellps);
	    if (!ellipse) {
	      ellipse = WGS84;
	    }
	    a = ellipse.a;
	    b = ellipse.b;
	    rf = ellipse.rf;
	  }

	  if (rf && !b) {
	    b = (1.0 - 1.0 / rf) * a;
	  }
	  if (rf === 0 || Math.abs(a - b) < EPSLN) {
	    sphere = true;
	    b = a;
	  }
	  return {
	    a: a,
	    b: b,
	    rf: rf,
	    sphere: sphere
	  };
	}

	var exports$3 = {};
	exports$3.wgs84 = {
	  towgs84: "0,0,0",
	  ellipse: "WGS84",
	  datumName: "WGS84"
	};

	exports$3.ch1903 = {
	  towgs84: "674.374,15.056,405.346",
	  ellipse: "bessel",
	  datumName: "swiss"
	};

	exports$3.ggrs87 = {
	  towgs84: "-199.87,74.79,246.62",
	  ellipse: "GRS80",
	  datumName: "Greek_Geodetic_Reference_System_1987"
	};

	exports$3.nad83 = {
	  towgs84: "0,0,0",
	  ellipse: "GRS80",
	  datumName: "North_American_Datum_1983"
	};

	exports$3.nad27 = {
	  nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
	  ellipse: "clrk66",
	  datumName: "North_American_Datum_1927"
	};

	exports$3.potsdam = {
	  towgs84: "606.0,23.0,413.0",
	  ellipse: "bessel",
	  datumName: "Potsdam Rauenberg 1950 DHDN"
	};

	exports$3.carthage = {
	  towgs84: "-263.0,6.0,431.0",
	  ellipse: "clark80",
	  datumName: "Carthage 1934 Tunisia"
	};

	exports$3.hermannskogel = {
	  towgs84: "653.0,-212.0,449.0",
	  ellipse: "bessel",
	  datumName: "Hermannskogel"
	};

	exports$3.osni52 = {
	  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
	  ellipse: "airy",
	  datumName: "Irish National"
	};

	exports$3.ire65 = {
	  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
	  ellipse: "mod_airy",
	  datumName: "Ireland 1965"
	};

	exports$3.rassadiran = {
	  towgs84: "-133.63,-157.5,-158.62",
	  ellipse: "intl",
	  datumName: "Rassadiran"
	};

	exports$3.nzgd49 = {
	  towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
	  ellipse: "intl",
	  datumName: "New Zealand Geodetic Datum 1949"
	};

	exports$3.osgb36 = {
	  towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
	  ellipse: "airy",
	  datumName: "Airy 1830"
	};

	exports$3.s_jtsk = {
	  towgs84: "589,76,480",
	  ellipse: 'bessel',
	  datumName: 'S-JTSK (Ferro)'
	};

	exports$3.beduaram = {
	  towgs84: '-106,-87,188',
	  ellipse: 'clrk80',
	  datumName: 'Beduaram'
	};

	exports$3.gunung_segara = {
	  towgs84: '-403,684,41',
	  ellipse: 'bessel',
	  datumName: 'Gunung Segara Jakarta'
	};

	exports$3.rnb72 = {
	  towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
	  ellipse: "intl",
	  datumName: "Reseau National Belge 1972"
	};

	function datum(datumCode, datum_params, a, b, es, ep2) {
	  var out = {};

	  if (datumCode === undefined || datumCode === 'none') {
	    out.datum_type = PJD_NODATUM;
	  } else {
	    out.datum_type = PJD_WGS84;
	  }

	  if (datum_params) {
	    out.datum_params = datum_params.map(parseFloat);
	    if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) {
	      out.datum_type = PJD_3PARAM;
	    }
	    if (out.datum_params.length > 3) {
	      if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
	        out.datum_type = PJD_7PARAM;
	        out.datum_params[3] *= SEC_TO_RAD;
	        out.datum_params[4] *= SEC_TO_RAD;
	        out.datum_params[5] *= SEC_TO_RAD;
	        out.datum_params[6] = (out.datum_params[6] / 1000000.0) + 1.0;
	      }
	    }
	  }

	  out.a = a; //datum object also uses these values
	  out.b = b;
	  out.es = es;
	  out.ep2 = ep2;
	  return out;
	}

	function Projection$1(srsCode,callback) {
	  if (!(this instanceof Projection$1)) {
	    return new Projection$1(srsCode);
	  }
	  callback = callback || function(error){
	    if(error){
	      throw error;
	    }
	  };
	  var json = parse(srsCode);
	  if(typeof json !== 'object'){
	    callback(srsCode);
	    return;
	  }
	  var ourProj = Projection$1.projections.get(json.projName);
	  if(!ourProj){
	    callback(srsCode);
	    return;
	  }
	  if (json.datumCode && json.datumCode !== 'none') {
	    var datumDef = match(exports$3, json.datumCode);
	    if (datumDef) {
	      json.datum_params = datumDef.towgs84 ? datumDef.towgs84.split(',') : null;
	      json.ellps = datumDef.ellipse;
	      json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
	    }
	  }
	  json.k0 = json.k0 || 1.0;
	  json.axis = json.axis || 'enu';
	  json.ellps = json.ellps || 'wgs84';
	  var sphere_ = sphere(json.a, json.b, json.rf, json.ellps, json.sphere);
	  var ecc = eccentricity(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
	  var datumObj = json.datum || datum(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2);

	  extend(this, json); // transfer everything over from the projection because we don't know what we'll need
	  extend(this, ourProj); // transfer all the methods from the projection

	  // copy the 4 things over we calulated in deriveConstants.sphere
	  this.a = sphere_.a;
	  this.b = sphere_.b;
	  this.rf = sphere_.rf;
	  this.sphere = sphere_.sphere;

	  // copy the 3 things we calculated in deriveConstants.eccentricity
	  this.es = ecc.es;
	  this.e = ecc.e;
	  this.ep2 = ecc.ep2;

	  // add in the datum object
	  this.datum = datumObj;

	  // init the projection
	  this.init();

	  // legecy callback from back in the day when it went to spatialreference.org
	  callback(null, this);

	}
	Projection$1.projections = projections;
	Projection$1.projections.start();

	function compareDatums(source, dest) {
	  if (source.datum_type !== dest.datum_type) {
	    return false; // false, datums are not equal
	  } else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) {
	    // the tolerance for es is to ensure that GRS80 and WGS84
	    // are considered identical
	    return false;
	  } else if (source.datum_type === PJD_3PARAM) {
	    return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2]);
	  } else if (source.datum_type === PJD_7PARAM) {
	    return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6]);
	  } else {
	    return true; // datums are equal
	  }
	} // cs_compare_datums()

	/*
	 * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
	 * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
	 * according to the current ellipsoid parameters.
	 *
	 *    Latitude  : Geodetic latitude in radians                     (input)
	 *    Longitude : Geodetic longitude in radians                    (input)
	 *    Height    : Geodetic height, in meters                       (input)
	 *    X         : Calculated Geocentric X coordinate, in meters    (output)
	 *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
	 *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
	 *
	 */
	function geodeticToGeocentric(p, es, a) {
	  var Longitude = p.x;
	  var Latitude = p.y;
	  var Height = p.z ? p.z : 0; //Z value not always supplied

	  var Rn; /*  Earth radius at location  */
	  var Sin_Lat; /*  Math.sin(Latitude)  */
	  var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
	  var Cos_Lat; /*  Math.cos(Latitude)  */

	  /*
	   ** Don't blow up if Latitude is just a little out of the value
	   ** range as it may just be a rounding issue.  Also removed longitude
	   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
	   */
	  if (Latitude < -HALF_PI && Latitude > -1.001 * HALF_PI) {
	    Latitude = -HALF_PI;
	  } else if (Latitude > HALF_PI && Latitude < 1.001 * HALF_PI) {
	    Latitude = HALF_PI;
	  } else if ((Latitude < -HALF_PI) || (Latitude > HALF_PI)) {
	    /* Latitude out of range */
	    //..reportError('geocent:lat out of range:' + Latitude);
	    return null;
	  }

	  if (Longitude > Math.PI) {
	    Longitude -= (2 * Math.PI);
	  }
	  Sin_Lat = Math.sin(Latitude);
	  Cos_Lat = Math.cos(Latitude);
	  Sin2_Lat = Sin_Lat * Sin_Lat;
	  Rn = a / (Math.sqrt(1.0e0 - es * Sin2_Lat));
	  return {
	    x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
	    y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
	    z: ((Rn * (1 - es)) + Height) * Sin_Lat
	  };
	} // cs_geodetic_to_geocentric()

	function geocentricToGeodetic(p, es, a, b) {
	  /* local defintions and variables */
	  /* end-criterium of loop, accuracy of sin(Latitude) */
	  var genau = 1e-12;
	  var genau2 = (genau * genau);
	  var maxiter = 30;

	  var P; /* distance between semi-minor axis and location */
	  var RR; /* distance between center and location */
	  var CT; /* sin of geocentric latitude */
	  var ST; /* cos of geocentric latitude */
	  var RX;
	  var RK;
	  var RN; /* Earth radius at location */
	  var CPHI0; /* cos of start or old geodetic latitude in iterations */
	  var SPHI0; /* sin of start or old geodetic latitude in iterations */
	  var CPHI; /* cos of searched geodetic latitude */
	  var SPHI; /* sin of searched geodetic latitude */
	  var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
	  var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */

	  var X = p.x;
	  var Y = p.y;
	  var Z = p.z ? p.z : 0.0; //Z value not always supplied
	  var Longitude;
	  var Latitude;
	  var Height;

	  P = Math.sqrt(X * X + Y * Y);
	  RR = Math.sqrt(X * X + Y * Y + Z * Z);

	  /*      special cases for latitude and longitude */
	  if (P / a < genau) {

	    /*  special case, if P=0. (X=0., Y=0.) */
	    Longitude = 0.0;

	    /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
	     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
	    if (RR / a < genau) {
	      Latitude = HALF_PI;
	      Height = -b;
	      return {
	        x: p.x,
	        y: p.y,
	        z: p.z
	      };
	    }
	  } else {
	    /*  ellipsoidal (geodetic) longitude
	     *  interval: -PI < Longitude <= +PI */
	    Longitude = Math.atan2(Y, X);
	  }

	  /* --------------------------------------------------------------
	   * Following iterative algorithm was developped by
	   * "Institut for Erdmessung", University of Hannover, July 1988.
	   * Internet: www.ife.uni-hannover.de
	   * Iterative computation of CPHI,SPHI and Height.
	   * Iteration of CPHI and SPHI to 10**-12 radian resp.
	   * 2*10**-7 arcsec.
	   * --------------------------------------------------------------
	   */
	  CT = Z / RR;
	  ST = P / RR;
	  RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
	  CPHI0 = ST * (1.0 - es) * RX;
	  SPHI0 = CT * RX;
	  iter = 0;

	  /* loop to find sin(Latitude) resp. Latitude
	   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
	  do {
	    iter++;
	    RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);

	    /*  ellipsoidal (geodetic) height */
	    Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);

	    RK = es * RN / (RN + Height);
	    RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
	    CPHI = ST * (1.0 - RK) * RX;
	    SPHI = CT * RX;
	    SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
	    CPHI0 = CPHI;
	    SPHI0 = SPHI;
	  }
	  while (SDPHI * SDPHI > genau2 && iter < maxiter);

	  /*      ellipsoidal (geodetic) latitude */
	  Latitude = Math.atan(SPHI / Math.abs(CPHI));
	  return {
	    x: Longitude,
	    y: Latitude,
	    z: Height
	  };
	} // cs_geocentric_to_geodetic()

	/****************************************************************/
	// pj_geocentic_to_wgs84( p )
	//  p = point to transform in geocentric coordinates (x,y,z)


	/** point object, nothing fancy, just allows values to be
	    passed back and forth by reference rather than by value.
	    Other point classes may be used as long as they have
	    x and y properties, which will get modified in the transform method.
	*/
	function geocentricToWgs84(p, datum_type, datum_params) {

	  if (datum_type === PJD_3PARAM) {
	    // if( x[io] === HUGE_VAL )
	    //    continue;
	    return {
	      x: p.x + datum_params[0],
	      y: p.y + datum_params[1],
	      z: p.z + datum_params[2],
	    };
	  } else if (datum_type === PJD_7PARAM) {
	    var Dx_BF = datum_params[0];
	    var Dy_BF = datum_params[1];
	    var Dz_BF = datum_params[2];
	    var Rx_BF = datum_params[3];
	    var Ry_BF = datum_params[4];
	    var Rz_BF = datum_params[5];
	    var M_BF = datum_params[6];
	    // if( x[io] === HUGE_VAL )
	    //    continue;
	    return {
	      x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
	      y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
	      z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
	    };
	  }
	} // cs_geocentric_to_wgs84

	/****************************************************************/
	// pj_geocentic_from_wgs84()
	//  coordinate system definition,
	//  point to transform in geocentric coordinates (x,y,z)
	function geocentricFromWgs84(p, datum_type, datum_params) {

	  if (datum_type === PJD_3PARAM) {
	    //if( x[io] === HUGE_VAL )
	    //    continue;
	    return {
	      x: p.x - datum_params[0],
	      y: p.y - datum_params[1],
	      z: p.z - datum_params[2],
	    };

	  } else if (datum_type === PJD_7PARAM) {
	    var Dx_BF = datum_params[0];
	    var Dy_BF = datum_params[1];
	    var Dz_BF = datum_params[2];
	    var Rx_BF = datum_params[3];
	    var Ry_BF = datum_params[4];
	    var Rz_BF = datum_params[5];
	    var M_BF = datum_params[6];
	    var x_tmp = (p.x - Dx_BF) / M_BF;
	    var y_tmp = (p.y - Dy_BF) / M_BF;
	    var z_tmp = (p.z - Dz_BF) / M_BF;
	    //if( x[io] === HUGE_VAL )
	    //    continue;

	    return {
	      x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
	      y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
	      z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
	    };
	  } //cs_geocentric_from_wgs84()
	}

	function checkParams(type) {
	  return (type === PJD_3PARAM || type === PJD_7PARAM);
	}

	var datum_transform = function(source, dest, point) {
	  // Short cut if the datums are identical.
	  if (compareDatums(source, dest)) {
	    return point; // in this case, zero is sucess,
	    // whereas cs_compare_datums returns 1 to indicate TRUE
	    // confusing, should fix this
	  }

	  // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
	  if (source.datum_type === PJD_NODATUM || dest.datum_type === PJD_NODATUM) {
	    return point;
	  }

	  // If this datum requires grid shifts, then apply it to geodetic coordinates.

	  // Do we need to go through geocentric coordinates?
	  if (source.es === dest.es && source.a === dest.a && !checkParams(source.datum_type) &&  !checkParams(dest.datum_type)) {
	    return point;
	  }

	  // Convert to geocentric coordinates.
	  point = geodeticToGeocentric(point, source.es, source.a);
	  // Convert between datums
	  if (checkParams(source.datum_type)) {
	    point = geocentricToWgs84(point, source.datum_type, source.datum_params);
	  }
	  if (checkParams(dest.datum_type)) {
	    point = geocentricFromWgs84(point, dest.datum_type, dest.datum_params);
	  }
	  return geocentricToGeodetic(point, dest.es, dest.a, dest.b);

	};

	var adjust_axis = function(crs, denorm, point) {
	  var xin = point.x,
	    yin = point.y,
	    zin = point.z || 0.0;
	  var v, t, i;
	  var out = {};
	  for (i = 0; i < 3; i++) {
	    if (denorm && i === 2 && point.z === undefined) {
	      continue;
	    }
	    if (i === 0) {
	      v = xin;
	      t = 'x';
	    }
	    else if (i === 1) {
	      v = yin;
	      t = 'y';
	    }
	    else {
	      v = zin;
	      t = 'z';
	    }
	    switch (crs.axis[i]) {
	    case 'e':
	      out[t] = v;
	      break;
	    case 'w':
	      out[t] = -v;
	      break;
	    case 'n':
	      out[t] = v;
	      break;
	    case 's':
	      out[t] = -v;
	      break;
	    case 'u':
	      if (point[t] !== undefined) {
	        out.z = v;
	      }
	      break;
	    case 'd':
	      if (point[t] !== undefined) {
	        out.z = -v;
	      }
	      break;
	    default:
	      //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
	      return null;
	    }
	  }
	  return out;
	};

	var toPoint = function (array){
	  var out = {
	    x: array[0],
	    y: array[1]
	  };
	  if (array.length>2) {
	    out.z = array[2];
	  }
	  if (array.length>3) {
	    out.m = array[3];
	  }
	  return out;
	};

	var checkSanity = function (point) {
	  checkCoord(point.x);
	  checkCoord(point.y);
	};
	function checkCoord(num) {
	  if (typeof Number.isFinite === 'function') {
	    if (Number.isFinite(num)) {
	      return;
	    }
	    throw new TypeError('coordinates must be finite numbers');
	  }
	  if (typeof num !== 'number' || num !== num || !isFinite(num)) {
	    throw new TypeError('coordinates must be finite numbers');
	  }
	}

	function checkNotWGS(source, dest) {
	  return ((source.datum.datum_type === PJD_3PARAM || source.datum.datum_type === PJD_7PARAM) && dest.datumCode !== 'WGS84') || ((dest.datum.datum_type === PJD_3PARAM || dest.datum.datum_type === PJD_7PARAM) && source.datumCode !== 'WGS84');
	}

	function transform(source, dest, point) {
	  var wgs84;
	  if (Array.isArray(point)) {
	    point = toPoint(point);
	  }
	  checkSanity(point);
	  // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
	  if (source.datum && dest.datum && checkNotWGS(source, dest)) {
	    wgs84 = new Projection$1('WGS84');
	    point = transform(source, wgs84, point);
	    source = wgs84;
	  }
	  // DGR, 2010/11/12
	  if (source.axis !== 'enu') {
	    point = adjust_axis(source, false, point);
	  }
	  // Transform source points to long/lat, if they aren't already.
	  if (source.projName === 'longlat') {
	    point = {
	      x: point.x * D2R,
	      y: point.y * D2R
	    };
	  }
	  else {
	    if (source.to_meter) {
	      point = {
	        x: point.x * source.to_meter,
	        y: point.y * source.to_meter
	      };
	    }
	    point = source.inverse(point); // Convert Cartesian to longlat
	  }
	  // Adjust for the prime meridian if necessary
	  if (source.from_greenwich) {
	    point.x += source.from_greenwich;
	  }

	  // Convert datums if needed, and if possible.
	  point = datum_transform(source.datum, dest.datum, point);

	  // Adjust for the prime meridian if necessary
	  if (dest.from_greenwich) {
	    point = {
	      x: point.x - dest.from_greenwich,
	      y: point.y
	    };
	  }

	  if (dest.projName === 'longlat') {
	    // convert radians to decimal degrees
	    point = {
	      x: point.x * R2D,
	      y: point.y * R2D
	    };
	  } else { // else project
	    point = dest.forward(point);
	    if (dest.to_meter) {
	      point = {
	        x: point.x / dest.to_meter,
	        y: point.y / dest.to_meter
	      };
	    }
	  }

	  // DGR, 2010/11/12
	  if (dest.axis !== 'enu') {
	    return adjust_axis(dest, true, point);
	  }

	  return point;
	}

	var wgs84 = Projection$1('WGS84');

	function transformer(from, to, coords) {
	  var transformedArray, out, keys;
	  if (Array.isArray(coords)) {
	    transformedArray = transform(from, to, coords);
	    if (coords.length === 3) {
	      return [transformedArray.x, transformedArray.y, transformedArray.z];
	    }
	    else {
	      return [transformedArray.x, transformedArray.y];
	    }
	  }
	  else {
	    out = transform(from, to, coords);
	    keys = Object.keys(coords);
	    if (keys.length === 2) {
	      return out;
	    }
	    keys.forEach(function (key) {
	      if (key === 'x' || key === 'y') {
	        return;
	      }
	      out[key] = coords[key];
	    });
	    return out;
	  }
	}

	function checkProj(item) {
	  if (item instanceof Projection$1) {
	    return item;
	  }
	  if (item.oProj) {
	    return item.oProj;
	  }
	  return Projection$1(item);
	}
	function proj4$1(fromProj, toProj, coord) {
	  fromProj = checkProj(fromProj);
	  var single = false;
	  var obj;
	  if (typeof toProj === 'undefined') {
	    toProj = fromProj;
	    fromProj = wgs84;
	    single = true;
	  }
	  else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
	    coord = toProj;
	    toProj = fromProj;
	    fromProj = wgs84;
	    single = true;
	  }
	  toProj = checkProj(toProj);
	  if (coord) {
	    return transformer(fromProj, toProj, coord);
	  }
	  else {
	    obj = {
	      forward: function(coords) {
	        return transformer(fromProj, toProj, coords);
	      },
	      inverse: function(coords) {
	        return transformer(toProj, fromProj, coords);
	      }
	    };
	    if (single) {
	      obj.oProj = toProj;
	    }
	    return obj;
	  }
	}

	/**
	 * UTM zones are grouped, and assigned to one of a group of 6
	 * sets.
	 *
	 * {int} @private
	 */
	var NUM_100K_SETS = 6;

	/**
	 * The column letters (for easting) of the lower left value, per
	 * set.
	 *
	 * {string} @private
	 */
	var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';

	/**
	 * The row letters (for northing) of the lower left value, per
	 * set.
	 *
	 * {string} @private
	 */
	var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';

	var A = 65; // A
	var I = 73; // I
	var O = 79; // O
	var V = 86; // V
	var Z = 90; // Z
	var mgrs = {
	  forward: forward$1,
	  inverse: inverse$1,
	  toPoint: toPoint$1
	};
	/**
	 * Conversion of lat/lon to MGRS.
	 *
	 * @param {object} ll Object literal with lat and lon properties on a
	 *     WGS84 ellipsoid.
	 * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
	 *      100 m, 2 for 1000 m or 1 for 10000 m). Optional, default is 5.
	 * @return {string} the MGRS string for the given location and accuracy.
	 */
	function forward$1(ll, accuracy) {
	  accuracy = accuracy || 5; // default accuracy 1m
	  return encode(LLtoUTM({
	    lat: ll[1],
	    lon: ll[0]
	  }), accuracy);
	}

	/**
	 * Conversion of MGRS to lat/lon.
	 *
	 * @param {string} mgrs MGRS string.
	 * @return {array} An array with left (longitude), bottom (latitude), right
	 *     (longitude) and top (latitude) values in WGS84, representing the
	 *     bounding box for the provided MGRS reference.
	 */
	function inverse$1(mgrs) {
	  var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
	  if (bbox.lat && bbox.lon) {
	    return [bbox.lon, bbox.lat, bbox.lon, bbox.lat];
	  }
	  return [bbox.left, bbox.bottom, bbox.right, bbox.top];
	}

	function toPoint$1(mgrs) {
	  var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
	  if (bbox.lat && bbox.lon) {
	    return [bbox.lon, bbox.lat];
	  }
	  return [(bbox.left + bbox.right) / 2, (bbox.top + bbox.bottom) / 2];
	}
	/**
	 * Conversion from degrees to radians.
	 *
	 * @private
	 * @param {number} deg the angle in degrees.
	 * @return {number} the angle in radians.
	 */
	function degToRad(deg) {
	  return (deg * (Math.PI / 180.0));
	}

	/**
	 * Conversion from radians to degrees.
	 *
	 * @private
	 * @param {number} rad the angle in radians.
	 * @return {number} the angle in degrees.
	 */
	function radToDeg(rad) {
	  return (180.0 * (rad / Math.PI));
	}

	/**
	 * Converts a set of Longitude and Latitude co-ordinates to UTM
	 * using the WGS84 ellipsoid.
	 *
	 * @private
	 * @param {object} ll Object literal with lat and lon properties
	 *     representing the WGS84 coordinate to be converted.
	 * @return {object} Object literal containing the UTM value with easting,
	 *     northing, zoneNumber and zoneLetter properties, and an optional
	 *     accuracy property in digits. Returns null if the conversion failed.
	 */
	function LLtoUTM(ll) {
	  var Lat = ll.lat;
	  var Long = ll.lon;
	  var a = 6378137.0; //ellip.radius;
	  var eccSquared = 0.00669438; //ellip.eccsq;
	  var k0 = 0.9996;
	  var LongOrigin;
	  var eccPrimeSquared;
	  var N, T, C, A, M;
	  var LatRad = degToRad(Lat);
	  var LongRad = degToRad(Long);
	  var LongOriginRad;
	  var ZoneNumber;
	  // (int)
	  ZoneNumber = Math.floor((Long + 180) / 6) + 1;

	  //Make sure the longitude 180.00 is in Zone 60
	  if (Long === 180) {
	    ZoneNumber = 60;
	  }

	  // Special zone for Norway
	  if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) {
	    ZoneNumber = 32;
	  }

	  // Special zones for Svalbard
	  if (Lat >= 72.0 && Lat < 84.0) {
	    if (Long >= 0.0 && Long < 9.0) {
	      ZoneNumber = 31;
	    }
	    else if (Long >= 9.0 && Long < 21.0) {
	      ZoneNumber = 33;
	    }
	    else if (Long >= 21.0 && Long < 33.0) {
	      ZoneNumber = 35;
	    }
	    else if (Long >= 33.0 && Long < 42.0) {
	      ZoneNumber = 37;
	    }
	  }

	  LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
	  // in middle of
	  // zone
	  LongOriginRad = degToRad(LongOrigin);

	  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

	  N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
	  T = Math.tan(LatRad) * Math.tan(LatRad);
	  C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
	  A = Math.cos(LatRad) * (LongRad - LongOriginRad);

	  M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));

	  var UTMEasting = (k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0);

	  var UTMNorthing = (k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0)));
	  if (Lat < 0.0) {
	    UTMNorthing += 10000000.0; //10000000 meter offset for
	    // southern hemisphere
	  }

	  return {
	    northing: Math.round(UTMNorthing),
	    easting: Math.round(UTMEasting),
	    zoneNumber: ZoneNumber,
	    zoneLetter: getLetterDesignator(Lat)
	  };
	}

	/**
	 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
	 * class where the Zone can be specified as a single string eg."60N" which
	 * is then broken down into the ZoneNumber and ZoneLetter.
	 *
	 * @private
	 * @param {object} utm An object literal with northing, easting, zoneNumber
	 *     and zoneLetter properties. If an optional accuracy property is
	 *     provided (in meters), a bounding box will be returned instead of
	 *     latitude and longitude.
	 * @return {object} An object literal containing either lat and lon values
	 *     (if no accuracy was provided), or top, right, bottom and left values
	 *     for the bounding box calculated according to the provided accuracy.
	 *     Returns null if the conversion failed.
	 */
	function UTMtoLL(utm) {

	  var UTMNorthing = utm.northing;
	  var UTMEasting = utm.easting;
	  var zoneLetter = utm.zoneLetter;
	  var zoneNumber = utm.zoneNumber;
	  // check the ZoneNummber is valid
	  if (zoneNumber < 0 || zoneNumber > 60) {
	    return null;
	  }

	  var k0 = 0.9996;
	  var a = 6378137.0; //ellip.radius;
	  var eccSquared = 0.00669438; //ellip.eccsq;
	  var eccPrimeSquared;
	  var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
	  var N1, T1, C1, R1, D, M;
	  var LongOrigin;
	  var mu, phi1Rad;

	  // remove 500,000 meter offset for longitude
	  var x = UTMEasting - 500000.0;
	  var y = UTMNorthing;

	  // We must know somehow if we are in the Northern or Southern
	  // hemisphere, this is the only time we use the letter So even
	  // if the Zone letter isn't exactly correct it should indicate
	  // the hemisphere correctly
	  if (zoneLetter < 'N') {
	    y -= 10000000.0; // remove 10,000,000 meter offset used
	    // for southern hemisphere
	  }

	  // There are 60 zones with zone 1 being at West -180 to -174
	  LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
	  // in middle of
	  // zone

	  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

	  M = y / k0;
	  mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));

	  phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
	  // double phi1 = ProjMath.radToDeg(phi1Rad);

	  N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
	  T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
	  C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
	  R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
	  D = x / (N1 * k0);

	  var lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
	  lat = radToDeg(lat);

	  var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
	  lon = LongOrigin + radToDeg(lon);

	  var result;
	  if (utm.accuracy) {
	    var topRight = UTMtoLL({
	      northing: utm.northing + utm.accuracy,
	      easting: utm.easting + utm.accuracy,
	      zoneLetter: utm.zoneLetter,
	      zoneNumber: utm.zoneNumber
	    });
	    result = {
	      top: topRight.lat,
	      right: topRight.lon,
	      bottom: lat,
	      left: lon
	    };
	  }
	  else {
	    result = {
	      lat: lat,
	      lon: lon
	    };
	  }
	  return result;
	}

	/**
	 * Calculates the MGRS letter designator for the given latitude.
	 *
	 * @private
	 * @param {number} lat The latitude in WGS84 to get the letter designator
	 *     for.
	 * @return {char} The letter designator.
	 */
	function getLetterDesignator(lat) {
	  //This is here as an error flag to show that the Latitude is
	  //outside MGRS limits
	  var LetterDesignator = 'Z';

	  if ((84 >= lat) && (lat >= 72)) {
	    LetterDesignator = 'X';
	  }
	  else if ((72 > lat) && (lat >= 64)) {
	    LetterDesignator = 'W';
	  }
	  else if ((64 > lat) && (lat >= 56)) {
	    LetterDesignator = 'V';
	  }
	  else if ((56 > lat) && (lat >= 48)) {
	    LetterDesignator = 'U';
	  }
	  else if ((48 > lat) && (lat >= 40)) {
	    LetterDesignator = 'T';
	  }
	  else if ((40 > lat) && (lat >= 32)) {
	    LetterDesignator = 'S';
	  }
	  else if ((32 > lat) && (lat >= 24)) {
	    LetterDesignator = 'R';
	  }
	  else if ((24 > lat) && (lat >= 16)) {
	    LetterDesignator = 'Q';
	  }
	  else if ((16 > lat) && (lat >= 8)) {
	    LetterDesignator = 'P';
	  }
	  else if ((8 > lat) && (lat >= 0)) {
	    LetterDesignator = 'N';
	  }
	  else if ((0 > lat) && (lat >= -8)) {
	    LetterDesignator = 'M';
	  }
	  else if ((-8 > lat) && (lat >= -16)) {
	    LetterDesignator = 'L';
	  }
	  else if ((-16 > lat) && (lat >= -24)) {
	    LetterDesignator = 'K';
	  }
	  else if ((-24 > lat) && (lat >= -32)) {
	    LetterDesignator = 'J';
	  }
	  else if ((-32 > lat) && (lat >= -40)) {
	    LetterDesignator = 'H';
	  }
	  else if ((-40 > lat) && (lat >= -48)) {
	    LetterDesignator = 'G';
	  }
	  else if ((-48 > lat) && (lat >= -56)) {
	    LetterDesignator = 'F';
	  }
	  else if ((-56 > lat) && (lat >= -64)) {
	    LetterDesignator = 'E';
	  }
	  else if ((-64 > lat) && (lat >= -72)) {
	    LetterDesignator = 'D';
	  }
	  else if ((-72 > lat) && (lat >= -80)) {
	    LetterDesignator = 'C';
	  }
	  return LetterDesignator;
	}

	/**
	 * Encodes a UTM location as MGRS string.
	 *
	 * @private
	 * @param {object} utm An object literal with easting, northing,
	 *     zoneLetter, zoneNumber
	 * @param {number} accuracy Accuracy in digits (1-5).
	 * @return {string} MGRS string for the given UTM location.
	 */
	function encode(utm, accuracy) {
	  // prepend with leading zeroes
	  var seasting = "00000" + utm.easting,
	    snorthing = "00000" + utm.northing;

	  return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
	}

	/**
	 * Get the two letter 100k designator for a given UTM easting,
	 * northing and zone number value.
	 *
	 * @private
	 * @param {number} easting
	 * @param {number} northing
	 * @param {number} zoneNumber
	 * @return the two letter 100k designator for the given UTM location.
	 */
	function get100kID(easting, northing, zoneNumber) {
	  var setParm = get100kSetForZone(zoneNumber);
	  var setColumn = Math.floor(easting / 100000);
	  var setRow = Math.floor(northing / 100000) % 20;
	  return getLetter100kID(setColumn, setRow, setParm);
	}

	/**
	 * Given a UTM zone number, figure out the MGRS 100K set it is in.
	 *
	 * @private
	 * @param {number} i An UTM zone number.
	 * @return {number} the 100k set the UTM zone is in.
	 */
	function get100kSetForZone(i) {
	  var setParm = i % NUM_100K_SETS;
	  if (setParm === 0) {
	    setParm = NUM_100K_SETS;
	  }

	  return setParm;
	}

	/**
	 * Get the two-letter MGRS 100k designator given information
	 * translated from the UTM northing, easting and zone number.
	 *
	 * @private
	 * @param {number} column the column index as it relates to the MGRS
	 *        100k set spreadsheet, created from the UTM easting.
	 *        Values are 1-8.
	 * @param {number} row the row index as it relates to the MGRS 100k set
	 *        spreadsheet, created from the UTM northing value. Values
	 *        are from 0-19.
	 * @param {number} parm the set block, as it relates to the MGRS 100k set
	 *        spreadsheet, created from the UTM zone. Values are from
	 *        1-60.
	 * @return two letter MGRS 100k code.
	 */
	function getLetter100kID(column, row, parm) {
	  // colOrigin and rowOrigin are the letters at the origin of the set
	  var index = parm - 1;
	  var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
	  var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);

	  // colInt and rowInt are the letters to build to return
	  var colInt = colOrigin + column - 1;
	  var rowInt = rowOrigin + row;
	  var rollover = false;

	  if (colInt > Z) {
	    colInt = colInt - Z + A - 1;
	    rollover = true;
	  }

	  if (colInt === I || (colOrigin < I && colInt > I) || ((colInt > I || colOrigin < I) && rollover)) {
	    colInt++;
	  }

	  if (colInt === O || (colOrigin < O && colInt > O) || ((colInt > O || colOrigin < O) && rollover)) {
	    colInt++;

	    if (colInt === I) {
	      colInt++;
	    }
	  }

	  if (colInt > Z) {
	    colInt = colInt - Z + A - 1;
	  }

	  if (rowInt > V) {
	    rowInt = rowInt - V + A - 1;
	    rollover = true;
	  }
	  else {
	    rollover = false;
	  }

	  if (((rowInt === I) || ((rowOrigin < I) && (rowInt > I))) || (((rowInt > I) || (rowOrigin < I)) && rollover)) {
	    rowInt++;
	  }

	  if (((rowInt === O) || ((rowOrigin < O) && (rowInt > O))) || (((rowInt > O) || (rowOrigin < O)) && rollover)) {
	    rowInt++;

	    if (rowInt === I) {
	      rowInt++;
	    }
	  }

	  if (rowInt > V) {
	    rowInt = rowInt - V + A - 1;
	  }

	  var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
	  return twoLetter;
	}

	/**
	 * Decode the UTM parameters from a MGRS string.
	 *
	 * @private
	 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
	 * @return {object} An object literal with easting, northing, zoneLetter,
	 *     zoneNumber and accuracy (in meters) properties.
	 */
	function decode(mgrsString) {

	  if (mgrsString && mgrsString.length === 0) {
	    throw ("MGRSPoint coverting from nothing");
	  }

	  var length = mgrsString.length;

	  var hunK = null;
	  var sb = "";
	  var testChar;
	  var i = 0;

	  // get Zone number
	  while (!(/[A-Z]/).test(testChar = mgrsString.charAt(i))) {
	    if (i >= 2) {
	      throw ("MGRSPoint bad conversion from: " + mgrsString);
	    }
	    sb += testChar;
	    i++;
	  }

	  var zoneNumber = parseInt(sb, 10);

	  if (i === 0 || i + 3 > length) {
	    // A good MGRS string has to be 4-5 digits long,
	    // ##AAA/#AAA at least.
	    throw ("MGRSPoint bad conversion from: " + mgrsString);
	  }

	  var zoneLetter = mgrsString.charAt(i++);

	  // Should we check the zone letter here? Why not.
	  if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') {
	    throw ("MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString);
	  }

	  hunK = mgrsString.substring(i, i += 2);

	  var set = get100kSetForZone(zoneNumber);

	  var east100k = getEastingFromChar(hunK.charAt(0), set);
	  var north100k = getNorthingFromChar(hunK.charAt(1), set);

	  // We have a bug where the northing may be 2000000 too low.
	  // How
	  // do we know when to roll over?

	  while (north100k < getMinNorthing(zoneLetter)) {
	    north100k += 2000000;
	  }

	  // calculate the char index for easting/northing separator
	  var remainder = length - i;

	  if (remainder % 2 !== 0) {
	    throw ("MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString);
	  }

	  var sep = remainder / 2;

	  var sepEasting = 0.0;
	  var sepNorthing = 0.0;
	  var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
	  if (sep > 0) {
	    accuracyBonus = 100000.0 / Math.pow(10, sep);
	    sepEastingString = mgrsString.substring(i, i + sep);
	    sepEasting = parseFloat(sepEastingString) * accuracyBonus;
	    sepNorthingString = mgrsString.substring(i + sep);
	    sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
	  }

	  easting = sepEasting + east100k;
	  northing = sepNorthing + north100k;

	  return {
	    easting: easting,
	    northing: northing,
	    zoneLetter: zoneLetter,
	    zoneNumber: zoneNumber,
	    accuracy: accuracyBonus
	  };
	}

	/**
	 * Given the first letter from a two-letter MGRS 100k zone, and given the
	 * MGRS table set for the zone number, figure out the easting value that
	 * should be added to the other, secondary easting value.
	 *
	 * @private
	 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
	 * @param {number} set The MGRS table set for the zone number.
	 * @return {number} The easting value for the given letter and set.
	 */
	function getEastingFromChar(e, set) {
	  // colOrigin is the letter at the origin of the set for the
	  // column
	  var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
	  var eastingValue = 100000.0;
	  var rewindMarker = false;

	  while (curCol !== e.charCodeAt(0)) {
	    curCol++;
	    if (curCol === I) {
	      curCol++;
	    }
	    if (curCol === O) {
	      curCol++;
	    }
	    if (curCol > Z) {
	      if (rewindMarker) {
	        throw ("Bad character: " + e);
	      }
	      curCol = A;
	      rewindMarker = true;
	    }
	    eastingValue += 100000.0;
	  }

	  return eastingValue;
	}

	/**
	 * Given the second letter from a two-letter MGRS 100k zone, and given the
	 * MGRS table set for the zone number, figure out the northing value that
	 * should be added to the other, secondary northing value. You have to
	 * remember that Northings are determined from the equator, and the vertical
	 * cycle of letters mean a 2000000 additional northing meters. This happens
	 * approx. every 18 degrees of latitude. This method does *NOT* count any
	 * additional northings. You have to figure out how many 2000000 meters need
	 * to be added for the zone letter of the MGRS coordinate.
	 *
	 * @private
	 * @param {char} n Second letter of the MGRS 100k zone
	 * @param {number} set The MGRS table set number, which is dependent on the
	 *     UTM zone number.
	 * @return {number} The northing value for the given letter and set.
	 */
	function getNorthingFromChar(n, set) {

	  if (n > 'V') {
	    throw ("MGRSPoint given invalid Northing " + n);
	  }

	  // rowOrigin is the letter at the origin of the set for the
	  // column
	  var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
	  var northingValue = 0.0;
	  var rewindMarker = false;

	  while (curRow !== n.charCodeAt(0)) {
	    curRow++;
	    if (curRow === I) {
	      curRow++;
	    }
	    if (curRow === O) {
	      curRow++;
	    }
	    // fixing a bug making whole application hang in this loop
	    // when 'n' is a wrong character
	    if (curRow > V) {
	      if (rewindMarker) { // making sure that this loop ends
	        throw ("Bad character: " + n);
	      }
	      curRow = A;
	      rewindMarker = true;
	    }
	    northingValue += 100000.0;
	  }

	  return northingValue;
	}

	/**
	 * The function getMinNorthing returns the minimum northing value of a MGRS
	 * zone.
	 *
	 * Ported from Geotrans' c Lattitude_Band_Value structure table.
	 *
	 * @private
	 * @param {char} zoneLetter The MGRS zone to get the min northing for.
	 * @return {number}
	 */
	function getMinNorthing(zoneLetter) {
	  var northing;
	  switch (zoneLetter) {
	  case 'C':
	    northing = 1100000.0;
	    break;
	  case 'D':
	    northing = 2000000.0;
	    break;
	  case 'E':
	    northing = 2800000.0;
	    break;
	  case 'F':
	    northing = 3700000.0;
	    break;
	  case 'G':
	    northing = 4600000.0;
	    break;
	  case 'H':
	    northing = 5500000.0;
	    break;
	  case 'J':
	    northing = 6400000.0;
	    break;
	  case 'K':
	    northing = 7300000.0;
	    break;
	  case 'L':
	    northing = 8200000.0;
	    break;
	  case 'M':
	    northing = 9100000.0;
	    break;
	  case 'N':
	    northing = 0.0;
	    break;
	  case 'P':
	    northing = 800000.0;
	    break;
	  case 'Q':
	    northing = 1700000.0;
	    break;
	  case 'R':
	    northing = 2600000.0;
	    break;
	  case 'S':
	    northing = 3500000.0;
	    break;
	  case 'T':
	    northing = 4400000.0;
	    break;
	  case 'U':
	    northing = 5300000.0;
	    break;
	  case 'V':
	    northing = 6200000.0;
	    break;
	  case 'W':
	    northing = 7000000.0;
	    break;
	  case 'X':
	    northing = 7900000.0;
	    break;
	  default:
	    northing = -1.0;
	  }
	  if (northing >= 0.0) {
	    return northing;
	  }
	  else {
	    throw ("Invalid zone letter: " + zoneLetter);
	  }

	}

	function Point(x, y, z) {
	  if (!(this instanceof Point)) {
	    return new Point(x, y, z);
	  }
	  if (Array.isArray(x)) {
	    this.x = x[0];
	    this.y = x[1];
	    this.z = x[2] || 0.0;
	  } else if(typeof x === 'object') {
	    this.x = x.x;
	    this.y = x.y;
	    this.z = x.z || 0.0;
	  } else if (typeof x === 'string' && typeof y === 'undefined') {
	    var coords = x.split(',');
	    this.x = parseFloat(coords[0], 10);
	    this.y = parseFloat(coords[1], 10);
	    this.z = parseFloat(coords[2], 10) || 0.0;
	  } else {
	    this.x = x;
	    this.y = y;
	    this.z = z || 0.0;
	  }
	  console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
	}

	Point.fromMGRS = function(mgrsStr) {
	  return new Point(toPoint$1(mgrsStr));
	};
	Point.prototype.toMGRS = function(accuracy) {
	  return forward$1([this.x, this.y], accuracy);
	};

	var version = "2.4.4";

	var C00 = 1;
	var C02 = 0.25;
	var C04 = 0.046875;
	var C06 = 0.01953125;
	var C08 = 0.01068115234375;
	var C22 = 0.75;
	var C44 = 0.46875;
	var C46 = 0.01302083333333333333;
	var C48 = 0.00712076822916666666;
	var C66 = 0.36458333333333333333;
	var C68 = 0.00569661458333333333;
	var C88 = 0.3076171875;

	var pj_enfn = function(es) {
	  var en = [];
	  en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
	  en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
	  var t = es * es;
	  en[2] = t * (C44 - es * (C46 + es * C48));
	  t *= es;
	  en[3] = t * (C66 - es * C68);
	  en[4] = t * es * C88;
	  return en;
	};

	var pj_mlfn = function(phi, sphi, cphi, en) {
	  cphi *= sphi;
	  sphi *= sphi;
	  return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
	};

	var MAX_ITER = 20;

	var pj_inv_mlfn = function(arg, es, en) {
	  var k = 1 / (1 - es);
	  var phi = arg;
	  for (var i = MAX_ITER; i; --i) { /* rarely goes over 2 iterations */
	    var s = Math.sin(phi);
	    var t = 1 - es * s * s;
	    //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
	    //phi -= t * (t * Math.sqrt(t)) * k;
	    t = (pj_mlfn(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
	    phi -= t;
	    if (Math.abs(t) < EPSLN) {
	      return phi;
	    }
	  }
	  //..reportError("cass:pj_inv_mlfn: Convergence error");
	  return phi;
	};

	// Heavily based on this tmerc projection implementation
	// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js

	function init$2() {
	  this.x0 = this.x0 !== undefined ? this.x0 : 0;
	  this.y0 = this.y0 !== undefined ? this.y0 : 0;
	  this.long0 = this.long0 !== undefined ? this.long0 : 0;
	  this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

	  if (this.es) {
	    this.en = pj_enfn(this.es);
	    this.ml0 = pj_mlfn(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
	  }
	}

	/**
	    Transverse Mercator Forward  - long/lat to x/y
	    long/lat in radians
	  */
	function forward$2(p) {
	  var lon = p.x;
	  var lat = p.y;

	  var delta_lon = adjust_lon(lon - this.long0);
	  var con;
	  var x, y;
	  var sin_phi = Math.sin(lat);
	  var cos_phi = Math.cos(lat);

	  if (!this.es) {
	    var b = cos_phi * Math.sin(delta_lon);

	    if ((Math.abs(Math.abs(b) - 1)) < EPSLN) {
	      return (93);
	    }
	    else {
	      x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
	      y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
	      b = Math.abs(y);

	      if (b >= 1) {
	        if ((b - 1) > EPSLN) {
	          return (93);
	        }
	        else {
	          y = 0;
	        }
	      }
	      else {
	        y = Math.acos(y);
	      }

	      if (lat < 0) {
	        y = -y;
	      }

	      y = this.a * this.k0 * (y - this.lat0) + this.y0;
	    }
	  }
	  else {
	    var al = cos_phi * delta_lon;
	    var als = Math.pow(al, 2);
	    var c = this.ep2 * Math.pow(cos_phi, 2);
	    var cs = Math.pow(c, 2);
	    var tq = Math.abs(cos_phi) > EPSLN ? Math.tan(lat) : 0;
	    var t = Math.pow(tq, 2);
	    var ts = Math.pow(t, 2);
	    con = 1 - this.es * Math.pow(sin_phi, 2);
	    al = al / Math.sqrt(con);
	    var ml = pj_mlfn(lat, sin_phi, cos_phi, this.en);

	    x = this.a * (this.k0 * al * (1 +
	      als / 6 * (1 - t + c +
	      als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c +
	      als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) +
	      this.x0;

	    y = this.a * (this.k0 * (ml - this.ml0 +
	      sin_phi * delta_lon * al / 2 * (1 +
	      als / 12 * (5 - t + 9 * c + 4 * cs +
	      als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c +
	      als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) +
	      this.y0;
	  }

	  p.x = x;
	  p.y = y;

	  return p;
	}

	/**
	    Transverse Mercator Inverse  -  x/y to long/lat
	  */
	function inverse$2(p) {
	  var con, phi;
	  var lat, lon;
	  var x = (p.x - this.x0) * (1 / this.a);
	  var y = (p.y - this.y0) * (1 / this.a);

	  if (!this.es) {
	    var f = Math.exp(x / this.k0);
	    var g = 0.5 * (f - 1 / f);
	    var temp = this.lat0 + y / this.k0;
	    var h = Math.cos(temp);
	    con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
	    lat = Math.asin(con);

	    if (y < 0) {
	      lat = -lat;
	    }

	    if ((g === 0) && (h === 0)) {
	      lon = 0;
	    }
	    else {
	      lon = adjust_lon(Math.atan2(g, h) + this.long0);
	    }
	  }
	  else { // ellipsoidal form
	    con = this.ml0 + y / this.k0;
	    phi = pj_inv_mlfn(con, this.es, this.en);

	    if (Math.abs(phi) < HALF_PI) {
	      var sin_phi = Math.sin(phi);
	      var cos_phi = Math.cos(phi);
	      var tan_phi = Math.abs(cos_phi) > EPSLN ? Math.tan(phi) : 0;
	      var c = this.ep2 * Math.pow(cos_phi, 2);
	      var cs = Math.pow(c, 2);
	      var t = Math.pow(tan_phi, 2);
	      var ts = Math.pow(t, 2);
	      con = 1 - this.es * Math.pow(sin_phi, 2);
	      var d = x * Math.sqrt(con) / this.k0;
	      var ds = Math.pow(d, 2);
	      con = con * tan_phi;

	      lat = phi - (con * ds / (1 - this.es)) * 0.5 * (1 -
	        ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs -
	        ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c -
	        ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));

	      lon = adjust_lon(this.long0 + (d * (1 -
	        ds / 6 * (1 + 2 * t + c -
	        ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c -
	        ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi));
	    }
	    else {
	      lat = HALF_PI * sign(y);
	      lon = 0;
	    }
	  }

	  p.x = lon;
	  p.y = lat;

	  return p;
	}

	var names$3 = ["Transverse_Mercator", "Transverse Mercator", "tmerc"];
	var tmerc = {
	  init: init$2,
	  forward: forward$2,
	  inverse: inverse$2,
	  names: names$3
	};

	var sinh = function(x) {
	  var r = Math.exp(x);
	  r = (r - 1 / r) / 2;
	  return r;
	};

	var hypot = function(x, y) {
	  x = Math.abs(x);
	  y = Math.abs(y);
	  var a = Math.max(x, y);
	  var b = Math.min(x, y) / (a ? a : 1);

	  return a * Math.sqrt(1 + Math.pow(b, 2));
	};

	var log1py = function(x) {
	  var y = 1 + x;
	  var z = y - 1;

	  return z === 0 ? x : x * Math.log(y) / z;
	};

	var asinhy = function(x) {
	  var y = Math.abs(x);
	  y = log1py(y * (1 + y / (hypot(1, y) + 1)));

	  return x < 0 ? -y : y;
	};

	var gatg = function(pp, B) {
	  var cos_2B = 2 * Math.cos(2 * B);
	  var i = pp.length - 1;
	  var h1 = pp[i];
	  var h2 = 0;
	  var h;

	  while (--i >= 0) {
	    h = -h2 + cos_2B * h1 + pp[i];
	    h2 = h1;
	    h1 = h;
	  }

	  return (B + h * Math.sin(2 * B));
	};

	var clens = function(pp, arg_r) {
	  var r = 2 * Math.cos(arg_r);
	  var i = pp.length - 1;
	  var hr1 = pp[i];
	  var hr2 = 0;
	  var hr;

	  while (--i >= 0) {
	    hr = -hr2 + r * hr1 + pp[i];
	    hr2 = hr1;
	    hr1 = hr;
	  }

	  return Math.sin(arg_r) * hr;
	};

	var cosh = function(x) {
	  var r = Math.exp(x);
	  r = (r + 1 / r) / 2;
	  return r;
	};

	var clens_cmplx = function(pp, arg_r, arg_i) {
	  var sin_arg_r = Math.sin(arg_r);
	  var cos_arg_r = Math.cos(arg_r);
	  var sinh_arg_i = sinh(arg_i);
	  var cosh_arg_i = cosh(arg_i);
	  var r = 2 * cos_arg_r * cosh_arg_i;
	  var i = -2 * sin_arg_r * sinh_arg_i;
	  var j = pp.length - 1;
	  var hr = pp[j];
	  var hi1 = 0;
	  var hr1 = 0;
	  var hi = 0;
	  var hr2;
	  var hi2;

	  while (--j >= 0) {
	    hr2 = hr1;
	    hi2 = hi1;
	    hr1 = hr;
	    hi1 = hi;
	    hr = -hr2 + r * hr1 - i * hi1 + pp[j];
	    hi = -hi2 + i * hr1 + r * hi1;
	  }

	  r = sin_arg_r * cosh_arg_i;
	  i = cos_arg_r * sinh_arg_i;

	  return [r * hr - i * hi, r * hi + i * hr];
	};

	// Heavily based on this etmerc projection implementation
	// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js

	function init$3() {
	  if (this.es === undefined || this.es <= 0) {
	    throw new Error('incorrect elliptical usage');
	  }

	  this.x0 = this.x0 !== undefined ? this.x0 : 0;
	  this.y0 = this.y0 !== undefined ? this.y0 : 0;
	  this.long0 = this.long0 !== undefined ? this.long0 : 0;
	  this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

	  this.cgb = [];
	  this.cbg = [];
	  this.utg = [];
	  this.gtu = [];

	  var f = this.es / (1 + Math.sqrt(1 - this.es));
	  var n = f / (2 - f);
	  var np = n;

	  this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675 ))))));
	  this.cbg[0] = n * (-2 + n * ( 2 / 3 + n * ( 4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));

	  np = np * n;
	  this.cgb[1] = np * (7 / 3 + n * (-8 / 5 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
	  this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * ( -13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));

	  np = np * n;
	  this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
	  this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (8 / 5 + n * (-12686 / 2835))));

	  np = np * n;
	  this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
	  this.cbg[3] = np * (1237 / 630 + n * (-12 / 5 + n * ( -24832 / 14175)));

	  np = np * n;
	  this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
	  this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));

	  np = np * n;
	  this.cgb[5] = np * (601676 / 22275);
	  this.cbg[5] = np * (444337 / 155925);

	  np = Math.pow(n, 2);
	  this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));

	  this.utg[0] = n * (-0.5 + n * ( 2 / 3 + n * (-37 / 96 + n * ( 1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
	  this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));

	  this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
	  this.gtu[1] = np * (13 / 48 + n * (-3 / 5 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));

	  np = np * n;
	  this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720 ))));
	  this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));

	  np = np * n;
	  this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
	  this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));

	  np = np * n;
	  this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
	  this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));

	  np = np * n;
	  this.utg[5] = np * (-20648693 / 638668800);
	  this.gtu[5] = np * (212378941 / 319334400);

	  var Z = gatg(this.cbg, this.lat0);
	  this.Zb = -this.Qn * (Z + clens(this.gtu, 2 * Z));
	}

	function forward$3(p) {
	  var Ce = adjust_lon(p.x - this.long0);
	  var Cn = p.y;

	  Cn = gatg(this.cbg, Cn);
	  var sin_Cn = Math.sin(Cn);
	  var cos_Cn = Math.cos(Cn);
	  var sin_Ce = Math.sin(Ce);
	  var cos_Ce = Math.cos(Ce);

	  Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
	  Ce = Math.atan2(sin_Ce * cos_Cn, hypot(sin_Cn, cos_Cn * cos_Ce));
	  Ce = asinhy(Math.tan(Ce));

	  var tmp = clens_cmplx(this.gtu, 2 * Cn, 2 * Ce);

	  Cn = Cn + tmp[0];
	  Ce = Ce + tmp[1];

	  var x;
	  var y;

	  if (Math.abs(Ce) <= 2.623395162778) {
	    x = this.a * (this.Qn * Ce) + this.x0;
	    y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
	  }
	  else {
	    x = Infinity;
	    y = Infinity;
	  }

	  p.x = x;
	  p.y = y;

	  return p;
	}

	function inverse$3(p) {
	  var Ce = (p.x - this.x0) * (1 / this.a);
	  var Cn = (p.y - this.y0) * (1 / this.a);

	  Cn = (Cn - this.Zb) / this.Qn;
	  Ce = Ce / this.Qn;

	  var lon;
	  var lat;

	  if (Math.abs(Ce) <= 2.623395162778) {
	    var tmp = clens_cmplx(this.utg, 2 * Cn, 2 * Ce);

	    Cn = Cn + tmp[0];
	    Ce = Ce + tmp[1];
	    Ce = Math.atan(sinh(Ce));

	    var sin_Cn = Math.sin(Cn);
	    var cos_Cn = Math.cos(Cn);
	    var sin_Ce = Math.sin(Ce);
	    var cos_Ce = Math.cos(Ce);

	    Cn = Math.atan2(sin_Cn * cos_Ce, hypot(sin_Ce, cos_Ce * cos_Cn));
	    Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);

	    lon = adjust_lon(Ce + this.long0);
	    lat = gatg(this.cgb, Cn);
	  }
	  else {
	    lon = Infinity;
	    lat = Infinity;
	  }

	  p.x = lon;
	  p.y = lat;

	  return p;
	}

	var names$4 = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc"];
	var etmerc = {
	  init: init$3,
	  forward: forward$3,
	  inverse: inverse$3,
	  names: names$4
	};

	var adjust_zone = function(zone, lon) {
	  if (zone === undefined) {
	    zone = Math.floor((adjust_lon(lon) + Math.PI) * 30 / Math.PI) + 1;

	    if (zone < 0) {
	      return 0;
	    } else if (zone > 60) {
	      return 60;
	    }
	  }
	  return zone;
	};

	var dependsOn = 'etmerc';
	function init$4() {
	  var zone = adjust_zone(this.zone, this.long0);
	  if (zone === undefined) {
	    throw new Error('unknown utm zone');
	  }
	  this.lat0 = 0;
	  this.long0 =  ((6 * Math.abs(zone)) - 183) * D2R;
	  this.x0 = 500000;
	  this.y0 = this.utmSouth ? 10000000 : 0;
	  this.k0 = 0.9996;

	  etmerc.init.apply(this);
	  this.forward = etmerc.forward;
	  this.inverse = etmerc.inverse;
	}

	var names$5 = ["Universal Transverse Mercator System", "utm"];
	var utm = {
	  init: init$4,
	  names: names$5,
	  dependsOn: dependsOn
	};

	var srat = function(esinp, exp) {
	  return (Math.pow((1 - esinp) / (1 + esinp), exp));
	};

	var MAX_ITER$1 = 20;
	function init$6() {
	  var sphi = Math.sin(this.lat0);
	  var cphi = Math.cos(this.lat0);
	  cphi *= cphi;
	  this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
	  this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
	  this.phic0 = Math.asin(sphi / this.C);
	  this.ratexp = 0.5 * this.C * this.e;
	  this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * sphi, this.ratexp));
	}

	function forward$5(p) {
	  var lon = p.x;
	  var lat = p.y;

	  p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + FORTPI), this.C) * srat(this.e * Math.sin(lat), this.ratexp)) - HALF_PI;
	  p.x = this.C * lon;
	  return p;
	}

	function inverse$5(p) {
	  var DEL_TOL = 1e-14;
	  var lon = p.x / this.C;
	  var lat = p.y;
	  var num = Math.pow(Math.tan(0.5 * lat + FORTPI) / this.K, 1 / this.C);
	  for (var i = MAX_ITER$1; i > 0; --i) {
	    lat = 2 * Math.atan(num * srat(this.e * Math.sin(p.y), - 0.5 * this.e)) - HALF_PI;
	    if (Math.abs(lat - p.y) < DEL_TOL) {
	      break;
	    }
	    p.y = lat;
	  }
	  /* convergence failed */
	  if (!i) {
	    return null;
	  }
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$7 = ["gauss"];
	var gauss = {
	  init: init$6,
	  forward: forward$5,
	  inverse: inverse$5,
	  names: names$7
	};

	function init$5() {
	  gauss.init.apply(this);
	  if (!this.rc) {
	    return;
	  }
	  this.sinc0 = Math.sin(this.phic0);
	  this.cosc0 = Math.cos(this.phic0);
	  this.R2 = 2 * this.rc;
	  if (!this.title) {
	    this.title = "Oblique Stereographic Alternative";
	  }
	}

	function forward$4(p) {
	  var sinc, cosc, cosl, k;
	  p.x = adjust_lon(p.x - this.long0);
	  gauss.forward.apply(this, [p]);
	  sinc = Math.sin(p.y);
	  cosc = Math.cos(p.y);
	  cosl = Math.cos(p.x);
	  k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
	  p.x = k * cosc * Math.sin(p.x);
	  p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
	  p.x = this.a * p.x + this.x0;
	  p.y = this.a * p.y + this.y0;
	  return p;
	}

	function inverse$4(p) {
	  var sinc, cosc, lon, lat, rho;
	  p.x = (p.x - this.x0) / this.a;
	  p.y = (p.y - this.y0) / this.a;

	  p.x /= this.k0;
	  p.y /= this.k0;
	  if ((rho = Math.sqrt(p.x * p.x + p.y * p.y))) {
	    var c = 2 * Math.atan2(rho, this.R2);
	    sinc = Math.sin(c);
	    cosc = Math.cos(c);
	    lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
	    lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
	  }
	  else {
	    lat = this.phic0;
	    lon = 0;
	  }

	  p.x = lon;
	  p.y = lat;
	  gauss.inverse.apply(this, [p]);
	  p.x = adjust_lon(p.x + this.long0);
	  return p;
	}

	var names$6 = ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea","Oblique Stereographic Alternative"];
	var sterea = {
	  init: init$5,
	  forward: forward$4,
	  inverse: inverse$4,
	  names: names$6
	};

	function ssfn_(phit, sinphi, eccen) {
	  sinphi *= eccen;
	  return (Math.tan(0.5 * (HALF_PI + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen));
	}

	function init$7() {
	  this.coslat0 = Math.cos(this.lat0);
	  this.sinlat0 = Math.sin(this.lat0);
	  if (this.sphere) {
	    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
	      this.k0 = 0.5 * (1 + sign(this.lat0) * Math.sin(this.lat_ts));
	    }
	  }
	  else {
	    if (Math.abs(this.coslat0) <= EPSLN) {
	      if (this.lat0 > 0) {
	        //North pole
	        //trace('stere:north pole');
	        this.con = 1;
	      }
	      else {
	        //South pole
	        //trace('stere:south pole');
	        this.con = -1;
	      }
	    }
	    this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
	    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
	      this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
	    }
	    this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0);
	    this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI;
	    this.cosX0 = Math.cos(this.X0);
	    this.sinX0 = Math.sin(this.X0);
	  }
	}

	// Stereographic forward equations--mapping lat,long to x,y
	function forward$6(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var sinlat = Math.sin(lat);
	  var coslat = Math.cos(lat);
	  var A, X, sinX, cosX, ts, rh;
	  var dlon = adjust_lon(lon - this.long0);

	  if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= EPSLN && Math.abs(lat + this.lat0) <= EPSLN) {
	    //case of the origine point
	    //trace('stere:this is the origin point');
	    p.x = NaN;
	    p.y = NaN;
	    return p;
	  }
	  if (this.sphere) {
	    //trace('stere:sphere case');
	    A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
	    p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
	    p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
	    return p;
	  }
	  else {
	    X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - HALF_PI;
	    cosX = Math.cos(X);
	    sinX = Math.sin(X);
	    if (Math.abs(this.coslat0) <= EPSLN) {
	      ts = tsfnz(this.e, lat * this.con, this.con * sinlat);
	      rh = 2 * this.a * this.k0 * ts / this.cons;
	      p.x = this.x0 + rh * Math.sin(lon - this.long0);
	      p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
	      //trace(p.toString());
	      return p;
	    }
	    else if (Math.abs(this.sinlat0) < EPSLN) {
	      //Eq
	      //trace('stere:equateur');
	      A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
	      p.y = A * sinX;
	    }
	    else {
	      //other case
	      //trace('stere:normal case');
	      A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
	      p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
	    }
	    p.x = A * cosX * Math.sin(dlon) + this.x0;
	  }
	  //trace(p.toString());
	  return p;
	}

	//* Stereographic inverse equations--mapping x,y to lat/long
	function inverse$6(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var lon, lat, ts, ce, Chi;
	  var rh = Math.sqrt(p.x * p.x + p.y * p.y);
	  if (this.sphere) {
	    var c = 2 * Math.atan(rh / (0.5 * this.a * this.k0));
	    lon = this.long0;
	    lat = this.lat0;
	    if (rh <= EPSLN) {
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	    lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
	    if (Math.abs(this.coslat0) < EPSLN) {
	      if (this.lat0 > 0) {
	        lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
	      }
	      else {
	        lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
	      }
	    }
	    else {
	      lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
	    }
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  else {
	    if (Math.abs(this.coslat0) <= EPSLN) {
	      if (rh <= EPSLN) {
	        lat = this.lat0;
	        lon = this.long0;
	        p.x = lon;
	        p.y = lat;
	        //trace(p.toString());
	        return p;
	      }
	      p.x *= this.con;
	      p.y *= this.con;
	      ts = rh * this.cons / (2 * this.a * this.k0);
	      lat = this.con * phi2z(this.e, ts);
	      lon = this.con * adjust_lon(this.con * this.long0 + Math.atan2(p.x, - 1 * p.y));
	    }
	    else {
	      ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
	      lon = this.long0;
	      if (rh <= EPSLN) {
	        Chi = this.X0;
	      }
	      else {
	        Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
	        lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
	      }
	      lat = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + Chi)));
	    }
	  }
	  p.x = lon;
	  p.y = lat;

	  //trace(p.toString());
	  return p;

	}

	var names$8 = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"];
	var stere = {
	  init: init$7,
	  forward: forward$6,
	  inverse: inverse$6,
	  names: names$8,
	  ssfn_: ssfn_
	};

	/*
	  references:
	    Formules et constantes pour le Calcul pour la
	    projection cylindrique conforme à axe oblique et pour la transformation entre
	    des systèmes de référence.
	    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
	  */

	function init$8() {
	  var phy0 = this.lat0;
	  this.lambda0 = this.long0;
	  var sinPhy0 = Math.sin(phy0);
	  var semiMajorAxis = this.a;
	  var invF = this.rf;
	  var flattening = 1 / invF;
	  var e2 = 2 * flattening - Math.pow(flattening, 2);
	  var e = this.e = Math.sqrt(e2);
	  this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
	  this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
	  this.b0 = Math.asin(sinPhy0 / this.alpha);
	  var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
	  var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
	  var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
	  this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
	}

	function forward$7(p) {
	  var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
	  var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
	  var S = -this.alpha * (Sa1 + Sa2) + this.K;

	  // spheric latitude
	  var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);

	  // spheric longitude
	  var I = this.alpha * (p.x - this.lambda0);

	  // psoeudo equatorial rotation
	  var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));

	  var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));

	  p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
	  p.x = this.R * rotI + this.x0;
	  return p;
	}

	function inverse$7(p) {
	  var Y = p.x - this.x0;
	  var X = p.y - this.y0;

	  var rotI = Y / this.R;
	  var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);

	  var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
	  var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));

	  var lambda = this.lambda0 + I / this.alpha;

	  var S = 0;
	  var phy = b;
	  var prevPhy = -1000;
	  var iteration = 0;
	  while (Math.abs(phy - prevPhy) > 0.0000001) {
	    if (++iteration > 20) {
	      //...reportError("omercFwdInfinity");
	      return;
	    }
	    //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
	    S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
	    prevPhy = phy;
	    phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
	  }

	  p.x = lambda;
	  p.y = phy;
	  return p;
	}

	var names$9 = ["somerc"];
	var somerc = {
	  init: init$8,
	  forward: forward$7,
	  inverse: inverse$7,
	  names: names$9
	};

	/* Initialize the Oblique Mercator  projection
	    ------------------------------------------*/
	function init$9() {
	  this.no_off = this.no_off || false;
	  this.no_rot = this.no_rot || false;

	  if (isNaN(this.k0)) {
	    this.k0 = 1;
	  }
	  var sinlat = Math.sin(this.lat0);
	  var coslat = Math.cos(this.lat0);
	  var con = this.e * sinlat;

	  this.bl = Math.sqrt(1 + this.es / (1 - this.es) * Math.pow(coslat, 4));
	  this.al = this.a * this.bl * this.k0 * Math.sqrt(1 - this.es) / (1 - con * con);
	  var t0 = tsfnz(this.e, this.lat0, sinlat);
	  var dl = this.bl / coslat * Math.sqrt((1 - this.es) / (1 - con * con));
	  if (dl * dl < 1) {
	    dl = 1;
	  }
	  var fl;
	  var gl;
	  if (!isNaN(this.longc)) {
	    //Central point and azimuth method

	    if (this.lat0 >= 0) {
	      fl = dl + Math.sqrt(dl * dl - 1);
	    }
	    else {
	      fl = dl - Math.sqrt(dl * dl - 1);
	    }
	    this.el = fl * Math.pow(t0, this.bl);
	    gl = 0.5 * (fl - 1 / fl);
	    this.gamma0 = Math.asin(Math.sin(this.alpha) / dl);
	    this.long0 = this.longc - Math.asin(gl * Math.tan(this.gamma0)) / this.bl;

	  }
	  else {
	    //2 points method
	    var t1 = tsfnz(this.e, this.lat1, Math.sin(this.lat1));
	    var t2 = tsfnz(this.e, this.lat2, Math.sin(this.lat2));
	    if (this.lat0 >= 0) {
	      this.el = (dl + Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
	    }
	    else {
	      this.el = (dl - Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
	    }
	    var hl = Math.pow(t1, this.bl);
	    var ll = Math.pow(t2, this.bl);
	    fl = this.el / hl;
	    gl = 0.5 * (fl - 1 / fl);
	    var jl = (this.el * this.el - ll * hl) / (this.el * this.el + ll * hl);
	    var pl = (ll - hl) / (ll + hl);
	    var dlon12 = adjust_lon(this.long1 - this.long2);
	    this.long0 = 0.5 * (this.long1 + this.long2) - Math.atan(jl * Math.tan(0.5 * this.bl * (dlon12)) / pl) / this.bl;
	    this.long0 = adjust_lon(this.long0);
	    var dlon10 = adjust_lon(this.long1 - this.long0);
	    this.gamma0 = Math.atan(Math.sin(this.bl * (dlon10)) / gl);
	    this.alpha = Math.asin(dl * Math.sin(this.gamma0));
	  }

	  if (this.no_off) {
	    this.uc = 0;
	  }
	  else {
	    if (this.lat0 >= 0) {
	      this.uc = this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
	    }
	    else {
	      this.uc = -1 * this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
	    }
	  }

	}

	/* Oblique Mercator forward equations--mapping lat,long to x,y
	    ----------------------------------------------------------*/
	function forward$8(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var dlon = adjust_lon(lon - this.long0);
	  var us, vs;
	  var con;
	  if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
	    if (lat > 0) {
	      con = -1;
	    }
	    else {
	      con = 1;
	    }
	    vs = this.al / this.bl * Math.log(Math.tan(FORTPI + con * this.gamma0 * 0.5));
	    us = -1 * con * HALF_PI * this.al / this.bl;
	  }
	  else {
	    var t = tsfnz(this.e, lat, Math.sin(lat));
	    var ql = this.el / Math.pow(t, this.bl);
	    var sl = 0.5 * (ql - 1 / ql);
	    var tl = 0.5 * (ql + 1 / ql);
	    var vl = Math.sin(this.bl * (dlon));
	    var ul = (sl * Math.sin(this.gamma0) - vl * Math.cos(this.gamma0)) / tl;
	    if (Math.abs(Math.abs(ul) - 1) <= EPSLN) {
	      vs = Number.POSITIVE_INFINITY;
	    }
	    else {
	      vs = 0.5 * this.al * Math.log((1 - ul) / (1 + ul)) / this.bl;
	    }
	    if (Math.abs(Math.cos(this.bl * (dlon))) <= EPSLN) {
	      us = this.al * this.bl * (dlon);
	    }
	    else {
	      us = this.al * Math.atan2(sl * Math.cos(this.gamma0) + vl * Math.sin(this.gamma0), Math.cos(this.bl * dlon)) / this.bl;
	    }
	  }

	  if (this.no_rot) {
	    p.x = this.x0 + us;
	    p.y = this.y0 + vs;
	  }
	  else {

	    us -= this.uc;
	    p.x = this.x0 + vs * Math.cos(this.alpha) + us * Math.sin(this.alpha);
	    p.y = this.y0 + us * Math.cos(this.alpha) - vs * Math.sin(this.alpha);
	  }
	  return p;
	}

	function inverse$8(p) {
	  var us, vs;
	  if (this.no_rot) {
	    vs = p.y - this.y0;
	    us = p.x - this.x0;
	  }
	  else {
	    vs = (p.x - this.x0) * Math.cos(this.alpha) - (p.y - this.y0) * Math.sin(this.alpha);
	    us = (p.y - this.y0) * Math.cos(this.alpha) + (p.x - this.x0) * Math.sin(this.alpha);
	    us += this.uc;
	  }
	  var qp = Math.exp(-1 * this.bl * vs / this.al);
	  var sp = 0.5 * (qp - 1 / qp);
	  var tp = 0.5 * (qp + 1 / qp);
	  var vp = Math.sin(this.bl * us / this.al);
	  var up = (vp * Math.cos(this.gamma0) + sp * Math.sin(this.gamma0)) / tp;
	  var ts = Math.pow(this.el / Math.sqrt((1 + up) / (1 - up)), 1 / this.bl);
	  if (Math.abs(up - 1) < EPSLN) {
	    p.x = this.long0;
	    p.y = HALF_PI;
	  }
	  else if (Math.abs(up + 1) < EPSLN) {
	    p.x = this.long0;
	    p.y = -1 * HALF_PI;
	  }
	  else {
	    p.y = phi2z(this.e, ts);
	    p.x = adjust_lon(this.long0 - Math.atan2(sp * Math.cos(this.gamma0) - vp * Math.sin(this.gamma0), Math.cos(this.bl * us / this.al)) / this.bl);
	  }
	  return p;
	}

	var names$10 = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "omerc"];
	var omerc = {
	  init: init$9,
	  forward: forward$8,
	  inverse: inverse$8,
	  names: names$10
	};

	function init$10() {

	  // array of:  r_maj,r_min,lat1,lat2,c_lon,c_lat,false_east,false_north
	  //double c_lat;                   /* center latitude                      */
	  //double c_lon;                   /* center longitude                     */
	  //double lat1;                    /* first standard parallel              */
	  //double lat2;                    /* second standard parallel             */
	  //double r_maj;                   /* major axis                           */
	  //double r_min;                   /* minor axis                           */
	  //double false_east;              /* x offset in meters                   */
	  //double false_north;             /* y offset in meters                   */

	  if (!this.lat2) {
	    this.lat2 = this.lat1;
	  } //if lat2 is not defined
	  if (!this.k0) {
	    this.k0 = 1;
	  }
	  this.x0 = this.x0 || 0;
	  this.y0 = this.y0 || 0;
	  // Standard Parallels cannot be equal and on opposite sides of the equator
	  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	    return;
	  }

	  var temp = this.b / this.a;
	  this.e = Math.sqrt(1 - temp * temp);

	  var sin1 = Math.sin(this.lat1);
	  var cos1 = Math.cos(this.lat1);
	  var ms1 = msfnz(this.e, sin1, cos1);
	  var ts1 = tsfnz(this.e, this.lat1, sin1);

	  var sin2 = Math.sin(this.lat2);
	  var cos2 = Math.cos(this.lat2);
	  var ms2 = msfnz(this.e, sin2, cos2);
	  var ts2 = tsfnz(this.e, this.lat2, sin2);

	  var ts0 = tsfnz(this.e, this.lat0, Math.sin(this.lat0));

	  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
	    this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
	  }
	  else {
	    this.ns = sin1;
	  }
	  if (isNaN(this.ns)) {
	    this.ns = sin1;
	  }
	  this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
	  this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
	  if (!this.title) {
	    this.title = "Lambert Conformal Conic";
	  }
	}

	// Lambert Conformal conic forward equations--mapping lat,long to x,y
	// -----------------------------------------------------------------
	function forward$9(p) {

	  var lon = p.x;
	  var lat = p.y;

	  // singular cases :
	  if (Math.abs(2 * Math.abs(lat) - Math.PI) <= EPSLN) {
	    lat = sign(lat) * (HALF_PI - 2 * EPSLN);
	  }

	  var con = Math.abs(Math.abs(lat) - HALF_PI);
	  var ts, rh1;
	  if (con > EPSLN) {
	    ts = tsfnz(this.e, lat, Math.sin(lat));
	    rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
	  }
	  else {
	    con = lat * this.ns;
	    if (con <= 0) {
	      return null;
	    }
	    rh1 = 0;
	  }
	  var theta = this.ns * adjust_lon(lon - this.long0);
	  p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
	  p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;

	  return p;
	}

	// Lambert Conformal Conic inverse equations--mapping x,y to lat/long
	// -----------------------------------------------------------------
	function inverse$9(p) {

	  var rh1, con, ts;
	  var lat, lon;
	  var x = (p.x - this.x0) / this.k0;
	  var y = (this.rh - (p.y - this.y0) / this.k0);
	  if (this.ns > 0) {
	    rh1 = Math.sqrt(x * x + y * y);
	    con = 1;
	  }
	  else {
	    rh1 = -Math.sqrt(x * x + y * y);
	    con = -1;
	  }
	  var theta = 0;
	  if (rh1 !== 0) {
	    theta = Math.atan2((con * x), (con * y));
	  }
	  if ((rh1 !== 0) || (this.ns > 0)) {
	    con = 1 / this.ns;
	    ts = Math.pow((rh1 / (this.a * this.f0)), con);
	    lat = phi2z(this.e, ts);
	    if (lat === -9999) {
	      return null;
	    }
	  }
	  else {
	    lat = -HALF_PI;
	  }
	  lon = adjust_lon(theta / this.ns + this.long0);

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$11 = ["Lambert Tangential Conformal Conic Projection", "Lambert_Conformal_Conic", "Lambert_Conformal_Conic_2SP", "lcc"];
	var lcc = {
	  init: init$10,
	  forward: forward$9,
	  inverse: inverse$9,
	  names: names$11
	};

	function init$11() {
	  this.a = 6377397.155;
	  this.es = 0.006674372230614;
	  this.e = Math.sqrt(this.es);
	  if (!this.lat0) {
	    this.lat0 = 0.863937979737193;
	  }
	  if (!this.long0) {
	    this.long0 = 0.7417649320975901 - 0.308341501185665;
	  }
	  /* if scale not set default to 0.9999 */
	  if (!this.k0) {
	    this.k0 = 0.9999;
	  }
	  this.s45 = 0.785398163397448; /* 45 */
	  this.s90 = 2 * this.s45;
	  this.fi0 = this.lat0;
	  this.e2 = this.es;
	  this.e = Math.sqrt(this.e2);
	  this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2));
	  this.uq = 1.04216856380474;
	  this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
	  this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
	  this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
	  this.k1 = this.k0;
	  this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
	  this.s0 = 1.37008346281555;
	  this.n = Math.sin(this.s0);
	  this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
	  this.ad = this.s90 - this.uq;
	}

	/* ellipsoid */
	/* calculate xy from lat/lon */
	/* Constants, identical to inverse transform function */
	function forward$10(p) {
	  var gfi, u, deltav, s, d, eps, ro;
	  var lon = p.x;
	  var lat = p.y;
	  var delta_lon = adjust_lon(lon - this.long0);
	  /* Transformation */
	  gfi = Math.pow(((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat))), (this.alfa * this.e / 2));
	  u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
	  deltav = -delta_lon * this.alfa;
	  s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
	  d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
	  eps = this.n * d;
	  ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
	  p.y = ro * Math.cos(eps) / 1;
	  p.x = ro * Math.sin(eps) / 1;

	  if (!this.czech) {
	    p.y *= -1;
	    p.x *= -1;
	  }
	  return (p);
	}

	/* calculate lat/lon from xy */
	function inverse$10(p) {
	  var u, deltav, s, d, eps, ro, fi1;
	  var ok;

	  /* Transformation */
	  /* revert y, x*/
	  var tmp = p.x;
	  p.x = p.y;
	  p.y = tmp;
	  if (!this.czech) {
	    p.y *= -1;
	    p.x *= -1;
	  }
	  ro = Math.sqrt(p.x * p.x + p.y * p.y);
	  eps = Math.atan2(p.y, p.x);
	  d = eps / Math.sin(this.s0);
	  s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
	  u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
	  deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
	  p.x = this.long0 - deltav / this.alfa;
	  fi1 = u;
	  ok = 0;
	  var iter = 0;
	  do {
	    p.y = 2 * (Math.atan(Math.pow(this.k, - 1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
	    if (Math.abs(fi1 - p.y) < 0.0000000001) {
	      ok = 1;
	    }
	    fi1 = p.y;
	    iter += 1;
	  } while (ok === 0 && iter < 15);
	  if (iter >= 15) {
	    return null;
	  }

	  return (p);
	}

	var names$12 = ["Krovak", "krovak"];
	var krovak = {
	  init: init$11,
	  forward: forward$10,
	  inverse: inverse$10,
	  names: names$12
	};

	var mlfn = function(e0, e1, e2, e3, phi) {
	  return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
	};

	var e0fn = function(x) {
	  return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
	};

	var e1fn = function(x) {
	  return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
	};

	var e2fn = function(x) {
	  return (0.05859375 * x * x * (1 + 0.75 * x));
	};

	var e3fn = function(x) {
	  return (x * x * x * (35 / 3072));
	};

	var gN = function(a, e, sinphi) {
	  var temp = e * sinphi;
	  return a / Math.sqrt(1 - temp * temp);
	};

	var adjust_lat = function(x) {
	  return (Math.abs(x) < HALF_PI) ? x : (x - (sign(x) * Math.PI));
	};

	var imlfn = function(ml, e0, e1, e2, e3) {
	  var phi;
	  var dphi;

	  phi = ml / e0;
	  for (var i = 0; i < 15; i++) {
	    dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
	    phi += dphi;
	    if (Math.abs(dphi) <= 0.0000000001) {
	      return phi;
	    }
	  }

	  //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
	  return NaN;
	};

	function init$12() {
	  if (!this.sphere) {
	    this.e0 = e0fn(this.es);
	    this.e1 = e1fn(this.es);
	    this.e2 = e2fn(this.es);
	    this.e3 = e3fn(this.es);
	    this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
	  }
	}

	/* Cassini forward equations--mapping lat,long to x,y
	  -----------------------------------------------------------------------*/
	function forward$11(p) {

	  /* Forward equations
	      -----------------*/
	  var x, y;
	  var lam = p.x;
	  var phi = p.y;
	  lam = adjust_lon(lam - this.long0);

	  if (this.sphere) {
	    x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
	    y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
	  }
	  else {
	    //ellipsoid
	    var sinphi = Math.sin(phi);
	    var cosphi = Math.cos(phi);
	    var nl = gN(this.a, this.e, sinphi);
	    var tl = Math.tan(phi) * Math.tan(phi);
	    var al = lam * Math.cos(phi);
	    var asq = al * al;
	    var cl = this.es * cosphi * cosphi / (1 - this.es);
	    var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);

	    x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
	    y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);


	  }

	  p.x = x + this.x0;
	  p.y = y + this.y0;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$11(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var x = p.x / this.a;
	  var y = p.y / this.a;
	  var phi, lam;

	  if (this.sphere) {
	    var dd = y + this.lat0;
	    phi = Math.asin(Math.sin(dd) * Math.cos(x));
	    lam = Math.atan2(Math.tan(x), Math.cos(dd));
	  }
	  else {
	    /* ellipsoid */
	    var ml1 = this.ml0 / this.a + y;
	    var phi1 = imlfn(ml1, this.e0, this.e1, this.e2, this.e3);
	    if (Math.abs(Math.abs(phi1) - HALF_PI) <= EPSLN) {
	      p.x = this.long0;
	      p.y = HALF_PI;
	      if (y < 0) {
	        p.y *= -1;
	      }
	      return p;
	    }
	    var nl1 = gN(this.a, this.e, Math.sin(phi1));

	    var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
	    var tl1 = Math.pow(Math.tan(phi1), 2);
	    var dl = x * this.a / nl1;
	    var dsq = dl * dl;
	    phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
	    lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);

	  }

	  p.x = adjust_lon(lam + this.long0);
	  p.y = adjust_lat(phi);
	  return p;

	}

	var names$13 = ["Cassini", "Cassini_Soldner", "cass"];
	var cass = {
	  init: init$12,
	  forward: forward$11,
	  inverse: inverse$11,
	  names: names$13
	};

	var qsfnz = function(eccent, sinphi) {
	  var con;
	  if (eccent > 1.0e-7) {
	    con = eccent * sinphi;
	    return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
	  }
	  else {
	    return (2 * sinphi);
	  }
	};

	/*
	  reference
	    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
	    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
	  */

	var S_POLE = 1;

	var N_POLE = 2;
	var EQUIT = 3;
	var OBLIQ = 4;

	/* Initialize the Lambert Azimuthal Equal Area projection
	  ------------------------------------------------------*/
	function init$13() {
	  var t = Math.abs(this.lat0);
	  if (Math.abs(t - HALF_PI) < EPSLN) {
	    this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
	  }
	  else if (Math.abs(t) < EPSLN) {
	    this.mode = this.EQUIT;
	  }
	  else {
	    this.mode = this.OBLIQ;
	  }
	  if (this.es > 0) {
	    var sinphi;

	    this.qp = qsfnz(this.e, 1);
	    this.mmf = 0.5 / (1 - this.es);
	    this.apa = authset(this.es);
	    switch (this.mode) {
	    case this.N_POLE:
	      this.dd = 1;
	      break;
	    case this.S_POLE:
	      this.dd = 1;
	      break;
	    case this.EQUIT:
	      this.rq = Math.sqrt(0.5 * this.qp);
	      this.dd = 1 / this.rq;
	      this.xmf = 1;
	      this.ymf = 0.5 * this.qp;
	      break;
	    case this.OBLIQ:
	      this.rq = Math.sqrt(0.5 * this.qp);
	      sinphi = Math.sin(this.lat0);
	      this.sinb1 = qsfnz(this.e, sinphi) / this.qp;
	      this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
	      this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
	      this.ymf = (this.xmf = this.rq) / this.dd;
	      this.xmf *= this.dd;
	      break;
	    }
	  }
	  else {
	    if (this.mode === this.OBLIQ) {
	      this.sinph0 = Math.sin(this.lat0);
	      this.cosph0 = Math.cos(this.lat0);
	    }
	  }
	}

	/* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
	  -----------------------------------------------------------------------*/
	function forward$12(p) {

	  /* Forward equations
	      -----------------*/
	  var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
	  var lam = p.x;
	  var phi = p.y;

	  lam = adjust_lon(lam - this.long0);
	  if (this.sphere) {
	    sinphi = Math.sin(phi);
	    cosphi = Math.cos(phi);
	    coslam = Math.cos(lam);
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      y = (this.mode === this.EQUIT) ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
	      if (y <= EPSLN) {
	        return null;
	      }
	      y = Math.sqrt(2 / y);
	      x = y * cosphi * Math.sin(lam);
	      y *= (this.mode === this.EQUIT) ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
	    }
	    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
	      if (this.mode === this.N_POLE) {
	        coslam = -coslam;
	      }
	      if (Math.abs(phi + this.phi0) < EPSLN) {
	        return null;
	      }
	      y = FORTPI - phi * 0.5;
	      y = 2 * ((this.mode === this.S_POLE) ? Math.cos(y) : Math.sin(y));
	      x = y * Math.sin(lam);
	      y *= coslam;
	    }
	  }
	  else {
	    sinb = 0;
	    cosb = 0;
	    b = 0;
	    coslam = Math.cos(lam);
	    sinlam = Math.sin(lam);
	    sinphi = Math.sin(phi);
	    q = qsfnz(this.e, sinphi);
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      sinb = q / this.qp;
	      cosb = Math.sqrt(1 - sinb * sinb);
	    }
	    switch (this.mode) {
	    case this.OBLIQ:
	      b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
	      break;
	    case this.EQUIT:
	      b = 1 + cosb * coslam;
	      break;
	    case this.N_POLE:
	      b = HALF_PI + phi;
	      q = this.qp - q;
	      break;
	    case this.S_POLE:
	      b = phi - HALF_PI;
	      q = this.qp + q;
	      break;
	    }
	    if (Math.abs(b) < EPSLN) {
	      return null;
	    }
	    switch (this.mode) {
	    case this.OBLIQ:
	    case this.EQUIT:
	      b = Math.sqrt(2 / b);
	      if (this.mode === this.OBLIQ) {
	        y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
	      }
	      else {
	        y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
	      }
	      x = this.xmf * b * cosb * sinlam;
	      break;
	    case this.N_POLE:
	    case this.S_POLE:
	      if (q >= 0) {
	        x = (b = Math.sqrt(q)) * sinlam;
	        y = coslam * ((this.mode === this.S_POLE) ? b : -b);
	      }
	      else {
	        x = y = 0;
	      }
	      break;
	    }
	  }

	  p.x = this.a * x + this.x0;
	  p.y = this.a * y + this.y0;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$12(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var x = p.x / this.a;
	  var y = p.y / this.a;
	  var lam, phi, cCe, sCe, q, rho, ab;
	  if (this.sphere) {
	    var cosz = 0,
	      rh, sinz = 0;

	    rh = Math.sqrt(x * x + y * y);
	    phi = rh * 0.5;
	    if (phi > 1) {
	      return null;
	    }
	    phi = 2 * Math.asin(phi);
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      sinz = Math.sin(phi);
	      cosz = Math.cos(phi);
	    }
	    switch (this.mode) {
	    case this.EQUIT:
	      phi = (Math.abs(rh) <= EPSLN) ? 0 : Math.asin(y * sinz / rh);
	      x *= sinz;
	      y = cosz * rh;
	      break;
	    case this.OBLIQ:
	      phi = (Math.abs(rh) <= EPSLN) ? this.phi0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
	      x *= sinz * this.cosph0;
	      y = (cosz - Math.sin(phi) * this.sinph0) * rh;
	      break;
	    case this.N_POLE:
	      y = -y;
	      phi = HALF_PI - phi;
	      break;
	    case this.S_POLE:
	      phi -= HALF_PI;
	      break;
	    }
	    lam = (y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ)) ? 0 : Math.atan2(x, y);
	  }
	  else {
	    ab = 0;
	    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
	      x /= this.dd;
	      y *= this.dd;
	      rho = Math.sqrt(x * x + y * y);
	      if (rho < EPSLN) {
	        p.x = 0;
	        p.y = this.phi0;
	        return p;
	      }
	      sCe = 2 * Math.asin(0.5 * rho / this.rq);
	      cCe = Math.cos(sCe);
	      x *= (sCe = Math.sin(sCe));
	      if (this.mode === this.OBLIQ) {
	        ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
	        q = this.qp * ab;
	        y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
	      }
	      else {
	        ab = y * sCe / rho;
	        q = this.qp * ab;
	        y = rho * cCe;
	      }
	    }
	    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
	      if (this.mode === this.N_POLE) {
	        y = -y;
	      }
	      q = (x * x + y * y);
	      if (!q) {
	        p.x = 0;
	        p.y = this.phi0;
	        return p;
	      }
	      ab = 1 - q / this.qp;
	      if (this.mode === this.S_POLE) {
	        ab = -ab;
	      }
	    }
	    lam = Math.atan2(x, y);
	    phi = authlat(Math.asin(ab), this.apa);
	  }

	  p.x = adjust_lon(this.long0 + lam);
	  p.y = phi;
	  return p;
	}

	/* determine latitude from authalic latitude */
	var P00 = 0.33333333333333333333;

	var P01 = 0.17222222222222222222;
	var P02 = 0.10257936507936507936;
	var P10 = 0.06388888888888888888;
	var P11 = 0.06640211640211640211;
	var P20 = 0.01641501294219154443;

	function authset(es) {
	  var t;
	  var APA = [];
	  APA[0] = es * P00;
	  t = es * es;
	  APA[0] += t * P01;
	  APA[1] = t * P10;
	  t *= es;
	  APA[0] += t * P02;
	  APA[1] += t * P11;
	  APA[2] = t * P20;
	  return APA;
	}

	function authlat(beta, APA) {
	  var t = beta + beta;
	  return (beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t));
	}

	var names$14 = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
	var laea = {
	  init: init$13,
	  forward: forward$12,
	  inverse: inverse$12,
	  names: names$14,
	  S_POLE: S_POLE,
	  N_POLE: N_POLE,
	  EQUIT: EQUIT,
	  OBLIQ: OBLIQ
	};

	var asinz = function(x) {
	  if (Math.abs(x) > 1) {
	    x = (x > 1) ? 1 : -1;
	  }
	  return Math.asin(x);
	};

	function init$14() {

	  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	    return;
	  }
	  this.temp = this.b / this.a;
	  this.es = 1 - Math.pow(this.temp, 2);
	  this.e3 = Math.sqrt(this.es);

	  this.sin_po = Math.sin(this.lat1);
	  this.cos_po = Math.cos(this.lat1);
	  this.t1 = this.sin_po;
	  this.con = this.sin_po;
	  this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po);
	  this.qs1 = qsfnz(this.e3, this.sin_po, this.cos_po);

	  this.sin_po = Math.sin(this.lat2);
	  this.cos_po = Math.cos(this.lat2);
	  this.t2 = this.sin_po;
	  this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po);
	  this.qs2 = qsfnz(this.e3, this.sin_po, this.cos_po);

	  this.sin_po = Math.sin(this.lat0);
	  this.cos_po = Math.cos(this.lat0);
	  this.t3 = this.sin_po;
	  this.qs0 = qsfnz(this.e3, this.sin_po, this.cos_po);

	  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
	    this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
	  }
	  else {
	    this.ns0 = this.con;
	  }
	  this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
	  this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
	}

	/* Albers Conical Equal Area forward equations--mapping lat,long to x,y
	  -------------------------------------------------------------------*/
	function forward$13(p) {

	  var lon = p.x;
	  var lat = p.y;

	  this.sin_phi = Math.sin(lat);
	  this.cos_phi = Math.cos(lat);

	  var qs = qsfnz(this.e3, this.sin_phi, this.cos_phi);
	  var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
	  var theta = this.ns0 * adjust_lon(lon - this.long0);
	  var x = rh1 * Math.sin(theta) + this.x0;
	  var y = this.rh - rh1 * Math.cos(theta) + this.y0;

	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$13(p) {
	  var rh1, qs, con, theta, lon, lat;

	  p.x -= this.x0;
	  p.y = this.rh - p.y + this.y0;
	  if (this.ns0 >= 0) {
	    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
	    con = 1;
	  }
	  else {
	    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
	    con = -1;
	  }
	  theta = 0;
	  if (rh1 !== 0) {
	    theta = Math.atan2(con * p.x, con * p.y);
	  }
	  con = rh1 * this.ns0 / this.a;
	  if (this.sphere) {
	    lat = Math.asin((this.c - con * con) / (2 * this.ns0));
	  }
	  else {
	    qs = (this.c - con * con) / this.ns0;
	    lat = this.phi1z(this.e3, qs);
	  }

	  lon = adjust_lon(theta / this.ns0 + this.long0);
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	/* Function to compute phi1, the latitude for the inverse of the
	   Albers Conical Equal-Area projection.
	-------------------------------------------*/
	function phi1z(eccent, qs) {
	  var sinphi, cosphi, con, com, dphi;
	  var phi = asinz(0.5 * qs);
	  if (eccent < EPSLN) {
	    return phi;
	  }

	  var eccnts = eccent * eccent;
	  for (var i = 1; i <= 25; i++) {
	    sinphi = Math.sin(phi);
	    cosphi = Math.cos(phi);
	    con = eccent * sinphi;
	    com = 1 - con * con;
	    dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
	    phi = phi + dphi;
	    if (Math.abs(dphi) <= 1e-7) {
	      return phi;
	    }
	  }
	  return null;
	}

	var names$15 = ["Albers_Conic_Equal_Area", "Albers", "aea"];
	var aea = {
	  init: init$14,
	  forward: forward$13,
	  inverse: inverse$13,
	  names: names$15,
	  phi1z: phi1z
	};

	/*
	  reference:
	    Wolfram Mathworld "Gnomonic Projection"
	    http://mathworld.wolfram.com/GnomonicProjection.html
	    Accessed: 12th November 2009
	  */
	function init$15() {

	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  this.sin_p14 = Math.sin(this.lat0);
	  this.cos_p14 = Math.cos(this.lat0);
	  // Approximation for projecting points to the horizon (infinity)
	  this.infinity_dist = 1000 * this.a;
	  this.rc = 1;
	}

	/* Gnomonic forward equations--mapping lat,long to x,y
	    ---------------------------------------------------*/
	function forward$14(p) {
	  var sinphi, cosphi; /* sin and cos value        */
	  var dlon; /* delta longitude value      */
	  var coslon; /* cos of longitude        */
	  var ksp; /* scale factor          */
	  var g;
	  var x, y;
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	      -----------------*/
	  dlon = adjust_lon(lon - this.long0);

	  sinphi = Math.sin(lat);
	  cosphi = Math.cos(lat);

	  coslon = Math.cos(dlon);
	  g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
	  ksp = 1;
	  if ((g > 0) || (Math.abs(g) <= EPSLN)) {
	    x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
	    y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
	  }
	  else {

	    // Point is in the opposing hemisphere and is unprojectable
	    // We still need to return a reasonable point, so we project
	    // to infinity, on a bearing
	    // equivalent to the northern hemisphere equivalent
	    // This is a reasonable approximation for short shapes and lines that
	    // straddle the horizon.

	    x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
	    y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);

	  }
	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$14(p) {
	  var rh; /* Rho */
	  var sinc, cosc;
	  var c;
	  var lon, lat;

	  /* Inverse equations
	      -----------------*/
	  p.x = (p.x - this.x0) / this.a;
	  p.y = (p.y - this.y0) / this.a;

	  p.x /= this.k0;
	  p.y /= this.k0;

	  if ((rh = Math.sqrt(p.x * p.x + p.y * p.y))) {
	    c = Math.atan2(rh, this.rc);
	    sinc = Math.sin(c);
	    cosc = Math.cos(c);

	    lat = asinz(cosc * this.sin_p14 + (p.y * sinc * this.cos_p14) / rh);
	    lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
	    lon = adjust_lon(this.long0 + lon);
	  }
	  else {
	    lat = this.phic0;
	    lon = 0;
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$16 = ["gnom"];
	var gnom = {
	  init: init$15,
	  forward: forward$14,
	  inverse: inverse$14,
	  names: names$16
	};

	var iqsfnz = function(eccent, q) {
	  var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
	  if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
	    if (q < 0) {
	      return (-1 * HALF_PI);
	    }
	    else {
	      return HALF_PI;
	    }
	  }
	  //var phi = 0.5* q/(1-eccent*eccent);
	  var phi = Math.asin(0.5 * q);
	  var dphi;
	  var sin_phi;
	  var cos_phi;
	  var con;
	  for (var i = 0; i < 30; i++) {
	    sin_phi = Math.sin(phi);
	    cos_phi = Math.cos(phi);
	    con = eccent * sin_phi;
	    dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
	    phi += dphi;
	    if (Math.abs(dphi) <= 0.0000000001) {
	      return phi;
	    }
	  }

	  //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
	  return NaN;
	};

	/*
	  reference:
	    "Cartographic Projection Procedures for the UNIX Environment-
	    A User's Manual" by Gerald I. Evenden,
	    USGS Open File Report 90-284and Release 4 Interim Reports (2003)
	*/
	function init$16() {
	  //no-op
	  if (!this.sphere) {
	    this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
	  }
	}

	/* Cylindrical Equal Area forward equations--mapping lat,long to x,y
	    ------------------------------------------------------------*/
	function forward$15(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var x, y;
	  /* Forward equations
	      -----------------*/
	  var dlon = adjust_lon(lon - this.long0);
	  if (this.sphere) {
	    x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
	    y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
	  }
	  else {
	    var qs = qsfnz(this.e, Math.sin(lat));
	    x = this.x0 + this.a * this.k0 * dlon;
	    y = this.y0 + this.a * qs * 0.5 / this.k0;
	  }

	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
	    ------------------------------------------------------------*/
	function inverse$15(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var lon, lat;

	  if (this.sphere) {
	    lon = adjust_lon(this.long0 + (p.x / this.a) / Math.cos(this.lat_ts));
	    lat = Math.asin((p.y / this.a) * Math.cos(this.lat_ts));
	  }
	  else {
	    lat = iqsfnz(this.e, 2 * p.y * this.k0 / this.a);
	    lon = adjust_lon(this.long0 + p.x / (this.a * this.k0));
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$17 = ["cea"];
	var cea = {
	  init: init$16,
	  forward: forward$15,
	  inverse: inverse$15,
	  names: names$17
	};

	function init$17() {

	  this.x0 = this.x0 || 0;
	  this.y0 = this.y0 || 0;
	  this.lat0 = this.lat0 || 0;
	  this.long0 = this.long0 || 0;
	  this.lat_ts = this.lat_ts || 0;
	  this.title = this.title || "Equidistant Cylindrical (Plate Carre)";

	  this.rc = Math.cos(this.lat_ts);
	}

	// forward equations--mapping lat,long to x,y
	// -----------------------------------------------------------------
	function forward$16(p) {

	  var lon = p.x;
	  var lat = p.y;

	  var dlon = adjust_lon(lon - this.long0);
	  var dlat = adjust_lat(lat - this.lat0);
	  p.x = this.x0 + (this.a * dlon * this.rc);
	  p.y = this.y0 + (this.a * dlat);
	  return p;
	}

	// inverse equations--mapping x,y to lat/long
	// -----------------------------------------------------------------
	function inverse$16(p) {

	  var x = p.x;
	  var y = p.y;

	  p.x = adjust_lon(this.long0 + ((x - this.x0) / (this.a * this.rc)));
	  p.y = adjust_lat(this.lat0 + ((y - this.y0) / (this.a)));
	  return p;
	}

	var names$18 = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
	var eqc = {
	  init: init$17,
	  forward: forward$16,
	  inverse: inverse$16,
	  names: names$18
	};

	var MAX_ITER$2 = 20;

	function init$18() {
	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  this.temp = this.b / this.a;
	  this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
	  this.e = Math.sqrt(this.es);
	  this.e0 = e0fn(this.es);
	  this.e1 = e1fn(this.es);
	  this.e2 = e2fn(this.es);
	  this.e3 = e3fn(this.es);
	  this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
	}

	/* Polyconic forward equations--mapping lat,long to x,y
	    ---------------------------------------------------*/
	function forward$17(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var x, y, el;
	  var dlon = adjust_lon(lon - this.long0);
	  el = dlon * Math.sin(lat);
	  if (this.sphere) {
	    if (Math.abs(lat) <= EPSLN) {
	      x = this.a * dlon;
	      y = -1 * this.a * this.lat0;
	    }
	    else {
	      x = this.a * Math.sin(el) / Math.tan(lat);
	      y = this.a * (adjust_lat(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
	    }
	  }
	  else {
	    if (Math.abs(lat) <= EPSLN) {
	      x = this.a * dlon;
	      y = -1 * this.ml0;
	    }
	    else {
	      var nl = gN(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
	      x = nl * Math.sin(el);
	      y = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
	    }

	  }
	  p.x = x + this.x0;
	  p.y = y + this.y0;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$17(p) {
	  var lon, lat, x, y, i;
	  var al, bl;
	  var phi, dphi;
	  x = p.x - this.x0;
	  y = p.y - this.y0;

	  if (this.sphere) {
	    if (Math.abs(y + this.a * this.lat0) <= EPSLN) {
	      lon = adjust_lon(x / this.a + this.long0);
	      lat = 0;
	    }
	    else {
	      al = this.lat0 + y / this.a;
	      bl = x * x / this.a / this.a + al * al;
	      phi = al;
	      var tanphi;
	      for (i = MAX_ITER$2; i; --i) {
	        tanphi = Math.tan(phi);
	        dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
	        phi += dphi;
	        if (Math.abs(dphi) <= EPSLN) {
	          lat = phi;
	          break;
	        }
	      }
	      lon = adjust_lon(this.long0 + (Math.asin(x * Math.tan(phi) / this.a)) / Math.sin(lat));
	    }
	  }
	  else {
	    if (Math.abs(y + this.ml0) <= EPSLN) {
	      lat = 0;
	      lon = adjust_lon(this.long0 + x / this.a);
	    }
	    else {

	      al = (this.ml0 + y) / this.a;
	      bl = x * x / this.a / this.a + al * al;
	      phi = al;
	      var cl, mln, mlnp, ma;
	      var con;
	      for (i = MAX_ITER$2; i; --i) {
	        con = this.e * Math.sin(phi);
	        cl = Math.sqrt(1 - con * con) * Math.tan(phi);
	        mln = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
	        mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
	        ma = mln / this.a;
	        dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
	        phi -= dphi;
	        if (Math.abs(dphi) <= EPSLN) {
	          lat = phi;
	          break;
	        }
	      }

	      //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
	      cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
	      lon = adjust_lon(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
	    }
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$19 = ["Polyconic", "poly"];
	var poly = {
	  init: init$18,
	  forward: forward$17,
	  inverse: inverse$17,
	  names: names$19
	};

	/*
	  reference
	    Department of Land and Survey Technical Circular 1973/32
	      http://www.linz.govt.nz/docs/miscellaneous/nz-map-definition.pdf
	    OSG Technical Report 4.1
	      http://www.linz.govt.nz/docs/miscellaneous/nzmg.pdf
	  */

	/**
	 * iterations: Number of iterations to refine inverse transform.
	 *     0 -> km accuracy
	 *     1 -> m accuracy -- suitable for most mapping applications
	 *     2 -> mm accuracy
	 */


	function init$19() {
	  this.A = [];
	  this.A[1] = 0.6399175073;
	  this.A[2] = -0.1358797613;
	  this.A[3] = 0.063294409;
	  this.A[4] = -0.02526853;
	  this.A[5] = 0.0117879;
	  this.A[6] = -0.0055161;
	  this.A[7] = 0.0026906;
	  this.A[8] = -0.001333;
	  this.A[9] = 0.00067;
	  this.A[10] = -0.00034;

	  this.B_re = [];
	  this.B_im = [];
	  this.B_re[1] = 0.7557853228;
	  this.B_im[1] = 0;
	  this.B_re[2] = 0.249204646;
	  this.B_im[2] = 0.003371507;
	  this.B_re[3] = -0.001541739;
	  this.B_im[3] = 0.041058560;
	  this.B_re[4] = -0.10162907;
	  this.B_im[4] = 0.01727609;
	  this.B_re[5] = -0.26623489;
	  this.B_im[5] = -0.36249218;
	  this.B_re[6] = -0.6870983;
	  this.B_im[6] = -1.1651967;

	  this.C_re = [];
	  this.C_im = [];
	  this.C_re[1] = 1.3231270439;
	  this.C_im[1] = 0;
	  this.C_re[2] = -0.577245789;
	  this.C_im[2] = -0.007809598;
	  this.C_re[3] = 0.508307513;
	  this.C_im[3] = -0.112208952;
	  this.C_re[4] = -0.15094762;
	  this.C_im[4] = 0.18200602;
	  this.C_re[5] = 1.01418179;
	  this.C_im[5] = 1.64497696;
	  this.C_re[6] = 1.9660549;
	  this.C_im[6] = 2.5127645;

	  this.D = [];
	  this.D[1] = 1.5627014243;
	  this.D[2] = 0.5185406398;
	  this.D[3] = -0.03333098;
	  this.D[4] = -0.1052906;
	  this.D[5] = -0.0368594;
	  this.D[6] = 0.007317;
	  this.D[7] = 0.01220;
	  this.D[8] = 0.00394;
	  this.D[9] = -0.0013;
	}

	/**
	    New Zealand Map Grid Forward  - long/lat to x/y
	    long/lat in radians
	  */
	function forward$18(p) {
	  var n;
	  var lon = p.x;
	  var lat = p.y;

	  var delta_lat = lat - this.lat0;
	  var delta_lon = lon - this.long0;

	  // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
	  // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
	  var d_phi = delta_lat / SEC_TO_RAD * 1E-5;
	  var d_lambda = delta_lon;
	  var d_phi_n = 1; // d_phi^0

	  var d_psi = 0;
	  for (n = 1; n <= 10; n++) {
	    d_phi_n = d_phi_n * d_phi;
	    d_psi = d_psi + this.A[n] * d_phi_n;
	  }

	  // 2. Calculate theta
	  var th_re = d_psi;
	  var th_im = d_lambda;

	  // 3. Calculate z
	  var th_n_re = 1;
	  var th_n_im = 0; // theta^0
	  var th_n_re1;
	  var th_n_im1;

	  var z_re = 0;
	  var z_im = 0;
	  for (n = 1; n <= 6; n++) {
	    th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	    th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	    th_n_re = th_n_re1;
	    th_n_im = th_n_im1;
	    z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
	    z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
	  }

	  // 4. Calculate easting and northing
	  p.x = (z_im * this.a) + this.x0;
	  p.y = (z_re * this.a) + this.y0;

	  return p;
	}

	/**
	    New Zealand Map Grid Inverse  -  x/y to long/lat
	  */
	function inverse$18(p) {
	  var n;
	  var x = p.x;
	  var y = p.y;

	  var delta_x = x - this.x0;
	  var delta_y = y - this.y0;

	  // 1. Calculate z
	  var z_re = delta_y / this.a;
	  var z_im = delta_x / this.a;

	  // 2a. Calculate theta - first approximation gives km accuracy
	  var z_n_re = 1;
	  var z_n_im = 0; // z^0
	  var z_n_re1;
	  var z_n_im1;

	  var th_re = 0;
	  var th_im = 0;
	  for (n = 1; n <= 6; n++) {
	    z_n_re1 = z_n_re * z_re - z_n_im * z_im;
	    z_n_im1 = z_n_im * z_re + z_n_re * z_im;
	    z_n_re = z_n_re1;
	    z_n_im = z_n_im1;
	    th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
	    th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
	  }

	  // 2b. Iterate to refine the accuracy of the calculation
	  //        0 iterations gives km accuracy
	  //        1 iteration gives m accuracy -- good enough for most mapping applications
	  //        2 iterations bives mm accuracy
	  for (var i = 0; i < this.iterations; i++) {
	    var th_n_re = th_re;
	    var th_n_im = th_im;
	    var th_n_re1;
	    var th_n_im1;

	    var num_re = z_re;
	    var num_im = z_im;
	    for (n = 2; n <= 6; n++) {
	      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	      th_n_re = th_n_re1;
	      th_n_im = th_n_im1;
	      num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
	      num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
	    }

	    th_n_re = 1;
	    th_n_im = 0;
	    var den_re = this.B_re[1];
	    var den_im = this.B_im[1];
	    for (n = 2; n <= 6; n++) {
	      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
	      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
	      th_n_re = th_n_re1;
	      th_n_im = th_n_im1;
	      den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
	      den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
	    }

	    // Complex division
	    var den2 = den_re * den_re + den_im * den_im;
	    th_re = (num_re * den_re + num_im * den_im) / den2;
	    th_im = (num_im * den_re - num_re * den_im) / den2;
	  }

	  // 3. Calculate d_phi              ...                                    // and d_lambda
	  var d_psi = th_re;
	  var d_lambda = th_im;
	  var d_psi_n = 1; // d_psi^0

	  var d_phi = 0;
	  for (n = 1; n <= 9; n++) {
	    d_psi_n = d_psi_n * d_psi;
	    d_phi = d_phi + this.D[n] * d_psi_n;
	  }

	  // 4. Calculate latitude and longitude
	  // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
	  var lat = this.lat0 + (d_phi * SEC_TO_RAD * 1E5);
	  var lon = this.long0 + d_lambda;

	  p.x = lon;
	  p.y = lat;

	  return p;
	}

	var names$20 = ["New_Zealand_Map_Grid", "nzmg"];
	var nzmg = {
	  init: init$19,
	  forward: forward$18,
	  inverse: inverse$18,
	  names: names$20
	};

	/*
	  reference
	    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
	    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
	  */


	/* Initialize the Miller Cylindrical projection
	  -------------------------------------------*/
	function init$20() {
	  //no-op
	}

	/* Miller Cylindrical forward equations--mapping lat,long to x,y
	    ------------------------------------------------------------*/
	function forward$19(p) {
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	      -----------------*/
	  var dlon = adjust_lon(lon - this.long0);
	  var x = this.x0 + this.a * dlon;
	  var y = this.y0 + this.a * Math.log(Math.tan((Math.PI / 4) + (lat / 2.5))) * 1.25;

	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Miller Cylindrical inverse equations--mapping x,y to lat/long
	    ------------------------------------------------------------*/
	function inverse$19(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;

	  var lon = adjust_lon(this.long0 + p.x / this.a);
	  var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$21 = ["Miller_Cylindrical", "mill"];
	var mill = {
	  init: init$20,
	  forward: forward$19,
	  inverse: inverse$19,
	  names: names$21
	};

	var MAX_ITER$3 = 20;
	function init$21() {
	  /* Place parameters in static storage for common use
	    -------------------------------------------------*/


	  if (!this.sphere) {
	    this.en = pj_enfn(this.es);
	  }
	  else {
	    this.n = 1;
	    this.m = 0;
	    this.es = 0;
	    this.C_y = Math.sqrt((this.m + 1) / this.n);
	    this.C_x = this.C_y / (this.m + 1);
	  }

	}

	/* Sinusoidal forward equations--mapping lat,long to x,y
	  -----------------------------------------------------*/
	function forward$20(p) {
	  var x, y;
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	    -----------------*/
	  lon = adjust_lon(lon - this.long0);

	  if (this.sphere) {
	    if (!this.m) {
	      lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
	    }
	    else {
	      var k = this.n * Math.sin(lat);
	      for (var i = MAX_ITER$3; i; --i) {
	        var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
	        lat -= V;
	        if (Math.abs(V) < EPSLN) {
	          break;
	        }
	      }
	    }
	    x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
	    y = this.a * this.C_y * lat;

	  }
	  else {

	    var s = Math.sin(lat);
	    var c = Math.cos(lat);
	    y = this.a * pj_mlfn(lat, s, c, this.en);
	    x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
	  }

	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$20(p) {
	  var lat, temp, lon, s;

	  p.x -= this.x0;
	  lon = p.x / this.a;
	  p.y -= this.y0;
	  lat = p.y / this.a;

	  if (this.sphere) {
	    lat /= this.C_y;
	    lon = lon / (this.C_x * (this.m + Math.cos(lat)));
	    if (this.m) {
	      lat = asinz((this.m * lat + Math.sin(lat)) / this.n);
	    }
	    else if (this.n !== 1) {
	      lat = asinz(Math.sin(lat) / this.n);
	    }
	    lon = adjust_lon(lon + this.long0);
	    lat = adjust_lat(lat);
	  }
	  else {
	    lat = pj_inv_mlfn(p.y / this.a, this.es, this.en);
	    s = Math.abs(lat);
	    if (s < HALF_PI) {
	      s = Math.sin(lat);
	      temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
	      //temp = this.long0 + p.x / (this.a * Math.cos(lat));
	      lon = adjust_lon(temp);
	    }
	    else if ((s - EPSLN) < HALF_PI) {
	      lon = this.long0;
	    }
	  }
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$22 = ["Sinusoidal", "sinu"];
	var sinu = {
	  init: init$21,
	  forward: forward$20,
	  inverse: inverse$20,
	  names: names$22
	};

	function init$22() {}
	/* Mollweide forward equations--mapping lat,long to x,y
	    ----------------------------------------------------*/
	function forward$21(p) {

	  /* Forward equations
	      -----------------*/
	  var lon = p.x;
	  var lat = p.y;

	  var delta_lon = adjust_lon(lon - this.long0);
	  var theta = lat;
	  var con = Math.PI * Math.sin(lat);

	  /* Iterate using the Newton-Raphson method to find theta
	      -----------------------------------------------------*/
	  while (true) {
	    var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
	    theta += delta_theta;
	    if (Math.abs(delta_theta) < EPSLN) {
	      break;
	    }
	  }
	  theta /= 2;

	  /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
	       this is done here because of precision problems with "cos(theta)"
	       --------------------------------------------------------------------------*/
	  if (Math.PI / 2 - Math.abs(lat) < EPSLN) {
	    delta_lon = 0;
	  }
	  var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
	  var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;

	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$21(p) {
	  var theta;
	  var arg;

	  /* Inverse equations
	      -----------------*/
	  p.x -= this.x0;
	  p.y -= this.y0;
	  arg = p.y / (1.4142135623731 * this.a);

	  /* Because of division by zero problems, 'arg' can not be 1.  Therefore
	       a number very close to one is used instead.
	       -------------------------------------------------------------------*/
	  if (Math.abs(arg) > 0.999999999999) {
	    arg = 0.999999999999;
	  }
	  theta = Math.asin(arg);
	  var lon = adjust_lon(this.long0 + (p.x / (0.900316316158 * this.a * Math.cos(theta))));
	  if (lon < (-Math.PI)) {
	    lon = -Math.PI;
	  }
	  if (lon > Math.PI) {
	    lon = Math.PI;
	  }
	  arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
	  if (Math.abs(arg) > 1) {
	    arg = 1;
	  }
	  var lat = Math.asin(arg);

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$23 = ["Mollweide", "moll"];
	var moll = {
	  init: init$22,
	  forward: forward$21,
	  inverse: inverse$21,
	  names: names$23
	};

	function init$23() {

	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  // Standard Parallels cannot be equal and on opposite sides of the equator
	  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
	    return;
	  }
	  this.lat2 = this.lat2 || this.lat1;
	  this.temp = this.b / this.a;
	  this.es = 1 - Math.pow(this.temp, 2);
	  this.e = Math.sqrt(this.es);
	  this.e0 = e0fn(this.es);
	  this.e1 = e1fn(this.es);
	  this.e2 = e2fn(this.es);
	  this.e3 = e3fn(this.es);

	  this.sinphi = Math.sin(this.lat1);
	  this.cosphi = Math.cos(this.lat1);

	  this.ms1 = msfnz(this.e, this.sinphi, this.cosphi);
	  this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);

	  if (Math.abs(this.lat1 - this.lat2) < EPSLN) {
	    this.ns = this.sinphi;
	  }
	  else {
	    this.sinphi = Math.sin(this.lat2);
	    this.cosphi = Math.cos(this.lat2);
	    this.ms2 = msfnz(this.e, this.sinphi, this.cosphi);
	    this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
	    this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
	  }
	  this.g = this.ml1 + this.ms1 / this.ns;
	  this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
	  this.rh = this.a * (this.g - this.ml0);
	}

	/* Equidistant Conic forward equations--mapping lat,long to x,y
	  -----------------------------------------------------------*/
	function forward$22(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var rh1;

	  /* Forward equations
	      -----------------*/
	  if (this.sphere) {
	    rh1 = this.a * (this.g - lat);
	  }
	  else {
	    var ml = mlfn(this.e0, this.e1, this.e2, this.e3, lat);
	    rh1 = this.a * (this.g - ml);
	  }
	  var theta = this.ns * adjust_lon(lon - this.long0);
	  var x = this.x0 + rh1 * Math.sin(theta);
	  var y = this.y0 + this.rh - rh1 * Math.cos(theta);
	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Inverse equations
	  -----------------*/
	function inverse$22(p) {
	  p.x -= this.x0;
	  p.y = this.rh - p.y + this.y0;
	  var con, rh1, lat, lon;
	  if (this.ns >= 0) {
	    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
	    con = 1;
	  }
	  else {
	    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
	    con = -1;
	  }
	  var theta = 0;
	  if (rh1 !== 0) {
	    theta = Math.atan2(con * p.x, con * p.y);
	  }

	  if (this.sphere) {
	    lon = adjust_lon(this.long0 + theta / this.ns);
	    lat = adjust_lat(this.g - rh1 / this.a);
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  else {
	    var ml = this.g - rh1 / this.a;
	    lat = imlfn(ml, this.e0, this.e1, this.e2, this.e3);
	    lon = adjust_lon(this.long0 + theta / this.ns);
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }

	}

	var names$24 = ["Equidistant_Conic", "eqdc"];
	var eqdc = {
	  init: init$23,
	  forward: forward$22,
	  inverse: inverse$22,
	  names: names$24
	};

	/* Initialize the Van Der Grinten projection
	  ----------------------------------------*/
	function init$24() {
	  //this.R = 6370997; //Radius of earth
	  this.R = this.a;
	}

	function forward$23(p) {

	  var lon = p.x;
	  var lat = p.y;

	  /* Forward equations
	    -----------------*/
	  var dlon = adjust_lon(lon - this.long0);
	  var x, y;

	  if (Math.abs(lat) <= EPSLN) {
	    x = this.x0 + this.R * dlon;
	    y = this.y0;
	  }
	  var theta = asinz(2 * Math.abs(lat / Math.PI));
	  if ((Math.abs(dlon) <= EPSLN) || (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN)) {
	    x = this.x0;
	    if (lat >= 0) {
	      y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
	    }
	    else {
	      y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
	    }
	    //  return(OK);
	  }
	  var al = 0.5 * Math.abs((Math.PI / dlon) - (dlon / Math.PI));
	  var asq = al * al;
	  var sinth = Math.sin(theta);
	  var costh = Math.cos(theta);

	  var g = costh / (sinth + costh - 1);
	  var gsq = g * g;
	  var m = g * (2 / sinth - 1);
	  var msq = m * m;
	  var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
	  if (dlon < 0) {
	    con = -con;
	  }
	  x = this.x0 + con;
	  //con = Math.abs(con / (Math.PI * this.R));
	  var q = asq + g;
	  con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
	  if (lat >= 0) {
	    //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
	    y = this.y0 + con;
	  }
	  else {
	    //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
	    y = this.y0 - con;
	  }
	  p.x = x;
	  p.y = y;
	  return p;
	}

	/* Van Der Grinten inverse equations--mapping x,y to lat/long
	  ---------------------------------------------------------*/
	function inverse$23(p) {
	  var lon, lat;
	  var xx, yy, xys, c1, c2, c3;
	  var a1;
	  var m1;
	  var con;
	  var th1;
	  var d;

	  /* inverse equations
	    -----------------*/
	  p.x -= this.x0;
	  p.y -= this.y0;
	  con = Math.PI * this.R;
	  xx = p.x / con;
	  yy = p.y / con;
	  xys = xx * xx + yy * yy;
	  c1 = -Math.abs(yy) * (1 + xys);
	  c2 = c1 - 2 * yy * yy + xx * xx;
	  c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
	  d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
	  a1 = (c1 - c2 * c2 / 3 / c3) / c3;
	  m1 = 2 * Math.sqrt(-a1 / 3);
	  con = ((3 * d) / a1) / m1;
	  if (Math.abs(con) > 1) {
	    if (con >= 0) {
	      con = 1;
	    }
	    else {
	      con = -1;
	    }
	  }
	  th1 = Math.acos(con) / 3;
	  if (p.y >= 0) {
	    lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
	  }
	  else {
	    lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
	  }

	  if (Math.abs(xx) < EPSLN) {
	    lon = this.long0;
	  }
	  else {
	    lon = adjust_lon(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
	  }

	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$25 = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
	var vandg = {
	  init: init$24,
	  forward: forward$23,
	  inverse: inverse$23,
	  names: names$25
	};

	function init$25() {
	  this.sin_p12 = Math.sin(this.lat0);
	  this.cos_p12 = Math.cos(this.lat0);
	}

	function forward$24(p) {
	  var lon = p.x;
	  var lat = p.y;
	  var sinphi = Math.sin(p.y);
	  var cosphi = Math.cos(p.y);
	  var dlon = adjust_lon(lon - this.long0);
	  var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
	  if (this.sphere) {
	    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	      //North Pole case
	      p.x = this.x0 + this.a * (HALF_PI - lat) * Math.sin(dlon);
	      p.y = this.y0 - this.a * (HALF_PI - lat) * Math.cos(dlon);
	      return p;
	    }
	    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	      //South Pole case
	      p.x = this.x0 + this.a * (HALF_PI + lat) * Math.sin(dlon);
	      p.y = this.y0 + this.a * (HALF_PI + lat) * Math.cos(dlon);
	      return p;
	    }
	    else {
	      //default case
	      cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
	      c = Math.acos(cos_c);
	      kp = c / Math.sin(c);
	      p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
	      p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
	      return p;
	    }
	  }
	  else {
	    e0 = e0fn(this.es);
	    e1 = e1fn(this.es);
	    e2 = e2fn(this.es);
	    e3 = e3fn(this.es);
	    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	      //North Pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      Ml = this.a * mlfn(e0, e1, e2, e3, lat);
	      p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
	      p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
	      return p;
	    }
	    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	      //South Pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      Ml = this.a * mlfn(e0, e1, e2, e3, lat);
	      p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
	      p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
	      return p;
	    }
	    else {
	      //Default case
	      tanphi = sinphi / cosphi;
	      Nl1 = gN(this.a, this.e, this.sin_p12);
	      Nl = gN(this.a, this.e, sinphi);
	      psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
	      Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
	      if (Az === 0) {
	        s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
	      }
	      else if (Math.abs(Math.abs(Az) - Math.PI) <= EPSLN) {
	        s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
	      }
	      else {
	        s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
	      }
	      G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
	      H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
	      GH = G * H;
	      Hs = H * H;
	      s2 = s * s;
	      s3 = s2 * s;
	      s4 = s3 * s;
	      s5 = s4 * s;
	      c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
	      p.x = this.x0 + c * Math.sin(Az);
	      p.y = this.y0 + c * Math.cos(Az);
	      return p;
	    }
	  }


	}

	function inverse$24(p) {
	  p.x -= this.x0;
	  p.y -= this.y0;
	  var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F;
	  if (this.sphere) {
	    rh = Math.sqrt(p.x * p.x + p.y * p.y);
	    if (rh > (2 * HALF_PI * this.a)) {
	      return;
	    }
	    z = rh / this.a;

	    sinz = Math.sin(z);
	    cosz = Math.cos(z);

	    lon = this.long0;
	    if (Math.abs(rh) <= EPSLN) {
	      lat = this.lat0;
	    }
	    else {
	      lat = asinz(cosz * this.sin_p12 + (p.y * sinz * this.cos_p12) / rh);
	      con = Math.abs(this.lat0) - HALF_PI;
	      if (Math.abs(con) <= EPSLN) {
	        if (this.lat0 >= 0) {
	          lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
	        }
	        else {
	          lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
	        }
	      }
	      else {
	        /*con = cosz - this.sin_p12 * Math.sin(lat);
	        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
	          //no-op, just keep the lon value as is
	        } else {
	          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
	          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
	        }*/
	        lon = adjust_lon(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
	      }
	    }

	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  else {
	    e0 = e0fn(this.es);
	    e1 = e1fn(this.es);
	    e2 = e2fn(this.es);
	    e3 = e3fn(this.es);
	    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
	      //North pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      M = Mlp - rh;
	      lat = imlfn(M / this.a, e0, e1, e2, e3);
	      lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
	      //South pole case
	      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
	      rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      M = rh - Mlp;

	      lat = imlfn(M / this.a, e0, e1, e2, e3);
	      lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	    else {
	      //default case
	      rh = Math.sqrt(p.x * p.x + p.y * p.y);
	      Az = Math.atan2(p.x, p.y);
	      N1 = gN(this.a, this.e, this.sin_p12);
	      cosAz = Math.cos(Az);
	      tmp = this.e * this.cos_p12 * cosAz;
	      A = -tmp * tmp / (1 - this.es);
	      B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
	      D = rh / N1;
	      Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
	      F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
	      psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
	      lon = adjust_lon(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
	      lat = Math.atan((1 - this.es * F * this.sin_p12 / Math.sin(psi)) * Math.tan(psi) / (1 - this.es));
	      p.x = lon;
	      p.y = lat;
	      return p;
	    }
	  }

	}

	var names$26 = ["Azimuthal_Equidistant", "aeqd"];
	var aeqd = {
	  init: init$25,
	  forward: forward$24,
	  inverse: inverse$24,
	  names: names$26
	};

	function init$26() {
	  //double temp;      /* temporary variable    */

	  /* Place parameters in static storage for common use
	      -------------------------------------------------*/
	  this.sin_p14 = Math.sin(this.lat0);
	  this.cos_p14 = Math.cos(this.lat0);
	}

	/* Orthographic forward equations--mapping lat,long to x,y
	    ---------------------------------------------------*/
	function forward$25(p) {
	  var sinphi, cosphi; /* sin and cos value        */
	  var dlon; /* delta longitude value      */
	  var coslon; /* cos of longitude        */
	  var ksp; /* scale factor          */
	  var g, x, y;
	  var lon = p.x;
	  var lat = p.y;
	  /* Forward equations
	      -----------------*/
	  dlon = adjust_lon(lon - this.long0);

	  sinphi = Math.sin(lat);
	  cosphi = Math.cos(lat);

	  coslon = Math.cos(dlon);
	  g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
	  ksp = 1;
	  if ((g > 0) || (Math.abs(g) <= EPSLN)) {
	    x = this.a * ksp * cosphi * Math.sin(dlon);
	    y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
	  }
	  p.x = x;
	  p.y = y;
	  return p;
	}

	function inverse$25(p) {
	  var rh; /* height above ellipsoid      */
	  var z; /* angle          */
	  var sinz, cosz; /* sin of z and cos of z      */
	  var con;
	  var lon, lat;
	  /* Inverse equations
	      -----------------*/
	  p.x -= this.x0;
	  p.y -= this.y0;
	  rh = Math.sqrt(p.x * p.x + p.y * p.y);
	  z = asinz(rh / this.a);

	  sinz = Math.sin(z);
	  cosz = Math.cos(z);

	  lon = this.long0;
	  if (Math.abs(rh) <= EPSLN) {
	    lat = this.lat0;
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  lat = asinz(cosz * this.sin_p14 + (p.y * sinz * this.cos_p14) / rh);
	  con = Math.abs(this.lat0) - HALF_PI;
	  if (Math.abs(con) <= EPSLN) {
	    if (this.lat0 >= 0) {
	      lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
	    }
	    else {
	      lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
	    }
	    p.x = lon;
	    p.y = lat;
	    return p;
	  }
	  lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz), rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
	  p.x = lon;
	  p.y = lat;
	  return p;
	}

	var names$27 = ["ortho"];
	var ortho = {
	  init: init$26,
	  forward: forward$25,
	  inverse: inverse$25,
	  names: names$27
	};

	// QSC projection rewritten from the original PROJ4
	// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c

	/* constants */
	var FACE_ENUM = {
	    FRONT: 1,
	    RIGHT: 2,
	    BACK: 3,
	    LEFT: 4,
	    TOP: 5,
	    BOTTOM: 6
	};

	var AREA_ENUM = {
	    AREA_0: 1,
	    AREA_1: 2,
	    AREA_2: 3,
	    AREA_3: 4
	};

	function init$27() {

	  this.x0 = this.x0 || 0;
	  this.y0 = this.y0 || 0;
	  this.lat0 = this.lat0 || 0;
	  this.long0 = this.long0 || 0;
	  this.lat_ts = this.lat_ts || 0;
	  this.title = this.title || "Quadrilateralized Spherical Cube";

	  /* Determine the cube face from the center of projection. */
	  if (this.lat0 >= HALF_PI - FORTPI / 2.0) {
	    this.face = FACE_ENUM.TOP;
	  } else if (this.lat0 <= -(HALF_PI - FORTPI / 2.0)) {
	    this.face = FACE_ENUM.BOTTOM;
	  } else if (Math.abs(this.long0) <= FORTPI) {
	    this.face = FACE_ENUM.FRONT;
	  } else if (Math.abs(this.long0) <= HALF_PI + FORTPI) {
	    this.face = this.long0 > 0.0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
	  } else {
	    this.face = FACE_ENUM.BACK;
	  }

	  /* Fill in useful values for the ellipsoid <-> sphere shift
	   * described in [LK12]. */
	  if (this.es !== 0) {
	    this.one_minus_f = 1 - (this.a - this.b) / this.a;
	    this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
	  }
	}

	// QSC forward equations--mapping lat,long to x,y
	// -----------------------------------------------------------------
	function forward$26(p) {
	  var xy = {x: 0, y: 0};
	  var lat, lon;
	  var theta, phi;
	  var t, mu;
	  /* nu; */
	  var area = {value: 0};

	  // move lon according to projection's lon
	  p.x -= this.long0;

	  /* Convert the geodetic latitude to a geocentric latitude.
	   * This corresponds to the shift from the ellipsoid to the sphere
	   * described in [LK12]. */
	  if (this.es !== 0) {//if (P->es != 0) {
	    lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
	  } else {
	    lat = p.y;
	  }

	  /* Convert the input lat, lon into theta, phi as used by QSC.
	   * This depends on the cube face and the area on it.
	   * For the top and bottom face, we can compute theta and phi
	   * directly from phi, lam. For the other faces, we must use
	   * unit sphere cartesian coordinates as an intermediate step. */
	  lon = p.x; //lon = lp.lam;
	  if (this.face === FACE_ENUM.TOP) {
	    phi = HALF_PI - lat;
	    if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
	      area.value = AREA_ENUM.AREA_0;
	      theta = lon - HALF_PI;
	    } else if (lon > HALF_PI + FORTPI || lon <= -(HALF_PI + FORTPI)) {
	      area.value = AREA_ENUM.AREA_1;
	      theta = (lon > 0.0 ? lon - SPI : lon + SPI);
	    } else if (lon > -(HALF_PI + FORTPI) && lon <= -FORTPI) {
	      area.value = AREA_ENUM.AREA_2;
	      theta = lon + HALF_PI;
	    } else {
	      area.value = AREA_ENUM.AREA_3;
	      theta = lon;
	    }
	  } else if (this.face === FACE_ENUM.BOTTOM) {
	    phi = HALF_PI + lat;
	    if (lon >= FORTPI && lon <= HALF_PI + FORTPI) {
	      area.value = AREA_ENUM.AREA_0;
	      theta = -lon + HALF_PI;
	    } else if (lon < FORTPI && lon >= -FORTPI) {
	      area.value = AREA_ENUM.AREA_1;
	      theta = -lon;
	    } else if (lon < -FORTPI && lon >= -(HALF_PI + FORTPI)) {
	      area.value = AREA_ENUM.AREA_2;
	      theta = -lon - HALF_PI;
	    } else {
	      area.value = AREA_ENUM.AREA_3;
	      theta = (lon > 0.0 ? -lon + SPI : -lon - SPI);
	    }
	  } else {
	    var q, r, s;
	    var sinlat, coslat;
	    var sinlon, coslon;

	    if (this.face === FACE_ENUM.RIGHT) {
	      lon = qsc_shift_lon_origin(lon, +HALF_PI);
	    } else if (this.face === FACE_ENUM.BACK) {
	      lon = qsc_shift_lon_origin(lon, +SPI);
	    } else if (this.face === FACE_ENUM.LEFT) {
	      lon = qsc_shift_lon_origin(lon, -HALF_PI);
	    }
	    sinlat = Math.sin(lat);
	    coslat = Math.cos(lat);
	    sinlon = Math.sin(lon);
	    coslon = Math.cos(lon);
	    q = coslat * coslon;
	    r = coslat * sinlon;
	    s = sinlat;

	    if (this.face === FACE_ENUM.FRONT) {
	      phi = Math.acos(q);
	      theta = qsc_fwd_equat_face_theta(phi, s, r, area);
	    } else if (this.face === FACE_ENUM.RIGHT) {
	      phi = Math.acos(r);
	      theta = qsc_fwd_equat_face_theta(phi, s, -q, area);
	    } else if (this.face === FACE_ENUM.BACK) {
	      phi = Math.acos(-q);
	      theta = qsc_fwd_equat_face_theta(phi, s, -r, area);
	    } else if (this.face === FACE_ENUM.LEFT) {
	      phi = Math.acos(-r);
	      theta = qsc_fwd_equat_face_theta(phi, s, q, area);
	    } else {
	      /* Impossible */
	      phi = theta = 0;
	      area.value = AREA_ENUM.AREA_0;
	    }
	  }

	  /* Compute mu and nu for the area of definition.
	   * For mu, see Eq. (3-21) in [OL76], but note the typos:
	   * compare with Eq. (3-14). For nu, see Eq. (3-38). */
	  mu = Math.atan((12 / SPI) * (theta + Math.acos(Math.sin(theta) * Math.cos(FORTPI)) - HALF_PI));
	  t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));

	  /* Apply the result to the real area. */
	  if (area.value === AREA_ENUM.AREA_1) {
	    mu += HALF_PI;
	  } else if (area.value === AREA_ENUM.AREA_2) {
	    mu += SPI;
	  } else if (area.value === AREA_ENUM.AREA_3) {
	    mu += 1.5 * SPI;
	  }

	  /* Now compute x, y from mu and nu */
	  xy.x = t * Math.cos(mu);
	  xy.y = t * Math.sin(mu);
	  xy.x = xy.x * this.a + this.x0;
	  xy.y = xy.y * this.a + this.y0;

	  p.x = xy.x;
	  p.y = xy.y;
	  return p;
	}

	// QSC inverse equations--mapping x,y to lat/long
	// -----------------------------------------------------------------
	function inverse$26(p) {
	  var lp = {lam: 0, phi: 0};
	  var mu, nu, cosmu, tannu;
	  var tantheta, theta, cosphi, phi;
	  var t;
	  var area = {value: 0};

	  /* de-offset */
	  p.x = (p.x - this.x0) / this.a;
	  p.y = (p.y - this.y0) / this.a;

	  /* Convert the input x, y to the mu and nu angles as used by QSC.
	   * This depends on the area of the cube face. */
	  nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
	  mu = Math.atan2(p.y, p.x);
	  if (p.x >= 0.0 && p.x >= Math.abs(p.y)) {
	    area.value = AREA_ENUM.AREA_0;
	  } else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
	    area.value = AREA_ENUM.AREA_1;
	    mu -= HALF_PI;
	  } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
	    area.value = AREA_ENUM.AREA_2;
	    mu = (mu < 0.0 ? mu + SPI : mu - SPI);
	  } else {
	    area.value = AREA_ENUM.AREA_3;
	    mu += HALF_PI;
	  }

	  /* Compute phi and theta for the area of definition.
	   * The inverse projection is not described in the original paper, but some
	   * good hints can be found here (as of 2011-12-14):
	   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
	   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */
	  t = (SPI / 12) * Math.tan(mu);
	  tantheta = Math.sin(t) / (Math.cos(t) - (1 / Math.sqrt(2)));
	  theta = Math.atan(tantheta);
	  cosmu = Math.cos(mu);
	  tannu = Math.tan(nu);
	  cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
	  if (cosphi < -1) {
	    cosphi = -1;
	  } else if (cosphi > +1) {
	    cosphi = +1;
	  }

	  /* Apply the result to the real area on the cube face.
	   * For the top and bottom face, we can compute phi and lam directly.
	   * For the other faces, we must use unit sphere cartesian coordinates
	   * as an intermediate step. */
	  if (this.face === FACE_ENUM.TOP) {
	    phi = Math.acos(cosphi);
	    lp.phi = HALF_PI - phi;
	    if (area.value === AREA_ENUM.AREA_0) {
	      lp.lam = theta + HALF_PI;
	    } else if (area.value === AREA_ENUM.AREA_1) {
	      lp.lam = (theta < 0.0 ? theta + SPI : theta - SPI);
	    } else if (area.value === AREA_ENUM.AREA_2) {
	      lp.lam = theta - HALF_PI;
	    } else /* area.value == AREA_ENUM.AREA_3 */ {
	      lp.lam = theta;
	    }
	  } else if (this.face === FACE_ENUM.BOTTOM) {
	    phi = Math.acos(cosphi);
	    lp.phi = phi - HALF_PI;
	    if (area.value === AREA_ENUM.AREA_0) {
	      lp.lam = -theta + HALF_PI;
	    } else if (area.value === AREA_ENUM.AREA_1) {
	      lp.lam = -theta;
	    } else if (area.value === AREA_ENUM.AREA_2) {
	      lp.lam = -theta - HALF_PI;
	    } else /* area.value == AREA_ENUM.AREA_3 */ {
	      lp.lam = (theta < 0.0 ? -theta - SPI : -theta + SPI);
	    }
	  } else {
	    /* Compute phi and lam via cartesian unit sphere coordinates. */
	    var q, r, s;
	    q = cosphi;
	    t = q * q;
	    if (t >= 1) {
	      s = 0;
	    } else {
	      s = Math.sqrt(1 - t) * Math.sin(theta);
	    }
	    t += s * s;
	    if (t >= 1) {
	      r = 0;
	    } else {
	      r = Math.sqrt(1 - t);
	    }
	    /* Rotate q,r,s into the correct area. */
	    if (area.value === AREA_ENUM.AREA_1) {
	      t = r;
	      r = -s;
	      s = t;
	    } else if (area.value === AREA_ENUM.AREA_2) {
	      r = -r;
	      s = -s;
	    } else if (area.value === AREA_ENUM.AREA_3) {
	      t = r;
	      r = s;
	      s = -t;
	    }
	    /* Rotate q,r,s into the correct cube face. */
	    if (this.face === FACE_ENUM.RIGHT) {
	      t = q;
	      q = -r;
	      r = t;
	    } else if (this.face === FACE_ENUM.BACK) {
	      q = -q;
	      r = -r;
	    } else if (this.face === FACE_ENUM.LEFT) {
	      t = q;
	      q = r;
	      r = -t;
	    }
	    /* Now compute phi and lam from the unit sphere coordinates. */
	    lp.phi = Math.acos(-s) - HALF_PI;
	    lp.lam = Math.atan2(r, q);
	    if (this.face === FACE_ENUM.RIGHT) {
	      lp.lam = qsc_shift_lon_origin(lp.lam, -HALF_PI);
	    } else if (this.face === FACE_ENUM.BACK) {
	      lp.lam = qsc_shift_lon_origin(lp.lam, -SPI);
	    } else if (this.face === FACE_ENUM.LEFT) {
	      lp.lam = qsc_shift_lon_origin(lp.lam, +HALF_PI);
	    }
	  }

	  /* Apply the shift from the sphere to the ellipsoid as described
	   * in [LK12]. */
	  if (this.es !== 0) {
	    var invert_sign;
	    var tanphi, xa;
	    invert_sign = (lp.phi < 0 ? 1 : 0);
	    tanphi = Math.tan(lp.phi);
	    xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
	    lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
	    if (invert_sign) {
	      lp.phi = -lp.phi;
	    }
	  }

	  lp.lam += this.long0;
	  p.x = lp.lam;
	  p.y = lp.phi;
	  return p;
	}

	/* Helper function for forward projection: compute the theta angle
	 * and determine the area number. */
	function qsc_fwd_equat_face_theta(phi, y, x, area) {
	  var theta;
	  if (phi < EPSLN) {
	    area.value = AREA_ENUM.AREA_0;
	    theta = 0.0;
	  } else {
	    theta = Math.atan2(y, x);
	    if (Math.abs(theta) <= FORTPI) {
	      area.value = AREA_ENUM.AREA_0;
	    } else if (theta > FORTPI && theta <= HALF_PI + FORTPI) {
	      area.value = AREA_ENUM.AREA_1;
	      theta -= HALF_PI;
	    } else if (theta > HALF_PI + FORTPI || theta <= -(HALF_PI + FORTPI)) {
	      area.value = AREA_ENUM.AREA_2;
	      theta = (theta >= 0.0 ? theta - SPI : theta + SPI);
	    } else {
	      area.value = AREA_ENUM.AREA_3;
	      theta += HALF_PI;
	    }
	  }
	  return theta;
	}

	/* Helper function: shift the longitude. */
	function qsc_shift_lon_origin(lon, offset) {
	  var slon = lon + offset;
	  if (slon < -SPI) {
	    slon += TWO_PI;
	  } else if (slon > +SPI) {
	    slon -= TWO_PI;
	  }
	  return slon;
	}

	var names$28 = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
	var qsc = {
	  init: init$27,
	  forward: forward$26,
	  inverse: inverse$26,
	  names: names$28
	};

	var includedProjections = function(proj4){
	  proj4.Proj.projections.add(tmerc);
	  proj4.Proj.projections.add(etmerc);
	  proj4.Proj.projections.add(utm);
	  proj4.Proj.projections.add(sterea);
	  proj4.Proj.projections.add(stere);
	  proj4.Proj.projections.add(somerc);
	  proj4.Proj.projections.add(omerc);
	  proj4.Proj.projections.add(lcc);
	  proj4.Proj.projections.add(krovak);
	  proj4.Proj.projections.add(cass);
	  proj4.Proj.projections.add(laea);
	  proj4.Proj.projections.add(aea);
	  proj4.Proj.projections.add(gnom);
	  proj4.Proj.projections.add(cea);
	  proj4.Proj.projections.add(eqc);
	  proj4.Proj.projections.add(poly);
	  proj4.Proj.projections.add(nzmg);
	  proj4.Proj.projections.add(mill);
	  proj4.Proj.projections.add(sinu);
	  proj4.Proj.projections.add(moll);
	  proj4.Proj.projections.add(eqdc);
	  proj4.Proj.projections.add(vandg);
	  proj4.Proj.projections.add(aeqd);
	  proj4.Proj.projections.add(ortho);
	  proj4.Proj.projections.add(qsc);
	};

	proj4$1.defaultDatum = 'WGS84'; //default datum
	proj4$1.Proj = Projection$1;
	proj4$1.WGS84 = new proj4$1.Proj('WGS84');
	proj4$1.Point = Point;
	proj4$1.toPoint = toPoint;
	proj4$1.defs = defs;
	proj4$1.transform = transform;
	proj4$1.mgrs = mgrs;
	proj4$1.version = version;
	includedProjections(proj4$1);

	return proj4$1;

})));

},{}],79:[function(require,module,exports){
(function (factory) {
	var L, proj4;
	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['leaflet', 'proj4'], factory);
	} else if (typeof module === 'object' && typeof module.exports === "object") {
		// Node/CommonJS
		L = require('leaflet');
		proj4 = require('proj4');
		module.exports = factory(L, proj4);
	} else {
		// Browser globals
		if (typeof window.L === 'undefined' || typeof window.proj4 === 'undefined')
			throw 'Leaflet and proj4 must be loaded first';
		factory(window.L, window.proj4);
	}
}(function (L, proj4) {
	if (proj4.__esModule && proj4.default) {
		// If proj4 was bundled as an ES6 module, unwrap it to get
		// to the actual main proj4 object.
		// See discussion in https://github.com/kartena/Proj4Leaflet/pull/147
		proj4 = proj4.default;
	}
 
	L.Proj = {};

	L.Proj._isProj4Obj = function(a) {
		return (typeof a.inverse !== 'undefined' &&
			typeof a.forward !== 'undefined');
	};

	L.Proj.Projection = L.Class.extend({
		initialize: function(code, def, bounds) {
			var isP4 = L.Proj._isProj4Obj(code);
			this._proj = isP4 ? code : this._projFromCodeDef(code, def);
			this.bounds = isP4 ? def : bounds;
		},

		project: function (latlng) {
			var point = this._proj.forward([latlng.lng, latlng.lat]);
			return new L.Point(point[0], point[1]);
		},

		unproject: function (point, unbounded) {
			var point2 = this._proj.inverse([point.x, point.y]);
			return new L.LatLng(point2[1], point2[0], unbounded);
		},

		_projFromCodeDef: function(code, def) {
			if (def) {
				proj4.defs(code, def);
			} else if (proj4.defs[code] === undefined) {
				var urn = code.split(':');
				if (urn.length > 3) {
					code = urn[urn.length - 3] + ':' + urn[urn.length - 1];
				}
				if (proj4.defs[code] === undefined) {
					throw 'No projection definition for code ' + code;
				}
			}

			return proj4(code);
		}
	});

	L.Proj.CRS = L.Class.extend({
		includes: L.CRS,

		options: {
			transformation: new L.Transformation(1, 0, -1, 0)
		},

		initialize: function(a, b, c) {
			var code,
			    proj,
			    def,
			    options;

			if (L.Proj._isProj4Obj(a)) {
				proj = a;
				code = proj.srsCode;
				options = b || {};

				this.projection = new L.Proj.Projection(proj, options.bounds);
			} else {
				code = a;
				def = b;
				options = c || {};
				this.projection = new L.Proj.Projection(code, def, options.bounds);
			}

			L.Util.setOptions(this, options);
			this.code = code;
			this.transformation = this.options.transformation;

			if (this.options.origin) {
				this.transformation =
					new L.Transformation(1, -this.options.origin[0],
						-1, this.options.origin[1]);
			}

			if (this.options.scales) {
				this._scales = this.options.scales;
			} else if (this.options.resolutions) {
				this._scales = [];
				for (var i = this.options.resolutions.length - 1; i >= 0; i--) {
					if (this.options.resolutions[i]) {
						this._scales[i] = 1 / this.options.resolutions[i];
					}
				}
			}

			this.infinite = !this.options.bounds;

		},

		scale: function(zoom) {
			var iZoom = Math.floor(zoom),
				baseScale,
				nextScale,
				scaleDiff,
				zDiff;
			if (zoom === iZoom) {
				return this._scales[zoom];
			} else {
				// Non-integer zoom, interpolate
				baseScale = this._scales[iZoom];
				nextScale = this._scales[iZoom + 1];
				scaleDiff = nextScale - baseScale;
				zDiff = (zoom - iZoom);
				return baseScale + scaleDiff * zDiff;
			}
		},

		zoom: function(scale) {
			// Find closest number in this._scales, down
			var downScale = this._closestElement(this._scales, scale),
				downZoom = this._scales.indexOf(downScale),
				nextScale,
				nextZoom,
				scaleDiff;
			// Check if scale is downScale => return array index
			if (scale === downScale) {
				return downZoom;
			}
			if (downScale === undefined) {
				return -Infinity;
			}
			// Interpolate
			nextZoom = downZoom + 1;
			nextScale = this._scales[nextZoom];
			if (nextScale === undefined) {
				return Infinity;
			}
			scaleDiff = nextScale - downScale;
			return (scale - downScale) / scaleDiff + downZoom;
		},

		distance: L.CRS.Earth.distance,

		R: L.CRS.Earth.R,

		/* Get the closest lowest element in an array */
		_closestElement: function(array, element) {
			var low;
			for (var i = array.length; i--;) {
				if (array[i] <= element && (low === undefined || low < array[i])) {
					low = array[i];
				}
			}
			return low;
		}
	});

	L.Proj.GeoJSON = L.GeoJSON.extend({
		initialize: function(geojson, options) {
			this._callLevel = 0;
			L.GeoJSON.prototype.initialize.call(this, geojson, options);
		},

		addData: function(geojson) {
			var crs;

			if (geojson) {
				if (geojson.crs && geojson.crs.type === 'name') {
					crs = new L.Proj.CRS(geojson.crs.properties.name);
				} else if (geojson.crs && geojson.crs.type) {
					crs = new L.Proj.CRS(geojson.crs.type + ':' + geojson.crs.properties.code);
				}

				if (crs !== undefined) {
					this.options.coordsToLatLng = function(coords) {
						var point = L.point(coords[0], coords[1]);
						return crs.projection.unproject(point);
					};
				}
			}

			// Base class' addData might call us recursively, but
			// CRS shouldn't be cleared in that case, since CRS applies
			// to the whole GeoJSON, inluding sub-features.
			this._callLevel++;
			try {
				L.GeoJSON.prototype.addData.call(this, geojson);
			} finally {
				this._callLevel--;
				if (this._callLevel === 0) {
					delete this.options.coordsToLatLng;
				}
			}
		}
	});

	L.Proj.geoJson = function(geojson, options) {
		return new L.Proj.GeoJSON(geojson, options);
	};

	L.Proj.ImageOverlay = L.ImageOverlay.extend({
		initialize: function (url, bounds, options) {
			L.ImageOverlay.prototype.initialize.call(this, url, null, options);
			this._projectedBounds = bounds;
		},

		// Danger ahead: Overriding internal methods in Leaflet.
		// Decided to do this rather than making a copy of L.ImageOverlay
		// and doing very tiny modifications to it.
		// Future will tell if this was wise or not.
		_animateZoom: function (event) {
			var scale = this._map.getZoomScale(event.zoom);
			var northWest = L.point(this._projectedBounds.min.x, this._projectedBounds.max.y);
			var offset = this._projectedToNewLayerPoint(northWest, event.zoom, event.center);

			L.DomUtil.setTransform(this._image, offset, scale);
		},

		_reset: function () {
			var zoom = this._map.getZoom();
			var pixelOrigin = this._map.getPixelOrigin();
			var bounds = L.bounds(
				this._transform(this._projectedBounds.min, zoom)._subtract(pixelOrigin),
				this._transform(this._projectedBounds.max, zoom)._subtract(pixelOrigin)
			);
			var size = bounds.getSize();

			L.DomUtil.setPosition(this._image, bounds.min);
			this._image.style.width = size.x + 'px';
			this._image.style.height = size.y + 'px';
		},

		_projectedToNewLayerPoint: function (point, zoom, center) {
			var viewHalf = this._map.getSize()._divideBy(2);
			var newTopLeft = this._map.project(center, zoom)._subtract(viewHalf)._round();
			var topLeft = newTopLeft.add(this._map._getMapPanePos());

			return this._transform(point, zoom)._subtract(topLeft);
		},

		_transform: function (point, zoom) {
			var crs = this._map.options.crs;
			var transformation = crs.transformation;
			var scale = crs.scale(zoom);

			return transformation.transform(point, scale);
		}
	});

	L.Proj.imageOverlay = function (url, bounds, options) {
		return new L.Proj.ImageOverlay(url, bounds, options);
	};

	return L.Proj;
}));

},{"leaflet":76,"proj4":78}],80:[function(require,module,exports){
module.exports={
	"Aacute": [ 193 ],
	"aacute": [ 225 ],
	"Abreve": [ 258 ],
	"abreve": [ 259 ],
	"ac": [ 8766 ],
	"acd": [ 8767 ],
	"acE": [ 8766, 819 ],
	"Acirc": [ 194 ],
	"acirc": [ 226 ],
	"acute": [ 180 ],
	"Acy": [ 1040 ],
	"acy": [ 1072 ],
	"AElig": [ 198 ],
	"aelig": [ 230 ],
	"af": [ 8289 ],
	"Afr": [ 120068 ],
	"afr": [ 120094 ],
	"Agrave": [ 192 ],
	"agrave": [ 224 ],
	"alefsym": [ 8501 ],
	"aleph": [ 8501 ],
	"Alpha": [ 913 ],
	"alpha": [ 945 ],
	"Amacr": [ 256 ],
	"amacr": [ 257 ],
	"amalg": [ 10815 ],
	"AMP": [ 38 ],
	"amp": [ 38 ],
	"And": [ 10835 ],
	"and": [ 8743 ],
	"andand": [ 10837 ],
	"andd": [ 10844 ],
	"andslope": [ 10840 ],
	"andv": [ 10842 ],
	"ang": [ 8736 ],
	"ange": [ 10660 ],
	"angle": [ 8736 ],
	"angmsd": [ 8737 ],
	"angmsdaa": [ 10664 ],
	"angmsdab": [ 10665 ],
	"angmsdac": [ 10666 ],
	"angmsdad": [ 10667 ],
	"angmsdae": [ 10668 ],
	"angmsdaf": [ 10669 ],
	"angmsdag": [ 10670 ],
	"angmsdah": [ 10671 ],
	"angrt": [ 8735 ],
	"angrtvb": [ 8894 ],
	"angrtvbd": [ 10653 ],
	"angsph": [ 8738 ],
	"angst": [ 197 ],
	"angzarr": [ 9084 ],
	"Aogon": [ 260 ],
	"aogon": [ 261 ],
	"Aopf": [ 120120 ],
	"aopf": [ 120146 ],
	"ap": [ 8776 ],
	"apacir": [ 10863 ],
	"apE": [ 10864 ],
	"ape": [ 8778 ],
	"apid": [ 8779 ],
	"apos": [ 39 ],
	"ApplyFunction": [ 8289 ],
	"approx": [ 8776 ],
	"approxeq": [ 8778 ],
	"Aring": [ 197 ],
	"aring": [ 229 ],
	"Ascr": [ 119964 ],
	"ascr": [ 119990 ],
	"Assign": [ 8788 ],
	"ast": [ 42 ],
	"asymp": [ 8776 ],
	"asympeq": [ 8781 ],
	"Atilde": [ 195 ],
	"atilde": [ 227 ],
	"Auml": [ 196 ],
	"auml": [ 228 ],
	"awconint": [ 8755 ],
	"awint": [ 10769 ],
	"backcong": [ 8780 ],
	"backepsilon": [ 1014 ],
	"backprime": [ 8245 ],
	"backsim": [ 8765 ],
	"backsimeq": [ 8909 ],
	"Backslash": [ 8726 ],
	"Barv": [ 10983 ],
	"barvee": [ 8893 ],
	"Barwed": [ 8966 ],
	"barwed": [ 8965 ],
	"barwedge": [ 8965 ],
	"bbrk": [ 9141 ],
	"bbrktbrk": [ 9142 ],
	"bcong": [ 8780 ],
	"Bcy": [ 1041 ],
	"bcy": [ 1073 ],
	"bdquo": [ 8222 ],
	"becaus": [ 8757 ],
	"Because": [ 8757 ],
	"because": [ 8757 ],
	"bemptyv": [ 10672 ],
	"bepsi": [ 1014 ],
	"bernou": [ 8492 ],
	"Bernoullis": [ 8492 ],
	"Beta": [ 914 ],
	"beta": [ 946 ],
	"beth": [ 8502 ],
	"between": [ 8812 ],
	"Bfr": [ 120069 ],
	"bfr": [ 120095 ],
	"bigcap": [ 8898 ],
	"bigcirc": [ 9711 ],
	"bigcup": [ 8899 ],
	"bigodot": [ 10752 ],
	"bigoplus": [ 10753 ],
	"bigotimes": [ 10754 ],
	"bigsqcup": [ 10758 ],
	"bigstar": [ 9733 ],
	"bigtriangledown": [ 9661 ],
	"bigtriangleup": [ 9651 ],
	"biguplus": [ 10756 ],
	"bigvee": [ 8897 ],
	"bigwedge": [ 8896 ],
	"bkarow": [ 10509 ],
	"blacklozenge": [ 10731 ],
	"blacksquare": [ 9642 ],
	"blacktriangle": [ 9652 ],
	"blacktriangledown": [ 9662 ],
	"blacktriangleleft": [ 9666 ],
	"blacktriangleright": [ 9656 ],
	"blank": [ 9251 ],
	"blk12": [ 9618 ],
	"blk14": [ 9617 ],
	"blk34": [ 9619 ],
	"block": [ 9608 ],
	"bne": [ 61, 8421 ],
	"bnequiv": [ 8801, 8421 ],
	"bNot": [ 10989 ],
	"bnot": [ 8976 ],
	"Bopf": [ 120121 ],
	"bopf": [ 120147 ],
	"bot": [ 8869 ],
	"bottom": [ 8869 ],
	"bowtie": [ 8904 ],
	"boxbox": [ 10697 ],
	"boxDL": [ 9559 ],
	"boxDl": [ 9558 ],
	"boxdL": [ 9557 ],
	"boxdl": [ 9488 ],
	"boxDR": [ 9556 ],
	"boxDr": [ 9555 ],
	"boxdR": [ 9554 ],
	"boxdr": [ 9484 ],
	"boxH": [ 9552 ],
	"boxh": [ 9472 ],
	"boxHD": [ 9574 ],
	"boxHd": [ 9572 ],
	"boxhD": [ 9573 ],
	"boxhd": [ 9516 ],
	"boxHU": [ 9577 ],
	"boxHu": [ 9575 ],
	"boxhU": [ 9576 ],
	"boxhu": [ 9524 ],
	"boxminus": [ 8863 ],
	"boxplus": [ 8862 ],
	"boxtimes": [ 8864 ],
	"boxUL": [ 9565 ],
	"boxUl": [ 9564 ],
	"boxuL": [ 9563 ],
	"boxul": [ 9496 ],
	"boxUR": [ 9562 ],
	"boxUr": [ 9561 ],
	"boxuR": [ 9560 ],
	"boxur": [ 9492 ],
	"boxV": [ 9553 ],
	"boxv": [ 9474 ],
	"boxVH": [ 9580 ],
	"boxVh": [ 9579 ],
	"boxvH": [ 9578 ],
	"boxvh": [ 9532 ],
	"boxVL": [ 9571 ],
	"boxVl": [ 9570 ],
	"boxvL": [ 9569 ],
	"boxvl": [ 9508 ],
	"boxVR": [ 9568 ],
	"boxVr": [ 9567 ],
	"boxvR": [ 9566 ],
	"boxvr": [ 9500 ],
	"bprime": [ 8245 ],
	"Breve": [ 728 ],
	"breve": [ 728 ],
	"brvbar": [ 166 ],
	"Bscr": [ 8492 ],
	"bscr": [ 119991 ],
	"bsemi": [ 8271 ],
	"bsim": [ 8765 ],
	"bsime": [ 8909 ],
	"bsol": [ 92 ],
	"bsolb": [ 10693 ],
	"bsolhsub": [ 10184 ],
	"bull": [ 8226 ],
	"bullet": [ 8226 ],
	"bump": [ 8782 ],
	"bumpE": [ 10926 ],
	"bumpe": [ 8783 ],
	"Bumpeq": [ 8782 ],
	"bumpeq": [ 8783 ],
	"Cacute": [ 262 ],
	"cacute": [ 263 ],
	"Cap": [ 8914 ],
	"cap": [ 8745 ],
	"capand": [ 10820 ],
	"capbrcup": [ 10825 ],
	"capcap": [ 10827 ],
	"capcup": [ 10823 ],
	"capdot": [ 10816 ],
	"CapitalDifferentialD": [ 8517 ],
	"caps": [ 8745, 65024 ],
	"caret": [ 8257 ],
	"caron": [ 711 ],
	"Cayleys": [ 8493 ],
	"ccaps": [ 10829 ],
	"Ccaron": [ 268 ],
	"ccaron": [ 269 ],
	"Ccedil": [ 199 ],
	"ccedil": [ 231 ],
	"Ccirc": [ 264 ],
	"ccirc": [ 265 ],
	"Cconint": [ 8752 ],
	"ccups": [ 10828 ],
	"ccupssm": [ 10832 ],
	"Cdot": [ 266 ],
	"cdot": [ 267 ],
	"cedil": [ 184 ],
	"Cedilla": [ 184 ],
	"cemptyv": [ 10674 ],
	"cent": [ 162 ],
	"CenterDot": [ 183 ],
	"centerdot": [ 183 ],
	"Cfr": [ 8493 ],
	"cfr": [ 120096 ],
	"CHcy": [ 1063 ],
	"chcy": [ 1095 ],
	"check": [ 10003 ],
	"checkmark": [ 10003 ],
	"Chi": [ 935 ],
	"chi": [ 967 ],
	"cir": [ 9675 ],
	"circ": [ 710 ],
	"circeq": [ 8791 ],
	"circlearrowleft": [ 8634 ],
	"circlearrowright": [ 8635 ],
	"circledast": [ 8859 ],
	"circledcirc": [ 8858 ],
	"circleddash": [ 8861 ],
	"CircleDot": [ 8857 ],
	"circledR": [ 174 ],
	"circledS": [ 9416 ],
	"CircleMinus": [ 8854 ],
	"CirclePlus": [ 8853 ],
	"CircleTimes": [ 8855 ],
	"cirE": [ 10691 ],
	"cire": [ 8791 ],
	"cirfnint": [ 10768 ],
	"cirmid": [ 10991 ],
	"cirscir": [ 10690 ],
	"ClockwiseContourIntegral": [ 8754 ],
	"CloseCurlyDoubleQuote": [ 8221 ],
	"CloseCurlyQuote": [ 8217 ],
	"clubs": [ 9827 ],
	"clubsuit": [ 9827 ],
	"Colon": [ 8759 ],
	"colon": [ 58 ],
	"Colone": [ 10868 ],
	"colone": [ 8788 ],
	"coloneq": [ 8788 ],
	"comma": [ 44 ],
	"commat": [ 64 ],
	"comp": [ 8705 ],
	"compfn": [ 8728 ],
	"complement": [ 8705 ],
	"complexes": [ 8450 ],
	"cong": [ 8773 ],
	"congdot": [ 10861 ],
	"Congruent": [ 8801 ],
	"Conint": [ 8751 ],
	"conint": [ 8750 ],
	"ContourIntegral": [ 8750 ],
	"Copf": [ 8450 ],
	"copf": [ 120148 ],
	"coprod": [ 8720 ],
	"Coproduct": [ 8720 ],
	"COPY": [ 169 ],
	"copy": [ 169 ],
	"copysr": [ 8471 ],
	"CounterClockwiseContourIntegral": [ 8755 ],
	"crarr": [ 8629 ],
	"Cross": [ 10799 ],
	"cross": [ 10007 ],
	"Cscr": [ 119966 ],
	"cscr": [ 119992 ],
	"csub": [ 10959 ],
	"csube": [ 10961 ],
	"csup": [ 10960 ],
	"csupe": [ 10962 ],
	"ctdot": [ 8943 ],
	"cudarrl": [ 10552 ],
	"cudarrr": [ 10549 ],
	"cuepr": [ 8926 ],
	"cuesc": [ 8927 ],
	"cularr": [ 8630 ],
	"cularrp": [ 10557 ],
	"Cup": [ 8915 ],
	"cup": [ 8746 ],
	"cupbrcap": [ 10824 ],
	"CupCap": [ 8781 ],
	"cupcap": [ 10822 ],
	"cupcup": [ 10826 ],
	"cupdot": [ 8845 ],
	"cupor": [ 10821 ],
	"cups": [ 8746, 65024 ],
	"curarr": [ 8631 ],
	"curarrm": [ 10556 ],
	"curlyeqprec": [ 8926 ],
	"curlyeqsucc": [ 8927 ],
	"curlyvee": [ 8910 ],
	"curlywedge": [ 8911 ],
	"curren": [ 164 ],
	"curvearrowleft": [ 8630 ],
	"curvearrowright": [ 8631 ],
	"cuvee": [ 8910 ],
	"cuwed": [ 8911 ],
	"cwconint": [ 8754 ],
	"cwint": [ 8753 ],
	"cylcty": [ 9005 ],
	"Dagger": [ 8225 ],
	"dagger": [ 8224 ],
	"daleth": [ 8504 ],
	"Darr": [ 8609 ],
	"dArr": [ 8659 ],
	"darr": [ 8595 ],
	"dash": [ 8208 ],
	"Dashv": [ 10980 ],
	"dashv": [ 8867 ],
	"dbkarow": [ 10511 ],
	"dblac": [ 733 ],
	"Dcaron": [ 270 ],
	"dcaron": [ 271 ],
	"Dcy": [ 1044 ],
	"dcy": [ 1076 ],
	"DD": [ 8517 ],
	"dd": [ 8518 ],
	"ddagger": [ 8225 ],
	"ddarr": [ 8650 ],
	"DDotrahd": [ 10513 ],
	"ddotseq": [ 10871 ],
	"deg": [ 176 ],
	"Del": [ 8711 ],
	"Delta": [ 916 ],
	"delta": [ 948 ],
	"demptyv": [ 10673 ],
	"dfisht": [ 10623 ],
	"Dfr": [ 120071 ],
	"dfr": [ 120097 ],
	"dHar": [ 10597 ],
	"dharl": [ 8643 ],
	"dharr": [ 8642 ],
	"DiacriticalAcute": [ 180 ],
	"DiacriticalDot": [ 729 ],
	"DiacriticalDoubleAcute": [ 733 ],
	"DiacriticalGrave": [ 96 ],
	"DiacriticalTilde": [ 732 ],
	"diam": [ 8900 ],
	"Diamond": [ 8900 ],
	"diamond": [ 8900 ],
	"diamondsuit": [ 9830 ],
	"diams": [ 9830 ],
	"die": [ 168 ],
	"DifferentialD": [ 8518 ],
	"digamma": [ 989 ],
	"disin": [ 8946 ],
	"div": [ 247 ],
	"divide": [ 247 ],
	"divideontimes": [ 8903 ],
	"divonx": [ 8903 ],
	"DJcy": [ 1026 ],
	"djcy": [ 1106 ],
	"dlcorn": [ 8990 ],
	"dlcrop": [ 8973 ],
	"dollar": [ 36 ],
	"Dopf": [ 120123 ],
	"dopf": [ 120149 ],
	"Dot": [ 168 ],
	"dot": [ 729 ],
	"DotDot": [ 8412 ],
	"doteq": [ 8784 ],
	"doteqdot": [ 8785 ],
	"DotEqual": [ 8784 ],
	"dotminus": [ 8760 ],
	"dotplus": [ 8724 ],
	"dotsquare": [ 8865 ],
	"doublebarwedge": [ 8966 ],
	"DoubleContourIntegral": [ 8751 ],
	"DoubleDot": [ 168 ],
	"DoubleDownArrow": [ 8659 ],
	"DoubleLeftArrow": [ 8656 ],
	"DoubleLeftRightArrow": [ 8660 ],
	"DoubleLeftTee": [ 10980 ],
	"DoubleLongLeftArrow": [ 10232 ],
	"DoubleLongLeftRightArrow": [ 10234 ],
	"DoubleLongRightArrow": [ 10233 ],
	"DoubleRightArrow": [ 8658 ],
	"DoubleRightTee": [ 8872 ],
	"DoubleUpArrow": [ 8657 ],
	"DoubleUpDownArrow": [ 8661 ],
	"DoubleVerticalBar": [ 8741 ],
	"DownArrow": [ 8595 ],
	"Downarrow": [ 8659 ],
	"downarrow": [ 8595 ],
	"DownArrowBar": [ 10515 ],
	"DownArrowUpArrow": [ 8693 ],
	"DownBreve": [ 785 ],
	"downdownarrows": [ 8650 ],
	"downharpoonleft": [ 8643 ],
	"downharpoonright": [ 8642 ],
	"DownLeftRightVector": [ 10576 ],
	"DownLeftTeeVector": [ 10590 ],
	"DownLeftVector": [ 8637 ],
	"DownLeftVectorBar": [ 10582 ],
	"DownRightTeeVector": [ 10591 ],
	"DownRightVector": [ 8641 ],
	"DownRightVectorBar": [ 10583 ],
	"DownTee": [ 8868 ],
	"DownTeeArrow": [ 8615 ],
	"drbkarow": [ 10512 ],
	"drcorn": [ 8991 ],
	"drcrop": [ 8972 ],
	"Dscr": [ 119967 ],
	"dscr": [ 119993 ],
	"DScy": [ 1029 ],
	"dscy": [ 1109 ],
	"dsol": [ 10742 ],
	"Dstrok": [ 272 ],
	"dstrok": [ 273 ],
	"dtdot": [ 8945 ],
	"dtri": [ 9663 ],
	"dtrif": [ 9662 ],
	"duarr": [ 8693 ],
	"duhar": [ 10607 ],
	"dwangle": [ 10662 ],
	"DZcy": [ 1039 ],
	"dzcy": [ 1119 ],
	"dzigrarr": [ 10239 ],
	"Eacute": [ 201 ],
	"eacute": [ 233 ],
	"easter": [ 10862 ],
	"Ecaron": [ 282 ],
	"ecaron": [ 283 ],
	"ecir": [ 8790 ],
	"Ecirc": [ 202 ],
	"ecirc": [ 234 ],
	"ecolon": [ 8789 ],
	"Ecy": [ 1069 ],
	"ecy": [ 1101 ],
	"eDDot": [ 10871 ],
	"Edot": [ 278 ],
	"eDot": [ 8785 ],
	"edot": [ 279 ],
	"ee": [ 8519 ],
	"efDot": [ 8786 ],
	"Efr": [ 120072 ],
	"efr": [ 120098 ],
	"eg": [ 10906 ],
	"Egrave": [ 200 ],
	"egrave": [ 232 ],
	"egs": [ 10902 ],
	"egsdot": [ 10904 ],
	"el": [ 10905 ],
	"Element": [ 8712 ],
	"elinters": [ 9191 ],
	"ell": [ 8467 ],
	"els": [ 10901 ],
	"elsdot": [ 10903 ],
	"Emacr": [ 274 ],
	"emacr": [ 275 ],
	"empty": [ 8709 ],
	"emptyset": [ 8709 ],
	"EmptySmallSquare": [ 9723 ],
	"emptyv": [ 8709 ],
	"EmptyVerySmallSquare": [ 9643 ],
	"emsp": [ 8195 ],
	"emsp13": [ 8196 ],
	"emsp14": [ 8197 ],
	"ENG": [ 330 ],
	"eng": [ 331 ],
	"ensp": [ 8194 ],
	"Eogon": [ 280 ],
	"eogon": [ 281 ],
	"Eopf": [ 120124 ],
	"eopf": [ 120150 ],
	"epar": [ 8917 ],
	"eparsl": [ 10723 ],
	"eplus": [ 10865 ],
	"epsi": [ 949 ],
	"Epsilon": [ 917 ],
	"epsilon": [ 949 ],
	"epsiv": [ 1013 ],
	"eqcirc": [ 8790 ],
	"eqcolon": [ 8789 ],
	"eqsim": [ 8770 ],
	"eqslantgtr": [ 10902 ],
	"eqslantless": [ 10901 ],
	"Equal": [ 10869 ],
	"equals": [ 61 ],
	"EqualTilde": [ 8770 ],
	"equest": [ 8799 ],
	"Equilibrium": [ 8652 ],
	"equiv": [ 8801 ],
	"equivDD": [ 10872 ],
	"eqvparsl": [ 10725 ],
	"erarr": [ 10609 ],
	"erDot": [ 8787 ],
	"Escr": [ 8496 ],
	"escr": [ 8495 ],
	"esdot": [ 8784 ],
	"Esim": [ 10867 ],
	"esim": [ 8770 ],
	"Eta": [ 919 ],
	"eta": [ 951 ],
	"ETH": [ 208 ],
	"eth": [ 240 ],
	"Euml": [ 203 ],
	"euml": [ 235 ],
	"euro": [ 8364 ],
	"excl": [ 33 ],
	"exist": [ 8707 ],
	"Exists": [ 8707 ],
	"expectation": [ 8496 ],
	"ExponentialE": [ 8519 ],
	"exponentiale": [ 8519 ],
	"fallingdotseq": [ 8786 ],
	"Fcy": [ 1060 ],
	"fcy": [ 1092 ],
	"female": [ 9792 ],
	"ffilig": [ 64259 ],
	"fflig": [ 64256 ],
	"ffllig": [ 64260 ],
	"Ffr": [ 120073 ],
	"ffr": [ 120099 ],
	"filig": [ 64257 ],
	"FilledSmallSquare": [ 9724 ],
	"FilledVerySmallSquare": [ 9642 ],
	"fjlig": [ 102, 106 ],
	"flat": [ 9837 ],
	"fllig": [ 64258 ],
	"fltns": [ 9649 ],
	"fnof": [ 402 ],
	"Fopf": [ 120125 ],
	"fopf": [ 120151 ],
	"ForAll": [ 8704 ],
	"forall": [ 8704 ],
	"fork": [ 8916 ],
	"forkv": [ 10969 ],
	"Fouriertrf": [ 8497 ],
	"fpartint": [ 10765 ],
	"frac12": [ 189 ],
	"frac13": [ 8531 ],
	"frac14": [ 188 ],
	"frac15": [ 8533 ],
	"frac16": [ 8537 ],
	"frac18": [ 8539 ],
	"frac23": [ 8532 ],
	"frac25": [ 8534 ],
	"frac34": [ 190 ],
	"frac35": [ 8535 ],
	"frac38": [ 8540 ],
	"frac45": [ 8536 ],
	"frac56": [ 8538 ],
	"frac58": [ 8541 ],
	"frac78": [ 8542 ],
	"frasl": [ 8260 ],
	"frown": [ 8994 ],
	"Fscr": [ 8497 ],
	"fscr": [ 119995 ],
	"gacute": [ 501 ],
	"Gamma": [ 915 ],
	"gamma": [ 947 ],
	"Gammad": [ 988 ],
	"gammad": [ 989 ],
	"gap": [ 10886 ],
	"Gbreve": [ 286 ],
	"gbreve": [ 287 ],
	"Gcedil": [ 290 ],
	"Gcirc": [ 284 ],
	"gcirc": [ 285 ],
	"Gcy": [ 1043 ],
	"gcy": [ 1075 ],
	"Gdot": [ 288 ],
	"gdot": [ 289 ],
	"gE": [ 8807 ],
	"ge": [ 8805 ],
	"gEl": [ 10892 ],
	"gel": [ 8923 ],
	"geq": [ 8805 ],
	"geqq": [ 8807 ],
	"geqslant": [ 10878 ],
	"ges": [ 10878 ],
	"gescc": [ 10921 ],
	"gesdot": [ 10880 ],
	"gesdoto": [ 10882 ],
	"gesdotol": [ 10884 ],
	"gesl": [ 8923, 65024 ],
	"gesles": [ 10900 ],
	"Gfr": [ 120074 ],
	"gfr": [ 120100 ],
	"Gg": [ 8921 ],
	"gg": [ 8811 ],
	"ggg": [ 8921 ],
	"gimel": [ 8503 ],
	"GJcy": [ 1027 ],
	"gjcy": [ 1107 ],
	"gl": [ 8823 ],
	"gla": [ 10917 ],
	"glE": [ 10898 ],
	"glj": [ 10916 ],
	"gnap": [ 10890 ],
	"gnapprox": [ 10890 ],
	"gnE": [ 8809 ],
	"gne": [ 10888 ],
	"gneq": [ 10888 ],
	"gneqq": [ 8809 ],
	"gnsim": [ 8935 ],
	"Gopf": [ 120126 ],
	"gopf": [ 120152 ],
	"grave": [ 96 ],
	"GreaterEqual": [ 8805 ],
	"GreaterEqualLess": [ 8923 ],
	"GreaterFullEqual": [ 8807 ],
	"GreaterGreater": [ 10914 ],
	"GreaterLess": [ 8823 ],
	"GreaterSlantEqual": [ 10878 ],
	"GreaterTilde": [ 8819 ],
	"Gscr": [ 119970 ],
	"gscr": [ 8458 ],
	"gsim": [ 8819 ],
	"gsime": [ 10894 ],
	"gsiml": [ 10896 ],
	"GT": [ 62 ],
	"Gt": [ 8811 ],
	"gt": [ 62 ],
	"gtcc": [ 10919 ],
	"gtcir": [ 10874 ],
	"gtdot": [ 8919 ],
	"gtlPar": [ 10645 ],
	"gtquest": [ 10876 ],
	"gtrapprox": [ 10886 ],
	"gtrarr": [ 10616 ],
	"gtrdot": [ 8919 ],
	"gtreqless": [ 8923 ],
	"gtreqqless": [ 10892 ],
	"gtrless": [ 8823 ],
	"gtrsim": [ 8819 ],
	"gvertneqq": [ 8809, 65024 ],
	"gvnE": [ 8809, 65024 ],
	"Hacek": [ 711 ],
	"hairsp": [ 8202 ],
	"half": [ 189 ],
	"hamilt": [ 8459 ],
	"HARDcy": [ 1066 ],
	"hardcy": [ 1098 ],
	"hArr": [ 8660 ],
	"harr": [ 8596 ],
	"harrcir": [ 10568 ],
	"harrw": [ 8621 ],
	"Hat": [ 94 ],
	"hbar": [ 8463 ],
	"Hcirc": [ 292 ],
	"hcirc": [ 293 ],
	"hearts": [ 9829 ],
	"heartsuit": [ 9829 ],
	"hellip": [ 8230 ],
	"hercon": [ 8889 ],
	"Hfr": [ 8460 ],
	"hfr": [ 120101 ],
	"HilbertSpace": [ 8459 ],
	"hksearow": [ 10533 ],
	"hkswarow": [ 10534 ],
	"hoarr": [ 8703 ],
	"homtht": [ 8763 ],
	"hookleftarrow": [ 8617 ],
	"hookrightarrow": [ 8618 ],
	"Hopf": [ 8461 ],
	"hopf": [ 120153 ],
	"horbar": [ 8213 ],
	"HorizontalLine": [ 9472 ],
	"Hscr": [ 8459 ],
	"hscr": [ 119997 ],
	"hslash": [ 8463 ],
	"Hstrok": [ 294 ],
	"hstrok": [ 295 ],
	"HumpDownHump": [ 8782 ],
	"HumpEqual": [ 8783 ],
	"hybull": [ 8259 ],
	"hyphen": [ 8208 ],
	"Iacute": [ 205 ],
	"iacute": [ 237 ],
	"ic": [ 8291 ],
	"Icirc": [ 206 ],
	"icirc": [ 238 ],
	"Icy": [ 1048 ],
	"icy": [ 1080 ],
	"Idot": [ 304 ],
	"IEcy": [ 1045 ],
	"iecy": [ 1077 ],
	"iexcl": [ 161 ],
	"iff": [ 8660 ],
	"Ifr": [ 8465 ],
	"ifr": [ 120102 ],
	"Igrave": [ 204 ],
	"igrave": [ 236 ],
	"ii": [ 8520 ],
	"iiiint": [ 10764 ],
	"iiint": [ 8749 ],
	"iinfin": [ 10716 ],
	"iiota": [ 8489 ],
	"IJlig": [ 306 ],
	"ijlig": [ 307 ],
	"Im": [ 8465 ],
	"Imacr": [ 298 ],
	"imacr": [ 299 ],
	"image": [ 8465 ],
	"ImaginaryI": [ 8520 ],
	"imagline": [ 8464 ],
	"imagpart": [ 8465 ],
	"imath": [ 305 ],
	"imof": [ 8887 ],
	"imped": [ 437 ],
	"Implies": [ 8658 ],
	"in": [ 8712 ],
	"incare": [ 8453 ],
	"infin": [ 8734 ],
	"infintie": [ 10717 ],
	"inodot": [ 305 ],
	"Int": [ 8748 ],
	"int": [ 8747 ],
	"intcal": [ 8890 ],
	"integers": [ 8484 ],
	"Integral": [ 8747 ],
	"intercal": [ 8890 ],
	"Intersection": [ 8898 ],
	"intlarhk": [ 10775 ],
	"intprod": [ 10812 ],
	"InvisibleComma": [ 8291 ],
	"InvisibleTimes": [ 8290 ],
	"IOcy": [ 1025 ],
	"iocy": [ 1105 ],
	"Iogon": [ 302 ],
	"iogon": [ 303 ],
	"Iopf": [ 120128 ],
	"iopf": [ 120154 ],
	"Iota": [ 921 ],
	"iota": [ 953 ],
	"iprod": [ 10812 ],
	"iquest": [ 191 ],
	"Iscr": [ 8464 ],
	"iscr": [ 119998 ],
	"isin": [ 8712 ],
	"isindot": [ 8949 ],
	"isinE": [ 8953 ],
	"isins": [ 8948 ],
	"isinsv": [ 8947 ],
	"isinv": [ 8712 ],
	"it": [ 8290 ],
	"Itilde": [ 296 ],
	"itilde": [ 297 ],
	"Iukcy": [ 1030 ],
	"iukcy": [ 1110 ],
	"Iuml": [ 207 ],
	"iuml": [ 239 ],
	"Jcirc": [ 308 ],
	"jcirc": [ 309 ],
	"Jcy": [ 1049 ],
	"jcy": [ 1081 ],
	"Jfr": [ 120077 ],
	"jfr": [ 120103 ],
	"jmath": [ 567 ],
	"Jopf": [ 120129 ],
	"jopf": [ 120155 ],
	"Jscr": [ 119973 ],
	"jscr": [ 119999 ],
	"Jsercy": [ 1032 ],
	"jsercy": [ 1112 ],
	"Jukcy": [ 1028 ],
	"jukcy": [ 1108 ],
	"Kappa": [ 922 ],
	"kappa": [ 954 ],
	"kappav": [ 1008 ],
	"Kcedil": [ 310 ],
	"kcedil": [ 311 ],
	"Kcy": [ 1050 ],
	"kcy": [ 1082 ],
	"Kfr": [ 120078 ],
	"kfr": [ 120104 ],
	"kgreen": [ 312 ],
	"KHcy": [ 1061 ],
	"khcy": [ 1093 ],
	"KJcy": [ 1036 ],
	"kjcy": [ 1116 ],
	"Kopf": [ 120130 ],
	"kopf": [ 120156 ],
	"Kscr": [ 119974 ],
	"kscr": [ 120000 ],
	"lAarr": [ 8666 ],
	"Lacute": [ 313 ],
	"lacute": [ 314 ],
	"laemptyv": [ 10676 ],
	"lagran": [ 8466 ],
	"Lambda": [ 923 ],
	"lambda": [ 955 ],
	"Lang": [ 10218 ],
	"lang": [ 10216 ],
	"langd": [ 10641 ],
	"langle": [ 10216 ],
	"lap": [ 10885 ],
	"Laplacetrf": [ 8466 ],
	"laquo": [ 171 ],
	"Larr": [ 8606 ],
	"lArr": [ 8656 ],
	"larr": [ 8592 ],
	"larrb": [ 8676 ],
	"larrbfs": [ 10527 ],
	"larrfs": [ 10525 ],
	"larrhk": [ 8617 ],
	"larrlp": [ 8619 ],
	"larrpl": [ 10553 ],
	"larrsim": [ 10611 ],
	"larrtl": [ 8610 ],
	"lat": [ 10923 ],
	"lAtail": [ 10523 ],
	"latail": [ 10521 ],
	"late": [ 10925 ],
	"lates": [ 10925, 65024 ],
	"lBarr": [ 10510 ],
	"lbarr": [ 10508 ],
	"lbbrk": [ 10098 ],
	"lbrace": [ 123 ],
	"lbrack": [ 91 ],
	"lbrke": [ 10635 ],
	"lbrksld": [ 10639 ],
	"lbrkslu": [ 10637 ],
	"Lcaron": [ 317 ],
	"lcaron": [ 318 ],
	"Lcedil": [ 315 ],
	"lcedil": [ 316 ],
	"lceil": [ 8968 ],
	"lcub": [ 123 ],
	"Lcy": [ 1051 ],
	"lcy": [ 1083 ],
	"ldca": [ 10550 ],
	"ldquo": [ 8220 ],
	"ldquor": [ 8222 ],
	"ldrdhar": [ 10599 ],
	"ldrushar": [ 10571 ],
	"ldsh": [ 8626 ],
	"lE": [ 8806 ],
	"le": [ 8804 ],
	"LeftAngleBracket": [ 10216 ],
	"LeftArrow": [ 8592 ],
	"Leftarrow": [ 8656 ],
	"leftarrow": [ 8592 ],
	"LeftArrowBar": [ 8676 ],
	"LeftArrowRightArrow": [ 8646 ],
	"leftarrowtail": [ 8610 ],
	"LeftCeiling": [ 8968 ],
	"LeftDoubleBracket": [ 10214 ],
	"LeftDownTeeVector": [ 10593 ],
	"LeftDownVector": [ 8643 ],
	"LeftDownVectorBar": [ 10585 ],
	"LeftFloor": [ 8970 ],
	"leftharpoondown": [ 8637 ],
	"leftharpoonup": [ 8636 ],
	"leftleftarrows": [ 8647 ],
	"LeftRightArrow": [ 8596 ],
	"Leftrightarrow": [ 8660 ],
	"leftrightarrow": [ 8596 ],
	"leftrightarrows": [ 8646 ],
	"leftrightharpoons": [ 8651 ],
	"leftrightsquigarrow": [ 8621 ],
	"LeftRightVector": [ 10574 ],
	"LeftTee": [ 8867 ],
	"LeftTeeArrow": [ 8612 ],
	"LeftTeeVector": [ 10586 ],
	"leftthreetimes": [ 8907 ],
	"LeftTriangle": [ 8882 ],
	"LeftTriangleBar": [ 10703 ],
	"LeftTriangleEqual": [ 8884 ],
	"LeftUpDownVector": [ 10577 ],
	"LeftUpTeeVector": [ 10592 ],
	"LeftUpVector": [ 8639 ],
	"LeftUpVectorBar": [ 10584 ],
	"LeftVector": [ 8636 ],
	"LeftVectorBar": [ 10578 ],
	"lEg": [ 10891 ],
	"leg": [ 8922 ],
	"leq": [ 8804 ],
	"leqq": [ 8806 ],
	"leqslant": [ 10877 ],
	"les": [ 10877 ],
	"lescc": [ 10920 ],
	"lesdot": [ 10879 ],
	"lesdoto": [ 10881 ],
	"lesdotor": [ 10883 ],
	"lesg": [ 8922, 65024 ],
	"lesges": [ 10899 ],
	"lessapprox": [ 10885 ],
	"lessdot": [ 8918 ],
	"lesseqgtr": [ 8922 ],
	"lesseqqgtr": [ 10891 ],
	"LessEqualGreater": [ 8922 ],
	"LessFullEqual": [ 8806 ],
	"LessGreater": [ 8822 ],
	"lessgtr": [ 8822 ],
	"LessLess": [ 10913 ],
	"lesssim": [ 8818 ],
	"LessSlantEqual": [ 10877 ],
	"LessTilde": [ 8818 ],
	"lfisht": [ 10620 ],
	"lfloor": [ 8970 ],
	"Lfr": [ 120079 ],
	"lfr": [ 120105 ],
	"lg": [ 8822 ],
	"lgE": [ 10897 ],
	"lHar": [ 10594 ],
	"lhard": [ 8637 ],
	"lharu": [ 8636 ],
	"lharul": [ 10602 ],
	"lhblk": [ 9604 ],
	"LJcy": [ 1033 ],
	"ljcy": [ 1113 ],
	"Ll": [ 8920 ],
	"ll": [ 8810 ],
	"llarr": [ 8647 ],
	"llcorner": [ 8990 ],
	"Lleftarrow": [ 8666 ],
	"llhard": [ 10603 ],
	"lltri": [ 9722 ],
	"Lmidot": [ 319 ],
	"lmidot": [ 320 ],
	"lmoust": [ 9136 ],
	"lmoustache": [ 9136 ],
	"lnap": [ 10889 ],
	"lnapprox": [ 10889 ],
	"lnE": [ 8808 ],
	"lne": [ 10887 ],
	"lneq": [ 10887 ],
	"lneqq": [ 8808 ],
	"lnsim": [ 8934 ],
	"loang": [ 10220 ],
	"loarr": [ 8701 ],
	"lobrk": [ 10214 ],
	"LongLeftArrow": [ 10229 ],
	"Longleftarrow": [ 10232 ],
	"longleftarrow": [ 10229 ],
	"LongLeftRightArrow": [ 10231 ],
	"Longleftrightarrow": [ 10234 ],
	"longleftrightarrow": [ 10231 ],
	"longmapsto": [ 10236 ],
	"LongRightArrow": [ 10230 ],
	"Longrightarrow": [ 10233 ],
	"longrightarrow": [ 10230 ],
	"looparrowleft": [ 8619 ],
	"looparrowright": [ 8620 ],
	"lopar": [ 10629 ],
	"Lopf": [ 120131 ],
	"lopf": [ 120157 ],
	"loplus": [ 10797 ],
	"lotimes": [ 10804 ],
	"lowast": [ 8727 ],
	"lowbar": [ 95 ],
	"LowerLeftArrow": [ 8601 ],
	"LowerRightArrow": [ 8600 ],
	"loz": [ 9674 ],
	"lozenge": [ 9674 ],
	"lozf": [ 10731 ],
	"lpar": [ 40 ],
	"lparlt": [ 10643 ],
	"lrarr": [ 8646 ],
	"lrcorner": [ 8991 ],
	"lrhar": [ 8651 ],
	"lrhard": [ 10605 ],
	"lrm": [ 8206 ],
	"lrtri": [ 8895 ],
	"lsaquo": [ 8249 ],
	"Lscr": [ 8466 ],
	"lscr": [ 120001 ],
	"Lsh": [ 8624 ],
	"lsh": [ 8624 ],
	"lsim": [ 8818 ],
	"lsime": [ 10893 ],
	"lsimg": [ 10895 ],
	"lsqb": [ 91 ],
	"lsquo": [ 8216 ],
	"lsquor": [ 8218 ],
	"Lstrok": [ 321 ],
	"lstrok": [ 322 ],
	"LT": [ 60 ],
	"Lt": [ 8810 ],
	"lt": [ 60 ],
	"ltcc": [ 10918 ],
	"ltcir": [ 10873 ],
	"ltdot": [ 8918 ],
	"lthree": [ 8907 ],
	"ltimes": [ 8905 ],
	"ltlarr": [ 10614 ],
	"ltquest": [ 10875 ],
	"ltri": [ 9667 ],
	"ltrie": [ 8884 ],
	"ltrif": [ 9666 ],
	"ltrPar": [ 10646 ],
	"lurdshar": [ 10570 ],
	"luruhar": [ 10598 ],
	"lvertneqq": [ 8808, 65024 ],
	"lvnE": [ 8808, 65024 ],
	"macr": [ 175 ],
	"male": [ 9794 ],
	"malt": [ 10016 ],
	"maltese": [ 10016 ],
	"Map": [ 10501 ],
	"map": [ 8614 ],
	"mapsto": [ 8614 ],
	"mapstodown": [ 8615 ],
	"mapstoleft": [ 8612 ],
	"mapstoup": [ 8613 ],
	"marker": [ 9646 ],
	"mcomma": [ 10793 ],
	"Mcy": [ 1052 ],
	"mcy": [ 1084 ],
	"mdash": [ 8212 ],
	"mDDot": [ 8762 ],
	"measuredangle": [ 8737 ],
	"MediumSpace": [ 8287 ],
	"Mellintrf": [ 8499 ],
	"Mfr": [ 120080 ],
	"mfr": [ 120106 ],
	"mho": [ 8487 ],
	"micro": [ 181 ],
	"mid": [ 8739 ],
	"midast": [ 42 ],
	"midcir": [ 10992 ],
	"middot": [ 183 ],
	"minus": [ 8722 ],
	"minusb": [ 8863 ],
	"minusd": [ 8760 ],
	"minusdu": [ 10794 ],
	"MinusPlus": [ 8723 ],
	"mlcp": [ 10971 ],
	"mldr": [ 8230 ],
	"mnplus": [ 8723 ],
	"models": [ 8871 ],
	"Mopf": [ 120132 ],
	"mopf": [ 120158 ],
	"mp": [ 8723 ],
	"Mscr": [ 8499 ],
	"mscr": [ 120002 ],
	"mstpos": [ 8766 ],
	"Mu": [ 924 ],
	"mu": [ 956 ],
	"multimap": [ 8888 ],
	"mumap": [ 8888 ],
	"nabla": [ 8711 ],
	"Nacute": [ 323 ],
	"nacute": [ 324 ],
	"nang": [ 8736, 8402 ],
	"nap": [ 8777 ],
	"napE": [ 10864, 824 ],
	"napid": [ 8779, 824 ],
	"napos": [ 329 ],
	"napprox": [ 8777 ],
	"natur": [ 9838 ],
	"natural": [ 9838 ],
	"naturals": [ 8469 ],
	"nbsp": [ 160 ],
	"nbump": [ 8782, 824 ],
	"nbumpe": [ 8783, 824 ],
	"ncap": [ 10819 ],
	"Ncaron": [ 327 ],
	"ncaron": [ 328 ],
	"Ncedil": [ 325 ],
	"ncedil": [ 326 ],
	"ncong": [ 8775 ],
	"ncongdot": [ 10861, 824 ],
	"ncup": [ 10818 ],
	"Ncy": [ 1053 ],
	"ncy": [ 1085 ],
	"ndash": [ 8211 ],
	"ne": [ 8800 ],
	"nearhk": [ 10532 ],
	"neArr": [ 8663 ],
	"nearr": [ 8599 ],
	"nearrow": [ 8599 ],
	"nedot": [ 8784, 824 ],
	"NegativeMediumSpace": [ 8203 ],
	"NegativeThickSpace": [ 8203 ],
	"NegativeThinSpace": [ 8203 ],
	"NegativeVeryThinSpace": [ 8203 ],
	"nequiv": [ 8802 ],
	"nesear": [ 10536 ],
	"nesim": [ 8770, 824 ],
	"NestedGreaterGreater": [ 8811 ],
	"NestedLessLess": [ 8810 ],
	"NewLine": [ 10 ],
	"nexist": [ 8708 ],
	"nexists": [ 8708 ],
	"Nfr": [ 120081 ],
	"nfr": [ 120107 ],
	"ngE": [ 8807, 824 ],
	"nge": [ 8817 ],
	"ngeq": [ 8817 ],
	"ngeqq": [ 8807, 824 ],
	"ngeqslant": [ 10878, 824 ],
	"nges": [ 10878, 824 ],
	"nGg": [ 8921, 824 ],
	"ngsim": [ 8821 ],
	"nGt": [ 8811, 8402 ],
	"ngt": [ 8815 ],
	"ngtr": [ 8815 ],
	"nGtv": [ 8811, 824 ],
	"nhArr": [ 8654 ],
	"nharr": [ 8622 ],
	"nhpar": [ 10994 ],
	"ni": [ 8715 ],
	"nis": [ 8956 ],
	"nisd": [ 8954 ],
	"niv": [ 8715 ],
	"NJcy": [ 1034 ],
	"njcy": [ 1114 ],
	"nlArr": [ 8653 ],
	"nlarr": [ 8602 ],
	"nldr": [ 8229 ],
	"nlE": [ 8806, 824 ],
	"nle": [ 8816 ],
	"nLeftarrow": [ 8653 ],
	"nleftarrow": [ 8602 ],
	"nLeftrightarrow": [ 8654 ],
	"nleftrightarrow": [ 8622 ],
	"nleq": [ 8816 ],
	"nleqq": [ 8806, 824 ],
	"nleqslant": [ 10877, 824 ],
	"nles": [ 10877, 824 ],
	"nless": [ 8814 ],
	"nLl": [ 8920, 824 ],
	"nlsim": [ 8820 ],
	"nLt": [ 8810, 8402 ],
	"nlt": [ 8814 ],
	"nltri": [ 8938 ],
	"nltrie": [ 8940 ],
	"nLtv": [ 8810, 824 ],
	"nmid": [ 8740 ],
	"NoBreak": [ 8288 ],
	"NonBreakingSpace": [ 160 ],
	"Nopf": [ 8469 ],
	"nopf": [ 120159 ],
	"Not": [ 10988 ],
	"not": [ 172 ],
	"NotCongruent": [ 8802 ],
	"NotCupCap": [ 8813 ],
	"NotDoubleVerticalBar": [ 8742 ],
	"NotElement": [ 8713 ],
	"NotEqual": [ 8800 ],
	"NotEqualTilde": [ 8770, 824 ],
	"NotExists": [ 8708 ],
	"NotGreater": [ 8815 ],
	"NotGreaterEqual": [ 8817 ],
	"NotGreaterFullEqual": [ 8807, 824 ],
	"NotGreaterGreater": [ 8811, 824 ],
	"NotGreaterLess": [ 8825 ],
	"NotGreaterSlantEqual": [ 10878, 824 ],
	"NotGreaterTilde": [ 8821 ],
	"NotHumpDownHump": [ 8782, 824 ],
	"NotHumpEqual": [ 8783, 824 ],
	"notin": [ 8713 ],
	"notindot": [ 8949, 824 ],
	"notinE": [ 8953, 824 ],
	"notinva": [ 8713 ],
	"notinvb": [ 8951 ],
	"notinvc": [ 8950 ],
	"NotLeftTriangle": [ 8938 ],
	"NotLeftTriangleBar": [ 10703, 824 ],
	"NotLeftTriangleEqual": [ 8940 ],
	"NotLess": [ 8814 ],
	"NotLessEqual": [ 8816 ],
	"NotLessGreater": [ 8824 ],
	"NotLessLess": [ 8810, 824 ],
	"NotLessSlantEqual": [ 10877, 824 ],
	"NotLessTilde": [ 8820 ],
	"NotNestedGreaterGreater": [ 10914, 824 ],
	"NotNestedLessLess": [ 10913, 824 ],
	"notni": [ 8716 ],
	"notniva": [ 8716 ],
	"notnivb": [ 8958 ],
	"notnivc": [ 8957 ],
	"NotPrecedes": [ 8832 ],
	"NotPrecedesEqual": [ 10927, 824 ],
	"NotPrecedesSlantEqual": [ 8928 ],
	"NotReverseElement": [ 8716 ],
	"NotRightTriangle": [ 8939 ],
	"NotRightTriangleBar": [ 10704, 824 ],
	"NotRightTriangleEqual": [ 8941 ],
	"NotSquareSubset": [ 8847, 824 ],
	"NotSquareSubsetEqual": [ 8930 ],
	"NotSquareSuperset": [ 8848, 824 ],
	"NotSquareSupersetEqual": [ 8931 ],
	"NotSubset": [ 8834, 8402 ],
	"NotSubsetEqual": [ 8840 ],
	"NotSucceeds": [ 8833 ],
	"NotSucceedsEqual": [ 10928, 824 ],
	"NotSucceedsSlantEqual": [ 8929 ],
	"NotSucceedsTilde": [ 8831, 824 ],
	"NotSuperset": [ 8835, 8402 ],
	"NotSupersetEqual": [ 8841 ],
	"NotTilde": [ 8769 ],
	"NotTildeEqual": [ 8772 ],
	"NotTildeFullEqual": [ 8775 ],
	"NotTildeTilde": [ 8777 ],
	"NotVerticalBar": [ 8740 ],
	"npar": [ 8742 ],
	"nparallel": [ 8742 ],
	"nparsl": [ 11005, 8421 ],
	"npart": [ 8706, 824 ],
	"npolint": [ 10772 ],
	"npr": [ 8832 ],
	"nprcue": [ 8928 ],
	"npre": [ 10927, 824 ],
	"nprec": [ 8832 ],
	"npreceq": [ 10927, 824 ],
	"nrArr": [ 8655 ],
	"nrarr": [ 8603 ],
	"nrarrc": [ 10547, 824 ],
	"nrarrw": [ 8605, 824 ],
	"nRightarrow": [ 8655 ],
	"nrightarrow": [ 8603 ],
	"nrtri": [ 8939 ],
	"nrtrie": [ 8941 ],
	"nsc": [ 8833 ],
	"nsccue": [ 8929 ],
	"nsce": [ 10928, 824 ],
	"Nscr": [ 119977 ],
	"nscr": [ 120003 ],
	"nshortmid": [ 8740 ],
	"nshortparallel": [ 8742 ],
	"nsim": [ 8769 ],
	"nsime": [ 8772 ],
	"nsimeq": [ 8772 ],
	"nsmid": [ 8740 ],
	"nspar": [ 8742 ],
	"nsqsube": [ 8930 ],
	"nsqsupe": [ 8931 ],
	"nsub": [ 8836 ],
	"nsubE": [ 10949, 824 ],
	"nsube": [ 8840 ],
	"nsubset": [ 8834, 8402 ],
	"nsubseteq": [ 8840 ],
	"nsubseteqq": [ 10949, 824 ],
	"nsucc": [ 8833 ],
	"nsucceq": [ 10928, 824 ],
	"nsup": [ 8837 ],
	"nsupE": [ 10950, 824 ],
	"nsupe": [ 8841 ],
	"nsupset": [ 8835, 8402 ],
	"nsupseteq": [ 8841 ],
	"nsupseteqq": [ 10950, 824 ],
	"ntgl": [ 8825 ],
	"Ntilde": [ 209 ],
	"ntilde": [ 241 ],
	"ntlg": [ 8824 ],
	"ntriangleleft": [ 8938 ],
	"ntrianglelefteq": [ 8940 ],
	"ntriangleright": [ 8939 ],
	"ntrianglerighteq": [ 8941 ],
	"Nu": [ 925 ],
	"nu": [ 957 ],
	"num": [ 35 ],
	"numero": [ 8470 ],
	"numsp": [ 8199 ],
	"nvap": [ 8781, 8402 ],
	"nVDash": [ 8879 ],
	"nVdash": [ 8878 ],
	"nvDash": [ 8877 ],
	"nvdash": [ 8876 ],
	"nvge": [ 8805, 8402 ],
	"nvgt": [ 62, 8402 ],
	"nvHarr": [ 10500 ],
	"nvinfin": [ 10718 ],
	"nvlArr": [ 10498 ],
	"nvle": [ 8804, 8402 ],
	"nvlt": [ 60, 8402 ],
	"nvltrie": [ 8884, 8402 ],
	"nvrArr": [ 10499 ],
	"nvrtrie": [ 8885, 8402 ],
	"nvsim": [ 8764, 8402 ],
	"nwarhk": [ 10531 ],
	"nwArr": [ 8662 ],
	"nwarr": [ 8598 ],
	"nwarrow": [ 8598 ],
	"nwnear": [ 10535 ],
	"Oacute": [ 211 ],
	"oacute": [ 243 ],
	"oast": [ 8859 ],
	"ocir": [ 8858 ],
	"Ocirc": [ 212 ],
	"ocirc": [ 244 ],
	"Ocy": [ 1054 ],
	"ocy": [ 1086 ],
	"odash": [ 8861 ],
	"Odblac": [ 336 ],
	"odblac": [ 337 ],
	"odiv": [ 10808 ],
	"odot": [ 8857 ],
	"odsold": [ 10684 ],
	"OElig": [ 338 ],
	"oelig": [ 339 ],
	"ofcir": [ 10687 ],
	"Ofr": [ 120082 ],
	"ofr": [ 120108 ],
	"ogon": [ 731 ],
	"Ograve": [ 210 ],
	"ograve": [ 242 ],
	"ogt": [ 10689 ],
	"ohbar": [ 10677 ],
	"ohm": [ 937 ],
	"oint": [ 8750 ],
	"olarr": [ 8634 ],
	"olcir": [ 10686 ],
	"olcross": [ 10683 ],
	"oline": [ 8254 ],
	"olt": [ 10688 ],
	"Omacr": [ 332 ],
	"omacr": [ 333 ],
	"Omega": [ 937 ],
	"omega": [ 969 ],
	"Omicron": [ 927 ],
	"omicron": [ 959 ],
	"omid": [ 10678 ],
	"ominus": [ 8854 ],
	"Oopf": [ 120134 ],
	"oopf": [ 120160 ],
	"opar": [ 10679 ],
	"OpenCurlyDoubleQuote": [ 8220 ],
	"OpenCurlyQuote": [ 8216 ],
	"operp": [ 10681 ],
	"oplus": [ 8853 ],
	"Or": [ 10836 ],
	"or": [ 8744 ],
	"orarr": [ 8635 ],
	"ord": [ 10845 ],
	"order": [ 8500 ],
	"orderof": [ 8500 ],
	"ordf": [ 170 ],
	"ordm": [ 186 ],
	"origof": [ 8886 ],
	"oror": [ 10838 ],
	"orslope": [ 10839 ],
	"orv": [ 10843 ],
	"oS": [ 9416 ],
	"Oscr": [ 119978 ],
	"oscr": [ 8500 ],
	"Oslash": [ 216 ],
	"oslash": [ 248 ],
	"osol": [ 8856 ],
	"Otilde": [ 213 ],
	"otilde": [ 245 ],
	"Otimes": [ 10807 ],
	"otimes": [ 8855 ],
	"otimesas": [ 10806 ],
	"Ouml": [ 214 ],
	"ouml": [ 246 ],
	"ovbar": [ 9021 ],
	"OverBar": [ 8254 ],
	"OverBrace": [ 9182 ],
	"OverBracket": [ 9140 ],
	"OverParenthesis": [ 9180 ],
	"par": [ 8741 ],
	"para": [ 182 ],
	"parallel": [ 8741 ],
	"parsim": [ 10995 ],
	"parsl": [ 11005 ],
	"part": [ 8706 ],
	"PartialD": [ 8706 ],
	"Pcy": [ 1055 ],
	"pcy": [ 1087 ],
	"percnt": [ 37 ],
	"period": [ 46 ],
	"permil": [ 8240 ],
	"perp": [ 8869 ],
	"pertenk": [ 8241 ],
	"Pfr": [ 120083 ],
	"pfr": [ 120109 ],
	"Phi": [ 934 ],
	"phi": [ 966 ],
	"phiv": [ 981 ],
	"phmmat": [ 8499 ],
	"phone": [ 9742 ],
	"Pi": [ 928 ],
	"pi": [ 960 ],
	"pitchfork": [ 8916 ],
	"piv": [ 982 ],
	"planck": [ 8463 ],
	"planckh": [ 8462 ],
	"plankv": [ 8463 ],
	"plus": [ 43 ],
	"plusacir": [ 10787 ],
	"plusb": [ 8862 ],
	"pluscir": [ 10786 ],
	"plusdo": [ 8724 ],
	"plusdu": [ 10789 ],
	"pluse": [ 10866 ],
	"PlusMinus": [ 177 ],
	"plusmn": [ 177 ],
	"plussim": [ 10790 ],
	"plustwo": [ 10791 ],
	"pm": [ 177 ],
	"Poincareplane": [ 8460 ],
	"pointint": [ 10773 ],
	"Popf": [ 8473 ],
	"popf": [ 120161 ],
	"pound": [ 163 ],
	"Pr": [ 10939 ],
	"pr": [ 8826 ],
	"prap": [ 10935 ],
	"prcue": [ 8828 ],
	"prE": [ 10931 ],
	"pre": [ 10927 ],
	"prec": [ 8826 ],
	"precapprox": [ 10935 ],
	"preccurlyeq": [ 8828 ],
	"Precedes": [ 8826 ],
	"PrecedesEqual": [ 10927 ],
	"PrecedesSlantEqual": [ 8828 ],
	"PrecedesTilde": [ 8830 ],
	"preceq": [ 10927 ],
	"precnapprox": [ 10937 ],
	"precneqq": [ 10933 ],
	"precnsim": [ 8936 ],
	"precsim": [ 8830 ],
	"Prime": [ 8243 ],
	"prime": [ 8242 ],
	"primes": [ 8473 ],
	"prnap": [ 10937 ],
	"prnE": [ 10933 ],
	"prnsim": [ 8936 ],
	"prod": [ 8719 ],
	"Product": [ 8719 ],
	"profalar": [ 9006 ],
	"profline": [ 8978 ],
	"profsurf": [ 8979 ],
	"prop": [ 8733 ],
	"Proportion": [ 8759 ],
	"Proportional": [ 8733 ],
	"propto": [ 8733 ],
	"prsim": [ 8830 ],
	"prurel": [ 8880 ],
	"Pscr": [ 119979 ],
	"pscr": [ 120005 ],
	"Psi": [ 936 ],
	"psi": [ 968 ],
	"puncsp": [ 8200 ],
	"Qfr": [ 120084 ],
	"qfr": [ 120110 ],
	"qint": [ 10764 ],
	"Qopf": [ 8474 ],
	"qopf": [ 120162 ],
	"qprime": [ 8279 ],
	"Qscr": [ 119980 ],
	"qscr": [ 120006 ],
	"quaternions": [ 8461 ],
	"quatint": [ 10774 ],
	"quest": [ 63 ],
	"questeq": [ 8799 ],
	"QUOT": [ 34 ],
	"quot": [ 34 ],
	"rAarr": [ 8667 ],
	"race": [ 8765, 817 ],
	"Racute": [ 340 ],
	"racute": [ 341 ],
	"radic": [ 8730 ],
	"raemptyv": [ 10675 ],
	"Rang": [ 10219 ],
	"rang": [ 10217 ],
	"rangd": [ 10642 ],
	"range": [ 10661 ],
	"rangle": [ 10217 ],
	"raquo": [ 187 ],
	"Rarr": [ 8608 ],
	"rArr": [ 8658 ],
	"rarr": [ 8594 ],
	"rarrap": [ 10613 ],
	"rarrb": [ 8677 ],
	"rarrbfs": [ 10528 ],
	"rarrc": [ 10547 ],
	"rarrfs": [ 10526 ],
	"rarrhk": [ 8618 ],
	"rarrlp": [ 8620 ],
	"rarrpl": [ 10565 ],
	"rarrsim": [ 10612 ],
	"Rarrtl": [ 10518 ],
	"rarrtl": [ 8611 ],
	"rarrw": [ 8605 ],
	"rAtail": [ 10524 ],
	"ratail": [ 10522 ],
	"ratio": [ 8758 ],
	"rationals": [ 8474 ],
	"RBarr": [ 10512 ],
	"rBarr": [ 10511 ],
	"rbarr": [ 10509 ],
	"rbbrk": [ 10099 ],
	"rbrace": [ 125 ],
	"rbrack": [ 93 ],
	"rbrke": [ 10636 ],
	"rbrksld": [ 10638 ],
	"rbrkslu": [ 10640 ],
	"Rcaron": [ 344 ],
	"rcaron": [ 345 ],
	"Rcedil": [ 342 ],
	"rcedil": [ 343 ],
	"rceil": [ 8969 ],
	"rcub": [ 125 ],
	"Rcy": [ 1056 ],
	"rcy": [ 1088 ],
	"rdca": [ 10551 ],
	"rdldhar": [ 10601 ],
	"rdquo": [ 8221 ],
	"rdquor": [ 8221 ],
	"rdsh": [ 8627 ],
	"Re": [ 8476 ],
	"real": [ 8476 ],
	"realine": [ 8475 ],
	"realpart": [ 8476 ],
	"reals": [ 8477 ],
	"rect": [ 9645 ],
	"REG": [ 174 ],
	"reg": [ 174 ],
	"ReverseElement": [ 8715 ],
	"ReverseEquilibrium": [ 8651 ],
	"ReverseUpEquilibrium": [ 10607 ],
	"rfisht": [ 10621 ],
	"rfloor": [ 8971 ],
	"Rfr": [ 8476 ],
	"rfr": [ 120111 ],
	"rHar": [ 10596 ],
	"rhard": [ 8641 ],
	"rharu": [ 8640 ],
	"rharul": [ 10604 ],
	"Rho": [ 929 ],
	"rho": [ 961 ],
	"rhov": [ 1009 ],
	"RightAngleBracket": [ 10217 ],
	"RightArrow": [ 8594 ],
	"Rightarrow": [ 8658 ],
	"rightarrow": [ 8594 ],
	"RightArrowBar": [ 8677 ],
	"RightArrowLeftArrow": [ 8644 ],
	"rightarrowtail": [ 8611 ],
	"RightCeiling": [ 8969 ],
	"RightDoubleBracket": [ 10215 ],
	"RightDownTeeVector": [ 10589 ],
	"RightDownVector": [ 8642 ],
	"RightDownVectorBar": [ 10581 ],
	"RightFloor": [ 8971 ],
	"rightharpoondown": [ 8641 ],
	"rightharpoonup": [ 8640 ],
	"rightleftarrows": [ 8644 ],
	"rightleftharpoons": [ 8652 ],
	"rightrightarrows": [ 8649 ],
	"rightsquigarrow": [ 8605 ],
	"RightTee": [ 8866 ],
	"RightTeeArrow": [ 8614 ],
	"RightTeeVector": [ 10587 ],
	"rightthreetimes": [ 8908 ],
	"RightTriangle": [ 8883 ],
	"RightTriangleBar": [ 10704 ],
	"RightTriangleEqual": [ 8885 ],
	"RightUpDownVector": [ 10575 ],
	"RightUpTeeVector": [ 10588 ],
	"RightUpVector": [ 8638 ],
	"RightUpVectorBar": [ 10580 ],
	"RightVector": [ 8640 ],
	"RightVectorBar": [ 10579 ],
	"ring": [ 730 ],
	"risingdotseq": [ 8787 ],
	"rlarr": [ 8644 ],
	"rlhar": [ 8652 ],
	"rlm": [ 8207 ],
	"rmoust": [ 9137 ],
	"rmoustache": [ 9137 ],
	"rnmid": [ 10990 ],
	"roang": [ 10221 ],
	"roarr": [ 8702 ],
	"robrk": [ 10215 ],
	"ropar": [ 10630 ],
	"Ropf": [ 8477 ],
	"ropf": [ 120163 ],
	"roplus": [ 10798 ],
	"rotimes": [ 10805 ],
	"RoundImplies": [ 10608 ],
	"rpar": [ 41 ],
	"rpargt": [ 10644 ],
	"rppolint": [ 10770 ],
	"rrarr": [ 8649 ],
	"Rrightarrow": [ 8667 ],
	"rsaquo": [ 8250 ],
	"Rscr": [ 8475 ],
	"rscr": [ 120007 ],
	"Rsh": [ 8625 ],
	"rsh": [ 8625 ],
	"rsqb": [ 93 ],
	"rsquo": [ 8217 ],
	"rsquor": [ 8217 ],
	"rthree": [ 8908 ],
	"rtimes": [ 8906 ],
	"rtri": [ 9657 ],
	"rtrie": [ 8885 ],
	"rtrif": [ 9656 ],
	"rtriltri": [ 10702 ],
	"RuleDelayed": [ 10740 ],
	"ruluhar": [ 10600 ],
	"rx": [ 8478 ],
	"Sacute": [ 346 ],
	"sacute": [ 347 ],
	"sbquo": [ 8218 ],
	"Sc": [ 10940 ],
	"sc": [ 8827 ],
	"scap": [ 10936 ],
	"Scaron": [ 352 ],
	"scaron": [ 353 ],
	"sccue": [ 8829 ],
	"scE": [ 10932 ],
	"sce": [ 10928 ],
	"Scedil": [ 350 ],
	"scedil": [ 351 ],
	"Scirc": [ 348 ],
	"scirc": [ 349 ],
	"scnap": [ 10938 ],
	"scnE": [ 10934 ],
	"scnsim": [ 8937 ],
	"scpolint": [ 10771 ],
	"scsim": [ 8831 ],
	"Scy": [ 1057 ],
	"scy": [ 1089 ],
	"sdot": [ 8901 ],
	"sdotb": [ 8865 ],
	"sdote": [ 10854 ],
	"searhk": [ 10533 ],
	"seArr": [ 8664 ],
	"searr": [ 8600 ],
	"searrow": [ 8600 ],
	"sect": [ 167 ],
	"semi": [ 59 ],
	"seswar": [ 10537 ],
	"setminus": [ 8726 ],
	"setmn": [ 8726 ],
	"sext": [ 10038 ],
	"Sfr": [ 120086 ],
	"sfr": [ 120112 ],
	"sfrown": [ 8994 ],
	"sharp": [ 9839 ],
	"SHCHcy": [ 1065 ],
	"shchcy": [ 1097 ],
	"SHcy": [ 1064 ],
	"shcy": [ 1096 ],
	"ShortDownArrow": [ 8595 ],
	"ShortLeftArrow": [ 8592 ],
	"shortmid": [ 8739 ],
	"shortparallel": [ 8741 ],
	"ShortRightArrow": [ 8594 ],
	"ShortUpArrow": [ 8593 ],
	"shy": [ 173 ],
	"Sigma": [ 931 ],
	"sigma": [ 963 ],
	"sigmaf": [ 962 ],
	"sigmav": [ 962 ],
	"sim": [ 8764 ],
	"simdot": [ 10858 ],
	"sime": [ 8771 ],
	"simeq": [ 8771 ],
	"simg": [ 10910 ],
	"simgE": [ 10912 ],
	"siml": [ 10909 ],
	"simlE": [ 10911 ],
	"simne": [ 8774 ],
	"simplus": [ 10788 ],
	"simrarr": [ 10610 ],
	"slarr": [ 8592 ],
	"SmallCircle": [ 8728 ],
	"smallsetminus": [ 8726 ],
	"smashp": [ 10803 ],
	"smeparsl": [ 10724 ],
	"smid": [ 8739 ],
	"smile": [ 8995 ],
	"smt": [ 10922 ],
	"smte": [ 10924 ],
	"smtes": [ 10924, 65024 ],
	"SOFTcy": [ 1068 ],
	"softcy": [ 1100 ],
	"sol": [ 47 ],
	"solb": [ 10692 ],
	"solbar": [ 9023 ],
	"Sopf": [ 120138 ],
	"sopf": [ 120164 ],
	"spades": [ 9824 ],
	"spadesuit": [ 9824 ],
	"spar": [ 8741 ],
	"sqcap": [ 8851 ],
	"sqcaps": [ 8851, 65024 ],
	"sqcup": [ 8852 ],
	"sqcups": [ 8852, 65024 ],
	"Sqrt": [ 8730 ],
	"sqsub": [ 8847 ],
	"sqsube": [ 8849 ],
	"sqsubset": [ 8847 ],
	"sqsubseteq": [ 8849 ],
	"sqsup": [ 8848 ],
	"sqsupe": [ 8850 ],
	"sqsupset": [ 8848 ],
	"sqsupseteq": [ 8850 ],
	"squ": [ 9633 ],
	"Square": [ 9633 ],
	"square": [ 9633 ],
	"SquareIntersection": [ 8851 ],
	"SquareSubset": [ 8847 ],
	"SquareSubsetEqual": [ 8849 ],
	"SquareSuperset": [ 8848 ],
	"SquareSupersetEqual": [ 8850 ],
	"SquareUnion": [ 8852 ],
	"squarf": [ 9642 ],
	"squf": [ 9642 ],
	"srarr": [ 8594 ],
	"Sscr": [ 119982 ],
	"sscr": [ 120008 ],
	"ssetmn": [ 8726 ],
	"ssmile": [ 8995 ],
	"sstarf": [ 8902 ],
	"Star": [ 8902 ],
	"star": [ 9734 ],
	"starf": [ 9733 ],
	"straightepsilon": [ 1013 ],
	"straightphi": [ 981 ],
	"strns": [ 175 ],
	"Sub": [ 8912 ],
	"sub": [ 8834 ],
	"subdot": [ 10941 ],
	"subE": [ 10949 ],
	"sube": [ 8838 ],
	"subedot": [ 10947 ],
	"submult": [ 10945 ],
	"subnE": [ 10955 ],
	"subne": [ 8842 ],
	"subplus": [ 10943 ],
	"subrarr": [ 10617 ],
	"Subset": [ 8912 ],
	"subset": [ 8834 ],
	"subseteq": [ 8838 ],
	"subseteqq": [ 10949 ],
	"SubsetEqual": [ 8838 ],
	"subsetneq": [ 8842 ],
	"subsetneqq": [ 10955 ],
	"subsim": [ 10951 ],
	"subsub": [ 10965 ],
	"subsup": [ 10963 ],
	"succ": [ 8827 ],
	"succapprox": [ 10936 ],
	"succcurlyeq": [ 8829 ],
	"Succeeds": [ 8827 ],
	"SucceedsEqual": [ 10928 ],
	"SucceedsSlantEqual": [ 8829 ],
	"SucceedsTilde": [ 8831 ],
	"succeq": [ 10928 ],
	"succnapprox": [ 10938 ],
	"succneqq": [ 10934 ],
	"succnsim": [ 8937 ],
	"succsim": [ 8831 ],
	"SuchThat": [ 8715 ],
	"Sum": [ 8721 ],
	"sum": [ 8721 ],
	"sung": [ 9834 ],
	"Sup": [ 8913 ],
	"sup": [ 8835 ],
	"sup1": [ 185 ],
	"sup2": [ 178 ],
	"sup3": [ 179 ],
	"supdot": [ 10942 ],
	"supdsub": [ 10968 ],
	"supE": [ 10950 ],
	"supe": [ 8839 ],
	"supedot": [ 10948 ],
	"Superset": [ 8835 ],
	"SupersetEqual": [ 8839 ],
	"suphsol": [ 10185 ],
	"suphsub": [ 10967 ],
	"suplarr": [ 10619 ],
	"supmult": [ 10946 ],
	"supnE": [ 10956 ],
	"supne": [ 8843 ],
	"supplus": [ 10944 ],
	"Supset": [ 8913 ],
	"supset": [ 8835 ],
	"supseteq": [ 8839 ],
	"supseteqq": [ 10950 ],
	"supsetneq": [ 8843 ],
	"supsetneqq": [ 10956 ],
	"supsim": [ 10952 ],
	"supsub": [ 10964 ],
	"supsup": [ 10966 ],
	"swarhk": [ 10534 ],
	"swArr": [ 8665 ],
	"swarr": [ 8601 ],
	"swarrow": [ 8601 ],
	"swnwar": [ 10538 ],
	"szlig": [ 223 ],
	"Tab": [ 9 ],
	"target": [ 8982 ],
	"Tau": [ 932 ],
	"tau": [ 964 ],
	"tbrk": [ 9140 ],
	"Tcaron": [ 356 ],
	"tcaron": [ 357 ],
	"Tcedil": [ 354 ],
	"tcedil": [ 355 ],
	"Tcy": [ 1058 ],
	"tcy": [ 1090 ],
	"tdot": [ 8411 ],
	"telrec": [ 8981 ],
	"Tfr": [ 120087 ],
	"tfr": [ 120113 ],
	"there4": [ 8756 ],
	"Therefore": [ 8756 ],
	"therefore": [ 8756 ],
	"Theta": [ 920 ],
	"theta": [ 952 ],
	"thetasym": [ 977 ],
	"thetav": [ 977 ],
	"thickapprox": [ 8776 ],
	"thicksim": [ 8764 ],
	"ThickSpace": [ 8287, 8202 ],
	"thinsp": [ 8201 ],
	"ThinSpace": [ 8201 ],
	"thkap": [ 8776 ],
	"thksim": [ 8764 ],
	"THORN": [ 222 ],
	"thorn": [ 254 ],
	"Tilde": [ 8764 ],
	"tilde": [ 732 ],
	"TildeEqual": [ 8771 ],
	"TildeFullEqual": [ 8773 ],
	"TildeTilde": [ 8776 ],
	"times": [ 215 ],
	"timesb": [ 8864 ],
	"timesbar": [ 10801 ],
	"timesd": [ 10800 ],
	"tint": [ 8749 ],
	"toea": [ 10536 ],
	"top": [ 8868 ],
	"topbot": [ 9014 ],
	"topcir": [ 10993 ],
	"Topf": [ 120139 ],
	"topf": [ 120165 ],
	"topfork": [ 10970 ],
	"tosa": [ 10537 ],
	"tprime": [ 8244 ],
	"TRADE": [ 8482 ],
	"trade": [ 8482 ],
	"triangle": [ 9653 ],
	"triangledown": [ 9663 ],
	"triangleleft": [ 9667 ],
	"trianglelefteq": [ 8884 ],
	"triangleq": [ 8796 ],
	"triangleright": [ 9657 ],
	"trianglerighteq": [ 8885 ],
	"tridot": [ 9708 ],
	"trie": [ 8796 ],
	"triminus": [ 10810 ],
	"TripleDot": [ 8411 ],
	"triplus": [ 10809 ],
	"trisb": [ 10701 ],
	"tritime": [ 10811 ],
	"trpezium": [ 9186 ],
	"Tscr": [ 119983 ],
	"tscr": [ 120009 ],
	"TScy": [ 1062 ],
	"tscy": [ 1094 ],
	"TSHcy": [ 1035 ],
	"tshcy": [ 1115 ],
	"Tstrok": [ 358 ],
	"tstrok": [ 359 ],
	"twixt": [ 8812 ],
	"twoheadleftarrow": [ 8606 ],
	"twoheadrightarrow": [ 8608 ],
	"Uacute": [ 218 ],
	"uacute": [ 250 ],
	"Uarr": [ 8607 ],
	"uArr": [ 8657 ],
	"uarr": [ 8593 ],
	"Uarrocir": [ 10569 ],
	"Ubrcy": [ 1038 ],
	"ubrcy": [ 1118 ],
	"Ubreve": [ 364 ],
	"ubreve": [ 365 ],
	"Ucirc": [ 219 ],
	"ucirc": [ 251 ],
	"Ucy": [ 1059 ],
	"ucy": [ 1091 ],
	"udarr": [ 8645 ],
	"Udblac": [ 368 ],
	"udblac": [ 369 ],
	"udhar": [ 10606 ],
	"ufisht": [ 10622 ],
	"Ufr": [ 120088 ],
	"ufr": [ 120114 ],
	"Ugrave": [ 217 ],
	"ugrave": [ 249 ],
	"uHar": [ 10595 ],
	"uharl": [ 8639 ],
	"uharr": [ 8638 ],
	"uhblk": [ 9600 ],
	"ulcorn": [ 8988 ],
	"ulcorner": [ 8988 ],
	"ulcrop": [ 8975 ],
	"ultri": [ 9720 ],
	"Umacr": [ 362 ],
	"umacr": [ 363 ],
	"uml": [ 168 ],
	"UnderBar": [ 95 ],
	"UnderBrace": [ 9183 ],
	"UnderBracket": [ 9141 ],
	"UnderParenthesis": [ 9181 ],
	"Union": [ 8899 ],
	"UnionPlus": [ 8846 ],
	"Uogon": [ 370 ],
	"uogon": [ 371 ],
	"Uopf": [ 120140 ],
	"uopf": [ 120166 ],
	"UpArrow": [ 8593 ],
	"Uparrow": [ 8657 ],
	"uparrow": [ 8593 ],
	"UpArrowBar": [ 10514 ],
	"UpArrowDownArrow": [ 8645 ],
	"UpDownArrow": [ 8597 ],
	"Updownarrow": [ 8661 ],
	"updownarrow": [ 8597 ],
	"UpEquilibrium": [ 10606 ],
	"upharpoonleft": [ 8639 ],
	"upharpoonright": [ 8638 ],
	"uplus": [ 8846 ],
	"UpperLeftArrow": [ 8598 ],
	"UpperRightArrow": [ 8599 ],
	"Upsi": [ 978 ],
	"upsi": [ 965 ],
	"upsih": [ 978 ],
	"Upsilon": [ 933 ],
	"upsilon": [ 965 ],
	"UpTee": [ 8869 ],
	"UpTeeArrow": [ 8613 ],
	"upuparrows": [ 8648 ],
	"urcorn": [ 8989 ],
	"urcorner": [ 8989 ],
	"urcrop": [ 8974 ],
	"Uring": [ 366 ],
	"uring": [ 367 ],
	"urtri": [ 9721 ],
	"Uscr": [ 119984 ],
	"uscr": [ 120010 ],
	"utdot": [ 8944 ],
	"Utilde": [ 360 ],
	"utilde": [ 361 ],
	"utri": [ 9653 ],
	"utrif": [ 9652 ],
	"uuarr": [ 8648 ],
	"Uuml": [ 220 ],
	"uuml": [ 252 ],
	"uwangle": [ 10663 ],
	"vangrt": [ 10652 ],
	"varepsilon": [ 1013 ],
	"varkappa": [ 1008 ],
	"varnothing": [ 8709 ],
	"varphi": [ 981 ],
	"varpi": [ 982 ],
	"varpropto": [ 8733 ],
	"vArr": [ 8661 ],
	"varr": [ 8597 ],
	"varrho": [ 1009 ],
	"varsigma": [ 962 ],
	"varsubsetneq": [ 8842, 65024 ],
	"varsubsetneqq": [ 10955, 65024 ],
	"varsupsetneq": [ 8843, 65024 ],
	"varsupsetneqq": [ 10956, 65024 ],
	"vartheta": [ 977 ],
	"vartriangleleft": [ 8882 ],
	"vartriangleright": [ 8883 ],
	"Vbar": [ 10987 ],
	"vBar": [ 10984 ],
	"vBarv": [ 10985 ],
	"Vcy": [ 1042 ],
	"vcy": [ 1074 ],
	"VDash": [ 8875 ],
	"Vdash": [ 8873 ],
	"vDash": [ 8872 ],
	"vdash": [ 8866 ],
	"Vdashl": [ 10982 ],
	"Vee": [ 8897 ],
	"vee": [ 8744 ],
	"veebar": [ 8891 ],
	"veeeq": [ 8794 ],
	"vellip": [ 8942 ],
	"Verbar": [ 8214 ],
	"verbar": [ 124 ],
	"Vert": [ 8214 ],
	"vert": [ 124 ],
	"VerticalBar": [ 8739 ],
	"VerticalLine": [ 124 ],
	"VerticalSeparator": [ 10072 ],
	"VerticalTilde": [ 8768 ],
	"VeryThinSpace": [ 8202 ],
	"Vfr": [ 120089 ],
	"vfr": [ 120115 ],
	"vltri": [ 8882 ],
	"vnsub": [ 8834, 8402 ],
	"vnsup": [ 8835, 8402 ],
	"Vopf": [ 120141 ],
	"vopf": [ 120167 ],
	"vprop": [ 8733 ],
	"vrtri": [ 8883 ],
	"Vscr": [ 119985 ],
	"vscr": [ 120011 ],
	"vsubnE": [ 10955, 65024 ],
	"vsubne": [ 8842, 65024 ],
	"vsupnE": [ 10956, 65024 ],
	"vsupne": [ 8843, 65024 ],
	"Vvdash": [ 8874 ],
	"vzigzag": [ 10650 ],
	"Wcirc": [ 372 ],
	"wcirc": [ 373 ],
	"wedbar": [ 10847 ],
	"Wedge": [ 8896 ],
	"wedge": [ 8743 ],
	"wedgeq": [ 8793 ],
	"weierp": [ 8472 ],
	"Wfr": [ 120090 ],
	"wfr": [ 120116 ],
	"Wopf": [ 120142 ],
	"wopf": [ 120168 ],
	"wp": [ 8472 ],
	"wr": [ 8768 ],
	"wreath": [ 8768 ],
	"Wscr": [ 119986 ],
	"wscr": [ 120012 ],
	"xcap": [ 8898 ],
	"xcirc": [ 9711 ],
	"xcup": [ 8899 ],
	"xdtri": [ 9661 ],
	"Xfr": [ 120091 ],
	"xfr": [ 120117 ],
	"xhArr": [ 10234 ],
	"xharr": [ 10231 ],
	"Xi": [ 926 ],
	"xi": [ 958 ],
	"xlArr": [ 10232 ],
	"xlarr": [ 10229 ],
	"xmap": [ 10236 ],
	"xnis": [ 8955 ],
	"xodot": [ 10752 ],
	"Xopf": [ 120143 ],
	"xopf": [ 120169 ],
	"xoplus": [ 10753 ],
	"xotime": [ 10754 ],
	"xrArr": [ 10233 ],
	"xrarr": [ 10230 ],
	"Xscr": [ 119987 ],
	"xscr": [ 120013 ],
	"xsqcup": [ 10758 ],
	"xuplus": [ 10756 ],
	"xutri": [ 9651 ],
	"xvee": [ 8897 ],
	"xwedge": [ 8896 ],
	"Yacute": [ 221 ],
	"yacute": [ 253 ],
	"YAcy": [ 1071 ],
	"yacy": [ 1103 ],
	"Ycirc": [ 374 ],
	"ycirc": [ 375 ],
	"Ycy": [ 1067 ],
	"ycy": [ 1099 ],
	"yen": [ 165 ],
	"Yfr": [ 120092 ],
	"yfr": [ 120118 ],
	"YIcy": [ 1031 ],
	"yicy": [ 1111 ],
	"Yopf": [ 120144 ],
	"yopf": [ 120170 ],
	"Yscr": [ 119988 ],
	"yscr": [ 120014 ],
	"YUcy": [ 1070 ],
	"yucy": [ 1102 ],
	"Yuml": [ 376 ],
	"yuml": [ 255 ],
	"Zacute": [ 377 ],
	"zacute": [ 378 ],
	"Zcaron": [ 381 ],
	"zcaron": [ 382 ],
	"Zcy": [ 1047 ],
	"zcy": [ 1079 ],
	"Zdot": [ 379 ],
	"zdot": [ 380 ],
	"zeetrf": [ 8488 ],
	"ZeroWidthSpace": [ 8203 ],
	"Zeta": [ 918 ],
	"zeta": [ 950 ],
	"Zfr": [ 8488 ],
	"zfr": [ 120119 ],
	"ZHcy": [ 1046 ],
	"zhcy": [ 1078 ],
	"zigrarr": [ 8669 ],
	"Zopf": [ 8484 ],
	"zopf": [ 120171 ],
	"Zscr": [ 119989 ],
	"zscr": [ 120015 ],
	"zwj": [ 8205 ],
	"zwnj": [ 8204 ]
}
},{}],81:[function(require,module,exports){
// the raw mapping of special names to unicode values
var by_name =
exports.by_name = require("../data/entities.json");

// index the reverse mappings immediately
var by_code = exports.by_code = {};
Object.keys(by_name).forEach(function(n) {
	by_name[n].forEach(function(c) {
		if (by_code[c] == null) by_code[c] = [];
		by_code[c].push(n);
	});
});

// a few regular expressions for parsing entities
var hex_value_regex = /^0?x([a-f0-9]+)$/i,
	entity_regex = /&(?:#x[a-f0-9]+|#[0-9]+|[a-z0-9]+);?/ig,
	dec_entity_regex = /^&#([0-9]+);?$/i,
	hex_entity_regex = /^&#x([a-f0-9]+);?$/i,
	spec_entity_regex = /^&([a-z0-9]+);?$/i;

// converts all entities found in string to specific format
var normalizeEntities =
exports.normalizeEntities = function(str, format) {
	return str.replace(entity_regex, function(entity) {
		return convert(entity, format) || entity;
	});
}

// converts all entities and higher order utf-8 chars to format
exports.normalizeXML = function(str, format) {
	var i, code, res;
	
	// convert entities first
	str = normalizeEntities(str, format);

	// find all characters above ASCII and replace, backwards
	for (i = str.length - 1; i >= 0; i--) {
		code = str.charCodeAt(i);
		if (code > 127) {
			res = convert(str[i], format);
			str = str.substr(0, i) + (res != null ? res : str[i]) + str.substr(i + 1);
		}
	}

	return str;
}

// converts single value into utf-8 character or entity equivalent
var convert =
exports.convert = function(s, format) {
	var code, name;
	if (format == null) format = "html";

	code = toCharCode(s);
	if (code === false) return null;

	switch(format) {
		// only decimal entities
		case "xml":
		case "xhtml":
		case "num":
		case "numeric":
			return toEntity(code);

		// only hex entities
		case "hex":
			return toEntity(code, true);

		// first special, then decimal
		case "html":
			return toEntity((name = cton(code)) != null ? name : code);

		// only special entities
		case "name":
		case "special":
			return (name = cton(code)) != null ? toEntity(name) : null;

		// utf-8 character
		case "char":
		case "character":
		case "utf-8":
		case "UTF-8":
			return String.fromCharCode(code);

		// regular number
		case "code":
			return code;
	}

	return null;
}

// code to name
var cton =
exports.codeToName = function(c) {
	var n = by_code[c.toString()];
	return n != null ? n[0] : null;
}

// name to code
var ntoc =
exports.nameToCode = function(n) {
	var c = by_name[n]
	return c != null ? c[0] : null;
}

// parse an array of inputs and returns the equivalent
// unicode decimal or false if invalid
var toCharCode =
exports.toCharCode = function(s) {
	var m, code;

	if (typeof s === "string") {
		if (s === "") return false;

		// regular char
		if (s.length === 1) return s.charCodeAt(0);

		// special entity
		if (m = spec_entity_regex.exec(s)) {
			return ntoc(m[1]) || false;
		}

		// decimal entity
		if (m = dec_entity_regex.exec(s)) {
			return parseInt(m[1], 10);
		}

		// hex entity
		if (m = hex_entity_regex.exec(s)) {
			return parseInt(m[1], 16);
		}

		// hex value
		if (m = hex_value_regex.exec(s)) {
			return parseInt(m[1], 16);
		}

		// otherwise look it up as a special entity name
		return ntoc(s) || false;
	}

	if (typeof s === "number") return s;

	return false;
}

// converts string or number to valid entity
var toEntity =
exports.toEntity = function(n, hex) {
	return "&" + (
		typeof n === "number" ?
		"#" + (hex ? "x" : "") +
		n.toString(hex ? 16 : 10).toUpperCase() : n
	) + ";";
}
},{"../data/entities.json":80}],82:[function(require,module,exports){
/*
Author: Geraint Luff and others
Year: 2013

This code is released into the "public domain" by its author(s).  Anybody may use, alter and distribute the code without restriction.  The author makes no guarantees, and takes no liability of any kind for use of this code.

If you find a bug or make an improvement, it would be courteous to let the author know, but it is not compulsory.
*/
(function (global, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if (typeof module !== 'undefined' && module.exports){
    // CommonJS. Define export.
    module.exports = factory();
  } else {
    // Browser globals
    global.tv4 = factory();
  }
}(this, function () {

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FObject%2Fkeys
if (!Object.keys) {
	Object.keys = (function () {
		var hasOwnProperty = Object.prototype.hasOwnProperty,
			hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
			dontEnums = [
				'toString',
				'toLocaleString',
				'valueOf',
				'hasOwnProperty',
				'isPrototypeOf',
				'propertyIsEnumerable',
				'constructor'
			],
			dontEnumsLength = dontEnums.length;

		return function (obj) {
			if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) {
				throw new TypeError('Object.keys called on non-object');
			}

			var result = [];

			for (var prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					result.push(prop);
				}
			}

			if (hasDontEnumBug) {
				for (var i=0; i < dontEnumsLength; i++) {
					if (hasOwnProperty.call(obj, dontEnums[i])) {
						result.push(dontEnums[i]);
					}
				}
			}
			return result;
		};
	})();
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
if (!Object.create) {
	Object.create = (function(){
		function F(){}

		return function(o){
			if (arguments.length !== 1) {
				throw new Error('Object.create implementation only accepts one parameter.');
			}
			F.prototype = o;
			return new F();
		};
	})();
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FisArray
if(!Array.isArray) {
	Array.isArray = function (vArg) {
		return Object.prototype.toString.call(vArg) === "[object Array]";
	};
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FindexOf
if (!Array.prototype.indexOf) {
	Array.prototype.indexOf = function (searchElement /*, fromIndex */ ) {
		if (this === null) {
			throw new TypeError();
		}
		var t = Object(this);
		var len = t.length >>> 0;

		if (len === 0) {
			return -1;
		}
		var n = 0;
		if (arguments.length > 1) {
			n = Number(arguments[1]);
			if (n !== n) { // shortcut for verifying if it's NaN
				n = 0;
			} else if (n !== 0 && n !== Infinity && n !== -Infinity) {
				n = (n > 0 || -1) * Math.floor(Math.abs(n));
			}
		}
		if (n >= len) {
			return -1;
		}
		var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
		for (; k < len; k++) {
			if (k in t && t[k] === searchElement) {
				return k;
			}
		}
		return -1;
	};
}

// Grungey Object.isFrozen hack
if (!Object.isFrozen) {
	Object.isFrozen = function (obj) {
		var key = "tv4_test_frozen_key";
		while (obj.hasOwnProperty(key)) {
			key += Math.random();
		}
		try {
			obj[key] = true;
			delete obj[key];
			return false;
		} catch (e) {
			return true;
		}
	};
}
// Based on: https://github.com/geraintluff/uri-templates, but with all the de-substitution stuff removed

var uriTemplateGlobalModifiers = {
	"+": true,
	"#": true,
	".": true,
	"/": true,
	";": true,
	"?": true,
	"&": true
};
var uriTemplateSuffices = {
	"*": true
};

function notReallyPercentEncode(string) {
	return encodeURI(string).replace(/%25[0-9][0-9]/g, function (doubleEncoded) {
		return "%" + doubleEncoded.substring(3);
	});
}

function uriTemplateSubstitution(spec) {
	var modifier = "";
	if (uriTemplateGlobalModifiers[spec.charAt(0)]) {
		modifier = spec.charAt(0);
		spec = spec.substring(1);
	}
	var separator = "";
	var prefix = "";
	var shouldEscape = true;
	var showVariables = false;
	var trimEmptyString = false;
	if (modifier === '+') {
		shouldEscape = false;
	} else if (modifier === ".") {
		prefix = ".";
		separator = ".";
	} else if (modifier === "/") {
		prefix = "/";
		separator = "/";
	} else if (modifier === '#') {
		prefix = "#";
		shouldEscape = false;
	} else if (modifier === ';') {
		prefix = ";";
		separator = ";";
		showVariables = true;
		trimEmptyString = true;
	} else if (modifier === '?') {
		prefix = "?";
		separator = "&";
		showVariables = true;
	} else if (modifier === '&') {
		prefix = "&";
		separator = "&";
		showVariables = true;
	}

	var varNames = [];
	var varList = spec.split(",");
	var varSpecs = [];
	var varSpecMap = {};
	for (var i = 0; i < varList.length; i++) {
		var varName = varList[i];
		var truncate = null;
		if (varName.indexOf(":") !== -1) {
			var parts = varName.split(":");
			varName = parts[0];
			truncate = parseInt(parts[1], 10);
		}
		var suffices = {};
		while (uriTemplateSuffices[varName.charAt(varName.length - 1)]) {
			suffices[varName.charAt(varName.length - 1)] = true;
			varName = varName.substring(0, varName.length - 1);
		}
		var varSpec = {
			truncate: truncate,
			name: varName,
			suffices: suffices
		};
		varSpecs.push(varSpec);
		varSpecMap[varName] = varSpec;
		varNames.push(varName);
	}
	var subFunction = function (valueFunction) {
		var result = "";
		var startIndex = 0;
		for (var i = 0; i < varSpecs.length; i++) {
			var varSpec = varSpecs[i];
			var value = valueFunction(varSpec.name);
			if (value === null || value === undefined || (Array.isArray(value) && value.length === 0) || (typeof value === 'object' && Object.keys(value).length === 0)) {
				startIndex++;
				continue;
			}
			if (i === startIndex) {
				result += prefix;
			} else {
				result += (separator || ",");
			}
			if (Array.isArray(value)) {
				if (showVariables) {
					result += varSpec.name + "=";
				}
				for (var j = 0; j < value.length; j++) {
					if (j > 0) {
						result += varSpec.suffices['*'] ? (separator || ",") : ",";
						if (varSpec.suffices['*'] && showVariables) {
							result += varSpec.name + "=";
						}
					}
					result += shouldEscape ? encodeURIComponent(value[j]).replace(/!/g, "%21") : notReallyPercentEncode(value[j]);
				}
			} else if (typeof value === "object") {
				if (showVariables && !varSpec.suffices['*']) {
					result += varSpec.name + "=";
				}
				var first = true;
				for (var key in value) {
					if (!first) {
						result += varSpec.suffices['*'] ? (separator || ",") : ",";
					}
					first = false;
					result += shouldEscape ? encodeURIComponent(key).replace(/!/g, "%21") : notReallyPercentEncode(key);
					result += varSpec.suffices['*'] ? '=' : ",";
					result += shouldEscape ? encodeURIComponent(value[key]).replace(/!/g, "%21") : notReallyPercentEncode(value[key]);
				}
			} else {
				if (showVariables) {
					result += varSpec.name;
					if (!trimEmptyString || value !== "") {
						result += "=";
					}
				}
				if (varSpec.truncate != null) {
					value = value.substring(0, varSpec.truncate);
				}
				result += shouldEscape ? encodeURIComponent(value).replace(/!/g, "%21"): notReallyPercentEncode(value);
			}
		}
		return result;
	};
	subFunction.varNames = varNames;
	return {
		prefix: prefix,
		substitution: subFunction
	};
}

function UriTemplate(template) {
	if (!(this instanceof UriTemplate)) {
		return new UriTemplate(template);
	}
	var parts = template.split("{");
	var textParts = [parts.shift()];
	var prefixes = [];
	var substitutions = [];
	var varNames = [];
	while (parts.length > 0) {
		var part = parts.shift();
		var spec = part.split("}")[0];
		var remainder = part.substring(spec.length + 1);
		var funcs = uriTemplateSubstitution(spec);
		substitutions.push(funcs.substitution);
		prefixes.push(funcs.prefix);
		textParts.push(remainder);
		varNames = varNames.concat(funcs.substitution.varNames);
	}
	this.fill = function (valueFunction) {
		var result = textParts[0];
		for (var i = 0; i < substitutions.length; i++) {
			var substitution = substitutions[i];
			result += substitution(valueFunction);
			result += textParts[i + 1];
		}
		return result;
	};
	this.varNames = varNames;
	this.template = template;
}
UriTemplate.prototype = {
	toString: function () {
		return this.template;
	},
	fillFromObject: function (obj) {
		return this.fill(function (varName) {
			return obj[varName];
		});
	}
};
var ValidatorContext = function ValidatorContext(parent, collectMultiple, errorReporter, checkRecursive, trackUnknownProperties) {
	this.missing = [];
	this.missingMap = {};
	this.formatValidators = parent ? Object.create(parent.formatValidators) : {};
	this.schemas = parent ? Object.create(parent.schemas) : {};
	this.collectMultiple = collectMultiple;
	this.errors = [];
	this.handleError = collectMultiple ? this.collectError : this.returnError;
	if (checkRecursive) {
		this.checkRecursive = true;
		this.scanned = [];
		this.scannedFrozen = [];
		this.scannedFrozenSchemas = [];
		this.scannedFrozenValidationErrors = [];
		this.validatedSchemasKey = 'tv4_validation_id';
		this.validationErrorsKey = 'tv4_validation_errors_id';
	}
	if (trackUnknownProperties) {
		this.trackUnknownProperties = true;
		this.knownPropertyPaths = {};
		this.unknownPropertyPaths = {};
	}
	this.errorReporter = errorReporter || defaultErrorReporter('en');
	if (typeof this.errorReporter === 'string') {
		throw new Error('debug');
	}
	this.definedKeywords = {};
	if (parent) {
		for (var key in parent.definedKeywords) {
			this.definedKeywords[key] = parent.definedKeywords[key].slice(0);
		}
	}
};
ValidatorContext.prototype.defineKeyword = function (keyword, keywordFunction) {
	this.definedKeywords[keyword] = this.definedKeywords[keyword] || [];
	this.definedKeywords[keyword].push(keywordFunction);
};
ValidatorContext.prototype.createError = function (code, messageParams, dataPath, schemaPath, subErrors, data, schema) {
	var error = new ValidationError(code, messageParams, dataPath, schemaPath, subErrors);
	error.message = this.errorReporter(error, data, schema);
	return error;
};
ValidatorContext.prototype.returnError = function (error) {
	return error;
};
ValidatorContext.prototype.collectError = function (error) {
	if (error) {
		this.errors.push(error);
	}
	return null;
};
ValidatorContext.prototype.prefixErrors = function (startIndex, dataPath, schemaPath) {
	for (var i = startIndex; i < this.errors.length; i++) {
		this.errors[i] = this.errors[i].prefixWith(dataPath, schemaPath);
	}
	return this;
};
ValidatorContext.prototype.banUnknownProperties = function (data, schema) {
	for (var unknownPath in this.unknownPropertyPaths) {
		var error = this.createError(ErrorCodes.UNKNOWN_PROPERTY, {path: unknownPath}, unknownPath, "", null, data, schema);
		var result = this.handleError(error);
		if (result) {
			return result;
		}
	}
	return null;
};

ValidatorContext.prototype.addFormat = function (format, validator) {
	if (typeof format === 'object') {
		for (var key in format) {
			this.addFormat(key, format[key]);
		}
		return this;
	}
	this.formatValidators[format] = validator;
};
ValidatorContext.prototype.resolveRefs = function (schema, urlHistory) {
	if (schema['$ref'] !== undefined) {
		urlHistory = urlHistory || {};
		if (urlHistory[schema['$ref']]) {
			return this.createError(ErrorCodes.CIRCULAR_REFERENCE, {urls: Object.keys(urlHistory).join(', ')}, '', '', null, undefined, schema);
		}
		urlHistory[schema['$ref']] = true;
		schema = this.getSchema(schema['$ref'], urlHistory);
	}
	return schema;
};
ValidatorContext.prototype.getSchema = function (url, urlHistory) {
	var schema;
	if (this.schemas[url] !== undefined) {
		schema = this.schemas[url];
		return this.resolveRefs(schema, urlHistory);
	}
	var baseUrl = url;
	var fragment = "";
	if (url.indexOf('#') !== -1) {
		fragment = url.substring(url.indexOf("#") + 1);
		baseUrl = url.substring(0, url.indexOf("#"));
	}
	if (typeof this.schemas[baseUrl] === 'object') {
		schema = this.schemas[baseUrl];
		var pointerPath = decodeURIComponent(fragment);
		if (pointerPath === "") {
			return this.resolveRefs(schema, urlHistory);
		} else if (pointerPath.charAt(0) !== "/") {
			return undefined;
		}
		var parts = pointerPath.split("/").slice(1);
		for (var i = 0; i < parts.length; i++) {
			var component = parts[i].replace(/~1/g, "/").replace(/~0/g, "~");
			if (schema[component] === undefined) {
				schema = undefined;
				break;
			}
			schema = schema[component];
		}
		if (schema !== undefined) {
			return this.resolveRefs(schema, urlHistory);
		}
	}
	if (this.missing[baseUrl] === undefined) {
		this.missing.push(baseUrl);
		this.missing[baseUrl] = baseUrl;
		this.missingMap[baseUrl] = baseUrl;
	}
};
ValidatorContext.prototype.searchSchemas = function (schema, url) {
	if (Array.isArray(schema)) {
		for (var i = 0; i < schema.length; i++) {
			this.searchSchemas(schema[i], url);
		}
	} else if (schema && typeof schema === "object") {
		if (typeof schema.id === "string") {
			if (isTrustedUrl(url, schema.id)) {
				if (this.schemas[schema.id] === undefined) {
					this.schemas[schema.id] = schema;
				}
			}
		}
		for (var key in schema) {
			if (key !== "enum") {
				if (typeof schema[key] === "object") {
					this.searchSchemas(schema[key], url);
				} else if (key === "$ref") {
					var uri = getDocumentUri(schema[key]);
					if (uri && this.schemas[uri] === undefined && this.missingMap[uri] === undefined) {
						this.missingMap[uri] = uri;
					}
				}
			}
		}
	}
};
ValidatorContext.prototype.addSchema = function (url, schema) {
	//overload
	if (typeof url !== 'string' || typeof schema === 'undefined') {
		if (typeof url === 'object' && typeof url.id === 'string') {
			schema = url;
			url = schema.id;
		}
		else {
			return;
		}
	}
	if (url === getDocumentUri(url) + "#") {
		// Remove empty fragment
		url = getDocumentUri(url);
	}
	this.schemas[url] = schema;
	delete this.missingMap[url];
	normSchema(schema, url);
	this.searchSchemas(schema, url);
};

ValidatorContext.prototype.getSchemaMap = function () {
	var map = {};
	for (var key in this.schemas) {
		map[key] = this.schemas[key];
	}
	return map;
};

ValidatorContext.prototype.getSchemaUris = function (filterRegExp) {
	var list = [];
	for (var key in this.schemas) {
		if (!filterRegExp || filterRegExp.test(key)) {
			list.push(key);
		}
	}
	return list;
};

ValidatorContext.prototype.getMissingUris = function (filterRegExp) {
	var list = [];
	for (var key in this.missingMap) {
		if (!filterRegExp || filterRegExp.test(key)) {
			list.push(key);
		}
	}
	return list;
};

ValidatorContext.prototype.dropSchemas = function () {
	this.schemas = {};
	this.reset();
};
ValidatorContext.prototype.reset = function () {
	this.missing = [];
	this.missingMap = {};
	this.errors = [];
};

ValidatorContext.prototype.validateAll = function (data, schema, dataPathParts, schemaPathParts, dataPointerPath) {
	var topLevel;
	schema = this.resolveRefs(schema);
	if (!schema) {
		return null;
	} else if (schema instanceof ValidationError) {
		this.errors.push(schema);
		return schema;
	}

	var startErrorCount = this.errors.length;
	var frozenIndex, scannedFrozenSchemaIndex = null, scannedSchemasIndex = null;
	if (this.checkRecursive && data && typeof data === 'object') {
		topLevel = !this.scanned.length;
		if (data[this.validatedSchemasKey]) {
			var schemaIndex = data[this.validatedSchemasKey].indexOf(schema);
			if (schemaIndex !== -1) {
				this.errors = this.errors.concat(data[this.validationErrorsKey][schemaIndex]);
				return null;
			}
		}
		if (Object.isFrozen(data)) {
			frozenIndex = this.scannedFrozen.indexOf(data);
			if (frozenIndex !== -1) {
				var frozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].indexOf(schema);
				if (frozenSchemaIndex !== -1) {
					this.errors = this.errors.concat(this.scannedFrozenValidationErrors[frozenIndex][frozenSchemaIndex]);
					return null;
				}
			}
		}
		this.scanned.push(data);
		if (Object.isFrozen(data)) {
			if (frozenIndex === -1) {
				frozenIndex = this.scannedFrozen.length;
				this.scannedFrozen.push(data);
				this.scannedFrozenSchemas.push([]);
			}
			scannedFrozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].length;
			this.scannedFrozenSchemas[frozenIndex][scannedFrozenSchemaIndex] = schema;
			this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = [];
		} else {
			if (!data[this.validatedSchemasKey]) {
				try {
					Object.defineProperty(data, this.validatedSchemasKey, {
						value: [],
						configurable: true
					});
					Object.defineProperty(data, this.validationErrorsKey, {
						value: [],
						configurable: true
					});
				} catch (e) {
					//IE 7/8 workaround
					data[this.validatedSchemasKey] = [];
					data[this.validationErrorsKey] = [];
				}
			}
			scannedSchemasIndex = data[this.validatedSchemasKey].length;
			data[this.validatedSchemasKey][scannedSchemasIndex] = schema;
			data[this.validationErrorsKey][scannedSchemasIndex] = [];
		}
	}

	var errorCount = this.errors.length;
	var error = this.validateBasic(data, schema, dataPointerPath)
		|| this.validateNumeric(data, schema, dataPointerPath)
		|| this.validateString(data, schema, dataPointerPath)
		|| this.validateArray(data, schema, dataPointerPath)
		|| this.validateObject(data, schema, dataPointerPath)
		|| this.validateCombinations(data, schema, dataPointerPath)
		|| this.validateHypermedia(data, schema, dataPointerPath)
		|| this.validateFormat(data, schema, dataPointerPath)
		|| this.validateDefinedKeywords(data, schema, dataPointerPath)
		|| null;

	if (topLevel) {
		while (this.scanned.length) {
			var item = this.scanned.pop();
			delete item[this.validatedSchemasKey];
		}
		this.scannedFrozen = [];
		this.scannedFrozenSchemas = [];
	}

	if (error || errorCount !== this.errors.length) {
		while ((dataPathParts && dataPathParts.length) || (schemaPathParts && schemaPathParts.length)) {
			var dataPart = (dataPathParts && dataPathParts.length) ? "" + dataPathParts.pop() : null;
			var schemaPart = (schemaPathParts && schemaPathParts.length) ? "" + schemaPathParts.pop() : null;
			if (error) {
				error = error.prefixWith(dataPart, schemaPart);
			}
			this.prefixErrors(errorCount, dataPart, schemaPart);
		}
	}

	if (scannedFrozenSchemaIndex !== null) {
		this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = this.errors.slice(startErrorCount);
	} else if (scannedSchemasIndex !== null) {
		data[this.validationErrorsKey][scannedSchemasIndex] = this.errors.slice(startErrorCount);
	}

	return this.handleError(error);
};
ValidatorContext.prototype.validateFormat = function (data, schema) {
	if (typeof schema.format !== 'string' || !this.formatValidators[schema.format]) {
		return null;
	}
	var errorMessage = this.formatValidators[schema.format].call(null, data, schema);
	if (typeof errorMessage === 'string' || typeof errorMessage === 'number') {
		return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage}, '', '/format', null, data, schema);
	} else if (errorMessage && typeof errorMessage === 'object') {
		return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage.message || "?"}, errorMessage.dataPath || '', errorMessage.schemaPath || "/format", null, data, schema);
	}
	return null;
};
ValidatorContext.prototype.validateDefinedKeywords = function (data, schema, dataPointerPath) {
	for (var key in this.definedKeywords) {
		if (typeof schema[key] === 'undefined') {
			continue;
		}
		var validationFunctions = this.definedKeywords[key];
		for (var i = 0; i < validationFunctions.length; i++) {
			var func = validationFunctions[i];
			var result = func(data, schema[key], schema, dataPointerPath);
			if (typeof result === 'string' || typeof result === 'number') {
				return this.createError(ErrorCodes.KEYWORD_CUSTOM, {key: key, message: result}, '', '', null, data, schema).prefixWith(null, key);
			} else if (result && typeof result === 'object') {
				var code = result.code;
				if (typeof code === 'string') {
					if (!ErrorCodes[code]) {
						throw new Error('Undefined error code (use defineError): ' + code);
					}
					code = ErrorCodes[code];
				} else if (typeof code !== 'number') {
					code = ErrorCodes.KEYWORD_CUSTOM;
				}
				var messageParams = (typeof result.message === 'object') ? result.message : {key: key, message: result.message || "?"};
				var schemaPath = result.schemaPath || ("/" + key.replace(/~/g, '~0').replace(/\//g, '~1'));
				return this.createError(code, messageParams, result.dataPath || null, schemaPath, null, data, schema);
			}
		}
	}
	return null;
};

function recursiveCompare(A, B) {
	if (A === B) {
		return true;
	}
	if (A && B && typeof A === "object" && typeof B === "object") {
		if (Array.isArray(A) !== Array.isArray(B)) {
			return false;
		} else if (Array.isArray(A)) {
			if (A.length !== B.length) {
				return false;
			}
			for (var i = 0; i < A.length; i++) {
				if (!recursiveCompare(A[i], B[i])) {
					return false;
				}
			}
		} else {
			var key;
			for (key in A) {
				if (B[key] === undefined && A[key] !== undefined) {
					return false;
				}
			}
			for (key in B) {
				if (A[key] === undefined && B[key] !== undefined) {
					return false;
				}
			}
			for (key in A) {
				if (!recursiveCompare(A[key], B[key])) {
					return false;
				}
			}
		}
		return true;
	}
	return false;
}

ValidatorContext.prototype.validateBasic = function validateBasic(data, schema, dataPointerPath) {
	var error;
	if (error = this.validateType(data, schema, dataPointerPath)) {
		return error.prefixWith(null, "type");
	}
	if (error = this.validateEnum(data, schema, dataPointerPath)) {
		return error.prefixWith(null, "type");
	}
	return null;
};

ValidatorContext.prototype.validateType = function validateType(data, schema) {
	if (schema.type === undefined) {
		return null;
	}
	var dataType = typeof data;
	if (data === null) {
		dataType = "null";
	} else if (Array.isArray(data)) {
		dataType = "array";
	}
	var allowedTypes = schema.type;
	if (!Array.isArray(allowedTypes)) {
		allowedTypes = [allowedTypes];
	}

	for (var i = 0; i < allowedTypes.length; i++) {
		var type = allowedTypes[i];
		if (type === dataType || (type === "integer" && dataType === "number" && (data % 1 === 0))) {
			return null;
		}
	}
	return this.createError(ErrorCodes.INVALID_TYPE, {type: dataType, expected: allowedTypes.join("/")}, '', '', null, data, schema);
};

ValidatorContext.prototype.validateEnum = function validateEnum(data, schema) {
	if (schema["enum"] === undefined) {
		return null;
	}
	for (var i = 0; i < schema["enum"].length; i++) {
		var enumVal = schema["enum"][i];
		if (recursiveCompare(data, enumVal)) {
			return null;
		}
	}
	return this.createError(ErrorCodes.ENUM_MISMATCH, {value: (typeof JSON !== 'undefined') ? JSON.stringify(data) : data}, '', '', null, data, schema);
};

ValidatorContext.prototype.validateNumeric = function validateNumeric(data, schema, dataPointerPath) {
	return this.validateMultipleOf(data, schema, dataPointerPath)
		|| this.validateMinMax(data, schema, dataPointerPath)
		|| this.validateNaN(data, schema, dataPointerPath)
		|| null;
};

var CLOSE_ENOUGH_LOW = Math.pow(2, -51);
var CLOSE_ENOUGH_HIGH = 1 - CLOSE_ENOUGH_LOW;
ValidatorContext.prototype.validateMultipleOf = function validateMultipleOf(data, schema) {
	var multipleOf = schema.multipleOf || schema.divisibleBy;
	if (multipleOf === undefined) {
		return null;
	}
	if (typeof data === "number") {
		var remainder = (data/multipleOf)%1;
		if (remainder >= CLOSE_ENOUGH_LOW && remainder < CLOSE_ENOUGH_HIGH) {
			return this.createError(ErrorCodes.NUMBER_MULTIPLE_OF, {value: data, multipleOf: multipleOf}, '', '', null, data, schema);
		}
	}
	return null;
};

ValidatorContext.prototype.validateMinMax = function validateMinMax(data, schema) {
	if (typeof data !== "number") {
		return null;
	}
	if (schema.minimum !== undefined) {
		if (data < schema.minimum) {
			return this.createError(ErrorCodes.NUMBER_MINIMUM, {value: data, minimum: schema.minimum}, '', '/minimum', null, data, schema);
		}
		if (schema.exclusiveMinimum && data === schema.minimum) {
			return this.createError(ErrorCodes.NUMBER_MINIMUM_EXCLUSIVE, {value: data, minimum: schema.minimum}, '', '/exclusiveMinimum', null, data, schema);
		}
	}
	if (schema.maximum !== undefined) {
		if (data > schema.maximum) {
			return this.createError(ErrorCodes.NUMBER_MAXIMUM, {value: data, maximum: schema.maximum}, '', '/maximum', null, data, schema);
		}
		if (schema.exclusiveMaximum && data === schema.maximum) {
			return this.createError(ErrorCodes.NUMBER_MAXIMUM_EXCLUSIVE, {value: data, maximum: schema.maximum}, '', '/exclusiveMaximum', null, data, schema);
		}
	}
	return null;
};

ValidatorContext.prototype.validateNaN = function validateNaN(data, schema) {
	if (typeof data !== "number") {
		return null;
	}
	if (isNaN(data) === true || data === Infinity || data === -Infinity) {
		return this.createError(ErrorCodes.NUMBER_NOT_A_NUMBER, {value: data}, '', '/type', null, data, schema);
	}
	return null;
};

ValidatorContext.prototype.validateString = function validateString(data, schema, dataPointerPath) {
	return this.validateStringLength(data, schema, dataPointerPath)
		|| this.validateStringPattern(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateStringLength = function validateStringLength(data, schema) {
	if (typeof data !== "string") {
		return null;
	}
	if (schema.minLength !== undefined) {
		if (data.length < schema.minLength) {
			return this.createError(ErrorCodes.STRING_LENGTH_SHORT, {length: data.length, minimum: schema.minLength}, '', '/minLength', null, data, schema);
		}
	}
	if (schema.maxLength !== undefined) {
		if (data.length > schema.maxLength) {
			return this.createError(ErrorCodes.STRING_LENGTH_LONG, {length: data.length, maximum: schema.maxLength}, '', '/maxLength', null, data, schema);
		}
	}
	return null;
};

ValidatorContext.prototype.validateStringPattern = function validateStringPattern(data, schema) {
	if (typeof data !== "string" || (typeof schema.pattern !== "string" && !(schema.pattern instanceof RegExp))) {
		return null;
	}
	var regexp;
	if (schema.pattern instanceof RegExp) {
	  regexp = schema.pattern;
	}
	else {
	  var body, flags = '';
	  // Check for regular expression literals
	  // @see http://www.ecma-international.org/ecma-262/5.1/#sec-7.8.5
	  var literal = schema.pattern.match(/^\/(.+)\/([img]*)$/);
	  if (literal) {
	    body = literal[1];
	    flags = literal[2];
	  }
	  else {
	    body = schema.pattern;
	  }
	  regexp = new RegExp(body, flags);
	}
	if (!regexp.test(data)) {
		return this.createError(ErrorCodes.STRING_PATTERN, {pattern: schema.pattern}, '', '/pattern', null, data, schema);
	}
	return null;
};

ValidatorContext.prototype.validateArray = function validateArray(data, schema, dataPointerPath) {
	if (!Array.isArray(data)) {
		return null;
	}
	return this.validateArrayLength(data, schema, dataPointerPath)
		|| this.validateArrayUniqueItems(data, schema, dataPointerPath)
		|| this.validateArrayItems(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateArrayLength = function validateArrayLength(data, schema) {
	var error;
	if (schema.minItems !== undefined) {
		if (data.length < schema.minItems) {
			error = this.createError(ErrorCodes.ARRAY_LENGTH_SHORT, {length: data.length, minimum: schema.minItems}, '', '/minItems', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	if (schema.maxItems !== undefined) {
		if (data.length > schema.maxItems) {
			error = this.createError(ErrorCodes.ARRAY_LENGTH_LONG, {length: data.length, maximum: schema.maxItems}, '', '/maxItems', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateArrayUniqueItems = function validateArrayUniqueItems(data, schema) {
	if (schema.uniqueItems) {
		for (var i = 0; i < data.length; i++) {
			for (var j = i + 1; j < data.length; j++) {
				if (recursiveCompare(data[i], data[j])) {
					var error = this.createError(ErrorCodes.ARRAY_UNIQUE, {match1: i, match2: j}, '', '/uniqueItems', null, data, schema);
					if (this.handleError(error)) {
						return error;
					}
				}
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateArrayItems = function validateArrayItems(data, schema, dataPointerPath) {
	if (schema.items === undefined) {
		return null;
	}
	var error, i;
	if (Array.isArray(schema.items)) {
		for (i = 0; i < data.length; i++) {
			if (i < schema.items.length) {
				if (error = this.validateAll(data[i], schema.items[i], [i], ["items", i], dataPointerPath + "/" + i)) {
					return error;
				}
			} else if (schema.additionalItems !== undefined) {
				if (typeof schema.additionalItems === "boolean") {
					if (!schema.additionalItems) {
						error = (this.createError(ErrorCodes.ARRAY_ADDITIONAL_ITEMS, {}, '/' + i, '/additionalItems', null, data, schema));
						if (this.handleError(error)) {
							return error;
						}
					}
				} else if (error = this.validateAll(data[i], schema.additionalItems, [i], ["additionalItems"], dataPointerPath + "/" + i)) {
					return error;
				}
			}
		}
	} else {
		for (i = 0; i < data.length; i++) {
			if (error = this.validateAll(data[i], schema.items, [i], ["items"], dataPointerPath + "/" + i)) {
				return error;
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateObject = function validateObject(data, schema, dataPointerPath) {
	if (typeof data !== "object" || data === null || Array.isArray(data)) {
		return null;
	}
	return this.validateObjectMinMaxProperties(data, schema, dataPointerPath)
		|| this.validateObjectRequiredProperties(data, schema, dataPointerPath)
		|| this.validateObjectProperties(data, schema, dataPointerPath)
		|| this.validateObjectDependencies(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateObjectMinMaxProperties = function validateObjectMinMaxProperties(data, schema) {
	var keys = Object.keys(data);
	var error;
	if (schema.minProperties !== undefined) {
		if (keys.length < schema.minProperties) {
			error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MINIMUM, {propertyCount: keys.length, minimum: schema.minProperties}, '', '/minProperties', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	if (schema.maxProperties !== undefined) {
		if (keys.length > schema.maxProperties) {
			error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MAXIMUM, {propertyCount: keys.length, maximum: schema.maxProperties}, '', '/maxProperties', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateObjectRequiredProperties = function validateObjectRequiredProperties(data, schema) {
	if (schema.required !== undefined) {
		for (var i = 0; i < schema.required.length; i++) {
			var key = schema.required[i];
			if (data[key] === undefined) {
				var error = this.createError(ErrorCodes.OBJECT_REQUIRED, {key: key}, '', '/required/' + i, null, data, schema);
				if (this.handleError(error)) {
					return error;
				}
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateObjectProperties = function validateObjectProperties(data, schema, dataPointerPath) {
	var error;
	for (var key in data) {
		var keyPointerPath = dataPointerPath + "/" + key.replace(/~/g, '~0').replace(/\//g, '~1');
		var foundMatch = false;
		if (schema.properties !== undefined && schema.properties[key] !== undefined) {
			foundMatch = true;
			if (error = this.validateAll(data[key], schema.properties[key], [key], ["properties", key], keyPointerPath)) {
				return error;
			}
		}
		if (schema.patternProperties !== undefined) {
			for (var patternKey in schema.patternProperties) {
				var regexp = new RegExp(patternKey);
				if (regexp.test(key)) {
					foundMatch = true;
					if (error = this.validateAll(data[key], schema.patternProperties[patternKey], [key], ["patternProperties", patternKey], keyPointerPath)) {
						return error;
					}
				}
			}
		}
		if (!foundMatch) {
			if (schema.additionalProperties !== undefined) {
				if (this.trackUnknownProperties) {
					this.knownPropertyPaths[keyPointerPath] = true;
					delete this.unknownPropertyPaths[keyPointerPath];
				}
				if (typeof schema.additionalProperties === "boolean") {
					if (!schema.additionalProperties) {
						error = this.createError(ErrorCodes.OBJECT_ADDITIONAL_PROPERTIES, {key: key}, '', '/additionalProperties', null, data, schema).prefixWith(key, null);
						if (this.handleError(error)) {
							return error;
						}
					}
				} else {
					if (error = this.validateAll(data[key], schema.additionalProperties, [key], ["additionalProperties"], keyPointerPath)) {
						return error;
					}
				}
			} else if (this.trackUnknownProperties && !this.knownPropertyPaths[keyPointerPath]) {
				this.unknownPropertyPaths[keyPointerPath] = true;
			}
		} else if (this.trackUnknownProperties) {
			this.knownPropertyPaths[keyPointerPath] = true;
			delete this.unknownPropertyPaths[keyPointerPath];
		}
	}
	return null;
};

ValidatorContext.prototype.validateObjectDependencies = function validateObjectDependencies(data, schema, dataPointerPath) {
	var error;
	if (schema.dependencies !== undefined) {
		for (var depKey in schema.dependencies) {
			if (data[depKey] !== undefined) {
				var dep = schema.dependencies[depKey];
				if (typeof dep === "string") {
					if (data[dep] === undefined) {
						error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: dep}, '', '', null, data, schema).prefixWith(null, depKey).prefixWith(null, "dependencies");
						if (this.handleError(error)) {
							return error;
						}
					}
				} else if (Array.isArray(dep)) {
					for (var i = 0; i < dep.length; i++) {
						var requiredKey = dep[i];
						if (data[requiredKey] === undefined) {
							error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: requiredKey}, '', '/' + i, null, data, schema).prefixWith(null, depKey).prefixWith(null, "dependencies");
							if (this.handleError(error)) {
								return error;
							}
						}
					}
				} else {
					if (error = this.validateAll(data, dep, [], ["dependencies", depKey], dataPointerPath)) {
						return error;
					}
				}
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateCombinations = function validateCombinations(data, schema, dataPointerPath) {
	return this.validateAllOf(data, schema, dataPointerPath)
		|| this.validateAnyOf(data, schema, dataPointerPath)
		|| this.validateOneOf(data, schema, dataPointerPath)
		|| this.validateNot(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateAllOf = function validateAllOf(data, schema, dataPointerPath) {
	if (schema.allOf === undefined) {
		return null;
	}
	var error;
	for (var i = 0; i < schema.allOf.length; i++) {
		var subSchema = schema.allOf[i];
		if (error = this.validateAll(data, subSchema, [], ["allOf", i], dataPointerPath)) {
			return error;
		}
	}
	return null;
};

ValidatorContext.prototype.validateAnyOf = function validateAnyOf(data, schema, dataPointerPath) {
	if (schema.anyOf === undefined) {
		return null;
	}
	var errors = [];
	var startErrorCount = this.errors.length;
	var oldUnknownPropertyPaths, oldKnownPropertyPaths;
	if (this.trackUnknownProperties) {
		oldUnknownPropertyPaths = this.unknownPropertyPaths;
		oldKnownPropertyPaths = this.knownPropertyPaths;
	}
	var errorAtEnd = true;
	for (var i = 0; i < schema.anyOf.length; i++) {
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = {};
			this.knownPropertyPaths = {};
		}
		var subSchema = schema.anyOf[i];

		var errorCount = this.errors.length;
		var error = this.validateAll(data, subSchema, [], ["anyOf", i], dataPointerPath);

		if (error === null && errorCount === this.errors.length) {
			this.errors = this.errors.slice(0, startErrorCount);

			if (this.trackUnknownProperties) {
				for (var knownKey in this.knownPropertyPaths) {
					oldKnownPropertyPaths[knownKey] = true;
					delete oldUnknownPropertyPaths[knownKey];
				}
				for (var unknownKey in this.unknownPropertyPaths) {
					if (!oldKnownPropertyPaths[unknownKey]) {
						oldUnknownPropertyPaths[unknownKey] = true;
					}
				}
				// We need to continue looping so we catch all the property definitions, but we don't want to return an error
				errorAtEnd = false;
				continue;
			}

			return null;
		}
		if (error) {
			errors.push(error.prefixWith(null, "" + i).prefixWith(null, "anyOf"));
		}
	}
	if (this.trackUnknownProperties) {
		this.unknownPropertyPaths = oldUnknownPropertyPaths;
		this.knownPropertyPaths = oldKnownPropertyPaths;
	}
	if (errorAtEnd) {
		errors = errors.concat(this.errors.slice(startErrorCount));
		this.errors = this.errors.slice(0, startErrorCount);
		return this.createError(ErrorCodes.ANY_OF_MISSING, {}, "", "/anyOf", errors, data, schema);
	}
};

ValidatorContext.prototype.validateOneOf = function validateOneOf(data, schema, dataPointerPath) {
	if (schema.oneOf === undefined) {
		return null;
	}
	var validIndex = null;
	var errors = [];
	var startErrorCount = this.errors.length;
	var oldUnknownPropertyPaths, oldKnownPropertyPaths;
	if (this.trackUnknownProperties) {
		oldUnknownPropertyPaths = this.unknownPropertyPaths;
		oldKnownPropertyPaths = this.knownPropertyPaths;
	}
	for (var i = 0; i < schema.oneOf.length; i++) {
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = {};
			this.knownPropertyPaths = {};
		}
		var subSchema = schema.oneOf[i];

		var errorCount = this.errors.length;
		var error = this.validateAll(data, subSchema, [], ["oneOf", i], dataPointerPath);

		if (error === null && errorCount === this.errors.length) {
			if (validIndex === null) {
				validIndex = i;
			} else {
				this.errors = this.errors.slice(0, startErrorCount);
				return this.createError(ErrorCodes.ONE_OF_MULTIPLE, {index1: validIndex, index2: i}, "", "/oneOf", null, data, schema);
			}
			if (this.trackUnknownProperties) {
				for (var knownKey in this.knownPropertyPaths) {
					oldKnownPropertyPaths[knownKey] = true;
					delete oldUnknownPropertyPaths[knownKey];
				}
				for (var unknownKey in this.unknownPropertyPaths) {
					if (!oldKnownPropertyPaths[unknownKey]) {
						oldUnknownPropertyPaths[unknownKey] = true;
					}
				}
			}
		} else if (error) {
			errors.push(error);
		}
	}
	if (this.trackUnknownProperties) {
		this.unknownPropertyPaths = oldUnknownPropertyPaths;
		this.knownPropertyPaths = oldKnownPropertyPaths;
	}
	if (validIndex === null) {
		errors = errors.concat(this.errors.slice(startErrorCount));
		this.errors = this.errors.slice(0, startErrorCount);
		return this.createError(ErrorCodes.ONE_OF_MISSING, {}, "", "/oneOf", errors, data, schema);
	} else {
		this.errors = this.errors.slice(0, startErrorCount);
	}
	return null;
};

ValidatorContext.prototype.validateNot = function validateNot(data, schema, dataPointerPath) {
	if (schema.not === undefined) {
		return null;
	}
	var oldErrorCount = this.errors.length;
	var oldUnknownPropertyPaths, oldKnownPropertyPaths;
	if (this.trackUnknownProperties) {
		oldUnknownPropertyPaths = this.unknownPropertyPaths;
		oldKnownPropertyPaths = this.knownPropertyPaths;
		this.unknownPropertyPaths = {};
		this.knownPropertyPaths = {};
	}
	var error = this.validateAll(data, schema.not, null, null, dataPointerPath);
	var notErrors = this.errors.slice(oldErrorCount);
	this.errors = this.errors.slice(0, oldErrorCount);
	if (this.trackUnknownProperties) {
		this.unknownPropertyPaths = oldUnknownPropertyPaths;
		this.knownPropertyPaths = oldKnownPropertyPaths;
	}
	if (error === null && notErrors.length === 0) {
		return this.createError(ErrorCodes.NOT_PASSED, {}, "", "/not", null, data, schema);
	}
	return null;
};

ValidatorContext.prototype.validateHypermedia = function validateCombinations(data, schema, dataPointerPath) {
	if (!schema.links) {
		return null;
	}
	var error;
	for (var i = 0; i < schema.links.length; i++) {
		var ldo = schema.links[i];
		if (ldo.rel === "describedby") {
			var template = new UriTemplate(ldo.href);
			var allPresent = true;
			for (var j = 0; j < template.varNames.length; j++) {
				if (!(template.varNames[j] in data)) {
					allPresent = false;
					break;
				}
			}
			if (allPresent) {
				var schemaUrl = template.fillFromObject(data);
				var subSchema = {"$ref": schemaUrl};
				if (error = this.validateAll(data, subSchema, [], ["links", i], dataPointerPath)) {
					return error;
				}
			}
		}
	}
};

// parseURI() and resolveUrl() are from https://gist.github.com/1088850
//   -  released as public domain by author ("Yaffle") - see comments on gist

function parseURI(url) {
	var m = String(url).replace(/^\s+|\s+$/g, '').match(/^([^:\/?#]+:)?(\/\/(?:[^:@]*(?::[^:@]*)?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
	// authority = '//' + user + ':' + pass '@' + hostname + ':' port
	return (m ? {
		href     : m[0] || '',
		protocol : m[1] || '',
		authority: m[2] || '',
		host     : m[3] || '',
		hostname : m[4] || '',
		port     : m[5] || '',
		pathname : m[6] || '',
		search   : m[7] || '',
		hash     : m[8] || ''
	} : null);
}

function resolveUrl(base, href) {// RFC 3986

	function removeDotSegments(input) {
		var output = [];
		input.replace(/^(\.\.?(\/|$))+/, '')
			.replace(/\/(\.(\/|$))+/g, '/')
			.replace(/\/\.\.$/, '/../')
			.replace(/\/?[^\/]*/g, function (p) {
				if (p === '/..') {
					output.pop();
				} else {
					output.push(p);
				}
		});
		return output.join('').replace(/^\//, input.charAt(0) === '/' ? '/' : '');
	}

	href = parseURI(href || '');
	base = parseURI(base || '');

	return !href || !base ? null : (href.protocol || base.protocol) +
		(href.protocol || href.authority ? href.authority : base.authority) +
		removeDotSegments(href.protocol || href.authority || href.pathname.charAt(0) === '/' ? href.pathname : (href.pathname ? ((base.authority && !base.pathname ? '/' : '') + base.pathname.slice(0, base.pathname.lastIndexOf('/') + 1) + href.pathname) : base.pathname)) +
		(href.protocol || href.authority || href.pathname ? href.search : (href.search || base.search)) +
		href.hash;
}

function getDocumentUri(uri) {
	return uri.split('#')[0];
}
function normSchema(schema, baseUri) {
	if (schema && typeof schema === "object") {
		if (baseUri === undefined) {
			baseUri = schema.id;
		} else if (typeof schema.id === "string") {
			baseUri = resolveUrl(baseUri, schema.id);
			schema.id = baseUri;
		}
		if (Array.isArray(schema)) {
			for (var i = 0; i < schema.length; i++) {
				normSchema(schema[i], baseUri);
			}
		} else {
			if (typeof schema['$ref'] === "string") {
				schema['$ref'] = resolveUrl(baseUri, schema['$ref']);
			}
			for (var key in schema) {
				if (key !== "enum") {
					normSchema(schema[key], baseUri);
				}
			}
		}
	}
}

function defaultErrorReporter(language) {
	language = language || 'en';

	var errorMessages = languages[language];

	return function (error) {
		var messageTemplate = errorMessages[error.code] || ErrorMessagesDefault[error.code];
		if (typeof messageTemplate !== 'string') {
			return "Unknown error code " + error.code + ": " + JSON.stringify(error.messageParams);
		}
		var messageParams = error.params;
		// Adapted from Crockford's supplant()
		return messageTemplate.replace(/\{([^{}]*)\}/g, function (whole, varName) {
			var subValue = messageParams[varName];
			return typeof subValue === 'string' || typeof subValue === 'number' ? subValue : whole;
		});
	};
}

var ErrorCodes = {
	INVALID_TYPE: 0,
	ENUM_MISMATCH: 1,
	ANY_OF_MISSING: 10,
	ONE_OF_MISSING: 11,
	ONE_OF_MULTIPLE: 12,
	NOT_PASSED: 13,
	// Numeric errors
	NUMBER_MULTIPLE_OF: 100,
	NUMBER_MINIMUM: 101,
	NUMBER_MINIMUM_EXCLUSIVE: 102,
	NUMBER_MAXIMUM: 103,
	NUMBER_MAXIMUM_EXCLUSIVE: 104,
	NUMBER_NOT_A_NUMBER: 105,
	// String errors
	STRING_LENGTH_SHORT: 200,
	STRING_LENGTH_LONG: 201,
	STRING_PATTERN: 202,
	// Object errors
	OBJECT_PROPERTIES_MINIMUM: 300,
	OBJECT_PROPERTIES_MAXIMUM: 301,
	OBJECT_REQUIRED: 302,
	OBJECT_ADDITIONAL_PROPERTIES: 303,
	OBJECT_DEPENDENCY_KEY: 304,
	// Array errors
	ARRAY_LENGTH_SHORT: 400,
	ARRAY_LENGTH_LONG: 401,
	ARRAY_UNIQUE: 402,
	ARRAY_ADDITIONAL_ITEMS: 403,
	// Custom/user-defined errors
	FORMAT_CUSTOM: 500,
	KEYWORD_CUSTOM: 501,
	// Schema structure
	CIRCULAR_REFERENCE: 600,
	// Non-standard validation options
	UNKNOWN_PROPERTY: 1000
};
var ErrorCodeLookup = {};
for (var key in ErrorCodes) {
	ErrorCodeLookup[ErrorCodes[key]] = key;
}
var ErrorMessagesDefault = {
	INVALID_TYPE: "Invalid type: {type} (expected {expected})",
	ENUM_MISMATCH: "No enum match for: {value}",
	ANY_OF_MISSING: "Data does not match any schemas from \"anyOf\"",
	ONE_OF_MISSING: "Data does not match any schemas from \"oneOf\"",
	ONE_OF_MULTIPLE: "Data is valid against more than one schema from \"oneOf\": indices {index1} and {index2}",
	NOT_PASSED: "Data matches schema from \"not\"",
	// Numeric errors
	NUMBER_MULTIPLE_OF: "Value {value} is not a multiple of {multipleOf}",
	NUMBER_MINIMUM: "Value {value} is less than minimum {minimum}",
	NUMBER_MINIMUM_EXCLUSIVE: "Value {value} is equal to exclusive minimum {minimum}",
	NUMBER_MAXIMUM: "Value {value} is greater than maximum {maximum}",
	NUMBER_MAXIMUM_EXCLUSIVE: "Value {value} is equal to exclusive maximum {maximum}",
	NUMBER_NOT_A_NUMBER: "Value {value} is not a valid number",
	// String errors
	STRING_LENGTH_SHORT: "String is too short ({length} chars), minimum {minimum}",
	STRING_LENGTH_LONG: "String is too long ({length} chars), maximum {maximum}",
	STRING_PATTERN: "String does not match pattern: {pattern}",
	// Object errors
	OBJECT_PROPERTIES_MINIMUM: "Too few properties defined ({propertyCount}), minimum {minimum}",
	OBJECT_PROPERTIES_MAXIMUM: "Too many properties defined ({propertyCount}), maximum {maximum}",
	OBJECT_REQUIRED: "Missing required property: {key}",
	OBJECT_ADDITIONAL_PROPERTIES: "Additional properties not allowed",
	OBJECT_DEPENDENCY_KEY: "Dependency failed - key must exist: {missing} (due to key: {key})",
	// Array errors
	ARRAY_LENGTH_SHORT: "Array is too short ({length}), minimum {minimum}",
	ARRAY_LENGTH_LONG: "Array is too long ({length}), maximum {maximum}",
	ARRAY_UNIQUE: "Array items are not unique (indices {match1} and {match2})",
	ARRAY_ADDITIONAL_ITEMS: "Additional items not allowed",
	// Format errors
	FORMAT_CUSTOM: "Format validation failed ({message})",
	KEYWORD_CUSTOM: "Keyword failed: {key} ({message})",
	// Schema structure
	CIRCULAR_REFERENCE: "Circular $refs: {urls}",
	// Non-standard validation options
	UNKNOWN_PROPERTY: "Unknown property (not in schema)"
};

function ValidationError(code, params, dataPath, schemaPath, subErrors) {
	Error.call(this);
	if (code === undefined) {
		throw new Error ("No error code supplied: " + schemaPath);
	}
	this.message = '';
	this.params = params;
	this.code = code;
	this.dataPath = dataPath || "";
	this.schemaPath = schemaPath || "";
	this.subErrors = subErrors || null;

	var err = new Error(this.message);
	this.stack = err.stack || err.stacktrace;
	if (!this.stack) {
		try {
			throw err;
		}
		catch(err) {
			this.stack = err.stack || err.stacktrace;
		}
	}
}
ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;
ValidationError.prototype.name = 'ValidationError';

ValidationError.prototype.prefixWith = function (dataPrefix, schemaPrefix) {
	if (dataPrefix !== null) {
		dataPrefix = dataPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
		this.dataPath = "/" + dataPrefix + this.dataPath;
	}
	if (schemaPrefix !== null) {
		schemaPrefix = schemaPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
		this.schemaPath = "/" + schemaPrefix + this.schemaPath;
	}
	if (this.subErrors !== null) {
		for (var i = 0; i < this.subErrors.length; i++) {
			this.subErrors[i].prefixWith(dataPrefix, schemaPrefix);
		}
	}
	return this;
};

function isTrustedUrl(baseUrl, testUrl) {
	if(testUrl.substring(0, baseUrl.length) === baseUrl){
		var remainder = testUrl.substring(baseUrl.length);
		if ((testUrl.length > 0 && testUrl.charAt(baseUrl.length - 1) === "/")
			|| remainder.charAt(0) === "#"
			|| remainder.charAt(0) === "?") {
			return true;
		}
	}
	return false;
}

var languages = {};
function createApi(language) {
	var globalContext = new ValidatorContext();
	var currentLanguage;
	var customErrorReporter;
	var api = {
		setErrorReporter: function (reporter) {
			if (typeof reporter === 'string') {
				return this.language(reporter);
			}
			customErrorReporter = reporter;
			return true;
		},
		addFormat: function () {
			globalContext.addFormat.apply(globalContext, arguments);
		},
		language: function (code) {
			if (!code) {
				return currentLanguage;
			}
			if (!languages[code]) {
				code = code.split('-')[0]; // fall back to base language
			}
			if (languages[code]) {
				currentLanguage = code;
				return code; // so you can tell if fall-back has happened
			}
			return false;
		},
		addLanguage: function (code, messageMap) {
			var key;
			for (key in ErrorCodes) {
				if (messageMap[key] && !messageMap[ErrorCodes[key]]) {
					messageMap[ErrorCodes[key]] = messageMap[key];
				}
			}
			var rootCode = code.split('-')[0];
			if (!languages[rootCode]) { // use for base language if not yet defined
				languages[code] = messageMap;
				languages[rootCode] = messageMap;
			} else {
				languages[code] = Object.create(languages[rootCode]);
				for (key in messageMap) {
					if (typeof languages[rootCode][key] === 'undefined') {
						languages[rootCode][key] = messageMap[key];
					}
					languages[code][key] = messageMap[key];
				}
			}
			return this;
		},
		freshApi: function (language) {
			var result = createApi();
			if (language) {
				result.language(language);
			}
			return result;
		},
		validate: function (data, schema, checkRecursive, banUnknownProperties) {
			var def = defaultErrorReporter(currentLanguage);
			var errorReporter = customErrorReporter ? function (error, data, schema) {
				return customErrorReporter(error, data, schema) || def(error, data, schema);
			} : def;
			var context = new ValidatorContext(globalContext, false, errorReporter, checkRecursive, banUnknownProperties);
			if (typeof schema === "string") {
				schema = {"$ref": schema};
			}
			context.addSchema("", schema);
			var error = context.validateAll(data, schema, null, null, "");
			if (!error && banUnknownProperties) {
				error = context.banUnknownProperties(data, schema);
			}
			this.error = error;
			this.missing = context.missing;
			this.valid = (error === null);
			return this.valid;
		},
		validateResult: function () {
			var result = {toString: function () {
				return this.valid ? 'valid' : this.error.message;
			}};
			this.validate.apply(result, arguments);
			return result;
		},
		validateMultiple: function (data, schema, checkRecursive, banUnknownProperties) {
			var def = defaultErrorReporter(currentLanguage);
			var errorReporter = customErrorReporter ? function (error, data, schema) {
				return customErrorReporter(error, data, schema) || def(error, data, schema);
			} : def;
			var context = new ValidatorContext(globalContext, true, errorReporter, checkRecursive, banUnknownProperties);
			if (typeof schema === "string") {
				schema = {"$ref": schema};
			}
			context.addSchema("", schema);
			context.validateAll(data, schema, null, null, "");
			if (banUnknownProperties) {
				context.banUnknownProperties(data, schema);
			}
			var result = {toString: function () {
				return this.valid ? 'valid' : this.error.message;
			}};
			result.errors = context.errors;
			result.missing = context.missing;
			result.valid = (result.errors.length === 0);
			return result;
		},
		addSchema: function () {
			return globalContext.addSchema.apply(globalContext, arguments);
		},
		getSchema: function () {
			return globalContext.getSchema.apply(globalContext, arguments);
		},
		getSchemaMap: function () {
			return globalContext.getSchemaMap.apply(globalContext, arguments);
		},
		getSchemaUris: function () {
			return globalContext.getSchemaUris.apply(globalContext, arguments);
		},
		getMissingUris: function () {
			return globalContext.getMissingUris.apply(globalContext, arguments);
		},
		dropSchemas: function () {
			globalContext.dropSchemas.apply(globalContext, arguments);
		},
		defineKeyword: function () {
			globalContext.defineKeyword.apply(globalContext, arguments);
		},
		defineError: function (codeName, codeNumber, defaultMessage) {
			if (typeof codeName !== 'string' || !/^[A-Z]+(_[A-Z]+)*$/.test(codeName)) {
				throw new Error('Code name must be a string in UPPER_CASE_WITH_UNDERSCORES');
			}
			if (typeof codeNumber !== 'number' || codeNumber%1 !== 0 || codeNumber < 10000) {
				throw new Error('Code number must be an integer > 10000');
			}
			if (typeof ErrorCodes[codeName] !== 'undefined') {
				throw new Error('Error already defined: ' + codeName + ' as ' + ErrorCodes[codeName]);
			}
			if (typeof ErrorCodeLookup[codeNumber] !== 'undefined') {
				throw new Error('Error code already used: ' + ErrorCodeLookup[codeNumber] + ' as ' + codeNumber);
			}
			ErrorCodes[codeName] = codeNumber;
			ErrorCodeLookup[codeNumber] = codeName;
			ErrorMessagesDefault[codeName] = ErrorMessagesDefault[codeNumber] = defaultMessage;
			for (var langCode in languages) {
				var language = languages[langCode];
				if (language[codeName]) {
					language[codeNumber] = language[codeNumber] || language[codeName];
				}
			}
		},
		reset: function () {
			globalContext.reset();
			this.error = null;
			this.missing = [];
			this.valid = true;
		},
		missing: [],
		error: null,
		valid: true,
		normSchema: normSchema,
		resolveUrl: resolveUrl,
		getDocumentUri: getDocumentUri,
		errorCodes: ErrorCodes
	};
	api.language(language || 'en');
	return api;
}

var tv4 = createApi();
tv4.addLanguage('en-gb', ErrorMessagesDefault);

//legacy property
tv4.tv4 = tv4;

return tv4; // used by _header.js to globalise.

}));
},{}],83:[function(require,module,exports){
"use strict";

var AppWrapperCtrl = function AppWrapperCtrl($location, $scope, npolarApiConfig, npdcAppConfig, NpolarApiSecurity, NpolarTranslate) {
  'ngInject';

  $scope.options = npdcAppConfig;

  $scope.security = NpolarApiSecurity;
  $scope.q = $location.search().q;

  if ("production" === npolarApiConfig.environment) {
    if ("data.npolar.no" !== window.location.hostname) {
      $scope.warning = true;
    }
  }
};
AppWrapperCtrl.$inject = ["$location", "$scope", "npolarApiConfig", "npdcAppConfig", "NpolarApiSecurity", "NpolarTranslate"];

module.exports = AppWrapperCtrl;

},{}],84:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<npdc:toolbar options="options"></npdc:toolbar>\n<div ng-if="warning" class="np-environment-warning">!! Environment: Production !!</div>\n\n<!-- Content wrapper -->\n<md-content class="np-content-wrapper">\n  <!-- Subheader bar -->\n  <div class="np-sub-toolbar"></div>\n\n  <div class="np-content-card">\n\n    <main class="np-content md-whiteframe-12dp" layout="column">\n      <npdc:warnings></npdc:warnings>\n      <!--<div hide-gt-xs><npdc:breadcrumbs></npdc:breadcrumbs></div>-->\n      <div ng-view autoscroll="true"></div>\n    </main>\n  </div>\n</md-content>\n\n<npdc:footer></npdc:footer>\n';
},{}],85:[function(require,module,exports){
"use strict";

var appWrapper = function appWrapper() {
  'ngInject';

  return {
    restrict: 'E',
    template: require('./app.html'),
    controller: 'NpdcAppController'
  };
};

module.exports = appWrapper;

},{"./app.html":84}],86:[function(require,module,exports){
"use strict";

var BottomSheetController = function BottomSheetController($scope, $mdBottomSheet) {
  "ngInject";

  $scope.showBottomSheet = function ($event) {
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-template.tmpl',
      scope: $scope,
      preserveScope: true,
      controller: ["$scope", "$timeout", function controller($scope, $timeout) {
        'ngInject';

        var init = function init() {
          var wrapper = document.querySelector('.np-content');
          if (wrapper) {
            var viewHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            var viewOffsetBottom = wrapper.getBoundingClientRect().bottom;
            if (viewOffsetBottom > viewHeight) {
              var bottomSheet = document.getElementsByTagName('md-bottom-sheet')[0];
              bottomSheet.style.bottom = viewOffsetBottom - viewHeight + 'px';
            }
          }
        };
        $timeout(init);
      }],
      targetEvent: $event,
      parent: document.querySelector('.np-content')
    });
  };

  $scope.listItemClick = function ($index) {
    var item = $scope.options.items[$index];
    item.action.apply({});
    $mdBottomSheet.hide(item);
  };
};
BottomSheetController.$inject = ["$scope", "$mdBottomSheet"];

module.exports = BottomSheetController;

},{}],87:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div>\n  <md-button class="md-icon-button np-bottom-sheet-toggle" ng-click="showBottomSheet($event)">\n    <md-icon>menu</md-icon>\n    <md-tooltip>{{ \'edit.actions\' | t }}</md-tooltip>\n  </md-button>\n  <div ng-if="options.alwaysShow" ng-include="\'bottom-sheet-template.tmpl\'"></div>\n</div>\n\n<script type="text/ng-template" id="bottom-sheet-template.tmpl">\n  <md-bottom-sheet class="md-grid" layout="column" ng-cloak>\n    <md-list flex layout="row" layout-align="center center">\n      <md-list-item ng-repeat="item in options.items">\n        <md-button class="md-grid-item-content {{item.classes}}" ng-click="listItemClick($index)">\n          <md-icon>{{item.icon}}</md-icon>\n          <div class="md-grid-text"> {{ item.name }} </div>\n        </md-button>\n      </md-list-item>\n    </md-list>\n  </md-bottom-sheet>\n</script>\n';
},{}],88:[function(require,module,exports){
"use strict";

var npdcBottomSheetDirective = function npdcBottomSheetDirective() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      options: '='
    },
    template: require('./bottomSheet.html'),
    controller: 'NpdcBottomSheetController'
  };
};

module.exports = npdcBottomSheetDirective;

},{"./bottomSheet.html":87}],89:[function(require,module,exports){
'use strict';

var BottomController = function BottomController($scope, $location, NpolarApiSecurity) {
  'ngInject';

  $scope.security = NpolarApiSecurity;
  $scope.q = $location.search().q;
};
BottomController.$inject = ["$scope", "$location", "NpolarApiSecurity"];

module.exports = BottomController;

},{}],90:[function(require,module,exports){
'use strict';

var Bottom = function Bottom() {
  'ngInject';

  return {
    controller: 'NpdcBottomController',
    templateUrl: 'npdc-common/src/components/bottom/npdc-bottom.html'
  };
};

module.exports = Bottom;

},{}],91:[function(require,module,exports){
'use strict';

var BreadcrumbsController = function BreadcrumbsController($scope, NpdcBreadcrumbs) {
  'ngInject';

  $scope.breadcrumbs = NpdcBreadcrumbs;
};
BreadcrumbsController.$inject = ["$scope", "NpdcBreadcrumbs"];

module.exports = BreadcrumbsController;

},{}],92:[function(require,module,exports){
'use strict';

/**
 * Angular breadcrumbs service
 */

var NpdcBreadcrumbs = function NpdcBreadcrumbs($location, $rootScope, $window) {
  'ngInject';

  var self = this;

  this.breadcrumbs = [];

  this.path = "";

  var home = { href: "/home", title: "Home [Norwegian Polar Data Centre]", text: "home" };

  var translate = function translate(string) {
    return string; // .charAt(0).toUpperCase() + string.slice(1);
  };

  var link = function link(crumb, i) {
    if (i === 0) {
      return home;
    }

    if (i > 0) {
      self.path += '/' + crumb;
    }

    var href = self.path;
    var title = translate(crumb);
    var text = decodeURIComponent(translate(crumb)) || title || href;
    if (/^[0-9a-f]{8}-/i.test(crumb)) {
      text = crumb.split('-')[0];
    }
    return { href: href, title: title, text: text };
  };

  var buildCrumbs = function buildCrumbs(event, uri) {
    // Get URI parts (split by /)
    var parts = uri.split("//")[1].split('?')[0].split("/").slice(1).filter(function (p) {
      return !!p;
    });

    // Handle home
    if (parts[0] === 'home') {
      self.path += '/home';
    } else {
      parts.unshift('home');
    }

    // Add query
    if ($location.search().q) {
      parts = parts.concat('"' + $location.search().q + '"');
    }

    // Handle "new"
    if (JSON.stringify(parts.slice(-2)) === JSON.stringify(['__new', 'edit'])) {
      parts = parts.slice(0, -2).concat('new');
    }

    var i = 0;
    self.breadcrumbs = parts.map(function (crumb) {
      return link(crumb, i++);
    });
    // Set html/head/title
    $window.document.title = $location.host() + ' > ' + self.breadcrumbs.slice(1).map(function (b) {
      return b.text.toLowerCase();
    }).join(' > ');
    self.path = "";
  };

  buildCrumbs(null, $location.absUrl());
  $rootScope.$on('$locationChangeSuccess', buildCrumbs);

  return this;
};
NpdcBreadcrumbs.$inject = ["$location", "$rootScope", "$window"];

module.exports = NpdcBreadcrumbs;

},{}],93:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<span class="npdc-crumbs-container">\n	<span ng-repeat="crumb in breadcrumbs.breadcrumbs">\n    <span ng-if="!$last">\n      <a ng-href="{{crumb.href}}" title="{{ (crumb.title || crumb.text) | t }}">{{ crumb.text | t }}</a>\n      <md-icon>chevron_right</md-icon>\n    </span>\n    <span ng-if="$last">{{ crumb.text  | t }}</span>\n  </span>\n</span>';
},{}],94:[function(require,module,exports){
'use strict';

var breadcrumbs = function breadcrumbs() {
  return {
    controller: 'NpdcBreadcrumbsController',
    template: require('./breadcrumbs.html')
  };
};

module.exports = breadcrumbs;

},{"./breadcrumbs.html":93}],95:[function(require,module,exports){
'use strict';

var DeleteButtonComponent = function DeleteButtonComponent($scope, $mdDialog, NpolarApiSecurity) {
  'ngInject';

  $scope.security = NpolarApiSecurity;

  $scope.confirmDelete = function (ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm().title('DELETE').textContent('Are you sure you want to delete?').targetEvent(ev).ok('Delete').cancel('Cancel');
    $mdDialog.show(confirm).then(function () {
      $scope.delete();
    }, function () {
      // noop
    });
  };
};
DeleteButtonComponent.$inject = ["$scope", "$mdDialog", "NpolarApiSecurity"];

module.exports = DeleteButtonComponent;

},{}],96:[function(require,module,exports){
'use strict';

var CreateButton = function CreateButton() {
  'ngInject';

  return {
    controller: "NpdcButtonComponent",
    templateUrl: 'npdc-common/src/components/button/create-button.html'
  };
};
module.exports = CreateButton;

},{}],97:[function(require,module,exports){
'use strict';

var DeleteButton = function DeleteButton() {
  'ngInject';

  return {
    controller: "NpdcButtonComponent",
    templateUrl: 'npdc-common/src/components/button/delete-button.html'
  };
};

module.exports = DeleteButton;

},{}],98:[function(require,module,exports){
'use strict';

var EditButton = function EditButton() {
  'ngInject';

  return {
    controller: "NpdcButtonComponent",
    templateUrl: 'npdc-common/src/components/button/edit-button.html'
  };
};

module.exports = EditButton;

},{}],99:[function(require,module,exports){
'use strict';

var SaveButton = function SaveButton() {
  'ngInject';

  return {
    controller: "NpdcButtonComponent",
    templateUrl: 'npdc-common/src/components/button/save-button.html'
  };
};

module.exports = SaveButton;

},{}],100:[function(require,module,exports){
module.exports = '<span ng-if="ctrl.isAuthenticated() && ctrl.getFacet(\'created_by\')">\n  <md-content>\n    <md-menu>\n      <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open contributors menu">\n        <md-icon>person</md-icon>\n        <md-tooltip>{{ \'Contributors\' | t }}</md-tooltip>\n      </md-button>\n\n      {{ ctrl.getUser().email | name }}\n\n      <md-menu-content width="6">\n        <!-- @todo searchable autocomplete list? -->\n        <md-subheader>{{ \'Created by\' | t }}</md-subheader>\n        <md-menu-item ng-repeat="f in ctrl.getFacet(\'created_by\', facets)">\n          <md-button rel="nofollow" ng-href="?filter-created_by={{f.term}}">{{ f.term | name }} [{{f.term}}] ({{f.count}})</md-button>\n        </md-menu-item>\n      </md-menu-content>\n    </md-menu>\n\n    <npdc:facet-link value="{{ ctrl.getUser().email }}" field="created_by" params="{ sort: \'-created\'}" text="is&#160;creator" count="{{ctrl.count(\'created_by\', ctrl.getUser().email) }}"></npdc:facet-link>\n    <npdc:facet-link value="{{ ctrl.getUser().email }}" field="updated_by" params="{ sort: \'-updated\'}" text="is&#160;last&#160;editor" count="{{ctrl.count(\'updated_by\', ctrl.getUser().email) }}"></npdc:facet-link>\n    <npdc:facet-link ng-if="ctrl.getFacet(\'people.email\')" value="{{ ctrl.getUser().email }}" field="people.email" text="is&#160;contributor" count="{{ctrl.count(\'people.email\', ctrl.getUser().email) }}"></npdc:facet-link>\n  </md-content>\n\n</span>';
},{}],101:[function(require,module,exports){
'use strict';

function contributions() {
  'ngInject';

  // Get edits from Editlog API ?
  //if (NpolarApiSecurity.isAuthenticated()) {
  //  $scope.user = NpolarApiSecurity.getUser();
  //  Editlog.facets({q:'', 'filter-request.username': $scope.user.email}, r => {
  //    $scope.contributions = r.find(f => f.facet === 'endpoint').terms.map(t => {
  //      return { text: t.term, href: `${t.term}?q=${$scope.user.name.split(' ').join('+')}`, count: t.count }; });
  //  });
  //}

  return {

    restrict: 'E',

    scope: {
      facets: '='
    },
    template: require('./contributions.html'),
    controller: ["$scope", "$location", "NpolarApiSecurity", function ContributionsController($scope, $location, NpolarApiSecurity) {
      'ngInject';

      var ctrl = this;

      this._user = null;

      this.getUser = function () {
        if ($location.search()['filter-created_by']) {
          var email = $location.search()['filter-created_by'];
          return { email: email, count: 0 };
        }
        return ctrl._user || NpolarApiSecurity.getUser();
      };

      this.isAuthenticated = function () {
        return NpolarApiSecurity.isAuthenticated();
      };

      this.count = function (field, term) {
        var facet = ctrl.getFacet(field);

        if (!term && facet) {
          return facet.length;
        } else if (term && facet) {
          var found = facet.find(function (f) {
            return f.term === term;
          });
          if (found && found.count) {
            return found.count;
          } else {
            return 0;
          }
        } else {
          return 0;
        }
      };

      this.getFacet = function (key) {
        var facets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $scope.facets;

        if (!facets) {
          return;
        }
        var contribs = facets.filter(function (f) {
          return Object.keys(f).includes(key) && f[key];
        }).map(function (c) {
          return c[key];
        })[0];
        return contribs;
      };

      this.setUser = function (email, count) {
        var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : email;

        ctrl._user = { name: name, email: email, count: count };
      };
    }],
    controllerAs: 'ctrl'

  };
}
module.exports = contributions;

},{"./contributions.html":100}],102:[function(require,module,exports){
'use strict';

AuthorsController.$inject = ["$scope", "$location", "$anchorScroll"];
function AuthorsController($scope, $location, $anchorScroll) {
  'ngInject';

  var self = this;

  var name = function name(p) {
    return ((p.first_name || '') + ' ' + p.last_name).trim();
  };

  this.icon = function () {
    if ($scope.icon) {
      return $scope.icon;
    }
    return 'people';
  };

  this._show = { author: true, contributor: false, affiliations: false };

  this.flip = function () {
    var role = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'contributor';

    self._show[role] = !self._show[role];
  };

  this.show = function (role) {
    return self._show[role];
  };

  // Inject contributors (other than authors) from outside scope
  this.contributors = ($scope.people || []).filter(function (p) {
    return false === p.roles.includes('author');
  }).map(function (c) {
    if (c && !c.name && c.last_name) {
      c.name = name(c);
    }
    return c;
  });

  // Inject authors from outside scope
  this.authors = ($scope.authors || []).map(function (a) {
    if (a && !a.name && a.last_name) {
      a.name = name(a);
    }
    return a;
  });

  $scope.document = { people: self.authors.concat(self.contributors || []) };

  this.isNpolar = function (o) {
    return (/npolar\.no|NPI|Norsk Polarinstitutt|Norwegian Polar Institute/i.test(o)
    );
  };

  this.tinyLogo = function (id) {
    return "http://www.npolar.no/system/modules/no.npolar.site.npweb/resources/style/np-logo.svg?fingerprint=1386594068655";
  };

  $scope.hasRole = function (person, role) {
    if (!person || !person.roles.length || !role) {
      return;
    }
    return person.roles.includes(role);
  };

  $scope.gotoPerson = function (person) {
    if (!person) {
      return;
    }
    var anchor = (person.first_name + '+' + person.last_name).toLowerCase();
    console.log('gotoPerson', person, anchor);
    $location.hash(anchor);
    $anchorScroll();
  };

  $scope.isContact = function (person) {
    if (!person || !person.roles.length || person.roles.length < 1) {
      return;
    }
    if (person.roles.findIndex(function (r) {
      return ['correspondent', 'pointOfContact'].includes(r);
    }) >= 0) {
      return true;
    }
  };
}
module.exports = AuthorsController;

},{}],103:[function(require,module,exports){
'use strict';

var authorsDirective = function authorsDirective() {
  'ngInject';

  return {
    scope: {
      authors: '=',
      icon: '@?',
      people: '=?' // may include or exclude authors
    },
    template: require('./authorstemplate.html'),
    controller: 'NpdcAuthorsController',
    controllerAs: 'ctrl'
  };
};

module.exports = authorsDirective;

},{"./authorstemplate.html":104}],104:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<section ng-controller="NpdcAuthorsController as ctrl">\n  <md-menu>\n\n    <md-button class="md-fab md-primary md-hue-2" aria-label="Open people interactions menu" ng-click="$mdMenu.open($event)">\n       <md-icon md-menu-origin>{{ctrl.icon()}}</md-icon>\n       <md-tooltip md-direction="top">{{ authors.length }} {{ (authors.length > 1) ? (\'authors\'|t) : (\'author\'|t) }}\n        <span ng-if="ctrl.contributors.length > 0">{{ contributors.length}}</span>\n       </md-tooltip>\n    </md-button>\n\n    <md-menu-content width="6">\n\n        <md-menu-item ng-if="ctrl.contributors.length > 0">\n          <md-button ng-click="ctrl.flip(\'contributor\')">\n            Show {{ ctrl.show(\'contributor\') ? \'only authors\' : \'contributors\' }}\n          </md-button>\n        </md-menu-item>\n\n        <md-menu-divider ng-if="ctrl.contributors.length > 0"></md-menu-divider>\n\n        <md-menu-item>\n          <md-button md-autofocus ng-click="ctrl.flip(\'affiliations\')">\n            Show {{ ctrl.show(\'affiliations\') ? \'names\' : \'affiliations\' }}\n          </md-button>\n        </md-menu-item>\n\n    </md-menu-content>\n  </md-menu>\n\n  <span ng-show="true" class="np-authors">\n    <span ng-repeat="p in ctrl.authors" class="author" ng-click="ctrl.gotoPerson(p)">\n      <span>{{ p.name }}<md-tooltip md-direction="top" md-delay="250">{{ p.roles }}</md-tooltip></span><a ng-if="p.email && isContact(p)" ng-href="mailto:{{p.email}}"><md-icon>email</md-icon><md-tooltip md-direction="bottom" md-delay="250">{{ p.email }}</md-tooltip></a><span class="md-caption" ng-show="ctrl.show(\'affiliations\')"><span ng-if="ctrl.isNpolar(p.organisation)"><img height="20" ng-src="{{ctrl.tinyLogo(\'npolar.no\')}}" alt="npolar.no"><md-tooltip md-direction="top" md-delay="250">{{ \'npolar.no\'|t }}</md-tooltip></img></span><span ng-if="!ctrl.isNpolar(p.organisation)">&#160;({{ p.organisation }})<md-tooltip md-direction="top" md-delay="250">{{ p.organisation|t }}</md-tooltip></span></span><span ng-if="!$last">,</span>\n    </span>\n    <p ng-show="ctrl.show(\'contributor\')">\n      <span ng-repeat="p in ctrl.contributors" ng-click="ctrl.gotoPerson(p)">\n        {{ p.name  }} {{ p.roles|json}}<a ng-if="p.email && isContact(p)" ng-href="mailto:{{p.email}}"><md-icon>email</md-icon></a>\n        <md-tooltip md-direction="top" md-delay="150">{{ p.name  }} ({{ (p.organisation||\'\') | t}})</md-tooltip>\n        <span ng-if="!$last">, </span>\n      </span>\n    </p>\n  </span>\n\n\n</section>';
},{}],105:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div class="npdc-badges">\n  <a ng-if="openAccess" ng-href="//en.wikipedia.org/wiki/Open_access">\n    <img src="/assets/img/oa.png" height="31px" title="Open access">\n  </a>\n\n  <a ng-if="license" ng-href="{{ licenseHref }}">\n    <img ng-src="/assets/img/{{ licenseImg }}.png" height="31px" title="{{ licenseTitle }}">\n  </a>\n\n  <a ng-if="doi" ng-href="//doi.org/{{ doi }}">\n    <img src="/assets/img/doi.png" height="31px" title="Digital Object Identifier">\n  </a>\n  <a ng-if="doi" ng-href="//doi.org/{{ doi }}" style="padding-bottom: 0.5em;">{{ doi }}</a>\n</div>\n';
},{}],106:[function(require,module,exports){
"use strict";

module.exports = function () {
  "ngInject";

  return {
    scope: {
      doi: "=?",
      license: "=?",
      openAccess: "=?"
    },
    template: require("./badges.html"),
    controller: ["$scope", function controller($scope) {
      "ngInject";

      var licenses = {
        "cc-by-nc-nd": { img: "licenses/cc/by-nc-nd", href: "https://creativecommons.org/licenses/by-nc-nd/4.0/" },
        "cc-by-nc-sa": { img: "licenses/cc/by-nc-sa", href: "https://creativecommons.org/licenses/by-nc-sa/4.0/" },
        "cc-by-nc": { img: "licenses/cc/by-nc", href: "https://creativecommons.org/licenses/by-nc/4.0/" },
        "cc-by-nd": { img: "licenses/cc/by-nd", href: "https://creativecommons.org/licenses/by-nd/4.0/" },
        "cc-by-sa": { img: "licenses/cc/by-sa", href: "https://creativecommons.org/licenses/by-sa/4.0/" },
        "cc-by": { img: "licenses/cc/by", href: "https://creativecommons.org/licenses/by/4.0/" },
        "cc-zero": { img: "licenses/cc/zero", href: "https://creativecommons.org/publicdomain/zero/1.0/" }
      };

      Object.defineProperties($scope, {
        licenseHref: {
          get: function get() {
            var license = licenses[$scope.license];
            return license.href || "";
          }
        },
        licenseImg: {
          get: function get() {
            var license = licenses[$scope.license];
            return license.img || "";
          }
        },
        licenseTitle: {
          get: function get() {
            var license = licenses[$scope.license];
            return license.title || "";
          }
        }
      });
    }]
  };
};

},{"./badges.html":105}],107:[function(require,module,exports){
'use strict';

module.exports = ["NpdcDOI", function (NpdcDOI) {
  'ngInject';

  var self = this;

  // Handle 0,1,2-6,7- authors
  this.apa_style_list = function (who) {
    if (who.length === 0) {
      who = '';
    } else if (who.length === 1) {
      who = who[0];
    } else if (who.length >= 2) {
      var last = who.pop();
      if (who.length <= 7) {
        who = who.join(', ').trim() + ', & ' + last;
      } else {
        who = who.slice(0, 6).join(', ').trim() + ', … ' + last;
      }
    }
    return who;
  };

  this.authors = function (authors) {
    var who = authors.map(function (a) {
      // @todo has .apa?
      if (a.last_name && a.first_name) {
        a.initials = a.first_name.split(' ').map(function (c) {
          return c[0];
        });
        a.apa = (a.last_name + ', ' + (a.initials.join('. ') + '. ')).trim();
        if (!a.name) {
          a.name = a.first_name + ' ' + a.last_name;
        }
      } else if (a.name) {
        a.apa = a.name;
      } else {
        a.apa = '';
      }
      return a;
    });
    return self.apa_style_list(who.map(function (a) {
      return a.apa;
    }));
  };

  this.citation = function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { authors: [], year: null, title: '', type: 'Data set', publisher: '', uri: '' };

    // @todo handle authors as array of strings or string
    return self.authors(param.authors) + ' (' + param.year + ').\n  ' + param.title + ' [' + param.type + '].\n  ' + param.publisher + '. ' + param.uri;
  };

  this.reference = function (authors, year) {
    return self.authors(authors) + ' (' + year + ')';
  };
}];

},{}],108:[function(require,module,exports){
'use strict';

module.exports = ["NpdcDOI", function (NpdcDOI) {
  'ngInject';

  var self = this;

  // BibTeX citation
  // Based on http://www.bibtex.org/Format/ and http://citation.datacite.org/format?doi=10.21334/npolar.2016.408e8178&style=bibtex&lang=en-US
  this.bibtex = function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { type: '@misc', id: '', year: null, title: '', url: '', doi: '', publisher: '', author: null, authors: null };


    if (param.author && param.authors) {
      throw "Please provide only author (string) OR authors (array)";
    }

    var author = void 0;
    if (param.author instanceof Array && param.author.length > 0) {
      author = param.author.map(function (a) {
        return a.name;
      }).join(' and ');
    }
    var doi = '';
    if (NpdcDOI.isDoi(param.doi)) {
      doi = '\nDOI="' + param.doi + '",\n';
    }
    return '@' + param.type.replace(/^@/, '') + '{' + (param.doi || param.id) + ',\n  title="' + param.title + '",\nurl="' + param.url + '",' + doi + '\npublisher="' + param.publisher + '",\nauthor="' + author + '",\nyear={' + param.year + '}}';
  };

  /*
  @article {ECS2:ECS21213,
  author = {Hindell, Mark A. and McMahon, Clive R. and Bester, Marthán N. and Boehme, Lars and Costa, Daniel and Fedak, Mike A. and Guinet, Christophe and Herraiz-Borreguero, Laura and Harcourt, Robert G. and Huckstadt, Luis and Kovacs, Kit M. and Lydersen, Christian and McIntyre, Trevor and Muelbert, Monica and Patterson, Toby and Roquet, Fabien and Williams, Guy and Charrassin, Jean-Benoit},
  title = {Circumpolar habitat use in the southern elephant seal: implications for foraging success and population trajectories},
  journal = {Ecosphere},
  volume = {7},
  number = {5},
  issn = {2150-8925},
  url = {http://dx.doi.org/10.1002/ecs2.1213},
  doi = {10.1002/ecs2.1213},
  pages = {e01213--n/a},
  keywords = {foraging behavior, Mirounga leonina, physical oceanography, population status, sea ice, Southern Ocean water masses},
  year = {2016},
  note = {e01213},
  }
  */

  this.citation = self.bibtex;
}];

},{}],109:[function(require,module,exports){
'use strict';

module.exports = ["NpdcDOI", "NpdcAPA", "NpdcBibTeX", function (NpdcDOI, NpdcAPA, NpdcBibTeX) {
  'ngInject';

  var self = this;

  this.authors = function (d) {

    var authors = [];

    if (d && d.people && d.people.length > 0) {
      authors = d.people.filter(function (p) {
        return (p.roles || []).includes("author");
      });
    }
    if (!authors || authors.length === 0) {
      if (d && d.organisations && d.organisations.length > 0) {
        authors = d.organisations.filter(function (o) {
          return (o.roles || []).includes("author");
        });
      }
    }
    return authors;
  };

  this.publisher = function (d) {
    var p = (d.organisations || []).find(function (o) {
      return (o.roles || []).includes("publisher");
    });
    if (p) {
      return p;
    } else {
      return { name: null, id: null };
    }
  };

  this.published_year = function (d) {
    var y = void 0;
    if (d && d.published && /^\d{4}/.test(d.published)) {
      y = new Date(d.published).getFullYear();
    } else if (d && d.released && /^\d{4}/.test(d.released)) {
      y = new Date(d.released).getFullYear();
    } else {
      y = "not released";
    }
    return y;
  };
  this.year = self.published_year;

  this.uri = function (d) {
    var p = (d.organisations || []).find(function (o) {
      return o.roles.includes("publisher");
    });
    if (p) {
      return p;
    } else {
      return {};
    }
  };

  this.citationList = function (document) {
    var citation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.citationMapper;


    var list = [{ text: citation(document, { style: 'apa' }), title: 'APA' }, { text: citation(document, { style: 'bibtex' }), title: 'BibTeX' }, { text: citation(document, { style: 'csl' }), title: 'CSL JSON' }];
    if (document.doi) {
      // Use Datacite citation service for publications
      if (/publication/.test(document.schema)) {
        //{ href: `//data.datacite.org/application/x-bibtex/${document.doi}`, title: 'BibTeX (Datacite)'},
        list = [
        //{ text: citation(document, { style: 'apa'}), title: 'APA'},
        { href: '//citation.datacite.org/format?doi=' + document.doi + '&style=apa&lang=en-GB', title: 'APA' }, { href: '//citation.datacite.org/format?doi=' + document.doi + '&style=bibtex&lang=en-GB', title: 'BibTeX' }, { href: '//api.crossref.org/works/' + document.doi + '/transform/application/vnd.citationstyles.csl+json', title: 'CSL JSON' }, { href: '//api.crossref.org/works/' + document.doi + '/transform/application/x-research-info-systems', title: 'RIS'
          //{ href: `//api.crossref.org/works/${document.doi}/transform/application/vnd.crossref.unixref+xml`, title: 'XML'}
        }];
      } //else {
      //list.push({ href: `https://search.datacite.org/citation?format=ris&doi=${document.doi}`, title: 'RIS'});
      //list.push({ href: `//data.datacite.org/application/x-research-info-systems/${document.doi}`, title: 'RIS'});
      //}
    }

    list = list.sort(function (a, b) {
      return a.title.localeCompare(b.title);
    });

    if (document.citation) {
      list = [{ text: document.citation, title: 'Custom' }].concat(list);
    }
    return list;
  };
}];

},{}],110:[function(require,module,exports){
module.exports = '<span><md-icon>format_quote</md-icon>{{ \'Citation\'|t }}</span>\n<span ng-repeat="link in citations">\n  <a ng-click="citationClicked(link)" href="" title="{{link.type}}"><span ng-show="link.title != citation.title" >{{ link.title || link.href }}</span></a>\n  <b ng-show="link.title == citation.title" >{{ link.title || link.href }}</b>\n  <span ng-if="!$last">|</span>\n</span>\n<br ng-if="!isPreformatted(citation)"></br>\n<code ng-show="!error && !isPreformatted(citation)" class="np-citation">{{ citation.text }}</code>\n<pre ng-show="!error && isPreformatted(citation)" class="np-citation">{{ citation.text }}</pre>\n<pre>{{ error | t }}</pre>';
},{}],111:[function(require,module,exports){
'use strict';
// Top: citation directive

var citationDirective = function citationDirective($http) {
  'ngInject';

  return {
    scope: {
      citation: '=?',
      citations: '=?',
      uri: '=?'
    },
    template: require('./citation.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope = $scope;
      $scope.citation = $scope.citation || $scope.citations[0];
      $scope.error = null;

      // Use <pre> ? (Not for all as this breaks mobile views)
      $scope.isPreformatted = function (citation) {
        return citation.title === 'RIS';
      };

      $scope.citationClicked = function (link) {
        $scope.error = null;
        if (link.text) {
          $scope.citation = link;
        } else if (link.href) {
          $scope.citation = link;
          $http.get(link.href).then(function (r) {
            $scope.citation.text = r.data;
          }, function (e) {
            if (404 === e.status) {
              $scope.error = 'No ' + link.title + ' citation for this dataset yet\nNot found: ' + link.href;
            } else {
              $scope.error = 'Citation service ' + link.href + ' failed, status: ' + e.status;
            }
          });
        }
      };
    }]
  };
};
citationDirective.$inject = ["$http"];

module.exports = citationDirective;

},{"./citation.html":110}],112:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div class="np-collection md-default-theme md-chips">\n  <div class="md-chip">\n    <div class="md-chip-content" tabindex="-1" aria-hidden="true">\n      <md-icon>label_outline</md-icon><strong>{{ collection | t }}</strong>\n    </div>\n  </div>\n</div>\n';
},{}],113:[function(require,module,exports){
'use strict';

var collectionDirective = function collectionDirective() {
  'ngInject';

  return {
    scope: {
      collection: '='
    },
    template: require('./collection.html')
  };
};

module.exports = collectionDirective;

},{"./collection.html":112}],114:[function(require,module,exports){
"use strict";

var angular = require('angular');
var ui = angular.module('npdcCommon');

ui.directive('npdcDocument', require('./show/document'));
ui.directive('npdcShow', require('./show/document'));

ui.directive('npdcCitation', require('./citation/citationDirective'));
ui.service('NpdcBibTeX', require('./citation/BibTeX'));
ui.service('NpdcAPA', require('./citation/APA'));
ui.service('NpdcCitationModel', require('./citation/CitationModel'));

ui.directive('npdcOrganisations', require('./organisations/organisationsDirective'));
ui.directive('npdcPersons', require('./persons/personsDirective'));
ui.directive('npdcLinks', require('./links/linksDirective'));
ui.directive('npdcData', require('./links/dataDirective'));
ui.directive('npdcDocumentMeta', require('./meta/metaDirective'));

ui.controller('NpdcAuthorsController', require('./authors/AuthorsController'));

ui.directive('npdcAuthors', require('./authors/authorsDirective'));

ui.directive('npdcPlacenames', require('./placenames/placenamesDirective'));
ui.directive('npdcCollection', require('./collection/collectionDirective'));
ui.directive('npdcLicences', require('./licences/licencesDirective'));

ui.directive('npdcBadges', require('./badges/badgesDirective'));

},{"./authors/AuthorsController":102,"./authors/authorsDirective":103,"./badges/badgesDirective":106,"./citation/APA":107,"./citation/BibTeX":108,"./citation/CitationModel":109,"./citation/citationDirective":111,"./collection/collectionDirective":113,"./licences/licencesDirective":116,"./links/dataDirective":117,"./links/linksDirective":119,"./meta/metaDirective":121,"./organisations/organisationsDirective":124,"./persons/personsDirective":126,"./placenames/placenamesDirective":128,"./show/document":130,"angular":"angular"}],115:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div class="np-licences">\n  <a ng-repeat="l in licences" class="{{l.class}}" ng-href="{{l.href}}">{{l.text}}</a>\n</div>\n';
},{}],116:[function(require,module,exports){
'use strict';

var licencesDirective = function licencesDirective() {
  'ngInject';

  return {
    scope: {
      docLicenses: '=licences'
    },
    template: require('./licences.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      var cc = /creativecommons/;
      var nlod = /nlod/;

      $scope.licences = ($scope.docLicenses || []).map(function (l) {
        var licence = {
          href: l
        };
        if (cc.test(l)) {
          licence.class = 'cc';
        } else if (nlod.test(l)) {
          licence.class = 'nlod';
          licence.text = 'NLOD 1.0';
        }
        return licence;
      });
    }]
  };
};

module.exports = licencesDirective;

},{"./licences.html":115}],117:[function(require,module,exports){
'use strict';

var dataDirective = function dataDirective() {
  'ngInject';

  return {
    scope: {
      data: '=',
      licenses: '=',
      rights: '='
    },
    template: require('./datatemplate.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.licenceText = function (licence) {
        return licence;
        /*if (/\/by\//.test(licence)) {
          return 'CC BY';
        } else if (/\/nlod\//.test(licence)) {
          return 'NLOD';
        } else {
          return licence;
        }*/
      };
    }]
  };
};

module.exports = dataDirective;

},{"./datatemplate.html":118}],118:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<section ng-if="data.length > 0">\n  <md-divider></md-divider>\n  <h3>Data</h3>\n  \n  <md-list>\n    <md-list-item class="md-2-line" ng-repeat="d in data">\n        <md-icon>file_download</md-icon>\n        <!--div class="md-list-item-text">-->\n          <p><a ng-href="{{d.href}}"> {{ d.title || d.href }} {{d.type ? \'(\'+d.type+\')\':\'\'}}</a></p>\n          <!--<p>\n            <span ng-repeat="licence in licenses">\n              <a ng-href="{{licence}}">{{ licenceText(licence); }}</a>{{ $last ? \'\':\', \'}}\n            </span>\n          </p>-->\n        <!--/div>-->\n    </md-list-item>\n    <div marked="rights"></div>\n  </md-list>\n</section>\n';
},{}],119:[function(require,module,exports){
'use strict';

var linkDirective = function linkDirective() {
  'ngInject';

  return {
    scope: {
      links: '=',
      related: '='
    },
    template: require('./linkstemplate.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.isEmpty = function (related) {
        return !!related && !related.some(function (collection) {
          return collection.length > 0;
        });
      };
    }]
  };
};

module.exports = linkDirective;

},{"./linkstemplate.html":120}],120:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<section>\n\n   <md-card ng-if="links.length > 0">\n    <md-card-header>\n      <md-card-avatar>\n        <md-icon>subdirectory_arrow_right</md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class="md-headline">{{ \'Links\' | t }}</span>\n        <span class="md-subhead">\n        </span>\n      </md-card-header-text>\n    </md-card-header>\n    <md-card-content>\n      <span ng-repeat="link in links">\n        <span ng-if="link.rel != \'related\'">{{ link.rel | t  }}: </span><a ng-href="{{link.href}}" title="{{link.title}}">{{ link.title }}</a>\n        <span ng-if="!$last">|</span>\n      </span>\n    </md-card-content>\n  </md-card>\n\n\n  <div ng-if="!isEmpty(related)">\n    <md-list>\n      <md-subheader class="md-no-sticky" ng-repeat-start="collection in related" ng-if="collection[0]">{{ collection | t }}</md-subheader>\n      <md-list-item ng-repeat="rel in collection" ng-if="rel._score > 0.45" ng-repeat-end>\n        <div class="md-list-item-text">\n          <a ng-href="{{\'/\' + rel.collection + \'/\' + rel.id}}">{{ rel.title }}</a>\n          <span ng-show="true">[{{ rel._score }}]</span>\n        </div>\n      </md-list-item>\n    </md-list>\n  </div>\n\n</section>\n';
},{}],121:[function(require,module,exports){
'use strict';

var metaDirective = function metaDirective() {
  'ngInject';

  return {
    template: require('./metatemplate.html')
  };
};

module.exports = metaDirective;

},{"./metatemplate.html":122}],122:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div layout="row" layout-align="start start" class="np-document-meta">\n  <div class="document-meta">\n    <h4><md-icon>access_time</md-icon><span> {{\'Created\' | t}}: </span></h4><span>{{document.created.substr(0,10)}}</span>\n  </div>\n  <div class="document-meta">\n    <h4><md-icon>sync</md-icon><span> {{\'Updated\' | t}}: </span></h4><span>{{document.updated.substr(0,10)}}</span>\n  </div>\n  <div class="document-meta" ng-if="document.draft === \'yes\'">\n    <code>DRAFT</code>\n  </div>\n</div>\n';
},{}],123:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<!-- <section ng-if="document.organisations">\n  <h3 class="headline">{{\'Organisations\' | t}}</h3>\n  <md-divider></md-divider>\n  <md-list>\n    <md-list-item class="md-2-line" ng-repeat="o in document.organisations">\n      <md-icon>business</md-icon>\n      <div class="md-list-item-text">\n        <h3><a ng-href="{{resource.uiBase}}?q={{ (o.id || o.name|t) }}">{{ (o.name || o.id) | t }}</a></h3>\n        <p ng-if="o.role">{{o.role | t }}</p>\n        <p><span ng-repeat="r in o.roles">{{ r }}<span ng-if="!$last">, </span></span></p>\n        <a ng-href="{{o.homepage}}">{{o.homepage}}</a>\n      </div>\n    </md-list-item>\n  </md-list>\n</section>\n-->\n<md-card>\n    <md-card-header>\n      <md-card-avatar>\n        <md-icon>business</md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class="md-headline">{{\'Organisations\' | t}}</span>\n        <span class="md-subhead"></span>\n      </md-card-header-text>\n    </md-card-header>\n    <md-card-content>\n      <span class="md-subhead">\n      <md-list>\n        <md-list-item class="md-1-line" ng-repeat="o in document.organisations">\n\n          <div class="md-list-item-text">\n            <span>{{ (o.name) | t }} ({{ o.id }})</span>\n\n            <i ng-repeat="r in o.roles">{{ r | t }}<span ng-if="!$last">, </span></i>\n\n            <a ng-if="o.homepage" ng-href="{{o.homepage}}"><md-icon>home</md-icon><md-tooltip>{{\'Homepage\'}}: {{o.homepage}}</md-tooltip></a>\n            <!-- @todo create nice menu --><!--<md-button ng-href="{{resource.uiBase}}?q={{ (o.id || o.name|t) }}">{{ \'Search\' }}</md-button>-->\n          </div>\n        </md-list-item>\n      </md-list>\n      </span>\n    </md-card-content>\n  </md-card>';
},{}],124:[function(require,module,exports){
'use strict';
// Organisations directive

var organisationsDirective = function organisationsDirective() {
  'ngInject';

  return {
    template: require('./organisations.html')
  };
};

module.exports = organisationsDirective;

},{"./organisations.html":123}],125:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-card ng-if="document.people && document.people.length > 0">\n    <md-card-header>\n      <md-card-avatar>\n        <md-icon>person</md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class="md-headline">{{\'People\' | t}}</span>\n        <span class="md-subhead"></span>\n      </md-card-header-text>\n    </md-card-header>\n    <md-card-content>\n      <p ng-repeat="p in document.people">\n        <span id="{{ p.first_name | lowercase }}+{{ p.last_name | lowercase}}" class="anchor"></span>\n        <span>\n          {{ p.first_name}} {{ p.last_name}}\n        </span>\n\n        <span ng-if="p.organisation">({{ (p.organisation) }})</span>\n        <i ng-repeat="r in p.roles || [p.role]">{{ r | t }}<span ng-if="!$last">, </span></i>\n\n        <a ng-if="p.homepage" ng-href="{{p.homepage}}"><md-icon alt="Homepage">home</md-icon><md-tooltip>{{\'Homepage\'}}: {{p.homepage}}</md-tooltip></a>\n        <a ng-if="p.email && isPointOfContact(p)" ng-href="mailto:{{p.email}}"><md-icon>email</md-icon></a>\n        <!-- todo nice menu <md-button ng-href="{{resource.uiBase}}?q={{ p.name }}&filter-people.last_name={{p.last_name}}">{{ \'Search\' }}</md-button>-->\n\n      </p>\n    </md-card-content>\n  </md-card>\n';
},{}],126:[function(require,module,exports){
'use strict';
// Person directive

var personsDirective = function personsDirective() {
  'ngInject';

  return {
    template: require('./persons.html')
  };
};

module.exports = personsDirective;

},{"./persons.html":125}],127:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<section ng-if="document.placenames">\n  <h3>Placenames</h3>\n  <md-divider></md-divider>\n  <p>\n    <div ng-repeat="p in document.placenames">\n      <md-icon>place</md-icon><a ng-href="{{resource.uiBase}}?q={{ p.placename || p.area }}">{{ p.placename || p.area }}</a>\n    </div>\n  </p>\n</section>\n';
},{}],128:[function(require,module,exports){
'use strict';
// placenames directive

var placenamesDirective = function placenamesDirective() {
  'ngInject';

  return {
    template: require('./placenames.html')
  };
};

module.exports = placenamesDirective;

},{"./placenames.html":127}],129:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<script type="text/ng-template" id="any.html">\n  <div ng-if="isArray(value)" layout="row" class="np-document-array">\n    <div class="np-document-title md-title" flex>{{ key }}</div>\n    <ul flex="85">\n      <li ng-repeat="(key, value) in value">\n        <ng-include src="\'any.html\'"></ng-include>\n      </li>\n    </ul>\n  </div>\n  <div ng-if="isObject(value)" layout="row" class="np-document-object">\n    <div class="np-document-title md-title" flex>{{ key }}</div>\n    <ul flex="85">\n      <li ng-repeat="(key, value) in value">\n        <ng-include src="\'any.html\'"></ng-include>\n      </li>\n    </ul>\n  </div>\n  <div ng-if="isItem(value)" layout="row" class="np-document-item">\n    <div class="np-document-title md-title" flex>{{ key }}</div>\n    <div class="np-document-value" flex="85">{{ value }}</div>\n  </div>\n</script>\n\n<div class="np-document">\n  <npdc:edit-button class="np-primary-control"></npdc:edit-button>\n  <div class="np-document-ctrls" layout="row">\n    <div class="np-document-ctrls-title" flex>Fancy: </div><md-switch flex ng-model="fancy" aria-label="Render mode"></md-switch>\n  </div>\n  <ul ng-if="fancy">\n    <li ng-repeat="(key, value) in document">\n      <ng-include src="\'any.html\'"></ng-include>\n    </li>\n  </ul>\n  <pre ng-if="!fancy">\n    {{ document | json }}\n  </pre>\n</div>\n';
},{}],130:[function(require,module,exports){
"use strict";

var angular = require('angular');

var npdcDocument = function npdcDocument() {
  'ngInject';

  return {
    restrict: 'E',
    template: require('./document.html'),
    link: function link(scope) {
      scope.fancy = true;

      scope.isArray = function (value) {
        return Array.isArray(value);
      };
      scope.isObject = function (value) {
        return angular.isObject(value) && !Array.isArray(value);
      };
      scope.isItem = function (value) {
        return !(scope.isArray(value) || scope.isObject(value));
      };
    }
  };
};

module.exports = npdcDocument;

},{"./document.html":129,"angular":"angular"}],131:[function(require,module,exports){
'use strict';

module.exports = ["$timeout", "$rootScope", "$parse", function ($timeout, $rootScope, $parse) {
  'ngInject';

  return {
    restrict: 'A',
    compile: function compile($element, attr) {
      var fn = $parse(attr.ngFocusOut);
      return function ngEventHandler(scope, element) {
        element.on('focusout', function (event) {
          var callback = function callback() {
            fn(scope, {
              $event: event
            });
          };
          if ($rootScope.$$phase) {
            scope.$evalAsync(callback);
          } else {
            scope.$apply(callback);
          }
        });
      };
    }
  };
}];

},{}],132:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<footer layout="row" layout-align="center start" layout-wrap>\n  <div flex="33" flex-sm="50" flex-order-sm="2">\n    <div class="np-center-box">\n      <ol class="address"><md-tooltip>NPDC is a permanent facility operated by the {{ \'npolar.no\' |t }}</md-tooltip>\n        <li><strong><a href="https://data.npolar.no">Norwegian Polar Data Centre</a></strong></li>\n        <li><a href="http://npolar.no">{{ \'npolar.no\' |t }}</a></li>\n      </ol>\n\n    </div>\n  </div>\n  <div flex="33" flex-sm="50" flex-order-sm="1">\n    <md-tooltip>NPDC is registered with re3data.org</md-tooltip>\n    <div class="np-center-box">\n      <a href="https://doi.org/10.17616/R3B94H"><img src="/assets/img/re3datalogo.png" width="142px" style="max-width:100%"/></a>\n    </div>\n  </div>\n  <div flex="33" flex-sm="100" flex-order-sm="3">\n    <div class="np-center-box">\n      <md-button class="md-icon-button" href="http://github.com/npolar/npdc-common">\n        <i class="github-icon"></i>\n        <md-tooltip>Open source @ Github</md-tooltip>\n      </md-button>\n    </div>\n  </div>\n\n  <a href="" id="scroll-up" onclick="window.scrollTo(0, 0); window.location.hash = \'\';" hide-sm hide-xs>\n    <md-icon>keyboard_arrow_up</md-icon>\n    <md-tooltip md-direction="left">Scroll to top</md-tooltip>\n  </a>\n</footer>\n<npolar-message></npolar-message>\n\n<script>\n  // Google Analytics\n  // https://developers.google.com/analytics/devguides/collection/analyticsjs/\n  window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;\n  ga(\'create\', \'UA-770196-26\', \'auto\');\n  ga(\'send\', \'pageview\');\n</script>\n<script async src=\'//www.google-analytics.com/analytics.js\'></script>\n<script>\n  //https://support.google.com/analytics/answer/1136920?hl=en\n  /**\n  * Function that tracks a click on an outbound link in Google Analytics.\n  * For this to work the outbound link needs a onclick="trackOutboundLink(uri); return false;" like:\n  * [a href="http://api.npolar.no/oceanography/?q=&amp;format=json" onclick="trackOutboundLink(\'http://api.npolar.no/oceanography/?q=&amp;format=json\'); return false;" target="_blank"]Oceanography API[/a]\n  */\n  var trackOutboundLink = function(url) {\n     ga(\'send\', \'event\', \'outbound\', \'click\', url, {\'hitCallback\':\n       function () {\n       document.location = url;\n       }\n     });\n  };\n</script>\n';
},{}],133:[function(require,module,exports){
"use strict";

var footer = function footer() {
  'ngInject';

  return {
    template: require('./footer.html'),
    link: function link(scope, element) {
      var updateCallback = function updateCallback() {
        var scroller = element[0].querySelector("#scroll-up");
        var scrollY = window.pageYOffset;

        if (scrollY >= 100) {
          scroller.style.transform = "scale(1.0)";
        } else {
          scroller.style.transform = "scale(0.0)";
        }
      };

      window.addEventListener("scroll", updateCallback);
      window.addEventListener("resize", updateCallback);
      updateCallback();
    }
  };
};

module.exports = footer;

},{"./footer.html":132}],134:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div ng-if="field.visible">\n  <md-autocomplete\n    md-items="item in items"\n    md-item-text="label(item)"\n    md-min-length="minLength"\n    md-search-text="search.text"\n    md-floating-label="{{field.title}}"\n    md-selected-item-change="onSelect(item)"\n    md-select-on-match="true"\n    md-search-text-change="searchChange(search.text)"\n    md-match-case-insensitive="true">\n\n    <md-item-template>\n      <span md-highlight-flags="^i" md-highlight-text="search.text">{{label(item)}}</span>\n    </md-item-template>\n\n  <div npdc:formula-validation-message class="np-validation-message"></div>\n  </md-autocomplete>\n</div>\n';
},{}],135:[function(require,module,exports){
'use strict';

var autocompleteDirective = function autocompleteDirective($http, $q, formulaAutoCompleteService) {
  'ngInject';

  return {
    template: require('./autocomplete.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      var field = $scope.field;
      var config = formulaAutoCompleteService.getOptions(field);

      if (!config) {
        throw "Missing autocomplete config for " + field.path;
      }

      $scope.onSelect = function (item) {
        if (item) {
          field.value = $scope.value(item);

          if (typeof config.onSelect === 'function') {
            config.onSelect(item);
          }
        }
      };

      var querySource = function querySource() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        var deferred = $q.defer();
        if (typeof config.querySource === 'function') {
          deferred.resolve(config.querySource(q));
        } else if (typeof config.querySource === 'string') {
          var options = {
            params: {
              q: q,
              variant: 'array',
              limit: 100,
              fields: '*'
            },
            headers: {
              Accept: 'application/json, application/geo+json'
            },
            isArray: true,
            cache: true
          };
          var link = config.querySource;
          //If using the ?q- option - submit the link without the field query value included and include it here
          var conf = link.split('?q-');
          if (conf.length === 2) {
            //arr[0] contains the field name
            var arr = conf[1].split('&');
            //include the query letters into link
            link = conf[0] + '?q-' + arr[0] + q + conf[1].replace(arr[0], '');
          }
          $http.get(link, options).then(function (response) {
            deferred.resolve(response.data);
          });
        } else if (config.querySource instanceof Array) {
          deferred.resolve(config.querySource.filter(function (item) {
            return $scope.label(item).toLowerCase().indexOf(q.toLowerCase()) === 0;
          }));
        }
        return deferred.promise;
      };

      $scope.minLength = config.minLength || 0;

      var mapItem = function mapItem(item, key) {
        var result = item;
        if (config[key]) {
          if (typeof config[key] === 'function') {
            result = config[key].apply({}, item);
          } else if (item[config[key]]) {
            result = item[config[key]];
          } else if (config[key].includes(".")) {
            //object value in array notation "array.value"
            var arr = config[key].split('.');
            result = item[arr[0]][arr[1]];
          }
        }
        return String(result);
      };

      $scope.search = {
        text: ''
      };

      $scope.value = function (item) {
        return mapItem(item, 'value');
      };

      $scope.label = function (item) {
        return mapItem(item, 'label');
      };

      $scope.items = querySource(field.value);

      $scope.items.then(function (items) {
        var item = items.find(function (item) {
          return $scope.value(item) === field.value;
        });
        $scope.search.text = item ? $scope.label(item) : field.value || '';
      });

      var isExactMatch = function isExactMatch(item) {
        var searchText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        if (typeof searchText === 'number') {
          return $scope.label(item).toLowerCase() === searchText.toString().toLowerCase();
        }
        return $scope.label(item).toLowerCase() === searchText.toLowerCase();
      };

      $scope.searchChange = function (searchText) {
        $scope.items = querySource(searchText);

        $scope.items.then(function (items) {
          if (items.length === 1 && isExactMatch(items[0], searchText)) {
            $scope.onSelect(items[0]);
          } else {
            field.value = searchText;
          }
        });
      };
    }]
  };
};
autocompleteDirective.$inject = ["$http", "$q", "formulaAutoCompleteService"];

module.exports = autocompleteDirective;

},{"./autocomplete.html":134}],136:[function(require,module,exports){
"use strict";

var angular = require('angular');

var autocompleteSourceService = function autocompleteSourceService($q, formulaFieldConfig) {
  'ngInject';

  var configs = formulaFieldConfig.getInstance();

  var getOptions = function getOptions(field) {
    return configs.getMatchingConfig(field);
  };

  var autocomplete = function autocomplete(config, formula) {
    configs.addConfig(config);
    if (formula) {
      formula.addTemplate({
        match: config.match,
        template: '<npdc:formula-autocomplete></npdc:formula-autocomplete>'
      });
    }
  };

  var autocompleteFacets = function autocompleteFacets(_autocompleteFacets, resource, formula) {
    var facets = _autocompleteFacets.join(',');

    resource.facets({ facets: facets, q: '' }, function (facets) {
      _autocompleteFacets.forEach(function (facet) {
        var item = facets.find(function (r) {
          return r.facet === facet;
        });
        var nodes = item.facet.split('.');

        var source = function source(q) {
          q = String(q || '').toLocaleLowerCase();
          return item.terms.map(function (t) {
            return String(t.term);
          }).filter(function (item) {
            return item.toLocaleLowerCase().indexOf(q) !== -1;
          }).sort(function (a, b) {
            var aIndex = a.toLocaleLowerCase().indexOf(q);
            var bIndex = b.toLocaleLowerCase().indexOf(q);
            if (aIndex < bIndex) {
              return -1;
            } else if (aIndex > bIndex) {
              return 1;
            }
            return 0;
          });
        };

        var match = function match(field) {
          var fieldNodes = field.path.replace(/^#\//, '').replace(/\/\d+/g, '').split('/');
          return !field.typeOf('array') && angular.equals(nodes, fieldNodes);
        };
        autocomplete({
          match: match,
          querySource: source
        }, formula);
      });
    });
  };

  return {
    autocomplete: autocomplete,
    getOptions: getOptions,
    autocompleteFacets: autocompleteFacets
  };
};
autocompleteSourceService.$inject = ["$q", "formulaFieldConfig"];

module.exports = autocompleteSourceService;

},{"angular":"angular"}],137:[function(require,module,exports){
'use strict';

FormulaFileController.$inject = ["$scope", "$mdDialog", "$http", "$routeParams", "NpolarApiSecurity", "fileFunnelService"];
function FormulaFileController($scope, $mdDialog, $http, $routeParams, NpolarApiSecurity, fileFunnelService) {
  'ngInject';

  var ctrl = this;

  ctrl.field = $scope.field;

  ctrl.isNew = function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $routeParams;

    return params.id === '__new';
  };

  ctrl.file_uri = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fileFunnelService.getOptions(ctrl.field);

    return options.server.replace('/:id/_file', '');
  };

  ctrl.canUpload = function () {
    var security = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NpolarApiSecurity;

    return false === ctrl.isNew() && security.isAuthorized('create', ctrl.file_uri());
  };

  ctrl.canDelete = function () {
    var security = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NpolarApiSecurity;

    return security.isAuthorized('delete', ctrl.file_uri());
  };

  $scope.files = [];
  var options = fileFunnelService.getOptions($scope.field);
  //console.log('field', $scope.field, fileFunnelService.getOptions(), options);

  // From app-specific metadata to Hashi object
  var toHashi = function toHashi(hashi_field) {

    // file: metadata object as stored in the application
    var file = Object.assign({}, hashi_field.value);

    if (typeof options.toHashi === "function") {
      file = options.toHashi(file);
      options.valueToFileMapper = options.toHashi;
    } else if (typeof options.valueToFileMapper === "function") {
      console.warn('DEPRECATED: use toHashi');
      file = options.valueToFileMapper(file);
    }
    if (file) {
      if (!file.filename || !file.url) {
        throw "The hashi file mapper should be an object with keys filename, url, [file_size, icon, extras].";
      }
      file.extras = hashi_field.fields.filter(function (field) {
        return (options.fields || []).includes(field.id);
      });
    }
    return file;
  };

  $scope.id = $routeParams.id;

  $scope.field.values.forEach(function (value) {
    var hashiFile = toHashi(value);
    $scope.files.push(hashiFile);
  });

  $scope.isFile = function (value, index, array) {
    return !!$scope.files[index];
  };

  ctrl.displayUploadDialog = function (ev) {
    console.log('displayUploadDialog', ev);
    fileFunnelService.showUpload(ev, $scope.field, options).then(function (files) {

      files = files.filter(function (f) {
        return f.status >= 200 && f.status < 300;
      });

      if (files) {
        files.forEach(function (file) {
          var length = $scope.files.push(file);
          file.extras = $scope.field.values[length - 1].fields.filter(function (field) {
            return (options.fields || []).includes(field.id);
          });
        });
      }
    });
  };

  $scope.removeFile = function (index) {
    var file = $scope.field.itemRemove(index);
    if (typeof options.valueToFileMapper === "function") {
      file = options.valueToFileMapper(file.value);
    }
    $scope.files = $scope.files.filter(function (f) {
      return f.md5sum !== file.md5sum;
    });
    $http.delete(file.url);
  };

  $scope.nrFiles = function () {
    return $scope.files.filter(function (f) {
      return !!f;
    }).length;
  };
}

module.exports = FormulaFileController;

},{}],138:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<fieldset ng-class="{ valid: field.valid, error: field.error }" ng-if="field.visible" ng-controller="NpdcFormulaFileController as ctrl">\n  <md-whiteframe class="md-whiteframe-z2 np-formula-file">\n\n    <legend>\n      <div>{{ field.title }} ({{ nrFiles() }})</div>\n      <div npdc:formula-field-info class="np-field-info" ng-if="::field.description"></div>\n    </legend>\n\n\n    <ul class="np-formula-list">\n      <li ng-repeat="value in field.values | filter:isFile" class="np-formula-list-item">\n        <div class="np-formula-collapsed-item" ng-if="!value.visible" ng-click="field.itemToggle($index)"></div>\n        <md-whiteframe class="md-whiteframe-z2">\n          <fieldset>\n            <legend>\n              <!--span class="np-formula-array-object-title">{{ value.title }}</span-->\n              <div>\n                <span><md-icon class="md-avatar">{{::files[$index].icon || \'attachment\'}}</md-icon></span>\n                <span>{{::files[$index].filename}}</span>&nbsp;<span>{{::files[$index].file_size | bytes}}</span>\n              </div>\n              <div class="np-formula-object-ctrls">\n                <div npdc:formula-field-info class="np-field-info" ng-if="value.description"></div>\n                <a ng-show="!$first" href="" ng-click="field.moveUp($index)">\n                  <md-icon>arrow_upward</md-icon>\n                  <md-tooltip>{{ i18n.text.moveup }}</md-tooltip>\n                </a>\n                <a ng-show="!$last" href="" ng-click="field.moveDown($index)">\n                  <md-icon>arrow_downward</md-icon>\n                  <md-tooltip>{{ i18n.text.movedown }}</md-tooltip>\n                </a>\n                <a ng-show="files[$index] && files[$index].extras && files[$index].extras.length > 0" href="" ng-click="field.itemToggle($index)">\n                  <md-icon>{{ value.visible ? \'expand_less\' : \'expand_more\' }}</md-icon>\n                  <md-tooltip>{{ value.visible ? i18n.text.minimize.tooltip : i18n.text.maximize.tooltip }}</md-tooltip>\n                </a>\n                <md-menu>\n                  <md-button ng-show="ctrl.canDelete()" aria-label="{{ i18n.text.remove.label }}" class="md-icon-button remove" ng-click="$mdMenu.open($event)">\n                    <md-icon md-menu-origin>close</md-icon>\n                    <md-tooltip>{{ i18n.text.remove.tooltip }}</md-tooltip>\n                  </md-button>\n                  <md-menu-content>\n                    <md-menu-item>\n                      <md-button ng-click="removeFile($index)" ng-attr-title="{{ i18n.text.remove.tooltip }}" class="md-warn">\n                        <md-icon md-menu-align-target>delete</md-icon> {{ i18n.text.remove.label }}\n                      </md-button>\n                    </md-menu-item>\n                  </md-menu-content>\n                </md-menu>\n              </div>\n            </legend>\n\n            <formula:fields fields="files[$index].extras" ng-if="value.visible"></formula:fields>\n          </fieldset>\n        </md-whiteframe>\n      </li>\n    </ul>\n    <div layout="column" layout-align="space-between end" class="np-formula-file-upload">\n      <md-button ng-disabled="!ctrl.canUpload()" ng-click="ctrl.displayUploadDialog($event);" class="md-raised md-primary">\n        <md-icon>backup</md-icon>\n        <md-tooltip ng-if="ctrl.canUpload()">Upload files</md-tooltip>\n      </md-button>\n      <p ng-show="!ctrl.canUpload()">\n        <span ng-if="!ctrl.isNew()">You are currently not authorized to upload (are you logged in?)</span>\n        <span ng-if="ctrl.isNew()">Uploading is disabled: You need to save before you can upload any files</span>\n      </p>\n    </div>\n\n    <div npdc:formula-validation-message class="np-validation-message"></div>\n  </md-whiteframe>\n</fieldset>\n';
},{}],139:[function(require,module,exports){
'use strict';

function fileDirective() {
  'ngInject';

  return {
    template: require('./file.html'),
    scope: false,
    controller: 'NpdcFormulaFileController'
  };
}

module.exports = fileDirective;

},{"./file.html":138}],140:[function(require,module,exports){
'use strict';

var gcmd = function gcmd(npdcGcmdService) {
  'ngInject';

  return {
    template: '<formula:field field="array"></formula:field>',
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.array = $scope.field.fields.find(function (field) {
        return field.id === 'sciencekeywords';
      });
    }],
    link: function link(scope, iElement, iAttrs) {
      iElement.addClass('formulaCustomObject');
    }
  };
};
gcmd.$inject = ["npdcGcmdService"];

module.exports = gcmd;

},{}],141:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div ng-if="tree && field.visible">\n  <md-autocomplete md-items="item in querySearch(filter.text)" md-min-length="1" md-search-text="filter.text" md-floating-label="{{ \'gcmd.find\' | t }}" md-selected-item-change="onSelect(item)" md-item-text="item.label" md-menu-class="np-autocomplete-custom">\n\n    <md-item-template>\n      <span class="np-autocomplete-custom-main">\n        <span md-highlight-flags="^i" md-highlight-text="filter.text">\n          {{item.label}}\n        </span>\n      </span>\n      <span class="np-autocomplete-custom-meta shade">\n        <span>{{ parents(item) }}</span>\n      </span>\n    </md-item-template>\n  </md-autocomplete>\n\n  <md-input-container>\n    <label>{{ keyword.Category.title }}</label>\n    <md-select ng-model="keyword.Category.value">\n      <md-option ng-repeat="val in treeValues(1)" value="{{::val.label}}">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if="!!keyword.Category.value">\n    <label>{{ keyword.Topic.title }}</label>\n    <md-select ng-model="keyword.Topic.value">\n      <md-option ng-repeat="val in treeValues(2)" value="{{::val.label}}">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if="!!keyword.Topic.value">\n    <label>{{ keyword.Term.title }}</label>\n    <md-select ng-model="keyword.Term.value">\n      <md-option ng-repeat="val in treeValues(3)" value="{{::val.label}}">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if="!!keyword.Term.value">\n    <label>{{ keyword.Variable_Level_1.title }}</label>\n    <md-select ng-model="keyword.Variable_Level_1.value">\n      <md-option ng-repeat="val in treeValues(4)" value="{{::val.label}}">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if="!!keyword.Variable_Level_1.value">\n    <label>{{ keyword.Variable_Level_2.title }}</label>\n    <md-select ng-model="keyword.Variable_Level_2.value">\n      <md-option ng-repeat="val in treeValues(5)" value="{{::val.label}}">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if="!!keyword.Variable_Level_2.value">\n    <label>{{ keyword.Variable_Level_3.title }}</label>\n    <md-select ng-model="keyword.Variable_Level_3.value">\n      <md-option ng-repeat="val in treeValues(6)" value="{{::val.label}}">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container>\n    <label>{{ keyword.Detailed_Variable.title }}</label>\n    <input type="text" ng-model="keyword.Detailed_Variable.value" />\n  </md-input-container>\n</div>\n';
},{}],142:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var gcmd = function gcmd(npdcGcmdService) {
  'ngInject';

  var FIELDS = ['Category', 'Topic', 'Term', 'Variable_Level_1', 'Variable_Level_2', 'Variable_Level_3', 'Detailed_Variable'];

  var setFieldValue = function setFieldValue(fieldset, item) {
    var key = FIELDS[item.cardinality - 1];
    var field = fieldset.fields.find(function (field) {
      return field.id === key;
    });
    field.value = item.label;
    if (item.parent) {
      setFieldValue(fieldset, item.parent);
    }
  };

  var matchQuery = function matchQuery(item, query) {
    return item.label.toLowerCase().indexOf(query.toLowerCase()) !== -1;
  };

  var searchTree = function searchTree(tree, query) {
    var matches = [];
    tree.forEach(function (item) {
      if (item.isBranch()) {
        matches = matches.concat(searchTree(item.children, query));
      }

      if (matchQuery(item, query)) {
        matches.push(item);
      }
    });
    return matches;
  };

  return {
    template: require('./gcmdKeyword.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.keyword = $scope.field.fields.reduce(function (memo, field) {
        memo[field.id] = field;
        return memo;
      }, {});

      $scope.filter = {
        text: ''
      };

      $scope.querySearch = function (value) {
        return searchTree($scope.tree, value);
      };

      $scope.parents = function (item) {
        var parents = '';
        if (item.parent) {
          var grandParents = $scope.parents(item.parent);
          parents += grandParents ? grandParents + ' > ' : '';
          parents += item.parent.label;
        }
        return parents;
      };

      /* jshint -W083 */
      $scope.treeValues = function (cardinality) {
        var i = 0;
        var level = $scope.tree;
        // get selected parent from top of tree and down to {cardinality}

        var _loop = function _loop() {
          var key = FIELDS[i];
          var field = $scope.keyword[key];
          if (field.value) {
            var selectedItem = level.find(function (item) {
              return item.label === field.value;
            });
            level = selectedItem.children;
            i++;
          } else {
            return {
              v: []
            };
          }
        };

        while (i < cardinality - 1) {
          var _ret = _loop();

          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }

        return level;
      };

      $scope.onSelect = function (item) {
        var key = FIELDS[item.cardinality - 1];
        var field = $scope.keyword[key];
        field.value = item.label;
        if (item.parent) {
          $scope.onSelect(item.parent);
        }
      };

      npdcGcmdService.tree.then(function (t) {
        $scope.tree = t;
      });
    }]
  };
};
gcmd.$inject = ["npdcGcmdService"];

module.exports = gcmd;

},{"./gcmdKeyword.html":141}],143:[function(require,module,exports){
'use strict';

var gcmdService = function gcmdService($q, NpolarApiResource) {
  'ngInject';

  var GCMD = NpolarApiResource.resource({ path: '/gcmd/concept', resource: 'GCMD' });
  var query = {
    'filter-concept': 'sciencekeywords',
    'fields': 'id,label,child_ids,cardinality',
    'variant': 'array',
    'limit': 'all'
  };

  var isBranch = function isBranch() {
    return this.children && this.children.length > 0;
  };

  var buildTree = function buildTree(currentLevel, cardinality, parent, source) {
    return currentLevel.map(function (item) {
      item.parent = parent;
      item.isBranch = isBranch;

      if (item.child_ids && source[cardinality]) {
        var filteredChildLevel = source[cardinality].filter(function (child) {
          return item.child_ids.indexOf(child.id) !== -1;
        });
        item.children = buildTree(filteredChildLevel, cardinality + 1, item, source);
      }
      return item;
    });
  };

  var deferred = $q.defer();

  GCMD.array(query, function (response) {
    var source = [response.filter(function (item) {
      return item.cardinality === 1;
    }), response.filter(function (item) {
      return item.cardinality === 2;
    }), response.filter(function (item) {
      return item.cardinality === 3;
    }), response.filter(function (item) {
      return item.cardinality === 4;
    }), response.filter(function (item) {
      return item.cardinality === 5;
    }), response.filter(function (item) {
      return item.cardinality === 6;
    }), response.filter(function (item) {
      return item.cardinality === 7;
    })];
    var tree = buildTree(source[0], 1, null, source);
    deferred.resolve(tree);
  }, function (err) {
    deferred.reject();
  });

  return {
    tree: deferred.promise
  };
};
gcmdService.$inject = ["$q", "NpolarApiResource"];

module.exports = gcmdService;

},{}],144:[function(require,module,exports){
"use strict";

var angular = require('angular');
var common = angular.module('npdcCommon');

common.service('formulaAutoCompleteService', require('./autocomplete/autocompleteSourceService'));
common.directive('npdcFormulaAutocomplete', require('./autocomplete/autocompleteDirective'));

common.controller('NpdcFormulaFileController', require('./file/FileController'));
common.directive('npdcFormulaFile', require('./file/fileDirective'));

common.directive('npdcFormulaPerson', require('./person/personDirective'));

common.service('npdcGcmdService', require('./gcmd/gcmdService'));
common.directive('npdcFormulaGcmd', require('./gcmd/gcmdDirective'));
common.directive('npdcFormulaGcmdKeyword', require('./gcmd/gcmdKeywordDirective'));

common.directive('npdcFormulaPlacename', require('./placename/placenameDirective'));

common.service('npdcCSVService', require('./tabdata/csvService'));
common.directive('npdcFormulaTabdata', require('./tabdata/tabdataDirective'));

},{"./autocomplete/autocompleteDirective":135,"./autocomplete/autocompleteSourceService":136,"./file/FileController":137,"./file/fileDirective":139,"./gcmd/gcmdDirective":140,"./gcmd/gcmdKeywordDirective":142,"./gcmd/gcmdService":143,"./person/personDirective":146,"./placename/placenameDirective":148,"./tabdata/csvService":149,"./tabdata/tabdataDirective":151,"angular":"angular"}],145:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div ng-if="field.visible">\n  <div layout="row">\n    <div flex="50" flex-sm="100">\n      <md-autocomplete\n        md-items="item in querySearch(firstName.value, \'first_name\')"\n        md-min-length="1"\n        md-search-text="firstName.value"\n        md-floating-label="{{firstName.title}}"\n        md-selected-item-change="onSelect(item)"\n        md-item-text="item.first_name"\n        md-menu-class="np-autocomplete-custom">\n\n        <md-item-template>\n          <span class="np-autocomplete-custom-main">\n            <span md-highlight-flags="^i" md-highlight-text="firstName.value">\n              {{item.first_name}}\n            </span>\n            <span class="shade">{{item.last_name}}</span>\n          </span>\n          <span class="np-autocomplete-custom-meta">\n            <span class="shade">{{item.email}}</span>\n          </span>\n        </md-item-template>\n\n      </md-autocomplete>\n      <div npdc:formula-validation-message class="np-validation-message"></div>\n    </div>\n    <div flex="50" flex-sm="100">\n      <md-autocomplete\n        md-items="item in querySearch(lastName.value, \'last_name\')"\n        md-min-length="1"\n        md-search-text="lastName.value"\n        md-floating-label="{{lastName.title}}"\n        md-selected-item-change="onSelect(item)"\n        md-item-text="item.last_name"\n        md-menu-class="np-autocomplete-custom">\n\n        <md-item-template>\n          <span class="np-autocomplete-custom-main">\n            <span md-highlight-flags="^i" md-highlight-text="lastName.value">\n              {{item.last_name}}\n            </span>\n            <span class="shade">, {{item.first_name}}</span>\n          </span>\n          <span class="np-autocomplete-custom-meta">\n            <span class="shade">{{item.email}}</span>\n          </span>\n        </md-item-template>\n\n      </md-autocomplete>\n      <div npdc:formula-validation-message class="np-validation-message"></div>\n    </div>\n  </div>\n  <div>\n    <md-autocomplete\n      md-items="item in querySearch(email.value, \'email\')"\n      md-min-length="1"\n      md-search-text="email.value"\n      md-floating-label="{{email.title}}"\n      md-selected-item-change="onSelect(item)"\n      md-item-text="item.email"\n      md-menu-class="np-autocomplete-custom">\n\n      <md-item-template>\n        <span class="np-autocomplete-custom-main">\n          <span md-highlight-flags="^i" md-highlight-text="email.value">\n            {{item.email}}\n          </span>\n        </span>\n        <span class="np-autocomplete-custom-meta">\n          <span class="shade">{{item.first_name}}</span>\n          <span class="shade">{{item.last_name}}</span>\n        </span>\n      </md-item-template>\n\n    </md-autocomplete>\n    <div npdc:formula-validation-message class="np-validation-message"></div>\n  </div>\n  <div ng-repeat="field in otherFields" ng-show="field.visible">\n    <formula:field field="field"></formula:field>\n  </div>\n</div>\n';
},{}],146:[function(require,module,exports){
'use strict';

var person = function person($q, NpolarApiResource) {
  'ngInject';

  // rolesList

  var Person = NpolarApiResource.resource({ path: '/person', resource: 'Person' });
  var query = { 'fields': 'first_name,last_name,organisation,email', 'variant': 'array', 'limit': 200 };

  return {
    template: require('./person.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      //@todo handle affiliation (multiple)

      $scope.firstName = $scope.field.fields.find(function (field) {
        return field.id === 'first_name';
      });
      $scope.lastName = $scope.field.fields.find(function (field) {
        return field.id === 'last_name';
      });
      $scope.organisation = $scope.field.fields.find(function (field) {
        return field.id === 'organisation';
      });
      $scope.email = $scope.field.fields.find(function (field) {
        return field.id === 'email';
      });
      var homepage = $scope.field.fields.find(function (field) {
        return field.id === 'homepage';
      });
      if (homepage) {
        $scope.homepage = homepage;
      }

      $scope.querySearch = function (searchText, field) {
        var deferred = $q.defer();
        var fullQuery = Object.assign({}, query, { q: searchText });
        Person.array(fullQuery, function (response) {
          var fieldFilteredMatches = response.filter(function (person) {
            return (person[field] || '').toLowerCase().indexOf(searchText.toLowerCase()) === 0;
          });
          deferred.resolve(fieldFilteredMatches);
        }, function (err) {
          deferred.reject();
        });
        return deferred.promise;
      };

      $scope.onSelect = function (person) {
        $scope.firstName.value = person.first_name;
        $scope.lastName.value = person.last_name;
        $scope.organisation.value = person.organisation;
        $scope.email.value = person.email;
        var id = person.email.split('@')[0];
        $scope.homepage.value = 'http://www.npolar.no/en/people/' + id;
      };

      $scope.otherFields = $scope.field.fields.filter(function (field) {
        return !['first_name', 'last_name', 'email', 'id', 'affiliation'].includes(field.id);
      });
    }]
  };
};
person.$inject = ["$q", "NpolarApiResource"];

module.exports = person;

},{"./person.html":145}],147:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div ng-if="field.visible">\n  <md-autocomplete md-items="item in querySearchPlacenames(placename.value)" md-min-length="1"\n    md-search-text="placename.value" md-floating-label="{{placename.title}}"\n    md-selected-item-change="onSelectPlacename(item)" md-item-text="item.title" md-menu-class="np-autocomplete-custom">\n\n    <md-item-template>\n      <span class="np-autocomplete-custom-main">\n        <span md-highlight-flags="^i" md-highlight-text="placename.value">\n          {{item.title}}\n        </span>\n      </span>\n      <span class="np-autocomplete-custom-meta shade">\n        <span>{{item.location}}</span>\n        <span>{{item.country}}</span>\n        <span>{{item.north}}N {{item.east}}E</span>\n      </span>\n    </md-item-template>\n\n  </md-autocomplete>\n  <div npdc:formula-validation-message class="np-validation-message" ng-init="field=placename"></div>\n  <div layout="row">\n    <div flex="50" flex-sm="100">\n      <md-input-container>\n        <label for="{{::area.uid}}">{{ (area.required ? area.title + \' (\' + i18n.text.required + \')\' : area.title) }}</label>\n\n        <md-select ng-model="area.value">\n          <md-option ng-repeat="val in area.values" value="{{::val.id}}">{{val.label}}</md-option>\n        </md-select>\n\n        <div npdc:formula-validation-message class="np-validation-message" ng-init="field=area"></div>\n      </md-input-container>\n    </div>\n    <div flex="50">\n      <md-autocomplete md-items="item in querySearchCountries(countrySearchText)" md-min-length="1"\n        md-search-text="countrySearchText" md-floating-label="{{country.title}}" md-item-text="item.name"\n        md-menu-class="np-autocomplete-custom" md-selected-item="selectedCountryItem" md-selected-item-change="country.value = item.code">\n\n        <md-item-template>\n          <span class="np-autocomplete-custom-main">\n            <span md-highlight-flags="^i" md-highlight-text="countrySearchText">\n              {{item.name}}\n            </span>\n          </span>\n          <span class="np-autocomplete-custom-meta shade">\n            <span>{{item.code}}</span>\n            <span>{{item.native}}</span>\n          </span>\n        </md-item-template>\n\n      </md-autocomplete>\n      <div npdc:formula-validation-message class="np-validation-message" ng-init="field=country"></div>\n    </div>\n  </div>\n\n</div>\n';
},{}],148:[function(require,module,exports){
'use strict';

var placename = function placename($q, $resource, npolarCountryService) {
  'ngInject';

  var Placename = $resource('http://placenames.npolar.no/stadnamn.json', { callback: "JSON_CALLBACK" }, { array: { method: 'JSONP', isArray: true } });
  var query = { 'rows': 20, 'approved': true };

  // First term is official, rest is mappings
  var AREAS = [{
    "terms": ["Svalbard"]
  }, {
    "terms": ["Dronning Maud Land"]
  }, {
    "terms": ["Jan Mayen"]
  }, {
    "terms": ["Antarctica", "Antarktis"]
  }, {
    "terms": ["Bouvetøya"]
  }, {
    "terms": ["Peter I Øy", "Peter 1 Øy"]
  }, {
    "terms": ["Arctic", "Arktis"]
  }, {
    "terms": ["Arctic Ocean"]
  }, {
    "terms": ["Barents Sea"]
  }, {
    "terms": ["Southern Ocean", "Antarctic Ocean"]
  }, {
    "terms": ["Other"] // Other...
  }];

  var COUNTRIES = {
    'USA': 'United States'
  };

  // dataset
  // placenames[{area,placename,country}]

  // publication
  // locations[{area,placename,country,(hemisphere,latitude,longitude)}]


  return {
    template: require('./placename.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      $scope.area = $scope.field.fields.find(function (field) {
        return field.id === 'area';
      });
      $scope.placename = $scope.field.fields.find(function (field) {
        return field.id === 'placename';
      });
      $scope.country = $scope.field.fields.find(function (field) {
        return field.id === 'country';
      });
      $scope.countrySearchText = '';
      $scope.selectedCountryItem = null;

      $scope.querySearchPlacenames = function (searchText) {
        return Placename.array(Object.assign({}, query, { q: searchText })).$promise;
      };

      $scope.onSelectPlacename = function (placename) {
        if (!placename) {
          return;
        }
        $scope.area.value = placename.location;
        placename.country = COUNTRIES[placename.country] || placename.country;
        $scope.selectedCountryItem = npolarCountryService.countryByName(placename.country);
      };

      $scope.querySearchCountries = function (searchText) {
        return npolarCountryService.countriesByQuery(searchText);
      };

      $scope.area.values = AREAS.map(function (area) {
        return { id: area.terms[0], label: area.terms[0] };
      });
      if ($scope.area.value && !$scope.area.values.some(function (val) {
        return val.id.toLowerCase() === $scope.area.value.toLowerCase();
      })) {
        // value is set but doesn't match any value in AREAS
        $scope.area.value = AREAS.reduce(function (memo, area) {
          if (area.terms.some(function (term) {
            return term.toLowerCase() === $scope.area.value.toLowerCase();
          })) {
            return area.terms[0];
          } else {
            return 'Other';
          }
        });
      }

      if ($scope.country.value) {
        $scope.selectedCountryItem = npolarCountryService.countryByCode($scope.country.value);
      }

      $scope.otherFields = $scope.field.fields.filter(function (field) {
        return !['area', 'placename', 'country'].includes(field.id);
      });
    }]
  };
};
placename.$inject = ["$q", "$resource", "npolarCountryService"];

module.exports = placename;

},{"./placename.html":147}],149:[function(require,module,exports){
'use strict';

var csvService = function csvService() {
  'ngInject';

  var DEFAULT_DELIMITER = ",";
  var NEWLINE = "\r\n";

  var isBoolean = function isBoolean(value) {
    return ["true", "false"].indexOf(value.toLowerCase()) !== -1;
  };

  var parseValue = function parseValue(value) {
    var num = void 0,
        parsed = void 0;
    if (value === undefined) {
      return undefined;
    } else if (value.toLowerCase() === "nan") {
      parsed = NaN;
    } else if (!isNaN(num = Number(value))) {
      parsed = num;
    } else if (isBoolean(value)) {
      parsed = JSON.parse(value.toLowerCase());
    } else {
      parsed = value;
    }
    return parsed;
  };

  var csvLineToArray = function csvLineToArray(str) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DELIMITER;


    var quotedValues = [],
        values = void 0,
        match = void 0;
    var expr = RegExp("([\"']{1}).*?(?=\\1\\s*(?:" + delimiter + "|$))", "g");

    (str.match(expr) || []).forEach(function (quoted, index) {
      quotedValues.push(quoted.replace(/["']/, ""));
      str = str.replace(quoted, "{{%" + index + "%}}");
    });

    (values = str.split(delimiter) || []).forEach(function (value, index, array) {
      if (match = value.match(/{{%(\d+)%}}/)) {
        value = quotedValues[Number(match[1])];
      }
      value = value.trim();
      value = value === '' ? undefined : value;
      array[index] = value;
    });

    return values;
  };

  var isMatchingHeaders = function isMatchingHeaders(h1, h2) {
    return h1 && h2 && h1.every(function (header) {
      return h2.indexOf(header) !== -1;
    });
  };

  var csvToJSON = function csvToJSON(csv) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { delimiter: DEFAULT_DELIMITER };

    var lines = csv.split(/\r?\n\r?/).filter(function (line) {
      return line !== '';
    });
    var firstLine = csvLineToArray(lines[0], options.delimiter);

    if (!options.headers || isMatchingHeaders(firstLine, options.headers)) {
      options.headers = firstLine;
      lines.shift();
    }

    return lines.map(function (line) {
      var record = csvLineToArray(line, options.delimiter).reduce(function (memo, item, index) {
        if (index < options.headers.length) {
          memo[options.headers[index]] = parseValue(item);
        }
        return memo;
      }, {});

      // fill missing values with undefined
      for (var i = options.headers.length - 1; i >= 0; i--) {
        if (record.hasOwnProperty([options.headers[i]])) {
          break;
        } else {
          record[options.headers[i]] = undefined;
        }
      }

      return record;
    });
  };

  var jsonToCSV = function jsonToCSV(json, options) {
    options = Object.assign({ delimiter: DEFAULT_DELIMITER, skipHeaders: false }, options);
    if (!options.headers) {
      throw "No CSV header specified";
    }

    var values = json instanceof String ? JSON.parse(json) : json;
    var csv = '';

    if (!options.skipHeaders) {
      csv += options.headers.toString().replace(/,/g, options.delimiter) + NEWLINE;
    }

    values.forEach(function (item, rowIndex) {
      options.headers.forEach(function (header, colIndex) {
        if (item[header] !== undefined) {
          csv += item[header];
          if (colIndex < Object.keys(item).length - 1) {
            csv += options.delimiter;
          }
        }
      });
      if (rowIndex < values.length - 1) {
        csv += NEWLINE;
      }
    });

    return csv;
  };

  return {
    jsonToCSV: jsonToCSV,
    csvToJSON: csvToJSON,
    csvLineToArray: csvLineToArray,
    isMatchingHeaders: isMatchingHeaders
  };
};

module.exports = csvService;

},{}],150:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-input-container class="np-formula-tabdata" ng-show="field.visible">\n  <label for="{{::field.uid}}">{{ (field.required ? field.title + \' (\' + i18n.text.required + \')\' : field.title ) }}</label>\n  <div class="np-formula-td-header">\n    <span class="header-number"></span>\n    <div class="header-string">{{csvHeader}}</div>\n  </div>\n  <textarea ng-model="csvData" md-no-autogrow class="csv-textarea"></textarea>\n  <div class="np-td-delimiter">Delimiter: {{delimiter}}</div>\n  <div ng-show="field.errors" class="np-validation-message">\n    <div ng-repeat="error in field.errors" class="md-caption" role="alert">\n      {{ field.getErrorText(error) }}\n    </div>\n  </div>\n</md-input-container>\n';
},{}],151:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var tabdata = function tabdata(npdcCSVService) {
  'ngInject';

  var DELIMITERS = {
    '\t': 'TAB',
    ',': 'COMMA (,)',
    ';': 'SEMICOLON (;)',
    ' ': 'SPACE ( )',
    '|': 'PIPE (|)'
  };

  var applySchemaValueType = function applySchemaValueType(item, schema) {
    Object.keys(item).forEach(function (prop) {
      var type = void 0;
      if (schema[prop] && (type = schema[prop].type)) {
        if (type instanceof Array) {
          type = type.find(function (t) {
            return t !== 'null';
          }) || 'string';
        }

        if (_typeof(item[prop]) !== type) {
          switch (type) {
            case 'string':
              item[prop] = JSON.stringify(item[prop]);
              break;
          }
        }
      }
    });
    return item;
  };

  var disableValueWatchers = function disableValueWatchers(field) {
    field.items[0].fields.forEach(function (field) {
      field.destroyWatcher();
    });
  };

  return {
    template: require('./tabdata.html'),
    controller: ["$scope", function controller($scope) {
      'ngInject';

      var headers = Object.keys($scope.field.schema.items.properties);
      var delimiter = '\t';

      // We take care of updating values outselves
      disableValueWatchers($scope.field);
      $scope.delimiter = DELIMITERS[delimiter];
      $scope.csvData = npdcCSVService.jsonToCSV($scope.field.value, { headers: headers, delimiter: delimiter });
      var headerString = headers.toString();
      $scope.csvHeader = headerString.replace(/,/g, delimiter);
      $scope.$watch('csvData', function (n, o) {
        if (n && n !== o) {
          var model = {};
          var headerLine = n.split(/\r?\n\r?/)[0];
          var detectedDelimiter = /([\s,;|])/.exec(headerLine)[1];
          $scope.csvHeader = headerLine;
          $scope.delimiter = DELIMITERS[detectedDelimiter];

          if (!npdcCSVService.isMatchingHeaders(npdcCSVService.csvLineToArray(headerLine, detectedDelimiter), headers)) {
            $scope.field.valid = false;
            $scope.field.errors = [{ message: "Invalid header line, should use names: " + headerString }];
          } else {
            $scope.field.valid = true;
            $scope.field.errors = null;
            model[$scope.field.id] = npdcCSVService.csvToJSON(n.trim(), { headers: headers, delimiter: delimiter }).map(function (item) {
              applySchemaValueType(item, $scope.field.schema.items.properties);
              Object.keys(item).forEach(function (prop) {
                if (item[prop] === undefined) {
                  delete item[prop];
                }
              });
              return item;
            });
            $scope.field.valueFromModel(model, true);
            // Uncomment to force default delimiter
            // $scope.csvData = $scope.csvData.replace(detectedDelimiter, delimiter, 'g');
          }
        }
      });

      $scope.$watch('csvHeader', function (n, o) {
        if (n && n !== o) {
          $scope.csvData = $scope.csvData.replace(/^.*/, n);
        }
      });
    }],
    link: function link(scope, element, attrs) {
      var move = false;
      var lineNumbers = document.createElement('TEXTAREA');
      var textarea = element.find('textarea')[0];
      var noOfLines = scope.csvData.split(/\r?\n\r?/g).length;
      var string = '';
      for (var no = 0; no < noOfLines + 500; no++) {
        if (string.length > 0) {
          string += '&#10;';
        }
        string += no;
      }

      var fontSize = Math.min(40 / noOfLines.toString().length, 15);
      lineNumbers.style.fontSize = fontSize + 'px';
      element[0].querySelector('.header-number').style.fontSize = fontSize + 'px';
      lineNumbers.innerHTML = string;
      lineNumbers.className = 'line-numbers md-input';
      textarea.parentNode.insertBefore(lineNumbers, textarea.nextSibling);

      function setLine() {
        lineNumbers.scrollTop = textarea.scrollTop;
        lineNumbers.style.top = textarea.offsetTop + "px";
      }

      textarea.onscroll = textarea.onkeyup = function () {
        setLine();
      };
      textarea.onmousedown = function () {
        setLine();
        move = true;
      };
      textarea.onmouseup = function () {
        setLine();
        move = false;
      };
      textarea.onmousemove = function () {
        if (move) {
          setLine();
        }
      };
      textarea.onkeydown = function (e) {
        if (e.keyCode === 9) {
          // tab was pressed
          // get caret position/selection
          var start = this.selectionStart;
          var end = this.selectionEnd;

          var target = e.target;
          var value = target.value;

          // set textarea value to: text before caret + tab + text after caret
          target.value = value.substring(0, start) + "\t" + value.substring(end);

          // put caret at right position again (add one for the tab)
          this.selectionStart = this.selectionEnd = start + 1;

          // prevent the focus lose
          e.preventDefault();
        }
      };
    }
  };
};
tabdata.$inject = ["npdcCSVService"];

module.exports = tabdata;

},{"./tabdata.html":150}],152:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<h1 class="np-heading md-display-1">{{ \'Editing\' | t }} <a ng-href="{{ id === \'__new\' ? resource.uiBase : href(id) }}">{{ title }}</a>\n  <a ng-if="help && help.uri" ng-href="{{ help.uri }}" target="_blank">\n    <md-button class="md-icon-button">\n    <md-icon md-menu-origin>help</md-icon>\n    <md-tooltip>{{ \'help-with-editing\' | t }}</md-tooltip>\n  </md-button></a>\n</h1>\n\n<npdc:bottom-sheet options="bottomSheetOptions" ng-show="document._rev"></npdc:bottom-sheet>\n<div ng-class="{ \'np-bottom-sheet-static\': bottomSheetOptions.alwaysShow }">\n  <formula options="formula._cfg"></formula>\n  <npdc:loader ng-if="!formula._cfg.form.ready"></npdc:loader>\n</div>\n<npdc:save-button class="np-primary-control" ng-show="formula._cfg.form.ready"></npdc:save-button>';
},{}],153:[function(require,module,exports){
'use strict';

var formula = function formula($mdDialog, $location, $routeParams, $filter, npdcAppConfig, NpolarTranslate) {
  'ngInject';

  return {
    template: require('./edit.html'),
    scope: false,
    controller: ["$scope", function controller($scope) {
      'ngInject';

      if (npdcAppConfig.help) {
        $scope.help = npdcAppConfig.help;
      }

      var initBottomSheet = function initBottomSheet() {
        $scope.bottomSheetOptions = {
          items: [],
          alwaysShow: false
        };

        if ($scope.security.isAuthorized('delete', $scope.resource.path) && $scope.document._rev) {
          var name = 'Delete';
          $scope.bottomSheetOptions.items.push({
            name: NpolarTranslate.translate(name),
            icon: 'delete',
            classes: 'md-warn',
            action: function action(ev) {
              // Appending dialog to document.body to cover sidenav in docs app
              var confirm = $mdDialog.confirm().title(NpolarTranslate.translate('Confirm delete')).textContent(NpolarTranslate.translate('delete.confirm')).targetEvent(ev).ok(NpolarTranslate.translate(name)).cancel(NpolarTranslate.translate('Cancel'));
              $mdDialog.show(confirm).then(function () {
                $scope.delete();
              }, function () {
                // noop
              });
            }
          });
        }

        if ($scope.security.isAuthorized('create', $scope.resource.path) && $scope.document._rev) {
          var duplicate = 'Duplicate';
          $scope.bottomSheetOptions.items.push({
            name: NpolarTranslate.translate(duplicate),
            icon: 'control_point_duplicate',
            classes: 'md-primary',
            action: function action(ev) {
              var confirm = $mdDialog.confirm().title(NpolarTranslate.translate('Confirm duplication')).textContent(NpolarTranslate.translate('Confirm that you want to create a copy of the current document')).targetEvent(ev).ok(NpolarTranslate.translate(duplicate)).cancel(NpolarTranslate.translate('Cancel'));
              $mdDialog.show(confirm).then(function () {
                $scope.duplicate($scope.document, true);
              }, function () {
                // noop
              });
            }
          });
        }
      };

      $scope.$on('npolar-lang', function (e, lang) {
        $scope.formula.i18n.set(lang.lang);
        if ($scope.document && $scope.document._rev && $scope.document.title) {
          $scope.title = $filter('i18n')($scope.document.title);
        }
      });

      // @FIXME Sometimes goes bananas and spams dialogs...
      // $scope.formula.setConfirmDirtyNavigate((navigate) => {
      //   let confirmNavigate = $mdDialog.confirm()
      //     .title(NpolarTranslate.translate('navigation.confirm.title'))
      //     .textContent(NpolarTranslate.translate('navigation.confirm.text'))
      //     .ok(NpolarTranslate.translate('Yes'))
      //     .cancel(NpolarTranslate.translate('No'));
      //   $mdDialog.show(confirmNavigate).then(function() {
      //     navigate();
      //   });
      // });

      $scope.title = $routeParams.id;
      $scope.id = $routeParams.id;

      $scope.href = function (id) {
        return $scope.resource ? $scope.resource.href(id) : id;
      };

      $scope.$watch('document', function (d, was) {
        if (d) {
          if (d._rev) {
            if (d.title) {
              $scope.title = $filter('i18n')(d.title);
            }
          } else {
            $scope.title = NpolarTranslate.translate('document.new');
          }
          initBottomSheet();
        }
      });
    }]
  };
};
formula.$inject = ["$mdDialog", "$location", "$routeParams", "$filter", "npdcAppConfig", "NpolarTranslate"];

module.exports = formula;

},{"./edit.html":152}],154:[function(require,module,exports){
"use strict";

var angular = require('angular');
var common = angular.module('npdcCommon');

var templates = require('./templates');
require('./directives');

common.directive('npdcFormula', require('./formulaDirective'));

common.run(["$templateCache", "npdcAppConfig", function ($templateCache, npdcAppConfig) {
  npdcAppConfig.formula.templates = templates.materialTemplates;
  npdcAppConfig.formula.languages = [{
    map: require('formula/i18n/no.json'),
    code: 'nb_NO',
    aliases: ['no', 'nb', 'nn']
  }];
}]);

},{"./directives":144,"./formulaDirective":153,"./templates":162,"angular":"angular","formula/i18n/no.json":66}],155:[function(require,module,exports){
module.exports = '<fieldset ng-class="{ valid: field.valid, error: field.error }" ng-if="field.visible">\n  <md-whiteframe class="md-whiteframe-z2">\n\n    <legend>\n      <div>{{ field.title }} ({{ field.nrArrayValues() }})</div>\n      <div npdc:formula-field-info class="np-field-info" ng-if="::field.description"></div>\n    </legend>\n\n    <ul ng-if="::field.typeOf(\'field\')" class="np-formula-list">\n      <li ng-repeat="value in field.values" ng-class="{ valid: field.valid, error: field.error }" class="np-formula-list-item">\n        <formula:field field="value" class="multi-ctrls"></formula:field>\n        <div class="np-formula-input-ctrls">\n          <md-menu>\n            <md-button aria-label="Actions" class="md-icon-button" ng-click="$mdMenu.open($event)">\n              <md-icon md-menu-origin>menu</md-icon>\n              <md-tooltip md-direction="left">{{ i18n.text.actions.tooltip }}</md-tooltip>\n            </md-button>\n            <md-menu-content>\n              <md-menu-item ng-show="!$first">\n                <md-button ng-click="field.moveUp($index)">\n                  <md-icon md-menu-align-target>arrow_upward</md-icon> {{ i18n.text.moveup.label }}\n                  <md-tooltip md-direction="left">{{ i18n.text.moveup.tooltip }}</md-tooltip>\n                </md-button>\n              </md-menu-item>\n              <md-menu-item ng-show="!$last">\n                <md-button ng-click="field.moveDown($index)">\n                  <md-icon md-menu-align-target>arrow_downward</md-icon> {{ i18n.text.movedown.label }}\n                  <md-tooltip md-direction="left">{{ i18n.text.movedown.tooltip }}</md-tooltip>\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button ng-click="field.itemRemove($index)" class="md-warn">\n                  <md-icon md-menu-align-target>delete</md-icon> {{ i18n.text.remove.label }}\n                  <md-tooltip md-direction="left">{{ i18n.text.remove.tooltip }}</md-tooltip>\n                </md-button>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n      </li>\n    </ul>\n\n    <ul ng-if="::field.typeOf(\'fieldset\')" class="np-formula-list">\n      <li ng-repeat="value in field.values" ng-if="!value.hidden" class="np-formula-list-item">\n        <div class="np-formula-collapsed-item" ng-if="!value.visible" ng-click="field.itemToggle($index)"></div>\n        <md-whiteframe class="md-whiteframe-z2">\n          <fieldset ng-class="{ valid: value.valid }">\n            <legend>\n              <!--span class="np-formula-array-object-title">{{ value.title }}</span-->\n              <span ng-if="!value.visible">{{ value.value | formulaInlineValues }}</span>\n              <div class="np-formula-object-ctrls">\n                <div npdc:formula-field-info class="np-field-info" ng-if="value.description"></div>\n                <a href="" ng-click="field.itemToggle($index)">\n                  <md-icon>{{ value.visible ? \'expand_less\' : \'expand_more\' }}</md-icon>\n                  <md-tooltip>{{ value.visible ? i18n.text.minimize.tooltip : i18n.text.maximize.tooltip }}</md-tooltip>\n                </a>\n                <md-menu>\n                  <md-button aria-label="Actions" class="md-icon-button" ng-click="$mdMenu.open($event)">\n                    <md-icon md-menu-origin>menu</md-icon>\n                    <md-tooltip md-direction="left">{{ i18n.text.actions.tooltip }}</md-tooltip>\n                  </md-button>\n                  <md-menu-content>\n                    <md-menu-item ng-show="!$first">\n                      <md-button ng-click="field.moveUp($index)">\n                        <md-icon md-menu-align-target>arrow_upward</md-icon> {{ i18n.text.moveup.label }}\n                        <md-tooltip md-direction="left">{{ i18n.text.moveup.tooltip }}</md-tooltip>\n                      </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-show="!$last">\n                      <md-button ng-click="field.moveDown($index)">\n                        <md-icon md-menu-align-target>arrow_downward</md-icon> {{ i18n.text.movedown.label }}\n                        <md-tooltip md-direction="left">{{ i18n.text.movedown.tooltip }}</md-tooltip>\n                      </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                      <md-button ng-click="field.itemRemove($index)" class="md-warn">\n                        <md-icon md-menu-align-target>delete</md-icon> {{ i18n.text.remove.label }}\n                        <md-tooltip md-direction="left">{{ i18n.text.remove.tooltip }}</md-tooltip>\n                      </md-button>\n                    </md-menu-item>\n                  </md-menu-content>\n                </md-menu>\n              </div>\n            </legend>\n            <formula:field field="value" ng-if="value.visible" class="np-formula-array-fieldset"></formula:field>\n          </fieldset>\n        </md-whiteframe>\n      </li>\n    </ul>\n\n    <div class="np-formula-array-add">\n      <md-button ng-click="field.itemAdd()" class="md-fab md-mini md-primary md-hue-1" aria-label="{{ i18n.text.add.tooltip }}">\n        <md-icon>add</md-icon>\n        <md-tooltip>{{ i18n.text.add.tooltip }}</md-tooltip>\n      </md-button>\n    </div>\n    <div style="clear: both;"></div>\n  </md-whiteframe>\n</fieldset>\n';
},{}],156:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-checkbox ng-attr-id="::field.uid" ng-model="field.value" ng-disabled="field.disabled" aria-label="{{ field.title }}"  ng-if="field.visible">\n  <label for="{{::field.uid}}">{{ field.title }}</label>\n</md-checkbox>\n<div npdc:formula-validation-message class="np-validation-message"></div>\n';
},{}],157:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-input-container ng-if="field.visible">\n  <label for="{{::field.uid}}">{{field.title}}<i ng-if="field.required">&nbsp;({{ i18n.text.required }})</i></label>\n  <input type="text" ng-model="field.value" ng-disabled="field.disabled" chronopic />\n  <div npdc:formula-validation-message class="np-validation-message"></div>\n</md-input-container>\n';
},{}],158:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-input-container ng-if="field.visible">\n  <label for="{{::field.uid}}">{{field.title}}<i ng-if="field.required">&nbsp;({{ i18n.text.required }})</i></label>\n  <formula:input field="field"></formula:input>\n  <div npdc:formula-validation-message class="np-validation-message"></div>\n</md-input-container>\n';
},{}],159:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-icon>info_outline\n  <md-tooltip md-direction="left">{{ field.description }}</md-tooltip>\n</md-icon>\n';
},{}],160:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div class="np-tab np-formula-tab" ng-class="{ \'active\': fieldset.active }">\n  <formula:fields fields="::fieldset.fields"></formula:fields>\n</div>\n';
},{}],161:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div>\n  <form name="formula" class="formula" ng-show="form.ready">\n    <header ng-if="::form.title">\n      {{ form.title }}\n    </header>\n\n    <npdc:tabs tabs="form.fieldsets" tabactivate="form.activate"></npdc:tabs>\n    <formula:fieldsets class="np-tabs np-formula-fieldsets"></formula:fieldsets>\n\n    <div class="np-padding">\n      <span ng-if="form.errors" title="{{ form.errors.join(\'\n\') }}">{{ i18n.text.invalid | formulaReplace : { count: form.errors.length } }}</span>\n    </div>\n  </form>\n</div>\n';
},{}],162:[function(require,module,exports){
"use strict";

var angular = require('angular');
var common = angular.module('npdcCommon');

common.directive('npdcFormulaFieldInfo', function () {
  return { scope: false, template: require('./fieldInfo.html') };
});
common.directive('npdcFormulaValidationMessage', function () {
  return { scope: false, template: require('./validationMessage.html') };
});

var materialTemplates = [{
  match: '@form',
  template: require('./form.html')
}, {
  match: '@fieldset',
  template: require('./fieldset.html')
}, {
  match: '@field',
  template: require('./field.html')
}, {
  match: '@object',
  template: require('./object.html')
}, {
  match: '@array',
  template: require('./array.html')
}, {
  match: function match(field) {
    return field.typeOf('checkbox');
  },

  template: require('./checkbox.html')
}, {
  match: function match(field) {
    return field.typeOf('date') || field.typeOf('datetime') || field.format === 'year-month';
  },

  template: require('./date.html')
}, {
  match: function match(field) {
    return field.typeOf('range');
  },

  template: require('./range.html')
}, {
  match: function match(field) {
    return field.typeOf('select');
  },

  template: require('./select.html')
}];

module.exports = {
  materialTemplates: materialTemplates
};

},{"./array.html":155,"./checkbox.html":156,"./date.html":157,"./field.html":158,"./fieldInfo.html":159,"./fieldset.html":160,"./form.html":161,"./object.html":163,"./range.html":164,"./select.html":165,"./validationMessage.html":166,"angular":"angular"}],163:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<fieldset ng-if="field.visible">\n  <md-whiteframe class="md-whiteframe-z2">\n    <legend>{{ field.title }}\n      <div npdc:formula-field-info class="np-field-info" ng-if="::field.description"></div>\n    </legend>\n\n    <formula:fields fields="field.fields"></formula:fields>\n  </md-whiteframe>\n</fieldset>\n';
},{}],164:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div ng-if="field.visible">\n  <label for="{{::field.uid}}">{{ field.title }}:\n    <span>{{field.value}}</span>\n  </label>\n  <md-slider flex min="{{field.minimum}}" max="{{field.maximum}}" step="{{field.step}}" md-discrete ng-model="field.value" aria-label="{{field.title}}" ng-attr-id="field.uid">\n  </md-slider>\n  <div npdc:formula-validation-message class="np-validation-message"></div>\n</div>\n';
},{}],165:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-input-container ng-if="field.visible">\n  <label for="{{::field.uid}}">{{field.title}}<i ng-if="field.required">&nbsp;({{ i18n.text.required }})</i></label>\n\n  <!-- single-select -->\n  <md-select ng-model="field.value" ng-if="::!field.multiple">\n    <md-option ng-repeat="val in field.values" value="{{::val.id}}">{{val.label}}</md-option>\n  </md-select>\n\n  <!-- multi-select, ref: https://docs.angularjs.org/error/$compile/selmulti -->\n  <md-select ng-model="field.value" multiple ng-if="::field.multiple">\n    <md-option ng-repeat="val in field.values" value="{{::val.id}}">{{val.label}}</md-option>\n  </md-select>\n\n  <div npdc:formula-validation-message class="np-validation-message"></div>\n</md-input-container>\n';
},{}],166:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div class="md-caption" role="alert" ng-show="field.error">\n  {{ field.error.message }}\n</div>\n';
},{}],167:[function(require,module,exports){
"use strict";

var angular = require('angular');
var common = angular.module('npdcCommon');
require('./search');
require('./document');
require('./formula');

common.directive('ngFocusOut', require('./focusOutDirective'));

common.directive('npdcToolbar', require('./toolbar/toolbarDirective'));
common.directive('npdcUserMenu', require('./user-menu/userMenu'));

common.service('NpdcBreadcrumbs', require('./breadcrumbs/BreadcrumbsService'));
common.controller('NpdcBreadcrumbsController', require('./breadcrumbs/BreadcrumbsController'));
common.directive('npdcBreadcrumbs', require('./breadcrumbs/breadcrumbsDirective'));

common.directive('npdcBottom', require('./bottom/bottom'));
common.controller('NpdcBottomController', require('./bottom/BottomController'));

common.directive('npdcCreateButton', require('./button/CreateButton'));
common.directive('npdcEditButton', require('./button/EditButton'));
common.directive('npdcSaveButton', require('./button/SaveButton'));
common.directive('npdcDeleteButton', require('./button/DeleteButton'));
common.controller('NpdcButtonComponent', require('./button/ButtonComponent'));

common.controller('NpdcAppController', require('./app/AppController'));
common.directive('npdcApp', require('./app/appDirective'));

common.controller('NpdcBottomSheetController', require('./bottom-sheet/BottomSheetController'));
common.directive('npdcBottomSheet', require('./bottom-sheet/bottomSheetDirective'));

common.directive('npdcLoader', require('./loader/loaderDirective'));
common.directive('npdcFooter', require('./footer/footerDirective'));
common.directive('npdcTabs', require('./tabs/tabsDirective'));

common.controller('NpdcMetadataController', require('./metadata/MetadataController'));
common.directive('npdcMetadata', require('./metadata/metadataDirective'));
common.service('NpdcDOI', require('./metadata/DOI'));

common.service('NpdcWarningsService', require('./warnings/WarningsService'));
common.controller('NpdcWarningsController', require('./warnings/WarningsController'));
common.directive('npdcWarnings', require('./warnings/warningsDirective'));

common.directive('npdcContributions', require('./contributions/contributionsDirective'));

},{"./app/AppController":83,"./app/appDirective":85,"./bottom-sheet/BottomSheetController":86,"./bottom-sheet/bottomSheetDirective":88,"./bottom/BottomController":89,"./bottom/bottom":90,"./breadcrumbs/BreadcrumbsController":91,"./breadcrumbs/BreadcrumbsService":92,"./breadcrumbs/breadcrumbsDirective":94,"./button/ButtonComponent":95,"./button/CreateButton":96,"./button/DeleteButton":97,"./button/EditButton":98,"./button/SaveButton":99,"./contributions/contributionsDirective":101,"./document":114,"./focusOutDirective":131,"./footer/footerDirective":133,"./formula":154,"./loader/loaderDirective":169,"./metadata/DOI":170,"./metadata/MetadataController":171,"./metadata/metadataDirective":173,"./search":188,"./tabs/tabsDirective":196,"./toolbar/toolbarDirective":198,"./user-menu/userMenu":200,"./warnings/WarningsController":201,"./warnings/WarningsService":202,"./warnings/warningsDirective":204,"angular":"angular"}],168:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div ng-if="!error()" layout="row" layout-sm="column" layout-align="center center" layout-padding>\n  <md-progress-circular md-mode="indeterminate" md-diameter="96"></md-progress-circular>\n</div>\n<div ng-if="error()" layout-padding>{{error()}}</div>\n';
},{}],169:[function(require,module,exports){
'use strict';

var loaderDirective = function loaderDirective() {
  'ngInject';

  return {
    template: require('./loader.html'),
    scope: false
  };
};

module.exports = loaderDirective;

},{"./loader.html":168}],170:[function(require,module,exports){
'use strict';

var DOI = function DOI() {
  'ngInject';

  var self = this;

  this.isDoi = function (str) {
    return (/^10[.][0-9]+[/].+/.test(str)
    );
  };
  this.isDOI = self.isDoi;

  this.doi = function (str) {
    var doi = '10.' + str.split('10.')[1];
    if (self.isDOI(doi)) {
      return doi;
    }
  };
  this.DOI = self.doi;

  this.uri = function (str) {
    return 'https://doi.org/' + self.doi(str);
  };
};
module.exports = DOI;

},{}],171:[function(require,module,exports){
'use strict';

MetadataController.$inject = ["$scope", "$http", "$routeParams", "$filter", "$window", "NpolarApiSecurity"];
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function MetadataController($scope, $http, $routeParams, $filter, $window, NpolarApiSecurity) {
  'ngInject';

  var ctrl = this;

  //const LICENSE = "https://creativecommons.org/publicdomain/zero/1.0/";
  ctrl.name = function (email) {
    if (!email) {
      return;
    }
    return $filter('name')(email);
  };

  ctrl.editUri = function (id, resource) {
    return NpolarApiSecurity.canonicalUri(resource.path + '/' + id);
  };
  ctrl.path = function (id, resource) {
    return resource.uiBase + '/' + id;
  };

  ctrl.metadata = function (document) {
    var resource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $scope.resource;
    var metadata = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $scope.metadata;

    var href = void 0;
    var uri = void 0;
    var l = $window.location;
    var id = $routeParams.id;
    var base = l.protocol + '//' + l.host;
    if (resource) {
      href = ctrl.editUri(id, resource);
      uri = base + ctrl.path(id, resource);
    }
    var formats = [{ href: href, title: "JSON" }];
    return Object.assign({ uri: uri, id: document.id, formats: formats, schema: document.schema }, metadata || {});
  };

  // Fetch edits from Editlog API

  ctrl.edits = function (dataset, path) {
    var id = $routeParams.id;

    var params = {
      q: '',
      limit: 'all',
      format: 'json',
      variant: 'array',
      sort: '-request.time',
      'filter-path': path + '/' + id,
      'filter-method': 'PUT',
      'filter-response.status': '200..299',
      //'filter-request.time': `${dataset.created}..${dataset.updated}`, only sensible if newest...
      fields: 'request.time,request.username,response.header.Location'
    };

    return $http.get('//api.npolar.no/editlog', { params: params, cache: true });
  };

  var document = $scope.document || {};
  var resource = $scope.resource;

  if (document && resource) {
    $scope.metadata = ctrl.metadata(document, resource, $scope.metadata);
  }

  Object.keys($scope.metadata || {}).forEach(function (p) {
    if ($scope.metadata && $scope.metadata[p]) {
      $scope[p] = $scope.metadata[p];
    }
  });

  // if (!$scope.edits && resource) {
  //   $scope.edits = [];
  //   let path = resource.path.split('//api.npolar.no')[1]; // FIXME Only works in production
  //
  //   ctrl.edits(document||{}, path).then(r => {
  //     r.data.forEach(e => {
  //       // hmm only pushing one at a time works, probably async/digest issue
  //       // @todo refactor
  //       let href = e.response.header.Location;
  //       let rev = href.split('rev=')[1];
  //       let revision = rev.split('-')[0];
  //       let edit = { action: 'update', user: { id: e.request.username, name: ctrl.name(e.request.username)}, when: e.request.time, href, revision, rev };
  //
  //       $scope.edits.push(edit);
  //
  //     });
  //     // FIXME (create/revision 1 is pt impossible to GET from Editlog)
  //     if (document) {
  //       let created = { action: 'create', user: { id: document.created_by, name: ctrl.name(document.created_by) }, when: document.created, revision: '1' };
  //       $scope.edits.push(created);
  //     }
  //
  //
  //   });
  // }

  $scope.editors = function () {
    if (!$scope.edits) {
      return;
    }
    return [].concat(_toConsumableArray(new Set($scope.edits.map(function (e) {
      return e.user.name;
    })))).filter(function (a) {
      return (/ /.test(a)
      );
    });
  };

  if (!$scope.creator && document) {
    $scope.creator = {
      id: document.created_by,
      name: ctrl.name(document.created_by)
    };
  }

  if (!$scope.updater && document) {
    $scope.updater = {
      id: document.updated_by,
      name: ctrl.name(document.updated_by)
    };
  }

  if (document) {
    $scope.id = document.id;
    $scope.rev = document._rev;
    $scope.created = document.created;
    $scope.created_by = document.created_by;
    $scope.updated = document.updated;
    $scope.updated_by = document.updated_by;
  }
  // @todo warn also in bottom about old times...
}

module.exports = MetadataController;

},{}],172:[function(require,module,exports){
module.exports = '<md-card>\n  <md-card-header>\n    <md-card-avatar>\n      <md-icon><img src="/assets/components/metadata/json-ld-data-48.png"></md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <span class="md-headline">{{ (headline || \'Machine-readable data\') | t }}</span>\n      <span class="md-subhead" title="URI">{{ uri }}</span>\n      </span>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n    <p ng-if="formats">{{ (formats.length > 1) ? (\'Formats\'|t) : (\'Format\'|t) }}:\n      <span ng-repeat="link in formats">\n        <a ng-href="{{link.href}}" title="{{link.type}}">{{ link.title || link.href }}</a> <span ng-if="!$last">|</span>\n      </span>\n    </p>\n    <p ng-if="license">Metadata license: <a ng-href="{{ license }}">{{ license | t}}</a></p>\n    <p ng-if="schema">Metadata schema: <a ng-href="{{ schema }}">{{ schema | t }}</a></p>\n    <p ng-if="byline" marked="byline"></p>\n  </md-card-content>\n</md-card>\n\n<md-card ng-if="document">\n  <md-card-header>\n    <md-card-avatar>\n      <md-icon>history</md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <span class="md-headline">{{ (headline || \'Edit history\') | t }}</span>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n\n    <p>Metadata was created by {{ document.created_by | name  }}<span ng-if="editors().length > 0">, and edited by </span><span ng-repeat="editor in editors()"><span ng-if="!$first">, <span ng-if="$last">and </span></span>{{ editor }}</span>. Last update by {{ document.updated_by | name  }}.</p>\n\n    <!-- <md-menu>\n      <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">\n       <md-icon>track_changes</md-icon>\n       <md-tooltip>Time machine</md-tooltip>\n     </md-button>\n\n      <md-menu-content width="6">\n        <md-menu-item ng-repeat="edit in edits" ng-init="text = edit.when +\' \'+ (edit.user.name || edit.user.id|name) +\' [revision \'+ (edit.revision || \'?\') +\']\'">\n          <md-button ng-if="rev == edit.rev || edit.revision == 1" ng-disabled="true">{{text}}</md-button>\n          <md-button ng-if="rev != edit.rev && edit.revision > 1" rel="nofollow" ng-href="{{ edit.href }}">{{text}}</md-button>\n        </md-menu-item>\n      </md-menu-content>\n     </md-menu> -->\n    <!--@todo WARN if not newest @todo make prettier-->\n    <!-- @todo Available/Published DOI created) time -->\n\n    <span>\n      <md-tooltip>{{ document.created.split(\'T\')[1] }}</md-tooltip>\n      {{\'Created\' | t}} {{ document.created | isodate }}\n    </span>\n    <span>\n      <md-tooltip>{{document.updated.split(\'T\')[1]}} [revision: {{document._rev.split(\'-\')[0] }}]</md-tooltip>\n      {{\'Updated\' | t}} {{ document.updated | isodate }}\n    </span>\n\n  </md-card-content>\n</md-card>\n';
},{}],173:[function(require,module,exports){
'use strict';
// <npdc:metadata document="document" resource="resource"></npdc:metadata>

function metadataDirective() {
  'ngInject';

  return {
    scope: {
      resource: "=?",
      document: "=?",
      metadata: "=?"

    },
    template: require('./metadata.html'),
    controller: 'NpdcMetadataController'
  };
}

module.exports = metadataDirective;

},{"./metadata.html":172}],174:[function(require,module,exports){
'use strict';

var SearchConfigFactory = function SearchConfigFactory($location, NpolarTranslate) {
  'ngInject';

  var results = {
    avatar: undefined,
    title: undefined,
    subtitle: undefined,
    detail: undefined
  };
  var filterUi = {
    'year-released': {
      type: 'range' // 'autocomplete', 'checkbox', 'hidden'
    }
  };
  var placeholder = NpolarTranslate.translate('search');

  var constructor = function constructor(options) {
    return Object.assign({
      results: results,
      filterUi: filterUi,
      placeholder: placeholder
    }, options);
  };

  return constructor;
};
SearchConfigFactory.$inject = ["$location", "NpolarTranslate"];

module.exports = SearchConfigFactory;

},{}],175:[function(require,module,exports){
'use strict';

var AutocompleteConfigFactory = function AutocompleteConfigFactory(NpolarTranslate) {
  'ngInject';

  var showCollections = false;
  var floatingLabel = true;

  var collections = [{
    name: 'publication',
    path: '/publication',
    enabled: true
  }, {
    name: 'timeseries',
    path: '/indicator/timeseries',
    enabled: true
  }, {
    name: 'map-archive',
    path: '/map/archive',
    enabled: true
  }, {
    name: 'person',
    path: '/person',
    enabled: true
  }, {
    name: 'service',
    path: '/service',
    enabled: true
  }, {
    name: 'vessel',
    path: '/vessel',
    enabled: false
  }, {
    name: 'dataset',
    path: '/dataset',
    enabled: true
  }];

  var query = {
    limit: 30,
    score: true,
    fields: 'id,_score,schema,collection,titles,names,title,name,code,platform,publication_type,journal.name,published_sort'
  };

  var constructor = function constructor(options) {
    return Object.assign({
      collections: collections,
      showCollections: showCollections,
      placeholder: NpolarTranslate.translate('search'),
      query: query,
      global: false,
      location: undefined,
      floatingLabel: floatingLabel
    }, options);
  };

  return constructor;
};
AutocompleteConfigFactory.$inject = ["NpolarTranslate"];

module.exports = AutocompleteConfigFactory;

},{}],176:[function(require,module,exports){
'use strict';

var AutocompleteController = function AutocompleteController($location, $window, $q, $scope, NpolarApiResource, NpdcSearchService, npolarDocumentUtil) {
  'ngInject';

  if (!$scope.options) {
    $scope.options = {};
  }
  $scope.options.q = $scope.options.q || $location.search().q || "";

  var appBase = function () {
    var baseElem = document.querySelector('base') || {};
    var baseParts = (baseElem.href || '/').split('/');
    return '/' + (baseParts.pop() || baseParts.pop());
  }();

  $scope.submit = function ($event) {
    $scope.$$childHead.$mdAutocompleteCtrl.hidden = true;
    if ($scope.options.global) {
      NpdcSearchService.globalSearch({ q: $scope.options.q });
    } else {
      NpdcSearchService.search({ q: $scope.options.q });
    }
  };

  $scope.title = npolarDocumentUtil.title;

  // Search all collections for text q
  $scope.querySearch = function (q) {
    return NpdcSearchService.searchCollections(q, $scope.options);
  };

  $scope.selectedItemChange = function (entry) {
    if (!entry) {
      return;
    }
    var path = entry.path;
    if (path.includes(appBase)) {
      path = path.replace(appBase, '');
      $location.url(path);
    } else {
      $window.location.href = path;
    }
    $scope.options.q = "";
    $scope.$emit('autocomplete-navigate');
  };

  $scope.keyup = function ($event) {
    if ($event.keyCode === 13) {
      $scope.submit();
    }
  };
};
AutocompleteController.$inject = ["$location", "$window", "$q", "$scope", "NpolarApiResource", "NpdcSearchService", "npolarDocumentUtil"];

module.exports = AutocompleteController;

},{}],177:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div ng-keyup="keyup($event);">\n    <md-autocomplete ng-if="options.floatingLabel"\n      md-floating-label="{{options.placeholder | t}}"\n      md-item-text="title(item)"\n      md-items="item in querySearch(options.q)"\n      md-min-length="1"\n      md-no-cache="false"\n      md-search-text="options.q"\n      md-selected-item-change="selectedItemChange(item)"\n      md-selected-item="selectedItem"\n      md-menu-class="{{options.menuClass}}">\n\n      <md-item-template>\n        [{{item.collection}}] <span md-highlight-flags="^i" md-highlight-text="options.q">{{ title(item) }}</span>\n      </md-item-template>\n\n    </md-autocomplete>\n\n    <md-autocomplete ng-if="!options.floatingLabel"\n      placeholder="{{options.placeholder | t}}"\n      md-item-text="title(item)"\n      md-items="item in querySearch(options.q)"\n      md-min-length="1"\n      md-no-cache="true"\n      md-search-text="options.q"\n      md-selected-item-change="selectedItemChange(item)"\n      md-selected-item="selectedItem"\n      md-menu-class="{{options.menuClass}}">\n\n      <md-item-template>\n        [{{item.collection}}] <span md-highlight-flags="^i" md-highlight-text="options.q">{{ title(item) }}</span>\n      </md-item-template>\n\n    </md-autocomplete>\n\n    <div ng-if="options.showCollections && !expandSearch">\n      <br/>\n      <md-checkbox ng-model="options.collections[collection]" ng-repeat="(collection, value) in options.collections">{{ collection }}</md-checkbox>\n    </div>\n</div>\n';
},{}],178:[function(require,module,exports){
'use strict';

var autocompleteDirective = function autocompleteDirective() {
  'ngInject';

  return {
    controller: 'NpdcAutocompleteController',
    require: '?^^npdcExpandSearch',
    template: require('./autocomplete.html'),
    scope: {
      options: '='
    },
    link: function link(scope, elem, attrs, ctrl) {
      if (ctrl) {
        scope.expandSearch = true;
      }
    }
  };
};

module.exports = autocompleteDirective;

},{"./autocomplete.html":177}],179:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div class="np-expand-search" ng-keyup="keyup($event);" ng-class="{ open: isOpen, sm: $mdMedia(\'sm\'), md: $mdMedia(\'md\'), lg: $mdMedia(\'lg\')}">\n  <md-fab-toolbar md-theme="white" md-open="isOpen" md-direction="left">\n    <md-fab-trigger>\n      <md-button aria-label="search" class="md-fab md-mini" ng-focus-out="blockEvent($event);" ng-click="open($event);">\n        <md-icon>search</md-icon>\n        <md-tooltip>{{ \'search\' | t }}</md-tooltip>\n      </md-button>\n    </md-fab-trigger>\n\n    <md-toolbar ng-focus-out="blockEvent($event);" ng-click="blockEvent($event);">\n      <md-fab-actions class="md-toolbar-tools">\n        <form class="np-es-input" ng-class="{open : isFiltersOpen}" ng-submit="search();" layout>\n          <div flex layout>\n            <npdc:autocomplete flex options="options"></npdc:autocomplete>\n          </div>\n          <md-button class="md-icon-button" ng-click="toggleFilters();" aria-label="{{ \'search.filter\' | t }}">\n            <md-icon>settings</md-icon>\n            <md-tooltip ng-if="isOpenDelay">{{ \'search.filter\' | t }}</md-tooltip>\n          </md-button>\n          <md-button class="md-icon-button" type="submit" aria-label="{{ \'search\' | t }}">\n            <md-icon>search</md-icon>\n            <md-tooltip ng-if="isOpenDelay">{{ \'search\' | t }}</md-tooltip>\n          </md-button>\n        </form>\n      </md-fab-actions>\n    </md-toolbar>\n  </md-fab-toolbar>\n\n  <div ng-show="isFiltersOpen && isOpen" class="np-es-filter" ng-class="{ open: isFiltersOpen && isOpen }">\n    <div ng-if="options.showCollections" layout layout-wrap layout-align="space-between center">\n      <span flex="25" ng-repeat="collection in options.collections">\n        <md-checkbox ng-model="collection.enabled">{{ collection.name }}</md-checkbox>\n      </span>\n    </div>\n  </div>\n</div>\n\n<div id="np-es-click-area" ng-class="{ open: isOpen }" ng-click="close();"></div>\n';
},{}],180:[function(require,module,exports){
"use strict";

var expandSearch = function expandSearch() {
  'ngInject';

  return {
    restrict: 'E',
    scope: {
      options: '='
    },
    template: require('./expandSearch.html'),
    controller: ["$scope", "$element", "$mdMedia", "$timeout", "$location", "NpdcSearchService", "npdcAppConfig", "NpolarTranslate", function controller($scope, $element, $mdMedia, $timeout, $location, NpdcSearchService, npdcAppConfig, NpolarTranslate) {
      'ngInject';

      $scope.$mdMedia = $mdMedia;
      $scope.isOpen = false;
      $scope.isFiltersOpen = false;

      Object.assign($scope.options, {
        respectUrl: false,
        q: $location.search().q
      });

      $scope.placeholder = $scope.options.placeholder || NpolarTranslate.translate('search') + ' ' + npdcAppConfig.toolbarTitle;

      $scope.blockEvent = function ($event) {
        $event.stopImmediatePropagation();
        return false;
      };

      $scope.open = function () {
        var input = $element[0].querySelector('.np-es-input input');
        if (input) {
          input.focus();
        }

        // Firefox workaround
        $timeout(function () {
          $scope.isOpen = true;
        }, 1);

        $timeout(function () {
          $scope.isOpenDelay = true;
        }, 200);

        return false;
      };

      $scope.keyup = function ($event) {
        switch ($event.keyCode) {
          case 27:
          case 13:
            $scope.close();
            break;
          case 32:
            // Workaround for angular material bug with inputs in fab-toolbar
            $scope.options.q += ' ';
            break;
          default:
          //noop;
        }
      };

      $scope.close = function () {
        $scope.isOpen = $scope.isOpenDelay = false;
      };

      $scope.search = function (q) {
        var query = Object.assign({}, $location.search(), q || { q: $scope.options.q });
        NpdcSearchService.globalSearch(query);
      };

      $scope.toggleFilters = function () {
        $scope.isFiltersOpen = !$scope.isFiltersOpen;
      };

      $scope.$on('autocomplete-navigate', $scope.close);
    }]
  };
};

module.exports = expandSearch;

},{"./expandSearch.html":179}],181:[function(require,module,exports){
"use strict";

var FilterCollection = require('./FilterCollection');
var QueryBuilder = require('./QueryBuilder');
var urlFilterParser = require('./urlFilterParser');

var FacetingCtrl = function FacetingCtrl($scope, $location, $timeout, NpdcSearchService) {
  'ngInject';

  var ctrl = this;

  ctrl.clickedFacet = function (f) {
    //console.log('ctrl.clickedFacet', f);
  };

  var queryBuilder = new QueryBuilder();
  var UI_TYPES = ['autocomplete', 'checkbox', 'range', 'hidden'];
  var isURLParsed = false;
  var sliders = {};

  var filterChangeCallback = function filterChangeCallback(filters) {
    var q = queryBuilder.build(filters);
    NpdcSearchService.search(q);
    $scope.$emit('filter-change', { q: q, count: filters.length });
  };

  var filters = new FilterCollection($scope, filterChangeCallback);

  var uiType = function uiType(facet) {

    var _type = 'autocomplete';
    // @todo facet hiding needs to be dynamic...
    var hide = ['created_by', 'updated_by']; // These are exposed in <npdc:contributions>

    if (hide.includes(facet.key)) {
      _type = 'hidden';
    } else if ($scope.options.filterUi && $scope.options.filterUi[facet.key]) {
      var optType = $scope.options.filterUi[facet.key].type;
      _type = UI_TYPES.some(function (type) {
        return type === optType;
      }) ? optType : _type;
    }
    return _type;
  };

  var termToInt = function termToInt(term) {
    return typeof term === 'string' ? parseInt(term.replace(/-/g, '')) : term;
  };

  var onSliderEnd = function onSliderEnd(sliderId) {
    var facet = sliders[sliderId];
    if (facet.slider.min === facet.slider.options.floor && facet.slider.max === facet.slider.options.ceil) {
      filters.removeRangeFilter(facet);
    } else {
      filters.addRangeFilter(facet);
    }
  };

  var initRangeFacet = function initRangeFacet(facet) {
    var floor = void 0,
        ceil = void 0,
        min = void 0,
        max = void 0,
        filter = void 0;
    facet.slider = {};

    floor = min = facet[facet.key].reduce(function (memo, term) {
      return Math.min(termToInt(term.term), memo);
    }, termToInt(facet[facet.key][0].term));
    ceil = max = facet[facet.key].reduce(function (memo, term) {
      return Math.max(termToInt(term.term), memo);
    }, termToInt(facet[facet.key][0].term));
    filter = $scope.filterArray.find(function (item) {
      return facet.key === item.facet;
    });
    if (filter) {
      min = filter.min;
      max = filter.max;
    }
    facet.slider = {
      options: {
        id: facet.key,
        onEnd: onSliderEnd,
        floor: Math.min(min, floor),
        ceil: Math.max(max, ceil)
      },
      min: min,
      max: max
    };
    sliders[facet.key] = facet;

    return facet;
  };

  var emptyFacet = function emptyFacet(facet) {
    var key = Object.keys(facet)[0];
    return facet[key].length > 1;
  };

  var initDataModel = function initDataModel() {
    if (!$scope.options.facets) {
      return;
    }
    $scope.model = $scope.options.facets.filter(emptyFacet).map(function (facet) {
      var oldFacet = void 0;
      facet.key = Object.keys(facet)[0];
      oldFacet = $scope.model ? $scope.model.find(function (item) {
        return item.key === facet.key;
      }) : null;
      facet.uiType = uiType(facet);
      facet[facet.key] = facet[facet.key].map(function (term) {
        var oldTerm = void 0;
        term.facet = facet.key;
        oldTerm = oldFacet ? oldFacet[facet.key].find(function (ot) {
          return ot.term === term.term;
        }) : null;
        term.selected = oldTerm ? oldTerm.selected : undefined;
        return term;
      });

      if (facet.uiType === 'range') {
        facet = initRangeFacet(facet);
      }

      if (facet.uiType === 'autocomplete') {
        facet.querySearch = function (q) {
          q = q || '';
          return facet[facet.key].filter(function (item) {
            return item.term.toString().toLowerCase().indexOf(q.toLowerCase()) === 0;
          });
        };
      }

      return facet;
    });

    filters.updateCount($scope.model);

    if (!isURLParsed && $scope.options.facets.length > 0) {
      urlFilterParser.parseUrl($scope, filters, $location.search());
      isURLParsed = true;
    }
  };

  // Init data model
  initDataModel();

  $scope.$watch('options.facets', function (newVal, oldVal) {
    if (newVal) {
      initDataModel();
    }
  });

  // Respect the URL!
  $scope.$on('$locationChangeSuccess', function (event, data) {
    urlFilterParser.parseUrl($scope, filters, $location.search());
  });

  // Chips
  $scope.selectedChip = -1;
  $scope.selectChip = function (index) {
    if ($scope.selectedChip === index) {
      $scope.selectedChip = -1;
    } else {
      $scope.selectedChip = index;
    }
  };

  // Filters
  $scope.filters = ctrl.filters;

  ctrl.filters = function () {
    if (!filters || !filters.array) {
      return [];
    }
    return filters.array;
  };

  ctrl.activeFilters = function () {
    return ctrl.filters().length > 0;
  };

  $scope.removeFilter = function (filter) {
    var facet = $scope.model.find(function (facet) {
      return facet.key === filter.facet;
    });
    $scope.selectedChip = -1;
    filters.remove(filter);
    if (facet && facet.slider) {
      facet.slider.min = facet.slider.options.floor;
      facet.slider.max = facet.slider.options.ceil;
    }
  };

  // Autocomplete value selected
  ctrl.selectedItemChange = function (item, facet) {
    if (item) {
      filters.add(item);
    }
    // @todo Close filters?
  };

  // Checkbox
  $scope.toggleSelect = function (item) {
    if (item.selected) {
      filters.add(item);
    } else {
      filters.remove(item);
    }
  };

  // Content
  $scope.i18n = function (key) {
    return 'field.' + key;
  };
};
FacetingCtrl.$inject = ["$scope", "$location", "$timeout", "NpdcSearchService"];

module.exports = FacetingCtrl;

},{"./FilterCollection":182,"./QueryBuilder":183,"./urlFilterParser":187}],182:[function(require,module,exports){
'use strict';

var FilterCollection = function FilterCollection($scope, callback) {

  $scope.filterArray = $scope.filterArray || [];
  var calcCount = false;

  var equals = function equals(itemA, itemB) {
    return itemA.term === itemB.term && itemA.facet === itemB.facet;
  };

  var isInRange = function isInRange(item, min, max) {
    var value = parseInt(item.term);
    return value >= min && value <= max;
  };

  var termsInRange = function termsInRange(facet) {
    return facet[facet.key].filter(function (item) {
      return isInRange(item, facet.slider.min, facet.slider.max);
    });
  };

  var sumTermCount = function sumTermCount(terms) {
    return terms.reduce(function (memo, item) {
      return memo + item.count;
    }, 0);
  };

  var updateCount = function updateCount(facets) {
    if (!calcCount) {
      return;
    }
    $scope.filterArray.forEach(function (filter) {
      var facet = facets.find(function (f) {
        return f.key === filter.facet;
      });
      if (facet) {
        if (['date', 'number'].includes(filter.type)) {
          filter.count = sumTermCount(termsInRange(facet));
        } else {
          var term = facet[facet.key].find(function (t) {
            return t.term === filter.term;
          });
          filter.count = term ? term.count : filter.count;
        }
      }
    });
    calcCount = false;
  };

  var add = function add(filter) {
    if (!$scope.filterArray.some(function (item) {
      return equals(filter, item);
    })) {
      $scope.filterArray.push(filter);
      callback($scope.filterArray);
    }
  };

  var remove = function remove(filter) {
    var index = $scope.filterArray.findIndex(function (item) {
      return equals(filter, item);
    });
    if (index !== -1) {
      calcCount = true;
      $scope.filterArray.splice(index, 1)[0].selected = false;
      callback($scope.filterArray);
    }
  };

  var removeRangeFilter = function removeRangeFilter(facet) {
    var index = $scope.filterArray.findIndex(function (item) {
      return item.facet === facet.key;
    });
    if (index !== -1) {
      calcCount = true;
      $scope.filterArray.splice(index, 1);
      callback($scope.filterArray);
    }
  };

  var addRangeFilter = function addRangeFilter(facet) {
    var filter = void 0,
        existingFilter = void 0;
    var terms = termsInRange(facet);
    var isDate = /^(year)-.*$/.test(facet.key);
    filter = {
      count: sumTermCount(terms),
      term: facet.slider.min + ".." + facet.slider.max,
      facet: facet.key,
      type: isDate ? 'date' : 'number',
      min: facet.slider.min,
      max: facet.slider.max
    };
    existingFilter = $scope.filterArray.find(function (item) {
      return filter.facet === item.facet;
    });
    if (!existingFilter) {
      $scope.filterArray.push(filter);
    } else {
      Object.assign(existingFilter, filter);
    }
    callback($scope.filterArray);
  };

  return {
    add: add,
    addRangeFilter: addRangeFilter,
    equals: equals,
    remove: remove,
    removeRangeFilter: removeRangeFilter,
    updateCount: updateCount,
    array: $scope.filterArray
  };
};

module.exports = FilterCollection;

},{}],183:[function(require,module,exports){
'use strict';

var QueryBuilder = function QueryBuilder() {
  var UTC_DATE_PART = '-01-01T00:00:00Z';
  var RANGE_SEPARATOR = '..';

  var filterKey = function filterKey(filter) {
    if (filter === undefined) {
      return;
    }
    var key = 'filter-';
    if (filter.type === 'date') {
      key += filter.facet.replace(/^year-/, '');
    } else {
      key += filter.facet;
    }
    return key;
  };

  var filterValue = function filterValue(filter) {
    var value = filter.term;
    if (filter.type === 'date') {
      value = filter.min + UTC_DATE_PART + RANGE_SEPARATOR + (filter.max + 1) + UTC_DATE_PART;
    }
    return value;
  };

  var build = function build(filters) {
    if (filters === undefined) {
      return;
    }
    var query = {};
    filters.forEach(function (filter) {
      var key = filterKey(filter);
      var val = query[key] ? query[key] + ',' : '';
      query[key] = val + filterValue(filter);
    });

    return query;
  };

  return {
    build: build
  };
};

module.exports = QueryBuilder;

},{}],184:[function(require,module,exports){
'use strict';

// The <npdc:facet-link> directive provides clickable field facets, ie. html anchor (<a>) elements with @href set to filter-{field}={value})
// The directive respects the URI (ie. keeps existing query parameters)
// Example usage
// <npdc:facet-link value="{{ ctrl.getUser().email }}" field="created_by" params="{ sort: '-created'}" text="is&#160;creator" count="{{ctrl.count('created_by', ctrl.getUser().email) }}"></npdc:facet-link>
// @todo support not-
// @todo rename not- => reject?

facetLink.$inject = ["$location"];
function facetLink($location) {
  'ngInject';

  return {

    restrict: 'E',

    scope: {
      field: '@',
      value: '@',
      count: '@?',
      params: '=?',
      text: '@'
    },

    // todo not link if locaton.seac filter.-field =value!
    template: '<span ng-if="!ctrl.isFilter(field,value)"><a ng-href="{{ ctrl.filter_href(field,value,params) }}">{{ text }}</a><span ng-if="count"> ({{count}})</span></span>\n      <span ng-if="ctrl.isFilter(field,value)"><!-- @todo configurable hiding of selected? {{ text }} --></span>',

    controller: ["$scope", "$location", function facetLinkController($scope, $location) {
      'ngInject';

      this.filter_href = function (field, value, params) {
        var existing = Object.assign({}, $location.search()); // If you don't create a new copy, the location.search is updated => the app's location is changed *before* anybody clicks the link
        var href = '';

        existing['filter-' + field] = value; // @todo encode uri

        if (params) {
          Object.keys(params).forEach(function (k) {
            existing[k] = params[k];
          });
        }

        Object.keys(existing).forEach(function (k) {
          href += '&' + k + '=' + existing[k];
        });
        href = href.replace('&', '?');
        return href;
      };

      this.isFilter = function (field, value) {
        return $location.search()['filter-' + field] === value;
      };
    }],
    controllerAs: 'ctrl'

  };
}
module.exports = facetLink;

},{}],185:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<div class="np-faceting">\n  <!-- blue pills (active facet filters)-->\n  <div class="np-faceting-active-filters np-center-content" ng-show="ctrl.activeFilters()">\n    <div class="np-chips">\n      <div ng-repeat="filter in ctrl.filters()" ng-class="{\'md-focused\': selectedChip === $index}" class="np-chip md-default-theme">\n        <div class="np-chip-content" tabindex="-1" aria-hidden="true" ng-click="selectChip($index)">\n          <strong>{{ i18n(filter.facet) | t }}: {{ filter.term.replace(\'field.\', \'\') }}</strong>\n          <span ng-if="false">({{ filter.count }})</span><!-- @todo Make configurable? -->\n          <a class="np-chip-remove" ng-click="removeFilter(filter)" type="button" aria-hidden="true">\n            <md-icon>close</md-icon>\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- faceting -->\n  <div class="np-faceting-facets" layout="row" layout-wrap layout-align="space-around start">\n    <div ng-repeat="facet in model" flex="100" flex-gt-sm="50" flex-gt-md="33" ng-if="facet.uiType !== \'hidden\'">\n\n      <!-- autocomplete -->\n      <md-autocomplete ng-if="facet.uiType === \'autocomplete\'"\n        md-items="item in facet.querySearch(facet.searchText)"\n        md-item-text="item.term"\n        md-min-length="0"\n        md-search-text="facet.searchText"\n        md-floating-label="{{ i18n(facet.key) | t}}"\n        md-selected-item-change="ctrl.selectedItemChange(item, facet)"\n        md-select-on-match="true"\n        md-selected-item="facet.selectedItem">\n        <md-item-template>\n          <span md-highlight-text="facet.searchText" md-highlight-flags="^i" ng-click="ctrl.clickedFacet(item)">{{item.term}} ({{item.count}})</span>\n        </md-item-template>\n        <md-not-found>\n          No matches found for "{{facet.searchText}}".\n        </md-not-found>\n        <md-icon class="np-faceting-autocomplete-icon">arrow_drop_down</md-icon>\n      </md-autocomplete>\n\n      <!-- checkbox -->\n      <div ng-if="facet.uiType === \'checkbox\'" class="np-custom-facet">\n        <label>{{i18n(facet.key) | t}}</label>\n        <ul layout layout-wrap>\n          <li ng-repeat="item in facet[facet.key] | orderBy:\'-term\'" flex="none">\n            <md-checkbox ng-model="item.selected" ng-change="toggleSelect(item)">\n              {{item.term}} ({{item.count}})\n            </md-checkbox>\n          </li>\n        </ul>\n      </div>\n\n      <!-- range -->\n      <div ng-if="facet.uiType === \'range\'" class="np-custom-facet np-range-facet">\n        <label>{{i18n(facet.key) | t}}</label>\n        <rzslider rz-slider-options="facet.slider.options" rz-slider-model="facet.slider.min" rz-slider-high="facet.slider.max"></rzslider>\n      </div>\n\n    </div>\n  </div>\n\n</div>\n';
},{}],186:[function(require,module,exports){
"use strict";

var sidenav = function sidenav() {
    'ngInject';

    return {
        restrict: 'E',
        template: require('./faceting.html'),
        scope: {
            options: '=',
            show: '='
        },
        controller: 'NpdcFacetingCtrl',
        controllerAs: 'ctrl'
    };
};

module.exports = sidenav;

},{"./faceting.html":185}],187:[function(require,module,exports){
'use strict';

var FILTER_PARAM_REQEX = /^filter-(.*)/;
var RANGE_SEPARATOR = '..';

var parseUrl = function parseUrl($scope, filters, query) {
  if (filters === undefined) {
    return;
  }

  var parseRangeFilter = function parseRangeFilter(facet, terms) {
    var range = terms[0].split(RANGE_SEPARATOR);
    var min = parseInt(range[0].split('-')[0]);
    var max = parseInt(range[1].split('-')[0]) - 1; // 2010-01-01 -> facet term 2009

    if (!filters.array.some(function (filter) {
      return filters.equals(filter, {
        term: min + '..' + max,
        facet: facet.key
      });
    })) {
      if (facet.slider) {
        facet.slider.min = Math.max(min, facet.slider.floor);
        facet.slider.max = Math.min(max, facet.slider.ceil);
      } else {
        facet.slider = {
          min: min,
          max: max
        };
      }
      filters.addRangeFilter(facet);
    }
  };

  if (query) {
    Object.keys(query).forEach(function (key) {
      var matches = FILTER_PARAM_REQEX.exec(key);
      if (matches) {
        var key_reqex = new RegExp('^(year-)?' + matches[1] + '$');
        var facet = ($scope.options.facets || []).find(function (f) {
          return key_reqex.test(Object.keys(f)[0]);
        });
        var terms = query[key].split(',');
        if (facet) {
          facet.key = Object.keys(facet)[0];
          var item = facet[facet.key].find(function (item) {
            return item.term === terms[0];
          });
          if (item) {
            item.facet = facet.key;
          }
          if (facet.uiType === 'range' || query[key].includes(RANGE_SEPARATOR)) {
            parseRangeFilter(facet, terms);
          } else if (facet.uiType === 'checkbox' && item) {
            item.selected = true;
            filters.add(item);
          } else {
            terms.forEach(function (term) {
              var item = facet[facet.key].find(function (item) {
                return item.term === term;
              });
              filters.add(item);
            });
          }
        }
      }
    });
  }
};

module.exports = {
  parseUrl: parseUrl
};

},{}],188:[function(require,module,exports){
"use strict";

var angular = require('angular');
var ui = angular.module('npdcCommon');

ui.service('NpdcSearchService', require('./searchService'));
ui.controller('NpdcFacetingCtrl', require('./faceting/FacetingCtrl'));

ui.directive('npdcFaceting', require('./faceting/facetingDirective'));
ui.directive('npdcExpandSearch', require('./expandable-search/expandSearchDirective'));

ui.directive('npdcSearch', require('./results/searchResultsDirective'));
ui.directive('npdcSearchInput', require('./input/searchInputDirective'));
ui.controller('NpdcSearchResultsController', require('./results/SearchResultsController'));
ui.factory('NpdcSearchConfigFactory', require('./SearchConfigFactory'));

ui.controller('NpdcAutocompleteController', require('./autocomplete/AutocompleteController'));
ui.factory('NpdcAutocompleteConfigFactory', require('./autocomplete/AutocompleteConfigFactory'));
ui.directive('npdcAutocomplete', require('./autocomplete/autocompleteDirective'));

ui.directive('npdcFacetLink', require('./faceting/facetLinkDirective'));

},{"./SearchConfigFactory":174,"./autocomplete/AutocompleteConfigFactory":175,"./autocomplete/AutocompleteController":176,"./autocomplete/autocompleteDirective":178,"./expandable-search/expandSearchDirective":180,"./faceting/FacetingCtrl":181,"./faceting/facetLinkDirective":184,"./faceting/facetingDirective":186,"./input/searchInputDirective":190,"./results/SearchResultsController":191,"./results/searchResultsDirective":193,"./searchService":194,"angular":"angular"}],189:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-card>\n  <md-card-content class="np-search-input">\n\n    <div layout="row">\n      <md-input-container flex md-no-float md-autofocus class="np-search-input-input md-icon-left md-has-icon">\n        <md-icon>search</md-icon>\n        <input ng-model="query.q" placeholder="{{options.placeholder | t}}" type="text" md-autofocus>\n      </md-input-container>\n      <md-button class="md-icon-button np-search-input-filters" ng-click="ctrl.toggleFilters();">\n        <md-icon>build</md-icon>\n        <md-tooltip>{{ \'search.filter\' | t }}</md-tooltip>\n      </md-button>\n    </div>\n\n    <npdc:faceting ng-if="options" options="options" ng-class="{ open: isFiltersOpen }"></npdc:faceting>\n\n  </md-card-content>\n</md-card>\n\n<div class="clearfix"></div>';
},{}],190:[function(require,module,exports){
'use strict';

var searchInputDirective = function searchInputDirective() {
  'ngInject';

  return {
    scope: {
      options: '=?',
      feed: '='
    },
    template: require('./searchInput.html'),
    controllerAs: 'ctrl',
    controller: ["$scope", "$location", "NpdcSearchService", "npdcAppConfig", function controller($scope, $location, NpdcSearchService, npdcAppConfig) {
      'ngInject';

      var ctrl = this;

      ctrl.sort = function () {
        if ($location.search().sort) {
          return $location.search().sort;
        } else if ($scope.feed) {
          if (!/[?&]sort=/.test($scope.feed.links.find(function (f) {
            return f.rel === 'self';
          }).href)) {
            return 'relevance';
          }
        }
      };

      $scope.options = $scope.options || {};
      Object.assign($scope.options, npdcAppConfig.search.local, $scope.options, $scope.feed ? { facets: $scope.feed.facets } : {});
      $scope.query = {
        q: $location.search().q
      };
      $scope.isFiltersOpen = false;

      $scope.$watch('query.q', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          var query = Object.assign({}, $location.search(), { q: newVal });
          NpdcSearchService.search(query);
        }
      });

      $scope.$watch('feed', function (newVal, oldVal) {
        if (newVal && newVal.facets) {
          $scope.options.facets = newVal.facets;
        }
      });

      ctrl.toggleFilters = function () {
        $scope.isFiltersOpen = !$scope.isFiltersOpen;
      };
    }]
  };
};

module.exports = searchInputDirective;

},{"./searchInput.html":189}],191:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var SearchResultsController = function SearchResultsController($scope, $filter, $location, $http, NpolarApiSecurity, npdcAppConfig, npolarDocumentUtil, NpdcApplications) {
  'ngInject';

  var ctrl = this;

  var options = Object.assign({}, npdcAppConfig.search.local.results, $scope.options ? $scope.options.results : {});

  // FIXME @todo Sort select proved problematic, so taken out. Maybe move into a directive of its own?
  //ctrl.sort = (param=$location.search(), feed=$scope.feed) => {
  //  return param.sort;
  //  let sort;
  //  if (param.sort) {
  //    return param.sort;
  //  } else if (feed && feed.links) {
  //    if ((/[?&]sort=/).test($scope.feed.links.find(f => f.rel==='self').href)) {
  //      sort = $scope.feed.links.find(f => f.rel==='self').href.split('sort=')[1];
  //      console.log('sort', sort);
  //      return sort;
  //    } else {
  //      return null;
  //    }
  //  }
  //
  //};

  ctrl.removeFilters = function () {
    $location.path('/');
  };

  ctrl.hasFilters = function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $location.search();

    return Object.keys(param).find(function (k) {
      return (/^filter[-]/.test(k)
      );
    });
  };

  // @todo FIXME sort
  //ctrl.sort=null
  //ctrl.direction = '-';
  //ctrl.sortList = () => [
  //    { name: 'sort.relevance', sort: undefined },
  //    { name: `sort.${ctrl.direction}created`, sort: `${ctrl.direction}created` },
  //    { name: `sort.${ctrl.direction}updated`, sort: `${ctrl.direction}updated` }
  //];
  //ctrl.sortHref = (sort=ctrl.sort) => {
  //  let uiBase = $scope.resource.uiBase || '';
  //  return `${uiBase}?sort=${ sort }`;
  //}
  //if (sort !== null && (/^[-]/).test(sort)) {
  //  //  direction = '';
  //  //}

  $scope.security = NpolarApiSecurity;

  $scope.q = function () {
    return $location.search().q || "";
  };

  $scope.entryHref = function (entry) {
    if (typeof options.href === 'function') {
      return options.href.call({}, entry);
    }
    if (options.href) {
      return valueFromPath(entry, options.href);
    }

    return $scope.resource.href(entry.id);
  };

  $scope.avatar = function (entry) {
    if (typeof options.avatar === 'function') {
      return options.avatar.call({}, entry);
    }
    if (options.avatar) {
      return valueFromPath(entry, options.avatar);
    }
    return entry.id.substr(0, 3);
  };

  $scope.icon = function () {
    if (/placename/.test($scope.resource.uiBase)) {
      return '/assets/img/app-icons/48/placename.png';
    }
    var app = NpdcApplications.find(function (app) {
      return new RegExp(app.link).test($scope.resource.uiBase);
    });
    if (app) {
      return app.icons.find(function (icon) {
        return icon.size === 48;
      }).src;
    } else {
      return '/assets/img/app-icons/48/generic.png';
    }
  };

  $scope.title = function (entry) {
    var title = '';
    if (typeof options.title === 'function') {
      title = options.title.call({}, entry);
    } else if (options.title) {
      title = valueFromPath(entry, options.title);
    } else {
      title = npolarDocumentUtil.title(entry);
    }
    return title;
  };

  $scope.subtitle = function (entry) {
    if (typeof options.subtitle === 'function') {
      return options.subtitle.call({}, entry);
    }
    if (options.subtitle) {
      return valueFromPath(entry, options.subtitle);
    }
    return entry.created_by;
  };

  $scope.detail = function (entry) {
    if (typeof options.detail === 'function') {
      return options.detail.call({}, entry);
    }
    if (options.detail) {
      return valueFromPath(entry, options.detail);
    }

    return entry.updated ? entry.updated.split("T")[0] : undefined;
  };

  $scope.showNext = function () {
    if (!$scope.feed) {
      return false;
    }
    return $scope.feed.entries.length < $scope.feed.opensearch.totalResults;
  };

  $scope.next = function () {
    if (!$scope.feed.links) {
      return;
    }

    var nextLink = $scope.feed.links.find(function (link) {
      return link.rel === "next";
    });
    if (nextLink.href) {
      $http.get(nextLink.href.replace(/^https?:/, '')).success(function (response) {
        response.feed.entries = $scope.feed.entries.concat(response.feed.entries);
        $scope.feed = response.feed;
      });
    }
  };

  function valueFromPath(object, path, separator) {
    if ("object" === (typeof object === 'undefined' ? 'undefined' : _typeof(object)) && "string" === typeof path) {
      var node = object;

      if ("string" !== typeof separator || !separator.length) {
        separator = "/";
      }

      for (var segment; path && (segment = path.split(separator)[0]); path = path.slice(segment.length + separator.length)) {
        if ("object" === (typeof node === 'undefined' ? 'undefined' : _typeof(node))) {
          node = node[segment];
        }
      }

      if (node instanceof Array) {
        node = node.join(', ');
      }

      return node;
    }

    return undefined;
  }
};
SearchResultsController.$inject = ["$scope", "$filter", "$location", "$http", "NpolarApiSecurity", "npdcAppConfig", "npolarDocumentUtil", "NpdcApplications"];

module.exports = SearchResultsController;

},{}],192:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-content layout-padding ng-if="true">\n  <span ng-if="feed.opensearch.totalResults > 0">\n    {{feed.opensearch.totalResults}} results, displaying {{ feed.entries.length}}\n  </span>\n  <span ng-if="showNext()" ><a ng-href="#" ng-click="next()">More</a></span>\n  <span ng-if="feed.opensearch.totalResults == 0">{{ \'search.no_results\' | t}} "{{q()}}"<span ng-if="ctrl.hasFilters()">, try <a ng-click="ctrl.removeFilters()">removing all filters</a></span></span>\n<!--  <span ng-show="feed.opensearch.totalResults > 0">@todo FIXME infinite loop[sort by:\n    <a ng-repeat="s in ctrl.sortList" ng-href="{{ctrl.sortHref(s.sort)}}">{{ s.name }} </a>]\n  </span>-->\n</md-content>\n\n<npdc:contributions facets="feed.facets"></npdc:contributions>\n<npdc:create-button class="np-primary-control"></npdc:create-button>\n\n<div class="npdc-search">\n  <md-content>\n\n    <section>\n      <npdc:loader ng-if="!feed.entries"></npdc:loader>\n\n      <div class="np-layout-list">\n        <md-list>\n          <md-list-item class="md-2-line" ng-repeat="e in feed.entries" ng-href="{{ entryHref(e) }}">\n            <img class="md-avatar" ng-src={{icon(e)}} title="ID: {{ e.id }}" />\n\n            <!-- <div class="np-search-icon md-avatar" title="ID: {{ e.id }}">\n              <span>{{ avatar(e) }}</span>\n            </div> -->\n            <div class="md-list-item-text">\n              <h3 class="md-headline">\n                <span md-highlight-text="q()" md-highlight-flags="ig">{{title(e)}}</span>\n                <em ng-if="subtitle(e)">\n                  「{{ subtitle(e) }}」\n                </em>\n              </h3>\n              <h4>{{ detail(e) }}</h4>\n            </div>\n          </md-list-item>\n        </md-list>\n        <md-divider></md-divider>\n      </div>\n      <md-button class="md-raised md-primary" ng-if="showNext()" ng-click="next()">More</md-button>\n\n    </section>\n  </md-content>\n</div>\n';
},{}],193:[function(require,module,exports){
'use strict';

var searchResultsDirective = function searchResultsDirective() {
  'ngInject';

  return {
    scope: {
      options: '=',
      feed: '='
    },
    controller: 'NpdcSearchResultsController',
    controllerAs: 'ctrl',
    template: require('./searchResults.html'),
    link: function link(scope) {
      scope.resource = scope.$parent.resource;
      scope.error = scope.$parent.error;
    }
  };
};

module.exports = searchResultsDirective;

},{"./searchResults.html":192}],194:[function(require,module,exports){
'use strict';

var SearchService = function SearchService($location, $window, $q, npolarDocumentUtil, npdcAppConfig, NpolarApiResource) {
  'ngInject';

  var globalCollections = npdcAppConfig.search.global.collections;

  var buildResources = function buildResources(collections) {
    var searchResources = [];
    collections.forEach(function (c) {
      searchResources.push(NpolarApiResource.resource({
        path: c.path
      }));
    });
    return searchResources;
  };

  var globalSearchResources = buildResources(globalCollections);

  return {
    search: function search(query) {
      console.log('Search', query);
      var prevSearch = $location.search();
      Object.keys(prevSearch).filter(function (k) {
        return !(/^filter-/.test(k) || query.hasOwnProperty(k));
      }).forEach(function (k) {
        query[k] = prevSearch[k];
      });

      $location.search(query);
    },
    globalSearch: function globalSearch(query) {
      console.log('Global search', query);
      if (/^\/home\/search/.test(location.pathname)) {
        $location.search(query);
      } else if (/^\/home/.test(location.pathname)) {
        $location.$$search = query;
        $location.$$path = '/search/';
        $location.$$compose();
      } else {
        $window.location.href = '/home/search?q=' + query.q;
      }
    },

    searchCollections: function searchCollections(q) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // Merge in default query, respect url ?
      q = (q || '').toLocaleLowerCase();
      var query = Object.assign({}, options.respectUrl ? $location.search() : {}, options.query, {
        q: q
      });

      var collections = globalCollections;
      var searchResources = globalSearchResources;
      if (options.collections) {
        collections = options.collections;
        searchResources = buildResources(collections);
      }

      return $q.all(searchResources.map(function (resource) {
        return resource.array(query).$promise;
      })).then(function (results) {
        return results.reduce(function (memo, result, index) {
          // Get collection name from options (if not set in document)
          var items = result.map(function (item) {
            item.collection = item.collection || collections[index].name;
            item.path = collections[index].path + '/' + item.id;
            return item;
          });
          return memo.concat(items);
        }, []).sort(function (a, b) {
          var aIndex = npolarDocumentUtil.title(a).toLocaleLowerCase().indexOf(q);
          var bIndex = npolarDocumentUtil.title(b).toLocaleLowerCase().indexOf(q);

          // sort on best title match q
          var sort = 0;
          if (aIndex === bIndex === -1) {
            // sort on score
            if (a._score < b._score) {
              sort = -1;
            } else if (a._score > b._score) {
              sort = 1;
            }
          } else {
            if (aIndex !== -1 && bIndex !== -1) {
              // sort on title
              if (aIndex < bIndex) {
                sort = -1;
              } else if (aIndex > bIndex) {
                sort = 1;
              }
            } else {
              // one of a and b is -1
              sort = bIndex === -1 ? -1 : 1;
            }
          }

          return sort;
        });
      });
    }
  };
};
SearchService.$inject = ["$location", "$window", "$q", "npolarDocumentUtil", "npdcAppConfig", "NpolarApiResource"];

module.exports = SearchService;

},{}],195:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<nav ng-if="::tabs.length > 1" class="np-tabs-nav" layout="row">\n  <a class="np-nav-scroll" ng-click="back();"><md-icon>navigate_before</md-icon></a>\n  <md-virtual-repeat-container md-orient-horizontal flex>\n    <a md-virtual-repeat="tab in ::tabs" flex href="" md-ink-ripple class="np-nav-item" ng-class="{ active: tab.active, error: tab.valid === false}" ng-click="go($event, tab)">{{ tab.title }}</a>\n  </md-virtual-repeat-container>\n  <a class="np-nav-scroll" ng-click="next();"><md-icon>navigate_next</md-icon></a>\n</nav>\n';
},{}],196:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var angular = require('angular');

var tabsDirective = function tabsDirective($timeout) {
  'ngInject';

  return {
    template: require('./tabs.html'),
    scope: {
      tabs: '=',
      tabactivate: '=?'
    },
    link: function link(scope, element) {
      var duration = 250;

      console.log('tabs', scope.tabs);

      var activate = function activate(tab) {
        var fieldsetContainer = document.querySelector('.np-tabs');
        if (!fieldsetContainer) {
          return;
        }
        var tabNodes = fieldsetContainer.querySelectorAll('.np-tab');
        scope.tabs.forEach(function (t, i) {
          var $tab = angular.element(tabNodes[i]);
          if ((typeof tab === 'undefined' ? 'undefined' : _typeof(tab)) === 'object' || typeof tab === 'number') {
            if ((typeof tab === 'undefined' ? 'undefined' : _typeof(tab)) === 'object' ? t === tab : i === tab) {
              t.active = true;
              $tab.addClass('active');
            } else {
              t.active = false;
              $tab.removeClass('active');
            }
          }
        });
        if (typeof scope.tabactivate === 'function') {
          scope.tabactivate(tab);
        }
      };

      var animateHorizontalScroll = function animateHorizontalScroll(elem, stop) {
        var step = 25;
        var steps = duration / step;
        var start = elem.scrollLeft;
        var length = stop - start;
        var increment = length / steps;
        if (length !== 0) {
          var timer = setInterval(function () {
            if (length > 0 && elem.scrollLeft + increment >= stop || length < 0 && elem.scrollLeft + increment <= stop) {
              elem.scrollLeft = stop;
              clearInterval(timer);
            } else {
              elem.scrollLeft += increment;
            }
          }, step);
          setTimeout(function () {
            clearInterval(timer);
          }, duration + 10);
        }
      };

      var slideIntoView = function slideIntoView() {
        var fieldsetContainer = document.querySelector('.np-tabs');
        if (fieldsetContainer) {
          var active = fieldsetContainer.querySelector('.np-tab.active');
          if (active) {
            var move = active.getBoundingClientRect().left - fieldsetContainer.getBoundingClientRect().left;
            fieldsetContainer.style.left = -move + 'px';
          }
        }
      };

      scope.next = function () {
        var scrollContainer = element[0].querySelector('.md-virtual-repeat-scroller');
        var scroll = scrollContainer.scrollLeft;
        animateHorizontalScroll(scrollContainer, scroll + 180);
      };

      scope.back = function () {
        var scrollContainer = element[0].querySelector('.md-virtual-repeat-scroller');
        var scroll = scrollContainer.scrollLeft;
        animateHorizontalScroll(scrollContainer, scroll - 180);
      };

      scope.go = function (ev, tab) {
        var tabsContainer = element[0].querySelector('md-virtual-repeat-container');
        var scrollContainer = element[0].querySelector('.md-virtual-repeat-scroller');
        var scrollPos = scrollContainer.scrollLeft;
        var width = tabsContainer.clientWidth;
        var offset = ev.target.offsetLeft;
        var elemWidth = ev.target.offsetWidth;
        if (scrollPos > offset) {
          animateHorizontalScroll(scrollContainer, offset);
        } else if (scrollPos + width < offset + elemWidth) {
          animateHorizontalScroll(scrollContainer, offset - width + elemWidth);
        }

        var i = 0,
            child = ev.target;
        while (child = child.previousElementSibling) {
          i++;
        }

        activate(tab);

        slideIntoView();
      };

      activate(scope.tabs[0]);

      // recalc slide if window is resized
      addEventListener('resize', slideIntoView);

      // Hack to dected if scrollbars are added
      // Demo: http://jsfiddle.net/pFaSx/
      // Create an invisible iframe
      var iframe = document.createElement('iframe');
      iframe.id = "hacky-scrollbar-resize-listener";
      iframe.style.cssText = 'height: 0; background-color: transparent; margin: 0; padding: 0; overflow: hidden; border-width: 0; position: absolute; width: 100%;';

      // Register our event when the iframe loads
      iframe.onload = function () {
        // The trick here is that because this iframe has 100% width
        // it should fire a window resize event when anything causes it to
        // resize (even scrollbars on the outer document)
        iframe.contentWindow.addEventListener('resize', function () {
          try {
            var evt = document.createEvent('UIEvents');
            evt.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(evt);
          } catch (e) {}
        });
      };

      // Stick the iframe somewhere out of the way
      document.body.appendChild(iframe);
    }
  };
};
tabsDirective.$inject = ["$timeout"];

module.exports = tabsDirective;

},{"./tabs.html":195,"angular":"angular"}],197:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-toolbar class="np-toolbar">\n  <div class="md-toolbar-tools np-toolbar-content">\n    \n    <a href=" {{ uiBase() || \'.\'}}" class="np-app-title">\n      <strong>{{ appTitle() }}</strong>\n    </a>\n\n    <span class="flex"><!-- This span is used to push the other content to the right --></span>\n\n    <a href="/" class="np-toolbar-title" hide>\n      <a href="/" class="np-toolbar-logo" hide-xs>\n        <img hide-xs src="/assets/img/NPI-logo-hvit-no.png" alt="{{siteTitle()}} {{ \'home\' | t }}" title="{{siteTitle()}}" />\n      </a>\n      <!--<span><!--{{ siteTitle() }}--><!--<a href="/" class="np-toolbar-logo"><abbr title="{{ \'NPDC\'|t }}">NPDC</abbr></a></span>-->\n    </a>\n    \n    <span class="flex"><!-- This span is used to push the other content to the right --></span>\n    \n     <md-menu class="np-app-menu">\n      \n      <md-button class="md-icon-button" ng-click="$mdMenu.open($event)">\n        <md-icon md-menu-origin>apps</md-icon>\n        <md-tooltip>{{ \'npdc.menu.quicknav\' | t }}</md-tooltip>\n      </md-button>\n      \n      <md-menu-content width="6" class="np-app-menu-content">\n    \n        <!-- Apps -->    \n        <div ng-repeat="group in options.toolbarMenuGroups">\n          <md-subheader>{{group.name}}</md-subheader>\n          <md-grid-list md-cols="3" md-row-height="80px" md-gutter="10px">\n            <md-grid-tile ng-repeat="app in group.apps">\n              <a ng-href="{{app.link}}" class="np-app-icon">\n                <img ng-src="{{icon48(app)}}"/>\n                <div>{{ app.link | t }}</div>\n              </a>\n            </md-grid-tile>\n          </md-grid-list>\n          <md-divider></md-divider>\n        </div>\n\n        <!-- Apps for logged-in users -->\n        \n        \n        <div ng-show="security.isAuthenticated()">\n          <div ng-repeat="group in options.toolbarInternalApps">\n            <md-subheader>{{group.name}}</md-subheader>\n            <md-grid-list md-cols="3" md-row-height="80px" md-gutter="10px">\n              <md-grid-tile ng-repeat="app in group.apps">\n                <a ng-href="{{app.link}}" class="np-app-icon">\n                  <img ng-src="{{icon48(app)}}"/>\n                  <div>{{ app.link | t }}</div>\n                </a>\n              </md-grid-tile>\n            </md-grid-list>\n            <md-divider></md-divider>\n          </div>\n        </div>\n              \n      </md-menu-content>\n    </md-menu>\n    \n    <!-- Login -->\n    <npdc:user-menu></npdc:user-menu>\n    \n\n    <npdc:expand-search options="options.search.global"></npdc:expand-search>\n  \n  </div>\n</md-toolbar>';
},{}],198:[function(require,module,exports){
"use strict";

var toolbar = function toolbar($mdSidenav, $document, NpolarApiSecurity, NpolarTranslate) {
  'ngInject';

  var APP_TITLE_CODE = 'npdc.app.Title';
  var SITE_TITLE_CODE = 'NPDC';

  return {
    restrict: 'E',
    scope: {
      resource: '=?',
      options: '=?'
    },
    template: require('./toolbar.html'),
    link: function link(scope) {
      scope.security = NpolarApiSecurity;
    },
    controller: ["$scope", "$location", "$routeParams", "NpolarApiResource", "npdcAppConfig", function controller($scope, $location, $routeParams, NpolarApiResource, npdcAppConfig) {
      'ngInject';

      $scope.uiBase = function () {
        var base = $document[0].getElementsByTagName('base')[0].href || '';
        base = base.replace(/\/$/, '');

        var path = '';
        if ($routeParams.id) {
          path = $location.path().split($routeParams.id)[0];
        } else {
          path = $location.path();
        }
        path = path.replace(/\/$/, '');

        var uiBase = base + path;

        return uiBase;
      };

      $scope.options = $scope.options || npdcAppConfig;

      $scope.appTitle = function () {
        var i18nTitle = NpolarTranslate.translate(APP_TITLE_CODE);
        return i18nTitle === APP_TITLE_CODE ? $scope.options.toolbarTitle : i18nTitle;
      };

      $scope.siteTitle = function () {
        var i18nTitle = NpolarTranslate.translate(SITE_TITLE_CODE);
        return i18nTitle === SITE_TITLE_CODE ? 'Norwegian Polar Data Centre' : i18nTitle;
      };

      $scope.icon48 = function (app) {
        return app.icons.find(function (icon) {
          return icon.size === 48;
        }).src;
      };
    }]
  };
};
toolbar.$inject = ["$mdSidenav", "$document", "NpolarApiSecurity", "NpolarTranslate"];

module.exports = toolbar;

},{"./toolbar.html":197}],199:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-menu ng-if="!security.isAuthenticated()" class="np-user-menu">\n  <md-button aria-label="Open user" class="md-icon-button" ng-click="$mdMenu.open($event)">\n    <md-icon md-menu-origin>person</md-icon>\n    <md-tooltip>{{ \'npdc.menu.user\' | t }}</md-tooltip>\n  </md-button>\n  <md-menu-content width="6">\n\n    <form class="np-login np-padding" ng-submit="login(email,password)">\n      <div layout="column">\n        <md-input-container>\n          <label for="username" class="md-no-float">{{ \'user.username\' | t }}</label>\n          <input type="text" ng-model="email" id="username" placeholder="Enter your email address">\n        </md-input-container>\n        <md-input-container ng-show="true">\n          <label for="password" class="md-no-float">{{ \'user.password\' | t }}</label>\n          <input type="password" id="password" ng-trim="true" ng-model="password" placeholder="Enter password (or 1-time code)">\n        </md-input-container>\n      </div>\n      <div layout="row" layout-align="space-between center">\n        <md-button ng-disabled="!email || password" type="button" ng-click="gouncer.onetime(email)" class="md-raised md-primary">Email code</md-button>\n        <md-button ng-disabled="!email || !password" type="submit" class="md-raised md-primary">{{ \'user.login\' | t }}</md-button>\n      </div>\n    </form>\n\n    <md-divider></md-divider>\n    <md-menu-item>\n      <md-menu>\n        <md-button ng-click="$mdMenu.open($event)">\n          <md-icon>language</md-icon>\n          {{ lang.getNativeName(lang.getLang()) }}\n        </md-button>\n        <md-menu-content width="6">\n          <md-menu-item ng-repeat="subtag in lang.getLanguages()">\n            <md-button ng-disabled="subtag == lang.getLang()" ng-click="lang.setLang(subtag, lang.getLang())">{{ lang.getNativeName(subtag) }}<span ng-show="subtag==lang.getLang()"> ({{ \'npdc.current_language\' | t }})</span></md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </md-menu-item>\n  \n  \n  \n  </md-menu-content>\n</md-menu>\n\n<md-menu ng-if="security.isAuthenticated()" class="np-user-menu">\n  <md-button aria-label="Open user" class="md-icon-button" ng-click="$mdMenu.open($event)">\n    <md-icon md-menu-origin>account_box</md-icon>\n    <md-tooltip>{{ security.getUser().name }}</md-tooltip>\n  </md-button>\n  <md-menu-content width="6">\n\n    <md-menu-item>\n      <md-button ng-href="/user/{{security.getUser().email }}" title="View profile for {{ security.getUser().name }}">\n        <md-icon md-menu-align-target>face</md-icon>\n        {{ security.getUser().name }}\n      </md-button>\n    </md-menu-item>\n\n    <md-divider></md-divider>\n    <md-menu-item>\n      <md-button ng-click="logout()">\n        <span>{{ \'user.logout\' | t }}</span>\n      </md-button>\n    </md-menu-item>\n    \n    <md-divider></md-divider>\n    <md-menu-item>\n      <md-menu>\n        <md-button ng-click="$mdMenu.open($event)">\n          <md-icon>language</md-icon>\n          {{ lang.getNativeName(lang.getLang()) }}\n        </md-button>\n        <md-menu-content width="6">\n          <md-menu-item ng-repeat="subtag in lang.getLanguages()">\n            <md-button ng-disabled="subtag == lang.getLang()" ng-click="lang.setLang(subtag, lang.getLang())">{{ lang.getNativeName(subtag) }}<span ng-show="subtag==lang.getLang()"> ({{ \'npdc.current_language\' | t }})</span></md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </md-menu-item>\n    \n\n  </md-menu-content>\n</md-menu>\n\n\n\n';
},{}],200:[function(require,module,exports){
"use strict";

var npdcUserMenu = function npdcUserMenu(NpolarApiSecurity, NpolarLang, Gouncer) {
  'ngInject';

  return {
    scope: {},
    restrict: 'AE',
    template: require('./userMenu.html'),
    controller: 'NpolarLoginController',
    link: function link(scope) {
      scope.security = NpolarApiSecurity;
      scope.lang = NpolarLang;
      scope.gouncer = Gouncer;
    }
  };
};
npdcUserMenu.$inject = ["NpolarApiSecurity", "NpolarLang", "Gouncer"];

module.exports = npdcUserMenu;

},{"./userMenu.html":199}],201:[function(require,module,exports){
'use strict';

var WarningsController = function WarningsController($scope, $routeParams, $document, $location, NpolarMessage, NpdcWarningsService) {
  'ngInject';

  var id = function id() {
    return $routeParams.id;
  };
  var rev = function rev() {
    return $location.search().rev;
  };
  var isArchived = function isArchived() {
    return $location.search().rev && /^[0-9]+[-]/.test($location.search().rev);
  };
  var revision = function revision() {
    return rev().split('-')[0];
  };

  // FIXME move to ?
  var uiBase = function uiBase() {
    var base = $document[0].getElementsByTagName('base')[0].href || '';
    base = base.replace(/\/$/, '');

    var path = '';
    if ($routeParams.id) {
      path = $location.path().split($routeParams.id)[0];
    } else {
      path = $location.path();
    }
    path = path.replace(/\/$/, '');

    var uiBase = base + path;

    return uiBase;
  };

  $scope.headline = "Warning";
  $scope.icon = "warning";
  $scope.subhead = "Observe the following issues";

  $scope.notices_headline = "Notice";
  $scope.notices_subhead = "Please observe";

  $scope.httpError = false;

  NpolarMessage.on('npolar-api-error', function (message) {

    console.log("httpError");

    $scope.httpError = true;
    // message = {status: 404, method: "GET", uri: "//api.npolar.no/…", headers: {}, time: "2016-11-25T10:48:12.510Z"…}
    $scope.headline = 'Error';
    $scope.icon = 'error';
    // @todo sticky
    $scope.subhead = '' + window.location;

    if (404 === message.status) {
      if (!rev()) {
        NpdcWarningsService.warnings[id] = ["Document does not exist"];
      } else {
        NpdcWarningsService.warnings[id] = ["Document or revision does not exist"];
      }
    }
  });

  $scope.warnings = function () {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $routeParams.id;

    if (!id) {
      return;
    }
    var warnings = NpdcWarningsService.warnings[id];
    if (isArchived()) {
      return ['You are displaying archived revision ' + revision() + ' of this page <a href="' + uiBase() + '/' + id + '">click here</a> to go back to the current version'].concat(warnings);
    }
    return warnings;
  };

  $scope.notices = function () {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $routeParams.id;

    return NpdcWarningsService.notices[id];
  };
};
WarningsController.$inject = ["$scope", "$routeParams", "$document", "$location", "NpolarMessage", "NpdcWarningsService"];

module.exports = WarningsController;

},{}],202:[function(require,module,exports){
'use strict';

// Set and get warnings and notices (for a document)
// Example of setting warnings:
// * NpdcWarningsService.warnings[dataset.id] = DatasetModel.warnings(dataset);

function NpdcWarningsService() {
  'ngInject';

  //let self = this;

  // Holds warnings for each document (key: $routeParam.id)

  this.warnings = {};

  // Holds notices for each document (key: $routeParam.id)
  this.notices = {};

  return this;
}

module.exports = NpdcWarningsService;

},{}],203:[function(require,module,exports){
module.exports = '<md-card ng-if="warnings().length > 0">\n  <md-card-header>\n  <md-card-avatar>\n    <md-icon>{{ icon }}</md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-headline">{{ headline | t }}</span>\n    <span class="md-subhead">{{ subhead | t }}</span>\n  </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n    <ul>\n      <li ng-repeat="warn in warnings()">\n        <span marked="warn"></span>\n      </li>\n    </ul>\n  </md-card-content>\n</md-card>\n<md-card ng-if="notices().length > 0 && warnings().length === 0">\n  <md-card-header>\n  <md-card-avatar>\n    <md-icon>info</md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class="md-headline">{{ notices_headline }} </span>\n    <span class="md-subhead">{{ notices_subhead}}<span ng-if="document.released">Data release: {{ document.released.split(\'T\')[0] }}</span></span>\n  </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n    <ul>\n      <li ng-repeat="info in notices()">\n        {{ info | t }}\n      </li>\n    </ul>      \n  </md-card-content>\n</md-card>';
},{}],204:[function(require,module,exports){
'use strict';

function warningsDirective() {
  return {
    controller: 'NpdcWarningsController',
    template: require('./warnings.html')
  };
}

module.exports = warningsDirective;

},{"./warnings.html":203}],205:[function(require,module,exports){
"use strict";

var AutoConfig = function AutoConfig(environment) {
  'ngInject';

  this.environment = environment;

  var isTest = function isTest(hostname) {
    return (/test/.test(hostname.split(".")[0])
    );
  };

  var detectEnvironment = function detectEnvironment(hostname) {
    var environment;
    if ("localhost" === hostname) {
      environment = "development";
    } else if (isTest(hostname)) {
      environment = "test";
    } else if ("data.npolar.no" === hostname) {
      environment = "production";
    }
    return environment;
  };

  // jshint -W116
  var base = function base(environment) {
    var base;
    if ("development" === environment) {
      base = "//localhost:9393";
    } else if ("test" === environment) {
      base = "https://api-test.data.npolar.no";
    } else if ("production" === environment || null == environment) {
      base = "//api.npolar.no";
    } else {
      throw "Unknown environment";
    }
    return base;
  };

  // Auto-detect environment - only allow overriding on localhost/vm
  if (("localhost" === window.location.hostname || "10.0.2.2" === window.location.hostname) && typeof this.environment === 'string') {
    console.warn("Environment:", this.environment, "[localhost override]");
  } else {
    this.environment = detectEnvironment(window.location.hostname);
    console.log("Environment:", this.environment, "[auto-detected]");
  }

  this.base = base(this.environment);

  if ("production" === this.environment) {
    if ("https:" !== window.location.protocol) {
      console.warn("WARNING", "Not using HTTPS in production environment");
    }
    if ("data.npolar.no" !== window.location.hostname) {
      console.warn("WARNING", "Running against production API", this.base, "from", window.location.href);
    }
  }
  return this;
};
AutoConfig.$inject = ["environment"];

module.exports = AutoConfig;

},{}],206:[function(require,module,exports){
module.exports=[{
		"link": "/dataset",
		"name": [{
			"@language": "en",
			"@value": "Dataset catalogue"
		}, {
			"@language": "no",
			"@value": "Datasett"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/dataset.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/dataset.png"
		}],
		"screenshots": ["/assets/img/screenshots/dataset_esri.png"],
		"description": [{
			"@language": "no",
			"@value": "Alle publiserte og ikke-publiserte datasett som forvaltes av Norsk Polarinstitutt"
		}, {
			"@language": "en",
			"@value": "All published and non-published datasets curated by the Norwegian Polar Institute"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "//api.npolar.no",
		"name": [{
			"@language": "en",
			"@value": "REST APIs"
		}, {
			"@language": "no",
			"@value": "REST API"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/api.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/api.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Machine readable data"
		}, {
			"@language": "no",
			"@value": "Maskinlesbare data"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/map",
		"name": [{
			"@language": "en",
			"@value": "Maps"
		}, {
			"@language": "nb",
			"@value": "Kart"
		}, {
			"@language": "nn",
			"@value": "Kart"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/geodata.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/geodata.png"
		}],
		"screenshots": ["https://raw.githubusercontent.com/npolar/npdc-map/master/screenshots/Kartarkiv-framside-2016-02-08.png"],
		"description": [{
			"@language": "en",
			"@value": "Map data. Map services. Digitised maps. Web maps"
		}, {
			"@language": "nb",
			"@value": "Kartdata. Karttjenester. Kartasamlinga. Kart på web"
		}, {
			"@language": "nn",
			"@value": "Kartdata. Karttenestar. Kartsamlinga. Kart på web"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/expedition",
		"name": [{
			"@language": "en",
			"@value": "Expeditions"
		}, {
			"@language": "no",
			"@value": "Ekspedisjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "data:image/png;base64,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"
		}, {
			"size": 48,
			"src": "data:image/png;base64,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"
		}],
		"screenshots": ["/assets/img/screenshots/expedition.png"],
		"description": [{
			"@language": "en",
			"@value": "Cruises and field campaigns"
		}, {
			"@language": "no",
			"@value": "Tokt og felt"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/geology",
		"name": [{
			"@language": "en",
			"@value": "Geology"
		}, {
			"@language": "no",
			"@value": "Geologi"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/geology.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/geology.png"
		}],
		"screenshots": ["/assets/img/screenshots/geology.png"],
		"description": [{
			"@language": "en",
			"@value": "Geology rock collection"
		}, {
			"@language": "no",
			"@value": "Geologi steinsamling"
		}],
		"category": "public",
		"promote": true
	},

	{
		"link": "/tracking",
		"name": [{
			"@language": "en",
			"@value": "Tracking"
		}, {
			"@language": "no",
			"@value": "Sporing"
		}],
		"icons": [{
			"size": 96,
			"src": "https://openclipart.org/image/96px/svg_to_png/205608/gps-icon.png"
		}, {
			"size": 48,
			"src": "https://openclipart.org/image/96px/svg_to_png/205608/gps-icon.png"
		}],
		"screenshots": ["/assets/img/screenshots/tracking.png"],
		"description": [{
			"@language": "en",
			"@value": "Animal positions and sensor data"
		}, {
			"@language": "no",
			"@value": "Sporing av dyr: posisjoner og sensordata"
		}],
		"category": "internal",
		"promote": false
	}, {
		"link": "/vessel",
		"name": [{
			"@language": "en",
			"@value": "Vessels"
		}, {
			"@language": "no",
			"@value": "Skuter"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/vessels.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/vessels.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "The life history of ships sailing in the Arctic, built before 1940"
		}, {
			"@language": "nb",
			"@value": "Historien til arktiske skuter bygget før 1940"
		}, {
			"@language": "nn",
			"@value": "Historia til arktiske skuter bygd før 1940"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/person",
		"name": [{
			"@language": "en",
			"@value": "People"
		}, {
			"@language": "no",
			"@value": "Personer"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/people.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/people.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Browse employees at the institue"
		}, {
			"@language": "no",
			"@value": "Ansatte ved Norsk Polarinstitutt"
		}],
		"category": "public",
		"promote": true
	},

	{
		"link": "http://svalbardkartet.npolar.no",
		"name": [{
			"@language": "en",
			"@value": "Svalbard atlas"
		}, {
			"@language": "nb",
			"@value": "Svalbard-kartet"
		}, {
			"@language": "nn",
			"@value": "Svalbard-kartet"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/svalbardkartet-logo.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/svalbardkartet-logo.png"
		}],
		"screenshots": ["/assets/img/screenshots/svalbardkartet.png"],
		"description": [{
			"@language": "en",
			"@value": "Interactive thematic atlas over Svalbard"
		}, {
			"@language": "nb",
			"@value": "Interaktivt temaatlas over Svalbard"
		}, {
			"@language": "nn",
			"@value": "Interaktivt temaatlas over Svalbard"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "https://placenames.npolar.no/",
		"name": [{
			"@language": "en",
			"@value": "Placenames"
		}, {
			"@language": "nb",
			"@value": "Stedsnavn"
		}, {
			"@language": "nn",
			"@value": "Stadnamn"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/placename.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/placename.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Official place names in Norwegian polar regions"
		}, {
			"@language": "nb",
			"@value": "Offisielle stedsnavn i norske polarområder"
		}, {
			"@language": "nn",
			"@value": "Offisielle stadnamn i norske polarområde"
		}],
		"category": "public",
		"promote": true
	},

	{
		"link": "/indicator/timeseries",
		"name": [{
			"@language": "en",
			"@value": "Timeseries"
		}, {
			"@language": "no",
			"@value": "Tidsserier"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/timeseries.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/timeseries.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Long-term environmental monitoring"
		}, {
			"@language": "no",
			"@value": "Langsiktig miljøovervåking"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/course",
		"name": [{
			"@language": "en",
			"@value": "Course"
		}, {
			"@language": "no",
			"@value": "Kurs"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/courses.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/courses.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Courses available at the institute"
		}, {
			"@language": "no",
			"@value": "Kurs tilgjengelig ved instituttet"
		}],
		"category": "internal"
	}, {
		"link": "/inventory",
		"name": [{
			"@language": "en",
			"@value": "Inventory"
		}, {
			"@language": "no",
			"@value": "Aktivitet"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/inventory.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/inventory.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "no",
			"@value": "Tidligere aktivitet Antarktis"
		}, {
			"@language": "en",
			"@value": "Inventory of past activities Antarctica"
		}],
		"category": "internal",
		"promote": true
	}, {
		"link": "/station-booking",
		"name": [{
			"@language": "en",
			"@value": "Stations"
		}, {
			"@language": "no",
			"@value": "Stasjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/station-booking.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/station-booking.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "no",
			"@value": "Forskningsstasjoner Statistikk"
		}, {
			"@language": "en",
			"@value": "Research Stations Statistics"
		}],
		"category": "internal",
		"promote": true
	},

	{
		"link": "/marine/biology",
		"name": [{
			"@language": "en",
			"@value": "Marine Biology"
		}, {
			"@language": "no",
			"@value": "Marinbiologi"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/marine_biology.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/marine_biology.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Sample database for nutrients, lipids and plankton"
		}, {
			"@language": "no",
			"@value": "Database for næringsstoffer, lipider og plankton"
		}],
		"category": "disabled"
	}, {
		"link": "/user",
		"name": [{
			"@language": "en",
			"@value": "Users"
		}, {
			"@language": "nb",
			"@value": "Brukere"
		}, {
			"@language": "nn",
			"@value": "Brukarar"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/users.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/users.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "User administration"
		}, {
			"@language": "no",
			"@value": "Brukeradministrasjon"
		}],
		"category": "internal"
	}, {
		"link": "/publication",
		"name": [{
			"@language": "en",
			"@value": "Publications"
		}, {
			"@language": "no",
			"@value": "Publikasjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/publication.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/publication.png"
		}],
		"screenshots": ["/assets/img/screenshots/publication.png"],
		"description": [{
			"@language": "en",
			"@value": "Scientific articles and other publications by Norwegian Polar Institute staff"
		}, {
			"@language": "no",
			"@value": "Vitenskapelige artikler og andre publikasjoner som er produsert av ansatte ved Norsk Polarinstitutt"
		}],
		"category": "public",
		"promote": false
	}, {
		"link": "/project",
		"name": [{
			"@language": "en",
			"@value": "Projects"
		}, {
			"@language": "no",
			"@value": "Prosjekter"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/service.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/service.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "Project catalogue"
		}, {
			"@language": "no",
			"@value": "Prosjektkatalog"
		}],
		"category": "public"
	}, {
		"link": "/text",
		"name": [{
			"@language": "en",
			"@value": "Texts"
		}, {
			"@language": "nb",
			"@value": "Tekster"
		}, {
			"@language": "nn",
			"@value": "Tekstar"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/text.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/text.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "en",
			"@value": "i18n texts"
		}],
		"category": "internal"
	}, {
		"link": "/sighting",
		"name": [{
			"@language": "en",
			"@value": "MMS"
		}, {
			"@language": "no",
			"@value": "Observasjoner"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/sighting.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/sighting.png"
		}],
		"screenshots": [],
		"description": [{
			"@language": "no",
			"@value": "Observasjoner av marine pattedyr på Svalbard"
		}, {
			"@language": "en",
			"@value": "Svalbard Marine Mammal Sightings"
		}],
		"category": "public",
		"promote": true
	}, {
		"link": "/pbhims",
		"name": [{
		    "@language": "en",
		    "@value": "PBHIMS"
		}, {
		    "@language": "no",
		    "@value": "PBHIMS"
		}],
		"icons": [{
			"size": 96,
			"src": "/assets/img/app-icons/96/pbhims.png"
		}, {
			"size": 48,
			"src": "/assets/img/app-icons/48/pbhims.png"
		}],
		"screenshots": [],
		"description": [{
		    "@language": "en",
		    "@value": "Polar Bear/Human Information Management System"
		}, {
		    "@language": "no",
		    "@value": "Hendelsesregister for interaksjoner mellom isbjørn og mennesker"
		}],
                "category": "public",
                "promote": true
	}
]

},{}],207:[function(require,module,exports){
'use strict';

var npdcAppConfigFactory = function npdcAppConfigFactory(NpdcAutocompleteConfigFactory, NpdcSearchConfigFactory, NpdcApplications) {
  'ngInject';

  return {
    toolbarTitle: "",
    toolbarMenuGroups: [{
      name: "Applications",
      apps: NpdcApplications.filter(function (app) {
        return app.category === "public";
      })
    }],
    toolbarInternalApps: [{
      name: "Internal",
      apps: NpdcApplications.filter(function (app) {
        return app.category === "internal";
      })
    }],
    search: {
      local: new NpdcSearchConfigFactory(),
      global: new NpdcAutocompleteConfigFactory({
        showCollections: true,
        global: true,
        placeholder: "Search Norwegian Polar Data Centre"
      })
    },
    formula: {},
    i18n: {
      languages: ['en', 'nb', 'nn', 'no']
    }
  };
};
npdcAppConfigFactory.$inject = ["NpdcAutocompleteConfigFactory", "NpdcSearchConfigFactory", "NpdcApplications"];

module.exports = npdcAppConfigFactory;

},{}],208:[function(require,module,exports){
"use strict";

var Chronopic = require('chronopic.js/src/chronopic.js');
var angular = require('angular');
require('chronopic.js/dist/js/chronopic-i18n.min.js');

var cp = angular.module('chronopic', []);

cp.service('chronopicService', ["formulaFieldConfig", function (formulaFieldConfig) {

  var configs = formulaFieldConfig.getInstance();

  var defineOptions = function defineOptions(config) {
    configs.addConfig(config);
  };

  var getOptions = function getOptions(field) {
    return configs.getMatchingConfig(field);
  };

  return {
    defineOptions: defineOptions,
    getOptions: getOptions
  };
}]);

cp.directive('chronopic', ["$timeout", "chronopicService", function ($timeout, chronopicService) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, elem, attrs, model) {
      if (scope.field.readonly) {
        attrs.$set('readonly', true);
      }
      if (scope.field.disabled) {
        attrs.$set('disabled', true);
      }

      var tabContainer = document.body.querySelector(".formula .np-formula-tab");
      var options = chronopicService.getOptions(scope.field) || {};
      var _onChange = options.onChange,
          cp = void 0;

      delete options.onChange;

      var parseDate = function parseDate(date) {
        // Try parsing any pre-existing value as a date
        if (!(date instanceof Date)) {
          var newDate = new Date(Date.parse(date));
          return isNaN(newDate) ? null : newDate;
        }
        return null;
      };

      // CSS Overrides
      Object.keys(options.css || {}).forEach(function (key) {
        elem.css(key, options.css[key]);
      });

      // Inject Chronopic instance on element
      cp = new Chronopic(elem[0], Object.assign({
        className: 'chronopic.chronopic-ext-md',
        container: tabContainer,
        direction: 'auto',
        format: '{' + scope.field.format.replace('-', '') + '}',
        monthYearOnly: scope.field.format === "year-month",
        min: { year: 1400 },
        max: { year: 2200 },
        onChange: function onChange(elem, date) {
          $timeout(function () {
            var internalFormat = date.toISOString(); // ISO-8601

            switch (scope.field.format) {
              case "date":
                internalFormat = internalFormat.slice(0, 10); // yyyy-mm-dd
                break;

              case "year-month":
                internalFormat = internalFormat.slice(0, 7); // yyyy-mm
                break;
            }

            model.$viewValue = scope.field.value = internalFormat;

            if (typeof _onChange === "function") {
              _onChange(elem, date, scope);
            }
          });
        }
      }, options));

      scope.$on('npolar-lang', function (e, lang) {
        cp.locale = lang.lang;
      });

      if (scope.field.value) {
        var date = parseDate(scope.field.value);

        if (date) {
          $timeout(function () {
            cp.instances[0].date = date;
            cp.instances[0].update();
          });
        }
      }
    }
  };
}]);

},{"angular":"angular","chronopic.js/dist/js/chronopic-i18n.min.js":59,"chronopic.js/src/chronopic.js":60}],209:[function(require,module,exports){
module.exports = '<!DOCTYPE html>\n<md-dialog aria-label="{{ \'upload.title\' | t }}" class="filefunnel">\n  <md-dialog-content>\n    <div class="md-dialog-content">\n      <h2 class="md-title">{{ \'upload.title\' | t }}</h2>\n\n      <md-list>\n        <md-list-item class="md-3-line" ng-repeat="file in ff.files">\n          \n          <md-icon class="md-avatar">attachment</md-icon>\n          <div class="md-list-item-text">\n            <h3>{{file.reference.name}}</h3>\n            <md-progress-linear md-mode="{{ff.progressType}}" value="{{file.progress}}"></md-progress-linear>\n            <span class="{{file.elements.info.dom.className}}">{{file.elements.info.value}}</span>\n          </div>\n        </md-list-item>\n        \n        <md-list-item ng-show="askForScope && ff.files.length">\n          <p>{{ \'upload.restrict\' | t }}</p>\n          <md-checkbox class="md-secondary" ng-model="access.data"></md-checkbox>\n        </md-list-item>\n      </md-list>\n\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <div flex layout="row" layout-align="space-between center">\n      <md-button class="md-raised md-primary" ng-disabled="ff.status == FileFunnelStatus.UPLOADING"\n        ng-click="ff.browse()" >{{ \'upload.choose\' | t }}</md-button>\n\n      <md-button class="md-raised md-primary" ng-if="ff.status != FileFunnelStatus.UPLOADING"\n        ng-disabled="ff.status == FileFunnelStatus.NONE" ng-click="upload()">{{ \'upload.action\' | t }}</md-button>\n      <md-button class="md-raised md-primary" ng-if="ff.status == FileFunnelStatus.UPLOADING"\n        ng-click="abort();">{{ \'cancel\' | t }}</md-button>\n    </div>\n  </md-dialog-actions>\n</md-dialog>\n';
},{}],210:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var FileFunnel = require('filefunnel.js');
var angular = require('angular');
require('filefunnel.js/dist/js/filefunnel-i18n.min.js');

var ff = angular.module('filefunnel', ['ngMaterial', 'ngNpolar']);

ff.controller('FFUploadController', ["$scope", "$rootScope", "$mdDialog", "options", "NpolarApiSecurity", function ($scope, $rootScope, $mdDialog, options, NpolarApiSecurity) {
  'ngInject';

  var ff = new FileFunnel(null, options);
  $scope.ff = ff;

  if (Object.keys(options).includes('restricted')) {
    var restricted = false; // Open access is default
    $scope.askForScope = false; // No checkbox is default

    if (typeof options.restricted === 'function') {
      restricted = options.restricted();
      $scope.askForScope = true;
    } else if ([true, false].includes(options.restricted)) {
      restricted = options.restricted;
    }
    $scope.access = {
      data: restricted !== true
    };
    $scope.$watch('access.data', function (access) {
      if (access) {
        ff.server = ff.server.replace('/restricted/', '/');
      } else {
        ff.server = ff.server.replace(/\/$/, '') + '/restricted/';
      }
    });
  }

  if (/:id/.test(options.server)) {
    if (options.formula) {
      var model = options.formula.getModel();
      ff.server = ff.server.replace(':id', model.id || model._id);
    } else {
      throw "Server needs a document id to be able to upload files.";
    }
  }

  ff._elements.fileInput.on('change', function (event) {
    $rootScope.$broadcast('npdc-filefunnel-change', ff);
    $scope.$apply();
  });

  $scope.abort = function () {
    ff.abort();
    $mdDialog.hide();
  };

  $scope.upload = function () {
    ff.auth = NpolarApiSecurity.authorization();
    ff.upload();
    //$mdDialog.hide();
  };

  $scope.$on('npolar-lang', function (e, lang) {
    ff.locale = lang.lang;
  });

  // Success for each file
  ff.on('success', function (file) {

    $rootScope.$broadcast('npdc-filefunnel-upload-success', file);

    // Completed when all files are in
    if (ff.status === FileFunnel.status.COMPLETED) {
      $mdDialog.hide(ff.files);
      $rootScope.$broadcast('npdc-filefunnel-upload-completed', ff.files.filter(function (f, k) {
        return typeof k === 'number';
      }));
    }
  }).on('error', function (file) {
    ff.progressType = 'determinate';
    $scope.$apply();
  }).on('progress', function (file) {
    ff.progressType = 'determinate';
  }).on('start', function (file) {
    ff.progressType = 'indeterminate';
  });

  $scope.FileFunnelStatus = FileFunnel.status;
  ff.progressType = 'determinate';
}]);

ff.service('fileFunnelService', ["$mdDialog", "formulaFieldConfig", "NpolarMessage", function ($mdDialog, formulaFieldConfig, NpolarMessage) {
  var DEFAULTS = {
    accept: "*/*",
    chunked: false,
    multiple: false,
    restricted: false
  };

  var configs = formulaFieldConfig.getInstance();
  var fileUploader = function fileUploader(config, formula) {
    var options = Object.assign({}, DEFAULTS, config, { formula: formula });
    if (!options.server) {
      throw "You must set a server!";
    }
    if (options.fromHashi) {
      options.fileToValueMapper = options.fromHashi;
    }
    if (!options.fileToValueMapper) {
      options.fileToValueMapper = function (file) {
        return file;
      };
    }
    if (!options.valueToFileMapper) {
      options.valueToFileMapper = function (value) {
        return value;
      };
    }

    configs.addConfig(options);
    formula.addTemplate({
      match: options.match,
      template: '<npdc:formula-file></npdc:formula-file>'
    });
  };

  var getOptions = function getOptions(field) {
    return configs.getMatchingConfig(field);
  };

  var handleOptions = function handleOptions(options) {
    if (options.restricted) {
      var restricted = options.restricted;
      if (typeof options.restricted === "function") {
        restricted = options.restricted();
      }
      options.server += restricted ? '/restricted' : '';
    }
  };

  var showUpload = function showUpload(ev, field, options) {
    handleOptions(options);
    return $mdDialog.show({
      clickOutsideToClose: true,
      controller: 'FFUploadController',
      locals: {
        options: options
      },
      targetEvent: ev,
      template: require('./filefunnel.html')
    }).then(function (files) {
      if (!files) {
        return;
      }

      var responses = JSON.parse(files.xhr.response);
      responses.forEach(function (response) {

        // @TODO Handle out of sync metadata in backend
        if (response.status >= 200 && response.status < 300) {
          var value = options.fileToValueMapper(response);
          console.log('fromHashi', value);
          if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
            throw "fileToValueMapper should return object with keys matching the fields you want to set file data to";
          }
          var item = field.itemAdd( /* preventValidation */true);
          var valueModel = {};
          valueModel[item.id] = value;
          item.valueFromModel(valueModel);
          field.itemChange();
        } else {
          console.log('Hashi error:', response);
        }
      });

      return responses;
    });
  };

  return {
    fileUploader: fileUploader,
    getOptions: getOptions,
    showUpload: showUpload,
    status: FileFunnel.status
  };
}]);

},{"./filefunnel.html":209,"angular":"angular","filefunnel.js":64,"filefunnel.js/dist/js/filefunnel-i18n.min.js":63}],211:[function(require,module,exports){
'use strict'; module.exports = angular.module("templates", []).run(["$templateCache", function($templateCache) {$templateCache.put("npdc-common/src/wrappers/filefunnel.html","<!DOCTYPE html>\n<md-dialog aria-label=\"{{ \'upload.title\' | t }}\" class=\"filefunnel\">\n  <md-dialog-content>\n    <div class=\"md-dialog-content\">\n      <h2 class=\"md-title\">{{ \'upload.title\' | t }}</h2>\n\n      <md-list>\n        <md-list-item class=\"md-3-line\" ng-repeat=\"file in ff.files\">\n          \n          <md-icon class=\"md-avatar\">attachment</md-icon>\n          <div class=\"md-list-item-text\">\n            <h3>{{file.reference.name}}</h3>\n            <md-progress-linear md-mode=\"{{ff.progressType}}\" value=\"{{file.progress}}\"></md-progress-linear>\n            <span class=\"{{file.elements.info.dom.className}}\">{{file.elements.info.value}}</span>\n          </div>\n        </md-list-item>\n        \n        <md-list-item ng-show=\"askForScope && ff.files.length\">\n          <p>{{ \'upload.restrict\' | t }}</p>\n          <md-checkbox class=\"md-secondary\" ng-model=\"access.data\"></md-checkbox>\n        </md-list-item>\n      </md-list>\n\n    </div>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <div flex layout=\"row\" layout-align=\"space-between center\">\n      <md-button class=\"md-raised md-primary\" ng-disabled=\"ff.status == FileFunnelStatus.UPLOADING\"\n        ng-click=\"ff.browse()\" >{{ \'upload.choose\' | t }}</md-button>\n\n      <md-button class=\"md-raised md-primary\" ng-if=\"ff.status != FileFunnelStatus.UPLOADING\"\n        ng-disabled=\"ff.status == FileFunnelStatus.NONE\" ng-click=\"upload()\">{{ \'upload.action\' | t }}</md-button>\n      <md-button class=\"md-raised md-primary\" ng-if=\"ff.status == FileFunnelStatus.UPLOADING\"\n        ng-click=\"abort();\">{{ \'cancel\' | t }}</md-button>\n    </div>\n  </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/auth/_user.html","<div class=\"login-logout\">\n  <div ng-show=\"security.isAuthenticated()\" ng-init=\"user = security.getUser()\">\n    \n    <button ng-click=\"logout()\">Logout</button> <b>{{ user.name }}</b> (<a title=\"View profile for user {{user.username}}\" ng-href=\"/user/{{user.username}}\">{{ user.email }} </a>)\n    \n    <p>Login session expires {{ 1000*user.exp | date:\'HH:mm\' }}</p>\n    \n    <!--<section>\n    <h2>Recent edits</h2>\n    <dl ng-repeat=\"edit in edits\">\n      <dt>{{ edit.request.time }}</dt>\n      <dd><a href=\"{{ edit.response.header.Location }}\">{{ edit.response.header.Location }}</a></dd>\n    </dl>\n    </section>-->\n    \n    <section>\n      <h2>Permissions</h2>\n      <dl ng-repeat=\"system in user.systems\">\n        <dt>{{ system.uri }}</dt>\n        <dd>{{ system.rights }}</dd>\n      </dl>\n    </section>\n  </div>\n  \n  <div ng-show=\"security.notAuthenticated()\">\n    <h1>Login</h1>\n    <form role=\"form\">\n      <section ng-show=\"true\" ng-init=\"loginClicked = false;\">\n      <div>\n        <label for=\"username\">Username</label>\n        <input type=\"text\" ng-model=\"email\" id=\"email\" placeholder=\"Username (email)\">\n      </div>\n      <div>\n        <label for=\"password\">Password</label>\n        <input type=\"password\" id=\"password\" ng-model=\"password\" placeholder=\"Password\">\n      </div>\n      <button id=\"login2\" type=\"submit\" ng-click=\"login(email,password)\">Login</button> \n      </section>\n      <a ng-href=\"/user/reset?username={{user.username}}\">Forgot password?</a> <a href=\"/user/register\">Sign up</a></section>\n    </form>\n  </div>\n</div>");
$templateCache.put("npdc-common/src/components/app/app.html","<!DOCTYPE html>\n<npdc:toolbar options=\"options\"></npdc:toolbar>\n<div ng-if=\"warning\" class=\"np-environment-warning\">!! Environment: Production !!</div>\n\n<!-- Content wrapper -->\n<md-content class=\"np-content-wrapper\">\n  <!-- Subheader bar -->\n  <div class=\"np-sub-toolbar\"></div>\n\n  <div class=\"np-content-card\">\n\n    <main class=\"np-content md-whiteframe-12dp\" layout=\"column\">\n      <npdc:warnings></npdc:warnings>\n      <!--<div hide-gt-xs><npdc:breadcrumbs></npdc:breadcrumbs></div>-->\n      <div ng-view autoscroll=\"true\"></div>\n    </main>\n  </div>\n</md-content>\n\n<npdc:footer></npdc:footer>\n");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/i18n/lang-menu.html","  <md-menu>\n      <md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\">\n        <md-icon md-menu-origin>language</md-icon>\n        <md-tooltip>{{ lang.getNativeName(lang.getLang()) }}</md-tooltip>\n      </md-button>\n      <md-menu-content width=\"6\">\n         <div>\n          <md-icon>language</md-icon>\n          \n          {{ \'npdc.menu.Select_language\' | t }} ({{ \'npdc.currently\' | t }} {{ lang.getNativeName(lang.getLang()) }})\n         </div>\n         <div>\n          \n         \n         </div>\n        <md-menu-item ng-repeat=\"subtag in lang.getLanguages()\">\n          <md-button ng-click=\"lang.setLang(subtag, lang.getLang())\">{{ lang.getNativeName(subtag) }}</md-button>\n        </md-menu-item>\n\n      </md-menu-content>\n    </md-menu>");
$templateCache.put("npdc-common/src/components/bottom/npdc-bottom.html","\n<footer layout-padding>\n  <md-content>\n    The <a href=\"https://data.npolar.no\"><b>Norwegian Polar Data Centre</b> </a> is operated by the <a href=\"http://npolar.no/en\">Norwegian Polar Institue</a>\n  </md-content>\n</footer>");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/message/_message.html","<div ng-if=\"info\" class=\"info\">[info]{{ info | json }}</div>\n<div ng-if=\"error\" class=\"error\">[error] {{ error | json }}</div>");
$templateCache.put("npdc-common/src/components/bottom-sheet/bottomSheet.html","<!DOCTYPE html>\n<div>\n  <md-button class=\"md-icon-button np-bottom-sheet-toggle\" ng-click=\"showBottomSheet($event)\">\n    <md-icon>menu</md-icon>\n    <md-tooltip>{{ \'edit.actions\' | t }}</md-tooltip>\n  </md-button>\n  <div ng-if=\"options.alwaysShow\" ng-include=\"\'bottom-sheet-template.tmpl\'\"></div>\n</div>\n\n<script type=\"text/ng-template\" id=\"bottom-sheet-template.tmpl\">\n  <md-bottom-sheet class=\"md-grid\" layout=\"column\" ng-cloak>\n    <md-list flex layout=\"row\" layout-align=\"center center\">\n      <md-list-item ng-repeat=\"item in options.items\">\n        <md-button class=\"md-grid-item-content {{item.classes}}\" ng-click=\"listItemClick($index)\">\n          <md-icon>{{item.icon}}</md-icon>\n          <div class=\"md-grid-text\"> {{ item.name }} </div>\n        </md-button>\n      </md-list-item>\n    </md-list>\n  </md-bottom-sheet>\n</script>\n");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/message/_message_toast.html","<md-toast class=\"{{msgType}}\">\n  <span flex> <b>{{explanation}}</b></span>\n  <md-button class=\"md-action\" ng-click=\"closeToast();\">OK</md-button>\n</md-toast>\n");
$templateCache.put("npdc-common/src/components/breadcrumbs/breadcrumbs.html","<!DOCTYPE html>\n<span class=\"npdc-crumbs-container\">\n	<span ng-repeat=\"crumb in breadcrumbs.breadcrumbs\">\n    <span ng-if=\"!$last\">\n      <a ng-href=\"{{crumb.href}}\" title=\"{{ (crumb.title || crumb.text) | t }}\">{{ crumb.text | t }}</a>\n      <md-icon>chevron_right</md-icon>\n    </span>\n    <span ng-if=\"$last\">{{ crumb.text  | t }}</span>\n  </span>\n</span>");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/template/_delete.html","<div class=\"npolar-confirm-delete\">\n  <h3>Really DELETE?</h3>\n\n  <button type=\"button\" ng-click=\"deleteClicked=false && back()\" class=\"btn btn-default\">no</button>\n  <button type=\"button\" ng-click=\"delete()\" class=\"btn btn-danger\">yes</button>\n</div>\n");
$templateCache.put("npdc-common/src/components/button/create-button.html","<!DOCTYPE html>\n<md-button class=\"md-fab\" ng-if=\"security.isAuthorized(\'create\', resource.path)\" ng-href=\"{{ resource.newHref() }}\">\n  <md-tooltip md-direction=\"top\">New</md-tooltip>\n  <md-icon>add</md-icon>\n</md-button>\n");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/template/_error.html","<h2 ng-if=\"error\" class=\"alert alert-danger\" role=\"alert\"><strong>{{error.status}} ERROR {{error.statusText}}</strong> {{error.data}}</h2>");
$templateCache.put("npdc-common/src/components/button/delete-button.html","<!DOCTYPE html>\n<md-button class=\"md-raised md-warn\"\n    ng-if=\"security.isAuthorized(\'delete\', resource.path) && document._rev\"\n    ng-click=\"confirmDelete()\">\n    <md-icon>delete</md-icon> Delete</md-button>\n");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/template/_foot.html","");
$templateCache.put("npdc-common/src/components/button/edit-button.html","<!DOCTYPE html>\n<md-button class=\"md-fab\" ng-if=\"security.isAuthorized(\'update\', resource.path)\" ng-href=\"{{ resource.editHref(document.id) }}\">\n  <md-tooltip md-direction=\"top\">Edit</md-tooltip>\n  <md-icon>edit</md-icon>\n</md-button>\n");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/template/_head.html","<div ng-if=\"error\" ng-include=\"\'angular-npolar/src/ui/template/_error.html\'\"></div>\n<div ng-if=\"info\" ng-include=\"\'angular-npolar/src/ui/template/_info.html\'\"></div>\n");
$templateCache.put("npdc-common/src/components/button/save-button.html","<!DOCTYPE html>\n<md-button ng-if=\"security.isAuthorized(\'update\', resource.path)\"\n    ng-click=\"save()\" class=\"md-fab\">\n  <md-tooltip md-direction=\"top\">Save</md-tooltip>\n  <md-icon>save</md-icon>\n</md-button>\n");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/template/_info.html","<h2 ng-if=\"info\" class=\"alert alert-success\"><strong>{{info.header}}</strong> {{info.message }}</h2>");
$templateCache.put("npdc-common/src/components/contributions/contributions.html","<span ng-if=\"ctrl.isAuthenticated() && ctrl.getFacet(\'created_by\')\">\n  <md-content>\n    <md-menu>\n      <md-button ng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\" aria-label=\"Open contributors menu\">\n        <md-icon>person</md-icon>\n        <md-tooltip>{{ \'Contributors\' | t }}</md-tooltip>\n      </md-button>\n\n      {{ ctrl.getUser().email | name }}\n\n      <md-menu-content width=\"6\">\n        <!-- @todo searchable autocomplete list? -->\n        <md-subheader>{{ \'Created by\' | t }}</md-subheader>\n        <md-menu-item ng-repeat=\"f in ctrl.getFacet(\'created_by\', facets)\">\n          <md-button rel=\"nofollow\" ng-href=\"?filter-created_by={{f.term}}\">{{ f.term | name }} [{{f.term}}] ({{f.count}})</md-button>\n        </md-menu-item>\n      </md-menu-content>\n    </md-menu>\n\n    <npdc:facet-link value=\"{{ ctrl.getUser().email }}\" field=\"created_by\" params=\"{ sort: \'-created\'}\" text=\"is&#160;creator\" count=\"{{ctrl.count(\'created_by\', ctrl.getUser().email) }}\"></npdc:facet-link>\n    <npdc:facet-link value=\"{{ ctrl.getUser().email }}\" field=\"updated_by\" params=\"{ sort: \'-updated\'}\" text=\"is&#160;last&#160;editor\" count=\"{{ctrl.count(\'updated_by\', ctrl.getUser().email) }}\"></npdc:facet-link>\n    <npdc:facet-link ng-if=\"ctrl.getFacet(\'people.email\')\" value=\"{{ ctrl.getUser().email }}\" field=\"people.email\" text=\"is&#160;contributor\" count=\"{{ctrl.count(\'people.email\', ctrl.getUser().email) }}\"></npdc:facet-link>\n  </md-content>\n\n</span>");
$templateCache.put("npdc-common/src/angular-npolar/src/ui/template/_search.html","<div>\n  <span ng-if=\"!feed.entries\">Fetching data from {{base}}</span>\n  <span ng-if=\"feed.opensearch.totalResults > 0\">{{feed.opensearch.totalResults}} results from {{ base }}</span>\n  <span ng-if=\"feed.opensearch.totalResults == 0\">No results</span>\n</div>\n\n<h3><span ng-if=\"filters.length\">Filters: {{filters | json}}</span><span ng-if=\"filters.length\"><a ng-href=\"/vessel\">Remove filters</a></span></h3>\n\n<h2><a ng-if=\"user.name\" href=\"__new/edit\"><button type=\"button\" class=\"pure-button\">New</button></a></h2>\n\n<p>Filter: <input ng-model=\"entryfilter\"></p>\n\n<div ng-repeat=\"e in feed.entries | filter:entryfilter\">\n  <h4 class=\"\"><a ng-href=\"{{e.id}}\">{{ e.title || e.name || e.id }}</a> {{e.updated }}</h4>\n</div>\n");
$templateCache.put("npdc-common/src/components/footer/footer.html","<!DOCTYPE html>\n<footer layout=\"row\" layout-align=\"center start\" layout-wrap>\n  <div flex=\"33\" flex-sm=\"50\" flex-order-sm=\"2\">\n    <div class=\"np-center-box\">\n      <ol class=\"address\"><md-tooltip>NPDC is a permanent facility operated by the {{ \'npolar.no\' |t }}</md-tooltip>\n        <li><strong><a href=\"https://data.npolar.no\">Norwegian Polar Data Centre</a></strong></li>\n        <li><a href=\"http://npolar.no\">{{ \'npolar.no\' |t }}</a></li>\n      </ol>\n\n    </div>\n  </div>\n  <div flex=\"33\" flex-sm=\"50\" flex-order-sm=\"1\">\n    <md-tooltip>NPDC is registered with re3data.org</md-tooltip>\n    <div class=\"np-center-box\">\n      <a href=\"https://doi.org/10.17616/R3B94H\"><img src=\"/assets/img/re3datalogo.png\" width=\"142px\" style=\"max-width:100%\"/></a>\n    </div>\n  </div>\n  <div flex=\"33\" flex-sm=\"100\" flex-order-sm=\"3\">\n    <div class=\"np-center-box\">\n      <md-button class=\"md-icon-button\" href=\"http://github.com/npolar/npdc-common\">\n        <i class=\"github-icon\"></i>\n        <md-tooltip>Open source @ Github</md-tooltip>\n      </md-button>\n    </div>\n  </div>\n\n  <a href=\"\" id=\"scroll-up\" onclick=\"window.scrollTo(0, 0); window.location.hash = \'\';\" hide-sm hide-xs>\n    <md-icon>keyboard_arrow_up</md-icon>\n    <md-tooltip md-direction=\"left\">Scroll to top</md-tooltip>\n  </a>\n</footer>\n<npolar-message></npolar-message>\n\n<script>\n  // Google Analytics\n  // https://developers.google.com/analytics/devguides/collection/analyticsjs/\n  window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;\n  ga(\'create\', \'UA-770196-26\', \'auto\');\n  ga(\'send\', \'pageview\');\n</script>\n<script async src=\'//www.google-analytics.com/analytics.js\'></script>\n<script>\n  //https://support.google.com/analytics/answer/1136920?hl=en\n  /**\n  * Function that tracks a click on an outbound link in Google Analytics.\n  * For this to work the outbound link needs a onclick=\"trackOutboundLink(uri); return false;\" like:\n  * [a href=\"http://api.npolar.no/oceanography/?q=&amp;format=json\" onclick=\"trackOutboundLink(\'http://api.npolar.no/oceanography/?q=&amp;format=json\'); return false;\" target=\"_blank\"]Oceanography API[/a]\n  */\n  var trackOutboundLink = function(url) {\n     ga(\'send\', \'event\', \'outbound\', \'click\', url, {\'hitCallback\':\n       function () {\n       document.location = url;\n       }\n     });\n  };\n</script>\n");
$templateCache.put("npdc-common/src/components/formula/edit.html","<!DOCTYPE html>\n<h1 class=\"np-heading md-display-1\">{{ \'Editing\' | t }} <a ng-href=\"{{ id === \'__new\' ? resource.uiBase : href(id) }}\">{{ title }}</a>\n  <a ng-if=\"help && help.uri\" ng-href=\"{{ help.uri }}\" target=\"_blank\">\n    <md-button class=\"md-icon-button\">\n    <md-icon md-menu-origin>help</md-icon>\n    <md-tooltip>{{ \'help-with-editing\' | t }}</md-tooltip>\n  </md-button></a>\n</h1>\n\n<npdc:bottom-sheet options=\"bottomSheetOptions\" ng-show=\"document._rev\"></npdc:bottom-sheet>\n<div ng-class=\"{ \'np-bottom-sheet-static\': bottomSheetOptions.alwaysShow }\">\n  <formula options=\"formula._cfg\"></formula>\n  <npdc:loader ng-if=\"!formula._cfg.form.ready\"></npdc:loader>\n</div>\n<npdc:save-button class=\"np-primary-control\" ng-show=\"formula._cfg.form.ready\"></npdc:save-button>");
$templateCache.put("npdc-common/src/components/loader/loader.html","<!DOCTYPE html>\n<div ng-if=\"!error()\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\" layout-padding>\n  <md-progress-circular md-mode=\"indeterminate\" md-diameter=\"96\"></md-progress-circular>\n</div>\n<div ng-if=\"error()\" layout-padding>{{error()}}</div>\n");
$templateCache.put("npdc-common/src/components/metadata/metadata.html","<md-card>\n  <md-card-header>\n    <md-card-avatar>\n      <md-icon><img src=\"/assets/components/metadata/json-ld-data-48.png\"></md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <span class=\"md-headline\">{{ (headline || \'Machine-readable data\') | t }}</span>\n      <span class=\"md-subhead\" title=\"URI\">{{ uri }}</span>\n      </span>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n    <p ng-if=\"formats\">{{ (formats.length > 1) ? (\'Formats\'|t) : (\'Format\'|t) }}:\n      <span ng-repeat=\"link in formats\">\n        <a ng-href=\"{{link.href}}\" title=\"{{link.type}}\">{{ link.title || link.href }}</a> <span ng-if=\"!$last\">|</span>\n      </span>\n    </p>\n    <p ng-if=\"license\">Metadata license: <a ng-href=\"{{ license }}\">{{ license | t}}</a></p>\n    <p ng-if=\"schema\">Metadata schema: <a ng-href=\"{{ schema }}\">{{ schema | t }}</a></p>\n    <p ng-if=\"byline\" marked=\"byline\"></p>\n  </md-card-content>\n</md-card>\n\n<md-card ng-if=\"document\">\n  <md-card-header>\n    <md-card-avatar>\n      <md-icon>history</md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <span class=\"md-headline\">{{ (headline || \'Edit history\') | t }}</span>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n\n    <p>Metadata was created by {{ document.created_by | name  }}<span ng-if=\"editors().length > 0\">, and edited by </span><span ng-repeat=\"editor in editors()\"><span ng-if=\"!$first\">, <span ng-if=\"$last\">and </span></span>{{ editor }}</span>. Last update by {{ document.updated_by | name  }}.</p>\n\n    <!-- <md-menu>\n      <md-button ng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\" aria-label=\"Open sample menu\">\n       <md-icon>track_changes</md-icon>\n       <md-tooltip>Time machine</md-tooltip>\n     </md-button>\n\n      <md-menu-content width=\"6\">\n        <md-menu-item ng-repeat=\"edit in edits\" ng-init=\"text = edit.when +\' \'+ (edit.user.name || edit.user.id|name) +\' [revision \'+ (edit.revision || \'?\') +\']\'\">\n          <md-button ng-if=\"rev == edit.rev || edit.revision == 1\" ng-disabled=\"true\">{{text}}</md-button>\n          <md-button ng-if=\"rev != edit.rev && edit.revision > 1\" rel=\"nofollow\" ng-href=\"{{ edit.href }}\">{{text}}</md-button>\n        </md-menu-item>\n      </md-menu-content>\n     </md-menu> -->\n    <!--@todo WARN if not newest @todo make prettier-->\n    <!-- @todo Available/Published DOI created) time -->\n\n    <span>\n      <md-tooltip>{{ document.created.split(\'T\')[1] }}</md-tooltip>\n      {{\'Created\' | t}} {{ document.created | isodate }}\n    </span>\n    <span>\n      <md-tooltip>{{document.updated.split(\'T\')[1]}} [revision: {{document._rev.split(\'-\')[0] }}]</md-tooltip>\n      {{\'Updated\' | t}} {{ document.updated | isodate }}\n    </span>\n\n  </md-card-content>\n</md-card>\n");
$templateCache.put("npdc-common/src/components/tabs/tabs.html","<!DOCTYPE html>\n<nav ng-if=\"::tabs.length > 1\" class=\"np-tabs-nav\" layout=\"row\">\n  <a class=\"np-nav-scroll\" ng-click=\"back();\"><md-icon>navigate_before</md-icon></a>\n  <md-virtual-repeat-container md-orient-horizontal flex>\n    <a md-virtual-repeat=\"tab in ::tabs\" flex href=\"\" md-ink-ripple class=\"np-nav-item\" ng-class=\"{ active: tab.active, error: tab.valid === false}\" ng-click=\"go($event, tab)\">{{ tab.title }}</a>\n  </md-virtual-repeat-container>\n  <a class=\"np-nav-scroll\" ng-click=\"next();\"><md-icon>navigate_next</md-icon></a>\n</nav>\n");
$templateCache.put("npdc-common/src/components/toolbar/toolbar.html","<!DOCTYPE html>\n<md-toolbar class=\"np-toolbar\">\n  <div class=\"md-toolbar-tools np-toolbar-content\">\n    \n    <a href=\" {{ uiBase() || \'.\'}}\" class=\"np-app-title\">\n      <strong>{{ appTitle() }}</strong>\n    </a>\n\n    <span class=\"flex\"><!-- This span is used to push the other content to the right --></span>\n\n    <a href=\"/\" class=\"np-toolbar-title\" hide>\n      <a href=\"/\" class=\"np-toolbar-logo\" hide-xs>\n        <img hide-xs src=\"/assets/img/NPI-logo-hvit-no.png\" alt=\"{{siteTitle()}} {{ \'home\' | t }}\" title=\"{{siteTitle()}}\" />\n      </a>\n      <!--<span><!--{{ siteTitle() }}--><!--<a href=\"/\" class=\"np-toolbar-logo\"><abbr title=\"{{ \'NPDC\'|t }}\">NPDC</abbr></a></span>-->\n    </a>\n    \n    <span class=\"flex\"><!-- This span is used to push the other content to the right --></span>\n    \n     <md-menu class=\"np-app-menu\">\n      \n      <md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n        <md-icon md-menu-origin>apps</md-icon>\n        <md-tooltip>{{ \'npdc.menu.quicknav\' | t }}</md-tooltip>\n      </md-button>\n      \n      <md-menu-content width=\"6\" class=\"np-app-menu-content\">\n    \n        <!-- Apps -->    \n        <div ng-repeat=\"group in options.toolbarMenuGroups\">\n          <md-subheader>{{group.name}}</md-subheader>\n          <md-grid-list md-cols=\"3\" md-row-height=\"80px\" md-gutter=\"10px\">\n            <md-grid-tile ng-repeat=\"app in group.apps\">\n              <a ng-href=\"{{app.link}}\" class=\"np-app-icon\">\n                <img ng-src=\"{{icon48(app)}}\"/>\n                <div>{{ app.link | t }}</div>\n              </a>\n            </md-grid-tile>\n          </md-grid-list>\n          <md-divider></md-divider>\n        </div>\n\n        <!-- Apps for logged-in users -->\n        \n        \n        <div ng-show=\"security.isAuthenticated()\">\n          <div ng-repeat=\"group in options.toolbarInternalApps\">\n            <md-subheader>{{group.name}}</md-subheader>\n            <md-grid-list md-cols=\"3\" md-row-height=\"80px\" md-gutter=\"10px\">\n              <md-grid-tile ng-repeat=\"app in group.apps\">\n                <a ng-href=\"{{app.link}}\" class=\"np-app-icon\">\n                  <img ng-src=\"{{icon48(app)}}\"/>\n                  <div>{{ app.link | t }}</div>\n                </a>\n              </md-grid-tile>\n            </md-grid-list>\n            <md-divider></md-divider>\n          </div>\n        </div>\n              \n      </md-menu-content>\n    </md-menu>\n    \n    <!-- Login -->\n    <npdc:user-menu></npdc:user-menu>\n    \n\n    <npdc:expand-search options=\"options.search.global\"></npdc:expand-search>\n  \n  </div>\n</md-toolbar>");
$templateCache.put("npdc-common/src/components/user-menu/userMenu.html","<!DOCTYPE html>\n<md-menu ng-if=\"!security.isAuthenticated()\" class=\"np-user-menu\">\n  <md-button aria-label=\"Open user\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n    <md-icon md-menu-origin>person</md-icon>\n    <md-tooltip>{{ \'npdc.menu.user\' | t }}</md-tooltip>\n  </md-button>\n  <md-menu-content width=\"6\">\n\n    <form class=\"np-login np-padding\" ng-submit=\"login(email,password)\">\n      <div layout=\"column\">\n        <md-input-container>\n          <label for=\"username\" class=\"md-no-float\">{{ \'user.username\' | t }}</label>\n          <input type=\"text\" ng-model=\"email\" id=\"username\" placeholder=\"Enter your email address\">\n        </md-input-container>\n        <md-input-container ng-show=\"true\">\n          <label for=\"password\" class=\"md-no-float\">{{ \'user.password\' | t }}</label>\n          <input type=\"password\" id=\"password\" ng-trim=\"true\" ng-model=\"password\" placeholder=\"Enter password (or 1-time code)\">\n        </md-input-container>\n      </div>\n      <div layout=\"row\" layout-align=\"space-between center\">\n        <md-button ng-disabled=\"!email || password\" type=\"button\" ng-click=\"gouncer.onetime(email)\" class=\"md-raised md-primary\">Email code</md-button>\n        <md-button ng-disabled=\"!email || !password\" type=\"submit\" class=\"md-raised md-primary\">{{ \'user.login\' | t }}</md-button>\n      </div>\n    </form>\n\n    <md-divider></md-divider>\n    <md-menu-item>\n      <md-menu>\n        <md-button ng-click=\"$mdMenu.open($event)\">\n          <md-icon>language</md-icon>\n          {{ lang.getNativeName(lang.getLang()) }}\n        </md-button>\n        <md-menu-content width=\"6\">\n          <md-menu-item ng-repeat=\"subtag in lang.getLanguages()\">\n            <md-button ng-disabled=\"subtag == lang.getLang()\" ng-click=\"lang.setLang(subtag, lang.getLang())\">{{ lang.getNativeName(subtag) }}<span ng-show=\"subtag==lang.getLang()\"> ({{ \'npdc.current_language\' | t }})</span></md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </md-menu-item>\n  \n  \n  \n  </md-menu-content>\n</md-menu>\n\n<md-menu ng-if=\"security.isAuthenticated()\" class=\"np-user-menu\">\n  <md-button aria-label=\"Open user\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n    <md-icon md-menu-origin>account_box</md-icon>\n    <md-tooltip>{{ security.getUser().name }}</md-tooltip>\n  </md-button>\n  <md-menu-content width=\"6\">\n\n    <md-menu-item>\n      <md-button ng-href=\"/user/{{security.getUser().email }}\" title=\"View profile for {{ security.getUser().name }}\">\n        <md-icon md-menu-align-target>face</md-icon>\n        {{ security.getUser().name }}\n      </md-button>\n    </md-menu-item>\n\n    <md-divider></md-divider>\n    <md-menu-item>\n      <md-button ng-click=\"logout()\">\n        <span>{{ \'user.logout\' | t }}</span>\n      </md-button>\n    </md-menu-item>\n    \n    <md-divider></md-divider>\n    <md-menu-item>\n      <md-menu>\n        <md-button ng-click=\"$mdMenu.open($event)\">\n          <md-icon>language</md-icon>\n          {{ lang.getNativeName(lang.getLang()) }}\n        </md-button>\n        <md-menu-content width=\"6\">\n          <md-menu-item ng-repeat=\"subtag in lang.getLanguages()\">\n            <md-button ng-disabled=\"subtag == lang.getLang()\" ng-click=\"lang.setLang(subtag, lang.getLang())\">{{ lang.getNativeName(subtag) }}<span ng-show=\"subtag==lang.getLang()\"> ({{ \'npdc.current_language\' | t }})</span></md-button>\n          </md-menu-item>\n        </md-menu-content>\n      </md-menu>\n    </md-menu-item>\n    \n\n  </md-menu-content>\n</md-menu>\n\n\n\n");
$templateCache.put("npdc-common/src/components/warnings/warnings.html","<md-card ng-if=\"warnings().length > 0\">\n  <md-card-header>\n  <md-card-avatar>\n    <md-icon>{{ icon }}</md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class=\"md-headline\">{{ headline | t }}</span>\n    <span class=\"md-subhead\">{{ subhead | t }}</span>\n  </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n    <ul>\n      <li ng-repeat=\"warn in warnings()\">\n        <span marked=\"warn\"></span>\n      </li>\n    </ul>\n  </md-card-content>\n</md-card>\n<md-card ng-if=\"notices().length > 0 && warnings().length === 0\">\n  <md-card-header>\n  <md-card-avatar>\n    <md-icon>info</md-icon>\n  </md-card-avatar>\n  <md-card-header-text>\n    <span class=\"md-headline\">{{ notices_headline }} </span>\n    <span class=\"md-subhead\">{{ notices_subhead}}<span ng-if=\"document.released\">Data release: {{ document.released.split(\'T\')[0] }}</span></span>\n  </md-card-header-text>\n  </md-card-header>\n  <md-card-content>\n    <ul>\n      <li ng-repeat=\"info in notices()\">\n        {{ info | t }}\n      </li>\n    </ul>      \n  </md-card-content>\n</md-card>");
$templateCache.put("npdc-common/src/components/document/authors/authorstemplate.html","<!DOCTYPE html>\n<section ng-controller=\"NpdcAuthorsController as ctrl\">\n  <md-menu>\n\n    <md-button class=\"md-fab md-primary md-hue-2\" aria-label=\"Open people interactions menu\" ng-click=\"$mdMenu.open($event)\">\n       <md-icon md-menu-origin>{{ctrl.icon()}}</md-icon>\n       <md-tooltip md-direction=\"top\">{{ authors.length }} {{ (authors.length > 1) ? (\'authors\'|t) : (\'author\'|t) }}\n        <span ng-if=\"ctrl.contributors.length > 0\">{{ contributors.length}}</span>\n       </md-tooltip>\n    </md-button>\n\n    <md-menu-content width=\"6\">\n\n        <md-menu-item ng-if=\"ctrl.contributors.length > 0\">\n          <md-button ng-click=\"ctrl.flip(\'contributor\')\">\n            Show {{ ctrl.show(\'contributor\') ? \'only authors\' : \'contributors\' }}\n          </md-button>\n        </md-menu-item>\n\n        <md-menu-divider ng-if=\"ctrl.contributors.length > 0\"></md-menu-divider>\n\n        <md-menu-item>\n          <md-button md-autofocus ng-click=\"ctrl.flip(\'affiliations\')\">\n            Show {{ ctrl.show(\'affiliations\') ? \'names\' : \'affiliations\' }}\n          </md-button>\n        </md-menu-item>\n\n    </md-menu-content>\n  </md-menu>\n\n  <span ng-show=\"true\" class=\"np-authors\">\n    <span ng-repeat=\"p in ctrl.authors\" class=\"author\" ng-click=\"ctrl.gotoPerson(p)\">\n      <span>{{ p.name }}<md-tooltip md-direction=\"top\" md-delay=\"250\">{{ p.roles }}</md-tooltip></span><a ng-if=\"p.email && isContact(p)\" ng-href=\"mailto:{{p.email}}\"><md-icon>email</md-icon><md-tooltip md-direction=\"bottom\" md-delay=\"250\">{{ p.email }}</md-tooltip></a><span class=\"md-caption\" ng-show=\"ctrl.show(\'affiliations\')\"><span ng-if=\"ctrl.isNpolar(p.organisation)\"><img height=\"20\" ng-src=\"{{ctrl.tinyLogo(\'npolar.no\')}}\" alt=\"npolar.no\"><md-tooltip md-direction=\"top\" md-delay=\"250\">{{ \'npolar.no\'|t }}</md-tooltip></img></span><span ng-if=\"!ctrl.isNpolar(p.organisation)\">&#160;({{ p.organisation }})<md-tooltip md-direction=\"top\" md-delay=\"250\">{{ p.organisation|t }}</md-tooltip></span></span><span ng-if=\"!$last\">,</span>\n    </span>\n    <p ng-show=\"ctrl.show(\'contributor\')\">\n      <span ng-repeat=\"p in ctrl.contributors\" ng-click=\"ctrl.gotoPerson(p)\">\n        {{ p.name  }} {{ p.roles|json}}<a ng-if=\"p.email && isContact(p)\" ng-href=\"mailto:{{p.email}}\"><md-icon>email</md-icon></a>\n        <md-tooltip md-direction=\"top\" md-delay=\"150\">{{ p.name  }} ({{ (p.organisation||\'\') | t}})</md-tooltip>\n        <span ng-if=\"!$last\">, </span>\n      </span>\n    </p>\n  </span>\n\n\n</section>");
$templateCache.put("npdc-common/src/components/document/badges/badges.html","<!DOCTYPE html>\n<div class=\"npdc-badges\">\n  <a ng-if=\"openAccess\" ng-href=\"//en.wikipedia.org/wiki/Open_access\">\n    <img src=\"/assets/img/oa.png\" height=\"31px\" title=\"Open access\">\n  </a>\n\n  <a ng-if=\"license\" ng-href=\"{{ licenseHref }}\">\n    <img ng-src=\"/assets/img/{{ licenseImg }}.png\" height=\"31px\" title=\"{{ licenseTitle }}\">\n  </a>\n\n  <a ng-if=\"doi\" ng-href=\"//doi.org/{{ doi }}\">\n    <img src=\"/assets/img/doi.png\" height=\"31px\" title=\"Digital Object Identifier\">\n  </a>\n  <a ng-if=\"doi\" ng-href=\"//doi.org/{{ doi }}\" style=\"padding-bottom: 0.5em;\">{{ doi }}</a>\n</div>\n");
$templateCache.put("npdc-common/src/components/document/citation/citation.html","<span><md-icon>format_quote</md-icon>{{ \'Citation\'|t }}</span>\n<span ng-repeat=\"link in citations\">\n  <a ng-click=\"citationClicked(link)\" href=\"\" title=\"{{link.type}}\"><span ng-show=\"link.title != citation.title\" >{{ link.title || link.href }}</span></a>\n  <b ng-show=\"link.title == citation.title\" >{{ link.title || link.href }}</b>\n  <span ng-if=\"!$last\">|</span>\n</span>\n<br ng-if=\"!isPreformatted(citation)\"></br>\n<code ng-show=\"!error && !isPreformatted(citation)\" class=\"np-citation\">{{ citation.text }}</code>\n<pre ng-show=\"!error && isPreformatted(citation)\" class=\"np-citation\">{{ citation.text }}</pre>\n<pre>{{ error | t }}</pre>");
$templateCache.put("npdc-common/src/components/document/citation/citationtemplate.html","<!DOCTYPE html>\n<md-card>\n  <md-card-header>\n    <md-card-avatar>\n      <md-icon>“”</md-icon>\n    </md-card-avatar>\n    <md-card-header-text>\n      <span class=\"md-headline\">{{ \'Citation\'|t }}</span>\n      <span class=\"md-subhead\">{{ \'Citation-subhead\'|t }}</span>\n    </md-card-header-text>\n  </md-card-header>\n  <md-card-content md-whiteframe-1dp>\n    <p>{{ \'Formats\'|t }}: <span ng-repeat=\"link in citations\">\n          <a ng-click=\"citationClicked(link)\" href=\"\" title=\"{{link.type}}\"><span ng-show=\"link.title != citation.title\" >{{ link.title || link.href }}</span></a>\n          <b ng-show=\"link.title == citation.title\" >{{ link.title || link.href }}</b>\n          <span ng-if=\"!$last\">|</span>\n        </span>\n    </p>\n    <code ng-show=\"!error && !isPreformatted(citation)\" class=\"np-citation\">{{ citation.text }}</code>\n    <pre ng-show=\"!error && isPreformatted(citation)\" class=\"np-citation\">{{ citation.text }}</pre>\n    <pre>{{ error | t }}</pre>\n  </md-card-content>\n</md-card>");
$templateCache.put("npdc-common/src/components/document/collection/collection.html","<!DOCTYPE html>\n<div class=\"np-collection md-default-theme md-chips\">\n  <div class=\"md-chip\">\n    <div class=\"md-chip-content\" tabindex=\"-1\" aria-hidden=\"true\">\n      <md-icon>label_outline</md-icon><strong>{{ collection | t }}</strong>\n    </div>\n  </div>\n</div>\n");
$templateCache.put("npdc-common/src/components/document/licences/licences.html","<!DOCTYPE html>\n<div class=\"np-licences\">\n  <a ng-repeat=\"l in licences\" class=\"{{l.class}}\" ng-href=\"{{l.href}}\">{{l.text}}</a>\n</div>\n");
$templateCache.put("npdc-common/src/components/document/links/datatemplate.html","<!DOCTYPE html>\n<section ng-if=\"data.length > 0\">\n  <md-divider></md-divider>\n  <h3>Data</h3>\n  \n  <md-list>\n    <md-list-item class=\"md-2-line\" ng-repeat=\"d in data\">\n        <md-icon>file_download</md-icon>\n        <!--div class=\"md-list-item-text\">-->\n          <p><a ng-href=\"{{d.href}}\"> {{ d.title || d.href }} {{d.type ? \'(\'+d.type+\')\':\'\'}}</a></p>\n          <!--<p>\n            <span ng-repeat=\"licence in licenses\">\n              <a ng-href=\"{{licence}}\">{{ licenceText(licence); }}</a>{{ $last ? \'\':\', \'}}\n            </span>\n          </p>-->\n        <!--/div>-->\n    </md-list-item>\n    <div marked=\"rights\"></div>\n  </md-list>\n</section>\n");
$templateCache.put("npdc-common/src/components/document/links/linkstemplate.html","<!DOCTYPE html>\n<section>\n\n   <md-card ng-if=\"links.length > 0\">\n    <md-card-header>\n      <md-card-avatar>\n        <md-icon>subdirectory_arrow_right</md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class=\"md-headline\">{{ \'Links\' | t }}</span>\n        <span class=\"md-subhead\">\n        </span>\n      </md-card-header-text>\n    </md-card-header>\n    <md-card-content>\n      <span ng-repeat=\"link in links\">\n        <span ng-if=\"link.rel != \'related\'\">{{ link.rel | t  }}: </span><a ng-href=\"{{link.href}}\" title=\"{{link.title}}\">{{ link.title }}</a>\n        <span ng-if=\"!$last\">|</span>\n      </span>\n    </md-card-content>\n  </md-card>\n\n\n  <div ng-if=\"!isEmpty(related)\">\n    <md-list>\n      <md-subheader class=\"md-no-sticky\" ng-repeat-start=\"collection in related\" ng-if=\"collection[0]\">{{ collection | t }}</md-subheader>\n      <md-list-item ng-repeat=\"rel in collection\" ng-if=\"rel._score > 0.45\" ng-repeat-end>\n        <div class=\"md-list-item-text\">\n          <a ng-href=\"{{\'/\' + rel.collection + \'/\' + rel.id}}\">{{ rel.title }}</a>\n          <span ng-show=\"true\">[{{ rel._score }}]</span>\n        </div>\n      </md-list-item>\n    </md-list>\n  </div>\n\n</section>\n");
$templateCache.put("npdc-common/src/components/document/meta/metatemplate.html","<!DOCTYPE html>\n<div layout=\"row\" layout-align=\"start start\" class=\"np-document-meta\">\n  <div class=\"document-meta\">\n    <h4><md-icon>access_time</md-icon><span> {{\'Created\' | t}}: </span></h4><span>{{document.created.substr(0,10)}}</span>\n  </div>\n  <div class=\"document-meta\">\n    <h4><md-icon>sync</md-icon><span> {{\'Updated\' | t}}: </span></h4><span>{{document.updated.substr(0,10)}}</span>\n  </div>\n  <div class=\"document-meta\" ng-if=\"document.draft === \'yes\'\">\n    <code>DRAFT</code>\n  </div>\n</div>\n");
$templateCache.put("npdc-common/src/components/document/organisations/organisations.html","<!DOCTYPE html>\n<!-- <section ng-if=\"document.organisations\">\n  <h3 class=\"headline\">{{\'Organisations\' | t}}</h3>\n  <md-divider></md-divider>\n  <md-list>\n    <md-list-item class=\"md-2-line\" ng-repeat=\"o in document.organisations\">\n      <md-icon>business</md-icon>\n      <div class=\"md-list-item-text\">\n        <h3><a ng-href=\"{{resource.uiBase}}?q={{ (o.id || o.name|t) }}\">{{ (o.name || o.id) | t }}</a></h3>\n        <p ng-if=\"o.role\">{{o.role | t }}</p>\n        <p><span ng-repeat=\"r in o.roles\">{{ r }}<span ng-if=\"!$last\">, </span></span></p>\n        <a ng-href=\"{{o.homepage}}\">{{o.homepage}}</a>\n      </div>\n    </md-list-item>\n  </md-list>\n</section>\n-->\n<md-card>\n    <md-card-header>\n      <md-card-avatar>\n        <md-icon>business</md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class=\"md-headline\">{{\'Organisations\' | t}}</span>\n        <span class=\"md-subhead\"></span>\n      </md-card-header-text>\n    </md-card-header>\n    <md-card-content>\n      <span class=\"md-subhead\">\n      <md-list>\n        <md-list-item class=\"md-1-line\" ng-repeat=\"o in document.organisations\">\n\n          <div class=\"md-list-item-text\">\n            <span>{{ (o.name) | t }} ({{ o.id }})</span>\n\n            <i ng-repeat=\"r in o.roles\">{{ r | t }}<span ng-if=\"!$last\">, </span></i>\n\n            <a ng-if=\"o.homepage\" ng-href=\"{{o.homepage}}\"><md-icon>home</md-icon><md-tooltip>{{\'Homepage\'}}: {{o.homepage}}</md-tooltip></a>\n            <!-- @todo create nice menu --><!--<md-button ng-href=\"{{resource.uiBase}}?q={{ (o.id || o.name|t) }}\">{{ \'Search\' }}</md-button>-->\n          </div>\n        </md-list-item>\n      </md-list>\n      </span>\n    </md-card-content>\n  </md-card>");
$templateCache.put("npdc-common/src/components/document/persons/persons.html","<!DOCTYPE html>\n<md-card ng-if=\"document.people && document.people.length > 0\">\n    <md-card-header>\n      <md-card-avatar>\n        <md-icon>person</md-icon>\n      </md-card-avatar>\n      <md-card-header-text>\n        <span class=\"md-headline\">{{\'People\' | t}}</span>\n        <span class=\"md-subhead\"></span>\n      </md-card-header-text>\n    </md-card-header>\n    <md-card-content>\n      <p ng-repeat=\"p in document.people\">\n        <span id=\"{{ p.first_name | lowercase }}+{{ p.last_name | lowercase}}\" class=\"anchor\"></span>\n        <span>\n          {{ p.first_name}} {{ p.last_name}}\n        </span>\n\n        <span ng-if=\"p.organisation\">({{ (p.organisation) }})</span>\n        <i ng-repeat=\"r in p.roles || [p.role]\">{{ r | t }}<span ng-if=\"!$last\">, </span></i>\n\n        <a ng-if=\"p.homepage\" ng-href=\"{{p.homepage}}\"><md-icon alt=\"Homepage\">home</md-icon><md-tooltip>{{\'Homepage\'}}: {{p.homepage}}</md-tooltip></a>\n        <a ng-if=\"p.email && isPointOfContact(p)\" ng-href=\"mailto:{{p.email}}\"><md-icon>email</md-icon></a>\n        <!-- todo nice menu <md-button ng-href=\"{{resource.uiBase}}?q={{ p.name }}&filter-people.last_name={{p.last_name}}\">{{ \'Search\' }}</md-button>-->\n\n      </p>\n    </md-card-content>\n  </md-card>\n");
$templateCache.put("npdc-common/src/components/document/persons/personstemplate.html","<!DOCTYPE html>\n<section ng-if=\"document.people && document.people.length > 0\">\n  <md-divider></md-divider>\n  <h3>{{ \'People\' | t }}</h3>\n  <md-list>\n    <md-list-item class=\"md-2-line\" ng-repeat=\"person in document.people\">\n      <md-icon class=\"md-avatar-icon\">person</md-icon>\n        <div class=\"md-list-item-text\">\n          <h3><a ng-href=\"{{resource.uiBase}}?q={{ person.first_name }}+{{ person.last_name }}&filter-people.last_name={{ person.last_name }}\">\n            {{ person.first_name }} {{ person.last_name }}</a></h3>\n          <p ng-if=\"person.organisation\">{{ person.organisation | t }}</p>\n          <p ng-if=\"person.role\">{{ person.role | t}}</p>\n          <p ng-if=\"person.roles\">\n            <span ng-repeat=\"r in person.roles\">{{ r | t }}\n              <span ng-if=\"person.email && r==\'pointOfContact\'\"> [{{ person.email}}] {{ person.homepage}}</span><span ng-if=\"!$last\">, </span>\n            </span>\n          </p>\n        </div>\n      </md-list-item>\n    </md-list>\n</section>\n");
$templateCache.put("npdc-common/src/components/document/placenames/placenames.html","<!DOCTYPE html>\n<section ng-if=\"document.placenames\">\n  <h3>Placenames</h3>\n  <md-divider></md-divider>\n  <p>\n    <div ng-repeat=\"p in document.placenames\">\n      <md-icon>place</md-icon><a ng-href=\"{{resource.uiBase}}?q={{ p.placename || p.area }}\">{{ p.placename || p.area }}</a>\n    </div>\n  </p>\n</section>\n");
$templateCache.put("npdc-common/src/components/document/show/document.html","<!DOCTYPE html>\n<script type=\"text/ng-template\" id=\"any.html\">\n  <div ng-if=\"isArray(value)\" layout=\"row\" class=\"np-document-array\">\n    <div class=\"np-document-title md-title\" flex>{{ key }}</div>\n    <ul flex=\"85\">\n      <li ng-repeat=\"(key, value) in value\">\n        <ng-include src=\"\'any.html\'\"></ng-include>\n      </li>\n    </ul>\n  </div>\n  <div ng-if=\"isObject(value)\" layout=\"row\" class=\"np-document-object\">\n    <div class=\"np-document-title md-title\" flex>{{ key }}</div>\n    <ul flex=\"85\">\n      <li ng-repeat=\"(key, value) in value\">\n        <ng-include src=\"\'any.html\'\"></ng-include>\n      </li>\n    </ul>\n  </div>\n  <div ng-if=\"isItem(value)\" layout=\"row\" class=\"np-document-item\">\n    <div class=\"np-document-title md-title\" flex>{{ key }}</div>\n    <div class=\"np-document-value\" flex=\"85\">{{ value }}</div>\n  </div>\n</script>\n\n<div class=\"np-document\">\n  <npdc:edit-button class=\"np-primary-control\"></npdc:edit-button>\n  <div class=\"np-document-ctrls\" layout=\"row\">\n    <div class=\"np-document-ctrls-title\" flex>Fancy: </div><md-switch flex ng-model=\"fancy\" aria-label=\"Render mode\"></md-switch>\n  </div>\n  <ul ng-if=\"fancy\">\n    <li ng-repeat=\"(key, value) in document\">\n      <ng-include src=\"\'any.html\'\"></ng-include>\n    </li>\n  </ul>\n  <pre ng-if=\"!fancy\">\n    {{ document | json }}\n  </pre>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/templates/array.html","<fieldset ng-class=\"{ valid: field.valid, error: field.error }\" ng-if=\"field.visible\">\n  <md-whiteframe class=\"md-whiteframe-z2\">\n\n    <legend>\n      <div>{{ field.title }} ({{ field.nrArrayValues() }})</div>\n      <div npdc:formula-field-info class=\"np-field-info\" ng-if=\"::field.description\"></div>\n    </legend>\n\n    <ul ng-if=\"::field.typeOf(\'field\')\" class=\"np-formula-list\">\n      <li ng-repeat=\"value in field.values\" ng-class=\"{ valid: field.valid, error: field.error }\" class=\"np-formula-list-item\">\n        <formula:field field=\"value\" class=\"multi-ctrls\"></formula:field>\n        <div class=\"np-formula-input-ctrls\">\n          <md-menu>\n            <md-button aria-label=\"Actions\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n              <md-icon md-menu-origin>menu</md-icon>\n              <md-tooltip md-direction=\"left\">{{ i18n.text.actions.tooltip }}</md-tooltip>\n            </md-button>\n            <md-menu-content>\n              <md-menu-item ng-show=\"!$first\">\n                <md-button ng-click=\"field.moveUp($index)\">\n                  <md-icon md-menu-align-target>arrow_upward</md-icon> {{ i18n.text.moveup.label }}\n                  <md-tooltip md-direction=\"left\">{{ i18n.text.moveup.tooltip }}</md-tooltip>\n                </md-button>\n              </md-menu-item>\n              <md-menu-item ng-show=\"!$last\">\n                <md-button ng-click=\"field.moveDown($index)\">\n                  <md-icon md-menu-align-target>arrow_downward</md-icon> {{ i18n.text.movedown.label }}\n                  <md-tooltip md-direction=\"left\">{{ i18n.text.movedown.tooltip }}</md-tooltip>\n                </md-button>\n              </md-menu-item>\n              <md-menu-item>\n                <md-button ng-click=\"field.itemRemove($index)\" class=\"md-warn\">\n                  <md-icon md-menu-align-target>delete</md-icon> {{ i18n.text.remove.label }}\n                  <md-tooltip md-direction=\"left\">{{ i18n.text.remove.tooltip }}</md-tooltip>\n                </md-button>\n              </md-menu-item>\n            </md-menu-content>\n          </md-menu>\n        </div>\n      </li>\n    </ul>\n\n    <ul ng-if=\"::field.typeOf(\'fieldset\')\" class=\"np-formula-list\">\n      <li ng-repeat=\"value in field.values\" ng-if=\"!value.hidden\" class=\"np-formula-list-item\">\n        <div class=\"np-formula-collapsed-item\" ng-if=\"!value.visible\" ng-click=\"field.itemToggle($index)\"></div>\n        <md-whiteframe class=\"md-whiteframe-z2\">\n          <fieldset ng-class=\"{ valid: value.valid }\">\n            <legend>\n              <!--span class=\"np-formula-array-object-title\">{{ value.title }}</span-->\n              <span ng-if=\"!value.visible\">{{ value.value | formulaInlineValues }}</span>\n              <div class=\"np-formula-object-ctrls\">\n                <div npdc:formula-field-info class=\"np-field-info\" ng-if=\"value.description\"></div>\n                <a href=\"\" ng-click=\"field.itemToggle($index)\">\n                  <md-icon>{{ value.visible ? \'expand_less\' : \'expand_more\' }}</md-icon>\n                  <md-tooltip>{{ value.visible ? i18n.text.minimize.tooltip : i18n.text.maximize.tooltip }}</md-tooltip>\n                </a>\n                <md-menu>\n                  <md-button aria-label=\"Actions\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n                    <md-icon md-menu-origin>menu</md-icon>\n                    <md-tooltip md-direction=\"left\">{{ i18n.text.actions.tooltip }}</md-tooltip>\n                  </md-button>\n                  <md-menu-content>\n                    <md-menu-item ng-show=\"!$first\">\n                      <md-button ng-click=\"field.moveUp($index)\">\n                        <md-icon md-menu-align-target>arrow_upward</md-icon> {{ i18n.text.moveup.label }}\n                        <md-tooltip md-direction=\"left\">{{ i18n.text.moveup.tooltip }}</md-tooltip>\n                      </md-button>\n                    </md-menu-item>\n                    <md-menu-item ng-show=\"!$last\">\n                      <md-button ng-click=\"field.moveDown($index)\">\n                        <md-icon md-menu-align-target>arrow_downward</md-icon> {{ i18n.text.movedown.label }}\n                        <md-tooltip md-direction=\"left\">{{ i18n.text.movedown.tooltip }}</md-tooltip>\n                      </md-button>\n                    </md-menu-item>\n                    <md-menu-item>\n                      <md-button ng-click=\"field.itemRemove($index)\" class=\"md-warn\">\n                        <md-icon md-menu-align-target>delete</md-icon> {{ i18n.text.remove.label }}\n                        <md-tooltip md-direction=\"left\">{{ i18n.text.remove.tooltip }}</md-tooltip>\n                      </md-button>\n                    </md-menu-item>\n                  </md-menu-content>\n                </md-menu>\n              </div>\n            </legend>\n            <formula:field field=\"value\" ng-if=\"value.visible\" class=\"np-formula-array-fieldset\"></formula:field>\n          </fieldset>\n        </md-whiteframe>\n      </li>\n    </ul>\n\n    <div class=\"np-formula-array-add\">\n      <md-button ng-click=\"field.itemAdd()\" class=\"md-fab md-mini md-primary md-hue-1\" aria-label=\"{{ i18n.text.add.tooltip }}\">\n        <md-icon>add</md-icon>\n        <md-tooltip>{{ i18n.text.add.tooltip }}</md-tooltip>\n      </md-button>\n    </div>\n    <div style=\"clear: both;\"></div>\n  </md-whiteframe>\n</fieldset>\n");
$templateCache.put("npdc-common/src/components/formula/templates/checkbox.html","<!DOCTYPE html>\n<md-checkbox ng-attr-id=\"::field.uid\" ng-model=\"field.value\" ng-disabled=\"field.disabled\" aria-label=\"{{ field.title }}\"  ng-if=\"field.visible\">\n  <label for=\"{{::field.uid}}\">{{ field.title }}</label>\n</md-checkbox>\n<div npdc:formula-validation-message class=\"np-validation-message\"></div>\n");
$templateCache.put("npdc-common/src/components/formula/templates/date.html","<!DOCTYPE html>\n<md-input-container ng-if=\"field.visible\">\n  <label for=\"{{::field.uid}}\">{{field.title}}<i ng-if=\"field.required\">&nbsp;({{ i18n.text.required }})</i></label>\n  <input type=\"text\" ng-model=\"field.value\" ng-disabled=\"field.disabled\" chronopic />\n  <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n</md-input-container>\n");
$templateCache.put("npdc-common/src/components/formula/templates/field.html","<!DOCTYPE html>\n<md-input-container ng-if=\"field.visible\">\n  <label for=\"{{::field.uid}}\">{{field.title}}<i ng-if=\"field.required\">&nbsp;({{ i18n.text.required }})</i></label>\n  <formula:input field=\"field\"></formula:input>\n  <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n</md-input-container>\n");
$templateCache.put("npdc-common/src/components/formula/templates/fieldInfo.html","<!DOCTYPE html>\n<md-icon>info_outline\n  <md-tooltip md-direction=\"left\">{{ field.description }}</md-tooltip>\n</md-icon>\n");
$templateCache.put("npdc-common/src/components/formula/templates/fieldset.html","<!DOCTYPE html>\n<div class=\"np-tab np-formula-tab\" ng-class=\"{ \'active\': fieldset.active }\">\n  <formula:fields fields=\"::fieldset.fields\"></formula:fields>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/templates/form.html","<!DOCTYPE html>\n<div>\n  <form name=\"formula\" class=\"formula\" ng-show=\"form.ready\">\n    <header ng-if=\"::form.title\">\n      {{ form.title }}\n    </header>\n\n    <npdc:tabs tabs=\"form.fieldsets\" tabactivate=\"form.activate\"></npdc:tabs>\n    <formula:fieldsets class=\"np-tabs np-formula-fieldsets\"></formula:fieldsets>\n\n    <div class=\"np-padding\">\n      <span ng-if=\"form.errors\" title=\"{{ form.errors.join(\'\\n\') }}\">{{ i18n.text.invalid | formulaReplace : { count: form.errors.length } }}</span>\n    </div>\n  </form>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/templates/object.html","<!DOCTYPE html>\n<fieldset ng-if=\"field.visible\">\n  <md-whiteframe class=\"md-whiteframe-z2\">\n    <legend>{{ field.title }}\n      <div npdc:formula-field-info class=\"np-field-info\" ng-if=\"::field.description\"></div>\n    </legend>\n\n    <formula:fields fields=\"field.fields\"></formula:fields>\n  </md-whiteframe>\n</fieldset>\n");
$templateCache.put("npdc-common/src/components/formula/templates/range.html","<!DOCTYPE html>\n<div ng-if=\"field.visible\">\n  <label for=\"{{::field.uid}}\">{{ field.title }}:\n    <span>{{field.value}}</span>\n  </label>\n  <md-slider flex min=\"{{field.minimum}}\" max=\"{{field.maximum}}\" step=\"{{field.step}}\" md-discrete ng-model=\"field.value\" aria-label=\"{{field.title}}\" ng-attr-id=\"field.uid\">\n  </md-slider>\n  <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/templates/select.html","<!DOCTYPE html>\n<md-input-container ng-if=\"field.visible\">\n  <label for=\"{{::field.uid}}\">{{field.title}}<i ng-if=\"field.required\">&nbsp;({{ i18n.text.required }})</i></label>\n\n  <!-- single-select -->\n  <md-select ng-model=\"field.value\" ng-if=\"::!field.multiple\">\n    <md-option ng-repeat=\"val in field.values\" value=\"{{::val.id}}\">{{val.label}}</md-option>\n  </md-select>\n\n  <!-- multi-select, ref: https://docs.angularjs.org/error/$compile/selmulti -->\n  <md-select ng-model=\"field.value\" multiple ng-if=\"::field.multiple\">\n    <md-option ng-repeat=\"val in field.values\" value=\"{{::val.id}}\">{{val.label}}</md-option>\n  </md-select>\n\n  <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n</md-input-container>\n");
$templateCache.put("npdc-common/src/components/formula/templates/validationMessage.html","<!DOCTYPE html>\n<div class=\"md-caption\" role=\"alert\" ng-show=\"field.error\">\n  {{ field.error.message }}\n</div>\n");
$templateCache.put("npdc-common/src/components/search/autocomplete/autocomplete.html","<!DOCTYPE html>\n<div ng-keyup=\"keyup($event);\">\n    <md-autocomplete ng-if=\"options.floatingLabel\"\n      md-floating-label=\"{{options.placeholder | t}}\"\n      md-item-text=\"title(item)\"\n      md-items=\"item in querySearch(options.q)\"\n      md-min-length=\"1\"\n      md-no-cache=\"false\"\n      md-search-text=\"options.q\"\n      md-selected-item-change=\"selectedItemChange(item)\"\n      md-selected-item=\"selectedItem\"\n      md-menu-class=\"{{options.menuClass}}\">\n\n      <md-item-template>\n        [{{item.collection}}] <span md-highlight-flags=\"^i\" md-highlight-text=\"options.q\">{{ title(item) }}</span>\n      </md-item-template>\n\n    </md-autocomplete>\n\n    <md-autocomplete ng-if=\"!options.floatingLabel\"\n      placeholder=\"{{options.placeholder | t}}\"\n      md-item-text=\"title(item)\"\n      md-items=\"item in querySearch(options.q)\"\n      md-min-length=\"1\"\n      md-no-cache=\"true\"\n      md-search-text=\"options.q\"\n      md-selected-item-change=\"selectedItemChange(item)\"\n      md-selected-item=\"selectedItem\"\n      md-menu-class=\"{{options.menuClass}}\">\n\n      <md-item-template>\n        [{{item.collection}}] <span md-highlight-flags=\"^i\" md-highlight-text=\"options.q\">{{ title(item) }}</span>\n      </md-item-template>\n\n    </md-autocomplete>\n\n    <div ng-if=\"options.showCollections && !expandSearch\">\n      <br/>\n      <md-checkbox ng-model=\"options.collections[collection]\" ng-repeat=\"(collection, value) in options.collections\">{{ collection }}</md-checkbox>\n    </div>\n</div>\n");
$templateCache.put("npdc-common/src/components/search/expandable-search/expandSearch.html","<!DOCTYPE html>\n<div class=\"np-expand-search\" ng-keyup=\"keyup($event);\" ng-class=\"{ open: isOpen, sm: $mdMedia(\'sm\'), md: $mdMedia(\'md\'), lg: $mdMedia(\'lg\')}\">\n  <md-fab-toolbar md-theme=\"white\" md-open=\"isOpen\" md-direction=\"left\">\n    <md-fab-trigger>\n      <md-button aria-label=\"search\" class=\"md-fab md-mini\" ng-focus-out=\"blockEvent($event);\" ng-click=\"open($event);\">\n        <md-icon>search</md-icon>\n        <md-tooltip>{{ \'search\' | t }}</md-tooltip>\n      </md-button>\n    </md-fab-trigger>\n\n    <md-toolbar ng-focus-out=\"blockEvent($event);\" ng-click=\"blockEvent($event);\">\n      <md-fab-actions class=\"md-toolbar-tools\">\n        <form class=\"np-es-input\" ng-class=\"{open : isFiltersOpen}\" ng-submit=\"search();\" layout>\n          <div flex layout>\n            <npdc:autocomplete flex options=\"options\"></npdc:autocomplete>\n          </div>\n          <md-button class=\"md-icon-button\" ng-click=\"toggleFilters();\" aria-label=\"{{ \'search.filter\' | t }}\">\n            <md-icon>settings</md-icon>\n            <md-tooltip ng-if=\"isOpenDelay\">{{ \'search.filter\' | t }}</md-tooltip>\n          </md-button>\n          <md-button class=\"md-icon-button\" type=\"submit\" aria-label=\"{{ \'search\' | t }}\">\n            <md-icon>search</md-icon>\n            <md-tooltip ng-if=\"isOpenDelay\">{{ \'search\' | t }}</md-tooltip>\n          </md-button>\n        </form>\n      </md-fab-actions>\n    </md-toolbar>\n  </md-fab-toolbar>\n\n  <div ng-show=\"isFiltersOpen && isOpen\" class=\"np-es-filter\" ng-class=\"{ open: isFiltersOpen && isOpen }\">\n    <div ng-if=\"options.showCollections\" layout layout-wrap layout-align=\"space-between center\">\n      <span flex=\"25\" ng-repeat=\"collection in options.collections\">\n        <md-checkbox ng-model=\"collection.enabled\">{{ collection.name }}</md-checkbox>\n      </span>\n    </div>\n  </div>\n</div>\n\n<div id=\"np-es-click-area\" ng-class=\"{ open: isOpen }\" ng-click=\"close();\"></div>\n");
$templateCache.put("npdc-common/src/components/search/faceting/faceting.html","<!DOCTYPE html>\n<div class=\"np-faceting\">\n  <!-- blue pills (active facet filters)-->\n  <div class=\"np-faceting-active-filters np-center-content\" ng-show=\"ctrl.activeFilters()\">\n    <div class=\"np-chips\">\n      <div ng-repeat=\"filter in ctrl.filters()\" ng-class=\"{\'md-focused\': selectedChip === $index}\" class=\"np-chip md-default-theme\">\n        <div class=\"np-chip-content\" tabindex=\"-1\" aria-hidden=\"true\" ng-click=\"selectChip($index)\">\n          <strong>{{ i18n(filter.facet) | t }}: {{ filter.term.replace(\'field.\', \'\') }}</strong>\n          <span ng-if=\"false\">({{ filter.count }})</span><!-- @todo Make configurable? -->\n          <a class=\"np-chip-remove\" ng-click=\"removeFilter(filter)\" type=\"button\" aria-hidden=\"true\">\n            <md-icon>close</md-icon>\n          </a>\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <!-- faceting -->\n  <div class=\"np-faceting-facets\" layout=\"row\" layout-wrap layout-align=\"space-around start\">\n    <div ng-repeat=\"facet in model\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"33\" ng-if=\"facet.uiType !== \'hidden\'\">\n\n      <!-- autocomplete -->\n      <md-autocomplete ng-if=\"facet.uiType === \'autocomplete\'\"\n        md-items=\"item in facet.querySearch(facet.searchText)\"\n        md-item-text=\"item.term\"\n        md-min-length=\"0\"\n        md-search-text=\"facet.searchText\"\n        md-floating-label=\"{{ i18n(facet.key) | t}}\"\n        md-selected-item-change=\"ctrl.selectedItemChange(item, facet)\"\n        md-select-on-match=\"true\"\n        md-selected-item=\"facet.selectedItem\">\n        <md-item-template>\n          <span md-highlight-text=\"facet.searchText\" md-highlight-flags=\"^i\" ng-click=\"ctrl.clickedFacet(item)\">{{item.term}} ({{item.count}})</span>\n        </md-item-template>\n        <md-not-found>\n          No matches found for \"{{facet.searchText}}\".\n        </md-not-found>\n        <md-icon class=\"np-faceting-autocomplete-icon\">arrow_drop_down</md-icon>\n      </md-autocomplete>\n\n      <!-- checkbox -->\n      <div ng-if=\"facet.uiType === \'checkbox\'\" class=\"np-custom-facet\">\n        <label>{{i18n(facet.key) | t}}</label>\n        <ul layout layout-wrap>\n          <li ng-repeat=\"item in facet[facet.key] | orderBy:\'-term\'\" flex=\"none\">\n            <md-checkbox ng-model=\"item.selected\" ng-change=\"toggleSelect(item)\">\n              {{item.term}} ({{item.count}})\n            </md-checkbox>\n          </li>\n        </ul>\n      </div>\n\n      <!-- range -->\n      <div ng-if=\"facet.uiType === \'range\'\" class=\"np-custom-facet np-range-facet\">\n        <label>{{i18n(facet.key) | t}}</label>\n        <rzslider rz-slider-options=\"facet.slider.options\" rz-slider-model=\"facet.slider.min\" rz-slider-high=\"facet.slider.max\"></rzslider>\n      </div>\n\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("npdc-common/src/components/search/input/searchInput.html","<!DOCTYPE html>\n<md-card>\n  <md-card-content class=\"np-search-input\">\n\n    <div layout=\"row\">\n      <md-input-container flex md-no-float md-autofocus class=\"np-search-input-input md-icon-left md-has-icon\">\n        <md-icon>search</md-icon>\n        <input ng-model=\"query.q\" placeholder=\"{{options.placeholder | t}}\" type=\"text\" md-autofocus>\n      </md-input-container>\n      <md-button class=\"md-icon-button np-search-input-filters\" ng-click=\"ctrl.toggleFilters();\">\n        <md-icon>build</md-icon>\n        <md-tooltip>{{ \'search.filter\' | t }}</md-tooltip>\n      </md-button>\n    </div>\n\n    <npdc:faceting ng-if=\"options\" options=\"options\" ng-class=\"{ open: isFiltersOpen }\"></npdc:faceting>\n\n  </md-card-content>\n</md-card>\n\n<div class=\"clearfix\"></div>");
$templateCache.put("npdc-common/src/components/search/results/searchResults.html","<!DOCTYPE html>\n<md-content layout-padding ng-if=\"true\">\n  <span ng-if=\"feed.opensearch.totalResults > 0\">\n    {{feed.opensearch.totalResults}} results, displaying {{ feed.entries.length}}\n  </span>\n  <span ng-if=\"showNext()\" ><a ng-href=\"#\" ng-click=\"next()\">More</a></span>\n  <span ng-if=\"feed.opensearch.totalResults == 0\">{{ \'search.no_results\' | t}} \"{{q()}}\"<span ng-if=\"ctrl.hasFilters()\">, try <a ng-click=\"ctrl.removeFilters()\">removing all filters</a></span></span>\n<!--  <span ng-show=\"feed.opensearch.totalResults > 0\">@todo FIXME infinite loop[sort by:\n    <a ng-repeat=\"s in ctrl.sortList\" ng-href=\"{{ctrl.sortHref(s.sort)}}\">{{ s.name }} </a>]\n  </span>-->\n</md-content>\n\n<npdc:contributions facets=\"feed.facets\"></npdc:contributions>\n<npdc:create-button class=\"np-primary-control\"></npdc:create-button>\n\n<div class=\"npdc-search\">\n  <md-content>\n\n    <section>\n      <npdc:loader ng-if=\"!feed.entries\"></npdc:loader>\n\n      <div class=\"np-layout-list\">\n        <md-list>\n          <md-list-item class=\"md-2-line\" ng-repeat=\"e in feed.entries\" ng-href=\"{{ entryHref(e) }}\">\n            <img class=\"md-avatar\" ng-src={{icon(e)}} title=\"ID: {{ e.id }}\" />\n\n            <!-- <div class=\"np-search-icon md-avatar\" title=\"ID: {{ e.id }}\">\n              <span>{{ avatar(e) }}</span>\n            </div> -->\n            <div class=\"md-list-item-text\">\n              <h3 class=\"md-headline\">\n                <span md-highlight-text=\"q()\" md-highlight-flags=\"ig\">{{title(e)}}</span>\n                <em ng-if=\"subtitle(e)\">\n                  「{{ subtitle(e) }}」\n                </em>\n              </h3>\n              <h4>{{ detail(e) }}</h4>\n            </div>\n          </md-list-item>\n        </md-list>\n        <md-divider></md-divider>\n      </div>\n      <md-button class=\"md-raised md-primary\" ng-if=\"showNext()\" ng-click=\"next()\">More</md-button>\n\n    </section>\n  </md-content>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/directives/autocomplete/autocomplete.html","<!DOCTYPE html>\n<div ng-if=\"field.visible\">\n  <md-autocomplete\n    md-items=\"item in items\"\n    md-item-text=\"label(item)\"\n    md-min-length=\"minLength\"\n    md-search-text=\"search.text\"\n    md-floating-label=\"{{field.title}}\"\n    md-selected-item-change=\"onSelect(item)\"\n    md-select-on-match=\"true\"\n    md-search-text-change=\"searchChange(search.text)\"\n    md-match-case-insensitive=\"true\">\n\n    <md-item-template>\n      <span md-highlight-flags=\"^i\" md-highlight-text=\"search.text\">{{label(item)}}</span>\n    </md-item-template>\n\n  <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n  </md-autocomplete>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/directives/file/file.html","<!DOCTYPE html>\n<fieldset ng-class=\"{ valid: field.valid, error: field.error }\" ng-if=\"field.visible\" ng-controller=\"NpdcFormulaFileController as ctrl\">\n  <md-whiteframe class=\"md-whiteframe-z2 np-formula-file\">\n\n    <legend>\n      <div>{{ field.title }} ({{ nrFiles() }})</div>\n      <div npdc:formula-field-info class=\"np-field-info\" ng-if=\"::field.description\"></div>\n    </legend>\n\n\n    <ul class=\"np-formula-list\">\n      <li ng-repeat=\"value in field.values | filter:isFile\" class=\"np-formula-list-item\">\n        <div class=\"np-formula-collapsed-item\" ng-if=\"!value.visible\" ng-click=\"field.itemToggle($index)\"></div>\n        <md-whiteframe class=\"md-whiteframe-z2\">\n          <fieldset>\n            <legend>\n              <!--span class=\"np-formula-array-object-title\">{{ value.title }}</span-->\n              <div>\n                <span><md-icon class=\"md-avatar\">{{::files[$index].icon || \'attachment\'}}</md-icon></span>\n                <span>{{::files[$index].filename}}</span>&nbsp;<span>{{::files[$index].file_size | bytes}}</span>\n              </div>\n              <div class=\"np-formula-object-ctrls\">\n                <div npdc:formula-field-info class=\"np-field-info\" ng-if=\"value.description\"></div>\n                <a ng-show=\"!$first\" href=\"\" ng-click=\"field.moveUp($index)\">\n                  <md-icon>arrow_upward</md-icon>\n                  <md-tooltip>{{ i18n.text.moveup }}</md-tooltip>\n                </a>\n                <a ng-show=\"!$last\" href=\"\" ng-click=\"field.moveDown($index)\">\n                  <md-icon>arrow_downward</md-icon>\n                  <md-tooltip>{{ i18n.text.movedown }}</md-tooltip>\n                </a>\n                <a ng-show=\"files[$index] && files[$index].extras && files[$index].extras.length > 0\" href=\"\" ng-click=\"field.itemToggle($index)\">\n                  <md-icon>{{ value.visible ? \'expand_less\' : \'expand_more\' }}</md-icon>\n                  <md-tooltip>{{ value.visible ? i18n.text.minimize.tooltip : i18n.text.maximize.tooltip }}</md-tooltip>\n                </a>\n                <md-menu>\n                  <md-button ng-show=\"ctrl.canDelete()\" aria-label=\"{{ i18n.text.remove.label }}\" class=\"md-icon-button remove\" ng-click=\"$mdMenu.open($event)\">\n                    <md-icon md-menu-origin>close</md-icon>\n                    <md-tooltip>{{ i18n.text.remove.tooltip }}</md-tooltip>\n                  </md-button>\n                  <md-menu-content>\n                    <md-menu-item>\n                      <md-button ng-click=\"removeFile($index)\" ng-attr-title=\"{{ i18n.text.remove.tooltip }}\" class=\"md-warn\">\n                        <md-icon md-menu-align-target>delete</md-icon> {{ i18n.text.remove.label }}\n                      </md-button>\n                    </md-menu-item>\n                  </md-menu-content>\n                </md-menu>\n              </div>\n            </legend>\n\n            <formula:fields fields=\"files[$index].extras\" ng-if=\"value.visible\"></formula:fields>\n          </fieldset>\n        </md-whiteframe>\n      </li>\n    </ul>\n    <div layout=\"column\" layout-align=\"space-between end\" class=\"np-formula-file-upload\">\n      <md-button ng-disabled=\"!ctrl.canUpload()\" ng-click=\"ctrl.displayUploadDialog($event);\" class=\"md-raised md-primary\">\n        <md-icon>backup</md-icon>\n        <md-tooltip ng-if=\"ctrl.canUpload()\">Upload files</md-tooltip>\n      </md-button>\n      <p ng-show=\"!ctrl.canUpload()\">\n        <span ng-if=\"!ctrl.isNew()\">You are currently not authorized to upload (are you logged in?)</span>\n        <span ng-if=\"ctrl.isNew()\">Uploading is disabled: You need to save before you can upload any files</span>\n      </p>\n    </div>\n\n    <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n  </md-whiteframe>\n</fieldset>\n");
$templateCache.put("npdc-common/src/components/formula/directives/gcmd/gcmdKeyword.html","<!DOCTYPE html>\n<div ng-if=\"tree && field.visible\">\n  <md-autocomplete md-items=\"item in querySearch(filter.text)\" md-min-length=\"1\" md-search-text=\"filter.text\" md-floating-label=\"{{ \'gcmd.find\' | t }}\" md-selected-item-change=\"onSelect(item)\" md-item-text=\"item.label\" md-menu-class=\"np-autocomplete-custom\">\n\n    <md-item-template>\n      <span class=\"np-autocomplete-custom-main\">\n        <span md-highlight-flags=\"^i\" md-highlight-text=\"filter.text\">\n          {{item.label}}\n        </span>\n      </span>\n      <span class=\"np-autocomplete-custom-meta shade\">\n        <span>{{ parents(item) }}</span>\n      </span>\n    </md-item-template>\n  </md-autocomplete>\n\n  <md-input-container>\n    <label>{{ keyword.Category.title }}</label>\n    <md-select ng-model=\"keyword.Category.value\">\n      <md-option ng-repeat=\"val in treeValues(1)\" value=\"{{::val.label}}\">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if=\"!!keyword.Category.value\">\n    <label>{{ keyword.Topic.title }}</label>\n    <md-select ng-model=\"keyword.Topic.value\">\n      <md-option ng-repeat=\"val in treeValues(2)\" value=\"{{::val.label}}\">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if=\"!!keyword.Topic.value\">\n    <label>{{ keyword.Term.title }}</label>\n    <md-select ng-model=\"keyword.Term.value\">\n      <md-option ng-repeat=\"val in treeValues(3)\" value=\"{{::val.label}}\">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if=\"!!keyword.Term.value\">\n    <label>{{ keyword.Variable_Level_1.title }}</label>\n    <md-select ng-model=\"keyword.Variable_Level_1.value\">\n      <md-option ng-repeat=\"val in treeValues(4)\" value=\"{{::val.label}}\">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if=\"!!keyword.Variable_Level_1.value\">\n    <label>{{ keyword.Variable_Level_2.title }}</label>\n    <md-select ng-model=\"keyword.Variable_Level_2.value\">\n      <md-option ng-repeat=\"val in treeValues(5)\" value=\"{{::val.label}}\">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container ng-if=\"!!keyword.Variable_Level_2.value\">\n    <label>{{ keyword.Variable_Level_3.title }}</label>\n    <md-select ng-model=\"keyword.Variable_Level_3.value\">\n      <md-option ng-repeat=\"val in treeValues(6)\" value=\"{{::val.label}}\">{{val.label}}</md-option>\n    </md-select>\n  </md-input-container>\n\n  <md-input-container>\n    <label>{{ keyword.Detailed_Variable.title }}</label>\n    <input type=\"text\" ng-model=\"keyword.Detailed_Variable.value\" />\n  </md-input-container>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/directives/person/person.html","<!DOCTYPE html>\n<div ng-if=\"field.visible\">\n  <div layout=\"row\">\n    <div flex=\"50\" flex-sm=\"100\">\n      <md-autocomplete\n        md-items=\"item in querySearch(firstName.value, \'first_name\')\"\n        md-min-length=\"1\"\n        md-search-text=\"firstName.value\"\n        md-floating-label=\"{{firstName.title}}\"\n        md-selected-item-change=\"onSelect(item)\"\n        md-item-text=\"item.first_name\"\n        md-menu-class=\"np-autocomplete-custom\">\n\n        <md-item-template>\n          <span class=\"np-autocomplete-custom-main\">\n            <span md-highlight-flags=\"^i\" md-highlight-text=\"firstName.value\">\n              {{item.first_name}}\n            </span>\n            <span class=\"shade\">{{item.last_name}}</span>\n          </span>\n          <span class=\"np-autocomplete-custom-meta\">\n            <span class=\"shade\">{{item.email}}</span>\n          </span>\n        </md-item-template>\n\n      </md-autocomplete>\n      <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n    </div>\n    <div flex=\"50\" flex-sm=\"100\">\n      <md-autocomplete\n        md-items=\"item in querySearch(lastName.value, \'last_name\')\"\n        md-min-length=\"1\"\n        md-search-text=\"lastName.value\"\n        md-floating-label=\"{{lastName.title}}\"\n        md-selected-item-change=\"onSelect(item)\"\n        md-item-text=\"item.last_name\"\n        md-menu-class=\"np-autocomplete-custom\">\n\n        <md-item-template>\n          <span class=\"np-autocomplete-custom-main\">\n            <span md-highlight-flags=\"^i\" md-highlight-text=\"lastName.value\">\n              {{item.last_name}}\n            </span>\n            <span class=\"shade\">, {{item.first_name}}</span>\n          </span>\n          <span class=\"np-autocomplete-custom-meta\">\n            <span class=\"shade\">{{item.email}}</span>\n          </span>\n        </md-item-template>\n\n      </md-autocomplete>\n      <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n    </div>\n  </div>\n  <div>\n    <md-autocomplete\n      md-items=\"item in querySearch(email.value, \'email\')\"\n      md-min-length=\"1\"\n      md-search-text=\"email.value\"\n      md-floating-label=\"{{email.title}}\"\n      md-selected-item-change=\"onSelect(item)\"\n      md-item-text=\"item.email\"\n      md-menu-class=\"np-autocomplete-custom\">\n\n      <md-item-template>\n        <span class=\"np-autocomplete-custom-main\">\n          <span md-highlight-flags=\"^i\" md-highlight-text=\"email.value\">\n            {{item.email}}\n          </span>\n        </span>\n        <span class=\"np-autocomplete-custom-meta\">\n          <span class=\"shade\">{{item.first_name}}</span>\n          <span class=\"shade\">{{item.last_name}}</span>\n        </span>\n      </md-item-template>\n\n    </md-autocomplete>\n    <div npdc:formula-validation-message class=\"np-validation-message\"></div>\n  </div>\n  <div ng-repeat=\"field in otherFields\" ng-show=\"field.visible\">\n    <formula:field field=\"field\"></formula:field>\n  </div>\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/directives/placename/placename.html","<!DOCTYPE html>\n<div ng-if=\"field.visible\">\n  <md-autocomplete md-items=\"item in querySearchPlacenames(placename.value)\" md-min-length=\"1\"\n    md-search-text=\"placename.value\" md-floating-label=\"{{placename.title}}\"\n    md-selected-item-change=\"onSelectPlacename(item)\" md-item-text=\"item.title\" md-menu-class=\"np-autocomplete-custom\">\n\n    <md-item-template>\n      <span class=\"np-autocomplete-custom-main\">\n        <span md-highlight-flags=\"^i\" md-highlight-text=\"placename.value\">\n          {{item.title}}\n        </span>\n      </span>\n      <span class=\"np-autocomplete-custom-meta shade\">\n        <span>{{item.location}}</span>\n        <span>{{item.country}}</span>\n        <span>{{item.north}}N {{item.east}}E</span>\n      </span>\n    </md-item-template>\n\n  </md-autocomplete>\n  <div npdc:formula-validation-message class=\"np-validation-message\" ng-init=\"field=placename\"></div>\n  <div layout=\"row\">\n    <div flex=\"50\" flex-sm=\"100\">\n      <md-input-container>\n        <label for=\"{{::area.uid}}\">{{ (area.required ? area.title + \' (\' + i18n.text.required + \')\' : area.title) }}</label>\n\n        <md-select ng-model=\"area.value\">\n          <md-option ng-repeat=\"val in area.values\" value=\"{{::val.id}}\">{{val.label}}</md-option>\n        </md-select>\n\n        <div npdc:formula-validation-message class=\"np-validation-message\" ng-init=\"field=area\"></div>\n      </md-input-container>\n    </div>\n    <div flex=\"50\">\n      <md-autocomplete md-items=\"item in querySearchCountries(countrySearchText)\" md-min-length=\"1\"\n        md-search-text=\"countrySearchText\" md-floating-label=\"{{country.title}}\" md-item-text=\"item.name\"\n        md-menu-class=\"np-autocomplete-custom\" md-selected-item=\"selectedCountryItem\" md-selected-item-change=\"country.value = item.code\">\n\n        <md-item-template>\n          <span class=\"np-autocomplete-custom-main\">\n            <span md-highlight-flags=\"^i\" md-highlight-text=\"countrySearchText\">\n              {{item.name}}\n            </span>\n          </span>\n          <span class=\"np-autocomplete-custom-meta shade\">\n            <span>{{item.code}}</span>\n            <span>{{item.native}}</span>\n          </span>\n        </md-item-template>\n\n      </md-autocomplete>\n      <div npdc:formula-validation-message class=\"np-validation-message\" ng-init=\"field=country\"></div>\n    </div>\n  </div>\n\n</div>\n");
$templateCache.put("npdc-common/src/components/formula/directives/tabdata/tabdata.html","<!DOCTYPE html>\n<md-input-container class=\"np-formula-tabdata\" ng-show=\"field.visible\">\n  <label for=\"{{::field.uid}}\">{{ (field.required ? field.title + \' (\' + i18n.text.required + \')\' : field.title ) }}</label>\n  <div class=\"np-formula-td-header\">\n    <span class=\"header-number\"></span>\n    <div class=\"header-string\">{{csvHeader}}</div>\n  </div>\n  <textarea ng-model=\"csvData\" md-no-autogrow class=\"csv-textarea\"></textarea>\n  <div class=\"np-td-delimiter\">Delimiter: {{delimiter}}</div>\n  <div ng-show=\"field.errors\" class=\"np-validation-message\">\n    <div ng-repeat=\"error in field.errors\" class=\"md-caption\" role=\"alert\">\n      {{ field.getErrorText(error) }}\n    </div>\n  </div>\n</md-input-container>\n");}]);
},{}],"angular":[function(require,module,exports){
require('./angular');
module.exports = angular;

},{"./angular":57}],"npdc-common":[function(require,module,exports){
'use strict';

var angular = require('angular');
//require('angular-animate');
require('angular-aria');
require('angular-marked');
require('angular-material');
require('angular-npolar');
require('angular-route');
require('formula');
require('angularjs-slider');
//require('./browser-warning');
require('./wrappers/chronopic');
require('./wrappers/filefunnel');

var common = angular.module('npdcCommon', ['chronopic', 'filefunnel', 'formula', 'hc.marked', 'ngAnimate', 'ngMaterial', 'ngNpolar', 'ngRoute', 'rzModule', 'templates']);

common.config(["$mdThemingProvider", function ($mdThemingProvider) {
  var npdcPrimary = $mdThemingProvider.extendPalette('light-blue', {
    "300": "#0f3f4c",
    "500": "#0c3642",
    "800": "#427296",
    "contrastDefaultColor": "light",
    "contrastLightColors": ["300", "500", "800"]
  });
  var npdcButton = $mdThemingProvider.extendPalette('green', {
    'A200': '#00963D'
  });
  var npdcAccent = $mdThemingProvider.extendPalette('brown', {
    'A200': '#ffffff',
    'A700': '#ffffff'
  });
  $mdThemingProvider.definePalette('npdcPrimary', npdcPrimary);
  $mdThemingProvider.definePalette('npdcButton', npdcButton);
  $mdThemingProvider.definePalette('npdcAccent', npdcAccent);
  $mdThemingProvider.theme('default').primaryPalette('npdcPrimary').accentPalette('npdcButton');
  $mdThemingProvider.theme('white').primaryPalette('npdcPrimary').accentPalette('npdcAccent');
}]);

common.factory('npdcAppConfig', require('./config/npdcAppConfig'));
common.value('NpdcApplications', require('./config/npdc-applications.json'));

common.run(["$http", "$window", "NpolarTranslate", "$templateCache", "NpdcApplications", "NpolarLang", "npdcAppConfig", function ($http, $window, NpolarTranslate, $templateCache, NpdcApplications, NpolarLang, npdcAppConfig) {
  // Convenience for debugging missing templates
  var og = $templateCache.get;
  $templateCache.get = function () {
    var o = og.apply(this, arguments);
    if (!o) {
      throw arguments[0] + ' not in templateCache!';
    }
    return o;
  };

  // Load text dictionary
  NpolarTranslate.loadBundles(['npolar', 'npdc']);

  // Add application texts
  NpdcApplications.forEach(function (app) {
    NpolarTranslate.dictionary[app.link] = app.name;
    NpolarTranslate.dictionary[app.link + '.description'] = app.description;
  });

  // Set default languages
  NpolarLang.setLanguages(npdcAppConfig.i18n.languages);

  // Check if app has update and update
  if (window.applicationCache) {
    applicationCache.addEventListener('updateready', function () {
      $window.location.reload();
    });
  }
}]);

require('./components');

module.exports = {
  AutoConfig: require('./config/AutoConfig')
};

},{"./components":167,"./config/AutoConfig":205,"./config/npdc-applications.json":206,"./config/npdcAppConfig":207,"./wrappers/chronopic":208,"./wrappers/filefunnel":210,"angular":"angular","angular-aria":4,"angular-marked":7,"angular-material":10,"angular-npolar":27,"angular-route":55,"angularjs-slider":58,"formula":65}]},{},["npdc-common",211])

